
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredacd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredacd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";
parcelRequire("8coUR");

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$g = 60103;
$0db8a335f84591c1$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $0db8a335f84591c1$var$h = Symbol.for;
    $0db8a335f84591c1$var$g = $0db8a335f84591c1$var$h("react.element");
    $0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$h("react.fragment");
}
var $0db8a335f84591c1$var$m = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$n = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$0db8a335f84591c1$var$n.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $0db8a335f84591c1$var$m.current
    };
}
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";

var $8coUR = parcelRequire("8coUR");
var $1c29a66706a62afd$var$n = 60103, $1c29a66706a62afd$var$p = 60106;
$1c29a66706a62afd$export$ffb0004e005737fa = 60107;
$1c29a66706a62afd$export$5f8d39834fd61797 = 60108;
$1c29a66706a62afd$export$e2c29f18771995cb = 60114;
var $1c29a66706a62afd$var$q = 60109, $1c29a66706a62afd$var$r = 60110, $1c29a66706a62afd$var$t = 60112;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = 60113;
var $1c29a66706a62afd$var$u = 60115, $1c29a66706a62afd$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $1c29a66706a62afd$var$w = Symbol.for;
    $1c29a66706a62afd$var$n = $1c29a66706a62afd$var$w("react.element");
    $1c29a66706a62afd$var$p = $1c29a66706a62afd$var$w("react.portal");
    $1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$w("react.fragment");
    $1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$w("react.strict_mode");
    $1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$w("react.profiler");
    $1c29a66706a62afd$var$q = $1c29a66706a62afd$var$w("react.provider");
    $1c29a66706a62afd$var$r = $1c29a66706a62afd$var$w("react.context");
    $1c29a66706a62afd$var$t = $1c29a66706a62afd$var$w("react.forward_ref");
    $1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w("react.suspense");
    $1c29a66706a62afd$var$u = $1c29a66706a62afd$var$w("react.memo");
    $1c29a66706a62afd$var$v = $1c29a66706a62afd$var$w("react.lazy");
}
var $1c29a66706a62afd$var$x = "function" === typeof Symbol && Symbol.iterator;
function $1c29a66706a62afd$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$x && a[$1c29a66706a62afd$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $1c29a66706a62afd$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $1c29a66706a62afd$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$B = {};
function $1c29a66706a62afd$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
$1c29a66706a62afd$var$C.prototype.isReactComponent = {};
$1c29a66706a62afd$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($1c29a66706a62afd$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$D() {}
$1c29a66706a62afd$var$D.prototype = $1c29a66706a62afd$var$C.prototype;
function $1c29a66706a62afd$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
var $1c29a66706a62afd$var$F = $1c29a66706a62afd$var$E.prototype = new $1c29a66706a62afd$var$D;
$1c29a66706a62afd$var$F.constructor = $1c29a66706a62afd$var$E;
$8coUR($1c29a66706a62afd$var$F, $1c29a66706a62afd$var$C.prototype);
$1c29a66706a62afd$var$F.isPureReactComponent = !0;
var $1c29a66706a62afd$var$G = {
    current: null
}, $1c29a66706a62afd$var$H = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$H.call(b, e) && !$1c29a66706a62afd$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $1c29a66706a62afd$var$G.current
    };
}
function $1c29a66706a62afd$var$K(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$n;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$M = /\/+/g;
function $1c29a66706a62afd$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$n:
                case $1c29a66706a62afd$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $1c29a66706a62afd$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($1c29a66706a62afd$var$M, "$&/") + "/"), $1c29a66706a62afd$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($1c29a66706a62afd$var$L(d) && (d = $1c29a66706a62afd$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($1c29a66706a62afd$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $1c29a66706a62afd$var$N(k, g);
        h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    }
    else if (f = $1c29a66706a62afd$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $1c29a66706a62afd$var$N(k, g++), h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($1c29a66706a62afd$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $1c29a66706a62afd$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $1c29a66706a62afd$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $1c29a66706a62afd$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $1c29a66706a62afd$var$R = {
    current: null
};
function $1c29a66706a62afd$var$S() {
    var a = $1c29a66706a62afd$var$R.current;
    if (null === a) throw Error($1c29a66706a62afd$var$z(321));
    return a;
}
var $1c29a66706a62afd$var$T = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $1c29a66706a62afd$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $8coUR
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$P,
    forEach: function(a, b, c) {
        $1c29a66706a62afd$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$L(a)) throw Error($1c29a66706a62afd$var$z(143));
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$C;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$T;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($1c29a66706a62afd$var$z(267, a));
    var e = $8coUR({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$H.call(b, f) && !$1c29a66706a62afd$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $1c29a66706a62afd$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$J;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$J.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$t,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$L;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$Q
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$S().useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a, b) {
    return $1c29a66706a62afd$var$S().useContext(a, b);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$S().useEffect(a, b);
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useImperativeHandle(a, b, c);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$S().useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$S().useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useReducer(a, b, c);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$S().useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$S().useState(a);
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("Xw6Mv", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $acw62 = parcelRequire("acw62");

var $8coUR = parcelRequire("8coUR");

var $fO90s = parcelRequire("fO90s");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$acw62) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $8coUR({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $8coUR({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $8coUR({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $8coUR({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $fO90s.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $fO90s.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $fO90s.unstable_UserBlockingPriority, ed = $fO90s.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $8coUR(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $8coUR({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $8coUR({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $8coUR({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $8coUR({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $8coUR({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $8coUR({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $8coUR({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $8coUR({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $8coUR({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $8coUR({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $8coUR({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $8coUR({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $8coUR({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $fO90s.unstable_runWithPriority, Of = $fO90s.unstable_scheduleCallback, Pf = $fO90s.unstable_cancelCallback, Qf = $fO90s.unstable_shouldYield, Rf = $fO90s.unstable_requestPaint, Sf = $fO90s.unstable_now, Tf = $fO90s.unstable_getCurrentPriorityLevel, Uf = $fO90s.unstable_ImmediatePriority, Vf = $fO90s.unstable_UserBlockingPriority, Wf = $fO90s.unstable_NormalPriority, Xf = $fO90s.unstable_LowPriority, Yf = $fO90s.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $8coUR({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $8coUR({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $acw62.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8coUR({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $8coUR({}, e, {
                    value: void 0
                });
                d = $8coUR({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $8coUR({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
var $bcb017604639e9d7$var$f, $bcb017604639e9d7$var$g, $bcb017604639e9d7$var$h, $bcb017604639e9d7$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$t = null, $bcb017604639e9d7$var$u = null, $bcb017604639e9d7$var$w = function() {
        if (null !== $bcb017604639e9d7$var$t) try {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$t(!0, a);
            $bcb017604639e9d7$var$t = null;
        } catch (b) {
            throw setTimeout($bcb017604639e9d7$var$w, 0), b;
        }
    };
    $bcb017604639e9d7$var$f = function(a) {
        null !== $bcb017604639e9d7$var$t ? setTimeout($bcb017604639e9d7$var$f, 0, a) : ($bcb017604639e9d7$var$t = a, setTimeout($bcb017604639e9d7$var$w, 0));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$u = setTimeout(a, b);
    };
    $bcb017604639e9d7$var$h = function() {
        clearTimeout($bcb017604639e9d7$var$u);
    };
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $bcb017604639e9d7$var$k = $bcb017604639e9d7$export$d66a1c1c77bd778b = function() {};
} else {
    var $bcb017604639e9d7$var$x = window.setTimeout, $bcb017604639e9d7$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $bcb017604639e9d7$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $bcb017604639e9d7$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null, $bcb017604639e9d7$var$C = -1, $bcb017604639e9d7$var$D = 5, $bcb017604639e9d7$var$E = 0;
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return $bcb017604639e9d7$export$c4744153514ff05d() >= $bcb017604639e9d7$var$E;
    };
    $bcb017604639e9d7$var$k = function() {};
    $bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $bcb017604639e9d7$var$F = new MessageChannel, $bcb017604639e9d7$var$G = $bcb017604639e9d7$var$F.port2;
    $bcb017604639e9d7$var$F.port1.onmessage = function() {
        if (null !== $bcb017604639e9d7$var$B) {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$E = a + $bcb017604639e9d7$var$D;
            try {
                $bcb017604639e9d7$var$B(!0, a) ? $bcb017604639e9d7$var$G.postMessage(null) : ($bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null);
            } catch (b) {
                throw $bcb017604639e9d7$var$G.postMessage(null), b;
            }
        } else $bcb017604639e9d7$var$A = !1;
    };
    $bcb017604639e9d7$var$f = function(a) {
        $bcb017604639e9d7$var$B = a;
        $bcb017604639e9d7$var$A || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$G.postMessage(null));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$C = $bcb017604639e9d7$var$x(function() {
            a($bcb017604639e9d7$export$c4744153514ff05d());
        }, b);
    };
    $bcb017604639e9d7$var$h = function() {
        $bcb017604639e9d7$var$y($bcb017604639e9d7$var$C);
        $bcb017604639e9d7$var$C = -1;
    };
}
function $bcb017604639e9d7$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $bcb017604639e9d7$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $bcb017604639e9d7$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $bcb017604639e9d7$var$I(n, c)) void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $bcb017604639e9d7$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $bcb017604639e9d7$var$L = [], $bcb017604639e9d7$var$M = [], $bcb017604639e9d7$var$N = 1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = 3, $bcb017604639e9d7$var$Q = !1, $bcb017604639e9d7$var$R = !1, $bcb017604639e9d7$var$S = !1;
function $bcb017604639e9d7$var$T(a) {
    for(var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M);
        else if (b.startTime <= a) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, b);
        else break;
        b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
    }
}
function $bcb017604639e9d7$var$U(a) {
    $bcb017604639e9d7$var$S = !1;
    $bcb017604639e9d7$var$T(a);
    if (!$bcb017604639e9d7$var$R) {
        if (null !== $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L)) $bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V);
        else {
            var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== b && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$V(a, b) {
    $bcb017604639e9d7$var$R = !1;
    $bcb017604639e9d7$var$S && ($bcb017604639e9d7$var$S = !1, $bcb017604639e9d7$var$h());
    $bcb017604639e9d7$var$Q = !0;
    var c = $bcb017604639e9d7$var$P;
    try {
        $bcb017604639e9d7$var$T(b);
        for($bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L); null !== $bcb017604639e9d7$var$O && (!($bcb017604639e9d7$var$O.expirationTime > b) || a && !$bcb017604639e9d7$export$b5836b71941fa3ed());){
            var d = $bcb017604639e9d7$var$O.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$O.callback = null;
                $bcb017604639e9d7$var$P = $bcb017604639e9d7$var$O.priorityLevel;
                var e = d($bcb017604639e9d7$var$O.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$O.callback = e : $bcb017604639e9d7$var$O === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
                $bcb017604639e9d7$var$T(b);
            } else $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
            $bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
        }
        if (null !== $bcb017604639e9d7$var$O) var m = !0;
        else {
            var n = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== n && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = c, $bcb017604639e9d7$var$Q = !1;
    }
}
var $bcb017604639e9d7$var$W = $bcb017604639e9d7$var$k;
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V));
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$P;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$P;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = $bcb017604639e9d7$var$W;
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$M, a), null === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && a === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M) && ($bcb017604639e9d7$var$S ? $bcb017604639e9d7$var$h() : $bcb017604639e9d7$var$S = !0, $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, a), $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V)));
    return a;
};
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$P;
    return function() {
        var c = $bcb017604639e9d7$var$P;
        $bcb017604639e9d7$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$P = c;
        }
    };
};

});



parcelRegister("f1q41", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("73t87", function(module, exports) {

$parcel$export(module.exports, "area", () => area);
$parcel$export(module.exports, "areaLineRange", () => areaLineRange);
$parcel$export(module.exports, "areaSpline", () => areaSpline);
$parcel$export(module.exports, "areaSplineRange", () => areaSplineRange);
$parcel$export(module.exports, "areaStep", () => areaStep);
$parcel$export(module.exports, "line", () => line);
$parcel$export(module.exports, "spline", () => spline);
$parcel$export(module.exports, "step", () => step);
$parcel$export(module.exports, "donut", () => donut);
$parcel$export(module.exports, "gauge", () => gauge);
$parcel$export(module.exports, "pie", () => pie);
$parcel$export(module.exports, "radar", () => radar);
$parcel$export(module.exports, "bar", () => bar);
$parcel$export(module.exports, "bubble", () => bubble);
$parcel$export(module.exports, "scatter", () => scatter);
$parcel$export(module.exports, "selection", () => selectionModule);
$parcel$export(module.exports, "subchart", () => subchartModule);
$parcel$export(module.exports, "zoom", () => zoomModule);
$parcel$export(module.exports, "bb", () => bb);
$parcel$export(module.exports, "default", () => bb);
/*!
* Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 * 
 * billboard.js, JavaScript chart library
 * https://naver.github.io/billboard.js/
 * 
 * @version 2.2.8
*/ 
var $UutV9 = parcelRequire("UutV9");

var $iZ2is = parcelRequire("iZ2is");
var $iS3vq = parcelRequire("iS3vq");
var $7cQXC = parcelRequire("7cQXC");
var $hOxpW = parcelRequire("hOxpW");
var $jJCd9 = parcelRequire("jJCd9");
parcelRequire("im8sd");
var $7Wzrn = parcelRequire("7Wzrn");

var $k3760 = parcelRequire("k3760");
var $kcqxh = parcelRequire("kcqxh");

var $Y5MKl = parcelRequire("Y5MKl");
parcelRequire("lkHQY");
var $iOlPi = parcelRequire("iOlPi");
var $7TrsU = parcelRequire("7TrsU");
var $4PqgM = parcelRequire("4PqgM");
var $ht0x4 = parcelRequire("ht0x4");
var $48U7R = parcelRequire("48U7R");
parcelRequire("dxJVY");
var $e9pyf = parcelRequire("e9pyf");

var $ffiwJ = parcelRequire("ffiwJ");
var $fEwLW = parcelRequire("fEwLW");
var $6QL1t = parcelRequire("6QL1t");
var $2515N = parcelRequire("2515N");
var $e1bEB = parcelRequire("e1bEB");
var $l8Mye = parcelRequire("l8Mye");
var $hga9n = parcelRequire("hga9n");
var $9XrSP = parcelRequire("9XrSP");
var $dUIyz = parcelRequire("dUIyz");
var $6FEsA = parcelRequire("6FEsA");
var $loyNQ = parcelRequire("loyNQ");
var $4tc8L = parcelRequire("4tc8L");
var $gEcf1 = parcelRequire("gEcf1");
var $4CT3t = parcelRequire("4CT3t");
var $hp3ls = parcelRequire("hp3ls");
var $kjPWc = parcelRequire("kjPWc");
var $1zRZO = parcelRequire("1zRZO");
var $5ti2H = parcelRequire("5ti2H");
var $fo0l5 = parcelRequire("fo0l5");
parcelRequire("kyQKC");
var $bgSbI = parcelRequire("bgSbI");

var $4Nk74 = parcelRequire("4Nk74");

var $bi4KR = parcelRequire("bi4KR");
parcelRequire("fOARq");
var $cwuwP = parcelRequire("cwuwP");
var $e3ER1 = parcelRequire("e3ER1");

var $bYoiY = parcelRequire("bYoiY");
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * CSS class names definition
 * @private
 */ var CLASS = {
    arc: "bb-arc",
    arcLabelLine: "bb-arc-label-line",
    arcs: "bb-arcs",
    area: "bb-area",
    areas: "bb-areas",
    axis: "bb-axis",
    axisX: "bb-axis-x",
    axisXLabel: "bb-axis-x-label",
    axisY: "bb-axis-y",
    axisY2: "bb-axis-y2",
    axisY2Label: "bb-axis-y2-label",
    axisYLabel: "bb-axis-y-label",
    bar: "bb-bar",
    bars: "bb-bars",
    brush: "bb-brush",
    button: "bb-button",
    buttonZoomReset: "bb-zoom-reset",
    chart: "bb-chart",
    chartArc: "bb-chart-arc",
    chartArcs: "bb-chart-arcs",
    chartArcsBackground: "bb-chart-arcs-background",
    chartArcsGaugeMax: "bb-chart-arcs-gauge-max",
    chartArcsGaugeMin: "bb-chart-arcs-gauge-min",
    chartArcsGaugeUnit: "bb-chart-arcs-gauge-unit",
    chartArcsTitle: "bb-chart-arcs-title",
    chartArcsGaugeTitle: "bb-chart-arcs-gauge-title",
    chartBar: "bb-chart-bar",
    chartBars: "bb-chart-bars",
    chartCircles: "bb-chart-circles",
    chartLine: "bb-chart-line",
    chartLines: "bb-chart-lines",
    chartRadar: "bb-chart-radar",
    chartRadars: "bb-chart-radars",
    chartText: "bb-chart-text",
    chartTexts: "bb-chart-texts",
    circle: "bb-circle",
    circles: "bb-circles",
    colorPattern: "bb-color-pattern",
    colorScale: "bb-colorscale",
    defocused: "bb-defocused",
    dragarea: "bb-dragarea",
    empty: "bb-empty",
    eventRect: "bb-event-rect",
    eventRects: "bb-event-rects",
    eventRectsMultiple: "bb-event-rects-multiple",
    eventRectsSingle: "bb-event-rects-single",
    focused: "bb-focused",
    gaugeValue: "bb-gauge-value",
    grid: "bb-grid",
    gridLines: "bb-grid-lines",
    legend: "bb-legend",
    legendBackground: "bb-legend-background",
    legendItem: "bb-legend-item",
    legendItemEvent: "bb-legend-item-event",
    legendItemFocused: "bb-legend-item-focused",
    legendItemHidden: "bb-legend-item-hidden",
    legendItemPoint: "bb-legend-item-point",
    legendItemTile: "bb-legend-item-tile",
    level: "bb-level",
    levels: "bb-levels",
    line: "bb-line",
    lines: "bb-lines",
    main: "bb-main",
    region: "bb-region",
    regions: "bb-regions",
    selectedCircle: "bb-selected-circle",
    selectedCircles: "bb-selected-circles",
    shape: "bb-shape",
    shapes: "bb-shapes",
    stanfordElements: "bb-stanford-elements",
    stanfordLine: "bb-stanford-line",
    stanfordLines: "bb-stanford-lines",
    stanfordRegion: "bb-stanford-region",
    stanfordRegions: "bb-stanford-regions",
    subchart: "bb-subchart",
    target: "bb-target",
    text: "bb-text",
    texts: "bb-texts",
    title: "bb-title",
    tooltip: "bb-tooltip",
    tooltipContainer: "bb-tooltip-container",
    tooltipName: "bb-tooltip-name",
    xgrid: "bb-xgrid",
    xgridFocus: "bb-xgrid-focus",
    xgridLine: "bb-xgrid-line",
    xgridLines: "bb-xgrid-lines",
    xgrids: "bb-xgrids",
    ygrid: "bb-ygrid",
    ygridFocus: "bb-ygrid-focus",
    ygridLine: "bb-ygrid-line",
    ygridLines: "bb-ygrid-lines",
    ygrids: "bb-ygrids",
    zoomBrush: "bb-zoom-brush",
    EXPANDED: "_expanded_",
    SELECTED: "_selected_",
    INCLUDED: "_included_",
    TextOverlapping: "text-overlapping"
};
/**
 * Elements class.
 * @class Elements
 * @ignore
 * @private
 */ var Element = /** @class */ function() {
    function Element() {
        var element = {
            chart: null,
            main: null,
            svg: null,
            axis: {
                x: null,
                y: null,
                y2: null,
                subX: null
            },
            defs: null,
            tooltip: null,
            legend: null,
            title: null,
            subchart: {
                main: null,
                bar: null,
                line: null,
                area: null // $$.contextArea
            },
            arcs: null,
            bar: null,
            line: null,
            area: null,
            circle: null,
            radar: null,
            text: null,
            grid: {
                main: null,
                x: null,
                y: null
            },
            gridLines: {
                main: null,
                x: null,
                y: null
            },
            region: {
                main: null,
                list: null // mainRegion
            },
            eventRect: null
        };
        return element;
    }
    return Element;
}();
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * State class.
 * @class State
 * @ignore
 * @private
 */ var State = /** @class */ function() {
    function State() {
        return {
            width: 0,
            width2: 0,
            height: 0,
            height2: 0,
            margin: {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0
            },
            margin2: {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0
            },
            margin3: {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0
            },
            arcWidth: 0,
            arcHeight: 0,
            xAxisHeight: 0,
            hasAxis: false,
            hasRadar: false,
            current: {
                width: 0,
                height: 0,
                dataMax: 0,
                maxTickWidths: {
                    x: {
                        size: 0,
                        ticks: [],
                        clipPath: 0,
                        domain: ""
                    },
                    y: {
                        size: 0,
                        domain: ""
                    },
                    y2: {
                        size: 0,
                        domain: ""
                    }
                },
                // current used chart type list
                types: []
            },
            // legend
            isLegendRight: false,
            isLegendInset: false,
            isLegendTop: false,
            isLegendLeft: false,
            legendStep: 0,
            legendItemWidth: 0,
            legendItemHeight: 0,
            legendHasRendered: false,
            eventReceiver: {
                currentIdx: -1,
                rect: {},
                data: [],
                coords: [] // coordination value of previous eventRect
            },
            axis: {
                x: {
                    padding: {
                        left: 0,
                        right: 0
                    },
                    tickCount: 0
                }
            },
            rotatedPadding: {
                left: 30,
                right: 0,
                top: 5
            },
            withoutFadeIn: {},
            inputType: "",
            datetimeId: "",
            // clip id string
            clip: {
                id: "",
                idXAxis: "",
                idYAxis: "",
                idXAxisTickTexts: "",
                idGrid: "",
                idSubchart: "",
                path: "",
                pathXAxis: "",
                pathYAxis: "",
                pathXAxisTickTexts: "",
                pathGrid: ""
            },
            // status
            dragStart: null,
            dragging: false,
            flowing: false,
            cancelClick: false,
            mouseover: false,
            rendered: false,
            transiting: false,
            redrawing: false,
            resizing: false,
            toggling: false,
            zooming: false,
            hasNegativeValue: false,
            hasPositiveValue: true,
            orgAreaOpacity: "0.2",
            // ID strings
            hiddenTargetIds: [],
            hiddenLegendIds: [],
            focusedTargetIds: [],
            defocusedTargetIds: [],
            // value for Arc
            radius: 0,
            innerRadius: 0,
            outerRadius: undefined,
            innerRadiusRatio: 0,
            gaugeArcWidth: 0,
            radiusExpanded: 0,
            // xgrid attribute
            xgridAttr: {
                x1: null,
                x2: null,
                y1: null,
                y2: null
            }
        };
    }
    return State;
}();
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ // mapping
var classes = {
    element: Element,
    state: State
};
/**
 * Internal store class.
 * @class Store
 * @ignore
 * @private
 */ var Store = /** @class */ function() {
    function Store() {
        var _this = this;
        Object.keys(classes).forEach(function(v) {
            _this[v] = new classes[v]();
        });
    }
    Store.prototype.getStore = function(name) {
        return this[name];
    };
    return Store;
}();
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var _assign = function __assign() {
    return _assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++)for(var p in s = arguments[i], s)Object.prototype.hasOwnProperty.call(s, p) && (t[p] = s[p]);
        return t;
    }, _assign.apply(this, arguments);
};
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for(var ar, i = 0, l = from.length; i < l; i++)(ar || !(i in from)) && (ar || (ar = Array.prototype.slice.call(from, 0, i)), ar[i] = from[i]);
    return to.concat(ar || Array.prototype.slice.call(from));
}
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * main config options
 */ var main = {
    /**
     * Specify the CSS selector or the element which the chart will be set to. D3 selection object can be specified also.<br>
     * If other chart is set already, it will be replaced with the new one (only one chart can be set in one element).
     * - **NOTE:** In case of element doesn't exist or not specified, will add a `<div>` element to the body.
     * @name bindto
     * @memberof Options
     * @property {string|HTMLElement|d3.selection|object} [bindto="#chart"] Specify the element where chart will be drawn.
     * @property {string|HTMLElement|d3.selection} bindto.element="#chart" Specify the element where chart will be drawn.
     * @property {string} [bindto.classname=bb] Specify the class name of bind element.<br>
     *     **NOTE:** When class name isn't `bb`, then you also need to update the default CSS to be rendered correctly.
     * @default #chart
     * @example
     * bindto: "#myContainer"
     *
     * // or HTMLElement
     * bindto: document.getElementById("myContainer")
     *
     * // or D3 selection object
     * bindto: d3.select("#myContainer")
     *
     * // or to change default classname
     * bindto: {
     *    element: "#chart",
     *    classname: "bill-board"  // ex) <div id='chart' class='bill-board'>
     * }
     */ bindto: "#chart",
    /**
     * Set chart background.
     * @name background
     * @memberof Options
     * @property {object} background background object
     * @property {string} background.class Specify the class name for background element.
     * @property {string} background.color Specify the fill color for background element.<br>**NOTE:** Will be ignored if `imgUrl` option is set.
     * @property {string} background.imgUrl Specify the image url string for background.
     * @see [Demo](https://naver.github.io/billboard.js/demo/#ChartOptions.Background)
     * @example
     * background: {
     *    class: "myClass",
     *    color: "red",
     *
     *    // Set image url for background.
     *    // If specified, 'color' option will be ignored.
     *    imgUrl: "https://naver.github.io/billboard.js/img/logo/billboard.js.svg",
     * }
     */ background: {},
    /**
     * Set 'clip-path' attribute for chart element
     * - **NOTE:**
     *  > When is false, chart node element is positioned after the axis node in DOM tree hierarchy.
     *  > Is to make chart element positioned over axis element.
     * @name clipPath
     * @memberof Options
     * @type {boolean}
     * @default true
     * @see [Demo](https://naver.github.io/billboard.js/demo/#ChartOptions.clipPath)
     * @example
     * // don't set 'clip-path' attribute
     * clipPath: false
     */ clipPath: true,
    /**
     * Set svg element's class name
     * @name svg
     * @memberof Options
     * @type {object}
     * @property {object} [svg] svg object
     * @property {string} [svg.classname] class name for svg element
     * @example
     * svg: {
     *   classname: "test_class"
     * }
     */ svg_classname: undefined,
    /**
     * The desired size of the chart element.
     * If value is not specified, the width of the chart will be calculated by the size of the parent element it's appended to.
     * @name size
     * @memberof Options
     * @type {object}
     * @property {object} [size] size object
     * @property {number} [size.width] width of the chart element
     * @property {number} [size.height] height of the chart element
     * @see [Demo](https://naver.github.io/billboard.js/demo/#ChartOptions.ChartSize)
     * @example
     * size: {
     *   width: 640,
     *   height: 480
     * }
     */ size_width: undefined,
    size_height: undefined,
    /**
     * The padding of the chart element.
     * @name padding
     * @memberof Options
     * @type {object}
     * @property {object} [padding] padding object
     * @property {number} [padding.top] padding on the top of chart
     * @property {number} [padding.right] padding on the right of chart
     * @property {number} [padding.bottom] padding on the bottom of chart
     * @property {number} [padding.left] padding on the left of chart
     * @example
     * padding: {
     *   top: 20,
     *   right: 20,
     *   bottom: 20,
     *   left: 20
     * }
     */ padding_left: undefined,
    padding_right: undefined,
    padding_top: undefined,
    padding_bottom: undefined,
    /**
     * Set chart resize options
     * @name resize
     * @memberof Options
     * @type {object}
     * @property {object} [resize] resize object
     * @property {boolean} [resize.auto=true] Set chart resize automatically on viewport changes.
     * @example
     *  resize: {
     *      auto: false
     *  }
     */ resize_auto: true,
    /**
     * Set a callback to execute when mouse/touch enters the chart.
     * @name onover
     * @memberof Options
     * @type {Function}
     * @default undefined
     * @example
     * onover: function() {
     *   this; // chart instance itself
     *   ...
     * }
     */ onover: undefined,
    /**
     * Set a callback to execute when mouse/touch leaves the chart.
     * @name onout
     * @memberof Options
     * @type {Function}
     * @default undefined
     * @example
     * onout: function() {
     *   this; // chart instance itself
     *   ...
     * }
     */ onout: undefined,
    /**
     * Set a callback to execute when user resizes the screen.
     * @name onresize
     * @memberof Options
     * @type {Function}
     * @default undefined
     * @example
     * onresize: function() {
     *   this; // chart instance itself
     *   ...
     * }
     */ onresize: undefined,
    /**
     * Set a callback to execute when screen resize finished.
     * @name onresized
     * @memberof Options
     * @type {Function}
     * @default undefined
     * @example
     * onresized: function() {
     *   this; // chart instance itself
     *   ...
     * }
     */ onresized: undefined,
    /**
     * Set a callback to execute before the chart is initialized
     * @name onbeforeinit
     * @memberof Options
     * @type {Function}
     * @default undefined
     * @example
     * onbeforeinit: function() {
     *   this; // chart instance itself
     *   ...
     * }
     */ onbeforeinit: undefined,
    /**
     * Set a callback to execute when the chart is initialized.
     * @name oninit
     * @memberof Options
     * @type {Function}
     * @default undefined
     * @example
     * oninit: function() {
     *   this; // chart instance itself
     *   ...
     * }
     */ oninit: undefined,
    /**
     * Set a callback to execute after the chart is initialized
     * @name onafterinit
     * @memberof Options
     * @type {Function}
     * @default undefined
     * @example
     * onafterinit: function() {
     *   this; // chart instance itself
     *   ...
     * }
     */ onafterinit: undefined,
    /**
     * Set a callback which is executed when the chart is rendered. Basically, this callback will be called in each time when the chart is redrawed.
     * @name onrendered
     * @memberof Options
     * @type {Function}
     * @default undefined
     * @example
     * onrendered: function() {
     *   this; // chart instance itself
     *   ...
     * }
     */ onrendered: undefined,
    /**
     * Set duration of transition (in milliseconds) for chart animation.<br><br>
     * - **NOTE:** If `0 `or `null` set, transition will be skipped. So, this makes initial rendering faster especially in case you have a lot of data.
     * @name transition
     * @memberof Options
     * @type {object}
     * @property {object} [transition] transition object
     * @property {number} [transition.duration=350] duration in milliseconds
     * @example
     * transition: {
     *    duration: 500
     * }
     */ transition_duration: 350,
    /**
     * Set plugins
     * @name plugins
     * @memberof Options
     * @type {Array}
     * @example
     *  plugins: [
     *    new bb.plugin.stanford({ ... }),
     *    new PluginA(),
     *    ...
     * ]
     */ plugins: [],
    /**
     * Control the render timing
     * @name render
     * @memberof Options
     * @type {object}
     * @property {object} [render] render object
     * @property {boolean} [render.lazy=true] Make to not render at initialization (enabled by default when bind element's visibility is hidden).
     * @property {boolean} [render.observe=true] Observe bind element's visibility(`display` or `visiblity` inline css property or class value) & render when is visible automatically (for IEs, only works IE11+). When set to **false**, call [`.flush()`](./Chart.html#flush) to render.
     * @see [Demo](https://naver.github.io/billboard.js/demo/#ChartOptions.LazyRender)
     * @example
     *  render: {
     *    lazy: true,
     *    observe: true
     * }
     *
     * @example
     *	// <!-- render.lazy will detect visibility defined -->
     *  // (a) <div id='chart' class='hide'></div>
     *  // (b) <div id='chart' style='display:none'></div>
     *
     *  // render.lazy enabled by default when element is hidden
     *  var chart = bb.generate({ ... });
     *
     *  // chart will be rendered automatically when element's visibility changes
     *  // Note: works only for inlined css property or class attribute changes
     *  document.getElementById('chart').classList.remove('hide')  // (a)
     *  document.getElementById('chart').style.display = 'block';  // (b)
     *
     * @example
     *	// chart won't be rendered and not observing bind element's visiblity changes
     *  var chart = bb.generate({
     *     render: {
     *          lazy: true,
     *          observe: false
     *     }
     *  });
     *
     *  // call at any point when you want to render
     *  chart.flush();
     */ render: {},
    /**
     * Show rectangles inside the chart.<br><br>
     * This option accepts array including object that has axis, start, end and class.
     * The keys start, end and class are optional.
     * axis must be x, y or y2. start and end should be the value where regions start and end.
     * If not specified, the edge values will be used.
     * If timeseries x axis, date string, Date object and unixtime integer can be used.
     * If class is set, the region element will have it as class.
     * @name regions
     * @memberof Options
     * @type {Array}
     * @default []
     * @example
     *  regions: [
     *    {
     *      axis: "x",
     *      start: 1,
     *      end: 4,
     *      class: "region-1-4"
     *    }
     *  ]
     */ regions: []
};
/**
 * data config options
 */ var data$2 = {
    /**
     * Specify the key of x values in the data.<br><br>
     * We can show the data with non-index x values by this option. This option is required when the type of x axis is timeseries. If this option is set on category axis, the values of the data on the key will be used for category names.
     * @name data․x
     * @memberof Options
     * @type {string}
     * @default undefined
     * @example
     * data: {
     *   x: "date"
     * }
     */ data_x: undefined,
    /**
     * Converts data id value
     * @name data․idConverter
     * @memberof Options
     * @type {Function}
     * @default function(id) { return id; }
     * @example
     * data: {
     *    idConverter: function(id) {
     *       // when id is 'data1', converts to be 'data2'
     *       // 'data2' should be given as the initial data value
     *       if (id === "data1") {
     *          return "data2";
     *       } else {
     *          return id;
     *       }
     *    }
     * }
     */ data_idConverter: function(id) {
        return id;
    },
    /**
     * Set custom data name.
     * @name data․names
     * @memberof Options
     * @type {object}
     * @default {}
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Data.DataName)
     * @example
     * data: {
     *   names: {
     *     data1: "Data Name 1",
     *     data2: "Data Name 2"
     *   }
     * }
     */ data_names: {},
    /**
     * Set custom data class.<br><br>
     * If this option is specified, the element g for the data has an additional class that has the prefix 'bb-target-' (eg. bb-target-additional-data1-class).
     * @name data․classes
     * @memberof Options
     * @type {object}
     * @default {}
     * @example
     * data: {
     *   classes: {
     *     data1: "additional-data1-class",
     *     data2: "additional-data2-class"
     *   }
     * }
     */ data_classes: {},
    /**
     * Set chart type at once.<br><br>
     * If this option is specified, the type will be applied to every data. This setting can be overwritten by data.types.<br><br>
     * **Available Values:**
     * - area
     * - area-line-range
     * - area-spline
     * - area-spline-range
     * - area-step
     * - bar
     * - bubble
     * - donut
     * - gauge
     * - line
     * - pie
     * - radar
     * - scatter
     * - spline
     * - step
     * @name data․type
     * @memberof Options
     * @type {string}
     * @default "line"<br>NOTE: When importing shapes by ESM, `line()` should be specified for type.
     * @example
     * data: {
     *    type: "bar"
     * }
     * @example
     * // Generate chart by importing ESM
     * // Import types to be used only, where this will make smaller bundle size.
     * import bb, {
     *   area,
     *   areaLineRange,
     *   areaSpline,
     *   areaSplineRange,
     *   areaStep,
     *   bar,
     *   bubble,
     *   donut,
     *   gauge,
     *   line,
     *   pie,
     *   radar,
     *   scatter,
     *   spline,
     *   step
     * }
     *
     * bb.generate({
     *   ...,
     *   data: {
     *     type: bar()
     *   }
     * });
     */ data_type: undefined,
    /**
     * Set chart type for each data.<br>
     * This setting overwrites data.type setting.
     * - **NOTE:** `radar` type can't be combined with other types.
     * @name data․types
     * @memberof Options
     * @type {object}
     * @default {}
     * @example
     * data: {
     *   types: {
     *     data1: "bar",
     *     data2: "spline"
     *   }
     * }
     * @example
     * // Generate chart by importing ESM
     * // Import types to be used only, where this will make smaller bundle size.
     * import bb, {
     *   area,
     *   areaLineRange,
     *   areaSpline,
     *   areaSplineRange,
     *   areaStep,
     *   bar,
     *   bubble,
     *   donut,
     *   gauge,
     *   line,
     *   pie,
     *   radar,
     *   scatter,
     *   spline,
     *   step
     * }
     *
     * bb.generate({
     *   ...,
     *   data: {
     *     types: {
     *       data1: bar(),
     *       data1: spline()
     *     }
     *   }
     * });
     */ data_types: {},
    /**
     *  This option changes the order of stacking data and pieces of pie/donut.
     *  - If `null` specified, it will be the order the data loaded.
     *  - If function specified, it will be used as [Array.sort compareFunction](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort#Parameters)<br><br>
     *
     *  **Available Values:**
     *  - `desc`: In descending order
     *  - `asc`: In ascending order
     *  - `null`: It keeps the data load order
     *  - `function(data1, data2) { ... }`: Array.sort compareFunction
     *
     *  **NOTE**: order function, only works for Axis based types & Arc types, except `Radar` type.
     * @name data․order
     * @memberof Options
     * @type {string|Function|null}
     * @default desc
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Data.DataOrder)
     * @example
     * data: {
     *   // in descending order (default)
     *   order: "desc"
     *
     *   // in ascending order
     *   order: "asc"
     *
     *   // keeps data input order
     *   order: null
     *
     *   // specifying sort function
     *   order: function(a, b) {
     *       // param data passed format
     *       // {
     *       //   id: "data1", id_org: "data1", values: [
     *       //      {x: 5, value: 250, id: "data1", index: 5, name: "data1"},
     *       //       ...
     *       //   ]
     *       // }
     *
     *       const reducer = (p, c) => p + Math.abs(c.value);
     *       const aSum = a.values.reduce(reducer, 0);
     *       const bSum = b.values.reduce(reducer, 0);
     *
     *       // ascending order
     *       return aSum - bSum;
     *
     *       // descending order
     *       // return bSum - aSum;
     *   }
     * }
     */ data_order: "desc",
    /**
     * Set groups for the data for stacking.
     * @name data․groups
     * @memberof Options
     * @type {Array}
     * @default []
     * @example
     * data: {
     *   groups: [
     *     ["data1", "data2"],
     *     ["data3"]
     *   ]
     * }
     */ data_groups: [],
    /**
     * Set color converter function.<br><br>
     * This option should a function and the specified function receives color (e.g. '#ff0000') and d that has data parameters like id, value, index, etc. And it must return a string that represents color (e.g. '#00ff00').
     * @name data․color
     * @memberof Options
     * @type {Function}
     * @default undefined
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Data.DataColor)
     * @example
     * data: {
     *   color: function(color, d) { ... }
     * }
     */ data_color: undefined,
    /**
     * Set color for each data.
     * @name data․colors
     * @memberof Options
     * @type {object}
     * @default {}
     * @example
     * data: {
     *   colors: {
     *     data1: "#ff0000",
     *     data2: function(d) {
     *        return "#000";
     *     }
     *     ...
     *   }
     * }
     */ data_colors: {},
    /**
     * Set labels options
     * @name data․labels
     * @memberof Options
     * @type {object}
     * @property {object} data Data object
     * @property {boolean} [data.labels=false] Show or hide labels on each data points
     * @property {boolean} [data.labels.centered=false] Centerize labels on `bar` shape. (**NOTE:** works only for 'bar' type)
     * @property {Function} [data.labels.format] Set formatter function for data labels.<br>
     * The formatter function receives 4 arguments such as v, id, i, j and it **must return a string**(`\n` character will be used as line break) that will be shown as the label.<br><br>
     * The arguments are:<br>
     *  - `v` is the value of the data point where the label is shown.
     *  - `id` is the id of the data where the label is shown.
     *  - `i` is the index of the data point where the label is shown.
     *  - `j` is the sub index of the data point where the label is shown.<br><br>
     * Formatter function can be defined for each data by specifying as an object and D3 formatter function can be set (ex. d3.format('$'))
     * @property {string|object|Function} [data.labels.colors] Set label text colors.
     * @property {object} [data.labels.position] Set each dataset position, relative the original.
     * @property {number} [data.labels.position.x=0] x coordinate position, relative the original.
     * @property {number} [data.labels.position.y=0] y coordinate position, relative the original.
     * @memberof Options
     * @type {object}
     * @default {}
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Data.DataLabel)
     * @see [Demo: label colors](https://naver.github.io/billboard.js/demo/#Data.DataLabelColors)
     * @see [Demo: label format](https://naver.github.io/billboard.js/demo/#Data.DataLabelFormat)
     * @see [Demo: label multiline](https://naver.github.io/billboard.js/demo/#Data.DataLabelMultiline)
     * @see [Demo: label overlap](https://naver.github.io/billboard.js/demo/#Data.DataLabelOverlap)
     * @see [Demo: label position](https://naver.github.io/billboard.js/demo/#Data.DataLabelPosition)
     * @example
     * data: {
     *   labels: true,
     *
     *   // or set specific options
     *   labels: {
     *     format: function(v, id, i, j) {
     *         ...
     *         // to multiline, return with '\n' character
     *         return "Line1\nLine2";
     *     },
     *
     *     // it's possible to set for each data
     *     format: {
     *         data1: function(v, id, i, j) { ... },
     *         ...
     *     },
     *
     *     // align text to center of the 'bar' shape (works only for 'bar' type)
     *     centered: true,
     *
     *     // apply for all label texts
     *     colors: "red",
     *
     *     // set different colors per dataset
     *     // for not specified dataset, will have the default color value
     *     colors: {
     *        data1: "yellow",
     *        data3: "green"
     *     },
     *
     *     // call back for label text color
     *     colors: function(color, d) {
     *         // color: the default data label color string
     *         // data: ex) {x: 0, value: 200, id: "data3", index: 0}
     *         ....
     *         return d.value > 200 ? "cyan" : color;
     *     },
     *
     *     // set x, y coordinate position
     *     position: {
     *        x: -10,
     *        y: 10
     *     },
     *
     *     // or set x, y coordinate position by each dataset
     *     position: {
     *        data1: {x: 5, y: 5},
     *        data2: {x: 10, y: -20}
     *     }
     *   }
     * }
     */ data_labels: {},
    data_labels_colors: undefined,
    data_labels_position: {},
    /**
     * Hide each data when the chart appears.<br><br>
     * If true specified, all of data will be hidden. If multiple ids specified as an array, those will be hidden.
     * @name data․hide
     * @memberof Options
     * @type {boolean|Array}
     * @default false
     * @example
     * data: {
     *   // all of data will be hidden
     *   hide: true
     *
     *   // specified data will be hidden
     *   hide: ["data1", ...]
     * }
     */ data_hide: false,
    /**
     * Filter values to be shown
     * The data value is the same as the returned by `.data()`.
     * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter
     * @name data․filter
     * @memberof Options
     * @type {Function}
     * @default undefined
     * @example
     * data: {
     *   // filter for id value
     *   filter: function(v) {
     *      // v: [{id: "data1", id_org: "data1", values: [
     *      //      {x: 0, value: 130, id: "data2", index: 0}, ...]
     *      //    }, ...]
     *      return v.id !== "data1";
     *   }
     */ data_filter: undefined,
    /**
     * Set a callback for click event on each data point.<br><br>
     * This callback will be called when each data point clicked and will receive `d` and element as the arguments.
     * - `d` is the data clicked and element is the element clicked.
     * - `element` is the current interacting svg element.
     * - In this callback, `this` will be the Chart object.
     * @name data․onclick
     * @memberof Options
     * @type {Function}
     * @default function() {}
     * @example
     * data: {
     *     onclick: function(d, element) {
     *        // d - ex) {x: 4, value: 150, id: "data1", index: 4, name: "data1"}
     *        // element - <circle>
     *        ...
     *     }
     * }
     */ data_onclick: function() {},
    /**
     * Set a callback for mouse/touch over event on each data point.<br><br>
     * This callback will be called when mouse cursor or via touch moves onto each data point and will receive `d` and `element` as the argument.
     * - `d` is the data where mouse cursor moves onto.
     * - `element` is the current interacting svg element.
     * - In this callback, `this` will be the Chart object.
     * @name data․onover
     * @memberof Options
     * @type {Function}
     * @default function() {}
     * @example
     * data: {
     *     onover: function(d, element) {
     *        // d - ex) {x: 4, value: 150, id: "data1", index: 4}
     *        // element - <circle>
     *        ...
     *     }
     * }
     */ data_onover: function() {},
    /**
     * Set a callback for mouse/touch out event on each data point.<br><br>
     * This callback will be called when mouse cursor or via touch moves out each data point and will receive `d` as the argument.
     * - `d` is the data where mouse cursor moves out.
     * - `element` is the current interacting svg element.
     * - In this callback, `this` will be the Chart object.
     * @name data․onout
     * @memberof Options
     * @type {Function}
     * @default function() {}
     * @example
     * data: {
     *     onout: function(d, element) {
     *        // d - ex) {x: 4, value: 150, id: "data1", index: 4}
     *        // element - <circle>
     *        ...
     *     }
     * }
     */ data_onout: function() {},
    /**
     * Set a callback for minimum data
     * - **NOTE:** For 'area-line-range' and 'area-spline-range', `mid` data will be taken for the comparison
     * @name data․onmin
     * @memberof Options
     * @type {Function}
     * @default undefined
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Data.OnMinMaxCallback)
     * @example
     *  onmin: function(data) {
     *    // data - ex) [{x: 3, value: 400, id: "data1", index: 3}, ... ]
     *    ...
     *  }
     */ data_onmin: undefined,
    /**
     * Set a callback for maximum data
     * - **NOTE:** For 'area-line-range' and 'area-spline-range', `mid` data will be taken for the comparison
     * @name data․onmax
     * @memberof Options
     * @type {Function}
     * @default undefined
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Data.OnMinMaxCallback)
     * @example
     *  onmax: function(data) {
     *    // data - ex) [{x: 3, value: 400, id: "data1", index: 3}, ... ]
     *    ...
     *  }
     */ data_onmax: undefined,
    /**
     * Load a CSV or JSON file from a URL. NOTE that this will not work if loading via the "file://" protocol as the most browsers will block XMLHTTPRequests.
     * @name data․url
     * @memberof Options
     * @type {string}
     * @default undefined
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Data.LoadData)
     * @example
     * data: {
     *     url: "/data/test.csv"
     * }
     */ data_url: undefined,
    /**
     * XHR header value
     * - **NOTE:** Should be used with `data.url` option
     * @name data․headers
     * @memberof Options
     * @type {string}
     * @default undefined
     * @see https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
     * @example
     * data: {
     *     url: "/data/test.csv",
     *     headers: {
     *        "Content-Type": "text/xml",
     *        ...
     *     }
     * }
     */ data_headers: undefined,
    /**
     * Parse a JSON object for data. See also data.keys.
     * @name data․json
     * @memberof Options
     * @type {Array}
     * @default undefined
     * @see [data․keys](#.data%25E2%2580%25A4keys)
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Data.JSONData)
     * @example
     * data: {
     *     json: [
     *       {name: "www.site1.com", upload: 200, download: 200, total: 400},
     *       {name: "www.site2.com", upload: 100, download: 300, total: 400},
     *       {name: "www.site3.com", upload: 300, download: 200, total: 500},
     *       {name: "www.site4.com", upload: 400, download: 100, total: 500}
     *     ],
     *     keys: {
     *       // x: "name", // it's possible to specify 'x' when category axis
     *       value: ["upload", "download"]
     *     }
     * }
     */ data_json: undefined,
    /**
     * Load data from a multidimensional array, with the first element containing the data names, the following containing related data in that order.
     * @name data․rows
     * @memberof Options
     * @type {Array}
     * @default undefined
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Data.RowOrientedData)
     * @example
     * data: {
     *   rows: [
     *     ["A", "B", "C"],
     *     [90, 120, 300],
     *     [40, 160, 240],
     *     [50, 200, 290],
     *     [120, 160, 230],
     *     [80, 130, 300],
     *     [90, 220, 320]
     *   ]
     * }
     *
     * // for 'range' types('area-line-range' or 'area-spline-range'), data should contain:
     * // - an array of [high, mid, low] data following the order
     * // - or an object with 'high', 'mid' and 'low' key value
     * data: {
     *   rows: [
     *      ["data1", "data2"],
     *      [
     *        // or {high:150, mid: 140, low: 110}, 120
     *        [150, 140, 110], 120
     *      ],
     *      [[155, 130, 115], 55],
     *      [[160, 135, 120], 60]
     *   ],
     *   types: {
     *       data1: "area-line-range",
     *       data2: "line"
     *   }
     * }
     *
     * // for 'bubble' type, data can contain dimension value:
     * // - an array of [y, z] data following the order
     * // - or an object with 'y' and 'z' key value
     * // 'y' is for y axis coordination and 'z' is the bubble radius value
     * data: {
     *   rows: [
     *      ["data1", "data2"],
     *      [
     *        // or {y:10, z: 140}, 120
     *        [10, 140], 120
     *      ],
     *      [[100, 30], 55],
     *      [[50, 100], 60]
     *   ],
     *   types: {
     *       data1: "bubble",
     *       data2: "line"
     *   }
     * }
     */ data_rows: undefined,
    /**
     * Load data from a multidimensional array, with each element containing an array consisting of a datum name and associated data values.
     * @name data․columns
     * @memberof Options
     * @type {Array}
     * @default undefined
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Data.ColumnOrientedData)
     * @example
     * data: {
     *   columns: [
     *      ["data1", 30, 20, 50, 40, 60, 50],
     *      ["data2", 200, 130, 90, 240, 130, 220],
     *      ["data3", 300, 200, 160, 400, 250, 250]
     *   ]
     * }
     *
     * // for 'range' types('area-line-range' or 'area-spline-range'), data should contain:
     * // - an array of [high, mid, low] data following the order
     * // - or an object with 'high', 'mid' and 'low' key value
     * data: {
     *   columns: [
     *      ["data1",
     *          [150, 140, 110],  // or {high:150, mid: 140, low: 110}
     *          [150, 140, 110],
     *          [150, 140, 110]
     *      ]
     *   ],
     *   type: "area-line-range"
     * }
     *
     * // for 'bubble' type, data can contain dimension value:
     * // - an array of [y, z] data following the order
     * // - or an object with 'y' and 'z' key value
     * // 'y' is for y axis coordination and 'z' is the bubble radius value
     * data: {
     *   columns: [
     *      ["data1",
     *          [10, 140],  // or {y:10, z: 140}
     *          [100, 30],
     *          [50, 100]
     *      ]
     *   ],
     *   type: "bubble"
     * }
     */ data_columns: undefined,
    /**
     * Used if loading JSON via data.url.
     * - **Available Values:**
     *   - json
     *   - csv
     *   - tsv
     * @name data․mimeType
     * @memberof Options
     * @type {string}
     * @default csv
     * @example
     * data: {
     *     mimeType: "json"
     * }
     */ data_mimeType: "csv",
    /**
     * Choose which JSON object keys correspond to desired data.
     * - **NOTE:** Only for JSON object given as array.
     * @name data․keys
     * @memberof Options
     * @type {string}
     * @default undefined
     * @example
     * data: {
     *     json: [
     *       {name: "www.site1.com", upload: 200, download: 200, total: 400},
     *       {name: "www.site2.com", upload: 100, download: 300, total: 400},
     *       {name: "www.site3.com", upload: 300, download: 200, total: 500},
     *       {name: "www.site4.com", upload: 400, download: 100, total: 500}
     *     ],
     *     keys: {
     *       // x: "name", // it's possible to specify 'x' when category axis
     *       value: ["upload", "download"]
     *     }
     * }
     */ data_keys: undefined,
    /**
     * Set text label to be displayed when there's no data to show.
     * - ex. Toggling all visible data to not be shown, unloading all current data, etc.
     * @name data․empty․label․text
     * @memberof Options
     * @type {string}
     * @default ""
     * @example
     * data: {
     *   empty: {
     *     label: {
     *       text: "No Data"
     *     }
     *   }
     * }
     */ data_empty_label_text: ""
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * color config options
 */ var color$1 = {
    /**
     * Set color of the data values
     * @name color
     * @memberof Options
     * @type {object}
     * @property {object} color color object
     * @property {string|object|Function} [color.onover] Set the color value for each data point when mouse/touch onover event occurs.
     * @property {Array|null} [color.pattern=[]] Set custom color pattern. Passing `null` will not set a color for these elements, which requires the usage of custom CSS-based theming to work.
     * @property {Function} [color.tiles] if defined, allows use svg's patterns to fill data area. It should return an array of [SVGPatternElement](https://developer.mozilla.org/en-US/docs/Web/API/SVGPatternElement).
     *  - **NOTE:** The pattern element's id will be defined as `bb-colorize-pattern-$COLOR-VALUE`.<br>
     *    ex. When color pattern value is `['red', '#fff']` and defined 2 patterns,then ids for pattern elements are:<br>
     *    - `bb-colorize-pattern-red`
     *    - `bb-colorize-pattern-fff`
     * @property {object} [color.threshold] color threshold for gauge and tooltip color
     * @property {string} [color.threshold.unit] If set to `value`, the threshold will be based on the data value. Otherwise it'll be based on equation of the `threshold.max` option value.
     * @property {Array} [color.threshold.values] Threshold values for each steps
     * @property {number} [color.threshold.max=100] The base value to determine threshold step value condition. When the given value is 15 and max 10, then the value for threshold is `15*100/10`.
     * @example
     *  color: {
     *      pattern: ["#1f77b4", "#aec7e8", ...],
     *
     *      // Set colors' patterns
     *      // it should return an array of SVGPatternElement
     *      tiles: function() {
     *         var pattern = document.createElementNS("http://www.w3.org/2000/svg", "pattern");
     *         var g = document.createElementNS("http://www.w3.org/2000/svg", "g");
     *         var circle1 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
     *
     *         pattern.setAttribute("patternUnits", "userSpaceOnUse");
     *         pattern.setAttribute("width", "32");
     *         pattern.setAttribute("height", "32");
     *
     *         g.style.fill = "#000";
     *         g.style.opacity = "0.2";
     *
     *         circle1.setAttribute("cx", "3");
     *         circle1.setAttribute("cy", "3");
     *         circle1.setAttribute("r", "3");
     *
     *         g.appendChild(circle1);
     *         pattern.appendChild(g);
     *
     *         return [pattern];
     *      },
     *
     *      // for threshold usage, pattern values should be set for each steps
     *      pattern: ["grey", "green", "yellow", "orange", "red"],
     *      threshold: {
     *          unit: "value",
     *
     *          // when value is 20 => 'green', value is 40 => 'orange' will be set.
     *          values: [10, 20, 30, 40, 50],
     *
     *          // the equation for max:
     *          // - unit == 'value': max => 30
     *          // - unit != 'value': max => value*100/30
     *          max: 30
     *      },
     *
     *      // set all data to 'red'
     *      onover: "red",
     *
     *      // set different color for data
     *      onover: {
     *          data1: "red",
     *          data2: "yellow"
     *      },
     *
     *      // will pass data object to the callback
     *      onover: function(d) {
     *          return d.id === "data1" ? "red" : "green";
     *      }
     *  }
     */ color_pattern: [],
    color_tiles: undefined,
    color_threshold: {},
    color_onover: undefined
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * interaction config options
 */ var interaction$1 = {
    /**
     * Interaction options
     * @name interaction
     * @memberof Options
     * @type {object}
     * @property {object} interaction Intersection object
     * @property {boolean} [interaction.enabled=true] Indicate if the chart should have interactions.<br>
     *     If `false` is set, all of interactions (showing/hiding tooltip, selection, mouse events, etc) will be disabled.
     * @property {boolean} [interaction.brighten=true] Make brighter for the selected area (ex. 'pie' type data selected area)
     * @property {boolean} [interaction.inputType.mouse=true] enable or disable mouse interaction
     * @property {boolean} [interaction.inputType.touch=true] enable or disable  touch interaction
     * @property {boolean|number} [interaction.inputType.touch.preventDefault=false] enable or disable to call event.preventDefault on touchstart & touchmove event. It's usually used to prevent document scrolling.
     * @see [Demo: touch.preventDefault](https://naver.github.io/billboard.js/demo/#Interaction.PreventScrollOnTouch)
     * @example
     * interaction: {
     *    enabled: false,
     *    brighten: false,
     *    inputType: {
     *        mouse: true,
     *        touch: false
     *
     *        // or declare preventDefault explicitly.
     *        // In this case touch inputType is enabled by default
     *        touch: {
     *            preventDefault: true
     *
     *            // or threshold pixel value (pixel moved from touchstart to touchmove)
     *            preventDefault: 5
     *        }
     *    }
     * }
     */ interaction_enabled: true,
    interaction_brighten: true,
    interaction_inputType_mouse: true,
    interaction_inputType_touch: {}
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * legend config options
 */ var legend$2 = {
    /**
     * Legend options
     * @name legend
     * @memberof Options
     * @type {object}
     * @property {object} legend Legend object
     * @property {boolean} [legend.show=true] Show or hide legend.
     * @property {boolean} [legend.hide=false] Hide legend
     *  If true given, all legend will be hidden. If string or array given, only the legend that has the id will be hidden.
     * @property {string|HTMLElement} [legend.contents.bindto=undefined] Set CSS selector or element reference to bind legend items.
     * @property {string|Function} [legend.contents.template=undefined] Set item's template.<br>
     *  - If set `string` value, within template the 'color' and 'title' can be replaced using template-like syntax string:
     *    - {=COLOR}: data color value
     *    - {=TITLE}: data title value
     *  - If set `function` value, will pass following arguments to the given function:
     *   - title {string}: data's id value
     *   - color {string}: color string
     *   - data {Array}: data array
     * @property {string} [legend.position=bottom] Change the position of legend.<br>
     *  Available values are: `bottom`, `right` and `inset` are supported.
     * @property {object} [legend.inset={anchor: 'top-left',x: 10,y: 0,step: undefined}] Change inset legend attributes.<br>
     *  This option accepts object that has the keys `anchor`, `x`, `y` and `step`.
     *  - **anchor** decides the position of the legend:
     *   - top-left
     *   - top-right
     *   - bottom-left
     *   - bottom-right
     *  - **x** and **y**:
     *   - set the position of the legend based on the anchor.
     *  - **step**:
     *   - defines the max step the legend has (e.g. If 2 set and legend has 3 legend item, the legend 2 columns).
     * @property {boolean} [legend.equally=false] Set to all items have same width size.
     * @property {boolean} [legend.padding=0] Set padding value
     * @property {Function} [legend.item.onclick=undefined] Set click event handler to the legend item.
     * @property {Function} [legend.item.onover=undefined] Set mouse/touch over event handler to the legend item.
     * @property {Function} [legend.item.onout=undefined] Set mouse/touch out event handler to the legend item.
     * @property {number} [legend.item.tile.width=10] Set width of item tile element
     * @property {number} [legend.item.tile.height=10] Set height of item tile element
     * @property {boolean} [legend.usePoint=false] Whether to use custom points in legend.
     * @see [Demo: position](https://naver.github.io/billboard.js/demo/#Legend.LegendPosition)
     * @see [Demo: contents.template](https://naver.github.io/billboard.js/demo/#Legend.LegendTemplate1)
     * @see [Demo: usePoint](https://naver.github.io/billboard.js/demo/#Legend.usePoint)
     * @example
     *  legend: {
     *      show: true,
     *      hide: true,
     *      //or hide: "data1"
     *      //or hide: ["data1", "data2"]
     *      contents: {
     *          bindto: "#legend",   // <ul id='legend'></ul>
     *
     *          // will be as: <li style='background-color:#1f77b4'>data1</li>
     *          template: "<li style='background-color:{=COLOR}'>{=TITLE}</li>"
     *
     *          // or using function
     *          template: function(id, color, data) {
     *               // if you want omit some legend, return falsy value
     *               if (id !== "data1") {
     *                    return "<li style='background-color:"+ color +">"+ id +"</li>";
     *               }
     *          }
     *      },
     *      position: "bottom",  // bottom, right, inset
     *      inset: {
     *          anchor: "top-right"  // top-left, top-right, bottom-left, bottom-right
     *          x: 20,
     *          y: 10,
     *          step: 2
     *      },
     *      equally: false,
     *      padding: 10,
     *      item: {
     *          onclick: function(id) { ... },
     *          onover: function(id) { ... },
     *          onout: function(id) { ... },
     *
     *          // set tile's size
     *          tile: {
     *              width: 20,
     *              height: 15
     *          }
     *      },
     *      usePoint: true
     *  }
     */ legend_show: true,
    legend_hide: false,
    legend_contents_bindto: undefined,
    legend_contents_template: undefined,
    legend_position: "bottom",
    legend_inset_anchor: "top-left",
    legend_inset_x: 10,
    legend_inset_y: 0,
    legend_inset_step: undefined,
    legend_item_onclick: undefined,
    legend_item_onover: undefined,
    legend_item_onout: undefined,
    legend_equally: false,
    legend_padding: 0,
    legend_item_tile_width: 10,
    legend_item_tile_height: 10,
    legend_usePoint: false
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * title config options
 */ var title$1 = {
    /**
     * Set title options
     * @name title
     * @memberof Options
     * @type {object}
     * @property {object} title Title object
     * @property {string} [title.text] Title text. If contains `\n`, it's used as line break allowing multiline title.
     * @property {number} [title.padding.top=0] Top padding value.
     * @property {number} [title.padding.right=0] Right padding value.
     * @property {number} [title.padding.bottom=0] Bottom padding value.
     * @property {number} [title.padding.left=0] Left padding value.
     * @property {string} [title.position=center] Available values are: 'center', 'right' and 'left'.
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Title.MultilinedTitle)
     * @example
     *  title: {
     *      text: "Title Text",
     *
     *      // or Multiline title text
     *      text: "Main title text\nSub title text",
     *
     *      padding: {
     *          top: 10,
     *          right: 10,
     *          bottom: 10,
     *          left: 10
     *      },
     *      position: "center"
     *  }
     */ title_text: undefined,
    title_padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    },
    title_position: "center"
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * tooltip config options
 */ var tooltip$2 = {
    /**
     * Tooltip options
     * @name tooltip
     * @memberof Options
     * @type {object}
     * @property {object} tooltip Tooltip object
     * @property {boolean} [tooltip.show=true] Show or hide tooltip.
     * @property {boolean} [tooltip.doNotHide=false] Make tooltip keep showing not hiding on interaction.
     * @property {boolean} [tooltip.grouped=true] Set if tooltip is grouped or not for the data points.
     *   - **NOTE:** The overlapped data points will be displayed as grouped even if set false.
     * @property {boolean} [tooltip.linked=false] Set if tooltips on all visible charts with like x points are shown together when one is shown.
     * @property {string} [tooltip.linked.name=""] Groping name for linked tooltip.<br>If specified, linked tooltip will be groped interacting to be worked only with the same name.
     * @property {Function} [tooltip.format.title] Set format for the title of tooltip.<br>
     *  Specified function receives x of the data point to show.
     * @property {Function} [tooltip.format.name] Set format for the name of each data in tooltip.<br>
     *  Specified function receives name, ratio, id and index of the data point to show. ratio will be undefined if the chart is not donut/pie/gauge.
     * @property {Function} [tooltip.format.value] Set format for the value of each data in tooltip.<br>
     *  Specified function receives name, ratio, id and index of the data point to show. ratio will be undefined if the chart is not donut/pie/gauge.
     *  If undefined returned, the row of that value will be skipped.
     * @property {Function} [tooltip.position] Set custom position function for the tooltip.<br>
     *  This option can be used to modify the tooltip position by returning object that has top and left.
     * @property {Function|object} [tooltip.contents] Set custom HTML for the tooltip.<br>
     *  Specified function receives data, defaultTitleFormat, defaultValueFormat and color of the data point to show. If tooltip.grouped is true, data includes multiple data points.
     * @property {string|HTMLElement} [tooltip.contents.bindto=undefined] Set CSS selector or element reference to bind tooltip.
     *  - **NOTE:** When is specified, will not be updating tooltip's position.
     * @property {string} [tooltip.contents.template=undefined] Set tooltip's template.<br><br>
     *  Within template, below syntax will be replaced using template-like syntax string:
     *    - **{{ ... }}**: the doubly curly brackets indicate loop block for data rows.
     *    - **{=CLASS_TOOLTIP}**: default tooltip class name `bb-tooltip`.
     *    - **{=CLASS_TOOLTIP_NAME}**: default tooltip data class name (ex. `bb-tooltip-name-data1`)
     *    - **{=TITLE}**: title value.
     *    - **{=COLOR}**: data color.
     *    - **{=VALUE}**: data value.
     * @property {object} [tooltip.contents.text=undefined] Set additional text content within data loop, using template syntax.
     *  - **NOTE:** It should contain `{ key: Array, ... }` value
     *    - 'key' name is used as substitution within template as '{=KEY}'
     *    - The value array length should match with the data length
     * @property {boolean} [tooltip.init.show=false] Show tooltip at the initialization.
     * @property {number} [tooltip.init.x=0] Set x Axis index(or index for Arc(donut, gauge, pie) types) to be shown at the initialization.
     * @property {object} [tooltip.init.position={top: "0px",left: "50px"}] Set the position of tooltip at the initialization.
     * @property {Function} [tooltip.onshow] Set a callback that will be invoked before the tooltip is shown.
     * @property {Function} [tooltip.onhide] Set a callback that will be invoked before the tooltip is hidden.
     * @property {Function} [tooltip.onshown] Set a callback that will be invoked after the tooltip is shown
     * @property {Function} [tooltip.onhidden] Set a callback that will be invoked after the tooltip is hidden.
     * @property {string|Function|null} [tooltip.order=null] Set tooltip data display order.<br><br>
     *  **Available Values:**
     *  - `desc`: In descending data value order
     *  - `asc`: In ascending data value order
     *  - `null`: It keeps the data display order<br>
     *     **NOTE:** When `data.groups` is set, the order will follow as the stacked graph order.<br>
     *      If want to order as data bound, set any value rather than asc, desc or null. (ex. empty string "")
     *  - `function(data1, data2) { ... }`: [Array.sort compareFunction](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort#Parameters)
     * @see [Demo: Hide Tooltip](https://naver.github.io/billboard.js/demo/#Tooltip.HideTooltip)
     * @see [Demo: Tooltip Grouping](https://naver.github.io/billboard.js/demo/#Tooltip.TooltipGrouping)
     * @see [Demo: Tooltip Format](https://naver.github.io/billboard.js/demo/#Tooltip.TooltipFormat)
     * @see [Demo: Linked Tooltip](https://naver.github.io/billboard.js/demo/#Tooltip.LinkedTooltips)
     * @see [Demo: Tooltip Template](https://naver.github.io/billboard.js/demo/#Tooltip.TooltipTemplate)
     * @example
     *  tooltip: {
     *      show: true,
     *      doNotHide: true,
     *      grouped: false,
     *      format: {
     *          title: function(x) { return "Data " + x; },
     *          name: function(name, ratio, id, index) { return name; },
     *          value: function(value, ratio, id, index) { return ratio; }
     *      },
     *      position: function(data, width, height, element) {
     *          return {top: 0, left: 0}
     *      },
     *
     *      contents: function(d, defaultTitleFormat, defaultValueFormat, color) {
     *          return ... // formatted html as you want
     *      },
     *
     *       // specify tooltip contents using template
     *       // - example of HTML returned:
     *       // <ul class="bb-tooltip">
     *       //   <li class="bb-tooltip-name-data1"><span>250</span><br><span style="color:#00c73c">data1</span></li>
     *       //   <li class="bb-tooltip-name-data2"><span>50</span><br><span style="color:#fa7171">data2</span></li>
     *       // </ul>
     *       contents: {
     *      	bindto: "#tooltip",
     *      	template: '<ul class={=CLASS_TOOLTIP}>{{' +
     *      			'<li class="{=CLASS_TOOLTIP_NAME}"><span>{=VALUE}</span><br>' +
     *      			'<span style=color:{=COLOR}>{=NAME}</span></li>' +
     *      		'}}</ul>'
     *      }
     *
     *       // with additional text value
     *       // - example of HTML returned:
     *       // <ul class="bb-tooltip">
     *       //   <li class="bb-tooltip-name-data1"><span>250</span><br>comment1<span style="color:#00c73c">data1</span>text1</li>
     *       //   <li class="bb-tooltip-name-data2"><span>50</span><br>comment2<span style="color:#fa7171">data2</span>text2</li>
     *       // </ul>
     *       contents: {
     *      	bindto: "#tooltip",
     *      	text: {
     *      		// a) 'key' name is used as substitution within template as '{=KEY}'
     *      		// b) the length should match with the data length
     *      		VAR1: ["text1", "text2"],
     *      		VAR2: ["comment1", "comment2"],
     *      	},
     *      	template: '<ul class={=CLASS_TOOLTIP}>{{' +
     *      			'<li class="{=CLASS_TOOLTIP_NAME}"><span>{=VALUE}</span>{=VAR2}<br>' +
     *      			'<span style=color:{=COLOR}>{=NAME}</span>{=VAR1}</li>' +
     *      		'}}</ul>'
     *      }
     *
     *      // sort tooltip data value display in ascending order
     *      order: "asc",
     *
     *      // specifying sort function
     *      order: function(a, b) {
     *         // param data passed format
     *         {x: 5, value: 250, id: "data1", index: 5, name: "data1"}
     *           ...
     *      },
     *
     *      // show at the initialization
     *      init: {
     *          show: true,
     *          x: 2, // x Axis index(or index for Arc(donut, gauge, pie) types)
     *          position: {
     *              top: "150px",
     *              left: "250px"
     *          }
     *      },
     *
     *      // fires prior tooltip is shown
     *      onshow: function(selectedData) {
     *      	// current dataset selected
     *      	// ==> [{x: 4, value: 150, id: "data2", index: 4, name: "data2"}, ...]
     *      	selectedData;
     *      },
     *
     *      // fires prior tooltip is hidden
     *      onhide: function(selectedData) {
     *      	// current dataset selected
     *      	// ==> [{x: 4, value: 150, id: "data2", index: 4, name: "data2"}, ...]
     *      	selectedData;
     *      },
     *
     *      // fires after tooltip is shown
     *      onshown: function(selectedData) {
     *      	// current dataset selected
     *      	// ==> [{x: 4, value: 150, id: "data2", index: 4, name: "data2"}, ...]
     *      	selectedData;
     *      },
     *
     *      // fires after tooltip is hidden
     *      onhidden: function(selectedData) {
     *      	// current dataset selected
     *      	// ==> [{x: 4, value: 150, id: "data2", index: 4, name: "data2"}, ...]
     *      	selectedData;
     *      },
     *
     *      // Link any tooltips when multiple charts are on the screen where same x coordinates are available
     *      // Useful for timeseries correlation
     *      linked: true,
     *
     *      // Specify name to interact those with the same name only.
     *      linked: {
     *          name: "some-group"
     *      }
     *  }
     */ tooltip_show: true,
    tooltip_doNotHide: false,
    tooltip_grouped: true,
    tooltip_format_title: undefined,
    tooltip_format_name: undefined,
    tooltip_format_value: undefined,
    tooltip_position: undefined,
    tooltip_contents: {},
    tooltip_init_show: false,
    tooltip_init_x: 0,
    tooltip_init_position: {
        top: "0px",
        left: "50px"
    },
    tooltip_linked: false,
    tooltip_linked_name: "",
    tooltip_onshow: function() {},
    tooltip_onhide: function() {},
    tooltip_onshown: function() {},
    tooltip_onhidden: function() {},
    tooltip_order: null
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var win = function() {
    var root = typeof globalThis === "object" && globalThis !== null && globalThis.Object === Object && globalThis || typeof $parcel$global === "object" && $parcel$global !== null && $parcel$global.Object === Object && $parcel$global || typeof self === "object" && self !== null && self.Object === Object && self;
    return root || Function("return this")();
}();
/* eslint-enable no-new-func, no-undef */ var doc = win && win.document;
var isValue = function(v) {
    return v || v === 0;
};
var isFunction = function(v) {
    return typeof v === "function";
};
var isString = function(v) {
    return typeof v === "string";
};
var isNumber = function(v) {
    return typeof v === "number";
};
var isUndefined = function(v) {
    return typeof v === "undefined";
};
var isDefined = function(v) {
    return typeof v !== "undefined";
};
var isboolean = function(v) {
    return typeof v === "boolean";
};
var ceil10 = function(v) {
    return Math.ceil(v / 10) * 10;
};
var asHalfPixel = function(n) {
    return Math.ceil(n) + 0.5;
};
var diffDomain = function(d) {
    return d[1] - d[0];
};
var isObjectType = function(v) {
    return typeof v === "object";
};
var isEmpty = function(o) {
    return isUndefined(o) || o === null || isString(o) && o.length === 0 || isObjectType(o) && !(o instanceof Date) && Object.keys(o).length === 0 || isNumber(o) && isNaN(o);
};
var notEmpty = function(o) {
    return !isEmpty(o);
};
/**
 * Check if is array
 * @param {Array} arr Data to be checked
 * @returns {boolean}
 * @private
 */ var isArray = function(arr) {
    return Array.isArray(arr);
};
/**
 * Check if is object
 * @param {object} obj Data to be checked
 * @returns {boolean}
 * @private
 */ var isObject = function(obj) {
    return obj && !obj.nodeType && isObjectType(obj) && !isArray(obj);
};
/**
 * Get specified key value from object
 * If default value is given, will return if given key value not found
 * @param {object} options Source object
 * @param {string} key Key value
 * @param {*} defaultValue Default value
 * @returns {*}
 * @private
 */ function getOption(options, key, defaultValue) {
    return isDefined(options[key]) ? options[key] : defaultValue;
}
/**
 * Check if value exist in the given object
 * @param {object} dict Target object to be checked
 * @param {*} value Value to be checked
 * @returns {boolean}
 * @private
 */ function hasValue(dict, value) {
    var found = false;
    Object.keys(dict).forEach(function(key) {
        return dict[key] === value && (found = true);
    });
    return found;
}
/**
 * Call function with arguments
 * @param {Function} fn Function to be called
 * @param {*} args Arguments
 * @returns {boolean} true: fn is function, false: fn is not function
 * @private
 */ function callFn(fn) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var isFn = isFunction(fn);
    isFn && fn.call.apply(fn, args);
    return isFn;
}
/**
 * Call function after all transitions ends
 * @param {d3.transition} transition Transition
 * @param {Fucntion} cb Callback function
 * @private
 */ function endall(transition, cb) {
    var n = 0;
    transition.each(function() {
        return ++n;
    }).on("end", function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        !--n && cb.apply.apply(cb, __spreadArray([
            this
        ], args, false));
    });
}
/**
 * Replace tag sign to html entity
 * @param {string} str Target string value
 * @returns {string}
 * @private
 */ function sanitise(str) {
    return isString(str) ? str.replace(/</g, "&lt;").replace(/>/g, "&gt;") : str;
}
/**
 * Set text value. If there's multiline add nodes.
 * @param {d3Selection} node Text node
 * @param {string} text Text value string
 * @param {Array} dy dy value for multilined text
 * @param {boolean} toMiddle To be alingned vertically middle
 * @private
 */ function setTextValue(node, text, dy, toMiddle) {
    if (dy === void 0) dy = [
        -1,
        1
    ];
    if (toMiddle === void 0) toMiddle = false;
    if (!node || !isString(text)) return;
    if (text.indexOf("\n") === -1) node.text(text);
    else {
        var diff = [
            node.text(),
            text
        ].map(function(v) {
            return v.replace(/[\s\n]/g, "");
        });
        if (diff[0] !== diff[1]) {
            var multiline = text.split("\n");
            var len_1 = toMiddle ? multiline.length - 1 : 1;
            // reset possible text
            node.html("");
            multiline.forEach(function(v, i) {
                node.append("tspan").attr("x", 0).attr("dy", "".concat(i === 0 ? dy[0] * len_1 : dy[1], "em")).text(v);
            });
        }
    }
}
/**
 * Substitution of SVGPathSeg API polyfill
 * @param {SVGGraphicsElement} path Target svg element
 * @returns {Array}
 * @private
 */ function getRectSegList(path) {
    /*
     * seg1 ---------- seg2
     *   |               |
     *   |               |
     *   |               |
     * seg0 ---------- seg3
     * */ var _a = path.getBBox(), x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    return [
        {
            x: x,
            y: y + height
        },
        {
            x: x,
            y: y
        },
        {
            x: x + width,
            y: y
        },
        {
            x: x + width,
            y: y + height
        } // seg3
    ];
}
/**
 * Get svg bounding path box dimension
 * @param {SVGGraphicsElement} path Target svg element
 * @returns {object}
 * @private
 */ function getPathBox(path) {
    var _a = path.getBoundingClientRect(), width = _a.width, height = _a.height;
    var items = getRectSegList(path);
    var x = items[0].x;
    var y = Math.min(items[0].y, items[1].y);
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Return brush selection array
 * @param {object} {} Selection object
 * @param {object} {}.$el Selection object
 * @returns {d3.brushSelection}
 * @private
 */ function getBrushSelection(_a) {
    var $el = _a.$el;
    var event$1 = (0, $iZ2is.event);
    var main = $el.subchart.main || $el.main;
    var selection;
    // check from event
    if (event$1 && event$1.type === "brush") selection = event$1.selection;
    else if (main && (selection = main.select(".".concat(CLASS.brush)).node())) selection = (0, $7Wzrn.brushSelection)(selection);
    return selection;
}
/**
 * Get boundingClientRect.
 * Cache the evaluated value once it was called.
 * @param {HTMLElement} node Target element
 * @returns {object}
 * @private
 */ function getBoundingRect(node) {
    var needEvaluate = !("rect" in node) || "rect" in node && node.hasAttribute("width") && node.rect.width !== +node.getAttribute("width");
    return needEvaluate ? node.rect = node.getBoundingClientRect() : node.rect;
}
/**
 * Retrun random number
 * @param {boolean} asStr Convert returned value as string
 * @returns {number|string}
 * @private
 */ function getRandom(asStr) {
    if (asStr === void 0) asStr = true;
    var rand = Math.random();
    return asStr ? String(rand) : rand;
}
/**
 * Find index based on binary search
 * @param {Array} arr Data array
 * @param {number} v Target number to find
 * @param {number} start Start index of data array
 * @param {number} end End index of data arr
 * @param {boolean} isRotated Weather is roted axis
 * @returns {number} Index number
 * @private
 */ function findIndex(arr, v, start, end, isRotated) {
    if (start > end) return -1;
    var mid = Math.floor((start + end) / 2);
    var _a = arr[mid], x = _a.x, _b = _a.w, w = _b === void 0 ? 0 : _b;
    if (isRotated) {
        x = arr[mid].y;
        w = arr[mid].h;
    }
    if (v >= x && v <= x + w) return mid;
    return v < x ? findIndex(arr, v, start, mid - 1, isRotated) : findIndex(arr, v, mid + 1, end, isRotated);
}
/**
 * Check if brush is empty
 * @param {object} ctx Bursh context
 * @returns {boolean}
 * @private
 */ function brushEmpty(ctx) {
    var selection = getBrushSelection(ctx);
    if (selection) // brush selected area
    // two-dimensional: [[x0, y0], [x1, y1]]
    // one-dimensional: [x0, x1] or [y0, y1]
    return selection[0] === selection[1];
    return true;
}
/**
 * Deep copy object
 * @param {object} objectN Source object
 * @returns {object} Cloned object
 * @private
 */ function deepClone() {
    var objectN = [];
    for(var _i = 0; _i < arguments.length; _i++)objectN[_i] = arguments[_i];
    var clone = function(v) {
        if (isObject(v) && v.constructor) {
            var r = new v.constructor();
            for(var k in v)r[k] = clone(v[k]);
            return r;
        }
        return v;
    };
    return objectN.map(function(v) {
        return clone(v);
    }).reduce(function(a, c) {
        return _assign(_assign({}, a), c);
    });
}
/**
 * Extend target from source object
 * @param {object} target Target object
 * @param {object|Array} source Source object
 * @returns {object}
 * @private
 */ function extend(target, source) {
    if (target === void 0) target = {};
    if (isArray(source)) source.forEach(function(v) {
        return extend(target, v);
    });
    // exclude name with only numbers
    for(var p in source){
        if (/^\d+$/.test(p) || p in target) continue;
        target[p] = source[p];
    }
    return target;
}
/**
 * Return first letter capitalized
 * @param {string} str Target string
 * @returns {string} capitalized string
 * @private
 */ var capitalize = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
/**
 * Convert to array
 * @param {object} v Target to be converted
 * @returns {Array}
 * @private
 */ var toArray = function(v) {
    return [].slice.call(v);
};
/**
 * Get css rules for specified stylesheets
 * @param {Array} styleSheets The stylesheets to get the rules from
 * @returns {Array}
 * @private
 */ function getCssRules(styleSheets) {
    var rules = [];
    styleSheets.forEach(function(sheet) {
        try {
            if (sheet.cssRules && sheet.cssRules.length) rules = rules.concat(toArray(sheet.cssRules));
        } catch (e) {
            console.error("Error while reading rules from ".concat(sheet.href, ": ").concat(e.toString()));
        }
    });
    return rules;
}
/**
 * Gets the SVGMatrix of an SVGGElement
 * @param {SVGElement} node Node element
 * @returns {SVGMatrix} matrix
 * @private
 */ var getTranslation = function(node) {
    var transform = node ? node.transform : null;
    var baseVal = transform && transform.baseVal;
    return baseVal && baseVal.numberOfItems ? baseVal.getItem(0).matrix : {
        a: 0,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0
    };
};
/**
 * Get unique value from array
 * @param {Array} data Source data
 * @returns {Array} Unique array value
 * @private
 */ function getUnique(data) {
    var isDate = data[0] instanceof Date;
    var d = (isDate ? data.map(Number) : data).filter(function(v, i, self1) {
        return self1.indexOf(v) === i;
    });
    return isDate ? d.map(function(v) {
        return new Date(v);
    }) : d;
}
/**
 * Merge array
 * @param {Array} arr Source array
 * @returns {Array}
 * @private
 */ function mergeArray(arr) {
    return arr && arr.length ? arr.reduce(function(p, c) {
        return p.concat(c);
    }) : [];
}
/**
 * Merge object returning new object
 * @param {object} target Target object
 * @param {object} objectN Source object
 * @returns {object} merged target object
 * @private
 */ function mergeObj(target) {
    var objectN = [];
    for(var _i = 1; _i < arguments.length; _i++)objectN[_i - 1] = arguments[_i];
    if (!objectN.length || objectN.length === 1 && !objectN[0]) return target;
    var source = objectN.shift();
    if (isObject(target) && isObject(source)) Object.keys(source).forEach(function(key) {
        var value = source[key];
        if (isObject(value)) {
            !target[key] && (target[key] = {});
            target[key] = mergeObj(target[key], value);
        } else target[key] = isArray(value) ? value.concat() : value;
    });
    return mergeObj.apply(void 0, __spreadArray([
        target
    ], objectN, false));
}
/**
 * Sort value
 * @param {Array} data value to be sorted
 * @param {boolean} isAsc true: asc, false: desc
 * @returns {number|string|Date} sorted date
 * @private
 */ function sortValue(data, isAsc) {
    if (isAsc === void 0) isAsc = true;
    var fn;
    if (data[0] instanceof Date) fn = isAsc ? function(a, b) {
        return a - b;
    } : function(a, b) {
        return b - a;
    };
    else {
        if (isAsc && !data.every(isNaN)) fn = function(a, b) {
            return a - b;
        };
        else if (!isAsc) fn = function(a, b) {
            return a > b && -1 || a < b && 1 || a === b && 0;
        };
    }
    return data.concat().sort(fn);
}
/**
 * Get min/max value
 * @param {string} type 'min' or 'max'
 * @param {Array} data Array data value
 * @returns {number|Date|undefined}
 * @private
 */ function getMinMax$1(type, data) {
    var res = data.filter(function(v) {
        return notEmpty(v);
    });
    if (res.length) {
        if (isNumber(res[0])) res = Math[type].apply(Math, res);
        else if (res[0] instanceof Date) res = sortValue(res, type === "min")[0];
    } else res = undefined;
    return res;
}
/**
 * Get range
 * @param {number} start Start number
 * @param {number} end End number
 * @param {number} step Step number
 * @returns {Array}
 * @private
 */ var getRange = function(start, end, step) {
    if (step === void 0) step = 1;
    var res = [];
    var n = Math.max(0, Math.ceil((end - start) / step)) | 0;
    for(var i = start; i < n; i++)res.push(start + i * step);
    return res;
};
// emulate event
var emulateEvent = {
    mouse: function() {
        var getParams = function() {
            return {
                bubbles: false,
                cancelable: false,
                screenX: 0,
                screenY: 0,
                clientX: 0,
                clientY: 0
            };
        };
        try {
            // eslint-disable-next-line no-new
            new MouseEvent("t");
            return function(el, eventType, params) {
                if (params === void 0) params = getParams();
                el.dispatchEvent(new MouseEvent(eventType, params));
            };
        } catch (e) {
            // Polyfills DOM4 MouseEvent
            return function(el, eventType, params) {
                if (params === void 0) params = getParams();
                var mouseEvent = doc.createEvent("MouseEvent");
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/initMouseEvent
                mouseEvent.initMouseEvent(eventType, params.bubbles, params.cancelable, win, 0, params.screenX, params.screenY, params.clientX, params.clientY, false, false, false, false, 0, null);
                el.dispatchEvent(mouseEvent);
            };
        }
    }(),
    touch: function(el, eventType, params) {
        var touchObj = new Touch(mergeObj({
            identifier: Date.now(),
            target: el,
            radiusX: 2.5,
            radiusY: 2.5,
            rotationAngle: 10,
            force: 0.5
        }, params));
        el.dispatchEvent(new TouchEvent(eventType, {
            cancelable: true,
            bubbles: true,
            shiftKey: true,
            touches: [
                touchObj
            ],
            targetTouches: [],
            changedTouches: [
                touchObj
            ]
        }));
    }
};
/**
 * Process the template  & return bound string
 * @param {string} tpl Template string
 * @param {object} data Data value to be replaced
 * @returns {string}
 * @private
 */ function tplProcess(tpl, data) {
    var res = tpl;
    for(var x in data)res = res.replace(new RegExp("{=".concat(x, "}"), "g"), data[x]);
    return res;
}
/**
 * Get parsed date value
 * (It must be called in 'ChartInternal' context)
 * @param {Date|string|number} date Value of date to be parsed
 * @returns {Date}
 * @private
 */ function parseDate(date) {
    var parsedDate;
    if (date instanceof Date) parsedDate = date;
    else if (isString(date)) {
        var _a = this, config = _a.config, format = _a.format;
        parsedDate = format.dataTime(config.data_xFormat)(date);
    } else if (isNumber(date) && !isNaN(date)) parsedDate = new Date(+date);
    if (!parsedDate || isNaN(+parsedDate)) console && console.error && console.error("Failed to parse x '".concat(date, "' to Date object"));
    return parsedDate;
}
/**
 * Return if the current doc is visible or not
 * @returns {boolean}
 * @private
 */ function isTabVisible() {
    return !doc.hidden;
}
/**
 * Get the current input type
 * @param {boolean} mouse Config value: interaction.inputType.mouse
 * @param {boolean} touch Config value: interaction.inputType.touch
 * @returns {string} "mouse" | "touch" | null
 * @private
 */ function convertInputType(mouse, touch) {
    var isMobile = false;
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#Mobile_Tablet_or_Desktop
    if (/Mobi/.test(win.navigator.userAgent) && touch) {
        // Some Edge desktop return true: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/20417074/
        var hasTouchPoints = win.navigator && "maxTouchPoints" in win.navigator && win.navigator.maxTouchPoints > 0;
        // Ref: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/touchevents.js
        // On IE11 with IE9 emulation mode, ('ontouchstart' in window) is returning true
        var hasTouch = "ontouchmove" in win || win.DocumentTouch && doc instanceof win.DocumentTouch;
        isMobile = hasTouchPoints || hasTouch;
    }
    var hasMouse = mouse && !isMobile ? "onmouseover" in win : false;
    return hasMouse && "mouse" || isMobile && "touch" || null;
}
/**
 * Class to set options on generating chart.
 * - It's instantiated internally, not exposed for public.
 * @class Options
 * @see {@link bb.generate} to use these options on generating the chart
 */ var Options = /** @class */ function() {
    function Options() {
        return deepClone(main, data$2, color$1, interaction$1, legend$2, title$1, tooltip$2, Options.data);
    }
    Options.setOptions = function(options) {
        this.data = options.reduce(function(a, c) {
            return _assign(_assign({}, a), c);
        }, this.data);
    };
    Options.data = {};
    return Options;
}();
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * Constant for cache key
 * - NOTE: Prefixed with '$', will be resetted when .load() is called
 * @private
 */ var KEY = {
    bubbleBaseLength: "$baseLength",
    colorPattern: "__colorPattern__",
    dataMinMax: "$dataMinMax",
    dataTotalSum: "$dataTotalSum",
    dataTotalPerIndex: "$totalPerIndex",
    legendItemTextBox: "legendItemTextBox",
    radarPoints: "$radarPoints",
    setOverOut: "setOverOut",
    callOverOutForTouch: "callOverOutForTouch",
    textRect: "textRect"
};
var Cache = /** @class */ function() {
    function Cache() {
        this.cache = {};
    }
    /**
     * Add cache
     * @param {string} key Cache key
     * @param {*} value Value to be stored
     * @param {boolean} isDataType Weather the cache is data typed '{id:'data', id_org: 'data', values: [{x:0, index:0,...}, ...]}'
     * @returns {*} Added data value
     * @private
     */ Cache.prototype.add = function(key, value, isDataType) {
        if (isDataType === void 0) isDataType = false;
        this.cache[key] = isDataType ? this.cloneTarget(value) : value;
        return this.cache[key];
    };
    /**
     * Remove cache
     * @param {string|Array} key Cache key
     * @private
     */ Cache.prototype.remove = function(key) {
        var _this = this;
        toArray(key).forEach(function(v) {
            return delete _this.cache[v];
        });
    };
    /**
     * Get cahce
     * @param {string|Array} key Cache key
     * @param {boolean} isDataType Weather the cache is data typed '{id:'data', id_org: 'data', values: [{x:0, index:0,...}, ...]}'
     * @returns {*}
     * @private
     */ Cache.prototype.get = function(key, isDataType) {
        if (isDataType === void 0) isDataType = false;
        if (isDataType) {
            var targets = [];
            for(var i = 0, id = void 0; id = key[i]; i++)if (id in this.cache) targets.push(this.cloneTarget(this.cache[id]));
            return targets;
        } else {
            var value = this.cache[key];
            return isValue(value) ? value : null;
        }
    };
    /**
     * Reset cached data
     * @param {boolean} all true: reset all data, false: reset only '$' prefixed key data
     * @private
     */ Cache.prototype.reset = function(all) {
        var $$ = this;
        for(var x in $$.cache)// reset the prefixed '$' key(which is internal use data) only.
        if (all || /^\$/.test(x)) $$.cache[x] = null;
    };
    /**
     * Clone data target object
     * @param {object} target Data object
     * @returns {object}
     * @private
     */ // eslint-disable-next-line camelcase
    Cache.prototype.cloneTarget = function(target) {
        return {
            id: target.id,
            id_org: target.id_org,
            values: target.values.map(function(d) {
                return {
                    x: d.x,
                    value: d.value,
                    id: d.id
                };
            })
        };
    };
    return Cache;
}();
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var setTimeout$1 = win.setTimeout, clearTimeout$1 = win.clearTimeout;
/**
 * Generate resize queue function
 * @returns {Fucntion}
 * @private
 */ function generateResize() {
    var fn = [];
    var timeout;
    var callResizeFn = function() {
        // Delay all resize functions call, to prevent unintended excessive call from resize event
        callResizeFn.clear();
        timeout = setTimeout$1(function() {
            fn.forEach(function(f) {
                return f();
            });
        }, 200);
    };
    callResizeFn.clear = function() {
        if (timeout) {
            clearTimeout$1(timeout);
            timeout = null;
        }
    };
    callResizeFn.add = function(f) {
        return fn.push(f);
    };
    callResizeFn.remove = function(f) {
        return fn.splice(fn.indexOf(f), 1);
    };
    return callResizeFn;
}
/**
 * Generate transition queue function
 * @returns {Function}
 * @private
 */ function generateWait() {
    var transitionsToWait = [];
    var f = function(t, callback) {
        var timer;
        // eslint-disable-next-line
        function loop() {
            var done = 0;
            for(var i = 0, t_1; t_1 = transitionsToWait[i]; i++){
                if (t_1 === true || t_1.empty && t_1.empty()) {
                    done++;
                    continue;
                }
                try {
                    t_1.transition();
                } catch (e) {
                    done++;
                }
            }
            timer && clearTimeout$1(timer);
            if (done === transitionsToWait.length) callback && callback();
            else timer = setTimeout$1(loop, 50);
        }
        loop();
    };
    f.add = function(t) {
        isArray(t) ? transitionsToWait = transitionsToWait.concat(t) : transitionsToWait.push(t);
    };
    return f;
}
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * Data convert
 * @memberof ChartInternal
 * @private
 */ var dataConvert = {
    /**
     * Convert data according its type
     * @param {object} args data object
     * @param {Function} [callback] callback for url(XHR) type loading
     * @returns {object}
     * @private
     */ convertData: function(args, callback) {
        var data;
        if (args.bindto) {
            data = {};
            [
                "url",
                "mimeType",
                "headers",
                "keys",
                "json",
                "keys",
                "rows",
                "columns"
            ].forEach(function(v) {
                var key = "data_".concat(v);
                if (key in args) data[v] = args[key];
            });
        } else data = args;
        if (data.url && callback) this.convertUrlToData(data.url, data.mimeType, data.headers, data.keys, callback);
        else if (data.json) data = this.convertJsonToData(data.json, data.keys);
        else if (data.rows) data = this.convertRowsToData(data.rows);
        else if (data.columns) data = this.convertColumnsToData(data.columns);
        else if (args.bindto) throw Error("url or json or rows or columns is required.");
        return isArray(data) && data;
    },
    /**
     * Convert URL data
     * @param {string} url Remote URL
     * @param {string} mimeType MIME type string: json | csv | tsv
     * @param {object} headers Header object
     * @param {object} keys Key object
     * @param {Function} done Callback function
     * @private
     */ convertUrlToData: function(url, mimeType, headers, keys, done) {
        var _this = this;
        if (mimeType === void 0) mimeType = "csv";
        var req = new XMLHttpRequest();
        req.open("GET", url);
        if (headers) Object.keys(headers).forEach(function(key) {
            req.setRequestHeader(key, headers[key]);
        });
        req.onreadystatechange = function() {
            if (req.readyState === 4) {
                if (req.status === 200) {
                    var response = req.responseText;
                    response && done.call(_this, _this["convert".concat(capitalize(mimeType), "ToData")](mimeType === "json" ? JSON.parse(response) : response, keys));
                } else throw new Error("".concat(url, ": Something went wrong loading!"));
            }
        };
        req.send();
    },
    /**
     * Convert CSV/TSV data
     * @param {object} parser Parser object
     * @param {object} xsv Data
     * @private
     * @returns {object}
     */ convertCsvTsvToData: function(parser, xsv) {
        var rows = parser.rows(xsv);
        var d;
        if (rows.length === 1) {
            d = [
                {}
            ];
            rows[0].forEach(function(id) {
                d[0][id] = null;
            });
        } else d = parser.parse(xsv);
        return d;
    },
    convertCsvToData: function(xsv) {
        return this.convertCsvTsvToData({
            rows: (0, $k3760.csvParseRows),
            parse: (0, $k3760.csvParse)
        }, xsv);
    },
    convertTsvToData: function(tsv) {
        return this.convertCsvTsvToData({
            rows: (0, $kcqxh.tsvParseRows),
            parse: (0, $kcqxh.tsvParse)
        }, tsv);
    },
    convertJsonToData: function(json, keysParam) {
        var _this = this;
        var config = this.config;
        var newRows = [];
        var targetKeys;
        var data;
        if (isArray(json)) {
            var keys = keysParam || config.data_keys;
            if (keys.x) {
                targetKeys = keys.value.concat(keys.x);
                config.data_x = keys.x;
            } else targetKeys = keys.value;
            newRows.push(targetKeys);
            json.forEach(function(o) {
                var newRow = targetKeys.map(function(key) {
                    // convert undefined to null because undefined data will be removed in convertDataToTargets()
                    var v = _this.findValueInJson(o, key);
                    if (isUndefined(v)) v = null;
                    return v;
                });
                newRows.push(newRow);
            });
            data = this.convertRowsToData(newRows);
        } else {
            Object.keys(json).forEach(function(key) {
                var tmp = json[key].concat();
                tmp.unshift(key);
                newRows.push(tmp);
            });
            data = this.convertColumnsToData(newRows);
        }
        return data;
    },
    findValueInJson: function(object, path) {
        if (object[path] !== undefined) return object[path];
        var convertedPath = path.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties (replace [] with .)
        var pathArray = convertedPath.replace(/^\./, "").split("."); // strip a leading dot
        var target = object;
        pathArray.some(function(k) {
            return !(target = target && k in target ? target[k] : undefined);
        });
        return target;
    },
    convertRowsToData: function(rows) {
        var keys = rows[0];
        var newRows = [];
        rows.forEach(function(row, i) {
            if (i > 0) {
                var newRow_1 = {};
                row.forEach(function(v, j) {
                    if (isUndefined(v)) throw new Error("Source data is missing a component at (".concat(i, ", ").concat(j, ")!"));
                    newRow_1[keys[j]] = v;
                });
                newRows.push(newRow_1);
            }
        });
        return newRows;
    },
    convertColumnsToData: function(columns) {
        var newRows = [];
        columns.forEach(function(col, i) {
            var key = col[0];
            col.forEach(function(v, j) {
                if (j > 0) {
                    if (isUndefined(newRows[j - 1])) newRows[j - 1] = {};
                    if (isUndefined(v)) throw new Error("Source data is missing a component at (".concat(i, ", ").concat(j, ")!"));
                    newRows[j - 1][key] = v;
                }
            });
        });
        return newRows;
    },
    convertDataToTargets: function(data, appendXs) {
        var _this = this;
        var $$ = this;
        var axis = $$.axis, config = $$.config, state = $$.state;
        var isCategorized = false;
        var isTimeSeries = false;
        var isCustomX = false;
        if (axis) {
            isCategorized = axis.isCategorized();
            isTimeSeries = axis.isTimeSeries();
            isCustomX = axis.isCustomX();
        }
        var dataKeys = Object.keys(data[0] || {});
        var ids = dataKeys.length ? dataKeys.filter($$.isNotX, $$) : [];
        var xs = dataKeys.length ? dataKeys.filter($$.isX, $$) : [];
        var xsData;
        // save x for update data by load when custom x and bb.x API
        ids.forEach(function(id) {
            var xKey = _this.getXKey(id);
            if (isCustomX || isTimeSeries) {
                // if included in input data
                if (xs.indexOf(xKey) >= 0) xsData = (appendXs && $$.data.xs[id] || []).concat(data.map(function(d) {
                    return d[xKey];
                }).filter(isValue).map(function(rawX, i) {
                    return $$.generateTargetX(rawX, id, i);
                }));
                else if (config.data_x) // if not included in input data, find from preloaded data of other id's x
                xsData = _this.getOtherTargetXs();
                else if (notEmpty(config.data_xs)) // if not included in input data, find from preloaded data
                xsData = $$.getXValuesOfXKey(xKey, $$.data.targets);
            // MEMO: if no x included, use same x of current will be used
            } else xsData = data.map(function(d, i) {
                return i;
            });
            xsData && (_this.data.xs[id] = xsData);
        });
        // check x is defined
        ids.forEach(function(id) {
            if (!_this.data.xs[id]) throw new Error('x is not defined for id = "'.concat(id, '".'));
        });
        // convert to target
        var targets = ids.map(function(id, index) {
            var convertedId = config.data_idConverter.bind($$.api)(id);
            var xKey = $$.getXKey(id);
            var isCategory = isCustomX && isCategorized;
            var hasCategory = isCategory && data.map(function(v) {
                return v.x;
            }).every(function(v) {
                return config.axis_x_categories.indexOf(v) > -1;
            });
            return {
                id: convertedId,
                id_org: id,
                values: data.map(function(d, i) {
                    var rawX = d[xKey];
                    var value = d[id];
                    var x;
                    value = value !== null && !isNaN(value) && !isObject(value) ? +value : isArray(value) || isObject(value) ? value : null;
                    // use x as categories if custom x and categorized
                    if ((isCategory || state.hasRadar) && index === 0 && !isUndefined(rawX)) {
                        if (!hasCategory && index === 0 && i === 0) config.axis_x_categories = [];
                        x = config.axis_x_categories.indexOf(rawX);
                        if (x === -1) {
                            x = config.axis_x_categories.length;
                            config.axis_x_categories.push(rawX);
                        }
                    } else x = $$.generateTargetX(rawX, id, i);
                    // mark as x = undefined if value is undefined and filter to remove after mapped
                    if (isUndefined(value) || $$.data.xs[id].length <= i) x = undefined;
                    return {
                        x: x,
                        value: value,
                        id: convertedId
                    };
                }).filter(function(v) {
                    return isDefined(v.x);
                })
            };
        });
        // finish targets
        targets.forEach(function(t) {
            // sort values by its x
            if (config.data_xSort) t.values = t.values.sort(function(v1, v2) {
                var x1 = v1.x || v1.x === 0 ? v1.x : Infinity;
                var x2 = v2.x || v2.x === 0 ? v2.x : Infinity;
                return x1 - x2;
            });
            // indexing each value
            t.values.forEach(function(v, i) {
                return v.index = i;
            });
            // this needs to be sorted because its index and value.index is identical
            $$.data.xs[t.id].sort(function(v1, v2) {
                return v1 - v2;
            });
        });
        // cache information about values
        state.hasNegativeValue = $$.hasNegativeValueInTargets(targets);
        state.hasPositiveValue = $$.hasPositiveValueInTargets(targets);
        // set target types
        if (config.data_type) $$.setTargetType($$.mapToIds(targets).filter(function(id) {
            return !(id in config.data_types);
        }), config.data_type);
        // cache as original id keyed
        targets.forEach(function(d) {
            return $$.cache.add(d.id_org, d, true);
        });
        return targets;
    }
};
var data$1 = {
    isX: function(key) {
        var $$ = this;
        var config = $$.config;
        var dataKey = config.data_x && key === config.data_x;
        var existValue = notEmpty(config.data_xs) && hasValue(config.data_xs, key);
        return dataKey || existValue;
    },
    isNotX: function(key) {
        return !this.isX(key);
    },
    isStackNormalized: function() {
        var config = this.config;
        return !!(config.data_stack_normalize && config.data_groups.length);
    },
    isGrouped: function(id) {
        var groups = this.config.data_groups;
        return id ? groups.some(function(v) {
            return v.indexOf(id) >= 0 && v.length > 1;
        }) : groups.length > 0;
    },
    getXKey: function(id) {
        var $$ = this;
        var config = $$.config;
        return config.data_x ? config.data_x : notEmpty(config.data_xs) ? config.data_xs[id] : null;
    },
    getXValuesOfXKey: function(key, targets) {
        var $$ = this;
        var ids = targets && notEmpty(targets) ? $$.mapToIds(targets) : [];
        var xValues;
        ids.forEach(function(id) {
            if ($$.getXKey(id) === key) xValues = $$.data.xs[id];
        });
        return xValues;
    },
    /**
     * Get index number based on given x Axis value
     * @param {Date|number|string} x x Axis to be compared
     * @param {Array} basedX x Axis list to be based on
     * @returns {number} index number
     * @private
     */ getIndexByX: function(x, basedX) {
        var $$ = this;
        return basedX ? basedX.indexOf(isString(x) ? x : +x) : ($$.filterByX($$.data.targets, x)[0] || {
            index: null
        }).index;
    },
    getXValue: function(id, i) {
        var $$ = this;
        return id in $$.data.xs && $$.data.xs[id] && isValue($$.data.xs[id][i]) ? $$.data.xs[id][i] : i;
    },
    getOtherTargetXs: function() {
        var $$ = this;
        var idsForX = Object.keys($$.data.xs);
        return idsForX.length ? $$.data.xs[idsForX[0]] : null;
    },
    getOtherTargetX: function(index) {
        var xs = this.getOtherTargetXs();
        return xs && index < xs.length ? xs[index] : null;
    },
    addXs: function(xs) {
        var $$ = this;
        var config = $$.config;
        Object.keys(xs).forEach(function(id) {
            config.data_xs[id] = xs[id];
        });
    },
    isMultipleX: function() {
        return notEmpty(this.config.data_xs) || !this.config.data_xSort || this.hasType("bubble") || this.hasType("scatter");
    },
    addName: function(data) {
        var $$ = this;
        var config = $$.config;
        var name;
        if (data) {
            name = config.data_names[data.id];
            data.name = name !== undefined ? name : data.id;
        }
        return data;
    },
    /**
     * Get all values on given index
     * @param {number} index Index
     * @param {boolean} filterNull Filter nullish value
     * @returns {Array}
     * @private
     */ getAllValuesOnIndex: function(index, filterNull) {
        if (filterNull === void 0) filterNull = false;
        var $$ = this;
        var value = $$.filterTargetsToShow($$.data.targets).map(function(t) {
            return $$.addName($$.getValueOnIndex(t.values, index));
        });
        if (filterNull) value = value.filter(function(v) {
            return isValue(v.value);
        });
        return value;
    },
    getValueOnIndex: function(values, index) {
        var valueOnIndex = values.filter(function(v) {
            return v.index === index;
        });
        return valueOnIndex.length ? valueOnIndex[0] : null;
    },
    updateTargetX: function(targets, x) {
        var $$ = this;
        targets.forEach(function(t) {
            t.values.forEach(function(v, i) {
                v.x = $$.generateTargetX(x[i], t.id, i);
            });
            $$.data.xs[t.id] = x;
        });
    },
    updateTargetXs: function(targets, xs) {
        var $$ = this;
        targets.forEach(function(t) {
            xs[t.id] && $$.updateTargetX([
                t
            ], xs[t.id]);
        });
    },
    generateTargetX: function(rawX, id, index) {
        var $$ = this;
        var axis = $$.axis;
        var x = axis && axis.isCategorized() ? index : rawX || index;
        if (axis && axis.isTimeSeries()) {
            var fn = parseDate.bind($$);
            x = rawX ? fn(rawX) : fn($$.getXValue(id, index));
        } else if (axis && axis.isCustomX() && !axis.isCategorized()) x = isValue(rawX) ? +rawX : $$.getXValue(id, index);
        return x;
    },
    updateXs: function(values) {
        if (values.length) this.axis.xs = values.map(function(v) {
            return v.x;
        });
    },
    getPrevX: function(i) {
        var x = this.axis.xs[i - 1];
        return isDefined(x) ? x : null;
    },
    getNextX: function(i) {
        var x = this.axis.xs[i + 1];
        return isDefined(x) ? x : null;
    },
    /**
     * Get base value isAreaRangeType
     * @param {object} data Data object
     * @returns {number}
     * @private
     */ getBaseValue: function(data) {
        var $$ = this;
        var hasAxis = $$.state.hasAxis;
        var value = data.value;
        // In case of area-range, data is given as: [low, mid, high] or {low, mid, high}
        // will take the 'mid' as the base value
        if (value && hasAxis) {
            if ($$.isAreaRangeType(data)) value = $$.getAreaRangeData(data, "mid");
            else if ($$.isBubbleZType(data)) value = $$.getBubbleZData(value, "y");
        }
        return value;
    },
    /**
     * Get min/max value from the data
     * @private
     * @param {Array} data array data to be evaluated
     * @returns {{min: {number}, max: {number}}}
     */ getMinMaxValue: function(data) {
        var getBaseValue = this.getBaseValue.bind(this);
        var min;
        var max;
        (data || this.data.targets.map(function(t) {
            return t.values;
        })).forEach(function(v, i) {
            var value = v.map(getBaseValue).filter(isNumber);
            min = Math.min.apply(Math, __spreadArray([
                i ? min : Infinity
            ], value, false));
            max = Math.max.apply(Math, __spreadArray([
                i ? max : -Infinity
            ], value, false));
        });
        return {
            min: min,
            max: max
        };
    },
    /**
     * Get the min/max data
     * @private
     * @returns {{min: Array, max: Array}}
     */ getMinMaxData: function() {
        var $$ = this;
        var cacheKey = KEY.dataMinMax;
        var minMaxData = $$.cache.get(cacheKey);
        if (!minMaxData) {
            var data = $$.data.targets.map(function(t) {
                return t.values;
            });
            var minMax_1 = $$.getMinMaxValue(data);
            var min_1 = [];
            var max_1 = [];
            data.forEach(function(v) {
                var minData = $$.getFilteredDataByValue(v, minMax_1.min);
                var maxData = $$.getFilteredDataByValue(v, minMax_1.max);
                if (minData.length) min_1 = min_1.concat(minData);
                if (maxData.length) max_1 = max_1.concat(maxData);
            });
            // update the cached data
            $$.cache.add(cacheKey, minMaxData = {
                min: min_1,
                max: max_1
            });
        }
        return minMaxData;
    },
    /**
     * Get sum of data per index
     * @private
     * @returns {Array}
     */ getTotalPerIndex: function() {
        var $$ = this;
        var cacheKey = KEY.dataTotalPerIndex;
        var sum = $$.cache.get(cacheKey);
        if ($$.isStackNormalized() && !sum) {
            sum = [];
            $$.data.targets.forEach(function(row) {
                row.values.forEach(function(v, i) {
                    if (!sum[i]) sum[i] = 0;
                    sum[i] += isNumber(v.value) ? v.value : 0;
                });
            });
        }
        return sum;
    },
    /**
     * Get total data sum
     * @param {boolean} subtractHidden Subtract hidden data from total
     * @returns {number}
     * @private
     */ getTotalDataSum: function(subtractHidden) {
        var $$ = this;
        var cacheKey = KEY.dataTotalSum;
        var total = $$.cache.get(cacheKey);
        if (!isNumber(total)) {
            var sum = mergeArray($$.data.targets.map(function(t) {
                return t.values;
            })).map(function(v) {
                return v.value;
            });
            total = sum.length ? sum.reduce(function(p, c) {
                return p + c;
            }) : 0;
            $$.cache.add(cacheKey, total = sum);
        }
        if (subtractHidden) total -= $$.getHiddenTotalDataSum();
        return total;
    },
    /**
     * Get total hidden data sum
     * @returns {number}
     * @private
     */ getHiddenTotalDataSum: function() {
        var $$ = this;
        var api = $$.api, hiddenTargetIds = $$.state.hiddenTargetIds;
        var total = 0;
        if (hiddenTargetIds.length) total = api.data.values.bind(api)(hiddenTargetIds).reduce(function(p, c) {
            return p + c;
        });
        return total;
    },
    /**
     * Get filtered data by value
     * @param {object} data Data
     * @param {number} value Value to be filtered
     * @returns {Array} filtered array data
     * @private
     */ getFilteredDataByValue: function(data, value) {
        var _this = this;
        return data.filter(function(t) {
            return _this.getBaseValue(t) === value;
        });
    },
    /**
     * Return the max length of the data
     * @returns {number} max data length
     * @private
     */ getMaxDataCount: function() {
        return Math.max.apply(Math, this.data.targets.map(function(t) {
            return t.values.length;
        }));
    },
    getMaxDataCountTarget: function() {
        var target = this.filterTargetsToShow() || [];
        var length = target.length;
        if (length > 1) {
            target = target.map(function(t) {
                return t.values;
            }).reduce(function(a, b) {
                return a.concat(b);
            }).map(function(v) {
                return v.x;
            });
            target = sortValue(getUnique(target)).map(function(x, index) {
                return {
                    x: x,
                    index: index
                };
            });
        } else if (length) target = target[0].values;
        return target;
    },
    mapToIds: function(targets) {
        return targets.map(function(d) {
            return d.id;
        });
    },
    mapToTargetIds: function(ids) {
        var $$ = this;
        return ids ? isArray(ids) ? ids.concat() : [
            ids
        ] : $$.mapToIds($$.data.targets);
    },
    hasTarget: function(targets, id) {
        var ids = this.mapToIds(targets);
        for(var i = 0, val = void 0; val = ids[i]; i++){
            if (val === id) return true;
        }
        return false;
    },
    isTargetToShow: function(targetId) {
        return this.state.hiddenTargetIds.indexOf(targetId) < 0;
    },
    isLegendToShow: function(targetId) {
        return this.state.hiddenLegendIds.indexOf(targetId) < 0;
    },
    filterTargetsToShow: function(targets) {
        var $$ = this;
        return (targets || $$.data.targets).filter(function(t) {
            return $$.isTargetToShow(t.id);
        });
    },
    mapTargetsToUniqueXs: function(targets) {
        var $$ = this;
        var axis = $$.axis;
        var xs = [];
        if (targets && targets.length) {
            xs = getUnique(mergeArray(targets.map(function(t) {
                return t.values.map(function(v) {
                    return +v.x;
                });
            })));
            xs = axis && axis.isTimeSeries() ? xs.map(function(x) {
                return new Date(+x);
            }) : xs.map(function(x) {
                return +x;
            });
        }
        return sortValue(xs);
    },
    addHiddenTargetIds: function(targetIds) {
        this.state.hiddenTargetIds = this.state.hiddenTargetIds.concat(targetIds);
    },
    removeHiddenTargetIds: function(targetIds) {
        this.state.hiddenTargetIds = this.state.hiddenTargetIds.filter(function(id) {
            return targetIds.indexOf(id) < 0;
        });
    },
    addHiddenLegendIds: function(targetIds) {
        this.state.hiddenLegendIds = this.state.hiddenLegendIds.concat(targetIds);
    },
    removeHiddenLegendIds: function(targetIds) {
        this.state.hiddenLegendIds = this.state.hiddenLegendIds.filter(function(id) {
            return targetIds.indexOf(id) < 0;
        });
    },
    getValuesAsIdKeyed: function(targets) {
        var $$ = this;
        var hasAxis = $$.state.hasAxis;
        var ys = {};
        var isMultipleX = $$.isMultipleX();
        var xs = isMultipleX ? $$.mapTargetsToUniqueXs(targets).map(function(v) {
            return isString(v) ? v : +v;
        }) : null;
        targets.forEach(function(t) {
            var data = [];
            t.values.forEach(function(v) {
                var value = v.value;
                if (isArray(value)) data.push.apply(data, value);
                else if (isObject(value) && "high" in value) data.push.apply(data, Object.values(value));
                else if ($$.isBubbleZType(v)) data.push(hasAxis && $$.getBubbleZData(value, "y"));
                else if (isMultipleX) data[$$.getIndexByX(v.x, xs)] = value;
                else data.push(value);
            });
            ys[t.id] = data;
        });
        return ys;
    },
    checkValueInTargets: function(targets, checker) {
        var ids = Object.keys(targets);
        var values;
        for(var i = 0; i < ids.length; i++){
            values = targets[ids[i]].values;
            for(var j = 0; j < values.length; j++){
                if (checker(values[j].value)) return true;
            }
        }
        return false;
    },
    hasMultiTargets: function() {
        return this.filterTargetsToShow().length > 1;
    },
    hasNegativeValueInTargets: function(targets) {
        return this.checkValueInTargets(targets, function(v) {
            return v < 0;
        });
    },
    hasPositiveValueInTargets: function(targets) {
        return this.checkValueInTargets(targets, function(v) {
            return v > 0;
        });
    },
    _checkOrder: function(type) {
        var config = this.config;
        var order = config.data_order;
        return isString(order) && order.toLowerCase() === type;
    },
    isOrderDesc: function() {
        return this._checkOrder("desc");
    },
    isOrderAsc: function() {
        return this._checkOrder("asc");
    },
    /**
     * Sort targets data
     * @param {Array} targetsValue Target value
     * @returns {Array}
     * @private
     */ orderTargets: function(targetsValue) {
        var $$ = this;
        var targets = __spreadArray([], targetsValue, true);
        var fn = $$.getSortCompareFn();
        fn && targets.sort(fn);
        return targets;
    },
    /**
     * Get data.order compare function
     * @param {boolean} isArc Is for Arc type sort or not
     * @returns {Function} compare function
     * @private
     */ getSortCompareFn: function(isArc) {
        if (isArc === void 0) isArc = false;
        var $$ = this;
        var config = $$.config;
        var orderAsc = $$.isOrderAsc();
        var orderDesc = $$.isOrderDesc();
        var fn;
        if (orderAsc || orderDesc) fn = function(t1, t2) {
            var reducer = function(p, c) {
                return p + Math.abs(c.value);
            };
            var t1Sum = t1.values.reduce(reducer, 0);
            var t2Sum = t2.values.reduce(reducer, 0);
            return isArc ? orderAsc ? t1Sum - t2Sum : t2Sum - t1Sum : orderAsc ? t2Sum - t1Sum : t1Sum - t2Sum;
        };
        else if (isFunction(config.data_order)) fn = config.data_order.bind($$.api);
        return fn || null;
    },
    filterByX: function(targets, x) {
        return mergeArray(targets.map(function(t) {
            return t.values;
        })).filter(function(v) {
            return v.x - x === 0;
        });
    },
    filterRemoveNull: function(data) {
        var _this = this;
        return data.filter(function(d) {
            return isValue(_this.getBaseValue(d));
        });
    },
    filterByXDomain: function(targets, xDomain) {
        return targets.map(function(t) {
            return {
                id: t.id,
                id_org: t.id_org,
                values: t.values.filter(function(v) {
                    return xDomain[0] <= v.x && v.x <= xDomain[1];
                })
            };
        });
    },
    hasDataLabel: function() {
        var dataLabels = this.config.data_labels;
        return isboolean(dataLabels) && dataLabels || isObjectType(dataLabels) && notEmpty(dataLabels);
    },
    /**
     * Get data index from the event coodinates
     * @param {Event} event Event object
     * @returns {number}
     */ getDataIndexFromEvent: function(event) {
        var $$ = this;
        var config = $$.config, _a = $$.state, inputType = _a.inputType, _b = _a.eventReceiver, coords = _b.coords, rect = _b.rect;
        var isRotated = config.axis_rotated;
        // get data based on the mouse coords
        var e = inputType === "touch" && event.changedTouches ? event.changedTouches[0] : event;
        var index = findIndex(coords, isRotated ? e.clientY - rect.top : e.clientX - rect.left, 0, coords.length - 1, isRotated);
        return index;
    },
    getDataLabelLength: function(min, max, key) {
        var $$ = this;
        var lengths = [
            0,
            0
        ];
        var paddingCoef = 1.3;
        $$.$el.chart.select("svg").selectAll(".dummy").data([
            min,
            max
        ]).enter().append("text").text(function(d) {
            return $$.dataLabelFormat(d.id)(d);
        }).each(function(d, i) {
            lengths[i] = this.getBoundingClientRect()[key] * paddingCoef;
        }).remove();
        return lengths;
    },
    isNoneArc: function(d) {
        return this.hasTarget(this.data.targets, d.id);
    },
    isArc: function(d) {
        return "data" in d && this.hasTarget(this.data.targets, d.data.id);
    },
    findSameXOfValues: function(values, index) {
        var targetX = values[index].x;
        var sames = [];
        var i;
        for(i = index - 1; i >= 0; i--){
            if (targetX !== values[i].x) break;
            sames.push(values[i]);
        }
        for(i = index; i < values.length; i++){
            if (targetX !== values[i].x) break;
            sames.push(values[i]);
        }
        return sames;
    },
    findClosestFromTargets: function(targets, pos) {
        var $$ = this;
        var candidates = targets.map(function(target) {
            return $$.findClosest(target.values, pos);
        }); // map to array of closest points of each target
        // decide closest point and return
        return $$.findClosest(candidates, pos);
    },
    findClosest: function(values, pos) {
        var $$ = this;
        var config = $$.config, main = $$.$el.main;
        var data = values.filter(function(v) {
            return v && isValue(v.value);
        });
        var minDist = config.point_sensitivity;
        var closest;
        // find mouseovering bar
        data.filter(function(v) {
            return $$.isBarType(v.id);
        }).forEach(function(v) {
            var shape = main.select(".".concat(CLASS.bars).concat($$.getTargetSelectorSuffix(v.id), " .").concat(CLASS.bar, "-").concat(v.index)).node();
            if (!closest && $$.isWithinBar(shape)) closest = v;
        });
        // find closest point from non-bar
        data.filter(function(v) {
            return !$$.isBarType(v.id);
        }).forEach(function(v) {
            var d = $$.dist(v, pos);
            if (d < minDist) {
                minDist = d;
                closest = v;
            }
        });
        return closest;
    },
    dist: function(data, pos) {
        var $$ = this;
        var isRotated = $$.config.axis_rotated, scale = $$.scale;
        var xIndex = isRotated ? 1 : 0;
        var yIndex = isRotated ? 0 : 1;
        var y = $$.circleY(data, data.index);
        var x = (scale.zoom || scale.x)(data.x);
        return Math.sqrt(Math.pow(x - pos[xIndex], 2) + Math.pow(y - pos[yIndex], 2));
    },
    /**
     * Convert data for step type
     * @param {Array} values Object data values
     * @returns {Array}
     * @private
     */ convertValuesToStep: function(values) {
        var $$ = this;
        var axis = $$.axis, config = $$.config;
        var stepType = config.line_step_type;
        var isCategorized = axis ? axis.isCategorized() : false;
        var converted = isArray(values) ? values.concat() : [
            values
        ];
        if (!(isCategorized || /step\-(after|before)/.test(stepType))) return values;
        // insert & append cloning first/last value to be fully rendered covering on each gap sides
        var head = converted[0];
        var tail = converted[converted.length - 1];
        var id = head.id;
        var x = head.x;
        // insert head
        converted.unshift({
            x: --x,
            value: head.value,
            id: id
        });
        isCategorized && stepType === "step-after" && converted.unshift({
            x: --x,
            value: head.value,
            id: id
        });
        // append tail
        x = tail.x;
        converted.push({
            x: ++x,
            value: tail.value,
            id: id
        });
        isCategorized && stepType === "step-before" && converted.push({
            x: ++x,
            value: tail.value,
            id: id
        });
        return converted;
    },
    convertValuesToRange: function(values) {
        var converted = isArray(values) ? values.concat() : [
            values
        ];
        var ranges = [];
        converted.forEach(function(range) {
            var x = range.x, id = range.id;
            ranges.push({
                x: x,
                id: id,
                value: range.value[0]
            });
            ranges.push({
                x: x,
                id: id,
                value: range.value[2]
            });
        });
        return ranges;
    },
    updateDataAttributes: function(name, attrs) {
        var $$ = this;
        var config = $$.config;
        var current = config["data_".concat(name)];
        if (isUndefined(attrs)) return current;
        Object.keys(attrs).forEach(function(id) {
            current[id] = attrs[id];
        });
        $$.redraw({
            withLegend: true
        });
        return current;
    },
    getAreaRangeData: function(d, type) {
        var value = d.value;
        if (isArray(value)) {
            var index = [
                "high",
                "mid",
                "low"
            ].indexOf(type);
            return index === -1 ? null : value[index];
        }
        return value[type];
    },
    /**
     * Get ratio value
     * @param {string} type Ratio for given type
     * @param {object} d Data value object
     * @param {boolean} asPercent Convert the return as percent or not
     * @returns {number} Ratio value
     * @private
     */ getRatio: function(type, d, asPercent) {
        var $$ = this;
        var config = $$.config, state = $$.state;
        var api = $$.api;
        var ratio = 0;
        if (d && api.data.shown().length) {
            ratio = d.ratio || d.value;
            if (type === "arc") {
                // if has padAngle set, calculate rate based on value
                if ($$.pie.padAngle()()) ratio = d.value / $$.getTotalDataSum(true);
                else {
                    var gaugeArcLength = config.gauge_fullCircle ? $$.getArcLength() : $$.getStartAngle() * -2;
                    var arcLength = $$.hasType("gauge") ? gaugeArcLength : Math.PI * 2;
                    ratio = (d.endAngle - d.startAngle) / arcLength;
                }
            } else if (type === "index") {
                var dataValues = api.data.values.bind(api);
                var total = this.getTotalPerIndex();
                if (state.hiddenTargetIds.length) {
                    var hiddenSum_1 = dataValues(state.hiddenTargetIds, false);
                    if (hiddenSum_1.length) {
                        hiddenSum_1 = hiddenSum_1.reduce(function(acc, curr) {
                            return acc.map(function(v, i) {
                                return (isNumber(v) ? v : 0) + curr[i];
                            });
                        });
                        total = total.map(function(v, i) {
                            return v - hiddenSum_1[i];
                        });
                    }
                }
                d.ratio = isNumber(d.value) && total && total[d.index] > 0 ? d.value / total[d.index] : 0;
                ratio = d.ratio;
            } else if (type === "radar") ratio = parseFloat(String(Math.max(d.value, 0))) / state.current.dataMax * config.radar_size_ratio;
            else if (type === "bar") {
                var yScale = $$.getYScaleById.bind($$)(d.id);
                var max = yScale.domain().reduce(function(a, c) {
                    return c - a;
                });
                ratio = Math.abs(d.value) / max;
            }
        }
        return asPercent && ratio ? ratio * 100 : ratio;
    },
    /**
     * Sort data index to be aligned with x axis.
     * @param {Array} tickValues Tick array values
     * @private
     */ updateDataIndexByX: function(tickValues) {
        var $$ = this;
        var tickValueMap = tickValues.reduce(function(out, tick, index) {
            out[Number(tick.x)] = index;
            return out;
        }, {});
        $$.data.targets.forEach(function(t) {
            t.values.forEach(function(value, valueIndex) {
                var index = tickValueMap[Number(value.x)];
                if (index === undefined) index = valueIndex;
                value.index = index;
            });
        });
    },
    /**
     * Determine if bubble has dimension data
     * @param {object|Array} d data value
     * @returns {boolean}
     * @private
     */ isBubbleZType: function(d) {
        var $$ = this;
        return $$.isBubbleType(d) && (isObject(d.value) && ("z" in d.value || "y" in d.value) || isArray(d.value) && d.value.length === 2);
    },
    /**
     * Get data object by id
     * @param {string} id data id
     * @returns {object}
     * @private
     */ getDataById: function(id) {
        var d = this.cache.get(id) || this.api.data(id);
        return isArray(d) ? d[0] : d;
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var dataLoad = {
    load: function(rawTargets, args) {
        var $$ = this;
        var targets = rawTargets;
        if (targets) {
            // filter loading targets if needed
            if (args.filter) targets = targets.filter(args.filter);
            // set type if args.types || args.type specified
            if (args.type || args.types) targets.forEach(function(t) {
                var type = args.types && args.types[t.id] || args.type;
                $$.setTargetType(t.id, type);
            });
            // Update/Add data
            $$.data.targets.forEach(function(d) {
                for(var i = 0; i < targets.length; i++)if (d.id === targets[i].id) {
                    d.values = targets[i].values;
                    targets.splice(i, 1);
                    break;
                }
            });
            $$.data.targets = $$.data.targets.concat(targets); // add remained
        }
        // Set targets
        $$.updateTargets($$.data.targets);
        // Redraw with new targets
        $$.redraw({
            withUpdateOrgXDomain: true,
            withUpdateXDomain: true,
            withLegend: true
        });
        // Update current state chart type and elements list after redraw
        $$.updateTypesElements();
        args.done && args.done.call($$.api);
    },
    loadFromArgs: function(args) {
        var $$ = this;
        // prevent load when chart is already destroyed
        if (!$$.config) return;
        // reset internally cached data
        $$.cache.reset();
        var data = args.data || $$.convertData(args, function(d) {
            return $$.load($$.convertDataToTargets(d), args);
        });
        data && $$.load($$.convertDataToTargets(data), args);
    },
    unload: function(rawTargetIds, customDoneCb) {
        var $$ = this;
        var state = $$.state, $el = $$.$el;
        var done = customDoneCb;
        var targetIds = rawTargetIds;
        // reset internally cached data
        $$.cache.reset();
        if (!done) done = function() {};
        // filter existing target
        targetIds = targetIds.filter(function(id) {
            return $$.hasTarget($$.data.targets, id);
        });
        // If no target, call done and return
        if (!targetIds || targetIds.length === 0) {
            done();
            return;
        }
        $el.svg.selectAll(targetIds.map(function(id) {
            return $$.selectorTarget(id);
        })).transition().style("opacity", "0").remove().call(endall, done);
        targetIds.forEach(function(id) {
            // Reset fadein for future load
            state.withoutFadeIn[id] = false;
            // Remove target's elements
            if ($el.legend) $el.legend.selectAll(".".concat(CLASS.legendItem).concat($$.getTargetSelectorSuffix(id))).remove();
            // Remove target
            $$.data.targets = $$.data.targets.filter(function(t) {
                return t.id !== id;
            });
        });
        // Update current state chart type and elements list after redraw
        $$.updateTypesElements();
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var interaction = {
    selectRectForSingle: function(context, eventRect, index) {
        var $$ = this;
        var config = $$.config, main = $$.$el.main;
        var isSelectionEnabled = config.data_selection_enabled;
        var isSelectionGrouped = config.data_selection_grouped;
        var isSelectable = config.data_selection_isselectable;
        var isTooltipGrouped = config.tooltip_grouped;
        var selectedData = $$.getAllValuesOnIndex(index);
        if (isTooltipGrouped) {
            $$.showTooltip(selectedData, context);
            $$.showGridFocus && $$.showGridFocus(selectedData);
            if (!isSelectionEnabled || isSelectionGrouped) return;
        }
        main.selectAll(".".concat(CLASS.shape, "-").concat(index)).each(function() {
            (0, $hOxpW.default)(this).classed(CLASS.EXPANDED, true);
            if (isSelectionEnabled) eventRect.style("cursor", isSelectionGrouped ? "pointer" : null);
            if (!isTooltipGrouped) {
                $$.hideGridFocus && $$.hideGridFocus();
                $$.hideTooltip();
                !isSelectionGrouped && $$.expandCirclesBars(index);
            }
        }).filter(function(d) {
            return $$.isWithinShape(this, d);
        }).call(function(selected) {
            var d = selected.data();
            if (isSelectionEnabled && (isSelectionGrouped || isSelectable && isSelectable.bind($$.api)(d))) eventRect.style("cursor", "pointer");
            if (!isTooltipGrouped) {
                $$.showTooltip(d, context);
                $$.showGridFocus && $$.showGridFocus(d);
                $$.unexpandCircles && $$.unexpandCircles();
                selected.each(function(d) {
                    return $$.expandCirclesBars(index, d.id);
                });
            }
        });
    },
    expandCirclesBars: function(index, id, reset) {
        var $$ = this;
        var config = $$.config, _a = $$.$el, bar = _a.bar, circle = _a.circle;
        circle && config.point_focus_expand_enabled && $$.expandCircles(index, id, reset);
        bar && $$.expandBars(index, id, reset);
    },
    /**
     * Handle data.onover/out callback options
     * @param {boolean} isOver Over or not
     * @param {number|object} d data object
     * @private
     */ setOverOut: function(isOver, d) {
        var $$ = this;
        var config = $$.config, hasRadar = $$.state.hasRadar, main = $$.$el.main;
        var isArc = isObject(d);
        // Call event handler
        if (isArc || d !== -1) {
            var callback_1 = config[isOver ? "data_onover" : "data_onout"].bind($$.api);
            config.color_onover && $$.setOverColor(isOver, d, isArc);
            if (isArc) callback_1(d, main.select(".".concat(CLASS.arc).concat($$.getTargetSelectorSuffix(d.id))).node());
            else if (!config.tooltip_grouped) {
                var last_1 = $$.cache.get(KEY.setOverOut) || [];
                var shape = main.selectAll(".".concat(CLASS.shape, "-").concat(d)).filter(function(d) {
                    return $$.isWithinShape(this, d);
                });
                shape.each(function(d) {
                    var _this = this;
                    if (last_1.length === 0 || last_1.every(function(v) {
                        return v !== _this;
                    })) {
                        callback_1(d, this);
                        last_1.push(this);
                    }
                });
                if (last_1.length > 0 && shape.empty()) {
                    callback_1 = config.data_onout.bind($$.api);
                    last_1.forEach(function(v) {
                        return callback_1((0, $hOxpW.default)(v).datum(), v);
                    });
                    last_1 = [];
                }
                $$.cache.add(KEY.setOverOut, last_1);
            } else {
                if (isOver) config.point_focus_only && hasRadar ? $$.showCircleFocus($$.getAllValuesOnIndex(d, true)) : $$.expandCirclesBars(d, null, true);
                !$$.isMultipleX() && main.selectAll(".".concat(CLASS.shape, "-").concat(d)).each(function(d) {
                    callback_1(d, this);
                });
            }
        }
    },
    /**
     * Call data.onover/out callback for touch event
     * @param {number|object} d target index or data object for Arc type
     * @private
     */ callOverOutForTouch: function(d) {
        var $$ = this;
        var last = $$.cache.get(KEY.callOverOutForTouch);
        if (isObject(d) && last ? d.id !== last.id : d !== last) {
            (last || isNumber(last)) && $$.setOverOut(false, last);
            (d || isNumber(d)) && $$.setOverOut(true, d);
            $$.cache.add(KEY.callOverOutForTouch, d);
        }
    },
    /**
     * Return draggable selection function
     * @returns {Function}
     * @private
     */ getDraggableSelection: function() {
        var $$ = this;
        var config = $$.config;
        return config.interaction_enabled && config.data_selection_draggable && $$.drag ? (0, $Y5MKl.default)().on("drag", function() {
            // @ts-ignore
            $$.drag((0, $iS3vq.default)(this));
        }).on("start", function() {
            // @ts-ignore
            $$.dragstart((0, $iS3vq.default)(this));
        }).on("end", function() {
            $$.dragend();
        }) : function() {};
    },
    /**
     * Dispatch a mouse event.
     * @private
     * @param {string} type event type
     * @param {number} index Index of eventRect
     * @param {Array} mouse x and y coordinate value
     */ dispatchEvent: function(type, index, mouse) {
        var $$ = this;
        var config = $$.config, _a = $$.state, eventReceiver = _a.eventReceiver, hasAxis = _a.hasAxis, hasRadar = _a.hasRadar, _b = $$.$el, eventRect = _b.eventRect, arcs = _b.arcs, radar = _b.radar;
        var isMultipleX = $$.isMultipleX();
        var element = (hasRadar ? radar.axes.select(".".concat(CLASS.axis, "-").concat(index, " text")) : eventRect || arcs.selectAll(".".concat(CLASS.target, " path")).filter(function(d, i) {
            return i === index;
        })).node();
        var _c = element.getBoundingClientRect(), width = _c.width, left = _c.left, top = _c.top;
        if (hasAxis && !hasRadar && !isMultipleX) {
            var coords = eventReceiver.coords[index];
            width = coords.w;
            left += coords.x;
            top += coords.y;
        }
        var x = left + (mouse ? mouse[0] : 0) + (isMultipleX || config.axis_rotated ? 0 : width / 2);
        var y = top + (mouse ? mouse[1] : 0);
        var params = {
            screenX: x,
            screenY: y,
            clientX: x,
            clientY: y
        };
        emulateEvent[/^(mouse|click)/.test(type) ? "mouse" : "touch"](element, type, params);
    },
    setDragStatus: function(isDragging) {
        this.state.dragging = isDragging;
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var classModule = {
    generateClass: function(prefix, targetId) {
        return " ".concat(prefix, " ").concat(prefix + this.getTargetSelectorSuffix(targetId));
    },
    /**
     * Get class string
     * @param {string} type Shape type
     * @param {boolean} withShape Get with shape prefix
     * @returns {string} Class string
     * @private
     */ getClass: function(type, withShape) {
        var _this = this;
        var isPlural = /s$/.test(type);
        var useIdKey = /^(area|arc|line)s?$/.test(type);
        var key = isPlural ? "id" : "index";
        return function(d) {
            var data = d.data || d;
            var result = (withShape ? _this.generateClass(CLASS[isPlural ? "shapes" : "shape"], data[key]) : "") + _this.generateClass(CLASS[type], data[useIdKey ? "id" : key]);
            return result;
        };
    },
    /**
     * Get chart class string
     * @param {string} type Shape type
     * @returns {string} Class string
     * @private
     */ getChartClass: function(type) {
        var _this = this;
        return function(d) {
            return CLASS["chart".concat(type)] + _this.classTarget((d.data ? d.data : d).id);
        };
    },
    generateExtraLineClass: function() {
        var $$ = this;
        var classes = $$.config.line_classes || [];
        var ids = [];
        return function(d) {
            var id = d.id || d.data && d.data.id || d;
            if (ids.indexOf(id) < 0) ids.push(id);
            return classes[ids.indexOf(id) % classes.length];
        };
    },
    classRegion: function(d, i) {
        return "".concat(this.generateClass(CLASS.region, i), " ").concat("class" in d ? d["class"] : "");
    },
    classTarget: function(id) {
        var additionalClassSuffix = this.config.data_classes[id];
        var additionalClass = "";
        if (additionalClassSuffix) additionalClass = " ".concat(CLASS.target, "-").concat(additionalClassSuffix);
        return this.generateClass(CLASS.target, id) + additionalClass;
    },
    classFocus: function(d) {
        return this.classFocused(d) + this.classDefocused(d);
    },
    classFocused: function(d) {
        return " ".concat(this.state.focusedTargetIds.indexOf(d.id) >= 0 ? CLASS.focused : "");
    },
    classDefocused: function(d) {
        return " ".concat(this.state.defocusedTargetIds.indexOf(d.id) >= 0 ? CLASS.defocused : "");
    },
    getTargetSelectorSuffix: function(targetId) {
        return targetId || targetId === 0 ? "-".concat(targetId).replace(/[\s?!@#$%^&*()_=+,.<>'":;\[\]\/|~`{}\\]/g, "-") : "";
    },
    selectorTarget: function(id, prefix) {
        var pfx = prefix || "";
        var target = this.getTargetSelectorSuffix(id);
        // select target & circle
        return "".concat(pfx, ".").concat(CLASS.target + target, ", ").concat(pfx, ".").concat(CLASS.circles + target);
    },
    selectorTargets: function(idsValue, prefix) {
        var _this = this;
        var ids = idsValue || [];
        return ids.length ? ids.map(function(id) {
            return _this.selectorTarget(id, prefix);
        }) : null;
    },
    selectorLegend: function(id) {
        return ".".concat(CLASS.legendItem + this.getTargetSelectorSuffix(id));
    },
    selectorLegends: function(ids) {
        var _this = this;
        return ids && ids.length ? ids.map(function(id) {
            return _this.selectorLegend(id);
        }) : null;
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var category = {
    /**
     * Category Name
     * @param {number} i Index number
     * @returns {string} category Name
     * @private
     */ categoryName: function(i) {
        var categories = this.config.axis_x_categories;
        return categories && i < categories.length ? categories[i] : i;
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * Set pattern's background color
 * (it adds a <rect> element to simulate bg-color)
 * @param {SVGPatternElement} pattern SVG pattern element
 * @param {string} color Color string
 * @param {string} id ID to be set
 * @returns {{id: string, node: SVGPatternElement}}
 * @private
 */ var colorizePattern = function(pattern, color, id) {
    var node = (0, $hOxpW.default)(pattern.cloneNode(true));
    node.attr("id", id).insert("rect", ":first-child").attr("width", node.attr("width")).attr("height", node.attr("height")).style("fill", color);
    return {
        id: id,
        node: node.node()
    };
};
// Replacement of d3.schemeCategory10.
// Contained differently depend on d3 version: v4(d3-scale), v5(d3-scale-chromatic)
var schemeCategory10 = [
    "#1f77b4",
    "#ff7f0e",
    "#2ca02c",
    "#d62728",
    "#9467bd",
    "#8c564b",
    "#e377c2",
    "#7f7f7f",
    "#bcbd22",
    "#17becf"
];
var color = {
    /**
     * Get color pattern from CSS file
     * CSS should be defined as: background-image: url("#00c73c;#fa7171; ...");
     * @returns {Array}
     * @private
     */ getColorFromCss: function() {
        var cacheKey = KEY.colorPattern;
        var body = doc.body;
        var pattern = body[cacheKey];
        if (!pattern) {
            var delimiter = ";";
            var span = doc.createElement("span");
            span.className = CLASS.colorPattern;
            span.style.display = "none";
            body.appendChild(span);
            var content = win.getComputedStyle(span).backgroundImage;
            span.parentNode.removeChild(span);
            if (content.indexOf(delimiter) > -1) {
                pattern = content.replace(/url[^#]*|["'()]|(\s|%20)/g, "").split(delimiter).map(function(v) {
                    return v.trim().replace(/[\"'\s]/g, "");
                }).filter(Boolean);
                body[cacheKey] = pattern;
            }
        }
        return pattern;
    },
    generateColor: function() {
        var $$ = this;
        var config = $$.config;
        var colors = config.data_colors;
        var callback = config.data_color;
        var ids = [];
        var pattern = notEmpty(config.color_pattern) ? config.color_pattern : (0, $4PqgM.default)($$.getColorFromCss() || schemeCategory10).range();
        var originalColorPattern = pattern;
        if (isFunction(config.color_tiles)) {
            var tiles_1 = config.color_tiles.bind($$.api)();
            // Add background color to patterns
            var colorizedPatterns = pattern.map(function(p, index) {
                var color = p.replace(/[#\(\)\s,]/g, "");
                var id = "".concat($$.state.datetimeId, "-pattern-").concat(color, "-").concat(index);
                return colorizePattern(tiles_1[index % tiles_1.length], p, id);
            });
            pattern = colorizedPatterns.map(function(p) {
                return "url(#".concat(p.id, ")");
            });
            $$.patterns = colorizedPatterns;
        }
        return function(d) {
            var id = d.id || d.data && d.data.id || d;
            var isLine = $$.isTypeOf(id, [
                "line",
                "spline",
                "step"
            ]) || !config.data_types[id];
            var color;
            // if callback function is provided
            if (isFunction(colors[id])) color = colors[id].bind($$.api)(d);
            else if (colors[id]) color = colors[id];
            else {
                if (ids.indexOf(id) < 0) ids.push(id);
                color = isLine ? originalColorPattern[ids.indexOf(id) % originalColorPattern.length] : pattern[ids.indexOf(id) % pattern.length];
                colors[id] = color;
            }
            return isFunction(callback) ? callback.bind($$.api)(color, d) : color;
        };
    },
    generateLevelColor: function() {
        var $$ = this;
        var config = $$.config;
        var colors = config.color_pattern;
        var threshold = config.color_threshold;
        var asValue = threshold.unit === "value";
        var max = threshold.max || 100;
        var values = threshold.values && threshold.values.length ? threshold.values : [];
        return notEmpty(threshold) ? function(value) {
            var v = asValue ? value : value * 100 / max;
            var color = colors[colors.length - 1];
            for(var i = 0, l = values.length; i < l; i++)if (v <= values[i]) {
                color = colors[i];
                break;
            }
            return color;
        } : null;
    },
    /**
     * Set the data over color.
     * When is out, will restate in its previous color value
     * @param {boolean} isOver true: set overed color, false: restore
     * @param {number|object} d target index or data object for Arc type
     * @private
     */ setOverColor: function(isOver, d) {
        var $$ = this;
        var config = $$.config, main = $$.$el.main;
        var onover = config.color_onover;
        var color = isOver ? onover : $$.color;
        if (isObject(color)) color = function(_a) {
            var id = _a.id;
            return id in onover ? onover[id] : $$.color(id);
        };
        else if (isString(color)) color = function() {
            return onover;
        };
        else if (isFunction(onover)) color = color.bind($$.api);
        main.selectAll(isObject(d) ? // when is Arc type
        ".".concat(CLASS.arc).concat($$.getTargetSelectorSuffix(d.id)) : ".".concat(CLASS.shape, "-").concat(d)).style("fill", color);
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * Chart type constant
 * @private
 */ var TYPE = {
    AREA: "area",
    AREA_LINE_RANGE: "area-line-range",
    AREA_SPLINE: "area-spline",
    AREA_SPLINE_RANGE: "area-spline-range",
    AREA_STEP: "area-step",
    BAR: "bar",
    BUBBLE: "bubble",
    DONUT: "donut",
    GAUGE: "gauge",
    LINE: "line",
    PIE: "pie",
    RADAR: "radar",
    SCATTER: "scatter",
    SPLINE: "spline",
    STEP: "step"
};
/**
 * chart types by category
 * @private
 */ var TYPE_BY_CATEGORY = {
    Area: [
        TYPE.AREA,
        TYPE.AREA_SPLINE,
        TYPE.AREA_SPLINE_RANGE,
        TYPE.AREA_LINE_RANGE,
        TYPE.AREA_STEP
    ],
    AreaRange: [
        TYPE.AREA_SPLINE_RANGE,
        TYPE.AREA_LINE_RANGE
    ],
    Arc: [
        TYPE.PIE,
        TYPE.DONUT,
        TYPE.GAUGE,
        TYPE.RADAR
    ],
    Line: [
        TYPE.LINE,
        TYPE.SPLINE,
        TYPE.AREA,
        TYPE.AREA_SPLINE,
        TYPE.AREA_SPLINE_RANGE,
        TYPE.AREA_LINE_RANGE,
        TYPE.STEP,
        TYPE.AREA_STEP
    ],
    Step: [
        TYPE.STEP,
        TYPE.AREA_STEP
    ],
    Spline: [
        TYPE.SPLINE,
        TYPE.AREA_SPLINE,
        TYPE.AREA_SPLINE_RANGE
    ]
};
var domain = {
    getYDomainMinMax: function(targets, type) {
        var $$ = this;
        var axis = $$.axis, config = $$.config;
        var isMin = type === "min";
        var dataGroups = config.data_groups;
        var ids = $$.mapToIds(targets);
        var ys = $$.getValuesAsIdKeyed(targets);
        if (dataGroups.length > 0) {
            var hasValue_1 = $$["has".concat(isMin ? "Negative" : "Positive", "ValueInTargets")](targets);
            var _loop_1 = function(j, idsInGroup) {
                // Determine baseId
                idsInGroup = idsInGroup.filter(function(v) {
                    return ids.indexOf(v) >= 0;
                });
                if (idsInGroup.length === 0) return out_idsInGroup_1 = idsInGroup, "continue";
                var baseId = idsInGroup[0];
                var baseAxisId = axis.getId(baseId);
                // Initialize base value. Set to 0 if not match with the condition
                if (hasValue_1 && ys[baseId]) ys[baseId] = ys[baseId].map(function(v) {
                    return (isMin ? v < 0 : v > 0) ? v : 0;
                });
                var _loop_2 = function(k, id) {
                    if (!ys[id]) return "continue";
                    var axisId = axis.getId(id);
                    ys[id].forEach(function(v, i) {
                        var val = +v;
                        var meetCondition = isMin ? val > 0 : val < 0;
                        if (axisId === baseAxisId && !(hasValue_1 && meetCondition)) ys[baseId][i] += val;
                    });
                };
                for(var k = 1, id = void 0; id = idsInGroup[k]; k++)_loop_2(k, id);
                out_idsInGroup_1 = idsInGroup;
            };
            var out_idsInGroup_1;
            for(var j = 0, idsInGroup = void 0; idsInGroup = dataGroups[j]; j++){
                _loop_1(j, idsInGroup);
                idsInGroup = out_idsInGroup_1;
            }
        }
        return getMinMax$1(type, Object.keys(ys).map(function(key) {
            return getMinMax$1(type, ys[key]);
        }));
    },
    getYDomainMin: function(targets) {
        return this.getYDomainMinMax(targets, "min");
    },
    getYDomainMax: function(targets) {
        return this.getYDomainMinMax(targets, "max");
    },
    /**
     * Check if hidden targets bound to the given axis id
     * @param {string} id ID to be checked
     * @returns {boolean}
     * @private
     */ isHiddenTargetWithYDomain: function(id) {
        var $$ = this;
        return $$.state.hiddenTargetIds.some(function(v) {
            return $$.axis.getId(v) === id;
        });
    },
    getYDomain: function(targets, axisId, xDomain) {
        var $$ = this;
        var axis = $$.axis, config = $$.config, scale = $$.scale;
        var pfx = "axis_".concat(axisId);
        if ($$.isStackNormalized()) return [
            0,
            100
        ];
        var isLog = scale && scale[axisId] && scale[axisId].type === "log";
        var targetsByAxisId = targets.filter(function(t) {
            return axis.getId(t.id) === axisId;
        });
        var yTargets = xDomain ? $$.filterByXDomain(targetsByAxisId, xDomain) : targetsByAxisId;
        if (yTargets.length === 0) {
            if ($$.isHiddenTargetWithYDomain(axisId)) return scale[axisId].domain();
            else return axisId === "y2" ? scale.y.domain() : // When all data bounds to y2, y Axis domain is called prior y2.
            // So, it needs to call to get y2 domain here
            $$.getYDomain(targets, "y2", xDomain);
        }
        var yMin = config["".concat(pfx, "_min")];
        var yMax = config["".concat(pfx, "_max")];
        var yDomainMin = $$.getYDomainMin(yTargets);
        var yDomainMax = $$.getYDomainMax(yTargets);
        var center = config["".concat(pfx, "_center")];
        var isZeroBased = __spreadArray([
            TYPE.BAR,
            TYPE.BUBBLE,
            TYPE.SCATTER
        ], TYPE_BY_CATEGORY.Line, true).some(function(v) {
            var type = v.indexOf("area") > -1 ? "area" : v;
            return $$.hasType(v, yTargets) && config["".concat(type, "_zerobased")];
        });
        var isInverted = config["".concat(pfx, "_inverted")];
        var showHorizontalDataLabel = $$.hasDataLabel() && config.axis_rotated;
        var showVerticalDataLabel = $$.hasDataLabel() && !config.axis_rotated;
        // MEMO: avoid inverting domain unexpectedly
        yDomainMin = isValue(yMin) ? yMin : isValue(yMax) ? yDomainMin < yMax ? yDomainMin : yMax - 10 : yDomainMin;
        yDomainMax = isValue(yMax) ? yMax : isValue(yMin) ? yMin < yDomainMax ? yDomainMax : yMin + 10 : yDomainMax;
        if (isNaN(yDomainMin)) yDomainMin = 0;
        if (isNaN(yDomainMax)) yDomainMax = yDomainMin;
        if (yDomainMin === yDomainMax) yDomainMin < 0 ? yDomainMax = 0 : yDomainMin = 0;
        var isAllPositive = yDomainMin >= 0 && yDomainMax >= 0;
        var isAllNegative = yDomainMin <= 0 && yDomainMax <= 0;
        // Cancel zerobased if axis_*_min / axis_*_max specified
        if (isValue(yMin) && isAllPositive || isValue(yMax) && isAllNegative) isZeroBased = false;
        // Bar/Area chart should be 0-based if all positive|negative
        if (isZeroBased) {
            isAllPositive && (yDomainMin = 0);
            isAllNegative && (yDomainMax = 0);
        }
        var domainLength = Math.abs(yDomainMax - yDomainMin);
        var padding = {
            top: domainLength * 0.1,
            bottom: domainLength * 0.1
        };
        if (isDefined(center)) {
            var yDomainAbs = Math.max(Math.abs(yDomainMin), Math.abs(yDomainMax));
            yDomainMax = center + yDomainAbs;
            yDomainMin = center - yDomainAbs;
        }
        // add padding for data label
        if (showHorizontalDataLabel) {
            var diff_1 = diffDomain(scale.y.range());
            var ratio_1 = $$.getDataLabelLength(yDomainMin, yDomainMax, "width").map(function(v) {
                return v / diff_1;
            });
            [
                "bottom",
                "top"
            ].forEach(function(v, i) {
                padding[v] += domainLength * (ratio_1[i] / (1 - ratio_1[0] - ratio_1[1]));
            });
        } else if (showVerticalDataLabel) {
            var lengths_1 = $$.getDataLabelLength(yDomainMin, yDomainMax, "height");
            [
                "bottom",
                "top"
            ].forEach(function(v, i) {
                padding[v] += axis.convertPixelsToAxisPadding(lengths_1[i], domainLength);
            });
        }
        // if padding is set, the domain will be updated relative the current domain value
        // ex) $$.height=300, padding.top=150, domainLength=4  --> domain=6
        var p = config["".concat(pfx, "_padding")];
        if (notEmpty(p)) [
            "bottom",
            "top"
        ].forEach(function(v) {
            padding[v] = axis.getPadding(p, v, padding[v], domainLength);
        });
        // Bar/Area chart should be 0-based if all positive|negative
        if (isZeroBased) {
            isAllPositive && (padding.bottom = yDomainMin);
            isAllNegative && (padding.top = -yDomainMax);
        }
        var domain = isLog ? [
            yDomainMin,
            yDomainMax
        ].map(function(v) {
            return v < 0 ? 0 : v;
        }) : [
            yDomainMin - padding.bottom,
            yDomainMax + padding.top
        ];
        return isInverted ? domain.reverse() : domain;
    },
    getXDomainMinMax: function(targets, type) {
        var $$ = this;
        var configValue = $$.config["axis_x_".concat(type)];
        var dataValue = getMinMax$1(type, targets.map(function(t) {
            return getMinMax$1(type, t.values.map(function(v) {
                return v.x;
            }));
        }));
        var value = isObject(configValue) ? configValue.value : configValue;
        value = isDefined(value) && $$.axis.isTimeSeries() ? parseDate(value) : value;
        if (isObject(configValue) && configValue.fit && (type === "min" && value < dataValue || type === "max" && value > dataValue)) value = undefined;
        return isDefined(value) ? value : dataValue;
    },
    getXDomainMin: function(targets) {
        return this.getXDomainMinMax(targets, "min");
    },
    getXDomainMax: function(targets) {
        return this.getXDomainMinMax(targets, "max");
    },
    getXDomainPadding: function(domain) {
        var $$ = this;
        var axis = $$.axis, config = $$.config;
        var diff = domain[1] - domain[0];
        var xPadding = config.axis_x_padding;
        var maxDataCount;
        var padding;
        if (axis.isCategorized()) padding = 0;
        else if ($$.hasType("bar")) {
            maxDataCount = $$.getMaxDataCount();
            padding = maxDataCount > 1 ? diff / (maxDataCount - 1) / 2 : 0.5;
        } else padding = diff * 0.01;
        var left = padding;
        var right = padding;
        if (isObject(xPadding) && notEmpty(xPadding)) {
            left = isValue(xPadding.left) ? xPadding.left : padding;
            right = isValue(xPadding.right) ? xPadding.right : padding;
        } else if (isNumber(config.axis_x_padding)) {
            left = xPadding;
            right = xPadding;
        }
        return {
            left: left,
            right: right
        };
    },
    getXDomain: function(targets) {
        var $$ = this;
        var isLog = $$.scale.x.type === "log";
        var xDomain = [
            $$.getXDomainMin(targets),
            $$.getXDomainMax(targets)
        ];
        var min = 0;
        var max = 0;
        if (isLog) {
            min = xDomain[0];
            max = xDomain[1];
        } else {
            var isCategorized = $$.axis.isCategorized();
            var isTimeSeries = $$.axis.isTimeSeries();
            var padding = $$.getXDomainPadding(xDomain);
            var firstX = xDomain[0], lastX = xDomain[1];
            // show center of x domain if min and max are the same
            if (firstX - lastX === 0 && !isCategorized) {
                if (isTimeSeries) {
                    firstX = new Date(firstX.getTime() * 0.5);
                    lastX = new Date(lastX.getTime() * 1.5);
                } else {
                    firstX = firstX === 0 ? 1 : firstX * 0.5;
                    lastX = lastX === 0 ? -1 : lastX * 1.5;
                }
            }
            if (firstX || firstX === 0) min = isTimeSeries ? new Date(firstX.getTime() - padding.left) : firstX - padding.left;
            if (lastX || lastX === 0) max = isTimeSeries ? new Date(lastX.getTime() + padding.right) : lastX + padding.right;
        }
        return [
            min,
            max
        ];
    },
    updateXDomain: function(targets, withUpdateXDomain, withUpdateOrgXDomain, withTrim, domain) {
        var $$ = this;
        var config = $$.config, org = $$.org, _a = $$.scale, x = _a.x, subX = _a.subX;
        var zoomEnabled = config.zoom_enabled;
        if (withUpdateOrgXDomain) {
            x.domain(domain || sortValue($$.getXDomain(targets)));
            org.xDomain = x.domain();
            zoomEnabled && $$.zoom.updateScaleExtent();
            subX.domain(x.domain());
            $$.brush && $$.brush.scale(subX);
        }
        if (withUpdateXDomain) {
            var domainValue = domain || !$$.brush || brushEmpty($$) ? org.xDomain : getBrushSelection($$).map(subX.invert);
            x.domain(domainValue);
            zoomEnabled && $$.zoom.updateScaleExtent();
        }
        // Trim domain when too big by zoom mousemove event
        withTrim && x.domain($$.trimXDomain(x.orgDomain()));
        return x.domain();
    },
    trimXDomain: function(domain) {
        var zoomDomain = this.getZoomDomain();
        var min = zoomDomain[0], max = zoomDomain[1];
        if (domain[0] <= min) {
            domain[1] = +domain[1] + (min - domain[0]);
            domain[0] = min;
        }
        if (max <= domain[1]) {
            domain[0] = +domain[0] - (domain[1] - max);
            domain[1] = max;
        }
        return domain;
    },
    /**
     * Get zoom domain
     * @returns {Array} zoom domain
     * @private
     */ getZoomDomain: function() {
        var $$ = this;
        var config = $$.config, org = $$.org;
        var _a = org.xDomain, min = _a[0], max = _a[1];
        if (isDefined(config.zoom_x_min)) min = getMinMax$1("min", [
            min,
            config.zoom_x_min
        ]);
        if (isDefined(config.zoom_x_max)) max = getMinMax$1("max", [
            max,
            config.zoom_x_max
        ]);
        return [
            min,
            max
        ];
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * Get formatted
 * @param {object} $$ Context
 * @param {string} typeValue Axis type
 * @param {number} v Value to be formatted
 * @returns {number | string}
 * @private
 */ function getFormat($$, typeValue, v) {
    var config = $$.config;
    var type = "axis_".concat(typeValue, "_tick_format");
    var format = config[type] ? config[type] : $$.defaultValueFormat;
    return format(v);
}
var format = {
    getYFormat: function(forArc) {
        var $$ = this;
        var yFormat = $$.yFormat, y2Format = $$.y2Format;
        if (forArc && !$$.hasType("gauge")) {
            yFormat = $$.defaultArcValueFormat;
            y2Format = $$.defaultArcValueFormat;
        }
        return function(v, ratio, id) {
            var format = $$.axis && $$.axis.getId(id) === "y2" ? y2Format : yFormat;
            return format.call($$, v, ratio);
        };
    },
    yFormat: function(v) {
        return getFormat(this, "y", v);
    },
    y2Format: function(v) {
        return getFormat(this, "y2", v);
    },
    defaultValueFormat: function(v) {
        return isValue(v) ? +v : "";
    },
    defaultArcValueFormat: function(v, ratio) {
        return "".concat((ratio * 100).toFixed(1), "%");
    },
    dataLabelFormat: function(targetId) {
        var $$ = this;
        var dataLabels = $$.config.data_labels;
        var defaultFormat = function(v) {
            return isValue(v) ? +v : "";
        };
        var format = defaultFormat;
        // find format according to axis id
        if (isFunction(dataLabels.format)) format = dataLabels.format;
        else if (isObjectType(dataLabels.format)) {
            if (dataLabels.format[targetId]) format = dataLabels.format[targetId] === true ? defaultFormat : dataLabels.format[targetId];
            else format = function() {
                return "";
            };
        }
        return format.bind($$.api);
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var legend$1 = {
    /**
     * Initialize the legend.
     * @private
     */ initLegend: function() {
        var $$ = this;
        var config = $$.config, $el = $$.$el;
        $$.legendItemTextBox = {};
        $$.state.legendHasRendered = false;
        if (config.legend_show) {
            if (!config.legend_contents_bindto) $el.legend = $$.$el.svg.append("g").classed(CLASS.legend, true).attr("transform", $$.getTranslate("legend"));
            // MEMO: call here to update legend box and translate for all
            // MEMO: translate will be updated by this, so transform not needed in updateLegend()
            $$.updateLegend();
        } else $$.state.hiddenLegendIds = $$.mapToIds($$.data.targets);
    },
    /**
     * Update legend element
     * @param {Array} targetIds ID's of target
     * @param {object} options withTransform : Whether to use the transform property / withTransitionForTransform: Whether transition is used when using the transform property / withTransition : whether or not to transition.
     * @param {object} transitions Return value of the generateTransitions
     * @private
     */ updateLegend: function(targetIds, options, transitions) {
        var $$ = this;
        var config = $$.config, state = $$.state, scale = $$.scale, $el = $$.$el;
        var optionz = options || {
            withTransform: false,
            withTransitionForTransform: false,
            withTransition: false
        };
        optionz.withTransition = getOption(optionz, "withTransition", true);
        optionz.withTransitionForTransform = getOption(optionz, "withTransitionForTransform", true);
        if (config.legend_contents_bindto && config.legend_contents_template) $$.updateLegendTemplate();
        else $$.updateLegendElement(targetIds || $$.mapToIds($$.data.targets), optionz, transitions);
        // toggle legend state
        $el.legend.selectAll(".".concat(CLASS.legendItem)).classed(CLASS.legendItemHidden, function(id) {
            var hide = !$$.isTargetToShow(id);
            if (hide) this.style.opacity = null;
            return hide;
        });
        // Update size and scale
        $$.updateScales(false, !scale.zoom);
        $$.updateSvgSize();
        // Update g positions
        $$.transformAll(optionz.withTransitionForTransform, transitions);
        state.legendHasRendered = true;
    },
    /**
     * Update legend using template option
     * @private
     */ updateLegendTemplate: function() {
        var $$ = this;
        var config = $$.config, $el = $$.$el;
        var wrapper = (0, $hOxpW.default)(config.legend_contents_bindto);
        var template = config.legend_contents_template;
        if (!wrapper.empty()) {
            var targets = $$.mapToIds($$.data.targets);
            var ids_1 = [];
            var html_1 = "";
            targets.forEach(function(v) {
                var content = isFunction(template) ? template.bind($$.api)(v, $$.color(v), $$.api.data(v)[0].values) : tplProcess(template, {
                    COLOR: $$.color(v),
                    TITLE: v
                });
                if (content) {
                    ids_1.push(v);
                    html_1 += content;
                }
            });
            var legendItem = wrapper.html(html_1).selectAll(function() {
                return this.childNodes;
            }).data(ids_1);
            $$.setLegendItem(legendItem);
            $el.legend = wrapper;
        }
    },
    /**
     * Update the size of the legend.
     * @param {Obejct} size Size object
     * @private
     */ updateSizeForLegend: function(size) {
        var $$ = this;
        var config = $$.config, _a = $$.state, isLegendTop = _a.isLegendTop, isLegendLeft = _a.isLegendLeft, isLegendRight = _a.isLegendRight, isLegendInset = _a.isLegendInset, current = _a.current;
        var width = size.width, height = size.height;
        var insetLegendPosition = {
            top: isLegendTop ? $$.getCurrentPaddingTop() + config.legend_inset_y + 5.5 : current.height - height - $$.getCurrentPaddingBottom() - config.legend_inset_y,
            left: isLegendLeft ? $$.getCurrentPaddingLeft() + config.legend_inset_x + 0.5 : current.width - width - $$.getCurrentPaddingRight() - config.legend_inset_x + 0.5
        };
        $$.state.margin3 = {
            top: isLegendRight ? 0 : isLegendInset ? insetLegendPosition.top : current.height - height,
            right: NaN,
            bottom: 0,
            left: isLegendRight ? current.width - width : isLegendInset ? insetLegendPosition.left : 0
        };
    },
    /**
     * Transform Legend
     * @param {boolean} withTransition whether or not to transition.
     * @private
     */ transformLegend: function(withTransition) {
        var $$ = this;
        var legend = $$.$el.legend;
        (withTransition ? legend.transition() : legend).attr("transform", $$.getTranslate("legend"));
    },
    /**
     * Update the legend step
     * @param {number} step Step value
     * @private
     */ updateLegendStep: function(step) {
        this.state.legendStep = step;
    },
    /**
     * Update legend item width
     * @param {number} width Width value
     * @private
     */ updateLegendItemWidth: function(width) {
        this.state.legendItemWidth = width;
    },
    /**
     * Update legend item height
     * @param {number} height Height value
     * @private
     */ updateLegendItemHeight: function(height) {
        this.state.legendItemHeight = height;
    },
    /**
     * Update legend item color
     * @param {string} id Corresponding data ID value
     * @param {string} color Color value
     * @private
     */ updateLegendItemColor: function(id, color) {
        var legend = this.$el.legend;
        if (legend) legend.select(".".concat(CLASS.legendItem, "-").concat(id, " line")).style("stroke", color);
    },
    /**
     * Get the width of the legend
     * @returns {number} width
     * @private
     */ getLegendWidth: function() {
        var $$ = this;
        var _a = $$.state, width = _a.current.width, isLegendRight = _a.isLegendRight, isLegendInset = _a.isLegendInset, legendItemWidth = _a.legendItemWidth, legendStep = _a.legendStep;
        return $$.config.legend_show ? isLegendRight || isLegendInset ? legendItemWidth * (legendStep + 1) : width : 0;
    },
    /**
     * Get the height of the legend
     * @returns {number} height
     * @private
     */ getLegendHeight: function() {
        var $$ = this;
        var _a = $$.state, current = _a.current, isLegendRight = _a.isLegendRight, legendItemHeight = _a.legendItemHeight, legendStep = _a.legendStep;
        return $$.config.legend_show ? isLegendRight ? current.height : Math.max(20, legendItemHeight) * (legendStep + 1) : 0;
    },
    /**
     * Get the opacity of the legend
     * @param {d3.selection} legendItem Legend item node
     * @returns {string|null} opacity
     * @private
     */ opacityForLegend: function(legendItem) {
        return legendItem.classed(CLASS.legendItemHidden) ? null : "1";
    },
    /**
     * Get the opacity of the legend that is unfocused
     * @param {d3.selection} legendItem Legend item node
     * @returns {string|null} opacity
     * @private
     */ opacityForUnfocusedLegend: function(legendItem) {
        return legendItem.classed(CLASS.legendItemHidden) ? null : "0.3";
    },
    /**
     * Toggles the focus of the legend
     * @param {Array} targetIds ID's of target
     * @param {boolean} focus whether or not to focus.
     * @private
     */ toggleFocusLegend: function(targetIds, focus) {
        var $$ = this;
        var legend = $$.$el.legend;
        var targetIdz = $$.mapToTargetIds(targetIds);
        legend && legend.selectAll(".".concat(CLASS.legendItem)).filter(function(id) {
            return targetIdz.indexOf(id) >= 0;
        }).classed(CLASS.legendItemFocused, focus).transition().duration(100).style("opacity", function() {
            return (focus ? $$.opacityForLegend : $$.opacityForUnfocusedLegend).call($$, (0, $hOxpW.default)(this));
        });
    },
    /**
     * Revert the legend to its default state
     * @private
     */ revertLegend: function() {
        var $$ = this;
        var legend = $$.$el.legend;
        legend && legend.selectAll(".".concat(CLASS.legendItem)).classed(CLASS.legendItemFocused, false).transition().duration(100).style("opacity", function() {
            return $$.opacityForLegend((0, $hOxpW.default)(this));
        });
    },
    /**
     * Shows the legend
     * @param {Array} targetIds ID's of target
     * @private
     */ showLegend: function(targetIds) {
        var $$ = this;
        var config = $$.config, $el = $$.$el;
        if (!config.legend_show) {
            config.legend_show = true;
            $el.legend ? $el.legend.style("visibility", "visible") : $$.initLegend();
            !$$.state.legendHasRendered && $$.updateLegend();
        }
        $$.removeHiddenLegendIds(targetIds);
        $el.legend.selectAll($$.selectorLegends(targetIds)).style("visibility", "visible").transition().style("opacity", function() {
            return $$.opacityForLegend((0, $hOxpW.default)(this));
        });
    },
    /**
     * Hide the legend
     * @param {Array} targetIds ID's of target
     * @private
     */ hideLegend: function(targetIds) {
        var $$ = this;
        var config = $$.config, legend = $$.$el.legend;
        if (config.legend_show && isEmpty(targetIds)) {
            config.legend_show = false;
            legend.style("visibility", "hidden");
        }
        $$.addHiddenLegendIds(targetIds);
        legend.selectAll($$.selectorLegends(targetIds)).style("opacity", "0").style("visibility", "hidden");
    },
    /**
     * Get legend item textbox dimension
     * @param {string} id Data ID
     * @param {HTMLElement|d3.selection} textElement Text node element
     * @returns {object} Bounding rect
     * @private
     */ getLegendItemTextBox: function(id, textElement) {
        var $$ = this;
        var cache = $$.cache, state = $$.state;
        var data;
        // do not prefix w/'$', to not be resetted cache in .load() call
        var cacheKey = KEY.legendItemTextBox;
        if (id) {
            data = !state.redrawing && cache.get(cacheKey) || {};
            if (!data[id]) {
                data[id] = $$.getTextRect(textElement, CLASS.legendItem);
                cache.add(cacheKey, data);
            }
            data = data[id];
        }
        return data;
    },
    /**
     * Set legend item style & bind events
     * @param {d3.selection} item Item node
     * @private
     */ setLegendItem: function(item) {
        var $$ = this;
        var api = $$.api, config = $$.config, state = $$.state;
        var isTouch = state.inputType === "touch";
        var hasGauge = $$.hasType("gauge");
        item.attr("class", function(id) {
            var node = (0, $hOxpW.default)(this);
            var itemClass = !node.empty() && node.attr("class") || "";
            return itemClass + $$.generateClass(CLASS.legendItem, id);
        }).style("visibility", function(id) {
            return $$.isLegendToShow(id) ? "visible" : "hidden";
        });
        if (config.interaction_enabled) {
            item.style("cursor", "pointer").on("click", function(id) {
                if (!callFn(config.legend_item_onclick, api, id)) {
                    if ((0, $iZ2is.event).altKey) {
                        api.hide();
                        api.show(id);
                    } else {
                        api.toggle(id);
                        (0, $hOxpW.default)(this).classed(CLASS.legendItemFocused, false).style("opacity", null);
                    }
                }
                isTouch && $$.hideTooltip();
            });
            !isTouch && item.on("mouseout", function(id) {
                if (!callFn(config.legend_item_onout, api, id)) {
                    (0, $hOxpW.default)(this).classed(CLASS.legendItemFocused, false);
                    if (hasGauge) $$.undoMarkOverlapped($$, ".".concat(CLASS.gaugeValue));
                    $$.api.revert();
                }
            }).on("mouseover", function(id) {
                if (!callFn(config.legend_item_onover, api, id)) {
                    (0, $hOxpW.default)(this).classed(CLASS.legendItemFocused, true);
                    if (hasGauge) $$.markOverlapped(id, $$, ".".concat(CLASS.gaugeValue));
                    if (!state.transiting && $$.isTargetToShow(id)) api.focus(id);
                }
            });
        }
    },
    /**
     * Update the legend
     * @param {Array} targetIds ID's of target
     * @param {object} options withTransform : Whether to use the transform property / withTransitionForTransform: Whether transition is used when using the transform property / withTransition : whether or not to transition.
     * @private
     */ updateLegendElement: function(targetIds, options) {
        var $$ = this;
        var config = $$.config, state = $$.state, legend = $$.$el.legend;
        var paddingTop = 4;
        var paddingRight = 10;
        var posMin = 10;
        var tileWidth = config.legend_item_tile_width + 5;
        var maxWidth = 0;
        var maxHeight = 0;
        var xForLegend;
        var yForLegend;
        var totalLength = 0;
        var offsets = {};
        var widths = {};
        var heights = {};
        var margins = [
            0
        ];
        var steps = {};
        var step = 0;
        var background;
        var isLegendRightOrInset = state.isLegendRight || state.isLegendInset;
        // Skip elements when their name is set to null
        var targetIdz = targetIds.filter(function(id) {
            return !isDefined(config.data_names[id]) || config.data_names[id] !== null;
        });
        var withTransition = options.withTransition;
        var updatePositions = function(textElement, id, index) {
            var reset = index === 0;
            var isLast = index === targetIdz.length - 1;
            var box = $$.getLegendItemTextBox(id, textElement);
            var itemWidth = box.width + tileWidth + (isLast && !isLegendRightOrInset ? 0 : paddingRight) + config.legend_padding;
            var itemHeight = box.height + paddingTop;
            var itemLength = isLegendRightOrInset ? itemHeight : itemWidth;
            var areaLength = isLegendRightOrInset ? $$.getLegendHeight() : $$.getLegendWidth();
            var margin;
            // MEMO: care about condifion of step, totalLength
            var updateValues = function(id2, withoutStep) {
                if (!withoutStep) {
                    margin = (areaLength - totalLength - itemLength) / 2;
                    if (margin < posMin) {
                        margin = (areaLength - itemLength) / 2;
                        totalLength = 0;
                        step++;
                    }
                }
                steps[id2] = step;
                margins[step] = state.isLegendInset ? 10 : margin;
                offsets[id2] = totalLength;
                totalLength += itemLength;
            };
            if (reset) {
                totalLength = 0;
                step = 0;
                maxWidth = 0;
                maxHeight = 0;
            }
            if (config.legend_show && !$$.isLegendToShow(id)) {
                widths[id] = 0;
                heights[id] = 0;
                steps[id] = 0;
                offsets[id] = 0;
                return;
            }
            widths[id] = itemWidth;
            heights[id] = itemHeight;
            if (!maxWidth || itemWidth >= maxWidth) maxWidth = itemWidth;
            if (!maxHeight || itemHeight >= maxHeight) maxHeight = itemHeight;
            var maxLength = isLegendRightOrInset ? maxHeight : maxWidth;
            if (config.legend_equally) {
                Object.keys(widths).forEach(function(id2) {
                    return widths[id2] = maxWidth;
                });
                Object.keys(heights).forEach(function(id2) {
                    return heights[id2] = maxHeight;
                });
                margin = (areaLength - maxLength * targetIdz.length) / 2;
                if (margin < posMin) {
                    totalLength = 0;
                    step = 0;
                    targetIdz.forEach(function(id2) {
                        return updateValues(id2);
                    });
                } else updateValues(id, true);
            } else updateValues(id);
        };
        if (state.isLegendInset) {
            step = config.legend_inset_step ? config.legend_inset_step : targetIdz.length;
            $$.updateLegendStep(step);
        }
        if (state.isLegendRight) {
            xForLegend = function(id) {
                return maxWidth * steps[id];
            };
            yForLegend = function(id) {
                return margins[steps[id]] + offsets[id];
            };
        } else if (state.isLegendInset) {
            xForLegend = function(id) {
                return maxWidth * steps[id] + 10;
            };
            yForLegend = function(id) {
                return margins[steps[id]] + offsets[id];
            };
        } else {
            xForLegend = function(id) {
                return margins[steps[id]] + offsets[id];
            };
            yForLegend = function(id) {
                return maxHeight * steps[id];
            };
        }
        var xForLegendText = function(id, i) {
            return xForLegend(id, i) + 4 + config.legend_item_tile_width;
        };
        var xForLegendRect = function(id, i) {
            return xForLegend(id, i);
        };
        var x1ForLegendTile = function(id, i) {
            return xForLegend(id, i) - 2;
        };
        var x2ForLegendTile = function(id, i) {
            return xForLegend(id, i) - 2 + config.legend_item_tile_width;
        };
        var yForLegendText = function(id, i) {
            return yForLegend(id, i) + 9;
        };
        var yForLegendRect = function(id, i) {
            return yForLegend(id, i) - 5;
        };
        var yForLegendTile = function(id, i) {
            return yForLegend(id, i) + 4;
        };
        var pos = -200;
        // Define g for legend area
        var l = legend.selectAll(".".concat(CLASS.legendItem)).data(targetIdz).enter().append("g");
        $$.setLegendItem(l);
        l.append("text").text(function(id) {
            return isDefined(config.data_names[id]) ? config.data_names[id] : id;
        }).each(function(id, i) {
            updatePositions(this, id, i);
        }).style("pointer-events", "none").attr("x", isLegendRightOrInset ? xForLegendText : pos).attr("y", isLegendRightOrInset ? pos : yForLegendText);
        l.append("rect").attr("class", CLASS.legendItemEvent).style("fill-opacity", "0").attr("x", isLegendRightOrInset ? xForLegendRect : pos).attr("y", isLegendRightOrInset ? pos : yForLegendRect);
        var getColor = function(id) {
            var data = $$.getDataById(id);
            return $$.levelColor ? $$.levelColor(data.values[0].value) : $$.color(data);
        };
        var usePoint = config.legend_usePoint;
        if (usePoint) {
            var ids_2 = [];
            l.append(function(d) {
                var pattern = notEmpty(config.point_pattern) ? config.point_pattern : [
                    config.point_type
                ];
                ids_2.indexOf(d) === -1 && ids_2.push(d);
                var point = pattern[ids_2.indexOf(d) % pattern.length];
                if (point === "rectangle") point = "rect";
                return doc.createElementNS((0, $7cQXC.default).svg, "hasValidPointType" in $$ && $$.hasValidPointType(point) ? point : "use");
            }).attr("class", CLASS.legendItemPoint).style("fill", getColor).style("pointer-events", "none").attr("href", function(data, idx, selection) {
                var node = selection[idx];
                var nodeName = node.nodeName.toLowerCase();
                return nodeName === "use" ? "#".concat(state.datetimeId, "-point-").concat(data) : undefined;
            });
        } else l.append("line").attr("class", CLASS.legendItemTile).style("stroke", getColor).style("pointer-events", "none").attr("x1", isLegendRightOrInset ? x1ForLegendTile : pos).attr("y1", isLegendRightOrInset ? pos : yForLegendTile).attr("x2", isLegendRightOrInset ? x2ForLegendTile : pos).attr("y2", isLegendRightOrInset ? pos : yForLegendTile).attr("stroke-width", config.legend_item_tile_height);
        // Set background for inset legend
        background = legend.select(".".concat(CLASS.legendBackground, " rect"));
        if (state.isLegendInset && maxWidth > 0 && background.size() === 0) background = legend.insert("g", ".".concat(CLASS.legendItem)).attr("class", CLASS.legendBackground).append("rect");
        var texts = legend.selectAll("text").data(targetIdz).text(function(id) {
            return isDefined(config.data_names[id]) ? config.data_names[id] : id;
        }) // MEMO: needed for update
        .each(function(id, i) {
            updatePositions(this, id, i);
        });
        (withTransition ? texts.transition() : texts).attr("x", xForLegendText).attr("y", yForLegendText);
        var rects = legend.selectAll("rect.".concat(CLASS.legendItemEvent)).data(targetIdz);
        (withTransition ? rects.transition() : rects).attr("width", function(id) {
            return widths[id];
        }).attr("height", function(id) {
            return heights[id];
        }).attr("x", xForLegendRect).attr("y", yForLegendRect);
        if (usePoint) {
            var tiles = legend.selectAll(".".concat(CLASS.legendItemPoint)).data(targetIdz);
            (withTransition ? tiles.transition() : tiles).each(function() {
                var nodeName = this.nodeName.toLowerCase();
                var pointR = config.point_r;
                var x = "x";
                var y = "y";
                var xOffset = 2;
                var yOffset = 2.5;
                var radius;
                var width;
                var height;
                if (nodeName === "circle") {
                    var size = pointR * 0.2;
                    x = "cx";
                    y = "cy";
                    radius = pointR + size;
                    xOffset = pointR * 2;
                    yOffset = -size;
                } else if (nodeName === "rect") {
                    var size = pointR * 2.5;
                    width = size;
                    height = size;
                    yOffset = 3;
                }
                (0, $hOxpW.default)(this).attr(x, function(d) {
                    return x1ForLegendTile(d) + xOffset;
                }).attr(y, function(d) {
                    return yForLegendTile(d) - yOffset;
                }).attr("r", radius).attr("width", width).attr("height", height);
            });
        } else {
            var tiles = legend.selectAll("line.".concat(CLASS.legendItemTile)).data(targetIdz);
            (withTransition ? tiles.transition() : tiles).style("stroke", getColor).attr("x1", x1ForLegendTile).attr("y1", yForLegendTile).attr("x2", x2ForLegendTile).attr("y2", yForLegendTile);
        }
        if (background) (withTransition ? background.transition() : background).attr("height", $$.getLegendHeight() - 12).attr("width", maxWidth * (step + 1) + 10);
        // Update all to reflect change of legend
        $$.updateLegendItemWidth(maxWidth);
        $$.updateLegendItemHeight(maxHeight);
        $$.updateLegendStep(step);
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var redraw = {
    redraw: function(options) {
        if (options === void 0) options = {};
        var $$ = this;
        var config = $$.config, state = $$.state, $el = $$.$el;
        var main = $el.main;
        state.redrawing = true;
        var targetsToShow = $$.filterTargetsToShow($$.data.targets);
        var initializing = options.initializing;
        var flow = options.flow;
        var wth = $$.getWithOption(options);
        var duration = wth.Transition ? config.transition_duration : 0;
        var durationForExit = wth.TransitionForExit ? duration : 0;
        var durationForAxis = wth.TransitionForAxis ? duration : 0;
        var transitions = $$.axis && $$.axis.generateTransitions(durationForAxis);
        $$.updateSizes(initializing);
        // update legend and transform each g
        if (wth.Legend && config.legend_show) {
            options.withTransition = !!duration;
            $$.updateLegend($$.mapToIds($$.data.targets), options, transitions);
        } else if (wth.Dimension) // need to update dimension (e.g. axis.y.tick.values) because y tick values should change
        // no need to update axis in it because they will be updated in redraw()
        $$.updateDimension(true);
        // update circleY based on updated parameters
        if (!$$.hasArcType() || state.hasRadar) $$.updateCircleY && $$.updateCircleY();
        // Data empty label positioning and text.
        config.data_empty_label_text && main.select("text.".concat(CLASS.text, ".").concat(CLASS.empty)).attr("x", state.width / 2).attr("y", state.height / 2).text(config.data_empty_label_text).style("display", targetsToShow.length ? "none" : null);
        // update axis
        if (state.hasAxis) {
            // @TODO: Make 'init' state to be accessible everywhere not passing as argument.
            $$.axis.redrawAxis(targetsToShow, wth, transitions, flow, initializing);
            // grid
            $$.hasGrid() && $$.updateGrid(duration);
            // rect for regions
            config.regions.length && $$.updateRegion(duration);
            // bars
            $$.hasType("bar") && $$.updateBar(durationForExit);
            // lines, areas and circles
            if ($$.hasTypeOf("Line")) $$.updateLine(durationForExit);
            if ($$.hasTypeOf("Area")) $$.updateArea(durationForExit);
            // circles for select
            $el.text && main.selectAll(".".concat(CLASS.selectedCircles)).filter($$.isBarType.bind($$)).selectAll("circle").remove();
            // event rects will redrawn when flow called
            if (config.interaction_enabled && !flow && wth.EventRect) {
                $$.redrawEventRect();
                $$.bindZoomEvent && $$.bindZoomEvent();
            }
        } else {
            // arc
            $el.arcs && $$.redrawArc(duration, durationForExit, wth.Transform);
            // radar
            $el.radar && $$.redrawRadar(durationForExit);
        }
        // @TODO: Axis & Radar type
        if (!state.resizing && ($$.hasPointType() || state.hasRadar)) $$.updateCircle();
        // text
        $$.hasDataLabel() && !$$.hasArcType(null, [
            "radar"
        ]) && $$.updateText(durationForExit);
        // title
        $$.redrawTitle && $$.redrawTitle();
        initializing && $$.updateTypesElements();
        $$.generateRedrawList(targetsToShow, flow, duration, wth.Subchart);
        $$.callPluginHook("$redraw", options, duration);
    },
    /**
     * Generate redraw list
     * @param {object} targets targets data to be shown
     * @param {object} flow flow object
     * @param {number} duration duration value
     * @param {boolean} withSubchart whether or not to show subchart
     * @private
     */ generateRedrawList: function(targets, flow, duration, withSubchart) {
        var $$ = this;
        var config = $$.config, state = $$.state;
        var shape = $$.getDrawShape();
        if (state.hasAxis) // subchart
        config.subchart_show && $$.redrawSubchart(withSubchart, duration, shape);
        // generate flow
        var flowFn = flow && $$.generateFlow({
            targets: targets,
            flow: flow,
            duration: flow.duration,
            shape: shape,
            xv: $$.xv.bind($$)
        });
        var isTransition = (duration || flowFn) && isTabVisible();
        // redraw list
        var redrawList = $$.getRedrawList(shape, flow, flowFn, isTransition);
        // callback function after redraw ends
        var afterRedraw = flow || config.onrendered ? function() {
            flowFn && flowFn();
            state.redrawing = false;
            callFn(config.onrendered, $$.api);
        } : null;
        if (afterRedraw) {
            // Only use transition when current tab is visible.
            if (isTransition && redrawList.length) {
                // Wait for end of transitions for callback
                var waitForDraw_1 = generateWait();
                // transition should be derived from one transition
                (0, $e9pyf.default)().duration(duration).each(function() {
                    redrawList.reduce(function(acc, t1) {
                        return acc.concat(t1);
                    }, []).forEach(function(t) {
                        return waitForDraw_1.add(t);
                    });
                }).call(waitForDraw_1, afterRedraw);
            } else if (!state.transiting) afterRedraw();
        }
        // update fadein condition
        $$.mapToIds($$.data.targets).forEach(function(id) {
            state.withoutFadeIn[id] = true;
        });
    },
    getRedrawList: function(shape, flow, flowFn, isTransition) {
        var $$ = this;
        var config = $$.config, _a = $$.state, hasAxis = _a.hasAxis, hasRadar = _a.hasRadar, grid = $$.$el.grid;
        var _b = shape.pos, cx = _b.cx, cy = _b.cy, xForText = _b.xForText, yForText = _b.yForText;
        var list = [];
        if (hasAxis) {
            var _c = shape.type, area = _c.area, bar = _c.bar, line = _c.line;
            if (config.grid_x_lines.length || config.grid_y_lines.length) list.push($$.redrawGrid(isTransition));
            if (config.regions.length) list.push($$.redrawRegion(isTransition));
            $$.hasTypeOf("Line") && list.push($$.redrawLine(line, isTransition));
            $$.hasTypeOf("Area") && list.push($$.redrawArea(area, isTransition));
            $$.hasType("bar") && list.push($$.redrawBar(bar, isTransition));
            !flow && grid.main && list.push($$.updateGridFocus());
        }
        if (!$$.hasArcType() || hasRadar) notEmpty(config.data_labels) && config.data_labels !== false && list.push($$.redrawText(xForText, yForText, flow, isTransition));
        if (($$.hasPointType() || hasRadar) && !config.point_focus_only) $$.redrawCircle && list.push($$.redrawCircle(cx, cy, isTransition, flowFn));
        return list;
    },
    updateAndRedraw: function(options) {
        if (options === void 0) options = {};
        var $$ = this;
        var config = $$.config, state = $$.state;
        var transitions;
        // same with redraw
        options.withTransition = getOption(options, "withTransition", true);
        options.withTransform = getOption(options, "withTransform", false);
        options.withLegend = getOption(options, "withLegend", false);
        // NOT same with redraw
        options.withUpdateXDomain = true;
        options.withUpdateOrgXDomain = true;
        options.withTransitionForExit = false;
        options.withTransitionForTransform = getOption(options, "withTransitionForTransform", options.withTransition);
        // MEMO: called in updateLegend in redraw if withLegend
        if (!(options.withLegend && config.legend_show)) {
            if (state.hasAxis) transitions = $$.axis.generateTransitions(options.withTransitionForAxis ? config.transition_duration : 0);
            // Update scales
            $$.updateScales();
            $$.updateSvgSize();
            // Update g positions
            $$.transformAll(options.withTransitionForTransform, transitions);
        }
        // Draw with new sizes & scales
        $$.redraw(options, transitions);
    },
    redrawWithoutRescale: function() {
        this.redraw({
            withY: false,
            withSubchart: false,
            withEventRect: false,
            withTransitionForAxis: false
        });
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * Get scale
 * @param {string} [type='linear'] Scale type
 * @param {number} [min] Min range
 * @param {number} [max] Max range
 * @returns {d3.scaleLinear|d3.scaleTime} scale
 * @private
 */ function getScale(type, min, max) {
    if (type === void 0) type = "linear";
    if (min === void 0) min = 0;
    if (max === void 0) max = 1;
    var scale = ({
        linear: (0, $iOlPi.default),
        log: (0, $ht0x4.default),
        _log: (0, $7TrsU.default),
        time: (0, $48U7R.default)
    })[type]();
    scale.type = type;
    /_?log/.test(type) && scale.clamp(true);
    return scale.range([
        min,
        max
    ]);
}
var scale = {
    /**
     * Get x Axis scale function
     * @param {number} min Min value
     * @param {number} max Max value
     * @param {Array} domain Domain value
     * @param {Function} offset The offset getter to be sum
     * @returns {Function} scale
     * @private
     */ getXScale: function(min, max, domain, offset) {
        var $$ = this;
        var scale = $$.scale.zoom || getScale($$.axis.getAxisType("x"), min, max);
        return $$.getCustomizedScale(domain ? scale.domain(domain) : scale, offset);
    },
    /**
     * Get y Axis scale function
     * @param {string} id Axis id: 'y' or 'y2'
     * @param {number} min Min value
     * @param {number} max Max value
     * @param {Array} domain Domain value
     * @returns {Function} Scale function
     * @private
     */ getYScale: function(id, min, max, domain) {
        var $$ = this;
        var scale = getScale($$.axis.getAxisType(id), min, max);
        domain && scale.domain(domain);
        return scale;
    },
    /**
     * Get y Axis scale
     * @param {string} id Axis id
     * @param {boolean} isSub Weather is sub Axis
     * @returns {Function} Scale function
     * @private
     */ getYScaleById: function(id, isSub) {
        if (isSub === void 0) isSub = false;
        var isY2 = this.axis.getId(id) === "y2";
        var key = isSub ? isY2 ? "subY2" : "subY" : isY2 ? "y2" : "y";
        return this.scale[key];
    },
    /**
     * Get customized scale
     * @param {d3.scaleLinear|d3.scaleTime} scaleValue Scale function
     * @param {Function} offsetValue Offset getter to be sum
     * @returns {Function} Scale function
     * @private
     */ getCustomizedScale: function(scaleValue, offsetValue) {
        var $$ = this;
        var offset = offsetValue || function() {
            return $$.axis.x.tickOffset();
        };
        var scale = function(d, raw) {
            var v = scaleValue(d) + offset();
            return raw ? v : Math.ceil(v);
        };
        // copy original scale methods
        for(var key in scaleValue)scale[key] = scaleValue[key];
        scale.orgDomain = function() {
            return scaleValue.domain();
        };
        scale.orgScale = function() {
            return scaleValue;
        };
        // define custom domain() for categorized axis
        if ($$.axis.isCategorized()) scale.domain = function(domainValue) {
            var domain = domainValue;
            if (!arguments.length) {
                domain = this.orgDomain();
                return [
                    domain[0],
                    domain[1] + 1
                ];
            }
            scaleValue.domain(domain);
            return scale;
        };
        return scale;
    },
    /**
     * Update scale
     * @param {boolean} isInit Param is given at the init rendering
     * @param {boolean} updateXDomain If update x domain
     * @private
     */ updateScales: function(isInit, updateXDomain) {
        if (updateXDomain === void 0) updateXDomain = true;
        var $$ = this;
        var axis = $$.axis, config = $$.config, format = $$.format, org = $$.org, scale = $$.scale, _a = $$.state, width = _a.width, height = _a.height, width2 = _a.width2, height2 = _a.height2, hasAxis = _a.hasAxis;
        if (hasAxis) {
            var isRotated = config.axis_rotated;
            // update edges
            var min = {
                x: isRotated ? 1 : 0,
                y: isRotated ? 0 : height,
                subX: isRotated ? 1 : 0,
                subY: isRotated ? 0 : height2
            };
            var max = {
                x: isRotated ? height : width,
                y: isRotated ? width : 1,
                subX: isRotated ? height : width,
                subY: isRotated ? width2 : 1
            };
            // update scales
            // x Axis
            var xDomain = updateXDomain && scale.x && scale.x.orgDomain();
            var xSubDomain = updateXDomain && org.xDomain;
            scale.x = $$.getXScale(min.x, max.x, xDomain, function() {
                return axis.x.tickOffset();
            });
            scale.subX = $$.getXScale(min.x, max.x, xSubDomain, function(d) {
                return d % 1 ? 0 : axis.subX.tickOffset();
            });
            format.xAxisTick = axis.getXAxisTickFormat();
            axis.setAxis("x", scale.x, config.axis_x_tick_outer, isInit);
            if (config.subchart_show) axis.setAxis("subX", scale.subX, config.axis_x_tick_outer, isInit);
            // y Axis
            scale.y = $$.getYScale("y", min.y, max.y, scale.y ? scale.y.domain() : config.axis_y_default);
            scale.subY = $$.getYScale("y", min.subY, max.subY, scale.subY ? scale.subY.domain() : config.axis_y_default);
            axis.setAxis("y", scale.y, config.axis_y_tick_outer, isInit);
            // y2 Axis
            if (config.axis_y2_show) {
                scale.y2 = $$.getYScale("y2", min.y, max.y, scale.y2 ? scale.y2.domain() : config.axis_y2_default);
                scale.subY2 = $$.getYScale("y2", min.subY, max.subY, scale.subY2 ? scale.subY2.domain() : config.axis_y2_default);
                axis.setAxis("y2", scale.y2, config.axis_y2_tick_outer, isInit);
            }
        } else // update for arc
        $$.updateArc && $$.updateArc();
    },
    /**
     * Get the zoom or unzoomed scaled value
     * @param {Date|number|object} d Data value
     * @returns {number|null}
     * @private
     */ xx: function(d) {
        var $$ = this;
        var config = $$.config, _a = $$.scale, x = _a.x, zoom = _a.zoom;
        var fn = config.zoom_enabled && zoom ? zoom : x;
        return d ? fn(isValue(d.x) ? d.x : d) : null;
    },
    xv: function(d) {
        var $$ = this;
        var axis = $$.axis, config = $$.config, x = $$.scale.x;
        var value = $$.getBaseValue(d);
        if (axis.isTimeSeries()) value = parseDate.call($$, value);
        else if (axis.isCategorized() && isString(value)) value = config.axis_x_categories.indexOf(value);
        return Math.ceil(x(value));
    },
    yv: function(d) {
        var $$ = this;
        var _a = $$.scale, y = _a.y, y2 = _a.y2;
        var yScale = d.axis && d.axis === "y2" ? y2 : y;
        return Math.ceil(yScale($$.getBaseValue(d)));
    },
    subxx: function(d) {
        return d ? this.scale.subX(d.x) : null;
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var shape = {
    /**
     * Get the shape draw function
     * @returns {object}
     * @private
     */ getDrawShape: function() {
        var $$ = this;
        var isRotated = $$.config.axis_rotated;
        var hasRadar = $$.state.hasRadar;
        var shape = {
            type: {},
            indices: {},
            pos: {}
        };
        // setup drawer - MEMO: these must be called after axis updated
        if ($$.hasTypeOf("Line") || $$.hasType("bubble") || $$.hasType("scatter")) {
            var indices = $$.getShapeIndices($$.isLineType);
            shape.indices.line = indices;
            shape.type.line = $$.generateDrawLine ? $$.generateDrawLine(indices, false) : undefined;
            if ($$.hasTypeOf("Area")) {
                var indices_1 = $$.getShapeIndices($$.isAreaType);
                shape.indices.area = indices_1;
                shape.type.area = $$.generateDrawArea ? $$.generateDrawArea(indices_1, false) : undefined;
            }
        }
        if ($$.hasType("bar")) {
            var indices = $$.getShapeIndices($$.isBarType);
            shape.indices.bar = indices;
            shape.type.bar = $$.generateDrawBar ? $$.generateDrawBar(indices) : undefined;
        }
        if (!$$.hasArcType() || hasRadar) {
            // generate circle x/y functions depending on updated params
            var cx = hasRadar ? $$.radarCircleX : isRotated ? $$.circleY : $$.circleX;
            var cy = hasRadar ? $$.radarCircleY : isRotated ? $$.circleX : $$.circleY;
            shape.pos = {
                xForText: $$.generateXYForText(shape.indices, true),
                yForText: $$.generateXYForText(shape.indices, false),
                cx: (cx || function() {}).bind($$),
                cy: (cy || function() {}).bind($$)
            };
        }
        return shape;
    },
    getShapeIndices: function(typeFilter) {
        var $$ = this;
        var config = $$.config;
        var xs = config.data_xs;
        var hasXs = notEmpty(xs);
        var indices = {};
        var i = hasXs ? {} : 0;
        if (hasXs) getUnique(Object.keys(xs).map(function(v) {
            return xs[v];
        })).forEach(function(v) {
            i[v] = 0;
            indices[v] = {};
        });
        $$.filterTargetsToShow($$.data.targets.filter(typeFilter, $$)).forEach(function(d) {
            var xKey = d.id in xs ? xs[d.id] : "";
            var ind = xKey ? indices[xKey] : indices;
            for(var j = 0, groups = void 0; groups = config.data_groups[j]; j++){
                if (groups.indexOf(d.id) < 0) continue;
                for(var k = 0, row = void 0; row = groups[k]; k++)if (row in ind) {
                    ind[d.id] = ind[row];
                    break;
                }
            }
            if (isUndefined(ind[d.id])) {
                ind[d.id] = xKey ? i[xKey]++ : i++;
                ind.__max__ = (xKey ? i[xKey] : i) - 1;
            }
        });
        return indices;
    },
    /**
     * Get indices value based on data ID value
     * @param {object} indices Indices object
     * @param {string} id Data id value
     * @returns {object} Indices object
     * @private
     */ getIndices: function(indices, id) {
        var xs = this.config.data_xs;
        return notEmpty(xs) ? indices[xs[id]] : indices;
    },
    /**
     * Get indices max number
     * @param {object} indices Indices object
     * @returns {number} Max number
     * @private
     */ getIndicesMax: function(indices) {
        return notEmpty(this.config.data_xs) ? // if is multiple xs, return total sum of xs' __max__ value
        Object.keys(indices).map(function(v) {
            return indices[v].__max__ || 0;
        }).reduce(function(acc, curr) {
            return acc + curr;
        }) : indices.__max__;
    },
    getShapeX: function(offset, indices, isSub) {
        var $$ = this;
        var config = $$.config, scale = $$.scale;
        var currScale = isSub ? scale.subX : scale.zoom || scale.x;
        var barPadding = config.bar_padding;
        var sum = function(p, c) {
            return p + c;
        };
        var halfWidth = isObjectType(offset) && (offset._$total.length ? offset._$total.reduce(sum) / 2 : 0);
        return function(d) {
            var ind = $$.getIndices(indices, d.id);
            var index = d.id in ind ? ind[d.id] : 0;
            var targetsNum = (ind.__max__ || 0) + 1;
            var x = 0;
            if (notEmpty(d.x)) {
                var xPos = currScale(d.x, true);
                if (halfWidth) x = xPos - (offset[d.id] || offset._$width) + offset._$total.slice(0, index + 1).reduce(sum) - halfWidth;
                else x = xPos - (isNumber(offset) ? offset : offset._$width) * (targetsNum / 2 - index);
            }
            // adjust x position for bar.padding optionq
            if (offset && x && targetsNum > 1 && barPadding) {
                if (index) x += barPadding * index;
                if (targetsNum > 2) x -= (targetsNum - 1) * barPadding / 2;
                else if (targetsNum === 2) x -= barPadding / 2;
            }
            return x;
        };
    },
    getShapeY: function(isSub) {
        var $$ = this;
        var isStackNormalized = $$.isStackNormalized();
        return function(d) {
            var value = isStackNormalized ? $$.getRatio("index", d, true) : $$.isBubbleZType(d) ? $$.getBubbleZData(d.value, "y") : d.value;
            return $$.getYScaleById(d.id, isSub)(value);
        };
    },
    /**
     * Get shape based y Axis min value
     * @param {string} id Data id
     * @returns {number}
     * @private
     */ getShapeYMin: function(id) {
        var $$ = this;
        var scale = $$.scale[$$.axis.getId(id)];
        var yMin = scale.domain()[0];
        return !$$.isGrouped(id) && yMin > 0 ? yMin : 0;
    },
    /**
     * Get Shape's offset data
     * @param {Function} typeFilter Type filter function
     * @returns {object}
     * @private
     */ getShapeOffsetData: function(typeFilter) {
        var $$ = this;
        var targets = $$.orderTargets($$.filterTargetsToShow($$.data.targets.filter(typeFilter, $$)));
        var isStackNormalized = $$.isStackNormalized();
        var shapeOffsetTargets = targets.map(function(target) {
            var rowValues = target.values;
            var values = {};
            if ($$.isStepType(target)) rowValues = $$.convertValuesToStep(rowValues);
            var rowValueMapByXValue = rowValues.reduce(function(out, d) {
                var key = Number(d.x);
                out[key] = d;
                values[key] = isStackNormalized ? $$.getRatio("index", d, true) : d.value;
                return out;
            }, {});
            return {
                id: target.id,
                rowValues: rowValues,
                rowValueMapByXValue: rowValueMapByXValue,
                values: values
            };
        });
        var indexMapByTargetId = targets.reduce(function(out, _a, index) {
            var id = _a.id;
            out[id] = index;
            return out;
        }, {});
        return {
            indexMapByTargetId: indexMapByTargetId,
            shapeOffsetTargets: shapeOffsetTargets
        };
    },
    getShapeOffset: function(typeFilter, indices, isSub) {
        var $$ = this;
        var _a = $$.getShapeOffsetData(typeFilter), shapeOffsetTargets = _a.shapeOffsetTargets, indexMapByTargetId = _a.indexMapByTargetId;
        return function(d, idx) {
            var ind = $$.getIndices(indices, d.id);
            var scale = $$.getYScaleById(d.id, isSub);
            var y0 = scale($$.getShapeYMin(d.id));
            var dataXAsNumber = Number(d.x);
            var offset = y0;
            shapeOffsetTargets.filter(function(t) {
                return t.id !== d.id;
            }).forEach(function(t) {
                if (ind[t.id] === ind[d.id] && indexMapByTargetId[t.id] < indexMapByTargetId[d.id]) {
                    var row = t.rowValues[idx];
                    // check if the x values line up
                    if (!row || Number(row.x) !== dataXAsNumber) row = t.rowValueMapByXValue[dataXAsNumber];
                    if (row && row.value * d.value >= 0) offset += scale(t.values[dataXAsNumber]) - y0;
                }
            });
            return offset;
        };
    },
    isWithinShape: function(that, d) {
        var $$ = this;
        var shape = (0, $hOxpW.default)(that);
        var isWithin;
        if (!$$.isTargetToShow(d.id)) isWithin = false;
        else if ("hasValidPointType" in $$ && $$.hasValidPointType(that.nodeName)) isWithin = $$.isStepType(d) ? $$.isWithinStep(that, $$.getYScaleById(d.id)(d.value)) : $$.isWithinCircle(that, $$.isBubbleType(d) ? $$.pointSelectR(d) * 1.5 : 0);
        else if (that.nodeName === "path") isWithin = shape.classed(CLASS.bar) ? $$.isWithinBar(that) : true;
        return isWithin;
    },
    getInterpolate: function(d) {
        var $$ = this;
        var interpolation = $$.getInterpolateType(d);
        return ({
            "basis": (0, $6QL1t.default),
            "basis-closed": (0, $2515N.default),
            "basis-open": (0, $e1bEB.default),
            "bundle": (0, $l8Mye.default),
            "cardinal": (0, $hga9n.default),
            "cardinal-closed": (0, $9XrSP.default),
            "cardinal-open": (0, $dUIyz.default),
            "catmull-rom": (0, $6FEsA.default),
            "catmull-rom-closed": (0, $loyNQ.default),
            "catmull-rom-open": (0, $4tc8L.default),
            "monotone-x": (0, $hp3ls.monotoneX),
            "monotone-y": (0, $hp3ls.monotoneY),
            "natural": (0, $kjPWc.default),
            "linear-closed": (0, $4CT3t.default),
            "linear": (0, $gEcf1.default),
            "step": (0, $1zRZO.default),
            "step-after": (0, $1zRZO.stepAfter),
            "step-before": (0, $1zRZO.stepBefore)
        })[interpolation];
    },
    getInterpolateType: function(d) {
        var $$ = this;
        var config = $$.config;
        var type = config.spline_interpolation_type;
        var interpolation = $$.isInterpolationType(type) ? type : "cardinal";
        return $$.isSplineType(d) ? interpolation : $$.isStepType(d) ? config.line_step_type : "linear";
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var size = {
    /**
     * Update container size
     * @private
     */ setContainerSize: function() {
        var $$ = this;
        var state = $$.state;
        state.current.width = $$.getCurrentWidth();
        state.current.height = $$.getCurrentHeight();
    },
    getCurrentWidth: function() {
        var $$ = this;
        return $$.config.size_width || $$.getParentWidth();
    },
    getCurrentHeight: function() {
        var $$ = this;
        var config = $$.config;
        var h = config.size_height || $$.getParentHeight();
        return h > 0 ? h : 320 / ($$.hasType("gauge") && !config.gauge_fullCircle ? 2 : 1);
    },
    getCurrentPaddingTop: function() {
        var $$ = this;
        var config = $$.config, hasAxis = $$.state.hasAxis, $el = $$.$el;
        var axesLen = hasAxis ? config.axis_y2_axes.length : 0;
        var padding = isValue(config.padding_top) ? config.padding_top : 0;
        if ($el.title && $el.title.node()) padding += $$.getTitlePadding();
        if (axesLen && config.axis_rotated) padding += $$.getHorizontalAxisHeight("y2") * axesLen;
        return padding;
    },
    getCurrentPaddingBottom: function() {
        var $$ = this;
        var config = $$.config, hasAxis = $$.state.hasAxis;
        var axisId = config.axis_rotated ? "y" : "x";
        var axesLen = hasAxis ? config["axis_".concat(axisId, "_axes")].length : 0;
        var padding = isValue(config.padding_bottom) ? config.padding_bottom : 0;
        return padding + (axesLen ? $$.getHorizontalAxisHeight(axisId) * axesLen : 0);
    },
    getCurrentPaddingLeft: function(withoutRecompute) {
        var $$ = this;
        var config = $$.config, hasAxis = $$.state.hasAxis;
        var isRotated = config.axis_rotated;
        var axisId = isRotated ? "x" : "y";
        var axesLen = hasAxis ? config["axis_".concat(axisId, "_axes")].length : 0;
        var axisWidth = hasAxis ? $$.getAxisWidthByAxisId(axisId, withoutRecompute) : 0;
        var padding;
        if (isValue(config.padding_left)) padding = config.padding_left;
        else if (hasAxis && isRotated) padding = !config.axis_x_show ? 1 : Math.max(ceil10(axisWidth), 40);
        else if (hasAxis && (!config.axis_y_show || config.axis_y_inner)) padding = $$.axis.getAxisLabelPosition("y").isOuter ? 30 : 1;
        else padding = ceil10(axisWidth);
        return padding + axisWidth * axesLen;
    },
    getCurrentPaddingRight: function(withXAxisTickTextOverflow) {
        if (withXAxisTickTextOverflow === void 0) withXAxisTickTextOverflow = false;
        var $$ = this;
        var config = $$.config, hasAxis = $$.state.hasAxis;
        var defaultPadding = 10;
        var legendWidthOnRight = $$.state.isLegendRight ? $$.getLegendWidth() + 20 : 0;
        var axesLen = hasAxis ? config.axis_y2_axes.length : 0;
        var axisWidth = hasAxis ? $$.getAxisWidthByAxisId("y2") : 0;
        var xAxisTickTextOverflow = withXAxisTickTextOverflow ? $$.axis.getXAxisTickTextY2Overflow(defaultPadding) : 0;
        var padding;
        if (isValue(config.padding_right)) padding = config.padding_right + 1; // 1 is needed not to hide tick line
        else if ($$.axis && config.axis_rotated) padding = defaultPadding + legendWidthOnRight;
        else if ($$.axis && (!config.axis_y2_show || config.axis_y2_inner)) padding = Math.max(2 + legendWidthOnRight + ($$.axis.getAxisLabelPosition("y2").isOuter ? 20 : 0), xAxisTickTextOverflow);
        else padding = Math.max(ceil10(axisWidth) + legendWidthOnRight, xAxisTickTextOverflow);
        return padding + axisWidth * axesLen;
    },
    /**
     * Get the parent rect element's size
     * @param {string} key property/attribute name
     * @returns {number}
     * @private
     */ getParentRectValue: function(key) {
        var offsetName = "offset".concat(capitalize(key));
        var parent = this.$el.chart.node();
        var v;
        while(!v && parent && parent.tagName !== "BODY"){
            try {
                v = parent.getBoundingClientRect()[key];
            } catch (e) {
                if (offsetName in parent) // In IE in certain cases getBoundingClientRect
                // will cause an "unspecified error"
                v = parent[offsetName];
            }
            parent = parent.parentNode;
        }
        if (key === "width") {
            // Sometimes element's width value is incorrect(ex. flex container)
            // In this case, use body's offsetWidth instead.
            var bodyWidth = doc.body.offsetWidth;
            v > bodyWidth && (v = bodyWidth);
        }
        return v;
    },
    getParentWidth: function() {
        return this.getParentRectValue("width");
    },
    getParentHeight: function() {
        var h = this.$el.chart.style("height");
        return h.indexOf("px") > 0 ? parseInt(h, 10) : 0;
    },
    getSvgLeft: function(withoutRecompute) {
        var $$ = this;
        var config = $$.config, $el = $$.$el;
        var hasLeftAxisRect = config.axis_rotated || !config.axis_rotated && !config.axis_y_inner;
        var leftAxisClass = config.axis_rotated ? CLASS.axisX : CLASS.axisY;
        var leftAxis = $el.main.select(".".concat(leftAxisClass)).node();
        var svgRect = leftAxis && hasLeftAxisRect ? leftAxis.getBoundingClientRect() : {
            right: 0
        };
        var chartRect = $el.chart.node().getBoundingClientRect();
        var hasArc = $$.hasArcType();
        var svgLeft = svgRect.right - chartRect.left - (hasArc ? 0 : $$.getCurrentPaddingLeft(withoutRecompute));
        return svgLeft > 0 ? svgLeft : 0;
    },
    updateDimension: function(withoutAxis) {
        var $$ = this;
        var config = $$.config, hasAxis = $$.state.hasAxis, $el = $$.$el;
        if (hasAxis && !withoutAxis) {
            if ($$.axis.x && config.axis_rotated) {
                $$.axis.x.create($el.axis.x);
                $$.axis.subX && $$.axis.subX.create($el.axis.subX);
            } else {
                $$.axis.y && $$.axis.y.create($el.axis.y);
                $$.axis.y2 && $$.axis.y2.create($el.axis.y2);
            }
        }
        // pass 'withoutAxis' param to not animate at the init rendering
        $$.updateScales(withoutAxis);
        $$.updateSvgSize();
        $$.transformAll(false);
    },
    updateSvgSize: function() {
        var $$ = this;
        var _a = $$.state, clip = _a.clip, current = _a.current, hasAxis = _a.hasAxis, width = _a.width, height = _a.height, svg = $$.$el.svg;
        svg.attr("width", current.width).attr("height", current.height);
        if (hasAxis) {
            var brush = svg.select(".".concat(CLASS.brush, " .overlay"));
            var brushSize = {
                width: 0,
                height: 0
            };
            if (brush.size()) {
                brushSize.width = +brush.attr("width");
                brushSize.height = +brush.attr("height");
            }
            svg.selectAll([
                "#".concat(clip.id),
                "#".concat(clip.idGrid)
            ]).select("rect").attr("width", width).attr("height", height);
            svg.select("#".concat(clip.idXAxis)).select("rect").call($$.setXAxisClipPath.bind($$));
            svg.select("#".concat(clip.idYAxis)).select("rect").call($$.setYAxisClipPath.bind($$));
            clip.idSubchart && svg.select("#".concat(clip.idSubchart)).select("rect").attr("width", width).attr("height", brushSize.height);
        }
    },
    /**
     * Update size values
     * @param {boolean} isInit If is called at initialization
     * @private
     */ updateSizes: function(isInit) {
        var $$ = this;
        var config = $$.config, state = $$.state, legend = $$.$el.legend;
        var isRotated = config.axis_rotated;
        var hasArc = $$.hasArcType();
        !isInit && $$.setContainerSize();
        var currLegend = {
            width: legend ? $$.getLegendWidth() : 0,
            height: legend ? $$.getLegendHeight() : 0
        };
        if (!hasArc && config.axis_x_show && config.axis_x_tick_autorotate) $$.updateXAxisTickClip();
        var legendHeightForBottom = state.isLegendRight || state.isLegendInset ? 0 : currLegend.height;
        var xAxisHeight = isRotated || hasArc ? 0 : $$.getHorizontalAxisHeight("x");
        var subchartXAxisHeight = config.subchart_axis_x_show && config.subchart_axis_x_tick_text_show ? xAxisHeight : 30;
        var subchartHeight = config.subchart_show && !hasArc ? config.subchart_size_height + subchartXAxisHeight : 0;
        // for main
        state.margin = !hasArc && isRotated ? {
            top: $$.getHorizontalAxisHeight("y2") + $$.getCurrentPaddingTop(),
            right: hasArc ? 0 : $$.getCurrentPaddingRight(true),
            bottom: $$.getHorizontalAxisHeight("y") + legendHeightForBottom + $$.getCurrentPaddingBottom(),
            left: subchartHeight + (hasArc ? 0 : $$.getCurrentPaddingLeft())
        } : {
            top: 4 + $$.getCurrentPaddingTop(),
            right: hasArc ? 0 : $$.getCurrentPaddingRight(true),
            bottom: xAxisHeight + subchartHeight + legendHeightForBottom + $$.getCurrentPaddingBottom(),
            left: hasArc ? 0 : $$.getCurrentPaddingLeft()
        };
        // for subchart
        state.margin2 = isRotated ? {
            top: state.margin.top,
            right: NaN,
            bottom: 20 + legendHeightForBottom,
            left: $$.state.rotatedPadding.left
        } : {
            top: state.current.height - subchartHeight - legendHeightForBottom,
            right: NaN,
            bottom: subchartXAxisHeight + legendHeightForBottom,
            left: state.margin.left
        };
        // for legend
        state.margin3 = {
            top: 0,
            right: NaN,
            bottom: 0,
            left: 0
        };
        $$.updateSizeForLegend && $$.updateSizeForLegend(currLegend);
        state.width = state.current.width - state.margin.left - state.margin.right;
        state.height = state.current.height - state.margin.top - state.margin.bottom;
        if (state.width < 0) state.width = 0;
        if (state.height < 0) state.height = 0;
        state.width2 = isRotated ? state.margin.left - state.rotatedPadding.left - state.rotatedPadding.right : state.width;
        state.height2 = isRotated ? state.height : state.current.height - state.margin2.top - state.margin2.bottom;
        if (state.width2 < 0) state.width2 = 0;
        if (state.height2 < 0) state.height2 = 0;
        // for arc
        var hasGauge = $$.hasType("gauge");
        var isLegendRight = config.legend_show && state.isLegendRight;
        state.arcWidth = state.width - (isLegendRight ? currLegend.width + 10 : 0);
        state.arcHeight = state.height - (isLegendRight && !hasGauge ? 0 : 10);
        if (hasGauge && !config.gauge_fullCircle) state.arcHeight += state.height - $$.getPaddingBottomForGauge();
        $$.updateRadius && $$.updateRadius();
        if (state.isLegendRight && hasArc) state.margin3.left = state.arcWidth / 2 + state.radiusExpanded * 1.1;
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var text = {
    opacityForText: function(d) {
        var $$ = this;
        return $$.isBarType(d) && !$$.meetsLabelThreshold(Math.abs($$.getRatio("bar", d)), "bar") ? "0" : $$.hasDataLabel ? "1" : "0";
    },
    /**
     * Initializes the text
     * @private
     */ initText: function() {
        var $el = this.$el;
        $el.main.select(".".concat(CLASS.chart)).append("g").attr("class", CLASS.chartTexts);
    },
    /**
     * Update chartText
     * @param {object} targets $$.data.targets
     * @private
     */ updateTargetsForText: function(targets) {
        var $$ = this;
        var classChartText = $$.getChartClass("Text");
        var classTexts = $$.getClass("texts", "id");
        var classFocus = $$.classFocus.bind($$);
        var mainTextUpdate = $$.$el.main.select(".".concat(CLASS.chartTexts)).selectAll(".".concat(CLASS.chartText)).data(targets).attr("class", function(d) {
            return classChartText(d) + classFocus(d);
        });
        var mainTextEnter = mainTextUpdate.enter().append("g").style("opacity", "0").attr("class", classChartText).style("pointer-events", "none");
        mainTextEnter.append("g").attr("class", classTexts);
    },
    /**
     * Update text
     * @param {number} durationForExit Fade-out transition duration
     * @private
     */ updateText: function(durationForExit) {
        var $$ = this;
        var config = $$.config, $el = $$.$el;
        var dataFn = $$.labelishData.bind($$);
        var classText = $$.getClass("text", "index");
        $el.text = $el.main.selectAll(".".concat(CLASS.texts)).selectAll(".".concat(CLASS.text)).data(function(d) {
            return $$.isRadarType(d) ? d.values : dataFn(d);
        });
        $el.text.exit().transition().duration(durationForExit).style("fill-opacity", "0").remove();
        $el.text = $el.text.enter().append("text").merge($$.$el.text).attr("class", classText).attr("text-anchor", function(d) {
            return config.axis_rotated ? d.value < 0 ? "end" : "start" : "middle";
        }).style("fill", $$.updateTextColor.bind($$)).style("fill-opacity", "0").call(function(selection) {
            selection.each(function(d, i, j) {
                var value = $$.isBubbleZType(d) ? $$.getBubbleZData(d.value, "z") : d.value;
                value = $$.dataLabelFormat(d.id)(value, d.id, i, j);
                if (isNumber(value)) this.textContent = value;
                else setTextValue((0, $hOxpW.default)(this), value);
            });
        });
    },
    updateTextColor: function(d) {
        var $$ = this;
        var labelColors = $$.config.data_labels_colors;
        var defaultColor = $$.isArcType(d) && !$$.isRadarType(d) ? null : $$.color(d);
        var color;
        if (isString(labelColors)) color = labelColors;
        else if (isObject(labelColors)) {
            var id = (d.data || d).id;
            color = labelColors[id];
        } else if (isFunction(labelColors)) color = labelColors.bind($$.api)(defaultColor, d);
        return color || defaultColor;
    },
    /**
     * Redraw chartText
     * @param {Function} x Positioning function for x
     * @param {Function} y Positioning function for y
     * @param {boolean} forFlow Weather is flow
     * @param {boolean} withTransition transition is enabled
     * @returns {Array}
     * @private
     */ redrawText: function(x, y, forFlow, withTransition) {
        var $$ = this;
        var t = getRandom();
        var opacityForText = forFlow ? 0 : $$.opacityForText.bind($$);
        $$.$el.text.each(function(d, index) {
            var text = (0, $hOxpW.default)(this);
            // do not apply transition for newly added text elements
            (withTransition && text.attr("x") ? text.transition(t) : text).call(function(selection) {
                selection.each(function(d) {
                    (0, $hOxpW.default)(this).style("fill", $$.updateTextColor.bind($$)).style("fill-opacity", opacityForText);
                    var posX = x.bind(this)(d, index);
                    var posY = y.bind(this)(d, index);
                    // when is multiline
                    if (this.childElementCount) this.setAttribute("transform", "translate(".concat(posX, " ").concat(posY, ")"));
                    else {
                        this.setAttribute("x", posX);
                        this.setAttribute("y", posY);
                    }
                });
            });
        });
        // need to return 'true' as of being pushed to the redraw list
        // ref: getRedrawList()
        return true;
    },
    /**
     * Gets the getBoundingClientRect value of the element
     * @param {HTMLElement|d3.selection} element Target element
     * @param {string} className Class name
     * @returns {object} value of element.getBoundingClientRect()
     * @private
     */ getTextRect: function(element, className) {
        var $$ = this;
        var base = element.node ? element.node() : element;
        if (!/text/i.test(base.tagName)) base = base.querySelector("text");
        var text = base.textContent;
        var cacheKey = "".concat(KEY.textRect, "-").concat(text.replace(/\W/g, "_"));
        var rect = $$.cache.get(cacheKey);
        if (!rect) {
            $$.$el.svg.append("text").style("visibility", "hidden").style("font", (0, $hOxpW.default)(base).style("font")).classed(className, true).text(text).call(function(v) {
                rect = getBoundingRect(v.node());
            }).remove();
            $$.cache.add(cacheKey, rect);
        }
        return rect;
    },
    /**
     * Gets the x or y coordinate of the text
     * @param {object} indices Indices values
     * @param {boolean} forX whether or not to x
     * @returns {number} coordinates
     * @private
     */ generateXYForText: function(indices, forX) {
        var $$ = this;
        var types = Object.keys(indices);
        var points = {};
        var getter = forX ? $$.getXForText : $$.getYForText;
        $$.hasType("radar") && types.push("radar");
        types.forEach(function(v) {
            points[v] = $$["generateGet".concat(capitalize(v), "Points")](indices[v], false);
        });
        return function(d, i) {
            var type = $$.isAreaType(d) && "area" || $$.isBarType(d) && "bar" || $$.isRadarType(d) && "radar" || "line";
            return getter.call($$, points[type](d, i), d, this);
        };
    },
    /**
     * Get centerized text position for bar type data.label.text
     * @param {object} d Data object
     * @param {Array} points Data points position
     * @param {HTMLElement} textElement Data label text element
     * @returns {number} Position value
     * @private
     */ getCenteredTextPos: function(d, points, textElement) {
        var $$ = this;
        var config = $$.config;
        var isRotated = config.axis_rotated;
        if (config.data_labels.centered && $$.isBarType(d)) {
            var rect = getBoundingRect(textElement);
            var isPositive = d.value >= 0;
            if (isRotated) {
                var w = (isPositive ? points[1][1] - points[0][1] : points[0][1] - points[1][1]) / 2 + rect.width / 2;
                return isPositive ? -w - 3 : w + 2;
            } else {
                var h = (isPositive ? points[0][1] - points[1][1] : points[1][1] - points[0][1]) / 2 + rect.height / 2;
                return isPositive ? h : -h - 2;
            }
        }
        return 0;
    },
    /**
     * Get data.labels.position value
     * @param {string} id Data id value
     * @param {string} type x | y
     * @returns {number} Position value
     * @private
     */ getTextPos: function(id, type) {
        var pos = this.config.data_labels_position;
        return (id in pos ? pos[id] : pos)[type] || 0;
    },
    /**
     * Gets the x coordinate of the text
     * @param {object} points Data points position
     * @param {object} d Data object
     * @param {HTMLElement} textElement Data label text element
     * @returns {number} x coordinate
     * @private
     */ getXForText: function(points, d, textElement) {
        var $$ = this;
        var config = $$.config, state = $$.state;
        var isRotated = config.axis_rotated;
        var xPos;
        var padding;
        if (isRotated) {
            padding = $$.isBarType(d) ? 4 : 6;
            xPos = points[2][1] + padding * (d.value < 0 ? -1 : 1);
        } else xPos = $$.hasType("bar") ? (points[2][0] + points[0][0]) / 2 : points[0][0];
        // show labels regardless of the domain if value is null
        if (d.value === null) {
            if (xPos > state.width) {
                var width = getBoundingRect(textElement).width;
                xPos = state.width - width;
            } else if (xPos < 0) xPos = 4;
        }
        if (isRotated) xPos += $$.getCenteredTextPos(d, points, textElement);
        return xPos + $$.getTextPos(d.id, "x");
    },
    /**
     * Gets the y coordinate of the text
     * @param {object} points Data points position
     * @param {object} d Data object
     * @param {HTMLElement} textElement Data label text element
     * @returns {number} y coordinate
     * @private
     */ getYForText: function(points, d, textElement) {
        var $$ = this;
        var config = $$.config, state = $$.state;
        var isRotated = config.axis_rotated;
        var r = config.point_r;
        var rect = getBoundingRect(textElement);
        var baseY = 3;
        var yPos;
        if (isRotated) yPos = (points[0][0] + points[2][0] + rect.height * 0.6) / 2;
        else {
            yPos = points[2][1];
            if (isNumber(r) && r > 5 && ($$.isLineType(d) || $$.isScatterType(d))) baseY += config.point_r / 2.3;
            if (d.value < 0 || d.value === 0 && !state.hasPositiveValue && state.hasNegativeValue) yPos += rect.height + ($$.isBarType(d) ? -baseY : baseY);
            else {
                var diff = -baseY * 2;
                if ($$.isBarType(d)) diff = -baseY;
                else if ($$.isBubbleType(d)) diff = baseY;
                yPos += diff;
            }
        }
        // show labels regardless of the domain if value is null
        if (d.value === null && !isRotated) {
            var boxHeight = rect.height;
            if (yPos < boxHeight) yPos = boxHeight;
            else if (yPos > state.height) yPos = state.height - 4;
        }
        if (!isRotated) yPos += $$.getCenteredTextPos(d, points, textElement);
        return yPos + $$.getTextPos(d.id, "y");
    },
    /**
     * Calculate if two or more text nodes are overlapping
     * Mark overlapping text nodes with "text-overlapping" class
     * @param {string} id Axis id
     * @param {ChartInternal} $$ ChartInternal context
     * @param {string} selector Selector string
     * @private
     */ markOverlapped: function(id, $$, selector) {
        var textNodes = $$.$el.arcs.selectAll(selector);
        var filteredTextNodes = textNodes.filter(function(node) {
            return node.data.id !== id;
        });
        var textNode = textNodes.filter(function(node) {
            return node.data.id === id;
        });
        var translate = getTranslation(textNode.node());
        // Calculates the length of the hypotenuse
        var calcHypo = function(x, y) {
            return Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
        };
        textNode.node() && filteredTextNodes.each(function() {
            var coordinate = getTranslation(this);
            var filteredTextNode = (0, $hOxpW.default)(this);
            var nodeForWidth = calcHypo(translate.e, translate.f) > calcHypo(coordinate.e, coordinate.f) ? textNode : filteredTextNode;
            var overlapsX = Math.ceil(Math.abs(translate.e - coordinate.e)) < Math.ceil(nodeForWidth.node().getComputedTextLength());
            var overlapsY = Math.ceil(Math.abs(translate.f - coordinate.f)) < parseInt(textNode.style("font-size"), 10);
            filteredTextNode.classed(CLASS.TextOverlapping, overlapsX && overlapsY);
        });
    },
    /**
     * Calculate if two or more text nodes are overlapping
     * Remove "text-overlapping" class on selected text nodes
     * @param {ChartInternal} $$ ChartInternal context
     * @param {string} selector Selector string
     * @private
     */ undoMarkOverlapped: function($$, selector) {
        $$.$el.arcs.selectAll(selector).each(function() {
            (0, $jJCd9.default)([
                this,
                this.previousSibling
            ]).classed(CLASS.TextOverlapping, false);
        });
    },
    /**
     * Check if meets the ratio to show data label text
     * @param {number} ratio ratio to meet
     * @param {string} type chart type
     * @returns {boolean}
     * @private
     */ meetsLabelThreshold: function(ratio, type) {
        if (ratio === void 0) ratio = 0;
        var $$ = this;
        var config = $$.config;
        var threshold = config["".concat(type, "_label_threshold")] || 0;
        return ratio >= threshold;
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * Get the text position
 * @param {string} pos right, left or center
 * @param {number} width chart width
 * @returns {string|number} text-anchor value or position in pixel
 * @private
 */ function getTextPos(pos, width) {
    if (pos === void 0) pos = "left";
    var isNum = isNumber(width);
    var position;
    if (pos.indexOf("center") > -1) position = isNum ? width / 2 : "middle";
    else if (pos.indexOf("right") > -1) position = isNum ? width : "end";
    else position = isNum ? 0 : "start";
    return position;
}
var title = {
    /**
     * Initializes the title
     * @private
     */ initTitle: function() {
        var $$ = this;
        var config = $$.config, $el = $$.$el;
        if (config.title_text) {
            $el.title = $el.svg.append("g");
            var text = $el.title.append("text").style("text-anchor", getTextPos(config.title_position)).attr("class", CLASS.title);
            setTextValue(text, config.title_text, [
                0.3,
                1.5
            ]);
        }
    },
    /**
     * Redraw title
     * @private
     */ redrawTitle: function() {
        var $$ = this;
        var config = $$.config, current = $$.state.current, title = $$.$el.title;
        if (title) {
            var y = $$.yForTitle.call($$);
            if (/g/i.test(title.node().tagName)) title.attr("transform", "translate(".concat(getTextPos(config.title_position, current.width), ", ").concat(y, ")"));
            else title.attr("x", $$.xForTitle.call($$)).attr("y", y);
        }
    },
    /**
     * Returns the x attribute value of the title
     * @returns {number} x attribute value
     * @private
     */ xForTitle: function() {
        var $$ = this;
        var config = $$.config, current = $$.state.current;
        var position = config.title_position || "left";
        var textRectWidth = $$.getTextRect($$.$el.title, CLASS.title).width;
        var x;
        if (/(right|center)/.test(position)) {
            x = current.width - textRectWidth;
            if (position.indexOf("right") >= 0) x = current.width - textRectWidth - config.title_padding.right;
            else if (position.indexOf("center") >= 0) x = (current.width - textRectWidth) / 2;
        } else x = config.title_padding.left || 0;
        return x;
    },
    /**
     * Returns the y attribute value of the title
     * @returns {number} y attribute value
     * @private
     */ yForTitle: function() {
        var $$ = this;
        return ($$.config.title_padding.top || 0) + $$.getTextRect($$.$el.title, CLASS.title).height;
    },
    /**
     * Get title padding
     * @returns {number} padding value
     * @private
     */ getTitlePadding: function() {
        var $$ = this;
        return $$.yForTitle() + ($$.config.title_padding.bottom || 0);
    }
};
var tooltip$1 = {
    /**
     * Initializes the tooltip
     * @private
     */ initTooltip: function() {
        var $$ = this;
        var config = $$.config, $el = $$.$el;
        $el.tooltip = (0, $hOxpW.default)(config.tooltip_contents.bindto);
        if ($el.tooltip.empty()) $el.tooltip = $el.chart.style("position", "relative").append("div").attr("class", CLASS.tooltipContainer).style("position", "absolute").style("pointer-events", "none").style("display", "none");
        $$.bindTooltipResizePos();
    },
    initShowTooltip: function() {
        var $$ = this;
        var config = $$.config, $el = $$.$el, _a = $$.state, hasAxis = _a.hasAxis, hasRadar = _a.hasRadar;
        // Show tooltip if needed
        if (config.tooltip_init_show) {
            var isArc_1 = !(hasAxis && hasRadar);
            if ($$.axis && $$.axis.isTimeSeries() && isString(config.tooltip_init_x)) {
                var targets = $$.data.targets[0];
                var i = void 0;
                var val = void 0;
                config.tooltip_init_x = parseDate.call($$, config.tooltip_init_x);
                for(i = 0; val = targets.values[i]; i++){
                    if (val.x - config.tooltip_init_x === 0) break;
                }
                config.tooltip_init_x = i;
            }
            var data = $$.data.targets.map(function(d) {
                var x = isArc_1 ? 0 : config.tooltip_init_x;
                return $$.addName(d.values[x]);
            });
            if (isArc_1) data = [
                data[config.tooltip_init_x]
            ];
            $el.tooltip.html($$.getTooltipHTML(data, $$.axis && $$.axis.getXAxisTickFormat(), $$.getYFormat($$.hasArcType(null, [
                "radar"
            ])), $$.color));
            if (!config.tooltip_contents.bindto) $el.tooltip.style("top", config.tooltip_init_position.top).style("left", config.tooltip_init_position.left).style("display", "block");
        }
    },
    /**
     * Get the tooltip HTML string
     * @param  {Array} args Arguments
     * @returns {string} Formatted HTML string
     * @private
     */ getTooltipHTML: function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var $$ = this;
        var api = $$.api, config = $$.config;
        return isFunction(config.tooltip_contents) ? config.tooltip_contents.bind(api).apply(void 0, args) : $$.getTooltipContent.apply($$, args);
    },
    /**
     * Returns the tooltip content(HTML string)
     * @param {object} d data
     * @param {Function} defaultTitleFormat Default title format
     * @param {Function} defaultValueFormat Default format for each data value in the tooltip.
     * @param {Function} color Color function
     * @returns {string} html
     * @private
     */ getTooltipContent: function(d, defaultTitleFormat, defaultValueFormat, color) {
        var $$ = this;
        var api = $$.api, config = $$.config, state = $$.state;
        var _a = [
            "title",
            "name",
            "value"
        ].map(function(v) {
            var fn = config["tooltip_format_".concat(v)];
            return isFunction(fn) ? fn.bind(api) : fn;
        }), titleFormat = _a[0], nameFormat = _a[1], valueFormat = _a[2];
        titleFormat = titleFormat || defaultTitleFormat;
        nameFormat = nameFormat || function(name) {
            return name;
        };
        valueFormat = valueFormat || ($$.isStackNormalized() ? function(v, ratio) {
            return "".concat((ratio * 100).toFixed(2), "%");
        } : defaultValueFormat);
        var order = config.tooltip_order;
        var getRowValue = function(row) {
            return $$.axis && $$.isBubbleZType(row) ? $$.getBubbleZData(row.value, "z") : $$.getBaseValue(row);
        };
        var getBgColor = $$.levelColor ? function(row) {
            return $$.levelColor(row.value);
        } : function(row) {
            return color(row);
        };
        var contents = config.tooltip_contents;
        var tplStr = contents.template;
        var targetIds = $$.mapToTargetIds();
        if (order === null && config.data_groups.length) {
            // for stacked data, order should aligned with the visually displayed data
            var ids_1 = $$.orderTargets($$.data.targets).map(function(i2) {
                return i2.id;
            }).reverse();
            d.sort(function(a, b) {
                var v1 = a ? a.value : null;
                var v2 = b ? b.value : null;
                if (v1 > 0 && v2 > 0) {
                    v1 = a.id ? ids_1.indexOf(a.id) : null;
                    v2 = b.id ? ids_1.indexOf(b.id) : null;
                }
                return v1 - v2;
            });
        } else if (/^(asc|desc)$/.test(order)) {
            var isAscending_1 = order === "asc";
            d.sort(function(a, b) {
                var v1 = a ? getRowValue(a) : null;
                var v2 = b ? getRowValue(b) : null;
                return isAscending_1 ? v1 - v2 : v2 - v1;
            });
        } else if (isFunction(order)) d.sort(order.bind(api));
        var tpl = $$.getTooltipContentTemplate(tplStr);
        var len = d.length;
        var text;
        var row;
        var param;
        var value;
        var i;
        var _loop_1 = function() {
            row = d[i];
            if (!row || !(getRowValue(row) || getRowValue(row) === 0)) return "continue";
            if (isUndefined(text)) {
                var title = (state.hasAxis || state.hasRadar) && sanitise(titleFormat ? titleFormat(row.x) : row.x);
                text = tplProcess(tpl[0], {
                    CLASS_TOOLTIP: CLASS.tooltip,
                    TITLE: isValue(title) ? tplStr ? title : '<tr><th colspan="2">'.concat(title, "</th></tr>") : ""
                });
            }
            if (!row.ratio && $$.$el.arcs) row.ratio = $$.getRatio("arc", $$.$el.arcs.select("path.".concat(CLASS.arc, "-").concat(row.id)).data()[0]);
            param = [
                row.ratio,
                row.id,
                row.index,
                d
            ];
            value = sanitise(valueFormat.apply(void 0, __spreadArray([
                getRowValue(row)
            ], param, false)));
            if ($$.isAreaRangeType(row)) {
                var _b = [
                    "high",
                    "low"
                ].map(function(v) {
                    return sanitise(valueFormat.apply(void 0, __spreadArray([
                        $$.getAreaRangeData(row, v)
                    ], param, false)));
                }), high = _b[0], low = _b[1];
                value = "<b>Mid:</b> ".concat(value, " <b>High:</b> ").concat(high, " <b>Low:</b> ").concat(low);
            }
            if (value !== undefined) {
                // Skip elements when their name is set to null
                if (row.name === null) return "continue";
                var name_1 = sanitise(nameFormat.apply(void 0, __spreadArray([
                    row.name
                ], param, false)));
                var color_1 = getBgColor(row);
                var contentValue_1 = {
                    CLASS_TOOLTIP_NAME: CLASS.tooltipName + $$.getTargetSelectorSuffix(row.id),
                    COLOR: tplStr || !$$.patterns ? color_1 : '<svg><rect style="fill:'.concat(color_1, '" width="10" height="10"></rect></svg>'),
                    NAME: name_1,
                    VALUE: value
                };
                if (tplStr && isObject(contents.text)) {
                    var index_1 = targetIds.indexOf(row.id);
                    Object.keys(contents.text).forEach(function(key) {
                        contentValue_1[key] = contents.text[key][index_1];
                    });
                }
                text += tplProcess(tpl[1], contentValue_1);
            }
        };
        for(i = 0; i < len; i++)_loop_1();
        return "".concat(text, "</table>");
    },
    /**
     * Get the content template string
     * @param {string} tplStr Tempalte string
     * @returns {Array} Template string
     * @private
     */ getTooltipContentTemplate: function(tplStr) {
        return (tplStr || '<table class="{=CLASS_TOOLTIP}"><tbody>\n				{=TITLE}\n				{{<tr class="{=CLASS_TOOLTIP_NAME}">\n					<td class="name">'.concat(this.patterns ? "{=COLOR}" : '<span style="background-color:{=COLOR}"></span>', '{=NAME}</td>\n					<td class="value">{=VALUE}</td>\n				</tr>}}\n			</tbody></table>')).replace(/(\r?\n|\t)/g, "").split(/{{(.*)}}/);
    },
    /**
     * Returns the position of the tooltip
     * @param {object} dataToShow data
     * @param {string} tWidth Width value of tooltip element
     * @param {string} tHeight Height value of tooltip element
     * @param {HTMLElement} element Tooltip element
     * @returns {object} top, left value
     * @private
     */ tooltipPosition: function(dataToShow, tWidth, tHeight, element) {
        var $$ = this;
        var config = $$.config, scale = $$.scale, state = $$.state;
        var width = state.width, height = state.height, current = state.current, isLegendRight = state.isLegendRight, inputType = state.inputType;
        var hasGauge = $$.hasType("gauge") && !config.gauge_fullCircle;
        var svgLeft = $$.getSvgLeft(true);
        var _a = (0, $iS3vq.default)(element), x = _a[0], y = _a[1];
        var chartRight = svgLeft + current.width - $$.getCurrentPaddingRight();
        var chartLeft = $$.getCurrentPaddingLeft(true);
        var size = 20;
        // Determine tooltip position
        if ($$.hasArcType()) {
            var raw = inputType === "touch" || $$.hasType("radar");
            if (!raw) {
                y += hasGauge ? height : height / 2;
                x += (width - (isLegendRight ? $$.getLegendWidth() : 0)) / 2;
            }
        } else {
            var dataScale = scale.x(dataToShow[0].x);
            if (config.axis_rotated) {
                y = dataScale + size;
                x += svgLeft + 100;
                chartRight -= svgLeft;
            } else {
                y -= 5;
                x = svgLeft + chartLeft + size + ($$.zoomScale ? x : dataScale);
            }
        }
        // when tooltip left + tWidth > chart's width
        if (x + tWidth + 15 > chartRight) x -= tWidth + chartLeft;
        if (y + tHeight > current.height) y -= hasGauge ? tHeight * 3 : tHeight + 30;
        var pos = {
            top: y,
            left: x
        };
        // make sure to not be positioned out of viewport
        Object.keys(pos).forEach(function(v) {
            if (pos[v] < 0) pos[v] = 0;
        });
        return pos;
    },
    /**
     * Show the tooltip
     * @param {object} selectedData Data object
     * @param {HTMLElement} element Tooltip element
     * @private
     */ showTooltip: function(selectedData, element) {
        var $$ = this;
        var config = $$.config, state = $$.state, tooltip = $$.$el.tooltip;
        var bindto = config.tooltip_contents.bindto;
        var forArc = $$.hasArcType(null, [
            "radar"
        ]);
        var dataToShow = selectedData.filter(function(d) {
            return d && isValue($$.getBaseValue(d));
        });
        if (!tooltip || dataToShow.length === 0 || !config.tooltip_show) return;
        var datum = tooltip.datum();
        var _a = datum || {}, _b = _a.width, width = _b === void 0 ? 0 : _b, _c = _a.height, height = _c === void 0 ? 0 : _c;
        var dataStr = JSON.stringify(selectedData);
        if (!datum || datum.current !== dataStr) {
            var index = selectedData.concat().sort()[0].index;
            callFn(config.tooltip_onshow, $$.api, selectedData);
            // set tooltip content
            tooltip.html($$.getTooltipHTML(selectedData, $$.axis ? $$.axis.getXAxisTickFormat() : $$.categoryName.bind($$), $$.getYFormat(forArc), $$.color // color
            )).style("display", null).style("visibility", null) // for IE9
            .datum(datum = {
                index: index,
                current: dataStr,
                width: width = tooltip.property("offsetWidth"),
                height: height = tooltip.property("offsetHeight")
            });
            callFn(config.tooltip_onshown, $$.api, selectedData);
            $$._handleLinkedCharts(true, index);
        }
        if (!bindto) {
            var fnPos = config.tooltip_position || $$.tooltipPosition;
            // Get tooltip dimensions
            var pos_1 = fnPos.call(this, dataToShow, width, height, element);
            [
                "top",
                "left"
            ].forEach(function(v) {
                var value = pos_1[v];
                tooltip.style(v, "".concat(value, "px"));
                // Remember left pos in percentage to be used on resize call
                if (v === "left" && !datum.xPosInPercent) datum.xPosInPercent = value / state.current.width * 100;
            });
        }
    },
    /**
     * Adjust tooltip position on resize event
     * @private
     */ bindTooltipResizePos: function() {
        var $$ = this;
        var resizeFunction = $$.resizeFunction, state = $$.state, tooltip = $$.$el.tooltip;
        resizeFunction.add(function() {
            if (tooltip.style("display") === "block") {
                var current = state.current;
                var _a = tooltip.datum(), width = _a.width, xPosInPercent = _a.xPosInPercent;
                var value = current.width / 100 * xPosInPercent;
                var diff = current.width - (value + width);
                // if tooltip size overs current viewport size
                if (diff < 0) value += diff;
                tooltip.style("left", "".concat(value, "px"));
            }
        });
    },
    /**
     * Hide the tooltip
     * @param {boolean} force Force to hide
     * @private
     */ hideTooltip: function(force) {
        var $$ = this;
        var api = $$.api, config = $$.config, tooltip = $$.$el.tooltip;
        if (tooltip && tooltip.style("display") !== "none" && (!config.tooltip_doNotHide || force)) {
            var selectedData = JSON.parse(tooltip.datum().current);
            callFn(config.tooltip_onhide, api, selectedData);
            // hide tooltip
            tooltip.style("display", "none").style("visibility", "hidden") // for IE9
            .datum(null);
            callFn(config.tooltip_onhidden, api, selectedData);
        }
    },
    /**
     * Toggle display for linked chart instances
     * @param {boolean} show true: show, false: hide
     * @param {number} index x Axis index
     * @private
     */ _handleLinkedCharts: function(show, index) {
        var $$ = this;
        var charts = $$.charts, config = $$.config;
        // Prevent propagation among instances if isn't instantiated from the user's event
        // https://github.com/naver/billboard.js/issues/1979
        if ((0, $iZ2is.event) && (0, $iZ2is.event).isTrusted && config.tooltip_linked && charts.length > 1) {
            var linkedName_1 = config.tooltip_linked_name;
            charts.filter(function(c) {
                return c !== $$.api;
            }).forEach(function(c) {
                var _a = c.internal, config = _a.config, $el = _a.$el;
                var isLinked = config.tooltip_linked;
                var name = config.tooltip_linked_name;
                var isInDom = doc.body.contains($el.chart.node());
                if (isLinked && linkedName_1 === name && isInDom) {
                    var data = $el.tooltip.data()[0];
                    var isNotSameIndex = index !== (data && data.index);
                    try {
                        c.tooltip[show && isNotSameIndex ? "show" : "hide"]({
                            index: index
                        });
                    } catch (e) {}
                }
            });
        }
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var transform = {
    getTranslate: function(target, index) {
        if (index === void 0) index = 0;
        var $$ = this;
        var config = $$.config, state = $$.state;
        var isRotated = config.axis_rotated;
        var padding = 0;
        var x;
        var y;
        if (index && /^(x|y2?)$/.test(target)) padding = $$.getAxisSize(target) * index;
        if (target === "main") {
            x = asHalfPixel(state.margin.left);
            y = asHalfPixel(state.margin.top);
        } else if (target === "context") {
            x = asHalfPixel(state.margin2.left);
            y = asHalfPixel(state.margin2.top);
        } else if (target === "legend") {
            x = state.margin3.left;
            y = state.margin3.top;
        } else if (target === "x") {
            x = isRotated ? -padding : 0;
            y = isRotated ? 0 : state.height + padding;
        } else if (target === "y") {
            x = isRotated ? 0 : -padding;
            y = isRotated ? state.height + padding : 0;
        } else if (target === "y2") {
            x = isRotated ? 0 : state.width + padding;
            y = isRotated ? 1 - padding : 0;
        } else if (target === "subX") {
            x = 0;
            y = isRotated ? 0 : state.height2;
        } else if (target === "arc") {
            x = state.arcWidth / 2;
            y = state.arcHeight / 2;
        } else if (target === "radar") {
            var width = $$.getRadarSize()[0];
            x = state.width / 2 - width;
            y = asHalfPixel(state.margin.top);
        }
        return "translate(".concat(x, ", ").concat(y, ")");
    },
    transformMain: function(withTransition, transitions) {
        var $$ = this;
        var main = $$.$el.main;
        var xAxis;
        var yAxis;
        var y2Axis;
        if (transitions && transitions.axisX) xAxis = transitions.axisX;
        else {
            xAxis = main.select(".".concat(CLASS.axisX));
            if (withTransition) xAxis = xAxis.transition();
        }
        if (transitions && transitions.axisY) yAxis = transitions.axisY;
        else {
            yAxis = main.select(".".concat(CLASS.axisY));
            if (withTransition) yAxis = yAxis.transition();
        }
        if (transitions && transitions.axisY2) y2Axis = transitions.axisY2;
        else {
            y2Axis = main.select(".".concat(CLASS.axisY2));
            if (withTransition) y2Axis = y2Axis.transition();
        }
        (withTransition ? main.transition() : main).attr("transform", $$.getTranslate("main"));
        xAxis.attr("transform", $$.getTranslate("x"));
        yAxis.attr("transform", $$.getTranslate("y"));
        y2Axis.attr("transform", $$.getTranslate("y2"));
        main.select(".".concat(CLASS.chartArcs)).attr("transform", $$.getTranslate("arc"));
    },
    transformAll: function(withTransition, transitions) {
        var $$ = this;
        var config = $$.config, hasAxis = $$.state.hasAxis, $el = $$.$el;
        $$.transformMain(withTransition, transitions);
        hasAxis && config.subchart_show && $$.transformContext(withTransition, transitions);
        $el.legend && $$.transformLegend(withTransition);
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var type = {
    setTargetType: function(targetIds, type) {
        var $$ = this;
        var config = $$.config, withoutFadeIn = $$.state.withoutFadeIn;
        $$.mapToTargetIds(targetIds).forEach(function(id) {
            withoutFadeIn[id] = type === config.data_types[id];
            config.data_types[id] = type;
        });
        if (!targetIds) config.data_type = type;
    },
    /**
     * Updte current used chart types
     * @private
     */ updateTypesElements: function() {
        var $$ = this;
        var current = $$.state.current;
        Object.keys(TYPE).forEach(function(v) {
            var t = TYPE[v];
            var has = $$.hasType(t, null, true);
            var idx = current.types.indexOf(t);
            if (idx === -1 && has) current.types.push(t);
            else if (idx > -1 && !has) current.types.splice(idx, 1);
        });
        // Update current chart elements reference
        $$.setChartElements();
    },
    /**
     * Check if given chart types exists
     * @param {string} type Chart type
     * @param {Array} targetsValue Data array
     * @param {boolean} checkFromData Force to check type cotains from data targets
     * @returns {boolean}
     * @private
     */ hasType: function(type, targetsValue, checkFromData) {
        if (checkFromData === void 0) checkFromData = false;
        var $$ = this;
        var config = $$.config, current = $$.state.current;
        var types = config.data_types;
        var targets = targetsValue || $$.data.targets;
        var has = false;
        if (!checkFromData && current.types.length && current.types.indexOf(type) > -1) has = true;
        else if (targets && targets.length) targets.forEach(function(target) {
            var t = types[target.id];
            if (t === type || !t && type === "line") has = true;
        });
        else if (Object.keys(types).length) Object.keys(types).forEach(function(id) {
            if (types[id] === type) has = true;
        });
        else has = config.data_type === type;
        return has;
    },
    /**
     * Check if contains given chart types
     * @param {string} type Type key
     * @param {object} targets Target data
     * @param {Array} exclude Excluded types
     * @returns {boolean}
     * @private
     */ hasTypeOf: function(type, targets, exclude) {
        var _this = this;
        if (exclude === void 0) exclude = [];
        return !TYPE_BY_CATEGORY[type]// @ts-ignore
        .filter(function(v) {
            return exclude.indexOf(v) === -1;
        }).every(function(v) {
            return !_this.hasType(v, targets);
        });
    },
    /**
     * Check if given data is certain chart type
     * @param {object} d Data object
     * @param {string|Array} type chart type
     * @returns {boolean}
     * @private
     */ isTypeOf: function(d, type) {
        var id = isString(d) ? d : d.id;
        var dataType = this.config.data_types[id] || this.config.data_type;
        return isArray(type) ? type.indexOf(dataType) >= 0 : dataType === type;
    },
    hasPointType: function() {
        var $$ = this;
        return $$.hasTypeOf("Line") || $$.hasType("bubble") || $$.hasType("scatter");
    },
    /**
     * Check if contains arc types chart
     * @param {object} targets Target data
     * @param {Array} exclude Excluded types
     * @returns {boolean}
     * @private
     */ hasArcType: function(targets, exclude) {
        return this.hasTypeOf("Arc", targets, exclude);
    },
    hasMultiArcGauge: function() {
        return this.hasType("gauge") && this.config.gauge_type === "multi";
    },
    isLineType: function(d) {
        var id = isString(d) ? d : d.id;
        return !this.config.data_types[id] || this.isTypeOf(id, TYPE_BY_CATEGORY.Line);
    },
    isStepType: function(d) {
        return this.isTypeOf(d, TYPE_BY_CATEGORY.Step);
    },
    isSplineType: function(d) {
        return this.isTypeOf(d, TYPE_BY_CATEGORY.Spline);
    },
    isAreaType: function(d) {
        return this.isTypeOf(d, TYPE_BY_CATEGORY.Area);
    },
    isAreaRangeType: function(d) {
        return this.isTypeOf(d, TYPE_BY_CATEGORY.AreaRange);
    },
    isBarType: function(d) {
        return this.isTypeOf(d, "bar");
    },
    isBubbleType: function(d) {
        return this.isTypeOf(d, "bubble");
    },
    isScatterType: function(d) {
        return this.isTypeOf(d, "scatter");
    },
    isPieType: function(d) {
        return this.isTypeOf(d, "pie");
    },
    isGaugeType: function(d) {
        return this.isTypeOf(d, "gauge");
    },
    isDonutType: function(d) {
        return this.isTypeOf(d, "donut");
    },
    isRadarType: function(d) {
        return this.isTypeOf(d, "radar");
    },
    isArcType: function(d) {
        return this.isPieType(d) || this.isDonutType(d) || this.isGaugeType(d) || this.isRadarType(d);
    },
    // determine if is 'circle' data point
    isCirclePoint: function(node) {
        var config = this.config;
        var pattern = config.point_pattern;
        var isCircle = false;
        if (node && node.tagName === "circle") isCircle = true;
        else isCircle = config.point_type === "circle" && (!pattern || isArray(pattern) && pattern.length === 0);
        return isCircle;
    },
    lineData: function(d) {
        return this.isLineType(d) ? [
            d
        ] : [];
    },
    arcData: function(d) {
        return this.isArcType(d.data) ? [
            d
        ] : [];
    },
    barData: function(d) {
        return this.isBarType(d) ? d.values : [];
    },
    /**
     * Get data adapt for data label showing
     * @param {object} d Data object
     * @returns {Array}
     * @private
     */ labelishData: function(d) {
        return this.isBarType(d) || this.isLineType(d) || this.isScatterType(d) || this.isBubbleType(d) || this.isRadarType(d) ? d.values : [];
    },
    barLineBubbleData: function(d) {
        return this.isBarType(d) || this.isLineType(d) || this.isBubbleType(d) ? d.values : [];
    },
    // https://github.com/d3/d3-shape#curves
    isInterpolationType: function(type) {
        return [
            "basis",
            "basis-closed",
            "basis-open",
            "bundle",
            "cardinal",
            "cardinal-closed",
            "cardinal-open",
            "catmull-rom",
            "catmull-rom-closed",
            "catmull-rom-open",
            "linear",
            "linear-closed",
            "monotone-x",
            "monotone-y",
            "natural"
        ].indexOf(type) >= 0;
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 * @ignore
 */ /**
 * Internal chart class.
 * - Note: Instantiated internally, not exposed for public.
 * @class ChartInternal
 * @ignore
 * @private
 */ var ChartInternal = /** @class */ function() {
    function ChartInternal(api) {
        // data object
        this.data = {
            xs: {},
            targets: []
        };
        // scales
        this.scale = {
            x: null,
            y: null,
            y2: null,
            subX: null,
            subY: null,
            subY2: null,
            zoom: null
        };
        // original values
        this.org = {
            xScale: null,
            xDomain: null
        };
        // format function
        this.format = {
            extraLineClasses: null,
            xAxisTick: null,
            dataTime: null,
            defaultAxisTime: null,
            axisTime: null // axisTimeFormat
        };
        var $$ = this;
        $$.api = api; // Chart class instance alias
        $$.config = new Options();
        $$.cache = new Cache();
        var store = new Store();
        $$.$el = store.getStore("element");
        $$.state = store.getStore("state");
    }
    ChartInternal.prototype.beforeInit = function() {
        var $$ = this;
        $$.callPluginHook("$beforeInit");
        // can do something
        callFn($$.config.onbeforeinit, $$.api);
    };
    ChartInternal.prototype.afterInit = function() {
        var $$ = this;
        $$.callPluginHook("$afterInit");
        // can do something
        callFn($$.config.onafterinit, $$.api);
    };
    ChartInternal.prototype.init = function() {
        var $$ = this;
        var config = $$.config, state = $$.state, $el = $$.$el;
        state.hasAxis = !$$.hasArcType();
        state.hasRadar = !state.hasAxis && $$.hasType("radar");
        $$.initParams();
        var bindto = {
            element: config.bindto,
            classname: "bb"
        };
        if (isObject(config.bindto)) {
            bindto.element = config.bindto.element || "#chart";
            bindto.classname = config.bindto.classname || bindto.classname;
        }
        // select bind element
        $el.chart = isFunction(bindto.element.node) ? config.bindto.element : (0, $hOxpW.default)(bindto.element || []);
        if ($el.chart.empty()) $el.chart = (0, $hOxpW.default)(doc.body.appendChild(doc.createElement("div")));
        $el.chart.html("").classed(bindto.classname, true);
        $$.initToRender();
    };
    /**
     * Initialize the rendering process
     * @param {boolean} forced Force to render process
     * @private
     */ ChartInternal.prototype.initToRender = function(forced) {
        var $$ = this;
        var config = $$.config, state = $$.state, chart = $$.$el.chart;
        var isHidden = function() {
            return chart.style("display") === "none" || chart.style("visibility") === "hidden";
        };
        var isLazy = config.render.lazy || isHidden();
        var MutationObserver = win.MutationObserver;
        if (isLazy && MutationObserver && config.render.observe !== false && !forced) new MutationObserver(function(mutation, observer) {
            if (!isHidden()) {
                observer.disconnect();
                !state.rendered && $$.initToRender(true);
            }
        }).observe(chart.node(), {
            attributes: true,
            attributeFilter: [
                "class",
                "style"
            ]
        });
        if (!isLazy || forced) {
            var convertedData = $$.convertData(config, $$.initWithData);
            convertedData && $$.initWithData(convertedData);
            $$.afterInit();
        }
    };
    ChartInternal.prototype.initParams = function() {
        var $$ = this;
        var _a = $$, config = _a.config, format = _a.format, state = _a.state;
        var isRotated = config.axis_rotated;
        // datetime to be used for uniqueness
        state.datetimeId = "bb-".concat(+new Date());
        $$.color = $$.generateColor();
        $$.levelColor = $$.generateLevelColor();
        if ($$.hasPointType()) $$.point = $$.generatePoint();
        if (state.hasAxis) {
            $$.initClip();
            format.extraLineClasses = $$.generateExtraLineClass();
            format.dataTime = config.data_xLocaltime ? (0, $UutV9.timeParse) : (0, $UutV9.utcParse);
            format.axisTime = config.axis_x_localtime ? (0, $UutV9.timeFormat) : (0, $UutV9.utcFormat);
            var isDragZoom_1 = $$.config.zoom_enabled && $$.config.zoom_type === "drag";
            format.defaultAxisTime = function(d) {
                var _a = $$.scale, x = _a.x, zoom = _a.zoom;
                var isZoomed = isDragZoom_1 ? zoom : zoom && x.orgDomain().toString() !== zoom.domain().toString();
                var specifier = d.getMilliseconds() && ".%L" || d.getSeconds() && ".:%S" || d.getMinutes() && "%I:%M" || d.getHours() && "%I %p" || d.getDate() !== 1 && "%b %d" || isZoomed && d.getDate() === 1 && "%b'%y" || d.getMonth() && "%-m/%-d" || "%Y";
                return format.axisTime(specifier)(d);
            };
        }
        state.isLegendRight = config.legend_position === "right";
        state.isLegendInset = config.legend_position === "inset";
        state.isLegendTop = config.legend_inset_anchor === "top-left" || config.legend_inset_anchor === "top-right";
        state.isLegendLeft = config.legend_inset_anchor === "top-left" || config.legend_inset_anchor === "bottom-left";
        state.rotatedPaddingRight = isRotated && !config.axis_x_show ? 0 : 30;
        state.inputType = convertInputType(config.interaction_inputType_mouse, config.interaction_inputType_touch);
    };
    ChartInternal.prototype.initWithData = function(data) {
        var $$ = this;
        var config = $$.config, scale = $$.scale, state = $$.state, $el = $$.$el, org = $$.org;
        var hasAxis = state.hasAxis;
        var hasInteraction = config.interaction_enabled;
        // for arc type, set axes to not be shown
        // $$.hasArcType() && ["x", "y", "y2"].forEach(id => (config[`axis_${id}_show`] = false));
        if (hasAxis) {
            $$.axis = $$.getAxisInstance();
            config.zoom_enabled && $$.initZoom();
        }
        // Init data as targets
        $$.data.xs = {};
        $$.data.targets = $$.convertDataToTargets(data);
        if (config.data_filter) $$.data.targets = $$.data.targets.filter(config.data_filter.bind($$.api));
        // Set targets to hide if needed
        if (config.data_hide) $$.addHiddenTargetIds(config.data_hide === true ? $$.mapToIds($$.data.targets) : config.data_hide);
        if (config.legend_hide) $$.addHiddenLegendIds(config.legend_hide === true ? $$.mapToIds($$.data.targets) : config.legend_hide);
        // Init sizes and scales
        $$.updateSizes();
        $$.updateScales(true);
        // retrieve scale after the 'updateScales()' is called
        var x = scale.x, y = scale.y, y2 = scale.y2, subX = scale.subX, subY = scale.subY, subY2 = scale.subY2;
        // Set domains for each scale
        if (x) {
            x.domain(sortValue($$.getXDomain($$.data.targets)));
            subX.domain(x.domain());
            // Save original x domain for zoom update
            org.xDomain = x.domain();
        }
        if (y) {
            y.domain($$.getYDomain($$.data.targets, "y"));
            subY.domain(y.domain());
        }
        if (y2) {
            y2.domain($$.getYDomain($$.data.targets, "y2"));
            subY2 && subY2.domain(y2.domain());
        }
        // -- Basic Elements --
        $el.svg = $el.chart.append("svg").style("overflow", "hidden").style("display", "block");
        if (hasInteraction && state.inputType) {
            var isTouch = state.inputType === "touch";
            $el.svg.on(isTouch ? "touchstart" : "mouseenter", function() {
                return callFn(config.onover, $$.api);
            }).on(isTouch ? "touchend" : "mouseleave", function() {
                return callFn(config.onout, $$.api);
            });
        }
        config.svg_classname && $el.svg.attr("class", config.svg_classname);
        // Define defs
        var hasColorPatterns = isFunction(config.color_tiles) && $$.patterns;
        if (hasAxis || hasColorPatterns) {
            $el.defs = $el.svg.append("defs");
            if (hasAxis) [
                "id",
                "idXAxis",
                "idYAxis",
                "idGrid"
            ].forEach(function(v) {
                $$.appendClip($el.defs, state.clip[v]);
            });
            // set color patterns
            if (hasColorPatterns) $$.patterns.forEach(function(p) {
                return $el.defs.append(function() {
                    return p.node;
                });
            });
        }
        $$.updateSvgSize();
        // Bind resize event
        $$.bindResize();
        // Define regions
        var main = $el.svg.append("g").classed(CLASS.main, true).attr("transform", $$.getTranslate("main"));
        $el.main = main;
        // initialize subchart when subchart show option is set
        config.subchart_show && $$.initSubchart();
        config.tooltip_show && $$.initTooltip();
        config.title_text && $$.initTitle();
        config.legend_show && $$.initLegend();
        // -- Main Region --
        // text when empty
        if (config.data_empty_label_text) main.append("text").attr("class", "".concat(CLASS.text, " ").concat(CLASS.empty)).attr("text-anchor", "middle") // horizontal centering of text at x position in all browsers.
        .attr("dominant-baseline", "middle"); // vertical centering of text at y position in all browsers, except IE.
        if (hasAxis) {
            // Regions
            config.regions.length && $$.initRegion();
            // Add Axis here, when clipPath is 'false'
            !config.clipPath && $$.axis.init();
        }
        // Define g for chart area
        main.append("g").attr("class", CLASS.chart).attr("clip-path", state.clip.path);
        $$.callPluginHook("$init");
        if (hasAxis) {
            // Cover whole with rects for events
            hasInteraction && $$.initEventRect && $$.initEventRect();
            // Grids
            $$.initGrid();
            // Add Axis here, when clipPath is 'true'
            config.clipPath && $$.axis && $$.axis.init();
        }
        $$.initChartElements();
        // Set targets
        $$.updateTargets($$.data.targets);
        // Draw with targets
        $$.updateDimension();
        // oninit callback
        callFn(config.oninit, $$.api);
        // Set background
        $$.setBackground();
        $$.redraw({
            withTransition: false,
            withTransform: true,
            withUpdateXDomain: true,
            withUpdateOrgXDomain: true,
            withTransitionForAxis: false,
            initializing: true
        });
        // data.onmin/max callback
        if (config.data_onmin || config.data_onmax) {
            var minMax = $$.getMinMaxData();
            callFn(config.data_onmin, $$.api, minMax.min);
            callFn(config.data_onmax, $$.api, minMax.max);
        }
        config.tooltip_show && $$.initShowTooltip();
        state.rendered = true;
    };
    ChartInternal.prototype.initChartElements = function() {
        var $$ = this;
        var _a = $$.state, hasAxis = _a.hasAxis, hasRadar = _a.hasRadar;
        var types = [];
        if (hasAxis) {
            $$.hasType("bar") && types.push("Bar");
            $$.hasType("bubble") && types.push("Bubble");
            $$.hasTypeOf("Line") && types.push("Line");
        } else {
            if (!hasRadar) types.push("Arc", "Pie");
            if ($$.hasType("gauge")) types.push("Gauge");
            else if (hasRadar) types.push("Radar");
        }
        types.forEach(function(v) {
            $$["init".concat(v)]();
        });
        notEmpty($$.config.data_labels) && !$$.hasArcType(null, [
            "radar"
        ]) && $$.initText();
    };
    ChartInternal.prototype.setChartElements = function() {
        var $$ = this;
        var _a = $$.$el, chart = _a.chart, svg = _a.svg, defs = _a.defs, main = _a.main, tooltip = _a.tooltip, legend = _a.legend, title = _a.title, grid = _a.grid, arc = _a.arcs, circles = _a.circle, bars = _a.bar, lines = _a.line, areas = _a.area, texts = _a.text;
        $$.api.$ = {
            chart: chart,
            svg: svg,
            defs: defs,
            main: main,
            tooltip: tooltip,
            legend: legend,
            title: title,
            grid: grid,
            arc: arc,
            circles: circles,
            bar: {
                bars: bars
            },
            line: {
                lines: lines,
                areas: areas
            },
            text: {
                texts: texts
            }
        };
    };
    /**
     * Set background element/image
     * @private
     */ ChartInternal.prototype.setBackground = function() {
        var $$ = this;
        var bg = $$.config.background, state = $$.state, svg = $$.$el.svg;
        if (notEmpty(bg)) {
            var element = svg.select("g").insert(bg.imgUrl ? "image" : "rect", ":first-child");
            if (bg.imgUrl) element.attr("href", bg.imgUrl);
            else if (bg.color) element.style("fill", bg.color).attr("clip-path", state.clip.path);
            element.attr("class", bg["class"] || null).attr("width", "100%").attr("height", "100%");
        }
    };
    /**
     * Update targeted element with given data
     * @param {object} targets Data object formatted as 'target'
     * @private
     */ ChartInternal.prototype.updateTargets = function(targets) {
        var $$ = this;
        var _a = $$.state, hasAxis = _a.hasAxis, hasRadar = _a.hasRadar;
        // Text
        $$.updateTargetsForText(targets);
        if (hasAxis) {
            $$.hasType("bar") && $$.updateTargetsForBar(targets); // Bar
            $$.hasTypeOf("Line") && $$.updateTargetsForLine(targets); // Line
            // Sub Chart
            $$.updateTargetsForSubchart && $$.updateTargetsForSubchart(targets);
        } else // Arc & Radar
        $$.hasArcType(targets) && (hasRadar ? $$.updateTargetsForRadar(targets) : $$.updateTargetsForArc(targets));
        // circle
        if ($$.hasType("bubble") || $$.hasType("scatter")) $$.updateTargetForCircle && $$.updateTargetForCircle();
        // Fade-in each chart
        $$.showTargets();
    };
    /**
     * Display targeted elements
     * @private
     */ ChartInternal.prototype.showTargets = function() {
        var $$ = this;
        var config = $$.config, svg = $$.$el.svg;
        svg.selectAll(".".concat(CLASS.target)).filter(function(d) {
            return $$.isTargetToShow(d.id);
        }).transition().duration(config.transition_duration).style("opacity", "1");
    };
    ChartInternal.prototype.getWithOption = function(options) {
        var withOptions = {
            Y: true,
            Subchart: true,
            Transition: true,
            EventRect: true,
            Dimension: true,
            TrimXDomain: true,
            Transform: false,
            UpdateXDomain: false,
            UpdateOrgXDomain: false,
            Legend: false,
            UpdateXAxis: "UpdateXDomain",
            TransitionForExit: "Transition",
            TransitionForAxis: "Transition"
        };
        Object.keys(withOptions).forEach(function(key) {
            var defVal = withOptions[key];
            if (isString(defVal)) defVal = withOptions[defVal];
            withOptions[key] = getOption(options, "with".concat(key), defVal);
        });
        return withOptions;
    };
    ChartInternal.prototype.initialOpacity = function(d) {
        var $$ = this;
        var withoutFadeIn = $$.state.withoutFadeIn;
        return $$.getBaseValue(d) !== null && withoutFadeIn[d.id] ? "1" : "0";
    };
    ChartInternal.prototype.bindResize = function() {
        var $$ = this;
        var config = $$.config, state = $$.state;
        var resizeFunction = generateResize();
        var list = [];
        list.push(function() {
            return callFn(config.onresize, $$, $$.api);
        });
        if (config.resize_auto) list.push(function() {
            state.resizing = true;
            $$.api.flush(false);
        });
        list.push(function() {
            callFn(config.onresized, $$, $$.api);
            state.resizing = false;
        });
        // add resize functions
        list.forEach(function(v) {
            return resizeFunction.add(v);
        });
        $$.resizeFunction = resizeFunction;
        // attach resize event
        win.addEventListener("resize", $$.resizeFunction = resizeFunction);
    };
    /**
     * Call plugin hook
     * @param {string} phase The lifecycle phase
     * @param {Array} args Arguments
     * @private
     */ ChartInternal.prototype.callPluginHook = function(phase) {
        var _this = this;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        this.config.plugins.forEach(function(v) {
            if (phase === "$beforeInit") {
                v.$$ = _this;
                _this.api.plugins.push(v);
            }
            v[phase].apply(v, args);
        });
    };
    return ChartInternal;
}();
extend(ChartInternal.prototype, [
    // common
    dataConvert,
    data$1,
    dataLoad,
    category,
    classModule,
    color,
    domain,
    interaction,
    format,
    legend$1,
    redraw,
    scale,
    shape,
    size,
    text,
    title,
    tooltip$1,
    transform,
    type
]);
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * Load configuration option
 * @param {object} config User's generation config value
 * @private
 */ function loadConfig(config) {
    var thisConfig = this.config;
    var target;
    var keys;
    var read;
    var find = function() {
        var key = keys.shift();
        if (key && target && isObjectType(target) && key in target) {
            target = target[key];
            return find();
        } else if (!key) return target;
        return undefined;
    };
    Object.keys(thisConfig).forEach(function(key) {
        target = config;
        keys = key.split("_");
        read = find();
        if (isDefined(read)) thisConfig[key] = read;
    });
}
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var apiChart = {
    /**
     * Resize the chart.
     * @function resize
     * @instance
     * @memberof Chart
     * @param {object} size This argument should include width and height in pixels.
     * @param {number} [size.width] width value
     * @param {number} [size.height] height value
     * @example
     * // Resize to 640x480
     * chart.resize({
     *    width: 640,
     *    height: 480
     * });
     */ resize: function(size) {
        var $$ = this.internal;
        var config = $$.config, state = $$.state;
        if (state.rendered) {
            config.size_width = size ? size.width : null;
            config.size_height = size ? size.height : null;
            state.resizing = true;
            this.flush(false, true);
            $$.resizeFunction();
        }
    },
    /**
     * Force to redraw.
     * - **NOTE:** When zoom/subchart is used, the zoomed state will be resetted.
     * @function flush
     * @instance
     * @memberof Chart
     * @param {boolean} [soft] For soft redraw.
     * @example
     * chart.flush();
     *
     * // for soft redraw
     * chart.flush(true);
     */ flush: function(soft) {
        var $$ = this.internal;
        var state = $$.state;
        if (state.rendered) {
            // reset possible zoom scale when is called from resize event
            // eslint-disable-next-line prefer-rest-params
            if (state.resizing) $$.brush && $$.brush.updateResize();
            else // re-update config info
            $$.axis && $$.axis.setOrient();
            $$.scale.zoom = null;
            soft ? $$.redraw({
                withTransform: true,
                withUpdateXDomain: true,
                withUpdateOrgXDomain: true,
                withLegend: true
            }) : $$.updateAndRedraw({
                withLegend: true,
                withTransition: false,
                withTransitionForTransform: false
            });
            // reset subchart selection & selection state
            if (!state.resizing && $$.brush) {
                $$.brush.getSelection().call($$.brush.move);
                $$.unselectRect();
            }
        } else $$.initToRender(true);
    },
    /**
     * Reset the chart object and remove element and events completely.
     * @function destroy
     * @instance
     * @memberof Chart
     * @returns {null}
     * @example
     * chart.destroy();
     */ destroy: function() {
        var _this = this;
        var $$ = this.internal;
        var _a = $$.$el, chart = _a.chart, svg = _a.svg;
        if (notEmpty($$)) {
            $$.callPluginHook("$willDestroy");
            $$.charts.splice($$.charts.indexOf(this), 1);
            // clear timers && pending transition
            svg.select("*").interrupt();
            $$.resizeFunction.clear();
            win.removeEventListener("resize", $$.resizeFunction);
            chart.classed("bb", false).html("");
            // releasing own references
            Object.keys(this).forEach(function(key) {
                key === "internal" && Object.keys($$).forEach(function(k) {
                    $$[k] = null;
                });
                _this[key] = null;
                delete _this[key];
            });
            // release prototype chains
            for(var key in this)this[key] = function() {};
        }
        return null;
    },
    /**
     * Get or set single config option value.
     * @function config
     * @instance
     * @memberof Chart
     * @param {string} name The option key name.
     * @param {*} [value] The value accepted for indicated option.
     * @param {boolean} [redraw] Set to redraw with the new option changes.
     * - **NOTE:** Doesn't guarantee work in all circumstances. It can be applied for limited options only.
     * @returns {*}
     * @example
     * // Getter
     * chart.config("gauge.max");
     *
     * // Setter
     * chart.config("gauge.max", 100);
     *
     * // Setter & redraw with the new option
     * chart.config("gauge.max", 100, true);
     */ config: function(name, value, redraw) {
        var $$ = this.internal;
        var config = $$.config;
        var key = name && name.replace(/\./g, "_");
        var res;
        if (key in config) {
            if (isDefined(value)) {
                config[key] = value;
                res = value;
                redraw && this.flush();
            } else res = config[key];
        }
        return res;
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var apiColor = {
    /**
     * Get the color
     * @function color
     * @instance
     * @memberof Chart
     * @param {string} id id to get the color
     * @returns {string}
     * @example
     * chart.color("data1");
     */ color: function(id) {
        return this.internal.color(id); // more patterns
    }
};
/**
 * Get data loaded in the chart.
 * @function data
 * @instance
 * @memberof Chart
 * @param {string|Array} targetIds If this argument is given, this API returns the specified target data. If this argument is not given, all of data will be returned.
 * @returns {Array} Data objects
 * @example
 * // Get only data1 data
 * chart.data("data1");
 * // --> [{id: "data1", id_org: "data1", values: Array(6)}, ...]
 *
 * // Get data1 and data2 data
 * chart.data(["data1", "data2"]);
 *
 * // Get all data
 * chart.data();
 */ function data(targetIds) {
    var targets = this.internal.data.targets;
    if (!isUndefined(targetIds)) {
        var ids_1 = isArray(targetIds) ? targetIds : [
            targetIds
        ];
        return targets.filter(function(t) {
            return ids_1.some(function(v) {
                return v === t.id;
            });
        });
    }
    return targets;
}
extend(data, {
    /**
     * Get data shown in the chart.
     * @function data․shown
     * @instance
     * @memberof Chart
     * @param {string|Array} targetIds If this argument is given, this API filters the data with specified target ids. If this argument is not given, all shown data will be returned.
     * @returns {Array} Data objects
     * @example
     * // Get shown data by filtering to include only data1 data
     * chart.data.shown("data1");
     * // --> [{id: "data1", id_org: "data1", values: Array(6)}, ...]
     *
     * // Get shown data by filtering to include data1 and data2 data
     * chart.data.shown(["data1", "data2"]);
     *
     * // Get all shown data
     * chart.data.shown();
     */ shown: function(targetIds) {
        return this.internal.filterTargetsToShow(this.data(targetIds));
    },
    /**
     * Get values of the data loaded in the chart.
     * @function data․values
     * @instance
     * @memberof Chart
     * @param {string|Array|null} targetIds This API returns the values of specified target. If this argument is not given, null will be retruned
     * @param {boolean} [flat=true] Get flatten values
     * @returns {Array} Data values
     * @example
     * // Get data1 values
     * chart.data.values("data1");
     * // --> [10, 20, 30, 40]
     */ values: function(targetIds, flat) {
        if (flat === void 0) flat = true;
        var values = null;
        if (targetIds) {
            var targets = this.data(targetIds);
            if (targets && isArray(targets)) {
                values = [];
                targets.forEach(function(v) {
                    var dataValue = v.values.map(function(d) {
                        return d.value;
                    });
                    flat ? values = values.concat(dataValue) : values.push(dataValue);
                });
            }
        }
        return values;
    },
    /**
     * Get and set names of the data loaded in the chart.
     * @function data․names
     * @instance
     * @memberof Chart
     * @param {object} names If this argument is given, the names of data will be updated. If not given, the current names will be returned. The format of this argument is the same as
     * @returns {object} Corresponding names according its key value, if specified names values.
     * @example
     * // Get current names
     * chart.data.names();
     * // --> {data1: "test1", data2: "test2"}
     *
     * // Update names
     * chart.data.names({
     *  data1: "New Name 1",
     *  data2: "New Name 2"
     *});
     */ names: function(names) {
        var $$ = this.internal;
        return $$.updateDataAttributes("names", names);
    },
    /**
     * Get and set colors of the data loaded in the chart.
     * @function data․colors
     * @instance
     * @memberof Chart
     * @param {object} colors If this argument is given, the colors of data will be updated. If not given, the current colors will be returned. The format of this argument is the same as [data.colors](./Options.html#.data%25E2%2580%25A4colors).
     * @returns {object} Corresponding data color value according its key value.
     * @example
     * // Get current colors
     * chart.data.colors();
     * // --> {data1: "#00c73c", data2: "#fa7171"}
     *
     * // Update colors
     * chart.data.colors({
     *  data1: "#FFFFFF",
     *  data2: "#000000"
     * });
     */ colors: function(colors) {
        return this.internal.updateDataAttributes("colors", colors);
    },
    /**
     * Get and set axes of the data loaded in the chart.
     * - **NOTE:** If all data is related to one of the axes, the domain of axis without related data will be replaced by the domain from the axis with related data
     * @function data․axes
     * @instance
     * @memberof Chart
     * @param {object} axes If this argument is given, the axes of data will be updated. If not given, the current axes will be returned. The format of this argument is the same as
     * @returns {object} Corresponding axes value for data, if specified axes value.
     * @example
     * // Get current axes
     * chart.data.axes();
     * // --> {data1: "y"}
     *
     * // Update axes
     * chart.data.axes({
     *  data1: "y",
     *  data2: "y2"
     * });
     */ axes: function(axes) {
        return this.internal.updateDataAttributes("axes", axes);
    },
    /**
     * Get the minimum data value bound to the chart
     * @function data․min
     * @instance
     * @memberof Chart
     * @returns {Array} Data objects
     * @example
     * // Get current axes
     * chart.data.min();
     * // --> [{x: 0, value: 30, id: "data1", index: 0}, ...]
     */ min: function() {
        return this.internal.getMinMaxData().min;
    },
    /**
     * Get the maximum data value bound to the chart
     * @function data․max
     * @instance
     * @memberof Chart
     * @returns {Array} Data objects
     * @example
     * // Get current axes
     * chart.data.max();
     * // --> [{x: 3, value: 400, id: "data1", index: 3}, ...]
     */ max: function() {
        return this.internal.getMinMaxData().max;
    }
});
var apiData = {
    data: data
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * Encode to base64
 * @param {string} str string to be encoded
 * @returns {string}
 * @private
 * @see https://developer.mozilla.org/ko/docs/Web/API/WindowBase64/Base64_encoding_and_decoding
 */ var b64EncodeUnicode = function(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p) {
        return String.fromCharCode(Number("0x".concat(p)));
    }));
};
/**
 * Convert svg node to data url
 * @param {HTMLElement} node target node
 * @param {object} size object containing {width, height}
 * @returns {string}
 * @private
 */ function nodeToSvgDataUrl(node, size) {
    var serializer = new XMLSerializer();
    var clone = node.cloneNode(true);
    var cssText = getCssRules(toArray(doc.styleSheets)).filter(function(r) {
        return r.cssText;
    }).map(function(r) {
        return r.cssText;
    });
    clone.setAttribute("xmlns", (0, $7cQXC.default).xhtml);
    var nodeXml = serializer.serializeToString(clone);
    // escape css for XML
    var style = doc.createElement("style");
    style.appendChild(doc.createTextNode(cssText.join("\n")));
    var styleXml = serializer.serializeToString(style);
    // foreignObject not supported in IE11 and below
    // https://msdn.microsoft.com/en-us/library/hh834675(v=vs.85).aspx
    var dataStr = '<svg xmlns="'.concat((0, $7cQXC.default).svg, '" width="').concat(size.width, '" height="').concat(size.height, '">\n			<foreignObject width="100%" height="100%">\n				').concat(styleXml, "\n				").concat(nodeXml.replace(/(url\()[^#]+/g, "$1"), "\n			</foreignObject></svg>").replace("/\n/g", "%0A");
    return "data:image/svg+xml;base64,".concat(b64EncodeUnicode(dataStr));
}
var apiExport = {
    /**
     * Export chart as an image.
     * - **NOTE:**
     *   - IE11 and below not work properly due to the lack of the feature(<a href="https://msdn.microsoft.com/en-us/library/hh834675(v=vs.85).aspx">foreignObject</a>) support
     *   - The basic CSS file(ex. billboard.css) should be at same domain as API call context to get correct styled export image.
     * @function export
     * @instance
     * @memberof Chart
     * @param {string} [mimeType=image/png] The desired output image format. (ex. 'image/png' for png, 'image/jpeg' for jpeg format)
     * @param {Function} [callback] The callback to be invoked when export is ready.
     * @returns {string} dataURI
     * @example
     *  chart.export();
     *  // --> "data:image/svg+xml;base64,PHN..."
     *
     *  // Initialize the download automatically
     *  chart.export("image/png", dataUrl => {
     *     const link = document.createElement("a");
     *
     *     link.download = `${Date.now()}.png`;
     *     link.href = dataUrl;
     *     link.innerHTML = "Download chart as image";
     *
     *     document.body.appendChild(link);
     *  });
     */ "export": function(mimeType, callback) {
        var _this = this;
        var $$ = this.internal;
        var state = $$.state, chart = $$.$el.chart;
        var _a = state.current, width = _a.width, height = _a.height;
        var svgDataUrl = nodeToSvgDataUrl(chart.node(), {
            width: width,
            height: height
        });
        if (callback && isFunction(callback)) {
            var img_1 = new Image();
            img_1.crossOrigin = "Anonymous";
            img_1.onload = function() {
                var canvas = doc.createElement("canvas");
                var ctx = canvas.getContext("2d");
                canvas.width = width;
                canvas.height = height;
                ctx.drawImage(img_1, 0, 0);
                callback.bind(_this)(canvas.toDataURL(mimeType));
            };
            img_1.src = svgDataUrl;
        }
        return svgDataUrl;
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var apiFocus = {
    /**
     * This API highlights specified targets and fade out the others.<br><br>
     * You can specify multiple targets by giving an array that includes id as String. If no argument is given, all of targets will be highlighted.
     * @function focus
     * @instance
     * @memberof Chart
     * @param {string|Array} targetIdsValue Target ids to be highlighted.
     * @example
     *  // data1 will be highlighted and the others will be faded out
     *  chart.focus("data1");
     *
     * // data1 and data2 will be highlighted and the others will be faded out
     * chart.focus(["data1", "data2"]);
     *
     * // all targets will be highlighted
     * chart.focus();
     */ focus: function(targetIdsValue) {
        var $$ = this.internal;
        var state = $$.state;
        var targetIds = $$.mapToTargetIds(targetIdsValue);
        var candidates = $$.$el.svg.selectAll($$.selectorTargets(targetIds.filter($$.isTargetToShow, $$)));
        this.revert();
        this.defocus();
        candidates.classed(CLASS.focused, true).classed(CLASS.defocused, false);
        if ($$.hasArcType() && !state.hasRadar) {
            $$.expandArc(targetIds);
            $$.hasType("gauge") && $$.markOverlapped(targetIdsValue, $$, ".".concat(CLASS.gaugeValue));
        }
        $$.toggleFocusLegend(targetIds, true);
        state.focusedTargetIds = targetIds;
        state.defocusedTargetIds = state.defocusedTargetIds.filter(function(id) {
            return targetIds.indexOf(id) < 0;
        });
    },
    /**
     * This API fades out specified targets and reverts the others.<br><br>
     * You can specify multiple targets by giving an array that includes id as String. If no argument is given, all of targets will be faded out.
     * @function defocus
     * @instance
     * @memberof Chart
     * @param {string|Array} targetIdsValue Target ids to be faded out.
     * @example
     * // data1 will be faded out and the others will be reverted.
     * chart.defocus("data1");
     *
     * // data1 and data2 will be faded out and the others will be reverted.
     * chart.defocus(["data1", "data2"]);
     *
     * // all targets will be faded out.
     * chart.defocus();
     */ defocus: function(targetIdsValue) {
        var $$ = this.internal;
        var state = $$.state;
        var targetIds = $$.mapToTargetIds(targetIdsValue);
        var candidates = $$.$el.svg.selectAll($$.selectorTargets(targetIds.filter($$.isTargetToShow, $$)));
        candidates.classed(CLASS.focused, false).classed(CLASS.defocused, true);
        if ($$.hasArcType()) {
            $$.unexpandArc(targetIds);
            $$.hasType("gauge") && $$.undoMarkOverlapped($$, ".".concat(CLASS.gaugeValue));
        }
        $$.toggleFocusLegend(targetIds, false);
        state.focusedTargetIds = state.focusedTargetIds.filter(function(id) {
            return targetIds.indexOf(id) < 0;
        });
        state.defocusedTargetIds = targetIds;
    },
    /**
     * This API reverts specified targets.<br><br>
     * You can specify multiple targets by giving an array that includes id as String. If no argument is given, all of targets will be reverted.
     * @function revert
     * @instance
     * @memberof Chart
     * @param {string|Array} targetIdsValue Target ids to be reverted
     * @example
     * // data1 will be reverted.
     * chart.revert("data1");
     *
     * // data1 and data2 will be reverted.
     * chart.revert(["data1", "data2"]);
     *
     * // all targets will be reverted.
     * chart.revert();
     */ revert: function(targetIdsValue) {
        var $$ = this.internal;
        var config = $$.config, state = $$.state, $el = $$.$el;
        var targetIds = $$.mapToTargetIds(targetIdsValue);
        var candidates = $el.svg.selectAll($$.selectorTargets(targetIds)); // should be for all targets
        candidates.classed(CLASS.focused, false).classed(CLASS.defocused, false);
        $$.hasArcType() && $$.unexpandArc(targetIds);
        if (config.legend_show) {
            $$.showLegend(targetIds.filter($$.isLegendToShow.bind($$)));
            $el.legend.selectAll($$.selectorLegends(targetIds)).filter(function() {
                return (0, $hOxpW.default)(this).classed(CLASS.legendItemFocused);
            }).classed(CLASS.legendItemFocused, false);
        }
        state.focusedTargetIds = [];
        state.defocusedTargetIds = [];
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * Define legend
 * @ignore
 */ var legend = {
    /**
     * Show legend for each target.
     * @function legend․show
     * @instance
     * @memberof Chart
     * @param {string|Array} targetIds
     * - If targetIds is given, specified target's legend will be shown.
     * - If only one target is the candidate, String can be passed.
     * - If no argument is given, all of target's legend will be shown.
     * @example
     * // Show legend for data1.
     * chart.legend.show("data1");
     *
     * // Show legend for data1 and data2.
     * chart.legend.show(["data1", "data2"]);
     *
     * // Show all legend.
     * chart.legend.show();
     */ show: function(targetIds) {
        var $$ = this.internal;
        $$.showLegend($$.mapToTargetIds(targetIds));
        $$.updateAndRedraw({
            withLegend: true
        });
    },
    /**
     * Hide legend for each target.
     * @function legend․hide
     * @instance
     * @memberof Chart
     * @param {string|Array} targetIds
     * - If targetIds is given, specified target's legend will be hidden.
     * - If only one target is the candidate, String can be passed.
     * - If no argument is given, all of target's legend will be hidden.
     * @example
     * // Hide legend for data1.
     * chart.legend.hide("data1");
     *
     * // Hide legend for data1 and data2.
     * chart.legend.hide(["data1", "data2"]);
     *
     * // Hide all legend.
     * chart.legend.hide();
     */ hide: function(targetIds) {
        var $$ = this.internal;
        $$.hideLegend($$.mapToTargetIds(targetIds));
        $$.updateAndRedraw({
            withLegend: true
        });
    }
};
var apiLegend = {
    legend: legend
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var apiLoad = {
    /**
     * Load data to the chart.<br><br>
     * You can specify multiple targets by giving an array that includes id as String. If no argument is given, all of targets will be toggles.
     * - <b>Note:</b>
     *   - unload should be used if some data needs to be unloaded simultaneously.
     *     If you call unload API soon after/before load instead of unload param, chart will not be rendered properly because of cancel of animation.<br>
     *   - done will be called after data loaded, but it's not after rendering.
     *     It's because rendering will finish after some transition and there is some time lag between loading and rendering
     * @function load
     * @instance
     * @memberof Chart
     * @param {object} args The object can consist with following members:<br>
     *
     *    | Key | Description |
     *    | --- | --- |
     *    | - url<br>- json<br>- rows<br>- columns | The data will be loaded. If data that has the same target id is given, the chart will be updated. Otherwise, new target will be added |
     *    | data | Data objects to be loaded. Checkout the example. |
     *    | names | Same as data.names() |
     *    | xs | Same as data.xs option  |
     *    | classes | The classes specified by data.classes will be updated. classes must be Object that has target id as keys. |
     *    | categories | The categories specified by axis.x.categories or data.x will be updated. categories must be Array. |
     *    | axes | The axes specified by data.axes will be updated. axes must be Object that has target id as keys. |
     *    | colors | The colors specified by data.colors will be updated. colors must be Object that has target id as keys. |
     *    | headers |  Set request header if loading via `data.url`.<br>@see [data․headers](Options.html#.data%25E2%2580%25A4headers) |
     *    | keys |  Choose which JSON objects keys correspond to desired data.<br>**NOTE:** Only for JSON object given as array.<br>@see [data․keys](Options.html#.data%25E2%2580%25A4keys) |
     *    | mimeType |  Set 'json' if loading JSON via url.<br>@see [data․mimeType](Options.html#.data%25E2%2580%25A4mimeType) |
     *    | - type<br>- types | The type of targets will be updated. type must be String and types must be Object. |
     *    | unload | Specify the data will be unloaded before loading new data. If true given, all of data will be unloaded. If target ids given as String or Array, specified targets will be unloaded. If absent or false given, unload will not occur. |
     *    | done | The specified function will be called after data loaded.|
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Data.DataFromURL)
     * @example
     * // Load data1 and unload data2 and data3
     * chart.load({
     *     columns: [
     *        ["data1", 100, 200, 150, ...],
     *        ...
     *    ],
     *    unload: ["data2", "data3"],
     *    url: "...",
     *    done: function() { ... }
     * });
     * @example
     * // myAPI.json
     * // {
     * //   "data1": [220, 240, 270, 250, 280],
     * //   "data2": [180, 150, 300, 70, 120]
     * // }
     *
     * chart.load({
     *     url: './data/myAPI.json',
     *     mimeType: "json",
     *
     *     // set request header if is needed
     *     headers: {
     *       "Content-Type": "text/json"
     *     }
     * });
     * @example
     * chart.load({
     *     data: [
     *       // equivalent as: columns: [["data1", 30, 200, 100]]
     *       {"data1": 30}, {"data1": 200}, {"data1": 100}
     *
     *       // or
     *       // equivalent as: columns: [["data1", 10, 20], ["data2", 13, 30]]
     *       // {"data1": 10, "data2": 13}, {"data1": 20, "data2": 30}}
     *     ]
     * });
     * @example
     * chart.load({
     *     json: [
     *          {name: "www.site1.com", upload: 800, download: 500, total: 400},
     *     ],
     *     keys: {
     *         x: "name",
     *         value: ["upload", "download"]
     *     }
     * });
     */ load: function(args) {
        var $$ = this.internal;
        var config = $$.config;
        // update xs if specified
        args.xs && $$.addXs(args.xs);
        // update names if exists
        "names" in args && this.data.names(args.names);
        // update classes if exists
        "classes" in args && Object.keys(args.classes).forEach(function(id) {
            config.data_classes[id] = args.classes[id];
        });
        // update categories if exists
        if ("categories" in args && $$.axis.isCategorized()) config.axis_x_categories = args.categories;
        // update axes if exists
        "axes" in args && Object.keys(args.axes).forEach(function(id) {
            config.data_axes[id] = args.axes[id];
        });
        // update colors if exists
        "colors" in args && Object.keys(args.colors).forEach(function(id) {
            config.data_colors[id] = args.colors[id];
        });
        // unload if needed
        if ("unload" in args && args.unload !== false) // TODO: do not unload if target will load (included in url/rows/columns)
        $$.unload($$.mapToTargetIds(args.unload === true ? null : args.unload), function() {
            return $$.loadFromArgs(args);
        });
        else $$.loadFromArgs(args);
    },
    /**
     * Unload data to the chart.<br><br>
     * You can specify multiple targets by giving an array that includes id as String. If no argument is given, all of targets will be toggles.
     * - <b>Note:</b>
     * If you call load API soon after/before unload, unload param of load should be used. Otherwise chart will not be rendered properly because of cancel of animation.<br>
     * `done` will be called after data loaded, but it's not after rendering. It's because rendering will finish after some transition and there is some time lag between loading and rendering.
     * @function unload
     * @instance
     * @memberof Chart
     * @param {object} argsValue
     *  | key | Type | Description |
     *  | --- | --- | --- |
     *  | ids | String &vert; Array | Target id data to be unloaded. If not given, all data will be unloaded. |
     *  | done | Fuction | Callback after data is unloaded. |
     * @example
     *  // Unload data2 and data3
     *  chart.unload({
     *    ids: ["data2", "data3"],
     *    done: function() {
     *       // called after the unloaded
     *    }
     *  });
     */ unload: function(argsValue) {
        var _this = this;
        var $$ = this.internal;
        var args = argsValue || {};
        if (isArray(args)) args = {
            ids: args
        };
        else if (isString(args)) args = {
            ids: [
                args
            ]
        };
        var ids = $$.mapToTargetIds(args.ids);
        $$.unload(ids, function() {
            $$.redraw({
                withUpdateOrgXDomain: true,
                withUpdateXDomain: true,
                withLegend: true
            });
            $$.cache.remove(ids);
            args.done && args.done.call(_this);
        });
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * Show/Hide data series
 * @param {boolean} show Show or hide
 * @param {Array} targetIdsValue Target id values
 * @param {object} options Options
 * @private
 */ function showHide(show, targetIdsValue, options) {
    var $$ = this.internal;
    var targetIds = $$.mapToTargetIds(targetIdsValue);
    $$.state.toggling = true;
    $$["".concat(show ? "remove" : "add", "HiddenTargetIds")](targetIds);
    var targets = $$.$el.svg.selectAll($$.selectorTargets(targetIds));
    var opacity = show ? "1" : "0";
    show && targets.style("display", null);
    targets.transition().style("opacity", opacity, "important").call(endall, function() {
        // https://github.com/naver/billboard.js/issues/1758
        !show && targets.style("display", "none");
        targets.style("opacity", opacity);
    });
    options.withLegend && $$["".concat(show ? "show" : "hide", "Legend")](targetIds);
    $$.redraw({
        withUpdateOrgXDomain: true,
        withUpdateXDomain: true,
        withLegend: true
    });
    $$.state.toggling = false;
}
var apiShow = {
    /**
     * Show data series on chart
     * @function show
     * @instance
     * @memberof Chart
     * @param {string|Array} [targetIdsValue] The target id value.
     * @param {object} [options] The object can consist with following members:<br>
     *
     *    | Key | Type | default | Description |
     *    | --- | --- | --- | --- |
     *    | withLegend | boolean | false | whether or not display legend |
     *
     * @example
     * // show 'data1'
     * chart.show("data1");
     *
     * // show 'data1' and 'data3'
     * chart.show(["data1", "data3"]);
     */ show: function(targetIdsValue, options) {
        if (options === void 0) options = {};
        showHide.call(this, true, targetIdsValue, options);
    },
    /**
     * Hide data series from chart
     * @function hide
     * @instance
     * @memberof Chart
     * @param {string|Array} [targetIdsValue] The target id value.
     * @param {object} [options] The object can consist with following members:<br>
     *
     *    | Key | Type | default | Description |
     *    | --- | --- | --- | --- |
     *    | withLegend | boolean | false | whether or not display legend |
     *
     * @example
     * // hide 'data1'
     * chart.hide("data1");
     *
     * // hide 'data1' and 'data3'
     * chart.hide(["data1", "data3"]);
     */ hide: function(targetIdsValue, options) {
        if (options === void 0) options = {};
        showHide.call(this, false, targetIdsValue, options);
    },
    /**
     * Toggle data series on chart. When target data is hidden, it will show. If is shown, it will hide in vice versa.
     * @function toggle
     * @instance
     * @memberof Chart
     * @param {string|Array} [targetIds] The target id value.
     * @param {object} [options] The object can consist with following members:<br>
     *
     *    | Key | Type | default | Description |
     *    | --- | --- | --- | --- |
     *    | withLegend | boolean | false | whether or not display legend |
     *
     * @example
     * // toggle 'data1'
     * chart.toggle("data1");
     *
     * // toggle 'data1' and 'data3'
     * chart.toggle(["data1", "data3"]);
     */ toggle: function(targetIds, options) {
        var _this = this;
        if (options === void 0) options = {};
        var $$ = this.internal;
        var targets = {
            show: [],
            hide: []
        };
        // sort show & hide target ids
        $$.mapToTargetIds(targetIds).forEach(function(id) {
            return targets[$$.isTargetToShow(id) ? "hide" : "show"].push(id);
        });
        // perform show & hide task separately
        // https://github.com/naver/billboard.js/issues/454
        targets.show.length && this.show(targets.show, options);
        targets.hide.length && setTimeout(function() {
            return _this.hide(targets.hide, options);
        }, 0);
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * Define tooltip
 * @ignore
 */ var tooltip = {
    /**
     * Show tooltip
     * @function tooltip․show
     * @instance
     * @memberof Chart
     * @param {object} args The object can consist with following members:<br>
     *
     *    | Key | Type | Description |
     *    | --- | --- | --- |
     *    | index | Number | Determine focus by index |
     *    | x | Number &vert; Date | Determine focus by x Axis index |
     *    | mouse | Array | Determine x and y coordinate value relative the targeted '.bb-event-rect' x Axis.<br>It should be used along with `data`, `index` or `x` value. The default value is set as `[0,0]` |
     *    | data | Object | When [data.xs](Options.html#.data%25E2%2580%25A4xs) option is used or [tooltip.grouped](Options.html#.tooltip) set to 'false', `should be used giving this param`.<br><br>**Key:**<br>- x {number &verbar; Date}: x Axis value<br>- index {number}: x Axis index (useless for data.xs)<br>- id {string}: data id<br>- value {number}: The corresponding value for tooltip. |
     *
     * @example
     *  // show the 2nd x Axis coordinate tooltip
     *  // for Arc(gauge, donut & pie) and radar type, approch showing tooltip by using "index" number.
     *  chart.tooltip.show({
     *    index: 1
     *  });
     *
     *  // show tooltip for the 3rd x Axis in x:50 and y:100 coordinate of '.bb-event-rect' of the x Axis.
     *  chart.tooltip.show({
     *    x: 2,
     *    mouse: [50, 100]
     *  });
     *
     *  // show tooltip for timeseries x axis
     *  chart.tooltip.show({
     *    x: new Date("2018-01-02 00:00")
     *  });
     *
     *  // when data.xs is used
     *  chart.tooltip.show({
     *    data: {
     *        x: 3,  // x Axis value
     *        id: "data1",  // data id
     *        value: 500  // data value
     *    }
     *  });
     *
     *  // when data.xs isn't used, but tooltip.grouped=false is set
     *  chart.tooltip.show({
     *    data: {
     *        index: 3,  // or 'x' key value
     *        id: "data1",  // data id
     *        value: 500  // data value
     *    }
     *  });
     */ show: function(args) {
        var $$ = this.internal;
        var config = $$.config, inputType = $$.state.inputType;
        var index;
        var mouse;
        // determine mouse position on the chart
        if (args.mouse) mouse = args.mouse;
        // determine focus data
        if (args.data) {
            var data = args.data;
            var y = $$.getYScaleById(data.id)(data.value);
            if ($$.isMultipleX()) // if multiple xs, target point will be determined by mouse
            mouse = [
                $$.scale.x(data.x),
                y
            ];
            else {
                if (!config.tooltip_grouped) mouse = [
                    0,
                    y
                ];
                index = isValue(data.index) ? data.index : $$.getIndexByX(data.x);
            }
        } else if (isDefined(args.x)) index = $$.getIndexByX(args.x);
        else if (isDefined(args.index)) index = args.index;
        (inputType === "mouse" ? [
            "mouseover",
            "mousemove"
        ] : [
            "touchstart"
        ]).forEach(function(eventName) {
            $$.dispatchEvent(eventName, index, mouse);
        });
    },
    /**
     * Hide tooltip
     * @function tooltip․hide
     * @instance
     * @memberof Chart
     */ hide: function() {
        var $$ = this.internal;
        var inputType = $$.state.inputType, tooltip = $$.$el.tooltip;
        var data = tooltip && tooltip.datum();
        if (data) {
            var index_1 = JSON.parse(data.current)[0].index;
            // make to finalize, possible pending event flow set from '.tooltip.show()' call
            (inputType === "mouse" ? [
                "mouseout"
            ] : [
                "touchend"
            ]).forEach(function(eventName) {
                $$.dispatchEvent(eventName, index_1);
            });
        }
        // reset last touch point index
        inputType === "touch" && $$.callOverOutForTouch();
        $$.hideTooltip(true);
        $$.hideGridFocus();
        $$.unexpandCircles && $$.unexpandCircles();
        $$.unexpandBars && $$.unexpandBars();
    }
};
var apiTooltip = {
    tooltip: tooltip
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * Main chart class.
 * - Note: Instantiated via `bb.generate()`.
 * @class Chart
 * @example
 * var chart = bb.generate({
 *  data: {
 *    columns: [
 *        ["x", "2015-11-02", "2015-12-01", "2016-01-01", "2016-02-01", "2016-03-01"],
 *        ["count1", 11, 8, 7, 6, 5 ],
 *        ["count2", 9, 3, 6, 2, 8 ]
 *   ]}
 * }
 * @see {@link bb.generate} for the initialization.
 */ /**
 * Access instance's primary node elements
 * @member {object} $
 * @property {object} $ Access instance's primary node elements
 * @property {d3.selection} $.chart Wrapper element
 * @property {d3.selection} $.svg Main svg element
 * @property {d3.selection} $.defs Definition element
 * @property {d3.selection} $.main Main grouping element
 * @property {d3.selection} $.tooltip Tooltip element
 * @property {d3.selection} $.legend Legend element
 * @property {d3.selection} $.title Title element
 * @property {d3.selection} $.grid Grid element
 * @property {d3.selection} $.arc Arc element
 * @property {d3.selection} $.circles Data point circle elements
 * @property {object} $.bar Bar element object
 * @property {d3.selection} $.bar.bars Bar elements
 * @property {object} $.line Line element object
 * @property {d3.selection} $.line.lines Line elements
 * @property {d3.selection} $.line.areas Areas elements
 * @property {object} $.text Text element object
 * @property {d3.selection} $.text.texts Data label text elements
 * @memberof Chart
 * @example
 * var chart = bb.generate({ ... });
 *
 * chart.$.chart; // wrapper element
 * chart.$.line.circles;  // all data point circle elements
 */ /**
 * Plugin instance array
 * @member {Array} plugins
 * @memberof Chart
 * @example
 *  var chart = bb.generate({
 *     ...
 *     plugins: [
 *        new bb.plugin.stanford({ ... }),
 *        new PluginA()
 *     ]
 *  });
 *
 *  chart.plugins; // [Stanford, PluginA] - instance array
 */ var Chart = /** @class */ function() {
    function Chart(options) {
        this.plugins = [];
        var $$ = new ChartInternal(this);
        this.internal = $$;
        // bind to namespaced APIs
        (function bindThis(fn, target, argThis) {
            Object.keys(fn).forEach(function(key) {
                var isFunc = isFunction(fn[key]);
                var isChild = target !== argThis;
                var hasChild = Object.keys(fn[key]).length > 0;
                if (isFunc && (!isChild && hasChild || isChild)) target[key] = fn[key].bind(argThis);
                else if (!isFunc) target[key] = {};
                hasChild && bindThis(fn[key], target[key], argThis);
            });
        })(Chart.prototype, this, this);
        loadConfig.call($$, options);
        $$.beforeInit();
        $$.init();
    }
    return Chart;
}();
// extend common APIs as part of Chart class
extend(Chart.prototype, [
    apiChart,
    apiColor,
    apiData,
    apiExport,
    apiFocus,
    apiLegend,
    apiLoad,
    apiShow,
    apiTooltip
]);
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * Set the min/max value
 * @param {Chart} $$ Chart instance
 * @param {string} type Set type 'min' or 'max'
 * @param {object} value Value to be set
 * @private
 */ function setMinMax($$, type, value) {
    var config = $$.config;
    var axisX = "axis_x_".concat(type);
    var axisY = "axis_y_".concat(type);
    var axisY2 = "axis_y2_".concat(type);
    if (isDefined(value)) {
        if (isObjectType(value)) {
            isValue(value.x) && (config[axisX] = value.x);
            isValue(value.y) && (config[axisY] = value.y);
            isValue(value.y2) && (config[axisY2] = value.y2);
        } else {
            config[axisY] = value;
            config[axisY2] = value;
        }
        $$.redraw({
            withUpdateOrgXDomain: true,
            withUpdateXDomain: true
        });
    }
}
/**
 * Get the min/max value
 * @param {Chart} $$ Chart instance
 * @param {string} type Set type 'min' or 'max'
 * @returns {{x, y, y2}}
 * @private
 */ function getMinMax($$, type) {
    var config = $$.config;
    return {
        x: config["axis_x_".concat(type)],
        y: config["axis_y_".concat(type)],
        y2: config["axis_y2_".concat(type)]
    };
}
/**
 * Define axis
 * @ignore
 */ var axis$1 = {
    /**
     * Get and set axis labels.
     * @function axis․labels
     * @instance
     * @memberof Chart
     * @param {object} labels specified axis' label to be updated.
     * @param {string} [labels.x] x Axis string
     * @param {string} [labels.y] y Axis string
     * @param {string} [labels.y2] y2 Axis string
     * @returns {object|undefined} axis labels text object
     * @example
     * // Update axis' label
     * chart.axis.labels({
     *   x: "New X Axis Label",
     *   y: "New Y Axis Label",
     *   y2: "New Y2 Axis Label"
     * });
     *
     * chart.axis.labels();
     * // --> {
     * //  x: "New X Axis Label",
     * //  y: "New Y Axis Label",
     * //  y2: "New Y2 Axis Label"
     * // }
     */ labels: function(labels) {
        var $$ = this.internal;
        var labelText;
        if (labels) {
            Object.keys(labels).forEach(function(axisId) {
                $$.axis.setLabelText(axisId, labels[axisId]);
            });
            $$.axis.updateLabels();
        }
        [
            "x",
            "y",
            "y2"
        ].forEach(function(v) {
            var text = $$.axis.getLabelText(v);
            if (text) {
                !labelText && (labelText = {});
                labelText[v] = text;
            }
        });
        return labelText;
    },
    /**
     * Get and set axis min value.
     * @function axis․min
     * @instance
     * @memberof Chart
     * @param {object} min If min is given, specified axis' min value will be updated.<br>
     *     If no argument is given, the min values set on generating option for each axis will be returned.
     *     If not set any min values on generation, it will return `undefined`.
     * @returns {object|undefined}
     * @example
     * // Update axis' min
     * chart.axis.min({
     *   x: -10,
     *   y: 1000,
     *   y2: 100
     * });
     */ min: function(min) {
        var $$ = this.internal;
        return isValue(min) ? setMinMax($$, "min", min) : getMinMax($$, "min");
    },
    /**
     * Get and set axis max value.
     * @function axis․max
     * @instance
     * @memberof Chart
     * @param {object} max If max is given, specified axis' max value will be updated.<br>
     *     If no argument is given, the max values set on generating option for each axis will be returned.
     *     If not set any max values on generation, it will return `undefined`.
     * @returns {object|undefined}
     * @example
     * // Update axis' label
     * chart.axis.max({
     *    x: 100,
     *    y: 1000,
     *    y2: 10000
     * });
     */ max: function(max) {
        var $$ = this.internal;
        return arguments.length ? setMinMax($$, "max", max) : getMinMax($$, "max");
    },
    /**
     * Get and set axis min and max value.
     * @function axis․range
     * @instance
     * @memberof Chart
     * @param {object} range If range is given, specified axis' min and max value will be updated. If no argument is given, the current min and max values for each axis will be returned.
     * @returns {object|undefined}
     * @example
     * // Update axis' label
     * chart.axis.range({
     *   min: {
     *     x: -10,
     *     y: -1000,
     *     y2: -10000
     *   },
     *   max: {
     *     x: 100,
     *     y: 1000,
     *     y2: 10000
     *   },
     * });
     */ range: function(range) {
        var axis = this.axis;
        if (arguments.length) {
            isDefined(range.max) && axis.max(range.max);
            isDefined(range.min) && axis.min(range.min);
        } else return {
            max: axis.max(),
            min: axis.min()
        };
        return undefined;
    }
};
var apiAxis = {
    axis: axis$1
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var apiCategory = {
    /**
     * Set specified category name on category axis.
     * @function category
     * @instance
     * @memberof Chart
     * @param {number} i index of category to be changed
     * @param {string} category category value to be changed
     * @returns {string}
     * @example
     * chart.category(2, "Category 3");
     */ category: function(i, category) {
        var $$ = this.internal;
        var config = $$.config;
        if (arguments.length > 1) {
            config.axis_x_categories[i] = category;
            $$.redraw();
        }
        return config.axis_x_categories[i];
    },
    /**
     * Set category names on category axis.
     * @function categories
     * @instance
     * @memberof Chart
     * @param {Array} categories This must be an array that includes category names in string. If category names are included in the date by data.x option, this is not required.
     * @returns {Array}
     * @example
     * chart.categories([
     *      "Category 1", "Category 2", ...
     * ]);
     */ categories: function(categories) {
        var $$ = this.internal;
        var config = $$.config;
        if (!arguments.length) return config.axis_x_categories;
        config.axis_x_categories = categories;
        $$.redraw();
        return config.axis_x_categories;
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * Update x grid lines.
 * @function xgrids
 * @instance
 * @memberof Chart
 * @param {Array} grids X grid lines will be replaced with this argument. The format of this argument is the same as grid.x.lines.
 * @returns {object}
 * @example
 *  // Show 2 x grid lines
 * chart.xgrids([
 *    {value: 1, text: "Label 1"},
 *    {value: 4, text: "Label 4"}
 * ]);
 * // --> Returns: [{value: 1, text: "Label 1"}, {value: 4, text: "Label 4"}]
 */ function xgrids(grids) {
    var $$ = this.internal;
    var config = $$.config;
    if (!grids) return config.grid_x_lines;
    config.grid_x_lines = grids;
    $$.redrawWithoutRescale();
    return config.grid_x_lines;
}
extend(xgrids, {
    /**
     * Add x grid lines.<br>
     * This API adds new x grid lines instead of replacing like xgrids.
     * @function xgrids․add
     * @instance
     * @memberof Chart
     * @param {Array|object} grids New x grid lines will be added. The format of this argument is the same as grid.x.lines and it's possible to give an Object if only one line will be added.
     * @returns {object}
     * @example
     *  // Add a new x grid line
     * chart.xgrids.add(
     *   {value: 4, text: "Label 4"}
     * );
     *
     * // Add new x grid lines
     * chart.xgrids.add([
     *   {value: 2, text: "Label 2"},
     *   {value: 4, text: "Label 4"}
     * ]);
     */ add: function(grids) {
        return this.xgrids(this.internal.config.grid_x_lines.concat(grids || []));
    },
    /**
     * Remove x grid lines.<br>
     * This API removes x grid lines.
     * @function xgrids․remove
     * @instance
     * @memberof Chart
     * @param {object} params This argument should include value or class. If value is given, the x grid lines that have specified x value will be removed. If class is given, the x grid lines that have specified class will be removed. If args is not given, all of x grid lines will be removed.
     * @example
     * // x grid line on x = 2 will be removed
     * chart.xgrids.remove({value: 2});
     *
     * // x grid lines that have 'grid-A' will be removed
     * chart.xgrids.remove({
     *   class: "grid-A"
     * });
     *
     * // all of x grid lines will be removed
     * chart.xgrids.remove();
     */ remove: function(params) {
        this.internal.removeGridLines(params, true);
    }
});
var apiXGrid = {
    xgrids: xgrids
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * Update y grid lines.
 * @function ygrids
 * @instance
 * @memberof Chart
 * @param {Array} grids Y grid lines will be replaced with this argument. The format of this argument is the same as grid.y.lines.
 * @returns {object}
 * @example
 *  // Show 2 y grid lines
 * chart.ygrids([
 *    {value: 100, text: "Label 1"},
 *    {value: 400, text: "Label 4"}
 * ]);
 * // --> Returns: [{value: 100, text: "Label 1"}, {value: 400, text: "Label 4"}]
 */ function ygrids(grids) {
    var $$ = this.internal;
    var config = $$.config;
    if (!grids) return config.grid_y_lines;
    config.grid_y_lines = grids;
    $$.redrawWithoutRescale();
    return config.grid_y_lines;
}
extend(ygrids, {
    /**
     * Add y grid lines.<br>
     * This API adds new y grid lines instead of replacing like ygrids.
     * @function ygrids․add
     * @instance
     * @memberof Chart
     * @param {Array|object} grids New y grid lines will be added. The format of this argument is the same as grid.y.lines and it's possible to give an Object if only one line will be added.
     * @returns {object}
     * @example
     *  // Add a new x grid line
     * chart.ygrids.add(
     *   {value: 400, text: "Label 4"}
     * );
     *
     * // Add new x grid lines
     * chart.ygrids.add([
     *   {value: 200, text: "Label 2"},
     *   {value: 400, text: "Label 4"}
     * ]);
     */ add: function(grids) {
        return this.ygrids(this.internal.config.grid_y_lines.concat(grids || []));
    },
    /**
     * Remove y grid lines.<br>
     * This API removes x grid lines.
     * @function ygrids․remove
     * @instance
     * @memberof Chart
     * @param {object} params This argument should include value or class. If value is given, the y grid lines that have specified y value will be removed. If class is given, the y grid lines that have specified class will be removed. If args is not given, all of y grid lines will be removed.
     * @param {number} [params.value] target value
     * @param {string} [params.class] target class
     * @example
     * // y grid line on y = 200 will be removed
     * chart.ygrids.remove({value: 200});
     *
     * // y grid lines that have 'grid-A' will be removed
     * chart.ygrids.remove({
     *   class: "grid-A"
     * });
     *
     * // all of y grid lines will be removed
     * chart.ygrids.remove();
     */ remove: function(params) {
        this.internal.removeGridLines(params, false);
    }
});
var apiYGrid = {
    ygrids: ygrids
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var apiGroup = {
    /**
     * Update groups for the targets.
     * @function groups
     * @instance
     * @memberof Chart
     * @param {Array} groups This argument needs to be an Array that includes one or more Array that includes target ids to be grouped.
     * @returns {Array} Grouped data names array
     * @example
     *  // data1 and data2 will be a new group.
     *  chart.groups([
     *     ["data1", "data2"]
     *  ]);
     */ groups: function(groups) {
        var $$ = this.internal;
        var config = $$.config;
        if (isUndefined(groups)) return config.data_groups;
        config.data_groups = groups;
        $$.redraw();
        return config.data_groups;
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * Update regions.
 * @function regions
 * @instance
 * @memberof Chart
 * @param {Array} regions Regions will be replaced with this argument. The format of this argument is the same as regions.
 * @returns {Array} regions
 * @example
 * // Show 2 regions
 * chart.regions([
 *    {axis: "x", start: 5, class: "regionX"},
 *    {axis: "y", end: 50, class: "regionY"}
 * ]);
 */ function regions(regions) {
    var $$ = this.internal;
    var config = $$.config;
    if (!regions) return config.regions;
    config.regions = regions;
    $$.redrawWithoutRescale();
    return regions;
}
extend(regions, {
    /**
     * Add new region.<br><br>
     * This API adds new region instead of replacing like regions.
     * @function regions․add
     * @instance
     * @memberof Chart
     * @param {Array|object} regions New region will be added. The format of this argument is the same as regions and it's possible to give an Object if only one region will be added.
     * @returns {Array} regions
     * @example
     * // Add a new region
     * chart.regions.add(
     *    {axis: "x", start: 5, class: "regionX"}
     * );
     *
     * // Add new regions
     * chart.regions.add([
     *    {axis: "x", start: 5, class: "regionX"},
     *    {axis: "y", end: 50, class: "regionY"}
     *]);
     */ add: function(regions) {
        var $$ = this.internal;
        var config = $$.config;
        if (!regions) return config.regions;
        config.regions = config.regions.concat(regions);
        $$.redrawWithoutRescale();
        return config.regions;
    },
    /**
     * Remove regions.<br><br>
     * This API removes regions.
     * @function regions․remove
     * @instance
     * @memberof Chart
     * @param {object} optionsValue This argument should include classes. If classes is given, the regions that have one of the specified classes will be removed. If args is not given, all of regions will be removed.
     * @returns {Array} regions Removed regions
     * @example
     * // regions that have 'region-A' or 'region-B' will be removed.
     * chart.regions.remove({
     *   classes: [
     *     "region-A", "region-B"
     *   ]
     * });
     *
     * // all of regions will be removed.
     * chart.regions.remove();
     */ remove: function(optionsValue) {
        var $$ = this.internal;
        var config = $$.config;
        var options = optionsValue || {};
        var duration = getOption(options, "duration", config.transition_duration);
        var classes = getOption(options, "classes", [
            CLASS.region
        ]);
        var regions = $$.$el.main.select(".".concat(CLASS.regions)).selectAll(classes.map(function(c) {
            return ".".concat(c);
        }));
        (duration ? regions.transition().duration(duration) : regions).style("opacity", "0").remove();
        regions = config.regions;
        if (Object.keys(options).length) {
            regions = regions.filter(function(region) {
                var found = false;
                if (!region["class"]) return true;
                region["class"].split(" ").forEach(function(c) {
                    if (classes.indexOf(c) >= 0) found = true;
                });
                return !found;
            });
            config.regions = regions;
        } else config.regions = [];
        return regions;
    }
});
var apiRegion = {
    regions: regions
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var apiX = {
    /**
     * Get and set x values for the chart.
     * @function x
     * @instance
     * @memberof Chart
     * @param {Array} x If x is given, x values of every target will be updated. If no argument is given, current x values will be returned as an Object whose keys are the target ids.
     * @returns {object} xs
     * @example
     *  // Get current x values
     *  chart.x();
     *
     *  // Update x values for all targets
     *  chart.x([100, 200, 300, 400, ...]);
     */ x: function(x) {
        var $$ = this.internal;
        var axis = $$.axis, data = $$.data;
        var isCategorized = axis.isCustomX() && axis.isCategorized();
        if (isArray(x)) {
            if (isCategorized) this.categories(x);
            else {
                $$.updateTargetX(data.targets, x);
                $$.redraw({
                    withUpdateOrgXDomain: true,
                    withUpdateXDomain: true
                });
            }
        }
        return isCategorized ? this.categories() : data.xs;
    },
    /**
     * Get and set x values for the chart.
     * @function xs
     * @instance
     * @memberof Chart
     * @param {Array} xs If xs is given, specified target's x values will be updated. If no argument is given, current x values will be returned as an Object whose keys are the target ids.
     * @returns {object} xs
     * @example
     *  // Get current x values
     *  chart.xs();
     *
     *  // Update x values for all targets
     *  chart.xs({
     *    data1: [10, 20, 30, 40, ...],
     *    data2: [100, 200, 300, 400, ...]
     *  });
     */ xs: function(xs) {
        var $$ = this.internal;
        if (isObject(xs)) {
            $$.updateTargetXs($$.data.targets, xs);
            $$.redraw({
                withUpdateOrgXDomain: true,
                withUpdateXDomain: true
            });
        }
        return $$.data.xs;
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var apiFlow = {
    /**
     * Flow data to the chart.<br><br>
     * By this API, you can append new data points to the chart.
     * @function flow
     * @instance
     * @memberof Chart
     * @param {object} args The object can consist with following members:<br>
     *
     *    | Key | Type | Description |
     *    | --- | --- | --- |
     *    | json | Object | Data as JSON format (@see [data․json](Options.html#.data%25E2%2580%25A4json)) |
     *    | rows | Array | Data in array as row format (@see [data․rows](Options.html#.data%25E2%2580%25A4json)) |
     *    | columns | Array | Data in array as column format (@see [data․columns](Options.html#.data%25E2%2580%25A4columns)) |
     *    | to | String | The lower x edge will move to that point. If not given, the lower x edge will move by the number of given data points |
     *    | length | Number | The lower x edge will move by the number of this argument |
     *    | duration | Number | The duration of the transition will be specified value. If not given, transition.duration will be used as default |
     *    | done | Function | The specified function will be called when flow ends |
     *
     * - **NOTE:**
     *   - If json, rows and columns given, the data will be loaded.
     *   - If data that has the same target id is given, the chart will be appended.
     *   - Otherwise, new target will be added. One of these is required when calling.
     *   - If json specified, keys is required as well as data.json.
     * 	 - If tab isn't visible(by evaluating `document.hidden`), will not be executed to prevent unnecessary work.
     * @example
     * // 2 data points will be apprended to the tail and popped from the head.
     * // After that, 4 data points will be appended and no data points will be poppoed.
     * chart.flow({
     *  columns: [
     *    ["x", "2018-01-11", "2018-01-21"],
     *    ["data1", 500, 200],
     *    ["data2", 100, 300],
     *    ["data3", 200, 120]
     *  ],
     *  to: "2013-01-11",
     *  done: function () {
     *    chart.flow({
     *      columns: [
     *        ["x", "2018-02-11", "2018-02-12", "2018-02-13", "2018-02-14"],
     *        ["data1", 200, 300, 100, 250],
     *        ["data2", 100, 90, 40, 120],
     *        ["data3", 100, 100, 300, 500]
     *      ],
     *      length: 2,
     *      duration: 1500
     *    });
     *  }
     * });
     */ flow: function(args) {
        var $$ = this.internal;
        var data;
        var domain;
        var length = 0;
        var tail = 0;
        var diff;
        var to;
        if (args.json || args.rows || args.columns) data = $$.convertData(args);
        if (!data || !isTabVisible()) return;
        var notfoundIds = [];
        var orgDataCount = $$.getMaxDataCount();
        var targets = $$.convertDataToTargets(data, true);
        var isTimeSeries = $$.axis.isTimeSeries();
        // Update/Add data
        $$.data.targets.forEach(function(t) {
            var found = false;
            for(var i = 0; i < targets.length; i++)if (t.id === targets[i].id) {
                found = true;
                if (t.values[t.values.length - 1]) tail = t.values[t.values.length - 1].index + 1;
                length = targets[i].values.length;
                for(var j = 0; j < length; j++){
                    targets[i].values[j].index = tail + j;
                    if (!isTimeSeries) targets[i].values[j].x = tail + j;
                }
                t.values = t.values.concat(targets[i].values);
                targets.splice(i, 1);
                break;
            }
            !found && notfoundIds.push(t.id);
        });
        // Append null for not found targets
        $$.data.targets.forEach(function(t) {
            for(var i = 0; i < notfoundIds.length; i++)if (t.id === notfoundIds[i]) {
                tail = t.values[t.values.length - 1].index + 1;
                for(var j = 0; j < length; j++)t.values.push({
                    id: t.id,
                    index: tail + j,
                    x: isTimeSeries ? $$.getOtherTargetX(tail + j) : tail + j,
                    value: null
                });
            }
        });
        // Generate null values for new target
        if ($$.data.targets.length) targets.forEach(function(t) {
            var missing = [];
            for(var i = $$.data.targets[0].values[0].index; i < tail; i++)missing.push({
                id: t.id,
                index: i,
                x: isTimeSeries ? $$.getOtherTargetX(i) : i,
                value: null
            });
            t.values.forEach(function(v) {
                v.index += tail;
                if (!isTimeSeries) v.x += tail;
            });
            t.values = missing.concat(t.values);
        });
        $$.data.targets = $$.data.targets.concat(targets); // add remained
        // check data count because behavior needs to change when it"s only one
        // const dataCount = $$.getMaxDataCount();
        var baseTarget = $$.data.targets[0];
        var baseValue = baseTarget.values[0];
        // Update length to flow if needed
        if (isDefined(args.to)) {
            length = 0;
            to = isTimeSeries ? parseDate.call($$, args.to) : args.to;
            baseTarget.values.forEach(function(v) {
                v.x < to && length++;
            });
        } else if (isDefined(args.length)) length = args.length;
        // If only one data, update the domain to flow from left edge of the chart
        if (!orgDataCount) {
            if (isTimeSeries) diff = baseTarget.values.length > 1 ? baseTarget.values[baseTarget.values.length - 1].x - baseValue.x : baseValue.x - $$.getXDomain($$.data.targets)[0];
            else diff = 1;
            domain = [
                baseValue.x - diff,
                baseValue.x
            ];
        } else if (orgDataCount === 1 && isTimeSeries) {
            diff = (baseTarget.values[baseTarget.values.length - 1].x - baseValue.x) / 2;
            domain = [
                new Date(+baseValue.x - diff),
                new Date(+baseValue.x + diff)
            ];
        }
        domain && $$.updateXDomain(null, true, true, false, domain);
        // Set targets
        $$.updateTargets($$.data.targets);
        // Redraw with new targets
        $$.redraw({
            flow: {
                index: baseValue.index,
                length: length,
                duration: isValue(args.duration) ? args.duration : $$.config.transition_duration,
                done: args.done,
                orgDataCount: orgDataCount
            },
            withLegend: true,
            withTransition: orgDataCount > 1,
            withTrimXDomain: false,
            withUpdateXAxis: true
        });
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 * @ignore
 */ var AxisRendererHelper = /** @class */ function() {
    function AxisRendererHelper(owner) {
        var scale = getScale();
        var config = owner.config, params = owner.params;
        this.owner = owner;
        this.config = config;
        this.scale = scale;
        if (config.noTransition || !params.config.transition_duration) config.withoutTransition = true;
        // set range
        config.range = this.scaleExtent((params.orgXScale || scale).range());
    }
    /**
     * Compute a character dimension
     * @param {d3.selection} node <g class=tick> node
     * @returns {{w: number, h: number}}
     * @private
     */ AxisRendererHelper.getSizeFor1Char = function(node) {
        // default size for one character
        var size = {
            w: 5.5,
            h: 11.5
        };
        !node.empty() && node.select("text").text("0").call(function(el) {
            try {
                var _a = el.node().getBBox(), width = _a.width, height = _a.height;
                if (width && height) {
                    size.w = width;
                    size.h = height;
                }
            } catch (e) {} finally{
                el.text("");
            }
        });
        this.getSizeFor1Char = function() {
            return size;
        };
        return size;
    };
    /**
     * Get tick transform setter function
     * @param {string} id Axis id
     * @returns {Function} transfrom setter function
     * @private
     */ AxisRendererHelper.prototype.getTickTransformSetter = function(id) {
        var config = this.config;
        var fn = id === "x" ? function(value) {
            return "translate(".concat(value + config.tickOffset, ",0)");
        } : function(value) {
            return "translate(0,".concat(value, ")");
        };
        return function(selection, scale) {
            selection.attr("transform", function(d) {
                return fn(Math.ceil(scale(d)));
            });
        };
    };
    AxisRendererHelper.prototype.scaleExtent = function(domain) {
        var start = domain[0];
        var stop = domain[domain.length - 1];
        return start < stop ? [
            start,
            stop
        ] : [
            stop,
            start
        ];
    };
    AxisRendererHelper.prototype.generateTicks = function(scale, isYAxes) {
        var tickStepSize = this.owner.params.tickStepSize;
        var _a = scale.domain(), start = _a[0], end = _a[1];
        var ticks = [];
        // When 'axis[y|y2].tick.stepSize' option is set
        if (isYAxes && tickStepSize) {
            var interval = start;
            while(interval <= end){
                ticks.push(interval);
                interval += tickStepSize;
            }
        } else if (scale.ticks) {
            var tickArguments = this.config.tickArguments;
            // adjust excessive tick count show
            if (scale.type === "log" && !tickArguments) {
                // nicer symlog ticks didn't implemented yet: https://github.com/d3/d3-scale/issues/162
                // get ticks values from logScale
                var s = getScale("_log").domain([
                    start > 0 ? start : 1,
                    end
                ]).range(scale.range());
                ticks = s.ticks();
                for(var cnt = end.toFixed().length; ticks.length > 15; cnt--)ticks = s.ticks(cnt);
                ticks.splice(0, 1, start);
                ticks.splice(ticks.length - 1, 1, end);
            } else ticks = scale.ticks.apply(scale, this.config.tickArguments || []);
            ticks = ticks.map(function(v) {
                // round the tick value if is number
                var r = isString(v) && isNumber(v) && !isNaN(v) && Math.round(v * 10) / 10 || v;
                return r;
            });
        } else {
            for(var i = Math.ceil(start); i < end; i++)ticks.push(i);
            if (ticks.length > 0 && ticks[0] > 0) ticks.unshift(ticks[0] - (ticks[1] - ticks[0]));
        }
        return ticks;
    };
    AxisRendererHelper.prototype.copyScale = function() {
        var newScale = this.scale.copy();
        if (!newScale.domain().length) newScale.domain(this.scale.domain());
        newScale.type = this.scale.type;
        return newScale;
    };
    AxisRendererHelper.prototype.textFormatted = function(v) {
        var tickFormat = this.config.tickFormat;
        // to round float numbers from 'binary floating point'
        // https://en.wikipedia.org/wiki/Double-precision_floating-point_format
        // https://stackoverflow.com/questions/17849101/laymans-explanation-for-why-javascript-has-weird-floating-math-ieee-754-stand
        var value = /\d+\.\d+0{5,}\d$/.test(v) ? +String(v).replace(/0+\d$/, "") : v;
        var formatted = tickFormat ? tickFormat(value) : value;
        return isDefined(formatted) ? formatted : "";
    };
    AxisRendererHelper.prototype.transitionise = function(selection) {
        var config = this.config;
        return config.withoutTransition ? selection.interrupt() : selection.transition(config.transition);
    };
    return AxisRendererHelper;
}();
var AxisRenderer = /** @class */ function() {
    function AxisRenderer(params) {
        if (params === void 0) params = {};
        var config = {
            innerTickSize: 6,
            outerTickSize: params.outerTick ? 6 : 0,
            orient: "bottom",
            range: [],
            tickArguments: null,
            tickCentered: null,
            tickCulling: true,
            tickFormat: null,
            tickLength: 9,
            tickOffset: 0,
            tickPadding: 3,
            tickValues: null,
            transition: null,
            noTransition: params.noTransition
        };
        config.tickLength = Math.max(config.innerTickSize, 0) + config.tickPadding;
        this.config = config;
        this.params = params;
        this.helper = new AxisRendererHelper(this);
    }
    /**
     * Create axis element
     * @param {d3.selection} g Axis selection
     * @private
     */ AxisRenderer.prototype.create = function(g) {
        var ctx = this;
        var _a = this, config = _a.config, helper = _a.helper, params = _a.params;
        var scale = helper.scale;
        var orient = config.orient;
        var splitTickText = this.splitTickText.bind(this);
        var isLeftRight = /^(left|right)$/.test(orient);
        var isTopBottom = /^(top|bottom)$/.test(orient);
        // line/text enter and path update
        var tickTransform = helper.getTickTransformSetter(isTopBottom ? "x" : "y");
        var axisPx = tickTransform === helper.axisX ? "y" : "x";
        var sign = /^(top|left)$/.test(orient) ? -1 : 1;
        // tick text helpers
        var rotate = params.tickTextRotate;
        this.config.range = scale.rangeExtent ? scale.rangeExtent() : helper.scaleExtent((params.orgXScale || scale).range());
        var innerTickSize = config.innerTickSize, tickLength = config.tickLength, range = config.range;
        // // get the axis' tick position configuration
        var id = params.id;
        var tickTextPos = id && /^(x|y|y2)$/.test(id) ? params.config["axis_".concat(id, "_tick_text_position")] : {
            x: 0,
            y: 0
        };
        // tick visiblity
        var prefix = id === "subX" ? "subchart_axis_x" : "axis_".concat(id);
        var axisShow = params.config["".concat(prefix, "_show")];
        var tickShow = {
            tick: axisShow ? params.config["".concat(prefix, "_tick_show")] : false,
            text: axisShow ? params.config["".concat(prefix, "_tick_text_show")] : false
        };
        var $g;
        g.each(function() {
            var g = (0, $hOxpW.default)(this);
            var scale0 = this.__chart__ || scale;
            var scale1 = helper.copyScale();
            $g = g;
            this.__chart__ = scale1;
            config.tickOffset = params.isCategory ? Math.ceil((scale1(1) - scale1(0)) / 2) : 0;
            // update selection - data join
            var path = g.selectAll(".domain").data([
                0
            ]);
            // enter + update selection
            path.enter().append("path").attr("class", "domain").merge(helper.transitionise(path)).attr("d", function() {
                var outerTickSized = config.outerTickSize * sign;
                return isTopBottom ? "M".concat(range[0], ",").concat(outerTickSized, "V0H").concat(range[1], "V").concat(outerTickSized) : "M".concat(outerTickSized, ",").concat(range[0], "H0V").concat(range[1], "H").concat(outerTickSized);
            });
            if (tickShow.tick || tickShow.text) {
                // count of tick data in array
                var ticks_1 = config.tickValues || helper.generateTicks(scale1, isLeftRight);
                // update selection
                var tick = g.selectAll(".tick").data(ticks_1, scale1);
                // enter selection
                var tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", "1");
                // MEMO: No exit transition. The reason is this transition affects max tick width calculation because old tick will be included in the ticks.
                var tickExit = tick.exit().remove();
                // enter + update selection
                tick = tickEnter.merge(tick);
                tickShow.tick && tickEnter.append("line");
                tickShow.text && tickEnter.append("text");
                var sizeFor1Char_1 = AxisRendererHelper.getSizeFor1Char(tick);
                var counts_1 = [];
                var tspan = tick.select("text").selectAll("tspan").data(function(d, index) {
                    var split = params.tickMultiline ? splitTickText(d, scale1, ticks_1, isLeftRight, sizeFor1Char_1.w) : isArray(helper.textFormatted(d)) ? helper.textFormatted(d).concat() : [
                        helper.textFormatted(d)
                    ];
                    counts_1[index] = split.length;
                    return split.map(function(splitted) {
                        return {
                            index: index,
                            splitted: splitted
                        };
                    });
                });
                tspan.exit().remove();
                tspan = tspan.enter().append("tspan").merge(tspan).text(function(d) {
                    return d.splitted;
                });
                // set <tspan>'s position
                tspan.attr("x", isTopBottom ? 0 : tickLength * sign).attr("dx", function() {
                    var dx = 0;
                    if (/(top|bottom)/.test(orient) && rotate) dx = 8 * Math.sin(Math.PI * (rotate / 180)) * (orient === "top" ? -1 : 1);
                    return dx + (tickTextPos.x || 0);
                }()).attr("dy", function(d, i) {
                    var defValue = ".71em";
                    var dy = 0;
                    if (orient !== "top") {
                        dy = sizeFor1Char_1.h;
                        if (i === 0) dy = isLeftRight ? -((counts_1[d.index] - 1) * (sizeFor1Char_1.h / 2) - 3) : tickTextPos.y === 0 ? defValue : 0;
                    }
                    return isNumber(dy) && tickTextPos.y ? dy + tickTextPos.y : dy || defValue;
                });
                var lineUpdate = tick.select("line");
                var textUpdate = tick.select("text");
                tickEnter.select("line").attr("".concat(axisPx, "2"), innerTickSize * sign);
                tickEnter.select("text").attr(axisPx, tickLength * sign);
                ctx.setTickLineTextPosition(lineUpdate, textUpdate);
                // Append <title> for tooltip display
                if (params.tickTitle) {
                    var title = textUpdate.select("title");
                    (title.empty() ? textUpdate.append("title") : title).text(function(index) {
                        return params.tickTitle[index];
                    });
                }
                if (scale1.bandwidth) {
                    var x_1 = scale1;
                    var dx_1 = x_1.bandwidth() / 2;
                    scale0 = function(d) {
                        return x_1(d) + dx_1;
                    };
                    scale1 = scale0;
                } else if (scale0.bandwidth) scale0 = scale1;
                else tickTransform(tickExit, scale1);
                tickTransform(tickEnter, scale0);
                tickTransform(helper.transitionise(tick).style("opacity", "1"), scale1);
            }
        });
        this.g = $g;
    };
    /**
     * Get tick x/y coordinate
     * @returns {{x: number, y: number}}
     * @private
     */ AxisRenderer.prototype.getTickXY = function() {
        var config = this.config;
        var pos = {
            x: 0,
            y: 0
        };
        if (this.params.isCategory) {
            pos.x = config.tickCentered ? 0 : config.tickOffset;
            pos.y = config.tickCentered ? config.tickOffset : 0;
        }
        return pos;
    };
    /**
     * Get tick size
     * @param {object} d data object
     * @returns {number}
     * @private
     */ AxisRenderer.prototype.getTickSize = function(d) {
        var scale = this.helper.scale;
        var config = this.config;
        var innerTickSize = config.innerTickSize, range = config.range;
        var tickPosition = scale(d) + (config.tickCentered ? 0 : config.tickOffset);
        return range[0] < tickPosition && tickPosition < range[1] ? innerTickSize : 0;
    };
    /**
     * Set tick's line & text position
     * @param {d3.selection} lineUpdate Line selection
     * @param {d3.selection} textUpdate Text selection
     * @private
     */ AxisRenderer.prototype.setTickLineTextPosition = function(lineUpdate, textUpdate) {
        var tickPos = this.getTickXY();
        var _a = this.config, innerTickSize = _a.innerTickSize, orient = _a.orient, tickLength = _a.tickLength, tickOffset = _a.tickOffset;
        var rotate = this.params.tickTextRotate;
        var textAnchorForText = function(r) {
            var value = [
                "start",
                "end"
            ];
            orient === "top" && value.reverse();
            return !r ? "middle" : r > 0 ? value[0] : value[1];
        };
        var textTransform = function(r) {
            return r ? "rotate(".concat(r, ")") : null;
        };
        var yForText = function(r) {
            var r2 = r / (orient === "bottom" ? 15 : 23);
            return r ? 11.5 - 2.5 * r2 * (r > 0 ? 1 : -1) : tickLength;
        };
        switch(orient){
            case "bottom":
                lineUpdate.attr("x1", tickPos.x).attr("x2", tickPos.x).attr("y2", this.getTickSize.bind(this));
                textUpdate.attr("x", 0).attr("y", yForText(rotate)).style("text-anchor", textAnchorForText(rotate)).attr("transform", textTransform(rotate));
                break;
            case "top":
                lineUpdate.attr("x2", 0).attr("y2", -innerTickSize);
                textUpdate.attr("x", 0).attr("y", -yForText(rotate) * 2).style("text-anchor", textAnchorForText(rotate)).attr("transform", textTransform(rotate));
                break;
            case "left":
                lineUpdate.attr("x2", -innerTickSize).attr("y1", tickPos.y).attr("y2", tickPos.y);
                textUpdate.attr("x", -tickLength).attr("y", tickOffset).style("text-anchor", "end");
                break;
            case "right":
                lineUpdate.attr("x2", innerTickSize).attr("y2", 0);
                textUpdate.attr("x", tickLength).attr("y", 0).style("text-anchor", "start");
        }
    };
    // this should be called only when category axis
    AxisRenderer.prototype.splitTickText = function(d, scale, ticks, isLeftRight, charWidth) {
        var params = this.params;
        var tickText = this.helper.textFormatted(d);
        var splitted = isString(tickText) && tickText.indexOf("\n") > -1 ? tickText.split("\n") : [];
        if (splitted.length) return splitted;
        if (isArray(tickText)) return tickText;
        var tickWidth = params.tickWidth;
        if (!tickWidth || tickWidth <= 0) tickWidth = isLeftRight ? 95 : params.isCategory ? Math.ceil(scale(ticks[1]) - scale(ticks[0])) - 12 : 110;
        // split given text by tick width size
        // eslint-disable-next-line
        function split(splitted, text) {
            var subtext;
            var spaceIndex;
            var textWidth;
            for(var i = 1; i < text.length; i++){
                if (text.charAt(i) === " ") spaceIndex = i;
                subtext = text.substr(0, i + 1);
                textWidth = charWidth * subtext.length;
                // if text width gets over tick width, split by space index or current index
                if (tickWidth < textWidth) return split(splitted.concat(text.substr(0, spaceIndex || i)), text.slice(spaceIndex ? spaceIndex + 1 : i));
            }
            return splitted.concat(text);
        }
        return split(splitted, String(tickText));
    };
    AxisRenderer.prototype.scale = function(x) {
        if (!arguments.length) return this.helper.scale;
        this.helper.scale = x;
        return this;
    };
    AxisRenderer.prototype.orient = function(x) {
        if (!arguments.length) return this.config.orient;
        this.config.orient = x in {
            top: 1,
            right: 1,
            bottom: 1,
            left: 1
        } ? String(x) : "bottom";
        return this;
    };
    AxisRenderer.prototype.tickFormat = function(format) {
        var config = this.config;
        if (!arguments.length) return config.tickFormat;
        config.tickFormat = format;
        return this;
    };
    AxisRenderer.prototype.tickCentered = function(isCentered) {
        var config = this.config;
        if (!arguments.length) return config.tickCentered;
        config.tickCentered = isCentered;
        return this;
    };
    /**
     * Return tick's offset value.
     * The value will be set for 'category' axis type.
     * @returns {number}
     * @private
     */ AxisRenderer.prototype.tickOffset = function() {
        return this.config.tickOffset;
    };
    /**
     * Get tick interval count
     * @private
     * @param {number} size Total data size
     * @returns {number}
     */ AxisRenderer.prototype.tickInterval = function(size) {
        var _this = this;
        var interval;
        if (this.params.isCategory) interval = this.config.tickOffset * 2;
        else {
            var length_1 = this.g.select("path.domain").node().getTotalLength() - this.config.outerTickSize * 2;
            interval = length_1 / (size || this.g.selectAll("line").size());
            // get the interval by its values
            var intervalByValue = this.config.tickValues.map(function(v, i, arr) {
                var next = i + 1;
                return next < arr.length ? _this.helper.scale(arr[next]) - _this.helper.scale(v) : null;
            }).filter(Boolean);
            interval = Math.min.apply(Math, __spreadArray(__spreadArray([], intervalByValue, false), [
                interval
            ], false));
        }
        return interval === Infinity ? 0 : interval;
    };
    AxisRenderer.prototype.ticks = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var config = this.config;
        if (!args.length) return config.tickArguments;
        config.tickArguments = toArray(args);
        return this;
    };
    AxisRenderer.prototype.tickCulling = function(culling) {
        var config = this.config;
        if (!arguments.length) return config.tickCulling;
        config.tickCulling = culling;
        return this;
    };
    AxisRenderer.prototype.tickValues = function(x) {
        var _this = this;
        var config = this.config;
        if (isFunction(x)) config.tickValues = function() {
            return x(_this.helper.scale.domain());
        };
        else {
            if (!arguments.length) return config.tickValues;
            config.tickValues = x;
        }
        return this;
    };
    AxisRenderer.prototype.setTransition = function(t) {
        this.config.transition = t;
        return this;
    };
    return AxisRenderer;
}();
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var axis = {
    getAxisInstance: function() {
        return this.axis || new Axis(this);
    }
};
var Axis = /** @class */ function() {
    function Axis(owner) {
        this.axesList = {};
        this.tick = {
            x: null,
            y: null,
            y2: null
        };
        this.xs = [];
        this.orient = {
            x: "bottom",
            y: "left",
            y2: "right",
            subX: "bottom"
        };
        this.owner = owner;
        this.setOrient();
    }
    Axis.prototype.getAxisClassName = function(id) {
        return "".concat(CLASS.axis, " ").concat(CLASS["axis".concat(capitalize(id))]);
    };
    Axis.prototype.isHorizontal = function($$, forHorizontal) {
        var isRotated = $$.config.axis_rotated;
        return forHorizontal ? isRotated : !isRotated;
    };
    Axis.prototype.isCategorized = function() {
        var _a = this.owner, config = _a.config, state = _a.state;
        return config.axis_x_type.indexOf("category") >= 0 || state.hasRadar;
    };
    Axis.prototype.isCustomX = function() {
        var config = this.owner.config;
        return !this.isTimeSeries() && (config.data_x || notEmpty(config.data_xs));
    };
    Axis.prototype.isTimeSeries = function(id) {
        if (id === void 0) id = "x";
        return this.owner.config["axis_".concat(id, "_type")] === "timeseries";
    };
    Axis.prototype.isLog = function(id) {
        if (id === void 0) id = "x";
        return this.owner.config["axis_".concat(id, "_type")] === "log";
    };
    Axis.prototype.isTimeSeriesY = function() {
        return this.isTimeSeries("y");
    };
    Axis.prototype.getAxisType = function(id) {
        if (id === void 0) id = "x";
        var type = "linear";
        if (this.isTimeSeries(id)) type = "time";
        else if (this.isLog(id)) type = "log";
        return type;
    };
    Axis.prototype.init = function() {
        var _this = this;
        var $$ = this.owner;
        var config = $$.config, _a = $$.$el, main = _a.main, axis = _a.axis, clip = $$.state.clip;
        var isRotated = config.axis_rotated;
        var target = [
            "x",
            "y"
        ];
        config.axis_y2_show && target.push("y2");
        target.forEach(function(v) {
            var classAxis = _this.getAxisClassName(v);
            var classLabel = CLASS["axis".concat(v.toUpperCase(), "Label")];
            axis[v] = main.append("g").attr("class", classAxis).attr("clip-path", function() {
                var res = null;
                if (v === "x") res = clip.pathXAxis;
                else if (v === "y") res = clip.pathYAxis;
                return res;
            }).attr("transform", $$.getTranslate(v)).style("visibility", config["axis_".concat(v, "_show")] ? "visible" : "hidden");
            axis[v].append("text").attr("class", classLabel).attr("transform", [
                "rotate(-90)",
                null
            ][v === "x" ? +!isRotated : +isRotated]).style("text-anchor", function() {
                return _this.textAnchorForAxisLabel(v);
            });
            _this.generateAxes(v);
        });
    };
    /**
     * Set axis orient according option value
     * @private
     */ Axis.prototype.setOrient = function() {
        var $$ = this.owner;
        var _a = $$.config, isRotated = _a.axis_rotated, yInner = _a.axis_y_inner, y2Inner = _a.axis_y2_inner;
        this.orient = {
            x: isRotated ? "left" : "bottom",
            y: isRotated ? yInner ? "top" : "bottom" : yInner ? "right" : "left",
            y2: isRotated ? y2Inner ? "bottom" : "top" : y2Inner ? "left" : "right",
            subX: isRotated ? "left" : "bottom"
        };
    };
    /**
     * Generate axes
     * It's used when axis' axes option is set
     * @param {string} id Axis id
     * @private
     */ Axis.prototype.generateAxes = function(id) {
        var $$ = this.owner;
        var config = $$.config;
        var axes = [];
        var axesConfig = config["axis_".concat(id, "_axes")];
        var isRotated = config.axis_rotated;
        var d3Axis;
        if (id === "x") d3Axis = isRotated ? (0, $bgSbI.axisLeft) : (0, $bgSbI.axisBottom);
        else if (id === "y") d3Axis = isRotated ? (0, $bgSbI.axisBottom) : (0, $bgSbI.axisLeft);
        else if (id === "y2") d3Axis = isRotated ? (0, $bgSbI.axisTop) : (0, $bgSbI.axisRight);
        if (axesConfig.length) axesConfig.forEach(function(v) {
            var tick = v.tick || {};
            var scale = $$.scale[id].copy();
            v.domain && scale.domain(v.domain);
            axes.push(d3Axis(scale).ticks(tick.count).tickFormat(isFunction(tick.format) ? tick.format.bind($$.api) : function(x) {
                return x;
            }).tickValues(tick.values).tickSizeOuter(tick.outer === false ? 0 : 6));
        });
        this.axesList[id] = axes;
    };
    /**
     * Update axes nodes
     * @private
     */ Axis.prototype.updateAxes = function() {
        var _this = this;
        var $$ = this.owner;
        var config = $$.config, main = $$.$el.main;
        Object.keys(this.axesList).forEach(function(id) {
            var axesConfig = config["axis_".concat(id, "_axes")];
            var scale = $$.scale[id].copy();
            var range = scale.range();
            _this.axesList[id].forEach(function(v, i) {
                var axisRange = v.scale().range();
                // adjust range value with the current
                // https://github.com/naver/billboard.js/issues/859
                if (!range.every(function(v, i) {
                    return v === axisRange[i];
                })) v.scale().range(range);
                var className = "".concat(_this.getAxisClassName(id), "-").concat(i + 1);
                var g = main.select(".".concat(className.replace(/\s/, ".")));
                if (g.empty()) g = main.append("g").attr("class", className).style("visibility", config["axis_".concat(id, "_show")] ? "visible" : "hidden").call(v);
                else {
                    axesConfig[i].domain && scale.domain(axesConfig[i].domain);
                    _this.x.helper.transitionise(g).call(v.scale(scale));
                }
                g.attr("transform", $$.getTranslate(id, i + 1));
            });
        });
    };
    /**
     * Set Axis & tick values
     * called from: updateScales()
     * @param {string} id Axis id string
     * @param {d3Scale} scale Scale
     * @param {boolean} outerTick If show outer tick
     * @param {boolean} noTransition If with no transition
     * @private
     */ Axis.prototype.setAxis = function(id, scale, outerTick, noTransition) {
        var $$ = this.owner;
        if (id !== "subX") this.tick[id] = this.getTickValues(id);
        // @ts-ignore
        this[id] = this.getAxis(id, scale, outerTick, // do not transit x Axis on zoom and resizing
        // https://github.com/naver/billboard.js/issues/1949
        id === "x" && ($$.scale.zoom || $$.config.subchart_show || $$.state.resizing) ? true : noTransition);
    };
    // called from : getMaxTickWidth()
    Axis.prototype.getAxis = function(id, scale, outerTick, noTransition, noTickTextRotate) {
        var $$ = this.owner;
        var config = $$.config;
        var isX = /^(x|subX)$/.test(id);
        var type = isX ? "x" : id;
        var isCategory = isX && this.isCategorized();
        var orient = this.orient[id];
        var tickTextRotate = noTickTextRotate ? 0 : $$.getAxisTickRotate(type);
        var tickFormat;
        if (isX) tickFormat = $$.format.xAxisTick;
        else {
            var fn = config["axis_".concat(id, "_tick_format")];
            if (isFunction(fn)) tickFormat = fn.bind($$.api);
        }
        var tickValues = this.tick[type];
        var axisParams = mergeObj({
            outerTick: outerTick,
            noTransition: noTransition,
            config: config,
            id: id,
            tickTextRotate: tickTextRotate
        }, isX && {
            isCategory: isCategory,
            tickMultiline: config.axis_x_tick_multiline,
            tickWidth: config.axis_x_tick_width,
            tickTitle: isCategory && config.axis_x_tick_tooltip && $$.api.categories(),
            orgXScale: $$.scale.x
        });
        if (!isX) axisParams.tickStepSize = config["axis_".concat(type, "_tick_stepSize")];
        var axis = new AxisRenderer(axisParams).scale(isX && $$.scale.zoom || scale).orient(orient);
        if (isX && this.isTimeSeries() && tickValues && !isFunction(tickValues)) {
            var fn_1 = parseDate.bind($$);
            tickValues = tickValues.map(function(v) {
                return fn_1(v);
            });
        } else if (!isX && this.isTimeSeriesY()) {
            // https://github.com/d3/d3/blob/master/CHANGES.md#time-intervals-d3-time
            axis.ticks(config.axis_y_tick_time_value);
            tickValues = null;
        }
        tickValues && axis.tickValues(tickValues);
        // Set tick
        axis.tickFormat(tickFormat || !isX && $$.isStackNormalized() && function(x) {
            return "".concat(x, "%");
        });
        if (isCategory) {
            axis.tickCentered(config.axis_x_tick_centered);
            if (isEmpty(config.axis_x_tick_culling)) config.axis_x_tick_culling = false;
        }
        var tickCount = config["axis_".concat(type, "_tick_count")];
        tickCount && axis.ticks(tickCount);
        return axis;
    };
    Axis.prototype.updateXAxisTickValues = function(targets, axis) {
        var $$ = this.owner;
        var config = $$.config;
        var fit = config.axis_x_tick_fit;
        var count = config.axis_x_tick_count;
        var values;
        if (fit || count && fit) {
            values = $$.mapTargetsToUniqueXs(targets);
            // if given count is greater than the value length, then limit the count.
            if (this.isCategorized() && count > values.length) count = values.length;
            values = this.generateTickValues(values, count, this.isTimeSeries());
        }
        if (axis) axis.tickValues(values);
        else if (this.x) {
            this.x.tickValues(values);
            this.subX && this.subX.tickValues(values);
        }
        return values;
    };
    Axis.prototype.getId = function(id) {
        var _a = this.owner, config = _a.config, scale = _a.scale;
        var axis = config.data_axes[id];
        // when data.axes option has 'y2', but 'axis.y2.show=true' isn't set will return 'y'
        if (!axis || !scale[axis]) axis = "y";
        return axis;
    };
    Axis.prototype.getXAxisTickFormat = function() {
        var $$ = this.owner;
        var config = $$.config, format = $$.format;
        var tickFormat = config.axis_x_tick_format;
        var isTimeSeries = this.isTimeSeries();
        var isCategorized = this.isCategorized();
        var currFormat;
        if (tickFormat) {
            if (isFunction(tickFormat)) currFormat = tickFormat.bind($$.api);
            else if (isTimeSeries) currFormat = function(date) {
                return date ? format.axisTime(tickFormat)(date) : "";
            };
        } else currFormat = isTimeSeries ? format.defaultAxisTime : isCategorized ? $$.categoryName : function(v) {
            return v < 0 ? v.toFixed(0) : v;
        };
        return isFunction(currFormat) ? function(v) {
            return currFormat.apply($$, isCategorized ? [
                v,
                $$.categoryName(v)
            ] : [
                v
            ]);
        } : currFormat;
    };
    Axis.prototype.getTickValues = function(id) {
        var $$ = this.owner;
        var tickValues = $$.config["axis_".concat(id, "_tick_values")];
        var axis = $$["".concat(id, "Axis")];
        return (isFunction(tickValues) ? tickValues.call($$.api) : tickValues) || (axis ? axis.tickValues() : undefined);
    };
    Axis.prototype.getLabelOptionByAxisId = function(id) {
        return this.owner.config["axis_".concat(id, "_label")];
    };
    Axis.prototype.getLabelText = function(id) {
        var option = this.getLabelOptionByAxisId(id);
        return isString(option) ? option : option ? option.text : null;
    };
    Axis.prototype.setLabelText = function(id, text) {
        var $$ = this.owner;
        var config = $$.config;
        var option = this.getLabelOptionByAxisId(id);
        if (isString(option)) config["axis_".concat(id, "_label")] = text;
        else if (option) option.text = text;
    };
    Axis.prototype.getLabelPosition = function(id, defaultPosition) {
        var isRotated = this.owner.config.axis_rotated;
        var option = this.getLabelOptionByAxisId(id);
        var position = isObjectType(option) && option.position ? option.position : defaultPosition[+!isRotated];
        var has = function(v) {
            return !!~position.indexOf(v);
        };
        return {
            isInner: has("inner"),
            isOuter: has("outer"),
            isLeft: has("left"),
            isCenter: has("center"),
            isRight: has("right"),
            isTop: has("top"),
            isMiddle: has("middle"),
            isBottom: has("bottom")
        };
    };
    Axis.prototype.getAxisLabelPosition = function(id) {
        return this.getLabelPosition(id, id === "x" ? [
            "inner-top",
            "inner-right"
        ] : [
            "inner-right",
            "inner-top"
        ]);
    };
    Axis.prototype.getLabelPositionById = function(id) {
        return this.getAxisLabelPosition(id);
    };
    Axis.prototype.xForAxisLabel = function(id) {
        var $$ = this.owner;
        var _a = $$.state, width = _a.width, height = _a.height;
        var position = this.getAxisLabelPosition(id);
        var x = position.isMiddle ? -height / 2 : 0;
        if (this.isHorizontal($$, id !== "x")) x = position.isLeft ? 0 : position.isCenter ? width / 2 : width;
        else if (position.isBottom) x = -height;
        return x;
    };
    Axis.prototype.dxForAxisLabel = function(id) {
        var $$ = this.owner;
        var position = this.getAxisLabelPosition(id);
        var dx = position.isBottom ? "0.5em" : "0";
        if (this.isHorizontal($$, id !== "x")) dx = position.isLeft ? "0.5em" : position.isRight ? "-0.5em" : "0";
        else if (position.isTop) dx = "-0.5em";
        return dx;
    };
    Axis.prototype.textAnchorForAxisLabel = function(id) {
        var $$ = this.owner;
        var position = this.getAxisLabelPosition(id);
        var anchor = position.isMiddle ? "middle" : "end";
        if (this.isHorizontal($$, id !== "x")) anchor = position.isLeft ? "start" : position.isCenter ? "middle" : "end";
        else if (position.isBottom) anchor = "start";
        return anchor;
    };
    Axis.prototype.dyForAxisLabel = function(id) {
        var $$ = this.owner;
        var config = $$.config;
        var isRotated = config.axis_rotated;
        var isInner = this.getAxisLabelPosition(id).isInner;
        var tickRotate = config["axis_".concat(id, "_tick_rotate")] ? $$.getHorizontalAxisHeight(id) : 0;
        var maxTickWidth = this.getMaxTickWidth(id);
        var dy;
        if (id === "x") {
            var xHeight = config.axis_x_height;
            if (isRotated) dy = isInner ? "1.2em" : -25 - maxTickWidth;
            else if (isInner) dy = "-0.5em";
            else if (xHeight) dy = xHeight - 10;
            else if (tickRotate) dy = tickRotate - 10;
            else dy = "3em";
        } else {
            dy = ({
                y: [
                    "-0.5em",
                    10,
                    "3em",
                    "1.2em",
                    10
                ],
                y2: [
                    "1.2em",
                    -20,
                    "-2.2em",
                    "-0.5em",
                    15
                ]
            })[id];
            if (isRotated) {
                if (isInner) dy = dy[0];
                else if (tickRotate) dy = tickRotate * (id === "y2" ? -1 : 1) - dy[1];
                else dy = dy[2];
            } else dy = isInner ? dy[3] : (dy[4] + (config["axis_".concat(id, "_inner")] ? 0 : maxTickWidth + dy[4])) * (id === "y" ? -1 : 1);
        }
        return dy;
    };
    Axis.prototype.getMaxTickWidth = function(id, withoutRecompute) {
        var $$ = this.owner;
        var config = $$.config, current = $$.state.current, _a = $$.$el, svg = _a.svg, chart = _a.chart;
        var currentTickMax = current.maxTickWidths[id];
        var maxWidth = 0;
        if (withoutRecompute || !config["axis_".concat(id, "_show")] || $$.filterTargetsToShow().length === 0) return currentTickMax.size;
        if (svg) {
            var isYAxis_1 = /^y2?$/.test(id);
            var targetsToShow = $$.filterTargetsToShow($$.data.targets);
            var scale = $$.scale[id].copy().domain($$["get".concat(isYAxis_1 ? "Y" : "X", "Domain")](targetsToShow, id));
            var domain = scale.domain();
            var isDomainSame = domain[0] === domain[1] && domain.every(function(v) {
                return v > 0;
            });
            var isCurrentMaxTickDomainSame = isArray(currentTickMax.domain) && currentTickMax.domain[0] === currentTickMax.domain[1] && currentTickMax.domain.every(function(v) {
                return v > 0;
            });
            // do not compute if domain or currentMaxTickDomain is same
            if (isDomainSame || isCurrentMaxTickDomainSame) return currentTickMax.size;
            else currentTickMax.domain = domain;
            // reset old max state value to prevent from new data loading
            if (!isYAxis_1) currentTickMax.ticks.splice(0);
            var axis = this.getAxis(id, scale, false, false, true);
            var tickCount = config["axis_".concat(id, "_tick_count")];
            var tickValues = config["axis_".concat(id, "_tick_values")];
            // Make to generate the final tick text to be rendered
            // https://github.com/naver/billboard.js/issues/920
            // Do not generate if 'tick values' option is given
            // https://github.com/naver/billboard.js/issues/1251
            if (!tickValues && tickCount) axis.tickValues(this.generateTickValues(domain, tickCount, isYAxis_1 ? this.isTimeSeriesY() : this.isTimeSeries()));
            !isYAxis_1 && this.updateXAxisTickValues(targetsToShow, axis);
            var dummy = chart.append("svg").style("visibility", "hidden").style("position", "fixed").style("top", "0px").style("left", "0px");
            axis.create(dummy);
            dummy.selectAll("text").each(function(d, i) {
                var currentTextWidth = this.getBoundingClientRect().width;
                maxWidth = Math.max(maxWidth, currentTextWidth);
                // cache tick text width for getXAxisTickTextY2Overflow()
                if (!isYAxis_1) currentTickMax.ticks[i] = currentTextWidth;
            });
            dummy.remove();
        }
        if (maxWidth > 0) currentTickMax.size = maxWidth;
        return currentTickMax.size;
    };
    Axis.prototype.getXAxisTickTextY2Overflow = function(defaultPadding) {
        var $$ = this.owner;
        var axis = $$.axis, config = $$.config, state = $$.state;
        var xAxisTickRotate = $$.getAxisTickRotate("x");
        var positiveRotation = xAxisTickRotate > 0 && xAxisTickRotate < 90;
        if ((axis.isCategorized() || axis.isTimeSeries()) && config.axis_x_tick_fit && !config.axis_x_tick_culling && !config.axis_x_tick_multiline && positiveRotation) {
            var widthWithoutCurrentPaddingLeft = state.current.width - $$.getCurrentPaddingLeft();
            var maxOverflow = this.getXAxisTickMaxOverflow(xAxisTickRotate, widthWithoutCurrentPaddingLeft - defaultPadding);
            var xAxisTickTextY2Overflow = Math.max(0, maxOverflow) + defaultPadding; // for display inconsistencies between browsers
            return Math.min(xAxisTickTextY2Overflow, widthWithoutCurrentPaddingLeft / 2);
        }
        return 0;
    };
    Axis.prototype.getXAxisTickMaxOverflow = function(xAxisTickRotate, widthWithoutCurrentPaddingLeft) {
        var $$ = this.owner;
        var axis = $$.axis, config = $$.config, state = $$.state;
        var isTimeSeries = axis.isTimeSeries();
        var tickTextWidths = state.current.maxTickWidths.x.ticks;
        var tickCount = tickTextWidths.length;
        var _a = state.axis.x.padding, left = _a.left, right = _a.right;
        var maxOverflow = 0;
        var remaining = tickCount - (isTimeSeries && config.axis_x_tick_fit ? 0.5 : 0);
        for(var i = 0; i < tickCount; i++){
            var tickIndex = i + 1;
            var rotatedTickTextWidth = Math.cos(Math.PI * xAxisTickRotate / 180) * tickTextWidths[i];
            var ticksBeforeTickText = tickIndex - (isTimeSeries ? 1 : 0.5) + left;
            // Skip ticks if there are no ticks before them
            if (ticksBeforeTickText <= 0) continue;
            var xAxisLengthWithoutTickTextWidth = widthWithoutCurrentPaddingLeft - rotatedTickTextWidth;
            var tickLength = xAxisLengthWithoutTickTextWidth / ticksBeforeTickText;
            var remainingTicks = remaining - tickIndex;
            var paddingRightLength = right * tickLength;
            var remainingTickWidth = remainingTicks * tickLength + paddingRightLength;
            var overflow = rotatedTickTextWidth - tickLength / 2 - remainingTickWidth;
            maxOverflow = Math.max(maxOverflow, overflow);
        }
        var filteredTargets = $$.filterTargetsToShow($$.data.targets);
        var tickOffset = 0;
        if (!isTimeSeries && config.axis_x_tick_count <= filteredTargets.length && filteredTargets[0].values.length) {
            var scale = getScale($$.axis.getAxisType("x"), 0, widthWithoutCurrentPaddingLeft - maxOverflow).domain([
                left * -1,
                $$.getXDomainMax($$.data.targets) + 1 + right
            ]);
            tickOffset = Math.ceil((scale(1) - scale(0)) / 2);
        }
        return maxOverflow + tickOffset;
    };
    /**
     * Get x Axis padding
     * @param {number} tickCount Tick count
     * @returns {object} Padding object values with 'left' & 'right' key
     * @private
     */ Axis.prototype.getXAxisPadding = function(tickCount) {
        var $$ = this.owner;
        var padding = $$.config.axis_x_padding;
        if (isEmpty(padding)) padding = {
            left: 0,
            right: 0
        };
        else {
            padding.left = padding.left || 0;
            padding.right = padding.right || 0;
        }
        if ($$.axis.isTimeSeries()) {
            var firstX = +$$.getXDomainMin($$.data.targets);
            var lastX = +$$.getXDomainMax($$.data.targets);
            var timeDiff = lastX - firstX;
            var range = timeDiff + padding.left + padding.right;
            var left = 0;
            var right = 0;
            if (tickCount && range) {
                var relativeTickWidth = timeDiff / tickCount / range;
                left = padding.left / range / relativeTickWidth;
                right = padding.right / range / relativeTickWidth;
            }
            padding = {
                left: left,
                right: right
            };
        }
        return padding;
    };
    Axis.prototype.updateLabels = function(withTransition) {
        var _this = this;
        var $$ = this.owner;
        var main = $$.$el.main;
        var labels = {
            x: main.select(".".concat(CLASS.axisX, " .").concat(CLASS.axisXLabel)),
            y: main.select(".".concat(CLASS.axisY, " .").concat(CLASS.axisYLabel)),
            y2: main.select(".".concat(CLASS.axisY2, " .").concat(CLASS.axisY2Label))
        };
        Object.keys(labels).filter(function(id) {
            return !labels[id].empty();
        }).forEach(function(v) {
            var node = labels[v];
            (withTransition ? node.transition() : node).attr("x", function() {
                return _this.xForAxisLabel(v);
            }).attr("dx", function() {
                return _this.dxForAxisLabel(v);
            }).attr("dy", function() {
                return _this.dyForAxisLabel(v);
            }).text(function() {
                return _this.getLabelText(v);
            });
        });
    };
    Axis.prototype.getPadding = function(padding, key, defaultValue, domainLength) {
        var p = isNumber(padding) ? padding : padding[key];
        if (!isValue(p)) return defaultValue;
        return this.convertPixelsToAxisPadding(p, domainLength);
    };
    Axis.prototype.convertPixelsToAxisPadding = function(pixels, domainLength) {
        var $$ = this.owner;
        var config = $$.config, _a = $$.state, width = _a.width, height = _a.height;
        var length = config.axis_rotated ? width : height;
        return domainLength * (pixels / length);
    };
    Axis.prototype.generateTickValues = function(values, tickCount, forTimeSeries) {
        var tickValues = values;
        if (tickCount) {
            var targetCount = isFunction(tickCount) ? tickCount() : tickCount;
            // compute ticks according to tickCount
            if (targetCount === 1) tickValues = [
                values[0]
            ];
            else if (targetCount === 2) tickValues = [
                values[0],
                values[values.length - 1]
            ];
            else if (targetCount > 2) {
                var isCategorized = this.isCategorized();
                var count = targetCount - 2;
                var start = values[0];
                var end = values[values.length - 1];
                var interval = (end - start) / (count + 1);
                var tickValue = void 0;
                // re-construct unique values
                tickValues = [
                    start
                ];
                for(var i = 0; i < count; i++){
                    tickValue = +start + interval * (i + 1);
                    tickValues.push(forTimeSeries ? new Date(tickValue) : isCategorized ? Math.round(tickValue) : tickValue);
                }
                tickValues.push(end);
            }
        }
        if (!forTimeSeries) tickValues = tickValues.sort(function(a, b) {
            return a - b;
        });
        return tickValues;
    };
    Axis.prototype.generateTransitions = function(duration) {
        var $$ = this.owner;
        var axis = $$.$el.axis;
        var _a = [
            "x",
            "y",
            "y2",
            "subX"
        ].map(function(v) {
            var ax = axis[v];
            if (ax && duration) ax = ax.transition().duration(duration);
            return ax;
        }), axisX = _a[0], axisY = _a[1], axisY2 = _a[2], axisSubX = _a[3];
        return {
            axisX: axisX,
            axisY: axisY,
            axisY2: axisY2,
            axisSubX: axisSubX
        };
    };
    Axis.prototype.redraw = function(transitions, isHidden, isInit) {
        var _this = this;
        var $$ = this.owner;
        var config = $$.config, $el = $$.$el;
        var opacity = isHidden ? "0" : "1";
        [
            "x",
            "y",
            "y2",
            "subX"
        ].forEach(function(id) {
            var axis = _this[id];
            var $axis = $el.axis[id];
            if (axis && $axis) {
                if (!isInit && !config.transition_duration) axis.config.withoutTransition = true;
                $axis.style("opacity", opacity);
                axis.create(transitions["axis".concat(capitalize(id))]);
            }
        });
        this.updateAxes();
    };
    /**
     * Redraw axis
     * @param {Array} targetsToShow targets data to be shown
     * @param {object} wth option object
     * @param {d3.Transition} transitions Transition object
     * @param {object} flow flow object
     * @param {boolean} isInit called from initialization
     * @private
     */ Axis.prototype.redrawAxis = function(targetsToShow, wth, transitions, flow, isInit) {
        var _this = this;
        var $$ = this.owner;
        var config = $$.config, scale = $$.scale, $el = $$.$el;
        var hasZoom = !!scale.zoom;
        var xDomainForZoom;
        if (!hasZoom && this.isCategorized() && targetsToShow.length === 0) scale.x.domain([
            0,
            $el.axis.x.selectAll(".tick").size()
        ]);
        if (scale.x && targetsToShow.length) {
            !hasZoom && $$.updateXDomain(targetsToShow, wth.UpdateXDomain, wth.UpdateOrgXDomain, wth.TrimXDomain);
            if (!config.axis_x_tick_values) this.updateXAxisTickValues(targetsToShow);
        } else if (this.x) {
            this.x.tickValues([]);
            this.subX && this.subX.tickValues([]);
        }
        if (config.zoom_rescale && !flow) xDomainForZoom = scale.x.orgDomain();
        [
            "y",
            "y2"
        ].forEach(function(key) {
            var axisScale = scale[key];
            if (axisScale) {
                var tickValues = config["axis_".concat(key, "_tick_values")];
                var tickCount = config["axis_".concat(key, "_tick_count")];
                axisScale.domain($$.getYDomain(targetsToShow, key, xDomainForZoom));
                if (!tickValues && tickCount) {
                    var axis = $$.axis[key];
                    var domain = axisScale.domain();
                    axis.tickValues(_this.generateTickValues(domain, domain.every(function(v) {
                        return v === 0;
                    }) ? 1 : tickCount, _this.isTimeSeriesY()));
                }
            }
        });
        // axes
        this.redraw(transitions, $$.hasArcType(), isInit);
        // Update axis label
        this.updateLabels(wth.Transition);
        // show/hide if manual culling needed
        if ((wth.UpdateXDomain || wth.UpdateXAxis || wth.Y) && targetsToShow.length) this.setCulling();
        // Update sub domain
        if (wth.Y) {
            scale.subY && scale.subY.domain($$.getYDomain(targetsToShow, "y"));
            scale.subY2 && scale.subY2.domain($$.getYDomain(targetsToShow, "y2"));
        }
    };
    /**
     * Set manual culling
     * @private
     */ Axis.prototype.setCulling = function() {
        var $$ = this.owner;
        var config = $$.config, _a = $$.state, clip = _a.clip, current = _a.current, $el = $$.$el;
        [
            "subX",
            "x",
            "y",
            "y2"
        ].forEach(function(type) {
            var axis = $el.axis[type];
            // subchart x axis should be aligned with x axis culling
            var id = type === "subX" ? "x" : type;
            var toCull = config["axis_".concat(id, "_tick_culling")];
            if (axis && toCull) {
                var tickText = axis.selectAll(".tick text");
                var tickValues_1 = sortValue(tickText.data());
                var tickSize = tickValues_1.length;
                var cullingMax = config["axis_".concat(id, "_tick_culling_max")];
                var intervalForCulling_1;
                if (tickSize) {
                    for(var i = 1; i < tickSize; i++)if (tickSize / i < cullingMax) {
                        intervalForCulling_1 = i;
                        break;
                    }
                    tickText.each(function(d) {
                        this.style.display = tickValues_1.indexOf(d) % intervalForCulling_1 ? "none" : "block";
                    });
                } else tickText.style("display", "block");
                // set/unset x_axis_tick_clippath
                if (type === "x") {
                    var clipPath = current.maxTickWidths.x.clipPath ? clip.pathXAxisTickTexts : null;
                    $el.svg.selectAll(".".concat(CLASS.axisX, " .tick text")).attr("clip-path", clipPath);
                }
            }
        });
    };
    return Axis;
}();
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var eventrect = {
    /**
     * Initialize the area that detects the event.
     * Add a container for the zone that detects the event.
     * @private
     */ initEventRect: function() {
        var $$ = this;
        $$.$el.main.select(".".concat(CLASS.chart)).append("g").attr("class", CLASS.eventRects).style("fill-opacity", "0");
    },
    /**
     * Redraws the area that detects the event.
     * @private
     */ redrawEventRect: function() {
        var $$ = this;
        var config = $$.config, state = $$.state, $el = $$.$el;
        var isMultipleX = $$.isMultipleX();
        if ($el.eventRect) $$.updateEventRect($el.eventRect, true);
        else {
            var eventRects = $$.$el.main.select(".".concat(CLASS.eventRects)).style("cursor", config.zoom_enabled && config.zoom_type !== "drag" ? config.axis_rotated ? "ns-resize" : "ew-resize" : null).classed(CLASS.eventRectsMultiple, isMultipleX).classed(CLASS.eventRectsSingle, !isMultipleX);
            // append event <rect>
            var eventRectUpdate = eventRects.selectAll(".".concat(CLASS.eventRect)).data([
                0
            ]).enter().append("rect");
            $$.updateEventRect(eventRectUpdate);
            // bind event to <rect> element
            isMultipleX ? $$.generateEventRectsForMultipleXs(eventRectUpdate) : $$.generateEventRectsForSingleX(eventRectUpdate);
            // bind draggable selection
            eventRectUpdate.call($$.getDraggableSelection());
            $el.eventRect = eventRectUpdate;
            if ($$.state.inputType === "touch" && !$el.svg.on("touchstart.eventRect") && !$$.hasArcType()) $$.bindTouchOnEventRect(isMultipleX);
        }
        if (!isMultipleX) {
            // Set data and update eventReceiver.data
            var xAxisTickValues = $$.getMaxDataCountTarget();
            // update data's index value to be alinged with the x Axis
            $$.updateDataIndexByX(xAxisTickValues);
            $$.updateXs(xAxisTickValues);
            $$.updatePointClass && $$.updatePointClass(true);
            state.eventReceiver.data = xAxisTickValues;
        }
        $$.updateEventRectData();
    },
    bindTouchOnEventRect: function(isMultipleX) {
        var $$ = this;
        var config = $$.config, state = $$.state, _a = $$.$el, eventRect = _a.eventRect, svg = _a.svg;
        var selectRect = function(context) {
            if (isMultipleX) $$.selectRectForMultipleXs(context);
            else {
                var index = $$.getDataIndexFromEvent((0, $iZ2is.event));
                $$.callOverOutForTouch(index);
                index === -1 ? $$.unselectRect() : $$.selectRectForSingle(context, eventRect, index);
            }
        };
        var unselectRect = function() {
            $$.unselectRect();
            $$.callOverOutForTouch();
        };
        // call event.preventDefault()
        // according 'interaction.inputType.touch.preventDefault' option
        var preventDefault = config.interaction_inputType_touch.preventDefault;
        var isPrevented = isboolean(preventDefault) && preventDefault || false;
        var preventThreshold = !isNaN(preventDefault) && preventDefault || null;
        var startPx;
        var preventEvent = function(event) {
            var eventType = event.type;
            var touch = event.changedTouches[0];
            var currentXY = touch["client".concat(config.axis_rotated ? "Y" : "X")];
            // prevent document scrolling
            if (eventType === "touchstart") {
                if (isPrevented) event.preventDefault();
                else if (preventThreshold !== null) startPx = currentXY;
            } else if (eventType === "touchmove") {
                if (isPrevented || startPx === true || preventThreshold !== null && Math.abs(startPx - currentXY) >= preventThreshold) {
                    // once prevented, keep prevented during whole 'touchmove' context
                    startPx = true;
                    event.preventDefault();
                }
            }
        };
        // bind touch events
        eventRect.on("touchstart", function() {
            return $$.updateEventRect();
        }).on("touchstart.eventRect touchmove.eventRect", function() {
            var event$1 = (0, $iZ2is.event);
            if (!eventRect.empty() && eventRect.classed(CLASS.eventRect)) {
                // if touch points are > 1, means doing zooming interaction. In this case do not execute tooltip codes.
                if (state.dragging || state.flowing || $$.hasArcType() || event$1.touches.length > 1) return;
                preventEvent(event$1);
                selectRect(eventRect.node());
            } else unselectRect();
        }, true).on("touchend.eventRect", function() {
            if (!eventRect.empty() && eventRect.classed(CLASS.eventRect)) {
                if ($$.hasArcType() || !$$.toggleShape || state.cancelClick) state.cancelClick && (state.cancelClick = false);
            }
        }, true);
        svg.on("touchstart", function() {
            var target = (0, $iZ2is.event).target;
            if (target && target !== eventRect.node()) unselectRect();
        });
    },
    /**
     * Update event rect size
     * @param {d3Selection} eventRect Event <rect> element
     * @param {boolean} force Force to update
     * @private
     */ updateEventRect: function(eventRect, force) {
        if (force === void 0) force = false;
        var $$ = this;
        var state = $$.state, $el = $$.$el;
        var eventReceiver = state.eventReceiver, width = state.width, height = state.height, rendered = state.rendered, resizing = state.resizing;
        var rectElement = eventRect || $el.eventRect;
        var updateClientRect = function() {
            eventReceiver && (eventReceiver.rect = rectElement.node().getBoundingClientRect());
        };
        if (!rendered || resizing || force) {
            rectElement.attr("x", 0).attr("y", 0).attr("width", width).attr("height", height);
            // only for init
            if (!rendered) rectElement.attr("class", CLASS.eventRect);
        }
        updateClientRect();
    },
    /**
     * Updates the location and size of the eventRect.
     * @private
     */ updateEventRectData: function() {
        var $$ = this;
        var config = $$.config, scale = $$.scale, state = $$.state;
        var xScale = scale.zoom || scale.x;
        var isRotated = config.axis_rotated;
        var x;
        var y;
        var w;
        var h;
        if ($$.isMultipleX()) {
            // TODO: rotated not supported yet
            x = 0;
            y = 0;
            w = state.width;
            h = state.height;
        } else {
            var rectW_1;
            var rectX = void 0;
            if ($$.axis.isCategorized()) {
                rectW_1 = $$.getEventRectWidth();
                rectX = function(d) {
                    return xScale(d.x) - rectW_1 / 2;
                };
            } else {
                var getPrevNextX_1 = function(_a) {
                    var index = _a.index;
                    return {
                        prev: $$.getPrevX(index),
                        next: $$.getNextX(index)
                    };
                };
                rectW_1 = function(d) {
                    var x = getPrevNextX_1(d);
                    // if there this is a single data point make the eventRect full width (or height)
                    if (x.prev === null && x.next === null) return isRotated ? state.height : state.width;
                    if (x.prev === null) x.prev = xScale.domain()[0];
                    if (x.next === null) x.next = xScale.domain()[1];
                    return Math.max(0, (xScale(x.next) - xScale(x.prev)) / 2);
                };
                rectX = function(d) {
                    var x = getPrevNextX_1(d);
                    var thisX = d.x;
                    // if there this is a single data point position the eventRect at 0
                    if (x.prev === null && x.next === null) return 0;
                    if (x.prev === null) x.prev = xScale.domain()[0];
                    return (xScale(thisX) + xScale(x.prev)) / 2;
                };
            }
            x = isRotated ? 0 : rectX;
            y = isRotated ? rectX : 0;
            w = isRotated ? state.width : rectW_1;
            h = isRotated ? rectW_1 : state.height;
        }
        var eventReceiver = state.eventReceiver;
        var call = function(fn, v) {
            return isFunction(fn) ? fn(v) : fn;
        };
        // reset for possible remains coords data before the data loading
        eventReceiver.coords.splice(eventReceiver.data.length);
        eventReceiver.data.forEach(function(d, i) {
            eventReceiver.coords[i] = {
                x: call(x, d),
                y: call(y, d),
                w: call(w, d),
                h: call(h, d)
            };
        });
    },
    selectRectForMultipleXs: function(context) {
        var $$ = this;
        var config = $$.config, state = $$.state;
        var targetsToShow = $$.filterTargetsToShow($$.data.targets);
        // do nothing when dragging
        if (state.dragging || $$.hasArcType(targetsToShow)) return;
        var mouse$1 = (0, $iS3vq.default)(context);
        var closest = $$.findClosestFromTargets(targetsToShow, mouse$1);
        if (state.mouseover && (!closest || closest.id !== state.mouseover.id)) {
            config.data_onout.call($$.api, state.mouseover);
            state.mouseover = undefined;
        }
        if (!closest) {
            $$.unselectRect();
            return;
        }
        var sameXData = $$.isBubbleType(closest) || $$.isScatterType(closest) || !config.tooltip_grouped ? [
            closest
        ] : $$.filterByX(targetsToShow, closest.x);
        // show tooltip when cursor is close to some point
        var selectedData = sameXData.map(function(d) {
            return $$.addName(d);
        });
        $$.showTooltip(selectedData, context);
        // expand points
        $$.expandCirclesBars(closest.index, closest.id, true);
        // Show xgrid focus line
        $$.showGridFocus(selectedData);
        // Show cursor as pointer if point is close to mouse position
        if ($$.isBarType(closest.id) || $$.dist(closest, mouse$1) < config.point_sensitivity) {
            $$.$el.svg.select(".".concat(CLASS.eventRect)).style("cursor", "pointer");
            if (!state.mouseover) {
                config.data_onover.call($$.api, closest);
                state.mouseover = closest;
            }
        }
    },
    /**
     * Unselect EventRect.
     * @private
     */ unselectRect: function() {
        var $$ = this;
        var config = $$.config, _a = $$.$el, bar = _a.bar, circle = _a.circle, tooltip = _a.tooltip;
        $$.$el.svg.select(".".concat(CLASS.eventRect)).style("cursor", null);
        $$.hideGridFocus();
        if (tooltip) {
            $$.hideTooltip();
            $$._handleLinkedCharts(false);
        }
        circle && !config.point_focus_only && $$.unexpandCircles();
        bar && $$.unexpandBars();
    },
    /**
     * Create eventRect for each data on the x-axis.
     * Register touch and drag events.
     * @param {object} eventRectEnter d3.select(CLASS.eventRects) object.
     * @returns {object} d3.select(CLASS.eventRects) object.
     * @private
     */ generateEventRectsForSingleX: function(eventRectEnter) {
        var $$ = this;
        var config = $$.config, state = $$.state;
        var eventReceiver = state.eventReceiver;
        var rect = eventRectEnter.style("cursor", config.data_selection_enabled && config.data_selection_grouped ? "pointer" : null).on("click", function() {
            var currentIdx = eventReceiver.currentIdx, data = eventReceiver.data;
            var d = data[currentIdx === -1 ? $$.getDataIndexFromEvent((0, $iZ2is.event)) : currentIdx];
            $$.clickHandlerForSingleX.bind(this)(d, $$);
        });
        if (state.inputType === "mouse") {
            var getData_1 = function() {
                var index = (0, $iZ2is.event) ? $$.getDataIndexFromEvent((0, $iZ2is.event)) : eventReceiver.currentIdx;
                return index > -1 ? eventReceiver.data[index] : null;
            };
            rect.on("mouseover", function() {
                return $$.updateEventRect();
            }).on("mousemove", function() {
                var d = getData_1();
                // do nothing while dragging/flowing
                if (state.dragging || state.flowing || $$.hasArcType() || !d || config.tooltip_grouped && d && d.index === eventReceiver.currentIdx) return;
                var index = d.index;
                if ($$.isStepType(d) && config.line_step_type === "step-after" && (0, $iS3vq.default)(this)[0] < $$.scale.x($$.getXValue(d.id, index))) index -= 1;
                if (index !== eventReceiver.currentIdx) {
                    $$.setOverOut(false, eventReceiver.currentIdx);
                    eventReceiver.currentIdx = index;
                }
                index === -1 ? $$.unselectRect() : $$.selectRectForSingle(this, rect, index);
                // As of individual data point(or <path>) element can't bind mouseover/out event
                // to determine current interacting element, so use 'mousemove' event instead.
                $$.setOverOut(index !== -1, index);
            }).on("mouseout", function() {
                // chart is destroyed
                if (!config || $$.hasArcType() || eventReceiver.currentIdx === -1) return;
                $$.unselectRect();
                $$.setOverOut(false, eventReceiver.currentIdx);
                // reset the event current index
                eventReceiver.currentIdx = -1;
            });
        }
        return rect;
    },
    clickHandlerForSingleX: function(d, ctx) {
        var $$ = ctx;
        var config = $$.config, state = $$.state, main = $$.$el.main;
        if (!d || $$.hasArcType() || state.cancelClick) {
            state.cancelClick && (state.cancelClick = false);
            return;
        }
        var index = d.index;
        main.selectAll(".".concat(CLASS.shape, "-").concat(index)).each(function(d2) {
            if (config.data_selection_grouped || $$.isWithinShape(this, d2)) {
                $$.toggleShape && $$.toggleShape(this, d2, index);
                config.data_onclick.bind($$.api)(d2, this);
            }
        });
    },
    /**
     * Create an eventRect,
     * Register touch and drag events.
     * @param {object} eventRectEnter d3.select(CLASS.eventRects) object.
     * @private
     */ generateEventRectsForMultipleXs: function(eventRectEnter) {
        var $$ = this;
        var inputType = $$.state.inputType;
        eventRectEnter.on("click", function() {
            $$.clickHandlerForMultipleXS.bind(this)($$);
        });
        if (inputType === "mouse") eventRectEnter.on("mouseover mousemove", function() {
            $$.selectRectForMultipleXs(this);
        }).on("mouseout", function() {
            // chart is destroyed
            if (!$$.config || $$.hasArcType()) return;
            $$.unselectRect();
        });
    },
    clickHandlerForMultipleXS: function(ctx) {
        var $$ = ctx;
        var config = $$.config;
        var targetsToShow = $$.filterTargetsToShow($$.data.targets);
        if ($$.hasArcType(targetsToShow)) return;
        var mouse$1 = (0, $iS3vq.default)(this);
        var closest = $$.findClosestFromTargets(targetsToShow, mouse$1);
        if (!closest) return;
        // select if selection enabled
        if ($$.isBarType(closest.id) || $$.dist(closest, mouse$1) < config.point_sensitivity) $$.$el.main.selectAll(".".concat(CLASS.shapes).concat($$.getTargetSelectorSuffix(closest.id))).selectAll(".".concat(CLASS.shape, "-").concat(closest.index)).each(function() {
            if (config.data_selection_grouped || $$.isWithinShape(this, closest)) {
                $$.toggleShape && $$.toggleShape(this, closest, closest.index);
                config.data_onclick.bind($$.api)(closest, this);
            }
        });
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var flow = {
    /**
     * Generate flow
     * @param {object} args option object
     * @returns {Function}
     * @private
     */ generateFlow: function(args) {
        var $$ = this;
        var data = $$.data, state = $$.state, $el = $$.$el;
        return function() {
            var flowLength = args.flow.length;
            // set flag
            state.flowing = true;
            // remove head data after rendered
            data.targets.forEach(function(d) {
                d.values.splice(0, flowLength);
            });
            // update elements related to x scale
            if ($$.updateXGrid) $$.updateXGrid(true);
            // target elements
            var elements = {};
            [
                "axis.x",
                "grid.x",
                "gridLines.x",
                "region.list",
                "text",
                "bar",
                "line",
                "area",
                "circle"
            ].forEach(function(v) {
                var name = v.split(".");
                var node = $el[name[0]];
                if (node && name.length > 1) node = node[name[1]];
                if (node && node.size()) elements[v] = node;
            });
            $$.hideGridFocus();
            $$.setFlowList(elements, args);
        };
    },
    /**
     * Set flow list
     * @param {object} elements Target elements
     * @param {object} args option object
     * @private
     */ setFlowList: function(elements, args) {
        var $$ = this;
        var flow = args.flow, targets = args.targets;
        var _a = flow.duration, duration = _a === void 0 ? args.duration : _a, flowIndex = flow.index, flowLength = flow.length, orgDataCount = flow.orgDataCount;
        var transform = $$.getFlowTransform(targets, orgDataCount, flowIndex, flowLength);
        var wait = generateWait();
        var gt = (0, $e9pyf.default)().ease((0, $4Nk74.linear)).duration(duration);
        wait.add(Object.keys(elements).map(function(v) {
            var n = elements[v];
            if (v === "axis.x") n = n.transition(gt).call(function(g) {
                return $$.axis.x.setTransition(gt).create(g);
            });
            else if (v === "region.list") n = n.filter($$.isRegionOnX).transition(gt).attr("transform", transform);
            else n = n.transition(gt).attr("transform", transform);
            return n;
        }));
        gt.call(wait, function() {
            $$.cleanUpFlow(elements, args);
        });
    },
    /**
     * Clean up flow
     * @param {object} elements Target elements
     * @param {object} args option object
     * @private
     */ cleanUpFlow: function(elements, args) {
        var $$ = this;
        var config = $$.config, state = $$.state, svg = $$.$el.svg;
        var isRotated = config.axis_rotated;
        var flow = args.flow, shape = args.shape, xv = args.xv;
        var _a = shape.pos, cx = _a.cx, cy = _a.cy, xForText = _a.xForText, yForText = _a.yForText;
        var _b = flow.done, done = _b === void 0 ? function() {} : _b, flowLength = flow.length;
        // Remove flowed elements
        if (flowLength) {
            [
                "circle",
                "text",
                "shape",
                "eventRect"
            ].forEach(function(v) {
                var target = [];
                for(var i = 0; i < flowLength; i++)target.push(".".concat(CLASS[v], "-").concat(i));
                svg.selectAll(".".concat(CLASS["".concat(v, "s")])) // circles, shapes, texts, eventRects
                .selectAll(target).remove();
            });
            svg.select(".".concat(CLASS.xgrid)).remove();
        }
        // draw again for removing flowed elements and reverting attr
        Object.keys(elements).forEach(function(v) {
            var n = elements[v];
            if (v !== "axis.x") n.attr("transform", null);
            if (v === "grid.x") n.attr(state.xgridAttr);
            else if (v === "gridLines.x") n.attr("x1", isRotated ? 0 : xv).attr("x2", isRotated ? state.width : xv);
            else if (v === "gridLines.x") {
                n.select("line").attr("x1", isRotated ? 0 : xv).attr("x2", isRotated ? state.width : xv);
                n.select("text").attr("x", isRotated ? state.width : 0).attr("y", xv);
            } else if (/^(area|bar|line)$/.test(v)) n.attr("d", shape.type[v]);
            else if (v === "text") n.attr("x", xForText).attr("y", yForText).style("fill-opacity", $$.opacityForText.bind($$));
            else if (v === "circle") {
                if ($$.isCirclePoint()) n.attr("cx", cx).attr("cy", cy);
                else {
                    var xFunc = function(d) {
                        return cx(d) - config.point_r;
                    };
                    var yFunc = function(d) {
                        return cy(d) - config.point_r;
                    };
                    n.attr("x", xFunc).attr("y", yFunc).attr("cx", cx) // when pattern is used, it possibly contain 'circle' also.
                    .attr("cy", cy);
                }
            } else if (v === "region.list") n.select("rect").filter($$.isRegionOnX).attr("x", $$.regionX.bind($$)).attr("width", $$.regionWidth.bind($$));
        });
        config.interaction_enabled && $$.redrawEventRect();
        // callback for end of flow
        done.call($$.api);
        state.flowing = false;
    },
    /**
     * Get flow transform value
     * @param {object} targets target
     * @param {number} orgDataCount original data count
     * @param {number} flowIndex flow index
     * @param {number} flowLength flow length
     * @returns {string}
     * @private
     */ getFlowTransform: function(targets, orgDataCount, flowIndex, flowLength) {
        var $$ = this;
        var data = $$.data, x = $$.scale.x;
        var dataValues = data.targets[0].values;
        var flowStart = $$.getValueOnIndex(dataValues, flowIndex);
        var flowEnd = $$.getValueOnIndex(dataValues, flowIndex + flowLength);
        var translateX;
        // update x domain to generate axis elements for flow
        var orgDomain = x.domain();
        var domain = $$.updateXDomain(targets, true, true);
        // generate transform to flow
        if (!orgDataCount) {
            if (dataValues.length !== 1) translateX = x(orgDomain[0]) - x(domain[0]);
            else if ($$.axis.isTimeSeries()) {
                flowStart = $$.getValueOnIndex(dataValues, 0);
                flowEnd = $$.getValueOnIndex(dataValues, dataValues.length - 1);
                translateX = x(flowStart.x) - x(flowEnd.x);
            } else translateX = diffDomain(domain) / 2;
        } else if (orgDataCount === 1 || (flowStart && flowStart.x) === (flowEnd && flowEnd.x)) translateX = x(orgDomain[0]) - x(domain[0]);
        else translateX = $$.axis.isTimeSeries() ? x(orgDomain[0]) - x(domain[0]) : x(flowStart.x) - x(flowEnd.x);
        var scaleX = diffDomain(orgDomain) / diffDomain(domain);
        return "translate(".concat(translateX, ",0) scale(").concat(scaleX, ",1)");
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var clip = {
    initClip: function() {
        var $$ = this;
        var clip = $$.state.clip;
        // MEMO: clipId needs to be unique because it conflicts when multiple charts exist
        clip.id = "".concat($$.state.datetimeId, "-clip");
        clip.idXAxis = "".concat(clip.id, "-xaxis");
        clip.idYAxis = "".concat(clip.id, "-yaxis");
        clip.idGrid = "".concat(clip.id, "-grid");
        // Define 'clip-path' attribute values
        clip.path = $$.getClipPath(clip.id);
        clip.pathXAxis = $$.getClipPath(clip.idXAxis);
        clip.pathYAxis = $$.getClipPath(clip.idYAxis);
        clip.pathGrid = $$.getClipPath(clip.idGrid);
    },
    getClipPath: function(id) {
        var $$ = this;
        var config = $$.config;
        if (!config.clipPath && /-clip$/.test(id) || !config.axis_x_clipPath && /-clip-xaxis$/.test(id) || !config.axis_y_clipPath && /-clip-yaxis$/.test(id)) return null;
        var isIE9 = win.navigator ? win.navigator.appVersion.toLowerCase().indexOf("msie 9.") >= 0 : false;
        return "url(".concat(isIE9 ? "" : doc.URL.split("#")[0], "#").concat(id, ")");
    },
    appendClip: function(parent, id) {
        id && parent.append("clipPath").attr("id", id).append("rect");
    },
    /**
     * Set x Axis clipPath dimension
     * @param {d3Selecton} node clipPath <rect> selection
     * @private
     */ setXAxisClipPath: function(node) {
        var $$ = this;
        var config = $$.config, _a = $$.state, margin = _a.margin, width = _a.width, height = _a.height;
        var isRotated = config.axis_rotated;
        var left = Math.max(30, margin.left) - (isRotated ? 0 : 20);
        var x = isRotated ? -(1 + left) : -(left - 1);
        var y = -Math.max(15, margin.top);
        var w = isRotated ? margin.left + 20 : width + 10 + left;
        // less than 20 is not enough to show the axis label 'outer' without legend
        var h = (isRotated ? margin.top + height + 10 : margin.bottom) + 20;
        node.attr("x", x).attr("y", y).attr("width", w).attr("height", h);
    },
    /**
     * Set y Axis clipPath dimension
     * @param {d3Selecton} node clipPath <rect> selection
     * @private
     */ setYAxisClipPath: function(node) {
        var $$ = this;
        var config = $$.config, _a = $$.state, margin = _a.margin, width = _a.width, height = _a.height;
        var isRotated = config.axis_rotated;
        var left = Math.max(30, margin.left) - (isRotated ? 20 : 0);
        var isInner = config.axis_y_inner;
        var x = isInner ? -1 : isRotated ? -(1 + left) : -(left - 1);
        var y = -(isRotated ? 20 : margin.top);
        var w = (isRotated ? width + 15 + left : margin.left + 20) + (isInner ? 20 : 0);
        var h = (isRotated ? margin.bottom : margin.top + height) + 10;
        node.attr("x", x).attr("y", y).attr("width", w).attr("height", h);
    },
    updateXAxisTickClip: function() {
        var $$ = this;
        var config = $$.config, _a = $$.state, clip = _a.clip, xAxisHeight = _a.xAxisHeight, defs = $$.$el.defs;
        var newXAxisHeight = $$.getHorizontalAxisHeight("x");
        if (defs && !clip.idXAxisTickTexts) {
            var clipId = "".concat(clip.id, "-xaxisticktexts");
            $$.appendClip(defs, clipId);
            clip.pathXAxisTickTexts = $$.getClipPath(clip.idXAxisTickTexts);
            clip.idXAxisTickTexts = clipId;
        }
        if (!config.axis_x_tick_multiline && $$.getAxisTickRotate("x") && newXAxisHeight !== xAxisHeight) {
            $$.setXAxisTickClipWidth();
            $$.setXAxisTickTextClipPathWidth();
        }
        $$.state.xAxisHeight = newXAxisHeight;
    },
    setXAxisTickClipWidth: function() {
        var $$ = this;
        var config = $$.config, maxTickWidths = $$.state.current.maxTickWidths;
        var xAxisTickRotate = $$.getAxisTickRotate("x");
        if (!config.axis_x_tick_multiline && xAxisTickRotate) {
            var sinRotation = Math.sin(Math.PI / 180 * Math.abs(xAxisTickRotate));
            maxTickWidths.x.clipPath = ($$.getHorizontalAxisHeight("x") - 20) / sinRotation;
        } else maxTickWidths.x.clipPath = null;
    },
    setXAxisTickTextClipPathWidth: function() {
        var $$ = this;
        var _a = $$.state, clip = _a.clip, current = _a.current, svg = $$.$el.svg;
        if (svg) svg.select("#".concat(clip.idXAxisTickTexts, " rect")).attr("width", current.maxTickWidths.x.clipPath).attr("height", 30);
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ // Grid position and text anchor helpers
var getGridTextAnchor = function(d) {
    return isValue(d.position) || "end";
};
var getGridTextDx = function(d) {
    return d.position === "start" ? 4 : d.position === "middle" ? 0 : -4;
};
/**
 * Get grid text x value getter function
 * @param {boolean} isX Is x Axis
 * @param {number} width Width value
 * @param {number} height Height value
 * @returns {Function}
 * @private
 */ function getGridTextX(isX, width, height) {
    return function(d) {
        var x = isX ? 0 : width;
        if (d.position === "start") x = isX ? -height : 0;
        else if (d.position === "middle") x = (isX ? -height : width) / 2;
        return x;
    };
}
/**
 * Update coordinate attributes value
 * @param {d3.selection} el Target node
 * @param {string} type Type
 * @private
 */ function smoothLines(el, type) {
    if (type === "grid") el.each(function() {
        var g = (0, $hOxpW.default)(this);
        [
            "x1",
            "x2",
            "y1",
            "y2"
        ].forEach(function(v) {
            return g.attr(v, Math.ceil(+g.attr(v)));
        });
    });
}
var grid = {
    hasGrid: function() {
        var config = this.config;
        return [
            "x",
            "y"
        ].some(function(v) {
            return config["grid_".concat(v, "_show")] || config["grid_".concat(v, "_lines")].length;
        });
    },
    initGrid: function() {
        var $$ = this;
        $$.hasGrid() && $$.initGridLines();
        $$.initFocusGrid();
    },
    initGridLines: function() {
        var $$ = this;
        var config = $$.config, clip = $$.state.clip, $el = $$.$el;
        if (config.grid_x_lines.length || config.grid_y_lines.length) {
            $el.gridLines.main = $el.main.insert("g", ".".concat(CLASS.chart).concat(config.grid_lines_front ? " + *" : "")).attr("clip-path", clip.pathGrid).attr("class", "".concat(CLASS.grid, " ").concat(CLASS.gridLines));
            $el.gridLines.main.append("g").attr("class", CLASS.xgridLines);
            $el.gridLines.main.append("g").attr("class", CLASS.ygridLines);
            $el.gridLines.x = (0, $jJCd9.default)([]);
        }
    },
    updateXGrid: function(withoutUpdate) {
        var $$ = this;
        var config = $$.config, scale = $$.scale, state = $$.state, _a = $$.$el, main = _a.main, grid = _a.grid;
        var isRotated = config.axis_rotated;
        var xgridData = $$.generateGridData(config.grid_x_type, scale.x);
        var tickOffset = $$.axis.isCategorized() ? $$.axis.x.tickOffset() : 0;
        var pos = function(d) {
            return (scale.zoom || scale.x)(d) + tickOffset * (isRotated ? -1 : 1);
        };
        state.xgridAttr = isRotated ? {
            "x1": 0,
            "x2": state.width,
            "y1": pos,
            "y2": pos
        } : {
            "x1": pos,
            "x2": pos,
            "y1": 0,
            "y2": state.height
        };
        grid.x = main.select(".".concat(CLASS.xgrids)).selectAll(".".concat(CLASS.xgrid)).data(xgridData);
        grid.x.exit().remove();
        grid.x = grid.x.enter().append("line").attr("class", CLASS.xgrid).merge(grid.x);
        if (!withoutUpdate) grid.x.each(function() {
            var grid = (0, $hOxpW.default)(this);
            Object.keys(state.xgridAttr).forEach(function(id) {
                grid.attr(id, state.xgridAttr[id]).style("opacity", function() {
                    return grid.attr(isRotated ? "y1" : "x1") === (isRotated ? state.height : 0) ? "0" : "1";
                });
            });
        });
    },
    updateYGrid: function() {
        var $$ = this;
        var config = $$.config, state = $$.state, _a = $$.$el, grid = _a.grid, main = _a.main;
        var isRotated = config.axis_rotated;
        var gridValues = $$.axis.y.tickValues() || $$.scale.y.ticks(config.grid_y_ticks);
        var pos = function(d) {
            return Math.ceil($$.scale.y(d));
        };
        grid.y = main.select(".".concat(CLASS.ygrids)).selectAll(".".concat(CLASS.ygrid)).data(gridValues);
        grid.y.exit().remove();
        grid.y = grid.y.enter().append("line").attr("class", CLASS.ygrid).merge(grid.y);
        grid.y.attr("x1", isRotated ? pos : 0).attr("x2", isRotated ? pos : state.width).attr("y1", isRotated ? 0 : pos).attr("y2", isRotated ? state.height : pos);
        smoothLines(grid.y, "grid");
    },
    updateGrid: function(duration) {
        var $$ = this;
        var _a = $$.$el, grid = _a.grid, gridLines = _a.gridLines;
        !gridLines.main && $$.initGridLines();
        // hide if arc type
        grid.main.style("visibility", $$.hasArcType() ? "hidden" : "visible");
        $$.hideGridFocus();
        $$.updateXGridLines(duration);
        $$.updateYGridLines(duration);
    },
    /**
     * Update X Grid lines
     * @param {number} duration Dration value
     * @private
     */ updateXGridLines: function(duration) {
        var $$ = this;
        var config = $$.config, _a = $$.$el, gridLines = _a.gridLines, main = _a.main;
        var isRotated = config.axis_rotated;
        config.grid_x_show && $$.updateXGrid();
        var xLines = main.select(".".concat(CLASS.xgridLines)).selectAll(".".concat(CLASS.xgridLine)).data(config.grid_x_lines);
        // exit
        xLines.exit().transition().duration(duration).style("opacity", "0").remove();
        // enter
        var xgridLine = xLines.enter().append("g");
        xgridLine.append("line").style("opacity", "0");
        xgridLine.append("text").attr("transform", isRotated ? "" : "rotate(-90)").attr("dy", -5).style("opacity", "0");
        xLines = xgridLine.merge(xLines);
        xLines.attr("class", function(d) {
            return "".concat(CLASS.xgridLine, " ").concat(d["class"] || "").trim();
        }).select("text").attr("text-anchor", getGridTextAnchor).attr("dx", getGridTextDx).transition().duration(duration).text(function(d) {
            return d.text;
        }).transition().style("opacity", "1");
        gridLines.x = xLines;
    },
    /**
     * Update Y Grid lines
     * @param {number} duration Duration value
     * @private
     */ updateYGridLines: function(duration) {
        var $$ = this;
        var config = $$.config, _a = $$.state, width = _a.width, height = _a.height, $el = $$.$el;
        var isRotated = config.axis_rotated;
        config.grid_y_show && $$.updateYGrid();
        var ygridLines = $el.main.select(".".concat(CLASS.ygridLines)).selectAll(".".concat(CLASS.ygridLine)).data(config.grid_y_lines);
        // exit
        ygridLines.exit().transition().duration(duration).style("opacity", "0").remove();
        // enter
        var ygridLine = ygridLines.enter().append("g");
        ygridLine.append("line").style("opacity", "0");
        ygridLine.append("text").attr("transform", isRotated ? "rotate(-90)" : "").style("opacity", "0");
        ygridLines = ygridLine.merge(ygridLines);
        // update
        var yv = $$.yv.bind($$);
        ygridLines.attr("class", function(d) {
            return "".concat(CLASS.ygridLine, " ").concat(d["class"] || "").trim();
        }).select("line").transition().duration(duration).attr("x1", isRotated ? yv : 0).attr("x2", isRotated ? yv : width).attr("y1", isRotated ? 0 : yv).attr("y2", isRotated ? height : yv).transition().style("opacity", "1");
        ygridLines.select("text").attr("text-anchor", getGridTextAnchor).attr("dx", getGridTextDx).transition().duration(duration).attr("dy", -5).attr("x", getGridTextX(isRotated, width, height)).attr("y", yv).text(function(d) {
            return d.text;
        }).transition().style("opacity", "1");
        $el.gridLines.y = ygridLines;
    },
    redrawGrid: function(withTransition) {
        var $$ = this;
        var isRotated = $$.config.axis_rotated, _a = $$.state, width = _a.width, height = _a.height, gridLines = $$.$el.gridLines;
        var xv = $$.xv.bind($$);
        var lines = gridLines.x.select("line");
        var texts = gridLines.x.select("text");
        lines = (withTransition ? lines.transition() : lines).attr("x1", isRotated ? 0 : xv).attr("x2", isRotated ? width : xv).attr("y1", isRotated ? xv : 0).attr("y2", isRotated ? xv : height);
        texts = (withTransition ? texts.transition() : texts).attr("x", getGridTextX(!isRotated, width, height)).attr("y", xv).text(function(d) {
            return d.text;
        });
        return [
            lines.style("opacity", "1"),
            texts.style("opacity", "1")
        ];
    },
    initFocusGrid: function() {
        var $$ = this;
        var config = $$.config, clip = $$.state.clip, $el = $$.$el;
        var isFront = config.grid_front;
        var className = ".".concat(CLASS[isFront && $el.gridLines.main ? "gridLines" : "chart"]).concat(isFront ? " + *" : "");
        var grid = $el.main.insert("g", className).attr("clip-path", clip.pathGrid).attr("class", CLASS.grid);
        $el.grid.main = grid;
        config.grid_x_show && grid.append("g").attr("class", CLASS.xgrids);
        config.grid_y_show && grid.append("g").attr("class", CLASS.ygrids);
        if (config.interaction_enabled && config.grid_focus_show) {
            grid.append("g").attr("class", CLASS.xgridFocus).append("line").attr("class", CLASS.xgridFocus);
            // to show xy focus grid line, should be 'tooltip.grouped=false'
            if (config.grid_focus_y && !config.tooltip_grouped) grid.append("g").attr("class", CLASS.ygridFocus).append("line").attr("class", CLASS.ygridFocus);
        }
    },
    /**
     * Show grid focus line
     * @param {Array} data Selected data
     * @private
     */ showGridFocus: function(data) {
        var $$ = this;
        var config = $$.config, _a = $$.state, width = _a.width, height = _a.height;
        var isRotated = config.axis_rotated;
        var focusEl = $$.$el.main.selectAll("line.".concat(CLASS.xgridFocus, ", line.").concat(CLASS.ygridFocus));
        var dataToShow = (data || [
            focusEl.datum()
        ]).filter(function(d) {
            return d && isValue($$.getBaseValue(d));
        });
        // Hide when bubble/scatter/stanford plot exists
        if (!config.tooltip_show || dataToShow.length === 0 || $$.hasType("bubble") || $$.hasArcType()) return;
        var isEdge = config.grid_focus_edge && !config.tooltip_grouped;
        var xx = $$.xx.bind($$);
        focusEl.style("visibility", "visible").data(dataToShow.concat(dataToShow)).each(function(d) {
            var el = (0, $hOxpW.default)(this);
            var pos = {
                x: xx(d),
                y: $$.getYScaleById(d.id)(d.value)
            };
            var xy;
            if (el.classed(CLASS.xgridFocus)) // will contain 'x1, y1, x2, y2' order
            xy = isRotated ? [
                null,
                pos.x,
                isEdge ? pos.y : width,
                pos.x // y2
            ] : [
                pos.x,
                isEdge ? pos.y : null,
                pos.x,
                height
            ];
            else {
                var isY2 = $$.axis.getId(d.id) === "y2";
                xy = isRotated ? [
                    pos.y,
                    isEdge && !isY2 ? pos.x : null,
                    pos.y,
                    isEdge && isY2 ? pos.x : height // y2
                ] : [
                    isEdge && isY2 ? pos.x : null,
                    pos.y,
                    isEdge && !isY2 ? pos.x : width,
                    pos.y
                ];
            }
            [
                "x1",
                "y1",
                "x2",
                "y2"
            ].forEach(function(v, i) {
                return el.attr(v, xy[i]);
            });
        });
        smoothLines(focusEl, "grid");
        $$.showCircleFocus && $$.showCircleFocus(data);
    },
    hideGridFocus: function() {
        var $$ = this;
        var _a = $$.state, inputType = _a.inputType, resizing = _a.resizing, main = $$.$el.main;
        if (inputType === "mouse" || !resizing) {
            main.selectAll("line.".concat(CLASS.xgridFocus, ", line.").concat(CLASS.ygridFocus)).style("visibility", "hidden");
            $$.hideCircleFocus && $$.hideCircleFocus();
        }
    },
    updateGridFocus: function() {
        var $$ = this;
        var _a = $$.state, inputType = _a.inputType, width = _a.width, height = _a.height, resizing = _a.resizing, grid = $$.$el.grid;
        var xgridFocus = grid.main.select("line.".concat(CLASS.xgridFocus));
        if (inputType === "touch") {
            if (xgridFocus.empty()) resizing && $$.showCircleFocus();
            else $$.showGridFocus();
        } else {
            var isRotated = $$.config.axis_rotated;
            xgridFocus.attr("x1", isRotated ? 0 : -10).attr("x2", isRotated ? width : -10).attr("y1", isRotated ? -10 : 0).attr("y2", isRotated ? -10 : height);
        }
        // need to return 'true' as of being pushed to the redraw list
        // ref: getRedrawList()
        return true;
    },
    generateGridData: function(type, scale) {
        var $$ = this;
        var tickNum = $$.$el.main.select(".".concat(CLASS.axisX)).selectAll(".tick").size();
        var gridData = [];
        if (type === "year") {
            var xDomain = $$.getXDomain();
            var firstYear = xDomain[0].getFullYear();
            var lastYear = xDomain[1].getFullYear();
            for(var i = firstYear; i <= lastYear; i++)gridData.push(new Date("".concat(i, "-01-01 00:00:00")));
        } else {
            gridData = scale.ticks(10);
            if (gridData.length > tickNum) gridData = gridData.filter(function(d) {
                return String(d).indexOf(".") < 0;
            });
        }
        return gridData;
    },
    getGridFilterToRemove: function(params) {
        return params ? function(line) {
            var found = false;
            (isArray(params) ? params.concat() : [
                params
            ]).forEach(function(param) {
                if ("value" in param && line.value === param.value || "class" in param && line["class"] === param["class"]) found = true;
            });
            return found;
        } : function() {
            return true;
        };
    },
    removeGridLines: function(params, forX) {
        var $$ = this;
        var config = $$.config;
        var toRemove = $$.getGridFilterToRemove(params);
        var toShow = function(line) {
            return !toRemove(line);
        };
        var classLines = forX ? CLASS.xgridLines : CLASS.ygridLines;
        var classLine = forX ? CLASS.xgridLine : CLASS.ygridLine;
        $$.$el.main.select(".".concat(classLines)).selectAll(".".concat(classLine)).filter(toRemove).transition().duration(config.transition_duration).style("opacity", "0").remove();
        var gridLines = "grid_".concat(forX ? "x" : "y", "_lines");
        config[gridLines] = config[gridLines].filter(toShow);
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var region = {
    initRegion: function() {
        var $$ = this;
        var $el = $$.$el;
        $el.region.main = $el.main.append("g").attr("clip-path", $$.state.clip.path).attr("class", CLASS.regions);
    },
    updateRegion: function(duration) {
        var $$ = this;
        var config = $$.config, $el = $$.$el;
        if (!$el.region.main) $$.initRegion();
        // hide if arc type
        $el.region.main.style("visibility", $$.hasArcType() ? "hidden" : "visible");
        // select <g> element
        var list = $el.main.select(".".concat(CLASS.regions)).selectAll(".".concat(CLASS.region)).data(config.regions);
        list.exit().transition().duration(duration).style("opacity", "0").remove();
        list = list.enter().append("g").merge(list).attr("class", $$.classRegion.bind($$));
        list.append("rect").style("fill-opacity", "0");
        $el.region.list = list;
    },
    redrawRegion: function(withTransition) {
        var $$ = this;
        var regions = $$.$el.region.list.select("rect");
        regions = (withTransition ? regions.transition() : regions).attr("x", $$.regionX.bind($$)).attr("y", $$.regionY.bind($$)).attr("width", $$.regionWidth.bind($$)).attr("height", $$.regionHeight.bind($$));
        return [
            (withTransition ? regions.transition() : regions).style("fill-opacity", function(d) {
                return isValue(d.opacity) ? d.opacity : "0.1";
            }).on("end", function() {
                // remove unnecessary rect after transition
                (0, $hOxpW.default)(this.parentNode).selectAll("rect:not([x])").remove();
            })
        ];
    },
    getRegionXY: function(type, d) {
        var $$ = this;
        var config = $$.config, scale = $$.scale;
        var isRotated = config.axis_rotated;
        var isX = type === "x";
        var key = "start";
        var currScale;
        var pos = 0;
        if (d.axis === "y" || d.axis === "y2") {
            if (!isX) key = "end";
            if ((isX ? isRotated : !isRotated) && key in d) {
                currScale = scale[d.axis];
                pos = currScale(d[key]);
            }
        } else if ((isX ? !isRotated : isRotated) && key in d) {
            currScale = scale.zoom || scale.x;
            pos = currScale($$.axis.isTimeSeries() ? parseDate.call($$, d[key]) : d[key]);
        }
        return pos;
    },
    regionX: function(d) {
        return this.getRegionXY("x", d);
    },
    regionY: function(d) {
        return this.getRegionXY("y", d);
    },
    getRegionSize: function(type, d) {
        var $$ = this;
        var config = $$.config, scale = $$.scale, state = $$.state;
        var isRotated = config.axis_rotated;
        var isWidth = type === "width";
        var start = $$[isWidth ? "regionX" : "regionY"](d);
        var currScale;
        var key = "end";
        var end = state[type];
        if (d.axis === "y" || d.axis === "y2") {
            if (!isWidth) key = "start";
            if ((isWidth ? isRotated : !isRotated) && key in d) {
                currScale = scale[d.axis];
                end = currScale(d[key]);
            }
        } else if ((isWidth ? !isRotated : isRotated) && key in d) {
            currScale = scale.zoom || scale.x;
            end = currScale($$.axis.isTimeSeries() ? parseDate.call($$, d[key]) : d[key]);
        }
        return end < start ? 0 : end - start;
    },
    regionWidth: function(d) {
        return this.getRegionSize("width", d);
    },
    regionHeight: function(d) {
        return this.getRegionSize("height", d);
    },
    isRegionOnX: function(d) {
        return !d.axis || d.axis === "x";
    }
};
var sizeAxis = {
    /**
     * Get Axis size according its position
     * @param {string} id Axis id value - x, y or y2
     * @returns {number} size Axis size value
     * @private
     */ getAxisSize: function(id) {
        var $$ = this;
        var isRotated = $$.config.axis_rotated;
        return isRotated && id === "x" || !isRotated && /y2?/.test(id) ? $$.getAxisWidthByAxisId(id, true) : $$.getHorizontalAxisHeight(id);
    },
    getAxisWidthByAxisId: function(id, withoutRecompute) {
        var $$ = this;
        if ($$.axis) {
            var position = $$.axis && $$.axis.getLabelPositionById(id);
            return $$.axis.getMaxTickWidth(id, withoutRecompute) + (position.isInner ? 20 : 40);
        } else return 40;
    },
    getHorizontalAxisHeight: function(id) {
        var $$ = this;
        var config = $$.config, state = $$.state;
        var current = state.current, rotatedPadding = state.rotatedPadding, isLegendRight = state.isLegendRight, isLegendInset = state.isLegendInset;
        var isRotated = config.axis_rotated;
        var h = 30;
        if (id === "x" && !config.axis_x_show) return 8;
        if (id === "x" && config.axis_x_height) return config.axis_x_height;
        if (id === "y" && !config.axis_y_show) return config.legend_show && !isLegendRight && !isLegendInset ? 10 : 1;
        if (id === "y2" && !config.axis_y2_show) return rotatedPadding.top;
        var rotate = $$.getAxisTickRotate(id);
        // Calculate x/y axis height when tick rotated
        if ((id === "x" && !isRotated || /y2?/.test(id) && isRotated) && rotate) {
            h = 30 + $$.axis.getMaxTickWidth(id) * Math.cos(Math.PI * (90 - rotate) / 180);
            if (!config.axis_x_tick_multiline && current.height) {
                if (h > current.height / 2) h = current.height / 2;
            }
        }
        return h + ($$.axis.getLabelPositionById(id).isInner ? 0 : 10) + (id === "y2" && !isRotated ? -10 : 0);
    },
    getEventRectWidth: function() {
        return Math.max(0, this.axis.x.tickInterval());
    },
    /**
     * Get axis tick test rotate value
     * @param {string} id Axis id
     * @returns {number} rotate value
     * @private
     */ getAxisTickRotate: function(id) {
        var $$ = this;
        var axis = $$.axis, config = $$.config, state = $$.state, $el = $$.$el;
        var rotate = config["axis_".concat(id, "_tick_rotate")];
        if (id === "x") {
            var allowedXAxisTypes = axis.isCategorized() || axis.isTimeSeries();
            if (config.axis_x_tick_fit && allowedXAxisTypes) {
                var xTickCount = config.axis_x_tick_count;
                var currentXTicksLength = state.current.maxTickWidths.x.ticks.length;
                var tickCount = 0;
                if (xTickCount) tickCount = xTickCount > currentXTicksLength ? currentXTicksLength : xTickCount;
                else if (currentXTicksLength) tickCount = currentXTicksLength;
                if (tickCount !== state.axis.x.tickCount) state.axis.x.padding = $$.axis.getXAxisPadding(tickCount);
                state.axis.x.tickCount = tickCount;
            }
            if ($el.svg && config.axis_x_tick_fit && !config.axis_x_tick_multiline && !config.axis_x_tick_culling && config.axis_x_tick_autorotate && allowedXAxisTypes) rotate = $$.needToRotateXAxisTickTexts() ? config.axis_x_tick_rotate : 0;
        }
        return rotate;
    },
    /**
     * Check weather axis tick text needs to be rotated
     * @returns {boolean}
     * @private
     */ needToRotateXAxisTickTexts: function() {
        var $$ = this;
        var _a = $$.state, axis = _a.axis, current = _a.current;
        var xAxisLength = current.width - $$.getCurrentPaddingLeft(false) - $$.getCurrentPaddingRight();
        var tickCountWithPadding = axis.x.tickCount + axis.x.padding.left + axis.x.padding.right;
        var maxTickWidth = $$.axis.getMaxTickWidth("x");
        var tickLength = tickCountWithPadding ? xAxisLength / tickCountWithPadding : 0;
        return maxTickWidth > tickLength;
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * Axis based chart data config options
 */ var optDataAxis = {
    /**
     * Specify the keys of the x values for each data.<br><br>
     * This option can be used if we want to show the data that has different x values.
     * @name data․xs
     * @memberof Options
     * @type {object}
     * @default {}
     * @example
     * data: {
     *   xs: {
     *      data1: "x1",
     *      data2: "x2"
     *   }
     * }
     */ data_xs: {},
    /**
     * Set a format specifier to parse string specifed as x.
     * @name data․xFormat
     * @memberof Options
     * @type {string}
     * @default %Y-%m-%d
     * @example
     * data: {
     *    x: "x",
     *    columns: [
     *        ["x", "01012019", "02012019", "03012019"],
     *        ["data1", 30, 200, 100]
     *    ],
     *    // Format specifier to parse as datetime for given 'x' string value
     *    xFormat: "%m%d%Y"
     * },
     * axis: {
     *    x: {
     *        type: "timeseries"
     *    }
     * }
     * @see [D3's time specifier](https://github.com/d3/d3-time-format#locale_format)
     */ data_xFormat: "%Y-%m-%d",
    /**
     * Set localtime format to parse x axis.
     * @name data․xLocaltime
     * @memberof Options
     * @type {boolean}
     * @default true
     * @example
     * data: {
     *   xLocaltime: false
     * }
     */ data_xLocaltime: true,
    /**
     * Sort on x axis.
     * @name data․xSort
     * @memberof Options
     * @type {boolean}
     * @default true
     * @example
     * data: {
     *   xSort: false
     * }
     */ data_xSort: true,
    /**
     * Set y axis the data related to. y and y2 can be used.
     * - **NOTE:** If all data is related to one of the axes, the domain of axis without related data will be replaced by the domain from the axis with related data
     * @name data․axes
     * @memberof Options
     * @type {object}
     * @default {}
     * @example
     * data: {
     *   axes: {
     *     data1: "y",
     *     data2: "y2"
     *   }
     * }
     */ data_axes: {},
    /**
     * Define regions for each data.<br>
     * The values must be an array for each data and it should include an object that has `start`, `end` and `style`.
     * - The object type should be as:
     *   - start {number}: Start data point number. If not set, the start will be the first data point.
     *   - [end] {number}: End data point number. If not set, the end will be the last data point.
     *   - [style.dasharray="2 2"] {object}: The first number specifies a distance for the filled area, and the second a distance for the unfilled area.
     * - **NOTE:** Currently this option supports only line chart and dashed style. If this option specified, the line will be dashed only in the regions.
     * @name data․regions
     * @memberof Options
     * @type {object}
     * @default {}
     * @example
     * data: {
     *   regions: {
     *     data1: [{
     *         start: 1,
     *         end: 2,
     *         style: {
     *             dasharray: "5 2"
     *         }
     *     }, {
     *         start: 3
     *     }],
     *     ...
     *   }
     * }
     */ data_regions: {},
    /**
     * Set the stacking to be normalized
     * - **NOTE:**
     *   - For stacking, '[data.groups](#.data%25E2%2580%25A4groups)' option should be set
     *   - y Axis will be set in percentage value (0 ~ 100%)
     *   - Must have postive values
     * @name data․stack․normalize
     * @memberof Options
     * @type {boolean}
     * @default false
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Data.DataStackNormalized)
     * @example
     * data: {
     *   stack: {
     *      normalize: true
     *   }
     * }
     */ data_stack_normalize: false
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * x Axis config options
 */ var x = {
    /**
     * Set clip-path attribute for x axis element
     * @name axis․x․clipPath
     * @memberof Options
     * @type {boolean}
     * @default true
     * @see [Demo]()
     * @example
     * // don't set 'clip-path' attribute
     * clipPath: false
     */ axis_x_clipPath: true,
    /**
     * Show or hide x axis.
     * @name axis․x․show
     * @memberof Options
     * @type {boolean}
     * @default true
     * @example
     * axis: {
     *   x: {
     *     show: false
     *   }
     * }
     */ axis_x_show: true,
    /**
     * Set type of x axis.<br><br>
     * **Available Values:**
     * - category
     * - indexed
     * - log
     * - timeseries
     *
     * **NOTE:**<br>
     * - **log** type:
     *   - the x values specified by [`data.x`](#.data%25E2%2580%25A4x)(or by any equivalent option), must be exclusively-positive.
     *   - x axis min value should be >= 0.
     *
     * @name axis․x․type
     * @memberof Options
     * @type {string}
     * @default indexed
     * @see [Demo: indexed](https://naver.github.io/billboard.js/demo/#Chart.AreaChart)
     * @see [Demo: timeseries](https://naver.github.io/billboard.js/demo/#Chart.TimeseriesChart)
     * @see [Demo: category](https://naver.github.io/billboard.js/demo/#Data.CategoryData)
     * @see [Demo: log](https://naver.github.io/billboard.js/demo/#Axis.LogScales)
     * @example
     * axis: {
     *   x: {
     *     type: "timeseries"
     *   }
     * }
     */ axis_x_type: "indexed",
    /**
     * Set how to treat the timezone of x values.<br>
     * If true, treat x value as localtime. If false, convert to UTC internally.
     * @name axis․x․localtime
     * @memberof Options
     * @type {boolean}
     * @default true
     * @example
     * axis: {
     *   x: {
     *     localtime: false
     *   }
     * }
     */ axis_x_localtime: true,
    /**
     * Set category names on category axis.
     * This must be an array that includes category names in string. If category names are included in the date by data.x option, this is not required.
     * @name axis․x․categories
     * @memberof Options
     * @type {Array}
     * @default []
     * @example
     * axis: {
     *   x: {
     *     categories: ["Category 1", "Category 2", ...]
     *   }
     * }
     */ axis_x_categories: [],
    /**
     * centerize ticks on category axis.
     * @name axis․x․tick․centered
     * @memberof Options
     * @type {boolean}
     * @default false
     * @example
     * axis: {
     *   x: {
     *     tick: {
     *       centered: true
     *     }
     *   }
     * }
     */ axis_x_tick_centered: false,
    /**
     * A function to format tick value. Format string is also available for timeseries data.
     * @name axis․x․tick․format
     * @memberof Options
     * @type {Function|string}
     * @default undefined
     * @see [D3's time specifier](https://github.com/d3/d3-time-format#locale_format)
     * @example
     * axis: {
     *   x: {
     *     tick: {
     *        // for timeseries, a 'datetime' object is given as parameter
     *       format: function(x) {
     *           return x.getFullYear();
     *       }
     *
     *       // for category, index(Number) and categoryName(String) are given as parameter
     *       format: function(index, categoryName) {
     *           return categoryName.substr(0, 10);
     *       },
     *
     *        // for timeseries format specifier
     *        format: "%Y-%m-%d %H:%M:%S"
     *     }
     *   }
     * }
     */ axis_x_tick_format: undefined,
    /**
     * Setting for culling ticks.<br><br>
     * If true is set, the ticks will be culled, then only limitted tick text will be shown. This option does not hide the tick lines. If false is set, all of ticks will be shown.<br><br>
     * We can change the number of ticks to be shown by axis.x.tick.culling.max.
     * @name axis․x․tick․culling
     * @memberof Options
     * @type {boolean}
     * @default
     * - true for indexed axis and timeseries axis
     * - false for category axis
     * @example
     * axis: {
     *   x: {
     *     tick: {
     *       culling: false
     *     }
     *   }
     * }
     */ axis_x_tick_culling: {},
    /**
     * The number of tick texts will be adjusted to less than this value.
     * @name axis․x․tick․culling․max
     * @memberof Options
     * @type {number}
     * @default 10
     * @example
     * axis: {
     *   x: {
     *     tick: {
     *       culling: {
     *           max: 5
     *       }
     *     }
     *   }
     * }
     */ axis_x_tick_culling_max: 10,
    /**
     * The number of x axis ticks to show.<br><br>
     * This option hides tick lines together with tick text. If this option is used on timeseries axis, the ticks position will be determined precisely and not nicely positioned (e.g. it will have rough second value).
     * @name axis․x․tick․count
     * @memberof Options
     * @type {number}
     * @default undefined
     * @example
     * axis: {
     *   x: {
     *     tick: {
     *       count: 5
     *     }
     *   }
     * }
     */ axis_x_tick_count: undefined,
    /**
     * Show or hide x axis tick line.
     * @name axis․x․tick․show
     * @memberof Options
     * @type {boolean}
     * @default true
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Axis.HideTickLineText)
     * @example
     * axis: {
     *   x: {
     *     tick: {
     *       show: false
     *     }
     *   }
     * }
     */ axis_x_tick_show: true,
    /**
     * Show or hide x axis tick text.
     * @name axis․x․tick․text․show
     * @memberof Options
     * @type {boolean}
     * @default true
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Axis.HideTickLineText)
     * @example
     * axis: {
     *   x: {
     *     tick: {
     *       text: {
     *           show: false
     *       }
     *     }
     *   }
     * }
     */ axis_x_tick_text_show: true,
    /**
     * Set the x Axis tick text's position relatively its original position
     * @name axis․x․tick․text․position
     * @memberof Options
     * @type {object}
     * @default {x: 0, y:0}
     * @example
     * axis: {
     *   x: {
     *     tick: {
     *       text: {
     *         position: {
     *           x: 10,
     *           y: 10
     *         }
     *       }
     *     }
     *   }
     * }
     */ axis_x_tick_text_position: {
        x: 0,
        y: 0
    },
    /**
     * Fit x axis ticks.
     * - **true**: ticks will be positioned nicely to have same intervals.
     * - **false**: ticks will be positioned according to x value of the data points.
     * @name axis․x․tick․fit
     * @memberof Options
     * @type {boolean}
     * @default true
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Axis.XAxisTickFitting)
     * @see [Demo: for timeseries zoom](https://naver.github.io/billboard.js/demo/#Axis.XAxisTickTimeseries)
     * @example
     * axis: {
     *   x: {
     *     tick: {
     *       fit: false
     *     }
     *   }
     * }
     */ axis_x_tick_fit: true,
    /**
     * Set the x values of ticks manually.<br><br>
     * If this option is provided, the position of the ticks will be determined based on those values.<br>
     * This option works with `timeseries` data and the x values will be parsed accoding to the type of the value and data.xFormat option.
     * @name axis․x․tick․values
     * @memberof Options
     * @type {Array|Function}
     * @default null
     * @example
     * axis: {
     *   x: {
     *     tick: {
     *       values: [1, 2, 4, 8, 16, 32, ...],
     *
     *       // an Array value should be returned
     *       values: function() {
     *       	return [ ... ];
     *       }
     *     }
     *   }
     * }
     */ axis_x_tick_values: null,
    /**
     * Rotate x axis tick text if there is not enough space for 'category' and 'timeseries' type axis.
     * - **NOTE:** The conditions where `autorotate` is enabled are:
     *   - axis.x.type='category' or 'timeseries
     *   - axis.x.tick.multiline=false
     *   - axis.x.tick.culling=false
     *   - axis.x.tick.fit=true
     * - **NOTE:** axis.x.tick.clippath=false is necessary for calculating the overflow padding between the end of x axis and the width of the SVG
     * @name axis․x․tick․autorotate
     * @memberof Options
     * @type {boolean}
     * @default false
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Axis.XAxisTickAutorotate)
     * @example
     * axis: {
     *   x: {
     *     tick: {
     *       rotate: 15,
     *       autorotate: true,
     *       multiline: false,
     *       culling: false,
     *       fit: true
     *     },
     *     clipPath: false
     *   }
     * }
     */ axis_x_tick_autorotate: false,
    /**
     * Rotate x axis tick text.
     * - If you set negative value, it will rotate to opposite direction.
     * - Applied when [`axis.rotated`](#.axis%25E2%2580%25A4rotated) option is `false`.
     * - As long as `axis_x_tick_fit` is set to `true` it will calculate an overflow for the y2 axis and add this value to the right padding.
     * @name axis․x․tick․rotate
     * @memberof Options
     * @type {number}
     * @default 0
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Axis.RotateXAxisTickText)
     * @example
     * axis: {
     *   x: {
     *     tick: {
     *       rotate: 60
     *     }
     *   }
     * }
     */ axis_x_tick_rotate: 0,
    /**
     * Show x axis outer tick.
     * @name axis․x․tick․outer
     * @memberof Options
     * @type {boolean}
     * @default true
     * @example
     * axis: {
     *   x: {
     *     tick: {
     *       outer: false
     *     }
     *   }
     * }
     */ axis_x_tick_outer: true,
    /**
     * Set tick text to be multiline
     * - **NOTE:**
     *  > When x tick text contains `\n`, it's used as line break and 'axis.x.tick.width' option is ignored.
     * @name axis․x․tick․multiline
     * @memberof Options
     * @type {boolean}
     * @default true
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Axis.XAxisTickMultiline)
     * @example
     * axis: {
     *   x: {
     *     tick: {
     *       multiline: false
     *     }
     *   }
     * }
     * @example
     * // example of line break with '\n'
     * // In this case, 'axis.x.tick.width' is ignored
     * data: {
     *    x: "x",
     *    columns: [
     *        ["x", "long\ntext", "Another\nLong\nText"],
     *        ...
     *    ],
     * }
     */ axis_x_tick_multiline: true,
    /**
     * Set tick width
     * - **NOTE:**
     *  > When x tick text contains `\n`, this option is ignored.
     * @name axis․x․tick․width
     * @memberof Options
     * @type {number}
     * @default null
     * @example
     * axis: {
     *   x: {
     *     tick: {
     *       width: 50
     *     }
     *   }
     * }
     */ axis_x_tick_width: null,
    /**
     * Set to display system tooltip(via 'title' attribute) for tick text
     * - **NOTE:** Only available for category axis type (`axis.x.type='category'`)
     * @name axis․x․tick․tooltip
     * @memberof Options
     * @type {boolean}
     * @default false
     * @example
     * axis: {
     *   x: {
     *     tick: {
     *       tooltip: true
     *     }
     *   }
     * }
     */ axis_x_tick_tooltip: false,
    /**
     * Set max value of x axis range.
     * @name axis․x․max
     * @memberof Options
     * @property {number} max Set the max value
     * @property {boolean} [max.fit=false] When specified `max.value` is greater than the bound data value, setting `true` will make x axis max to be fitted to the bound data max value.
     * - **NOTE:** If the bound data max value is greater than the `max.value`, the x axis max will be limited as the given `max.value`.
     * @property {number} [max.value] Set the max value
     * @example
     * axis: {
     *   x: {
     *     max: 100,
     *
     *     max: {
     *       // 'fit=true' will make x axis max to be limited as the bound data value max when 'max.value' is greater.
     *       // - when bound data max is '10' and max.value: '100' ==>  x axis max will be '10'
     *       // - when bound data max is '1000' and max.value: '100' ==> x axis max will be '100'
     *       fit: true,
     *       value: 100
     *     }
     *   }
     * }
     */ axis_x_max: undefined,
    /**
     * Set min value of x axis range.
     * @name axis․x․min
     * @memberof Options
     * @property {number} min Set the min value
     * @property {boolean} [min.fit=false] When specified `min.value` is lower than the bound data value, setting `true` will make x axis min to be fitted to the bound data min value.
     * - **NOTE:** If the bound data min value is lower than the `min.value`, the x axis min will be limited as the given `min.value`.
     * @property {number} [min.value] Set the min value
     * @example
     * axis: {
     *   x: {
     *     min: -100,
     *
     *     min: {
     *       // 'fit=true' will make x axis min to be limited as the bound data value min when 'min.value' is lower.
     *       // - when bound data min is '-10' and min.value: '-100' ==>  x axis min will be '-10'
     *       // - when bound data min is '-1000' and min.value: '-100' ==> x axis min will be '-100'
     *       fit: true,
     *       value: -100
     *     }
     *   }
     * }
     */ axis_x_min: undefined,
    /**
     * Set padding for x axis.<br><br>
     * If this option is set, the range of x axis will increase/decrease according to the values.
     * If no padding is needed in the rage of x axis, 0 should be set.
     * - **NOTE:**
     *   The padding values aren't based on pixels. It differs according axis types<br>
     *   - **category:** The unit of tick value
     *     ex. the given value `1`, is same as the width of 1 tick width
     *   - **timeseries:** Numeric time value
     *     ex. the given value `1000*60*60*24`, which is numeric time equivalent of a day, is same as the width of 1 tick width
     * @name axis․x․padding
     * @memberof Options
     * @type {object|number}
     * @default {}
     * @example
     * axis: {
     *   x: {
     *     padding: {
     *       // when axis type is 'category'
     *       left: 1,  // set left padding width of equivalent value of a tick's width
     *       right: 0.5  // set right padding width as half of equivalent value of tick's width
     *
     *       // when axis type is 'timeseries'
     *       left: 1000*60*60*24,  // set left padding width of equivalent value of a day tick's width
     *       right: 1000*60*60*12   // set right padding width as half of equivalent value of a day tick's width
     *     },
     *
     *     // or set both values at once.
     *     padding: 10
     *   }
     * }
     */ axis_x_padding: {},
    /**
     * Set height of x axis.<br><br>
     * The height of x axis can be set manually by this option. If you need more space for x axis, please use this option for that. The unit is pixel.
     * @name axis․x․height
     * @memberof Options
     * @type {number}
     * @default undefined
     * @example
     * axis: {
     *   x: {
     *     height: 20
     *   }
     * }
     */ axis_x_height: undefined,
    /**
     * Set default extent for subchart and zoom. This can be an array or function that returns an array.
     * @name axis․x․extent
     * @memberof Options
     * @type {Array|Function}
     * @default undefined
     * @example
     * axis: {
     *   x: {
     *     // extent range as a pixel value
     *     extent: [0, 200],
     *
     *     // when axis is 'timeseries', parsable datetime string
     *     extent: ["2019-03-01", "2019-03-05"],
     *
     *     // return extent value
     *     extent: function(domain, scale) {
     *    	 var extent = domain.map(function(v) {
     *     	    return scale(v);
     *     	 });
     *
     *   	 // it should return a format of array
     *   	 // ex) [0, 584]
     *     	 return extent;
     *     }
     *   }
     * }
     */ axis_x_extent: undefined,
    /**
     * Set label on x axis.<br><br>
     * You can set x axis label and change its position by this option.
     * `string` and `object` can be passed and we can change the poisiton by passing object that has position key.<br>
     * Available position differs according to the axis direction (vertical or horizontal).
     * If string set, the position will be the default.
     *
     *  - **If it's horizontal axis:**
     *    - inner-right [default]
     *    - inner-center
     *    - inner-left
     *    - outer-right
     *    - outer-center
     *    - outer-left
     *  - **If it's vertical axis:**
     *    - inner-top [default]
     *    - inner-middle
     *    - inner-bottom
     *    - outer-top
     *    - outer-middle
     *    - outer-bottom
     * @name axis․x․label
     * @memberof Options
     * @type {string|object}
     * @default undefined
     * @example
     * axis: {
     *   x: {
     *     label: "Your X Axis"
     *   }
     * }
     *
     * axis: {
     *   x: {
     *     label: {
     *        text: "Your X Axis",
     *        position: "outer-center"
     *     }
     *   }
     * }
     */ axis_x_label: {},
    /**
     * Set additional axes for x Axis.
     * - **NOTE:** Axis' scale is based on x Axis value if domain option isn't set.
     *
     * Each axis object should consist with following options:
     *
     * | Name | Type | Default | Description |
     * | --- | --- | --- | --- |
     * | domain | Array | - | Set the domain value |
     * | tick.outer | boolean | true | Show outer tick |
     * | tick.format | Function | - | Set formatter for tick text |
     * | tick.count | Number | - | Set the number of y axis ticks |
     * | tick.values | Array | - | Set tick values manually |
     * @name axis․x․axes
     * @memberof Options
     * @type {Array}
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Axis.MultiAxes)
     * @see [Demo: Domain](https://naver.github.io/billboard.js/demo/#Axis.MultiAxesDomain)
     * @example
     * x: {
     *    axes: [
     *      {
     *        // if set, will not be correlated with the main x Axis domain value
     *        domain: [0, 1000],
     *        tick: {
     *          outer: false,
     *          format: function(x) {
     *             return x + "%";
     *          },
     *          count: 2,
     *          values: [10, 20, 30]
     *        }
     *      },
     *      ...
     *    ]
     * }
     */ axis_x_axes: []
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * y Axis  config options
 */ var y = {
    /**
     * Set clip-path attribute for y axis element
     * - **NOTE**: `clip-path` attribute for y Axis is set only when `axis.y.inner` option is true.
     * @name axis․y․clipPath
     * @memberof Options
     * @type {boolean}
     * @default true
     * @example
     * // don't set 'clip-path' attribute
     * clipPath: false
     */ axis_y_clipPath: true,
    /**
     * Show or hide y axis.
     * @name axis․y․show
     * @memberof Options
     * @type {boolean}
     * @default true
     * @example
     * axis: {
     *   y: {
     *     show: false
     *   }
     * }
     */ axis_y_show: true,
    /**
     * Set type of y axis.<br><br>
     * **Available Values:**
     *  - indexed
     *  - log
     *  - timeseries
     *
     * **NOTE:**<br>
     * - **log** type:
     *   - the bound data values must be exclusively-positive.
     *   - y axis min value should be >= 0.
     *   - [`data.groups`](#.data%25E2%2580%25A4groups)(stacked data) option aren't supported.
     *
     * @name axis․y․type
     * @memberof Options
     * @type {string}
     * @default "indexed"
     * @see [Demo: log](https://naver.github.io/billboard.js/demo/#Axis.LogScales)
     * @example
     * axis: {
     *   y: {
     *     type: "log"
     *   }
     * }
     */ axis_y_type: "indexed",
    /**
     * Set max value of y axis.
     * - **NOTE:** Padding will be added based on this value, so if you don't need the padding, please set axis.y.padding to disable it (e.g. axis.y.padding = 0).
     * @name axis․y․max
     * @memberof Options
     * @type {number}
     * @default undefined
     * @example
     * axis: {
     *   y: {
     *     max: 1000
     *   }
     * }
     */ axis_y_max: undefined,
    /**
     * Set min value of y axis.
     * - **NOTE:**
     *   Padding will be added based on this value, so if you don't need the padding, please set axis.y.padding to disable it (e.g. axis.y.padding = 0).
     * @name axis․y․min
     * @memberof Options
     * @type {number}
     * @default undefined
     * @example
     * axis: {
     *   y: {
     *     min: 1000
     *   }
     * }
     */ axis_y_min: undefined,
    /**
     * Change the direction of y axis.<br><br>
     * If true set, the direction will be from the top to the bottom.
     * @name axis․y․inverted
     * @memberof Options
     * @type {boolean}
     * @default false
     * @example
     * axis: {
     *   y: {
     *     inverted: true
     *   }
     * }
     */ axis_y_inverted: false,
    /**
     * Set center value of y axis.
     * @name axis․y․center
     * @memberof Options
     * @type {number}
     * @default undefined
     * @example
     * axis: {
     *   y: {
     *     center: 0
     *   }
     * }
     */ axis_y_center: undefined,
    /**
     * Show y axis inside of the chart.
     * @name axis․y․inner
     * @memberof Options
     * @type {boolean}
     * @default false
     * @example
     * axis: {
     *   y: {
     *     inner: true
     *   }
     * }
     */ axis_y_inner: false,
    /**
     * Set label on y axis.<br><br>
     * You can set y axis label and change its position by this option. This option works in the same way as [axis.x.label](#.axis%25E2%2580%25A4x%25E2%2580%25A4label).
     * @name axis․y․label
     * @memberof Options
     * @type {string|object}
     * @default {}
     * @see [axis.x.label](#.axis%25E2%2580%25A4x%25E2%2580%25A4label) for position string value.
     * @example
     * axis: {
     *   y: {
     *     label: "Your Y Axis"
     *   }
     * }
     *
     * axis: {
     *   y: {
     *     label: {
     *        text: "Your Y Axis",
     *        position: "outer-middle"
     *     }
     *   }
     * }
     */ axis_y_label: {},
    /**
     * Set formatter for y axis tick text.<br><br>
     * This option accepts d3.format object as well as a function you define.
     * @name axis․y․tick․format
     * @memberof Options
     * @type {Function}
     * @default undefined
     * @example
     * axis: {
     *   y: {
     *     tick: {
     *       format: function(x) {
     *           return x.getFullYear();
     *       }
     *     }
     *   }
     * }
     */ axis_y_tick_format: undefined,
    /**
     * Setting for culling ticks.<br><br>
     * If true is set, the ticks will be culled, then only limitted tick text will be shown. This option does not hide the tick lines. If false is set, all of ticks will be shown.<br><br>
     * We can change the number of ticks to be shown by axis.y.tick.culling.max.
     * @name axis․y․tick․culling
     * @memberof Options
     * @type {boolean}
     * @default false
     * @example
     * axis: {
     *   y: {
     *     tick: {
     *       culling: false
     *     }
     *   }
     * }
     */ axis_y_tick_culling: false,
    /**
     * The number of tick texts will be adjusted to less than this value.
     * @name axis․y․tick․culling․max
     * @memberof Options
     * @type {number}
     * @default 5
     * @example
     * axis: {
     *   y: {
     *     tick: {
     *       culling: {
     *           max: 5
     *       }
     *     }
     *   }
     * }
     */ axis_y_tick_culling_max: 5,
    /**
     * Show y axis outer tick.
     * @name axis․y․tick․outer
     * @memberof Options
     * @type {boolean}
     * @default true
     * @example
     * axis: {
     *   y: {
     *     tick: {
     *       outer: false
     *     }
     *   }
     * }
     */ axis_y_tick_outer: true,
    /**
     * Set y axis tick values manually.
     * @name axis․y․tick․values
     * @memberof Options
     * @type {Array|Function}
     * @default null
     * @example
     * axis: {
     *   y: {
     *     tick: {
     *       values: [100, 1000, 10000],
     *
     *       // an Array value should be returned
     *       values: function() {
     *       	return [ ... ];
     *       }
     *     }
     *   }
     * }
     */ axis_y_tick_values: null,
    /**
     * Rotate y axis tick text.
     * - If you set negative value, it will rotate to opposite direction.
     * - Applied when [`axis.rotated`](#.axis%25E2%2580%25A4rotated) option is `true`.
     * @name axis․y․tick․rotate
     * @memberof Options
     * @type {number}
     * @default 0
     * @example
     * axis: {
     *   y: {
     *     tick: {
     *       rotate: 60
     *     }
     *   }
     * }
     */ axis_y_tick_rotate: 0,
    /**
     * Set the number of y axis ticks.<br><br>
     * - **NOTE:** The position of the ticks will be calculated precisely, so the values on the ticks will not be rounded nicely. In the case, axis.y.tick.format or axis.y.tick.values will be helpful.
     * @name axis․y․tick․count
     * @memberof Options
     * @type {number}
     * @default undefined
     * @example
     * axis: {
     *   y: {
     *     tick: {
     *       count: 5
     *     }
     *   }
     * }
     */ axis_y_tick_count: undefined,
    /**
     * Show or hide y axis tick line.
     * @name axis․y․tick․show
     * @memberof Options
     * @type {boolean}
     * @default true
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Axis.HideTickLineText)
     * @example
     * axis: {
     *   y: {
     *     tick: {
     *       show: false
     *     }
     *   }
     * }
     */ axis_y_tick_show: true,
    /**
     * Set axis tick step(interval) size.
     * - **NOTE:** Will be ignored if `axis.y.tick.count` or `axis.y.tick.values` options are set.
     * @name axis․y․tick․stepSize
     * @memberof Options
     * @type {number}
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Axis.StepSizeForYAxis)
     * @example
     * axis: {
     *   y: {
     *     tick: {
     *       // tick value will step as indicated interval value.
     *       // ex) 'stepSize=15' ==> [0, 15, 30, 45, 60]
     *       stepSize: 15
     *     }
     *   }
     * }
     */ axis_y_tick_stepSize: null,
    /**
     * Show or hide y axis tick text.
     * @name axis․y․tick․text․show
     * @memberof Options
     * @type {boolean}
     * @default true
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Axis.HideTickLineText)
     * @example
     * axis: {
     *   y: {
     *     tick: {
     *       text: {
     *           show: false
     *       }
     *     }
     *   }
     * }
     */ axis_y_tick_text_show: true,
    /**
     * Set the y Axis tick text's position relatively its original position
     * @name axis․y․tick․text․position
     * @memberof Options
     * @type {object}
     * @default {x: 0, y:0}
     * @example
     * axis: {
     *   y: {
     *     tick: {
     *       text: {
     *         position: {
     *           x: 10,
     *           y: 10
     *         }
     *       }
     *     }
     *   }
     * }
     */ axis_y_tick_text_position: {
        x: 0,
        y: 0
    },
    /**
     * Set the number of y axis ticks.<br><br>
     * - **NOTE:** The position of the ticks will be calculated precisely, so the values on the ticks will not be rounded nicely. In the case, axis.y.tick.format or axis.y.tick.values will be helpful.
     * @name axis․y․tick․time
     * @memberof Options
     * @private
     * @type {object}
     * @property {object} time time object
     * @property {Function} [time.value] D3's time interval function (https://github.com/d3/d3-time#intervals)
     * @example
     * axis: {
     *   y: {
     *     tick: {
     *       time: {
     *          // ticks at 15-minute intervals
     *          // https://github.com/d3/d3-scale/blob/master/README.md#time_ticks
     *          value: d3.timeMinute.every(15)
     *       }
     *     }
     *   }
     * }
     */ // @TODO: not fully implemented yet
    axis_y_tick_time_value: undefined,
    /**
     * Set padding for y axis.<br><br>
     * You can set padding for y axis to create more space on the edge of the axis.
     * This option accepts object and it can include top and bottom. top, bottom will be treated as pixels.
     *
     * - **NOTE:**
     *   - Given values are translated relative to the y Axis domain value for padding
     *   - For area and bar type charts, [area.zerobased](#.area) or [bar.zerobased](#.bar) options should be set to 'false` to get padded bottom.
     * @name axis․y․padding
     * @memberof Options
     * @type {object|number}
     * @default {}
     * @example
     * axis: {
     *   y: {
     *     padding: {
     *       top: 0,
     *       bottom: 0
     *     },
     *
     *     // or set both values at once.
     *     padding: 10
     *   }
     * }
     */ axis_y_padding: {},
    /**
     * Set default range of y axis.<br><br>
     * This option set the default value for y axis when there is no data on init.
     * @name axis․y․default
     * @memberof Options
     * @type {Array}
     * @default undefined
     * @example
     * axis: {
     *   y: {
     *     default: [0, 1000]
     *   }
     * }
     */ axis_y_default: undefined,
    /**
     * Set additional axes for y Axis.
     * - **NOTE:** Axis' scale is based on y Axis value if domain option isn't set.
     *
     * Each axis object should consist with following options:
     *
     * | Name | Type | Default | Description |
     * | --- | --- | --- | --- |
     * | domain | Array | - | Set the domain value |
     * | tick.outer | boolean | true | Show outer tick |
     * | tick.format | Function | - | Set formatter for tick text |
     * | tick.count | Number | - | Set the number of y axis ticks |
     * | tick.values | Array | - | Set tick values manually |
     * @name axis․y․axes
     * @memberof Options
     * @type {Array}
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Axis.MultiAxes)
     * @see [Demo: Domain](https://naver.github.io/billboard.js/demo/#Axis.MultiAxesDomain)
     * @example
     * y: {
     *    axes: [
     *      {
     *        // if set, will not be correlated with the main y Axis domain value
     *        domain: [0, 1000],
     *        tick: {
     *          outer: false,
     *          format: function(x) {
     *             return x + "%";
     *          },
     *          count: 2,
     *          values: [10, 20, 30]
     *        }
     *      },
     *      ...
     *    ]
     * }
     */ axis_y_axes: []
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * y2 Axis  config options
 */ var y2 = {
    /**
     * Show or hide y2 axis.
     * - **NOTE**:
     *   - When set to `false` will not generate y2 axis node. In this case, all 'y2' axis related functionality won't work properly.
     *   - If need to use 'y2' related options while y2 isn't visible, set the value `true` and control visibility by css display property.
     * @name axis․y2․show
     * @memberof Options
     * @type {boolean}
     * @default false
     * @example
     * axis: {
     *   y2: {
     *     show: true
     *   }
     * }
     */ axis_y2_show: false,
    /**
     * Set type of y2 axis.<br><br>
     * **Available Values:**
     *  - indexed
     *  - log
     *  - timeseries
     *
     * **NOTE:**<br>
     * - **log** type:
     *   - the bound data values must be exclusively-positive.
     *   - y2 axis min value should be >= 0.
     *   - [`data.groups`](#.data%25E2%2580%25A4groups)(stacked data) option aren't supported.
     *
     * @name axis․y2․type
     * @memberof Options
     * @type {string}
     * @default "indexed"
     * @see [Demo: log](https://naver.github.io/billboard.js/demo/#Axis.LogScales)
     * @example
     * axis: {
     *   y2: {
     *     type: "indexed"
     *   }
     * }
     */ axis_y2_type: "indexed",
    /**
     * Set max value of y2 axis.
     * @name axis․y2․max
     * @memberof Options
     * @type {number}
     * @default undefined
     * @example
     * axis: {
     *   y2: {
     *     max: 1000
     *   }
     * }
     */ axis_y2_max: undefined,
    /**
     * Set min value of y2 axis.
     * @name axis․y2․min
     * @memberof Options
     * @type {number}
     * @default undefined
     * @example
     * axis: {
     *   y2: {
     *     min: -1000
     *   }
     * }
     */ axis_y2_min: undefined,
    /**
     * Change the direction of y2 axis.<br><br>
     * If true set, the direction will be from the top to the bottom.
     * @name axis․y2․inverted
     * @memberof Options
     * @type {boolean}
     * @default false
     * @example
     * axis: {
     *   y2: {
     *     inverted: true
     *   }
     * }
     */ axis_y2_inverted: false,
    /**
     * Set center value of y2 axis.
     * @name axis․y2․center
     * @memberof Options
     * @type {number}
     * @default undefined
     * @example
     * axis: {
     *   y2: {
     *     center: 0
     *   }
     * }
     */ axis_y2_center: undefined,
    /**
     * Show y2 axis inside of the chart.
     * @name axis․y2․inner
     * @memberof Options
     * @type {boolean}
     * @default false
     * @example
     * axis: {
     *   y2: {
     *     inner: true
     *   }
     * }
     */ axis_y2_inner: false,
    /**
     * Set label on y2 axis.<br><br>
     * You can set y2 axis label and change its position by this option. This option works in the same way as [axis.x.label](#.axis%25E2%2580%25A4x%25E2%2580%25A4label).
     * @name axis․y2․label
     * @memberof Options
     * @type {string|object}
     * @default {}
     * @see [axis.x.label](#.axis%25E2%2580%25A4x%25E2%2580%25A4label) for position string value.
     * @example
     * axis: {
     *   y2: {
     *     label: "Your Y2 Axis"
     *   }
     * }
     *
     * axis: {
     *   y2: {
     *     label: {
     *        text: "Your Y2 Axis",
     *        position: "outer-middle"
     *     }
     *   }
     * }
     */ axis_y2_label: {},
    /**
     * Set formatter for y2 axis tick text.<br><br>
     * This option works in the same way as axis.y.format.
     * @name axis․y2․tick․format
     * @memberof Options
     * @type {Function}
     * @default undefined
     * @example
     * axis: {
     *   y2: {
     *     tick: {
     *       format: d3.format("$,")
     *       //or format: function(d) { return "$" + d; }
     *     }
     *   }
     * }
     */ axis_y2_tick_format: undefined,
    /**
     * Setting for culling ticks.<br><br>
     * If true is set, the ticks will be culled, then only limitted tick text will be shown. This option does not hide the tick lines. If false is set, all of ticks will be shown.<br><br>
     * We can change the number of ticks to be shown by axis.y.tick.culling.max.
     * @name axis․y2․tick․culling
     * @memberof Options
     * @type {boolean}
     * @default false
     * @example
     * axis: {
     *   y2: {
     *     tick: {
     *       culling: false
     *     }
     *   }
     * }
     */ axis_y2_tick_culling: false,
    /**
     * The number of tick texts will be adjusted to less than this value.
     * @name axis․y2․tick․culling․max
     * @memberof Options
     * @type {number}
     * @default 5
     * @example
     * axis: {
     *   y2: {
     *     tick: {
     *       culling: {
     *           max: 5
     *       }
     *     }
     *   }
     * }
     */ axis_y2_tick_culling_max: 5,
    /**
     * Show or hide y2 axis outer tick.
     * @name axis․y2․tick․outer
     * @memberof Options
     * @type {boolean}
     * @default true
     * @example
     * axis: {
     *   y2: {
     *     tick: {
     *       outer: false
     *     }
     *   }
     * }
     */ axis_y2_tick_outer: true,
    /**
     * Set y2 axis tick values manually.
     * @name axis․y2․tick․values
     * @memberof Options
     * @type {Array|Function}
     * @default null
     * @example
     * axis: {
     *   y2: {
     *     tick: {
     *       values: [100, 1000, 10000],
     *
     *       // an Array value should be returned
     *       values: function() {
     *       	return [ ... ];
     *       }
     *     }
     *   }
     * }
     */ axis_y2_tick_values: null,
    /**
     * Rotate y2 axis tick text.
     * - If you set negative value, it will rotate to opposite direction.
     * - Applied when [`axis.rotated`](#.axis%25E2%2580%25A4rotated) option is `true`.
     * @name axis․y2․tick․rotate
     * @memberof Options
     * @type {number}
     * @default 0
     * @example
     * axis: {
     *   y2: {
     *     tick: {
     *       rotate: 60
     *     }
     *   }
     * }
     */ axis_y2_tick_rotate: 0,
    /**
     * Set the number of y2 axis ticks.
     * - **NOTE:** This works in the same way as axis.y.tick.count.
     * @name axis․y2․tick․count
     * @memberof Options
     * @type {number}
     * @default undefined
     * @example
     * axis: {
     *   y2: {
     *     tick: {
     *       count: 5
     *     }
     *   }
     * }
     */ axis_y2_tick_count: undefined,
    /**
     * Show or hide y2 axis tick line.
     * @name axis․y2․tick․show
     * @memberof Options
     * @type {boolean}
     * @default true
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Axis.HideTickLineText)
     * @example
     * axis: {
     *   y2: {
     *     tick: {
     *       show: false
     *     }
     *   }
     * }
     */ axis_y2_tick_show: true,
    /**
     * Set axis tick step(interval) size.
     * - **NOTE:** Will be ignored if `axis.y2.tick.count` or `axis.y2.tick.values` options are set.
     * @name axis․y2․tick․stepSize
     * @memberof Options
     * @type {number}
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Axis.StepSizeForYAxis)
     * @example
     * axis: {
     *   y2: {
     *     tick: {
     *       // tick value will step as indicated interval value.
     *       // ex) 'stepSize=15' ==> [0, 15, 30, 45, 60]
     *       stepSize: 15
     *     }
     *   }
     * }
     */ axis_y2_tick_stepSize: null,
    /**
     * Show or hide y2 axis tick text.
     * @name axis․y2․tick․text․show
     * @memberof Options
     * @type {boolean}
     * @default true
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Axis.HideTickLineText)
     * @example
     * axis: {
     *   y2: {
     *     tick: {
     *       text: {
     *           show: false
     *       }
     *     }
     *   }
     * }
     */ axis_y2_tick_text_show: true,
    /**
     * Set the y2 Axis tick text's position relatively its original position
     * @name axis․y2․tick․text․position
     * @memberof Options
     * @type {object}
     * @default {x: 0, y:0}
     * @example
     * axis: {
     *   y2: {
     *     tick: {
     *       text: {
     *         position: {
     *           x: 10,
     *           y: 10
     *         }
     *       }
     *     }
     *   }
     * }
     */ axis_y2_tick_text_position: {
        x: 0,
        y: 0
    },
    /**
     * Set padding for y2 axis.<br><br>
     * You can set padding for y2 axis to create more space on the edge of the axis.
     * This option accepts object and it can include top and bottom. top, bottom will be treated as pixels.
     *
     * - **NOTE:**
     *   - Given values are translated relative to the y2 Axis domain value for padding
     *   - For area and bar type charts, [area.zerobased](#.area) or [bar.zerobased](#.bar) options should be set to 'false` to get padded bottom.
     * @name axis․y2․padding
     * @memberof Options
     * @type {object|number}
     * @default {}
     * @example
     * axis: {
     *   y2: {
     *     padding: {
     *       top: 100,
     *       bottom: 100
     *     }
     *
     *     // or set both values at once.
     *     padding: 10
     * }
     */ axis_y2_padding: {},
    /**
     * Set default range of y2 axis.<br><br>
     * This option set the default value for y2 axis when there is no data on init.
     * @name axis․y2․default
     * @memberof Options
     * @type {Array}
     * @default undefined
     * @example
     * axis: {
     *   y2: {
     *     default: [0, 1000]
     *   }
     * }
     */ axis_y2_default: undefined,
    /**
     * Set additional axes for y2 Axis.
     * - **NOTE:** Axis' scale is based on y2 Axis value if domain option isn't set.
     *
     * Each axis object should consist with following options:
     *
     * | Name | Type | Default | Description |
     * | --- | --- | --- | --- |
     * | domain | Array | - | Set the domain value |
     * | tick.outer | boolean | true | Show outer tick |
     * | tick.format | Function | - | Set formatter for tick text |
     * | tick.count | Number | - | Set the number of y axis ticks |
     * | tick.values | Array | - | Set tick values manually |
     * @name axis․y2․axes
     * @memberof Options
     * @type {Array}
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Axis.MultiAxes)
     * @see [Demo: Domain](https://naver.github.io/billboard.js/demo/#Axis.MultiAxesDomain)
     * @example
     * y2: {
     *    axes: [
     *      {
     *        // if set, will not be correlated with the main y2 Axis domain value
     *        domain: [0, 1000],
     *        tick: {
     *          outer: false,
     *          format: function(x) {
     *             return x + "%";
     *          },
     *          count: 2,
     *          values: [10, 20, 30]
     *        }
     *      },
     *      ...
     *    ]
     * }
     */ axis_y2_axes: []
};
/**
 * y Axis  config options
 */ var optAxis = _assign(_assign(_assign({
    /**
     * Switch x and y axis position.
     * @name axis․rotated
     * @memberof Options
     * @type {boolean}
     * @default false
     * @example
     * axis: {
     *   rotated: true
     * }
     */ axis_rotated: false
}, x), y), y2);
var optGrid = {
    /**
     * Set related options
     * @name grid
     * @memberof Options
     * @type {object}
     * @property {boolean} [front=false] Set 'grid & focus lines' to be positioned over grid lines and chart elements.
     * @property {object} x Grid x object
     * @property {boolean} [x.show=false] Show grids along x axis.
     * @property {Array} [x.lines=[]] Show additional grid lines along x axis.<br>
     *  This option accepts array including object that has value, text, position and class. text, position and class are optional. For position, start, middle and end (default) are available.
     *  If x axis is category axis, value can be category name. If x axis is timeseries axis, value can be date string, Date object and unixtime integer.
     * @property {object} y Grid y object
     * @property {boolean} [y.show=false] Show grids along x axis.
     * @property {Array} [y.lines=[]] Show additional grid lines along y axis.<br>
     *  This option accepts array including object that has value, text, position and class.
     * @property {number} [y.ticks=10] Number of y grids to be shown.
     * @property {object} focus Grid focus object
     * @property {boolean} [focus.edge=false] Show edged focus grid line.<br>**NOTE:** Available when [`tooltip.grouped=false`](#.tooltip) option is set.
     * @property {boolean} [focus.show=true] Show grid line when focus.
     * @property {boolean} [focus.y=false] Show y coordinate focus grid line.<br>**NOTE:** Available when [`tooltip.grouped=false`](#.tooltip) option is set.
     * @property {object} lines Grid lines object
     * @property {boolean} [lines.front=true] Set grid lines to be positioned over chart elements.
     * @default undefined
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Grid.GridLines)
     * @see [Demo: X Grid Lines](https://naver.github.io/billboard.js/demo/#Grid.OptionalXGridLines)
     * @see [Demo: Y Grid Lines](https://naver.github.io/billboard.js/demo/#Grid.OptionalYGridLines)
     * @example
     * grid: {
     *   x: {
     *     show: true,
     *     lines: [
     *       {value: 2, text: "Label on 2"},
     *       {value: 5, text: "Label on 5", class: "label-5"},
     *       {value: 6, text: "Label on 6", position: "start"}
     *     ]
     *   },
     *   y: {
     *     show: true,
     *     lines: [
     *       {value: 100, text: "Label on 100"},
     *       {value: 200, text: "Label on 200", class: "label-200"},
     *       {value: 300, text: "Label on 300", position: 'middle'}
     *     ],
     *     ticks: 5
     *   },
     *   front: true,
     *   focus: {
     *      show: false,
     *
     *      // Below options are available when 'tooltip.grouped=false' option is set
     *      edge: true,
     *      y: true
     *   },
     *   lines: {
     *      front: false
     *   }
     * }
     */ grid_x_show: false,
    grid_x_type: "tick",
    grid_x_lines: [],
    grid_y_show: false,
    grid_y_lines: [],
    grid_y_ticks: 10,
    grid_focus_edge: false,
    grid_focus_show: true,
    grid_focus_y: false,
    grid_front: false,
    grid_lines_front: true
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var api = [
    apiAxis,
    apiCategory,
    apiXGrid,
    apiYGrid,
    apiFlow,
    apiGroup,
    apiRegion,
    apiX
];
var internal = [
    axis,
    clip,
    eventrect,
    flow,
    grid,
    region,
    sizeAxis
];
var options = [
    optDataAxis,
    optAxis,
    optGrid
];
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var shapeArc = {
    initPie: function() {
        var $$ = this;
        var config = $$.config;
        var dataType = config.data_type;
        var padding = config.pie_padding;
        var startingAngle = config["".concat(dataType, "_startingAngle")] || 0;
        var padAngle = ($$.hasType("pie") && padding ? padding * 0.01 : config["".concat(dataType, "_padAngle")]) || 0;
        $$.pie = (0, $fo0l5.default)().startAngle(startingAngle).endAngle(startingAngle + 2 * Math.PI).padAngle(padAngle).value(function(d) {
            return d.values.reduce(function(a, b) {
                return a + b.value;
            }, 0);
        }).sort($$.getSortCompareFn.bind($$)(true));
    },
    updateRadius: function() {
        var $$ = this;
        var config = $$.config, state = $$.state;
        var padding = config.pie_padding;
        var w = config.gauge_width || config.donut_width;
        var gaugeArcWidth = $$.filterTargetsToShow($$.data.targets).length * config.gauge_arcs_minWidth;
        // determine radius
        state.radiusExpanded = Math.min(state.arcWidth, state.arcHeight) / 2 * ($$.hasMultiArcGauge() ? 0.85 : 1);
        state.radius = state.radiusExpanded * 0.95;
        state.innerRadiusRatio = w ? (state.radius - w) / state.radius : 0.6;
        state.gaugeArcWidth = w || (gaugeArcWidth <= state.radius - state.innerRadius ? state.radius - state.innerRadius : gaugeArcWidth <= state.radius ? gaugeArcWidth : state.radius);
        var innerRadius = config.pie_innerRadius || (padding ? padding * (state.innerRadiusRatio + 0.1) : 0);
        // NOTE: inner/outerRadius can be an object by user setting, only for 'pie' type
        state.outerRadius = config.pie_outerRadius;
        state.innerRadius = $$.hasType("donut") || $$.hasType("gauge") ? state.radius * state.innerRadiusRatio : innerRadius;
    },
    /**
     * Get pie's inner & outer radius value
     * @param {object|undefined} d Data object
     * @returns {object}
     * @private
     */ getRadius: function(d) {
        var $$ = this;
        var data = d && d.data;
        var _a = $$.state, innerRadius = _a.innerRadius, outerRadius = _a.outerRadius;
        if (!isNumber(innerRadius) && data) innerRadius = innerRadius[data.id] || 0;
        if (isObject(outerRadius) && data && data.id in outerRadius) outerRadius = outerRadius[data.id];
        else if (!isNumber(outerRadius)) outerRadius = $$.state.radius;
        return {
            innerRadius: innerRadius,
            outerRadius: outerRadius
        };
    },
    updateArc: function() {
        var $$ = this;
        $$.updateRadius();
        $$.svgArc = $$.getSvgArc();
        $$.svgArcExpanded = $$.getSvgArcExpanded();
    },
    getArcLength: function() {
        var $$ = this;
        var config = $$.config;
        var arcLengthInPercent = config.gauge_arcLength * 3.6;
        var len = 2 * (arcLengthInPercent / 360);
        if (arcLengthInPercent < -360) len = -2;
        else if (arcLengthInPercent > 360) len = 2;
        return len * Math.PI;
    },
    getStartAngle: function() {
        var $$ = this;
        var config = $$.config;
        var isFullCircle = config.gauge_fullCircle;
        var defaultStartAngle = -1 * Math.PI / 2;
        var defaultEndAngle = Math.PI / 2;
        var startAngle = config.gauge_startingAngle;
        if (!isFullCircle && startAngle <= defaultStartAngle) startAngle = defaultStartAngle;
        else if (!isFullCircle && startAngle >= defaultEndAngle) startAngle = defaultEndAngle;
        else if (startAngle > Math.PI || startAngle < -1 * Math.PI) startAngle = Math.PI;
        return startAngle;
    },
    updateAngle: function(dValue) {
        var $$ = this;
        var config = $$.config, state = $$.state;
        var pie = $$.pie;
        var d = dValue;
        var found = false;
        if (!config) return null;
        var gStart = $$.getStartAngle();
        var radius = config.gauge_fullCircle ? $$.getArcLength() : gStart * -2;
        if (d.data && $$.isGaugeType(d.data) && !$$.hasMultiArcGauge()) {
            // to prevent excluding total data sum during the init(when data.hide option is used), use $$.rendered state value
            var totalSum = $$.getTotalDataSum(state.rendered);
            var gEnd = radius * (totalSum / (config.gauge_max - config.gauge_min));
            pie = pie.startAngle(gStart).endAngle(gEnd + gStart);
        }
        pie($$.filterTargetsToShow()).forEach(function(t, i) {
            if (!found && t.data.id === d.data.id) {
                found = true;
                d = t;
                d.index = i;
            }
        });
        if (isNaN(d.startAngle)) d.startAngle = 0;
        if (isNaN(d.endAngle)) d.endAngle = d.startAngle;
        if (d.data && $$.hasMultiArcGauge()) {
            var gMin = config.gauge_min;
            var gMax = config.gauge_max;
            var gTic = radius / (gMax - gMin);
            var gValue = d.value < gMin ? 0 : d.value < gMax ? d.value - gMin : gMax - gMin;
            d.startAngle = gStart;
            d.endAngle = gStart + gTic * gValue;
        }
        return found ? d : null;
    },
    getSvgArc: function() {
        var $$ = this;
        var state = $$.state;
        var singleArcWidth = state.gaugeArcWidth / $$.filterTargetsToShow($$.data.targets).length;
        var hasMultiArcGauge = $$.hasMultiArcGauge();
        var arc$1 = (0, $ffiwJ.default)().innerRadius(function(d) {
            var innerRadius = $$.getRadius(d).innerRadius;
            return hasMultiArcGauge ? state.radius - singleArcWidth * (d.index + 1) : isNumber(innerRadius) ? innerRadius : 0;
        }).outerRadius(function(d) {
            var outerRadius = $$.getRadius(d).outerRadius;
            return hasMultiArcGauge ? state.radius - singleArcWidth * d.index : outerRadius;
        });
        var newArc = function(d, withoutUpdate) {
            var path = "M 0 0";
            if (d.value || d.data) {
                var updated = !withoutUpdate && $$.updateAngle(d);
                if (withoutUpdate) path = arc$1(d);
                else if (updated) path = arc$1(updated);
            }
            return path;
        };
        // TODO: extends all function
        newArc.centroid = arc$1.centroid;
        return newArc;
    },
    getSvgArcExpanded: function(rate) {
        var $$ = this;
        var state = $$.state;
        var newRate = rate || 1;
        var singleArcWidth = state.gaugeArcWidth / $$.filterTargetsToShow($$.data.targets).length;
        var hasMultiArcGauge = $$.hasMultiArcGauge();
        var expandWidth = Math.min(state.radiusExpanded * newRate - state.radius, singleArcWidth * 0.8 - (1 - newRate) * 100);
        var arc$1 = (0, $ffiwJ.default)().innerRadius(function(d) {
            return hasMultiArcGauge ? state.radius - singleArcWidth * (d.index + 1) : $$.getRadius(d).innerRadius;
        }).outerRadius(function(d) {
            var radius;
            if (hasMultiArcGauge) radius = state.radius - singleArcWidth * d.index + expandWidth;
            else {
                var outerRadius = $$.getRadius(d).outerRadius;
                var radiusExpanded = state.radiusExpanded;
                if (state.radius !== outerRadius) radiusExpanded -= Math.abs(state.radius - outerRadius);
                radius = radiusExpanded * newRate;
            }
            return radius;
        });
        return function(d) {
            var updated = $$.updateAngle(d);
            return updated ? arc$1(updated) : "M 0 0";
        };
    },
    getArc: function(d, withoutUpdate, force) {
        return force || this.isArcType(d.data) ? this.svgArc(d, withoutUpdate) : "M 0 0";
    },
    transformForArcLabel: function(d) {
        var $$ = this;
        var config = $$.config, radiusExpanded = $$.state.radiusExpanded;
        var updated = $$.updateAngle(d);
        var translate = "";
        if (updated) {
            if ($$.hasMultiArcGauge()) {
                var y1 = Math.sin(updated.endAngle - Math.PI / 2);
                var x = Math.cos(updated.endAngle - Math.PI / 2) * (radiusExpanded + 25);
                var y = y1 * (radiusExpanded + 15 - Math.abs(y1 * 10)) + 3;
                translate = "translate(".concat(x, ",").concat(y, ")");
            } else if (!$$.hasType("gauge") || $$.data.targets.length > 1) {
                var outerRadius = $$.getRadius(d).outerRadius;
                var c = this.svgArc.centroid(updated);
                var x = isNaN(c[0]) ? 0 : c[0];
                var y = isNaN(c[1]) ? 0 : c[1];
                var h = Math.sqrt(x * x + y * y);
                var ratio = $$.hasType("donut") && config.donut_label_ratio || $$.hasType("pie") && config.pie_label_ratio;
                if (ratio) ratio = isFunction(ratio) ? ratio.bind($$.api)(d, outerRadius, h) : ratio;
                else ratio = outerRadius && (h ? (36 / outerRadius > 0.375 ? 1.175 - 36 / outerRadius : 0.8) * outerRadius / h : 0);
                translate = "translate(".concat(x * ratio, ",").concat(y * ratio, ")");
            }
        }
        return translate;
    },
    convertToArcData: function(d) {
        return this.addName({
            id: d.data ? d.data.id : d.id,
            value: d.value,
            ratio: this.getRatio("arc", d),
            index: d.index
        });
    },
    textForArcLabel: function(selection) {
        var $$ = this;
        var hasGauge = $$.hasType("gauge");
        if ($$.shouldShowArcLabel()) selection.style("fill", $$.updateTextColor.bind($$)).each(function(d) {
            var node = (0, $hOxpW.default)(this);
            var updated = $$.updateAngle(d);
            var ratio = $$.getRatio("arc", updated);
            var isUnderThreshold = $$.meetsLabelThreshold(ratio, $$.hasType("donut") && "donut" || $$.hasType("gauge") && "gauge" || $$.hasType("pie") && "pie");
            if (isUnderThreshold) {
                var value = (updated || d).value;
                var text = ($$.getArcLabelFormat() || $$.defaultArcValueFormat)(value, ratio, d.data.id).toString();
                setTextValue(node, text, [
                    -1,
                    1
                ], hasGauge);
            } else node.text("");
        });
    },
    expandArc: function(targetIds) {
        var $$ = this;
        var transiting = $$.state.transiting, $el = $$.$el;
        // MEMO: avoid to cancel transition
        if (transiting) {
            var interval_1 = setInterval(function() {
                if (!transiting) {
                    clearInterval(interval_1);
                    $el.legend.selectAll(".".concat(CLASS.legendItemFocused)).size() > 0 && $$.expandArc(targetIds);
                }
            }, 10);
            return;
        }
        var newTargetIds = $$.mapToTargetIds(targetIds);
        $el.svg.selectAll($$.selectorTargets(newTargetIds, ".".concat(CLASS.chartArc))).each(function(d) {
            if (!$$.shouldExpand(d.data.id)) return;
            var expandDuration = $$.getExpandConfig(d.data.id, "duration");
            var svgArcExpandedSub = $$.getSvgArcExpanded($$.getExpandConfig(d.data.id, "rate"));
            (0, $hOxpW.default)(this).selectAll("path").transition().duration(expandDuration).attr("d", $$.svgArcExpanded).transition().duration(expandDuration * 2).attr("d", svgArcExpandedSub);
        });
    },
    unexpandArc: function(targetIds) {
        var $$ = this;
        var transiting = $$.state.transiting, svg = $$.$el.svg;
        if (transiting) return;
        var newTargetIds = $$.mapToTargetIds(targetIds);
        svg.selectAll($$.selectorTargets(newTargetIds, ".".concat(CLASS.chartArc))).selectAll("path").transition().duration(function(d) {
            return $$.getExpandConfig(d.data.id, "duration");
        }).attr("d", $$.svgArc);
        svg.selectAll("".concat(CLASS.arc)).style("opacity", "1");
    },
    /**
     * Get expand config value
     * @param {string} id data ID
     * @param {string} key config key: 'duration | rate'
     * @returns {number}
     * @private
     */ getExpandConfig: function(id, key) {
        var $$ = this;
        var config = $$.config;
        var def = {
            duration: 50,
            rate: 0.98
        };
        var type;
        if ($$.isDonutType(id)) type = "donut";
        else if ($$.isGaugeType(id)) type = "gauge";
        else if ($$.isPieType(id)) type = "pie";
        return type ? config["".concat(type, "_expand_").concat(key)] : def[key];
    },
    shouldExpand: function(id) {
        var $$ = this;
        var config = $$.config;
        return $$.isDonutType(id) && config.donut_expand || $$.isGaugeType(id) && config.gauge_expand || $$.isPieType(id) && config.pie_expand;
    },
    shouldShowArcLabel: function() {
        var $$ = this;
        var config = $$.config;
        return [
            "pie",
            "donut",
            "gauge"
        ].some(function(v) {
            return $$.hasType(v) && config["".concat(v, "_label_show")];
        });
    },
    getArcLabelFormat: function() {
        var $$ = this;
        var config = $$.config;
        var format = config.pie_label_format;
        if ($$.hasType("gauge")) format = config.gauge_label_format;
        else if ($$.hasType("donut")) format = config.donut_label_format;
        return isFunction(format) ? format.bind($$.api) : format;
    },
    getArcTitle: function() {
        var $$ = this;
        var type = $$.hasType("donut") && "donut" || $$.hasType("gauge") && "gauge";
        return type ? $$.config["".concat(type, "_title")] : "";
    },
    updateTargetsForArc: function(targets) {
        var $$ = this;
        var $el = $$.$el;
        var hasGauge = $$.hasType("gauge");
        var classChartArc = $$.getChartClass("Arc");
        var classArcs = $$.getClass("arcs", true);
        var classFocus = $$.classFocus.bind($$);
        var chartArcs = $el.main.select(".".concat(CLASS.chartArcs));
        var mainPieUpdate = chartArcs.selectAll(".".concat(CLASS.chartArc)).data($$.pie(targets)).attr("class", function(d) {
            return classChartArc(d) + classFocus(d.data);
        });
        var mainPieEnter = mainPieUpdate.enter().append("g").attr("class", classChartArc);
        mainPieEnter.append("g").attr("class", classArcs).merge(mainPieUpdate);
        mainPieEnter.append("text").attr("dy", hasGauge && !$$.hasMultiTargets() ? "-.1em" : ".35em").style("opacity", "0").style("text-anchor", "middle").style("pointer-events", "none");
        $el.text = chartArcs.selectAll(".".concat(CLASS.target, " text"));
    // MEMO: can not keep same color..., but not bad to update color in redraw
    // mainPieUpdate.exit().remove();
    },
    initArc: function() {
        var $$ = this;
        var $el = $$.$el;
        $el.arcs = $el.main.select(".".concat(CLASS.chart)).append("g").attr("class", CLASS.chartArcs).attr("transform", $$.getTranslate("arc"));
        $$.setArcTitle();
    },
    /**
     * Set arc title text
     * @private
     */ setArcTitle: function() {
        var $$ = this;
        var title = $$.getArcTitle();
        var hasGauge = $$.hasType("gauge");
        if (title) {
            var text = $$.$el.arcs.append("text").attr("class", CLASS[hasGauge ? "chartArcsGaugeTitle" : "chartArcsTitle"]).style("text-anchor", "middle");
            if (hasGauge) text.attr("dy", "-0.3em").style("font-size", "27px");
            setTextValue(text, title, hasGauge ? undefined : [
                -0.6,
                1.35
            ], true);
        }
    },
    redrawArc: function(duration, durationForExit, withTransform) {
        var $$ = this;
        var config = $$.config, state = $$.state, main = $$.$el.main;
        var hasInteraction = config.interaction_enabled;
        var isSelectable = hasInteraction && config.data_selection_isselectable;
        var mainArc = main.selectAll(".".concat(CLASS.arcs)).selectAll(".".concat(CLASS.arc)).data($$.arcData.bind($$));
        mainArc.exit().transition().duration(durationForExit).style("opacity", "0").remove();
        mainArc = mainArc.enter().append("path").attr("class", $$.getClass("arc", true)).style("fill", function(d) {
            return $$.color(d.data);
        }).style("cursor", function(d) {
            return isSelectable && isSelectable.bind($$.api)(d) ? "pointer" : null;
        }).style("opacity", "0").each(function(d) {
            if ($$.isGaugeType(d.data)) {
                d.startAngle = config.gauge_startingAngle;
                d.endAngle = config.gauge_startingAngle;
            }
            this._current = d;
        }).merge(mainArc);
        if ($$.hasType("gauge")) {
            $$.updateGaugeMax();
            $$.hasMultiArcGauge() && $$.redrawMultiArcGauge();
        }
        mainArc.attr("transform", function(d) {
            return !$$.isGaugeType(d.data) && withTransform ? "scale(0)" : "";
        }).style("opacity", function(d) {
            return d === this._current ? "0" : "1";
        }).each(function() {
            state.transiting = true;
        }).transition().duration(duration).attrTween("d", function(d) {
            var updated = $$.updateAngle(d);
            if (!updated) return function() {
                return "M 0 0";
            };
            if (isNaN(this._current.startAngle)) this._current.startAngle = 0;
            if (isNaN(this._current.endAngle)) this._current.endAngle = this._current.startAngle;
            var interpolate$1 = (0, $bi4KR.default)(this._current, updated);
            this._current = interpolate$1(0);
            return function(t) {
                var interpolated = interpolate$1(t);
                interpolated.data = d.data; // data.id will be updated by interporator
                return $$.getArc(interpolated, true);
            };
        }).attr("transform", withTransform ? "scale(1)" : "").style("fill", function(d) {
            var color;
            if ($$.levelColor) {
                color = $$.levelColor(d.data.values[0].value);
                // update data's color
                config.data_colors[d.data.id] = color;
            } else color = $$.color(d.data);
            return color;
        })// Where gauge reading color would receive customization.
        .style("opacity", "1").call(endall, function() {
            if ($$.levelColor) {
                var path = (0, $hOxpW.default)(this);
                var d = path.datum();
                $$.updateLegendItemColor(d.data.id, path.style("fill"));
            }
            state.transiting = false;
            callFn(config.onrendered, $$.api);
        });
        // bind arc events
        hasInteraction && $$.bindArcEvent(mainArc);
        $$.hasType("gauge") && $$.redrawBackgroundArcs();
        $$.redrawArcText(duration);
    },
    redrawBackgroundArcs: function() {
        var $$ = this;
        var config = $$.config, state = $$.state;
        var hasMultiArcGauge = $$.hasMultiArcGauge();
        var isFullCircle = config.gauge_fullCircle;
        var showEmptyTextLabel = $$.filterTargetsToShow($$.data.targets).length === 0 && !!config.data_empty_label_text;
        var startAngle = $$.getStartAngle();
        var endAngle = isFullCircle ? startAngle + $$.getArcLength() : startAngle * -1;
        var backgroundArc = $$.$el.arcs.select("".concat(hasMultiArcGauge ? "g" : "", ".").concat(CLASS.chartArcsBackground));
        if (hasMultiArcGauge) {
            var index_1 = 0;
            backgroundArc = backgroundArc.selectAll("path.".concat(CLASS.chartArcsBackground)).data($$.data.targets);
            backgroundArc.enter().append("path").attr("class", function(d, i) {
                return "".concat(CLASS.chartArcsBackground, " ").concat(CLASS.chartArcsBackground, "-").concat(i);
            }).merge(backgroundArc).style("fill", config.gauge_background || null).attr("d", function(_a) {
                var id = _a.id;
                if (showEmptyTextLabel || state.hiddenTargetIds.indexOf(id) >= 0) return "M 0 0";
                var d = {
                    data: [
                        {
                            value: config.gauge_max
                        }
                    ],
                    startAngle: startAngle,
                    endAngle: endAngle,
                    index: index_1++
                };
                return $$.getArc(d, true, true);
            });
            backgroundArc.exit().remove();
        } else backgroundArc.attr("d", showEmptyTextLabel ? "M 0 0" : function() {
            var d = {
                data: [
                    {
                        value: config.gauge_max
                    }
                ],
                startAngle: startAngle,
                endAngle: endAngle
            };
            return $$.getArc(d, true, true);
        });
    },
    bindArcEvent: function(arc) {
        var $$ = this;
        var config = $$.config, state = $$.state;
        var isTouch = state.inputType === "touch";
        var isMouse = state.inputType === "mouse";
        // eslint-disable-next-line
        function selectArc(_this, arcData, id) {
            // transitions
            $$.expandArc(id);
            $$.api.focus(id);
            $$.toggleFocusLegend(id, true);
            $$.showTooltip([
                arcData
            ], _this);
        }
        // eslint-disable-next-line
        function unselectArc(arcData) {
            var id = arcData && arcData.id || undefined;
            $$.unexpandArc(id);
            $$.api.revert();
            $$.revertLegend();
            $$.hideTooltip();
        }
        arc.on("click", function(d, i) {
            var updated = $$.updateAngle(d);
            var arcData;
            if (updated) {
                arcData = $$.convertToArcData(updated);
                $$.toggleShape && $$.toggleShape(this, arcData, i);
                config.data_onclick.bind($$.api)(arcData, this);
            }
        });
        // mouse events
        if (isMouse) arc.on("mouseover", function(d) {
            if (state.transiting) return;
            var updated = $$.updateAngle(d);
            var arcData = updated ? $$.convertToArcData(updated) : null;
            var id = arcData && arcData.id || undefined;
            selectArc(this, arcData, id);
            $$.setOverOut(true, arcData);
        }).on("mouseout", function(d) {
            if (state.transiting) return;
            var updated = $$.updateAngle(d);
            var arcData = updated ? $$.convertToArcData(updated) : null;
            unselectArc();
            $$.setOverOut(false, arcData);
        }).on("mousemove", function(d) {
            var updated = $$.updateAngle(d);
            var arcData = updated ? $$.convertToArcData(updated) : null;
            $$.showTooltip([
                arcData
            ], this);
        });
        // touch events
        if (isTouch && $$.hasArcType() && !$$.radars) {
            var getEventArc_1 = function() {
                var touch = (0, $iZ2is.event).changedTouches[0];
                var eventArc = (0, $hOxpW.default)(doc.elementFromPoint(touch.clientX, touch.clientY));
                return eventArc;
            };
            var handler = function() {
                if (state.transiting) return;
                var eventArc = getEventArc_1();
                var datum = eventArc.datum();
                var updated = datum && datum.data && datum.data.id ? $$.updateAngle(datum) : null;
                var arcData = updated ? $$.convertToArcData(updated) : null;
                var id = arcData && arcData.id || undefined;
                $$.callOverOutForTouch(arcData);
                isUndefined(id) ? unselectArc() : selectArc(this, arcData, id);
            };
            $$.$el.svg.on("touchstart", handler).on("touchmove", handler);
        }
    },
    redrawArcText: function(duration) {
        var $$ = this;
        var config = $$.config, state = $$.state, _a = $$.$el, main = _a.main, arcs = _a.arcs;
        var hasGauge = $$.hasType("gauge");
        var hasMultiArcGauge = $$.hasMultiArcGauge();
        var text;
        // for gauge type, update text when has no title & multi data
        if (!(hasGauge && $$.data.targets.length === 1 && config.gauge_title)) {
            text = main.selectAll(".".concat(CLASS.chartArc)).select("text").style("opacity", "0").attr("class", function(d) {
                return $$.isGaugeType(d.data) ? CLASS.gaugeValue : null;
            }).call($$.textForArcLabel.bind($$)).attr("transform", $$.transformForArcLabel.bind($$)).style("font-size", function(d) {
                return $$.isGaugeType(d.data) && $$.data.targets.length === 1 && !hasMultiArcGauge ? "".concat(Math.round(state.radius / 5), "px") : null;
            }).transition().duration(duration).style("opacity", function(d) {
                return $$.isTargetToShow(d.data.id) && $$.isArcType(d.data) ? "1" : "0";
            });
            hasMultiArcGauge && text.attr("dy", "-.1em");
        }
        main.select(".".concat(CLASS.chartArcsTitle)).style("opacity", $$.hasType("donut") || hasGauge ? "1" : "0");
        if (hasGauge) {
            var isFullCircle = config.gauge_fullCircle;
            isFullCircle && text && text.attr("dy", "".concat(hasMultiArcGauge ? 0 : Math.round(state.radius / 14)));
            if (config.gauge_label_show) {
                arcs.select(".".concat(CLASS.chartArcsGaugeUnit)).attr("dy", "".concat(isFullCircle ? 1.5 : 0.75, "em")).text(config.gauge_units);
                arcs.select(".".concat(CLASS.chartArcsGaugeMin)).attr("dx", "".concat(-1 * (state.innerRadius + (state.radius - state.innerRadius) / (isFullCircle ? 1 : 2)), "px")).attr("dy", "1.2em").text($$.textForGaugeMinMax(config.gauge_min, false));
                // show max text when isn't fullCircle
                !isFullCircle && arcs.select(".".concat(CLASS.chartArcsGaugeMax)).attr("dx", "".concat(state.innerRadius + (state.radius - state.innerRadius) / 2, "px")).attr("dy", "1.2em").text($$.textForGaugeMinMax(config.gauge_max, true));
            }
        }
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var shapeArea = {
    initArea: function(mainLine) {
        var $$ = this;
        var config = $$.config;
        mainLine.insert("g", ".".concat(CLASS[config.area_front ? "circles" : "lines"])).attr("class", $$.getClass("areas", true));
    },
    updateAreaGradient: function() {
        var $$ = this;
        var config = $$.config, datetimeId = $$.state.datetimeId, defs = $$.$el.defs;
        $$.data.targets.forEach(function(d) {
            var id = "".concat(datetimeId, "-areaGradient").concat($$.getTargetSelectorSuffix(d.id));
            if ($$.isAreaType(d) && defs.select("#".concat(id)).empty()) {
                var color_1 = $$.color(d);
                var _a = config.area_linearGradient, _b = _a.x, x = _b === void 0 ? [
                    0,
                    0
                ] : _b, _c = _a.y, y = _c === void 0 ? [
                    0,
                    1
                ] : _c, _d = _a.stops, stops = _d === void 0 ? [
                    [
                        0,
                        color_1,
                        1
                    ],
                    [
                        1,
                        color_1,
                        0
                    ]
                ] : _d;
                var linearGradient_1 = defs.append("linearGradient").attr("id", "".concat(id)).attr("x1", x[0]).attr("x2", x[1]).attr("y1", y[0]).attr("y2", y[1]);
                stops.forEach(function(v) {
                    var stopColor = isFunction(v[1]) ? v[1].bind($$.api)(d.id) : v[1];
                    linearGradient_1.append("stop").attr("offset", v[0]).attr("stop-color", stopColor || color_1).attr("stop-opacity", v[2]);
                });
            }
        });
    },
    updateAreaColor: function(d) {
        var $$ = this;
        return $$.config.area_linearGradient ? "url(#".concat($$.state.datetimeId, "-areaGradient").concat($$.getTargetSelectorSuffix(d.id), ")") : $$.color(d);
    },
    updateArea: function(durationForExit) {
        var $$ = this;
        var config = $$.config, state = $$.state, $el = $$.$el;
        config.area_linearGradient && $$.updateAreaGradient();
        $el.area = $el.main.selectAll(".".concat(CLASS.areas)).selectAll(".".concat(CLASS.area)).data($$.lineData.bind($$));
        $el.area.exit().transition().duration(durationForExit).style("opacity", "0").remove();
        $el.area = $el.area.enter().append("path").attr("class", $$.getClass("area", true)).style("fill", $$.updateAreaColor.bind($$)).style("opacity", function() {
            state.orgAreaOpacity = (0, $hOxpW.default)(this).style("opacity");
            return "0";
        }).merge($el.area);
        $el.area.style("opacity", state.orgAreaOpacity);
    },
    redrawArea: function(drawArea, withTransition) {
        var $$ = this;
        var orgAreaOpacity = $$.state.orgAreaOpacity;
        return [
            (withTransition ? $$.$el.area.transition(getRandom()) : $$.$el.area).attr("d", drawArea).style("fill", $$.updateAreaColor.bind($$)).style("opacity", function(d) {
                return String($$.isAreaRangeType(d) ? orgAreaOpacity / 1.75 : orgAreaOpacity);
            })
        ];
    },
    /**
     * Generate area path data
     * @param {object} areaIndices Indices
     * @param {boolean} isSub Weather is sub axis
     * @returns {Function}
     * @private
     */ generateDrawArea: function(areaIndices, isSub) {
        var $$ = this;
        var config = $$.config;
        var lineConnectNull = config.line_connectNull;
        var isRotated = config.axis_rotated;
        var getPoints = $$.generateGetAreaPoints(areaIndices, isSub);
        var yScale = $$.getYScaleById.bind($$);
        var xValue = function(d) {
            return (isSub ? $$.subxx : $$.xx).call($$, d);
        };
        var value0 = function(d, i) {
            return $$.isGrouped(d.id) ? getPoints(d, i)[0][1] : yScale(d.id, isSub)($$.isAreaRangeType(d) ? $$.getAreaRangeData(d, "high") : $$.getShapeYMin(d.id));
        };
        var value1 = function(d, i) {
            return $$.isGrouped(d.id) ? getPoints(d, i)[1][1] : yScale(d.id, isSub)($$.isAreaRangeType(d) ? $$.getAreaRangeData(d, "low") : d.value);
        };
        return function(d) {
            var values = lineConnectNull ? $$.filterRemoveNull(d.values) : d.values;
            var x0 = 0;
            var y0 = 0;
            var path;
            if ($$.isAreaType(d)) {
                var area = (0, $fEwLW.default)();
                area = isRotated ? area.y(xValue).x0(value0).x1(value1) : area.x(xValue)// @ts-ignore
                .y0(config.area_above ? 0 : value0).y1(value1);
                if (!lineConnectNull) area = area.defined(function(d) {
                    return $$.getBaseValue(d) !== null;
                });
                if ($$.isStepType(d)) values = $$.convertValuesToStep(values);
                path = area.curve($$.getCurve(d))(values);
            } else {
                if (values[0]) {
                    x0 = $$.scale.x(values[0].x);
                    y0 = $$.getYScaleById(d.id)(values[0].value);
                }
                path = isRotated ? "M ".concat(y0, " ").concat(x0) : "M ".concat(x0, " ").concat(y0);
            }
            return path || "M 0 0";
        };
    },
    generateGetAreaPoints: function(areaIndices, isSub) {
        // partial duplication of generateGetBarPoints
        var $$ = this;
        var config = $$.config;
        var x = $$.getShapeX(0, areaIndices, isSub);
        var y = $$.getShapeY(!!isSub);
        var areaOffset = $$.getShapeOffset($$.isAreaType, areaIndices, isSub);
        var yScale = $$.getYScaleById.bind($$);
        return function(d, i) {
            var y0 = yScale.call($$, d.id, isSub)($$.getShapeYMin(d.id));
            var offset = areaOffset(d, i) || y0; // offset is for stacked area chart
            var posX = x(d);
            var posY = y(d);
            // fix posY not to overflow opposite quadrant
            if (config.axis_rotated && (d.value > 0 && posY < y0 || d.value < 0 && y0 < posY)) posY = y0;
            // 1 point that marks the area position
            return [
                [
                    posX,
                    offset
                ],
                [
                    posX,
                    posY - (y0 - offset)
                ],
                [
                    posX,
                    posY - (y0 - offset)
                ],
                [
                    posX,
                    offset
                ] // needed for compatibility
            ];
        };
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var shapeBar = {
    initBar: function() {
        var $el = this.$el;
        $el.bar = $el.main.select(".".concat(CLASS.chart))// should positioned at the beginning of the shape node to not overlap others
        .insert("g", ":first-child").attr("class", CLASS.chartBars);
    },
    updateTargetsForBar: function(targets) {
        var $$ = this;
        var config = $$.config, $el = $$.$el;
        var classChartBar = $$.getChartClass("Bar");
        var classBars = $$.getClass("bars", true);
        var classFocus = $$.classFocus.bind($$);
        var isSelectable = config.interaction_enabled && config.data_selection_isselectable;
        if (!$el.bar) $$.initBar();
        var mainBarUpdate = $$.$el.main.select(".".concat(CLASS.chartBars)).selectAll(".".concat(CLASS.chartBar)).data(targets).attr("class", function(d) {
            return classChartBar(d) + classFocus(d);
        });
        var mainBarEnter = mainBarUpdate.enter().append("g").attr("class", classChartBar).style("opacity", "0").style("pointer-events", "none");
        // Bars for each data
        mainBarEnter.append("g").attr("class", classBars).style("cursor", function(d) {
            return isSelectable && isSelectable.bind($$.api)(d) ? "pointer" : null;
        });
    },
    updateBar: function(durationForExit) {
        var $$ = this;
        var $el = $$.$el;
        var barData = $$.barData.bind($$);
        var classBar = $$.getClass("bar", true);
        var initialOpacity = $$.initialOpacity.bind($$);
        $el.bar = $el.main.selectAll(".".concat(CLASS.bars)).selectAll(".".concat(CLASS.bar)).data(barData);
        $el.bar.exit().transition().duration(durationForExit).style("opacity", "0").remove();
        $el.bar = $el.bar.enter().append("path").attr("class", classBar).style("fill", $$.color).merge($el.bar).style("opacity", initialOpacity);
    },
    redrawBar: function(drawBar, withTransition) {
        var bar = this.$el.bar;
        return [
            (withTransition ? bar.transition(getRandom()) : bar).attr("d", drawBar).style("fill", this.color).style("opacity", "1")
        ];
    },
    getBarW: function(axis, barTargetsNum) {
        var $$ = this;
        var config = $$.config, org = $$.org, scale = $$.scale;
        var maxDataCount = $$.getMaxDataCount();
        var isGrouped = config.data_groups.length;
        var tickInterval = scale.zoom && !$$.axis.isCategorized() ? org.xDomain.map(function(v) {
            return scale.zoom(v);
        }).reduce(function(a, c) {
            return Math.abs(a) + c;
        }) / maxDataCount : axis.tickInterval(maxDataCount);
        var getWidth = function(id) {
            var width = id ? config.bar_width[id] : config.bar_width;
            var ratio = id ? width.ratio : config.bar_width_ratio;
            var max = id ? width.max : config.bar_width_max;
            var w = isNumber(width) ? width : barTargetsNum ? tickInterval * ratio / barTargetsNum : 0;
            return max && w > max ? max : w;
        };
        var result = getWidth();
        if (!isGrouped && isObjectType(config.bar_width)) {
            result = {
                _$width: result,
                _$total: []
            };
            $$.filterTargetsToShow($$.data.targets).forEach(function(v) {
                if (config.bar_width[v.id]) {
                    result[v.id] = getWidth(v.id);
                    result._$total.push(result[v.id] || result._$width);
                }
            });
        }
        return result;
    },
    getBars: function(i, id) {
        var $$ = this;
        var main = $$.$el.main;
        var suffix = isValue(i) ? "-".concat(i) : "";
        return (id ? main.selectAll(".".concat(CLASS.bars).concat($$.getTargetSelectorSuffix(id))) : main).selectAll(".".concat(CLASS.bar).concat(suffix));
    },
    expandBars: function(i, id, reset) {
        var $$ = this;
        reset && $$.unexpandBars();
        $$.getBars(i, id).classed(CLASS.EXPANDED, true);
    },
    unexpandBars: function(i) {
        this.getBars(i).classed(CLASS.EXPANDED, false);
    },
    generateDrawBar: function(barIndices, isSub) {
        var $$ = this;
        var config = $$.config;
        var getPoints = $$.generateGetBarPoints(barIndices, isSub);
        var isRotated = config.axis_rotated;
        var isGrouped = config.data_groups.length;
        var barRadius = config.bar_radius;
        var barRadiusRatio = config.bar_radius_ratio;
        // get the bar radius
        var getRadius = isNumber(barRadius) && barRadius > 0 ? function() {
            return barRadius;
        } : isNumber(barRadiusRatio) ? function(w) {
            return w * barRadiusRatio;
        } : null;
        return function(d, i) {
            // 4 points that make a bar
            var points = getPoints(d, i);
            // switch points if axis is rotated, not applicable for sub chart
            var indexX = +isRotated;
            var indexY = +!indexX;
            var isNegative = d.value < 0;
            var pathRadius = [
                "",
                ""
            ];
            var radius = 0;
            if (getRadius && !isGrouped) {
                var index = isRotated ? indexY : indexX;
                var barW = points[2][index] - points[0][index];
                radius = getRadius(barW);
                var arc = "a".concat(radius, ",").concat(radius, " ").concat(isNegative ? "1 0 0" : "0 0 1", " ");
                pathRadius[+!isRotated] = "".concat(arc).concat(radius, ",").concat(radius);
                pathRadius[+isRotated] = "".concat(arc).concat([
                    -radius,
                    radius
                ][isRotated ? "sort" : "reverse"]());
                isNegative && pathRadius.reverse();
            }
            // path string data shouldn't be containing new line chars
            // https://github.com/naver/billboard.js/issues/530
            var path = isRotated ? "H".concat(points[1][indexX] - radius, " ").concat(pathRadius[0], "V").concat(points[2][indexY] - radius, " ").concat(pathRadius[1], "H").concat(points[3][indexX]) : "V".concat(points[1][indexY] + (isNegative ? -radius : radius), " ").concat(pathRadius[0], "H").concat(points[2][indexX] - radius, " ").concat(pathRadius[1], "V").concat(points[3][indexY]);
            return "M".concat(points[0][indexX], ",").concat(points[0][indexY]).concat(path, "z");
        };
    },
    generateGetBarPoints: function(barIndices, isSub) {
        var $$ = this;
        var config = $$.config;
        var axis = isSub ? $$.axis.subX : $$.axis.x;
        var barTargetsNum = $$.getIndicesMax(barIndices) + 1;
        var barW = $$.getBarW(axis, barTargetsNum);
        var barX = $$.getShapeX(barW, barIndices, !!isSub);
        var barY = $$.getShapeY(!!isSub);
        var barOffset = $$.getShapeOffset($$.isBarType, barIndices, !!isSub);
        var yScale = $$.getYScaleById.bind($$);
        return function(d, i) {
            var y0 = yScale.call($$, d.id, isSub)($$.getShapeYMin(d.id));
            var offset = barOffset(d, i) || y0; // offset is for stacked bar chart
            var width = isNumber(barW) ? barW : barW[d.id] || barW._$width;
            var posX = barX(d);
            var posY = barY(d);
            // fix posY not to overflow opposite quadrant
            if (config.axis_rotated && (d.value > 0 && posY < y0 || d.value < 0 && y0 < posY)) posY = y0;
            posY -= y0 - offset;
            var startPosX = posX + width;
            // 4 points that make a bar
            return [
                [
                    posX,
                    offset
                ],
                [
                    posX,
                    posY
                ],
                [
                    startPosX,
                    posY
                ],
                [
                    startPosX,
                    offset
                ]
            ];
        };
    },
    isWithinBar: function(that) {
        var mouse$1 = (0, $iS3vq.default)(that);
        var list = getRectSegList(that);
        var seg0 = list[0], seg1 = list[1];
        var x = Math.min(seg0.x, seg1.x);
        var y = Math.min(seg0.y, seg1.y);
        var offset = this.config.bar_sensitivity;
        var _a = that.getBBox(), width = _a.width, height = _a.height;
        var sx = x - offset;
        var ex = x + width + offset;
        var sy = y + height + offset;
        var ey = y - offset;
        return sx < mouse$1[0] && mouse$1[0] < ex && ey < mouse$1[1] && mouse$1[1] < sy;
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var shapeGauge = {
    initGauge: function() {
        var $$ = this;
        var config = $$.config, arcs = $$.$el.arcs;
        var appendText = function(className) {
            arcs.append("text").attr("class", className).style("text-anchor", "middle").style("pointer-events", "none");
        };
        if ($$.hasType("gauge")) {
            var hasMulti = $$.hasMultiArcGauge();
            arcs.append(hasMulti ? "g" : "path").attr("class", CLASS.chartArcsBackground).style("fill", !hasMulti && config.gauge_background || null);
            config.gauge_units && appendText(CLASS.chartArcsGaugeUnit);
            if (config.gauge_label_show) {
                appendText(CLASS.chartArcsGaugeMin);
                !config.gauge_fullCircle && appendText(CLASS.chartArcsGaugeMax);
            }
        }
    },
    updateGaugeMax: function() {
        var $$ = this;
        var config = $$.config, state = $$.state;
        var hasMultiGauge = $$.hasMultiArcGauge();
        // to prevent excluding total data sum during the init(when data.hide option is used), use $$.rendered state value
        var max = hasMultiGauge ? $$.getMinMaxData().max[0].value : $$.getTotalDataSum(state.rendered);
        // if gauge_max less than max, make max to max value
        if (max > config.gauge_max) config.gauge_max = max;
    },
    redrawMultiArcGauge: function() {
        var $$ = this;
        var config = $$.config, state = $$.state, $el = $$.$el;
        var hiddenTargetIds = $$.state.hiddenTargetIds;
        var arcLabelLines = $el.main.selectAll(".".concat(CLASS.arcs)).selectAll(".".concat(CLASS.arcLabelLine)).data($$.arcData.bind($$));
        var mainArcLabelLine = arcLabelLines.enter().append("rect").attr("class", function(d) {
            return "".concat(CLASS.arcLabelLine, " ").concat(CLASS.target, " ").concat(CLASS.target, "-").concat(d.data.id);
        }).merge(arcLabelLines);
        mainArcLabelLine.style("fill", function(d) {
            return $$.levelColor ? $$.levelColor(d.data.values[0].value) : $$.color(d.data);
        }).style("display", config.gauge_label_show ? "" : "none").each(function(d) {
            var lineLength = 0;
            var lineThickness = 2;
            var x = 0;
            var y = 0;
            var transform = "";
            if (hiddenTargetIds.indexOf(d.data.id) < 0) {
                var updated = $$.updateAngle(d);
                var innerLineLength = state.gaugeArcWidth / $$.filterTargetsToShow($$.data.targets).length * (updated.index + 1);
                var lineAngle = updated.endAngle - Math.PI / 2;
                var arcInnerRadius = state.radius - innerLineLength;
                var linePositioningAngle = lineAngle - (arcInnerRadius === 0 ? 0 : 1 / arcInnerRadius);
                lineLength = state.radiusExpanded - state.radius + innerLineLength;
                x = Math.cos(linePositioningAngle) * arcInnerRadius;
                y = Math.sin(linePositioningAngle) * arcInnerRadius;
                transform = "rotate(".concat(lineAngle * 180 / Math.PI, ", ").concat(x, ", ").concat(y, ")");
            }
            (0, $hOxpW.default)(this).attr("x", x).attr("y", y).attr("width", lineLength).attr("height", lineThickness).attr("transform", transform).style("stroke-dasharray", "0, ".concat(lineLength + lineThickness, ", 0"));
        });
    },
    textForGaugeMinMax: function(value, isMax) {
        var $$ = this;
        var config = $$.config;
        var format = config.gauge_label_extents;
        return isFunction(format) ? format.bind($$.api)(value, isMax) : value;
    },
    getGaugeLabelHeight: function() {
        var config = this.config;
        return this.config.gauge_label_show && !config.gauge_fullCircle ? 20 : 0;
    },
    getPaddingBottomForGauge: function() {
        var $$ = this;
        return $$.getGaugeLabelHeight() * ($$.config.gauge_label_show ? 2 : 2.5);
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var shapeBubble = {
    /**
     * Initializer
     * @private
     */ initBubble: function() {
        var $$ = this;
        var config = $$.config;
        if ($$.hasType("bubble")) {
            config.point_show = true;
            config.point_type = "circle";
            config.point_sensitivity = 25;
        }
    },
    /**
     * Get user agent's computed value
     * @returns {number}
     * @private
     */ getBaseLength: function() {
        var $$ = this;
        var _a = $$.state, width = _a.width, height = _a.height;
        var cacheKey = KEY.bubbleBaseLength;
        var baseLength = $$.cache.get(cacheKey);
        if (!baseLength) $$.cache.add(cacheKey, baseLength = getMinMax$1("min", [
            width,
            height
        ]));
        return baseLength;
    },
    /**
     * Get the radius value for bubble circle
     * @param {object} d Data object
     * @returns {number}
     * @private
     */ getBubbleR: function(d) {
        var $$ = this;
        var maxR = $$.config.bubble_maxR;
        if (isFunction(maxR)) maxR = maxR.bind($$.api)(d);
        else if (!isNumber(maxR)) maxR = $$.getBaseLength() / ($$.getMaxDataCount() * 2) + 12;
        var max = getMinMax$1("max", $$.getMinMaxData().max.map(function(d) {
            return $$.isBubbleZType(d) ? $$.getBubbleZData(d.value, "y") : isObject(d.value) ? d.value.mid : d.value;
        }));
        var maxArea = maxR * maxR * Math.PI;
        var area = ($$.isBubbleZType(d) ? $$.getBubbleZData(d.value, "z") : d.value) * (maxArea / max);
        return Math.sqrt(area / Math.PI);
    },
    /**
     * Get bubble dimension data
     * @param {object|Array} d data value
     * @param {string} type - y or z
     * @returns {number}
     * @private
     */ getBubbleZData: function(d, type) {
        return isObject(d) ? d[type] : d[type === "y" ? 0 : 1];
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var shapeLine = {
    initLine: function() {
        var $el = this.$el;
        $el.line = $el.main.select(".".concat(CLASS.chart)).append("g").attr("class", CLASS.chartLines);
    },
    updateTargetsForLine: function(t) {
        var $$ = this;
        var _a = $$.$el, area = _a.area, line = _a.line, main = _a.main;
        var classChartLine = $$.getChartClass("Line");
        var classLines = $$.getClass("lines", true);
        var classFocus = $$.classFocus.bind($$);
        if (!line) $$.initLine();
        var targets = t.filter(function(d) {
            return !($$.isScatterType(d) || $$.isBubbleType(d));
        });
        var mainLineUpdate = main.select(".".concat(CLASS.chartLines)).selectAll(".".concat(CLASS.chartLine)).data(targets).attr("class", function(d) {
            return classChartLine(d) + classFocus(d);
        });
        var mainLineEnter = mainLineUpdate.enter().append("g").attr("class", classChartLine).style("opacity", "0").style("pointer-events", "none");
        // Lines for each data
        mainLineEnter.append("g").attr("class", classLines);
        // Areas
        if ($$.hasTypeOf("Area")) $$.initArea(!area && mainLineEnter.empty() ? mainLineUpdate : mainLineEnter);
        $$.updateTargetForCircle(targets, mainLineEnter);
    },
    updateLine: function(durationForExit) {
        var $$ = this;
        var extraLineClasses = $$.format.extraLineClasses, $el = $$.$el;
        $el.line = $el.main.selectAll(".".concat(CLASS.lines)).selectAll(".".concat(CLASS.line)).data($$.lineData.bind($$));
        $el.line.exit().transition().duration(durationForExit).style("opacity", "0").remove();
        $el.line = $el.line.enter().append("path").attr("class", function(d) {
            return "".concat($$.getClass("line", true)(d), " ").concat(extraLineClasses(d) || "");
        }).style("stroke", $$.color).merge($el.line).style("opacity", $$.initialOpacity.bind($$)).style("shape-rendering", function(d) {
            return $$.isStepType(d) ? "crispEdges" : "";
        }).attr("transform", null);
    },
    redrawLine: function(drawLine, withTransition) {
        var line = this.$el.line;
        return [
            (withTransition ? line.transition(getRandom()) : line).attr("d", drawLine).style("stroke", this.color).style("opacity", "1")
        ];
    },
    /**
     * Get the curve interpolate
     * @param {Array} d Data object
     * @returns {Function}
     * @private
     */ getCurve: function(d) {
        var $$ = this;
        var isRotatedStepType = $$.config.axis_rotated && $$.isStepType(d);
        // when is step & rotated, should be computed in different way
        // https://github.com/naver/billboard.js/issues/471
        return isRotatedStepType ? function(context) {
            var step = $$.getInterpolate(d)(context);
            // keep the original method
            step.orgPoint = step.point;
            // to get rotated path data
            step.pointRotated = function(x, y) {
                this._point === 1 && (this._point = 2);
                var y1 = this._y * (1 - this._t) + y * this._t;
                this._context.lineTo(this._x, y1);
                this._context.lineTo(x, y1);
                this._x = x;
                this._y = y;
            };
            step.point = function(x, y) {
                this._point === 0 ? this.orgPoint(x, y) : this.pointRotated(x, y);
            };
            return step;
        } : $$.getInterpolate(d);
    },
    generateDrawLine: function(lineIndices, isSub) {
        var $$ = this;
        var config = $$.config, scale = $$.scale;
        var lineConnectNull = config.line_connectNull;
        var isRotated = config.axis_rotated;
        var getPoints = $$.generateGetLinePoints(lineIndices, isSub);
        var yScale = $$.getYScaleById.bind($$);
        var xValue = function(d) {
            return (isSub ? $$.subxx : $$.xx).call($$, d);
        };
        var yValue = function(d, i) {
            return $$.isGrouped(d.id) ? getPoints(d, i)[0][1] : yScale(d.id, isSub)($$.getBaseValue(d));
        };
        var line = (0, $5ti2H.default)();
        line = isRotated ? line.x(yValue).y(xValue) : line.x(xValue).y(yValue);
        if (!lineConnectNull) line = line.defined(function(d) {
            return $$.getBaseValue(d) !== null;
        });
        var x = isSub ? scale.subX : scale.x;
        return function(d) {
            var y = yScale(d.id, isSub);
            var values = lineConnectNull ? $$.filterRemoveNull(d.values) : d.values;
            var x0 = 0;
            var y0 = 0;
            var path;
            if ($$.isLineType(d)) {
                var regions = config.data_regions[d.id];
                if (regions) path = $$.lineWithRegions(values, x, y, regions);
                else {
                    if ($$.isStepType(d)) values = $$.convertValuesToStep(values);
                    path = line.curve($$.getCurve(d))(values);
                }
            } else {
                if (values[0]) {
                    x0 = x(values[0].x);
                    y0 = y(values[0].value);
                }
                path = isRotated ? "M ".concat(y0, " ").concat(x0) : "M ".concat(x0, " ").concat(y0);
            }
            return path || "M 0 0";
        };
    },
    lineWithRegions: function(d, x, y, _regions) {
        var $$ = this;
        var config = $$.config;
        var isRotated = config.axis_rotated;
        var isTimeSeries = $$.axis.isTimeSeries();
        var xOffset = $$.axis.isCategorized() ? 0.5 : 0;
        var regions = [];
        var dasharray = "2 2"; // default value
        var xp;
        var yp;
        var diff;
        var diffx2;
        // check weather data is within region
        var isWithinRegions = function(withinX, withinRegions) {
            for(var i = 0, reg = void 0; reg = withinRegions[i]; i++){
                if (reg.start < withinX && withinX <= reg.end) return reg.style;
            }
            return false;
        };
        // Check start/end of regions
        if (isDefined(_regions)) {
            var getValue = function(v, def) {
                return isUndefined(v) ? def : isTimeSeries ? parseDate.call($$, v) : v;
            };
            for(var i = 0, reg = void 0; reg = _regions[i]; i++){
                var start = getValue(reg.start, d[0].x);
                var end = getValue(reg.end, d[d.length - 1].x);
                var style = reg.style || {
                    dasharray: dasharray
                };
                regions[i] = {
                    start: start,
                    end: end,
                    style: style
                };
            }
        }
        // Set scales
        var xValue = isRotated ? function(dt) {
            return y(dt.value);
        } : function(dt) {
            return x(dt.x);
        };
        var yValue = isRotated ? function(dt) {
            return x(dt.x);
        } : function(dt) {
            return y(dt.value);
        };
        // Define svg generator function for region
        var generateM = function(points) {
            return "M".concat(points[0][0], ",").concat(points[0][1], "L").concat(points[1][0], ",").concat(points[1][1]);
        };
        var sWithRegion = isTimeSeries ? function(d0, d1, k, timeseriesDiff) {
            var x0 = d0.x.getTime();
            var xDiff = d1.x - d0.x;
            var xv0 = new Date(x0 + xDiff * k);
            var xv1 = new Date(x0 + xDiff * (k + timeseriesDiff));
            var points = isRotated ? [
                [
                    y(yp(k)),
                    x(xv0)
                ],
                [
                    y(yp(k + diff)),
                    x(xv1)
                ]
            ] : [
                [
                    x(xv0),
                    y(yp(k))
                ],
                [
                    x(xv1),
                    y(yp(k + diff))
                ]
            ];
            return generateM(points);
        } : function(d0, d1, k, otherDiff) {
            var points = isRotated ? [
                [
                    y(yp(k), true),
                    x(xp(k))
                ],
                [
                    y(yp(k + otherDiff), true),
                    x(xp(k + otherDiff))
                ]
            ] : [
                [
                    x(xp(k), true),
                    y(yp(k))
                ],
                [
                    x(xp(k + otherDiff), true),
                    y(yp(k + otherDiff))
                ]
            ];
            return generateM(points);
        };
        // Generate
        var axisType = {
            x: $$.axis.getAxisType("x"),
            y: $$.axis.getAxisType("y")
        };
        var path = "";
        for(var i = 0, data = void 0; data = d[i]; i++){
            var prevData = d[i - 1];
            var hasPrevData = prevData && isValue(prevData.value);
            var style = isWithinRegions(data.x, regions);
            // https://github.com/naver/billboard.js/issues/1172
            if (!isValue(data.value)) continue;
            // Draw as normal
            if (isUndefined(regions) || !style || !hasPrevData) path += "".concat(i && hasPrevData ? "L" : "M").concat(xValue(data), ",").concat(yValue(data));
            else if (hasPrevData) {
                try {
                    style = style.dasharray.split(" ");
                } catch (e) {
                    style = dasharray.split(" ");
                }
                // Draw with region // TODO: Fix for horizotal charts
                xp = getScale(axisType.x, prevData.x + xOffset, data.x + xOffset);
                yp = getScale(axisType.y, prevData.value, data.value);
                var dx = x(data.x) - x(prevData.x);
                var dy = y(data.value) - y(prevData.value);
                var dd = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
                diff = style[0] / dd;
                diffx2 = diff * style[1];
                for(var j = diff; j <= 1; j += diffx2){
                    path += sWithRegion(prevData, data, j, diff);
                    // to make sure correct line drawing
                    if (j + diffx2 >= 1) path += sWithRegion(prevData, data, 1, 0);
                }
            }
        }
        return path;
    },
    isWithinStep: function(that, y) {
        return Math.abs(y - (0, $iS3vq.default)(that)[1]) < 30;
    },
    shouldDrawPointsForLine: function(d) {
        var linePoint = this.config.line_point;
        return linePoint === true || isArray(linePoint) && linePoint.indexOf(d.id) !== -1;
    }
};
var getTransitionName = function() {
    return getRandom();
};
var shapePoint = {
    hasValidPointType: function(type) {
        return /^(circle|rect(angle)?|polygon|ellipse|use)$/i.test(type || this.config.point_type);
    },
    hasValidPointDrawMethods: function(type) {
        var pointType = type || this.config.point_type;
        return isObjectType(pointType) && isFunction(pointType.create) && isFunction(pointType.update);
    },
    initialOpacityForCircle: function(d) {
        var _a = this, config = _a.config, withoutFadeIn = _a.state.withoutFadeIn;
        var opacity = config.point_opacity;
        if (isUndefined(opacity)) opacity = this.getBaseValue(d) !== null && withoutFadeIn[d.id] ? this.opacityForCircle(d) : "0";
        return opacity;
    },
    opacityForCircle: function(d) {
        var config = this.config;
        var opacity = config.point_opacity;
        if (isUndefined(opacity)) {
            opacity = config.point_show && !config.point_focus_only ? "1" : "0";
            opacity = isValue(this.getBaseValue(d)) ? this.isBubbleType(d) || this.isScatterType(d) ? "0.5" : opacity : "0";
        }
        return opacity;
    },
    initCircle: function() {
        var $$ = this;
        var main = $$.$el.main;
        $$.point = $$.generatePoint();
        if (($$.hasType("bubble") || $$.hasType("scatter")) && main.select(".".concat(CLASS.chartCircles)).empty()) main.select(".".concat(CLASS.chart)).append("g").attr("class", CLASS.chartCircles);
    },
    updateTargetForCircle: function(targetsValue, enterNodeValue) {
        var _this = this;
        var $$ = this;
        var config = $$.config, data = $$.data, $el = $$.$el;
        var selectionEnabled = config.interaction_enabled && config.data_selection_enabled;
        var isSelectable = selectionEnabled && config.data_selection_isselectable;
        var classCircles = $$.getClass("circles", true);
        if (!config.point_show) return;
        !$el.circle && $$.initCircle();
        var targets = targetsValue;
        var enterNode = enterNodeValue;
        // only for scatter & bubble type should generate seprate <g> node
        if (!targets) {
            targets = data.targets.filter(function(d) {
                return _this.isScatterType(d) || _this.isBubbleType(d);
            });
            var mainCircle = $el.main.select(".".concat(CLASS.chartCircles)).style("pointer-events", "none").selectAll(".".concat(CLASS.circles)).data(targets).attr("class", classCircles);
            mainCircle.exit().remove();
            enterNode = mainCircle.enter();
        }
        // Circles for each data point on lines
        selectionEnabled && enterNode.append("g").attr("class", function(d) {
            return $$.generateClass(CLASS.selectedCircles, d.id);
        });
        enterNode.append("g").attr("class", classCircles).style("cursor", function(d) {
            return isSelectable && isSelectable(d) ? "pointer" : null;
        });
        // Update date for selected circles
        selectionEnabled && targets.forEach(function(t) {
            $el.main.selectAll(".".concat(CLASS.selectedCircles).concat($$.getTargetSelectorSuffix(t.id))).selectAll("".concat(CLASS.selectedCircle)).each(function(d) {
                d.value = t.values[d.index].value;
            });
        });
    },
    updateCircle: function() {
        var $$ = this;
        var config = $$.config, state = $$.state, $el = $$.$el;
        var focusOnly = config.point_focus_only;
        if (config.point_show && !state.toggling) {
            var circles = $el.main.selectAll(".".concat(CLASS.circles)).selectAll(".".concat(CLASS.circle)).data(function(d) {
                return $$.isLineType(d) && $$.shouldDrawPointsForLine(d) || $$.isBubbleType(d) || $$.isRadarType(d) || $$.isScatterType(d) ? focusOnly ? [
                    d.values[0]
                ] : d.values : [];
            });
            circles.exit().remove();
            circles.enter().filter(Boolean).append($$.point("create", this, $$.pointR.bind($$), $$.color));
            $el.circle = $el.main.selectAll(".".concat(CLASS.circles, " .").concat(CLASS.circle)).style("stroke", $$.color).style("opacity", $$.initialOpacityForCircle.bind($$));
        }
    },
    redrawCircle: function(cx, cy, withTransition, flow) {
        var $$ = this;
        var rendered = $$.state.rendered, _a = $$.$el, circle = _a.circle, main = _a.main;
        var selectedCircles = main.selectAll(".".concat(CLASS.selectedCircle));
        if (!$$.config.point_show) return [];
        var fn = $$.point("update", $$, cx, cy, $$.color, withTransition, flow, selectedCircles);
        var posAttr = $$.isCirclePoint() ? "c" : "";
        var t = getRandom();
        var opacityStyleFn = $$.opacityForCircle.bind($$);
        var mainCircles = [];
        circle.each(function(d) {
            var result = fn.bind(this)(d);
            result = (withTransition || !rendered ? result.transition(t) : result).style("opacity", opacityStyleFn);
            mainCircles.push(result);
        });
        return [
            mainCircles,
            (withTransition ? selectedCircles.transition() : selectedCircles).attr("".concat(posAttr, "x"), cx).attr("".concat(posAttr, "y"), cy)
        ];
    },
    /**
     * Show focused data point circle
     * @param {object} d Selected data
     * @private
     */ showCircleFocus: function(d) {
        var $$ = this;
        var config = $$.config, _a = $$.state, hasRadar = _a.hasRadar, resizing = _a.resizing, toggling = _a.toggling, transiting = _a.transiting, $el = $$.$el;
        var circle = $el.circle;
        if (transiting === false && config.point_focus_only && circle) {
            var cx = (hasRadar ? $$.radarCircleX : $$.circleX).bind($$);
            var cy = (hasRadar ? $$.radarCircleY : $$.circleY).bind($$);
            var withTransition = toggling || isUndefined(d);
            var fn_1 = $$.point("update", $$, cx, cy, $$.color, resizing ? false : withTransition);
            if (d) circle = circle.filter(function(t) {
                var data = d.filter(function(v) {
                    return v.id === t.id;
                });
                return data.length ? (0, $hOxpW.default)(this).datum(data[0]) : false;
            });
            circle.attr("class", this.updatePointClass.bind(this)).style("opacity", "1").each(function(d) {
                var id = d.id, index = d.index, value = d.value;
                var visibility = "hidden";
                if (isValue(value)) {
                    fn_1.bind(this)(d);
                    $$.expandCircles(index, id);
                    visibility = "";
                }
                this.style.visibility = visibility;
            });
        }
    },
    /**
     * Hide focused data point circle
     * @private
     */ hideCircleFocus: function() {
        var $$ = this;
        var config = $$.config, circle = $$.$el.circle;
        if (config.point_focus_only && circle) {
            $$.unexpandCircles();
            circle.style("visibility", "hidden");
        }
    },
    circleX: function(d) {
        return this.xx(d);
    },
    updateCircleY: function() {
        var $$ = this;
        var getPoints = $$.generateGetLinePoints($$.getShapeIndices($$.isLineType), false);
        $$.circleY = function(d, i) {
            var id = d.id;
            return $$.isGrouped(id) ? getPoints(d, i)[0][1] : $$.getYScaleById(id)($$.getBaseValue(d));
        };
    },
    getCircles: function(i, id) {
        var $$ = this;
        var suffix = isValue(i) ? "-".concat(i) : "";
        return (id ? $$.$el.main.selectAll(".".concat(CLASS.circles).concat($$.getTargetSelectorSuffix(id))) : $$.$el.main).selectAll(".".concat(CLASS.circle).concat(suffix));
    },
    expandCircles: function(i, id, reset) {
        var $$ = this;
        var r = $$.pointExpandedR.bind($$);
        reset && $$.unexpandCircles();
        var circles = $$.getCircles(i, id).classed(CLASS.EXPANDED, true);
        var scale = r(circles) / $$.config.point_r;
        var ratio = 1 - scale;
        if ($$.isCirclePoint()) circles.attr("r", r);
        else // transform must be applied to each node individually
        circles.each(function() {
            var point = (0, $hOxpW.default)(this);
            if (this.tagName === "circle") point.attr("r", r);
            else {
                var _a = this.getBBox(), width = _a.width, height = _a.height;
                var x = ratio * (+point.attr("x") + width / 2);
                var y = ratio * (+point.attr("y") + height / 2);
                point.attr("transform", "translate(".concat(x, " ").concat(y, ") scale(").concat(scale, ")"));
            }
        });
    },
    unexpandCircles: function(i) {
        var $$ = this;
        var r = $$.pointR.bind($$);
        var circles = $$.getCircles(i).filter(function() {
            return (0, $hOxpW.default)(this).classed(CLASS.EXPANDED);
        }).classed(CLASS.EXPANDED, false);
        circles.attr("r", r);
        !$$.isCirclePoint() && circles.attr("transform", "scale(".concat(r(circles) / $$.config.point_r, ")"));
    },
    pointR: function(d) {
        var $$ = this;
        var config = $$.config;
        var pointR = config.point_r;
        var r = pointR;
        if ($$.isBubbleType(d)) r = $$.getBubbleR(d);
        else if (isFunction(pointR)) r = pointR.bind($$.api)(d);
        return r;
    },
    pointExpandedR: function(d) {
        var $$ = this;
        var config = $$.config;
        var scale = $$.isBubbleType(d) ? 1.15 : 1.75;
        return config.point_focus_expand_enabled ? config.point_focus_expand_r || $$.pointR(d) * scale : $$.pointR(d);
    },
    pointSelectR: function(d) {
        var $$ = this;
        var selectR = $$.config.point_select_r;
        return isFunction(selectR) ? selectR(d) : selectR || $$.pointR(d) * 4;
    },
    isWithinCircle: function(node, r) {
        var mouse$1 = (0, $iS3vq.default)(node);
        var element = (0, $hOxpW.default)(node);
        var prefix = this.isCirclePoint(node) ? "c" : "";
        var cx = +element.attr("".concat(prefix, "x"));
        var cy = +element.attr("".concat(prefix, "y"));
        // if node don't have cx/y or x/y attribute value
        if (!(cx || cy) && node.nodeType === 1) {
            var _a = getBoundingRect(node), x = _a.x, y = _a.y;
            cx = x;
            cy = y;
        }
        return Math.sqrt(Math.pow(cx - mouse$1[0], 2) + Math.pow(cy - mouse$1[1], 2)) < (r || this.config.point_sensitivity);
    },
    insertPointInfoDefs: function(point, id) {
        var $$ = this;
        var copyAttr = function(from, target) {
            var attribs = from.attributes;
            for(var i = 0, name_1; name_1 = attribs[i]; i++){
                name_1 = name_1.name;
                target.setAttribute(name_1, from.getAttribute(name_1));
            }
        };
        var doc$1 = new DOMParser().parseFromString(point, "image/svg+xml");
        var node = doc$1.documentElement;
        var clone = doc.createElementNS((0, $7cQXC.default).svg, node.nodeName.toLowerCase());
        clone.id = id;
        clone.style.fill = "inherit";
        clone.style.stroke = "inherit";
        copyAttr(node, clone);
        if (node.childNodes && node.childNodes.length) {
            var parent_1 = (0, $hOxpW.default)(clone);
            if ("innerHTML" in clone) parent_1.html(node.innerHTML);
            else toArray(node.childNodes).forEach(function(v) {
                copyAttr(v, parent_1.append(v.tagName).node());
            });
        }
        $$.$el.defs.node().appendChild(clone);
    },
    pointFromDefs: function(id) {
        return this.$el.defs.select("#".concat(id));
    },
    updatePointClass: function(d) {
        var $$ = this;
        var circle = $$.$el.circle;
        var pointClass = false;
        if (isObject(d) || circle) pointClass = d === true ? circle.each(function(d) {
            var className = $$.getClass("circle", true)(d);
            if (this.getAttribute("class").indexOf(CLASS.EXPANDED) > -1) className += " ".concat(CLASS.EXPANDED);
            this.setAttribute("class", className);
        }) : $$.getClass("circle", true)(d);
        return pointClass;
    },
    generateGetLinePoints: function(lineIndices, isSub) {
        var $$ = this;
        var config = $$.config;
        var x = $$.getShapeX(0, lineIndices, isSub);
        var y = $$.getShapeY(isSub);
        var lineOffset = $$.getShapeOffset($$.isLineType, lineIndices, isSub);
        var yScale = $$.getYScaleById.bind($$);
        return function(d, i) {
            var y0 = yScale.call($$, d.id, isSub)($$.getShapeYMin(d.id));
            var offset = lineOffset(d, i) || y0; // offset is for stacked area chart
            var posX = x(d);
            var posY = y(d);
            // fix posY not to overflow opposite quadrant
            if (config.axis_rotated && (d.value > 0 && posY < y0 || d.value < 0 && y0 < posY)) posY = y0;
            // 1 point that marks the line position
            var point = [
                posX,
                posY - (y0 - offset)
            ];
            return [
                point,
                point,
                point,
                point
            ];
        };
    },
    generatePoint: function() {
        var $$ = this;
        var config = $$.config, datetimeId = $$.state.datetimeId;
        var ids = [];
        var pattern = notEmpty(config.point_pattern) ? config.point_pattern : [
            config.point_type
        ];
        return function(method, context) {
            var args = [];
            for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
            return function(d) {
                var id = $$.getTargetSelectorSuffix(d.id || d.data && d.data.id || d);
                var element = (0, $hOxpW.default)(this);
                ids.indexOf(id) < 0 && ids.push(id);
                var point = pattern[ids.indexOf(id) % pattern.length];
                if ($$.hasValidPointType(point)) point = $$[point];
                else if (!$$.hasValidPointDrawMethods(point)) {
                    var pointId = "".concat(datetimeId, "-point").concat(id);
                    var pointFromDefs = $$.pointFromDefs(pointId);
                    if (pointFromDefs.size() < 1) $$.insertPointInfoDefs(point, pointId);
                    if (method === "create") return $$.custom.create.bind(context).apply(void 0, __spreadArray([
                        element,
                        pointId
                    ], args, false));
                    else if (method === "update") return $$.custom.update.bind(context).apply(void 0, __spreadArray([
                        element
                    ], args, false));
                }
                return point[method].bind(context).apply(void 0, __spreadArray([
                    element
                ], args, false));
            };
        };
    },
    custom: {
        create: function(element, id, sizeFn, fillStyleFn) {
            return element.append("use").attr("xlink:href", "#".concat(id)).attr("class", this.updatePointClass.bind(this)).style("fill", fillStyleFn).node();
        },
        update: function(element, xPosFn, yPosFn, fillStyleFn, withTransition, flow, selectedCircles) {
            var _a = element.node().getBBox(), width = _a.width, height = _a.height;
            var xPosFn2 = function(d) {
                return xPosFn(d) - width / 2;
            };
            var yPosFn2 = function(d) {
                return yPosFn(d) - height / 2;
            };
            var mainCircles = element;
            if (withTransition) {
                var transitionName = getTransitionName();
                flow && mainCircles.attr("x", xPosFn2);
                mainCircles = mainCircles.transition(transitionName);
                selectedCircles && selectedCircles.transition(getTransitionName());
            }
            return mainCircles.attr("x", xPosFn2).attr("y", yPosFn2).style("fill", fillStyleFn);
        }
    },
    // 'circle' data point
    circle: {
        create: function(element, sizeFn, fillStyleFn) {
            return element.append("circle").attr("class", this.updatePointClass.bind(this)).attr("r", sizeFn).style("fill", fillStyleFn).node();
        },
        update: function(element, xPosFn, yPosFn, fillStyleFn, withTransition, flow, selectedCircles) {
            var $$ = this;
            var mainCircles = element;
            // when '.load()' called, bubble size should be updated
            if ($$.hasType("bubble")) mainCircles.attr("r", $$.pointR.bind($$));
            if (withTransition) {
                var transitionName = getTransitionName();
                flow && mainCircles.attr("cx", xPosFn);
                if (mainCircles.attr("cx")) mainCircles = mainCircles.transition(transitionName);
                selectedCircles && selectedCircles.transition(getTransitionName());
            }
            return mainCircles.attr("cx", xPosFn).attr("cy", yPosFn).style("fill", fillStyleFn);
        }
    },
    // 'rectangle' data point
    rectangle: {
        create: function(element, sizeFn, fillStyleFn) {
            var rectSizeFn = function(d) {
                return sizeFn(d) * 2.0;
            };
            return element.append("rect").attr("class", this.updatePointClass.bind(this)).attr("width", rectSizeFn).attr("height", rectSizeFn).style("fill", fillStyleFn).node();
        },
        update: function(element, xPosFn, yPosFn, fillStyleFn, withTransition, flow, selectedCircles) {
            var $$ = this;
            var r = $$.config.point_r;
            var rectXPosFn = function(d) {
                return xPosFn(d) - r;
            };
            var rectYPosFn = function(d) {
                return yPosFn(d) - r;
            };
            var mainCircles = element;
            if (withTransition) {
                var transitionName = getTransitionName();
                flow && mainCircles.attr("x", rectXPosFn);
                mainCircles = mainCircles.transition(transitionName);
                selectedCircles && selectedCircles.transition(getTransitionName());
            }
            return mainCircles.attr("x", rectXPosFn).attr("y", rectYPosFn).style("fill", fillStyleFn);
        }
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * Get the position value
 * @param {boolean} isClockwise If the direction is clockwise
 * @param {string} type Coordinate type 'x' or 'y'
 * @param {number} edge Number of edge
 * @param {number} pos The indexed position
 * @param {number} range Range value
 * @param {number} ratio Ratio value
 * @returns {number}
 * @private
 */ function getPosition(isClockwise, type, edge, pos, range, ratio) {
    var index = isClockwise && pos > 0 ? edge - pos : pos;
    var r = 2 * Math.PI;
    var func = type === "x" ? Math.sin : Math.cos;
    return range * (1 - ratio * func(index * r / edge));
}
// cache key
var cacheKey = KEY.radarPoints;
var shapeRadar = {
    initRadar: function() {
        var $$ = this;
        var config = $$.config, current = $$.state.current, $el = $$.$el;
        if ($$.hasType("radar")) {
            $el.radar = $el.main.select(".".concat(CLASS.chart)).append("g").attr("class", CLASS.chartRadars);
            // level
            $el.radar.levels = $el.radar.append("g").attr("class", CLASS.levels);
            // axis
            $el.radar.axes = $el.radar.append("g").attr("class", CLASS.axis);
            // shapes
            $el.radar.shapes = $el.radar.append("g").attr("class", CLASS.shapes);
            current.dataMax = config.radar_axis_max || $$.getMinMaxData().max[0].value;
        }
    },
    getRadarSize: function() {
        var $$ = this;
        var config = $$.config, _a = $$.state, arcWidth = _a.arcWidth, arcHeight = _a.arcHeight;
        var padding = config.axis_x_categories.length < 4 ? -20 : 10;
        var size = (Math.min(arcWidth, arcHeight) - padding) / 2;
        return [
            size,
            size
        ];
    },
    updateTargetsForRadar: function(targets) {
        var $$ = this;
        var config = $$.config;
        if (isEmpty(config.axis_x_categories)) config.axis_x_categories = getRange(0, getMinMax$1("max", targets.map(function(v) {
            return v.values.length;
        })));
        $$.generateRadarPoints();
    },
    getRadarPosition: function(type, index, range, ratio) {
        var $$ = this;
        var config = $$.config;
        var _a = $$.getRadarSize(), width = _a[0], height = _a[1];
        var edge = config.axis_x_categories.length;
        var isClockwise = config.radar_direction_clockwise;
        var pos = toArray(type).map(function(v) {
            return getPosition(isClockwise, v, edge, index, isDefined(range) ? range : type === "x" ? width : height, isNumber(ratio) ? ratio : config.radar_size_ratio);
        });
        return pos.length === 1 ? pos[0] : pos;
    },
    /**
     * Generate data points
     * @private
     */ generateRadarPoints: function() {
        var $$ = this;
        var targets = $$.data.targets;
        var _a = $$.getRadarSize(), width = _a[0], height = _a[1];
        var points = $$.cache.get(cacheKey) || {};
        var size = points._size;
        // recalculate position only when the previous dimension has been changed
        if (!size || size.width !== width && size.height !== height) {
            targets.forEach(function(d) {
                points[d.id] = d.values.map(function(v, i) {
                    return $$.getRadarPosition([
                        "x",
                        "y"
                    ], i, undefined, $$.getRatio("radar", v));
                });
            });
            points._size = {
                width: width,
                height: height
            };
            $$.cache.add(cacheKey, points);
        }
    },
    redrawRadar: function(durationForExit) {
        var $$ = this;
        var _a = $$.$el, radar = _a.radar, main = _a.main;
        var translate = $$.getTranslate("radar");
        // Adjust radar, circles and texts' position
        if (translate) {
            radar.attr("transform", translate);
            main.select(".".concat(CLASS.chartTexts)).attr("transform", translate);
            $$.generateRadarPoints();
            $$.updateRadarLevel();
            $$.updateRadarAxes();
            $$.updateRadarShape(durationForExit);
        }
    },
    generateGetRadarPoints: function() {
        var points = this.cache.get(cacheKey);
        return function(d, i) {
            var point = points[d.id][i];
            return [
                point,
                point,
                point,
                point
            ];
        };
    },
    updateRadarLevel: function() {
        var $$ = this;
        var config = $$.config, state = $$.state, radar = $$.$el.radar;
        var _a = $$.getRadarSize(), width = _a[0], height = _a[1];
        var depth = config.radar_level_depth;
        var edge = config.axis_x_categories.length;
        var showText = config.radar_level_text_show;
        var radarLevels = radar.levels;
        var levelData = getRange(0, depth);
        var radius = config.radar_size_ratio * Math.min(width, height);
        var levelRatio = levelData.map(function(l) {
            return radius * ((l + 1) / depth);
        });
        var levelTextFormat = (config.radar_level_text_format || function() {}).bind($$.api);
        // Generate points
        var points = levelData.map(function(v) {
            var range = levelRatio[v];
            var pos = getRange(0, edge).map(function(i) {
                return $$.getRadarPosition([
                    "x",
                    "y"
                ], i, range, 1).join(",");
            });
            return pos.join(" ");
        });
        var level = radarLevels.selectAll(".".concat(CLASS.level)).data(levelData);
        level.exit().remove();
        var levelEnter = level.enter().append("g").attr("class", function(d, i) {
            return "".concat(CLASS.level, " ").concat(CLASS.level, "-").concat(i);
        });
        levelEnter.append("polygon").style("visibility", config.radar_level_show ? null : "hidden");
        if (showText) {
            if (radarLevels.select("text").empty()) radarLevels.append("text").attr("dx", "-.5em").attr("dy", "-.7em").style("text-anchor", "end").text(function() {
                return levelTextFormat(0);
            });
            levelEnter.append("text").attr("dx", "-.5em").style("text-anchor", "end").text(function(d) {
                return levelTextFormat(state.current.dataMax / levelData.length * (d + 1));
            });
        }
        levelEnter.merge(level).attr("transform", function(d) {
            return "translate(".concat(width - levelRatio[d], ", ").concat(height - levelRatio[d], ")");
        }).selectAll("polygon").attr("points", function(d) {
            return points[d];
        });
        // update level text position
        if (showText) radarLevels.selectAll("text").attr("x", function(d) {
            return isUndefined(d) ? width : points[d].split(",")[0];
        }).attr("y", function(d) {
            return isUndefined(d) ? height : 0;
        });
    },
    updateRadarAxes: function() {
        var $$ = this;
        var config = $$.config, radar = $$.$el.radar;
        var _a = $$.getRadarSize(), width = _a[0], height = _a[1];
        var categories = config.axis_x_categories;
        var axis = radar.axes.selectAll("g").data(categories);
        axis.exit().remove();
        var axisEnter = axis.enter().append("g").attr("class", function(d, i) {
            return "".concat(CLASS.axis, "-").concat(i);
        });
        config.radar_axis_line_show && axisEnter.append("line");
        config.radar_axis_text_show && axisEnter.append("text");
        axis = axisEnter.merge(axis);
        // axis line
        if (config.radar_axis_line_show) axis.select("line").attr("x1", width).attr("y1", height).attr("x2", function(d, i) {
            return $$.getRadarPosition("x", i);
        }).attr("y2", function(d, i) {
            return $$.getRadarPosition("y", i);
        });
        // axis text
        if (config.radar_axis_text_show) {
            var _b = config.radar_axis_text_position, _c = _b.x, x_1 = _c === void 0 ? 0 : _c, _d = _b.y, y_1 = _d === void 0 ? 0 : _d;
            axis.select("text").style("text-anchor", "middle").attr("dy", ".5em").call(function(selection) {
                selection.each(function(d) {
                    setTextValue((0, $hOxpW.default)(this), String(d), [
                        -0.6,
                        1.2
                    ]);
                });
            }).datum(function(d, i) {
                return {
                    index: i
                };
            }).attr("transform", function(d) {
                if (isUndefined(this.width)) // cache evaluated axis text width
                this.width = this.getBoundingClientRect().width / 2;
                var posX = $$.getRadarPosition("x", d.index, undefined, 1);
                var posY = Math.round($$.getRadarPosition("y", d.index, undefined, 1));
                if (posX > width) posX += this.width + x_1;
                else if (Math.round(posX) < width) posX -= this.width + x_1;
                if (posY > height) {
                    // update vertical centered edge axis text dy position
                    if (posY / 2 === height && this.firstChild.tagName === "tspan") this.firstChild.setAttribute("dy", "0em");
                    posY += y_1;
                } else if (posY < height) posY -= y_1;
                return "translate(".concat(posX, " ").concat(posY, ")");
            });
        }
        $$.bindEvent();
    },
    bindEvent: function() {
        var $$ = this;
        var config = $$.config, _a = $$.state, inputType = _a.inputType, transiting = _a.transiting, _b = $$.$el, radar = _b.radar, svg = _b.svg;
        var focusOnly = config.point_focus_only;
        if (config.interaction_enabled) {
            var isMouse_1 = inputType === "mouse";
            var getIndex_1 = function() {
                var target = (0, $iZ2is.event).target;
                // in case of multilined axis text
                if (/tspan/i.test(target.tagName)) target = target.parentNode;
                var d = (0, $hOxpW.default)(target).datum();
                return d && Object.keys(d).length === 1 ? d.index : undefined;
            };
            var hide = function() {
                var index = getIndex_1();
                var noIndex = isUndefined(index);
                if (isMouse_1 || noIndex) {
                    $$.hideTooltip();
                    focusOnly ? $$.hideCircleFocus() : $$.unexpandCircles();
                    if (isMouse_1) $$.setOverOut(false, index);
                    else if (noIndex) $$.callOverOutForTouch();
                }
            };
            radar.axes.selectAll("text").on(isMouse_1 ? "mouseover " : "touchstart", function() {
                if (transiting) return;
                var index = getIndex_1();
                $$.selectRectForSingle(svg.node(), null, index);
                isMouse_1 ? $$.setOverOut(true, index) : $$.callOverOutForTouch(index);
            }).on("mouseout", isMouse_1 ? hide : null);
            if (!isMouse_1) svg.on("touchstart", hide);
        }
    },
    updateRadarShape: function(durationForExit) {
        var $$ = this;
        var targets = $$.data.targets.filter(function(d) {
            return $$.isRadarType(d);
        });
        var points = $$.cache.get(cacheKey);
        var areas = $$.$el.radar.shapes.selectAll("polygon").data(targets);
        var areasEnter = areas.enter().append("g").attr("class", $$.getChartClass("Radar"));
        areas.exit().transition().duration(durationForExit).remove();
        areasEnter.append("polygon").merge(areas).style("fill", $$.color).style("stroke", $$.color).attr("points", function(d) {
            return points[d.id].join(" ");
        });
        $$.updateTargetForCircle(targets, areasEnter);
    },
    /**
     * Get data point x coordinate
     * @param {object} d Data object
     * @returns {number}
     * @private
     */ radarCircleX: function(d) {
        return this.cache.get(cacheKey)[d.id][d.index][0];
    },
    /**
     * Get data point y coordinate
     * @param {object} d Data object
     * @returns {number}
     * @private
     */ radarCircleY: function(d) {
        return this.cache.get(cacheKey)[d.id][d.index][1];
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * point config options
 */ var optPoint = {
    /**
     * Set point options
     * @name point
     * @memberof Options
     * @type {object}
     * @property {object} point Point object
     * @property {boolean} [point.show=true] Whether to show each point in line.
     * @property {number|Function} [point.r=2.5] The radius size of each point.
     *  - **NOTE:** Disabled for 'bubble' type
     * @property {boolean} [point.focus.expand.enabled=true] Whether to expand each point on focus.
     * @property {number} [point.focus.expand.r=point.r*1.75] The radius size of each point on focus.
     *  - **NOTE:** For 'bubble' type, the default is `bubbleSize*1.15`
     * @property {boolean} [point.focus.only=false] Show point only when is focused.
     * @property {number|null} [point.opacity=undefined] Set point opacity value.
     * - **NOTE:**
     *	- `null` will make to not set inline 'opacity' css prop.
     *	- when no value(or undefined) is set, it defaults to set opacity value according its chart types.
     * @property {number} [point.sensitivity=10] The senstivity value for interaction boundary.
     * @property {number} [point.select.r=point.r*4] The radius size of each point on selected.
     * @property {string} [point.type="circle"] The type of point to be drawn
     * - **NOTE:**
     *   - If chart has 'bubble' type, only circle can be used.
     *   - For IE, non circle point expansions are not supported due to lack of transform support.
     * - **Available Values:**
     *   - circle
     *   - rectangle
     * @property {Array} [point.pattern=[]] The type of point or svg shape as string, to be drawn for each line
     * - **NOTE:**
     *   - This is an `experimental` feature and can have some unexpected behaviors.
     *   - If chart has 'bubble' type, only circle can be used.
     *   - For IE, non circle point expansions are not supported due to lack of transform support.
     * - **Available Values:**
     *   - circle
     *   - rectangle
     *   - svg shape tag interpreted as string<br>
     *     (ex. `<polygon points='2.5 0 0 5 5 5'></polygon>`)
     * @see [Demo: point type](https://naver.github.io/billboard.js/demo/#Point.RectanglePoints)
     * @see [Demo: point focus only](https://naver.github.io/billboard.js/demo/#Point.FocusOnly)
     * @example
     *  point: {
     *      show: false,
     *      r: 5,
     *
     *      // or customize the radius
     *      r: function(d) {
     *          ...
     *          return r;
     *      },
     *
     *      focus: {
     *          expand: {
     *              enabled: true,
     *              r: 1
     *          },
     *          only: true
     *      },
     *
     *      // do not set inline 'opacity' css prop setting
     *      opacity: null,
     *
     *      // set every data point's opacity value
     *      opacity: 0.7,
     *
     *      select: {
     *          r: 3
     *      },
     *
     *      // having lower value, means how closer to be for interaction
     *      sensitivity: 3,
     *
     *      // valid values are "circle" or "rectangle"
     *      type: "rectangle",
     *
     *      // or indicate as pattern
     *      pattern: [
     *        "circle",
     *        "rectangle",
     *        "<polygon points='0 6 4 0 -4 0'></polygon>"
     *     ],
     *  }
     */ point_show: true,
    point_r: 2.5,
    point_sensitivity: 10,
    point_focus_expand_enabled: true,
    point_focus_expand_r: undefined,
    point_focus_only: false,
    point_opacity: undefined,
    point_pattern: [],
    point_select_r: undefined,
    point_type: "circle"
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * area config options
 */ var optArea = {
    /**
     * Set area options
     * @name area
     * @memberof Options
     * @type {object}
     * @property {object} area Area object
     * @property {boolean} [area.above=false] Set background area above the data chart line.
     * @property {boolean} [area.front=true] Set area node to be positioned over line node.
     * @property {boolean|object} [area.linearGradient=false] Set the linear gradient on area.<br><br>
     * Or customize by giving below object value:
     *  - x {Array}: `x1`, `x2` value
     *  - y {Array}: `y1`, `y2` value
     *  - stops {Array}: Each item should be having `[offset, stop-color, stop-opacity]` values.
     * @property {boolean} [area.zerobased=true] Set if min or max value will be 0 on area chart.
     * @see [MDN's &lt;linearGradient>](https://developer.mozilla.org/en-US/docs/Web/SVG/Element/linearGradient), [&lt;stop>](https://developer.mozilla.org/en-US/docs/Web/SVG/Element/stop)
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Chart.AreaChart)
     * @see [Demo: above](https://naver.github.io/billboard.js/demo/#AreaChartOptions.Above)
     * @see [Demo: linearGradient](https://naver.github.io/billboard.js/demo/#AreaChartOptions.LinearGradient)
     * @example
     *  area: {
     *      above: true,
     *      zerobased: false,
     *
     *      // <g class='bb-areas'> will be positioned behind the line <g class='bb-lines'> in stacking order
     *      front: false,
     *
     *      // will generate follwing linearGradient:
     *      // <linearGradient x1="0" x2="0" y1="0" y2="1">
     *      //    <stop offset="0" stop-color="$DATA_COLOR" stop-opacity="1"></stop>
     *      //    <stop offset="1" stop-color="$DATA_COLOR" stop-opacity="0"></stop>
     *      // </linearGradient>
     *      linearGradient: true,
     *
     *      // Or customized gradient
     *      linearGradient: {
     *      	x: [0, 0],  // x1, x2 attributes
     *      	y: [0, 0],  // y1, y2 attributes
     *      	stops: [
     *      	  // offset, stop-color, stop-opacity
     *      	  [0, "#7cb5ec", 1],
     *
     *      	  // setting 'null' for stop-color, will set its original data color
     *      	  [0.5, null, 0],
     *
     *      	  // setting 'function' for stop-color, will pass data id as argument.
     *      	  // It should return color string or null value
     *      	  [1, function(id) { return id === "data1" ? "red" : "blue"; }, 0],
     *      	]
     *      }
     *  }
     */ area_above: false,
    area_front: true,
    area_linearGradient: false,
    area_zerobased: true
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * bar config options
 */ var optBar = {
    /**
     * Set bar options
     * @name bar
     * @memberof Options
     * @type {object}
     * @property {object} bar Bar object
     * @property {number} [bar.label.threshold=0] Set threshold ratio to show/hide labels.
     * @property {number} [bar.padding=0] The padding pixel value between each bar.
     * @property {number} [bar.radius] Set the radius of bar edge in pixel.
     * - **NOTE:** Works only for non-stacked bar
     * @property {number} [bar.radius.ratio] Set the radius ratio of bar edge in relative the bar's width.
     * @property {number} [bar.sensitivity=2] The senstivity offset value for interaction boundary.
     * @property {number} [bar.width] Change the width of bar chart.
     * @property {number} [bar.width.ratio=0.6] Change the width of bar chart by ratio.
     * @property {number} [bar.width.max] The maximum width value for ratio.
     * @property {number} [bar.width.dataname] Change the width of bar for indicated dataset only.
     * - **NOTE:**
     *   - Works only for non-stacked bar
     *   - Bars are centered accoding its total width value
     * @property {number} [bar.width.dataname.ratio=0.6] Change the width of bar chart by ratio.
     * @property {number} [bar.width.dataname.max] The maximum width value for ratio.
     * @property {boolean} [bar.zerobased=true] Set if min or max value will be 0 on bar chart.
     * @see [Demo: bar padding](https://naver.github.io/billboard.js/demo/#BarChartOptions.BarPadding)
     * @see [Demo: bar radius](https://naver.github.io/billboard.js/demo/#BarChartOptions.BarRadius)
     * @see [Demo: bar width](https://naver.github.io/billboard.js/demo/#BarChartOptions.BarWidth)
     * @see [Demo: bar width variant](https://naver.github.io/billboard.js/demo/#BarChartOptions.BarWidthVariant)
     * @example
     *  bar: {
     *      padding: 1,
     *
     *      // the 'radius' option can be used only for non-stacking bars
     *      radius: 10,
     *      // or
     *      radius: {
     *          ratio: 0.5
     *      }
     *
     *      label: {
     *          // 0.1(10%) ratio value means, the minimum ratio to show text label relative to the y Axis domain range value.
     *          // if data value is below than 0.1, text label will be hidden.
     *          threshold: 0.1,
     *      },
     *
     *      // will not have offset between each bar elements for interaction
     *      sensitivity: 0,
     *
     *      width: 10,
     *
     *      // or
     *      width: {
     *          ratio: 0.2,
     *          max: 20
     *      },
     *
     *      // or specify width per dataset
     *      width: {
     *          data1: 20,
     *          data2: {
     *              ratio: 0.2,
     *              max: 20
     *          }
     *      },
     *
     *      zerobased: false
     *  }
     */ bar_label_threshold: 0,
    bar_padding: 0,
    bar_radius: undefined,
    bar_radius_ratio: undefined,
    bar_sensitivity: 2,
    bar_width: undefined,
    bar_width_ratio: 0.6,
    bar_width_max: undefined,
    bar_zerobased: true
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * bubble config options
 */ var optBubble = {
    /**
     * Set bubble options
     * @name bubble
     * @memberof Options
     * @type {object}
     * @property {object} bubble bubble object
     * @property {number|Function} [bubble.maxR=35] Set the max bubble radius value
     * @property {boolean} [bubble.zerobased=false] Set if min or max value will be 0 on bubble chart.
     * @example
     *  bubble: {
     *      // ex) If 100 is the highest value among data bound, the representation bubble of 100 will have radius of 50.
     *      // And the lesser will have radius relatively from tha max value.
     *      maxR: 50,
     *
     *      // or set radius callback
     *      maxR: function(d) {
     *          // ex. of d param - {x: Fri Oct 06 2017 00:00:00 GMT+0900, value: 80, id: "data2", index: 5}
     *          ...
     *          return Math.sqrt(d.value * 2);
     *      },
     *      zerobased: false
     *  }
     */ bubble_maxR: 35,
    bubble_zerobased: false
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * line config options
 */ var optLine = {
    /**
     * Set line options
     * @name line
     * @memberof Options
     * @type {object}
     * @property {object} line Line object
     * @property {boolean} [line.connectNull=false] Set if null data point will be connected or not.<br>
     *  If true set, the region of null data will be connected without any data point. If false set, the region of null data will not be connected and get empty.
     * @property {Array}   [line.classes=undefined] If set, used to set a css class on each line.
     * @property {boolean} [line.step.type=step] Change step type for step chart.<br>
     * **Available values:**
     * - step
     * - step-before
     * - step-after
     * @property {boolean|Array} [line.point=true] Set to false to not draw points on linecharts. Or pass an array of line ids to draw points for.
     * @property {boolean} [line.zerobased=false] Set if min or max value will be 0 on line chart.
     * @example
     *  line: {
     *      connectNull: true,
     *      classes: [
     *          "line-class1",
     *          "line-class2"
     *      ],
     *      step: {
     *          type: "step-after"
     *      },
     *
     *      // hide all data points ('point.show=false' also has similar effect)
     *      point: false,
     *
     *      // show data points for only indicated datas
     *      point: [
     *          "data1", "data3"
     *      ],
     *
     *      zerobased: false
     *  }
     */ line_connectNull: false,
    line_step_type: "step",
    line_zerobased: false,
    line_classes: undefined,
    line_point: true
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * scatter config options
 */ var optScatter = {
    /**
     * Set scatter options
     * @name scatter
     * @memberof Options
     * @type {object}
     * @property {object} [scatter] scatter object
     * @property {boolean} [scatter.zerobased=false] Set if min or max value will be 0 on scatter chart.
     * @example
     *  scatter: {
     *      connectNull: true,
     *      step: {
     *          type: "step-after"
     *      },
     *
     *      // hide all data points ('point.show=false' also has similar effect)
     *      point: false,
     *
     *      // show data points for only indicated datas
     *      point: [
     *          "data1", "data3"
     *      ],
     *
     *      zerobased: false
     *  }
     */ scatter_zerobased: false
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * x Axis config options
 */ var optSpline = {
    /**
     * Set spline options
     * - **Available interpolation type values:**
     *  - basis (d3.curveBasis)
     *  - basis-closed (d3.curveBasisClosed)
     *  - basis-open (d3.curveBasisOpen)
     *  - bundle (d3.curveBundle)
     *  - cardinal (d3.curveCardinal)
     *  - cardinal-closed (d3.curveCardinalClosed)
     *  - cardinal-open (d3.curveCardinalOpen)
     *  - catmull-rom (d3.curveCatmullRom)
     *  - catmull-rom-closed (d3.curveCatmullRomClosed)
     *  - catmull-rom-open (d3.curveCatmullRomOpen)
     *  - monotone-x (d3.curveMonotoneX)
     *  - monotone-y (d3.curveMonotoneY)
     *  - natural (d3.curveNatural)
     *  - linear-closed (d3.curveLinearClosed)
     *  - linear (d3.curveLinear)
     *  - step (d3.curveStep)
     *  - step-after (d3.curveStepAfter)
     *  - step-before (d3.curveStepBefore)
     * @name spline
     * @memberof Options
     * @type {object}
     * @property {object} spline Spline object
     * @property {object} spline.interpolation Spline interpolation object
     * @property {string} [spline.interpolation.type="cardinal"] Interpolation type
     * @see [Interpolation (d3 v4)](http://bl.ocks.org/emmasaunders/c25a147970def2b02d8c7c2719dc7502)
     * @example
     *  spline: {
     *      interpolation: {
     *          type: "cardinal"
     *      }
     *  }
     */ spline_interpolation_type: "cardinal"
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * donut config options
 */ var optDonut = {
    /**
     * Set donut options
     * @name donut
     * @memberof Options
     * @type {object}
     * @property {object} donut Donut object
     * @property {boolean} [donut.label.show=true] Show or hide label on each donut piece.
     * @property {Function} [donut.label.format] Set formatter for the label on each donut piece.
     * @property {number} [donut.label.threshold=0.05] Set threshold ratio to show/hide labels.
     * @property {number|Function} [donut.label.ratio=undefined] Set ratio of labels position.
     * @property {boolean} [donut.expand=true] Enable or disable expanding donut pieces.
     * @property {number} [donut.expand.rate=0.98] Set expand rate.
     * @property {number} [donut.expand.duration=50] Set expand transition time in ms.
     * @property {number} [donut.width] Set width of donut chart.
     * @property {string} [donut.title=""] Set title of donut chart. Use `\n` character for line break.
     * @property {number} [donut.padAngle=0] Set padding between data.
     * @property {number} [donut.startingAngle=0] Set starting angle where data draws.
     * @example
     *  donut: {
     *      label: {
     *          show: false,
     *          format: function(value, ratio, id) {
     *              return d3.format("$")(value);
     *
     *              // to multiline, return with '\n' character
     *              // return value +"%\nLine1\n2Line2";
     *          },
     *
     *          // 0.1(10%) ratio value means, the minimum ratio to show text label relative to the total value.
     *          // if data value is below than 0.1, text label will be hidden.
     *          threshold: 0.1,
     *
     *          // set ratio callback. Should return ratio value
     *          ratio: function(d, radius, h) {
     *          	...
     *          	return ratio;
     *          },
     *          // or set ratio number
     *          ratio: 0.5
     *      },
     *
     *      // disable expand transition for interaction
     *      expand: false,
     *
     *      expand: {
     *      	// set duration of expand transition to 500ms.
     *          duration: 500,
     *
     *      	// set expand area rate
     *          rate: 1
     *      },
     *
     *      width: 10,
     *      padAngle: 0.2,
     *      startingAngle: 1,
     *      title: "Donut Title"
     *
     *      // title with line break
     *      title: "Title1\nTitle2"
     *  }
     */ donut_label_show: true,
    donut_label_format: undefined,
    donut_label_threshold: 0.05,
    donut_label_ratio: undefined,
    donut_width: undefined,
    donut_title: "",
    donut_expand: {},
    donut_expand_rate: 0.98,
    donut_expand_duration: 50,
    donut_padAngle: 0,
    donut_startingAngle: 0
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * gauge config options
 */ var optGauge = {
    /**
     * Set gauge options
     * @name gauge
     * @memberof Options
     * @type {object}
     * @property {object} gauge Gauge object
     * @property {boolean} [gauge.background=""] Set background color. (The `.bb-chart-arcs-background` element)
     * @property {boolean} [gauge.fullCircle=false] Show full circle as donut. When set to 'true', the max label will not be showed due to start and end points are same location.
     * @property {boolean} [gauge.label.show=true] Show or hide label on gauge.
     * @property {Function} [gauge.label.format] Set formatter for the label on gauge. Label text can be multilined with `\n` character.
     * @property {Function} [gauge.label.extents] Set customized min/max label text.
     * @property {number} [gauge.label.threshold=0] Set threshold ratio to show/hide labels.
     * @property {boolean} [gauge.expand=true] Enable or disable expanding gauge.
     * @property {number} [gauge.expand.rate=0.98] Set expand rate.
     * @property {number} [gauge.expand.duration=50] Set the expand transition time in milliseconds.
     * @property {number} [gauge.min=0] Set min value of the gauge.
     * @property {number} [gauge.max=100] Set max value of the gauge.
     * @property {number} [gauge.startingAngle=-1 * Math.PI / 2] Set starting angle where data draws.
     *
     * **Limitations:**
     * - when `gauge.fullCircle=false`:
     *   - -1 * Math.PI / 2 <= startingAngle <= Math.PI / 2
     *   - `startingAngle <= -1 * Math.PI / 2` defaults to `-1 * Math.PI / 2`
     *   - `startingAngle >= Math.PI / 2` defaults to `Math.PI / 2`
     * - when `gauge.fullCircle=true`:
     *   - -1 * Math.PI < startingAngle < Math.PI
     *   - `startingAngle < -1 * Math.PI` defaults to `Math.PI`
     *   - `startingAngle >  Math.PI` defaults to `Math.PI`
     * @property {number} [gauge.arcLength=100] Set the length of the arc to be drawn in percent from -100 to 100.<br>
     * Negative value will draw the arc **counterclockwise**.
     *
     * **Limitations:**
     * - -100 <= arcLength (in percent) <= 100
     * - 'arcLength < -100' defaults to -100
     * - 'arcLength > 100' defaults to 100
     * @property {string} [gauge.title=""] Set title of gauge chart. Use `\n` character for line break.
     * @property {string} [gauge.units] Set units of the gauge.
     * @property {number} [gauge.width] Set width of gauge chart.
     * @property {string} [gauge.type="single"] Set type of gauge to be displayed.<br><br>
     * **Available Values:**
     * - single
     * - multi
     * @property {string} [gauge.arcs.minWidth=5] Set minimal width of gauge arcs until the innerRadius disappears.
     * @see [Demo: archLength](https://naver.github.io/billboard.js/demo/#GaugeChartOptions.GaugeArcLength)
     * @see [Demo: startingAngle](https://naver.github.io/billboard.js/demo/#GaugeChartOptions.GaugeStartingAngle)
     * @example
     *  gauge: {
     *      background: "#eee", // will set 'fill' css prop for '.bb-chart-arcs-background' classed element.
     *      fullCircle: false,
     *      label: {
     *          show: false,
     *          format: function(value, ratio) {
     *              return value;
     *
     *              // to multiline, return with '\n' character
     *              // return value +"%\nLine1\n2Line2";
     *          },
     *
     *           extents: function(value, isMax) {
     *              return (isMax ? "Max:" : "Min:") + value;
     *          },
     *
     *          // 0.1(10%) ratio value means, the minimum ratio to show text label relative to the total value.
     *          // if data value is below than 0.1, text label will be hidden.
     *          threshold: 0.1,
     *      },
     *
     *      // disable expand transition for interaction
     *      expand: false,
     *
     *      expand: {
     *      	// set duration of expand transition to 500ms.
     *          duration: 500,
     *
     *      	// set expand area rate
     *          rate: 1
     *      },
     *
     *      min: -100,
     *      max: 200,
     *      type: "single"  // or 'multi'
     *      title: "Title Text",
     *      units: "%",
     *      width: 10,
     *      startingAngle: -1 * Math.PI / 2,
     *      arcLength: 100,
     *      arcs: {
     *          minWidth: 5
     *      }
     *  }
     */ gauge_background: "",
    gauge_fullCircle: false,
    gauge_label_show: true,
    gauge_label_format: undefined,
    gauge_label_extents: undefined,
    gauge_label_threshold: 0,
    gauge_min: 0,
    gauge_max: 100,
    gauge_type: "single",
    gauge_startingAngle: -1 * Math.PI / 2,
    gauge_arcLength: 100,
    gauge_title: "",
    gauge_units: undefined,
    gauge_width: undefined,
    gauge_arcs_minWidth: 5,
    gauge_expand: {},
    gauge_expand_rate: 0.98,
    gauge_expand_duration: 50
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * x Axis config options
 */ var optPie = {
    /**
     * Set pie options
     * @name pie
     * @memberof Options
     * @type {object}
     * @property {object} pie Pie object
     * @property {boolean} [pie.label.show=true] Show or hide label on each pie piece.
     * @property {Function} [pie.label.format] Set formatter for the label on each pie piece.
     * @property {number} [pie.label.threshold=0.05] Set threshold ratio to show/hide labels.
     * @property {number|Function} [pie.label.ratio=undefined] Set ratio of labels position.
     * @property {boolean|object} [pie.expand=true] Enable or disable expanding pie pieces.
     * @property {number} [pie.expand.rate=0.98] Set expand rate.
     * @property {number} [pie.expand.duration=50] Set expand transition time in ms.
     * @property {number|object} [pie.innerRadius=0] Sets the inner radius of pie arc.
     * @property {number|object|undefined} [pie.outerRadius=undefined] Sets the outer radius of pie arc.
     * @property {number} [pie.padAngle=0] Set padding between data.
     * @property {number} [pie.padding=0] Sets the gap between pie arcs.
     * @property {number} [pie.startingAngle=0] Set starting angle where data draws.
     * @see [Demo: expand.rate](https://naver.github.io/billboard.js/demo/#PieChartOptions.ExpandRate)
     * @see [Demo: innerRadius](https://naver.github.io/billboard.js/demo/#PieChartOptions.InnerRadius)
     * @see [Demo: outerRadius](https://naver.github.io/billboard.js/demo/#PieChartOptions.OuterRadius)
     * @see [Demo: startingAngle](https://naver.github.io/billboard.js/demo/#PieChartOptions.StartingAngle)
     * @example
     *  pie: {
     *      label: {
     *          show: false,
     *          format: function(value, ratio, id) {
     *              return d3.format("$")(value);
     *
     *              // to multiline, return with '\n' character
     *              // return value +"%\nLine1\n2Line2";
     *          },
     *
     *          // 0.1(10%) ratio value means, the minimum ratio to show text label relative to the total value.
     *          // if data value is below than 0.1, text label will be hidden.
     *          threshold: 0.1,
     *
     *          // set ratio callback. Should return ratio value
     *          ratio: function(d, radius, h) {
     *              ...
     *              return ratio;
     *          },
     *          // or set ratio number
     *          ratio: 0.5
     *      },
     *
     *      // disable expand transition for interaction
     *      expand: false,
     *
     *      expand: {
     *      	// set duration of expand transition to 500ms.
     *          duration: 500,
     *
     *      	// set expand area rate
     *          rate: 1
     *      },
     *
     *      innerRadius: 0,
     *
     *      // set different innerRadius for each data
     *      innerRadius: {
     *      	data1: 10,
     *      	data2: 0
     *      },
     *
     *      outerRadius: 100,
     *
     *      // set different outerRadius for each data
     *      outerRadius: {
     *      	data1: 50,
     *      	data2: 100
     *      }
     *
     *      padAngle: 0.1,
     *      padding: 0,
     *      startingAngle: 1
     *  }
     */ pie_label_show: true,
    pie_label_format: undefined,
    pie_label_threshold: 0.05,
    pie_label_ratio: undefined,
    pie_expand: {},
    pie_expand_rate: 0.98,
    pie_expand_duration: 50,
    pie_innerRadius: 0,
    pie_outerRadius: undefined,
    pie_padAngle: 0,
    pie_padding: 0,
    pie_startingAngle: 0
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * x Axis config options
 */ var optRadar = {
    /**
     * Set radar options
     * - **NOTE:**
     *  > When x tick text contains `\n`, it's used as line break.
     * @name radar
     * @memberof Options
     * @type {object}
     * @property {object} radar Radar object
     * @property {number} [radar.axis.max=undefined] The max value of axis. If not given, it'll take the max value from the given data.
     * @property {boolean} [radar.axis.line.show=true] Show or hide axis line.
     * @property {number} [radar.axis.text.position.x=0] x coordinate position, relative the original.
     * @property {number} [radar.axis.text.position.y=0] y coordinate position, relative the original.
     * @property {boolean} [radar.axis.text.show=true] Show or hide axis text.
     * @property {boolean} [radar.direction.clockwise=false] Set the direction to be drawn.
     * @property {number} [radar.level.depth=3] Set the level depth.
     * @property {boolean} [radar.level.show=true] Show or hide level.
     * @property {Function} [radar.level.text.format] Set format function for the level value.<br>- Default value: `(x) => x % 1 === 0 ? x : x.toFixed(2)`
     * @property {boolean} [radar.level.text.show=true] Show or hide level text.
     * @property {number} [radar.size.ratio=0.87] Set size ratio.
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Chart.RadarChart)
     * @see [Demo: radar axis](https://naver.github.io/billboard.js/demo/#RadarChartOptions.RadarAxis)
     * @see [Demo: radar level](https://naver.github.io/billboard.js/demo/#RadarChartOptions.RadarLevel)
     * @see [Demo: radar size](https://naver.github.io/billboard.js/demo/#RadarChartOptions.RadarSize)
     * @see [Demo: radar axis multiline](https://naver.github.io/billboard.js/demo/#RadarChartOptions.RadarAxisMultiline)
     * @example
     *  radar: {
     *      axis: {
     *          max: 50,
     *          line: {
     *              show: false
     *          },
     *          text: {
     *              position: {
     *              	x: 0,
     *              	y: 0
     *              },
     *              show: false
     *          }
     *      },
     *      direction: {
     *          clockwise: true
     *      },
     *      level: {
     *          show: false,
     *          text: {
     *              format: function(x) {
     *                  return x + "%";
     *              },
     *              show: true
     *          }
     *      },
     *      size: {
     *          ratio: 0.7
     *      }
     *  }
     */ radar_axis_max: undefined,
    radar_axis_line_show: true,
    radar_axis_text_show: true,
    radar_axis_text_position: {},
    radar_level_depth: 3,
    radar_level_show: true,
    radar_level_text_format: function(x) {
        return x % 1 === 0 ? x : x.toFixed(2);
    },
    radar_level_text_show: true,
    radar_size_ratio: 0.87,
    radar_direction_clockwise: false
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * Extend Axis
 * @param {Array} module Module to be extended
 * @param {Array} option Option object to be extended
 * @private
 */ function extendAxis(module, option) {
    extend(ChartInternal.prototype, internal.concat(module));
    extend(Chart.prototype, api);
    Options.setOptions(options.concat(option || []));
}
/**
 * Extend Line type modules
 * @param {object} module Module to be extended
 * @param {Array} option Option object to be extended
 * @private
 */ function extendLine(module, option) {
    extendAxis([
        shapePoint,
        shapeLine
    ].concat(module || []));
    Options.setOptions([
        optPoint,
        optLine
    ].concat(option || []));
}
/**
 * Extend Arc type modules
 * @param {Array} module Module to be extended
 * @param {Array} option Option object to be extended
 * @private
 */ function extendArc(module, option) {
    extend(ChartInternal.prototype, [
        shapeArc
    ].concat(module || []));
    Options.setOptions(option);
}
// Area types
var area = function() {
    return extendLine(shapeArea, [
        optArea
    ]), (area = function() {
        return TYPE.AREA;
    })();
};
var areaLineRange = function() {
    return extendLine(shapeArea, [
        optArea
    ]), (areaLineRange = function() {
        return TYPE.AREA_LINE_RANGE;
    })();
};
var areaSpline = function() {
    return extendLine(shapeArea, [
        optArea,
        optSpline
    ]), (areaSpline = function() {
        return TYPE.AREA_SPLINE;
    })();
};
var areaSplineRange = function() {
    return extendLine(shapeArea, [
        optArea,
        optSpline
    ]), (areaSplineRange = function() {
        return TYPE.AREA_SPLINE_RANGE;
    })();
};
var areaStep = function() {
    return extendLine(shapeArea, [
        optArea
    ]), (areaStep = function() {
        return TYPE.AREA_STEP;
    })();
};
// Line types
var line = function() {
    return extendLine(), (line = function() {
        return TYPE.LINE;
    })();
};
var spline = function() {
    return extendLine(undefined, [
        optSpline
    ]), (spline = function() {
        return TYPE.SPLINE;
    })();
};
var step = function() {
    return extendLine(), (step = function() {
        return TYPE.STEP;
    })();
};
// Arc types
var donut = function() {
    return extendArc(undefined, [
        optDonut
    ]), (donut = function() {
        return TYPE.DONUT;
    })();
};
var gauge = function() {
    return extendArc([
        shapeGauge
    ], [
        optGauge
    ]), (gauge = function() {
        return TYPE.GAUGE;
    })();
};
var pie = function() {
    return extendArc(undefined, [
        optPie
    ]), (pie = function() {
        return TYPE.PIE;
    })();
};
var radar = function() {
    return extendArc([
        shapePoint,
        shapeRadar
    ], [
        optPoint,
        optRadar
    ]), (radar = function() {
        return TYPE.RADAR;
    })();
};
// Axis based types
var bar = function() {
    return extendAxis([
        shapeBar
    ], optBar), (bar = function() {
        return TYPE.BAR;
    })();
};
var bubble = function() {
    return extendAxis([
        shapePoint,
        shapeBubble
    ], [
        optBubble,
        optPoint
    ]), (bubble = function() {
        return TYPE.BUBBLE;
    })();
};
var scatter = function() {
    return extendAxis([
        shapePoint
    ], [
        optPoint,
        optScatter
    ]), (scatter = function() {
        return TYPE.SCATTER;
    })();
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var apiSelection = {
    /**
     * Get selected data points.<br><br>
     * By this API, you can get selected data points information. To use this API, data.selection.enabled needs to be set true.
     * @function selected
     * @instance
     * @memberof Chart
     * @param {string} [targetId] You can filter the result by giving target id that you want to get. If not given, all of data points will be returned.
     * @returns {Array} dataPoint Array of the data points.<br>ex.) `[{x: 1, value: 200, id: "data1", index: 1, name: "data1"}, ...]`
     * @example
     *  // all selected data points will be returned.
     *  chart.selected();
     *  // --> ex.) [{x: 1, value: 200, id: "data1", index: 1, name: "data1"}, ... ]
     *
     *  // all selected data points of data1 will be returned.
     *  chart.selected("data1");
     */ selected: function(targetId) {
        var $$ = this.internal;
        var dataPoint = [];
        $$.$el.main.selectAll(".".concat(CLASS.shapes + $$.getTargetSelectorSuffix(targetId))).selectAll(".".concat(CLASS.shape)).filter(function() {
            return (0, $hOxpW.default)(this).classed(CLASS.SELECTED);
        }).each(function(d) {
            return dataPoint.push(d);
        });
        return dataPoint;
    },
    /**
     * Set data points to be selected. ([`data.selection.enabled`](Options.html#.data%25E2%2580%25A4selection%25E2%2580%25A4enabled) option should be set true to use this method)
     * @function select
     * @instance
     * @memberof Chart
     * @param {string|Array} [ids] id value to get selected.
     * @param {Array} [indices] The index array of data points. If falsy value given, will select all data points.
     * @param {boolean} [resetOther] Unselect already selected.
     * @example
     *  // select all data points
     *  chart.select();
     *
     *  // select all from 'data2'
     *  chart.select("data2");
     *
     *  // select all from 'data1' and 'data2'
     *  chart.select(["data1", "data2"]);
     *
     *  // select from 'data1', indices 2 and unselect others selected
     *  chart.select("data1", [2], true);
     *
     *  // select from 'data1', indices 0, 3 and 5
     *  chart.select("data1", [0, 3, 5]);
     */ select: function(ids, indices, resetOther) {
        var $$ = this.internal;
        var config = $$.config, $el = $$.$el;
        if (!config.data_selection_enabled) return;
        $el.main.selectAll(".".concat(CLASS.shapes)).selectAll(".".concat(CLASS.shape)).each(function(d, i) {
            var shape = (0, $hOxpW.default)(this);
            var id = d.data ? d.data.id : d.id;
            var toggle = $$.getToggle(this, d).bind($$);
            var isTargetId = config.data_selection_grouped || !ids || ids.indexOf(id) >= 0;
            var isTargetIndex = !indices || indices.indexOf(i) >= 0;
            var isSelected = shape.classed(CLASS.SELECTED);
            // line/area selection not supported yet
            if (shape.classed(CLASS.line) || shape.classed(CLASS.area)) return;
            if (isTargetId && isTargetIndex) {
                if (config.data_selection_isselectable.bind($$.api)(d) && !isSelected) toggle(true, shape.classed(CLASS.SELECTED, true), d, i);
            } else if (isDefined(resetOther) && resetOther && isSelected) toggle(false, shape.classed(CLASS.SELECTED, false), d, i);
        });
    },
    /**
     * Set data points to be un-selected.
     * @function unselect
     * @instance
     * @memberof Chart
     * @param {string|Array} [ids] id value to be unselected.
     * @param {Array} [indices] The index array of data points. If falsy value given, will select all data points.
     * @example
     *  // unselect all data points
     *  chart.unselect();
     *
     *  // unselect all from 'data1'
     *  chart.unselect("data1");
     *
     *  // unselect from 'data1', indices 2
     *  chart.unselect("data1", [2]);
     */ unselect: function(ids, indices) {
        var $$ = this.internal;
        var config = $$.config, $el = $$.$el;
        if (!config.data_selection_enabled) return;
        $el.main.selectAll(".".concat(CLASS.shapes)).selectAll(".".concat(CLASS.shape)).each(function(d, i) {
            var shape = (0, $hOxpW.default)(this);
            var id = d.data ? d.data.id : d.id;
            var toggle = $$.getToggle(this, d).bind($$);
            var isTargetId = config.data_selection_grouped || !ids || ids.indexOf(id) >= 0;
            var isTargetIndex = !indices || indices.indexOf(i) >= 0;
            var isSelected = shape.classed(CLASS.SELECTED);
            // line/area selection not supported yet
            if (shape.classed(CLASS.line) || shape.classed(CLASS.area)) return;
            if (isTargetId && isTargetIndex && config.data_selection_isselectable.bind($$.api)(d) && isSelected) toggle(false, shape.classed(CLASS.SELECTED, false), d, i);
        });
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * Check if the given domain is within zoom range
 * @param {Array} domain domain value
 * @param {Array} range zoom range value
 * @returns {boolean}
 * @private
 */ function withinRange(domain, range) {
    var min = range[0], max = range[1];
    return domain.every(function(v, i) {
        return i === 0 ? v >= min : v <= max;
    });
}
/**
 * Zoom by giving x domain.
 * - **NOTE:**
 *  - For `wheel` type zoom, the minimum zoom range will be set as the given domain. To get the initial state, [.unzoom()](#unzoom) should be called.
 *  - To be used [zoom.enabled](Options.html#.zoom) option should be set as `truthy`.
 * @function zoom
 * @instance
 * @memberof Chart
 * @param {Array} domainValue If domain is given, the chart will be zoomed to the given domain. If no argument is given, the current zoomed domain will be returned.
 * @returns {Array} domain value in array
 * @example
 *  // Zoom to specified domain
 *  chart.zoom([10, 20]);
 *
 *  // Get the current zoomed domain
 *  chart.zoom();
 */ var zoom$1 = function(domainValue) {
    var $$ = this.internal;
    var config = $$.config, scale = $$.scale;
    var domain = domainValue;
    var resultDomain;
    if (config.zoom_enabled && domain) {
        if ($$.axis.isTimeSeries()) domain = domain.map(function(x) {
            return parseDate.bind($$)(x);
        });
        if (withinRange(domain, $$.getZoomDomain())) {
            // hide any possible tooltip show before the zoom
            $$.api.tooltip.hide();
            if (config.subchart_show) {
                var xScale = scale.zoom || scale.x;
                $$.brush.getSelection().call($$.brush.move, [
                    xScale(domain[0]),
                    xScale(domain[1])
                ]);
                resultDomain = domain;
            } else {
                scale.x.domain(domain);
                scale.zoom = scale.x;
                $$.axis.x.scale(scale.zoom);
                resultDomain = scale.zoom.orgDomain();
            }
            $$.redraw({
                withTransition: true,
                withY: config.zoom_rescale,
                withDimension: false
            });
            $$.setZoomResetButton();
            callFn(config.zoom_onzoom, $$.api, resultDomain);
        }
    } else resultDomain = scale.zoom ? scale.zoom.domain() : scale.x.orgDomain();
    return resultDomain;
};
extend(zoom$1, {
    /**
     * Enable and disable zooming.
     * @function zoom․enable
     * @instance
     * @memberof Chart
     * @param {string|boolean} enabled Possible string values are "wheel" or "drag". If enabled is true, "wheel" will be used. If false is given, zooming will be disabled.<br>When set to false, the current zooming status will be reset.
     * @example
     *  // Enable zooming using the mouse wheel
     *  chart.zoom.enable(true);
     *  // Or
     *  chart.zoom.enable("wheel");
     *
     *  // Enable zooming by dragging
     *  chart.zoom.enable("drag");
     *
     *  // Disable zooming
     *  chart.zoom.enable(false);
     */ enable: function(enabled) {
        var $$ = this.internal;
        var config = $$.config;
        if (/^(drag|wheel)$/.test(enabled)) config.zoom_type = enabled;
        config.zoom_enabled = !!enabled;
        if (!$$.zoom) {
            $$.initZoom();
            $$.bindZoomEvent();
        } else if (enabled === false) $$.bindZoomEvent(false);
        $$.updateAndRedraw();
    },
    /**
     * Set or get x Axis maximum zoom range value
     * @function zoom․max
     * @instance
     * @memberof Chart
     * @param {number} [max] maximum value to set for zoom
     * @returns {number} zoom max value
     * @example
     *  // Set maximum range value
     *  chart.zoom.max(20);
     */ max: function(max) {
        var $$ = this.internal;
        var config = $$.config, xDomain = $$.org.xDomain;
        if (max === 0 || max) config.zoom_x_max = getMinMax$1("max", [
            xDomain[1],
            max
        ]);
        return config.zoom_x_max;
    },
    /**
     * Set or get x Axis minimum zoom range value
     * @function zoom․min
     * @instance
     * @memberof Chart
     * @param {number} [min] minimum value to set for zoom
     * @returns {number} zoom min value
     * @example
     *  // Set minimum range value
     *  chart.zoom.min(-1);
     */ min: function(min) {
        var $$ = this.internal;
        var config = $$.config, xDomain = $$.org.xDomain;
        if (min === 0 || min) config.zoom_x_min = getMinMax$1("min", [
            xDomain[0],
            min
        ]);
        return config.zoom_x_min;
    },
    /**
     * Set zoom range
     * @function zoom․range
     * @instance
     * @memberof Chart
     * @param {object} [range] zoom range
     * @returns {object} zoom range value
     * {
     *   min: 0,
     *   max: 100
     * }
     * @example
     *  chart.zoom.range({
     *      min: 10,
     *      max: 100
     *  });
     */ range: function(range) {
        var zoom = this.zoom;
        if (isObject(range)) {
            var min = range.min, max = range.max;
            isDefined(min) && zoom.min(min);
            isDefined(max) && zoom.max(max);
        }
        return {
            min: zoom.min(),
            max: zoom.max()
        };
    }
});
var apiZoom = {
    zoom: zoom$1,
    /**
     * Unzoom zoomed area
     * @function unzoom
     * @instance
     * @memberof Chart
     * @example
     *  chart.unzoom();
     */ unzoom: function() {
        var $$ = this.internal;
        var config = $$.config;
        if ($$.scale.zoom) {
            config.subchart_show ? $$.brush.getSelection().call($$.brush.move, null) : $$.zoom.updateTransformScale((0, $e3ER1.identity));
            $$.updateZoom(true);
            $$.zoom.resetBtn && $$.zoom.resetBtn.style("display", "none");
            // reset transform
            var eventRects = $$.$el.main.select(".".concat(CLASS.eventRects));
            if ((0, $e3ER1.default)(eventRects.node()) !== (0, $e3ER1.identity)) $$.zoom.transform(eventRects, (0, $e3ER1.identity));
            $$.redraw({
                withTransition: true,
                withUpdateXDomain: true,
                withUpdateOrgXDomain: true,
                withY: config.zoom_rescale
            });
        }
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * Module used for data.selection.draggable option
 */ var drag = {
    /**
     * Called when dragging.
     * Data points can be selected.
     * @private
     * @param {object} mouse Object
     */ drag: function(mouse) {
        var $$ = this;
        var config = $$.config, state = $$.state, main = $$.$el.main;
        var isSelectionGrouped = config.data_selection_grouped;
        var isSelectable = config.interaction_enabled && config.data_selection_isselectable;
        if ($$.hasArcType() || !config.data_selection_enabled || // do nothing if not selectable
        config.zoom_enabled && !$$.zoom.altDomain || // skip if zoomable because of conflict drag behavior
        !config.data_selection_multiple // skip when single selection because drag is used for multiple selection
        ) return;
        var _a = state.dragStart || [
            0,
            0
        ], sx = _a[0], sy = _a[1];
        var mx = mouse[0], my = mouse[1];
        var minX = Math.min(sx, mx);
        var maxX = Math.max(sx, mx);
        var minY = isSelectionGrouped ? state.margin.top : Math.min(sy, my);
        var maxY = isSelectionGrouped ? state.height : Math.max(sy, my);
        main.select(".".concat(CLASS.dragarea)).attr("x", minX).attr("y", minY).attr("width", maxX - minX).attr("height", maxY - minY);
        // TODO: binary search when multiple xs
        main.selectAll(".".concat(CLASS.shapes)).selectAll(".".concat(CLASS.shape)).filter(function(d) {
            return isSelectable && isSelectable.bind($$.api)(d);
        }).each(function(d, i) {
            var shape = (0, $hOxpW.default)(this);
            var isSelected = shape.classed(CLASS.SELECTED);
            var isIncluded = shape.classed(CLASS.INCLUDED);
            var isWithin = false;
            var toggle;
            if (shape.classed(CLASS.circle)) {
                var x = +shape.attr("cx") * 1;
                var y = +shape.attr("cy") * 1;
                toggle = $$.togglePoint;
                isWithin = minX < x && x < maxX && minY < y && y < maxY;
            } else if (shape.classed(CLASS.bar)) {
                var _a = getPathBox(this), x = _a.x, y = _a.y, width = _a.width, height = _a.height;
                toggle = $$.togglePath;
                isWithin = !(maxX < x || x + width < minX) && !(maxY < y || y + height < minY);
            } else // line/area selection not supported yet
            return;
            // @ts-ignore
            if (isWithin ^ isIncluded) {
                shape.classed(CLASS.INCLUDED, !isIncluded);
                // TODO: included/unincluded callback here
                shape.classed(CLASS.SELECTED, !isSelected);
                toggle.call($$, !isSelected, shape, d, i);
            }
        });
    },
    /**
     * Called when the drag starts.
     * Adds and Shows the drag area.
     * @private
     * @param {object} mouse Object
     */ dragstart: function(mouse) {
        var $$ = this;
        var config = $$.config, state = $$.state, main = $$.$el.main;
        if ($$.hasArcType() || !config.data_selection_enabled) return;
        state.dragStart = mouse;
        main.select(".".concat(CLASS.chart)).append("rect").attr("class", CLASS.dragarea).style("opacity", "0.1");
        $$.setDragStatus(true);
    },
    /**
     * Called when the drag finishes.
     * Removes the drag area.
     * @private
     */ dragend: function() {
        var $$ = this;
        var config = $$.config, main = $$.$el.main;
        if ($$.hasArcType() || !config.data_selection_enabled) return;
        main.select(".".concat(CLASS.dragarea)).transition().duration(100).style("opacity", "0").remove();
        main.selectAll(".".concat(CLASS.shape)).classed(CLASS.INCLUDED, false);
        $$.setDragStatus(false);
    }
};
var selection = _assign(_assign({}, drag), {
    /**
     * Select a point
     * @param {object} target Target point
     * @param {object} d Data object
     * @param {number} i Index number
     * @private
     */ selectPoint: function(target, d, i) {
        var $$ = this;
        var config = $$.config, main = $$.$el.main;
        var isRotated = config.axis_rotated;
        var cx = (isRotated ? $$.circleY : $$.circleX).bind($$);
        var cy = (isRotated ? $$.circleX : $$.circleY).bind($$);
        var r = $$.pointSelectR.bind($$);
        callFn(config.data_onselected, $$.api, d, target.node());
        // add selected-circle on low layer g
        main.select(".".concat(CLASS.selectedCircles).concat($$.getTargetSelectorSuffix(d.id))).selectAll(".".concat(CLASS.selectedCircle, "-").concat(i)).data([
            d
        ]).enter().append("circle").attr("class", function() {
            return $$.generateClass(CLASS.selectedCircle, i);
        }).attr("cx", cx).attr("cy", cy).attr("stroke", $$.color).attr("r", function(d2) {
            return $$.pointSelectR(d2) * 1.4;
        }).transition().duration(100).attr("r", r);
    },
    /**
     * Unelect a point
     * @param {object} target Target point
     * @param {object} d Data object
     * @param {number} i Index number
     * @private
     */ unselectPoint: function(target, d, i) {
        var $$ = this;
        var config = $$.config, $el = $$.$el;
        callFn(config.data_onunselected, $$.api, d, target.node());
        // remove selected-circle from low layer g
        $el.main.select(".".concat(CLASS.selectedCircles).concat($$.getTargetSelectorSuffix(d.id))).selectAll(".".concat(CLASS.selectedCircle, "-").concat(i)).transition().duration(100).attr("r", 0).remove();
    },
    /**
     * Toggles the selection of points
     * @param {boolean} selected whether or not to select.
     * @param {object} target Target object
     * @param {object} d Data object
     * @param {number} i Index number
     * @private
     */ togglePoint: function(selected, target, d, i) {
        var method = "".concat(selected ? "" : "un", "selectPoint");
        this[method](target, d, i);
    },
    /**
     * Select a path
     * @param {object} target Target path
     * @param {object} d Data object
     * @private
     */ selectPath: function(target, d) {
        var $$ = this;
        var config = $$.config;
        callFn(config.data_onselected, $$.api, d, target.node());
        if (config.interaction_brighten) target.transition().duration(100).style("fill", function() {
            return (0, $bYoiY.rgb)($$.color(d)).brighter(0.75);
        });
    },
    /**
     * Unelect a path
     * @private
     * @param {object} target Target path
     * @param {object} d Data object
     */ unselectPath: function(target, d) {
        var $$ = this;
        var config = $$.config;
        callFn(config.data_onunselected, $$.api, d, target.node());
        if (config.interaction_brighten) target.transition().duration(100).style("fill", function() {
            return $$.color(d);
        });
    },
    /**
     * Toggles the selection of lines
     * @param {boolean} selected whether or not to select.
     * @param {object} target Target object
     * @param {object} d Data object
     * @param {number} i Index number
     * @private
     */ togglePath: function(selected, target, d, i) {
        this["".concat(selected ? "" : "un", "selectPath")](target, d, i);
    },
    /**
     * Returns the toggle method of the target
     * @param {object} that shape
     * @param {object} d Data object
     * @returns {Function} toggle method
     * @private
     */ getToggle: function(that, d) {
        var $$ = this;
        return that.nodeName === "path" ? $$.togglePath : $$.isStepType(d) ? function() {} : $$.togglePoint;
    },
    /**
     * Toggles the selection of shapes
     * @param {object} that shape
     * @param {object} d Data object
     * @param {number} i Index number
     * @private
     */ toggleShape: function(that, d, i) {
        var $$ = this;
        var config = $$.config, main = $$.$el.main;
        var shape = (0, $hOxpW.default)(that);
        var isSelected = shape.classed(CLASS.SELECTED);
        var toggle = $$.getToggle(that, d).bind($$);
        var toggledShape;
        if (config.data_selection_enabled && config.data_selection_isselectable.bind($$.api)(d)) {
            if (!config.data_selection_multiple) {
                var selector = ".".concat(CLASS.shapes);
                if (config.data_selection_grouped) selector += $$.getTargetSelectorSuffix(d.id);
                main.selectAll(selector).selectAll(".".concat(CLASS.shape)).each(function(d, i) {
                    var shape = (0, $hOxpW.default)(this);
                    if (shape.classed(CLASS.SELECTED)) {
                        toggledShape = shape;
                        toggle(false, shape.classed(CLASS.SELECTED, false), d, i);
                    }
                });
            }
            if (!toggledShape || toggledShape.node() !== shape.node()) {
                shape.classed(CLASS.SELECTED, !isSelected);
                toggle(!isSelected, shape, d, i);
            }
        }
    }
});
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var subchart = {
    /**
     * Initialize the brush.
     * @private
     */ initBrush: function() {
        var $$ = this;
        var config = $$.config, scale = $$.scale, subchart = $$.$el.subchart;
        var isRotated = config.axis_rotated;
        // set the brush
        $$.brush = isRotated ? (0, $7Wzrn.brushY)() : (0, $7Wzrn.brushX)();
        // set "brush" event
        var brushHandler = function() {
            $$.redrawForBrush();
        };
        var getBrushSize = function() {
            var brush = $$.$el.svg.select(".".concat(CLASS.brush, " .overlay"));
            var brushSize = {
                width: 0,
                height: 0
            };
            if (brush.size()) {
                brushSize.width = +brush.attr("width");
                brushSize.height = +brush.attr("height");
            }
            return brushSize[isRotated ? "width" : "height"];
        };
        var lastDomain;
        var timeout;
        $$.brush.on("start", function() {
            $$.state.inputType === "touch" && $$.hideTooltip();
            brushHandler();
        }).on("brush", brushHandler).on("end", function() {
            lastDomain = scale.x.orgDomain();
        });
        $$.brush.updateResize = function() {
            var _this = this;
            timeout && clearTimeout(timeout);
            timeout = setTimeout(function() {
                var selection = _this.getSelection();
                lastDomain && (0, $7Wzrn.brushSelection)(selection.node()) && _this.move(selection, lastDomain.map(scale.subX.orgScale()));
            }, 0);
        };
        $$.brush.update = function() {
            var extent = this.extent()();
            if (extent[1].filter(function(v) {
                return isNaN(v);
            }).length === 0) subchart.main && subchart.main.select(".".concat(CLASS.brush)).call(this);
            return this;
        };
        // set the brush extent
        $$.brush.scale = function(scale) {
            var h = config.subchart_size_height || getBrushSize();
            var extent = $$.getExtent();
            if (!extent && scale.range) extent = [
                [
                    0,
                    0
                ],
                [
                    scale.range()[1],
                    h
                ]
            ];
            else if (isArray(extent)) extent = extent.map(function(v, i) {
                return [
                    v,
                    i > 0 ? h : i
                ];
            });
            // [[x0, y0], [x1, y1]], where [x0, y0] is the top-left corner and [x1, y1] is the bottom-right corner
            isRotated && extent[1].reverse();
            this.extent(extent);
            // when extent updates, brush selection also be re-applied
            // https://github.com/d3/d3/issues/2918
            this.update();
        };
        $$.brush.getSelection = function() {
            return(// @ts-ignore
            subchart.main ? subchart.main.select(".".concat(CLASS.brush)) : (0, $hOxpW.default)([]));
        };
    },
    /**
     * Initialize the subchart.
     * @private
     */ initSubchart: function() {
        var $$ = this;
        var config = $$.config, _a = $$.state, clip = _a.clip, hasAxis = _a.hasAxis, _b = $$.$el, defs = _b.defs, svg = _b.svg, subchart = _b.subchart, axis = _b.axis;
        if (!hasAxis) return;
        var visibility = config.subchart_show ? "visible" : "hidden";
        var clipId = "".concat(clip.id, "-subchart");
        var clipPath = $$.getClipPath(clipId);
        clip.idSubchart = clipId;
        $$.appendClip(defs, clipId);
        $$.initBrush();
        subchart.main = svg.append("g").classed(CLASS.subchart, true).attr("transform", $$.getTranslate("context"));
        var main = subchart.main;
        main.style("visibility", visibility);
        // Define g for chart area
        main.append("g").attr("clip-path", clipPath).attr("class", CLASS.chart);
        // Define g for bar chart area
        $$.hasType("bar") && main.select(".".concat(CLASS.chart)).append("g").attr("class", CLASS.chartBars);
        // Define g for line chart area
        main.select(".".concat(CLASS.chart)).append("g").attr("class", CLASS.chartLines);
        // Add extent rect for Brush
        main.append("g").attr("clip-path", clipPath).attr("class", CLASS.brush).call($$.brush);
        // ATTENTION: This must be called AFTER chart added
        // Add Axis
        axis.subX = main.append("g").attr("class", CLASS.axisX).attr("transform", $$.getTranslate("subX")).attr("clip-path", config.axis_rotated ? "" : clip.pathXAxis).style("visibility", config.subchart_axis_x_show ? visibility : "hidden");
    },
    /**
     * Update sub chart
     * @param {object} targets $$.data.targets
     * @private
     */ updateTargetsForSubchart: function(targets) {
        var $$ = this;
        var config = $$.config, state = $$.state, main = $$.$el.subchart.main;
        var classChartBar = $$.getChartClass("Bar");
        var classBars = $$.getClass("bars", true);
        var classChartLine = $$.getChartClass("Line");
        var classLines = $$.getClass("lines", true);
        var classAreas = $$.getClass("areas", true);
        if (config.subchart_show) {
            // -- Bar --//
            var barUpdate = main.select(".".concat(CLASS.chartBars)).selectAll(".".concat(CLASS.chartBar)).data(targets).attr("class", classChartBar);
            var barEnter = barUpdate.enter().append("g").style("opacity", "0").attr("class", classChartBar).merge(barUpdate);
            // Bars for each data
            barEnter.append("g").attr("class", classBars);
            // -- Line --//
            var lineUpdate = main.select(".".concat(CLASS.chartLines)).selectAll(".".concat(CLASS.chartLine)).data(targets).attr("class", classChartLine);
            var lineEnter = lineUpdate.enter().append("g").style("opacity", "0").attr("class", classChartLine).merge(lineUpdate);
            // Lines for each data
            lineEnter.append("g").attr("class", classLines);
            // Area
            $$.hasTypeOf("Area") && lineEnter.append("g").attr("class", classAreas);
            // -- Brush --//
            main.selectAll(".".concat(CLASS.brush, " rect")).attr(config.axis_rotated ? "width" : "height", config.axis_rotated ? state.width2 : state.height2);
        }
    },
    /**
     * Update the bar of the sub chart
     * @param {object} durationForExit Transition duration
     * @private
     */ updateBarForSubchart: function(durationForExit) {
        var $$ = this;
        var subchart = $$.$el.subchart;
        subchart.bar = subchart.main.selectAll(".".concat(CLASS.bars)).selectAll(".".concat(CLASS.bar)).data($$.barData.bind($$));
        subchart.bar.exit().transition().duration(durationForExit).style("opacity", "0").remove();
        subchart.bar = subchart.bar.enter().append("path").attr("class", $$.getClass("bar", true)).style("stroke", "none").style("fill", $$.color).merge(subchart.bar).style("opacity", $$.initialOpacity.bind($$));
    },
    /**
     * Redraw the bar of the subchart
     * @param {string} drawBarOnSub path in subchart line
     * @param {boolean} withTransition whether or not to transition
     * @param {number} duration transition duration
     * @private
     */ redrawBarForSubchart: function(drawBarOnSub, withTransition, duration) {
        var bar = this.$el.subchart.bar;
        (withTransition ? bar.transition(getRandom()).duration(duration) : bar).attr("d", drawBarOnSub).style("opacity", "1");
    },
    /**
     * Update the line of the sub chart
     * @param {number} durationForExit Fade-out transition duration
     * @private
     */ updateLineForSubchart: function(durationForExit) {
        var $$ = this;
        var subchart = $$.$el.subchart;
        subchart.line = subchart.main.selectAll(".".concat(CLASS.lines)).selectAll(".".concat(CLASS.line)).data($$.lineData.bind($$));
        subchart.line.exit().transition().duration(durationForExit).style("opacity", "0").remove();
        subchart.line = subchart.line.enter().append("path").attr("class", $$.getClass("line", true)).style("stroke", $$.color).merge(subchart.line).style("opacity", $$.initialOpacity.bind($$));
    },
    /**
     * Redraw the line of the subchart
     * @private
     * @param {string} drawLineOnSub path in subchart line
     * @param {boolean} withTransition whether or not to transition
     * @param {number} duration transition duration
     */ redrawLineForSubchart: function(drawLineOnSub, withTransition, duration) {
        var line = this.$el.subchart.line;
        (withTransition ? line.transition(getRandom()).duration(duration) : line).attr("d", drawLineOnSub).style("opacity", "1");
    },
    /**
     * Update the area of the sub chart
     * @param {number} durationForExit Fade-out transition duration
     * @private
     */ updateAreaForSubchart: function(durationForExit) {
        var $$ = this;
        var subchart = $$.$el.subchart;
        subchart.area = subchart.main.selectAll(".".concat(CLASS.areas)).selectAll(".".concat(CLASS.area)).data($$.lineData.bind($$));
        subchart.area.exit().transition().duration(durationForExit).style("opacity", "0").remove();
        subchart.area = subchart.area.enter().append("path").attr("class", $$.getClass("area", true)).style("fill", $$.color).style("opacity", function() {
            $$.state.orgAreaOpacity = (0, $hOxpW.default)(this).style("opacity");
            return "0";
        }).merge(subchart.area).style("opacity", "0");
    },
    /**
     * Redraw the area of the subchart
     * @private
     * @param {string} drawAreaOnSub path in subchart line
     * @param {boolean} withTransition whether or not to transition
     * @param {number} duration transition duration
     */ redrawAreaForSubchart: function(drawAreaOnSub, withTransition, duration) {
        var area = this.$el.subchart.area;
        (withTransition ? area.transition(getRandom()).duration(duration) : area).attr("d", drawAreaOnSub).style("fill", this.color).style("opacity", this.state.orgAreaOpacity);
    },
    /**
     * Redraw subchart.
     * @private
     * @param {boolean} withSubchart whether or not to show subchart
     * @param {number} duration duration
     * @param {object} shape Shape's info
     */ redrawSubchart: function(withSubchart, duration, shape) {
        var $$ = this;
        var config = $$.config, main = $$.$el.subchart.main;
        main.style("visibility", config.subchart_show ? "visible" : "hidden");
        // subchart
        if (config.subchart_show) {
            // reflect main chart to extent on subchart if zoomed
            if ((0, $iZ2is.event) && (0, $iZ2is.event).type === "zoom") $$.brush.update();
            // update subchart elements if needed
            if (withSubchart) {
                // extent rect
                !brushEmpty($$) && $$.brush.update();
                Object.keys(shape.type).forEach(function(v) {
                    var name = capitalize(v);
                    var draw = $$["generateDraw".concat(name)](shape.indices[v], true);
                    $$["update".concat(name, "ForSubchart")](duration);
                    $$["redraw".concat(name, "ForSubchart")](draw, duration, duration);
                });
            }
        }
    },
    /**
     * Redraw the brush.
     * @private
     */ redrawForBrush: function() {
        var $$ = this;
        var _a = $$.config, onBrush = _a.subchart_onbrush, withY = _a.zoom_rescale, scale = $$.scale;
        $$.redraw({
            withTransition: false,
            withY: withY,
            withSubchart: false,
            withUpdateXDomain: true,
            withDimension: false
        });
        onBrush.bind($$.api)(scale.x.orgDomain());
    },
    /**
     * Transform context
     * @param {boolean} withTransition indicates transition is enabled
     * @param {object} transitions The return value of the generateTransitions method of Axis.
     * @private
     */ transformContext: function(withTransition, transitions) {
        var $$ = this;
        var main = $$.$el.subchart.main;
        var subXAxis;
        if (transitions && transitions.axisSubX) subXAxis = transitions.axisSubX;
        else {
            subXAxis = main.select(".".concat(CLASS.axisX));
            if (withTransition) subXAxis = subXAxis.transition();
        }
        main.attr("transform", $$.getTranslate("context"));
        subXAxis.attr("transform", $$.getTranslate("subX"));
    },
    /**
     * Get extent value
     * @returns {Array} default extent
     * @private
     */ getExtent: function() {
        var $$ = this;
        var config = $$.config, scale = $$.scale;
        var extent = config.axis_x_extent;
        if (extent) {
            if (isFunction(extent)) extent = extent.bind($$.api)($$.getXDomain($$.data.targets), scale.subX);
            else if ($$.axis.isTimeSeries() && extent.every(isNaN)) {
                var fn_1 = parseDate.bind($$);
                extent = extent.map(function(v) {
                    return scale.subX(fn_1(v));
                });
            }
        }
        return extent;
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var zoom = {
    /**
     * Initialize zoom.
     * @private
     */ initZoom: function() {
        var $$ = this;
        $$.scale.zoom = null;
        $$.generateZoom();
        $$.initZoomBehaviour();
    },
    /**
     * Bind zoom event
     * @param {boolean} bind Weather bind or unbound
     * @private
     */ bindZoomEvent: function(bind) {
        if (bind === void 0) bind = true;
        var $$ = this;
        var config = $$.config, main = $$.$el.main;
        var zoomEnabled = config.zoom_enabled;
        var eventRects = main.select(".".concat(CLASS.eventRects));
        if (zoomEnabled && bind) // Do not bind zoom event when subchart is shown
        !config.subchart_show && $$.bindZoomOnEventRect(eventRects, config.zoom_type);
        else if (bind === false) {
            $$.api.unzoom();
            eventRects.on(".zoom", null).on(".drag", null);
        }
    },
    /**
     * Generate zoom
     * @private
     */ generateZoom: function() {
        var $$ = this;
        var config = $$.config, org = $$.org, scale = $$.scale;
        var zoom = (0, $cwuwP.default)().duration(0).on("start", $$.onZoomStart.bind($$)).on("zoom", $$.onZoom.bind($$)).on("end", $$.onZoomEnd.bind($$));
        // get zoom extent
        // @ts-ignore
        zoom.orgScaleExtent = function() {
            var extent = config.zoom_extent || [
                1,
                10
            ];
            return [
                extent[0],
                Math.max($$.getMaxDataCount() / extent[1], extent[1])
            ];
        };
        // @ts-ignore
        zoom.updateScaleExtent = function() {
            var ratio = diffDomain($$.scale.x.orgDomain()) / diffDomain($$.getZoomDomain());
            var extent = this.orgScaleExtent();
            this.scaleExtent([
                extent[0] * ratio,
                extent[1] * ratio
            ]);
            return this;
        };
        /**
         * Update scale according zoom transform value
         * @param {object} transform transform object
         * @private
         */ // @ts-ignore
        zoom.updateTransformScale = function(transform) {
            // in case of resize, update range of orgXScale
            org.xScale && org.xScale.range(scale.x.range());
            // rescale from the original scale
            var newScale = transform[config.axis_rotated ? "rescaleY" : "rescaleX"](org.xScale || scale.x);
            var domain = $$.trimXDomain(newScale.domain());
            var rescale = config.zoom_rescale;
            newScale.domain(domain, org.xDomain);
            scale.zoom = $$.getCustomizedScale(newScale);
            $$.axis.x.scale(scale.zoom);
            if (rescale) {
                // copy current initial x scale in case of rescale option is used
                !org.xScale && (org.xScale = scale.x.copy());
                scale.x.domain(domain);
            }
        };
        $$.zoom = zoom;
    },
    /**
     * 'start' event listener
     * @private
     */ onZoomStart: function() {
        var $$ = this;
        var event$1 = (0, $iZ2is.event).sourceEvent;
        if (!event$1) return;
        $$.zoom.startEvent = event$1;
        $$.state.zooming = true;
        callFn($$.config.zoom_onzoomstart, $$.api, event$1);
    },
    /**
     * 'zoom' event listener
     * @private
     */ onZoom: function() {
        var $$ = this;
        var config = $$.config, scale = $$.scale, org = $$.org;
        var event$1 = (0, $iZ2is.event);
        var sourceEvent = event$1.sourceEvent;
        if (!config.zoom_enabled || !event$1.sourceEvent || $$.filterTargetsToShow($$.data.targets).length === 0 || !scale.zoom && sourceEvent.type.indexOf("touch") > -1 && sourceEvent.touches.length === 1) return;
        var isMousemove = sourceEvent.type === "mousemove";
        var isZoomOut = sourceEvent.wheelDelta < 0;
        var transform = event$1.transform;
        if (!isMousemove && isZoomOut && scale.x.domain().every(function(v, i) {
            return v !== org.xDomain[i];
        })) scale.x.domain(org.xDomain);
        $$.zoom.updateTransformScale(transform);
        if ($$.axis.isCategorized() && scale.x.orgDomain()[0] === org.xDomain[0]) scale.x.domain([
            org.xDomain[0] - 1e-10,
            scale.x.orgDomain()[1]
        ]);
        $$.redraw({
            withTransition: false,
            withY: config.zoom_rescale,
            withSubchart: false,
            withEventRect: false,
            withDimension: false
        });
        $$.state.cancelClick = isMousemove;
        callFn(config.zoom_onzoom, $$.api, scale.zoom.domain());
    },
    /**
     * 'end' event listener
     * @private
     */ onZoomEnd: function() {
        var $$ = this;
        var config = $$.config, scale = $$.scale;
        var startEvent = $$.zoom.startEvent;
        var event$1 = (0, $iZ2is.event) && (0, $iZ2is.event).sourceEvent;
        if (startEvent && startEvent.type.indexOf("touch") > -1) {
            startEvent = startEvent.changedTouches[0];
            event$1 = event$1.changedTouches[0];
        }
        // if click, do nothing. otherwise, click interaction will be canceled.
        if (!startEvent || event$1 && startEvent.clientX === event$1.clientX && startEvent.clientY === event$1.clientY) return;
        $$.redrawEventRect();
        $$.updateZoom();
        $$.state.zooming = false;
        callFn(config.zoom_onzoomend, $$.api, scale[scale.zoom ? "zoom" : "subX"].domain());
    },
    /**
     * Get zoom domain
     * @returns {Array} zoom domain
     * @private
     */ getZoomDomain: function() {
        var $$ = this;
        var config = $$.config, org = $$.org;
        var _a = org.xDomain, min = _a[0], max = _a[1];
        if (isDefined(config.zoom_x_min)) min = getMinMax$1("min", [
            min,
            config.zoom_x_min
        ]);
        if (isDefined(config.zoom_x_max)) max = getMinMax$1("max", [
            max,
            config.zoom_x_max
        ]);
        return [
            min,
            max
        ];
    },
    /**
     * Update zoom
     * @param {boolean} force Force unzoom
     * @private
     */ updateZoom: function(force) {
        var $$ = this;
        var _a = $$.scale, subX = _a.subX, x = _a.x, zoom = _a.zoom;
        if (zoom) {
            var zoomDomain = zoom.domain();
            var xDomain = subX.domain();
            var delta = 0.015; // arbitrary value
            var isfullyShown = (zoomDomain[0] <= xDomain[0] || zoomDomain[0] - delta <= xDomain[0]) && (xDomain[1] <= zoomDomain[1] || xDomain[1] <= zoomDomain[1] - delta);
            // check if the zoomed chart is fully shown, then reset scale when zoom is out as initial
            if (force || isfullyShown) {
                $$.axis.x.scale(subX);
                x.domain(subX.orgDomain());
                $$.scale.zoom = null;
            }
        }
    },
    /**
     * Attach zoom event on <rect>
     * @param {d3.selection} eventRects evemt <rect> element
     * @param {string} type zoom type
     * @private
     */ bindZoomOnEventRect: function(eventRects, type) {
        var $$ = this;
        var behaviour = type === "drag" ? $$.zoomBehaviour : $$.zoom;
        eventRects.call(behaviour).on("dblclick.zoom", null);
    },
    /**
     * Initialize the drag behaviour used for zooming.
     * @private
     */ initZoomBehaviour: function() {
        var $$ = this;
        var config = $$.config, state = $$.state;
        var isRotated = config.axis_rotated;
        var start = 0;
        var end = 0;
        var zoomRect;
        var prop = {
            axis: isRotated ? "y" : "x",
            attr: isRotated ? "height" : "width",
            index: isRotated ? 1 : 0
        };
        $$.zoomBehaviour = (0, $Y5MKl.default)().clickDistance(4).on("start", function() {
            $$.setDragStatus(true);
            $$.unselectRect();
            if (!zoomRect) zoomRect = $$.$el.main.append("rect").attr("clip-path", state.clip.path).attr("class", CLASS.zoomBrush).attr("width", isRotated ? state.width : 0).attr("height", isRotated ? 0 : state.height);
            // @ts-ignore
            start = (0, $iS3vq.default)(this)[prop.index];
            end = start;
            zoomRect.attr(prop.axis, start).attr(prop.attr, 0);
            $$.onZoomStart();
        }).on("drag", function() {
            // @ts-ignore
            end = (0, $iS3vq.default)(this)[prop.index];
            zoomRect.attr(prop.axis, Math.min(start, end)).attr(prop.attr, Math.abs(end - start));
        }).on("end", function() {
            var _a;
            var scale = $$.scale.zoom || $$.scale.x;
            $$.setDragStatus(false);
            zoomRect.attr(prop.axis, 0).attr(prop.attr, 0);
            if (start > end) _a = [
                end,
                start
            ], start = _a[0], end = _a[1];
            if (start < 0) {
                end += Math.abs(start);
                start = 0;
            }
            if (start !== end) {
                $$.api.zoom([
                    start,
                    end
                ].map(function(v) {
                    return scale.invert(v);
                }));
                $$.onZoomEnd();
            } else if ($$.isMultipleX()) $$.clickHandlerForMultipleXS.bind(this)($$);
            else {
                var event_1 = (0, $iZ2is.event).sourceEvent || (0, $iZ2is.event);
                var _b = "clientX" in event_1 ? [
                    event_1.clientX,
                    event_1.clientY
                ] : [
                    event_1.x,
                    event_1.y
                ], x = _b[0], y = _b[1];
                var target = doc.elementFromPoint(x, y);
                $$.clickHandlerForSingleX.bind(target)((0, $hOxpW.default)(target).datum(), $$);
            }
        });
    },
    setZoomResetButton: function() {
        var $$ = this;
        var config = $$.config;
        var resetButton = config.zoom_resetButton;
        if (resetButton && config.zoom_type === "drag") {
            if (!$$.zoom.resetBtn) $$.zoom.resetBtn = $$.$el.chart.append("div").classed(CLASS.button, true).append("span").on("click", function() {
                isFunction(resetButton.onclick) && resetButton.onclick.bind($$.api)(this);
                $$.api.unzoom();
            }).classed(CLASS.buttonZoomReset, true).text(resetButton.text || "Reset Zoom");
            else $$.zoom.resetBtn.style("display", null);
        }
    }
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * data.selection config options
 */ var optDataSelection = {
    /**
     * Set data selection enabled<br><br>
     * If this option is set true, we can select the data points and get/set its state of selection by API (e.g. select, unselect, selected).
     *  - **NOTE:** for ESM imports, needs to import 'selection' exports and instantiate it by calling `selection()`.
     *    - `enabled: selection()`
     * @name data․selection․enabled
     * @memberof Options
     * @type {boolean}
     * @default false
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Data.DataSelection)
     * @example
     * data: {
     *    selection: {
     *       enabled: true
     *    }
     * }
     * @example
     * // importing ESM
     * import bb, {selection} from "billboard.js";
     *
     * data: {
     *    selection: {
     *       enabled: selection(),
     *       ...
     *    }
     * }
     */ data_selection_enabled: false,
    /**
     * Set grouped selection enabled.<br><br>
     * If this option set true, multiple data points that have same x value will be selected by one selection.
     * @name data․selection․grouped
     * @memberof Options
     * @type {boolean}
     * @default false
     * @example
     * data: {
     *    selection: {
     *       grouped: true
     *    }
     * }
     */ data_selection_grouped: false,
    /**
     * Set a callback for each data point to determine if it's selectable or not.<br><br>
     * The callback will receive d as an argument and it has some parameters like id, value, index. This callback should return boolean.
     * @name data․selection․isselectable
     * @memberof Options
     * @type {Function}
     * @default function() { return true; }
     * @example
     * data: {
     *    selection: {
     *       isselectable: function(d) { ... }
     *    }
     * }
     */ data_selection_isselectable: function() {
        return true;
    },
    /**
     * Set multiple data points selection enabled.<br><br>
     * If this option set true, multile data points can have the selected state at the same time. If false set, only one data point can have the selected state and the others will be unselected when the new data point is selected.
     * @name data․selection․multiple
     * @memberof Options
     * @type {boolean}
     * @default true
     * @example
     * data: {
     *    selection: {
     *       multiple: false
     *    }
     * }
     */ data_selection_multiple: true,
    /**
     * Enable to select data points by dragging.
     * If this option set true, data points can be selected by dragging.
     * - **NOTE:** If this option set true, scrolling on the chart will be disabled because dragging event will handle the event.
     * @name data․selection․draggable
     * @memberof Options
     * @type {boolean}
     * @default false
     * @example
     * data: {
     *    selection: {
     *       draggable: true
     *   }
     * }
     */ data_selection_draggable: false,
    /**
     * Set a callback for on data selection.
     * @name data․onselected
     * @memberof Options
     * @type {Function}
     * @default function() {}
     * @example
     * data: {
     *     onselected: function(d, element) {
     *        // d - ex) {x: 4, value: 150, id: "data1", index: 4, name: "data1"}
     *        // element - <circle>
     *        ...
     *    }
     * }
     */ data_onselected: function() {},
    /**
     * Set a callback for on data un-selection.
     * @name data․onunselected
     * @memberof Options
     * @type {Function}
     * @default function() {}
     * @example
     * data: {
     *     onunselected: function(d, element) {
     *        // d - ex) {x: 4, value: 150, id: "data1", index: 4, name: "data1"}
     *        // element - <circle>
     *        ...
     *    }
     * }
     */ data_onunselected: function() {}
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * x Axis config options
 */ var optSubchart = {
    /**
     * Set subchart options.
     * - **NOTE:** Not supported for `bubble`, `scatter` and non-Axis based(pie, donut, gauge, radar) types.
     * @name subchart
     * @memberof Options
     * @type {object}
     * @property {object} subchart Subchart object
     * @property {boolean} [subchart.show=false] Show sub chart on the bottom of the chart.
     *  - **NOTE:** for ESM imports, needs to import 'subchart' exports and instantiate it by calling `subchart()`.
     *    - `show: subchart()`
     * @property {boolean} [subchart.axis.x.show=true] Show or hide x axis.
     * @property {boolean} [subchart.axis.x.tick.show=true] Show or hide x axis tick line.
     * @property {boolean} [subchart.axis.x.tick.text.show=true] Show or hide x axis tick text.
     * @property {number} [subchart.size.height] Change the height of the subchart.
     * @property {Function} [subchart.onbrush] Set callback for brush event.<br>
     *  Specified function receives the current zoomed x domain.
     * @see [Demo](https://naver.github.io/billboard.js/demo/#Interaction.SubChart)
     * @example
     *  subchart: {
     *      show: true,
     *      size: {
     *          height: 20
     *      },
     *      axis: {
     *      	x: {
     *      	  show: true,
     *      	    tick: {
     *      	      show: true,
     *      	      text: {
     *      	        show: false
     *      	      }
     *      	    }
     *      	}
     *      },
     *      onbrush: function(domain) { ... }
     *  }
     * @example
     * // importing ESM
     * import bb, {subchart} from "billboard.js";
     *
     * subchart: {
     *      show: subchart(),
     *      ...
     * }
     */ subchart_show: false,
    subchart_size_height: 60,
    subchart_axis_x_show: true,
    subchart_axis_x_tick_show: true,
    subchart_axis_x_tick_text_show: true,
    subchart_onbrush: function() {}
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ /**
 * zoom config options
 */ var optZoom = {
    /**
     * Set zoom options
     * @name zoom
     * @memberof Options
     * @type {object}
     * @property {object} zoom Zoom object
     * @property {boolean} [zoom.enabled=false] Enable zooming.
     *  - **NOTE:** for ESM imports, needs to import 'zoom' exports and instantiate it by calling `zoom()`.
     *    - `enabled: zoom()`
     * @property {string} [zoom.type='wheel'] Set zoom interaction type.
     *  - **Available types:**
     *    - wheel
     *    - drag
     * @property {boolean} [zoom.rescale=false] Enable to rescale after zooming.<br>
     *  If true set, y domain will be updated according to the zoomed region.
     * @property {Array} [zoom.extent=[1, 10]] Change zoom extent.
     * @property {number|Date} [zoom.x.min] Set x Axis minimum zoom range
     * @property {number|Date} [zoom.x.max] Set x Axis maximum zoom range
     * @property {Function} [zoom.onzoomstart=undefined] Set callback that is called when zooming starts.<br>
     *  Specified function receives the zoom event.
     * @property {Function} [zoom.onzoom=undefined] Set callback that is called when the chart is zooming.<br>
     *  Specified function receives the zoomed domain.
     * @property {Function} [zoom.onzoomend=undefined] Set callback that is called when zooming ends.<br>
     *  Specified function receives the zoomed domain.
     * @property {boolean|object} [zoom.resetButton=true] Set to display zoom reset button for 'drag' type zoom
     * @property {Function} [zoom.resetButton.onclick] Set callback when clicks the reset button. The callback will receive reset button element reference as argument.
     * @property {string} [zoom.resetButton.text='Reset Zoom'] Text value for zoom reset button.
     * @see [Demo:zoom](https://naver.github.io/billboard.js/demo/#Interaction.Zoom)
     * @see [Demo:drag zoom](https://naver.github.io/billboard.js/demo/#Interaction.DragZoom)
     * @example
     *  zoom: {
     *      enabled: true,
     *      type: "drag",
     *      rescale: true,
     *      extent: [1, 100]  // enable more zooming
     *      x: {
     *          min: -1,  // set min range
     *          max: 10  // set max range
     *      },
     *      onzoomstart: function(event) { ... },
     *      onzoom: function(domain) { ... },
     *      onzoomend: function(domain) { ... },
     *
     *      // show reset button when is zoomed-in
     *      resetButton: true,
     *
     *      resetButton: {
     *          // onclick callback when reset button is clicked
     *          onclick: function(button) {
     *            button; // Reset button element reference
     *            ...
     *          },
     *
     *          // customized text value for reset zoom button
     *          text: "Unzoom"
     *      }
     *  }
     * @example
     * // importing ESM
     * import bb, {zoom} from "billboard.js";
     *
     * zoom: {
     *      enabled: zoom(),
     *      ...
     * }
     */ zoom_enabled: false,
    zoom_type: "wheel",
    zoom_extent: undefined,
    zoom_privileged: false,
    zoom_rescale: false,
    zoom_onzoom: undefined,
    zoom_onzoomstart: undefined,
    zoom_onzoomend: undefined,
    zoom_resetButton: true,
    zoom_x_min: undefined,
    zoom_x_max: undefined
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */ var selectionModule = function() {
    extend(ChartInternal.prototype, selection);
    extend(Chart.prototype, apiSelection);
    Options.setOptions([
        optDataSelection
    ]);
    return (selectionModule = function() {
        return true;
    })();
};
var subchartModule = function() {
    extend(ChartInternal.prototype, subchart);
    Options.setOptions([
        optSubchart
    ]);
    return (subchartModule = function() {
        return true;
    })();
};
var zoomModule = function() {
    extend(ChartInternal.prototype, zoom);
    extend(Chart.prototype, apiZoom);
    Options.setOptions([
        optZoom
    ]);
    return (zoomModule = function() {
        return true;
    })();
};
/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard project is licensed under the MIT license
 */ var defaults = {};
/**
 * @namespace bb
 * @version 2.2.8
 */ var bb = {
    /**
     * Version information
     * @property {string} version version
     * @example
     *    bb.version;  // "1.0.0"
     * @memberof bb
     */ version: "2.2.8",
    /**
     * Generate chart
     * - **NOTE:** Bear in mind for the possiblity of ***throwing an error***, during the generation when:
     *   - Unused option value is given.
     *     - ex) For `data.type="pie"` option, setting 'axis' option can cause unexpected generation error.
     *   - Insufficient value is given for certain option used.
     *     - ex) `data: { x: "x", columns: [["x"], ["data1", 30, 200, 100]] }`
     * @param {Options} config chart options
     * @memberof bb
     * @returns {Chart}
     * @see {@link Options} for different generation options
     * @see {@link Chart} for different methods API
     * @example
     *  <!-- chart holder -->
     * <div id="LineChart"></div>
     * @example
     *  // Generate chart with options
     *  var chart = bb.generate({
     *      "bindto": "#LineChart"
     *      "data": {
     *          "columns": [
     *              ["data1", 30, 200, 100, 400, 150, 250],
     *              ["data2", 50, 20, 10, 40, 15, 25]
     *           ],
     *          "type": "line"
     *      }
     *  });
     *
     *  // call some API
     *  // ex) get the data of 'data1'
     *  chart.data("data1");
     * @example
     * // Generate chart by importing ESM
     * // Import types to be used only, where this will make smaller bundle size.
     * import bb, {
     *   area,
     *   areaLineRange,
     *   areaSpline,
     *   areaSplineRange,
     *   areaStep,
     *   bar,
     *   bubble,
     *   donut,
     *   gauge,
     *   line,
     *   pie,
     *   radar,
     *   scatter,
     *   spline,
     *   step
     * }
     *
     * bb.generate({
     *      "bindto": "#LineChart"
     *      "data": {
     *          "columns": [
     *              ["data1", 30, 200, 100, 400, 150, 250],
     *              ["data2", 50, 20, 10, 40, 15, 25]
     *           ]
     *      },
     *      type: line(),
     *
     *      // or
     *      types: {
     *        data1: bar(),
     *        data2: step()
     *      }
     * });
     */ generate: function(config) {
        var options = mergeObj({}, defaults, config);
        var inst = new Chart(options);
        inst.internal.charts = this.instance;
        this.instance.push(inst);
        return inst;
    },
    /**
     * Set or get global default options.
     * - **NOTE:**
     *   - The options values settings are valid within page context only.
     *   - If is called multiple times, will override the last value.
     * @param {Options} options chart options
     * @memberof bb
     * @returns {Options}
     * @see {@link Options}
     * @example
     * // Set same option value as for `.generate()`
     * bb.defaults({
     *   data: {
     *     type: "bar"
     *   }
     * });
     *
     * bb.defaults();  // {data:{type: "bar"}}
     *
     * // data.type defaults to 'bar'
     * var chart = bb.generate({ ... });
     */ defaults: function(options) {
        if (isObject(options)) defaults = options;
        return defaults;
    },
    /**
     * An array containing instance created
     * @property {Array} instance instance array
     * @example
     *  // generate charts
     *  var chart1 = bb.generate(...);
     *  var chart2 = bb.generate(...);
     *
     *  bb.instance;  // [ chart1, chart2, ... ]
     * @memberof bb
     */ instance: [],
    /**
     * Namespace for plugins
     * @property {object} plugin plugin namespace
     * @example
     *  // Stanford diagram plugin
     *  bb.plugin.stanford;
     * @memberof bb
     */ plugin: {}
};

});
parcelRegister("UutV9", function(module, exports) {

$parcel$export(module.exports, "timeFormat", () => $0a9ce0165786feda$export$94f4d87fad5dcf9a);
$parcel$export(module.exports, "timeParse", () => $0a9ce0165786feda$export$32b9cd16e1b8c8d2);
$parcel$export(module.exports, "utcFormat", () => $0a9ce0165786feda$export$1a08fe38f63ebbbb);
$parcel$export(module.exports, "utcParse", () => $0a9ce0165786feda$export$3edae9cf8e233729);

var $61I4u = parcelRequire("61I4u");
var $0a9ce0165786feda$var$locale;
var $0a9ce0165786feda$export$94f4d87fad5dcf9a;
var $0a9ce0165786feda$export$32b9cd16e1b8c8d2;
var $0a9ce0165786feda$export$1a08fe38f63ebbbb;
var $0a9ce0165786feda$export$3edae9cf8e233729;
$0a9ce0165786feda$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $0a9ce0165786feda$export$2e2bcd8739ae039(definition) {
    $0a9ce0165786feda$var$locale = (0, $61I4u.default)(definition);
    $0a9ce0165786feda$export$94f4d87fad5dcf9a = $0a9ce0165786feda$var$locale.format;
    $0a9ce0165786feda$export$32b9cd16e1b8c8d2 = $0a9ce0165786feda$var$locale.parse;
    $0a9ce0165786feda$export$1a08fe38f63ebbbb = $0a9ce0165786feda$var$locale.utcFormat;
    $0a9ce0165786feda$export$3edae9cf8e233729 = $0a9ce0165786feda$var$locale.utcParse;
    return $0a9ce0165786feda$var$locale;
}

});
parcelRegister("61I4u", function(module, exports) {

$parcel$export(module.exports, "default", () => $463505b9d968caf4$export$2e2bcd8739ae039);

var $72rFk = parcelRequire("72rFk");
var $aW15j = parcelRequire("aW15j");
var $j0Fj9 = parcelRequire("j0Fj9");
var $2CWR6 = parcelRequire("2CWR6");
var $9DXjR = parcelRequire("9DXjR");
var $daOr3 = parcelRequire("daOr3");
function $463505b9d968caf4$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $463505b9d968caf4$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $463505b9d968caf4$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $463505b9d968caf4$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $463505b9d968caf4$var$formatRe(locale_periods), periodLookup = $463505b9d968caf4$var$formatLookup(locale_periods), weekdayRe = $463505b9d968caf4$var$formatRe(locale_weekdays), weekdayLookup = $463505b9d968caf4$var$formatLookup(locale_weekdays), shortWeekdayRe = $463505b9d968caf4$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $463505b9d968caf4$var$formatLookup(locale_shortWeekdays), monthRe = $463505b9d968caf4$var$formatRe(locale_months), monthLookup = $463505b9d968caf4$var$formatLookup(locale_months), shortMonthRe = $463505b9d968caf4$var$formatRe(locale_shortMonths), shortMonthLookup = $463505b9d968caf4$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $463505b9d968caf4$var$formatDayOfMonth,
        "e": $463505b9d968caf4$var$formatDayOfMonth,
        "f": $463505b9d968caf4$var$formatMicroseconds,
        "g": $463505b9d968caf4$var$formatYearISO,
        "G": $463505b9d968caf4$var$formatFullYearISO,
        "H": $463505b9d968caf4$var$formatHour24,
        "I": $463505b9d968caf4$var$formatHour12,
        "j": $463505b9d968caf4$var$formatDayOfYear,
        "L": $463505b9d968caf4$var$formatMilliseconds,
        "m": $463505b9d968caf4$var$formatMonthNumber,
        "M": $463505b9d968caf4$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $463505b9d968caf4$var$formatUnixTimestamp,
        "s": $463505b9d968caf4$var$formatUnixTimestampSeconds,
        "S": $463505b9d968caf4$var$formatSeconds,
        "u": $463505b9d968caf4$var$formatWeekdayNumberMonday,
        "U": $463505b9d968caf4$var$formatWeekNumberSunday,
        "V": $463505b9d968caf4$var$formatWeekNumberISO,
        "w": $463505b9d968caf4$var$formatWeekdayNumberSunday,
        "W": $463505b9d968caf4$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $463505b9d968caf4$var$formatYear,
        "Y": $463505b9d968caf4$var$formatFullYear,
        "Z": $463505b9d968caf4$var$formatZone,
        "%": $463505b9d968caf4$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $463505b9d968caf4$var$formatUTCDayOfMonth,
        "e": $463505b9d968caf4$var$formatUTCDayOfMonth,
        "f": $463505b9d968caf4$var$formatUTCMicroseconds,
        "g": $463505b9d968caf4$var$formatUTCYearISO,
        "G": $463505b9d968caf4$var$formatUTCFullYearISO,
        "H": $463505b9d968caf4$var$formatUTCHour24,
        "I": $463505b9d968caf4$var$formatUTCHour12,
        "j": $463505b9d968caf4$var$formatUTCDayOfYear,
        "L": $463505b9d968caf4$var$formatUTCMilliseconds,
        "m": $463505b9d968caf4$var$formatUTCMonthNumber,
        "M": $463505b9d968caf4$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $463505b9d968caf4$var$formatUnixTimestamp,
        "s": $463505b9d968caf4$var$formatUnixTimestampSeconds,
        "S": $463505b9d968caf4$var$formatUTCSeconds,
        "u": $463505b9d968caf4$var$formatUTCWeekdayNumberMonday,
        "U": $463505b9d968caf4$var$formatUTCWeekNumberSunday,
        "V": $463505b9d968caf4$var$formatUTCWeekNumberISO,
        "w": $463505b9d968caf4$var$formatUTCWeekdayNumberSunday,
        "W": $463505b9d968caf4$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $463505b9d968caf4$var$formatUTCYear,
        "Y": $463505b9d968caf4$var$formatUTCFullYear,
        "Z": $463505b9d968caf4$var$formatUTCZone,
        "%": $463505b9d968caf4$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $463505b9d968caf4$var$parseDayOfMonth,
        "e": $463505b9d968caf4$var$parseDayOfMonth,
        "f": $463505b9d968caf4$var$parseMicroseconds,
        "g": $463505b9d968caf4$var$parseYear,
        "G": $463505b9d968caf4$var$parseFullYear,
        "H": $463505b9d968caf4$var$parseHour24,
        "I": $463505b9d968caf4$var$parseHour24,
        "j": $463505b9d968caf4$var$parseDayOfYear,
        "L": $463505b9d968caf4$var$parseMilliseconds,
        "m": $463505b9d968caf4$var$parseMonthNumber,
        "M": $463505b9d968caf4$var$parseMinutes,
        "p": parsePeriod,
        "q": $463505b9d968caf4$var$parseQuarter,
        "Q": $463505b9d968caf4$var$parseUnixTimestamp,
        "s": $463505b9d968caf4$var$parseUnixTimestampSeconds,
        "S": $463505b9d968caf4$var$parseSeconds,
        "u": $463505b9d968caf4$var$parseWeekdayNumberMonday,
        "U": $463505b9d968caf4$var$parseWeekNumberSunday,
        "V": $463505b9d968caf4$var$parseWeekNumberISO,
        "w": $463505b9d968caf4$var$parseWeekdayNumberSunday,
        "W": $463505b9d968caf4$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $463505b9d968caf4$var$parseYear,
        "Y": $463505b9d968caf4$var$parseFullYear,
        "Z": $463505b9d968caf4$var$parseZone,
        "%": $463505b9d968caf4$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $463505b9d968caf4$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $463505b9d968caf4$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $463505b9d968caf4$var$utcDate($463505b9d968caf4$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $9DXjR.utcMonday).ceil(week) : (0, $9DXjR.utcMonday)(week);
                    week = (0, $2CWR6.default).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $463505b9d968caf4$var$localDate($463505b9d968caf4$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $aW15j.monday).ceil(week) : (0, $aW15j.monday)(week);
                    week = (0, $72rFk.default).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $463505b9d968caf4$var$utcDate($463505b9d968caf4$var$newDate(d.y, 0, 1)).getUTCDay() : $463505b9d968caf4$var$localDate($463505b9d968caf4$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $463505b9d968caf4$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $463505b9d968caf4$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $463505b9d968caf4$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $463505b9d968caf4$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $463505b9d968caf4$var$numberRe = /^\s*\d+/, $463505b9d968caf4$var$percentRe = /^%/, $463505b9d968caf4$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $463505b9d968caf4$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $463505b9d968caf4$var$requote(s) {
    return s.replace($463505b9d968caf4$var$requoteRe, "\\$&");
}
function $463505b9d968caf4$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($463505b9d968caf4$var$requote).join("|") + ")", "i");
}
function $463505b9d968caf4$var$formatLookup(names) {
    var map = {}, i = -1, n = names.length;
    while(++i < n)map[names[i].toLowerCase()] = i;
    return map;
}
function $463505b9d968caf4$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekNumberSunday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekNumberISO(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekNumberMonday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseFullYear(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseYear(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseQuarter(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMonthNumber(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseDayOfMonth(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseDayOfYear(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseHour24(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMinutes(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseSeconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMilliseconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMicroseconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseLiteralPercent(d, string, i) {
    var n = $463505b9d968caf4$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $463505b9d968caf4$var$parseUnixTimestamp(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$formatDayOfMonth(d, p) {
    return $463505b9d968caf4$var$pad(d.getDate(), p, 2);
}
function $463505b9d968caf4$var$formatHour24(d, p) {
    return $463505b9d968caf4$var$pad(d.getHours(), p, 2);
}
function $463505b9d968caf4$var$formatHour12(d, p) {
    return $463505b9d968caf4$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $463505b9d968caf4$var$formatDayOfYear(d, p) {
    return $463505b9d968caf4$var$pad(1 + (0, $72rFk.default).count((0, $j0Fj9.default)(d), d), p, 3);
}
function $463505b9d968caf4$var$formatMilliseconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getMilliseconds(), p, 3);
}
function $463505b9d968caf4$var$formatMicroseconds(d, p) {
    return $463505b9d968caf4$var$formatMilliseconds(d, p) + "000";
}
function $463505b9d968caf4$var$formatMonthNumber(d, p) {
    return $463505b9d968caf4$var$pad(d.getMonth() + 1, p, 2);
}
function $463505b9d968caf4$var$formatMinutes(d, p) {
    return $463505b9d968caf4$var$pad(d.getMinutes(), p, 2);
}
function $463505b9d968caf4$var$formatSeconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getSeconds(), p, 2);
}
function $463505b9d968caf4$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $463505b9d968caf4$var$formatWeekNumberSunday(d, p) {
    return $463505b9d968caf4$var$pad((0, $aW15j.sunday).count((0, $j0Fj9.default)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $aW15j.thursday)(d) : (0, $aW15j.thursday).ceil(d);
}
function $463505b9d968caf4$var$formatWeekNumberISO(d, p) {
    d = $463505b9d968caf4$var$dISO(d);
    return $463505b9d968caf4$var$pad((0, $aW15j.thursday).count((0, $j0Fj9.default)(d), d) + ((0, $j0Fj9.default)(d).getDay() === 4), p, 2);
}
function $463505b9d968caf4$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $463505b9d968caf4$var$formatWeekNumberMonday(d, p) {
    return $463505b9d968caf4$var$pad((0, $aW15j.monday).count((0, $j0Fj9.default)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$formatYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatYearISO(d, p) {
    d = $463505b9d968caf4$var$dISO(d);
    return $463505b9d968caf4$var$pad(d.getFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatFullYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $aW15j.thursday)(d) : (0, $aW15j.thursday).ceil(d);
    return $463505b9d968caf4$var$pad(d.getFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $463505b9d968caf4$var$pad(z / 60 | 0, "0", 2) + $463505b9d968caf4$var$pad(z % 60, "0", 2);
}
function $463505b9d968caf4$var$formatUTCDayOfMonth(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCDate(), p, 2);
}
function $463505b9d968caf4$var$formatUTCHour24(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCHours(), p, 2);
}
function $463505b9d968caf4$var$formatUTCHour12(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $463505b9d968caf4$var$formatUTCDayOfYear(d, p) {
    return $463505b9d968caf4$var$pad(1 + (0, $2CWR6.default).count((0, $daOr3.default)(d), d), p, 3);
}
function $463505b9d968caf4$var$formatUTCMilliseconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $463505b9d968caf4$var$formatUTCMicroseconds(d, p) {
    return $463505b9d968caf4$var$formatUTCMilliseconds(d, p) + "000";
}
function $463505b9d968caf4$var$formatUTCMonthNumber(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $463505b9d968caf4$var$formatUTCMinutes(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCMinutes(), p, 2);
}
function $463505b9d968caf4$var$formatUTCSeconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCSeconds(), p, 2);
}
function $463505b9d968caf4$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $463505b9d968caf4$var$formatUTCWeekNumberSunday(d, p) {
    return $463505b9d968caf4$var$pad((0, $9DXjR.utcSunday).count((0, $daOr3.default)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $9DXjR.utcThursday)(d) : (0, $9DXjR.utcThursday).ceil(d);
}
function $463505b9d968caf4$var$formatUTCWeekNumberISO(d, p) {
    d = $463505b9d968caf4$var$UTCdISO(d);
    return $463505b9d968caf4$var$pad((0, $9DXjR.utcThursday).count((0, $daOr3.default)(d), d) + ((0, $daOr3.default)(d).getUTCDay() === 4), p, 2);
}
function $463505b9d968caf4$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $463505b9d968caf4$var$formatUTCWeekNumberMonday(d, p) {
    return $463505b9d968caf4$var$pad((0, $9DXjR.utcMonday).count((0, $daOr3.default)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$formatUTCYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatUTCYearISO(d, p) {
    d = $463505b9d968caf4$var$UTCdISO(d);
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatUTCFullYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $9DXjR.utcThursday)(d) : (0, $9DXjR.utcThursday).ceil(d);
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatUTCZone() {
    return "+0000";
}
function $463505b9d968caf4$var$formatLiteralPercent() {
    return "%";
}
function $463505b9d968caf4$var$formatUnixTimestamp(d) {
    return +d;
}
function $463505b9d968caf4$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});
parcelRegister("72rFk", function(module, exports) {

$parcel$export(module.exports, "default", () => $51fe2e20810fcb40$export$2e2bcd8739ae039);

var $kOu3f = parcelRequire("kOu3f");

var $dXf4A = parcelRequire("dXf4A");
var $51fe2e20810fcb40$var$day = (0, $kOu3f.default)(function(date) {
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setDate(date.getDate() + step);
}, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $dXf4A.durationMinute)) / (0, $dXf4A.durationDay);
}, function(date) {
    return date.getDate() - 1;
});
var $51fe2e20810fcb40$export$2e2bcd8739ae039 = $51fe2e20810fcb40$var$day;
var $51fe2e20810fcb40$export$3cf5dda4201cc0f2 = $51fe2e20810fcb40$var$day.range;

});
parcelRegister("kOu3f", function(module, exports) {

$parcel$export(module.exports, "default", () => $f26fc9b6912de968$export$2e2bcd8739ae039);
var $f26fc9b6912de968$var$t0 = new Date, $f26fc9b6912de968$var$t1 = new Date;
function $f26fc9b6912de968$export$2e2bcd8739ae039(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $f26fc9b6912de968$export$2e2bcd8739ae039(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $f26fc9b6912de968$var$t0.setTime(+start), $f26fc9b6912de968$var$t1.setTime(+end);
            floori($f26fc9b6912de968$var$t0), floori($f26fc9b6912de968$var$t1);
            return Math.floor(count($f26fc9b6912de968$var$t0, $f26fc9b6912de968$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("dXf4A", function(module, exports) {

$parcel$export(module.exports, "durationSecond", () => $a28c7a35eadfe1f6$export$79ef0e34099623dc);
$parcel$export(module.exports, "durationMinute", () => $a28c7a35eadfe1f6$export$683905d551c33fa9);
$parcel$export(module.exports, "durationHour", () => $a28c7a35eadfe1f6$export$4157bf0c8e241659);
$parcel$export(module.exports, "durationDay", () => $a28c7a35eadfe1f6$export$353686095f4fbf45);
$parcel$export(module.exports, "durationWeek", () => $a28c7a35eadfe1f6$export$c241eb88520d5016);
var $a28c7a35eadfe1f6$export$79ef0e34099623dc = 1e3;
var $a28c7a35eadfe1f6$export$683905d551c33fa9 = 6e4;
var $a28c7a35eadfe1f6$export$4157bf0c8e241659 = 36e5;
var $a28c7a35eadfe1f6$export$353686095f4fbf45 = 864e5;
var $a28c7a35eadfe1f6$export$c241eb88520d5016 = 6048e5;

});


parcelRegister("aW15j", function(module, exports) {

$parcel$export(module.exports, "sunday", () => $7f6029921eecd017$export$fb3ee18ed410cc21);
$parcel$export(module.exports, "monday", () => $7f6029921eecd017$export$6416afaab03bc9b8);
$parcel$export(module.exports, "thursday", () => $7f6029921eecd017$export$2f2b56683a3e5629);

var $kOu3f = parcelRequire("kOu3f");

var $dXf4A = parcelRequire("dXf4A");
function $7f6029921eecd017$var$weekday(i) {
    return (0, $kOu3f.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $dXf4A.durationMinute)) / (0, $dXf4A.durationWeek);
    });
}
var $7f6029921eecd017$export$fb3ee18ed410cc21 = $7f6029921eecd017$var$weekday(0);
var $7f6029921eecd017$export$6416afaab03bc9b8 = $7f6029921eecd017$var$weekday(1);
var $7f6029921eecd017$export$cb8f040f5d17ac7b = $7f6029921eecd017$var$weekday(2);
var $7f6029921eecd017$export$347581849975dfc8 = $7f6029921eecd017$var$weekday(3);
var $7f6029921eecd017$export$2f2b56683a3e5629 = $7f6029921eecd017$var$weekday(4);
var $7f6029921eecd017$export$59b8c2ccd931d806 = $7f6029921eecd017$var$weekday(5);
var $7f6029921eecd017$export$478ceadebff4d377 = $7f6029921eecd017$var$weekday(6);
var $7f6029921eecd017$export$e8daabaa40641211 = $7f6029921eecd017$export$fb3ee18ed410cc21.range;
var $7f6029921eecd017$export$74e5b559c235c00e = $7f6029921eecd017$export$6416afaab03bc9b8.range;
var $7f6029921eecd017$export$e7d6aa4fb107bc56 = $7f6029921eecd017$export$cb8f040f5d17ac7b.range;
var $7f6029921eecd017$export$fcd5880b20bb06a8 = $7f6029921eecd017$export$347581849975dfc8.range;
var $7f6029921eecd017$export$682716b7bbe33641 = $7f6029921eecd017$export$2f2b56683a3e5629.range;
var $7f6029921eecd017$export$482924968ca86084 = $7f6029921eecd017$export$59b8c2ccd931d806.range;
var $7f6029921eecd017$export$7d755172c9cda9d2 = $7f6029921eecd017$export$478ceadebff4d377.range;

});

parcelRegister("j0Fj9", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd6e0f506bfbbd03$export$2e2bcd8739ae039);

var $kOu3f = parcelRequire("kOu3f");
var $dd6e0f506bfbbd03$var$year = (0, $kOu3f.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$dd6e0f506bfbbd03$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $kOu3f.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $dd6e0f506bfbbd03$export$2e2bcd8739ae039 = $dd6e0f506bfbbd03$var$year;
var $dd6e0f506bfbbd03$export$6fda41c7fb23acf9 = $dd6e0f506bfbbd03$var$year.range;

});

parcelRegister("2CWR6", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e9cc8da96008c84$export$2e2bcd8739ae039);

var $kOu3f = parcelRequire("kOu3f");

var $dXf4A = parcelRequire("dXf4A");
var $1e9cc8da96008c84$var$utcDay = (0, $kOu3f.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, $dXf4A.durationDay);
}, function(date) {
    return date.getUTCDate() - 1;
});
var $1e9cc8da96008c84$export$2e2bcd8739ae039 = $1e9cc8da96008c84$var$utcDay;
var $1e9cc8da96008c84$export$d277e198508549a1 = $1e9cc8da96008c84$var$utcDay.range;

});

parcelRegister("9DXjR", function(module, exports) {

$parcel$export(module.exports, "utcSunday", () => $7055c522f3e8f599$export$4898b06303a92011);
$parcel$export(module.exports, "utcMonday", () => $7055c522f3e8f599$export$9cfc53b9cfafd080);
$parcel$export(module.exports, "utcThursday", () => $7055c522f3e8f599$export$1db08111baec2f53);

var $kOu3f = parcelRequire("kOu3f");

var $dXf4A = parcelRequire("dXf4A");
function $7055c522f3e8f599$var$utcWeekday(i) {
    return (0, $kOu3f.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, $dXf4A.durationWeek);
    });
}
var $7055c522f3e8f599$export$4898b06303a92011 = $7055c522f3e8f599$var$utcWeekday(0);
var $7055c522f3e8f599$export$9cfc53b9cfafd080 = $7055c522f3e8f599$var$utcWeekday(1);
var $7055c522f3e8f599$export$2a6d545f77eceb15 = $7055c522f3e8f599$var$utcWeekday(2);
var $7055c522f3e8f599$export$a5c25d8ed64433c4 = $7055c522f3e8f599$var$utcWeekday(3);
var $7055c522f3e8f599$export$1db08111baec2f53 = $7055c522f3e8f599$var$utcWeekday(4);
var $7055c522f3e8f599$export$29265e34dd5921f7 = $7055c522f3e8f599$var$utcWeekday(5);
var $7055c522f3e8f599$export$85b74dad05049604 = $7055c522f3e8f599$var$utcWeekday(6);
var $7055c522f3e8f599$export$6f3e1c2b0f7d7880 = $7055c522f3e8f599$export$4898b06303a92011.range;
var $7055c522f3e8f599$export$1d2d8b858bb366f9 = $7055c522f3e8f599$export$9cfc53b9cfafd080.range;
var $7055c522f3e8f599$export$1d5f6785fc7f30f8 = $7055c522f3e8f599$export$2a6d545f77eceb15.range;
var $7055c522f3e8f599$export$7a75faf0e37ef4af = $7055c522f3e8f599$export$a5c25d8ed64433c4.range;
var $7055c522f3e8f599$export$417eb959611b2f2f = $7055c522f3e8f599$export$1db08111baec2f53.range;
var $7055c522f3e8f599$export$59d308db7af08c64 = $7055c522f3e8f599$export$29265e34dd5921f7.range;
var $7055c522f3e8f599$export$a124108a0a7f34c8 = $7055c522f3e8f599$export$85b74dad05049604.range;

});

parcelRegister("daOr3", function(module, exports) {

$parcel$export(module.exports, "default", () => $997354f20ca19d0d$export$2e2bcd8739ae039);

var $kOu3f = parcelRequire("kOu3f");
var $997354f20ca19d0d$var$utcYear = (0, $kOu3f.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$997354f20ca19d0d$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $kOu3f.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $997354f20ca19d0d$export$2e2bcd8739ae039 = $997354f20ca19d0d$var$utcYear;
var $997354f20ca19d0d$export$3e24d311e17f5802 = $997354f20ca19d0d$var$utcYear.range;

});



parcelRegister("iZ2is", function(module, exports) {

$parcel$export(module.exports, "event", () => $dd1fb49221ad966f$export$6cd530ed55e06764);
$parcel$export(module.exports, "default", () => $dd1fb49221ad966f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "customEvent", () => $dd1fb49221ad966f$export$4c724631b4750aef);
var $dd1fb49221ad966f$var$filterEvents = {};
var $dd1fb49221ad966f$export$6cd530ed55e06764 = null;
if (typeof document !== "undefined") {
    var $dd1fb49221ad966f$var$element = document.documentElement;
    if (!("onmouseenter" in $dd1fb49221ad966f$var$element)) $dd1fb49221ad966f$var$filterEvents = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    };
}
function $dd1fb49221ad966f$var$filterContextListener(listener, index, group) {
    listener = $dd1fb49221ad966f$var$contextListener(listener, index, group);
    return function(event) {
        var related = event.relatedTarget;
        if (!related || related !== this && !(related.compareDocumentPosition(this) & 8)) listener.call(this, event);
    };
}
function $dd1fb49221ad966f$var$contextListener(listener, index, group) {
    return function(event1) {
        var event0 = $dd1fb49221ad966f$export$6cd530ed55e06764; // Events can be reentrant (e.g., focus).
        $dd1fb49221ad966f$export$6cd530ed55e06764 = event1;
        try {
            listener.call(this, this.__data__, index, group);
        } finally{
            $dd1fb49221ad966f$export$6cd530ed55e06764 = event0;
        }
    };
}
function $dd1fb49221ad966f$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $dd1fb49221ad966f$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.capture);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $dd1fb49221ad966f$var$onAdd(typename, value, capture) {
    var wrap = $dd1fb49221ad966f$var$filterEvents.hasOwnProperty(typename.type) ? $dd1fb49221ad966f$var$filterContextListener : $dd1fb49221ad966f$var$contextListener;
    return function(d, i, group) {
        var on = this.__on, o, listener = wrap(value, i, group);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.capture);
                this.addEventListener(o.type, o.listener = listener, o.capture = capture);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, capture);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            capture: capture
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $dd1fb49221ad966f$export$2e2bcd8739ae039(typename, value, capture) {
    var typenames = $dd1fb49221ad966f$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $dd1fb49221ad966f$var$onAdd : $dd1fb49221ad966f$var$onRemove;
    if (capture == null) capture = false;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, capture));
    return this;
}
function $dd1fb49221ad966f$export$4c724631b4750aef(event1, listener, that, args) {
    var event0 = $dd1fb49221ad966f$export$6cd530ed55e06764;
    event1.sourceEvent = $dd1fb49221ad966f$export$6cd530ed55e06764;
    $dd1fb49221ad966f$export$6cd530ed55e06764 = event1;
    try {
        return listener.apply(that, args);
    } finally{
        $dd1fb49221ad966f$export$6cd530ed55e06764 = event0;
    }
}

});

parcelRegister("iS3vq", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbcffd59364661d7$export$2e2bcd8739ae039);

var $gQNdD = parcelRequire("gQNdD");

var $4tmhl = parcelRequire("4tmhl");
function $dbcffd59364661d7$export$2e2bcd8739ae039(node) {
    var event = (0, $gQNdD.default)();
    if (event.changedTouches) event = event.changedTouches[0];
    return (0, $4tmhl.default)(node, event);
}

});
parcelRegister("gQNdD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c447ae86a8320d39$export$2e2bcd8739ae039);

var $iZ2is = parcelRequire("iZ2is");
function $c447ae86a8320d39$export$2e2bcd8739ae039() {
    var current = (0, $iZ2is.event), source;
    while(source = current.sourceEvent)current = source;
    return current;
}

});

parcelRegister("4tmhl", function(module, exports) {

$parcel$export(module.exports, "default", () => $341b26f2670eba15$export$2e2bcd8739ae039);
function $341b26f2670eba15$export$2e2bcd8739ae039(node, event) {
    var svg = node.ownerSVGElement || node;
    if (svg.createSVGPoint) {
        var point = svg.createSVGPoint();
        point.x = event.clientX, point.y = event.clientY;
        point = point.matrixTransform(node.getScreenCTM().inverse());
        return [
            point.x,
            point.y
        ];
    }
    var rect = node.getBoundingClientRect();
    return [
        event.clientX - rect.left - node.clientLeft,
        event.clientY - rect.top - node.clientTop
    ];
}

});


parcelRegister("7cQXC", function(module, exports) {

$parcel$export(module.exports, "xhtml", () => $53f2bc3e7847f93d$export$201a3f7520ccc326);
$parcel$export(module.exports, "default", () => $53f2bc3e7847f93d$export$2e2bcd8739ae039);
var $53f2bc3e7847f93d$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $53f2bc3e7847f93d$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $53f2bc3e7847f93d$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};

});

parcelRegister("hOxpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf81072cf307ee25$export$2e2bcd8739ae039);

var $3us5W = parcelRequire("3us5W");
function $cf81072cf307ee25$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $3us5W.Selection)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $3us5W.Selection)([
        [
            selector
        ]
    ], (0, $3us5W.root));
}

});
parcelRegister("3us5W", function(module, exports) {

$parcel$export(module.exports, "root", () => $28a9f77d63e1ff25$export$e8e78c978b129247);
$parcel$export(module.exports, "Selection", () => $28a9f77d63e1ff25$export$52baac22726c72bf);
$parcel$export(module.exports, "default", () => $28a9f77d63e1ff25$export$2e2bcd8739ae039);

var $4dcxD = parcelRequire("4dcxD");

var $e48mM = parcelRequire("e48mM");

var $kePFY = parcelRequire("kePFY");

var $hOWaJ = parcelRequire("hOWaJ");

var $5ndv3 = parcelRequire("5ndv3");

var $94na1 = parcelRequire("94na1");

var $b4sDG = parcelRequire("b4sDG");

var $8yR9d = parcelRequire("8yR9d");

var $awsX1 = parcelRequire("awsX1");

var $lxGnS = parcelRequire("lxGnS");

var $lv7c7 = parcelRequire("lv7c7");

var $gJ79D = parcelRequire("gJ79D");

var $hryK9 = parcelRequire("hryK9");

var $c7pKF = parcelRequire("c7pKF");

var $5ouhg = parcelRequire("5ouhg");

var $6neWh = parcelRequire("6neWh");

var $bZhEJ = parcelRequire("bZhEJ");

var $9a8q4 = parcelRequire("9a8q4");

var $3I2BK = parcelRequire("3I2BK");

var $8G4xj = parcelRequire("8G4xj");

var $34eax = parcelRequire("34eax");

var $iju2Z = parcelRequire("iju2Z");

var $h3vbL = parcelRequire("h3vbL");

var $62NTp = parcelRequire("62NTp");

var $03tNP = parcelRequire("03tNP");

var $5WMZy = parcelRequire("5WMZy");

var $ikClj = parcelRequire("ikClj");

var $4odnA = parcelRequire("4odnA");

var $hSH4f = parcelRequire("hSH4f");

var $iZ2is = parcelRequire("iZ2is");

var $3pIv8 = parcelRequire("3pIv8");
var $28a9f77d63e1ff25$export$e8e78c978b129247 = [
    null
];
function $28a9f77d63e1ff25$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $28a9f77d63e1ff25$var$selection() {
    return new $28a9f77d63e1ff25$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $28a9f77d63e1ff25$export$e8e78c978b129247);
}
$28a9f77d63e1ff25$export$52baac22726c72bf.prototype = $28a9f77d63e1ff25$var$selection.prototype = {
    constructor: $28a9f77d63e1ff25$export$52baac22726c72bf,
    select: (0, $4dcxD.default),
    selectAll: (0, $e48mM.default),
    filter: (0, $kePFY.default),
    data: (0, $hOWaJ.default),
    enter: (0, $5ndv3.default),
    exit: (0, $94na1.default),
    join: (0, $b4sDG.default),
    merge: (0, $8yR9d.default),
    order: (0, $awsX1.default),
    sort: (0, $lxGnS.default),
    call: (0, $lv7c7.default),
    nodes: (0, $gJ79D.default),
    node: (0, $hryK9.default),
    size: (0, $c7pKF.default),
    empty: (0, $5ouhg.default),
    each: (0, $6neWh.default),
    attr: (0, $bZhEJ.default),
    style: (0, $9a8q4.default),
    property: (0, $3I2BK.default),
    classed: (0, $8G4xj.default),
    text: (0, $34eax.default),
    html: (0, $iju2Z.default),
    raise: (0, $h3vbL.default),
    lower: (0, $62NTp.default),
    append: (0, $03tNP.default),
    insert: (0, $5WMZy.default),
    remove: (0, $ikClj.default),
    clone: (0, $4odnA.default),
    datum: (0, $hSH4f.default),
    on: (0, $iZ2is.default),
    dispatch: (0, $3pIv8.default)
};
var $28a9f77d63e1ff25$export$2e2bcd8739ae039 = $28a9f77d63e1ff25$var$selection;

});
parcelRegister("4dcxD", function(module, exports) {

$parcel$export(module.exports, "default", () => $31121acbef1e6956$export$2e2bcd8739ae039);

var $3us5W = parcelRequire("3us5W");

var $9rOh8 = parcelRequire("9rOh8");
function $31121acbef1e6956$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $9rOh8.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $3us5W.Selection)(subgroups, this._parents);
}

});
parcelRegister("9rOh8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e0da2549057218e$export$2e2bcd8739ae039);
function $6e0da2549057218e$var$none() {}
function $6e0da2549057218e$export$2e2bcd8739ae039(selector) {
    return selector == null ? $6e0da2549057218e$var$none : function() {
        return this.querySelector(selector);
    };
}

});


parcelRegister("e48mM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3d7edd03ec30cc1$export$2e2bcd8739ae039);

var $3us5W = parcelRequire("3us5W");

var $aMqra = parcelRequire("aMqra");
function $a3d7edd03ec30cc1$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $aMqra.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $3us5W.Selection)(subgroups, parents);
}

});
parcelRegister("aMqra", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d92e4f75dbef49d$export$2e2bcd8739ae039);
function $7d92e4f75dbef49d$var$empty() {
    return [];
}
function $7d92e4f75dbef49d$export$2e2bcd8739ae039(selector) {
    return selector == null ? $7d92e4f75dbef49d$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}

});


parcelRegister("kePFY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebbd333b038c2847$export$2e2bcd8739ae039);

var $3us5W = parcelRequire("3us5W");

var $8doa3 = parcelRequire("8doa3");
function $ebbd333b038c2847$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $8doa3.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $3us5W.Selection)(subgroups, this._parents);
}

});
parcelRegister("8doa3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fb24786d2a5f87a$export$2e2bcd8739ae039);
function $5fb24786d2a5f87a$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}

});


parcelRegister("hOWaJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf943aeeeea8dffb$export$2e2bcd8739ae039);

var $3us5W = parcelRequire("3us5W");

var $5ndv3 = parcelRequire("5ndv3");

var $iCdMC = parcelRequire("iCdMC");
var $cf943aeeeea8dffb$var$keyPrefix = "$"; // Protect against keys like “__proto__”.
function $cf943aeeeea8dffb$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $5ndv3.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $cf943aeeeea8dffb$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = {}, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = $cf943aeeeea8dffb$var$keyPrefix + key.call(node, node.__data__, i, group);
        if (keyValue in nodeByKeyValue) exit[i] = node;
        else nodeByKeyValue[keyValue] = node;
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = $cf943aeeeea8dffb$var$keyPrefix + key.call(parent, data[i], i, data);
        if (node = nodeByKeyValue[keyValue]) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue[keyValue] = null;
        } else enter[i] = new (0, $5ndv3.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue[keyValues[i]] === node) exit[i] = node;
}
function $cf943aeeeea8dffb$export$2e2bcd8739ae039(value, key) {
    if (!value) {
        data = new Array(this.size()), j = -1;
        this.each(function(d) {
            data[++j] = d;
        });
        return data;
    }
    var bind = key ? $cf943aeeeea8dffb$var$bindKey : $cf943aeeeea8dffb$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $iCdMC.default)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = value.call(parent, parent && parent.__data__, j, parents), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $3us5W.Selection)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}

});
parcelRegister("5ndv3", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e99928b06782938$export$2e2bcd8739ae039);
$parcel$export(module.exports, "EnterNode", () => $3e99928b06782938$export$67b01759a14cf6a4);

var $jUPKb = parcelRequire("jUPKb");

var $3us5W = parcelRequire("3us5W");
function $3e99928b06782938$export$2e2bcd8739ae039() {
    return new (0, $3us5W.Selection)(this._enter || this._groups.map((0, $jUPKb.default)), this._parents);
}
function $3e99928b06782938$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$3e99928b06782938$export$67b01759a14cf6a4.prototype = {
    constructor: $3e99928b06782938$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};

});
parcelRegister("jUPKb", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7fb628d3a97a780$export$2e2bcd8739ae039);
function $e7fb628d3a97a780$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}

});


parcelRegister("iCdMC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8d677a8510c2e55$export$2e2bcd8739ae039);
function $d8d677a8510c2e55$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});


parcelRegister("94na1", function(module, exports) {

$parcel$export(module.exports, "default", () => $69a673ff94b874e4$export$2e2bcd8739ae039);

var $jUPKb = parcelRequire("jUPKb");

var $3us5W = parcelRequire("3us5W");
function $69a673ff94b874e4$export$2e2bcd8739ae039() {
    return new (0, $3us5W.Selection)(this._exit || this._groups.map((0, $jUPKb.default)), this._parents);
}

});

parcelRegister("b4sDG", function(module, exports) {

$parcel$export(module.exports, "default", () => $80f6488751784891$export$2e2bcd8739ae039);
function $80f6488751784891$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
    if (onupdate != null) update = onupdate(update);
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}

});

parcelRegister("8yR9d", function(module, exports) {

$parcel$export(module.exports, "default", () => $63bab9b342eb32db$export$2e2bcd8739ae039);

var $3us5W = parcelRequire("3us5W");
function $63bab9b342eb32db$export$2e2bcd8739ae039(selection) {
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $3us5W.Selection)(merges, this._parents);
}

});

parcelRegister("awsX1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a935994b7a1f6cf$export$2e2bcd8739ae039);
function $7a935994b7a1f6cf$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}

});

parcelRegister("lxGnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $faed8eab1469f61d$export$2e2bcd8739ae039);

var $3us5W = parcelRequire("3us5W");
function $faed8eab1469f61d$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $faed8eab1469f61d$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $3us5W.Selection)(sortgroups, this._parents).order();
}
function $faed8eab1469f61d$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("lv7c7", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa7212ea177e0f60$export$2e2bcd8739ae039);
function $fa7212ea177e0f60$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}

});

parcelRegister("gJ79D", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2d66609f799a53b$export$2e2bcd8739ae039);
function $c2d66609f799a53b$export$2e2bcd8739ae039() {
    var nodes = new Array(this.size()), i = -1;
    this.each(function() {
        nodes[++i] = this;
    });
    return nodes;
}

});

parcelRegister("hryK9", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb2fe8996a284614$export$2e2bcd8739ae039);
function $cb2fe8996a284614$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}

});

parcelRegister("c7pKF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d2a1d37edc5fc51$export$2e2bcd8739ae039);
function $8d2a1d37edc5fc51$export$2e2bcd8739ae039() {
    var size = 0;
    this.each(function() {
        ++size;
    });
    return size;
}

});

parcelRegister("5ouhg", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ed6ae19ad0a17a6$export$2e2bcd8739ae039);
function $3ed6ae19ad0a17a6$export$2e2bcd8739ae039() {
    return !this.node();
}

});

parcelRegister("6neWh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a407aa055eb21e9$export$2e2bcd8739ae039);
function $4a407aa055eb21e9$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}

});

parcelRegister("bZhEJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ba31651ad7591ba$export$2e2bcd8739ae039);

var $fEEcv = parcelRequire("fEEcv");
function $8ba31651ad7591ba$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $8ba31651ad7591ba$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $8ba31651ad7591ba$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $8ba31651ad7591ba$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $8ba31651ad7591ba$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $8ba31651ad7591ba$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $8ba31651ad7591ba$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $fEEcv.default)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $8ba31651ad7591ba$var$attrRemoveNS : $8ba31651ad7591ba$var$attrRemove : typeof value === "function" ? fullname.local ? $8ba31651ad7591ba$var$attrFunctionNS : $8ba31651ad7591ba$var$attrFunction : fullname.local ? $8ba31651ad7591ba$var$attrConstantNS : $8ba31651ad7591ba$var$attrConstant)(fullname, value));
}

});
parcelRegister("fEEcv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b659c67af9335162$export$2e2bcd8739ae039);

var $7cQXC = parcelRequire("7cQXC");
function $b659c67af9335162$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $7cQXC.default).hasOwnProperty(prefix) ? {
        space: (0, $7cQXC.default)[prefix],
        local: name
    } : name;
}

});


parcelRegister("9a8q4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6abb942964e997ae$export$2e2bcd8739ae039);
$parcel$export(module.exports, "styleValue", () => $6abb942964e997ae$export$5e3cec964f0b5efd);

var $bQhLV = parcelRequire("bQhLV");
function $6abb942964e997ae$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $6abb942964e997ae$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $6abb942964e997ae$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $6abb942964e997ae$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $6abb942964e997ae$var$styleRemove : typeof value === "function" ? $6abb942964e997ae$var$styleFunction : $6abb942964e997ae$var$styleConstant)(name, value, priority == null ? "" : priority)) : $6abb942964e997ae$export$5e3cec964f0b5efd(this.node(), name);
}
function $6abb942964e997ae$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $bQhLV.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}

});
parcelRegister("bQhLV", function(module, exports) {

$parcel$export(module.exports, "default", () => $89f2562a5a0d5a13$export$2e2bcd8739ae039);
function $89f2562a5a0d5a13$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}

});


parcelRegister("3I2BK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b37810bbc11c28b$export$2e2bcd8739ae039);
function $2b37810bbc11c28b$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $2b37810bbc11c28b$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $2b37810bbc11c28b$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $2b37810bbc11c28b$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $2b37810bbc11c28b$var$propertyRemove : typeof value === "function" ? $2b37810bbc11c28b$var$propertyFunction : $2b37810bbc11c28b$var$propertyConstant)(name, value)) : this.node()[name];
}

});

parcelRegister("8G4xj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6515c3ccac9efd7a$export$2e2bcd8739ae039);
function $6515c3ccac9efd7a$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $6515c3ccac9efd7a$var$classList(node) {
    return node.classList || new $6515c3ccac9efd7a$var$ClassList(node);
}
function $6515c3ccac9efd7a$var$ClassList(node) {
    this._node = node;
    this._names = $6515c3ccac9efd7a$var$classArray(node.getAttribute("class") || "");
}
$6515c3ccac9efd7a$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $6515c3ccac9efd7a$var$classedAdd(node, names) {
    var list = $6515c3ccac9efd7a$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $6515c3ccac9efd7a$var$classedRemove(node, names) {
    var list = $6515c3ccac9efd7a$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $6515c3ccac9efd7a$var$classedTrue(names) {
    return function() {
        $6515c3ccac9efd7a$var$classedAdd(this, names);
    };
}
function $6515c3ccac9efd7a$var$classedFalse(names) {
    return function() {
        $6515c3ccac9efd7a$var$classedRemove(this, names);
    };
}
function $6515c3ccac9efd7a$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $6515c3ccac9efd7a$var$classedAdd : $6515c3ccac9efd7a$var$classedRemove)(this, names);
    };
}
function $6515c3ccac9efd7a$export$2e2bcd8739ae039(name, value) {
    var names = $6515c3ccac9efd7a$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $6515c3ccac9efd7a$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $6515c3ccac9efd7a$var$classedFunction : value ? $6515c3ccac9efd7a$var$classedTrue : $6515c3ccac9efd7a$var$classedFalse)(names, value));
}

});

parcelRegister("34eax", function(module, exports) {

$parcel$export(module.exports, "default", () => $23bcbc7d81179ba9$export$2e2bcd8739ae039);
function $23bcbc7d81179ba9$var$textRemove() {
    this.textContent = "";
}
function $23bcbc7d81179ba9$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $23bcbc7d81179ba9$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $23bcbc7d81179ba9$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $23bcbc7d81179ba9$var$textRemove : (typeof value === "function" ? $23bcbc7d81179ba9$var$textFunction : $23bcbc7d81179ba9$var$textConstant)(value)) : this.node().textContent;
}

});

parcelRegister("iju2Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5514f1406649954$export$2e2bcd8739ae039);
function $d5514f1406649954$var$htmlRemove() {
    this.innerHTML = "";
}
function $d5514f1406649954$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $d5514f1406649954$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $d5514f1406649954$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $d5514f1406649954$var$htmlRemove : (typeof value === "function" ? $d5514f1406649954$var$htmlFunction : $d5514f1406649954$var$htmlConstant)(value)) : this.node().innerHTML;
}

});

parcelRegister("h3vbL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6aae8ef09c3d03d$export$2e2bcd8739ae039);
function $c6aae8ef09c3d03d$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $c6aae8ef09c3d03d$export$2e2bcd8739ae039() {
    return this.each($c6aae8ef09c3d03d$var$raise);
}

});

parcelRegister("62NTp", function(module, exports) {

$parcel$export(module.exports, "default", () => $4669a19c71181bd1$export$2e2bcd8739ae039);
function $4669a19c71181bd1$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $4669a19c71181bd1$export$2e2bcd8739ae039() {
    return this.each($4669a19c71181bd1$var$lower);
}

});

parcelRegister("03tNP", function(module, exports) {

$parcel$export(module.exports, "default", () => $00a766249763e814$export$2e2bcd8739ae039);

var $bkOxa = parcelRequire("bkOxa");
function $00a766249763e814$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $bkOxa.default)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}

});
parcelRegister("bkOxa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8408c2f95f59818f$export$2e2bcd8739ae039);

var $fEEcv = parcelRequire("fEEcv");

var $7cQXC = parcelRequire("7cQXC");
function $8408c2f95f59818f$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $7cQXC.xhtml) && document.documentElement.namespaceURI === (0, $7cQXC.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $8408c2f95f59818f$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $8408c2f95f59818f$export$2e2bcd8739ae039(name) {
    var fullname = (0, $fEEcv.default)(name);
    return (fullname.local ? $8408c2f95f59818f$var$creatorFixed : $8408c2f95f59818f$var$creatorInherit)(fullname);
}

});


parcelRegister("5WMZy", function(module, exports) {

$parcel$export(module.exports, "default", () => $45485f4f27d149f8$export$2e2bcd8739ae039);

var $bkOxa = parcelRequire("bkOxa");

var $9rOh8 = parcelRequire("9rOh8");
function $45485f4f27d149f8$var$constantNull() {
    return null;
}
function $45485f4f27d149f8$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $bkOxa.default)(name), select = before == null ? $45485f4f27d149f8$var$constantNull : typeof before === "function" ? before : (0, $9rOh8.default)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}

});

parcelRegister("ikClj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d587d6535138580c$export$2e2bcd8739ae039);
function $d587d6535138580c$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $d587d6535138580c$export$2e2bcd8739ae039() {
    return this.each($d587d6535138580c$var$remove);
}

});

parcelRegister("4odnA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3323c835dc2d74de$export$2e2bcd8739ae039);
function $3323c835dc2d74de$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $3323c835dc2d74de$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $3323c835dc2d74de$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $3323c835dc2d74de$var$selection_cloneDeep : $3323c835dc2d74de$var$selection_cloneShallow);
}

});

parcelRegister("hSH4f", function(module, exports) {

$parcel$export(module.exports, "default", () => $d048e3258aa4fe8e$export$2e2bcd8739ae039);
function $d048e3258aa4fe8e$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}

});

parcelRegister("3pIv8", function(module, exports) {

$parcel$export(module.exports, "default", () => $27c639e461d8a390$export$2e2bcd8739ae039);

var $bQhLV = parcelRequire("bQhLV");
function $27c639e461d8a390$var$dispatchEvent(node, type, params) {
    var window = (0, $bQhLV.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $27c639e461d8a390$var$dispatchConstant(type, params) {
    return function() {
        return $27c639e461d8a390$var$dispatchEvent(this, type, params);
    };
}
function $27c639e461d8a390$var$dispatchFunction(type, params) {
    return function() {
        return $27c639e461d8a390$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $27c639e461d8a390$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $27c639e461d8a390$var$dispatchFunction : $27c639e461d8a390$var$dispatchConstant)(type, params));
}

});



parcelRegister("jJCd9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5dfdc386da08eff$export$2e2bcd8739ae039);

var $3us5W = parcelRequire("3us5W");
function $e5dfdc386da08eff$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $3us5W.Selection)([
        document.querySelectorAll(selector)
    ], [
        document.documentElement
    ]) : new (0, $3us5W.Selection)([
        selector == null ? [] : selector
    ], (0, $3us5W.root));
}

});

parcelRegister("im8sd", function(module, exports) {

$parcel$export(module.exports, "brushX", () => (parcelRequire("7Wzrn")).brushX);
$parcel$export(module.exports, "brushY", () => (parcelRequire("7Wzrn")).brushY);
$parcel$export(module.exports, "brushSelection", () => (parcelRequire("7Wzrn")).brushSelection);

var $7Wzrn = parcelRequire("7Wzrn");

});
parcelRegister("7Wzrn", function(module, exports) {

$parcel$export(module.exports, "brushSelection", () => $5c8970f4694d4107$export$69760394fc76f689);
$parcel$export(module.exports, "brushX", () => $5c8970f4694d4107$export$979ace6c88860aa8);
$parcel$export(module.exports, "brushY", () => $5c8970f4694d4107$export$468748b530991c54);

var $aFEgl = parcelRequire("aFEgl");

var $cohyw = parcelRequire("cohyw");

var $bi4KR = parcelRequire("bi4KR");

var $iZ2is = parcelRequire("iZ2is");
var $iS3vq = parcelRequire("iS3vq");
var $hOxpW = parcelRequire("hOxpW");
var $5IKYT = parcelRequire("5IKYT");
parcelRequire("dxJVY");
var $f8M3T = parcelRequire("f8M3T");

var $6QApF = parcelRequire("6QApF");

var $j3W5K = parcelRequire("j3W5K");

var $6fYbl = parcelRequire("6fYbl");
var $5c8970f4694d4107$var$MODE_DRAG = {
    name: "drag"
}, $5c8970f4694d4107$var$MODE_SPACE = {
    name: "space"
}, $5c8970f4694d4107$var$MODE_HANDLE = {
    name: "handle"
}, $5c8970f4694d4107$var$MODE_CENTER = {
    name: "center"
};
function $5c8970f4694d4107$var$number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function $5c8970f4694d4107$var$number2(e) {
    return [
        $5c8970f4694d4107$var$number1(e[0]),
        $5c8970f4694d4107$var$number1(e[1])
    ];
}
function $5c8970f4694d4107$var$toucher(identifier) {
    return function(target) {
        return (0, $5IKYT.default)(target, (0, $iZ2is.event).touches, identifier);
    };
}
var $5c8970f4694d4107$var$X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map($5c8970f4694d4107$var$type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $5c8970f4694d4107$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($5c8970f4694d4107$var$type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $5c8970f4694d4107$var$XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map($5c8970f4694d4107$var$type),
    input: function(xy) {
        return xy == null ? null : $5c8970f4694d4107$var$number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var $5c8970f4694d4107$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $5c8970f4694d4107$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $5c8970f4694d4107$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $5c8970f4694d4107$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $5c8970f4694d4107$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $5c8970f4694d4107$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $5c8970f4694d4107$var$defaultFilter() {
    return !(0, $iZ2is.event).ctrlKey && !(0, $iZ2is.event).button;
}
function $5c8970f4694d4107$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function $5c8970f4694d4107$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $5c8970f4694d4107$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $5c8970f4694d4107$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $5c8970f4694d4107$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $5c8970f4694d4107$export$979ace6c88860aa8() {
    return $5c8970f4694d4107$var$brush($5c8970f4694d4107$var$X);
}
function $5c8970f4694d4107$export$468748b530991c54() {
    return $5c8970f4694d4107$var$brush($5c8970f4694d4107$var$Y);
}
function $5c8970f4694d4107$export$2e2bcd8739ae039() {
    return $5c8970f4694d4107$var$brush($5c8970f4694d4107$var$XY);
}
function $5c8970f4694d4107$var$brush(dim) {
    var extent = $5c8970f4694d4107$var$defaultExtent, filter = $5c8970f4694d4107$var$defaultFilter, touchable = $5c8970f4694d4107$var$defaultTouchable, keys = true, listeners = (0, $aFEgl.default)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $5c8970f4694d4107$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $5c8970f4694d4107$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $5c8970f4694d4107$var$local(this).extent;
            (0, $hOxpW.default)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $5c8970f4694d4107$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $5c8970f4694d4107$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $5c8970f4694d4107$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection) {
        if (group.selection) group.on("start.brush", function() {
            emitter(this, arguments).beforestart().start();
        }).on("interrupt.brush end.brush", function() {
            emitter(this, arguments).end();
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $bi4KR.default)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $f8M3T.default)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
        });
    };
    brush.clear = function(group) {
        brush.move(group, null);
    };
    function redraw() {
        var group = (0, $hOxpW.default)(this), selection = $5c8970f4694d4107$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function() {
            if (this.starting) this.starting = false, this.emit("start");
            else this.emit("brush");
            return this;
        },
        brush: function() {
            this.emit("brush");
            return this;
        },
        end: function() {
            if (--this.active === 0) delete this.state.emitter, this.emit("end");
            return this;
        },
        emit: function(type) {
            (0, $iZ2is.customEvent)(new (0, $j3W5K.default)(brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [
                type,
                this.that,
                this.args
            ]);
        }
    };
    function started() {
        if (touchending && !(0, $iZ2is.event).touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = (0, $iZ2is.event).target.__data__.type, mode = (keys && (0, $iZ2is.event).metaKey ? type = "overlay" : type) === "selection" ? $5c8970f4694d4107$var$MODE_DRAG : keys && (0, $iZ2is.event).altKey ? $5c8970f4694d4107$var$MODE_CENTER : $5c8970f4694d4107$var$MODE_HANDLE, signX = dim === $5c8970f4694d4107$var$Y ? null : $5c8970f4694d4107$var$signsX[type], signY = dim === $5c8970f4694d4107$var$X ? null : $5c8970f4694d4107$var$signsY[type], state = $5c8970f4694d4107$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && (0, $iZ2is.event).shiftKey, lockX, lockY, pointer = (0, $iZ2is.event).touches ? $5c8970f4694d4107$var$toucher((0, $iZ2is.event).changedTouches[0].identifier) : (0, $iS3vq.default), point0 = pointer(that), point = point0, emit = emitter(that, arguments, true).beforestart();
        if (type === "overlay") {
            if (selection) moving = true;
            state.selection = selection = [
                [
                    w0 = dim === $5c8970f4694d4107$var$Y ? W : point0[0],
                    n0 = dim === $5c8970f4694d4107$var$X ? N : point0[1]
                ],
                [
                    e0 = dim === $5c8970f4694d4107$var$Y ? E : w0,
                    s0 = dim === $5c8970f4694d4107$var$X ? S : n0
                ]
            ];
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $hOxpW.default)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $5c8970f4694d4107$var$cursors[type]);
        if ((0, $iZ2is.event).touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, $hOxpW.default)((0, $iZ2is.event).view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, $cohyw.default)((0, $iZ2is.event).view);
        }
        (0, $6fYbl.nopropagation)();
        (0, $f8M3T.default)(that);
        redraw.call(that);
        emit.start();
        function moved() {
            var point1 = pointer(that);
            if (shifting && !lockX && !lockY) {
                if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
                else lockX = true;
            }
            point = point1;
            moving = true;
            (0, $6fYbl.default)();
            move();
        }
        function move() {
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $5c8970f4694d4107$var$MODE_SPACE:
                case $5c8970f4694d4107$var$MODE_DRAG:
                    if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $5c8970f4694d4107$var$MODE_HANDLE:
                    if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                    else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                    if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                    else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    break;
                case $5c8970f4694d4107$var$MODE_CENTER:
                    if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
                    if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $5c8970f4694d4107$var$flipX) overlay.attr("cursor", $5c8970f4694d4107$var$cursors[type = $5c8970f4694d4107$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $5c8970f4694d4107$var$flipY) overlay.attr("cursor", $5c8970f4694d4107$var$cursors[type = $5c8970f4694d4107$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush();
            }
        }
        function ended() {
            (0, $6fYbl.nopropagation)();
            if ((0, $iZ2is.event).touches) {
                if ((0, $iZ2is.event).touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, $cohyw.yesdrag)((0, $iZ2is.event).view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $5c8970f4694d4107$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($5c8970f4694d4107$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end();
        }
        function keydowned() {
            switch((0, $iZ2is.event).keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $5c8970f4694d4107$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $5c8970f4694d4107$var$MODE_CENTER;
                        move();
                    }
                    break;
                case 32:
                    if (mode === $5c8970f4694d4107$var$MODE_HANDLE || mode === $5c8970f4694d4107$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $5c8970f4694d4107$var$MODE_SPACE;
                        overlay.attr("cursor", $5c8970f4694d4107$var$cursors.selection);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, $6fYbl.default)();
        }
        function keyupped() {
            switch((0, $iZ2is.event).keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move();
                    }
                    break;
                case 18:
                    if (mode === $5c8970f4694d4107$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $5c8970f4694d4107$var$MODE_HANDLE;
                        move();
                    }
                    break;
                case 32:
                    if (mode === $5c8970f4694d4107$var$MODE_SPACE) {
                        if ((0, $iZ2is.event).altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $5c8970f4694d4107$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $5c8970f4694d4107$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $5c8970f4694d4107$var$cursors[type]);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, $6fYbl.default)();
        }
    }
    function touchmoved() {
        emitter(this, arguments).moved();
    }
    function touchended() {
        emitter(this, arguments).ended();
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = $5c8970f4694d4107$var$number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $6QApF.default)($5c8970f4694d4107$var$number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $6QApF.default)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $6QApF.default)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}

});
parcelRegister("aFEgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c4cf709d1826294$export$2e2bcd8739ae039);
var $7c4cf709d1826294$var$noop = {
    value: function() {}
};
function $7c4cf709d1826294$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $7c4cf709d1826294$var$Dispatch(_);
}
function $7c4cf709d1826294$var$Dispatch(_) {
    this._ = _;
}
function $7c4cf709d1826294$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$7c4cf709d1826294$var$Dispatch.prototype = $7c4cf709d1826294$var$dispatch.prototype = {
    constructor: $7c4cf709d1826294$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $7c4cf709d1826294$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $7c4cf709d1826294$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $7c4cf709d1826294$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $7c4cf709d1826294$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $7c4cf709d1826294$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $7c4cf709d1826294$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $7c4cf709d1826294$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $7c4cf709d1826294$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $7c4cf709d1826294$export$2e2bcd8739ae039 = $7c4cf709d1826294$var$dispatch;

});

parcelRegister("cohyw", function(module, exports) {

$parcel$export(module.exports, "default", () => $905558291b0c219c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "yesdrag", () => $905558291b0c219c$export$833237748009e1e1);

var $hOxpW = parcelRequire("hOxpW");

var $cttdm = parcelRequire("cttdm");
function $905558291b0c219c$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $hOxpW.default)(view).on("dragstart.drag", (0, $cttdm.default), true);
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $cttdm.default), true);
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $905558291b0c219c$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $hOxpW.default)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $cttdm.default), true);
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}

});
parcelRegister("cttdm", function(module, exports) {

$parcel$export(module.exports, "nopropagation", () => $914edae09cbfb4c0$export$2e2561858db9bf47);
$parcel$export(module.exports, "default", () => $914edae09cbfb4c0$export$2e2bcd8739ae039);

var $iZ2is = parcelRequire("iZ2is");
function $914edae09cbfb4c0$export$2e2561858db9bf47() {
    (0, $iZ2is.event).stopImmediatePropagation();
}
function $914edae09cbfb4c0$export$2e2bcd8739ae039() {
    (0, $iZ2is.event).preventDefault();
    (0, $iZ2is.event).stopImmediatePropagation();
}

});


parcelRegister("bi4KR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8385105b4986daed$export$2e2bcd8739ae039);

var $bYoiY = parcelRequire("bYoiY");

var $jUrtA = parcelRequire("jUrtA");

var $34d8K = parcelRequire("34d8K");

var $xcrgO = parcelRequire("xcrgO");

var $gnkFs = parcelRequire("gnkFs");

var $hNADL = parcelRequire("hNADL");

var $aPLyh = parcelRequire("aPLyh");

var $amdqR = parcelRequire("amdqR");

var $aE1fz = parcelRequire("aE1fz");
function $8385105b4986daed$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $amdqR.default)(b) : (t === "number" ? (0, $gnkFs.default) : t === "string" ? (c = (0, $bYoiY.default)(b)) ? (b = c, $jUrtA.default) : (0, $aPLyh.default) : b instanceof (0, $bYoiY.default) ? (0, $jUrtA.default) : b instanceof Date ? (0, $xcrgO.default) : (0, $aE1fz.isNumberArray)(b) ? (0, $aE1fz.default) : Array.isArray(b) ? (0, $34d8K.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $hNADL.default) : (0, $gnkFs.default))(a, b);
}

});
parcelRegister("bYoiY", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $bfWFq = parcelRequire("bfWFq");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $bfWFq.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $bfWFq.default)(Rgb, rgb, (0, $bfWFq.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $bfWFq.default)(Hsl, hsl, (0, $bfWFq.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("bfWFq", function(module, exports) {

$parcel$export(module.exports, "default", () => $831e9a7deaab9d1d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $831e9a7deaab9d1d$export$8b58be045bf06082);
function $831e9a7deaab9d1d$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $831e9a7deaab9d1d$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("jUrtA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7e88f7f6ed95eef$export$2e2bcd8739ae039);

var $bYoiY = parcelRequire("bYoiY");

var $j0bQ2 = parcelRequire("j0bQ2");

var $8XYWK = parcelRequire("8XYWK");

var $75Lq4 = parcelRequire("75Lq4");
var $e7e88f7f6ed95eef$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $75Lq4.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $bYoiY.rgb)(start)).r, (end = (0, $bYoiY.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $75Lq4.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $e7e88f7f6ed95eef$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $bYoiY.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $e7e88f7f6ed95eef$export$2c0e28f2e2852d3f = $e7e88f7f6ed95eef$var$rgbSpline((0, $j0bQ2.default));
var $e7e88f7f6ed95eef$export$53d5214f625ccd4c = $e7e88f7f6ed95eef$var$rgbSpline((0, $8XYWK.default));

});
parcelRegister("j0bQ2", function(module, exports) {

$parcel$export(module.exports, "basis", () => $dd5733431a2d0880$export$4e41033bfeec1a4c);
$parcel$export(module.exports, "default", () => $dd5733431a2d0880$export$2e2bcd8739ae039);
function $dd5733431a2d0880$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $dd5733431a2d0880$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $dd5733431a2d0880$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("8XYWK", function(module, exports) {

$parcel$export(module.exports, "default", () => $68731c1c421d9916$export$2e2bcd8739ae039);

var $j0bQ2 = parcelRequire("j0bQ2");
function $68731c1c421d9916$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $j0bQ2.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("75Lq4", function(module, exports) {

$parcel$export(module.exports, "gamma", () => $529dc8928f6a4077$export$a7ebe8cc6aaf8d37);
$parcel$export(module.exports, "default", () => $529dc8928f6a4077$export$2e2bcd8739ae039);

var $amdqR = parcelRequire("amdqR");
function $529dc8928f6a4077$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $529dc8928f6a4077$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $529dc8928f6a4077$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $529dc8928f6a4077$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $amdqR.default)(isNaN(a) ? b : a);
}
function $529dc8928f6a4077$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $529dc8928f6a4077$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $529dc8928f6a4077$var$exponential(a, b, y) : (0, $amdqR.default)(isNaN(a) ? b : a);
    };
}
function $529dc8928f6a4077$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $529dc8928f6a4077$var$linear(a, d) : (0, $amdqR.default)(isNaN(a) ? b : a);
}

});
parcelRegister("amdqR", function(module, exports) {

$parcel$export(module.exports, "default", () => $78a660cd70c52f6f$export$2e2bcd8739ae039);
function $78a660cd70c52f6f$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});



parcelRegister("34d8K", function(module, exports) {

$parcel$export(module.exports, "genericArray", () => $23bbf03008765dcc$export$15d09067c6a5ee49);

var $bi4KR = parcelRequire("bi4KR");

var $aE1fz = parcelRequire("aE1fz");
function $23bbf03008765dcc$export$2e2bcd8739ae039(a, b) {
    return ((0, $aE1fz.isNumberArray)(b) ? (0, $aE1fz.default) : $23bbf03008765dcc$export$15d09067c6a5ee49)(a, b);
}
function $23bbf03008765dcc$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $bi4KR.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("aE1fz", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bfe9c15ff8ebf5c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isNumberArray", () => $7bfe9c15ff8ebf5c$export$5cd576d1827d40c8);
function $7bfe9c15ff8ebf5c$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $7bfe9c15ff8ebf5c$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("xcrgO", function(module, exports) {

$parcel$export(module.exports, "default", () => $063cbb46f86ba478$export$2e2bcd8739ae039);
function $063cbb46f86ba478$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("gnkFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $bebed377ddb9d3af$export$2e2bcd8739ae039);
function $bebed377ddb9d3af$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("hNADL", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf536f4647e343d9$export$2e2bcd8739ae039);

var $bi4KR = parcelRequire("bi4KR");
function $cf536f4647e343d9$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $bi4KR.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("aPLyh", function(module, exports) {

$parcel$export(module.exports, "default", () => $020916edd93bff72$export$2e2bcd8739ae039);

var $gnkFs = parcelRequire("gnkFs");
var $020916edd93bff72$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $020916edd93bff72$var$reB = new RegExp($020916edd93bff72$var$reA.source, "g");
function $020916edd93bff72$var$zero(b) {
    return function() {
        return b;
    };
}
function $020916edd93bff72$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $020916edd93bff72$export$2e2bcd8739ae039(a, b) {
    var bi = $020916edd93bff72$var$reA.lastIndex = $020916edd93bff72$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $020916edd93bff72$var$reA.exec(a)) && (bm = $020916edd93bff72$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $gnkFs.default)(am, bm)
            });
        }
        bi = $020916edd93bff72$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $020916edd93bff72$var$one(q[0].x) : $020916edd93bff72$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("5IKYT", function(module, exports) {

$parcel$export(module.exports, "default", () => $42a581473eb076b1$export$2e2bcd8739ae039);

var $gQNdD = parcelRequire("gQNdD");

var $4tmhl = parcelRequire("4tmhl");
function $42a581473eb076b1$export$2e2bcd8739ae039(node, touches, identifier) {
    if (arguments.length < 3) identifier = touches, touches = (0, $gQNdD.default)().changedTouches;
    for(var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i){
        if ((touch = touches[i]).identifier === identifier) return (0, $4tmhl.default)(node, touch);
    }
    return null;
}

});

parcelRegister("dxJVY", function(module, exports) {

$parcel$export(module.exports, "transition", () => (parcelRequire("e9pyf")).default);
$parcel$export(module.exports, "interrupt", () => (parcelRequire("f8M3T")).default);
parcelRequire("2k9Hs");

var $e9pyf = parcelRequire("e9pyf");

var $e4waW = parcelRequire("e4waW");

var $f8M3T = parcelRequire("f8M3T");

});
parcelRegister("2k9Hs", function(module, exports) {

var $3us5W = parcelRequire("3us5W");

var $gDVVi = parcelRequire("gDVVi");

var $fBcKd = parcelRequire("fBcKd");
(0, $3us5W.default).prototype.interrupt = (0, $gDVVi.default);
(0, $3us5W.default).prototype.transition = (0, $fBcKd.default);

});
parcelRegister("gDVVi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1dd383074e2630e$export$2e2bcd8739ae039);

var $f8M3T = parcelRequire("f8M3T");
function $c1dd383074e2630e$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $f8M3T.default)(this, name);
    });
}

});
parcelRegister("f8M3T", function(module, exports) {

$parcel$export(module.exports, "default", () => $b05ce272ee11a654$export$2e2bcd8739ae039);

var $1O1wu = parcelRequire("1O1wu");
function $b05ce272ee11a654$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $1O1wu.STARTING) && schedule.state < (0, $1O1wu.ENDING);
        schedule.state = (0, $1O1wu.ENDED);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}

});
parcelRegister("1O1wu", function(module, exports) {

$parcel$export(module.exports, "SCHEDULED", () => $150ba4634a330696$export$584530fe98d14a84);
$parcel$export(module.exports, "STARTING", () => $150ba4634a330696$export$a5d151aee16efd42);
$parcel$export(module.exports, "ENDING", () => $150ba4634a330696$export$a2e792214ded83b2);
$parcel$export(module.exports, "ENDED", () => $150ba4634a330696$export$9d38167254403955);
$parcel$export(module.exports, "default", () => $150ba4634a330696$export$2e2bcd8739ae039);
$parcel$export(module.exports, "init", () => $150ba4634a330696$export$2cd8252107eb640b);
$parcel$export(module.exports, "get", () => $150ba4634a330696$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $150ba4634a330696$export$adaa4cf7ef1b65be);

var $aFEgl = parcelRequire("aFEgl");

var $hYquC = parcelRequire("hYquC");
var $jSjsP = parcelRequire("jSjsP");
var $150ba4634a330696$var$emptyOn = (0, $aFEgl.default)("start", "end", "cancel", "interrupt");
var $150ba4634a330696$var$emptyTween = [];
var $150ba4634a330696$export$ff39ebd4bb12b718 = 0;
var $150ba4634a330696$export$584530fe98d14a84 = 1;
var $150ba4634a330696$export$a5d151aee16efd42 = 2;
var $150ba4634a330696$export$fb935ab5849a0db9 = 3;
var $150ba4634a330696$export$1573e22b087389af = 4;
var $150ba4634a330696$export$a2e792214ded83b2 = 5;
var $150ba4634a330696$export$9d38167254403955 = 6;
function $150ba4634a330696$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $150ba4634a330696$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $150ba4634a330696$var$emptyOn,
        tween: $150ba4634a330696$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $150ba4634a330696$export$ff39ebd4bb12b718
    });
}
function $150ba4634a330696$export$2cd8252107eb640b(node, id) {
    var schedule = $150ba4634a330696$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $150ba4634a330696$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $150ba4634a330696$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $150ba4634a330696$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $150ba4634a330696$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $150ba4634a330696$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $150ba4634a330696$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $jSjsP.timer)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $150ba4634a330696$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $150ba4634a330696$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $150ba4634a330696$export$fb935ab5849a0db9) return (0, $hYquC.default)(start);
            // Interrupt the active transition, if any.
            if (o.state === $150ba4634a330696$export$1573e22b087389af) {
                o.state = $150ba4634a330696$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $150ba4634a330696$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $hYquC.default)(function() {
            if (self.state === $150ba4634a330696$export$fb935ab5849a0db9) {
                self.state = $150ba4634a330696$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $150ba4634a330696$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $150ba4634a330696$export$a5d151aee16efd42) return; // interrupted
        self.state = $150ba4634a330696$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $150ba4634a330696$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $150ba4634a330696$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $150ba4634a330696$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}

});
parcelRegister("hYquC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d15c972f8843a0f2$export$2e2bcd8739ae039);

var $jSjsP = parcelRequire("jSjsP");
function $d15c972f8843a0f2$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $jSjsP.Timer);
    delay = delay == null ? 0 : +delay;
    t.restart(function(elapsed) {
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}

});
parcelRegister("jSjsP", function(module, exports) {

$parcel$export(module.exports, "now", () => $e782289d8bd71451$export$461939dd4422153);
$parcel$export(module.exports, "Timer", () => $e782289d8bd71451$export$c57e9b2d8b9e4de);
$parcel$export(module.exports, "timer", () => $e782289d8bd71451$export$9dc4ecf953986f04);
var $e782289d8bd71451$var$frame = 0, $e782289d8bd71451$var$timeout = 0, $e782289d8bd71451$var$interval = 0, $e782289d8bd71451$var$pokeDelay = 1000, $e782289d8bd71451$var$taskHead, $e782289d8bd71451$var$taskTail, $e782289d8bd71451$var$clockLast = 0, $e782289d8bd71451$var$clockNow = 0, $e782289d8bd71451$var$clockSkew = 0, $e782289d8bd71451$var$clock = typeof performance === "object" && performance.now ? performance : Date, $e782289d8bd71451$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $e782289d8bd71451$export$461939dd4422153() {
    return $e782289d8bd71451$var$clockNow || ($e782289d8bd71451$var$setFrame($e782289d8bd71451$var$clearNow), $e782289d8bd71451$var$clockNow = $e782289d8bd71451$var$clock.now() + $e782289d8bd71451$var$clockSkew);
}
function $e782289d8bd71451$var$clearNow() {
    $e782289d8bd71451$var$clockNow = 0;
}
function $e782289d8bd71451$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$e782289d8bd71451$export$c57e9b2d8b9e4de.prototype = $e782289d8bd71451$export$9dc4ecf953986f04.prototype = {
    constructor: $e782289d8bd71451$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $e782289d8bd71451$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $e782289d8bd71451$var$taskTail !== this) {
            if ($e782289d8bd71451$var$taskTail) $e782289d8bd71451$var$taskTail._next = this;
            else $e782289d8bd71451$var$taskHead = this;
            $e782289d8bd71451$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $e782289d8bd71451$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $e782289d8bd71451$var$sleep();
        }
    }
};
function $e782289d8bd71451$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $e782289d8bd71451$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $e782289d8bd71451$export$d60154c1d7f3990e() {
    $e782289d8bd71451$export$461939dd4422153(); // Get the current time, if not already set.
    ++$e782289d8bd71451$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $e782289d8bd71451$var$taskHead, e;
    while(t){
        if ((e = $e782289d8bd71451$var$clockNow - t._time) >= 0) t._call.call(null, e);
        t = t._next;
    }
    --$e782289d8bd71451$var$frame;
}
function $e782289d8bd71451$var$wake() {
    $e782289d8bd71451$var$clockNow = ($e782289d8bd71451$var$clockLast = $e782289d8bd71451$var$clock.now()) + $e782289d8bd71451$var$clockSkew;
    $e782289d8bd71451$var$frame = $e782289d8bd71451$var$timeout = 0;
    try {
        $e782289d8bd71451$export$d60154c1d7f3990e();
    } finally{
        $e782289d8bd71451$var$frame = 0;
        $e782289d8bd71451$var$nap();
        $e782289d8bd71451$var$clockNow = 0;
    }
}
function $e782289d8bd71451$var$poke() {
    var now = $e782289d8bd71451$var$clock.now(), delay = now - $e782289d8bd71451$var$clockLast;
    if (delay > $e782289d8bd71451$var$pokeDelay) $e782289d8bd71451$var$clockSkew -= delay, $e782289d8bd71451$var$clockLast = now;
}
function $e782289d8bd71451$var$nap() {
    var t0, t1 = $e782289d8bd71451$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $e782289d8bd71451$var$taskHead = t2;
    }
    $e782289d8bd71451$var$taskTail = t0;
    $e782289d8bd71451$var$sleep(time);
}
function $e782289d8bd71451$var$sleep(time) {
    if ($e782289d8bd71451$var$frame) return; // Soonest alarm already set, or will be.
    if ($e782289d8bd71451$var$timeout) $e782289d8bd71451$var$timeout = clearTimeout($e782289d8bd71451$var$timeout);
    var delay = time - $e782289d8bd71451$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $e782289d8bd71451$var$timeout = setTimeout($e782289d8bd71451$var$wake, time - $e782289d8bd71451$var$clock.now() - $e782289d8bd71451$var$clockSkew);
        if ($e782289d8bd71451$var$interval) $e782289d8bd71451$var$interval = clearInterval($e782289d8bd71451$var$interval);
    } else {
        if (!$e782289d8bd71451$var$interval) $e782289d8bd71451$var$clockLast = $e782289d8bd71451$var$clock.now(), $e782289d8bd71451$var$interval = setInterval($e782289d8bd71451$var$poke, $e782289d8bd71451$var$pokeDelay);
        $e782289d8bd71451$var$frame = 1, $e782289d8bd71451$var$setFrame($e782289d8bd71451$var$wake);
    }
}

});





parcelRegister("fBcKd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5b43281074f9351$export$2e2bcd8739ae039);

var $e9pyf = parcelRequire("e9pyf");

var $1O1wu = parcelRequire("1O1wu");

var $7OMS0 = parcelRequire("7OMS0");

var $jSjsP = parcelRequire("jSjsP");
var $b5b43281074f9351$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $7OMS0.cubicInOut)
};
function $b5b43281074f9351$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) return $b5b43281074f9351$var$defaultTiming.time = (0, $jSjsP.now)(), $b5b43281074f9351$var$defaultTiming;
    }
    return timing;
}
function $b5b43281074f9351$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $e9pyf.Transition)) id = name._id, name = name._name;
    else id = (0, $e9pyf.newId)(), (timing = $b5b43281074f9351$var$defaultTiming).time = (0, $jSjsP.now)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $1O1wu.default)(node, name, id, i, group, timing || $b5b43281074f9351$var$inherit(node, id));
    }
    return new (0, $e9pyf.Transition)(groups, this._parents, name, id);
}

});
parcelRegister("e9pyf", function(module, exports) {

$parcel$export(module.exports, "Transition", () => $a4d5b9ef4f9cfabb$export$be58926105124dd4);
$parcel$export(module.exports, "default", () => $a4d5b9ef4f9cfabb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "newId", () => $a4d5b9ef4f9cfabb$export$9ffd10a3fbdc175b);

var $3us5W = parcelRequire("3us5W");

var $3DFnF = parcelRequire("3DFnF");

var $hpADm = parcelRequire("hpADm");

var $QaWfs = parcelRequire("QaWfs");

var $drGTC = parcelRequire("drGTC");

var $cflrC = parcelRequire("cflrC");

var $gE3NB = parcelRequire("gE3NB");

var $jUpER = parcelRequire("jUpER");

var $lKQ2g = parcelRequire("lKQ2g");

var $fAKgz = parcelRequire("fAKgz");

var $dp6Bd = parcelRequire("dp6Bd");

var $asVWM = parcelRequire("asVWM");

var $1H5R6 = parcelRequire("1H5R6");

var $hV9BK = parcelRequire("hV9BK");

var $bhsa4 = parcelRequire("bhsa4");

var $jLbDc = parcelRequire("jLbDc");

var $8EN5J = parcelRequire("8EN5J");

var $jZTje = parcelRequire("jZTje");

var $cy9mc = parcelRequire("cy9mc");

var $73a8S = parcelRequire("73a8S");
var $a4d5b9ef4f9cfabb$var$id = 0;
function $a4d5b9ef4f9cfabb$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $a4d5b9ef4f9cfabb$export$2e2bcd8739ae039(name) {
    return (0, $3us5W.default)().transition(name);
}
function $a4d5b9ef4f9cfabb$export$9ffd10a3fbdc175b() {
    return ++$a4d5b9ef4f9cfabb$var$id;
}
var $a4d5b9ef4f9cfabb$var$selection_prototype = (0, $3us5W.default).prototype;
$a4d5b9ef4f9cfabb$export$be58926105124dd4.prototype = $a4d5b9ef4f9cfabb$export$2e2bcd8739ae039.prototype = {
    constructor: $a4d5b9ef4f9cfabb$export$be58926105124dd4,
    select: (0, $dp6Bd.default),
    selectAll: (0, $asVWM.default),
    filter: (0, $gE3NB.default),
    merge: (0, $jUpER.default),
    selection: (0, $1H5R6.default),
    transition: (0, $jZTje.default),
    call: $a4d5b9ef4f9cfabb$var$selection_prototype.call,
    nodes: $a4d5b9ef4f9cfabb$var$selection_prototype.nodes,
    node: $a4d5b9ef4f9cfabb$var$selection_prototype.node,
    size: $a4d5b9ef4f9cfabb$var$selection_prototype.size,
    empty: $a4d5b9ef4f9cfabb$var$selection_prototype.empty,
    each: $a4d5b9ef4f9cfabb$var$selection_prototype.each,
    on: (0, $lKQ2g.default),
    attr: (0, $3DFnF.default),
    attrTween: (0, $hpADm.default),
    style: (0, $hV9BK.default),
    styleTween: (0, $bhsa4.default),
    text: (0, $jLbDc.default),
    textTween: (0, $8EN5J.default),
    remove: (0, $fAKgz.default),
    tween: (0, $cy9mc.default),
    delay: (0, $QaWfs.default),
    duration: (0, $drGTC.default),
    ease: (0, $cflrC.default),
    end: (0, $73a8S.default)
};

});
parcelRegister("3DFnF", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a651cfc4e49b53d$export$2e2bcd8739ae039);

var $jDZQw = parcelRequire("jDZQw");

var $fEEcv = parcelRequire("fEEcv");

var $cy9mc = parcelRequire("cy9mc");

var $bSVkw = parcelRequire("bSVkw");
function $2a651cfc4e49b53d$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $2a651cfc4e49b53d$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $2a651cfc4e49b53d$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $2a651cfc4e49b53d$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $2a651cfc4e49b53d$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $2a651cfc4e49b53d$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $2a651cfc4e49b53d$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $fEEcv.default)(name), i = fullname === "transform" ? (0, $jDZQw.interpolateTransformSvg) : (0, $bSVkw.default);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $2a651cfc4e49b53d$var$attrFunctionNS : $2a651cfc4e49b53d$var$attrFunction)(fullname, i, (0, $cy9mc.tweenValue)(this, "attr." + name, value)) : value == null ? (fullname.local ? $2a651cfc4e49b53d$var$attrRemoveNS : $2a651cfc4e49b53d$var$attrRemove)(fullname) : (fullname.local ? $2a651cfc4e49b53d$var$attrConstantNS : $2a651cfc4e49b53d$var$attrConstant)(fullname, i, value));
}

});
parcelRegister("jDZQw", function(module, exports) {

$parcel$export(module.exports, "interpolateTransformCss", () => $e4d1a233c7242264$export$56bec7123bb3589a);
$parcel$export(module.exports, "interpolateTransformSvg", () => $e4d1a233c7242264$export$da8cba906d64c082);

var $gnkFs = parcelRequire("gnkFs");

var $6lTYu = parcelRequire("6lTYu");
function $e4d1a233c7242264$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $gnkFs.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $gnkFs.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $gnkFs.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $gnkFs.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $gnkFs.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $gnkFs.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $e4d1a233c7242264$export$56bec7123bb3589a = $e4d1a233c7242264$var$interpolateTransform((0, $6lTYu.parseCss), "px, ", "px)", "deg)");
var $e4d1a233c7242264$export$da8cba906d64c082 = $e4d1a233c7242264$var$interpolateTransform((0, $6lTYu.parseSvg), ", ", ")", ")");

});
parcelRegister("6lTYu", function(module, exports) {

$parcel$export(module.exports, "parseCss", () => $4a001faa54972590$export$59ad369bf4938177);
$parcel$export(module.exports, "parseSvg", () => $4a001faa54972590$export$f9ef43f9a1d89a18);

var $3xqrJ = parcelRequire("3xqrJ");
var $4a001faa54972590$var$cssNode, $4a001faa54972590$var$cssRoot, $4a001faa54972590$var$cssView, $4a001faa54972590$var$svgNode;
function $4a001faa54972590$export$59ad369bf4938177(value) {
    if (value === "none") return 0, $3xqrJ.identity;
    if (!$4a001faa54972590$var$cssNode) $4a001faa54972590$var$cssNode = document.createElement("DIV"), $4a001faa54972590$var$cssRoot = document.documentElement, $4a001faa54972590$var$cssView = document.defaultView;
    $4a001faa54972590$var$cssNode.style.transform = value;
    value = $4a001faa54972590$var$cssView.getComputedStyle($4a001faa54972590$var$cssRoot.appendChild($4a001faa54972590$var$cssNode), null).getPropertyValue("transform");
    $4a001faa54972590$var$cssRoot.removeChild($4a001faa54972590$var$cssNode);
    value = value.slice(7, -1).split(",");
    return (0, $3xqrJ.default)(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}
function $4a001faa54972590$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $3xqrJ.identity;
    if (!$4a001faa54972590$var$svgNode) $4a001faa54972590$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $4a001faa54972590$var$svgNode.setAttribute("transform", value);
    if (!(value = $4a001faa54972590$var$svgNode.transform.baseVal.consolidate())) return 0, $3xqrJ.identity;
    value = value.matrix;
    return (0, $3xqrJ.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("3xqrJ", function(module, exports) {

$parcel$export(module.exports, "identity", () => $2938f7d64470581a$export$f0954fd7d5368655);
$parcel$export(module.exports, "default", () => $2938f7d64470581a$export$2e2bcd8739ae039);
var $2938f7d64470581a$var$degrees = 180 / Math.PI;
var $2938f7d64470581a$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $2938f7d64470581a$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $2938f7d64470581a$var$degrees,
        skewX: Math.atan(skewX) * $2938f7d64470581a$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("cy9mc", function(module, exports) {

$parcel$export(module.exports, "default", () => $922feb1dfe9c8dcf$export$2e2bcd8739ae039);
$parcel$export(module.exports, "tweenValue", () => $922feb1dfe9c8dcf$export$f78ce6ab10405d82);

var $1O1wu = parcelRequire("1O1wu");
function $922feb1dfe9c8dcf$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $1O1wu.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $922feb1dfe9c8dcf$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $1O1wu.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $922feb1dfe9c8dcf$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $1O1wu.get)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $922feb1dfe9c8dcf$var$tweenRemove : $922feb1dfe9c8dcf$var$tweenFunction)(id, name, value));
}
function $922feb1dfe9c8dcf$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $1O1wu.set)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $1O1wu.get)(node, id).value[name];
    };
}

});

parcelRegister("bSVkw", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a713565676b726d$export$2e2bcd8739ae039);

var $bYoiY = parcelRequire("bYoiY");

var $gnkFs = parcelRequire("gnkFs");
var $jUrtA = parcelRequire("jUrtA");
var $aPLyh = parcelRequire("aPLyh");
function $8a713565676b726d$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $gnkFs.default) : b instanceof (0, $bYoiY.default) ? (0, $jUrtA.default) : (c = (0, $bYoiY.default)(b)) ? (b = c, $jUrtA.default) : (0, $aPLyh.default))(a, b);
}

});


parcelRegister("hpADm", function(module, exports) {

$parcel$export(module.exports, "default", () => $cad13035adb29669$export$2e2bcd8739ae039);

var $fEEcv = parcelRequire("fEEcv");
function $cad13035adb29669$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $cad13035adb29669$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $cad13035adb29669$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $cad13035adb29669$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $cad13035adb29669$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $cad13035adb29669$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $cad13035adb29669$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $fEEcv.default)(name);
    return this.tween(key, (fullname.local ? $cad13035adb29669$var$attrTweenNS : $cad13035adb29669$var$attrTween)(fullname, value));
}

});

parcelRegister("QaWfs", function(module, exports) {

$parcel$export(module.exports, "default", () => $09cd57996bd81614$export$2e2bcd8739ae039);

var $1O1wu = parcelRequire("1O1wu");
function $09cd57996bd81614$var$delayFunction(id, value) {
    return function() {
        (0, $1O1wu.init)(this, id).delay = +value.apply(this, arguments);
    };
}
function $09cd57996bd81614$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $1O1wu.init)(this, id).delay = value;
    };
}
function $09cd57996bd81614$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $09cd57996bd81614$var$delayFunction : $09cd57996bd81614$var$delayConstant)(id, value)) : (0, $1O1wu.get)(this.node(), id).delay;
}

});

parcelRegister("drGTC", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c9f124117d5bf14$export$2e2bcd8739ae039);

var $1O1wu = parcelRequire("1O1wu");
function $9c9f124117d5bf14$var$durationFunction(id, value) {
    return function() {
        (0, $1O1wu.set)(this, id).duration = +value.apply(this, arguments);
    };
}
function $9c9f124117d5bf14$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $1O1wu.set)(this, id).duration = value;
    };
}
function $9c9f124117d5bf14$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $9c9f124117d5bf14$var$durationFunction : $9c9f124117d5bf14$var$durationConstant)(id, value)) : (0, $1O1wu.get)(this.node(), id).duration;
}

});

parcelRegister("cflrC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ea7852b6976e6d1$export$2e2bcd8739ae039);

var $1O1wu = parcelRequire("1O1wu");
function $8ea7852b6976e6d1$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $1O1wu.set)(this, id).ease = value;
    };
}
function $8ea7852b6976e6d1$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($8ea7852b6976e6d1$var$easeConstant(id, value)) : (0, $1O1wu.get)(this.node(), id).ease;
}

});

parcelRegister("gE3NB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1e3543439d9f5fd$export$2e2bcd8739ae039);

var $8doa3 = parcelRequire("8doa3");

var $e9pyf = parcelRequire("e9pyf");
function $c1e3543439d9f5fd$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $8doa3.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $e9pyf.Transition)(subgroups, this._parents, this._name, this._id);
}

});

parcelRegister("jUpER", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7e726720f484153$export$2e2bcd8739ae039);

var $e9pyf = parcelRequire("e9pyf");
function $e7e726720f484153$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $e9pyf.Transition)(merges, this._parents, this._name, this._id);
}

});

parcelRegister("lKQ2g", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd664209e896113c$export$2e2bcd8739ae039);

var $1O1wu = parcelRequire("1O1wu");
function $fd664209e896113c$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $fd664209e896113c$var$onFunction(id, name, listener) {
    var on0, on1, sit = $fd664209e896113c$var$start(name) ? (0, $1O1wu.init) : (0, $1O1wu.set);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $fd664209e896113c$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $1O1wu.get)(this.node(), id).on.on(name) : this.each($fd664209e896113c$var$onFunction(id, name, listener));
}

});

parcelRegister("fAKgz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b59e1b517983ad92$export$2e2bcd8739ae039);
function $b59e1b517983ad92$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $b59e1b517983ad92$export$2e2bcd8739ae039() {
    return this.on("end.remove", $b59e1b517983ad92$var$removeFunction(this._id));
}

});

parcelRegister("dp6Bd", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c22ba9ec568d18f$export$2e2bcd8739ae039);

var $9rOh8 = parcelRequire("9rOh8");

var $e9pyf = parcelRequire("e9pyf");

var $1O1wu = parcelRequire("1O1wu");
function $9c22ba9ec568d18f$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $9rOh8.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $1O1wu.default)(subgroup[i], name, id, i, subgroup, (0, $1O1wu.get)(node, id));
        }
    }
    return new (0, $e9pyf.Transition)(subgroups, this._parents, name, id);
}

});

parcelRegister("asVWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $79e977f9a26c99f1$export$2e2bcd8739ae039);

var $aMqra = parcelRequire("aMqra");

var $e9pyf = parcelRequire("e9pyf");

var $1O1wu = parcelRequire("1O1wu");
function $79e977f9a26c99f1$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $aMqra.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $1O1wu.get)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $1O1wu.default)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $e9pyf.Transition)(subgroups, parents, name, id);
}

});

parcelRegister("1H5R6", function(module, exports) {

$parcel$export(module.exports, "default", () => $13be595fcf5febb7$export$2e2bcd8739ae039);

var $3us5W = parcelRequire("3us5W");
var $13be595fcf5febb7$var$Selection = (0, $3us5W.default).prototype.constructor;
function $13be595fcf5febb7$export$2e2bcd8739ae039() {
    return new $13be595fcf5febb7$var$Selection(this._groups, this._parents);
}

});

parcelRegister("hV9BK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0bf366fdef4c332$export$2e2bcd8739ae039);

var $jDZQw = parcelRequire("jDZQw");

var $9a8q4 = parcelRequire("9a8q4");

var $1O1wu = parcelRequire("1O1wu");

var $cy9mc = parcelRequire("cy9mc");

var $bSVkw = parcelRequire("bSVkw");
function $d0bf366fdef4c332$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $9a8q4.styleValue)(this, name), string1 = (this.style.removeProperty(name), (0, $9a8q4.styleValue)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $d0bf366fdef4c332$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $d0bf366fdef4c332$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $9a8q4.styleValue)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $d0bf366fdef4c332$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $9a8q4.styleValue)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $9a8q4.styleValue)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $d0bf366fdef4c332$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $1O1wu.set)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $d0bf366fdef4c332$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $d0bf366fdef4c332$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $jDZQw.interpolateTransformCss) : (0, $bSVkw.default);
    return value == null ? this.styleTween(name, $d0bf366fdef4c332$var$styleNull(name, i)).on("end.style." + name, $d0bf366fdef4c332$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $d0bf366fdef4c332$var$styleFunction(name, i, (0, $cy9mc.tweenValue)(this, "style." + name, value))).each($d0bf366fdef4c332$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $d0bf366fdef4c332$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}

});

parcelRegister("bhsa4", function(module, exports) {

$parcel$export(module.exports, "default", () => $83672080502c9717$export$2e2bcd8739ae039);
function $83672080502c9717$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $83672080502c9717$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $83672080502c9717$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $83672080502c9717$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $83672080502c9717$var$styleTween(name, value, priority == null ? "" : priority));
}

});

parcelRegister("jLbDc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e62b6dd5e7df40e7$export$2e2bcd8739ae039);

var $cy9mc = parcelRequire("cy9mc");
function $e62b6dd5e7df40e7$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $e62b6dd5e7df40e7$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $e62b6dd5e7df40e7$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $e62b6dd5e7df40e7$var$textFunction((0, $cy9mc.tweenValue)(this, "text", value)) : $e62b6dd5e7df40e7$var$textConstant(value == null ? "" : value + ""));
}

});

parcelRegister("8EN5J", function(module, exports) {

$parcel$export(module.exports, "default", () => $64d823b28aa7019a$export$2e2bcd8739ae039);
function $64d823b28aa7019a$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $64d823b28aa7019a$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $64d823b28aa7019a$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $64d823b28aa7019a$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $64d823b28aa7019a$var$textTween(value));
}

});

parcelRegister("jZTje", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8ee9e113d6ecbba$export$2e2bcd8739ae039);

var $e9pyf = parcelRequire("e9pyf");

var $1O1wu = parcelRequire("1O1wu");
function $e8ee9e113d6ecbba$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $e9pyf.newId)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $1O1wu.get)(node, id0);
            (0, $1O1wu.default)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $e9pyf.Transition)(groups, this._parents, name, id1);
}

});

parcelRegister("73a8S", function(module, exports) {

$parcel$export(module.exports, "default", () => $5220ae42feb560ba$export$2e2bcd8739ae039);

var $1O1wu = parcelRequire("1O1wu");
function $5220ae42feb560ba$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $1O1wu.set)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
    });
}

});


parcelRegister("7OMS0", function(module, exports) {

$parcel$export(module.exports, "cubicInOut", () => $5b131c7b61a09e82$export$89238d3bc79d3ada);
function $5b131c7b61a09e82$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $5b131c7b61a09e82$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $5b131c7b61a09e82$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

});



parcelRegister("e4waW", function(module, exports) {

var $e9pyf = parcelRequire("e9pyf");

var $1O1wu = parcelRequire("1O1wu");
var $a3ea65c9b2342fdf$var$root = [
    null
];
function $a3ea65c9b2342fdf$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, i;
    if (schedules) {
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).state > (0, $1O1wu.SCHEDULED) && schedule.name === name) return new (0, $e9pyf.Transition)([
                [
                    node
                ]
            ], $a3ea65c9b2342fdf$var$root, name, +i);
        }
    }
    return null;
}

});


parcelRegister("6QApF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fc3d848825eb4c8$export$2e2bcd8739ae039);
function $4fc3d848825eb4c8$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("j3W5K", function(module, exports) {

$parcel$export(module.exports, "default", () => $de0b5bec424cf247$export$2e2bcd8739ae039);
function $de0b5bec424cf247$export$2e2bcd8739ae039(target, type, selection) {
    this.target = target;
    this.type = type;
    this.selection = selection;
}

});

parcelRegister("6fYbl", function(module, exports) {

$parcel$export(module.exports, "nopropagation", () => $48e2d3ac3b9a75ee$export$2e2561858db9bf47);
$parcel$export(module.exports, "default", () => $48e2d3ac3b9a75ee$export$2e2bcd8739ae039);

var $iZ2is = parcelRequire("iZ2is");
function $48e2d3ac3b9a75ee$export$2e2561858db9bf47() {
    (0, $iZ2is.event).stopImmediatePropagation();
}
function $48e2d3ac3b9a75ee$export$2e2bcd8739ae039() {
    (0, $iZ2is.event).preventDefault();
    (0, $iZ2is.event).stopImmediatePropagation();
}

});



parcelRegister("k3760", function(module, exports) {

$parcel$export(module.exports, "csvParse", () => $e989978fabb69dc0$export$289d25497b0f4c16);
$parcel$export(module.exports, "csvParseRows", () => $e989978fabb69dc0$export$c82550ca942d869);

var $iLItl = parcelRequire("iLItl");
var $e989978fabb69dc0$var$csv = (0, $iLItl.default)(",");
var $e989978fabb69dc0$export$289d25497b0f4c16 = $e989978fabb69dc0$var$csv.parse;
var $e989978fabb69dc0$export$c82550ca942d869 = $e989978fabb69dc0$var$csv.parseRows;
var $e989978fabb69dc0$export$afe767551074aa08 = $e989978fabb69dc0$var$csv.format;
var $e989978fabb69dc0$export$b46fa59a5e3bc8a2 = $e989978fabb69dc0$var$csv.formatBody;
var $e989978fabb69dc0$export$3f42a65843fbd1d9 = $e989978fabb69dc0$var$csv.formatRows;
var $e989978fabb69dc0$export$c30212b87b2d080f = $e989978fabb69dc0$var$csv.formatRow;
var $e989978fabb69dc0$export$2771de09a60fc648 = $e989978fabb69dc0$var$csv.formatValue;

});
parcelRegister("iLItl", function(module, exports) {

$parcel$export(module.exports, "default", () => $da9f1d0b98e1d19a$export$2e2bcd8739ae039);
var $da9f1d0b98e1d19a$var$EOL = {}, $da9f1d0b98e1d19a$var$EOF = {}, $da9f1d0b98e1d19a$var$QUOTE = 34, $da9f1d0b98e1d19a$var$NEWLINE = 10, $da9f1d0b98e1d19a$var$RETURN = 13;
function $da9f1d0b98e1d19a$var$objectConverter(columns) {
    return new Function("d", "return {" + columns.map(function(name, i) {
        return JSON.stringify(name) + ": d[" + i + '] || ""';
    }).join(",") + "}");
}
function $da9f1d0b98e1d19a$var$customConverter(columns, f) {
    var object = $da9f1d0b98e1d19a$var$objectConverter(columns);
    return function(row, i) {
        return f(object(row), i, columns);
    };
}
// Compute unique columns in order of discovery.
function $da9f1d0b98e1d19a$var$inferColumns(rows) {
    var columnSet = Object.create(null), columns = [];
    rows.forEach(function(row) {
        for(var column in row)if (!(column in columnSet)) columns.push(columnSet[column] = column);
    });
    return columns;
}
function $da9f1d0b98e1d19a$var$pad(value, width) {
    var s = value + "", length = s.length;
    return length < width ? new Array(width - length + 1).join(0) + s : s;
}
function $da9f1d0b98e1d19a$var$formatYear(year) {
    return year < 0 ? "-" + $da9f1d0b98e1d19a$var$pad(-year, 6) : year > 9999 ? "+" + $da9f1d0b98e1d19a$var$pad(year, 6) : $da9f1d0b98e1d19a$var$pad(year, 4);
}
function $da9f1d0b98e1d19a$var$formatDate(date) {
    var hours = date.getUTCHours(), minutes = date.getUTCMinutes(), seconds = date.getUTCSeconds(), milliseconds = date.getUTCMilliseconds();
    return isNaN(date) ? "Invalid Date" : $da9f1d0b98e1d19a$var$formatYear(date.getUTCFullYear(), 4) + "-" + $da9f1d0b98e1d19a$var$pad(date.getUTCMonth() + 1, 2) + "-" + $da9f1d0b98e1d19a$var$pad(date.getUTCDate(), 2) + (milliseconds ? "T" + $da9f1d0b98e1d19a$var$pad(hours, 2) + ":" + $da9f1d0b98e1d19a$var$pad(minutes, 2) + ":" + $da9f1d0b98e1d19a$var$pad(seconds, 2) + "." + $da9f1d0b98e1d19a$var$pad(milliseconds, 3) + "Z" : seconds ? "T" + $da9f1d0b98e1d19a$var$pad(hours, 2) + ":" + $da9f1d0b98e1d19a$var$pad(minutes, 2) + ":" + $da9f1d0b98e1d19a$var$pad(seconds, 2) + "Z" : minutes || hours ? "T" + $da9f1d0b98e1d19a$var$pad(hours, 2) + ":" + $da9f1d0b98e1d19a$var$pad(minutes, 2) + "Z" : "");
}
function $da9f1d0b98e1d19a$export$2e2bcd8739ae039(delimiter) {
    var reFormat = new RegExp('["' + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
    function parse(text, f) {
        var convert, columns, rows = parseRows(text, function(row, i) {
            if (convert) return convert(row, i - 1);
            columns = row, convert = f ? $da9f1d0b98e1d19a$var$customConverter(row, f) : $da9f1d0b98e1d19a$var$objectConverter(row);
        });
        rows.columns = columns || [];
        return rows;
    }
    function parseRows(text, f) {
        var rows = [], N = text.length, I = 0, n = 0, t, eof = N <= 0, eol = false; // current token followed by EOL?
        // Strip the trailing newline.
        if (text.charCodeAt(N - 1) === $da9f1d0b98e1d19a$var$NEWLINE) --N;
        if (text.charCodeAt(N - 1) === $da9f1d0b98e1d19a$var$RETURN) --N;
        function token() {
            if (eof) return $da9f1d0b98e1d19a$var$EOF;
            if (eol) return eol = false, $da9f1d0b98e1d19a$var$EOL;
            // Unescape quotes.
            var i, j = I, c;
            if (text.charCodeAt(j) === $da9f1d0b98e1d19a$var$QUOTE) {
                while(I++ < N && text.charCodeAt(I) !== $da9f1d0b98e1d19a$var$QUOTE || text.charCodeAt(++I) === $da9f1d0b98e1d19a$var$QUOTE);
                if ((i = I) >= N) eof = true;
                else if ((c = text.charCodeAt(I++)) === $da9f1d0b98e1d19a$var$NEWLINE) eol = true;
                else if (c === $da9f1d0b98e1d19a$var$RETURN) {
                    eol = true;
                    if (text.charCodeAt(I) === $da9f1d0b98e1d19a$var$NEWLINE) ++I;
                }
                return text.slice(j + 1, i - 1).replace(/""/g, '"');
            }
            // Find next delimiter or newline.
            while(I < N){
                if ((c = text.charCodeAt(i = I++)) === $da9f1d0b98e1d19a$var$NEWLINE) eol = true;
                else if (c === $da9f1d0b98e1d19a$var$RETURN) {
                    eol = true;
                    if (text.charCodeAt(I) === $da9f1d0b98e1d19a$var$NEWLINE) ++I;
                } else if (c !== DELIMITER) continue;
                return text.slice(j, i);
            }
            // Return last token before EOF.
            return eof = true, text.slice(j, N);
        }
        while((t = token()) !== $da9f1d0b98e1d19a$var$EOF){
            var row = [];
            while(t !== $da9f1d0b98e1d19a$var$EOL && t !== $da9f1d0b98e1d19a$var$EOF)row.push(t), t = token();
            if (f && (row = f(row, n++)) == null) continue;
            rows.push(row);
        }
        return rows;
    }
    function preformatBody(rows, columns) {
        return rows.map(function(row) {
            return columns.map(function(column) {
                return formatValue(row[column]);
            }).join(delimiter);
        });
    }
    function format(rows, columns) {
        if (columns == null) columns = $da9f1d0b98e1d19a$var$inferColumns(rows);
        return [
            columns.map(formatValue).join(delimiter)
        ].concat(preformatBody(rows, columns)).join("\n");
    }
    function formatBody(rows, columns) {
        if (columns == null) columns = $da9f1d0b98e1d19a$var$inferColumns(rows);
        return preformatBody(rows, columns).join("\n");
    }
    function formatRows(rows) {
        return rows.map(formatRow).join("\n");
    }
    function formatRow(row) {
        return row.map(formatValue).join(delimiter);
    }
    function formatValue(value) {
        return value == null ? "" : value instanceof Date ? $da9f1d0b98e1d19a$var$formatDate(value) : reFormat.test(value += "") ? '"' + value.replace(/"/g, '""') + '"' : value;
    }
    return {
        parse: parse,
        parseRows: parseRows,
        format: format,
        formatBody: formatBody,
        formatRows: formatRows,
        formatRow: formatRow,
        formatValue: formatValue
    };
}

});


parcelRegister("kcqxh", function(module, exports) {

$parcel$export(module.exports, "tsvParse", () => $eb4983181a99ad22$export$f913251db2f734ee);
$parcel$export(module.exports, "tsvParseRows", () => $eb4983181a99ad22$export$8de3b5abc40a067f);

var $iLItl = parcelRequire("iLItl");
var $eb4983181a99ad22$var$tsv = (0, $iLItl.default)("	");
var $eb4983181a99ad22$export$f913251db2f734ee = $eb4983181a99ad22$var$tsv.parse;
var $eb4983181a99ad22$export$8de3b5abc40a067f = $eb4983181a99ad22$var$tsv.parseRows;
var $eb4983181a99ad22$export$77e754c4f8504293 = $eb4983181a99ad22$var$tsv.format;
var $eb4983181a99ad22$export$9d44987d460c9cb3 = $eb4983181a99ad22$var$tsv.formatBody;
var $eb4983181a99ad22$export$ae461973f6adc981 = $eb4983181a99ad22$var$tsv.formatRows;
var $eb4983181a99ad22$export$5d61cf35a4a738d2 = $eb4983181a99ad22$var$tsv.formatRow;
var $eb4983181a99ad22$export$4280e6a416cd92a3 = $eb4983181a99ad22$var$tsv.formatValue;

});

parcelRegister("Y5MKl", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b4a1789c016a21b$export$2e2bcd8739ae039);

var $aFEgl = parcelRequire("aFEgl");

var $iZ2is = parcelRequire("iZ2is");
var $iS3vq = parcelRequire("iS3vq");
var $hOxpW = parcelRequire("hOxpW");
var $5IKYT = parcelRequire("5IKYT");

var $cohyw = parcelRequire("cohyw");

var $cttdm = parcelRequire("cttdm");

var $8pScv = parcelRequire("8pScv");

var $5XYjj = parcelRequire("5XYjj");
// Ignore right-click, since that should open the context menu.
function $0b4a1789c016a21b$var$defaultFilter() {
    return !(0, $iZ2is.event).ctrlKey && !(0, $iZ2is.event).button;
}
function $0b4a1789c016a21b$var$defaultContainer() {
    return this.parentNode;
}
function $0b4a1789c016a21b$var$defaultSubject(d) {
    return d == null ? {
        x: (0, $iZ2is.event).x,
        y: (0, $iZ2is.event).y
    } : d;
}
function $0b4a1789c016a21b$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $0b4a1789c016a21b$export$2e2bcd8739ae039() {
    var filter = $0b4a1789c016a21b$var$defaultFilter, container = $0b4a1789c016a21b$var$defaultContainer, subject = $0b4a1789c016a21b$var$defaultSubject, touchable = $0b4a1789c016a21b$var$defaultTouchable, gestures = {}, listeners = (0, $aFEgl.default)("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
    function drag(selection) {
        selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    function mousedowned() {
        if (touchending || !filter.apply(this, arguments)) return;
        var gesture = beforestart("mouse", container.apply(this, arguments), (0, $iS3vq.default), this, arguments);
        if (!gesture) return;
        (0, $hOxpW.default)((0, $iZ2is.event).view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
        (0, $cohyw.default)((0, $iZ2is.event).view);
        (0, $cttdm.nopropagation)();
        mousemoving = false;
        mousedownx = (0, $iZ2is.event).clientX;
        mousedowny = (0, $iZ2is.event).clientY;
        gesture("start");
    }
    function mousemoved() {
        (0, $cttdm.default)();
        if (!mousemoving) {
            var dx = (0, $iZ2is.event).clientX - mousedownx, dy = (0, $iZ2is.event).clientY - mousedowny;
            mousemoving = dx * dx + dy * dy > clickDistance2;
        }
        gestures.mouse("drag");
    }
    function mouseupped() {
        (0, $hOxpW.default)((0, $iZ2is.event).view).on("mousemove.drag mouseup.drag", null);
        (0, $cohyw.yesdrag)((0, $iZ2is.event).view, mousemoving);
        (0, $cttdm.default)();
        gestures.mouse("end");
    }
    function touchstarted() {
        if (!filter.apply(this, arguments)) return;
        var touches = (0, $iZ2is.event).changedTouches, c = container.apply(this, arguments), n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = beforestart(touches[i].identifier, c, (0, $5IKYT.default), this, arguments)) {
            (0, $cttdm.nopropagation)();
            gesture("start");
        }
    }
    function touchmoved() {
        var touches = (0, $iZ2is.event).changedTouches, n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $cttdm.default)();
            gesture("drag");
        }
    }
    function touchended() {
        var touches = (0, $iZ2is.event).changedTouches, n = touches.length, i, gesture;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, 500); // Ghost clicks are delayed!
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $cttdm.nopropagation)();
            gesture("end");
        }
    }
    function beforestart(id, container, point, that, args) {
        var p = point(container, id), s, dx, dy, sublisteners = listeners.copy();
        if (!(0, $iZ2is.customEvent)(new (0, $5XYjj.default)(drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
            if (((0, $iZ2is.event).subject = s = subject.apply(that, args)) == null) return false;
            dx = s.x - p[0] || 0;
            dy = s.y - p[1] || 0;
            return true;
        })) return;
        return function gesture(type) {
            var p0 = p, n;
            switch(type){
                case "start":
                    gestures[id] = gesture, n = active++;
                    break;
                case "end":
                    delete gestures[id], --active; // nobreak
                case "drag":
                    p = point(container, id), n = active;
                    break;
            }
            (0, $iZ2is.customEvent)(new (0, $5XYjj.default)(drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [
                type,
                that,
                args
            ]);
        };
    }
    drag.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $8pScv.default)(!!_), drag) : filter;
    };
    drag.container = function(_) {
        return arguments.length ? (container = typeof _ === "function" ? _ : (0, $8pScv.default)(_), drag) : container;
    };
    drag.subject = function(_) {
        return arguments.length ? (subject = typeof _ === "function" ? _ : (0, $8pScv.default)(_), drag) : subject;
    };
    drag.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $8pScv.default)(!!_), drag) : touchable;
    };
    drag.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? drag : value;
    };
    drag.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
    };
    return drag;
}

});
parcelRegister("8pScv", function(module, exports) {

$parcel$export(module.exports, "default", () => $620ab3a49fccb4fc$export$2e2bcd8739ae039);
function $620ab3a49fccb4fc$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("5XYjj", function(module, exports) {

$parcel$export(module.exports, "default", () => $45813ed5c6fd1799$export$2e2bcd8739ae039);
function $45813ed5c6fd1799$export$2e2bcd8739ae039(target, type, subject, id, active, x, y, dx, dy, dispatch) {
    this.target = target;
    this.type = type;
    this.subject = subject;
    this.identifier = id;
    this.active = active;
    this.x = x;
    this.y = y;
    this.dx = dx;
    this.dy = dy;
    this._ = dispatch;
}
$45813ed5c6fd1799$export$2e2bcd8739ae039.prototype.on = function() {
    var value = this._.on.apply(this._, arguments);
    return value === this._ ? this : value;
};

});


parcelRegister("lkHQY", function(module, exports) {

$parcel$export(module.exports, "scaleLinear", () => (parcelRequire("iOlPi")).default);
$parcel$export(module.exports, "scaleLog", () => (parcelRequire("7TrsU")).default);
$parcel$export(module.exports, "scaleSymlog", () => (parcelRequire("ht0x4")).default);
$parcel$export(module.exports, "scaleOrdinal", () => (parcelRequire("4PqgM")).default);
$parcel$export(module.exports, "scaleTime", () => (parcelRequire("48U7R")).default);

var $gEnYl = parcelRequire("gEnYl");

var $iYj4F = parcelRequire("iYj4F");

var $iOlPi = parcelRequire("iOlPi");

var $7TrsU = parcelRequire("7TrsU");

var $ht0x4 = parcelRequire("ht0x4");

var $4PqgM = parcelRequire("4PqgM");

var $iFFhE = parcelRequire("iFFhE");

var $cTbvO = parcelRequire("cTbvO");

var $ekSyn = parcelRequire("ekSyn");

var $b1bfu = parcelRequire("b1bfu");

var $48U7R = parcelRequire("48U7R");

var $l1Ebe = parcelRequire("l1Ebe");

var $lrv5b = parcelRequire("lrv5b");

var $77K6z = parcelRequire("77K6z");

var $2dSUq = parcelRequire("2dSUq");

var $fabdk = parcelRequire("fabdk");

});
parcelRegister("gEnYl", function(module, exports) {
parcelRequire("b6jkW");
var $8oHIF = parcelRequire("8oHIF");

var $7QzZn = parcelRequire("7QzZn");

var $4PqgM = parcelRequire("4PqgM");
function $c1f2fa2a7653ca3a$export$2e2bcd8739ae039() {
    var scale = (0, $4PqgM.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, range = [
        0,
        1
    ], step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = range[1] < range[0], start = range[reverse - 0], stop = range[1 - reverse];
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $8oHIF.default)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? (range = [
            +_[0],
            +_[1]
        ], rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = [
            +_[0],
            +_[1]
        ], round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $c1f2fa2a7653ca3a$export$2e2bcd8739ae039(domain(), range).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $7QzZn.initRange).apply(rescale(), arguments);
}
function $c1f2fa2a7653ca3a$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $c1f2fa2a7653ca3a$var$pointish(copy());
    };
    return scale;
}
function $c1f2fa2a7653ca3a$export$105684a3041cb6f3() {
    return $c1f2fa2a7653ca3a$var$pointish($c1f2fa2a7653ca3a$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("b6jkW", function(module, exports) {

$parcel$export(module.exports, "bisect", () => (parcelRequire("ekiL6")).default);
$parcel$export(module.exports, "ascending", () => (parcelRequire("8zdji")).default);
$parcel$export(module.exports, "bisector", () => (parcelRequire("W4CTv")).default);
$parcel$export(module.exports, "quantile", () => (parcelRequire("30TGf")).default);
$parcel$export(module.exports, "range", () => (parcelRequire("8oHIF")).default);
$parcel$export(module.exports, "ticks", () => (parcelRequire("aE6k7")).default);
$parcel$export(module.exports, "tickIncrement", () => (parcelRequire("aE6k7")).tickIncrement);
$parcel$export(module.exports, "tickStep", () => (parcelRequire("aE6k7")).tickStep);

var $ekiL6 = parcelRequire("ekiL6");

var $8zdji = parcelRequire("8zdji");

var $W4CTv = parcelRequire("W4CTv");

var $8RPRG = parcelRequire("8RPRG");

var $5303J = parcelRequire("5303J");

var $4feMU = parcelRequire("4feMU");

var $375dL = parcelRequire("375dL");

var $d5ZOB = parcelRequire("d5ZOB");

var $2j8PU = parcelRequire("2j8PU");

var $jJ5Zx = parcelRequire("jJ5Zx");

var $9nnn8 = parcelRequire("9nnn8");

var $7MbYq = parcelRequire("7MbYq");

var $gkaVF = parcelRequire("gkaVF");

var $7tvEC = parcelRequire("7tvEC");

var $7hqG7 = parcelRequire("7hqG7");

var $fzQB8 = parcelRequire("fzQB8");

var $exF8A = parcelRequire("exF8A");

var $a3ID3 = parcelRequire("a3ID3");

var $30TGf = parcelRequire("30TGf");

var $8oHIF = parcelRequire("8oHIF");

var $965ZG = parcelRequire("965ZG");

var $TsEdq = parcelRequire("TsEdq");

var $iNu7i = parcelRequire("iNu7i");

var $aE6k7 = parcelRequire("aE6k7");

var $jHSXP = parcelRequire("jHSXP");

var $6Mb8u = parcelRequire("6Mb8u");

var $aMrXu = parcelRequire("aMrXu");

});
parcelRegister("ekiL6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6e17c0ec55d7735$export$2e2bcd8739ae039);

var $8zdji = parcelRequire("8zdji");

var $W4CTv = parcelRequire("W4CTv");
var $a6e17c0ec55d7735$var$ascendingBisect = (0, $W4CTv.default)((0, $8zdji.default));
var $a6e17c0ec55d7735$export$4d945ad3ad5751b0 = $a6e17c0ec55d7735$var$ascendingBisect.right;
var $a6e17c0ec55d7735$export$df7d25c84ebd12a5 = $a6e17c0ec55d7735$var$ascendingBisect.left;
var $a6e17c0ec55d7735$export$2e2bcd8739ae039 = $a6e17c0ec55d7735$export$4d945ad3ad5751b0;

});
parcelRegister("8zdji", function(module, exports) {

$parcel$export(module.exports, "default", () => $63cbeabc75241824$export$2e2bcd8739ae039);
function $63cbeabc75241824$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("W4CTv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ae9019609d046a1$export$2e2bcd8739ae039);

var $8zdji = parcelRequire("8zdji");
function $0ae9019609d046a1$export$2e2bcd8739ae039(compare) {
    if (compare.length === 1) compare = $0ae9019609d046a1$var$ascendingComparator(compare);
    return {
        left: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }
            return lo;
        },
        right: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) > 0) hi = mid;
                else lo = mid + 1;
            }
            return lo;
        }
    };
}
function $0ae9019609d046a1$var$ascendingComparator(f) {
    return function(d, x) {
        return (0, $8zdji.default)(f(d), x);
    };
}

});


parcelRegister("8RPRG", function(module, exports) {

var $exF8A = parcelRequire("exF8A");
function $674b813fb857ae76$export$2e2bcd8739ae039(values0, values1, reduce) {
    var n0 = values0.length, n1 = values1.length, values = new Array(n0 * n1), i0, i1, i, value0;
    if (reduce == null) reduce = (0, $exF8A.pair);
    for(i0 = i = 0; i0 < n0; ++i0)for(value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i)values[i] = reduce(value0, values1[i1]);
    return values;
}

});
parcelRegister("exF8A", function(module, exports) {

$parcel$export(module.exports, "pair", () => $a9640ed34ca3d852$export$a04cb3fe8b81dd);
function $a9640ed34ca3d852$export$2e2bcd8739ae039(array, f) {
    if (f == null) f = $a9640ed34ca3d852$export$a04cb3fe8b81dd;
    var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
    while(i < n)pairs[i] = f(p, p = array[++i]);
    return pairs;
}
function $a9640ed34ca3d852$export$a04cb3fe8b81dd(a, b) {
    return [
        a,
        b
    ];
}

});


parcelRegister("5303J", function(module, exports) {
function $3acd474ceacf8a38$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("4feMU", function(module, exports) {

$parcel$export(module.exports, "default", () => $317408b795339b26$export$2e2bcd8739ae039);

var $6Mb8u = parcelRequire("6Mb8u");
function $317408b795339b26$export$2e2bcd8739ae039(array, f) {
    var v = (0, $6Mb8u.default)(array, f);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("6Mb8u", function(module, exports) {

$parcel$export(module.exports, "default", () => $4eefdd235be3059b$export$2e2bcd8739ae039);

var $7EiNs = parcelRequire("7EiNs");
function $4eefdd235be3059b$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = 0, i = -1, mean = 0, value, delta, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $7EiNs.default)(values[i]))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    } else {
        while(++i < n)if (!isNaN(value = (0, $7EiNs.default)(valueof(values[i], i, values)))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    }
    if (m > 1) return sum / (m - 1);
}

});
parcelRegister("7EiNs", function(module, exports) {

$parcel$export(module.exports, "default", () => $591ad978f2ce6133$export$2e2bcd8739ae039);
function $591ad978f2ce6133$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}

});



parcelRegister("375dL", function(module, exports) {

$parcel$export(module.exports, "default", () => $24461355656d8852$export$2e2bcd8739ae039);
function $24461355656d8852$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = values[i]) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("d5ZOB", function(module, exports) {

var $4QKWq = parcelRequire("4QKWq");

var $ekiL6 = parcelRequire("ekiL6");

var $dS4Hg = parcelRequire("dS4Hg");

var $375dL = parcelRequire("375dL");

var $iHiZH = parcelRequire("iHiZH");

var $8oHIF = parcelRequire("8oHIF");

var $aE6k7 = parcelRequire("aE6k7");

var $9nnn8 = parcelRequire("9nnn8");
function $988bb1338864c108$export$2e2bcd8739ae039() {
    var value = (0, $iHiZH.default), domain = (0, $375dL.default), threshold = (0, $9nnn8.default);
    function histogram(data) {
        var i, n = data.length, x, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            tz = (0, $aE6k7.tickStep)(x0, x1, tz);
            tz = (0, $8oHIF.default)(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
        }
        // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        for(i = 0; i < n; ++i){
            x = values[i];
            if (x0 <= x && x <= x1) bins[(0, $ekiL6.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $dS4Hg.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $dS4Hg.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $dS4Hg.default)((0, $4QKWq.slice).call(_)) : (0, $dS4Hg.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("4QKWq", function(module, exports) {

$parcel$export(module.exports, "slice", () => $38806e4e35e056bb$export$58adb3bec8346d0f);
$parcel$export(module.exports, "map", () => $38806e4e35e056bb$export$871de8747c9eaa88);
var $38806e4e35e056bb$var$array = Array.prototype;
var $38806e4e35e056bb$export$58adb3bec8346d0f = $38806e4e35e056bb$var$array.slice;
var $38806e4e35e056bb$export$871de8747c9eaa88 = $38806e4e35e056bb$var$array.map;

});

parcelRegister("dS4Hg", function(module, exports) {

$parcel$export(module.exports, "default", () => $a193f63211edda81$export$2e2bcd8739ae039);
function $a193f63211edda81$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("iHiZH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9caf9fd1659d791$export$2e2bcd8739ae039);
function $d9caf9fd1659d791$export$2e2bcd8739ae039(x) {
    return x;
}

});

parcelRegister("8oHIF", function(module, exports) {

$parcel$export(module.exports, "default", () => $61d27a61db04c1a6$export$2e2bcd8739ae039);
function $61d27a61db04c1a6$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("aE6k7", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c028b8201e48c5a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "tickIncrement", () => $7c028b8201e48c5a$export$bc64d00cc98e7e95);
$parcel$export(module.exports, "tickStep", () => $7c028b8201e48c5a$export$81087d9b915d4ede);
var $7c028b8201e48c5a$var$e10 = Math.sqrt(50), $7c028b8201e48c5a$var$e5 = Math.sqrt(10), $7c028b8201e48c5a$var$e2 = Math.sqrt(2);
function $7c028b8201e48c5a$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $7c028b8201e48c5a$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        start = Math.ceil(start / step);
        stop = Math.floor(stop / step);
        ticks = new Array(n = Math.ceil(stop - start + 1));
        while(++i < n)ticks[i] = (start + i) * step;
    } else {
        start = Math.floor(start * step);
        stop = Math.ceil(stop * step);
        ticks = new Array(n = Math.ceil(start - stop + 1));
        while(++i < n)ticks[i] = (start - i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $7c028b8201e48c5a$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $7c028b8201e48c5a$var$e10 ? 10 : error >= $7c028b8201e48c5a$var$e5 ? 5 : error >= $7c028b8201e48c5a$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $7c028b8201e48c5a$var$e10 ? 10 : error >= $7c028b8201e48c5a$var$e5 ? 5 : error >= $7c028b8201e48c5a$var$e2 ? 2 : 1);
}
function $7c028b8201e48c5a$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $7c028b8201e48c5a$var$e10) step1 *= 10;
    else if (error >= $7c028b8201e48c5a$var$e5) step1 *= 5;
    else if (error >= $7c028b8201e48c5a$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});

parcelRegister("9nnn8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d386446084ca1a9$export$2e2bcd8739ae039);
function $6d386446084ca1a9$export$2e2bcd8739ae039(values) {
    return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}

});


parcelRegister("2j8PU", function(module, exports) {

var $4QKWq = parcelRequire("4QKWq");

var $8zdji = parcelRequire("8zdji");

var $7EiNs = parcelRequire("7EiNs");

var $30TGf = parcelRequire("30TGf");
function $1ae435d6739098c4$export$2e2bcd8739ae039(values, min, max) {
    values = (0, $4QKWq.map).call(values, (0, $7EiNs.default)).sort((0, $8zdji.default));
    return Math.ceil((max - min) / (2 * ((0, $30TGf.default)(values, 0.75) - (0, $30TGf.default)(values, 0.25)) * Math.pow(values.length, -1 / 3)));
}

});
parcelRegister("30TGf", function(module, exports) {

$parcel$export(module.exports, "default", () => $231c9024a6754413$export$2e2bcd8739ae039);

var $7EiNs = parcelRequire("7EiNs");
function $231c9024a6754413$export$2e2bcd8739ae039(values, p, valueof) {
    if (valueof == null) valueof = (0, $7EiNs.default);
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});


parcelRegister("jJ5Zx", function(module, exports) {

var $4feMU = parcelRequire("4feMU");
function $e5c6de1a6d3b2294$export$2e2bcd8739ae039(values, min, max) {
    return Math.ceil((max - min) / (3.5 * (0, $4feMU.default)(values) * Math.pow(values.length, -1 / 3)));
}

});

parcelRegister("7MbYq", function(module, exports) {
function $5a964dca3df4eea7$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = values[i]) != null && value > max) max = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && value > max) max = value;
        }
    }
    return max;
}

});

parcelRegister("gkaVF", function(module, exports) {

var $7EiNs = parcelRequire("7EiNs");
function $be26fde1f1f97ef0$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = n, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $7EiNs.default)(values[i]))) sum += value;
        else --m;
    } else {
        while(++i < n)if (!isNaN(value = (0, $7EiNs.default)(valueof(values[i], i, values)))) sum += value;
        else --m;
    }
    if (m) return sum / m;
}

});

parcelRegister("7tvEC", function(module, exports) {

var $8zdji = parcelRequire("8zdji");

var $7EiNs = parcelRequire("7EiNs");

var $30TGf = parcelRequire("30TGf");
function $5713cbb46e42efc2$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, numbers = [];
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $7EiNs.default)(values[i]))) numbers.push(value);
    } else {
        while(++i < n)if (!isNaN(value = (0, $7EiNs.default)(valueof(values[i], i, values)))) numbers.push(value);
    }
    return (0, $30TGf.default)(numbers.sort((0, $8zdji.default)), 0.5);
}

});

parcelRegister("7hqG7", function(module, exports) {
function $54ced0ad7294c1a8$export$2e2bcd8739ae039(arrays) {
    var n = arrays.length, m, i = -1, j = 0, merged, array;
    while(++i < n)j += arrays[i].length;
    merged = new Array(j);
    while(--n >= 0){
        array = arrays[n];
        m = array.length;
        while(--m >= 0)merged[--j] = array[m];
    }
    return merged;
}

});

parcelRegister("fzQB8", function(module, exports) {

$parcel$export(module.exports, "default", () => $02ed355deaa9e190$export$2e2bcd8739ae039);
function $02ed355deaa9e190$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = values[i]) != null && min > value) min = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && min > value) min = value;
        }
    }
    return min;
}

});

parcelRegister("a3ID3", function(module, exports) {
function $752ccd95a674b233$export$2e2bcd8739ae039(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while(i--)permutes[i] = array[indexes[i]];
    return permutes;
}

});

parcelRegister("965ZG", function(module, exports) {

var $8zdji = parcelRequire("8zdji");
function $69f952dec6daacf1$export$2e2bcd8739ae039(values, compare) {
    if (!(n = values.length)) return;
    var n, i = 0, j = 0, xi, xj = values[j];
    if (compare == null) compare = (0, $8zdji.default);
    while(++i < n)if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
    if (compare(xj, xj) === 0) return j;
}

});

parcelRegister("TsEdq", function(module, exports) {
function $0a6b5bfe2fca1ade$export$2e2bcd8739ae039(array, i0, i1) {
    var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0), t, i;
    while(m){
        i = Math.random() * m-- | 0;
        t = array[m + i0];
        array[m + i0] = array[i + i0];
        array[i + i0] = t;
    }
    return array;
}

});

parcelRegister("iNu7i", function(module, exports) {
function $daf42a1f07322cf6$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    } else {
        while(++i < n)if (value = +valueof(values[i], i, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("jHSXP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e58cab29de1f7712$export$2e2bcd8739ae039);

var $fzQB8 = parcelRequire("fzQB8");
function $e58cab29de1f7712$export$2e2bcd8739ae039(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $fzQB8.default)(matrix, $e58cab29de1f7712$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $e58cab29de1f7712$var$length(d) {
    return d.length;
}

});

parcelRegister("aMrXu", function(module, exports) {

var $jHSXP = parcelRequire("jHSXP");
function $7d941308464d4714$export$2e2bcd8739ae039() {
    return (0, $jHSXP.default)(arguments);
}

});


parcelRegister("7QzZn", function(module, exports) {

$parcel$export(module.exports, "initRange", () => $5b694e64f5326630$export$23c7bb9e6558da2a);
$parcel$export(module.exports, "initInterpolator", () => $5b694e64f5326630$export$7d6b419e59e83f3d);
function $5b694e64f5326630$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $5b694e64f5326630$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.interpolator(domain);
            break;
        default:
            this.interpolator(interpolator).domain(domain);
            break;
    }
    return this;
}

});

parcelRegister("4PqgM", function(module, exports) {

$parcel$export(module.exports, "default", () => $38404d762c7ac827$export$2e2bcd8739ae039);
parcelRequire("jVei2");
var $4Odqs = parcelRequire("4Odqs");

var $akaTP = parcelRequire("akaTP");

var $7QzZn = parcelRequire("7QzZn");
var $38404d762c7ac827$export$e4f898ab14d9d460 = {
    name: "implicit"
};
function $38404d762c7ac827$export$2e2bcd8739ae039() {
    var index = (0, $4Odqs.default)(), domain = [], range = [], unknown = $38404d762c7ac827$export$e4f898ab14d9d460;
    function scale(d) {
        var key = d + "", i = index.get(key);
        if (!i) {
            if (unknown !== $38404d762c7ac827$export$e4f898ab14d9d460) return unknown;
            index.set(key, i = domain.push(d));
        }
        return range[(i - 1) % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = (0, $4Odqs.default)();
        var i = -1, n = _.length, d, key;
        while(++i < n)if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, $akaTP.slice).call(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $38404d762c7ac827$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $7QzZn.initRange).apply(scale, arguments);
    return scale;
}

});
parcelRegister("jVei2", function(module, exports) {

$parcel$export(module.exports, "map", () => (parcelRequire("4Odqs")).default);

var $bogsH = parcelRequire("bogsH");

var $hN70o = parcelRequire("hN70o");

var $4Odqs = parcelRequire("4Odqs");

var $fgOqA = parcelRequire("fgOqA");

var $9IFuT = parcelRequire("9IFuT");

var $R8upf = parcelRequire("R8upf");

});
parcelRegister("bogsH", function(module, exports) {

var $4Odqs = parcelRequire("4Odqs");
function $84aeb4920efec81c$export$2e2bcd8739ae039() {
    var keys = [], sortKeys = [], sortValues, rollup, nest;
    function apply(array, depth, createResult, setResult) {
        if (depth >= keys.length) {
            if (sortValues != null) array.sort(sortValues);
            return rollup != null ? rollup(array) : array;
        }
        var i = -1, n = array.length, key = keys[depth++], keyValue, value, valuesByKey = (0, $4Odqs.default)(), values, result = createResult();
        while(++i < n)if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) values.push(value);
        else valuesByKey.set(keyValue, [
            value
        ]);
        valuesByKey.each(function(values, key) {
            setResult(result, key, apply(values, depth, createResult, setResult));
        });
        return result;
    }
    function entries(map, depth) {
        if (++depth > keys.length) return map;
        var array, sortKey = sortKeys[depth - 1];
        if (rollup != null && depth >= keys.length) array = map.entries();
        else array = [], map.each(function(v, k) {
            array.push({
                key: k,
                values: entries(v, depth)
            });
        });
        return sortKey != null ? array.sort(function(a, b) {
            return sortKey(a.key, b.key);
        }) : array;
    }
    return nest = {
        object: function(array) {
            return apply(array, 0, $84aeb4920efec81c$var$createObject, $84aeb4920efec81c$var$setObject);
        },
        map: function(array) {
            return apply(array, 0, $84aeb4920efec81c$var$createMap, $84aeb4920efec81c$var$setMap);
        },
        entries: function(array) {
            return entries(apply(array, 0, $84aeb4920efec81c$var$createMap, $84aeb4920efec81c$var$setMap), 0);
        },
        key: function(d) {
            keys.push(d);
            return nest;
        },
        sortKeys: function(order) {
            sortKeys[keys.length - 1] = order;
            return nest;
        },
        sortValues: function(order) {
            sortValues = order;
            return nest;
        },
        rollup: function(f) {
            rollup = f;
            return nest;
        }
    };
}
function $84aeb4920efec81c$var$createObject() {
    return {};
}
function $84aeb4920efec81c$var$setObject(object, key, value) {
    object[key] = value;
}
function $84aeb4920efec81c$var$createMap() {
    return (0, $4Odqs.default)();
}
function $84aeb4920efec81c$var$setMap(map, key, value) {
    map.set(key, value);
}

});
parcelRegister("4Odqs", function(module, exports) {

$parcel$export(module.exports, "prefix", () => $38063efcb0b229b0$export$82e9f45cca5ba907);
$parcel$export(module.exports, "default", () => $38063efcb0b229b0$export$2e2bcd8739ae039);
var $38063efcb0b229b0$export$82e9f45cca5ba907 = "$";
function $38063efcb0b229b0$var$Map() {}
$38063efcb0b229b0$var$Map.prototype = $38063efcb0b229b0$var$map.prototype = {
    constructor: $38063efcb0b229b0$var$Map,
    has: function(key) {
        return $38063efcb0b229b0$export$82e9f45cca5ba907 + key in this;
    },
    get: function(key) {
        return this[$38063efcb0b229b0$export$82e9f45cca5ba907 + key];
    },
    set: function(key, value) {
        this[$38063efcb0b229b0$export$82e9f45cca5ba907 + key] = value;
        return this;
    },
    remove: function(key) {
        var property = $38063efcb0b229b0$export$82e9f45cca5ba907 + key;
        return property in this && delete this[property];
    },
    clear: function() {
        for(var property in this)if (property[0] === $38063efcb0b229b0$export$82e9f45cca5ba907) delete this[property];
    },
    keys: function() {
        var keys = [];
        for(var property in this)if (property[0] === $38063efcb0b229b0$export$82e9f45cca5ba907) keys.push(property.slice(1));
        return keys;
    },
    values: function() {
        var values = [];
        for(var property in this)if (property[0] === $38063efcb0b229b0$export$82e9f45cca5ba907) values.push(this[property]);
        return values;
    },
    entries: function() {
        var entries = [];
        for(var property in this)if (property[0] === $38063efcb0b229b0$export$82e9f45cca5ba907) entries.push({
            key: property.slice(1),
            value: this[property]
        });
        return entries;
    },
    size: function() {
        var size = 0;
        for(var property in this)if (property[0] === $38063efcb0b229b0$export$82e9f45cca5ba907) ++size;
        return size;
    },
    empty: function() {
        for(var property in this)if (property[0] === $38063efcb0b229b0$export$82e9f45cca5ba907) return false;
        return true;
    },
    each: function(f) {
        for(var property in this)if (property[0] === $38063efcb0b229b0$export$82e9f45cca5ba907) f(this[property], property.slice(1), this);
    }
};
function $38063efcb0b229b0$var$map(object, f) {
    var map = new $38063efcb0b229b0$var$Map;
    // Copy constructor.
    if (object instanceof $38063efcb0b229b0$var$Map) object.each(function(value, key) {
        map.set(key, value);
    });
    else if (Array.isArray(object)) {
        var i = -1, n = object.length, o;
        if (f == null) while(++i < n)map.set(i, object[i]);
        else while(++i < n)map.set(f(o = object[i], i, object), o);
    } else if (object) for(var key in object)map.set(key, object[key]);
    return map;
}
var $38063efcb0b229b0$export$2e2bcd8739ae039 = $38063efcb0b229b0$var$map;

});


parcelRegister("hN70o", function(module, exports) {

var $4Odqs = parcelRequire("4Odqs");
function $cf3c72678de97179$var$Set() {}
var $cf3c72678de97179$var$proto = (0, $4Odqs.default).prototype;
$cf3c72678de97179$var$Set.prototype = $cf3c72678de97179$var$set.prototype = {
    constructor: $cf3c72678de97179$var$Set,
    has: $cf3c72678de97179$var$proto.has,
    add: function(value) {
        value += "";
        this[(0, $4Odqs.prefix) + value] = value;
        return this;
    },
    remove: $cf3c72678de97179$var$proto.remove,
    clear: $cf3c72678de97179$var$proto.clear,
    values: $cf3c72678de97179$var$proto.keys,
    size: $cf3c72678de97179$var$proto.size,
    empty: $cf3c72678de97179$var$proto.empty,
    each: $cf3c72678de97179$var$proto.each
};
function $cf3c72678de97179$var$set(object, f) {
    var set = new $cf3c72678de97179$var$Set;
    // Copy constructor.
    if (object instanceof $cf3c72678de97179$var$Set) object.each(function(value) {
        set.add(value);
    });
    else if (object) {
        var i = -1, n = object.length;
        if (f == null) while(++i < n)set.add(object[i]);
        else while(++i < n)set.add(f(object[i], i, object));
    }
    return set;
}
var $cf3c72678de97179$export$2e2bcd8739ae039 = $cf3c72678de97179$var$set;

});

parcelRegister("fgOqA", function(module, exports) {
function $b1df778a51d6d6fd$export$2e2bcd8739ae039(map) {
    var keys = [];
    for(var key in map)keys.push(key);
    return keys;
}

});

parcelRegister("9IFuT", function(module, exports) {
function $7138699956e0deee$export$2e2bcd8739ae039(map) {
    var values = [];
    for(var key in map)values.push(map[key]);
    return values;
}

});

parcelRegister("R8upf", function(module, exports) {
function $09fb892cb60fcd6e$export$2e2bcd8739ae039(map) {
    var entries = [];
    for(var key in map)entries.push({
        key: key,
        value: map[key]
    });
    return entries;
}

});


parcelRegister("akaTP", function(module, exports) {

$parcel$export(module.exports, "map", () => $01f09594bbab007c$export$871de8747c9eaa88);
$parcel$export(module.exports, "slice", () => $01f09594bbab007c$export$58adb3bec8346d0f);
var $01f09594bbab007c$var$array = Array.prototype;
var $01f09594bbab007c$export$871de8747c9eaa88 = $01f09594bbab007c$var$array.map;
var $01f09594bbab007c$export$58adb3bec8346d0f = $01f09594bbab007c$var$array.slice;

});



parcelRegister("iYj4F", function(module, exports) {

var $akaTP = parcelRequire("akaTP");

var $iOlPi = parcelRequire("iOlPi");

var $9krIo = parcelRequire("9krIo");
function $dcfca0550ace1fe6$export$2e2bcd8739ae039(domain) {
    var unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = (0, $akaTP.map).call(_, (0, $9krIo.default)), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $dcfca0550ace1fe6$export$2e2bcd8739ae039(domain).unknown(unknown);
    };
    domain = arguments.length ? (0, $akaTP.map).call(domain, (0, $9krIo.default)) : [
        0,
        1
    ];
    return (0, $iOlPi.linearish)(scale);
}

});
parcelRegister("iOlPi", function(module, exports) {

$parcel$export(module.exports, "linearish", () => $db1dd3c66a0cbf94$export$16a5d4b4a61a274d);
$parcel$export(module.exports, "default", () => $db1dd3c66a0cbf94$export$2e2bcd8739ae039);
parcelRequire("b6jkW");
var $aE6k7 = parcelRequire("aE6k7");

var $f6dVf = parcelRequire("f6dVf");

var $7QzZn = parcelRequire("7QzZn");

var $fabdk = parcelRequire("fabdk");
function $db1dd3c66a0cbf94$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $aE6k7.default)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $fabdk.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain(), i0 = 0, i1 = d.length - 1, start = d[i0], stop = d[i1], step;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        step = (0, $aE6k7.tickIncrement)(start, stop, count);
        if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
            step = (0, $aE6k7.tickIncrement)(start, stop, count);
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
            step = (0, $aE6k7.tickIncrement)(start, stop, count);
        }
        if (step > 0) {
            d[i0] = Math.floor(start / step) * step;
            d[i1] = Math.ceil(stop / step) * step;
            domain(d);
        } else if (step < 0) {
            d[i0] = Math.ceil(start * step) / step;
            d[i1] = Math.floor(stop * step) / step;
            domain(d);
        }
        return scale;
    };
    return scale;
}
function $db1dd3c66a0cbf94$export$2e2bcd8739ae039() {
    var scale = (0, $f6dVf.default)((0, $f6dVf.identity), (0, $f6dVf.identity));
    scale.copy = function() {
        return (0, $f6dVf.copy)(scale, $db1dd3c66a0cbf94$export$2e2bcd8739ae039());
    };
    (0, $7QzZn.initRange).apply(scale, arguments);
    return $db1dd3c66a0cbf94$export$16a5d4b4a61a274d(scale);
}

});
parcelRegister("f6dVf", function(module, exports) {

$parcel$export(module.exports, "identity", () => $afe237385175446a$export$f0954fd7d5368655);
$parcel$export(module.exports, "copy", () => $afe237385175446a$export$784d13d8ee351f07);
$parcel$export(module.exports, "transformer", () => $afe237385175446a$export$6b468dcfb64c653c);
$parcel$export(module.exports, "default", () => $afe237385175446a$export$2e2bcd8739ae039);
parcelRequire("b6jkW");
var $ekiL6 = parcelRequire("ekiL6");

var $bi4KR = parcelRequire("bi4KR");
var $gnkFs = parcelRequire("gnkFs");
var $gzbhl = parcelRequire("gzbhl");

var $akaTP = parcelRequire("akaTP");

var $ePWrs = parcelRequire("ePWrs");

var $9krIo = parcelRequire("9krIo");
var $afe237385175446a$var$unit = [
    0,
    1
];
function $afe237385175446a$export$f0954fd7d5368655(x) {
    return x;
}
function $afe237385175446a$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $ePWrs.default)(isNaN(b) ? NaN : 0.5);
}
function $afe237385175446a$var$clamper(domain) {
    var a = domain[0], b = domain[domain.length - 1], t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $afe237385175446a$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $afe237385175446a$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $afe237385175446a$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $afe237385175446a$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $afe237385175446a$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $ekiL6.default)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $afe237385175446a$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $afe237385175446a$export$6b468dcfb64c653c() {
    var domain = $afe237385175446a$var$unit, range = $afe237385175446a$var$unit, interpolate = (0, $bi4KR.default), transform, untransform, unknown, clamp = $afe237385175446a$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        piecewise = Math.min(domain.length, range.length) > 2 ? $afe237385175446a$var$polymap : $afe237385175446a$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $gnkFs.default))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = (0, $akaTP.map).call(_, (0, $9krIo.default)), clamp === $afe237385175446a$export$f0954fd7d5368655 || (clamp = $afe237385175446a$var$clamper(domain)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, $akaTP.slice).call(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = (0, $akaTP.slice).call(_), interpolate = (0, $gzbhl.default), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? $afe237385175446a$var$clamper(domain) : $afe237385175446a$export$f0954fd7d5368655, scale) : clamp !== $afe237385175446a$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $afe237385175446a$export$2e2bcd8739ae039(transform, untransform) {
    return $afe237385175446a$export$6b468dcfb64c653c()(transform, untransform);
}

});
parcelRegister("gzbhl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0f8a9efb1caa699$export$2e2bcd8739ae039);
function $c0f8a9efb1caa699$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("ePWrs", function(module, exports) {

$parcel$export(module.exports, "default", () => $acd329741cbdf381$export$2e2bcd8739ae039);
function $acd329741cbdf381$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("9krIo", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cab7aea8ef8b40b$export$2e2bcd8739ae039);
function $6cab7aea8ef8b40b$export$2e2bcd8739ae039(x) {
    return +x;
}

});


parcelRegister("fabdk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0a07d06c8b316c1$export$2e2bcd8739ae039);
parcelRequire("b6jkW");
var $aE6k7 = parcelRequire("aE6k7");

var $7gBNf = parcelRequire("7gBNf");
var $ikvwP = parcelRequire("ikvwP");
var $l1vM3 = parcelRequire("l1vM3");
var $1TXup = parcelRequire("1TXup");
var $i4t6x = parcelRequire("i4t6x");
function $b0a07d06c8b316c1$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $aE6k7.tickStep)(start, stop, count), precision;
    specifier = (0, $ikvwP.default)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $1TXup.default)(step, value))) specifier.precision = precision;
            return (0, $7gBNf.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $i4t6x.default)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $l1vM3.default)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $7gBNf.format)(specifier);
}

});
parcelRegister("7gBNf", function(module, exports) {

$parcel$export(module.exports, "format", () => $54a757fa53542946$export$d9468344d3651243);
$parcel$export(module.exports, "formatPrefix", () => $54a757fa53542946$export$8d85692a469dde6f);

var $jYBVj = parcelRequire("jYBVj");
var $54a757fa53542946$var$locale;
var $54a757fa53542946$export$d9468344d3651243;
var $54a757fa53542946$export$8d85692a469dde6f;
$54a757fa53542946$export$2e2bcd8739ae039({
    decimal: ".",
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ],
    minus: "-"
});
function $54a757fa53542946$export$2e2bcd8739ae039(definition) {
    $54a757fa53542946$var$locale = (0, $jYBVj.default)(definition);
    $54a757fa53542946$export$d9468344d3651243 = $54a757fa53542946$var$locale.format;
    $54a757fa53542946$export$8d85692a469dde6f = $54a757fa53542946$var$locale.formatPrefix;
    return $54a757fa53542946$var$locale;
}

});
parcelRegister("jYBVj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8b109bb95cf9845$export$2e2bcd8739ae039);

var $1QDsO = parcelRequire("1QDsO");

var $l0OJc = parcelRequire("l0OJc");

var $cRZ1i = parcelRequire("cRZ1i");

var $ikvwP = parcelRequire("ikvwP");

var $j0yhO = parcelRequire("j0yhO");

var $kGAxb = parcelRequire("kGAxb");

var $lPyuV = parcelRequire("lPyuV");

var $2nOSB = parcelRequire("2nOSB");
var $e8b109bb95cf9845$var$map = Array.prototype.map, $e8b109bb95cf9845$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $e8b109bb95cf9845$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $2nOSB.default) : (0, $l0OJc.default)($e8b109bb95cf9845$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $2nOSB.default) : (0, $cRZ1i.default)($e8b109bb95cf9845$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "-" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $ikvwP.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $kGAxb.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $kGAxb.default)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $j0yhO.default)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $e8b109bb95cf9845$var$prefixes[8 + (0, $lPyuV.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $ikvwP.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $1QDsO.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $e8b109bb95cf9845$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("1QDsO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1589426e0436f502$export$2e2bcd8739ae039);

var $1fLhe = parcelRequire("1fLhe");
function $1589426e0436f502$export$2e2bcd8739ae039(x) {
    return x = (0, $1fLhe.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("1fLhe", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e9bdd5fefd6a5f6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "formatDecimalParts", () => $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5);
function $0e9bdd5fefd6a5f6$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("l0OJc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4c0f29ad920aaa1$export$2e2bcd8739ae039);
function $f4c0f29ad920aaa1$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("cRZ1i", function(module, exports) {

$parcel$export(module.exports, "default", () => $95e9c493347f9308$export$2e2bcd8739ae039);
function $95e9c493347f9308$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("ikvwP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5828d241e6c1f75$export$2e2bcd8739ae039);
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $d5828d241e6c1f75$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $d5828d241e6c1f75$export$2e2bcd8739ae039(specifier) {
    if (!(match = $d5828d241e6c1f75$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $d5828d241e6c1f75$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$d5828d241e6c1f75$export$2e2bcd8739ae039.prototype = $d5828d241e6c1f75$export$963aac351db36ed4.prototype; // instanceof
function $d5828d241e6c1f75$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$d5828d241e6c1f75$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("j0yhO", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd689cef4c920567$export$2e2bcd8739ae039);
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $dd689cef4c920567$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("kGAxb", function(module, exports) {

$parcel$export(module.exports, "default", () => $03e2e7837f70dba5$export$2e2bcd8739ae039);

var $1fLhe = parcelRequire("1fLhe");

var $lPyuV = parcelRequire("lPyuV");

var $5YhaN = parcelRequire("5YhaN");
var $03e2e7837f70dba5$export$2e2bcd8739ae039 = {
    "%": function(x, p) {
        return (x * 100).toFixed(p);
    },
    "b": function(x) {
        return Math.round(x).toString(2);
    },
    "c": function(x) {
        return x + "";
    },
    "d": (0, $1fLhe.default),
    "e": function(x, p) {
        return x.toExponential(p);
    },
    "f": function(x, p) {
        return x.toFixed(p);
    },
    "g": function(x, p) {
        return x.toPrecision(p);
    },
    "o": function(x) {
        return Math.round(x).toString(8);
    },
    "p": function(x, p) {
        return (0, $5YhaN.default)(x * 100, p);
    },
    "r": (0, $5YhaN.default),
    "s": (0, $lPyuV.default),
    "X": function(x) {
        return Math.round(x).toString(16).toUpperCase();
    },
    "x": function(x) {
        return Math.round(x).toString(16);
    }
};

});
parcelRegister("lPyuV", function(module, exports) {

$parcel$export(module.exports, "prefixExponent", () => $fe491ef31c379765$export$6863724d9a42263);
$parcel$export(module.exports, "default", () => $fe491ef31c379765$export$2e2bcd8739ae039);

var $1fLhe = parcelRequire("1fLhe");
var $fe491ef31c379765$export$6863724d9a42263;
function $fe491ef31c379765$export$2e2bcd8739ae039(x, p) {
    var d = (0, $1fLhe.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($fe491ef31c379765$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $1fLhe.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("5YhaN", function(module, exports) {

$parcel$export(module.exports, "default", () => $458fe095863893c0$export$2e2bcd8739ae039);

var $1fLhe = parcelRequire("1fLhe");
function $458fe095863893c0$export$2e2bcd8739ae039(x, p) {
    var d = (0, $1fLhe.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("2nOSB", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bc532601db445af$export$2e2bcd8739ae039);
function $1bc532601db445af$export$2e2bcd8739ae039(x) {
    return x;
}

});



parcelRegister("l1vM3", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4e256a3cb9c44da$export$2e2bcd8739ae039);

var $1QDsO = parcelRequire("1QDsO");
function $f4e256a3cb9c44da$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $1QDsO.default)(Math.abs(step)));
}

});

parcelRegister("1TXup", function(module, exports) {

$parcel$export(module.exports, "default", () => $162912dc121d0934$export$2e2bcd8739ae039);

var $1QDsO = parcelRequire("1QDsO");
function $162912dc121d0934$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $1QDsO.default)(value) / 3))) * 3 - (0, $1QDsO.default)(Math.abs(step)));
}

});

parcelRegister("i4t6x", function(module, exports) {

$parcel$export(module.exports, "default", () => $d27f2d3c2137f747$export$2e2bcd8739ae039);

var $1QDsO = parcelRequire("1QDsO");
function $d27f2d3c2137f747$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $1QDsO.default)(max) - (0, $1QDsO.default)(step)) + 1;
}

});




parcelRegister("7TrsU", function(module, exports) {

$parcel$export(module.exports, "loggish", () => $5bf2f979a0299157$export$860836db074028f0);
$parcel$export(module.exports, "default", () => $5bf2f979a0299157$export$2e2bcd8739ae039);
parcelRequire("b6jkW");
var $aE6k7 = parcelRequire("aE6k7");

var $7gBNf = parcelRequire("7gBNf");

var $13gv1 = parcelRequire("13gv1");

var $f6dVf = parcelRequire("f6dVf");

var $7QzZn = parcelRequire("7QzZn");
function $5bf2f979a0299157$var$transformLog(x) {
    return Math.log(x);
}
function $5bf2f979a0299157$var$transformExp(x) {
    return Math.exp(x);
}
function $5bf2f979a0299157$var$transformLogn(x) {
    return -Math.log(-x);
}
function $5bf2f979a0299157$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $5bf2f979a0299157$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $5bf2f979a0299157$var$powp(base) {
    return base === 10 ? $5bf2f979a0299157$var$pow10 : base === Math.E ? Math.exp : function(x) {
        return Math.pow(base, x);
    };
}
function $5bf2f979a0299157$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function(x) {
        return Math.log(x) / base;
    });
}
function $5bf2f979a0299157$var$reflect(f) {
    return function(x) {
        return -f(-x);
    };
}
function $5bf2f979a0299157$export$860836db074028f0(transform) {
    var scale = transform($5bf2f979a0299157$var$transformLog, $5bf2f979a0299157$var$transformExp), domain = scale.domain, base = 10, logs, pows;
    function rescale() {
        logs = $5bf2f979a0299157$var$logp(base), pows = $5bf2f979a0299157$var$powp(base);
        if (domain()[0] < 0) {
            logs = $5bf2f979a0299157$var$reflect(logs), pows = $5bf2f979a0299157$var$reflect(pows);
            transform($5bf2f979a0299157$var$transformLogn, $5bf2f979a0299157$var$transformExpn);
        } else transform($5bf2f979a0299157$var$transformLog, $5bf2f979a0299157$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = function(count) {
        var d = domain(), u = d[0], v = d[d.length - 1], r;
        if (r = v < u) i = u, u = v, v = i;
        var i = logs(u), j = logs(v), p, k, t, n = count == null ? 10 : +count, z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.round(i) - 1, j = Math.round(j) + 1;
            if (u > 0) for(; i < j; ++i)for(k = 1, p = pows(i); k < base; ++k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i < j; ++i)for(k = base - 1, p = pows(i); k >= 1; --k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
        } else z = (0, $aE6k7.default)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = function(count, specifier) {
        if (specifier == null) specifier = base === 10 ? ".0e" : ",";
        if (typeof specifier !== "function") specifier = (0, $7gBNf.format)(specifier);
        if (count === Infinity) return specifier;
        if (count == null) count = 10;
        var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return function(d) {
            var i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = function() {
        return domain((0, $13gv1.default)(domain(), {
            floor: function(x) {
                return pows(Math.floor(logs(x)));
            },
            ceil: function(x) {
                return pows(Math.ceil(logs(x)));
            }
        }));
    };
    return scale;
}
function $5bf2f979a0299157$export$2e2bcd8739ae039() {
    var scale = $5bf2f979a0299157$export$860836db074028f0((0, $f6dVf.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $f6dVf.copy)(scale, $5bf2f979a0299157$export$2e2bcd8739ae039()).base(scale.base());
    };
    (0, $7QzZn.initRange).apply(scale, arguments);
    return scale;
}

});
parcelRegister("13gv1", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c42deabcdb569d9$export$2e2bcd8739ae039);
function $0c42deabcdb569d9$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("ht0x4", function(module, exports) {

$parcel$export(module.exports, "symlogish", () => $cb758ed0dff37844$export$4602684e614eba38);
$parcel$export(module.exports, "default", () => $cb758ed0dff37844$export$2e2bcd8739ae039);

var $iOlPi = parcelRequire("iOlPi");

var $f6dVf = parcelRequire("f6dVf");

var $7QzZn = parcelRequire("7QzZn");
function $cb758ed0dff37844$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $cb758ed0dff37844$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $cb758ed0dff37844$export$4602684e614eba38(transform) {
    var c = 1, scale = transform($cb758ed0dff37844$var$transformSymlog(c), $cb758ed0dff37844$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($cb758ed0dff37844$var$transformSymlog(c = +_), $cb758ed0dff37844$var$transformSymexp(c)) : c;
    };
    return (0, $iOlPi.linearish)(scale);
}
function $cb758ed0dff37844$export$2e2bcd8739ae039() {
    var scale = $cb758ed0dff37844$export$4602684e614eba38((0, $f6dVf.transformer)());
    scale.copy = function() {
        return (0, $f6dVf.copy)(scale, $cb758ed0dff37844$export$2e2bcd8739ae039()).constant(scale.constant());
    };
    return (0, $7QzZn.initRange).apply(scale, arguments);
}

});

parcelRegister("iFFhE", function(module, exports) {

$parcel$export(module.exports, "powish", () => $d97c146f4f811488$export$34695211ec403a46);

var $iOlPi = parcelRequire("iOlPi");

var $f6dVf = parcelRequire("f6dVf");

var $7QzZn = parcelRequire("7QzZn");
function $d97c146f4f811488$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $d97c146f4f811488$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $d97c146f4f811488$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $d97c146f4f811488$export$34695211ec403a46(transform) {
    var scale = transform((0, $f6dVf.identity), (0, $f6dVf.identity)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $f6dVf.identity), (0, $f6dVf.identity)) : exponent === 0.5 ? transform($d97c146f4f811488$var$transformSqrt, $d97c146f4f811488$var$transformSquare) : transform($d97c146f4f811488$var$transformPow(exponent), $d97c146f4f811488$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $iOlPi.linearish)(scale);
}
function $d97c146f4f811488$export$2e2bcd8739ae039() {
    var scale = $d97c146f4f811488$export$34695211ec403a46((0, $f6dVf.transformer)());
    scale.copy = function() {
        return (0, $f6dVf.copy)(scale, $d97c146f4f811488$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $7QzZn.initRange).apply(scale, arguments);
    return scale;
}
function $d97c146f4f811488$export$eba8049fb5020b81() {
    return $d97c146f4f811488$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("cTbvO", function(module, exports) {
parcelRequire("b6jkW");
var $8zdji = parcelRequire("8zdji");
var $ekiL6 = parcelRequire("ekiL6");
var $30TGf = parcelRequire("30TGf");

var $akaTP = parcelRequire("akaTP");

var $7QzZn = parcelRequire("7QzZn");
function $96238d247b54f1ee$export$2e2bcd8739ae039() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $30TGf.default)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return isNaN(x = +x) ? unknown : range[(0, $ekiL6.default)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for(var i = 0, n = _.length, d; i < n; ++i)if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $8zdji.default));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, $akaTP.slice).call(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $96238d247b54f1ee$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $7QzZn.initRange).apply(scale, arguments);
}

});

parcelRegister("ekSyn", function(module, exports) {
parcelRequire("b6jkW");
var $ekiL6 = parcelRequire("ekiL6");

var $akaTP = parcelRequire("akaTP");

var $iOlPi = parcelRequire("iOlPi");

var $7QzZn = parcelRequire("7QzZn");
function $a6fd4026648153e5$export$2e2bcd8739ae039() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x <= x ? range[(0, $ekiL6.default)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = (0, $akaTP.slice).call(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $a6fd4026648153e5$export$2e2bcd8739ae039().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, $7QzZn.initRange).apply((0, $iOlPi.linearish)(scale), arguments);
}

});

parcelRegister("b1bfu", function(module, exports) {
parcelRequire("b6jkW");
var $ekiL6 = parcelRequire("ekiL6");

var $akaTP = parcelRequire("akaTP");

var $7QzZn = parcelRequire("7QzZn");
function $8058838348a44fed$export$2e2bcd8739ae039() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x <= x ? range[(0, $ekiL6.default)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = (0, $akaTP.slice).call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, $akaTP.slice).call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $8058838348a44fed$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $7QzZn.initRange).apply(scale, arguments);
}

});

parcelRegister("48U7R", function(module, exports) {

$parcel$export(module.exports, "calendar", () => $304372357472b2a4$export$56bbcdb8aca31149);
$parcel$export(module.exports, "default", () => $304372357472b2a4$export$2e2bcd8739ae039);
parcelRequire("b6jkW");
var $W4CTv = parcelRequire("W4CTv");
var $aE6k7 = parcelRequire("aE6k7");

var $72rFk = parcelRequire("72rFk");
var $cKbL9 = parcelRequire("cKbL9");
var $asZKP = parcelRequire("asZKP");
var $3wXBo = parcelRequire("3wXBo");
var $gyimR = parcelRequire("gyimR");
var $6gR0W = parcelRequire("6gR0W");
var $aW15j = parcelRequire("aW15j");
var $j0Fj9 = parcelRequire("j0Fj9");

var $UutV9 = parcelRequire("UutV9");

var $akaTP = parcelRequire("akaTP");

var $f6dVf = parcelRequire("f6dVf");

var $7QzZn = parcelRequire("7QzZn");

var $13gv1 = parcelRequire("13gv1");
var $304372357472b2a4$var$durationSecond = 1000, $304372357472b2a4$var$durationMinute = $304372357472b2a4$var$durationSecond * 60, $304372357472b2a4$var$durationHour = $304372357472b2a4$var$durationMinute * 60, $304372357472b2a4$var$durationDay = $304372357472b2a4$var$durationHour * 24, $304372357472b2a4$var$durationWeek = $304372357472b2a4$var$durationDay * 7, $304372357472b2a4$var$durationMonth = $304372357472b2a4$var$durationDay * 30, $304372357472b2a4$var$durationYear = $304372357472b2a4$var$durationDay * 365;
function $304372357472b2a4$var$date(t) {
    return new Date(t);
}
function $304372357472b2a4$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $304372357472b2a4$export$56bbcdb8aca31149(year, month, week, day, hour, minute, second, millisecond, format) {
    var scale = (0, $f6dVf.default)((0, $f6dVf.identity), (0, $f6dVf.identity)), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    var tickIntervals = [
        [
            second,
            1,
            $304372357472b2a4$var$durationSecond
        ],
        [
            second,
            5,
            5 * $304372357472b2a4$var$durationSecond
        ],
        [
            second,
            15,
            15 * $304372357472b2a4$var$durationSecond
        ],
        [
            second,
            30,
            30 * $304372357472b2a4$var$durationSecond
        ],
        [
            minute,
            1,
            $304372357472b2a4$var$durationMinute
        ],
        [
            minute,
            5,
            5 * $304372357472b2a4$var$durationMinute
        ],
        [
            minute,
            15,
            15 * $304372357472b2a4$var$durationMinute
        ],
        [
            minute,
            30,
            30 * $304372357472b2a4$var$durationMinute
        ],
        [
            hour,
            1,
            $304372357472b2a4$var$durationHour
        ],
        [
            hour,
            3,
            3 * $304372357472b2a4$var$durationHour
        ],
        [
            hour,
            6,
            6 * $304372357472b2a4$var$durationHour
        ],
        [
            hour,
            12,
            12 * $304372357472b2a4$var$durationHour
        ],
        [
            day,
            1,
            $304372357472b2a4$var$durationDay
        ],
        [
            day,
            2,
            2 * $304372357472b2a4$var$durationDay
        ],
        [
            week,
            1,
            $304372357472b2a4$var$durationWeek
        ],
        [
            month,
            1,
            $304372357472b2a4$var$durationMonth
        ],
        [
            month,
            3,
            3 * $304372357472b2a4$var$durationMonth
        ],
        [
            year,
            1,
            $304372357472b2a4$var$durationYear
        ]
    ];
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    function tickInterval(interval, start, stop, step) {
        if (interval == null) interval = 10;
        // If a desired tick count is specified, pick a reasonable tick interval
        // based on the extent of the domain and a rough estimate of tick size.
        // Otherwise, assume interval is already a time interval and use it.
        if (typeof interval === "number") {
            var target = Math.abs(stop - start) / interval, i = (0, $W4CTv.default)(function(i) {
                return i[2];
            }).right(tickIntervals, target);
            if (i === tickIntervals.length) {
                step = (0, $aE6k7.tickStep)(start / $304372357472b2a4$var$durationYear, stop / $304372357472b2a4$var$durationYear, interval);
                interval = year;
            } else if (i) {
                i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
                step = i[1];
                interval = i[0];
            } else {
                step = Math.max((0, $aE6k7.tickStep)(start, stop, interval), 1);
                interval = millisecond;
            }
        }
        return step == null ? interval : interval.every(step);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain((0, $akaTP.map).call(_, $304372357472b2a4$var$number)) : domain().map($304372357472b2a4$var$date);
    };
    scale.ticks = function(interval, step) {
        var d = domain(), t0 = d[0], t1 = d[d.length - 1], r = t1 < t0, t;
        if (r) t = t0, t0 = t1, t1 = t;
        t = tickInterval(interval, t0, t1, step);
        t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
        return r ? t.reverse() : t;
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval, step) {
        var d = domain();
        return (interval = tickInterval(interval, d[0], d[d.length - 1], step)) ? domain((0, $13gv1.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $f6dVf.copy)(scale, $304372357472b2a4$export$56bbcdb8aca31149(year, month, week, day, hour, minute, second, millisecond, format));
    };
    return scale;
}
function $304372357472b2a4$export$2e2bcd8739ae039() {
    return (0, $7QzZn.initRange).apply($304372357472b2a4$export$56bbcdb8aca31149((0, $j0Fj9.default), (0, $gyimR.default), (0, $aW15j.sunday), (0, $72rFk.default), (0, $cKbL9.default), (0, $3wXBo.default), (0, $6gR0W.default), (0, $asZKP.default), (0, $UutV9.timeFormat)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("cKbL9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9472e71f07850dab$export$2e2bcd8739ae039);

var $kOu3f = parcelRequire("kOu3f");

var $dXf4A = parcelRequire("dXf4A");
var $9472e71f07850dab$var$hour = (0, $kOu3f.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $dXf4A.durationSecond) - date.getMinutes() * (0, $dXf4A.durationMinute));
}, function(date, step) {
    date.setTime(+date + step * (0, $dXf4A.durationHour));
}, function(start, end) {
    return (end - start) / (0, $dXf4A.durationHour);
}, function(date) {
    return date.getHours();
});
var $9472e71f07850dab$export$2e2bcd8739ae039 = $9472e71f07850dab$var$hour;
var $9472e71f07850dab$export$8d468796d69cdad1 = $9472e71f07850dab$var$hour.range;

});

parcelRegister("asZKP", function(module, exports) {

$parcel$export(module.exports, "default", () => $79ec6c01997bf022$export$2e2bcd8739ae039);

var $kOu3f = parcelRequire("kOu3f");
var $79ec6c01997bf022$var$millisecond = (0, $kOu3f.default)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
$79ec6c01997bf022$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $79ec6c01997bf022$var$millisecond;
    return (0, $kOu3f.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $79ec6c01997bf022$export$2e2bcd8739ae039 = $79ec6c01997bf022$var$millisecond;
var $79ec6c01997bf022$export$9a27fac83d67afd3 = $79ec6c01997bf022$var$millisecond.range;

});

parcelRegister("3wXBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $292297f992a3b17e$export$2e2bcd8739ae039);

var $kOu3f = parcelRequire("kOu3f");

var $dXf4A = parcelRequire("dXf4A");
var $292297f992a3b17e$var$minute = (0, $kOu3f.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $dXf4A.durationSecond));
}, function(date, step) {
    date.setTime(+date + step * (0, $dXf4A.durationMinute));
}, function(start, end) {
    return (end - start) / (0, $dXf4A.durationMinute);
}, function(date) {
    return date.getMinutes();
});
var $292297f992a3b17e$export$2e2bcd8739ae039 = $292297f992a3b17e$var$minute;
var $292297f992a3b17e$export$666252b437cce0c7 = $292297f992a3b17e$var$minute.range;

});

parcelRegister("gyimR", function(module, exports) {

$parcel$export(module.exports, "default", () => $031c190f93ea3efa$export$2e2bcd8739ae039);

var $kOu3f = parcelRequire("kOu3f");
var $031c190f93ea3efa$var$month = (0, $kOu3f.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $031c190f93ea3efa$export$2e2bcd8739ae039 = $031c190f93ea3efa$var$month;
var $031c190f93ea3efa$export$16352d1b10c5eb38 = $031c190f93ea3efa$var$month.range;

});

parcelRegister("6gR0W", function(module, exports) {

$parcel$export(module.exports, "default", () => $490d5c36270b8fcb$export$2e2bcd8739ae039);

var $kOu3f = parcelRequire("kOu3f");

var $dXf4A = parcelRequire("dXf4A");
var $490d5c36270b8fcb$var$second = (0, $kOu3f.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * (0, $dXf4A.durationSecond));
}, function(start, end) {
    return (end - start) / (0, $dXf4A.durationSecond);
}, function(date) {
    return date.getUTCSeconds();
});
var $490d5c36270b8fcb$export$2e2bcd8739ae039 = $490d5c36270b8fcb$var$second;
var $490d5c36270b8fcb$export$4792e48abc550fa1 = $490d5c36270b8fcb$var$second.range;

});


parcelRegister("l1Ebe", function(module, exports) {

var $48U7R = parcelRequire("48U7R");

var $UutV9 = parcelRequire("UutV9");

var $2CWR6 = parcelRequire("2CWR6");
var $30pPt = parcelRequire("30pPt");
var $asZKP = parcelRequire("asZKP");
var $8Th7U = parcelRequire("8Th7U");
var $ck0WF = parcelRequire("ck0WF");
var $6gR0W = parcelRequire("6gR0W");
var $9DXjR = parcelRequire("9DXjR");
var $daOr3 = parcelRequire("daOr3");

var $7QzZn = parcelRequire("7QzZn");
function $f4e8dbe80a3143de$export$2e2bcd8739ae039() {
    return (0, $7QzZn.initRange).apply((0, $48U7R.calendar)((0, $daOr3.default), (0, $ck0WF.default), (0, $9DXjR.utcSunday), (0, $2CWR6.default), (0, $30pPt.default), (0, $8Th7U.default), (0, $6gR0W.default), (0, $asZKP.default), (0, $UutV9.utcFormat)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("30pPt", function(module, exports) {

$parcel$export(module.exports, "default", () => $2305685918ef6fca$export$2e2bcd8739ae039);

var $kOu3f = parcelRequire("kOu3f");

var $dXf4A = parcelRequire("dXf4A");
var $2305685918ef6fca$var$utcHour = (0, $kOu3f.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $dXf4A.durationHour));
}, function(start, end) {
    return (end - start) / (0, $dXf4A.durationHour);
}, function(date) {
    return date.getUTCHours();
});
var $2305685918ef6fca$export$2e2bcd8739ae039 = $2305685918ef6fca$var$utcHour;
var $2305685918ef6fca$export$6e7a76cd5f50b719 = $2305685918ef6fca$var$utcHour.range;

});

parcelRegister("8Th7U", function(module, exports) {

$parcel$export(module.exports, "default", () => $6790bec6cda46448$export$2e2bcd8739ae039);

var $kOu3f = parcelRequire("kOu3f");

var $dXf4A = parcelRequire("dXf4A");
var $6790bec6cda46448$var$utcMinute = (0, $kOu3f.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $dXf4A.durationMinute));
}, function(start, end) {
    return (end - start) / (0, $dXf4A.durationMinute);
}, function(date) {
    return date.getUTCMinutes();
});
var $6790bec6cda46448$export$2e2bcd8739ae039 = $6790bec6cda46448$var$utcMinute;
var $6790bec6cda46448$export$cedd563624e8ee50 = $6790bec6cda46448$var$utcMinute.range;

});

parcelRegister("ck0WF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f8815fab2435516$export$2e2bcd8739ae039);

var $kOu3f = parcelRequire("kOu3f");
var $8f8815fab2435516$var$utcMonth = (0, $kOu3f.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $8f8815fab2435516$export$2e2bcd8739ae039 = $8f8815fab2435516$var$utcMonth;
var $8f8815fab2435516$export$49159f585997498 = $8f8815fab2435516$var$utcMonth.range;

});


parcelRegister("lrv5b", function(module, exports) {

$parcel$export(module.exports, "copy", () => $f9c43af42f8b19e4$export$784d13d8ee351f07);

var $f6dVf = parcelRequire("f6dVf");

var $7QzZn = parcelRequire("7QzZn");

var $iOlPi = parcelRequire("iOlPi");

var $7TrsU = parcelRequire("7TrsU");

var $ht0x4 = parcelRequire("ht0x4");

var $iFFhE = parcelRequire("iFFhE");
function $f9c43af42f8b19e4$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, $f6dVf.identity), clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $f9c43af42f8b19e4$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $f9c43af42f8b19e4$export$2e2bcd8739ae039() {
    var scale = (0, $iOlPi.linearish)($f9c43af42f8b19e4$var$transformer()((0, $f6dVf.identity)));
    scale.copy = function() {
        return $f9c43af42f8b19e4$export$784d13d8ee351f07(scale, $f9c43af42f8b19e4$export$2e2bcd8739ae039());
    };
    return (0, $7QzZn.initInterpolator).apply(scale, arguments);
}
function $f9c43af42f8b19e4$export$6843e08bf2ff981f() {
    var scale = (0, $7TrsU.loggish)($f9c43af42f8b19e4$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $f9c43af42f8b19e4$export$784d13d8ee351f07(scale, $f9c43af42f8b19e4$export$6843e08bf2ff981f()).base(scale.base());
    };
    return (0, $7QzZn.initInterpolator).apply(scale, arguments);
}
function $f9c43af42f8b19e4$export$9d4af4de62c81941() {
    var scale = (0, $ht0x4.symlogish)($f9c43af42f8b19e4$var$transformer());
    scale.copy = function() {
        return $f9c43af42f8b19e4$export$784d13d8ee351f07(scale, $f9c43af42f8b19e4$export$9d4af4de62c81941()).constant(scale.constant());
    };
    return (0, $7QzZn.initInterpolator).apply(scale, arguments);
}
function $f9c43af42f8b19e4$export$de9f78581b4f2405() {
    var scale = (0, $iFFhE.powish)($f9c43af42f8b19e4$var$transformer());
    scale.copy = function() {
        return $f9c43af42f8b19e4$export$784d13d8ee351f07(scale, $f9c43af42f8b19e4$export$de9f78581b4f2405()).exponent(scale.exponent());
    };
    return (0, $7QzZn.initInterpolator).apply(scale, arguments);
}
function $f9c43af42f8b19e4$export$413d935127ed466e() {
    return $f9c43af42f8b19e4$export$de9f78581b4f2405.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("77K6z", function(module, exports) {
parcelRequire("b6jkW");
var $8zdji = parcelRequire("8zdji");
var $ekiL6 = parcelRequire("ekiL6");

var $f6dVf = parcelRequire("f6dVf");

var $7QzZn = parcelRequire("7QzZn");
function $52fcf35202383c14$export$2e2bcd8739ae039() {
    var domain = [], interpolator = (0, $f6dVf.identity);
    function scale(x) {
        if (!isNaN(x = +x)) return interpolator(((0, $ekiL6.default)(domain, x) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for(var i = 0, n = _.length, d; i < n; ++i)if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $8zdji.default));
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.copy = function() {
        return $52fcf35202383c14$export$2e2bcd8739ae039(interpolator).domain(domain);
    };
    return (0, $7QzZn.initInterpolator).apply(scale, arguments);
}

});

parcelRegister("2dSUq", function(module, exports) {

var $f6dVf = parcelRequire("f6dVf");

var $7QzZn = parcelRequire("7QzZn");

var $iOlPi = parcelRequire("iOlPi");

var $7TrsU = parcelRequire("7TrsU");

var $lrv5b = parcelRequire("lrv5b");

var $ht0x4 = parcelRequire("ht0x4");

var $iFFhE = parcelRequire("iFFhE");
function $19e76371916c670d$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, t0, t1, t2, k10, k21, interpolator = (0, $f6dVf.identity), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (x < t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), t2 = transform(x2 = +_[2]), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1);
        return scale;
    };
}
function $19e76371916c670d$export$2e2bcd8739ae039() {
    var scale = (0, $iOlPi.linearish)($19e76371916c670d$var$transformer()((0, $f6dVf.identity)));
    scale.copy = function() {
        return (0, $lrv5b.copy)(scale, $19e76371916c670d$export$2e2bcd8739ae039());
    };
    return (0, $7QzZn.initInterpolator).apply(scale, arguments);
}
function $19e76371916c670d$export$5f0266a9159c47fb() {
    var scale = (0, $7TrsU.loggish)($19e76371916c670d$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $lrv5b.copy)(scale, $19e76371916c670d$export$5f0266a9159c47fb()).base(scale.base());
    };
    return (0, $7QzZn.initInterpolator).apply(scale, arguments);
}
function $19e76371916c670d$export$50b3da713cf557c6() {
    var scale = (0, $ht0x4.symlogish)($19e76371916c670d$var$transformer());
    scale.copy = function() {
        return (0, $lrv5b.copy)(scale, $19e76371916c670d$export$50b3da713cf557c6()).constant(scale.constant());
    };
    return (0, $7QzZn.initInterpolator).apply(scale, arguments);
}
function $19e76371916c670d$export$d6cedcc63bf26e7e() {
    var scale = (0, $iFFhE.powish)($19e76371916c670d$var$transformer());
    scale.copy = function() {
        return (0, $lrv5b.copy)(scale, $19e76371916c670d$export$d6cedcc63bf26e7e()).exponent(scale.exponent());
    };
    return (0, $7QzZn.initInterpolator).apply(scale, arguments);
}
function $19e76371916c670d$export$33ddefb5c4ab9e9c() {
    return $19e76371916c670d$export$d6cedcc63bf26e7e.apply(null, arguments).exponent(0.5);
}

});


parcelRegister("ffiwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b196a0c5210e8c70$export$2e2bcd8739ae039);

var $hl2Bj = parcelRequire("hl2Bj");

var $7HXTO = parcelRequire("7HXTO");

var $kDiOX = parcelRequire("kDiOX");
function $b196a0c5210e8c70$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $b196a0c5210e8c70$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $b196a0c5210e8c70$var$arcStartAngle(d) {
    return d.startAngle;
}
function $b196a0c5210e8c70$var$arcEndAngle(d) {
    return d.endAngle;
}
function $b196a0c5210e8c70$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $b196a0c5210e8c70$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, $kDiOX.epsilon)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $b196a0c5210e8c70$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $kDiOX.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $kDiOX.sqrt)((0, $kDiOX.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $b196a0c5210e8c70$export$2e2bcd8739ae039() {
    var innerRadius = $b196a0c5210e8c70$var$arcInnerRadius, outerRadius = $b196a0c5210e8c70$var$arcOuterRadius, cornerRadius = (0, $7HXTO.default)(0), padRadius = null, startAngle = $b196a0c5210e8c70$var$arcStartAngle, endAngle = $b196a0c5210e8c70$var$arcEndAngle, padAngle = $b196a0c5210e8c70$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, $kDiOX.halfPi), a1 = endAngle.apply(this, arguments) - (0, $kDiOX.halfPi), da = (0, $kDiOX.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $hl2Bj.default)();
        // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r;
        // Is it a point?
        if (!(r1 > (0, $kDiOX.epsilon))) context.moveTo(0, 0);
        else if (da > (0, $kDiOX.tau) - (0, $kDiOX.epsilon)) {
            context.moveTo(r1 * (0, $kDiOX.cos)(a0), r1 * (0, $kDiOX.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > (0, $kDiOX.epsilon)) {
                context.moveTo(r0 * (0, $kDiOX.cos)(a1), r0 * (0, $kDiOX.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, $kDiOX.epsilon) && (padRadius ? +padRadius.apply(this, arguments) : (0, $kDiOX.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $kDiOX.min)((0, $kDiOX.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
            // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > (0, $kDiOX.epsilon)) {
                var p0 = (0, $kDiOX.asin)(rp / r0 * (0, $kDiOX.sin)(ap)), p1 = (0, $kDiOX.asin)(rp / r1 * (0, $kDiOX.sin)(ap));
                if ((da0 -= p0 * 2) > (0, $kDiOX.epsilon)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > (0, $kDiOX.epsilon)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $kDiOX.cos)(a01), y01 = r1 * (0, $kDiOX.sin)(a01), x10 = r0 * (0, $kDiOX.cos)(a10), y10 = r0 * (0, $kDiOX.sin)(a10);
            // Apply rounded corners?
            if (rc > (0, $kDiOX.epsilon)) {
                var x11 = r1 * (0, $kDiOX.cos)(a11), y11 = r1 * (0, $kDiOX.sin)(a11), x00 = r0 * (0, $kDiOX.cos)(a00), y00 = r0 * (0, $kDiOX.sin)(a00), oc;
                // Restrict the corner radius according to the sector angle.
                if (da < (0, $kDiOX.pi) && (oc = $b196a0c5210e8c70$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $kDiOX.sin)((0, $kDiOX.acos)((ax * bx + ay * by) / ((0, $kDiOX.sqrt)(ax * ax + ay * ay) * (0, $kDiOX.sqrt)(bx * bx + by * by))) / 2), lc = (0, $kDiOX.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $kDiOX.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $kDiOX.min)(rc, (r1 - lc) / (kc + 1));
                }
            }
            // Is the sector collapsed to a line?
            if (!(da1 > (0, $kDiOX.epsilon))) context.moveTo(x01, y01);
            else if (rc1 > (0, $kDiOX.epsilon)) {
                t0 = $b196a0c5210e8c70$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $b196a0c5210e8c70$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $kDiOX.atan2)(t0.y01, t0.x01), (0, $kDiOX.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $kDiOX.atan2)(t0.y01, t0.x01), (0, $kDiOX.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $kDiOX.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $kDiOX.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $kDiOX.atan2)(t1.y11, t1.x11), (0, $kDiOX.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
            // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > (0, $kDiOX.epsilon)) || !(da0 > (0, $kDiOX.epsilon))) context.lineTo(x10, y10);
            else if (rc0 > (0, $kDiOX.epsilon)) {
                t0 = $b196a0c5210e8c70$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $b196a0c5210e8c70$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $kDiOX.atan2)(t0.y01, t0.x01), (0, $kDiOX.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $kDiOX.atan2)(t0.y01, t0.x01), (0, $kDiOX.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $kDiOX.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $kDiOX.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $kDiOX.atan2)(t1.y11, t1.x11), (0, $kDiOX.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, $kDiOX.pi) / 2;
        return [
            (0, $kDiOX.cos)(a) * r,
            (0, $kDiOX.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("hl2Bj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9f66a4d1c06b373$export$2e2bcd8739ae039);
var $c9f66a4d1c06b373$var$pi = Math.PI, $c9f66a4d1c06b373$var$tau = 2 * $c9f66a4d1c06b373$var$pi, $c9f66a4d1c06b373$var$epsilon = 1e-6, $c9f66a4d1c06b373$var$tauEpsilon = $c9f66a4d1c06b373$var$tau - $c9f66a4d1c06b373$var$epsilon;
function $c9f66a4d1c06b373$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $c9f66a4d1c06b373$var$path() {
    return new $c9f66a4d1c06b373$var$Path;
}
$c9f66a4d1c06b373$var$Path.prototype = $c9f66a4d1c06b373$var$path.prototype = {
    constructor: $c9f66a4d1c06b373$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $c9f66a4d1c06b373$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $c9f66a4d1c06b373$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($c9f66a4d1c06b373$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $c9f66a4d1c06b373$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $c9f66a4d1c06b373$var$epsilon || Math.abs(this._y1 - y0) > $c9f66a4d1c06b373$var$epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $c9f66a4d1c06b373$var$tau + $c9f66a4d1c06b373$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $c9f66a4d1c06b373$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $c9f66a4d1c06b373$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $c9f66a4d1c06b373$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $c9f66a4d1c06b373$export$2e2bcd8739ae039 = $c9f66a4d1c06b373$var$path;

});

parcelRegister("7HXTO", function(module, exports) {

$parcel$export(module.exports, "default", () => $59cb0344df9474fa$export$2e2bcd8739ae039);
function $59cb0344df9474fa$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("kDiOX", function(module, exports) {

$parcel$export(module.exports, "abs", () => $f0560c970166d25b$export$2335f513bbd82c6d);
$parcel$export(module.exports, "atan2", () => $f0560c970166d25b$export$b8b770ee6a0d9760);
$parcel$export(module.exports, "cos", () => $f0560c970166d25b$export$50d414a77b60d802);
$parcel$export(module.exports, "max", () => $f0560c970166d25b$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $f0560c970166d25b$export$96ec731ed4dcb222);
$parcel$export(module.exports, "sin", () => $f0560c970166d25b$export$5de3937cb4b592ed);
$parcel$export(module.exports, "sqrt", () => $f0560c970166d25b$export$eba8049fb5020b81);
$parcel$export(module.exports, "epsilon", () => $f0560c970166d25b$export$6c421550c66a327d);
$parcel$export(module.exports, "pi", () => $f0560c970166d25b$export$18c7bea995a110f);
$parcel$export(module.exports, "halfPi", () => $f0560c970166d25b$export$e51408a300e8929a);
$parcel$export(module.exports, "tau", () => $f0560c970166d25b$export$a4b4b4d4d776fe92);
$parcel$export(module.exports, "acos", () => $f0560c970166d25b$export$fd6306be3fde5b04);
$parcel$export(module.exports, "asin", () => $f0560c970166d25b$export$41726bdb1fc63f);
var $f0560c970166d25b$export$2335f513bbd82c6d = Math.abs;
var $f0560c970166d25b$export$b8b770ee6a0d9760 = Math.atan2;
var $f0560c970166d25b$export$50d414a77b60d802 = Math.cos;
var $f0560c970166d25b$export$8960430cfd85939f = Math.max;
var $f0560c970166d25b$export$96ec731ed4dcb222 = Math.min;
var $f0560c970166d25b$export$5de3937cb4b592ed = Math.sin;
var $f0560c970166d25b$export$eba8049fb5020b81 = Math.sqrt;
var $f0560c970166d25b$export$6c421550c66a327d = 1e-12;
var $f0560c970166d25b$export$18c7bea995a110f = Math.PI;
var $f0560c970166d25b$export$e51408a300e8929a = $f0560c970166d25b$export$18c7bea995a110f / 2;
var $f0560c970166d25b$export$a4b4b4d4d776fe92 = 2 * $f0560c970166d25b$export$18c7bea995a110f;
function $f0560c970166d25b$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $f0560c970166d25b$export$18c7bea995a110f : Math.acos(x);
}
function $f0560c970166d25b$export$41726bdb1fc63f(x) {
    return x >= 1 ? $f0560c970166d25b$export$e51408a300e8929a : x <= -1 ? -$f0560c970166d25b$export$e51408a300e8929a : Math.asin(x);
}

});


parcelRegister("fEwLW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b654034e6c52569c$export$2e2bcd8739ae039);

var $hl2Bj = parcelRequire("hl2Bj");

var $7HXTO = parcelRequire("7HXTO");

var $gEcf1 = parcelRequire("gEcf1");

var $5ti2H = parcelRequire("5ti2H");

var $kfOCT = parcelRequire("kfOCT");
function $b654034e6c52569c$export$2e2bcd8739ae039() {
    var x0 = (0, $kfOCT.x), x1 = null, y0 = (0, $7HXTO.default)(0), y1 = (0, $kfOCT.y), defined = (0, $7HXTO.default)(true), context = null, curve = (0, $gEcf1.default), output = null;
    function area(data) {
        var i, j, k, n = data.length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $hl2Bj.default)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $5ti2H.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $7HXTO.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("gEcf1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1e9e09d9174b864$export$2e2bcd8739ae039);
function $c1e9e09d9174b864$var$Linear(context) {
    this._context = context;
}
$c1e9e09d9174b864$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $c1e9e09d9174b864$export$2e2bcd8739ae039(context) {
    return new $c1e9e09d9174b864$var$Linear(context);
}

});

parcelRegister("5ti2H", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fbda81220c6ea9c$export$2e2bcd8739ae039);

var $hl2Bj = parcelRequire("hl2Bj");

var $7HXTO = parcelRequire("7HXTO");

var $gEcf1 = parcelRequire("gEcf1");

var $kfOCT = parcelRequire("kfOCT");
function $3fbda81220c6ea9c$export$2e2bcd8739ae039() {
    var x = (0, $kfOCT.x), y = (0, $kfOCT.y), defined = (0, $7HXTO.default)(true), context = null, curve = (0, $gEcf1.default), output = null;
    function line(data) {
        var i, n = data.length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $hl2Bj.default)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $7HXTO.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("kfOCT", function(module, exports) {

$parcel$export(module.exports, "x", () => $ebec7ab58e49c436$export$d141bba7fdc215a3);
$parcel$export(module.exports, "y", () => $ebec7ab58e49c436$export$4a5767248b18ef41);
function $ebec7ab58e49c436$export$d141bba7fdc215a3(p) {
    return p[0];
}
function $ebec7ab58e49c436$export$4a5767248b18ef41(p) {
    return p[1];
}

});



parcelRegister("6QL1t", function(module, exports) {

$parcel$export(module.exports, "point", () => $4fcc1327a5d07e55$export$105684a3041cb6f3);
$parcel$export(module.exports, "Basis", () => $4fcc1327a5d07e55$export$957f7263e89bedd2);
$parcel$export(module.exports, "default", () => $4fcc1327a5d07e55$export$2e2bcd8739ae039);
function $4fcc1327a5d07e55$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $4fcc1327a5d07e55$export$957f7263e89bedd2(context) {
    this._context = context;
}
$4fcc1327a5d07e55$export$957f7263e89bedd2.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $4fcc1327a5d07e55$export$105684a3041cb6f3(this, this._x1, this._y1); // proceed
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
            default:
                $4fcc1327a5d07e55$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $4fcc1327a5d07e55$export$2e2bcd8739ae039(context) {
    return new $4fcc1327a5d07e55$export$957f7263e89bedd2(context);
}

});

parcelRegister("2515N", function(module, exports) {

$parcel$export(module.exports, "default", () => $183ce554afe8c6f0$export$2e2bcd8739ae039);

var $9R4F2 = parcelRequire("9R4F2");

var $6QL1t = parcelRequire("6QL1t");
function $183ce554afe8c6f0$var$BasisClosed(context) {
    this._context = context;
}
$183ce554afe8c6f0$var$BasisClosed.prototype = {
    areaStart: (0, $9R4F2.default),
    areaEnd: (0, $9R4F2.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $6QL1t.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $183ce554afe8c6f0$export$2e2bcd8739ae039(context) {
    return new $183ce554afe8c6f0$var$BasisClosed(context);
}

});
parcelRegister("9R4F2", function(module, exports) {

$parcel$export(module.exports, "default", () => $72ccadd7b0a5f010$export$2e2bcd8739ae039);
function $72ccadd7b0a5f010$export$2e2bcd8739ae039() {}

});


parcelRegister("e1bEB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a34a32e088f640bf$export$2e2bcd8739ae039);

var $6QL1t = parcelRequire("6QL1t");
function $a34a32e088f640bf$var$BasisOpen(context) {
    this._context = context;
}
$a34a32e088f640bf$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $6QL1t.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $a34a32e088f640bf$export$2e2bcd8739ae039(context) {
    return new $a34a32e088f640bf$var$BasisOpen(context);
}

});

parcelRegister("l8Mye", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6400194fd6a0bdb$export$2e2bcd8739ae039);

var $6QL1t = parcelRequire("6QL1t");
function $f6400194fd6a0bdb$var$Bundle(context, beta) {
    this._basis = new (0, $6QL1t.Basis)(context);
    this._beta = beta;
}
$f6400194fd6a0bdb$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $f6400194fd6a0bdb$export$2e2bcd8739ae039 = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, $6QL1t.Basis)(context) : new $f6400194fd6a0bdb$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);

});

parcelRegister("hga9n", function(module, exports) {

$parcel$export(module.exports, "point", () => $c90bcdedc71457ea$export$105684a3041cb6f3);
$parcel$export(module.exports, "Cardinal", () => $c90bcdedc71457ea$export$ee51ff373511cbeb);
$parcel$export(module.exports, "default", () => $c90bcdedc71457ea$export$2e2bcd8739ae039);
function $c90bcdedc71457ea$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $c90bcdedc71457ea$export$ee51ff373511cbeb(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$c90bcdedc71457ea$export$ee51ff373511cbeb.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $c90bcdedc71457ea$export$105684a3041cb6f3(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                $c90bcdedc71457ea$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $c90bcdedc71457ea$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $c90bcdedc71457ea$export$ee51ff373511cbeb(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});

parcelRegister("9XrSP", function(module, exports) {

$parcel$export(module.exports, "CardinalClosed", () => $73ff40c99770ef6d$export$da3940d7e9162858);
$parcel$export(module.exports, "default", () => $73ff40c99770ef6d$export$2e2bcd8739ae039);

var $9R4F2 = parcelRequire("9R4F2");

var $hga9n = parcelRequire("hga9n");
function $73ff40c99770ef6d$export$da3940d7e9162858(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$73ff40c99770ef6d$export$da3940d7e9162858.prototype = {
    areaStart: (0, $9R4F2.default),
    areaEnd: (0, $9R4F2.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $hga9n.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $73ff40c99770ef6d$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $73ff40c99770ef6d$export$da3940d7e9162858(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});

parcelRegister("dUIyz", function(module, exports) {

$parcel$export(module.exports, "CardinalOpen", () => $a213115754da7990$export$cd7d1a617282f2f1);
$parcel$export(module.exports, "default", () => $a213115754da7990$export$2e2bcd8739ae039);

var $hga9n = parcelRequire("hga9n");
function $a213115754da7990$export$cd7d1a617282f2f1(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$a213115754da7990$export$cd7d1a617282f2f1.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $hga9n.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $a213115754da7990$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $a213115754da7990$export$cd7d1a617282f2f1(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});

parcelRegister("6FEsA", function(module, exports) {

$parcel$export(module.exports, "point", () => point);
$parcel$export(module.exports, "default", () => $4db5f4f17c3a16b3$export$2e2bcd8739ae039);

var $kDiOX = parcelRequire("kDiOX");

var $hga9n = parcelRequire("hga9n");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, $kDiOX.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, $kDiOX.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $4db5f4f17c3a16b3$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, $hga9n.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});

parcelRegister("loyNQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f936d5ffcfb25824$export$2e2bcd8739ae039);

var $9XrSP = parcelRequire("9XrSP");

var $9R4F2 = parcelRequire("9R4F2");

var $6FEsA = parcelRequire("6FEsA");
function $f936d5ffcfb25824$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$f936d5ffcfb25824$var$CatmullRomClosed.prototype = {
    areaStart: (0, $9R4F2.default),
    areaEnd: (0, $9R4F2.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $6FEsA.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $f936d5ffcfb25824$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $f936d5ffcfb25824$var$CatmullRomClosed(context, alpha) : new (0, $9XrSP.CardinalClosed)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});

parcelRegister("4tc8L", function(module, exports) {

$parcel$export(module.exports, "default", () => $341349acb9991726$export$2e2bcd8739ae039);

var $dUIyz = parcelRequire("dUIyz");

var $6FEsA = parcelRequire("6FEsA");
function $341349acb9991726$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$341349acb9991726$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $6FEsA.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $341349acb9991726$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $341349acb9991726$var$CatmullRomOpen(context, alpha) : new (0, $dUIyz.CardinalOpen)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});

parcelRegister("4CT3t", function(module, exports) {

$parcel$export(module.exports, "default", () => $35e56ad4997e8f65$export$2e2bcd8739ae039);

var $9R4F2 = parcelRequire("9R4F2");
function $35e56ad4997e8f65$var$LinearClosed(context) {
    this._context = context;
}
$35e56ad4997e8f65$var$LinearClosed.prototype = {
    areaStart: (0, $9R4F2.default),
    areaEnd: (0, $9R4F2.default),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $35e56ad4997e8f65$export$2e2bcd8739ae039(context) {
    return new $35e56ad4997e8f65$var$LinearClosed(context);
}

});

parcelRegister("hp3ls", function(module, exports) {

$parcel$export(module.exports, "monotoneX", () => $cab75dc01e66b193$export$99563b5420dbdc55);
$parcel$export(module.exports, "monotoneY", () => $cab75dc01e66b193$export$8b5360456d6bdb88);
function $cab75dc01e66b193$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $cab75dc01e66b193$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($cab75dc01e66b193$var$sign(s0) + $cab75dc01e66b193$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $cab75dc01e66b193$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $cab75dc01e66b193$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $cab75dc01e66b193$var$MonotoneX(context) {
    this._context = context;
}
$cab75dc01e66b193$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $cab75dc01e66b193$var$point(this, this._t0, $cab75dc01e66b193$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $cab75dc01e66b193$var$point(this, $cab75dc01e66b193$var$slope2(this, t1 = $cab75dc01e66b193$var$slope3(this, x, y)), t1);
                break;
            default:
                $cab75dc01e66b193$var$point(this, this._t0, t1 = $cab75dc01e66b193$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $cab75dc01e66b193$var$MonotoneY(context) {
    this._context = new $cab75dc01e66b193$var$ReflectContext(context);
}
($cab75dc01e66b193$var$MonotoneY.prototype = Object.create($cab75dc01e66b193$var$MonotoneX.prototype)).point = function(x, y) {
    $cab75dc01e66b193$var$MonotoneX.prototype.point.call(this, y, x);
};
function $cab75dc01e66b193$var$ReflectContext(context) {
    this._context = context;
}
$cab75dc01e66b193$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $cab75dc01e66b193$export$99563b5420dbdc55(context) {
    return new $cab75dc01e66b193$var$MonotoneX(context);
}
function $cab75dc01e66b193$export$8b5360456d6bdb88(context) {
    return new $cab75dc01e66b193$var$MonotoneY(context);
}

});

parcelRegister("kjPWc", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaddebfc9069a1b$export$2e2bcd8739ae039);
function $ecaddebfc9069a1b$var$Natural(context) {
    this._context = context;
}
$ecaddebfc9069a1b$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $ecaddebfc9069a1b$var$controlPoints(x), py = $ecaddebfc9069a1b$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $ecaddebfc9069a1b$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $ecaddebfc9069a1b$export$2e2bcd8739ae039(context) {
    return new $ecaddebfc9069a1b$var$Natural(context);
}

});

parcelRegister("1zRZO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1262f1c88e9696b5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "stepBefore", () => $1262f1c88e9696b5$export$10eafa5b7478b343);
$parcel$export(module.exports, "stepAfter", () => $1262f1c88e9696b5$export$793b3db073781cbb);
function $1262f1c88e9696b5$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$1262f1c88e9696b5$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $1262f1c88e9696b5$export$2e2bcd8739ae039(context) {
    return new $1262f1c88e9696b5$var$Step(context, 0.5);
}
function $1262f1c88e9696b5$export$10eafa5b7478b343(context) {
    return new $1262f1c88e9696b5$var$Step(context, 0);
}
function $1262f1c88e9696b5$export$793b3db073781cbb(context) {
    return new $1262f1c88e9696b5$var$Step(context, 1);
}

});

parcelRegister("fo0l5", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3395c44b48089b3$export$2e2bcd8739ae039);

var $7HXTO = parcelRequire("7HXTO");

var $f5PAg = parcelRequire("f5PAg");

var $fNubL = parcelRequire("fNubL");

var $kDiOX = parcelRequire("kDiOX");
function $b3395c44b48089b3$export$2e2bcd8739ae039() {
    var value = (0, $fNubL.default), sortValues = (0, $f5PAg.default), sort = null, startAngle = (0, $7HXTO.default)(0), endAngle = (0, $7HXTO.default)((0, $kDiOX.tau)), padAngle = (0, $7HXTO.default)(0);
    function pie(data) {
        var i, n = data.length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, $kDiOX.tau), Math.max(-(0, $kDiOX.tau), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
        // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        });
        // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("f5PAg", function(module, exports) {

$parcel$export(module.exports, "default", () => $afcf5628442ed482$export$2e2bcd8739ae039);
function $afcf5628442ed482$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("fNubL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b802d97edd5fe3af$export$2e2bcd8739ae039);
function $b802d97edd5fe3af$export$2e2bcd8739ae039(d) {
    return d;
}

});


parcelRegister("kyQKC", function(module, exports) {

$parcel$export(module.exports, "axisTop", () => (parcelRequire("bgSbI")).axisTop);
$parcel$export(module.exports, "axisRight", () => (parcelRequire("bgSbI")).axisRight);
$parcel$export(module.exports, "axisBottom", () => (parcelRequire("bgSbI")).axisBottom);
$parcel$export(module.exports, "axisLeft", () => (parcelRequire("bgSbI")).axisLeft);

var $bgSbI = parcelRequire("bgSbI");

});
parcelRegister("bgSbI", function(module, exports) {

$parcel$export(module.exports, "axisTop", () => $834b38f205523964$export$59b8cfab074bdeb1);
$parcel$export(module.exports, "axisRight", () => $834b38f205523964$export$b0d2e24dc4f898f0);
$parcel$export(module.exports, "axisBottom", () => $834b38f205523964$export$e5cb22533a15e72e);
$parcel$export(module.exports, "axisLeft", () => $834b38f205523964$export$2749afb169a520d2);

var $1BaLg = parcelRequire("1BaLg");

var $7v1sx = parcelRequire("7v1sx");
var $834b38f205523964$var$top = 1, $834b38f205523964$var$right = 2, $834b38f205523964$var$bottom = 3, $834b38f205523964$var$left = 4, $834b38f205523964$var$epsilon = 1e-6;
function $834b38f205523964$var$translateX(x) {
    return "translate(" + (x + 0.5) + ",0)";
}
function $834b38f205523964$var$translateY(y) {
    return "translate(0," + (y + 0.5) + ")";
}
function $834b38f205523964$var$number(scale) {
    return function(d) {
        return +scale(d);
    };
}
function $834b38f205523964$var$center(scale) {
    var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
    if (scale.round()) offset = Math.round(offset);
    return function(d) {
        return +scale(d) + offset;
    };
}
function $834b38f205523964$var$entering() {
    return !this.__axis;
}
function $834b38f205523964$var$axis(orient, scale) {
    var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, k = orient === $834b38f205523964$var$top || orient === $834b38f205523964$var$left ? -1 : 1, x = orient === $834b38f205523964$var$left || orient === $834b38f205523964$var$right ? "x" : "y", transform = orient === $834b38f205523964$var$top || orient === $834b38f205523964$var$bottom ? $834b38f205523964$var$translateX : $834b38f205523964$var$translateY;
    function axis(context) {
        var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : (0, $7v1sx.default) : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + 0.5, range1 = +range[range.length - 1] + 0.5, position = (scale.bandwidth ? $834b38f205523964$var$center : $834b38f205523964$var$number)(scale.copy()), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
            null
        ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
        path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
        tick = tick.merge(tickEnter);
        line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
        text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === $834b38f205523964$var$top ? "0em" : orient === $834b38f205523964$var$bottom ? "0.71em" : "0.32em"));
        if (context !== selection) {
            path = path.transition(context);
            tick = tick.transition(context);
            line = line.transition(context);
            text = text.transition(context);
            tickExit = tickExit.transition(context).attr("opacity", $834b38f205523964$var$epsilon).attr("transform", function(d) {
                return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform");
            });
            tickEnter.attr("opacity", $834b38f205523964$var$epsilon).attr("transform", function(d) {
                var p = this.parentNode.__axis;
                return transform(p && isFinite(p = p(d)) ? p : position(d));
            });
        }
        tickExit.remove();
        path.attr("d", orient === $834b38f205523964$var$left || orient == $834b38f205523964$var$right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter : "M0.5," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + ",0.5H" + range1);
        tick.attr("opacity", 1).attr("transform", function(d) {
            return transform(position(d));
        });
        line.attr(x + "2", k * tickSizeInner);
        text.attr(x, k * spacing).text(format);
        selection.filter($834b38f205523964$var$entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === $834b38f205523964$var$right ? "start" : orient === $834b38f205523964$var$left ? "end" : "middle");
        selection.each(function() {
            this.__axis = position;
        });
    }
    axis.scale = function(_) {
        return arguments.length ? (scale = _, axis) : scale;
    };
    axis.ticks = function() {
        return tickArguments = (0, $1BaLg.slice).call(arguments), axis;
    };
    axis.tickArguments = function(_) {
        return arguments.length ? (tickArguments = _ == null ? [] : (0, $1BaLg.slice).call(_), axis) : tickArguments.slice();
    };
    axis.tickValues = function(_) {
        return arguments.length ? (tickValues = _ == null ? null : (0, $1BaLg.slice).call(_), axis) : tickValues && tickValues.slice();
    };
    axis.tickFormat = function(_) {
        return arguments.length ? (tickFormat = _, axis) : tickFormat;
    };
    axis.tickSize = function(_) {
        return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
    };
    axis.tickSizeInner = function(_) {
        return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
    };
    axis.tickSizeOuter = function(_) {
        return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
    };
    axis.tickPadding = function(_) {
        return arguments.length ? (tickPadding = +_, axis) : tickPadding;
    };
    return axis;
}
function $834b38f205523964$export$59b8cfab074bdeb1(scale) {
    return $834b38f205523964$var$axis($834b38f205523964$var$top, scale);
}
function $834b38f205523964$export$b0d2e24dc4f898f0(scale) {
    return $834b38f205523964$var$axis($834b38f205523964$var$right, scale);
}
function $834b38f205523964$export$e5cb22533a15e72e(scale) {
    return $834b38f205523964$var$axis($834b38f205523964$var$bottom, scale);
}
function $834b38f205523964$export$2749afb169a520d2(scale) {
    return $834b38f205523964$var$axis($834b38f205523964$var$left, scale);
}

});
parcelRegister("1BaLg", function(module, exports) {

$parcel$export(module.exports, "slice", () => $12a19819930050d0$export$58adb3bec8346d0f);
var $12a19819930050d0$export$58adb3bec8346d0f = Array.prototype.slice;

});

parcelRegister("7v1sx", function(module, exports) {

$parcel$export(module.exports, "default", () => $575c8f74500ed33b$export$2e2bcd8739ae039);
function $575c8f74500ed33b$export$2e2bcd8739ae039(x) {
    return x;
}

});



parcelRegister("4Nk74", function(module, exports) {

$parcel$export(module.exports, "linear", () => $37db570cec68f9fe$export$45db2fc2f15997e7);
function $37db570cec68f9fe$export$45db2fc2f15997e7(t) {
    return +t;
}

});

parcelRegister("fOARq", function(module, exports) {

$parcel$export(module.exports, "zoom", () => (parcelRequire("cwuwP")).default);
$parcel$export(module.exports, "zoomTransform", () => (parcelRequire("e3ER1")).default);
$parcel$export(module.exports, "zoomIdentity", () => (parcelRequire("e3ER1")).identity);

var $cwuwP = parcelRequire("cwuwP");

var $e3ER1 = parcelRequire("e3ER1");

});
parcelRegister("cwuwP", function(module, exports) {

$parcel$export(module.exports, "default", () => $91e02783b8b1c24a$export$2e2bcd8739ae039);

var $aFEgl = parcelRequire("aFEgl");

var $cohyw = parcelRequire("cohyw");

var $jAaAF = parcelRequire("jAaAF");

var $iZ2is = parcelRequire("iZ2is");
var $iS3vq = parcelRequire("iS3vq");
var $hOxpW = parcelRequire("hOxpW");
var $5IKYT = parcelRequire("5IKYT");
parcelRequire("dxJVY");
var $f8M3T = parcelRequire("f8M3T");

var $6qNlB = parcelRequire("6qNlB");

var $awhiZ = parcelRequire("awhiZ");

var $e3ER1 = parcelRequire("e3ER1");

var $fmeOl = parcelRequire("fmeOl");
// Ignore right-click, since that should open the context menu.
function $91e02783b8b1c24a$var$defaultFilter() {
    return !(0, $iZ2is.event).ctrlKey && !(0, $iZ2is.event).button;
}
function $91e02783b8b1c24a$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $91e02783b8b1c24a$var$defaultTransform() {
    return this.__zoom || (0, $e3ER1.identity);
}
function $91e02783b8b1c24a$var$defaultWheelDelta() {
    return -(0, $iZ2is.event).deltaY * ((0, $iZ2is.event).deltaMode === 1 ? 0.05 : (0, $iZ2is.event).deltaMode ? 1 : 0.002);
}
function $91e02783b8b1c24a$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $91e02783b8b1c24a$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $91e02783b8b1c24a$export$2e2bcd8739ae039() {
    var filter = $91e02783b8b1c24a$var$defaultFilter, extent = $91e02783b8b1c24a$var$defaultExtent, constrain = $91e02783b8b1c24a$var$defaultConstrain, wheelDelta = $91e02783b8b1c24a$var$defaultWheelDelta, touchable = $91e02783b8b1c24a$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $jAaAF.default), listeners = (0, $aFEgl.default)("start", "zoom", "end"), touchstarting, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0;
    function zoom(selection) {
        selection.property("__zoom", $91e02783b8b1c24a$var$defaultTransform).on("wheel.zoom", wheeled).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $91e02783b8b1c24a$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point);
        else selection.interrupt().each(function() {
            gesture(this, arguments).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p);
    };
    zoom.scaleTo = function(selection, k, p) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p);
    };
    zoom.translateBy = function(selection, x, y) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        });
    };
    zoom.translateTo = function(selection, x, y, p) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $e3ER1.identity).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $e3ER1.Transform)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $e3ER1.Transform)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $e3ER1.Transform)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            (0, $iZ2is.customEvent)(new (0, $awhiZ.default)(zoom, type, this.that.__zoom), listeners.apply, listeners, [
                type,
                this.that,
                this.args
            ]);
        }
    };
    function wheeled() {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, arguments), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $iS3vq.default)(this);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $f8M3T.default)(this);
            g.start();
        }
        (0, $fmeOl.default)();
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned() {
        if (touchending || !filter.apply(this, arguments)) return;
        var g = gesture(this, arguments, true), v = (0, $hOxpW.default)((0, $iZ2is.event).view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $iS3vq.default)(this), x0 = (0, $iZ2is.event).clientX, y0 = (0, $iZ2is.event).clientY;
        (0, $cohyw.default)((0, $iZ2is.event).view);
        (0, $fmeOl.nopropagation)();
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $f8M3T.default)(this);
        g.start();
        function mousemoved() {
            (0, $fmeOl.default)();
            if (!g.moved) {
                var dx = (0, $iZ2is.event).clientX - x0, dy = (0, $iZ2is.event).clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $iS3vq.default)(g.that), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped() {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $cohyw.yesdrag)((0, $iZ2is.event).view, g.moved);
            (0, $fmeOl.default)();
            g.end();
        }
    }
    function dblclicked() {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $iS3vq.default)(this), p1 = t0.invert(p0), k1 = t0.k * ((0, $iZ2is.event).shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments), translateExtent);
        (0, $fmeOl.default)();
        if (duration > 0) (0, $hOxpW.default)(this).transition().duration(duration).call(schedule, t1, p0);
        else (0, $hOxpW.default)(this).call(zoom.transform, t1);
    }
    function touchstarted() {
        if (!filter.apply(this, arguments)) return;
        var touches = (0, $iZ2is.event).touches, n = touches.length, g = gesture(this, arguments, (0, $iZ2is.event).changedTouches.length === n), started, i, t, p;
        (0, $fmeOl.nopropagation)();
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $5IKYT.default)(this, touches, t.identifier);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $f8M3T.default)(this);
            g.start();
        }
    }
    function touchmoved() {
        if (!this.__zooming) return;
        var g = gesture(this, arguments), touches = (0, $iZ2is.event).changedTouches, n = touches.length, i, t, p, l;
        (0, $fmeOl.default)();
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        g.taps = 0;
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $5IKYT.default)(this, touches, t.identifier);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended() {
        if (!this.__zooming) return;
        var g = gesture(this, arguments), touches = (0, $iZ2is.event).changedTouches, n = touches.length, i, t;
        (0, $fmeOl.nopropagation)();
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                var p = (0, $hOxpW.default)(this).on("dblclick.zoom");
                if (p) p.apply(this, arguments);
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $6qNlB.default)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $6qNlB.default)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $6qNlB.default)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $6qNlB.default)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    return zoom;
}

});
parcelRegister("jAaAF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4199827a75856fd$export$2e2bcd8739ae039);
var $e4199827a75856fd$var$rho = Math.SQRT2, $e4199827a75856fd$var$rho2 = 2, $e4199827a75856fd$var$rho4 = 4, $e4199827a75856fd$var$epsilon2 = 1e-12;
function $e4199827a75856fd$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $e4199827a75856fd$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $e4199827a75856fd$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
function $e4199827a75856fd$export$2e2bcd8739ae039(p0, p1) {
    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
    // Special case for u0 ≅ u1.
    if (d2 < $e4199827a75856fd$var$epsilon2) {
        S = Math.log(w1 / w0) / $e4199827a75856fd$var$rho;
        i = function(t) {
            return [
                ux0 + t * dx,
                uy0 + t * dy,
                w0 * Math.exp($e4199827a75856fd$var$rho * t * S)
            ];
        };
    } else {
        var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + $e4199827a75856fd$var$rho4 * d2) / (2 * w0 * $e4199827a75856fd$var$rho2 * d1), b1 = (w1 * w1 - w0 * w0 - $e4199827a75856fd$var$rho4 * d2) / (2 * w1 * $e4199827a75856fd$var$rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
        S = (r1 - r0) / $e4199827a75856fd$var$rho;
        i = function(t) {
            var s = t * S, coshr0 = $e4199827a75856fd$var$cosh(r0), u = w0 / ($e4199827a75856fd$var$rho2 * d1) * (coshr0 * $e4199827a75856fd$var$tanh($e4199827a75856fd$var$rho * s + r0) - $e4199827a75856fd$var$sinh(r0));
            return [
                ux0 + u * dx,
                uy0 + u * dy,
                w0 * coshr0 / $e4199827a75856fd$var$cosh($e4199827a75856fd$var$rho * s + r0)
            ];
        };
    }
    i.duration = S * 1000;
    return i;
}

});

parcelRegister("6qNlB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aeb7326706b2467$export$2e2bcd8739ae039);
function $4aeb7326706b2467$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("awhiZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a8a51016481311d$export$2e2bcd8739ae039);
function $7a8a51016481311d$export$2e2bcd8739ae039(target, type, transform) {
    this.target = target;
    this.type = type;
    this.transform = transform;
}

});

parcelRegister("e3ER1", function(module, exports) {

$parcel$export(module.exports, "Transform", () => $a3c1094a2e8782d7$export$563a914cafbdc389);
$parcel$export(module.exports, "identity", () => $a3c1094a2e8782d7$export$f0954fd7d5368655);
$parcel$export(module.exports, "default", () => $a3c1094a2e8782d7$export$2e2bcd8739ae039);
function $a3c1094a2e8782d7$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$a3c1094a2e8782d7$export$563a914cafbdc389.prototype = {
    constructor: $a3c1094a2e8782d7$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $a3c1094a2e8782d7$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $a3c1094a2e8782d7$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $a3c1094a2e8782d7$export$f0954fd7d5368655 = new $a3c1094a2e8782d7$export$563a914cafbdc389(1, 0, 0);
$a3c1094a2e8782d7$export$2e2bcd8739ae039.prototype = $a3c1094a2e8782d7$export$563a914cafbdc389.prototype;
function $a3c1094a2e8782d7$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $a3c1094a2e8782d7$export$f0954fd7d5368655;
    return node.__zoom;
}

});

parcelRegister("fmeOl", function(module, exports) {

$parcel$export(module.exports, "nopropagation", () => $b2e4663bd9fbfcc1$export$2e2561858db9bf47);
$parcel$export(module.exports, "default", () => $b2e4663bd9fbfcc1$export$2e2bcd8739ae039);

var $iZ2is = parcelRequire("iZ2is");
function $b2e4663bd9fbfcc1$export$2e2561858db9bf47() {
    (0, $iZ2is.event).stopImmediatePropagation();
}
function $b2e4663bd9fbfcc1$export$2e2bcd8739ae039() {
    (0, $iZ2is.event).preventDefault();
    (0, $iZ2is.event).stopImmediatePropagation();
}

});




parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
"use strict";
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});

parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f4905a8b274aa381$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


parcelRegister("8SsuU", function(module, exports) {

var $dvUl4 = parcelRequire("dvUl4");
/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $676978e4775c0e9c$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== "string") return output;
    var declaration;
    var declarations = $dvUl4(style);
    var hasIterator = typeof iterator === "function";
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
module.exports = $676978e4775c0e9c$var$StyleToObject;

});
parcelRegister("dvUl4", function(module, exports) {
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $9d69df5777ad44b8$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $9d69df5777ad44b8$var$NEWLINE_REGEX = /\n/g;
var $9d69df5777ad44b8$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $9d69df5777ad44b8$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $9d69df5777ad44b8$var$COLON_REGEX = /^:\s*/;
var $9d69df5777ad44b8$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $9d69df5777ad44b8$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $9d69df5777ad44b8$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $9d69df5777ad44b8$var$NEWLINE = "\n";
var $9d69df5777ad44b8$var$FORWARD_SLASH = "/";
var $9d69df5777ad44b8$var$ASTERISK = "*";
var $9d69df5777ad44b8$var$EMPTY_STRING = "";
// types
var $9d69df5777ad44b8$var$TYPE_COMMENT = "comment";
var $9d69df5777ad44b8$var$TYPE_DECLARATION = "declaration";
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ module.exports = function(style, options) {
    if (typeof style !== "string") throw new TypeError("First argument must be a string");
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($9d69df5777ad44b8$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($9d69df5777ad44b8$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ":" + lineno + ":" + column + ": " + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($9d69df5777ad44b8$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($9d69df5777ad44b8$var$FORWARD_SLASH != style.charAt(0) || $9d69df5777ad44b8$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($9d69df5777ad44b8$var$EMPTY_STRING != style.charAt(i) && ($9d69df5777ad44b8$var$ASTERISK != style.charAt(i) || $9d69df5777ad44b8$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($9d69df5777ad44b8$var$EMPTY_STRING === style.charAt(i - 1)) return error("End of comment missing");
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $9d69df5777ad44b8$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($9d69df5777ad44b8$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($9d69df5777ad44b8$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($9d69df5777ad44b8$var$VALUE_REGEX);
        var ret = pos({
            type: $9d69df5777ad44b8$var$TYPE_DECLARATION,
            property: $9d69df5777ad44b8$var$trim(prop[0].replace($9d69df5777ad44b8$var$COMMENT_REGEX, $9d69df5777ad44b8$var$EMPTY_STRING)),
            value: val ? $9d69df5777ad44b8$var$trim(val[0].replace($9d69df5777ad44b8$var$COMMENT_REGEX, $9d69df5777ad44b8$var$EMPTY_STRING)) : $9d69df5777ad44b8$var$EMPTY_STRING
        });
        // ;
        match($9d69df5777ad44b8$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $9d69df5777ad44b8$var$trim(str) {
    return str ? str.replace($9d69df5777ad44b8$var$TRIM_REGEX, $9d69df5777ad44b8$var$EMPTY_STRING) : $9d69df5777ad44b8$var$EMPTY_STRING;
}

});


parcelRegister("bbrtK", function(module, exports) {

var $6PeEc = parcelRequire("6PeEc");

var $4mEbv = parcelRequire("4mEbv");
var $8246097ee3a6e368$var$CASE_SENSITIVE_TAG_NAMES = $6PeEc.CASE_SENSITIVE_TAG_NAMES;
var $8246097ee3a6e368$var$Comment = $4mEbv.Comment;
var $8246097ee3a6e368$var$Element = $4mEbv.Element;
var $8246097ee3a6e368$var$ProcessingInstruction = $4mEbv.ProcessingInstruction;
var $8246097ee3a6e368$var$Text = $4mEbv.Text;
var $8246097ee3a6e368$var$caseSensitiveTagNamesMap = {};
var $8246097ee3a6e368$var$tagName;
for(var $8246097ee3a6e368$var$i = 0, $8246097ee3a6e368$var$len = $8246097ee3a6e368$var$CASE_SENSITIVE_TAG_NAMES.length; $8246097ee3a6e368$var$i < $8246097ee3a6e368$var$len; $8246097ee3a6e368$var$i++){
    $8246097ee3a6e368$var$tagName = $8246097ee3a6e368$var$CASE_SENSITIVE_TAG_NAMES[$8246097ee3a6e368$var$i];
    $8246097ee3a6e368$var$caseSensitiveTagNamesMap[$8246097ee3a6e368$var$tagName.toLowerCase()] = $8246097ee3a6e368$var$tagName;
}
/**
 * Gets case-sensitive tag name.
 *
 * @param  {string}           tagName - Tag name in lowercase.
 * @return {string|undefined}         - Case-sensitive tag name.
 */ function $8246097ee3a6e368$var$getCaseSensitiveTagName(tagName) {
    return $8246097ee3a6e368$var$caseSensitiveTagNamesMap[tagName];
}
/**
 * Formats DOM attributes to a hash map.
 *
 * @param  {NamedNodeMap} attributes - List of attributes.
 * @return {object}                  - Map of attribute name to value.
 */ function $8246097ee3a6e368$var$formatAttributes(attributes) {
    var result = {};
    var attribute;
    // `NamedNodeMap` is array-like
    for(var i = 0, len = attributes.length; i < len; i++){
        attribute = attributes[i];
        result[attribute.name] = attribute.value;
    }
    return result;
}
/**
 * Corrects the tag name if it is case-sensitive (SVG).
 * Otherwise, returns the lowercase tag name (HTML).
 *
 * @param  {string} tagName - Lowercase tag name.
 * @return {string}         - Formatted tag name.
 */ function $8246097ee3a6e368$var$formatTagName(tagName) {
    tagName = tagName.toLowerCase();
    var caseSensitiveTagName = $8246097ee3a6e368$var$getCaseSensitiveTagName(tagName);
    if (caseSensitiveTagName) return caseSensitiveTagName;
    return tagName;
}
/**
 * Transforms DOM nodes to `domhandler` nodes.
 *
 * @param  {NodeList}     nodes         - DOM nodes.
 * @param  {Element|null} [parent=null] - Parent node.
 * @param  {string}       [directive]   - Directive.
 * @return {Array<Comment|Element|ProcessingInstruction|Text>}
 */ function $8246097ee3a6e368$var$formatDOM(nodes, parent, directive) {
    parent = parent || null;
    var result = [];
    for(var index = 0, len = nodes.length; index < len; index++){
        var node = nodes[index];
        var current;
        // set the node data given the type
        switch(node.nodeType){
            case 1:
                // script, style, or tag
                current = new $8246097ee3a6e368$var$Element($8246097ee3a6e368$var$formatTagName(node.nodeName), $8246097ee3a6e368$var$formatAttributes(node.attributes));
                current.children = $8246097ee3a6e368$var$formatDOM(node.childNodes, current);
                break;
            case 3:
                current = new $8246097ee3a6e368$var$Text(node.nodeValue);
                break;
            case 8:
                current = new $8246097ee3a6e368$var$Comment(node.nodeValue);
                break;
            default:
                continue;
        }
        // set previous node next
        var prev = result[index - 1] || null;
        if (prev) prev.next = current;
        // set properties for current node
        current.parent = parent;
        current.prev = prev;
        current.next = null;
        result.push(current);
    }
    if (directive) {
        current = new $8246097ee3a6e368$var$ProcessingInstruction(directive.substring(0, directive.indexOf(" ")).toLowerCase(), directive);
        current.next = result[0] || null;
        current.parent = parent;
        result.unshift(current);
        if (result[1]) result[1].prev = result[0];
    }
    return result;
}
/**
 * Detects if browser is Internet Explorer.
 *
 * @return {boolean} - Whether IE is detected.
 */ function $8246097ee3a6e368$var$isIE() {
    return /(MSIE |Trident\/|Edge\/)/.test(navigator.userAgent);
}
module.exports = {
    formatAttributes: $8246097ee3a6e368$var$formatAttributes,
    formatDOM: $8246097ee3a6e368$var$formatDOM,
    isIE: $8246097ee3a6e368$var$isIE
};

});
parcelRegister("6PeEc", function(module, exports) {
/**
 * SVG elements are case-sensitive.
 *
 * @see {@link https://developer.mozilla.org/docs/Web/SVG/Element#SVG_elements_A_to_Z}
 */ var $4f82de26c9ecf64f$var$CASE_SENSITIVE_TAG_NAMES = [
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussainBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "linearGradient",
    "radialGradient",
    "textPath"
];
module.exports = {
    CASE_SENSITIVE_TAG_NAMES: $4f82de26c9ecf64f$var$CASE_SENSITIVE_TAG_NAMES
};

});

parcelRegister("4mEbv", function(module, exports) {
"use strict";
var $32d863528239eae9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $32d863528239eae9$var$__assign = module.exports && module.exports.__assign || function() {
    $32d863528239eae9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $32d863528239eae9$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cloneNode = module.exports.hasChildren = module.exports.isDocument = module.exports.isDirective = module.exports.isComment = module.exports.isText = module.exports.isCDATA = module.exports.isTag = module.exports.Element = module.exports.Document = module.exports.NodeWithChildren = module.exports.ProcessingInstruction = module.exports.Comment = module.exports.Text = module.exports.DataNode = module.exports.Node = void 0;

var $hREhV = parcelRequire("hREhV");
var $32d863528239eae9$var$nodeTypes = new Map([
    [
        $hREhV.ElementType.Tag,
        1
    ],
    [
        $hREhV.ElementType.Script,
        1
    ],
    [
        $hREhV.ElementType.Style,
        1
    ],
    [
        $hREhV.ElementType.Directive,
        1
    ],
    [
        $hREhV.ElementType.Text,
        3
    ],
    [
        $hREhV.ElementType.CDATA,
        4
    ],
    [
        $hREhV.ElementType.Comment,
        8
    ],
    [
        $hREhV.ElementType.Root,
        9
    ]
]);
/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */ var $32d863528239eae9$var$Node = /** @class */ function() {
    /**
     *
     * @param type The type of the node.
     */ function Node(type) {
        this.type = type;
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
    Object.defineProperty(Node.prototype, "nodeType", {
        // Read-only aliases
        /**
         * [DOM spec](https://dom.spec.whatwg.org/#dom-node-nodetype)-compatible
         * node {@link type}.
         */ get: function() {
            var _a;
            return (_a = $32d863528239eae9$var$nodeTypes.get(this.type)) !== null && _a !== void 0 ? _a : 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.parent;
        },
        set: function(parent) {
            this.parent = parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.prev;
        },
        set: function(prev) {
            this.prev = prev;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.next;
        },
        set: function(next) {
            this.next = next;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ Node.prototype.cloneNode = function(recursive) {
        if (recursive === void 0) recursive = false;
        return $32d863528239eae9$var$cloneNode(this, recursive);
    };
    return Node;
}();
module.exports.Node = $32d863528239eae9$var$Node;
/**
 * A node that contains some data.
 */ var $32d863528239eae9$var$DataNode = /** @class */ function(_super) {
    $32d863528239eae9$var$__extends(DataNode, _super);
    /**
     * @param type The type of the node
     * @param data The content of the data node
     */ function DataNode(type, data) {
        var _this = _super.call(this, type) || this;
        _this.data = data;
        return _this;
    }
    Object.defineProperty(DataNode.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.data;
        },
        set: function(data) {
            this.data = data;
        },
        enumerable: false,
        configurable: true
    });
    return DataNode;
}($32d863528239eae9$var$Node);
module.exports.DataNode = $32d863528239eae9$var$DataNode;
/**
 * Text within the document.
 */ var $32d863528239eae9$var$Text = /** @class */ function(_super) {
    $32d863528239eae9$var$__extends(Text, _super);
    function Text(data) {
        return _super.call(this, $hREhV.ElementType.Text, data) || this;
    }
    return Text;
}($32d863528239eae9$var$DataNode);
module.exports.Text = $32d863528239eae9$var$Text;
/**
 * Comments within the document.
 */ var $32d863528239eae9$var$Comment = /** @class */ function(_super) {
    $32d863528239eae9$var$__extends(Comment, _super);
    function Comment(data) {
        return _super.call(this, $hREhV.ElementType.Comment, data) || this;
    }
    return Comment;
}($32d863528239eae9$var$DataNode);
module.exports.Comment = $32d863528239eae9$var$Comment;
/**
 * Processing instructions, including doc types.
 */ var $32d863528239eae9$var$ProcessingInstruction = /** @class */ function(_super) {
    $32d863528239eae9$var$__extends(ProcessingInstruction, _super);
    function ProcessingInstruction(name, data) {
        var _this = _super.call(this, $hREhV.ElementType.Directive, data) || this;
        _this.name = name;
        return _this;
    }
    return ProcessingInstruction;
}($32d863528239eae9$var$DataNode);
module.exports.ProcessingInstruction = $32d863528239eae9$var$ProcessingInstruction;
/**
 * A `Node` that can have children.
 */ var $32d863528239eae9$var$NodeWithChildren = /** @class */ function(_super) {
    $32d863528239eae9$var$__extends(NodeWithChildren, _super);
    /**
     * @param type Type of the node.
     * @param children Children of the node. Only certain node types can have children.
     */ function NodeWithChildren(type, children) {
        var _this = _super.call(this, type) || this;
        _this.children = children;
        return _this;
    }
    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */ get: function() {
            var _a;
            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
        /** Last child of the node. */ get: function() {
            return this.children.length > 0 ? this.children[this.children.length - 1] : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.children;
        },
        set: function(children) {
            this.children = children;
        },
        enumerable: false,
        configurable: true
    });
    return NodeWithChildren;
}($32d863528239eae9$var$Node);
module.exports.NodeWithChildren = $32d863528239eae9$var$NodeWithChildren;
/**
 * The root node of the document.
 */ var $32d863528239eae9$var$Document = /** @class */ function(_super) {
    $32d863528239eae9$var$__extends(Document, _super);
    function Document(children) {
        return _super.call(this, $hREhV.ElementType.Root, children) || this;
    }
    return Document;
}($32d863528239eae9$var$NodeWithChildren);
module.exports.Document = $32d863528239eae9$var$Document;
/**
 * An element within the DOM.
 */ var $32d863528239eae9$var$Element = /** @class */ function(_super) {
    $32d863528239eae9$var$__extends(Element, _super);
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */ function Element(name, attribs, children, type) {
        if (children === void 0) children = [];
        if (type === void 0) type = name === "script" ? $hREhV.ElementType.Script : name === "style" ? $hREhV.ElementType.Style : $hREhV.ElementType.Tag;
        var _this = _super.call(this, type, children) || this;
        _this.name = name;
        _this.attribs = attribs;
        return _this;
    }
    Object.defineProperty(Element.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.name;
        },
        set: function(name) {
            this.name = name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "attributes", {
        get: function() {
            var _this = this;
            return Object.keys(this.attribs).map(function(name) {
                var _a, _b;
                return {
                    name: name,
                    value: _this.attribs[name],
                    namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                    prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    return Element;
}($32d863528239eae9$var$NodeWithChildren);
module.exports.Element = $32d863528239eae9$var$Element;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */ function $32d863528239eae9$var$isTag(node) {
    return (0, $hREhV.isTag)(node);
}
module.exports.isTag = $32d863528239eae9$var$isTag;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */ function $32d863528239eae9$var$isCDATA(node) {
    return node.type === $hREhV.ElementType.CDATA;
}
module.exports.isCDATA = $32d863528239eae9$var$isCDATA;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */ function $32d863528239eae9$var$isText(node) {
    return node.type === $hREhV.ElementType.Text;
}
module.exports.isText = $32d863528239eae9$var$isText;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */ function $32d863528239eae9$var$isComment(node) {
    return node.type === $hREhV.ElementType.Comment;
}
module.exports.isComment = $32d863528239eae9$var$isComment;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */ function $32d863528239eae9$var$isDirective(node) {
    return node.type === $hREhV.ElementType.Directive;
}
module.exports.isDirective = $32d863528239eae9$var$isDirective;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */ function $32d863528239eae9$var$isDocument(node) {
    return node.type === $hREhV.ElementType.Root;
}
module.exports.isDocument = $32d863528239eae9$var$isDocument;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `NodeWithChildren` (has children), `false` otherwise.
 */ function $32d863528239eae9$var$hasChildren(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
module.exports.hasChildren = $32d863528239eae9$var$hasChildren;
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */ function $32d863528239eae9$var$cloneNode(node, recursive) {
    if (recursive === void 0) recursive = false;
    var result;
    if ($32d863528239eae9$var$isText(node)) result = new $32d863528239eae9$var$Text(node.data);
    else if ($32d863528239eae9$var$isComment(node)) result = new $32d863528239eae9$var$Comment(node.data);
    else if ($32d863528239eae9$var$isTag(node)) {
        var children = recursive ? $32d863528239eae9$var$cloneChildren(node.children) : [];
        var clone_1 = new $32d863528239eae9$var$Element(node.name, $32d863528239eae9$var$__assign({}, node.attribs), children);
        children.forEach(function(child) {
            return child.parent = clone_1;
        });
        if (node.namespace != null) clone_1.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone_1["x-attribsNamespace"] = $32d863528239eae9$var$__assign({}, node["x-attribsNamespace"]);
        if (node["x-attribsPrefix"]) clone_1["x-attribsPrefix"] = $32d863528239eae9$var$__assign({}, node["x-attribsPrefix"]);
        result = clone_1;
    } else if ($32d863528239eae9$var$isCDATA(node)) {
        var children = recursive ? $32d863528239eae9$var$cloneChildren(node.children) : [];
        var clone_2 = new $32d863528239eae9$var$NodeWithChildren($hREhV.ElementType.CDATA, children);
        children.forEach(function(child) {
            return child.parent = clone_2;
        });
        result = clone_2;
    } else if ($32d863528239eae9$var$isDocument(node)) {
        var children = recursive ? $32d863528239eae9$var$cloneChildren(node.children) : [];
        var clone_3 = new $32d863528239eae9$var$Document(children);
        children.forEach(function(child) {
            return child.parent = clone_3;
        });
        if (node["x-mode"]) clone_3["x-mode"] = node["x-mode"];
        result = clone_3;
    } else if ($32d863528239eae9$var$isDirective(node)) {
        var instruction = new $32d863528239eae9$var$ProcessingInstruction(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error("Not implemented yet: ".concat(node.type));
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
module.exports.cloneNode = $32d863528239eae9$var$cloneNode;
function $32d863528239eae9$var$cloneChildren(childs) {
    var children = childs.map(function(child) {
        return $32d863528239eae9$var$cloneNode(child, true);
    });
    for(var i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

});
parcelRegister("hREhV", function(module, exports) {

$parcel$export(module.exports, "ElementType", () => $d016a34ede83f3d0$export$b992dc138d950e31);
$parcel$export(module.exports, "isTag", () => $d016a34ede83f3d0$export$3bf645f08efe3292);
/** Types of elements found in htmlparser2's DOM */ var $d016a34ede83f3d0$export$b992dc138d950e31;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($d016a34ede83f3d0$export$b992dc138d950e31 || ($d016a34ede83f3d0$export$b992dc138d950e31 = {}));
function $d016a34ede83f3d0$export$3bf645f08efe3292(elem) {
    return elem.type === $d016a34ede83f3d0$export$b992dc138d950e31.Tag || elem.type === $d016a34ede83f3d0$export$b992dc138d950e31.Script || elem.type === $d016a34ede83f3d0$export$b992dc138d950e31.Style;
}
const $d016a34ede83f3d0$export$be92b6f5f03c0fe9 = $d016a34ede83f3d0$export$b992dc138d950e31.Root;
const $d016a34ede83f3d0$export$5f1af8db9871e1d6 = $d016a34ede83f3d0$export$b992dc138d950e31.Text;
const $d016a34ede83f3d0$export$befdefbdce210f91 = $d016a34ede83f3d0$export$b992dc138d950e31.Directive;
const $d016a34ede83f3d0$export$4d299b491347818a = $d016a34ede83f3d0$export$b992dc138d950e31.Comment;
const $d016a34ede83f3d0$export$2f8b47a141e57afc = $d016a34ede83f3d0$export$b992dc138d950e31.Script;
const $d016a34ede83f3d0$export$d9e45bc13d335801 = $d016a34ede83f3d0$export$b992dc138d950e31.Style;
const $d016a34ede83f3d0$export$3288d34c523a1192 = $d016a34ede83f3d0$export$b992dc138d950e31.Tag;
const $d016a34ede83f3d0$export$1f8b8f7e5c763232 = $d016a34ede83f3d0$export$b992dc138d950e31.CDATA;
const $d016a34ede83f3d0$export$31b44af36ff2c60f = $d016a34ede83f3d0$export$b992dc138d950e31.Doctype;

});



parcelRegister("2UBPZ", function(module, exports) {
"use strict";
var $21ee2981a5b3fcf1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $21ee2981a5b3fcf1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $21ee2981a5b3fcf1$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DomHandler = void 0;

var $hREhV = parcelRequire("hREhV");


$21ee2981a5b3fcf1$var$__exportStar((parcelRequire("4mEbv")), module.exports);
var $21ee2981a5b3fcf1$var$reWhitespace = /\s+/g;
// Default options
var $21ee2981a5b3fcf1$var$defaultOpts = {
    normalizeWhitespace: false,
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
var $21ee2981a5b3fcf1$var$DomHandler = /** @class */ function() {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */ function DomHandler(callback, options, elementCB) {
        /** The elements of the DOM */ this.dom = [];
        /** The root element for the DOM */ this.root = new (parcelRequire("4mEbv")).Document(this.dom);
        /** Indicated whether parsing has been completed. */ this.done = false;
        /** Stack of open tags. */ this.tagStack = [
            this.root
        ];
        /** A data node that is still being written to. */ this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */ this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = $21ee2981a5b3fcf1$var$defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : $21ee2981a5b3fcf1$var$defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    DomHandler.prototype.onparserinit = function(parser) {
        this.parser = parser;
    };
    // Resets the handler back to starting state
    DomHandler.prototype.onreset = function() {
        this.dom = [];
        this.root = new (parcelRequire("4mEbv")).Document(this.dom);
        this.done = false;
        this.tagStack = [
            this.root
        ];
        this.lastNode = null;
        this.parser = null;
    };
    // Signals the handler that parsing is done
    DomHandler.prototype.onend = function() {
        if (this.done) return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    };
    DomHandler.prototype.onerror = function(error) {
        this.handleCallback(error);
    };
    DomHandler.prototype.onclosetag = function() {
        this.lastNode = null;
        var elem = this.tagStack.pop();
        if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
        if (this.elementCB) this.elementCB(elem);
    };
    DomHandler.prototype.onopentag = function(name, attribs) {
        var type = this.options.xmlMode ? $hREhV.ElementType.Tag : undefined;
        var element = new (parcelRequire("4mEbv")).Element(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    };
    DomHandler.prototype.ontext = function(data) {
        var normalizeWhitespace = this.options.normalizeWhitespace;
        var lastNode = this.lastNode;
        if (lastNode && lastNode.type === $hREhV.ElementType.Text) {
            if (normalizeWhitespace) lastNode.data = (lastNode.data + data).replace($21ee2981a5b3fcf1$var$reWhitespace, " ");
            else lastNode.data += data;
            if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
        } else {
            if (normalizeWhitespace) data = data.replace($21ee2981a5b3fcf1$var$reWhitespace, " ");
            var node = new (parcelRequire("4mEbv")).Text(data);
            this.addNode(node);
            this.lastNode = node;
        }
    };
    DomHandler.prototype.oncomment = function(data) {
        if (this.lastNode && this.lastNode.type === $hREhV.ElementType.Comment) {
            this.lastNode.data += data;
            return;
        }
        var node = new (parcelRequire("4mEbv")).Comment(data);
        this.addNode(node);
        this.lastNode = node;
    };
    DomHandler.prototype.oncommentend = function() {
        this.lastNode = null;
    };
    DomHandler.prototype.oncdatastart = function() {
        var text = new (parcelRequire("4mEbv")).Text("");
        var node = new (parcelRequire("4mEbv")).NodeWithChildren($hREhV.ElementType.CDATA, [
            text
        ]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    };
    DomHandler.prototype.oncdataend = function() {
        this.lastNode = null;
    };
    DomHandler.prototype.onprocessinginstruction = function(name, data) {
        var node = new (parcelRequire("4mEbv")).ProcessingInstruction(name, data);
        this.addNode(node);
    };
    DomHandler.prototype.handleCallback = function(error) {
        if (typeof this.callback === "function") this.callback(error, this.dom);
        else if (error) throw error;
    };
    DomHandler.prototype.addNode = function(node) {
        var parent = this.tagStack[this.tagStack.length - 1];
        var previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
        if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    };
    return DomHandler;
}();
module.exports.DomHandler = $21ee2981a5b3fcf1$var$DomHandler;
module.exports.default = $21ee2981a5b3fcf1$var$DomHandler;

});

parcelRegister("iH1gS", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $d9bd3a91f40543dd$export$a7c73072b1a182ae, (v) => $d9bd3a91f40543dd$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $d9bd3a91f40543dd$export$9f27bc3417b4524d, (v) => $d9bd3a91f40543dd$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $d9bd3a91f40543dd$export$db77ccec0bb4ccac, (v) => $d9bd3a91f40543dd$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $d9bd3a91f40543dd$export$8392c0c9d3dcbd35, (v) => $d9bd3a91f40543dd$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $d9bd3a91f40543dd$export$ffb0004e005737fa, (v) => $d9bd3a91f40543dd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $d9bd3a91f40543dd$export$b624eff549462981, (v) => $d9bd3a91f40543dd$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $d9bd3a91f40543dd$export$7897aa7841a5380c, (v) => $d9bd3a91f40543dd$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $d9bd3a91f40543dd$export$602eac185826482c, (v) => $d9bd3a91f40543dd$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $d9bd3a91f40543dd$export$e2c29f18771995cb, (v) => $d9bd3a91f40543dd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $d9bd3a91f40543dd$export$5f8d39834fd61797, (v) => $d9bd3a91f40543dd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $d9bd3a91f40543dd$export$74bf444e3cd11ea5, (v) => $d9bd3a91f40543dd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $d9bd3a91f40543dd$export$998bcd577473dd93, (v) => $d9bd3a91f40543dd$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $d9bd3a91f40543dd$export$92387174baf9b227, (v) => $d9bd3a91f40543dd$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $d9bd3a91f40543dd$export$ec112efeb987d9c6, (v) => $d9bd3a91f40543dd$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $d9bd3a91f40543dd$export$b706b080d889d2c9, (v) => $d9bd3a91f40543dd$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $d9bd3a91f40543dd$export$5be5a87408f70ddc, (v) => $d9bd3a91f40543dd$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $d9bd3a91f40543dd$export$45a5e7f76e0caa8d, (v) => $d9bd3a91f40543dd$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $d9bd3a91f40543dd$export$455c2e768291efa6, (v) => $d9bd3a91f40543dd$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $d9bd3a91f40543dd$export$9522e17588c12572, (v) => $d9bd3a91f40543dd$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $d9bd3a91f40543dd$export$2110ac352bb060b9, (v) => $d9bd3a91f40543dd$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $d9bd3a91f40543dd$export$56885ab8b9c456ab, (v) => $d9bd3a91f40543dd$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $d9bd3a91f40543dd$export$d927fcb6adf8f9de, (v) => $d9bd3a91f40543dd$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $d9bd3a91f40543dd$export$b82d16f27459e05a, (v) => $d9bd3a91f40543dd$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $d9bd3a91f40543dd$export$522c17b4f5e123e8, (v) => $d9bd3a91f40543dd$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $d9bd3a91f40543dd$export$1aabd8a0274ecfd6, (v) => $d9bd3a91f40543dd$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $d9bd3a91f40543dd$export$3d6c20d97e46b957, (v) => $d9bd3a91f40543dd$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $d9bd3a91f40543dd$export$9b621391a187a31a, (v) => $d9bd3a91f40543dd$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $d9bd3a91f40543dd$export$f5bbd400c2f4426f, (v) => $d9bd3a91f40543dd$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d9bd3a91f40543dd$export$a7c73072b1a182ae;
var $d9bd3a91f40543dd$export$9f27bc3417b4524d;
var $d9bd3a91f40543dd$export$db77ccec0bb4ccac;
var $d9bd3a91f40543dd$export$8392c0c9d3dcbd35;
var $d9bd3a91f40543dd$export$ffb0004e005737fa;
var $d9bd3a91f40543dd$export$b624eff549462981;
var $d9bd3a91f40543dd$export$7897aa7841a5380c;
var $d9bd3a91f40543dd$export$602eac185826482c;
var $d9bd3a91f40543dd$export$e2c29f18771995cb;
var $d9bd3a91f40543dd$export$5f8d39834fd61797;
var $d9bd3a91f40543dd$export$74bf444e3cd11ea5;
var $d9bd3a91f40543dd$export$998bcd577473dd93;
var $d9bd3a91f40543dd$export$92387174baf9b227;
var $d9bd3a91f40543dd$export$ec112efeb987d9c6;
var $d9bd3a91f40543dd$export$b706b080d889d2c9;
var $d9bd3a91f40543dd$export$5be5a87408f70ddc;
var $d9bd3a91f40543dd$export$45a5e7f76e0caa8d;
var $d9bd3a91f40543dd$export$455c2e768291efa6;
var $d9bd3a91f40543dd$export$9522e17588c12572;
var $d9bd3a91f40543dd$export$2110ac352bb060b9;
var $d9bd3a91f40543dd$export$56885ab8b9c456ab;
var $d9bd3a91f40543dd$export$d927fcb6adf8f9de;
var $d9bd3a91f40543dd$export$b82d16f27459e05a;
var $d9bd3a91f40543dd$export$522c17b4f5e123e8;
var $d9bd3a91f40543dd$export$1aabd8a0274ecfd6;
var $d9bd3a91f40543dd$export$3d6c20d97e46b957;
var $d9bd3a91f40543dd$export$9b621391a187a31a;
var $d9bd3a91f40543dd$export$f5bbd400c2f4426f;
"use strict";
var $d9bd3a91f40543dd$var$b = Symbol.for("react.element"), $d9bd3a91f40543dd$var$c = Symbol.for("react.portal"), $d9bd3a91f40543dd$var$d = Symbol.for("react.fragment"), $d9bd3a91f40543dd$var$e = Symbol.for("react.strict_mode"), $d9bd3a91f40543dd$var$f = Symbol.for("react.profiler"), $d9bd3a91f40543dd$var$g = Symbol.for("react.provider"), $d9bd3a91f40543dd$var$h = Symbol.for("react.context"), $d9bd3a91f40543dd$var$k = Symbol.for("react.server_context"), $d9bd3a91f40543dd$var$l = Symbol.for("react.forward_ref"), $d9bd3a91f40543dd$var$m = Symbol.for("react.suspense"), $d9bd3a91f40543dd$var$n = Symbol.for("react.suspense_list"), $d9bd3a91f40543dd$var$p = Symbol.for("react.memo"), $d9bd3a91f40543dd$var$q = Symbol.for("react.lazy"), $d9bd3a91f40543dd$var$t = Symbol.for("react.offscreen"), $d9bd3a91f40543dd$var$u;
$d9bd3a91f40543dd$var$u = Symbol.for("react.module.reference");
function $d9bd3a91f40543dd$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $d9bd3a91f40543dd$var$b:
                switch(a = a.type, a){
                    case $d9bd3a91f40543dd$var$d:
                    case $d9bd3a91f40543dd$var$f:
                    case $d9bd3a91f40543dd$var$e:
                    case $d9bd3a91f40543dd$var$m:
                    case $d9bd3a91f40543dd$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $d9bd3a91f40543dd$var$k:
                            case $d9bd3a91f40543dd$var$h:
                            case $d9bd3a91f40543dd$var$l:
                            case $d9bd3a91f40543dd$var$q:
                            case $d9bd3a91f40543dd$var$p:
                            case $d9bd3a91f40543dd$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $d9bd3a91f40543dd$var$c:
                return r;
        }
    }
}
$d9bd3a91f40543dd$export$a7c73072b1a182ae = $d9bd3a91f40543dd$var$h;
$d9bd3a91f40543dd$export$9f27bc3417b4524d = $d9bd3a91f40543dd$var$g;
$d9bd3a91f40543dd$export$db77ccec0bb4ccac = $d9bd3a91f40543dd$var$b;
$d9bd3a91f40543dd$export$8392c0c9d3dcbd35 = $d9bd3a91f40543dd$var$l;
$d9bd3a91f40543dd$export$ffb0004e005737fa = $d9bd3a91f40543dd$var$d;
$d9bd3a91f40543dd$export$b624eff549462981 = $d9bd3a91f40543dd$var$q;
$d9bd3a91f40543dd$export$7897aa7841a5380c = $d9bd3a91f40543dd$var$p;
$d9bd3a91f40543dd$export$602eac185826482c = $d9bd3a91f40543dd$var$c;
$d9bd3a91f40543dd$export$e2c29f18771995cb = $d9bd3a91f40543dd$var$f;
$d9bd3a91f40543dd$export$5f8d39834fd61797 = $d9bd3a91f40543dd$var$e;
$d9bd3a91f40543dd$export$74bf444e3cd11ea5 = $d9bd3a91f40543dd$var$m;
$d9bd3a91f40543dd$export$998bcd577473dd93 = $d9bd3a91f40543dd$var$n;
$d9bd3a91f40543dd$export$92387174baf9b227 = function() {
    return !1;
};
$d9bd3a91f40543dd$export$ec112efeb987d9c6 = function() {
    return !1;
};
$d9bd3a91f40543dd$export$b706b080d889d2c9 = function(a) {
    return $d9bd3a91f40543dd$var$v(a) === $d9bd3a91f40543dd$var$h;
};
$d9bd3a91f40543dd$export$5be5a87408f70ddc = function(a) {
    return $d9bd3a91f40543dd$var$v(a) === $d9bd3a91f40543dd$var$g;
};
$d9bd3a91f40543dd$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $d9bd3a91f40543dd$var$b;
};
$d9bd3a91f40543dd$export$455c2e768291efa6 = function(a) {
    return $d9bd3a91f40543dd$var$v(a) === $d9bd3a91f40543dd$var$l;
};
$d9bd3a91f40543dd$export$9522e17588c12572 = function(a) {
    return $d9bd3a91f40543dd$var$v(a) === $d9bd3a91f40543dd$var$d;
};
$d9bd3a91f40543dd$export$2110ac352bb060b9 = function(a) {
    return $d9bd3a91f40543dd$var$v(a) === $d9bd3a91f40543dd$var$q;
};
$d9bd3a91f40543dd$export$56885ab8b9c456ab = function(a) {
    return $d9bd3a91f40543dd$var$v(a) === $d9bd3a91f40543dd$var$p;
};
$d9bd3a91f40543dd$export$d927fcb6adf8f9de = function(a) {
    return $d9bd3a91f40543dd$var$v(a) === $d9bd3a91f40543dd$var$c;
};
$d9bd3a91f40543dd$export$b82d16f27459e05a = function(a) {
    return $d9bd3a91f40543dd$var$v(a) === $d9bd3a91f40543dd$var$f;
};
$d9bd3a91f40543dd$export$522c17b4f5e123e8 = function(a) {
    return $d9bd3a91f40543dd$var$v(a) === $d9bd3a91f40543dd$var$e;
};
$d9bd3a91f40543dd$export$1aabd8a0274ecfd6 = function(a) {
    return $d9bd3a91f40543dd$var$v(a) === $d9bd3a91f40543dd$var$m;
};
$d9bd3a91f40543dd$export$3d6c20d97e46b957 = function(a) {
    return $d9bd3a91f40543dd$var$v(a) === $d9bd3a91f40543dd$var$n;
};
$d9bd3a91f40543dd$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $d9bd3a91f40543dd$var$d || a === $d9bd3a91f40543dd$var$f || a === $d9bd3a91f40543dd$var$e || a === $d9bd3a91f40543dd$var$m || a === $d9bd3a91f40543dd$var$n || a === $d9bd3a91f40543dd$var$t || "object" === typeof a && null !== a && (a.$$typeof === $d9bd3a91f40543dd$var$q || a.$$typeof === $d9bd3a91f40543dd$var$p || a.$$typeof === $d9bd3a91f40543dd$var$g || a.$$typeof === $d9bd3a91f40543dd$var$h || a.$$typeof === $d9bd3a91f40543dd$var$l || a.$$typeof === $d9bd3a91f40543dd$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$d9bd3a91f40543dd$export$f5bbd400c2f4426f = $d9bd3a91f40543dd$var$v;

});

parcelRegister("hz7px", function(module, exports) {

$parcel$export(module.exports, "DiceRoller", () => DiceRoller);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jv7bZ = parcelRequire("jv7bZ");

var $4Uh7a = parcelRequire("4Uh7a");
var $jnHKE = parcelRequire("jnHKE");
var $bAJM4 = parcelRequire("bAJM4");
var $h5DBq = parcelRequire("h5DBq");
var $eTcXV = parcelRequire("eTcXV");
var $3liF5 = parcelRequire("3liF5");
var $cwPDC = parcelRequire("cwPDC");
var $VoMtX = parcelRequire("VoMtX");

var $AWXcC = parcelRequire("AWXcC");
var $8p4qI = parcelRequire("8p4qI");
var $llc8B = parcelRequire("llc8B");

var $igqD6 = parcelRequire("igqD6");

var $eqoJO = parcelRequire("eqoJO");

var $ggrpt = parcelRequire("ggrpt");
parcelRequire("8vlVz");

var $lTvyy = parcelRequire("lTvyy");

var $ii71U = parcelRequire("ii71U");

var $f1q41 = parcelRequire("f1q41");
let roller = new (0, $eqoJO.DiceRoller)();
function evaluateRoll(successLevels, roll) {
    return successLevels.filter((config)=>{
        return config.condition.every((condition)=>{
            return eval(`${roll} ${condition}`);
        });
    });
}
function colorizeDataBySuccessLevels(successLevels11, data11) {
    let backgroundColor11 = {};
    data11.forEach((entry11)=>{
        let matchingSuccessLevel11 = evaluateRoll(successLevels11, entry11.roll);
        if (matchingSuccessLevel11.length > 2) throw new Error("Cannot match more than two labels.");
        backgroundColor11[entry11.roll] = matchingSuccessLevel11[0]?.style?.fillStyle ?? "grey";
        entry11.successLevel = matchingSuccessLevel11[0];
        matchingSuccessLevel11[0].data[entry11.roll] = entry11.percent;
    });
    successLevels11.forEach((config11)=>{
        config11.percent = 0;
        Object.values(config11.data).forEach((value11)=>{
            config11.percent += value11;
        });
    });
    let lower11 = 0;
    successLevels11.forEach((config11)=>{
        config11.thisOrLower = lower11 + config11.percent;
        config11.thisOrHigher = 100 - lower11;
        lower11 += config11.percent;
    });
    // A cute way of removing 'empty' elements.
    backgroundColor11 = Object.entries(backgroundColor11).sort((a11, b11)=>Number(a11[0]) - Number(b11[0])).map(([key11, value11])=>value11);
    return [
        successLevels11,
        backgroundColor11
    ];
}
const colors = [
    "crimson",
    "darkorange",
    "gold",
    "chartreuse",
    "dodgerblue"
];
function defaultLevelsConfig() {
    return {
        label: "Roll",
        style: {
            fillStyle: "dodgerblue"
        },
        condition: [
            ">= -Infinity"
        ],
        data: {},
        percent: 0,
        thisOrHigher: 0,
        thisOrLower: 0
    };
}
// currently ignores middle levels w/o numbers
function parseSuccessLevelsString(successLevelsString11) {
    // let thresholdRegex = /\s*(\d+(?:-(\d+))?)?\s*(.+)?/
    let thresholdRegex11 = /\s*(?:(\d+)(?:-(\d+))?)?\s*(.+)?/;
    let sep11 = "__SEP__";
    return successLevelsString11.replace(/,\s*(\d+)/g, `${sep11}$1`).split(sep11).reduce((all11, thresholdString11, index11, array11)=>{
        let [, lowerBound11, upperBound11, label11] = thresholdString11.match(thresholdRegex11);
        let isLast11 = index11 === array11.length - 1;
        let parsedLowerBound11 = Number(lowerBound11);
        let parsedUpperBound11 = Number(upperBound11);
        let hasLowerBound11 = !Number.isNaN(parsedLowerBound11);
        let hasUpperBound11 = !Number.isNaN(parsedUpperBound11);
        let min11 = hasLowerBound11 ? parsedLowerBound11 : undefined;
        let max11 = hasUpperBound11 ? parsedUpperBound11 : undefined;
        let previousThreshold11 = all11[all11.length - 1];
        // To keep this simple, each time we look at a bound, we also check to see if we should "fix" the previous bound. This allows us to make sure we're not leaving any gaps. The only time we can't do that is at the very end, so we have to handle that as well.
        if (hasLowerBound11) {
            let previousMaxShouldBe11 = min11 - 1;
            if (!previousThreshold11) all11.push({
                threshold: undefined,
                min: undefined,
                max: previousMaxShouldBe11,
                label: undefined
            });
            else // correct previous threshold
            if (previousThreshold11.max < previousMaxShouldBe11) all11.push({
                threshold: previousThreshold11.max + 1,
                min: previousThreshold11.max + 1,
                max: previousMaxShouldBe11,
                label: undefined
            });
            else previousThreshold11.max;
        }
        all11.push({
            threshold: min11,
            min: min11,
            max: max11,
            label: label11
        });
        if (isLast11 && hasUpperBound11) all11.push({
            threshold: max11 + 1,
            min: max11 + 1,
            max: undefined,
            label: undefined
        });
        return all11;
    }, []).sort((a11, b11)=>a11.threshold - b11.threshold);
}
function buildSuccessLevelsString(successLevels11) {
    return successLevels11.reduce((string11, level11, index11)=>{
        let threshold11 = [
            level11.threshold,
            level11.label
        ].filter((item11)=>item11).join(" ");
        return string11 + (index11 !== 0 ? ", " : "") + threshold11;
    }, "");
}
function generateCondition(index11, allIncs11) {
    let level11 = allIncs11[index11];
    let nextLevel11 = allIncs11[index11 + 1];
    let isFirst11 = index11 === 0;
    let isLast11 = !nextLevel11;
    if (isFirst11 && isLast11) {
        let friendlyCondition11 = "All values";
        let condition11 = [
            "\u221E"
        ];
        return {
            condition: condition11,
            friendlyCondition: friendlyCondition11
        };
    } else if (isFirst11) {
        let friendlyCondition11 = `${Number(nextLevel11.threshold) - 1} or lower`;
        let condition11 = [
            `< ${nextLevel11.threshold}`
        ];
        return {
            condition: condition11,
            friendlyCondition: friendlyCondition11
        };
    } else if (isLast11) {
        let friendlyCondition11 = `${level11.threshold} or higher`;
        let condition11 = [
            `>= ${level11.threshold}`
        ];
        return {
            condition: condition11,
            friendlyCondition: friendlyCondition11
        };
    } else {
        let friendlyCondition11 = `${level11.threshold} to ${Number(nextLevel11.threshold) - 1}`;
        let condition11 = [
            `>= ${level11.threshold}`,
            `< ${nextLevel11.threshold}`
        ];
        return {
            condition: condition11,
            friendlyCondition: friendlyCondition11
        };
    }
}
function generateSuccessLevelsFromString(successLevelsString11) {
    let configs11 = [];
    parseSuccessLevelsString(successLevelsString11).forEach((level11, index11, allIncs11)=>{
        const { condition: condition11, friendlyCondition: friendlyCondition11 } = generateCondition(index11, allIncs11);
        configs11.push({
            threshold: level11.threshold,
            label: level11.label || friendlyCondition11,
            style: {
                fillStyle: colors[configs11.length % colors.length]
            },
            condition: condition11,
            friendlyCondition: friendlyCondition11,
            data: {},
            percent: 0,
            thisOrHigher: 0,
            thisOrLower: 0
        });
    });
    if (configs11.length === 0) configs11.push(defaultLevelsConfig());
    return configs11;
}
function getGraphConfig(levelsString11 = "", data11) {
    let result11 = [];
    try {
        let successLevels11 = generateSuccessLevelsFromString(levelsString11);
        result11 = colorizeDataBySuccessLevels(successLevels11, data11);
    } catch (e11) {
        let successLevels11 = [
            defaultLevelsConfig()
        ];
        result11 = colorizeDataBySuccessLevels(successLevels11, data11);
    }
    return result11;
}
function generateRollData(rollString11) {
    let internalData11 = {};
    let rolls11 = 200000;
    for(let count11 = rolls11; count11; count11--){
        let roll11;
        try {
            roll11 = roller.rollValue(rollString11);
        } catch (e11) {
            roll11 = 1;
        }
        if (!internalData11[roll11]) internalData11[roll11] = 0;
        internalData11[roll11]++;
    }
    let lower11 = 0;
    return Object.keys(internalData11).map((key11)=>{
        return {
            roll: key11,
            count: internalData11[key11],
            percent: internalData11[key11] / rolls11 * 100
        };
    }).sort((a11, b11)=>Number(a11.roll) - Number(b11.roll)).map((roll11)=>{
        roll11.thisOrLower = lower11 + roll11.percent;
        roll11.thisOrHigher = 100 - lower11;
        lower11 += roll11.percent;
        return roll11;
    });
}
const setRollData = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).debounce((setRollData11, setLoading11, rollString11)=>{
    setRollData11(generateRollData(rollString11));
    setLoading11(false);
}, 1000);
const DiceRoller = ()=>{
    const [rollString11, setRollString11] = (0, $lTvyy.useQueryState)("dice", "2d6");
    const [loading11, setLoading11] = (0, $acw62.useState)(false);
    const [data11, setData11] = (0, $acw62.useState)(()=>generateRollData(rollString11));
    const [successLevelsString11, setSuccessLevelsString11] = (0, $lTvyy.useQueryState)("success-levels", "Failure, 7 Partial success, 10 Complete success");
    const [successLevels11, bgColorConfig11] = getGraphConfig(successLevelsString11, data11);
    const inputCss11 = (0, $igqD6.css)`
    font-family: Arial;
    font-size: 20px;
    margin: 0;
    border-radius: 3px;
    padding: 3.5px 10px;
  `;
    const chartRef11 = (0, $acw62.useRef)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $igqD6.css)`
    height: 100%;
    font-family: Arial; 
    font-weight: 100; 
    display: grid; 
    grid-template-columns: 3fr 5fr; 
    column-gap: 30px;
  `,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(Roller, {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: (0, $igqD6.css)`
          display: grid;
          grid-template-columns: 1fr 2fr;
          column-gap: 20px;
          margin-bottom: 20px;`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $h5DBq.default), {
                                className: (0, $igqD6.css)`gap: 5px;`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTcXV.default), {
                                        placeholder: "d1",
                                        className: inputCss11,
                                        value: rollString11,
                                        onChange: ({ target: target11 })=>{
                                            setLoading11(true);
                                            setRollString11(target11.value);
                                            setRollData(setData11, setLoading11, target11.value);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $VoMtX.default), {
                                        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                "Check out the Roll20 Dice Specification doc to see what kinds of rolls are supported!",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                "(Opens in a new window.)"
                                            ]
                                        }),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Uh7a.default), {
                                            href: "https://help.roll20.net/hc/en-us/articles/360037773133-Dice-Reference#DiceReference-Roll20DiceSpecification",
                                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $llc8B.default), {}),
                                            shape: "circle",
                                            size: "small",
                                            type: "text",
                                            target: "_blank"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Uh7a.default), {
                                size: "large",
                                onClick: ()=>{
                                    performRoll({
                                        key: `${rollString11}:${successLevelsString11}`,
                                        diceRoll: rollString11,
                                        rolls: [],
                                        successLevels: successLevels11
                                    });
                                },
                                children: "Roll this"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3liF5.default), {
                        spinning: loading11,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)(Thresholds, {
                                successLevels: successLevels11,
                                successLevelsString: successLevelsString11,
                                setSuccessLevelsString: setSuccessLevelsString11,
                                data: data11
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jv7bZ.Bar), {
                                ref: chartRef11,
                                data: {
                                    datasets: [
                                        {
                                            data: data11,
                                            backgroundColor: bgColorConfig11
                                        }
                                    ]
                                },
                                options: {
                                    scales: {
                                        x: {
                                            title: {
                                                display: true,
                                                text: "Result rolled"
                                            }
                                        },
                                        y: {
                                            display: false
                                        }
                                    },
                                    parsing: {
                                        xAxisKey: "roll",
                                        yAxisKey: "percent"
                                    },
                                    plugins: {
                                        // legend: {
                                        //   labels: {
                                        //     generateLabels: (...args) => {
                                        //       return successLevels.map(config => {
                                        //         return { text: `${config.label} (~${Math.round(config.percent)}%)`, ...config.style }
                                        //       })
                                        //     }
                                        //   }
                                        // },
                                        legend: false,
                                        tooltip: {
                                            callbacks: {
                                                title (data11) {
                                                    const { label: label11, raw: raw11 } = data11[0];
                                                    return `Roll of ${label11} (${raw11.successLevel.label})`;
                                                },
                                                label (data11) {
                                                    const { raw: raw11 } = data11;
                                                    return ` ${(0, $ggrpt.round)(raw11.percent, 2)}%`;
                                                },
                                                // beforeBody (data) { return 'beforeBody' },
                                                // beforeLabel () { return 'beforeLabel' },
                                                // afterLabel () { return 'afterLabel' },
                                                afterBody (data11) {
                                                    return `\n${data11[0].label} or higher: ${Math.round(data11[0].raw.thisOrHigher)}%\n${data11[0].label} or lower: ${Math.round(data11[0].raw.thisOrLower)}%`;
                                                }
                                            }
                                        }
                                    }
                                },
                                onClick: (event11)=>{
                                    let clickedBar11 = (0, $jv7bZ.getElementAtEvent)(chartRef11.current, event11)[0];
                                    if (clickedBar11) setSuccessLevelsString11(clickedBar11.element.$context.raw.roll);
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const [useRollerConfigs, setRollerConfigs] = (0, $ii71U.makeStateHook)({});
let id = 0;
const Thresholds = ({ successLevels: successLevels11, successLevelsString: successLevelsString11, setSuccessLevelsString: setSuccessLevelsString11, data: data11 })=>{
    const [editAsText11, setEditAsText11] = (0, $acw62.useState)(false);
    const [isEditing11, setIsEditing11] = (0, $acw62.useState)(false);
    const [editState11, setEditState11] = (0, $acw62.useState)(null);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: isEditing11 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                editAsText11 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTcXV.default).TextArea, {
                            autoSize: true,
                            value: editState11,
                            onChange: (event11)=>{
                                setEditState11(event11.target.value);
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jnHKE.default), {
                            className: (0, $igqD6.css)`margin-top: 10px;`,
                            size: "small",
                            title: "Preview",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)(RenderThresholds, {
                                successLevels: getGraphConfig(editState11.split(/\n/g).join(", "), data11)[0]
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: (0, $igqD6.css)`
                  display: grid;
                  grid-template-columns: auto 1fr 50px;
                  column-gap: 20px;
                  row-gap: 10px;
                  margin-bottom: 10px;
                `,
                            children: editState11.map((currentLevel11, index11, allSuccessLevels11)=>{
                                let nextLevel11 = allSuccessLevels11[index11 + 1];
                                let isFirst11 = index11 === 0;
                                let isLast11 = !nextLevel11;
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTcXV.default), {
                                            value: currentLevel11.label,
                                            onChange: ({ target: target11 })=>{
                                                setEditState11((editState11)=>{
                                                    let newEditState11 = [
                                                        ...editState11
                                                    ];
                                                    newEditState11[index11] = {
                                                        ...currentLevel11,
                                                        label: target11.value
                                                    };
                                                    return newEditState11;
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: (0, $igqD6.css)` display: flex; column-gap: 20px;`,
                                            children: isFirst11 || isLast11 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: (0, $igqD6.css)`white-space: nowrap;`,
                                                        children: "\u2264"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTcXV.default), {
                                                        placeholder: "0",
                                                        // There's some quirky behaviour inferring the thresholds if it's first or last.
                                                        value: isFirst11 && isLast11 ? "" : isFirst11 ? nextLevel11.threshold - 1 : currentLevel11.threshold,
                                                        onChange: ({ target: target11 })=>{
                                                            setEditState11((editState11)=>{
                                                                let newEditState11 = [
                                                                    ...editState11
                                                                ];
                                                                newEditState11[index11 + 1] = {
                                                                    ...nextLevel11,
                                                                    threshold: Number(target11.value) + 1
                                                                };
                                                                return newEditState11;
                                                            });
                                                        }
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTcXV.default), {
                                                        placeholder: "0",
                                                        value: currentLevel11.threshold,
                                                        onChange: ({ target: target11 })=>{
                                                            setEditState11((editState11)=>{
                                                                let newEditState11 = [
                                                                    ...editState11
                                                                ];
                                                                newEditState11[index11] = {
                                                                    ...currentLevel11,
                                                                    threshold: Number(target11.value)
                                                                };
                                                                return newEditState11;
                                                            });
                                                        }
                                                    }),
                                                    "-",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTcXV.default), {
                                                        placeholder: "0",
                                                        value: nextLevel11.threshold - 1,
                                                        onChange: ({ target: target11 })=>{
                                                            setEditState11((editState11)=>{
                                                                let newEditState11 = [
                                                                    ...editState11
                                                                ];
                                                                newEditState11[index11 + 1] = {
                                                                    ...nextLevel11,
                                                                    threshold: Number(target11.value) + 1
                                                                };
                                                                return newEditState11;
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Uh7a.default), {
                                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $AWXcC.default), {}),
                                            shape: "circle",
                                            onClick: ()=>{
                                                setEditState11((editState11)=>{
                                                    let newEditState11 = editState11.filter((level11)=>level11.id !== currentLevel11.id);
                                                    return newEditState11;
                                                });
                                            }
                                        })
                                    ]
                                }, currentLevel11.id);
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Uh7a.default), {
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8p4qI.default), {}),
                            onClick: ()=>{
                                setEditState11((editState11)=>{
                                    return [
                                        ...editState11,
                                        {
                                            threshold: 0,
                                            secondaryThreshold: undefined,
                                            label: "",
                                            id: id++
                                        }
                                    ];
                                });
                            },
                            children: "Add threshold"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jnHKE.default), {
                            className: (0, $igqD6.css)`margin-top: 10px;`,
                            size: "small",
                            title: "Preview",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)(RenderThresholds, {
                                successLevels: getGraphConfig(buildSuccessLevelsString(editState11).split(/\n/g).join(", "), data11)[0]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $h5DBq.default), {
                    gap: "small",
                    className: (0, $igqD6.css)`
              margin-top: 10px;
              display: flex;
              justify-content: center;
            `,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Uh7a.default), {
                            onClick: ()=>{
                                if (editAsText11) setSuccessLevelsString11(editState11.split(/\n/g).join(", "));
                                else setSuccessLevelsString11(buildSuccessLevelsString(editState11));
                                setIsEditing11(false);
                            },
                            children: "Save thresholds"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Uh7a.default), {
                            onClick: ()=>{
                                setIsEditing11(false);
                            },
                            children: "Cancel changes"
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $h5DBq.default), {
            className: (0, $igqD6.css)`
          flex-direction: row;
          justify-content: center;
          align-items: center;
        `,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)(RenderThresholds, {
                    successLevels: successLevels11
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $h5DBq.default), {
                    className: (0, $igqD6.css)`
              margin-left: 20px;
              flex-direction: column;
              display: flex;
              justify-content: center;
              button {
                text-align: left;
                font-size: 12px !important;
                color: gray;
              }
            `,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Uh7a.default), {
                            type: "text",
                            size: "small",
                            onClick: ()=>{
                                setEditState11(successLevels11.map((level11)=>({
                                        threshold: level11.threshold,
                                        label: level11.label,
                                        id: id++
                                    })));
                                setEditAsText11(false);
                                setIsEditing11(true);
                            },
                            children: "Edit thresholds"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Uh7a.default), {
                            type: "text",
                            size: "small",
                            onClick: ()=>{
                                setEditState11(successLevelsString11.replace(/,\s+/g, "\n"));
                                setEditAsText11(true);
                                setIsEditing11(true);
                            },
                            children: "Edit thresholds as text"
                        })
                    ]
                })
            ]
        })
    });
};
const RenderThresholds = ({ successLevels: successLevels11 })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $igqD6.css)`
        display: grid;
        grid-template-columns: max-content max-content max-content max-content;
        column-gap: 20px;
      `,
        children: successLevels11.map((level11, index11)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: (0, $igqD6.css)`
                background-color: ${level11.style.fillStyle};
                border: 2px solid gray;
                margin: 2px;
                width: 40px;
              `
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: level11.label
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: level11.friendlyCondition
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            "~",
                            Math.round(level11.percent),
                            "%",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $VoMtX.default), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: (0, $igqD6.css)`display: flex; flex-direction: column; gap: 20px;`,
                                    children: [
                                        index11 !== 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "If trying to roll high:"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                "~",
                                                Math.round(level11.thisOrHigher),
                                                "% chance to meet or beat ",
                                                level11.label
                                            ]
                                        }),
                                        index11 !== successLevels11.length - 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "If trying to roll low:"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                "~",
                                                Math.round(level11.thisOrLower),
                                                "% chance to meet or beat ",
                                                level11.label
                                            ]
                                        })
                                    ]
                                }),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Uh7a.default), {
                                    href: "https://help.roll20.net/hc/en-us/articles/360037773133-Dice-Reference#DiceReference-Roll20DiceSpecification",
                                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $llc8B.default), {}),
                                    shape: "circle",
                                    size: "small",
                                    type: "text",
                                    target: "_blank"
                                })
                            })
                        ]
                    })
                ]
            }, level11.label);
        })
    });
};
const Roller = ()=>{
    const [rollerConfigs11] = useRollerConfigs();
    let rollersElements11 = Object.values(rollerConfigs11).map((roller11)=>/*#__PURE__*/ (0, $ayMG0.jsx)(Panel, {
            rollerConfig: roller11
        }, roller11.key));
    if (rollersElements11.length === 0) return "No dice rolls yet. Enter a dice roll (and optional success levels) and click 'Roll this'.";
    else return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: rollersElements11
    });
};
function performRoll(rollerConfig11) {
    setRollerConfigs((rollerConfigs11)=>{
        let newRollerConfigs11 = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep(rollerConfigs11);
        let thisRollerConfig11 = newRollerConfigs11[rollerConfig11.key];
        if (!thisRollerConfig11) {
            thisRollerConfig11 = rollerConfig11;
            newRollerConfigs11[thisRollerConfig11.key] = thisRollerConfig11;
        }
        thisRollerConfig11.active = true;
        let rollValue11 = roller.rollValue(thisRollerConfig11.diceRoll);
        let matchedLevels11 = evaluateRoll(thisRollerConfig11.successLevels, rollValue11);
        thisRollerConfig11.rolls.unshift({
            value: rollValue11,
            levelText: matchedLevels11[0].label,
            levelColor: matchedLevels11[0].style.fillStyle,
            level: matchedLevels11[0]
        });
        return newRollerConfigs11;
    });
}
const Panel = ({ rollerConfig: rollerConfig11 })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bAJM4.default), {
        ghost: true,
        activeKey: rollerConfig11.active ? [
            "key"
        ] : [],
        onChange: ()=>{
            setRollerConfigs((rollerConfigs11)=>{
                let newRollerConfigs11 = {
                    ...rollerConfigs11
                };
                newRollerConfigs11[rollerConfig11.key].active = !newRollerConfigs11[rollerConfig11.key].active;
                return newRollerConfigs11;
            });
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bAJM4.default).Panel, {
            header: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                children: rollerConfig11.diceRoll
            }),
            extra: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Uh7a.default), {
                        onClick: (event11)=>{
                            event11.stopPropagation();
                            performRoll(rollerConfig11);
                        },
                        type: "prim",
                        size: "small",
                        children: "Roll"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Uh7a.default), {
                        onClick: (event11)=>{
                            event11.stopPropagation();
                            setRollerConfigs((rollerConfigs11)=>{
                                let newRollerConfigs11 = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep(rollerConfigs11);
                                newRollerConfigs11[rollerConfig11.key].rolls = [];
                                return newRollerConfigs11;
                            });
                        },
                        type: "text",
                        size: "small",
                        children: "Clear rolls"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Uh7a.default), {
                        onClick: (event11)=>{
                            event11.stopPropagation();
                            setRollerConfigs((rollerConfigs11)=>{
                                let newRollerConfigs11 = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep(rollerConfigs11);
                                delete newRollerConfigs11[rollerConfig11.key];
                                return newRollerConfigs11;
                            });
                        },
                        type: "text",
                        size: "small",
                        danger: true,
                        children: "Remove roller"
                    })
                ]
            }),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $igqD6.css)`
          display: grid;
          grid-template-columns: 1fr;
          row-gap: 6px;
        `,
                children: rollerConfig11.rolls.map((roll11, index11)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(ResultTag, {
                            value: roll11.value,
                            label: roll11.levelText,
                            color: roll11.levelColor
                        })
                    }, index11);
                })
            })
        }, "key")
    });
};
const ResultTag = ({ color: color11, value: value11, label: label11 })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cwPDC.default), {
        color: color11,
        className: (0, $igqD6.css)`
        border-radius: 20px;
        padding: 1px 11px 1px 1px;
        display: flex;
        width: max-content;
        font-size: 14px;
        align-items: center;
      `,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $igqD6.css)`
        background: white;
        color: black;
        min-width: 26px;
        height: 26px;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: row;
        font-size: 13px;
        margin-right: 7px;
        font-weight: bold;
        font-size: 20px;
      `,
                children: value11
            }),
            label11
        ]
    });
};

});
parcelRegister("ayMG0", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1b2ls"));

});

parcelRegister("jv7bZ", function(module, exports) {

$parcel$export(module.exports, "getElementAtEvent", () => $e3267dd1fa7af6a7$export$7786cd514625a1ff);
$parcel$export(module.exports, "Bar", () => $e3267dd1fa7af6a7$export$bbc6c6369b38e3d1);

var $acw62 = parcelRequire("acw62");

var $gorid = parcelRequire("gorid");
const $e3267dd1fa7af6a7$var$defaultDatasetIdKey = "label";
function $e3267dd1fa7af6a7$var$reforwardRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}
function $e3267dd1fa7af6a7$var$setOptions(chart, nextOptions) {
    Object.assign(chart.options, nextOptions);
}
function $e3267dd1fa7af6a7$var$setLabels(currentData, nextLabels) {
    currentData.labels = nextLabels;
}
function $e3267dd1fa7af6a7$var$setDatasets(currentData, nextDatasets) {
    let datasetIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $e3267dd1fa7af6a7$var$defaultDatasetIdKey;
    const addedDatasets = [];
    currentData.datasets = nextDatasets.map((nextDataset)=>{
        // given the new set, find it's current match
        const currentDataset = currentData.datasets.find((dataset)=>dataset[datasetIdKey] === nextDataset[datasetIdKey]);
        // There is no original to update, so simply add new one
        if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) return {
            ...nextDataset
        };
        addedDatasets.push(currentDataset);
        Object.assign(currentDataset, nextDataset);
        return currentDataset;
    });
}
function $e3267dd1fa7af6a7$var$cloneData(data) {
    let datasetIdKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $e3267dd1fa7af6a7$var$defaultDatasetIdKey;
    const nextData = {
        labels: [],
        datasets: []
    };
    $e3267dd1fa7af6a7$var$setLabels(nextData, data.labels);
    $e3267dd1fa7af6a7$var$setDatasets(nextData, data.datasets, datasetIdKey);
    return nextData;
}
/**
 * Get dataset from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $e3267dd1fa7af6a7$export$b2390aa6eb9120be(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "dataset", {
        intersect: true
    }, false);
}
/**
 * Get single dataset element from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $e3267dd1fa7af6a7$export$7786cd514625a1ff(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "nearest", {
        intersect: true
    }, false);
}
/**
 * Get all dataset elements from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $e3267dd1fa7af6a7$export$6e8ebb3a5733e348(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "index", {
        intersect: true
    }, false);
}
function $e3267dd1fa7af6a7$var$ChartComponent(param, ref) {
    let { height: height = 150, width: width = 300, redraw: redraw = false, datasetIdKey: datasetIdKey, type: type, data: data, options: options, plugins: plugins = [], fallbackContent: fallbackContent, updateMode: updateMode, ...props } = param;
    const canvasRef = (0, $acw62.useRef)(null);
    const chartRef = (0, $acw62.useRef)();
    const renderChart = ()=>{
        if (!canvasRef.current) return;
        chartRef.current = new (0, $gorid.Chart)(canvasRef.current, {
            type: type,
            data: $e3267dd1fa7af6a7$var$cloneData(data, datasetIdKey),
            options: options && {
                ...options
            },
            plugins: plugins
        });
        $e3267dd1fa7af6a7$var$reforwardRef(ref, chartRef.current);
    };
    const destroyChart = ()=>{
        $e3267dd1fa7af6a7$var$reforwardRef(ref, null);
        if (chartRef.current) {
            chartRef.current.destroy();
            chartRef.current = null;
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (!redraw && chartRef.current && options) $e3267dd1fa7af6a7$var$setOptions(chartRef.current, options);
    }, [
        redraw,
        options
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!redraw && chartRef.current) $e3267dd1fa7af6a7$var$setLabels(chartRef.current.config.data, data.labels);
    }, [
        redraw,
        data.labels
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!redraw && chartRef.current && data.datasets) $e3267dd1fa7af6a7$var$setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
    }, [
        redraw,
        data.datasets
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!chartRef.current) return;
        if (redraw) {
            destroyChart();
            setTimeout(renderChart);
        } else chartRef.current.update(updateMode);
    }, [
        redraw,
        options,
        data.labels,
        data.datasets,
        updateMode
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!chartRef.current) return;
        destroyChart();
        setTimeout(renderChart);
    }, [
        type
    ]);
    (0, $acw62.useEffect)(()=>{
        renderChart();
        return ()=>destroyChart();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("canvas", Object.assign({
        ref: canvasRef,
        role: "img",
        height: height,
        width: width
    }, props), fallbackContent);
}
const $e3267dd1fa7af6a7$export$acaa6426d77a227e = /*#__PURE__*/ (0, $acw62.forwardRef)($e3267dd1fa7af6a7$var$ChartComponent);
function $e3267dd1fa7af6a7$var$createTypedChart(type, registerables) {
    (0, $gorid.Chart).register(registerables);
    return /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e3267dd1fa7af6a7$export$acaa6426d77a227e, Object.assign({}, props, {
            ref: ref,
            type: type
        })));
}
const $e3267dd1fa7af6a7$export$17d680238e50603e = /* #__PURE__ */ $e3267dd1fa7af6a7$var$createTypedChart("line", (0, $gorid.LineController));
const $e3267dd1fa7af6a7$export$bbc6c6369b38e3d1 = /* #__PURE__ */ $e3267dd1fa7af6a7$var$createTypedChart("bar", (0, $gorid.BarController));
const $e3267dd1fa7af6a7$export$bace472c466fdd25 = /* #__PURE__ */ $e3267dd1fa7af6a7$var$createTypedChart("radar", (0, $gorid.RadarController));
const $e3267dd1fa7af6a7$export$b8b3cfdc3fe36b10 = /* #__PURE__ */ $e3267dd1fa7af6a7$var$createTypedChart("doughnut", (0, $gorid.DoughnutController));
const $e3267dd1fa7af6a7$export$d0dcaac1fc41ea1e = /* #__PURE__ */ $e3267dd1fa7af6a7$var$createTypedChart("polarArea", (0, $gorid.PolarAreaController));
const $e3267dd1fa7af6a7$export$646feb54fbadbe06 = /* #__PURE__ */ $e3267dd1fa7af6a7$var$createTypedChart("bubble", (0, $gorid.BubbleController));
const $e3267dd1fa7af6a7$export$2ae8800cf67c848c = /* #__PURE__ */ $e3267dd1fa7af6a7$var$createTypedChart("pie", (0, $gorid.PieController));
const $e3267dd1fa7af6a7$export$1c460fb4285edadc = /* #__PURE__ */ $e3267dd1fa7af6a7$var$createTypedChart("scatter", (0, $gorid.ScatterController));

});
parcelRegister("gorid", function(module, exports) {

$parcel$export(module.exports, "BarController", () => $1af551c56cb88ebf$export$e97d5dc64e999004);
$parcel$export(module.exports, "BubbleController", () => $1af551c56cb88ebf$export$19b5c4773f17abe);
$parcel$export(module.exports, "DoughnutController", () => $1af551c56cb88ebf$export$e04603e7d8b77172);
$parcel$export(module.exports, "LineController", () => $1af551c56cb88ebf$export$3c9b5d28c11cbfd0);
$parcel$export(module.exports, "PolarAreaController", () => $1af551c56cb88ebf$export$2a270b3a0d973c85);
$parcel$export(module.exports, "PieController", () => $1af551c56cb88ebf$export$b21a3f1286706191);
$parcel$export(module.exports, "RadarController", () => $1af551c56cb88ebf$export$48dbc6ac651bf8be);
$parcel$export(module.exports, "ScatterController", () => $1af551c56cb88ebf$export$b2f2bae6713db87);
$parcel$export(module.exports, "Chart", () => $1af551c56cb88ebf$export$acaa6426d77a227e);
$parcel$export(module.exports, "registerables", () => $1af551c56cb88ebf$export$e8959e79e3af550f);
/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */ 
var $9seh1 = parcelRequire("9seh1");
class $1af551c56cb88ebf$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $9seh1.r).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, "progress");
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, "complete");
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), "complete");
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $1af551c56cb88ebf$export$a424a0aa8f687495 = new $1af551c56cb88ebf$var$Animator();
const $1af551c56cb88ebf$var$transparent = "transparent";
const $1af551c56cb88ebf$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $9seh1.c)(from || $1af551c56cb88ebf$var$transparent);
        const c1 = c0.valid && (0, $9seh1.c)(to || $1af551c56cb88ebf$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $1af551c56cb88ebf$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $9seh1.a)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $9seh1.a)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $1af551c56cb88ebf$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $9seh1.e)[cfg.easing] || (0, $9seh1.e).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $9seh1.a)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $9seh1.a)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? "res" : "rej";
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
const $1af551c56cb88ebf$var$numbers = [
    "x",
    "y",
    "borderWidth",
    "radius",
    "tension"
];
const $1af551c56cb88ebf$var$colors = [
    "color",
    "borderColor",
    "backgroundColor"
];
(0, $9seh1.d).set("animation", {
    delay: undefined,
    duration: 1000,
    easing: "easeOutQuart",
    fn: undefined,
    from: undefined,
    loop: undefined,
    to: undefined,
    type: undefined
});
const $1af551c56cb88ebf$var$animationOptions = Object.keys((0, $9seh1.d).animation);
(0, $9seh1.d).describe("animation", {
    _fallback: false,
    _indexable: false,
    _scriptable: (name)=>name !== "onProgress" && name !== "onComplete" && name !== "fn"
});
(0, $9seh1.d).set("animations", {
    colors: {
        type: "color",
        properties: $1af551c56cb88ebf$var$colors
    },
    numbers: {
        type: "number",
        properties: $1af551c56cb88ebf$var$numbers
    }
});
(0, $9seh1.d).describe("animations", {
    _fallback: "animation"
});
(0, $9seh1.d).set("transitions", {
    active: {
        animation: {
            duration: 400
        }
    },
    resize: {
        animation: {
            duration: 0
        }
    },
    show: {
        animations: {
            colors: {
                from: "transparent"
            },
            visible: {
                type: "boolean",
                duration: 0
            }
        }
    },
    hide: {
        animations: {
            colors: {
                to: "transparent"
            },
            visible: {
                type: "boolean",
                easing: "linear",
                fn: (v)=>v | 0
            }
        }
    }
});
class $1af551c56cb88ebf$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $9seh1.i)(config)) return;
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $9seh1.i)(cfg)) return;
            const resolved = {};
            for (const option of $1af551c56cb88ebf$var$animationOptions)resolved[option] = cfg[option];
            ((0, $9seh1.b)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $1af551c56cb88ebf$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $1af551c56cb88ebf$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === "$") continue;
            if (prop === "options") {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $1af551c56cb88ebf$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $1af551c56cb88ebf$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $1af551c56cb88ebf$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $1af551c56cb88ebf$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $1af551c56cb88ebf$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $1af551c56cb88ebf$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $1af551c56cb88ebf$var$scaleClip(xScale, allowedOverflow);
    const y = $1af551c56cb88ebf$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $1af551c56cb88ebf$var$toClip(value) {
    let t, r, b, l;
    if ((0, $9seh1.i)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $1af551c56cb88ebf$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $1af551c56cb88ebf$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === "single";
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $9seh1.g)(otherValue) && (singleMode || value === 0 || (0, $9seh1.s)(value) === (0, $9seh1.s)(otherValue))) value += otherValue;
    }
    return value;
}
function $1af551c56cb88ebf$var$convertObjectDataToArray(data) {
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            x: key,
            y: data[key]
        };
    }
    return adata;
}
function $1af551c56cb88ebf$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $1af551c56cb88ebf$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $1af551c56cb88ebf$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $1af551c56cb88ebf$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $1af551c56cb88ebf$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $1af551c56cb88ebf$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $1af551c56cb88ebf$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $1af551c56cb88ebf$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $1af551c56cb88ebf$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $1af551c56cb88ebf$var$getLastIndexInStack(stack, vScale, false, meta.type);
    }
}
function $1af551c56cb88ebf$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $1af551c56cb88ebf$var$createDatasetContext(parent, index) {
    return (0, $9seh1.h)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: "default",
        type: "dataset"
    });
}
function $1af551c56cb88ebf$var$createDataContext(parent, index, element) {
    return (0, $9seh1.h)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: "default",
        type: "data"
    });
}
function $1af551c56cb88ebf$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
    }
}
const $1af551c56cb88ebf$var$isDirectUpdateMode = (mode)=>mode === "reset" || mode === "none";
const $1af551c56cb88ebf$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $1af551c56cb88ebf$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $1af551c56cb88ebf$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $1af551c56cb88ebf$export$75572ec5c55b4048 {
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $1af551c56cb88ebf$var$isStacked(meta.vScale, meta);
        this.addElements();
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $1af551c56cb88ebf$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === "x" ? x : axis === "r" ? r : y;
        const xid = meta.xAxisID = (0, $9seh1.v)(dataset.xAxisID, $1af551c56cb88ebf$var$getFirstScaleId(chart, "x"));
        const yid = meta.yAxisID = (0, $9seh1.v)(dataset.yAxisID, $1af551c56cb88ebf$var$getFirstScaleId(chart, "y"));
        const rid = meta.rAxisID = (0, $9seh1.v)(dataset.rAxisID, $1af551c56cb88ebf$var$getFirstScaleId(chart, "r"));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update("reset");
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $9seh1.u)(this._data, this);
        if (meta._stacked) $1af551c56cb88ebf$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $9seh1.i)(data)) this._data = $1af551c56cb88ebf$var$convertObjectDataToArray(data);
        else if (_data !== data) {
            if (_data) {
                (0, $9seh1.u)(_data, this);
                const meta = this._cachedMeta;
                $1af551c56cb88ebf$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $9seh1.l)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $1af551c56cb88ebf$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $1af551c56cb88ebf$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) $1af551c56cb88ebf$var$updateStacks(this, meta._parsed);
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $9seh1.b)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $9seh1.i)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $1af551c56cb88ebf$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = "x", yAxisKey: yAxisKey = "y" } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $9seh1.f)(item, xAxisKey), index),
                y: yScale.parse((0, $9seh1.f)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $1af551c56cb88ebf$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]
        };
        return $1af551c56cb88ebf$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $1af551c56cb88ebf$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $1af551c56cb88ebf$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $1af551c56cb88ebf$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $9seh1.g)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $9seh1.g)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? "" + iScale.getLabelForValue(parsed[iScale.axis]) : "",
            value: vScale ? "" + vScale.getLabelForValue(parsed[vScale.axis]) : ""
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || "default");
        meta._clip = $1af551c56cb88ebf$var$toClip((0, $9seh1.v)(this.options.clip, $1af551c56cb88ebf$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? "active" : "default";
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $1af551c56cb88ebf$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $1af551c56cb88ebf$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = "default", index) {
        const active = mode === "active";
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + "-" + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $9seh1.j)(index);
        if (cached) return $1af551c56cb88ebf$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            "hover",
            elementType,
            ""
        ] : [
            elementType,
            ""
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $9seh1.d).elements[elementType]);
        const context = ()=>this.getContext(index, active);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($1af551c56cb88ebf$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $1af551c56cb88ebf$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $1af551c56cb88ebf$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($1af551c56cb88ebf$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$1af551c56cb88ebf$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, "reset");
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $1af551c56cb88ebf$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            "_insertElements",
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            "_removeElements",
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            "_removeElements",
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            "_removeElements",
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            "_insertElements",
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            "_insertElements",
            0,
            arguments.length
        ]);
    }
}
$1af551c56cb88ebf$export$75572ec5c55b4048.defaults = {};
$1af551c56cb88ebf$export$75572ec5c55b4048.prototype.datasetElementType = null;
$1af551c56cb88ebf$export$75572ec5c55b4048.prototype.dataElementType = null;
function $1af551c56cb88ebf$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $9seh1._)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $1af551c56cb88ebf$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $1af551c56cb88ebf$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $9seh1.j)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $1af551c56cb88ebf$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $9seh1.k)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $1af551c56cb88ebf$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $1af551c56cb88ebf$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $1af551c56cb88ebf$var$parseValue(entry, item, vScale, i) {
    if ((0, $9seh1.b)(entry)) $1af551c56cb88ebf$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $1af551c56cb88ebf$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($1af551c56cb88ebf$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $1af551c56cb88ebf$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $1af551c56cb88ebf$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $9seh1.s)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $1af551c56cb88ebf$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = "left";
        end = "right";
    } else {
        reverse = properties.base < properties.y;
        start = "bottom";
        end = "top";
    }
    if (reverse) {
        top = "end";
        bottom = "start";
    } else {
        top = "start";
        bottom = "end";
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $1af551c56cb88ebf$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $1af551c56cb88ebf$var$borderProps(properties);
    if (edge === "middle" && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$1af551c56cb88ebf$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$1af551c56cb88ebf$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $1af551c56cb88ebf$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $1af551c56cb88ebf$var$swap(edge, a, b);
        edge = $1af551c56cb88ebf$var$startEnd(edge, b, a);
    } else edge = $1af551c56cb88ebf$var$startEnd(edge, a, b);
    return edge;
}
function $1af551c56cb88ebf$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $1af551c56cb88ebf$var$startEnd(v, start, end) {
    return v === "start" ? start : v === "end" ? end : v;
}
function $1af551c56cb88ebf$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === "auto" ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $1af551c56cb88ebf$export$e97d5dc64e999004 extends $1af551c56cb88ebf$export$75572ec5c55b4048 {
    parsePrimitiveData(meta, data, start, count) {
        return $1af551c56cb88ebf$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $1af551c56cb88ebf$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = "x", yAxisKey: yAxisKey = "y" } = this._parsing;
        const iAxisKey = iScale.axis === "x" ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === "x" ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $9seh1.f)(obj, iAxisKey), i);
            parsed.push($1af551c56cb88ebf$var$parseValue((0, $9seh1.f)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $1af551c56cb88ebf$var$isFloatBar(custom) ? "[" + custom.start + ", " + custom.end + "]" : "" + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: "" + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === "reset";
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $9seh1.k)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $1af551c56cb88ebf$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? "active" : mode);
            const options = properties.options || bars[i].options;
            $1af551c56cb88ebf$var$setBorderSkipped(properties, options, stack, index);
            $1af551c56cb88ebf$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const skipNull = (meta)=>{
            const parsed = meta.controller.getParsed(dataIndex);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $9seh1.k)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $1af551c56cb88ebf$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $1af551c56cb88ebf$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $9seh1.s)(value) !== (0, $9seh1.s)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $9seh1.k)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $1af551c56cb88ebf$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $9seh1.s)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $9seh1.v)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === "flex" ? $1af551c56cb88ebf$var$computeFlexCategoryTraits(index, ruler, options, stackCount) : $1af551c56cb88ebf$var$computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null) rects[i].draw(this._ctx);
    }
}
$1af551c56cb88ebf$export$e97d5dc64e999004.id = "bar";
$1af551c56cb88ebf$export$e97d5dc64e999004.defaults = {
    datasetElementType: false,
    dataElementType: "bar",
    categoryPercentage: 0.8,
    barPercentage: 0.9,
    grouped: true,
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "base",
                "width",
                "height"
            ]
        }
    }
};
$1af551c56cb88ebf$export$e97d5dc64e999004.overrides = {
    scales: {
        _index_: {
            type: "category",
            offset: true,
            grid: {
                offset: true
            }
        },
        _value_: {
            type: "linear",
            beginAtZero: true
        }
    }
};
class $1af551c56cb88ebf$export$19b5c4773f17abe extends $1af551c56cb88ebf$export$75572ec5c55b4048 {
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $9seh1.v)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $9seh1.v)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: meta.label,
            value: "(" + x + ", " + y + (r ? ", " + r : "") + ")"
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== "active") values.radius = 0;
        values.radius += (0, $9seh1.v)(parsed && parsed._custom, radius);
        return values;
    }
}
$1af551c56cb88ebf$export$19b5c4773f17abe.id = "bubble";
$1af551c56cb88ebf$export$19b5c4773f17abe.defaults = {
    datasetElementType: false,
    dataElementType: "point",
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "borderWidth",
                "radius"
            ]
        }
    }
};
$1af551c56cb88ebf$export$19b5c4773f17abe.overrides = {
    scales: {
        x: {
            type: "linear"
        },
        y: {
            type: "linear"
        }
    },
    plugins: {
        tooltip: {
            callbacks: {
                title () {
                    return "";
                }
            }
        }
    }
};
function $1af551c56cb88ebf$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $9seh1.T)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $9seh1.p)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $9seh1.p)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $9seh1.H), startY, endY);
        const minX = calcMin((0, $9seh1.P), startX, endX);
        const minY = calcMin((0, $9seh1.P) + (0, $9seh1.H), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $1af551c56cb88ebf$export$e04603e7d8b77172 extends $1af551c56cb88ebf$export$75572ec5c55b4048 {
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $9seh1.i)(data[start])) {
                const { key: key = "value" } = this._parsing;
                getter = (i)=>+(0, $9seh1.f)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $9seh1.t)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $9seh1.t)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $9seh1.T);
        let max = -(0, $9seh1.T);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i)) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $9seh1.m)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $1af551c56cb88ebf$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $9seh1.n)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $9seh1.T));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === "reset";
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? "active" : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $9seh1.T) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $9seh1.o)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || "",
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== "inner") max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $9seh1.v)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
$1af551c56cb88ebf$export$e04603e7d8b77172.id = "doughnut";
$1af551c56cb88ebf$export$e04603e7d8b77172.defaults = {
    datasetElementType: false,
    dataElementType: "arc",
    animation: {
        animateRotate: true,
        animateScale: false
    },
    animations: {
        numbers: {
            type: "number",
            properties: [
                "circumference",
                "endAngle",
                "innerRadius",
                "outerRadius",
                "startAngle",
                "x",
                "y",
                "offset",
                "borderWidth",
                "spacing"
            ]
        }
    },
    cutout: "50%",
    rotation: 0,
    circumference: 360,
    radius: "100%",
    spacing: 0,
    indexAxis: "r"
};
$1af551c56cb88ebf$export$e04603e7d8b77172.descriptors = {
    _scriptable: (name)=>name !== "spacing",
    _indexable: (name)=>name !== "spacing"
};
$1af551c56cb88ebf$export$e04603e7d8b77172.overrides = {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const { labels: { pointStyle: pointStyle } } = chart.legend.options;
                        return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        },
        tooltip: {
            callbacks: {
                title () {
                    return "";
                },
                label (tooltipItem) {
                    let dataLabel = tooltipItem.label;
                    const value = ": " + tooltipItem.formattedValue;
                    if ((0, $9seh1.b)(dataLabel)) {
                        dataLabel = dataLabel.slice();
                        dataLabel[0] += value;
                    } else dataLabel += value;
                    return dataLabel;
                }
            }
        }
    }
};
class $1af551c56cb88ebf$export$3c9b5d28c11cbfd0 extends $1af551c56cb88ebf$export$75572ec5c55b4048 {
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $9seh1.q)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $9seh1.w)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $9seh1.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $9seh1.k)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
$1af551c56cb88ebf$export$3c9b5d28c11cbfd0.id = "line";
$1af551c56cb88ebf$export$3c9b5d28c11cbfd0.defaults = {
    datasetElementType: "line",
    dataElementType: "point",
    showLine: true,
    spanGaps: false
};
$1af551c56cb88ebf$export$3c9b5d28c11cbfd0.overrides = {
    scales: {
        _index_: {
            type: "category"
        },
        _value_: {
            type: "linear"
        }
    }
};
class $1af551c56cb88ebf$export$2a270b3a0d973c85 extends $1af551c56cb88ebf$export$75572ec5c55b4048 {
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $9seh1.o)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || "",
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $9seh1.y).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === "reset";
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $9seh1.P);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? "active" : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $9seh1.t)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
$1af551c56cb88ebf$export$2a270b3a0d973c85.id = "polarArea";
$1af551c56cb88ebf$export$2a270b3a0d973c85.defaults = {
    dataElementType: "arc",
    animation: {
        animateRotate: true,
        animateScale: true
    },
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "startAngle",
                "endAngle",
                "innerRadius",
                "outerRadius"
            ]
        }
    },
    indexAxis: "r",
    startAngle: 0
};
$1af551c56cb88ebf$export$2a270b3a0d973c85.overrides = {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const { labels: { pointStyle: pointStyle } } = chart.legend.options;
                        return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        },
        tooltip: {
            callbacks: {
                title () {
                    return "";
                },
                label (context) {
                    return context.chart.data.labels[context.dataIndex] + ": " + context.formattedValue;
                }
            }
        }
    },
    scales: {
        r: {
            type: "radialLinear",
            angleLines: {
                display: false
            },
            beginAtZero: true,
            grid: {
                circular: true
            },
            pointLabels: {
                display: false
            },
            startAngle: 0
        }
    }
};
class $1af551c56cb88ebf$export$b21a3f1286706191 extends $1af551c56cb88ebf$export$e04603e7d8b77172 {
}
$1af551c56cb88ebf$export$b21a3f1286706191.id = "pie";
$1af551c56cb88ebf$export$b21a3f1286706191.defaults = {
    cutout: 0,
    rotation: 0,
    circumference: 360,
    radius: "100%"
};
class $1af551c56cb88ebf$export$48dbc6ac651bf8be extends $1af551c56cb88ebf$export$75572ec5c55b4048 {
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: "" + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $9seh1.y).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== "resize") {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === "reset";
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? "active" : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
$1af551c56cb88ebf$export$48dbc6ac651bf8be.id = "radar";
$1af551c56cb88ebf$export$48dbc6ac651bf8be.defaults = {
    datasetElementType: "line",
    dataElementType: "point",
    indexAxis: "r",
    showLine: true,
    elements: {
        line: {
            fill: "start"
        }
    }
};
$1af551c56cb88ebf$export$48dbc6ac651bf8be.overrides = {
    aspectRatio: 1,
    scales: {
        r: {
            type: "radialLinear"
        }
    }
};
class $1af551c56cb88ebf$export$db77ccec0bb4ccac {
    constructor(){
        this.x = undefined;
        this.y = undefined;
        this.active = false;
        this.options = undefined;
        this.$animations = undefined;
    }
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $9seh1.x)(this.x) && (0, $9seh1.x)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
$1af551c56cb88ebf$export$db77ccec0bb4ccac.defaults = {};
$1af551c56cb88ebf$export$db77ccec0bb4ccac.defaultRoutes = undefined;
const $1af551c56cb88ebf$var$formatters = {
    values (value) {
        return (0, $9seh1.b)(value) ? value : "" + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = "scientific";
            delta = $1af551c56cb88ebf$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = (0, $9seh1.z)(Math.abs(delta));
        const numDecimal = Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return (0, $9seh1.o)(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const remain = tickValue / Math.pow(10, Math.floor((0, $9seh1.z)(tickValue)));
        if (remain === 1 || remain === 2 || remain === 5) return $1af551c56cb88ebf$var$formatters.numeric.call(this, tickValue, index, ticks);
        return "";
    }
};
function $1af551c56cb88ebf$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $1af551c56cb88ebf$export$27c7467594ef87bd = {
    formatters: $1af551c56cb88ebf$var$formatters
};
(0, $9seh1.d).set("scale", {
    display: true,
    offset: false,
    reverse: false,
    beginAtZero: false,
    bounds: "ticks",
    grace: 0,
    grid: {
        display: true,
        lineWidth: 1,
        drawBorder: true,
        drawOnChartArea: true,
        drawTicks: true,
        tickLength: 8,
        tickWidth: (_ctx, options)=>options.lineWidth,
        tickColor: (_ctx, options)=>options.color,
        offset: false,
        borderDash: [],
        borderDashOffset: 0.0,
        borderWidth: 1
    },
    title: {
        display: false,
        text: "",
        padding: {
            top: 4,
            bottom: 4
        }
    },
    ticks: {
        minRotation: 0,
        maxRotation: 50,
        mirror: false,
        textStrokeWidth: 0,
        textStrokeColor: "",
        padding: 3,
        display: true,
        autoSkip: true,
        autoSkipPadding: 3,
        labelOffset: 0,
        callback: $1af551c56cb88ebf$export$27c7467594ef87bd.formatters.values,
        minor: {},
        major: {},
        align: "center",
        crossAlign: "near",
        showLabelBackdrop: false,
        backdropColor: "rgba(255, 255, 255, 0.75)",
        backdropPadding: 2
    }
});
(0, $9seh1.d).route("scale.ticks", "color", "", "color");
(0, $9seh1.d).route("scale.grid", "color", "", "borderColor");
(0, $9seh1.d).route("scale.grid", "borderColor", "", "borderColor");
(0, $9seh1.d).route("scale.title", "color", "", "color");
(0, $9seh1.d).describe("scale", {
    _fallback: false,
    _scriptable: (name)=>!name.startsWith("before") && !name.startsWith("after") && name !== "callback" && name !== "parser",
    _indexable: (name)=>name !== "borderDash" && name !== "tickBorderDash"
});
(0, $9seh1.d).describe("scales", {
    _fallback: "scale"
});
(0, $9seh1.d).describe("scale.ticks", {
    _scriptable: (name)=>name !== "backdropPadding" && name !== "callback",
    _indexable: (name)=>name !== "backdropPadding"
});
function $1af551c56cb88ebf$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const ticksLimit = tickOpts.maxTicksLimit || $1af551c56cb88ebf$var$determineMaxTicks(scale);
    const majorIndices = tickOpts.major.enabled ? $1af551c56cb88ebf$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $1af551c56cb88ebf$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $1af551c56cb88ebf$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $1af551c56cb88ebf$var$skip(ticks, newTicks, spacing, (0, $9seh1.k)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$1af551c56cb88ebf$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $1af551c56cb88ebf$var$skip(ticks, newTicks, spacing, last, (0, $9seh1.k)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $1af551c56cb88ebf$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $1af551c56cb88ebf$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $1af551c56cb88ebf$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $1af551c56cb88ebf$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $9seh1.A)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $1af551c56cb88ebf$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $1af551c56cb88ebf$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $1af551c56cb88ebf$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $9seh1.v)(majorStart, 0);
    const end = Math.min((0, $9seh1.v)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $1af551c56cb88ebf$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $1af551c56cb88ebf$var$reverseAlign = (align)=>align === "left" ? "right" : align === "right" ? "left" : align;
const $1af551c56cb88ebf$var$offsetFromEdge = (scale, edge, offset)=>edge === "top" || edge === "left" ? scale[edge] + offset : scale[edge] - offset;
function $1af551c56cb88ebf$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $1af551c56cb88ebf$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $1af551c56cb88ebf$var$garbageCollect(caches, length) {
    (0, $9seh1.Q)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $1af551c56cb88ebf$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $1af551c56cb88ebf$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $9seh1.O)(options.font, fallback);
    const padding = (0, $9seh1.K)(options.padding);
    const lines = (0, $9seh1.b)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $1af551c56cb88ebf$var$createScaleContext(parent, scale) {
    return (0, $9seh1.h)(parent, {
        scale: scale,
        type: "scale"
    });
}
function $1af551c56cb88ebf$var$createTickContext(parent, index, tick) {
    return (0, $9seh1.h)(parent, {
        tick: tick,
        index: index,
        type: "tick"
    });
}
function $1af551c56cb88ebf$var$titleAlign(align, position, reverse) {
    let ret = (0, $9seh1.R)(align);
    if (reverse && position !== "right" || !reverse && position === "right") ret = $1af551c56cb88ebf$var$reverseAlign(ret);
    return ret;
}
function $1af551c56cb88ebf$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $9seh1.S)(align, left, right);
        if ((0, $9seh1.i)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === "center") titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $1af551c56cb88ebf$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $9seh1.i)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === "center") titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $1af551c56cb88ebf$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $9seh1.S)(align, bottom, top);
        rotation = position === "left" ? -(0, $9seh1.H) : (0, $9seh1.H);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $1af551c56cb88ebf$export$d60cfc58d3c358b6 extends $1af551c56cb88ebf$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $9seh1.B)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $9seh1.B)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $9seh1.B)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $9seh1.B)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $9seh1.B)(_userMin, _suggestedMin),
            max: (0, $9seh1.B)(_userMax, _suggestedMax),
            minDefined: (0, $9seh1.g)(_userMin),
            maxDefined: (0, $9seh1.g)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $9seh1.B)(min, (0, $9seh1.B)(max, min)),
            max: (0, $9seh1.B)(max, (0, $9seh1.B)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $9seh1.C)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $9seh1.D)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $1af551c56cb88ebf$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === "auto")) {
            this.ticks = $1af551c56cb88ebf$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $9seh1.C)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $9seh1.C)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $9seh1.C)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $9seh1.C)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks("beforeDataLimits");
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks("afterDataLimits");
    }
    beforeBuildTicks() {
        this._callHooks("beforeBuildTicks");
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks("afterBuildTicks");
    }
    beforeTickToLabelConversion() {
        (0, $9seh1.C)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $9seh1.C)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $9seh1.C)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $9seh1.C)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = this.ticks.length;
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $9seh1.E)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $1af551c56cb88ebf$var$getTickMarkLength(options.grid) - tickOpts.padding - $1af551c56cb88ebf$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $9seh1.F)(Math.min(Math.asin((0, $9seh1.E)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $9seh1.E)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $9seh1.E)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $9seh1.C)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $9seh1.C)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $1af551c56cb88ebf$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $1af551c56cb88ebf$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $1af551c56cb88ebf$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $9seh1.t)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== "top" && this.axis === "x";
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === "start") paddingRight = last.width;
            else if (align === "end") paddingLeft = first.width;
            else if (align !== "inner") {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === "start") {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === "end") {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $9seh1.C)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === "top" || position === "bottom" || axis === "x";
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $9seh1.k)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $1af551c56cb88ebf$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; ++i){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $9seh1.k)(label) && !(0, $9seh1.b)(label)) {
                width = (0, $9seh1.G)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $9seh1.b)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $9seh1.k)(nestedLabel) && !(0, $9seh1.b)(nestedLabel)) {
                    width = (0, $9seh1.G)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $1af551c56cb88ebf$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $9seh1.I)(this._alignToPixels ? (0, $9seh1.J)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $1af551c56cb88ebf$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $1af551c56cb88ebf$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $9seh1.t)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== "auto") return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $1af551c56cb88ebf$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = grid.setContext(this.getContext());
        const axisWidth = borderOpts.drawBorder ? borderOpts.borderWidth : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $9seh1.J)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === "top") {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === "bottom") {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === "left") {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === "right") {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === "x") {
            if (position === "center") borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $9seh1.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === "y") {
            if (position === "center") borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $9seh1.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $9seh1.v)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const optsAtIndex = grid.setContext(this.getContext(i));
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndex.borderDash || [];
            const borderDashOffset = optsAtIndex.borderDashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $1af551c56cb88ebf$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $9seh1.J)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $1af551c56cb88ebf$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $9seh1.t)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = "middle";
        if (position === "top") {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "bottom") {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "left") {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === "right") {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === "x") {
            if (position === "center") y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $9seh1.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === "y") {
            if (position === "center") x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $9seh1.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === "y") {
            if (align === "start") textBaseline = "top";
            else if (align === "end") textBaseline = "bottom";
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $9seh1.b)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === "inner") {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? "right" : "left";
                    else if (i === 0) tickTextAlign = !this.options.reverse ? "left" : "right";
                    else tickTextAlign = "center";
                }
                if (position === "top") {
                    if (crossAlign === "near" || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === "center") textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === "near" || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === "center") textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $9seh1.K)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = y + textOffset - labelPadding.top;
                let left = x - labelPadding.left;
                switch(textBaseline){
                    case "middle":
                        top -= height / 2;
                        break;
                    case "bottom":
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case "center":
                        left -= width / 2;
                        break;
                    case "right":
                        left -= width;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                rotation: rotation,
                label: label,
                font: font,
                color: color,
                strokeColor: strokeColor,
                strokeWidth: strokeWidth,
                textOffset: textOffset,
                textAlign: tickTextAlign,
                textBaseline: textBaseline,
                translation: [
                    x,
                    y
                ],
                backdrop: backdrop
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $9seh1.t)(this.labelRotation);
        if (rotation) return position === "top" ? "left" : "right";
        let align = "center";
        if (ticks.align === "start") align = "left";
        else if (ticks.align === "end") align = "right";
        else if (ticks.align === "inner") align = "inner";
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === "left") {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x = this.left;
                }
            }
        } else if (position === "right") {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x = this.right;
                }
            }
        } else textAlign = "right";
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === "left" || position === "right") return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === "top" || position === "bottom") return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { grid: grid } } = this;
        const borderOpts = grid.setContext(this.getContext());
        const axisWidth = grid.drawBorder ? borderOpts.borderWidth : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $9seh1.J)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $9seh1.J)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $9seh1.J)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $9seh1.J)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.borderWidth;
        ctx.strokeStyle = borderOpts.borderColor;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $9seh1.L)(ctx, area);
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        let i, ilen;
        for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            const tickFont = item.font;
            const label = item.label;
            if (item.backdrop) {
                ctx.fillStyle = item.backdrop.color;
                ctx.fillRect(item.backdrop.left, item.backdrop.top, item.backdrop.width, item.backdrop.height);
            }
            let y = item.textOffset;
            (0, $9seh1.M)(ctx, label, 0, y, tickFont, item);
        }
        if (area) (0, $9seh1.N)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $9seh1.O)(title.font);
        const padding = (0, $9seh1.K)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === "bottom" || position === "center" || (0, $9seh1.i)(position)) {
            offset += padding.bottom;
            if ((0, $9seh1.b)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $1af551c56cb88ebf$var$titleArgs(this, offset, position, align);
        (0, $9seh1.M)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $1af551c56cb88ebf$var$titleAlign(align, position, reverse),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $9seh1.v)(opts.grid && opts.grid.z, -1);
        if (!this._isVisible() || this.draw !== $1af551c56cb88ebf$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: gz + 1,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + "AxisID";
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $9seh1.O)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $1af551c56cb88ebf$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($1af551c56cb88ebf$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + "." + id;
        if (!id) throw new Error("class does not have id: " + item);
        if (id in items) return scope;
        items[id] = item;
        $1af551c56cb88ebf$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $9seh1.d).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $9seh1.d)[scope]) {
            delete (0, $9seh1.d)[scope][id];
            if (this.override) delete (0, $9seh1.U)[id];
        }
    }
}
function $1af551c56cb88ebf$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $9seh1.V)(Object.create(null), [
        parentScope ? (0, $9seh1.d).get(parentScope) : {},
        (0, $9seh1.d).get(scope),
        item.defaults
    ]);
    (0, $9seh1.d).set(scope, itemDefaults);
    if (item.defaultRoutes) $1af551c56cb88ebf$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $9seh1.d).describe(scope, item.descriptors);
}
function $1af551c56cb88ebf$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split(".");
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join(".");
        const parts = routes[property].split(".");
        const targetName = parts.pop();
        const targetScope = parts.join(".");
        (0, $9seh1.d).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $1af551c56cb88ebf$var$isIChartComponent(proto) {
    return "id" in proto && "defaults" in proto;
}
class $1af551c56cb88ebf$var$Registry {
    constructor(){
        this.controllers = new $1af551c56cb88ebf$var$TypedRegistry($1af551c56cb88ebf$export$75572ec5c55b4048, "datasets", true);
        this.elements = new $1af551c56cb88ebf$var$TypedRegistry($1af551c56cb88ebf$export$db77ccec0bb4ccac, "elements");
        this.plugins = new $1af551c56cb88ebf$var$TypedRegistry(Object, "plugins");
        this.scales = new $1af551c56cb88ebf$var$TypedRegistry($1af551c56cb88ebf$export$d60cfc58d3c358b6, "scales");
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each("register", args);
    }
    remove(...args) {
        this._each("unregister", args);
    }
    addControllers(...args) {
        this._each("register", args, this.controllers);
    }
    addElements(...args) {
        this._each("register", args, this.elements);
    }
    addPlugins(...args) {
        this._each("register", args, this.plugins);
    }
    addScales(...args) {
        this._each("register", args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, "controller");
    }
    getElement(id) {
        return this._get(id, this.elements, "element");
    }
    getPlugin(id) {
        return this._get(id, this.plugins, "plugin");
    }
    getScale(id) {
        return this._get(id, this.scales, "scale");
    }
    removeControllers(...args) {
        this._each("unregister", args, this.controllers);
    }
    removeElements(...args) {
        this._each("unregister", args, this.elements);
    }
    removePlugins(...args) {
        this._each("unregister", args, this.plugins);
    }
    removeScales(...args) {
        this._each("unregister", args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $9seh1.Q)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $9seh1.W)(method);
        (0, $9seh1.C)(component["before" + camelMethod], [], component);
        registry[method](component);
        (0, $9seh1.C)(component["after" + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + ".");
        return item;
    }
}
var $1af551c56cb88ebf$export$4bb7493d241fd8a5 = new $1af551c56cb88ebf$var$Registry();
class $1af551c56cb88ebf$export$b2f2bae6713db87 extends $1af551c56cb88ebf$export$75572ec5c55b4048 {
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $9seh1.q)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $9seh1.w)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = $1af551c56cb88ebf$export$4bb7493d241fd8a5.getElement("line");
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $9seh1.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $9seh1.k)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
$1af551c56cb88ebf$export$b2f2bae6713db87.id = "scatter";
$1af551c56cb88ebf$export$b2f2bae6713db87.defaults = {
    datasetElementType: false,
    dataElementType: "point",
    showLine: false,
    fill: false
};
$1af551c56cb88ebf$export$b2f2bae6713db87.overrides = {
    interaction: {
        mode: "point"
    },
    plugins: {
        tooltip: {
            callbacks: {
                title () {
                    return "";
                },
                label (item) {
                    return "(" + item.label + ", " + item.formattedValue + ")";
                }
            }
        }
    },
    scales: {
        x: {
            type: "linear"
        },
        y: {
            type: "linear"
        }
    }
};
var $1af551c56cb88ebf$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $1af551c56cb88ebf$export$e97d5dc64e999004,
    BubbleController: $1af551c56cb88ebf$export$19b5c4773f17abe,
    DoughnutController: $1af551c56cb88ebf$export$e04603e7d8b77172,
    LineController: $1af551c56cb88ebf$export$3c9b5d28c11cbfd0,
    PolarAreaController: $1af551c56cb88ebf$export$2a270b3a0d973c85,
    PieController: $1af551c56cb88ebf$export$b21a3f1286706191,
    RadarController: $1af551c56cb88ebf$export$48dbc6ac651bf8be,
    ScatterController: $1af551c56cb88ebf$export$b2f2bae6713db87
});
function $1af551c56cb88ebf$var$abstract() {
    throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class $1af551c56cb88ebf$var$DateAdapter {
    constructor(options){
        this.options = options || {};
    }
    init(chartOptions) {}
    formats() {
        return $1af551c56cb88ebf$var$abstract();
    }
    parse(value, format) {
        return $1af551c56cb88ebf$var$abstract();
    }
    format(timestamp, format) {
        return $1af551c56cb88ebf$var$abstract();
    }
    add(timestamp, amount, unit) {
        return $1af551c56cb88ebf$var$abstract();
    }
    diff(a, b, unit) {
        return $1af551c56cb88ebf$var$abstract();
    }
    startOf(timestamp, unit, weekday) {
        return $1af551c56cb88ebf$var$abstract();
    }
    endOf(timestamp, unit) {
        return $1af551c56cb88ebf$var$abstract();
    }
}
$1af551c56cb88ebf$var$DateAdapter.override = function(members) {
    Object.assign($1af551c56cb88ebf$var$DateAdapter.prototype, members);
};
var $1af551c56cb88ebf$export$f32766ea09ec8bc4 = {
    _date: $1af551c56cb88ebf$var$DateAdapter
};
function $1af551c56cb88ebf$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    if (iScale && axis === iScale.axis && axis !== "r" && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $9seh1.Y) : (0, $9seh1.Z);
        if (!intersect) return lookupMethod(data, axis, value);
        else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === "function" && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $1af551c56cb88ebf$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $1af551c56cb88ebf$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $1af551c56cb88ebf$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf("x") !== -1;
    const useY = axis.indexOf("y") !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $1af551c56cb88ebf$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $9seh1.$)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $1af551c56cb88ebf$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $1af551c56cb88ebf$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            "startAngle",
            "endAngle"
        ], useFinalPosition);
        const { angle: angle } = (0, $9seh1.a0)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $9seh1.p)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $1af551c56cb88ebf$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $1af551c56cb88ebf$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $1af551c56cb88ebf$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $1af551c56cb88ebf$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $1af551c56cb88ebf$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === "r" && !intersect ? $1af551c56cb88ebf$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $1af551c56cb88ebf$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $1af551c56cb88ebf$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === "x" ? "inXRange" : "inYRange";
    let intersectsItem = false;
    $1af551c56cb88ebf$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $1af551c56cb88ebf$export$a13296960cae0384 = {
    evaluateInteractionItems: $1af551c56cb88ebf$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $9seh1.X)(e, chart);
            const axis = options.axis || "x";
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $1af551c56cb88ebf$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $1af551c56cb88ebf$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $9seh1.X)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $1af551c56cb88ebf$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $1af551c56cb88ebf$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $9seh1.X)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            return $1af551c56cb88ebf$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $9seh1.X)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            return $1af551c56cb88ebf$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $9seh1.X)(e, chart);
            return $1af551c56cb88ebf$var$getAxisItems(chart, position, "x", options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $9seh1.X)(e, chart);
            return $1af551c56cb88ebf$var$getAxisItems(chart, position, "y", options.intersect, useFinalPosition);
        }
    }
};
const $1af551c56cb88ebf$var$STATIC_POSITIONS = [
    "left",
    "top",
    "right",
    "bottom"
];
function $1af551c56cb88ebf$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $1af551c56cb88ebf$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$1af551c56cb88ebf$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $1af551c56cb88ebf$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $1af551c56cb88ebf$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $1af551c56cb88ebf$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$1af551c56cb88ebf$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $1af551c56cb88ebf$var$setLayoutDims(layouts, params) {
    const stacks = $1af551c56cb88ebf$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $1af551c56cb88ebf$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $1af551c56cb88ebf$var$wrapBoxes(boxes);
    const fullSize = $1af551c56cb88ebf$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $1af551c56cb88ebf$var$sortByWeight($1af551c56cb88ebf$var$filterByPosition(layoutBoxes, "left"), true);
    const right = $1af551c56cb88ebf$var$sortByWeight($1af551c56cb88ebf$var$filterByPosition(layoutBoxes, "right"));
    const top = $1af551c56cb88ebf$var$sortByWeight($1af551c56cb88ebf$var$filterByPosition(layoutBoxes, "top"), true);
    const bottom = $1af551c56cb88ebf$var$sortByWeight($1af551c56cb88ebf$var$filterByPosition(layoutBoxes, "bottom"));
    const centerHorizontal = $1af551c56cb88ebf$var$filterDynamicPositionByAxis(layoutBoxes, "x");
    const centerVertical = $1af551c56cb88ebf$var$filterDynamicPositionByAxis(layoutBoxes, "y");
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $1af551c56cb88ebf$var$filterByPosition(layoutBoxes, "chartArea"),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $1af551c56cb88ebf$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $1af551c56cb88ebf$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $1af551c56cb88ebf$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $9seh1.i)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $1af551c56cb88ebf$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $1af551c56cb88ebf$var$getCombinedMax(maxPadding, chartArea, "left", "right"));
    const newHeight = Math.max(0, params.outerHeight - $1af551c56cb88ebf$var$getCombinedMax(maxPadding, chartArea, "top", "bottom"));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $1af551c56cb88ebf$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos("top");
    chartArea.x += updatePos("left");
    updatePos("right");
    updatePos("bottom");
}
function $1af551c56cb88ebf$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        "left",
        "right"
    ]) : marginForPositions([
        "top",
        "bottom"
    ]);
}
function $1af551c56cb88ebf$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $1af551c56cb88ebf$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $1af551c56cb88ebf$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $1af551c56cb88ebf$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $1af551c56cb88ebf$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $1af551c56cb88ebf$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $9seh1.j)(stack.start)) y = stack.start;
            if (box.fullSize) $1af551c56cb88ebf$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $1af551c56cb88ebf$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $9seh1.j)(stack.start)) x = stack.start;
            if (box.fullSize) $1af551c56cb88ebf$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $1af551c56cb88ebf$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
(0, $9seh1.d).set("layout", {
    autoPadding: true,
    padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }
});
var $1af551c56cb88ebf$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || "top";
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $9seh1.K)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $1af551c56cb88ebf$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $9seh1.Q)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === "function") box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $1af551c56cb88ebf$var$updateMaxPadding(maxPadding, (0, $9seh1.K)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $1af551c56cb88ebf$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $1af551c56cb88ebf$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $1af551c56cb88ebf$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($1af551c56cb88ebf$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $1af551c56cb88ebf$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $1af551c56cb88ebf$var$handleMaxPadding(chartArea);
        $1af551c56cb88ebf$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $1af551c56cb88ebf$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $9seh1.Q)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $1af551c56cb88ebf$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $1af551c56cb88ebf$export$a40a96b24b46cf35 extends $1af551c56cb88ebf$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext("2d") || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $1af551c56cb88ebf$var$EXPANDO_KEY = "$chartjs";
const $1af551c56cb88ebf$var$EVENT_TYPES = {
    touchstart: "mousedown",
    touchmove: "mousemove",
    touchend: "mouseup",
    pointerenter: "mouseenter",
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointerleave: "mouseout",
    pointerout: "mouseout"
};
const $1af551c56cb88ebf$var$isNullOrEmpty = (value)=>value === null || value === "";
function $1af551c56cb88ebf$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute("height");
    const renderWidth = canvas.getAttribute("width");
    canvas[$1af551c56cb88ebf$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || "block";
    style.boxSizing = style.boxSizing || "border-box";
    if ($1af551c56cb88ebf$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $9seh1.a3)(canvas, "width");
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($1af551c56cb88ebf$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === "") canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $9seh1.a3)(canvas, "height");
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $1af551c56cb88ebf$var$eventListenerOptions = (0, $9seh1.a5) ? {
    passive: true
} : false;
function $1af551c56cb88ebf$var$addListener(node, type, listener) {
    node.addEventListener(type, listener, $1af551c56cb88ebf$var$eventListenerOptions);
}
function $1af551c56cb88ebf$var$removeListener(chart, type, listener) {
    chart.canvas.removeEventListener(type, listener, $1af551c56cb88ebf$var$eventListenerOptions);
}
function $1af551c56cb88ebf$var$fromNativeEvent(event, chart) {
    const type = $1af551c56cb88ebf$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $9seh1.X)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $1af551c56cb88ebf$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $1af551c56cb88ebf$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $1af551c56cb88ebf$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$1af551c56cb88ebf$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $1af551c56cb88ebf$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $1af551c56cb88ebf$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$1af551c56cb88ebf$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $1af551c56cb88ebf$var$drpListeningCharts = new Map();
let $1af551c56cb88ebf$var$oldDevicePixelRatio = 0;
function $1af551c56cb88ebf$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $1af551c56cb88ebf$var$oldDevicePixelRatio) return;
    $1af551c56cb88ebf$var$oldDevicePixelRatio = dpr;
    $1af551c56cb88ebf$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $1af551c56cb88ebf$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$1af551c56cb88ebf$var$drpListeningCharts.size) window.addEventListener("resize", $1af551c56cb88ebf$var$onWindowResize);
    $1af551c56cb88ebf$var$drpListeningCharts.set(chart, resize);
}
function $1af551c56cb88ebf$var$unlistenDevicePixelRatioChanges(chart) {
    $1af551c56cb88ebf$var$drpListeningCharts.delete(chart);
    if (!$1af551c56cb88ebf$var$drpListeningCharts.size) window.removeEventListener("resize", $1af551c56cb88ebf$var$onWindowResize);
}
function $1af551c56cb88ebf$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $9seh1.a2)(canvas);
    if (!container) return;
    const resize = (0, $9seh1.a4)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $1af551c56cb88ebf$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $1af551c56cb88ebf$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === "resize") $1af551c56cb88ebf$var$unlistenDevicePixelRatioChanges(chart);
}
function $1af551c56cb88ebf$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $9seh1.a4)((event)=>{
        if (chart.ctx !== null) listener($1af551c56cb88ebf$var$fromNativeEvent(event, chart));
    }, chart, (args)=>{
        const event = args[0];
        return [
            event,
            event.offsetX,
            event.offsetY
        ];
    });
    $1af551c56cb88ebf$var$addListener(canvas, type, proxy);
    return proxy;
}
class $1af551c56cb88ebf$export$f02da7f882cf6b2e extends $1af551c56cb88ebf$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext("2d");
        if (context && context.canvas === canvas) {
            $1af551c56cb88ebf$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$1af551c56cb88ebf$var$EXPANDO_KEY]) return false;
        const initial = canvas[$1af551c56cb88ebf$var$EXPANDO_KEY].initial;
        [
            "height",
            "width"
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $9seh1.k)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$1af551c56cb88ebf$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $1af551c56cb88ebf$var$createAttachObserver,
            detach: $1af551c56cb88ebf$var$createDetachObserver,
            resize: $1af551c56cb88ebf$var$createResizeObserver
        };
        const handler = handlers[type] || $1af551c56cb88ebf$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $1af551c56cb88ebf$var$releaseObserver,
            detach: $1af551c56cb88ebf$var$releaseObserver,
            resize: $1af551c56cb88ebf$var$releaseObserver
        };
        const handler = handlers[type] || $1af551c56cb88ebf$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $9seh1.a1)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = (0, $9seh1.a2)(canvas);
        return !!(container && container.isConnected);
    }
}
function $1af551c56cb88ebf$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $9seh1.a6)() || typeof OffscreenCanvas !== "undefined" && canvas instanceof OffscreenCanvas) return $1af551c56cb88ebf$export$a40a96b24b46cf35;
    return $1af551c56cb88ebf$export$f02da7f882cf6b2e;
}
class $1af551c56cb88ebf$var$PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        if (hook === "beforeInit") {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, "install");
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === "afterDestroy") {
            this._notify(descriptors, chart, "stop");
            this._notify(this._init, chart, "uninstall");
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $9seh1.C)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $9seh1.k)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $9seh1.v)(config.options && config.options.plugins, {});
        const plugins = $1af551c56cb88ebf$var$allPlugins(config);
        return options === false && !all ? [] : $1af551c56cb88ebf$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, "stop");
        this._notify(diff(descriptors, previousDescriptors), chart, "start");
    }
}
function $1af551c56cb88ebf$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($1af551c56cb88ebf$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($1af551c56cb88ebf$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $1af551c56cb88ebf$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $1af551c56cb88ebf$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $1af551c56cb88ebf$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $1af551c56cb88ebf$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $1af551c56cb88ebf$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ""
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $1af551c56cb88ebf$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $9seh1.d).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || "x";
}
function $1af551c56cb88ebf$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === "_index_") axis = indexAxis;
    else if (id === "_value_") axis = indexAxis === "x" ? "y" : "x";
    return axis;
}
function $1af551c56cb88ebf$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? "_index_" : "_value_";
}
function $1af551c56cb88ebf$var$axisFromPosition(position) {
    if (position === "top" || position === "bottom") return "x";
    if (position === "left" || position === "right") return "y";
}
function $1af551c56cb88ebf$var$determineAxis(id, scaleOptions) {
    if (id === "x" || id === "y") return id;
    return scaleOptions.axis || $1af551c56cb88ebf$var$axisFromPosition(scaleOptions.position) || id.charAt(0).toLowerCase();
}
function $1af551c56cb88ebf$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $9seh1.U)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $1af551c56cb88ebf$var$getIndexAxis(config.type, options);
    const firstIDs = Object.create(null);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $9seh1.i)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $1af551c56cb88ebf$var$determineAxis(id, scaleConf);
        const defaultId = $1af551c56cb88ebf$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        firstIDs[axis] = firstIDs[axis] || id;
        scales[id] = (0, $9seh1.ac)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $1af551c56cb88ebf$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $9seh1.U)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $1af551c56cb88ebf$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + "AxisID"] || firstIDs[axis] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $9seh1.ac)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $9seh1.ac)(scale, [
            (0, $9seh1.d).scales[scale.type],
            (0, $9seh1.d).scale
        ]);
    });
    return scales;
}
function $1af551c56cb88ebf$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $9seh1.v)(options.plugins, {});
    options.scales = $1af551c56cb88ebf$var$mergeScaleConfig(config, options);
}
function $1af551c56cb88ebf$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $1af551c56cb88ebf$var$initConfig(config) {
    config = config || {};
    config.data = $1af551c56cb88ebf$var$initData(config.data);
    $1af551c56cb88ebf$var$initOptions(config);
    return config;
}
const $1af551c56cb88ebf$var$keyCache = new Map();
const $1af551c56cb88ebf$var$keysCached = new Set();
function $1af551c56cb88ebf$var$cachedKeys(cacheKey, generate) {
    let keys = $1af551c56cb88ebf$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $1af551c56cb88ebf$var$keyCache.set(cacheKey, keys);
        $1af551c56cb88ebf$var$keysCached.add(keys);
    }
    return keys;
}
const $1af551c56cb88ebf$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $9seh1.f)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $1af551c56cb88ebf$var$Config {
    constructor(config){
        this._config = $1af551c56cb88ebf$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $1af551c56cb88ebf$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $1af551c56cb88ebf$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $1af551c56cb88ebf$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $1af551c56cb88ebf$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $1af551c56cb88ebf$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ""
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $1af551c56cb88ebf$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$1af551c56cb88ebf$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$1af551c56cb88ebf$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$1af551c56cb88ebf$var$addIfFound(scopes, (0, $9seh1.U)[type] || {}, key));
            keys.forEach((key)=>$1af551c56cb88ebf$var$addIfFound(scopes, (0, $9seh1.d), key));
            keys.forEach((key)=>$1af551c56cb88ebf$var$addIfFound(scopes, (0, $9seh1.a7), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($1af551c56cb88ebf$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $9seh1.U)[type] || {},
            (0, $9seh1.d).datasets[type] || {},
            {
                type: type
            },
            (0, $9seh1.d),
            (0, $9seh1.a7)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ""
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $1af551c56cb88ebf$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($1af551c56cb88ebf$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $9seh1.a8)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $9seh1.a9)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ""
    ], descriptorDefaults) {
        const { resolver: resolver } = $1af551c56cb88ebf$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $9seh1.i)(context) ? (0, $9seh1.a9)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $1af551c56cb88ebf$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $9seh1.aa)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes("hover"))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $1af551c56cb88ebf$var$hasFunction = (value)=>(0, $9seh1.i)(value) && Object.getOwnPropertyNames(value).reduce((acc, key)=>acc || (0, $9seh1.a8)(value[key]), false);
function $1af551c56cb88ebf$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $9seh1.ab)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $9seh1.a8)(value) || $1af551c56cb88ebf$var$hasFunction(value)) || indexable && (0, $9seh1.b)(value)) return true;
    }
    return false;
}
var $1af551c56cb88ebf$var$version = "3.9.1";
const $1af551c56cb88ebf$var$KNOWN_POSITIONS = [
    "top",
    "bottom",
    "left",
    "right",
    "chartArea"
];
function $1af551c56cb88ebf$var$positionIsHorizontal(position, axis) {
    return position === "top" || position === "bottom" || $1af551c56cb88ebf$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === "x";
}
function $1af551c56cb88ebf$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $1af551c56cb88ebf$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins("afterRender");
    (0, $9seh1.C)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $1af551c56cb88ebf$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $9seh1.C)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $1af551c56cb88ebf$var$getCanvas(item) {
    if ((0, $9seh1.a6)() && typeof item === "string") item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $1af551c56cb88ebf$var$instances = {};
const $1af551c56cb88ebf$var$getChart = (key)=>{
    const canvas = $1af551c56cb88ebf$var$getCanvas(key);
    return Object.values($1af551c56cb88ebf$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $1af551c56cb88ebf$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $1af551c56cb88ebf$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === "mouseout") return null;
    if (isClick) return lastEvent;
    return e;
}
class $1af551c56cb88ebf$export$acaa6426d77a227e {
    constructor(item, userConfig){
        const config = this.config = new $1af551c56cb88ebf$var$Config(userConfig);
        const initialCanvas = $1af551c56cb88ebf$var$getCanvas(item);
        const existingChart = $1af551c56cb88ebf$var$getChart(initialCanvas);
        if (existingChart) throw new Error("Canvas is already in use. Chart with ID '" + existingChart.id + "'" + " must be destroyed before the canvas with ID '" + existingChart.canvas.id + "' can be reused.");
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $1af551c56cb88ebf$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $9seh1.ad)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $1af551c56cb88ebf$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $9seh1.ae)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $1af551c56cb88ebf$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $1af551c56cb88ebf$export$a424a0aa8f687495.listen(this, "complete", $1af551c56cb88ebf$var$onAnimationsComplete);
        $1af551c56cb88ebf$export$a424a0aa8f687495.listen(this, "progress", $1af551c56cb88ebf$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $9seh1.k)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    _initialize() {
        this.notifyPlugins("beforeInit");
        if (this.options.responsive) this.resize();
        else (0, $9seh1.af)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins("afterInit");
        return this;
    }
    clear() {
        (0, $9seh1.ag)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $1af551c56cb88ebf$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$1af551c56cb88ebf$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? "resize" : "attach";
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $9seh1.af)(this, newRatio, true)) return;
        this.notifyPlugins("resize", {
            size: newSize
        });
        (0, $9seh1.C)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $9seh1.Q)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $1af551c56cb88ebf$var$determineAxis(id, scaleOptions);
            const isRadial = axis === "r";
            const isHorizontal = axis === "x";
            return {
                options: scaleOptions,
                dposition: isRadial ? "chartArea" : isHorizontal ? "bottom" : "left",
                dtype: isRadial ? "radialLinear" : isHorizontal ? "category" : "linear"
            };
        }));
        (0, $9seh1.Q)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $1af551c56cb88ebf$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $9seh1.v)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $1af551c56cb88ebf$var$positionIsHorizontal(scaleOptions.position, axis) !== $1af551c56cb88ebf$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $1af551c56cb88ebf$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $9seh1.Q)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $9seh1.Q)(scales, (scale)=>{
            $1af551c56cb88ebf$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $1af551c56cb88ebf$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($1af551c56cb88ebf$var$compare2Level("order", "index"));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $1af551c56cb88ebf$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = "" + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $1af551c56cb88ebf$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $9seh1.d).datasets[type];
                Object.assign(ControllerClass.prototype, {
                    dataElementType: $1af551c56cb88ebf$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $1af551c56cb88ebf$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $9seh1.Q)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins("reset");
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins("beforeUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins("beforeElementsUpdate");
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $9seh1.Q)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins("afterUpdate", {
            mode: mode
        });
        this._layers.sort($1af551c56cb88ebf$var$compare2Level("z", "_idx"));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $9seh1.Q)(this.scales, (scale)=>{
            $1af551c56cb88ebf$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $9seh1.ah)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === "_removeElements" ? -count : count;
            $1af551c56cb88ebf$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + "," + c.splice(1).join(",")));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $9seh1.ah)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(",")).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins("beforeLayout", {
            cancelable: true
        }) === false) return;
        $1af551c56cb88ebf$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $9seh1.Q)(this.boxes, (box)=>{
            if (noArea && box.position === "chartArea") return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins("afterLayout");
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins("beforeDatasetsUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $9seh1.a8)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins("afterDatasetsUpdate", {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetUpdate", args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetUpdate", args);
    }
    render() {
        if (this.notifyPlugins("beforeRender", {
            cancelable: true
        }) === false) return;
        if ($1af551c56cb88ebf$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$1af551c56cb88ebf$export$a424a0aa8f687495.running(this)) $1af551c56cb88ebf$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $1af551c56cb88ebf$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resize(width, height);
            this._resizeBeforeDraw = null;
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins("beforeDraw", {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins("afterDraw");
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins("beforeDatasetsDraw", {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins("afterDatasetsDraw");
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const clip = meta._clip;
        const useClip = !clip.disabled;
        const area = this.chartArea;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetDraw", args) === false) return;
        if (useClip) (0, $9seh1.L)(ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? this.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
        });
        meta.controller.draw();
        if (useClip) (0, $9seh1.N)(ctx);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetDraw", args);
    }
    isPointInArea(point) {
        return (0, $9seh1.$)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $1af551c56cb88ebf$export$a13296960cae0384.modes[mode];
        if (typeof method === "function") return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $9seh1.h)(null, {
            chart: this,
            type: "chart"
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === "boolean" ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? "show" : "hide";
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $9seh1.j)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $1af551c56cb88ebf$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins("beforeDestroy");
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $9seh1.ag)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        this.notifyPlugins("destroy");
        delete $1af551c56cb88ebf$var$instances[this.id];
        this.notifyPlugins("afterDestroy");
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $9seh1.Q)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove("attach", attached);
            this.attached = true;
            this.resize();
            _add("resize", listener);
            _add("detach", detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove("resize", listener);
            this._stop();
            this._resize(0, 0);
            _add("attach", attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $9seh1.Q)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $9seh1.Q)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? "set" : "remove";
        let meta, item, i, ilen;
        if (mode === "dataset") {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller["_" + prefix + "DatasetHoverStyle"]();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + "HoverStyle"](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("No dataset found at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $9seh1.ai)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins("beforeEvent", args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins("afterEvent", args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $9seh1.aj)(e);
        const lastEvent = $1af551c56cb88ebf$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $9seh1.C)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $9seh1.C)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $9seh1.ai)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
const $1af551c56cb88ebf$var$invalidatePlugins = ()=>(0, $9seh1.Q)($1af551c56cb88ebf$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
const $1af551c56cb88ebf$var$enumerable = true;
Object.defineProperties($1af551c56cb88ebf$export$acaa6426d77a227e, {
    defaults: {
        enumerable: $1af551c56cb88ebf$var$enumerable,
        value: (0, $9seh1.d)
    },
    instances: {
        enumerable: $1af551c56cb88ebf$var$enumerable,
        value: $1af551c56cb88ebf$var$instances
    },
    overrides: {
        enumerable: $1af551c56cb88ebf$var$enumerable,
        value: (0, $9seh1.U)
    },
    registry: {
        enumerable: $1af551c56cb88ebf$var$enumerable,
        value: $1af551c56cb88ebf$export$4bb7493d241fd8a5
    },
    version: {
        enumerable: $1af551c56cb88ebf$var$enumerable,
        value: $1af551c56cb88ebf$var$version
    },
    getChart: {
        enumerable: $1af551c56cb88ebf$var$enumerable,
        value: $1af551c56cb88ebf$var$getChart
    },
    register: {
        enumerable: $1af551c56cb88ebf$var$enumerable,
        value: (...items)=>{
            $1af551c56cb88ebf$export$4bb7493d241fd8a5.add(...items);
            $1af551c56cb88ebf$var$invalidatePlugins();
        }
    },
    unregister: {
        enumerable: $1af551c56cb88ebf$var$enumerable,
        value: (...items)=>{
            $1af551c56cb88ebf$export$4bb7493d241fd8a5.remove(...items);
            $1af551c56cb88ebf$var$invalidatePlugins();
        }
    }
});
function $1af551c56cb88ebf$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $9seh1.H), startAngle - (0, $9seh1.H));
    ctx.closePath();
    ctx.clip();
}
function $1af551c56cb88ebf$var$toRadiusCorners(value) {
    return (0, $9seh1.al)(value, [
        "outerStart",
        "outerEnd",
        "innerStart",
        "innerEnd"
    ]);
}
function $1af551c56cb88ebf$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $1af551c56cb88ebf$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $9seh1.E)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $9seh1.E)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $9seh1.E)(o.innerEnd, 0, innerLimit)
    };
}
function $1af551c56cb88ebf$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
function $1af551c56cb88ebf$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $9seh1.P)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $1af551c56cb88ebf$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerEndAdjustedAngle);
        if (outerEnd > 0) {
            const pCenter = $1af551c56cb88ebf$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $9seh1.H));
        }
        const p4 = $1af551c56cb88ebf$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        if (innerEnd > 0) {
            const pCenter = $1af551c56cb88ebf$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $9seh1.H), innerEndAdjustedAngle + Math.PI);
        }
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, startAngle + innerStart / innerRadius, true);
        if (innerStart > 0) {
            const pCenter = $1af551c56cb88ebf$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $9seh1.H));
        }
        const p8 = $1af551c56cb88ebf$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        if (outerStart > 0) {
            const pCenter = $1af551c56cb88ebf$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $9seh1.H), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $1af551c56cb88ebf$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $1af551c56cb88ebf$var$pathArc(ctx, element, offset, spacing, startAngle + (0, $9seh1.T), circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) {
            endAngle = startAngle + circumference % (0, $9seh1.T);
            if (circumference % (0, $9seh1.T) === 0) endAngle += (0, $9seh1.T);
        }
    }
    $1af551c56cb88ebf$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $1af551c56cb88ebf$var$drawFullCircleBorders(ctx, element, inner) {
    const { x: x, y: y, startAngle: startAngle, pixelMargin: pixelMargin, fullCircles: fullCircles } = element;
    const outerRadius = Math.max(element.outerRadius - pixelMargin, 0);
    const innerRadius = element.innerRadius + pixelMargin;
    let i;
    if (inner) $1af551c56cb88ebf$var$clipArc(ctx, element, startAngle + (0, $9seh1.T));
    ctx.beginPath();
    ctx.arc(x, y, innerRadius, startAngle + (0, $9seh1.T), startAngle, true);
    for(i = 0; i < fullCircles; ++i)ctx.stroke();
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle, startAngle + (0, $9seh1.T));
    for(i = 0; i < fullCircles; ++i)ctx.stroke();
}
function $1af551c56cb88ebf$var$drawBorder(ctx, element, offset, spacing, endAngle, circular) {
    const { options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle } = options;
    const inner = options.borderAlign === "inner";
    if (!borderWidth) return;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || "round";
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || "bevel";
    }
    if (element.fullCircles) $1af551c56cb88ebf$var$drawFullCircleBorders(ctx, element, inner);
    if (inner) $1af551c56cb88ebf$var$clipArc(ctx, element, endAngle);
    $1af551c56cb88ebf$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.stroke();
}
class $1af551c56cb88ebf$export$d48203c759d6a1fc extends $1af551c56cb88ebf$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $9seh1.a0)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius",
            "circumference"
        ], useFinalPosition);
        const rAdjust = this.options.spacing / 2;
        const _circumference = (0, $9seh1.v)(circumference, endAngle - startAngle);
        const betweenAngles = _circumference >= (0, $9seh1.T) || (0, $9seh1.p)(angle, startAngle, endAngle);
        const withinRadius = (0, $9seh1.ak)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            "x",
            "y",
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius",
            "circumference"
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 2;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === "inner" ? 0.33 : 0;
        this.fullCircles = circumference > (0, $9seh1.T) ? Math.floor(circumference / (0, $9seh1.T)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        let radiusOffset = 0;
        if (offset) {
            radiusOffset = offset / 2;
            const halfAngle = (this.startAngle + this.endAngle) / 2;
            ctx.translate(Math.cos(halfAngle) * radiusOffset, Math.sin(halfAngle) * radiusOffset);
            if (this.circumference >= (0, $9seh1.P)) radiusOffset = offset;
        }
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        const endAngle = $1af551c56cb88ebf$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $1af551c56cb88ebf$var$drawBorder(ctx, this, radiusOffset, spacing, endAngle, circular);
        ctx.restore();
    }
}
$1af551c56cb88ebf$export$d48203c759d6a1fc.id = "arc";
$1af551c56cb88ebf$export$d48203c759d6a1fc.defaults = {
    borderAlign: "center",
    borderColor: "#fff",
    borderJoinStyle: undefined,
    borderRadius: 0,
    borderWidth: 2,
    offset: 0,
    spacing: 0,
    angle: undefined,
    circular: true
};
$1af551c56cb88ebf$export$d48203c759d6a1fc.defaultRoutes = {
    backgroundColor: "backgroundColor"
};
function $1af551c56cb88ebf$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $9seh1.v)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $9seh1.v)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $9seh1.v)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $9seh1.v)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $9seh1.v)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $9seh1.v)(style.borderColor, options.borderColor);
}
function $1af551c56cb88ebf$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $1af551c56cb88ebf$var$getLineMethod(options) {
    if (options.stepped) return 0, $9seh1.as;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, $9seh1.at;
    return $1af551c56cb88ebf$var$lineTo;
}
function $1af551c56cb88ebf$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $1af551c56cb88ebf$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $1af551c56cb88ebf$var$pathVars(points, segment, params);
    const lineMethod = $1af551c56cb88ebf$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $1af551c56cb88ebf$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $1af551c56cb88ebf$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $1af551c56cb88ebf$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== "monotone" && !opts.stepped && !borderDash;
    return useFastPath ? $1af551c56cb88ebf$var$fastPathSegment : $1af551c56cb88ebf$var$pathSegment;
}
function $1af551c56cb88ebf$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $9seh1.ap;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, $9seh1.aq;
    return 0, $9seh1.ar;
}
function $1af551c56cb88ebf$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $1af551c56cb88ebf$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $1af551c56cb88ebf$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $1af551c56cb88ebf$var$_getSegmentMethod(line);
    for (const segment of segments){
        $1af551c56cb88ebf$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $1af551c56cb88ebf$var$usePath2D = typeof Path2D === "function";
function $1af551c56cb88ebf$var$draw(ctx, line, start, count) {
    if ($1af551c56cb88ebf$var$usePath2D && !line.options.segment) $1af551c56cb88ebf$var$strokePathWithCache(ctx, line, start, count);
    else $1af551c56cb88ebf$var$strokePathDirect(ctx, line, start, count);
}
class $1af551c56cb88ebf$export$55e463fa7bcd3469 extends $1af551c56cb88ebf$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === "monotone") && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $9seh1.am)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $9seh1.an)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $9seh1.ao)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $1af551c56cb88ebf$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $1af551c56cb88ebf$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $1af551c56cb88ebf$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $1af551c56cb88ebf$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
$1af551c56cb88ebf$export$55e463fa7bcd3469.id = "line";
$1af551c56cb88ebf$export$55e463fa7bcd3469.defaults = {
    borderCapStyle: "butt",
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderWidth: 3,
    capBezierPoints: true,
    cubicInterpolationMode: "default",
    fill: false,
    spanGaps: false,
    stepped: false,
    tension: 0
};
$1af551c56cb88ebf$export$55e463fa7bcd3469.defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
};
$1af551c56cb88ebf$export$55e463fa7bcd3469.descriptors = {
    _scriptable: true,
    _indexable: (name)=>name !== "borderDash" && name !== "fill"
};
function $1af551c56cb88ebf$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $1af551c56cb88ebf$export$bd159b522b230b7a extends $1af551c56cb88ebf$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $1af551c56cb88ebf$var$inRange$1(this, mouseX, "x", useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $1af551c56cb88ebf$var$inRange$1(this, mouseY, "y", useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $9seh1.$)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $9seh1.au)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        return options.radius + options.hitRadius;
    }
}
$1af551c56cb88ebf$export$bd159b522b230b7a.id = "point";
$1af551c56cb88ebf$export$bd159b522b230b7a.defaults = {
    borderWidth: 1,
    hitRadius: 1,
    hoverBorderWidth: 1,
    hoverRadius: 4,
    pointStyle: "circle",
    radius: 3,
    rotation: 0
};
$1af551c56cb88ebf$export$bd159b522b230b7a.defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
};
function $1af551c56cb88ebf$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        "x",
        "y",
        "base",
        "width",
        "height"
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $1af551c56cb88ebf$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $9seh1.E)(value, min, max);
}
function $1af551c56cb88ebf$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $9seh1.aw)(value);
    return {
        t: $1af551c56cb88ebf$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $1af551c56cb88ebf$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $1af551c56cb88ebf$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $1af551c56cb88ebf$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $1af551c56cb88ebf$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        "enableBorderRadius"
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $9seh1.ax)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $9seh1.i)(value);
    return {
        topLeft: $1af551c56cb88ebf$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $1af551c56cb88ebf$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $1af551c56cb88ebf$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $1af551c56cb88ebf$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $1af551c56cb88ebf$var$boundingRects(bar) {
    const bounds = $1af551c56cb88ebf$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $1af551c56cb88ebf$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $1af551c56cb88ebf$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $1af551c56cb88ebf$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $1af551c56cb88ebf$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $9seh1.ak)(x, bounds.left, bounds.right)) && (skipY || (0, $9seh1.ak)(y, bounds.top, bounds.bottom));
}
function $1af551c56cb88ebf$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $1af551c56cb88ebf$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $1af551c56cb88ebf$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $1af551c56cb88ebf$export$a16ed71bf4b07672 extends $1af551c56cb88ebf$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $1af551c56cb88ebf$var$boundingRects(this);
        const addRectPath = $1af551c56cb88ebf$var$hasRadius(outer.radius) ? (0, $9seh1.av) : $1af551c56cb88ebf$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $1af551c56cb88ebf$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $1af551c56cb88ebf$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill("evenodd");
        }
        ctx.beginPath();
        addRectPath(ctx, $1af551c56cb88ebf$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $1af551c56cb88ebf$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $1af551c56cb88ebf$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $1af551c56cb88ebf$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            "x",
            "y",
            "base",
            "horizontal"
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === "x" ? this.width / 2 : this.height / 2;
    }
}
$1af551c56cb88ebf$export$a16ed71bf4b07672.id = "bar";
$1af551c56cb88ebf$export$a16ed71bf4b07672.defaults = {
    borderSkipped: "start",
    borderWidth: 0,
    borderRadius: 0,
    inflateAmount: "auto",
    pointStyle: undefined
};
$1af551c56cb88ebf$export$a16ed71bf4b07672.defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
};
var $1af551c56cb88ebf$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $1af551c56cb88ebf$export$d48203c759d6a1fc,
    LineElement: $1af551c56cb88ebf$export$55e463fa7bcd3469,
    PointElement: $1af551c56cb88ebf$export$bd159b522b230b7a,
    BarElement: $1af551c56cb88ebf$export$a16ed71bf4b07672
});
function $1af551c56cb88ebf$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $1af551c56cb88ebf$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $9seh1.k)(minIndex) && !(0, $9seh1.k)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $1af551c56cb88ebf$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, "data", {
            value: data
        });
    }
}
function $1af551c56cb88ebf$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $1af551c56cb88ebf$var$cleanDecimatedDataset(dataset);
    });
}
function $1af551c56cb88ebf$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $9seh1.E)((0, $9seh1.Z)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $9seh1.E)((0, $9seh1.Z)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $1af551c56cb88ebf$export$be17f937e9aa7533 = {
    id: "decimation",
    defaults: {
        algorithm: "min-max",
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $1af551c56cb88ebf$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $9seh1.a)([
                indexAxis,
                chart.options.indexAxis
            ]) === "y") return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== "linear" && xAxis.type !== "time") return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $1af551c56cb88ebf$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $1af551c56cb88ebf$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $9seh1.k)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, "data", {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case "lttb":
                    decimated = $1af551c56cb88ebf$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case "min-max":
                    decimated = $1af551c56cb88ebf$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $1af551c56cb88ebf$var$cleanDecimatedData(chart);
    }
};
function $1af551c56cb88ebf$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $1af551c56cb88ebf$var$_findSegmentEnd(start, end, points);
        const bounds = $1af551c56cb88ebf$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $9seh1.ao)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $1af551c56cb88ebf$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $9seh1.ay)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $1af551c56cb88ebf$var$_getEdge(bounds, subBounds, "start", Math.max)
                },
                end: {
                    [property]: $1af551c56cb88ebf$var$_getEdge(bounds, subBounds, "end", Math.min)
                }
            });
        }
    }
    return parts;
}
function $1af551c56cb88ebf$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === "angle") {
        start = (0, $9seh1.az)(start);
        end = (0, $9seh1.az)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $1af551c56cb88ebf$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $1af551c56cb88ebf$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $1af551c56cb88ebf$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $1af551c56cb88ebf$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $1af551c56cb88ebf$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $9seh1.b)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $1af551c56cb88ebf$var$_pointsFromSegments(boundary, line);
    return points.length ? new $1af551c56cb88ebf$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $1af551c56cb88ebf$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $1af551c56cb88ebf$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $9seh1.g)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $1af551c56cb88ebf$var$_decodeFill(line, index, count) {
    const fill = $1af551c56cb88ebf$var$parseFillOption(line);
    if ((0, $9seh1.i)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $9seh1.g)(target) && Math.floor(target) === target) return $1af551c56cb88ebf$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        "origin",
        "start",
        "end",
        "stack",
        "shape"
    ].indexOf(fill) >= 0 && fill;
}
function $1af551c56cb88ebf$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === "-" || firstCh === "+") target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $1af551c56cb88ebf$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === "start") pixel = scale.bottom;
    else if (fill === "end") pixel = scale.top;
    else if ((0, $9seh1.i)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $1af551c56cb88ebf$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === "start") value = startValue;
    else if (fill === "end") value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $9seh1.i)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $1af551c56cb88ebf$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $9seh1.v)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return "origin";
    return fill;
}
function $1af551c56cb88ebf$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $1af551c56cb88ebf$var$getLinesBelow(scale, index);
    linesBelow.push($1af551c56cb88ebf$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$1af551c56cb88ebf$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $1af551c56cb88ebf$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $1af551c56cb88ebf$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas("line");
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $1af551c56cb88ebf$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $1af551c56cb88ebf$var$findPoint(line, sourcePoint, "x");
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $1af551c56cb88ebf$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $9seh1.ak)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $1af551c56cb88ebf$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $9seh1.T)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $1af551c56cb88ebf$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $9seh1.g)(fill)) return $1af551c56cb88ebf$var$getLineByIndex(chart, fill);
    if (fill === "stack") return $1af551c56cb88ebf$var$_buildStackLine(source);
    if (fill === "shape") return true;
    const boundary = $1af551c56cb88ebf$var$computeBoundary(source);
    if (boundary instanceof $1af551c56cb88ebf$var$simpleArc) return boundary;
    return $1af551c56cb88ebf$var$_createBoundaryLine(boundary, line);
}
function $1af551c56cb88ebf$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $1af551c56cb88ebf$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $1af551c56cb88ebf$var$computeCircularBoundary(source);
    return $1af551c56cb88ebf$var$computeLinearBoundary(source);
}
function $1af551c56cb88ebf$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $1af551c56cb88ebf$var$_getTargetPixel(fill, scale);
    if ((0, $9seh1.g)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $1af551c56cb88ebf$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $1af551c56cb88ebf$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $1af551c56cb88ebf$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $1af551c56cb88ebf$var$_drawfill(ctx, source, area) {
    const target = $1af551c56cb88ebf$var$_getTarget(source);
    const { line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    if (target && line.points.length) {
        (0, $9seh1.L)(ctx, area);
        $1af551c56cb88ebf$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis
        });
        (0, $9seh1.N)(ctx);
    }
}
function $1af551c56cb88ebf$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale } = cfg;
    const property = line._loop ? "angle" : cfg.axis;
    ctx.save();
    if (property === "x" && below !== above) {
        $1af551c56cb88ebf$var$clipVertical(ctx, target, area.top);
        $1af551c56cb88ebf$var$fill(ctx, {
            line: line,
            target: target,
            color: above,
            scale: scale,
            property: property
        });
        ctx.restore();
        ctx.save();
        $1af551c56cb88ebf$var$clipVertical(ctx, target, area.bottom);
    }
    $1af551c56cb88ebf$var$fill(ctx, {
        line: line,
        target: target,
        color: below,
        scale: scale,
        property: property
    });
    ctx.restore();
}
function $1af551c56cb88ebf$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$1af551c56cb88ebf$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $1af551c56cb88ebf$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale } = cfg;
    const segments = $1af551c56cb88ebf$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $1af551c56cb88ebf$var$clipBounds(ctx, scale, notShape && $1af551c56cb88ebf$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $1af551c56cb88ebf$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $1af551c56cb88ebf$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? "evenodd" : "nonzero");
        ctx.restore();
    }
}
function $1af551c56cb88ebf$var$clipBounds(ctx, scale, bounds) {
    const { top: top, bottom: bottom } = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === "x") {
        ctx.beginPath();
        ctx.rect(start, top, end - start, bottom - top);
        ctx.clip();
    }
}
function $1af551c56cb88ebf$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $1af551c56cb88ebf$export$d19ba4d812bed757 = {
    id: "filler",
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $1af551c56cb88ebf$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $1af551c56cb88ebf$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $1af551c56cb88ebf$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === "beforeDraw";
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $1af551c56cb88ebf$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== "beforeDatasetsDraw") return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($1af551c56cb88ebf$var$_shouldApplyFill(source)) $1af551c56cb88ebf$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$1af551c56cb88ebf$var$_shouldApplyFill(source) || options.drawTime !== "beforeDatasetDraw") return;
        $1af551c56cb88ebf$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: "beforeDatasetDraw"
    }
};
const $1af551c56cb88ebf$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $1af551c56cb88ebf$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $1af551c56cb88ebf$var$Legend extends $1af551c56cb88ebf$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $9seh1.C)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $9seh1.O)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $1af551c56cb88ebf$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = "left";
        ctx.textBaseline = "middle";
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $9seh1.aA)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $9seh1.S)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $9seh1.S)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $9seh1.S)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $9seh1.S)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === "top" || this.options.position === "bottom";
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $9seh1.L)(ctx, this);
            this._draw();
            (0, $9seh1.N)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $9seh1.d).color;
        const rtlHelper = (0, $9seh1.aA)(opts.rtl, this.left, this.width);
        const labelFont = (0, $9seh1.O)(labelOpts.font);
        const { color: fontColor, padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign("left");
        ctx.textBaseline = "middle";
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $1af551c56cb88ebf$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $9seh1.v)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $9seh1.v)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $9seh1.v)(legendItem.lineCap, "butt");
            ctx.lineDashOffset = (0, $9seh1.v)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $9seh1.v)(legendItem.lineJoin, "miter");
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $9seh1.v)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $9seh1.v)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $9seh1.aE)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $9seh1.ax)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $9seh1.av)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $9seh1.M)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $9seh1.S)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $9seh1.S)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $9seh1.aB)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor || fontColor;
            ctx.fillStyle = legendItem.fontColor || fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $9seh1.S)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $9seh1.S)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $9seh1.aC)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else cursor.y += lineHeight;
        });
        (0, $9seh1.aD)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $9seh1.O)(titleOpts.font);
        const titlePadding = (0, $9seh1.K)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $9seh1.aA)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $9seh1.S)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $9seh1.S)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $9seh1.S)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $9seh1.R)(position));
        ctx.textBaseline = "middle";
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $9seh1.M)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $9seh1.O)(titleOpts.font);
        const titlePadding = (0, $9seh1.K)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $9seh1.ak)(x, this.left, this.right) && (0, $9seh1.ak)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $9seh1.ak)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $9seh1.ak)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$1af551c56cb88ebf$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === "mousemove" || e.type === "mouseout") {
            const previous = this._hoveredItem;
            const sameItem = $1af551c56cb88ebf$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $9seh1.C)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $9seh1.C)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $9seh1.C)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $1af551c56cb88ebf$var$isListened(type, opts) {
    if ((type === "mousemove" || type === "mouseout") && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === "click" || type === "mouseup")) return true;
    return false;
}
var $1af551c56cb88ebf$export$ed247974535929c7 = {
    id: "legend",
    _element: $1af551c56cb88ebf$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $1af551c56cb88ebf$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $1af551c56cb88ebf$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $1af551c56cb88ebf$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $1af551c56cb88ebf$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $1af551c56cb88ebf$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: "top",
        align: "center",
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $9seh1.K)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: 0,
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: "center",
            text: ""
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith("on"),
        labels: {
            _scriptable: (name)=>![
                    "generateLabels",
                    "filter",
                    "sort"
                ].includes(name)
        }
    }
};
class $1af551c56cb88ebf$var$Title extends $1af551c56cb88ebf$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $9seh1.b)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $9seh1.K)(opts.padding);
        const textSize = lineCount * (0, $9seh1.O)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === "top" || pos === "bottom";
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $9seh1.S)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === "left") {
                titleX = left + offset;
                titleY = (0, $9seh1.S)(align, bottom, top);
                rotation = (0, $9seh1.P) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $9seh1.S)(align, top, bottom);
                rotation = (0, $9seh1.P) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $9seh1.O)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $9seh1.M)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $9seh1.R)(opts.align),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $1af551c56cb88ebf$var$createTitle(chart, titleOpts) {
    const title = new $1af551c56cb88ebf$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $1af551c56cb88ebf$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $1af551c56cb88ebf$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $1af551c56cb88ebf$export$f99233281efd08a0 = {
    id: "title",
    _element: $1af551c56cb88ebf$var$Title,
    start (chart, _args, options) {
        $1af551c56cb88ebf$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $1af551c56cb88ebf$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $1af551c56cb88ebf$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "bold"
        },
        fullSize: true,
        padding: 10,
        position: "top",
        text: "",
        weight: 2000
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $1af551c56cb88ebf$var$map = new WeakMap();
var $1af551c56cb88ebf$export$d5c56664638992a4 = {
    id: "subtitle",
    start (chart, _args, options) {
        const title = new $1af551c56cb88ebf$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $1af551c56cb88ebf$export$1ecca0613f5e56d2.configure(chart, title, options);
        $1af551c56cb88ebf$export$1ecca0613f5e56d2.addBox(chart, title);
        $1af551c56cb88ebf$var$map.set(chart, title);
    },
    stop (chart) {
        $1af551c56cb88ebf$export$1ecca0613f5e56d2.removeBox(chart, $1af551c56cb88ebf$var$map.get(chart));
        $1af551c56cb88ebf$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $1af551c56cb88ebf$var$map.get(chart);
        $1af551c56cb88ebf$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "normal"
        },
        fullSize: true,
        padding: 0,
        position: "top",
        text: "",
        weight: 1500
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $1af551c56cb88ebf$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let x = 0;
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                x += pos.x;
                y += pos.y;
                ++count;
            }
        }
        return {
            x: x / count,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $9seh1.aG)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $1af551c56cb88ebf$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $9seh1.b)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $1af551c56cb88ebf$var$splitNewlines(str) {
    if ((typeof str === "string" || str instanceof String) && str.indexOf("\n") > -1) return str.split("\n");
    return str;
}
function $1af551c56cb88ebf$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $1af551c56cb88ebf$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $9seh1.O)(options.bodyFont);
    const titleFont = (0, $9seh1.O)(options.titleFont);
    const footerFont = (0, $9seh1.O)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $9seh1.K)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $9seh1.Q)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $9seh1.Q)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $9seh1.Q)(body, (bodyItem)=>{
        (0, $9seh1.Q)(bodyItem.before, maxLineWidth);
        (0, $9seh1.Q)(bodyItem.lines, maxLineWidth);
        (0, $9seh1.Q)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $9seh1.Q)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $1af551c56cb88ebf$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return "top";
    else if (y > chart.height - height / 2) return "bottom";
    return "center";
}
function $1af551c56cb88ebf$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === "left" && x + width + caret > chart.width) return true;
    if (xAlign === "right" && x - width - caret < 0) return true;
}
function $1af551c56cb88ebf$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = "center";
    if (yAlign === "center") xAlign = x <= (left + right) / 2 ? "left" : "right";
    else if (x <= width / 2) xAlign = "left";
    else if (x >= chartWidth - width / 2) xAlign = "right";
    if ($1af551c56cb88ebf$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = "center";
    return xAlign;
}
function $1af551c56cb88ebf$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $1af551c56cb88ebf$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $1af551c56cb88ebf$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $1af551c56cb88ebf$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === "right") x -= width;
    else if (xAlign === "center") x -= width / 2;
    return x;
}
function $1af551c56cb88ebf$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === "top") y += paddingAndSize;
    else if (yAlign === "bottom") y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $1af551c56cb88ebf$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $9seh1.ax)(cornerRadius);
    let x = $1af551c56cb88ebf$var$alignX(size, xAlign);
    const y = $1af551c56cb88ebf$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === "center") {
        if (xAlign === "left") x += paddingAndSize;
        else if (xAlign === "right") x -= paddingAndSize;
    } else if (xAlign === "left") x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === "right") x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $9seh1.E)(x, 0, chart.width - size.width),
        y: (0, $9seh1.E)(y, 0, chart.height - size.height)
    };
}
function $1af551c56cb88ebf$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $9seh1.K)(options.padding);
    return align === "center" ? tooltip.x + tooltip.width / 2 : align === "right" ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $1af551c56cb88ebf$var$getBeforeAfterBodyLines(callback) {
    return $1af551c56cb88ebf$var$pushOrConcat([], $1af551c56cb88ebf$var$splitNewlines(callback));
}
function $1af551c56cb88ebf$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $9seh1.h)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: "tooltip"
    });
}
function $1af551c56cb88ebf$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
class $1af551c56cb88ebf$var$Tooltip extends $1af551c56cb88ebf$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart || config._chart;
        this._chart = this.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $1af551c56cb88ebf$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $1af551c56cb88ebf$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = callbacks.beforeTitle.apply(this, [
            context
        ]);
        const title = callbacks.title.apply(this, [
            context
        ]);
        const afterTitle = callbacks.afterTitle.apply(this, [
            context
        ]);
        let lines = [];
        lines = $1af551c56cb88ebf$var$pushOrConcat(lines, $1af551c56cb88ebf$var$splitNewlines(beforeTitle));
        lines = $1af551c56cb88ebf$var$pushOrConcat(lines, $1af551c56cb88ebf$var$splitNewlines(title));
        lines = $1af551c56cb88ebf$var$pushOrConcat(lines, $1af551c56cb88ebf$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $1af551c56cb88ebf$var$getBeforeAfterBodyLines(options.callbacks.beforeBody.apply(this, [
            tooltipItems
        ]));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $9seh1.Q)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $1af551c56cb88ebf$var$overrideCallbacks(callbacks, context);
            $1af551c56cb88ebf$var$pushOrConcat(bodyItem.before, $1af551c56cb88ebf$var$splitNewlines(scoped.beforeLabel.call(this, context)));
            $1af551c56cb88ebf$var$pushOrConcat(bodyItem.lines, scoped.label.call(this, context));
            $1af551c56cb88ebf$var$pushOrConcat(bodyItem.after, $1af551c56cb88ebf$var$splitNewlines(scoped.afterLabel.call(this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $1af551c56cb88ebf$var$getBeforeAfterBodyLines(options.callbacks.afterBody.apply(this, [
            tooltipItems
        ]));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = callbacks.beforeFooter.apply(this, [
            tooltipItems
        ]);
        const footer = callbacks.footer.apply(this, [
            tooltipItems
        ]);
        const afterFooter = callbacks.afterFooter.apply(this, [
            tooltipItems
        ]);
        let lines = [];
        lines = $1af551c56cb88ebf$var$pushOrConcat(lines, $1af551c56cb88ebf$var$splitNewlines(beforeFooter));
        lines = $1af551c56cb88ebf$var$pushOrConcat(lines, $1af551c56cb88ebf$var$splitNewlines(footer));
        lines = $1af551c56cb88ebf$var$pushOrConcat(lines, $1af551c56cb88ebf$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($1af551c56cb88ebf$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $9seh1.Q)(tooltipItems, (context)=>{
            const scoped = $1af551c56cb88ebf$var$overrideCallbacks(options.callbacks, context);
            labelColors.push(scoped.labelColor.call(this, context));
            labelPointStyles.push(scoped.labelPointStyle.call(this, context));
            labelTextColors.push(scoped.labelTextColor.call(this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $1af551c56cb88ebf$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $1af551c56cb88ebf$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $1af551c56cb88ebf$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $1af551c56cb88ebf$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $9seh1.ax)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === "center") {
            y2 = ptY + height / 2;
            if (xAlign === "left") {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === "left") x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === "right") x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === "top") {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $9seh1.aA)(options.rtl, this.x, this.width);
            pt.x = $1af551c56cb88ebf$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = "middle";
            titleFont = (0, $9seh1.O)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColors = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $9seh1.O)(options.bodyFont);
        const colorX = $1af551c56cb88ebf$var$getAlignedX(this, "left", options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $9seh1.au)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColors.borderColor;
            ctx.fillStyle = labelColors.backgroundColor;
            (0, $9seh1.au)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $9seh1.i)(labelColors.borderWidth) ? Math.max(...Object.values(labelColors.borderWidth)) : labelColors.borderWidth || 1;
            ctx.strokeStyle = labelColors.borderColor;
            ctx.setLineDash(labelColors.borderDash || []);
            ctx.lineDashOffset = labelColors.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth - boxPadding);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - boxPadding - 2);
            const borderRadius = (0, $9seh1.ax)(labelColors.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $9seh1.av)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColors.backgroundColor;
                ctx.beginPath();
                (0, $9seh1.av)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColors.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $9seh1.O)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $9seh1.aA)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = "middle";
        ctx.font = bodyFont.string;
        pt.x = $1af551c56cb88ebf$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $9seh1.Q)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== "right" ? bodyAlign === "center" ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $9seh1.Q)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $9seh1.Q)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $9seh1.Q)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $9seh1.aA)(options.rtl, this.x, this.width);
            pt.x = $1af551c56cb88ebf$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = "middle";
            footerFont = (0, $9seh1.O)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $9seh1.ax)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === "top") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === "center" && xAlign === "right") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === "bottom") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === "center" && xAlign === "left") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $1af551c56cb88ebf$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $1af551c56cb88ebf$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $1af551c56cb88ebf$var$determineAlignment(chart, options, positionAndSize);
            const point = $1af551c56cb88ebf$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $9seh1.K)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $9seh1.aB)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $9seh1.aD)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("Cannot find a dataset at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $9seh1.ai)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $9seh1.ai)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive;
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $1af551c56cb88ebf$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
$1af551c56cb88ebf$var$Tooltip.positioners = $1af551c56cb88ebf$var$positioners;
var $1af551c56cb88ebf$export$28c660c63b792dea = {
    id: "tooltip",
    _element: $1af551c56cb88ebf$var$Tooltip,
    positioners: $1af551c56cb88ebf$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $1af551c56cb88ebf$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins("beforeTooltipDraw", args) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins("afterTooltipDraw", args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: "average",
        backgroundColor: "rgba(0,0,0,0.8)",
        titleColor: "#fff",
        titleFont: {
            weight: "bold"
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: "left",
        bodyColor: "#fff",
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: "left",
        footerColor: "#fff",
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: "bold"
        },
        footerAlign: "left",
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: "#fff",
        displayColors: true,
        boxPadding: 0,
        borderColor: "rgba(0,0,0,0)",
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: "easeOutQuart"
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "width",
                    "height",
                    "caretX",
                    "caretY"
                ]
            },
            opacity: {
                easing: "linear",
                duration: 200
            }
        },
        callbacks: {
            beforeTitle: (0, $9seh1.aF),
            title (tooltipItems) {
                if (tooltipItems.length > 0) {
                    const item = tooltipItems[0];
                    const labels = item.chart.data.labels;
                    const labelCount = labels ? labels.length : 0;
                    if (this && this.options && this.options.mode === "dataset") return item.dataset.label || "";
                    else if (item.label) return item.label;
                    else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
                }
                return "";
            },
            afterTitle: (0, $9seh1.aF),
            beforeBody: (0, $9seh1.aF),
            beforeLabel: (0, $9seh1.aF),
            label (tooltipItem) {
                if (this && this.options && this.options.mode === "dataset") return tooltipItem.label + ": " + tooltipItem.formattedValue || tooltipItem.formattedValue;
                let label = tooltipItem.dataset.label || "";
                if (label) label += ": ";
                const value = tooltipItem.formattedValue;
                if (!(0, $9seh1.k)(value)) label += value;
                return label;
            },
            labelColor (tooltipItem) {
                const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
                const options = meta.controller.getStyle(tooltipItem.dataIndex);
                return {
                    borderColor: options.borderColor,
                    backgroundColor: options.backgroundColor,
                    borderWidth: options.borderWidth,
                    borderDash: options.borderDash,
                    borderDashOffset: options.borderDashOffset,
                    borderRadius: 0
                };
            },
            labelTextColor () {
                return this.options.bodyColor;
            },
            labelPointStyle (tooltipItem) {
                const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
                const options = meta.controller.getStyle(tooltipItem.dataIndex);
                return {
                    pointStyle: options.pointStyle,
                    rotation: options.rotation
                };
            },
            afterLabel: (0, $9seh1.aF),
            afterBody: (0, $9seh1.aF),
            beforeFooter: (0, $9seh1.aF),
            footer: (0, $9seh1.aF),
            afterFooter: (0, $9seh1.aF)
        }
    },
    defaultRoutes: {
        bodyFont: "font",
        footerFont: "font",
        titleFont: "font"
    },
    descriptors: {
        _scriptable: (name)=>name !== "filter" && name !== "itemSort" && name !== "external",
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: "animation"
        }
    },
    additionalOptionScopes: [
        "interaction"
    ]
};
var $1af551c56cb88ebf$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Decimation: $1af551c56cb88ebf$export$be17f937e9aa7533,
    Filler: $1af551c56cb88ebf$export$d19ba4d812bed757,
    Legend: $1af551c56cb88ebf$export$ed247974535929c7,
    SubTitle: $1af551c56cb88ebf$export$d5c56664638992a4,
    Title: $1af551c56cb88ebf$export$f99233281efd08a0,
    Tooltip: $1af551c56cb88ebf$export$28c660c63b792dea
});
const $1af551c56cb88ebf$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === "string") {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $1af551c56cb88ebf$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $1af551c56cb88ebf$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $1af551c56cb88ebf$var$validIndex = (index, max)=>index === null ? null : (0, $9seh1.E)(Math.round(index), 0, max);
class $1af551c56cb88ebf$export$29e663ba4d09fe7 extends $1af551c56cb88ebf$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $9seh1.k)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $1af551c56cb88ebf$var$findOrAddLabel(labels, raw, (0, $9seh1.v)(index, raw), this._addedLabels);
        return $1af551c56cb88ebf$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === "ticks") {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        const labels = this.getLabels();
        if (value >= 0 && value < labels.length) return labels[value];
        return value;
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== "number") value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
$1af551c56cb88ebf$export$29e663ba4d09fe7.id = "category";
$1af551c56cb88ebf$export$29e663ba4d09fe7.defaults = {
    ticks: {
        callback: $1af551c56cb88ebf$export$29e663ba4d09fe7.prototype.getLabelForValue
    }
};
function $1af551c56cb88ebf$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $9seh1.k)(min);
    const maxDefined = !(0, $9seh1.k)(max);
    const countDefined = !(0, $9seh1.k)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $9seh1.aI)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $9seh1.aI)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $9seh1.k)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === "ticks") {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $9seh1.aJ)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $9seh1.aK)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $9seh1.aL)(spacing), (0, $9seh1.aL)(niceMin));
    factor = Math.pow(10, (0, $9seh1.k)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $9seh1.aK)(Math.round((niceMin + j * spacing) * factor) / factor, min, $1af551c56cb88ebf$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j)ticks.push({
        value: Math.round((niceMin + j * spacing) * factor) / factor
    });
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $9seh1.aK)(ticks[ticks.length - 1].value, max, $1af551c56cb88ebf$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $1af551c56cb88ebf$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $9seh1.t)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ("" + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $1af551c56cb88ebf$var$LinearScaleBase extends $1af551c56cb88ebf$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $9seh1.k)(raw)) return null;
        if ((typeof raw === "number" || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $9seh1.s)(min);
            const maxSign = (0, $9seh1.s)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = 1;
            if (max >= Number.MAX_SAFE_INTEGER || min <= Number.MIN_SAFE_INTEGER) offset = Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $1af551c56cb88ebf$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === "ticks") (0, $9seh1.aH)(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $9seh1.o)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $1af551c56cb88ebf$export$e7f4e5e8656f0b93 extends $1af551c56cb88ebf$var$LinearScaleBase {
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $9seh1.g)(min) ? min : 0;
        this.max = (0, $9seh1.g)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $9seh1.t)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
$1af551c56cb88ebf$export$e7f4e5e8656f0b93.id = "linear";
$1af551c56cb88ebf$export$e7f4e5e8656f0b93.defaults = {
    ticks: {
        callback: $1af551c56cb88ebf$export$27c7467594ef87bd.formatters.numeric
    }
};
function $1af551c56cb88ebf$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, Math.floor((0, $9seh1.z)(tickVal)));
    return remain === 1;
}
function $1af551c56cb88ebf$var$generateTicks(generationOptions, dataRange) {
    const endExp = Math.floor((0, $9seh1.z)(dataRange.max));
    const endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
    const ticks = [];
    let tickVal = (0, $9seh1.B)(generationOptions.min, Math.pow(10, Math.floor((0, $9seh1.z)(dataRange.min))));
    let exp = Math.floor((0, $9seh1.z)(tickVal));
    let significand = Math.floor(tickVal / Math.pow(10, exp));
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    do {
        ticks.push({
            value: tickVal,
            major: $1af551c56cb88ebf$var$isMajor(tickVal)
        });
        ++significand;
        if (significand === 10) {
            significand = 1;
            ++exp;
            precision = exp >= 0 ? 1 : precision;
        }
        tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
    }while (exp < endExp || exp === endExp && significand < endSignificand);
    const lastTick = (0, $9seh1.B)(generationOptions.max, tickVal);
    ticks.push({
        value: lastTick,
        major: $1af551c56cb88ebf$var$isMajor(tickVal)
    });
    return ticks;
}
class $1af551c56cb88ebf$export$85295eaf7cb3ac3e extends $1af551c56cb88ebf$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $1af551c56cb88ebf$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $9seh1.g)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $9seh1.g)(min) ? Math.max(0, min) : null;
        this.max = (0, $9seh1.g)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        const exp = (v, m)=>Math.pow(10, Math.floor((0, $9seh1.z)(v)) + m);
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin(exp(min, -1));
                setMax(exp(max, 1));
            }
        }
        if (min <= 0) setMin(exp(max, -1));
        if (max <= 0) setMax(exp(min, 1));
        if (this._zero && this.min !== this._suggestedMin && min === exp(this.min, 0)) setMin(exp(min, -1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $1af551c56cb88ebf$var$generateTicks(generationOptions, this);
        if (opts.bounds === "ticks") (0, $9seh1.aH)(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? "0" : (0, $9seh1.o)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $9seh1.z)(start);
        this._valueRange = (0, $9seh1.z)(this.max) - (0, $9seh1.z)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $9seh1.z)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
$1af551c56cb88ebf$export$85295eaf7cb3ac3e.id = "logarithmic";
$1af551c56cb88ebf$export$85295eaf7cb3ac3e.defaults = {
    ticks: {
        callback: $1af551c56cb88ebf$export$27c7467594ef87bd.formatters.logarithmic,
        major: {
            enabled: true
        }
    }
};
function $1af551c56cb88ebf$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $9seh1.K)(tickOpts.backdropPadding);
        return (0, $9seh1.v)(tickOpts.font && tickOpts.font.size, (0, $9seh1.d).font.size) + padding.height;
    }
    return 0;
}
function $1af551c56cb88ebf$var$measureLabelSize(ctx, font, label) {
    label = (0, $9seh1.b)(label) ? label : [
        label
    ];
    return {
        w: (0, $9seh1.aM)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $1af551c56cb88ebf$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $1af551c56cb88ebf$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $9seh1.P) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $9seh1.O)(opts.font);
        const textSize = $1af551c56cb88ebf$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $9seh1.az)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $9seh1.F)(angleRadians));
        const hLimits = $1af551c56cb88ebf$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $1af551c56cb88ebf$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $1af551c56cb88ebf$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $1af551c56cb88ebf$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $1af551c56cb88ebf$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $1af551c56cb88ebf$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const extra = $1af551c56cb88ebf$var$getTickBackdropHeight(opts) / 2;
    const outerDistance = scale.drawingArea;
    const additionalAngle = opts.pointLabels.centerPointLabels ? (0, $9seh1.P) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + padding[i], additionalAngle);
        const angle = Math.round((0, $9seh1.F)((0, $9seh1.az)(pointLabelPosition.angle + (0, $9seh1.H))));
        const size = labelSizes[i];
        const y = $1af551c56cb88ebf$var$yForAngle(pointLabelPosition.y, size.h, angle);
        const textAlign = $1af551c56cb88ebf$var$getTextAlignForAngle(angle);
        const left = $1af551c56cb88ebf$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
        items.push({
            x: pointLabelPosition.x,
            y: y,
            textAlign: textAlign,
            left: left,
            top: y,
            right: left + size.w,
            bottom: y + size.h
        });
    }
    return items;
}
function $1af551c56cb88ebf$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return "center";
    else if (angle < 180) return "left";
    return "right";
}
function $1af551c56cb88ebf$var$leftForTextAlign(x, w, align) {
    if (align === "right") x -= w;
    else if (align === "center") x -= w / 2;
    return x;
}
function $1af551c56cb88ebf$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $1af551c56cb88ebf$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        const plFont = (0, $9seh1.O)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign, left: left, top: top, right: right, bottom: bottom } = scale._pointLabelItems[i];
        const { backdropColor: backdropColor } = optsAtIndex;
        if (!(0, $9seh1.k)(backdropColor)) {
            const borderRadius = (0, $9seh1.ax)(optsAtIndex.borderRadius);
            const padding = (0, $9seh1.K)(optsAtIndex.backdropPadding);
            ctx.fillStyle = backdropColor;
            const backdropLeft = left - padding.left;
            const backdropTop = top - padding.top;
            const backdropWidth = right - left + padding.width;
            const backdropHeight = bottom - top + padding.height;
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                (0, $9seh1.av)(ctx, {
                    x: backdropLeft,
                    y: backdropTop,
                    w: backdropWidth,
                    h: backdropHeight,
                    radius: borderRadius
                });
                ctx.fill();
            } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
        }
        (0, $9seh1.M)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: "middle"
        });
    }
}
function $1af551c56cb88ebf$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $9seh1.T));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $1af551c56cb88ebf$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(gridLineOpts.borderDash);
    ctx.lineDashOffset = gridLineOpts.borderDashOffset;
    ctx.beginPath();
    $1af551c56cb88ebf$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $1af551c56cb88ebf$var$createPointLabelContext(parent, index, label) {
    return (0, $9seh1.h)(parent, {
        label: label,
        index: index,
        type: "pointLabel"
    });
}
class $1af551c56cb88ebf$export$cfafc36d95386d38 extends $1af551c56cb88ebf$var$LinearScaleBase {
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $9seh1.K)($1af551c56cb88ebf$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $9seh1.g)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $9seh1.g)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $1af551c56cb88ebf$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $1af551c56cb88ebf$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $9seh1.C)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : "";
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $1af551c56cb88ebf$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $9seh1.T) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $9seh1.az)(index * angleMultiplier + (0, $9seh1.t)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $9seh1.k)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $9seh1.k)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $1af551c56cb88ebf$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $9seh1.H) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $1af551c56cb88ebf$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $1af551c56cb88ebf$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const optsAtIndex = grid.setContext(this.getContext(index - 1));
                $1af551c56cb88ebf$var$drawRadiusLine(this, optsAtIndex, offset, labelCount);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $9seh1.O)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $9seh1.K)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $9seh1.M)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
$1af551c56cb88ebf$export$cfafc36d95386d38.id = "radialLinear";
$1af551c56cb88ebf$export$cfafc36d95386d38.defaults = {
    display: true,
    animate: true,
    position: "chartArea",
    angleLines: {
        display: true,
        lineWidth: 1,
        borderDash: [],
        borderDashOffset: 0.0
    },
    grid: {
        circular: false
    },
    startAngle: 0,
    ticks: {
        showLabelBackdrop: true,
        callback: $1af551c56cb88ebf$export$27c7467594ef87bd.formatters.numeric
    },
    pointLabels: {
        backdropColor: undefined,
        backdropPadding: 2,
        display: true,
        font: {
            size: 10
        },
        callback (label) {
            return label;
        },
        padding: 5,
        centerPointLabels: false
    }
};
$1af551c56cb88ebf$export$cfafc36d95386d38.defaultRoutes = {
    "angleLines.color": "borderColor",
    "pointLabels.color": "color",
    "ticks.color": "color"
};
$1af551c56cb88ebf$export$cfafc36d95386d38.descriptors = {
    angleLines: {
        _fallback: "grid"
    }
};
const $1af551c56cb88ebf$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $1af551c56cb88ebf$var$UNITS = Object.keys($1af551c56cb88ebf$var$INTERVALS);
function $1af551c56cb88ebf$var$sorter(a, b) {
    return a - b;
}
function $1af551c56cb88ebf$var$parse(scale, input) {
    if ((0, $9seh1.k)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === "function") value = parser(value);
    if (!(0, $9seh1.g)(value)) value = typeof parser === "string" ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === "week" && ((0, $9seh1.x)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, "isoWeek", isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $1af551c56cb88ebf$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $1af551c56cb88ebf$var$UNITS.length;
    for(let i = $1af551c56cb88ebf$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $1af551c56cb88ebf$var$INTERVALS[$1af551c56cb88ebf$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $1af551c56cb88ebf$var$UNITS[i];
    }
    return $1af551c56cb88ebf$var$UNITS[ilen - 1];
}
function $1af551c56cb88ebf$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $1af551c56cb88ebf$var$UNITS.length - 1; i >= $1af551c56cb88ebf$var$UNITS.indexOf(minUnit); i--){
        const unit = $1af551c56cb88ebf$var$UNITS[i];
        if ($1af551c56cb88ebf$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $1af551c56cb88ebf$var$UNITS[minUnit ? $1af551c56cb88ebf$var$UNITS.indexOf(minUnit) : 0];
}
function $1af551c56cb88ebf$var$determineMajorUnit(unit) {
    for(let i = $1af551c56cb88ebf$var$UNITS.indexOf(unit) + 1, ilen = $1af551c56cb88ebf$var$UNITS.length; i < ilen; ++i){
        if ($1af551c56cb88ebf$var$INTERVALS[$1af551c56cb88ebf$var$UNITS[i]].common) return $1af551c56cb88ebf$var$UNITS[i];
    }
}
function $1af551c56cb88ebf$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $9seh1.aO)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $1af551c56cb88ebf$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $1af551c56cb88ebf$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $1af551c56cb88ebf$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $1af551c56cb88ebf$export$a894c72689ff3ec extends $1af551c56cb88ebf$export$d60cfc58d3c358b6 {
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = "day";
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $1af551c56cb88ebf$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $9seh1.ac)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $1af551c56cb88ebf$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || "day";
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== "ticks" || options.ticks.source !== "labels") _applyBounds(this.getMinMax(false));
        }
        min = (0, $9seh1.g)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $9seh1.g)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === "labels" ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === "ticks" && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $9seh1.aN)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $1af551c56cb88ebf$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $1af551c56cb88ebf$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === "year" ? undefined : $1af551c56cb88ebf$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $1af551c56cb88ebf$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $9seh1.E)(start, 0, limit);
        end = (0, $9seh1.E)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $1af551c56cb88ebf$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $9seh1.v)(timeOpts.stepSize, 1);
        const weekday = minor === "week" ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $9seh1.x)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, "isoWeek", weekday);
        first = +adapter.startOf(first, hasWeekday ? "day" : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + " and " + max + " are too far apart with stepSize of " + stepSize + " " + minor);
        const timestamps = options.ticks.source === "data" && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$1af551c56cb88ebf$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === "ticks" || count === 1) $1af551c56cb88ebf$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort((a, b)=>a - b).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        const label = this._adapter.format(time, format || (major ? majorFormat : minorFormat));
        const formatter = options.ticks.callback;
        return formatter ? (0, $9seh1.C)(formatter, [
            label,
            index,
            ticks
        ], this) : label;
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $9seh1.t)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $1af551c56cb88ebf$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($1af551c56cb88ebf$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $9seh1._)(values.sort($1af551c56cb88ebf$var$sorter));
    }
}
$1af551c56cb88ebf$export$a894c72689ff3ec.id = "time";
$1af551c56cb88ebf$export$a894c72689ff3ec.defaults = {
    bounds: "data",
    adapters: {},
    time: {
        parser: false,
        unit: false,
        round: false,
        isoWeekday: false,
        minUnit: "millisecond",
        displayFormats: {}
    },
    ticks: {
        source: "auto",
        major: {
            enabled: false
        }
    }
};
function $1af551c56cb88ebf$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $9seh1.Z)(table, "pos", val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $9seh1.Z)(table, "time", val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $1af551c56cb88ebf$export$85df64a8eb6dc986 extends $1af551c56cb88ebf$export$a894c72689ff3ec {
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $1af551c56cb88ebf$var$interpolate(table, this.min);
        this._tableRange = $1af551c56cb88ebf$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($1af551c56cb88ebf$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $1af551c56cb88ebf$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
$1af551c56cb88ebf$export$85df64a8eb6dc986.id = "timeseries";
$1af551c56cb88ebf$export$85df64a8eb6dc986.defaults = $1af551c56cb88ebf$export$a894c72689ff3ec.defaults;
var $1af551c56cb88ebf$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $1af551c56cb88ebf$export$29e663ba4d09fe7,
    LinearScale: $1af551c56cb88ebf$export$e7f4e5e8656f0b93,
    LogarithmicScale: $1af551c56cb88ebf$export$85295eaf7cb3ac3e,
    RadialLinearScale: $1af551c56cb88ebf$export$cfafc36d95386d38,
    TimeScale: $1af551c56cb88ebf$export$a894c72689ff3ec,
    TimeSeriesScale: $1af551c56cb88ebf$export$85df64a8eb6dc986
});
const $1af551c56cb88ebf$export$e8959e79e3af550f = [
    $1af551c56cb88ebf$export$a6506504f799c5d5,
    $1af551c56cb88ebf$export$7a5d735b2ab6389d,
    $1af551c56cb88ebf$export$8b3ca321c77fdea6,
    $1af551c56cb88ebf$export$bcac1c16f1530ec2
];

});
parcelRegister("9seh1", function(module, exports) {

$parcel$export(module.exports, "aF", () => $97ecbd121be4860b$export$cf2f7c5792f80b46);
$parcel$export(module.exports, "ad", () => $97ecbd121be4860b$export$4c3d22f3d993c33f);
$parcel$export(module.exports, "k", () => $97ecbd121be4860b$export$342063e11d6c3cad);
$parcel$export(module.exports, "b", () => $97ecbd121be4860b$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "i", () => $97ecbd121be4860b$export$23f2a1d2818174ef);
$parcel$export(module.exports, "g", () => $97ecbd121be4860b$export$39b482c5e57630a8);
$parcel$export(module.exports, "B", () => $97ecbd121be4860b$export$ef35774e6d314e91);
$parcel$export(module.exports, "v", () => $97ecbd121be4860b$export$90a7f3efeed30595);
$parcel$export(module.exports, "m", () => $97ecbd121be4860b$export$953cecd6e717a553);
$parcel$export(module.exports, "n", () => $97ecbd121be4860b$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "C", () => $97ecbd121be4860b$export$e7094788287c5e9b);
$parcel$export(module.exports, "Q", () => $97ecbd121be4860b$export$3722cfe417b6ed86);
$parcel$export(module.exports, "ai", () => $97ecbd121be4860b$export$f38c853ae54ed474);
$parcel$export(module.exports, "V", () => $97ecbd121be4860b$export$e7c866399fa523f5);
$parcel$export(module.exports, "ac", () => $97ecbd121be4860b$export$2219238a014317b0);
$parcel$export(module.exports, "f", () => $97ecbd121be4860b$export$2d1720544b23b823);
$parcel$export(module.exports, "W", () => $97ecbd121be4860b$export$71cec2538cb2c617);
$parcel$export(module.exports, "j", () => $97ecbd121be4860b$export$35e795649ee09318);
$parcel$export(module.exports, "a8", () => $97ecbd121be4860b$export$c3950d9923825c02);
$parcel$export(module.exports, "ah", () => $97ecbd121be4860b$export$995eb9fca571757);
$parcel$export(module.exports, "aj", () => $97ecbd121be4860b$export$3b513254972cfc9c);
$parcel$export(module.exports, "P", () => $97ecbd121be4860b$export$56c0d5a1e737357d);
$parcel$export(module.exports, "T", () => $97ecbd121be4860b$export$971d5caa766a69d7);
$parcel$export(module.exports, "H", () => $97ecbd121be4860b$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "z", () => $97ecbd121be4860b$export$df995fae86a55f06);
$parcel$export(module.exports, "s", () => $97ecbd121be4860b$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "aI", () => $97ecbd121be4860b$export$b9a6b53f9be3734);
$parcel$export(module.exports, "aK", () => $97ecbd121be4860b$export$23ebac1979863676);
$parcel$export(module.exports, "A", () => $97ecbd121be4860b$export$ebd11618f299a286);
$parcel$export(module.exports, "x", () => $97ecbd121be4860b$export$d141bba7fdc215a3);
$parcel$export(module.exports, "aJ", () => $97ecbd121be4860b$export$a05254e7c3aeba6e);
$parcel$export(module.exports, "aH", () => $97ecbd121be4860b$export$a33b77bbdbb8366c);
$parcel$export(module.exports, "t", () => $97ecbd121be4860b$export$625550452a3fa3ec);
$parcel$export(module.exports, "F", () => $97ecbd121be4860b$export$d66501df72047452);
$parcel$export(module.exports, "aL", () => $97ecbd121be4860b$export$91477dc880baac21);
$parcel$export(module.exports, "a0", () => $97ecbd121be4860b$export$34aec0b863436764);
$parcel$export(module.exports, "aG", () => $97ecbd121be4860b$export$53a70dd1ebbae346);
$parcel$export(module.exports, "az", () => $97ecbd121be4860b$export$3d12bd131bb975d1);
$parcel$export(module.exports, "p", () => $97ecbd121be4860b$export$ffb5f4729a158638);
$parcel$export(module.exports, "E", () => $97ecbd121be4860b$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "I", () => $97ecbd121be4860b$export$9bb611d729802a56);
$parcel$export(module.exports, "ak", () => $97ecbd121be4860b$export$21579262ef46735b);
$parcel$export(module.exports, "aO", () => $97ecbd121be4860b$export$c03999cb2f36933f);
$parcel$export(module.exports, "Z", () => $97ecbd121be4860b$export$dc98b0b04f4c7758);
$parcel$export(module.exports, "Y", () => $97ecbd121be4860b$export$8743009a87fcb00f);
$parcel$export(module.exports, "aN", () => $97ecbd121be4860b$export$faec65b429be379);
$parcel$export(module.exports, "l", () => $97ecbd121be4860b$export$882b5998b3b9117c);
$parcel$export(module.exports, "u", () => $97ecbd121be4860b$export$3b14a55fb2447963);
$parcel$export(module.exports, "_", () => $97ecbd121be4860b$export$71511d61b312f219);
$parcel$export(module.exports, "r", () => $97ecbd121be4860b$export$43caf9889c228507);
$parcel$export(module.exports, "a4", () => $97ecbd121be4860b$export$efca4cbe5dd06740);
$parcel$export(module.exports, "ae", () => $97ecbd121be4860b$export$f787f51d84a910ad);
$parcel$export(module.exports, "R", () => $97ecbd121be4860b$export$db202ddc8be9136);
$parcel$export(module.exports, "S", () => $97ecbd121be4860b$export$25ce5a424b770e84);
$parcel$export(module.exports, "aC", () => $97ecbd121be4860b$export$890c4ad488842ce7);
$parcel$export(module.exports, "q", () => $97ecbd121be4860b$export$9e5f44173e64f162);
$parcel$export(module.exports, "w", () => $97ecbd121be4860b$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "e", () => $97ecbd121be4860b$export$f1e1789686576879);
$parcel$export(module.exports, "c", () => $97ecbd121be4860b$export$db3b6bfb95261072);
$parcel$export(module.exports, "U", () => $97ecbd121be4860b$export$3a6d5c9ae78a2c08);
$parcel$export(module.exports, "a7", () => $97ecbd121be4860b$export$a93c5207d687da10);
$parcel$export(module.exports, "d", () => $97ecbd121be4860b$export$4368d992c4eafac0);
$parcel$export(module.exports, "G", () => $97ecbd121be4860b$export$2329c99376c9d0a4);
$parcel$export(module.exports, "aM", () => $97ecbd121be4860b$export$9f4f30ee63539e24);
$parcel$export(module.exports, "J", () => $97ecbd121be4860b$export$b4171a6734a65d42);
$parcel$export(module.exports, "ag", () => $97ecbd121be4860b$export$ee7c8ad385a60b7b);
$parcel$export(module.exports, "au", () => $97ecbd121be4860b$export$1fbe638ecf81657e);
$parcel$export(module.exports, "aE", () => $97ecbd121be4860b$export$158acd800e1ef08b);
$parcel$export(module.exports, "$", () => $97ecbd121be4860b$export$3d8c2f653ac9d0b9);
$parcel$export(module.exports, "L", () => $97ecbd121be4860b$export$61196ced6d74a310);
$parcel$export(module.exports, "N", () => $97ecbd121be4860b$export$a07804094c3ecf2d);
$parcel$export(module.exports, "as", () => $97ecbd121be4860b$export$6554612db691658e);
$parcel$export(module.exports, "at", () => $97ecbd121be4860b$export$493d36ec626b6698);
$parcel$export(module.exports, "M", () => $97ecbd121be4860b$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "av", () => $97ecbd121be4860b$export$d66dc83d8cfc8dd);
$parcel$export(module.exports, "al", () => $97ecbd121be4860b$export$ab83b03e4111b1d0);
$parcel$export(module.exports, "aw", () => $97ecbd121be4860b$export$92108d983e8ee699);
$parcel$export(module.exports, "ax", () => $97ecbd121be4860b$export$9fa96a7d116ea3ce);
$parcel$export(module.exports, "K", () => $97ecbd121be4860b$export$3466f893ebf79586);
$parcel$export(module.exports, "O", () => $97ecbd121be4860b$export$c4ce752e73470fba);
$parcel$export(module.exports, "a", () => $97ecbd121be4860b$export$407448d2b89b1813);
$parcel$export(module.exports, "D", () => $97ecbd121be4860b$export$96f57966bedc81b4);
$parcel$export(module.exports, "h", () => $97ecbd121be4860b$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "aa", () => $97ecbd121be4860b$export$7910e0436ed8d1de);
$parcel$export(module.exports, "a9", () => $97ecbd121be4860b$export$a9c996f45e5784d0);
$parcel$export(module.exports, "ab", () => $97ecbd121be4860b$export$555508cbc6add439);
$parcel$export(module.exports, "y", () => $97ecbd121be4860b$export$4a5767248b18ef41);
$parcel$export(module.exports, "am", () => $97ecbd121be4860b$export$1a82df3d29112e01);
$parcel$export(module.exports, "a6", () => $97ecbd121be4860b$export$2e2af4578d910ddf);
$parcel$export(module.exports, "a2", () => $97ecbd121be4860b$export$ce26c07117d59d6a);
$parcel$export(module.exports, "X", () => $97ecbd121be4860b$export$78acf4525d8a74c4);
$parcel$export(module.exports, "a1", () => $97ecbd121be4860b$export$3c2fa207a37baaea);
$parcel$export(module.exports, "af", () => $97ecbd121be4860b$export$c9170ad7d4cd7e57);
$parcel$export(module.exports, "a5", () => $97ecbd121be4860b$export$a8550f7dbe79f93a);
$parcel$export(module.exports, "a3", () => $97ecbd121be4860b$export$6559d589eb85fbb6);
$parcel$export(module.exports, "ar", () => $97ecbd121be4860b$export$d24c54395ce0c509);
$parcel$export(module.exports, "ap", () => $97ecbd121be4860b$export$2f6ca3d3b1f80bf5);
$parcel$export(module.exports, "aq", () => $97ecbd121be4860b$export$8a5498727ef6be21);
$parcel$export(module.exports, "o", () => $97ecbd121be4860b$export$ae1af26003f05816);
$parcel$export(module.exports, "aA", () => $97ecbd121be4860b$export$91c6e00c14e7e6fd);
$parcel$export(module.exports, "aB", () => $97ecbd121be4860b$export$9d398bebfec1c039);
$parcel$export(module.exports, "aD", () => $97ecbd121be4860b$export$24baa2b76016ce0e);
$parcel$export(module.exports, "ay", () => $97ecbd121be4860b$export$28f7fcd39efa255);
$parcel$export(module.exports, "ao", () => $97ecbd121be4860b$export$7a38258bbe170828);
$parcel$export(module.exports, "an", () => $97ecbd121be4860b$export$306ddfe3a8403e2);
/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */ function $97ecbd121be4860b$export$cf2f7c5792f80b46() {}
const $97ecbd121be4860b$export$4c3d22f3d993c33f = function() {
    let id = 0;
    return function() {
        return id++;
    };
}();
function $97ecbd121be4860b$export$342063e11d6c3cad(value) {
    return value === null || typeof value === "undefined";
}
function $97ecbd121be4860b$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === "[object" && type.slice(-6) === "Array]") return true;
    return false;
}
function $97ecbd121be4860b$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === "[object Object]";
}
const $97ecbd121be4860b$export$39b482c5e57630a8 = (value)=>(typeof value === "number" || value instanceof Number) && isFinite(+value);
function $97ecbd121be4860b$export$ef35774e6d314e91(value, defaultValue) {
    return $97ecbd121be4860b$export$39b482c5e57630a8(value) ? value : defaultValue;
}
function $97ecbd121be4860b$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === "undefined" ? defaultValue : value;
}
const $97ecbd121be4860b$export$953cecd6e717a553 = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 : value / dimension;
const $97ecbd121be4860b$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 * dimension : +value;
function $97ecbd121be4860b$export$e7094788287c5e9b(fn, args, thisArg) {
    if (fn && typeof fn.call === "function") return fn.apply(thisArg, args);
}
function $97ecbd121be4860b$export$3722cfe417b6ed86(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($97ecbd121be4860b$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($97ecbd121be4860b$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
function $97ecbd121be4860b$export$f38c853ae54ed474(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
function $97ecbd121be4860b$export$738ab4df8bf92ae9(source) {
    if ($97ecbd121be4860b$export$8b22cf2602fb60ce(source)) return source.map($97ecbd121be4860b$export$738ab4df8bf92ae9);
    if ($97ecbd121be4860b$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $97ecbd121be4860b$export$738ab4df8bf92ae9(source[keys[k]]);
        return target;
    }
    return source;
}
function $97ecbd121be4860b$var$isValidKey(key) {
    return [
        "__proto__",
        "prototype",
        "constructor"
    ].indexOf(key) === -1;
}
function $97ecbd121be4860b$export$d377dcb2b61d6c4e(key, target, source, options) {
    if (!$97ecbd121be4860b$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($97ecbd121be4860b$export$23f2a1d2818174ef(tval) && $97ecbd121be4860b$export$23f2a1d2818174ef(sval)) $97ecbd121be4860b$export$e7c866399fa523f5(tval, sval, options);
    else target[key] = $97ecbd121be4860b$export$738ab4df8bf92ae9(sval);
}
function $97ecbd121be4860b$export$e7c866399fa523f5(target, source, options) {
    const sources = $97ecbd121be4860b$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$97ecbd121be4860b$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $97ecbd121be4860b$export$d377dcb2b61d6c4e;
    for(let i = 0; i < ilen; ++i){
        source = sources[i];
        if (!$97ecbd121be4860b$export$23f2a1d2818174ef(source)) continue;
        const keys = Object.keys(source);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, source, options);
    }
    return target;
}
function $97ecbd121be4860b$export$2219238a014317b0(target, source) {
    return $97ecbd121be4860b$export$e7c866399fa523f5(target, source, {
        merger: $97ecbd121be4860b$export$667d3bf0c5f83305
    });
}
function $97ecbd121be4860b$export$667d3bf0c5f83305(key, target, source) {
    if (!$97ecbd121be4860b$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($97ecbd121be4860b$export$23f2a1d2818174ef(tval) && $97ecbd121be4860b$export$23f2a1d2818174ef(sval)) $97ecbd121be4860b$export$2219238a014317b0(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $97ecbd121be4860b$export$738ab4df8bf92ae9(sval);
}
function $97ecbd121be4860b$export$317a3d46287192d8(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
const $97ecbd121be4860b$var$keyResolvers = {
    "": (v)=>v,
    x: (o)=>o.x,
    y: (o)=>o.y
};
function $97ecbd121be4860b$export$2d1720544b23b823(obj, key) {
    const resolver = $97ecbd121be4860b$var$keyResolvers[key] || ($97ecbd121be4860b$var$keyResolvers[key] = $97ecbd121be4860b$var$_getKeyResolver(key));
    return resolver(obj);
}
function $97ecbd121be4860b$var$_getKeyResolver(key) {
    const keys = $97ecbd121be4860b$export$1ee57be6f6687d2c(key);
    return (obj)=>{
        for (const k of keys){
            if (k === "") break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $97ecbd121be4860b$export$1ee57be6f6687d2c(key) {
    const parts = key.split(".");
    const keys = [];
    let tmp = "";
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith("\\")) tmp = tmp.slice(0, -1) + ".";
        else {
            keys.push(tmp);
            tmp = "";
        }
    }
    return keys;
}
function $97ecbd121be4860b$export$71cec2538cb2c617(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $97ecbd121be4860b$export$35e795649ee09318 = (value)=>typeof value !== "undefined";
const $97ecbd121be4860b$export$c3950d9923825c02 = (value)=>typeof value === "function";
const $97ecbd121be4860b$export$995eb9fca571757 = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
function $97ecbd121be4860b$export$3b513254972cfc9c(e) {
    return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const $97ecbd121be4860b$export$56c0d5a1e737357d = Math.PI;
const $97ecbd121be4860b$export$971d5caa766a69d7 = 2 * $97ecbd121be4860b$export$56c0d5a1e737357d;
const $97ecbd121be4860b$export$8c78c7c36408ea29 = $97ecbd121be4860b$export$971d5caa766a69d7 + $97ecbd121be4860b$export$56c0d5a1e737357d;
const $97ecbd121be4860b$export$d29e374196577086 = Number.POSITIVE_INFINITY;
const $97ecbd121be4860b$export$2ec5befb9e6c97d4 = $97ecbd121be4860b$export$56c0d5a1e737357d / 180;
const $97ecbd121be4860b$export$7f8ddf7c7c20b3cd = $97ecbd121be4860b$export$56c0d5a1e737357d / 2;
const $97ecbd121be4860b$export$53c86fa97d611818 = $97ecbd121be4860b$export$56c0d5a1e737357d / 4;
const $97ecbd121be4860b$export$39c1cc7c062529d4 = $97ecbd121be4860b$export$56c0d5a1e737357d * 2 / 3;
const $97ecbd121be4860b$export$df995fae86a55f06 = Math.log10;
const $97ecbd121be4860b$export$2408f22a0fab9ae5 = Math.sign;
function $97ecbd121be4860b$export$b9a6b53f9be3734(range) {
    const roundedRange = Math.round(range);
    range = $97ecbd121be4860b$export$23ebac1979863676(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($97ecbd121be4860b$export$df995fae86a55f06(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
function $97ecbd121be4860b$export$ebd11618f299a286(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
function $97ecbd121be4860b$export$d141bba7fdc215a3(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function $97ecbd121be4860b$export$23ebac1979863676(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
function $97ecbd121be4860b$export$a05254e7c3aeba6e(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
function $97ecbd121be4860b$export$a33b77bbdbb8366c(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $97ecbd121be4860b$export$625550452a3fa3ec(degrees) {
    return degrees * ($97ecbd121be4860b$export$56c0d5a1e737357d / 180);
}
function $97ecbd121be4860b$export$d66501df72047452(radians) {
    return radians * (180 / $97ecbd121be4860b$export$56c0d5a1e737357d);
}
function $97ecbd121be4860b$export$91477dc880baac21(x) {
    if (!$97ecbd121be4860b$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
function $97ecbd121be4860b$export$34aec0b863436764(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $97ecbd121be4860b$export$56c0d5a1e737357d) angle += $97ecbd121be4860b$export$971d5caa766a69d7;
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $97ecbd121be4860b$export$53a70dd1ebbae346(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
function $97ecbd121be4860b$export$7a0bdf7d4a91ea88(a, b) {
    return (a - b + $97ecbd121be4860b$export$8c78c7c36408ea29) % $97ecbd121be4860b$export$971d5caa766a69d7 - $97ecbd121be4860b$export$56c0d5a1e737357d;
}
function $97ecbd121be4860b$export$3d12bd131bb975d1(a) {
    return (a % $97ecbd121be4860b$export$971d5caa766a69d7 + $97ecbd121be4860b$export$971d5caa766a69d7) % $97ecbd121be4860b$export$971d5caa766a69d7;
}
function $97ecbd121be4860b$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $97ecbd121be4860b$export$3d12bd131bb975d1(angle);
    const s = $97ecbd121be4860b$export$3d12bd131bb975d1(start);
    const e = $97ecbd121be4860b$export$3d12bd131bb975d1(end);
    const angleToStart = $97ecbd121be4860b$export$3d12bd131bb975d1(s - a);
    const angleToEnd = $97ecbd121be4860b$export$3d12bd131bb975d1(e - a);
    const startToAngle = $97ecbd121be4860b$export$3d12bd131bb975d1(a - s);
    const endToAngle = $97ecbd121be4860b$export$3d12bd131bb975d1(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
function $97ecbd121be4860b$export$a9c23c6ac3fc3eca(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
function $97ecbd121be4860b$export$9bb611d729802a56(value) {
    return $97ecbd121be4860b$export$a9c23c6ac3fc3eca(value, -32768, 32767);
}
function $97ecbd121be4860b$export$21579262ef46735b(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $97ecbd121be4860b$export$c03999cb2f36933f(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
const $97ecbd121be4860b$export$dc98b0b04f4c7758 = (table, key, value, last)=>$97ecbd121be4860b$export$c03999cb2f36933f(table, value, last ? (index)=>table[index][key] <= value : (index)=>table[index][key] < value);
const $97ecbd121be4860b$export$8743009a87fcb00f = (table, key, value)=>$97ecbd121be4860b$export$c03999cb2f36933f(table, value, (index)=>table[index][key] >= value);
function $97ecbd121be4860b$export$faec65b429be379(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $97ecbd121be4860b$var$arrayEvents = [
    "push",
    "pop",
    "shift",
    "splice",
    "unshift"
];
function $97ecbd121be4860b$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, "_chartjs", {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $97ecbd121be4860b$var$arrayEvents.forEach((key)=>{
        const method = "_onData" + $97ecbd121be4860b$export$71cec2538cb2c617(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === "function") object[method](...args);
                });
                return res;
            }
        });
    });
}
function $97ecbd121be4860b$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $97ecbd121be4860b$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
function $97ecbd121be4860b$export$71511d61b312f219(items) {
    const set = new Set();
    let i, ilen;
    for(i = 0, ilen = items.length; i < ilen; ++i)set.add(items[i]);
    if (set.size === ilen) return items;
    return Array.from(set);
}
function $97ecbd121be4860b$export$a17c37559e1db147(pixelSize, fontStyle, fontFamily) {
    return fontStyle + " " + pixelSize + "px " + fontFamily;
}
const $97ecbd121be4860b$export$43caf9889c228507 = function() {
    if (typeof window === "undefined") return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
function $97ecbd121be4860b$export$efca4cbe5dd06740(fn, thisArg, updateFn) {
    const updateArgs = updateFn || ((args)=>Array.prototype.slice.call(args));
    let ticking = false;
    let args = [];
    return function(...rest) {
        args = updateArgs(rest);
        if (!ticking) {
            ticking = true;
            $97ecbd121be4860b$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, args);
            });
        }
    };
}
function $97ecbd121be4860b$export$f787f51d84a910ad(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
const $97ecbd121be4860b$export$db202ddc8be9136 = (align)=>align === "start" ? "left" : align === "end" ? "right" : "center";
const $97ecbd121be4860b$export$25ce5a424b770e84 = (align, start, end)=>align === "start" ? start : align === "end" ? end : (start + end) / 2;
const $97ecbd121be4860b$export$890c4ad488842ce7 = (align, left, right, rtl)=>{
    const check = rtl ? "left" : "right";
    return align === check ? right : align === "center" ? (left + right) / 2 : left;
};
function $97ecbd121be4860b$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, _parsed: _parsed } = meta;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) start = $97ecbd121be4860b$export$a9c23c6ac3fc3eca(Math.min($97ecbd121be4860b$export$dc98b0b04f4c7758(_parsed, iScale.axis, min).lo, animationsDisabled ? pointCount : $97ecbd121be4860b$export$dc98b0b04f4c7758(points, axis, iScale.getPixelForValue(min)).lo), 0, pointCount - 1);
        if (maxDefined) count = $97ecbd121be4860b$export$a9c23c6ac3fc3eca(Math.max($97ecbd121be4860b$export$dc98b0b04f4c7758(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $97ecbd121be4860b$export$dc98b0b04f4c7758(points, axis, iScale.getPixelForValue(max), true).hi + 1), start, pointCount) - start;
        else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
function $97ecbd121be4860b$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $97ecbd121be4860b$var$atEdge = (t)=>t === 0 || t === 1;
const $97ecbd121be4860b$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $97ecbd121be4860b$export$971d5caa766a69d7 / p));
const $97ecbd121be4860b$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $97ecbd121be4860b$export$971d5caa766a69d7 / p) + 1;
const $97ecbd121be4860b$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $97ecbd121be4860b$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $97ecbd121be4860b$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($97ecbd121be4860b$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$97ecbd121be4860b$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$97ecbd121be4860b$var$atEdge(t) ? t : $97ecbd121be4860b$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$97ecbd121be4860b$var$atEdge(t) ? t : $97ecbd121be4860b$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $97ecbd121be4860b$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $97ecbd121be4860b$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $97ecbd121be4860b$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $97ecbd121be4860b$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $97ecbd121be4860b$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $97ecbd121be4860b$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
/*!
 * @kurkle/color v0.2.1
 * https://github.com/kurkle/color#readme
 * (c) 2022 Jukka Kurkela
 * Released under the MIT License
 */ function $97ecbd121be4860b$var$round(v) {
    return v + 0.5 | 0;
}
const $97ecbd121be4860b$var$lim = (v, l, h)=>Math.max(Math.min(v, h), l);
function $97ecbd121be4860b$var$p2b(v) {
    return $97ecbd121be4860b$var$lim($97ecbd121be4860b$var$round(v * 2.55), 0, 255);
}
function $97ecbd121be4860b$var$n2b(v) {
    return $97ecbd121be4860b$var$lim($97ecbd121be4860b$var$round(v * 255), 0, 255);
}
function $97ecbd121be4860b$var$b2n(v) {
    return $97ecbd121be4860b$var$lim($97ecbd121be4860b$var$round(v / 2.55) / 100, 0, 1);
}
function $97ecbd121be4860b$var$n2p(v) {
    return $97ecbd121be4860b$var$lim($97ecbd121be4860b$var$round(v * 100), 0, 100);
}
const $97ecbd121be4860b$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $97ecbd121be4860b$var$hex = [
    ..."0123456789ABCDEF"
];
const $97ecbd121be4860b$var$h1 = (b)=>$97ecbd121be4860b$var$hex[b & 0xF];
const $97ecbd121be4860b$var$h2 = (b)=>$97ecbd121be4860b$var$hex[(b & 0xF0) >> 4] + $97ecbd121be4860b$var$hex[b & 0xF];
const $97ecbd121be4860b$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $97ecbd121be4860b$var$isShort = (v)=>$97ecbd121be4860b$var$eq(v.r) && $97ecbd121be4860b$var$eq(v.g) && $97ecbd121be4860b$var$eq(v.b) && $97ecbd121be4860b$var$eq(v.a);
function $97ecbd121be4860b$var$hexParse(str) {
    var len = str.length;
    var ret;
    if (str[0] === "#") {
        if (len === 4 || len === 5) ret = {
            r: 255 & $97ecbd121be4860b$var$map$1[str[1]] * 17,
            g: 255 & $97ecbd121be4860b$var$map$1[str[2]] * 17,
            b: 255 & $97ecbd121be4860b$var$map$1[str[3]] * 17,
            a: len === 5 ? $97ecbd121be4860b$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $97ecbd121be4860b$var$map$1[str[1]] << 4 | $97ecbd121be4860b$var$map$1[str[2]],
            g: $97ecbd121be4860b$var$map$1[str[3]] << 4 | $97ecbd121be4860b$var$map$1[str[4]],
            b: $97ecbd121be4860b$var$map$1[str[5]] << 4 | $97ecbd121be4860b$var$map$1[str[6]],
            a: len === 9 ? $97ecbd121be4860b$var$map$1[str[7]] << 4 | $97ecbd121be4860b$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $97ecbd121be4860b$var$alpha = (a, f)=>a < 255 ? f(a) : "";
function $97ecbd121be4860b$var$hexString(v) {
    var f = $97ecbd121be4860b$var$isShort(v) ? $97ecbd121be4860b$var$h1 : $97ecbd121be4860b$var$h2;
    return v ? "#" + f(v.r) + f(v.g) + f(v.b) + $97ecbd121be4860b$var$alpha(v.a, f) : undefined;
}
const $97ecbd121be4860b$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $97ecbd121be4860b$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $97ecbd121be4860b$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $97ecbd121be4860b$var$hwb2rgbn(h, w, b) {
    const rgb = $97ecbd121be4860b$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $97ecbd121be4860b$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $97ecbd121be4860b$var$rgb2hsl(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $97ecbd121be4860b$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $97ecbd121be4860b$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($97ecbd121be4860b$var$n2b);
}
function $97ecbd121be4860b$var$hsl2rgb(h, s, l) {
    return $97ecbd121be4860b$var$calln($97ecbd121be4860b$var$hsl2rgbn, h, s, l);
}
function $97ecbd121be4860b$var$hwb2rgb(h, w, b) {
    return $97ecbd121be4860b$var$calln($97ecbd121be4860b$var$hwb2rgbn, h, w, b);
}
function $97ecbd121be4860b$var$hsv2rgb(h, s, v) {
    return $97ecbd121be4860b$var$calln($97ecbd121be4860b$var$hsv2rgbn, h, s, v);
}
function $97ecbd121be4860b$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $97ecbd121be4860b$var$hueParse(str) {
    const m = $97ecbd121be4860b$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $97ecbd121be4860b$var$p2b(+m[5]) : $97ecbd121be4860b$var$n2b(+m[5]);
    const h = $97ecbd121be4860b$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === "hwb") v = $97ecbd121be4860b$var$hwb2rgb(h, p1, p2);
    else if (m[1] === "hsv") v = $97ecbd121be4860b$var$hsv2rgb(h, p1, p2);
    else v = $97ecbd121be4860b$var$hsl2rgb(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $97ecbd121be4860b$var$rotate(v, deg) {
    var h = $97ecbd121be4860b$var$rgb2hsl(v);
    h[0] = $97ecbd121be4860b$var$hue(h[0] + deg);
    h = $97ecbd121be4860b$var$hsl2rgb(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $97ecbd121be4860b$var$hslString(v) {
    if (!v) return;
    const a = $97ecbd121be4860b$var$rgb2hsl(v);
    const h = a[0];
    const s = $97ecbd121be4860b$var$n2p(a[1]);
    const l = $97ecbd121be4860b$var$n2p(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$97ecbd121be4860b$var$b2n(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $97ecbd121be4860b$var$map = {
    x: "dark",
    Z: "light",
    Y: "re",
    X: "blu",
    W: "gr",
    V: "medium",
    U: "slate",
    A: "ee",
    T: "ol",
    S: "or",
    B: "ra",
    C: "lateg",
    D: "ights",
    R: "in",
    Q: "turquois",
    E: "hi",
    P: "ro",
    O: "al",
    N: "le",
    M: "de",
    L: "yello",
    F: "en",
    K: "ch",
    G: "arks",
    H: "ea",
    I: "ightg",
    J: "wh"
};
const $97ecbd121be4860b$var$names$1 = {
    OiceXe: "f0f8ff",
    antiquewEte: "faebd7",
    aqua: "ffff",
    aquamarRe: "7fffd4",
    azuY: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "0",
    blanKedOmond: "ffebcd",
    Xe: "ff",
    XeviTet: "8a2be2",
    bPwn: "a52a2a",
    burlywood: "deb887",
    caMtXe: "5f9ea0",
    KartYuse: "7fff00",
    KocTate: "d2691e",
    cSO: "ff7f50",
    cSnflowerXe: "6495ed",
    cSnsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "ffff",
    xXe: "8b",
    xcyan: "8b8b",
    xgTMnPd: "b8860b",
    xWay: "a9a9a9",
    xgYF: "6400",
    xgYy: "a9a9a9",
    xkhaki: "bdb76b",
    xmagFta: "8b008b",
    xTivegYF: "556b2f",
    xSange: "ff8c00",
    xScEd: "9932cc",
    xYd: "8b0000",
    xsOmon: "e9967a",
    xsHgYF: "8fbc8f",
    xUXe: "483d8b",
    xUWay: "2f4f4f",
    xUgYy: "2f4f4f",
    xQe: "ced1",
    xviTet: "9400d3",
    dAppRk: "ff1493",
    dApskyXe: "bfff",
    dimWay: "696969",
    dimgYy: "696969",
    dodgerXe: "1e90ff",
    fiYbrick: "b22222",
    flSOwEte: "fffaf0",
    foYstWAn: "228b22",
    fuKsia: "ff00ff",
    gaRsbSo: "dcdcdc",
    ghostwEte: "f8f8ff",
    gTd: "ffd700",
    gTMnPd: "daa520",
    Way: "808080",
    gYF: "8000",
    gYFLw: "adff2f",
    gYy: "808080",
    honeyMw: "f0fff0",
    hotpRk: "ff69b4",
    RdianYd: "cd5c5c",
    Rdigo: "4b0082",
    ivSy: "fffff0",
    khaki: "f0e68c",
    lavFMr: "e6e6fa",
    lavFMrXsh: "fff0f5",
    lawngYF: "7cfc00",
    NmoncEffon: "fffacd",
    ZXe: "add8e6",
    ZcSO: "f08080",
    Zcyan: "e0ffff",
    ZgTMnPdLw: "fafad2",
    ZWay: "d3d3d3",
    ZgYF: "90ee90",
    ZgYy: "d3d3d3",
    ZpRk: "ffb6c1",
    ZsOmon: "ffa07a",
    ZsHgYF: "20b2aa",
    ZskyXe: "87cefa",
    ZUWay: "778899",
    ZUgYy: "778899",
    ZstAlXe: "b0c4de",
    ZLw: "ffffe0",
    lime: "ff00",
    limegYF: "32cd32",
    lRF: "faf0e6",
    magFta: "ff00ff",
    maPon: "800000",
    VaquamarRe: "66cdaa",
    VXe: "cd",
    VScEd: "ba55d3",
    VpurpN: "9370db",
    VsHgYF: "3cb371",
    VUXe: "7b68ee",
    VsprRggYF: "fa9a",
    VQe: "48d1cc",
    VviTetYd: "c71585",
    midnightXe: "191970",
    mRtcYam: "f5fffa",
    mistyPse: "ffe4e1",
    moccasR: "ffe4b5",
    navajowEte: "ffdead",
    navy: "80",
    Tdlace: "fdf5e6",
    Tive: "808000",
    TivedBb: "6b8e23",
    Sange: "ffa500",
    SangeYd: "ff4500",
    ScEd: "da70d6",
    pOegTMnPd: "eee8aa",
    pOegYF: "98fb98",
    pOeQe: "afeeee",
    pOeviTetYd: "db7093",
    papayawEp: "ffefd5",
    pHKpuff: "ffdab9",
    peru: "cd853f",
    pRk: "ffc0cb",
    plum: "dda0dd",
    powMrXe: "b0e0e6",
    purpN: "800080",
    YbeccapurpN: "663399",
    Yd: "ff0000",
    Psybrown: "bc8f8f",
    PyOXe: "4169e1",
    saddNbPwn: "8b4513",
    sOmon: "fa8072",
    sandybPwn: "f4a460",
    sHgYF: "2e8b57",
    sHshell: "fff5ee",
    siFna: "a0522d",
    silver: "c0c0c0",
    skyXe: "87ceeb",
    UXe: "6a5acd",
    UWay: "708090",
    UgYy: "708090",
    snow: "fffafa",
    sprRggYF: "ff7f",
    stAlXe: "4682b4",
    tan: "d2b48c",
    teO: "8080",
    tEstN: "d8bfd8",
    tomato: "ff6347",
    Qe: "40e0d0",
    viTet: "ee82ee",
    JHt: "f5deb3",
    wEte: "ffffff",
    wEtesmoke: "f5f5f5",
    Lw: "ffff00",
    LwgYF: "9acd32"
};
function $97ecbd121be4860b$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($97ecbd121be4860b$var$names$1);
    const tkeys = Object.keys($97ecbd121be4860b$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $97ecbd121be4860b$var$map[k]);
        }
        k = parseInt($97ecbd121be4860b$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $97ecbd121be4860b$var$names;
function $97ecbd121be4860b$var$nameParse(str) {
    if (!$97ecbd121be4860b$var$names) {
        $97ecbd121be4860b$var$names = $97ecbd121be4860b$var$unpack();
        $97ecbd121be4860b$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $97ecbd121be4860b$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $97ecbd121be4860b$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $97ecbd121be4860b$var$rgbParse(str) {
    const m = $97ecbd121be4860b$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $97ecbd121be4860b$var$p2b(v) : $97ecbd121be4860b$var$lim(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $97ecbd121be4860b$var$p2b(r) : $97ecbd121be4860b$var$lim(r, 0, 255));
    g = 255 & (m[4] ? $97ecbd121be4860b$var$p2b(g) : $97ecbd121be4860b$var$lim(g, 0, 255));
    b = 255 & (m[6] ? $97ecbd121be4860b$var$p2b(b) : $97ecbd121be4860b$var$lim(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $97ecbd121be4860b$var$rgbString(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$97ecbd121be4860b$var$b2n(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $97ecbd121be4860b$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $97ecbd121be4860b$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $97ecbd121be4860b$var$interpolate(rgb1, rgb2, t) {
    const r = $97ecbd121be4860b$var$from($97ecbd121be4860b$var$b2n(rgb1.r));
    const g = $97ecbd121be4860b$var$from($97ecbd121be4860b$var$b2n(rgb1.g));
    const b = $97ecbd121be4860b$var$from($97ecbd121be4860b$var$b2n(rgb1.b));
    return {
        r: $97ecbd121be4860b$var$n2b($97ecbd121be4860b$var$to(r + t * ($97ecbd121be4860b$var$from($97ecbd121be4860b$var$b2n(rgb2.r)) - r))),
        g: $97ecbd121be4860b$var$n2b($97ecbd121be4860b$var$to(g + t * ($97ecbd121be4860b$var$from($97ecbd121be4860b$var$b2n(rgb2.g)) - g))),
        b: $97ecbd121be4860b$var$n2b($97ecbd121be4860b$var$to(b + t * ($97ecbd121be4860b$var$from($97ecbd121be4860b$var$b2n(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $97ecbd121be4860b$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $97ecbd121be4860b$var$rgb2hsl(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $97ecbd121be4860b$var$hsl2rgb(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $97ecbd121be4860b$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $97ecbd121be4860b$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $97ecbd121be4860b$var$n2b(input[3]);
        }
    } else {
        v = $97ecbd121be4860b$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $97ecbd121be4860b$var$n2b(v.a);
    }
    return v;
}
function $97ecbd121be4860b$var$functionParse(str) {
    if (str.charAt(0) === "r") return $97ecbd121be4860b$var$rgbParse(str);
    return $97ecbd121be4860b$var$hueParse(str);
}
class $97ecbd121be4860b$var$Color {
    constructor(input){
        if (input instanceof $97ecbd121be4860b$var$Color) return input;
        const type = typeof input;
        let v;
        if (type === "object") v = $97ecbd121be4860b$var$fromObject(input);
        else if (type === "string") v = $97ecbd121be4860b$var$hexParse(input) || $97ecbd121be4860b$var$nameParse(input) || $97ecbd121be4860b$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $97ecbd121be4860b$var$clone(this._rgb);
        if (v) v.a = $97ecbd121be4860b$var$b2n(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $97ecbd121be4860b$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $97ecbd121be4860b$var$rgbString(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $97ecbd121be4860b$var$hexString(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $97ecbd121be4860b$var$hslString(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $97ecbd121be4860b$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $97ecbd121be4860b$var$Color(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $97ecbd121be4860b$var$n2b(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $97ecbd121be4860b$var$round(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $97ecbd121be4860b$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $97ecbd121be4860b$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $97ecbd121be4860b$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $97ecbd121be4860b$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $97ecbd121be4860b$var$rotate(this._rgb, deg);
        return this;
    }
}
function $97ecbd121be4860b$var$index_esm(input) {
    return new $97ecbd121be4860b$var$Color(input);
}
function $97ecbd121be4860b$export$2ed0fc6709e59212(value) {
    if (value && typeof value === "object") {
        const type = value.toString();
        return type === "[object CanvasPattern]" || type === "[object CanvasGradient]";
    }
    return false;
}
function $97ecbd121be4860b$export$db3b6bfb95261072(value) {
    return $97ecbd121be4860b$export$2ed0fc6709e59212(value) ? value : $97ecbd121be4860b$var$index_esm(value);
}
function $97ecbd121be4860b$export$f96d196f7728bb5(value) {
    return $97ecbd121be4860b$export$2ed0fc6709e59212(value) ? value : $97ecbd121be4860b$var$index_esm(value).saturate(0.5).darken(0.1).hexString();
}
const $97ecbd121be4860b$export$3a6d5c9ae78a2c08 = Object.create(null);
const $97ecbd121be4860b$export$a93c5207d687da10 = Object.create(null);
function $97ecbd121be4860b$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split(".");
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $97ecbd121be4860b$var$set(root, scope, values) {
    if (typeof scope === "string") return $97ecbd121be4860b$export$e7c866399fa523f5($97ecbd121be4860b$var$getScope$1(root, scope), values);
    return $97ecbd121be4860b$export$e7c866399fa523f5($97ecbd121be4860b$var$getScope$1(root, ""), scope);
}
class $97ecbd121be4860b$var$Defaults {
    constructor(_descriptors){
        this.animation = undefined;
        this.backgroundColor = "rgba(0,0,0,0.1)";
        this.borderColor = "rgba(0,0,0,0.1)";
        this.color = "#666";
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            "mousemove",
            "mouseout",
            "click",
            "touchstart",
            "touchmove"
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: "normal",
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$97ecbd121be4860b$export$f96d196f7728bb5(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$97ecbd121be4860b$export$f96d196f7728bb5(options.borderColor);
        this.hoverColor = (ctx, options)=>$97ecbd121be4860b$export$f96d196f7728bb5(options.color);
        this.indexAxis = "x";
        this.interaction = {
            mode: "nearest",
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
    }
    set(scope, values) {
        return $97ecbd121be4860b$var$set(this, scope, values);
    }
    get(scope) {
        return $97ecbd121be4860b$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $97ecbd121be4860b$var$set($97ecbd121be4860b$export$a93c5207d687da10, scope, values);
    }
    override(scope, values) {
        return $97ecbd121be4860b$var$set($97ecbd121be4860b$export$3a6d5c9ae78a2c08, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $97ecbd121be4860b$var$getScope$1(this, scope);
        const targetScopeObject = $97ecbd121be4860b$var$getScope$1(this, targetScope);
        const privateName = "_" + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($97ecbd121be4860b$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $97ecbd121be4860b$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
}
var $97ecbd121be4860b$export$4368d992c4eafac0 = new $97ecbd121be4860b$var$Defaults({
    _scriptable: (name)=>!name.startsWith("on"),
    _indexable: (name)=>name !== "events",
    hover: {
        _fallback: "interaction"
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
});
function $97ecbd121be4860b$export$9d0e2d13d04f7070(font) {
    if (!font || $97ecbd121be4860b$export$342063e11d6c3cad(font.size) || $97ecbd121be4860b$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
}
function $97ecbd121be4860b$export$2329c99376c9d0a4(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
function $97ecbd121be4860b$export$9f4f30ee63539e24(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        if (thing !== undefined && thing !== null && $97ecbd121be4860b$export$8b22cf2602fb60ce(thing) !== true) longest = $97ecbd121be4860b$export$2329c99376c9d0a4(ctx, data, gc, longest, thing);
        else if ($97ecbd121be4860b$export$8b22cf2602fb60ce(thing)) for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            if (nestedThing !== undefined && nestedThing !== null && !$97ecbd121be4860b$export$8b22cf2602fb60ce(nestedThing)) longest = $97ecbd121be4860b$export$2329c99376c9d0a4(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
function $97ecbd121be4860b$export$b4171a6734a65d42(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
function $97ecbd121be4860b$export$ee7c8ad385a60b7b(canvas, ctx) {
    ctx = ctx || canvas.getContext("2d");
    ctx.save();
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $97ecbd121be4860b$export$1fbe638ecf81657e(ctx, options, x, y) {
    $97ecbd121be4860b$export$158acd800e1ef08b(ctx, options, x, y, null);
}
function $97ecbd121be4860b$export$158acd800e1ef08b(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $97ecbd121be4860b$export$2ec5befb9e6c97d4;
    if (style && typeof style === "object") {
        type = style.toString();
        if (type === "[object HTMLImageElement]" || type === "[object HTMLCanvasElement]") {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $97ecbd121be4860b$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $97ecbd121be4860b$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case "triangle":
            ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += $97ecbd121be4860b$export$39c1cc7c062529d4;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += $97ecbd121be4860b$export$39c1cc7c062529d4;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case "rectRounded":
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $97ecbd121be4860b$export$53c86fa97d611818) * size;
            yOffset = Math.sin(rad + $97ecbd121be4860b$export$53c86fa97d611818) * size;
            ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - $97ecbd121be4860b$export$56c0d5a1e737357d, rad - $97ecbd121be4860b$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - $97ecbd121be4860b$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + $97ecbd121be4860b$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + $97ecbd121be4860b$export$7f8ddf7c7c20b3cd, rad + $97ecbd121be4860b$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case "rect":
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $97ecbd121be4860b$export$53c86fa97d611818;
        case "rectRot":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + yOffset, y - xOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            ctx.closePath();
            break;
        case "crossRot":
            rad += $97ecbd121be4860b$export$53c86fa97d611818;
        case "cross":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case "star":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            rad += $97ecbd121be4860b$export$53c86fa97d611818;
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case "line":
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case "dash":
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
function $97ecbd121be4860b$export$3d8c2f653ac9d0b9(point, area, margin) {
    margin = margin || 0.5;
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $97ecbd121be4860b$export$61196ced6d74a310(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $97ecbd121be4860b$export$a07804094c3ecf2d(ctx) {
    ctx.restore();
}
function $97ecbd121be4860b$export$6554612db691658e(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === "middle") {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === "after" !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
function $97ecbd121be4860b$export$493d36ec626b6698(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $97ecbd121be4860b$export$3a1a48c8f6ef640e(ctx, text, x, y, font, opts = {}) {
    const lines = $97ecbd121be4860b$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== "";
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $97ecbd121be4860b$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$97ecbd121be4860b$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $97ecbd121be4860b$var$decorateText(ctx, x, y, line, opts);
        y += font.lineHeight;
    }
    ctx.restore();
}
function $97ecbd121be4860b$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$97ecbd121be4860b$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $97ecbd121be4860b$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $97ecbd121be4860b$export$d66dc83d8cfc8dd(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, -$97ecbd121be4860b$export$7f8ddf7c7c20b3cd, $97ecbd121be4860b$export$56c0d5a1e737357d, true);
    ctx.lineTo(x, y + h - radius.bottomLeft);
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $97ecbd121be4860b$export$56c0d5a1e737357d, $97ecbd121be4860b$export$7f8ddf7c7c20b3cd, true);
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $97ecbd121be4860b$export$7f8ddf7c7c20b3cd, 0, true);
    ctx.lineTo(x + w, y + radius.topRight);
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$97ecbd121be4860b$export$7f8ddf7c7c20b3cd, true);
    ctx.lineTo(x + radius.topLeft, y);
}
const $97ecbd121be4860b$var$LINE_HEIGHT = new RegExp(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
const $97ecbd121be4860b$var$FONT_STYLE = new RegExp(/^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/);
function $97ecbd121be4860b$export$fef3dfd9bad05307(value, size) {
    const matches = ("" + value).match($97ecbd121be4860b$var$LINE_HEIGHT);
    if (!matches || matches[1] === "normal") return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case "px":
            return value;
        case "%":
            value /= 100;
            break;
    }
    return size * value;
}
const $97ecbd121be4860b$var$numberOrZero = (v)=>+v || 0;
function $97ecbd121be4860b$export$ab83b03e4111b1d0(value, props) {
    const ret = {};
    const objProps = $97ecbd121be4860b$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $97ecbd121be4860b$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$97ecbd121be4860b$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $97ecbd121be4860b$var$numberOrZero(read(prop));
    return ret;
}
function $97ecbd121be4860b$export$92108d983e8ee699(value) {
    return $97ecbd121be4860b$export$ab83b03e4111b1d0(value, {
        top: "y",
        right: "x",
        bottom: "y",
        left: "x"
    });
}
function $97ecbd121be4860b$export$9fa96a7d116ea3ce(value) {
    return $97ecbd121be4860b$export$ab83b03e4111b1d0(value, [
        "topLeft",
        "topRight",
        "bottomLeft",
        "bottomRight"
    ]);
}
function $97ecbd121be4860b$export$3466f893ebf79586(value) {
    const obj = $97ecbd121be4860b$export$92108d983e8ee699(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
function $97ecbd121be4860b$export$c4ce752e73470fba(options, fallback) {
    options = options || {};
    fallback = fallback || $97ecbd121be4860b$export$4368d992c4eafac0.font;
    let size = $97ecbd121be4860b$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === "string") size = parseInt(size, 10);
    let style = $97ecbd121be4860b$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !("" + style).match($97ecbd121be4860b$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = "";
    }
    const font = {
        family: $97ecbd121be4860b$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $97ecbd121be4860b$export$fef3dfd9bad05307($97ecbd121be4860b$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $97ecbd121be4860b$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ""
    };
    font.string = $97ecbd121be4860b$export$9d0e2d13d04f7070(font);
    return font;
}
function $97ecbd121be4860b$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === "function") {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $97ecbd121be4860b$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
function $97ecbd121be4860b$export$96f57966bedc81b4(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $97ecbd121be4860b$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $97ecbd121be4860b$export$dda1d9f60106f0e9(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
function $97ecbd121be4860b$export$7910e0436ed8d1de(scopes, prefixes = [
    ""
], rootScopes = scopes, fallback, getTarget = ()=>scopes[0]) {
    if (!$97ecbd121be4860b$export$35e795649ee09318(fallback)) fallback = $97ecbd121be4860b$var$_resolve("_fallback", scopes);
    const cache = {
        [Symbol.toStringTag]: "Object",
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: rootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$97ecbd121be4860b$export$7910e0436ed8d1de([
                scope,
                ...scopes
            ], prefixes, rootScopes, fallback)
    };
    return new Proxy(cache, {
        deleteProperty (target, prop) {
            delete target[prop];
            delete target._keys;
            delete scopes[0][prop];
            return true;
        },
        get (target, prop) {
            return $97ecbd121be4860b$var$_cached(target, prop, ()=>$97ecbd121be4860b$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        has (target, prop) {
            return $97ecbd121be4860b$var$getKeysFromAllScopes(target).includes(prop);
        },
        ownKeys (target) {
            return $97ecbd121be4860b$var$getKeysFromAllScopes(target);
        },
        set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value;
            delete target._keys;
            return true;
        }
    });
}
function $97ecbd121be4860b$export$a9c996f45e5784d0(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $97ecbd121be4860b$export$555508cbc6add439(proxy, descriptorDefaults),
        setContext: (ctx)=>$97ecbd121be4860b$export$a9c996f45e5784d0(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$97ecbd121be4860b$export$a9c996f45e5784d0(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        deleteProperty (target, prop) {
            delete target[prop];
            delete proxy[prop];
            return true;
        },
        get (target, prop, receiver) {
            return $97ecbd121be4860b$var$_cached(target, prop, ()=>$97ecbd121be4860b$var$_resolveWithContext(target, prop, receiver));
        },
        getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        set (target, prop, value) {
            proxy[prop] = value;
            delete target[prop];
            return true;
        }
    });
}
function $97ecbd121be4860b$export$555508cbc6add439(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $97ecbd121be4860b$export$c3950d9923825c02(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $97ecbd121be4860b$export$c3950d9923825c02(_indexable) ? _indexable : ()=>_indexable
    };
}
const $97ecbd121be4860b$var$readKey = (prefix, name)=>prefix ? prefix + $97ecbd121be4860b$export$71cec2538cb2c617(name) : name;
const $97ecbd121be4860b$var$needsSubResolver = (prop, value)=>$97ecbd121be4860b$export$23f2a1d2818174ef(value) && prop !== "adapters" && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $97ecbd121be4860b$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop)) return target[prop];
    const value = resolve();
    target[prop] = value;
    return value;
}
function $97ecbd121be4860b$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop];
    if ($97ecbd121be4860b$export$c3950d9923825c02(value) && descriptors.isScriptable(prop)) value = $97ecbd121be4860b$var$_resolveScriptable(prop, value, target, receiver);
    if ($97ecbd121be4860b$export$8b22cf2602fb60ce(value) && value.length) value = $97ecbd121be4860b$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($97ecbd121be4860b$var$needsSubResolver(prop, value)) value = $97ecbd121be4860b$export$a9c996f45e5784d0(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $97ecbd121be4860b$var$_resolveScriptable(prop, value, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error("Recursion detected: " + Array.from(_stack).join("->") + "->" + prop);
    _stack.add(prop);
    value = value(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($97ecbd121be4860b$var$needsSubResolver(prop, value)) value = $97ecbd121be4860b$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $97ecbd121be4860b$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if ($97ecbd121be4860b$export$35e795649ee09318(_context.index) && isIndexable(prop)) value = value[_context.index % value.length];
    else if ($97ecbd121be4860b$export$23f2a1d2818174ef(value[0])) {
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $97ecbd121be4860b$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($97ecbd121be4860b$export$a9c996f45e5784d0(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $97ecbd121be4860b$var$resolveFallback(fallback, prop, value) {
    return $97ecbd121be4860b$export$c3950d9923825c02(fallback) ? fallback(prop, value) : fallback;
}
const $97ecbd121be4860b$var$getScope = (key, parent)=>key === true ? parent : typeof key === "string" ? $97ecbd121be4860b$export$2d1720544b23b823(parent, key) : undefined;
function $97ecbd121be4860b$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $97ecbd121be4860b$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $97ecbd121be4860b$var$resolveFallback(scope._fallback, key, value);
            if ($97ecbd121be4860b$export$35e795649ee09318(fallback) && fallback !== key && fallback !== parentFallback) return fallback;
        } else if (scope === false && $97ecbd121be4860b$export$35e795649ee09318(parentFallback) && key !== parentFallback) return null;
    }
    return false;
}
function $97ecbd121be4860b$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $97ecbd121be4860b$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $97ecbd121be4860b$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if ($97ecbd121be4860b$export$35e795649ee09318(fallback) && fallback !== prop) {
        key = $97ecbd121be4860b$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $97ecbd121be4860b$export$7910e0436ed8d1de(Array.from(set), [
        ""
    ], rootScopes, fallback, ()=>$97ecbd121be4860b$var$subGetTarget(resolver, prop, value));
}
function $97ecbd121be4860b$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $97ecbd121be4860b$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $97ecbd121be4860b$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($97ecbd121be4860b$export$8b22cf2602fb60ce(target) && $97ecbd121be4860b$export$23f2a1d2818174ef(value)) return value;
    return target;
}
function $97ecbd121be4860b$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $97ecbd121be4860b$var$_resolve($97ecbd121be4860b$var$readKey(prefix, prop), scopes);
        if ($97ecbd121be4860b$export$35e795649ee09318(value)) return $97ecbd121be4860b$var$needsSubResolver(prop, value) ? $97ecbd121be4860b$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $97ecbd121be4860b$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if ($97ecbd121be4860b$export$35e795649ee09318(value)) return value;
    }
}
function $97ecbd121be4860b$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $97ecbd121be4860b$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $97ecbd121be4860b$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith("_")))set.add(key);
    return Array.from(set);
}
function $97ecbd121be4860b$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = "r" } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($97ecbd121be4860b$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $97ecbd121be4860b$var$EPSILON = Number.EPSILON || 1e-14;
const $97ecbd121be4860b$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $97ecbd121be4860b$var$getValueAxis = (indexAxis)=>indexAxis === "x" ? "y" : "x";
function $97ecbd121be4860b$export$1a8f5705751d8277(firstPoint, middlePoint, afterPoint, t) {
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $97ecbd121be4860b$export$53a70dd1ebbae346(current, previous);
    const d12 = $97ecbd121be4860b$export$53a70dd1ebbae346(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01;
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
function $97ecbd121be4860b$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $97ecbd121be4860b$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $97ecbd121be4860b$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($97ecbd121be4860b$export$23ebac1979863676(deltaK[i], 0, $97ecbd121be4860b$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $97ecbd121be4860b$var$monotoneCompute(points, mK, indexAxis = "x") {
    const valueAxis = $97ecbd121be4860b$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $97ecbd121be4860b$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $97ecbd121be4860b$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
function $97ecbd121be4860b$export$e171bab687b50e0(points, indexAxis = "x") {
    const valueAxis = $97ecbd121be4860b$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    let i, pointBefore, pointCurrent;
    let pointAfter = $97ecbd121be4860b$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $97ecbd121be4860b$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $97ecbd121be4860b$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $97ecbd121be4860b$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $97ecbd121be4860b$var$monotoneAdjust(points, deltaK, mK);
    $97ecbd121be4860b$var$monotoneCompute(points, mK, indexAxis);
}
function $97ecbd121be4860b$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $97ecbd121be4860b$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $97ecbd121be4860b$export$3d8c2f653ac9d0b9(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $97ecbd121be4860b$export$3d8c2f653ac9d0b9(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $97ecbd121be4860b$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $97ecbd121be4860b$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $97ecbd121be4860b$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $97ecbd121be4860b$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
function $97ecbd121be4860b$export$1a82df3d29112e01(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === "monotone") $97ecbd121be4860b$export$e171bab687b50e0(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $97ecbd121be4860b$export$1a8f5705751d8277(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $97ecbd121be4860b$var$capBezierPoints(points, area);
}
function $97ecbd121be4860b$export$2e2af4578d910ddf() {
    return typeof window !== "undefined" && typeof document !== "undefined";
}
function $97ecbd121be4860b$export$ce26c07117d59d6a(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === "[object ShadowRoot]") parent = parent.host;
    return parent;
}
function $97ecbd121be4860b$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === "string") {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf("%") !== -1) valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $97ecbd121be4860b$var$getComputedStyle = (element)=>window.getComputedStyle(element, null);
function $97ecbd121be4860b$export$527e9aa3390079e9(el, property) {
    return $97ecbd121be4860b$var$getComputedStyle(el).getPropertyValue(property);
}
const $97ecbd121be4860b$var$positions = [
    "top",
    "right",
    "bottom",
    "left"
];
function $97ecbd121be4860b$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? "-" + suffix : "";
    for(let i = 0; i < 4; i++){
        const pos = $97ecbd121be4860b$var$positions[i];
        result[pos] = parseFloat(styles[style + "-" + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $97ecbd121be4860b$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
function $97ecbd121be4860b$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($97ecbd121be4860b$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
function $97ecbd121be4860b$export$78acf4525d8a74c4(evt, chart) {
    if ("native" in evt) return evt;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $97ecbd121be4860b$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === "border-box";
    const paddings = $97ecbd121be4860b$var$getPositionedStyle(style, "padding");
    const borders = $97ecbd121be4860b$var$getPositionedStyle(style, "border", "width");
    const { x: x, y: y, box: box } = $97ecbd121be4860b$var$getCanvasPosition(evt, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $97ecbd121be4860b$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = $97ecbd121be4860b$export$ce26c07117d59d6a(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect();
            const containerStyle = $97ecbd121be4860b$var$getComputedStyle(container);
            const containerBorder = $97ecbd121be4860b$var$getPositionedStyle(containerStyle, "border", "width");
            const containerPadding = $97ecbd121be4860b$var$getPositionedStyle(containerStyle, "padding");
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $97ecbd121be4860b$var$parseMaxStyle(containerStyle.maxWidth, container, "clientWidth");
            maxHeight = $97ecbd121be4860b$var$parseMaxStyle(containerStyle.maxHeight, container, "clientHeight");
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $97ecbd121be4860b$export$d29e374196577086,
        maxHeight: maxHeight || $97ecbd121be4860b$export$d29e374196577086
    };
}
const $97ecbd121be4860b$var$round1 = (v)=>Math.round(v * 10) / 10;
function $97ecbd121be4860b$export$3c2fa207a37baaea(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $97ecbd121be4860b$var$getComputedStyle(canvas);
    const margins = $97ecbd121be4860b$var$getPositionedStyle(style, "margin");
    const maxWidth = $97ecbd121be4860b$var$parseMaxStyle(style.maxWidth, canvas, "clientWidth") || $97ecbd121be4860b$export$d29e374196577086;
    const maxHeight = $97ecbd121be4860b$var$parseMaxStyle(style.maxHeight, canvas, "clientHeight") || $97ecbd121be4860b$export$d29e374196577086;
    const containerSize = $97ecbd121be4860b$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === "content-box") {
        const borders = $97ecbd121be4860b$var$getPositionedStyle(style, "border", "width");
        const paddings = $97ecbd121be4860b$var$getPositionedStyle(style, "padding");
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height - margins.height);
    width = $97ecbd121be4860b$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $97ecbd121be4860b$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) height = $97ecbd121be4860b$var$round1(width / 2);
    return {
        width: width,
        height: height
    };
}
function $97ecbd121be4860b$export$c9170ad7d4cd7e57(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = deviceHeight / pixelRatio;
    chart.width = deviceWidth / pixelRatio;
    const canvas = chart.canvas;
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
const $97ecbd121be4860b$export$a8550f7dbe79f93a = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        window.addEventListener("test", null, options);
        window.removeEventListener("test", null, options);
    } catch (e) {}
    return passiveSupported;
}();
function $97ecbd121be4860b$export$6559d589eb85fbb6(element, property) {
    const value = $97ecbd121be4860b$export$527e9aa3390079e9(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
function $97ecbd121be4860b$export$d24c54395ce0c509(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
function $97ecbd121be4860b$export$2f6ca3d3b1f80bf5(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === "middle" ? t < 0.5 ? p1.y : p2.y : mode === "after" ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
function $97ecbd121be4860b$export$8a5498727ef6be21(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $97ecbd121be4860b$export$d24c54395ce0c509(p1, cp1, t);
    const b = $97ecbd121be4860b$export$d24c54395ce0c509(cp1, cp2, t);
    const c = $97ecbd121be4860b$export$d24c54395ce0c509(cp2, p2, t);
    const d = $97ecbd121be4860b$export$d24c54395ce0c509(a, b, t);
    const e = $97ecbd121be4860b$export$d24c54395ce0c509(b, c, t);
    return $97ecbd121be4860b$export$d24c54395ce0c509(d, e, t);
}
const $97ecbd121be4860b$var$intlCache = new Map();
function $97ecbd121be4860b$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $97ecbd121be4860b$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $97ecbd121be4860b$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $97ecbd121be4860b$export$ae1af26003f05816(num, locale, options) {
    return $97ecbd121be4860b$var$getNumberFormat(locale, options).format(num);
}
const $97ecbd121be4860b$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === "center") return align;
            return align === "right" ? "left" : "right";
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $97ecbd121be4860b$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $97ecbd121be4860b$export$91c6e00c14e7e6fd(rtl, rectX, width) {
    return rtl ? $97ecbd121be4860b$var$getRightToLeftAdapter(rectX, width) : $97ecbd121be4860b$var$getLeftToRightAdapter();
}
function $97ecbd121be4860b$export$9d398bebfec1c039(ctx, direction) {
    let style, original;
    if (direction === "ltr" || direction === "rtl") {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue("direction"),
            style.getPropertyPriority("direction")
        ];
        style.setProperty("direction", direction, "important");
        ctx.prevTextDirection = original;
    }
}
function $97ecbd121be4860b$export$24baa2b76016ce0e(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty("direction", original[0], original[1]);
    }
}
function $97ecbd121be4860b$var$propertyFn(property) {
    if (property === "angle") return {
        between: $97ecbd121be4860b$export$ffb5f4729a158638,
        compare: $97ecbd121be4860b$export$7a0bdf7d4a91ea88,
        normalize: $97ecbd121be4860b$export$3d12bd131bb975d1
    };
    return {
        between: $97ecbd121be4860b$export$21579262ef46735b,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $97ecbd121be4860b$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $97ecbd121be4860b$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $97ecbd121be4860b$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $97ecbd121be4860b$export$28f7fcd39efa255(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $97ecbd121be4860b$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $97ecbd121be4860b$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($97ecbd121be4860b$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($97ecbd121be4860b$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $97ecbd121be4860b$export$7a38258bbe170828(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $97ecbd121be4860b$export$28f7fcd39efa255(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $97ecbd121be4860b$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $97ecbd121be4860b$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $97ecbd121be4860b$export$306ddfe3a8403e2(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $97ecbd121be4860b$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $97ecbd121be4860b$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $97ecbd121be4860b$var$splitByStyles(line, $97ecbd121be4860b$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $97ecbd121be4860b$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $97ecbd121be4860b$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $97ecbd121be4860b$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $97ecbd121be4860b$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $97ecbd121be4860b$var$readStyle(segmentOptions.setContext($97ecbd121be4860b$export$dda1d9f60106f0e9(chartContext, {
                type: "segment",
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($97ecbd121be4860b$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $97ecbd121be4860b$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $97ecbd121be4860b$var$styleChanged(style, prevStyle) {
    return prevStyle && JSON.stringify(style) !== JSON.stringify(prevStyle);
}

});



parcelRegister("4Uh7a", function(module, exports) {

$parcel$export(module.exports, "default", () => $3929aafb948ac62c$export$2e2bcd8739ae039);

var $h1Xpf = parcelRequire("h1Xpf");

"use client";
var $3929aafb948ac62c$export$2e2bcd8739ae039 = (0, $h1Xpf.default);

});
parcelRegister("h1Xpf", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6609c7ee777e096$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $1pcHX = parcelRequire("1pcHX");

var $85dLH = parcelRequire("85dLH");


var $4NqjK = parcelRequire("4NqjK");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $9f1hj = parcelRequire("9f1hj");

var $IFe7R = parcelRequire("IFe7R");

var $3gns8 = parcelRequire("3gns8");

var $d3HKf = parcelRequire("d3HKf");

var $bLQWM = parcelRequire("bLQWM");

var $2d3DV = parcelRequire("2d3DV");

var $a5WcK = parcelRequire("a5WcK");

var $5sLjr = parcelRequire("5sLjr");

var $ilFXF = parcelRequire("ilFXF");
"use client";
var $c6609c7ee777e096$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $c6609c7ee777e096$var$getLoadingConfig(loading) {
    if (typeof loading === "object" && loading) {
        let delay = loading === null || loading === void 0 ? void 0 : loading.delay;
        delay = !Number.isNaN(delay) && typeof delay === "number" ? delay : 0;
        return {
            loading: delay <= 0,
            delay: delay
        };
    }
    return {
        loading: !!loading,
        delay: 0
    };
}
const $c6609c7ee777e096$var$InternalButton = (props, ref)=>{
    var _a, _b;
    const { loading: loading = false, prefixCls: customizePrefixCls, type: type = "default", danger: danger, shape: shape = "default", size: customizeSize, styles: styles, disabled: customDisabled, className: className, rootClassName: rootClassName, children: children, icon: icon, ghost: ghost = false, block: block = false, htmlType: // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType = "button", classNames: customClassNames, style: customStyle = {} } = props, rest = $c6609c7ee777e096$var$__rest(props, [
        "loading",
        "prefixCls",
        "type",
        "danger",
        "shape",
        "size",
        "styles",
        "disabled",
        "className",
        "rootClassName",
        "children",
        "icon",
        "ghost",
        "block",
        "htmlType",
        "classNames",
        "style"
    ]);
    const { getPrefixCls: getPrefixCls, autoInsertSpaceInButton: autoInsertSpaceInButton, direction: direction, button: button } = (0, $acw62.useContext)((0, $dRTnM.ConfigContext));
    const prefixCls = getPrefixCls("btn", customizePrefixCls);
    const [wrapCSSVar, hashId] = (0, $5sLjr.default)(prefixCls);
    const disabled = (0, $acw62.useContext)((0, $9f1hj.default));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    const groupSize = (0, $acw62.useContext)((0, $d3HKf.GroupSizeContext));
    const loadingOrDelay = (0, $acw62.useMemo)(()=>$c6609c7ee777e096$var$getLoadingConfig(loading), [
        loading
    ]);
    const [innerLoading, setLoading] = (0, $acw62.useState)(loadingOrDelay.loading);
    const [hasTwoCNChar, setHasTwoCNChar] = (0, $acw62.useState)(false);
    const internalRef = /*#__PURE__*/ (0, $acw62.createRef)();
    const buttonRef = (0, $85dLH.composeRef)(ref, internalRef);
    const needInserted = (0, $acw62.Children).count(children) === 1 && !icon && !(0, $bLQWM.isUnBorderedButtonType)(type);
    (0, $acw62.useEffect)(()=>{
        let delayTimer = null;
        if (loadingOrDelay.delay > 0) delayTimer = setTimeout(()=>{
            delayTimer = null;
            setLoading(true);
        }, loadingOrDelay.delay);
        else setLoading(loadingOrDelay.loading);
        function cleanupTimer() {
            if (delayTimer) {
                clearTimeout(delayTimer);
                delayTimer = null;
            }
        }
        return cleanupTimer;
    }, [
        loadingOrDelay
    ]);
    (0, $acw62.useEffect)(()=>{
        // FIXME: for HOC usage like <FormatMessage />
        if (!buttonRef || !buttonRef.current || autoInsertSpaceInButton === false) return;
        const buttonText = buttonRef.current.textContent;
        if (needInserted && (0, $bLQWM.isTwoCNChar)(buttonText)) {
            if (!hasTwoCNChar) setHasTwoCNChar(true);
        } else if (hasTwoCNChar) setHasTwoCNChar(false);
    }, [
        buttonRef
    ]);
    const handleClick = (e)=>{
        const { onClick: onClick } = props;
        // FIXME: https://github.com/ant-design/ant-design/issues/30207
        if (innerLoading || mergedDisabled) {
            e.preventDefault();
            return;
        }
        onClick === null || onClick === void 0 || onClick(e);
    };
    const autoInsertSpace = autoInsertSpaceInButton !== false;
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $3gns8.useCompactItemContext)(prefixCls, direction);
    const sizeClassNameMap = {
        large: "lg",
        small: "sm",
        middle: undefined
    };
    const sizeFullName = (0, $IFe7R.default)((ctxSize)=>{
        var _a, _b;
        return (_b = (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : groupSize) !== null && _b !== void 0 ? _b : ctxSize;
    });
    const sizeCls = sizeFullName ? sizeClassNameMap[sizeFullName] || "" : "";
    const iconType = innerLoading ? "loading" : icon;
    const linkButtonRestProps = (0, $1pcHX.default)(rest, [
        "navigate"
    ]);
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, hashId, {
        [`${prefixCls}-${shape}`]: shape !== "default" && shape,
        [`${prefixCls}-${type}`]: type,
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-icon-only`]: !children && children !== 0 && !!iconType,
        [`${prefixCls}-background-ghost`]: ghost && !(0, $bLQWM.isUnBorderedButtonType)(type),
        [`${prefixCls}-loading`]: innerLoading,
        [`${prefixCls}-two-chinese-chars`]: hasTwoCNChar && autoInsertSpace && !innerLoading,
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-dangerous`]: !!danger,
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, compactItemClassnames, className, rootClassName, button === null || button === void 0 ? void 0 : button.className);
    const fullStyle = Object.assign(Object.assign({}, button === null || button === void 0 ? void 0 : button.style), customStyle);
    const iconClasses = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.icon, (_a = button === null || button === void 0 ? void 0 : button.classNames) === null || _a === void 0 ? void 0 : _a.icon);
    const iconStyle = Object.assign(Object.assign({}, (styles === null || styles === void 0 ? void 0 : styles.icon) || {}), ((_b = button === null || button === void 0 ? void 0 : button.styles) === null || _b === void 0 ? void 0 : _b.icon) || {});
    const iconNode = icon && !innerLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2d3DV.default), {
        prefixCls: prefixCls,
        className: iconClasses,
        style: iconStyle
    }, icon) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a5WcK.default), {
        existIcon: !!icon,
        prefixCls: prefixCls,
        loading: !!innerLoading
    });
    const kids = children || children === 0 ? (0, $bLQWM.spaceChildren)(children, needInserted && autoInsertSpace) : null;
    if (linkButtonRestProps.href !== undefined) return wrapCSSVar(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({}, linkButtonRestProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(classes, {
            [`${prefixCls}-disabled`]: mergedDisabled
        }),
        href: mergedDisabled ? undefined : linkButtonRestProps.href,
        style: fullStyle,
        onClick: handleClick,
        ref: buttonRef,
        tabIndex: mergedDisabled ? -1 : 0
    }), iconNode, kids));
    let buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({}, rest, {
        type: htmlType,
        className: classes,
        style: fullStyle,
        onClick: handleClick,
        disabled: mergedDisabled,
        ref: buttonRef
    }), iconNode, kids, compactItemClassnames && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ilFXF.default), {
        key: "compact",
        prefixCls: prefixCls
    }));
    if (!(0, $bLQWM.isUnBorderedButtonType)(type)) buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4NqjK.default), {
        component: "Button",
        disabled: !!innerLoading
    }, buttonNode);
    return wrapCSSVar(buttonNode);
};
const $c6609c7ee777e096$var$Button = /*#__PURE__*/ (0, $acw62.forwardRef)($c6609c7ee777e096$var$InternalButton);
$c6609c7ee777e096$var$Button.Group = (0, $d3HKf.default);
$c6609c7ee777e096$var$Button.__ANT_BUTTON = true;
var $c6609c7ee777e096$export$2e2bcd8739ae039 = $c6609c7ee777e096$var$Button;

});
parcelRegister("8g1PZ", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("1pcHX", function(module, exports) {

$parcel$export(module.exports, "default", () => $1061fbcb6f08086c$export$2e2bcd8739ae039);

var $d49SP = parcelRequire("d49SP");
function $1061fbcb6f08086c$export$2e2bcd8739ae039(obj, fields) {
    var clone = (0, $d49SP.default)({}, obj);
    if (Array.isArray(fields)) fields.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}

});
parcelRegister("d49SP", function(module, exports) {

$parcel$export(module.exports, "default", () => $983350b7b3960a26$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");
function $983350b7b3960a26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $983350b7b3960a26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $kSlfw.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $983350b7b3960a26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("kSlfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f329557dcab6d0bb$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $f329557dcab6d0bb$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $4ZreY.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});
parcelRegister("4ZreY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a21fd50cbcd11cf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $cXkjo = parcelRequire("cXkjo");
function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $cXkjo.default)(t, "string");
    return "symbol" == (0, $fSwVM.default)(i) ? i : String(i);
}

});
parcelRegister("fSwVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f57191916382d3$export$2e2bcd8739ae039);
function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}

});

parcelRegister("cXkjo", function(module, exports) {

$parcel$export(module.exports, "default", () => $96eac03571e01dbf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");
function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $fSwVM.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $fSwVM.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("85dLH", function(module, exports) {

$parcel$export(module.exports, "fillRef", () => $5e297877593af644$export$f17fd18fa51dcb5b);
$parcel$export(module.exports, "composeRef", () => $5e297877593af644$export$ab452c34e8e05029);
$parcel$export(module.exports, "useComposeRef", () => $5e297877593af644$export$1d1c999670a1285d);
$parcel$export(module.exports, "supportRef", () => $5e297877593af644$export$c1cec34af06bcf7);

var $fSwVM = parcelRequire("fSwVM");

var $acw62 = parcelRequire("acw62");

var $lwoRE = parcelRequire("lwoRE");

var $3Ysvw = parcelRequire("3Ysvw");
function $5e297877593af644$export$f17fd18fa51dcb5b(ref, node) {
    if (typeof ref === "function") ref(node);
    else if ((0, $fSwVM.default)(ref) === "object" && ref && "current" in ref) ref.current = node;
}
function $5e297877593af644$export$ab452c34e8e05029() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(function(ref) {
        return ref;
    });
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $5e297877593af644$export$f17fd18fa51dcb5b(ref, node);
        });
    };
}
function $5e297877593af644$export$1d1c999670a1285d() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $3Ysvw.default)(function() {
        return $5e297877593af644$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
}
function $5e297877593af644$export$c1cec34af06bcf7(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    var type = (0, $lwoRE.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === "function" && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render)) return false;
    // Class component
    if (typeof nodeOrComponent === "function" && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render)) return false;
    return true;
}
function $5e297877593af644$export$b51ae67c7882a242(node) {
    if (!/*#__PURE__*/ (0, $acw62.isValidElement)(node)) return false;
    if ((0, $lwoRE.isFragment)(node)) return false;
    return $5e297877593af644$export$c1cec34af06bcf7(node);
} /* eslint-enable */ 

});
parcelRegister("lwoRE", function(module, exports) {
"use strict";

module.exports = (parcelRequire("iH1gS"));

});

parcelRegister("3Ysvw", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e4d16a6147a082d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $2e4d16a6147a082d$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $acw62.useRef({});
    if (!("value" in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}

});


parcelRegister("4NqjK", function(module, exports) {

$parcel$export(module.exports, "default", () => $37e027257ee01609$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $85dLH = parcelRequire("85dLH");

var $7klNq = parcelRequire("7klNq");

var $acw62 = parcelRequire("acw62");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $4a1I5 = parcelRequire("4a1I5");

var $czdip = parcelRequire("czdip");

var $2OvCY = parcelRequire("2OvCY");
const $37e027257ee01609$var$Wave = (props)=>{
    const { children: children, disabled: disabled, component: component } = props;
    const { getPrefixCls: getPrefixCls } = (0, $acw62.useContext)((0, $dRTnM.ConfigContext));
    const containerRef = (0, $acw62.useRef)(null);
    // ============================== Style ===============================
    const prefixCls = getPrefixCls("wave");
    const [, hashId] = (0, $czdip.default)(prefixCls);
    // =============================== Wave ===============================
    const showWave = (0, $2OvCY.default)(containerRef, (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, hashId), component);
    // ============================== Effect ==============================
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const node = containerRef.current;
        if (!node || node.nodeType !== 1 || disabled) return;
        // Click handler
        const onClick = (e)=>{
            // Fix radio button click twice
            if (!(0, $7klNq.default)(e.target) || // No need wave
            !node.getAttribute || node.getAttribute("disabled") || node.disabled || node.className.includes("disabled") || node.className.includes("-leave")) return;
            showWave(e);
        };
        // Bind events
        node.addEventListener("click", onClick, true);
        return ()=>{
            node.removeEventListener("click", onClick, true);
        };
    }, [
        disabled
    ]);
    // ============================== Render ==============================
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(children)) return children !== null && children !== void 0 ? children : null;
    const ref = (0, $85dLH.supportRef)(children) ? (0, $85dLH.composeRef)(children.ref, containerRef) : containerRef;
    return (0, $4a1I5.cloneElement)(children, {
        ref: ref
    });
};
var $37e027257ee01609$export$2e2bcd8739ae039 = $37e027257ee01609$var$Wave;

});
parcelRegister("7klNq", function(module, exports) {

$parcel$export(module.exports, "default", () => $555b4eee2695f264$export$2e2bcd8739ae039);
var $555b4eee2695f264$export$2e2bcd8739ae039 = function(element) {
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            var _getBBox = element.getBBox(), width = _getBBox.width, height = _getBBox.height;
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            var _element$getBoundingC = element.getBoundingClientRect(), _width = _element$getBoundingC.width, _height = _element$getBoundingC.height;
            if (_width || _height) return true;
        }
    }
    return false;
};

});

parcelRegister("aT8OD", function(module, exports) {

$parcel$export(module.exports, "globalConfig", () => $7ed5e10e08c170f8$export$f9cd1e43211d8a4a);
$parcel$export(module.exports, "default", () => $7ed5e10e08c170f8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ConfigContext", () => (parcelRequire("dRTnM")).ConfigContext);

var $acw62 = parcelRequire("acw62");
parcelRequire("3i86m");
var $iPfci = parcelRequire("iPfci");

var $9f9mi = parcelRequire("9f9mi");

var $3Ysvw = parcelRequire("3Ysvw");

var $6vgkH = parcelRequire("6vgkH");

var $7SSa4 = parcelRequire("7SSa4");

var $kzLok = parcelRequire("kzLok");

var $aardd = parcelRequire("aardd");

var $9qIAY = parcelRequire("9qIAY");

var $h9Mt9 = parcelRequire("h9Mt9");

var $iqsy8 = parcelRequire("iqsy8");

var $fcQiF = parcelRequire("fcQiF");

var $dRTnM = parcelRequire("dRTnM");

var $jnSmR = parcelRequire("jnSmR");

var $9f1hj = parcelRequire("9f1hj");

var $2AhEK = parcelRequire("2AhEK");

var $dOZZ1 = parcelRequire("dOZZ1");

var $7tV7X = parcelRequire("7tV7X");

var $dMQNr = parcelRequire("dMQNr");

var $5kmdZ = parcelRequire("5kmdZ");

var $f3iOG = parcelRequire("f3iOG");
"use client";
"use client";
var $7ed5e10e08c170f8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/**
 * Since too many feedback using static method like `Modal.confirm` not getting theme, we record the
 * theme register info here to help developer get warning info.
 */ let $7ed5e10e08c170f8$var$existThemeConfig = false;
const $7ed5e10e08c170f8$export$7c4f6da0f9434a77 = /* istanbul ignore next */ null;
const $7ed5e10e08c170f8$export$e7f14a745e5c386a = [
    "getTargetContainer",
    "getPopupContainer",
    "rootPrefixCls",
    "getPrefixCls",
    "renderEmpty",
    "csp",
    "autoInsertSpaceInButton",
    "locale",
    "pageHeader"
];
// These props is used by `useContext` directly in sub component
const $7ed5e10e08c170f8$var$PASSED_PROPS = [
    "getTargetContainer",
    "getPopupContainer",
    "renderEmpty",
    "pageHeader",
    "input",
    "pagination",
    "form",
    "select",
    "button"
];
const $7ed5e10e08c170f8$export$e4ec87ea71f29b41 = "ant";
let $7ed5e10e08c170f8$var$globalPrefixCls;
let $7ed5e10e08c170f8$var$globalIconPrefixCls;
let $7ed5e10e08c170f8$var$globalTheme;
function $7ed5e10e08c170f8$var$getGlobalPrefixCls() {
    return $7ed5e10e08c170f8$var$globalPrefixCls || $7ed5e10e08c170f8$export$e4ec87ea71f29b41;
}
function $7ed5e10e08c170f8$var$getGlobalIconPrefixCls() {
    return $7ed5e10e08c170f8$var$globalIconPrefixCls || (0, $dRTnM.defaultIconPrefixCls);
}
function $7ed5e10e08c170f8$var$isLegacyTheme(theme) {
    return Object.keys(theme).some((key)=>key.endsWith("Color"));
}
const $7ed5e10e08c170f8$var$setGlobalConfig = (_ref)=>{
    let { prefixCls: prefixCls, iconPrefixCls: iconPrefixCls, theme: theme } = _ref;
    if (prefixCls !== undefined) $7ed5e10e08c170f8$var$globalPrefixCls = prefixCls;
    if (iconPrefixCls !== undefined) $7ed5e10e08c170f8$var$globalIconPrefixCls = iconPrefixCls;
    if (theme) {
        if ($7ed5e10e08c170f8$var$isLegacyTheme(theme)) (0, $jnSmR.registerTheme)($7ed5e10e08c170f8$var$getGlobalPrefixCls(), theme);
        else $7ed5e10e08c170f8$var$globalTheme = theme;
    }
};
const $7ed5e10e08c170f8$export$f9cd1e43211d8a4a = ()=>({
        getPrefixCls: (suffixCls, customizePrefixCls)=>{
            if (customizePrefixCls) return customizePrefixCls;
            return suffixCls ? `${$7ed5e10e08c170f8$var$getGlobalPrefixCls()}-${suffixCls}` : $7ed5e10e08c170f8$var$getGlobalPrefixCls();
        },
        getIconPrefixCls: $7ed5e10e08c170f8$var$getGlobalIconPrefixCls,
        getRootPrefixCls: ()=>{
            // If Global prefixCls provided, use this
            if ($7ed5e10e08c170f8$var$globalPrefixCls) return $7ed5e10e08c170f8$var$globalPrefixCls;
            // Fallback to default prefixCls
            return $7ed5e10e08c170f8$var$getGlobalPrefixCls();
        },
        getTheme: ()=>$7ed5e10e08c170f8$var$globalTheme
    });
const $7ed5e10e08c170f8$var$ProviderChildren = (props)=>{
    const { children: children, csp: customCsp, autoInsertSpaceInButton: autoInsertSpaceInButton, alert: alert, anchor: anchor, form: form, locale: locale, componentSize: componentSize, direction: direction, space: space, virtual: virtual, dropdownMatchSelectWidth: dropdownMatchSelectWidth, popupMatchSelectWidth: popupMatchSelectWidth, popupOverflow: popupOverflow, legacyLocale: legacyLocale, parentContext: parentContext, iconPrefixCls: customIconPrefixCls, theme: theme, componentDisabled: componentDisabled, segmented: segmented, statistic: statistic, spin: spin, calendar: calendar, carousel: carousel, cascader: cascader, collapse: collapse, typography: typography, checkbox: checkbox, descriptions: descriptions, divider: divider, drawer: drawer, skeleton: skeleton, steps: steps, image: image, layout: layout, list: list, mentions: mentions, modal: modal, progress: progress, result: result, slider: slider, breadcrumb: breadcrumb, menu: menu, pagination: pagination, input: input, empty: empty, badge: badge, radio: radio, rate: rate, switch: SWITCH, transfer: transfer, avatar: avatar, message: message, tag: tag, table: table, card: card, tabs: tabs, timeline: timeline, timePicker: timePicker, upload: upload, notification: notification, tree: tree, colorPicker: colorPicker, datePicker: datePicker, rangePicker: rangePicker, flex: flex, wave: wave, dropdown: dropdown, warning: warningConfig } = props;
    // =================================== Context ===================================
    const getPrefixCls = $acw62.useCallback((suffixCls, customizePrefixCls)=>{
        const { prefixCls: prefixCls } = props;
        if (customizePrefixCls) return customizePrefixCls;
        const mergedPrefixCls = prefixCls || parentContext.getPrefixCls("");
        return suffixCls ? `${mergedPrefixCls}-${suffixCls}` : mergedPrefixCls;
    }, [
        parentContext.getPrefixCls,
        props.prefixCls
    ]);
    const iconPrefixCls = customIconPrefixCls || parentContext.iconPrefixCls || (0, $dRTnM.defaultIconPrefixCls);
    const csp = customCsp || parentContext.csp;
    (0, $f3iOG.default)(iconPrefixCls, csp);
    const mergedTheme = (0, $dOZZ1.default)(theme, parentContext.theme);
    const baseConfig = {
        csp: csp,
        autoInsertSpaceInButton: autoInsertSpaceInButton,
        alert: alert,
        anchor: anchor,
        locale: locale || legacyLocale,
        direction: direction,
        space: space,
        virtual: virtual,
        popupMatchSelectWidth: popupMatchSelectWidth !== null && popupMatchSelectWidth !== void 0 ? popupMatchSelectWidth : dropdownMatchSelectWidth,
        popupOverflow: popupOverflow,
        getPrefixCls: getPrefixCls,
        iconPrefixCls: iconPrefixCls,
        theme: mergedTheme,
        segmented: segmented,
        statistic: statistic,
        spin: spin,
        calendar: calendar,
        carousel: carousel,
        cascader: cascader,
        collapse: collapse,
        typography: typography,
        checkbox: checkbox,
        descriptions: descriptions,
        divider: divider,
        drawer: drawer,
        skeleton: skeleton,
        steps: steps,
        image: image,
        input: input,
        layout: layout,
        list: list,
        mentions: mentions,
        modal: modal,
        progress: progress,
        result: result,
        slider: slider,
        breadcrumb: breadcrumb,
        menu: menu,
        pagination: pagination,
        empty: empty,
        badge: badge,
        radio: radio,
        rate: rate,
        switch: SWITCH,
        transfer: transfer,
        avatar: avatar,
        message: message,
        tag: tag,
        table: table,
        card: card,
        tabs: tabs,
        timeline: timeline,
        timePicker: timePicker,
        upload: upload,
        notification: notification,
        tree: tree,
        colorPicker: colorPicker,
        datePicker: datePicker,
        rangePicker: rangePicker,
        flex: flex,
        wave: wave,
        dropdown: dropdown,
        warning: warningConfig
    };
    const config = Object.assign({}, parentContext);
    Object.keys(baseConfig).forEach((key)=>{
        if (baseConfig[key] !== undefined) config[key] = baseConfig[key];
    });
    // Pass the props used by `useContext` directly with child component.
    // These props should merged into `config`.
    $7ed5e10e08c170f8$var$PASSED_PROPS.forEach((propName)=>{
        const propValue = props[propName];
        if (propValue) config[propName] = propValue;
    });
    // https://github.com/ant-design/ant-design/issues/27617
    const memoedConfig = (0, $3Ysvw.default)(()=>config, config, (prevConfig, currentConfig)=>{
        const prevKeys = Object.keys(prevConfig);
        const currentKeys = Object.keys(currentConfig);
        return prevKeys.length !== currentKeys.length || prevKeys.some((key)=>prevConfig[key] !== currentConfig[key]);
    });
    const memoIconContextValue = $acw62.useMemo(()=>({
            prefixCls: iconPrefixCls,
            csp: csp
        }), [
        iconPrefixCls,
        csp
    ]);
    let childNode = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $dMQNr.default), {
        dropdownMatchSelectWidth: dropdownMatchSelectWidth
    }), children);
    const validateMessages = $acw62.useMemo(()=>{
        var _a, _b, _c, _d;
        return (0, $6vgkH.merge)(((_a = (0, $h9Mt9.default).Form) === null || _a === void 0 ? void 0 : _a.defaultValidateMessages) || {}, ((_c = (_b = memoedConfig.locale) === null || _b === void 0 ? void 0 : _b.Form) === null || _c === void 0 ? void 0 : _c.defaultValidateMessages) || {}, ((_d = memoedConfig.form) === null || _d === void 0 ? void 0 : _d.validateMessages) || {}, (form === null || form === void 0 ? void 0 : form.validateMessages) || {});
    }, [
        memoedConfig,
        form === null || form === void 0 ? void 0 : form.validateMessages
    ]);
    if (Object.keys(validateMessages).length > 0) childNode = /*#__PURE__*/ $acw62.createElement((0, $kzLok.default).Provider, {
        value: validateMessages
    }, childNode);
    if (locale) childNode = /*#__PURE__*/ $acw62.createElement((0, $aardd.default), {
        locale: locale,
        _ANT_MARK__: (0, $aardd.ANT_MARK)
    }, childNode);
    if (iconPrefixCls || csp) childNode = /*#__PURE__*/ $acw62.createElement((0, $9f9mi.default).Provider, {
        value: memoIconContextValue
    }, childNode);
    if (componentSize) childNode = /*#__PURE__*/ $acw62.createElement((0, $5kmdZ.SizeContextProvider), {
        size: componentSize
    }, childNode);
    // =================================== Motion ===================================
    childNode = /*#__PURE__*/ $acw62.createElement((0, $7tV7X.default), null, childNode);
    // ================================ Dynamic theme ================================
    const memoTheme = $acw62.useMemo(()=>{
        const _a = mergedTheme || {}, { algorithm: algorithm, token: token, components: components, cssVar: cssVar } = _a, rest = $7ed5e10e08c170f8$var$__rest(_a, [
            "algorithm",
            "token",
            "components",
            "cssVar"
        ]);
        const themeObj = algorithm && (!Array.isArray(algorithm) || algorithm.length > 0) ? (0, $iPfci.default)(algorithm) : (0, $iqsy8.defaultTheme);
        const parsedComponents = {};
        Object.entries(components || {}).forEach((_ref2)=>{
            let [componentName, componentToken] = _ref2;
            const parsedToken = Object.assign({}, componentToken);
            if ("algorithm" in parsedToken) {
                if (parsedToken.algorithm === true) parsedToken.theme = themeObj;
                else if (Array.isArray(parsedToken.algorithm) || typeof parsedToken.algorithm === "function") parsedToken.theme = (0, $iPfci.default)(parsedToken.algorithm);
                delete parsedToken.algorithm;
            }
            parsedComponents[componentName] = parsedToken;
        });
        const mergedToken = Object.assign(Object.assign({}, (0, $fcQiF.default)), token);
        return Object.assign(Object.assign({}, rest), {
            theme: themeObj,
            token: mergedToken,
            components: parsedComponents,
            override: Object.assign({
                override: mergedToken
            }, parsedComponents),
            cssVar: cssVar
        });
    }, [
        mergedTheme
    ]);
    if (theme) childNode = /*#__PURE__*/ $acw62.createElement((0, $iqsy8.DesignTokenContext).Provider, {
        value: memoTheme
    }, childNode);
    // ================================== Warning ===================================
    if (memoedConfig.warning) childNode = /*#__PURE__*/ $acw62.createElement((0, $7SSa4.WarningContext).Provider, {
        value: memoedConfig.warning
    }, childNode);
    // =================================== Render ===================================
    if (componentDisabled !== undefined) childNode = /*#__PURE__*/ $acw62.createElement((0, $9f1hj.DisabledContextProvider), {
        disabled: componentDisabled
    }, childNode);
    return /*#__PURE__*/ $acw62.createElement((0, $dRTnM.ConfigContext).Provider, {
        value: memoedConfig
    }, childNode);
};
const $7ed5e10e08c170f8$var$ConfigProvider = (props)=>{
    const context = $acw62.useContext((0, $dRTnM.ConfigContext));
    const antLocale = $acw62.useContext((0, $9qIAY.default));
    return /*#__PURE__*/ $acw62.createElement($7ed5e10e08c170f8$var$ProviderChildren, Object.assign({
        parentContext: context,
        legacyLocale: antLocale
    }, props));
};
$7ed5e10e08c170f8$var$ConfigProvider.ConfigContext = (0, $dRTnM.ConfigContext);
$7ed5e10e08c170f8$var$ConfigProvider.SizeContext = (0, $5kmdZ.default);
$7ed5e10e08c170f8$var$ConfigProvider.config = $7ed5e10e08c170f8$var$setGlobalConfig;
$7ed5e10e08c170f8$var$ConfigProvider.useConfig = (0, $2AhEK.default);
Object.defineProperty($7ed5e10e08c170f8$var$ConfigProvider, "SizeContext", {
    get: ()=>{
        return 0, $5kmdZ.default;
    }
});
var $7ed5e10e08c170f8$export$2e2bcd8739ae039 = $7ed5e10e08c170f8$var$ConfigProvider;

});
parcelRegister("3i86m", function(module, exports) {

$parcel$export(module.exports, "createTheme", () => (parcelRequire("iPfci")).default);
$parcel$export(module.exports, "useStyleRegister", () => (parcelRequire("aoTVg")).default);
$parcel$export(module.exports, "useCSSVarRegister", () => (parcelRequire("684jW")).default);
$parcel$export(module.exports, "useCacheToken", () => (parcelRequire("ly9Vc")).default);
$parcel$export(module.exports, "Keyframes", () => (parcelRequire("hsEk2")).default);
$parcel$export(module.exports, "getComputedToken", () => (parcelRequire("ly9Vc")).getComputedToken);
$parcel$export(module.exports, "token2CSSVar", () => (parcelRequire("7KFFu")).token2CSSVar);
$parcel$export(module.exports, "unit", () => (parcelRequire("lpQ06")).unit);

var $12qFo = parcelRequire("12qFo");

var $ly9Vc = parcelRequire("ly9Vc");

var $684jW = parcelRequire("684jW");

var $aoTVg = parcelRequire("aoTVg");

var $hsEk2 = parcelRequire("hsEk2");
parcelRequire("yUL79");
var $jcTSE = parcelRequire("jcTSE");
var $1iOYs = parcelRequire("1iOYs");
var $9L1eX = parcelRequire("9L1eX");
var $hjBd1 = parcelRequire("hjBd1");

var $24Ei6 = parcelRequire("24Ei6");
parcelRequire("c4pBP");
var $iPfci = parcelRequire("iPfci");

var $hfjpM = parcelRequire("hfjpM");

var $5h4kx = parcelRequire("5h4kx");

var $lpQ06 = parcelRequire("lpQ06");

var $7KFFu = parcelRequire("7KFFu");
var $26595656c8972ad7$export$73abaea5066f503b = {
    supportModernCSS: function supportModernCSS() {
        return (0, $lpQ06.supportWhere)() && (0, $lpQ06.supportLogicProps)();
    }
};

});
parcelRegister("12qFo", function(module, exports) {

var $eUqlC = parcelRequire("eUqlC");

var $kSlfw = parcelRequire("kSlfw");

var $ly9Vc = parcelRequire("ly9Vc");

var $684jW = parcelRequire("684jW");

var $aoTVg = parcelRequire("aoTVg");

var $lpQ06 = parcelRequire("lpQ06");

var $79KwC = parcelRequire("79KwC");
var $0c1aa9cd61c22229$var$_ExtractStyleFns;
var $0c1aa9cd61c22229$var$ExtractStyleFns = ($0c1aa9cd61c22229$var$_ExtractStyleFns = {}, (0, $kSlfw.default)($0c1aa9cd61c22229$var$_ExtractStyleFns, (0, $aoTVg.STYLE_PREFIX), (0, $aoTVg.extract)), (0, $kSlfw.default)($0c1aa9cd61c22229$var$_ExtractStyleFns, (0, $ly9Vc.TOKEN_PREFIX), (0, $ly9Vc.extract)), (0, $kSlfw.default)($0c1aa9cd61c22229$var$_ExtractStyleFns, (0, $684jW.CSS_VAR_PREFIX), (0, $684jW.extract)), $0c1aa9cd61c22229$var$_ExtractStyleFns);
function $0c1aa9cd61c22229$var$isNotNull(value) {
    return value !== null;
}
function $0c1aa9cd61c22229$export$2e2bcd8739ae039(cache) {
    var plain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var matchPrefixRegexp = new RegExp("^(".concat(Object.keys($0c1aa9cd61c22229$var$ExtractStyleFns).join("|"), ")%"));
    // prefix with `style` is used for `useStyleRegister` to cache style context
    var styleKeys = Array.from(cache.cache.keys()).filter(function(key) {
        return matchPrefixRegexp.test(key);
    });
    // Common effect styles like animation
    var effectStyles = {};
    // Mapping of cachePath to style hash
    var cachePathMap = {};
    var styleText = "";
    styleKeys.map(function(key) {
        var cachePath = key.replace(matchPrefixRegexp, "").replace(/%/g, "|");
        var _key$split = key.split("%"), _key$split2 = (0, $eUqlC.default)(_key$split, 1), prefix = _key$split2[0];
        var extractFn = $0c1aa9cd61c22229$var$ExtractStyleFns[prefix];
        var extractedStyle = extractFn(cache.cache.get(key)[1], effectStyles, {
            plain: plain
        });
        if (!extractedStyle) return null;
        var _extractedStyle = (0, $eUqlC.default)(extractedStyle, 3), order = _extractedStyle[0], styleId = _extractedStyle[1], styleStr = _extractedStyle[2];
        if (key.startsWith("style")) cachePathMap[cachePath] = styleId;
        return [
            order,
            styleStr
        ];
    }).filter($0c1aa9cd61c22229$var$isNotNull).sort(function(_ref, _ref2) {
        var _ref3 = (0, $eUqlC.default)(_ref, 1), o1 = _ref3[0];
        var _ref4 = (0, $eUqlC.default)(_ref2, 1), o2 = _ref4[0];
        return o1 - o2;
    }).forEach(function(_ref5) {
        var _ref6 = (0, $eUqlC.default)(_ref5, 2), style = _ref6[1];
        styleText += style;
    });
    // ==================== Fill Cache Path ====================
    styleText += (0, $lpQ06.toStyleStr)(".".concat((0, $79KwC.ATTR_CACHE_MAP), '{content:"').concat((0, $79KwC.serialize)(cachePathMap), '";}'), undefined, undefined, (0, $kSlfw.default)({}, (0, $79KwC.ATTR_CACHE_MAP), (0, $79KwC.ATTR_CACHE_MAP)), plain);
    return styleText;
}

});
parcelRegister("eUqlC", function(module, exports) {

$parcel$export(module.exports, "default", () => $adaabbc18727b3e6$export$2e2bcd8739ae039);

var $1uEeT = parcelRequire("1uEeT");

var $guSBA = parcelRequire("guSBA");

var $abLc2 = parcelRequire("abLc2");

var $782Uh = parcelRequire("782Uh");
function $adaabbc18727b3e6$export$2e2bcd8739ae039(arr, i) {
    return (0, $1uEeT.default)(arr) || (0, $guSBA.default)(arr, i) || (0, $abLc2.default)(arr, i) || (0, $782Uh.default)();
}

});
parcelRegister("1uEeT", function(module, exports) {

$parcel$export(module.exports, "default", () => $1167ce760980f343$export$2e2bcd8739ae039);
function $1167ce760980f343$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("guSBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c029ce1ef065e371$export$2e2bcd8739ae039);
function $c029ce1ef065e371$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("abLc2", function(module, exports) {

$parcel$export(module.exports, "default", () => $76af8a05551d5f25$export$2e2bcd8739ae039);

var $7K8zV = parcelRequire("7K8zV");
function $76af8a05551d5f25$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $7K8zV.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $7K8zV.default)(o, minLen);
}

});
parcelRegister("7K8zV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a337bca9556bfe7$export$2e2bcd8739ae039);
function $5a337bca9556bfe7$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("782Uh", function(module, exports) {

$parcel$export(module.exports, "default", () => $530b88ff20858fe6$export$2e2bcd8739ae039);
function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("ly9Vc", function(module, exports) {

$parcel$export(module.exports, "getComputedToken", () => $fb047830d7776fb2$export$18602cb46ae80b62);
$parcel$export(module.exports, "TOKEN_PREFIX", () => $fb047830d7776fb2$export$270fba097347f4fa);
$parcel$export(module.exports, "default", () => $fb047830d7776fb2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extract", () => $fb047830d7776fb2$export$f9380c9a627682d3);

var $eUqlC = parcelRequire("eUqlC");

var $kbxxf = parcelRequire("kbxxf");

var $d49SP = parcelRequire("d49SP");

var $isNEn = parcelRequire("isNEn");

var $4ZrBP = parcelRequire("4ZrBP");

var $acw62 = parcelRequire("acw62");

var $24Ei6 = parcelRequire("24Ei6");

var $lpQ06 = parcelRequire("lpQ06");

var $7KFFu = parcelRequire("7KFFu");

var $7YTbd = parcelRequire("7YTbd");
var $fb047830d7776fb2$var$EMPTY_OVERRIDE = {};
// Generate different prefix to make user selector break in production env.
// This helps developer not to do style override directly on the hash id.
var $fb047830d7776fb2$var$hashPrefix = "css";
var $fb047830d7776fb2$var$tokenKeys = new Map();
function $fb047830d7776fb2$var$recordCleanToken(tokenKey) {
    $fb047830d7776fb2$var$tokenKeys.set(tokenKey, ($fb047830d7776fb2$var$tokenKeys.get(tokenKey) || 0) + 1);
}
function $fb047830d7776fb2$var$removeStyleTags(key, instanceId) {
    if (typeof document !== "undefined") {
        var styles = document.querySelectorAll("style[".concat((0, $24Ei6.ATTR_TOKEN), '="').concat(key, '"]'));
        styles.forEach(function(style) {
            if (style[0, $24Ei6.CSS_IN_JS_INSTANCE] === instanceId) {
                var _style$parentNode;
                (_style$parentNode = style.parentNode) === null || _style$parentNode === void 0 || _style$parentNode.removeChild(style);
            }
        });
    }
}
var $fb047830d7776fb2$var$TOKEN_THRESHOLD = 0;
// Remove will check current keys first
function $fb047830d7776fb2$var$cleanTokenStyle(tokenKey, instanceId) {
    $fb047830d7776fb2$var$tokenKeys.set(tokenKey, ($fb047830d7776fb2$var$tokenKeys.get(tokenKey) || 0) - 1);
    var tokenKeyList = Array.from($fb047830d7776fb2$var$tokenKeys.keys());
    var cleanableKeyList = tokenKeyList.filter(function(key) {
        var count = $fb047830d7776fb2$var$tokenKeys.get(key) || 0;
        return count <= 0;
    });
    // Should keep tokens under threshold for not to insert style too often
    if (tokenKeyList.length - cleanableKeyList.length > $fb047830d7776fb2$var$TOKEN_THRESHOLD) cleanableKeyList.forEach(function(key) {
        $fb047830d7776fb2$var$removeStyleTags(key, instanceId);
        $fb047830d7776fb2$var$tokenKeys.delete(key);
    });
}
var $fb047830d7776fb2$export$18602cb46ae80b62 = function getComputedToken(originToken, overrideToken, theme, format) {
    var derivativeToken = theme.getDerivativeToken(originToken);
    // Merge with override
    var mergedDerivativeToken = (0, $d49SP.default)((0, $d49SP.default)({}, derivativeToken), overrideToken);
    // Format if needed
    if (format) mergedDerivativeToken = format(mergedDerivativeToken);
    return mergedDerivativeToken;
};
var $fb047830d7776fb2$export$270fba097347f4fa = "token";
function $fb047830d7776fb2$export$2e2bcd8739ae039(theme, tokens) {
    var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _useContext = (0, $acw62.useContext)((0, $24Ei6.default)), instanceId = _useContext.cache.instanceId, container = _useContext.container;
    var _option$salt = option.salt, salt = _option$salt === void 0 ? "" : _option$salt, _option$override = option.override, override = _option$override === void 0 ? $fb047830d7776fb2$var$EMPTY_OVERRIDE : _option$override, formatToken = option.formatToken, compute = option.getComputedToken, cssVar = option.cssVar;
    // Basic - We do basic cache here
    var mergedToken = (0, $lpQ06.memoResult)(function() {
        return Object.assign.apply(Object, [
            {}
        ].concat((0, $kbxxf.default)(tokens)));
    }, tokens);
    var tokenStr = (0, $lpQ06.flattenToken)(mergedToken);
    var overrideTokenStr = (0, $lpQ06.flattenToken)(override);
    var cssVarStr = cssVar ? (0, $lpQ06.flattenToken)(cssVar) : "";
    var cachedToken = (0, $7YTbd.default)($fb047830d7776fb2$export$270fba097347f4fa, [
        salt,
        theme.id,
        tokenStr,
        overrideTokenStr,
        cssVarStr
    ], function() {
        var _cssVar$key;
        var mergedDerivativeToken = compute ? compute(mergedToken, override, theme) : $fb047830d7776fb2$export$18602cb46ae80b62(mergedToken, override, theme, formatToken);
        // Replace token value with css variables
        var actualToken = (0, $d49SP.default)({}, mergedDerivativeToken);
        var cssVarsStr = "";
        if (!!cssVar) {
            var _transformToken = (0, $7KFFu.transformToken)(mergedDerivativeToken, cssVar.key, {
                prefix: cssVar.prefix,
                ignore: cssVar.ignore,
                unitless: cssVar.unitless,
                preserve: cssVar.preserve
            });
            var _transformToken2 = (0, $eUqlC.default)(_transformToken, 2);
            mergedDerivativeToken = _transformToken2[0];
            cssVarsStr = _transformToken2[1];
        }
        // Optimize for `useStyleRegister` performance
        var tokenKey = (0, $lpQ06.token2key)(mergedDerivativeToken, salt);
        mergedDerivativeToken._tokenKey = tokenKey;
        actualToken._tokenKey = (0, $lpQ06.token2key)(actualToken, salt);
        var themeKey = (_cssVar$key = cssVar === null || cssVar === void 0 ? void 0 : cssVar.key) !== null && _cssVar$key !== void 0 ? _cssVar$key : tokenKey;
        mergedDerivativeToken._themeKey = themeKey;
        $fb047830d7776fb2$var$recordCleanToken(themeKey);
        var hashId = "".concat($fb047830d7776fb2$var$hashPrefix, "-").concat((0, $isNEn.default)(tokenKey));
        mergedDerivativeToken._hashId = hashId; // Not used
        return [
            mergedDerivativeToken,
            hashId,
            actualToken,
            cssVarsStr,
            (cssVar === null || cssVar === void 0 ? void 0 : cssVar.key) || ""
        ];
    }, function(cache) {
        // Remove token will remove all related style
        $fb047830d7776fb2$var$cleanTokenStyle(cache[0]._themeKey, instanceId);
    }, function(_ref) {
        var _ref2 = (0, $eUqlC.default)(_ref, 4), token = _ref2[0], cssVarsStr = _ref2[3];
        if (cssVar && cssVarsStr) {
            var style = (0, $4ZrBP.updateCSS)(cssVarsStr, (0, $isNEn.default)("css-variables-".concat(token._themeKey)), {
                mark: (0, $24Ei6.ATTR_MARK),
                prepend: "queue",
                attachTo: container,
                priority: -999
            });
            style[0, $24Ei6.CSS_IN_JS_INSTANCE] = instanceId;
            // Used for `useCacheToken` to remove on batch when token removed
            style.setAttribute((0, $24Ei6.ATTR_TOKEN), token._themeKey);
        }
    });
    return cachedToken;
}
var $fb047830d7776fb2$export$f9380c9a627682d3 = function extract(cache, effectStyles, options) {
    var _cache = (0, $eUqlC.default)(cache, 5), realToken = _cache[2], styleStr = _cache[3], cssVarKey = _cache[4];
    var _ref3 = options || {}, plain = _ref3.plain;
    if (!styleStr) return null;
    var styleId = realToken._tokenKey;
    var order = -999;
    // ====================== Style ======================
    // Used for rc-util
    var sharedAttrs = {
        "data-rc-order": "prependQueue",
        "data-rc-priority": "".concat(order)
    };
    var styleText = (0, $lpQ06.toStyleStr)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};

});
parcelRegister("kbxxf", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb1ed927433e7e98$export$2e2bcd8739ae039);

var $cN7Ua = parcelRequire("cN7Ua");

var $dOjF6 = parcelRequire("dOjF6");

var $abLc2 = parcelRequire("abLc2");

var $fB5Ly = parcelRequire("fB5Ly");
function $eb1ed927433e7e98$export$2e2bcd8739ae039(arr) {
    return (0, $cN7Ua.default)(arr) || (0, $dOjF6.default)(arr) || (0, $abLc2.default)(arr) || (0, $fB5Ly.default)();
}

});
parcelRegister("cN7Ua", function(module, exports) {

$parcel$export(module.exports, "default", () => $95003165623aa54c$export$2e2bcd8739ae039);

var $7K8zV = parcelRequire("7K8zV");
function $95003165623aa54c$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $7K8zV.default)(arr);
}

});

parcelRegister("dOjF6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0df324e6f81ee90$export$2e2bcd8739ae039);
function $a0df324e6f81ee90$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("fB5Ly", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5aec8b8da7ac2f2$export$2e2bcd8739ae039);
function $b5aec8b8da7ac2f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("isNEn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7115b05d769e639$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $d7115b05d769e639$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $d7115b05d769e639$export$2e2bcd8739ae039 = $d7115b05d769e639$var$murmur2;

});

parcelRegister("4ZrBP", function(module, exports) {

$parcel$export(module.exports, "removeCSS", () => $3a22468320d7d808$export$2232e336aecaa80a);
$parcel$export(module.exports, "updateCSS", () => $3a22468320d7d808$export$4d99a2890bb989f0);

var $h4v51 = parcelRequire("h4v51");

var $d1wDM = parcelRequire("d1wDM");
var $3a22468320d7d808$var$APPEND_ORDER = "data-rc-order";
var $3a22468320d7d808$var$APPEND_PRIORITY = "data-rc-priority";
var $3a22468320d7d808$var$MARK_KEY = "rc-util-key";
var $3a22468320d7d808$var$containerCache = new Map();
function $3a22468320d7d808$var$getMark() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, mark = _ref.mark;
    if (mark) return mark.startsWith("data-") ? mark : "data-".concat(mark);
    return $3a22468320d7d808$var$MARK_KEY;
}
function $3a22468320d7d808$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    var head = document.querySelector("head");
    return head || document.body;
}
function $3a22468320d7d808$var$getOrder(prepend) {
    if (prepend === "queue") return "prependQueue";
    return prepend ? "prepend" : "append";
}
/**
 * Find style which inject by rc-util
 */ function $3a22468320d7d808$var$findStyles(container) {
    return Array.from(($3a22468320d7d808$var$containerCache.get(container) || container).children).filter(function(node) {
        return node.tagName === "STYLE";
    });
}
function $3a22468320d7d808$export$1ab5838465dbd10a(css) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!(0, $h4v51.default)()) return null;
    var csp = option.csp, prepend = option.prepend, _option$priority = option.priority, priority = _option$priority === void 0 ? 0 : _option$priority;
    var mergedOrder = $3a22468320d7d808$var$getOrder(prepend);
    var isPrependQueue = mergedOrder === "prependQueue";
    var styleNode = document.createElement("style");
    styleNode.setAttribute($3a22468320d7d808$var$APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute($3a22468320d7d808$var$APPEND_PRIORITY, "".concat(priority));
    if (csp !== null && csp !== void 0 && csp.nonce) styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
    styleNode.innerHTML = css;
    var container = $3a22468320d7d808$var$getContainer(option);
    var firstChild = container.firstChild;
    if (prepend) {
        // If is queue `prepend`, it will prepend first style and then append rest style
        if (isPrependQueue) {
            var existStyle = $3a22468320d7d808$var$findStyles(container).filter(function(node) {
                // Ignore style which not injected by rc-util with prepend
                if (![
                    "prepend",
                    "prependQueue"
                ].includes(node.getAttribute($3a22468320d7d808$var$APPEND_ORDER))) return false;
                // Ignore style which priority less then new style
                var nodePriority = Number(node.getAttribute($3a22468320d7d808$var$APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        // Use `insertBefore` as `prepend`
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $3a22468320d7d808$var$findExistNode(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var container = $3a22468320d7d808$var$getContainer(option);
    return $3a22468320d7d808$var$findStyles(container).find(function(node) {
        return node.getAttribute($3a22468320d7d808$var$getMark(option)) === key;
    });
}
function $3a22468320d7d808$export$2232e336aecaa80a(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var existNode = $3a22468320d7d808$var$findExistNode(key, option);
    if (existNode) {
        var container = $3a22468320d7d808$var$getContainer(option);
        container.removeChild(existNode);
    }
}
/**
 * qiankun will inject `appendChild` to insert into other
 */ function $3a22468320d7d808$var$syncRealContainer(container, option) {
    var cachedRealContainer = $3a22468320d7d808$var$containerCache.get(container);
    // Find real container when not cached or cached container removed
    if (!cachedRealContainer || !(0, $d1wDM.default)(document, cachedRealContainer)) {
        var placeholderStyle = $3a22468320d7d808$export$1ab5838465dbd10a("", option);
        var parentNode = placeholderStyle.parentNode;
        $3a22468320d7d808$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
function $3a22468320d7d808$export$f80df667f2f5a272() {
    $3a22468320d7d808$var$containerCache.clear();
}
function $3a22468320d7d808$export$4d99a2890bb989f0(css, key) {
    var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var container = $3a22468320d7d808$var$getContainer(option);
    // Sync real parent
    $3a22468320d7d808$var$syncRealContainer(container, option);
    var existNode = $3a22468320d7d808$var$findExistNode(key, option);
    if (existNode) {
        var _option$csp, _option$csp2;
        if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
            var _option$csp3;
            existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
        }
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    var newNode = $3a22468320d7d808$export$1ab5838465dbd10a(css, option);
    newNode.setAttribute($3a22468320d7d808$var$getMark(option), key);
    return newNode;
}

});
parcelRegister("h4v51", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6daeb3adc2b0e60$export$2e2bcd8739ae039);
function $c6daeb3adc2b0e60$export$2e2bcd8739ae039() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}

});

parcelRegister("d1wDM", function(module, exports) {

$parcel$export(module.exports, "default", () => $97b4b0194c593c05$export$2e2bcd8739ae039);
function $97b4b0194c593c05$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    var node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}

});


parcelRegister("24Ei6", function(module, exports) {

$parcel$export(module.exports, "ATTR_TOKEN", () => $182b356f02bf1b9b$export$5d99297dcd5476ac);
$parcel$export(module.exports, "ATTR_MARK", () => $182b356f02bf1b9b$export$89ce1123b3c0bd9e);
$parcel$export(module.exports, "CSS_IN_JS_INSTANCE", () => $182b356f02bf1b9b$export$4c16a0c02134a7dc);
$parcel$export(module.exports, "default", () => $182b356f02bf1b9b$export$2e2bcd8739ae039);

var $d49SP = parcelRequire("d49SP");

var $9X7IJ = parcelRequire("9X7IJ");

var $3Ysvw = parcelRequire("3Ysvw");

var $4AFGH = parcelRequire("4AFGH");

var $acw62 = parcelRequire("acw62");

var $9VkfB = parcelRequire("9VkfB");
var $182b356f02bf1b9b$var$_excluded = [
    "children"
];
var $182b356f02bf1b9b$export$5d99297dcd5476ac = "data-token-hash";
var $182b356f02bf1b9b$export$89ce1123b3c0bd9e = "data-css-hash";
var $182b356f02bf1b9b$export$36f8a6c9fa24262a = "data-cache-path";
var $182b356f02bf1b9b$export$4c16a0c02134a7dc = "__cssinjs_instance__";
function $182b356f02bf1b9b$export$cf6fa0bbcc94b912() {
    var cssinjsInstanceId = Math.random().toString(12).slice(2);
    // Tricky SSR: Move all inline style to the head.
    // PS: We do not recommend tricky mode.
    if (typeof document !== "undefined" && document.head && document.body) {
        var styles = document.body.querySelectorAll("style[".concat($182b356f02bf1b9b$export$89ce1123b3c0bd9e, "]")) || [];
        var firstChild = document.head.firstChild;
        Array.from(styles).forEach(function(style) {
            style[$182b356f02bf1b9b$export$4c16a0c02134a7dc] = style[$182b356f02bf1b9b$export$4c16a0c02134a7dc] || cssinjsInstanceId;
            // Not force move if no head
            if (style[$182b356f02bf1b9b$export$4c16a0c02134a7dc] === cssinjsInstanceId) document.head.insertBefore(style, firstChild);
        });
        // Deduplicate of moved styles
        var styleHash = {};
        Array.from(document.querySelectorAll("style[".concat($182b356f02bf1b9b$export$89ce1123b3c0bd9e, "]"))).forEach(function(style) {
            var hash = style.getAttribute($182b356f02bf1b9b$export$89ce1123b3c0bd9e);
            if (styleHash[hash]) {
                if (style[$182b356f02bf1b9b$export$4c16a0c02134a7dc] === cssinjsInstanceId) {
                    var _style$parentNode;
                    (_style$parentNode = style.parentNode) === null || _style$parentNode === void 0 || _style$parentNode.removeChild(style);
                }
            } else styleHash[hash] = true;
        });
    }
    return new (0, $9VkfB.default)(cssinjsInstanceId);
}
var $182b356f02bf1b9b$var$StyleContext = /*#__PURE__*/ $acw62.createContext({
    hashPriority: "low",
    cache: $182b356f02bf1b9b$export$cf6fa0bbcc94b912(),
    defaultCache: true
});
var $182b356f02bf1b9b$export$6aedb87c7b665270 = function StyleProvider(props) {
    var children = props.children, restProps = (0, $9X7IJ.default)(props, $182b356f02bf1b9b$var$_excluded);
    var parentContext = $acw62.useContext($182b356f02bf1b9b$var$StyleContext);
    var context = (0, $3Ysvw.default)(function() {
        var mergedContext = (0, $d49SP.default)({}, parentContext);
        Object.keys(restProps).forEach(function(key) {
            var value = restProps[key];
            if (restProps[key] !== undefined) mergedContext[key] = value;
        });
        var cache = restProps.cache;
        mergedContext.cache = mergedContext.cache || $182b356f02bf1b9b$export$cf6fa0bbcc94b912();
        mergedContext.defaultCache = !cache && parentContext.defaultCache;
        return mergedContext;
    }, [
        parentContext,
        restProps
    ], function(prev, next) {
        return !(0, $4AFGH.default)(prev[0], next[0], true) || !(0, $4AFGH.default)(prev[1], next[1], true);
    });
    return /*#__PURE__*/ $acw62.createElement($182b356f02bf1b9b$var$StyleContext.Provider, {
        value: context
    }, children);
};
var $182b356f02bf1b9b$export$2e2bcd8739ae039 = $182b356f02bf1b9b$var$StyleContext;

});
parcelRegister("9X7IJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $73ef9ce1c41fc0c0$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");
function $73ef9ce1c41fc0c0$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $1En50.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("4AFGH", function(module, exports) {

$parcel$export(module.exports, "default", () => $357adc8667cde522$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $u43uR = parcelRequire("u43uR");
/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $357adc8667cde522$var$isEqual(obj1, obj2) {
    var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    var refSet = new Set();
    function deepEqual(a, b) {
        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var circular = refSet.has(a);
        (0, $u43uR.default)(!circular, "Warning: There may be circular references");
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        var newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(var i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && (0, $fSwVM.default)(a) === "object" && (0, $fSwVM.default)(b) === "object") {
            var keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every(function(key) {
                return deepEqual(a[key], b[key], newLevel);
            });
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $357adc8667cde522$export$2e2bcd8739ae039 = $357adc8667cde522$var$isEqual;

});
parcelRegister("u43uR", function(module, exports) {

$parcel$export(module.exports, "warning", () => $05a5f2c645683a81$export$491112666e282270);
$parcel$export(module.exports, "resetWarned", () => $05a5f2c645683a81$export$60eef1277fe463e4);
$parcel$export(module.exports, "noteOnce", () => $05a5f2c645683a81$export$89ff31684837bbbf);
$parcel$export(module.exports, "default", () => $05a5f2c645683a81$export$2e2bcd8739ae039);
/* eslint-disable no-console */ var $05a5f2c645683a81$var$warned = {};
var $05a5f2c645683a81$var$preWarningFns = [];
var $05a5f2c645683a81$export$61616f168f0e5a05 = function preMessage(fn) {
    $05a5f2c645683a81$var$preWarningFns.push(fn);
};
function $05a5f2c645683a81$export$491112666e282270(valid, message) {
    var finalMessage;
}
function $05a5f2c645683a81$export$a92e4c44d367d0af(valid, message) {
    var finalMessage;
}
function $05a5f2c645683a81$export$60eef1277fe463e4() {
    $05a5f2c645683a81$var$warned = {};
}
function $05a5f2c645683a81$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$05a5f2c645683a81$var$warned[message]) {
        method(false, message);
        $05a5f2c645683a81$var$warned[message] = true;
    }
}
function $05a5f2c645683a81$export$82934adf09101657(valid, message) {
    $05a5f2c645683a81$export$848feb93d8f32b9b($05a5f2c645683a81$export$491112666e282270, valid, message);
}
function $05a5f2c645683a81$export$89ff31684837bbbf(valid, message) {
    $05a5f2c645683a81$export$848feb93d8f32b9b($05a5f2c645683a81$export$a92e4c44d367d0af, valid, message);
}
$05a5f2c645683a81$export$82934adf09101657.preMessage = $05a5f2c645683a81$export$61616f168f0e5a05;
$05a5f2c645683a81$export$82934adf09101657.resetWarned = $05a5f2c645683a81$export$60eef1277fe463e4;
$05a5f2c645683a81$export$82934adf09101657.noteOnce = $05a5f2c645683a81$export$89ff31684837bbbf;
var $05a5f2c645683a81$export$2e2bcd8739ae039 /* eslint-enable */  = $05a5f2c645683a81$export$82934adf09101657;

});


parcelRegister("9VkfB", function(module, exports) {

$parcel$export(module.exports, "default", () => $7399254758448c39$export$2e2bcd8739ae039);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $kSlfw = parcelRequire("kSlfw");
// [times, realValue]
var $7399254758448c39$var$SPLIT = "%";
var $7399254758448c39$var$Entity = /*#__PURE__*/ function() {
    function Entity(instanceId) {
        (0, $6CZeq.default)(this, Entity);
        (0, $kSlfw.default)(this, "instanceId", void 0);
        /** @private Internal cache map. Do not access this directly */ (0, $kSlfw.default)(this, "cache", new Map());
        this.instanceId = instanceId;
    }
    (0, $cHPF9.default)(Entity, [
        {
            key: "get",
            value: function get(keys) {
                return this.cache.get(keys.join($7399254758448c39$var$SPLIT)) || null;
            }
        },
        {
            key: "update",
            value: function update(keys, valueFn) {
                var path = keys.join($7399254758448c39$var$SPLIT);
                var prevValue = this.cache.get(path);
                var nextValue = valueFn(prevValue);
                if (nextValue === null) this.cache.delete(path);
                else this.cache.set(path, nextValue);
            }
        }
    ]);
    return Entity;
}();
var $7399254758448c39$export$2e2bcd8739ae039 = $7399254758448c39$var$Entity;

});
parcelRegister("6CZeq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d35ca0862055760$export$2e2bcd8739ae039);
function $4d35ca0862055760$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("cHPF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $94019358ecbcf36b$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $94019358ecbcf36b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $4ZreY.default)(descriptor.key), descriptor);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $94019358ecbcf36b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $94019358ecbcf36b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});



parcelRegister("lpQ06", function(module, exports) {

$parcel$export(module.exports, "memoResult", () => $f97444ff16d95e90$export$6aabcc1951563d93);
$parcel$export(module.exports, "flattenToken", () => $f97444ff16d95e90$export$597374558a261efc);
$parcel$export(module.exports, "token2key", () => $f97444ff16d95e90$export$6c82d0ebe8f2ea2c);
$parcel$export(module.exports, "supportLayer", () => $f97444ff16d95e90$export$ac8d3fd9840e20dd);
$parcel$export(module.exports, "supportWhere", () => $f97444ff16d95e90$export$f51d3b8ac4ac9ed1);
$parcel$export(module.exports, "supportLogicProps", () => $f97444ff16d95e90$export$64a912f57d5de48e);
$parcel$export(module.exports, "isClientSide", () => $f97444ff16d95e90$export$9542afab8c2a5f48);
$parcel$export(module.exports, "unit", () => $f97444ff16d95e90$export$523c0b569236b342);
$parcel$export(module.exports, "toStyleStr", () => $f97444ff16d95e90$export$71c98ec84f0481d3);

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $fSwVM = parcelRequire("fSwVM");

var $isNEn = parcelRequire("isNEn");

var $h4v51 = parcelRequire("h4v51");

var $4ZrBP = parcelRequire("4ZrBP");

var $24Ei6 = parcelRequire("24Ei6");
parcelRequire("c4pBP");
var $5ja8O = parcelRequire("5ja8O");
// Create a cache for memo concat
var $f97444ff16d95e90$var$resultCache = new WeakMap();
var $f97444ff16d95e90$var$RESULT_VALUE = {};
function $f97444ff16d95e90$export$6aabcc1951563d93(callback, deps) {
    var current = $f97444ff16d95e90$var$resultCache;
    for(var i = 0; i < deps.length; i += 1){
        var dep = deps[i];
        if (!current.has(dep)) current.set(dep, new WeakMap());
        current = current.get(dep);
    }
    if (!current.has($f97444ff16d95e90$var$RESULT_VALUE)) current.set($f97444ff16d95e90$var$RESULT_VALUE, callback());
    return current.get($f97444ff16d95e90$var$RESULT_VALUE);
}
// Create a cache here to avoid always loop generate
var $f97444ff16d95e90$var$flattenTokenCache = new WeakMap();
function $f97444ff16d95e90$export$597374558a261efc(token) {
    var str = $f97444ff16d95e90$var$flattenTokenCache.get(token) || "";
    if (!str) {
        Object.keys(token).forEach(function(key) {
            var value = token[key];
            str += key;
            if (value instanceof (0, $5ja8O.default)) str += value.id;
            else if (value && (0, $fSwVM.default)(value) === "object") str += $f97444ff16d95e90$export$597374558a261efc(value);
            else str += value;
        });
        // Put in cache
        $f97444ff16d95e90$var$flattenTokenCache.set(token, str);
    }
    return str;
}
function $f97444ff16d95e90$export$6c82d0ebe8f2ea2c(token, salt) {
    return (0, $isNEn.default)("".concat(salt, "_").concat($f97444ff16d95e90$export$597374558a261efc(token)));
}
var $f97444ff16d95e90$var$randomSelectorKey = "random-".concat(Date.now(), "-").concat(Math.random()).replace(/\./g, "");
// Magic `content` for detect selector support
var $f97444ff16d95e90$var$checkContent = "_bAmBoO_";
function $f97444ff16d95e90$var$supportSelector(styleStr, handleElement, supportCheck) {
    if ((0, $h4v51.default)()) {
        var _getComputedStyle$con, _ele$parentNode;
        (0, $4ZrBP.updateCSS)(styleStr, $f97444ff16d95e90$var$randomSelectorKey);
        var _ele = document.createElement("div");
        _ele.style.position = "fixed";
        _ele.style.left = "0";
        _ele.style.top = "0";
        handleElement === null || handleElement === void 0 || handleElement(_ele);
        document.body.appendChild(_ele);
        var support = supportCheck ? supportCheck(_ele) : (_getComputedStyle$con = getComputedStyle(_ele).content) === null || _getComputedStyle$con === void 0 ? void 0 : _getComputedStyle$con.includes($f97444ff16d95e90$var$checkContent);
        (_ele$parentNode = _ele.parentNode) === null || _ele$parentNode === void 0 || _ele$parentNode.removeChild(_ele);
        (0, $4ZrBP.removeCSS)($f97444ff16d95e90$var$randomSelectorKey);
        return support;
    }
    return false;
}
var $f97444ff16d95e90$var$canLayer = undefined;
function $f97444ff16d95e90$export$ac8d3fd9840e20dd() {
    if ($f97444ff16d95e90$var$canLayer === undefined) $f97444ff16d95e90$var$canLayer = $f97444ff16d95e90$var$supportSelector("@layer ".concat($f97444ff16d95e90$var$randomSelectorKey, " { .").concat($f97444ff16d95e90$var$randomSelectorKey, ' { content: "').concat($f97444ff16d95e90$var$checkContent, '"!important; } }'), function(ele) {
        ele.className = $f97444ff16d95e90$var$randomSelectorKey;
    });
    return $f97444ff16d95e90$var$canLayer;
}
var $f97444ff16d95e90$var$canWhere = undefined;
function $f97444ff16d95e90$export$f51d3b8ac4ac9ed1() {
    if ($f97444ff16d95e90$var$canWhere === undefined) $f97444ff16d95e90$var$canWhere = $f97444ff16d95e90$var$supportSelector(":where(.".concat($f97444ff16d95e90$var$randomSelectorKey, ') { content: "').concat($f97444ff16d95e90$var$checkContent, '"!important; }'), function(ele) {
        ele.className = $f97444ff16d95e90$var$randomSelectorKey;
    });
    return $f97444ff16d95e90$var$canWhere;
}
var $f97444ff16d95e90$var$canLogic = undefined;
function $f97444ff16d95e90$export$64a912f57d5de48e() {
    if ($f97444ff16d95e90$var$canLogic === undefined) $f97444ff16d95e90$var$canLogic = $f97444ff16d95e90$var$supportSelector(".".concat($f97444ff16d95e90$var$randomSelectorKey, " { inset-block: 93px !important; }"), function(ele) {
        ele.className = $f97444ff16d95e90$var$randomSelectorKey;
    }, function(ele) {
        return getComputedStyle(ele).bottom === "93px";
    });
    return $f97444ff16d95e90$var$canLogic;
}
var $f97444ff16d95e90$export$9542afab8c2a5f48 = (0, $h4v51.default)();
function $f97444ff16d95e90$export$523c0b569236b342(num) {
    if (typeof num === "number") return "".concat(num, "px");
    return num;
}
function $f97444ff16d95e90$export$71c98ec84f0481d3(style, tokenKey, styleId) {
    var _objectSpread2;
    var customizeAttrs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var plain = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    if (plain) return style;
    var attrs = (0, $d49SP.default)((0, $d49SP.default)({}, customizeAttrs), {}, (_objectSpread2 = {}, (0, $kSlfw.default)(_objectSpread2, (0, $24Ei6.ATTR_TOKEN), tokenKey), (0, $kSlfw.default)(_objectSpread2, (0, $24Ei6.ATTR_MARK), styleId), _objectSpread2));
    var attrStr = Object.keys(attrs).map(function(attr) {
        var val = attrs[attr];
        return val ? "".concat(attr, '="').concat(val, '"') : null;
    }).filter(function(v) {
        return v;
    }).join(" ");
    return "<style ".concat(attrStr, ">").concat(style, "</style>");
}

});
parcelRegister("c4pBP", function(module, exports) {

$parcel$export(module.exports, "createTheme", () => (parcelRequire("iPfci")).default);
$parcel$export(module.exports, "Theme", () => (parcelRequire("5ja8O")).default);

var $iPfci = parcelRequire("iPfci");

var $5ja8O = parcelRequire("5ja8O");

var $AKpyT = parcelRequire("AKpyT");

});
parcelRegister("iPfci", function(module, exports) {

$parcel$export(module.exports, "default", () => $db48c74b3367fd88$export$2e2bcd8739ae039);

var $AKpyT = parcelRequire("AKpyT");

var $5ja8O = parcelRequire("5ja8O");
var $db48c74b3367fd88$var$cacheThemes = new (0, $AKpyT.default)();
function $db48c74b3367fd88$export$2e2bcd8739ae039(derivatives) {
    var derivativeArr = Array.isArray(derivatives) ? derivatives : [
        derivatives
    ];
    // Create new theme if not exist
    if (!$db48c74b3367fd88$var$cacheThemes.has(derivativeArr)) $db48c74b3367fd88$var$cacheThemes.set(derivativeArr, new (0, $5ja8O.default)(derivativeArr));
    // Get theme from cache and return
    return $db48c74b3367fd88$var$cacheThemes.get(derivativeArr);
}

});
parcelRegister("AKpyT", function(module, exports) {

$parcel$export(module.exports, "default", () => $06e75d38ebf58c74$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $kSlfw = parcelRequire("kSlfw");
function $06e75d38ebf58c74$export$dd65e95e99ed0739(left, right) {
    if (left.length !== right.length) return false;
    for(var i = 0; i < left.length; i++){
        if (left[i] !== right[i]) return false;
    }
    return true;
}
var $06e75d38ebf58c74$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeCache() {
        (0, $6CZeq.default)(this, ThemeCache);
        (0, $kSlfw.default)(this, "cache", void 0);
        (0, $kSlfw.default)(this, "keys", void 0);
        (0, $kSlfw.default)(this, "cacheCallTimes", void 0);
        this.cache = new Map();
        this.keys = [];
        this.cacheCallTimes = 0;
    }
    (0, $cHPF9.default)(ThemeCache, [
        {
            key: "size",
            value: function size() {
                return this.keys.length;
            }
        },
        {
            key: "internalGet",
            value: function internalGet(derivativeOption) {
                var _cache2, _cache3;
                var updateCallTimes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var cache = {
                    map: this.cache
                };
                derivativeOption.forEach(function(derivative) {
                    if (!cache) cache = undefined;
                    else {
                        var _cache;
                        cache = (_cache = cache) === null || _cache === void 0 || (_cache = _cache.map) === null || _cache === void 0 ? void 0 : _cache.get(derivative);
                    }
                });
                if ((_cache2 = cache) !== null && _cache2 !== void 0 && _cache2.value && updateCallTimes) cache.value[1] = this.cacheCallTimes++;
                return (_cache3 = cache) === null || _cache3 === void 0 ? void 0 : _cache3.value;
            }
        },
        {
            key: "get",
            value: function get(derivativeOption) {
                var _this$internalGet;
                return (_this$internalGet = this.internalGet(derivativeOption, true)) === null || _this$internalGet === void 0 ? void 0 : _this$internalGet[0];
            }
        },
        {
            key: "has",
            value: function has(derivativeOption) {
                return !!this.internalGet(derivativeOption);
            }
        },
        {
            key: "set",
            value: function set(derivativeOption, value) {
                var _this = this;
                // New cache
                if (!this.has(derivativeOption)) {
                    if (this.size() + 1 > ThemeCache.MAX_CACHE_SIZE + ThemeCache.MAX_CACHE_OFFSET) {
                        var _this$keys$reduce = this.keys.reduce(function(result, key) {
                            var _result = (0, $eUqlC.default)(result, 2), callTimes = _result[1];
                            if (_this.internalGet(key)[1] < callTimes) return [
                                key,
                                _this.internalGet(key)[1]
                            ];
                            return result;
                        }, [
                            this.keys[0],
                            this.cacheCallTimes
                        ]), _this$keys$reduce2 = (0, $eUqlC.default)(_this$keys$reduce, 1), targetKey = _this$keys$reduce2[0];
                        this.delete(targetKey);
                    }
                    this.keys.push(derivativeOption);
                }
                var cache = this.cache;
                derivativeOption.forEach(function(derivative, index) {
                    if (index === derivativeOption.length - 1) cache.set(derivative, {
                        value: [
                            value,
                            _this.cacheCallTimes++
                        ]
                    });
                    else {
                        var cacheValue = cache.get(derivative);
                        if (!cacheValue) cache.set(derivative, {
                            map: new Map()
                        });
                        else if (!cacheValue.map) cacheValue.map = new Map();
                        cache = cache.get(derivative).map;
                    }
                });
            }
        },
        {
            key: "deleteByPath",
            value: function deleteByPath(currentCache, derivatives) {
                var cache = currentCache.get(derivatives[0]);
                if (derivatives.length === 1) {
                    var _cache$value;
                    if (!cache.map) currentCache.delete(derivatives[0]);
                    else currentCache.set(derivatives[0], {
                        map: cache.map
                    });
                    return (_cache$value = cache.value) === null || _cache$value === void 0 ? void 0 : _cache$value[0];
                }
                var result = this.deleteByPath(cache.map, derivatives.slice(1));
                if ((!cache.map || cache.map.size === 0) && !cache.value) currentCache.delete(derivatives[0]);
                return result;
            }
        },
        {
            key: "delete",
            value: function _delete(derivativeOption) {
                // If cache exists
                if (this.has(derivativeOption)) {
                    this.keys = this.keys.filter(function(item) {
                        return !$06e75d38ebf58c74$export$dd65e95e99ed0739(item, derivativeOption);
                    });
                    return this.deleteByPath(this.cache, derivativeOption);
                }
                return undefined;
            }
        }
    ]);
    return ThemeCache;
}();
(0, $kSlfw.default)($06e75d38ebf58c74$export$2e2bcd8739ae039, "MAX_CACHE_SIZE", 20);
(0, $kSlfw.default)($06e75d38ebf58c74$export$2e2bcd8739ae039, "MAX_CACHE_OFFSET", 5);

});

parcelRegister("5ja8O", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dd697ea901030c8$export$2e2bcd8739ae039);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $kSlfw = parcelRequire("kSlfw");

var $u43uR = parcelRequire("u43uR");
var $3dd697ea901030c8$var$uuid = 0;
/**
 * Theme with algorithms to derive tokens from design tokens.
 * Use `createTheme` first which will help to manage the theme instance cache.
 */ var $3dd697ea901030c8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Theme(derivatives) {
        (0, $6CZeq.default)(this, Theme);
        (0, $kSlfw.default)(this, "derivatives", void 0);
        (0, $kSlfw.default)(this, "id", void 0);
        this.derivatives = Array.isArray(derivatives) ? derivatives : [
            derivatives
        ];
        this.id = $3dd697ea901030c8$var$uuid;
        if (derivatives.length === 0) (0, $u43uR.warning)(derivatives.length > 0, "[Ant Design CSS-in-JS] Theme should have at least one derivative function.");
        $3dd697ea901030c8$var$uuid += 1;
    }
    (0, $cHPF9.default)(Theme, [
        {
            key: "getDerivativeToken",
            value: function getDerivativeToken(token) {
                return this.derivatives.reduce(function(result, derivative) {
                    return derivative(token, result);
                }, undefined);
            }
        }
    ]);
    return Theme;
}();

});




parcelRegister("7KFFu", function(module, exports) {

$parcel$export(module.exports, "token2CSSVar", () => $5a4d26b111585357$export$309b3b095f0c7662);
$parcel$export(module.exports, "transformToken", () => $5a4d26b111585357$export$67858afe85bce49f);

var $eUqlC = parcelRequire("eUqlC");
var $5a4d26b111585357$export$309b3b095f0c7662 = function token2CSSVar(token) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    return "--".concat(prefix ? "".concat(prefix, "-") : "").concat(token).replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1-$2").replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
};
var $5a4d26b111585357$export$a27ef1ee9bbc757e = function serializeCSSVar(cssVars, hashId, options) {
    if (!Object.keys(cssVars).length) return "";
    return ".".concat(hashId).concat(options !== null && options !== void 0 && options.scope ? ".".concat(options.scope) : "", "{").concat(Object.entries(cssVars).map(function(_ref) {
        var _ref2 = (0, $eUqlC.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        return "".concat(key, ":").concat(value, ";");
    }).join(""), "}");
};
var $5a4d26b111585357$export$67858afe85bce49f = function transformToken(token, themeKey, config) {
    var cssVars = {};
    var result = {};
    Object.entries(token).forEach(function(_ref3) {
        var _config$preserve, _config$ignore;
        var _ref4 = (0, $eUqlC.default)(_ref3, 2), key = _ref4[0], value = _ref4[1];
        if (config !== null && config !== void 0 && (_config$preserve = config.preserve) !== null && _config$preserve !== void 0 && _config$preserve[key]) result[key] = value;
        else if ((typeof value === "string" || typeof value === "number") && !(config !== null && config !== void 0 && (_config$ignore = config.ignore) !== null && _config$ignore !== void 0 && _config$ignore[key])) {
            var _config$unitless;
            var cssVar = $5a4d26b111585357$export$309b3b095f0c7662(key, config === null || config === void 0 ? void 0 : config.prefix);
            cssVars[cssVar] = typeof value === "number" && !(config !== null && config !== void 0 && (_config$unitless = config.unitless) !== null && _config$unitless !== void 0 && _config$unitless[key]) ? "".concat(value, "px") : String(value);
            result[key] = "var(".concat(cssVar, ")");
        }
    });
    return [
        result,
        $5a4d26b111585357$export$a27ef1ee9bbc757e(cssVars, themeKey, {
            scope: config === null || config === void 0 ? void 0 : config.scope
        })
    ];
};

});

parcelRegister("7YTbd", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cf8f09379a7b7de$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $kbxxf = parcelRequire("kbxxf");

var $acw62 = parcelRequire("acw62");

var $24Ei6 = parcelRequire("24Ei6");

var $iSMSZ = parcelRequire("iSMSZ");

var $aTt2u = parcelRequire("aTt2u");

var $bNXkD = parcelRequire("bNXkD");
function $5cf8f09379a7b7de$export$2e2bcd8739ae039(prefix, keyPath, cacheFn, onCacheRemove, // Add additional effect trigger by `useInsertionEffect`
onCacheEffect) {
    var _React$useContext = $acw62.useContext((0, $24Ei6.default)), globalCache = _React$useContext.cache;
    var fullPath = [
        prefix
    ].concat((0, $kbxxf.default)(keyPath));
    var deps = fullPath.join("_");
    var register = (0, $aTt2u.default)([
        deps
    ]);
    var HMRUpdate = (0, $bNXkD.default)();
    var buildCache = function buildCache(updater) {
        globalCache.update(fullPath, function(prevCache) {
            var _ref = prevCache || [
                undefined,
                undefined
            ], _ref2 = (0, $eUqlC.default)(_ref, 2), _ref2$ = _ref2[0], times = _ref2$ === void 0 ? 0 : _ref2$, cache = _ref2[1];
            // HMR should always ignore cache since developer may change it
            var tmpCache = cache;
            var mergedCache = tmpCache || cacheFn();
            var data = [
                times,
                mergedCache
            ];
            // Call updater if need additional logic
            return updater ? updater(data) : data;
        });
    };
    // Create cache
    $acw62.useMemo(function() {
        buildCache();
    }, /* eslint-disable react-hooks/exhaustive-deps */ [
        deps
    ]);
    var cacheEntity = globalCache.get(fullPath);
    var cacheContent = cacheEntity[1];
    // Remove if no need anymore
    (0, $iSMSZ.default)(function() {
        onCacheEffect === null || onCacheEffect === void 0 || onCacheEffect(cacheContent);
    }, function(polyfill) {
        // It's bad to call build again in effect.
        // But we have to do this since StrictMode will call effect twice
        // which will clear cache on the first time.
        buildCache(function(_ref3) {
            var _ref4 = (0, $eUqlC.default)(_ref3, 2), times = _ref4[0], cache = _ref4[1];
            if (polyfill && times === 0) onCacheEffect === null || onCacheEffect === void 0 || onCacheEffect(cacheContent);
            return [
                times + 1,
                cache
            ];
        });
        return function() {
            globalCache.update(fullPath, function(prevCache) {
                var _ref5 = prevCache || [], _ref6 = (0, $eUqlC.default)(_ref5, 2), _ref6$ = _ref6[0], times = _ref6$ === void 0 ? 0 : _ref6$, cache = _ref6[1];
                var nextCount = times - 1;
                if (nextCount === 0) {
                    // Always remove styles in useEffect callback
                    register(function() {
                        // With polyfill, registered callback will always be called synchronously
                        // But without polyfill, it will be called in effect clean up,
                        // And by that time this cache is cleaned up.
                        if (polyfill || !globalCache.get(fullPath)) onCacheRemove === null || onCacheRemove === void 0 || onCacheRemove(cache, false);
                    });
                    return null;
                }
                return [
                    times - 1,
                    cache
                ];
            });
        };
    }, [
        deps
    ]);
    return cacheContent;
}

});
parcelRegister("iSMSZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbf330e0793a2d94$export$2e2bcd8739ae039);

var $d49SP = parcelRequire("d49SP");

var $6hDTM = parcelRequire("6hDTM");

var $acw62 = parcelRequire("acw62");
// We need fully clone React function here
// to avoid webpack warning React 17 do not export `useId`
var $dbf330e0793a2d94$var$fullClone = (0, $d49SP.default)({}, $acw62);
var $dbf330e0793a2d94$var$useInsertionEffect = $dbf330e0793a2d94$var$fullClone.useInsertionEffect;
/**
 * Polyfill `useInsertionEffect` for React < 18
 * @param renderEffect will be executed in `useMemo`, and do not have callback
 * @param effect will be executed in `useLayoutEffect`
 * @param deps
 */ var $dbf330e0793a2d94$var$useInsertionEffectPolyfill = function useInsertionEffectPolyfill(renderEffect, effect, deps) {
    $acw62.useMemo(renderEffect, deps);
    (0, $6hDTM.default)(function() {
        return effect(true);
    }, deps);
};
/**
 * Compatible `useInsertionEffect`
 * will use `useInsertionEffect` if React version >= 18,
 * otherwise use `useInsertionEffectPolyfill`.
 */ var $dbf330e0793a2d94$var$useCompatibleInsertionEffect = $dbf330e0793a2d94$var$useInsertionEffect ? function(renderEffect, effect, deps) {
    return $dbf330e0793a2d94$var$useInsertionEffect(function() {
        renderEffect();
        return effect();
    }, deps);
} : $dbf330e0793a2d94$var$useInsertionEffectPolyfill;
var $dbf330e0793a2d94$export$2e2bcd8739ae039 = $dbf330e0793a2d94$var$useCompatibleInsertionEffect;

});
parcelRegister("6hDTM", function(module, exports) {

$parcel$export(module.exports, "useLayoutUpdateEffect", () => $493347a9fd5d8394$export$9283e56bae2f7b0f);
$parcel$export(module.exports, "default", () => $493347a9fd5d8394$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $h4v51 = parcelRequire("h4v51");
/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $493347a9fd5d8394$var$useInternalLayoutEffect = (0, $h4v51.default)() ? $acw62.useLayoutEffect : $acw62.useEffect;
var $493347a9fd5d8394$var$useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = $acw62.useRef(true);
    $493347a9fd5d8394$var$useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $493347a9fd5d8394$var$useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var $493347a9fd5d8394$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    $493347a9fd5d8394$var$useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
var $493347a9fd5d8394$export$2e2bcd8739ae039 = $493347a9fd5d8394$var$useLayoutEffect;

});


parcelRegister("aTt2u", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ee590fd65ab0539$export$2e2bcd8739ae039);

var $d49SP = parcelRequire("d49SP");
parcelRequire("u43uR");

var $acw62 = parcelRequire("acw62");
var $7ee590fd65ab0539$var$fullClone = (0, $d49SP.default)({}, $acw62);
var $7ee590fd65ab0539$var$useInsertionEffect = $7ee590fd65ab0539$var$fullClone.useInsertionEffect;
// DO NOT register functions in useEffect cleanup function, or functions that registered will never be called.
var $7ee590fd65ab0539$var$useCleanupRegister = function useCleanupRegister(deps) {
    var effectCleanups = [];
    var cleanupFlag = false;
    function register(fn) {
        if (cleanupFlag) return;
        effectCleanups.push(fn);
    }
    $acw62.useEffect(function() {
        // Compatible with strict mode
        cleanupFlag = false;
        return function() {
            cleanupFlag = true;
            if (effectCleanups.length) effectCleanups.forEach(function(fn) {
                return fn();
            });
        };
    }, deps);
    return register;
};
var $7ee590fd65ab0539$var$useRun = function useRun() {
    return function(fn) {
        fn();
    };
};
// Only enable register in React 18
var $7ee590fd65ab0539$var$useEffectCleanupRegister = typeof $7ee590fd65ab0539$var$useInsertionEffect !== "undefined" ? $7ee590fd65ab0539$var$useCleanupRegister : $7ee590fd65ab0539$var$useRun;
var $7ee590fd65ab0539$export$2e2bcd8739ae039 = $7ee590fd65ab0539$var$useEffectCleanupRegister;

});

parcelRegister("bNXkD", function(module, exports) {

$parcel$export(module.exports, "default", () => $89824b6453bf0586$export$2e2bcd8739ae039);
function $89824b6453bf0586$var$useProdHMR() {
    return false;
}
var $89824b6453bf0586$var$webpackHMR = false;
function $89824b6453bf0586$var$useDevHMR() {
    return $89824b6453bf0586$var$webpackHMR;
}
var $89824b6453bf0586$export$2e2bcd8739ae039 = $89824b6453bf0586$var$useProdHMR;
var $89824b6453bf0586$var$win, $89824b6453bf0586$var$originWebpackHotUpdate;

});



parcelRegister("684jW", function(module, exports) {

$parcel$export(module.exports, "CSS_VAR_PREFIX", () => $4766d7657208f51d$export$d96c342855c5e1fc);
$parcel$export(module.exports, "extract", () => $4766d7657208f51d$export$f9380c9a627682d3);
$parcel$export(module.exports, "default", () => $4766d7657208f51d$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $kbxxf = parcelRequire("kbxxf");

var $4ZrBP = parcelRequire("4ZrBP");

var $acw62 = parcelRequire("acw62");

var $24Ei6 = parcelRequire("24Ei6");

var $lpQ06 = parcelRequire("lpQ06");

var $7KFFu = parcelRequire("7KFFu");

var $7YTbd = parcelRequire("7YTbd");

var $aoTVg = parcelRequire("aoTVg");
var $4766d7657208f51d$export$d96c342855c5e1fc = "cssVar";
var $4766d7657208f51d$var$useCSSVarRegister = function useCSSVarRegister(config, fn) {
    var key = config.key, prefix = config.prefix, unitless = config.unitless, ignore = config.ignore, token = config.token, _config$scope = config.scope, scope = _config$scope === void 0 ? "" : _config$scope;
    var _useContext = (0, $acw62.useContext)((0, $24Ei6.default)), instanceId = _useContext.cache.instanceId, container = _useContext.container;
    var tokenKey = token._tokenKey;
    var stylePath = [].concat((0, $kbxxf.default)(config.path), [
        key,
        scope,
        tokenKey
    ]);
    var cache = (0, $7YTbd.default)($4766d7657208f51d$export$d96c342855c5e1fc, stylePath, function() {
        var originToken = fn();
        var _transformToken = (0, $7KFFu.transformToken)(originToken, key, {
            prefix: prefix,
            unitless: unitless,
            ignore: ignore,
            scope: scope
        }), _transformToken2 = (0, $eUqlC.default)(_transformToken, 2), mergedToken = _transformToken2[0], cssVarsStr = _transformToken2[1];
        var styleId = (0, $aoTVg.uniqueHash)(stylePath, cssVarsStr);
        return [
            mergedToken,
            cssVarsStr,
            styleId,
            key
        ];
    }, function(_ref) {
        var _ref2 = (0, $eUqlC.default)(_ref, 3), styleId = _ref2[2];
        if (0, $lpQ06.isClientSide) (0, $4ZrBP.removeCSS)(styleId, {
            mark: (0, $24Ei6.ATTR_MARK)
        });
    }, function(_ref3) {
        var _ref4 = (0, $eUqlC.default)(_ref3, 3), cssVarsStr = _ref4[1], styleId = _ref4[2];
        if (!cssVarsStr) return;
        var style = (0, $4ZrBP.updateCSS)(cssVarsStr, styleId, {
            mark: (0, $24Ei6.ATTR_MARK),
            prepend: "queue",
            attachTo: container,
            priority: -999
        });
        style[0, $24Ei6.CSS_IN_JS_INSTANCE] = instanceId;
        // Used for `useCacheToken` to remove on batch when token removed
        style.setAttribute((0, $24Ei6.ATTR_TOKEN), key);
    });
    return cache;
};
var $4766d7657208f51d$export$f9380c9a627682d3 = function extract(cache, effectStyles, options) {
    var _cache = (0, $eUqlC.default)(cache, 4), styleStr = _cache[1], styleId = _cache[2], cssVarKey = _cache[3];
    var _ref5 = options || {}, plain = _ref5.plain;
    if (!styleStr) return null;
    var order = -999;
    // ====================== Style ======================
    // Used for rc-util
    var sharedAttrs = {
        "data-rc-order": "prependQueue",
        "data-rc-priority": "".concat(order)
    };
    var styleText = (0, $lpQ06.toStyleStr)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};
var $4766d7657208f51d$export$2e2bcd8739ae039 = $4766d7657208f51d$var$useCSSVarRegister;

});
parcelRegister("aoTVg", function(module, exports) {

$parcel$export(module.exports, "uniqueHash", () => $7927865cee518bb3$export$412618713057f6ca);
$parcel$export(module.exports, "STYLE_PREFIX", () => $7927865cee518bb3$export$1e6d9f0d06c7ec14);
$parcel$export(module.exports, "default", () => $7927865cee518bb3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extract", () => $7927865cee518bb3$export$f9380c9a627682d3);

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $kbxxf = parcelRequire("kbxxf");

var $fSwVM = parcelRequire("fSwVM");

var $isNEn = parcelRequire("isNEn");

var $4ZrBP = parcelRequire("4ZrBP");

var $acw62 = parcelRequire("acw62");

var $3ycpT = parcelRequire("3ycpT");

var $fm8kz = parcelRequire("fm8kz");
parcelRequire("yUL79");

var $24Ei6 = parcelRequire("24Ei6");

var $lpQ06 = parcelRequire("lpQ06");

var $79KwC = parcelRequire("79KwC");

var $7YTbd = parcelRequire("7YTbd");
var $7927865cee518bb3$var$SKIP_CHECK = "_skip_check_";
var $7927865cee518bb3$var$MULTI_VALUE = "_multi_value_";
function $7927865cee518bb3$export$8756898546458274(styleStr) {
    var serialized = (0, $fm8kz.serialize)((0, $fm8kz.compile)(styleStr), (0, $fm8kz.stringify));
    return serialized.replace(/\{%%%\:[^;];}/g, ";");
}
function $7927865cee518bb3$var$isCompoundCSSProperty(value) {
    return (0, $fSwVM.default)(value) === "object" && value && ($7927865cee518bb3$var$SKIP_CHECK in value || $7927865cee518bb3$var$MULTI_VALUE in value);
}
// 注入 hash 值
function $7927865cee518bb3$var$injectSelectorHash(key, hashId, hashPriority) {
    if (!hashId) return key;
    var hashClassName = ".".concat(hashId);
    var hashSelector = hashPriority === "low" ? ":where(".concat(hashClassName, ")") : hashClassName;
    // 注入 hashId
    var keys = key.split(",").map(function(k) {
        var _firstPath$match;
        var fullPath = k.trim().split(/\s+/);
        // 如果 Selector 第一个是 HTML Element，那我们就插到它的后面。反之，就插到最前面。
        var firstPath = fullPath[0] || "";
        var htmlElement = ((_firstPath$match = firstPath.match(/^\w+/)) === null || _firstPath$match === void 0 ? void 0 : _firstPath$match[0]) || "";
        firstPath = "".concat(htmlElement).concat(hashSelector).concat(firstPath.slice(htmlElement.length));
        return [
            firstPath
        ].concat((0, $kbxxf.default)(fullPath.slice(1))).join(" ");
    });
    return keys.join(",");
}
var $7927865cee518bb3$export$e13dc740254f53d7 = function parseStyle(interpolation) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        root: true,
        parentSelectors: []
    }, root = _ref.root, injectHash = _ref.injectHash, parentSelectors = _ref.parentSelectors;
    var hashId = config.hashId, layer = config.layer, path = config.path, hashPriority = config.hashPriority, _config$transformers = config.transformers, transformers = _config$transformers === void 0 ? [] : _config$transformers, _config$linters = config.linters, linters = _config$linters === void 0 ? [] : _config$linters;
    var styleStr = "";
    var effectStyle = {};
    function parseKeyframes(keyframes) {
        var animationName = keyframes.getName(hashId);
        if (!effectStyle[animationName]) {
            var _parseStyle = parseStyle(keyframes.style, config, {
                root: false,
                parentSelectors: parentSelectors
            }), _parseStyle2 = (0, $eUqlC.default)(_parseStyle, 1), _parsedStr = _parseStyle2[0];
            effectStyle[animationName] = "@keyframes ".concat(keyframes.getName(hashId)).concat(_parsedStr);
        }
    }
    function flattenList(list) {
        var fullList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        list.forEach(function(item) {
            if (Array.isArray(item)) flattenList(item, fullList);
            else if (item) fullList.push(item);
        });
        return fullList;
    }
    var flattenStyleList = flattenList(Array.isArray(interpolation) ? interpolation : [
        interpolation
    ]);
    flattenStyleList.forEach(function(originStyle) {
        // Only root level can use raw string
        var style = typeof originStyle === "string" && !root ? {} : originStyle;
        if (typeof style === "string") styleStr += "".concat(style, "\n");
        else if (style._keyframe) // Keyframe
        parseKeyframes(style);
        else {
            var mergedStyle = transformers.reduce(function(prev, trans) {
                var _trans$visit;
                return (trans === null || trans === void 0 || (_trans$visit = trans.visit) === null || _trans$visit === void 0 ? void 0 : _trans$visit.call(trans, prev)) || prev;
            }, style);
            // Normal CSSObject
            Object.keys(mergedStyle).forEach(function(key) {
                var value = mergedStyle[key];
                if ((0, $fSwVM.default)(value) === "object" && value && (key !== "animationName" || !value._keyframe) && !$7927865cee518bb3$var$isCompoundCSSProperty(value)) {
                    var subInjectHash = false;
                    // 当成嵌套对象来处理
                    var mergedKey = key.trim();
                    // Whether treat child as root. In most case it is false.
                    var nextRoot = false;
                    // 拆分多个选择器
                    if ((root || injectHash) && hashId) {
                        if (mergedKey.startsWith("@")) // 略过媒体查询，交给子节点继续插入 hashId
                        subInjectHash = true;
                        else // 注入 hashId
                        mergedKey = $7927865cee518bb3$var$injectSelectorHash(key, hashId, hashPriority);
                    } else if (root && !hashId && (mergedKey === "&" || mergedKey === "")) {
                        // In case of `{ '&': { a: { color: 'red' } } }` or `{ '': { a: { color: 'red' } } }` without hashId,
                        // we will get `&{a:{color:red;}}` or `{a:{color:red;}}` string for stylis to compile.
                        // But it does not conform to stylis syntax,
                        // and finally we will get `{color:red;}` as css, which is wrong.
                        // So we need to remove key in root, and treat child `{ a: { color: 'red' } }` as root.
                        mergedKey = "";
                        nextRoot = true;
                    }
                    var _parseStyle3 = parseStyle(value, config, {
                        root: nextRoot,
                        injectHash: subInjectHash,
                        parentSelectors: [].concat((0, $kbxxf.default)(parentSelectors), [
                            mergedKey
                        ])
                    }), _parseStyle4 = (0, $eUqlC.default)(_parseStyle3, 2), _parsedStr2 = _parseStyle4[0], childEffectStyle = _parseStyle4[1];
                    effectStyle = (0, $d49SP.default)((0, $d49SP.default)({}, effectStyle), childEffectStyle);
                    styleStr += "".concat(mergedKey).concat(_parsedStr2);
                } else {
                    var _value;
                    function appendStyle(cssKey, cssValue) {
                        // 如果是样式则直接插入
                        var styleName = cssKey.replace(/[A-Z]/g, function(match) {
                            return "-".concat(match.toLowerCase());
                        });
                        // Auto suffix with px
                        var formatValue = cssValue;
                        if (!(0, $3ycpT.default)[cssKey] && typeof formatValue === "number" && formatValue !== 0) formatValue = "".concat(formatValue, "px");
                        // handle animationName & Keyframe value
                        if (cssKey === "animationName" && cssValue !== null && cssValue !== void 0 && cssValue._keyframe) {
                            parseKeyframes(cssValue);
                            formatValue = cssValue.getName(hashId);
                        }
                        styleStr += "".concat(styleName, ":").concat(formatValue, ";");
                    }
                    var actualValue = (_value = value === null || value === void 0 ? void 0 : value.value) !== null && _value !== void 0 ? _value : value;
                    if ((0, $fSwVM.default)(value) === "object" && value !== null && value !== void 0 && value[$7927865cee518bb3$var$MULTI_VALUE] && Array.isArray(actualValue)) actualValue.forEach(function(item) {
                        appendStyle(key, item);
                    });
                    else appendStyle(key, actualValue);
                }
            });
        }
    });
    if (!root) styleStr = "{".concat(styleStr, "}");
    else if (layer && (0, $lpQ06.supportLayer)()) {
        var layerCells = layer.split(",");
        var layerName = layerCells[layerCells.length - 1].trim();
        styleStr = "@layer ".concat(layerName, " {").concat(styleStr, "}");
        // Order of layer if needed
        if (layerCells.length > 1) // zombieJ: stylis do not support layer order, so we need to handle it manually.
        styleStr = "@layer ".concat(layer, "{%%%:%}").concat(styleStr);
    }
    return [
        styleStr,
        effectStyle
    ];
};
function $7927865cee518bb3$export$412618713057f6ca(path, styleStr) {
    return (0, $isNEn.default)("".concat(path.join("%")).concat(styleStr));
}
function $7927865cee518bb3$var$Empty() {
    return null;
}
var $7927865cee518bb3$export$1e6d9f0d06c7ec14 = "style";
function $7927865cee518bb3$export$2e2bcd8739ae039(info, styleFn) {
    var token = info.token, path = info.path, hashId = info.hashId, layer = info.layer, nonce = info.nonce, clientOnly = info.clientOnly, _info$order = info.order, order = _info$order === void 0 ? 0 : _info$order;
    var _React$useContext = $acw62.useContext((0, $24Ei6.default)), autoClear = _React$useContext.autoClear, mock = _React$useContext.mock, defaultCache = _React$useContext.defaultCache, hashPriority = _React$useContext.hashPriority, container = _React$useContext.container, ssrInline = _React$useContext.ssrInline, transformers = _React$useContext.transformers, linters = _React$useContext.linters, cache = _React$useContext.cache;
    var tokenKey = token._tokenKey;
    var fullPath = [
        tokenKey
    ].concat((0, $kbxxf.default)(path));
    // Check if need insert style
    var isMergedClientSide = (0, $lpQ06.isClientSide);
    var _useGlobalCache = (0, $7YTbd.default)($7927865cee518bb3$export$1e6d9f0d06c7ec14, fullPath, // Create cache if needed
    function() {
        var cachePath = fullPath.join("|");
        // Get style from SSR inline style directly
        if ((0, $79KwC.existPath)(cachePath)) {
            var _getStyleAndHash = (0, $79KwC.getStyleAndHash)(cachePath), _getStyleAndHash2 = (0, $eUqlC.default)(_getStyleAndHash, 2), inlineCacheStyleStr = _getStyleAndHash2[0], styleHash = _getStyleAndHash2[1];
            if (inlineCacheStyleStr) return [
                inlineCacheStyleStr,
                tokenKey,
                styleHash,
                {},
                clientOnly,
                order
            ];
        }
        // Generate style
        var styleObj = styleFn();
        var _parseStyle5 = $7927865cee518bb3$export$e13dc740254f53d7(styleObj, {
            hashId: hashId,
            hashPriority: hashPriority,
            layer: layer,
            path: path.join("-"),
            transformers: transformers,
            linters: linters
        }), _parseStyle6 = (0, $eUqlC.default)(_parseStyle5, 2), parsedStyle = _parseStyle6[0], effectStyle = _parseStyle6[1];
        var styleStr = $7927865cee518bb3$export$8756898546458274(parsedStyle);
        var styleId = $7927865cee518bb3$export$412618713057f6ca(fullPath, styleStr);
        return [
            styleStr,
            tokenKey,
            styleId,
            effectStyle,
            clientOnly,
            order
        ];
    }, // Remove cache if no need
    function(_ref2, fromHMR) {
        var _ref3 = (0, $eUqlC.default)(_ref2, 3), styleId = _ref3[2];
        if ((fromHMR || autoClear) && (0, $lpQ06.isClientSide)) (0, $4ZrBP.removeCSS)(styleId, {
            mark: (0, $24Ei6.ATTR_MARK)
        });
    }, // Effect: Inject style here
    function(_ref4) {
        var _ref5 = (0, $eUqlC.default)(_ref4, 4), styleStr = _ref5[0], _ = _ref5[1], styleId = _ref5[2], effectStyle = _ref5[3];
        if (isMergedClientSide && styleStr !== (0, $79KwC.CSS_FILE_STYLE)) {
            var mergedCSSConfig = {
                mark: (0, $24Ei6.ATTR_MARK),
                prepend: "queue",
                attachTo: container,
                priority: order
            };
            var nonceStr = typeof nonce === "function" ? nonce() : nonce;
            if (nonceStr) mergedCSSConfig.csp = {
                nonce: nonceStr
            };
            var style = (0, $4ZrBP.updateCSS)(styleStr, styleId, mergedCSSConfig);
            style[0, $24Ei6.CSS_IN_JS_INSTANCE] = cache.instanceId;
            // Used for `useCacheToken` to remove on batch when token removed
            style.setAttribute((0, $24Ei6.ATTR_TOKEN), tokenKey);
            // Inject client side effect style
            Object.keys(effectStyle).forEach(function(effectKey) {
                (0, $4ZrBP.updateCSS)($7927865cee518bb3$export$8756898546458274(effectStyle[effectKey]), "_effect-".concat(effectKey), mergedCSSConfig);
            });
        }
    }), _useGlobalCache2 = (0, $eUqlC.default)(_useGlobalCache, 3), cachedStyleStr = _useGlobalCache2[0], cachedTokenKey = _useGlobalCache2[1], cachedStyleId = _useGlobalCache2[2];
    return function(node) {
        var styleNode;
        if (!ssrInline || isMergedClientSide || !defaultCache) styleNode = /*#__PURE__*/ $acw62.createElement($7927865cee518bb3$var$Empty, null);
        else {
            var _ref6;
            styleNode = /*#__PURE__*/ $acw62.createElement("style", (0, $8nd05.default)({}, (_ref6 = {}, (0, $kSlfw.default)(_ref6, (0, $24Ei6.ATTR_TOKEN), cachedTokenKey), (0, $kSlfw.default)(_ref6, (0, $24Ei6.ATTR_MARK), cachedStyleId), _ref6), {
                dangerouslySetInnerHTML: {
                    __html: cachedStyleStr
                }
            }));
        }
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, styleNode, node);
    };
}
var $7927865cee518bb3$export$f9380c9a627682d3 = function extract(cache, effectStyles, options) {
    var _cache = (0, $eUqlC.default)(cache, 6), styleStr = _cache[0], tokenKey = _cache[1], styleId = _cache[2], effectStyle = _cache[3], clientOnly = _cache[4], order = _cache[5];
    var _ref7 = options || {}, plain = _ref7.plain;
    // Skip client only style
    if (clientOnly) return null;
    var keyStyleText = styleStr;
    // ====================== Style ======================
    // Used for rc-util
    var sharedAttrs = {
        "data-rc-order": "prependQueue",
        "data-rc-priority": "".concat(order)
    };
    keyStyleText = (0, $lpQ06.toStyleStr)(styleStr, tokenKey, styleId, sharedAttrs, plain);
    // =============== Create effect style ===============
    if (effectStyle) Object.keys(effectStyle).forEach(function(effectKey) {
        // Effect style can be reused
        if (!effectStyles[effectKey]) {
            effectStyles[effectKey] = true;
            var effectStyleStr = $7927865cee518bb3$export$8756898546458274(effectStyle[effectKey]);
            keyStyleText += (0, $lpQ06.toStyleStr)(effectStyleStr, tokenKey, "_effect-".concat(effectKey), sharedAttrs, plain);
        }
    });
    return [
        order,
        styleId,
        keyStyleText
    ];
};

});
parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("3ycpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $295e2dc178c4782f$export$2e2bcd8739ae039);
var $295e2dc178c4782f$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $295e2dc178c4782f$export$2e2bcd8739ae039 = $295e2dc178c4782f$var$unitlessKeys;

});

parcelRegister("fm8kz", function(module, exports) {

$parcel$export(module.exports, "MS", () => $298fb931ed4fbf8b$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $298fb931ed4fbf8b$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $298fb931ed4fbf8b$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $298fb931ed4fbf8b$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $298fb931ed4fbf8b$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $298fb931ed4fbf8b$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $298fb931ed4fbf8b$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $298fb931ed4fbf8b$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $298fb931ed4fbf8b$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $298fb931ed4fbf8b$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $298fb931ed4fbf8b$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $298fb931ed4fbf8b$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $298fb931ed4fbf8b$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $298fb931ed4fbf8b$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $298fb931ed4fbf8b$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $298fb931ed4fbf8b$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $298fb931ed4fbf8b$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $298fb931ed4fbf8b$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $298fb931ed4fbf8b$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $298fb931ed4fbf8b$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $298fb931ed4fbf8b$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $298fb931ed4fbf8b$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $298fb931ed4fbf8b$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $298fb931ed4fbf8b$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $298fb931ed4fbf8b$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $298fb931ed4fbf8b$export$38bcb760f1d4871c);
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("yUL79", function(module, exports) {

var $jOWkI = parcelRequire("jOWkI");

var $hIyCU = parcelRequire("hIyCU");

var $1iOYs = parcelRequire("1iOYs");

var $jcTSE = parcelRequire("jcTSE");

var $hjBd1 = parcelRequire("hjBd1");

var $9L1eX = parcelRequire("9L1eX");

});
parcelRegister("jOWkI", function(module, exports) {

var $dD47W = parcelRequire("dD47W");
var $e6dfef8f0af50f8c$var$linter = function linter(key, value, info) {
    if (key === "content") {
        // From emotion: https://github.com/emotion-js/emotion/blob/main/packages/serialize/src/index.js#L63
        var contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
        var contentValues = [
            "normal",
            "none",
            "initial",
            "inherit",
            "unset"
        ];
        if (typeof value !== "string" || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) (0, $dD47W.lintWarning)("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"".concat(value, "\"'`."), info);
    }
};
var $e6dfef8f0af50f8c$export$2e2bcd8739ae039 = $e6dfef8f0af50f8c$var$linter;

});
parcelRegister("dD47W", function(module, exports) {

$parcel$export(module.exports, "lintWarning", () => $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03);

var $u43uR = parcelRequire("u43uR");
function $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03(message, info) {
    var path = info.path, parentSelectors = info.parentSelectors;
    (0, $u43uR.default)(false, "[Ant Design CSS-in-JS] ".concat(path ? "Error in ".concat(path, ": ") : "").concat(message).concat(parentSelectors.length ? " Selector: ".concat(parentSelectors.join(" | ")) : ""));
}

});


parcelRegister("hIyCU", function(module, exports) {

var $dD47W = parcelRequire("dD47W");
var $ce6167d258bd4ce8$var$linter = function linter(key, value, info) {
    if (key === "animation") {
        if (info.hashId && value !== "none") (0, $dD47W.lintWarning)("You seem to be using hashed animation '".concat(value, "', in which case 'animationName' with Keyframe as value is recommended."), info);
    }
};
var $ce6167d258bd4ce8$export$2e2bcd8739ae039 = $ce6167d258bd4ce8$var$linter;

});

parcelRegister("1iOYs", function(module, exports) {

var $dD47W = parcelRequire("dD47W");
function $0f2f0342ec57fd4c$var$isConcatSelector(selector) {
    var _selector$match;
    var notContent = ((_selector$match = selector.match(/:not\(([^)]*)\)/)) === null || _selector$match === void 0 ? void 0 : _selector$match[1]) || "";
    // split selector. e.g.
    // `h1#a.b` => ['h1', #a', '.b']
    var splitCells = notContent.split(/(\[[^[]*])|(?=[.#])/).filter(function(str) {
        return str;
    });
    return splitCells.length > 1;
}
function $0f2f0342ec57fd4c$var$parsePath(info) {
    return info.parentSelectors.reduce(function(prev, cur) {
        if (!prev) return cur;
        return cur.includes("&") ? cur.replace(/&/g, prev) : "".concat(prev, " ").concat(cur);
    }, "");
}
var $0f2f0342ec57fd4c$var$linter = function linter(key, value, info) {
    var parentSelectorPath = $0f2f0342ec57fd4c$var$parsePath(info);
    var notList = parentSelectorPath.match(/:not\([^)]*\)/g) || [];
    if (notList.length > 0 && notList.some($0f2f0342ec57fd4c$var$isConcatSelector)) (0, $dD47W.lintWarning)("Concat ':not' selector not support in legacy browsers.", info);
};
var $0f2f0342ec57fd4c$export$2e2bcd8739ae039 = $0f2f0342ec57fd4c$var$linter;

});

parcelRegister("jcTSE", function(module, exports) {

var $dD47W = parcelRequire("dD47W");
var $dfba7bff08539c12$var$linter = function linter(key, value, info) {
    switch(key){
        case "marginLeft":
        case "marginRight":
        case "paddingLeft":
        case "paddingRight":
        case "left":
        case "right":
        case "borderLeft":
        case "borderLeftWidth":
        case "borderLeftStyle":
        case "borderLeftColor":
        case "borderRight":
        case "borderRightWidth":
        case "borderRightStyle":
        case "borderRightColor":
        case "borderTopLeftRadius":
        case "borderTopRightRadius":
        case "borderBottomLeftRadius":
        case "borderBottomRightRadius":
            (0, $dD47W.lintWarning)("You seem to be using non-logical property '".concat(key, "' which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            return;
        case "margin":
        case "padding":
        case "borderWidth":
        case "borderStyle":
            // case 'borderColor':
            if (typeof value === "string") {
                var valueArr = value.split(" ").map(function(item) {
                    return item.trim();
                });
                if (valueArr.length === 4 && valueArr[1] !== valueArr[3]) (0, $dD47W.lintWarning)("You seem to be using '".concat(key, "' property with different left ").concat(key, " and right ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            }
            return;
        case "clear":
        case "textAlign":
            if (value === "left" || value === "right") (0, $dD47W.lintWarning)("You seem to be using non-logical value '".concat(value, "' of ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            return;
        case "borderRadius":
            if (typeof value === "string") {
                var radiusGroups = value.split("/").map(function(item) {
                    return item.trim();
                });
                var invalid = radiusGroups.reduce(function(result, group) {
                    if (result) return result;
                    var radiusArr = group.split(" ").map(function(item) {
                        return item.trim();
                    });
                    // borderRadius: '2px 4px'
                    if (radiusArr.length >= 2 && radiusArr[0] !== radiusArr[1]) return true;
                    // borderRadius: '4px 4px 2px'
                    if (radiusArr.length === 3 && radiusArr[1] !== radiusArr[2]) return true;
                    // borderRadius: '4px 4px 2px 4px'
                    if (radiusArr.length === 4 && radiusArr[2] !== radiusArr[3]) return true;
                    return result;
                }, false);
                if (invalid) (0, $dD47W.lintWarning)("You seem to be using non-logical value '".concat(value, "' of ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            }
            return;
        default:
    }
};
var $dfba7bff08539c12$export$2e2bcd8739ae039 = $dfba7bff08539c12$var$linter;

});

parcelRegister("hjBd1", function(module, exports) {

var $dD47W = parcelRequire("dD47W");
var $c9b112fad2a88d07$var$linter = function linter(key, value, info) {
    if (typeof value === "string" && /NaN/g.test(value) || Number.isNaN(value)) (0, $dD47W.lintWarning)("Unexpected 'NaN' in property '".concat(key, ": ").concat(value, "'."), info);
};
var $c9b112fad2a88d07$export$2e2bcd8739ae039 = $c9b112fad2a88d07$var$linter;

});

parcelRegister("9L1eX", function(module, exports) {

var $dD47W = parcelRequire("dD47W");
var $71a97720875b4c78$var$linter = function linter(key, value, info) {
    if (info.parentSelectors.some(function(selector) {
        var selectors = selector.split(",");
        return selectors.some(function(item) {
            return item.split("&").length > 2;
        });
    })) (0, $dD47W.lintWarning)("Should not use more than one `&` in a selector.", info);
};
var $71a97720875b4c78$export$2e2bcd8739ae039 = $71a97720875b4c78$var$linter;

});


parcelRegister("79KwC", function(module, exports) {

$parcel$export(module.exports, "ATTR_CACHE_MAP", () => $535d769197131042$export$1c054aa01963e47e);
$parcel$export(module.exports, "CSS_FILE_STYLE", () => $535d769197131042$export$e0a2f8ff7fc63361);
$parcel$export(module.exports, "serialize", () => $535d769197131042$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "existPath", () => $535d769197131042$export$5aa0d776d676ab98);
$parcel$export(module.exports, "getStyleAndHash", () => $535d769197131042$export$d3851dfd3659b2ce);

var $eUqlC = parcelRequire("eUqlC");

var $h4v51 = parcelRequire("h4v51");

var $24Ei6 = parcelRequire("24Ei6");
var $535d769197131042$export$1c054aa01963e47e = "data-ant-cssinjs-cache-path";
var $535d769197131042$export$e0a2f8ff7fc63361 = "_FILE_STYLE__";
function $535d769197131042$export$dfdc1655ccc5b9cb(cachePathMap) {
    return Object.keys(cachePathMap).map(function(path) {
        var hash = cachePathMap[path];
        return "".concat(path, ":").concat(hash);
    }).join(";");
}
var $535d769197131042$var$cachePathMap;
var $535d769197131042$var$fromCSSFile = true;
function $535d769197131042$export$aad8462122ac592b(mockCache) {
    var fromFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    $535d769197131042$var$cachePathMap = mockCache;
    $535d769197131042$var$fromCSSFile = fromFile;
}
function $535d769197131042$export$18298bb220d85216() {
    if (!$535d769197131042$var$cachePathMap) {
        $535d769197131042$var$cachePathMap = {};
        if ((0, $h4v51.default)()) {
            var div = document.createElement("div");
            div.className = $535d769197131042$export$1c054aa01963e47e;
            div.style.position = "fixed";
            div.style.visibility = "hidden";
            div.style.top = "-9999px";
            document.body.appendChild(div);
            var content = getComputedStyle(div).content || "";
            content = content.replace(/^"/, "").replace(/"$/, "");
            // Fill data
            content.split(";").forEach(function(item) {
                var _item$split = item.split(":"), _item$split2 = (0, $eUqlC.default)(_item$split, 2), path = _item$split2[0], hash = _item$split2[1];
                $535d769197131042$var$cachePathMap[path] = hash;
            });
            // Remove inline record style
            var inlineMapStyle = document.querySelector("style[".concat($535d769197131042$export$1c054aa01963e47e, "]"));
            if (inlineMapStyle) {
                var _inlineMapStyle$paren;
                $535d769197131042$var$fromCSSFile = false;
                (_inlineMapStyle$paren = inlineMapStyle.parentNode) === null || _inlineMapStyle$paren === void 0 || _inlineMapStyle$paren.removeChild(inlineMapStyle);
            }
            document.body.removeChild(div);
        }
    }
}
function $535d769197131042$export$5aa0d776d676ab98(path) {
    $535d769197131042$export$18298bb220d85216();
    return !!$535d769197131042$var$cachePathMap[path];
}
function $535d769197131042$export$d3851dfd3659b2ce(path) {
    var hash = $535d769197131042$var$cachePathMap[path];
    var styleStr = null;
    if (hash && (0, $h4v51.default)()) {
        if ($535d769197131042$var$fromCSSFile) styleStr = $535d769197131042$export$e0a2f8ff7fc63361;
        else {
            var _style = document.querySelector("style[".concat((0, $24Ei6.ATTR_MARK), '="').concat($535d769197131042$var$cachePathMap[path], '"]'));
            if (_style) styleStr = _style.innerHTML;
            else // Clean up since not exist anymore
            delete $535d769197131042$var$cachePathMap[path];
        }
    }
    return [
        styleStr,
        hash
    ];
}

});




parcelRegister("hsEk2", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb64545ddf8f118e$export$2e2bcd8739ae039);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $kSlfw = parcelRequire("kSlfw");
var $cb64545ddf8f118e$var$Keyframe = /*#__PURE__*/ function() {
    function Keyframe(name, style) {
        (0, $6CZeq.default)(this, Keyframe);
        (0, $kSlfw.default)(this, "name", void 0);
        (0, $kSlfw.default)(this, "style", void 0);
        (0, $kSlfw.default)(this, "_keyframe", true);
        this.name = name;
        this.style = style;
    }
    (0, $cHPF9.default)(Keyframe, [
        {
            key: "getName",
            value: function getName() {
                var hashId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                return hashId ? "".concat(hashId, "-").concat(this.name) : this.name;
            }
        }
    ]);
    return Keyframe;
}();
var $cb64545ddf8f118e$export$2e2bcd8739ae039 = $cb64545ddf8f118e$var$Keyframe;

});

parcelRegister("hfjpM", function(module, exports) {

var $eUqlC = parcelRequire("eUqlC");
function $c8e2e5c3988aca39$var$splitValues(value) {
    if (typeof value === "number") return [
        [
            value
        ],
        false
    ];
    var rawStyle = String(value).trim();
    var importantCells = rawStyle.match(/(.*)(!important)/);
    var splitStyle = (importantCells ? importantCells[1] : rawStyle).trim().split(/\s+/);
    // Combine styles split in brackets, like `calc(1px + 2px)`
    var temp = "";
    var brackets = 0;
    return [
        splitStyle.reduce(function(list, item) {
            if (item.includes("(") || item.includes(")")) {
                var left = item.split("(").length - 1;
                var right = item.split(")").length - 1;
                brackets += left - right;
            }
            if (brackets === 0) {
                list.push(temp + item);
                temp = "";
            } else if (brackets > 0) temp += item;
            return list;
        }, []),
        !!importantCells
    ];
}
function $c8e2e5c3988aca39$var$noSplit(list) {
    list.notSplit = true;
    return list;
}
var $c8e2e5c3988aca39$var$keyMap = {
    // Inset
    inset: [
        "top",
        "right",
        "bottom",
        "left"
    ],
    insetBlock: [
        "top",
        "bottom"
    ],
    insetBlockStart: [
        "top"
    ],
    insetBlockEnd: [
        "bottom"
    ],
    insetInline: [
        "left",
        "right"
    ],
    insetInlineStart: [
        "left"
    ],
    insetInlineEnd: [
        "right"
    ],
    // Margin
    marginBlock: [
        "marginTop",
        "marginBottom"
    ],
    marginBlockStart: [
        "marginTop"
    ],
    marginBlockEnd: [
        "marginBottom"
    ],
    marginInline: [
        "marginLeft",
        "marginRight"
    ],
    marginInlineStart: [
        "marginLeft"
    ],
    marginInlineEnd: [
        "marginRight"
    ],
    // Padding
    paddingBlock: [
        "paddingTop",
        "paddingBottom"
    ],
    paddingBlockStart: [
        "paddingTop"
    ],
    paddingBlockEnd: [
        "paddingBottom"
    ],
    paddingInline: [
        "paddingLeft",
        "paddingRight"
    ],
    paddingInlineStart: [
        "paddingLeft"
    ],
    paddingInlineEnd: [
        "paddingRight"
    ],
    // Border
    borderBlock: $c8e2e5c3988aca39$var$noSplit([
        "borderTop",
        "borderBottom"
    ]),
    borderBlockStart: $c8e2e5c3988aca39$var$noSplit([
        "borderTop"
    ]),
    borderBlockEnd: $c8e2e5c3988aca39$var$noSplit([
        "borderBottom"
    ]),
    borderInline: $c8e2e5c3988aca39$var$noSplit([
        "borderLeft",
        "borderRight"
    ]),
    borderInlineStart: $c8e2e5c3988aca39$var$noSplit([
        "borderLeft"
    ]),
    borderInlineEnd: $c8e2e5c3988aca39$var$noSplit([
        "borderRight"
    ]),
    // Border width
    borderBlockWidth: [
        "borderTopWidth",
        "borderBottomWidth"
    ],
    borderBlockStartWidth: [
        "borderTopWidth"
    ],
    borderBlockEndWidth: [
        "borderBottomWidth"
    ],
    borderInlineWidth: [
        "borderLeftWidth",
        "borderRightWidth"
    ],
    borderInlineStartWidth: [
        "borderLeftWidth"
    ],
    borderInlineEndWidth: [
        "borderRightWidth"
    ],
    // Border style
    borderBlockStyle: [
        "borderTopStyle",
        "borderBottomStyle"
    ],
    borderBlockStartStyle: [
        "borderTopStyle"
    ],
    borderBlockEndStyle: [
        "borderBottomStyle"
    ],
    borderInlineStyle: [
        "borderLeftStyle",
        "borderRightStyle"
    ],
    borderInlineStartStyle: [
        "borderLeftStyle"
    ],
    borderInlineEndStyle: [
        "borderRightStyle"
    ],
    // Border color
    borderBlockColor: [
        "borderTopColor",
        "borderBottomColor"
    ],
    borderBlockStartColor: [
        "borderTopColor"
    ],
    borderBlockEndColor: [
        "borderBottomColor"
    ],
    borderInlineColor: [
        "borderLeftColor",
        "borderRightColor"
    ],
    borderInlineStartColor: [
        "borderLeftColor"
    ],
    borderInlineEndColor: [
        "borderRightColor"
    ],
    // Border radius
    borderStartStartRadius: [
        "borderTopLeftRadius"
    ],
    borderStartEndRadius: [
        "borderTopRightRadius"
    ],
    borderEndStartRadius: [
        "borderBottomLeftRadius"
    ],
    borderEndEndRadius: [
        "borderBottomRightRadius"
    ]
};
function $c8e2e5c3988aca39$var$wrapImportantAndSkipCheck(value, important) {
    var parsedValue = value;
    if (important) parsedValue = "".concat(parsedValue, " !important");
    return {
        _skip_check_: true,
        value: parsedValue
    };
}
/**
 * Convert css logical properties to legacy properties.
 * Such as: `margin-block-start` to `margin-top`.
 * Transform list:
 * - inset
 * - margin
 * - padding
 * - border
 */ var $c8e2e5c3988aca39$var$transform = {
    visit: function visit(cssObj) {
        var clone = {};
        Object.keys(cssObj).forEach(function(key) {
            var value = cssObj[key];
            var matchValue = $c8e2e5c3988aca39$var$keyMap[key];
            if (matchValue && (typeof value === "number" || typeof value === "string")) {
                var _splitValues = $c8e2e5c3988aca39$var$splitValues(value), _splitValues2 = (0, $eUqlC.default)(_splitValues, 2), _values = _splitValues2[0], _important = _splitValues2[1];
                if (matchValue.length && matchValue.notSplit) // not split means always give same value like border
                matchValue.forEach(function(matchKey) {
                    clone[matchKey] = $c8e2e5c3988aca39$var$wrapImportantAndSkipCheck(value, _important);
                });
                else if (matchValue.length === 1) // Handle like `marginBlockStart` => `marginTop`
                clone[matchValue[0]] = $c8e2e5c3988aca39$var$wrapImportantAndSkipCheck(value, _important);
                else if (matchValue.length === 2) // Handle like `marginBlock` => `marginTop` & `marginBottom`
                matchValue.forEach(function(matchKey, index) {
                    var _values$index;
                    clone[matchKey] = $c8e2e5c3988aca39$var$wrapImportantAndSkipCheck((_values$index = _values[index]) !== null && _values$index !== void 0 ? _values$index : _values[0], _important);
                });
                else if (matchValue.length === 4) // Handle like `inset` => `top` & `right` & `bottom` & `left`
                matchValue.forEach(function(matchKey, index) {
                    var _ref, _values$index2;
                    clone[matchKey] = $c8e2e5c3988aca39$var$wrapImportantAndSkipCheck((_ref = (_values$index2 = _values[index]) !== null && _values$index2 !== void 0 ? _values$index2 : _values[index - 2]) !== null && _ref !== void 0 ? _ref : _values[0], _important);
                });
                else clone[key] = value;
            } else clone[key] = value;
        });
        return clone;
    }
};
var $c8e2e5c3988aca39$export$2e2bcd8739ae039 = $c8e2e5c3988aca39$var$transform;

});

parcelRegister("5h4kx", function(module, exports) {

var $eUqlC = parcelRequire("eUqlC");

var $d49SP = parcelRequire("d49SP");

var $3ycpT = parcelRequire("3ycpT");
var $3d71e62b1d8dd17b$var$pxRegex = /url\([^)]+\)|var\([^)]+\)|(\d*\.?\d+)px/g;
function $3d71e62b1d8dd17b$var$toFixed(number, precision) {
    var multiplier = Math.pow(10, precision + 1), wholeNumber = Math.floor(number * multiplier);
    return Math.round(wholeNumber / 10) * 10 / multiplier;
}
var $3d71e62b1d8dd17b$var$transform = function transform() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$rootValue = options.rootValue, rootValue = _options$rootValue === void 0 ? 16 : _options$rootValue, _options$precision = options.precision, precision = _options$precision === void 0 ? 5 : _options$precision, _options$mediaQuery = options.mediaQuery, mediaQuery = _options$mediaQuery === void 0 ? false : _options$mediaQuery;
    var pxReplace = function pxReplace(m, $1) {
        if (!$1) return m;
        var pixels = parseFloat($1);
        // covenant: pixels <= 1, not transform to rem @zombieJ
        if (pixels <= 1) return m;
        var fixedVal = $3d71e62b1d8dd17b$var$toFixed(pixels / rootValue, precision);
        return "".concat(fixedVal, "rem");
    };
    var visit = function visit(cssObj) {
        var clone = (0, $d49SP.default)({}, cssObj);
        Object.entries(cssObj).forEach(function(_ref) {
            var _ref2 = (0, $eUqlC.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
            if (typeof value === "string" && value.includes("px")) {
                var newValue = value.replace($3d71e62b1d8dd17b$var$pxRegex, pxReplace);
                clone[key] = newValue;
            }
            // no unit
            if (!(0, $3ycpT.default)[key] && typeof value === "number" && value !== 0) clone[key] = "".concat(value, "px").replace($3d71e62b1d8dd17b$var$pxRegex, pxReplace);
            // Media queries
            var mergedKey = key.trim();
            if (mergedKey.startsWith("@") && mergedKey.includes("px") && mediaQuery) {
                var newKey = key.replace($3d71e62b1d8dd17b$var$pxRegex, pxReplace);
                clone[newKey] = clone[key];
                delete clone[key];
            }
        });
        return clone;
    };
    return {
        visit: visit
    };
};
var $3d71e62b1d8dd17b$export$2e2bcd8739ae039 = $3d71e62b1d8dd17b$var$transform;

});


parcelRegister("9f9mi", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bacc63174d40f3c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $6bacc63174d40f3c$var$IconContext = /*#__PURE__*/ (0, $acw62.createContext)({});
var $6bacc63174d40f3c$export$2e2bcd8739ae039 = $6bacc63174d40f3c$var$IconContext;

});

parcelRegister("6vgkH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bc24eaedd2a47a4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "merge", () => $4bc24eaedd2a47a4$export$4950aa0f605343fb);

var $fSwVM = parcelRequire("fSwVM");

var $d49SP = parcelRequire("d49SP");

var $kbxxf = parcelRequire("kbxxf");

var $aJJ3v = parcelRequire("aJJ3v");

var $23Gye = parcelRequire("23Gye");
function $4bc24eaedd2a47a4$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    var _paths = (0, $aJJ3v.default)(paths), path = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path === "number") clone = [];
    else if (Array.isArray(entity)) clone = (0, $kbxxf.default)(entity);
    else clone = (0, $d49SP.default)({}, entity);
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $4bc24eaedd2a47a4$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $4bc24eaedd2a47a4$export$2e2bcd8739ae039(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $23Gye.default)(entity, paths.slice(0, -1))) return entity;
    return $4bc24eaedd2a47a4$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $4bc24eaedd2a47a4$var$isObject(obj) {
    return (0, $fSwVM.default)(obj) === "object" && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $4bc24eaedd2a47a4$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
var $4bc24eaedd2a47a4$var$keys = typeof Reflect === "undefined" ? Object.keys : Reflect.ownKeys;
function $4bc24eaedd2a47a4$export$4950aa0f605343fb() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    var clone = $4bc24eaedd2a47a4$var$createEmpty(sources[0]);
    sources.forEach(function(src) {
        function internalMerge(path, parentLoopSet) {
            var loopSet = new Set(parentLoopSet);
            var value = (0, $23Gye.default)(src, path);
            var isArr = Array.isArray(value);
            if (isArr || $4bc24eaedd2a47a4$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    var originValue = (0, $23Gye.default)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $4bc24eaedd2a47a4$export$2e2bcd8739ae039(clone, path, []);
                    else if (!originValue || (0, $fSwVM.default)(originValue) !== "object") // Init container if not exist
                    clone = $4bc24eaedd2a47a4$export$2e2bcd8739ae039(clone, path, $4bc24eaedd2a47a4$var$createEmpty(value));
                    $4bc24eaedd2a47a4$var$keys(value).forEach(function(key) {
                        internalMerge([].concat((0, $kbxxf.default)(path), [
                            key
                        ]), loopSet);
                    });
                }
            } else clone = $4bc24eaedd2a47a4$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}

});
parcelRegister("aJJ3v", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d110e739ae14cc6$export$2e2bcd8739ae039);

var $1uEeT = parcelRequire("1uEeT");

var $dOjF6 = parcelRequire("dOjF6");

var $abLc2 = parcelRequire("abLc2");

var $782Uh = parcelRequire("782Uh");
function $7d110e739ae14cc6$export$2e2bcd8739ae039(arr) {
    return (0, $1uEeT.default)(arr) || (0, $dOjF6.default)(arr) || (0, $abLc2.default)(arr) || (0, $782Uh.default)();
}

});

parcelRegister("23Gye", function(module, exports) {

$parcel$export(module.exports, "default", () => $17fcde5782384c29$export$2e2bcd8739ae039);
function $17fcde5782384c29$export$2e2bcd8739ae039(entity, path) {
    var current = entity;
    for(var i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}

});


parcelRegister("7SSa4", function(module, exports) {

$parcel$export(module.exports, "WarningContext", () => $5bd796dbed593bbb$export$11b88c75b33aa1fd);
$parcel$export(module.exports, "devUseWarning", () => $5bd796dbed593bbb$export$cf977aa92c751e61);

var $acw62 = parcelRequire("acw62");

var $u43uR = parcelRequire("u43uR");
function $5bd796dbed593bbb$export$8793edee2d425525() {}
let $5bd796dbed593bbb$var$deprecatedWarnList = null;
function $5bd796dbed593bbb$export$60eef1277fe463e4() {
    $5bd796dbed593bbb$var$deprecatedWarnList = null;
    (0, $u43uR.resetWarned)();
}
// eslint-disable-next-line import/no-mutable-exports
let $5bd796dbed593bbb$var$warning = $5bd796dbed593bbb$export$8793edee2d425525;
var $5bd796dbed593bbb$var$valid, $5bd796dbed593bbb$var$component, $5bd796dbed593bbb$var$message;
const $5bd796dbed593bbb$export$11b88c75b33aa1fd = /*#__PURE__*/ $acw62.createContext({});
const $5bd796dbed593bbb$export$cf977aa92c751e61 = ()=>{
    const noopWarning = ()=>{};
    noopWarning.deprecated = $5bd796dbed593bbb$export$8793edee2d425525;
    return noopWarning;
};
var $5bd796dbed593bbb$export$2e2bcd8739ae039 = $5bd796dbed593bbb$var$warning;

});

parcelRegister("kzLok", function(module, exports) {

$parcel$export(module.exports, "default", () => $efabd6732f69a6da$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
"use client";
var // ZombieJ: We export single file here since
// ConfigProvider use this which will make loop deps
// to import whole `rc-field-form`
$efabd6732f69a6da$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);

});

parcelRegister("aardd", function(module, exports) {

$parcel$export(module.exports, "ANT_MARK", () => $766ff256ac32087c$export$b2f162cd5c15ea3e);
$parcel$export(module.exports, "default", () => $766ff256ac32087c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $62TUi = parcelRequire("62TUi");

var $9qIAY = parcelRequire("9qIAY");

var $0G7XT = parcelRequire("0G7XT");
"use client";
const $766ff256ac32087c$export$b2f162cd5c15ea3e = "internalMark";
const $766ff256ac32087c$var$LocaleProvider = (props)=>{
    const { locale: locale = {}, children: children, _ANT_MARK__: _ANT_MARK__ } = props;
    $acw62.useEffect(()=>{
        const clearLocale = (0, $62TUi.changeConfirmLocale)(locale && locale.Modal);
        return clearLocale;
    }, [
        locale
    ]);
    const getMemoizedContextValue = $acw62.useMemo(()=>Object.assign(Object.assign({}, locale), {
            exist: true
        }), [
        locale
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $9qIAY.default).Provider, {
        value: getMemoizedContextValue
    }, children);
};
var $766ff256ac32087c$export$2e2bcd8739ae039 = $766ff256ac32087c$var$LocaleProvider;

});
parcelRegister("62TUi", function(module, exports) {

$parcel$export(module.exports, "changeConfirmLocale", () => $466e4bebfd7443ca$export$9485ecb9d81a550c);
$parcel$export(module.exports, "getConfirmLocale", () => $466e4bebfd7443ca$export$1b6004afda18cd51);

var $h9Mt9 = parcelRequire("h9Mt9");
"use client";
let $466e4bebfd7443ca$var$runtimeLocale = Object.assign({}, (0, $h9Mt9.default).Modal);
let $466e4bebfd7443ca$var$localeList = [];
const $466e4bebfd7443ca$var$generateLocale = ()=>$466e4bebfd7443ca$var$localeList.reduce((merged, locale)=>Object.assign(Object.assign({}, merged), locale), (0, $h9Mt9.default).Modal);
function $466e4bebfd7443ca$export$9485ecb9d81a550c(newLocale) {
    if (newLocale) {
        const cloneLocale = Object.assign({}, newLocale);
        $466e4bebfd7443ca$var$localeList.push(cloneLocale);
        $466e4bebfd7443ca$var$runtimeLocale = $466e4bebfd7443ca$var$generateLocale();
        return ()=>{
            $466e4bebfd7443ca$var$localeList = $466e4bebfd7443ca$var$localeList.filter((locale)=>locale !== cloneLocale);
            $466e4bebfd7443ca$var$runtimeLocale = $466e4bebfd7443ca$var$generateLocale();
        };
    }
    $466e4bebfd7443ca$var$runtimeLocale = Object.assign({}, (0, $h9Mt9.default).Modal);
}
function $466e4bebfd7443ca$export$1b6004afda18cd51() {
    return $466e4bebfd7443ca$var$runtimeLocale;
}

});
parcelRegister("h9Mt9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7d8dfeaf08e9faa$export$2e2bcd8739ae039);
/* eslint-disable no-template-curly-in-string */ 
var $bwViM = parcelRequire("bwViM");

var $4mMv4 = parcelRequire("4mMv4");

var $a0Ydd = parcelRequire("a0Ydd");

var $7Fi37 = parcelRequire("7Fi37");
const $c7d8dfeaf08e9faa$var$typeTemplate = "${label} is not a valid ${type}";
const $c7d8dfeaf08e9faa$var$localeValues = {
    locale: "en",
    Pagination: $bwViM.default,
    DatePicker: $a0Ydd.default,
    TimePicker: $7Fi37.default,
    Calendar: $4mMv4.default,
    global: {
        placeholder: "Please select"
    },
    Table: {
        filterTitle: "Filter menu",
        filterConfirm: "OK",
        filterReset: "Reset",
        filterEmptyText: "No filters",
        filterCheckall: "Select all items",
        filterSearchPlaceholder: "Search in filters",
        emptyText: "No data",
        selectAll: "Select current page",
        selectInvert: "Invert current page",
        selectNone: "Clear all data",
        selectionAll: "Select all data",
        sortTitle: "Sort",
        expand: "Expand row",
        collapse: "Collapse row",
        triggerDesc: "Click to sort descending",
        triggerAsc: "Click to sort ascending",
        cancelSort: "Click to cancel sorting"
    },
    Tour: {
        Next: "Next",
        Previous: "Previous",
        Finish: "Finish"
    },
    Modal: {
        okText: "OK",
        cancelText: "Cancel",
        justOkText: "OK"
    },
    Popconfirm: {
        okText: "OK",
        cancelText: "Cancel"
    },
    Transfer: {
        titles: [
            "",
            ""
        ],
        searchPlaceholder: "Search here",
        itemUnit: "item",
        itemsUnit: "items",
        remove: "Remove",
        selectCurrent: "Select current page",
        removeCurrent: "Remove current page",
        selectAll: "Select all data",
        removeAll: "Remove all data",
        selectInvert: "Invert current page"
    },
    Upload: {
        uploading: "Uploading...",
        removeFile: "Remove file",
        uploadError: "Upload error",
        previewFile: "Preview file",
        downloadFile: "Download file"
    },
    Empty: {
        description: "No data"
    },
    Icon: {
        icon: "icon"
    },
    Text: {
        edit: "Edit",
        copy: "Copy",
        copied: "Copied",
        expand: "Expand"
    },
    PageHeader: {
        back: "Back"
    },
    Form: {
        optional: "(optional)",
        defaultValidateMessages: {
            default: "Field validation error for ${label}",
            required: "Please enter ${label}",
            enum: "${label} must be one of [${enum}]",
            whitespace: "${label} cannot be a blank character",
            date: {
                format: "${label} date format is invalid",
                parse: "${label} cannot be converted to a date",
                invalid: "${label} is an invalid date"
            },
            types: {
                string: $c7d8dfeaf08e9faa$var$typeTemplate,
                method: $c7d8dfeaf08e9faa$var$typeTemplate,
                array: $c7d8dfeaf08e9faa$var$typeTemplate,
                object: $c7d8dfeaf08e9faa$var$typeTemplate,
                number: $c7d8dfeaf08e9faa$var$typeTemplate,
                date: $c7d8dfeaf08e9faa$var$typeTemplate,
                boolean: $c7d8dfeaf08e9faa$var$typeTemplate,
                integer: $c7d8dfeaf08e9faa$var$typeTemplate,
                float: $c7d8dfeaf08e9faa$var$typeTemplate,
                regexp: $c7d8dfeaf08e9faa$var$typeTemplate,
                email: $c7d8dfeaf08e9faa$var$typeTemplate,
                url: $c7d8dfeaf08e9faa$var$typeTemplate,
                hex: $c7d8dfeaf08e9faa$var$typeTemplate
            },
            string: {
                len: "${label} must be ${len} characters",
                min: "${label} must be at least ${min} characters",
                max: "${label} must be up to ${max} characters",
                range: "${label} must be between ${min}-${max} characters"
            },
            number: {
                len: "${label} must be equal to ${len}",
                min: "${label} must be minimum ${min}",
                max: "${label} must be maximum ${max}",
                range: "${label} must be between ${min}-${max}"
            },
            array: {
                len: "Must be ${len} ${label}",
                min: "At least ${min} ${label}",
                max: "At most ${max} ${label}",
                range: "The amount of ${label} must be between ${min}-${max}"
            },
            pattern: {
                mismatch: "${label} does not match the pattern ${pattern}"
            }
        }
    },
    Image: {
        preview: "Preview"
    },
    QRCode: {
        expired: "QR code expired",
        refresh: "Refresh"
    },
    ColorPicker: {
        presetEmpty: "Empty"
    }
};
var $c7d8dfeaf08e9faa$export$2e2bcd8739ae039 = $c7d8dfeaf08e9faa$var$localeValues;

});
parcelRegister("bwViM", function(module, exports) {

$parcel$export(module.exports, "default", () => $864f21d08855a737$export$2e2bcd8739ae039);
var $864f21d08855a737$var$locale = {
    // Options
    items_per_page: "/ page",
    jump_to: "Go to",
    jump_to_confirm: "confirm",
    page: "Page",
    // Pagination
    prev_page: "Previous Page",
    next_page: "Next Page",
    prev_5: "Previous 5 Pages",
    next_5: "Next 5 Pages",
    prev_3: "Previous 3 Pages",
    next_3: "Next 3 Pages",
    page_size: "Page Size"
};
var $864f21d08855a737$export$2e2bcd8739ae039 = $864f21d08855a737$var$locale;

});

parcelRegister("4mMv4", function(module, exports) {

$parcel$export(module.exports, "default", () => $32ded69f6ae6c615$export$2e2bcd8739ae039);

var $a0Ydd = parcelRequire("a0Ydd");
var $32ded69f6ae6c615$export$2e2bcd8739ae039 = (0, $a0Ydd.default);

});
parcelRegister("a0Ydd", function(module, exports) {

$parcel$export(module.exports, "default", () => $74a89c57a3cfafd2$export$2e2bcd8739ae039);

var $gaSAG = parcelRequire("gaSAG");

var $7Fi37 = parcelRequire("7Fi37");
// Merge into a locale object
const $74a89c57a3cfafd2$var$locale = {
    lang: Object.assign({
        placeholder: "Select date",
        yearPlaceholder: "Select year",
        quarterPlaceholder: "Select quarter",
        monthPlaceholder: "Select month",
        weekPlaceholder: "Select week",
        rangePlaceholder: [
            "Start date",
            "End date"
        ],
        rangeYearPlaceholder: [
            "Start year",
            "End year"
        ],
        rangeQuarterPlaceholder: [
            "Start quarter",
            "End quarter"
        ],
        rangeMonthPlaceholder: [
            "Start month",
            "End month"
        ],
        rangeWeekPlaceholder: [
            "Start week",
            "End week"
        ]
    }, (0, $gaSAG.default)),
    timePickerLocale: Object.assign({}, (0, $7Fi37.default))
};
var // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
$74a89c57a3cfafd2$export$2e2bcd8739ae039 = $74a89c57a3cfafd2$var$locale;

});
parcelRegister("gaSAG", function(module, exports) {

$parcel$export(module.exports, "default", () => $0309ef2dc8eb0939$export$2e2bcd8739ae039);
var $0309ef2dc8eb0939$var$locale = {
    locale: "en_US",
    today: "Today",
    now: "Now",
    backToToday: "Back to today",
    ok: "OK",
    clear: "Clear",
    month: "Month",
    year: "Year",
    timeSelect: "select time",
    dateSelect: "select date",
    weekSelect: "Choose a week",
    monthSelect: "Choose a month",
    yearSelect: "Choose a year",
    decadeSelect: "Choose a decade",
    yearFormat: "YYYY",
    dateFormat: "M/D/YYYY",
    dayFormat: "D",
    dateTimeFormat: "M/D/YYYY HH:mm:ss",
    monthBeforeYear: true,
    previousMonth: "Previous month (PageUp)",
    nextMonth: "Next month (PageDown)",
    previousYear: "Last year (Control + left)",
    nextYear: "Next year (Control + right)",
    previousDecade: "Last decade",
    nextDecade: "Next decade",
    previousCentury: "Last century",
    nextCentury: "Next century"
};
var $0309ef2dc8eb0939$export$2e2bcd8739ae039 = $0309ef2dc8eb0939$var$locale;

});

parcelRegister("7Fi37", function(module, exports) {

$parcel$export(module.exports, "default", () => $594a5cf7899ad7e1$export$2e2bcd8739ae039);
const $594a5cf7899ad7e1$var$locale = {
    placeholder: "Select time",
    rangePlaceholder: [
        "Start time",
        "End time"
    ]
};
var $594a5cf7899ad7e1$export$2e2bcd8739ae039 = $594a5cf7899ad7e1$var$locale;

});





parcelRegister("9qIAY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dd9227cba6de9ce$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
const $6dd9227cba6de9ce$var$LocaleContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $6dd9227cba6de9ce$export$2e2bcd8739ae039 = $6dd9227cba6de9ce$var$LocaleContext;

});

parcelRegister("0G7XT", function(module, exports) {

$parcel$export(module.exports, "default", () => $0020add6ec984361$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $9qIAY = parcelRequire("9qIAY");

var $h9Mt9 = parcelRequire("h9Mt9");
const $0020add6ec984361$var$useLocale = (componentName, defaultLocale)=>{
    const fullLocale = $acw62.useContext((0, $9qIAY.default));
    const getLocale = $acw62.useMemo(()=>{
        var _a;
        const locale = defaultLocale || (0, $h9Mt9.default)[componentName];
        const localeFromContext = (_a = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale[componentName]) !== null && _a !== void 0 ? _a : {};
        return Object.assign(Object.assign({}, typeof locale === "function" ? locale() : locale), localeFromContext || {});
    }, [
        componentName,
        defaultLocale,
        fullLocale
    ]);
    const getLocaleCode = $acw62.useMemo(()=>{
        const localeCode = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.locale;
        // Had use LocaleProvide but didn't set locale
        if ((fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.exist) && !localeCode) return (0, $h9Mt9.default).locale;
        return localeCode;
    }, [
        fullLocale
    ]);
    return [
        getLocale,
        getLocaleCode
    ];
};
var $0020add6ec984361$export$2e2bcd8739ae039 = $0020add6ec984361$var$useLocale;

});


parcelRegister("iqsy8", function(module, exports) {

$parcel$export(module.exports, "defaultTheme", () => $d6a0cd0c670c9aed$export$164de7ab8df77ef0);
$parcel$export(module.exports, "defaultConfig", () => $d6a0cd0c670c9aed$export$f84bd70098573c5c);
$parcel$export(module.exports, "DesignTokenContext", () => $d6a0cd0c670c9aed$export$69b0ebb9efcddb30);

var $acw62 = parcelRequire("acw62");
parcelRequire("3i86m");
var $iPfci = parcelRequire("iPfci");

var $1wI7H = parcelRequire("1wI7H");

var $fcQiF = parcelRequire("fcQiF");
const $d6a0cd0c670c9aed$export$164de7ab8df77ef0 = (0, $iPfci.default)((0, $1wI7H.default));
const $d6a0cd0c670c9aed$export$f84bd70098573c5c = {
    token: (0, $fcQiF.default),
    override: {
        override: (0, $fcQiF.default)
    },
    hashed: true
};
const $d6a0cd0c670c9aed$export$69b0ebb9efcddb30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($d6a0cd0c670c9aed$export$f84bd70098573c5c);

});
parcelRegister("1wI7H", function(module, exports) {

$parcel$export(module.exports, "default", () => $11cb018871a499d7$export$2e2bcd8739ae039);
parcelRequire("eIR68");
var $i1881 = parcelRequire("i1881");

var $9JyOV = parcelRequire("9JyOV");

var $hkRUC = parcelRequire("hkRUC");

var $fcQiF = parcelRequire("fcQiF");

var $lqU0w = parcelRequire("lqU0w");

var $20wgT = parcelRequire("20wgT");

var $c5lHT = parcelRequire("c5lHT");

var $1oU0E = parcelRequire("1oU0E");
function $11cb018871a499d7$export$2e2bcd8739ae039(token) {
    const colorPalettes = Object.keys((0, $fcQiF.defaultPresetColors)).map((colorKey)=>{
        const colors = (0, $i1881.default)(token[colorKey]);
        return new Array(10).fill(1).reduce((prev, _, i)=>{
            prev[`${colorKey}-${i + 1}`] = colors[i];
            prev[`${colorKey}${i + 1}`] = colors[i];
            return prev;
        }, {});
    }).reduce((prev, cur)=>{
        prev = Object.assign(Object.assign({}, prev), cur);
        return prev;
    }, {});
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, token), colorPalettes), (0, $lqU0w.default)(token, {
        generateColorPalettes: $c5lHT.generateColorPalettes,
        generateNeutralColorPalettes: $c5lHT.generateNeutralColorPalettes
    })), (0, $1oU0E.default)(token.fontSize)), (0, $hkRUC.default)(token)), (0, $9JyOV.default)(token)), (0, $20wgT.default)(token));
}

});
parcelRegister("eIR68", function(module, exports) {

$parcel$export(module.exports, "gold", () => $ab7e5ce61c1b0def$export$c24201f7fe3571d8);
$parcel$export(module.exports, "blue", () => $ab7e5ce61c1b0def$export$2aa0182783e7e9de);
$parcel$export(module.exports, "generate", () => (parcelRequire("i1881")).default);

var $i1881 = parcelRequire("i1881");
var $ab7e5ce61c1b0def$export$3968a3afc810b5f5 = {
    red: "#F5222D",
    volcano: "#FA541C",
    orange: "#FA8C16",
    gold: "#FAAD14",
    yellow: "#FADB14",
    lime: "#A0D911",
    green: "#52C41A",
    cyan: "#13C2C2",
    blue: "#1677FF",
    geekblue: "#2F54EB",
    purple: "#722ED1",
    magenta: "#EB2F96",
    grey: "#666666"
};
var $ab7e5ce61c1b0def$export$36ad6df0f83f284d = {};
var $ab7e5ce61c1b0def$export$24617255e4daf647 = {};
Object.keys($ab7e5ce61c1b0def$export$3968a3afc810b5f5).forEach(function(key) {
    $ab7e5ce61c1b0def$export$36ad6df0f83f284d[key] = (0, $i1881.default)($ab7e5ce61c1b0def$export$3968a3afc810b5f5[key]);
    $ab7e5ce61c1b0def$export$36ad6df0f83f284d[key].primary = $ab7e5ce61c1b0def$export$36ad6df0f83f284d[key][5]; // dark presetPalettes
    $ab7e5ce61c1b0def$export$24617255e4daf647[key] = (0, $i1881.default)($ab7e5ce61c1b0def$export$3968a3afc810b5f5[key], {
        theme: "dark",
        backgroundColor: "#141414"
    });
    $ab7e5ce61c1b0def$export$24617255e4daf647[key].primary = $ab7e5ce61c1b0def$export$24617255e4daf647[key][5];
});
var $ab7e5ce61c1b0def$export$a90204d1394caf30 = $ab7e5ce61c1b0def$export$36ad6df0f83f284d.red;
var $ab7e5ce61c1b0def$export$e63a1643b2f79b16 = $ab7e5ce61c1b0def$export$36ad6df0f83f284d.volcano;
var $ab7e5ce61c1b0def$export$c24201f7fe3571d8 = $ab7e5ce61c1b0def$export$36ad6df0f83f284d.gold;
var $ab7e5ce61c1b0def$export$ad766f34ace1cafd = $ab7e5ce61c1b0def$export$36ad6df0f83f284d.orange;
var $ab7e5ce61c1b0def$export$594c5a8758200c32 = $ab7e5ce61c1b0def$export$36ad6df0f83f284d.yellow;
var $ab7e5ce61c1b0def$export$221d31baf2636aad = $ab7e5ce61c1b0def$export$36ad6df0f83f284d.lime;
var $ab7e5ce61c1b0def$export$955a2ebd2fb142ae = $ab7e5ce61c1b0def$export$36ad6df0f83f284d.green;
var $ab7e5ce61c1b0def$export$7474046f446842ee = $ab7e5ce61c1b0def$export$36ad6df0f83f284d.cyan;
var $ab7e5ce61c1b0def$export$2aa0182783e7e9de = $ab7e5ce61c1b0def$export$36ad6df0f83f284d.blue;
var $ab7e5ce61c1b0def$export$4138d3aeddcbf415 = $ab7e5ce61c1b0def$export$36ad6df0f83f284d.geekblue;
var $ab7e5ce61c1b0def$export$e13cce2a2d16a9d4 = $ab7e5ce61c1b0def$export$36ad6df0f83f284d.purple;
var $ab7e5ce61c1b0def$export$2a9ca2e383622e18 = $ab7e5ce61c1b0def$export$36ad6df0f83f284d.magenta;
var $ab7e5ce61c1b0def$export$e4c89085febbc618 = $ab7e5ce61c1b0def$export$36ad6df0f83f284d.grey;
var $ab7e5ce61c1b0def$export$3e2c219d3ab79d01 = $ab7e5ce61c1b0def$export$36ad6df0f83f284d.grey;

});
parcelRegister("i1881", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1dea01cb419bab7$export$2e2bcd8739ae039);

var $5BsRb = parcelRequire("5BsRb");
var $82UWo = parcelRequire("82UWo");
var $d1dea01cb419bab7$var$hueStep = 2; // 色相阶梯
var $d1dea01cb419bab7$var$saturationStep = 0.16; // 饱和度阶梯，浅色部分
var $d1dea01cb419bab7$var$saturationStep2 = 0.05; // 饱和度阶梯，深色部分
var $d1dea01cb419bab7$var$brightnessStep1 = 0.05; // 亮度阶梯，浅色部分
var $d1dea01cb419bab7$var$brightnessStep2 = 0.15; // 亮度阶梯，深色部分
var $d1dea01cb419bab7$var$lightColorCount = 5; // 浅色数量，主色上
var $d1dea01cb419bab7$var$darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表
var $d1dea01cb419bab7$var$darkColorMap = [
    {
        index: 7,
        opacity: 0.15
    },
    {
        index: 6,
        opacity: 0.25
    },
    {
        index: 5,
        opacity: 0.3
    },
    {
        index: 5,
        opacity: 0.45
    },
    {
        index: 5,
        opacity: 0.65
    },
    {
        index: 5,
        opacity: 0.85
    },
    {
        index: 4,
        opacity: 0.9
    },
    {
        index: 3,
        opacity: 0.95
    },
    {
        index: 2,
        opacity: 0.97
    },
    {
        index: 1,
        opacity: 0.98
    }
];
// Wrapper function ported from TinyColor.prototype.toHsv
// Keep it here because of `hsv.h * 360`
function $d1dea01cb419bab7$var$toHsv(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    var hsv = (0, $82UWo.rgbToHsv)(r, g, b);
    return {
        h: hsv.h * 360,
        s: hsv.s,
        v: hsv.v
    };
} // Wrapper function ported from TinyColor.prototype.toHexString
// Keep it here because of the prefix `#`
function $d1dea01cb419bab7$var$toHex(_ref2) {
    var r = _ref2.r, g = _ref2.g, b = _ref2.b;
    return "#".concat((0, $82UWo.rgbToHex)(r, g, b, false));
} // Wrapper function ported from TinyColor.prototype.mix, not treeshakable.
// Amount in range [0, 1]
// Assume color1 & color2 has no alpha, since the following src code did so.
function $d1dea01cb419bab7$var$mix(rgb1, rgb2, amount) {
    var p = amount / 100;
    var rgb = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b
    };
    return rgb;
}
function $d1dea01cb419bab7$var$getHue(hsv, i, light) {
    var hue; // 根据色相不同，色相转向不同
    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) hue = light ? Math.round(hsv.h) - $d1dea01cb419bab7$var$hueStep * i : Math.round(hsv.h) + $d1dea01cb419bab7$var$hueStep * i;
    else hue = light ? Math.round(hsv.h) + $d1dea01cb419bab7$var$hueStep * i : Math.round(hsv.h) - $d1dea01cb419bab7$var$hueStep * i;
    if (hue < 0) hue += 360;
    else if (hue >= 360) hue -= 360;
    return hue;
}
function $d1dea01cb419bab7$var$getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) return hsv.s;
    var saturation;
    if (light) saturation = hsv.s - $d1dea01cb419bab7$var$saturationStep * i;
    else if (i === $d1dea01cb419bab7$var$darkColorCount) saturation = hsv.s + $d1dea01cb419bab7$var$saturationStep;
    else saturation = hsv.s + $d1dea01cb419bab7$var$saturationStep2 * i;
     // 边界值修正
    if (saturation > 1) saturation = 1;
     // 第一格的 s 限制在 0.06-0.1 之间
    if (light && i === $d1dea01cb419bab7$var$lightColorCount && saturation > 0.1) saturation = 0.1;
    if (saturation < 0.06) saturation = 0.06;
    return Number(saturation.toFixed(2));
}
function $d1dea01cb419bab7$var$getValue(hsv, i, light) {
    var value;
    if (light) value = hsv.v + $d1dea01cb419bab7$var$brightnessStep1 * i;
    else value = hsv.v - $d1dea01cb419bab7$var$brightnessStep2 * i;
    if (value > 1) value = 1;
    return Number(value.toFixed(2));
}
function $d1dea01cb419bab7$export$2e2bcd8739ae039(color) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var patterns = [];
    var pColor = (0, $5BsRb.inputToRGB)(color);
    for(var i = $d1dea01cb419bab7$var$lightColorCount; i > 0; i -= 1){
        var hsv = $d1dea01cb419bab7$var$toHsv(pColor);
        var colorString = $d1dea01cb419bab7$var$toHex((0, $5BsRb.inputToRGB)({
            h: $d1dea01cb419bab7$var$getHue(hsv, i, true),
            s: $d1dea01cb419bab7$var$getSaturation(hsv, i, true),
            v: $d1dea01cb419bab7$var$getValue(hsv, i, true)
        }));
        patterns.push(colorString);
    }
    patterns.push($d1dea01cb419bab7$var$toHex(pColor));
    for(var _i = 1; _i <= $d1dea01cb419bab7$var$darkColorCount; _i += 1){
        var _hsv = $d1dea01cb419bab7$var$toHsv(pColor);
        var _colorString = $d1dea01cb419bab7$var$toHex((0, $5BsRb.inputToRGB)({
            h: $d1dea01cb419bab7$var$getHue(_hsv, _i),
            s: $d1dea01cb419bab7$var$getSaturation(_hsv, _i),
            v: $d1dea01cb419bab7$var$getValue(_hsv, _i)
        }));
        patterns.push(_colorString);
    } // dark theme patterns
    if (opts.theme === "dark") return $d1dea01cb419bab7$var$darkColorMap.map(function(_ref3) {
        var index = _ref3.index, opacity = _ref3.opacity;
        var darkColorString = $d1dea01cb419bab7$var$toHex($d1dea01cb419bab7$var$mix((0, $5BsRb.inputToRGB)(opts.backgroundColor || "#141414"), (0, $5BsRb.inputToRGB)(patterns[index]), opacity * 100));
        return darkColorString;
    });
    return patterns;
}

});
parcelRegister("5BsRb", function(module, exports) {

$parcel$export(module.exports, "inputToRGB", () => $4146cacf0fc753c3$export$87de337d8199f22c);
/* eslint-disable @typescript-eslint/no-redundant-type-constituents */ 
var $82UWo = parcelRequire("82UWo");

var $aErMP = parcelRequire("aErMP");

var $bPjXA = parcelRequire("bPjXA");
function $4146cacf0fc753c3$export$87de337d8199f22c(color) {
    var rgb = {
        r: 0,
        g: 0,
        b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color === "string") color = $4146cacf0fc753c3$export$56237d872eed15a0(color);
    if (typeof color === "object") {
        if ($4146cacf0fc753c3$export$80d4d71a83d4526d(color.r) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.g) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.b)) {
            rgb = (0, $82UWo.rgbToRgb)(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        } else if ($4146cacf0fc753c3$export$80d4d71a83d4526d(color.h) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.s) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.v)) {
            s = (0, $bPjXA.convertToPercentage)(color.s);
            v = (0, $bPjXA.convertToPercentage)(color.v);
            rgb = (0, $82UWo.hsvToRgb)(color.h, s, v);
            ok = true;
            format = "hsv";
        } else if ($4146cacf0fc753c3$export$80d4d71a83d4526d(color.h) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.s) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.l)) {
            s = (0, $bPjXA.convertToPercentage)(color.s);
            l = (0, $bPjXA.convertToPercentage)(color.l);
            rgb = (0, $82UWo.hslToRgb)(color.h, s, l);
            ok = true;
            format = "hsl";
        }
        if (Object.prototype.hasOwnProperty.call(color, "a")) a = color.a;
    }
    a = (0, $bPjXA.boundAlpha)(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a
    };
}
// <http://www.w3.org/TR/css3-values/#integers>
var $4146cacf0fc753c3$var$CSS_INTEGER = "[-\\+]?\\d+%?";
// <http://www.w3.org/TR/css3-values/#number-value>
var $4146cacf0fc753c3$var$CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
// Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
var $4146cacf0fc753c3$var$CSS_UNIT = "(?:".concat($4146cacf0fc753c3$var$CSS_NUMBER, ")|(?:").concat($4146cacf0fc753c3$var$CSS_INTEGER, ")");
// Actual matching.
// Parentheses and commas are optional, but not required.
// Whitespace can take the place of commas or opening paren
var $4146cacf0fc753c3$var$PERMISSIVE_MATCH3 = "[\\s|\\(]+(".concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")\\s*\\)?");
var $4146cacf0fc753c3$var$PERMISSIVE_MATCH4 = "[\\s|\\(]+(".concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")\\s*\\)?");
var $4146cacf0fc753c3$var$matchers = {
    CSS_UNIT: new RegExp($4146cacf0fc753c3$var$CSS_UNIT),
    rgb: new RegExp("rgb" + $4146cacf0fc753c3$var$PERMISSIVE_MATCH3),
    rgba: new RegExp("rgba" + $4146cacf0fc753c3$var$PERMISSIVE_MATCH4),
    hsl: new RegExp("hsl" + $4146cacf0fc753c3$var$PERMISSIVE_MATCH3),
    hsla: new RegExp("hsla" + $4146cacf0fc753c3$var$PERMISSIVE_MATCH4),
    hsv: new RegExp("hsv" + $4146cacf0fc753c3$var$PERMISSIVE_MATCH3),
    hsva: new RegExp("hsva" + $4146cacf0fc753c3$var$PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function $4146cacf0fc753c3$export$56237d872eed15a0(color) {
    color = color.trim().toLowerCase();
    if (color.length === 0) return false;
    var named = false;
    if ((0, $aErMP.names)[color]) {
        color = (0, $aErMP.names)[color];
        named = true;
    } else if (color === "transparent") return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
    };
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match = $4146cacf0fc753c3$var$matchers.rgb.exec(color);
    if (match) return {
        r: match[1],
        g: match[2],
        b: match[3]
    };
    match = $4146cacf0fc753c3$var$matchers.rgba.exec(color);
    if (match) return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
    };
    match = $4146cacf0fc753c3$var$matchers.hsl.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        l: match[3]
    };
    match = $4146cacf0fc753c3$var$matchers.hsla.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
    };
    match = $4146cacf0fc753c3$var$matchers.hsv.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        v: match[3]
    };
    match = $4146cacf0fc753c3$var$matchers.hsva.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
    };
    match = $4146cacf0fc753c3$var$matchers.hex8.exec(color);
    if (match) return {
        r: (0, $82UWo.parseIntFromHex)(match[1]),
        g: (0, $82UWo.parseIntFromHex)(match[2]),
        b: (0, $82UWo.parseIntFromHex)(match[3]),
        a: (0, $82UWo.convertHexToDecimal)(match[4]),
        format: named ? "name" : "hex8"
    };
    match = $4146cacf0fc753c3$var$matchers.hex6.exec(color);
    if (match) return {
        r: (0, $82UWo.parseIntFromHex)(match[1]),
        g: (0, $82UWo.parseIntFromHex)(match[2]),
        b: (0, $82UWo.parseIntFromHex)(match[3]),
        format: named ? "name" : "hex"
    };
    match = $4146cacf0fc753c3$var$matchers.hex4.exec(color);
    if (match) return {
        r: (0, $82UWo.parseIntFromHex)(match[1] + match[1]),
        g: (0, $82UWo.parseIntFromHex)(match[2] + match[2]),
        b: (0, $82UWo.parseIntFromHex)(match[3] + match[3]),
        a: (0, $82UWo.convertHexToDecimal)(match[4] + match[4]),
        format: named ? "name" : "hex8"
    };
    match = $4146cacf0fc753c3$var$matchers.hex3.exec(color);
    if (match) return {
        r: (0, $82UWo.parseIntFromHex)(match[1] + match[1]),
        g: (0, $82UWo.parseIntFromHex)(match[2] + match[2]),
        b: (0, $82UWo.parseIntFromHex)(match[3] + match[3]),
        format: named ? "name" : "hex"
    };
    return false;
}
function $4146cacf0fc753c3$export$80d4d71a83d4526d(color) {
    return Boolean($4146cacf0fc753c3$var$matchers.CSS_UNIT.exec(String(color)));
}

});
parcelRegister("82UWo", function(module, exports) {

$parcel$export(module.exports, "rgbToRgb", () => $5dbaaddf372549d4$export$1a0d7f039f803cb);
$parcel$export(module.exports, "rgbToHsl", () => $5dbaaddf372549d4$export$c85ca4f4753af384);
$parcel$export(module.exports, "hslToRgb", () => $5dbaaddf372549d4$export$29fb7152bd3f781a);
$parcel$export(module.exports, "rgbToHsv", () => $5dbaaddf372549d4$export$f76e85ca00a47f5c);
$parcel$export(module.exports, "hsvToRgb", () => $5dbaaddf372549d4$export$210753cfeec758a5);
$parcel$export(module.exports, "rgbToHex", () => $5dbaaddf372549d4$export$34d09c4a771c46ef);
$parcel$export(module.exports, "rgbaToHex", () => $5dbaaddf372549d4$export$ffee5509a14af63d);
$parcel$export(module.exports, "convertHexToDecimal", () => $5dbaaddf372549d4$export$616da979ad1c2414);
$parcel$export(module.exports, "parseIntFromHex", () => $5dbaaddf372549d4$export$262b3ba788b4d07c);
$parcel$export(module.exports, "numberInputToObject", () => $5dbaaddf372549d4$export$4076ec82b665900d);

var $bPjXA = parcelRequire("bPjXA");
function $5dbaaddf372549d4$export$1a0d7f039f803cb(r, g, b) {
    return {
        r: (0, $bPjXA.bound01)(r, 255) * 255,
        g: (0, $bPjXA.bound01)(g, 255) * 255,
        b: (0, $bPjXA.bound01)(b, 255) * 255
    };
}
function $5dbaaddf372549d4$export$c85ca4f4753af384(r, g, b) {
    r = (0, $bPjXA.bound01)(r, 255);
    g = (0, $bPjXA.bound01)(g, 255);
    b = (0, $bPjXA.bound01)(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var s = 0;
    var l = (max + min) / 2;
    if (max === min) {
        s = 0;
        h = 0; // achromatic
    } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
function $5dbaaddf372549d4$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * (6 * t);
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $5dbaaddf372549d4$export$29fb7152bd3f781a(h, s, l) {
    var r;
    var g;
    var b;
    h = (0, $bPjXA.bound01)(h, 360);
    s = (0, $bPjXA.bound01)(s, 100);
    l = (0, $bPjXA.bound01)(l, 100);
    if (s === 0) {
        // achromatic
        g = l;
        b = l;
        r = l;
    } else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = $5dbaaddf372549d4$var$hue2rgb(p, q, h + 1 / 3);
        g = $5dbaaddf372549d4$var$hue2rgb(p, q, h);
        b = $5dbaaddf372549d4$var$hue2rgb(p, q, h - 1 / 3);
    }
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
function $5dbaaddf372549d4$export$f76e85ca00a47f5c(r, g, b) {
    r = (0, $bPjXA.bound01)(r, 255);
    g = (0, $bPjXA.bound01)(g, 255);
    b = (0, $bPjXA.bound01)(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var v = max;
    var d = max - min;
    var s = max === 0 ? 0 : d / max;
    if (max === min) h = 0; // achromatic
    else {
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        v: v
    };
}
function $5dbaaddf372549d4$export$210753cfeec758a5(h, s, v) {
    h = (0, $bPjXA.bound01)(h, 360) * 6;
    s = (0, $bPjXA.bound01)(s, 100);
    v = (0, $bPjXA.bound01)(v, 100);
    var i = Math.floor(h);
    var f = h - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    var mod = i % 6;
    var r = [
        v,
        q,
        p,
        p,
        t,
        v
    ][mod];
    var g = [
        t,
        v,
        v,
        q,
        p,
        p
    ][mod];
    var b = [
        p,
        p,
        t,
        v,
        v,
        q
    ][mod];
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
function $5dbaaddf372549d4$export$34d09c4a771c46ef(r, g, b, allow3Char) {
    var hex = [
        (0, $bPjXA.pad2)(Math.round(r).toString(16)),
        (0, $bPjXA.pad2)(Math.round(g).toString(16)),
        (0, $bPjXA.pad2)(Math.round(b).toString(16))
    ];
    // Return a 3 character hex if possible
    if (allow3Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1))) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    return hex.join("");
}
function $5dbaaddf372549d4$export$ffee5509a14af63d(r, g, b, a, allow4Char) {
    var hex = [
        (0, $bPjXA.pad2)(Math.round(r).toString(16)),
        (0, $bPjXA.pad2)(Math.round(g).toString(16)),
        (0, $bPjXA.pad2)(Math.round(b).toString(16)),
        (0, $bPjXA.pad2)($5dbaaddf372549d4$export$51dcdea396f3aff6(a))
    ];
    // Return a 4 character hex if possible
    if (allow4Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1)) && hex[3].startsWith(hex[3].charAt(1))) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    return hex.join("");
}
function $5dbaaddf372549d4$export$ce6645f7d73030f4(r, g, b, a) {
    var hex = [
        (0, $bPjXA.pad2)($5dbaaddf372549d4$export$51dcdea396f3aff6(a)),
        (0, $bPjXA.pad2)(Math.round(r).toString(16)),
        (0, $bPjXA.pad2)(Math.round(g).toString(16)),
        (0, $bPjXA.pad2)(Math.round(b).toString(16))
    ];
    return hex.join("");
}
function $5dbaaddf372549d4$export$51dcdea396f3aff6(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
function $5dbaaddf372549d4$export$616da979ad1c2414(h) {
    return $5dbaaddf372549d4$export$262b3ba788b4d07c(h) / 255;
}
function $5dbaaddf372549d4$export$262b3ba788b4d07c(val) {
    return parseInt(val, 16);
}
function $5dbaaddf372549d4$export$4076ec82b665900d(color) {
    return {
        r: color >> 16,
        g: (color & 0xff00) >> 8,
        b: color & 0xff
    };
}

});
parcelRegister("bPjXA", function(module, exports) {

$parcel$export(module.exports, "bound01", () => $89c3f0c2cde0477f$export$b0e60b43d1d059f0);
$parcel$export(module.exports, "clamp01", () => $89c3f0c2cde0477f$export$5c5ee632c52bc4a2);
$parcel$export(module.exports, "boundAlpha", () => $89c3f0c2cde0477f$export$3ae665204365318d);
$parcel$export(module.exports, "convertToPercentage", () => $89c3f0c2cde0477f$export$8ba0754c08bd5ca8);
$parcel$export(module.exports, "pad2", () => $89c3f0c2cde0477f$export$9decc9dc70e2c76f);
/**
 * Take input from [0, n] and return it as [0, 1]
 * @hidden
 */ function $89c3f0c2cde0477f$export$b0e60b43d1d059f0(n, max) {
    if ($89c3f0c2cde0477f$export$7bf7d6849640691b(n)) n = "100%";
    var isPercent = $89c3f0c2cde0477f$export$d86432a85610ea90(n);
    n = max === 360 ? n : Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (isPercent) n = parseInt(String(n * max), 10) / 100;
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) return 1;
    // Convert into [0, 1] range if it isn't already
    if (max === 360) // If n is a hue given in degrees,
    // wrap around out-of-range values into [0, 360] range
    // then convert into [0, 1].
    n = (n < 0 ? n % max + max : n % max) / parseFloat(String(max));
    else // If n not a hue given in degrees
    // Convert into [0, 1] range if it isn't already.
    n = n % max / parseFloat(String(max));
    return n;
}
function $89c3f0c2cde0477f$export$5c5ee632c52bc4a2(val) {
    return Math.min(1, Math.max(0, val));
}
function $89c3f0c2cde0477f$export$7bf7d6849640691b(n) {
    return typeof n === "string" && n.indexOf(".") !== -1 && parseFloat(n) === 1;
}
function $89c3f0c2cde0477f$export$d86432a85610ea90(n) {
    return typeof n === "string" && n.indexOf("%") !== -1;
}
function $89c3f0c2cde0477f$export$3ae665204365318d(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) a = 1;
    return a;
}
function $89c3f0c2cde0477f$export$8ba0754c08bd5ca8(n) {
    if (n <= 1) return "".concat(Number(n) * 100, "%");
    return n;
}
function $89c3f0c2cde0477f$export$9decc9dc70e2c76f(c) {
    return c.length === 1 ? "0" + c : String(c);
}

});


parcelRegister("aErMP", function(module, exports) {

$parcel$export(module.exports, "names", () => $7c1331a6b98e7de3$export$e4b2ac9215619f8d);
// https://github.com/bahamas10/css-color-names/blob/master/css-color-names.json
/**
 * @hidden
 */ var $7c1331a6b98e7de3$export$e4b2ac9215619f8d = {
    aliceblue: "#f0f8ff",
    antiquewhite: "#faebd7",
    aqua: "#00ffff",
    aquamarine: "#7fffd4",
    azure: "#f0ffff",
    beige: "#f5f5dc",
    bisque: "#ffe4c4",
    black: "#000000",
    blanchedalmond: "#ffebcd",
    blue: "#0000ff",
    blueviolet: "#8a2be2",
    brown: "#a52a2a",
    burlywood: "#deb887",
    cadetblue: "#5f9ea0",
    chartreuse: "#7fff00",
    chocolate: "#d2691e",
    coral: "#ff7f50",
    cornflowerblue: "#6495ed",
    cornsilk: "#fff8dc",
    crimson: "#dc143c",
    cyan: "#00ffff",
    darkblue: "#00008b",
    darkcyan: "#008b8b",
    darkgoldenrod: "#b8860b",
    darkgray: "#a9a9a9",
    darkgreen: "#006400",
    darkgrey: "#a9a9a9",
    darkkhaki: "#bdb76b",
    darkmagenta: "#8b008b",
    darkolivegreen: "#556b2f",
    darkorange: "#ff8c00",
    darkorchid: "#9932cc",
    darkred: "#8b0000",
    darksalmon: "#e9967a",
    darkseagreen: "#8fbc8f",
    darkslateblue: "#483d8b",
    darkslategray: "#2f4f4f",
    darkslategrey: "#2f4f4f",
    darkturquoise: "#00ced1",
    darkviolet: "#9400d3",
    deeppink: "#ff1493",
    deepskyblue: "#00bfff",
    dimgray: "#696969",
    dimgrey: "#696969",
    dodgerblue: "#1e90ff",
    firebrick: "#b22222",
    floralwhite: "#fffaf0",
    forestgreen: "#228b22",
    fuchsia: "#ff00ff",
    gainsboro: "#dcdcdc",
    ghostwhite: "#f8f8ff",
    goldenrod: "#daa520",
    gold: "#ffd700",
    gray: "#808080",
    green: "#008000",
    greenyellow: "#adff2f",
    grey: "#808080",
    honeydew: "#f0fff0",
    hotpink: "#ff69b4",
    indianred: "#cd5c5c",
    indigo: "#4b0082",
    ivory: "#fffff0",
    khaki: "#f0e68c",
    lavenderblush: "#fff0f5",
    lavender: "#e6e6fa",
    lawngreen: "#7cfc00",
    lemonchiffon: "#fffacd",
    lightblue: "#add8e6",
    lightcoral: "#f08080",
    lightcyan: "#e0ffff",
    lightgoldenrodyellow: "#fafad2",
    lightgray: "#d3d3d3",
    lightgreen: "#90ee90",
    lightgrey: "#d3d3d3",
    lightpink: "#ffb6c1",
    lightsalmon: "#ffa07a",
    lightseagreen: "#20b2aa",
    lightskyblue: "#87cefa",
    lightslategray: "#778899",
    lightslategrey: "#778899",
    lightsteelblue: "#b0c4de",
    lightyellow: "#ffffe0",
    lime: "#00ff00",
    limegreen: "#32cd32",
    linen: "#faf0e6",
    magenta: "#ff00ff",
    maroon: "#800000",
    mediumaquamarine: "#66cdaa",
    mediumblue: "#0000cd",
    mediumorchid: "#ba55d3",
    mediumpurple: "#9370db",
    mediumseagreen: "#3cb371",
    mediumslateblue: "#7b68ee",
    mediumspringgreen: "#00fa9a",
    mediumturquoise: "#48d1cc",
    mediumvioletred: "#c71585",
    midnightblue: "#191970",
    mintcream: "#f5fffa",
    mistyrose: "#ffe4e1",
    moccasin: "#ffe4b5",
    navajowhite: "#ffdead",
    navy: "#000080",
    oldlace: "#fdf5e6",
    olive: "#808000",
    olivedrab: "#6b8e23",
    orange: "#ffa500",
    orangered: "#ff4500",
    orchid: "#da70d6",
    palegoldenrod: "#eee8aa",
    palegreen: "#98fb98",
    paleturquoise: "#afeeee",
    palevioletred: "#db7093",
    papayawhip: "#ffefd5",
    peachpuff: "#ffdab9",
    peru: "#cd853f",
    pink: "#ffc0cb",
    plum: "#dda0dd",
    powderblue: "#b0e0e6",
    purple: "#800080",
    rebeccapurple: "#663399",
    red: "#ff0000",
    rosybrown: "#bc8f8f",
    royalblue: "#4169e1",
    saddlebrown: "#8b4513",
    salmon: "#fa8072",
    sandybrown: "#f4a460",
    seagreen: "#2e8b57",
    seashell: "#fff5ee",
    sienna: "#a0522d",
    silver: "#c0c0c0",
    skyblue: "#87ceeb",
    slateblue: "#6a5acd",
    slategray: "#708090",
    slategrey: "#708090",
    snow: "#fffafa",
    springgreen: "#00ff7f",
    steelblue: "#4682b4",
    tan: "#d2b48c",
    teal: "#008080",
    thistle: "#d8bfd8",
    tomato: "#ff6347",
    turquoise: "#40e0d0",
    violet: "#ee82ee",
    wheat: "#f5deb3",
    white: "#ffffff",
    whitesmoke: "#f5f5f5",
    yellow: "#ffff00",
    yellowgreen: "#9acd32"
};

});




parcelRegister("9JyOV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7163539f10d66a74$export$2e2bcd8739ae039);
const $7163539f10d66a74$var$genControlHeight = (token)=>{
    const { controlHeight: controlHeight } = token;
    return {
        controlHeightSM: controlHeight * 0.75,
        controlHeightXS: controlHeight * 0.5,
        controlHeightLG: controlHeight * 1.25
    };
};
var $7163539f10d66a74$export$2e2bcd8739ae039 = $7163539f10d66a74$var$genControlHeight;

});

parcelRegister("hkRUC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9ee1fc436061bcb$export$2e2bcd8739ae039);
function $c9ee1fc436061bcb$export$2e2bcd8739ae039(token) {
    const { sizeUnit: sizeUnit, sizeStep: sizeStep } = token;
    return {
        sizeXXL: sizeUnit * (sizeStep + 8),
        // 48
        sizeXL: sizeUnit * (sizeStep + 4),
        // 32
        sizeLG: sizeUnit * (sizeStep + 2),
        // 24
        sizeMD: sizeUnit * (sizeStep + 1),
        // 20
        sizeMS: sizeUnit * sizeStep,
        // 16
        size: sizeUnit * sizeStep,
        // 16
        sizeSM: sizeUnit * (sizeStep - 1),
        // 12
        sizeXS: sizeUnit * (sizeStep - 2),
        // 8
        sizeXXS: sizeUnit * (sizeStep - 3 // 4
        )
    };
}

});

parcelRegister("fcQiF", function(module, exports) {

$parcel$export(module.exports, "defaultPresetColors", () => $b1208bbc03407e2e$export$37e27b43af4d16eb);
$parcel$export(module.exports, "default", () => $b1208bbc03407e2e$export$2e2bcd8739ae039);
const $b1208bbc03407e2e$export$37e27b43af4d16eb = {
    blue: "#1677ff",
    purple: "#722ED1",
    cyan: "#13C2C2",
    green: "#52C41A",
    magenta: "#EB2F96",
    pink: "#eb2f96",
    red: "#F5222D",
    orange: "#FA8C16",
    yellow: "#FADB14",
    volcano: "#FA541C",
    geekblue: "#2F54EB",
    gold: "#FAAD14",
    lime: "#A0D911"
};
const $b1208bbc03407e2e$var$seedToken = Object.assign(Object.assign({}, $b1208bbc03407e2e$export$37e27b43af4d16eb), {
    // Color
    colorPrimary: "#1677ff",
    colorSuccess: "#52c41a",
    colorWarning: "#faad14",
    colorError: "#ff4d4f",
    colorInfo: "#1677ff",
    colorLink: "",
    colorTextBase: "",
    colorBgBase: "",
    // Font
    fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
    fontFamilyCode: `'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace`,
    fontSize: 14,
    // Line
    lineWidth: 1,
    lineType: "solid",
    // Motion
    motionUnit: 0.1,
    motionBase: 0,
    motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
    motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
    motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
    motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
    motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
    motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
    motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
    motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
    // Radius
    borderRadius: 6,
    // Size
    sizeUnit: 4,
    sizeStep: 4,
    sizePopupArrow: 16,
    // Control Base
    controlHeight: 32,
    // zIndex
    zIndexBase: 0,
    zIndexPopupBase: 1000,
    // Image
    opacityImage: 1,
    // Wireframe
    wireframe: false,
    // Motion
    motion: true
});
var $b1208bbc03407e2e$export$2e2bcd8739ae039 = $b1208bbc03407e2e$var$seedToken;

});

parcelRegister("lqU0w", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9a7789ccb5ebec2$export$2e2bcd8739ae039);

var $9nbKF = parcelRequire("9nbKF");
function $f9a7789ccb5ebec2$export$2e2bcd8739ae039(seed, _ref) {
    let { generateColorPalettes: generateColorPalettes, generateNeutralColorPalettes: generateNeutralColorPalettes } = _ref;
    const { colorSuccess: colorSuccessBase, colorWarning: colorWarningBase, colorError: colorErrorBase, colorInfo: colorInfoBase, colorPrimary: colorPrimaryBase, colorBgBase: colorBgBase, colorTextBase: colorTextBase } = seed;
    const primaryColors = generateColorPalettes(colorPrimaryBase);
    const successColors = generateColorPalettes(colorSuccessBase);
    const warningColors = generateColorPalettes(colorWarningBase);
    const errorColors = generateColorPalettes(colorErrorBase);
    const infoColors = generateColorPalettes(colorInfoBase);
    const neutralColors = generateNeutralColorPalettes(colorBgBase, colorTextBase);
    // Color Link
    const colorLink = seed.colorLink || seed.colorInfo;
    const linkColors = generateColorPalettes(colorLink);
    return Object.assign(Object.assign({}, neutralColors), {
        colorPrimaryBg: primaryColors[1],
        colorPrimaryBgHover: primaryColors[2],
        colorPrimaryBorder: primaryColors[3],
        colorPrimaryBorderHover: primaryColors[4],
        colorPrimaryHover: primaryColors[5],
        colorPrimary: primaryColors[6],
        colorPrimaryActive: primaryColors[7],
        colorPrimaryTextHover: primaryColors[8],
        colorPrimaryText: primaryColors[9],
        colorPrimaryTextActive: primaryColors[10],
        colorSuccessBg: successColors[1],
        colorSuccessBgHover: successColors[2],
        colorSuccessBorder: successColors[3],
        colorSuccessBorderHover: successColors[4],
        colorSuccessHover: successColors[4],
        colorSuccess: successColors[6],
        colorSuccessActive: successColors[7],
        colorSuccessTextHover: successColors[8],
        colorSuccessText: successColors[9],
        colorSuccessTextActive: successColors[10],
        colorErrorBg: errorColors[1],
        colorErrorBgHover: errorColors[2],
        colorErrorBorder: errorColors[3],
        colorErrorBorderHover: errorColors[4],
        colorErrorHover: errorColors[5],
        colorError: errorColors[6],
        colorErrorActive: errorColors[7],
        colorErrorTextHover: errorColors[8],
        colorErrorText: errorColors[9],
        colorErrorTextActive: errorColors[10],
        colorWarningBg: warningColors[1],
        colorWarningBgHover: warningColors[2],
        colorWarningBorder: warningColors[3],
        colorWarningBorderHover: warningColors[4],
        colorWarningHover: warningColors[4],
        colorWarning: warningColors[6],
        colorWarningActive: warningColors[7],
        colorWarningTextHover: warningColors[8],
        colorWarningText: warningColors[9],
        colorWarningTextActive: warningColors[10],
        colorInfoBg: infoColors[1],
        colorInfoBgHover: infoColors[2],
        colorInfoBorder: infoColors[3],
        colorInfoBorderHover: infoColors[4],
        colorInfoHover: infoColors[4],
        colorInfo: infoColors[6],
        colorInfoActive: infoColors[7],
        colorInfoTextHover: infoColors[8],
        colorInfoText: infoColors[9],
        colorInfoTextActive: infoColors[10],
        colorLinkHover: linkColors[4],
        colorLink: linkColors[6],
        colorLinkActive: linkColors[7],
        colorBgMask: new (0, $9nbKF.TinyColor)("#000").setAlpha(0.45).toRgbString(),
        colorWhite: "#fff"
    });
}

});
parcelRegister("9nbKF", function(module, exports) {

$parcel$export(module.exports, "TinyColor", () => $6d2f60b2591128fc$export$d850312fc213f33e);

var $82UWo = parcelRequire("82UWo");

var $aErMP = parcelRequire("aErMP");

var $5BsRb = parcelRequire("5BsRb");

var $bPjXA = parcelRequire("bPjXA");
var $6d2f60b2591128fc$export$d850312fc213f33e = /** @class */ function() {
    function TinyColor(color, opts) {
        if (color === void 0) color = "";
        if (opts === void 0) opts = {};
        var _a;
        // If input is already a tinycolor, return itself
        if (color instanceof TinyColor) // eslint-disable-next-line no-constructor-return
        return color;
        if (typeof color === "number") color = (0, $82UWo.numberInputToObject)(color);
        this.originalInput = color;
        var rgb = (0, $5BsRb.inputToRGB)(color);
        this.originalInput = color;
        this.r = rgb.r;
        this.g = rgb.g;
        this.b = rgb.b;
        this.a = rgb.a;
        this.roundA = Math.round(100 * this.a) / 100;
        this.format = (_a = opts.format) !== null && _a !== void 0 ? _a : rgb.format;
        this.gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this.r < 1) this.r = Math.round(this.r);
        if (this.g < 1) this.g = Math.round(this.g);
        if (this.b < 1) this.b = Math.round(this.b);
        this.isValid = rgb.ok;
    }
    TinyColor.prototype.isDark = function() {
        return this.getBrightness() < 128;
    };
    TinyColor.prototype.isLight = function() {
        return !this.isDark();
    };
    /**
     * Returns the perceived brightness of the color, from 0-255.
     */ TinyColor.prototype.getBrightness = function() {
        // http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    };
    /**
     * Returns the perceived luminance of a color, from 0-1.
     */ TinyColor.prototype.getLuminance = function() {
        // http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var R;
        var G;
        var B;
        var RsRGB = rgb.r / 255;
        var GsRGB = rgb.g / 255;
        var BsRGB = rgb.b / 255;
        if (RsRGB <= 0.03928) R = RsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        if (GsRGB <= 0.03928) G = GsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        if (BsRGB <= 0.03928) B = BsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    };
    /**
     * Returns the alpha value of a color, from 0-1.
     */ TinyColor.prototype.getAlpha = function() {
        return this.a;
    };
    /**
     * Sets the alpha value on the current color.
     *
     * @param alpha - The new alpha value. The accepted range is 0-1.
     */ TinyColor.prototype.setAlpha = function(alpha) {
        this.a = (0, $bPjXA.boundAlpha)(alpha);
        this.roundA = Math.round(100 * this.a) / 100;
        return this;
    };
    /**
     * Returns whether the color is monochrome.
     */ TinyColor.prototype.isMonochrome = function() {
        var s = this.toHsl().s;
        return s === 0;
    };
    /**
     * Returns the object as a HSVA object.
     */ TinyColor.prototype.toHsv = function() {
        var hsv = (0, $82UWo.rgbToHsv)(this.r, this.g, this.b);
        return {
            h: hsv.h * 360,
            s: hsv.s,
            v: hsv.v,
            a: this.a
        };
    };
    /**
     * Returns the hsva values interpolated into a string with the following format:
     * "hsva(xxx, xxx, xxx, xx)".
     */ TinyColor.prototype.toHsvString = function() {
        var hsv = (0, $82UWo.rgbToHsv)(this.r, this.g, this.b);
        var h = Math.round(hsv.h * 360);
        var s = Math.round(hsv.s * 100);
        var v = Math.round(hsv.v * 100);
        return this.a === 1 ? "hsv(".concat(h, ", ").concat(s, "%, ").concat(v, "%)") : "hsva(".concat(h, ", ").concat(s, "%, ").concat(v, "%, ").concat(this.roundA, ")");
    };
    /**
     * Returns the object as a HSLA object.
     */ TinyColor.prototype.toHsl = function() {
        var hsl = (0, $82UWo.rgbToHsl)(this.r, this.g, this.b);
        return {
            h: hsl.h * 360,
            s: hsl.s,
            l: hsl.l,
            a: this.a
        };
    };
    /**
     * Returns the hsla values interpolated into a string with the following format:
     * "hsla(xxx, xxx, xxx, xx)".
     */ TinyColor.prototype.toHslString = function() {
        var hsl = (0, $82UWo.rgbToHsl)(this.r, this.g, this.b);
        var h = Math.round(hsl.h * 360);
        var s = Math.round(hsl.s * 100);
        var l = Math.round(hsl.l * 100);
        return this.a === 1 ? "hsl(".concat(h, ", ").concat(s, "%, ").concat(l, "%)") : "hsla(".concat(h, ", ").concat(s, "%, ").concat(l, "%, ").concat(this.roundA, ")");
    };
    /**
     * Returns the hex value of the color.
     * @param allow3Char will shorten hex value to 3 char if possible
     */ TinyColor.prototype.toHex = function(allow3Char) {
        if (allow3Char === void 0) allow3Char = false;
        return (0, $82UWo.rgbToHex)(this.r, this.g, this.b, allow3Char);
    };
    /**
     * Returns the hex value of the color -with a # prefixed.
     * @param allow3Char will shorten hex value to 3 char if possible
     */ TinyColor.prototype.toHexString = function(allow3Char) {
        if (allow3Char === void 0) allow3Char = false;
        return "#" + this.toHex(allow3Char);
    };
    /**
     * Returns the hex 8 value of the color.
     * @param allow4Char will shorten hex value to 4 char if possible
     */ TinyColor.prototype.toHex8 = function(allow4Char) {
        if (allow4Char === void 0) allow4Char = false;
        return (0, $82UWo.rgbaToHex)(this.r, this.g, this.b, this.a, allow4Char);
    };
    /**
     * Returns the hex 8 value of the color -with a # prefixed.
     * @param allow4Char will shorten hex value to 4 char if possible
     */ TinyColor.prototype.toHex8String = function(allow4Char) {
        if (allow4Char === void 0) allow4Char = false;
        return "#" + this.toHex8(allow4Char);
    };
    /**
     * Returns the shorter hex value of the color depends on its alpha -with a # prefixed.
     * @param allowShortChar will shorten hex value to 3 or 4 char if possible
     */ TinyColor.prototype.toHexShortString = function(allowShortChar) {
        if (allowShortChar === void 0) allowShortChar = false;
        return this.a === 1 ? this.toHexString(allowShortChar) : this.toHex8String(allowShortChar);
    };
    /**
     * Returns the object as a RGBA object.
     */ TinyColor.prototype.toRgb = function() {
        return {
            r: Math.round(this.r),
            g: Math.round(this.g),
            b: Math.round(this.b),
            a: this.a
        };
    };
    /**
     * Returns the RGBA values interpolated into a string with the following format:
     * "RGBA(xxx, xxx, xxx, xx)".
     */ TinyColor.prototype.toRgbString = function() {
        var r = Math.round(this.r);
        var g = Math.round(this.g);
        var b = Math.round(this.b);
        return this.a === 1 ? "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")") : "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(this.roundA, ")");
    };
    /**
     * Returns the object as a RGBA object.
     */ TinyColor.prototype.toPercentageRgb = function() {
        var fmt = function(x) {
            return "".concat(Math.round((0, $bPjXA.bound01)(x, 255) * 100), "%");
        };
        return {
            r: fmt(this.r),
            g: fmt(this.g),
            b: fmt(this.b),
            a: this.a
        };
    };
    /**
     * Returns the RGBA relative values interpolated into a string
     */ TinyColor.prototype.toPercentageRgbString = function() {
        var rnd = function(x) {
            return Math.round((0, $bPjXA.bound01)(x, 255) * 100);
        };
        return this.a === 1 ? "rgb(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%)") : "rgba(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%, ").concat(this.roundA, ")");
    };
    /**
     * The 'real' name of the color -if there is one.
     */ TinyColor.prototype.toName = function() {
        if (this.a === 0) return "transparent";
        if (this.a < 1) return false;
        var hex = "#" + (0, $82UWo.rgbToHex)(this.r, this.g, this.b, false);
        for(var _i = 0, _a = Object.entries((0, $aErMP.names)); _i < _a.length; _i++){
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (hex === value) return key;
        }
        return false;
    };
    TinyColor.prototype.toString = function(format) {
        var formatSet = Boolean(format);
        format = format !== null && format !== void 0 ? format : this.format;
        var formattedString = false;
        var hasAlpha = this.a < 1 && this.a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format.startsWith("hex") || format === "name");
        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this.a === 0) return this.toName();
            return this.toRgbString();
        }
        if (format === "rgb") formattedString = this.toRgbString();
        if (format === "prgb") formattedString = this.toPercentageRgbString();
        if (format === "hex" || format === "hex6") formattedString = this.toHexString();
        if (format === "hex3") formattedString = this.toHexString(true);
        if (format === "hex4") formattedString = this.toHex8String(true);
        if (format === "hex8") formattedString = this.toHex8String();
        if (format === "name") formattedString = this.toName();
        if (format === "hsl") formattedString = this.toHslString();
        if (format === "hsv") formattedString = this.toHsvString();
        return formattedString || this.toHexString();
    };
    TinyColor.prototype.toNumber = function() {
        return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    };
    TinyColor.prototype.clone = function() {
        return new TinyColor(this.toString());
    };
    /**
     * Lighten the color a given amount. Providing 100 will always return white.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.lighten = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.l += amount / 100;
        hsl.l = (0, $bPjXA.clamp01)(hsl.l);
        return new TinyColor(hsl);
    };
    /**
     * Brighten the color a given amount, from 0 to 100.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.brighten = function(amount) {
        if (amount === void 0) amount = 10;
        var rgb = this.toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return new TinyColor(rgb);
    };
    /**
     * Darken the color a given amount, from 0 to 100.
     * Providing 100 will always return black.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.darken = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.l -= amount / 100;
        hsl.l = (0, $bPjXA.clamp01)(hsl.l);
        return new TinyColor(hsl);
    };
    /**
     * Mix the color with pure white, from 0 to 100.
     * Providing 0 will do nothing, providing 100 will always return white.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.tint = function(amount) {
        if (amount === void 0) amount = 10;
        return this.mix("white", amount);
    };
    /**
     * Mix the color with pure black, from 0 to 100.
     * Providing 0 will do nothing, providing 100 will always return black.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.shade = function(amount) {
        if (amount === void 0) amount = 10;
        return this.mix("black", amount);
    };
    /**
     * Desaturate the color a given amount, from 0 to 100.
     * Providing 100 will is the same as calling greyscale
     * @param amount - valid between 1-100
     */ TinyColor.prototype.desaturate = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.s -= amount / 100;
        hsl.s = (0, $bPjXA.clamp01)(hsl.s);
        return new TinyColor(hsl);
    };
    /**
     * Saturate the color a given amount, from 0 to 100.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.saturate = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.s += amount / 100;
        hsl.s = (0, $bPjXA.clamp01)(hsl.s);
        return new TinyColor(hsl);
    };
    /**
     * Completely desaturates a color into greyscale.
     * Same as calling `desaturate(100)`
     */ TinyColor.prototype.greyscale = function() {
        return this.desaturate(100);
    };
    /**
     * Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
     * Values outside of this range will be wrapped into this range.
     */ TinyColor.prototype.spin = function(amount) {
        var hsl = this.toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return new TinyColor(hsl);
    };
    /**
     * Mix the current color a given amount with another color, from 0 to 100.
     * 0 means no mixing (return current color).
     */ TinyColor.prototype.mix = function(color, amount) {
        if (amount === void 0) amount = 50;
        var rgb1 = this.toRgb();
        var rgb2 = new TinyColor(color).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return new TinyColor(rgba);
    };
    TinyColor.prototype.analogous = function(results, slices) {
        if (results === void 0) results = 6;
        if (slices === void 0) slices = 30;
        var hsl = this.toHsl();
        var part = 360 / slices;
        var ret = [
            this
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(new TinyColor(hsl));
        }
        return ret;
    };
    /**
     * taken from https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js
     */ TinyColor.prototype.complement = function() {
        var hsl = this.toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return new TinyColor(hsl);
    };
    TinyColor.prototype.monochromatic = function(results) {
        if (results === void 0) results = 6;
        var hsv = this.toHsv();
        var h = hsv.h;
        var s = hsv.s;
        var v = hsv.v;
        var res = [];
        var modification = 1 / results;
        while(results--){
            res.push(new TinyColor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return res;
    };
    TinyColor.prototype.splitcomplement = function() {
        var hsl = this.toHsl();
        var h = hsl.h;
        return [
            this,
            new TinyColor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            new TinyColor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    };
    /**
     * Compute how the color would appear on a background
     */ TinyColor.prototype.onBackground = function(background) {
        var fg = this.toRgb();
        var bg = new TinyColor(background).toRgb();
        var alpha = fg.a + bg.a * (1 - fg.a);
        return new TinyColor({
            r: (fg.r * fg.a + bg.r * bg.a * (1 - fg.a)) / alpha,
            g: (fg.g * fg.a + bg.g * bg.a * (1 - fg.a)) / alpha,
            b: (fg.b * fg.a + bg.b * bg.a * (1 - fg.a)) / alpha,
            a: alpha
        });
    };
    /**
     * Alias for `polyad(3)`
     */ TinyColor.prototype.triad = function() {
        return this.polyad(3);
    };
    /**
     * Alias for `polyad(4)`
     */ TinyColor.prototype.tetrad = function() {
        return this.polyad(4);
    };
    /**
     * Get polyad colors, like (for 1, 2, 3, 4, 5, 6, 7, 8, etc...)
     * monad, dyad, triad, tetrad, pentad, hexad, heptad, octad, etc...
     */ TinyColor.prototype.polyad = function(n) {
        var hsl = this.toHsl();
        var h = hsl.h;
        var result = [
            this
        ];
        var increment = 360 / n;
        for(var i = 1; i < n; i++)result.push(new TinyColor({
            h: (h + i * increment) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    };
    /**
     * compare color vs current color
     */ TinyColor.prototype.equals = function(color) {
        return this.toRgbString() === new TinyColor(color).toRgbString();
    };
    return TinyColor;
}();
function $6d2f60b2591128fc$export$6325b328a5266d34(color, opts) {
    if (color === void 0) color = "";
    if (opts === void 0) opts = {};
    return new $6d2f60b2591128fc$export$d850312fc213f33e(color, opts);
}

});


parcelRegister("20wgT", function(module, exports) {

$parcel$export(module.exports, "default", () => $17649d51225b21b7$export$2e2bcd8739ae039);

var $a1Tue = parcelRequire("a1Tue");
function $17649d51225b21b7$export$2e2bcd8739ae039(token) {
    const { motionUnit: motionUnit, motionBase: motionBase, borderRadius: borderRadius, lineWidth: lineWidth } = token;
    return Object.assign({
        // motion
        motionDurationFast: `${(motionBase + motionUnit).toFixed(1)}s`,
        motionDurationMid: `${(motionBase + motionUnit * 2).toFixed(1)}s`,
        motionDurationSlow: `${(motionBase + motionUnit * 3).toFixed(1)}s`,
        // line
        lineWidthBold: lineWidth + 1
    }, (0, $a1Tue.default)(borderRadius));
}

});
parcelRegister("a1Tue", function(module, exports) {

$parcel$export(module.exports, "default", () => $74d509d83ea2ceca$export$2e2bcd8739ae039);
const $74d509d83ea2ceca$var$genRadius = (radiusBase)=>{
    let radiusLG = radiusBase;
    let radiusSM = radiusBase;
    let radiusXS = radiusBase;
    let radiusOuter = radiusBase;
    // radiusLG
    if (radiusBase < 6 && radiusBase >= 5) radiusLG = radiusBase + 1;
    else if (radiusBase < 16 && radiusBase >= 6) radiusLG = radiusBase + 2;
    else if (radiusBase >= 16) radiusLG = 16;
    // radiusSM
    if (radiusBase < 7 && radiusBase >= 5) radiusSM = 4;
    else if (radiusBase < 8 && radiusBase >= 7) radiusSM = 5;
    else if (radiusBase < 14 && radiusBase >= 8) radiusSM = 6;
    else if (radiusBase < 16 && radiusBase >= 14) radiusSM = 7;
    else if (radiusBase >= 16) radiusSM = 8;
    // radiusXS
    if (radiusBase < 6 && radiusBase >= 2) radiusXS = 1;
    else if (radiusBase >= 6) radiusXS = 2;
    // radiusOuter
    if (radiusBase > 4 && radiusBase < 8) radiusOuter = 4;
    else if (radiusBase >= 8) radiusOuter = 6;
    return {
        borderRadius: radiusBase,
        borderRadiusXS: radiusXS,
        borderRadiusSM: radiusSM,
        borderRadiusLG: radiusLG,
        borderRadiusOuter: radiusOuter
    };
};
var $74d509d83ea2ceca$export$2e2bcd8739ae039 = $74d509d83ea2ceca$var$genRadius;

});


parcelRegister("c5lHT", function(module, exports) {

$parcel$export(module.exports, "generateColorPalettes", () => $8cc6ca3a04c40fcf$export$da275153033f4ec1);
$parcel$export(module.exports, "generateNeutralColorPalettes", () => $8cc6ca3a04c40fcf$export$3e0cb0c1d9c1b691);
parcelRequire("eIR68");
var $i1881 = parcelRequire("i1881");

var $6xS2C = parcelRequire("6xS2C");
const $8cc6ca3a04c40fcf$export$da275153033f4ec1 = (baseColor)=>{
    const colors = (0, $i1881.default)(baseColor);
    return {
        1: colors[0],
        2: colors[1],
        3: colors[2],
        4: colors[3],
        5: colors[4],
        6: colors[5],
        7: colors[6],
        8: colors[4],
        9: colors[5],
        10: colors[6]
    };
};
const $8cc6ca3a04c40fcf$export$3e0cb0c1d9c1b691 = (bgBaseColor, textBaseColor)=>{
    const colorBgBase = bgBaseColor || "#fff";
    const colorTextBase = textBaseColor || "#000";
    return {
        colorBgBase: colorBgBase,
        colorTextBase: colorTextBase,
        colorText: (0, $6xS2C.getAlphaColor)(colorTextBase, 0.88),
        colorTextSecondary: (0, $6xS2C.getAlphaColor)(colorTextBase, 0.65),
        colorTextTertiary: (0, $6xS2C.getAlphaColor)(colorTextBase, 0.45),
        colorTextQuaternary: (0, $6xS2C.getAlphaColor)(colorTextBase, 0.25),
        colorFill: (0, $6xS2C.getAlphaColor)(colorTextBase, 0.15),
        colorFillSecondary: (0, $6xS2C.getAlphaColor)(colorTextBase, 0.06),
        colorFillTertiary: (0, $6xS2C.getAlphaColor)(colorTextBase, 0.04),
        colorFillQuaternary: (0, $6xS2C.getAlphaColor)(colorTextBase, 0.02),
        colorBgLayout: (0, $6xS2C.getSolidColor)(colorBgBase, 4),
        colorBgContainer: (0, $6xS2C.getSolidColor)(colorBgBase, 0),
        colorBgElevated: (0, $6xS2C.getSolidColor)(colorBgBase, 0),
        colorBgSpotlight: (0, $6xS2C.getAlphaColor)(colorTextBase, 0.85),
        colorBgBlur: "transparent",
        colorBorder: (0, $6xS2C.getSolidColor)(colorBgBase, 15),
        colorBorderSecondary: (0, $6xS2C.getSolidColor)(colorBgBase, 6)
    };
};

});
parcelRegister("6xS2C", function(module, exports) {

$parcel$export(module.exports, "getAlphaColor", () => $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea);
$parcel$export(module.exports, "getSolidColor", () => $4c3fbe9a4ea0d6be$export$7003a8a990e79359);

var $9nbKF = parcelRequire("9nbKF");
const $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea = (baseColor, alpha)=>new (0, $9nbKF.TinyColor)(baseColor).setAlpha(alpha).toRgbString();
const $4c3fbe9a4ea0d6be$export$7003a8a990e79359 = (baseColor, brightness)=>{
    const instance = new (0, $9nbKF.TinyColor)(baseColor);
    return instance.darken(brightness).toHexString();
};

});


parcelRegister("1oU0E", function(module, exports) {

$parcel$export(module.exports, "default", () => $10537aa233bce652$export$2e2bcd8739ae039);

var $33t0f = parcelRequire("33t0f");
const $10537aa233bce652$var$genFontMapToken = (fontSize)=>{
    const fontSizePairs = (0, $33t0f.default)(fontSize);
    const fontSizes = fontSizePairs.map((pair)=>pair.size);
    const lineHeights = fontSizePairs.map((pair)=>pair.lineHeight);
    const fontSizeMD = fontSizes[1];
    const fontSizeSM = fontSizes[0];
    const fontSizeLG = fontSizes[2];
    const lineHeight = lineHeights[1];
    const lineHeightSM = lineHeights[0];
    const lineHeightLG = lineHeights[2];
    return {
        fontSizeSM: fontSizeSM,
        fontSize: fontSizeMD,
        fontSizeLG: fontSizeLG,
        fontSizeXL: fontSizes[3],
        fontSizeHeading1: fontSizes[6],
        fontSizeHeading2: fontSizes[5],
        fontSizeHeading3: fontSizes[4],
        fontSizeHeading4: fontSizes[3],
        fontSizeHeading5: fontSizes[2],
        lineHeight: lineHeight,
        lineHeightLG: lineHeightLG,
        lineHeightSM: lineHeightSM,
        fontHeight: Math.round(lineHeight * fontSizeMD),
        fontHeightLG: Math.round(lineHeightLG * fontSizeLG),
        fontHeightSM: Math.round(lineHeightSM * fontSizeSM),
        lineHeightHeading1: lineHeights[6],
        lineHeightHeading2: lineHeights[5],
        lineHeightHeading3: lineHeights[4],
        lineHeightHeading4: lineHeights[3],
        lineHeightHeading5: lineHeights[2]
    };
};
var $10537aa233bce652$export$2e2bcd8739ae039 = $10537aa233bce652$var$genFontMapToken;

});
parcelRegister("33t0f", function(module, exports) {

$parcel$export(module.exports, "default", () => $239826517175299d$export$2e2bcd8739ae039);
// https://zhuanlan.zhihu.com/p/32746810
function $239826517175299d$export$2e2bcd8739ae039(base) {
    const fontSizes = new Array(10).fill(null).map((_, index)=>{
        const i = index - 1;
        const baseSize = base * Math.pow(2.71828, i / 5);
        const intSize = index > 1 ? Math.floor(baseSize) : Math.ceil(baseSize);
        // Convert to even
        return Math.floor(intSize / 2) * 2;
    });
    fontSizes[1] = base;
    return fontSizes.map((size)=>{
        const height = size + 8;
        return {
            size: size,
            lineHeight: height / size
        };
    });
}

});




parcelRegister("dRTnM", function(module, exports) {

$parcel$export(module.exports, "defaultIconPrefixCls", () => $a18b2f6f56546238$export$eaca8ee5ed21b4e9);
$parcel$export(module.exports, "ConfigContext", () => $a18b2f6f56546238$export$a92f85ab3e9ad68b);

var $acw62 = parcelRequire("acw62");
const $a18b2f6f56546238$export$eaca8ee5ed21b4e9 = "anticon";
const $a18b2f6f56546238$var$defaultGetPrefixCls = (suffixCls, customizePrefixCls)=>{
    if (customizePrefixCls) return customizePrefixCls;
    return suffixCls ? `ant-${suffixCls}` : "ant";
};
const $a18b2f6f56546238$export$a92f85ab3e9ad68b = /*#__PURE__*/ $acw62.createContext({
    // We provide a default function for Context without provider
    getPrefixCls: $a18b2f6f56546238$var$defaultGetPrefixCls,
    iconPrefixCls: $a18b2f6f56546238$export$eaca8ee5ed21b4e9
});
const { Consumer: $a18b2f6f56546238$export$cd5442f2b8da7663 } = $a18b2f6f56546238$export$a92f85ab3e9ad68b;

});

parcelRegister("jnSmR", function(module, exports) {

$parcel$export(module.exports, "registerTheme", () => $e1ca56936d2d2b32$export$f9c59eed5de5ff80);
/* eslint-disable import/prefer-default-export, prefer-destructuring */ parcelRequire("eIR68");
var $i1881 = parcelRequire("i1881");

var $9nbKF = parcelRequire("9nbKF");

var $h4v51 = parcelRequire("h4v51");

var $4ZrBP = parcelRequire("4ZrBP");

const $e1ca56936d2d2b32$var$dynamicStyleMark = `-ant-${Date.now()}-${Math.random()}`;
function $e1ca56936d2d2b32$export$3d2f074408bd1b82(globalPrefixCls, theme) {
    const variables = {};
    const formatColor = (color, updater)=>{
        let clone = color.clone();
        clone = (updater === null || updater === void 0 ? void 0 : updater(clone)) || clone;
        return clone.toRgbString();
    };
    const fillColor = (colorVal, type)=>{
        const baseColor = new (0, $9nbKF.TinyColor)(colorVal);
        const colorPalettes = (0, $i1881.default)(baseColor.toRgbString());
        variables[`${type}-color`] = formatColor(baseColor);
        variables[`${type}-color-disabled`] = colorPalettes[1];
        variables[`${type}-color-hover`] = colorPalettes[4];
        variables[`${type}-color-active`] = colorPalettes[6];
        variables[`${type}-color-outline`] = baseColor.clone().setAlpha(0.2).toRgbString();
        variables[`${type}-color-deprecated-bg`] = colorPalettes[0];
        variables[`${type}-color-deprecated-border`] = colorPalettes[2];
    };
    // ================ Primary Color ================
    if (theme.primaryColor) {
        fillColor(theme.primaryColor, "primary");
        const primaryColor = new (0, $9nbKF.TinyColor)(theme.primaryColor);
        const primaryColors = (0, $i1881.default)(primaryColor.toRgbString());
        // Legacy - We should use semantic naming standard
        primaryColors.forEach((color, index)=>{
            variables[`primary-${index + 1}`] = color;
        });
        // Deprecated
        variables["primary-color-deprecated-l-35"] = formatColor(primaryColor, (c)=>c.lighten(35));
        variables["primary-color-deprecated-l-20"] = formatColor(primaryColor, (c)=>c.lighten(20));
        variables["primary-color-deprecated-t-20"] = formatColor(primaryColor, (c)=>c.tint(20));
        variables["primary-color-deprecated-t-50"] = formatColor(primaryColor, (c)=>c.tint(50));
        variables["primary-color-deprecated-f-12"] = formatColor(primaryColor, (c)=>c.setAlpha(c.getAlpha() * 0.12));
        const primaryActiveColor = new (0, $9nbKF.TinyColor)(primaryColors[0]);
        variables["primary-color-active-deprecated-f-30"] = formatColor(primaryActiveColor, (c)=>c.setAlpha(c.getAlpha() * 0.3));
        variables["primary-color-active-deprecated-d-02"] = formatColor(primaryActiveColor, (c)=>c.darken(2));
    }
    // ================ Success Color ================
    if (theme.successColor) fillColor(theme.successColor, "success");
    // ================ Warning Color ================
    if (theme.warningColor) fillColor(theme.warningColor, "warning");
    // ================= Error Color =================
    if (theme.errorColor) fillColor(theme.errorColor, "error");
    // ================= Info Color ==================
    if (theme.infoColor) fillColor(theme.infoColor, "info");
    // Convert to css variables
    const cssList = Object.keys(variables).map((key)=>`--${globalPrefixCls}-${key}: ${variables[key]};`);
    return `
  :root {
    ${cssList.join("\n")}
  }
  `.trim();
}
function $e1ca56936d2d2b32$export$f9c59eed5de5ff80(globalPrefixCls, theme) {
    const style = $e1ca56936d2d2b32$export$3d2f074408bd1b82(globalPrefixCls, theme);
    if ((0, $h4v51.default)()) (0, $4ZrBP.updateCSS)(style, `${$e1ca56936d2d2b32$var$dynamicStyleMark}-dynamic-theme`);
}

});

parcelRegister("9f1hj", function(module, exports) {

$parcel$export(module.exports, "DisabledContextProvider", () => $6ba6819805fb0a44$export$6adb5f3b918b11bb);
$parcel$export(module.exports, "default", () => $6ba6819805fb0a44$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
"use client";
const $6ba6819805fb0a44$var$DisabledContext = /*#__PURE__*/ $acw62.createContext(false);
const $6ba6819805fb0a44$export$6adb5f3b918b11bb = (_ref)=>{
    let { children: children, disabled: disabled } = _ref;
    const originDisabled = $acw62.useContext($6ba6819805fb0a44$var$DisabledContext);
    return /*#__PURE__*/ $acw62.createElement($6ba6819805fb0a44$var$DisabledContext.Provider, {
        value: disabled !== null && disabled !== void 0 ? disabled : originDisabled
    }, children);
};
var $6ba6819805fb0a44$export$2e2bcd8739ae039 = $6ba6819805fb0a44$var$DisabledContext;

});

parcelRegister("2AhEK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e1ca3bea54a77f7$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $9f1hj = parcelRequire("9f1hj");

var $5kmdZ = parcelRequire("5kmdZ");
function $1e1ca3bea54a77f7$var$useConfig() {
    const componentDisabled = (0, $acw62.useContext)((0, $9f1hj.default));
    const componentSize = (0, $acw62.useContext)((0, $5kmdZ.default));
    return {
        componentDisabled: componentDisabled,
        componentSize: componentSize
    };
}
var $1e1ca3bea54a77f7$export$2e2bcd8739ae039 = $1e1ca3bea54a77f7$var$useConfig;

});
parcelRegister("5kmdZ", function(module, exports) {

$parcel$export(module.exports, "SizeContextProvider", () => $3e100f55cf8f3689$export$dbc92d89fabc8ebe);
$parcel$export(module.exports, "default", () => $3e100f55cf8f3689$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
"use client";
const $3e100f55cf8f3689$var$SizeContext = /*#__PURE__*/ $acw62.createContext(undefined);
const $3e100f55cf8f3689$export$dbc92d89fabc8ebe = (_ref)=>{
    let { children: children, size: size } = _ref;
    const originSize = $acw62.useContext($3e100f55cf8f3689$var$SizeContext);
    return /*#__PURE__*/ $acw62.createElement($3e100f55cf8f3689$var$SizeContext.Provider, {
        value: size || originSize
    }, children);
};
var $3e100f55cf8f3689$export$2e2bcd8739ae039 = $3e100f55cf8f3689$var$SizeContext;

});


parcelRegister("dOZZ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1000671d52972e2$export$2e2bcd8739ae039);

var $3Ysvw = parcelRequire("3Ysvw");

var $4AFGH = parcelRequire("4AFGH");

var $iqsy8 = parcelRequire("iqsy8");

var $77898 = parcelRequire("77898");

var $7SSa4 = parcelRequire("7SSa4");
function $a1000671d52972e2$export$2e2bcd8739ae039(theme, parentTheme) {
    var _a;
    const warning = (0, $7SSa4.devUseWarning)("ConfigProvider");
    const themeConfig = theme || {};
    const parentThemeConfig = themeConfig.inherit === false || !parentTheme ? (0, $iqsy8.defaultConfig) : parentTheme;
    const themeKey = (0, $77898.default)();
    return (0, $3Ysvw.default)(()=>{
        var _a, _b;
        if (!theme) return parentTheme;
        // Override
        const mergedComponents = Object.assign({}, parentThemeConfig.components);
        Object.keys(theme.components || {}).forEach((componentName)=>{
            mergedComponents[componentName] = Object.assign(Object.assign({}, mergedComponents[componentName]), theme.components[componentName]);
        });
        const cssVarKey = `css-var-${themeKey.replace(/:/g, "")}`;
        const mergedCssVar = ((_a = themeConfig.cssVar) !== null && _a !== void 0 ? _a : parentThemeConfig.cssVar) && Object.assign(Object.assign(Object.assign({
            prefix: "ant"
        }, typeof parentThemeConfig.cssVar === "object" ? parentThemeConfig.cssVar : {}), typeof themeConfig.cssVar === "object" ? themeConfig.cssVar : {}), {
            key: typeof themeConfig.cssVar === "object" && ((_b = themeConfig.cssVar) === null || _b === void 0 ? void 0 : _b.key) || cssVarKey
        });
        // Base token
        return Object.assign(Object.assign(Object.assign({}, parentThemeConfig), themeConfig), {
            token: Object.assign(Object.assign({}, parentThemeConfig.token), themeConfig.token),
            components: mergedComponents,
            cssVar: mergedCssVar
        });
    }, [
        themeConfig,
        parentThemeConfig
    ], (prev, next)=>prev.some((prevTheme, index)=>{
            const nextTheme = next[index];
            return !(0, $4AFGH.default)(prevTheme, nextTheme, true);
        }));
}

});
parcelRegister("77898", function(module, exports) {

$parcel$export(module.exports, "default", () => $52df818a8259ef26$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
const $52df818a8259ef26$var$fullClone = Object.assign({}, $acw62);
const { useId: $52df818a8259ef26$var$useId } = $52df818a8259ef26$var$fullClone;
const $52df818a8259ef26$var$useEmptyId = ()=>"";
const $52df818a8259ef26$var$useThemeKey = typeof $52df818a8259ef26$var$useId === "undefined" ? $52df818a8259ef26$var$useEmptyId : $52df818a8259ef26$var$useId;
var $52df818a8259ef26$export$2e2bcd8739ae039 = $52df818a8259ef26$var$useThemeKey;

});


parcelRegister("7tV7X", function(module, exports) {

$parcel$export(module.exports, "default", () => $57278e23ed3ca8fa$export$2e2bcd8739ae039);
parcelRequire("8iiJy");
var $aBcZh = parcelRequire("aBcZh");

var $acw62 = parcelRequire("acw62");

var $hRCaH = parcelRequire("hRCaH");
"use client";
function $57278e23ed3ca8fa$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const [, token] = (0, $hRCaH.default)();
    const { motion: motion } = token;
    const needWrapMotionProviderRef = $acw62.useRef(false);
    needWrapMotionProviderRef.current = needWrapMotionProviderRef.current || motion === false;
    if (needWrapMotionProviderRef.current) return /*#__PURE__*/ $acw62.createElement((0, $aBcZh.default), {
        motion: motion
    }, children);
    return children;
}

});
parcelRegister("8iiJy", function(module, exports) {

$parcel$export(module.exports, "default", () => $609e894acbce1933$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Provider", () => (parcelRequire("aBcZh")).default);

var $I4iWQ = parcelRequire("I4iWQ");

var $eGxZY = parcelRequire("eGxZY");

var $aBcZh = parcelRequire("aBcZh");
var $609e894acbce1933$export$2e2bcd8739ae039 = (0, $I4iWQ.default);

});
parcelRegister("I4iWQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $084772fb8d80df29$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $fSwVM = parcelRequire("fSwVM");

var $8g1PZ = parcelRequire("8g1PZ");

var $b2dYb = parcelRequire("b2dYb");

var $85dLH = parcelRequire("85dLH");

var $acw62 = parcelRequire("acw62");

var $aBcZh = parcelRequire("aBcZh");

var $jwRhB = parcelRequire("jwRhB");

var $2ztka = parcelRequire("2ztka");

var $2zM5O = parcelRequire("2zM5O");

var $1fdez = parcelRequire("1fdez");

var $gGgDs = parcelRequire("gGgDs");
function $084772fb8d80df29$export$e265d52a86a9f199(config) {
    var transitionSupport = config;
    if ((0, $fSwVM.default)(config) === "object") transitionSupport = config.transitionSupport;
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    var CSSMotion = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
        var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
        var _React$useContext = $acw62.useContext((0, $aBcZh.Context)), contextMotion = _React$useContext.motion;
        var supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        var nodeRef = (0, $acw62.useRef)();
        // Ref to the dom wrapper in case ref can not pass to HTMLElement
        var wrapperNodeRef = (0, $acw62.useRef)();
        function getDomElement() {
            try {
                // Here we're avoiding call for findDOMNode since it's deprecated
                // in strict mode. We're calling it only when node ref is not
                // an instance of DOM HTMLElement. Otherwise use
                // findDOMNode as a final resort
                return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0, $b2dYb.default)(wrapperNodeRef.current);
            } catch (e) {
                // Only happen when `motionDeadline` trigger but element removed.
                return null;
            }
        }
        var _useStatus = (0, $2ztka.default)(supportMotion, visible, getDomElement, props), _useStatus2 = (0, $eUqlC.default)(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        var renderedRef = $acw62.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        var setNodeRef = $acw62.useCallback(function(node) {
            nodeRef.current = node;
            (0, $85dLH.fillRef)(ref, node);
        }, [
            ref
        ]);
        // ===================== Render =====================
        var motionChildren;
        var mergedProps = (0, $d49SP.default)((0, $d49SP.default)({}, eventProps), {}, {
            visible: visible
        });
        if (!children) // No children
        motionChildren = null;
        else if (status === (0, $1fdez.STATUS_NONE)) {
            // Stable children
            if (mergedVisible) motionChildren = children((0, $d49SP.default)({}, mergedProps), setNodeRef);
            else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children((0, $d49SP.default)((0, $d49SP.default)({}, mergedProps), {}, {
                className: leavedClassName
            }), setNodeRef);
            else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children((0, $d49SP.default)((0, $d49SP.default)({}, mergedProps), {}, {
                style: {
                    display: "none"
                }
            }), setNodeRef);
            else motionChildren = null;
        } else {
            var _classNames;
            // In motion
            var statusSuffix;
            if (statusStep === (0, $1fdez.STEP_PREPARE)) statusSuffix = "prepare";
            else if ((0, $2zM5O.isActive)(statusStep)) statusSuffix = "active";
            else if (statusStep === (0, $1fdez.STEP_START)) statusSuffix = "start";
            var motionCls = (0, $gGgDs.getTransitionName)(motionName, "".concat(status, "-").concat(statusSuffix));
            motionChildren = children((0, $d49SP.default)((0, $d49SP.default)({}, mergedProps), {}, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $gGgDs.getTransitionName)(motionName, status), (_classNames = {}, (0, $kSlfw.default)(_classNames, motionCls, motionCls && statusSuffix), (0, $kSlfw.default)(_classNames, motionName, typeof motionName === "string"), _classNames)),
                style: statusStyle
            }), setNodeRef);
        }
        // Auto inject ref if child node not have `ref` props
        if (/*#__PURE__*/ $acw62.isValidElement(motionChildren) && (0, $85dLH.supportRef)(motionChildren)) {
            var _ref = motionChildren, originNodeRef = _ref.ref;
            if (!originNodeRef) motionChildren = /*#__PURE__*/ $acw62.cloneElement(motionChildren, {
                ref: setNodeRef
            });
        }
        return /*#__PURE__*/ $acw62.createElement((0, $jwRhB.default), {
            ref: wrapperNodeRef
        }, motionChildren);
    });
    CSSMotion.displayName = "CSSMotion";
    return CSSMotion;
}
var $084772fb8d80df29$export$2e2bcd8739ae039 = $084772fb8d80df29$export$e265d52a86a9f199((0, $gGgDs.supportTransition));

});
parcelRegister("b2dYb", function(module, exports) {

$parcel$export(module.exports, "isDOM", () => $808ab7b8a87ab771$export$41e30d8dd0ba7a50);
$parcel$export(module.exports, "default", () => $808ab7b8a87ab771$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $808ab7b8a87ab771$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $808ab7b8a87ab771$export$2e2bcd8739ae039(node) {
    if ($808ab7b8a87ab771$export$41e30d8dd0ba7a50(node)) return node;
    if (node instanceof (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component) return (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(node);
    return null;
}

});
parcelRegister("1u0KT", function(module, exports) {
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});


parcelRegister("aBcZh", function(module, exports) {

$parcel$export(module.exports, "Context", () => $7b776f21b7918d7b$export$841858b892ce1f4c);
$parcel$export(module.exports, "default", () => $7b776f21b7918d7b$export$2e2bcd8739ae039);

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");
var $7b776f21b7918d7b$var$_excluded = [
    "children"
];
var $7b776f21b7918d7b$export$841858b892ce1f4c = /*#__PURE__*/ $acw62.createContext({});
function $7b776f21b7918d7b$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, props = (0, $9X7IJ.default)(_ref, $7b776f21b7918d7b$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement($7b776f21b7918d7b$export$841858b892ce1f4c.Provider, {
        value: props
    }, children);
}

});

parcelRegister("jwRhB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e37a565edd3e4d81$export$2e2bcd8739ae039);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $acw62 = parcelRequire("acw62");
var $e37a565edd3e4d81$var$DomWrapper = /*#__PURE__*/ function(_React$Component) {
    (0, $1gYAD.default)(DomWrapper, _React$Component);
    var _super = (0, $enfmq.default)(DomWrapper);
    function DomWrapper() {
        (0, $6CZeq.default)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $cHPF9.default)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($acw62.Component);
var $e37a565edd3e4d81$export$2e2bcd8739ae039 = $e37a565edd3e4d81$var$DomWrapper;

});
parcelRegister("1gYAD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ed648f7bbaf3aff$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $VFVve.default)(subClass, superClass);
}

});
parcelRegister("VFVve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad5d8b55fe970db$export$2e2bcd8739ae039);
function $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p) {
    $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("enfmq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a76f20fb39fa9d46$export$2e2bcd8739ae039);

var $jDKKo = parcelRequire("jDKKo");

var $fhGLX = parcelRequire("fhGLX");

var $9715X = parcelRequire("9715X");
function $a76f20fb39fa9d46$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $fhGLX.default)();
    return function _createSuperInternal() {
        var Super = (0, $jDKKo.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jDKKo.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9715X.default)(this, result);
    };
}

});
parcelRegister("jDKKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4c5ebe502337db0$export$2e2bcd8739ae039);
function $e4c5ebe502337db0$export$2e2bcd8739ae039(o) {
    $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e4c5ebe502337db0$export$2e2bcd8739ae039(o);
}

});

parcelRegister("fhGLX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2099f49db83e2df$export$2e2bcd8739ae039);
function $b2099f49db83e2df$export$2e2bcd8739ae039() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("9715X", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a259df8fa92dc4a$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $hDpcU = parcelRequire("hDpcU");
function $6a259df8fa92dc4a$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $fSwVM.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $hDpcU.default)(self);
}

});
parcelRegister("hDpcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd69a1d4c6210e44$export$2e2bcd8739ae039);
function $cd69a1d4c6210e44$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});




parcelRegister("2ztka", function(module, exports) {

$parcel$export(module.exports, "default", () => $1df598d21d8025e6$export$2e2bcd8739ae039);

var $d49SP = parcelRequire("d49SP");

var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");

var $3fDfx = parcelRequire("3fDfx");

var $acw62 = parcelRequire("acw62");

var $1fdez = parcelRequire("1fdez");

var $aIgUv = parcelRequire("aIgUv");

var $lyPxB = parcelRequire("lyPxB");

var $2zM5O = parcelRequire("2zM5O");
function $1df598d21d8025e6$export$2e2bcd8739ae039(supportMotion, visible, getElement, _ref) {
    var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    var _useState = (0, $3fDfx.default)(), _useState2 = (0, $eUqlC.default)(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
    var _useState3 = (0, $3fDfx.default)((0, $1fdez.STATUS_NONE)), _useState4 = (0, $eUqlC.default)(_useState3, 2), status = _useState4[0], setStatus = _useState4[1];
    var _useState5 = (0, $3fDfx.default)(null), _useState6 = (0, $eUqlC.default)(_useState5, 2), style = _useState6[0], setStyle = _useState6[1];
    var mountedRef = (0, $acw62.useRef)(false);
    var deadlineRef = (0, $acw62.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    var activeRef = (0, $acw62.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, $1fdez.STATUS_NONE), true);
        setStyle(null, true);
    }
    function onInternalMotionEnd(event) {
        var element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        var currentActive = activeRef.current;
        var canEnd;
        if (status === (0, $1fdez.STATUS_APPEAR) && currentActive) canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
        else if (status === (0, $1fdez.STATUS_ENTER) && currentActive) canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
        else if (status === (0, $1fdez.STATUS_LEAVE) && currentActive) canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
        // Only update status when `canEnd` and not destroyed
        if (status !== (0, $1fdez.STATUS_NONE) && currentActive && canEnd !== false) updateMotionEndStatus();
    }
    var _useDomMotionEvents = (0, $aIgUv.default)(onInternalMotionEnd), _useDomMotionEvents2 = (0, $eUqlC.default)(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
    // ============================= Step =============================
    var getEventHandlers = function getEventHandlers(targetStatus) {
        var _ref2, _ref3, _ref4;
        switch(targetStatus){
            case 0, $1fdez.STATUS_APPEAR:
                return _ref2 = {}, (0, $kSlfw.default)(_ref2, (0, $1fdez.STEP_PREPARE), onAppearPrepare), (0, $kSlfw.default)(_ref2, (0, $1fdez.STEP_START), onAppearStart), (0, $kSlfw.default)(_ref2, (0, $1fdez.STEP_ACTIVE), onAppearActive), _ref2;
            case 0, $1fdez.STATUS_ENTER:
                return _ref3 = {}, (0, $kSlfw.default)(_ref3, (0, $1fdez.STEP_PREPARE), onEnterPrepare), (0, $kSlfw.default)(_ref3, (0, $1fdez.STEP_START), onEnterStart), (0, $kSlfw.default)(_ref3, (0, $1fdez.STEP_ACTIVE), onEnterActive), _ref3;
            case 0, $1fdez.STATUS_LEAVE:
                return _ref4 = {}, (0, $kSlfw.default)(_ref4, (0, $1fdez.STEP_PREPARE), onLeavePrepare), (0, $kSlfw.default)(_ref4, (0, $1fdez.STEP_START), onLeaveStart), (0, $kSlfw.default)(_ref4, (0, $1fdez.STEP_ACTIVE), onLeaveActive), _ref4;
            default:
                return {};
        }
    };
    var eventHandlers = $acw62.useMemo(function() {
        return getEventHandlers(status);
    }, [
        status
    ]);
    var _useStepQueue = (0, $2zM5O.default)(status, !supportMotion, function(newStep) {
        // Only prepare step can be skip
        if (newStep === (0, $1fdez.STEP_PREPARE)) {
            var onPrepare = eventHandlers[0, $1fdez.STEP_PREPARE];
            if (!onPrepare) return 0, $2zM5O.SkipStep;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (step in eventHandlers) {
            var _eventHandlers$step;
            setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
        }
        if (step === (0, $1fdez.STEP_ACTIVE)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(function() {
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (step === (0, $1fdez.STEP_PREPARED)) updateMotionEndStatus();
        return 0, $2zM5O.DoStep;
    }), _useStepQueue2 = (0, $eUqlC.default)(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
    var active = (0, $2zM5O.isActive)(step);
    activeRef.current = active;
    // ============================ Status ============================
    // Update with new status
    (0, $lyPxB.default)(function() {
        setAsyncVisible(visible);
        var isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        var nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $1fdez.STATUS_APPEAR);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $1fdez.STATUS_ENTER);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $1fdez.STATUS_LEAVE);
        var nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, $1fdez.STEP_PREPARE])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, $1fdez.STATUS_NONE));
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, $acw62.useEffect)(function() {
        if (// Cancel appear
        status === (0, $1fdez.STATUS_APPEAR) && !motionAppear || // Cancel enter
        status === (0, $1fdez.STATUS_ENTER) && !motionEnter || // Cancel leave
        status === (0, $1fdez.STATUS_LEAVE) && !motionLeave) setStatus((0, $1fdez.STATUS_NONE));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $acw62.useEffect)(function() {
        return function() {
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        };
    }, []);
    // Trigger `onVisibleChanged`
    var firstMountChangeRef = $acw62.useRef(false);
    (0, $acw62.useEffect)(function() {
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && status === (0, $1fdez.STATUS_NONE)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        status
    ]);
    // ============================ Styles ============================
    var mergedStyle = style;
    if (eventHandlers[0, $1fdez.STEP_PREPARE] && step === (0, $1fdez.STEP_START)) mergedStyle = (0, $d49SP.default)({
        transition: "none"
    }, mergedStyle);
    return [
        status,
        step,
        mergedStyle,
        asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible
    ];
}

});
parcelRegister("3fDfx", function(module, exports) {

$parcel$export(module.exports, "default", () => $25e137fc56329ad1$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");
function $25e137fc56329ad1$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $acw62.useRef(false);
    var _React$useState = $acw62.useState(defaultValue), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $acw62.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}

});

parcelRegister("1fdez", function(module, exports) {

$parcel$export(module.exports, "STATUS_NONE", () => $0e817525d7f1f474$export$de71442bbf2143da);
$parcel$export(module.exports, "STATUS_APPEAR", () => $0e817525d7f1f474$export$4fc3521687bcacd2);
$parcel$export(module.exports, "STATUS_ENTER", () => $0e817525d7f1f474$export$5d6af549241fe2e8);
$parcel$export(module.exports, "STATUS_LEAVE", () => $0e817525d7f1f474$export$59b1c493d29f68e4);
$parcel$export(module.exports, "STEP_NONE", () => $0e817525d7f1f474$export$40b34dd77d5522bf);
$parcel$export(module.exports, "STEP_PREPARE", () => $0e817525d7f1f474$export$1b792916a5fac4fc);
$parcel$export(module.exports, "STEP_START", () => $0e817525d7f1f474$export$9563153dd25a3ce8);
$parcel$export(module.exports, "STEP_ACTIVE", () => $0e817525d7f1f474$export$e205886172277ec6);
$parcel$export(module.exports, "STEP_ACTIVATED", () => $0e817525d7f1f474$export$3a846c3d2fac10b8);
$parcel$export(module.exports, "STEP_PREPARED", () => $0e817525d7f1f474$export$98351fa4e6b4f204);
var $0e817525d7f1f474$export$de71442bbf2143da = "none";
var $0e817525d7f1f474$export$4fc3521687bcacd2 = "appear";
var $0e817525d7f1f474$export$5d6af549241fe2e8 = "enter";
var $0e817525d7f1f474$export$59b1c493d29f68e4 = "leave";
var $0e817525d7f1f474$export$40b34dd77d5522bf = "none";
var $0e817525d7f1f474$export$1b792916a5fac4fc = "prepare";
var $0e817525d7f1f474$export$9563153dd25a3ce8 = "start";
var $0e817525d7f1f474$export$e205886172277ec6 = "active";
var $0e817525d7f1f474$export$3a846c3d2fac10b8 = "end";
var $0e817525d7f1f474$export$98351fa4e6b4f204 = "prepared";

});

parcelRegister("aIgUv", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ccb217d091ef41f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $gGgDs = parcelRequire("gGgDs");
var $7ccb217d091ef41f$export$2e2bcd8739ae039 = function(callback) {
    var cacheElementRef = (0, $acw62.useRef)();
    // Cache callback
    var callbackRef = (0, $acw62.useRef)(callback);
    callbackRef.current = callback;
    // Internal motion event handler
    var onInternalMotionEnd = $acw62.useCallback(function(event) {
        callbackRef.current(event);
    }, []);
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $gGgDs.transitionEndName), onInternalMotionEnd);
            element.removeEventListener((0, $gGgDs.animationEndName), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $gGgDs.transitionEndName), onInternalMotionEnd);
            element.addEventListener((0, $gGgDs.animationEndName), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    $acw62.useEffect(function() {
        return function() {
            removeMotionEvents(cacheElementRef.current);
        };
    }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};

});
parcelRegister("gGgDs", function(module, exports) {

$parcel$export(module.exports, "supportTransition", () => $c24d790a085c6d93$export$d28133ed3ad06c8b);
$parcel$export(module.exports, "animationEndName", () => $c24d790a085c6d93$export$760cc9769c51b738);
$parcel$export(module.exports, "transitionEndName", () => $c24d790a085c6d93$export$44baea64b8602e3c);
$parcel$export(module.exports, "getTransitionName", () => $c24d790a085c6d93$export$27c72201b1d09951);

var $fSwVM = parcelRequire("fSwVM");

var $h4v51 = parcelRequire("h4v51");
// ================= Transition =================
// Event wrapper. Copy from react source code
function $c24d790a085c6d93$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
    prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
    prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
    prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
    return prefixes;
}
function $c24d790a085c6d93$export$6e8b350b1a8958a0(domSupport, win) {
    var prefixes = {
        animationend: $c24d790a085c6d93$var$makePrefixMap("Animation", "AnimationEnd"),
        transitionend: $c24d790a085c6d93$var$makePrefixMap("Transition", "TransitionEnd")
    };
    if (domSupport) {
        if (!("AnimationEvent" in win)) delete prefixes.animationend.animation;
        if (!("TransitionEvent" in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
var $c24d790a085c6d93$var$vendorPrefixes = $c24d790a085c6d93$export$6e8b350b1a8958a0((0, $h4v51.default)(), typeof window !== "undefined" ? window : {});
var $c24d790a085c6d93$var$style = {};
if ((0, $h4v51.default)()) {
    var $c24d790a085c6d93$var$_document$createEleme = document.createElement("div");
    $c24d790a085c6d93$var$style = $c24d790a085c6d93$var$_document$createEleme.style;
}
var $c24d790a085c6d93$var$prefixedEventNames = {};
function $c24d790a085c6d93$export$a032e4f39350c1d8(eventName) {
    if ($c24d790a085c6d93$var$prefixedEventNames[eventName]) return $c24d790a085c6d93$var$prefixedEventNames[eventName];
    var prefixMap = $c24d790a085c6d93$var$vendorPrefixes[eventName];
    if (prefixMap) {
        var stylePropList = Object.keys(prefixMap);
        var len = stylePropList.length;
        for(var i = 0; i < len; i += 1){
            var styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $c24d790a085c6d93$var$style) {
                $c24d790a085c6d93$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $c24d790a085c6d93$var$prefixedEventNames[eventName];
            }
        }
    }
    return "";
}
var $c24d790a085c6d93$var$internalAnimationEndName = $c24d790a085c6d93$export$a032e4f39350c1d8("animationend");
var $c24d790a085c6d93$var$internalTransitionEndName = $c24d790a085c6d93$export$a032e4f39350c1d8("transitionend");
var $c24d790a085c6d93$export$d28133ed3ad06c8b = !!($c24d790a085c6d93$var$internalAnimationEndName && $c24d790a085c6d93$var$internalTransitionEndName);
var $c24d790a085c6d93$export$760cc9769c51b738 = $c24d790a085c6d93$var$internalAnimationEndName || "animationend";
var $c24d790a085c6d93$export$44baea64b8602e3c = $c24d790a085c6d93$var$internalTransitionEndName || "transitionend";
function $c24d790a085c6d93$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if ((0, $fSwVM.default)(transitionName) === "object") {
        var type = transitionType.replace(/-\w/g, function(match) {
            return match[1].toUpperCase();
        });
        return transitionName[type];
    }
    return "".concat(transitionName, "-").concat(transitionType);
}

});


parcelRegister("lyPxB", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb24c0ebe270f6f6$export$2e2bcd8739ae039);

var $h4v51 = parcelRequire("h4v51");

var $acw62 = parcelRequire("acw62");
// It's safe to use `useLayoutEffect` but the warning is annoying
var $fb24c0ebe270f6f6$var$useIsomorphicLayoutEffect = (0, $h4v51.default)() ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $fb24c0ebe270f6f6$export$2e2bcd8739ae039 = $fb24c0ebe270f6f6$var$useIsomorphicLayoutEffect;

});

parcelRegister("2zM5O", function(module, exports) {

$parcel$export(module.exports, "SkipStep", () => $1e0427d97d69e92c$export$c2029bf6cfdbc28a);
$parcel$export(module.exports, "DoStep", () => $1e0427d97d69e92c$export$dbee1e282e8c4830);
$parcel$export(module.exports, "isActive", () => $1e0427d97d69e92c$export$39e04e72f972b885);
$parcel$export(module.exports, "default", () => $1e0427d97d69e92c$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $3fDfx = parcelRequire("3fDfx");

var $acw62 = parcelRequire("acw62");

var $1fdez = parcelRequire("1fdez");

var $lyPxB = parcelRequire("lyPxB");

var $iZ4W8 = parcelRequire("iZ4W8");
var $1e0427d97d69e92c$var$FULL_STEP_QUEUE = [
    (0, $1fdez.STEP_PREPARE),
    (0, $1fdez.STEP_START),
    (0, $1fdez.STEP_ACTIVE),
    (0, $1fdez.STEP_ACTIVATED)
];
var $1e0427d97d69e92c$var$SIMPLE_STEP_QUEUE = [
    (0, $1fdez.STEP_PREPARE),
    (0, $1fdez.STEP_PREPARED)
];
var $1e0427d97d69e92c$export$c2029bf6cfdbc28a = false;
var $1e0427d97d69e92c$export$dbee1e282e8c4830 = true;
function $1e0427d97d69e92c$export$39e04e72f972b885(step) {
    return step === (0, $1fdez.STEP_ACTIVE) || step === (0, $1fdez.STEP_ACTIVATED);
}
var $1e0427d97d69e92c$export$2e2bcd8739ae039 = function(status, prepareOnly, callback) {
    var _useState = (0, $3fDfx.default)((0, $1fdez.STEP_NONE)), _useState2 = (0, $eUqlC.default)(_useState, 2), step = _useState2[0], setStep = _useState2[1];
    var _useNextFrame = (0, $iZ4W8.default)(), _useNextFrame2 = (0, $eUqlC.default)(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
    function startQueue() {
        setStep((0, $1fdez.STEP_PREPARE), true);
    }
    var STEP_QUEUE = prepareOnly ? $1e0427d97d69e92c$var$SIMPLE_STEP_QUEUE : $1e0427d97d69e92c$var$FULL_STEP_QUEUE;
    (0, $lyPxB.default)(function() {
        if (step !== (0, $1fdez.STEP_NONE) && step !== (0, $1fdez.STEP_ACTIVATED)) {
            var index = STEP_QUEUE.indexOf(step);
            var nextStep = STEP_QUEUE[index + 1];
            var result = callback(step);
            if (result === $1e0427d97d69e92c$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame(function(info) {
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $acw62.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        startQueue,
        step
    ];
};

});
parcelRegister("iZ4W8", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd21c0d0173075f3$export$2e2bcd8739ae039);

var $dTiBu = parcelRequire("dTiBu");

var $acw62 = parcelRequire("acw62");
var $dd21c0d0173075f3$export$2e2bcd8739ae039 = function() {
    var nextFrameRef = $acw62.useRef(null);
    function cancelNextFrame() {
        (0, $dTiBu.default).cancel(nextFrameRef.current);
    }
    function nextFrame(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        cancelNextFrame();
        var nextFrameId = (0, $dTiBu.default)(function() {
            if (delay <= 1) callback({
                isCanceled: function isCanceled() {
                    return nextFrameId !== nextFrameRef.current;
                }
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $acw62.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};

});
parcelRegister("dTiBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1ced7b983ea61a4$export$2e2bcd8739ae039);
var $a1ced7b983ea61a4$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $a1ced7b983ea61a4$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== "undefined" && "requestAnimationFrame" in window) {
    $a1ced7b983ea61a4$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $a1ced7b983ea61a4$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $a1ced7b983ea61a4$var$rafUUID = 0;
var $a1ced7b983ea61a4$var$rafIds = new Map();
function $a1ced7b983ea61a4$var$cleanup(id) {
    $a1ced7b983ea61a4$var$rafIds.delete(id);
}
var $a1ced7b983ea61a4$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $a1ced7b983ea61a4$var$rafUUID += 1;
    var id = $a1ced7b983ea61a4$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $a1ced7b983ea61a4$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $a1ced7b983ea61a4$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $a1ced7b983ea61a4$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$a1ced7b983ea61a4$var$wrapperRaf.cancel = function(id) {
    var realId = $a1ced7b983ea61a4$var$rafIds.get(id);
    $a1ced7b983ea61a4$var$cleanup(id);
    return $a1ced7b983ea61a4$var$caf(realId);
};
var $a1ced7b983ea61a4$export$2e2bcd8739ae039 = $a1ced7b983ea61a4$var$wrapperRaf;

});





parcelRegister("eGxZY", function(module, exports) {

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $d49SP = parcelRequire("d49SP");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");

var $I4iWQ = parcelRequire("I4iWQ");

var $1Wi9G = parcelRequire("1Wi9G");

var $gGgDs = parcelRequire("gGgDs");
var $ab0f5c5a9767e13d$var$_excluded = [
    "component",
    "children",
    "onVisibleChanged",
    "onAllRemoved"
], $ab0f5c5a9767e13d$var$_excluded2 = [
    "status"
];
var $ab0f5c5a9767e13d$var$MOTION_PROP_NAMES = [
    "eventProps",
    "visible",
    "children",
    "motionName",
    "motionAppear",
    "motionEnter",
    "motionLeave",
    "motionLeaveImmediately",
    "motionDeadline",
    "removeOnLeave",
    "leavedClassName",
    "onAppearPrepare",
    "onAppearStart",
    "onAppearActive",
    "onAppearEnd",
    "onEnterStart",
    "onEnterActive",
    "onEnterEnd",
    "onLeaveStart",
    "onLeaveActive",
    "onLeaveEnd"
];
function $ab0f5c5a9767e13d$export$fcfc62c1d33d5e2e(transitionSupport) {
    var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $I4iWQ.default);
    var CSSMotionList = /*#__PURE__*/ function(_React$Component) {
        (0, $1gYAD.default)(CSSMotionList, _React$Component);
        var _super = (0, $enfmq.default)(CSSMotionList);
        function CSSMotionList() {
            var _this;
            (0, $6CZeq.default)(this, CSSMotionList);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "state", {
                keyEntities: []
            });
            // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "removeKey", function(removeKey) {
                var keyEntities = _this.state.keyEntities;
                var nextKeyEntities = keyEntities.map(function(entity) {
                    if (entity.key !== removeKey) return entity;
                    return (0, $d49SP.default)((0, $d49SP.default)({}, entity), {}, {
                        status: (0, $1Wi9G.STATUS_REMOVED)
                    });
                });
                _this.setState({
                    keyEntities: nextKeyEntities
                });
                return nextKeyEntities.filter(function(_ref) {
                    var status = _ref.status;
                    return status !== (0, $1Wi9G.STATUS_REMOVED);
                }).length;
            });
            return _this;
        }
        (0, $cHPF9.default)(CSSMotionList, [
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var keyEntities = this.state.keyEntities;
                    var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged, onAllRemoved = _this$props.onAllRemoved, restProps = (0, $9X7IJ.default)(_this$props, $ab0f5c5a9767e13d$var$_excluded);
                    var Component = component || $acw62.Fragment;
                    var motionProps = {};
                    $ab0f5c5a9767e13d$var$MOTION_PROP_NAMES.forEach(function(prop) {
                        motionProps[prop] = restProps[prop];
                        delete restProps[prop];
                    });
                    delete restProps.keys;
                    return /*#__PURE__*/ $acw62.createElement(Component, restProps, keyEntities.map(function(_ref2, index) {
                        var status = _ref2.status, eventProps = (0, $9X7IJ.default)(_ref2, $ab0f5c5a9767e13d$var$_excluded2);
                        var visible = status === (0, $1Wi9G.STATUS_ADD) || status === (0, $1Wi9G.STATUS_KEEP);
                        return /*#__PURE__*/ $acw62.createElement(CSSMotion, (0, $8nd05.default)({}, motionProps, {
                            key: eventProps.key,
                            visible: visible,
                            eventProps: eventProps,
                            onVisibleChanged: function onVisibleChanged(changedVisible) {
                                _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                                    key: eventProps.key
                                });
                                if (!changedVisible) {
                                    var restKeysCount = _this2.removeKey(eventProps.key);
                                    if (restKeysCount === 0 && onAllRemoved) onAllRemoved();
                                }
                            }
                        }), function(props, ref) {
                            return children((0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
                                index: index
                            }), ref);
                        });
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref3, _ref4) {
                    var keys = _ref3.keys;
                    var keyEntities = _ref4.keyEntities;
                    var parsedKeyObjects = (0, $1Wi9G.parseKeys)(keys);
                    var mixedKeyEntities = (0, $1Wi9G.diffKeys)(keyEntities, parsedKeyObjects);
                    return {
                        keyEntities: mixedKeyEntities.filter(function(entity) {
                            var prevEntity = keyEntities.find(function(_ref5) {
                                var key = _ref5.key;
                                return entity.key === key;
                            });
                            // Remove if already mark as removed
                            if (prevEntity && prevEntity.status === (0, $1Wi9G.STATUS_REMOVED) && entity.status === (0, $1Wi9G.STATUS_REMOVE)) return false;
                            return true;
                        })
                    };
                }
            }
        ]);
        return CSSMotionList;
    }($acw62.Component);
    (0, $kSlfw.default)(CSSMotionList, "defaultProps", {
        component: "div"
    });
    return CSSMotionList;
}
var $ab0f5c5a9767e13d$export$2e2bcd8739ae039 = $ab0f5c5a9767e13d$export$fcfc62c1d33d5e2e((0, $gGgDs.supportTransition));

});
parcelRegister("1Wi9G", function(module, exports) {

$parcel$export(module.exports, "STATUS_ADD", () => $16994a73d43ee3a4$export$3904baa009bc026e);
$parcel$export(module.exports, "STATUS_KEEP", () => $16994a73d43ee3a4$export$851162f0adad2cbc);
$parcel$export(module.exports, "STATUS_REMOVE", () => $16994a73d43ee3a4$export$c8b3fb08b68cfc85);
$parcel$export(module.exports, "STATUS_REMOVED", () => $16994a73d43ee3a4$export$2ac1bd1808d2e43a);
$parcel$export(module.exports, "parseKeys", () => $16994a73d43ee3a4$export$84bd7bd42ccc0f72);
$parcel$export(module.exports, "diffKeys", () => $16994a73d43ee3a4$export$14527669107aa301);

var $d49SP = parcelRequire("d49SP");

var $fSwVM = parcelRequire("fSwVM");
var $16994a73d43ee3a4$export$3904baa009bc026e = "add";
var $16994a73d43ee3a4$export$851162f0adad2cbc = "keep";
var $16994a73d43ee3a4$export$c8b3fb08b68cfc85 = "remove";
var $16994a73d43ee3a4$export$2ac1bd1808d2e43a = "removed";
function $16994a73d43ee3a4$export$c47fd798e598c85c(key) {
    var keyObj;
    if (key && (0, $fSwVM.default)(key) === "object" && "key" in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return (0, $d49SP.default)((0, $d49SP.default)({}, keyObj), {}, {
        key: String(keyObj.key)
    });
}
function $16994a73d43ee3a4$export$84bd7bd42ccc0f72() {
    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return keys.map($16994a73d43ee3a4$export$c47fd798e598c85c);
}
function $16994a73d43ee3a4$export$14527669107aa301() {
    var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var list = [];
    var currentIndex = 0;
    var currentLen = currentKeys.length;
    var prevKeyObjects = $16994a73d43ee3a4$export$84bd7bd42ccc0f72(prevKeys);
    var currentKeyObjects = $16994a73d43ee3a4$export$84bd7bd42ccc0f72(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach(function(keyObj) {
        var hit = false;
        for(var i = currentIndex; i < currentLen; i += 1){
            var currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function(obj) {
                        return (0, $d49SP.default)((0, $d49SP.default)({}, obj), {}, {
                            status: $16994a73d43ee3a4$export$3904baa009bc026e
                        });
                    }));
                    currentIndex = i;
                }
                list.push((0, $d49SP.default)((0, $d49SP.default)({}, currentKeyObj), {}, {
                    status: $16994a73d43ee3a4$export$851162f0adad2cbc
                }));
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push((0, $d49SP.default)((0, $d49SP.default)({}, keyObj), {}, {
            status: $16994a73d43ee3a4$export$c8b3fb08b68cfc85
        }));
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
        return (0, $d49SP.default)((0, $d49SP.default)({}, obj), {}, {
            status: $16994a73d43ee3a4$export$3904baa009bc026e
        });
    }));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ var keys = {};
    list.forEach(function(_ref) {
        var key = _ref.key;
        keys[key] = (keys[key] || 0) + 1;
    });
    var duplicatedKeys = Object.keys(keys).filter(function(key) {
        return keys[key] > 1;
    });
    duplicatedKeys.forEach(function(matchKey) {
        // Remove `STATUS_REMOVE` node.
        list = list.filter(function(_ref2) {
            var key = _ref2.key, status = _ref2.status;
            return key !== matchKey || status !== $16994a73d43ee3a4$export$c8b3fb08b68cfc85;
        });
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach(function(node) {
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $16994a73d43ee3a4$export$851162f0adad2cbc;
        });
    });
    return list;
}

});



parcelRegister("hRCaH", function(module, exports) {

$parcel$export(module.exports, "unitless", () => $d014fefdb4420ef5$export$c6b9faa6b723d31a);
$parcel$export(module.exports, "ignore", () => $d014fefdb4420ef5$export$738b109e247a462c);
$parcel$export(module.exports, "default", () => $d014fefdb4420ef5$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("3i86m");
var $ly9Vc = parcelRequire("ly9Vc");

var $iAg6F = parcelRequire("iAg6F");

var $iqsy8 = parcelRequire("iqsy8");

var $fcQiF = parcelRequire("fcQiF");

var $jL5bw = parcelRequire("jL5bw");
var $d014fefdb4420ef5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $d014fefdb4420ef5$export$c6b9faa6b723d31a = {
    lineHeight: true,
    lineHeightSM: true,
    lineHeightLG: true,
    lineHeightHeading1: true,
    lineHeightHeading2: true,
    lineHeightHeading3: true,
    lineHeightHeading4: true,
    lineHeightHeading5: true,
    opacityLoading: true,
    fontWeightStrong: true,
    zIndexPopupBase: true,
    zIndexBase: true
};
const $d014fefdb4420ef5$export$738b109e247a462c = {
    size: true,
    sizeSM: true,
    sizeLG: true,
    sizeMD: true,
    sizeXS: true,
    sizeXXS: true,
    sizeMS: true,
    sizeXL: true,
    sizeXXL: true,
    sizeUnit: true,
    sizeStep: true,
    motionBase: true,
    motionUnit: true
};
const $d014fefdb4420ef5$var$preserve = {
    screenXS: true,
    screenXSMin: true,
    screenXSMax: true,
    screenSM: true,
    screenSMMin: true,
    screenSMMax: true,
    screenMD: true,
    screenMDMin: true,
    screenMDMax: true,
    screenLG: true,
    screenLGMin: true,
    screenLGMax: true,
    screenXL: true,
    screenXLMin: true,
    screenXLMax: true,
    screenXXL: true,
    screenXXLMin: true
};
const $d014fefdb4420ef5$export$18602cb46ae80b62 = (originToken, overrideToken, theme)=>{
    const derivativeToken = theme.getDerivativeToken(originToken);
    const { override: override } = overrideToken, components = $d014fefdb4420ef5$var$__rest(overrideToken, [
        "override"
    ]);
    // Merge with override
    let mergedDerivativeToken = Object.assign(Object.assign({}, derivativeToken), {
        override: override
    });
    // Format if needed
    mergedDerivativeToken = (0, $jL5bw.default)(mergedDerivativeToken);
    if (components) Object.entries(components).forEach((_ref)=>{
        let [key, value] = _ref;
        const { theme: componentTheme } = value, componentTokens = $d014fefdb4420ef5$var$__rest(value, [
            "theme"
        ]);
        let mergedComponentToken = componentTokens;
        if (componentTheme) mergedComponentToken = $d014fefdb4420ef5$export$18602cb46ae80b62(Object.assign(Object.assign({}, mergedDerivativeToken), componentTokens), {
            override: componentTokens
        }, componentTheme);
        mergedDerivativeToken[key] = mergedComponentToken;
    });
    return mergedDerivativeToken;
};
function $d014fefdb4420ef5$export$2e2bcd8739ae039() {
    const { token: rootDesignToken, hashed: hashed, theme: theme, override: override, cssVar: cssVar } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $iqsy8.DesignTokenContext));
    const salt = `${(0, $iAg6F.default)}-${hashed || ""}`;
    const mergedTheme = theme || (0, $iqsy8.defaultTheme);
    const [token, hashId, realToken] = (0, $ly9Vc.default)(mergedTheme, [
        (0, $fcQiF.default),
        rootDesignToken
    ], {
        salt: salt,
        override: override,
        getComputedToken: $d014fefdb4420ef5$export$18602cb46ae80b62,
        formatToken: // formatToken will not be consumed after 1.15.0 with getComputedToken.
        // But token will break if @ant-design/cssinjs is under 1.15.0 without it
        $jL5bw.default,
        cssVar: cssVar && {
            prefix: cssVar.prefix,
            key: cssVar.key,
            unitless: $d014fefdb4420ef5$export$c6b9faa6b723d31a,
            ignore: $d014fefdb4420ef5$export$738b109e247a462c,
            preserve: $d014fefdb4420ef5$var$preserve
        }
    });
    return [
        mergedTheme,
        realToken,
        hashed ? hashId : "",
        token,
        cssVar
    ];
}

});
parcelRegister("iAg6F", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8781535a68aa2aa$export$2e2bcd8739ae039);

var $eFxB4 = parcelRequire("eFxB4");
"use client";
var $d8781535a68aa2aa$export$2e2bcd8739ae039 = (0, $eFxB4.default);

});
parcelRegister("eFxB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $aadef4b21b7a3672$export$2e2bcd8739ae039);
var $aadef4b21b7a3672$export$2e2bcd8739ae039 = "5.12.2";

});


parcelRegister("jL5bw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6266db79468900d$export$2e2bcd8739ae039);

var $9nbKF = parcelRequire("9nbKF");

var $fcQiF = parcelRequire("fcQiF");

var $6kR2p = parcelRequire("6kR2p");
var $e6266db79468900d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $e6266db79468900d$export$2e2bcd8739ae039(derivativeToken) {
    const { override: override } = derivativeToken, restToken = $e6266db79468900d$var$__rest(derivativeToken, [
        "override"
    ]);
    const overrideTokens = Object.assign({}, override);
    Object.keys((0, $fcQiF.default)).forEach((token)=>{
        delete overrideTokens[token];
    });
    const mergedToken = Object.assign(Object.assign({}, restToken), overrideTokens);
    const screenXS = 480;
    const screenSM = 576;
    const screenMD = 768;
    const screenLG = 992;
    const screenXL = 1200;
    const screenXXL = 1600;
    // Motion
    if (mergedToken.motion === false) {
        const fastDuration = "0s";
        mergedToken.motionDurationFast = fastDuration;
        mergedToken.motionDurationMid = fastDuration;
        mergedToken.motionDurationSlow = fastDuration;
    }
    // Generate alias token
    const aliasToken = Object.assign(Object.assign(Object.assign({}, mergedToken), {
        // ============== Background ============== //
        colorFillContent: mergedToken.colorFillSecondary,
        colorFillContentHover: mergedToken.colorFill,
        colorFillAlter: mergedToken.colorFillQuaternary,
        colorBgContainerDisabled: mergedToken.colorFillTertiary,
        // ============== Split ============== //
        colorBorderBg: mergedToken.colorBgContainer,
        colorSplit: (0, $6kR2p.default)(mergedToken.colorBorderSecondary, mergedToken.colorBgContainer),
        // ============== Text ============== //
        colorTextPlaceholder: mergedToken.colorTextQuaternary,
        colorTextDisabled: mergedToken.colorTextQuaternary,
        colorTextHeading: mergedToken.colorText,
        colorTextLabel: mergedToken.colorTextSecondary,
        colorTextDescription: mergedToken.colorTextTertiary,
        colorTextLightSolid: mergedToken.colorWhite,
        colorHighlight: mergedToken.colorError,
        colorBgTextHover: mergedToken.colorFillSecondary,
        colorBgTextActive: mergedToken.colorFill,
        colorIcon: mergedToken.colorTextTertiary,
        colorIconHover: mergedToken.colorText,
        colorErrorOutline: (0, $6kR2p.default)(mergedToken.colorErrorBg, mergedToken.colorBgContainer),
        colorWarningOutline: (0, $6kR2p.default)(mergedToken.colorWarningBg, mergedToken.colorBgContainer),
        // Font
        fontSizeIcon: mergedToken.fontSizeSM,
        // Line
        lineWidthFocus: mergedToken.lineWidth * 4,
        // Control
        lineWidth: mergedToken.lineWidth,
        controlOutlineWidth: mergedToken.lineWidth * 2,
        // Checkbox size and expand icon size
        controlInteractiveSize: mergedToken.controlHeight / 2,
        controlItemBgHover: mergedToken.colorFillTertiary,
        controlItemBgActive: mergedToken.colorPrimaryBg,
        controlItemBgActiveHover: mergedToken.colorPrimaryBgHover,
        controlItemBgActiveDisabled: mergedToken.colorFill,
        controlTmpOutline: mergedToken.colorFillQuaternary,
        controlOutline: (0, $6kR2p.default)(mergedToken.colorPrimaryBg, mergedToken.colorBgContainer),
        lineType: mergedToken.lineType,
        borderRadius: mergedToken.borderRadius,
        borderRadiusXS: mergedToken.borderRadiusXS,
        borderRadiusSM: mergedToken.borderRadiusSM,
        borderRadiusLG: mergedToken.borderRadiusLG,
        fontWeightStrong: 600,
        opacityLoading: 0.65,
        linkDecoration: "none",
        linkHoverDecoration: "none",
        linkFocusDecoration: "none",
        controlPaddingHorizontal: 12,
        controlPaddingHorizontalSM: 8,
        paddingXXS: mergedToken.sizeXXS,
        paddingXS: mergedToken.sizeXS,
        paddingSM: mergedToken.sizeSM,
        padding: mergedToken.size,
        paddingMD: mergedToken.sizeMD,
        paddingLG: mergedToken.sizeLG,
        paddingXL: mergedToken.sizeXL,
        paddingContentHorizontalLG: mergedToken.sizeLG,
        paddingContentVerticalLG: mergedToken.sizeMS,
        paddingContentHorizontal: mergedToken.sizeMS,
        paddingContentVertical: mergedToken.sizeSM,
        paddingContentHorizontalSM: mergedToken.size,
        paddingContentVerticalSM: mergedToken.sizeXS,
        marginXXS: mergedToken.sizeXXS,
        marginXS: mergedToken.sizeXS,
        marginSM: mergedToken.sizeSM,
        margin: mergedToken.size,
        marginMD: mergedToken.sizeMD,
        marginLG: mergedToken.sizeLG,
        marginXL: mergedToken.sizeXL,
        marginXXL: mergedToken.sizeXXL,
        boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
        screenXS: screenXS,
        screenXSMin: screenXS,
        screenXSMax: screenSM - 1,
        screenSM: screenSM,
        screenSMMin: screenSM,
        screenSMMax: screenMD - 1,
        screenMD: screenMD,
        screenMDMin: screenMD,
        screenMDMax: screenLG - 1,
        screenLG: screenLG,
        screenLGMin: screenLG,
        screenLGMax: screenXL - 1,
        screenXL: screenXL,
        screenXLMin: screenXL,
        screenXLMax: screenXXL - 1,
        screenXXL: screenXXL,
        screenXXLMin: screenXXL,
        boxShadowPopoverArrow: "2px 2px 5px rgba(0, 0, 0, 0.05)",
        boxShadowCard: `
      0 1px 2px -2px ${new (0, $9nbKF.TinyColor)("rgba(0, 0, 0, 0.16)").toRgbString()},
      0 3px 6px 0 ${new (0, $9nbKF.TinyColor)("rgba(0, 0, 0, 0.12)").toRgbString()},
      0 5px 12px 4px ${new (0, $9nbKF.TinyColor)("rgba(0, 0, 0, 0.09)").toRgbString()}
    `,
        boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
        boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
        boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
        boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
    }), overrideTokens);
    return aliasToken;
}

});
parcelRegister("6kR2p", function(module, exports) {

$parcel$export(module.exports, "default", () => $49cdc08d8072d4ba$export$2e2bcd8739ae039);

var $9nbKF = parcelRequire("9nbKF");
function $49cdc08d8072d4ba$var$isStableColor(color) {
    return color >= 0 && color <= 255;
}
function $49cdc08d8072d4ba$var$getAlphaColor(frontColor, backgroundColor) {
    const { r: fR, g: fG, b: fB, a: originAlpha } = new (0, $9nbKF.TinyColor)(frontColor).toRgb();
    if (originAlpha < 1) return frontColor;
    const { r: bR, g: bG, b: bB } = new (0, $9nbKF.TinyColor)(backgroundColor).toRgb();
    for(let fA = 0.01; fA <= 1; fA += 0.01){
        const r = Math.round((fR - bR * (1 - fA)) / fA);
        const g = Math.round((fG - bG * (1 - fA)) / fA);
        const b = Math.round((fB - bB * (1 - fA)) / fA);
        if ($49cdc08d8072d4ba$var$isStableColor(r) && $49cdc08d8072d4ba$var$isStableColor(g) && $49cdc08d8072d4ba$var$isStableColor(b)) return new (0, $9nbKF.TinyColor)({
            r: r,
            g: g,
            b: b,
            a: Math.round(fA * 100) / 100
        }).toRgbString();
    }
    // fallback
    /* istanbul ignore next */ return new (0, $9nbKF.TinyColor)({
        r: fR,
        g: fG,
        b: fB,
        a: 1
    }).toRgbString();
}
var $49cdc08d8072d4ba$export$2e2bcd8739ae039 = $49cdc08d8072d4ba$var$getAlphaColor;

});




parcelRegister("dMQNr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a098b6503d6d9fdd$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $7SSa4 = parcelRequire("7SSa4");
"use client";
/**
 * Warning for ConfigProviderProps.
 * This will be empty function in production.
 */ const $a098b6503d6d9fdd$var$PropWarning = /*#__PURE__*/ $acw62.memo((_ref)=>{
    let { dropdownMatchSelectWidth: dropdownMatchSelectWidth } = _ref;
    const warning = (0, $7SSa4.devUseWarning)("ConfigProvider");
    warning.deprecated(dropdownMatchSelectWidth === undefined, "dropdownMatchSelectWidth", "popupMatchSelectWidth");
    return null;
});
var $a098b6503d6d9fdd$export$2e2bcd8739ae039 = ()=>null;

});

parcelRegister("f3iOG", function(module, exports) {

$parcel$export(module.exports, "default", () => $af55bb63f7325a53$export$2e2bcd8739ae039);
parcelRequire("3i86m");
var $aoTVg = parcelRequire("aoTVg");

var $670jt = parcelRequire("670jt");

var $hRCaH = parcelRequire("hRCaH");
const $af55bb63f7325a53$var$useResetIconStyle = (iconPrefixCls, csp)=>{
    const [theme, token] = (0, $hRCaH.default)();
    // Generate style for icons
    return (0, $aoTVg.default)({
        theme: theme,
        token: token,
        hashId: "",
        path: [
            "ant-design-icons",
            iconPrefixCls
        ],
        nonce: ()=>csp === null || csp === void 0 ? void 0 : csp.nonce
    }, ()=>[
            {
                [`.${iconPrefixCls}`]: Object.assign(Object.assign({}, (0, $670jt.resetIcon)()), {
                    [`.${iconPrefixCls} .${iconPrefixCls}-icon`]: {
                        display: "block"
                    }
                })
            }
        ]);
};
var $af55bb63f7325a53$export$2e2bcd8739ae039 = $af55bb63f7325a53$var$useResetIconStyle;

});
parcelRegister("670jt", function(module, exports) {

$parcel$export(module.exports, "textEllipsis", () => $4733a3b3eb18f80d$export$b2b65df0d0824629);
$parcel$export(module.exports, "resetComponent", () => $4733a3b3eb18f80d$export$23997c3e44cc1c59);
$parcel$export(module.exports, "resetIcon", () => $4733a3b3eb18f80d$export$171ccda7bc085e59);
$parcel$export(module.exports, "clearFix", () => $4733a3b3eb18f80d$export$8c467e8859fdef13);
$parcel$export(module.exports, "genLinkStyle", () => $4733a3b3eb18f80d$export$905d771977096614);
$parcel$export(module.exports, "genCommonStyle", () => $4733a3b3eb18f80d$export$689382c111559cd9);
$parcel$export(module.exports, "genFocusStyle", () => $4733a3b3eb18f80d$export$a44db842bcb28231);
parcelRequire("3i86m");
var $lpQ06 = parcelRequire("lpQ06");

var $if8uR = parcelRequire("if8uR");
"use client";
const $4733a3b3eb18f80d$export$b2b65df0d0824629 = {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
};
const $4733a3b3eb18f80d$export$23997c3e44cc1c59 = function(token) {
    let needInheritFontFamily = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return {
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
        color: token.colorText,
        fontSize: token.fontSize,
        // font-variant: @font-variant-base;
        lineHeight: token.lineHeight,
        listStyle: "none",
        // font-feature-settings: @font-feature-settings-base;
        fontFamily: needInheritFontFamily ? "inherit" : token.fontFamily
    };
};
const $4733a3b3eb18f80d$export$171ccda7bc085e59 = ()=>({
        display: "inline-flex",
        alignItems: "center",
        color: "inherit",
        fontStyle: "normal",
        lineHeight: 0,
        textAlign: "center",
        textTransform: "none",
        // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
        verticalAlign: "-0.125em",
        textRendering: "optimizeLegibility",
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
        "> *": {
            lineHeight: 1
        },
        svg: {
            display: "inline-block"
        }
    });
const $4733a3b3eb18f80d$export$8c467e8859fdef13 = ()=>({
        // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
        "&::before": {
            display: "table",
            content: '""'
        },
        "&::after": {
            // https://github.com/ant-design/ant-design/issues/21864
            display: "table",
            clear: "both",
            content: '""'
        }
    });
const $4733a3b3eb18f80d$export$905d771977096614 = (token)=>({
        a: {
            color: token.colorLink,
            textDecoration: token.linkDecoration,
            backgroundColor: "transparent",
            // remove the gray background on active links in IE 10.
            outline: "none",
            cursor: "pointer",
            transition: `color ${token.motionDurationSlow}`,
            "-webkit-text-decoration-skip": "objects",
            // remove gaps in links underline in iOS 8+ and Safari 8+.
            "&:hover": {
                color: token.colorLinkHover
            },
            "&:active": {
                color: token.colorLinkActive
            },
            [`&:active,
  &:hover`]: {
                textDecoration: token.linkHoverDecoration,
                outline: 0
            },
            // https://github.com/ant-design/ant-design/issues/22503
            "&:focus": {
                textDecoration: token.linkFocusDecoration,
                outline: 0
            },
            "&[disabled]": {
                color: token.colorTextDisabled,
                cursor: "not-allowed"
            }
        }
    });
const $4733a3b3eb18f80d$export$689382c111559cd9 = (token, componentPrefixCls)=>{
    const { fontFamily: fontFamily, fontSize: fontSize } = token;
    const rootPrefixSelector = `[class^="${componentPrefixCls}"], [class*=" ${componentPrefixCls}"]`;
    return {
        [rootPrefixSelector]: {
            fontFamily: fontFamily,
            fontSize: fontSize,
            boxSizing: "border-box",
            "&::before, &::after": {
                boxSizing: "border-box"
            },
            [rootPrefixSelector]: {
                boxSizing: "border-box",
                "&::before, &::after": {
                    boxSizing: "border-box"
                }
            }
        }
    };
};
const $4733a3b3eb18f80d$export$6539948f0a737e39 = (token)=>({
        outline: `${(0, $lpQ06.unit)(token.lineWidthFocus)} solid ${token.colorPrimaryBorder}`,
        outlineOffset: 1,
        transition: "outline-offset 0s, outline 0s"
    });
const $4733a3b3eb18f80d$export$a44db842bcb28231 = (token)=>({
        "&:focus-visible": Object.assign({}, $4733a3b3eb18f80d$export$6539948f0a737e39(token))
    });

});
parcelRegister("if8uR", function(module, exports) {

$parcel$export(module.exports, "operationUnit", () => $d48037fcbf78d816$export$9a16e7694a707ab4);
// eslint-disable-next-line import/prefer-default-export
const $d48037fcbf78d816$export$9a16e7694a707ab4 = (token)=>({
        // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
        // And Typography use this to generate link style which should not do this.
        color: token.colorLink,
        textDecoration: "none",
        outline: "none",
        cursor: "pointer",
        transition: `color ${token.motionDurationSlow}`,
        "&:focus, &:hover": {
            color: token.colorLinkHover
        },
        "&:active": {
            color: token.colorLinkActive
        }
    });

});




parcelRegister("4a1I5", function(module, exports) {

$parcel$export(module.exports, "isValidElement", () => $30796c32f374b477$export$a8257692ac88316c);
$parcel$export(module.exports, "isFragment", () => $30796c32f374b477$export$9522e17588c12572);
$parcel$export(module.exports, "cloneElement", () => $30796c32f374b477$export$e530037191fcd5d7);

var $acw62 = parcelRequire("acw62");
const { isValidElement: $30796c32f374b477$export$a8257692ac88316c } = $acw62;
function $30796c32f374b477$export$9522e17588c12572(child) {
    return child && $30796c32f374b477$export$a8257692ac88316c(child) && child.type === $acw62.Fragment;
}
function $30796c32f374b477$export$2dfe578f95754f6a(element, replacement, props) {
    if (!$30796c32f374b477$export$a8257692ac88316c(element)) return replacement;
    return /*#__PURE__*/ $acw62.cloneElement(element, typeof props === "function" ? props(element.props || {}) : props);
}
function $30796c32f374b477$export$e530037191fcd5d7(element, props) {
    return $30796c32f374b477$export$2dfe578f95754f6a(element, element, props);
}

});

parcelRegister("czdip", function(module, exports) {

$parcel$export(module.exports, "default", () => $92631131e38a19f0$export$2e2bcd8739ae039);

var $P8Drj = parcelRequire("P8Drj");
const $92631131e38a19f0$var$genWaveStyle = (token)=>{
    const { componentCls: componentCls, colorPrimary: colorPrimary } = token;
    return {
        [componentCls]: {
            position: "absolute",
            background: "transparent",
            pointerEvents: "none",
            boxSizing: "border-box",
            color: `var(--wave-color, ${colorPrimary})`,
            boxShadow: `0 0 0 0 currentcolor`,
            opacity: 0.2,
            // =================== Motion ===================
            "&.wave-motion-appear": {
                transition: [
                    `box-shadow 0.4s ${token.motionEaseOutCirc}`,
                    `opacity 2s ${token.motionEaseOutCirc}`
                ].join(","),
                "&-active": {
                    boxShadow: `0 0 0 6px currentcolor`,
                    opacity: 0
                },
                "&.wave-quick": {
                    transition: [
                        `box-shadow 0.3s ${token.motionEaseInOut}`,
                        `opacity 0.35s ${token.motionEaseInOut}`
                    ].join(",")
                }
            }
        }
    };
};
var $92631131e38a19f0$export$2e2bcd8739ae039 = (0, $P8Drj.default)("Wave", (token)=>[
        $92631131e38a19f0$var$genWaveStyle(token)
    ]);

});
parcelRegister("P8Drj", function(module, exports) {

$parcel$export(module.exports, "default", () => $099b764a368ed79c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "genSubStyleComponent", () => $099b764a368ed79c$export$1537386bc155ea56);
$parcel$export(module.exports, "genStyleHooks", () => $099b764a368ed79c$export$51ec95de45185b42);

var $acw62 = parcelRequire("acw62");
parcelRequire("3i86m");
var $7KFFu = parcelRequire("7KFFu");
var $684jW = parcelRequire("684jW");
var $aoTVg = parcelRequire("aoTVg");

var $8g1PZ = parcelRequire("8g1PZ");
parcelRequire("gwOwm");

var $dRTnM = parcelRequire("dRTnM");

var $670jt = parcelRequire("670jt");

var $hRCaH = parcelRequire("hRCaH");

var $gJSjB = parcelRequire("gJSjB");

var $9tj4s = parcelRequire("9tj4s");

var $2LRCS = parcelRequire("2LRCS");

var $f3iOG = parcelRequire("f3iOG");
"use client";
const $099b764a368ed79c$var$getDefaultComponentToken = (component, token, getDefaultToken)=>{
    var _a;
    if (typeof getDefaultToken === "function") return getDefaultToken((0, $2LRCS.merge)(token, (_a = token[component]) !== null && _a !== void 0 ? _a : {}));
    return getDefaultToken !== null && getDefaultToken !== void 0 ? getDefaultToken : {};
};
const $099b764a368ed79c$var$getComponentToken = (component, token, defaultToken, options)=>{
    const customToken = Object.assign({}, token[component]);
    if (options === null || options === void 0 ? void 0 : options.deprecatedTokens) {
        const { deprecatedTokens: deprecatedTokens } = options;
        deprecatedTokens.forEach((_ref)=>{
            let [oldTokenKey, newTokenKey] = _ref;
            var _a;
            // Should wrap with `if` clause, or there will be `undefined` in object.
            if ((customToken === null || customToken === void 0 ? void 0 : customToken[oldTokenKey]) || (customToken === null || customToken === void 0 ? void 0 : customToken[newTokenKey])) (_a = customToken[newTokenKey]) !== null && _a !== void 0 ? _a : customToken[newTokenKey] = customToken === null || customToken === void 0 ? void 0 : customToken[oldTokenKey];
        });
    }
    let mergedToken = Object.assign(Object.assign({}, defaultToken), customToken);
    if (options === null || options === void 0 ? void 0 : options.format) mergedToken = options.format(mergedToken);
    // Remove same value as global token to minimize size
    Object.keys(mergedToken).forEach((key)=>{
        if (mergedToken[key] === token[key]) delete mergedToken[key];
    });
    return mergedToken;
};
const $099b764a368ed79c$var$getCompVarPrefix = (component, prefix)=>`${[
        prefix,
        component.replace(/([A-Z]+)([A-Z][a-z]+)/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2")
    ].filter(Boolean).join("-")}`;
function $099b764a368ed79c$export$2e2bcd8739ae039(componentName, styleFn, getDefaultToken) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    const cells = Array.isArray(componentName) ? componentName : [
        componentName,
        componentName
    ];
    const [component] = cells;
    const concatComponent = cells.join("-");
    return (prefixCls)=>{
        const [theme, realToken, hashId, token, cssVar] = (0, $hRCaH.default)();
        const { getPrefixCls: getPrefixCls, iconPrefixCls: iconPrefixCls, csp: csp } = (0, $acw62.useContext)((0, $dRTnM.ConfigContext));
        const rootPrefixCls = getPrefixCls();
        const type = cssVar ? "css" : "js";
        const calc = (0, $gJSjB.default)(type);
        const { max: max, min: min } = (0, $9tj4s.default)(type);
        // Shared config
        const sharedConfig = {
            theme: theme,
            token: token,
            hashId: hashId,
            nonce: ()=>csp === null || csp === void 0 ? void 0 : csp.nonce,
            clientOnly: options.clientOnly,
            // antd is always at top of styles
            order: options.order || -999
        };
        // Generate style for all a tags in antd component.
        (0, $aoTVg.default)(Object.assign(Object.assign({}, sharedConfig), {
            clientOnly: false,
            path: [
                "Shared",
                rootPrefixCls
            ]
        }), ()=>[
                {
                    // Link
                    "&": (0, $670jt.genLinkStyle)(token)
                }
            ]);
        // Generate style for icons
        (0, $f3iOG.default)(iconPrefixCls, csp);
        const wrapSSR = (0, $aoTVg.default)(Object.assign(Object.assign({}, sharedConfig), {
            path: [
                concatComponent,
                prefixCls,
                iconPrefixCls
            ]
        }), ()=>{
            if (options.injectStyle === false) return [];
            const { token: proxyToken, flush: flush } = (0, $2LRCS.default)(token);
            const defaultComponentToken = $099b764a368ed79c$var$getDefaultComponentToken(component, realToken, getDefaultToken);
            const componentCls = `.${prefixCls}`;
            const componentToken = $099b764a368ed79c$var$getComponentToken(component, realToken, defaultComponentToken, {
                deprecatedTokens: options.deprecatedTokens,
                format: options.format
            });
            if (cssVar) Object.keys(defaultComponentToken).forEach((key)=>{
                defaultComponentToken[key] = `var(${(0, $7KFFu.token2CSSVar)(key, $099b764a368ed79c$var$getCompVarPrefix(component, cssVar.prefix))})`;
            });
            const mergedToken = (0, $2LRCS.merge)(proxyToken, {
                componentCls: componentCls,
                prefixCls: prefixCls,
                iconCls: `.${iconPrefixCls}`,
                antCls: `.${rootPrefixCls}`,
                calc: calc,
                max: max,
                min: min
            }, cssVar ? defaultComponentToken : componentToken);
            const styleInterpolation = styleFn(mergedToken, {
                hashId: hashId,
                prefixCls: prefixCls,
                rootPrefixCls: rootPrefixCls,
                iconPrefixCls: iconPrefixCls
            });
            flush(component, componentToken);
            return [
                options.resetStyle === false ? null : (0, $670jt.genCommonStyle)(mergedToken, prefixCls),
                styleInterpolation
            ];
        });
        return [
            wrapSSR,
            (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(hashId, cssVar === null || cssVar === void 0 ? void 0 : cssVar.key)
        ];
    };
}
const $099b764a368ed79c$export$1537386bc155ea56 = (componentName, styleFn, getDefaultToken, options)=>{
    const useStyle = $099b764a368ed79c$export$2e2bcd8739ae039(componentName, styleFn, getDefaultToken, Object.assign({
        resetStyle: false,
        // Sub Style should default after root one
        order: -998
    }, options));
    const StyledComponent = (_ref2)=>{
        let { prefixCls: prefixCls } = _ref2;
        useStyle(prefixCls);
        return null;
    };
    return StyledComponent;
};
const $099b764a368ed79c$var$genCSSVarRegister = (component, getDefaultToken, options)=>{
    function prefixToken(key) {
        return `${component}${key.slice(0, 1).toUpperCase()}${key.slice(1)}`;
    }
    const { unitless: originUnitless = {}, injectStyle: injectStyle = true } = options !== null && options !== void 0 ? options : {};
    const compUnitless = {
        [prefixToken("zIndexPopup")]: true
    };
    Object.keys(originUnitless).forEach((key)=>{
        compUnitless[prefixToken(key)] = originUnitless[key];
    });
    const CSSVarRegister = (_ref3)=>{
        let { rootCls: rootCls, cssVar: cssVar } = _ref3;
        const [, realToken] = (0, $hRCaH.default)();
        (0, $684jW.default)({
            path: [
                component
            ],
            prefix: cssVar.prefix,
            key: cssVar === null || cssVar === void 0 ? void 0 : cssVar.key,
            unitless: Object.assign(Object.assign({}, (0, $hRCaH.unitless)), compUnitless),
            ignore: $hRCaH.ignore,
            token: realToken,
            scope: rootCls
        }, ()=>{
            const defaultToken = $099b764a368ed79c$var$getDefaultComponentToken(component, realToken, getDefaultToken);
            const componentToken = $099b764a368ed79c$var$getComponentToken(component, realToken, defaultToken, {
                format: options === null || options === void 0 ? void 0 : options.format,
                deprecatedTokens: options === null || options === void 0 ? void 0 : options.deprecatedTokens
            });
            Object.keys(defaultToken).forEach((key)=>{
                componentToken[prefixToken(key)] = componentToken[key];
                delete componentToken[key];
            });
            return componentToken;
        });
        return null;
    };
    const useCSSVar = (rootCls)=>{
        const [, , , , cssVar] = (0, $hRCaH.default)();
        return (node)=>injectStyle && cssVar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CSSVarRegister, {
                rootCls: rootCls,
                cssVar: cssVar,
                component: component
            }), node) : node;
    };
    return useCSSVar;
};
const $099b764a368ed79c$export$51ec95de45185b42 = (component, styleFn, getDefaultToken, options)=>{
    const useStyle = $099b764a368ed79c$export$2e2bcd8739ae039(component, styleFn, getDefaultToken, options);
    const useCSSVar = $099b764a368ed79c$var$genCSSVarRegister(component, getDefaultToken, options);
    return function(prefixCls) {
        let rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
        const [, hashId] = useStyle(prefixCls);
        const wrapCSSVar = useCSSVar(rootCls);
        return [
            wrapCSSVar,
            hashId
        ];
    };
};

});
parcelRegister("gwOwm", function(module, exports) {

$parcel$export(module.exports, "useEvent", () => (parcelRequire("a4gyP")).default);

var $a4gyP = parcelRequire("a4gyP");

var $iSQh8 = parcelRequire("iSQh8");

var $85dLH = parcelRequire("85dLH");

var $23Gye = parcelRequire("23Gye");

var $6vgkH = parcelRequire("6vgkH");

var $u43uR = parcelRequire("u43uR");

});
parcelRegister("a4gyP", function(module, exports) {

$parcel$export(module.exports, "default", () => $01e43e72865dc583$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $01e43e72865dc583$export$2e2bcd8739ae039(callback) {
    var fnRef = $acw62.useRef();
    fnRef.current = callback;
    var memoFn = $acw62.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}

});

parcelRegister("iSQh8", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $a4gyP = parcelRequire("a4gyP");

var $6hDTM = parcelRequire("6hDTM");

var $3fDfx = parcelRequire("3fDfx");
/** We only think `undefined` is empty */ function $dbf5d1f4f4ecbb6a$var$hasValue(value) {
    return value !== undefined;
}
function $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, $3fDfx.default)(function() {
        if ($dbf5d1f4f4ecbb6a$var$hasValue(value)) return value;
        else if ($dbf5d1f4f4ecbb6a$var$hasValue(defaultValue)) return typeof defaultValue === "function" ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === "function" ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, $eUqlC.default)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, $a4gyP.default)(onChange);
    var _useState3 = (0, $3fDfx.default)([
        mergedValue
    ]), _useState4 = (0, $eUqlC.default)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, $6hDTM.useLayoutUpdateEffect)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $6hDTM.useLayoutUpdateEffect)(function() {
        if (!$dbf5d1f4f4ecbb6a$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, $a4gyP.default)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}

});


parcelRegister("gJSjB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2fafb31bc3fc56c$export$2e2bcd8739ae039);

var $98u8s = parcelRequire("98u8s");

var $8iYCW = parcelRequire("8iYCW");
const $c2fafb31bc3fc56c$var$genCalc = (type)=>{
    const Calculator = type === "css" ? (0, $8iYCW.default) : (0, $98u8s.default);
    return (num)=>new Calculator(num);
};
var $c2fafb31bc3fc56c$export$2e2bcd8739ae039 = $c2fafb31bc3fc56c$var$genCalc;

});
parcelRegister("98u8s", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a6c3cab975aeaef$export$2e2bcd8739ae039);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $i2aiK = parcelRequire("i2aiK");
let $6a6c3cab975aeaef$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $1gYAD.default)(NumCalculator, _AbstractCalculator);
    var _super = (0, $enfmq.default)(NumCalculator);
    function NumCalculator(num) {
        var _this;
        (0, $6CZeq.default)(this, NumCalculator);
        _this = _super.call(this);
        _this.result = 0;
        if (num instanceof NumCalculator) _this.result = num.result;
        else if (typeof num === "number") _this.result = num;
        return _this;
    }
    (0, $cHPF9.default)(NumCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof NumCalculator) this.result += num.result;
                else if (typeof num === "number") this.result += num;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof NumCalculator) this.result -= num.result;
                else if (typeof num === "number") this.result -= num;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (num instanceof NumCalculator) this.result *= num.result;
                else if (typeof num === "number") this.result *= num;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (num instanceof NumCalculator) this.result /= num.result;
                else if (typeof num === "number") this.result /= num;
                return this;
            }
        },
        {
            key: "equal",
            value: function equal() {
                return this.result;
            }
        }
    ]);
    return NumCalculator;
}((0, $i2aiK.default));

});
parcelRegister("i2aiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2106783e81bf495$export$2e2bcd8739ae039);

var $cHPF9 = parcelRequire("cHPF9");

var $6CZeq = parcelRequire("6CZeq");
let $d2106783e81bf495$var$AbstractCalculator = /*#__PURE__*/ (0, $cHPF9.default)(function AbstractCalculator() {
    (0, $6CZeq.default)(this, AbstractCalculator);
});
var $d2106783e81bf495$export$2e2bcd8739ae039 = $d2106783e81bf495$var$AbstractCalculator;

});


parcelRegister("8iYCW", function(module, exports) {

$parcel$export(module.exports, "default", () => $60bf086cef4d98b3$export$2e2bcd8739ae039);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $i2aiK = parcelRequire("i2aiK");
const $60bf086cef4d98b3$var$CALC_UNIT = "CALC_UNIT";
function $60bf086cef4d98b3$var$unit(value) {
    if (typeof value === "number") return `${value}${$60bf086cef4d98b3$var$CALC_UNIT}`;
    return value;
}
let $60bf086cef4d98b3$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $1gYAD.default)(CSSCalculator, _AbstractCalculator);
    var _super = (0, $enfmq.default)(CSSCalculator);
    function CSSCalculator(num) {
        var _this;
        (0, $6CZeq.default)(this, CSSCalculator);
        _this = _super.call(this);
        _this.result = "";
        if (num instanceof CSSCalculator) _this.result = `(${num.result})`;
        else if (typeof num === "number") _this.result = $60bf086cef4d98b3$var$unit(num);
        else if (typeof num === "string") _this.result = num;
        return _this;
    }
    (0, $cHPF9.default)(CSSCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof CSSCalculator) this.result = `${this.result} + ${num.getResult()}`;
                else if (typeof num === "number" || typeof num === "string") this.result = `${this.result} + ${$60bf086cef4d98b3$var$unit(num)}`;
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof CSSCalculator) this.result = `${this.result} - ${num.getResult()}`;
                else if (typeof num === "number" || typeof num === "string") this.result = `${this.result} - ${$60bf086cef4d98b3$var$unit(num)}`;
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (this.lowPriority) this.result = `(${this.result})`;
                if (num instanceof CSSCalculator) this.result = `${this.result} * ${num.getResult(true)}`;
                else if (typeof num === "number" || typeof num === "string") this.result = `${this.result} * ${num}`;
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (this.lowPriority) this.result = `(${this.result})`;
                if (num instanceof CSSCalculator) this.result = `${this.result} / ${num.getResult(true)}`;
                else if (typeof num === "number" || typeof num === "string") this.result = `${this.result} / ${num}`;
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "getResult",
            value: function getResult(force) {
                return this.lowPriority || force ? `(${this.result})` : this.result;
            }
        },
        {
            key: "equal",
            value: function equal(options) {
                const { unit: cssUnit = true } = options || {};
                const regexp = new RegExp(`${$60bf086cef4d98b3$var$CALC_UNIT}`, "g");
                this.result = this.result.replace(regexp, cssUnit ? "px" : "");
                if (typeof this.lowPriority !== "undefined") return `calc(${this.result})`;
                return this.result;
            }
        }
    ]);
    return CSSCalculator;
}((0, $i2aiK.default));

});


parcelRegister("9tj4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e559d99029dd9fb$export$2e2bcd8739ae039);
parcelRequire("3i86m");
var $lpQ06 = parcelRequire("lpQ06");
function $6e559d99029dd9fb$export$2e2bcd8739ae039(type) {
    if (type === "js") return {
        max: Math.max,
        min: Math.min
    };
    return {
        max: function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return `max(${args.map((value)=>(0, $lpQ06.unit)(value)).join(",")})`;
        },
        min: function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return `min(${args.map((value)=>(0, $lpQ06.unit)(value)).join(",")})`;
        }
    };
}

});

parcelRegister("2LRCS", function(module, exports) {

$parcel$export(module.exports, "merge", () => $2049919111d93bd2$export$4950aa0f605343fb);
$parcel$export(module.exports, "default", () => $2049919111d93bd2$export$2e2bcd8739ae039);
const $2049919111d93bd2$var$enableStatistic = typeof CSSINJS_STATISTIC !== "undefined";
let $2049919111d93bd2$var$recording = true;
function $2049919111d93bd2$export$4950aa0f605343fb() {
    for(var _len = arguments.length, objs = new Array(_len), _key = 0; _key < _len; _key++)objs[_key] = arguments[_key];
    /* istanbul ignore next */ if (!$2049919111d93bd2$var$enableStatistic) return Object.assign.apply(Object, [
        {}
    ].concat(objs));
    $2049919111d93bd2$var$recording = false;
    const ret = {};
    objs.forEach((obj)=>{
        const keys = Object.keys(obj);
        keys.forEach((key)=>{
            Object.defineProperty(ret, key, {
                configurable: true,
                enumerable: true,
                get: ()=>obj[key]
            });
        });
    });
    $2049919111d93bd2$var$recording = true;
    return ret;
}
const $2049919111d93bd2$export$754a5e2d36c5fa7a = {};
const $2049919111d93bd2$export$36157caab8bf9cbd = {};
/* istanbul ignore next */ function $2049919111d93bd2$var$noop() {}
function $2049919111d93bd2$export$2e2bcd8739ae039(token) {
    let tokenKeys;
    let proxy = token;
    let flush = $2049919111d93bd2$var$noop;
    if ($2049919111d93bd2$var$enableStatistic && typeof Proxy !== "undefined") {
        tokenKeys = new Set();
        proxy = new Proxy(token, {
            get (obj, prop) {
                if ($2049919111d93bd2$var$recording) tokenKeys.add(prop);
                return obj[prop];
            }
        });
        flush = (componentName, componentToken)=>{
            var _a;
            $2049919111d93bd2$export$754a5e2d36c5fa7a[componentName] = {
                global: Array.from(tokenKeys),
                component: Object.assign(Object.assign({}, (_a = $2049919111d93bd2$export$754a5e2d36c5fa7a[componentName]) === null || _a === void 0 ? void 0 : _a.component), componentToken)
            };
        };
    }
    return {
        token: proxy,
        keys: tokenKeys,
        flush: flush
    };
}

});



parcelRegister("2OvCY", function(module, exports) {

$parcel$export(module.exports, "default", () => $20c8c8dba0bc4c2d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("gwOwm");
var $a4gyP = parcelRequire("a4gyP");

var $dTiBu = parcelRequire("dTiBu");

var $1zYrS = parcelRequire("1zYrS");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $hRCaH = parcelRequire("hRCaH");

var $kqeqa = parcelRequire("kqeqa");
function $20c8c8dba0bc4c2d$export$2e2bcd8739ae039(nodeRef, className, component) {
    const { wave: wave } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const [, token, hashId] = (0, $hRCaH.default)();
    const showWave = (0, $a4gyP.default)((event)=>{
        const node = nodeRef.current;
        if ((wave === null || wave === void 0 ? void 0 : wave.disabled) || !node) return;
        const targetNode = node.querySelector(`.${(0, $kqeqa.TARGET_CLS)}`) || node;
        const { showEffect: showEffect } = wave || {};
        // Customize wave effect
        (showEffect || (0, $1zYrS.default))(targetNode, {
            className: className,
            token: token,
            component: component,
            event: event,
            hashId: hashId
        });
    });
    const rafId = $acw62.useRef();
    // Merge trigger event into one for each frame
    const showDebounceWave = (event)=>{
        (0, $dTiBu.default).cancel(rafId.current);
        rafId.current = (0, $dTiBu.default)(()=>{
            showWave(event);
        });
    };
    return showDebounceWave;
}

});
parcelRegister("1zYrS", function(module, exports) {

$parcel$export(module.exports, "default", () => $1267f32cdb4173c5$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $8iiJy = parcelRequire("8iiJy");

var $iORrr = parcelRequire("iORrr");

var $dTiBu = parcelRequire("dTiBu");

var $acw62 = parcelRequire("acw62");

var $lDOQ1 = parcelRequire("lDOQ1");

var $kqeqa = parcelRequire("kqeqa");
"use client";
function $1267f32cdb4173c5$var$validateNum(value) {
    return Number.isNaN(value) ? 0 : value;
}
const $1267f32cdb4173c5$var$WaveEffect = (props)=>{
    const { className: className, target: target, component: component } = props;
    const divRef = $acw62.useRef(null);
    const [color, setWaveColor] = $acw62.useState(null);
    const [borderRadius, setBorderRadius] = $acw62.useState([]);
    const [left, setLeft] = $acw62.useState(0);
    const [top, setTop] = $acw62.useState(0);
    const [width, setWidth] = $acw62.useState(0);
    const [height, setHeight] = $acw62.useState(0);
    const [enabled, setEnabled] = $acw62.useState(false);
    const waveStyle = {
        left: left,
        top: top,
        width: width,
        height: height,
        borderRadius: borderRadius.map((radius)=>`${radius}px`).join(" ")
    };
    if (color) waveStyle["--wave-color"] = color;
    function syncPos() {
        const nodeStyle = getComputedStyle(target);
        // Get wave color from target
        setWaveColor((0, $lDOQ1.getTargetWaveColor)(target));
        const isStatic = nodeStyle.position === "static";
        // Rect
        const { borderLeftWidth: borderLeftWidth, borderTopWidth: borderTopWidth } = nodeStyle;
        setLeft(isStatic ? target.offsetLeft : $1267f32cdb4173c5$var$validateNum(-parseFloat(borderLeftWidth)));
        setTop(isStatic ? target.offsetTop : $1267f32cdb4173c5$var$validateNum(-parseFloat(borderTopWidth)));
        setWidth(target.offsetWidth);
        setHeight(target.offsetHeight);
        // Get border radius
        const { borderTopLeftRadius: borderTopLeftRadius, borderTopRightRadius: borderTopRightRadius, borderBottomLeftRadius: borderBottomLeftRadius, borderBottomRightRadius: borderBottomRightRadius } = nodeStyle;
        setBorderRadius([
            borderTopLeftRadius,
            borderTopRightRadius,
            borderBottomRightRadius,
            borderBottomLeftRadius
        ].map((radius)=>$1267f32cdb4173c5$var$validateNum(parseFloat(radius))));
    }
    $acw62.useEffect(()=>{
        if (target) {
            // We need delay to check position here
            // since UI may change after click
            const id = (0, $dTiBu.default)(()=>{
                syncPos();
                setEnabled(true);
            });
            // Add resize observer to follow size
            let resizeObserver;
            if (typeof ResizeObserver !== "undefined") {
                resizeObserver = new ResizeObserver(syncPos);
                resizeObserver.observe(target);
            }
            return ()=>{
                (0, $dTiBu.default).cancel(id);
                resizeObserver === null || resizeObserver === void 0 || resizeObserver.disconnect();
            };
        }
    }, []);
    if (!enabled) return null;
    const isSmallComponent = (component === "Checkbox" || component === "Radio") && (target === null || target === void 0 ? void 0 : target.classList.contains((0, $kqeqa.TARGET_CLS)));
    return /*#__PURE__*/ $acw62.createElement((0, $8iiJy.default), {
        visible: true,
        motionAppear: true,
        motionName: "wave-motion",
        motionDeadline: 5000,
        onAppearEnd: (_, event)=>{
            var _a;
            if (event.deadline || event.propertyName === "opacity") {
                const holder = (_a = divRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
                (0, $iORrr.unmount)(holder).then(()=>{
                    holder === null || holder === void 0 || holder.remove();
                });
            }
            return false;
        }
    }, (_ref)=>{
        let { className: motionClassName } = _ref;
        return /*#__PURE__*/ $acw62.createElement("div", {
            ref: divRef,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, {
                "wave-quick": isSmallComponent
            }, motionClassName),
            style: waveStyle
        });
    });
};
const $1267f32cdb4173c5$var$showWaveEffect = (target, info)=>{
    var _a;
    const { component: component } = info;
    // Skip for unchecked checkbox
    if (component === "Checkbox" && !((_a = target.querySelector("input")) === null || _a === void 0 ? void 0 : _a.checked)) return;
    // Create holder
    const holder = document.createElement("div");
    holder.style.position = "absolute";
    holder.style.left = "0px";
    holder.style.top = "0px";
    target === null || target === void 0 || target.insertBefore(holder, target === null || target === void 0 ? void 0 : target.firstChild);
    (0, $iORrr.render)(/*#__PURE__*/ $acw62.createElement($1267f32cdb4173c5$var$WaveEffect, Object.assign({}, info, {
        target: target
    })), holder);
};
var $1267f32cdb4173c5$export$2e2bcd8739ae039 = $1267f32cdb4173c5$var$showWaveEffect;

});
parcelRegister("iORrr", function(module, exports) {

$parcel$export(module.exports, "render", () => $db3659e597d7eb55$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "unmount", () => $db3659e597d7eb55$export$121e2d597d222bad);

var $cqPKg = parcelRequire("cqPKg");

var $5wm0G = parcelRequire("5wm0G");

var $fSwVM = parcelRequire("fSwVM");

var $d49SP = parcelRequire("d49SP");

var $1u0KT = parcelRequire("1u0KT");
// Let compiler not to search module usage
var $db3659e597d7eb55$var$fullClone = (0, $d49SP.default)({}, $1u0KT);
var $db3659e597d7eb55$var$version = $db3659e597d7eb55$var$fullClone.version, $db3659e597d7eb55$var$reactRender = $db3659e597d7eb55$var$fullClone.render, $db3659e597d7eb55$var$unmountComponentAtNode = $db3659e597d7eb55$var$fullClone.unmountComponentAtNode;
var $db3659e597d7eb55$var$createRoot;
try {
    var $db3659e597d7eb55$var$mainVersion = Number(($db3659e597d7eb55$var$version || "").split(".")[0]);
    if ($db3659e597d7eb55$var$mainVersion >= 18) $db3659e597d7eb55$var$createRoot = $db3659e597d7eb55$var$fullClone.createRoot;
} catch (e) {
// Do nothing;
}
function $db3659e597d7eb55$var$toggleWarning(skip) {
    var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = $db3659e597d7eb55$var$fullClone.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    if (__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && (0, $fSwVM.default)(__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === "object") __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.usingClientEntryPoint = skip;
}
var $db3659e597d7eb55$var$MARK = "__rc_react_root__";
// ========================== Render ==========================
function $db3659e597d7eb55$var$modernRender(node, container) {
    $db3659e597d7eb55$var$toggleWarning(true);
    var root = container[$db3659e597d7eb55$var$MARK] || $db3659e597d7eb55$var$createRoot(container);
    $db3659e597d7eb55$var$toggleWarning(false);
    root.render(node);
    container[$db3659e597d7eb55$var$MARK] = root;
}
function $db3659e597d7eb55$var$legacyRender(node, container) {
    $db3659e597d7eb55$var$reactRender(node, container);
}
function $db3659e597d7eb55$export$892c6608f54d7438(node, container) {}
function $db3659e597d7eb55$export$b3890eb0ae9dca99(node, container) {
    if ($db3659e597d7eb55$var$createRoot) {
        $db3659e597d7eb55$var$modernRender(node, container);
        return;
    }
    $db3659e597d7eb55$var$legacyRender(node, container);
}
// ========================= Unmount ==========================
function $db3659e597d7eb55$var$modernUnmount(_x) {
    return $db3659e597d7eb55$var$_modernUnmount.apply(this, arguments);
}
function $db3659e597d7eb55$var$_modernUnmount() {
    $db3659e597d7eb55$var$_modernUnmount = (0, $5wm0G.default)(/*#__PURE__*/ (0, $cqPKg.default)().mark(function _callee(container) {
        return (0, $cqPKg.default)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", Promise.resolve().then(function() {
                        var _container$MARK;
                        (_container$MARK = container[$db3659e597d7eb55$var$MARK]) === null || _container$MARK === void 0 || _container$MARK.unmount();
                        delete container[$db3659e597d7eb55$var$MARK];
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $db3659e597d7eb55$var$_modernUnmount.apply(this, arguments);
}
function $db3659e597d7eb55$var$legacyUnmount(container) {
    $db3659e597d7eb55$var$unmountComponentAtNode(container);
}
function $db3659e597d7eb55$export$fd39fe14445b207a(container) {}
function $db3659e597d7eb55$export$121e2d597d222bad(_x2) {
    return $db3659e597d7eb55$var$_unmount.apply(this, arguments);
}
function $db3659e597d7eb55$var$_unmount() {
    $db3659e597d7eb55$var$_unmount = (0, $5wm0G.default)(/*#__PURE__*/ (0, $cqPKg.default)().mark(function _callee2(container) {
        return (0, $cqPKg.default)().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if (!($db3659e597d7eb55$var$createRoot !== undefined)) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return", $db3659e597d7eb55$var$modernUnmount(container));
                case 2:
                    $db3659e597d7eb55$var$legacyUnmount(container);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $db3659e597d7eb55$var$_unmount.apply(this, arguments);
}

});
parcelRegister("cqPKg", function(module, exports) {

$parcel$export(module.exports, "default", () => $90d00d496f52c75c$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");
function $90d00d496f52c75c$export$2e2bcd8739ae039() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $90d00d496f52c75c$export$2e2bcd8739ae039 = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == (0, $fSwVM.default)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw new Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError((0, $fSwVM.default)(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw new Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}

});

parcelRegister("5wm0G", function(module, exports) {

$parcel$export(module.exports, "default", () => $4051039ece381ef4$export$2e2bcd8739ae039);
function $4051039ece381ef4$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $4051039ece381ef4$export$2e2bcd8739ae039(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $4051039ece381ef4$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $4051039ece381ef4$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});


parcelRegister("lDOQ1", function(module, exports) {

$parcel$export(module.exports, "getTargetWaveColor", () => $fc14acdc17dc0f28$export$651d8e9c80304fc8);
function $fc14acdc17dc0f28$export$1394a8dd73acd4cc(color) {
    // eslint-disable-next-line no-useless-escape
    const match = (color || "").match(/rgba?\((\d*), (\d*), (\d*)(, [\d.]*)?\)/);
    if (match && match[1] && match[2] && match[3]) return !(match[1] === match[2] && match[2] === match[3]);
    return true;
}
function $fc14acdc17dc0f28$export$9d61ea039e87eb91(color) {
    return color && color !== "#fff" && color !== "#ffffff" && color !== "rgb(255, 255, 255)" && color !== "rgba(255, 255, 255, 1)" && $fc14acdc17dc0f28$export$1394a8dd73acd4cc(color) && !/rgba\((?:\d*, ){3}0\)/.test(color) && // any transparent rgba color
    color !== "transparent";
}
function $fc14acdc17dc0f28$export$651d8e9c80304fc8(node) {
    const { borderTopColor: borderTopColor, borderColor: borderColor, backgroundColor: backgroundColor } = getComputedStyle(node);
    if ($fc14acdc17dc0f28$export$9d61ea039e87eb91(borderTopColor)) return borderTopColor;
    if ($fc14acdc17dc0f28$export$9d61ea039e87eb91(borderColor)) return borderColor;
    if ($fc14acdc17dc0f28$export$9d61ea039e87eb91(backgroundColor)) return backgroundColor;
    return null;
}

});

parcelRegister("kqeqa", function(module, exports) {

$parcel$export(module.exports, "TARGET_CLS", () => $ede16c18199d1556$export$23466a5792b7a5d3);
const $ede16c18199d1556$export$23466a5792b7a5d3 = "ant-wave-target";

});




parcelRegister("IFe7R", function(module, exports) {

$parcel$export(module.exports, "default", () => $086416f743106ac8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5kmdZ = parcelRequire("5kmdZ");
const $086416f743106ac8$var$useSize = (customSize)=>{
    const size = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $5kmdZ.default));
    const mergedSize = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!customSize) return size;
        if (typeof customSize === "string") return customSize !== null && customSize !== void 0 ? customSize : size;
        if (customSize instanceof Function) return customSize(size);
        return size;
    }, [
        customSize,
        size
    ]);
    return mergedSize;
};
var $086416f743106ac8$export$2e2bcd8739ae039 = $086416f743106ac8$var$useSize;

});

parcelRegister("3gns8", function(module, exports) {

$parcel$export(module.exports, "useCompactItemContext", () => $26050ef76e24a749$export$cd8cf9d7bab8dd4);
$parcel$export(module.exports, "NoCompactStyle", () => $26050ef76e24a749$export$5f56e610a4afb685);

var $8g1PZ = parcelRequire("8g1PZ");

var $jWR62 = parcelRequire("jWR62");

var $acw62 = parcelRequire("acw62");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $IFe7R = parcelRequire("IFe7R");

var $c3tKe = parcelRequire("c3tKe");
"use client";
var $26050ef76e24a749$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $26050ef76e24a749$export$8d1c486ac0db0a7d = /*#__PURE__*/ $acw62.createContext(null);
const $26050ef76e24a749$export$cd8cf9d7bab8dd4 = (prefixCls, direction)=>{
    const compactItemContext = $acw62.useContext($26050ef76e24a749$export$8d1c486ac0db0a7d);
    const compactItemClassnames = $acw62.useMemo(()=>{
        if (!compactItemContext) return "";
        const { compactDirection: compactDirection, isFirstItem: isFirstItem, isLastItem: isLastItem } = compactItemContext;
        const separator = compactDirection === "vertical" ? "-vertical-" : "-";
        return (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(`${prefixCls}-compact${separator}item`, {
            [`${prefixCls}-compact${separator}first-item`]: isFirstItem,
            [`${prefixCls}-compact${separator}last-item`]: isLastItem,
            [`${prefixCls}-compact${separator}item-rtl`]: direction === "rtl"
        });
    }, [
        prefixCls,
        direction,
        compactItemContext
    ]);
    return {
        compactSize: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactSize,
        compactDirection: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactDirection,
        compactItemClassnames: compactItemClassnames
    };
};
const $26050ef76e24a749$export$5f56e610a4afb685 = (_ref)=>{
    let { children: children } = _ref;
    return /*#__PURE__*/ $acw62.createElement($26050ef76e24a749$export$8d1c486ac0db0a7d.Provider, {
        value: null
    }, children);
};
const $26050ef76e24a749$var$CompactItem = (_a)=>{
    var { children: children } = _a, otherProps = $26050ef76e24a749$var$__rest(_a, [
        "children"
    ]);
    return /*#__PURE__*/ $acw62.createElement($26050ef76e24a749$export$8d1c486ac0db0a7d.Provider, {
        value: otherProps
    }, children);
};
const $26050ef76e24a749$var$Compact = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: directionConfig } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const { size: size, direction: direction, block: block, prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children } = props, restProps = $26050ef76e24a749$var$__rest(props, [
        "size",
        "direction",
        "block",
        "prefixCls",
        "className",
        "rootClassName",
        "children"
    ]);
    const mergedSize = (0, $IFe7R.default)((ctx)=>size !== null && size !== void 0 ? size : ctx);
    const prefixCls = getPrefixCls("space-compact", customizePrefixCls);
    const [wrapCSSVar, hashId] = (0, $c3tKe.default)(prefixCls);
    const clx = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, hashId, {
        [`${prefixCls}-rtl`]: directionConfig === "rtl",
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-vertical`]: direction === "vertical"
    }, className, rootClassName);
    const compactItemContext = $acw62.useContext($26050ef76e24a749$export$8d1c486ac0db0a7d);
    const childNodes = (0, $jWR62.default)(children);
    const nodes = $acw62.useMemo(()=>childNodes.map((child, i)=>{
            const key = child && child.key || `${prefixCls}-item-${i}`;
            return /*#__PURE__*/ $acw62.createElement($26050ef76e24a749$var$CompactItem, {
                key: key,
                compactSize: mergedSize,
                compactDirection: direction,
                isFirstItem: i === 0 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isFirstItem)),
                isLastItem: i === childNodes.length - 1 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isLastItem))
            }, child);
        }), [
        size,
        childNodes,
        compactItemContext
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", Object.assign({
        className: clx
    }, restProps), nodes));
};
var $26050ef76e24a749$export$2e2bcd8739ae039 = $26050ef76e24a749$var$Compact;

});
parcelRegister("jWR62", function(module, exports) {

$parcel$export(module.exports, "default", () => $e85c9ef0f09d251f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $lwoRE = parcelRequire("lwoRE");
function $e85c9ef0f09d251f$export$2e2bcd8739ae039(children) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ret = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, function(child) {
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat($e85c9ef0f09d251f$export$2e2bcd8739ae039(child));
        else if ((0, $lwoRE.isFragment)(child) && child.props) ret = ret.concat($e85c9ef0f09d251f$export$2e2bcd8739ae039(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}

});

parcelRegister("c3tKe", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c6cd68a6974f2d0$export$2e2bcd8739ae039);

var $P8Drj = parcelRequire("P8Drj");
var $2LRCS = parcelRequire("2LRCS");

var $d5vRq = parcelRequire("d5vRq");
const $8c6cd68a6974f2d0$var$genSpaceStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            display: "inline-flex",
            "&-rtl": {
                direction: "rtl"
            },
            "&-vertical": {
                flexDirection: "column"
            },
            "&-align": {
                flexDirection: "column",
                "&-center": {
                    alignItems: "center"
                },
                "&-start": {
                    alignItems: "flex-start"
                },
                "&-end": {
                    alignItems: "flex-end"
                },
                "&-baseline": {
                    alignItems: "baseline"
                }
            },
            [`${componentCls}-item:empty`]: {
                display: "none"
            }
        }
    };
};
const $8c6cd68a6974f2d0$var$genSpaceGapStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            "&-gap-row-small": {
                rowGap: token.spaceGapSmallSize
            },
            "&-gap-row-middle": {
                rowGap: token.spaceGapMiddleSize
            },
            "&-gap-row-large": {
                rowGap: token.spaceGapLargeSize
            },
            "&-gap-col-small": {
                columnGap: token.spaceGapSmallSize
            },
            "&-gap-col-middle": {
                columnGap: token.spaceGapMiddleSize
            },
            "&-gap-col-large": {
                columnGap: token.spaceGapLargeSize
            }
        }
    };
};
const $8c6cd68a6974f2d0$export$9ca1be8807fe0675 = ()=>({});
var $8c6cd68a6974f2d0$export$2e2bcd8739ae039 = (0, $P8Drj.genStyleHooks)("Space", (token)=>{
    const spaceToken = (0, $2LRCS.merge)(token, {
        spaceGapSmallSize: token.paddingXS,
        spaceGapMiddleSize: token.padding,
        spaceGapLargeSize: token.paddingLG
    });
    return [
        $8c6cd68a6974f2d0$var$genSpaceStyle(spaceToken),
        $8c6cd68a6974f2d0$var$genSpaceGapStyle(spaceToken),
        (0, $d5vRq.default)(spaceToken)
    ];
}, ()=>({}), {
    // Space component don't apply extra font style
    // https://github.com/ant-design/ant-design/issues/40315
    resetStyle: false
});

});
parcelRegister("d5vRq", function(module, exports) {

$parcel$export(module.exports, "default", () => $987474def15ea51b$export$2e2bcd8739ae039);
const $987474def15ea51b$var$genSpaceCompactStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            "&-block": {
                display: "flex",
                width: "100%"
            },
            "&-vertical": {
                flexDirection: "column"
            }
        }
    };
};
var // ============================== Export ==============================
$987474def15ea51b$export$2e2bcd8739ae039 = $987474def15ea51b$var$genSpaceCompactStyle;

});



parcelRegister("d3HKf", function(module, exports) {

$parcel$export(module.exports, "GroupSizeContext", () => $981d7d04085c8929$export$ed0cc8bd1f617d6d);
$parcel$export(module.exports, "default", () => $981d7d04085c8929$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $hRCaH = parcelRequire("hRCaH");
"use client";
var $981d7d04085c8929$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $981d7d04085c8929$export$ed0cc8bd1f617d6d = /*#__PURE__*/ $acw62.createContext(undefined);
const $981d7d04085c8929$var$ButtonGroup = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const { prefixCls: customizePrefixCls, size: size, className: className } = props, others = $981d7d04085c8929$var$__rest(props, [
        "prefixCls",
        "size",
        "className"
    ]);
    const prefixCls = getPrefixCls("btn-group", customizePrefixCls);
    const [, , hashId] = (0, $hRCaH.default)();
    let sizeCls = "";
    switch(size){
        case "large":
            sizeCls = "lg";
            break;
        case "small":
            sizeCls = "sm";
            break;
        case "middle":
        default:
    }
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, {
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, className, hashId);
    return /*#__PURE__*/ $acw62.createElement($981d7d04085c8929$export$ed0cc8bd1f617d6d.Provider, {
        value: size
    }, /*#__PURE__*/ $acw62.createElement("div", Object.assign({}, others, {
        className: classes
    })));
};
var $981d7d04085c8929$export$2e2bcd8739ae039 = $981d7d04085c8929$var$ButtonGroup;

});

parcelRegister("bLQWM", function(module, exports) {

$parcel$export(module.exports, "isTwoCNChar", () => $891d27b465b97c91$export$c5dca2bf412dea0d);
$parcel$export(module.exports, "convertLegacyProps", () => $891d27b465b97c91$export$19bc9a290855952);
$parcel$export(module.exports, "isUnBorderedButtonType", () => $891d27b465b97c91$export$1085c0511270cee);
$parcel$export(module.exports, "spaceChildren", () => $891d27b465b97c91$export$b6ee00a7e7908bc);

var $acw62 = parcelRequire("acw62");

var $4a1I5 = parcelRequire("4a1I5");
"use client";
const $891d27b465b97c91$var$rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
const $891d27b465b97c91$export$c5dca2bf412dea0d = $891d27b465b97c91$var$rxTwoCNChar.test.bind($891d27b465b97c91$var$rxTwoCNChar);
function $891d27b465b97c91$export$19bc9a290855952(type) {
    if (type === "danger") return {
        danger: true
    };
    return {
        type: type
    };
}
function $891d27b465b97c91$export$844ec244b1367d54(str) {
    return typeof str === "string";
}
function $891d27b465b97c91$export$1085c0511270cee(type) {
    return type === "text" || type === "link";
}
function $891d27b465b97c91$var$splitCNCharsBySpace(child, needInserted) {
    if (child === null || child === undefined) return;
    const SPACE = needInserted ? " " : "";
    if (typeof child !== "string" && typeof child !== "number" && $891d27b465b97c91$export$844ec244b1367d54(child.type) && $891d27b465b97c91$export$c5dca2bf412dea0d(child.props.children)) return (0, $4a1I5.cloneElement)(child, {
        children: child.props.children.split("").join(SPACE)
    });
    if ($891d27b465b97c91$export$844ec244b1367d54(child)) return $891d27b465b97c91$export$c5dca2bf412dea0d(child) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, child.split("").join(SPACE)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, child);
    if ((0, $4a1I5.isFragment)(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, child);
    return child;
}
function $891d27b465b97c91$export$b6ee00a7e7908bc(children, needInserted) {
    let isPrevChildPure = false;
    const childList = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (child)=>{
        const type = typeof child;
        const isCurrentChildPure = type === "string" || type === "number";
        if (isPrevChildPure && isCurrentChildPure) {
            const lastIndex = childList.length - 1;
            const lastChild = childList[lastIndex];
            childList[lastIndex] = `${lastChild}${child}`;
        } else childList.push(child);
        isPrevChildPure = isCurrentChildPure;
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(childList, (child)=>$891d27b465b97c91$var$splitCNCharsBySpace(child, needInserted));
}
const $891d27b465b97c91$var$ButtonTypes = [
    "default",
    "primary",
    "dashed",
    "link",
    "text"
];
const $891d27b465b97c91$var$ButtonShapes = [
    "default",
    "circle",
    "round"
];
const $891d27b465b97c91$var$ButtonHTMLTypes = [
    "submit",
    "button",
    "reset"
];

});

parcelRegister("2d3DV", function(module, exports) {

$parcel$export(module.exports, "default", () => $19bf9f13d1d4a6e4$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");
"use client";
const $19bf9f13d1d4a6e4$var$IconWrapper = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    const { className: className, style: style, children: children, prefixCls: prefixCls } = props;
    const iconWrapperCls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(`${prefixCls}-icon`, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: ref,
        className: iconWrapperCls,
        style: style
    }, children);
});
var $19bf9f13d1d4a6e4$export$2e2bcd8739ae039 = $19bf9f13d1d4a6e4$var$IconWrapper;

});

parcelRegister("a5WcK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7597853c34b57de5$export$2e2bcd8739ae039);

var $iCcrH = parcelRequire("iCcrH");

var $8g1PZ = parcelRequire("8g1PZ");

var $8iiJy = parcelRequire("8iiJy");

var $acw62 = parcelRequire("acw62");

var $2d3DV = parcelRequire("2d3DV");
"use client";
const $7597853c34b57de5$var$InnerLoadingIcon = /*#__PURE__*/ (0, $acw62.forwardRef)((_ref, ref)=>{
    let { prefixCls: prefixCls, className: className, style: style, iconClassName: iconClassName } = _ref;
    const mergedIconCls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(`${prefixCls}-loading-icon`, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2d3DV.default), {
        prefixCls: prefixCls,
        className: mergedIconCls,
        style: style,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iCcrH.default), {
        className: iconClassName
    }));
});
const $7597853c34b57de5$var$getCollapsedWidth = ()=>({
        width: 0,
        opacity: 0,
        transform: "scale(0)"
    });
const $7597853c34b57de5$var$getRealWidth = (node)=>({
        width: node.scrollWidth,
        opacity: 1,
        transform: "scale(1)"
    });
const $7597853c34b57de5$var$LoadingIcon = (props)=>{
    const { prefixCls: prefixCls, loading: loading, existIcon: existIcon, className: className, style: style } = props;
    const visible = !!loading;
    if (existIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7597853c34b57de5$var$InnerLoadingIcon, {
        prefixCls: prefixCls,
        className: className,
        style: style
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8iiJy.default), {
        visible: visible,
        // We do not really use this motionName
        motionName: `${prefixCls}-loading-icon-motion`,
        motionLeave: visible,
        removeOnLeave: true,
        onAppearStart: $7597853c34b57de5$var$getCollapsedWidth,
        onAppearActive: $7597853c34b57de5$var$getRealWidth,
        onEnterStart: $7597853c34b57de5$var$getCollapsedWidth,
        onEnterActive: $7597853c34b57de5$var$getRealWidth,
        onLeaveStart: $7597853c34b57de5$var$getRealWidth,
        onLeaveActive: $7597853c34b57de5$var$getCollapsedWidth
    }, (_ref2, ref)=>{
        let { className: motionCls, style: motionStyle } = _ref2;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7597853c34b57de5$var$InnerLoadingIcon, {
            prefixCls: prefixCls,
            className: className,
            style: Object.assign(Object.assign({}, style), motionStyle),
            ref: ref,
            iconClassName: motionCls
        });
    });
};
var $7597853c34b57de5$export$2e2bcd8739ae039 = $7597853c34b57de5$var$LoadingIcon;

});
parcelRegister("iCcrH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8d56e1090f62915$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $3HcDv = parcelRequire("3HcDv");

var $adRcI = parcelRequire("adRcI");
var $d8d56e1090f62915$var$LoadingOutlined = function LoadingOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $adRcI.default), (0, $8nd05.default)({}, props, {
        ref: ref,
        icon: (0, $3HcDv.default)
    }));
};
var $d8d56e1090f62915$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($d8d56e1090f62915$var$LoadingOutlined);

});
parcelRegister("3HcDv", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b0f3084756e08d0$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $2b0f3084756e08d0$var$LoadingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
                }
            }
        ]
    },
    "name": "loading",
    "theme": "outlined"
};
var $2b0f3084756e08d0$export$2e2bcd8739ae039 = $2b0f3084756e08d0$var$LoadingOutlined;

});

parcelRegister("adRcI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7714637e9c1f1f3f$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $kSlfw = parcelRequire("kSlfw");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $eIR68 = parcelRequire("eIR68");

var $9f9mi = parcelRequire("9f9mi");

var $gVALr = parcelRequire("gVALr");

var $3qc8O = parcelRequire("3qc8O");

var $2oDWm = parcelRequire("2oDWm");
"use client";
var $7714637e9c1f1f3f$var$_excluded = [
    "className",
    "icon",
    "spin",
    "rotate",
    "tabIndex",
    "onClick",
    "twoToneColor"
];
// Initial setting
// should move it to antd main repo?
(0, $3qc8O.setTwoToneColor)((0, $eIR68.blue).primary);
// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757#issuecomment-488848720
var $7714637e9c1f1f3f$var$Icon = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _classNames;
    var className = props.className, icon = props.icon, spin = props.spin, rotate = props.rotate, tabIndex = props.tabIndex, onClick = props.onClick, twoToneColor = props.twoToneColor, restProps = (0, $9X7IJ.default)(props, $7714637e9c1f1f3f$var$_excluded);
    var _React$useContext = $acw62.useContext((0, $9f9mi.default)), _React$useContext$pre = _React$useContext.prefixCls, prefixCls = _React$useContext$pre === void 0 ? "anticon" : _React$useContext$pre, rootClassName = _React$useContext.rootClassName;
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(rootClassName, prefixCls, (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-spin"), !!spin || icon.name === "loading"), _classNames), className);
    var iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) iconTabIndex = -1;
    var svgStyle = rotate ? {
        msTransform: "rotate(".concat(rotate, "deg)"),
        transform: "rotate(".concat(rotate, "deg)")
    } : undefined;
    var _normalizeTwoToneColo = (0, $2oDWm.normalizeTwoToneColors)(twoToneColor), _normalizeTwoToneColo2 = (0, $eUqlC.default)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return /*#__PURE__*/ $acw62.createElement("span", (0, $8nd05.default)({
        role: "img",
        "aria-label": icon.name
    }, restProps, {
        ref: ref,
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
    }), /*#__PURE__*/ $acw62.createElement((0, $gVALr.default), {
        icon: icon,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        style: svgStyle
    }));
});
$7714637e9c1f1f3f$var$Icon.displayName = "AntdIcon";
$7714637e9c1f1f3f$var$Icon.getTwoToneColor = (0, $3qc8O.getTwoToneColor);
$7714637e9c1f1f3f$var$Icon.setTwoToneColor = (0, $3qc8O.setTwoToneColor);
var $7714637e9c1f1f3f$export$2e2bcd8739ae039 = $7714637e9c1f1f3f$var$Icon;

});
parcelRegister("gVALr", function(module, exports) {

$parcel$export(module.exports, "default", () => $c52e7cd4d4f30fad$export$2e2bcd8739ae039);

var $9X7IJ = parcelRequire("9X7IJ");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");

var $2oDWm = parcelRequire("2oDWm");
var $c52e7cd4d4f30fad$var$_excluded = [
    "icon",
    "className",
    "onClick",
    "style",
    "primaryColor",
    "secondaryColor"
];
var $c52e7cd4d4f30fad$var$twoToneColorPalette = {
    primaryColor: "#333",
    secondaryColor: "#E6E6E6",
    calculated: false
};
function $c52e7cd4d4f30fad$var$setTwoToneColors(_ref) {
    var primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
    $c52e7cd4d4f30fad$var$twoToneColorPalette.primaryColor = primaryColor;
    $c52e7cd4d4f30fad$var$twoToneColorPalette.secondaryColor = secondaryColor || (0, $2oDWm.getSecondaryColor)(primaryColor);
    $c52e7cd4d4f30fad$var$twoToneColorPalette.calculated = !!secondaryColor;
}
function $c52e7cd4d4f30fad$var$getTwoToneColors() {
    return (0, $d49SP.default)({}, $c52e7cd4d4f30fad$var$twoToneColorPalette);
}
var $c52e7cd4d4f30fad$var$IconBase = function IconBase(props) {
    var icon = props.icon, className = props.className, onClick = props.onClick, style = props.style, primaryColor = props.primaryColor, secondaryColor = props.secondaryColor, restProps = (0, $9X7IJ.default)(props, $c52e7cd4d4f30fad$var$_excluded);
    var svgRef = $acw62.useRef();
    var colors = $c52e7cd4d4f30fad$var$twoToneColorPalette;
    if (primaryColor) colors = {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor || (0, $2oDWm.getSecondaryColor)(primaryColor)
    };
    (0, $2oDWm.useInsertStyles)(svgRef);
    (0, $2oDWm.warning)((0, $2oDWm.isIconDefinition)(icon), "icon should be icon definiton, but got ".concat(icon));
    if (!(0, $2oDWm.isIconDefinition)(icon)) return null;
    var target = icon;
    if (target && typeof target.icon === "function") target = (0, $d49SP.default)((0, $d49SP.default)({}, target), {}, {
        icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
    return (0, $2oDWm.generate)(target.icon, "svg-".concat(target.name), (0, $d49SP.default)((0, $d49SP.default)({
        className: className,
        onClick: onClick,
        style: style,
        "data-icon": target.name,
        width: "1em",
        height: "1em",
        fill: "currentColor",
        "aria-hidden": "true"
    }, restProps), {}, {
        ref: svgRef
    }));
};
$c52e7cd4d4f30fad$var$IconBase.displayName = "IconReact";
$c52e7cd4d4f30fad$var$IconBase.getTwoToneColors = $c52e7cd4d4f30fad$var$getTwoToneColors;
$c52e7cd4d4f30fad$var$IconBase.setTwoToneColors = $c52e7cd4d4f30fad$var$setTwoToneColors;
var $c52e7cd4d4f30fad$export$2e2bcd8739ae039 = $c52e7cd4d4f30fad$var$IconBase;

});
parcelRegister("2oDWm", function(module, exports) {

$parcel$export(module.exports, "warning", () => $1beccdf56290315b$export$491112666e282270);
$parcel$export(module.exports, "isIconDefinition", () => $1beccdf56290315b$export$ab652842c37578f4);
$parcel$export(module.exports, "generate", () => $1beccdf56290315b$export$80d376111cc09ad7);
$parcel$export(module.exports, "getSecondaryColor", () => $1beccdf56290315b$export$b71c93f469694483);
$parcel$export(module.exports, "normalizeTwoToneColors", () => $1beccdf56290315b$export$b5b464c3d8433a9b);
$parcel$export(module.exports, "useInsertStyles", () => $1beccdf56290315b$export$938b1f86b61613d0);

var $d49SP = parcelRequire("d49SP");

var $fSwVM = parcelRequire("fSwVM");
parcelRequire("eIR68");
var $i1881 = parcelRequire("i1881");

var $4ZrBP = parcelRequire("4ZrBP");

var $fXR7w = parcelRequire("fXR7w");

var $u43uR = parcelRequire("u43uR");

var $acw62 = parcelRequire("acw62");

var $9f9mi = parcelRequire("9f9mi");
function $1beccdf56290315b$var$camelCase(input) {
    return input.replace(/-(.)/g, function(match, g) {
        return g.toUpperCase();
    });
}
function $1beccdf56290315b$export$491112666e282270(valid, message) {
    (0, $u43uR.default)(valid, "[@ant-design/icons] ".concat(message));
}
function $1beccdf56290315b$export$ab652842c37578f4(target) {
    return (0, $fSwVM.default)(target) === "object" && typeof target.name === "string" && typeof target.theme === "string" && ((0, $fSwVM.default)(target.icon) === "object" || typeof target.icon === "function");
}
function $1beccdf56290315b$export$9f5073e7201cc21c() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.keys(attrs).reduce(function(acc, key) {
        var val = attrs[key];
        switch(key){
            case "class":
                acc.className = val;
                delete acc.class;
                break;
            default:
                delete acc[key];
                acc[$1beccdf56290315b$var$camelCase(key)] = val;
        }
        return acc;
    }, {});
}
function $1beccdf56290315b$export$80d376111cc09ad7(node, key, rootProps) {
    if (!rootProps) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(node.tag, (0, $d49SP.default)({
        key: key
    }, $1beccdf56290315b$export$9f5073e7201cc21c(node.attrs)), (node.children || []).map(function(child, index) {
        return $1beccdf56290315b$export$80d376111cc09ad7(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(node.tag, (0, $d49SP.default)((0, $d49SP.default)({
        key: key
    }, $1beccdf56290315b$export$9f5073e7201cc21c(node.attrs)), rootProps), (node.children || []).map(function(child, index) {
        return $1beccdf56290315b$export$80d376111cc09ad7(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
}
function $1beccdf56290315b$export$b71c93f469694483(primaryColor) {
    // choose the second color
    return (0, $i1881.default)(primaryColor)[0];
}
function $1beccdf56290315b$export$b5b464c3d8433a9b(twoToneColor) {
    if (!twoToneColor) return [];
    return Array.isArray(twoToneColor) ? twoToneColor : [
        twoToneColor
    ];
}
var $1beccdf56290315b$export$960a899a9cccb2d5 = {
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    focusable: "false"
};
var $1beccdf56290315b$export$2c99b98b77550cb4 = "\n.anticon {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var $1beccdf56290315b$export$938b1f86b61613d0 = function useInsertStyles(eleRef) {
    var _useContext = (0, $acw62.useContext)((0, $9f9mi.default)), csp = _useContext.csp, prefixCls = _useContext.prefixCls;
    var mergedStyleStr = $1beccdf56290315b$export$2c99b98b77550cb4;
    if (prefixCls) mergedStyleStr = mergedStyleStr.replace(/anticon/g, prefixCls);
    (0, $acw62.useEffect)(function() {
        var ele = eleRef.current;
        var shadowRoot = (0, $fXR7w.getShadowRoot)(ele);
        (0, $4ZrBP.updateCSS)(mergedStyleStr, "@ant-design-icons", {
            prepend: true,
            csp: csp,
            attachTo: shadowRoot
        });
    }, []);
};

});
parcelRegister("fXR7w", function(module, exports) {

$parcel$export(module.exports, "getShadowRoot", () => $b9f59244e9def868$export$70e8259662bb498b);
function $b9f59244e9def868$var$getRoot(ele) {
    var _ele$getRootNode;
    return ele === null || ele === void 0 || (_ele$getRootNode = ele.getRootNode) === null || _ele$getRootNode === void 0 ? void 0 : _ele$getRootNode.call(ele);
}
function $b9f59244e9def868$export$cca82218ea4431a(ele) {
    return $b9f59244e9def868$var$getRoot(ele) instanceof ShadowRoot;
}
function $b9f59244e9def868$export$70e8259662bb498b(ele) {
    return $b9f59244e9def868$export$cca82218ea4431a(ele) ? $b9f59244e9def868$var$getRoot(ele) : null;
}

});



parcelRegister("3qc8O", function(module, exports) {

$parcel$export(module.exports, "setTwoToneColor", () => $27dd37ce58e7c6e8$export$8a145f34580ff02b);
$parcel$export(module.exports, "getTwoToneColor", () => $27dd37ce58e7c6e8$export$abc7c554784cb4a7);

var $eUqlC = parcelRequire("eUqlC");

var $gVALr = parcelRequire("gVALr");

var $2oDWm = parcelRequire("2oDWm");
function $27dd37ce58e7c6e8$export$8a145f34580ff02b(twoToneColor) {
    var _normalizeTwoToneColo = (0, $2oDWm.normalizeTwoToneColors)(twoToneColor), _normalizeTwoToneColo2 = (0, $eUqlC.default)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return (0, $gVALr.default).setTwoToneColors({
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    });
}
function $27dd37ce58e7c6e8$export$abc7c554784cb4a7() {
    var colors = (0, $gVALr.default).getTwoToneColors();
    if (!colors.calculated) return colors.primaryColor;
    return [
        colors.primaryColor,
        colors.secondaryColor
    ];
}

});




parcelRegister("5sLjr", function(module, exports) {

$parcel$export(module.exports, "prepareToken", () => $3fa444975abc8ac9$export$362fb92a8f81bbf9);
$parcel$export(module.exports, "prepareComponentToken", () => $3fa444975abc8ac9$export$9ca1be8807fe0675);
$parcel$export(module.exports, "default", () => $3fa444975abc8ac9$export$2e2bcd8739ae039);
parcelRequire("3i86m");
var $lpQ06 = parcelRequire("lpQ06");

var $670jt = parcelRequire("670jt");

var $P8Drj = parcelRequire("P8Drj");
var $2LRCS = parcelRequire("2LRCS");

var $djC1n = parcelRequire("djC1n");
// ============================== Shared ==============================
const $3fa444975abc8ac9$var$genSharedButtonStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, fontWeight: fontWeight } = token;
    return {
        [componentCls]: {
            outline: "none",
            position: "relative",
            display: "inline-block",
            fontWeight: fontWeight,
            whiteSpace: "nowrap",
            textAlign: "center",
            backgroundImage: "none",
            background: "transparent",
            border: `${(0, $lpQ06.unit)(token.lineWidth)} ${token.lineType} transparent`,
            cursor: "pointer",
            transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`,
            userSelect: "none",
            touchAction: "manipulation",
            lineHeight: token.lineHeight,
            color: token.colorText,
            "&:disabled > *": {
                pointerEvents: "none"
            },
            "> span": {
                display: "inline-block"
            },
            [`${componentCls}-icon`]: {
                lineHeight: 0
            },
            // Leave a space between icon and text.
            [`> ${iconCls} + span, > span + ${iconCls}`]: {
                marginInlineStart: token.marginXS
            },
            [`&:not(${componentCls}-icon-only) > ${componentCls}-icon`]: {
                [`&${componentCls}-loading-icon, &:not(:last-child)`]: {
                    marginInlineEnd: token.marginXS
                }
            },
            "> a": {
                color: "currentColor"
            },
            "&:not(:disabled)": Object.assign({}, (0, $670jt.genFocusStyle)(token)),
            [`&${componentCls}-two-chinese-chars::first-letter`]: {
                letterSpacing: "0.34em"
            },
            [`&${componentCls}-two-chinese-chars > *:not(${iconCls})`]: {
                marginInlineEnd: "-0.34em",
                letterSpacing: "0.34em"
            },
            // make `btn-icon-only` not too narrow
            [`&-icon-only${componentCls}-compact-item`]: {
                flex: "none"
            }
        }
    };
};
const $3fa444975abc8ac9$var$genHoverActiveButtonStyle = (btnCls, hoverStyle, activeStyle)=>({
        [`&:not(:disabled):not(${btnCls}-disabled)`]: {
            "&:hover": hoverStyle,
            "&:active": activeStyle
        }
    });
// ============================== Shape ===============================
const $3fa444975abc8ac9$var$genCircleButtonStyle = (token)=>({
        minWidth: token.controlHeight,
        paddingInlineStart: 0,
        paddingInlineEnd: 0,
        borderRadius: "50%"
    });
const $3fa444975abc8ac9$var$genRoundButtonStyle = (token)=>({
        borderRadius: token.controlHeight,
        paddingInlineStart: token.calc(token.controlHeight).div(2).equal(),
        paddingInlineEnd: token.calc(token.controlHeight).div(2).equal()
    });
// =============================== Type ===============================
const $3fa444975abc8ac9$var$genDisabledStyle = (token)=>({
        cursor: "not-allowed",
        borderColor: token.borderColorDisabled,
        color: token.colorTextDisabled,
        background: token.colorBgContainerDisabled,
        boxShadow: "none"
    });
const $3fa444975abc8ac9$var$genGhostButtonStyle = (btnCls, background, textColor, borderColor, textColorDisabled, borderColorDisabled, hoverStyle, activeStyle)=>({
        [`&${btnCls}-background-ghost`]: Object.assign(Object.assign({
            color: textColor || undefined,
            background: background,
            borderColor: borderColor || undefined,
            boxShadow: "none"
        }, $3fa444975abc8ac9$var$genHoverActiveButtonStyle(btnCls, Object.assign({
            background: background
        }, hoverStyle), Object.assign({
            background: background
        }, activeStyle))), {
            "&:disabled": {
                cursor: "not-allowed",
                color: textColorDisabled || undefined,
                borderColor: borderColorDisabled || undefined
            }
        })
    });
const $3fa444975abc8ac9$var$genSolidDisabledButtonStyle = (token)=>({
        [`&:disabled, &${token.componentCls}-disabled`]: Object.assign({}, $3fa444975abc8ac9$var$genDisabledStyle(token))
    });
const $3fa444975abc8ac9$var$genSolidButtonStyle = (token)=>Object.assign({}, $3fa444975abc8ac9$var$genSolidDisabledButtonStyle(token));
const $3fa444975abc8ac9$var$genPureDisabledButtonStyle = (token)=>({
        [`&:disabled, &${token.componentCls}-disabled`]: {
            cursor: "not-allowed",
            color: token.colorTextDisabled
        }
    });
// Type: Default
const $3fa444975abc8ac9$var$genDefaultButtonStyle = (token)=>Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, $3fa444975abc8ac9$var$genSolidButtonStyle(token)), {
        background: token.defaultBg,
        borderColor: token.defaultBorderColor,
        color: token.defaultColor,
        boxShadow: token.defaultShadow
    }), $3fa444975abc8ac9$var$genHoverActiveButtonStyle(token.componentCls, {
        color: token.colorPrimaryHover,
        borderColor: token.colorPrimaryHover
    }, {
        color: token.colorPrimaryActive,
        borderColor: token.colorPrimaryActive
    })), $3fa444975abc8ac9$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.defaultGhostColor, token.defaultGhostBorderColor, token.colorTextDisabled, token.colorBorder)), {
        [`&${token.componentCls}-dangerous`]: Object.assign(Object.assign(Object.assign({
            color: token.colorError,
            borderColor: token.colorError
        }, $3fa444975abc8ac9$var$genHoverActiveButtonStyle(token.componentCls, {
            color: token.colorErrorHover,
            borderColor: token.colorErrorBorderHover
        }, {
            color: token.colorErrorActive,
            borderColor: token.colorErrorActive
        })), $3fa444975abc8ac9$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorError, token.colorError, token.colorTextDisabled, token.colorBorder)), $3fa444975abc8ac9$var$genSolidDisabledButtonStyle(token))
    });
// Type: Primary
const $3fa444975abc8ac9$var$genPrimaryButtonStyle = (token)=>Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, $3fa444975abc8ac9$var$genSolidButtonStyle(token)), {
        color: token.primaryColor,
        background: token.colorPrimary,
        boxShadow: token.primaryShadow
    }), $3fa444975abc8ac9$var$genHoverActiveButtonStyle(token.componentCls, {
        color: token.colorTextLightSolid,
        background: token.colorPrimaryHover
    }, {
        color: token.colorTextLightSolid,
        background: token.colorPrimaryActive
    })), $3fa444975abc8ac9$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorPrimary, token.colorPrimary, token.colorTextDisabled, token.colorBorder, {
        color: token.colorPrimaryHover,
        borderColor: token.colorPrimaryHover
    }, {
        color: token.colorPrimaryActive,
        borderColor: token.colorPrimaryActive
    })), {
        [`&${token.componentCls}-dangerous`]: Object.assign(Object.assign(Object.assign({
            background: token.colorError,
            boxShadow: token.dangerShadow,
            color: token.dangerColor
        }, $3fa444975abc8ac9$var$genHoverActiveButtonStyle(token.componentCls, {
            background: token.colorErrorHover
        }, {
            background: token.colorErrorActive
        })), $3fa444975abc8ac9$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorError, token.colorError, token.colorTextDisabled, token.colorBorder, {
            color: token.colorErrorHover,
            borderColor: token.colorErrorHover
        }, {
            color: token.colorErrorActive,
            borderColor: token.colorErrorActive
        })), $3fa444975abc8ac9$var$genSolidDisabledButtonStyle(token))
    });
// Type: Dashed
const $3fa444975abc8ac9$var$genDashedButtonStyle = (token)=>Object.assign(Object.assign({}, $3fa444975abc8ac9$var$genDefaultButtonStyle(token)), {
        borderStyle: "dashed"
    });
// Type: Link
const $3fa444975abc8ac9$var$genLinkButtonStyle = (token)=>Object.assign(Object.assign(Object.assign({
        color: token.colorLink
    }, $3fa444975abc8ac9$var$genHoverActiveButtonStyle(token.componentCls, {
        color: token.colorLinkHover,
        background: token.linkHoverBg
    }, {
        color: token.colorLinkActive
    })), $3fa444975abc8ac9$var$genPureDisabledButtonStyle(token)), {
        [`&${token.componentCls}-dangerous`]: Object.assign(Object.assign({
            color: token.colorError
        }, $3fa444975abc8ac9$var$genHoverActiveButtonStyle(token.componentCls, {
            color: token.colorErrorHover
        }, {
            color: token.colorErrorActive
        })), $3fa444975abc8ac9$var$genPureDisabledButtonStyle(token))
    });
// Type: Text
const $3fa444975abc8ac9$var$genTextButtonStyle = (token)=>Object.assign(Object.assign(Object.assign({}, $3fa444975abc8ac9$var$genHoverActiveButtonStyle(token.componentCls, {
        color: token.colorText,
        background: token.textHoverBg
    }, {
        color: token.colorText,
        background: token.colorBgTextActive
    })), $3fa444975abc8ac9$var$genPureDisabledButtonStyle(token)), {
        [`&${token.componentCls}-dangerous`]: Object.assign(Object.assign({
            color: token.colorError
        }, $3fa444975abc8ac9$var$genPureDisabledButtonStyle(token)), $3fa444975abc8ac9$var$genHoverActiveButtonStyle(token.componentCls, {
            color: token.colorErrorHover,
            background: token.colorErrorBg
        }, {
            color: token.colorErrorHover,
            background: token.colorErrorBg
        }))
    });
const $3fa444975abc8ac9$var$genTypeButtonStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-default`]: $3fa444975abc8ac9$var$genDefaultButtonStyle(token),
        [`${componentCls}-primary`]: $3fa444975abc8ac9$var$genPrimaryButtonStyle(token),
        [`${componentCls}-dashed`]: $3fa444975abc8ac9$var$genDashedButtonStyle(token),
        [`${componentCls}-link`]: $3fa444975abc8ac9$var$genLinkButtonStyle(token),
        [`${componentCls}-text`]: $3fa444975abc8ac9$var$genTextButtonStyle(token),
        [`${componentCls}-ghost`]: $3fa444975abc8ac9$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorBgContainer, token.colorBgContainer, token.colorTextDisabled, token.colorBorder)
    };
};
// =============================== Size ===============================
const $3fa444975abc8ac9$var$genSizeButtonStyle = function(token) {
    let sizePrefixCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    const { componentCls: componentCls, controlHeight: controlHeight, fontSize: fontSize, borderRadius: borderRadius, buttonPaddingHorizontal: buttonPaddingHorizontal, iconCls: iconCls, buttonPaddingVertical: buttonPaddingVertical } = token;
    const iconOnlyCls = `${componentCls}-icon-only`;
    return [
        // Size
        {
            [`${componentCls}${sizePrefixCls}`]: {
                fontSize: fontSize,
                height: controlHeight,
                padding: `${(0, $lpQ06.unit)(buttonPaddingVertical)} ${(0, $lpQ06.unit)(buttonPaddingHorizontal)}`,
                borderRadius: borderRadius,
                [`&${iconOnlyCls}`]: {
                    width: controlHeight,
                    paddingInlineStart: 0,
                    paddingInlineEnd: 0,
                    [`&${componentCls}-round`]: {
                        width: "auto"
                    },
                    [iconCls]: {
                        fontSize: token.buttonIconOnlyFontSize
                    }
                },
                // Loading
                [`&${componentCls}-loading`]: {
                    opacity: token.opacityLoading,
                    cursor: "default"
                },
                [`${componentCls}-loading-icon`]: {
                    transition: `width ${token.motionDurationSlow} ${token.motionEaseInOut}, opacity ${token.motionDurationSlow} ${token.motionEaseInOut}`
                }
            }
        },
        // Shape - patch prefixCls again to override solid border radius style
        {
            [`${componentCls}${componentCls}-circle${sizePrefixCls}`]: $3fa444975abc8ac9$var$genCircleButtonStyle(token)
        },
        {
            [`${componentCls}${componentCls}-round${sizePrefixCls}`]: $3fa444975abc8ac9$var$genRoundButtonStyle(token)
        }
    ];
};
const $3fa444975abc8ac9$var$genSizeBaseButtonStyle = (token)=>$3fa444975abc8ac9$var$genSizeButtonStyle((0, $2LRCS.merge)(token, {
        fontSize: token.contentFontSize
    }));
const $3fa444975abc8ac9$var$genSizeSmallButtonStyle = (token)=>{
    const smallToken = (0, $2LRCS.merge)(token, {
        controlHeight: token.controlHeightSM,
        fontSize: token.contentFontSizeSM,
        padding: token.paddingXS,
        buttonPaddingHorizontal: token.paddingInlineSM,
        buttonPaddingVertical: token.paddingBlockSM,
        borderRadius: token.borderRadiusSM,
        buttonIconOnlyFontSize: token.onlyIconSizeSM
    });
    return $3fa444975abc8ac9$var$genSizeButtonStyle(smallToken, `${token.componentCls}-sm`);
};
const $3fa444975abc8ac9$var$genSizeLargeButtonStyle = (token)=>{
    const largeToken = (0, $2LRCS.merge)(token, {
        controlHeight: token.controlHeightLG,
        fontSize: token.contentFontSizeLG,
        buttonPaddingHorizontal: token.paddingInlineLG,
        buttonPaddingVertical: token.paddingBlockLG,
        borderRadius: token.borderRadiusLG,
        buttonIconOnlyFontSize: token.onlyIconSizeLG
    });
    return $3fa444975abc8ac9$var$genSizeButtonStyle(largeToken, `${token.componentCls}-lg`);
};
const $3fa444975abc8ac9$var$genBlockButtonStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            [`&${componentCls}-block`]: {
                width: "100%"
            }
        }
    };
};
const $3fa444975abc8ac9$export$362fb92a8f81bbf9 = (token)=>{
    const { paddingInline: paddingInline, onlyIconSize: onlyIconSize, paddingBlock: paddingBlock } = token;
    const buttonToken = (0, $2LRCS.merge)(token, {
        buttonPaddingHorizontal: paddingInline,
        buttonPaddingVertical: paddingBlock,
        buttonIconOnlyFontSize: onlyIconSize
    });
    return buttonToken;
};
const $3fa444975abc8ac9$export$9ca1be8807fe0675 = (token)=>{
    const contentFontSize = token.fontSize;
    const contentFontSizeSM = token.fontSize;
    const contentFontSizeLG = token.fontSizeLG;
    return {
        fontWeight: 400,
        defaultShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlTmpOutline}`,
        primaryShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlOutline}`,
        dangerShadow: `0 ${token.controlOutlineWidth}px 0 ${token.colorErrorOutline}`,
        primaryColor: token.colorTextLightSolid,
        dangerColor: token.colorTextLightSolid,
        borderColorDisabled: token.colorBorder,
        defaultGhostColor: token.colorBgContainer,
        ghostBg: "transparent",
        defaultGhostBorderColor: token.colorBgContainer,
        paddingInline: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineLG: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineSM: 8 - token.lineWidth,
        paddingBlock: Math.max((token.controlHeight - contentFontSize * token.lineHeight) / 2 - token.lineWidth, 0),
        paddingBlockSM: Math.max((token.controlHeightSM - contentFontSizeSM * token.lineHeight) / 2 - token.lineWidth, 0),
        paddingBlockLG: Math.max((token.controlHeightLG - contentFontSizeLG * token.lineHeight) / 2 - token.lineWidth, 0),
        onlyIconSize: token.fontSizeLG,
        onlyIconSizeSM: token.fontSizeLG - 2,
        onlyIconSizeLG: token.fontSizeLG + 2,
        groupBorderColor: token.colorPrimaryHover,
        linkHoverBg: "transparent",
        textHoverBg: token.colorBgTextHover,
        defaultColor: token.colorText,
        defaultBg: token.colorBgContainer,
        defaultBorderColor: token.colorBorder,
        defaultBorderColorDisabled: token.colorBorder,
        contentFontSize: contentFontSize,
        contentFontSizeSM: contentFontSizeSM,
        contentFontSizeLG: contentFontSizeLG
    };
};
var $3fa444975abc8ac9$export$2e2bcd8739ae039 = (0, $P8Drj.genStyleHooks)("Button", (token)=>{
    const buttonToken = $3fa444975abc8ac9$export$362fb92a8f81bbf9(token);
    return [
        // Shared
        $3fa444975abc8ac9$var$genSharedButtonStyle(buttonToken),
        // Size
        $3fa444975abc8ac9$var$genSizeSmallButtonStyle(buttonToken),
        $3fa444975abc8ac9$var$genSizeBaseButtonStyle(buttonToken),
        $3fa444975abc8ac9$var$genSizeLargeButtonStyle(buttonToken),
        // Block
        $3fa444975abc8ac9$var$genBlockButtonStyle(buttonToken),
        // Group (type, ghost, danger, loading)
        $3fa444975abc8ac9$var$genTypeButtonStyle(buttonToken),
        // Button Group
        (0, $djC1n.default)(buttonToken)
    ];
}, $3fa444975abc8ac9$export$9ca1be8807fe0675, {
    unitless: {
        fontWeight: true
    }
});

});
parcelRegister("djC1n", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b1a8aea1f437a60$export$2e2bcd8739ae039);
const $9b1a8aea1f437a60$var$genButtonBorderStyle = (buttonTypeCls, borderColor)=>({
        // Border
        [`> span, > ${buttonTypeCls}`]: {
            "&:not(:last-child)": {
                [`&, & > ${buttonTypeCls}`]: {
                    "&:not(:disabled)": {
                        borderInlineEndColor: borderColor
                    }
                }
            },
            "&:not(:first-child)": {
                [`&, & > ${buttonTypeCls}`]: {
                    "&:not(:disabled)": {
                        borderInlineStartColor: borderColor
                    }
                }
            }
        }
    });
const $9b1a8aea1f437a60$var$genGroupStyle = (token)=>{
    const { componentCls: componentCls, fontSize: fontSize, lineWidth: lineWidth, groupBorderColor: groupBorderColor, colorErrorHover: colorErrorHover } = token;
    return {
        [`${componentCls}-group`]: [
            {
                position: "relative",
                display: "inline-flex",
                // Border
                [`> span, > ${componentCls}`]: {
                    "&:not(:last-child)": {
                        [`&, & > ${componentCls}`]: {
                            borderStartEndRadius: 0,
                            borderEndEndRadius: 0
                        }
                    },
                    "&:not(:first-child)": {
                        marginInlineStart: token.calc(lineWidth).mul(-1).equal(),
                        [`&, & > ${componentCls}`]: {
                            borderStartStartRadius: 0,
                            borderEndStartRadius: 0
                        }
                    }
                },
                [componentCls]: {
                    position: "relative",
                    zIndex: 1,
                    [`&:hover,
          &:focus,
          &:active`]: {
                        zIndex: 2
                    },
                    "&[disabled]": {
                        zIndex: 0
                    }
                },
                [`${componentCls}-icon-only`]: {
                    fontSize: fontSize
                }
            },
            // Border Color
            $9b1a8aea1f437a60$var$genButtonBorderStyle(`${componentCls}-primary`, groupBorderColor),
            $9b1a8aea1f437a60$var$genButtonBorderStyle(`${componentCls}-danger`, colorErrorHover)
        ]
    };
};
var $9b1a8aea1f437a60$export$2e2bcd8739ae039 = $9b1a8aea1f437a60$var$genGroupStyle;

});


parcelRegister("ilFXF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5babcd62cf57d30$export$2e2bcd8739ae039);

var $5sLjr = parcelRequire("5sLjr");

var $1g5Jl = parcelRequire("1g5Jl");

var $9wBd2 = parcelRequire("9wBd2");

var $P8Drj = parcelRequire("P8Drj");
parcelRequire("3i86m");
var $lpQ06 = parcelRequire("lpQ06");
const $d5babcd62cf57d30$var$genButtonCompactStyle = (token)=>{
    const { componentCls: componentCls, calc: calc } = token;
    return {
        [componentCls]: {
            // Special styles for Primary Button
            [`&-compact-item${componentCls}-primary`]: {
                [`&:not([disabled]) + ${componentCls}-compact-item${componentCls}-primary:not([disabled])`]: {
                    position: "relative",
                    "&:before": {
                        position: "absolute",
                        top: calc(token.lineWidth).mul(-1).equal(),
                        insetInlineStart: calc(token.lineWidth).mul(-1).equal(),
                        display: "inline-block",
                        width: token.lineWidth,
                        height: `calc(100% + ${(0, $lpQ06.unit)(token.lineWidth)} * 2)`,
                        backgroundColor: token.colorPrimaryHover,
                        content: '""'
                    }
                }
            },
            // Special styles for Primary Button
            "&-compact-vertical-item": {
                [`&${componentCls}-primary`]: {
                    [`&:not([disabled]) + ${componentCls}-compact-vertical-item${componentCls}-primary:not([disabled])`]: {
                        position: "relative",
                        "&:before": {
                            position: "absolute",
                            top: calc(token.lineWidth).mul(-1).equal(),
                            insetInlineStart: calc(token.lineWidth).mul(-1).equal(),
                            display: "inline-block",
                            width: `calc(100% + ${(0, $lpQ06.unit)(token.lineWidth)} * 2)`,
                            height: token.lineWidth,
                            backgroundColor: token.colorPrimaryHover,
                            content: '""'
                        }
                    }
                }
            }
        }
    };
};
var // ============================== Export ==============================
$d5babcd62cf57d30$export$2e2bcd8739ae039 = (0, $P8Drj.genSubStyleComponent)([
    "Button",
    "compact"
], (token)=>{
    const buttonToken = (0, $5sLjr.prepareToken)(token);
    return [
        // Space Compact
        (0, $1g5Jl.genCompactItemStyle)(buttonToken),
        (0, $9wBd2.genCompactItemVerticalStyle)(buttonToken),
        $d5babcd62cf57d30$var$genButtonCompactStyle(buttonToken)
    ];
}, (0, $5sLjr.prepareComponentToken));

});
parcelRegister("1g5Jl", function(module, exports) {

$parcel$export(module.exports, "genCompactItemStyle", () => $0eabbafc4673511e$export$b1208b23589b4b73);
// handle border collapse
function $0eabbafc4673511e$var$compactItemBorder(token, parentCls, options) {
    const { focusElCls: focusElCls, focus: focus, borderElCls: borderElCls } = options;
    const childCombinator = borderElCls ? "> *" : "";
    const hoverEffects = [
        "hover",
        focus ? "focus" : null,
        "active"
    ].filter(Boolean).map((n)=>`&:${n} ${childCombinator}`).join(",");
    return {
        [`&-item:not(${parentCls}-last-item)`]: {
            marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal()
        },
        "&-item": Object.assign(Object.assign({
            [hoverEffects]: {
                zIndex: 2
            }
        }, focusElCls ? {
            [`&${focusElCls}`]: {
                zIndex: 2
            }
        } : {}), {
            [`&[disabled] ${childCombinator}`]: {
                zIndex: 0
            }
        })
    };
}
// handle border-radius
function $0eabbafc4673511e$var$compactItemBorderRadius(prefixCls, parentCls, options) {
    const { borderElCls: borderElCls } = options;
    const childCombinator = borderElCls ? `> ${borderElCls}` : "";
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item) ${childCombinator}`]: {
            borderRadius: 0
        },
        [`&-item:not(${parentCls}-last-item)${parentCls}-first-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`&-item:not(${parentCls}-first-item)${parentCls}-last-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        }
    };
}
function $0eabbafc4673511e$export$b1208b23589b4b73(token) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        focus: true
    };
    const { componentCls: componentCls } = token;
    const compactCls = `${componentCls}-compact`;
    return {
        [compactCls]: Object.assign(Object.assign({}, $0eabbafc4673511e$var$compactItemBorder(token, compactCls, options)), $0eabbafc4673511e$var$compactItemBorderRadius(componentCls, compactCls, options))
    };
}

});

parcelRegister("9wBd2", function(module, exports) {

$parcel$export(module.exports, "genCompactItemVerticalStyle", () => $6ef3f73594535ba5$export$4dc87cb8ebf78ac6);
function $6ef3f73594535ba5$var$compactItemVerticalBorder(token, parentCls) {
    return {
        // border collapse
        [`&-item:not(${parentCls}-last-item)`]: {
            marginBottom: token.calc(token.lineWidth).mul(-1).equal()
        },
        "&-item": {
            "&:hover,&:focus,&:active": {
                zIndex: 2
            },
            "&[disabled]": {
                zIndex: 0
            }
        }
    };
}
function $6ef3f73594535ba5$var$compactItemBorderVerticalRadius(prefixCls, parentCls) {
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item)`]: {
            borderRadius: 0
        },
        [`&-item${parentCls}-first-item:not(${parentCls}-last-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderEndEndRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`&-item${parentCls}-last-item:not(${parentCls}-first-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderStartStartRadius: 0,
                borderStartEndRadius: 0
            }
        }
    };
}
function $6ef3f73594535ba5$export$4dc87cb8ebf78ac6(token) {
    const compactCls = `${token.componentCls}-compact-vertical`;
    return {
        [compactCls]: Object.assign(Object.assign({}, $6ef3f73594535ba5$var$compactItemVerticalBorder(token, compactCls)), $6ef3f73594535ba5$var$compactItemBorderVerticalRadius(token.componentCls, compactCls))
    };
}

});




parcelRegister("jnHKE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1c21a702bf20ca7$export$2e2bcd8739ae039);

var $aMQC3 = parcelRequire("aMQC3");

var $gWZ4x = parcelRequire("gWZ4x");

var $kZiF8 = parcelRequire("kZiF8");
"use client";
const $e1c21a702bf20ca7$var$Card = (0, $aMQC3.default);
$e1c21a702bf20ca7$var$Card.Grid = (0, $gWZ4x.default);
$e1c21a702bf20ca7$var$Card.Meta = (0, $kZiF8.default);
var $e1c21a702bf20ca7$export$2e2bcd8739ae039 = $e1c21a702bf20ca7$var$Card;

});
parcelRegister("aMQC3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7da732e5b8f158a2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $1pcHX = parcelRequire("1pcHX");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $IFe7R = parcelRequire("IFe7R");

var $fXDDJ = parcelRequire("fXDDJ");

var $4RmmN = parcelRequire("4RmmN");

var $gWZ4x = parcelRequire("gWZ4x");

var $gCOq5 = parcelRequire("gCOq5");
"use client";
var $7da732e5b8f158a2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $7da732e5b8f158a2$var$ActionNode = (props)=>{
    const { prefixCls: prefixCls, actions: actions = [] } = props;
    return /*#__PURE__*/ $acw62.createElement("ul", {
        className: `${prefixCls}-actions`
    }, actions.map((action, index)=>{
        // Move this out since eslint not allow index key
        // And eslint-disable makes conflict with rollup
        // ref https://github.com/ant-design/ant-design/issues/46022
        const key = `action-${index}`;
        return /*#__PURE__*/ $acw62.createElement("li", {
            style: {
                width: `${100 / actions.length}%`
            },
            key: key
        }, /*#__PURE__*/ $acw62.createElement("span", null, action));
    }));
};
const $7da732e5b8f158a2$var$Card = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, extra: extra, headStyle: headStyle = {}, bodyStyle: bodyStyle = {}, title: title, loading: loading, bordered: bordered = true, size: customizeSize, type: type, cover: cover, actions: actions, tabList: tabList, children: children, activeTabKey: activeTabKey, defaultActiveTabKey: defaultActiveTabKey, tabBarExtraContent: tabBarExtraContent, hoverable: hoverable, tabProps: tabProps = {} } = props, others = $7da732e5b8f158a2$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "style",
        "extra",
        "headStyle",
        "bodyStyle",
        "title",
        "loading",
        "bordered",
        "size",
        "type",
        "cover",
        "actions",
        "tabList",
        "children",
        "activeTabKey",
        "defaultActiveTabKey",
        "tabBarExtraContent",
        "hoverable",
        "tabProps"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, card: card } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const onTabChange = (key)=>{
        var _a;
        (_a = props.onTabChange) === null || _a === void 0 || _a.call(props, key);
    };
    const isContainGrid = $acw62.useMemo(()=>{
        let containGrid = false;
        $acw62.Children.forEach(children, (element)=>{
            if (element && element.type && element.type === (0, $gWZ4x.default)) containGrid = true;
        });
        return containGrid;
    }, [
        children
    ]);
    const prefixCls = getPrefixCls("card", customizePrefixCls);
    const [wrapCSSVar, hashId] = (0, $gCOq5.default)(prefixCls);
    const loadingBlock = /*#__PURE__*/ $acw62.createElement((0, $fXDDJ.default), {
        loading: true,
        active: true,
        paragraph: {
            rows: 4
        },
        title: false
    }, children);
    const hasActiveTabKey = activeTabKey !== undefined;
    const extraProps = Object.assign(Object.assign({}, tabProps), {
        [hasActiveTabKey ? "activeKey" : "defaultActiveKey"]: hasActiveTabKey ? activeTabKey : defaultActiveTabKey,
        tabBarExtraContent: tabBarExtraContent
    });
    let head;
    const mergedSize = (0, $IFe7R.default)(customizeSize);
    const tabSize = !mergedSize || mergedSize === "default" ? "large" : mergedSize;
    const tabs = tabList ? /*#__PURE__*/ $acw62.createElement((0, $4RmmN.default), Object.assign({
        size: tabSize
    }, extraProps, {
        className: `${prefixCls}-head-tabs`,
        onChange: onTabChange,
        items: tabList.map((_a)=>{
            var { tab: tab } = _a, item = $7da732e5b8f158a2$var$__rest(_a, [
                "tab"
            ]);
            return Object.assign({
                label: tab
            }, item);
        })
    })) : null;
    if (title || extra || tabs) head = /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-head`,
        style: headStyle
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-head-wrapper`
    }, title && /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-head-title`
    }, title), extra && /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-extra`
    }, extra)), tabs);
    const coverDom = cover ? /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-cover`
    }, cover) : null;
    const body = /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-body`,
        style: bodyStyle
    }, loading ? loadingBlock : children);
    const actionDom = actions && actions.length ? /*#__PURE__*/ $acw62.createElement($7da732e5b8f158a2$var$ActionNode, {
        prefixCls: prefixCls,
        actions: actions
    }) : null;
    const divProps = (0, $1pcHX.default)(others, [
        "onTabChange"
    ]);
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, card === null || card === void 0 ? void 0 : card.className, {
        [`${prefixCls}-loading`]: loading,
        [`${prefixCls}-bordered`]: bordered,
        [`${prefixCls}-hoverable`]: hoverable,
        [`${prefixCls}-contain-grid`]: isContainGrid,
        [`${prefixCls}-contain-tabs`]: tabList && tabList.length,
        [`${prefixCls}-${mergedSize}`]: mergedSize,
        [`${prefixCls}-type-${type}`]: !!type,
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, className, rootClassName, hashId);
    const mergedStyle = Object.assign(Object.assign({}, card === null || card === void 0 ? void 0 : card.style), style);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", Object.assign({
        ref: ref
    }, divProps, {
        className: classString,
        style: mergedStyle
    }), head, coverDom, body, actionDom));
});
var $7da732e5b8f158a2$export$2e2bcd8739ae039 = $7da732e5b8f158a2$var$Card;

});
parcelRegister("fXDDJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9eb1d5949d003b0$export$2e2bcd8739ae039);

var $25V4R = parcelRequire("25V4R");
"use client";
var $b9eb1d5949d003b0$export$2e2bcd8739ae039 = (0, $25V4R.default);

});
parcelRegister("25V4R", function(module, exports) {

$parcel$export(module.exports, "default", () => $186852cf13bfcae4$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $lS0JL = parcelRequire("lS0JL");

var $1HMFo = parcelRequire("1HMFo");

var $aFpUb = parcelRequire("aFpUb");

var $3RZh4 = parcelRequire("3RZh4");

var $cwFgH = parcelRequire("cwFgH");

var $3vdYo = parcelRequire("3vdYo");

var $jabNw = parcelRequire("jabNw");

var $ioy4t = parcelRequire("ioy4t");

var $hec2U = parcelRequire("hec2U");
"use client";
function $186852cf13bfcae4$var$getComponentProps(prop) {
    if (prop && typeof prop === "object") return prop;
    return {};
}
function $186852cf13bfcae4$var$getAvatarBasicProps(hasTitle, hasParagraph) {
    if (hasTitle && !hasParagraph) // Square avatar
    return {
        size: "large",
        shape: "square"
    };
    return {
        size: "large",
        shape: "circle"
    };
}
function $186852cf13bfcae4$var$getTitleBasicProps(hasAvatar, hasParagraph) {
    if (!hasAvatar && hasParagraph) return {
        width: "38%"
    };
    if (hasAvatar && hasParagraph) return {
        width: "50%"
    };
    return {};
}
function $186852cf13bfcae4$var$getParagraphBasicProps(hasAvatar, hasTitle) {
    const basicProps = {};
    // Width
    if (!hasAvatar || !hasTitle) basicProps.width = "61%";
    // Rows
    if (!hasAvatar && hasTitle) basicProps.rows = 3;
    else basicProps.rows = 2;
    return basicProps;
}
const $186852cf13bfcae4$var$Skeleton = (props)=>{
    const { prefixCls: customizePrefixCls, loading: loading, className: className, rootClassName: rootClassName, style: style, children: children, avatar: avatar = false, title: title = true, paragraph: paragraph = true, active: active, round: round } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, skeleton: skeleton } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    const [wrapCSSVar, hashId] = (0, $hec2U.default)(prefixCls);
    if (loading || !("loading" in props)) {
        const hasAvatar = !!avatar;
        const hasTitle = !!title;
        const hasParagraph = !!paragraph;
        // Avatar
        let avatarNode;
        if (hasAvatar) {
            const avatarProps = Object.assign(Object.assign({
                prefixCls: `${prefixCls}-avatar`
            }, $186852cf13bfcae4$var$getAvatarBasicProps(hasTitle, hasParagraph)), $186852cf13bfcae4$var$getComponentProps(avatar));
            // We direct use SkeletonElement as avatar in skeleton internal.
            avatarNode = /*#__PURE__*/ $acw62.createElement("div", {
                className: `${prefixCls}-header`
            }, /*#__PURE__*/ $acw62.createElement((0, $aFpUb.default), Object.assign({}, avatarProps)));
        }
        let contentNode;
        if (hasTitle || hasParagraph) {
            // Title
            let $title;
            if (hasTitle) {
                const titleProps = Object.assign(Object.assign({
                    prefixCls: `${prefixCls}-title`
                }, $186852cf13bfcae4$var$getTitleBasicProps(hasAvatar, hasParagraph)), $186852cf13bfcae4$var$getComponentProps(title));
                $title = /*#__PURE__*/ $acw62.createElement((0, $ioy4t.default), Object.assign({}, titleProps));
            }
            // Paragraph
            let paragraphNode;
            if (hasParagraph) {
                const paragraphProps = Object.assign(Object.assign({
                    prefixCls: `${prefixCls}-paragraph`
                }, $186852cf13bfcae4$var$getParagraphBasicProps(hasAvatar, hasTitle)), $186852cf13bfcae4$var$getComponentProps(paragraph));
                paragraphNode = /*#__PURE__*/ $acw62.createElement((0, $jabNw.default), Object.assign({}, paragraphProps));
            }
            contentNode = /*#__PURE__*/ $acw62.createElement("div", {
                className: `${prefixCls}-content`
            }, $title, paragraphNode);
        }
        const cls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, {
            [`${prefixCls}-with-avatar`]: hasAvatar,
            [`${prefixCls}-active`]: active,
            [`${prefixCls}-rtl`]: direction === "rtl",
            [`${prefixCls}-round`]: round
        }, skeleton === null || skeleton === void 0 ? void 0 : skeleton.className, className, rootClassName, hashId);
        return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", {
            className: cls,
            style: Object.assign(Object.assign({}, skeleton === null || skeleton === void 0 ? void 0 : skeleton.style), style)
        }, avatarNode, contentNode));
    }
    return typeof children !== "undefined" ? children : null;
};
$186852cf13bfcae4$var$Skeleton.Button = (0, $1HMFo.default);
$186852cf13bfcae4$var$Skeleton.Avatar = (0, $lS0JL.default);
$186852cf13bfcae4$var$Skeleton.Input = (0, $cwFgH.default);
$186852cf13bfcae4$var$Skeleton.Image = (0, $3RZh4.default);
$186852cf13bfcae4$var$Skeleton.Node = (0, $3vdYo.default);
var $186852cf13bfcae4$export$2e2bcd8739ae039 = $186852cf13bfcae4$var$Skeleton;

});
parcelRegister("lS0JL", function(module, exports) {

$parcel$export(module.exports, "default", () => $febf367e4c351696$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $1pcHX = parcelRequire("1pcHX");

var $acw62 = parcelRequire("acw62");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $aFpUb = parcelRequire("aFpUb");

var $hec2U = parcelRequire("hec2U");
"use client";
const $febf367e4c351696$var$SkeletonAvatar = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, active: active, shape: shape = "circle", size: size = "default" } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    const [wrapCSSVar, hashId] = (0, $hec2U.default)(prefixCls);
    const otherProps = (0, $1pcHX.default)(props, [
        "prefixCls",
        "className"
    ]);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, className, rootClassName, hashId);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $acw62.createElement((0, $aFpUb.default), Object.assign({
        prefixCls: `${prefixCls}-avatar`,
        shape: shape,
        size: size
    }, otherProps))));
};
var $febf367e4c351696$export$2e2bcd8739ae039 = $febf367e4c351696$var$SkeletonAvatar;

});
parcelRegister("aFpUb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c41d3edfd4df78b$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
"use client";
const $7c41d3edfd4df78b$var$Element = (props)=>{
    const { prefixCls: prefixCls, className: className, style: style, size: size, shape: shape } = props;
    const sizeCls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
        [`${prefixCls}-lg`]: size === "large",
        [`${prefixCls}-sm`]: size === "small"
    });
    const shapeCls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
        [`${prefixCls}-circle`]: shape === "circle",
        [`${prefixCls}-square`]: shape === "square",
        [`${prefixCls}-round`]: shape === "round"
    });
    const sizeStyle = $acw62.useMemo(()=>typeof size === "number" ? {
            width: size,
            height: size,
            lineHeight: `${size}px`
        } : {}, [
        size
    ]);
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, sizeCls, shapeCls, className),
        style: Object.assign(Object.assign({}, sizeStyle), style)
    });
};
var $7c41d3edfd4df78b$export$2e2bcd8739ae039 = $7c41d3edfd4df78b$var$Element;

});

parcelRegister("hec2U", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8ad1686c6f1e1ca$export$2e2bcd8739ae039);
parcelRequire("3i86m");
var $hsEk2 = parcelRequire("hsEk2");
var $lpQ06 = parcelRequire("lpQ06");

var $P8Drj = parcelRequire("P8Drj");
var $2LRCS = parcelRequire("2LRCS");
"use client";
const $c8ad1686c6f1e1ca$var$skeletonClsLoading = new (0, $hsEk2.default)(`ant-skeleton-loading`, {
    "0%": {
        backgroundPosition: "100% 50%"
    },
    "100%": {
        backgroundPosition: "0 50%"
    }
});
const $c8ad1686c6f1e1ca$var$genSkeletonElementCommonSize = (size)=>({
        height: size,
        lineHeight: (0, $lpQ06.unit)(size)
    });
const $c8ad1686c6f1e1ca$var$genSkeletonElementAvatarSize = (size)=>Object.assign({
        width: size
    }, $c8ad1686c6f1e1ca$var$genSkeletonElementCommonSize(size));
const $c8ad1686c6f1e1ca$var$genSkeletonColor = (token)=>({
        background: token.skeletonLoadingBackground,
        backgroundSize: "400% 100%",
        animationName: $c8ad1686c6f1e1ca$var$skeletonClsLoading,
        animationDuration: token.skeletonLoadingMotionDuration,
        animationTimingFunction: "ease",
        animationIterationCount: "infinite"
    });
const $c8ad1686c6f1e1ca$var$genSkeletonElementInputSize = (size, calc)=>Object.assign({
        width: calc(size).mul(5).equal(),
        minWidth: calc(size).mul(5).equal()
    }, $c8ad1686c6f1e1ca$var$genSkeletonElementCommonSize(size));
const $c8ad1686c6f1e1ca$var$genSkeletonElementAvatar = (token)=>{
    const { skeletonAvatarCls: skeletonAvatarCls, gradientFromColor: gradientFromColor, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM } = token;
    return {
        [`${skeletonAvatarCls}`]: Object.assign({
            display: "inline-block",
            verticalAlign: "top",
            background: gradientFromColor
        }, $c8ad1686c6f1e1ca$var$genSkeletonElementAvatarSize(controlHeight)),
        [`${skeletonAvatarCls}${skeletonAvatarCls}-circle`]: {
            borderRadius: "50%"
        },
        [`${skeletonAvatarCls}${skeletonAvatarCls}-lg`]: Object.assign({}, $c8ad1686c6f1e1ca$var$genSkeletonElementAvatarSize(controlHeightLG)),
        [`${skeletonAvatarCls}${skeletonAvatarCls}-sm`]: Object.assign({}, $c8ad1686c6f1e1ca$var$genSkeletonElementAvatarSize(controlHeightSM))
    };
};
const $c8ad1686c6f1e1ca$var$genSkeletonElementInput = (token)=>{
    const { controlHeight: controlHeight, borderRadiusSM: borderRadiusSM, skeletonInputCls: skeletonInputCls, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, calc: calc } = token;
    return {
        [`${skeletonInputCls}`]: Object.assign({
            display: "inline-block",
            verticalAlign: "top",
            background: gradientFromColor,
            borderRadius: borderRadiusSM
        }, $c8ad1686c6f1e1ca$var$genSkeletonElementInputSize(controlHeight, calc)),
        [`${skeletonInputCls}-lg`]: Object.assign({}, $c8ad1686c6f1e1ca$var$genSkeletonElementInputSize(controlHeightLG, calc)),
        [`${skeletonInputCls}-sm`]: Object.assign({}, $c8ad1686c6f1e1ca$var$genSkeletonElementInputSize(controlHeightSM, calc))
    };
};
const $c8ad1686c6f1e1ca$var$genSkeletonElementImageSize = (size)=>Object.assign({
        width: size
    }, $c8ad1686c6f1e1ca$var$genSkeletonElementCommonSize(size));
const $c8ad1686c6f1e1ca$var$genSkeletonElementImage = (token)=>{
    const { skeletonImageCls: skeletonImageCls, imageSizeBase: imageSizeBase, gradientFromColor: gradientFromColor, borderRadiusSM: borderRadiusSM, calc: calc } = token;
    return {
        [`${skeletonImageCls}`]: Object.assign(Object.assign({
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            verticalAlign: "top",
            background: gradientFromColor,
            borderRadius: borderRadiusSM
        }, $c8ad1686c6f1e1ca$var$genSkeletonElementImageSize(calc(imageSizeBase).mul(2).equal())), {
            [`${skeletonImageCls}-path`]: {
                fill: "#bfbfbf"
            },
            [`${skeletonImageCls}-svg`]: Object.assign(Object.assign({}, $c8ad1686c6f1e1ca$var$genSkeletonElementImageSize(imageSizeBase)), {
                maxWidth: calc(imageSizeBase).mul(4).equal(),
                maxHeight: calc(imageSizeBase).mul(4).equal()
            }),
            [`${skeletonImageCls}-svg${skeletonImageCls}-svg-circle`]: {
                borderRadius: "50%"
            }
        }),
        [`${skeletonImageCls}${skeletonImageCls}-circle`]: {
            borderRadius: "50%"
        }
    };
};
const $c8ad1686c6f1e1ca$var$genSkeletonElementButtonShape = (token, size, buttonCls)=>{
    const { skeletonButtonCls: skeletonButtonCls } = token;
    return {
        [`${buttonCls}${skeletonButtonCls}-circle`]: {
            width: size,
            minWidth: size,
            borderRadius: "50%"
        },
        [`${buttonCls}${skeletonButtonCls}-round`]: {
            borderRadius: size
        }
    };
};
const $c8ad1686c6f1e1ca$var$genSkeletonElementButtonSize = (size, calc)=>Object.assign({
        width: calc(size).mul(2).equal(),
        minWidth: calc(size).mul(2).equal()
    }, $c8ad1686c6f1e1ca$var$genSkeletonElementCommonSize(size));
const $c8ad1686c6f1e1ca$var$genSkeletonElementButton = (token)=>{
    const { borderRadiusSM: borderRadiusSM, skeletonButtonCls: skeletonButtonCls, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, calc: calc } = token;
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        [`${skeletonButtonCls}`]: Object.assign({
            display: "inline-block",
            verticalAlign: "top",
            background: gradientFromColor,
            borderRadius: borderRadiusSM,
            width: calc(controlHeight).mul(2).equal(),
            minWidth: calc(controlHeight).mul(2).equal()
        }, $c8ad1686c6f1e1ca$var$genSkeletonElementButtonSize(controlHeight, calc))
    }, $c8ad1686c6f1e1ca$var$genSkeletonElementButtonShape(token, controlHeight, skeletonButtonCls)), {
        [`${skeletonButtonCls}-lg`]: Object.assign({}, $c8ad1686c6f1e1ca$var$genSkeletonElementButtonSize(controlHeightLG, calc))
    }), $c8ad1686c6f1e1ca$var$genSkeletonElementButtonShape(token, controlHeightLG, `${skeletonButtonCls}-lg`)), {
        [`${skeletonButtonCls}-sm`]: Object.assign({}, $c8ad1686c6f1e1ca$var$genSkeletonElementButtonSize(controlHeightSM, calc))
    }), $c8ad1686c6f1e1ca$var$genSkeletonElementButtonShape(token, controlHeightSM, `${skeletonButtonCls}-sm`));
};
// =============================== Base ===============================
const $c8ad1686c6f1e1ca$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, skeletonAvatarCls: skeletonAvatarCls, skeletonTitleCls: skeletonTitleCls, skeletonParagraphCls: skeletonParagraphCls, skeletonButtonCls: skeletonButtonCls, skeletonInputCls: skeletonInputCls, skeletonImageCls: skeletonImageCls, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, padding: padding, marginSM: marginSM, borderRadius: borderRadius, titleHeight: titleHeight, blockRadius: blockRadius, paragraphLiHeight: paragraphLiHeight, controlHeightXS: controlHeightXS, paragraphMarginTop: paragraphMarginTop } = token;
    return {
        [`${componentCls}`]: {
            display: "table",
            width: "100%",
            [`${componentCls}-header`]: {
                display: "table-cell",
                paddingInlineEnd: padding,
                verticalAlign: "top",
                // Avatar
                [`${skeletonAvatarCls}`]: Object.assign({
                    display: "inline-block",
                    verticalAlign: "top",
                    background: gradientFromColor
                }, $c8ad1686c6f1e1ca$var$genSkeletonElementAvatarSize(controlHeight)),
                [`${skeletonAvatarCls}-circle`]: {
                    borderRadius: "50%"
                },
                [`${skeletonAvatarCls}-lg`]: Object.assign({}, $c8ad1686c6f1e1ca$var$genSkeletonElementAvatarSize(controlHeightLG)),
                [`${skeletonAvatarCls}-sm`]: Object.assign({}, $c8ad1686c6f1e1ca$var$genSkeletonElementAvatarSize(controlHeightSM))
            },
            [`${componentCls}-content`]: {
                display: "table-cell",
                width: "100%",
                verticalAlign: "top",
                // Title
                [`${skeletonTitleCls}`]: {
                    width: "100%",
                    height: titleHeight,
                    background: gradientFromColor,
                    borderRadius: blockRadius,
                    [`+ ${skeletonParagraphCls}`]: {
                        marginBlockStart: controlHeightSM
                    }
                },
                // paragraph
                [`${skeletonParagraphCls}`]: {
                    padding: 0,
                    "> li": {
                        width: "100%",
                        height: paragraphLiHeight,
                        listStyle: "none",
                        background: gradientFromColor,
                        borderRadius: blockRadius,
                        "+ li": {
                            marginBlockStart: controlHeightXS
                        }
                    }
                },
                [`${skeletonParagraphCls}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
                    width: "61%"
                }
            },
            [`&-round ${componentCls}-content`]: {
                [`${skeletonTitleCls}, ${skeletonParagraphCls} > li`]: {
                    borderRadius: borderRadius
                }
            }
        },
        [`${componentCls}-with-avatar ${componentCls}-content`]: {
            // Title
            [`${skeletonTitleCls}`]: {
                marginBlockStart: marginSM,
                [`+ ${skeletonParagraphCls}`]: {
                    marginBlockStart: paragraphMarginTop
                }
            }
        },
        // Skeleton element
        [`${componentCls}${componentCls}-element`]: Object.assign(Object.assign(Object.assign(Object.assign({
            display: "inline-block",
            width: "auto"
        }, $c8ad1686c6f1e1ca$var$genSkeletonElementButton(token)), $c8ad1686c6f1e1ca$var$genSkeletonElementAvatar(token)), $c8ad1686c6f1e1ca$var$genSkeletonElementInput(token)), $c8ad1686c6f1e1ca$var$genSkeletonElementImage(token)),
        // Skeleton Block Button, Input
        [`${componentCls}${componentCls}-block`]: {
            width: "100%",
            [`${skeletonButtonCls}`]: {
                width: "100%"
            },
            [`${skeletonInputCls}`]: {
                width: "100%"
            }
        },
        // With active animation
        [`${componentCls}${componentCls}-active`]: {
            [`
        ${skeletonTitleCls},
        ${skeletonParagraphCls} > li,
        ${skeletonAvatarCls},
        ${skeletonButtonCls},
        ${skeletonInputCls},
        ${skeletonImageCls}
      `]: Object.assign({}, $c8ad1686c6f1e1ca$var$genSkeletonColor(token))
        }
    };
};
const $c8ad1686c6f1e1ca$export$9ca1be8807fe0675 = (token)=>{
    const { colorFillContent: colorFillContent, colorFill: colorFill } = token;
    const gradientFromColor = colorFillContent;
    const gradientToColor = colorFill;
    return {
        color: gradientFromColor,
        colorGradientEnd: gradientToColor,
        gradientFromColor: gradientFromColor,
        gradientToColor: gradientToColor,
        titleHeight: token.controlHeight / 2,
        blockRadius: token.borderRadiusSM,
        paragraphMarginTop: token.marginLG + token.marginXXS,
        paragraphLiHeight: token.controlHeight / 2
    };
};
var $c8ad1686c6f1e1ca$export$2e2bcd8739ae039 = (0, $P8Drj.genStyleHooks)("Skeleton", (token)=>{
    const { componentCls: componentCls, calc: calc } = token;
    const skeletonToken = (0, $2LRCS.merge)(token, {
        skeletonAvatarCls: `${componentCls}-avatar`,
        skeletonTitleCls: `${componentCls}-title`,
        skeletonParagraphCls: `${componentCls}-paragraph`,
        skeletonButtonCls: `${componentCls}-button`,
        skeletonInputCls: `${componentCls}-input`,
        skeletonImageCls: `${componentCls}-image`,
        imageSizeBase: calc(token.controlHeight).mul(1.5).equal(),
        borderRadius: 100,
        // Large number to make capsule shape
        skeletonLoadingBackground: `linear-gradient(90deg, ${token.gradientFromColor} 25%, ${token.gradientToColor} 37%, ${token.gradientFromColor} 63%)`,
        skeletonLoadingMotionDuration: "1.4s"
    });
    return [
        $c8ad1686c6f1e1ca$var$genBaseStyle(skeletonToken)
    ];
}, $c8ad1686c6f1e1ca$export$9ca1be8807fe0675, {
    deprecatedTokens: [
        [
            "color",
            "gradientFromColor"
        ],
        [
            "colorGradientEnd",
            "gradientToColor"
        ]
    ]
});

});


parcelRegister("1HMFo", function(module, exports) {

$parcel$export(module.exports, "default", () => $13df8eca828a64aa$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $1pcHX = parcelRequire("1pcHX");

var $acw62 = parcelRequire("acw62");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $aFpUb = parcelRequire("aFpUb");

var $hec2U = parcelRequire("hec2U");
"use client";
const $13df8eca828a64aa$var$SkeletonButton = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, active: active, block: block = false, size: size = "default" } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    const [wrapCSSVar, hashId] = (0, $hec2U.default)(prefixCls);
    const otherProps = (0, $1pcHX.default)(props, [
        "prefixCls"
    ]);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-block`]: block
    }, className, rootClassName, hashId);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $acw62.createElement((0, $aFpUb.default), Object.assign({
        prefixCls: `${prefixCls}-button`,
        size: size
    }, otherProps))));
};
var $13df8eca828a64aa$export$2e2bcd8739ae039 = $13df8eca828a64aa$var$SkeletonButton;

});

parcelRegister("3RZh4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d15da232c1f201d$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $hec2U = parcelRequire("hec2U");
"use client";
const $2d15da232c1f201d$var$path = "M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z";
const $2d15da232c1f201d$var$SkeletonImage = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, active: active } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    const [wrapCSSVar, hashId] = (0, $hec2U.default)(prefixCls);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, className, rootClassName, hashId);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(`${prefixCls}-image`, className),
        style: style
    }, /*#__PURE__*/ $acw62.createElement("svg", {
        viewBox: "0 0 1098 1024",
        xmlns: "http://www.w3.org/2000/svg",
        className: `${prefixCls}-image-svg`
    }, /*#__PURE__*/ $acw62.createElement("path", {
        d: $2d15da232c1f201d$var$path,
        className: `${prefixCls}-image-path`
    })))));
};
var $2d15da232c1f201d$export$2e2bcd8739ae039 = $2d15da232c1f201d$var$SkeletonImage;

});

parcelRegister("cwFgH", function(module, exports) {

$parcel$export(module.exports, "default", () => $91e87c3cdd7d215d$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $1pcHX = parcelRequire("1pcHX");

var $acw62 = parcelRequire("acw62");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $aFpUb = parcelRequire("aFpUb");

var $hec2U = parcelRequire("hec2U");
"use client";
const $91e87c3cdd7d215d$var$SkeletonInput = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, active: active, block: block, size: size = "default" } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    const [wrapCSSVar, hashId] = (0, $hec2U.default)(prefixCls);
    const otherProps = (0, $1pcHX.default)(props, [
        "prefixCls"
    ]);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-block`]: block
    }, className, rootClassName, hashId);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $acw62.createElement((0, $aFpUb.default), Object.assign({
        prefixCls: `${prefixCls}-input`,
        size: size
    }, otherProps))));
};
var $91e87c3cdd7d215d$export$2e2bcd8739ae039 = $91e87c3cdd7d215d$var$SkeletonInput;

});

parcelRegister("3vdYo", function(module, exports) {

$parcel$export(module.exports, "default", () => $28cf1b1f35f23ace$export$2e2bcd8739ae039);

var $eHGAB = parcelRequire("eHGAB");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $hec2U = parcelRequire("hec2U");
"use client";
const $28cf1b1f35f23ace$var$SkeletonNode = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, active: active, children: children } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    const [wrapCSSVar, hashId] = (0, $hec2U.default)(prefixCls);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, hashId, className, rootClassName);
    const content = children !== null && children !== void 0 ? children : /*#__PURE__*/ $acw62.createElement((0, $eHGAB.default), null);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(`${prefixCls}-image`, className),
        style: style
    }, content)));
};
var $28cf1b1f35f23ace$export$2e2bcd8739ae039 = $28cf1b1f35f23ace$var$SkeletonNode;

});
parcelRegister("eHGAB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab461e380423e01a$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $6qZhV = parcelRequire("6qZhV");

var $adRcI = parcelRequire("adRcI");
var $ab461e380423e01a$var$DotChartOutlined = function DotChartOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $adRcI.default), (0, $8nd05.default)({}, props, {
        ref: ref,
        icon: (0, $6qZhV.default)
    }));
};
var $ab461e380423e01a$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($ab461e380423e01a$var$DotChartOutlined);

});
parcelRegister("6qZhV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4af4b6581042791c$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $4af4b6581042791c$var$DotChartOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM288 604a64 64 0 10128 0 64 64 0 10-128 0zm118-224a48 48 0 1096 0 48 48 0 10-96 0zm158 228a96 96 0 10192 0 96 96 0 10-192 0zm148-314a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "dot-chart",
    "theme": "outlined"
};
var $4af4b6581042791c$export$2e2bcd8739ae039 = $4af4b6581042791c$var$DotChartOutlined;

});



parcelRegister("jabNw", function(module, exports) {

$parcel$export(module.exports, "default", () => $df381a499592442b$export$2e2bcd8739ae039);

var $kbxxf = parcelRequire("kbxxf");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
"use client";
const $df381a499592442b$var$Paragraph = (props)=>{
    const getWidth = (index)=>{
        const { width: width, rows: rows = 2 } = props;
        if (Array.isArray(width)) return width[index];
        // last paragraph
        if (rows - 1 === index) return width;
        return undefined;
    };
    const { prefixCls: prefixCls, className: className, style: style, rows: rows } = props;
    const rowList = (0, $kbxxf.default)(Array(rows)).map((_, index)=>/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        $acw62.createElement("li", {
            key: index,
            style: {
                width: getWidth(index)
            }
        }));
    return /*#__PURE__*/ $acw62.createElement("ul", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, className),
        style: style
    }, rowList);
};
var $df381a499592442b$export$2e2bcd8739ae039 = $df381a499592442b$var$Paragraph;

});

parcelRegister("ioy4t", function(module, exports) {

$parcel$export(module.exports, "default", () => $d644e5b233ba4700$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
"use client";
const $d644e5b233ba4700$var$Title = (_ref)=>{
    let { prefixCls: prefixCls, className: className, width: width, style: style } = _ref;
    return /*#__PURE__*/ $acw62.createElement("h3", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, className),
        style: Object.assign({
            width: width
        }, style)
    });
};
var $d644e5b233ba4700$export$2e2bcd8739ae039 = $d644e5b233ba4700$var$Title;

});



parcelRegister("4RmmN", function(module, exports) {

$parcel$export(module.exports, "default", () => $389d763730796d58$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $AWXcC = parcelRequire("AWXcC");

var $27Biq = parcelRequire("27Biq");

var $8p4qI = parcelRequire("8p4qI");

var $8g1PZ = parcelRequire("8g1PZ");

var $ehQBf = parcelRequire("ehQBf");

parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $IFe7R = parcelRequire("IFe7R");

var $kcVug = parcelRequire("kcVug");

var $4ERFI = parcelRequire("4ERFI");

var $7XKHO = parcelRequire("7XKHO");

var $dnT3A = parcelRequire("dnT3A");

var $6zpGA = parcelRequire("6zpGA");
"use client";
var $389d763730796d58$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $389d763730796d58$var$Tabs = (props)=>{
    const { type: type, className: className, rootClassName: rootClassName, size: customSize, onEdit: onEdit, hideAdd: hideAdd, centered: centered, addIcon: addIcon, popupClassName: popupClassName, children: children, items: items, animated: animated, style: style, indicatorSize: indicatorSize } = props, otherProps = $389d763730796d58$var$__rest(props, [
        "type",
        "className",
        "rootClassName",
        "size",
        "onEdit",
        "hideAdd",
        "centered",
        "addIcon",
        "popupClassName",
        "children",
        "items",
        "animated",
        "style",
        "indicatorSize"
    ]);
    const { prefixCls: customizePrefixCls, moreIcon: moreIcon = /*#__PURE__*/ $acw62.createElement((0, $27Biq.default), null) } = otherProps;
    const { direction: direction, tabs: tabs, getPrefixCls: getPrefixCls, getPopupContainer: getPopupContainer } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const prefixCls = getPrefixCls("tabs", customizePrefixCls);
    const rootCls = (0, $dnT3A.default)(prefixCls);
    const [wrapCSSVar, hashId] = (0, $7XKHO.default)(prefixCls, rootCls);
    let editable;
    if (type === "editable-card") editable = {
        onEdit: (editType, _ref)=>{
            let { key: key, event: event } = _ref;
            onEdit === null || onEdit === void 0 || onEdit(editType === "add" ? event : key, editType);
        },
        removeIcon: /*#__PURE__*/ $acw62.createElement((0, $AWXcC.default), null),
        addIcon: addIcon || /*#__PURE__*/ $acw62.createElement((0, $8p4qI.default), null),
        showAdd: hideAdd !== true
    };
    const rootPrefixCls = getPrefixCls();
    const mergedItems = (0, $4ERFI.default)(items, children);
    const mergedAnimated = (0, $kcVug.default)(prefixCls, animated);
    const size = (0, $IFe7R.default)(customSize);
    const mergedStyle = Object.assign(Object.assign({}, tabs === null || tabs === void 0 ? void 0 : tabs.style), style);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $ehQBf.default), Object.assign({
        direction: direction,
        getPopupContainer: getPopupContainer,
        moreTransitionName: `${rootPrefixCls}-slide-up`
    }, otherProps, {
        items: mergedItems,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
            [`${prefixCls}-${size}`]: size,
            [`${prefixCls}-card`]: [
                "card",
                "editable-card"
            ].includes(type),
            [`${prefixCls}-editable-card`]: type === "editable-card",
            [`${prefixCls}-centered`]: centered
        }, tabs === null || tabs === void 0 ? void 0 : tabs.className, className, rootClassName, hashId, rootCls),
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(popupClassName, hashId, rootCls),
        style: mergedStyle,
        editable: editable,
        moreIcon: moreIcon,
        prefixCls: prefixCls,
        animated: mergedAnimated,
        indicatorSize: indicatorSize !== null && indicatorSize !== void 0 ? indicatorSize : tabs === null || tabs === void 0 ? void 0 : tabs.indicatorSize
    })));
};
$389d763730796d58$var$Tabs.TabPane = (0, $6zpGA.default);
var $389d763730796d58$export$2e2bcd8739ae039 = $389d763730796d58$var$Tabs;

});
parcelRegister("AWXcC", function(module, exports) {

$parcel$export(module.exports, "default", () => $06f117eb9481f34c$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $csSaG = parcelRequire("csSaG");

var $adRcI = parcelRequire("adRcI");
var $06f117eb9481f34c$var$CloseOutlined = function CloseOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $adRcI.default), (0, $8nd05.default)({}, props, {
        ref: ref,
        icon: (0, $csSaG.default)
    }));
};
var $06f117eb9481f34c$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($06f117eb9481f34c$var$CloseOutlined);

});
parcelRegister("csSaG", function(module, exports) {

$parcel$export(module.exports, "default", () => $91321edc6c28da63$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $91321edc6c28da63$var$CloseOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    "name": "close",
    "theme": "outlined"
};
var $91321edc6c28da63$export$2e2bcd8739ae039 = $91321edc6c28da63$var$CloseOutlined;

});


parcelRegister("27Biq", function(module, exports) {

$parcel$export(module.exports, "default", () => $18b92a77e6b0d38f$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $gp47T = parcelRequire("gp47T");

var $adRcI = parcelRequire("adRcI");
var $18b92a77e6b0d38f$var$EllipsisOutlined = function EllipsisOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $adRcI.default), (0, $8nd05.default)({}, props, {
        ref: ref,
        icon: (0, $gp47T.default)
    }));
};
var $18b92a77e6b0d38f$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($18b92a77e6b0d38f$var$EllipsisOutlined);

});
parcelRegister("gp47T", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf122e88db242cab$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $bf122e88db242cab$var$EllipsisOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "ellipsis",
    "theme": "outlined"
};
var $bf122e88db242cab$export$2e2bcd8739ae039 = $bf122e88db242cab$var$EllipsisOutlined;

});


parcelRegister("8p4qI", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e4183d607620fc$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $7fhiU = parcelRequire("7fhiU");

var $adRcI = parcelRequire("adRcI");
var $61e4183d607620fc$var$PlusOutlined = function PlusOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $adRcI.default), (0, $8nd05.default)({}, props, {
        ref: ref,
        icon: (0, $7fhiU.default)
    }));
};
var $61e4183d607620fc$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($61e4183d607620fc$var$PlusOutlined);

});
parcelRegister("7fhiU", function(module, exports) {

$parcel$export(module.exports, "default", () => $54675b4e19f0d6af$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $54675b4e19f0d6af$var$PlusOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"
                }
            }
        ]
    },
    "name": "plus",
    "theme": "outlined"
};
var $54675b4e19f0d6af$export$2e2bcd8739ae039 = $54675b4e19f0d6af$var$PlusOutlined;

});


parcelRegister("ehQBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a66b746dc2ee365b$export$2e2bcd8739ae039);

var $4h0UX = parcelRequire("4h0UX");
var $a66b746dc2ee365b$export$2e2bcd8739ae039 = (0, $4h0UX.default);

});
parcelRegister("4h0UX", function(module, exports) {

$parcel$export(module.exports, "default", () => $31c9762e836450cf$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $fSwVM = parcelRequire("fSwVM");

var $9X7IJ = parcelRequire("9X7IJ");

var $8g1PZ = parcelRequire("8g1PZ");

var $iSQh8 = parcelRequire("iSQh8");

var $ycMhT = parcelRequire("ycMhT");

var $acw62 = parcelRequire("acw62");

var $bZge9 = parcelRequire("bZge9");

var $g4n1M = parcelRequire("g4n1M");

var $dANSY = parcelRequire("dANSY");

var $bRUSh = parcelRequire("bRUSh");
var $31c9762e836450cf$var$_excluded = [
    "id",
    "prefixCls",
    "className",
    "items",
    "direction",
    "activeKey",
    "defaultActiveKey",
    "editable",
    "animated",
    "tabPosition",
    "tabBarGutter",
    "tabBarStyle",
    "tabBarExtraContent",
    "locale",
    "moreIcon",
    "moreTransitionName",
    "destroyInactiveTabPane",
    "renderTabBar",
    "onChange",
    "onTabClick",
    "onTabScroll",
    "getPopupContainer",
    "popupClassName",
    "indicatorSize"
];
/**
 * Should added antd:
 * - type
 *
 * Removed:
 * - onNextClick
 * - onPrevClick
 * - keyboard
 */ // Used for accessibility
var $31c9762e836450cf$var$uuid = 0;
var $31c9762e836450cf$var$Tabs = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _classNames;
    var id = props.id, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-tabs" : _props$prefixCls, className = props.className, items = props.items, direction = props.direction, activeKey = props.activeKey, defaultActiveKey = props.defaultActiveKey, editable = props.editable, animated = props.animated, _props$tabPosition = props.tabPosition, tabPosition = _props$tabPosition === void 0 ? "top" : _props$tabPosition, tabBarGutter = props.tabBarGutter, tabBarStyle = props.tabBarStyle, tabBarExtraContent = props.tabBarExtraContent, locale = props.locale, moreIcon = props.moreIcon, moreTransitionName = props.moreTransitionName, destroyInactiveTabPane = props.destroyInactiveTabPane, renderTabBar = props.renderTabBar, onChange = props.onChange, onTabClick = props.onTabClick, onTabScroll = props.onTabScroll, getPopupContainer = props.getPopupContainer, popupClassName = props.popupClassName, indicatorSize = props.indicatorSize, restProps = (0, $9X7IJ.default)(props, $31c9762e836450cf$var$_excluded);
    var tabs = $acw62.useMemo(function() {
        return (items || []).filter(function(item) {
            return item && (0, $fSwVM.default)(item) === "object" && "key" in item;
        });
    }, [
        items
    ]);
    var rtl = direction === "rtl";
    var mergedAnimated = (0, $bZge9.default)(animated);
    // ======================== Mobile ========================
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, $eUqlC.default)(_useState, 2), mobile = _useState2[0], setMobile = _useState2[1];
    (0, $acw62.useEffect)(function() {
        // Only update on the client side
        setMobile((0, $ycMhT.default)());
    }, []);
    // ====================== Active Key ======================
    var _useMergedState = (0, $iSQh8.default)(function() {
        var _tabs$;
        return (_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.key;
    }, {
        value: activeKey,
        defaultValue: defaultActiveKey
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), mergedActiveKey = _useMergedState2[0], setMergedActiveKey = _useMergedState2[1];
    var _useState3 = (0, $acw62.useState)(function() {
        return tabs.findIndex(function(tab) {
            return tab.key === mergedActiveKey;
        });
    }), _useState4 = (0, $eUqlC.default)(_useState3, 2), activeIndex = _useState4[0], setActiveIndex = _useState4[1];
    // Reset active key if not exist anymore
    (0, $acw62.useEffect)(function() {
        var newActiveIndex = tabs.findIndex(function(tab) {
            return tab.key === mergedActiveKey;
        });
        if (newActiveIndex === -1) {
            var _tabs$newActiveIndex;
            newActiveIndex = Math.max(0, Math.min(activeIndex, tabs.length - 1));
            setMergedActiveKey((_tabs$newActiveIndex = tabs[newActiveIndex]) === null || _tabs$newActiveIndex === void 0 ? void 0 : _tabs$newActiveIndex.key);
        }
        setActiveIndex(newActiveIndex);
    }, [
        tabs.map(function(tab) {
            return tab.key;
        }).join("_"),
        mergedActiveKey,
        activeIndex
    ]);
    // ===================== Accessibility ====================
    var _useMergedState3 = (0, $iSQh8.default)(null, {
        value: id
    }), _useMergedState4 = (0, $eUqlC.default)(_useMergedState3, 2), mergedId = _useMergedState4[0], setMergedId = _useMergedState4[1];
    // Async generate id to avoid ssr mapping failed
    (0, $acw62.useEffect)(function() {
        if (!id) {
            setMergedId("rc-tabs-".concat($31c9762e836450cf$var$uuid));
            $31c9762e836450cf$var$uuid += 1;
        }
    }, []);
    // ======================== Events ========================
    function onInternalTabClick(key, e) {
        onTabClick === null || onTabClick === void 0 || onTabClick(key, e);
        var isActiveChanged = key !== mergedActiveKey;
        setMergedActiveKey(key);
        if (isActiveChanged) onChange === null || onChange === void 0 || onChange(key);
    }
    // ======================== Render ========================
    var sharedProps = {
        id: mergedId,
        activeKey: mergedActiveKey,
        animated: mergedAnimated,
        tabPosition: tabPosition,
        rtl: rtl,
        mobile: mobile
    };
    var tabNavBarProps = (0, $d49SP.default)((0, $d49SP.default)({}, sharedProps), {}, {
        editable: editable,
        locale: locale,
        moreIcon: moreIcon,
        moreTransitionName: moreTransitionName,
        tabBarGutter: tabBarGutter,
        onTabClick: onInternalTabClick,
        onTabScroll: onTabScroll,
        extra: tabBarExtraContent,
        style: tabBarStyle,
        panes: null,
        getPopupContainer: getPopupContainer,
        popupClassName: popupClassName,
        indicatorSize: indicatorSize
    });
    return /*#__PURE__*/ $acw62.createElement((0, $g4n1M.default).Provider, {
        value: {
            tabs: tabs,
            prefixCls: prefixCls
        }
    }, /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        ref: ref,
        id: id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, "".concat(prefixCls, "-").concat(tabPosition), (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-mobile"), mobile), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-editable"), editable), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-rtl"), rtl), _classNames), className)
    }, restProps), /*#__PURE__*/ $acw62.createElement((0, $dANSY.default), (0, $8nd05.default)({}, tabNavBarProps, {
        renderTabBar: renderTabBar
    })), /*#__PURE__*/ $acw62.createElement((0, $bRUSh.default), (0, $8nd05.default)({
        destroyInactiveTabPane: destroyInactiveTabPane
    }, sharedProps, {
        animated: mergedAnimated
    }))));
});
var $31c9762e836450cf$export$2e2bcd8739ae039 = $31c9762e836450cf$var$Tabs;

});
parcelRegister("ycMhT", function(module, exports) {

$parcel$export(module.exports, "default", () => $066d1680709fcf3c$export$2e2bcd8739ae039);
var $066d1680709fcf3c$export$2e2bcd8739ae039 = function() {
    if (typeof navigator === "undefined" || typeof window === "undefined") return false;
    var agent = navigator.userAgent || navigator.vendor || window.opera;
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
};

});

parcelRegister("bZge9", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ba1fa9e00219fcd$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $d49SP = parcelRequire("d49SP");
parcelRequire("u43uR");
function $8ba1fa9e00219fcd$export$2e2bcd8739ae039() {
    var animated = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        inkBar: true,
        tabPane: false
    };
    var mergedAnimated;
    if (animated === false) mergedAnimated = {
        inkBar: false,
        tabPane: false
    };
    else if (animated === true) mergedAnimated = {
        inkBar: true,
        tabPane: false
    };
    else mergedAnimated = (0, $d49SP.default)({
        inkBar: true
    }, (0, $fSwVM.default)(animated) === "object" ? animated : {});
    // Enable tabPane animation if provide motion
    if (mergedAnimated.tabPaneMotion && mergedAnimated.tabPane === undefined) mergedAnimated.tabPane = true;
    if (!mergedAnimated.tabPaneMotion && mergedAnimated.tabPane) mergedAnimated.tabPane = false;
    return mergedAnimated;
}

});

parcelRegister("g4n1M", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb2ee1e3f89d10a5$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $bb2ee1e3f89d10a5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(null);

});

parcelRegister("dANSY", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e555564d15c1afa$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $3bxNK = parcelRequire("3bxNK");

var $g4n1M = parcelRequire("g4n1M");

var $4lX2B = parcelRequire("4lX2B");
var $9e555564d15c1afa$var$_excluded = [
    "renderTabBar"
], $9e555564d15c1afa$var$_excluded2 = [
    "label",
    "key"
];
// We have to create a TabNavList components.
var $9e555564d15c1afa$var$TabNavListWrapper = function TabNavListWrapper(_ref) {
    var renderTabBar = _ref.renderTabBar, restProps = (0, $9X7IJ.default)(_ref, $9e555564d15c1afa$var$_excluded);
    var _React$useContext = $acw62.useContext((0, $g4n1M.default)), tabs = _React$useContext.tabs;
    if (renderTabBar) {
        var tabNavBarProps = (0, $d49SP.default)((0, $d49SP.default)({}, restProps), {}, {
            // Legacy support. We do not use this actually
            panes: tabs.map(function(_ref2) {
                var label = _ref2.label, key = _ref2.key, restTabProps = (0, $9X7IJ.default)(_ref2, $9e555564d15c1afa$var$_excluded2);
                return /*#__PURE__*/ $acw62.createElement((0, $4lX2B.default), (0, $8nd05.default)({
                    tab: label,
                    key: key,
                    tabKey: key
                }, restTabProps));
            })
        });
        return renderTabBar(tabNavBarProps, (0, $3bxNK.default));
    }
    return /*#__PURE__*/ $acw62.createElement((0, $3bxNK.default), restProps);
};
var $9e555564d15c1afa$export$2e2bcd8739ae039 = $9e555564d15c1afa$var$TabNavListWrapper;

});
parcelRegister("3bxNK", function(module, exports) {

$parcel$export(module.exports, "default", () => $251c9e7122a85d75$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $kbxxf = parcelRequire("kbxxf");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $8g1PZ = parcelRequire("8g1PZ");

var $bVxlN = parcelRequire("bVxlN");

var $a4gyP = parcelRequire("a4gyP");

var $85dLH = parcelRequire("85dLH");

var $acw62 = parcelRequire("acw62");

var $iregu = parcelRequire("iregu");

var $lRqZM = parcelRequire("lRqZM");

var $kKQEZ = parcelRequire("kKQEZ");

var $geUbK = parcelRequire("geUbK");

var $9fhUU = parcelRequire("9fhUU");

var $2AX26 = parcelRequire("2AX26");

var $g4n1M = parcelRequire("g4n1M");

var $P8LbM = parcelRequire("P8LbM");

var $hzIxa = parcelRequire("hzIxa");

var $kJlV6 = parcelRequire("kJlV6");

var $aRPJM = parcelRequire("aRPJM");

var $uKgWz = parcelRequire("uKgWz");
var $251c9e7122a85d75$var$getTabSize = function getTabSize(tab, containerRect) {
    // tabListRef
    var offsetWidth = tab.offsetWidth, offsetHeight = tab.offsetHeight, offsetTop = tab.offsetTop, offsetLeft = tab.offsetLeft;
    var _tab$getBoundingClien = tab.getBoundingClientRect(), width = _tab$getBoundingClien.width, height = _tab$getBoundingClien.height, x = _tab$getBoundingClien.x, y = _tab$getBoundingClien.y;
    // Use getBoundingClientRect to avoid decimal inaccuracy
    if (Math.abs(width - offsetWidth) < 1) return [
        width,
        height,
        x - containerRect.x,
        y - containerRect.y
    ];
    return [
        offsetWidth,
        offsetHeight,
        offsetLeft,
        offsetTop
    ];
};
var $251c9e7122a85d75$var$getSize = function getSize(refObj) {
    var _ref = refObj.current || {}, _ref$offsetWidth = _ref.offsetWidth, offsetWidth = _ref$offsetWidth === void 0 ? 0 : _ref$offsetWidth, _ref$offsetHeight = _ref.offsetHeight, offsetHeight = _ref$offsetHeight === void 0 ? 0 : _ref$offsetHeight;
    // Use getBoundingClientRect to avoid decimal inaccuracy
    if (refObj.current) {
        var _refObj$current$getBo = refObj.current.getBoundingClientRect(), width = _refObj$current$getBo.width, height = _refObj$current$getBo.height;
        if (Math.abs(width - offsetWidth) < 1) return [
            width,
            height
        ];
    }
    return [
        offsetWidth,
        offsetHeight
    ];
};
/**
 * Convert `SizeInfo` to unit value. Such as [123, 456] with `top` position get `123`
 */ var $251c9e7122a85d75$var$getUnitValue = function getUnitValue(size, tabPositionTopOrBottom) {
    return size[tabPositionTopOrBottom ? 0 : 1];
};
var $251c9e7122a85d75$var$TabNavList = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _classNames;
    var className = props.className, style = props.style, id = props.id, animated = props.animated, activeKey = props.activeKey, rtl = props.rtl, extra = props.extra, editable = props.editable, locale = props.locale, tabPosition = props.tabPosition, tabBarGutter = props.tabBarGutter, children = props.children, onTabClick = props.onTabClick, onTabScroll = props.onTabScroll, indicatorSize = props.indicatorSize;
    var _React$useContext = $acw62.useContext((0, $g4n1M.default)), prefixCls = _React$useContext.prefixCls, tabs = _React$useContext.tabs;
    var containerRef = (0, $acw62.useRef)(null);
    var extraLeftRef = (0, $acw62.useRef)(null);
    var extraRightRef = (0, $acw62.useRef)(null);
    var tabsWrapperRef = (0, $acw62.useRef)(null);
    var tabListRef = (0, $acw62.useRef)(null);
    var operationsRef = (0, $acw62.useRef)(null);
    var innerAddButtonRef = (0, $acw62.useRef)(null);
    var tabPositionTopOrBottom = tabPosition === "top" || tabPosition === "bottom";
    var _useSyncState = (0, $kKQEZ.default)(0, function(next, prev) {
        if (tabPositionTopOrBottom && onTabScroll) onTabScroll({
            direction: next > prev ? "left" : "right"
        });
    }), _useSyncState2 = (0, $eUqlC.default)(_useSyncState, 2), transformLeft = _useSyncState2[0], setTransformLeft = _useSyncState2[1];
    var _useSyncState3 = (0, $kKQEZ.default)(0, function(next, prev) {
        if (!tabPositionTopOrBottom && onTabScroll) onTabScroll({
            direction: next > prev ? "top" : "bottom"
        });
    }), _useSyncState4 = (0, $eUqlC.default)(_useSyncState3, 2), transformTop = _useSyncState4[0], setTransformTop = _useSyncState4[1];
    var _useState = (0, $acw62.useState)([
        0,
        0
    ]), _useState2 = (0, $eUqlC.default)(_useState, 2), containerExcludeExtraSize = _useState2[0], setContainerExcludeExtraSize = _useState2[1];
    var _useState3 = (0, $acw62.useState)([
        0,
        0
    ]), _useState4 = (0, $eUqlC.default)(_useState3, 2), tabContentSize = _useState4[0], setTabContentSize = _useState4[1];
    var _useState5 = (0, $acw62.useState)([
        0,
        0
    ]), _useState6 = (0, $eUqlC.default)(_useState5, 2), addSize = _useState6[0], setAddSize = _useState6[1];
    var _useState7 = (0, $acw62.useState)([
        0,
        0
    ]), _useState8 = (0, $eUqlC.default)(_useState7, 2), operationSize = _useState8[0], setOperationSize = _useState8[1];
    var _useUpdateState = (0, $9fhUU.useUpdateState)(new Map()), _useUpdateState2 = (0, $eUqlC.default)(_useUpdateState, 2), tabSizes = _useUpdateState2[0], setTabSizes = _useUpdateState2[1];
    var tabOffsets = (0, $lRqZM.default)(tabs, tabSizes, tabContentSize[0]);
    // ========================== Unit =========================
    var containerExcludeExtraSizeValue = $251c9e7122a85d75$var$getUnitValue(containerExcludeExtraSize, tabPositionTopOrBottom);
    var tabContentSizeValue = $251c9e7122a85d75$var$getUnitValue(tabContentSize, tabPositionTopOrBottom);
    var addSizeValue = $251c9e7122a85d75$var$getUnitValue(addSize, tabPositionTopOrBottom);
    var operationSizeValue = $251c9e7122a85d75$var$getUnitValue(operationSize, tabPositionTopOrBottom);
    var needScroll = containerExcludeExtraSizeValue < tabContentSizeValue + addSizeValue;
    var visibleTabContentValue = needScroll ? containerExcludeExtraSizeValue - operationSizeValue : containerExcludeExtraSizeValue - addSizeValue;
    // ========================== Util =========================
    var operationsHiddenClassName = "".concat(prefixCls, "-nav-operations-hidden");
    var transformMin = 0;
    var transformMax = 0;
    if (!tabPositionTopOrBottom) {
        transformMin = Math.min(0, visibleTabContentValue - tabContentSizeValue);
        transformMax = 0;
    } else if (rtl) {
        transformMin = 0;
        transformMax = Math.max(0, tabContentSizeValue - visibleTabContentValue);
    } else {
        transformMin = Math.min(0, visibleTabContentValue - tabContentSizeValue);
        transformMax = 0;
    }
    function alignInRange(value) {
        if (value < transformMin) return transformMin;
        if (value > transformMax) return transformMax;
        return value;
    }
    // ========================= Mobile ========================
    var touchMovingRef = (0, $acw62.useRef)(null);
    var _useState9 = (0, $acw62.useState)(), _useState10 = (0, $eUqlC.default)(_useState9, 2), lockAnimation = _useState10[0], setLockAnimation = _useState10[1];
    function doLockAnimation() {
        setLockAnimation(Date.now());
    }
    function clearTouchMoving() {
        if (touchMovingRef.current) clearTimeout(touchMovingRef.current);
    }
    (0, $geUbK.default)(tabsWrapperRef, function(offsetX, offsetY) {
        function doMove(setState, offset) {
            setState(function(value) {
                var newValue = alignInRange(value + offset);
                return newValue;
            });
        }
        // Skip scroll if place is enough
        if (!needScroll) return false;
        if (tabPositionTopOrBottom) doMove(setTransformLeft, offsetX);
        else doMove(setTransformTop, offsetY);
        clearTouchMoving();
        doLockAnimation();
        return true;
    });
    (0, $acw62.useEffect)(function() {
        clearTouchMoving();
        if (lockAnimation) touchMovingRef.current = setTimeout(function() {
            setLockAnimation(0);
        }, 100);
        return clearTouchMoving;
    }, [
        lockAnimation
    ]);
    // ===================== Visible Range =====================
    // Render tab node & collect tab offset
    var _useVisibleRange = (0, $2AX26.default)(tabOffsets, // Container
    visibleTabContentValue, // Transform
    tabPositionTopOrBottom ? transformLeft : transformTop, // Tabs
    tabContentSizeValue, // Add
    addSizeValue, // Operation
    operationSizeValue, (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        tabs: tabs
    })), _useVisibleRange2 = (0, $eUqlC.default)(_useVisibleRange, 2), visibleStart = _useVisibleRange2[0], visibleEnd = _useVisibleRange2[1];
    // ========================= Scroll ========================
    var scrollToTab = (0, $a4gyP.default)(function() {
        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : activeKey;
        var tabOffset = tabOffsets.get(key) || {
            width: 0,
            height: 0,
            left: 0,
            right: 0,
            top: 0
        };
        if (tabPositionTopOrBottom) {
            // ============ Align with top & bottom ============
            var newTransform = transformLeft;
            // RTL
            if (rtl) {
                if (tabOffset.right < transformLeft) newTransform = tabOffset.right;
                else if (tabOffset.right + tabOffset.width > transformLeft + visibleTabContentValue) newTransform = tabOffset.right + tabOffset.width - visibleTabContentValue;
            } else if (tabOffset.left < -transformLeft) newTransform = -tabOffset.left;
            else if (tabOffset.left + tabOffset.width > -transformLeft + visibleTabContentValue) newTransform = -(tabOffset.left + tabOffset.width - visibleTabContentValue);
            setTransformTop(0);
            setTransformLeft(alignInRange(newTransform));
        } else {
            // ============ Align with left & right ============
            var _newTransform = transformTop;
            if (tabOffset.top < -transformTop) _newTransform = -tabOffset.top;
            else if (tabOffset.top + tabOffset.height > -transformTop + visibleTabContentValue) _newTransform = -(tabOffset.top + tabOffset.height - visibleTabContentValue);
            setTransformLeft(0);
            setTransformTop(alignInRange(_newTransform));
        }
    });
    // ========================== Tab ==========================
    var tabNodeStyle = {};
    if (tabPosition === "top" || tabPosition === "bottom") tabNodeStyle[rtl ? "marginRight" : "marginLeft"] = tabBarGutter;
    else tabNodeStyle.marginTop = tabBarGutter;
    var tabNodes = tabs.map(function(tab, i) {
        var key = tab.key;
        return /*#__PURE__*/ $acw62.createElement((0, $uKgWz.default), {
            id: id,
            prefixCls: prefixCls,
            key: key,
            tab: tab,
            style: i === 0 ? undefined : tabNodeStyle,
            closable: tab.closable,
            editable: editable,
            active: key === activeKey,
            renderWrapper: children,
            removeAriaLabel: locale === null || locale === void 0 ? void 0 : locale.removeAriaLabel,
            onClick: function onClick(e) {
                onTabClick(key, e);
            },
            onFocus: function onFocus() {
                scrollToTab(key);
                doLockAnimation();
                if (!tabsWrapperRef.current) return;
                // Focus element will make scrollLeft change which we should reset back
                if (!rtl) tabsWrapperRef.current.scrollLeft = 0;
                tabsWrapperRef.current.scrollTop = 0;
            }
        });
    });
    // Update buttons records
    var updateTabSizes = function updateTabSizes() {
        return setTabSizes(function() {
            var _tabListRef$current;
            var newSizes = new Map();
            var listRect = (_tabListRef$current = tabListRef.current) === null || _tabListRef$current === void 0 ? void 0 : _tabListRef$current.getBoundingClientRect();
            tabs.forEach(function(_ref2) {
                var _tabListRef$current2;
                var key = _ref2.key;
                var btnNode = (_tabListRef$current2 = tabListRef.current) === null || _tabListRef$current2 === void 0 ? void 0 : _tabListRef$current2.querySelector('[data-node-key="'.concat((0, $P8LbM.genDataNodeKey)(key), '"]'));
                if (btnNode) {
                    var _getTabSize = $251c9e7122a85d75$var$getTabSize(btnNode, listRect), _getTabSize2 = (0, $eUqlC.default)(_getTabSize, 4), width = _getTabSize2[0], height = _getTabSize2[1], left = _getTabSize2[2], top = _getTabSize2[3];
                    newSizes.set(key, {
                        width: width,
                        height: height,
                        left: left,
                        top: top
                    });
                }
            });
            return newSizes;
        });
    };
    (0, $acw62.useEffect)(function() {
        updateTabSizes();
    }, [
        tabs.map(function(tab) {
            return tab.key;
        }).join("_")
    ]);
    var onListHolderResize = (0, $9fhUU.default)(function() {
        // Update wrapper records
        var containerSize = $251c9e7122a85d75$var$getSize(containerRef);
        var extraLeftSize = $251c9e7122a85d75$var$getSize(extraLeftRef);
        var extraRightSize = $251c9e7122a85d75$var$getSize(extraRightRef);
        setContainerExcludeExtraSize([
            containerSize[0] - extraLeftSize[0] - extraRightSize[0],
            containerSize[1] - extraLeftSize[1] - extraRightSize[1]
        ]);
        var newAddSize = $251c9e7122a85d75$var$getSize(innerAddButtonRef);
        setAddSize(newAddSize);
        var newOperationSize = $251c9e7122a85d75$var$getSize(operationsRef);
        setOperationSize(newOperationSize);
        // Which includes add button size
        var tabContentFullSize = $251c9e7122a85d75$var$getSize(tabListRef);
        setTabContentSize([
            tabContentFullSize[0] - newAddSize[0],
            tabContentFullSize[1] - newAddSize[1]
        ]);
        // Update buttons records
        updateTabSizes();
    });
    // ======================== Dropdown =======================
    var startHiddenTabs = tabs.slice(0, visibleStart);
    var endHiddenTabs = tabs.slice(visibleEnd + 1);
    var hiddenTabs = [].concat((0, $kbxxf.default)(startHiddenTabs), (0, $kbxxf.default)(endHiddenTabs));
    // =================== Link & Operations ===================
    var activeTabOffset = tabOffsets.get(activeKey);
    var _useIndicator = (0, $iregu.default)({
        activeTabOffset: activeTabOffset,
        horizontal: tabPositionTopOrBottom,
        rtl: rtl,
        indicatorSize: indicatorSize
    }), indicatorStyle = _useIndicator.style;
    // ========================= Effect ========================
    (0, $acw62.useEffect)(function() {
        scrollToTab();
    // eslint-disable-next-line
    }, [
        activeKey,
        transformMin,
        transformMax,
        (0, $P8LbM.stringify)(activeTabOffset),
        (0, $P8LbM.stringify)(tabOffsets),
        tabPositionTopOrBottom
    ]);
    // Should recalculate when rtl changed
    (0, $acw62.useEffect)(function() {
        onListHolderResize();
    // eslint-disable-next-line
    }, [
        rtl
    ]);
    // ========================= Render ========================
    var hasDropdown = !!hiddenTabs.length;
    var wrapPrefix = "".concat(prefixCls, "-nav-wrap");
    var pingLeft;
    var pingRight;
    var pingTop;
    var pingBottom;
    if (tabPositionTopOrBottom) {
        if (rtl) {
            pingRight = transformLeft > 0;
            pingLeft = transformLeft !== transformMax;
        } else {
            pingLeft = transformLeft < 0;
            pingRight = transformLeft !== transformMin;
        }
    } else {
        pingTop = transformTop < 0;
        pingBottom = transformTop !== transformMin;
    }
    return /*#__PURE__*/ $acw62.createElement((0, $bVxlN.default), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $acw62.createElement("div", {
        ref: (0, $85dLH.useComposeRef)(ref, containerRef),
        role: "tablist",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-nav"), className),
        style: style,
        onKeyDown: function onKeyDown() {
            // No need animation when use keyboard
            doLockAnimation();
        }
    }, /*#__PURE__*/ $acw62.createElement((0, $kJlV6.default), {
        ref: extraLeftRef,
        position: "left",
        extra: extra,
        prefixCls: prefixCls
    }), /*#__PURE__*/ $acw62.createElement((0, $bVxlN.default), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(wrapPrefix, (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(wrapPrefix, "-ping-left"), pingLeft), (0, $kSlfw.default)(_classNames, "".concat(wrapPrefix, "-ping-right"), pingRight), (0, $kSlfw.default)(_classNames, "".concat(wrapPrefix, "-ping-top"), pingTop), (0, $kSlfw.default)(_classNames, "".concat(wrapPrefix, "-ping-bottom"), pingBottom), _classNames)),
        ref: tabsWrapperRef
    }, /*#__PURE__*/ $acw62.createElement((0, $bVxlN.default), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $acw62.createElement("div", {
        ref: tabListRef,
        className: "".concat(prefixCls, "-nav-list"),
        style: {
            transform: "translate(".concat(transformLeft, "px, ").concat(transformTop, "px)"),
            transition: lockAnimation ? "none" : undefined
        }
    }, tabNodes, /*#__PURE__*/ $acw62.createElement((0, $hzIxa.default), {
        ref: innerAddButtonRef,
        prefixCls: prefixCls,
        locale: locale,
        editable: editable,
        style: (0, $d49SP.default)((0, $d49SP.default)({}, tabNodes.length === 0 ? undefined : tabNodeStyle), {}, {
            visibility: hasDropdown ? "hidden" : null
        })
    }), /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-ink-bar"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-ink-bar-animated"), animated.inkBar)),
        style: indicatorStyle
    }))))), /*#__PURE__*/ $acw62.createElement((0, $aRPJM.default), (0, $8nd05.default)({}, props, {
        removeAriaLabel: locale === null || locale === void 0 ? void 0 : locale.removeAriaLabel,
        ref: operationsRef,
        prefixCls: prefixCls,
        tabs: hiddenTabs,
        className: !hasDropdown && operationsHiddenClassName,
        tabMoving: !!lockAnimation
    })), /*#__PURE__*/ $acw62.createElement((0, $kJlV6.default), {
        ref: extraRightRef,
        position: "right",
        extra: extra,
        prefixCls: prefixCls
    })));
/* eslint-enable */ });
var $251c9e7122a85d75$export$2e2bcd8739ae039 = $251c9e7122a85d75$var$TabNavList;

});
parcelRegister("bVxlN", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aeee349dead8f85$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $jWR62 = parcelRequire("jWR62");
parcelRequire("u43uR");

var $42BBK = parcelRequire("42BBK");

var $56fsy = parcelRequire("56fsy");

var $knKfz = parcelRequire("knKfz");
var $8aeee349dead8f85$var$INTERNAL_PREFIX_KEY = "rc-observer-key";
function $8aeee349dead8f85$var$ResizeObserver(props, ref) {
    var children = props.children;
    var childNodes = typeof children === "function" ? [
        children
    ] : (0, $jWR62.default)(children);
    return childNodes.map(function(child, index) {
        var key = (child === null || child === void 0 ? void 0 : child.key) || "".concat($8aeee349dead8f85$var$INTERNAL_PREFIX_KEY, "-").concat(index);
        return /*#__PURE__*/ $acw62.createElement((0, $42BBK.default), (0, $8nd05.default)({}, props, {
            key: key,
            ref: index === 0 ? ref : undefined
        }), child);
    });
}
var $8aeee349dead8f85$var$RefResizeObserver = /*#__PURE__*/ $acw62.forwardRef($8aeee349dead8f85$var$ResizeObserver);
$8aeee349dead8f85$var$RefResizeObserver.Collection = (0, $56fsy.Collection);
var $8aeee349dead8f85$export$2e2bcd8739ae039 = $8aeee349dead8f85$var$RefResizeObserver;

});
parcelRegister("42BBK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f1485708e9ce0e2$export$2e2bcd8739ae039);

var $d49SP = parcelRequire("d49SP");

var $fSwVM = parcelRequire("fSwVM");

var $b2dYb = parcelRequire("b2dYb");

var $85dLH = parcelRequire("85dLH");

var $acw62 = parcelRequire("acw62");

var $56fsy = parcelRequire("56fsy");

var $knKfz = parcelRequire("knKfz");

var $2kud5 = parcelRequire("2kud5");
function $2f1485708e9ce0e2$var$SingleObserver(props, ref) {
    var children = props.children, disabled = props.disabled;
    var elementRef = $acw62.useRef(null);
    var wrapperRef = $acw62.useRef(null);
    var onCollectionResize = $acw62.useContext((0, $56fsy.CollectionContext));
    // =========================== Children ===========================
    var isRenderProps = typeof children === "function";
    var mergedChildren = isRenderProps ? children(elementRef) : children;
    // ============================= Size =============================
    var sizeRef = $acw62.useRef({
        width: -1,
        height: -1,
        offsetWidth: -1,
        offsetHeight: -1
    });
    // ============================= Ref ==============================
    var canRef = !isRenderProps && /*#__PURE__*/ $acw62.isValidElement(mergedChildren) && (0, $85dLH.supportRef)(mergedChildren);
    var originRef = canRef ? mergedChildren.ref : null;
    var mergedRef = (0, $85dLH.useComposeRef)(originRef, elementRef);
    var getDom = function getDom() {
        var _elementRef$current;
        return (0, $b2dYb.default)(elementRef.current) || // Support `nativeElement` format
        (elementRef.current && (0, $fSwVM.default)(elementRef.current) === "object" ? (0, $b2dYb.default)((_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.nativeElement) : null) || (0, $b2dYb.default)(wrapperRef.current);
    };
    $acw62.useImperativeHandle(ref, function() {
        return getDom();
    });
    // =========================== Observe ============================
    var propsRef = $acw62.useRef(props);
    propsRef.current = props;
    // Handler
    var onInternalResize = $acw62.useCallback(function(target) {
        var _propsRef$current = propsRef.current, onResize = _propsRef$current.onResize, data = _propsRef$current.data;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var offsetWidth = target.offsetWidth, offsetHeight = target.offsetHeight;
        /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */ var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
            var size = {
                width: fixedWidth,
                height: fixedHeight,
                offsetWidth: offsetWidth,
                offsetHeight: offsetHeight
            };
            sizeRef.current = size;
            // IE is strange, right?
            var mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
            var mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
            var sizeInfo = (0, $d49SP.default)((0, $d49SP.default)({}, size), {}, {
                offsetWidth: mergedOffsetWidth,
                offsetHeight: mergedOffsetHeight
            });
            // Let collection know what happened
            onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(sizeInfo, target, data);
            if (onResize) // defer the callback but not defer to next frame
            Promise.resolve().then(function() {
                onResize(sizeInfo, target);
            });
        }
    }, []);
    // Dynamic observe
    $acw62.useEffect(function() {
        var currentElement = getDom();
        if (currentElement && !disabled) (0, $knKfz.observe)(currentElement, onInternalResize);
        return function() {
            return (0, $knKfz.unobserve)(currentElement, onInternalResize);
        };
    }, [
        elementRef.current,
        disabled
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $acw62.createElement((0, $2kud5.default), {
        ref: wrapperRef
    }, canRef ? /*#__PURE__*/ $acw62.cloneElement(mergedChildren, {
        ref: mergedRef
    }) : mergedChildren);
}
var $2f1485708e9ce0e2$var$RefSingleObserver = /*#__PURE__*/ $acw62.forwardRef($2f1485708e9ce0e2$var$SingleObserver);
var $2f1485708e9ce0e2$export$2e2bcd8739ae039 = $2f1485708e9ce0e2$var$RefSingleObserver;

});
parcelRegister("56fsy", function(module, exports) {

$parcel$export(module.exports, "CollectionContext", () => $3b6981416c8ff0a7$export$db36075d98ba73d3);
$parcel$export(module.exports, "Collection", () => $3b6981416c8ff0a7$export$fb8073518f34e6ec);

var $acw62 = parcelRequire("acw62");
var $3b6981416c8ff0a7$export$db36075d98ba73d3 = /*#__PURE__*/ $acw62.createContext(null);
function $3b6981416c8ff0a7$export$fb8073518f34e6ec(_ref) {
    var children = _ref.children, onBatchResize = _ref.onBatchResize;
    var resizeIdRef = $acw62.useRef(0);
    var resizeInfosRef = $acw62.useRef([]);
    var onCollectionResize = $acw62.useContext($3b6981416c8ff0a7$export$db36075d98ba73d3);
    var onResize = $acw62.useCallback(function(size, element, data) {
        resizeIdRef.current += 1;
        var currentId = resizeIdRef.current;
        resizeInfosRef.current.push({
            size: size,
            element: element,
            data: data
        });
        Promise.resolve().then(function() {
            if (currentId === resizeIdRef.current) {
                onBatchResize === null || onBatchResize === void 0 || onBatchResize(resizeInfosRef.current);
                resizeInfosRef.current = [];
            }
        });
        // Continue bubbling if parent exist
        onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(size, element, data);
    }, [
        onBatchResize,
        onCollectionResize
    ]);
    return /*#__PURE__*/ $acw62.createElement($3b6981416c8ff0a7$export$db36075d98ba73d3.Provider, {
        value: onResize
    }, children);
}

});

parcelRegister("knKfz", function(module, exports) {

$parcel$export(module.exports, "observe", () => $ed69d4f7f0510fbd$export$d1203567a167490e);
$parcel$export(module.exports, "unobserve", () => $ed69d4f7f0510fbd$export$23a2283368c55ea2);

var $bEEfE = parcelRequire("bEEfE");
// =============================== Const ===============================
var $ed69d4f7f0510fbd$var$elementListeners = new Map();
function $ed69d4f7f0510fbd$var$onResize(entities) {
    entities.forEach(function(entity) {
        var _elementListeners$get;
        var target = entity.target;
        (_elementListeners$get = $ed69d4f7f0510fbd$var$elementListeners.get(target)) === null || _elementListeners$get === void 0 || _elementListeners$get.forEach(function(listener) {
            return listener(target);
        });
    });
}
// Note: ResizeObserver polyfill not support option to measure border-box resize
var $ed69d4f7f0510fbd$var$resizeObserver = new (0, $bEEfE.default)($ed69d4f7f0510fbd$var$onResize);
var $ed69d4f7f0510fbd$export$3fbe5a08fd9e4702 = null; // eslint-disable-line
var $ed69d4f7f0510fbd$export$524f0fd3b47831a = null; // eslint-disable-line
function $ed69d4f7f0510fbd$export$d1203567a167490e(element, callback) {
    if (!$ed69d4f7f0510fbd$var$elementListeners.has(element)) {
        $ed69d4f7f0510fbd$var$elementListeners.set(element, new Set());
        $ed69d4f7f0510fbd$var$resizeObserver.observe(element);
    }
    $ed69d4f7f0510fbd$var$elementListeners.get(element).add(callback);
}
function $ed69d4f7f0510fbd$export$23a2283368c55ea2(element, callback) {
    if ($ed69d4f7f0510fbd$var$elementListeners.has(element)) {
        $ed69d4f7f0510fbd$var$elementListeners.get(element).delete(callback);
        if (!$ed69d4f7f0510fbd$var$elementListeners.get(element).size) {
            $ed69d4f7f0510fbd$var$resizeObserver.unobserve(element);
            $ed69d4f7f0510fbd$var$elementListeners.delete(element);
        }
    }
}

});
parcelRegister("bEEfE", function(module, exports) {

$parcel$export(module.exports, "default", () => $87c2a74187854fda$export$2e2bcd8739ae039);
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $87c2a74187854fda$var$MapShim = function() {
    if (typeof Map !== "undefined") return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $87c2a74187854fda$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
// Returns global object of a current environment.
var $87c2a74187854fda$var$global$1 = function() {
    if (typeof $parcel$global !== "undefined" && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== "undefined" && self.Math === Math) return self;
    if (typeof window !== "undefined" && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function("return this")();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $87c2a74187854fda$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === "function") // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($87c2a74187854fda$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $87c2a74187854fda$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $87c2a74187854fda$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $87c2a74187854fda$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $87c2a74187854fda$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $87c2a74187854fda$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $87c2a74187854fda$var$transitionKeys = [
    "top",
    "right",
    "bottom",
    "left",
    "width",
    "height",
    "size",
    "weight"
];
// Check if MutationObserver is available.
var $87c2a74187854fda$var$mutationObserverSupported = typeof MutationObserver !== "undefined";
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $87c2a74187854fda$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $87c2a74187854fda$var$throttle(this.refresh.bind(this), $87c2a74187854fda$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$87c2a74187854fda$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener("transitionend", this.onTransitionEnd_);
        window.addEventListener("resize", this.refresh);
        if ($87c2a74187854fda$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener("DOMSubtreeModified", this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$87c2a74187854fda$var$isBrowser || !this.connected_) return;
        document.removeEventListener("transitionend", this.onTransitionEnd_);
        window.removeEventListener("resize", this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener("DOMSubtreeModified", this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $87c2a74187854fda$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $87c2a74187854fda$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $87c2a74187854fda$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $87c2a74187854fda$var$global$1;
};
// Placeholder of an empty content rectangle.
var $87c2a74187854fda$var$emptyRect = $87c2a74187854fda$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $87c2a74187854fda$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $87c2a74187854fda$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles["border-" + position + "-width"];
        return size + $87c2a74187854fda$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $87c2a74187854fda$var$getPaddings(styles) {
    var positions = [
        "top",
        "right",
        "bottom",
        "left"
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles["padding-" + position];
        paddings[position] = $87c2a74187854fda$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $87c2a74187854fda$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $87c2a74187854fda$var$emptyRect;
    var styles = $87c2a74187854fda$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $87c2a74187854fda$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $87c2a74187854fda$var$toFloat(styles.width), height = $87c2a74187854fda$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === "border-box") {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $87c2a74187854fda$var$getBordersSize(styles, "left", "right") + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $87c2a74187854fda$var$getBordersSize(styles, "top", "bottom") + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$87c2a74187854fda$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $87c2a74187854fda$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $87c2a74187854fda$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== "undefined") return function(target) {
        return target instanceof $87c2a74187854fda$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $87c2a74187854fda$var$getWindowOf(target).SVGElement && typeof target.getBBox === "function";
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $87c2a74187854fda$var$isDocumentElement(target) {
    return target === $87c2a74187854fda$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$getContentRect(target) {
    if (!$87c2a74187854fda$var$isBrowser) return $87c2a74187854fda$var$emptyRect;
    if ($87c2a74187854fda$var$isSVGGraphicsElement(target)) return $87c2a74187854fda$var$getSVGContentRect(target);
    return $87c2a74187854fda$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $87c2a74187854fda$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $87c2a74187854fda$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $87c2a74187854fda$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $87c2a74187854fda$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $87c2a74187854fda$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $87c2a74187854fda$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $87c2a74187854fda$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $87c2a74187854fda$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $87c2a74187854fda$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $87c2a74187854fda$var$MapShim();
        if (typeof callback !== "function") throw new TypeError("The callback provided as parameter 1 is not a function.");
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $87c2a74187854fda$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $87c2a74187854fda$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $87c2a74187854fda$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $87c2a74187854fda$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $87c2a74187854fda$var$observers = typeof WeakMap !== "undefined" ? new WeakMap() : new $87c2a74187854fda$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $87c2a74187854fda$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        var controller = $87c2a74187854fda$var$ResizeObserverController.getInstance();
        var observer = new $87c2a74187854fda$var$ResizeObserverSPI(callback, controller, this);
        $87c2a74187854fda$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    "observe",
    "unobserve",
    "disconnect"
].forEach(function(method) {
    $87c2a74187854fda$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $87c2a74187854fda$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $87c2a74187854fda$var$index = function() {
    // Export existing implementation if available.
    if (typeof $87c2a74187854fda$var$global$1.ResizeObserver !== "undefined") return $87c2a74187854fda$var$global$1.ResizeObserver;
    return $87c2a74187854fda$var$ResizeObserver;
}();
var $87c2a74187854fda$export$2e2bcd8739ae039 = $87c2a74187854fda$var$index;

});


parcelRegister("2kud5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b24e2207f75c1d9$export$2e2bcd8739ae039);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $acw62 = parcelRequire("acw62");
/**
 * Fallback to findDOMNode if origin ref do not provide any dom element
 */ var $1b24e2207f75c1d9$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $1gYAD.default)(DomWrapper, _React$Component);
    var _super = (0, $enfmq.default)(DomWrapper);
    function DomWrapper() {
        (0, $6CZeq.default)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $cHPF9.default)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($acw62.Component);

});



parcelRegister("iregu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6c5d05385b01772$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $dTiBu = parcelRequire("dTiBu");

var $acw62 = parcelRequire("acw62");
var $d6c5d05385b01772$var$useIndicator = function useIndicator(_ref) {
    var activeTabOffset = _ref.activeTabOffset, horizontal = _ref.horizontal, rtl = _ref.rtl, indicatorSize = _ref.indicatorSize;
    var _useState = (0, $acw62.useState)(), _useState2 = (0, $eUqlC.default)(_useState, 2), inkStyle = _useState2[0], setInkStyle = _useState2[1];
    var inkBarRafRef = (0, $acw62.useRef)();
    var getLength = function getLength(origin) {
        if (typeof indicatorSize === "function") return indicatorSize(origin);
        if (typeof indicatorSize === "number") return indicatorSize;
        return origin;
    };
    // Delay set ink style to avoid remove tab blink
    function cleanInkBarRaf() {
        (0, $dTiBu.default).cancel(inkBarRafRef.current);
    }
    (0, $acw62.useEffect)(function() {
        var newInkStyle = {};
        if (activeTabOffset) {
            if (horizontal) {
                if (rtl) {
                    newInkStyle.right = activeTabOffset.right + activeTabOffset.width / 2;
                    newInkStyle.transform = "translateX(50%)";
                } else {
                    newInkStyle.left = activeTabOffset.left + activeTabOffset.width / 2;
                    newInkStyle.transform = "translateX(-50%)";
                }
                newInkStyle.width = getLength(activeTabOffset.width);
            } else {
                newInkStyle.top = activeTabOffset.top + activeTabOffset.height / 2;
                newInkStyle.transform = "translateY(-50%)";
                newInkStyle.height = getLength(activeTabOffset.height);
            }
        }
        cleanInkBarRaf();
        inkBarRafRef.current = (0, $dTiBu.default)(function() {
            setInkStyle(newInkStyle);
        });
        return cleanInkBarRaf;
    }, [
        activeTabOffset,
        horizontal,
        rtl,
        indicatorSize
    ]);
    return {
        style: inkStyle
    };
};
var $d6c5d05385b01772$export$2e2bcd8739ae039 = $d6c5d05385b01772$var$useIndicator;

});

parcelRegister("lRqZM", function(module, exports) {

$parcel$export(module.exports, "default", () => $fea37cf40acfe645$export$2e2bcd8739ae039);

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
var $fea37cf40acfe645$var$DEFAULT_SIZE = {
    width: 0,
    height: 0,
    left: 0,
    top: 0
};
function $fea37cf40acfe645$export$2e2bcd8739ae039(tabs, tabSizes, holderScrollWidth) {
    return (0, $acw62.useMemo)(function() {
        var _tabs$;
        var map = new Map();
        var lastOffset = tabSizes.get((_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.key) || $fea37cf40acfe645$var$DEFAULT_SIZE;
        var rightOffset = lastOffset.left + lastOffset.width;
        for(var i = 0; i < tabs.length; i += 1){
            var key = tabs[i].key;
            var data = tabSizes.get(key);
            // Reuse last one when not exist yet
            if (!data) {
                var _tabs;
                data = tabSizes.get((_tabs = tabs[i - 1]) === null || _tabs === void 0 ? void 0 : _tabs.key) || $fea37cf40acfe645$var$DEFAULT_SIZE;
            }
            var entity = map.get(key) || (0, $d49SP.default)({}, data);
            // Right
            entity.right = rightOffset - entity.left - entity.width;
            // Update entity
            map.set(key, entity);
        }
        return map;
    }, [
        tabs.map(function(tab) {
            return tab.key;
        }).join("_"),
        tabSizes,
        holderScrollWidth
    ]);
}

});

parcelRegister("kKQEZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1c0f3be6d5fa93f$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");
function $f1c0f3be6d5fa93f$export$2e2bcd8739ae039(defaultState, onChange) {
    var stateRef = $acw62.useRef(defaultState);
    var _React$useState = $acw62.useState({}), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), forceUpdate = _React$useState2[1];
    function setState(updater) {
        var newValue = typeof updater === "function" ? updater(stateRef.current) : updater;
        if (newValue !== stateRef.current) onChange(newValue, stateRef.current);
        stateRef.current = newValue;
        forceUpdate({});
    }
    return [
        stateRef.current,
        setState
    ];
}

});

parcelRegister("geUbK", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd298a079d025635$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");
var $bd298a079d025635$var$MIN_SWIPE_DISTANCE = 0.1;
var $bd298a079d025635$var$STOP_SWIPE_DISTANCE = 0.01;
var $bd298a079d025635$var$REFRESH_INTERVAL = 20;
var $bd298a079d025635$var$SPEED_OFF_MULTIPLE = Math.pow(0.995, $bd298a079d025635$var$REFRESH_INTERVAL);
function $bd298a079d025635$export$2e2bcd8739ae039(ref, onOffset) {
    var _useState = (0, $acw62.useState)(), _useState2 = (0, $eUqlC.default)(_useState, 2), touchPosition = _useState2[0], setTouchPosition = _useState2[1];
    var _useState3 = (0, $acw62.useState)(0), _useState4 = (0, $eUqlC.default)(_useState3, 2), lastTimestamp = _useState4[0], setLastTimestamp = _useState4[1];
    var _useState5 = (0, $acw62.useState)(0), _useState6 = (0, $eUqlC.default)(_useState5, 2), lastTimeDiff = _useState6[0], setLastTimeDiff = _useState6[1];
    var _useState7 = (0, $acw62.useState)(), _useState8 = (0, $eUqlC.default)(_useState7, 2), lastOffset = _useState8[0], setLastOffset = _useState8[1];
    var motionRef = (0, $acw62.useRef)();
    // ========================= Events =========================
    // >>> Touch events
    function onTouchStart(e) {
        var _e$touches$ = e.touches[0], screenX = _e$touches$.screenX, screenY = _e$touches$.screenY;
        setTouchPosition({
            x: screenX,
            y: screenY
        });
        window.clearInterval(motionRef.current);
    }
    function onTouchMove(e) {
        if (!touchPosition) return;
        e.preventDefault();
        var _e$touches$2 = e.touches[0], screenX = _e$touches$2.screenX, screenY = _e$touches$2.screenY;
        setTouchPosition({
            x: screenX,
            y: screenY
        });
        var offsetX = screenX - touchPosition.x;
        var offsetY = screenY - touchPosition.y;
        onOffset(offsetX, offsetY);
        var now = Date.now();
        setLastTimestamp(now);
        setLastTimeDiff(now - lastTimestamp);
        setLastOffset({
            x: offsetX,
            y: offsetY
        });
    }
    function onTouchEnd() {
        if (!touchPosition) return;
        setTouchPosition(null);
        setLastOffset(null);
        // Swipe if needed
        if (lastOffset) {
            var distanceX = lastOffset.x / lastTimeDiff;
            var distanceY = lastOffset.y / lastTimeDiff;
            var absX = Math.abs(distanceX);
            var absY = Math.abs(distanceY);
            // Skip swipe if low distance
            if (Math.max(absX, absY) < $bd298a079d025635$var$MIN_SWIPE_DISTANCE) return;
            var currentX = distanceX;
            var currentY = distanceY;
            motionRef.current = window.setInterval(function() {
                if (Math.abs(currentX) < $bd298a079d025635$var$STOP_SWIPE_DISTANCE && Math.abs(currentY) < $bd298a079d025635$var$STOP_SWIPE_DISTANCE) {
                    window.clearInterval(motionRef.current);
                    return;
                }
                currentX *= $bd298a079d025635$var$SPEED_OFF_MULTIPLE;
                currentY *= $bd298a079d025635$var$SPEED_OFF_MULTIPLE;
                onOffset(currentX * $bd298a079d025635$var$REFRESH_INTERVAL, currentY * $bd298a079d025635$var$REFRESH_INTERVAL);
            }, $bd298a079d025635$var$REFRESH_INTERVAL);
        }
    }
    // >>> Wheel event
    var lastWheelDirectionRef = (0, $acw62.useRef)();
    function onWheel(e) {
        var deltaX = e.deltaX, deltaY = e.deltaY;
        // Convert both to x & y since wheel only happened on PC
        var mixed = 0;
        var absX = Math.abs(deltaX);
        var absY = Math.abs(deltaY);
        if (absX === absY) mixed = lastWheelDirectionRef.current === "x" ? deltaX : deltaY;
        else if (absX > absY) {
            mixed = deltaX;
            lastWheelDirectionRef.current = "x";
        } else {
            mixed = deltaY;
            lastWheelDirectionRef.current = "y";
        }
        if (onOffset(-mixed, -mixed)) e.preventDefault();
    }
    // ========================= Effect =========================
    var touchEventsRef = (0, $acw62.useRef)(null);
    touchEventsRef.current = {
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        onWheel: onWheel
    };
    $acw62.useEffect(function() {
        function onProxyTouchStart(e) {
            touchEventsRef.current.onTouchStart(e);
        }
        function onProxyTouchMove(e) {
            touchEventsRef.current.onTouchMove(e);
        }
        function onProxyTouchEnd(e) {
            touchEventsRef.current.onTouchEnd(e);
        }
        function onProxyWheel(e) {
            touchEventsRef.current.onWheel(e);
        }
        document.addEventListener("touchmove", onProxyTouchMove, {
            passive: false
        });
        document.addEventListener("touchend", onProxyTouchEnd, {
            passive: false
        });
        // No need to clean up since element removed
        ref.current.addEventListener("touchstart", onProxyTouchStart, {
            passive: false
        });
        ref.current.addEventListener("wheel", onProxyWheel);
        return function() {
            document.removeEventListener("touchmove", onProxyTouchMove);
            document.removeEventListener("touchend", onProxyTouchEnd);
        };
    }, []);
}

});

parcelRegister("9fhUU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb369ac1283ea97$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useUpdateState", () => $6bb369ac1283ea97$export$aefd2a30eb6d999e);

var $eUqlC = parcelRequire("eUqlC");

var $6hDTM = parcelRequire("6hDTM");

var $acw62 = parcelRequire("acw62");
function $6bb369ac1283ea97$export$2e2bcd8739ae039(callback) {
    var _useState = (0, $acw62.useState)(0), _useState2 = (0, $eUqlC.default)(_useState, 2), count = _useState2[0], setCount = _useState2[1];
    var effectRef = (0, $acw62.useRef)(0);
    var callbackRef = (0, $acw62.useRef)();
    callbackRef.current = callback;
    // Trigger on `useLayoutEffect`
    (0, $6hDTM.useLayoutUpdateEffect)(function() {
        var _callbackRef$current;
        (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 || _callbackRef$current.call(callbackRef);
    }, [
        count
    ]);
    // Trigger to update count
    return function() {
        if (effectRef.current !== count) return;
        effectRef.current += 1;
        setCount(effectRef.current);
    };
}
function $6bb369ac1283ea97$export$aefd2a30eb6d999e(defaultState) {
    var batchRef = (0, $acw62.useRef)([]);
    var _useState3 = (0, $acw62.useState)({}), _useState4 = (0, $eUqlC.default)(_useState3, 2), forceUpdate = _useState4[1];
    var state = (0, $acw62.useRef)(typeof defaultState === "function" ? defaultState() : defaultState);
    var flushUpdate = $6bb369ac1283ea97$export$2e2bcd8739ae039(function() {
        var current = state.current;
        batchRef.current.forEach(function(callback) {
            current = callback(current);
        });
        batchRef.current = [];
        state.current = current;
        forceUpdate({});
    });
    function updater(callback) {
        batchRef.current.push(callback);
        flushUpdate();
    }
    return [
        state.current,
        updater
    ];
}

});

parcelRegister("2AX26", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e3cbc4ab07e0147$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $1e3cbc4ab07e0147$var$DEFAULT_SIZE = {
    width: 0,
    height: 0,
    left: 0,
    top: 0,
    right: 0
};
function $1e3cbc4ab07e0147$export$2e2bcd8739ae039(tabOffsets, visibleTabContentValue, transform, tabContentSizeValue, addNodeSizeValue, operationNodeSizeValue, _ref) {
    var tabs = _ref.tabs, tabPosition = _ref.tabPosition, rtl = _ref.rtl;
    var charUnit;
    var position;
    var transformSize;
    if ([
        "top",
        "bottom"
    ].includes(tabPosition)) {
        charUnit = "width";
        position = rtl ? "right" : "left";
        transformSize = Math.abs(transform);
    } else {
        charUnit = "height";
        position = "top";
        transformSize = -transform;
    }
    return (0, $acw62.useMemo)(function() {
        if (!tabs.length) return [
            0,
            0
        ];
        var len = tabs.length;
        var endIndex = len;
        for(var i = 0; i < len; i += 1){
            var offset = tabOffsets.get(tabs[i].key) || $1e3cbc4ab07e0147$var$DEFAULT_SIZE;
            if (offset[position] + offset[charUnit] > transformSize + visibleTabContentValue) {
                endIndex = i - 1;
                break;
            }
        }
        var startIndex = 0;
        for(var _i = len - 1; _i >= 0; _i -= 1){
            var _offset = tabOffsets.get(tabs[_i].key) || $1e3cbc4ab07e0147$var$DEFAULT_SIZE;
            if (_offset[position] < transformSize) {
                startIndex = _i + 1;
                break;
            }
        }
        return startIndex >= endIndex ? [
            0,
            0
        ] : [
            startIndex,
            endIndex
        ];
    }, [
        tabOffsets,
        visibleTabContentValue,
        tabContentSizeValue,
        addNodeSizeValue,
        operationNodeSizeValue,
        transformSize,
        tabPosition,
        tabs.map(function(tab) {
            return tab.key;
        }).join("_"),
        rtl
    ]);
}

});

parcelRegister("P8LbM", function(module, exports) {

$parcel$export(module.exports, "stringify", () => $099b8f1c61d35623$export$fac44ee5b035f737);
$parcel$export(module.exports, "genDataNodeKey", () => $099b8f1c61d35623$export$c55417729a96230c);
$parcel$export(module.exports, "getRemovable", () => $099b8f1c61d35623$export$eab31ca11b8b073);
/**
 * We trade Map as deps which may change with same value but different ref object.
 * We should make it as hash for deps
 * */ function $099b8f1c61d35623$export$fac44ee5b035f737(obj) {
    var tgt;
    if (obj instanceof Map) {
        tgt = {};
        obj.forEach(function(v, k) {
            tgt[k] = v;
        });
    } else tgt = obj;
    return JSON.stringify(tgt);
}
var $099b8f1c61d35623$var$RC_TABS_DOUBLE_QUOTE = "TABS_DQ";
function $099b8f1c61d35623$export$c55417729a96230c(key) {
    return String(key).replace(/"/g, $099b8f1c61d35623$var$RC_TABS_DOUBLE_QUOTE);
}
function $099b8f1c61d35623$export$eab31ca11b8b073(closable, closeIcon, editable, disabled) {
    if (// Only editable tabs can be removed
    !editable || // Tabs cannot be removed when disabled
    disabled || // closable is false
    closable === false || // If closable is undefined, the remove button should be hidden when closeIcon is null or false
    closable === undefined && (closeIcon === false || closeIcon === null)) return false;
    return true;
}

});

parcelRegister("hzIxa", function(module, exports) {

$parcel$export(module.exports, "default", () => $034d4b5b2135dc44$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $034d4b5b2135dc44$var$AddButton = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, editable = props.editable, locale = props.locale, style = props.style;
    if (!editable || editable.showAdd === false) return null;
    return /*#__PURE__*/ $acw62.createElement("button", {
        ref: ref,
        type: "button",
        className: "".concat(prefixCls, "-nav-add"),
        style: style,
        "aria-label": (locale === null || locale === void 0 ? void 0 : locale.addAriaLabel) || "Add tab",
        onClick: function onClick(event) {
            editable.onEdit("add", {
                event: event
            });
        }
    }, editable.addIcon || "+");
});
var $034d4b5b2135dc44$export$2e2bcd8739ae039 = $034d4b5b2135dc44$var$AddButton;

});

parcelRegister("kJlV6", function(module, exports) {

$parcel$export(module.exports, "default", () => $f179037cdfb41409$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $acw62 = parcelRequire("acw62");
var $f179037cdfb41409$var$ExtraContent = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var position = props.position, prefixCls = props.prefixCls, extra = props.extra;
    if (!extra) return null;
    var content;
    // Parse extra
    var assertExtra = {};
    if ((0, $fSwVM.default)(extra) === "object" && !/*#__PURE__*/ $acw62.isValidElement(extra)) assertExtra = extra;
    else assertExtra.right = extra;
    if (position === "right") content = assertExtra.right;
    if (position === "left") content = assertExtra.left;
    return content ? /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-extra-content"),
        ref: ref
    }, content) : null;
});
var $f179037cdfb41409$export$2e2bcd8739ae039 = $f179037cdfb41409$var$ExtraContent;

});

parcelRegister("aRPJM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e96fc940147fd66$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");

var $8g1PZ = parcelRequire("8g1PZ");

var $jtXXN = parcelRequire("jtXXN");

var $feYPt = parcelRequire("feYPt");
var $gXR8t = parcelRequire("gXR8t");

var $iCi4s = parcelRequire("iCi4s");

var $acw62 = parcelRequire("acw62");

var $P8LbM = parcelRequire("P8LbM");

var $hzIxa = parcelRequire("hzIxa");
var $7e96fc940147fd66$var$OperationNode = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, id = props.id, tabs = props.tabs, locale = props.locale, mobile = props.mobile, _props$moreIcon = props.moreIcon, moreIcon = _props$moreIcon === void 0 ? "More" : _props$moreIcon, moreTransitionName = props.moreTransitionName, style = props.style, className = props.className, editable = props.editable, tabBarGutter = props.tabBarGutter, rtl = props.rtl, removeAriaLabel = props.removeAriaLabel, onTabClick = props.onTabClick, getPopupContainer = props.getPopupContainer, popupClassName = props.popupClassName;
    // ======================== Dropdown ========================
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, $eUqlC.default)(_useState, 2), open = _useState2[0], setOpen = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, $eUqlC.default)(_useState3, 2), selectedKey = _useState4[0], setSelectedKey = _useState4[1];
    var popupId = "".concat(id, "-more-popup");
    var dropdownPrefix = "".concat(prefixCls, "-dropdown");
    var selectedItemId = selectedKey !== null ? "".concat(popupId, "-").concat(selectedKey) : null;
    var dropdownAriaLabel = locale === null || locale === void 0 ? void 0 : locale.dropdownAriaLabel;
    function onRemoveTab(event, key) {
        event.preventDefault();
        event.stopPropagation();
        editable.onEdit("remove", {
            key: key,
            event: event
        });
    }
    var menu = /*#__PURE__*/ $acw62.createElement((0, $feYPt.default), {
        onClick: function onClick(_ref) {
            var key = _ref.key, domEvent = _ref.domEvent;
            onTabClick(key, domEvent);
            setOpen(false);
        },
        prefixCls: "".concat(dropdownPrefix, "-menu"),
        id: popupId,
        tabIndex: -1,
        role: "listbox",
        "aria-activedescendant": selectedItemId,
        selectedKeys: [
            selectedKey
        ],
        "aria-label": dropdownAriaLabel !== undefined ? dropdownAriaLabel : "expanded dropdown"
    }, tabs.map(function(tab) {
        var closable = tab.closable, disabled = tab.disabled, closeIcon = tab.closeIcon, key = tab.key, label = tab.label;
        var removable = (0, $P8LbM.getRemovable)(closable, closeIcon, editable, disabled);
        return /*#__PURE__*/ $acw62.createElement((0, $gXR8t.default), {
            key: key,
            id: "".concat(popupId, "-").concat(key),
            role: "option",
            "aria-controls": id && "".concat(id, "-panel-").concat(key),
            disabled: disabled
        }, /*#__PURE__*/ $acw62.createElement("span", null, label), removable && /*#__PURE__*/ $acw62.createElement("button", {
            type: "button",
            "aria-label": removeAriaLabel || "remove",
            tabIndex: 0,
            className: "".concat(dropdownPrefix, "-menu-item-remove"),
            onClick: function onClick(e) {
                e.stopPropagation();
                onRemoveTab(e, key);
            }
        }, closeIcon || editable.removeIcon || "\xd7"));
    }));
    function selectOffset(offset) {
        var enabledTabs = tabs.filter(function(tab) {
            return !tab.disabled;
        });
        var selectedIndex = enabledTabs.findIndex(function(tab) {
            return tab.key === selectedKey;
        }) || 0;
        var len = enabledTabs.length;
        for(var i = 0; i < len; i += 1){
            selectedIndex = (selectedIndex + offset + len) % len;
            var tab = enabledTabs[selectedIndex];
            if (!tab.disabled) {
                setSelectedKey(tab.key);
                return;
            }
        }
    }
    function onKeyDown(e) {
        var which = e.which;
        if (!open) {
            if ([
                (0, $iCi4s.default).DOWN,
                (0, $iCi4s.default).SPACE,
                (0, $iCi4s.default).ENTER
            ].includes(which)) {
                setOpen(true);
                e.preventDefault();
            }
            return;
        }
        switch(which){
            case (0, $iCi4s.default).UP:
                selectOffset(-1);
                e.preventDefault();
                break;
            case (0, $iCi4s.default).DOWN:
                selectOffset(1);
                e.preventDefault();
                break;
            case (0, $iCi4s.default).ESC:
                setOpen(false);
                break;
            case (0, $iCi4s.default).SPACE:
            case (0, $iCi4s.default).ENTER:
                if (selectedKey !== null) onTabClick(selectedKey, e);
                break;
        }
    }
    // ========================= Effect =========================
    (0, $acw62.useEffect)(function() {
        // We use query element here to avoid React strict warning
        var ele = document.getElementById(selectedItemId);
        if (ele && ele.scrollIntoView) ele.scrollIntoView(false);
    }, [
        selectedKey
    ]);
    (0, $acw62.useEffect)(function() {
        if (!open) setSelectedKey(null);
    }, [
        open
    ]);
    // ========================= Render =========================
    var moreStyle = (0, $kSlfw.default)({}, rtl ? "marginRight" : "marginLeft", tabBarGutter);
    if (!tabs.length) {
        moreStyle.visibility = "hidden";
        moreStyle.order = 1;
    }
    var overlayClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)({}, "".concat(dropdownPrefix, "-rtl"), rtl));
    var moreNode = mobile ? null : /*#__PURE__*/ $acw62.createElement((0, $jtXXN.default), {
        prefixCls: dropdownPrefix,
        overlay: menu,
        trigger: [
            "hover"
        ],
        visible: tabs.length ? open : false,
        transitionName: moreTransitionName,
        onVisibleChange: setOpen,
        overlayClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(overlayClassName, popupClassName),
        mouseEnterDelay: 0.1,
        mouseLeaveDelay: 0.1,
        getPopupContainer: getPopupContainer
    }, /*#__PURE__*/ $acw62.createElement("button", {
        type: "button",
        className: "".concat(prefixCls, "-nav-more"),
        style: moreStyle,
        tabIndex: -1,
        "aria-hidden": "true",
        "aria-haspopup": "listbox",
        "aria-controls": popupId,
        id: "".concat(id, "-more"),
        "aria-expanded": open,
        onKeyDown: onKeyDown
    }, moreIcon));
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-nav-operations"), className),
        style: style,
        ref: ref
    }, moreNode, /*#__PURE__*/ $acw62.createElement((0, $hzIxa.default), {
        prefixCls: prefixCls,
        locale: locale,
        editable: editable
    }));
});
var $7e96fc940147fd66$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.memo($7e96fc940147fd66$var$OperationNode, function(_, next) {
    return(// https://github.com/ant-design/ant-design/issues/32544
    // We'd better remove syntactic sugar in `rc-menu` since this has perf issue
    next.tabMoving);
});

});
parcelRegister("jtXXN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2ef3d42b101c489$export$2e2bcd8739ae039);

var $kzwHj = parcelRequire("kzwHj");
var $e2ef3d42b101c489$export$2e2bcd8739ae039 = (0, $kzwHj.default);

});
parcelRegister("kzwHj", function(module, exports) {

$parcel$export(module.exports, "default", () => $efa0709bbe269de7$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $eyPR1 = parcelRequire("eyPR1");

var $8g1PZ = parcelRequire("8g1PZ");

var $85dLH = parcelRequire("85dLH");

var $acw62 = parcelRequire("acw62");

var $lKDdC = parcelRequire("lKDdC");

var $jNeWR = parcelRequire("jNeWR");

var $dfVFD = parcelRequire("dfVFD");
var $efa0709bbe269de7$var$_excluded = [
    "arrow",
    "prefixCls",
    "transitionName",
    "animation",
    "align",
    "placement",
    "placements",
    "getPopupContainer",
    "showAction",
    "hideAction",
    "overlayClassName",
    "overlayStyle",
    "visible",
    "trigger",
    "autoFocus",
    "overlay",
    "children",
    "onVisibleChange"
];
function $efa0709bbe269de7$var$Dropdown(props, ref) {
    var _children$props;
    var _props$arrow = props.arrow, arrow = _props$arrow === void 0 ? false : _props$arrow, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-dropdown" : _props$prefixCls, transitionName = props.transitionName, animation = props.animation, align = props.align, _props$placement = props.placement, placement = _props$placement === void 0 ? "bottomLeft" : _props$placement, _props$placements = props.placements, placements = _props$placements === void 0 ? (0, $dfVFD.default) : _props$placements, getPopupContainer = props.getPopupContainer, showAction = props.showAction, hideAction = props.hideAction, overlayClassName = props.overlayClassName, overlayStyle = props.overlayStyle, visible = props.visible, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? [
        "hover"
    ] : _props$trigger, autoFocus = props.autoFocus, overlay = props.overlay, children = props.children, onVisibleChange = props.onVisibleChange, otherProps = (0, $9X7IJ.default)(props, $efa0709bbe269de7$var$_excluded);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), triggerVisible = _React$useState2[0], setTriggerVisible = _React$useState2[1];
    var mergedVisible = "visible" in props ? visible : triggerVisible;
    var triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    var overlayRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    var childRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, function() {
        return triggerRef.current;
    });
    var handleVisibleChange = function handleVisibleChange(newVisible) {
        setTriggerVisible(newVisible);
        onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(newVisible);
    };
    (0, $lKDdC.default)({
        visible: mergedVisible,
        triggerRef: childRef,
        onVisibleChange: handleVisibleChange,
        autoFocus: autoFocus,
        overlayRef: overlayRef
    });
    var onClick = function onClick(e) {
        var onOverlayClick = props.onOverlayClick;
        setTriggerVisible(false);
        if (onOverlayClick) onOverlayClick(e);
    };
    var getMenuElement = function getMenuElement() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jNeWR.default), {
            ref: overlayRef,
            overlay: overlay,
            prefixCls: prefixCls,
            arrow: arrow
        });
    };
    var getMenuElementOrLambda = function getMenuElementOrLambda() {
        if (typeof overlay === "function") return getMenuElement;
        return getMenuElement();
    };
    var getMinOverlayWidthMatchTrigger = function getMinOverlayWidthMatchTrigger() {
        var minOverlayWidthMatchTrigger = props.minOverlayWidthMatchTrigger, alignPoint = props.alignPoint;
        if ("minOverlayWidthMatchTrigger" in props) return minOverlayWidthMatchTrigger;
        return !alignPoint;
    };
    var getOpenClassName = function getOpenClassName() {
        var openClassName = props.openClassName;
        if (openClassName !== undefined) return openClassName;
        return "".concat(prefixCls, "-open");
    };
    var childrenNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(children, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props.className, mergedVisible && getOpenClassName()),
        ref: (0, $85dLH.supportRef)(children) ? (0, $85dLH.composeRef)(childRef, children.ref) : undefined
    });
    var triggerHideAction = hideAction;
    if (!triggerHideAction && trigger.indexOf("contextMenu") !== -1) triggerHideAction = [
        "click"
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eyPR1.default), (0, $8nd05.default)({
        builtinPlacements: placements
    }, otherProps, {
        prefixCls: prefixCls,
        ref: triggerRef,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(overlayClassName, (0, $kSlfw.default)({}, "".concat(prefixCls, "-show-arrow"), arrow)),
        popupStyle: overlayStyle,
        action: trigger,
        showAction: showAction,
        hideAction: triggerHideAction,
        popupPlacement: placement,
        popupAlign: align,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupVisible: mergedVisible,
        stretch: getMinOverlayWidthMatchTrigger() ? "minWidth" : "",
        popup: getMenuElementOrLambda(),
        onPopupVisibleChange: handleVisibleChange,
        onPopupClick: onClick,
        getPopupContainer: getPopupContainer
    }), childrenNode);
}
var $efa0709bbe269de7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($efa0709bbe269de7$var$Dropdown);

});
parcelRegister("eyPR1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a99c76d30a1f506f$export$2e2bcd8739ae039);

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $7PQDT = parcelRequire("7PQDT");

var $8g1PZ = parcelRequire("8g1PZ");

var $bVxlN = parcelRequire("bVxlN");

var $b2dYb = parcelRequire("b2dYb");

var $fXR7w = parcelRequire("fXR7w");

var $a4gyP = parcelRequire("a4gyP");

var $i35Ni = parcelRequire("i35Ni");

var $6hDTM = parcelRequire("6hDTM");

var $ycMhT = parcelRequire("ycMhT");

var $acw62 = parcelRequire("acw62");

var $izbs9 = parcelRequire("izbs9");

var $f5iV2 = parcelRequire("f5iV2");

var $lras0 = parcelRequire("lras0");

var $8KMNr = parcelRequire("8KMNr");

var $e3cNJ = parcelRequire("e3cNJ");

var $dGzen = parcelRequire("dGzen");

var $b4OTf = parcelRequire("b4OTf");

var $1ILwc = parcelRequire("1ILwc");
var $a99c76d30a1f506f$var$_excluded = [
    "prefixCls",
    "children",
    "action",
    "showAction",
    "hideAction",
    "popupVisible",
    "defaultPopupVisible",
    "onPopupVisibleChange",
    "afterPopupVisibleChange",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "focusDelay",
    "blurDelay",
    "mask",
    "maskClosable",
    "getPopupContainer",
    "forceRender",
    "autoDestroy",
    "destroyPopupOnHide",
    "popup",
    "popupClassName",
    "popupStyle",
    "popupPlacement",
    "builtinPlacements",
    "popupAlign",
    "zIndex",
    "stretch",
    "getPopupClassNameFromAlign",
    "fresh",
    "alignPoint",
    "onPopupClick",
    "onPopupAlign",
    "arrow",
    "popupMotion",
    "maskMotion",
    "popupTransitionName",
    "popupAnimation",
    "maskTransitionName",
    "maskAnimation",
    "className",
    "getTriggerDOMNode"
];
function $a99c76d30a1f506f$export$55e99723d7f71b47() {
    var PortalComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $7PQDT.default);
    var Trigger = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
        var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-trigger-popup" : _props$prefixCls, children = props.children, _props$action = props.action, action = _props$action === void 0 ? "hover" : _props$action, showAction = props.showAction, hideAction = props.hideAction, popupVisible = props.popupVisible, defaultPopupVisible = props.defaultPopupVisible, onPopupVisibleChange = props.onPopupVisibleChange, afterPopupVisibleChange = props.afterPopupVisibleChange, mouseEnterDelay = props.mouseEnterDelay, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, focusDelay = props.focusDelay, blurDelay = props.blurDelay, mask = props.mask, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, getPopupContainer = props.getPopupContainer, forceRender = props.forceRender, autoDestroy = props.autoDestroy, destroyPopupOnHide = props.destroyPopupOnHide, popup = props.popup, popupClassName = props.popupClassName, popupStyle = props.popupStyle, popupPlacement = props.popupPlacement, _props$builtinPlaceme = props.builtinPlacements, builtinPlacements = _props$builtinPlaceme === void 0 ? {} : _props$builtinPlaceme, popupAlign = props.popupAlign, zIndex = props.zIndex, stretch = props.stretch, getPopupClassNameFromAlign = props.getPopupClassNameFromAlign, fresh = props.fresh, alignPoint = props.alignPoint, onPopupClick = props.onPopupClick, onPopupAlign = props.onPopupAlign, arrow = props.arrow, popupMotion = props.popupMotion, maskMotion = props.maskMotion, popupTransitionName = props.popupTransitionName, popupAnimation = props.popupAnimation, maskTransitionName = props.maskTransitionName, maskAnimation = props.maskAnimation, className = props.className, getTriggerDOMNode = props.getTriggerDOMNode, restProps = (0, $9X7IJ.default)(props, $a99c76d30a1f506f$var$_excluded);
        var mergedAutoDestroy = autoDestroy || destroyPopupOnHide || false;
        // =========================== Mobile ===========================
        var _React$useState = $acw62.useState(false), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), mobile = _React$useState2[0], setMobile = _React$useState2[1];
        (0, $6hDTM.default)(function() {
            setMobile((0, $ycMhT.default)());
        }, []);
        // ========================== Context ===========================
        var subPopupElements = $acw62.useRef({});
        var parentContext = $acw62.useContext((0, $lras0.default));
        var context = $acw62.useMemo(function() {
            return {
                registerSubPopup: function registerSubPopup(id, subPopupEle) {
                    subPopupElements.current[id] = subPopupEle;
                    parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id, subPopupEle);
                }
            };
        }, [
            parentContext
        ]);
        // =========================== Popup ============================
        var id = (0, $i35Ni.default)();
        var _React$useState3 = $acw62.useState(null), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), popupEle = _React$useState4[0], setPopupEle = _React$useState4[1];
        var setPopupRef = (0, $a4gyP.default)(function(node) {
            if ((0, $b2dYb.isDOM)(node) && popupEle !== node) setPopupEle(node);
            parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id, node);
        });
        // =========================== Target ===========================
        // Use state to control here since `useRef` update not trigger render
        var _React$useState5 = $acw62.useState(null), _React$useState6 = (0, $eUqlC.default)(_React$useState5, 2), targetEle = _React$useState6[0], setTargetEle = _React$useState6[1];
        // Used for forwardRef target. Not use internal
        var externalForwardRef = $acw62.useRef(null);
        var setTargetRef = (0, $a4gyP.default)(function(node) {
            if ((0, $b2dYb.isDOM)(node) && targetEle !== node) {
                setTargetEle(node);
                externalForwardRef.current = node;
            }
        });
        // ========================== Children ==========================
        var child = $acw62.Children.only(children);
        var originChildProps = (child === null || child === void 0 ? void 0 : child.props) || {};
        var cloneProps = {};
        var inPopupOrChild = (0, $a4gyP.default)(function(ele) {
            var _getShadowRoot, _getShadowRoot2;
            var childDOM = targetEle;
            return (childDOM === null || childDOM === void 0 ? void 0 : childDOM.contains(ele)) || ((_getShadowRoot = (0, $fXR7w.getShadowRoot)(childDOM)) === null || _getShadowRoot === void 0 ? void 0 : _getShadowRoot.host) === ele || ele === childDOM || (popupEle === null || popupEle === void 0 ? void 0 : popupEle.contains(ele)) || ((_getShadowRoot2 = (0, $fXR7w.getShadowRoot)(popupEle)) === null || _getShadowRoot2 === void 0 ? void 0 : _getShadowRoot2.host) === ele || ele === popupEle || Object.values(subPopupElements.current).some(function(subPopupEle) {
                return (subPopupEle === null || subPopupEle === void 0 ? void 0 : subPopupEle.contains(ele)) || ele === subPopupEle;
            });
        });
        // =========================== Motion ===========================
        var mergePopupMotion = (0, $1ILwc.getMotion)(prefixCls, popupMotion, popupAnimation, popupTransitionName);
        var mergeMaskMotion = (0, $1ILwc.getMotion)(prefixCls, maskMotion, maskAnimation, maskTransitionName);
        // ============================ Open ============================
        var _React$useState7 = $acw62.useState(defaultPopupVisible || false), _React$useState8 = (0, $eUqlC.default)(_React$useState7, 2), internalOpen = _React$useState8[0], setInternalOpen = _React$useState8[1];
        // Render still use props as first priority
        var mergedOpen = popupVisible !== null && popupVisible !== void 0 ? popupVisible : internalOpen;
        // We use effect sync here in case `popupVisible` back to `undefined`
        var setMergedOpen = (0, $a4gyP.default)(function(nextOpen) {
            if (popupVisible === undefined) setInternalOpen(nextOpen);
        });
        (0, $6hDTM.default)(function() {
            setInternalOpen(popupVisible || false);
        }, [
            popupVisible
        ]);
        var openRef = $acw62.useRef(mergedOpen);
        openRef.current = mergedOpen;
        var lastTriggerRef = $acw62.useRef([]);
        lastTriggerRef.current = [];
        var internalTriggerOpen = (0, $a4gyP.default)(function(nextOpen) {
            var _lastTriggerRef$curre;
            setMergedOpen(nextOpen);
            // Enter or Pointer will both trigger open state change
            // We only need take one to avoid duplicated change event trigger
            // Use `lastTriggerRef` to record last open type
            if (((_lastTriggerRef$curre = lastTriggerRef.current[lastTriggerRef.current.length - 1]) !== null && _lastTriggerRef$curre !== void 0 ? _lastTriggerRef$curre : mergedOpen) !== nextOpen) {
                lastTriggerRef.current.push(nextOpen);
                onPopupVisibleChange === null || onPopupVisibleChange === void 0 || onPopupVisibleChange(nextOpen);
            }
        });
        // Trigger for delay
        var delayRef = $acw62.useRef();
        var clearDelay = function clearDelay() {
            clearTimeout(delayRef.current);
        };
        var triggerOpen = function triggerOpen(nextOpen) {
            var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            clearDelay();
            if (delay === 0) internalTriggerOpen(nextOpen);
            else delayRef.current = setTimeout(function() {
                internalTriggerOpen(nextOpen);
            }, delay * 1000);
        };
        $acw62.useEffect(function() {
            return clearDelay;
        }, []);
        // ========================== Motion ============================
        var _React$useState9 = $acw62.useState(false), _React$useState10 = (0, $eUqlC.default)(_React$useState9, 2), inMotion = _React$useState10[0], setInMotion = _React$useState10[1];
        (0, $6hDTM.default)(function(firstMount) {
            if (!firstMount || mergedOpen) setInMotion(true);
        }, [
            mergedOpen
        ]);
        var _React$useState11 = $acw62.useState(null), _React$useState12 = (0, $eUqlC.default)(_React$useState11, 2), motionPrepareResolve = _React$useState12[0], setMotionPrepareResolve = _React$useState12[1];
        // =========================== Align ============================
        var _React$useState13 = $acw62.useState([
            0,
            0
        ]), _React$useState14 = (0, $eUqlC.default)(_React$useState13, 2), mousePos = _React$useState14[0], setMousePos = _React$useState14[1];
        var setMousePosByEvent = function setMousePosByEvent(event) {
            setMousePos([
                event.clientX,
                event.clientY
            ]);
        };
        var _useAlign = (0, $e3cNJ.default)(mergedOpen, popupEle, alignPoint ? mousePos : targetEle, popupPlacement, builtinPlacements, popupAlign, onPopupAlign), _useAlign2 = (0, $eUqlC.default)(_useAlign, 11), ready = _useAlign2[0], offsetX = _useAlign2[1], offsetY = _useAlign2[2], offsetR = _useAlign2[3], offsetB = _useAlign2[4], arrowX = _useAlign2[5], arrowY = _useAlign2[6], scaleX = _useAlign2[7], scaleY = _useAlign2[8], alignInfo = _useAlign2[9], onAlign = _useAlign2[10];
        var _useAction = (0, $8KMNr.default)(mobile, action, showAction, hideAction), _useAction2 = (0, $eUqlC.default)(_useAction, 2), showActions = _useAction2[0], hideActions = _useAction2[1];
        var clickToShow = showActions.has("click");
        var clickToHide = hideActions.has("click") || hideActions.has("contextMenu");
        var triggerAlign = (0, $a4gyP.default)(function() {
            if (!inMotion) onAlign();
        });
        var onScroll = function onScroll() {
            if (openRef.current && alignPoint && clickToHide) triggerOpen(false);
        };
        (0, $dGzen.default)(mergedOpen, targetEle, popupEle, triggerAlign, onScroll);
        (0, $6hDTM.default)(function() {
            triggerAlign();
        }, [
            mousePos,
            popupPlacement
        ]);
        // When no builtinPlacements and popupAlign changed
        (0, $6hDTM.default)(function() {
            if (mergedOpen && !(builtinPlacements !== null && builtinPlacements !== void 0 && builtinPlacements[popupPlacement])) triggerAlign();
        }, [
            JSON.stringify(popupAlign)
        ]);
        var alignedClassName = $acw62.useMemo(function() {
            var baseClassName = (0, $1ILwc.getAlignPopupClassName)(builtinPlacements, prefixCls, alignInfo, alignPoint);
            return (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(baseClassName, getPopupClassNameFromAlign === null || getPopupClassNameFromAlign === void 0 ? void 0 : getPopupClassNameFromAlign(alignInfo));
        }, [
            alignInfo,
            getPopupClassNameFromAlign,
            builtinPlacements,
            prefixCls,
            alignPoint
        ]);
        // ============================ Refs ============================
        $acw62.useImperativeHandle(ref, function() {
            return {
                nativeElement: externalForwardRef.current,
                forceAlign: triggerAlign
            };
        });
        // ========================== Stretch ===========================
        var _React$useState15 = $acw62.useState(0), _React$useState16 = (0, $eUqlC.default)(_React$useState15, 2), targetWidth = _React$useState16[0], setTargetWidth = _React$useState16[1];
        var _React$useState17 = $acw62.useState(0), _React$useState18 = (0, $eUqlC.default)(_React$useState17, 2), targetHeight = _React$useState18[0], setTargetHeight = _React$useState18[1];
        var syncTargetSize = function syncTargetSize() {
            if (stretch && targetEle) {
                var rect = targetEle.getBoundingClientRect();
                setTargetWidth(rect.width);
                setTargetHeight(rect.height);
            }
        };
        var onTargetResize = function onTargetResize() {
            syncTargetSize();
            triggerAlign();
        };
        // ========================== Motion ============================
        var onVisibleChanged = function onVisibleChanged(visible) {
            setInMotion(false);
            onAlign();
            afterPopupVisibleChange === null || afterPopupVisibleChange === void 0 || afterPopupVisibleChange(visible);
        };
        // We will trigger align when motion is in prepare
        var onPrepare = function onPrepare() {
            return new Promise(function(resolve) {
                syncTargetSize();
                setMotionPrepareResolve(function() {
                    return resolve;
                });
            });
        };
        (0, $6hDTM.default)(function() {
            if (motionPrepareResolve) {
                onAlign();
                motionPrepareResolve();
                setMotionPrepareResolve(null);
            }
        }, [
            motionPrepareResolve
        ]);
        // =========================== Action ===========================
        /**
     * Util wrapper for trigger action
     */ function wrapperAction(eventName, nextOpen, delay, preEvent) {
            cloneProps[eventName] = function(event) {
                var _originChildProps$eve;
                preEvent === null || preEvent === void 0 || preEvent(event);
                triggerOpen(nextOpen, delay);
                // Pass to origin
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                (_originChildProps$eve = originChildProps[eventName]) === null || _originChildProps$eve === void 0 || _originChildProps$eve.call.apply(_originChildProps$eve, [
                    originChildProps,
                    event
                ].concat(args));
            };
        }
        // ======================= Action: Click ========================
        if (clickToShow || clickToHide) cloneProps.onClick = function(event) {
            var _originChildProps$onC;
            if (openRef.current && clickToHide) triggerOpen(false);
            else if (!openRef.current && clickToShow) {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            // Pass to origin
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            (_originChildProps$onC = originChildProps.onClick) === null || _originChildProps$onC === void 0 || _originChildProps$onC.call.apply(_originChildProps$onC, [
                originChildProps,
                event
            ].concat(args));
        };
        // Click to hide is special action since click popup element should not hide
        (0, $b4OTf.default)(mergedOpen, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen);
        // ======================= Action: Hover ========================
        var hoverToShow = showActions.has("hover");
        var hoverToHide = hideActions.has("hover");
        var onPopupMouseEnter;
        var onPopupMouseLeave;
        if (hoverToShow) {
            // Compatible with old browser which not support pointer event
            wrapperAction("onMouseEnter", true, mouseEnterDelay, function(event) {
                setMousePosByEvent(event);
            });
            wrapperAction("onPointerEnter", true, mouseEnterDelay, function(event) {
                setMousePosByEvent(event);
            });
            onPopupMouseEnter = function onPopupMouseEnter() {
                // Only trigger re-open when popup is visible
                if (mergedOpen || inMotion) triggerOpen(true, mouseEnterDelay);
            };
            // Align Point
            if (alignPoint) cloneProps.onMouseMove = function(event) {
                var _originChildProps$onM;
                // setMousePosByEvent(event);
                (_originChildProps$onM = originChildProps.onMouseMove) === null || _originChildProps$onM === void 0 || _originChildProps$onM.call(originChildProps, event);
            };
        }
        if (hoverToHide) {
            wrapperAction("onMouseLeave", false, mouseLeaveDelay);
            wrapperAction("onPointerLeave", false, mouseLeaveDelay);
            onPopupMouseLeave = function onPopupMouseLeave() {
                triggerOpen(false, mouseLeaveDelay);
            };
        }
        // ======================= Action: Focus ========================
        if (showActions.has("focus")) wrapperAction("onFocus", true, focusDelay);
        if (hideActions.has("focus")) wrapperAction("onBlur", false, blurDelay);
        // ==================== Action: ContextMenu =====================
        if (showActions.has("contextMenu")) cloneProps.onContextMenu = function(event) {
            var _originChildProps$onC2;
            if (openRef.current && hideActions.has("contextMenu")) triggerOpen(false);
            else {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            event.preventDefault();
            // Pass to origin
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            (_originChildProps$onC2 = originChildProps.onContextMenu) === null || _originChildProps$onC2 === void 0 || _originChildProps$onC2.call.apply(_originChildProps$onC2, [
                originChildProps,
                event
            ].concat(args));
        };
        // ========================= ClassName ==========================
        if (className) cloneProps.className = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(originChildProps.className, className);
        // =========================== Render ===========================
        var mergedChildrenProps = (0, $d49SP.default)((0, $d49SP.default)({}, originChildProps), cloneProps);
        // Pass props into cloneProps for nest usage
        var passedProps = {};
        var passedEventList = [
            "onContextMenu",
            "onClick",
            "onMouseDown",
            "onTouchStart",
            "onMouseEnter",
            "onMouseLeave",
            "onFocus",
            "onBlur"
        ];
        passedEventList.forEach(function(eventName) {
            if (restProps[eventName]) passedProps[eventName] = function() {
                var _mergedChildrenProps$;
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                (_mergedChildrenProps$ = mergedChildrenProps[eventName]) === null || _mergedChildrenProps$ === void 0 || _mergedChildrenProps$.call.apply(_mergedChildrenProps$, [
                    mergedChildrenProps
                ].concat(args));
                restProps[eventName].apply(restProps, args);
            };
        });
        // Child Node
        var triggerNode = /*#__PURE__*/ $acw62.cloneElement(child, (0, $d49SP.default)((0, $d49SP.default)({}, mergedChildrenProps), passedProps));
        var arrowPos = {
            x: arrowX,
            y: arrowY
        };
        var innerArrow = arrow ? (0, $d49SP.default)({}, arrow !== true ? arrow : {}) : null;
        // Render
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $bVxlN.default), {
            disabled: !mergedOpen,
            ref: setTargetRef,
            onResize: onTargetResize
        }, /*#__PURE__*/ $acw62.createElement((0, $f5iV2.default), {
            getTriggerDOMNode: getTriggerDOMNode
        }, triggerNode)), /*#__PURE__*/ $acw62.createElement((0, $lras0.default).Provider, {
            value: context
        }, /*#__PURE__*/ $acw62.createElement((0, $izbs9.default), {
            portal: PortalComponent,
            ref: setPopupRef,
            prefixCls: prefixCls,
            popup: popup,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(popupClassName, alignedClassName),
            style: popupStyle,
            target: targetEle,
            onMouseEnter: onPopupMouseEnter,
            onMouseLeave: onPopupMouseLeave,
            onPointerEnter: onPopupMouseEnter,
            zIndex: zIndex,
            open: mergedOpen,
            keepDom: inMotion,
            fresh: fresh,
            onClick: onPopupClick,
            mask: mask,
            motion: mergePopupMotion,
            maskMotion: mergeMaskMotion,
            onVisibleChanged: onVisibleChanged,
            onPrepare: onPrepare,
            forceRender: forceRender,
            autoDestroy: mergedAutoDestroy,
            getPopupContainer: getPopupContainer,
            align: alignInfo,
            arrow: innerArrow,
            arrowPos: arrowPos,
            ready: ready,
            offsetX: offsetX,
            offsetY: offsetY,
            offsetR: offsetR,
            offsetB: offsetB,
            onAlign: triggerAlign,
            stretch: stretch,
            targetWidth: targetWidth / scaleX,
            targetHeight: targetHeight / scaleY
        })));
    });
    return Trigger;
}
var $a99c76d30a1f506f$export$2e2bcd8739ae039 = $a99c76d30a1f506f$export$55e99723d7f71b47((0, $7PQDT.default));

});
parcelRegister("7PQDT", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b46218595a40828$export$2e2bcd8739ae039);

var $eXIAJ = parcelRequire("eXIAJ");

var $3QskB = parcelRequire("3QskB");
var $5b46218595a40828$export$2e2bcd8739ae039 = (0, $eXIAJ.default);

});
parcelRegister("eXIAJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae492a4c7ad9d4f3$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $h4v51 = parcelRequire("h4v51");
parcelRequire("u43uR");

var $85dLH = parcelRequire("85dLH");

var $fsRi1 = parcelRequire("fsRi1");

var $1Zl4D = parcelRequire("1Zl4D");

var $8OR1g = parcelRequire("8OR1g");

var $3QskB = parcelRequire("3QskB");
var $ae492a4c7ad9d4f3$var$getPortalContainer = function getPortalContainer(getContainer) {
    if (getContainer === false) return false;
    if (!(0, $h4v51.default)() || !getContainer) return null;
    if (typeof getContainer === "string") return document.querySelector(getContainer);
    if (typeof getContainer === "function") return getContainer();
    return getContainer;
};
var $ae492a4c7ad9d4f3$var$Portal = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var open = props.open, autoLock = props.autoLock, getContainer = props.getContainer, debug = props.debug, _props$autoDestroy = props.autoDestroy, autoDestroy = _props$autoDestroy === void 0 ? true : _props$autoDestroy, children = props.children;
    var _React$useState = $acw62.useState(open), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), shouldRender = _React$useState2[0], setShouldRender = _React$useState2[1];
    var mergedRender = shouldRender || open;
    // ====================== Should Render ======================
    $acw62.useEffect(function() {
        if (autoDestroy || open) setShouldRender(open);
    }, [
        open,
        autoDestroy
    ]);
    // ======================== Container ========================
    var _React$useState3 = $acw62.useState(function() {
        return $ae492a4c7ad9d4f3$var$getPortalContainer(getContainer);
    }), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), innerContainer = _React$useState4[0], setInnerContainer = _React$useState4[1];
    $acw62.useEffect(function() {
        var customizeContainer = $ae492a4c7ad9d4f3$var$getPortalContainer(getContainer);
        // Tell component that we check this in effect which is safe to be `null`
        setInnerContainer(customizeContainer !== null && customizeContainer !== void 0 ? customizeContainer : null);
    });
    var _useDom = (0, $1Zl4D.default)(mergedRender && !innerContainer, debug), _useDom2 = (0, $eUqlC.default)(_useDom, 2), defaultContainer = _useDom2[0], queueCreate = _useDom2[1];
    var mergedContainer = innerContainer !== null && innerContainer !== void 0 ? innerContainer : defaultContainer;
    // ========================= Locker ==========================
    (0, $8OR1g.default)(autoLock && open && (0, $h4v51.default)() && (mergedContainer === defaultContainer || mergedContainer === document.body));
    // =========================== Ref ===========================
    var childRef = null;
    if (children && (0, $85dLH.supportRef)(children) && ref) {
        var _ref = children;
        childRef = _ref.ref;
    }
    var mergedRef = (0, $85dLH.useComposeRef)(childRef, ref);
    // ========================= Render ==========================
    // Do not render when nothing need render
    // When innerContainer is `undefined`, it may not ready since user use ref in the same render
    if (!mergedRender || !(0, $h4v51.default)() || innerContainer === undefined) return null;
    // Render inline
    var renderInline = mergedContainer === false || (0, $3QskB.inlineMock)();
    var reffedChildren = children;
    if (ref) reffedChildren = /*#__PURE__*/ $acw62.cloneElement(children, {
        ref: mergedRef
    });
    return /*#__PURE__*/ $acw62.createElement((0, $fsRi1.default).Provider, {
        value: queueCreate
    }, renderInline ? reffedChildren : /*#__PURE__*/ (0, $1u0KT.createPortal)(reffedChildren, mergedContainer));
});
var $ae492a4c7ad9d4f3$export$2e2bcd8739ae039 = $ae492a4c7ad9d4f3$var$Portal;

});
parcelRegister("fsRi1", function(module, exports) {

$parcel$export(module.exports, "default", () => $b422cebf586837cd$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $b422cebf586837cd$var$OrderContext = /*#__PURE__*/ $acw62.createContext(null);
var $b422cebf586837cd$export$2e2bcd8739ae039 = $b422cebf586837cd$var$OrderContext;

});

parcelRegister("1Zl4D", function(module, exports) {

$parcel$export(module.exports, "default", () => $172bd5bc03f91d44$export$2e2bcd8739ae039);

var $kbxxf = parcelRequire("kbxxf");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $6hDTM = parcelRequire("6hDTM");

var $h4v51 = parcelRequire("h4v51");

var $fsRi1 = parcelRequire("fsRi1");
var $172bd5bc03f91d44$var$EMPTY_LIST = [];
function $172bd5bc03f91d44$export$2e2bcd8739ae039(render, debug) {
    var _React$useState = $acw62.useState(function() {
        if (!(0, $h4v51.default)()) return null;
        var defaultEle = document.createElement("div");
        return defaultEle;
    }), _React$useState2 = (0, $eUqlC.default)(_React$useState, 1), ele = _React$useState2[0];
    // ========================== Order ==========================
    var appendedRef = $acw62.useRef(false);
    var queueCreate = $acw62.useContext((0, $fsRi1.default));
    var _React$useState3 = $acw62.useState($172bd5bc03f91d44$var$EMPTY_LIST), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), queue = _React$useState4[0], setQueue = _React$useState4[1];
    var mergedQueueCreate = queueCreate || (appendedRef.current ? undefined : function(appendFn) {
        setQueue(function(origin) {
            var newQueue = [
                appendFn
            ].concat((0, $kbxxf.default)(origin));
            return newQueue;
        });
    });
    // =========================== DOM ===========================
    function append() {
        if (!ele.parentElement) document.body.appendChild(ele);
        appendedRef.current = true;
    }
    function cleanup() {
        var _ele$parentElement;
        (_ele$parentElement = ele.parentElement) === null || _ele$parentElement === void 0 || _ele$parentElement.removeChild(ele);
        appendedRef.current = false;
    }
    (0, $6hDTM.default)(function() {
        if (render) {
            if (queueCreate) queueCreate(append);
            else append();
        } else cleanup();
        return cleanup;
    }, [
        render
    ]);
    (0, $6hDTM.default)(function() {
        if (queue.length) {
            queue.forEach(function(appendFn) {
                return appendFn();
            });
            setQueue($172bd5bc03f91d44$var$EMPTY_LIST);
        }
    }, [
        queue
    ]);
    return [
        ele,
        mergedQueueCreate
    ];
}

});

parcelRegister("8OR1g", function(module, exports) {

$parcel$export(module.exports, "default", () => $66bc1eccb2a603c3$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $4ZrBP = parcelRequire("4ZrBP");

var $6hDTM = parcelRequire("6hDTM");

var $2SjmF = parcelRequire("2SjmF");

var $hhYXs = parcelRequire("hhYXs");
var $66bc1eccb2a603c3$var$UNIQUE_ID = "rc-util-locker-".concat(Date.now());
var $66bc1eccb2a603c3$var$uuid = 0;
function $66bc1eccb2a603c3$export$2e2bcd8739ae039(lock) {
    var mergedLock = !!lock;
    var _React$useState = $acw62.useState(function() {
        $66bc1eccb2a603c3$var$uuid += 1;
        return "".concat($66bc1eccb2a603c3$var$UNIQUE_ID, "_").concat($66bc1eccb2a603c3$var$uuid);
    }), _React$useState2 = (0, $eUqlC.default)(_React$useState, 1), id = _React$useState2[0];
    (0, $6hDTM.default)(function() {
        if (mergedLock) {
            var scrollbarSize = (0, $2SjmF.getTargetScrollBarSize)(document.body).width;
            var isOverflow = (0, $hhYXs.isBodyOverflowing)();
            (0, $4ZrBP.updateCSS)("\nhtml body {\n  overflow-y: hidden;\n  ".concat(isOverflow ? "width: calc(100% - ".concat(scrollbarSize, "px);") : "", "\n}"), id);
        } else (0, $4ZrBP.removeCSS)(id);
        return function() {
            (0, $4ZrBP.removeCSS)(id);
        };
    }, [
        mergedLock,
        id
    ]);
}

});
parcelRegister("2SjmF", function(module, exports) {

$parcel$export(module.exports, "getTargetScrollBarSize", () => $217fa5593a6718d2$export$4f3ef2310365b56a);
/* eslint-disable no-param-reassign */ var $217fa5593a6718d2$var$cached;
function $217fa5593a6718d2$export$2e2bcd8739ae039(fresh) {
    if (typeof document === "undefined") return 0;
    if (fresh || $217fa5593a6718d2$var$cached === undefined) {
        var inner = document.createElement("div");
        inner.style.width = "100%";
        inner.style.height = "200px";
        var outer = document.createElement("div");
        var outerStyle = outer.style;
        outerStyle.position = "absolute";
        outerStyle.top = "0";
        outerStyle.left = "0";
        outerStyle.pointerEvents = "none";
        outerStyle.visibility = "hidden";
        outerStyle.width = "200px";
        outerStyle.height = "150px";
        outerStyle.overflow = "hidden";
        outer.appendChild(inner);
        document.body.appendChild(outer);
        var widthContained = inner.offsetWidth;
        outer.style.overflow = "scroll";
        var widthScroll = inner.offsetWidth;
        if (widthContained === widthScroll) widthScroll = outer.clientWidth;
        document.body.removeChild(outer);
        $217fa5593a6718d2$var$cached = widthContained - widthScroll;
    }
    return $217fa5593a6718d2$var$cached;
}
function $217fa5593a6718d2$var$ensureSize(str) {
    var match = str.match(/^(.*)px$/);
    var value = Number(match === null || match === void 0 ? void 0 : match[1]);
    return Number.isNaN(value) ? $217fa5593a6718d2$export$2e2bcd8739ae039() : value;
}
function $217fa5593a6718d2$export$4f3ef2310365b56a(target) {
    if (typeof document === "undefined" || !target || !(target instanceof Element)) return {
        width: 0,
        height: 0
    };
    var _getComputedStyle = getComputedStyle(target, "::-webkit-scrollbar"), width = _getComputedStyle.width, height = _getComputedStyle.height;
    return {
        width: $217fa5593a6718d2$var$ensureSize(width),
        height: $217fa5593a6718d2$var$ensureSize(height)
    };
}

});

parcelRegister("hhYXs", function(module, exports) {

$parcel$export(module.exports, "isBodyOverflowing", () => $c9634f2c2418b2d0$export$31b5c8f1131a3a52);
/**
 * Test usage export. Do not use in your production
 */ function $c9634f2c2418b2d0$export$31b5c8f1131a3a52() {
    return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}

});


parcelRegister("3QskB", function(module, exports) {

$parcel$export(module.exports, "inlineMock", () => $2ccc34741b4bb73f$export$121d9fd0ca615463);
var $2ccc34741b4bb73f$export$18c8ad048e32c7d5 = false;
function $2ccc34741b4bb73f$export$121d9fd0ca615463(nextInline) {
    if (typeof nextInline === "boolean") $2ccc34741b4bb73f$export$18c8ad048e32c7d5 = nextInline;
    return $2ccc34741b4bb73f$export$18c8ad048e32c7d5;
}

});



parcelRegister("i35Ni", function(module, exports) {

$parcel$export(module.exports, "default", () => $d23d006593dfab9c$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
function $d23d006593dfab9c$var$getUseId() {
    // We need fully clone React function here to avoid webpack warning React 17 do not export `useId`
    var fullClone = (0, $d49SP.default)({}, $acw62);
    return fullClone.useId;
}
var $d23d006593dfab9c$var$uuid = 0;
function $d23d006593dfab9c$export$2f0435a662835942() {}
var $d23d006593dfab9c$var$useOriginId = $d23d006593dfab9c$var$getUseId();
var $d23d006593dfab9c$export$2e2bcd8739ae039 = $d23d006593dfab9c$var$useOriginId ? // Use React `useId`
function useId(id) {
    var reactId = $d23d006593dfab9c$var$useOriginId();
    // Developer passed id is single source of truth
    if (id) return id;
    return reactId;
} : // Use compatible of `useId`
function useCompatId(id) {
    // Inner id for accessibility usage. Only work in client side
    var _React$useState = $acw62.useState("ssr-id"), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    $acw62.useEffect(function() {
        var nextId = $d23d006593dfab9c$var$uuid;
        $d23d006593dfab9c$var$uuid += 1;
        setInnerId("rc_unique_".concat(nextId));
    }, []);
    // Developer passed id is single source of truth
    if (id) return id;
    // Return react native id or inner id
    return innerId;
};

});

parcelRegister("izbs9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8446137fd226eb8$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $8g1PZ = parcelRequire("8g1PZ");

var $8iiJy = parcelRequire("8iiJy");

var $bVxlN = parcelRequire("bVxlN");

var $6hDTM = parcelRequire("6hDTM");

var $85dLH = parcelRequire("85dLH");

var $acw62 = parcelRequire("acw62");

var $gIKRy = parcelRequire("gIKRy");

var $h3fax = parcelRequire("h3fax");

var $2NGCC = parcelRequire("2NGCC");
var $d8446137fd226eb8$var$Popup = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var popup = props.popup, className = props.className, prefixCls = props.prefixCls, style = props.style, target = props.target, _onVisibleChanged = props.onVisibleChanged, open = props.open, keepDom = props.keepDom, fresh = props.fresh, onClick = props.onClick, mask = props.mask, arrow = props.arrow, arrowPos = props.arrowPos, align = props.align, motion = props.motion, maskMotion = props.maskMotion, forceRender = props.forceRender, getPopupContainer = props.getPopupContainer, autoDestroy = props.autoDestroy, Portal = props.portal, zIndex = props.zIndex, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onPointerEnter = props.onPointerEnter, ready = props.ready, offsetX = props.offsetX, offsetY = props.offsetY, offsetR = props.offsetR, offsetB = props.offsetB, onAlign = props.onAlign, onPrepare = props.onPrepare, stretch = props.stretch, targetWidth = props.targetWidth, targetHeight = props.targetHeight;
    var childNode = typeof popup === "function" ? popup() : popup;
    // We can not remove holder only when motion finished.
    var isNodeVisible = open || keepDom;
    // ======================= Container ========================
    var getPopupContainerNeedParams = (getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer.length) > 0;
    var _React$useState = $acw62.useState(!getPopupContainer || !getPopupContainerNeedParams), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), show = _React$useState2[0], setShow = _React$useState2[1];
    // Delay to show since `getPopupContainer` need target element
    (0, $6hDTM.default)(function() {
        if (!show && getPopupContainerNeedParams && target) setShow(true);
    }, [
        show,
        getPopupContainerNeedParams,
        target
    ]);
    // ========================= Render =========================
    if (!show) return null;
    // >>>>> Offset
    var AUTO = "auto";
    var offsetStyle = {
        left: "-1000vw",
        top: "-1000vh",
        right: AUTO,
        bottom: AUTO
    };
    // Set align style
    if (ready || !open) {
        var _experimental;
        var points = align.points;
        var dynamicInset = align.dynamicInset || ((_experimental = align._experimental) === null || _experimental === void 0 ? void 0 : _experimental.dynamicInset);
        var alignRight = dynamicInset && points[0][1] === "r";
        var alignBottom = dynamicInset && points[0][0] === "b";
        if (alignRight) {
            offsetStyle.right = offsetR;
            offsetStyle.left = AUTO;
        } else {
            offsetStyle.left = offsetX;
            offsetStyle.right = AUTO;
        }
        if (alignBottom) {
            offsetStyle.bottom = offsetB;
            offsetStyle.top = AUTO;
        } else {
            offsetStyle.top = offsetY;
            offsetStyle.bottom = AUTO;
        }
    }
    // >>>>> Misc
    var miscStyle = {};
    if (stretch) {
        if (stretch.includes("height") && targetHeight) miscStyle.height = targetHeight;
        else if (stretch.includes("minHeight") && targetHeight) miscStyle.minHeight = targetHeight;
        if (stretch.includes("width") && targetWidth) miscStyle.width = targetWidth;
        else if (stretch.includes("minWidth") && targetWidth) miscStyle.minWidth = targetWidth;
    }
    if (!open) miscStyle.pointerEvents = "none";
    return /*#__PURE__*/ $acw62.createElement(Portal, {
        open: forceRender || isNodeVisible,
        getContainer: getPopupContainer && function() {
            return getPopupContainer(target);
        },
        autoDestroy: autoDestroy
    }, /*#__PURE__*/ $acw62.createElement((0, $h3fax.default), {
        prefixCls: prefixCls,
        open: open,
        zIndex: zIndex,
        mask: mask,
        motion: maskMotion
    }), /*#__PURE__*/ $acw62.createElement((0, $bVxlN.default), {
        onResize: onAlign,
        disabled: !open
    }, function(resizeObserverRef) {
        return /*#__PURE__*/ $acw62.createElement((0, $8iiJy.default), (0, $8nd05.default)({
            motionAppear: true,
            motionEnter: true,
            motionLeave: true,
            removeOnLeave: false,
            forceRender: forceRender,
            leavedClassName: "".concat(prefixCls, "-hidden")
        }, motion, {
            onAppearPrepare: onPrepare,
            onEnterPrepare: onPrepare,
            visible: open,
            onVisibleChanged: function onVisibleChanged(nextVisible) {
                var _motion$onVisibleChan;
                motion === null || motion === void 0 || (_motion$onVisibleChan = motion.onVisibleChanged) === null || _motion$onVisibleChan === void 0 || _motion$onVisibleChan.call(motion, nextVisible);
                _onVisibleChanged(nextVisible);
            }
        }), function(_ref, motionRef) {
            var motionClassName = _ref.className, motionStyle = _ref.style;
            var cls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, motionClassName, className);
            return /*#__PURE__*/ $acw62.createElement("div", {
                ref: (0, $85dLH.composeRef)(resizeObserverRef, ref, motionRef),
                className: cls,
                style: (0, $d49SP.default)((0, $d49SP.default)((0, $d49SP.default)((0, $d49SP.default)({
                    "--arrow-x": "".concat(arrowPos.x || 0, "px"),
                    "--arrow-y": "".concat(arrowPos.y || 0, "px")
                }, offsetStyle), miscStyle), motionStyle), {}, {
                    boxSizing: "border-box",
                    zIndex: zIndex
                }, style),
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onPointerEnter: onPointerEnter,
                onClick: onClick
            }, arrow && /*#__PURE__*/ $acw62.createElement((0, $gIKRy.default), {
                prefixCls: prefixCls,
                arrow: arrow,
                arrowPos: arrowPos,
                align: align
            }), /*#__PURE__*/ $acw62.createElement((0, $2NGCC.default), {
                cache: !open && !fresh
            }, childNode));
        });
    }));
});
var $d8446137fd226eb8$export$2e2bcd8739ae039 = $d8446137fd226eb8$var$Popup;

});
parcelRegister("gIKRy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2c51b639b0318a5$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
function $c2c51b639b0318a5$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, align = props.align, arrow = props.arrow, arrowPos = props.arrowPos;
    var _ref = arrow || {}, className = _ref.className, content = _ref.content;
    var _arrowPos$x = arrowPos.x, x = _arrowPos$x === void 0 ? 0 : _arrowPos$x, _arrowPos$y = arrowPos.y, y = _arrowPos$y === void 0 ? 0 : _arrowPos$y;
    var arrowRef = $acw62.useRef();
    // Skip if no align
    if (!align || !align.points) return null;
    var alignStyle = {
        position: "absolute"
    };
    // Skip if no need to align
    if (align.autoArrow !== false) {
        var popupPoints = align.points[0];
        var targetPoints = align.points[1];
        var popupTB = popupPoints[0];
        var popupLR = popupPoints[1];
        var targetTB = targetPoints[0];
        var targetLR = targetPoints[1];
        // Top & Bottom
        if (popupTB === targetTB || ![
            "t",
            "b"
        ].includes(popupTB)) alignStyle.top = y;
        else if (popupTB === "t") alignStyle.top = 0;
        else alignStyle.bottom = 0;
        // Left & Right
        if (popupLR === targetLR || ![
            "l",
            "r"
        ].includes(popupLR)) alignStyle.left = x;
        else if (popupLR === "l") alignStyle.left = 0;
        else alignStyle.right = 0;
    }
    return /*#__PURE__*/ $acw62.createElement("div", {
        ref: arrowRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-arrow"), className),
        style: alignStyle
    }, content);
}

});

parcelRegister("h3fax", function(module, exports) {

$parcel$export(module.exports, "default", () => $c69e7bbf660984b6$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $8g1PZ = parcelRequire("8g1PZ");

var $8iiJy = parcelRequire("8iiJy");

var $acw62 = parcelRequire("acw62");
function $c69e7bbf660984b6$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, open = props.open, zIndex = props.zIndex, mask = props.mask, motion = props.motion;
    if (!mask) return null;
    return /*#__PURE__*/ $acw62.createElement((0, $8iiJy.default), (0, $8nd05.default)({}, motion, {
        motionAppear: true,
        visible: open,
        removeOnLeave: true
    }), function(_ref) {
        var className = _ref.className;
        return /*#__PURE__*/ $acw62.createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-mask"), className)
        });
    });
}

});

parcelRegister("2NGCC", function(module, exports) {

$parcel$export(module.exports, "default", () => $20a13834bc71bb31$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $20a13834bc71bb31$var$PopupContent = /*#__PURE__*/ $acw62.memo(function(_ref) {
    var children = _ref.children;
    return children;
}, function(_, next) {
    return next.cache;
});
var $20a13834bc71bb31$export$2e2bcd8739ae039 = $20a13834bc71bb31$var$PopupContent;

});


parcelRegister("f5iV2", function(module, exports) {

$parcel$export(module.exports, "default", () => $afb5ff905a8de769$export$2e2bcd8739ae039);

var $85dLH = parcelRequire("85dLH");

var $acw62 = parcelRequire("acw62");
var $afb5ff905a8de769$var$TriggerWrapper = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var children = props.children, getTriggerDOMNode = props.getTriggerDOMNode;
    var canUseRef = (0, $85dLH.supportRef)(children);
    // When use `getTriggerDOMNode`, we should do additional work to get the real dom
    var setRef = $acw62.useCallback(function(node) {
        (0, $85dLH.fillRef)(ref, getTriggerDOMNode ? getTriggerDOMNode(node) : node);
    }, [
        getTriggerDOMNode
    ]);
    var mergedRef = (0, $85dLH.useComposeRef)(setRef, children.ref);
    return canUseRef ? /*#__PURE__*/ $acw62.cloneElement(children, {
        ref: mergedRef
    }) : children;
});
var $afb5ff905a8de769$export$2e2bcd8739ae039 = $afb5ff905a8de769$var$TriggerWrapper;

});

parcelRegister("lras0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9b439e1e53d6d59$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $f9b439e1e53d6d59$var$TriggerContext = /*#__PURE__*/ $acw62.createContext(null);
var $f9b439e1e53d6d59$export$2e2bcd8739ae039 = $f9b439e1e53d6d59$var$TriggerContext;

});

parcelRegister("8KMNr", function(module, exports) {

$parcel$export(module.exports, "default", () => $65f8789299df97eb$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $65f8789299df97eb$var$toArray(val) {
    return val ? Array.isArray(val) ? val : [
        val
    ] : [];
}
function $65f8789299df97eb$export$2e2bcd8739ae039(mobile, action, showAction, hideAction) {
    return $acw62.useMemo(function() {
        var mergedShowAction = $65f8789299df97eb$var$toArray(showAction !== null && showAction !== void 0 ? showAction : action);
        var mergedHideAction = $65f8789299df97eb$var$toArray(hideAction !== null && hideAction !== void 0 ? hideAction : action);
        var showActionSet = new Set(mergedShowAction);
        var hideActionSet = new Set(mergedHideAction);
        if (mobile) {
            if (showActionSet.has("hover")) {
                showActionSet.delete("hover");
                showActionSet.add("click");
            }
            if (hideActionSet.has("hover")) {
                hideActionSet.delete("hover");
                hideActionSet.add("click");
            }
        }
        return [
            showActionSet,
            hideActionSet
        ];
    }, [
        mobile,
        action,
        showAction,
        hideAction
    ]);
}

});

parcelRegister("e3cNJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3ab468f9842aab3$export$2e2bcd8739ae039);

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $b2dYb = parcelRequire("b2dYb");

var $7klNq = parcelRequire("7klNq");

var $a4gyP = parcelRequire("a4gyP");

var $6hDTM = parcelRequire("6hDTM");

var $acw62 = parcelRequire("acw62");

var $1ILwc = parcelRequire("1ILwc");
function $a3ab468f9842aab3$var$getUnitOffset(size) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var offsetStr = "".concat(offset);
    var cells = offsetStr.match(/^(.*)\%$/);
    if (cells) return size * (parseFloat(cells[1]) / 100);
    return parseFloat(offsetStr);
}
function $a3ab468f9842aab3$var$getNumberOffset(rect, offset) {
    var _ref = offset || [], _ref2 = (0, $eUqlC.default)(_ref, 2), offsetX = _ref2[0], offsetY = _ref2[1];
    return [
        $a3ab468f9842aab3$var$getUnitOffset(rect.width, offsetX),
        $a3ab468f9842aab3$var$getUnitOffset(rect.height, offsetY)
    ];
}
function $a3ab468f9842aab3$var$splitPoints() {
    var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return [
        points[0],
        points[1]
    ];
}
function $a3ab468f9842aab3$var$getAlignPoint(rect, points) {
    var topBottom = points[0];
    var leftRight = points[1];
    var x;
    var y;
    // Top & Bottom
    if (topBottom === "t") y = rect.y;
    else if (topBottom === "b") y = rect.y + rect.height;
    else y = rect.y + rect.height / 2;
    // Left & Right
    if (leftRight === "l") x = rect.x;
    else if (leftRight === "r") x = rect.x + rect.width;
    else x = rect.x + rect.width / 2;
    return {
        x: x,
        y: y
    };
}
function $a3ab468f9842aab3$var$reversePoints(points, index) {
    var reverseMap = {
        t: "b",
        b: "t",
        l: "r",
        r: "l"
    };
    return points.map(function(point, i) {
        if (i === index) return reverseMap[point] || "c";
        return point;
    }).join("");
}
function $a3ab468f9842aab3$export$2e2bcd8739ae039(open, popupEle, target, placement, builtinPlacements, popupAlign, onPopupAlign) {
    var _React$useState = $acw62.useState({
        ready: false,
        offsetX: 0,
        offsetY: 0,
        offsetR: 0,
        offsetB: 0,
        arrowX: 0,
        arrowY: 0,
        scaleX: 1,
        scaleY: 1,
        align: builtinPlacements[placement] || {}
    }), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), offsetInfo = _React$useState2[0], setOffsetInfo = _React$useState2[1];
    var alignCountRef = $acw62.useRef(0);
    var scrollerList = $acw62.useMemo(function() {
        if (!popupEle) return [];
        return (0, $1ILwc.collectScroller)(popupEle);
    }, [
        popupEle
    ]);
    // ========================= Flip ==========================
    // We will memo flip info.
    // If size change to make flip, it will memo the flip info and use it in next align.
    var prevFlipRef = $acw62.useRef({});
    var resetFlipCache = function resetFlipCache() {
        prevFlipRef.current = {};
    };
    if (!open) resetFlipCache();
    // ========================= Align =========================
    var onAlign = (0, $a4gyP.default)(function() {
        if (popupEle && target && open) {
            var _popupElement$parentE, _popupElement$parentE2;
            var popupElement = popupEle;
            var doc = popupElement.ownerDocument;
            var win = (0, $1ILwc.getWin)(popupElement);
            var _win$getComputedStyle = win.getComputedStyle(popupElement), width = _win$getComputedStyle.width, height = _win$getComputedStyle.height, popupPosition = _win$getComputedStyle.position;
            var originLeft = popupElement.style.left;
            var originTop = popupElement.style.top;
            var originRight = popupElement.style.right;
            var originBottom = popupElement.style.bottom;
            var originOverflow = popupElement.style.overflow;
            // Placement
            var placementInfo = (0, $d49SP.default)((0, $d49SP.default)({}, builtinPlacements[placement]), popupAlign);
            // placeholder element
            var placeholderElement = doc.createElement("div");
            (_popupElement$parentE = popupElement.parentElement) === null || _popupElement$parentE === void 0 || _popupElement$parentE.appendChild(placeholderElement);
            placeholderElement.style.left = "".concat(popupElement.offsetLeft, "px");
            placeholderElement.style.top = "".concat(popupElement.offsetTop, "px");
            placeholderElement.style.position = popupPosition;
            placeholderElement.style.height = "".concat(popupElement.offsetHeight, "px");
            placeholderElement.style.width = "".concat(popupElement.offsetWidth, "px");
            // Reset first
            popupElement.style.left = "0";
            popupElement.style.top = "0";
            popupElement.style.right = "auto";
            popupElement.style.bottom = "auto";
            popupElement.style.overflow = "hidden";
            // Calculate align style, we should consider `transform` case
            var targetRect;
            if (Array.isArray(target)) targetRect = {
                x: target[0],
                y: target[1],
                width: 0,
                height: 0
            };
            else {
                var rect = target.getBoundingClientRect();
                targetRect = {
                    x: rect.x,
                    y: rect.y,
                    width: rect.width,
                    height: rect.height
                };
            }
            var popupRect = popupElement.getBoundingClientRect();
            var _doc$documentElement = doc.documentElement, clientWidth = _doc$documentElement.clientWidth, clientHeight = _doc$documentElement.clientHeight, scrollWidth = _doc$documentElement.scrollWidth, scrollHeight = _doc$documentElement.scrollHeight, scrollTop = _doc$documentElement.scrollTop, scrollLeft = _doc$documentElement.scrollLeft;
            var popupHeight = popupRect.height;
            var popupWidth = popupRect.width;
            var targetHeight = targetRect.height;
            var targetWidth = targetRect.width;
            // Get bounding of visible area
            var visibleRegion = {
                left: 0,
                top: 0,
                right: clientWidth,
                bottom: clientHeight
            };
            var scrollRegion = {
                left: -scrollLeft,
                top: -scrollTop,
                right: scrollWidth - scrollLeft,
                bottom: scrollHeight - scrollTop
            };
            var htmlRegion = placementInfo.htmlRegion;
            var VISIBLE = "visible";
            var VISIBLE_FIRST = "visibleFirst";
            if (htmlRegion !== "scroll" && htmlRegion !== VISIBLE_FIRST) htmlRegion = VISIBLE;
            var isVisibleFirst = htmlRegion === VISIBLE_FIRST;
            var scrollRegionArea = (0, $1ILwc.getVisibleArea)(scrollRegion, scrollerList);
            var visibleRegionArea = (0, $1ILwc.getVisibleArea)(visibleRegion, scrollerList);
            var visibleArea = htmlRegion === VISIBLE ? visibleRegionArea : scrollRegionArea;
            // When set to `visibleFirst`,
            // the check `adjust` logic will use `visibleRegion` for check first.
            var adjustCheckVisibleArea = isVisibleFirst ? visibleRegionArea : visibleArea;
            // Record right & bottom align data
            popupElement.style.left = "auto";
            popupElement.style.top = "auto";
            popupElement.style.right = "0";
            popupElement.style.bottom = "0";
            var popupMirrorRect = popupElement.getBoundingClientRect();
            // Reset back
            popupElement.style.left = originLeft;
            popupElement.style.top = originTop;
            popupElement.style.right = originRight;
            popupElement.style.bottom = originBottom;
            popupElement.style.overflow = originOverflow;
            (_popupElement$parentE2 = popupElement.parentElement) === null || _popupElement$parentE2 === void 0 || _popupElement$parentE2.removeChild(placeholderElement);
            // Calculate scale
            var _scaleX = (0, $1ILwc.toNum)(Math.round(popupWidth / parseFloat(width) * 1000) / 1000);
            var _scaleY = (0, $1ILwc.toNum)(Math.round(popupHeight / parseFloat(height) * 1000) / 1000);
            // No need to align since it's not visible in view
            if (_scaleX === 0 || _scaleY === 0 || (0, $b2dYb.isDOM)(target) && !(0, $7klNq.default)(target)) return;
            // Offset
            var offset = placementInfo.offset, targetOffset = placementInfo.targetOffset;
            var _getNumberOffset = $a3ab468f9842aab3$var$getNumberOffset(popupRect, offset), _getNumberOffset2 = (0, $eUqlC.default)(_getNumberOffset, 2), popupOffsetX = _getNumberOffset2[0], popupOffsetY = _getNumberOffset2[1];
            var _getNumberOffset3 = $a3ab468f9842aab3$var$getNumberOffset(targetRect, targetOffset), _getNumberOffset4 = (0, $eUqlC.default)(_getNumberOffset3, 2), targetOffsetX = _getNumberOffset4[0], targetOffsetY = _getNumberOffset4[1];
            targetRect.x -= targetOffsetX;
            targetRect.y -= targetOffsetY;
            // Points
            var _ref3 = placementInfo.points || [], _ref4 = (0, $eUqlC.default)(_ref3, 2), popupPoint = _ref4[0], targetPoint = _ref4[1];
            var targetPoints = $a3ab468f9842aab3$var$splitPoints(targetPoint);
            var popupPoints = $a3ab468f9842aab3$var$splitPoints(popupPoint);
            var targetAlignPoint = $a3ab468f9842aab3$var$getAlignPoint(targetRect, targetPoints);
            var popupAlignPoint = $a3ab468f9842aab3$var$getAlignPoint(popupRect, popupPoints);
            // Real align info may not same as origin one
            var nextAlignInfo = (0, $d49SP.default)({}, placementInfo);
            // Next Offset
            var nextOffsetX = targetAlignPoint.x - popupAlignPoint.x + popupOffsetX;
            var nextOffsetY = targetAlignPoint.y - popupAlignPoint.y + popupOffsetY;
            // ============== Intersection ===============
            // Get area by position. Used for check if flip area is better
            function getIntersectionVisibleArea(offsetX, offsetY) {
                var area = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : visibleArea;
                var l = popupRect.x + offsetX;
                var t = popupRect.y + offsetY;
                var r = l + popupWidth;
                var b = t + popupHeight;
                var visibleL = Math.max(l, area.left);
                var visibleT = Math.max(t, area.top);
                var visibleR = Math.min(r, area.right);
                var visibleB = Math.min(b, area.bottom);
                return Math.max(0, (visibleR - visibleL) * (visibleB - visibleT));
            }
            var originIntersectionVisibleArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY);
            // As `visibleFirst`, we prepare this for check
            var originIntersectionRecommendArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY, visibleRegionArea);
            // ========================== Overflow ===========================
            var targetAlignPointTL = $a3ab468f9842aab3$var$getAlignPoint(targetRect, [
                "t",
                "l"
            ]);
            var popupAlignPointTL = $a3ab468f9842aab3$var$getAlignPoint(popupRect, [
                "t",
                "l"
            ]);
            var targetAlignPointBR = $a3ab468f9842aab3$var$getAlignPoint(targetRect, [
                "b",
                "r"
            ]);
            var popupAlignPointBR = $a3ab468f9842aab3$var$getAlignPoint(popupRect, [
                "b",
                "r"
            ]);
            var overflow = placementInfo.overflow || {};
            var adjustX = overflow.adjustX, adjustY = overflow.adjustY, shiftX = overflow.shiftX, shiftY = overflow.shiftY;
            var supportAdjust = function supportAdjust(val) {
                if (typeof val === "boolean") return val;
                return val >= 0;
            };
            // Prepare position
            var nextPopupY;
            var nextPopupBottom;
            var nextPopupX;
            var nextPopupRight;
            function syncNextPopupPosition() {
                nextPopupY = popupRect.y + nextOffsetY;
                nextPopupBottom = nextPopupY + popupHeight;
                nextPopupX = popupRect.x + nextOffsetX;
                nextPopupRight = nextPopupX + popupWidth;
            }
            syncNextPopupPosition();
            // >>>>>>>>>> Top & Bottom
            var needAdjustY = supportAdjust(adjustY);
            var sameTB = popupPoints[0] === targetPoints[0];
            // Bottom to Top
            if (needAdjustY && popupPoints[0] === "t" && (nextPopupBottom > adjustCheckVisibleArea.bottom || prevFlipRef.current.bt)) {
                var tmpNextOffsetY = nextOffsetY;
                if (sameTB) tmpNextOffsetY -= popupHeight - targetHeight;
                else tmpNextOffsetY = targetAlignPointTL.y - popupAlignPointBR.y - popupOffsetY;
                var newVisibleArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY);
                var newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.bt = true;
                    nextOffsetY = tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextAlignInfo.points = [
                        $a3ab468f9842aab3$var$reversePoints(popupPoints, 0),
                        $a3ab468f9842aab3$var$reversePoints(targetPoints, 0)
                    ];
                } else prevFlipRef.current.bt = false;
            }
            // Top to Bottom
            if (needAdjustY && popupPoints[0] === "b" && (nextPopupY < adjustCheckVisibleArea.top || prevFlipRef.current.tb)) {
                var _tmpNextOffsetY = nextOffsetY;
                if (sameTB) _tmpNextOffsetY += popupHeight - targetHeight;
                else _tmpNextOffsetY = targetAlignPointBR.y - popupAlignPointTL.y - popupOffsetY;
                var _newVisibleArea = getIntersectionVisibleArea(nextOffsetX, _tmpNextOffsetY);
                var _newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, _tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                _newVisibleArea > originIntersectionVisibleArea || _newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                _newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.tb = true;
                    nextOffsetY = _tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextAlignInfo.points = [
                        $a3ab468f9842aab3$var$reversePoints(popupPoints, 0),
                        $a3ab468f9842aab3$var$reversePoints(targetPoints, 0)
                    ];
                } else prevFlipRef.current.tb = false;
            }
            // >>>>>>>>>> Left & Right
            var needAdjustX = supportAdjust(adjustX);
            // >>>>> Flip
            var sameLR = popupPoints[1] === targetPoints[1];
            // Right to Left
            if (needAdjustX && popupPoints[1] === "l" && (nextPopupRight > adjustCheckVisibleArea.right || prevFlipRef.current.rl)) {
                var tmpNextOffsetX = nextOffsetX;
                if (sameLR) tmpNextOffsetX -= popupWidth - targetWidth;
                else tmpNextOffsetX = targetAlignPointTL.x - popupAlignPointBR.x - popupOffsetX;
                var _newVisibleArea2 = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY);
                var _newVisibleRecommendArea2 = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                _newVisibleArea2 > originIntersectionVisibleArea || _newVisibleArea2 === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                _newVisibleRecommendArea2 >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.rl = true;
                    nextOffsetX = tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextAlignInfo.points = [
                        $a3ab468f9842aab3$var$reversePoints(popupPoints, 1),
                        $a3ab468f9842aab3$var$reversePoints(targetPoints, 1)
                    ];
                } else prevFlipRef.current.rl = false;
            }
            // Left to Right
            if (needAdjustX && popupPoints[1] === "r" && (nextPopupX < adjustCheckVisibleArea.left || prevFlipRef.current.lr)) {
                var _tmpNextOffsetX = nextOffsetX;
                if (sameLR) _tmpNextOffsetX += popupWidth - targetWidth;
                else _tmpNextOffsetX = targetAlignPointBR.x - popupAlignPointTL.x - popupOffsetX;
                var _newVisibleArea3 = getIntersectionVisibleArea(_tmpNextOffsetX, nextOffsetY);
                var _newVisibleRecommendArea3 = getIntersectionVisibleArea(_tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                _newVisibleArea3 > originIntersectionVisibleArea || _newVisibleArea3 === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                _newVisibleRecommendArea3 >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.lr = true;
                    nextOffsetX = _tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextAlignInfo.points = [
                        $a3ab468f9842aab3$var$reversePoints(popupPoints, 1),
                        $a3ab468f9842aab3$var$reversePoints(targetPoints, 1)
                    ];
                } else prevFlipRef.current.lr = false;
            }
            // ============================ Shift ============================
            syncNextPopupPosition();
            var numShiftX = shiftX === true ? 0 : shiftX;
            if (typeof numShiftX === "number") {
                // Left
                if (nextPopupX < visibleRegionArea.left) {
                    nextOffsetX -= nextPopupX - visibleRegionArea.left - popupOffsetX;
                    if (targetRect.x + targetWidth < visibleRegionArea.left + numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.left + targetWidth - numShiftX;
                }
                // Right
                if (nextPopupRight > visibleRegionArea.right) {
                    nextOffsetX -= nextPopupRight - visibleRegionArea.right - popupOffsetX;
                    if (targetRect.x > visibleRegionArea.right - numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.right + numShiftX;
                }
            }
            var numShiftY = shiftY === true ? 0 : shiftY;
            if (typeof numShiftY === "number") {
                // Top
                if (nextPopupY < visibleRegionArea.top) {
                    nextOffsetY -= nextPopupY - visibleRegionArea.top - popupOffsetY;
                    // When target if far away from visible area
                    // Stop shift
                    if (targetRect.y + targetHeight < visibleRegionArea.top + numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.top + targetHeight - numShiftY;
                }
                // Bottom
                if (nextPopupBottom > visibleRegionArea.bottom) {
                    nextOffsetY -= nextPopupBottom - visibleRegionArea.bottom - popupOffsetY;
                    if (targetRect.y > visibleRegionArea.bottom - numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.bottom + numShiftY;
                }
            }
            // ============================ Arrow ============================
            // Arrow center align
            var popupLeft = popupRect.x + nextOffsetX;
            var popupRight = popupLeft + popupWidth;
            var popupTop = popupRect.y + nextOffsetY;
            var popupBottom = popupTop + popupHeight;
            var targetLeft = targetRect.x;
            var targetRight = targetLeft + targetWidth;
            var targetTop = targetRect.y;
            var targetBottom = targetTop + targetHeight;
            var maxLeft = Math.max(popupLeft, targetLeft);
            var minRight = Math.min(popupRight, targetRight);
            var xCenter = (maxLeft + minRight) / 2;
            var nextArrowX = xCenter - popupLeft;
            var maxTop = Math.max(popupTop, targetTop);
            var minBottom = Math.min(popupBottom, targetBottom);
            var yCenter = (maxTop + minBottom) / 2;
            var nextArrowY = yCenter - popupTop;
            onPopupAlign === null || onPopupAlign === void 0 || onPopupAlign(popupEle, nextAlignInfo);
            // Additional calculate right & bottom position
            var offsetX4Right = popupMirrorRect.right - popupRect.x - (nextOffsetX + popupRect.width);
            var offsetY4Bottom = popupMirrorRect.bottom - popupRect.y - (nextOffsetY + popupRect.height);
            setOffsetInfo({
                ready: true,
                offsetX: nextOffsetX / _scaleX,
                offsetY: nextOffsetY / _scaleY,
                offsetR: offsetX4Right / _scaleX,
                offsetB: offsetY4Bottom / _scaleY,
                arrowX: nextArrowX / _scaleX,
                arrowY: nextArrowY / _scaleY,
                scaleX: _scaleX,
                scaleY: _scaleY,
                align: nextAlignInfo
            });
        }
    });
    var triggerAlign = function triggerAlign() {
        alignCountRef.current += 1;
        var id = alignCountRef.current;
        // Merge all align requirement into one frame
        Promise.resolve().then(function() {
            if (alignCountRef.current === id) onAlign();
        });
    };
    // Reset ready status when placement & open changed
    var resetReady = function resetReady() {
        setOffsetInfo(function(ori) {
            return (0, $d49SP.default)((0, $d49SP.default)({}, ori), {}, {
                ready: false
            });
        });
    };
    (0, $6hDTM.default)(resetReady, [
        placement
    ]);
    (0, $6hDTM.default)(function() {
        if (!open) resetReady();
    }, [
        open
    ]);
    return [
        offsetInfo.ready,
        offsetInfo.offsetX,
        offsetInfo.offsetY,
        offsetInfo.offsetR,
        offsetInfo.offsetB,
        offsetInfo.arrowX,
        offsetInfo.arrowY,
        offsetInfo.scaleX,
        offsetInfo.scaleY,
        offsetInfo.align,
        triggerAlign
    ];
}

});
parcelRegister("1ILwc", function(module, exports) {

$parcel$export(module.exports, "getAlignPopupClassName", () => $140ec2a5382714e1$export$faa0aa8ed2fe6432);
$parcel$export(module.exports, "getMotion", () => $140ec2a5382714e1$export$7b8936ddc277a29a);
$parcel$export(module.exports, "getWin", () => $140ec2a5382714e1$export$9c0584a7cc24d9e);
$parcel$export(module.exports, "collectScroller", () => $140ec2a5382714e1$export$ba21ed9400ca485b);
$parcel$export(module.exports, "toNum", () => $140ec2a5382714e1$export$34dfc8f73bbb64ae);
$parcel$export(module.exports, "getVisibleArea", () => $140ec2a5382714e1$export$94be9d7985092f2d);

var $d49SP = parcelRequire("d49SP");
function $140ec2a5382714e1$var$isPointsEq() {
    var a1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var a2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var isAlignPoint = arguments.length > 2 ? arguments[2] : undefined;
    if (isAlignPoint) return a1[0] === a2[0];
    return a1[0] === a2[0] && a1[1] === a2[1];
}
function $140ec2a5382714e1$export$faa0aa8ed2fe6432(builtinPlacements, prefixCls, align, isAlignPoint) {
    var points = align.points;
    var placements = Object.keys(builtinPlacements);
    for(var i = 0; i < placements.length; i += 1){
        var _builtinPlacements$pl;
        var placement = placements[i];
        if ($140ec2a5382714e1$var$isPointsEq((_builtinPlacements$pl = builtinPlacements[placement]) === null || _builtinPlacements$pl === void 0 ? void 0 : _builtinPlacements$pl.points, points, isAlignPoint)) return "".concat(prefixCls, "-placement-").concat(placement);
    }
    return "";
}
function $140ec2a5382714e1$export$7b8936ddc277a29a(prefixCls, motion, animation, transitionName) {
    if (motion) return motion;
    if (animation) return {
        motionName: "".concat(prefixCls, "-").concat(animation)
    };
    if (transitionName) return {
        motionName: transitionName
    };
    return null;
}
function $140ec2a5382714e1$export$9c0584a7cc24d9e(ele) {
    return ele.ownerDocument.defaultView;
}
function $140ec2a5382714e1$export$ba21ed9400ca485b(ele) {
    var scrollerList = [];
    var current = ele === null || ele === void 0 ? void 0 : ele.parentElement;
    var scrollStyle = [
        "hidden",
        "scroll",
        "clip",
        "auto"
    ];
    while(current){
        var _getWin$getComputedSt = $140ec2a5382714e1$export$9c0584a7cc24d9e(current).getComputedStyle(current), overflowX = _getWin$getComputedSt.overflowX, overflowY = _getWin$getComputedSt.overflowY, overflow = _getWin$getComputedSt.overflow;
        if ([
            overflowX,
            overflowY,
            overflow
        ].some(function(o) {
            return scrollStyle.includes(o);
        })) scrollerList.push(current);
        current = current.parentElement;
    }
    return scrollerList;
}
function $140ec2a5382714e1$export$34dfc8f73bbb64ae(num) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return Number.isNaN(num) ? defaultValue : num;
}
function $140ec2a5382714e1$var$getPxValue(val) {
    return $140ec2a5382714e1$export$34dfc8f73bbb64ae(parseFloat(val), 0);
}
function $140ec2a5382714e1$export$94be9d7985092f2d(initArea, scrollerList) {
    var visibleArea = (0, $d49SP.default)({}, initArea);
    (scrollerList || []).forEach(function(ele) {
        if (ele instanceof HTMLBodyElement || ele instanceof HTMLHtmlElement) return;
        // Skip if static position which will not affect visible area
        var _getWin$getComputedSt2 = $140ec2a5382714e1$export$9c0584a7cc24d9e(ele).getComputedStyle(ele), overflow = _getWin$getComputedSt2.overflow, overflowClipMargin = _getWin$getComputedSt2.overflowClipMargin, borderTopWidth = _getWin$getComputedSt2.borderTopWidth, borderBottomWidth = _getWin$getComputedSt2.borderBottomWidth, borderLeftWidth = _getWin$getComputedSt2.borderLeftWidth, borderRightWidth = _getWin$getComputedSt2.borderRightWidth;
        var eleRect = ele.getBoundingClientRect();
        var eleOutHeight = ele.offsetHeight, eleInnerHeight = ele.clientHeight, eleOutWidth = ele.offsetWidth, eleInnerWidth = ele.clientWidth;
        var borderTopNum = $140ec2a5382714e1$var$getPxValue(borderTopWidth);
        var borderBottomNum = $140ec2a5382714e1$var$getPxValue(borderBottomWidth);
        var borderLeftNum = $140ec2a5382714e1$var$getPxValue(borderLeftWidth);
        var borderRightNum = $140ec2a5382714e1$var$getPxValue(borderRightWidth);
        var scaleX = $140ec2a5382714e1$export$34dfc8f73bbb64ae(Math.round(eleRect.width / eleOutWidth * 1000) / 1000);
        var scaleY = $140ec2a5382714e1$export$34dfc8f73bbb64ae(Math.round(eleRect.height / eleOutHeight * 1000) / 1000);
        // Original visible area
        var eleScrollWidth = (eleOutWidth - eleInnerWidth - borderLeftNum - borderRightNum) * scaleX;
        var eleScrollHeight = (eleOutHeight - eleInnerHeight - borderTopNum - borderBottomNum) * scaleY;
        // Cut border size
        var scaledBorderTopWidth = borderTopNum * scaleY;
        var scaledBorderBottomWidth = borderBottomNum * scaleY;
        var scaledBorderLeftWidth = borderLeftNum * scaleX;
        var scaledBorderRightWidth = borderRightNum * scaleX;
        // Clip margin
        var clipMarginWidth = 0;
        var clipMarginHeight = 0;
        if (overflow === "clip") {
            var clipNum = $140ec2a5382714e1$var$getPxValue(overflowClipMargin);
            clipMarginWidth = clipNum * scaleX;
            clipMarginHeight = clipNum * scaleY;
        }
        // Region
        var eleLeft = eleRect.x + scaledBorderLeftWidth - clipMarginWidth;
        var eleTop = eleRect.y + scaledBorderTopWidth - clipMarginHeight;
        var eleRight = eleLeft + eleRect.width + 2 * clipMarginWidth - scaledBorderLeftWidth - scaledBorderRightWidth - eleScrollWidth;
        var eleBottom = eleTop + eleRect.height + 2 * clipMarginHeight - scaledBorderTopWidth - scaledBorderBottomWidth - eleScrollHeight;
        visibleArea.left = Math.max(visibleArea.left, eleLeft);
        visibleArea.top = Math.max(visibleArea.top, eleTop);
        visibleArea.right = Math.min(visibleArea.right, eleRight);
        visibleArea.bottom = Math.min(visibleArea.bottom, eleBottom);
    });
    return visibleArea;
}

});


parcelRegister("dGzen", function(module, exports) {

$parcel$export(module.exports, "default", () => $02923bfaa4b78dec$export$2e2bcd8739ae039);

var $kbxxf = parcelRequire("kbxxf");

var $6hDTM = parcelRequire("6hDTM");

var $1ILwc = parcelRequire("1ILwc");
function $02923bfaa4b78dec$export$2e2bcd8739ae039(open, target, popup, onAlign, onScroll) {
    (0, $6hDTM.default)(function() {
        if (open && target && popup) {
            var targetElement = target;
            var popupElement = popup;
            var targetScrollList = (0, $1ILwc.collectScroller)(targetElement);
            var popupScrollList = (0, $1ILwc.collectScroller)(popupElement);
            var win = (0, $1ILwc.getWin)(popupElement);
            var mergedList = new Set([
                win
            ].concat((0, $kbxxf.default)(targetScrollList), (0, $kbxxf.default)(popupScrollList)));
            function notifyScroll() {
                onAlign();
                onScroll();
            }
            mergedList.forEach(function(scroller) {
                scroller.addEventListener("scroll", notifyScroll, {
                    passive: true
                });
            });
            win.addEventListener("resize", notifyScroll, {
                passive: true
            });
            // First time always do align
            onAlign();
            return function() {
                mergedList.forEach(function(scroller) {
                    scroller.removeEventListener("scroll", notifyScroll);
                    win.removeEventListener("resize", notifyScroll);
                });
            };
        }
    }, [
        open,
        target,
        popup
    ]);
}

});

parcelRegister("b4OTf", function(module, exports) {

$parcel$export(module.exports, "default", () => $81078b27d1014ac5$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");
parcelRequire("u43uR");

var $fXR7w = parcelRequire("fXR7w");

var $dTiBu = parcelRequire("dTiBu");

var $acw62 = parcelRequire("acw62");

var $1ILwc = parcelRequire("1ILwc");
function $81078b27d1014ac5$export$2e2bcd8739ae039(open, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen) {
    var openRef = $acw62.useRef(open);
    // Window click to hide should be lock to avoid trigger lock immediately
    var lockRef = $acw62.useRef(false);
    if (openRef.current !== open) {
        lockRef.current = true;
        openRef.current = open;
    }
    $acw62.useEffect(function() {
        var id = (0, $dTiBu.default)(function() {
            lockRef.current = false;
        });
        return function() {
            (0, $dTiBu.default).cancel(id);
        };
    }, [
        open
    ]);
    // Click to hide is special action since click popup element should not hide
    $acw62.useEffect(function() {
        if (clickToHide && popupEle && (!mask || maskClosable)) {
            var genClickEvents = function genClickEvents() {
                var clickInside = false;
                // User may mouseDown inside and drag out of popup and mouse up
                // Record here to prevent close
                var onWindowMouseDown = function onWindowMouseDown(_ref) {
                    var target = _ref.target;
                    clickInside = inPopupOrChild(target);
                };
                var onWindowClick = function onWindowClick(_ref2) {
                    var target = _ref2.target;
                    if (!lockRef.current && openRef.current && !clickInside && !inPopupOrChild(target)) triggerOpen(false);
                };
                return [
                    onWindowMouseDown,
                    onWindowClick
                ];
            };
            // Events
            var _genClickEvents = genClickEvents(), _genClickEvents2 = (0, $eUqlC.default)(_genClickEvents, 2), onWinMouseDown = _genClickEvents2[0], onWinClick = _genClickEvents2[1];
            var _genClickEvents3 = genClickEvents(), _genClickEvents4 = (0, $eUqlC.default)(_genClickEvents3, 2), onShadowMouseDown = _genClickEvents4[0], onShadowClick = _genClickEvents4[1];
            var win = (0, $1ILwc.getWin)(popupEle);
            win.addEventListener("mousedown", onWinMouseDown, true);
            win.addEventListener("click", onWinClick, true);
            win.addEventListener("contextmenu", onWinClick, true);
            // shadow root
            var targetShadowRoot = (0, $fXR7w.getShadowRoot)(targetEle);
            if (targetShadowRoot) {
                targetShadowRoot.addEventListener("mousedown", onShadowMouseDown, true);
                targetShadowRoot.addEventListener("click", onShadowClick, true);
                targetShadowRoot.addEventListener("contextmenu", onShadowClick, true);
            }
            var _targetEle$getRootNod, _popupEle$getRootNode, targetRoot, popupRoot;
            return function() {
                win.removeEventListener("mousedown", onWinMouseDown, true);
                win.removeEventListener("click", onWinClick, true);
                win.removeEventListener("contextmenu", onWinClick, true);
                if (targetShadowRoot) {
                    targetShadowRoot.removeEventListener("mousedown", onShadowMouseDown, true);
                    targetShadowRoot.removeEventListener("click", onShadowClick, true);
                    targetShadowRoot.removeEventListener("contextmenu", onShadowClick, true);
                }
            };
        }
    }, [
        clickToHide,
        targetEle,
        popupEle,
        mask,
        maskClosable
    ]);
}

});


parcelRegister("lKDdC", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd5c50d68a830e84$export$2e2bcd8739ae039);

var $iCi4s = parcelRequire("iCi4s");

var $dTiBu = parcelRequire("dTiBu");

var $acw62 = parcelRequire("acw62");
var $fd5c50d68a830e84$var$ESC = (0, $iCi4s.default).ESC, $fd5c50d68a830e84$var$TAB = (0, $iCi4s.default).TAB;
function $fd5c50d68a830e84$export$2e2bcd8739ae039(_ref) {
    var visible = _ref.visible, triggerRef = _ref.triggerRef, onVisibleChange = _ref.onVisibleChange, autoFocus = _ref.autoFocus, overlayRef = _ref.overlayRef;
    var focusMenuRef = $acw62.useRef(false);
    var handleCloseMenuAndReturnFocus = function handleCloseMenuAndReturnFocus() {
        if (visible) {
            var _triggerRef$current, _triggerRef$current$f;
            (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || (_triggerRef$current$f = _triggerRef$current.focus) === null || _triggerRef$current$f === void 0 || _triggerRef$current$f.call(_triggerRef$current);
            onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(false);
        }
    };
    var focusMenu = function focusMenu() {
        var _overlayRef$current;
        if ((_overlayRef$current = overlayRef.current) !== null && _overlayRef$current !== void 0 && _overlayRef$current.focus) {
            overlayRef.current.focus();
            focusMenuRef.current = true;
            return true;
        }
        return false;
    };
    var handleKeyDown = function handleKeyDown(event) {
        switch(event.keyCode){
            case $fd5c50d68a830e84$var$ESC:
                handleCloseMenuAndReturnFocus();
                break;
            case $fd5c50d68a830e84$var$TAB:
                var focusResult = false;
                if (!focusMenuRef.current) focusResult = focusMenu();
                if (focusResult) event.preventDefault();
                else handleCloseMenuAndReturnFocus();
                break;
        }
    };
    $acw62.useEffect(function() {
        if (visible) {
            window.addEventListener("keydown", handleKeyDown);
            if (autoFocus) // FIXME: hack with raf
            (0, $dTiBu.default)(focusMenu, 3);
            return function() {
                window.removeEventListener("keydown", handleKeyDown);
                focusMenuRef.current = false;
            };
        }
        return function() {
            focusMenuRef.current = false;
        };
    }, [
        visible
    ]); // eslint-disable-line react-hooks/exhaustive-deps
}

});
parcelRegister("iCi4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8d9cb1a28007639$export$2e2bcd8739ae039);
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ var $d8d9cb1a28007639$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $d8d9cb1a28007639$var$KeyCode.F1 && keyCode <= $d8d9cb1a28007639$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $d8d9cb1a28007639$var$KeyCode.ALT:
            case $d8d9cb1a28007639$var$KeyCode.CAPS_LOCK:
            case $d8d9cb1a28007639$var$KeyCode.CONTEXT_MENU:
            case $d8d9cb1a28007639$var$KeyCode.CTRL:
            case $d8d9cb1a28007639$var$KeyCode.DOWN:
            case $d8d9cb1a28007639$var$KeyCode.END:
            case $d8d9cb1a28007639$var$KeyCode.ESC:
            case $d8d9cb1a28007639$var$KeyCode.HOME:
            case $d8d9cb1a28007639$var$KeyCode.INSERT:
            case $d8d9cb1a28007639$var$KeyCode.LEFT:
            case $d8d9cb1a28007639$var$KeyCode.MAC_FF_META:
            case $d8d9cb1a28007639$var$KeyCode.META:
            case $d8d9cb1a28007639$var$KeyCode.NUMLOCK:
            case $d8d9cb1a28007639$var$KeyCode.NUM_CENTER:
            case $d8d9cb1a28007639$var$KeyCode.PAGE_DOWN:
            case $d8d9cb1a28007639$var$KeyCode.PAGE_UP:
            case $d8d9cb1a28007639$var$KeyCode.PAUSE:
            case $d8d9cb1a28007639$var$KeyCode.PRINT_SCREEN:
            case $d8d9cb1a28007639$var$KeyCode.RIGHT:
            case $d8d9cb1a28007639$var$KeyCode.SHIFT:
            case $d8d9cb1a28007639$var$KeyCode.UP:
            case $d8d9cb1a28007639$var$KeyCode.WIN_KEY:
            case $d8d9cb1a28007639$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $d8d9cb1a28007639$var$KeyCode.ZERO && keyCode <= $d8d9cb1a28007639$var$KeyCode.NINE) return true;
        if (keyCode >= $d8d9cb1a28007639$var$KeyCode.NUM_ZERO && keyCode <= $d8d9cb1a28007639$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $d8d9cb1a28007639$var$KeyCode.A && keyCode <= $d8d9cb1a28007639$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf("WebKit") !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $d8d9cb1a28007639$var$KeyCode.SPACE:
            case $d8d9cb1a28007639$var$KeyCode.QUESTION_MARK:
            case $d8d9cb1a28007639$var$KeyCode.NUM_PLUS:
            case $d8d9cb1a28007639$var$KeyCode.NUM_MINUS:
            case $d8d9cb1a28007639$var$KeyCode.NUM_PERIOD:
            case $d8d9cb1a28007639$var$KeyCode.NUM_DIVISION:
            case $d8d9cb1a28007639$var$KeyCode.SEMICOLON:
            case $d8d9cb1a28007639$var$KeyCode.DASH:
            case $d8d9cb1a28007639$var$KeyCode.EQUALS:
            case $d8d9cb1a28007639$var$KeyCode.COMMA:
            case $d8d9cb1a28007639$var$KeyCode.PERIOD:
            case $d8d9cb1a28007639$var$KeyCode.SLASH:
            case $d8d9cb1a28007639$var$KeyCode.APOSTROPHE:
            case $d8d9cb1a28007639$var$KeyCode.SINGLE_QUOTE:
            case $d8d9cb1a28007639$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $d8d9cb1a28007639$var$KeyCode.BACKSLASH:
            case $d8d9cb1a28007639$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
var $d8d9cb1a28007639$export$2e2bcd8739ae039 = $d8d9cb1a28007639$var$KeyCode;

});


parcelRegister("jNeWR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e68e305c80c7967c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $85dLH = parcelRequire("85dLH");
var $e68e305c80c7967c$var$Overlay = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var overlay = props.overlay, arrow = props.arrow, prefixCls = props.prefixCls;
    var overlayNode = (0, $acw62.useMemo)(function() {
        var overlayElement;
        if (typeof overlay === "function") overlayElement = overlay();
        else overlayElement = overlay;
        return overlayElement;
    }, [
        overlay
    ]);
    var composedRef = (0, $85dLH.composeRef)(ref, overlayNode === null || overlayNode === void 0 ? void 0 : overlayNode.ref);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, arrow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat(prefixCls, "-arrow")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(overlayNode, {
        ref: (0, $85dLH.supportRef)(overlayNode) ? composedRef : undefined
    }));
});
var $e68e305c80c7967c$export$2e2bcd8739ae039 = $e68e305c80c7967c$var$Overlay;

});

parcelRegister("dfVFD", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a69693d1b18e39e$export$2e2bcd8739ae039);
var $9a69693d1b18e39e$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $9a69693d1b18e39e$var$targetOffset = [
    0,
    0
];
var $9a69693d1b18e39e$var$placements = {
    topLeft: {
        points: [
            "bl",
            "tl"
        ],
        overflow: $9a69693d1b18e39e$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $9a69693d1b18e39e$var$targetOffset
    },
    top: {
        points: [
            "bc",
            "tc"
        ],
        overflow: $9a69693d1b18e39e$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $9a69693d1b18e39e$var$targetOffset
    },
    topRight: {
        points: [
            "br",
            "tr"
        ],
        overflow: $9a69693d1b18e39e$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $9a69693d1b18e39e$var$targetOffset
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ],
        overflow: $9a69693d1b18e39e$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $9a69693d1b18e39e$var$targetOffset
    },
    bottom: {
        points: [
            "tc",
            "bc"
        ],
        overflow: $9a69693d1b18e39e$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $9a69693d1b18e39e$var$targetOffset
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ],
        overflow: $9a69693d1b18e39e$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $9a69693d1b18e39e$var$targetOffset
    }
};
var $9a69693d1b18e39e$export$2e2bcd8739ae039 = $9a69693d1b18e39e$var$placements;

});



parcelRegister("feYPt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b187593cf569a182$export$2e2bcd8739ae039);
$parcel$export(module.exports, "MenuItem", () => (parcelRequire("gXR8t")).default);

var $gK11r = parcelRequire("gK11r");

var $gXR8t = parcelRequire("gXR8t");

var $gASnm = parcelRequire("gASnm");

var $9TcXG = parcelRequire("9TcXG");

var $a8XZl = parcelRequire("a8XZl");

var $iPQJN = parcelRequire("iPQJN");
var $b187593cf569a182$var$ExportMenu = (0, $gK11r.default);
$b187593cf569a182$var$ExportMenu.Item = (0, $gXR8t.default);
$b187593cf569a182$var$ExportMenu.SubMenu = (0, $gASnm.default);
$b187593cf569a182$var$ExportMenu.ItemGroup = (0, $9TcXG.default);
$b187593cf569a182$var$ExportMenu.Divider = (0, $iPQJN.default);
var $b187593cf569a182$export$2e2bcd8739ae039 = $b187593cf569a182$var$ExportMenu;

});
parcelRegister("gK11r", function(module, exports) {

$parcel$export(module.exports, "default", () => $c301bc30ecc557ca$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $kbxxf = parcelRequire("kbxxf");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $8g1PZ = parcelRequire("8g1PZ");

var $6dkAu = parcelRequire("6dkAu");

var $iSQh8 = parcelRequire("iSQh8");

var $4AFGH = parcelRequire("4AFGH");
parcelRequire("u43uR");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $dpnFa = parcelRequire("dpnFa");

var $392Az = parcelRequire("392Az");

var $a8XZl = parcelRequire("a8XZl");

var $iPTpg = parcelRequire("iPTpg");

var $8SYfi = parcelRequire("8SYfi");

var $cwnCS = parcelRequire("cwnCS");

var $lg5nd = parcelRequire("lg5nd");

var $8krl6 = parcelRequire("8krl6");

var $gXR8t = parcelRequire("gXR8t");

var $gASnm = parcelRequire("gASnm");

var $lvs07 = parcelRequire("lvs07");

var $1zp6Q = parcelRequire("1zp6Q");
var $c301bc30ecc557ca$var$_excluded = [
    "prefixCls",
    "rootClassName",
    "style",
    "className",
    "tabIndex",
    "items",
    "children",
    "direction",
    "id",
    "mode",
    "inlineCollapsed",
    "disabled",
    "disabledOverflow",
    "subMenuOpenDelay",
    "subMenuCloseDelay",
    "forceSubMenuRender",
    "defaultOpenKeys",
    "openKeys",
    "activeKey",
    "defaultActiveFirst",
    "selectable",
    "multiple",
    "defaultSelectedKeys",
    "selectedKeys",
    "onSelect",
    "onDeselect",
    "inlineIndent",
    "motion",
    "defaultMotions",
    "triggerSubMenuAction",
    "builtinPlacements",
    "itemIcon",
    "expandIcon",
    "overflowedIndicator",
    "overflowedIndicatorPopupClassName",
    "getPopupContainer",
    "onClick",
    "onOpenChange",
    "onKeyDown",
    "openAnimation",
    "openTransitionName",
    "_internalRenderMenuItem",
    "_internalRenderSubMenuItem"
];
/**
 * Menu modify after refactor:
 * ## Add
 * - disabled
 *
 * ## Remove
 * - openTransitionName
 * - openAnimation
 * - onDestroy
 * - siderCollapsed: Seems antd do not use this prop (Need test in antd)
 * - collapsedWidth: Seems this logic should be handle by antd Layout.Sider
 */ // optimize for render
var $c301bc30ecc557ca$var$EMPTY_LIST = [];
var $c301bc30ecc557ca$var$Menu = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _childList$, _classNames;
    var _ref = props, _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? "rc-menu" : _ref$prefixCls, rootClassName = _ref.rootClassName, style = _ref.style, className = _ref.className, _ref$tabIndex = _ref.tabIndex, tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex, items = _ref.items, children = _ref.children, direction = _ref.direction, id = _ref.id, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? "vertical" : _ref$mode, inlineCollapsed = _ref.inlineCollapsed, disabled = _ref.disabled, disabledOverflow = _ref.disabledOverflow, _ref$subMenuOpenDelay = _ref.subMenuOpenDelay, subMenuOpenDelay = _ref$subMenuOpenDelay === void 0 ? 0.1 : _ref$subMenuOpenDelay, _ref$subMenuCloseDela = _ref.subMenuCloseDelay, subMenuCloseDelay = _ref$subMenuCloseDela === void 0 ? 0.1 : _ref$subMenuCloseDela, forceSubMenuRender = _ref.forceSubMenuRender, defaultOpenKeys = _ref.defaultOpenKeys, openKeys = _ref.openKeys, activeKey = _ref.activeKey, defaultActiveFirst = _ref.defaultActiveFirst, _ref$selectable = _ref.selectable, selectable = _ref$selectable === void 0 ? true : _ref$selectable, _ref$multiple = _ref.multiple, multiple = _ref$multiple === void 0 ? false : _ref$multiple, defaultSelectedKeys = _ref.defaultSelectedKeys, selectedKeys = _ref.selectedKeys, onSelect = _ref.onSelect, onDeselect = _ref.onDeselect, _ref$inlineIndent = _ref.inlineIndent, inlineIndent = _ref$inlineIndent === void 0 ? 24 : _ref$inlineIndent, motion = _ref.motion, defaultMotions = _ref.defaultMotions, _ref$triggerSubMenuAc = _ref.triggerSubMenuAction, triggerSubMenuAction = _ref$triggerSubMenuAc === void 0 ? "hover" : _ref$triggerSubMenuAc, builtinPlacements = _ref.builtinPlacements, itemIcon = _ref.itemIcon, expandIcon = _ref.expandIcon, _ref$overflowedIndica = _ref.overflowedIndicator, overflowedIndicator = _ref$overflowedIndica === void 0 ? "..." : _ref$overflowedIndica, overflowedIndicatorPopupClassName = _ref.overflowedIndicatorPopupClassName, getPopupContainer = _ref.getPopupContainer, onClick = _ref.onClick, onOpenChange = _ref.onOpenChange, onKeyDown = _ref.onKeyDown, openAnimation = _ref.openAnimation, openTransitionName = _ref.openTransitionName, _internalRenderMenuItem = _ref._internalRenderMenuItem, _internalRenderSubMenuItem = _ref._internalRenderSubMenuItem, restProps = (0, $9X7IJ.default)(_ref, $c301bc30ecc557ca$var$_excluded);
    var childList = $acw62.useMemo(function() {
        return (0, $lvs07.parseItems)(children, items, $c301bc30ecc557ca$var$EMPTY_LIST);
    }, [
        children,
        items
    ]);
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), mounted = _React$useState2[0], setMounted = _React$useState2[1];
    var containerRef = $acw62.useRef();
    var uuid = (0, $8krl6.default)(id);
    var isRtl = direction === "rtl";
    // ========================= Open =========================
    var _useMergedState = (0, $iSQh8.default)(defaultOpenKeys, {
        value: openKeys,
        postState: function postState(keys) {
            return keys || $c301bc30ecc557ca$var$EMPTY_LIST;
        }
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), mergedOpenKeys = _useMergedState2[0], setMergedOpenKeys = _useMergedState2[1];
    // React 18 will merge mouse event which means we open key will not sync
    // ref: https://github.com/ant-design/ant-design/issues/38818
    var triggerOpenKeys = function triggerOpenKeys(keys) {
        var forceFlush = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        function doUpdate() {
            setMergedOpenKeys(keys);
            onOpenChange === null || onOpenChange === void 0 || onOpenChange(keys);
        }
        if (forceFlush) (0, $1u0KT.flushSync)(doUpdate);
        else doUpdate();
    };
    // >>>>> Cache & Reset open keys when inlineCollapsed changed
    var _React$useState3 = $acw62.useState(mergedOpenKeys), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), inlineCacheOpenKeys = _React$useState4[0], setInlineCacheOpenKeys = _React$useState4[1];
    var mountRef = $acw62.useRef(false);
    // ========================= Mode =========================
    var _React$useMemo = $acw62.useMemo(function() {
        if ((mode === "inline" || mode === "vertical") && inlineCollapsed) return [
            "vertical",
            inlineCollapsed
        ];
        return [
            mode,
            false
        ];
    }, [
        mode,
        inlineCollapsed
    ]), _React$useMemo2 = (0, $eUqlC.default)(_React$useMemo, 2), mergedMode = _React$useMemo2[0], mergedInlineCollapsed = _React$useMemo2[1];
    var isInlineMode = mergedMode === "inline";
    var _React$useState5 = $acw62.useState(mergedMode), _React$useState6 = (0, $eUqlC.default)(_React$useState5, 2), internalMode = _React$useState6[0], setInternalMode = _React$useState6[1];
    var _React$useState7 = $acw62.useState(mergedInlineCollapsed), _React$useState8 = (0, $eUqlC.default)(_React$useState7, 2), internalInlineCollapsed = _React$useState8[0], setInternalInlineCollapsed = _React$useState8[1];
    $acw62.useEffect(function() {
        setInternalMode(mergedMode);
        setInternalInlineCollapsed(mergedInlineCollapsed);
        if (!mountRef.current) return;
        // Synchronously update MergedOpenKeys
        if (isInlineMode) setMergedOpenKeys(inlineCacheOpenKeys);
        else // Trigger open event in case its in control
        triggerOpenKeys($c301bc30ecc557ca$var$EMPTY_LIST);
    }, [
        mergedMode,
        mergedInlineCollapsed
    ]);
    // ====================== Responsive ======================
    var _React$useState9 = $acw62.useState(0), _React$useState10 = (0, $eUqlC.default)(_React$useState9, 2), lastVisibleIndex = _React$useState10[0], setLastVisibleIndex = _React$useState10[1];
    var allVisible = lastVisibleIndex >= childList.length - 1 || internalMode !== "horizontal" || disabledOverflow;
    // Cache
    $acw62.useEffect(function() {
        if (isInlineMode) setInlineCacheOpenKeys(mergedOpenKeys);
    }, [
        mergedOpenKeys
    ]);
    $acw62.useEffect(function() {
        mountRef.current = true;
        return function() {
            mountRef.current = false;
        };
    }, []);
    // ========================= Path =========================
    var _useKeyRecords = (0, $cwnCS.default)(), registerPath = _useKeyRecords.registerPath, unregisterPath = _useKeyRecords.unregisterPath, refreshOverflowKeys = _useKeyRecords.refreshOverflowKeys, isSubPathKey = _useKeyRecords.isSubPathKey, getKeyPath = _useKeyRecords.getKeyPath, getKeys = _useKeyRecords.getKeys, getSubPathKeys = _useKeyRecords.getSubPathKeys;
    var registerPathContext = $acw62.useMemo(function() {
        return {
            registerPath: registerPath,
            unregisterPath: unregisterPath
        };
    }, [
        registerPath,
        unregisterPath
    ]);
    var pathUserContext = $acw62.useMemo(function() {
        return {
            isSubPathKey: isSubPathKey
        };
    }, [
        isSubPathKey
    ]);
    $acw62.useEffect(function() {
        refreshOverflowKeys(allVisible ? $c301bc30ecc557ca$var$EMPTY_LIST : childList.slice(lastVisibleIndex + 1).map(function(child) {
            return child.key;
        }));
    }, [
        lastVisibleIndex,
        allVisible
    ]);
    // ======================== Active ========================
    var _useMergedState3 = (0, $iSQh8.default)(activeKey || defaultActiveFirst && ((_childList$ = childList[0]) === null || _childList$ === void 0 ? void 0 : _childList$.key), {
        value: activeKey
    }), _useMergedState4 = (0, $eUqlC.default)(_useMergedState3, 2), mergedActiveKey = _useMergedState4[0], setMergedActiveKey = _useMergedState4[1];
    var onActive = (0, $lg5nd.default)(function(key) {
        setMergedActiveKey(key);
    });
    var onInactive = (0, $lg5nd.default)(function() {
        setMergedActiveKey(undefined);
    });
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            list: containerRef.current,
            focus: function focus(options) {
                var _childList$find;
                var keys = getKeys();
                var _refreshElements = (0, $8SYfi.refreshElements)(keys, uuid), elements = _refreshElements.elements, key2element = _refreshElements.key2element, element2key = _refreshElements.element2key;
                var focusableElements = (0, $8SYfi.getFocusableElements)(containerRef.current, elements);
                var shouldFocusKey = mergedActiveKey !== null && mergedActiveKey !== void 0 ? mergedActiveKey : focusableElements[0] ? element2key.get(focusableElements[0]) : (_childList$find = childList.find(function(node) {
                    return !node.props.disabled;
                })) === null || _childList$find === void 0 ? void 0 : _childList$find.key;
                var elementToFocus = key2element.get(shouldFocusKey);
                if (shouldFocusKey && elementToFocus) {
                    var _elementToFocus$focus;
                    elementToFocus === null || elementToFocus === void 0 || (_elementToFocus$focus = elementToFocus.focus) === null || _elementToFocus$focus === void 0 || _elementToFocus$focus.call(elementToFocus, options);
                }
            }
        };
    });
    // ======================== Select ========================
    // >>>>> Select keys
    var _useMergedState5 = (0, $iSQh8.default)(defaultSelectedKeys || [], {
        value: selectedKeys,
        // Legacy convert key to array
        postState: function postState(keys) {
            if (Array.isArray(keys)) return keys;
            if (keys === null || keys === undefined) return $c301bc30ecc557ca$var$EMPTY_LIST;
            return [
                keys
            ];
        }
    }), _useMergedState6 = (0, $eUqlC.default)(_useMergedState5, 2), mergedSelectKeys = _useMergedState6[0], setMergedSelectKeys = _useMergedState6[1];
    // >>>>> Trigger select
    var triggerSelection = function triggerSelection(info) {
        if (selectable) {
            // Insert or Remove
            var targetKey = info.key;
            var exist = mergedSelectKeys.includes(targetKey);
            var newSelectKeys;
            if (multiple) {
                if (exist) newSelectKeys = mergedSelectKeys.filter(function(key) {
                    return key !== targetKey;
                });
                else newSelectKeys = [].concat((0, $kbxxf.default)(mergedSelectKeys), [
                    targetKey
                ]);
            } else newSelectKeys = [
                targetKey
            ];
            setMergedSelectKeys(newSelectKeys);
            // Trigger event
            var selectInfo = (0, $d49SP.default)((0, $d49SP.default)({}, info), {}, {
                selectedKeys: newSelectKeys
            });
            if (exist) onDeselect === null || onDeselect === void 0 || onDeselect(selectInfo);
            else onSelect === null || onSelect === void 0 || onSelect(selectInfo);
        }
        // Whatever selectable, always close it
        if (!multiple && mergedOpenKeys.length && internalMode !== "inline") triggerOpenKeys($c301bc30ecc557ca$var$EMPTY_LIST);
    };
    // ========================= Open =========================
    /**
   * Click for item. SubMenu do not have selection status
   */ var onInternalClick = (0, $lg5nd.default)(function(info) {
        onClick === null || onClick === void 0 || onClick((0, $1zp6Q.warnItemProp)(info));
        triggerSelection(info);
    });
    var onInternalOpenChange = (0, $lg5nd.default)(function(key, open) {
        var newOpenKeys = mergedOpenKeys.filter(function(k) {
            return k !== key;
        });
        if (open) newOpenKeys.push(key);
        else if (internalMode !== "inline") {
            // We need find all related popup to close
            var subPathKeys = getSubPathKeys(key);
            newOpenKeys = newOpenKeys.filter(function(k) {
                return !subPathKeys.has(k);
            });
        }
        if (!(0, $4AFGH.default)(mergedOpenKeys, newOpenKeys, true)) triggerOpenKeys(newOpenKeys, true);
    });
    // ==================== Accessibility =====================
    var triggerAccessibilityOpen = function triggerAccessibilityOpen(key, open) {
        var nextOpen = open !== null && open !== void 0 ? open : !mergedOpenKeys.includes(key);
        onInternalOpenChange(key, nextOpen);
    };
    var onInternalKeyDown = (0, $8SYfi.useAccessibility)(internalMode, mergedActiveKey, isRtl, uuid, containerRef, getKeys, getKeyPath, setMergedActiveKey, triggerAccessibilityOpen, onKeyDown);
    // ======================== Effect ========================
    $acw62.useEffect(function() {
        setMounted(true);
    }, []);
    // ======================= Context ========================
    var privateContext = $acw62.useMemo(function() {
        return {
            _internalRenderMenuItem: _internalRenderMenuItem,
            _internalRenderSubMenuItem: _internalRenderSubMenuItem
        };
    }, [
        _internalRenderMenuItem,
        _internalRenderSubMenuItem
    ]);
    // ======================== Render ========================
    // >>>>> Children
    var wrappedChildList = internalMode !== "horizontal" || disabledOverflow ? childList : // Need wrap for overflow dropdown that do not response for open
    childList.map(function(child, index) {
        return(/*#__PURE__*/ // Always wrap provider to avoid sub node re-mount
        $acw62.createElement((0, $392Az.default), {
            key: child.key,
            overflowDisabled: index > lastVisibleIndex
        }, child));
    });
    // >>>>> Container
    var container = /*#__PURE__*/ $acw62.createElement((0, $6dkAu.default), (0, $8nd05.default)({
        id: id,
        ref: containerRef,
        prefixCls: "".concat(prefixCls, "-overflow"),
        component: "ul",
        itemComponent: (0, $gXR8t.default),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, "".concat(prefixCls, "-root"), "".concat(prefixCls, "-").concat(internalMode), className, (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-inline-collapsed"), internalInlineCollapsed), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-rtl"), isRtl), _classNames), rootClassName),
        dir: direction,
        style: style,
        role: "menu",
        tabIndex: tabIndex,
        data: wrappedChildList,
        renderRawItem: function renderRawItem(node) {
            return node;
        },
        renderRawRest: function renderRawRest(omitItems) {
            // We use origin list since wrapped list use context to prevent open
            var len = omitItems.length;
            var originOmitItems = len ? childList.slice(-len) : null;
            return /*#__PURE__*/ $acw62.createElement((0, $gASnm.default), {
                eventKey: (0, $cwnCS.OVERFLOW_KEY),
                title: overflowedIndicator,
                disabled: allVisible,
                internalPopupClose: len === 0,
                popupClassName: overflowedIndicatorPopupClassName
            }, originOmitItems);
        },
        maxCount: internalMode !== "horizontal" || disabledOverflow ? (0, $6dkAu.default).INVALIDATE : (0, $6dkAu.default).RESPONSIVE,
        ssr: "full",
        "data-menu-list": true,
        onVisibleChange: function onVisibleChange(newLastIndex) {
            setLastVisibleIndex(newLastIndex);
        },
        onKeyDown: onInternalKeyDown
    }, restProps));
    // >>>>> Render
    return /*#__PURE__*/ $acw62.createElement((0, $iPTpg.default).Provider, {
        value: privateContext
    }, /*#__PURE__*/ $acw62.createElement((0, $dpnFa.IdContext).Provider, {
        value: uuid
    }, /*#__PURE__*/ $acw62.createElement((0, $392Az.default), {
        prefixCls: prefixCls,
        rootClassName: rootClassName,
        mode: internalMode,
        openKeys: mergedOpenKeys,
        rtl: isRtl,
        disabled: disabled,
        motion: mounted ? motion : null,
        defaultMotions: mounted ? defaultMotions : null,
        activeKey: mergedActiveKey,
        onActive: onActive,
        onInactive: onInactive,
        selectedKeys: mergedSelectKeys,
        inlineIndent: inlineIndent,
        subMenuOpenDelay: subMenuOpenDelay,
        subMenuCloseDelay: subMenuCloseDelay,
        forceSubMenuRender: forceSubMenuRender,
        builtinPlacements: builtinPlacements,
        triggerSubMenuAction: triggerSubMenuAction,
        getPopupContainer: getPopupContainer,
        itemIcon: itemIcon,
        expandIcon: expandIcon,
        onItemClick: onInternalClick,
        onOpenChange: onInternalOpenChange
    }, /*#__PURE__*/ $acw62.createElement((0, $a8XZl.PathUserContext).Provider, {
        value: pathUserContext
    }, container), /*#__PURE__*/ $acw62.createElement("div", {
        style: {
            display: "none"
        },
        "aria-hidden": true
    }, /*#__PURE__*/ $acw62.createElement((0, $a8XZl.PathRegisterContext).Provider, {
        value: registerPathContext
    }, childList)))));
});
var $c301bc30ecc557ca$export$2e2bcd8739ae039 = $c301bc30ecc557ca$var$Menu;

});
parcelRegister("6dkAu", function(module, exports) {

$parcel$export(module.exports, "default", () => $4863ed3a14942ec4$export$2e2bcd8739ae039);

var $3unmm = parcelRequire("3unmm");
var $4863ed3a14942ec4$export$2e2bcd8739ae039 = (0, $3unmm.default);

});
parcelRegister("3unmm", function(module, exports) {

$parcel$export(module.exports, "default", () => $28a64b28232d3cd3$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $bVxlN = parcelRequire("bVxlN");

var $6hDTM = parcelRequire("6hDTM");

var $qp3UV = parcelRequire("qp3UV");

var $khBri = parcelRequire("khBri");

var $24COT = parcelRequire("24COT");

var $5MJBM = parcelRequire("5MJBM");
var $28a64b28232d3cd3$var$_excluded = [
    "prefixCls",
    "data",
    "renderItem",
    "renderRawItem",
    "itemKey",
    "itemWidth",
    "ssr",
    "style",
    "className",
    "maxCount",
    "renderRest",
    "renderRawRest",
    "suffix",
    "component",
    "itemComponent",
    "onVisibleChange"
];
var $28a64b28232d3cd3$var$RESPONSIVE = "responsive";
var $28a64b28232d3cd3$var$INVALIDATE = "invalidate";
function $28a64b28232d3cd3$var$defaultRenderRest(omittedItems) {
    return "+ ".concat(omittedItems.length, " ...");
}
function $28a64b28232d3cd3$var$Overflow(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-overflow" : _props$prefixCls, _props$data = props.data, data = _props$data === void 0 ? [] : _props$data, renderItem = props.renderItem, renderRawItem = props.renderRawItem, itemKey = props.itemKey, _props$itemWidth = props.itemWidth, itemWidth = _props$itemWidth === void 0 ? 10 : _props$itemWidth, ssr = props.ssr, style = props.style, className = props.className, maxCount = props.maxCount, renderRest = props.renderRest, renderRawRest = props.renderRawRest, suffix = props.suffix, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, itemComponent = props.itemComponent, onVisibleChange = props.onVisibleChange, restProps = (0, $9X7IJ.default)(props, $28a64b28232d3cd3$var$_excluded);
    var fullySSR = ssr === "full";
    var notifyEffectUpdate = (0, $khBri.useBatcher)();
    var _useEffectState = (0, $khBri.default)(notifyEffectUpdate, null), _useEffectState2 = (0, $eUqlC.default)(_useEffectState, 2), containerWidth = _useEffectState2[0], setContainerWidth = _useEffectState2[1];
    var mergedContainerWidth = containerWidth || 0;
    var _useEffectState3 = (0, $khBri.default)(notifyEffectUpdate, new Map()), _useEffectState4 = (0, $eUqlC.default)(_useEffectState3, 2), itemWidths = _useEffectState4[0], setItemWidths = _useEffectState4[1];
    var _useEffectState5 = (0, $khBri.default)(notifyEffectUpdate, 0), _useEffectState6 = (0, $eUqlC.default)(_useEffectState5, 2), prevRestWidth = _useEffectState6[0], setPrevRestWidth = _useEffectState6[1];
    var _useEffectState7 = (0, $khBri.default)(notifyEffectUpdate, 0), _useEffectState8 = (0, $eUqlC.default)(_useEffectState7, 2), restWidth = _useEffectState8[0], setRestWidth = _useEffectState8[1];
    var _useEffectState9 = (0, $khBri.default)(notifyEffectUpdate, 0), _useEffectState10 = (0, $eUqlC.default)(_useEffectState9, 2), suffixWidth = _useEffectState10[0], setSuffixWidth = _useEffectState10[1];
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, $eUqlC.default)(_useState, 2), suffixFixedStart = _useState2[0], setSuffixFixedStart = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, $eUqlC.default)(_useState3, 2), displayCount = _useState4[0], setDisplayCount = _useState4[1];
    var mergedDisplayCount = $acw62.useMemo(function() {
        if (displayCount === null && fullySSR) return Number.MAX_SAFE_INTEGER;
        return displayCount || 0;
    }, [
        displayCount,
        containerWidth
    ]);
    var _useState5 = (0, $acw62.useState)(false), _useState6 = (0, $eUqlC.default)(_useState5, 2), restReady = _useState6[0], setRestReady = _useState6[1];
    var itemPrefixCls = "".concat(prefixCls, "-item");
    // Always use the max width to avoid blink
    var mergedRestWidth = Math.max(prevRestWidth, restWidth);
    // ================================= Data =================================
    var isResponsive = maxCount === $28a64b28232d3cd3$var$RESPONSIVE;
    var shouldResponsive = data.length && isResponsive;
    var invalidate = maxCount === $28a64b28232d3cd3$var$INVALIDATE;
    /**
   * When is `responsive`, we will always render rest node to get the real width of it for calculation
   */ var showRest = shouldResponsive || typeof maxCount === "number" && data.length > maxCount;
    var mergedData = (0, $acw62.useMemo)(function() {
        var items = data;
        if (shouldResponsive) {
            if (containerWidth === null && fullySSR) items = data;
            else items = data.slice(0, Math.min(data.length, mergedContainerWidth / itemWidth));
        } else if (typeof maxCount === "number") items = data.slice(0, maxCount);
        return items;
    }, [
        data,
        itemWidth,
        containerWidth,
        maxCount,
        shouldResponsive
    ]);
    var omittedItems = (0, $acw62.useMemo)(function() {
        if (shouldResponsive) return data.slice(mergedDisplayCount + 1);
        return data.slice(mergedData.length);
    }, [
        data,
        mergedData,
        shouldResponsive,
        mergedDisplayCount
    ]);
    // ================================= Item =================================
    var getKey = (0, $acw62.useCallback)(function(item, index) {
        var _ref;
        if (typeof itemKey === "function") return itemKey(item);
        return (_ref = itemKey && (item === null || item === void 0 ? void 0 : item[itemKey])) !== null && _ref !== void 0 ? _ref : index;
    }, [
        itemKey
    ]);
    var mergedRenderItem = (0, $acw62.useCallback)(renderItem || function(item) {
        return item;
    }, [
        renderItem
    ]);
    function updateDisplayCount(count, suffixFixedStartVal, notReady) {
        // React 18 will sync render even when the value is same in some case.
        // We take `mergedData` as deps which may cause dead loop if it's dynamic generate.
        // ref: https://github.com/ant-design/ant-design/issues/36559
        if (displayCount === count && (suffixFixedStartVal === undefined || suffixFixedStartVal === suffixFixedStart)) return;
        setDisplayCount(count);
        if (!notReady) {
            setRestReady(count < data.length - 1);
            onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(count);
        }
        if (suffixFixedStartVal !== undefined) setSuffixFixedStart(suffixFixedStartVal);
    }
    // ================================= Size =================================
    function onOverflowResize(_, element) {
        setContainerWidth(element.clientWidth);
    }
    function registerSize(key, width) {
        setItemWidths(function(origin) {
            var clone = new Map(origin);
            if (width === null) clone.delete(key);
            else clone.set(key, width);
            return clone;
        });
    }
    function registerOverflowSize(_, width) {
        setRestWidth(width);
        setPrevRestWidth(restWidth);
    }
    function registerSuffixSize(_, width) {
        setSuffixWidth(width);
    }
    // ================================ Effect ================================
    function getItemWidth(index) {
        return itemWidths.get(getKey(mergedData[index], index));
    }
    (0, $6hDTM.default)(function() {
        if (mergedContainerWidth && typeof mergedRestWidth === "number" && mergedData) {
            var totalWidth = suffixWidth;
            var len = mergedData.length;
            var lastIndex = len - 1;
            // When data count change to 0, reset this since not loop will reach
            if (!len) {
                updateDisplayCount(0, null);
                return;
            }
            for(var i = 0; i < len; i += 1){
                var currentItemWidth = getItemWidth(i);
                // Fully will always render
                if (fullySSR) currentItemWidth = currentItemWidth || 0;
                // Break since data not ready
                if (currentItemWidth === undefined) {
                    updateDisplayCount(i - 1, undefined, true);
                    break;
                }
                // Find best match
                totalWidth += currentItemWidth;
                if (// Only one means `totalWidth` is the final width
                lastIndex === 0 && totalWidth <= mergedContainerWidth || // Last two width will be the final width
                i === lastIndex - 1 && totalWidth + getItemWidth(lastIndex) <= mergedContainerWidth) {
                    // Additional check if match the end
                    updateDisplayCount(lastIndex, null);
                    break;
                } else if (totalWidth + mergedRestWidth > mergedContainerWidth) {
                    // Can not hold all the content to show rest
                    updateDisplayCount(i - 1, totalWidth - currentItemWidth - suffixWidth + restWidth);
                    break;
                }
            }
            if (suffix && getItemWidth(0) + suffixWidth > mergedContainerWidth) setSuffixFixedStart(null);
        }
    }, [
        mergedContainerWidth,
        itemWidths,
        restWidth,
        suffixWidth,
        getKey,
        mergedData
    ]);
    // ================================ Render ================================
    var displayRest = restReady && !!omittedItems.length;
    var suffixStyle = {};
    if (suffixFixedStart !== null && shouldResponsive) suffixStyle = {
        position: "absolute",
        left: suffixFixedStart,
        top: 0
    };
    var itemSharedProps = {
        prefixCls: itemPrefixCls,
        responsive: shouldResponsive,
        component: itemComponent,
        invalidate: invalidate
    };
    // >>>>> Choice render fun by `renderRawItem`
    var internalRenderItemNode = renderRawItem ? function(item, index) {
        var key = getKey(item, index);
        return /*#__PURE__*/ $acw62.createElement((0, $5MJBM.OverflowContext).Provider, {
            key: key,
            value: (0, $d49SP.default)((0, $d49SP.default)({}, itemSharedProps), {}, {
                order: index,
                item: item,
                itemKey: key,
                registerSize: registerSize,
                display: index <= mergedDisplayCount
            })
        }, renderRawItem(item, index));
    } : function(item, index) {
        var key = getKey(item, index);
        return /*#__PURE__*/ $acw62.createElement((0, $qp3UV.default), (0, $8nd05.default)({}, itemSharedProps, {
            order: index,
            key: key,
            item: item,
            renderItem: mergedRenderItem,
            itemKey: key,
            registerSize: registerSize,
            display: index <= mergedDisplayCount
        }));
    };
    // >>>>> Rest node
    var restNode;
    var restContextProps = {
        order: displayRest ? mergedDisplayCount : Number.MAX_SAFE_INTEGER,
        className: "".concat(itemPrefixCls, "-rest"),
        registerSize: registerOverflowSize,
        display: displayRest
    };
    if (!renderRawRest) {
        var mergedRenderRest = renderRest || $28a64b28232d3cd3$var$defaultRenderRest;
        restNode = /*#__PURE__*/ $acw62.createElement((0, $qp3UV.default), (0, $8nd05.default)({}, itemSharedProps, restContextProps), typeof mergedRenderRest === "function" ? mergedRenderRest(omittedItems) : mergedRenderRest);
    } else if (renderRawRest) restNode = /*#__PURE__*/ $acw62.createElement((0, $5MJBM.OverflowContext).Provider, {
        value: (0, $d49SP.default)((0, $d49SP.default)({}, itemSharedProps), restContextProps)
    }, renderRawRest(omittedItems));
    var overflowNode = /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(!invalidate && prefixCls, className),
        style: style,
        ref: ref
    }, restProps), mergedData.map(internalRenderItemNode), showRest ? restNode : null, suffix && /*#__PURE__*/ $acw62.createElement((0, $qp3UV.default), (0, $8nd05.default)({}, itemSharedProps, {
        responsive: isResponsive,
        responsiveDisabled: !shouldResponsive,
        order: mergedDisplayCount,
        className: "".concat(itemPrefixCls, "-suffix"),
        registerSize: registerSuffixSize,
        display: true,
        style: suffixStyle
    }), suffix));
    if (isResponsive) overflowNode = /*#__PURE__*/ $acw62.createElement((0, $bVxlN.default), {
        onResize: onOverflowResize,
        disabled: !shouldResponsive
    }, overflowNode);
    return overflowNode;
}
var $28a64b28232d3cd3$var$ForwardOverflow = /*#__PURE__*/ $acw62.forwardRef($28a64b28232d3cd3$var$Overflow);
$28a64b28232d3cd3$var$ForwardOverflow.displayName = "Overflow";
$28a64b28232d3cd3$var$ForwardOverflow.Item = (0, $24COT.default);
$28a64b28232d3cd3$var$ForwardOverflow.RESPONSIVE = $28a64b28232d3cd3$var$RESPONSIVE;
$28a64b28232d3cd3$var$ForwardOverflow.INVALIDATE = $28a64b28232d3cd3$var$INVALIDATE;
var // Convert to generic type
$28a64b28232d3cd3$export$2e2bcd8739ae039 = $28a64b28232d3cd3$var$ForwardOverflow;

});
parcelRegister("qp3UV", function(module, exports) {

$parcel$export(module.exports, "default", () => $04f5dea65135d084$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $bVxlN = parcelRequire("bVxlN");
var $04f5dea65135d084$var$_excluded = [
    "prefixCls",
    "invalidate",
    "item",
    "renderItem",
    "responsive",
    "responsiveDisabled",
    "registerSize",
    "itemKey",
    "className",
    "style",
    "children",
    "display",
    "order",
    "component"
];
// Use shared variable to save bundle size
var $04f5dea65135d084$var$UNDEFINED = undefined;
function $04f5dea65135d084$var$InternalItem(props, ref) {
    var prefixCls = props.prefixCls, invalidate = props.invalidate, item = props.item, renderItem = props.renderItem, responsive = props.responsive, responsiveDisabled = props.responsiveDisabled, registerSize = props.registerSize, itemKey = props.itemKey, className = props.className, style = props.style, children = props.children, display = props.display, order = props.order, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, restProps = (0, $9X7IJ.default)(props, $04f5dea65135d084$var$_excluded);
    var mergedHidden = responsive && !display;
    // ================================ Effect ================================
    function internalRegisterSize(width) {
        registerSize(itemKey, width);
    }
    $acw62.useEffect(function() {
        return function() {
            internalRegisterSize(null);
        };
    }, []);
    // ================================ Render ================================
    var childNode = renderItem && item !== $04f5dea65135d084$var$UNDEFINED ? renderItem(item) : children;
    var overflowStyle;
    if (!invalidate) overflowStyle = {
        opacity: mergedHidden ? 0 : 1,
        height: mergedHidden ? 0 : $04f5dea65135d084$var$UNDEFINED,
        overflowY: mergedHidden ? "hidden" : $04f5dea65135d084$var$UNDEFINED,
        order: responsive ? order : $04f5dea65135d084$var$UNDEFINED,
        pointerEvents: mergedHidden ? "none" : $04f5dea65135d084$var$UNDEFINED,
        position: mergedHidden ? "absolute" : $04f5dea65135d084$var$UNDEFINED
    };
    var overflowProps = {};
    if (mergedHidden) overflowProps["aria-hidden"] = true;
    var itemNode = /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(!invalidate && prefixCls, className),
        style: (0, $d49SP.default)((0, $d49SP.default)({}, overflowStyle), style)
    }, overflowProps, restProps, {
        ref: ref
    }), childNode);
    if (responsive) itemNode = /*#__PURE__*/ $acw62.createElement((0, $bVxlN.default), {
        onResize: function onResize(_ref) {
            var offsetWidth = _ref.offsetWidth;
            internalRegisterSize(offsetWidth);
        },
        disabled: responsiveDisabled
    }, itemNode);
    return itemNode;
}
var $04f5dea65135d084$var$Item = /*#__PURE__*/ $acw62.forwardRef($04f5dea65135d084$var$InternalItem);
$04f5dea65135d084$var$Item.displayName = "Item";
var $04f5dea65135d084$export$2e2bcd8739ae039 = $04f5dea65135d084$var$Item;

});

parcelRegister("khBri", function(module, exports) {

$parcel$export(module.exports, "useBatcher", () => $ec426fd785b0196a$export$eedf51fe9d751c7a);
$parcel$export(module.exports, "default", () => $ec426fd785b0196a$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $a4gyP = parcelRequire("a4gyP");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $gMdgc = parcelRequire("gMdgc");
function $ec426fd785b0196a$export$eedf51fe9d751c7a() {
    // Updater Trigger
    var updateFuncRef = $acw62.useRef(null);
    // Notify update
    var notifyEffectUpdate = function notifyEffectUpdate(callback) {
        if (!updateFuncRef.current) {
            updateFuncRef.current = [];
            (0, $gMdgc.default)(function() {
                (0, $1u0KT.unstable_batchedUpdates)(function() {
                    updateFuncRef.current.forEach(function(fn) {
                        fn();
                    });
                    updateFuncRef.current = null;
                });
            });
        }
        updateFuncRef.current.push(callback);
    };
    return notifyEffectUpdate;
}
function $ec426fd785b0196a$export$2e2bcd8739ae039(notifyEffectUpdate, defaultValue) {
    // Value
    var _React$useState = $acw62.useState(defaultValue), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), stateValue = _React$useState2[0], setStateValue = _React$useState2[1];
    // Set State
    var setEffectVal = (0, $a4gyP.default)(function(nextValue) {
        notifyEffectUpdate(function() {
            setStateValue(nextValue);
        });
    });
    return [
        stateValue,
        setEffectVal
    ];
}

});
parcelRegister("gMdgc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c36b6a4565c7d957$export$2e2bcd8739ae039);

var $dTiBu = parcelRequire("dTiBu");
function $c36b6a4565c7d957$export$2e2bcd8739ae039(callback) {
    if (typeof MessageChannel === "undefined") (0, $dTiBu.default)(callback);
    else {
        var channel = new MessageChannel();
        channel.port1.onmessage = function() {
            return callback();
        };
        channel.port2.postMessage(undefined);
    }
}

});


parcelRegister("24COT", function(module, exports) {

$parcel$export(module.exports, "default", () => $182a1149db3c9d79$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $qp3UV = parcelRequire("qp3UV");

var $5MJBM = parcelRequire("5MJBM");
var $182a1149db3c9d79$var$_excluded = [
    "component"
], $182a1149db3c9d79$var$_excluded2 = [
    "className"
], $182a1149db3c9d79$var$_excluded3 = [
    "className"
];
var $182a1149db3c9d79$var$InternalRawItem = function InternalRawItem(props, ref) {
    var context = $acw62.useContext((0, $5MJBM.OverflowContext));
    // Render directly when context not provided
    if (!context) {
        var _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _restProps = (0, $9X7IJ.default)(props, $182a1149db3c9d79$var$_excluded);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({}, _restProps, {
            ref: ref
        }));
    }
    var contextClassName = context.className, restContext = (0, $9X7IJ.default)(context, $182a1149db3c9d79$var$_excluded2);
    var className = props.className, restProps = (0, $9X7IJ.default)(props, $182a1149db3c9d79$var$_excluded3);
    // Do not pass context to sub item to avoid multiple measure
    return /*#__PURE__*/ $acw62.createElement((0, $5MJBM.OverflowContext).Provider, {
        value: null
    }, /*#__PURE__*/ $acw62.createElement((0, $qp3UV.default), (0, $8nd05.default)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(contextClassName, className)
    }, restContext, restProps)));
};
var $182a1149db3c9d79$var$RawItem = /*#__PURE__*/ $acw62.forwardRef($182a1149db3c9d79$var$InternalRawItem);
$182a1149db3c9d79$var$RawItem.displayName = "RawItem";
var $182a1149db3c9d79$export$2e2bcd8739ae039 = $182a1149db3c9d79$var$RawItem;

});
parcelRegister("5MJBM", function(module, exports) {

$parcel$export(module.exports, "OverflowContext", () => $4364d04fa4ed57d4$export$79f16dd643143c25);

var $acw62 = parcelRequire("acw62");
var $4364d04fa4ed57d4$export$79f16dd643143c25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);

});




parcelRegister("dpnFa", function(module, exports) {

$parcel$export(module.exports, "IdContext", () => $9c2ff7221738ac19$export$26537912ea160acd);
$parcel$export(module.exports, "getMenuId", () => $9c2ff7221738ac19$export$80c871fe8d6b896);
$parcel$export(module.exports, "useMenuId", () => $9c2ff7221738ac19$export$a276eb4e9be640f8);

var $acw62 = parcelRequire("acw62");
var $9c2ff7221738ac19$export$26537912ea160acd = /*#__PURE__*/ $acw62.createContext(null);
function $9c2ff7221738ac19$export$80c871fe8d6b896(uuid, eventKey) {
    if (uuid === undefined) return null;
    return "".concat(uuid, "-").concat(eventKey);
}
function $9c2ff7221738ac19$export$a276eb4e9be640f8(eventKey) {
    var id = $acw62.useContext($9c2ff7221738ac19$export$26537912ea160acd);
    return $9c2ff7221738ac19$export$80c871fe8d6b896(id, eventKey);
}

});

parcelRegister("392Az", function(module, exports) {

$parcel$export(module.exports, "MenuContext", () => $24a4386da4a32dce$export$c7e742effb1c51e2);
$parcel$export(module.exports, "default", () => $24a4386da4a32dce$export$2e2bcd8739ae039);

var $9X7IJ = parcelRequire("9X7IJ");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");

var $3Ysvw = parcelRequire("3Ysvw");

var $4AFGH = parcelRequire("4AFGH");
var $24a4386da4a32dce$var$_excluded = [
    "children",
    "locked"
];
var $24a4386da4a32dce$export$c7e742effb1c51e2 = /*#__PURE__*/ $acw62.createContext(null);
function $24a4386da4a32dce$var$mergeProps(origin, target) {
    var clone = (0, $d49SP.default)({}, origin);
    Object.keys(target).forEach(function(key) {
        var value = target[key];
        if (value !== undefined) clone[key] = value;
    });
    return clone;
}
function $24a4386da4a32dce$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, locked = _ref.locked, restProps = (0, $9X7IJ.default)(_ref, $24a4386da4a32dce$var$_excluded);
    var context = $acw62.useContext($24a4386da4a32dce$export$c7e742effb1c51e2);
    var inheritableContext = (0, $3Ysvw.default)(function() {
        return $24a4386da4a32dce$var$mergeProps(context, restProps);
    }, [
        context,
        restProps
    ], function(prev, next) {
        return !locked && (prev[0] !== next[0] || !(0, $4AFGH.default)(prev[1], next[1], true));
    });
    return /*#__PURE__*/ $acw62.createElement($24a4386da4a32dce$export$c7e742effb1c51e2.Provider, {
        value: inheritableContext
    }, children);
}

});

parcelRegister("a8XZl", function(module, exports) {

$parcel$export(module.exports, "PathRegisterContext", () => $76292f3495da88ff$export$d9ffb5bfd108b003);
$parcel$export(module.exports, "useMeasure", () => $76292f3495da88ff$export$e295b0c537d32d7d);
$parcel$export(module.exports, "PathTrackerContext", () => $76292f3495da88ff$export$54d9e16aa4c8a7fa);
$parcel$export(module.exports, "useFullPath", () => $76292f3495da88ff$export$d3d2d0a05677870a);
$parcel$export(module.exports, "PathUserContext", () => $76292f3495da88ff$export$f0b9e0db98edfa53);

var $kbxxf = parcelRequire("kbxxf");

var $acw62 = parcelRequire("acw62");
var $76292f3495da88ff$var$EmptyList = [];
var $76292f3495da88ff$export$d9ffb5bfd108b003 = /*#__PURE__*/ $acw62.createContext(null);
function $76292f3495da88ff$export$e295b0c537d32d7d() {
    return $acw62.useContext($76292f3495da88ff$export$d9ffb5bfd108b003);
}
var $76292f3495da88ff$export$54d9e16aa4c8a7fa = /*#__PURE__*/ $acw62.createContext($76292f3495da88ff$var$EmptyList);
function $76292f3495da88ff$export$d3d2d0a05677870a(eventKey) {
    var parentKeyPath = $acw62.useContext($76292f3495da88ff$export$54d9e16aa4c8a7fa);
    return $acw62.useMemo(function() {
        return eventKey !== undefined ? [].concat((0, $kbxxf.default)(parentKeyPath), [
            eventKey
        ]) : parentKeyPath;
    }, [
        parentKeyPath,
        eventKey
    ]);
}
var $76292f3495da88ff$export$f0b9e0db98edfa53 = /*#__PURE__*/ $acw62.createContext(null);

});

parcelRegister("iPTpg", function(module, exports) {

$parcel$export(module.exports, "default", () => $db67f8032758903f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $db67f8032758903f$var$PrivateContext = /*#__PURE__*/ $acw62.createContext({});
var $db67f8032758903f$export$2e2bcd8739ae039 = $db67f8032758903f$var$PrivateContext;

});

parcelRegister("8SYfi", function(module, exports) {

$parcel$export(module.exports, "getFocusableElements", () => $6782197159192667$export$433aaa1f216cf32d);
$parcel$export(module.exports, "refreshElements", () => $6782197159192667$export$20827b68c762d23);
$parcel$export(module.exports, "useAccessibility", () => $6782197159192667$export$aa6de64279d64603);

var $kSlfw = parcelRequire("kSlfw");

var $77reW = parcelRequire("77reW");

var $iCi4s = parcelRequire("iCi4s");

var $dTiBu = parcelRequire("dTiBu");

var $acw62 = parcelRequire("acw62");

var $dpnFa = parcelRequire("dpnFa");
// destruct to reduce minify size
var $6782197159192667$var$LEFT = (0, $iCi4s.default).LEFT, $6782197159192667$var$RIGHT = (0, $iCi4s.default).RIGHT, $6782197159192667$var$UP = (0, $iCi4s.default).UP, $6782197159192667$var$DOWN = (0, $iCi4s.default).DOWN, $6782197159192667$var$ENTER = (0, $iCi4s.default).ENTER, $6782197159192667$var$ESC = (0, $iCi4s.default).ESC, $6782197159192667$var$HOME = (0, $iCi4s.default).HOME, $6782197159192667$var$END = (0, $iCi4s.default).END;
var $6782197159192667$var$ArrowKeys = [
    $6782197159192667$var$UP,
    $6782197159192667$var$DOWN,
    $6782197159192667$var$LEFT,
    $6782197159192667$var$RIGHT
];
function $6782197159192667$var$getOffset(mode, isRootLevel, isRtl, which) {
    var _inline, _horizontal, _vertical, _offsets;
    var prev = "prev";
    var next = "next";
    var children = "children";
    var parent = "parent";
    // Inline enter is special that we use unique operation
    if (mode === "inline" && which === $6782197159192667$var$ENTER) return {
        inlineTrigger: true
    };
    var inline = (_inline = {}, (0, $kSlfw.default)(_inline, $6782197159192667$var$UP, prev), (0, $kSlfw.default)(_inline, $6782197159192667$var$DOWN, next), _inline);
    var horizontal = (_horizontal = {}, (0, $kSlfw.default)(_horizontal, $6782197159192667$var$LEFT, isRtl ? next : prev), (0, $kSlfw.default)(_horizontal, $6782197159192667$var$RIGHT, isRtl ? prev : next), (0, $kSlfw.default)(_horizontal, $6782197159192667$var$DOWN, children), (0, $kSlfw.default)(_horizontal, $6782197159192667$var$ENTER, children), _horizontal);
    var vertical = (_vertical = {}, (0, $kSlfw.default)(_vertical, $6782197159192667$var$UP, prev), (0, $kSlfw.default)(_vertical, $6782197159192667$var$DOWN, next), (0, $kSlfw.default)(_vertical, $6782197159192667$var$ENTER, children), (0, $kSlfw.default)(_vertical, $6782197159192667$var$ESC, parent), (0, $kSlfw.default)(_vertical, $6782197159192667$var$LEFT, isRtl ? children : parent), (0, $kSlfw.default)(_vertical, $6782197159192667$var$RIGHT, isRtl ? parent : children), _vertical);
    var offsets = {
        inline: inline,
        horizontal: horizontal,
        vertical: vertical,
        inlineSub: inline,
        horizontalSub: vertical,
        verticalSub: vertical
    };
    var type = (_offsets = offsets["".concat(mode).concat(isRootLevel ? "" : "Sub")]) === null || _offsets === void 0 ? void 0 : _offsets[which];
    switch(type){
        case prev:
            return {
                offset: -1,
                sibling: true
            };
        case next:
            return {
                offset: 1,
                sibling: true
            };
        case parent:
            return {
                offset: -1,
                sibling: false
            };
        case children:
            return {
                offset: 1,
                sibling: false
            };
        default:
            return null;
    }
}
function $6782197159192667$var$findContainerUL(element) {
    var current = element;
    while(current){
        if (current.getAttribute("data-menu-list")) return current;
        current = current.parentElement;
    }
    // Normally should not reach this line
    /* istanbul ignore next */ return null;
}
/**
 * Find focused element within element set provided
 */ function $6782197159192667$var$getFocusElement(activeElement, elements) {
    var current = activeElement || document.activeElement;
    while(current){
        if (elements.has(current)) return current;
        current = current.parentElement;
    }
    return null;
}
function $6782197159192667$export$433aaa1f216cf32d(container, elements) {
    var list = (0, $77reW.getFocusNodeList)(container, true);
    return list.filter(function(ele) {
        return elements.has(ele);
    });
}
function $6782197159192667$var$getNextFocusElement(parentQueryContainer, elements, focusMenuElement) {
    var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    // Key on the menu item will not get validate parent container
    if (!parentQueryContainer) return null;
    // List current level menu item elements
    var sameLevelFocusableMenuElementList = $6782197159192667$export$433aaa1f216cf32d(parentQueryContainer, elements);
    // Find next focus index
    var count = sameLevelFocusableMenuElementList.length;
    var focusIndex = sameLevelFocusableMenuElementList.findIndex(function(ele) {
        return focusMenuElement === ele;
    });
    if (offset < 0) {
        if (focusIndex === -1) focusIndex = count - 1;
        else focusIndex -= 1;
    } else if (offset > 0) focusIndex += 1;
    focusIndex = (focusIndex + count) % count;
    // Focus menu item
    return sameLevelFocusableMenuElementList[focusIndex];
}
var $6782197159192667$export$20827b68c762d23 = function refreshElements(keys, id) {
    var elements = new Set();
    var key2element = new Map();
    var element2key = new Map();
    keys.forEach(function(key) {
        var element = document.querySelector("[data-menu-id='".concat((0, $dpnFa.getMenuId)(id, key), "']"));
        if (element) {
            elements.add(element);
            element2key.set(element, key);
            key2element.set(key, element);
        }
    });
    return {
        elements: elements,
        key2element: key2element,
        element2key: element2key
    };
};
function $6782197159192667$export$aa6de64279d64603(mode, activeKey, isRtl, id, containerRef, getKeys, getKeyPath, triggerActiveKey, triggerAccessibilityOpen, originOnKeyDown) {
    var rafRef = $acw62.useRef();
    var activeRef = $acw62.useRef();
    activeRef.current = activeKey;
    var cleanRaf = function cleanRaf() {
        (0, $dTiBu.default).cancel(rafRef.current);
    };
    $acw62.useEffect(function() {
        return function() {
            cleanRaf();
        };
    }, []);
    return function(e) {
        var which = e.which;
        if ([].concat($6782197159192667$var$ArrowKeys, [
            $6782197159192667$var$ENTER,
            $6782197159192667$var$ESC,
            $6782197159192667$var$HOME,
            $6782197159192667$var$END
        ]).includes(which)) {
            var keys = getKeys();
            var refreshedElements = $6782197159192667$export$20827b68c762d23(keys, id);
            var _refreshedElements = refreshedElements, elements = _refreshedElements.elements, key2element = _refreshedElements.key2element, element2key = _refreshedElements.element2key;
            // First we should find current focused MenuItem/SubMenu element
            var activeElement = key2element.get(activeKey);
            var focusMenuElement = $6782197159192667$var$getFocusElement(activeElement, elements);
            var focusMenuKey = element2key.get(focusMenuElement);
            var offsetObj = $6782197159192667$var$getOffset(mode, getKeyPath(focusMenuKey, true).length === 1, isRtl, which);
            // Some mode do not have fully arrow operation like inline
            if (!offsetObj && which !== $6782197159192667$var$HOME && which !== $6782197159192667$var$END) return;
            // Arrow prevent default to avoid page scroll
            if ($6782197159192667$var$ArrowKeys.includes(which) || [
                $6782197159192667$var$HOME,
                $6782197159192667$var$END
            ].includes(which)) e.preventDefault();
            var tryFocus = function tryFocus(menuElement) {
                if (menuElement) {
                    var focusTargetElement = menuElement;
                    // Focus to link instead of menu item if possible
                    var link = menuElement.querySelector("a");
                    if (link !== null && link !== void 0 && link.getAttribute("href")) focusTargetElement = link;
                    var targetKey = element2key.get(menuElement);
                    triggerActiveKey(targetKey);
                    /**
           * Do not `useEffect` here since `tryFocus` may trigger async
           * which makes React sync update the `activeKey`
           * that force render before `useRef` set the next activeKey
           */ cleanRaf();
                    rafRef.current = (0, $dTiBu.default)(function() {
                        if (activeRef.current === targetKey) focusTargetElement.focus();
                    });
                }
            };
            if ([
                $6782197159192667$var$HOME,
                $6782197159192667$var$END
            ].includes(which) || offsetObj.sibling || !focusMenuElement) {
                // ========================== Sibling ==========================
                // Find walkable focus menu element container
                var parentQueryContainer;
                if (!focusMenuElement || mode === "inline") parentQueryContainer = containerRef.current;
                else parentQueryContainer = $6782197159192667$var$findContainerUL(focusMenuElement);
                // Get next focus element
                var targetElement;
                var focusableElements = $6782197159192667$export$433aaa1f216cf32d(parentQueryContainer, elements);
                if (which === $6782197159192667$var$HOME) targetElement = focusableElements[0];
                else if (which === $6782197159192667$var$END) targetElement = focusableElements[focusableElements.length - 1];
                else targetElement = $6782197159192667$var$getNextFocusElement(parentQueryContainer, elements, focusMenuElement, offsetObj.offset);
                // Focus menu item
                tryFocus(targetElement);
            // ======================= InlineTrigger =======================
            } else if (offsetObj.inlineTrigger) // Inline trigger no need switch to sub menu item
            triggerAccessibilityOpen(focusMenuKey);
            else if (offsetObj.offset > 0) {
                triggerAccessibilityOpen(focusMenuKey, true);
                cleanRaf();
                rafRef.current = (0, $dTiBu.default)(function() {
                    // Async should resync elements
                    refreshedElements = $6782197159192667$export$20827b68c762d23(keys, id);
                    var controlId = focusMenuElement.getAttribute("aria-controls");
                    var subQueryContainer = document.getElementById(controlId);
                    // Get sub focusable menu item
                    var targetElement = $6782197159192667$var$getNextFocusElement(subQueryContainer, refreshedElements.elements);
                    // Focus menu item
                    tryFocus(targetElement);
                }, 5);
            } else if (offsetObj.offset < 0) {
                var keyPath = getKeyPath(focusMenuKey, true);
                var parentKey = keyPath[keyPath.length - 2];
                var parentMenuElement = key2element.get(parentKey);
                // Focus menu item
                triggerAccessibilityOpen(parentKey, false);
                tryFocus(parentMenuElement);
            }
        }
        // Pass origin key down event
        originOnKeyDown === null || originOnKeyDown === void 0 || originOnKeyDown(e);
    };
}

});
parcelRegister("77reW", function(module, exports) {

$parcel$export(module.exports, "getFocusNodeList", () => $52ee51206a0899df$export$bbc7b5f11aba534b);

var $kbxxf = parcelRequire("kbxxf");

var $7klNq = parcelRequire("7klNq");
function $52ee51206a0899df$var$focusable(node) {
    var includePositive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if ((0, $7klNq.default)(node)) {
        var nodeName = node.nodeName.toLowerCase();
        var isFocusableElement = // Focusable element
        [
            "input",
            "select",
            "textarea",
            "button"
        ].includes(nodeName) || // Editable element
        node.isContentEditable || // Anchor with href element
        nodeName === "a" && !!node.getAttribute("href");
        // Get tabIndex
        var tabIndexAttr = node.getAttribute("tabindex");
        var tabIndexNum = Number(tabIndexAttr);
        // Parse as number if validate
        var tabIndex = null;
        if (tabIndexAttr && !Number.isNaN(tabIndexNum)) tabIndex = tabIndexNum;
        else if (isFocusableElement && tabIndex === null) tabIndex = 0;
        // Block focusable if disabled
        if (isFocusableElement && node.disabled) tabIndex = null;
        return tabIndex !== null && (tabIndex >= 0 || includePositive && tabIndex < 0);
    }
    return false;
}
function $52ee51206a0899df$export$bbc7b5f11aba534b(node) {
    var includePositive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var res = (0, $kbxxf.default)(node.querySelectorAll("*")).filter(function(child) {
        return $52ee51206a0899df$var$focusable(child, includePositive);
    });
    if ($52ee51206a0899df$var$focusable(node, includePositive)) res.unshift(node);
    return res;
}
var $52ee51206a0899df$var$lastFocusElement = null;
function $52ee51206a0899df$export$79fea02f7a83293d() {
    $52ee51206a0899df$var$lastFocusElement = document.activeElement;
}
function $52ee51206a0899df$export$8785654047fe7352() {
    $52ee51206a0899df$var$lastFocusElement = null;
}
function $52ee51206a0899df$export$fac0a9974415d98f() {
    if ($52ee51206a0899df$var$lastFocusElement) try {
        // 元素可能已经被移动了
        $52ee51206a0899df$var$lastFocusElement.focus();
    /* eslint-disable no-empty */ } catch (e) {
    // empty
    }
}
function $52ee51206a0899df$export$5717027f63f8addb(node, e) {
    if (e.keyCode === 9) {
        var tabNodeList = $52ee51206a0899df$export$bbc7b5f11aba534b(node);
        var lastTabNode = tabNodeList[e.shiftKey ? 0 : tabNodeList.length - 1];
        var leavingTab = lastTabNode === document.activeElement || node === document.activeElement;
        if (leavingTab) {
            var target = tabNodeList[e.shiftKey ? tabNodeList.length - 1 : 0];
            target.focus();
            e.preventDefault();
        }
    }
}

});


parcelRegister("cwnCS", function(module, exports) {

$parcel$export(module.exports, "OVERFLOW_KEY", () => $91daccd328800b8c$export$20a0132c46ce5b04);
$parcel$export(module.exports, "default", () => $91daccd328800b8c$export$2e2bcd8739ae039);

var $kbxxf = parcelRequire("kbxxf");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");
parcelRequire("u43uR");

var $4PkqS = parcelRequire("4PkqS");
var $91daccd328800b8c$var$PATH_SPLIT = "__RC_UTIL_PATH_SPLIT__";
var $91daccd328800b8c$var$getPathStr = function getPathStr(keyPath) {
    return keyPath.join($91daccd328800b8c$var$PATH_SPLIT);
};
var $91daccd328800b8c$var$getPathKeys = function getPathKeys(keyPathStr) {
    return keyPathStr.split($91daccd328800b8c$var$PATH_SPLIT);
};
var $91daccd328800b8c$export$20a0132c46ce5b04 = "rc-menu-more";
function $91daccd328800b8c$export$2e2bcd8739ae039() {
    var _React$useState = $acw62.useState({}), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), internalForceUpdate = _React$useState2[1];
    var key2pathRef = (0, $acw62.useRef)(new Map());
    var path2keyRef = (0, $acw62.useRef)(new Map());
    var _React$useState3 = $acw62.useState([]), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), overflowKeys = _React$useState4[0], setOverflowKeys = _React$useState4[1];
    var updateRef = (0, $acw62.useRef)(0);
    var destroyRef = (0, $acw62.useRef)(false);
    var forceUpdate = function forceUpdate() {
        if (!destroyRef.current) internalForceUpdate({});
    };
    var registerPath = (0, $acw62.useCallback)(function(key, keyPath) {
        // Fill map
        var connectedPath = $91daccd328800b8c$var$getPathStr(keyPath);
        path2keyRef.current.set(connectedPath, key);
        key2pathRef.current.set(key, connectedPath);
        updateRef.current += 1;
        var id = updateRef.current;
        (0, $4PkqS.nextSlice)(function() {
            if (id === updateRef.current) forceUpdate();
        });
    }, []);
    var unregisterPath = (0, $acw62.useCallback)(function(key, keyPath) {
        var connectedPath = $91daccd328800b8c$var$getPathStr(keyPath);
        path2keyRef.current.delete(connectedPath);
        key2pathRef.current.delete(key);
    }, []);
    var refreshOverflowKeys = (0, $acw62.useCallback)(function(keys) {
        setOverflowKeys(keys);
    }, []);
    var getKeyPath = (0, $acw62.useCallback)(function(eventKey, includeOverflow) {
        var fullPath = key2pathRef.current.get(eventKey) || "";
        var keys = $91daccd328800b8c$var$getPathKeys(fullPath);
        if (includeOverflow && overflowKeys.includes(keys[0])) keys.unshift($91daccd328800b8c$export$20a0132c46ce5b04);
        return keys;
    }, [
        overflowKeys
    ]);
    var isSubPathKey = (0, $acw62.useCallback)(function(pathKeys, eventKey) {
        return pathKeys.some(function(pathKey) {
            var pathKeyList = getKeyPath(pathKey, true);
            return pathKeyList.includes(eventKey);
        });
    }, [
        getKeyPath
    ]);
    var getKeys = function getKeys() {
        var keys = (0, $kbxxf.default)(key2pathRef.current.keys());
        if (overflowKeys.length) keys.push($91daccd328800b8c$export$20a0132c46ce5b04);
        return keys;
    };
    /**
   * Find current key related child path keys
   */ var getSubPathKeys = (0, $acw62.useCallback)(function(key) {
        var connectedPath = "".concat(key2pathRef.current.get(key)).concat($91daccd328800b8c$var$PATH_SPLIT);
        var pathKeys = new Set();
        (0, $kbxxf.default)(path2keyRef.current.keys()).forEach(function(pathKey) {
            if (pathKey.startsWith(connectedPath)) pathKeys.add(path2keyRef.current.get(pathKey));
        });
        return pathKeys;
    }, []);
    $acw62.useEffect(function() {
        return function() {
            destroyRef.current = true;
        };
    }, []);
    return {
        // Register
        registerPath: registerPath,
        unregisterPath: unregisterPath,
        refreshOverflowKeys: refreshOverflowKeys,
        // Util
        isSubPathKey: isSubPathKey,
        getKeyPath: getKeyPath,
        getKeys: getKeys,
        getSubPathKeys: getSubPathKeys
    };
}

});
parcelRegister("4PkqS", function(module, exports) {

$parcel$export(module.exports, "nextSlice", () => $383bc652cde1c429$export$7693db51ef834b40);
function $383bc652cde1c429$export$7693db51ef834b40(callback) {
    /* istanbul ignore next */ Promise.resolve().then(callback);
}

});


parcelRegister("lg5nd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f79f42a79a2878d1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $f79f42a79a2878d1$export$2e2bcd8739ae039(func) {
    var funRef = $acw62.useRef(func);
    funRef.current = func;
    var callback = $acw62.useCallback(function() {
        var _funRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_funRef$current = funRef.current) === null || _funRef$current === void 0 ? void 0 : _funRef$current.call.apply(_funRef$current, [
            funRef
        ].concat(args));
    }, []);
    return func ? callback : undefined;
}

});

parcelRegister("8krl6", function(module, exports) {

$parcel$export(module.exports, "default", () => $610565fd72f5965a$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $iSQh8 = parcelRequire("iSQh8");
var $610565fd72f5965a$var$uniquePrefix = Math.random().toFixed(5).toString().slice(2);
var $610565fd72f5965a$var$internalId = 0;
function $610565fd72f5965a$export$2e2bcd8739ae039(id) {
    var _useMergedState = (0, $iSQh8.default)(id, {
        value: id
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), uuid = _useMergedState2[0], setUUID = _useMergedState2[1];
    $acw62.useEffect(function() {
        $610565fd72f5965a$var$internalId += 1;
        var newId = "".concat($610565fd72f5965a$var$uniquePrefix, "-").concat($610565fd72f5965a$var$internalId);
        setUUID("rc-menu-uuid-".concat(newId));
    }, []);
    return uuid;
}

});

parcelRegister("gXR8t", function(module, exports) {

$parcel$export(module.exports, "default", () => $c59b5fb169e5cf0f$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $kbxxf = parcelRequire("kbxxf");

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $8g1PZ = parcelRequire("8g1PZ");

var $6dkAu = parcelRequire("6dkAu");

var $iCi4s = parcelRequire("iCi4s");

var $1pcHX = parcelRequire("1pcHX");

var $85dLH = parcelRequire("85dLH");

var $u43uR = parcelRequire("u43uR");

var $acw62 = parcelRequire("acw62");

var $dpnFa = parcelRequire("dpnFa");

var $392Az = parcelRequire("392Az");

var $a8XZl = parcelRequire("a8XZl");

var $iPTpg = parcelRequire("iPTpg");

var $eh9jt = parcelRequire("eh9jt");

var $7j6OO = parcelRequire("7j6OO");

var $gO591 = parcelRequire("gO591");

var $1zp6Q = parcelRequire("1zp6Q");
var $c59b5fb169e5cf0f$var$_excluded = [
    "title",
    "attribute",
    "elementRef"
], $c59b5fb169e5cf0f$var$_excluded2 = [
    "style",
    "className",
    "eventKey",
    "warnKey",
    "disabled",
    "itemIcon",
    "children",
    "role",
    "onMouseEnter",
    "onMouseLeave",
    "onClick",
    "onKeyDown",
    "onFocus"
], $c59b5fb169e5cf0f$var$_excluded3 = [
    "active"
];
// Since Menu event provide the `info.item` which point to the MenuItem node instance.
// We have to use class component here.
// This should be removed from doc & api in future.
var $c59b5fb169e5cf0f$var$LegacyMenuItem = /*#__PURE__*/ function(_React$Component) {
    (0, $1gYAD.default)(LegacyMenuItem, _React$Component);
    var _super = (0, $enfmq.default)(LegacyMenuItem);
    function LegacyMenuItem() {
        (0, $6CZeq.default)(this, LegacyMenuItem);
        return _super.apply(this, arguments);
    }
    (0, $cHPF9.default)(LegacyMenuItem, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, title = _this$props.title, attribute = _this$props.attribute, elementRef = _this$props.elementRef, restProps = (0, $9X7IJ.default)(_this$props, $c59b5fb169e5cf0f$var$_excluded);
                // Here the props are eventually passed to the DOM element.
                // React does not recognize non-standard attributes.
                // Therefore, remove the props that is not used here.
                // ref: https://github.com/ant-design/ant-design/issues/41395
                var passedProps = (0, $1pcHX.default)(restProps, [
                    "eventKey",
                    "popupClassName",
                    "popupOffset",
                    "onTitleClick"
                ]);
                (0, $u43uR.default)(!attribute, "`attribute` of Menu.Item is deprecated. Please pass attribute directly.");
                return /*#__PURE__*/ $acw62.createElement((0, $6dkAu.default).Item, (0, $8nd05.default)({}, attribute, {
                    title: typeof title === "string" ? title : undefined
                }, passedProps, {
                    ref: elementRef
                }));
            }
        }
    ]);
    return LegacyMenuItem;
}($acw62.Component);
/**
 * Real Menu Item component
 */ var $c59b5fb169e5cf0f$var$InternalMenuItem = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _classNames;
    var style = props.style, className = props.className, eventKey = props.eventKey, warnKey = props.warnKey, disabled = props.disabled, itemIcon = props.itemIcon, children = props.children, role = props.role, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onClick = props.onClick, onKeyDown = props.onKeyDown, onFocus = props.onFocus, restProps = (0, $9X7IJ.default)(props, $c59b5fb169e5cf0f$var$_excluded2);
    var domDataId = (0, $dpnFa.useMenuId)(eventKey);
    var _React$useContext = $acw62.useContext((0, $392Az.MenuContext)), prefixCls = _React$useContext.prefixCls, onItemClick = _React$useContext.onItemClick, contextDisabled = _React$useContext.disabled, overflowDisabled = _React$useContext.overflowDisabled, contextItemIcon = _React$useContext.itemIcon, selectedKeys = _React$useContext.selectedKeys, onActive = _React$useContext.onActive;
    var _React$useContext2 = $acw62.useContext((0, $iPTpg.default)), _internalRenderMenuItem = _React$useContext2._internalRenderMenuItem;
    var itemCls = "".concat(prefixCls, "-item");
    var legacyMenuItemRef = $acw62.useRef();
    var elementRef = $acw62.useRef();
    var mergedDisabled = contextDisabled || disabled;
    var mergedEleRef = (0, $85dLH.useComposeRef)(ref, elementRef);
    var connectedKeys = (0, $a8XZl.useFullPath)(eventKey);
    // ============================= Info =============================
    var getEventInfo = function getEventInfo(e) {
        return {
            key: eventKey,
            // Note: For legacy code is reversed which not like other antd component
            keyPath: (0, $kbxxf.default)(connectedKeys).reverse(),
            item: legacyMenuItemRef.current,
            domEvent: e
        };
    };
    // ============================= Icon =============================
    var mergedItemIcon = itemIcon || contextItemIcon;
    // ============================ Active ============================
    var _useActive = (0, $eh9jt.default)(eventKey, mergedDisabled, onMouseEnter, onMouseLeave), active = _useActive.active, activeProps = (0, $9X7IJ.default)(_useActive, $c59b5fb169e5cf0f$var$_excluded3);
    // ============================ Select ============================
    var selected = selectedKeys.includes(eventKey);
    // ======================== DirectionStyle ========================
    var directionStyle = (0, $7j6OO.default)(connectedKeys.length);
    // ============================ Events ============================
    var onInternalClick = function onInternalClick(e) {
        if (mergedDisabled) return;
        var info = getEventInfo(e);
        onClick === null || onClick === void 0 || onClick((0, $1zp6Q.warnItemProp)(info));
        onItemClick(info);
    };
    var onInternalKeyDown = function onInternalKeyDown(e) {
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
        if (e.which === (0, $iCi4s.default).ENTER) {
            var info = getEventInfo(e);
            // Legacy. Key will also trigger click event
            onClick === null || onClick === void 0 || onClick((0, $1zp6Q.warnItemProp)(info));
            onItemClick(info);
        }
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ var onInternalFocus = function onInternalFocus(e) {
        onActive(eventKey);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    // ============================ Render ============================
    var optionRoleProps = {};
    if (props.role === "option") optionRoleProps["aria-selected"] = selected;
    var renderNode = /*#__PURE__*/ $acw62.createElement($c59b5fb169e5cf0f$var$LegacyMenuItem, (0, $8nd05.default)({
        ref: legacyMenuItemRef,
        elementRef: mergedEleRef,
        role: role === null ? "none" : role || "menuitem",
        tabIndex: disabled ? null : -1,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId
    }, restProps, activeProps, optionRoleProps, {
        component: "li",
        "aria-disabled": disabled,
        style: (0, $d49SP.default)((0, $d49SP.default)({}, directionStyle), style),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(itemCls, (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(itemCls, "-active"), active), (0, $kSlfw.default)(_classNames, "".concat(itemCls, "-selected"), selected), (0, $kSlfw.default)(_classNames, "".concat(itemCls, "-disabled"), mergedDisabled), _classNames), className),
        onClick: onInternalClick,
        onKeyDown: onInternalKeyDown,
        onFocus: onInternalFocus
    }), children, /*#__PURE__*/ $acw62.createElement((0, $gO591.default), {
        props: (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
            isSelected: selected
        }),
        icon: mergedItemIcon
    }));
    if (_internalRenderMenuItem) renderNode = _internalRenderMenuItem(renderNode, props, {
        selected: selected
    });
    return renderNode;
});
function $c59b5fb169e5cf0f$var$MenuItem(props, ref) {
    var eventKey = props.eventKey;
    // ==================== Record KeyPath ====================
    var measure = (0, $a8XZl.useMeasure)();
    var connectedKeyPath = (0, $a8XZl.useFullPath)(eventKey);
    // eslint-disable-next-line consistent-return
    $acw62.useEffect(function() {
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return function() {
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    if (measure) return null;
    // ======================== Render ========================
    return /*#__PURE__*/ $acw62.createElement($c59b5fb169e5cf0f$var$InternalMenuItem, (0, $8nd05.default)({}, props, {
        ref: ref
    }));
}
var $c59b5fb169e5cf0f$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($c59b5fb169e5cf0f$var$MenuItem);

});
parcelRegister("eh9jt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a649e094df404c52$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $392Az = parcelRequire("392Az");
function $a649e094df404c52$export$2e2bcd8739ae039(eventKey, disabled, onMouseEnter, onMouseLeave) {
    var _React$useContext = $acw62.useContext((0, $392Az.MenuContext)), activeKey = _React$useContext.activeKey, onActive = _React$useContext.onActive, onInactive = _React$useContext.onInactive;
    var ret = {
        active: activeKey === eventKey
    };
    // Skip when disabled
    if (!disabled) {
        ret.onMouseEnter = function(domEvent) {
            onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter({
                key: eventKey,
                domEvent: domEvent
            });
            onActive(eventKey);
        };
        ret.onMouseLeave = function(domEvent) {
            onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave({
                key: eventKey,
                domEvent: domEvent
            });
            onInactive(eventKey);
        };
    }
    return ret;
}

});

parcelRegister("7j6OO", function(module, exports) {

$parcel$export(module.exports, "default", () => $551f98bff3692876$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $392Az = parcelRequire("392Az");
function $551f98bff3692876$export$2e2bcd8739ae039(level) {
    var _React$useContext = $acw62.useContext((0, $392Az.MenuContext)), mode = _React$useContext.mode, rtl = _React$useContext.rtl, inlineIndent = _React$useContext.inlineIndent;
    if (mode !== "inline") return null;
    var len = level;
    return rtl ? {
        paddingRight: len * inlineIndent
    } : {
        paddingLeft: len * inlineIndent
    };
}

});

parcelRegister("gO591", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3c54e71b725e1ff$export$2e2bcd8739ae039);

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
function $c3c54e71b725e1ff$export$2e2bcd8739ae039(_ref) {
    var icon = _ref.icon, props = _ref.props, children = _ref.children;
    var iconNode;
    if (icon === null || icon === false) return null;
    if (typeof icon === "function") iconNode = /*#__PURE__*/ $acw62.createElement(icon, (0, $d49SP.default)({}, props));
    else if (typeof icon !== "boolean") // Compatible for origin definition
    iconNode = icon;
    return iconNode || children || null;
}

});

parcelRegister("1zp6Q", function(module, exports) {

$parcel$export(module.exports, "warnItemProp", () => $124c89870f2be225$export$e189bcd94b66c1db);

var $9X7IJ = parcelRequire("9X7IJ");

var $u43uR = parcelRequire("u43uR");
var $124c89870f2be225$var$_excluded = [
    "item"
];
function $124c89870f2be225$export$e189bcd94b66c1db(_ref) {
    var item = _ref.item, restInfo = (0, $9X7IJ.default)(_ref, $124c89870f2be225$var$_excluded);
    Object.defineProperty(restInfo, "item", {
        get: function get() {
            (0, $u43uR.default)(false, "`info.item` is deprecated since we will move to function component that not provides React Node instance in future.");
            return item;
        }
    });
    return restInfo;
}

});


parcelRegister("gASnm", function(module, exports) {

$parcel$export(module.exports, "default", () => $c14a300ca0685832$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $6dkAu = parcelRequire("6dkAu");
parcelRequire("u43uR");

var $eRb58 = parcelRequire("eRb58");

var $1OIm3 = parcelRequire("1OIm3");

var $392Az = parcelRequire("392Az");

var $lg5nd = parcelRequire("lg5nd");

var $cUQRe = parcelRequire("cUQRe");

var $gO591 = parcelRequire("gO591");

var $eh9jt = parcelRequire("eh9jt");

var $1zp6Q = parcelRequire("1zp6Q");

var $7j6OO = parcelRequire("7j6OO");

var $1pNez = parcelRequire("1pNez");

var $a8XZl = parcelRequire("a8XZl");

var $dpnFa = parcelRequire("dpnFa");

var $iPTpg = parcelRequire("iPTpg");
var $c14a300ca0685832$var$_excluded = [
    "style",
    "className",
    "title",
    "eventKey",
    "warnKey",
    "disabled",
    "internalPopupClose",
    "children",
    "itemIcon",
    "expandIcon",
    "popupClassName",
    "popupOffset",
    "popupStyle",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onTitleClick",
    "onTitleMouseEnter",
    "onTitleMouseLeave"
], $c14a300ca0685832$var$_excluded2 = [
    "active"
];
var $c14a300ca0685832$var$InternalSubMenu = function InternalSubMenu(props) {
    var _classNames;
    var style = props.style, className = props.className, title = props.title, eventKey = props.eventKey, warnKey = props.warnKey, disabled = props.disabled, internalPopupClose = props.internalPopupClose, children = props.children, itemIcon = props.itemIcon, expandIcon = props.expandIcon, popupClassName = props.popupClassName, popupOffset = props.popupOffset, popupStyle = props.popupStyle, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onTitleClick = props.onTitleClick, onTitleMouseEnter = props.onTitleMouseEnter, onTitleMouseLeave = props.onTitleMouseLeave, restProps = (0, $9X7IJ.default)(props, $c14a300ca0685832$var$_excluded);
    var domDataId = (0, $dpnFa.useMenuId)(eventKey);
    var _React$useContext = $acw62.useContext((0, $392Az.MenuContext)), prefixCls = _React$useContext.prefixCls, mode = _React$useContext.mode, openKeys = _React$useContext.openKeys, contextDisabled = _React$useContext.disabled, overflowDisabled = _React$useContext.overflowDisabled, activeKey = _React$useContext.activeKey, selectedKeys = _React$useContext.selectedKeys, contextItemIcon = _React$useContext.itemIcon, contextExpandIcon = _React$useContext.expandIcon, onItemClick = _React$useContext.onItemClick, onOpenChange = _React$useContext.onOpenChange, onActive = _React$useContext.onActive;
    var _React$useContext2 = $acw62.useContext((0, $iPTpg.default)), _internalRenderSubMenuItem = _React$useContext2._internalRenderSubMenuItem;
    var _React$useContext3 = $acw62.useContext((0, $a8XZl.PathUserContext)), isSubPathKey = _React$useContext3.isSubPathKey;
    var connectedPath = (0, $a8XZl.useFullPath)();
    var subMenuPrefixCls = "".concat(prefixCls, "-submenu");
    var mergedDisabled = contextDisabled || disabled;
    var elementRef = $acw62.useRef();
    var popupRef = $acw62.useRef();
    // ================================ Icon ================================
    var mergedItemIcon = itemIcon !== null && itemIcon !== void 0 ? itemIcon : contextItemIcon;
    var mergedExpandIcon = expandIcon !== null && expandIcon !== void 0 ? expandIcon : contextExpandIcon;
    // ================================ Open ================================
    var originOpen = openKeys.includes(eventKey);
    var open = !overflowDisabled && originOpen;
    // =============================== Select ===============================
    var childrenSelected = isSubPathKey(selectedKeys, eventKey);
    // =============================== Active ===============================
    var _useActive = (0, $eh9jt.default)(eventKey, mergedDisabled, onTitleMouseEnter, onTitleMouseLeave), active = _useActive.active, activeProps = (0, $9X7IJ.default)(_useActive, $c14a300ca0685832$var$_excluded2);
    // Fallback of active check to avoid hover on menu title or disabled item
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), childrenActive = _React$useState2[0], setChildrenActive = _React$useState2[1];
    var triggerChildrenActive = function triggerChildrenActive(newActive) {
        if (!mergedDisabled) setChildrenActive(newActive);
    };
    var onInternalMouseEnter = function onInternalMouseEnter(domEvent) {
        triggerChildrenActive(true);
        onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter({
            key: eventKey,
            domEvent: domEvent
        });
    };
    var onInternalMouseLeave = function onInternalMouseLeave(domEvent) {
        triggerChildrenActive(false);
        onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave({
            key: eventKey,
            domEvent: domEvent
        });
    };
    var mergedActive = $acw62.useMemo(function() {
        if (active) return active;
        if (mode !== "inline") return childrenActive || isSubPathKey([
            activeKey
        ], eventKey);
        return false;
    }, [
        mode,
        active,
        activeKey,
        childrenActive,
        eventKey,
        isSubPathKey
    ]);
    // ========================== DirectionStyle ==========================
    var directionStyle = (0, $7j6OO.default)(connectedPath.length);
    // =============================== Events ===============================
    // >>>> Title click
    var onInternalTitleClick = function onInternalTitleClick(e) {
        // Skip if disabled
        if (mergedDisabled) return;
        onTitleClick === null || onTitleClick === void 0 || onTitleClick({
            key: eventKey,
            domEvent: e
        });
        // Trigger open by click when mode is `inline`
        if (mode === "inline") onOpenChange(eventKey, !originOpen);
    };
    // >>>> Context for children click
    var onMergedItemClick = (0, $lg5nd.default)(function(info) {
        onClick === null || onClick === void 0 || onClick((0, $1zp6Q.warnItemProp)(info));
        onItemClick(info);
    });
    // >>>>> Visible change
    var onPopupVisibleChange = function onPopupVisibleChange(newVisible) {
        if (mode !== "inline") onOpenChange(eventKey, newVisible);
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ var onInternalFocus = function onInternalFocus() {
        onActive(eventKey);
    };
    // =============================== Render ===============================
    var popupId = domDataId && "".concat(domDataId, "-popup");
    // >>>>> Title
    var titleNode = /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        role: "menuitem",
        style: directionStyle,
        className: "".concat(subMenuPrefixCls, "-title"),
        tabIndex: mergedDisabled ? null : -1,
        ref: elementRef,
        title: typeof title === "string" ? title : null,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId,
        "aria-expanded": open,
        "aria-haspopup": true,
        "aria-controls": popupId,
        "aria-disabled": mergedDisabled,
        onClick: onInternalTitleClick,
        onFocus: onInternalFocus
    }, activeProps), title, /*#__PURE__*/ $acw62.createElement((0, $gO591.default), {
        icon: mode !== "horizontal" ? mergedExpandIcon : undefined,
        props: (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
            isOpen: open,
            // [Legacy] Not sure why need this mark
            isSubMenu: true
        })
    }, /*#__PURE__*/ $acw62.createElement("i", {
        className: "".concat(subMenuPrefixCls, "-arrow")
    })));
    // Cache mode if it change to `inline` which do not have popup motion
    var triggerModeRef = $acw62.useRef(mode);
    if (mode !== "inline" && connectedPath.length > 1) triggerModeRef.current = "vertical";
    else triggerModeRef.current = mode;
    if (!overflowDisabled) {
        var triggerMode = triggerModeRef.current;
        // Still wrap with Trigger here since we need avoid react re-mount dom node
        // Which makes motion failed
        titleNode = /*#__PURE__*/ $acw62.createElement((0, $cUQRe.default), {
            mode: triggerMode,
            prefixCls: subMenuPrefixCls,
            visible: !internalPopupClose && open && mode !== "inline",
            popupClassName: popupClassName,
            popupOffset: popupOffset,
            popupStyle: popupStyle,
            popup: /*#__PURE__*/ $acw62.createElement((0, $392Az.default), {
                mode: triggerMode === "horizontal" ? "vertical" : triggerMode
            }, /*#__PURE__*/ $acw62.createElement((0, $eRb58.default), {
                id: popupId,
                ref: popupRef
            }, children)),
            disabled: mergedDisabled,
            onVisibleChange: onPopupVisibleChange
        }, titleNode);
    }
    // >>>>> List node
    var listNode = /*#__PURE__*/ $acw62.createElement((0, $6dkAu.default).Item, (0, $8nd05.default)({
        role: "none"
    }, restProps, {
        component: "li",
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(subMenuPrefixCls, "".concat(subMenuPrefixCls, "-").concat(mode), className, (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(subMenuPrefixCls, "-open"), open), (0, $kSlfw.default)(_classNames, "".concat(subMenuPrefixCls, "-active"), mergedActive), (0, $kSlfw.default)(_classNames, "".concat(subMenuPrefixCls, "-selected"), childrenSelected), (0, $kSlfw.default)(_classNames, "".concat(subMenuPrefixCls, "-disabled"), mergedDisabled), _classNames)),
        onMouseEnter: onInternalMouseEnter,
        onMouseLeave: onInternalMouseLeave
    }), titleNode, !overflowDisabled && /*#__PURE__*/ $acw62.createElement((0, $1pNez.default), {
        id: popupId,
        open: open,
        keyPath: connectedPath
    }, children));
    if (_internalRenderSubMenuItem) listNode = _internalRenderSubMenuItem(listNode, props, {
        selected: childrenSelected,
        active: mergedActive,
        open: open,
        disabled: mergedDisabled
    });
    // >>>>> Render
    return /*#__PURE__*/ $acw62.createElement((0, $392Az.default), {
        onItemClick: onMergedItemClick,
        mode: mode === "horizontal" ? "vertical" : mode,
        itemIcon: mergedItemIcon,
        expandIcon: mergedExpandIcon
    }, listNode);
};
function $c14a300ca0685832$export$2e2bcd8739ae039(props) {
    var eventKey = props.eventKey, children = props.children;
    var connectedKeyPath = (0, $a8XZl.useFullPath)(eventKey);
    var childList = (0, $1OIm3.parseChildren)(children, connectedKeyPath);
    // ==================== Record KeyPath ====================
    var measure = (0, $a8XZl.useMeasure)();
    // eslint-disable-next-line consistent-return
    $acw62.useEffect(function() {
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return function() {
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    var renderNode;
    // ======================== Render ========================
    if (measure) renderNode = childList;
    else renderNode = /*#__PURE__*/ $acw62.createElement($c14a300ca0685832$var$InternalSubMenu, props, childList);
    return /*#__PURE__*/ $acw62.createElement((0, $a8XZl.PathTrackerContext).Provider, {
        value: connectedKeyPath
    }, renderNode);
}

});
parcelRegister("eRb58", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad0e9c8fde51e397$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $392Az = parcelRequire("392Az");
var $ad0e9c8fde51e397$var$_excluded = [
    "className",
    "children"
];
var $ad0e9c8fde51e397$var$InternalSubMenuList = function InternalSubMenuList(_ref, ref) {
    var className = _ref.className, children = _ref.children, restProps = (0, $9X7IJ.default)(_ref, $ad0e9c8fde51e397$var$_excluded);
    var _React$useContext = $acw62.useContext((0, $392Az.MenuContext)), prefixCls = _React$useContext.prefixCls, mode = _React$useContext.mode, rtl = _React$useContext.rtl;
    return /*#__PURE__*/ $acw62.createElement("ul", (0, $8nd05.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, rtl && "".concat(prefixCls, "-rtl"), "".concat(prefixCls, "-sub"), "".concat(prefixCls, "-").concat(mode === "inline" ? "inline" : "vertical"), className),
        role: "menu"
    }, restProps, {
        "data-menu-list": true,
        ref: ref
    }), children);
};
var $ad0e9c8fde51e397$var$SubMenuList = /*#__PURE__*/ $acw62.forwardRef($ad0e9c8fde51e397$var$InternalSubMenuList);
$ad0e9c8fde51e397$var$SubMenuList.displayName = "SubMenuList";
var $ad0e9c8fde51e397$export$2e2bcd8739ae039 = $ad0e9c8fde51e397$var$SubMenuList;

});

parcelRegister("1OIm3", function(module, exports) {

$parcel$export(module.exports, "parseChildren", () => $152cdddbd0a33c22$export$cd230e97e668be9);

var $kbxxf = parcelRequire("kbxxf");

var $jWR62 = parcelRequire("jWR62");

var $acw62 = parcelRequire("acw62");
function $152cdddbd0a33c22$export$cd230e97e668be9(children, keyPath) {
    return (0, $jWR62.default)(children).map(function(child, index) {
        if (/*#__PURE__*/ $acw62.isValidElement(child)) {
            var _eventKey, _child$props;
            var key = child.key;
            var eventKey = (_eventKey = (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.eventKey) !== null && _eventKey !== void 0 ? _eventKey : key;
            var emptyKey = eventKey === null || eventKey === undefined;
            if (emptyKey) eventKey = "tmp_key-".concat([].concat((0, $kbxxf.default)(keyPath), [
                index
            ]).join("-"));
            var cloneProps = {
                key: eventKey,
                eventKey: eventKey
            };
            return /*#__PURE__*/ $acw62.cloneElement(child, cloneProps);
        }
        return child;
    });
}

});

parcelRegister("cUQRe", function(module, exports) {

$parcel$export(module.exports, "default", () => $9673b769529d0dd1$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $eyPR1 = parcelRequire("eyPR1");

var $8g1PZ = parcelRequire("8g1PZ");

var $dTiBu = parcelRequire("dTiBu");

var $392Az = parcelRequire("392Az");

var $hNP9x = parcelRequire("hNP9x");

var $eDaQ3 = parcelRequire("eDaQ3");
var $9673b769529d0dd1$var$popupPlacementMap = {
    horizontal: "bottomLeft",
    vertical: "rightTop",
    "vertical-left": "rightTop",
    "vertical-right": "leftTop"
};
function $9673b769529d0dd1$export$2e2bcd8739ae039(_ref) {
    var prefixCls = _ref.prefixCls, visible = _ref.visible, children = _ref.children, popup = _ref.popup, popupStyle = _ref.popupStyle, popupClassName = _ref.popupClassName, popupOffset = _ref.popupOffset, disabled = _ref.disabled, mode = _ref.mode, onVisibleChange = _ref.onVisibleChange;
    var _React$useContext = $acw62.useContext((0, $392Az.MenuContext)), getPopupContainer = _React$useContext.getPopupContainer, rtl = _React$useContext.rtl, subMenuOpenDelay = _React$useContext.subMenuOpenDelay, subMenuCloseDelay = _React$useContext.subMenuCloseDelay, builtinPlacements = _React$useContext.builtinPlacements, triggerSubMenuAction = _React$useContext.triggerSubMenuAction, forceSubMenuRender = _React$useContext.forceSubMenuRender, rootClassName = _React$useContext.rootClassName, motion = _React$useContext.motion, defaultMotions = _React$useContext.defaultMotions;
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), innerVisible = _React$useState2[0], setInnerVisible = _React$useState2[1];
    var placement = rtl ? (0, $d49SP.default)((0, $d49SP.default)({}, (0, $hNP9x.placementsRtl)), builtinPlacements) : (0, $d49SP.default)((0, $d49SP.default)({}, (0, $hNP9x.placements)), builtinPlacements);
    var popupPlacement = $9673b769529d0dd1$var$popupPlacementMap[mode];
    var targetMotion = (0, $eDaQ3.getMotion)(mode, motion, defaultMotions);
    var targetMotionRef = $acw62.useRef(targetMotion);
    if (mode !== "inline") /**
     * PopupTrigger is only used for vertical and horizontal types.
     * When collapsed is unfolded, the inline animation will destroy the vertical animation.
     */ targetMotionRef.current = targetMotion;
    var mergedMotion = (0, $d49SP.default)((0, $d49SP.default)({}, targetMotionRef.current), {}, {
        leavedClassName: "".concat(prefixCls, "-hidden"),
        removeOnLeave: false,
        motionAppear: true
    });
    // Delay to change visible
    var visibleRef = $acw62.useRef();
    $acw62.useEffect(function() {
        visibleRef.current = (0, $dTiBu.default)(function() {
            setInnerVisible(visible);
        });
        return function() {
            (0, $dTiBu.default).cancel(visibleRef.current);
        };
    }, [
        visible
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $eyPR1.default), {
        prefixCls: prefixCls,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-popup"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-rtl"), rtl), popupClassName, rootClassName),
        stretch: mode === "horizontal" ? "minWidth" : null,
        getPopupContainer: getPopupContainer,
        builtinPlacements: placement,
        popupPlacement: popupPlacement,
        popupVisible: innerVisible,
        popup: popup,
        popupStyle: popupStyle,
        popupAlign: popupOffset && {
            offset: popupOffset
        },
        action: disabled ? [] : [
            triggerSubMenuAction
        ],
        mouseEnterDelay: subMenuOpenDelay,
        mouseLeaveDelay: subMenuCloseDelay,
        onPopupVisibleChange: onVisibleChange,
        forceRender: forceSubMenuRender,
        popupMotion: mergedMotion,
        fresh: true
    }, children);
}

});
parcelRegister("hNP9x", function(module, exports) {

$parcel$export(module.exports, "placements", () => $cf5eb12962f7aceb$export$803cd8101b6c182b);
$parcel$export(module.exports, "placementsRtl", () => $cf5eb12962f7aceb$export$e2b3f69b0a16e1f);
var $cf5eb12962f7aceb$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $cf5eb12962f7aceb$export$803cd8101b6c182b = {
    topLeft: {
        points: [
            "bl",
            "tl"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    topRight: {
        points: [
            "br",
            "tr"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    leftTop: {
        points: [
            "tr",
            "tl"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    leftBottom: {
        points: [
            "br",
            "bl"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    rightTop: {
        points: [
            "tl",
            "tr"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    rightBottom: {
        points: [
            "bl",
            "br"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    }
};
var $cf5eb12962f7aceb$export$e2b3f69b0a16e1f = {
    topLeft: {
        points: [
            "bl",
            "tl"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    topRight: {
        points: [
            "br",
            "tr"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    rightTop: {
        points: [
            "tr",
            "tl"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    rightBottom: {
        points: [
            "br",
            "bl"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    leftTop: {
        points: [
            "tl",
            "tr"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    leftBottom: {
        points: [
            "bl",
            "br"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    }
};
var $cf5eb12962f7aceb$export$2e2bcd8739ae039 = $cf5eb12962f7aceb$export$803cd8101b6c182b;

});

parcelRegister("eDaQ3", function(module, exports) {

$parcel$export(module.exports, "getMotion", () => $aa6d1d843f423253$export$7b8936ddc277a29a);
function $aa6d1d843f423253$export$7b8936ddc277a29a(mode, motion, defaultMotions) {
    if (motion) return motion;
    if (defaultMotions) return defaultMotions[mode] || defaultMotions.other;
    return undefined;
}

});


parcelRegister("1pNez", function(module, exports) {

$parcel$export(module.exports, "default", () => $107e5113551bc6e9$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $8iiJy = parcelRequire("8iiJy");

var $eDaQ3 = parcelRequire("eDaQ3");

var $392Az = parcelRequire("392Az");

var $eRb58 = parcelRequire("eRb58");
function $107e5113551bc6e9$export$2e2bcd8739ae039(_ref) {
    var id = _ref.id, open = _ref.open, keyPath = _ref.keyPath, children = _ref.children;
    var fixedMode = "inline";
    var _React$useContext = $acw62.useContext((0, $392Az.MenuContext)), prefixCls = _React$useContext.prefixCls, forceSubMenuRender = _React$useContext.forceSubMenuRender, motion = _React$useContext.motion, defaultMotions = _React$useContext.defaultMotions, mode = _React$useContext.mode;
    // Always use latest mode check
    var sameModeRef = $acw62.useRef(false);
    sameModeRef.current = mode === fixedMode;
    // We record `destroy` mark here since when mode change from `inline` to others.
    // The inline list should remove when motion end.
    var _React$useState = $acw62.useState(!sameModeRef.current), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), destroy = _React$useState2[0], setDestroy = _React$useState2[1];
    var mergedOpen = sameModeRef.current ? open : false;
    // ================================= Effect =================================
    // Reset destroy state when mode change back
    $acw62.useEffect(function() {
        if (sameModeRef.current) setDestroy(false);
    }, [
        mode
    ]);
    // ================================= Render =================================
    var mergedMotion = (0, $d49SP.default)({}, (0, $eDaQ3.getMotion)(fixedMode, motion, defaultMotions));
    // No need appear since nest inlineCollapse changed
    if (keyPath.length > 1) mergedMotion.motionAppear = false;
    // Hide inline list when mode changed and motion end
    var originOnVisibleChanged = mergedMotion.onVisibleChanged;
    mergedMotion.onVisibleChanged = function(newVisible) {
        if (!sameModeRef.current && !newVisible) setDestroy(true);
        return originOnVisibleChanged === null || originOnVisibleChanged === void 0 ? void 0 : originOnVisibleChanged(newVisible);
    };
    if (destroy) return null;
    return /*#__PURE__*/ $acw62.createElement((0, $392Az.default), {
        mode: fixedMode,
        locked: !sameModeRef.current
    }, /*#__PURE__*/ $acw62.createElement((0, $8iiJy.default), (0, $8nd05.default)({
        visible: mergedOpen
    }, mergedMotion, {
        forceRender: forceSubMenuRender,
        removeOnLeave: false,
        leavedClassName: "".concat(prefixCls, "-hidden")
    }), function(_ref2) {
        var motionClassName = _ref2.className, motionStyle = _ref2.style;
        return /*#__PURE__*/ $acw62.createElement((0, $eRb58.default), {
            id: id,
            className: motionClassName,
            style: motionStyle
        }, children);
    }));
}

});


parcelRegister("lvs07", function(module, exports) {

$parcel$export(module.exports, "parseItems", () => $fa82369bcec373f6$export$50458dc1a9a0f894);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $fSwVM = parcelRequire("fSwVM");

var $acw62 = parcelRequire("acw62");

var $9TcXG = parcelRequire("9TcXG");

var $gASnm = parcelRequire("gASnm");

var $iPQJN = parcelRequire("iPQJN");

var $gXR8t = parcelRequire("gXR8t");

var $1OIm3 = parcelRequire("1OIm3");
var $fa82369bcec373f6$var$_excluded = [
    "label",
    "children",
    "key",
    "type"
];
function $fa82369bcec373f6$var$convertItemsToNodes(list) {
    return (list || []).map(function(opt, index) {
        if (opt && (0, $fSwVM.default)(opt) === "object") {
            var _ref = opt, label = _ref.label, children = _ref.children, key = _ref.key, type = _ref.type, restProps = (0, $9X7IJ.default)(_ref, $fa82369bcec373f6$var$_excluded);
            var mergedKey = key !== null && key !== void 0 ? key : "tmp-".concat(index);
            // MenuItemGroup & SubMenuItem
            if (children || type === "group") {
                if (type === "group") // Group
                return /*#__PURE__*/ $acw62.createElement((0, $9TcXG.default), (0, $8nd05.default)({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $fa82369bcec373f6$var$convertItemsToNodes(children));
                // Sub Menu
                return /*#__PURE__*/ $acw62.createElement((0, $gASnm.default), (0, $8nd05.default)({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $fa82369bcec373f6$var$convertItemsToNodes(children));
            }
            // MenuItem & Divider
            if (type === "divider") return /*#__PURE__*/ $acw62.createElement((0, $iPQJN.default), (0, $8nd05.default)({
                key: mergedKey
            }, restProps));
            return /*#__PURE__*/ $acw62.createElement((0, $gXR8t.default), (0, $8nd05.default)({
                key: mergedKey
            }, restProps), label);
        }
        return null;
    }).filter(function(opt) {
        return opt;
    });
}
function $fa82369bcec373f6$export$50458dc1a9a0f894(children, items, keyPath) {
    var childNodes = children;
    if (items) childNodes = $fa82369bcec373f6$var$convertItemsToNodes(items);
    return (0, $1OIm3.parseChildren)(childNodes, keyPath);
}

});
parcelRegister("9TcXG", function(module, exports) {

$parcel$export(module.exports, "default", () => $73334e01b4c90e74$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $8g1PZ = parcelRequire("8g1PZ");

var $1pcHX = parcelRequire("1pcHX");

var $acw62 = parcelRequire("acw62");

var $392Az = parcelRequire("392Az");

var $a8XZl = parcelRequire("a8XZl");

var $1OIm3 = parcelRequire("1OIm3");
var $73334e01b4c90e74$var$_excluded = [
    "className",
    "title",
    "eventKey",
    "children"
], $73334e01b4c90e74$var$_excluded2 = [
    "children"
];
var $73334e01b4c90e74$var$InternalMenuItemGroup = function InternalMenuItemGroup(_ref) {
    var className = _ref.className, title = _ref.title, eventKey = _ref.eventKey, children = _ref.children, restProps = (0, $9X7IJ.default)(_ref, $73334e01b4c90e74$var$_excluded);
    var _React$useContext = $acw62.useContext((0, $392Az.MenuContext)), prefixCls = _React$useContext.prefixCls;
    var groupPrefixCls = "".concat(prefixCls, "-item-group");
    return /*#__PURE__*/ $acw62.createElement("li", (0, $8nd05.default)({
        role: "presentation"
    }, restProps, {
        onClick: function onClick(e) {
            return e.stopPropagation();
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(groupPrefixCls, className)
    }), /*#__PURE__*/ $acw62.createElement("div", {
        role: "presentation",
        className: "".concat(groupPrefixCls, "-title"),
        title: typeof title === "string" ? title : undefined
    }, title), /*#__PURE__*/ $acw62.createElement("ul", {
        role: "group",
        className: "".concat(groupPrefixCls, "-list")
    }, children));
};
function $73334e01b4c90e74$export$2e2bcd8739ae039(_ref2) {
    var children = _ref2.children, props = (0, $9X7IJ.default)(_ref2, $73334e01b4c90e74$var$_excluded2);
    var connectedKeyPath = (0, $a8XZl.useFullPath)(props.eventKey);
    var childList = (0, $1OIm3.parseChildren)(children, connectedKeyPath);
    var measure = (0, $a8XZl.useMeasure)();
    if (measure) return childList;
    return /*#__PURE__*/ $acw62.createElement($73334e01b4c90e74$var$InternalMenuItemGroup, (0, $1pcHX.default)(props, [
        "warnKey"
    ]), childList);
}

});

parcelRegister("iPQJN", function(module, exports) {

$parcel$export(module.exports, "default", () => $db65e601ae4bf633$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $392Az = parcelRequire("392Az");

var $a8XZl = parcelRequire("a8XZl");
function $db65e601ae4bf633$export$2e2bcd8739ae039(_ref) {
    var className = _ref.className, style = _ref.style;
    var _React$useContext = $acw62.useContext((0, $392Az.MenuContext)), prefixCls = _React$useContext.prefixCls;
    var measure = (0, $a8XZl.useMeasure)();
    if (measure) return null;
    return /*#__PURE__*/ $acw62.createElement("li", {
        role: "separator",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-item-divider"), className),
        style: style
    });
}

});





parcelRegister("uKgWz", function(module, exports) {

$parcel$export(module.exports, "default", () => $05c6b22b26939e9e$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $8g1PZ = parcelRequire("8g1PZ");

var $iCi4s = parcelRequire("iCi4s");

var $acw62 = parcelRequire("acw62");

var $P8LbM = parcelRequire("P8LbM");
var $05c6b22b26939e9e$var$TabNode = function TabNode(props) {
    var _classNames;
    var prefixCls = props.prefixCls, id = props.id, active = props.active, _props$tab = props.tab, key = _props$tab.key, label = _props$tab.label, disabled = _props$tab.disabled, closeIcon = _props$tab.closeIcon, icon = _props$tab.icon, closable = props.closable, renderWrapper = props.renderWrapper, removeAriaLabel = props.removeAriaLabel, editable = props.editable, onClick = props.onClick, onFocus = props.onFocus, style = props.style;
    var tabPrefix = "".concat(prefixCls, "-tab");
    var removable = (0, $P8LbM.getRemovable)(closable, closeIcon, editable, disabled);
    function onInternalClick(e) {
        if (disabled) return;
        onClick(e);
    }
    function onRemoveTab(event) {
        event.preventDefault();
        event.stopPropagation();
        editable.onEdit("remove", {
            key: key,
            event: event
        });
    }
    var labelNode = $acw62.useMemo(function() {
        return icon && typeof label === "string" ? /*#__PURE__*/ $acw62.createElement("span", null, label) : label;
    }, [
        label,
        icon
    ]);
    var node = /*#__PURE__*/ $acw62.createElement("div", {
        key: key,
        "data-node-key": (0, $P8LbM.genDataNodeKey)(key),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(tabPrefix, (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(tabPrefix, "-with-remove"), removable), (0, $kSlfw.default)(_classNames, "".concat(tabPrefix, "-active"), active), (0, $kSlfw.default)(_classNames, "".concat(tabPrefix, "-disabled"), disabled), _classNames)),
        style: style,
        onClick: onInternalClick
    }, /*#__PURE__*/ $acw62.createElement("div", {
        role: "tab",
        "aria-selected": active,
        id: id && "".concat(id, "-tab-").concat(key),
        className: "".concat(tabPrefix, "-btn"),
        "aria-controls": id && "".concat(id, "-panel-").concat(key),
        "aria-disabled": disabled,
        tabIndex: disabled ? null : 0,
        onClick: function onClick(e) {
            e.stopPropagation();
            onInternalClick(e);
        },
        onKeyDown: function onKeyDown(e) {
            if ([
                (0, $iCi4s.default).SPACE,
                (0, $iCi4s.default).ENTER
            ].includes(e.which)) {
                e.preventDefault();
                onInternalClick(e);
            }
        },
        onFocus: onFocus
    }, icon && /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(tabPrefix, "-icon")
    }, icon), label && labelNode), removable && /*#__PURE__*/ $acw62.createElement("button", {
        type: "button",
        "aria-label": removeAriaLabel || "remove",
        tabIndex: 0,
        className: "".concat(tabPrefix, "-remove"),
        onClick: function onClick(e) {
            e.stopPropagation();
            onRemoveTab(e);
        }
    }, closeIcon || editable.removeIcon || "\xd7"));
    return renderWrapper ? renderWrapper(node) : node;
};
var $05c6b22b26939e9e$export$2e2bcd8739ae039 = $05c6b22b26939e9e$var$TabNode;

});


parcelRegister("4lX2B", function(module, exports) {

$parcel$export(module.exports, "default", () => $32b6ebe184c19bb6$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
var $32b6ebe184c19bb6$var$TabPane = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, className = props.className, style = props.style, id = props.id, active = props.active, tabKey = props.tabKey, children = props.children;
    return /*#__PURE__*/ $acw62.createElement("div", {
        id: id && "".concat(id, "-panel-").concat(tabKey),
        role: "tabpanel",
        tabIndex: active ? 0 : -1,
        "aria-labelledby": id && "".concat(id, "-tab-").concat(tabKey),
        "aria-hidden": !active,
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, active && "".concat(prefixCls, "-active"), className),
        ref: ref
    }, children);
});
var $32b6ebe184c19bb6$export$2e2bcd8739ae039 = $32b6ebe184c19bb6$var$TabPane;

});


parcelRegister("bRUSh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a40c3051886a790$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $9X7IJ = parcelRequire("9X7IJ");

var $kSlfw = parcelRequire("kSlfw");

var $8g1PZ = parcelRequire("8g1PZ");

var $8iiJy = parcelRequire("8iiJy");

var $acw62 = parcelRequire("acw62");

var $g4n1M = parcelRequire("g4n1M");

var $4lX2B = parcelRequire("4lX2B");
var $8a40c3051886a790$var$_excluded = [
    "key",
    "forceRender",
    "style",
    "className",
    "destroyInactiveTabPane"
];
var $8a40c3051886a790$var$TabPanelList = function TabPanelList(props) {
    var id = props.id, activeKey = props.activeKey, animated = props.animated, tabPosition = props.tabPosition, destroyInactiveTabPane = props.destroyInactiveTabPane;
    var _React$useContext = $acw62.useContext((0, $g4n1M.default)), prefixCls = _React$useContext.prefixCls, tabs = _React$useContext.tabs;
    var tabPaneAnimated = animated.tabPane;
    var tabPanePrefixCls = "".concat(prefixCls, "-tabpane");
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-content-holder"))
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-content"), "".concat(prefixCls, "-content-").concat(tabPosition), (0, $kSlfw.default)({}, "".concat(prefixCls, "-content-animated"), tabPaneAnimated))
    }, tabs.map(function(item) {
        var key = item.key, forceRender = item.forceRender, paneStyle = item.style, paneClassName = item.className, itemDestroyInactiveTabPane = item.destroyInactiveTabPane, restTabProps = (0, $9X7IJ.default)(item, $8a40c3051886a790$var$_excluded);
        var active = key === activeKey;
        return /*#__PURE__*/ $acw62.createElement((0, $8iiJy.default), (0, $8nd05.default)({
            key: key,
            visible: active,
            forceRender: forceRender,
            removeOnLeave: !!(destroyInactiveTabPane || itemDestroyInactiveTabPane),
            leavedClassName: "".concat(tabPanePrefixCls, "-hidden")
        }, animated.tabPaneMotion), function(_ref, ref) {
            var motionStyle = _ref.style, motionClassName = _ref.className;
            return /*#__PURE__*/ $acw62.createElement((0, $4lX2B.default), (0, $8nd05.default)({}, restTabProps, {
                prefixCls: tabPanePrefixCls,
                id: id,
                tabKey: key,
                animated: tabPaneAnimated,
                active: active,
                style: (0, $d49SP.default)((0, $d49SP.default)({}, paneStyle), motionStyle),
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(paneClassName, motionClassName),
                ref: ref
            }));
        });
    })));
};
var $8a40c3051886a790$export$2e2bcd8739ae039 = $8a40c3051886a790$var$TabPanelList;

});



parcelRegister("kcVug", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb61855ec5fb79d5$export$2e2bcd8739ae039);

var $4257x = parcelRequire("4257x");
const $eb61855ec5fb79d5$var$motion = {
    motionAppear: false,
    motionEnter: true,
    motionLeave: true
};
function $eb61855ec5fb79d5$export$2e2bcd8739ae039(prefixCls) {
    let animated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        inkBar: true,
        tabPane: false
    };
    let mergedAnimated;
    if (animated === false) mergedAnimated = {
        inkBar: false,
        tabPane: false
    };
    else if (animated === true) mergedAnimated = {
        inkBar: true,
        tabPane: true
    };
    else mergedAnimated = Object.assign({
        inkBar: true
    }, typeof animated === "object" ? animated : {});
    if (mergedAnimated.tabPane) mergedAnimated.tabPaneMotion = Object.assign(Object.assign({}, $eb61855ec5fb79d5$var$motion), {
        motionName: (0, $4257x.getTransitionName)(prefixCls, "switch")
    });
    return mergedAnimated;
}

});
parcelRegister("4257x", function(module, exports) {

$parcel$export(module.exports, "getTransitionName", () => $2efb522a5615f01e$export$27c72201b1d09951);
$parcel$export(module.exports, "default", () => $2efb522a5615f01e$export$2e2bcd8739ae039);
// ================== Collapse Motion ==================
const $2efb522a5615f01e$var$getCollapsedHeight = ()=>({
        height: 0,
        opacity: 0
    });
const $2efb522a5615f01e$var$getRealHeight = (node)=>{
    const { scrollHeight: scrollHeight } = node;
    return {
        height: scrollHeight,
        opacity: 1
    };
};
const $2efb522a5615f01e$var$getCurrentHeight = (node)=>({
        height: node ? node.offsetHeight : 0
    });
const $2efb522a5615f01e$var$skipOpacityTransition = (_, event)=>(event === null || event === void 0 ? void 0 : event.deadline) === true || event.propertyName === "height";
const $2efb522a5615f01e$var$initCollapseMotion = function() {
    let rootCls = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "ant";
    return {
        motionName: `${rootCls}-motion-collapse`,
        onAppearStart: $2efb522a5615f01e$var$getCollapsedHeight,
        onEnterStart: $2efb522a5615f01e$var$getCollapsedHeight,
        onAppearActive: $2efb522a5615f01e$var$getRealHeight,
        onEnterActive: $2efb522a5615f01e$var$getRealHeight,
        onLeaveStart: $2efb522a5615f01e$var$getCurrentHeight,
        onLeaveActive: $2efb522a5615f01e$var$getCollapsedHeight,
        onAppearEnd: $2efb522a5615f01e$var$skipOpacityTransition,
        onEnterEnd: $2efb522a5615f01e$var$skipOpacityTransition,
        onLeaveEnd: $2efb522a5615f01e$var$skipOpacityTransition,
        motionDeadline: 500
    };
};
const $2efb522a5615f01e$var$SelectPlacements = [
    "bottomLeft",
    "bottomRight",
    "topLeft",
    "topRight"
];
const $2efb522a5615f01e$export$27c72201b1d09951 = (rootPrefixCls, motion, transitionName)=>{
    if (transitionName !== undefined) return transitionName;
    return `${rootPrefixCls}-${motion}`;
};
var $2efb522a5615f01e$export$2e2bcd8739ae039 = $2efb522a5615f01e$var$initCollapseMotion;

});


parcelRegister("4ERFI", function(module, exports) {

$parcel$export(module.exports, "default", () => $364487f9f614b61c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jWR62 = parcelRequire("jWR62");

var $364487f9f614b61c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $364487f9f614b61c$var$filter(items) {
    return items.filter((item)=>item);
}
function $364487f9f614b61c$export$2e2bcd8739ae039(items, children) {
    if (items) return items;
    const childrenItems = (0, $jWR62.default)(children).map((node)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(node)) {
            const { key: key, props: props } = node;
            const _a = props || {}, { tab: tab } = _a, restProps = $364487f9f614b61c$var$__rest(_a, [
                "tab"
            ]);
            const item = Object.assign(Object.assign({
                key: String(key)
            }, restProps), {
                label: tab
            });
            return item;
        }
        return null;
    });
    return $364487f9f614b61c$var$filter(childrenItems);
}

});

parcelRegister("7XKHO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cc245dd2cc46dea$export$2e2bcd8739ae039);
parcelRequire("3i86m");
var $lpQ06 = parcelRequire("lpQ06");

var $670jt = parcelRequire("670jt");

var $P8Drj = parcelRequire("P8Drj");
var $2LRCS = parcelRequire("2LRCS");

var $dwRTy = parcelRequire("dwRTy");
const $5cc245dd2cc46dea$var$genCardStyle = (token)=>{
    const { componentCls: componentCls, tabsCardPadding: tabsCardPadding, cardBg: cardBg, cardGutter: cardGutter, colorBorderSecondary: colorBorderSecondary, itemSelectedColor: itemSelectedColor } = token;
    return {
        [`${componentCls}-card`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                [`${componentCls}-tab`]: {
                    margin: 0,
                    padding: tabsCardPadding,
                    background: cardBg,
                    border: `${(0, $lpQ06.unit)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
                    transition: `all ${token.motionDurationSlow} ${token.motionEaseInOut}`
                },
                [`${componentCls}-tab-active`]: {
                    color: itemSelectedColor,
                    background: token.colorBgContainer
                },
                [`${componentCls}-ink-bar`]: {
                    visibility: "hidden"
                }
            },
            // ========================== Top & Bottom ==========================
            [`&${componentCls}-top, &${componentCls}-bottom`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab + ${componentCls}-tab`]: {
                        marginLeft: {
                            _skip_check_: true,
                            value: (0, $lpQ06.unit)(cardGutter)
                        }
                    }
                }
            },
            [`&${componentCls}-top`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: `${(0, $lpQ06.unit)(token.borderRadiusLG)} ${(0, $lpQ06.unit)(token.borderRadiusLG)} 0 0`
                    },
                    [`${componentCls}-tab-active`]: {
                        borderBottomColor: token.colorBgContainer
                    }
                }
            },
            [`&${componentCls}-bottom`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: `0 0 ${(0, $lpQ06.unit)(token.borderRadiusLG)} ${(0, $lpQ06.unit)(token.borderRadiusLG)}`
                    },
                    [`${componentCls}-tab-active`]: {
                        borderTopColor: token.colorBgContainer
                    }
                }
            },
            // ========================== Left & Right ==========================
            [`&${componentCls}-left, &${componentCls}-right`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab + ${componentCls}-tab`]: {
                        marginTop: (0, $lpQ06.unit)(cardGutter)
                    }
                }
            },
            [`&${componentCls}-left`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `${(0, $lpQ06.unit)(token.borderRadiusLG)} 0 0 ${(0, $lpQ06.unit)(token.borderRadiusLG)}`
                        }
                    },
                    [`${componentCls}-tab-active`]: {
                        borderRightColor: {
                            _skip_check_: true,
                            value: token.colorBgContainer
                        }
                    }
                }
            },
            [`&${componentCls}-right`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `0 ${(0, $lpQ06.unit)(token.borderRadiusLG)} ${(0, $lpQ06.unit)(token.borderRadiusLG)} 0`
                        }
                    },
                    [`${componentCls}-tab-active`]: {
                        borderLeftColor: {
                            _skip_check_: true,
                            value: token.colorBgContainer
                        }
                    }
                }
            }
        }
    };
};
const $5cc245dd2cc46dea$var$genDropdownStyle = (token)=>{
    const { componentCls: componentCls, itemHoverColor: itemHoverColor, dropdownEdgeChildVerticalPadding: dropdownEdgeChildVerticalPadding } = token;
    return {
        [`${componentCls}-dropdown`]: Object.assign(Object.assign({}, (0, $670jt.resetComponent)(token)), {
            position: "absolute",
            top: -9999,
            left: {
                _skip_check_: true,
                value: -9999
            },
            zIndex: token.zIndexPopup,
            display: "block",
            "&-hidden": {
                display: "none"
            },
            [`${componentCls}-dropdown-menu`]: {
                maxHeight: token.tabsDropdownHeight,
                margin: 0,
                padding: `${(0, $lpQ06.unit)(dropdownEdgeChildVerticalPadding)} 0`,
                overflowX: "hidden",
                overflowY: "auto",
                textAlign: {
                    _skip_check_: true,
                    value: "left"
                },
                listStyleType: "none",
                backgroundColor: token.colorBgContainer,
                backgroundClip: "padding-box",
                borderRadius: token.borderRadiusLG,
                outline: "none",
                boxShadow: token.boxShadowSecondary,
                "&-item": Object.assign(Object.assign({}, (0, $670jt.textEllipsis)), {
                    display: "flex",
                    alignItems: "center",
                    minWidth: token.tabsDropdownWidth,
                    margin: 0,
                    padding: `${(0, $lpQ06.unit)(token.paddingXXS)} ${(0, $lpQ06.unit)(token.paddingSM)}`,
                    color: token.colorText,
                    fontWeight: "normal",
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight,
                    cursor: "pointer",
                    transition: `all ${token.motionDurationSlow}`,
                    "> span": {
                        flex: 1,
                        whiteSpace: "nowrap"
                    },
                    "&-remove": {
                        flex: "none",
                        marginLeft: {
                            _skip_check_: true,
                            value: token.marginSM
                        },
                        color: token.colorTextDescription,
                        fontSize: token.fontSizeSM,
                        background: "transparent",
                        border: 0,
                        cursor: "pointer",
                        "&:hover": {
                            color: itemHoverColor
                        }
                    },
                    "&:hover": {
                        background: token.controlItemBgHover
                    },
                    "&-disabled": {
                        "&, &:hover": {
                            color: token.colorTextDisabled,
                            background: "transparent",
                            cursor: "not-allowed"
                        }
                    }
                })
            }
        })
    };
};
const $5cc245dd2cc46dea$var$genPositionStyle = (token)=>{
    const { componentCls: componentCls, margin: margin, colorBorderSecondary: colorBorderSecondary, horizontalMargin: horizontalMargin, verticalItemPadding: verticalItemPadding, verticalItemMargin: verticalItemMargin, calc: calc } = token;
    return {
        // ========================== Top & Bottom ==========================
        [`${componentCls}-top, ${componentCls}-bottom`]: {
            flexDirection: "column",
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                margin: horizontalMargin,
                "&::before": {
                    position: "absolute",
                    right: {
                        _skip_check_: true,
                        value: 0
                    },
                    left: {
                        _skip_check_: true,
                        value: 0
                    },
                    borderBottom: `${(0, $lpQ06.unit)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
                    content: "''"
                },
                [`${componentCls}-ink-bar`]: {
                    height: token.lineWidthBold,
                    "&-animated": {
                        transition: `width ${token.motionDurationSlow}, left ${token.motionDurationSlow},
            right ${token.motionDurationSlow}`
                    }
                },
                [`${componentCls}-nav-wrap`]: {
                    "&::before, &::after": {
                        top: 0,
                        bottom: 0,
                        width: token.controlHeight
                    },
                    "&::before": {
                        left: {
                            _skip_check_: true,
                            value: 0
                        },
                        boxShadow: token.boxShadowTabsOverflowLeft
                    },
                    "&::after": {
                        right: {
                            _skip_check_: true,
                            value: 0
                        },
                        boxShadow: token.boxShadowTabsOverflowRight
                    },
                    [`&${componentCls}-nav-wrap-ping-left::before`]: {
                        opacity: 1
                    },
                    [`&${componentCls}-nav-wrap-ping-right::after`]: {
                        opacity: 1
                    }
                }
            }
        },
        [`${componentCls}-top`]: {
            [`> ${componentCls}-nav,
        > div > ${componentCls}-nav`]: {
                "&::before": {
                    bottom: 0
                },
                [`${componentCls}-ink-bar`]: {
                    bottom: 0
                }
            }
        },
        [`${componentCls}-bottom`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                order: 1,
                marginTop: margin,
                marginBottom: 0,
                "&::before": {
                    top: 0
                },
                [`${componentCls}-ink-bar`]: {
                    top: 0
                }
            },
            [`> ${componentCls}-content-holder, > div > ${componentCls}-content-holder`]: {
                order: 0
            }
        },
        // ========================== Left & Right ==========================
        [`${componentCls}-left, ${componentCls}-right`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                flexDirection: "column",
                minWidth: calc(token.controlHeight).mul(1.25).equal(),
                // >>>>>>>>>>> Tab
                [`${componentCls}-tab`]: {
                    padding: verticalItemPadding,
                    textAlign: "center"
                },
                [`${componentCls}-tab + ${componentCls}-tab`]: {
                    margin: verticalItemMargin
                },
                // >>>>>>>>>>> Nav
                [`${componentCls}-nav-wrap`]: {
                    flexDirection: "column",
                    "&::before, &::after": {
                        right: {
                            _skip_check_: true,
                            value: 0
                        },
                        left: {
                            _skip_check_: true,
                            value: 0
                        },
                        height: token.controlHeight
                    },
                    "&::before": {
                        top: 0,
                        boxShadow: token.boxShadowTabsOverflowTop
                    },
                    "&::after": {
                        bottom: 0,
                        boxShadow: token.boxShadowTabsOverflowBottom
                    },
                    [`&${componentCls}-nav-wrap-ping-top::before`]: {
                        opacity: 1
                    },
                    [`&${componentCls}-nav-wrap-ping-bottom::after`]: {
                        opacity: 1
                    }
                },
                // >>>>>>>>>>> Ink Bar
                [`${componentCls}-ink-bar`]: {
                    width: token.lineWidthBold,
                    "&-animated": {
                        transition: `height ${token.motionDurationSlow}, top ${token.motionDurationSlow}`
                    }
                },
                [`${componentCls}-nav-list, ${componentCls}-nav-operations`]: {
                    flex: "1 0 auto",
                    // fix safari scroll problem
                    flexDirection: "column"
                }
            }
        },
        [`${componentCls}-left`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                [`${componentCls}-ink-bar`]: {
                    right: {
                        _skip_check_: true,
                        value: 0
                    }
                }
            },
            [`> ${componentCls}-content-holder, > div > ${componentCls}-content-holder`]: {
                marginLeft: {
                    _skip_check_: true,
                    value: (0, $lpQ06.unit)(calc(token.lineWidth).mul(-1).equal())
                },
                borderLeft: {
                    _skip_check_: true,
                    value: `${(0, $lpQ06.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                [`> ${componentCls}-content > ${componentCls}-tabpane`]: {
                    paddingLeft: {
                        _skip_check_: true,
                        value: token.paddingLG
                    }
                }
            }
        },
        [`${componentCls}-right`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                order: 1,
                [`${componentCls}-ink-bar`]: {
                    left: {
                        _skip_check_: true,
                        value: 0
                    }
                }
            },
            [`> ${componentCls}-content-holder, > div > ${componentCls}-content-holder`]: {
                order: 0,
                marginRight: {
                    _skip_check_: true,
                    value: calc(token.lineWidth).mul(-1).equal()
                },
                borderRight: {
                    _skip_check_: true,
                    value: `${(0, $lpQ06.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                [`> ${componentCls}-content > ${componentCls}-tabpane`]: {
                    paddingRight: {
                        _skip_check_: true,
                        value: token.paddingLG
                    }
                }
            }
        }
    };
};
const $5cc245dd2cc46dea$var$genSizeStyle = (token)=>{
    const { componentCls: componentCls, cardPaddingSM: cardPaddingSM, cardPaddingLG: cardPaddingLG, horizontalItemPaddingSM: horizontalItemPaddingSM, horizontalItemPaddingLG: horizontalItemPaddingLG } = token;
    return {
        [componentCls]: {
            "&-small": {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: horizontalItemPaddingSM,
                        fontSize: token.titleFontSizeSM
                    }
                }
            },
            "&-large": {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: horizontalItemPaddingLG,
                        fontSize: token.titleFontSizeLG
                    }
                }
            }
        },
        [`${componentCls}-card`]: {
            [`&${componentCls}-small`]: {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: cardPaddingSM
                    }
                },
                [`&${componentCls}-bottom`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: `0 0 ${(0, $lpQ06.unit)(token.borderRadius)} ${(0, $lpQ06.unit)(token.borderRadius)}`
                    }
                },
                [`&${componentCls}-top`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: `${(0, $lpQ06.unit)(token.borderRadius)} ${(0, $lpQ06.unit)(token.borderRadius)} 0 0`
                    }
                },
                [`&${componentCls}-right`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `0 ${(0, $lpQ06.unit)(token.borderRadius)} ${(0, $lpQ06.unit)(token.borderRadius)} 0`
                        }
                    }
                },
                [`&${componentCls}-left`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `${(0, $lpQ06.unit)(token.borderRadius)} 0 0 ${(0, $lpQ06.unit)(token.borderRadius)}`
                        }
                    }
                }
            },
            [`&${componentCls}-large`]: {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: cardPaddingLG
                    }
                }
            }
        }
    };
};
const $5cc245dd2cc46dea$var$genTabStyle = (token)=>{
    const { componentCls: componentCls, itemActiveColor: itemActiveColor, itemHoverColor: itemHoverColor, iconCls: iconCls, tabsHorizontalItemMargin: tabsHorizontalItemMargin, horizontalItemPadding: horizontalItemPadding, itemSelectedColor: itemSelectedColor, itemColor: itemColor } = token;
    const tabCls = `${componentCls}-tab`;
    return {
        [tabCls]: {
            position: "relative",
            WebkitTouchCallout: "none",
            WebkitTapHighlightColor: "transparent",
            display: "inline-flex",
            alignItems: "center",
            padding: horizontalItemPadding,
            fontSize: token.titleFontSize,
            background: "transparent",
            border: 0,
            outline: "none",
            cursor: "pointer",
            color: itemColor,
            "&-btn, &-remove": Object.assign({
                "&:focus:not(:focus-visible), &:active": {
                    color: itemActiveColor
                }
            }, (0, $670jt.genFocusStyle)(token)),
            "&-btn": {
                outline: "none",
                transition: "all 0.3s",
                [`${tabCls}-icon:not(:last-child)`]: {
                    marginInlineEnd: token.marginSM
                }
            },
            "&-remove": {
                flex: "none",
                marginRight: {
                    _skip_check_: true,
                    value: token.calc(token.marginXXS).mul(-1).equal()
                },
                marginLeft: {
                    _skip_check_: true,
                    value: token.marginXS
                },
                color: token.colorTextDescription,
                fontSize: token.fontSizeSM,
                background: "transparent",
                border: "none",
                outline: "none",
                cursor: "pointer",
                transition: `all ${token.motionDurationSlow}`,
                "&:hover": {
                    color: token.colorTextHeading
                }
            },
            "&:hover": {
                color: itemHoverColor
            },
            [`&${tabCls}-active ${tabCls}-btn`]: {
                color: itemSelectedColor,
                textShadow: token.tabsActiveTextShadow
            },
            [`&${tabCls}-disabled`]: {
                color: token.colorTextDisabled,
                cursor: "not-allowed"
            },
            [`&${tabCls}-disabled ${tabCls}-btn, &${tabCls}-disabled ${componentCls}-remove`]: {
                "&:focus, &:active": {
                    color: token.colorTextDisabled
                }
            },
            [`& ${tabCls}-remove ${iconCls}`]: {
                margin: 0
            },
            [`${iconCls}:not(:last-child)`]: {
                marginRight: {
                    _skip_check_: true,
                    value: token.marginSM
                }
            }
        },
        [`${tabCls} + ${tabCls}`]: {
            margin: {
                _skip_check_: true,
                value: tabsHorizontalItemMargin
            }
        }
    };
};
const $5cc245dd2cc46dea$var$genRtlStyle = (token)=>{
    const { componentCls: componentCls, tabsHorizontalItemMarginRTL: tabsHorizontalItemMarginRTL, iconCls: iconCls, cardGutter: cardGutter, calc: calc } = token;
    const rtlCls = `${componentCls}-rtl`;
    return {
        [rtlCls]: {
            direction: "rtl",
            [`${componentCls}-nav`]: {
                [`${componentCls}-tab`]: {
                    margin: {
                        _skip_check_: true,
                        value: tabsHorizontalItemMarginRTL
                    },
                    [`${componentCls}-tab:last-of-type`]: {
                        marginLeft: {
                            _skip_check_: true,
                            value: 0
                        }
                    },
                    [iconCls]: {
                        marginRight: {
                            _skip_check_: true,
                            value: 0
                        },
                        marginLeft: {
                            _skip_check_: true,
                            value: (0, $lpQ06.unit)(token.marginSM)
                        }
                    },
                    [`${componentCls}-tab-remove`]: {
                        marginRight: {
                            _skip_check_: true,
                            value: (0, $lpQ06.unit)(token.marginXS)
                        },
                        marginLeft: {
                            _skip_check_: true,
                            value: (0, $lpQ06.unit)(calc(token.marginXXS).mul(-1).equal())
                        },
                        [iconCls]: {
                            margin: 0
                        }
                    }
                }
            },
            [`&${componentCls}-left`]: {
                [`> ${componentCls}-nav`]: {
                    order: 1
                },
                [`> ${componentCls}-content-holder`]: {
                    order: 0
                }
            },
            [`&${componentCls}-right`]: {
                [`> ${componentCls}-nav`]: {
                    order: 0
                },
                [`> ${componentCls}-content-holder`]: {
                    order: 1
                }
            },
            // ====================== Card ======================
            [`&${componentCls}-card${componentCls}-top, &${componentCls}-card${componentCls}-bottom`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab + ${componentCls}-tab`]: {
                        marginRight: {
                            _skip_check_: true,
                            value: cardGutter
                        },
                        marginLeft: {
                            _skip_check_: true,
                            value: 0
                        }
                    }
                }
            }
        },
        [`${componentCls}-dropdown-rtl`]: {
            direction: "rtl"
        },
        [`${componentCls}-menu-item`]: {
            [`${componentCls}-dropdown-rtl`]: {
                textAlign: {
                    _skip_check_: true,
                    value: "right"
                }
            }
        }
    };
};
const $5cc245dd2cc46dea$var$genTabsStyle = (token)=>{
    const { componentCls: componentCls, tabsCardPadding: tabsCardPadding, cardHeight: cardHeight, cardGutter: cardGutter, itemHoverColor: itemHoverColor, itemActiveColor: itemActiveColor, colorBorderSecondary: colorBorderSecondary } = token;
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $670jt.resetComponent)(token)), {
            display: "flex",
            // ========================== Navigation ==========================
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                position: "relative",
                display: "flex",
                flex: "none",
                alignItems: "center",
                [`${componentCls}-nav-wrap`]: {
                    position: "relative",
                    display: "flex",
                    flex: "auto",
                    alignSelf: "stretch",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    transform: "translate(0)",
                    // Fix chrome render bug
                    // >>>>> Ping shadow
                    "&::before, &::after": {
                        position: "absolute",
                        zIndex: 1,
                        opacity: 0,
                        transition: `opacity ${token.motionDurationSlow}`,
                        content: "''",
                        pointerEvents: "none"
                    }
                },
                [`${componentCls}-nav-list`]: {
                    position: "relative",
                    display: "flex",
                    transition: `opacity ${token.motionDurationSlow}`
                },
                // >>>>>>>> Operations
                [`${componentCls}-nav-operations`]: {
                    display: "flex",
                    alignSelf: "stretch"
                },
                [`${componentCls}-nav-operations-hidden`]: {
                    position: "absolute",
                    visibility: "hidden",
                    pointerEvents: "none"
                },
                [`${componentCls}-nav-more`]: {
                    position: "relative",
                    padding: tabsCardPadding,
                    background: "transparent",
                    border: 0,
                    color: token.colorText,
                    "&::after": {
                        position: "absolute",
                        right: {
                            _skip_check_: true,
                            value: 0
                        },
                        bottom: 0,
                        left: {
                            _skip_check_: true,
                            value: 0
                        },
                        height: token.calc(token.controlHeightLG).div(8).equal(),
                        transform: "translateY(100%)",
                        content: "''"
                    }
                },
                [`${componentCls}-nav-add`]: Object.assign({
                    minWidth: cardHeight,
                    marginLeft: {
                        _skip_check_: true,
                        value: cardGutter
                    },
                    padding: `0 ${(0, $lpQ06.unit)(token.paddingXS)}`,
                    background: "transparent",
                    border: `${(0, $lpQ06.unit)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
                    borderRadius: `${(0, $lpQ06.unit)(token.borderRadiusLG)} ${(0, $lpQ06.unit)(token.borderRadiusLG)} 0 0`,
                    outline: "none",
                    cursor: "pointer",
                    color: token.colorText,
                    transition: `all ${token.motionDurationSlow} ${token.motionEaseInOut}`,
                    "&:hover": {
                        color: itemHoverColor
                    },
                    "&:active, &:focus:not(:focus-visible)": {
                        color: itemActiveColor
                    }
                }, (0, $670jt.genFocusStyle)(token))
            },
            [`${componentCls}-extra-content`]: {
                flex: "none"
            },
            // ============================ InkBar ============================
            [`${componentCls}-ink-bar`]: {
                position: "absolute",
                background: token.inkBarColor,
                pointerEvents: "none"
            }
        }), $5cc245dd2cc46dea$var$genTabStyle(token)), {
            // =========================== TabPanes ===========================
            [`${componentCls}-content`]: {
                position: "relative",
                width: "100%"
            },
            [`${componentCls}-content-holder`]: {
                flex: "auto",
                minWidth: 0,
                minHeight: 0
            },
            [`${componentCls}-tabpane`]: {
                outline: "none",
                "&-hidden": {
                    display: "none"
                }
            }
        }),
        [`${componentCls}-centered`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                [`${componentCls}-nav-wrap`]: {
                    [`&:not([class*='${componentCls}-nav-wrap-ping'])`]: {
                        justifyContent: "center"
                    }
                }
            }
        }
    };
};
const $5cc245dd2cc46dea$export$9ca1be8807fe0675 = (token)=>{
    const cardHeight = token.controlHeightLG;
    return {
        zIndexPopup: token.zIndexPopupBase + 50,
        cardBg: token.colorFillAlter,
        cardHeight: cardHeight,
        // Initialize with empty string, because cardPadding will be calculated with cardHeight by default.
        cardPadding: `${(cardHeight - Math.round(token.fontSize * token.lineHeight)) / 2 - token.lineWidth}px ${token.padding}px`,
        cardPaddingSM: `${token.paddingXXS * 1.5}px ${token.padding}px`,
        cardPaddingLG: `${token.paddingXS}px ${token.padding}px ${token.paddingXXS * 1.5}px`,
        titleFontSize: token.fontSize,
        titleFontSizeLG: token.fontSizeLG,
        titleFontSizeSM: token.fontSize,
        inkBarColor: token.colorPrimary,
        horizontalMargin: `0 0 ${token.margin}px 0`,
        horizontalItemGutter: 32,
        // Fixed Value
        // Initialize with empty string, because horizontalItemMargin will be calculated with horizontalItemGutter by default.
        horizontalItemMargin: ``,
        horizontalItemMarginRTL: ``,
        horizontalItemPadding: `${token.paddingSM}px 0`,
        horizontalItemPaddingSM: `${token.paddingXS}px 0`,
        horizontalItemPaddingLG: `${token.padding}px 0`,
        verticalItemPadding: `${token.paddingXS}px ${token.paddingLG}px`,
        verticalItemMargin: `${token.margin}px 0 0 0`,
        itemColor: token.colorText,
        itemSelectedColor: token.colorPrimary,
        itemHoverColor: token.colorPrimaryHover,
        itemActiveColor: token.colorPrimaryActive,
        cardGutter: token.marginXXS / 2
    };
};
var // ============================== Export ==============================
$5cc245dd2cc46dea$export$2e2bcd8739ae039 = (0, $P8Drj.genStyleHooks)("Tabs", (token)=>{
    const tabsToken = (0, $2LRCS.merge)(token, {
        // `cardPadding` is empty by default, so we could calculate with dynamic `cardHeight`
        tabsCardPadding: token.cardPadding,
        dropdownEdgeChildVerticalPadding: token.paddingXXS,
        tabsActiveTextShadow: "0 0 0.25px currentcolor",
        tabsDropdownHeight: 200,
        tabsDropdownWidth: 120,
        tabsHorizontalItemMargin: `0 0 0 ${(0, $lpQ06.unit)(token.horizontalItemGutter)}`,
        tabsHorizontalItemMarginRTL: `0 0 0 ${(0, $lpQ06.unit)(token.horizontalItemGutter)}`
    });
    return [
        $5cc245dd2cc46dea$var$genSizeStyle(tabsToken),
        $5cc245dd2cc46dea$var$genRtlStyle(tabsToken),
        $5cc245dd2cc46dea$var$genPositionStyle(tabsToken),
        $5cc245dd2cc46dea$var$genDropdownStyle(tabsToken),
        $5cc245dd2cc46dea$var$genCardStyle(tabsToken),
        $5cc245dd2cc46dea$var$genTabsStyle(tabsToken),
        (0, $dwRTy.default)(tabsToken)
    ];
}, $5cc245dd2cc46dea$export$9ca1be8807fe0675);

});
parcelRegister("dwRTy", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d9811f30568fd64$export$2e2bcd8739ae039);

var $llQv4 = parcelRequire("llQv4");
const $9d9811f30568fd64$var$genMotionStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow } = token;
    return [
        {
            [componentCls]: {
                [`${componentCls}-switch`]: {
                    "&-appear, &-enter": {
                        transition: "none",
                        "&-start": {
                            opacity: 0
                        },
                        "&-active": {
                            opacity: 1,
                            transition: `opacity ${motionDurationSlow}`
                        }
                    },
                    "&-leave": {
                        position: "absolute",
                        transition: "none",
                        inset: 0,
                        "&-start": {
                            opacity: 1
                        },
                        "&-active": {
                            opacity: 0,
                            transition: `opacity ${motionDurationSlow}`
                        }
                    }
                }
            }
        },
        // Follow code may reuse in other components
        [
            (0, $llQv4.initSlideMotion)(token, "slide-up"),
            (0, $llQv4.initSlideMotion)(token, "slide-down")
        ]
    ];
};
var $9d9811f30568fd64$export$2e2bcd8739ae039 = $9d9811f30568fd64$var$genMotionStyle;

});
parcelRegister("llQv4", function(module, exports) {

$parcel$export(module.exports, "slideUpIn", () => $f8b44896cb986807$export$e801b802b037de6a);
$parcel$export(module.exports, "slideUpOut", () => $f8b44896cb986807$export$f40f41df328ebc38);
$parcel$export(module.exports, "slideDownIn", () => $f8b44896cb986807$export$dd9f089fa5e819fe);
$parcel$export(module.exports, "slideDownOut", () => $f8b44896cb986807$export$f7243fdb9c27c3b7);
$parcel$export(module.exports, "initSlideMotion", () => $f8b44896cb986807$export$9018e60daecf7a6c);
parcelRequire("3i86m");
var $hsEk2 = parcelRequire("hsEk2");

var $gvSPY = parcelRequire("gvSPY");
const $f8b44896cb986807$export$e801b802b037de6a = new (0, $hsEk2.default)("antSlideUpIn", {
    "0%": {
        transform: "scaleY(0.8)",
        transformOrigin: "0% 0%",
        opacity: 0
    },
    "100%": {
        transform: "scaleY(1)",
        transformOrigin: "0% 0%",
        opacity: 1
    }
});
const $f8b44896cb986807$export$f40f41df328ebc38 = new (0, $hsEk2.default)("antSlideUpOut", {
    "0%": {
        transform: "scaleY(1)",
        transformOrigin: "0% 0%",
        opacity: 1
    },
    "100%": {
        transform: "scaleY(0.8)",
        transformOrigin: "0% 0%",
        opacity: 0
    }
});
const $f8b44896cb986807$export$dd9f089fa5e819fe = new (0, $hsEk2.default)("antSlideDownIn", {
    "0%": {
        transform: "scaleY(0.8)",
        transformOrigin: "100% 100%",
        opacity: 0
    },
    "100%": {
        transform: "scaleY(1)",
        transformOrigin: "100% 100%",
        opacity: 1
    }
});
const $f8b44896cb986807$export$f7243fdb9c27c3b7 = new (0, $hsEk2.default)("antSlideDownOut", {
    "0%": {
        transform: "scaleY(1)",
        transformOrigin: "100% 100%",
        opacity: 1
    },
    "100%": {
        transform: "scaleY(0.8)",
        transformOrigin: "100% 100%",
        opacity: 0
    }
});
const $f8b44896cb986807$export$2ad3a07c3513a54 = new (0, $hsEk2.default)("antSlideLeftIn", {
    "0%": {
        transform: "scaleX(0.8)",
        transformOrigin: "0% 0%",
        opacity: 0
    },
    "100%": {
        transform: "scaleX(1)",
        transformOrigin: "0% 0%",
        opacity: 1
    }
});
const $f8b44896cb986807$export$486fbda27512d5a9 = new (0, $hsEk2.default)("antSlideLeftOut", {
    "0%": {
        transform: "scaleX(1)",
        transformOrigin: "0% 0%",
        opacity: 1
    },
    "100%": {
        transform: "scaleX(0.8)",
        transformOrigin: "0% 0%",
        opacity: 0
    }
});
const $f8b44896cb986807$export$dd03ad46dbbcd7e0 = new (0, $hsEk2.default)("antSlideRightIn", {
    "0%": {
        transform: "scaleX(0.8)",
        transformOrigin: "100% 0%",
        opacity: 0
    },
    "100%": {
        transform: "scaleX(1)",
        transformOrigin: "100% 0%",
        opacity: 1
    }
});
const $f8b44896cb986807$export$db8e3c9b93664f34 = new (0, $hsEk2.default)("antSlideRightOut", {
    "0%": {
        transform: "scaleX(1)",
        transformOrigin: "100% 0%",
        opacity: 1
    },
    "100%": {
        transform: "scaleX(0.8)",
        transformOrigin: "100% 0%",
        opacity: 0
    }
});
const $f8b44896cb986807$var$slideMotion = {
    "slide-up": {
        inKeyframes: $f8b44896cb986807$export$e801b802b037de6a,
        outKeyframes: $f8b44896cb986807$export$f40f41df328ebc38
    },
    "slide-down": {
        inKeyframes: $f8b44896cb986807$export$dd9f089fa5e819fe,
        outKeyframes: $f8b44896cb986807$export$f7243fdb9c27c3b7
    },
    "slide-left": {
        inKeyframes: $f8b44896cb986807$export$2ad3a07c3513a54,
        outKeyframes: $f8b44896cb986807$export$486fbda27512d5a9
    },
    "slide-right": {
        inKeyframes: $f8b44896cb986807$export$dd03ad46dbbcd7e0,
        outKeyframes: $f8b44896cb986807$export$db8e3c9b93664f34
    }
};
const $f8b44896cb986807$export$9018e60daecf7a6c = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $f8b44896cb986807$var$slideMotion[motionName];
    return [
        (0, $gvSPY.initMotion)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        {
            [`
      ${motionCls}-enter,
      ${motionCls}-appear
    `]: {
                transform: "scale(0)",
                transformOrigin: "0% 0%",
                opacity: 0,
                animationTimingFunction: token.motionEaseOutQuint,
                [`&-prepare`]: {
                    transform: "scale(1)"
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInQuint
            }
        }
    ];
};

});
parcelRegister("gvSPY", function(module, exports) {

$parcel$export(module.exports, "initMotion", () => $c05a1428f4a08fb2$export$83e1da9e09ec9112);
const $c05a1428f4a08fb2$var$initMotionCommon = (duration)=>({
        animationDuration: duration,
        animationFillMode: "both"
    });
// FIXME: origin less code seems same as initMotionCommon. Maybe we can safe remove
const $c05a1428f4a08fb2$var$initMotionCommonLeave = (duration)=>({
        animationDuration: duration,
        animationFillMode: "both"
    });
const $c05a1428f4a08fb2$export$83e1da9e09ec9112 = function(motionCls, inKeyframes, outKeyframes, duration) {
    let sameLevel = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    const sameLevelPrefix = sameLevel ? "&" : "";
    return {
        [`
      ${sameLevelPrefix}${motionCls}-enter,
      ${sameLevelPrefix}${motionCls}-appear
    `]: Object.assign(Object.assign({}, $c05a1428f4a08fb2$var$initMotionCommon(duration)), {
            animationPlayState: "paused"
        }),
        [`${sameLevelPrefix}${motionCls}-leave`]: Object.assign(Object.assign({}, $c05a1428f4a08fb2$var$initMotionCommonLeave(duration)), {
            animationPlayState: "paused"
        }),
        [`
      ${sameLevelPrefix}${motionCls}-enter${motionCls}-enter-active,
      ${sameLevelPrefix}${motionCls}-appear${motionCls}-appear-active
    `]: {
            animationName: inKeyframes,
            animationPlayState: "running"
        },
        [`${sameLevelPrefix}${motionCls}-leave${motionCls}-leave-active`]: {
            animationName: outKeyframes,
            animationPlayState: "running",
            pointerEvents: "none"
        }
    };
};

});




parcelRegister("dnT3A", function(module, exports) {

$parcel$export(module.exports, "default", () => $9be8217fdbca7dca$export$2e2bcd8739ae039);

var $hRCaH = parcelRequire("hRCaH");
const $9be8217fdbca7dca$var$useCSSVarCls = (prefixCls)=>{
    const [, , , , cssVar] = (0, $hRCaH.default)();
    return cssVar ? `${prefixCls}-css-var` : "";
};
var $9be8217fdbca7dca$export$2e2bcd8739ae039 = $9be8217fdbca7dca$var$useCSSVarCls;

});

parcelRegister("6zpGA", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c89efaaf6882e88$export$2e2bcd8739ae039);
const $4c89efaaf6882e88$var$TabPane = ()=>null;
var $4c89efaaf6882e88$export$2e2bcd8739ae039 = $4c89efaaf6882e88$var$TabPane;

});


parcelRegister("gWZ4x", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5716fc3f3b274e3$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");
"use client";
var $c5716fc3f3b274e3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $c5716fc3f3b274e3$var$Grid = (_a)=>{
    var { prefixCls: prefixCls, className: className, hoverable: hoverable = true } = _a, props = $c5716fc3f3b274e3$var$__rest(_a, [
        "prefixCls",
        "className",
        "hoverable"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const prefix = getPrefixCls("card", prefixCls);
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(`${prefix}-grid`, className, {
        [`${prefix}-grid-hoverable`]: hoverable
    });
    return /*#__PURE__*/ $acw62.createElement("div", Object.assign({}, props, {
        className: classString
    }));
};
var $c5716fc3f3b274e3$export$2e2bcd8739ae039 = $c5716fc3f3b274e3$var$Grid;

});

parcelRegister("gCOq5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1a74e45bd15dd4b$export$2e2bcd8739ae039);
parcelRequire("3i86m");
var $lpQ06 = parcelRequire("lpQ06");

var $670jt = parcelRequire("670jt");

var $P8Drj = parcelRequire("P8Drj");
var $2LRCS = parcelRequire("2LRCS");
// ============================== Styles ==============================
// ============================== Head ==============================
const $c1a74e45bd15dd4b$var$genCardHeadStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, headerHeight: headerHeight, cardPaddingBase: cardPaddingBase, tabsMarginBottom: tabsMarginBottom } = token;
    return Object.assign(Object.assign({
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        minHeight: headerHeight,
        marginBottom: -1,
        padding: `0 ${(0, $lpQ06.unit)(cardPaddingBase)}`,
        color: token.colorTextHeading,
        fontWeight: token.fontWeightStrong,
        fontSize: token.headerFontSize,
        background: token.headerBg,
        borderBottom: `${(0, $lpQ06.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorderSecondary}`,
        borderRadius: `${(0, $lpQ06.unit)(token.borderRadiusLG)} ${(0, $lpQ06.unit)(token.borderRadiusLG)} 0 0`
    }, (0, $670jt.clearFix)()), {
        "&-wrapper": {
            width: "100%",
            display: "flex",
            alignItems: "center"
        },
        "&-title": Object.assign(Object.assign({
            display: "inline-block",
            flex: 1
        }, (0, $670jt.textEllipsis)), {
            [`
          > ${componentCls}-typography,
          > ${componentCls}-typography-edit-content
        `]: {
                insetInlineStart: 0,
                marginTop: 0,
                marginBottom: 0
            }
        }),
        [`${antCls}-tabs-top`]: {
            clear: "both",
            marginBottom: tabsMarginBottom,
            color: token.colorText,
            fontWeight: "normal",
            fontSize: token.fontSize,
            "&-bar": {
                borderBottom: `${(0, $lpQ06.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorderSecondary}`
            }
        }
    });
};
// ============================== Grid ==============================
const $c1a74e45bd15dd4b$var$genCardGridStyle = (token)=>{
    const { cardPaddingBase: cardPaddingBase, colorBorderSecondary: colorBorderSecondary, cardShadow: cardShadow, lineWidth: lineWidth } = token;
    return {
        width: "33.33%",
        padding: cardPaddingBase,
        border: 0,
        borderRadius: 0,
        boxShadow: `
      ${(0, $lpQ06.unit)(lineWidth)} 0 0 0 ${colorBorderSecondary},
      0 ${(0, $lpQ06.unit)(lineWidth)} 0 0 ${colorBorderSecondary},
      ${(0, $lpQ06.unit)(lineWidth)} ${(0, $lpQ06.unit)(lineWidth)} 0 0 ${colorBorderSecondary},
      ${(0, $lpQ06.unit)(lineWidth)} 0 0 0 ${colorBorderSecondary} inset,
      0 ${(0, $lpQ06.unit)(lineWidth)} 0 0 ${colorBorderSecondary} inset;
    `,
        transition: `all ${token.motionDurationMid}`,
        "&-hoverable:hover": {
            position: "relative",
            zIndex: 1,
            boxShadow: cardShadow
        }
    };
};
// ============================== Actions ==============================
const $c1a74e45bd15dd4b$var$genCardActionsStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, actionsLiMargin: actionsLiMargin, cardActionsIconSize: cardActionsIconSize, colorBorderSecondary: colorBorderSecondary, actionsBg: actionsBg } = token;
    return Object.assign(Object.assign({
        margin: 0,
        padding: 0,
        listStyle: "none",
        background: actionsBg,
        borderTop: `${(0, $lpQ06.unit)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
        display: "flex",
        borderRadius: `0 0 ${(0, $lpQ06.unit)(token.borderRadiusLG)} ${(0, $lpQ06.unit)(token.borderRadiusLG)}`
    }, (0, $670jt.clearFix)()), {
        "& > li": {
            margin: actionsLiMargin,
            color: token.colorTextDescription,
            textAlign: "center",
            "> span": {
                position: "relative",
                display: "block",
                minWidth: token.calc(token.cardActionsIconSize).mul(2).equal(),
                fontSize: token.fontSize,
                lineHeight: token.lineHeight,
                cursor: "pointer",
                "&:hover": {
                    color: token.colorPrimary,
                    transition: `color ${token.motionDurationMid}`
                },
                [`a:not(${componentCls}-btn), > ${iconCls}`]: {
                    display: "inline-block",
                    width: "100%",
                    color: token.colorTextDescription,
                    lineHeight: (0, $lpQ06.unit)(token.fontHeight),
                    transition: `color ${token.motionDurationMid}`,
                    "&:hover": {
                        color: token.colorPrimary
                    }
                },
                [`> ${iconCls}`]: {
                    fontSize: cardActionsIconSize,
                    lineHeight: (0, $lpQ06.unit)(token.calc(cardActionsIconSize).mul(token.lineHeight).equal())
                }
            },
            "&:not(:last-child)": {
                borderInlineEnd: `${(0, $lpQ06.unit)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`
            }
        }
    });
};
// ============================== Meta ==============================
const $c1a74e45bd15dd4b$var$genCardMetaStyle = (token)=>Object.assign(Object.assign({
        margin: `${(0, $lpQ06.unit)(token.calc(token.marginXXS).mul(-1).equal())} 0`,
        display: "flex"
    }, (0, $670jt.clearFix)()), {
        "&-avatar": {
            paddingInlineEnd: token.padding
        },
        "&-detail": {
            overflow: "hidden",
            flex: 1,
            "> div:not(:last-child)": {
                marginBottom: token.marginXS
            }
        },
        "&-title": Object.assign({
            color: token.colorTextHeading,
            fontWeight: token.fontWeightStrong,
            fontSize: token.fontSizeLG
        }, (0, $670jt.textEllipsis)),
        "&-description": {
            color: token.colorTextDescription
        }
    });
// ============================== Inner ==============================
const $c1a74e45bd15dd4b$var$genCardTypeInnerStyle = (token)=>{
    const { componentCls: componentCls, cardPaddingBase: cardPaddingBase, colorFillAlter: colorFillAlter } = token;
    return {
        [`${componentCls}-head`]: {
            padding: `0 ${(0, $lpQ06.unit)(cardPaddingBase)}`,
            background: colorFillAlter,
            "&-title": {
                fontSize: token.fontSize
            }
        },
        [`${componentCls}-body`]: {
            padding: `${(0, $lpQ06.unit)(token.padding)} ${(0, $lpQ06.unit)(cardPaddingBase)}`
        }
    };
};
// ============================== Loading ==============================
const $c1a74e45bd15dd4b$var$genCardLoadingStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        overflow: "hidden",
        [`${componentCls}-body`]: {
            userSelect: "none"
        }
    };
};
// ============================== Basic ==============================
const $c1a74e45bd15dd4b$var$genCardStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, cardShadow: cardShadow, cardHeadPadding: cardHeadPadding, colorBorderSecondary: colorBorderSecondary, boxShadowTertiary: boxShadowTertiary, cardPaddingBase: cardPaddingBase, extraColor: extraColor } = token;
    return {
        [componentCls]: Object.assign(Object.assign({}, (0, $670jt.resetComponent)(token)), {
            position: "relative",
            background: token.colorBgContainer,
            borderRadius: token.borderRadiusLG,
            [`&:not(${componentCls}-bordered)`]: {
                boxShadow: boxShadowTertiary
            },
            [`${componentCls}-head`]: $c1a74e45bd15dd4b$var$genCardHeadStyle(token),
            [`${componentCls}-extra`]: {
                // https://stackoverflow.com/a/22429853/3040605
                marginInlineStart: "auto",
                color: extraColor,
                fontWeight: "normal",
                fontSize: token.fontSize
            },
            [`${componentCls}-body`]: Object.assign({
                padding: cardPaddingBase,
                borderRadius: ` 0 0 ${(0, $lpQ06.unit)(token.borderRadiusLG)} ${(0, $lpQ06.unit)(token.borderRadiusLG)}`
            }, (0, $670jt.clearFix)()),
            [`${componentCls}-grid`]: $c1a74e45bd15dd4b$var$genCardGridStyle(token),
            [`${componentCls}-cover`]: {
                "> *": {
                    display: "block",
                    width: "100%"
                },
                [`img, img + ${antCls}-image-mask`]: {
                    borderRadius: `${(0, $lpQ06.unit)(token.borderRadiusLG)} ${(0, $lpQ06.unit)(token.borderRadiusLG)} 0 0`
                }
            },
            [`${componentCls}-actions`]: $c1a74e45bd15dd4b$var$genCardActionsStyle(token),
            [`${componentCls}-meta`]: $c1a74e45bd15dd4b$var$genCardMetaStyle(token)
        }),
        [`${componentCls}-bordered`]: {
            border: `${(0, $lpQ06.unit)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
            [`${componentCls}-cover`]: {
                marginTop: -1,
                marginInlineStart: -1,
                marginInlineEnd: -1
            }
        },
        [`${componentCls}-hoverable`]: {
            cursor: "pointer",
            transition: `box-shadow ${token.motionDurationMid}, border-color ${token.motionDurationMid}`,
            "&:hover": {
                borderColor: "transparent",
                boxShadow: cardShadow
            }
        },
        [`${componentCls}-contain-grid`]: {
            borderRadius: `${(0, $lpQ06.unit)(token.borderRadiusLG)} ${(0, $lpQ06.unit)(token.borderRadiusLG)} 0 0 `,
            [`${componentCls}-body`]: {
                display: "flex",
                flexWrap: "wrap"
            },
            [`&:not(${componentCls}-loading) ${componentCls}-body`]: {
                marginBlockStart: token.calc(token.lineWidth).mul(-1).equal(),
                marginInlineStart: token.calc(token.lineWidth).mul(-1).equal(),
                padding: 0
            }
        },
        [`${componentCls}-contain-tabs`]: {
            [`> ${componentCls}-head`]: {
                minHeight: 0,
                [`${componentCls}-head-title, ${componentCls}-extra`]: {
                    paddingTop: cardHeadPadding
                }
            }
        },
        [`${componentCls}-type-inner`]: $c1a74e45bd15dd4b$var$genCardTypeInnerStyle(token),
        [`${componentCls}-loading`]: $c1a74e45bd15dd4b$var$genCardLoadingStyle(token),
        [`${componentCls}-rtl`]: {
            direction: "rtl"
        }
    };
};
// ============================== Size ==============================
const $c1a74e45bd15dd4b$var$genCardSizeStyle = (token)=>{
    const { componentCls: componentCls, cardPaddingSM: cardPaddingSM, headerHeightSM: headerHeightSM, headerFontSizeSM: headerFontSizeSM } = token;
    return {
        [`${componentCls}-small`]: {
            [`> ${componentCls}-head`]: {
                minHeight: headerHeightSM,
                padding: `0 ${(0, $lpQ06.unit)(cardPaddingSM)}`,
                fontSize: headerFontSizeSM,
                [`> ${componentCls}-head-wrapper`]: {
                    [`> ${componentCls}-extra`]: {
                        fontSize: token.fontSize
                    }
                }
            },
            [`> ${componentCls}-body`]: {
                padding: cardPaddingSM
            }
        },
        [`${componentCls}-small${componentCls}-contain-tabs`]: {
            [`> ${componentCls}-head`]: {
                [`${componentCls}-head-title, ${componentCls}-extra`]: {
                    paddingTop: 0,
                    display: "flex",
                    alignItems: "center"
                }
            }
        }
    };
};
const $c1a74e45bd15dd4b$export$9ca1be8807fe0675 = (token)=>({
        headerBg: "transparent",
        headerFontSize: token.fontSizeLG,
        headerFontSizeSM: token.fontSize,
        headerHeight: token.fontSizeLG * token.lineHeightLG + token.padding * 2,
        headerHeightSM: token.fontSize * token.lineHeight + token.paddingXS * 2,
        actionsBg: token.colorBgContainer,
        actionsLiMargin: `${token.paddingSM}px 0`,
        tabsMarginBottom: -token.padding - token.lineWidth,
        extraColor: token.colorText
    });
var // ============================== Export ==============================
$c1a74e45bd15dd4b$export$2e2bcd8739ae039 = (0, $P8Drj.genStyleHooks)("Card", (token)=>{
    const cardToken = (0, $2LRCS.merge)(token, {
        cardShadow: token.boxShadowCard,
        cardHeadPadding: token.padding,
        cardPaddingBase: token.paddingLG,
        cardActionsIconSize: token.fontSize,
        cardPaddingSM: 12 // Fixed padding.
    });
    return [
        // Style
        $c1a74e45bd15dd4b$var$genCardStyle(cardToken),
        // Size
        $c1a74e45bd15dd4b$var$genCardSizeStyle(cardToken)
    ];
}, $c1a74e45bd15dd4b$export$9ca1be8807fe0675);

});


parcelRegister("kZiF8", function(module, exports) {

$parcel$export(module.exports, "default", () => $f477fb231ccbb49c$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");
"use client";
var $f477fb231ccbb49c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $f477fb231ccbb49c$var$Meta = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, avatar: avatar, title: title, description: description } = props, others = $f477fb231ccbb49c$var$__rest(props, [
        "prefixCls",
        "className",
        "avatar",
        "title",
        "description"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const prefixCls = getPrefixCls("card", customizePrefixCls);
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(`${prefixCls}-meta`, className);
    const avatarDom = avatar ? /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-meta-avatar`
    }, avatar) : null;
    const titleDom = title ? /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-meta-title`
    }, title) : null;
    const descriptionDom = description ? /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-meta-description`
    }, description) : null;
    const MetaDetail = titleDom || descriptionDom ? /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-meta-detail`
    }, titleDom, descriptionDom) : null;
    return /*#__PURE__*/ $acw62.createElement("div", Object.assign({}, others, {
        className: classString
    }), avatarDom, MetaDetail);
};
var $f477fb231ccbb49c$export$2e2bcd8739ae039 = $f477fb231ccbb49c$var$Meta;

});


parcelRegister("bAJM4", function(module, exports) {

$parcel$export(module.exports, "default", () => $87069059c399a8f7$export$2e2bcd8739ae039);

var $lq9mO = parcelRequire("lq9mO");
"use client";
var $87069059c399a8f7$export$2e2bcd8739ae039 = (0, $lq9mO.default);

});
parcelRegister("lq9mO", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9834ac36ee4cc31$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $eWJ8C = parcelRequire("eWJ8C");

var $8g1PZ = parcelRequire("8g1PZ");

var $gNc3A = parcelRequire("gNc3A");

var $jWR62 = parcelRequire("jWR62");

var $1pcHX = parcelRequire("1pcHX");

var $4257x = parcelRequire("4257x");

var $4a1I5 = parcelRequire("4a1I5");

parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $IFe7R = parcelRequire("IFe7R");

var $bbtWP = parcelRequire("bbtWP");

var $kUZsh = parcelRequire("kUZsh");
"use client";
const $f9834ac36ee4cc31$var$Collapse = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction, collapse: collapse } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, bordered: bordered = true, ghost: ghost, size: customizeSize, expandIconPosition: expandIconPosition = "start", children: children, expandIcon: expandIcon } = props;
    const mergedSize = (0, $IFe7R.default)((ctx)=>{
        var _a;
        return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : ctx) !== null && _a !== void 0 ? _a : "middle";
    });
    const prefixCls = getPrefixCls("collapse", customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const [wrapCSSVar, hashId] = (0, $kUZsh.default)(prefixCls);
    // Align with logic position
    const mergedExpandIconPosition = $acw62.useMemo(()=>{
        if (expandIconPosition === "left") return "start";
        return expandIconPosition === "right" ? "end" : expandIconPosition;
    }, [
        expandIconPosition
    ]);
    const renderExpandIcon = function() {
        let panelProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const icon = expandIcon ? expandIcon(panelProps) : /*#__PURE__*/ $acw62.createElement((0, $eWJ8C.default), {
            rotate: panelProps.isActive ? 90 : undefined
        });
        return (0, $4a1I5.cloneElement)(icon, ()=>({
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(icon.props.className, `${prefixCls}-arrow`)
            }));
    };
    const collapseClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(`${prefixCls}-icon-position-${mergedExpandIconPosition}`, {
        [`${prefixCls}-borderless`]: !bordered,
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-ghost`]: !!ghost,
        [`${prefixCls}-${mergedSize}`]: mergedSize !== "middle"
    }, collapse === null || collapse === void 0 ? void 0 : collapse.className, className, rootClassName, hashId);
    const openMotion = Object.assign(Object.assign({}, (0, $4257x.default)(rootPrefixCls)), {
        motionAppear: false,
        leavedClassName: `${prefixCls}-content-hidden`
    });
    const items = $acw62.useMemo(()=>children ? (0, $jWR62.default)(children).map((child, index)=>{
            var _a, _b;
            if ((_a = child.props) === null || _a === void 0 ? void 0 : _a.disabled) {
                const key = (_b = child.key) !== null && _b !== void 0 ? _b : String(index);
                const { disabled: disabled, collapsible: collapsible } = child.props;
                const childProps = Object.assign(Object.assign({}, (0, $1pcHX.default)(child.props, [
                    "disabled"
                ])), {
                    key: key,
                    collapsible: collapsible !== null && collapsible !== void 0 ? collapsible : disabled ? "disabled" : undefined
                });
                return (0, $4a1I5.cloneElement)(child, childProps);
            }
            return child;
        }) : null, [
        children
    ]);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $gNc3A.default), Object.assign({
        ref: ref,
        openMotion: openMotion
    }, (0, $1pcHX.default)(props, [
        "rootClassName"
    ]), {
        expandIcon: renderExpandIcon,
        prefixCls: prefixCls,
        className: collapseClassName,
        style: Object.assign(Object.assign({}, collapse === null || collapse === void 0 ? void 0 : collapse.style), style)
    }), items));
});
var $f9834ac36ee4cc31$export$2e2bcd8739ae039 = Object.assign($f9834ac36ee4cc31$var$Collapse, {
    Panel: (0, $bbtWP.default)
});

});
parcelRegister("eWJ8C", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae197ef38b34eab8$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $9Ubxp = parcelRequire("9Ubxp");

var $adRcI = parcelRequire("adRcI");
var $ae197ef38b34eab8$var$RightOutlined = function RightOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $adRcI.default), (0, $8nd05.default)({}, props, {
        ref: ref,
        icon: (0, $9Ubxp.default)
    }));
};
var $ae197ef38b34eab8$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($ae197ef38b34eab8$var$RightOutlined);

});
parcelRegister("9Ubxp", function(module, exports) {

$parcel$export(module.exports, "default", () => $73624b371df38195$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $73624b371df38195$var$RightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"
                }
            }
        ]
    },
    "name": "right",
    "theme": "outlined"
};
var $73624b371df38195$export$2e2bcd8739ae039 = $73624b371df38195$var$RightOutlined;

});


parcelRegister("gNc3A", function(module, exports) {

$parcel$export(module.exports, "default", () => $c39a932f4146e741$export$2e2bcd8739ae039);

var $4nQ0M = parcelRequire("4nQ0M");
var $c39a932f4146e741$export$2e2bcd8739ae039 = (0, $4nQ0M.default);
/**
 * @deprecated use `items` instead, will be removed in `v4.0.0`
 */ var $c39a932f4146e741$export$2ddb90ad54e5f587 = (0, $4nQ0M.default).Panel;

});
parcelRegister("4nQ0M", function(module, exports) {

$parcel$export(module.exports, "default", () => $3311a7ce873bb787$export$2e2bcd8739ae039);

var $kbxxf = parcelRequire("kbxxf");

var $eUqlC = parcelRequire("eUqlC");

var $fSwVM = parcelRequire("fSwVM");

var $8g1PZ = parcelRequire("8g1PZ");

var $iSQh8 = parcelRequire("iSQh8");

var $u43uR = parcelRequire("u43uR");

var $acw62 = parcelRequire("acw62");

var $73xFi = parcelRequire("73xFi");

var $4yobu = parcelRequire("4yobu");
function $3311a7ce873bb787$var$getActiveKeysArray(activeKey) {
    var currentActiveKey = activeKey;
    if (!Array.isArray(currentActiveKey)) {
        var activeKeyType = (0, $fSwVM.default)(currentActiveKey);
        currentActiveKey = activeKeyType === "number" || activeKeyType === "string" ? [
            currentActiveKey
        ] : [];
    }
    return currentActiveKey.map(function(key) {
        return String(key);
    });
}
var $3311a7ce873bb787$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-collapse" : _props$prefixCls, _props$destroyInactiv = props.destroyInactivePanel, destroyInactivePanel = _props$destroyInactiv === void 0 ? false : _props$destroyInactiv, style = props.style, accordion = props.accordion, className = props.className, children = props.children, collapsible = props.collapsible, openMotion = props.openMotion, expandIcon = props.expandIcon, rawActiveKey = props.activeKey, defaultActiveKey = props.defaultActiveKey, _onChange = props.onChange, items = props.items;
    var collapseClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, className);
    var _useMergedState = (0, $iSQh8.default)([], {
        value: rawActiveKey,
        onChange: function onChange(v) {
            return _onChange === null || _onChange === void 0 ? void 0 : _onChange(v);
        },
        defaultValue: defaultActiveKey,
        postState: $3311a7ce873bb787$var$getActiveKeysArray
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), activeKey = _useMergedState2[0], setActiveKey = _useMergedState2[1];
    var onItemClick = function onItemClick(key) {
        return setActiveKey(function() {
            if (accordion) return activeKey[0] === key ? [] : [
                key
            ];
            var index = activeKey.indexOf(key);
            var isActive = index > -1;
            if (isActive) return activeKey.filter(function(item) {
                return item !== key;
            });
            return [].concat((0, $kbxxf.default)(activeKey), [
                key
            ]);
        });
    };
    // ======================== Children ========================
    (0, $u43uR.default)(!children, "[rc-collapse] `children` will be removed in next major version. Please use `items` instead.");
    var mergedChildren = (0, $73xFi.default)(items, children, {
        prefixCls: prefixCls,
        accordion: accordion,
        openMotion: openMotion,
        expandIcon: expandIcon,
        collapsible: collapsible,
        destroyInactivePanel: destroyInactivePanel,
        onItemClick: onItemClick,
        activeKey: activeKey
    });
    // ======================== Render ========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: collapseClassName,
        style: style,
        role: accordion ? "tablist" : undefined
    }, mergedChildren);
});
var $3311a7ce873bb787$export$2e2bcd8739ae039 = Object.assign($3311a7ce873bb787$var$Collapse, {
    /**
   * @deprecated use `items` instead, will be removed in `v4.0.0`
   */ Panel: (0, $4yobu.default)
});

});
parcelRegister("73xFi", function(module, exports) {

$parcel$export(module.exports, "default", () => $5232ed645c6d7d63$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $jWR62 = parcelRequire("jWR62");

var $acw62 = parcelRequire("acw62");

var $4yobu = parcelRequire("4yobu");
var $5232ed645c6d7d63$var$_excluded = [
    "children",
    "label",
    "key",
    "collapsible",
    "onItemClick",
    "destroyInactivePanel"
];
var $5232ed645c6d7d63$var$convertItemsToNodes = function convertItemsToNodes(items, props) {
    var prefixCls = props.prefixCls, accordion = props.accordion, collapsible = props.collapsible, destroyInactivePanel = props.destroyInactivePanel, onItemClick = props.onItemClick, activeKey = props.activeKey, openMotion = props.openMotion, expandIcon = props.expandIcon;
    return items.map(function(item, index) {
        var children = item.children, label = item.label, rawKey = item.key, rawCollapsible = item.collapsible, rawOnItemClick = item.onItemClick, rawDestroyInactivePanel = item.destroyInactivePanel, restProps = (0, $9X7IJ.default)(item, $5232ed645c6d7d63$var$_excluded);
        // You may be puzzled why you want to convert them all into strings, me too.
        // Maybe: https://github.com/react-component/collapse/blob/aac303a8b6ff30e35060b4f8fecde6f4556fcbe2/src/Collapse.tsx#L15
        var key = String(rawKey !== null && rawKey !== void 0 ? rawKey : index);
        var mergeCollapsible = rawCollapsible !== null && rawCollapsible !== void 0 ? rawCollapsible : collapsible;
        var mergeDestroyInactivePanel = rawDestroyInactivePanel !== null && rawDestroyInactivePanel !== void 0 ? rawDestroyInactivePanel : destroyInactivePanel;
        var handleItemClick = function handleItemClick(value) {
            if (mergeCollapsible === "disabled") return;
            onItemClick(value);
            rawOnItemClick === null || rawOnItemClick === void 0 || rawOnItemClick(value);
        };
        var isActive = false;
        if (accordion) isActive = activeKey[0] === key;
        else isActive = activeKey.indexOf(key) > -1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4yobu.default), (0, $8nd05.default)({}, restProps, {
            prefixCls: prefixCls,
            key: key,
            panelKey: key,
            isActive: isActive,
            accordion: accordion,
            openMotion: openMotion,
            expandIcon: expandIcon,
            header: label,
            collapsible: mergeCollapsible,
            onItemClick: handleItemClick,
            destroyInactivePanel: mergeDestroyInactivePanel
        }), children);
    });
};
/**
 * @deprecated The next major version will be removed
 */ var $5232ed645c6d7d63$var$getNewChild = function getNewChild(child, index, props) {
    if (!child) return null;
    var prefixCls = props.prefixCls, accordion = props.accordion, collapsible = props.collapsible, destroyInactivePanel = props.destroyInactivePanel, onItemClick = props.onItemClick, activeKey = props.activeKey, openMotion = props.openMotion, expandIcon = props.expandIcon;
    var key = child.key || String(index);
    var _child$props = child.props, header = _child$props.header, headerClass = _child$props.headerClass, childDestroyInactivePanel = _child$props.destroyInactivePanel, childCollapsible = _child$props.collapsible, childOnItemClick = _child$props.onItemClick;
    var isActive = false;
    if (accordion) isActive = activeKey[0] === key;
    else isActive = activeKey.indexOf(key) > -1;
    var mergeCollapsible = childCollapsible !== null && childCollapsible !== void 0 ? childCollapsible : collapsible;
    var handleItemClick = function handleItemClick(value) {
        if (mergeCollapsible === "disabled") return;
        onItemClick(value);
        childOnItemClick === null || childOnItemClick === void 0 || childOnItemClick(value);
    };
    var childProps = {
        key: key,
        panelKey: key,
        header: header,
        headerClass: headerClass,
        isActive: isActive,
        prefixCls: prefixCls,
        destroyInactivePanel: childDestroyInactivePanel !== null && childDestroyInactivePanel !== void 0 ? childDestroyInactivePanel : destroyInactivePanel,
        openMotion: openMotion,
        accordion: accordion,
        children: child.props.children,
        onItemClick: handleItemClick,
        expandIcon: expandIcon,
        collapsible: mergeCollapsible
    };
    // https://github.com/ant-design/ant-design/issues/20479
    if (typeof child.type === "string") return child;
    Object.keys(childProps).forEach(function(propName) {
        if (typeof childProps[propName] === "undefined") delete childProps[propName];
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, childProps);
};
function $5232ed645c6d7d63$var$useItems(items, rawChildren, props) {
    if (Array.isArray(items)) return $5232ed645c6d7d63$var$convertItemsToNodes(items, props);
    return (0, $jWR62.default)(rawChildren).map(function(child, index) {
        return $5232ed645c6d7d63$var$getNewChild(child, index, props);
    });
}
var $5232ed645c6d7d63$export$2e2bcd8739ae039 = $5232ed645c6d7d63$var$useItems;

});
parcelRegister("4yobu", function(module, exports) {

$parcel$export(module.exports, "default", () => $350d18e6f82391e6$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $9X7IJ = parcelRequire("9X7IJ");

var $8g1PZ = parcelRequire("8g1PZ");

var $8iiJy = parcelRequire("8iiJy");

var $iCi4s = parcelRequire("iCi4s");

var $acw62 = parcelRequire("acw62");

var $5o2Yr = parcelRequire("5o2Yr");
var $350d18e6f82391e6$var$_excluded = [
    "showArrow",
    "headerClass",
    "isActive",
    "onItemClick",
    "forceRender",
    "className",
    "prefixCls",
    "collapsible",
    "accordion",
    "panelKey",
    "extra",
    "header",
    "expandIcon",
    "openMotion",
    "destroyInactivePanel",
    "children"
];
var $350d18e6f82391e6$var$CollapsePanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var _classNames, _classNames2;
    var _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow, headerClass = props.headerClass, isActive = props.isActive, onItemClick = props.onItemClick, forceRender = props.forceRender, className = props.className, prefixCls = props.prefixCls, collapsible = props.collapsible, accordion = props.accordion, panelKey = props.panelKey, extra = props.extra, header = props.header, expandIcon = props.expandIcon, openMotion = props.openMotion, destroyInactivePanel = props.destroyInactivePanel, children = props.children, resetProps = (0, $9X7IJ.default)(props, $350d18e6f82391e6$var$_excluded);
    var disabled = collapsible === "disabled";
    var collapsibleHeader = collapsible === "header";
    var collapsibleIcon = collapsible === "icon";
    var ifExtraExist = extra !== null && extra !== undefined && typeof extra !== "boolean";
    var handleItemClick = function handleItemClick() {
        onItemClick === null || onItemClick === void 0 || onItemClick(panelKey);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === "Enter" || e.keyCode === (0, $iCi4s.default).ENTER || e.which === (0, $iCi4s.default).ENTER) handleItemClick();
    };
    // ======================== Icon ========================
    var iconNode = typeof expandIcon === "function" ? expandIcon(props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
        className: "arrow"
    });
    if (iconNode) iconNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat(prefixCls, "-expand-icon"),
        onClick: [
            "header",
            "icon"
        ].includes(collapsible) ? handleItemClick : undefined
    }, iconNode);
    var collapsePanelClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-item"), true), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-item-active"), isActive), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-item-disabled"), disabled), _classNames), className);
    var headerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(headerClass, (_classNames2 = {}, (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-header"), true), (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-header-collapsible-only"), collapsibleHeader), (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-icon-collapsible-only"), collapsibleIcon), _classNames2));
    // ======================== HeaderProps ========================
    var headerProps = {
        className: headerClassName,
        "aria-expanded": isActive,
        "aria-disabled": disabled,
        onKeyDown: handleKeyDown
    };
    if (!collapsibleHeader && !collapsibleIcon) {
        headerProps.onClick = handleItemClick;
        headerProps.role = accordion ? "tab" : "button";
        headerProps.tabIndex = disabled ? -1 : 0;
    }
    // ======================== Render ========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, $8nd05.default)({}, resetProps, {
        ref: ref,
        className: collapsePanelClassNames
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", headerProps, showArrow && iconNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "".concat(prefixCls, "-header-text"),
        onClick: collapsible === "header" ? handleItemClick : undefined
    }, header), ifExtraExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat(prefixCls, "-extra")
    }, extra)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8iiJy.default), (0, $8nd05.default)({
        visible: isActive,
        leavedClassName: "".concat(prefixCls, "-content-hidden")
    }, openMotion, {
        forceRender: forceRender,
        removeOnLeave: destroyInactivePanel
    }), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5o2Yr.default), {
            ref: motionRef,
            prefixCls: prefixCls,
            className: motionClassName,
            style: motionStyle,
            isActive: isActive,
            forceRender: forceRender,
            role: accordion ? "tabpanel" : void 0
        }, children);
    }));
});
var $350d18e6f82391e6$export$2e2bcd8739ae039 = $350d18e6f82391e6$var$CollapsePanel;

});
parcelRegister("5o2Yr", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ec18031647490fe$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
var $3ec18031647490fe$var$PanelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var _classnames;
    var prefixCls = props.prefixCls, forceRender = props.forceRender, className = props.className, style = props.style, children = props.children, isActive = props.isActive, role = props.role;
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(isActive || forceRender), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), rendered = _React$useState2[0], setRendered = _React$useState2[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        if (forceRender || isActive) setRendered(true);
    }, [
        forceRender,
        isActive
    ]);
    if (!rendered) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-content"), (_classnames = {}, (0, $kSlfw.default)(_classnames, "".concat(prefixCls, "-content-active"), isActive), (0, $kSlfw.default)(_classnames, "".concat(prefixCls, "-content-inactive"), !isActive), _classnames), className),
        style: style,
        role: role
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat(prefixCls, "-content-box")
    }, children));
});
$3ec18031647490fe$var$PanelContent.displayName = "PanelContent";
var $3ec18031647490fe$export$2e2bcd8739ae039 = $3ec18031647490fe$var$PanelContent;

});





parcelRegister("bbtWP", function(module, exports) {

$parcel$export(module.exports, "default", () => $8247f3cd58331054$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $gNc3A = parcelRequire("gNc3A");

parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");
"use client";
const $8247f3cd58331054$var$CollapsePanel = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const { prefixCls: customizePrefixCls, className: className, showArrow: showArrow = true } = props;
    const prefixCls = getPrefixCls("collapse", customizePrefixCls);
    const collapsePanelClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
        [`${prefixCls}-no-arrow`]: !showArrow
    }, className);
    return /*#__PURE__*/ $acw62.createElement((0, $gNc3A.default).Panel, Object.assign({
        ref: ref
    }, props, {
        prefixCls: prefixCls,
        className: collapsePanelClassName
    }));
});
var $8247f3cd58331054$export$2e2bcd8739ae039 = $8247f3cd58331054$var$CollapsePanel;

});

parcelRegister("kUZsh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3a8b55181e5e7fb$export$2e2bcd8739ae039);
parcelRequire("3i86m");
var $lpQ06 = parcelRequire("lpQ06");

var $670jt = parcelRequire("670jt");

var $cfu1t = parcelRequire("cfu1t");

var $P8Drj = parcelRequire("P8Drj");
var $2LRCS = parcelRequire("2LRCS");
const $f3a8b55181e5e7fb$export$5ca74f7be820a85 = (token)=>{
    const { componentCls: componentCls, contentBg: contentBg, padding: padding, headerBg: headerBg, headerPadding: headerPadding, collapseHeaderPaddingSM: collapseHeaderPaddingSM, collapseHeaderPaddingLG: collapseHeaderPaddingLG, collapsePanelBorderRadius: collapsePanelBorderRadius, lineWidth: lineWidth, lineType: lineType, colorBorder: colorBorder, colorText: colorText, colorTextHeading: colorTextHeading, colorTextDisabled: colorTextDisabled, fontSizeLG: fontSizeLG, lineHeight: lineHeight, lineHeightLG: lineHeightLG, marginSM: marginSM, paddingSM: paddingSM, paddingLG: paddingLG, paddingXS: paddingXS, motionDurationSlow: motionDurationSlow, fontSizeIcon: fontSizeIcon, contentPadding: contentPadding, fontHeight: fontHeight, fontHeightLG: fontHeightLG } = token;
    const borderBase = `${(0, $lpQ06.unit)(lineWidth)} ${lineType} ${colorBorder}`;
    return {
        [componentCls]: Object.assign(Object.assign({}, (0, $670jt.resetComponent)(token)), {
            backgroundColor: headerBg,
            border: borderBase,
            borderBottom: 0,
            borderRadius: collapsePanelBorderRadius,
            [`&-rtl`]: {
                direction: "rtl"
            },
            [`& > ${componentCls}-item`]: {
                borderBottom: borderBase,
                [`&:last-child`]: {
                    [`
            &,
            & > ${componentCls}-header`]: {
                        borderRadius: `0 0 ${(0, $lpQ06.unit)(collapsePanelBorderRadius)} ${(0, $lpQ06.unit)(collapsePanelBorderRadius)}`
                    }
                },
                [`> ${componentCls}-header`]: {
                    position: "relative",
                    // Compatible with old version of antd, should remove in next version
                    display: "flex",
                    flexWrap: "nowrap",
                    alignItems: "flex-start",
                    padding: headerPadding,
                    color: colorTextHeading,
                    lineHeight: lineHeight,
                    cursor: "pointer",
                    transition: `all ${motionDurationSlow}, visibility 0s`,
                    [`> ${componentCls}-header-text`]: {
                        flex: "auto"
                    },
                    "&:focus": {
                        outline: "none"
                    },
                    // >>>>> Arrow
                    [`${componentCls}-expand-icon`]: {
                        height: fontHeight,
                        display: "flex",
                        alignItems: "center",
                        paddingInlineEnd: marginSM
                    },
                    [`${componentCls}-arrow`]: Object.assign(Object.assign({}, (0, $670jt.resetIcon)()), {
                        fontSize: fontSizeIcon,
                        svg: {
                            transition: `transform ${motionDurationSlow}`
                        }
                    }),
                    // >>>>> Text
                    [`${componentCls}-header-text`]: {
                        marginInlineEnd: "auto"
                    }
                },
                [`${componentCls}-icon-collapsible-only`]: {
                    cursor: "unset",
                    [`${componentCls}-expand-icon`]: {
                        cursor: "pointer"
                    }
                }
            },
            [`${componentCls}-content`]: {
                color: colorText,
                backgroundColor: contentBg,
                borderTop: borderBase,
                [`& > ${componentCls}-content-box`]: {
                    padding: contentPadding
                },
                [`&-hidden`]: {
                    display: "none"
                }
            },
            [`&-small`]: {
                [`> ${componentCls}-item`]: {
                    [`> ${componentCls}-header`]: {
                        padding: collapseHeaderPaddingSM,
                        paddingInlineStart: paddingXS,
                        [`> ${componentCls}-expand-icon`]: {
                            // Arrow offset
                            marginInlineStart: token.calc(paddingSM).sub(paddingXS).equal()
                        }
                    },
                    [`> ${componentCls}-content > ${componentCls}-content-box`]: {
                        padding: paddingSM
                    }
                }
            },
            [`&-large`]: {
                [`> ${componentCls}-item`]: {
                    fontSize: fontSizeLG,
                    lineHeight: lineHeightLG,
                    [`> ${componentCls}-header`]: {
                        padding: collapseHeaderPaddingLG,
                        paddingInlineStart: padding,
                        [`> ${componentCls}-expand-icon`]: {
                            height: fontHeightLG,
                            // Arrow offset
                            marginInlineStart: token.calc(paddingLG).sub(padding).equal()
                        }
                    },
                    [`> ${componentCls}-content > ${componentCls}-content-box`]: {
                        padding: paddingLG
                    }
                }
            },
            [`${componentCls}-item:last-child`]: {
                [`> ${componentCls}-content`]: {
                    borderRadius: `0 0 ${(0, $lpQ06.unit)(collapsePanelBorderRadius)} ${(0, $lpQ06.unit)(collapsePanelBorderRadius)}`
                }
            },
            [`& ${componentCls}-item-disabled > ${componentCls}-header`]: {
                [`
          &,
          & > .arrow
        `]: {
                    color: colorTextDisabled,
                    cursor: "not-allowed"
                }
            },
            // ========================== Icon Position ==========================
            [`&${componentCls}-icon-position-end`]: {
                [`& > ${componentCls}-item`]: {
                    [`> ${componentCls}-header`]: {
                        [`${componentCls}-expand-icon`]: {
                            order: 1,
                            paddingInlineEnd: 0,
                            paddingInlineStart: marginSM
                        }
                    }
                }
            }
        })
    };
};
const $f3a8b55181e5e7fb$var$genArrowStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const fixedSelector = `> ${componentCls}-item > ${componentCls}-header ${componentCls}-arrow svg`;
    return {
        [`${componentCls}-rtl`]: {
            [fixedSelector]: {
                transform: `rotate(180deg)`
            }
        }
    };
};
const $f3a8b55181e5e7fb$var$genBorderlessStyle = (token)=>{
    const { componentCls: componentCls, headerBg: headerBg, paddingXXS: paddingXXS, colorBorder: colorBorder } = token;
    return {
        [`${componentCls}-borderless`]: {
            backgroundColor: headerBg,
            border: 0,
            [`> ${componentCls}-item`]: {
                borderBottom: `1px solid ${colorBorder}`
            },
            [`
        > ${componentCls}-item:last-child,
        > ${componentCls}-item:last-child ${componentCls}-header
      `]: {
                borderRadius: 0
            },
            [`> ${componentCls}-item:last-child`]: {
                borderBottom: 0
            },
            [`> ${componentCls}-item > ${componentCls}-content`]: {
                backgroundColor: "transparent",
                borderTop: 0
            },
            [`> ${componentCls}-item > ${componentCls}-content > ${componentCls}-content-box`]: {
                paddingTop: paddingXXS
            }
        }
    };
};
const $f3a8b55181e5e7fb$var$genGhostStyle = (token)=>{
    const { componentCls: componentCls, paddingSM: paddingSM } = token;
    return {
        [`${componentCls}-ghost`]: {
            backgroundColor: "transparent",
            border: 0,
            [`> ${componentCls}-item`]: {
                borderBottom: 0,
                [`> ${componentCls}-content`]: {
                    backgroundColor: "transparent",
                    border: 0,
                    [`> ${componentCls}-content-box`]: {
                        paddingBlock: paddingSM
                    }
                }
            }
        }
    };
};
const $f3a8b55181e5e7fb$export$9ca1be8807fe0675 = (token)=>({
        headerPadding: `${token.paddingSM}px ${token.padding}px`,
        headerBg: token.colorFillAlter,
        contentPadding: `${token.padding}px 16px`,
        // Fixed Value
        contentBg: token.colorBgContainer
    });
var $f3a8b55181e5e7fb$export$2e2bcd8739ae039 = (0, $P8Drj.genStyleHooks)("Collapse", (token)=>{
    const collapseToken = (0, $2LRCS.merge)(token, {
        collapseHeaderPaddingSM: `${(0, $lpQ06.unit)(token.paddingXS)} ${(0, $lpQ06.unit)(token.paddingSM)}`,
        collapseHeaderPaddingLG: `${(0, $lpQ06.unit)(token.padding)} ${(0, $lpQ06.unit)(token.paddingLG)}`,
        collapsePanelBorderRadius: token.borderRadiusLG
    });
    return [
        $f3a8b55181e5e7fb$export$5ca74f7be820a85(collapseToken),
        $f3a8b55181e5e7fb$var$genBorderlessStyle(collapseToken),
        $f3a8b55181e5e7fb$var$genGhostStyle(collapseToken),
        $f3a8b55181e5e7fb$var$genArrowStyle(collapseToken),
        (0, $cfu1t.default)(collapseToken)
    ];
}, $f3a8b55181e5e7fb$export$9ca1be8807fe0675);

});
parcelRegister("cfu1t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8eae2cab6b8e600b$export$2e2bcd8739ae039);
const $8eae2cab6b8e600b$var$genCollapseMotion = (token)=>({
        [token.componentCls]: {
            // For common/openAnimation
            [`${token.antCls}-motion-collapse-legacy`]: {
                overflow: "hidden",
                "&-active": {
                    transition: `height ${token.motionDurationMid} ${token.motionEaseInOut},
        opacity ${token.motionDurationMid} ${token.motionEaseInOut} !important`
                }
            },
            [`${token.antCls}-motion-collapse`]: {
                overflow: "hidden",
                transition: `height ${token.motionDurationMid} ${token.motionEaseInOut},
        opacity ${token.motionDurationMid} ${token.motionEaseInOut} !important`
            }
        }
    });
var $8eae2cab6b8e600b$export$2e2bcd8739ae039 = $8eae2cab6b8e600b$var$genCollapseMotion;

});




parcelRegister("h5DBq", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7119f916fc54765$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $1pcHX = parcelRequire("1pcHX");

var $hMaQy = parcelRequire("hMaQy");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $8zQmX = parcelRequire("8zQmX");

var $5XBQv = parcelRequire("5XBQv");
"use client";
var $c7119f916fc54765$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $c7119f916fc54765$var$Flex = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, rootClassName: rootClassName, className: className, style: style, flex: flex, gap: gap, children: children, vertical: vertical = false, component: Component = "div" } = props, othersProps = $c7119f916fc54765$var$__rest(props, [
        "prefixCls",
        "rootClassName",
        "className",
        "style",
        "flex",
        "gap",
        "children",
        "vertical",
        "component"
    ]);
    const { flex: ctxFlex, direction: ctxDirection, getPrefixCls: getPrefixCls } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $dRTnM.ConfigContext));
    const prefixCls = getPrefixCls("flex", customizePrefixCls);
    const [wrapCSSVar, hashId] = (0, $8zQmX.default)(prefixCls);
    const mergedVertical = vertical !== null && vertical !== void 0 ? vertical : ctxFlex === null || ctxFlex === void 0 ? void 0 : ctxFlex.vertical;
    const mergedCls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, rootClassName, ctxFlex === null || ctxFlex === void 0 ? void 0 : ctxFlex.className, prefixCls, hashId, (0, $5XBQv.default)(prefixCls, props), {
        [`${prefixCls}-rtl`]: ctxDirection === "rtl",
        [`${prefixCls}-gap-${gap}`]: (0, $hMaQy.isPresetSize)(gap),
        [`${prefixCls}-vertical`]: mergedVertical
    });
    const mergedStyle = Object.assign(Object.assign({}, ctxFlex === null || ctxFlex === void 0 ? void 0 : ctxFlex.style), style);
    if (flex) mergedStyle.flex = flex;
    if (gap && !(0, $hMaQy.isPresetSize)(gap)) mergedStyle.gap = gap;
    return wrapCSSVar(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, Object.assign({
        ref: ref,
        className: mergedCls,
        style: mergedStyle
    }, (0, $1pcHX.default)(othersProps, [
        "justify",
        "wrap",
        "align"
    ])), children));
});
var $c7119f916fc54765$export$2e2bcd8739ae039 = $c7119f916fc54765$var$Flex;

});
parcelRegister("hMaQy", function(module, exports) {

$parcel$export(module.exports, "isPresetSize", () => $cf0f554ddf4da10f$export$f5153c3888a6824e);
function $cf0f554ddf4da10f$export$f5153c3888a6824e(size) {
    return [
        "small",
        "middle",
        "large"
    ].includes(size);
}
function $cf0f554ddf4da10f$export$1b502d0a9135d42b(size) {
    if (!size) // The case of size = 0 is deliberately excluded here, because the default value of the gap attribute in CSS is 0, so if the user passes 0 in, we can directly ignore it.
    return false;
    return typeof size === "number" && !Number.isNaN(size);
}

});

parcelRegister("8zQmX", function(module, exports) {

$parcel$export(module.exports, "default", () => $63ea37159c444462$export$2e2bcd8739ae039);

var $P8Drj = parcelRequire("P8Drj");
var $2LRCS = parcelRequire("2LRCS");

var $5XBQv = parcelRequire("5XBQv");
const $63ea37159c444462$var$genFlexStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            display: "flex",
            "&-vertical": {
                flexDirection: "column"
            },
            "&-rtl": {
                direction: "rtl"
            },
            "&:empty": {
                display: "none"
            }
        }
    };
};
const $63ea37159c444462$var$genFlexGapStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            "&-gap-small": {
                gap: token.flexGapSM
            },
            "&-gap-middle": {
                gap: token.flexGap
            },
            "&-gap-large": {
                gap: token.flexGapLG
            }
        }
    };
};
const $63ea37159c444462$var$genFlexWrapStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const wrapStyle = {};
    (0, $5XBQv.flexWrapValues).forEach((value)=>{
        wrapStyle[`${componentCls}-wrap-${value}`] = {
            flexWrap: value
        };
    });
    return wrapStyle;
};
const $63ea37159c444462$var$genAlignItemsStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const alignStyle = {};
    (0, $5XBQv.alignItemsValues).forEach((value)=>{
        alignStyle[`${componentCls}-align-${value}`] = {
            alignItems: value
        };
    });
    return alignStyle;
};
const $63ea37159c444462$var$genJustifyContentStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const justifyStyle = {};
    (0, $5XBQv.justifyContentValues).forEach((value)=>{
        justifyStyle[`${componentCls}-justify-${value}`] = {
            justifyContent: value
        };
    });
    return justifyStyle;
};
const $63ea37159c444462$export$9ca1be8807fe0675 = ()=>({});
var $63ea37159c444462$export$2e2bcd8739ae039 = (0, $P8Drj.genStyleHooks)("Flex", (token)=>{
    const { paddingXS: paddingXS, padding: padding, paddingLG: paddingLG } = token;
    const flexToken = (0, $2LRCS.merge)(token, {
        flexGapSM: paddingXS,
        flexGap: padding,
        flexGapLG: paddingLG
    });
    return [
        $63ea37159c444462$var$genFlexStyle(flexToken),
        $63ea37159c444462$var$genFlexGapStyle(flexToken),
        $63ea37159c444462$var$genFlexWrapStyle(flexToken),
        $63ea37159c444462$var$genAlignItemsStyle(flexToken),
        $63ea37159c444462$var$genJustifyContentStyle(flexToken)
    ];
}, $63ea37159c444462$export$9ca1be8807fe0675);

});
parcelRegister("5XBQv", function(module, exports) {

$parcel$export(module.exports, "flexWrapValues", () => $456fd1d46e9f26d7$export$6773a72e15c6c21d);
$parcel$export(module.exports, "justifyContentValues", () => $456fd1d46e9f26d7$export$fc1ed670ad7f670d);
$parcel$export(module.exports, "alignItemsValues", () => $456fd1d46e9f26d7$export$4a0bd4174fc92cb3);
$parcel$export(module.exports, "default", () => $456fd1d46e9f26d7$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");
const $456fd1d46e9f26d7$export$6773a72e15c6c21d = [
    "wrap",
    "nowrap",
    "wrap-reverse"
];
const $456fd1d46e9f26d7$export$fc1ed670ad7f670d = [
    "flex-start",
    "flex-end",
    "start",
    "end",
    "center",
    "space-between",
    "space-around",
    "space-evenly",
    "stretch",
    "normal",
    "left",
    "right"
];
const $456fd1d46e9f26d7$export$4a0bd4174fc92cb3 = [
    "center",
    "start",
    "end",
    "flex-start",
    "flex-end",
    "self-start",
    "self-end",
    "baseline",
    "normal",
    "stretch"
];
const $456fd1d46e9f26d7$var$genClsWrap = (prefixCls, props)=>{
    const wrapCls = {};
    $456fd1d46e9f26d7$export$6773a72e15c6c21d.forEach((cssKey)=>{
        wrapCls[`${prefixCls}-wrap-${cssKey}`] = props.wrap === cssKey;
    });
    return wrapCls;
};
const $456fd1d46e9f26d7$var$genClsAlign = (prefixCls, props)=>{
    const alignCls = {};
    $456fd1d46e9f26d7$export$4a0bd4174fc92cb3.forEach((cssKey)=>{
        alignCls[`${prefixCls}-align-${cssKey}`] = props.align === cssKey;
    });
    alignCls[`${prefixCls}-align-stretch`] = !props.align && !!props.vertical;
    return alignCls;
};
const $456fd1d46e9f26d7$var$genClsJustify = (prefixCls, props)=>{
    const justifyCls = {};
    $456fd1d46e9f26d7$export$fc1ed670ad7f670d.forEach((cssKey)=>{
        justifyCls[`${prefixCls}-justify-${cssKey}`] = props.justify === cssKey;
    });
    return justifyCls;
};
function $456fd1d46e9f26d7$var$createFlexClassNames(prefixCls, props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(Object.assign(Object.assign(Object.assign({}, $456fd1d46e9f26d7$var$genClsWrap(prefixCls, props)), $456fd1d46e9f26d7$var$genClsAlign(prefixCls, props)), $456fd1d46e9f26d7$var$genClsJustify(prefixCls, props)));
}
var $456fd1d46e9f26d7$export$2e2bcd8739ae039 = $456fd1d46e9f26d7$var$createFlexClassNames;

});



parcelRegister("eTcXV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad70426818bb52aa$export$2e2bcd8739ae039);

var $eWEm4 = parcelRequire("eWEm4");

var $7aL1y = parcelRequire("7aL1y");

var $3phh6 = parcelRequire("3phh6");

var $2Xl9q = parcelRequire("2Xl9q");

var $lEgf5 = parcelRequire("lEgf5");
"use client";
const $ad70426818bb52aa$var$Input = (0, $7aL1y.default);
$ad70426818bb52aa$var$Input.Group = (0, $eWEm4.default);
$ad70426818bb52aa$var$Input.Search = (0, $2Xl9q.default);
$ad70426818bb52aa$var$Input.TextArea = (0, $lEgf5.default);
$ad70426818bb52aa$var$Input.Password = (0, $3phh6.default);
var $ad70426818bb52aa$export$2e2bcd8739ae039 = $ad70426818bb52aa$var$Input;

});
parcelRegister("eWEm4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae15c91e7f32cbed$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $eSOz6 = parcelRequire("eSOz6");

var $317P8 = parcelRequire("317P8");
"use client";
const $ae15c91e7f32cbed$var$Group = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = (0, $acw62.useContext)((0, $dRTnM.ConfigContext));
    const { prefixCls: customizePrefixCls, className: className } = props;
    const prefixCls = getPrefixCls("input-group", customizePrefixCls);
    const inputPrefixCls = getPrefixCls("input");
    const [wrapCSSVar, hashId] = (0, $317P8.default)(inputPrefixCls);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, {
        [`${prefixCls}-lg`]: props.size === "large",
        [`${prefixCls}-sm`]: props.size === "small",
        [`${prefixCls}-compact`]: props.compact,
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, hashId, className);
    const formItemContext = (0, $acw62.useContext)((0, $eSOz6.FormItemInputContext));
    const groupFormItemContext = (0, $acw62.useMemo)(()=>Object.assign(Object.assign({}, formItemContext), {
            isFormItemInput: false
        }), [
        formItemContext
    ]);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("span", {
        className: cls,
        style: props.style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onFocus: props.onFocus,
        onBlur: props.onBlur
    }, /*#__PURE__*/ $acw62.createElement((0, $eSOz6.FormItemInputContext).Provider, {
        value: groupFormItemContext
    }, props.children)));
};
var $ae15c91e7f32cbed$export$2e2bcd8739ae039 = $ae15c91e7f32cbed$var$Group;

});
parcelRegister("eSOz6", function(module, exports) {

$parcel$export(module.exports, "FormItemInputContext", () => $ad5d550b51ac8abd$export$bbb5553c6c7a14ed);
$parcel$export(module.exports, "NoFormStyle", () => $ad5d550b51ac8abd$export$80e4c53cb85dcab1);

var $acw62 = parcelRequire("acw62");
parcelRequire("8a8Nr");
var $144QO = parcelRequire("144QO");

var $1pcHX = parcelRequire("1pcHX");
"use client";
const $ad5d550b51ac8abd$export$c24727297075ec6a = /*#__PURE__*/ $acw62.createContext({
    labelAlign: "right",
    vertical: false,
    itemRef: ()=>{}
});
const $ad5d550b51ac8abd$export$d718247e9f9b0b9e = /*#__PURE__*/ $acw62.createContext(null);
const $ad5d550b51ac8abd$export$8ce1ff4f94d08846 = (props)=>{
    const providerProps = (0, $1pcHX.default)(props, [
        "prefixCls"
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $144QO.FormProvider), Object.assign({}, providerProps));
};
const $ad5d550b51ac8abd$export$fb6582d3042cc879 = /*#__PURE__*/ $acw62.createContext({
    prefixCls: ""
});
const $ad5d550b51ac8abd$export$bbb5553c6c7a14ed = /*#__PURE__*/ $acw62.createContext({});
const $ad5d550b51ac8abd$export$80e4c53cb85dcab1 = (_ref)=>{
    let { children: children, status: status, override: override } = _ref;
    const formItemInputContext = (0, $acw62.useContext)($ad5d550b51ac8abd$export$bbb5553c6c7a14ed);
    const newFormItemInputContext = (0, $acw62.useMemo)(()=>{
        const newContext = Object.assign({}, formItemInputContext);
        if (override) delete newContext.isFormItemInput;
        if (status) {
            delete newContext.status;
            delete newContext.hasFeedback;
            delete newContext.feedbackIcon;
        }
        return newContext;
    }, [
        status,
        override,
        formItemInputContext
    ]);
    return /*#__PURE__*/ $acw62.createElement($ad5d550b51ac8abd$export$bbb5553c6c7a14ed.Provider, {
        value: newFormItemInputContext
    }, children);
};

});
parcelRegister("8a8Nr", function(module, exports) {

$parcel$export(module.exports, "FormProvider", () => (parcelRequire("144QO")).FormProvider);

var $acw62 = parcelRequire("acw62");

var $4llrF = parcelRequire("4llrF");

var $2iMfo = parcelRequire("2iMfo");

var $dRl3b = parcelRequire("dRl3b");

var $akLVU = parcelRequire("akLVU");

var $144QO = parcelRequire("144QO");

var $260BS = parcelRequire("260BS");

var $livSf = parcelRequire("livSf");

var $gPDhi = parcelRequire("gPDhi");
var $5f1614ae44e69c1b$var$InternalForm = /*#__PURE__*/ $acw62.forwardRef((0, $akLVU.default));
var $5f1614ae44e69c1b$var$RefForm = $5f1614ae44e69c1b$var$InternalForm;
$5f1614ae44e69c1b$var$RefForm.FormProvider = (0, $144QO.FormProvider);
$5f1614ae44e69c1b$var$RefForm.Field = (0, $4llrF.default);
$5f1614ae44e69c1b$var$RefForm.List = (0, $2iMfo.default);
$5f1614ae44e69c1b$var$RefForm.useForm = (0, $dRl3b.default);
$5f1614ae44e69c1b$var$RefForm.useWatch = (0, $gPDhi.default);
var $5f1614ae44e69c1b$export$2e2bcd8739ae039 = $5f1614ae44e69c1b$var$RefForm;

});
parcelRegister("4llrF", function(module, exports) {

$parcel$export(module.exports, "default", () => $3299c229146a7fb5$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $cqPKg = parcelRequire("cqPKg");

var $5wm0G = parcelRequire("5wm0G");

var $d49SP = parcelRequire("d49SP");

var $kbxxf = parcelRequire("kbxxf");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $jWR62 = parcelRequire("jWR62");

var $4AFGH = parcelRequire("4AFGH");

var $u43uR = parcelRequire("u43uR");

var $acw62 = parcelRequire("acw62");

var $260BS = parcelRequire("260BS");

var $livSf = parcelRequire("livSf");

var $hhXFI = parcelRequire("hhXFI");

var $8MG7S = parcelRequire("8MG7S");

var $kFGlN = parcelRequire("kFGlN");
var $23Gye = parcelRequire("23Gye");
var $3299c229146a7fb5$var$_excluded = [
    "name"
];
var $3299c229146a7fb5$var$EMPTY_ERRORS = [];
function $3299c229146a7fb5$var$requireUpdate(shouldUpdate, prev, next, prevValue, nextValue, info) {
    if (typeof shouldUpdate === "function") return shouldUpdate(prev, next, "source" in info ? {
        source: info.source
    } : {});
    return prevValue !== nextValue;
}
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
// We use Class instead of Hooks here since it will cost much code by using Hooks.
var $3299c229146a7fb5$var$Field = /*#__PURE__*/ function(_React$Component) {
    (0, $1gYAD.default)(Field, _React$Component);
    var _super = (0, $enfmq.default)(Field);
    // ============================== Subscriptions ==============================
    function Field(props) {
        var _this;
        (0, $6CZeq.default)(this, Field);
        _this = _super.call(this, props);
        // Register on init
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "state", {
            resetCount: 0
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "cancelRegisterFunc", null);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "mounted", false);
        /**
     * Follow state should not management in State since it will async update by React.
     * This makes first render of form can not get correct state value.
     */ (0, $kSlfw.default)((0, $hDpcU.default)(_this), "touched", false);
        /**
     * Mark when touched & validated. Currently only used for `dependencies`.
     * Note that we do not think field with `initialValue` is dirty
     * but this will be by `isFieldDirty` func.
     */ (0, $kSlfw.default)((0, $hDpcU.default)(_this), "dirty", false);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "validatePromise", void 0);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "prevValidating", void 0);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "errors", $3299c229146a7fb5$var$EMPTY_ERRORS);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "warnings", $3299c229146a7fb5$var$EMPTY_ERRORS);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "cancelRegister", function() {
            var _this$props = _this.props, preserve = _this$props.preserve, isListField = _this$props.isListField, name = _this$props.name;
            if (_this.cancelRegisterFunc) _this.cancelRegisterFunc(isListField, preserve, (0, $kFGlN.getNamePath)(name));
            _this.cancelRegisterFunc = null;
        });
        // ================================== Utils ==================================
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "getNamePath", function() {
            var _this$props2 = _this.props, name = _this$props2.name, fieldContext = _this$props2.fieldContext;
            var _fieldContext$prefixN = fieldContext.prefixName, prefixName = _fieldContext$prefixN === void 0 ? [] : _fieldContext$prefixN;
            return name !== undefined ? [].concat((0, $kbxxf.default)(prefixName), (0, $kbxxf.default)(name)) : [];
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "getRules", function() {
            var _this$props3 = _this.props, _this$props3$rules = _this$props3.rules, rules = _this$props3$rules === void 0 ? [] : _this$props3$rules, fieldContext = _this$props3.fieldContext;
            return rules.map(function(rule) {
                if (typeof rule === "function") return rule(fieldContext);
                return rule;
            });
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "refresh", function() {
            if (!_this.mounted) return;
            /**
       * Clean up current node.
       */ _this.setState(function(_ref) {
                var resetCount = _ref.resetCount;
                return {
                    resetCount: resetCount + 1
                };
            });
        });
        // Event should only trigger when meta changed
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "metaCache", null);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "triggerMetaEvent", function(destroy) {
            var onMetaChange = _this.props.onMetaChange;
            if (onMetaChange) {
                var _meta = (0, $d49SP.default)((0, $d49SP.default)({}, _this.getMeta()), {}, {
                    destroy: destroy
                });
                if (!(0, $4AFGH.default)(_this.metaCache, _meta)) onMetaChange(_meta);
                _this.metaCache = _meta;
            } else _this.metaCache = null;
        });
        // ========================= Field Entity Interfaces =========================
        // Trigger by store update. Check if need update the component
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "onStoreChange", function(prevStore, namePathList, info) {
            var _this$props4 = _this.props, shouldUpdate = _this$props4.shouldUpdate, _this$props4$dependen = _this$props4.dependencies, dependencies = _this$props4$dependen === void 0 ? [] : _this$props4$dependen, onReset = _this$props4.onReset;
            var store = info.store;
            var namePath = _this.getNamePath();
            var prevValue = _this.getValue(prevStore);
            var curValue = _this.getValue(store);
            var namePathMatch = namePathList && (0, $kFGlN.containsNamePath)(namePathList, namePath);
            // `setFieldsValue` is a quick access to update related status
            if (info.type === "valueUpdate" && info.source === "external" && prevValue !== curValue) {
                _this.touched = true;
                _this.dirty = true;
                _this.validatePromise = null;
                _this.errors = $3299c229146a7fb5$var$EMPTY_ERRORS;
                _this.warnings = $3299c229146a7fb5$var$EMPTY_ERRORS;
                _this.triggerMetaEvent();
            }
            switch(info.type){
                case "reset":
                    if (!namePathList || namePathMatch) {
                        // Clean up state
                        _this.touched = false;
                        _this.dirty = false;
                        _this.validatePromise = undefined;
                        _this.errors = $3299c229146a7fb5$var$EMPTY_ERRORS;
                        _this.warnings = $3299c229146a7fb5$var$EMPTY_ERRORS;
                        _this.triggerMetaEvent();
                        onReset === null || onReset === void 0 || onReset();
                        _this.refresh();
                        return;
                    }
                    break;
                /**
         * In case field with `preserve = false` nest deps like:
         * - A = 1 => show B
         * - B = 1 => show C
         * - Reset A, need clean B, C
         */ case "remove":
                    if (shouldUpdate) {
                        _this.reRender();
                        return;
                    }
                    break;
                case "setField":
                    var data = info.data;
                    if (namePathMatch) {
                        if ("touched" in data) _this.touched = data.touched;
                        if ("validating" in data && !("originRCField" in data)) _this.validatePromise = data.validating ? Promise.resolve([]) : null;
                        if ("errors" in data) _this.errors = data.errors || $3299c229146a7fb5$var$EMPTY_ERRORS;
                        if ("warnings" in data) _this.warnings = data.warnings || $3299c229146a7fb5$var$EMPTY_ERRORS;
                        _this.dirty = true;
                        _this.triggerMetaEvent();
                        _this.reRender();
                        return;
                    } else if ("value" in data && (0, $kFGlN.containsNamePath)(namePathList, namePath, true)) {
                        // Contains path with value should also check
                        _this.reRender();
                        return;
                    }
                    // Handle update by `setField` with `shouldUpdate`
                    if (shouldUpdate && !namePath.length && $3299c229146a7fb5$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        _this.reRender();
                        return;
                    }
                    break;
                case "dependenciesUpdate":
                    /**
             * Trigger when marked `dependencies` updated. Related fields will all update
             */ var dependencyList = dependencies.map((0, $kFGlN.getNamePath));
                    // No need for `namePathMath` check and `shouldUpdate` check, since `valueUpdate` will be
                    // emitted earlier and they will work there
                    // If set it may cause unnecessary twice rerendering
                    if (dependencyList.some(function(dependency) {
                        return (0, $kFGlN.containsNamePath)(info.relatedFields, dependency);
                    })) {
                        _this.reRender();
                        return;
                    }
                    break;
                default:
                    // 1. If `namePath` exists in `namePathList`, means it's related value and should update
                    //      For example <List name="list"><Field name={['list', 0]}></List>
                    //      If `namePathList` is [['list']] (List value update), Field should be updated
                    //      If `namePathList` is [['list', 0]] (Field value update), List shouldn't be updated
                    // 2.
                    //   2.1 If `dependencies` is set, `name` is not set and `shouldUpdate` is not set,
                    //       don't use `shouldUpdate`. `dependencies` is view as a shortcut if `shouldUpdate`
                    //       is not provided
                    //   2.2 If `shouldUpdate` provided, use customize logic to update the field
                    //       else to check if value changed
                    if (namePathMatch || (!dependencies.length || namePath.length || shouldUpdate) && $3299c229146a7fb5$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        _this.reRender();
                        return;
                    }
                    break;
            }
            if (shouldUpdate === true) _this.reRender();
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "validateRules", function(options) {
            // We should fixed namePath & value to avoid developer change then by form function
            var namePath = _this.getNamePath();
            var currentValue = _this.getValue();
            var _ref2 = options || {}, triggerName = _ref2.triggerName, _ref2$validateOnly = _ref2.validateOnly, validateOnly = _ref2$validateOnly === void 0 ? false : _ref2$validateOnly;
            // Force change to async to avoid rule OOD under renderProps field
            var rootPromise = Promise.resolve().then(/*#__PURE__*/ (0, $5wm0G.default)(/*#__PURE__*/ (0, $cqPKg.default)().mark(function _callee() {
                var _this$props5, _this$props5$validate, validateFirst, messageVariables, validateDebounce, filteredRules, promise;
                return (0, $cqPKg.default)().wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (_this.mounted) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return", []);
                        case 2:
                            _this$props5 = _this.props, _this$props5$validate = _this$props5.validateFirst, validateFirst = _this$props5$validate === void 0 ? false : _this$props5$validate, messageVariables = _this$props5.messageVariables, validateDebounce = _this$props5.validateDebounce; // Start validate
                            filteredRules = _this.getRules();
                            if (triggerName) filteredRules = filteredRules.filter(function(rule) {
                                return rule;
                            }).filter(function(rule) {
                                var validateTrigger = rule.validateTrigger;
                                if (!validateTrigger) return true;
                                var triggerList = (0, $hhXFI.toArray)(validateTrigger);
                                return triggerList.includes(triggerName);
                            });
                            // Wait for debounce. Skip if no `triggerName` since its from `validateFields / submit`
                            if (!(validateDebounce && triggerName)) {
                                _context.next = 10;
                                break;
                            }
                            _context.next = 8;
                            return new Promise(function(resolve) {
                                setTimeout(resolve, validateDebounce);
                            });
                        case 8:
                            if (!(_this.validatePromise !== rootPromise)) {
                                _context.next = 10;
                                break;
                            }
                            return _context.abrupt("return", []);
                        case 10:
                            promise = (0, $8MG7S.validateRules)(namePath, currentValue, filteredRules, options, validateFirst, messageVariables);
                            promise.catch(function(e) {
                                return e;
                            }).then(function() {
                                var ruleErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $3299c229146a7fb5$var$EMPTY_ERRORS;
                                if (_this.validatePromise === rootPromise) {
                                    var _ruleErrors$forEach;
                                    _this.validatePromise = null;
                                    // Get errors & warnings
                                    var nextErrors = [];
                                    var nextWarnings = [];
                                    (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref4) {
                                        var warningOnly = _ref4.rule.warningOnly, _ref4$errors = _ref4.errors, errors = _ref4$errors === void 0 ? $3299c229146a7fb5$var$EMPTY_ERRORS : _ref4$errors;
                                        if (warningOnly) nextWarnings.push.apply(nextWarnings, (0, $kbxxf.default)(errors));
                                        else nextErrors.push.apply(nextErrors, (0, $kbxxf.default)(errors));
                                    });
                                    _this.errors = nextErrors;
                                    _this.warnings = nextWarnings;
                                    _this.triggerMetaEvent();
                                    _this.reRender();
                                }
                            });
                            return _context.abrupt("return", promise);
                        case 13:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            })));
            if (validateOnly) return rootPromise;
            _this.validatePromise = rootPromise;
            _this.dirty = true;
            _this.errors = $3299c229146a7fb5$var$EMPTY_ERRORS;
            _this.warnings = $3299c229146a7fb5$var$EMPTY_ERRORS;
            _this.triggerMetaEvent();
            // Force trigger re-render since we need sync renderProps with new meta
            _this.reRender();
            return rootPromise;
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "isFieldValidating", function() {
            return !!_this.validatePromise;
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "isFieldTouched", function() {
            return _this.touched;
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "isFieldDirty", function() {
            // Touched or validate or has initialValue
            if (_this.dirty || _this.props.initialValue !== undefined) return true;
            // Form set initialValue
            var fieldContext = _this.props.fieldContext;
            var _fieldContext$getInte = fieldContext.getInternalHooks((0, $260BS.HOOK_MARK)), getInitialValue = _fieldContext$getInte.getInitialValue;
            if (getInitialValue(_this.getNamePath()) !== undefined) return true;
            return false;
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "getErrors", function() {
            return _this.errors;
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "getWarnings", function() {
            return _this.warnings;
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "isListField", function() {
            return _this.props.isListField;
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "isList", function() {
            return _this.props.isList;
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "isPreserve", function() {
            return _this.props.preserve;
        });
        // ============================= Child Component =============================
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "getMeta", function() {
            // Make error & validating in cache to save perf
            _this.prevValidating = _this.isFieldValidating();
            var meta = {
                touched: _this.isFieldTouched(),
                validating: _this.prevValidating,
                errors: _this.errors,
                warnings: _this.warnings,
                name: _this.getNamePath(),
                validated: _this.validatePromise === null
            };
            return meta;
        });
        // Only return validate child node. If invalidate, will do nothing about field.
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "getOnlyChild", function(children) {
            // Support render props
            if (typeof children === "function") {
                var _meta2 = _this.getMeta();
                return (0, $d49SP.default)((0, $d49SP.default)({}, _this.getOnlyChild(children(_this.getControlled(), _meta2, _this.props.fieldContext))), {}, {
                    isFunction: true
                });
            }
            // Filed element only
            var childList = (0, $jWR62.default)(children);
            if (childList.length !== 1 || !/*#__PURE__*/ $acw62.isValidElement(childList[0])) return {
                child: childList,
                isFunction: false
            };
            return {
                child: childList[0],
                isFunction: false
            };
        });
        // ============================== Field Control ==============================
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "getValue", function(store) {
            var getFieldsValue = _this.props.fieldContext.getFieldsValue;
            var namePath = _this.getNamePath();
            return (0, $23Gye.default)(store || getFieldsValue(true), namePath);
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "getControlled", function() {
            var childProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _this$props6 = _this.props, trigger = _this$props6.trigger, validateTrigger = _this$props6.validateTrigger, getValueFromEvent = _this$props6.getValueFromEvent, normalize = _this$props6.normalize, valuePropName = _this$props6.valuePropName, getValueProps = _this$props6.getValueProps, fieldContext = _this$props6.fieldContext;
            var mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : fieldContext.validateTrigger;
            var namePath = _this.getNamePath();
            var getInternalHooks = fieldContext.getInternalHooks, getFieldsValue = fieldContext.getFieldsValue;
            var _getInternalHooks = getInternalHooks((0, $260BS.HOOK_MARK)), dispatch = _getInternalHooks.dispatch;
            var value = _this.getValue();
            var mergedGetValueProps = getValueProps || function(val) {
                return (0, $kSlfw.default)({}, valuePropName, val);
            };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var originTriggerFunc = childProps[trigger];
            var control = (0, $d49SP.default)((0, $d49SP.default)({}, childProps), mergedGetValueProps(value));
            // Add trigger
            control[trigger] = function() {
                // Mark as touched
                _this.touched = true;
                _this.dirty = true;
                _this.triggerMetaEvent();
                var newValue;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (getValueFromEvent) newValue = getValueFromEvent.apply(void 0, args);
                else newValue = (0, $kFGlN.defaultGetValueFromEvent).apply(void 0, [
                    valuePropName
                ].concat(args));
                if (normalize) newValue = normalize(newValue, value, getFieldsValue(true));
                dispatch({
                    type: "updateValue",
                    namePath: namePath,
                    value: newValue
                });
                if (originTriggerFunc) originTriggerFunc.apply(void 0, args);
            };
            // Add validateTrigger
            var validateTriggerList = (0, $hhXFI.toArray)(mergedValidateTrigger || []);
            validateTriggerList.forEach(function(triggerName) {
                // Wrap additional function of component, so that we can get latest value from store
                var originTrigger = control[triggerName];
                control[triggerName] = function() {
                    if (originTrigger) originTrigger.apply(void 0, arguments);
                    // Always use latest rules
                    var rules = _this.props.rules;
                    if (rules && rules.length) // We dispatch validate to root,
                    // since it will update related data with other field with same name
                    dispatch({
                        type: "validateField",
                        namePath: namePath,
                        triggerName: triggerName
                    });
                };
            });
            return control;
        });
        if (props.fieldContext) {
            var getInternalHooks = props.fieldContext.getInternalHooks;
            var _getInternalHooks2 = getInternalHooks((0, $260BS.HOOK_MARK)), initEntityValue = _getInternalHooks2.initEntityValue;
            initEntityValue((0, $hDpcU.default)(_this));
        }
        return _this;
    }
    (0, $cHPF9.default)(Field, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props7 = this.props, shouldUpdate = _this$props7.shouldUpdate, fieldContext = _this$props7.fieldContext;
                this.mounted = true;
                // Register on init
                if (fieldContext) {
                    var getInternalHooks = fieldContext.getInternalHooks;
                    var _getInternalHooks3 = getInternalHooks((0, $260BS.HOOK_MARK)), registerField = _getInternalHooks3.registerField;
                    this.cancelRegisterFunc = registerField(this);
                }
                // One more render for component in case fields not ready
                if (shouldUpdate === true) this.reRender();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.cancelRegister();
                this.triggerMetaEvent(true);
                this.mounted = false;
            }
        },
        {
            key: "reRender",
            value: function reRender() {
                if (!this.mounted) return;
                this.forceUpdate();
            }
        },
        {
            key: "render",
            value: function render() {
                var resetCount = this.state.resetCount;
                var children = this.props.children;
                var _this$getOnlyChild = this.getOnlyChild(children), child = _this$getOnlyChild.child, isFunction = _this$getOnlyChild.isFunction;
                // Not need to `cloneElement` since user can handle this in render function self
                var returnChildNode;
                if (isFunction) returnChildNode = child;
                else if (/*#__PURE__*/ $acw62.isValidElement(child)) returnChildNode = /*#__PURE__*/ $acw62.cloneElement(child, this.getControlled(child.props));
                else {
                    (0, $u43uR.default)(!child, "`children` of Field is not validate ReactElement.");
                    returnChildNode = child;
                }
                return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, {
                    key: resetCount
                }, returnChildNode);
            }
        }
    ]);
    return Field;
}($acw62.Component);
(0, $kSlfw.default)($3299c229146a7fb5$var$Field, "contextType", (0, $260BS.default));
(0, $kSlfw.default)($3299c229146a7fb5$var$Field, "defaultProps", {
    trigger: "onChange",
    valuePropName: "value"
});
function $3299c229146a7fb5$var$WrapperField(_ref6) {
    var name = _ref6.name, restProps = (0, $9X7IJ.default)(_ref6, $3299c229146a7fb5$var$_excluded);
    var fieldContext = $acw62.useContext((0, $260BS.default));
    var listContext = $acw62.useContext((0, $livSf.default));
    var namePath = name !== undefined ? (0, $kFGlN.getNamePath)(name) : undefined;
    var key = "keep";
    if (!restProps.isListField) key = "_".concat((namePath || []).join("_"));
    return /*#__PURE__*/ $acw62.createElement($3299c229146a7fb5$var$Field, (0, $8nd05.default)({
        key: key,
        name: namePath,
        isListField: !!listContext
    }, restProps, {
        fieldContext: fieldContext
    }));
}
var $3299c229146a7fb5$export$2e2bcd8739ae039 = $3299c229146a7fb5$var$WrapperField;

});
parcelRegister("260BS", function(module, exports) {

$parcel$export(module.exports, "HOOK_MARK", () => $186c9d6ed579317b$export$24829b7c0e49e9f7);
$parcel$export(module.exports, "default", () => $186c9d6ed579317b$export$2e2bcd8739ae039);

var $u43uR = parcelRequire("u43uR");

var $acw62 = parcelRequire("acw62");
var $186c9d6ed579317b$export$24829b7c0e49e9f7 = "RC_FORM_INTERNAL_HOOKS";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $186c9d6ed579317b$var$warningFunc = function warningFunc() {
    (0, $u43uR.default)(false, "Can not find FormContext. Please make sure you wrap Field under Form.");
};
var $186c9d6ed579317b$var$Context = /*#__PURE__*/ $acw62.createContext({
    getFieldValue: $186c9d6ed579317b$var$warningFunc,
    getFieldsValue: $186c9d6ed579317b$var$warningFunc,
    getFieldError: $186c9d6ed579317b$var$warningFunc,
    getFieldWarning: $186c9d6ed579317b$var$warningFunc,
    getFieldsError: $186c9d6ed579317b$var$warningFunc,
    isFieldsTouched: $186c9d6ed579317b$var$warningFunc,
    isFieldTouched: $186c9d6ed579317b$var$warningFunc,
    isFieldValidating: $186c9d6ed579317b$var$warningFunc,
    isFieldsValidating: $186c9d6ed579317b$var$warningFunc,
    resetFields: $186c9d6ed579317b$var$warningFunc,
    setFields: $186c9d6ed579317b$var$warningFunc,
    setFieldValue: $186c9d6ed579317b$var$warningFunc,
    setFieldsValue: $186c9d6ed579317b$var$warningFunc,
    validateFields: $186c9d6ed579317b$var$warningFunc,
    submit: $186c9d6ed579317b$var$warningFunc,
    getInternalHooks: function getInternalHooks() {
        $186c9d6ed579317b$var$warningFunc();
        return {
            dispatch: $186c9d6ed579317b$var$warningFunc,
            initEntityValue: $186c9d6ed579317b$var$warningFunc,
            registerField: $186c9d6ed579317b$var$warningFunc,
            useSubscribe: $186c9d6ed579317b$var$warningFunc,
            setInitialValues: $186c9d6ed579317b$var$warningFunc,
            destroyForm: $186c9d6ed579317b$var$warningFunc,
            setCallbacks: $186c9d6ed579317b$var$warningFunc,
            registerWatch: $186c9d6ed579317b$var$warningFunc,
            getFields: $186c9d6ed579317b$var$warningFunc,
            setValidateMessages: $186c9d6ed579317b$var$warningFunc,
            setPreserve: $186c9d6ed579317b$var$warningFunc,
            getInitialValue: $186c9d6ed579317b$var$warningFunc
        };
    }
});
var $186c9d6ed579317b$export$2e2bcd8739ae039 = $186c9d6ed579317b$var$Context;

});

parcelRegister("livSf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f81400e90cbb2e33$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $f81400e90cbb2e33$var$ListContext = /*#__PURE__*/ $acw62.createContext(null);
var $f81400e90cbb2e33$export$2e2bcd8739ae039 = $f81400e90cbb2e33$var$ListContext;

});

parcelRegister("hhXFI", function(module, exports) {

$parcel$export(module.exports, "toArray", () => $c9624fc8667843e4$export$45b10814cc054894);
$parcel$export(module.exports, "isFormInstance", () => $c9624fc8667843e4$export$717b316e73068e8d);
function $c9624fc8667843e4$export$45b10814cc054894(value) {
    if (value === undefined || value === null) return [];
    return Array.isArray(value) ? value : [
        value
    ];
}
function $c9624fc8667843e4$export$717b316e73068e8d(form) {
    return form && !!form._init;
}

});

parcelRegister("8MG7S", function(module, exports) {

$parcel$export(module.exports, "validateRules", () => $66537bc44202668a$export$e1fc4b442d0297dd);

var $kbxxf = parcelRequire("kbxxf");

var $kSlfw = parcelRequire("kSlfw");

var $cqPKg = parcelRequire("cqPKg");

var $d49SP = parcelRequire("d49SP");

var $5wm0G = parcelRequire("5wm0G");

var $62Vkp = parcelRequire("62Vkp");

var $acw62 = parcelRequire("acw62");

var $u43uR = parcelRequire("u43uR");

var $kg8Ze = parcelRequire("kg8Ze");

var $6vgkH = parcelRequire("6vgkH");
// Remove incorrect original ts define
var $66537bc44202668a$var$AsyncValidator = (0, $62Vkp.default);
/**
 * Replace with template.
 *   `I'm ${name}` + { name: 'bamboo' } = I'm bamboo
 */ function $66537bc44202668a$var$replaceMessage(template, kv) {
    return template.replace(/\$\{\w+\}/g, function(str) {
        var key = str.slice(2, -1);
        return kv[key];
    });
}
var $66537bc44202668a$var$CODE_LOGIC_ERROR = "CODE_LOGIC_ERROR";
function $66537bc44202668a$var$validateRule(_x, _x2, _x3, _x4, _x5) {
    return $66537bc44202668a$var$_validateRule.apply(this, arguments);
}
/**
 * We use `async-validator` to validate the value.
 * But only check one value in a time to avoid namePath validate issue.
 */ function $66537bc44202668a$var$_validateRule() {
    $66537bc44202668a$var$_validateRule = (0, $5wm0G.default)(/*#__PURE__*/ (0, $cqPKg.default)().mark(function _callee2(name, value, rule, options, messageVariables) {
        var cloneRule, originValidator, subRuleField, validator, messages, result, subResults, kv, fillVariableResult;
        return (0, $cqPKg.default)().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    cloneRule = (0, $d49SP.default)({}, rule); // Bug of `async-validator`
                    // https://github.com/react-component/field-form/issues/316
                    // https://github.com/react-component/field-form/issues/313
                    delete cloneRule.ruleIndex;
                    // https://github.com/ant-design/ant-design/issues/40497#issuecomment-1422282378
                    $66537bc44202668a$var$AsyncValidator.warning = function() {
                        return void 0;
                    };
                    if (cloneRule.validator) {
                        originValidator = cloneRule.validator;
                        cloneRule.validator = function() {
                            try {
                                return originValidator.apply(void 0, arguments);
                            } catch (error) {
                                console.error(error);
                                return Promise.reject($66537bc44202668a$var$CODE_LOGIC_ERROR);
                            }
                        };
                    }
                    // We should special handle array validate
                    subRuleField = null;
                    if (cloneRule && cloneRule.type === "array" && cloneRule.defaultField) {
                        subRuleField = cloneRule.defaultField;
                        delete cloneRule.defaultField;
                    }
                    validator = new $66537bc44202668a$var$AsyncValidator((0, $kSlfw.default)({}, name, [
                        cloneRule
                    ]));
                    messages = (0, $6vgkH.merge)((0, $kg8Ze.defaultValidateMessages), options.validateMessages);
                    validator.messages(messages);
                    result = [];
                    _context2.prev = 10;
                    _context2.next = 13;
                    return Promise.resolve(validator.validate((0, $kSlfw.default)({}, name, value), (0, $d49SP.default)({}, options)));
                case 13:
                    _context2.next = 18;
                    break;
                case 15:
                    _context2.prev = 15;
                    _context2.t0 = _context2["catch"](10);
                    if (_context2.t0.errors) result = _context2.t0.errors.map(function(_ref4, index) {
                        var message = _ref4.message;
                        var mergedMessage = message === $66537bc44202668a$var$CODE_LOGIC_ERROR ? messages.default : message;
                        return /*#__PURE__*/ $acw62.isValidElement(mergedMessage) ? /*#__PURE__*/ // Wrap ReactNode with `key`
                        $acw62.cloneElement(mergedMessage, {
                            key: "error_".concat(index)
                        }) : mergedMessage;
                    });
                case 18:
                    if (!(!result.length && subRuleField)) {
                        _context2.next = 23;
                        break;
                    }
                    _context2.next = 21;
                    return Promise.all(value.map(function(subValue, i) {
                        return $66537bc44202668a$var$validateRule("".concat(name, ".").concat(i), subValue, subRuleField, options, messageVariables);
                    }));
                case 21:
                    subResults = _context2.sent;
                    return _context2.abrupt("return", subResults.reduce(function(prev, errors) {
                        return [].concat((0, $kbxxf.default)(prev), (0, $kbxxf.default)(errors));
                    }, []));
                case 23:
                    // Replace message with variables
                    kv = (0, $d49SP.default)((0, $d49SP.default)({}, rule), {}, {
                        name: name,
                        enum: (rule.enum || []).join(", ")
                    }, messageVariables);
                    fillVariableResult = result.map(function(error) {
                        if (typeof error === "string") return $66537bc44202668a$var$replaceMessage(error, kv);
                        return error;
                    });
                    return _context2.abrupt("return", fillVariableResult);
                case 26:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                10,
                15
            ]
        ]);
    }));
    return $66537bc44202668a$var$_validateRule.apply(this, arguments);
}
function $66537bc44202668a$export$e1fc4b442d0297dd(namePath, value, rules, options, validateFirst, messageVariables) {
    var name = namePath.join(".");
    // Fill rule with context
    var filledRules = rules.map(function(currentRule, ruleIndex) {
        var originValidatorFunc = currentRule.validator;
        var cloneRule = (0, $d49SP.default)((0, $d49SP.default)({}, currentRule), {}, {
            ruleIndex: ruleIndex
        });
        // Replace validator if needed
        if (originValidatorFunc) cloneRule.validator = function(rule, val, callback) {
            var hasPromise = false;
            // Wrap callback only accept when promise not provided
            var wrappedCallback = function wrappedCallback() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // Wait a tick to make sure return type is a promise
                Promise.resolve().then(function() {
                    (0, $u43uR.default)(!hasPromise, "Your validator function has already return a promise. `callback` will be ignored.");
                    if (!hasPromise) callback.apply(void 0, args);
                });
            };
            // Get promise
            var promise = originValidatorFunc(rule, val, wrappedCallback);
            hasPromise = promise && typeof promise.then === "function" && typeof promise.catch === "function";
            /**
         * 1. Use promise as the first priority.
         * 2. If promise not exist, use callback with warning instead
         */ (0, $u43uR.default)(hasPromise, "`callback` is deprecated. Please return a promise instead.");
            if (hasPromise) promise.then(function() {
                callback();
            }).catch(function(err) {
                callback(err || " ");
            });
        };
        return cloneRule;
    }).sort(function(_ref, _ref2) {
        var w1 = _ref.warningOnly, i1 = _ref.ruleIndex;
        var w2 = _ref2.warningOnly, i2 = _ref2.ruleIndex;
        if (!!w1 === !!w2) // Let keep origin order
        return i1 - i2;
        if (w1) return 1;
        return -1;
    });
    // Do validate rules
    var summaryPromise;
    if (validateFirst === true) // >>>>> Validate by serialization
    summaryPromise = new Promise(/*#__PURE__*/ function() {
        var _ref3 = (0, $5wm0G.default)(/*#__PURE__*/ (0, $cqPKg.default)().mark(function _callee(resolve, reject) {
            var i, rule, errors;
            return (0, $cqPKg.default)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        i = 0;
                    case 1:
                        if (!(i < filledRules.length)) {
                            _context.next = 12;
                            break;
                        }
                        rule = filledRules[i];
                        _context.next = 5;
                        return $66537bc44202668a$var$validateRule(name, value, rule, options, messageVariables);
                    case 5:
                        errors = _context.sent;
                        if (!errors.length) {
                            _context.next = 9;
                            break;
                        }
                        reject([
                            {
                                errors: errors,
                                rule: rule
                            }
                        ]);
                        return _context.abrupt("return");
                    case 9:
                        i += 1;
                        _context.next = 1;
                        break;
                    case 12:
                        /* eslint-enable */ resolve([]);
                    case 13:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function(_x6, _x7) {
            return _ref3.apply(this, arguments);
        };
    }());
    else {
        // >>>>> Validate by parallel
        var rulePromises = filledRules.map(function(rule) {
            return $66537bc44202668a$var$validateRule(name, value, rule, options, messageVariables).then(function(errors) {
                return {
                    errors: errors,
                    rule: rule
                };
            });
        });
        summaryPromise = (validateFirst ? $66537bc44202668a$var$finishOnFirstFailed(rulePromises) : $66537bc44202668a$var$finishOnAllFailed(rulePromises)).then(function(errors) {
            // Always change to rejection for Field to catch
            return Promise.reject(errors);
        });
    }
    // Internal catch error to avoid console error log.
    summaryPromise.catch(function(e) {
        return e;
    });
    return summaryPromise;
}
function $66537bc44202668a$var$finishOnAllFailed(_x8) {
    return $66537bc44202668a$var$_finishOnAllFailed.apply(this, arguments);
}
function $66537bc44202668a$var$_finishOnAllFailed() {
    $66537bc44202668a$var$_finishOnAllFailed = (0, $5wm0G.default)(/*#__PURE__*/ (0, $cqPKg.default)().mark(function _callee3(rulePromises) {
        return (0, $cqPKg.default)().wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    return _context3.abrupt("return", Promise.all(rulePromises).then(function(errorsList) {
                        var _ref5;
                        var errors = (_ref5 = []).concat.apply(_ref5, (0, $kbxxf.default)(errorsList));
                        return errors;
                    }));
                case 1:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return $66537bc44202668a$var$_finishOnAllFailed.apply(this, arguments);
}
function $66537bc44202668a$var$finishOnFirstFailed(_x9) {
    return $66537bc44202668a$var$_finishOnFirstFailed.apply(this, arguments);
}
function $66537bc44202668a$var$_finishOnFirstFailed() {
    $66537bc44202668a$var$_finishOnFirstFailed = (0, $5wm0G.default)(/*#__PURE__*/ (0, $cqPKg.default)().mark(function _callee4(rulePromises) {
        var count;
        return (0, $cqPKg.default)().wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    count = 0;
                    return _context4.abrupt("return", new Promise(function(resolve) {
                        rulePromises.forEach(function(promise) {
                            promise.then(function(ruleError) {
                                if (ruleError.errors.length) resolve([
                                    ruleError
                                ]);
                                count += 1;
                                if (count === rulePromises.length) resolve([]);
                            });
                        });
                    }));
                case 2:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return $66537bc44202668a$var$_finishOnFirstFailed.apply(this, arguments);
}

});
parcelRegister("62Vkp", function(module, exports) {

$parcel$export(module.exports, "default", () => $466f66254aa75085$export$2e2bcd8739ae039);

var $hPtJY = parcelRequire("hPtJY");
function $466f66254aa75085$var$_extends() {
    $466f66254aa75085$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $466f66254aa75085$var$_extends.apply(this, arguments);
}
function $466f66254aa75085$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $466f66254aa75085$var$_setPrototypeOf(subClass, superClass);
}
function $466f66254aa75085$var$_getPrototypeOf(o) {
    $466f66254aa75085$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $466f66254aa75085$var$_getPrototypeOf(o);
}
function $466f66254aa75085$var$_setPrototypeOf(o, p) {
    $466f66254aa75085$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $466f66254aa75085$var$_setPrototypeOf(o, p);
}
function $466f66254aa75085$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $466f66254aa75085$var$_construct(Parent, args, Class) {
    if ($466f66254aa75085$var$_isNativeReflectConstruct()) $466f66254aa75085$var$_construct = Reflect.construct.bind();
    else $466f66254aa75085$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $466f66254aa75085$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $466f66254aa75085$var$_construct.apply(null, arguments);
}
function $466f66254aa75085$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $466f66254aa75085$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $466f66254aa75085$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$466f66254aa75085$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $466f66254aa75085$var$_construct(Class, arguments, $466f66254aa75085$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $466f66254aa75085$var$_setPrototypeOf(Wrapper, Class);
    };
    return $466f66254aa75085$var$_wrapNativeSuper(Class);
}
/* eslint no-console:0 */ var $466f66254aa75085$var$formatRegExp = /%[sdj%]/g;
var $466f66254aa75085$var$warning = function warning() {}; // don't print warning message when in production env or node runtime
typeof $hPtJY !== "undefined" && $hPtJY.env;
function $466f66254aa75085$var$convertFieldsError(errors) {
    if (!errors || !errors.length) return null;
    var fields = {};
    errors.forEach(function(error) {
        var field = error.field;
        fields[field] = fields[field] || [];
        fields[field].push(error);
    });
    return fields;
}
function $466f66254aa75085$var$format(template) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var i = 0;
    var len = args.length;
    if (typeof template === "function") return template.apply(null, args);
    if (typeof template === "string") {
        var str = template.replace($466f66254aa75085$var$formatRegExp, function(x) {
            if (x === "%%") return "%";
            if (i >= len) return x;
            switch(x){
                case "%s":
                    return String(args[i++]);
                case "%d":
                    return Number(args[i++]);
                case "%j":
                    try {
                        return JSON.stringify(args[i++]);
                    } catch (_) {
                        return "[Circular]";
                    }
                    break;
                default:
                    return x;
            }
        });
        return str;
    }
    return template;
}
function $466f66254aa75085$var$isNativeStringType(type) {
    return type === "string" || type === "url" || type === "hex" || type === "email" || type === "date" || type === "pattern";
}
function $466f66254aa75085$var$isEmptyValue(value, type) {
    if (value === undefined || value === null) return true;
    if (type === "array" && Array.isArray(value) && !value.length) return true;
    if ($466f66254aa75085$var$isNativeStringType(type) && typeof value === "string" && !value) return true;
    return false;
}
function $466f66254aa75085$var$asyncParallelArray(arr, func, callback) {
    var results = [];
    var total = 0;
    var arrLength = arr.length;
    function count(errors) {
        results.push.apply(results, errors || []);
        total++;
        if (total === arrLength) callback(results);
    }
    arr.forEach(function(a) {
        func(a, count);
    });
}
function $466f66254aa75085$var$asyncSerialArray(arr, func, callback) {
    var index = 0;
    var arrLength = arr.length;
    function next(errors) {
        if (errors && errors.length) {
            callback(errors);
            return;
        }
        var original = index;
        index = index + 1;
        if (original < arrLength) func(arr[original], next);
        else callback([]);
    }
    next([]);
}
function $466f66254aa75085$var$flattenObjArr(objArr) {
    var ret = [];
    Object.keys(objArr).forEach(function(k) {
        ret.push.apply(ret, objArr[k] || []);
    });
    return ret;
}
var $466f66254aa75085$var$AsyncValidationError = /*#__PURE__*/ function(_Error) {
    $466f66254aa75085$var$_inheritsLoose(AsyncValidationError, _Error);
    function AsyncValidationError(errors, fields) {
        var _this;
        _this = _Error.call(this, "Async Validation Error") || this;
        _this.errors = errors;
        _this.fields = fields;
        return _this;
    }
    return AsyncValidationError;
}(/*#__PURE__*/ $466f66254aa75085$var$_wrapNativeSuper(Error));
function $466f66254aa75085$var$asyncMap(objArr, option, func, callback, source) {
    if (option.first) {
        var _pending = new Promise(function(resolve, reject) {
            var next = function next(errors) {
                callback(errors);
                return errors.length ? reject(new $466f66254aa75085$var$AsyncValidationError(errors, $466f66254aa75085$var$convertFieldsError(errors))) : resolve(source);
            };
            var flattenArr = $466f66254aa75085$var$flattenObjArr(objArr);
            $466f66254aa75085$var$asyncSerialArray(flattenArr, func, next);
        });
        _pending["catch"](function(e) {
            return e;
        });
        return _pending;
    }
    var firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
    var objArrKeys = Object.keys(objArr);
    var objArrLength = objArrKeys.length;
    var total = 0;
    var results = [];
    var pending = new Promise(function(resolve, reject) {
        var next = function next(errors) {
            results.push.apply(results, errors);
            total++;
            if (total === objArrLength) {
                callback(results);
                return results.length ? reject(new $466f66254aa75085$var$AsyncValidationError(results, $466f66254aa75085$var$convertFieldsError(results))) : resolve(source);
            }
        };
        if (!objArrKeys.length) {
            callback(results);
            resolve(source);
        }
        objArrKeys.forEach(function(key) {
            var arr = objArr[key];
            if (firstFields.indexOf(key) !== -1) $466f66254aa75085$var$asyncSerialArray(arr, func, next);
            else $466f66254aa75085$var$asyncParallelArray(arr, func, next);
        });
    });
    pending["catch"](function(e) {
        return e;
    });
    return pending;
}
function $466f66254aa75085$var$isErrorObj(obj) {
    return !!(obj && obj.message !== undefined);
}
function $466f66254aa75085$var$getValue(value, path) {
    var v = value;
    for(var i = 0; i < path.length; i++){
        if (v == undefined) return v;
        v = v[path[i]];
    }
    return v;
}
function $466f66254aa75085$var$complementError(rule, source) {
    return function(oe) {
        var fieldValue;
        if (rule.fullFields) fieldValue = $466f66254aa75085$var$getValue(source, rule.fullFields);
        else fieldValue = source[oe.field || rule.fullField];
        if ($466f66254aa75085$var$isErrorObj(oe)) {
            oe.field = oe.field || rule.fullField;
            oe.fieldValue = fieldValue;
            return oe;
        }
        return {
            message: typeof oe === "function" ? oe() : oe,
            fieldValue: fieldValue,
            field: oe.field || rule.fullField
        };
    };
}
function $466f66254aa75085$var$deepMerge(target, source) {
    if (source) {
        for(var s in source)if (source.hasOwnProperty(s)) {
            var value = source[s];
            if (typeof value === "object" && typeof target[s] === "object") target[s] = $466f66254aa75085$var$_extends({}, target[s], value);
            else target[s] = value;
        }
    }
    return target;
}
var $466f66254aa75085$var$required$1 = function required(rule, value, source, errors, options, type) {
    if (rule.required && (!source.hasOwnProperty(rule.field) || $466f66254aa75085$var$isEmptyValue(value, type || rule.type))) errors.push($466f66254aa75085$var$format(options.messages.required, rule.fullField));
};
/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */ var $466f66254aa75085$var$whitespace = function whitespace(rule, value, source, errors, options) {
    if (/^\s+$/.test(value) || value === "") errors.push($466f66254aa75085$var$format(options.messages.whitespace, rule.fullField));
};
// https://github.com/kevva/url-regex/blob/master/index.js
var $466f66254aa75085$var$urlReg;
var $466f66254aa75085$var$getUrlRegex = function() {
    if ($466f66254aa75085$var$urlReg) return $466f66254aa75085$var$urlReg;
    var word = "[a-fA-F\\d:]";
    var b = function b(options) {
        return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=" + word + ")|(?<=" + word + ")(?=\\s|$))" : "";
    };
    var v4 = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}";
    var v6seg = "[a-fA-F\\d]{1,4}";
    var v6 = ("\n(?:\n(?:" + v6seg + ":){7}(?:" + v6seg + "|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8\n(?:" + v6seg + ":){6}(?:" + v4 + "|:" + v6seg + "|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4\n(?:" + v6seg + ":){5}(?::" + v4 + "|(?::" + v6seg + "){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4\n(?:" + v6seg + ":){4}(?:(?::" + v6seg + "){0,1}:" + v4 + "|(?::" + v6seg + "){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4\n(?:" + v6seg + ":){3}(?:(?::" + v6seg + "){0,2}:" + v4 + "|(?::" + v6seg + "){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4\n(?:" + v6seg + ":){2}(?:(?::" + v6seg + "){0,3}:" + v4 + "|(?::" + v6seg + "){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4\n(?:" + v6seg + ":){1}(?:(?::" + v6seg + "){0,4}:" + v4 + "|(?::" + v6seg + "){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4\n(?::(?:(?::" + v6seg + "){0,5}:" + v4 + "|(?::" + v6seg + "){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4\n)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1\n").replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim(); // Pre-compile only the exact regexes because adding a global flag make regexes stateful
    var v46Exact = new RegExp("(?:^" + v4 + "$)|(?:^" + v6 + "$)");
    var v4exact = new RegExp("^" + v4 + "$");
    var v6exact = new RegExp("^" + v6 + "$");
    var ip = function ip(options) {
        return options && options.exact ? v46Exact : new RegExp("(?:" + b(options) + v4 + b(options) + ")|(?:" + b(options) + v6 + b(options) + ")", "g");
    };
    ip.v4 = function(options) {
        return options && options.exact ? v4exact : new RegExp("" + b(options) + v4 + b(options), "g");
    };
    ip.v6 = function(options) {
        return options && options.exact ? v6exact : new RegExp("" + b(options) + v6 + b(options), "g");
    };
    var protocol = "(?:(?:[a-z]+:)?//)";
    var auth = "(?:\\S+(?::\\S*)?@)?";
    var ipv4 = ip.v4().source;
    var ipv6 = ip.v6().source;
    var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
    var domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
    var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
    var port = "(?::\\d{2,5})?";
    var path = '(?:[/?#][^\\s"]*)?';
    var regex = "(?:" + protocol + "|www\\.)" + auth + "(?:localhost|" + ipv4 + "|" + ipv6 + "|" + host + domain + tld + ")" + port + path;
    $466f66254aa75085$var$urlReg = new RegExp("(?:^" + regex + "$)", "i");
    return $466f66254aa75085$var$urlReg;
};
/* eslint max-len:0 */ var $466f66254aa75085$var$pattern$2 = {
    // http://emailregex.com/
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
    // url: new RegExp(
    //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
    //   'i',
    // ),
    hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var $466f66254aa75085$var$types = {
    integer: function integer(value) {
        return $466f66254aa75085$var$types.number(value) && parseInt(value, 10) === value;
    },
    "float": function float(value) {
        return $466f66254aa75085$var$types.number(value) && !$466f66254aa75085$var$types.integer(value);
    },
    array: function array(value) {
        return Array.isArray(value);
    },
    regexp: function regexp(value) {
        if (value instanceof RegExp) return true;
        try {
            return new RegExp(value), true;
        } catch (e) {
            return false;
        }
    },
    date: function date(value) {
        return typeof value.getTime === "function" && typeof value.getMonth === "function" && typeof value.getYear === "function" && !isNaN(value.getTime());
    },
    number: function number(value) {
        if (isNaN(value)) return false;
        return typeof value === "number";
    },
    object: function object(value) {
        return typeof value === "object" && !$466f66254aa75085$var$types.array(value);
    },
    method: function method(value) {
        return typeof value === "function";
    },
    email: function email(value) {
        return typeof value === "string" && value.length <= 320 && !!value.match($466f66254aa75085$var$pattern$2.email);
    },
    url: function url(value) {
        return typeof value === "string" && value.length <= 2048 && !!value.match($466f66254aa75085$var$getUrlRegex());
    },
    hex: function hex(value) {
        return typeof value === "string" && !!value.match($466f66254aa75085$var$pattern$2.hex);
    }
};
var $466f66254aa75085$var$type$1 = function type(rule, value, source, errors, options) {
    if (rule.required && value === undefined) {
        $466f66254aa75085$var$required$1(rule, value, source, errors, options);
        return;
    }
    var custom = [
        "integer",
        "float",
        "array",
        "regexp",
        "object",
        "method",
        "email",
        "number",
        "date",
        "url",
        "hex"
    ];
    var ruleType = rule.type;
    if (custom.indexOf(ruleType) > -1) {
        if (!$466f66254aa75085$var$types[ruleType](value)) errors.push($466f66254aa75085$var$format(options.messages.types[ruleType], rule.fullField, rule.type));
         // straight typeof check
    } else if (ruleType && typeof value !== rule.type) errors.push($466f66254aa75085$var$format(options.messages.types[ruleType], rule.fullField, rule.type));
};
var $466f66254aa75085$var$range = function range(rule, value, source, errors, options) {
    var len = typeof rule.len === "number";
    var min = typeof rule.min === "number";
    var max = typeof rule.max === "number"; // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
    var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    var val = value;
    var key = null;
    var num = typeof value === "number";
    var str = typeof value === "string";
    var arr = Array.isArray(value);
    if (num) key = "number";
    else if (str) key = "string";
    else if (arr) key = "array";
     // if the value is not of a supported type for range validation
    // the validation rule rule should use the
    // type property to also test for a particular type
    if (!key) return false;
    if (arr) val = value.length;
    if (str) // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = value.replace(spRegexp, "_").length;
    if (len) {
        if (val !== rule.len) errors.push($466f66254aa75085$var$format(options.messages[key].len, rule.fullField, rule.len));
    } else if (min && !max && val < rule.min) errors.push($466f66254aa75085$var$format(options.messages[key].min, rule.fullField, rule.min));
    else if (max && !min && val > rule.max) errors.push($466f66254aa75085$var$format(options.messages[key].max, rule.fullField, rule.max));
    else if (min && max && (val < rule.min || val > rule.max)) errors.push($466f66254aa75085$var$format(options.messages[key].range, rule.fullField, rule.min, rule.max));
};
var $466f66254aa75085$var$ENUM$1 = "enum";
var $466f66254aa75085$var$enumerable$1 = function enumerable(rule, value, source, errors, options) {
    rule[$466f66254aa75085$var$ENUM$1] = Array.isArray(rule[$466f66254aa75085$var$ENUM$1]) ? rule[$466f66254aa75085$var$ENUM$1] : [];
    if (rule[$466f66254aa75085$var$ENUM$1].indexOf(value) === -1) errors.push($466f66254aa75085$var$format(options.messages[$466f66254aa75085$var$ENUM$1], rule.fullField, rule[$466f66254aa75085$var$ENUM$1].join(", ")));
};
var $466f66254aa75085$var$pattern$1 = function pattern(rule, value, source, errors, options) {
    if (rule.pattern) {
        if (rule.pattern instanceof RegExp) {
            // if a RegExp instance is passed, reset `lastIndex` in case its `global`
            // flag is accidentally set to `true`, which in a validation scenario
            // is not necessary and the result might be misleading
            rule.pattern.lastIndex = 0;
            if (!rule.pattern.test(value)) errors.push($466f66254aa75085$var$format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        } else if (typeof rule.pattern === "string") {
            var _pattern = new RegExp(rule.pattern);
            if (!_pattern.test(value)) errors.push($466f66254aa75085$var$format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        }
    }
};
var $466f66254aa75085$var$rules = {
    required: $466f66254aa75085$var$required$1,
    whitespace: $466f66254aa75085$var$whitespace,
    type: $466f66254aa75085$var$type$1,
    range: $466f66254aa75085$var$range,
    "enum": $466f66254aa75085$var$enumerable$1,
    pattern: $466f66254aa75085$var$pattern$1
};
var $466f66254aa75085$var$string = function string(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value, "string") && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options, "string");
        if (!$466f66254aa75085$var$isEmptyValue(value, "string")) {
            $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
            $466f66254aa75085$var$rules.range(rule, value, source, errors, options);
            $466f66254aa75085$var$rules.pattern(rule, value, source, errors, options);
            if (rule.whitespace === true) $466f66254aa75085$var$rules.whitespace(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $466f66254aa75085$var$method = function method(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $466f66254aa75085$var$number = function number(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if (value === "") value = undefined;
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) {
            $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
            $466f66254aa75085$var$rules.range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $466f66254aa75085$var$_boolean = function _boolean(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $466f66254aa75085$var$regexp = function regexp(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (!$466f66254aa75085$var$isEmptyValue(value)) $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $466f66254aa75085$var$integer = function integer(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) {
            $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
            $466f66254aa75085$var$rules.range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $466f66254aa75085$var$floatFn = function floatFn(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) {
            $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
            $466f66254aa75085$var$rules.range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $466f66254aa75085$var$array = function array(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((value === undefined || value === null) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options, "array");
        if (value !== undefined && value !== null) {
            $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
            $466f66254aa75085$var$rules.range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $466f66254aa75085$var$object = function object(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $466f66254aa75085$var$ENUM = "enum";
var $466f66254aa75085$var$enumerable = function enumerable(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) $466f66254aa75085$var$rules[$466f66254aa75085$var$ENUM](rule, value, source, errors, options);
    }
    callback(errors);
};
var $466f66254aa75085$var$pattern = function pattern(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value, "string") && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (!$466f66254aa75085$var$isEmptyValue(value, "string")) $466f66254aa75085$var$rules.pattern(rule, value, source, errors, options);
    }
    callback(errors);
};
var $466f66254aa75085$var$date = function date(rule, value, callback, source, options) {
    // console.log('integer rule called %j', rule);
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field); // console.log('validate on %s value', value);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value, "date") && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (!$466f66254aa75085$var$isEmptyValue(value, "date")) {
            var dateObject;
            if (value instanceof Date) dateObject = value;
            else dateObject = new Date(value);
            $466f66254aa75085$var$rules.type(rule, dateObject, source, errors, options);
            if (dateObject) $466f66254aa75085$var$rules.range(rule, dateObject.getTime(), source, errors, options);
        }
    }
    callback(errors);
};
var $466f66254aa75085$var$required = function required(rule, value, callback, source, options) {
    var errors = [];
    var type = Array.isArray(value) ? "array" : typeof value;
    $466f66254aa75085$var$rules.required(rule, value, source, errors, options, type);
    callback(errors);
};
var $466f66254aa75085$var$type = function type(rule, value, callback, source, options) {
    var ruleType = rule.type;
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value, ruleType) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options, ruleType);
        if (!$466f66254aa75085$var$isEmptyValue(value, ruleType)) $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $466f66254aa75085$var$any = function any(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
    }
    callback(errors);
};
var $466f66254aa75085$var$validators = {
    string: $466f66254aa75085$var$string,
    method: $466f66254aa75085$var$method,
    number: $466f66254aa75085$var$number,
    "boolean": $466f66254aa75085$var$_boolean,
    regexp: $466f66254aa75085$var$regexp,
    integer: $466f66254aa75085$var$integer,
    "float": $466f66254aa75085$var$floatFn,
    array: $466f66254aa75085$var$array,
    object: $466f66254aa75085$var$object,
    "enum": $466f66254aa75085$var$enumerable,
    pattern: $466f66254aa75085$var$pattern,
    date: $466f66254aa75085$var$date,
    url: $466f66254aa75085$var$type,
    hex: $466f66254aa75085$var$type,
    email: $466f66254aa75085$var$type,
    required: $466f66254aa75085$var$required,
    any: $466f66254aa75085$var$any
};
function $466f66254aa75085$var$newMessages() {
    return {
        "default": "Validation error on field %s",
        required: "%s is required",
        "enum": "%s must be one of %s",
        whitespace: "%s cannot be empty",
        date: {
            format: "%s date %s is invalid for format %s",
            parse: "%s date could not be parsed, %s is invalid ",
            invalid: "%s date %s is invalid"
        },
        types: {
            string: "%s is not a %s",
            method: "%s is not a %s (function)",
            array: "%s is not an %s",
            object: "%s is not an %s",
            number: "%s is not a %s",
            date: "%s is not a %s",
            "boolean": "%s is not a %s",
            integer: "%s is not an %s",
            "float": "%s is not a %s",
            regexp: "%s is not a valid %s",
            email: "%s is not a valid %s",
            url: "%s is not a valid %s",
            hex: "%s is not a valid %s"
        },
        string: {
            len: "%s must be exactly %s characters",
            min: "%s must be at least %s characters",
            max: "%s cannot be longer than %s characters",
            range: "%s must be between %s and %s characters"
        },
        number: {
            len: "%s must equal %s",
            min: "%s cannot be less than %s",
            max: "%s cannot be greater than %s",
            range: "%s must be between %s and %s"
        },
        array: {
            len: "%s must be exactly %s in length",
            min: "%s cannot be less than %s in length",
            max: "%s cannot be greater than %s in length",
            range: "%s must be between %s and %s in length"
        },
        pattern: {
            mismatch: "%s value %s does not match pattern %s"
        },
        clone: function clone() {
            var cloned = JSON.parse(JSON.stringify(this));
            cloned.clone = this.clone;
            return cloned;
        }
    };
}
var $466f66254aa75085$var$messages = $466f66254aa75085$var$newMessages();
/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */ var $466f66254aa75085$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    // ========================= Static =========================
    // ======================== Instance ========================
    function Schema(descriptor) {
        this.rules = null;
        this._messages = $466f66254aa75085$var$messages;
        this.define(descriptor);
    }
    var _proto = Schema.prototype;
    _proto.define = function define(rules) {
        var _this = this;
        if (!rules) throw new Error("Cannot configure a schema with no rules");
        if (typeof rules !== "object" || Array.isArray(rules)) throw new Error("Rules must be an object");
        this.rules = {};
        Object.keys(rules).forEach(function(name) {
            var item = rules[name];
            _this.rules[name] = Array.isArray(item) ? item : [
                item
            ];
        });
    };
    _proto.messages = function messages(_messages) {
        if (_messages) this._messages = $466f66254aa75085$var$deepMerge($466f66254aa75085$var$newMessages(), _messages);
        return this._messages;
    };
    _proto.validate = function validate(source_, o, oc) {
        var _this2 = this;
        if (o === void 0) o = {};
        if (oc === void 0) oc = function oc() {};
        var source = source_;
        var options = o;
        var callback = oc;
        if (typeof options === "function") {
            callback = options;
            options = {};
        }
        if (!this.rules || Object.keys(this.rules).length === 0) {
            if (callback) callback(null, source);
            return Promise.resolve(source);
        }
        function complete(results) {
            var errors = [];
            var fields = {};
            function add(e) {
                if (Array.isArray(e)) {
                    var _errors;
                    errors = (_errors = errors).concat.apply(_errors, e);
                } else errors.push(e);
            }
            for(var i = 0; i < results.length; i++)add(results[i]);
            if (!errors.length) callback(null, source);
            else {
                fields = $466f66254aa75085$var$convertFieldsError(errors);
                callback(errors, fields);
            }
        }
        if (options.messages) {
            var messages$1 = this.messages();
            if (messages$1 === $466f66254aa75085$var$messages) messages$1 = $466f66254aa75085$var$newMessages();
            $466f66254aa75085$var$deepMerge(messages$1, options.messages);
            options.messages = messages$1;
        } else options.messages = this.messages();
        var series = {};
        var keys = options.keys || Object.keys(this.rules);
        keys.forEach(function(z) {
            var arr = _this2.rules[z];
            var value = source[z];
            arr.forEach(function(r) {
                var rule = r;
                if (typeof rule.transform === "function") {
                    if (source === source_) source = $466f66254aa75085$var$_extends({}, source);
                    value = source[z] = rule.transform(value);
                }
                if (typeof rule === "function") rule = {
                    validator: rule
                };
                else rule = $466f66254aa75085$var$_extends({}, rule);
                 // Fill validator. Skip if nothing need to validate
                rule.validator = _this2.getValidationMethod(rule);
                if (!rule.validator) return;
                rule.field = z;
                rule.fullField = rule.fullField || z;
                rule.type = _this2.getType(rule);
                series[z] = series[z] || [];
                series[z].push({
                    rule: rule,
                    value: value,
                    source: source,
                    field: z
                });
            });
        });
        var errorFields = {};
        return $466f66254aa75085$var$asyncMap(series, options, function(data, doIt) {
            var rule = data.rule;
            var deep = (rule.type === "object" || rule.type === "array") && (typeof rule.fields === "object" || typeof rule.defaultField === "object");
            deep = deep && (rule.required || !rule.required && data.value);
            rule.field = data.field;
            function addFullField(key, schema) {
                return $466f66254aa75085$var$_extends({}, schema, {
                    fullField: rule.fullField + "." + key,
                    fullFields: rule.fullFields ? [].concat(rule.fullFields, [
                        key
                    ]) : [
                        key
                    ]
                });
            }
            function cb(e) {
                if (e === void 0) e = [];
                var errorList = Array.isArray(e) ? e : [
                    e
                ];
                if (!options.suppressWarning && errorList.length) Schema.warning("async-validator:", errorList);
                if (errorList.length && rule.message !== undefined) errorList = [].concat(rule.message);
                 // Fill error info
                var filledErrors = errorList.map($466f66254aa75085$var$complementError(rule, source));
                if (options.first && filledErrors.length) {
                    errorFields[rule.field] = 1;
                    return doIt(filledErrors);
                }
                if (!deep) doIt(filledErrors);
                else {
                    // if rule is required but the target object
                    // does not exist fail at the rule level and don't
                    // go deeper
                    if (rule.required && !data.value) {
                        if (rule.message !== undefined) filledErrors = [].concat(rule.message).map($466f66254aa75085$var$complementError(rule, source));
                        else if (options.error) filledErrors = [
                            options.error(rule, $466f66254aa75085$var$format(options.messages.required, rule.field))
                        ];
                        return doIt(filledErrors);
                    }
                    var fieldsSchema = {};
                    if (rule.defaultField) Object.keys(data.value).map(function(key) {
                        fieldsSchema[key] = rule.defaultField;
                    });
                    fieldsSchema = $466f66254aa75085$var$_extends({}, fieldsSchema, data.rule.fields);
                    var paredFieldsSchema = {};
                    Object.keys(fieldsSchema).forEach(function(field) {
                        var fieldSchema = fieldsSchema[field];
                        var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [
                            fieldSchema
                        ];
                        paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
                    });
                    var schema = new Schema(paredFieldsSchema);
                    schema.messages(options.messages);
                    if (data.rule.options) {
                        data.rule.options.messages = options.messages;
                        data.rule.options.error = options.error;
                    }
                    schema.validate(data.value, data.rule.options || options, function(errs) {
                        var finalErrors = [];
                        if (filledErrors && filledErrors.length) finalErrors.push.apply(finalErrors, filledErrors);
                        if (errs && errs.length) finalErrors.push.apply(finalErrors, errs);
                        doIt(finalErrors.length ? finalErrors : null);
                    });
                }
            }
            var res;
            if (rule.asyncValidator) res = rule.asyncValidator(rule, data.value, cb, data.source, options);
            else if (rule.validator) {
                try {
                    res = rule.validator(rule, data.value, cb, data.source, options);
                } catch (error) {
                    console.error == null || console.error(error); // rethrow to report error
                    if (!options.suppressValidatorError) setTimeout(function() {
                        throw error;
                    }, 0);
                    cb(error.message);
                }
                if (res === true) cb();
                else if (res === false) cb(typeof rule.message === "function" ? rule.message(rule.fullField || rule.field) : rule.message || (rule.fullField || rule.field) + " fails");
                else if (res instanceof Array) cb(res);
                else if (res instanceof Error) cb(res.message);
            }
            if (res && res.then) res.then(function() {
                return cb();
            }, function(e) {
                return cb(e);
            });
        }, function(results) {
            complete(results);
        }, source);
    };
    _proto.getType = function getType(rule) {
        if (rule.type === undefined && rule.pattern instanceof RegExp) rule.type = "pattern";
        if (typeof rule.validator !== "function" && rule.type && !$466f66254aa75085$var$validators.hasOwnProperty(rule.type)) throw new Error($466f66254aa75085$var$format("Unknown rule type %s", rule.type));
        return rule.type || "string";
    };
    _proto.getValidationMethod = function getValidationMethod(rule) {
        if (typeof rule.validator === "function") return rule.validator;
        var keys = Object.keys(rule);
        var messageIndex = keys.indexOf("message");
        if (messageIndex !== -1) keys.splice(messageIndex, 1);
        if (keys.length === 1 && keys[0] === "required") return $466f66254aa75085$var$validators.required;
        return $466f66254aa75085$var$validators[this.getType(rule)] || undefined;
    };
    return Schema;
}();
$466f66254aa75085$export$2e2bcd8739ae039.register = function register(type, validator) {
    if (typeof validator !== "function") throw new Error("Cannot register a validator by type, validator is not a function");
    $466f66254aa75085$var$validators[type] = validator;
};
$466f66254aa75085$export$2e2bcd8739ae039.warning = $466f66254aa75085$var$warning;
$466f66254aa75085$export$2e2bcd8739ae039.messages = $466f66254aa75085$var$messages;
$466f66254aa75085$export$2e2bcd8739ae039.validators = $466f66254aa75085$var$validators;

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("kg8Ze", function(module, exports) {

$parcel$export(module.exports, "defaultValidateMessages", () => $ebfc45d3b86f29a2$export$c86b939816b8fbf8);
var $ebfc45d3b86f29a2$var$typeTemplate = "'${name}' is not a valid ${type}";
var $ebfc45d3b86f29a2$export$c86b939816b8fbf8 = {
    default: "Validation error on field '${name}'",
    required: "'${name}' is required",
    enum: "'${name}' must be one of [${enum}]",
    whitespace: "'${name}' cannot be empty",
    date: {
        format: "'${name}' is invalid for format date",
        parse: "'${name}' could not be parsed as date",
        invalid: "'${name}' is invalid date"
    },
    types: {
        string: $ebfc45d3b86f29a2$var$typeTemplate,
        method: $ebfc45d3b86f29a2$var$typeTemplate,
        array: $ebfc45d3b86f29a2$var$typeTemplate,
        object: $ebfc45d3b86f29a2$var$typeTemplate,
        number: $ebfc45d3b86f29a2$var$typeTemplate,
        date: $ebfc45d3b86f29a2$var$typeTemplate,
        boolean: $ebfc45d3b86f29a2$var$typeTemplate,
        integer: $ebfc45d3b86f29a2$var$typeTemplate,
        float: $ebfc45d3b86f29a2$var$typeTemplate,
        regexp: $ebfc45d3b86f29a2$var$typeTemplate,
        email: $ebfc45d3b86f29a2$var$typeTemplate,
        url: $ebfc45d3b86f29a2$var$typeTemplate,
        hex: $ebfc45d3b86f29a2$var$typeTemplate
    },
    string: {
        len: "'${name}' must be exactly ${len} characters",
        min: "'${name}' must be at least ${min} characters",
        max: "'${name}' cannot be longer than ${max} characters",
        range: "'${name}' must be between ${min} and ${max} characters"
    },
    number: {
        len: "'${name}' must equal ${len}",
        min: "'${name}' cannot be less than ${min}",
        max: "'${name}' cannot be greater than ${max}",
        range: "'${name}' must be between ${min} and ${max}"
    },
    array: {
        len: "'${name}' must be exactly ${len} in length",
        min: "'${name}' cannot be less than ${min} in length",
        max: "'${name}' cannot be greater than ${max} in length",
        range: "'${name}' must be between ${min} and ${max} in length"
    },
    pattern: {
        mismatch: "'${name}' does not match pattern ${pattern}"
    }
};

});


parcelRegister("kFGlN", function(module, exports) {

$parcel$export(module.exports, "getNamePath", () => $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9);
$parcel$export(module.exports, "cloneByNamePathList", () => $f0c87cef6ee60bcb$export$f5be6dfb30403c59);
$parcel$export(module.exports, "containsNamePath", () => $f0c87cef6ee60bcb$export$646d5504364ae55b);
$parcel$export(module.exports, "matchNamePath", () => $f0c87cef6ee60bcb$export$325a4bd0e71bdc3a);
$parcel$export(module.exports, "isSimilar", () => $f0c87cef6ee60bcb$export$dfcec05bb7372a54);
$parcel$export(module.exports, "defaultGetValueFromEvent", () => $f0c87cef6ee60bcb$export$6eeac3c5b406fb30);
$parcel$export(module.exports, "move", () => $f0c87cef6ee60bcb$export$d947e5f4f4c48d48);
$parcel$export(module.exports, "getValue", () => (parcelRequire("23Gye")).default);
$parcel$export(module.exports, "setValue", () => (parcelRequire("6vgkH")).default);

var $kbxxf = parcelRequire("kbxxf");

var $fSwVM = parcelRequire("fSwVM");

var $23Gye = parcelRequire("23Gye");

var $6vgkH = parcelRequire("6vgkH");

var $hhXFI = parcelRequire("hhXFI");
function $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9(path) {
    return (0, $hhXFI.toArray)(path);
}
function $f0c87cef6ee60bcb$export$f5be6dfb30403c59(store, namePathList) {
    var newStore = {};
    namePathList.forEach(function(namePath) {
        var value = (0, $23Gye.default)(store, namePath);
        newStore = (0, $6vgkH.default)(newStore, namePath, value);
    });
    return newStore;
}
function $f0c87cef6ee60bcb$export$646d5504364ae55b(namePathList, namePath) {
    var partialMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return namePathList && namePathList.some(function(path) {
        return $f0c87cef6ee60bcb$export$325a4bd0e71bdc3a(namePath, path, partialMatch);
    });
}
function $f0c87cef6ee60bcb$export$325a4bd0e71bdc3a(namePath, subNamePath) {
    var partialMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!namePath || !subNamePath) return false;
    if (!partialMatch && namePath.length !== subNamePath.length) return false;
    return subNamePath.every(function(nameUnit, i) {
        return namePath[i] === nameUnit;
    });
}
function $f0c87cef6ee60bcb$export$dfcec05bb7372a54(source, target) {
    if (source === target) return true;
    if (!source && target || source && !target) return false;
    if (!source || !target || (0, $fSwVM.default)(source) !== "object" || (0, $fSwVM.default)(target) !== "object") return false;
    var sourceKeys = Object.keys(source);
    var targetKeys = Object.keys(target);
    var keys = new Set([].concat(sourceKeys, targetKeys));
    return (0, $kbxxf.default)(keys).every(function(key) {
        var sourceValue = source[key];
        var targetValue = target[key];
        if (typeof sourceValue === "function" && typeof targetValue === "function") return true;
        return sourceValue === targetValue;
    });
}
function $f0c87cef6ee60bcb$export$6eeac3c5b406fb30(valuePropName) {
    var event = arguments.length <= 1 ? undefined : arguments[1];
    if (event && event.target && (0, $fSwVM.default)(event.target) === "object" && valuePropName in event.target) return event.target[valuePropName];
    return event;
}
function $f0c87cef6ee60bcb$export$d947e5f4f4c48d48(array, moveIndex, toIndex) {
    var length = array.length;
    if (moveIndex < 0 || moveIndex >= length || toIndex < 0 || toIndex >= length) return array;
    var item = array[moveIndex];
    var diff = moveIndex - toIndex;
    if (diff > 0) // move left
    return [].concat((0, $kbxxf.default)(array.slice(0, toIndex)), [
        item
    ], (0, $kbxxf.default)(array.slice(toIndex, moveIndex)), (0, $kbxxf.default)(array.slice(moveIndex + 1, length)));
    if (diff < 0) // move right
    return [].concat((0, $kbxxf.default)(array.slice(0, moveIndex)), (0, $kbxxf.default)(array.slice(moveIndex + 1, toIndex + 1)), [
        item
    ], (0, $kbxxf.default)(array.slice(toIndex + 1, length)));
    return array;
}

});


parcelRegister("2iMfo", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ad2b0235e0eb0b7$export$2e2bcd8739ae039);

var $d49SP = parcelRequire("d49SP");

var $kbxxf = parcelRequire("kbxxf");

var $acw62 = parcelRequire("acw62");

var $u43uR = parcelRequire("u43uR");

var $260BS = parcelRequire("260BS");

var $4llrF = parcelRequire("4llrF");

var $kFGlN = parcelRequire("kFGlN");

var $livSf = parcelRequire("livSf");
function $1ad2b0235e0eb0b7$var$List(_ref) {
    var name = _ref.name, initialValue = _ref.initialValue, children = _ref.children, rules = _ref.rules, validateTrigger = _ref.validateTrigger, isListField = _ref.isListField;
    var context = $acw62.useContext((0, $260BS.default));
    var wrapperListContext = $acw62.useContext((0, $livSf.default));
    var keyRef = $acw62.useRef({
        keys: [],
        id: 0
    });
    var keyManager = keyRef.current;
    var prefixName = $acw62.useMemo(function() {
        var parentPrefixName = (0, $kFGlN.getNamePath)(context.prefixName) || [];
        return [].concat((0, $kbxxf.default)(parentPrefixName), (0, $kbxxf.default)((0, $kFGlN.getNamePath)(name)));
    }, [
        context.prefixName,
        name
    ]);
    var fieldContext = $acw62.useMemo(function() {
        return (0, $d49SP.default)((0, $d49SP.default)({}, context), {}, {
            prefixName: prefixName
        });
    }, [
        context,
        prefixName
    ]);
    // List context
    var listContext = $acw62.useMemo(function() {
        return {
            getKey: function getKey(namePath) {
                var len = prefixName.length;
                var pathName = namePath[len];
                return [
                    keyManager.keys[pathName],
                    namePath.slice(len + 1)
                ];
            }
        };
    }, [
        prefixName
    ]);
    // User should not pass `children` as other type.
    if (typeof children !== "function") {
        (0, $u43uR.default)(false, "Form.List only accepts function as children.");
        return null;
    }
    var shouldUpdate = function shouldUpdate(prevValue, nextValue, _ref2) {
        var source = _ref2.source;
        if (source === "internal") return false;
        return prevValue !== nextValue;
    };
    return /*#__PURE__*/ $acw62.createElement((0, $livSf.default).Provider, {
        value: listContext
    }, /*#__PURE__*/ $acw62.createElement((0, $260BS.default).Provider, {
        value: fieldContext
    }, /*#__PURE__*/ $acw62.createElement((0, $4llrF.default), {
        name: [],
        shouldUpdate: shouldUpdate,
        rules: rules,
        validateTrigger: validateTrigger,
        initialValue: initialValue,
        isList: true,
        isListField: isListField !== null && isListField !== void 0 ? isListField : !!wrapperListContext
    }, function(_ref3, meta) {
        var _ref3$value = _ref3.value, value = _ref3$value === void 0 ? [] : _ref3$value, onChange = _ref3.onChange;
        var getFieldValue = context.getFieldValue;
        var getNewValue = function getNewValue() {
            var values = getFieldValue(prefixName || []);
            return values || [];
        };
        /**
     * Always get latest value in case user update fields by `form` api.
     */ var operations = {
            add: function add(defaultValue, index) {
                // Mapping keys
                var newValue = getNewValue();
                if (index >= 0 && index <= newValue.length) {
                    keyManager.keys = [].concat((0, $kbxxf.default)(keyManager.keys.slice(0, index)), [
                        keyManager.id
                    ], (0, $kbxxf.default)(keyManager.keys.slice(index)));
                    onChange([].concat((0, $kbxxf.default)(newValue.slice(0, index)), [
                        defaultValue
                    ], (0, $kbxxf.default)(newValue.slice(index))));
                } else {
                    keyManager.keys = [].concat((0, $kbxxf.default)(keyManager.keys), [
                        keyManager.id
                    ]);
                    onChange([].concat((0, $kbxxf.default)(newValue), [
                        defaultValue
                    ]));
                }
                keyManager.id += 1;
            },
            remove: function remove(index) {
                var newValue = getNewValue();
                var indexSet = new Set(Array.isArray(index) ? index : [
                    index
                ]);
                if (indexSet.size <= 0) return;
                keyManager.keys = keyManager.keys.filter(function(_, keysIndex) {
                    return !indexSet.has(keysIndex);
                });
                // Trigger store change
                onChange(newValue.filter(function(_, valueIndex) {
                    return !indexSet.has(valueIndex);
                }));
            },
            move: function move(from, to) {
                if (from === to) return;
                var newValue = getNewValue();
                // Do not handle out of range
                if (from < 0 || from >= newValue.length || to < 0 || to >= newValue.length) return;
                keyManager.keys = (0, $kFGlN.move)(keyManager.keys, from, to);
                // Trigger store change
                onChange((0, $kFGlN.move)(newValue, from, to));
            }
        };
        var listValue = value || [];
        if (!Array.isArray(listValue)) listValue = [];
        return children(listValue.map(function(__, index) {
            var key = keyManager.keys[index];
            if (key === undefined) {
                keyManager.keys[index] = keyManager.id;
                key = keyManager.keys[index];
                keyManager.id += 1;
            }
            return {
                name: index,
                key: key,
                isListField: true
            };
        }), operations, meta);
    })));
}
var $1ad2b0235e0eb0b7$export$2e2bcd8739ae039 = $1ad2b0235e0eb0b7$var$List;

});

parcelRegister("dRl3b", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1708dc7c20669c0$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $d49SP = parcelRequire("d49SP");

var $9X7IJ = parcelRequire("9X7IJ");

var $kbxxf = parcelRequire("kbxxf");

var $fSwVM = parcelRequire("fSwVM");

var $cHPF9 = parcelRequire("cHPF9");

var $6CZeq = parcelRequire("6CZeq");

var $kSlfw = parcelRequire("kSlfw");

var $6vgkH = parcelRequire("6vgkH");

var $u43uR = parcelRequire("u43uR");

var $acw62 = parcelRequire("acw62");

var $260BS = parcelRequire("260BS");

var $2yepO = parcelRequire("2yepO");

var $kg8Ze = parcelRequire("kg8Ze");

var $g2KHW = parcelRequire("g2KHW");

var $kFGlN = parcelRequire("kFGlN");
var $23Gye = parcelRequire("23Gye");
var $6vgkH = parcelRequire("6vgkH");
var $a1708dc7c20669c0$var$_excluded = [
    "name"
];
var $a1708dc7c20669c0$export$75ff1ab1187e691 = /*#__PURE__*/ (0, $cHPF9.default)(function FormStore(forceRootUpdate) {
    var _this = this;
    (0, $6CZeq.default)(this, FormStore);
    (0, $kSlfw.default)(this, "formHooked", false);
    (0, $kSlfw.default)(this, "forceRootUpdate", void 0);
    (0, $kSlfw.default)(this, "subscribable", true);
    (0, $kSlfw.default)(this, "store", {});
    (0, $kSlfw.default)(this, "fieldEntities", []);
    (0, $kSlfw.default)(this, "initialValues", {});
    (0, $kSlfw.default)(this, "callbacks", {});
    (0, $kSlfw.default)(this, "validateMessages", null);
    (0, $kSlfw.default)(this, "preserve", null);
    (0, $kSlfw.default)(this, "lastValidatePromise", null);
    (0, $kSlfw.default)(this, "getForm", function() {
        return {
            getFieldValue: _this.getFieldValue,
            getFieldsValue: _this.getFieldsValue,
            getFieldError: _this.getFieldError,
            getFieldWarning: _this.getFieldWarning,
            getFieldsError: _this.getFieldsError,
            isFieldsTouched: _this.isFieldsTouched,
            isFieldTouched: _this.isFieldTouched,
            isFieldValidating: _this.isFieldValidating,
            isFieldsValidating: _this.isFieldsValidating,
            resetFields: _this.resetFields,
            setFields: _this.setFields,
            setFieldValue: _this.setFieldValue,
            setFieldsValue: _this.setFieldsValue,
            validateFields: _this.validateFields,
            submit: _this.submit,
            _init: true,
            getInternalHooks: _this.getInternalHooks
        };
    });
    // ======================== Internal Hooks ========================
    (0, $kSlfw.default)(this, "getInternalHooks", function(key) {
        if (key === (0, $260BS.HOOK_MARK)) {
            _this.formHooked = true;
            return {
                dispatch: _this.dispatch,
                initEntityValue: _this.initEntityValue,
                registerField: _this.registerField,
                useSubscribe: _this.useSubscribe,
                setInitialValues: _this.setInitialValues,
                destroyForm: _this.destroyForm,
                setCallbacks: _this.setCallbacks,
                setValidateMessages: _this.setValidateMessages,
                getFields: _this.getFields,
                setPreserve: _this.setPreserve,
                getInitialValue: _this.getInitialValue,
                registerWatch: _this.registerWatch
            };
        }
        (0, $u43uR.default)(false, "`getInternalHooks` is internal usage. Should not call directly.");
        return null;
    });
    (0, $kSlfw.default)(this, "useSubscribe", function(subscribable) {
        _this.subscribable = subscribable;
    });
    /**
   * Record prev Form unmount fieldEntities which config preserve false.
   * This need to be refill with initialValues instead of store value.
   */ (0, $kSlfw.default)(this, "prevWithoutPreserves", null);
    /**
   * First time `setInitialValues` should update store with initial value
   */ (0, $kSlfw.default)(this, "setInitialValues", function(initialValues, init) {
        _this.initialValues = initialValues || {};
        if (init) {
            var _this$prevWithoutPres;
            var nextStore = (0, $6vgkH.merge)(initialValues, _this.store);
            // We will take consider prev form unmount fields.
            // When the field is not `preserve`, we need fill this with initialValues instead of store.
            // eslint-disable-next-line array-callback-return
            (_this$prevWithoutPres = _this.prevWithoutPreserves) === null || _this$prevWithoutPres === void 0 || _this$prevWithoutPres.map(function(_ref) {
                var namePath = _ref.key;
                nextStore = (0, $6vgkH.default)(nextStore, namePath, (0, $23Gye.default)(initialValues, namePath));
            });
            _this.prevWithoutPreserves = null;
            _this.updateStore(nextStore);
        }
    });
    (0, $kSlfw.default)(this, "destroyForm", function() {
        var prevWithoutPreserves = new (0, $g2KHW.default)();
        _this.getFieldEntities(true).forEach(function(entity) {
            if (!_this.isMergedPreserve(entity.isPreserve())) prevWithoutPreserves.set(entity.getNamePath(), true);
        });
        _this.prevWithoutPreserves = prevWithoutPreserves;
    });
    (0, $kSlfw.default)(this, "getInitialValue", function(namePath) {
        var initValue = (0, $23Gye.default)(_this.initialValues, namePath);
        // Not cloneDeep when without `namePath`
        return namePath.length ? (0, $6vgkH.merge)(initValue) : initValue;
    });
    (0, $kSlfw.default)(this, "setCallbacks", function(callbacks) {
        _this.callbacks = callbacks;
    });
    (0, $kSlfw.default)(this, "setValidateMessages", function(validateMessages) {
        _this.validateMessages = validateMessages;
    });
    (0, $kSlfw.default)(this, "setPreserve", function(preserve) {
        _this.preserve = preserve;
    });
    // ============================= Watch ============================
    (0, $kSlfw.default)(this, "watchList", []);
    (0, $kSlfw.default)(this, "registerWatch", function(callback) {
        _this.watchList.push(callback);
        return function() {
            _this.watchList = _this.watchList.filter(function(fn) {
                return fn !== callback;
            });
        };
    });
    (0, $kSlfw.default)(this, "notifyWatch", function() {
        var namePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        // No need to cost perf when nothing need to watch
        if (_this.watchList.length) {
            var values = _this.getFieldsValue();
            var allValues = _this.getFieldsValue(true);
            _this.watchList.forEach(function(callback) {
                callback(values, allValues, namePath);
            });
        }
    });
    // ========================== Dev Warning =========================
    (0, $kSlfw.default)(this, "timeoutId", null);
    (0, $kSlfw.default)(this, "warningUnhooked", function() {});
    // ============================ Store =============================
    (0, $kSlfw.default)(this, "updateStore", function(nextStore) {
        _this.store = nextStore;
    });
    // ============================ Fields ============================
    /**
   * Get registered field entities.
   * @param pure Only return field which has a `name`. Default: false
   */ (0, $kSlfw.default)(this, "getFieldEntities", function() {
        var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (!pure) return _this.fieldEntities;
        return _this.fieldEntities.filter(function(field) {
            return field.getNamePath().length;
        });
    });
    (0, $kSlfw.default)(this, "getFieldsMap", function() {
        var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var cache = new (0, $g2KHW.default)();
        _this.getFieldEntities(pure).forEach(function(field) {
            var namePath = field.getNamePath();
            cache.set(namePath, field);
        });
        return cache;
    });
    (0, $kSlfw.default)(this, "getFieldEntitiesForNamePathList", function(nameList) {
        if (!nameList) return _this.getFieldEntities(true);
        var cache = _this.getFieldsMap(true);
        return nameList.map(function(name) {
            var namePath = (0, $kFGlN.getNamePath)(name);
            return cache.get(namePath) || {
                INVALIDATE_NAME_PATH: (0, $kFGlN.getNamePath)(name)
            };
        });
    });
    (0, $kSlfw.default)(this, "getFieldsValue", function(nameList, filterFunc) {
        _this.warningUnhooked();
        // Fill args
        var mergedNameList;
        var mergedFilterFunc;
        var mergedStrict;
        if (nameList === true || Array.isArray(nameList)) {
            mergedNameList = nameList;
            mergedFilterFunc = filterFunc;
        } else if (nameList && (0, $fSwVM.default)(nameList) === "object") {
            mergedStrict = nameList.strict;
            mergedFilterFunc = nameList.filter;
        }
        if (mergedNameList === true && !mergedFilterFunc) return _this.store;
        var fieldEntities = _this.getFieldEntitiesForNamePathList(Array.isArray(mergedNameList) ? mergedNameList : null);
        var filteredNameList = [];
        fieldEntities.forEach(function(entity) {
            var _isListField, _ref3;
            var namePath = "INVALIDATE_NAME_PATH" in entity ? entity.INVALIDATE_NAME_PATH : entity.getNamePath();
            // Ignore when it's a list item and not specific the namePath,
            // since parent field is already take in count
            if (mergedStrict) {
                var _isList, _ref2;
                if ((_isList = (_ref2 = entity).isList) !== null && _isList !== void 0 && _isList.call(_ref2)) return;
            } else if (!mergedNameList && (_isListField = (_ref3 = entity).isListField) !== null && _isListField !== void 0 && _isListField.call(_ref3)) return;
            if (!mergedFilterFunc) filteredNameList.push(namePath);
            else {
                var meta = "getMeta" in entity ? entity.getMeta() : null;
                if (mergedFilterFunc(meta)) filteredNameList.push(namePath);
            }
        });
        return (0, $kFGlN.cloneByNamePathList)(_this.store, filteredNameList.map((0, $kFGlN.getNamePath)));
    });
    (0, $kSlfw.default)(this, "getFieldValue", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $kFGlN.getNamePath)(name);
        return (0, $23Gye.default)(_this.store, namePath);
    });
    (0, $kSlfw.default)(this, "getFieldsError", function(nameList) {
        _this.warningUnhooked();
        var fieldEntities = _this.getFieldEntitiesForNamePathList(nameList);
        return fieldEntities.map(function(entity, index) {
            if (entity && !("INVALIDATE_NAME_PATH" in entity)) return {
                name: entity.getNamePath(),
                errors: entity.getErrors(),
                warnings: entity.getWarnings()
            };
            return {
                name: (0, $kFGlN.getNamePath)(nameList[index]),
                errors: [],
                warnings: []
            };
        });
    });
    (0, $kSlfw.default)(this, "getFieldError", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $kFGlN.getNamePath)(name);
        var fieldError = _this.getFieldsError([
            namePath
        ])[0];
        return fieldError.errors;
    });
    (0, $kSlfw.default)(this, "getFieldWarning", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $kFGlN.getNamePath)(name);
        var fieldError = _this.getFieldsError([
            namePath
        ])[0];
        return fieldError.warnings;
    });
    (0, $kSlfw.default)(this, "isFieldsTouched", function() {
        _this.warningUnhooked();
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var arg0 = args[0], arg1 = args[1];
        var namePathList;
        var isAllFieldsTouched = false;
        if (args.length === 0) namePathList = null;
        else if (args.length === 1) {
            if (Array.isArray(arg0)) {
                namePathList = arg0.map((0, $kFGlN.getNamePath));
                isAllFieldsTouched = false;
            } else {
                namePathList = null;
                isAllFieldsTouched = arg0;
            }
        } else {
            namePathList = arg0.map((0, $kFGlN.getNamePath));
            isAllFieldsTouched = arg1;
        }
        var fieldEntities = _this.getFieldEntities(true);
        var isFieldTouched = function isFieldTouched(field) {
            return field.isFieldTouched();
        };
        // ===== Will get fully compare when not config namePathList =====
        if (!namePathList) return isAllFieldsTouched ? fieldEntities.every(isFieldTouched) : fieldEntities.some(isFieldTouched);
        // Generate a nest tree for validate
        var map = new (0, $g2KHW.default)();
        namePathList.forEach(function(shortNamePath) {
            map.set(shortNamePath, []);
        });
        fieldEntities.forEach(function(field) {
            var fieldNamePath = field.getNamePath();
            // Find matched entity and put into list
            namePathList.forEach(function(shortNamePath) {
                if (shortNamePath.every(function(nameUnit, i) {
                    return fieldNamePath[i] === nameUnit;
                })) map.update(shortNamePath, function(list) {
                    return [].concat((0, $kbxxf.default)(list), [
                        field
                    ]);
                });
            });
        });
        // Check if NameMap value is touched
        var isNamePathListTouched = function isNamePathListTouched(entities) {
            return entities.some(isFieldTouched);
        };
        var namePathListEntities = map.map(function(_ref4) {
            var value = _ref4.value;
            return value;
        });
        return isAllFieldsTouched ? namePathListEntities.every(isNamePathListTouched) : namePathListEntities.some(isNamePathListTouched);
    });
    (0, $kSlfw.default)(this, "isFieldTouched", function(name) {
        _this.warningUnhooked();
        return _this.isFieldsTouched([
            name
        ]);
    });
    (0, $kSlfw.default)(this, "isFieldsValidating", function(nameList) {
        _this.warningUnhooked();
        var fieldEntities = _this.getFieldEntities();
        if (!nameList) return fieldEntities.some(function(testField) {
            return testField.isFieldValidating();
        });
        var namePathList = nameList.map((0, $kFGlN.getNamePath));
        return fieldEntities.some(function(testField) {
            var fieldNamePath = testField.getNamePath();
            return (0, $kFGlN.containsNamePath)(namePathList, fieldNamePath) && testField.isFieldValidating();
        });
    });
    (0, $kSlfw.default)(this, "isFieldValidating", function(name) {
        _this.warningUnhooked();
        return _this.isFieldsValidating([
            name
        ]);
    });
    /**
   * Reset Field with field `initialValue` prop.
   * Can pass `entities` or `namePathList` or just nothing.
   */ (0, $kSlfw.default)(this, "resetWithFieldInitialValue", function() {
        var info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // Create cache
        var cache = new (0, $g2KHW.default)();
        var fieldEntities = _this.getFieldEntities(true);
        fieldEntities.forEach(function(field) {
            var initialValue = field.props.initialValue;
            var namePath = field.getNamePath();
            // Record only if has `initialValue`
            if (initialValue !== undefined) {
                var records = cache.get(namePath) || new Set();
                records.add({
                    entity: field,
                    value: initialValue
                });
                cache.set(namePath, records);
            }
        });
        // Reset
        var resetWithFields = function resetWithFields(entities) {
            entities.forEach(function(field) {
                var initialValue = field.props.initialValue;
                if (initialValue !== undefined) {
                    var namePath = field.getNamePath();
                    var formInitialValue = _this.getInitialValue(namePath);
                    if (formInitialValue !== undefined) // Warning if conflict with form initialValues and do not modify value
                    (0, $u43uR.default)(false, "Form already set 'initialValues' with path '".concat(namePath.join("."), "'. Field can not overwrite it."));
                    else {
                        var records = cache.get(namePath);
                        if (records && records.size > 1) // Warning if multiple field set `initialValue`and do not modify value
                        (0, $u43uR.default)(false, "Multiple Field with path '".concat(namePath.join("."), "' set 'initialValue'. Can not decide which one to pick."));
                        else if (records) {
                            var originValue = _this.getFieldValue(namePath);
                            var isListField = field.isListField();
                            // Set `initialValue`
                            if (!isListField && (!info.skipExist || originValue === undefined)) _this.updateStore((0, $6vgkH.default)(_this.store, namePath, (0, $kbxxf.default)(records)[0].value));
                        }
                    }
                }
            });
        };
        var requiredFieldEntities;
        if (info.entities) requiredFieldEntities = info.entities;
        else if (info.namePathList) {
            requiredFieldEntities = [];
            info.namePathList.forEach(function(namePath) {
                var records = cache.get(namePath);
                if (records) {
                    var _requiredFieldEntitie;
                    (_requiredFieldEntitie = requiredFieldEntities).push.apply(_requiredFieldEntitie, (0, $kbxxf.default)((0, $kbxxf.default)(records).map(function(r) {
                        return r.entity;
                    })));
                }
            });
        } else requiredFieldEntities = fieldEntities;
        resetWithFields(requiredFieldEntities);
    });
    (0, $kSlfw.default)(this, "resetFields", function(nameList) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        if (!nameList) {
            _this.updateStore((0, $6vgkH.merge)(_this.initialValues));
            _this.resetWithFieldInitialValue();
            _this.notifyObservers(prevStore, null, {
                type: "reset"
            });
            _this.notifyWatch();
            return;
        }
        // Reset by `nameList`
        var namePathList = nameList.map((0, $kFGlN.getNamePath));
        namePathList.forEach(function(namePath) {
            var initialValue = _this.getInitialValue(namePath);
            _this.updateStore((0, $6vgkH.default)(_this.store, namePath, initialValue));
        });
        _this.resetWithFieldInitialValue({
            namePathList: namePathList
        });
        _this.notifyObservers(prevStore, namePathList, {
            type: "reset"
        });
        _this.notifyWatch(namePathList);
    });
    (0, $kSlfw.default)(this, "setFields", function(fields) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        var namePathList = [];
        fields.forEach(function(fieldData) {
            var name = fieldData.name, data = (0, $9X7IJ.default)(fieldData, $a1708dc7c20669c0$var$_excluded);
            var namePath = (0, $kFGlN.getNamePath)(name);
            namePathList.push(namePath);
            // Value
            if ("value" in data) _this.updateStore((0, $6vgkH.default)(_this.store, namePath, data.value));
            _this.notifyObservers(prevStore, [
                namePath
            ], {
                type: "setField",
                data: fieldData
            });
        });
        _this.notifyWatch(namePathList);
    });
    (0, $kSlfw.default)(this, "getFields", function() {
        var entities = _this.getFieldEntities(true);
        var fields = entities.map(function(field) {
            var namePath = field.getNamePath();
            var meta = field.getMeta();
            var fieldData = (0, $d49SP.default)((0, $d49SP.default)({}, meta), {}, {
                name: namePath,
                value: _this.getFieldValue(namePath)
            });
            Object.defineProperty(fieldData, "originRCField", {
                value: true
            });
            return fieldData;
        });
        return fields;
    });
    // =========================== Observer ===========================
    /**
   * This only trigger when a field is on constructor to avoid we get initialValue too late
   */ (0, $kSlfw.default)(this, "initEntityValue", function(entity) {
        var initialValue = entity.props.initialValue;
        if (initialValue !== undefined) {
            var namePath = entity.getNamePath();
            var prevValue = (0, $23Gye.default)(_this.store, namePath);
            if (prevValue === undefined) _this.updateStore((0, $6vgkH.default)(_this.store, namePath, initialValue));
        }
    });
    (0, $kSlfw.default)(this, "isMergedPreserve", function(fieldPreserve) {
        var mergedPreserve = fieldPreserve !== undefined ? fieldPreserve : _this.preserve;
        return mergedPreserve !== null && mergedPreserve !== void 0 ? mergedPreserve : true;
    });
    (0, $kSlfw.default)(this, "registerField", function(entity) {
        _this.fieldEntities.push(entity);
        var namePath = entity.getNamePath();
        _this.notifyWatch([
            namePath
        ]);
        // Set initial values
        if (entity.props.initialValue !== undefined) {
            var prevStore = _this.store;
            _this.resetWithFieldInitialValue({
                entities: [
                    entity
                ],
                skipExist: true
            });
            _this.notifyObservers(prevStore, [
                entity.getNamePath()
            ], {
                type: "valueUpdate",
                source: "internal"
            });
        }
        // un-register field callback
        return function(isListField, preserve) {
            var subNamePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            _this.fieldEntities = _this.fieldEntities.filter(function(item) {
                return item !== entity;
            });
            // Clean up store value if not preserve
            if (!_this.isMergedPreserve(preserve) && (!isListField || subNamePath.length > 1)) {
                var defaultValue = isListField ? undefined : _this.getInitialValue(namePath);
                if (namePath.length && _this.getFieldValue(namePath) !== defaultValue && _this.fieldEntities.every(function(field) {
                    return(// Only reset when no namePath exist
                    !(0, $kFGlN.matchNamePath)(field.getNamePath(), namePath));
                })) {
                    var _prevStore = _this.store;
                    _this.updateStore((0, $6vgkH.default)(_prevStore, namePath, defaultValue, true));
                    // Notify that field is unmount
                    _this.notifyObservers(_prevStore, [
                        namePath
                    ], {
                        type: "remove"
                    });
                    // Dependencies update
                    _this.triggerDependenciesUpdate(_prevStore, namePath);
                }
            }
            _this.notifyWatch([
                namePath
            ]);
        };
    });
    (0, $kSlfw.default)(this, "dispatch", function(action) {
        switch(action.type){
            case "updateValue":
                var namePath = action.namePath, value = action.value;
                _this.updateValue(namePath, value);
                break;
            case "validateField":
                var _namePath = action.namePath, triggerName = action.triggerName;
                _this.validateFields([
                    _namePath
                ], {
                    triggerName: triggerName
                });
                break;
            default:
        }
    });
    (0, $kSlfw.default)(this, "notifyObservers", function(prevStore, namePathList, info) {
        if (_this.subscribable) {
            var mergedInfo = (0, $d49SP.default)((0, $d49SP.default)({}, info), {}, {
                store: _this.getFieldsValue(true)
            });
            _this.getFieldEntities().forEach(function(_ref5) {
                var onStoreChange = _ref5.onStoreChange;
                onStoreChange(prevStore, namePathList, mergedInfo);
            });
        } else _this.forceRootUpdate();
    });
    /**
   * Notify dependencies children with parent update
   * We need delay to trigger validate in case Field is under render props
   */ (0, $kSlfw.default)(this, "triggerDependenciesUpdate", function(prevStore, namePath) {
        var childrenFields = _this.getDependencyChildrenFields(namePath);
        if (childrenFields.length) _this.validateFields(childrenFields);
        _this.notifyObservers(prevStore, childrenFields, {
            type: "dependenciesUpdate",
            relatedFields: [
                namePath
            ].concat((0, $kbxxf.default)(childrenFields))
        });
        return childrenFields;
    });
    (0, $kSlfw.default)(this, "updateValue", function(name, value) {
        var namePath = (0, $kFGlN.getNamePath)(name);
        var prevStore = _this.store;
        _this.updateStore((0, $6vgkH.default)(_this.store, namePath, value));
        _this.notifyObservers(prevStore, [
            namePath
        ], {
            type: "valueUpdate",
            source: "internal"
        });
        _this.notifyWatch([
            namePath
        ]);
        // Dependencies update
        var childrenFields = _this.triggerDependenciesUpdate(prevStore, namePath);
        // trigger callback function
        var onValuesChange = _this.callbacks.onValuesChange;
        if (onValuesChange) {
            var changedValues = (0, $kFGlN.cloneByNamePathList)(_this.store, [
                namePath
            ]);
            onValuesChange(changedValues, _this.getFieldsValue());
        }
        _this.triggerOnFieldsChange([
            namePath
        ].concat((0, $kbxxf.default)(childrenFields)));
    });
    // Let all child Field get update.
    (0, $kSlfw.default)(this, "setFieldsValue", function(store) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        if (store) {
            var nextStore = (0, $6vgkH.merge)(_this.store, store);
            _this.updateStore(nextStore);
        }
        _this.notifyObservers(prevStore, null, {
            type: "valueUpdate",
            source: "external"
        });
        _this.notifyWatch();
    });
    (0, $kSlfw.default)(this, "setFieldValue", function(name, value) {
        _this.setFields([
            {
                name: name,
                value: value
            }
        ]);
    });
    (0, $kSlfw.default)(this, "getDependencyChildrenFields", function(rootNamePath) {
        var children = new Set();
        var childrenFields = [];
        var dependencies2fields = new (0, $g2KHW.default)();
        /**
     * Generate maps
     * Can use cache to save perf if user report performance issue with this
     */ _this.getFieldEntities().forEach(function(field) {
            var dependencies = field.props.dependencies;
            (dependencies || []).forEach(function(dependency) {
                var dependencyNamePath = (0, $kFGlN.getNamePath)(dependency);
                dependencies2fields.update(dependencyNamePath, function() {
                    var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Set();
                    fields.add(field);
                    return fields;
                });
            });
        });
        var fillChildren = function fillChildren(namePath) {
            var fields = dependencies2fields.get(namePath) || new Set();
            fields.forEach(function(field) {
                if (!children.has(field)) {
                    children.add(field);
                    var fieldNamePath = field.getNamePath();
                    if (field.isFieldDirty() && fieldNamePath.length) {
                        childrenFields.push(fieldNamePath);
                        fillChildren(fieldNamePath);
                    }
                }
            });
        };
        fillChildren(rootNamePath);
        return childrenFields;
    });
    (0, $kSlfw.default)(this, "triggerOnFieldsChange", function(namePathList, filedErrors) {
        var onFieldsChange = _this.callbacks.onFieldsChange;
        if (onFieldsChange) {
            var fields = _this.getFields();
            /**
       * Fill errors since `fields` may be replaced by controlled fields
       */ if (filedErrors) {
                var cache = new (0, $g2KHW.default)();
                filedErrors.forEach(function(_ref6) {
                    var name = _ref6.name, errors = _ref6.errors;
                    cache.set(name, errors);
                });
                fields.forEach(function(field) {
                    // eslint-disable-next-line no-param-reassign
                    field.errors = cache.get(field.name) || field.errors;
                });
            }
            var changedFields = fields.filter(function(_ref7) {
                var fieldName = _ref7.name;
                return (0, $kFGlN.containsNamePath)(namePathList, fieldName);
            });
            if (changedFields.length) onFieldsChange(changedFields, fields);
        }
    });
    // =========================== Validate ===========================
    (0, $kSlfw.default)(this, "validateFields", function(arg1, arg2) {
        _this.warningUnhooked();
        var nameList;
        var options;
        if (Array.isArray(arg1) || typeof arg1 === "string" || typeof arg2 === "string") {
            nameList = arg1;
            options = arg2;
        } else options = arg1;
        var provideNameList = !!nameList;
        var namePathList = provideNameList ? nameList.map((0, $kFGlN.getNamePath)) : [];
        // Collect result in promise list
        var promiseList = [];
        // We temp save the path which need trigger for `onFieldsChange`
        var TMP_SPLIT = String(Date.now());
        var validateNamePathList = new Set();
        var _ref8 = options || {}, recursive = _ref8.recursive, dirty = _ref8.dirty;
        _this.getFieldEntities(true).forEach(function(field) {
            // Add field if not provide `nameList`
            if (!provideNameList) namePathList.push(field.getNamePath());
            // Skip if without rule
            if (!field.props.rules || !field.props.rules.length) return;
            // Skip if only validate dirty field
            if (dirty && !field.isFieldDirty()) return;
            var fieldNamePath = field.getNamePath();
            validateNamePathList.add(fieldNamePath.join(TMP_SPLIT));
            // Add field validate rule in to promise list
            if (!provideNameList || (0, $kFGlN.containsNamePath)(namePathList, fieldNamePath, recursive)) {
                var promise = field.validateRules((0, $d49SP.default)({
                    validateMessages: (0, $d49SP.default)((0, $d49SP.default)({}, (0, $kg8Ze.defaultValidateMessages)), _this.validateMessages)
                }, options));
                // Wrap promise with field
                promiseList.push(promise.then(function() {
                    return {
                        name: fieldNamePath,
                        errors: [],
                        warnings: []
                    };
                }).catch(function(ruleErrors) {
                    var _ruleErrors$forEach;
                    var mergedErrors = [];
                    var mergedWarnings = [];
                    (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref9) {
                        var warningOnly = _ref9.rule.warningOnly, errors = _ref9.errors;
                        if (warningOnly) mergedWarnings.push.apply(mergedWarnings, (0, $kbxxf.default)(errors));
                        else mergedErrors.push.apply(mergedErrors, (0, $kbxxf.default)(errors));
                    });
                    if (mergedErrors.length) return Promise.reject({
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    });
                    return {
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    };
                }));
            }
        });
        var summaryPromise = (0, $2yepO.allPromiseFinish)(promiseList);
        _this.lastValidatePromise = summaryPromise;
        // Notify fields with rule that validate has finished and need update
        summaryPromise.catch(function(results) {
            return results;
        }).then(function(results) {
            var resultNamePathList = results.map(function(_ref10) {
                var name = _ref10.name;
                return name;
            });
            _this.notifyObservers(_this.store, resultNamePathList, {
                type: "validateFinish"
            });
            _this.triggerOnFieldsChange(resultNamePathList, results);
        });
        var returnPromise = summaryPromise.then(function() {
            if (_this.lastValidatePromise === summaryPromise) return Promise.resolve(_this.getFieldsValue(namePathList));
            return Promise.reject([]);
        }).catch(function(results) {
            var errorList = results.filter(function(result) {
                return result && result.errors.length;
            });
            return Promise.reject({
                values: _this.getFieldsValue(namePathList),
                errorFields: errorList,
                outOfDate: _this.lastValidatePromise !== summaryPromise
            });
        });
        // Do not throw in console
        returnPromise.catch(function(e) {
            return e;
        });
        // `validating` changed. Trigger `onFieldsChange`
        var triggerNamePathList = namePathList.filter(function(namePath) {
            return validateNamePathList.has(namePath.join(TMP_SPLIT));
        });
        _this.triggerOnFieldsChange(triggerNamePathList);
        return returnPromise;
    });
    // ============================ Submit ============================
    (0, $kSlfw.default)(this, "submit", function() {
        _this.warningUnhooked();
        _this.validateFields().then(function(values) {
            var onFinish = _this.callbacks.onFinish;
            if (onFinish) try {
                onFinish(values);
            } catch (err) {
                // Should print error if user `onFinish` callback failed
                console.error(err);
            }
        }).catch(function(e) {
            var onFinishFailed = _this.callbacks.onFinishFailed;
            if (onFinishFailed) onFinishFailed(e);
        });
    });
    this.forceRootUpdate = forceRootUpdate;
});
function $a1708dc7c20669c0$var$useForm(form) {
    var formRef = $acw62.useRef();
    var _React$useState = $acw62.useState({}), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), forceUpdate = _React$useState2[1];
    if (!formRef.current) {
        if (form) formRef.current = form;
        else {
            // Create a new FormStore if not provided
            var forceReRender = function forceReRender() {
                forceUpdate({});
            };
            var formStore = new $a1708dc7c20669c0$export$75ff1ab1187e691(forceReRender);
            formRef.current = formStore.getForm();
        }
    }
    return [
        formRef.current
    ];
}
var $a1708dc7c20669c0$export$2e2bcd8739ae039 = $a1708dc7c20669c0$var$useForm;

});
parcelRegister("2yepO", function(module, exports) {

$parcel$export(module.exports, "allPromiseFinish", () => $1db9f053670497ce$export$6152adfdcc6be2b5);
function $1db9f053670497ce$export$6152adfdcc6be2b5(promiseList) {
    var hasError = false;
    var count = promiseList.length;
    var results = [];
    if (!promiseList.length) return Promise.resolve([]);
    return new Promise(function(resolve, reject) {
        promiseList.forEach(function(promise, index) {
            promise.catch(function(e) {
                hasError = true;
                return e;
            }).then(function(result) {
                count -= 1;
                results[index] = result;
                if (count > 0) return;
                if (hasError) reject(results);
                resolve(results);
            });
        });
    });
}

});

parcelRegister("g2KHW", function(module, exports) {

$parcel$export(module.exports, "default", () => $bae1107165a0db1c$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $kbxxf = parcelRequire("kbxxf");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $kSlfw = parcelRequire("kSlfw");

var $fSwVM = parcelRequire("fSwVM");
var $bae1107165a0db1c$var$SPLIT = "__@field_split__";
/**
 * Convert name path into string to fast the fetch speed of Map.
 */ function $bae1107165a0db1c$var$normalize(namePath) {
    return namePath.map(function(cell) {
        return "".concat((0, $fSwVM.default)(cell), ":").concat(cell);
    })// Magic split
    .join($bae1107165a0db1c$var$SPLIT);
}
/**
 * NameMap like a `Map` but accepts `string[]` as key.
 */ var $bae1107165a0db1c$var$NameMap = /*#__PURE__*/ function() {
    function NameMap() {
        (0, $6CZeq.default)(this, NameMap);
        (0, $kSlfw.default)(this, "kvs", new Map());
    }
    (0, $cHPF9.default)(NameMap, [
        {
            key: "set",
            value: function set(key, value) {
                this.kvs.set($bae1107165a0db1c$var$normalize(key), value);
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this.kvs.get($bae1107165a0db1c$var$normalize(key));
            }
        },
        {
            key: "update",
            value: function update(key, updater) {
                var origin = this.get(key);
                var next = updater(origin);
                if (!next) this.delete(key);
                else this.set(key, next);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                this.kvs.delete($bae1107165a0db1c$var$normalize(key));
            }
        },
        {
            key: "map",
            value: function map(callback) {
                return (0, $kbxxf.default)(this.kvs.entries()).map(function(_ref) {
                    var _ref2 = (0, $eUqlC.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
                    var cells = key.split($bae1107165a0db1c$var$SPLIT);
                    return callback({
                        key: cells.map(function(cell) {
                            var _cell$match = cell.match(/^([^:]*):(.*)$/), _cell$match2 = (0, $eUqlC.default)(_cell$match, 3), type = _cell$match2[1], unit = _cell$match2[2];
                            return type === "number" ? Number(unit) : unit;
                        }),
                        value: value
                    });
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var json = {};
                this.map(function(_ref3) {
                    var key = _ref3.key, value = _ref3.value;
                    json[key.join(".")] = value;
                    return null;
                });
                return json;
            }
        }
    ]);
    return NameMap;
}();
var $bae1107165a0db1c$export$2e2bcd8739ae039 = $bae1107165a0db1c$var$NameMap;

});


parcelRegister("akLVU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7860f41d917f18d2$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $dRl3b = parcelRequire("dRl3b");

var $260BS = parcelRequire("260BS");

var $144QO = parcelRequire("144QO");

var $kFGlN = parcelRequire("kFGlN");

var $livSf = parcelRequire("livSf");
var $7860f41d917f18d2$var$_excluded = [
    "name",
    "initialValues",
    "fields",
    "form",
    "preserve",
    "children",
    "component",
    "validateMessages",
    "validateTrigger",
    "onValuesChange",
    "onFieldsChange",
    "onFinish",
    "onFinishFailed"
];
var $7860f41d917f18d2$var$Form = function Form(_ref, ref) {
    var name = _ref.name, initialValues = _ref.initialValues, fields = _ref.fields, form = _ref.form, preserve = _ref.preserve, children = _ref.children, _ref$component = _ref.component, Component = _ref$component === void 0 ? "form" : _ref$component, validateMessages = _ref.validateMessages, _ref$validateTrigger = _ref.validateTrigger, validateTrigger = _ref$validateTrigger === void 0 ? "onChange" : _ref$validateTrigger, onValuesChange = _ref.onValuesChange, _onFieldsChange = _ref.onFieldsChange, _onFinish = _ref.onFinish, onFinishFailed = _ref.onFinishFailed, restProps = (0, $9X7IJ.default)(_ref, $7860f41d917f18d2$var$_excluded);
    var formContext = $acw62.useContext((0, $144QO.default));
    // We customize handle event since Context will makes all the consumer re-render:
    // https://reactjs.org/docs/context.html#contextprovider
    var _useForm = (0, $dRl3b.default)(form), _useForm2 = (0, $eUqlC.default)(_useForm, 1), formInstance = _useForm2[0];
    var _getInternalHooks = formInstance.getInternalHooks((0, $260BS.HOOK_MARK)), useSubscribe = _getInternalHooks.useSubscribe, setInitialValues = _getInternalHooks.setInitialValues, setCallbacks = _getInternalHooks.setCallbacks, setValidateMessages = _getInternalHooks.setValidateMessages, setPreserve = _getInternalHooks.setPreserve, destroyForm = _getInternalHooks.destroyForm;
    // Pass ref with form instance
    $acw62.useImperativeHandle(ref, function() {
        return formInstance;
    });
    // Register form into Context
    $acw62.useEffect(function() {
        formContext.registerForm(name, formInstance);
        return function() {
            formContext.unregisterForm(name);
        };
    }, [
        formContext,
        formInstance,
        name
    ]);
    // Pass props to store
    setValidateMessages((0, $d49SP.default)((0, $d49SP.default)({}, formContext.validateMessages), validateMessages));
    setCallbacks({
        onValuesChange: onValuesChange,
        onFieldsChange: function onFieldsChange(changedFields) {
            formContext.triggerFormChange(name, changedFields);
            if (_onFieldsChange) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
                _onFieldsChange.apply(void 0, [
                    changedFields
                ].concat(rest));
            }
        },
        onFinish: function onFinish(values) {
            formContext.triggerFormFinish(name, values);
            if (_onFinish) _onFinish(values);
        },
        onFinishFailed: onFinishFailed
    });
    setPreserve(preserve);
    // Set initial value, init store value when first mount
    var mountRef = $acw62.useRef(null);
    setInitialValues(initialValues, !mountRef.current);
    if (!mountRef.current) mountRef.current = true;
    $acw62.useEffect(function() {
        return destroyForm;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Prepare children by `children` type
    var childrenNode;
    var childrenRenderProps = typeof children === "function";
    if (childrenRenderProps) {
        var _values = formInstance.getFieldsValue(true);
        childrenNode = children(_values, formInstance);
    } else childrenNode = children;
    // Not use subscribe when using render props
    useSubscribe(!childrenRenderProps);
    // Listen if fields provided. We use ref to save prev data here to avoid additional render
    var prevFieldsRef = $acw62.useRef();
    $acw62.useEffect(function() {
        if (!(0, $kFGlN.isSimilar)(prevFieldsRef.current || [], fields || [])) formInstance.setFields(fields || []);
        prevFieldsRef.current = fields;
    }, [
        fields,
        formInstance
    ]);
    var formContextValue = $acw62.useMemo(function() {
        return (0, $d49SP.default)((0, $d49SP.default)({}, formInstance), {}, {
            validateTrigger: validateTrigger
        });
    }, [
        formInstance,
        validateTrigger
    ]);
    var wrapperNode = /*#__PURE__*/ $acw62.createElement((0, $livSf.default).Provider, {
        value: null
    }, /*#__PURE__*/ $acw62.createElement((0, $260BS.default).Provider, {
        value: formContextValue
    }, childrenNode));
    if (Component === false) return wrapperNode;
    return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({}, restProps, {
        onSubmit: function onSubmit(event) {
            event.preventDefault();
            event.stopPropagation();
            formInstance.submit();
        },
        onReset: function onReset(event) {
            var _restProps$onReset;
            event.preventDefault();
            formInstance.resetFields();
            (_restProps$onReset = restProps.onReset) === null || _restProps$onReset === void 0 || _restProps$onReset.call(restProps, event);
        }
    }), wrapperNode);
};
var $7860f41d917f18d2$export$2e2bcd8739ae039 = $7860f41d917f18d2$var$Form;

});
parcelRegister("144QO", function(module, exports) {

$parcel$export(module.exports, "FormProvider", () => $0c69ed761f95e1b0$export$8ce1ff4f94d08846);
$parcel$export(module.exports, "default", () => $0c69ed761f95e1b0$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
var $0c69ed761f95e1b0$var$FormContext = /*#__PURE__*/ $acw62.createContext({
    triggerFormChange: function triggerFormChange() {},
    triggerFormFinish: function triggerFormFinish() {},
    registerForm: function registerForm() {},
    unregisterForm: function unregisterForm() {}
});
var $0c69ed761f95e1b0$export$8ce1ff4f94d08846 = function FormProvider(_ref) {
    var validateMessages = _ref.validateMessages, onFormChange = _ref.onFormChange, onFormFinish = _ref.onFormFinish, children = _ref.children;
    var formContext = $acw62.useContext($0c69ed761f95e1b0$var$FormContext);
    var formsRef = $acw62.useRef({});
    return /*#__PURE__*/ $acw62.createElement($0c69ed761f95e1b0$var$FormContext.Provider, {
        value: (0, $d49SP.default)((0, $d49SP.default)({}, formContext), {}, {
            validateMessages: (0, $d49SP.default)((0, $d49SP.default)({}, formContext.validateMessages), validateMessages),
            // =========================================================
            // =                  Global Form Control                  =
            // =========================================================
            triggerFormChange: function triggerFormChange(name, changedFields) {
                if (onFormChange) onFormChange(name, {
                    changedFields: changedFields,
                    forms: formsRef.current
                });
                formContext.triggerFormChange(name, changedFields);
            },
            triggerFormFinish: function triggerFormFinish(name, values) {
                if (onFormFinish) onFormFinish(name, {
                    values: values,
                    forms: formsRef.current
                });
                formContext.triggerFormFinish(name, values);
            },
            registerForm: function registerForm(name, form) {
                if (name) formsRef.current = (0, $d49SP.default)((0, $d49SP.default)({}, formsRef.current), {}, (0, $kSlfw.default)({}, name, form));
                formContext.registerForm(name, form);
            },
            unregisterForm: function unregisterForm(name) {
                var newForms = (0, $d49SP.default)({}, formsRef.current);
                delete newForms[name];
                formsRef.current = newForms;
                formContext.unregisterForm(name);
            }
        })
    }, children);
};
var $0c69ed761f95e1b0$export$2e2bcd8739ae039 = $0c69ed761f95e1b0$var$FormContext;

});


parcelRegister("gPDhi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c40fe08ecbe59c71$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");
parcelRequire("u43uR");

var $acw62 = parcelRequire("acw62");

var $260BS = parcelRequire("260BS");

var $hhXFI = parcelRequire("hhXFI");

var $kFGlN = parcelRequire("kFGlN");
var $23Gye = parcelRequire("23Gye");
function $c40fe08ecbe59c71$export$fac44ee5b035f737(value) {
    try {
        return JSON.stringify(value);
    } catch (err) {
        return Math.random();
    }
}
var $c40fe08ecbe59c71$var$useWatchWarning = function() {};
// ------- selector type -------
// ------- selector type end -------
function $c40fe08ecbe59c71$var$useWatch() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var dependencies = args[0], _args$ = args[1], _form = _args$ === void 0 ? {} : _args$;
    var options = (0, $hhXFI.isFormInstance)(_form) ? {
        form: _form
    } : _form;
    var form = options.form;
    var _useState = (0, $acw62.useState)(), _useState2 = (0, $eUqlC.default)(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueStr = (0, $acw62.useMemo)(function() {
        return $c40fe08ecbe59c71$export$fac44ee5b035f737(value);
    }, [
        value
    ]);
    var valueStrRef = (0, $acw62.useRef)(valueStr);
    valueStrRef.current = valueStr;
    var fieldContext = (0, $acw62.useContext)((0, $260BS.default));
    var formInstance = form || fieldContext;
    var isValidForm = formInstance && formInstance._init;
    var namePath = (0, $kFGlN.getNamePath)(dependencies);
    var namePathRef = (0, $acw62.useRef)(namePath);
    namePathRef.current = namePath;
    $c40fe08ecbe59c71$var$useWatchWarning(namePath);
    (0, $acw62.useEffect)(function() {
        // Skip if not exist form instance
        if (!isValidForm) return;
        var getFieldsValue = formInstance.getFieldsValue, getInternalHooks = formInstance.getInternalHooks;
        var _getInternalHooks = getInternalHooks((0, $260BS.HOOK_MARK)), registerWatch = _getInternalHooks.registerWatch;
        var getWatchValue = function getWatchValue(values, allValues) {
            var watchValue = options.preserve ? allValues : values;
            return typeof dependencies === "function" ? dependencies(watchValue) : (0, $23Gye.default)(watchValue, namePathRef.current);
        };
        var cancelRegister = registerWatch(function(values, allValues) {
            var newValue = getWatchValue(values, allValues);
            var nextValueStr = $c40fe08ecbe59c71$export$fac44ee5b035f737(newValue);
            // Compare stringify in case it's nest object
            if (valueStrRef.current !== nextValueStr) {
                valueStrRef.current = nextValueStr;
                setValue(newValue);
            }
        });
        // TODO: We can improve this perf in future
        var initialValue = getWatchValue(getFieldsValue(), getFieldsValue(true));
        // React 18 has the bug that will queue update twice even the value is not changed
        // ref: https://github.com/facebook/react/issues/27213
        if (value !== initialValue) setValue(initialValue);
        return cancelRegister;
    }, // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isValidForm
    ]);
    return value;
}
var $c40fe08ecbe59c71$export$2e2bcd8739ae039 = $c40fe08ecbe59c71$var$useWatch;

});



parcelRegister("317P8", function(module, exports) {

$parcel$export(module.exports, "default", () => $232788b5c0fca573$export$2e2bcd8739ae039);
parcelRequire("3i86m");
var $lpQ06 = parcelRequire("lpQ06");

var $670jt = parcelRequire("670jt");

var $1g5Jl = parcelRequire("1g5Jl");

var $P8Drj = parcelRequire("P8Drj");
var $2LRCS = parcelRequire("2LRCS");
const $232788b5c0fca573$export$92095d0f4c77bd56 = (color)=>({
        // Firefox
        "&::-moz-placeholder": {
            opacity: 1
        },
        "&::placeholder": {
            color: color,
            userSelect: "none" // https://github.com/ant-design/ant-design/pull/32639
        },
        "&:placeholder-shown": {
            textOverflow: "ellipsis"
        }
    });
const $232788b5c0fca573$export$bf820fba296f2fd8 = (token)=>({
        borderColor: token.hoverBorderColor,
        backgroundColor: token.hoverBg
    });
const $232788b5c0fca573$export$3fe86db3643510f9 = (token)=>({
        borderColor: token.activeBorderColor,
        boxShadow: token.activeShadow,
        outline: 0,
        backgroundColor: token.activeBg
    });
const $232788b5c0fca573$export$12789f962d420a93 = (token)=>({
        color: token.colorTextDisabled,
        backgroundColor: token.colorBgContainerDisabled,
        borderColor: token.colorBorder,
        boxShadow: "none",
        cursor: "not-allowed",
        opacity: 1,
        "&:hover:not([disabled])": Object.assign({}, $232788b5c0fca573$export$bf820fba296f2fd8((0, $2LRCS.merge)(token, {
            hoverBorderColor: token.colorBorder,
            hoverBg: token.colorBgContainerDisabled
        })))
    });
const $232788b5c0fca573$var$genInputLargeStyle = (token)=>{
    const { paddingBlockLG: paddingBlockLG, fontSizeLG: fontSizeLG, lineHeightLG: lineHeightLG, borderRadiusLG: borderRadiusLG, paddingInlineLG: paddingInlineLG } = token;
    return {
        padding: `${(0, $lpQ06.unit)(paddingBlockLG)} ${(0, $lpQ06.unit)(paddingInlineLG)}`,
        fontSize: fontSizeLG,
        lineHeight: lineHeightLG,
        borderRadius: borderRadiusLG
    };
};
const $232788b5c0fca573$export$bb047f62c5a56f90 = (token)=>({
        padding: `${(0, $lpQ06.unit)(token.paddingBlockSM)} ${(0, $lpQ06.unit)(token.paddingInlineSM)}`,
        borderRadius: token.borderRadiusSM
    });
const $232788b5c0fca573$export$cf983a15949ad61e = (token, parentCls)=>{
    const { componentCls: componentCls, colorError: colorError, colorWarning: colorWarning, errorActiveShadow: errorActiveShadow, warningActiveShadow: warningActiveShadow, colorErrorBorderHover: colorErrorBorderHover, colorWarningBorderHover: colorWarningBorderHover } = token;
    return {
        [`&-status-error:not(${parentCls}-disabled):not(${parentCls}-borderless)${parentCls}`]: {
            borderColor: colorError,
            "&:hover": {
                borderColor: colorErrorBorderHover
            },
            "&:focus, &:focus-within": Object.assign({}, $232788b5c0fca573$export$3fe86db3643510f9((0, $2LRCS.merge)(token, {
                activeBorderColor: colorError,
                activeShadow: errorActiveShadow
            }))),
            [`${componentCls}-prefix, ${componentCls}-suffix`]: {
                color: colorError
            }
        },
        [`&-status-warning:not(${parentCls}-disabled):not(${parentCls}-borderless)${parentCls}`]: {
            borderColor: colorWarning,
            "&:hover": {
                borderColor: colorWarningBorderHover
            },
            "&:focus, &:focus-within": Object.assign({}, $232788b5c0fca573$export$3fe86db3643510f9((0, $2LRCS.merge)(token, {
                activeBorderColor: colorWarning,
                activeShadow: warningActiveShadow
            }))),
            [`${componentCls}-prefix, ${componentCls}-suffix`]: {
                color: colorWarning
            }
        }
    };
};
const $232788b5c0fca573$export$8c9a381315f3ebcd = (token)=>Object.assign(Object.assign({
        position: "relative",
        display: "inline-block",
        width: "100%",
        minWidth: 0,
        padding: `${(0, $lpQ06.unit)(token.paddingBlock)} ${(0, $lpQ06.unit)(token.paddingInline)}`,
        color: token.colorText,
        fontSize: token.fontSize,
        lineHeight: token.lineHeight,
        backgroundColor: token.colorBgContainer,
        backgroundImage: "none",
        borderWidth: token.lineWidth,
        borderStyle: token.lineType,
        borderColor: token.colorBorder,
        borderRadius: token.borderRadius,
        transition: `all ${token.motionDurationMid}`
    }, $232788b5c0fca573$export$92095d0f4c77bd56(token.colorTextPlaceholder)), {
        "&:hover": Object.assign({}, $232788b5c0fca573$export$bf820fba296f2fd8(token)),
        "&:focus, &:focus-within": Object.assign({}, $232788b5c0fca573$export$3fe86db3643510f9(token)),
        "&-disabled, &[disabled]": Object.assign({}, $232788b5c0fca573$export$12789f962d420a93(token)),
        "&-borderless": {
            "&, &:hover, &:focus, &-focused, &-disabled, &[disabled]": {
                backgroundColor: "transparent",
                border: "none",
                boxShadow: "none"
            }
        },
        // Reset height for `textarea`s
        "textarea&": {
            maxWidth: "100%",
            // prevent textarea resize from coming out of its container
            height: "auto",
            minHeight: token.controlHeight,
            lineHeight: token.lineHeight,
            verticalAlign: "bottom",
            transition: `all ${token.motionDurationSlow}, height 0s`,
            resize: "vertical"
        },
        // Size
        "&-lg": Object.assign({}, $232788b5c0fca573$var$genInputLargeStyle(token)),
        "&-sm": Object.assign({}, $232788b5c0fca573$export$bb047f62c5a56f90(token)),
        // RTL
        "&-rtl": {
            direction: "rtl"
        },
        "&-textarea-rtl": {
            direction: "rtl"
        }
    });
const $232788b5c0fca573$export$ffe8b2a9bd2e5cfe = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        position: "relative",
        display: "table",
        width: "100%",
        borderCollapse: "separate",
        borderSpacing: 0,
        // Undo padding and float of grid classes
        [`&[class*='col-']`]: {
            paddingInlineEnd: token.paddingXS,
            "&:last-child": {
                paddingInlineEnd: 0
            }
        },
        // Sizing options
        [`&-lg ${componentCls}, &-lg > ${componentCls}-group-addon`]: Object.assign({}, $232788b5c0fca573$var$genInputLargeStyle(token)),
        [`&-sm ${componentCls}, &-sm > ${componentCls}-group-addon`]: Object.assign({}, $232788b5c0fca573$export$bb047f62c5a56f90(token)),
        // Fix https://github.com/ant-design/ant-design/issues/5754
        [`&-lg ${antCls}-select-single ${antCls}-select-selector`]: {
            height: token.controlHeightLG
        },
        [`&-sm ${antCls}-select-single ${antCls}-select-selector`]: {
            height: token.controlHeightSM
        },
        [`> ${componentCls}`]: {
            display: "table-cell",
            "&:not(:first-child):not(:last-child)": {
                borderRadius: 0
            }
        },
        [`${componentCls}-group`]: {
            [`&-addon, &-wrap`]: {
                display: "table-cell",
                width: 1,
                whiteSpace: "nowrap",
                verticalAlign: "middle",
                "&:not(:first-child):not(:last-child)": {
                    borderRadius: 0
                }
            },
            "&-wrap > *": {
                display: "block !important"
            },
            "&-addon": {
                position: "relative",
                padding: `0 ${(0, $lpQ06.unit)(token.paddingInline)}`,
                color: token.colorText,
                fontWeight: "normal",
                fontSize: token.fontSize,
                textAlign: "center",
                backgroundColor: token.addonBg,
                border: `${(0, $lpQ06.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                borderRadius: token.borderRadius,
                transition: `all ${token.motionDurationSlow}`,
                lineHeight: 1,
                // Reset Select's style in addon
                [`${antCls}-select`]: {
                    margin: `${(0, $lpQ06.unit)(token.calc(token.paddingBlock).add(1).mul(-1).equal())} ${(0, $lpQ06.unit)(token.calc(token.paddingInline).mul(-1).equal())}`,
                    [`&${antCls}-select-single:not(${antCls}-select-customize-input):not(${antCls}-pagination-size-changer)`]: {
                        [`${antCls}-select-selector`]: {
                            backgroundColor: "inherit",
                            border: `${(0, $lpQ06.unit)(token.lineWidth)} ${token.lineType} transparent`,
                            boxShadow: "none"
                        }
                    },
                    "&-open, &-focused": {
                        [`${antCls}-select-selector`]: {
                            color: token.colorPrimary
                        }
                    }
                },
                // https://github.com/ant-design/ant-design/issues/31333
                [`${antCls}-cascader-picker`]: {
                    margin: `-9px ${(0, $lpQ06.unit)(token.calc(token.paddingInline).mul(-1).equal())}`,
                    backgroundColor: "transparent",
                    [`${antCls}-cascader-input`]: {
                        textAlign: "start",
                        border: 0,
                        boxShadow: "none"
                    }
                }
            },
            "&-addon:first-child": {
                borderInlineEnd: 0
            },
            "&-addon:last-child": {
                borderInlineStart: 0
            }
        },
        [`${componentCls}`]: {
            width: "100%",
            marginBottom: 0,
            textAlign: "inherit",
            "&:focus": {
                zIndex: 1,
                // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
                borderInlineEndWidth: 1
            },
            "&:hover": {
                zIndex: 1,
                borderInlineEndWidth: 1,
                [`${componentCls}-search-with-button &`]: {
                    zIndex: 0
                }
            }
        },
        // Reset rounded corners
        [`> ${componentCls}:first-child, ${componentCls}-group-addon:first-child`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            // Reset Select's style in addon
            [`${antCls}-select ${antCls}-select-selector`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`> ${componentCls}-affix-wrapper`]: {
            [`&:not(:first-child) ${componentCls}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            },
            [`&:not(:last-child) ${componentCls}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`> ${componentCls}:last-child, ${componentCls}-group-addon:last-child`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            // Reset Select's style in addon
            [`${antCls}-select ${antCls}-select-selector`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`${componentCls}-affix-wrapper`]: {
            "&:not(:last-child)": {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0,
                [`${componentCls}-search &`]: {
                    borderStartStartRadius: token.borderRadius,
                    borderEndStartRadius: token.borderRadius
                }
            },
            [`&:not(:first-child), ${componentCls}-search &:not(:first-child)`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`&${componentCls}-group-compact`]: Object.assign(Object.assign({
            display: "block"
        }, (0, $670jt.clearFix)()), {
            [`${componentCls}-group-addon, ${componentCls}-group-wrap, > ${componentCls}`]: {
                "&:not(:first-child):not(:last-child)": {
                    borderInlineEndWidth: token.lineWidth,
                    "&:hover": {
                        zIndex: 1
                    },
                    "&:focus": {
                        zIndex: 1
                    }
                }
            },
            "& > *": {
                display: "inline-block",
                float: "none",
                verticalAlign: "top",
                // https://github.com/ant-design/ant-design-pro/issues/139
                borderRadius: 0
            },
            [`
        & > ${componentCls}-affix-wrapper,
        & > ${componentCls}-number-affix-wrapper,
        & > ${antCls}-picker-range
      `]: {
                display: "inline-flex"
            },
            "& > *:not(:last-child)": {
                marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal(),
                borderInlineEndWidth: token.lineWidth
            },
            // Undo float for .ant-input-group .ant-input
            [`${componentCls}`]: {
                float: "none"
            },
            // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
            [`& > ${antCls}-select > ${antCls}-select-selector,
      & > ${antCls}-select-auto-complete ${componentCls},
      & > ${antCls}-cascader-picker ${componentCls},
      & > ${componentCls}-group-wrapper ${componentCls}`]: {
                borderInlineEndWidth: token.lineWidth,
                borderRadius: 0,
                "&:hover": {
                    zIndex: 1
                },
                "&:focus": {
                    zIndex: 1
                }
            },
            [`& > ${antCls}-select-focused`]: {
                zIndex: 1
            },
            // update z-index for arrow icon
            [`& > ${antCls}-select > ${antCls}-select-arrow`]: {
                zIndex: 1 // https://github.com/ant-design/ant-design/issues/20371
            },
            [`& > *:first-child,
      & > ${antCls}-select:first-child > ${antCls}-select-selector,
      & > ${antCls}-select-auto-complete:first-child ${componentCls},
      & > ${antCls}-cascader-picker:first-child ${componentCls}`]: {
                borderStartStartRadius: token.borderRadius,
                borderEndStartRadius: token.borderRadius
            },
            [`& > *:last-child,
      & > ${antCls}-select:last-child > ${antCls}-select-selector,
      & > ${antCls}-cascader-picker:last-child ${componentCls},
      & > ${antCls}-cascader-picker-focused:last-child ${componentCls}`]: {
                borderInlineEndWidth: token.lineWidth,
                borderStartEndRadius: token.borderRadius,
                borderEndEndRadius: token.borderRadius
            },
            // https://github.com/ant-design/ant-design/issues/12493
            [`& > ${antCls}-select-auto-complete ${componentCls}`]: {
                verticalAlign: "top"
            },
            [`${componentCls}-group-wrapper + ${componentCls}-group-wrapper`]: {
                marginInlineStart: token.calc(token.lineWidth).mul(-1).equal(),
                [`${componentCls}-affix-wrapper`]: {
                    borderRadius: 0
                }
            },
            [`${componentCls}-group-wrapper:not(:last-child)`]: {
                [`&${componentCls}-search > ${componentCls}-group`]: {
                    [`& > ${componentCls}-group-addon > ${componentCls}-search-button`]: {
                        borderRadius: 0
                    },
                    [`& > ${componentCls}`]: {
                        borderStartStartRadius: token.borderRadius,
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0,
                        borderEndStartRadius: token.borderRadius
                    }
                }
            }
        })
    };
};
const $232788b5c0fca573$var$genInputStyle = (token)=>{
    const { componentCls: componentCls, controlHeightSM: controlHeightSM, lineWidth: lineWidth, calc: calc } = token;
    const FIXED_CHROME_COLOR_HEIGHT = 16;
    const colorSmallPadding = calc(controlHeightSM).sub(calc(lineWidth).mul(2)).sub(FIXED_CHROME_COLOR_HEIGHT).div(2).equal();
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $670jt.resetComponent)(token)), $232788b5c0fca573$export$8c9a381315f3ebcd(token)), $232788b5c0fca573$export$cf983a15949ad61e(token, componentCls)), {
            '&[type="color"]': {
                height: token.controlHeight,
                [`&${componentCls}-lg`]: {
                    height: token.controlHeightLG
                },
                [`&${componentCls}-sm`]: {
                    height: controlHeightSM,
                    paddingTop: colorSmallPadding,
                    paddingBottom: colorSmallPadding
                }
            },
            '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
                "-webkit-appearance": "none"
            }
        })
    };
};
const $232788b5c0fca573$var$genAllowClearStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // ========================= Input =========================
        [`${componentCls}-clear-icon`]: {
            margin: 0,
            color: token.colorTextQuaternary,
            fontSize: token.fontSizeIcon,
            verticalAlign: -1,
            // https://github.com/ant-design/ant-design/pull/18151
            // https://codesandbox.io/s/wizardly-sun-u10br
            cursor: "pointer",
            transition: `color ${token.motionDurationSlow}`,
            "&:hover": {
                color: token.colorTextTertiary
            },
            "&:active": {
                color: token.colorText
            },
            "&-hidden": {
                visibility: "hidden"
            },
            "&-has-suffix": {
                margin: `0 ${(0, $lpQ06.unit)(token.inputAffixPadding)}`
            }
        }
    };
};
const $232788b5c0fca573$var$genAffixStyle = (token)=>{
    const { componentCls: componentCls, inputAffixPadding: inputAffixPadding, colorTextDescription: colorTextDescription, motionDurationSlow: motionDurationSlow, colorIcon: colorIcon, colorIconHover: colorIconHover, iconCls: iconCls } = token;
    return {
        [`${componentCls}-affix-wrapper`]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, $232788b5c0fca573$export$8c9a381315f3ebcd(token)), {
            display: "inline-flex",
            [`&:not(${componentCls}-affix-wrapper-disabled):hover`]: {
                zIndex: 1,
                [`${componentCls}-search-with-button &`]: {
                    zIndex: 0
                }
            },
            "&-focused, &:focus": {
                zIndex: 1
            },
            "&-disabled": {
                [`${componentCls}[disabled]`]: {
                    background: "transparent"
                }
            },
            [`> input${componentCls}`]: {
                padding: 0,
                fontSize: "inherit",
                border: "none",
                borderRadius: 0,
                outline: "none",
                "&::-ms-reveal": {
                    display: "none"
                },
                "&:focus": {
                    boxShadow: "none !important"
                }
            },
            "&::before": {
                display: "inline-block",
                width: 0,
                visibility: "hidden",
                content: '"\\a0"'
            },
            [`${componentCls}`]: {
                "&-prefix, &-suffix": {
                    display: "flex",
                    flex: "none",
                    alignItems: "center",
                    "> *:not(:last-child)": {
                        marginInlineEnd: token.paddingXS
                    }
                },
                "&-show-count-suffix": {
                    color: colorTextDescription
                },
                "&-show-count-has-suffix": {
                    marginInlineEnd: token.paddingXXS
                },
                "&-prefix": {
                    marginInlineEnd: inputAffixPadding
                },
                "&-suffix": {
                    marginInlineStart: inputAffixPadding
                }
            }
        }), $232788b5c0fca573$var$genAllowClearStyle(token)), {
            // password
            [`${iconCls}${componentCls}-password-icon`]: {
                color: colorIcon,
                cursor: "pointer",
                transition: `all ${motionDurationSlow}`,
                "&:hover": {
                    color: colorIconHover
                }
            }
        }), $232788b5c0fca573$export$cf983a15949ad61e(token, `${componentCls}-affix-wrapper`))
    };
};
const $232788b5c0fca573$var$genGroupStyle = (token)=>{
    const { componentCls: componentCls, colorError: colorError, colorWarning: colorWarning, borderRadiusLG: borderRadiusLG, borderRadiusSM: borderRadiusSM } = token;
    return {
        [`${componentCls}-group`]: Object.assign(Object.assign(Object.assign({}, (0, $670jt.resetComponent)(token)), $232788b5c0fca573$export$ffe8b2a9bd2e5cfe(token)), {
            "&-rtl": {
                direction: "rtl"
            },
            "&-wrapper": {
                display: "inline-block",
                width: "100%",
                textAlign: "start",
                verticalAlign: "top",
                // https://github.com/ant-design/ant-design/issues/6403
                "&-rtl": {
                    direction: "rtl"
                },
                // Size
                "&-lg": {
                    [`${componentCls}-group-addon`]: {
                        borderRadius: borderRadiusLG,
                        fontSize: token.fontSizeLG
                    }
                },
                "&-sm": {
                    [`${componentCls}-group-addon`]: {
                        borderRadius: borderRadiusSM
                    }
                },
                // Status
                "&-status-error": {
                    [`${componentCls}-group-addon`]: {
                        color: colorError,
                        borderColor: colorError
                    }
                },
                "&-status-warning": {
                    [`${componentCls}-group-addon`]: {
                        color: colorWarning,
                        borderColor: colorWarning
                    }
                },
                "&-disabled": {
                    [`${componentCls}-group-addon`]: Object.assign({}, $232788b5c0fca573$export$12789f962d420a93(token))
                },
                // Fix the issue of using icons in Space Compact mode
                // https://github.com/ant-design/ant-design/issues/42122
                [`&:not(${componentCls}-compact-first-item):not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderRadius: 0
                    }
                },
                [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-first-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0
                    }
                },
                [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-last-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0
                    }
                }
            }
        })
    };
};
const $232788b5c0fca573$var$genSearchInputStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const searchPrefixCls = `${componentCls}-search`;
    return {
        [searchPrefixCls]: {
            [`${componentCls}`]: {
                "&:hover, &:focus": {
                    borderColor: token.colorPrimaryHover,
                    [`+ ${componentCls}-group-addon ${searchPrefixCls}-button:not(${antCls}-btn-primary)`]: {
                        borderInlineStartColor: token.colorPrimaryHover
                    }
                }
            },
            [`${componentCls}-affix-wrapper`]: {
                borderRadius: 0
            },
            // fix slight height diff in Firefox:
            // https://ant.design/components/auto-complete-cn/#components-auto-complete-demo-certain-category
            [`${componentCls}-lg`]: {
                lineHeight: token.calc(token.lineHeightLG).sub(0.0002).equal({
                    unit: false
                })
            },
            [`> ${componentCls}-group`]: {
                [`> ${componentCls}-group-addon:last-child`]: {
                    insetInlineStart: -1,
                    padding: 0,
                    border: 0,
                    [`${searchPrefixCls}-button`]: {
                        paddingTop: 0,
                        paddingBottom: 0,
                        borderStartStartRadius: 0,
                        borderStartEndRadius: token.borderRadius,
                        borderEndEndRadius: token.borderRadius,
                        borderEndStartRadius: 0,
                        boxShadow: "none"
                    },
                    [`${searchPrefixCls}-button:not(${antCls}-btn-primary)`]: {
                        color: token.colorTextDescription,
                        "&:hover": {
                            color: token.colorPrimaryHover
                        },
                        "&:active": {
                            color: token.colorPrimaryActive
                        },
                        [`&${antCls}-btn-loading::before`]: {
                            insetInlineStart: 0,
                            insetInlineEnd: 0,
                            insetBlockStart: 0,
                            insetBlockEnd: 0
                        }
                    }
                }
            },
            [`${searchPrefixCls}-button`]: {
                height: token.controlHeight,
                "&:hover, &:focus": {
                    zIndex: 1
                }
            },
            [`&-large ${searchPrefixCls}-button`]: {
                height: token.controlHeightLG
            },
            [`&-small ${searchPrefixCls}-button`]: {
                height: token.controlHeightSM
            },
            "&-rtl": {
                direction: "rtl"
            },
            // ===================== Compact Item Customized Styles =====================
            [`&${componentCls}-compact-item`]: {
                [`&:not(${componentCls}-compact-last-item)`]: {
                    [`${componentCls}-group-addon`]: {
                        [`${componentCls}-search-button`]: {
                            marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal(),
                            borderRadius: 0
                        }
                    }
                },
                [`&:not(${componentCls}-compact-first-item)`]: {
                    [`${componentCls},${componentCls}-affix-wrapper`]: {
                        borderRadius: 0
                    }
                },
                [`> ${componentCls}-group-addon ${componentCls}-search-button,
        > ${componentCls},
        ${componentCls}-affix-wrapper`]: {
                    "&:hover,&:focus,&:active": {
                        zIndex: 2
                    }
                },
                [`> ${componentCls}-affix-wrapper-focused`]: {
                    zIndex: 2
                }
            }
        }
    };
};
const $232788b5c0fca573$var$genTextAreaStyle = (token)=>{
    const { componentCls: componentCls, paddingLG: paddingLG } = token;
    const textareaPrefixCls = `${componentCls}-textarea`;
    return {
        [textareaPrefixCls]: {
            position: "relative",
            "&-show-count": {
                // https://github.com/ant-design/ant-design/issues/33049
                [`> ${componentCls}`]: {
                    height: "100%"
                },
                [`${componentCls}-data-count`]: {
                    position: "absolute",
                    bottom: token.calc(token.fontSize).mul(token.lineHeight).mul(-1).equal(),
                    insetInlineEnd: 0,
                    color: token.colorTextDescription,
                    whiteSpace: "nowrap",
                    pointerEvents: "none"
                }
            },
            "&-allow-clear": {
                [`> ${componentCls}`]: {
                    paddingInlineEnd: paddingLG
                }
            },
            [`&-affix-wrapper${textareaPrefixCls}-has-feedback`]: {
                [`${componentCls}`]: {
                    paddingInlineEnd: paddingLG
                }
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper`]: {
                padding: 0,
                [`> textarea${componentCls}`]: {
                    fontSize: "inherit",
                    border: "none",
                    outline: "none",
                    "&:focus": {
                        boxShadow: "none !important"
                    }
                },
                [`${componentCls}-suffix`]: {
                    margin: 0,
                    "> *:not(:last-child)": {
                        marginInline: 0
                    },
                    // Clear Icon
                    [`${componentCls}-clear-icon`]: {
                        position: "absolute",
                        insetInlineEnd: token.paddingXS,
                        insetBlockStart: token.paddingXS
                    },
                    // Feedback Icon
                    [`${textareaPrefixCls}-suffix`]: {
                        position: "absolute",
                        top: 0,
                        insetInlineEnd: token.paddingInline,
                        bottom: 0,
                        zIndex: 1,
                        display: "inline-flex",
                        alignItems: "center",
                        margin: "auto",
                        pointerEvents: "none"
                    }
                }
            }
        }
    };
};
// ============================== Range ===============================
const $232788b5c0fca573$var$genRangeStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-out-of-range`]: {
            [`&, & input, & textarea, ${componentCls}-show-count-suffix, ${componentCls}-data-count`]: {
                color: token.colorError
            }
        }
    };
};
function $232788b5c0fca573$export$a157d95850191a12(token) {
    return (0, $2LRCS.merge)(token, {
        inputAffixPadding: token.paddingXXS
    });
}
const $232788b5c0fca573$export$bd8b682992bc9781 = (token)=>{
    const { controlHeight: controlHeight, fontSize: fontSize, lineHeight: lineHeight, lineWidth: lineWidth, controlHeightSM: controlHeightSM, controlHeightLG: controlHeightLG, fontSizeLG: fontSizeLG, lineHeightLG: lineHeightLG, paddingSM: paddingSM, controlPaddingHorizontalSM: controlPaddingHorizontalSM, controlPaddingHorizontal: controlPaddingHorizontal, colorFillAlter: colorFillAlter, colorPrimaryHover: colorPrimaryHover, colorPrimary: colorPrimary, controlOutlineWidth: controlOutlineWidth, controlOutline: controlOutline, colorErrorOutline: colorErrorOutline, colorWarningOutline: colorWarningOutline } = token;
    return {
        paddingBlock: Math.max(Math.round((controlHeight - fontSize * lineHeight) / 2 * 10) / 10 - lineWidth, 0),
        paddingBlockSM: Math.max(Math.round((controlHeightSM - fontSize * lineHeight) / 2 * 10) / 10 - lineWidth, 0),
        paddingBlockLG: Math.ceil((controlHeightLG - fontSizeLG * lineHeightLG) / 2 * 10) / 10 - lineWidth,
        paddingInline: paddingSM - lineWidth,
        paddingInlineSM: controlPaddingHorizontalSM - lineWidth,
        paddingInlineLG: controlPaddingHorizontal - lineWidth,
        addonBg: colorFillAlter,
        activeBorderColor: colorPrimary,
        hoverBorderColor: colorPrimaryHover,
        activeShadow: `0 0 0 ${controlOutlineWidth}px ${controlOutline}`,
        errorActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorErrorOutline}`,
        warningActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorWarningOutline}`,
        hoverBg: "",
        activeBg: ""
    };
};
var // ============================== Export ==============================
$232788b5c0fca573$export$2e2bcd8739ae039 = (0, $P8Drj.genStyleHooks)("Input", (token)=>{
    const inputToken = (0, $2LRCS.merge)(token, $232788b5c0fca573$export$a157d95850191a12(token));
    return [
        $232788b5c0fca573$var$genInputStyle(inputToken),
        $232788b5c0fca573$var$genTextAreaStyle(inputToken),
        $232788b5c0fca573$var$genAffixStyle(inputToken),
        $232788b5c0fca573$var$genGroupStyle(inputToken),
        $232788b5c0fca573$var$genSearchInputStyle(inputToken),
        $232788b5c0fca573$var$genRangeStyle(inputToken),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $1g5Jl.genCompactItemStyle)(inputToken)
    ];
}, $232788b5c0fca573$export$bd8b682992bc9781);

});


parcelRegister("7aL1y", function(module, exports) {

$parcel$export(module.exports, "triggerFocus", () => $538df197b854e6d1$export$2b92016deb0b7aad);
$parcel$export(module.exports, "default", () => $538df197b854e6d1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $b9YHa = parcelRequire("b9YHa");

var $8g1PZ = parcelRequire("8g1PZ");

var $cGjF0 = parcelRequire("cGjF0");

var $85dLH = parcelRequire("85dLH");

var $8Vr1S = parcelRequire("8Vr1S");

parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $9f1hj = parcelRequire("9f1hj");

var $IFe7R = parcelRequire("IFe7R");

var $eSOz6 = parcelRequire("eSOz6");

var $3gns8 = parcelRequire("3gns8");

var $jApbz = parcelRequire("jApbz");

var $317P8 = parcelRequire("317P8");

var $30J1N = parcelRequire("30J1N");

var $dnT3A = parcelRequire("dnT3A");
"use client";
var $538df197b854e6d1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $538df197b854e6d1$export$2b92016deb0b7aad(element, option) {
    if (!element) return;
    element.focus(option);
    // Selection content
    const { cursor: cursor } = option || {};
    if (cursor) {
        const len = element.value.length;
        switch(cursor){
            case "start":
                element.setSelectionRange(0, 0);
                break;
            case "end":
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
                break;
        }
    }
}
const $538df197b854e6d1$var$Input = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var _a;
    const { prefixCls: customizePrefixCls, bordered: bordered = true, status: customStatus, size: customSize, disabled: customDisabled, onBlur: onBlur, onFocus: onFocus, suffix: suffix, allowClear: allowClear, addonAfter: addonAfter, addonBefore: addonBefore, className: className, style: style, styles: styles, rootClassName: rootClassName, onChange: onChange, classNames: classes } = props, rest = $538df197b854e6d1$var$__rest(props, [
        "prefixCls",
        "bordered",
        "status",
        "size",
        "disabled",
        "onBlur",
        "onFocus",
        "suffix",
        "allowClear",
        "addonAfter",
        "addonBefore",
        "className",
        "style",
        "styles",
        "rootClassName",
        "onChange",
        "classNames"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, input: input } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $dRTnM.ConfigContext));
    const prefixCls = getPrefixCls("input", customizePrefixCls);
    const inputRef = (0, $acw62.useRef)(null);
    // Style
    const cssVarCls = (0, $dnT3A.default)(prefixCls);
    const [wrapCSSVar, hashId] = (0, $317P8.default)(prefixCls, cssVarCls);
    // ===================== Compact Item =====================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $3gns8.useCompactItemContext)(prefixCls, direction);
    // ===================== Size =====================
    const mergedSize = (0, $IFe7R.default)((ctx)=>{
        var _a;
        return (_a = customSize !== null && customSize !== void 0 ? customSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
    });
    // ===================== Disabled =====================
    const disabled = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $9f1hj.default));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    // ===================== Status =====================
    const { status: contextStatus, hasFeedback: hasFeedback, feedbackIcon: feedbackIcon } = (0, $acw62.useContext)((0, $eSOz6.FormItemInputContext));
    const mergedStatus = (0, $8Vr1S.getMergedStatus)(contextStatus, customStatus);
    // ===================== Focus warning =====================
    const inputHasPrefixSuffix = (0, $30J1N.hasPrefixSuffix)(props) || !!hasFeedback;
    const prevHasPrefixSuffix = (0, $acw62.useRef)(inputHasPrefixSuffix);
    var _a1;
    /* eslint-enable */ // ===================== Remove Password value =====================
    const removePasswordTimeout = (0, $jApbz.default)(inputRef, true);
    const handleBlur = (e)=>{
        removePasswordTimeout();
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    const handleFocus = (e)=>{
        removePasswordTimeout();
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    const handleChange = (e)=>{
        removePasswordTimeout();
        onChange === null || onChange === void 0 || onChange(e);
    };
    const suffixNode = (hasFeedback || suffix) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, suffix, hasFeedback && feedbackIcon);
    // Allow clear
    let mergedAllowClear;
    if (typeof allowClear === "object" && (allowClear === null || allowClear === void 0 ? void 0 : allowClear.clearIcon)) mergedAllowClear = allowClear;
    else if (allowClear) mergedAllowClear = {
        clearIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9YHa.default), null)
    };
    return wrapCSSVar(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cGjF0.default), Object.assign({
        ref: (0, $85dLH.composeRef)(ref, inputRef),
        prefixCls: prefixCls,
        autoComplete: input === null || input === void 0 ? void 0 : input.autoComplete
    }, rest, {
        disabled: mergedDisabled,
        onBlur: handleBlur,
        onFocus: handleFocus,
        style: Object.assign(Object.assign({}, input === null || input === void 0 ? void 0 : input.style), style),
        styles: Object.assign(Object.assign({}, input === null || input === void 0 ? void 0 : input.styles), styles),
        suffix: suffixNode,
        allowClear: mergedAllowClear,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, rootClassName, cssVarCls, hashId, compactItemClassnames, input === null || input === void 0 ? void 0 : input.className),
        onChange: handleChange,
        addonAfter: addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3gns8.NoCompactStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eSOz6.NoFormStyle), {
            override: true,
            status: true
        }, addonAfter)),
        addonBefore: addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3gns8.NoCompactStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eSOz6.NoFormStyle), {
            override: true,
            status: true
        }, addonBefore)),
        classNames: Object.assign(Object.assign(Object.assign({}, classes), input === null || input === void 0 ? void 0 : input.classNames), {
            input: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                [`${prefixCls}-sm`]: mergedSize === "small",
                [`${prefixCls}-lg`]: mergedSize === "large",
                [`${prefixCls}-rtl`]: direction === "rtl",
                [`${prefixCls}-borderless`]: !bordered
            }, !inputHasPrefixSuffix && (0, $8Vr1S.getStatusClassNames)(prefixCls, mergedStatus), classes === null || classes === void 0 ? void 0 : classes.input, (_a = input === null || input === void 0 ? void 0 : input.classNames) === null || _a === void 0 ? void 0 : _a.input, hashId)
        }),
        classes: {
            affixWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === "small",
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === "large",
                [`${prefixCls}-affix-wrapper-rtl`]: direction === "rtl",
                [`${prefixCls}-affix-wrapper-borderless`]: !bordered
            }, (0, $8Vr1S.getStatusClassNames)(`${prefixCls}-affix-wrapper`, mergedStatus, hasFeedback), hashId),
            wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                [`${prefixCls}-group-rtl`]: direction === "rtl"
            }, hashId),
            group: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                [`${prefixCls}-group-wrapper-sm`]: mergedSize === "small",
                [`${prefixCls}-group-wrapper-lg`]: mergedSize === "large",
                [`${prefixCls}-group-wrapper-rtl`]: direction === "rtl",
                [`${prefixCls}-group-wrapper-disabled`]: mergedDisabled
            }, (0, $8Vr1S.getStatusClassNames)(`${prefixCls}-group-wrapper`, mergedStatus, hasFeedback), hashId)
        }
    })));
});
var $538df197b854e6d1$export$2e2bcd8739ae039 = $538df197b854e6d1$var$Input;

});
parcelRegister("b9YHa", function(module, exports) {

$parcel$export(module.exports, "default", () => $81ff9dc68eb84eda$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $12Y80 = parcelRequire("12Y80");

var $adRcI = parcelRequire("adRcI");
var $81ff9dc68eb84eda$var$CloseCircleFilled = function CloseCircleFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $adRcI.default), (0, $8nd05.default)({}, props, {
        ref: ref,
        icon: (0, $12Y80.default)
    }));
};
var $81ff9dc68eb84eda$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($81ff9dc68eb84eda$var$CloseCircleFilled);

});
parcelRegister("12Y80", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c349e8b6d22460f$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $0c349e8b6d22460f$var$CloseCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "filled"
};
var $0c349e8b6d22460f$export$2e2bcd8739ae039 = $0c349e8b6d22460f$var$CloseCircleFilled;

});


parcelRegister("cGjF0", function(module, exports) {

$parcel$export(module.exports, "default", () => $93b8a86f8ed15614$export$2e2bcd8739ae039);
$parcel$export(module.exports, "BaseInput", () => (parcelRequire("4lB6V")).default);

var $4lB6V = parcelRequire("4lB6V");

var $dsUZF = parcelRequire("dsUZF");
var $93b8a86f8ed15614$export$2e2bcd8739ae039 = (0, $dsUZF.default);

});
parcelRegister("4lB6V", function(module, exports) {

$parcel$export(module.exports, "default", () => $32a5e8fad29dc207$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $kSlfw = parcelRequire("kSlfw");

var $fSwVM = parcelRequire("fSwVM");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $lKHNk = parcelRequire("lKHNk");
var $32a5e8fad29dc207$var$BaseInput = function BaseInput(props) {
    var _inputElement$props, _inputElement$props2;
    var inputElement = props.inputElement, prefixCls = props.prefixCls, prefix = props.prefix, suffix = props.suffix, addonBefore = props.addonBefore, addonAfter = props.addonAfter, className = props.className, style = props.style, disabled = props.disabled, readOnly = props.readOnly, focused = props.focused, triggerFocus = props.triggerFocus, allowClear = props.allowClear, value = props.value, handleReset = props.handleReset, hidden = props.hidden, classes = props.classes, classNames = props.classNames, dataAttrs = props.dataAttrs, styles = props.styles, components = props.components;
    var AffixWrapperComponent = (components === null || components === void 0 ? void 0 : components.affixWrapper) || "span";
    var GroupWrapperComponent = (components === null || components === void 0 ? void 0 : components.groupWrapper) || "span";
    var WrapperComponent = (components === null || components === void 0 ? void 0 : components.wrapper) || "span";
    var GroupAddonComponent = (components === null || components === void 0 ? void 0 : components.groupAddon) || "span";
    var containerRef = (0, $acw62.useRef)(null);
    var onInputClick = function onInputClick(e) {
        var _containerRef$current;
        if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(e.target)) triggerFocus === null || triggerFocus === void 0 || triggerFocus();
    };
    // ================== Clear Icon ================== //
    var getClearIcon = function getClearIcon() {
        var _clsx;
        if (!allowClear) return null;
        var needClear = !disabled && !readOnly && value;
        var clearIconCls = "".concat(prefixCls, "-clear-icon");
        var iconNode = (0, $fSwVM.default)(allowClear) === "object" && allowClear !== null && allowClear !== void 0 && allowClear.clearIcon ? allowClear.clearIcon : "\u2716";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            onClick: handleReset,
            onMouseDown: function onMouseDown(e) {
                return e.preventDefault();
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(clearIconCls, (_clsx = {}, (0, $kSlfw.default)(_clsx, "".concat(clearIconCls, "-hidden"), !needClear), (0, $kSlfw.default)(_clsx, "".concat(clearIconCls, "-has-suffix"), !!suffix), _clsx)),
            role: "button",
            tabIndex: -1
        }, iconNode);
    };
    var element = /*#__PURE__*/ (0, $acw62.cloneElement)(inputElement, {
        value: value,
        hidden: hidden,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((_inputElement$props = inputElement.props) === null || _inputElement$props === void 0 ? void 0 : _inputElement$props.className, !(0, $lKHNk.hasPrefixSuffix)(props) && !(0, $lKHNk.hasAddon)(props) && className) || null,
        style: (0, $d49SP.default)((0, $d49SP.default)({}, (_inputElement$props2 = inputElement.props) === null || _inputElement$props2 === void 0 ? void 0 : _inputElement$props2.style), !(0, $lKHNk.hasPrefixSuffix)(props) && !(0, $lKHNk.hasAddon)(props) ? style : {})
    });
    // ================== Prefix & Suffix ================== //
    if ((0, $lKHNk.hasPrefixSuffix)(props)) {
        var _clsx2;
        var affixWrapperPrefixCls = "".concat(prefixCls, "-affix-wrapper");
        var affixWrapperCls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(affixWrapperPrefixCls, (_clsx2 = {}, (0, $kSlfw.default)(_clsx2, "".concat(affixWrapperPrefixCls, "-disabled"), disabled), (0, $kSlfw.default)(_clsx2, "".concat(affixWrapperPrefixCls, "-focused"), focused), (0, $kSlfw.default)(_clsx2, "".concat(affixWrapperPrefixCls, "-readonly"), readOnly), (0, $kSlfw.default)(_clsx2, "".concat(affixWrapperPrefixCls, "-input-with-clear-btn"), suffix && allowClear && value), _clsx2), !(0, $lKHNk.hasAddon)(props) && className, classes === null || classes === void 0 ? void 0 : classes.affixWrapper, classNames === null || classNames === void 0 ? void 0 : classNames.affixWrapper);
        var suffixNode = (suffix || allowClear) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-suffix"), classNames === null || classNames === void 0 ? void 0 : classNames.suffix),
            style: styles === null || styles === void 0 ? void 0 : styles.suffix
        }, getClearIcon(), suffix);
        element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(AffixWrapperComponent, (0, $8nd05.default)({
            className: affixWrapperCls,
            style: (0, $d49SP.default)((0, $d49SP.default)({}, !(0, $lKHNk.hasAddon)(props) ? style : undefined), styles === null || styles === void 0 ? void 0 : styles.affixWrapper),
            hidden: !(0, $lKHNk.hasAddon)(props) && hidden,
            onClick: onInputClick
        }, dataAttrs === null || dataAttrs === void 0 ? void 0 : dataAttrs.affixWrapper, {
            ref: containerRef
        }), prefix && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-prefix"), classNames === null || classNames === void 0 ? void 0 : classNames.prefix),
            style: styles === null || styles === void 0 ? void 0 : styles.prefix
        }, prefix), /*#__PURE__*/ (0, $acw62.cloneElement)(inputElement, {
            value: value,
            hidden: null
        }), suffixNode);
    }
    // ================== Addon ================== //
    if ((0, $lKHNk.hasAddon)(props)) {
        var wrapperCls = "".concat(prefixCls, "-group");
        var addonCls = "".concat(wrapperCls, "-addon");
        var mergedWrapperClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-wrapper"), wrapperCls, classes === null || classes === void 0 ? void 0 : classes.wrapper);
        var mergedGroupClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-group-wrapper"), className, classes === null || classes === void 0 ? void 0 : classes.group);
        // Need another wrapper for changing display:table to display:inline-block
        // and put style prop in wrapper
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(GroupWrapperComponent, {
            className: mergedGroupClassName,
            style: style,
            hidden: hidden
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrapperComponent, {
            className: mergedWrapperClassName
        }, addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonBefore), /*#__PURE__*/ (0, $acw62.cloneElement)(element, {
            hidden: null
        }), addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonAfter)));
    }
    return element;
};
var $32a5e8fad29dc207$export$2e2bcd8739ae039 = $32a5e8fad29dc207$var$BaseInput;

});
parcelRegister("lKHNk", function(module, exports) {

$parcel$export(module.exports, "hasAddon", () => $fd5fdd8da073bd4e$export$ae6255aa850a31d1);
$parcel$export(module.exports, "hasPrefixSuffix", () => $fd5fdd8da073bd4e$export$a19010aeeaa0c7a);
$parcel$export(module.exports, "resolveOnChange", () => $fd5fdd8da073bd4e$export$c28984794956ddc0);
$parcel$export(module.exports, "triggerFocus", () => $fd5fdd8da073bd4e$export$2b92016deb0b7aad);
function $fd5fdd8da073bd4e$export$ae6255aa850a31d1(props) {
    return !!(props.addonBefore || props.addonAfter);
}
function $fd5fdd8da073bd4e$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
}
function $fd5fdd8da073bd4e$export$c28984794956ddc0(target, e, onChange, targetValue) {
    if (!onChange) return;
    var event = e;
    if (e.type === "click") {
        // Clone a new target for event.
        // Avoid the following usage, the setQuery method gets the original value.
        //
        // const [query, setQuery] = React.useState('');
        // <Input
        //   allowClear
        //   value={query}
        //   onChange={(e)=> {
        //     setQuery((prevStatus) => e.target.value);
        //   }}
        // />
        var currentTarget = target.cloneNode(true);
        // click clear icon
        event = Object.create(e, {
            target: {
                value: currentTarget
            },
            currentTarget: {
                value: currentTarget
            }
        });
        currentTarget.value = "";
        onChange(event);
        return;
    }
    // Trigger by composition event, this means we need force change the input value
    if (targetValue !== undefined) {
        var _currentTarget = target.cloneNode(true);
        event = Object.create(e, {
            target: {
                value: _currentTarget
            },
            currentTarget: {
                value: _currentTarget
            }
        });
        // https://github.com/ant-design/ant-design/issues/45737
        if (_currentTarget.type !== "file") _currentTarget.value = targetValue;
        onChange(event);
        return;
    }
    onChange(event);
}
function $fd5fdd8da073bd4e$export$2b92016deb0b7aad(element, option) {
    if (!element) return;
    element.focus(option);
    // Selection content
    var _ref = option || {}, cursor = _ref.cursor;
    if (cursor) {
        var len = element.value.length;
        switch(cursor){
            case "start":
                element.setSelectionRange(0, 0);
                break;
            case "end":
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
        }
    }
}

});


parcelRegister("dsUZF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cda19a001f87ecf$export$2e2bcd8739ae039);

var $d49SP = parcelRequire("d49SP");

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $kbxxf = parcelRequire("kbxxf");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $8g1PZ = parcelRequire("8g1PZ");

var $iSQh8 = parcelRequire("iSQh8");

var $1pcHX = parcelRequire("1pcHX");

var $acw62 = parcelRequire("acw62");

var $4lB6V = parcelRequire("4lB6V");

var $c8ddo = parcelRequire("c8ddo");

var $lKHNk = parcelRequire("lKHNk");
var $9cda19a001f87ecf$var$_excluded = [
    "autoComplete",
    "onChange",
    "onFocus",
    "onBlur",
    "onPressEnter",
    "onKeyDown",
    "prefixCls",
    "disabled",
    "htmlSize",
    "className",
    "maxLength",
    "suffix",
    "showCount",
    "count",
    "type",
    "classes",
    "classNames",
    "styles",
    "onCompositionStart",
    "onCompositionEnd"
];
var $9cda19a001f87ecf$var$Input = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var autoComplete = props.autoComplete, onChange = props.onChange, onFocus = props.onFocus, onBlur = props.onBlur, onPressEnter = props.onPressEnter, onKeyDown = props.onKeyDown, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-input" : _props$prefixCls, disabled = props.disabled, htmlSize = props.htmlSize, className = props.className, maxLength = props.maxLength, suffix = props.suffix, showCount = props.showCount, count = props.count, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, classes = props.classes, classNames = props.classNames, styles = props.styles, _onCompositionStart = props.onCompositionStart, onCompositionEnd = props.onCompositionEnd, rest = (0, $9X7IJ.default)(props, $9cda19a001f87ecf$var$_excluded);
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, $eUqlC.default)(_useState, 2), focused = _useState2[0], setFocused = _useState2[1];
    var compositionRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    var inputRef = (0, $acw62.useRef)(null);
    var focus = function focus(option) {
        if (inputRef.current) (0, $lKHNk.triggerFocus)(inputRef.current, option);
    };
    // ====================== Value =======================
    var _useMergedState = (0, $iSQh8.default)(props.defaultValue, {
        value: props.value
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
    var formatValue = value === undefined || value === null ? "" : String(value);
    // =================== Select Range ===================
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), selection = _React$useState2[0], setSelection = _React$useState2[1];
    // ====================== Count =======================
    var countConfig = (0, $c8ddo.default)(count, showCount);
    var mergedMax = countConfig.max || maxLength;
    var valueLength = countConfig.strategy(formatValue);
    var isOutOfRange = !!mergedMax && valueLength > mergedMax;
    // ======================= Ref ========================
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            focus: focus,
            blur: function blur() {
                var _inputRef$current;
                (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.blur();
            },
            setSelectionRange: function setSelectionRange(start, end, direction) {
                var _inputRef$current2;
                (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.setSelectionRange(start, end, direction);
            },
            select: function select() {
                var _inputRef$current3;
                (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 || _inputRef$current3.select();
            },
            input: inputRef.current
        };
    });
    (0, $acw62.useEffect)(function() {
        setFocused(function(prev) {
            return prev && disabled ? false : prev;
        });
    }, [
        disabled
    ]);
    var triggerChange = function triggerChange(e, currentValue) {
        var cutValue = currentValue;
        if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
            cutValue = countConfig.exceedFormatter(currentValue, {
                max: countConfig.max
            });
            if (currentValue !== cutValue) {
                var _inputRef$current4, _inputRef$current5;
                setSelection([
                    ((_inputRef$current4 = inputRef.current) === null || _inputRef$current4 === void 0 ? void 0 : _inputRef$current4.selectionStart) || 0,
                    ((_inputRef$current5 = inputRef.current) === null || _inputRef$current5 === void 0 ? void 0 : _inputRef$current5.selectionEnd) || 0
                ]);
            }
        }
        setValue(cutValue);
        if (inputRef.current) (0, $lKHNk.resolveOnChange)(inputRef.current, e, onChange, cutValue);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        if (selection) {
            var _inputRef$current6;
            (_inputRef$current6 = inputRef.current) === null || _inputRef$current6 === void 0 || _inputRef$current6.setSelectionRange.apply(_inputRef$current6, (0, $kbxxf.default)(selection));
        }
    }, [
        selection
    ]);
    var onInternalChange = function onInternalChange(e) {
        triggerChange(e, e.target.value);
    };
    var onInternalCompositionEnd = function onInternalCompositionEnd(e) {
        compositionRef.current = false;
        triggerChange(e, e.currentTarget.value);
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (onPressEnter && e.key === "Enter") onPressEnter(e);
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    };
    var handleFocus = function handleFocus(e) {
        setFocused(true);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    var handleBlur = function handleBlur(e) {
        setFocused(false);
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    var handleReset = function handleReset(e) {
        setValue("");
        focus();
        if (inputRef.current) (0, $lKHNk.resolveOnChange)(inputRef.current, e, onChange);
    };
    // ====================== Input =======================
    var outOfRangeCls = isOutOfRange && "".concat(prefixCls, "-out-of-range");
    var getInputElement = function getInputElement() {
        // Fix https://fb.me/react-unknown-prop
        var otherProps = (0, $1pcHX.default)(props, [
            "prefixCls",
            "onPressEnter",
            "addonBefore",
            "addonAfter",
            "prefix",
            "suffix",
            "allowClear",
            // Input elements must be either controlled or uncontrolled,
            // specify either the value prop, or the defaultValue prop, but not both.
            "defaultValue",
            "showCount",
            "count",
            "classes",
            "htmlSize",
            "styles",
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", (0, $8nd05.default)({
            autoComplete: autoComplete
        }, otherProps, {
            onChange: onInternalChange,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyDown: handleKeyDown,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, (0, $kSlfw.default)({}, "".concat(prefixCls, "-disabled"), disabled), classNames === null || classNames === void 0 ? void 0 : classNames.input),
            style: styles === null || styles === void 0 ? void 0 : styles.input,
            ref: inputRef,
            size: htmlSize,
            type: type,
            onCompositionStart: function onCompositionStart(e) {
                compositionRef.current = true;
                _onCompositionStart === null || _onCompositionStart === void 0 || _onCompositionStart(e);
            },
            onCompositionEnd: onInternalCompositionEnd
        }));
    };
    var getSuffix = function getSuffix() {
        // Max length value
        var hasMaxLength = Number(mergedMax) > 0;
        if (suffix || countConfig.show) {
            var dataCount = countConfig.showFormatter ? countConfig.showFormatter({
                value: formatValue,
                count: valueLength,
                maxLength: mergedMax
            }) : "".concat(valueLength).concat(hasMaxLength ? " / ".concat(mergedMax) : "");
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, countConfig.show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-show-count-suffix"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-show-count-has-suffix"), !!suffix), classNames === null || classNames === void 0 ? void 0 : classNames.count),
                style: (0, $d49SP.default)({}, styles === null || styles === void 0 ? void 0 : styles.count)
            }, dataCount), suffix);
        }
        return null;
    };
    // ====================== Render ======================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4lB6V.default), (0, $8nd05.default)({}, rest, {
        prefixCls: prefixCls,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, outOfRangeCls),
        inputElement: getInputElement(),
        handleReset: handleReset,
        value: formatValue,
        focused: focused,
        triggerFocus: focus,
        suffix: getSuffix(),
        disabled: disabled,
        classes: classes,
        classNames: classNames,
        styles: styles
    }));
});
var $9cda19a001f87ecf$export$2e2bcd8739ae039 = $9cda19a001f87ecf$var$Input;

});
parcelRegister("c8ddo", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d507ba491af0684$export$2e2bcd8739ae039);

var $9X7IJ = parcelRequire("9X7IJ");

var $d49SP = parcelRequire("d49SP");

var $fSwVM = parcelRequire("fSwVM");

var $acw62 = parcelRequire("acw62");
var $8d507ba491af0684$var$_excluded = [
    "show"
];
function $8d507ba491af0684$export$7a29f0d5cac613ba(value, countConfig) {
    if (!countConfig.max) return true;
    var count = countConfig.strategy(value);
    return count <= countConfig.max;
}
function $8d507ba491af0684$export$2e2bcd8739ae039(count, showCount) {
    return $acw62.useMemo(function() {
        var mergedConfig = {};
        if (showCount) mergedConfig.show = (0, $fSwVM.default)(showCount) === "object" && showCount.formatter ? showCount.formatter : !!showCount;
        mergedConfig = (0, $d49SP.default)((0, $d49SP.default)({}, mergedConfig), count);
        var _ref = mergedConfig, show = _ref.show, rest = (0, $9X7IJ.default)(_ref, $8d507ba491af0684$var$_excluded);
        return (0, $d49SP.default)((0, $d49SP.default)({}, rest), {}, {
            show: !!show,
            showFormatter: typeof show === "function" ? show : undefined,
            strategy: rest.strategy || function(value) {
                return value.length;
            }
        });
    }, [
        count,
        showCount
    ]);
}

});



parcelRegister("8Vr1S", function(module, exports) {

$parcel$export(module.exports, "getStatusClassNames", () => $67f89d06f52454a6$export$b08e7b47149942a2);
$parcel$export(module.exports, "getMergedStatus", () => $67f89d06f52454a6$export$314e193082d7ba49);

var $8g1PZ = parcelRequire("8g1PZ");
const $67f89d06f52454a6$var$InputStatuses = [
    "warning",
    "error",
    ""
];
function $67f89d06f52454a6$export$b08e7b47149942a2(prefixCls, status, hasFeedback) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
        [`${prefixCls}-status-success`]: status === "success",
        [`${prefixCls}-status-warning`]: status === "warning",
        [`${prefixCls}-status-error`]: status === "error",
        [`${prefixCls}-status-validating`]: status === "validating",
        [`${prefixCls}-has-feedback`]: hasFeedback
    });
}
const $67f89d06f52454a6$export$314e193082d7ba49 = (contextStatus, customStatus)=>customStatus || contextStatus;

});

parcelRegister("jApbz", function(module, exports) {

$parcel$export(module.exports, "default", () => $e424ea760f35b51a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $e424ea760f35b51a$export$2e2bcd8739ae039(inputRef, triggerOnMount) {
    const removePasswordTimeoutRef = (0, $acw62.useRef)([]);
    const removePasswordTimeout = ()=>{
        removePasswordTimeoutRef.current.push(setTimeout(()=>{
            var _a, _b, _c, _d;
            if (((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) && ((_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.input.getAttribute("type")) === "password" && ((_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.input.hasAttribute("value"))) (_d = inputRef.current) === null || _d === void 0 || _d.input.removeAttribute("value");
        }));
    };
    (0, $acw62.useEffect)(()=>{
        if (triggerOnMount) removePasswordTimeout();
        return ()=>removePasswordTimeoutRef.current.forEach((timer)=>{
                if (timer) clearTimeout(timer);
            });
    }, []);
    return removePasswordTimeout;
}

});

parcelRegister("30J1N", function(module, exports) {

$parcel$export(module.exports, "hasPrefixSuffix", () => $23144ccd376634c7$export$a19010aeeaa0c7a);
// eslint-disable-next-line import/prefer-default-export
function $23144ccd376634c7$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
}

});


parcelRegister("3phh6", function(module, exports) {

$parcel$export(module.exports, "default", () => $27b11b4fcd97a00b$export$2e2bcd8739ae039);

var $6glBm = parcelRequire("6glBm");

var $iBino = parcelRequire("iBino");

var $8g1PZ = parcelRequire("8g1PZ");

var $1pcHX = parcelRequire("1pcHX");

var $85dLH = parcelRequire("85dLH");

var $acw62 = parcelRequire("acw62");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $jApbz = parcelRequire("jApbz");

var $7aL1y = parcelRequire("7aL1y");
"use client";
var $27b11b4fcd97a00b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $27b11b4fcd97a00b$var$defaultIconRender = (visible)=>visible ? /*#__PURE__*/ $acw62.createElement((0, $iBino.default), null) : /*#__PURE__*/ $acw62.createElement((0, $6glBm.default), null);
const $27b11b4fcd97a00b$var$ActionMap = {
    click: "onClick",
    hover: "onMouseOver"
};
const $27b11b4fcd97a00b$var$Password = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { visibilityToggle: visibilityToggle = true } = props;
    const visibilityControlled = typeof visibilityToggle === "object" && visibilityToggle.visible !== undefined;
    const [visible, setVisible] = (0, $acw62.useState)(()=>visibilityControlled ? visibilityToggle.visible : false);
    const inputRef = (0, $acw62.useRef)(null);
    $acw62.useEffect(()=>{
        if (visibilityControlled) setVisible(visibilityToggle.visible);
    }, [
        visibilityControlled,
        visibilityToggle
    ]);
    // Remove Password value
    const removePasswordTimeout = (0, $jApbz.default)(inputRef);
    const onVisibleChange = ()=>{
        const { disabled: disabled } = props;
        if (disabled) return;
        if (visible) removePasswordTimeout();
        setVisible((prevState)=>{
            var _a;
            const newState = !prevState;
            if (typeof visibilityToggle === "object") (_a = visibilityToggle.onVisibleChange) === null || _a === void 0 || _a.call(visibilityToggle, newState);
            return newState;
        });
    };
    const getIcon = (prefixCls)=>{
        const { action: action = "click", iconRender: iconRender = $27b11b4fcd97a00b$var$defaultIconRender } = props;
        const iconTrigger = $27b11b4fcd97a00b$var$ActionMap[action] || "";
        const icon = iconRender(visible);
        const iconProps = {
            [iconTrigger]: onVisibleChange,
            className: `${prefixCls}-icon`,
            key: "passwordIcon",
            onMouseDown: (e)=>{
                // Prevent focused state lost
                // https://github.com/ant-design/ant-design/issues/15173
                e.preventDefault();
            },
            onMouseUp: (e)=>{
                // Prevent caret position change
                // https://github.com/ant-design/ant-design/issues/23524
                e.preventDefault();
            }
        };
        return /*#__PURE__*/ $acw62.cloneElement(/*#__PURE__*/ $acw62.isValidElement(icon) ? icon : /*#__PURE__*/ $acw62.createElement("span", null, icon), iconProps);
    };
    const { className: className, prefixCls: customizePrefixCls, inputPrefixCls: customizeInputPrefixCls, size: size } = props, restProps = $27b11b4fcd97a00b$var$__rest(props, [
        "className",
        "prefixCls",
        "inputPrefixCls",
        "size"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const inputPrefixCls = getPrefixCls("input", customizeInputPrefixCls);
    const prefixCls = getPrefixCls("input-password", customizePrefixCls);
    const suffixIcon = visibilityToggle && getIcon(prefixCls);
    const inputClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, className, {
        [`${prefixCls}-${size}`]: !!size
    });
    const omittedProps = Object.assign(Object.assign({}, (0, $1pcHX.default)(restProps, [
        "suffix",
        "iconRender",
        "visibilityToggle"
    ])), {
        type: visible ? "text" : "password",
        className: inputClassName,
        prefixCls: inputPrefixCls,
        suffix: suffixIcon
    });
    if (size) omittedProps.size = size;
    return /*#__PURE__*/ $acw62.createElement((0, $7aL1y.default), Object.assign({
        ref: (0, $85dLH.composeRef)(ref, inputRef)
    }, omittedProps));
});
var $27b11b4fcd97a00b$export$2e2bcd8739ae039 = $27b11b4fcd97a00b$var$Password;

});
parcelRegister("6glBm", function(module, exports) {

$parcel$export(module.exports, "default", () => $48f4fe50ff6ca9c8$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $9GgB6 = parcelRequire("9GgB6");

var $adRcI = parcelRequire("adRcI");
var $48f4fe50ff6ca9c8$var$EyeInvisibleOutlined = function EyeInvisibleOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $adRcI.default), (0, $8nd05.default)({}, props, {
        ref: ref,
        icon: (0, $9GgB6.default)
    }));
};
var $48f4fe50ff6ca9c8$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($48f4fe50ff6ca9c8$var$EyeInvisibleOutlined);

});
parcelRegister("9GgB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $70c4e92fea0b3f8a$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $70c4e92fea0b3f8a$var$EyeInvisibleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z"
                }
            }
        ]
    },
    "name": "eye-invisible",
    "theme": "outlined"
};
var $70c4e92fea0b3f8a$export$2e2bcd8739ae039 = $70c4e92fea0b3f8a$var$EyeInvisibleOutlined;

});


parcelRegister("iBino", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8a9efd7a074f5f5$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $fM1rB = parcelRequire("fM1rB");

var $adRcI = parcelRequire("adRcI");
var $d8a9efd7a074f5f5$var$EyeOutlined = function EyeOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $adRcI.default), (0, $8nd05.default)({}, props, {
        ref: ref,
        icon: (0, $fM1rB.default)
    }));
};
var $d8a9efd7a074f5f5$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($d8a9efd7a074f5f5$var$EyeOutlined);

});
parcelRegister("fM1rB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7bc758130af6b02$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $b7bc758130af6b02$var$EyeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    },
    "name": "eye",
    "theme": "outlined"
};
var $b7bc758130af6b02$export$2e2bcd8739ae039 = $b7bc758130af6b02$var$EyeOutlined;

});



parcelRegister("2Xl9q", function(module, exports) {

$parcel$export(module.exports, "default", () => $22717f99dfeb0b1a$export$2e2bcd8739ae039);

var $ldXL3 = parcelRequire("ldXL3");

var $8g1PZ = parcelRequire("8g1PZ");

var $85dLH = parcelRequire("85dLH");

var $acw62 = parcelRequire("acw62");

var $4a1I5 = parcelRequire("4a1I5");

var $4Uh7a = parcelRequire("4Uh7a");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $IFe7R = parcelRequire("IFe7R");

var $3gns8 = parcelRequire("3gns8");

var $7aL1y = parcelRequire("7aL1y");
"use client";
var $22717f99dfeb0b1a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $22717f99dfeb0b1a$var$Search = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, inputPrefixCls: customizeInputPrefixCls, className: className, size: customizeSize, suffix: suffix, enterButton: enterButton = false, addonAfter: addonAfter, loading: loading, disabled: disabled, onSearch: customOnSearch, onChange: customOnChange, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd } = props, restProps = $22717f99dfeb0b1a$var$__rest(props, [
        "prefixCls",
        "inputPrefixCls",
        "className",
        "size",
        "suffix",
        "enterButton",
        "addonAfter",
        "loading",
        "disabled",
        "onSearch",
        "onChange",
        "onCompositionStart",
        "onCompositionEnd"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const composedRef = $acw62.useRef(false);
    const prefixCls = getPrefixCls("input-search", customizePrefixCls);
    const inputPrefixCls = getPrefixCls("input", customizeInputPrefixCls);
    const { compactSize: compactSize } = (0, $3gns8.useCompactItemContext)(prefixCls, direction);
    const size = (0, $IFe7R.default)((ctx)=>{
        var _a;
        return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
    });
    const inputRef = $acw62.useRef(null);
    const onChange = (e)=>{
        if (e && e.target && e.type === "click" && customOnSearch) customOnSearch(e.target.value, e, {
            source: "clear"
        });
        if (customOnChange) customOnChange(e);
    };
    const onMouseDown = (e)=>{
        var _a;
        if (document.activeElement === ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input)) e.preventDefault();
    };
    const onSearch = (e)=>{
        var _a, _b;
        if (customOnSearch) customOnSearch((_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.value, e, {
            source: "input"
        });
    };
    const onPressEnter = (e)=>{
        if (composedRef.current || loading) return;
        onSearch(e);
    };
    const searchIcon = typeof enterButton === "boolean" ? /*#__PURE__*/ $acw62.createElement((0, $ldXL3.default), null) : null;
    const btnClassName = `${prefixCls}-button`;
    let button;
    const enterButtonAsElement = enterButton || {};
    const isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
    if (isAntdButton || enterButtonAsElement.type === "button") button = (0, $4a1I5.cloneElement)(enterButtonAsElement, Object.assign({
        onMouseDown: onMouseDown,
        onClick: (e)=>{
            var _a, _b;
            (_b = (_a = enterButtonAsElement === null || enterButtonAsElement === void 0 ? void 0 : enterButtonAsElement.props) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 || _b.call(_a, e);
            onSearch(e);
        },
        key: "enterButton"
    }, isAntdButton ? {
        className: btnClassName,
        size: size
    } : {}));
    else button = /*#__PURE__*/ $acw62.createElement((0, $4Uh7a.default), {
        className: btnClassName,
        type: enterButton ? "primary" : undefined,
        size: size,
        disabled: disabled,
        key: "enterButton",
        onMouseDown: onMouseDown,
        onClick: onSearch,
        loading: loading,
        icon: searchIcon
    }, enterButton);
    if (addonAfter) button = [
        button,
        (0, $4a1I5.cloneElement)(addonAfter, {
            key: "addonAfter"
        })
    ];
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, {
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-${size}`]: !!size,
        [`${prefixCls}-with-button`]: !!enterButton
    }, className);
    const handleOnCompositionStart = (e)=>{
        composedRef.current = true;
        onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(e);
    };
    const handleOnCompositionEnd = (e)=>{
        composedRef.current = false;
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    return /*#__PURE__*/ $acw62.createElement((0, $7aL1y.default), Object.assign({
        ref: (0, $85dLH.composeRef)(inputRef, ref),
        onPressEnter: onPressEnter
    }, restProps, {
        size: size,
        onCompositionStart: handleOnCompositionStart,
        onCompositionEnd: handleOnCompositionEnd,
        prefixCls: inputPrefixCls,
        addonAfter: button,
        suffix: suffix,
        onChange: onChange,
        className: cls,
        disabled: disabled
    }));
});
var $22717f99dfeb0b1a$export$2e2bcd8739ae039 = $22717f99dfeb0b1a$var$Search;

});
parcelRegister("ldXL3", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7392a88184334dd$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $byUZl = parcelRequire("byUZl");

var $adRcI = parcelRequire("adRcI");
var $f7392a88184334dd$var$SearchOutlined = function SearchOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $adRcI.default), (0, $8nd05.default)({}, props, {
        ref: ref,
        icon: (0, $byUZl.default)
    }));
};
var $f7392a88184334dd$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($f7392a88184334dd$var$SearchOutlined);

});
parcelRegister("byUZl", function(module, exports) {

$parcel$export(module.exports, "default", () => $86af1367b2b71ab8$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $86af1367b2b71ab8$var$SearchOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
                }
            }
        ]
    },
    "name": "search",
    "theme": "outlined"
};
var $86af1367b2b71ab8$export$2e2bcd8739ae039 = $86af1367b2b71ab8$var$SearchOutlined;

});



parcelRegister("lEgf5", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc29eec8796e8593$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $b9YHa = parcelRequire("b9YHa");

var $8g1PZ = parcelRequire("8g1PZ");

var $4GwQn = parcelRequire("4GwQn");

var $8Vr1S = parcelRequire("8Vr1S");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $9f1hj = parcelRequire("9f1hj");

var $IFe7R = parcelRequire("IFe7R");

var $eSOz6 = parcelRequire("eSOz6");

var $7aL1y = parcelRequire("7aL1y");

var $317P8 = parcelRequire("317P8");

var $dnT3A = parcelRequire("dnT3A");
"use client";
var $fc29eec8796e8593$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $fc29eec8796e8593$var$TextArea = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var _a;
    const { prefixCls: customizePrefixCls, bordered: bordered = true, size: customizeSize, disabled: customDisabled, status: customStatus, allowClear: allowClear, classNames: classes, rootClassName: rootClassName, className: className } = props, rest = $fc29eec8796e8593$var$__rest(props, [
        "prefixCls",
        "bordered",
        "size",
        "disabled",
        "status",
        "allowClear",
        "classNames",
        "rootClassName",
        "className"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $dRTnM.ConfigContext));
    // ===================== Size =====================
    const mergedSize = (0, $IFe7R.default)(customizeSize);
    // ===================== Disabled =====================
    const disabled = $acw62.useContext((0, $9f1hj.default));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    // ===================== Status =====================
    const { status: contextStatus, hasFeedback: hasFeedback, feedbackIcon: feedbackIcon } = $acw62.useContext((0, $eSOz6.FormItemInputContext));
    const mergedStatus = (0, $8Vr1S.getMergedStatus)(contextStatus, customStatus);
    // ===================== Ref =====================
    const innerRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, ()=>{
        var _a;
        return {
            resizableTextArea: (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea,
            focus: (option)=>{
                var _a, _b;
                (0, $7aL1y.triggerFocus)((_b = (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea) === null || _b === void 0 ? void 0 : _b.textArea, option);
            },
            blur: ()=>{
                var _a;
                return (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            }
        };
    });
    const prefixCls = getPrefixCls("input", customizePrefixCls);
    // Allow clear
    let mergedAllowClear;
    if (typeof allowClear === "object" && (allowClear === null || allowClear === void 0 ? void 0 : allowClear.clearIcon)) mergedAllowClear = allowClear;
    else if (allowClear) mergedAllowClear = {
        clearIcon: /*#__PURE__*/ $acw62.createElement((0, $b9YHa.default), null)
    };
    // ===================== Style =====================
    const cssVarCls = (0, $dnT3A.default)(prefixCls);
    const [wrapCSSVar, hashId] = (0, $317P8.default)(prefixCls, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $4GwQn.default), Object.assign({}, rest, {
        disabled: mergedDisabled,
        allowClear: mergedAllowClear,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(cssVarCls, className, rootClassName),
        classes: {
            affixWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(`${prefixCls}-textarea-affix-wrapper`, {
                [`${prefixCls}-affix-wrapper-rtl`]: direction === "rtl",
                [`${prefixCls}-affix-wrapper-borderless`]: !bordered,
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === "small",
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === "large",
                [`${prefixCls}-textarea-show-count`]: props.showCount || ((_a = props.count) === null || _a === void 0 ? void 0 : _a.show)
            }, (0, $8Vr1S.getStatusClassNames)(`${prefixCls}-affix-wrapper`, mergedStatus), hashId)
        },
        classNames: Object.assign(Object.assign({}, classes), {
            textarea: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                [`${prefixCls}-borderless`]: !bordered,
                [`${prefixCls}-sm`]: mergedSize === "small",
                [`${prefixCls}-lg`]: mergedSize === "large"
            }, (0, $8Vr1S.getStatusClassNames)(prefixCls, mergedStatus), hashId, classes === null || classes === void 0 ? void 0 : classes.textarea)
        }),
        prefixCls: prefixCls,
        suffix: hasFeedback && /*#__PURE__*/ $acw62.createElement("span", {
            className: `${prefixCls}-textarea-suffix`
        }, feedbackIcon),
        ref: innerRef
    })));
});
var $fc29eec8796e8593$export$2e2bcd8739ae039 = $fc29eec8796e8593$var$TextArea;

});
parcelRegister("4GwQn", function(module, exports) {

$parcel$export(module.exports, "default", () => $36948fc6671d6b75$export$2e2bcd8739ae039);

var $4GjDn = parcelRequire("4GjDn");

var $4bXyH = parcelRequire("4bXyH");
var $36948fc6671d6b75$export$2e2bcd8739ae039 = (0, $4GjDn.default);

});
parcelRegister("4GjDn", function(module, exports) {

$parcel$export(module.exports, "default", () => $368a509879ccc1d0$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $kSlfw = parcelRequire("kSlfw");

var $kbxxf = parcelRequire("kbxxf");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $8g1PZ = parcelRequire("8g1PZ");
parcelRequire("cGjF0");
var $4lB6V = parcelRequire("4lB6V");

var $c8ddo = parcelRequire("c8ddo");

var $lKHNk = parcelRequire("lKHNk");

var $iSQh8 = parcelRequire("iSQh8");

var $acw62 = parcelRequire("acw62");

var $4bXyH = parcelRequire("4bXyH");
var $368a509879ccc1d0$var$_excluded = [
    "defaultValue",
    "value",
    "onFocus",
    "onBlur",
    "onChange",
    "allowClear",
    "maxLength",
    "onCompositionStart",
    "onCompositionEnd",
    "suffix",
    "prefixCls",
    "classes",
    "showCount",
    "count",
    "className",
    "style",
    "disabled",
    "hidden",
    "classNames",
    "styles",
    "onResize"
];
var $368a509879ccc1d0$var$TextArea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(_ref, ref) {
    var _countConfig$max, _clsx;
    var defaultValue = _ref.defaultValue, customValue = _ref.value, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onChange = _ref.onChange, allowClear = _ref.allowClear, maxLength = _ref.maxLength, onCompositionStart = _ref.onCompositionStart, onCompositionEnd = _ref.onCompositionEnd, suffix = _ref.suffix, _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? "rc-textarea" : _ref$prefixCls, classes = _ref.classes, showCount = _ref.showCount, count = _ref.count, className = _ref.className, style = _ref.style, disabled = _ref.disabled, hidden = _ref.hidden, classNames = _ref.classNames, styles = _ref.styles, onResize = _ref.onResize, rest = (0, $9X7IJ.default)(_ref, $368a509879ccc1d0$var$_excluded);
    var _useMergedState = (0, $iSQh8.default)(defaultValue, {
        value: customValue,
        defaultValue: defaultValue
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
    var formatValue = value === undefined || value === null ? "" : String(value);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), focused = _React$useState2[0], setFocused = _React$useState2[1];
    var compositionRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), textareaResized = _React$useState4[0], setTextareaResized = _React$useState4[1];
    // =============================== Ref ================================
    var resizableTextAreaRef = (0, $acw62.useRef)(null);
    var getTextArea = function getTextArea() {
        var _resizableTextAreaRef;
        return (_resizableTextAreaRef = resizableTextAreaRef.current) === null || _resizableTextAreaRef === void 0 ? void 0 : _resizableTextAreaRef.textArea;
    };
    var focus = function focus() {
        getTextArea().focus();
    };
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            resizableTextArea: resizableTextAreaRef.current,
            focus: focus,
            blur: function blur() {
                getTextArea().blur();
            }
        };
    });
    (0, $acw62.useEffect)(function() {
        setFocused(function(prev) {
            return !disabled && prev;
        });
    }, [
        disabled
    ]);
    // =========================== Select Range ===========================
    var _React$useState5 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null), _React$useState6 = (0, $eUqlC.default)(_React$useState5, 2), selection = _React$useState6[0], setSelection = _React$useState6[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        if (selection) {
            var _getTextArea;
            (_getTextArea = getTextArea()).setSelectionRange.apply(_getTextArea, (0, $kbxxf.default)(selection));
        }
    }, [
        selection
    ]);
    // ============================== Count ===============================
    var countConfig = (0, $c8ddo.default)(count, showCount);
    var mergedMax = (_countConfig$max = countConfig.max) !== null && _countConfig$max !== void 0 ? _countConfig$max : maxLength;
    // Max length value
    var hasMaxLength = Number(mergedMax) > 0;
    var valueLength = countConfig.strategy(formatValue);
    var isOutOfRange = !!mergedMax && valueLength > mergedMax;
    // ============================== Change ==============================
    var triggerChange = function triggerChange(e, currentValue) {
        var cutValue = currentValue;
        if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
            cutValue = countConfig.exceedFormatter(currentValue, {
                max: countConfig.max
            });
            if (currentValue !== cutValue) setSelection([
                getTextArea().selectionStart || 0,
                getTextArea().selectionEnd || 0
            ]);
        }
        setValue(cutValue);
        (0, $lKHNk.resolveOnChange)(e.currentTarget, e, onChange, cutValue);
    };
    // =========================== Value Update ===========================
    var onInternalCompositionStart = function onInternalCompositionStart(e) {
        compositionRef.current = true;
        onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(e);
    };
    var onInternalCompositionEnd = function onInternalCompositionEnd(e) {
        compositionRef.current = false;
        triggerChange(e, e.currentTarget.value);
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    var onInternalChange = function onInternalChange(e) {
        triggerChange(e, e.target.value);
    };
    var handleKeyDown = function handleKeyDown(e) {
        var onPressEnter = rest.onPressEnter, onKeyDown = rest.onKeyDown;
        if (e.key === "Enter" && onPressEnter) onPressEnter(e);
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    };
    var handleFocus = function handleFocus(e) {
        setFocused(true);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    var handleBlur = function handleBlur(e) {
        setFocused(false);
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    // ============================== Reset ===============================
    var handleReset = function handleReset(e) {
        setValue("");
        focus();
        (0, $lKHNk.resolveOnChange)(getTextArea(), e, onChange);
    };
    var suffixNode = suffix;
    var dataCount;
    if (countConfig.show) {
        if (countConfig.showFormatter) dataCount = countConfig.showFormatter({
            value: formatValue,
            count: valueLength,
            maxLength: mergedMax
        });
        else dataCount = "".concat(valueLength).concat(hasMaxLength ? " / ".concat(mergedMax) : "");
        suffixNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, suffixNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-data-count"), classNames === null || classNames === void 0 ? void 0 : classNames.count),
            style: styles === null || styles === void 0 ? void 0 : styles.count
        }, dataCount));
    }
    var handleResize = function handleResize(size) {
        var _getTextArea2;
        onResize === null || onResize === void 0 || onResize(size);
        if ((_getTextArea2 = getTextArea()) !== null && _getTextArea2 !== void 0 && _getTextArea2.style.height) setTextareaResized(true);
    };
    var isPureTextArea = !rest.autoSize && !showCount && !allowClear;
    var textarea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4lB6V.default), {
        value: formatValue,
        allowClear: allowClear,
        handleReset: handleReset,
        suffix: suffixNode,
        prefixCls: prefixCls,
        classes: {
            affixWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(classes === null || classes === void 0 ? void 0 : classes.affixWrapper, (_clsx = {}, (0, $kSlfw.default)(_clsx, "".concat(prefixCls, "-show-count"), showCount), (0, $kSlfw.default)(_clsx, "".concat(prefixCls, "-textarea-allow-clear"), allowClear), _clsx))
        },
        disabled: disabled,
        focused: focused,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, isOutOfRange && "".concat(prefixCls, "-out-of-range")),
        style: (0, $d49SP.default)((0, $d49SP.default)({}, style), textareaResized && !isPureTextArea ? {
            height: "auto"
        } : {}),
        dataAttrs: {
            affixWrapper: {
                "data-count": typeof dataCount === "string" ? dataCount : undefined
            }
        },
        hidden: hidden,
        inputElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4bXyH.default), (0, $8nd05.default)({}, rest, {
            maxLength: maxLength,
            onKeyDown: handleKeyDown,
            onChange: onInternalChange,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onCompositionStart: onInternalCompositionStart,
            onCompositionEnd: onInternalCompositionEnd,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(classNames === null || classNames === void 0 ? void 0 : classNames.textarea),
            style: (0, $d49SP.default)((0, $d49SP.default)({}, styles === null || styles === void 0 ? void 0 : styles.textarea), {}, {
                resize: style === null || style === void 0 ? void 0 : style.resize
            }),
            disabled: disabled,
            prefixCls: prefixCls,
            onResize: handleResize,
            ref: resizableTextAreaRef
        }))
    });
    return textarea;
});
var $368a509879ccc1d0$export$2e2bcd8739ae039 = $368a509879ccc1d0$var$TextArea;

});
parcelRegister("4bXyH", function(module, exports) {

$parcel$export(module.exports, "default", () => $30d6639cbca42aae$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $fSwVM = parcelRequire("fSwVM");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $8g1PZ = parcelRequire("8g1PZ");

var $bVxlN = parcelRequire("bVxlN");

var $6hDTM = parcelRequire("6hDTM");

var $iSQh8 = parcelRequire("iSQh8");

var $dTiBu = parcelRequire("dTiBu");

var $acw62 = parcelRequire("acw62");

var $jycHX = parcelRequire("jycHX");
var $30d6639cbca42aae$var$_excluded = [
    "prefixCls",
    "onPressEnter",
    "defaultValue",
    "value",
    "autoSize",
    "onResize",
    "className",
    "style",
    "disabled",
    "onChange",
    "onInternalAutoSize"
];
var $30d6639cbca42aae$var$RESIZE_START = 0;
var $30d6639cbca42aae$var$RESIZE_MEASURING = 1;
var $30d6639cbca42aae$var$RESIZE_STABLE = 2;
var $30d6639cbca42aae$var$ResizableTextArea = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _ref = props, prefixCls = _ref.prefixCls, onPressEnter = _ref.onPressEnter, defaultValue = _ref.defaultValue, value = _ref.value, autoSize = _ref.autoSize, onResize = _ref.onResize, className = _ref.className, style = _ref.style, disabled = _ref.disabled, onChange = _ref.onChange, onInternalAutoSize = _ref.onInternalAutoSize, restProps = (0, $9X7IJ.default)(_ref, $30d6639cbca42aae$var$_excluded);
    // =============================== Value ================================
    var _useMergedState = (0, $iSQh8.default)(defaultValue, {
        value: value,
        postState: function postState(val) {
            return val !== null && val !== void 0 ? val : "";
        }
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), mergedValue = _useMergedState2[0], setMergedValue = _useMergedState2[1];
    var onInternalChange = function onInternalChange(event) {
        setMergedValue(event.target.value);
        onChange === null || onChange === void 0 || onChange(event);
    };
    // ================================ Ref =================================
    var textareaRef = $acw62.useRef();
    $acw62.useImperativeHandle(ref, function() {
        return {
            textArea: textareaRef.current
        };
    });
    // ============================== AutoSize ==============================
    var _React$useMemo = $acw62.useMemo(function() {
        if (autoSize && (0, $fSwVM.default)(autoSize) === "object") return [
            autoSize.minRows,
            autoSize.maxRows
        ];
        return [];
    }, [
        autoSize
    ]), _React$useMemo2 = (0, $eUqlC.default)(_React$useMemo, 2), minRows = _React$useMemo2[0], maxRows = _React$useMemo2[1];
    var needAutoSize = !!autoSize;
    // =============================== Scroll ===============================
    // https://github.com/ant-design/ant-design/issues/21870
    var fixFirefoxAutoScroll = function fixFirefoxAutoScroll() {
        try {
            // FF has bug with jump of scroll to top. We force back here.
            if (document.activeElement === textareaRef.current) {
                var _textareaRef$current = textareaRef.current, selectionStart = _textareaRef$current.selectionStart, selectionEnd = _textareaRef$current.selectionEnd, scrollTop = _textareaRef$current.scrollTop;
                // Fix Safari bug which not rollback when break line
                // This makes Chinese IME can't input. Do not fix this
                // const { value: tmpValue } = textareaRef.current;
                // textareaRef.current.value = '';
                // textareaRef.current.value = tmpValue;
                textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
                textareaRef.current.scrollTop = scrollTop;
            }
        } catch (e) {
        // Fix error in Chrome:
        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
        // http://stackoverflow.com/q/21177489/3040605
        }
    };
    // =============================== Resize ===============================
    var _React$useState = $acw62.useState($30d6639cbca42aae$var$RESIZE_STABLE), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), resizeState = _React$useState2[0], setResizeState = _React$useState2[1];
    var _React$useState3 = $acw62.useState(), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), autoSizeStyle = _React$useState4[0], setAutoSizeStyle = _React$useState4[1];
    var startResize = function startResize() {
        setResizeState($30d6639cbca42aae$var$RESIZE_START);
    };
    // Change to trigger resize measure
    (0, $6hDTM.default)(function() {
        if (needAutoSize) startResize();
    }, [
        value,
        minRows,
        maxRows,
        needAutoSize
    ]);
    (0, $6hDTM.default)(function() {
        if (resizeState === $30d6639cbca42aae$var$RESIZE_START) setResizeState($30d6639cbca42aae$var$RESIZE_MEASURING);
        else if (resizeState === $30d6639cbca42aae$var$RESIZE_MEASURING) {
            var textareaStyles = (0, $jycHX.default)(textareaRef.current, false, minRows, maxRows);
            // Safari has bug that text will keep break line on text cut when it's prev is break line.
            // ZombieJ: This not often happen. So we just skip it.
            // const { selectionStart, selectionEnd, scrollTop } = textareaRef.current;
            // const { value: tmpValue } = textareaRef.current;
            // textareaRef.current.value = '';
            // textareaRef.current.value = tmpValue;
            // if (document.activeElement === textareaRef.current) {
            //   textareaRef.current.scrollTop = scrollTop;
            //   textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
            // }
            setResizeState($30d6639cbca42aae$var$RESIZE_STABLE);
            setAutoSizeStyle(textareaStyles);
        } else fixFirefoxAutoScroll();
    }, [
        resizeState
    ]);
    // We lock resize trigger by raf to avoid Safari warning
    var resizeRafRef = $acw62.useRef();
    var cleanRaf = function cleanRaf() {
        (0, $dTiBu.default).cancel(resizeRafRef.current);
    };
    var onInternalResize = function onInternalResize(size) {
        if (resizeState === $30d6639cbca42aae$var$RESIZE_STABLE) {
            onResize === null || onResize === void 0 || onResize(size);
            if (autoSize) {
                cleanRaf();
                resizeRafRef.current = (0, $dTiBu.default)(function() {
                    startResize();
                });
            }
        }
    };
    $acw62.useEffect(function() {
        return cleanRaf;
    }, []);
    // =============================== Render ===============================
    var mergedAutoSizeStyle = needAutoSize ? autoSizeStyle : null;
    var mergedStyle = (0, $d49SP.default)((0, $d49SP.default)({}, style), mergedAutoSizeStyle);
    if (resizeState === $30d6639cbca42aae$var$RESIZE_START || resizeState === $30d6639cbca42aae$var$RESIZE_MEASURING) {
        mergedStyle.overflowY = "hidden";
        mergedStyle.overflowX = "hidden";
    }
    return /*#__PURE__*/ $acw62.createElement((0, $bVxlN.default), {
        onResize: onInternalResize,
        disabled: !(autoSize || onResize)
    }, /*#__PURE__*/ $acw62.createElement("textarea", (0, $8nd05.default)({}, restProps, {
        ref: textareaRef,
        style: mergedStyle,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, className, (0, $kSlfw.default)({}, "".concat(prefixCls, "-disabled"), disabled)),
        disabled: disabled,
        value: mergedValue,
        onChange: onInternalChange
    })));
});
var $30d6639cbca42aae$export$2e2bcd8739ae039 = $30d6639cbca42aae$var$ResizableTextArea;

});
parcelRegister("jycHX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3bb0cd99ab7a8bc$export$2e2bcd8739ae039);
// Thanks to https://github.com/andreypopp/react-textarea-autosize/
/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */ var $e3bb0cd99ab7a8bc$var$HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important;\n  pointer-events: none !important;\n";
var $e3bb0cd99ab7a8bc$var$SIZING_STYLE = [
    "letter-spacing",
    "line-height",
    "padding-top",
    "padding-bottom",
    "font-family",
    "font-weight",
    "font-size",
    "font-variant",
    "text-rendering",
    "text-transform",
    "width",
    "text-indent",
    "padding-left",
    "padding-right",
    "border-width",
    "box-sizing",
    "word-break",
    "white-space"
];
var $e3bb0cd99ab7a8bc$var$computedStyleCache = {};
var $e3bb0cd99ab7a8bc$var$hiddenTextarea;
function $e3bb0cd99ab7a8bc$export$1a56dc6a39385a18(node) {
    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var nodeRef = node.getAttribute("id") || node.getAttribute("data-reactid") || node.getAttribute("name");
    if (useCache && $e3bb0cd99ab7a8bc$var$computedStyleCache[nodeRef]) return $e3bb0cd99ab7a8bc$var$computedStyleCache[nodeRef];
    var style = window.getComputedStyle(node);
    var boxSizing = style.getPropertyValue("box-sizing") || style.getPropertyValue("-moz-box-sizing") || style.getPropertyValue("-webkit-box-sizing");
    var paddingSize = parseFloat(style.getPropertyValue("padding-bottom")) + parseFloat(style.getPropertyValue("padding-top"));
    var borderSize = parseFloat(style.getPropertyValue("border-bottom-width")) + parseFloat(style.getPropertyValue("border-top-width"));
    var sizingStyle = $e3bb0cd99ab7a8bc$var$SIZING_STYLE.map(function(name) {
        return "".concat(name, ":").concat(style.getPropertyValue(name));
    }).join(";");
    var nodeInfo = {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize,
        boxSizing: boxSizing
    };
    if (useCache && nodeRef) $e3bb0cd99ab7a8bc$var$computedStyleCache[nodeRef] = nodeInfo;
    return nodeInfo;
}
function $e3bb0cd99ab7a8bc$export$2e2bcd8739ae039(uiTextNode) {
    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    if (!$e3bb0cd99ab7a8bc$var$hiddenTextarea) {
        $e3bb0cd99ab7a8bc$var$hiddenTextarea = document.createElement("textarea");
        $e3bb0cd99ab7a8bc$var$hiddenTextarea.setAttribute("tab-index", "-1");
        $e3bb0cd99ab7a8bc$var$hiddenTextarea.setAttribute("aria-hidden", "true");
        document.body.appendChild($e3bb0cd99ab7a8bc$var$hiddenTextarea);
    }
    // Fix wrap="off" issue
    // https://github.com/ant-design/ant-design/issues/6577
    if (uiTextNode.getAttribute("wrap")) $e3bb0cd99ab7a8bc$var$hiddenTextarea.setAttribute("wrap", uiTextNode.getAttribute("wrap"));
    else $e3bb0cd99ab7a8bc$var$hiddenTextarea.removeAttribute("wrap");
    // Copy all CSS properties that have an impact on the height of the content in
    // the textbox
    var _calculateNodeStyling = $e3bb0cd99ab7a8bc$export$1a56dc6a39385a18(uiTextNode, useCache), paddingSize = _calculateNodeStyling.paddingSize, borderSize = _calculateNodeStyling.borderSize, boxSizing = _calculateNodeStyling.boxSizing, sizingStyle = _calculateNodeStyling.sizingStyle;
    // Need to have the overflow attribute to hide the scrollbar otherwise
    // text-lines will not calculated properly as the shadow will technically be
    // narrower for content
    $e3bb0cd99ab7a8bc$var$hiddenTextarea.setAttribute("style", "".concat(sizingStyle, ";").concat($e3bb0cd99ab7a8bc$var$HIDDEN_TEXTAREA_STYLE));
    $e3bb0cd99ab7a8bc$var$hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || "";
    var minHeight = undefined;
    var maxHeight = undefined;
    var overflowY;
    var height = $e3bb0cd99ab7a8bc$var$hiddenTextarea.scrollHeight;
    if (boxSizing === "border-box") // border-box: add border, since height = content + padding + border
    height += borderSize;
    else if (boxSizing === "content-box") // remove padding, since height = content
    height -= paddingSize;
    if (minRows !== null || maxRows !== null) {
        // measure height of a textarea with a single row
        $e3bb0cd99ab7a8bc$var$hiddenTextarea.value = " ";
        var singleRowHeight = $e3bb0cd99ab7a8bc$var$hiddenTextarea.scrollHeight - paddingSize;
        if (minRows !== null) {
            minHeight = singleRowHeight * minRows;
            if (boxSizing === "border-box") minHeight = minHeight + paddingSize + borderSize;
            height = Math.max(minHeight, height);
        }
        if (maxRows !== null) {
            maxHeight = singleRowHeight * maxRows;
            if (boxSizing === "border-box") maxHeight = maxHeight + paddingSize + borderSize;
            overflowY = height > maxHeight ? "" : "hidden";
            height = Math.min(maxHeight, height);
        }
    }
    var style = {
        height: height,
        overflowY: overflowY,
        resize: "none"
    };
    if (minHeight) style.minHeight = minHeight;
    if (maxHeight) style.maxHeight = maxHeight;
    return style;
}

});






parcelRegister("3liF5", function(module, exports) {

$parcel$export(module.exports, "default", () => $26f1cf19d4dd7058$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $1pcHX = parcelRequire("1pcHX");

var $80Dm5 = parcelRequire("80Dm5");

var $4a1I5 = parcelRequire("4a1I5");

parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $l1DVE = parcelRequire("l1DVE");
"use client";
var $26f1cf19d4dd7058$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $26f1cf19d4dd7058$var$SpinSizes = [
    "small",
    "default",
    "large"
];
// Render indicator
let $26f1cf19d4dd7058$var$defaultIndicator = null;
function $26f1cf19d4dd7058$var$renderIndicator(prefixCls, props) {
    const { indicator: indicator } = props;
    const dotClassName = `${prefixCls}-dot`;
    // should not be render default indicator when indicator value is null
    if (indicator === null) return null;
    if ((0, $4a1I5.isValidElement)(indicator)) return (0, $4a1I5.cloneElement)(indicator, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(indicator.props.className, dotClassName)
    });
    if ((0, $4a1I5.isValidElement)($26f1cf19d4dd7058$var$defaultIndicator)) return (0, $4a1I5.cloneElement)($26f1cf19d4dd7058$var$defaultIndicator, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))($26f1cf19d4dd7058$var$defaultIndicator.props.className, dotClassName)
    });
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(dotClassName, `${prefixCls}-dot-spin`)
    }, /*#__PURE__*/ $acw62.createElement("i", {
        className: `${prefixCls}-dot-item`,
        key: 1
    }), /*#__PURE__*/ $acw62.createElement("i", {
        className: `${prefixCls}-dot-item`,
        key: 2
    }), /*#__PURE__*/ $acw62.createElement("i", {
        className: `${prefixCls}-dot-item`,
        key: 3
    }), /*#__PURE__*/ $acw62.createElement("i", {
        className: `${prefixCls}-dot-item`,
        key: 4
    }));
}
function $26f1cf19d4dd7058$var$shouldDelay(spinning, delay) {
    return !!spinning && !!delay && !isNaN(Number(delay));
}
const $26f1cf19d4dd7058$var$Spin = (props)=>{
    const { spinPrefixCls: prefixCls, spinning: customSpinning = true, delay: delay = 0, className: className, rootClassName: rootClassName, size: size = "default", tip: tip, wrapperClassName: wrapperClassName, style: style, children: children, hashId: hashId, fullscreen: fullscreen } = props, restProps = $26f1cf19d4dd7058$var$__rest(props, [
        "spinPrefixCls",
        "spinning",
        "delay",
        "className",
        "rootClassName",
        "size",
        "tip",
        "wrapperClassName",
        "style",
        "children",
        "hashId",
        "fullscreen"
    ]);
    const [spinning, setSpinning] = $acw62.useState(()=>customSpinning && !$26f1cf19d4dd7058$var$shouldDelay(customSpinning, delay));
    $acw62.useEffect(()=>{
        if (customSpinning) {
            const showSpinning = (0, $80Dm5.debounce)(delay, ()=>{
                setSpinning(true);
            });
            showSpinning();
            return ()=>{
                var _a;
                (_a = showSpinning === null || showSpinning === void 0 ? void 0 : showSpinning.cancel) === null || _a === void 0 || _a.call(showSpinning);
            };
        }
        setSpinning(false);
    }, [
        delay,
        customSpinning
    ]);
    const isNestedPattern = $acw62.useMemo(()=>typeof children !== "undefined" && !fullscreen, [
        children,
        fullscreen
    ]);
    const { direction: direction, spin: spin } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const spinClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, spin === null || spin === void 0 ? void 0 : spin.className, {
        [`${prefixCls}-sm`]: size === "small",
        [`${prefixCls}-lg`]: size === "large",
        [`${prefixCls}-spinning`]: spinning,
        [`${prefixCls}-show-text`]: !!tip,
        [`${prefixCls}-fullscreen`]: fullscreen,
        [`${prefixCls}-fullscreen-show`]: fullscreen && spinning,
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, className, rootClassName, hashId);
    const containerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(`${prefixCls}-container`, {
        [`${prefixCls}-blur`]: spinning
    });
    // fix https://fb.me/react-unknown-prop
    const divProps = (0, $1pcHX.default)(restProps, [
        "indicator",
        "prefixCls"
    ]);
    const mergedStyle = Object.assign(Object.assign({}, spin === null || spin === void 0 ? void 0 : spin.style), style);
    const spinElement = /*#__PURE__*/ $acw62.createElement("div", Object.assign({}, divProps, {
        style: mergedStyle,
        className: spinClassName,
        "aria-live": "polite",
        "aria-busy": spinning
    }), $26f1cf19d4dd7058$var$renderIndicator(prefixCls, props), tip && (isNestedPattern || fullscreen) ? /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-text`
    }, tip) : null);
    if (isNestedPattern) return /*#__PURE__*/ $acw62.createElement("div", Object.assign({}, divProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(`${prefixCls}-nested-loading`, wrapperClassName, hashId)
    }), spinning && /*#__PURE__*/ $acw62.createElement("div", {
        key: "loading"
    }, spinElement), /*#__PURE__*/ $acw62.createElement("div", {
        className: containerClassName,
        key: "container"
    }, children));
    return spinElement;
};
const $26f1cf19d4dd7058$var$SpinFC = (props)=>{
    const { prefixCls: customizePrefixCls } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const spinPrefixCls = getPrefixCls("spin", customizePrefixCls);
    const [wrapCSSVar, hashId] = (0, $l1DVE.default)(spinPrefixCls);
    const spinClassProps = Object.assign(Object.assign({}, props), {
        spinPrefixCls: spinPrefixCls,
        hashId: hashId
    });
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement($26f1cf19d4dd7058$var$Spin, Object.assign({}, spinClassProps)));
};
$26f1cf19d4dd7058$var$SpinFC.setDefaultIndicator = (indicator)=>{
    $26f1cf19d4dd7058$var$defaultIndicator = indicator;
};
var $26f1cf19d4dd7058$export$2e2bcd8739ae039 = $26f1cf19d4dd7058$var$SpinFC;

});
parcelRegister("80Dm5", function(module, exports) {

$parcel$export(module.exports, "debounce", () => $5d4cd9f8bc92bd41$export$61fc7d43ac8f84b0);
/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */ function $5d4cd9f8bc92bd41$export$de363e709c412c8a(delay, callback, options) {
    var _ref = options || {}, _ref$noTrailing = _ref.noTrailing, noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing, _ref$noLeading = _ref.noLeading, noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading, _ref$debounceMode = _ref.debounceMode, debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false; // Keep track of the last time `callback` was executed.
    var lastExec = 0; // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    } // Function to cancel next exec
    function cancel(options) {
        var _ref2 = options || {}, _ref2$upcomingOnly = _ref2.upcomingOnly, upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;
        clearExistingTimeout();
        cancelled = !upcomingOnly;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
        var self = this;
        var elapsed = Date.now() - lastExec;
        if (cancelled) return;
         // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, arguments_);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (!noLeading && debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) {
            if (noLeading) {
                /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */ lastExec = Date.now();
                if (!noTrailing) timeoutID = setTimeout(debounceMode ? clear : exec, delay);
            } else /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */ exec();
        } else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel; // Return the wrapper function.
    return wrapper;
}
/* eslint-disable no-undefined */ /**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                        to `callback` when the debounced-function is executed.
 * @param {object} [options] -           An object to configure options.
 * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 *
 * @returns {Function} A new, debounced function.
 */ function $5d4cd9f8bc92bd41$export$61fc7d43ac8f84b0(delay, callback, options) {
    var _ref = options || {}, _ref$atBegin = _ref.atBegin, atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;
    return $5d4cd9f8bc92bd41$export$de363e709c412c8a(delay, callback, {
        debounceMode: atBegin !== false
    });
}

});

parcelRegister("l1DVE", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4e8aa06f042a155$export$2e2bcd8739ae039);
parcelRequire("3i86m");
var $hsEk2 = parcelRequire("hsEk2");

var $670jt = parcelRequire("670jt");

var $P8Drj = parcelRequire("P8Drj");
var $2LRCS = parcelRequire("2LRCS");
const $f4e8aa06f042a155$var$antSpinMove = new (0, $hsEk2.default)("antSpinMove", {
    to: {
        opacity: 1
    }
});
const $f4e8aa06f042a155$var$antRotate = new (0, $hsEk2.default)("antRotate", {
    to: {
        transform: "rotate(405deg)"
    }
});
const $f4e8aa06f042a155$var$genSpinStyle = (token)=>{
    const { componentCls: componentCls, calc: calc } = token;
    return {
        [`${componentCls}`]: Object.assign(Object.assign({}, (0, $670jt.resetComponent)(token)), {
            position: "absolute",
            display: "none",
            color: token.colorPrimary,
            fontSize: 0,
            textAlign: "center",
            verticalAlign: "middle",
            opacity: 0,
            transition: `transform ${token.motionDurationSlow} ${token.motionEaseInOutCirc}`,
            "&-spinning": {
                position: "static",
                display: "inline-block",
                opacity: 1
            },
            [`${componentCls}-text`]: {
                fontSize: token.fontSize,
                paddingTop: calc(calc(token.dotSize).sub(token.fontSize)).div(2).add(2).equal()
            },
            "&-fullscreen": {
                position: "fixed",
                width: "100vw",
                height: "100vh",
                backgroundColor: token.colorBgMask,
                zIndex: token.zIndexPopupBase,
                inset: 0,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center",
                opacity: 0,
                visibility: "hidden",
                transition: `all ${token.motionDurationMid}`,
                "&-show": {
                    opacity: 1,
                    visibility: "visible"
                },
                [`${componentCls}-dot ${componentCls}-dot-item`]: {
                    backgroundColor: token.colorWhite
                },
                [`${componentCls}-text`]: {
                    color: token.colorTextLightSolid
                }
            },
            "&-nested-loading": {
                position: "relative",
                [`> div > ${componentCls}`]: {
                    position: "absolute",
                    top: 0,
                    insetInlineStart: 0,
                    zIndex: 4,
                    display: "block",
                    width: "100%",
                    height: "100%",
                    maxHeight: token.contentHeight,
                    [`${componentCls}-dot`]: {
                        position: "absolute",
                        top: "50%",
                        insetInlineStart: "50%",
                        margin: calc(token.dotSize).mul(-1).div(2).equal()
                    },
                    [`${componentCls}-text`]: {
                        position: "absolute",
                        top: "50%",
                        width: "100%",
                        textShadow: `0 1px 2px ${token.colorBgContainer}` // FIXME: shadow
                    },
                    [`&${componentCls}-show-text ${componentCls}-dot`]: {
                        marginTop: calc(token.dotSize).div(2).mul(-1).sub(10).equal()
                    },
                    "&-sm": {
                        [`${componentCls}-dot`]: {
                            margin: calc(token.dotSizeSM).mul(-1).div(2).equal()
                        },
                        [`${componentCls}-text`]: {
                            paddingTop: calc(calc(token.dotSizeSM).sub(token.fontSize)).div(2).add(2).equal()
                        },
                        [`&${componentCls}-show-text ${componentCls}-dot`]: {
                            marginTop: calc(token.dotSizeSM).div(2).mul(-1).sub(10).equal()
                        }
                    },
                    "&-lg": {
                        [`${componentCls}-dot`]: {
                            margin: calc(token.dotSizeLG).mul(-1).div(2).equal()
                        },
                        [`${componentCls}-text`]: {
                            paddingTop: calc(calc(token.dotSizeLG).sub(token.fontSize)).div(2).add(2).equal()
                        },
                        [`&${componentCls}-show-text ${componentCls}-dot`]: {
                            marginTop: calc(token.dotSizeLG).div(2).mul(-1).sub(10).equal()
                        }
                    }
                },
                [`${componentCls}-container`]: {
                    position: "relative",
                    transition: `opacity ${token.motionDurationSlow}`,
                    "&::after": {
                        position: "absolute",
                        top: 0,
                        insetInlineEnd: 0,
                        bottom: 0,
                        insetInlineStart: 0,
                        zIndex: 10,
                        width: "100%",
                        height: "100%",
                        background: token.colorBgContainer,
                        opacity: 0,
                        transition: `all ${token.motionDurationSlow}`,
                        content: '""',
                        pointerEvents: "none"
                    }
                },
                [`${componentCls}-blur`]: {
                    clear: "both",
                    opacity: 0.5,
                    userSelect: "none",
                    pointerEvents: "none",
                    [`&::after`]: {
                        opacity: 0.4,
                        pointerEvents: "auto"
                    }
                }
            },
            // tip
            // ------------------------------
            [`&-tip`]: {
                color: token.spinDotDefault
            },
            // dots
            // ------------------------------
            [`${componentCls}-dot`]: {
                position: "relative",
                display: "inline-block",
                fontSize: token.dotSize,
                width: "1em",
                height: "1em",
                "&-item": {
                    position: "absolute",
                    display: "block",
                    width: calc(token.dotSize).sub(calc(token.marginXXS).div(2)).div(2).equal(),
                    height: calc(token.dotSize).sub(calc(token.marginXXS).div(2)).div(2).equal(),
                    backgroundColor: token.colorPrimary,
                    borderRadius: "100%",
                    transform: "scale(0.75)",
                    transformOrigin: "50% 50%",
                    opacity: 0.3,
                    animationName: $f4e8aa06f042a155$var$antSpinMove,
                    animationDuration: "1s",
                    animationIterationCount: "infinite",
                    animationTimingFunction: "linear",
                    animationDirection: "alternate",
                    "&:nth-child(1)": {
                        top: 0,
                        insetInlineStart: 0,
                        animationDelay: "0s"
                    },
                    "&:nth-child(2)": {
                        top: 0,
                        insetInlineEnd: 0,
                        animationDelay: "0.4s"
                    },
                    "&:nth-child(3)": {
                        insetInlineEnd: 0,
                        bottom: 0,
                        animationDelay: "0.8s"
                    },
                    "&:nth-child(4)": {
                        bottom: 0,
                        insetInlineStart: 0,
                        animationDelay: "1.2s"
                    }
                },
                "&-spin": {
                    transform: "rotate(45deg)",
                    animationName: $f4e8aa06f042a155$var$antRotate,
                    animationDuration: "1.2s",
                    animationIterationCount: "infinite",
                    animationTimingFunction: "linear"
                }
            },
            // small
            [`&-sm ${componentCls}-dot`]: {
                fontSize: token.dotSizeSM,
                i: {
                    width: calc(calc(token.dotSizeSM).sub(calc(token.marginXXS).div(2))).div(2).equal(),
                    height: calc(calc(token.dotSizeSM).sub(calc(token.marginXXS).div(2))).div(2).equal()
                }
            },
            // large
            [`&-lg ${componentCls}-dot`]: {
                fontSize: token.dotSizeLG,
                i: {
                    width: calc(calc(token.dotSizeLG).sub(token.marginXXS)).div(2).equal(),
                    height: calc(calc(token.dotSizeLG).sub(token.marginXXS)).div(2).equal()
                }
            },
            [`&${componentCls}-show-text ${componentCls}-text`]: {
                display: "block"
            }
        })
    };
};
const $f4e8aa06f042a155$export$9ca1be8807fe0675 = (token)=>{
    const { controlHeightLG: controlHeightLG, controlHeight: controlHeight } = token;
    return {
        contentHeight: 400,
        dotSize: controlHeightLG / 2,
        dotSizeSM: controlHeightLG * 0.35,
        dotSizeLG: controlHeight
    };
};
var // ============================== Export ==============================
$f4e8aa06f042a155$export$2e2bcd8739ae039 = (0, $P8Drj.genStyleHooks)("Spin", (token)=>{
    const spinToken = (0, $2LRCS.merge)(token, {
        spinDotDefault: token.colorTextDescription
    });
    return [
        $f4e8aa06f042a155$var$genSpinStyle(spinToken)
    ];
}, $f4e8aa06f042a155$export$9ca1be8807fe0675);

});


parcelRegister("cwPDC", function(module, exports) {

$parcel$export(module.exports, "default", () => $91f0876852f6510f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $AWXcC = parcelRequire("AWXcC");

var $8g1PZ = parcelRequire("8g1PZ");

var $1Oc38 = parcelRequire("1Oc38");

var $cwFcq = parcelRequire("cwFcq");


var $4NqjK = parcelRequire("4NqjK");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $bU1KL = parcelRequire("bU1KL");

var $ggJkR = parcelRequire("ggJkR");

var $1zQv5 = parcelRequire("1zQv5");

var $1vCAt = parcelRequire("1vCAt");
"use client";
var $91f0876852f6510f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $91f0876852f6510f$var$InternalTag = (tagProps, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, children: children, icon: icon, color: color, onClose: onClose, closeIcon: closeIcon, closable: closable, bordered: bordered = true } = tagProps, props = $91f0876852f6510f$var$__rest(tagProps, [
        "prefixCls",
        "className",
        "rootClassName",
        "style",
        "children",
        "icon",
        "color",
        "onClose",
        "closeIcon",
        "closable",
        "bordered"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, tag: tag } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const [visible, setVisible] = $acw62.useState(true);
    $acw62.useEffect(()=>{
        if ("visible" in props) setVisible(props.visible);
    }, [
        props.visible
    ]);
    const isPreset = (0, $1Oc38.isPresetColor)(color);
    const isStatus = (0, $1Oc38.isPresetStatusColor)(color);
    const isInternalColor = isPreset || isStatus;
    const tagStyle = Object.assign(Object.assign({
        backgroundColor: color && !isInternalColor ? color : undefined
    }, tag === null || tag === void 0 ? void 0 : tag.style), style);
    const prefixCls = getPrefixCls("tag", customizePrefixCls);
    const [wrapCSSVar, hashId] = (0, $ggJkR.default)(prefixCls);
    // Style
    const tagClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, tag === null || tag === void 0 ? void 0 : tag.className, {
        [`${prefixCls}-${color}`]: isInternalColor,
        [`${prefixCls}-has-color`]: color && !isInternalColor,
        [`${prefixCls}-hidden`]: !visible,
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-borderless`]: !bordered
    }, className, rootClassName, hashId);
    const handleCloseClick = (e)=>{
        e.stopPropagation();
        onClose === null || onClose === void 0 || onClose(e);
        if (e.defaultPrevented) return;
        setVisible(false);
    };
    const [, mergedCloseIcon] = (0, $cwFcq.default)(closable, closeIcon, (iconNode)=>iconNode === null ? /*#__PURE__*/ $acw62.createElement((0, $AWXcC.default), {
            className: `${prefixCls}-close-icon`,
            onClick: handleCloseClick
        }) : /*#__PURE__*/ $acw62.createElement("span", {
            className: `${prefixCls}-close-icon`,
            onClick: handleCloseClick
        }, iconNode), null, false);
    const isNeedWave = typeof props.onClick === "function" || children && children.type === "a";
    const iconNode = icon || null;
    const kids = iconNode ? /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, iconNode, children && /*#__PURE__*/ $acw62.createElement("span", null, children)) : children;
    const tagNode = /*#__PURE__*/ $acw62.createElement("span", Object.assign({}, props, {
        ref: ref,
        className: tagClassName,
        style: tagStyle
    }), kids, mergedCloseIcon, isPreset && /*#__PURE__*/ $acw62.createElement((0, $1zQv5.default), {
        key: "preset",
        prefixCls: prefixCls
    }), isStatus && /*#__PURE__*/ $acw62.createElement((0, $1vCAt.default), {
        key: "status",
        prefixCls: prefixCls
    }));
    return wrapCSSVar(isNeedWave ? /*#__PURE__*/ $acw62.createElement((0, $4NqjK.default), {
        component: "Tag"
    }, tagNode) : tagNode);
};
const $91f0876852f6510f$var$Tag = /*#__PURE__*/ $acw62.forwardRef($91f0876852f6510f$var$InternalTag);
$91f0876852f6510f$var$Tag.CheckableTag = (0, $bU1KL.default);
var $91f0876852f6510f$export$2e2bcd8739ae039 = $91f0876852f6510f$var$Tag;

});
parcelRegister("1Oc38", function(module, exports) {

$parcel$export(module.exports, "isPresetColor", () => $1513ceb924eda9b6$export$ee62ebd6a58c4884);
$parcel$export(module.exports, "isPresetStatusColor", () => $1513ceb924eda9b6$export$88a0ba1f7d1ea40e);

var $kbxxf = parcelRequire("kbxxf");

var $bZMQK = parcelRequire("bZMQK");
const $1513ceb924eda9b6$var$inverseColors = (0, $bZMQK.PresetColors).map((color)=>`${color}-inverse`);
const $1513ceb924eda9b6$export$bb684163c94c55ae = [
    "success",
    "processing",
    "error",
    "default",
    "warning"
];
function $1513ceb924eda9b6$export$ee62ebd6a58c4884(color) {
    let includeInverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (includeInverse) return [].concat((0, $kbxxf.default)($1513ceb924eda9b6$var$inverseColors), (0, $kbxxf.default)((0, $bZMQK.PresetColors))).includes(color);
    return (0, $bZMQK.PresetColors).includes(color);
}
function $1513ceb924eda9b6$export$88a0ba1f7d1ea40e(color) {
    return $1513ceb924eda9b6$export$bb684163c94c55ae.includes(color);
}

});
parcelRegister("bZMQK", function(module, exports) {

$parcel$export(module.exports, "PresetColors", () => $8bbb48c728db3fab$export$6d4fe3a00a1811ad);
const $8bbb48c728db3fab$export$6d4fe3a00a1811ad = [
    "blue",
    "purple",
    "cyan",
    "green",
    "magenta",
    "pink",
    "red",
    "orange",
    "yellow",
    "volcano",
    "geekblue",
    "lime",
    "gold"
];

});


parcelRegister("cwFcq", function(module, exports) {

$parcel$export(module.exports, "default", () => $91e86e8e8e97dd3f$export$2e2bcd8739ae039);

var $AWXcC = parcelRequire("AWXcC");

var $acw62 = parcelRequire("acw62");
"use client";
function $91e86e8e8e97dd3f$var$useInnerClosable(closable, closeIcon, defaultClosable) {
    if (typeof closable === "boolean") return closable;
    if (closeIcon === undefined) return !!defaultClosable;
    return closeIcon !== false && closeIcon !== null;
}
function $91e86e8e8e97dd3f$export$2e2bcd8739ae039(closable, closeIcon, customCloseIconRender) {
    let defaultCloseIcon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $AWXcC.default), null);
    let defaultClosable = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    const mergedClosable = $91e86e8e8e97dd3f$var$useInnerClosable(closable, closeIcon, defaultClosable);
    if (!mergedClosable) return [
        false,
        null
    ];
    const mergedCloseIcon = typeof closeIcon === "boolean" || closeIcon === undefined || closeIcon === null ? defaultCloseIcon : closeIcon;
    return [
        true,
        customCloseIconRender ? customCloseIconRender(mergedCloseIcon) : mergedCloseIcon
    ];
}

});

parcelRegister("bU1KL", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aa648d8fa6484b7$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $ggJkR = parcelRequire("ggJkR");
"use client";
var $8aa648d8fa6484b7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $8aa648d8fa6484b7$var$CheckableTag = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, style: style, className: className, checked: checked, onChange: onChange, onClick: onClick } = props, restProps = $8aa648d8fa6484b7$var$__rest(props, [
        "prefixCls",
        "style",
        "className",
        "checked",
        "onChange",
        "onClick"
    ]);
    const { getPrefixCls: getPrefixCls, tag: tag } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const handleClick = (e)=>{
        onChange === null || onChange === void 0 || onChange(!checked);
        onClick === null || onClick === void 0 || onClick(e);
    };
    const prefixCls = getPrefixCls("tag", customizePrefixCls);
    // Style
    const [wrapCSSVar, hashId] = (0, $ggJkR.default)(prefixCls);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, `${prefixCls}-checkable`, {
        [`${prefixCls}-checkable-checked`]: checked
    }, tag === null || tag === void 0 ? void 0 : tag.className, className, hashId);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("span", Object.assign({}, restProps, {
        ref: ref,
        style: Object.assign(Object.assign({}, style), tag === null || tag === void 0 ? void 0 : tag.style),
        className: cls,
        onClick: handleClick
    })));
});
var $8aa648d8fa6484b7$export$2e2bcd8739ae039 = $8aa648d8fa6484b7$var$CheckableTag;

});
parcelRegister("ggJkR", function(module, exports) {

$parcel$export(module.exports, "prepareToken", () => $bd814ea00a1f65a8$export$362fb92a8f81bbf9);
$parcel$export(module.exports, "prepareComponentToken", () => $bd814ea00a1f65a8$export$9ca1be8807fe0675);
$parcel$export(module.exports, "default", () => $bd814ea00a1f65a8$export$2e2bcd8739ae039);
parcelRequire("3i86m");
var $lpQ06 = parcelRequire("lpQ06");

var $9nbKF = parcelRequire("9nbKF");

var $670jt = parcelRequire("670jt");

var $P8Drj = parcelRequire("P8Drj");
var $2LRCS = parcelRequire("2LRCS");
// ============================== Styles ==============================
const $bd814ea00a1f65a8$var$genBaseStyle = (token)=>{
    const { paddingXXS: paddingXXS, lineWidth: lineWidth, tagPaddingHorizontal: tagPaddingHorizontal, componentCls: componentCls, calc: calc } = token;
    const paddingInline = calc(tagPaddingHorizontal).sub(lineWidth).equal();
    const iconMarginInline = calc(paddingXXS).sub(lineWidth).equal();
    return {
        // Result
        [componentCls]: Object.assign(Object.assign({}, (0, $670jt.resetComponent)(token)), {
            display: "inline-block",
            height: "auto",
            marginInlineEnd: token.marginXS,
            paddingInline: paddingInline,
            fontSize: token.tagFontSize,
            lineHeight: token.tagLineHeight,
            whiteSpace: "nowrap",
            background: token.defaultBg,
            border: `${(0, $lpQ06.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
            borderRadius: token.borderRadiusSM,
            opacity: 1,
            transition: `all ${token.motionDurationMid}`,
            textAlign: "start",
            position: "relative",
            // RTL
            [`&${componentCls}-rtl`]: {
                direction: "rtl"
            },
            "&, a, a:hover": {
                color: token.defaultColor
            },
            [`${componentCls}-close-icon`]: {
                marginInlineStart: iconMarginInline,
                fontSize: token.tagIconSize,
                color: token.colorTextDescription,
                cursor: "pointer",
                transition: `all ${token.motionDurationMid}`,
                "&:hover": {
                    color: token.colorTextHeading
                }
            },
            [`&${componentCls}-has-color`]: {
                borderColor: "transparent",
                [`&, a, a:hover, ${token.iconCls}-close, ${token.iconCls}-close:hover`]: {
                    color: token.colorTextLightSolid
                }
            },
            [`&-checkable`]: {
                backgroundColor: "transparent",
                borderColor: "transparent",
                cursor: "pointer",
                [`&:not(${componentCls}-checkable-checked):hover`]: {
                    color: token.colorPrimary,
                    backgroundColor: token.colorFillSecondary
                },
                "&:active, &-checked": {
                    color: token.colorTextLightSolid
                },
                "&-checked": {
                    backgroundColor: token.colorPrimary,
                    "&:hover": {
                        backgroundColor: token.colorPrimaryHover
                    }
                },
                "&:active": {
                    backgroundColor: token.colorPrimaryActive
                }
            },
            [`&-hidden`]: {
                display: "none"
            },
            // To ensure that a space will be placed between character and `Icon`.
            [`> ${token.iconCls} + span, > span + ${token.iconCls}`]: {
                marginInlineStart: paddingInline
            }
        }),
        [`${componentCls}-borderless`]: {
            borderColor: "transparent",
            background: token.tagBorderlessBg
        }
    };
};
const $bd814ea00a1f65a8$export$362fb92a8f81bbf9 = (token)=>{
    const { lineWidth: lineWidth, fontSizeIcon: fontSizeIcon, calc: calc } = token;
    const tagFontSize = token.fontSizeSM;
    const tagToken = (0, $2LRCS.merge)(token, {
        tagFontSize: tagFontSize,
        tagLineHeight: (0, $lpQ06.unit)(calc(token.lineHeightSM).mul(tagFontSize).equal()),
        tagIconSize: calc(fontSizeIcon).sub(calc(lineWidth).mul(2)).equal(),
        // Tag icon is much smaller
        tagPaddingHorizontal: 8,
        // Fixed padding.
        tagBorderlessBg: token.colorFillTertiary
    });
    return tagToken;
};
const $bd814ea00a1f65a8$export$9ca1be8807fe0675 = (token)=>({
        defaultBg: new (0, $9nbKF.TinyColor)(token.colorFillQuaternary).onBackground(token.colorBgContainer).toHexString(),
        defaultColor: token.colorText
    });
var $bd814ea00a1f65a8$export$2e2bcd8739ae039 = (0, $P8Drj.genStyleHooks)("Tag", (token)=>{
    const tagToken = $bd814ea00a1f65a8$export$362fb92a8f81bbf9(token);
    return $bd814ea00a1f65a8$var$genBaseStyle(tagToken);
}, $bd814ea00a1f65a8$export$9ca1be8807fe0675);

});


parcelRegister("1zQv5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1261c8cdaed9abdc$export$2e2bcd8739ae039);
// Style as status component

var $ggJkR = parcelRequire("ggJkR");

var $925hW = parcelRequire("925hW");
var $P8Drj = parcelRequire("P8Drj");
// ============================== Preset ==============================
const $1261c8cdaed9abdc$var$genPresetStyle = (token)=>(0, $925hW.default)(token, (colorKey, _ref)=>{
        let { textColor: textColor, lightBorderColor: lightBorderColor, lightColor: lightColor, darkColor: darkColor } = _ref;
        return {
            [`${token.componentCls}-${colorKey}`]: {
                color: textColor,
                background: lightColor,
                borderColor: lightBorderColor,
                // Inverse color
                "&-inverse": {
                    color: token.colorTextLightSolid,
                    background: darkColor,
                    borderColor: darkColor
                },
                [`&${token.componentCls}-borderless`]: {
                    borderColor: "transparent"
                }
            }
        };
    });
var // ============================== Export ==============================
$1261c8cdaed9abdc$export$2e2bcd8739ae039 = (0, $P8Drj.genSubStyleComponent)([
    "Tag",
    "preset"
], (token)=>{
    const tagToken = (0, $ggJkR.prepareToken)(token);
    return $1261c8cdaed9abdc$var$genPresetStyle(tagToken);
}, (0, $ggJkR.prepareComponentToken));

});
parcelRegister("925hW", function(module, exports) {

$parcel$export(module.exports, "default", () => $69386722b4e8be32$export$2e2bcd8739ae039);

var $bZMQK = parcelRequire("bZMQK");
function $69386722b4e8be32$export$2e2bcd8739ae039(token, genCss) {
    return (0, $bZMQK.PresetColors).reduce((prev, colorKey)=>{
        const lightColor = token[`${colorKey}1`];
        const lightBorderColor = token[`${colorKey}3`];
        const darkColor = token[`${colorKey}6`];
        const textColor = token[`${colorKey}7`];
        return Object.assign(Object.assign({}, prev), genCss(colorKey, {
            lightColor: lightColor,
            lightBorderColor: lightBorderColor,
            darkColor: darkColor,
            textColor: textColor
        }));
    }, {});
}

});


parcelRegister("1vCAt", function(module, exports) {

$parcel$export(module.exports, "default", () => $11969e51a90dd42b$export$2e2bcd8739ae039);

var $ggJkR = parcelRequire("ggJkR");

var $cNDVz = parcelRequire("cNDVz");

var $P8Drj = parcelRequire("P8Drj");
const $11969e51a90dd42b$var$genTagStatusStyle = (token, status, cssVariableType)=>{
    const capitalizedCssVariableType = (0, $cNDVz.default)(cssVariableType);
    return {
        [`${token.componentCls}-${status}`]: {
            color: token[`color${cssVariableType}`],
            background: token[`color${capitalizedCssVariableType}Bg`],
            borderColor: token[`color${capitalizedCssVariableType}Border`],
            [`&${token.componentCls}-borderless`]: {
                borderColor: "transparent"
            }
        }
    };
};
var // ============================== Export ==============================
$11969e51a90dd42b$export$2e2bcd8739ae039 = (0, $P8Drj.genSubStyleComponent)([
    "Tag",
    "status"
], (token)=>{
    const tagToken = (0, $ggJkR.prepareToken)(token);
    return [
        $11969e51a90dd42b$var$genTagStatusStyle(tagToken, "success", "Success"),
        $11969e51a90dd42b$var$genTagStatusStyle(tagToken, "processing", "Info"),
        $11969e51a90dd42b$var$genTagStatusStyle(tagToken, "error", "Error"),
        $11969e51a90dd42b$var$genTagStatusStyle(tagToken, "warning", "Warning")
    ];
}, (0, $ggJkR.prepareComponentToken));

});
parcelRegister("cNDVz", function(module, exports) {

$parcel$export(module.exports, "default", () => $95190870cfa49bfc$export$2e2bcd8739ae039);
function $95190870cfa49bfc$export$2e2bcd8739ae039(str) {
    if (typeof str !== "string") return str;
    const ret = str.charAt(0).toUpperCase() + str.slice(1);
    return ret;
}

});



parcelRegister("VoMtX", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ac88bf86814a6e5$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $hRA8u = parcelRequire("hRA8u");

var $iSQh8 = parcelRequire("iSQh8");

var $brFSt = parcelRequire("brFSt");

var $4257x = parcelRequire("4257x");

var $eBB7Q = parcelRequire("eBB7Q");

var $4a1I5 = parcelRequire("4a1I5");

var $7SSa4 = parcelRequire("7SSa4");

var $3GcAE = parcelRequire("3GcAE");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $3gns8 = parcelRequire("3gns8");

var $hRCaH = parcelRequire("hRCaH");

var $jKniu = parcelRequire("jKniu");

var $c09fQ = parcelRequire("c09fQ");

var $GQ0on = parcelRequire("GQ0on");
"use client";
var $0ac88bf86814a6e5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $0ac88bf86814a6e5$var$Tooltip = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    var _a, _b;
    const { prefixCls: customizePrefixCls, openClassName: openClassName, getTooltipContainer: getTooltipContainer, overlayClassName: overlayClassName, color: color, overlayInnerStyle: overlayInnerStyle, children: children, afterOpenChange: afterOpenChange, afterVisibleChange: afterVisibleChange, destroyTooltipOnHide: destroyTooltipOnHide, arrow: arrow = true, title: title, overlay: overlay, builtinPlacements: builtinPlacements, arrowPointAtCenter: arrowPointAtCenter = false, autoAdjustOverflow: autoAdjustOverflow = true } = props;
    const mergedShowArrow = !!arrow;
    const [, token] = (0, $hRCaH.default)();
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $dRTnM.ConfigContext));
    // ============================== Ref ===============================
    const warning = (0, $7SSa4.devUseWarning)("Tooltip");
    const tooltipRef = $acw62.useRef(null);
    const forceAlign = ()=>{
        var _a;
        (_a = tooltipRef.current) === null || _a === void 0 || _a.forceAlign();
    };
    $acw62.useImperativeHandle(ref, ()=>({
            forceAlign: forceAlign,
            forcePopupAlign: ()=>{
                warning.deprecated(false, "forcePopupAlign", "forceAlign");
                forceAlign();
            }
        }));
    var _ref;
    // ============================== Open ==============================
    const [open, setOpen] = (0, $iSQh8.default)(false, {
        value: (_a = props.open) !== null && _a !== void 0 ? _a : props.visible,
        defaultValue: (_b = props.defaultOpen) !== null && _b !== void 0 ? _b : props.defaultVisible
    });
    const noTitle = !title && !overlay && title !== 0; // overlay for old version compatibility
    const onOpenChange = (vis)=>{
        var _a, _b;
        setOpen(noTitle ? false : vis);
        if (!noTitle) {
            (_a = props.onOpenChange) === null || _a === void 0 || _a.call(props, vis);
            (_b = props.onVisibleChange) === null || _b === void 0 || _b.call(props, vis);
        }
    };
    const tooltipPlacements = $acw62.useMemo(()=>{
        var _a, _b;
        let mergedArrowPointAtCenter = arrowPointAtCenter;
        if (typeof arrow === "object") mergedArrowPointAtCenter = (_b = (_a = arrow.pointAtCenter) !== null && _a !== void 0 ? _a : arrow.arrowPointAtCenter) !== null && _b !== void 0 ? _b : arrowPointAtCenter;
        return builtinPlacements || (0, $eBB7Q.default)({
            arrowPointAtCenter: mergedArrowPointAtCenter,
            autoAdjustOverflow: autoAdjustOverflow,
            arrowWidth: mergedShowArrow ? token.sizePopupArrow : 0,
            borderRadius: token.borderRadius,
            offset: token.marginXXS,
            visibleFirst: true
        });
    }, [
        arrowPointAtCenter,
        arrow,
        builtinPlacements,
        token
    ]);
    const memoOverlay = $acw62.useMemo(()=>{
        if (title === 0) return title;
        return overlay || title || "";
    }, [
        overlay,
        title
    ]);
    const memoOverlayWrapper = /*#__PURE__*/ $acw62.createElement((0, $3gns8.NoCompactStyle), null, typeof memoOverlay === "function" ? memoOverlay() : memoOverlay);
    const { getPopupContainer: getPopupContainer, placement: placement = "top", mouseEnterDelay: mouseEnterDelay = 0.1, mouseLeaveDelay: mouseLeaveDelay = 0.1, overlayStyle: overlayStyle, rootClassName: rootClassName } = props, otherProps = $0ac88bf86814a6e5$var$__rest(props, [
        "getPopupContainer",
        "placement",
        "mouseEnterDelay",
        "mouseLeaveDelay",
        "overlayStyle",
        "rootClassName"
    ]);
    const prefixCls = getPrefixCls("tooltip", customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const injectFromPopover = props["data-popover-inject"];
    let tempOpen = open;
    // Hide tooltip when there is no title
    if (!("open" in props) && !("visible" in props) && noTitle) tempOpen = false;
    // ============================= Render =============================
    const child = (0, $4a1I5.isValidElement)(children) && !(0, $4a1I5.isFragment)(children) ? children : /*#__PURE__*/ $acw62.createElement("span", null, children);
    const childProps = child.props;
    const childCls = !childProps.className || typeof childProps.className === "string" ? (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(childProps.className, openClassName || `${prefixCls}-open`) : childProps.className;
    // Style
    const [wrapCSSVar, hashId] = (0, $c09fQ.default)(prefixCls, !injectFromPopover);
    // Color
    const colorInfo = (0, $GQ0on.parseColor)(prefixCls, color);
    const arrowContentStyle = colorInfo.arrowStyle;
    const formattedOverlayInnerStyle = Object.assign(Object.assign({}, overlayInnerStyle), colorInfo.overlayStyle);
    const customOverlayClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(overlayClassName, {
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, colorInfo.className, rootClassName, hashId);
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, $brFSt.useZIndex)("Tooltip", otherProps.zIndex);
    const content = /*#__PURE__*/ $acw62.createElement((0, $hRA8u.default), Object.assign({}, otherProps, {
        zIndex: zIndex,
        showArrow: mergedShowArrow,
        placement: placement,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        prefixCls: prefixCls,
        overlayClassName: customOverlayClassName,
        overlayStyle: Object.assign(Object.assign({}, arrowContentStyle), overlayStyle),
        getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
        ref: tooltipRef,
        builtinPlacements: tooltipPlacements,
        overlay: memoOverlayWrapper,
        visible: tempOpen,
        onVisibleChange: onOpenChange,
        afterVisibleChange: afterOpenChange !== null && afterOpenChange !== void 0 ? afterOpenChange : afterVisibleChange,
        overlayInnerStyle: formattedOverlayInnerStyle,
        arrowContent: /*#__PURE__*/ $acw62.createElement("span", {
            className: `${prefixCls}-arrow-content`
        }),
        motion: {
            motionName: (0, $4257x.getTransitionName)(rootPrefixCls, "zoom-big-fast", props.transitionName),
            motionDeadline: 1000
        },
        destroyTooltipOnHide: !!destroyTooltipOnHide
    }), tempOpen ? (0, $4a1I5.cloneElement)(child, {
        className: childCls
    }) : child);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $3GcAE.default).Provider, {
        value: contextZIndex
    }, content));
});
$0ac88bf86814a6e5$var$Tooltip._InternalPanelDoNotUseOrYouWillBeFired = (0, $jKniu.default);
var $0ac88bf86814a6e5$export$2e2bcd8739ae039 = $0ac88bf86814a6e5$var$Tooltip;

});
parcelRegister("hRA8u", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0136ab94ce7f56e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Popup", () => (parcelRequire("7v8Xm")).default);

var $7v8Xm = parcelRequire("7v8Xm");

var $bABpZ = parcelRequire("bABpZ");
var $d0136ab94ce7f56e$export$2e2bcd8739ae039 = (0, $bABpZ.default);

});
parcelRegister("7v8Xm", function(module, exports) {

$parcel$export(module.exports, "default", () => $576260377b469890$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
function $576260377b469890$export$2e2bcd8739ae039(props) {
    var children = props.children, prefixCls = props.prefixCls, id = props.id, overlayInnerStyle = props.overlayInnerStyle, className = props.className, style = props.style;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-content"), className),
        style: style
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-inner"),
        id: id,
        role: "tooltip",
        style: overlayInnerStyle
    }, typeof children === "function" ? children() : children));
}

});

parcelRegister("bABpZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $870014fb7370caba$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $9X7IJ = parcelRequire("9X7IJ");

var $eyPR1 = parcelRequire("eyPR1");

var $acw62 = parcelRequire("acw62");

var $9jtir = parcelRequire("9jtir");

var $7v8Xm = parcelRequire("7v8Xm");
var $870014fb7370caba$var$_excluded = [
    "overlayClassName",
    "trigger",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "overlayStyle",
    "prefixCls",
    "children",
    "onVisibleChange",
    "afterVisibleChange",
    "transitionName",
    "animation",
    "motion",
    "placement",
    "align",
    "destroyTooltipOnHide",
    "defaultVisible",
    "getTooltipContainer",
    "overlayInnerStyle",
    "arrowContent",
    "overlay",
    "id",
    "showArrow"
];
var $870014fb7370caba$var$Tooltip = function Tooltip(props, ref) {
    var overlayClassName = props.overlayClassName, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? [
        "hover"
    ] : _props$trigger, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, overlayStyle = props.overlayStyle, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-tooltip" : _props$prefixCls, children = props.children, onVisibleChange = props.onVisibleChange, afterVisibleChange = props.afterVisibleChange, transitionName = props.transitionName, animation = props.animation, motion = props.motion, _props$placement = props.placement, placement = _props$placement === void 0 ? "right" : _props$placement, _props$align = props.align, align = _props$align === void 0 ? {} : _props$align, _props$destroyTooltip = props.destroyTooltipOnHide, destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip, defaultVisible = props.defaultVisible, getTooltipContainer = props.getTooltipContainer, overlayInnerStyle = props.overlayInnerStyle, arrowContent = props.arrowContent, overlay = props.overlay, id = props.id, _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow, restProps = (0, $9X7IJ.default)(props, $870014fb7370caba$var$_excluded);
    var triggerRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, function() {
        return triggerRef.current;
    });
    var extraProps = (0, $d49SP.default)({}, restProps);
    if ("visible" in props) extraProps.popupVisible = props.visible;
    var getPopupElement = function getPopupElement() {
        return /*#__PURE__*/ $acw62.createElement((0, $7v8Xm.default), {
            key: "content",
            prefixCls: prefixCls,
            id: id,
            overlayInnerStyle: overlayInnerStyle
        }, overlay);
    };
    return /*#__PURE__*/ $acw62.createElement((0, $eyPR1.default), (0, $8nd05.default)({
        popupClassName: overlayClassName,
        prefixCls: prefixCls,
        popup: getPopupElement,
        action: trigger,
        builtinPlacements: (0, $9jtir.placements),
        popupPlacement: placement,
        ref: triggerRef,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupMotion: motion,
        defaultPopupVisible: defaultVisible,
        autoDestroy: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay,
        arrow: showArrow
    }, extraProps), children);
};
var $870014fb7370caba$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.forwardRef)($870014fb7370caba$var$Tooltip);

});
parcelRegister("9jtir", function(module, exports) {

$parcel$export(module.exports, "placements", () => $6c7c9d120875ff76$export$803cd8101b6c182b);
var $6c7c9d120875ff76$var$autoAdjustOverflowTopBottom = {
    shiftX: 64,
    adjustY: 1
};
var $6c7c9d120875ff76$var$autoAdjustOverflowLeftRight = {
    adjustX: 1,
    shiftY: true
};
var $6c7c9d120875ff76$var$targetOffset = [
    0,
    0
];
var $6c7c9d120875ff76$export$803cd8101b6c182b = {
    left: {
        points: [
            "cr",
            "cl"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    right: {
        points: [
            "cl",
            "cr"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    top: {
        points: [
            "bc",
            "tc"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    bottom: {
        points: [
            "tc",
            "bc"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    topLeft: {
        points: [
            "bl",
            "tl"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    leftTop: {
        points: [
            "tr",
            "tl"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    topRight: {
        points: [
            "br",
            "tr"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    rightTop: {
        points: [
            "tl",
            "tr"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    rightBottom: {
        points: [
            "bl",
            "br"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    leftBottom: {
        points: [
            "br",
            "bl"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    }
};
var $6c7c9d120875ff76$export$2e2bcd8739ae039 = $6c7c9d120875ff76$export$803cd8101b6c182b;

});



parcelRegister("brFSt", function(module, exports) {

$parcel$export(module.exports, "CONTAINER_MAX_OFFSET", () => $8552b358f1d5b0a4$export$33ada7d8845f7e5);
$parcel$export(module.exports, "useZIndex", () => $8552b358f1d5b0a4$export$3e7906d4075187a4);

var $acw62 = parcelRequire("acw62");

var $hRCaH = parcelRequire("hRCaH");

var $3GcAE = parcelRequire("3GcAE");
"use client";
// Z-Index control range
// Container: 1000 + offset 100 (max base + 10 * offset = 2000)
// Popover: offset 50
// Notification: Container Max zIndex + componentOffset
const $8552b358f1d5b0a4$var$CONTAINER_OFFSET = 100;
const $8552b358f1d5b0a4$var$CONTAINER_OFFSET_MAX_COUNT = 10;
const $8552b358f1d5b0a4$export$33ada7d8845f7e5 = $8552b358f1d5b0a4$var$CONTAINER_OFFSET * $8552b358f1d5b0a4$var$CONTAINER_OFFSET_MAX_COUNT;
const $8552b358f1d5b0a4$export$1658852af8bb2a55 = {
    Modal: $8552b358f1d5b0a4$var$CONTAINER_OFFSET,
    Drawer: $8552b358f1d5b0a4$var$CONTAINER_OFFSET,
    Popover: $8552b358f1d5b0a4$var$CONTAINER_OFFSET,
    Popconfirm: $8552b358f1d5b0a4$var$CONTAINER_OFFSET,
    Tooltip: $8552b358f1d5b0a4$var$CONTAINER_OFFSET,
    Tour: $8552b358f1d5b0a4$var$CONTAINER_OFFSET
};
const $8552b358f1d5b0a4$export$3f7a364c708f940b = {
    SelectLike: 50,
    Dropdown: 50,
    DatePicker: 50,
    Menu: 50,
    ImagePreview: 1
};
function $8552b358f1d5b0a4$var$isContainerType(type) {
    return type in $8552b358f1d5b0a4$export$1658852af8bb2a55;
}
function $8552b358f1d5b0a4$export$3e7906d4075187a4(componentType, customZIndex) {
    const [, token] = (0, $hRCaH.default)();
    const parentZIndex = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $3GcAE.default));
    const isContainer = $8552b358f1d5b0a4$var$isContainerType(componentType);
    if (customZIndex !== undefined) return [
        customZIndex,
        customZIndex
    ];
    let zIndex = parentZIndex !== null && parentZIndex !== void 0 ? parentZIndex : 0;
    if (isContainer) {
        zIndex += // Use preset token zIndex by default but not stack when has parent container
        (parentZIndex ? 0 : token.zIndexPopupBase) + // Container offset
        $8552b358f1d5b0a4$export$1658852af8bb2a55[componentType];
        zIndex = Math.min(zIndex, token.zIndexPopupBase + $8552b358f1d5b0a4$export$33ada7d8845f7e5);
    } else zIndex += $8552b358f1d5b0a4$export$3f7a364c708f940b[componentType];
    return [
        parentZIndex === undefined ? customZIndex : zIndex,
        zIndex
    ];
}

});
parcelRegister("3GcAE", function(module, exports) {

$parcel$export(module.exports, "default", () => $2adf0f811816efa6$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
const $2adf0f811816efa6$var$zIndexContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(undefined);
var $2adf0f811816efa6$export$2e2bcd8739ae039 = $2adf0f811816efa6$var$zIndexContext;

});


parcelRegister("eBB7Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa2151c32cec40fb$export$2e2bcd8739ae039);

var $1HprZ = parcelRequire("1HprZ");
function $aa2151c32cec40fb$export$fde75e5b410c093f(placement, arrowOffset, arrowWidth, autoAdjustOverflow) {
    if (autoAdjustOverflow === false) return {
        adjustX: false,
        adjustY: false
    };
    const overflow = autoAdjustOverflow && typeof autoAdjustOverflow === "object" ? autoAdjustOverflow : {};
    const baseOverflow = {};
    switch(placement){
        case "top":
        case "bottom":
            baseOverflow.shiftX = arrowOffset.arrowOffsetHorizontal * 2 + arrowWidth;
            baseOverflow.shiftY = true;
            baseOverflow.adjustY = true;
            break;
        case "left":
        case "right":
            baseOverflow.shiftY = arrowOffset.arrowOffsetVertical * 2 + arrowWidth;
            baseOverflow.shiftX = true;
            baseOverflow.adjustX = true;
            break;
    }
    const mergedOverflow = Object.assign(Object.assign({}, baseOverflow), overflow);
    // Support auto shift
    if (!mergedOverflow.shiftX) mergedOverflow.adjustX = true;
    if (!mergedOverflow.shiftY) mergedOverflow.adjustY = true;
    return mergedOverflow;
}
const $aa2151c32cec40fb$var$PlacementAlignMap = {
    left: {
        points: [
            "cr",
            "cl"
        ]
    },
    right: {
        points: [
            "cl",
            "cr"
        ]
    },
    top: {
        points: [
            "bc",
            "tc"
        ]
    },
    bottom: {
        points: [
            "tc",
            "bc"
        ]
    },
    topLeft: {
        points: [
            "bl",
            "tl"
        ]
    },
    leftTop: {
        points: [
            "tr",
            "tl"
        ]
    },
    topRight: {
        points: [
            "br",
            "tr"
        ]
    },
    rightTop: {
        points: [
            "tl",
            "tr"
        ]
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ]
    },
    rightBottom: {
        points: [
            "bl",
            "br"
        ]
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ]
    },
    leftBottom: {
        points: [
            "br",
            "bl"
        ]
    }
};
const $aa2151c32cec40fb$var$ArrowCenterPlacementAlignMap = {
    topLeft: {
        points: [
            "bl",
            "tc"
        ]
    },
    leftTop: {
        points: [
            "tr",
            "cl"
        ]
    },
    topRight: {
        points: [
            "br",
            "tc"
        ]
    },
    rightTop: {
        points: [
            "tl",
            "cr"
        ]
    },
    bottomRight: {
        points: [
            "tr",
            "bc"
        ]
    },
    rightBottom: {
        points: [
            "bl",
            "cr"
        ]
    },
    bottomLeft: {
        points: [
            "tl",
            "bc"
        ]
    },
    leftBottom: {
        points: [
            "br",
            "cl"
        ]
    }
};
const $aa2151c32cec40fb$var$DisableAutoArrowList = new Set([
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight",
    "leftTop",
    "leftBottom",
    "rightTop",
    "rightBottom"
]);
function $aa2151c32cec40fb$export$2e2bcd8739ae039(config) {
    const { arrowWidth: arrowWidth, autoAdjustOverflow: autoAdjustOverflow, arrowPointAtCenter: arrowPointAtCenter, offset: offset, borderRadius: borderRadius, visibleFirst: visibleFirst } = config;
    const halfArrowWidth = arrowWidth / 2;
    const placementMap = {};
    Object.keys($aa2151c32cec40fb$var$PlacementAlignMap).forEach((key)=>{
        const template = arrowPointAtCenter && $aa2151c32cec40fb$var$ArrowCenterPlacementAlignMap[key] || $aa2151c32cec40fb$var$PlacementAlignMap[key];
        const placementInfo = Object.assign(Object.assign({}, template), {
            offset: [
                0,
                0
            ],
            dynamicInset: true
        });
        placementMap[key] = placementInfo;
        // Disable autoArrow since design is fixed position
        if ($aa2151c32cec40fb$var$DisableAutoArrowList.has(key)) placementInfo.autoArrow = false;
        // Static offset
        switch(key){
            case "top":
            case "topLeft":
            case "topRight":
                placementInfo.offset[1] = -halfArrowWidth - offset;
                break;
            case "bottom":
            case "bottomLeft":
            case "bottomRight":
                placementInfo.offset[1] = halfArrowWidth + offset;
                break;
            case "left":
            case "leftTop":
            case "leftBottom":
                placementInfo.offset[0] = -halfArrowWidth - offset;
                break;
            case "right":
            case "rightTop":
            case "rightBottom":
                placementInfo.offset[0] = halfArrowWidth + offset;
                break;
        }
        // Dynamic offset
        const arrowOffset = (0, $1HprZ.getArrowOffsetToken)({
            contentRadius: borderRadius,
            limitVerticalRadius: true
        });
        if (arrowPointAtCenter) switch(key){
            case "topLeft":
            case "bottomLeft":
                placementInfo.offset[0] = -arrowOffset.arrowOffsetHorizontal - halfArrowWidth;
                break;
            case "topRight":
            case "bottomRight":
                placementInfo.offset[0] = arrowOffset.arrowOffsetHorizontal + halfArrowWidth;
                break;
            case "leftTop":
            case "rightTop":
                placementInfo.offset[1] = -arrowOffset.arrowOffsetHorizontal - halfArrowWidth;
                break;
            case "leftBottom":
            case "rightBottom":
                placementInfo.offset[1] = arrowOffset.arrowOffsetHorizontal + halfArrowWidth;
                break;
        }
        // Overflow
        placementInfo.overflow = $aa2151c32cec40fb$export$fde75e5b410c093f(key, arrowOffset, arrowWidth, autoAdjustOverflow);
        // VisibleFirst
        if (visibleFirst) placementInfo.htmlRegion = "visibleFirst";
    });
    return placementMap;
}

});
parcelRegister("1HprZ", function(module, exports) {

$parcel$export(module.exports, "MAX_VERTICAL_CONTENT_RADIUS", () => $13cd8c878b3c9176$export$de6e4ffc9ec3c089);
$parcel$export(module.exports, "getArrowOffsetToken", () => $13cd8c878b3c9176$export$bddc192327bb9823);
$parcel$export(module.exports, "default", () => $13cd8c878b3c9176$export$2e2bcd8739ae039);

var $11ZuO = parcelRequire("11ZuO");
const $13cd8c878b3c9176$export$de6e4ffc9ec3c089 = 8;
function $13cd8c878b3c9176$export$bddc192327bb9823(options) {
    const { contentRadius: contentRadius, limitVerticalRadius: limitVerticalRadius } = options;
    const arrowOffset = contentRadius > 12 ? contentRadius + 2 : 12;
    const arrowOffsetVertical = limitVerticalRadius ? $13cd8c878b3c9176$export$de6e4ffc9ec3c089 : arrowOffset;
    return {
        arrowOffsetHorizontal: arrowOffset,
        arrowOffsetVertical: arrowOffsetVertical
    };
}
function $13cd8c878b3c9176$var$isInject(valid, code) {
    if (!valid) return {};
    return code;
}
function $13cd8c878b3c9176$export$2e2bcd8739ae039(token, colorBg, options) {
    const { componentCls: componentCls, boxShadowPopoverArrow: boxShadowPopoverArrow, arrowOffsetVertical: arrowOffsetVertical, arrowOffsetHorizontal: arrowOffsetHorizontal } = token;
    const { arrowDistance: arrowDistance = 0, arrowPlacement: arrowPlacement = {
        left: true,
        right: true,
        top: true,
        bottom: true
    } } = options || {};
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({
            // ============================ Basic ============================
            [`${componentCls}-arrow`]: [
                Object.assign(Object.assign({
                    position: "absolute",
                    zIndex: 1,
                    display: "block"
                }, (0, $11ZuO.genRoundedArrow)(token, colorBg, boxShadowPopoverArrow)), {
                    "&:before": {
                        background: colorBg
                    }
                })
            ]
        }, $13cd8c878b3c9176$var$isInject(!!arrowPlacement.top, {
            [[
                `&-placement-top ${componentCls}-arrow`,
                `&-placement-topLeft ${componentCls}-arrow`,
                `&-placement-topRight ${componentCls}-arrow`
            ].join(",")]: {
                bottom: arrowDistance,
                transform: "translateY(100%) rotate(180deg)"
            },
            [`&-placement-top ${componentCls}-arrow`]: {
                left: {
                    _skip_check_: true,
                    value: "50%"
                },
                transform: "translateX(-50%) translateY(100%) rotate(180deg)"
            },
            [`&-placement-topLeft ${componentCls}-arrow`]: {
                left: {
                    _skip_check_: true,
                    value: arrowOffsetHorizontal
                }
            },
            [`&-placement-topRight ${componentCls}-arrow`]: {
                right: {
                    _skip_check_: true,
                    value: arrowOffsetHorizontal
                }
            }
        })), $13cd8c878b3c9176$var$isInject(!!arrowPlacement.bottom, {
            [[
                `&-placement-bottom ${componentCls}-arrow`,
                `&-placement-bottomLeft ${componentCls}-arrow`,
                `&-placement-bottomRight ${componentCls}-arrow`
            ].join(",")]: {
                top: arrowDistance,
                transform: `translateY(-100%)`
            },
            [`&-placement-bottom ${componentCls}-arrow`]: {
                left: {
                    _skip_check_: true,
                    value: "50%"
                },
                transform: `translateX(-50%) translateY(-100%)`
            },
            [`&-placement-bottomLeft ${componentCls}-arrow`]: {
                left: {
                    _skip_check_: true,
                    value: arrowOffsetHorizontal
                }
            },
            [`&-placement-bottomRight ${componentCls}-arrow`]: {
                right: {
                    _skip_check_: true,
                    value: arrowOffsetHorizontal
                }
            }
        })), $13cd8c878b3c9176$var$isInject(!!arrowPlacement.left, {
            [[
                `&-placement-left ${componentCls}-arrow`,
                `&-placement-leftTop ${componentCls}-arrow`,
                `&-placement-leftBottom ${componentCls}-arrow`
            ].join(",")]: {
                right: {
                    _skip_check_: true,
                    value: arrowDistance
                },
                transform: "translateX(100%) rotate(90deg)"
            },
            [`&-placement-left ${componentCls}-arrow`]: {
                top: {
                    _skip_check_: true,
                    value: "50%"
                },
                transform: "translateY(-50%) translateX(100%) rotate(90deg)"
            },
            [`&-placement-leftTop ${componentCls}-arrow`]: {
                top: arrowOffsetVertical
            },
            [`&-placement-leftBottom ${componentCls}-arrow`]: {
                bottom: arrowOffsetVertical
            }
        })), $13cd8c878b3c9176$var$isInject(!!arrowPlacement.right, {
            [[
                `&-placement-right ${componentCls}-arrow`,
                `&-placement-rightTop ${componentCls}-arrow`,
                `&-placement-rightBottom ${componentCls}-arrow`
            ].join(",")]: {
                left: {
                    _skip_check_: true,
                    value: arrowDistance
                },
                transform: "translateX(-100%) rotate(-90deg)"
            },
            [`&-placement-right ${componentCls}-arrow`]: {
                top: {
                    _skip_check_: true,
                    value: "50%"
                },
                transform: "translateY(-50%) translateX(-100%) rotate(-90deg)"
            },
            [`&-placement-rightTop ${componentCls}-arrow`]: {
                top: arrowOffsetVertical
            },
            [`&-placement-rightBottom ${componentCls}-arrow`]: {
                bottom: arrowOffsetVertical
            }
        }))
    };
}

});
parcelRegister("11ZuO", function(module, exports) {

$parcel$export(module.exports, "getArrowToken", () => $0c0596420865f622$export$87e38ee403661ccc);
$parcel$export(module.exports, "genRoundedArrow", () => $0c0596420865f622$export$601fa0375eb80eec);
parcelRequire("3i86m");
var $lpQ06 = parcelRequire("lpQ06");
function $0c0596420865f622$export$87e38ee403661ccc(token) {
    const { sizePopupArrow: sizePopupArrow, borderRadiusXS: borderRadiusXS, borderRadiusOuter: borderRadiusOuter } = token;
    const unitWidth = sizePopupArrow / 2;
    const ax = 0;
    const ay = unitWidth;
    const bx = borderRadiusOuter * 1 / Math.sqrt(2);
    const by = unitWidth - borderRadiusOuter * (1 - 1 / Math.sqrt(2));
    const cx = unitWidth - borderRadiusXS * (1 / Math.sqrt(2));
    const cy = borderRadiusOuter * (Math.sqrt(2) - 1) + borderRadiusXS * (1 / Math.sqrt(2));
    const dx = 2 * unitWidth - cx;
    const dy = cy;
    const ex = 2 * unitWidth - bx;
    const ey = by;
    const fx = 2 * unitWidth - ax;
    const fy = ay;
    const shadowWidth = unitWidth * Math.sqrt(2) + borderRadiusOuter * (Math.sqrt(2) - 2);
    const polygonOffset = borderRadiusOuter * (Math.sqrt(2) - 1);
    const arrowPolygon = `polygon(${polygonOffset}px 100%, 50% ${polygonOffset}px, ${2 * unitWidth - polygonOffset}px 100%, ${polygonOffset}px 100%)`;
    const arrowPath = `path('M ${ax} ${ay} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${bx} ${by} L ${cx} ${cy} A ${borderRadiusXS} ${borderRadiusXS} 0 0 1 ${dx} ${dy} L ${ex} ${ey} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${fx} ${fy} Z')`;
    return {
        arrowShadowWidth: shadowWidth,
        arrowPath: arrowPath,
        arrowPolygon: arrowPolygon
    };
}
const $0c0596420865f622$export$601fa0375eb80eec = (token, bgColor, boxShadow)=>{
    const { sizePopupArrow: sizePopupArrow, arrowPolygon: arrowPolygon, arrowPath: arrowPath, arrowShadowWidth: arrowShadowWidth, borderRadiusXS: borderRadiusXS, calc: calc } = token;
    return {
        pointerEvents: "none",
        width: sizePopupArrow,
        height: sizePopupArrow,
        overflow: "hidden",
        "&::before": {
            position: "absolute",
            bottom: 0,
            insetInlineStart: 0,
            width: sizePopupArrow,
            height: calc(sizePopupArrow).div(2).equal(),
            background: bgColor,
            clipPath: {
                _multi_value_: true,
                value: [
                    arrowPolygon,
                    arrowPath
                ]
            },
            content: '""'
        },
        "&::after": {
            content: '""',
            position: "absolute",
            width: arrowShadowWidth,
            height: arrowShadowWidth,
            bottom: 0,
            insetInline: 0,
            margin: "auto",
            borderRadius: {
                _skip_check_: true,
                value: `0 0 ${(0, $lpQ06.unit)(borderRadiusXS)} 0`
            },
            transform: "translateY(50%) rotate(-135deg)",
            boxShadow: boxShadow,
            zIndex: 0,
            background: "transparent"
        }
    };
};

});



parcelRegister("jKniu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e604628db2f2c0d3$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");
parcelRequire("hRA8u");
var $7v8Xm = parcelRequire("7v8Xm");

var $acw62 = parcelRequire("acw62");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $c09fQ = parcelRequire("c09fQ");

var $GQ0on = parcelRequire("GQ0on");
"use client";
/** @private Internal Component. Do not use in your production. */ const $e604628db2f2c0d3$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, placement: placement = "top", title: title, color: color, overlayInnerStyle: overlayInnerStyle } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const prefixCls = getPrefixCls("tooltip", customizePrefixCls);
    const [wrapCSSVar, hashId] = (0, $c09fQ.default)(prefixCls);
    // Color
    const colorInfo = (0, $GQ0on.parseColor)(prefixCls, color);
    const arrowContentStyle = colorInfo.arrowStyle;
    const formattedOverlayInnerStyle = Object.assign(Object.assign({}, overlayInnerStyle), colorInfo.overlayStyle);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(hashId, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className, colorInfo.className);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", {
        className: cls,
        style: arrowContentStyle
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ $acw62.createElement((0, $7v8Xm.default), Object.assign({}, props, {
        className: hashId,
        prefixCls: prefixCls,
        overlayInnerStyle: formattedOverlayInnerStyle
    }), title)));
};
var $e604628db2f2c0d3$export$2e2bcd8739ae039 = $e604628db2f2c0d3$var$PurePanel;

});
parcelRegister("c09fQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bcca9e8f96db88a$export$2e2bcd8739ae039);

var $670jt = parcelRequire("670jt");

var $i1ZDk = parcelRequire("i1ZDk");

var $1HprZ = parcelRequire("1HprZ");

var $925hW = parcelRequire("925hW");
var $P8Drj = parcelRequire("P8Drj");
var $2LRCS = parcelRequire("2LRCS");
parcelRequire("3i86m");
var $lpQ06 = parcelRequire("lpQ06");

var $11ZuO = parcelRequire("11ZuO");
const $8bcca9e8f96db88a$var$genTooltipStyle = (token)=>{
    const { componentCls: componentCls, tooltipMaxWidth: // ant-tooltip
    tooltipMaxWidth, tooltipColor: tooltipColor, tooltipBg: tooltipBg, tooltipBorderRadius: tooltipBorderRadius, zIndexPopup: zIndexPopup, controlHeight: controlHeight, boxShadowSecondary: boxShadowSecondary, paddingSM: paddingSM, paddingXS: paddingXS } = token;
    return [
        {
            [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $670jt.resetComponent)(token)), {
                position: "absolute",
                zIndex: zIndexPopup,
                display: "block",
                width: "max-content",
                maxWidth: tooltipMaxWidth,
                visibility: "visible",
                transformOrigin: `var(--arrow-x, 50%) var(--arrow-y, 50%)`,
                "&-hidden": {
                    display: "none"
                },
                "--antd-arrow-background-color": tooltipBg,
                // Wrapper for the tooltip content
                [`${componentCls}-inner`]: {
                    minWidth: controlHeight,
                    minHeight: controlHeight,
                    padding: `${(0, $lpQ06.unit)(token.calc(paddingSM).div(2).equal())} ${(0, $lpQ06.unit)(paddingXS)}`,
                    color: tooltipColor,
                    textAlign: "start",
                    textDecoration: "none",
                    wordWrap: "break-word",
                    backgroundColor: tooltipBg,
                    borderRadius: tooltipBorderRadius,
                    boxShadow: boxShadowSecondary,
                    boxSizing: "border-box"
                },
                // Limit left and right placement radius
                [[
                    `&-placement-left`,
                    `&-placement-leftTop`,
                    `&-placement-leftBottom`,
                    `&-placement-right`,
                    `&-placement-rightTop`,
                    `&-placement-rightBottom`
                ].join(",")]: {
                    [`${componentCls}-inner`]: {
                        borderRadius: token.min(tooltipBorderRadius, (0, $1HprZ.MAX_VERTICAL_CONTENT_RADIUS))
                    }
                },
                [`${componentCls}-content`]: {
                    position: "relative"
                }
            }), (0, $925hW.default)(token, (colorKey, _ref)=>{
                let { darkColor: darkColor } = _ref;
                return {
                    [`&${componentCls}-${colorKey}`]: {
                        [`${componentCls}-inner`]: {
                            backgroundColor: darkColor
                        },
                        [`${componentCls}-arrow`]: {
                            "--antd-arrow-background-color": darkColor
                        }
                    }
                };
            })), {
                // RTL
                "&-rtl": {
                    direction: "rtl"
                }
            })
        },
        // Arrow Style
        (0, $1HprZ.default)(token, "var(--antd-arrow-background-color)"),
        // Pure Render
        {
            [`${componentCls}-pure`]: {
                position: "relative",
                maxWidth: "none",
                margin: token.sizePopupArrow
            }
        }
    ];
};
const $8bcca9e8f96db88a$export$9ca1be8807fe0675 = (token)=>Object.assign(Object.assign({
        zIndexPopup: token.zIndexPopupBase + 70
    }, (0, $1HprZ.getArrowOffsetToken)({
        contentRadius: token.borderRadius,
        limitVerticalRadius: true
    })), (0, $11ZuO.getArrowToken)((0, $2LRCS.merge)(token, {
        borderRadiusOuter: Math.min(token.borderRadiusOuter, 4)
    })));
var $8bcca9e8f96db88a$export$2e2bcd8739ae039 = function(prefixCls) {
    let injectStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    const useStyle = (0, $P8Drj.genStyleHooks)("Tooltip", (token)=>{
        const { borderRadius: borderRadius, colorTextLightSolid: colorTextLightSolid, colorBgSpotlight: colorBgSpotlight } = token;
        const TooltipToken = (0, $2LRCS.merge)(token, {
            // default variables
            tooltipMaxWidth: 250,
            tooltipColor: colorTextLightSolid,
            tooltipBorderRadius: borderRadius,
            tooltipBg: colorBgSpotlight
        });
        return [
            $8bcca9e8f96db88a$var$genTooltipStyle(TooltipToken),
            (0, $i1ZDk.initZoomMotion)(token, "zoom-big-fast")
        ];
    }, $8bcca9e8f96db88a$export$9ca1be8807fe0675, {
        resetStyle: false,
        injectStyle: // Popover use Tooltip as internal component. We do not need to handle this.
        injectStyle
    });
    return useStyle(prefixCls);
};

});
parcelRegister("i1ZDk", function(module, exports) {

$parcel$export(module.exports, "initZoomMotion", () => $d2082114d5952afb$export$f5d123412490d9dc);
parcelRequire("3i86m");
var $hsEk2 = parcelRequire("hsEk2");

var $gvSPY = parcelRequire("gvSPY");
const $d2082114d5952afb$export$3b71758b3ed5255f = new (0, $hsEk2.default)("antZoomIn", {
    "0%": {
        transform: "scale(0.2)",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)",
        opacity: 1
    }
});
const $d2082114d5952afb$export$9fdb0a49c6b4b521 = new (0, $hsEk2.default)("antZoomOut", {
    "0%": {
        transform: "scale(1)"
    },
    "100%": {
        transform: "scale(0.2)",
        opacity: 0
    }
});
const $d2082114d5952afb$export$be061d573c42e33a = new (0, $hsEk2.default)("antZoomBigIn", {
    "0%": {
        transform: "scale(0.8)",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)",
        opacity: 1
    }
});
const $d2082114d5952afb$export$582d93d613303da3 = new (0, $hsEk2.default)("antZoomBigOut", {
    "0%": {
        transform: "scale(1)"
    },
    "100%": {
        transform: "scale(0.8)",
        opacity: 0
    }
});
const $d2082114d5952afb$export$45eddd18c599b827 = new (0, $hsEk2.default)("antZoomUpIn", {
    "0%": {
        transform: "scale(0.8)",
        transformOrigin: "50% 0%",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)",
        transformOrigin: "50% 0%"
    }
});
const $d2082114d5952afb$export$a85c97750adaa37a = new (0, $hsEk2.default)("antZoomUpOut", {
    "0%": {
        transform: "scale(1)",
        transformOrigin: "50% 0%"
    },
    "100%": {
        transform: "scale(0.8)",
        transformOrigin: "50% 0%",
        opacity: 0
    }
});
const $d2082114d5952afb$export$bd2378f7814f5f1a = new (0, $hsEk2.default)("antZoomLeftIn", {
    "0%": {
        transform: "scale(0.8)",
        transformOrigin: "0% 50%",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)",
        transformOrigin: "0% 50%"
    }
});
const $d2082114d5952afb$export$e58f88c751c4f04e = new (0, $hsEk2.default)("antZoomLeftOut", {
    "0%": {
        transform: "scale(1)",
        transformOrigin: "0% 50%"
    },
    "100%": {
        transform: "scale(0.8)",
        transformOrigin: "0% 50%",
        opacity: 0
    }
});
const $d2082114d5952afb$export$fee1456954aef331 = new (0, $hsEk2.default)("antZoomRightIn", {
    "0%": {
        transform: "scale(0.8)",
        transformOrigin: "100% 50%",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)",
        transformOrigin: "100% 50%"
    }
});
const $d2082114d5952afb$export$811ba6d3e2adb730 = new (0, $hsEk2.default)("antZoomRightOut", {
    "0%": {
        transform: "scale(1)",
        transformOrigin: "100% 50%"
    },
    "100%": {
        transform: "scale(0.8)",
        transformOrigin: "100% 50%",
        opacity: 0
    }
});
const $d2082114d5952afb$export$633a68aa72dec21c = new (0, $hsEk2.default)("antZoomDownIn", {
    "0%": {
        transform: "scale(0.8)",
        transformOrigin: "50% 100%",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)",
        transformOrigin: "50% 100%"
    }
});
const $d2082114d5952afb$export$1cf46a906e8dede4 = new (0, $hsEk2.default)("antZoomDownOut", {
    "0%": {
        transform: "scale(1)",
        transformOrigin: "50% 100%"
    },
    "100%": {
        transform: "scale(0.8)",
        transformOrigin: "50% 100%",
        opacity: 0
    }
});
const $d2082114d5952afb$var$zoomMotion = {
    zoom: {
        inKeyframes: $d2082114d5952afb$export$3b71758b3ed5255f,
        outKeyframes: $d2082114d5952afb$export$9fdb0a49c6b4b521
    },
    "zoom-big": {
        inKeyframes: $d2082114d5952afb$export$be061d573c42e33a,
        outKeyframes: $d2082114d5952afb$export$582d93d613303da3
    },
    "zoom-big-fast": {
        inKeyframes: $d2082114d5952afb$export$be061d573c42e33a,
        outKeyframes: $d2082114d5952afb$export$582d93d613303da3
    },
    "zoom-left": {
        inKeyframes: $d2082114d5952afb$export$bd2378f7814f5f1a,
        outKeyframes: $d2082114d5952afb$export$e58f88c751c4f04e
    },
    "zoom-right": {
        inKeyframes: $d2082114d5952afb$export$fee1456954aef331,
        outKeyframes: $d2082114d5952afb$export$811ba6d3e2adb730
    },
    "zoom-up": {
        inKeyframes: $d2082114d5952afb$export$45eddd18c599b827,
        outKeyframes: $d2082114d5952afb$export$a85c97750adaa37a
    },
    "zoom-down": {
        inKeyframes: $d2082114d5952afb$export$633a68aa72dec21c,
        outKeyframes: $d2082114d5952afb$export$1cf46a906e8dede4
    }
};
const $d2082114d5952afb$export$f5d123412490d9dc = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $d2082114d5952afb$var$zoomMotion[motionName];
    return [
        (0, $gvSPY.initMotion)(motionCls, inKeyframes, outKeyframes, motionName === "zoom-big-fast" ? token.motionDurationFast : token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                transform: "scale(0)",
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc,
                "&-prepare": {
                    transform: "none"
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};

});


parcelRegister("GQ0on", function(module, exports) {

$parcel$export(module.exports, "parseColor", () => $080c438853985df7$export$6e865ea70d7724f);
/* eslint-disable import/prefer-default-export */ 
var $8g1PZ = parcelRequire("8g1PZ");

var $1Oc38 = parcelRequire("1Oc38");
function $080c438853985df7$export$6e865ea70d7724f(prefixCls, color) {
    const isInternalColor = (0, $1Oc38.isPresetColor)(color);
    const className = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
        [`${prefixCls}-${color}`]: color && isInternalColor
    });
    const overlayStyle = {};
    const arrowStyle = {};
    if (color && !isInternalColor) {
        overlayStyle.background = color;
        // @ts-ignore
        arrowStyle["--antd-arrow-background-color"] = color;
    }
    return {
        className: className,
        overlayStyle: overlayStyle,
        arrowStyle: arrowStyle
    };
}

});



parcelRegister("llc8B", function(module, exports) {

$parcel$export(module.exports, "default", () => $f894f96f86da23c6$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $8tTzv = parcelRequire("8tTzv");

var $adRcI = parcelRequire("adRcI");
var $f894f96f86da23c6$var$QuestionCircleOutlined = function QuestionCircleOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $adRcI.default), (0, $8nd05.default)({}, props, {
        ref: ref,
        icon: (0, $8tTzv.default)
    }));
};
var $f894f96f86da23c6$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($f894f96f86da23c6$var$QuestionCircleOutlined);

});
parcelRegister("8tTzv", function(module, exports) {

$parcel$export(module.exports, "default", () => $62cc23852a32c921$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $62cc23852a32c921$var$QuestionCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z"
                }
            }
        ]
    },
    "name": "question-circle",
    "theme": "outlined"
};
var $62cc23852a32c921$export$2e2bcd8739ae039 = $62cc23852a32c921$var$QuestionCircleOutlined;

});


parcelRegister("igqD6", function(module, exports) {

$parcel$export(module.exports, "cx", () => $d4be60b58ad177a9$export$a274e22fb40f762e);
$parcel$export(module.exports, "css", () => $d4be60b58ad177a9$export$dbf350e5966cf602);

var $lik8s = parcelRequire("lik8s");
parcelRequire("lDTld");
parcelRequire("cqnxX");
parcelRequire("2Hahg");
var $d4be60b58ad177a9$var$_createEmotion = (0, $lik8s.default)({
    key: "css"
}), $d4be60b58ad177a9$export$4909b86c8034bf73 = $d4be60b58ad177a9$var$_createEmotion.flush, $d4be60b58ad177a9$export$fa8d919ba61d84db = $d4be60b58ad177a9$var$_createEmotion.hydrate, $d4be60b58ad177a9$export$a274e22fb40f762e = $d4be60b58ad177a9$var$_createEmotion.cx, $d4be60b58ad177a9$export$4950aa0f605343fb = $d4be60b58ad177a9$var$_createEmotion.merge, $d4be60b58ad177a9$export$95d99596f328fd52 = $d4be60b58ad177a9$var$_createEmotion.getRegisteredStyles, $d4be60b58ad177a9$export$efb9f5caaa2ca0c7 = $d4be60b58ad177a9$var$_createEmotion.injectGlobal, $d4be60b58ad177a9$export$d25ddfdf17c3ad3e = $d4be60b58ad177a9$var$_createEmotion.keyframes, $d4be60b58ad177a9$export$dbf350e5966cf602 = $d4be60b58ad177a9$var$_createEmotion.css, $d4be60b58ad177a9$export$995990c5c04c46f0 = $d4be60b58ad177a9$var$_createEmotion.sheet, $d4be60b58ad177a9$export$69a3209f1a06c04d = $d4be60b58ad177a9$var$_createEmotion.cache;

});
parcelRegister("lik8s", function(module, exports) {

$parcel$export(module.exports, "default", () => $f80ae5e019588f18$export$2e2bcd8739ae039);

var $lDTld = parcelRequire("lDTld");

var $cqnxX = parcelRequire("cqnxX");

var $2Hahg = parcelRequire("2Hahg");
function $f80ae5e019588f18$var$insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert("", serialized, cache.sheet, true);
}
function $f80ae5e019588f18$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $2Hahg.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $f80ae5e019588f18$export$2e2bcd8739ae039 = function createEmotion(options) {
    var cache = (0, $lDTld.default)(options); // $FlowFixMe
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $cqnxX.serializeStyles)(args, cache.registered, undefined);
        (0, $2Hahg.insertStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, $cqnxX.serializeStyles)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        $f80ae5e019588f18$var$insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, $cqnxX.serializeStyles)(args, cache.registered);
        $f80ae5e019588f18$var$insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $f80ae5e019588f18$var$merge(cache.registered, css, $f80ae5e019588f18$var$classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        // $FlowFixMe
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, $2Hahg.getRegisteredStyles).bind(null, cache.registered),
        merge: $f80ae5e019588f18$var$merge.bind(null, cache.registered, css)
    };
};
var $f80ae5e019588f18$var$classnames = function classnames(args) {
    var cls = "";
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};

});
parcelRegister("lDTld", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc182b1f84212d3f$export$2e2bcd8739ae039);

var $jmsCu = parcelRequire("jmsCu");

var $fm8kz = parcelRequire("fm8kz");
parcelRequire("aJJpq");
parcelRequire("9ffXE");
var $fc182b1f84212d3f$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fm8kz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fm8kz.token)(character)) break;
        (0, $fm8kz.next)();
    }
    return (0, $fm8kz.slice)(begin, (0, $fm8kz.position));
};
var $fc182b1f84212d3f$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fm8kz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fm8kz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $fc182b1f84212d3f$var$identifierWithPointTracking((0, $fm8kz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fm8kz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fm8kz.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fm8kz.from)(character);
    }
    while (character = (0, $fm8kz.next)());
    return parsed;
};
var $fc182b1f84212d3f$var$getRules = function getRules(value, points) {
    return (0, $fm8kz.dealloc)($fc182b1f84212d3f$var$toRules((0, $fm8kz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $fc182b1f84212d3f$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $fc182b1f84212d3f$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$fc182b1f84212d3f$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $fc182b1f84212d3f$var$fixedElements.set(element, true);
    var points = [];
    var rules = $fc182b1f84212d3f$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $fc182b1f84212d3f$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $fc182b1f84212d3f$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $fc182b1f84212d3f$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($fc182b1f84212d3f$var$ignoreFlag) > -1;
};
var $fc182b1f84212d3f$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($fc182b1f84212d3f$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $fc182b1f84212d3f$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $fc182b1f84212d3f$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$fc182b1f84212d3f$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $fc182b1f84212d3f$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $fc182b1f84212d3f$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$fc182b1f84212d3f$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    } else if ($fc182b1f84212d3f$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $fc182b1f84212d3f$var$prefix(value, length) {
    switch((0, $fm8kz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fm8kz.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fm8kz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MOZ) + value + (0, $fm8kz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
        // order
        case 6165:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.replace)(value, /(\w+).+(:[^]+)/, (0, $fm8kz.WEBKIT) + "box-$1$2" + (0, $fm8kz.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + "flex-item-" + (0, $fm8kz.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + "flex-line-pack" + (0, $fm8kz.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $fm8kz.WEBKIT) + "box-" + (0, $fm8kz.replace)(value, "-grow", "") + (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $fm8kz.WEBKIT) + (0, $fm8kz.replace)(value, /([^-])(transform)/g, "$1" + (0, $fm8kz.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(zoom-|grab)/, (0, $fm8kz.WEBKIT) + "$1"), /(image-set)/, (0, $fm8kz.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fm8kz.replace)(value, /(image-set\([^]*)/, (0, $fm8kz.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fm8kz.WEBKIT) + "box-pack:$3" + (0, $fm8kz.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $fm8kz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fm8kz.replace)(value, /(.+)-inline(.+)/, (0, $fm8kz.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fm8kz.strlen)(value) - 1 - length > 6) switch((0, $fm8kz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fm8kz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fm8kz.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $fm8kz.WEBKIT) + "$2-$3" + "$1" + (0, $fm8kz.MOZ) + ((0, $fm8kz.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fm8kz.indexof)(value, "stretch") ? $fc182b1f84212d3f$var$prefix((0, $fm8kz.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fm8kz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fm8kz.charat)(value, (0, $fm8kz.strlen)(value) - 3 - (~(0, $fm8kz.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $fm8kz.replace)(value, ":", ":" + (0, $fm8kz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fm8kz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $fm8kz.WEBKIT) + ((0, $fm8kz.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $fm8kz.WEBKIT) + "$2$3" + "$1" + (0, $fm8kz.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fm8kz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
    }
    return value;
}
var $fc182b1f84212d3f$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fm8kz.DECLARATION:
                element["return"] = $fc182b1f84212d3f$var$prefix(element.value, element.length);
                break;
            case 0, $fm8kz.KEYFRAMES:
                return (0, $fm8kz.serialize)([
                    (0, $fm8kz.copy)(element, {
                        value: (0, $fm8kz.replace)(element.value, "@", "@" + (0, $fm8kz.WEBKIT))
                    })
                ], callback);
            case 0, $fm8kz.RULESET:
                if (element.length) return (0, $fm8kz.combine)(element.props, function(value) {
                    switch((0, $fm8kz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(read-\w+)/, ":" + (0, $fm8kz.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ":" + (0, $fm8kz.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ":" + (0, $fm8kz.MOZ) + "$1")
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, (0, $fm8kz.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $fc182b1f84212d3f$var$defaultStylisPlugins = [
    $fc182b1f84212d3f$var$prefixer
];
var $fc182b1f84212d3f$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $fc182b1f84212d3f$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $fc182b1f84212d3f$var$compat,
        $fc182b1f84212d3f$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $fm8kz.stringify),
        (0, $fm8kz.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $jmsCu.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("jmsCu", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $e18645ac1956fbe6$export$9d753cd7ae895cce);
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $e18645ac1956fbe6$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $e18645ac1956fbe6$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $e18645ac1956fbe6$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e18645ac1956fbe6$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $e18645ac1956fbe6$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("aJJpq", function(module, exports) {
var $7d1154ab70079230$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("9ffXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb1e54ce1bc6efa$export$2e2bcd8739ae039);
function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("cqnxX", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $90ba2da1f62e5f1b$export$6321afa313b251b5);

var $4EiWM = parcelRequire("4EiWM");

var $cEIH4 = parcelRequire("cEIH4");

var $9ffXE = parcelRequire("9ffXE");
var $90ba2da1f62e5f1b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $90ba2da1f62e5f1b$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $90ba2da1f62e5f1b$var$hyphenateRegex = /[A-Z]|^ms/g;
var $90ba2da1f62e5f1b$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $90ba2da1f62e5f1b$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $90ba2da1f62e5f1b$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $90ba2da1f62e5f1b$var$processStyleName = /* #__PURE__ */ (0, $9ffXE.default)(function(styleName) {
    return $90ba2da1f62e5f1b$var$isCustomProperty(styleName) ? styleName : styleName.replace($90ba2da1f62e5f1b$var$hyphenateRegex, "-$&").toLowerCase();
});
var $90ba2da1f62e5f1b$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($90ba2da1f62e5f1b$var$animationRegex, function(match, p1, p2) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cEIH4.default)[key] !== 1 && !$90ba2da1f62e5f1b$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $90ba2da1f62e5f1b$var$contentValuePattern, $90ba2da1f62e5f1b$var$contentValues, $90ba2da1f62e5f1b$var$oldProcessStyleValue, $90ba2da1f62e5f1b$var$msPattern, $90ba2da1f62e5f1b$var$hyphenPattern, $90ba2da1f62e5f1b$var$hyphenatedCache;
var $90ba2da1f62e5f1b$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $90ba2da1f62e5f1b$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $90ba2da1f62e5f1b$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $90ba2da1f62e5f1b$var$cursor;
                var result = interpolation(mergedProps);
                $90ba2da1f62e5f1b$var$cursor = previousCursor;
                return $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($90ba2da1f62e5f1b$var$isProcessableValue(value)) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($90ba2da1f62e5f1b$var$isProcessableValue(value[_i])) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $90ba2da1f62e5f1b$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $90ba2da1f62e5f1b$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $90ba2da1f62e5f1b$var$cursor;
var $90ba2da1f62e5f1b$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $90ba2da1f62e5f1b$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $90ba2da1f62e5f1b$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $90ba2da1f62e5f1b$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $4EiWM.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $90ba2da1f62e5f1b$var$cursor
    };
};

});
parcelRegister("4EiWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3629985b3ecf741f$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("cEIH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $936be3b045ab836e$export$2e2bcd8739ae039);
var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("2Hahg", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $1f6791d0a193b918$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $1f6791d0a193b918$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $1f6791d0a193b918$export$6f077d94b33a01aa);
var $1f6791d0a193b918$var$isBrowser = true;
function $1f6791d0a193b918$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $1f6791d0a193b918$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $1f6791d0a193b918$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $1f6791d0a193b918$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $1f6791d0a193b918$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});



parcelRegister("eqoJO", function(module, exports) {
!function(e, r) {
    var t, l;
    module.exports = r();
}(module.exports, function() {
    return (()=>{
        "use strict";
        var e = {
            95: (e, r, t)=>{
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.DiceRoller = void 0;
                const l = t(51);
                r.DiceRoller = class {
                    constructor(e, r = 1e3){
                        this.randFunction = Math.random, this.maxRollCount = 1e3, e && (this.randFunction = e), this.maxRollCount = r;
                    }
                    parse(e) {
                        return l.parse(e);
                    }
                    roll(e) {
                        const r = l.parse(e);
                        return this.rollType(r);
                    }
                    rollValue(e) {
                        return this.roll(e).value;
                    }
                    rollParsed(e) {
                        return this.rollType(e);
                    }
                    rollType(e) {
                        let r;
                        switch(e.type){
                            case "diceExpression":
                                r = this.rollDiceExpr(e);
                                break;
                            case "group":
                                r = this.rollGroup(e);
                                break;
                            case "die":
                                r = this.rollDie(e);
                                break;
                            case "expression":
                                r = this.rollExpression(e);
                                break;
                            case "mathfunction":
                                r = this.rollFunction(e);
                                break;
                            case "inline":
                                r = this.rollType(e.expr);
                                break;
                            case "number":
                                r = Object.assign(Object.assign({}, e), {
                                    success: null,
                                    successes: 0,
                                    failures: 0,
                                    valid: !0,
                                    order: 0
                                });
                                break;
                            default:
                                throw new Error(`Unable to render ${e.type}`);
                        }
                        return e.label && (r.label = e.label), r;
                    }
                    rollDiceExpr(e) {
                        const r = this.rollType(e.head), t = [
                            r
                        ], l = [], o = e.ops.reduce((e, r, o)=>{
                            const s = this.rollType(r.tail);
                            switch(s.order = o, t.push(s), l.push(r.op), r.op){
                                case "+":
                                    return e + s.value;
                                case "-":
                                    return e - s.value;
                                default:
                                    return e;
                            }
                        }, r.value);
                        return {
                            dice: t,
                            ops: l,
                            success: null,
                            successes: 0,
                            failures: 0,
                            type: "diceexpressionroll",
                            valid: !0,
                            value: o,
                            order: 0
                        };
                    }
                    rollGroup(e) {
                        let r = e.rolls.map((e, r)=>Object.assign(Object.assign({}, this.rollType(e)), {
                                order: r
                            })), t = 0, l = 0, o = !1;
                        if (e.mods) {
                            const s = e.mods, n = (e)=>(o = s.some((e)=>[
                                        "failure",
                                        "success"
                                    ].includes(e.type)), e = s.reduce((e, r)=>this.applyGroupMod(e, r), e), o && (e = e.map((e)=>(t += e.successes, l += e.failures, e.value = e.successes - e.failures, e.success = e.value > 0, e))), e);
                            if (1 === r.length && [
                                "die",
                                "diceexpressionroll"
                            ].includes(r[0].type)) {
                                const e = r[0];
                                let t = "die" === e.type ? e.rolls : e.dice.filter((e)=>"number" !== e.type).reduce((e, r)=>[
                                        ...e,
                                        ..."die" === r.type ? r.rolls : r.dice
                                    ], []);
                                t = n(t), e.value = t.reduce((e, r)=>r.valid ? e + r.value : e, 0);
                            } else r = n(r);
                        }
                        const s = r.reduce((e, r)=>r.valid ? e + r.value : e, 0);
                        return {
                            dice: r,
                            success: o ? s > 0 : null,
                            successes: t,
                            failures: l,
                            type: "grouproll",
                            valid: !0,
                            value: s,
                            order: 0
                        };
                    }
                    rollDie(e) {
                        const r = this.rollType(e.count);
                        if (r.value > this.maxRollCount) throw new Error("Entered number of dice too large.");
                        let t, l;
                        "fate" === e.die.type ? (l = {
                            type: "fate",
                            success: null,
                            successes: 0,
                            failures: 0,
                            valid: !1,
                            value: 0,
                            order: 0
                        }, t = Array.from({
                            length: r.value
                        }, (e, r)=>this.generateFateRoll(r))) : (l = this.rollType(e.die), t = Array.from({
                            length: r.value
                        }, (e, r)=>this.generateDiceRoll(l.value, r))), e.mods && (t = e.mods.reduce((e, r)=>this.applyMod(e, r), t));
                        let o = 0, s = 0;
                        e.targets && (t = e.targets.reduce((e, r)=>this.applyMod(e, r), t).map((e)=>(o += e.successes, s += e.failures, e.value = e.successes - e.failures, e.success = e.value > 0, e)));
                        let n = !1, u = 0;
                        if (e.match) {
                            const r = e.match, l = t.reduce((e, r)=>e.set(r.roll, (e.get(r.roll) || 0) + 1), new Map), o = new Set(Array.from(l.entries()).filter(([e, t])=>t >= r.min.value).filter(([e])=>!(r.mod && r.expr) || this.successTest(r.mod, this.rollType(r.expr).value, e)).map(([e])=>e));
                            t.filter((e)=>o.has(e.roll)).forEach((e)=>e.matched = !0), r.count && (n = !0, u = o.size);
                        }
                        e.sort && (t = this.applySort(t, e.sort));
                        const a = t.reduce((e, r)=>r.valid ? e + r.value : e, 0);
                        return {
                            count: r,
                            die: l,
                            rolls: t,
                            success: e.targets ? a > 0 : null,
                            successes: o,
                            failures: s,
                            type: "die",
                            valid: !0,
                            value: n ? u : a,
                            order: 0,
                            matched: n
                        };
                    }
                    rollExpression(e) {
                        const r = this.rollType(e.head), t = [
                            r
                        ], l = [], o = e.ops.reduce((e, r)=>{
                            const o = this.rollType(r.tail);
                            switch(t.push(o), l.push(r.op), r.op){
                                case "+":
                                    return e + o.value;
                                case "-":
                                    return e - o.value;
                                case "*":
                                    return e * o.value;
                                case "/":
                                    return e / o.value;
                                case "%":
                                    return e % o.value;
                                case "**":
                                    return e ** o.value;
                                default:
                                    return e;
                            }
                        }, r.value);
                        return {
                            dice: t,
                            ops: l,
                            success: null,
                            successes: 0,
                            failures: 0,
                            type: "expressionroll",
                            valid: !0,
                            value: o,
                            order: 0
                        };
                    }
                    rollFunction(e) {
                        const r = this.rollType(e.expr);
                        let t;
                        switch(e.op){
                            case "floor":
                                t = Math.floor(r.value);
                                break;
                            case "ceil":
                                t = Math.ceil(r.value);
                                break;
                            case "round":
                                t = Math.round(r.value);
                                break;
                            case "abs":
                                t = Math.abs(r.value);
                                break;
                            default:
                                t = r.value;
                        }
                        return {
                            expr: r,
                            op: e.op,
                            success: null,
                            successes: 0,
                            failures: 0,
                            type: "mathfunction",
                            valid: !0,
                            value: t,
                            order: 0
                        };
                    }
                    applyGroupMod(e, r) {
                        return this.getGroupModMethod(r)(e);
                    }
                    getGroupModMethod(e) {
                        const r = (e)=>e.value;
                        switch(e.type){
                            case "success":
                                return this.getSuccessMethod(e, r);
                            case "failure":
                                return this.getFailureMethod(e, r);
                            case "keep":
                                return this.getKeepMethod(e, r);
                            case "drop":
                                return this.getDropMethod(e, r);
                            default:
                                throw new Error(`Mod ${e.type} is not recognised`);
                        }
                    }
                    applyMod(e, r) {
                        return this.getModMethod(r)(e);
                    }
                    getModMethod(e) {
                        const r = (e)=>e.roll;
                        switch(e.type){
                            case "success":
                                return this.getSuccessMethod(e, r);
                            case "failure":
                                return this.getFailureMethod(e, r);
                            case "crit":
                                return this.getCritSuccessMethod(e, r);
                            case "critfail":
                                return this.getCritFailureMethod(e, r);
                            case "keep":
                                return (t)=>this.getKeepMethod(e, r)(t).sort((e, r)=>e.order - r.order);
                            case "drop":
                                return (t)=>this.getDropMethod(e, r)(t).sort((e, r)=>e.order - r.order);
                            case "explode":
                                return this.getExplodeMethod(e);
                            case "compound":
                                return this.getCompoundMethod(e);
                            case "penetrate":
                                return this.getPenetrateMethod(e);
                            case "reroll":
                                return this.getReRollMethod(e);
                            case "rerollOnce":
                                return this.getReRollOnceMethod(e);
                            default:
                                throw new Error(`Mod ${e.type} is not recognised`);
                        }
                    }
                    applySort(e, r) {
                        return e.sort((e, t)=>r.asc ? e.roll - t.roll : t.roll - e.roll), e.forEach((e, r)=>e.order = r), e;
                    }
                    getCritSuccessMethod(e, r) {
                        const t = this.rollType(e.expr);
                        return (l)=>l.map((l)=>{
                                if (!l.valid) return l;
                                if ("roll" !== l.type) return l;
                                if (l.success) return l;
                                const o = l;
                                return this.successTest(e.mod, t.value, r(l)) ? o.critical = "success" : "success" === o.critical && (o.critical = null), l;
                            });
                    }
                    getCritFailureMethod(e, r) {
                        const t = this.rollType(e.expr);
                        return (l)=>l.map((l)=>{
                                if (!l.valid) return l;
                                if ("roll" !== l.type) return l;
                                if (l.success) return l;
                                const o = l;
                                return this.successTest(e.mod, t.value, r(l)) ? o.critical = "failure" : "failure" === o.critical && (o.critical = null), l;
                            });
                    }
                    getSuccessMethod(e, r) {
                        const t = this.rollType(e.expr);
                        return (l)=>l.map((l)=>l.valid ? (this.successTest(e.mod, t.value, r(l)) && (l.successes += 1), l) : l);
                    }
                    getFailureMethod(e, r) {
                        const t = this.rollType(e.expr);
                        return (l)=>l.map((l)=>l.valid ? (this.successTest(e.mod, t.value, r(l)) && (l.failures += 1), l) : l);
                    }
                    getKeepMethod(e, r) {
                        const t = this.rollType(e.expr);
                        return (l)=>{
                            if (0 === l.length) return l;
                            l = l.sort((t, l)=>"l" === e.highlow ? r(l) - r(t) : r(t) - r(l)).sort((e, r)=>(e.valid ? 1 : 0) - (r.valid ? 1 : 0));
                            const o = Math.max(Math.min(t.value, l.length), 0);
                            let s = 0, n = 0;
                            const u = l.reduce((e, r)=>(r.valid ? 1 : 0) + e, 0) - o;
                            for(; n < l.length && s < u;)l[n].valid && (l[n].valid = !1, l[n].drop = !0, s++), n++;
                            return l;
                        };
                    }
                    getDropMethod(e, r) {
                        const t = this.rollType(e.expr);
                        return (l)=>{
                            l = l.sort((t, l)=>"h" === e.highlow ? r(l) - r(t) : r(t) - r(l));
                            const o = Math.max(Math.min(t.value, l.length), 0);
                            let s = 0, n = 0;
                            for(; n < l.length && s < o;)l[n].valid && (l[n].valid = !1, l[n].drop = !0, s++), n++;
                            return l;
                        };
                    }
                    getExplodeMethod(e) {
                        const r = e.target ? this.rollType(e.target.value) : null;
                        return (t)=>{
                            const l = r ? (t)=>this.successTest(e.target.mod, r.value, t.roll) : (e)=>this.successTest("=", "fateroll" === e.type ? 1 : e.die, e.roll);
                            if ("roll" === t[0].type && l({
                                roll: 1
                            }) && l({
                                roll: t[0].die
                            })) throw new Error("Invalid reroll target");
                            for(let e = 0; e < t.length; e++){
                                let r = t[e];
                                r.order = e;
                                let o = 0;
                                for(; l(r) && o++ < 1e3;){
                                    r.explode = !0;
                                    const l = this.reRoll(r, ++e);
                                    t.splice(e, 0, l), r = l;
                                }
                            }
                            return t;
                        };
                    }
                    getCompoundMethod(e) {
                        const r = e.target ? this.rollType(e.target.value) : null;
                        return (t)=>{
                            const l = r ? (t)=>this.successTest(e.target.mod, r.value, t.roll) : (e)=>this.successTest("=", "fateroll" === e.type ? 1 : e.die, e.roll);
                            if ("roll" === t[0].type && l({
                                roll: 1
                            }) && l({
                                roll: t[0].die
                            })) throw new Error("Invalid reroll target");
                            for(let e = 0; e < t.length; e++){
                                let r = t[e], o = r.roll, s = 0;
                                for(; l(r) && s++ < 1e3;){
                                    r.explode = !0;
                                    const t = this.reRoll(r, e + 1);
                                    o += t.roll, r = t;
                                }
                                t[e].value = o, t[e].roll = o;
                            }
                            return t;
                        };
                    }
                    getPenetrateMethod(e) {
                        const r = e.target ? this.rollType(e.target.value) : null;
                        return (t)=>{
                            const l = r ? (t)=>this.successTest(e.target.mod, r.value, t.roll) : (e)=>this.successTest("=", "fateroll" === e.type ? 1 : e.die, e.roll);
                            if (r && "roll" === t[0].type && l(t[0]) && this.successTest(e.target.mod, r.value, 1)) throw new Error("Invalid reroll target");
                            for(let e = 0; e < t.length; e++){
                                let r = t[e];
                                r.order = e;
                                let o = 0;
                                for(; l(r) && o++ < 1e3;){
                                    r.explode = !0;
                                    const l = this.reRoll(r, ++e);
                                    l.value -= 1, t.splice(e, 0, l), r = l;
                                }
                            }
                            return t;
                        };
                    }
                    getReRollMethod(e) {
                        const r = e.target ? this.successTest.bind(null, e.target.mod, this.rollType(e.target.value).value) : this.successTest.bind(null, "=", 1);
                        return (e)=>{
                            if ("roll" === e[0].type && r(1) && r(e[0].die)) throw new Error("Invalid reroll target");
                            for(let t = 0; t < e.length; t++)for(; r(e[t].roll);){
                                e[t].reroll = !0, e[t].valid = !1;
                                const r = this.reRoll(e[t], t + 1);
                                e.splice(++t, 0, r);
                            }
                            return e;
                        };
                    }
                    getReRollOnceMethod(e) {
                        const r = e.target ? this.successTest.bind(null, e.target.mod, this.rollType(e.target.value).value) : this.successTest.bind(null, "=", 1);
                        return (e)=>{
                            if ("roll" === e[0].type && r(1) && r(e[0].die)) throw new Error("Invalid reroll target");
                            for(let t = 0; t < e.length; t++)if (r(e[t].roll)) {
                                e[t].reroll = !0, e[t].valid = !1;
                                const r = this.reRoll(e[t], t + 1);
                                e.splice(++t, 0, r);
                            }
                            return e;
                        };
                    }
                    successTest(e, r, t) {
                        switch(e){
                            case ">":
                                return t >= r;
                            case "<":
                                return t <= r;
                            default:
                                return t == r;
                        }
                    }
                    reRoll(e, r) {
                        switch(e.type){
                            case "roll":
                                return this.generateDiceRoll(e.die, r);
                            case "fateroll":
                                return this.generateFateRoll(r);
                            default:
                                throw new Error(`Cannot do a reroll of a ${e.type}.`);
                        }
                    }
                    generateDiceRoll(e, r) {
                        const t = parseInt(Math.floor(this.randFunction() * e).toFixed(), 10) + 1;
                        return {
                            critical: t === e ? "success" : 1 === t ? "failure" : null,
                            die: e,
                            matched: !1,
                            order: r,
                            roll: t,
                            success: null,
                            successes: 0,
                            failures: 0,
                            type: "roll",
                            valid: !0,
                            value: t
                        };
                    }
                    generateFateRoll(e) {
                        const r = Math.floor(3 * this.randFunction()) - 1;
                        return {
                            matched: !1,
                            order: e,
                            roll: r,
                            success: null,
                            successes: 0,
                            failures: 0,
                            type: "fateroll",
                            valid: !0,
                            value: r
                        };
                    }
                };
            },
            619: (e, r)=>{
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.DiscordRollRenderer = void 0, r.DiscordRollRenderer = class {
                    render(e) {
                        return this.doRender(e, !0);
                    }
                    doRender(e, r = !1) {
                        let t = "";
                        switch(e.type){
                            case "diceexpressionroll":
                                t = this.renderGroupExpr(e);
                                break;
                            case "grouproll":
                                t = this.renderGroup(e);
                                break;
                            case "die":
                                t = this.renderDie(e);
                                break;
                            case "expressionroll":
                                t = this.renderExpression(e);
                                break;
                            case "mathfunction":
                                t = this.renderFunction(e);
                                break;
                            case "roll":
                                return this.renderRoll(e);
                            case "fateroll":
                                return this.renderFateRoll(e);
                            case "number":
                                const r1 = e.label ? ` (${e.label})` : "";
                                return `${e.value}${r1}`;
                            case "fate":
                                return "F";
                            default:
                                throw new Error("Unable to render");
                        }
                        return e.valid || (t = "~~" + t.replace(/~~/g, "") + "~~"), r ? this.stripBrackets(t) : e.label ? `(${e.label}: ${t})` : t;
                    }
                    renderGroup(e) {
                        const r = [];
                        for (const t of e.dice)r.push(this.doRender(t));
                        return r.length > 1 ? `{ ${r.join(" + ")} } = ${e.value}` : `{ ${this.stripBrackets(r[0])} } = ${e.value}`;
                    }
                    renderGroupExpr(e) {
                        const r = [];
                        for (const t of e.dice)r.push(this.doRender(t));
                        return r.length > 1 ? `(${r.join(" + ")} = ${e.value})` : r[0];
                    }
                    renderDie(e) {
                        const r = [];
                        for (const t of e.rolls)r.push(this.doRender(t));
                        let t = `${r.join(", ")}`;
                        [
                            "number",
                            "fate"
                        ].includes(e.die.type) && "number" === e.count.type || (t += `[*Rolling: ${this.doRender(e.count)}d${this.doRender(e.die)}*]`);
                        const l = e.matched ? " Match" + (1 === e.value ? "" : "es") : "";
                        return t += ` = ${e.value}${l}`, `(${t})`;
                    }
                    renderExpression(e) {
                        if (e.dice.length > 1) {
                            const r = [];
                            for(let t = 0; t < e.dice.length - 1; t++)r.push(this.doRender(e.dice[t])), r.push(e.ops[t]);
                            return r.push(this.doRender(e.dice.slice(-1)[0])), r.push("="), r.push(e.value + ""), `(${r.join(" ")})`;
                        }
                        return "number" === e.dice[0].type ? e.value + "" : this.doRender(e.dice[0]);
                    }
                    renderFunction(e) {
                        const r = this.doRender(e.expr);
                        return `(${e.op}${this.addBrackets(r)} = ${e.value})`;
                    }
                    addBrackets(e) {
                        return e.startsWith("(") || (e = `(${e}`), e.endsWith(")") || (e = `${e})`), e;
                    }
                    stripBrackets(e) {
                        return e.startsWith("(") && (e = e.substring(1)), e.endsWith(")") && (e = e.substring(0, e.length - 1)), e;
                    }
                    renderRoll(e) {
                        let r = `${e.roll}`;
                        return e.valid ? e.success && 1 === e.value ? r = `**${e.roll}**` : e.success && -1 === e.value ? r = `*${e.roll}*` : e.success || "success" !== e.critical ? e.success || "failure" !== e.critical || (r = `*${e.roll}*`) : r = `**${e.roll}**` : r = `~~${e.roll}~~`, e.matched && (r = `__${r}__`), r;
                    }
                    renderFateRoll(e) {
                        const r = 0 === e.roll ? "0" : e.roll > 0 ? "+" : "-";
                        let t = `${e.roll}`;
                        return e.valid ? e.success && 1 === e.value ? t = `**${r}**` : e.success && -1 === e.value && (t = `*${r}*`) : t = `~~${r}~~`, e.matched && (t = `__${t}__`), t;
                    }
                };
            },
            607: function(e, r, t) {
                var l = this && this.__createBinding || (Object.create ? function(e, r, t, l) {
                    void 0 === l && (l = t);
                    var o = Object.getOwnPropertyDescriptor(r, t);
                    o && !("get" in o ? !r.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return r[t];
                        }
                    }), Object.defineProperty(e, l, o);
                } : function(e, r, t, l) {
                    void 0 === l && (l = t), e[l] = r[t];
                }), o = this && this.__exportStar || function(e, r) {
                    for(var t in e)"default" === t || Object.prototype.hasOwnProperty.call(r, t) || l(r, e, t);
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), o(t(95), r), o(t(604), r), o(t(234), r), o(t(619), r), o(t(54), r);
            },
            604: (e, r)=>{
                Object.defineProperty(r, "__esModule", {
                    value: !0
                });
            },
            234: (e, r)=>{
                Object.defineProperty(r, "__esModule", {
                    value: !0
                });
            },
            54: (e, r)=>{
                Object.defineProperty(r, "__esModule", {
                    value: !0
                });
            },
            51: (e)=>{
                function r(e, t, l, o) {
                    this.message = e, this.expected = t, this.found = l, this.location = o, this.name = "SyntaxError", "function" == typeof Error.captureStackTrace && Error.captureStackTrace(this, r);
                }
                !function(e, r) {
                    function t() {
                        this.constructor = e;
                    }
                    t.prototype = r.prototype, e.prototype = new t;
                }(r, Error), r.buildMessage = function(e, r) {
                    var t = {
                        literal: function(e) {
                            return '"' + o(e.text) + '"';
                        },
                        class: function(e) {
                            var r, t = "";
                            for(r = 0; r < e.parts.length; r++)t += e.parts[r] instanceof Array ? s(e.parts[r][0]) + "-" + s(e.parts[r][1]) : s(e.parts[r]);
                            return "[" + (e.inverted ? "^" : "") + t + "]";
                        },
                        any: function(e) {
                            return "any character";
                        },
                        end: function(e) {
                            return "end of input";
                        },
                        other: function(e) {
                            return e.description;
                        }
                    };
                    function l(e) {
                        return e.charCodeAt(0).toString(16).toUpperCase();
                    }
                    function o(e) {
                        return e.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(e) {
                            return "\\x0" + l(e);
                        }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(e) {
                            return "\\x" + l(e);
                        });
                    }
                    function s(e) {
                        return e.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(e) {
                            return "\\x0" + l(e);
                        }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(e) {
                            return "\\x" + l(e);
                        });
                    }
                    return "Expected " + function(e) {
                        var r, l, o, s = new Array(e.length);
                        for(r = 0; r < e.length; r++)s[r] = (o = e[r], t[o.type](o));
                        if (s.sort(), s.length > 0) {
                            for(r = 1, l = 1; r < s.length; r++)s[r - 1] !== s[r] && (s[l] = s[r], l++);
                            s.length = l;
                        }
                        switch(s.length){
                            case 1:
                                return s[0];
                            case 2:
                                return s[0] + " or " + s[1];
                            default:
                                return s.slice(0, -1).join(", ") + ", or " + s[s.length - 1];
                        }
                    }(e) + " but " + function(e) {
                        return e ? '"' + o(e) + '"' : "end of input";
                    }(r) + " found.";
                }, e.exports = {
                    SyntaxError: r,
                    parse: function(e, t) {
                        t = void 0 !== t ? t : {};
                        var l, o = {}, s = {
                            start: Me
                        }, n = Me, u = {
                            type: "any"
                        }, a = ye("[[", !1), c = ye("]]", !1), i = function(e, r) {
                            return r && (e.label = r), e;
                        }, d = ">", h = ye(">", !1), p = "<", f = ye("<", !1), v = "=", g = ye("=", !1), y = ye("f", !1), m = ye("cs", !1), b = ye("cf", !1), x = ye("m", !1), A = ye("t", !1), C = ye("k", !1), M = ye("l", !1), R = ye("h", !1), w = ye("d", !1), T = ye("{", !1), $ = ye(",", !1), E = ye("}", !1), F = "+", k = ye("+", !1), _ = ye("s", !1), j = ye("a", !1), O = ye("!", !1), D = ye("!!", !1), S = ye("!p", !1), P = ye("r", !1), G = ye("ro", !1), I = ye("F", !1), B = ye("%", !1), W = ye("(", !1), K = ye(")", !1), U = ye("-", !1), z = function(e, r) {
                            return 0 == r.length ? e : {
                                head: e,
                                type: "expression",
                                ops: r.map((e)=>({
                                        type: "math",
                                        op: e[1],
                                        tail: e[3]
                                    }))
                            };
                        }, V = ye("*", !1), q = ye("/", !1), H = "**", J = ye("**", !1), L = "floor", N = ye("floor", !1), Q = "ceil", X = ye("ceil", !1), Y = "round", Z = ye("round", !1), ee = ye("abs", !1), re = be("integer"), te = /^[0-9]/, le = me([
                            [
                                "0",
                                "9"
                            ]
                        ], !1, !1), oe = ye("[", !1), se = /^[^\]]/, ne = me([
                            "]"
                        ], !0, !1), ue = ye("]", !1), ae = be("whitespace"), ce = /^[ \t\n\r]/, ie = me([
                            " ",
                            "	",
                            "\n",
                            "\r"
                        ], !1, !1), de = 0, he = 0, pe = [
                            {
                                line: 1,
                                column: 1
                            }
                        ], fe = 0, ve = [], ge = 0;
                        if ("startRule" in t) {
                            if (!(t.startRule in s)) throw new Error("Can't start parsing from rule \"" + t.startRule + '".');
                            n = s[t.startRule];
                        }
                        function ye(e, r) {
                            return {
                                type: "literal",
                                text: e,
                                ignoreCase: r
                            };
                        }
                        function me(e, r, t) {
                            return {
                                type: "class",
                                parts: e,
                                inverted: r,
                                ignoreCase: t
                            };
                        }
                        function be(e) {
                            return {
                                type: "other",
                                description: e
                            };
                        }
                        function xe(r) {
                            var t, l = pe[r];
                            if (l) return l;
                            for(t = r - 1; !pe[t];)t--;
                            for(l = {
                                line: (l = pe[t]).line,
                                column: l.column
                            }; t < r;)10 === e.charCodeAt(t) ? (l.line++, l.column = 1) : l.column++, t++;
                            return pe[r] = l, l;
                        }
                        function Ae(e, r) {
                            var t = xe(e), l = xe(r);
                            return {
                                start: {
                                    offset: e,
                                    line: t.line,
                                    column: t.column
                                },
                                end: {
                                    offset: r,
                                    line: l.line,
                                    column: l.column
                                }
                            };
                        }
                        function Ce(e) {
                            de < fe || (de > fe && (fe = de, ve = []), ve.push(e));
                        }
                        function Me() {
                            var r, t, l, s, n, a;
                            if (r = de, (t = We()) !== o) {
                                for(l = [], e.length > de ? (s = e.charAt(de), de++) : (s = o, 0 === ge && Ce(u)); s !== o;)l.push(s), e.length > de ? (s = e.charAt(de), de++) : (s = o, 0 === ge && Ce(u));
                                l !== o ? (he = r, a = l, (n = t).root = !0, a && (n.label = a.join("")), r = t = n) : (de = r, r = o);
                            } else de = r, r = o;
                            return r;
                        }
                        function Re() {
                            var r, t, l;
                            return r = de, 62 === e.charCodeAt(de) ? (t = d, de++) : (t = o, 0 === ge && Ce(h)), t === o && (60 === e.charCodeAt(de) ? (t = p, de++) : (t = o, 0 === ge && Ce(f)), t === o && (61 === e.charCodeAt(de) ? (t = v, de++) : (t = o, 0 === ge && Ce(g)))), t !== o && (l = Be()) !== o ? (he = r, r = t = {
                                type: "success",
                                mod: t,
                                expr: l
                            }) : (de = r, r = o), r;
                        }
                        function we() {
                            var r, t, l, s;
                            return r = de, 102 === e.charCodeAt(de) ? (t = "f", de++) : (t = o, 0 === ge && Ce(y)), t !== o ? (62 === e.charCodeAt(de) ? (l = d, de++) : (l = o, 0 === ge && Ce(h)), l === o && (60 === e.charCodeAt(de) ? (l = p, de++) : (l = o, 0 === ge && Ce(f)), l === o && (61 === e.charCodeAt(de) ? (l = v, de++) : (l = o, 0 === ge && Ce(g)))), l === o && (l = null), l !== o && (s = Be()) !== o ? (he = r, r = t = {
                                type: "failure",
                                mod: l,
                                expr: s
                            }) : (de = r, r = o)) : (de = r, r = o), r;
                        }
                        function Te() {
                            var r, t, l, s;
                            return r = de, "cs" === e.substr(de, 2) ? (t = "cs", de += 2) : (t = o, 0 === ge && Ce(m)), t !== o ? (62 === e.charCodeAt(de) ? (l = d, de++) : (l = o, 0 === ge && Ce(h)), l === o && (60 === e.charCodeAt(de) ? (l = p, de++) : (l = o, 0 === ge && Ce(f)), l === o && (61 === e.charCodeAt(de) ? (l = v, de++) : (l = o, 0 === ge && Ce(g)))), l === o && (l = null), l !== o && (s = Be()) !== o ? (he = r, r = t = {
                                type: "crit",
                                mod: l,
                                expr: s
                            }) : (de = r, r = o)) : (de = r, r = o), r;
                        }
                        function $e() {
                            var r, t, l, s;
                            return r = de, "cf" === e.substr(de, 2) ? (t = "cf", de += 2) : (t = o, 0 === ge && Ce(b)), t !== o ? (62 === e.charCodeAt(de) ? (l = d, de++) : (l = o, 0 === ge && Ce(h)), l === o && (60 === e.charCodeAt(de) ? (l = p, de++) : (l = o, 0 === ge && Ce(f)), l === o && (61 === e.charCodeAt(de) ? (l = v, de++) : (l = o, 0 === ge && Ce(g)))), l === o && (l = null), l !== o && (s = Be()) !== o ? (he = r, r = t = {
                                type: "critfail",
                                mod: l,
                                expr: s
                            }) : (de = r, r = o)) : (de = r, r = o), r;
                        }
                        function Ee() {
                            var r, t, l, s;
                            return r = de, 107 === e.charCodeAt(de) ? (t = "k", de++) : (t = o, 0 === ge && Ce(C)), t !== o ? (108 === e.charCodeAt(de) ? (l = "l", de++) : (l = o, 0 === ge && Ce(M)), l === o && (104 === e.charCodeAt(de) ? (l = "h", de++) : (l = o, 0 === ge && Ce(R))), l === o && (l = null), l !== o ? ((s = Be()) === o && (s = null), s !== o ? (he = r, r = t = {
                                type: "keep",
                                highlow: l,
                                expr: s || Qe
                            }) : (de = r, r = o)) : (de = r, r = o)) : (de = r, r = o), r;
                        }
                        function Fe() {
                            var r, t, l, s;
                            return r = de, 100 === e.charCodeAt(de) ? (t = "d", de++) : (t = o, 0 === ge && Ce(w)), t !== o ? (108 === e.charCodeAt(de) ? (l = "l", de++) : (l = o, 0 === ge && Ce(M)), l === o && (104 === e.charCodeAt(de) ? (l = "h", de++) : (l = o, 0 === ge && Ce(R))), l === o && (l = null), l !== o ? ((s = Be()) === o && (s = null), s !== o ? (he = r, r = t = {
                                type: "drop",
                                highlow: l,
                                expr: s || Qe
                            }) : (de = r, r = o)) : (de = r, r = o)) : (de = r, r = o), r;
                        }
                        function ke() {
                            var r, t, l, s, n, u, a, c, i, d;
                            if (r = de, (t = _e()) !== o) {
                                for(l = [], s = de, (n = Le()) !== o ? (43 === e.charCodeAt(de) ? (u = F, de++) : (u = o, 0 === ge && Ce(k)), u !== o && (a = Le()) !== o && (c = _e()) !== o ? s = n = [
                                    n,
                                    u,
                                    a,
                                    c
                                ] : (de = s, s = o)) : (de = s, s = o); s !== o;)l.push(s), s = de, (n = Le()) !== o ? (43 === e.charCodeAt(de) ? (u = F, de++) : (u = o, 0 === ge && Ce(k)), u !== o && (a = Le()) !== o && (c = _e()) !== o ? s = n = [
                                    n,
                                    u,
                                    a,
                                    c
                                ] : (de = s, s = o)) : (de = s, s = o);
                                l !== o ? (he = r, i = t, r = t = 0 == (d = l).length ? i : {
                                    head: i,
                                    type: "diceExpression",
                                    ops: d.map((e)=>({
                                            type: "math",
                                            op: e[1],
                                            tail: e[3]
                                        }))
                                }) : (de = r, r = o);
                            } else de = r, r = o;
                            return r;
                        }
                        function _e() {
                            var e;
                            return (e = je()) === o && (e = We()), e;
                        }
                        function je() {
                            var r, t, l;
                            return r = de, t = function() {
                                var r, t, l, s, n;
                                if (r = de, t = function() {
                                    var r, t, l, s, n, u;
                                    if (r = de, t = function() {
                                        var r, t, l, s;
                                        return r = de, (t = Be()) === o && (t = null), t !== o ? (100 === e.charCodeAt(de) ? (l = "d", de++) : (l = o, 0 === ge && Ce(w)), l !== o ? (s = function() {
                                            var r, t;
                                            return r = de, 70 === e.charCodeAt(de) ? (t = "F", de++) : (t = o, 0 === ge && Ce(I)), t === o && (102 === e.charCodeAt(de) ? (t = "f", de++) : (t = o, 0 === ge && Ce(y))), t !== o && (he = r, t = {
                                                type: "fate"
                                            }), t;
                                        }(), s === o && (s = function() {
                                            var r, t;
                                            return r = de, 37 === e.charCodeAt(de) ? (t = "%", de++) : (t = o, 0 === ge && Ce(B)), t !== o && (he = r, t = {
                                                type: "number",
                                                value: "100"
                                            }), t;
                                        }(), s === o && (s = Be())), s !== o ? (he = r, r = t = {
                                            die: s,
                                            count: t || {
                                                type: "number",
                                                value: 1
                                            },
                                            type: "die"
                                        }) : (de = r, r = o)) : (de = r, r = o)) : (de = r, r = o), r;
                                    }(), t !== o) {
                                        for(l = [], (s = De()) === o && (s = Se()) === o && (s = Oe()) === o && (s = Ge()) === o && (s = Pe()); s !== o;)l.push(s), (s = De()) === o && (s = Se()) === o && (s = Oe()) === o && (s = Ge()) === o && (s = Pe());
                                        l !== o ? (he = r, u = l, (n = t).mods = (n.mods || []).concat(u), r = t = n) : (de = r, r = o);
                                    } else de = r, r = o;
                                    return r;
                                }(), t !== o) {
                                    for(l = [], (s = Fe()) === o && (s = Ee()) === o && (s = Re()) === o && (s = we()) === o && (s = $e()) === o && (s = Te()); s !== o;)l.push(s), (s = Fe()) === o && (s = Ee()) === o && (s = Re()) === o && (s = we()) === o && (s = $e()) === o && (s = Te());
                                    l !== o ? ((s = function() {
                                        var r, t, l, s, n;
                                        return r = de, 109 === e.charCodeAt(de) ? (t = "m", de++) : (t = o, 0 === ge && Ce(x)), t !== o ? (116 === e.charCodeAt(de) ? (l = "t", de++) : (l = o, 0 === ge && Ce(A)), l === o && (l = null), l !== o ? ((s = He()) === o && (s = null), s !== o ? (n = function() {
                                            var r, t, l;
                                            return r = de, 62 === e.charCodeAt(de) ? (t = d, de++) : (t = o, 0 === ge && Ce(h)), t === o && (60 === e.charCodeAt(de) ? (t = p, de++) : (t = o, 0 === ge && Ce(f)), t === o && (61 === e.charCodeAt(de) ? (t = v, de++) : (t = o, 0 === ge && Ce(g)))), t !== o && (l = Be()) !== o ? (he = r, r = t = {
                                                mod: t,
                                                expr: l
                                            }) : (de = r, r = o), r;
                                        }(), n === o && (n = null), n !== o ? (he = r, r = t = function(e, r, t) {
                                            const l = {
                                                type: "match",
                                                min: r || {
                                                    type: "number",
                                                    value: 2
                                                },
                                                count: !!e
                                            };
                                            return t && (l.mod = t.mod, l.expr = t.expr), l;
                                        }(l, s, n)) : (de = r, r = o)) : (de = r, r = o)) : (de = r, r = o)) : (de = r, r = o), r;
                                    }()) === o && (s = null), s !== o ? (n = function() {
                                        var r, t, l;
                                        return r = de, 115 === e.charCodeAt(de) ? (t = "s", de++) : (t = o, 0 === ge && Ce(_)), t !== o ? (97 === e.charCodeAt(de) ? (l = "a", de++) : (l = o, 0 === ge && Ce(j)), l === o && (100 === e.charCodeAt(de) ? (l = "d", de++) : (l = o, 0 === ge && Ce(w))), l === o && (l = null), l !== o ? (he = r, r = t = "d" == l ? {
                                            type: "sort",
                                            asc: !1
                                        } : {
                                            type: "sort",
                                            asc: !0
                                        }) : (de = r, r = o)) : (de = r, r = o), r;
                                    }(), n === o && (n = null), n !== o ? (he = r, r = t = function(e, r, t, l) {
                                        const o = r.filter((e)=>[
                                                "success",
                                                "failure"
                                            ].includes(e.type));
                                        return r = r.filter((e)=>!o.includes(e)), e.mods = (e.mods || []).concat(r), o.length > 0 && (e.targets = o), t && (e.match = t), l && (e.sort = l), e;
                                    }(t, l, s, n)) : (de = r, r = o)) : (de = r, r = o)) : (de = r, r = o);
                                } else de = r, r = o;
                                return r;
                            }(), t !== o && Le() !== o ? ((l = Je()) === o && (l = null), l !== o ? (he = r, r = t = i(t, l)) : (de = r, r = o)) : (de = r, r = o), r;
                        }
                        function Oe() {
                            var r, t, l;
                            return r = de, 33 === e.charCodeAt(de) ? (t = "!", de++) : (t = o, 0 === ge && Ce(O)), t !== o ? ((l = Ie()) === o && (l = null), l !== o ? (he = r, r = t = {
                                type: "explode",
                                target: l
                            }) : (de = r, r = o)) : (de = r, r = o), r;
                        }
                        function De() {
                            var r, t, l;
                            return r = de, "!!" === e.substr(de, 2) ? (t = "!!", de += 2) : (t = o, 0 === ge && Ce(D)), t !== o ? ((l = Ie()) === o && (l = null), l !== o ? (he = r, r = t = {
                                type: "compound",
                                target: l
                            }) : (de = r, r = o)) : (de = r, r = o), r;
                        }
                        function Se() {
                            var r, t, l;
                            return r = de, "!p" === e.substr(de, 2) ? (t = "!p", de += 2) : (t = o, 0 === ge && Ce(S)), t !== o ? ((l = Ie()) === o && (l = null), l !== o ? (he = r, r = t = {
                                type: "penetrate",
                                target: l
                            }) : (de = r, r = o)) : (de = r, r = o), r;
                        }
                        function Pe() {
                            var r, t, l;
                            return r = de, 114 === e.charCodeAt(de) ? (t = "r", de++) : (t = o, 0 === ge && Ce(P)), t !== o ? ((l = Ie()) === o && (l = null), l !== o ? (he = r, r = t = {
                                type: "reroll",
                                target: l || Ne
                            }) : (de = r, r = o)) : (de = r, r = o), r;
                        }
                        function Ge() {
                            var r, t, l;
                            return r = de, "ro" === e.substr(de, 2) ? (t = "ro", de += 2) : (t = o, 0 === ge && Ce(G)), t !== o ? ((l = Ie()) === o && (l = null), l !== o ? (he = r, r = t = {
                                type: "rerollOnce",
                                target: l || Ne
                            }) : (de = r, r = o)) : (de = r, r = o), r;
                        }
                        function Ie() {
                            var r, t, l;
                            return r = de, 62 === e.charCodeAt(de) ? (t = d, de++) : (t = o, 0 === ge && Ce(h)), t === o && (60 === e.charCodeAt(de) ? (t = p, de++) : (t = o, 0 === ge && Ce(f)), t === o && (61 === e.charCodeAt(de) ? (t = v, de++) : (t = o, 0 === ge && Ce(g)))), t === o && (t = null), t !== o && (l = Be()) !== o ? (he = r, r = t = {
                                type: "target",
                                mod: t,
                                value: l
                            }) : (de = r, r = o), r;
                        }
                        function Be() {
                            var e;
                            return (e = Ke()) === o && (e = He()), e;
                        }
                        function We() {
                            var r;
                            return (r = function() {
                                var r, t, l, s;
                                return r = de, "[[" === e.substr(de, 2) ? (t = "[[", de += 2) : (t = o, 0 === ge && Ce(a)), t !== o && (l = We()) !== o ? ("]]" === e.substr(de, 2) ? (s = "]]", de += 2) : (s = o, 0 === ge && Ce(c)), s !== o ? (he = r, r = t = {
                                    type: "inline",
                                    expr: l
                                }) : (de = r, r = o)) : (de = r, r = o), r;
                            }()) === o && (r = Ue()) === o && (r = Ke()), r;
                        }
                        function Ke() {
                            var r, t, l, s, n, u, a;
                            return r = de, 40 === e.charCodeAt(de) ? (t = "(", de++) : (t = o, 0 === ge && Ce(W)), t !== o && (l = Ue()) !== o ? (41 === e.charCodeAt(de) ? (s = ")", de++) : (s = o, 0 === ge && Ce(K)), s !== o && Le() !== o ? ((n = Je()) === o && (n = null), n !== o ? (he = r, u = l, (a = n) && (u.label = a), r = t = u) : (de = r, r = o)) : (de = r, r = o)) : (de = r, r = o), r;
                        }
                        function Ue() {
                            var r, t, l, s, n, u, a, c;
                            if (r = de, (t = ze()) !== o) {
                                for(l = [], s = de, (n = Le()) !== o ? (43 === e.charCodeAt(de) ? (u = F, de++) : (u = o, 0 === ge && Ce(k)), u === o && (45 === e.charCodeAt(de) ? (u = "-", de++) : (u = o, 0 === ge && Ce(U))), u !== o && (a = Le()) !== o && (c = ze()) !== o ? s = n = [
                                    n,
                                    u,
                                    a,
                                    c
                                ] : (de = s, s = o)) : (de = s, s = o); s !== o;)l.push(s), s = de, (n = Le()) !== o ? (43 === e.charCodeAt(de) ? (u = F, de++) : (u = o, 0 === ge && Ce(k)), u === o && (45 === e.charCodeAt(de) ? (u = "-", de++) : (u = o, 0 === ge && Ce(U))), u !== o && (a = Le()) !== o && (c = ze()) !== o ? s = n = [
                                    n,
                                    u,
                                    a,
                                    c
                                ] : (de = s, s = o)) : (de = s, s = o);
                                l !== o ? (he = r, r = t = z(t, l)) : (de = r, r = o);
                            } else de = r, r = o;
                            return r;
                        }
                        function ze() {
                            var r, t, l, s, n, u, a, c;
                            if (r = de, (t = Ve()) !== o) {
                                for(l = [], s = de, (n = Le()) !== o ? (42 === e.charCodeAt(de) ? (u = "*", de++) : (u = o, 0 === ge && Ce(V)), u === o && (47 === e.charCodeAt(de) ? (u = "/", de++) : (u = o, 0 === ge && Ce(q))), u !== o && (a = Le()) !== o && (c = Ve()) !== o ? s = n = [
                                    n,
                                    u,
                                    a,
                                    c
                                ] : (de = s, s = o)) : (de = s, s = o); s !== o;)l.push(s), s = de, (n = Le()) !== o ? (42 === e.charCodeAt(de) ? (u = "*", de++) : (u = o, 0 === ge && Ce(V)), u === o && (47 === e.charCodeAt(de) ? (u = "/", de++) : (u = o, 0 === ge && Ce(q))), u !== o && (a = Le()) !== o && (c = Ve()) !== o ? s = n = [
                                    n,
                                    u,
                                    a,
                                    c
                                ] : (de = s, s = o)) : (de = s, s = o);
                                l !== o ? (he = r, r = t = z(t, l)) : (de = r, r = o);
                            } else de = r, r = o;
                            return r;
                        }
                        function Ve() {
                            var r, t, l, s, n, u, a, c;
                            if (r = de, (t = qe()) !== o) {
                                for(l = [], s = de, (n = Le()) !== o ? (e.substr(de, 2) === H ? (u = H, de += 2) : (u = o, 0 === ge && Ce(J)), u === o && (37 === e.charCodeAt(de) ? (u = "%", de++) : (u = o, 0 === ge && Ce(B))), u !== o && (a = Le()) !== o && (c = qe()) !== o ? s = n = [
                                    n,
                                    u,
                                    a,
                                    c
                                ] : (de = s, s = o)) : (de = s, s = o); s !== o;)l.push(s), s = de, (n = Le()) !== o ? (e.substr(de, 2) === H ? (u = H, de += 2) : (u = o, 0 === ge && Ce(J)), u === o && (37 === e.charCodeAt(de) ? (u = "%", de++) : (u = o, 0 === ge && Ce(B))), u !== o && (a = Le()) !== o && (c = qe()) !== o ? s = n = [
                                    n,
                                    u,
                                    a,
                                    c
                                ] : (de = s, s = o)) : (de = s, s = o);
                                l !== o ? (he = r, r = t = z(t, l)) : (de = r, r = o);
                            } else de = r, r = o;
                            return r;
                        }
                        function qe() {
                            var r;
                            return (r = function() {
                                var r, t, l, s, n;
                                return r = de, t = function() {
                                    var r;
                                    return e.substr(de, 5) === L ? (r = L, de += 5) : (r = o, 0 === ge && Ce(N)), r === o && (e.substr(de, 4) === Q ? (r = Q, de += 4) : (r = o, 0 === ge && Ce(X)), r === o && (e.substr(de, 5) === Y ? (r = Y, de += 5) : (r = o, 0 === ge && Ce(Z)), r === o && ("abs" === e.substr(de, 3) ? (r = "abs", de += 3) : (r = o, 0 === ge && Ce(ee))))), r;
                                }(), t !== o && Le() !== o ? (40 === e.charCodeAt(de) ? (l = "(", de++) : (l = o, 0 === ge && Ce(W)), l !== o && Le() !== o && (s = Ue()) !== o && Le() !== o ? (41 === e.charCodeAt(de) ? (n = ")", de++) : (n = o, 0 === ge && Ce(K)), n !== o ? (he = r, r = t = {
                                    type: "mathfunction",
                                    op: t,
                                    expr: s
                                }) : (de = r, r = o)) : (de = r, r = o)) : (de = r, r = o), r;
                            }()) === o && (r = function() {
                                var r, t, l;
                                return r = de, t = function() {
                                    var r, t, l, s, n, u, a, c;
                                    if (r = de, t = function() {
                                        var r, t, l, s, n, u, a, c, i;
                                        if (r = de, 123 === e.charCodeAt(de) ? (t = "{", de++) : (t = o, 0 === ge && Ce(T)), t !== o) {
                                            if (Le() !== o) {
                                                if ((l = ke()) !== o) {
                                                    for(s = [], n = de, (u = Le()) !== o ? (44 === e.charCodeAt(de) ? (a = ",", de++) : (a = o, 0 === ge && Ce($)), a !== o && (c = Le()) !== o && (i = ke()) !== o ? n = u = [
                                                        u,
                                                        a,
                                                        c,
                                                        i
                                                    ] : (de = n, n = o)) : (de = n, n = o); n !== o;)s.push(n), n = de, (u = Le()) !== o ? (44 === e.charCodeAt(de) ? (a = ",", de++) : (a = o, 0 === ge && Ce($)), a !== o && (c = Le()) !== o && (i = ke()) !== o ? n = u = [
                                                        u,
                                                        a,
                                                        c,
                                                        i
                                                    ] : (de = n, n = o)) : (de = n, n = o);
                                                    s !== o && (n = Le()) !== o ? (125 === e.charCodeAt(de) ? (u = "}", de++) : (u = o, 0 === ge && Ce(E)), u !== o ? (he = r, r = t = {
                                                        rolls: [
                                                            l,
                                                            ...s.map((e)=>e[3])
                                                        ],
                                                        type: "group"
                                                    }) : (de = r, r = o)) : (de = r, r = o);
                                                } else de = r, r = o;
                                            } else de = r, r = o;
                                        } else de = r, r = o;
                                        return r;
                                    }(), t !== o) {
                                        for(l = [], (s = Ee()) === o && (s = Fe()) === o && (s = Re()) === o && (s = we()); s !== o;)l.push(s), (s = Ee()) === o && (s = Fe()) === o && (s = Re()) === o && (s = we());
                                        l !== o && (s = Le()) !== o ? ((n = Je()) === o && (n = null), n !== o ? (he = r, u = t, c = n, (a = l).length > 0 && (u.mods = (u.mods || []).concat(a)), c && (u.label = c), r = t = u) : (de = r, r = o)) : (de = r, r = o);
                                    } else de = r, r = o;
                                    return r;
                                }(), t === o && (t = je()) === o && (t = He()), t !== o && Le() !== o ? ((l = Je()) === o && (l = null), l !== o ? (he = r, r = t = i(t, l)) : (de = r, r = o)) : (de = r, r = o), r;
                            }()) === o && (r = Ke()), r;
                        }
                        function He() {
                            var r, t, l, s;
                            if (ge++, r = de, 45 === e.charCodeAt(de) ? (t = "-", de++) : (t = o, 0 === ge && Ce(U)), t === o && (t = null), t !== o) {
                                if (l = [], te.test(e.charAt(de)) ? (s = e.charAt(de), de++) : (s = o, 0 === ge && Ce(le)), s !== o) for(; s !== o;)l.push(s), te.test(e.charAt(de)) ? (s = e.charAt(de), de++) : (s = o, 0 === ge && Ce(le));
                                else l = o;
                                l !== o ? (he = r, r = t = {
                                    type: "number",
                                    value: parseInt(e.substring(he, de), 10)
                                }) : (de = r, r = o);
                            } else de = r, r = o;
                            return ge--, r === o && (t = o, 0 === ge && Ce(re)), r;
                        }
                        function Je() {
                            var r, t, l, s;
                            if (r = de, 91 === e.charCodeAt(de) ? (t = "[", de++) : (t = o, 0 === ge && Ce(oe)), t !== o) {
                                if (l = [], se.test(e.charAt(de)) ? (s = e.charAt(de), de++) : (s = o, 0 === ge && Ce(ne)), s !== o) for(; s !== o;)l.push(s), se.test(e.charAt(de)) ? (s = e.charAt(de), de++) : (s = o, 0 === ge && Ce(ne));
                                else l = o;
                                l !== o ? (93 === e.charCodeAt(de) ? (s = "]", de++) : (s = o, 0 === ge && Ce(ue)), s !== o ? (he = r, r = t = l.join("")) : (de = r, r = o)) : (de = r, r = o);
                            } else de = r, r = o;
                            return r;
                        }
                        function Le() {
                            var r, t;
                            for(ge++, r = [], ce.test(e.charAt(de)) ? (t = e.charAt(de), de++) : (t = o, 0 === ge && Ce(ie)); t !== o;)r.push(t), ce.test(e.charAt(de)) ? (t = e.charAt(de), de++) : (t = o, 0 === ge && Ce(ie));
                            return ge--, r === o && (t = o, 0 === ge && Ce(ae)), r;
                        }
                        const Ne = {
                            type: "target",
                            mod: "=",
                            value: {
                                type: "number",
                                value: 1
                            }
                        }, Qe = {
                            type: "number",
                            value: 1
                        };
                        if ((l = n()) !== o && de === e.length) return l;
                        var Xe, Ye, Ze;
                        throw l !== o && de < e.length && Ce({
                            type: "end"
                        }), Xe = ve, Ye = fe < e.length ? e.charAt(fe) : null, Ze = fe < e.length ? Ae(fe, fe + 1) : Ae(fe, fe), new r(r.buildMessage(Xe, Ye), Xe, Ye, Ze);
                    }
                };
            }
        }, r = {};
        return function t(l) {
            var o = r[l];
            if (void 0 !== o) return o.exports;
            var s = r[l] = {
                exports: {}
            };
            return e[l].call(s.exports, s, s.exports, t), s.exports;
        }(607);
    })();
});

});

parcelRegister("ggrpt", function(module, exports) {

$parcel$export(module.exports, "random", () => $be8cb586a7028067$export$4385e60b38654f68);
$parcel$export(module.exports, "round", () => $be8cb586a7028067$export$2077e0241d6afd3c);
$parcel$export(module.exports, "useResizeRerender", () => $be8cb586a7028067$export$943300145382847b);
$parcel$export(module.exports, "convertToInputState", () => $be8cb586a7028067$export$b720e2033aa2d90f);

var $acw62 = parcelRequire("acw62");
function $be8cb586a7028067$export$4385e60b38654f68(max, min = 1) {
    // the + 1 is b/c Math.random() generates a number from 0 to 1 including 0 but not including 1
    // if we want a random number between 0 and 20, we generally want to include both 0 and 20
    return Math.floor(Math.random() * (Number(max) + 1 - Number(min))) + Number(min);
}
function $be8cb586a7028067$export$2077e0241d6afd3c(number, decimal = 0) {
    const multiple = Number("1" + new Array(decimal).fill("0").join(""));
    return Math.round(number * multiple) / multiple;
}
function $be8cb586a7028067$export$943300145382847b() {
    const [, reload] = (0, $acw62.useReducer)((c)=>c + 1, 0);
    (0, $acw62.useEffect)(()=>{
        window.addEventListener("resize", reload);
        return ()=>window.removeEventListener("resize", reload);
    });
}
function $be8cb586a7028067$export$d52f7a47d0bab5ed(defaultValue) {
    return $be8cb586a7028067$export$b720e2033aa2d90f((0, $acw62.useState)(defaultValue));
}
function $be8cb586a7028067$export$b720e2033aa2d90f(stateHook) {
    const [state, setState] = stateHook;
    return {
        state: state,
        value: state,
        set: setState,
        setState: setState,
        setValue: setState,
        input: {
            onChange: ({ target: target })=>setState(target.value),
            value: state
        },
        checkbox: {
            onChange: ({ target: target })=>setState(target.checked),
            checked: state
        },
        antd: {
            select: {
                onChange: (value)=>setState(value),
                value: state
            }
        }
    };
}

});

parcelRegister("8vlVz", function(module, exports) {

var $acw62 = parcelRequire("acw62");
function $63123a52d33a1434$export$ab2fc8b19e9a847a(fn, deps) {
    const previousDeps = (0, $acw62.useRef)([]);
    const firstRun = (0, $acw62.useRef)(true);
    const previousValue = (0, $acw62.useRef)();
    let shouldRun = false;
    if (firstRun.current === true) {
        // on first run, always run
        firstRun.current = false;
        shouldRun = true;
    } else {
        // on second+ runs, check deps
        let length = Math.max(deps.length, previousDeps.current.length);
        let isEqual = true;
        for(let index = 0; index < length; index++)if (previousDeps.current[index] !== deps[index]) isEqual = false;
        shouldRun = !isEqual;
    }
    if (shouldRun) previousValue.current = fn(previousValue.current);
    previousDeps.current = deps;
    return previousValue.current;
}

});

parcelRegister("lTvyy", function(module, exports) {

$parcel$export(module.exports, "useQueryState", () => $ff07367001e04977$export$8a4c65ea4f241b48);

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");
function $ff07367001e04977$export$8a4c65ea4f241b48(paramKey, defaultValue = "") {
    const [searchParams, setSearchParams] = (0, $lzNIT.useSearchParams)();
    const [paramValue, setParamValue] = (0, $acw62.useState)(searchParams.get(paramKey) || defaultValue);
    function setParam(value) {
        setParamValue(value);
        let searchParamsNow = new URLSearchParams(window.location.search);
        searchParamsNow.set(paramKey, value);
        setSearchParams(searchParamsNow);
    }
    // initialize, if no query string
    (0, $acw62.useEffect)(()=>{
        let searchParamsNow = new URLSearchParams(window.location.search);
        if (!searchParamsNow.has(paramKey)) {
            searchParamsNow.set(paramKey, defaultValue);
            setSearchParams(searchParamsNow);
        }
    });
    // each time querystring changes...
    (0, $acw62.useEffect)(()=>{
        let searchParamsNow = new URLSearchParams(window.location.search);
        if (searchParamsNow.get(paramKey) && paramValue !== searchParamsNow.get(paramKey)) setParamValue(searchParamsNow.get(paramKey));
    }, [
        searchParams.get(paramKey)
    ]);
    return [
        paramValue,
        setParam
    ];
} // how do we handle cross-page params?
 // useGlobalQueryState() ?

});
parcelRegister("lzNIT", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", () => $040dbb9c344a508d$export$9ba4e89fdfa1fc54);
$parcel$export(module.exports, "useSearchParams", () => $040dbb9c344a508d$export$f1a78c17382fe22a);
$parcel$export(module.exports, "useLocation", () => (parcelRequire("aphAM")).useLocation);
$parcel$export(module.exports, "useNavigate", () => (parcelRequire("aphAM")).useNavigate);
$parcel$export(module.exports, "useResolvedPath", () => (parcelRequire("aphAM")).useResolvedPath);
/**
 * React Router DOM v6.21.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $2vsP7 = parcelRequire("2vsP7");
var $aphAM = parcelRequire("aphAM");

var $2vsP7 = parcelRequire("2vsP7");
function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $2vsP7.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $2vsP7.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aphAM.UNSAFE_mapRouteProperties),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aphAM.UNSAFE_mapRouteProperties),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $2vsP7.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $1u0KT[$040dbb9c344a508d$var$FLUSH_SYNC];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $aphAM.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $aphAM.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $aphAM.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $2vsP7.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $aphAM.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $aphAM.useLocation)();
    let routerState = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterStateContext));
    let { navigator: navigator } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterContext));
    !ctx && (0, $2vsP7.UNSAFE_invariant)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterStateContext));
    !state && (0, $2vsP7.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $aphAM.useNavigate)();
    let location = (0, $aphAM.useLocation)();
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $2vsP7.createPath)(location) === (0, $2vsP7.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $aphAM.useLocation)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $aphAM.useNavigate)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let currentRouteId = (0, $aphAM.UNSAFE_useRouteId)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let routeContext = $acw62.useContext((0, $aphAM.UNSAFE_RouteContext));
    !routeContext && (0, $2vsP7.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $aphAM.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $aphAM.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $2vsP7.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $aphAM.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $2vsP7.UNSAFE_invariant)(false);
    !route && (0, $2vsP7.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $2vsP7.UNSAFE_invariant)(false);
    // Fetcher key handling
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || "");
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $2vsP7.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $2vsP7.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let location = (0, $aphAM.useLocation)();
    let matches = (0, $aphAM.useMatches)();
    let navigation = (0, $aphAM.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $2vsP7.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $aphAM.useBlocker)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $2vsP7.UNSAFE_invariant)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $2vsP7.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $2vsP7.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $2vsP7.matchPath)(path.pathname, nextPath) != null || (0, $2vsP7.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("2vsP7", function(module, exports) {

$parcel$export(module.exports, "Action", () => $1d34d5c4a288b213$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $1d34d5c4a288b213$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $1d34d5c4a288b213$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $1d34d5c4a288b213$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createBrowserHistory", () => $1d34d5c4a288b213$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $1d34d5c4a288b213$export$b71fdd3798280242);
$parcel$export(module.exports, "UNSAFE_invariant", () => $1d34d5c4a288b213$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $1d34d5c4a288b213$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $1d34d5c4a288b213$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $1d34d5c4a288b213$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $1d34d5c4a288b213$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $1d34d5c4a288b213$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $1d34d5c4a288b213$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $1d34d5c4a288b213$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $1d34d5c4a288b213$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", () => $1d34d5c4a288b213$export$6c6580e81da25755);
$parcel$export(module.exports, "isRouteErrorResponse", () => $1d34d5c4a288b213$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_FETCHER", () => $1d34d5c4a288b213$export$52eace9c284d3585);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $1d34d5c4a288b213$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $1d34d5c4a288b213$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.14.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $1d34d5c4a288b213$var$safelyDecodeURI(pathname));
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:\w+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = $1d34d5c4a288b213$var$safelyDecodeURIComponent(value || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $1d34d5c4a288b213$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else if (isPathRelative) {
        let fromSegments = routePathnames.length === 0 ? [] : routePathnames[routePathnames.length - 1].replace(/^\//, "").split("/");
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // With relative="path", each leading .. segment means "go up one URL segment"
            while(toSegments[0] === ".."){
                toSegments.shift();
                fromSegments.pop();
            }
            to.pathname = toSegments.join("/");
        }
        from = "/" + fromSegments.join("/");
    } else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // With relative="route" (the default), each leading .. segment means
            // "go up one route" instead of "go up one URL segment".  This is a key
            // difference from how <a href> works and a major reason we call this a
            // "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        initialized = initialMatches.every((m)=>m.route.loader && m.route.loader.hydrate !== true && (loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$1d34d5c4a288b213$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since iot's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($1d34d5c4a288b213$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $1d34d5c4a288b213$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                return startRedirectNavigation(state, actionResult, {
                    fetcherSubmission: submission
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $1d34d5c4a288b213$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $1d34d5c4a288b213$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $1d34d5c4a288b213$var$callLoaderOrAction("loader", $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $1d34d5c4a288b213$var$ResultType.error,
                        error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($1d34d5c4a288b213$var$isQueryRouteResponse(e)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $1d34d5c4a288b213$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1d34d5c4a288b213$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (isInitialLoad) // On initial hydration we don't do any shouldRevalidate stuff - we just
        // call the unhydrated loaders
        return $1d34d5c4a288b213$var$isUnhydratedRoute(state, match.route);
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
// Is this route unhydrated (when v7_partialHydration=true) such that we need
// to call it's loader on the initial router creation
function $1d34d5c4a288b213$var$isUnhydratedRoute(state, route) {
    if (!route.loader) return false;
    if (route.loader.hydrate) return true;
    return state.loaderData[route.id] === undefined && (!state.errors || // Loader ran but errored - don't re-run
    state.errors[route.id] === undefined);
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $1d34d5c4a288b213$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($1d34d5c4a288b213$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $1d34d5c4a288b213$var$ResultType.error ? $1d34d5c4a288b213$var$ResultType.error : $1d34d5c4a288b213$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
            else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
            type: resultType,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isQueryRouteResponse(obj) {
    return obj && $1d34d5c4a288b213$var$isResponse(obj.response) && (obj.type === $1d34d5c4a288b213$var$ResultType.data || obj.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $1d34d5c4a288b213$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("aphAM", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", () => $7939e29d663dd3ed$export$3add0d5dce533e2e);
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", () => $7939e29d663dd3ed$export$145dfa71566a64dc);
$parcel$export(module.exports, "UNSAFE_NavigationContext", () => $7939e29d663dd3ed$export$26749e8557646306);
$parcel$export(module.exports, "UNSAFE_RouteContext", () => $7939e29d663dd3ed$export$9072aa6dd1f93057);
$parcel$export(module.exports, "useHref", () => $7939e29d663dd3ed$export$b66bb29c5006f12f);
$parcel$export(module.exports, "useResolvedPath", () => $7939e29d663dd3ed$export$e75d2a2d1b3c245b);
$parcel$export(module.exports, "useLocation", () => $7939e29d663dd3ed$export$45d76561a5302f2b);
$parcel$export(module.exports, "useNavigate", () => $7939e29d663dd3ed$export$9770f232ac06a008);
$parcel$export(module.exports, "useParams", () => $7939e29d663dd3ed$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", () => $7939e29d663dd3ed$export$5fcee62552a12fbf);
$parcel$export(module.exports, "UNSAFE_useRouteId", () => $7939e29d663dd3ed$export$5fc8298006ad9e58);
$parcel$export(module.exports, "useNavigation", () => $7939e29d663dd3ed$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useMatches", () => $7939e29d663dd3ed$export$2378eb7f5ff86053);
$parcel$export(module.exports, "useBlocker", () => $7939e29d663dd3ed$export$b273b3273281a049);
$parcel$export(module.exports, "Router", () => $7939e29d663dd3ed$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Navigate", () => $7939e29d663dd3ed$export$444b3ab0cb9aec40);
$parcel$export(module.exports, "Outlet", () => $7939e29d663dd3ed$export$910ae8079b2c2852);
$parcel$export(module.exports, "Route", () => $7939e29d663dd3ed$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Routes", () => $7939e29d663dd3ed$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", () => $7939e29d663dd3ed$export$52b333d321859367);
/**
 * React Router v6.21.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $2vsP7 = parcelRequire("2vsP7");
function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $2vsP7.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $2vsP7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $2vsP7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $2vsP7.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $2vsP7.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $2vsP7.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $2vsP7.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $2vsP7.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $2vsP7.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $2vsP7.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $2vsP7.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.loader && match.route.id && dataRouterState.loaderData[match.route.id] === undefined && (!dataRouterState.errors || dataRouterState.errors[match.route.id] === undefined)) {
            // We found the first route without data/errors which means it's loader
            // still needs to run.  Flag that we need to render a fallback and
            // render up until the appropriate fallback
            renderFallback = true;
            if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
            else renderedMatches = [
                renderedMatches[0]
            ];
            break;
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $2vsP7.UNSAFE_invariant)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $2vsP7.UNSAFE_invariant)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $2vsP7.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $2vsP7.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $2vsP7.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $2vsP7.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $2vsP7.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $2vsP7.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) $7939e29d663dd3ed$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $2vsP7.resolveTo)(to, (0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $2vsP7.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $2vsP7.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $2vsP7.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $2vsP7.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : promise._data !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $2vsP7.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $2vsP7.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $2vsP7.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367
    }).initialize();
}

});



parcelRegister("ii71U", function(module, exports) {

$parcel$export(module.exports, "makeStateHook", () => $d50f5c6dd169b322$export$36ad4c515e3536e1);
$parcel$export(module.exports, "filterSetData", () => $d50f5c6dd169b322$export$35ac0df3a87519ff);

var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");
function $d50f5c6dd169b322$export$36ad4c515e3536e1(defaultData, saveSideEffect) {
    let subscriberId = 0;
    const subscribers = {};
    const internal = {
        data: defaultData
    };
    // make sure data is defaulted to an object
    // doing it here so that we can ignore typescript's BS in an isolated spot
    // @ts-ignore - seriously, buzz off TS
    if (defaultData === undefined) internal.data = {};
    // iterate through the subscribers and force updates on all of them
    // pass them the unsubscribe function in case they want to stop listening dynamically
    function updateSubscribers() {
        Object.values(subscribers).forEach((subscriber)=>{
            if (subscriber.path) {
                let currentData = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(internal.data, subscriber.path);
                if (subscriber.previousData !== currentData) {
                    subscriber.previousData = currentData;
                    subscriber.update((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep(currentData), subscriber.unsubscribe);
                }
            } else subscriber.update((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep(internal.data), subscriber.unsubscribe);
        });
    }
    /**
   *
   * Subscribe a react component to data changes.
   *
   * @param path An optional path to filter the data being returned and set by the setter
   *
   * @example
   * // given `{ foo: { bar: 'baz' } }`
   * const [state, setState] = useData() // state === { foo: { bar: 'baz' } }
   *
   * @example
   * // given `{ foo: { bar: 'baz' } }`
   * const [state, setState] = useData('foo.bar') // state === 'baz'
   * setState(oldState => newState) // oldState === 'baz'
   *
   * @returns
   */ function useData(path) {
        const [, forceUpdate] = (0, $acw62.useReducer)((c)=>c > 100 ? 0 : c + 1, 0);
        // register this component's forceUpdate as a subscriber
        // subscribers get triggered by "updateSubscribers"
        // we're using a `useLayoutEffect` because `useEffect` happens too late in some circumstances
        (0, $acw62.useLayoutEffect)(()=>{
            return subscribeToData(()=>forceUpdate(), path);
        }, [
            forceUpdate
        ]);
        if (path) return [
            (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(internal.data, path),
            function(pathOrDataOrDataFn, dataOrFn) {
                if (arguments.length === 2) setData((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).toPath(path).concat((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).toPath(pathOrDataOrDataFn)), dataOrFn);
                else if (arguments.length === 1) setData(path, pathOrDataOrDataFn);
            }
        ];
        else return [
            internal.data,
            setData
        ];
    }
    /**
   *
   * Sets the new value of the data, then updates all subscribers.
   *
   * @param pathOrDataOrFn
   * @param dataOrFn
   *
   * @example
   * setData(newState) // overwrite the entire state
   * setData((oldState) => newState) // update the entire state with a function
   * setData('path.to', newState) // overwrite (or set) the state at 'path.to'
   * setData('path.to', (oldState) => newState) // overwrite (or set) the state at 'path.to' with a function
   */ function setData(pathOrDataOrFn, dataOrFn) {
        if (arguments.length === 2) {
            // two arguments means that the first argument is a lodash-style Path and the second is either new data or an updater function
            let path = pathOrDataOrFn;
            let nextData = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep(internal.data) // prepare for new data
            ;
            let newData = typeof dataOrFn === "function" ? dataOrFn((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(nextData, path)) // either run the updater to get new data
             : dataOrFn // or, if it's not an updater, use it as new data
            ;
            (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).set(nextData ?? {}, path, newData) // set it
            ;
            internal.data = nextData;
        } else if (arguments.length === 1) // one argument means that the first argument is either new data or an updater function
        internal.data = typeof pathOrDataOrFn === "function" ? pathOrDataOrFn((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep(internal.data)) // either run the updater to get new data
         : pathOrDataOrFn // or, if it's not an updater, use it as new data
        ;
        if (saveSideEffect) internal.data = saveSideEffect(internal.data);
        updateSubscribers();
    }
    /**
   *
   * Gets the data. (Suprise!) If provided, path filters it.
   *
   * @param path A lodash-style path that filters the returned value.    *
   * @example
   * // state = { foo: { bar: 'baz' } }
   * getData() // returns `{ foo: { bar: 'baz' } }`
   * getData('foo.bar') // return `baz`
   * @returns
   */ function getData(path) {
        if (path) return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(internal.data, path);
        else return internal.data;
    }
    /**
   *
   * Subscribe to data changes by providing a function to be fired when a change occurs.
   *
   * @param triggerOnChange The function to run on change.
   * @param path An optional path to filter the data provided to the subscriber.
   *
   * @returns returns a function that should be run when you want to unsubscribe
   */ function subscribeToData(triggerOnChange, path) {
        const mySubscriberId = subscriberId;
        subscriberId += 1;
        /**
     * Unsubscribe to data changes.
     */ function unsubscribe() {
            delete subscribers[mySubscriberId];
        }
        subscribers[mySubscriberId] = {
            update: triggerOnChange,
            unsubscribe: unsubscribe,
            path: path,
            previousData: path ? (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(internal.data, path) : undefined
        };
        // returning the unsubscribe fn to allow subscribers to store it for later use,
        // and it makes the useEffect (in useData) unsubscribe automatically on unmount
        return unsubscribe;
    }
    let returnStatement = [
        useData,
        setData,
        getData,
        subscribeToData
    ];
    return returnStatement;
}
function $d50f5c6dd169b322$export$35ac0df3a87519ff(setData, basePath) {
    return function(pathOrDataOrDataFn, dataOrFn) {
        if (arguments.length === 2) setData((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).toPath(basePath).concat((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).toPath(pathOrDataOrDataFn)), dataOrFn);
        else if (arguments.length === 1) setData(basePath, pathOrDataOrDataFn);
    };
}

});



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $aphAM = parcelRequire("aphAM");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $igqD6 = parcelRequire("igqD6");
const $3d4d1bba653c6d14$export$53f1cd6809577fc5 = ({ expand: expand = false })=>{
    const nathaniel = (0, $igqD6.css)`
    color: rgb(90,155,230);
  `;
    const hutchins = (0, $igqD6.css)`
    color: rgb(110,192,56);
    white-space: nowrap;
  `;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("header", {
        className: (0, $igqD6.css)`
      display: block;
      position: relative;
      top: 0px; 
      left: 0px; 
      right: 0px; 
      min-width: 600px; 
      border-bottom: 2px solid orange;
      box-shadow: 0px 1px 4px rgba(0,0,0,.25);
    `,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
            id: "title",
            className: (0, $igqD6.css)`
            display: block;

            top: 0px; 
            left: 0px; 
            right: 0px;

            margin: auto;
            padding: 15px 20px 20px 20px;

            ${expand ? "" : (0, $igqD6.css)`
              max-width: 940px;
              min-width: 560px; /* Not sure I need this bit */
            `}

            font-family: Source Code Pro Woff, Monaco, monospace;
            font-size: 31.5pt; /* 42px */
            text-shadow: 1px 1px 3px rgba(0,0,0,.3);
            line-height: 1.1;
            color: white;
          `,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                href: "/",
                children: [
                    "< ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: nathaniel,
                        children: "nathaniel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: hutchins,
                        children: "\xa0\xa0hutchins"
                    }),
                    " />"
                ]
            })
        })
    });
};
const $3d4d1bba653c6d14$export$16800ac069904dff = ({ expand: expand = false, children: children, ...htmlProps })=>{
    const containerCss = (0, $igqD6.css)`
    position: relative;
  
    left: 0px;
    right: 0px;
  
    margin: auto;
  
    margin-top: 15px;
    margin-bottom: 40px;
  
    padding-left: 20px;
    padding-right: 20px;
  
    ${expand ? (0, $igqD6.css)`
      padding: 20px 73px;
    ` : (0, $igqD6.css)`
      padding: 20px;
      max-width: 910px;
      min-width: 530px;
    `}

    font-size: 12pt; /* 16px */
    line-height: 24px; /* Required for the numbers on the side. */
  
    color: rgb(190, 190, 190);
  `;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ...htmlProps,
        className: (0, $igqD6.cx)(containerCss, htmlProps.className || ""),
        children: children
    });
};
const $3d4d1bba653c6d14$export$6955bcca4cd3539f = ({ expand: expand = false, children: children, className: className })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($3d4d1bba653c6d14$export$53f1cd6809577fc5, {
                expand: expand
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($3d4d1bba653c6d14$export$16800ac069904dff, {
                expand: expand,
                className: className,
                children: children
            })
        ]
    });
};


var $6690377ff2917a7c$exports = {};
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */ (function(global, factory) {
    if (typeof define === "function" && define.amd) define(factory);
    else if (0, $6690377ff2917a7c$exports) $6690377ff2917a7c$exports = factory();
    else global.numeral = factory();
})($6690377ff2917a7c$exports, function() {
    /************************************
        Variables
    ************************************/ var numeral, _, VERSION = "2.0.6", formats = {}, locales = {}, defaults = {
        currentLocale: "en",
        zeroFormat: null,
        nullFormat: null,
        defaultFormat: "0,0",
        scalePercentBy100: true
    }, options = {
        currentLocale: defaults.currentLocale,
        zeroFormat: defaults.zeroFormat,
        nullFormat: defaults.nullFormat,
        defaultFormat: defaults.defaultFormat,
        scalePercentBy100: defaults.scalePercentBy100
    };
    /************************************
        Constructors
    ************************************/ // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;
        this._value = number;
    }
    numeral = function(input) {
        var value, kind, unformatFunction, regexp;
        if (numeral.isNumeral(input)) value = input.value();
        else if (input === 0 || typeof input === "undefined") value = 0;
        else if (input === null || _.isNaN(input)) value = null;
        else if (typeof input === "string") {
            if (options.zeroFormat && input === options.zeroFormat) value = 0;
            else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, "").length) value = null;
            else {
                for(kind in formats){
                    regexp = typeof formats[kind].regexps.unformat === "function" ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;
                        break;
                    }
                }
                unformatFunction = unformatFunction || numeral._.stringToNumber;
                value = unformatFunction(input);
            }
        } else value = Number(input) || null;
        return new Numeral(input, value);
    };
    // version number
    numeral.version = VERSION;
    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };
    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale], negP = false, optDec = false, leadingCount = 0, abbr = "", trillion = 1000000000000, billion = 1000000000, million = 1000000, thousand = 1000, decimal = "", neg = false, abbrForce, abs, min, max, power, int, precision, signed, thousands, output;
            // make sure we never format a null value
            value = value || 0;
            abs = Math.abs(value);
            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, "(")) {
                negP = true;
                format = format.replace(/[\(|\)]/g, "");
            } else if (numeral._.includes(format, "+") || numeral._.includes(format, "-")) {
                signed = numeral._.includes(format, "+") ? format.indexOf("+") : value < 0 ? format.indexOf("-") : -1;
                format = format.replace(/[\+|\-]/g, "");
            }
            // see if abbreviation is wanted
            if (numeral._.includes(format, "a")) {
                abbrForce = format.match(/a(k|m|b|t)?/);
                abbrForce = abbrForce ? abbrForce[1] : false;
                // check for space before abbreviation
                if (numeral._.includes(format, " a")) abbr = " ";
                format = format.replace(new RegExp(abbr + "a[kmbt]?"), "");
                if (abs >= trillion && !abbrForce || abbrForce === "t") {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === "b") {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === "m") {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === "k") {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }
            // check for optional decimals
            if (numeral._.includes(format, "[.]")) {
                optDec = true;
                format = format.replace("[.]", ".");
            }
            // break number and format
            int = value.toString().split(".")[0];
            precision = format.split(".")[1];
            thousands = format.indexOf(",");
            leadingCount = (format.split(".")[0].split(",")[0].match(/0/g) || []).length;
            if (precision) {
                if (numeral._.includes(precision, "[")) {
                    precision = precision.replace("]", "");
                    precision = precision.split("[");
                    decimal = numeral._.toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length);
                } else decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                int = decimal.split(".")[0];
                if (numeral._.includes(decimal, ".")) decimal = locale.delimiters.decimal + decimal.split(".")[1];
                else decimal = "";
                if (optDec && Number(decimal.slice(1)) === 0) decimal = "";
            } else int = numeral._.toFixed(value, 0, roundingFunction);
            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);
                switch(abbr){
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }
            // format number
            if (numeral._.includes(int, "-")) {
                int = int.slice(1);
                neg = true;
            }
            if (int.length < leadingCount) for(var i = leadingCount - int.length; i > 0; i--)int = "0" + int;
            if (thousands > -1) int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + locale.delimiters.thousands);
            if (format.indexOf(".") === 0) int = "";
            output = int + decimal + (abbr ? abbr : "");
            if (negP) output = (negP && neg ? "(" : "") + output + (negP && neg ? ")" : "");
            else {
                if (signed >= 0) output = signed === 0 ? (neg ? "-" : "+") + output : output + (neg ? "-" : "+");
                else if (neg) output = "-" + output;
            }
            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale], stringOriginal = string, abbreviations = {
                thousand: 3,
                million: 6,
                billion: 9,
                trillion: 12
            }, abbreviation, value, i, regexp;
            if (options.zeroFormat && string === options.zeroFormat) value = 0;
            else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, "").length) value = null;
            else {
                value = 1;
                if (locale.delimiters.decimal !== ".") string = string.replace(/\./g, "").replace(locale.delimiters.decimal, ".");
                for(abbreviation in abbreviations){
                    regexp = new RegExp("[^a-zA-Z]" + locale.abbreviations[abbreviation] + "(?:\\)|(\\" + locale.currency.symbol + ")?(?:\\))?)?$");
                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }
                // check for negative number
                value *= (string.split("-").length + Math.min(string.split("(").length - 1, string.split(")").length - 1)) % 2 ? 1 : -1;
                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, "");
                value *= Number(string);
            }
            return value;
        },
        isNaN: function(value) {
            return typeof value === "number" && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/ ) {
            if (this === null) throw new TypeError("Array.prototype.reduce called on null or undefined");
            if (typeof callback !== "function") throw new TypeError(callback + " is not a function");
            var t = Object(array), len = t.length >>> 0, k = 0, value;
            if (arguments.length === 3) value = arguments[2];
            else {
                while(k < len && !(k in t))k++;
                if (k >= len) throw new TypeError("Reduce of empty array with no initial value");
                value = t[k++];
            }
            for(; k < len; k++)if (k in t) value = callback(value, t[k], k, t);
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */ multiplier: function(x) {
            var parts = x.toString().split(".");
            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */ correctionFactor: function() {
            var args = Array.prototype.slice.call(arguments);
            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */ toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split("."), minDecimals = maxDecimals - (optionals || 0), boundedPrecision, optionalsRegExp, power, output;
            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            else boundedPrecision = minDecimals;
            power = Math.pow(10, boundedPrecision);
            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + "e+" + boundedPrecision) / power).toFixed(boundedPrecision);
            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp("\\.?0{1," + (optionals - (maxDecimals - boundedPrecision)) + "}$");
                output = output.replace(optionalsRegExp, "");
            }
            return output;
        }
    };
    // avaliable options
    numeral.options = options;
    // avaliable formats
    numeral.formats = formats;
    // avaliable formats
    numeral.locales = locales;
    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) options.currentLocale = key.toLowerCase();
        return options.currentLocale;
    };
    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) return locales[options.currentLocale];
        key = key.toLowerCase();
        if (!locales[key]) throw new Error("Unknown locale : " + key);
        return locales[key];
    };
    numeral.reset = function() {
        for(var property in defaults)options[property] = defaults[property];
    };
    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof format === "string" ? format : null;
    };
    numeral.nullFormat = function(format) {
        options.nullFormat = typeof format === "string" ? format : null;
    };
    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof format === "string" ? format : "0.0";
    };
    numeral.register = function(type, name, format) {
        name = name.toLowerCase();
        if (this[type + "s"][name]) throw new TypeError(name + " " + type + " already registered.");
        this[type + "s"][name] = format;
        return format;
    };
    numeral.validate = function(val, culture) {
        var _decimalSep, _thousandSep, _currSymbol, _valArray, _abbrObj, _thousandRegEx, localeData, temp;
        //coerce val to string
        if (typeof val !== "string") {
            val += "";
            if (console.warn) console.warn("Numeral.js: Value is not string. It has been co-erced to: ", val);
        }
        //trim whitespaces from either sides
        val = val.trim();
        //if val is just digits return true
        if (!!val.match(/^\d+$/)) return true;
        //if val is empty return false
        if (val === "") return false;
        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }
        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === ".") _thousandSep = "\\.";
        else _thousandSep = localeData.delimiters.thousands;
        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) return false;
        }
        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) return false;
        }
        _thousandRegEx = new RegExp(_thousandSep + "{2}");
        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) return false;
            else {
                if (_valArray.length < 2) return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx);
                else {
                    if (_valArray[0].length === 1) return !!_valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                    else return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                }
            }
        }
        return false;
    };
    /************************************
        Numeral Prototype
    ************************************/ numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value, format = inputString || options.defaultFormat, kind, output, formatFunction;
            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;
            // format based on value
            if (value === 0 && options.zeroFormat !== null) output = options.zeroFormat;
            else if (value === null && options.nullFormat !== null) output = options.nullFormat;
            else {
                for(kind in formats)if (format.match(formats[kind].regexps.format)) {
                    formatFunction = formats[kind].format;
                    break;
                }
                formatFunction = formatFunction || numeral._.numberToFormat;
                output = formatFunction(value, format, roundingFunction);
            }
            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);
            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback, 0) / corrFactor;
            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }
            this._value = _.reduce([
                value
            ], cback, Math.round(this._value * corrFactor)) / corrFactor;
            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback, 1);
            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback);
            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };
    /************************************
        Default Locale && Format
    ************************************/ numeral.register("locale", "en", {
        delimiters: {
            thousands: ",",
            decimal: "."
        },
        abbreviations: {
            thousand: "k",
            million: "m",
            billion: "b",
            trillion: "t"
        },
        ordinal: function(number) {
            var b = number % 10;
            return ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
        },
        currency: {
            symbol: "$"
        }
    });
    (function() {
        numeral.register("format", "bps", {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, " BPS") ? " " : "", output;
                value = value * 10000;
                // check for space before BPS
                format = format.replace(/\s?BPS/, "");
                output = numeral._.numberToFormat(value, format, roundingFunction);
                if (numeral._.includes(output, ")")) {
                    output = output.split("");
                    output.splice(-1, 0, space + "BPS");
                    output = output.join("");
                } else output = output + space + "BPS";
                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
    })();
    (function() {
        var decimal = {
            base: 1000,
            suffixes: [
                "B",
                "KB",
                "MB",
                "GB",
                "TB",
                "PB",
                "EB",
                "ZB",
                "YB"
            ]
        }, binary = {
            base: 1024,
            suffixes: [
                "B",
                "KiB",
                "MiB",
                "GiB",
                "TiB",
                "PiB",
                "EiB",
                "ZiB",
                "YiB"
            ]
        };
        var allSuffixes = decimal.suffixes.concat(binary.suffixes.filter(function(item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join("|");
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = "(" + unformatRegex.replace("B", "B(?!PS)") + ")";
        numeral.register("format", "bytes", {
            regexps: {
                format: /([0\s]i?b)/,
                unformat: new RegExp(unformatRegex)
            },
            format: function(value, format, roundingFunction) {
                var output, bytes = numeral._.includes(format, "ib") ? binary : decimal, suffix = numeral._.includes(format, " b") || numeral._.includes(format, " ib") ? " " : "", power, min, max;
                // check for space before
                format = format.replace(/\s?i?b/, "");
                for(power = 0; power <= bytes.suffixes.length; power++){
                    min = Math.pow(bytes.base, power);
                    max = Math.pow(bytes.base, power + 1);
                    if (value === null || value === 0 || value >= min && value < max) {
                        suffix += bytes.suffixes[power];
                        if (min > 0) value = value / min;
                        break;
                    }
                }
                output = numeral._.numberToFormat(value, format, roundingFunction);
                return output + suffix;
            },
            unformat: function(string) {
                var value = numeral._.stringToNumber(string), power, bytesMultiplier;
                if (value) {
                    for(power = decimal.suffixes.length - 1; power >= 0; power--){
                        if (numeral._.includes(string, decimal.suffixes[power])) {
                            bytesMultiplier = Math.pow(decimal.base, power);
                            break;
                        }
                        if (numeral._.includes(string, binary.suffixes[power])) {
                            bytesMultiplier = Math.pow(binary.base, power);
                            break;
                        }
                    }
                    value *= bytesMultiplier || 1;
                }
                return value;
            }
        });
    })();
    (function() {
        numeral.register("format", "currency", {
            regexps: {
                format: /(\$)/
            },
            format: function(value, format, roundingFunction) {
                var locale = numeral.locales[numeral.options.currentLocale], symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                }, output, symbol, i;
                // strip format of spaces and $
                format = format.replace(/\s?\$\s?/, "");
                // format the number
                output = numeral._.numberToFormat(value, format, roundingFunction);
                // update the before and after based on value
                if (value >= 0) {
                    symbols.before = symbols.before.replace(/[\-\(]/, "");
                    symbols.after = symbols.after.replace(/[\-\)]/, "");
                } else if (value < 0 && !numeral._.includes(symbols.before, "-") && !numeral._.includes(symbols.before, "(")) symbols.before = "-" + symbols.before;
                // loop through each before symbol
                for(i = 0; i < symbols.before.length; i++){
                    symbol = symbols.before[i];
                    switch(symbol){
                        case "$":
                            output = numeral._.insert(output, locale.currency.symbol, i);
                            break;
                        case " ":
                            output = numeral._.insert(output, " ", i + locale.currency.symbol.length - 1);
                            break;
                    }
                }
                // loop through each after symbol
                for(i = symbols.after.length - 1; i >= 0; i--){
                    symbol = symbols.after[i];
                    switch(symbol){
                        case "$":
                            output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                            break;
                        case " ":
                            output = i === symbols.after.length - 1 ? output + " " : numeral._.insert(output, " ", -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                            break;
                    }
                }
                return output;
            }
        });
    })();
    (function() {
        numeral.register("format", "exponential", {
            regexps: {
                format: /(e\+|e-)/,
                unformat: /(e\+|e-)/
            },
            format: function(value, format, roundingFunction) {
                var output, exponential = typeof value === "number" && !numeral._.isNaN(value) ? value.toExponential() : "0e+0", parts = exponential.split("e");
                format = format.replace(/e[\+|\-]{1}0/, "");
                output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
                return output + "e" + parts[1];
            },
            unformat: function(string) {
                var parts = numeral._.includes(string, "e+") ? string.split("e+") : string.split("e-"), value = Number(parts[0]), power = Number(parts[1]);
                power = numeral._.includes(string, "e-") ? power *= -1 : power;
                function cback(accum, curr, currI, O) {
                    var corrFactor = numeral._.correctionFactor(accum, curr), num = accum * corrFactor * (curr * corrFactor) / (corrFactor * corrFactor);
                    return num;
                }
                return numeral._.reduce([
                    value,
                    Math.pow(10, power)
                ], cback, 1);
            }
        });
    })();
    (function() {
        numeral.register("format", "ordinal", {
            regexps: {
                format: /(o)/
            },
            format: function(value, format, roundingFunction) {
                var locale = numeral.locales[numeral.options.currentLocale], output, ordinal = numeral._.includes(format, " o") ? " " : "";
                // check for space before
                format = format.replace(/\s?o/, "");
                ordinal += locale.ordinal(value);
                output = numeral._.numberToFormat(value, format, roundingFunction);
                return output + ordinal;
            }
        });
    })();
    (function() {
        numeral.register("format", "percentage", {
            regexps: {
                format: /(%)/,
                unformat: /(%)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, " %") ? " " : "", output;
                if (numeral.options.scalePercentBy100) value = value * 100;
                // check for space before %
                format = format.replace(/\s?\%/, "");
                output = numeral._.numberToFormat(value, format, roundingFunction);
                if (numeral._.includes(output, ")")) {
                    output = output.split("");
                    output.splice(-1, 0, space + "%");
                    output = output.join("");
                } else output = output + space + "%";
                return output;
            },
            unformat: function(string) {
                var number = numeral._.stringToNumber(string);
                if (numeral.options.scalePercentBy100) return number * 0.01;
                return number;
            }
        });
    })();
    (function() {
        numeral.register("format", "time", {
            regexps: {
                format: /(:)/,
                unformat: /(:)/
            },
            format: function(value, format, roundingFunction) {
                var hours = Math.floor(value / 60 / 60), minutes = Math.floor((value - hours * 3600) / 60), seconds = Math.round(value - hours * 3600 - minutes * 60);
                return hours + ":" + (minutes < 10 ? "0" + minutes : minutes) + ":" + (seconds < 10 ? "0" + seconds : seconds);
            },
            unformat: function(string) {
                var timeArray = string.split(":"), seconds = 0;
                // turn hours and minutes into seconds and add them all up
                if (timeArray.length === 3) {
                    // hours
                    seconds = seconds + Number(timeArray[0]) * 3600;
                    // minutes
                    seconds = seconds + Number(timeArray[1]) * 60;
                    // seconds
                    seconds = seconds + Number(timeArray[2]);
                } else if (timeArray.length === 2) {
                    // minutes
                    seconds = seconds + Number(timeArray[0]) * 60;
                    // seconds
                    seconds = seconds + Number(timeArray[1]);
                }
                return Number(seconds);
            }
        });
    })();
    return numeral;
});



var $f1q41 = parcelRequire("f1q41");
var $83f0759578d3f154$exports = {};
$83f0759578d3f154$exports = JSON.parse('{"Total":{"ageData":{"2019":{"total":"157,538","16to19":"5,150","20to24":"14,172","25to34":"35,807","35to44":"33,127","45to54":"32,042","55to64":"26,893","65+":"10,347","medianAge":"26,893"}},"title":"Total","depth":1,"parent":"","sexRaceEthnicityData":{"2019":{"total":"157,538","women":"47.0","white":"77.7","black":"12.3","asian":"6.5","hispanicOrLatino":"17.6"}},"wageData":{"2019":{"workers":"117,584","median":"$917","maleWorkers":"65,007","maleMedian":"$1,007","femaleWorkers":"52,577","femaleMedian":"$821"}}},"Management, professional, and related occupations":{"ageData":{"2019":{"total":"64,218","16to19":"428","20to24":"3,402","25to34":"15,126","35to44":"15,133","45to54":"14,103","55to64":"11,360","65+":"4,665","medianAge":"11,360"}},"title":"Management, professional, and related occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2019":{"total":"64,218","women":"51.8","white":"79.0","black":"9.6","asian":"8.7","hispanicOrLatino":"10.1"}},"wageData":{"2019":{"workers":"50,119","median":"1,309","maleWorkers":"24,260","maleMedian":"1,539","femaleWorkers":"25,859","femaleMedian":"1,135"}}},"Management, business, and financial operations occupations":{"ageData":{"2019":{"total":"26,981","16to19":"82","20to24":"969","25to34":"5,529","35to44":"6,330","45to54":"6,469","55to64":"5,394","65+":"2,208","medianAge":"5,394"}},"title":"Management, business, and financial operations occupations","depth":2,"parent":"Management, professional, and related occupations","sexRaceEthnicityData":{"2019":{"total":"26,981","women":"44.1","white":"82.1","black":"8.4","asian":"7.0","hispanicOrLatino":"10.4"}},"wageData":{"2019":{"workers":"20,696","median":"1,415","maleWorkers":"11,111","maleMedian":"1,598","femaleWorkers":"9,585","femaleMedian":"1,221"}}},"Management occupations":{"ageData":{"2019":{"total":"18,985","16to19":"62","20to24":"536","25to34":"3,452","35to44":"4,524","45to54":"4,731","55to64":"4,024","65+":"1,655","medianAge":"4,024"}},"title":"Management occupations","depth":3,"parent":"Management, business, and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"18,985","women":"40.0","white":"83.6","black":"7.8","asian":"6.1","hispanicOrLatino":"10.7"}},"wageData":{"2019":{"workers":"13,948","median":"1,478","maleWorkers":"8,002","maleMedian":"1,659","femaleWorkers":"5,946","femaleMedian":"1,266"}}},"Chief executives":{"ageData":{"2019":{"total":"1,602","16to19":"2","20to24":"5","25to34":"121","35to44":"329","45to54":"461","55to64":"465","65+":"219","medianAge":"465"}},"title":"Chief executives","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"1,602","women":"27.6","white":"88.8","black":"4.1","asian":"5.8","hispanicOrLatino":"6.2"}},"wageData":{"2019":{"workers":"1,113","median":"2,380","maleWorkers":"812","maleMedian":"2,509","femaleWorkers":"302","femaleMedian":"2,019"}}},"General and operations managers":{"ageData":{"2019":{"total":"1,058","16to19":"0","20to24":"19","25to34":"258","35to44":"282","45to54":"257","55to64":"196","65+":"46","medianAge":"196"}},"title":"General and operations managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"1,058","women":"30.6","white":"86.4","black":"6.6","asian":"3.5","hispanicOrLatino":"12.5"}},"wageData":{"2019":{"workers":"990","median":"1,384","maleWorkers":"678","maleMedian":"1,476","femaleWorkers":"312","femaleMedian":"1,153"}}},"Legislators":{"ageData":{"2019":{"total":"19","16to19":"0","20to24":"0","25to34":"3","35to44":"2","45to54":"1","55to64":"5","65+":"7","medianAge":"5"}},"title":"Legislators","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"19","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"14","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Advertising and promotions managers":{"ageData":{"2019":{"total":"55","16to19":"0","20to24":"9","25to34":"13","35to44":"12","45to54":"10","55to64":"8","65+":"3","medianAge":"8"}},"title":"Advertising and promotions managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"55","women":"56.9","white":"89.5","black":"0.7","asian":"7.0","hispanicOrLatino":"9.0"}},"wageData":{"2019":{"workers":"45","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"27","femaleMedian":"-"}}},"Marketing and sales managers":{"ageData":{"2019":{"total":"1,184","16to19":"4","20to24":"69","25to34":"283","35to44":"313","45to54":"289","55to64":"180","65+":"45","medianAge":"180"}},"title":"Marketing and sales managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"1,184","women":"48.5","white":"86.1","black":"6.1","asian":"5.6","hispanicOrLatino":"8.9"}},"wageData":{"2019":{"workers":"1,109","median":"1,600","maleWorkers":"591","maleMedian":"1,895","femaleWorkers":"518","femaleMedian":"1,393"}}},"Public relations and fundraising managers":{"ageData":{"2019":{"total":"73","16to19":"0","20to24":"2","25to34":"19","35to44":"12","45to54":"17","55to64":"19","65+":"4","medianAge":"19"}},"title":"Public relations and fundraising managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"73","women":"71.4","white":"89.8","black":"8.0","asian":"0.4","hispanicOrLatino":"1.4"}},"wageData":{"2019":{"workers":"72","median":"1,416","maleWorkers":"22","maleMedian":"-","femaleWorkers":"50","femaleMedian":"1,399"}}},"Administrative services managers":{"ageData":{"2019":{"total":"184","16to19":"1","20to24":"3","25to34":"19","35to44":"41","45to54":"46","55to64":"56","65+":"18","medianAge":"56"}},"title":"Administrative services managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"184","women":"42.0","white":"83.9","black":"10.5","asian":"3.2","hispanicOrLatino":"10.9"}},"wageData":{"2019":{"workers":"154","median":"1,235","maleWorkers":"93","maleMedian":"1,277","femaleWorkers":"61","femaleMedian":"1,084"}}},"Computer and information systems managers":{"ageData":{"2019":{"total":"654","16to19":"1","20to24":"6","25to34":"115","35to44":"197","45to54":"198","55to64":"116","65+":"23","medianAge":"116"}},"title":"Computer and information systems managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"654","women":"28.7","white":"72.7","black":"9.6","asian":"15.8","hispanicOrLatino":"4.7"}},"wageData":{"2019":{"workers":"629","median":"1,984","maleWorkers":"439","maleMedian":"2,019","femaleWorkers":"190","femaleMedian":"1,892"}}},"Financial managers":{"ageData":{"2019":{"total":"1,194","16to19":"1","20to24":"30","25to34":"264","35to44":"332","45to54":"299","55to64":"210","65+":"58","medianAge":"210"}},"title":"Financial managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"1,194","women":"53.5","white":"80.2","black":"8.5","asian":"9.4","hispanicOrLatino":"11.4"}},"wageData":{"2019":{"workers":"1,142","median":"1,447","maleWorkers":"523","maleMedian":"1,897","femaleWorkers":"619","femaleMedian":"1,207"}}},"Compensation and benefits managers":{"ageData":{"2019":{"total":"24","16to19":"0","20to24":"2","25to34":"1","35to44":"6","45to54":"10","55to64":"3","65+":"2","medianAge":"3"}},"title":"Compensation and benefits managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"24","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"23","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"15","femaleMedian":"-"}}},"Human resources managers":{"ageData":{"2019":{"total":"321","16to19":"1","20to24":"6","25to34":"64","35to44":"99","45to54":"77","55to64":"64","65+":"11","medianAge":"64"}},"title":"Human resources managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"321","women":"74.7","white":"77.8","black":"11.1","asian":"7.1","hispanicOrLatino":"10.1"}},"wageData":{"2019":{"workers":"299","median":"1,592","maleWorkers":"69","maleMedian":"1,829","femaleWorkers":"230","femaleMedian":"1,538"}}},"Training and development managers":{"ageData":{"2019":{"total":"46","16to19":"2","20to24":"1","25to34":"9","35to44":"17","45to54":"6","55to64":"9","65+":"2","medianAge":"9"}},"title":"Training and development managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"46","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"44","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"25","femaleMedian":"-"}}},"Industrial production managers":{"ageData":{"2019":{"total":"274","16to19":"0","20to24":"3","25to34":"51","35to44":"77","45to54":"68","55to64":"65","65+":"11","medianAge":"65"}},"title":"Industrial production managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"274","women":"22.4","white":"87.2","black":"5.4","asian":"5.5","hispanicOrLatino":"10.9"}},"wageData":{"2019":{"workers":"270","median":"1,472","maleWorkers":"208","maleMedian":"1,469","femaleWorkers":"62","femaleMedian":"1,497"}}},"Purchasing managers":{"ageData":{"2019":{"total":"227","16to19":"0","20to24":"5","25to34":"44","35to44":"56","45to54":"67","55to64":"46","65+":"9","medianAge":"46"}},"title":"Purchasing managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"227","women":"42.8","white":"75.1","black":"14.4","asian":"5.9","hispanicOrLatino":"10.0"}},"wageData":{"2019":{"workers":"214","median":"1,539","maleWorkers":"129","maleMedian":"1,657","femaleWorkers":"84","femaleMedian":"1,390"}}},"Transportation, storage, and distribution managers":{"ageData":{"2019":{"total":"281","16to19":"0","20to24":"11","25to34":"55","35to44":"59","45to54":"77","55to64":"69","65+":"10","medianAge":"69"}},"title":"Transportation, storage, and distribution managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"281","women":"17.3","white":"85.1","black":"9.6","asian":"2.4","hispanicOrLatino":"17.3"}},"wageData":{"2019":{"workers":"261","median":"1,160","maleWorkers":"213","maleMedian":"1,238","femaleWorkers":"49","femaleMedian":"-"}}},"Farmers, ranchers, and other agricultural managers":{"ageData":{"2019":{"total":"962","16to19":"3","20to24":"23","25to34":"114","35to44":"132","45to54":"145","55to64":"251","65+":"296","medianAge":"251"}},"title":"Farmers, ranchers, and other agricultural managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"962","women":"24.5","white":"96.6","black":"0.9","asian":"1.0","hispanicOrLatino":"5.7"}},"wageData":{"2019":{"workers":"114","median":"987","maleWorkers":"94","maleMedian":"1,162","femaleWorkers":"20","femaleMedian":"-"}}},"Construction managers":{"ageData":{"2019":{"total":"994","16to19":"1","20to24":"27","25to34":"184","35to44":"259","45to54":"233","55to64":"214","65+":"77","medianAge":"214"}},"title":"Construction managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"994","women":"10.0","white":"90.9","black":"3.5","asian":"2.5","hispanicOrLatino":"13.9"}},"wageData":{"2019":{"workers":"610","median":"1,468","maleWorkers":"539","maleMedian":"1,511","femaleWorkers":"71","femaleMedian":"1,210"}}},"Education administrators":{"ageData":{"2019":{"total":"958","16to19":"4","20to24":"21","25to34":"140","35to44":"255","45to54":"307","55to64":"178","65+":"52","medianAge":"178"}},"title":"Education administrators","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"958","women":"67.7","white":"78.6","black":"15.3","asian":"3.3","hispanicOrLatino":"11.8"}},"wageData":{"2019":{"workers":"811","median":"1,371","maleWorkers":"276","maleMedian":"1,467","femaleWorkers":"536","femaleMedian":"1,335"}}},"Architectural and engineering managers":{"ageData":{"2019":{"total":"154","16to19":"0","20to24":"1","25to34":"21","35to44":"41","45to54":"45","55to64":"41","65+":"5","medianAge":"41"}},"title":"Architectural and engineering managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"154","women":"11.7","white":"81.5","black":"6.0","asian":"11.8","hispanicOrLatino":"6.7"}},"wageData":{"2019":{"workers":"148","median":"2,471","maleWorkers":"128","maleMedian":"2,457","femaleWorkers":"20","femaleMedian":"-"}}},"Food service managers":{"ageData":{"2019":{"total":"1,249","16to19":"24","20to24":"131","25to34":"309","35to44":"283","45to54":"264","55to64":"176","65+":"61","medianAge":"176"}},"title":"Food service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"1,249","women":"46.5","white":"76.3","black":"9.8","asian":"9.6","hispanicOrLatino":"19.8"}},"wageData":{"2019":{"workers":"785","median":"863","maleWorkers":"420","maleMedian":"964","femaleWorkers":"365","femaleMedian":"719"}}},"Funeral service managers":{"ageData":{"2019":{"total":"13","16to19":"0","20to24":"0","25to34":"0","35to44":"2","45to54":"1","55to64":"6","65+":"4","medianAge":"6"}},"title":"Funeral service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"13","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"3","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Gaming managers":{"ageData":{"2019":{"total":"19","16to19":"0","20to24":"2","25to34":"1","35to44":"4","45to54":"6","55to64":"3","65+":"2","medianAge":"3"}},"title":"Gaming managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"19","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"18","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Lodging managers":{"ageData":{"2019":{"total":"162","16to19":"1","20to24":"8","25to34":"37","35to44":"36","45to54":"32","55to64":"31","65+":"18","medianAge":"31"}},"title":"Lodging managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"162","women":"49.5","white":"80.9","black":"7.0","asian":"9.3","hispanicOrLatino":"14.6"}},"wageData":{"2019":{"workers":"116","median":"975","maleWorkers":"61","maleMedian":"1,096","femaleWorkers":"55","femaleMedian":"894"}}},"Medical and health services managers":{"ageData":{"2019":{"total":"677","16to19":"1","20to24":"8","25to34":"135","35to44":"177","45to54":"164","55to64":"142","65+":"50","medianAge":"142"}},"title":"Medical and health services managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"677","women":"69.7","white":"79.0","black":"12.7","asian":"5.7","hispanicOrLatino":"11.8"}},"wageData":{"2019":{"workers":"578","median":"1,478","maleWorkers":"169","maleMedian":"1,828","femaleWorkers":"409","femaleMedian":"1,362"}}},"Natural sciences managers":{"ageData":{"2019":{"total":"15","16to19":"0","20to24":"0","25to34":"1","35to44":"3","45to54":"8","55to64":"0","65+":"1","medianAge":"0"}},"title":"Natural sciences managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"15","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"12","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Postmasters and mail superintendents":{"ageData":{"2019":{"total":"30","16to19":"0","20to24":"0","25to34":"3","35to44":"7","45to54":"10","55to64":"9","65+":"2","medianAge":"9"}},"title":"Postmasters and mail superintendents","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"30","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"28","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"14","femaleMedian":"-"}}},"Property, real estate, and community association managers":{"ageData":{"2019":{"total":"780","16to19":"1","20to24":"21","25to34":"152","35to44":"140","45to54":"162","55to64":"169","65+":"134","medianAge":"169"}},"title":"Property, real estate, and community association managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"780","women":"47.3","white":"83.6","black":"8.9","asian":"4.5","hispanicOrLatino":"12.8"}},"wageData":{"2019":{"workers":"438","median":"954","maleWorkers":"214","maleMedian":"1,168","femaleWorkers":"224","femaleMedian":"849"}}},"Social and community service managers":{"ageData":{"2019":{"total":"470","16to19":"3","20to24":"17","25to34":"96","35to44":"109","45to54":"107","55to64":"97","65+":"41","medianAge":"97"}},"title":"Social and community service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"470","women":"68.2","white":"79.9","black":"12.3","asian":"3.2","hispanicOrLatino":"10.6"}},"wageData":{"2019":{"workers":"403","median":"1,243","maleWorkers":"143","maleMedian":"1,452","femaleWorkers":"260","femaleMedian":"1,156"}}},"Emergency management directors":{"ageData":{"2019":{"total":"7","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"4","55to64":"1","65+":"0","medianAge":"1"}},"title":"Emergency management directors","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"7","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"9","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Managers, all other":{"ageData":{"2019":{"total":"5,299","16to19":"12","20to24":"105","25to34":"939","35to44":"1,243","45to54":"1,360","55to64":"1,196","65+":"444","medianAge":"1,196"}},"title":"Managers, all other","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2019":{"total":"5,299","women":"36.0","white":"83.4","black":"7.5","asian":"6.8","hispanicOrLatino":"10.3"}},"wageData":{"2019":{"workers":"3,497","median":"1,533","maleWorkers":"2,088","maleMedian":"1,725","femaleWorkers":"1,409","femaleMedian":"1,317"}}},"Business and financial operations occupations":{"ageData":{"2019":{"total":"7,996","16to19":"19","20to24":"433","25to34":"2,076","35to44":"1,806","45to54":"1,738","55to64":"1,370","65+":"554","medianAge":"1,370"}},"title":"Business and financial operations occupations","depth":3,"parent":"Management, business, and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"7,996","women":"54.0","white":"78.4","black":"9.9","asian":"9.0","hispanicOrLatino":"9.5"}},"wageData":{"2019":{"workers":"6,748","median":"1,285","maleWorkers":"3,109","maleMedian":"1,468","femaleWorkers":"3,639","femaleMedian":"1,148"}}},"Agents and business managers of artists, performers, and athletes":{"ageData":{"2019":{"total":"47","16to19":"1","20to24":"3","25to34":"11","35to44":"12","45to54":"10","55to64":"3","65+":"7","medianAge":"3"}},"title":"Agents and business managers of artists, performers, and athletes","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"47","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"28","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"15","femaleMedian":"-"}}},"Buyers and purchasing agents, farm products":{"ageData":{"2019":{"total":"16","16to19":"0","20to24":"1","25to34":"4","35to44":"6","45to54":"1","55to64":"1","65+":"3","medianAge":"1"}},"title":"Buyers and purchasing agents, farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"16","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"7","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Wholesale and retail buyers, except farm products":{"ageData":{"2019":{"total":"226","16to19":"1","20to24":"20","25to34":"56","35to44":"41","45to54":"38","55to64":"50","65+":"20","medianAge":"50"}},"title":"Wholesale and retail buyers, except farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"226","women":"47.8","white":"87.0","black":"6.9","asian":"3.5","hispanicOrLatino":"14.6"}},"wageData":{"2019":{"workers":"162","median":"979","maleWorkers":"87","maleMedian":"982","femaleWorkers":"76","femaleMedian":"977"}}},"Purchasing agents, except wholesale, retail, and farm products":{"ageData":{"2019":{"total":"279","16to19":"0","20to24":"16","25to34":"57","35to44":"56","45to54":"73","55to64":"53","65+":"23","medianAge":"53"}},"title":"Purchasing agents, except wholesale, retail, and farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"279","women":"48.5","white":"82.5","black":"9.9","asian":"4.2","hispanicOrLatino":"10.3"}},"wageData":{"2019":{"workers":"248","median":"1,170","maleWorkers":"134","maleMedian":"1,202","femaleWorkers":"113","femaleMedian":"1,081"}}},"Claims adjusters, appraisers, examiners, and investigators":{"ageData":{"2019":{"total":"318","16to19":"0","20to24":"11","25to34":"64","35to44":"81","45to54":"88","55to64":"58","65+":"16","medianAge":"58"}},"title":"Claims adjusters, appraisers, examiners, and investigators","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"318","women":"62.1","white":"73.6","black":"19.5","asian":"4.4","hispanicOrLatino":"9.5"}},"wageData":{"2019":{"workers":"299","median":"1,103","maleWorkers":"104","maleMedian":"1,277","femaleWorkers":"195","femaleMedian":"972"}}},"Compliance officers":{"ageData":{"2019":{"total":"298","16to19":"0","20to24":"10","25to34":"56","35to44":"84","45to54":"85","55to64":"50","65+":"13","medianAge":"50"}},"title":"Compliance officers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"298","women":"59.5","white":"80.7","black":"10.2","asian":"6.1","hispanicOrLatino":"10.5"}},"wageData":{"2019":{"workers":"271","median":"1,346","maleWorkers":"105","maleMedian":"1,561","femaleWorkers":"165","femaleMedian":"1,264"}}},"Cost estimators":{"ageData":{"2019":{"total":"127","16to19":"0","20to24":"2","25to34":"27","35to44":"25","45to54":"26","55to64":"31","65+":"15","medianAge":"31"}},"title":"Cost estimators","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"127","women":"14.3","white":"90.0","black":"3.1","asian":"5.8","hispanicOrLatino":"8.1"}},"wageData":{"2019":{"workers":"113","median":"1,254","maleWorkers":"100","maleMedian":"1,264","femaleWorkers":"13","femaleMedian":"-"}}},"Human resources workers":{"ageData":{"2019":{"total":"770","16to19":"2","20to24":"43","25to34":"235","35to44":"195","45to54":"155","55to64":"105","65+":"35","medianAge":"105"}},"title":"Human resources workers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"770","women":"73.5","white":"75.7","black":"13.8","asian":"7.1","hispanicOrLatino":"13.8"}},"wageData":{"2019":{"workers":"680","median":"1,203","maleWorkers":"186","maleMedian":"1,325","femaleWorkers":"494","femaleMedian":"1,149"}}},"Compensation, benefits, and job analysis specialists":{"ageData":{"2019":{"total":"51","16to19":"1","20to24":"2","25to34":"10","35to44":"11","45to54":"15","55to64":"8","65+":"4","medianAge":"8"}},"title":"Compensation, benefits, and job analysis specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"51","women":"75.0","white":"76.0","black":"19.0","asian":"3.7","hispanicOrLatino":"6.0"}},"wageData":{"2019":{"workers":"46","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"32","femaleMedian":"-"}}},"Training and development specialists":{"ageData":{"2019":{"total":"125","16to19":"2","20to24":"2","25to34":"26","35to44":"29","45to54":"28","55to64":"30","65+":"8","medianAge":"30"}},"title":"Training and development specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"125","women":"52.5","white":"77.3","black":"15.4","asian":"4.0","hispanicOrLatino":"10.6"}},"wageData":{"2019":{"workers":"120","median":"1,127","maleWorkers":"51","maleMedian":"1,249","femaleWorkers":"68","femaleMedian":"968"}}},"Logisticians":{"ageData":{"2019":{"total":"154","16to19":"0","20to24":"12","25to34":"45","35to44":"33","45to54":"41","55to64":"20","65+":"3","medianAge":"20"}},"title":"Logisticians","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"154","women":"31.7","white":"77.1","black":"15.5","asian":"2.7","hispanicOrLatino":"8.2"}},"wageData":{"2019":{"workers":"152","median":"1,093","maleWorkers":"107","maleMedian":"1,149","femaleWorkers":"45","femaleMedian":"-"}}},"Management analysts":{"ageData":{"2019":{"total":"950","16to19":"1","20to24":"31","25to34":"241","35to44":"191","45to54":"203","55to64":"181","65+":"102","medianAge":"181"}},"title":"Management analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"950","women":"42.1","white":"76.1","black":"7.5","asian":"13.7","hispanicOrLatino":"8.6"}},"wageData":{"2019":{"workers":"692","median":"1,622","maleWorkers":"389","maleMedian":"1,870","femaleWorkers":"303","femaleMedian":"1,517"}}},"Meeting, convention, and event planners":{"ageData":{"2019":{"total":"146","16to19":"1","20to24":"22","25to34":"47","35to44":"27","45to54":"28","55to64":"15","65+":"6","medianAge":"15"}},"title":"Meeting, convention, and event planners","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"146","women":"78.7","white":"82.0","black":"8.8","asian":"7.4","hispanicOrLatino":"11.9"}},"wageData":{"2019":{"workers":"116","median":"1,023","maleWorkers":"28","maleMedian":"-","femaleWorkers":"89","femaleMedian":"1,018"}}},"Fundraisers":{"ageData":{"2019":{"total":"93","16to19":"0","20to24":"5","25to34":"29","35to44":"23","45to54":"17","55to64":"11","65+":"8","medianAge":"11"}},"title":"Fundraisers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"93","women":"67.2","white":"89.3","black":"5.1","asian":"2.5","hispanicOrLatino":"5.2"}},"wageData":{"2019":{"workers":"85","median":"1,330","maleWorkers":"33","maleMedian":"-","femaleWorkers":"52","femaleMedian":"1,229"}}},"Market research analysts and marketing specialists":{"ageData":{"2019":{"total":"369","16to19":"1","20to24":"41","25to34":"128","35to44":"86","45to54":"68","55to64":"32","65+":"12","medianAge":"32"}},"title":"Market research analysts and marketing specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"369","women":"56.6","white":"80.6","black":"5.9","asian":"11.4","hispanicOrLatino":"7.2"}},"wageData":{"2019":{"workers":"281","median":"1,363","maleWorkers":"130","maleMedian":"1,688","femaleWorkers":"152","femaleMedian":"1,228"}}},"Business operations specialists, all other":{"ageData":{"2019":{"total":"269","16to19":"1","20to24":"19","25to34":"69","35to44":"62","45to54":"49","55to64":"55","65+":"14","medianAge":"55"}},"title":"Business operations specialists, all other","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"269","women":"57.7","white":"75.8","black":"10.3","asian":"10.9","hispanicOrLatino":"10.5"}},"wageData":{"2019":{"workers":"248","median":"1,283","maleWorkers":"100","maleMedian":"1,540","femaleWorkers":"148","femaleMedian":"1,193"}}},"Accountants and auditors":{"ageData":{"2019":{"total":"1,964","16to19":"5","20to24":"91","25to34":"503","35to44":"413","45to54":"429","55to64":"364","65+":"160","medianAge":"364"}},"title":"Accountants and auditors","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"1,964","women":"61.7","white":"77.1","black":"8.5","asian":"12.0","hispanicOrLatino":"8.9"}},"wageData":{"2019":{"workers":"1,683","median":"1,221","maleWorkers":"670","maleMedian":"1,419","femaleWorkers":"1,013","femaleMedian":"1,141"}}},"Appraisers and assessors of real estate":{"ageData":{"2019":{"total":"84","16to19":"1","20to24":"0","25to34":"9","35to44":"18","45to54":"18","55to64":"28","65+":"10","medianAge":"28"}},"title":"Appraisers and assessors of real estate","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"84","women":"42.0","white":"93.2","black":"2.7","asian":"4.1","hispanicOrLatino":"8.3"}},"wageData":{"2019":{"workers":"46","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"23","femaleMedian":"-"}}},"Budget analysts":{"ageData":{"2019":{"total":"51","16to19":"0","20to24":"1","25to34":"19","35to44":"10","45to54":"11","55to64":"9","65+":"1","medianAge":"9"}},"title":"Budget analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"51","women":"60.4","white":"64.6","black":"19.3","asian":"12.2","hispanicOrLatino":"3.6"}},"wageData":{"2019":{"workers":"40","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"21","femaleMedian":"-"}}},"Credit analysts":{"ageData":{"2019":{"total":"28","16to19":"0","20to24":"5","25to34":"8","35to44":"8","45to54":"4","55to64":"3","65+":"0","medianAge":"3"}},"title":"Credit analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"28","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"26","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"18","femaleMedian":"-"}}},"Financial analysts":{"ageData":{"2019":{"total":"345","16to19":"1","20to24":"27","25to34":"119","35to44":"94","45to54":"67","55to64":"29","65+":"7","medianAge":"29"}},"title":"Financial analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"345","women":"34.2","white":"77.8","black":"8.6","asian":"11.7","hispanicOrLatino":"8.3"}},"wageData":{"2019":{"workers":"307","median":"1,613","maleWorkers":"203","maleMedian":"1,763","femaleWorkers":"104","femaleMedian":"1,386"}}},"Personal financial advisors":{"ageData":{"2019":{"total":"551","16to19":"0","20to24":"31","25to34":"140","35to44":"133","45to54":"112","55to64":"93","65+":"41","medianAge":"93"}},"title":"Personal financial advisors","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"551","women":"32.1","white":"82.2","black":"6.9","asian":"8.6","hispanicOrLatino":"6.3"}},"wageData":{"2019":{"workers":"448","median":"1,618","maleWorkers":"296","maleMedian":"1,905","femaleWorkers":"152","femaleMedian":"1,232"}}},"Insurance underwriters":{"ageData":{"2019":{"total":"105","16to19":"1","20to24":"8","25to34":"23","35to44":"21","45to54":"31","55to64":"18","65+":"3","medianAge":"18"}},"title":"Insurance underwriters","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"105","women":"51.1","white":"87.0","black":"5.9","asian":"5.4","hispanicOrLatino":"6.2"}},"wageData":{"2019":{"workers":"116","median":"1,169","maleWorkers":"57","maleMedian":"1,338","femaleWorkers":"59","femaleMedian":"1,142"}}},"Financial examiners":{"ageData":{"2019":{"total":"21","16to19":"0","20to24":"0","25to34":"3","35to44":"7","45to54":"2","55to64":"10","65+":"0","medianAge":"10"}},"title":"Financial examiners","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"21","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"20","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Credit counselors and loan officers":{"ageData":{"2019":{"total":"403","16to19":"1","20to24":"20","25to34":"104","35to44":"103","45to54":"88","55to64":"70","65+":"17","medianAge":"70"}},"title":"Credit counselors and loan officers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"403","women":"53.9","white":"81.7","black":"12.2","asian":"4.2","hispanicOrLatino":"11.6"}},"wageData":{"2019":{"workers":"366","median":"1,235","maleWorkers":"173","maleMedian":"1,542","femaleWorkers":"193","femaleMedian":"1,020"}}},"Tax examiners and collectors, and revenue agents":{"ageData":{"2019":{"total":"53","16to19":"0","20to24":"0","25to34":"12","35to44":"11","45to54":"12","55to64":"14","65+":"3","medianAge":"14"}},"title":"Tax examiners and collectors, and revenue agents","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"53","women":"69.2","white":"58.8","black":"25.8","asian":"12.8","hispanicOrLatino":"12.1"}},"wageData":{"2019":{"workers":"49","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"31","femaleMedian":"-"}}},"Tax preparers":{"ageData":{"2019":{"total":"97","16to19":"0","20to24":"7","25to34":"14","35to44":"12","45to54":"20","55to64":"22","65+":"23","medianAge":"22"}},"title":"Tax preparers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"97","women":"62.3","white":"77.5","black":"16.6","asian":"5.6","hispanicOrLatino":"15.2"}},"wageData":{"2019":{"workers":"46","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"26","femaleMedian":"-"}}},"Financial specialists, all other":{"ageData":{"2019":{"total":"57","16to19":"0","20to24":"3","25to34":"15","35to44":"15","45to54":"16","55to64":"7","65+":"1","medianAge":"7"}},"title":"Financial specialists, all other","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2019":{"total":"57","women":"46.8","white":"68.6","black":"17.9","asian":"8.7","hispanicOrLatino":"15.9"}},"wageData":{"2019":{"workers":"50","median":"1,209","maleWorkers":"24","maleMedian":"-","femaleWorkers":"26","femaleMedian":"-"}}},"Professional and related occupations":{"ageData":{"2019":{"total":"37,237","16to19":"346","20to24":"2,433","25to34":"9,598","35to44":"8,803","45to54":"7,634","55to64":"5,966","65+":"2,457","medianAge":"5,966"}},"title":"Professional and related occupations","depth":2,"parent":"Management, professional, and related occupations","sexRaceEthnicityData":{"2019":{"total":"37,237","women":"57.4","white":"76.7","black":"10.5","asian":"10.0","hispanicOrLatino":"9.9"}},"wageData":{"2019":{"workers":"29,423","median":"1,237","maleWorkers":"13,149","maleMedian":"1,493","femaleWorkers":"16,274","femaleMedian":"1,085"}}},"Computer and mathematical occupations":{"ageData":{"2019":{"total":"5,352","16to19":"26","20to24":"354","25to34":"1,593","35to44":"1,414","45to54":"1,092","55to64":"700","65+":"173","medianAge":"700"}},"title":"Computer and mathematical occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2019":{"total":"5,352","women":"25.8","white":"65.7","black":"8.7","asian":"23.1","hispanicOrLatino":"7.8"}},"wageData":{"2019":{"workers":"4,947","median":"1,579","maleWorkers":"3,668","maleMedian":"1,658","femaleWorkers":"1,279","femaleMedian":"1,353"}}},"Computer and information research scientists":{"ageData":{"2019":{"total":"24","16to19":"0","20to24":"4","25to34":"6","35to44":"7","45to54":"4","55to64":"1","65+":"1","medianAge":"1"}},"title":"Computer and information research scientists","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2019":{"total":"24","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"20","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Computer systems analysts":{"ageData":{"2019":{"total":"663","16to19":"1","20to24":"59","25to34":"191","35to44":"181","45to54":"121","55to64":"94","65+":"16","medianAge":"94"}},"title":"Computer systems analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2019":{"total":"663","women":"40.1","white":"67.8","black":"9.7","asian":"20.3","hispanicOrLatino":"8.3"}},"wageData":{"2019":{"workers":"623","median":"1,461","maleWorkers":"368","maleMedian":"1,580","femaleWorkers":"255","femaleMedian":"1,289"}}},"Information security analysts":{"ageData":{"2019":{"total":"125","16to19":"1","20to24":"12","25to34":"46","35to44":"31","45to54":"18","55to64":"15","65+":"2","medianAge":"15"}},"title":"Information security analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2019":{"total":"125","women":"17.1","white":"74.6","black":"16.6","asian":"7.6","hispanicOrLatino":"12.9"}},"wageData":{"2019":{"workers":"128","median":"1,758","maleWorkers":"103","maleMedian":"1,875","femaleWorkers":"25","femaleMedian":"-"}}},"Computer programmers":{"ageData":{"2019":{"total":"454","16to19":"2","20to24":"19","25to34":"117","35to44":"105","45to54":"116","55to64":"72","65+":"24","medianAge":"72"}},"title":"Computer programmers","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2019":{"total":"454","women":"20.3","white":"67.8","black":"8.5","asian":"21.8","hispanicOrLatino":"8.7"}},"wageData":{"2019":{"workers":"425","median":"1,586","maleWorkers":"343","maleMedian":"1,613","femaleWorkers":"82","femaleMedian":"1,463"}}},"Software developers, applications and systems software":{"ageData":{"2019":{"total":"1,815","16to19":"2","20to24":"111","25to34":"640","35to44":"496","45to54":"313","55to64":"195","65+":"56","medianAge":"195"}},"title":"Software developers, applications and systems software","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2019":{"total":"1,815","women":"18.7","white":"54.0","black":"5.8","asian":"37.7","hispanicOrLatino":"5.1"}},"wageData":{"2019":{"workers":"1,714","median":"1,894","maleWorkers":"1,379","maleMedian":"1,920","femaleWorkers":"335","femaleMedian":"1,718"}}},"Web developers":{"ageData":{"2019":{"total":"193","16to19":"4","20to24":"15","25to34":"56","35to44":"60","45to54":"36","55to64":"16","65+":"7","medianAge":"16"}},"title":"Web developers","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2019":{"total":"193","women":"41.4","white":"77.6","black":"6.7","asian":"12.0","hispanicOrLatino":"4.6"}},"wageData":{"2019":{"workers":"144","median":"1,470","maleWorkers":"88","maleMedian":"1,633","femaleWorkers":"56","femaleMedian":"1,150"}}},"Computer support specialists":{"ageData":{"2019":{"total":"547","16to19":"5","20to24":"36","25to34":"158","35to44":"145","45to54":"119","55to64":"68","65+":"15","medianAge":"68"}},"title":"Computer support specialists","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2019":{"total":"547","women":"26.4","white":"74.2","black":"10.5","asian":"12.7","hispanicOrLatino":"11.3"}},"wageData":{"2019":{"workers":"486","median":"1,192","maleWorkers":"365","maleMedian":"1,223","femaleWorkers":"121","femaleMedian":"1,103"}}},"Database administrators":{"ageData":{"2019":{"total":"106","16to19":"0","20to24":"5","25to34":"21","35to44":"29","45to54":"27","55to64":"18","65+":"7","medianAge":"18"}},"title":"Database administrators","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2019":{"total":"106","women":"30.2","white":"72.0","black":"6.8","asian":"16.7","hispanicOrLatino":"6.2"}},"wageData":{"2019":{"workers":"96","median":"1,642","maleWorkers":"67","maleMedian":"1,752","femaleWorkers":"29","femaleMedian":"-"}}},"Network and computer systems administrators":{"ageData":{"2019":{"total":"199","16to19":"0","20to24":"8","25to34":"48","35to44":"65","45to54":"50","55to64":"25","65+":"4","medianAge":"25"}},"title":"Network and computer systems administrators","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2019":{"total":"199","women":"26.1","white":"77.2","black":"9.7","asian":"11.7","hispanicOrLatino":"8.5"}},"wageData":{"2019":{"workers":"194","median":"1,447","maleWorkers":"144","maleMedian":"1,541","femaleWorkers":"50","femaleMedian":"1,233"}}},"Computer network architects":{"ageData":{"2019":{"total":"106","16to19":"0","20to24":"1","25to34":"15","35to44":"32","45to54":"37","55to64":"19","65+":"3","medianAge":"19"}},"title":"Computer network architects","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2019":{"total":"106","women":"9.2","white":"76.1","black":"13.1","asian":"10.3","hispanicOrLatino":"14.1"}},"wageData":{"2019":{"workers":"104","median":"1,883","maleWorkers":"95","maleMedian":"1,901","femaleWorkers":"10","femaleMedian":"-"}}},"Computer occupations, all other":{"ageData":{"2019":{"total":"808","16to19":"11","20to24":"61","25to34":"205","35to44":"190","45to54":"188","55to64":"121","65+":"33","medianAge":"121"}},"title":"Computer occupations, all other","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2019":{"total":"808","women":"23.6","white":"70.5","black":"12.7","asian":"14.1","hispanicOrLatino":"9.7"}},"wageData":{"2019":{"workers":"721","median":"1,277","maleWorkers":"542","maleMedian":"1,365","femaleWorkers":"179","femaleMedian":"1,148"}}},"Actuaries":{"ageData":{"2019":{"total":"33","16to19":"0","20to24":"1","25to34":"7","35to44":"7","45to54":"10","55to64":"7","65+":"0","medianAge":"7"}},"title":"Actuaries","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2019":{"total":"33","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"28","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Mathematicians":{"ageData":{"2019":{"total":"3","16to19":"0","20to24":"1","25to34":"0","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Mathematicians","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2019":{"total":"3","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Operations research analysts":{"ageData":{"2019":{"total":"152","16to19":"0","20to24":"8","25to34":"42","35to44":"34","45to54":"35","55to64":"30","65+":"4","medianAge":"30"}},"title":"Operations research analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2019":{"total":"152","women":"42.7","white":"80.5","black":"6.8","asian":"8.3","hispanicOrLatino":"9.7"}},"wageData":{"2019":{"workers":"153","median":"1,512","maleWorkers":"86","maleMedian":"1,753","femaleWorkers":"67","femaleMedian":"1,188"}}},"Statisticians":{"ageData":{"2019":{"total":"101","16to19":"0","20to24":"9","25to34":"35","35to44":"26","45to54":"14","55to64":"15","65+":"2","medianAge":"15"}},"title":"Statisticians","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2019":{"total":"101","women":"52.4","white":"69.6","black":"8.2","asian":"21.1","hispanicOrLatino":"7.7"}},"wageData":{"2019":{"workers":"90","median":"1,456","maleWorkers":"44","maleMedian":"-","femaleWorkers":"46","femaleMedian":"-"}}},"Miscellaneous mathematical science occupations":{"ageData":{"2019":{"total":"22","16to19":"0","20to24":"5","25to34":"6","35to44":"5","45to54":"4","55to64":"4","65+":"0","medianAge":"4"}},"title":"Miscellaneous mathematical science occupations","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2019":{"total":"22","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"18","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Architecture and engineering occupations":{"ageData":{"2019":{"total":"3,305","16to19":"13","20to24":"209","25to34":"871","35to44":"718","45to54":"659","55to64":"663","65+":"173","medianAge":"663"}},"title":"Architecture and engineering occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2019":{"total":"3,305","women":"15.7","white":"77.5","black":"6.8","asian":"13.3","hispanicOrLatino":"9.2"}},"wageData":{"2019":{"workers":"3,011","median":"1,550","maleWorkers":"2,559","maleMedian":"1,589","femaleWorkers":"452","femaleMedian":"1,339"}}},"Architects, except naval":{"ageData":{"2019":{"total":"208","16to19":"0","20to24":"3","25to34":"42","35to44":"53","45to54":"43","55to64":"46","65+":"21","medianAge":"46"}},"title":"Architects, except naval","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2019":{"total":"208","women":"24.5","white":"82.6","black":"6.3","asian":"8.8","hispanicOrLatino":"8.5"}},"wageData":{"2019":{"workers":"152","median":"1,572","maleWorkers":"114","maleMedian":"1,706","femaleWorkers":"38","femaleMedian":"-"}}},"Surveyors, cartographers, and photogrammetrists":{"ageData":{"2019":{"total":"48","16to19":"0","20to24":"1","25to34":"9","35to44":"9","45to54":"10","55to64":"13","65+":"5","medianAge":"13"}},"title":"Surveyors, cartographers, and photogrammetrists","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2019":{"total":"48","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"42","median":"-","maleWorkers":"34","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Aerospace engineers":{"ageData":{"2019":{"total":"134","16to19":"0","20to24":"4","25to34":"36","35to44":"23","45to54":"22","55to64":"39","65+":"10","medianAge":"39"}},"title":"Aerospace engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2019":{"total":"134","women":"13.8","white":"78.0","black":"6.5","asian":"14.5","hispanicOrLatino":"7.3"}},"wageData":{"2019":{"workers":"138","median":"1,917","maleWorkers":"121","maleMedian":"2,018","femaleWorkers":"17","femaleMedian":"-"}}},"Agricultural engineers":{"ageData":{"2019":{"total":"6","16to19":"0","20to24":"0","25to34":"3","35to44":"0","45to54":"0","55to64":"2","65+":"0","medianAge":"2"}},"title":"Agricultural engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2019":{"total":"6","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Biomedical engineers":{"ageData":{"2019":{"total":"25","16to19":"0","20to24":"4","25to34":"8","35to44":"6","45to54":"1","55to64":"5","65+":"1","medianAge":"5"}},"title":"Biomedical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2019":{"total":"25","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"17","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Chemical engineers":{"ageData":{"2019":{"total":"87","16to19":"0","20to24":"6","25to34":"28","35to44":"14","45to54":"17","55to64":"15","65+":"6","medianAge":"15"}},"title":"Chemical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2019":{"total":"87","women":"14.4","white":"75.6","black":"4.0","asian":"17.1","hispanicOrLatino":"2.4"}},"wageData":{"2019":{"workers":"86","median":"1,863","maleWorkers":"74","maleMedian":"1,878","femaleWorkers":"12","femaleMedian":"-"}}},"Civil engineers":{"ageData":{"2019":{"total":"475","16to19":"0","20to24":"37","25to34":"134","35to44":"109","45to54":"75","55to64":"90","65+":"29","medianAge":"90"}},"title":"Civil engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2019":{"total":"475","women":"13.9","white":"80.3","black":"5.9","asian":"12.2","hispanicOrLatino":"8.4"}},"wageData":{"2019":{"workers":"421","median":"1,616","maleWorkers":"360","maleMedian":"1,657","femaleWorkers":"61","femaleMedian":"1,353"}}},"Computer hardware engineers":{"ageData":{"2019":{"total":"77","16to19":"0","20to24":"12","25to34":"17","35to44":"22","45to54":"11","55to64":"13","65+":"1","medianAge":"13"}},"title":"Computer hardware engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2019":{"total":"77","women":"22.8","white":"54.3","black":"5.7","asian":"38.4","hispanicOrLatino":"10.2"}},"wageData":{"2019":{"workers":"71","median":"1,882","maleWorkers":"57","maleMedian":"1,919","femaleWorkers":"15","femaleMedian":"-"}}},"Electrical and electronics engineers":{"ageData":{"2019":{"total":"285","16to19":"0","20to24":"13","25to34":"70","35to44":"69","45to54":"54","55to64":"61","65+":"18","medianAge":"61"}},"title":"Electrical and electronics engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2019":{"total":"285","women":"11.6","white":"71.3","black":"7.3","asian":"19.9","hispanicOrLatino":"8.7"}},"wageData":{"2019":{"workers":"266","median":"1,781","maleWorkers":"241","maleMedian":"1,830","femaleWorkers":"25","femaleMedian":"-"}}},"Environmental engineers":{"ageData":{"2019":{"total":"25","16to19":"0","20to24":"0","25to34":"8","35to44":"5","45to54":"6","55to64":"3","65+":"2","medianAge":"3"}},"title":"Environmental engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2019":{"total":"25","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"25","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Industrial engineers, including health and safety":{"ageData":{"2019":{"total":"245","16to19":"1","20to24":"11","25to34":"64","35to44":"56","45to54":"53","55to64":"49","65+":"11","medianAge":"49"}},"title":"Industrial engineers, including health and safety","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2019":{"total":"245","women":"24.3","white":"80.7","black":"7.9","asian":"9.4","hispanicOrLatino":"5.9"}},"wageData":{"2019":{"workers":"227","median":"1,589","maleWorkers":"169","maleMedian":"1,616","femaleWorkers":"58","femaleMedian":"1,487"}}},"Marine engineers and naval architects":{"ageData":{"2019":{"total":"12","16to19":"0","20to24":"0","25to34":"4","35to44":"3","45to54":"3","55to64":"2","65+":"0","medianAge":"2"}},"title":"Marine engineers and naval architects","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2019":{"total":"12","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"13","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Materials engineers":{"ageData":{"2019":{"total":"44","16to19":"0","20to24":"1","25to34":"16","35to44":"7","45to54":"10","55to64":"8","65+":"3","medianAge":"8"}},"title":"Materials engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2019":{"total":"44","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"44","median":"-","maleWorkers":"39","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Mechanical engineers":{"ageData":{"2019":{"total":"351","16to19":"4","20to24":"22","25to34":"113","35to44":"74","45to54":"73","55to64":"54","65+":"12","medianAge":"54"}},"title":"Mechanical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2019":{"total":"351","women":"6.6","white":"80.4","black":"5.1","asian":"11.6","hispanicOrLatino":"8.4"}},"wageData":{"2019":{"workers":"322","median":"1,625","maleWorkers":"303","maleMedian":"1,635","femaleWorkers":"19","femaleMedian":"-"}}},"Mining and geological engineers, including mining safety engineers":{"ageData":{"2019":{"total":"8","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"2","55to64":"3","65+":"0","medianAge":"3"}},"title":"Mining and geological engineers, including mining safety engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2019":{"total":"8","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"8","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Nuclear engineers":{"ageData":{"2019":{"total":"8","16to19":"0","20to24":"0","25to34":"3","35to44":"1","45to54":"1","55to64":"2","65+":"2","medianAge":"2"}},"title":"Nuclear engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2019":{"total":"8","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"8","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Petroleum engineers":{"ageData":{"2019":{"total":"24","16to19":"0","20to24":"1","25to34":"7","35to44":"9","45to54":"4","55to64":"2","65+":"1","medianAge":"2"}},"title":"Petroleum engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2019":{"total":"24","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"24","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Engineers, all other":{"ageData":{"2019":{"total":"582","16to19":"1","20to24":"32","25to34":"150","35to44":"128","45to54":"118","55to64":"125","65+":"27","medianAge":"125"}},"title":"Engineers, all other","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2019":{"total":"582","women":"13.9","white":"71.8","black":"5.4","asian":"20.6","hispanicOrLatino":"9.8"}},"wageData":{"2019":{"workers":"529","median":"1,636","maleWorkers":"455","maleMedian":"1,663","femaleWorkers":"74","femaleMedian":"1,446"}}},"Drafters":{"ageData":{"2019":{"total":"113","16to19":"0","20to24":"12","25to34":"23","35to44":"24","45to54":"32","55to64":"17","65+":"4","medianAge":"17"}},"title":"Drafters","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2019":{"total":"113","women":"23.3","white":"90.8","black":"3.5","asian":"2.7","hispanicOrLatino":"14.7"}},"wageData":{"2019":{"workers":"104","median":"1,045","maleWorkers":"82","maleMedian":"1,047","femaleWorkers":"22","femaleMedian":"-"}}},"Engineering technicians, except drafters":{"ageData":{"2019":{"total":"496","16to19":"5","20to24":"41","25to34":"120","35to44":"97","45to54":"111","55to64":"106","65+":"15","medianAge":"106"}},"title":"Engineering technicians, except drafters","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2019":{"total":"496","women":"19.8","white":"76.5","black":"12.1","asian":"8.3","hispanicOrLatino":"12.7"}},"wageData":{"2019":{"workers":"462","median":"1,161","maleWorkers":"382","maleMedian":"1,200","femaleWorkers":"79","femaleMedian":"915"}}},"Surveying and mapping technicians":{"ageData":{"2019":{"total":"53","16to19":"1","20to24":"7","25to34":"13","35to44":"6","45to54":"13","55to64":"8","65+":"5","medianAge":"8"}},"title":"Surveying and mapping technicians","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2019":{"total":"53","women":"6.8","white":"86.3","black":"6.6","asian":"3.5","hispanicOrLatino":"10.9"}},"wageData":{"2019":{"workers":"50","median":"1,060","maleWorkers":"46","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Life, physical, and social science occupations":{"ageData":{"2019":{"total":"1,485","16to19":"9","20to24":"137","25to34":"427","35to44":"320","45to54":"262","55to64":"231","65+":"99","medianAge":"231"}},"title":"Life, physical, and social science occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2019":{"total":"1,485","women":"49.4","white":"76.9","black":"6.3","asian":"14.4","hispanicOrLatino":"9.5"}},"wageData":{"2019":{"workers":"1,233","median":"1,334","maleWorkers":"676","maleMedian":"1,447","femaleWorkers":"556","femaleMedian":"1,237"}}},"Agricultural and food scientists":{"ageData":{"2019":{"total":"37","16to19":"0","20to24":"8","25to34":"13","35to44":"6","45to54":"5","55to64":"6","65+":"1","medianAge":"6"}},"title":"Agricultural and food scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2019":{"total":"37","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"36","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Biological scientists":{"ageData":{"2019":{"total":"104","16to19":"0","20to24":"8","25to34":"32","35to44":"23","45to54":"23","55to64":"12","65+":"7","medianAge":"12"}},"title":"Biological scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2019":{"total":"104","women":"47.7","white":"81.0","black":"3.4","asian":"14.4","hispanicOrLatino":"8.7"}},"wageData":{"2019":{"workers":"101","median":"1,250","maleWorkers":"57","maleMedian":"1,266","femaleWorkers":"44","femaleMedian":"-"}}},"Conservation scientists and foresters":{"ageData":{"2019":{"total":"20","16to19":"0","20to24":"1","25to34":"3","35to44":"8","45to54":"3","55to64":"4","65+":"1","medianAge":"4"}},"title":"Conservation scientists and foresters","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2019":{"total":"20","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"20","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Medical scientists":{"ageData":{"2019":{"total":"170","16to19":"0","20to24":"12","25to34":"59","35to44":"43","45to54":"24","55to64":"25","65+":"7","medianAge":"25"}},"title":"Medical scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2019":{"total":"170","women":"51.8","white":"64.1","black":"7.3","asian":"27.8","hispanicOrLatino":"8.8"}},"wageData":{"2019":{"workers":"146","median":"1,188","maleWorkers":"77","maleMedian":"1,214","femaleWorkers":"70","femaleMedian":"1,175"}}},"Life scientists, all other":{"ageData":{"2019":{"total":"2","16to19":"0","20to24":"1","25to34":"1","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Life scientists, all other","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2019":{"total":"2","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"3","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Astronomers and physicists":{"ageData":{"2019":{"total":"17","16to19":"0","20to24":"0","25to34":"4","35to44":"4","45to54":"3","55to64":"6","65+":"1","medianAge":"6"}},"title":"Astronomers and physicists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2019":{"total":"17","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"15","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Atmospheric and space scientists":{"ageData":{"2019":{"total":"10","16to19":"0","20to24":"0","25to34":"2","35to44":"2","45to54":"2","55to64":"4","65+":"0","medianAge":"4"}},"title":"Atmospheric and space scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2019":{"total":"10","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"13","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Chemists and materials scientists":{"ageData":{"2019":{"total":"97","16to19":"0","20to24":"7","25to34":"35","35to44":"16","45to54":"16","55to64":"17","65+":"5","medianAge":"17"}},"title":"Chemists and materials scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2019":{"total":"97","women":"42.5","white":"75.7","black":"7.0","asian":"13.7","hispanicOrLatino":"8.2"}},"wageData":{"2019":{"workers":"85","median":"1,582","maleWorkers":"49","maleMedian":"-","femaleWorkers":"36","femaleMedian":"-"}}},"Environmental scientists and geoscientists":{"ageData":{"2019":{"total":"119","16to19":"1","20to24":"10","25to34":"32","35to44":"31","45to54":"18","55to64":"18","65+":"10","medianAge":"18"}},"title":"Environmental scientists and geoscientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2019":{"total":"119","women":"33.0","white":"85.1","black":"4.8","asian":"7.4","hispanicOrLatino":"12.4"}},"wageData":{"2019":{"workers":"101","median":"1,486","maleWorkers":"65","maleMedian":"1,519","femaleWorkers":"36","femaleMedian":"-"}}},"Physical scientists, all other":{"ageData":{"2019":{"total":"298","16to19":"0","20to24":"23","25to34":"99","35to44":"71","45to54":"50","55to64":"45","65+":"10","medianAge":"45"}},"title":"Physical scientists, all other","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2019":{"total":"298","women":"43.7","white":"68.3","black":"3.4","asian":"25.7","hispanicOrLatino":"7.1"}},"wageData":{"2019":{"workers":"278","median":"1,669","maleWorkers":"158","maleMedian":"1,901","femaleWorkers":"120","femaleMedian":"1,385"}}},"Economists":{"ageData":{"2019":{"total":"35","16to19":"0","20to24":"0","25to34":"9","35to44":"8","45to54":"6","55to64":"10","65+":"2","medianAge":"10"}},"title":"Economists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2019":{"total":"35","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"35","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Survey researchers":{"ageData":{"2019":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Survey researchers","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2019":{"total":"0","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Psychologists":{"ageData":{"2019":{"total":"234","16to19":"0","20to24":"4","25to34":"43","35to44":"49","45to54":"61","55to64":"37","65+":"41","medianAge":"37"}},"title":"Psychologists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2019":{"total":"234","women":"79.7","white":"89.9","black":"5.8","asian":"3.5","hispanicOrLatino":"10.3"}},"wageData":{"2019":{"workers":"114","median":"1,468","maleWorkers":"22","maleMedian":"-","femaleWorkers":"93","femaleMedian":"1,441"}}},"Sociologists":{"ageData":{"2019":{"total":"2","16to19":"0","20to24":"2","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Sociologists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2019":{"total":"2","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"2","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Urban and regional planners":{"ageData":{"2019":{"total":"25","16to19":"0","20to24":"3","25to34":"8","35to44":"6","45to54":"5","55to64":"2","65+":"1","medianAge":"2"}},"title":"Urban and regional planners","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2019":{"total":"25","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"22","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Miscellaneous social scientists and related workers":{"ageData":{"2019":{"total":"39","16to19":"0","20to24":"2","25to34":"11","35to44":"8","45to54":"8","55to64":"5","65+":"5","medianAge":"5"}},"title":"Miscellaneous social scientists and related workers","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2019":{"total":"39","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"32","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Agricultural and food science technicians":{"ageData":{"2019":{"total":"20","16to19":"0","20to24":"5","25to34":"4","35to44":"1","45to54":"3","55to64":"4","65+":"3","medianAge":"4"}},"title":"Agricultural and food science technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2019":{"total":"20","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"20","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Biological technicians":{"ageData":{"2019":{"total":"23","16to19":"0","20to24":"3","25to34":"8","35to44":"6","45to54":"3","55to64":"4","65+":"0","medianAge":"4"}},"title":"Biological technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2019":{"total":"23","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"20","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Chemical technicians":{"ageData":{"2019":{"total":"56","16to19":"1","20to24":"3","25to34":"17","35to44":"15","45to54":"11","55to64":"9","65+":"1","medianAge":"9"}},"title":"Chemical technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2019":{"total":"56","women":"30.8","white":"80.1","black":"10.6","asian":"6.3","hispanicOrLatino":"12.2"}},"wageData":{"2019":{"workers":"61","median":"893","maleWorkers":"41","maleMedian":"-","femaleWorkers":"20","femaleMedian":"-"}}},"Geological and petroleum technicians":{"ageData":{"2019":{"total":"20","16to19":"0","20to24":"1","25to34":"3","35to44":"6","45to54":"8","55to64":"0","65+":"1","medianAge":"0"}},"title":"Geological and petroleum technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2019":{"total":"20","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"18","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Nuclear technicians":{"ageData":{"2019":{"total":"3","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Nuclear technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2019":{"total":"3","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"3","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Social science research assistants":{"ageData":{"2019":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Social science research assistants","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2019":{"total":"1","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Miscellaneous life, physical, and social science technicians":{"ageData":{"2019":{"total":"152","16to19":"6","20to24":"44","25to34":"45","35to44":"16","45to54":"13","55to64":"22","65+":"6","medianAge":"22"}},"title":"Miscellaneous life, physical, and social science technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2019":{"total":"152","women":"54.0","white":"72.8","black":"8.6","asian":"15.0","hispanicOrLatino":"13.4"}},"wageData":{"2019":{"workers":"108","median":"907","maleWorkers":"57","maleMedian":"928","femaleWorkers":"51","femaleMedian":"896"}}},"Community and social service occupations":{"ageData":{"2019":{"total":"2,717","16to19":"20","20to24":"168","25to34":"648","35to44":"596","45to54":"559","55to64":"479","65+":"247","medianAge":"479"}},"title":"Community and social service occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2019":{"total":"2,717","women":"67.5","white":"72.9","black":"20.1","asian":"3.6","hispanicOrLatino":"13.0"}},"wageData":{"2019":{"workers":"2,240","median":"968","maleWorkers":"742","maleMedian":"1,064","femaleWorkers":"1,498","femaleMedian":"941"}}},"Counselors":{"ageData":{"2019":{"total":"927","16to19":"13","20to24":"67","25to34":"232","35to44":"214","45to54":"182","55to64":"142","65+":"78","medianAge":"142"}},"title":"Counselors","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2019":{"total":"927","women":"75.7","white":"72.7","black":"21.2","asian":"2.7","hispanicOrLatino":"12.7"}},"wageData":{"2019":{"workers":"720","median":"987","maleWorkers":"179","maleMedian":"944","femaleWorkers":"541","femaleMedian":"1,003"}}},"Social workers":{"ageData":{"2019":{"total":"823","16to19":"2","20to24":"38","25to34":"226","35to44":"190","45to54":"187","55to64":"140","65+":"40","medianAge":"140"}},"title":"Social workers","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2019":{"total":"823","women":"81.9","white":"69.6","black":"23.0","asian":"3.7","hispanicOrLatino":"14.3"}},"wageData":{"2019":{"workers":"739","median":"964","maleWorkers":"136","maleMedian":"1,108","femaleWorkers":"603","femaleMedian":"944"}}},"Probation officers and correctional treatment specialists":{"ageData":{"2019":{"total":"97","16to19":"0","20to24":"2","25to34":"26","35to44":"27","45to54":"31","55to64":"10","65+":"1","medianAge":"10"}},"title":"Probation officers and correctional treatment specialists","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2019":{"total":"97","women":"44.6","white":"70.6","black":"26.7","asian":"0.4","hispanicOrLatino":"15.8"}},"wageData":{"2019":{"workers":"94","median":"1,067","maleWorkers":"50","maleMedian":"1,050","femaleWorkers":"45","femaleMedian":"-"}}},"Social and human service assistants":{"ageData":{"2019":{"total":"238","16to19":"2","20to24":"30","25to34":"63","35to44":"46","45to54":"39","55to64":"45","65+":"13","medianAge":"45"}},"title":"Social and human service assistants","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2019":{"total":"238","women":"79.0","white":"65.2","black":"25.5","asian":"4.3","hispanicOrLatino":"16.4"}},"wageData":{"2019":{"workers":"207","median":"805","maleWorkers":"41","maleMedian":"-","femaleWorkers":"166","femaleMedian":"778"}}},"Miscellaneous community and social service specialists, including health educators and community health workers":{"ageData":{"2019":{"total":"78","16to19":"0","20to24":"4","25to34":"13","35to44":"21","45to54":"21","55to64":"15","65+":"4","medianAge":"15"}},"title":"Miscellaneous community and social service specialists, including health educators and community health workers","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2019":{"total":"78","women":"70.8","white":"71.1","black":"22.5","asian":"2.5","hispanicOrLatino":"21.9"}},"wageData":{"2019":{"workers":"66","median":"920","maleWorkers":"20","maleMedian":"-","femaleWorkers":"46","femaleMedian":"-"}}},"Clergy":{"ageData":{"2019":{"total":"413","16to19":"0","20to24":"11","25to34":"60","35to44":"73","45to54":"80","55to64":"103","65+":"86","medianAge":"103"}},"title":"Clergy","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2019":{"total":"413","women":"20.7","white":"79.1","black":"12.2","asian":"5.9","hispanicOrLatino":"7.7"}},"wageData":{"2019":{"workers":"332","median":"1,066","maleWorkers":"275","maleMedian":"1,155","femaleWorkers":"57","femaleMedian":"862"}}},"Directors, religious activities and education":{"ageData":{"2019":{"total":"72","16to19":"1","20to24":"5","25to34":"20","35to44":"13","45to54":"11","55to64":"12","65+":"10","medianAge":"12"}},"title":"Directors, religious activities and education","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2019":{"total":"72","women":"48.6","white":"92.3","black":"5.1","asian":"2.3","hispanicOrLatino":"13.4"}},"wageData":{"2019":{"workers":"48","median":"-","maleWorkers":"29","maleMedian":"-","femaleWorkers":"19","femaleMedian":"-"}}},"Religious workers, all other":{"ageData":{"2019":{"total":"69","16to19":"2","20to24":"9","25to34":"8","35to44":"12","45to54":"9","55to64":"13","65+":"15","medianAge":"13"}},"title":"Religious workers, all other","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2019":{"total":"69","women":"72.7","white":"89.6","black":"5.1","asian":"4.7","hispanicOrLatino":"8.3"}},"wageData":{"2019":{"workers":"34","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"21","femaleMedian":"-"}}},"Legal occupations":{"ageData":{"2019":{"total":"1,955","16to19":"4","20to24":"54","25to34":"406","35to44":"438","45to54":"432","55to64":"368","65+":"251","medianAge":"368"}},"title":"Legal occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2019":{"total":"1,955","women":"52.7","white":"83.0","black":"8.3","asian":"6.1","hispanicOrLatino":"9.5"}},"wageData":{"2019":{"workers":"1,478","median":"1,562","maleWorkers":"670","maleMedian":"1,999","femaleWorkers":"808","femaleMedian":"1,266"}}},"Lawyers":{"ageData":{"2019":{"total":"1,240","16to19":"2","20to24":"5","25to34":"233","35to44":"310","45to54":"279","55to64":"224","65+":"188","medianAge":"224"}},"title":"Lawyers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2019":{"total":"1,240","women":"36.4","white":"86.6","black":"5.9","asian":"5.7","hispanicOrLatino":"5.8"}},"wageData":{"2019":{"workers":"884","median":"2,043","maleWorkers":"548","maleMedian":"2,202","femaleWorkers":"336","femaleMedian":"1,878"}}},"Judicial law clerks":{"ageData":{"2019":{"total":"7","16to19":"0","20to24":"0","25to34":"4","35to44":"0","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Judicial law clerks","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2019":{"total":"7","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"12","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Judges, magistrates, and other judicial workers":{"ageData":{"2019":{"total":"70","16to19":"0","20to24":"0","25to34":"3","35to44":"10","45to54":"21","55to64":"22","65+":"15","medianAge":"22"}},"title":"Judges, magistrates, and other judicial workers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2019":{"total":"70","women":"52.5","white":"81.5","black":"13.4","asian":"4.8","hispanicOrLatino":"8.6"}},"wageData":{"2019":{"workers":"61","median":"1,794","maleWorkers":"27","maleMedian":"-","femaleWorkers":"34","femaleMedian":"-"}}},"Paralegals and legal assistants":{"ageData":{"2019":{"total":"444","16to19":"2","20to24":"37","25to34":"115","35to44":"83","45to54":"84","55to64":"92","65+":"30","medianAge":"92"}},"title":"Paralegals and legal assistants","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2019":{"total":"444","women":"89.6","white":"77.1","black":"11.8","asian":"6.7","hispanicOrLatino":"17.7"}},"wageData":{"2019":{"workers":"364","median":"963","maleWorkers":"41","maleMedian":"-","femaleWorkers":"323","femaleMedian":"970"}}},"Miscellaneous legal support workers":{"ageData":{"2019":{"total":"193","16to19":"0","20to24":"12","25to34":"51","35to44":"36","45to54":"46","55to64":"30","65+":"18","medianAge":"30"}},"title":"Miscellaneous legal support workers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2019":{"total":"193","women":"72.5","white":"74.2","black":"13.2","asian":"8.0","hispanicOrLatino":"13.9"}},"wageData":{"2019":{"workers":"157","median":"1,124","maleWorkers":"49","maleMedian":"-","femaleWorkers":"109","femaleMedian":"1,009"}}},"Education, training, and library occupations":{"ageData":{"2019":{"total":"9,455","16to19":"126","20to24":"689","25to34":"2,157","35to44":"2,254","45to54":"2,053","55to64":"1,511","65+":"664","medianAge":"1,511"}},"title":"Education, training, and library occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2019":{"total":"9,455","women":"73.6","white":"81.7","black":"10.2","asian":"5.3","hispanicOrLatino":"11.0"}},"wageData":{"2019":{"workers":"7,238","median":"1,057","maleWorkers":"1,991","maleMedian":"1,265","femaleWorkers":"5,247","femaleMedian":"987"}}},"Postsecondary teachers":{"ageData":{"2019":{"total":"1,386","16to19":"6","20to24":"103","25to34":"284","35to44":"312","45to54":"258","55to64":"251","65+":"172","medianAge":"251"}},"title":"Postsecondary teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2019":{"total":"1,386","women":"47.4","white":"75.3","black":"7.0","asian":"15.1","hispanicOrLatino":"8.3"}},"wageData":{"2019":{"workers":"986","median":"1,512","maleWorkers":"544","maleMedian":"1,670","femaleWorkers":"442","femaleMedian":"1,358"}}},"Preschool and kindergarten teachers":{"ageData":{"2019":{"total":"655","16to19":"10","20to24":"80","25to34":"175","35to44":"157","45to54":"131","55to64":"79","65+":"23","medianAge":"79"}},"title":"Preschool and kindergarten teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2019":{"total":"655","women":"98.7","white":"75.8","black":"15.7","asian":"5.2","hispanicOrLatino":"14.9"}},"wageData":{"2019":{"workers":"496","median":"701","maleWorkers":"7","maleMedian":"-","femaleWorkers":"489","femaleMedian":"705"}}},"Elementary and middle school teachers":{"ageData":{"2019":{"total":"3,604","16to19":"6","20to24":"171","25to34":"887","35to44":"938","45to54":"877","55to64":"539","65+":"185","medianAge":"539"}},"title":"Elementary and middle school teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2019":{"total":"3,604","women":"80.5","white":"84.7","black":"10.2","asian":"2.6","hispanicOrLatino":"10.2"}},"wageData":{"2019":{"workers":"3,162","median":"1,067","maleWorkers":"640","maleMedian":"1,161","femaleWorkers":"2,522","femaleMedian":"1,042"}}},"Secondary school teachers":{"ageData":{"2019":{"total":"1,015","16to19":"4","20to24":"49","25to34":"261","35to44":"280","45to54":"225","55to64":"147","65+":"50","medianAge":"147"}},"title":"Secondary school teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2019":{"total":"1,015","women":"56.5","white":"87.1","black":"7.3","asian":"3.3","hispanicOrLatino":"8.8"}},"wageData":{"2019":{"workers":"882","median":"1,161","maleWorkers":"408","maleMedian":"1,262","femaleWorkers":"474","femaleMedian":"1,095"}}},"Special education teachers":{"ageData":{"2019":{"total":"331","16to19":"1","20to24":"14","25to34":"74","35to44":"84","45to54":"86","55to64":"58","65+":"15","medianAge":"58"}},"title":"Special education teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2019":{"total":"331","women":"86.7","white":"85.2","black":"9.2","asian":"3.5","hispanicOrLatino":"6.5"}},"wageData":{"2019":{"workers":"295","median":"1,108","maleWorkers":"42","maleMedian":"-","femaleWorkers":"253","femaleMedian":"1,104"}}},"Other teachers and instructors":{"ageData":{"2019":{"total":"1,017","16to19":"63","20to24":"123","25to34":"205","35to44":"187","45to54":"169","55to64":"158","65+":"112","medianAge":"158"}},"title":"Other teachers and instructors","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2019":{"total":"1,017","women":"64.6","white":"78.4","black":"11.7","asian":"6.1","hispanicOrLatino":"11.6"}},"wageData":{"2019":{"workers":"455","median":"1,054","maleWorkers":"192","maleMedian":"1,190","femaleWorkers":"263","femaleMedian":"942"}}},"Archivists, curators, and museum technicians":{"ageData":{"2019":{"total":"48","16to19":"1","20to24":"5","25to34":"10","35to44":"11","45to54":"10","55to64":"5","65+":"8","medianAge":"5"}},"title":"Archivists, curators, and museum technicians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2019":{"total":"48","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"34","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"19","femaleMedian":"-"}}},"Librarians":{"ageData":{"2019":{"total":"179","16to19":"0","20to24":"9","25to34":"33","35to44":"37","45to54":"34","55to64":"38","65+":"26","medianAge":"38"}},"title":"Librarians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2019":{"total":"179","women":"79.9","white":"87.8","black":"6.0","asian":"3.2","hispanicOrLatino":"9.8"}},"wageData":{"2019":{"workers":"138","median":"1,095","maleWorkers":"27","maleMedian":"-","femaleWorkers":"111","femaleMedian":"1,093"}}},"Library technicians":{"ageData":{"2019":{"total":"33","16to19":"7","20to24":"6","25to34":"2","35to44":"5","45to54":"5","55to64":"6","65+":"1","medianAge":"6"}},"title":"Library technicians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2019":{"total":"33","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"9","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Teacher assistants":{"ageData":{"2019":{"total":"999","16to19":"25","20to24":"115","25to34":"186","35to44":"202","45to54":"217","55to64":"197","65+":"57","medianAge":"197"}},"title":"Teacher assistants","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2019":{"total":"999","women":"89.7","white":"79.0","black":"13.4","asian":"4.1","hispanicOrLatino":"18.0"}},"wageData":{"2019":{"workers":"637","median":"590","maleWorkers":"72","maleMedian":"707","femaleWorkers":"565","femaleMedian":"579"}}},"Other education, training, and library workers":{"ageData":{"2019":{"total":"189","16to19":"2","20to24":"15","25to34":"41","35to44":"40","45to54":"42","55to64":"34","65+":"16","medianAge":"34"}},"title":"Other education, training, and library workers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2019":{"total":"189","women":"72.6","white":"82.4","black":"12.6","asian":"3.5","hispanicOrLatino":"12.2"}},"wageData":{"2019":{"workers":"143","median":"1,143","maleWorkers":"41","maleMedian":"-","femaleWorkers":"102","femaleMedian":"1,058"}}},"Arts, design, entertainment, sports, and media occupations":{"ageData":{"2019":{"total":"3,285","16to19":"100","20to24":"290","25to34":"910","35to44":"690","45to54":"586","55to64":"437","65+":"272","medianAge":"437"}},"title":"Arts, design, entertainment, sports, and media occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2019":{"total":"3,285","women":"49.0","white":"82.8","black":"7.7","asian":"5.9","hispanicOrLatino":"11.6"}},"wageData":{"2019":{"workers":"1,762","median":"1,151","maleWorkers":"956","maleMedian":"1,231","femaleWorkers":"806","femaleMedian":"1,077"}}},"Artists and related workers":{"ageData":{"2019":{"total":"248","16to19":"4","20to24":"11","25to34":"64","35to44":"51","45to54":"39","55to64":"45","65+":"34","medianAge":"45"}},"title":"Artists and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2019":{"total":"248","women":"54.0","white":"86.8","black":"4.5","asian":"3.8","hispanicOrLatino":"11.1"}},"wageData":{"2019":{"workers":"83","median":"1,155","maleWorkers":"48","maleMedian":"-","femaleWorkers":"35","femaleMedian":"-"}}},"Designers":{"ageData":{"2019":{"total":"983","16to19":"10","20to24":"80","25to34":"299","35to44":"226","45to54":"169","55to64":"133","65+":"66","medianAge":"133"}},"title":"Designers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2019":{"total":"983","women":"54.0","white":"82.2","black":"5.7","asian":"9.0","hispanicOrLatino":"11.0"}},"wageData":{"2019":{"workers":"661","median":"1,126","maleWorkers":"337","maleMedian":"1,214","femaleWorkers":"324","femaleMedian":"1,052"}}},"Actors":{"ageData":{"2019":{"total":"40","16to19":"2","20to24":"3","25to34":"11","35to44":"9","45to54":"7","55to64":"6","65+":"2","medianAge":"6"}},"title":"Actors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2019":{"total":"40","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"13","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Producers and directors":{"ageData":{"2019":{"total":"186","16to19":"0","20to24":"5","25to34":"64","35to44":"44","45to54":"47","55to64":"21","65+":"5","medianAge":"21"}},"title":"Producers and directors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2019":{"total":"186","women":"42.5","white":"86.7","black":"6.4","asian":"3.5","hispanicOrLatino":"8.0"}},"wageData":{"2019":{"workers":"109","median":"1,483","maleWorkers":"59","maleMedian":"1,652","femaleWorkers":"50","femaleMedian":"1,156"}}},"Athletes, coaches, umpires, and related workers":{"ageData":{"2019":{"total":"345","16to19":"65","20to24":"53","25to34":"84","35to44":"50","45to54":"43","55to64":"23","65+":"26","medianAge":"23"}},"title":"Athletes, coaches, umpires, and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2019":{"total":"345","women":"35.3","white":"81.1","black":"9.3","asian":"4.3","hispanicOrLatino":"10.8"}},"wageData":{"2019":{"workers":"157","median":"1,051","maleWorkers":"122","maleMedian":"1,134","femaleWorkers":"35","femaleMedian":"-"}}},"Dancers and choreographers":{"ageData":{"2019":{"total":"23","16to19":"1","20to24":"6","25to34":"9","35to44":"2","45to54":"1","55to64":"1","65+":"2","medianAge":"1"}},"title":"Dancers and choreographers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2019":{"total":"23","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"13","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Musicians, singers, and related workers":{"ageData":{"2019":{"total":"202","16to19":"4","20to24":"17","25to34":"42","35to44":"35","45to54":"36","55to64":"29","65+":"41","medianAge":"29"}},"title":"Musicians, singers, and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2019":{"total":"202","women":"36.7","white":"78.9","black":"12.4","asian":"3.9","hispanicOrLatino":"9.7"}},"wageData":{"2019":{"workers":"36","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Entertainers and performers, sports and related workers, all other":{"ageData":{"2019":{"total":"50","16to19":"1","20to24":"3","25to34":"21","35to44":"8","45to54":"6","55to64":"6","65+":"5","medianAge":"6"}},"title":"Entertainers and performers, sports and related workers, all other","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2019":{"total":"50","women":"32.8","white":"86.4","black":"5.0","asian":"0.3","hispanicOrLatino":"7.3"}},"wageData":{"2019":{"workers":"15","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Announcers":{"ageData":{"2019":{"total":"58","16to19":"1","20to24":"3","25to34":"16","35to44":"14","45to54":"14","55to64":"8","65+":"3","medianAge":"8"}},"title":"Announcers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2019":{"total":"58","women":"30.4","white":"75.6","black":"15.7","asian":"5.3","hispanicOrLatino":"19.2"}},"wageData":{"2019":{"workers":"20","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"News analysts, reporters and correspondents":{"ageData":{"2019":{"total":"93","16to19":"0","20to24":"10","25to34":"32","35to44":"15","45to54":"18","55to64":"14","65+":"4","medianAge":"14"}},"title":"News analysts, reporters and correspondents","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2019":{"total":"93","women":"45.1","white":"82.4","black":"6.9","asian":"9.7","hispanicOrLatino":"9.3"}},"wageData":{"2019":{"workers":"77","median":"1,301","maleWorkers":"40","maleMedian":"-","femaleWorkers":"37","femaleMedian":"-"}}},"Public relations specialists":{"ageData":{"2019":{"total":"137","16to19":"1","20to24":"19","25to34":"33","35to44":"33","45to54":"30","55to64":"14","65+":"6","medianAge":"14"}},"title":"Public relations specialists","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2019":{"total":"137","women":"63.6","white":"83.6","black":"9.9","asian":"5.8","hispanicOrLatino":"13.6"}},"wageData":{"2019":{"workers":"119","median":"1,410","maleWorkers":"41","maleMedian":"-","femaleWorkers":"78","femaleMedian":"1,255"}}},"Editors":{"ageData":{"2019":{"total":"147","16to19":"1","20to24":"13","25to34":"29","35to44":"31","45to54":"33","55to64":"29","65+":"10","medianAge":"29"}},"title":"Editors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2019":{"total":"147","women":"63.3","white":"91.3","black":"3.0","asian":"2.4","hispanicOrLatino":"10.6"}},"wageData":{"2019":{"workers":"98","median":"1,163","maleWorkers":"32","maleMedian":"-","femaleWorkers":"66","femaleMedian":"1,135"}}},"Technical writers":{"ageData":{"2019":{"total":"61","16to19":"0","20to24":"2","25to34":"16","35to44":"10","45to54":"14","55to64":"13","65+":"7","medianAge":"13"}},"title":"Technical writers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2019":{"total":"61","women":"57.8","white":"84.2","black":"11.8","asian":"2.9","hispanicOrLatino":"8.8"}},"wageData":{"2019":{"workers":"54","median":"1,434","maleWorkers":"26","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Writers and authors":{"ageData":{"2019":{"total":"225","16to19":"0","20to24":"15","25to34":"58","35to44":"49","45to54":"40","55to64":"33","65+":"29","medianAge":"33"}},"title":"Writers and authors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2019":{"total":"225","women":"63.5","white":"89.6","black":"5.9","asian":"3.4","hispanicOrLatino":"4.8"}},"wageData":{"2019":{"workers":"88","median":"1,159","maleWorkers":"41","maleMedian":"-","femaleWorkers":"48","femaleMedian":"-"}}},"Miscellaneous media and communication workers":{"ageData":{"2019":{"total":"118","16to19":"1","20to24":"4","25to34":"28","35to44":"28","45to54":"28","55to64":"20","65+":"8","medianAge":"20"}},"title":"Miscellaneous media and communication workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2019":{"total":"118","women":"66.4","white":"67.8","black":"14.6","asian":"11.2","hispanicOrLatino":"35.3"}},"wageData":{"2019":{"workers":"56","median":"794","maleWorkers":"22","maleMedian":"-","femaleWorkers":"34","femaleMedian":"-"}}},"Broadcast and sound engineering technicians and radio operators":{"ageData":{"2019":{"total":"119","16to19":"5","20to24":"16","25to34":"32","35to44":"32","45to54":"21","55to64":"10","65+":"4","medianAge":"10"}},"title":"Broadcast and sound engineering technicians and radio operators","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2019":{"total":"119","women":"12.0","white":"78.3","black":"9.1","asian":"7.9","hispanicOrLatino":"14.0"}},"wageData":{"2019":{"workers":"90","median":"1,158","maleWorkers":"79","maleMedian":"1,189","femaleWorkers":"11","femaleMedian":"-"}}},"Photographers":{"ageData":{"2019":{"total":"188","16to19":"2","20to24":"20","25to34":"52","35to44":"39","45to54":"32","55to64":"29","65+":"14","medianAge":"29"}},"title":"Photographers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2019":{"total":"188","women":"49.3","white":"84.3","black":"8.6","asian":"3.5","hispanicOrLatino":"12.3"}},"wageData":{"2019":{"workers":"45","median":"-","maleWorkers":"29","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Television, video, and motion picture camera operators and editors":{"ageData":{"2019":{"total":"60","16to19":"2","20to24":"9","25to34":"19","35to44":"14","45to54":"7","55to64":"4","65+":"5","medianAge":"4"}},"title":"Television, video, and motion picture camera operators and editors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2019":{"total":"60","women":"16.3","white":"83.0","black":"10.7","asian":"0.6","hispanicOrLatino":"12.7"}},"wageData":{"2019":{"workers":"27","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Media and communication equipment workers, all other":{"ageData":{"2019":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Media and communication equipment workers, all other","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2019":{"total":"0","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Healthcare practitioners and technical occupations":{"ageData":{"2019":{"total":"9,684","16to19":"48","20to24":"532","25to34":"2,586","35to44":"2,373","45to54":"1,990","55to64":"1,576","65+":"579","medianAge":"1,576"}},"title":"Healthcare practitioners and technical occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2019":{"total":"9,684","women":"75.4","white":"75.3","black":"12.5","asian":"9.6","hispanicOrLatino":"9.0"}},"wageData":{"2019":{"workers":"7,514","median":"1,180","maleWorkers":"1,887","maleMedian":"1,422","femaleWorkers":"5,627","femaleMedian":"1,130"}}},"Chiropractors":{"ageData":{"2019":{"total":"61","16to19":"0","20to24":"1","25to34":"11","35to44":"17","45to54":"15","55to64":"14","65+":"4","medianAge":"14"}},"title":"Chiropractors","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"61","women":"28.0","white":"86.1","black":"2.8","asian":"5.3","hispanicOrLatino":"6.4"}},"wageData":{"2019":{"workers":"19","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Dentists":{"ageData":{"2019":{"total":"162","16to19":"0","20to24":"0","25to34":"32","35to44":"35","45to54":"41","55to64":"30","65+":"23","medianAge":"30"}},"title":"Dentists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"162","women":"33.9","white":"74.3","black":"0.8","asian":"23.6","hispanicOrLatino":"7.2"}},"wageData":{"2019":{"workers":"71","median":"2,302","maleWorkers":"43","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Dietitians and nutritionists":{"ageData":{"2019":{"total":"128","16to19":"3","20to24":"4","25to34":"33","35to44":"20","45to54":"34","55to64":"23","65+":"11","medianAge":"23"}},"title":"Dietitians and nutritionists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"128","women":"92.1","white":"77.9","black":"15.2","asian":"5.9","hispanicOrLatino":"9.0"}},"wageData":{"2019":{"workers":"94","median":"1,019","maleWorkers":"10","maleMedian":"-","femaleWorkers":"85","femaleMedian":"948"}}},"Optometrists":{"ageData":{"2019":{"total":"43","16to19":"0","20to24":"1","25to34":"16","35to44":"10","45to54":"8","55to64":"4","65+":"5","medianAge":"4"}},"title":"Optometrists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"43","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"27","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"15","femaleMedian":"-"}}},"Pharmacists":{"ageData":{"2019":{"total":"341","16to19":"0","20to24":"11","25to34":"109","35to44":"90","45to54":"69","55to64":"43","65+":"19","medianAge":"43"}},"title":"Pharmacists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"341","women":"60.4","white":"64.5","black":"10.5","asian":"22.0","hispanicOrLatino":"2.7"}},"wageData":{"2019":{"workers":"255","median":"2,013","maleWorkers":"100","maleMedian":"2,245","femaleWorkers":"155","femaleMedian":"1,877"}}},"Physicians and surgeons":{"ageData":{"2019":{"total":"1,098","16to19":"0","20to24":"5","25to34":"250","35to44":"272","45to54":"250","55to64":"194","65+":"127","medianAge":"194"}},"title":"Physicians and surgeons","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"1,098","women":"40.8","white":"72.0","black":"8.2","asian":"18.0","hispanicOrLatino":"7.6"}},"wageData":{"2019":{"workers":"857","median":"2,292","maleWorkers":"507","maleMedian":"2,500","femaleWorkers":"349","femaleMedian":"1,878"}}},"Physician assistants":{"ageData":{"2019":{"total":"131","16to19":"0","20to24":"2","25to34":"56","35to44":"35","45to54":"27","55to64":"9","65+":"2","medianAge":"9"}},"title":"Physician assistants","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"131","women":"70.8","white":"84.3","black":"4.5","asian":"6.8","hispanicOrLatino":"8.6"}},"wageData":{"2019":{"workers":"109","median":"1,831","maleWorkers":"31","maleMedian":"-","femaleWorkers":"77","femaleMedian":"1,763"}}},"Podiatrists":{"ageData":{"2019":{"total":"10","16to19":"0","20to24":"0","25to34":"4","35to44":"0","45to54":"3","55to64":"3","65+":"0","medianAge":"3"}},"title":"Podiatrists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"10","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"4","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Audiologists":{"ageData":{"2019":{"total":"14","16to19":"0","20to24":"0","25to34":"2","35to44":"5","45to54":"2","55to64":"4","65+":"0","medianAge":"4"}},"title":"Audiologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"14","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"11","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Occupational therapists":{"ageData":{"2019":{"total":"136","16to19":"0","20to24":"2","25to34":"42","35to44":"42","45to54":"33","55to64":"13","65+":"3","medianAge":"13"}},"title":"Occupational therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"136","women":"88.0","white":"75.7","black":"10.2","asian":"12.4","hispanicOrLatino":"10.2"}},"wageData":{"2019":{"workers":"92","median":"1,447","maleWorkers":"13","maleMedian":"-","femaleWorkers":"79","femaleMedian":"1,441"}}},"Physical therapists":{"ageData":{"2019":{"total":"304","16to19":"0","20to24":"5","25to34":"84","35to44":"95","45to54":"74","55to64":"37","65+":"10","medianAge":"37"}},"title":"Physical therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"304","women":"67.9","white":"76.4","black":"5.9","asian":"14.1","hispanicOrLatino":"4.0"}},"wageData":{"2019":{"workers":"211","median":"1,431","maleWorkers":"81","maleMedian":"1,610","femaleWorkers":"130","femaleMedian":"1,323"}}},"Radiation therapists":{"ageData":{"2019":{"total":"16","16to19":"0","20to24":"2","25to34":"8","35to44":"2","45to54":"3","55to64":"0","65+":"1","medianAge":"0"}},"title":"Radiation therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"16","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"9","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Recreational therapists":{"ageData":{"2019":{"total":"10","16to19":"0","20to24":"2","25to34":"2","35to44":"1","45to54":"2","55to64":"2","65+":"1","medianAge":"2"}},"title":"Recreational therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"10","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"9","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Respiratory therapists":{"ageData":{"2019":{"total":"112","16to19":"0","20to24":"2","25to34":"27","35to44":"32","45to54":"28","55to64":"21","65+":"3","medianAge":"21"}},"title":"Respiratory therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"112","women":"66.8","white":"66.2","black":"23.2","asian":"8.9","hispanicOrLatino":"8.6"}},"wageData":{"2019":{"workers":"93","median":"1,213","maleWorkers":"34","maleMedian":"-","femaleWorkers":"59","femaleMedian":"1,073"}}},"Speech-language pathologists":{"ageData":{"2019":{"total":"180","16to19":"0","20to24":"9","25to34":"58","35to44":"49","45to54":"33","55to64":"22","65+":"8","medianAge":"22"}},"title":"Speech-language pathologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"180","women":"95.8","white":"93.7","black":"3.9","asian":"2.2","hispanicOrLatino":"6.7"}},"wageData":{"2019":{"workers":"131","median":"1,193","maleWorkers":"7","maleMedian":"-","femaleWorkers":"124","femaleMedian":"1,171"}}},"Exercise physiologists":{"ageData":{"2019":{"total":"2","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Exercise physiologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"2","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"2","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Therapists, all other":{"ageData":{"2019":{"total":"235","16to19":"2","20to24":"14","25to34":"77","35to44":"44","45to54":"40","55to64":"36","65+":"22","medianAge":"36"}},"title":"Therapists, all other","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"235","women":"81.4","white":"81.1","black":"12.2","asian":"5.1","hispanicOrLatino":"11.9"}},"wageData":{"2019":{"workers":"162","median":"935","maleWorkers":"31","maleMedian":"-","femaleWorkers":"131","femaleMedian":"919"}}},"Veterinarians":{"ageData":{"2019":{"total":"104","16to19":"0","20to24":"1","25to34":"21","35to44":"33","45to54":"21","55to64":"21","65+":"7","medianAge":"21"}},"title":"Veterinarians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"104","women":"68.3","white":"89.8","black":"0.0","asian":"6.1","hispanicOrLatino":"1.6"}},"wageData":{"2019":{"workers":"72","median":"1,773","maleWorkers":"17","maleMedian":"-","femaleWorkers":"55","femaleMedian":"1,985"}}},"Registered nurses":{"ageData":{"2019":{"total":"3,242","16to19":"2","20to24":"138","25to34":"860","35to44":"803","45to54":"684","55to64":"586","65+":"168","medianAge":"586"}},"title":"Registered nurses","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"3,242","women":"88.9","white":"75.9","black":"12.4","asian":"9.2","hispanicOrLatino":"7.2"}},"wageData":{"2019":{"workers":"2,640","median":"1,223","maleWorkers":"320","maleMedian":"1,256","femaleWorkers":"2,321","femaleMedian":"1,217"}}},"Nurse anesthetists":{"ageData":{"2019":{"total":"33","16to19":"0","20to24":"0","25to34":"8","35to44":"10","45to54":"8","55to64":"4","65+":"3","medianAge":"4"}},"title":"Nurse anesthetists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"33","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"22","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Nurse midwives":{"ageData":{"2019":{"total":"10","16to19":"0","20to24":"0","25to34":"1","35to44":"4","45to54":"2","55to64":"1","65+":"2","medianAge":"1"}},"title":"Nurse midwives","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"10","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"6","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Nurse practitioners":{"ageData":{"2019":{"total":"225","16to19":"0","20to24":"0","25to34":"51","35to44":"71","45to54":"50","55to64":"38","65+":"16","medianAge":"38"}},"title":"Nurse practitioners","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"225","women":"87.8","white":"76.6","black":"12.2","asian":"9.9","hispanicOrLatino":"2.6"}},"wageData":{"2019":{"workers":"187","median":"1,760","maleWorkers":"23","maleMedian":"-","femaleWorkers":"163","femaleMedian":"1,753"}}},"Health diagnosing and treating practitioners, all other":{"ageData":{"2019":{"total":"35","16to19":"0","20to24":"0","25to34":"8","35to44":"8","45to54":"7","55to64":"5","65+":"7","medianAge":"5"}},"title":"Health diagnosing and treating practitioners, all other","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"35","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"12","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Clinical laboratory technologists and technicians":{"ageData":{"2019":{"total":"323","16to19":"4","20to24":"29","25to34":"75","35to44":"77","45to54":"64","55to64":"58","65+":"16","medianAge":"58"}},"title":"Clinical laboratory technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"323","women":"73.8","white":"71.1","black":"15.3","asian":"10.0","hispanicOrLatino":"13.0"}},"wageData":{"2019":{"workers":"281","median":"979","maleWorkers":"66","maleMedian":"1,117","femaleWorkers":"215","femaleMedian":"952"}}},"Dental hygienists":{"ageData":{"2019":{"total":"208","16to19":"0","20to24":"10","25to34":"67","35to44":"39","45to54":"44","55to64":"41","65+":"7","medianAge":"41"}},"title":"Dental hygienists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"208","women":"96.0","white":"88.2","black":"5.1","asian":"5.0","hispanicOrLatino":"11.3"}},"wageData":{"2019":{"workers":"104","median":"1,094","maleWorkers":"5","maleMedian":"-","femaleWorkers":"99","femaleMedian":"1,066"}}},"Diagnostic related technologists and technicians":{"ageData":{"2019":{"total":"398","16to19":"1","20to24":"15","25to34":"103","35to44":"109","45to54":"83","55to64":"70","65+":"17","medianAge":"70"}},"title":"Diagnostic related technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"398","women":"70.0","white":"76.7","black":"12.8","asian":"5.8","hispanicOrLatino":"9.7"}},"wageData":{"2019":{"workers":"320","median":"1,126","maleWorkers":"107","maleMedian":"1,166","femaleWorkers":"213","femaleMedian":"1,076"}}},"Emergency medical technicians and paramedics":{"ageData":{"2019":{"total":"206","16to19":"1","20to24":"33","25to34":"81","35to44":"44","45to54":"27","55to64":"14","65+":"5","medianAge":"14"}},"title":"Emergency medical technicians and paramedics","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"206","women":"33.5","white":"86.6","black":"10.5","asian":"0.8","hispanicOrLatino":"11.5"}},"wageData":{"2019":{"workers":"179","median":"912","maleWorkers":"125","maleMedian":"991","femaleWorkers":"54","femaleMedian":"786"}}},"Health practitioner support technologists and technicians":{"ageData":{"2019":{"total":"710","16to19":"19","20to24":"131","25to34":"234","35to44":"138","45to54":"92","55to64":"78","65+":"18","medianAge":"78"}},"title":"Health practitioner support technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"710","women":"79.0","white":"74.7","black":"15.6","asian":"5.4","hispanicOrLatino":"16.5"}},"wageData":{"2019":{"workers":"570","median":"735","maleWorkers":"126","maleMedian":"843","femaleWorkers":"444","femaleMedian":"712"}}},"Licensed practical and licensed vocational nurses":{"ageData":{"2019":{"total":"687","16to19":"10","20to24":"62","25to34":"150","35to44":"161","45to54":"144","55to64":"117","65+":"43","medianAge":"117"}},"title":"Licensed practical and licensed vocational nurses","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"687","women":"90.8","white":"67.0","black":"27.0","asian":"3.3","hispanicOrLatino":"13.8"}},"wageData":{"2019":{"workers":"533","median":"806","maleWorkers":"53","maleMedian":"896","femaleWorkers":"481","femaleMedian":"799"}}},"Medical records and health information technicians":{"ageData":{"2019":{"total":"185","16to19":"2","20to24":"9","25to34":"32","35to44":"49","45to54":"42","55to64":"40","65+":"11","medianAge":"40"}},"title":"Medical records and health information technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"185","women":"93.3","white":"72.8","black":"17.5","asian":"6.0","hispanicOrLatino":"14.4"}},"wageData":{"2019":{"workers":"152","median":"829","maleWorkers":"15","maleMedian":"-","femaleWorkers":"138","femaleMedian":"799"}}},"Opticians, dispensing":{"ageData":{"2019":{"total":"49","16to19":"0","20to24":"0","25to34":"7","35to44":"8","45to54":"11","55to64":"15","65+":"7","medianAge":"15"}},"title":"Opticians, dispensing","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"49","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"34","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"26","femaleMedian":"-"}}},"Miscellaneous health technologists and technicians":{"ageData":{"2019":{"total":"152","16to19":"3","20to24":"30","25to34":"38","35to44":"33","45to54":"22","55to64":"19","65+":"7","medianAge":"19"}},"title":"Miscellaneous health technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"152","women":"65.0","white":"64.6","black":"19.6","asian":"13.7","hispanicOrLatino":"16.3"}},"wageData":{"2019":{"workers":"130","median":"880","maleWorkers":"46","maleMedian":"-","femaleWorkers":"84","femaleMedian":"799"}}},"Other healthcare practitioners and technical occupations":{"ageData":{"2019":{"total":"133","16to19":"0","20to24":"12","25to34":"36","35to44":"36","45to54":"26","55to64":"18","65+":"6","medianAge":"18"}},"title":"Other healthcare practitioners and technical occupations","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2019":{"total":"133","women":"49.5","white":"80.9","black":"12.5","asian":"4.3","hispanicOrLatino":"12.1"}},"wageData":{"2019":{"workers":"117","median":"1,252","maleWorkers":"69","maleMedian":"1,261","femaleWorkers":"48","femaleMedian":"-"}}},"Service occupations":{"ageData":{"2019":{"total":"26,978","16to19":"2,126","20to24":"3,815","25to34":"6,091","35to44":"4,847","45to54":"4,705","55to64":"3,855","65+":"1,539","medianAge":"3,855"}},"title":"Service occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2019":{"total":"26,978","women":"57.6","white":"72.2","black":"17.1","asian":"5.9","hispanicOrLatino":"25.0"}},"wageData":{"2019":{"workers":"16,558","median":"592","maleWorkers":"7,898","maleMedian":"659","femaleWorkers":"8,660","femaleMedian":"537"}}},"Healthcare support occupations":{"ageData":{"2019":{"total":"3,758","16to19":"104","20to24":"521","25to34":"1,019","35to44":"705","45to54":"648","55to64":"571","65+":"189","medianAge":"571"}},"title":"Healthcare support occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2019":{"total":"3,758","women":"86.9","white":"64.2","black":"26.7","asian":"5.1","hispanicOrLatino":"19.1"}},"wageData":{"2019":{"workers":"2,700","median":"591","maleWorkers":"363","maleMedian":"639","femaleWorkers":"2,337","femaleMedian":"585"}}},"Nursing, psychiatric, and home health aides":{"ageData":{"2019":{"total":"2,086","16to19":"61","20to24":"261","25to34":"498","35to44":"390","45to54":"381","55to64":"363","65+":"132","medianAge":"363"}},"title":"Nursing, psychiatric, and home health aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2019":{"total":"2,086","women":"88.3","white":"54.3","black":"37.2","asian":"4.4","hispanicOrLatino":"17.6"}},"wageData":{"2019":{"workers":"1,471","median":"562","maleWorkers":"184","maleMedian":"588","femaleWorkers":"1,287","femaleMedian":"556"}}},"Occupational therapy assistants and aides":{"ageData":{"2019":{"total":"29","16to19":"0","20to24":"1","25to34":"9","35to44":"5","45to54":"7","55to64":"8","65+":"1","medianAge":"8"}},"title":"Occupational therapy assistants and aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2019":{"total":"29","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"23","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"19","femaleMedian":"-"}}},"Physical therapist assistants and aides":{"ageData":{"2019":{"total":"101","16to19":"0","20to24":"20","25to34":"22","35to44":"13","45to54":"25","55to64":"18","65+":"2","medianAge":"18"}},"title":"Physical therapist assistants and aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2019":{"total":"101","women":"63.4","white":"83.2","black":"6.8","asian":"6.5","hispanicOrLatino":"7.2"}},"wageData":{"2019":{"workers":"72","median":"955","maleWorkers":"29","maleMedian":"-","femaleWorkers":"43","femaleMedian":"-"}}},"Massage therapists":{"ageData":{"2019":{"total":"183","16to19":"2","20to24":"7","25to34":"49","35to44":"43","45to54":"41","55to64":"26","65+":"16","medianAge":"26"}},"title":"Massage therapists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2019":{"total":"183","women":"83.6","white":"72.3","black":"8.8","asian":"13.1","hispanicOrLatino":"11.1"}},"wageData":{"2019":{"workers":"57","median":"582","maleWorkers":"15","maleMedian":"-","femaleWorkers":"42","femaleMedian":"-"}}},"Dental assistants":{"ageData":{"2019":{"total":"284","16to19":"6","20to24":"54","25to34":"82","35to44":"65","45to54":"42","55to64":"30","65+":"5","medianAge":"30"}},"title":"Dental assistants","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2019":{"total":"284","women":"94.9","white":"85.5","black":"6.7","asian":"3.1","hispanicOrLatino":"28.9"}},"wageData":{"2019":{"workers":"199","median":"615","maleWorkers":"6","maleMedian":"-","femaleWorkers":"193","femaleMedian":"613"}}},"Medical assistants":{"ageData":{"2019":{"total":"596","16to19":"13","20to24":"84","25to34":"230","35to44":"113","45to54":"82","55to64":"61","65+":"13","medianAge":"61"}},"title":"Medical assistants","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2019":{"total":"596","women":"92.7","white":"75.1","black":"15.3","asian":"4.8","hispanicOrLatino":"29.0"}},"wageData":{"2019":{"workers":"521","median":"635","maleWorkers":"40","maleMedian":"-","femaleWorkers":"481","femaleMedian":"635"}}},"Medical transcriptionists":{"ageData":{"2019":{"total":"41","16to19":"0","20to24":"15","25to34":"5","35to44":"3","45to54":"6","55to64":"11","65+":"1","medianAge":"11"}},"title":"Medical transcriptionists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2019":{"total":"41","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"28","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"23","femaleMedian":"-"}}},"Pharmacy aides":{"ageData":{"2019":{"total":"49","16to19":"1","20to24":"9","25to34":"19","35to44":"6","45to54":"9","55to64":"3","65+":"2","medianAge":"3"}},"title":"Pharmacy aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2019":{"total":"49","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"41","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"27","femaleMedian":"-"}}},"Veterinary assistants and laboratory animal caretakers":{"ageData":{"2019":{"total":"59","16to19":"4","20to24":"23","25to34":"18","35to44":"7","45to54":"3","55to64":"3","65+":"1","medianAge":"3"}},"title":"Veterinary assistants and laboratory animal caretakers","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2019":{"total":"59","women":"82.7","white":"97.2","black":"2.1","asian":"0.4","hispanicOrLatino":"3.7"}},"wageData":{"2019":{"workers":"39","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"31","femaleMedian":"-"}}},"Phlebotomists":{"ageData":{"2019":{"total":"124","16to19":"2","20to24":"18","25to34":"36","35to44":"26","45to54":"25","55to64":"17","65+":"1","medianAge":"17"}},"title":"Phlebotomists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2019":{"total":"124","women":"89.3","white":"70.5","black":"24.6","asian":"2.9","hispanicOrLatino":"14.9"}},"wageData":{"2019":{"workers":"98","median":"623","maleWorkers":"9","maleMedian":"-","femaleWorkers":"88","femaleMedian":"612"}}},"Miscellaneous healthcare support occupations, including medical equipment preparers":{"ageData":{"2019":{"total":"206","16to19":"16","20to24":"29","25to34":"53","35to44":"35","45to54":"28","55to64":"32","65+":"14","medianAge":"32"}},"title":"Miscellaneous healthcare support occupations, including medical equipment preparers","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2019":{"total":"206","women":"68.1","white":"64.7","black":"25.7","asian":"7.1","hispanicOrLatino":"13.7"}},"wageData":{"2019":{"workers":"151","median":"617","maleWorkers":"47","maleMedian":"-","femaleWorkers":"103","femaleMedian":"571"}}},"Protective service occupations":{"ageData":{"2019":{"total":"3,128","16to19":"96","20to24":"256","25to34":"835","35to44":"707","45to54":"657","55to64":"410","65+":"166","medianAge":"410"}},"title":"Protective service occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2019":{"total":"3,128","women":"22.1","white":"73.9","black":"20.3","asian":"2.2","hispanicOrLatino":"15.3"}},"wageData":{"2019":{"workers":"2,725","median":"900","maleWorkers":"2,172","maleMedian":"953","femaleWorkers":"553","femaleMedian":"731"}}},"First-line supervisors of correctional officers":{"ageData":{"2019":{"total":"44","16to19":"0","20to24":"2","25to34":"9","35to44":"12","45to54":"12","55to64":"7","65+":"2","medianAge":"7"}},"title":"First-line supervisors of correctional officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2019":{"total":"44","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"41","median":"-","maleWorkers":"29","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"First-line supervisors of police and detectives":{"ageData":{"2019":{"total":"83","16to19":"0","20to24":"0","25to34":"12","35to44":"26","45to54":"33","55to64":"11","65+":"1","medianAge":"11"}},"title":"First-line supervisors of police and detectives","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2019":{"total":"83","women":"9.9","white":"89.2","black":"7.6","asian":"0.4","hispanicOrLatino":"5.6"}},"wageData":{"2019":{"workers":"80","median":"1,438","maleWorkers":"71","maleMedian":"1,449","femaleWorkers":"9","femaleMedian":"-"}}},"First-line supervisors of fire fighting and prevention workers":{"ageData":{"2019":{"total":"42","16to19":"0","20to24":"0","25to34":"3","35to44":"19","45to54":"14","55to64":"5","65+":"1","medianAge":"5"}},"title":"First-line supervisors of fire fighting and prevention workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2019":{"total":"42","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"40","median":"-","maleWorkers":"36","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"First-line supervisors of protective service workers, all other":{"ageData":{"2019":{"total":"78","16to19":"0","20to24":"2","25to34":"8","35to44":"21","45to54":"24","55to64":"15","65+":"8","medianAge":"15"}},"title":"First-line supervisors of protective service workers, all other","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2019":{"total":"78","women":"25.0","white":"69.8","black":"20.7","asian":"2.2","hispanicOrLatino":"11.3"}},"wageData":{"2019":{"workers":"66","median":"659","maleWorkers":"50","maleMedian":"698","femaleWorkers":"17","femaleMedian":"-"}}},"Firefighters":{"ageData":{"2019":{"total":"318","16to19":"0","20to24":"13","25to34":"100","35to44":"96","45to54":"71","55to64":"30","65+":"6","medianAge":"30"}},"title":"Firefighters","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2019":{"total":"318","women":"3.3","white":"86.7","black":"8.5","asian":"1.3","hispanicOrLatino":"11.6"}},"wageData":{"2019":{"workers":"292","median":"1,207","maleWorkers":"287","maleMedian":"1,203","femaleWorkers":"6","femaleMedian":"-"}}},"Fire inspectors":{"ageData":{"2019":{"total":"21","16to19":"1","20to24":"0","25to34":"4","35to44":"4","45to54":"4","55to64":"5","65+":"3","medianAge":"5"}},"title":"Fire inspectors","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2019":{"total":"21","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"16","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Bailiffs, correctional officers, and jailers":{"ageData":{"2019":{"total":"372","16to19":"2","20to24":"33","25to34":"113","35to44":"81","45to54":"80","55to64":"47","65+":"16","medianAge":"47"}},"title":"Bailiffs, correctional officers, and jailers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2019":{"total":"372","women":"30.1","white":"60.5","black":"34.2","asian":"1.7","hispanicOrLatino":"12.3"}},"wageData":{"2019":{"workers":"365","median":"776","maleWorkers":"251","maleMedian":"890","femaleWorkers":"114","femaleMedian":"664"}}},"Detectives and criminal investigators":{"ageData":{"2019":{"total":"164","16to19":"0","20to24":"5","25to34":"27","35to44":"57","45to54":"49","55to64":"23","65+":"4","medianAge":"23"}},"title":"Detectives and criminal investigators","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2019":{"total":"164","women":"23.0","white":"82.7","black":"12.7","asian":"1.9","hispanicOrLatino":"8.4"}},"wageData":{"2019":{"workers":"151","median":"1,428","maleWorkers":"119","maleMedian":"1,472","femaleWorkers":"32","femaleMedian":"-"}}},"Fish and game wardens":{"ageData":{"2019":{"total":"4","16to19":"0","20to24":"1","25to34":"1","35to44":"2","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Fish and game wardens","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2019":{"total":"4","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Parking enforcement workers":{"ageData":{"2019":{"total":"4","16to19":"0","20to24":"0","25to34":"0","35to44":"2","45to54":"1","55to64":"0","65+":"1","medianAge":"0"}},"title":"Parking enforcement workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2019":{"total":"4","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Police and sheriff\'s patrol officers":{"ageData":{"2019":{"total":"716","16to19":"1","20to24":"44","25to34":"229","35to44":"190","45to54":"175","55to64":"56","65+":"21","medianAge":"56"}},"title":"Police and sheriff\'s patrol officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2019":{"total":"716","women":"17.6","white":"82.9","black":"12.6","asian":"1.5","hispanicOrLatino":"17.0"}},"wageData":{"2019":{"workers":"686","median":"1,111","maleWorkers":"559","maleMedian":"1,143","femaleWorkers":"127","femaleMedian":"922"}}},"Transit and railroad police":{"ageData":{"2019":{"total":"5","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Transit and railroad police","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2019":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Animal control workers":{"ageData":{"2019":{"total":"10","16to19":"0","20to24":"0","25to34":"4","35to44":"2","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Animal control workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2019":{"total":"10","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"7","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Private detectives and investigators":{"ageData":{"2019":{"total":"97","16to19":"0","20to24":"3","25to34":"28","35to44":"19","45to54":"25","55to64":"16","65+":"6","medianAge":"16"}},"title":"Private detectives and investigators","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2019":{"total":"97","women":"47.6","white":"72.6","black":"23.5","asian":"3.0","hispanicOrLatino":"17.7"}},"wageData":{"2019":{"workers":"78","median":"973","maleWorkers":"38","maleMedian":"-","femaleWorkers":"41","femaleMedian":"-"}}},"Security guards and gaming surveillance officers":{"ageData":{"2019":{"total":"937","16to19":"16","20to24":"114","25to34":"258","35to44":"156","45to54":"146","55to64":"167","65+":"80","medianAge":"167"}},"title":"Security guards and gaming surveillance officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2019":{"total":"937","women":"21.5","white":"62.9","black":"29.6","asian":"3.5","hispanicOrLatino":"18.8"}},"wageData":{"2019":{"workers":"790","median":"650","maleWorkers":"631","maleMedian":"671","femaleWorkers":"159","femaleMedian":"589"}}},"Crossing guards":{"ageData":{"2019":{"total":"52","16to19":"1","20to24":"3","25to34":"10","35to44":"4","45to54":"5","55to64":"16","65+":"13","medianAge":"16"}},"title":"Crossing guards","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2019":{"total":"52","women":"48.6","white":"76.3","black":"17.6","asian":"1.3","hispanicOrLatino":"21.0"}},"wageData":{"2019":{"workers":"21","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Transportation security screeners":{"ageData":{"2019":{"total":"43","16to19":"0","20to24":"5","25to34":"13","35to44":"11","45to54":"8","55to64":"4","65+":"2","medianAge":"4"}},"title":"Transportation security screeners","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2019":{"total":"43","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"41","median":"-","maleWorkers":"32","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Lifeguards and other recreational, and all other protective service workers":{"ageData":{"2019":{"total":"139","16to19":"75","20to24":"30","25to34":"12","35to44":"6","45to54":"8","55to64":"5","65+":"3","medianAge":"5"}},"title":"Lifeguards and other recreational, and all other protective service workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2019":{"total":"139","women":"49.4","white":"87.7","black":"6.4","asian":"0.7","hispanicOrLatino":"14.7"}},"wageData":{"2019":{"workers":"41","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Food preparation and serving related occupations":{"ageData":{"2019":{"total":"8,378","16to19":"1,379","20to24":"1,811","25to34":"1,902","35to44":"1,189","45to54":"1,027","55to64":"791","65+":"278","medianAge":"791"}},"title":"Food preparation and serving related occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2019":{"total":"8,378","women":"54.5","white":"73.7","black":"13.9","asian":"6.9","hispanicOrLatino":"27.0"}},"wageData":{"2019":{"workers":"4,689","median":"522","maleWorkers":"2,352","maleMedian":"576","femaleWorkers":"2,337","femaleMedian":"492"}}},"Chefs and head cooks":{"ageData":{"2019":{"total":"474","16to19":"10","20to24":"48","25to34":"132","35to44":"102","45to54":"110","55to64":"59","65+":"14","medianAge":"59"}},"title":"Chefs and head cooks","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2019":{"total":"474","women":"22.0","white":"63.0","black":"14.3","asian":"16.4","hispanicOrLatino":"26.0"}},"wageData":{"2019":{"workers":"406","median":"698","maleWorkers":"334","maleMedian":"727","femaleWorkers":"72","femaleMedian":"553"}}},"First-line supervisors of food preparation and serving workers":{"ageData":{"2019":{"total":"597","16to19":"31","20to24":"101","25to34":"162","35to44":"115","45to54":"93","55to64":"76","65+":"20","medianAge":"76"}},"title":"First-line supervisors of food preparation and serving workers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2019":{"total":"597","women":"57.4","white":"76.7","black":"14.9","asian":"4.8","hispanicOrLatino":"22.6"}},"wageData":{"2019":{"workers":"426","median":"584","maleWorkers":"184","maleMedian":"657","femaleWorkers":"242","femaleMedian":"545"}}},"Cooks":{"ageData":{"2019":{"total":"2,031","16to19":"228","20to24":"322","25to34":"481","35to44":"360","45to54":"313","55to64":"247","65+":"81","medianAge":"247"}},"title":"Cooks","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2019":{"total":"2,031","women":"41.7","white":"70.4","black":"18.1","asian":"6.2","hispanicOrLatino":"36.7"}},"wageData":{"2019":{"workers":"1,362","median":"512","maleWorkers":"831","maleMedian":"535","femaleWorkers":"531","femaleMedian":"489"}}},"Food preparation workers":{"ageData":{"2019":{"total":"1,079","16to19":"230","20to24":"242","25to34":"217","35to44":"132","45to54":"124","55to64":"89","65+":"44","medianAge":"89"}},"title":"Food preparation workers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2019":{"total":"1,079","women":"59.3","white":"73.5","black":"13.2","asian":"8.3","hispanicOrLatino":"28.1"}},"wageData":{"2019":{"workers":"574","median":"496","maleWorkers":"246","maleMedian":"532","femaleWorkers":"328","femaleMedian":"463"}}},"Bartenders":{"ageData":{"2019":{"total":"464","16to19":"12","20to24":"83","25to34":"170","35to44":"97","45to54":"61","55to64":"30","65+":"10","medianAge":"30"}},"title":"Bartenders","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2019":{"total":"464","women":"53.1","white":"86.1","black":"6.3","asian":"2.8","hispanicOrLatino":"16.5"}},"wageData":{"2019":{"workers":"293","median":"610","maleWorkers":"159","maleMedian":"655","femaleWorkers":"134","femaleMedian":"578"}}},"Combined food preparation and serving workers, including fast food":{"ageData":{"2019":{"total":"372","16to19":"96","20to24":"84","25to34":"69","35to44":"46","45to54":"33","55to64":"34","65+":"11","medianAge":"34"}},"title":"Combined food preparation and serving workers, including fast food","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2019":{"total":"372","women":"62.4","white":"70.2","black":"19.6","asian":"5.4","hispanicOrLatino":"19.9"}},"wageData":{"2019":{"workers":"191","median":"462","maleWorkers":"65","maleMedian":"457","femaleWorkers":"126","femaleMedian":"467"}}},"Counter attendants, cafeteria, food concession, and coffee shop":{"ageData":{"2019":{"total":"200","16to19":"105","20to24":"49","25to34":"20","35to44":"12","45to54":"2","55to64":"9","65+":"3","medianAge":"9"}},"title":"Counter attendants, cafeteria, food concession, and coffee shop","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2019":{"total":"200","women":"59.2","white":"76.0","black":"11.3","asian":"5.2","hispanicOrLatino":"18.6"}},"wageData":{"2019":{"workers":"48","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"22","femaleMedian":"-"}}},"Waiters and waitresses":{"ageData":{"2019":{"total":"2,038","16to19":"335","20to24":"627","25to34":"494","35to44":"226","45to54":"178","55to64":"136","65+":"42","medianAge":"136"}},"title":"Waiters and waitresses","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2019":{"total":"2,038","women":"71.3","white":"75.5","black":"11.1","asian":"7.6","hispanicOrLatino":"23.4"}},"wageData":{"2019":{"workers":"973","median":"511","maleWorkers":"292","maleMedian":"594","femaleWorkers":"681","femaleMedian":"491"}}},"Food servers, nonrestaurant":{"ageData":{"2019":{"total":"191","16to19":"39","20to24":"34","25to34":"38","35to44":"20","45to54":"17","55to64":"30","65+":"13","medianAge":"30"}},"title":"Food servers, nonrestaurant","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2019":{"total":"191","women":"66.1","white":"68.4","black":"19.2","asian":"6.6","hispanicOrLatino":"21.6"}},"wageData":{"2019":{"workers":"89","median":"515","maleWorkers":"29","maleMedian":"-","femaleWorkers":"60","femaleMedian":"501"}}},"Dining room and cafeteria attendants and bartender helpers":{"ageData":{"2019":{"total":"338","16to19":"87","20to24":"66","25to34":"43","35to44":"32","45to54":"48","55to64":"40","65+":"22","medianAge":"40"}},"title":"Dining room and cafeteria attendants and bartender helpers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2019":{"total":"338","women":"40.5","white":"77.1","black":"12.6","asian":"6.2","hispanicOrLatino":"34.2"}},"wageData":{"2019":{"workers":"116","median":"554","maleWorkers":"66","maleMedian":"605","femaleWorkers":"50","femaleMedian":"513"}}},"Dishwashers":{"ageData":{"2019":{"total":"264","16to19":"63","20to24":"46","25to34":"45","35to44":"39","45to54":"33","55to64":"28","65+":"10","medianAge":"28"}},"title":"Dishwashers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2019":{"total":"264","women":"21.0","white":"73.4","black":"16.1","asian":"4.2","hispanicOrLatino":"28.9"}},"wageData":{"2019":{"workers":"126","median":"453","maleWorkers":"102","maleMedian":"464","femaleWorkers":"24","femaleMedian":"-"}}},"Hosts and hostesses, restaurant, lounge, and coffee shop":{"ageData":{"2019":{"total":"322","16to19":"141","20to24":"106","25to34":"29","35to44":"8","45to54":"16","55to64":"13","65+":"9","medianAge":"13"}},"title":"Hosts and hostesses, restaurant, lounge, and coffee shop","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2019":{"total":"322","women":"82.1","white":"77.6","black":"8.6","asian":"4.0","hispanicOrLatino":"17.7"}},"wageData":{"2019":{"workers":"81","median":"456","maleWorkers":"17","maleMedian":"-","femaleWorkers":"64","femaleMedian":"441"}}},"Food preparation and serving related workers, all other":{"ageData":{"2019":{"total":"7","16to19":"1","20to24":"3","25to34":"3","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Food preparation and serving related workers, all other","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2019":{"total":"7","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"4","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Building and grounds cleaning and maintenance occupations":{"ageData":{"2019":{"total":"5,746","16to19":"205","20to24":"411","25to34":"1,065","35to44":"1,182","45to54":"1,300","55to64":"1,158","65+":"427","medianAge":"1,158"}},"title":"Building and grounds cleaning and maintenance occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2019":{"total":"5,746","women":"42.0","white":"77.3","black":"14.9","asian":"2.9","hispanicOrLatino":"38.2"}},"wageData":{"2019":{"workers":"3,679","median":"580","maleWorkers":"2,293","maleMedian":"618","femaleWorkers":"1,386","femaleMedian":"502"}}},"First-line supervisors of housekeeping and janitorial workers":{"ageData":{"2019":{"total":"352","16to19":"3","20to24":"7","25to34":"55","35to44":"92","45to54":"102","55to64":"71","65+":"22","medianAge":"71"}},"title":"First-line supervisors of housekeeping and janitorial workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2019":{"total":"352","women":"41.6","white":"78.5","black":"15.0","asian":"3.2","hispanicOrLatino":"27.5"}},"wageData":{"2019":{"workers":"215","median":"710","maleWorkers":"134","maleMedian":"758","femaleWorkers":"80","femaleMedian":"639"}}},"First-line supervisors of landscaping, lawn service, and groundskeeping workers":{"ageData":{"2019":{"total":"285","16to19":"4","20to24":"11","25to34":"50","35to44":"78","45to54":"68","55to64":"55","65+":"18","medianAge":"55"}},"title":"First-line supervisors of landscaping, lawn service, and groundskeeping workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2019":{"total":"285","women":"9.3","white":"88.0","black":"7.5","asian":"1.1","hispanicOrLatino":"28.1"}},"wageData":{"2019":{"workers":"121","median":"797","maleWorkers":"110","maleMedian":"800","femaleWorkers":"11","femaleMedian":"-"}}},"Janitors and building cleaners":{"ageData":{"2019":{"total":"2,265","16to19":"92","20to24":"176","25to34":"378","35to44":"378","45to54":"503","55to64":"535","65+":"202","medianAge":"535"}},"title":"Janitors and building cleaners","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2019":{"total":"2,265","women":"37.2","white":"74.0","black":"18.2","asian":"3.4","hispanicOrLatino":"31.6"}},"wageData":{"2019":{"workers":"1,563","median":"582","maleWorkers":"1,068","maleMedian":"610","femaleWorkers":"494","femaleMedian":"510"}}},"Maids and housekeeping cleaners":{"ageData":{"2019":{"total":"1,475","16to19":"26","20to24":"77","25to34":"235","35to44":"348","45to54":"402","55to64":"293","65+":"94","medianAge":"293"}},"title":"Maids and housekeeping cleaners","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2019":{"total":"1,475","women":"89.0","white":"72.2","black":"17.4","asian":"4.1","hispanicOrLatino":"49.2"}},"wageData":{"2019":{"workers":"895","median":"490","maleWorkers":"126","maleMedian":"520","femaleWorkers":"769","femaleMedian":"484"}}},"Pest control workers":{"ageData":{"2019":{"total":"96","16to19":"2","20to24":"9","25to34":"24","35to44":"23","45to54":"18","55to64":"16","65+":"4","medianAge":"16"}},"title":"Pest control workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2019":{"total":"96","women":"6.7","white":"85.2","black":"8.5","asian":"1.6","hispanicOrLatino":"18.5"}},"wageData":{"2019":{"workers":"73","median":"731","maleWorkers":"71","maleMedian":"741","femaleWorkers":"2","femaleMedian":"-"}}},"Grounds maintenance workers":{"ageData":{"2019":{"total":"1,273","16to19":"77","20to24":"130","25to34":"323","35to44":"262","45to54":"208","55to64":"188","65+":"85","medianAge":"188"}},"title":"Grounds maintenance workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2019":{"total":"1,273","women":"6.3","white":"86.0","black":"8.2","asian":"0.9","hispanicOrLatino":"43.6"}},"wageData":{"2019":{"workers":"813","median":"606","maleWorkers":"784","maleMedian":"607","femaleWorkers":"29","femaleMedian":"-"}}},"Personal care and service occupations":{"ageData":{"2019":{"total":"5,968","16to19":"343","20to24":"816","25to34":"1,271","35to44":"1,063","45to54":"1,072","55to64":"924","65+":"479","medianAge":"924"}},"title":"Personal care and service occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2019":{"total":"5,968","women":"76.9","white":"69.4","black":"16.1","asian":"10.1","hispanicOrLatino":"18.2"}},"wageData":{"2019":{"workers":"2,764","median":"565","maleWorkers":"718","maleMedian":"624","femaleWorkers":"2,047","femaleMedian":"531"}}},"First-line supervisors of gaming workers":{"ageData":{"2019":{"total":"211","16to19":"6","20to24":"14","25to34":"54","35to44":"46","45to54":"41","55to64":"29","65+":"21","medianAge":"29"}},"title":"First-line supervisors of gaming workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2019":{"total":"211","women":"43.2","white":"82.7","black":"9.1","asian":"4.1","hispanicOrLatino":"10.3"}},"wageData":{"2019":{"workers":"117","median":"821","maleWorkers":"63","maleMedian":"853","femaleWorkers":"54","femaleMedian":"791"}}},"First-line supervisors of personal service workers":{"ageData":{"2019":{"total":"213","16to19":"2","20to24":"11","25to34":"38","35to44":"49","45to54":"58","55to64":"43","65+":"12","medianAge":"43"}},"title":"First-line supervisors of personal service workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2019":{"total":"213","women":"68.5","white":"72.4","black":"4.5","asian":"19.8","hispanicOrLatino":"13.0"}},"wageData":{"2019":{"workers":"75","median":"778","maleWorkers":"32","maleMedian":"-","femaleWorkers":"43","femaleMedian":"-"}}},"Animal trainers":{"ageData":{"2019":{"total":"63","16to19":"2","20to24":"9","25to34":"17","35to44":"10","45to54":"12","55to64":"8","65+":"4","medianAge":"8"}},"title":"Animal trainers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2019":{"total":"63","women":"58.6","white":"86.7","black":"4.6","asian":"2.0","hispanicOrLatino":"12.3"}},"wageData":{"2019":{"workers":"25","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Nonfarm animal caretakers":{"ageData":{"2019":{"total":"296","16to19":"31","20to24":"68","25to34":"63","35to44":"46","45to54":"30","55to64":"43","65+":"17","medianAge":"43"}},"title":"Nonfarm animal caretakers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2019":{"total":"296","women":"75.1","white":"88.8","black":"5.0","asian":"2.1","hispanicOrLatino":"12.5"}},"wageData":{"2019":{"workers":"105","median":"515","maleWorkers":"25","maleMedian":"-","femaleWorkers":"79","femaleMedian":"489"}}},"Gaming services workers":{"ageData":{"2019":{"total":"93","16to19":"7","20to24":"7","25to34":"24","35to44":"20","45to54":"12","55to64":"15","65+":"9","medianAge":"15"}},"title":"Gaming services workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2019":{"total":"93","women":"45.1","white":"40.5","black":"19.6","asian":"27.3","hispanicOrLatino":"12.2"}},"wageData":{"2019":{"workers":"60","median":"635","maleWorkers":"32","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Motion picture projectionists":{"ageData":{"2019":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Motion picture projectionists","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2019":{"total":"1","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Ushers, lobby attendants, and ticket takers":{"ageData":{"2019":{"total":"38","16to19":"12","20to24":"8","25to34":"3","35to44":"2","45to54":"4","55to64":"3","65+":"7","medianAge":"3"}},"title":"Ushers, lobby attendants, and ticket takers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2019":{"total":"38","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"10","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Miscellaneous entertainment attendants and related workers":{"ageData":{"2019":{"total":"210","16to19":"46","20to24":"55","25to34":"34","35to44":"20","45to54":"9","55to64":"25","65+":"22","medianAge":"25"}},"title":"Miscellaneous entertainment attendants and related workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2019":{"total":"210","women":"39.3","white":"79.6","black":"10.8","asian":"5.4","hispanicOrLatino":"15.5"}},"wageData":{"2019":{"workers":"77","median":"583","maleWorkers":"54","maleMedian":"557","femaleWorkers":"24","femaleMedian":"-"}}},"Embalmers and funeral attendants":{"ageData":{"2019":{"total":"15","16to19":"0","20to24":"2","25to34":"2","35to44":"2","45to54":"1","55to64":"4","65+":"5","medianAge":"4"}},"title":"Embalmers and funeral attendants","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2019":{"total":"15","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"6","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Morticians, undertakers, and funeral directors":{"ageData":{"2019":{"total":"26","16to19":"0","20to24":"3","25to34":"2","35to44":"6","45to54":"4","55to64":"7","65+":"4","medianAge":"7"}},"title":"Morticians, undertakers, and funeral directors","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2019":{"total":"26","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"20","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Barbers":{"ageData":{"2019":{"total":"137","16to19":"1","20to24":"12","25to34":"37","35to44":"30","45to54":"29","55to64":"12","65+":"16","medianAge":"12"}},"title":"Barbers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2019":{"total":"137","women":"23.0","white":"61.8","black":"31.1","asian":"4.5","hispanicOrLatino":"29.0"}},"wageData":{"2019":{"workers":"62","median":"662","maleWorkers":"50","maleMedian":"789","femaleWorkers":"12","femaleMedian":"-"}}},"Hairdressers, hairstylists, and cosmetologists":{"ageData":{"2019":{"total":"803","16to19":"9","20to24":"91","25to34":"203","35to44":"175","45to54":"160","55to64":"101","65+":"64","medianAge":"101"}},"title":"Hairdressers, hairstylists, and cosmetologists","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2019":{"total":"803","women":"92.3","white":"77.3","black":"13.9","asian":"6.1","hispanicOrLatino":"17.0"}},"wageData":{"2019":{"workers":"310","median":"570","maleWorkers":"24","maleMedian":"-","femaleWorkers":"286","femaleMedian":"569"}}},"Miscellaneous personal appearance workers":{"ageData":{"2019":{"total":"409","16to19":"6","20to24":"33","25to34":"102","35to44":"104","45to54":"98","55to64":"44","65+":"22","medianAge":"44"}},"title":"Miscellaneous personal appearance workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2019":{"total":"409","women":"85.5","white":"30.7","black":"7.7","asian":"59.2","hispanicOrLatino":"11.6"}},"wageData":{"2019":{"workers":"227","median":"571","maleWorkers":"33","maleMedian":"-","femaleWorkers":"193","femaleMedian":"554"}}},"Baggage porters, bellhops, and concierges":{"ageData":{"2019":{"total":"92","16to19":"5","20to24":"14","25to34":"19","35to44":"7","45to54":"17","55to64":"23","65+":"9","medianAge":"23"}},"title":"Baggage porters, bellhops, and concierges","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2019":{"total":"92","women":"24.3","white":"58.1","black":"26.2","asian":"12.4","hispanicOrLatino":"30.6"}},"wageData":{"2019":{"workers":"69","median":"663","maleWorkers":"54","maleMedian":"672","femaleWorkers":"15","femaleMedian":"-"}}},"Tour and travel guides":{"ageData":{"2019":{"total":"61","16to19":"5","20to24":"12","25to34":"10","35to44":"12","45to54":"3","55to64":"11","65+":"7","medianAge":"11"}},"title":"Tour and travel guides","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2019":{"total":"61","women":"43.6","white":"82.3","black":"1.7","asian":"5.5","hispanicOrLatino":"5.3"}},"wageData":{"2019":{"workers":"28","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Childcare workers":{"ageData":{"2019":{"total":"1,193","16to19":"128","20to24":"222","25to34":"223","35to44":"173","45to54":"193","55to64":"174","65+":"79","medianAge":"174"}},"title":"Childcare workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2019":{"total":"1,193","women":"93.4","white":"76.0","black":"17.4","asian":"3.3","hispanicOrLatino":"24.6"}},"wageData":{"2019":{"workers":"473","median":"495","maleWorkers":"40","maleMedian":"-","femaleWorkers":"433","femaleMedian":"491"}}},"Personal care aides":{"ageData":{"2019":{"total":"1,458","16to19":"33","20to24":"155","25to34":"272","35to44":"253","45to54":"299","55to64":"305","65+":"140","medianAge":"305"}},"title":"Personal care aides","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2019":{"total":"1,458","women":"85.6","white":"60.2","black":"25.1","asian":"8.4","hispanicOrLatino":"21.6"}},"wageData":{"2019":{"workers":"815","median":"516","maleWorkers":"130","maleMedian":"581","femaleWorkers":"685","femaleMedian":"509"}}},"Recreation and fitness workers":{"ageData":{"2019":{"total":"440","16to19":"37","20to24":"64","25to34":"111","35to44":"70","45to54":"68","55to64":"58","65+":"32","medianAge":"58"}},"title":"Recreation and fitness workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2019":{"total":"440","women":"63.3","white":"81.6","black":"10.8","asian":"3.4","hispanicOrLatino":"10.2"}},"wageData":{"2019":{"workers":"191","median":"607","maleWorkers":"88","maleMedian":"656","femaleWorkers":"102","femaleMedian":"580"}}},"Residential advisors":{"ageData":{"2019":{"total":"30","16to19":"1","20to24":"10","25to34":"5","35to44":"5","45to54":"5","55to64":"2","65+":"2","medianAge":"2"}},"title":"Residential advisors","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2019":{"total":"30","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"21","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Personal care and service workers, all other":{"ageData":{"2019":{"total":"178","16to19":"11","20to24":"25","25to34":"54","35to44":"33","45to54":"27","55to64":"18","65+":"10","medianAge":"18"}},"title":"Personal care and service workers, all other","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2019":{"total":"178","women":"61.7","white":"73.8","black":"14.3","asian":"7.0","hispanicOrLatino":"18.1"}},"wageData":{"2019":{"workers":"74","median":"611","maleWorkers":"30","maleMedian":"-","femaleWorkers":"44","femaleMedian":"-"}}},"Sales and office occupations":{"ageData":{"2019":{"total":"33,370","16to19":"1,717","20to24":"3,836","25to34":"7,243","35to44":"6,025","45to54":"6,331","55to64":"5,794","65+":"2,425","medianAge":"5,794"}},"title":"Sales and office occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2019":{"total":"33,370","women":"60.6","white":"78.1","black":"13.0","asian":"5.2","hispanicOrLatino":"17.1"}},"wageData":{"2019":{"workers":"23,883","median":"758","maleWorkers":"9,695","maleMedian":"874","femaleWorkers":"14,188","femaleMedian":"713"}}},"Sales and related occupations":{"ageData":{"2019":{"total":"15,582","16to19":"1,100","20to24":"1,885","25to34":"3,231","35to44":"2,737","45to54":"2,889","55to64":"2,508","65+":"1,232","medianAge":"2,508"}},"title":"Sales and related occupations","depth":2,"parent":"Sales and office occupations","sexRaceEthnicityData":{"2019":{"total":"15,582","women":"48.8","white":"79.8","black":"11.2","asian":"5.4","hispanicOrLatino":"16.7"}},"wageData":{"2019":{"workers":"9,929","median":"830","maleWorkers":"5,525","maleMedian":"982","femaleWorkers":"4,404","femaleMedian":"677"}}},"First-line supervisors of retail sales workers":{"ageData":{"2019":{"total":"3,232","16to19":"36","20to24":"221","25to34":"782","35to44":"695","45to54":"683","55to64":"581","65+":"232","medianAge":"581"}},"title":"First-line supervisors of retail sales workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2019":{"total":"3,232","women":"45.5","white":"81.0","black":"9.5","asian":"5.5","hispanicOrLatino":"14.7"}},"wageData":{"2019":{"workers":"2,316","median":"817","maleWorkers":"1,246","maleMedian":"955","femaleWorkers":"1,070","femaleMedian":"708"}}},"First-line supervisors of non-retail sales workers":{"ageData":{"2019":{"total":"1,247","16to19":"5","20to24":"43","25to34":"211","35to44":"269","45to54":"349","55to64":"259","65+":"111","medianAge":"259"}},"title":"First-line supervisors of non-retail sales workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2019":{"total":"1,247","women":"27.1","white":"86.2","black":"6.5","asian":"5.7","hispanicOrLatino":"14.4"}},"wageData":{"2019":{"workers":"857","median":"1,162","maleWorkers":"596","maleMedian":"1,157","femaleWorkers":"261","femaleMedian":"1,173"}}},"Cashiers":{"ageData":{"2019":{"total":"3,164","16to19":"738","20to24":"735","25to34":"557","35to44":"368","45to54":"319","55to64":"299","65+":"148","medianAge":"299"}},"title":"Cashiers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2019":{"total":"3,164","women":"71.2","white":"69.2","black":"17.9","asian":"7.3","hispanicOrLatino":"24.1"}},"wageData":{"2019":{"workers":"1,398","median":"503","maleWorkers":"438","maleMedian":"510","femaleWorkers":"959","femaleMedian":"499"}}},"Counter and rental clerks":{"ageData":{"2019":{"total":"97","16to19":"4","20to24":"12","25to34":"20","35to44":"25","45to54":"14","55to64":"11","65+":"10","medianAge":"11"}},"title":"Counter and rental clerks","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2019":{"total":"97","women":"42.6","white":"72.8","black":"18.3","asian":"6.6","hispanicOrLatino":"15.8"}},"wageData":{"2019":{"workers":"67","median":"686","maleWorkers":"44","maleMedian":"-","femaleWorkers":"23","femaleMedian":"-"}}},"Parts salespersons":{"ageData":{"2019":{"total":"142","16to19":"2","20to24":"13","25to34":"38","35to44":"25","45to54":"27","55to64":"26","65+":"10","medianAge":"26"}},"title":"Parts salespersons","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2019":{"total":"142","women":"12.0","white":"84.9","black":"10.4","asian":"1.3","hispanicOrLatino":"19.8"}},"wageData":{"2019":{"workers":"122","median":"777","maleWorkers":"107","maleMedian":"768","femaleWorkers":"15","femaleMedian":"-"}}},"Retail salespersons":{"ageData":{"2019":{"total":"3,105","16to19":"258","20to24":"611","25to34":"647","35to44":"411","45to54":"441","55to64":"456","65+":"281","medianAge":"456"}},"title":"Retail salespersons","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2019":{"total":"3,105","women":"48.5","white":"78.9","black":"12.4","asian":"4.5","hispanicOrLatino":"18.7"}},"wageData":{"2019":{"workers":"1,856","median":"692","maleWorkers":"1,094","maleMedian":"806","femaleWorkers":"762","femaleMedian":"578"}}},"Advertising sales agents":{"ageData":{"2019":{"total":"190","16to19":"1","20to24":"14","25to34":"59","35to44":"39","45to54":"39","55to64":"29","65+":"9","medianAge":"29"}},"title":"Advertising sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2019":{"total":"190","women":"49.7","white":"81.9","black":"10.8","asian":"3.7","hispanicOrLatino":"13.7"}},"wageData":{"2019":{"workers":"169","median":"1,050","maleWorkers":"88","maleMedian":"1,143","femaleWorkers":"81","femaleMedian":"874"}}},"Insurance sales agents":{"ageData":{"2019":{"total":"595","16to19":"2","20to24":"31","25to34":"133","35to44":"131","45to54":"119","55to64":"118","65+":"61","medianAge":"118"}},"title":"Insurance sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2019":{"total":"595","women":"50.6","white":"81.2","black":"10.1","asian":"5.6","hispanicOrLatino":"13.4"}},"wageData":{"2019":{"workers":"461","median":"927","maleWorkers":"214","maleMedian":"1,034","femaleWorkers":"247","femaleMedian":"806"}}},"Securities, commodities, and financial services sales agents":{"ageData":{"2019":{"total":"231","16to19":"2","20to24":"16","25to34":"60","35to44":"51","45to54":"53","55to64":"34","65+":"13","medianAge":"34"}},"title":"Securities, commodities, and financial services sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2019":{"total":"231","women":"30.0","white":"85.9","black":"5.4","asian":"7.5","hispanicOrLatino":"11.9"}},"wageData":{"2019":{"workers":"192","median":"1,302","maleWorkers":"129","maleMedian":"1,386","femaleWorkers":"63","femaleMedian":"1,063"}}},"Travel agents":{"ageData":{"2019":{"total":"82","16to19":"0","20to24":"3","25to34":"7","35to44":"13","45to54":"30","55to64":"17","65+":"12","medianAge":"17"}},"title":"Travel agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2019":{"total":"82","women":"86.0","white":"81.6","black":"9.5","asian":"7.1","hispanicOrLatino":"6.7"}},"wageData":{"2019":{"workers":"52","median":"745","maleWorkers":"8","maleMedian":"-","femaleWorkers":"44","femaleMedian":"-"}}},"Sales representatives, services, all other":{"ageData":{"2019":{"total":"557","16to19":"5","20to24":"47","25to34":"161","35to44":"117","45to54":"121","55to64":"80","65+":"26","medianAge":"80"}},"title":"Sales representatives, services, all other","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2019":{"total":"557","women":"30.4","white":"85.2","black":"7.7","asian":"5.0","hispanicOrLatino":"12.3"}},"wageData":{"2019":{"workers":"477","median":"1,211","maleWorkers":"340","maleMedian":"1,332","femaleWorkers":"137","femaleMedian":"973"}}},"Sales representatives, wholesale and manufacturing":{"ageData":{"2019":{"total":"1,281","16to19":"17","20to24":"51","25to34":"256","35to44":"279","45to54":"330","55to64":"258","65+":"90","medianAge":"258"}},"title":"Sales representatives, wholesale and manufacturing","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2019":{"total":"1,281","women":"27.2","white":"88.8","black":"5.9","asian":"3.9","hispanicOrLatino":"10.9"}},"wageData":{"2019":{"workers":"1,107","median":"1,206","maleWorkers":"813","maleMedian":"1,262","femaleWorkers":"294","femaleMedian":"1,067"}}},"Models, demonstrators, and product promoters":{"ageData":{"2019":{"total":"62","16to19":"3","20to24":"4","25to34":"11","35to44":"7","45to54":"7","55to64":"8","65+":"21","medianAge":"8"}},"title":"Models, demonstrators, and product promoters","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2019":{"total":"62","women":"73.3","white":"79.5","black":"11.3","asian":"3.1","hispanicOrLatino":"16.0"}},"wageData":{"2019":{"workers":"15","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Real estate brokers and sales agents":{"ageData":{"2019":{"total":"1,095","16to19":"5","20to24":"38","25to34":"181","35to44":"214","45to54":"255","55to64":"240","65+":"161","medianAge":"240"}},"title":"Real estate brokers and sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2019":{"total":"1,095","women":"58.9","white":"85.0","black":"7.9","asian":"5.2","hispanicOrLatino":"10.7"}},"wageData":{"2019":{"workers":"543","median":"1,019","maleWorkers":"222","maleMedian":"1,344","femaleWorkers":"321","femaleMedian":"883"}}},"Sales engineers":{"ageData":{"2019":{"total":"35","16to19":"0","20to24":"2","25to34":"10","35to44":"6","45to54":"8","55to64":"9","65+":"1","medianAge":"9"}},"title":"Sales engineers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2019":{"total":"35","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"32","median":"-","maleWorkers":"29","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Telemarketers":{"ageData":{"2019":{"total":"49","16to19":"2","20to24":"9","25to34":"16","35to44":"5","45to54":"9","55to64":"4","65+":"3","medianAge":"4"}},"title":"Telemarketers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2019":{"total":"49","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"42","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"24","femaleMedian":"-"}}},"Door-to-door sales workers, news and street vendors, and related workers":{"ageData":{"2019":{"total":"135","16to19":"4","20to24":"9","25to34":"21","35to44":"29","45to54":"24","55to64":"30","65+":"19","medianAge":"30"}},"title":"Door-to-door sales workers, news and street vendors, and related workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2019":{"total":"135","women":"59.5","white":"85.4","black":"9.4","asian":"1.2","hispanicOrLatino":"24.9"}},"wageData":{"2019":{"workers":"31","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Sales and related workers, all other":{"ageData":{"2019":{"total":"284","16to19":"14","20to24":"26","25to34":"60","35to44":"53","45to54":"61","55to64":"47","65+":"23","medianAge":"47"}},"title":"Sales and related workers, all other","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2019":{"total":"284","women":"42.9","white":"83.9","black":"10.6","asian":"1.1","hispanicOrLatino":"13.9"}},"wageData":{"2019":{"workers":"194","median":"935","maleWorkers":"123","maleMedian":"966","femaleWorkers":"71","femaleMedian":"848"}}},"Office and administrative support occupations":{"ageData":{"2019":{"total":"17,789","16to19":"616","20to24":"1,951","25to34":"4,011","35to44":"3,288","45to54":"3,443","55to64":"3,286","65+":"1,192","medianAge":"3,286"}},"title":"Office and administrative support occupations","depth":2,"parent":"Sales and office occupations","sexRaceEthnicityData":{"2019":{"total":"17,789","women":"70.9","white":"76.6","black":"14.5","asian":"5.0","hispanicOrLatino":"17.5"}},"wageData":{"2019":{"workers":"13,954","median":"732","maleWorkers":"4,170","maleMedian":"771","femaleWorkers":"9,784","femaleMedian":"721"}}},"First-line supervisors of office and administrative support workers":{"ageData":{"2019":{"total":"1,306","16to19":"6","20to24":"51","25to34":"286","35to44":"294","45to54":"335","55to64":"264","65+":"71","medianAge":"264"}},"title":"First-line supervisors of office and administrative support workers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"1,306","women":"68.5","white":"80.2","black":"13.4","asian":"3.7","hispanicOrLatino":"13.3"}},"wageData":{"2019":{"workers":"1,215","median":"866","maleWorkers":"406","maleMedian":"971","femaleWorkers":"809","femaleMedian":"816"}}},"Switchboard operators, including answering service":{"ageData":{"2019":{"total":"21","16to19":"0","20to24":"1","25to34":"5","35to44":"2","45to54":"4","55to64":"8","65+":"1","medianAge":"8"}},"title":"Switchboard operators, including answering service","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"21","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"20","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Telephone operators":{"ageData":{"2019":{"total":"42","16to19":"3","20to24":"7","25to34":"10","35to44":"10","45to54":"4","55to64":"5","65+":"3","medianAge":"5"}},"title":"Telephone operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"42","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"34","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Communications equipment operators, all other":{"ageData":{"2019":{"total":"12","16to19":"0","20to24":"0","25to34":"5","35to44":"1","45to54":"4","55to64":"1","65+":"0","medianAge":"1"}},"title":"Communications equipment operators, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"12","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"8","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Bill and account collectors":{"ageData":{"2019":{"total":"116","16to19":"1","20to24":"11","25to34":"47","35to44":"18","45to54":"22","55to64":"11","65+":"5","medianAge":"11"}},"title":"Bill and account collectors","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"116","women":"80.8","white":"63.6","black":"30.2","asian":"1.3","hispanicOrLatino":"17.8"}},"wageData":{"2019":{"workers":"113","median":"701","maleWorkers":"22","maleMedian":"-","femaleWorkers":"91","femaleMedian":"672"}}},"Billing and posting clerks":{"ageData":{"2019":{"total":"459","16to19":"4","20to24":"34","25to34":"90","35to44":"110","45to54":"112","55to64":"82","65+":"27","medianAge":"82"}},"title":"Billing and posting clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"459","women":"89.5","white":"81.5","black":"10.3","asian":"4.7","hispanicOrLatino":"15.7"}},"wageData":{"2019":{"workers":"389","median":"742","maleWorkers":"45","maleMedian":"-","femaleWorkers":"344","femaleMedian":"736"}}},"Bookkeeping, accounting, and auditing clerks":{"ageData":{"2019":{"total":"1,015","16to19":"9","20to24":"50","25to34":"123","35to44":"181","45to54":"239","55to64":"285","65+":"129","medianAge":"285"}},"title":"Bookkeeping, accounting, and auditing clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"1,015","women":"88.5","white":"85.2","black":"6.9","asian":"5.4","hispanicOrLatino":"13.0"}},"wageData":{"2019":{"workers":"657","median":"764","maleWorkers":"84","maleMedian":"784","femaleWorkers":"573","femaleMedian":"764"}}},"Gaming cage workers":{"ageData":{"2019":{"total":"13","16to19":"0","20to24":"0","25to34":"5","35to44":"2","45to54":"2","55to64":"2","65+":"1","medianAge":"2"}},"title":"Gaming cage workers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"13","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"10","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Payroll and timekeeping clerks":{"ageData":{"2019":{"total":"155","16to19":"0","20to24":"5","25to34":"24","35to44":"35","45to54":"34","55to64":"38","65+":"17","medianAge":"38"}},"title":"Payroll and timekeeping clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"155","women":"85.2","white":"79.8","black":"8.4","asian":"6.9","hispanicOrLatino":"17.9"}},"wageData":{"2019":{"workers":"127","median":"766","maleWorkers":"17","maleMedian":"-","femaleWorkers":"110","femaleMedian":"756"}}},"Procurement clerks":{"ageData":{"2019":{"total":"29","16to19":"0","20to24":"3","25to34":"3","35to44":"4","45to54":"12","55to64":"7","65+":"0","medianAge":"7"}},"title":"Procurement clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"29","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"29","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"21","femaleMedian":"-"}}},"Tellers":{"ageData":{"2019":{"total":"294","16to19":"10","20to24":"77","25to34":"84","35to44":"45","45to54":"36","55to64":"32","65+":"10","medianAge":"32"}},"title":"Tellers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"294","women":"84.7","white":"80.0","black":"9.9","asian":"4.8","hispanicOrLatino":"20.0"}},"wageData":{"2019":{"workers":"241","median":"575","maleWorkers":"35","maleMedian":"-","femaleWorkers":"207","femaleMedian":"571"}}},"Financial clerks, all other":{"ageData":{"2019":{"total":"119","16to19":"0","20to24":"15","25to34":"29","35to44":"32","45to54":"21","55to64":"18","65+":"5","medianAge":"18"}},"title":"Financial clerks, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"119","women":"59.7","white":"83.2","black":"10.9","asian":"3.8","hispanicOrLatino":"15.4"}},"wageData":{"2019":{"workers":"119","median":"890","maleWorkers":"48","maleMedian":"-","femaleWorkers":"71","femaleMedian":"797"}}},"Brokerage clerks":{"ageData":{"2019":{"total":"3","16to19":"0","20to24":"0","25to34":"0","35to44":"2","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Brokerage clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"3","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"3","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Correspondence clerks":{"ageData":{"2019":{"total":"5","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"0","55to64":"1","65+":"1","medianAge":"1"}},"title":"Correspondence clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"6","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Court, municipal, and license clerks":{"ageData":{"2019":{"total":"95","16to19":"0","20to24":"2","25to34":"24","35to44":"13","45to54":"21","55to64":"28","65+":"6","medianAge":"28"}},"title":"Court, municipal, and license clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"95","women":"75.3","white":"81.6","black":"14.5","asian":"1.2","hispanicOrLatino":"17.3"}},"wageData":{"2019":{"workers":"83","median":"748","maleWorkers":"17","maleMedian":"-","femaleWorkers":"66","femaleMedian":"759"}}},"Credit authorizers, checkers, and clerks":{"ageData":{"2019":{"total":"41","16to19":"0","20to24":"1","25to34":"17","35to44":"6","45to54":"9","55to64":"5","65+":"2","medianAge":"5"}},"title":"Credit authorizers, checkers, and clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"41","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"39","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"30","femaleMedian":"-"}}},"Customer service representatives":{"ageData":{"2019":{"total":"2,552","16to19":"201","20to24":"398","25to34":"679","35to44":"448","45to54":"388","55to64":"332","65+":"105","medianAge":"332"}},"title":"Customer service representatives","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"2,552","women":"64.2","white":"73.3","black":"17.7","asian":"5.3","hispanicOrLatino":"19.6"}},"wageData":{"2019":{"workers":"1,977","median":"693","maleWorkers":"717","maleMedian":"736","femaleWorkers":"1,259","femaleMedian":"673"}}},"Eligibility interviewers, government programs":{"ageData":{"2019":{"total":"70","16to19":"0","20to24":"0","25to34":"15","35to44":"24","45to54":"16","55to64":"13","65+":"2","medianAge":"13"}},"title":"Eligibility interviewers, government programs","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"70","women":"80.1","white":"70.1","black":"22.2","asian":"1.1","hispanicOrLatino":"23.0"}},"wageData":{"2019":{"workers":"68","median":"763","maleWorkers":"16","maleMedian":"-","femaleWorkers":"52","femaleMedian":"756"}}},"File clerks":{"ageData":{"2019":{"total":"175","16to19":"12","20to24":"18","25to34":"35","35to44":"24","45to54":"41","55to64":"27","65+":"17","medianAge":"27"}},"title":"File clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"175","women":"83.1","white":"75.3","black":"16.8","asian":"4.1","hispanicOrLatino":"14.2"}},"wageData":{"2019":{"workers":"137","median":"672","maleWorkers":"27","maleMedian":"-","femaleWorkers":"110","femaleMedian":"667"}}},"Hotel, motel, and resort desk clerks":{"ageData":{"2019":{"total":"116","16to19":"3","20to24":"35","25to34":"44","35to44":"13","45to54":"12","55to64":"5","65+":"5","medianAge":"5"}},"title":"Hotel, motel, and resort desk clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"116","women":"74.6","white":"60.7","black":"21.6","asian":"7.4","hispanicOrLatino":"22.3"}},"wageData":{"2019":{"workers":"90","median":"519","maleWorkers":"24","maleMedian":"-","femaleWorkers":"65","femaleMedian":"490"}}},"Interviewers, except eligibility and loan":{"ageData":{"2019":{"total":"131","16to19":"5","20to24":"14","25to34":"27","35to44":"27","45to54":"20","55to64":"21","65+":"17","medianAge":"21"}},"title":"Interviewers, except eligibility and loan","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"131","women":"85.5","white":"72.9","black":"18.1","asian":"4.7","hispanicOrLatino":"18.3"}},"wageData":{"2019":{"workers":"93","median":"740","maleWorkers":"10","maleMedian":"-","femaleWorkers":"82","femaleMedian":"734"}}},"Library assistants, clerical":{"ageData":{"2019":{"total":"88","16to19":"4","20to24":"15","25to34":"21","35to44":"8","45to54":"14","55to64":"16","65+":"11","medianAge":"16"}},"title":"Library assistants, clerical","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"88","women":"81.4","white":"78.2","black":"12.0","asian":"8.9","hispanicOrLatino":"12.6"}},"wageData":{"2019":{"workers":"34","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"29","femaleMedian":"-"}}},"Loan interviewers and clerks":{"ageData":{"2019":{"total":"116","16to19":"0","20to24":"5","25to34":"37","35to44":"32","45to54":"22","55to64":"13","65+":"5","medianAge":"13"}},"title":"Loan interviewers and clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"116","women":"76.8","white":"75.2","black":"16.3","asian":"4.3","hispanicOrLatino":"13.3"}},"wageData":{"2019":{"workers":"118","median":"825","maleWorkers":"30","maleMedian":"-","femaleWorkers":"88","femaleMedian":"802"}}},"New accounts clerks":{"ageData":{"2019":{"total":"22","16to19":"0","20to24":"2","25to34":"4","35to44":"7","45to54":"3","55to64":"4","65+":"1","medianAge":"4"}},"title":"New accounts clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"22","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"25","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Order clerks":{"ageData":{"2019":{"total":"112","16to19":"5","20to24":"15","25to34":"27","35to44":"21","45to54":"19","55to64":"20","65+":"5","medianAge":"20"}},"title":"Order clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"112","women":"53.3","white":"66.9","black":"18.2","asian":"9.9","hispanicOrLatino":"18.3"}},"wageData":{"2019":{"workers":"72","median":"783","maleWorkers":"40","maleMedian":"-","femaleWorkers":"32","femaleMedian":"-"}}},"Human resources assistants, except payroll and timekeeping":{"ageData":{"2019":{"total":"60","16to19":"1","20to24":"5","25to34":"17","35to44":"14","45to54":"12","55to64":"8","65+":"3","medianAge":"8"}},"title":"Human resources assistants, except payroll and timekeeping","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"60","women":"81.2","white":"74.2","black":"12.7","asian":"3.8","hispanicOrLatino":"18.5"}},"wageData":{"2019":{"workers":"51","median":"702","maleWorkers":"10","maleMedian":"-","femaleWorkers":"41","femaleMedian":"-"}}},"Receptionists and information clerks":{"ageData":{"2019":{"total":"1,288","16to19":"72","20to24":"219","25to34":"317","35to44":"207","45to54":"192","55to64":"187","65+":"94","medianAge":"187"}},"title":"Receptionists and information clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"1,288","women":"89.3","white":"75.8","black":"15.4","asian":"4.6","hispanicOrLatino":"21.8"}},"wageData":{"2019":{"workers":"909","median":"642","maleWorkers":"100","maleMedian":"735","femaleWorkers":"809","femaleMedian":"636"}}},"Reservation and transportation ticket agents and travel clerks":{"ageData":{"2019":{"total":"119","16to19":"1","20to24":"10","25to34":"37","35to44":"23","45to54":"22","55to64":"22","65+":"3","medianAge":"22"}},"title":"Reservation and transportation ticket agents and travel clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"119","women":"58.9","white":"51.4","black":"27.9","asian":"9.1","hispanicOrLatino":"13.5"}},"wageData":{"2019":{"workers":"103","median":"813","maleWorkers":"46","maleMedian":"-","femaleWorkers":"56","femaleMedian":"789"}}},"Information and record clerks, all other":{"ageData":{"2019":{"total":"99","16to19":"0","20to24":"9","25to34":"23","35to44":"24","45to54":"17","55to64":"20","65+":"6","medianAge":"20"}},"title":"Information and record clerks, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"99","women":"76.9","white":"79.9","black":"13.4","asian":"2.3","hispanicOrLatino":"22.8"}},"wageData":{"2019":{"workers":"88","median":"735","maleWorkers":"24","maleMedian":"-","femaleWorkers":"64","femaleMedian":"691"}}},"Cargo and freight agents":{"ageData":{"2019":{"total":"20","16to19":"1","20to24":"1","25to34":"5","35to44":"6","45to54":"3","55to64":"4","65+":"2","medianAge":"4"}},"title":"Cargo and freight agents","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"20","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"19","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Couriers and messengers":{"ageData":{"2019":{"total":"402","16to19":"14","20to24":"50","25to34":"102","35to44":"70","45to54":"76","55to64":"58","65+":"33","medianAge":"58"}},"title":"Couriers and messengers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"402","women":"20.7","white":"73.3","black":"17.4","asian":"4.4","hispanicOrLatino":"21.4"}},"wageData":{"2019":{"workers":"260","median":"769","maleWorkers":"221","maleMedian":"789","femaleWorkers":"40","femaleMedian":"-"}}},"Dispatchers":{"ageData":{"2019":{"total":"261","16to19":"3","20to24":"23","25to34":"72","35to44":"67","45to54":"51","55to64":"35","65+":"11","medianAge":"35"}},"title":"Dispatchers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"261","women":"53.1","white":"80.8","black":"14.2","asian":"2.5","hispanicOrLatino":"15.2"}},"wageData":{"2019":{"workers":"240","median":"806","maleWorkers":"108","maleMedian":"854","femaleWorkers":"131","femaleMedian":"763"}}},"Meter readers, utilities":{"ageData":{"2019":{"total":"17","16to19":"0","20to24":"4","25to34":"3","35to44":"1","45to54":"4","55to64":"3","65+":"2","medianAge":"3"}},"title":"Meter readers, utilities","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"17","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"13","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Postal service clerks":{"ageData":{"2019":{"total":"96","16to19":"0","20to24":"8","25to34":"11","35to44":"17","45to54":"21","55to64":"31","65+":"8","medianAge":"31"}},"title":"Postal service clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"96","women":"55.1","white":"47.4","black":"35.8","asian":"13.0","hispanicOrLatino":"6.7"}},"wageData":{"2019":{"workers":"73","median":"907","maleWorkers":"30","maleMedian":"-","femaleWorkers":"43","femaleMedian":"-"}}},"Postal service mail carriers":{"ageData":{"2019":{"total":"331","16to19":"0","20to24":"17","25to34":"73","35to44":"69","45to54":"79","55to64":"79","65+":"14","medianAge":"79"}},"title":"Postal service mail carriers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"331","women":"36.6","white":"72.7","black":"19.6","asian":"5.5","hispanicOrLatino":"14.4"}},"wageData":{"2019":{"workers":"296","median":"951","maleWorkers":"185","maleMedian":"994","femaleWorkers":"111","femaleMedian":"893"}}},"Postal service mail sorters, processors, and processing machine operators":{"ageData":{"2019":{"total":"76","16to19":"0","20to24":"5","25to34":"17","35to44":"5","45to54":"13","55to64":"28","65+":"9","medianAge":"28"}},"title":"Postal service mail sorters, processors, and processing machine operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"76","women":"53.3","white":"35.8","black":"42.3","asian":"17.8","hispanicOrLatino":"5.8"}},"wageData":{"2019":{"workers":"67","median":"1,145","maleWorkers":"37","maleMedian":"-","femaleWorkers":"30","femaleMedian":"-"}}},"Production, planning, and expediting clerks":{"ageData":{"2019":{"total":"297","16to19":"3","20to24":"14","25to34":"80","35to44":"60","45to54":"63","55to64":"61","65+":"15","medianAge":"61"}},"title":"Production, planning, and expediting clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"297","women":"57.7","white":"80.0","black":"14.0","asian":"3.3","hispanicOrLatino":"12.5"}},"wageData":{"2019":{"workers":"268","median":"939","maleWorkers":"114","maleMedian":"1,039","femaleWorkers":"154","femaleMedian":"872"}}},"Shipping, receiving, and traffic clerks":{"ageData":{"2019":{"total":"563","16to19":"16","20to24":"57","25to34":"132","35to44":"98","45to54":"125","55to64":"102","65+":"32","medianAge":"102"}},"title":"Shipping, receiving, and traffic clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"563","women":"34.9","white":"74.7","black":"15.5","asian":"4.2","hispanicOrLatino":"25.1"}},"wageData":{"2019":{"workers":"507","median":"679","maleWorkers":"332","maleMedian":"686","femaleWorkers":"175","femaleMedian":"662"}}},"Stock clerks and order fillers":{"ageData":{"2019":{"total":"1,512","16to19":"136","20to24":"308","25to34":"364","35to44":"226","45to54":"216","55to64":"191","65+":"71","medianAge":"191"}},"title":"Stock clerks and order fillers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"1,512","women":"37.5","white":"70.3","black":"18.2","asian":"5.0","hispanicOrLatino":"23.1"}},"wageData":{"2019":{"workers":"1,016","median":"599","maleWorkers":"636","maleMedian":"596","femaleWorkers":"380","femaleMedian":"605"}}},"Weighers, measurers, checkers, and samplers, recordkeeping":{"ageData":{"2019":{"total":"66","16to19":"2","20to24":"2","25to34":"10","35to44":"16","45to54":"17","55to64":"15","65+":"3","medianAge":"15"}},"title":"Weighers, measurers, checkers, and samplers, recordkeeping","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"66","women":"47.3","white":"75.8","black":"10.6","asian":"8.5","hispanicOrLatino":"21.1"}},"wageData":{"2019":{"workers":"53","median":"716","maleWorkers":"26","maleMedian":"-","femaleWorkers":"27","femaleMedian":"-"}}},"Secretaries and administrative assistants":{"ageData":{"2019":{"total":"2,688","16to19":"27","20to24":"155","25to34":"439","35to44":"511","45to54":"632","55to64":"675","65+":"249","medianAge":"675"}},"title":"Secretaries and administrative assistants","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"2,688","women":"93.2","white":"85.2","black":"8.7","asian":"3.5","hispanicOrLatino":"13.4"}},"wageData":{"2019":{"workers":"2,069","median":"765","maleWorkers":"137","maleMedian":"795","femaleWorkers":"1,932","femaleMedian":"763"}}},"Computer operators":{"ageData":{"2019":{"total":"72","16to19":"3","20to24":"3","25to34":"19","35to44":"13","45to54":"12","55to64":"14","65+":"8","medianAge":"14"}},"title":"Computer operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"72","women":"47.5","white":"76.3","black":"11.9","asian":"9.1","hispanicOrLatino":"19.4"}},"wageData":{"2019":{"workers":"68","median":"960","maleWorkers":"41","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Data entry keyers":{"ageData":{"2019":{"total":"250","16to19":"7","20to24":"27","25to34":"56","35to44":"62","45to54":"42","55to64":"44","65+":"12","medianAge":"44"}},"title":"Data entry keyers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"250","women":"73.4","white":"75.1","black":"14.7","asian":"6.5","hispanicOrLatino":"20.3"}},"wageData":{"2019":{"workers":"203","median":"675","maleWorkers":"50","maleMedian":"738","femaleWorkers":"153","femaleMedian":"656"}}},"Word processors and typists":{"ageData":{"2019":{"total":"57","16to19":"2","20to24":"6","25to34":"13","35to44":"11","45to54":"7","55to64":"14","65+":"4","medianAge":"14"}},"title":"Word processors and typists","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"57","women":"86.0","white":"77.8","black":"12.6","asian":"3.3","hispanicOrLatino":"16.1"}},"wageData":{"2019":{"workers":"36","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"30","femaleMedian":"-"}}},"Desktop publishers":{"ageData":{"2019":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Desktop publishers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"0","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Insurance claims and policy processing clerks":{"ageData":{"2019":{"total":"269","16to19":"5","20to24":"20","25to34":"84","35to44":"50","45to54":"51","55to64":"51","65+":"8","medianAge":"51"}},"title":"Insurance claims and policy processing clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"269","women":"81.7","white":"71.3","black":"21.8","asian":"2.4","hispanicOrLatino":"15.5"}},"wageData":{"2019":{"workers":"251","median":"746","maleWorkers":"47","maleMedian":"-","femaleWorkers":"204","femaleMedian":"739"}}},"Mail clerks and mail machine operators, except postal service":{"ageData":{"2019":{"total":"68","16to19":"1","20to24":"10","25to34":"19","35to44":"10","45to54":"13","55to64":"9","65+":"5","medianAge":"9"}},"title":"Mail clerks and mail machine operators, except postal service","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"68","women":"49.8","white":"67.6","black":"24.0","asian":"4.1","hispanicOrLatino":"14.2"}},"wageData":{"2019":{"workers":"48","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"22","femaleMedian":"-"}}},"Office clerks, general":{"ageData":{"2019":{"total":"1,355","16to19":"54","20to24":"174","25to34":"301","35to44":"222","45to54":"237","55to64":"263","65+":"105","medianAge":"263"}},"title":"Office clerks, general","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"1,355","women":"82.7","white":"74.0","black":"13.6","asian":"8.6","hispanicOrLatino":"20.9"}},"wageData":{"2019":{"workers":"997","median":"685","maleWorkers":"188","maleMedian":"718","femaleWorkers":"809","femaleMedian":"677"}}},"Office machine operators, except computer":{"ageData":{"2019":{"total":"32","16to19":"2","20to24":"5","25to34":"8","35to44":"6","45to54":"4","55to64":"6","65+":"2","medianAge":"6"}},"title":"Office machine operators, except computer","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"32","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"30","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Proofreaders and copy markers":{"ageData":{"2019":{"total":"7","16to19":"0","20to24":"0","25to34":"1","35to44":"2","45to54":"1","55to64":"2","65+":"1","medianAge":"2"}},"title":"Proofreaders and copy markers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"7","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"5","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Statistical assistants":{"ageData":{"2019":{"total":"58","16to19":"0","20to24":"7","25to34":"18","35to44":"11","45to54":"13","55to64":"10","65+":"0","medianAge":"10"}},"title":"Statistical assistants","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"58","women":"42.8","white":"67.4","black":"0.0","asian":"32.3","hispanicOrLatino":"4.9"}},"wageData":{"2019":{"workers":"58","median":"1,480","maleWorkers":"33","maleMedian":"-","femaleWorkers":"25","femaleMedian":"-"}}},"Office and administrative support workers, all other":{"ageData":{"2019":{"total":"618","16to19":"3","20to24":"53","25to34":"147","35to44":"129","45to54":"128","55to64":"116","65+":"42","medianAge":"116"}},"title":"Office and administrative support workers, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2019":{"total":"618","women":"74.6","white":"77.7","black":"15.5","asian":"3.4","hispanicOrLatino":"13.6"}},"wageData":{"2019":{"workers":"522","median":"866","maleWorkers":"147","maleMedian":"950","femaleWorkers":"375","femaleMedian":"820"}}},"Natural resources, construction, and maintenance occupations":{"ageData":{"2019":{"total":"14,343","16to19":"336","20to24":"1,311","25to34":"3,320","35to44":"3,479","45to54":"2,952","55to64":"2,342","65+":"602","medianAge":"2,342"}},"title":"Natural resources, construction, and maintenance occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2019":{"total":"14,343","women":"5.4","white":"86.2","black":"7.7","asian":"2.2","hispanicOrLatino":"31.9"}},"wageData":{"2019":{"workers":"11,671","median":"869","maleWorkers":"11,134","maleMedian":"881","femaleWorkers":"537","femaleMedian":"614"}}},"Farming, fishing, and forestry occupations":{"ageData":{"2019":{"total":"1,156","16to19":"75","20to24":"126","25to34":"257","35to44":"247","45to54":"201","55to64":"182","65+":"69","medianAge":"182"}},"title":"Farming, fishing, and forestry occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2019":{"total":"1,156","women":"25.2","white":"89.3","black":"4.4","asian":"1.8","hispanicOrLatino":"47.6"}},"wageData":{"2019":{"workers":"900","median":"574","maleWorkers":"690","maleMedian":"593","femaleWorkers":"210","femaleMedian":"513"}}},"First-line supervisors of farming, fishing, and forestry workers":{"ageData":{"2019":{"total":"51","16to19":"0","20to24":"2","25to34":"10","35to44":"10","45to54":"8","55to64":"17","65+":"4","medianAge":"17"}},"title":"First-line supervisors of farming, fishing, and forestry workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2019":{"total":"51","women":"9.4","white":"88.8","black":"1.2","asian":"1.3","hispanicOrLatino":"28.4"}},"wageData":{"2019":{"workers":"40","median":"-","maleWorkers":"37","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Agricultural inspectors":{"ageData":{"2019":{"total":"18","16to19":"0","20to24":"0","25to34":"3","35to44":"3","45to54":"3","55to64":"8","65+":"0","medianAge":"8"}},"title":"Agricultural inspectors","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2019":{"total":"18","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"16","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Animal breeders":{"ageData":{"2019":{"total":"10","16to19":"0","20to24":"0","25to34":"1","35to44":"5","45to54":"1","55to64":"2","65+":"1","medianAge":"2"}},"title":"Animal breeders","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2019":{"total":"10","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Graders and sorters, agricultural products":{"ageData":{"2019":{"total":"88","16to19":"1","20to24":"11","25to34":"25","35to44":"21","45to54":"15","55to64":"11","65+":"4","medianAge":"11"}},"title":"Graders and sorters, agricultural products","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2019":{"total":"88","women":"64.5","white":"71.2","black":"21.3","asian":"3.6","hispanicOrLatino":"49.9"}},"wageData":{"2019":{"workers":"78","median":"564","maleWorkers":"29","maleMedian":"-","femaleWorkers":"50","femaleMedian":"549"}}},"Miscellaneous agricultural workers":{"ageData":{"2019":{"total":"866","16to19":"68","20to24":"100","25to34":"192","35to44":"187","45to54":"144","55to64":"126","65+":"50","medianAge":"126"}},"title":"Miscellaneous agricultural workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2019":{"total":"866","women":"24.2","white":"92.5","black":"2.6","asian":"1.2","hispanicOrLatino":"54.0"}},"wageData":{"2019":{"workers":"691","median":"558","maleWorkers":"544","maleMedian":"581","femaleWorkers":"148","femaleMedian":"502"}}},"Fishers and related fishing workers":{"ageData":{"2019":{"total":"36","16to19":"1","20to24":"4","25to34":"6","35to44":"6","45to54":"10","55to64":"6","65+":"4","medianAge":"6"}},"title":"Fishers and related fishing workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2019":{"total":"36","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"14","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Hunters and trappers":{"ageData":{"2019":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Hunters and trappers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2019":{"total":"0","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Forest and conservation workers":{"ageData":{"2019":{"total":"21","16to19":"0","20to24":"2","25to34":"5","35to44":"3","45to54":"6","55to64":"2","65+":"3","medianAge":"2"}},"title":"Forest and conservation workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2019":{"total":"21","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"14","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Logging workers":{"ageData":{"2019":{"total":"66","16to19":"3","20to24":"7","25to34":"14","35to44":"12","45to54":"15","55to64":"11","65+":"4","medianAge":"11"}},"title":"Logging workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2019":{"total":"66","women":"1.8","white":"83.2","black":"2.7","asian":"2.9","hispanicOrLatino":"16.0"}},"wageData":{"2019":{"workers":"44","median":"-","maleWorkers":"44","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Construction and extraction occupations":{"ageData":{"2019":{"total":"8,325","16to19":"171","20to24":"745","25to34":"1,967","35to44":"2,157","45to54":"1,705","55to64":"1,258","65+":"321","medianAge":"1,258"}},"title":"Construction and extraction occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2019":{"total":"8,325","women":"3.5","white":"87.1","black":"7.3","asian":"1.6","hispanicOrLatino":"36.4"}},"wageData":{"2019":{"workers":"6,467","median":"866","maleWorkers":"6,280","maleMedian":"873","femaleWorkers":"187","femaleMedian":"711"}}},"First-line supervisors of construction trades and extraction workers":{"ageData":{"2019":{"total":"682","16to19":"3","20to24":"22","25to34":"126","35to44":"197","45to54":"178","55to64":"121","65+":"35","medianAge":"121"}},"title":"First-line supervisors of construction trades and extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"682","women":"3.4","white":"88.0","black":"7.5","asian":"1.2","hispanicOrLatino":"24.8"}},"wageData":{"2019":{"workers":"586","median":"1,162","maleWorkers":"571","maleMedian":"1,167","femaleWorkers":"15","femaleMedian":"-"}}},"Boilermakers":{"ageData":{"2019":{"total":"24","16to19":"0","20to24":"2","25to34":"5","35to44":"9","45to54":"5","55to64":"3","65+":"0","medianAge":"3"}},"title":"Boilermakers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"24","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"26","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Brickmasons, blockmasons, and stonemasons":{"ageData":{"2019":{"total":"152","16to19":"1","20to24":"12","25to34":"31","35to44":"35","45to54":"44","55to64":"20","65+":"9","medianAge":"20"}},"title":"Brickmasons, blockmasons, and stonemasons","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"152","women":"0.7","white":"91.6","black":"5.2","asian":"1.2","hispanicOrLatino":"37.7"}},"wageData":{"2019":{"workers":"115","median":"817","maleWorkers":"114","maleMedian":"819","femaleWorkers":"1","femaleMedian":"-"}}},"Carpenters":{"ageData":{"2019":{"total":"1,292","16to19":"21","20to24":"104","25to34":"285","35to44":"363","45to54":"256","55to64":"207","65+":"55","medianAge":"207"}},"title":"Carpenters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"1,292","women":"2.8","white":"89.1","black":"5.1","asian":"1.5","hispanicOrLatino":"37.3"}},"wageData":{"2019":{"workers":"873","median":"820","maleWorkers":"855","maleMedian":"826","femaleWorkers":"18","femaleMedian":"-"}}},"Carpet, floor, and tile installers and finishers":{"ageData":{"2019":{"total":"170","16to19":"4","20to24":"11","25to34":"49","35to44":"47","45to54":"35","55to64":"17","65+":"7","medianAge":"17"}},"title":"Carpet, floor, and tile installers and finishers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"170","women":"1.9","white":"90.8","black":"5.1","asian":"0.5","hispanicOrLatino":"59.7"}},"wageData":{"2019":{"workers":"118","median":"708","maleWorkers":"115","maleMedian":"709","femaleWorkers":"3","femaleMedian":"-"}}},"Cement masons, concrete finishers, and terrazzo workers":{"ageData":{"2019":{"total":"65","16to19":"1","20to24":"7","25to34":"17","35to44":"19","45to54":"12","55to64":"7","65+":"2","medianAge":"7"}},"title":"Cement masons, concrete finishers, and terrazzo workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"65","women":"3.0","white":"89.5","black":"4.4","asian":"1.1","hispanicOrLatino":"53.5"}},"wageData":{"2019":{"workers":"60","median":"975","maleWorkers":"60","maleMedian":"975","femaleWorkers":"0","femaleMedian":"-"}}},"Construction laborers":{"ageData":{"2019":{"total":"2,051","16to19":"74","20to24":"243","25to34":"484","35to44":"535","45to54":"386","55to64":"265","65+":"65","medianAge":"265"}},"title":"Construction laborers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"2,051","women":"3.5","white":"85.3","black":"8.6","asian":"1.6","hispanicOrLatino":"46.7"}},"wageData":{"2019":{"workers":"1,434","median":"723","maleWorkers":"1,393","maleMedian":"724","femaleWorkers":"41","femaleMedian":"-"}}},"Paving, surfacing, and tamping equipment operators":{"ageData":{"2019":{"total":"22","16to19":"0","20to24":"3","25to34":"7","35to44":"2","45to54":"5","55to64":"5","65+":"1","medianAge":"5"}},"title":"Paving, surfacing, and tamping equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"22","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"20","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Pile-driver operators":{"ageData":{"2019":{"total":"1","16to19":"0","20to24":"1","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Pile-driver operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"1","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Operating engineers and other construction equipment operators":{"ageData":{"2019":{"total":"375","16to19":"7","20to24":"29","25to34":"77","35to44":"90","45to54":"86","55to64":"67","65+":"19","medianAge":"67"}},"title":"Operating engineers and other construction equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"375","women":"1.7","white":"85.1","black":"8.9","asian":"0.9","hispanicOrLatino":"14.9"}},"wageData":{"2019":{"workers":"354","median":"930","maleWorkers":"350","maleMedian":"927","femaleWorkers":"5","femaleMedian":"-"}}},"Drywall installers, ceiling tile installers, and tapers":{"ageData":{"2019":{"total":"178","16to19":"4","20to24":"15","25to34":"44","35to44":"50","45to54":"37","55to64":"23","65+":"5","medianAge":"23"}},"title":"Drywall installers, ceiling tile installers, and tapers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"178","women":"0.7","white":"91.1","black":"2.5","asian":"1.7","hispanicOrLatino":"67.7"}},"wageData":{"2019":{"workers":"131","median":"790","maleWorkers":"131","maleMedian":"790","femaleWorkers":"0","femaleMedian":"-"}}},"Electricians":{"ageData":{"2019":{"total":"914","16to19":"17","20to24":"95","25to34":"210","35to44":"217","45to54":"192","55to64":"149","65+":"34","medianAge":"149"}},"title":"Electricians","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"914","women":"2.2","white":"87.4","black":"6.8","asian":"2.6","hispanicOrLatino":"21.1"}},"wageData":{"2019":{"workers":"814","median":"1,012","maleWorkers":"799","maleMedian":"1,015","femaleWorkers":"15","femaleMedian":"-"}}},"Glaziers":{"ageData":{"2019":{"total":"38","16to19":"0","20to24":"3","25to34":"10","35to44":"8","45to54":"13","55to64":"5","65+":"0","medianAge":"5"}},"title":"Glaziers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"38","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"35","median":"-","maleWorkers":"32","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Insulation workers":{"ageData":{"2019":{"total":"59","16to19":"0","20to24":"7","25to34":"14","35to44":"21","45to54":"9","55to64":"6","65+":"2","medianAge":"6"}},"title":"Insulation workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"59","women":"3.7","white":"91.8","black":"5.9","asian":"1.4","hispanicOrLatino":"43.3"}},"wageData":{"2019":{"workers":"56","median":"877","maleWorkers":"54","maleMedian":"885","femaleWorkers":"2","femaleMedian":"-"}}},"Painters, construction and maintenance":{"ageData":{"2019":{"total":"599","16to19":"8","20to24":"35","25to34":"136","35to44":"166","45to54":"133","55to64":"95","65+":"25","medianAge":"95"}},"title":"Painters, construction and maintenance","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"599","women":"8.9","white":"87.4","black":"8.1","asian":"0.6","hispanicOrLatino":"55.5"}},"wageData":{"2019":{"workers":"395","median":"732","maleWorkers":"364","maleMedian":"744","femaleWorkers":"31","femaleMedian":"-"}}},"Paperhangers":{"ageData":{"2019":{"total":"7","16to19":"0","20to24":"0","25to34":"3","35to44":"2","45to54":"0","55to64":"2","65+":"0","medianAge":"2"}},"title":"Paperhangers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"7","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Pipelayers, plumbers, pipefitters, and steamfitters":{"ageData":{"2019":{"total":"637","16to19":"8","20to24":"49","25to34":"165","35to44":"171","45to54":"114","55to64":"104","65+":"26","medianAge":"104"}},"title":"Pipelayers, plumbers, pipefitters, and steamfitters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"637","women":"2.7","white":"87.1","black":"8.4","asian":"0.9","hispanicOrLatino":"27.1"}},"wageData":{"2019":{"workers":"561","median":"921","maleWorkers":"546","maleMedian":"918","femaleWorkers":"15","femaleMedian":"-"}}},"Plasterers and stucco masons":{"ageData":{"2019":{"total":"23","16to19":"0","20to24":"1","25to34":"8","35to44":"6","45to54":"2","55to64":"5","65+":"0","medianAge":"5"}},"title":"Plasterers and stucco masons","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"23","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"15","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Reinforcing iron and rebar workers":{"ageData":{"2019":{"total":"6","16to19":"1","20to24":"2","25to34":"1","35to44":"2","45to54":"0","55to64":"0","65+":"1","medianAge":"0"}},"title":"Reinforcing iron and rebar workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"6","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Roofers":{"ageData":{"2019":{"total":"222","16to19":"3","20to24":"27","25to34":"82","35to44":"47","45to54":"38","55to64":"19","65+":"5","medianAge":"19"}},"title":"Roofers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"222","women":"1.9","white":"87.7","black":"5.2","asian":"0.7","hispanicOrLatino":"50.7"}},"wageData":{"2019":{"workers":"156","median":"687","maleWorkers":"154","maleMedian":"690","femaleWorkers":"2","femaleMedian":"-"}}},"Sheet metal workers":{"ageData":{"2019":{"total":"140","16to19":"4","20to24":"8","25to34":"31","35to44":"37","45to54":"35","55to64":"22","65+":"4","medianAge":"22"}},"title":"Sheet metal workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"140","women":"6.8","white":"89.1","black":"6.7","asian":"2.3","hispanicOrLatino":"28.9"}},"wageData":{"2019":{"workers":"124","median":"894","maleWorkers":"117","maleMedian":"900","femaleWorkers":"6","femaleMedian":"-"}}},"Structural iron and steel workers":{"ageData":{"2019":{"total":"66","16to19":"2","20to24":"4","25to34":"19","35to44":"19","45to54":"12","55to64":"8","65+":"1","medianAge":"8"}},"title":"Structural iron and steel workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"66","women":"0.9","white":"75.7","black":"11.7","asian":"7.8","hispanicOrLatino":"18.7"}},"wageData":{"2019":{"workers":"71","median":"1,057","maleWorkers":"71","maleMedian":"1,057","femaleWorkers":"0","femaleMedian":"-"}}},"Solar photovoltaic installers":{"ageData":{"2019":{"total":"18","16to19":"0","20to24":"4","25to34":"10","35to44":"2","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Solar photovoltaic installers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"18","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"16","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Helpers, construction trades":{"ageData":{"2019":{"total":"50","16to19":"6","20to24":"10","25to34":"16","35to44":"7","45to54":"5","55to64":"5","65+":"1","medianAge":"5"}},"title":"Helpers, construction trades","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"50","women":"5.7","white":"86.6","black":"3.4","asian":"4.5","hispanicOrLatino":"35.2"}},"wageData":{"2019":{"workers":"51","median":"612","maleWorkers":"48","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Construction and building inspectors":{"ageData":{"2019":{"total":"105","16to19":"2","20to24":"5","25to34":"12","35to44":"16","45to54":"28","55to64":"32","65+":"10","medianAge":"32"}},"title":"Construction and building inspectors","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"105","women":"10.4","white":"82.0","black":"8.3","asian":"6.8","hispanicOrLatino":"12.8"}},"wageData":{"2019":{"workers":"77","median":"1,134","maleWorkers":"70","maleMedian":"1,134","femaleWorkers":"7","femaleMedian":"-"}}},"Elevator installers and repairers":{"ageData":{"2019":{"total":"20","16to19":"0","20to24":"3","25to34":"2","35to44":"5","45to54":"3","55to64":"6","65+":"0","medianAge":"6"}},"title":"Elevator installers and repairers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"20","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"19","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Fence erectors":{"ageData":{"2019":{"total":"41","16to19":"1","20to24":"5","25to34":"17","35to44":"7","45to54":"8","55to64":"3","65+":"0","medianAge":"3"}},"title":"Fence erectors","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"41","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"26","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Hazardous materials removal workers":{"ageData":{"2019":{"total":"40","16to19":"0","20to24":"3","25to34":"8","35to44":"8","45to54":"9","55to64":"9","65+":"1","medianAge":"9"}},"title":"Hazardous materials removal workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"40","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"36","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Highway maintenance workers":{"ageData":{"2019":{"total":"113","16to19":"3","20to24":"12","25to34":"23","35to44":"15","45to54":"29","55to64":"24","65+":"7","medianAge":"24"}},"title":"Highway maintenance workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"113","women":"3.6","white":"83.6","black":"12.7","asian":"0.4","hispanicOrLatino":"13.3"}},"wageData":{"2019":{"workers":"96","median":"799","maleWorkers":"91","maleMedian":"806","femaleWorkers":"5","femaleMedian":"-"}}},"Rail-track laying and maintenance equipment operators":{"ageData":{"2019":{"total":"4","16to19":"0","20to24":"1","25to34":"2","35to44":"0","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Rail-track laying and maintenance equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"4","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Septic tank servicers and sewer pipe cleaners":{"ageData":{"2019":{"total":"8","16to19":"0","20to24":"0","25to34":"1","35to44":"3","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Septic tank servicers and sewer pipe cleaners","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"8","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Miscellaneous construction and related workers":{"ageData":{"2019":{"total":"32","16to19":"0","20to24":"8","25to34":"7","35to44":"6","45to54":"5","55to64":"3","65+":"2","medianAge":"3"}},"title":"Miscellaneous construction and related workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"32","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"26","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Derrick, rotary drill, and service unit operators, oil, gas, and mining":{"ageData":{"2019":{"total":"29","16to19":"0","20to24":"2","25to34":"14","35to44":"8","45to54":"3","55to64":"2","65+":"0","medianAge":"2"}},"title":"Derrick, rotary drill, and service unit operators, oil, gas, and mining","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"29","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"24","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Earth drillers, except oil and gas":{"ageData":{"2019":{"total":"22","16to19":"0","20to24":"1","25to34":"8","35to44":"7","45to54":"3","55to64":"2","65+":"0","medianAge":"2"}},"title":"Earth drillers, except oil and gas","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"22","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"15","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Explosives workers, ordnance handling experts, and blasters":{"ageData":{"2019":{"total":"8","16to19":"0","20to24":"0","25to34":"3","35to44":"3","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Explosives workers, ordnance handling experts, and blasters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"8","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"8","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Mining machine operators":{"ageData":{"2019":{"total":"56","16to19":"0","20to24":"4","25to34":"18","35to44":"13","45to54":"9","55to64":"10","65+":"1","medianAge":"10"}},"title":"Mining machine operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"56","women":"2.0","white":"85.2","black":"9.3","asian":"0.0","hispanicOrLatino":"13.1"}},"wageData":{"2019":{"workers":"51","median":"1,094","maleWorkers":"50","maleMedian":"1,101","femaleWorkers":"1","femaleMedian":"-"}}},"Roof bolters, mining":{"ageData":{"2019":{"total":"1","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Roof bolters, mining","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"1","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Roustabouts, oil and gas":{"ageData":{"2019":{"total":"8","16to19":"0","20to24":"1","25to34":"4","35to44":"1","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Roustabouts, oil and gas","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"8","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers--extraction workers":{"ageData":{"2019":{"total":"2","16to19":"0","20to24":"0","25to34":"2","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Helpers--extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"2","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Other extraction workers":{"ageData":{"2019":{"total":"46","16to19":"0","20to24":"5","25to34":"17","35to44":"11","45to54":"6","55to64":"6","65+":"0","medianAge":"6"}},"title":"Other extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2019":{"total":"46","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"51","median":"1,128","maleWorkers":"45","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Installation, maintenance, and repair occupations":{"ageData":{"2019":{"total":"4,862","16to19":"90","20to24":"440","25to34":"1,096","35to44":"1,075","45to54":"1,046","55to64":"903","65+":"212","medianAge":"903"}},"title":"Installation, maintenance, and repair occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2019":{"total":"4,862","women":"3.9","white":"84.0","black":"9.1","asian":"3.3","hispanicOrLatino":"20.3"}},"wageData":{"2019":{"workers":"4,304","median":"939","maleWorkers":"4,164","maleMedian":"943","femaleWorkers":"140","femaleMedian":"850"}}},"First-line supervisors of mechanics, installers, and repairers":{"ageData":{"2019":{"total":"272","16to19":"0","20to24":"4","25to34":"46","35to44":"67","45to54":"71","55to64":"68","65+":"16","medianAge":"68"}},"title":"First-line supervisors of mechanics, installers, and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"272","women":"8.2","white":"85.7","black":"9.9","asian":"1.5","hispanicOrLatino":"16.1"}},"wageData":{"2019":{"workers":"267","median":"1,061","maleWorkers":"250","maleMedian":"1,082","femaleWorkers":"17","femaleMedian":"-"}}},"Computer, automated teller, and office machine repairers":{"ageData":{"2019":{"total":"184","16to19":"2","20to24":"20","25to34":"50","35to44":"33","45to54":"43","55to64":"28","65+":"7","medianAge":"28"}},"title":"Computer, automated teller, and office machine repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"184","women":"14.0","white":"74.7","black":"11.7","asian":"9.3","hispanicOrLatino":"15.9"}},"wageData":{"2019":{"workers":"162","median":"897","maleWorkers":"141","maleMedian":"899","femaleWorkers":"21","femaleMedian":"-"}}},"Radio and telecommunications equipment installers and repairers":{"ageData":{"2019":{"total":"131","16to19":"3","20to24":"13","25to34":"27","35to44":"30","45to54":"31","55to64":"22","65+":"5","medianAge":"22"}},"title":"Radio and telecommunications equipment installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"131","women":"7.6","white":"73.1","black":"15.8","asian":"4.9","hispanicOrLatino":"15.0"}},"wageData":{"2019":{"workers":"124","median":"1,063","maleWorkers":"117","maleMedian":"1,058","femaleWorkers":"7","femaleMedian":"-"}}},"Avionics technicians":{"ageData":{"2019":{"total":"13","16to19":"0","20to24":"1","25to34":"1","35to44":"4","45to54":"3","55to64":"5","65+":"0","medianAge":"5"}},"title":"Avionics technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"13","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"16","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Electric motor, power tool, and related repairers":{"ageData":{"2019":{"total":"16","16to19":"1","20to24":"1","25to34":"3","35to44":"2","45to54":"2","55to64":"5","65+":"1","medianAge":"5"}},"title":"Electric motor, power tool, and related repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"16","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"12","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electrical and electronics installers and repairers, transportation equipment":{"ageData":{"2019":{"total":"7","16to19":"0","20to24":"0","25to34":"1","35to44":"2","45to54":"1","55to64":"3","65+":"0","medianAge":"3"}},"title":"Electrical and electronics installers and repairers, transportation equipment","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"7","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"8","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Electrical and electronics repairers, industrial and utility":{"ageData":{"2019":{"total":"17","16to19":"0","20to24":"0","25to34":"6","35to44":"2","45to54":"6","55to64":"3","65+":"0","medianAge":"3"}},"title":"Electrical and electronics repairers, industrial and utility","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"17","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"22","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electronic equipment installers and repairers, motor vehicles":{"ageData":{"2019":{"total":"9","16to19":"0","20to24":"0","25to34":"3","35to44":"0","45to54":"3","55to64":"1","65+":"1","medianAge":"1"}},"title":"Electronic equipment installers and repairers, motor vehicles","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"9","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electronic home entertainment equipment installers and repairers":{"ageData":{"2019":{"total":"32","16to19":"1","20to24":"3","25to34":"12","35to44":"8","45to54":"5","55to64":"3","65+":"1","medianAge":"3"}},"title":"Electronic home entertainment equipment installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"32","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"25","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Security and fire alarm systems installers":{"ageData":{"2019":{"total":"58","16to19":"1","20to24":"6","25to34":"12","35to44":"17","45to54":"15","55to64":"7","65+":"1","medianAge":"7"}},"title":"Security and fire alarm systems installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"58","women":"2.9","white":"76.9","black":"14.3","asian":"4.6","hispanicOrLatino":"23.5"}},"wageData":{"2019":{"workers":"55","median":"869","maleWorkers":"54","maleMedian":"875","femaleWorkers":"1","femaleMedian":"-"}}},"Aircraft mechanics and service technicians":{"ageData":{"2019":{"total":"152","16to19":"1","20to24":"11","25to34":"25","35to44":"32","45to54":"41","55to64":"32","65+":"10","medianAge":"32"}},"title":"Aircraft mechanics and service technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"152","women":"4.8","white":"82.4","black":"10.5","asian":"4.8","hispanicOrLatino":"12.4"}},"wageData":{"2019":{"workers":"155","median":"1,245","maleWorkers":"148","maleMedian":"1,265","femaleWorkers":"7","femaleMedian":"-"}}},"Automotive body and related repairers":{"ageData":{"2019":{"total":"125","16to19":"1","20to24":"7","25to34":"31","35to44":"30","45to54":"27","55to64":"25","65+":"5","medianAge":"25"}},"title":"Automotive body and related repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"125","women":"2.2","white":"92.4","black":"3.4","asian":"1.8","hispanicOrLatino":"29.6"}},"wageData":{"2019":{"workers":"94","median":"885","maleWorkers":"94","maleMedian":"885","femaleWorkers":"0","femaleMedian":"-"}}},"Automotive glass installers and repairers":{"ageData":{"2019":{"total":"21","16to19":"1","20to24":"4","25to34":"4","35to44":"4","45to54":"5","55to64":"2","65+":"1","medianAge":"2"}},"title":"Automotive glass installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"21","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"15","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Automotive service technicians and mechanics":{"ageData":{"2019":{"total":"880","16to19":"22","20to24":"120","25to34":"223","35to44":"184","45to54":"176","55to64":"133","65+":"22","medianAge":"133"}},"title":"Automotive service technicians and mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"880","women":"1.9","white":"83.8","black":"8.7","asian":"3.2","hispanicOrLatino":"27.7"}},"wageData":{"2019":{"workers":"705","median":"811","maleWorkers":"693","maleMedian":"811","femaleWorkers":"12","femaleMedian":"-"}}},"Bus and truck mechanics and diesel engine specialists":{"ageData":{"2019":{"total":"347","16to19":"5","20to24":"42","25to34":"83","35to44":"79","45to54":"65","55to64":"62","65+":"11","medianAge":"62"}},"title":"Bus and truck mechanics and diesel engine specialists","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"347","women":"1.5","white":"87.3","black":"6.5","asian":"3.7","hispanicOrLatino":"14.1"}},"wageData":{"2019":{"workers":"315","median":"984","maleWorkers":"312","maleMedian":"983","femaleWorkers":"3","femaleMedian":"-"}}},"Heavy vehicle and mobile equipment service technicians and mechanics":{"ageData":{"2019":{"total":"211","16to19":"2","20to24":"21","25to34":"50","35to44":"38","45to54":"46","55to64":"46","65+":"8","medianAge":"46"}},"title":"Heavy vehicle and mobile equipment service technicians and mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"211","women":"1.5","white":"88.3","black":"6.0","asian":"2.6","hispanicOrLatino":"15.8"}},"wageData":{"2019":{"workers":"212","median":"1,008","maleWorkers":"212","maleMedian":"1,008","femaleWorkers":"0","femaleMedian":"-"}}},"Small engine mechanics":{"ageData":{"2019":{"total":"45","16to19":"3","20to24":"4","25to34":"10","35to44":"11","45to54":"5","55to64":"8","65+":"5","medianAge":"8"}},"title":"Small engine mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"45","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"24","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Miscellaneous vehicle and mobile equipment mechanics, installers, and repairers":{"ageData":{"2019":{"total":"73","16to19":"6","20to24":"14","25to34":"18","35to44":"14","45to54":"10","55to64":"11","65+":"1","medianAge":"11"}},"title":"Miscellaneous vehicle and mobile equipment mechanics, installers, and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"73","women":"1.3","white":"77.0","black":"12.2","asian":"3.6","hispanicOrLatino":"31.0"}},"wageData":{"2019":{"workers":"58","median":"627","maleWorkers":"58","maleMedian":"628","femaleWorkers":"0","femaleMedian":"-"}}},"Control and valve installers and repairers":{"ageData":{"2019":{"total":"22","16to19":"0","20to24":"1","25to34":"4","35to44":"7","45to54":"4","55to64":"5","65+":"1","medianAge":"5"}},"title":"Control and valve installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"22","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"22","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Heating, air conditioning, and refrigeration mechanics and installers":{"ageData":{"2019":{"total":"466","16to19":"13","20to24":"44","25to34":"121","35to44":"104","45to54":"97","55to64":"68","65+":"19","medianAge":"68"}},"title":"Heating, air conditioning, and refrigeration mechanics and installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"466","women":"1.5","white":"84.0","black":"9.1","asian":"3.0","hispanicOrLatino":"20.2"}},"wageData":{"2019":{"workers":"416","median":"944","maleWorkers":"409","maleMedian":"947","femaleWorkers":"6","femaleMedian":"-"}}},"Home appliance repairers":{"ageData":{"2019":{"total":"51","16to19":"1","20to24":"3","25to34":"11","35to44":"8","45to54":"16","55to64":"7","65+":"5","medianAge":"7"}},"title":"Home appliance repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"51","women":"5.7","white":"86.3","black":"11.7","asian":"1.8","hispanicOrLatino":"18.8"}},"wageData":{"2019":{"workers":"32","median":"-","maleWorkers":"31","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Industrial and refractory machinery mechanics":{"ageData":{"2019":{"total":"408","16to19":"4","20to24":"24","25to34":"71","35to44":"100","45to54":"95","55to64":"99","65+":"14","medianAge":"99"}},"title":"Industrial and refractory machinery mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"408","women":"4.1","white":"85.6","black":"8.7","asian":"2.5","hispanicOrLatino":"18.1"}},"wageData":{"2019":{"workers":"392","median":"1,018","maleWorkers":"382","maleMedian":"1,028","femaleWorkers":"10","femaleMedian":"-"}}},"Maintenance and repair workers, general":{"ageData":{"2019":{"total":"579","16to19":"8","20to24":"32","25to34":"102","35to44":"123","45to54":"141","55to64":"134","65+":"40","medianAge":"134"}},"title":"Maintenance and repair workers, general","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"579","women":"3.8","white":"83.9","black":"9.4","asian":"3.2","hispanicOrLatino":"20.1"}},"wageData":{"2019":{"workers":"534","median":"882","maleWorkers":"514","maleMedian":"883","femaleWorkers":"20","femaleMedian":"-"}}},"Maintenance workers, machinery":{"ageData":{"2019":{"total":"21","16to19":"0","20to24":"0","25to34":"6","35to44":"4","45to54":"5","55to64":"4","65+":"2","medianAge":"4"}},"title":"Maintenance workers, machinery","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"21","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"21","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Millwrights":{"ageData":{"2019":{"total":"52","16to19":"0","20to24":"3","25to34":"9","35to44":"13","45to54":"11","55to64":"12","65+":"3","medianAge":"12"}},"title":"Millwrights","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"52","women":"5.0","white":"88.9","black":"7.9","asian":"1.8","hispanicOrLatino":"10.3"}},"wageData":{"2019":{"workers":"51","median":"1,180","maleWorkers":"48","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Electrical power-line installers and repairers":{"ageData":{"2019":{"total":"133","16to19":"1","20to24":"18","25to34":"40","35to44":"39","45to54":"23","55to64":"13","65+":"1","medianAge":"13"}},"title":"Electrical power-line installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"133","women":"1.6","white":"89.8","black":"3.0","asian":"0.6","hispanicOrLatino":"15.4"}},"wageData":{"2019":{"workers":"123","median":"1,460","maleWorkers":"123","maleMedian":"1,460","femaleWorkers":"0","femaleMedian":"-"}}},"Telecommunications line installers and repairers":{"ageData":{"2019":{"total":"184","16to19":"5","20to24":"12","25to34":"53","35to44":"52","45to54":"43","55to64":"16","65+":"2","medianAge":"16"}},"title":"Telecommunications line installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"184","women":"4.5","white":"82.2","black":"12.5","asian":"2.3","hispanicOrLatino":"24.7"}},"wageData":{"2019":{"workers":"178","median":"901","maleWorkers":"168","maleMedian":"884","femaleWorkers":"10","femaleMedian":"-"}}},"Precision instrument and equipment repairers":{"ageData":{"2019":{"total":"69","16to19":"1","20to24":"5","25to34":"9","35to44":"12","45to54":"12","55to64":"20","65+":"9","medianAge":"20"}},"title":"Precision instrument and equipment repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"69","women":"11.6","white":"73.7","black":"11.9","asian":"12.6","hispanicOrLatino":"11.4"}},"wageData":{"2019":{"workers":"48","median":"-","maleWorkers":"42","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Wind turbine service technicians":{"ageData":{"2019":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Wind turbine service technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"2","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Coin, vending, and amusement machine servicers and repairers":{"ageData":{"2019":{"total":"28","16to19":"0","20to24":"3","25to34":"3","35to44":"7","45to54":"3","55to64":"8","65+":"3","medianAge":"8"}},"title":"Coin, vending, and amusement machine servicers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"28","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"20","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Commercial divers":{"ageData":{"2019":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Commercial divers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"2","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Locksmiths and safe repairers":{"ageData":{"2019":{"total":"32","16to19":"0","20to24":"0","25to34":"11","35to44":"6","45to54":"5","55to64":"7","65+":"2","medianAge":"7"}},"title":"Locksmiths and safe repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"32","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"21","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Manufactured building and mobile home installers":{"ageData":{"2019":{"total":"5","16to19":"0","20to24":"0","25to34":"4","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Manufactured building and mobile home installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Riggers":{"ageData":{"2019":{"total":"12","16to19":"0","20to24":"0","25to34":"5","35to44":"3","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Riggers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"12","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"13","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Signal and track switch repairers":{"ageData":{"2019":{"total":"7","16to19":"0","20to24":"0","25to34":"2","35to44":"2","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Signal and track switch repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"7","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers--installation, maintenance, and repair workers":{"ageData":{"2019":{"total":"19","16to19":"3","20to24":"4","25to34":"4","35to44":"4","45to54":"1","55to64":"1","65+":"2","medianAge":"1"}},"title":"Helpers--installation, maintenance, and repair workers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"19","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"17","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Other installation, maintenance, and repair workers":{"ageData":{"2019":{"total":"179","16to19":"5","20to24":"21","25to34":"36","35to44":"34","45to54":"30","55to64":"41","65+":"13","medianAge":"41"}},"title":"Other installation, maintenance, and repair workers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2019":{"total":"179","women":"8.0","white":"88.4","black":"8.1","asian":"0.9","hispanicOrLatino":"27.1"}},"wageData":{"2019":{"workers":"128","median":"839","maleWorkers":"118","maleMedian":"850","femaleWorkers":"10","femaleMedian":"-"}}},"Production, transportation, and material moving occupations":{"ageData":{"2019":{"total":"18,628","16to19":"543","20to24":"1,808","25to34":"4,027","35to44":"3,644","45to54":"3,950","55to64":"3,542","65+":"1,115","medianAge":"3,542"}},"title":"Production, transportation, and material moving occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2019":{"total":"18,628","women":"23.0","white":"74.2","black":"16.9","asian":"5.0","hispanicOrLatino":"23.0"}},"wageData":{"2019":{"workers":"15,353","median":"727","maleWorkers":"12,020","maleMedian":"780","femaleWorkers":"3,334","femaleMedian":"593"}}},"Production occupations":{"ageData":{"2019":{"total":"8,565","16to19":"170","20to24":"775","25to34":"1,897","35to44":"1,778","45to54":"1,841","55to64":"1,705","65+":"399","medianAge":"1,705"}},"title":"Production occupations","depth":2,"parent":"Production, transportation, and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"8,565","women":"28.6","white":"76.6","black":"13.3","asian":"6.0","hispanicOrLatino":"23.1"}},"wageData":{"2019":{"workers":"7,741","median":"745","maleWorkers":"5,668","maleMedian":"814","femaleWorkers":"2,073","femaleMedian":"596"}}},"First-line supervisors of production and operating workers":{"ageData":{"2019":{"total":"844","16to19":"1","20to24":"20","25to34":"173","35to44":"209","45to54":"227","55to64":"186","65+":"28","medianAge":"186"}},"title":"First-line supervisors of production and operating workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"844","women":"21.3","white":"80.3","black":"12.2","asian":"3.8","hispanicOrLatino":"17.2"}},"wageData":{"2019":{"workers":"806","median":"949","maleWorkers":"633","maleMedian":"1,031","femaleWorkers":"173","femaleMedian":"721"}}},"Aircraft structure, surfaces, rigging, and systems assemblers":{"ageData":{"2019":{"total":"8","16to19":"0","20to24":"0","25to34":"3","35to44":"0","45to54":"2","55to64":"1","65+":"2","medianAge":"1"}},"title":"Aircraft structure, surfaces, rigging, and systems assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"8","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"9","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Electrical, electronics, and electromechanical assemblers":{"ageData":{"2019":{"total":"101","16to19":"3","20to24":"9","25to34":"19","35to44":"19","45to54":"24","55to64":"22","65+":"4","medianAge":"22"}},"title":"Electrical, electronics, and electromechanical assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"101","women":"50.4","white":"64.5","black":"8.0","asian":"20.2","hispanicOrLatino":"20.1"}},"wageData":{"2019":{"workers":"103","median":"644","maleWorkers":"52","maleMedian":"712","femaleWorkers":"51","femaleMedian":"594"}}},"Engine and other machine assemblers":{"ageData":{"2019":{"total":"9","16to19":"0","20to24":"1","25to34":"3","35to44":"2","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Engine and other machine assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"9","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"8","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Structural metal fabricators and fitters":{"ageData":{"2019":{"total":"25","16to19":"1","20to24":"3","25to34":"9","35to44":"7","45to54":"2","55to64":"3","65+":"0","medianAge":"3"}},"title":"Structural metal fabricators and fitters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"25","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"24","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Miscellaneous assemblers and fabricators":{"ageData":{"2019":{"total":"1,001","16to19":"30","20to24":"120","25to34":"240","35to44":"201","45to54":"190","55to64":"181","65+":"39","medianAge":"181"}},"title":"Miscellaneous assemblers and fabricators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"1,001","women":"36.4","white":"67.0","black":"19.7","asian":"9.6","hispanicOrLatino":"21.7"}},"wageData":{"2019":{"workers":"900","median":"684","maleWorkers":"574","maleMedian":"724","femaleWorkers":"326","femaleMedian":"597"}}},"Bakers":{"ageData":{"2019":{"total":"228","16to19":"7","20to24":"22","25to34":"53","35to44":"46","45to54":"42","55to64":"46","65+":"12","medianAge":"46"}},"title":"Bakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"228","women":"60.4","white":"74.0","black":"11.7","asian":"9.6","hispanicOrLatino":"30.7"}},"wageData":{"2019":{"workers":"151","median":"561","maleWorkers":"70","maleMedian":"590","femaleWorkers":"81","femaleMedian":"522"}}},"Butchers and other meat, poultry, and fish processing workers":{"ageData":{"2019":{"total":"297","16to19":"5","20to24":"32","25to34":"62","35to44":"70","45to54":"68","55to64":"43","65+":"16","medianAge":"43"}},"title":"Butchers and other meat, poultry, and fish processing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"297","women":"26.9","white":"71.2","black":"17.1","asian":"6.2","hispanicOrLatino":"37.3"}},"wageData":{"2019":{"workers":"265","median":"648","maleWorkers":"198","maleMedian":"671","femaleWorkers":"67","femaleMedian":"573"}}},"Food and tobacco roasting, baking, and drying machine operators and tenders":{"ageData":{"2019":{"total":"17","16to19":"0","20to24":"0","25to34":"4","35to44":"3","45to54":"4","55to64":"3","65+":"2","medianAge":"3"}},"title":"Food and tobacco roasting, baking, and drying machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"17","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"13","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Food batchmakers":{"ageData":{"2019":{"total":"82","16to19":"3","20to24":"5","25to34":"23","35to44":"14","45to54":"19","55to64":"13","65+":"5","medianAge":"13"}},"title":"Food batchmakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"82","women":"62.7","white":"87.9","black":"7.3","asian":"1.6","hispanicOrLatino":"36.2"}},"wageData":{"2019":{"workers":"68","median":"615","maleWorkers":"26","maleMedian":"-","femaleWorkers":"42","femaleMedian":"-"}}},"Food cooking machine operators and tenders":{"ageData":{"2019":{"total":"3","16to19":"1","20to24":"0","25to34":"1","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Food cooking machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"3","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"2","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Food processing workers, all other":{"ageData":{"2019":{"total":"147","16to19":"2","20to24":"16","25to34":"31","35to44":"40","45to54":"28","55to64":"26","65+":"4","medianAge":"26"}},"title":"Food processing workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"147","women":"33.8","white":"72.1","black":"18.1","asian":"7.0","hispanicOrLatino":"38.8"}},"wageData":{"2019":{"workers":"144","median":"658","maleWorkers":"94","maleMedian":"779","femaleWorkers":"50","femaleMedian":"573"}}},"Computer control programmers and operators":{"ageData":{"2019":{"total":"108","16to19":"2","20to24":"13","25to34":"36","35to44":"21","45to54":"19","55to64":"14","65+":"3","medianAge":"14"}},"title":"Computer control programmers and operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"108","women":"3.7","white":"87.0","black":"6.6","asian":"5.0","hispanicOrLatino":"11.4"}},"wageData":{"2019":{"workers":"103","median":"849","maleWorkers":"100","maleMedian":"857","femaleWorkers":"3","femaleMedian":"-"}}},"Extruding and drawing machine setters, operators, and tenders, metal and plastic":{"ageData":{"2019":{"total":"13","16to19":"0","20to24":"0","25to34":"3","35to44":"3","45to54":"4","55to64":"1","65+":"0","medianAge":"1"}},"title":"Extruding and drawing machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"13","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"16","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Forging machine setters, operators, and tenders, metal and plastic":{"ageData":{"2019":{"total":"7","16to19":"0","20to24":"0","25to34":"0","35to44":"3","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Forging machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"7","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"9","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Rolling machine setters, operators, and tenders, metal and plastic":{"ageData":{"2019":{"total":"13","16to19":"0","20to24":"1","25to34":"0","35to44":"4","45to54":"4","55to64":"3","65+":"2","medianAge":"3"}},"title":"Rolling machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"13","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"13","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Cutting, punching, and press machine setters, operators, and tenders, metal and plastic":{"ageData":{"2019":{"total":"70","16to19":"0","20to24":"6","25to34":"15","35to44":"16","45to54":"13","55to64":"16","65+":"4","medianAge":"16"}},"title":"Cutting, punching, and press machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"70","women":"15.8","white":"75.2","black":"17.3","asian":"0.3","hispanicOrLatino":"13.9"}},"wageData":{"2019":{"workers":"67","median":"830","maleWorkers":"58","maleMedian":"816","femaleWorkers":"9","femaleMedian":"-"}}},"Drilling and boring machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2019":{"total":"6","16to19":"0","20to24":"1","25to34":"1","35to44":"3","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Drilling and boring machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"6","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Grinding, lapping, polishing, and buffing machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2019":{"total":"44","16to19":"2","20to24":"1","25to34":"9","35to44":"8","45to54":"10","55to64":"9","65+":"3","medianAge":"9"}},"title":"Grinding, lapping, polishing, and buffing machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"44","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"40","median":"-","maleWorkers":"35","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Lathe and turning machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2019":{"total":"6","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Lathe and turning machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"6","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Milling and planing machine setters, operators, and tenders, metal and plastic":{"ageData":{"2019":{"total":"5","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Milling and planing machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"5","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Machinists":{"ageData":{"2019":{"total":"375","16to19":"7","20to24":"38","25to34":"70","35to44":"61","45to54":"74","55to64":"108","65+":"16","medianAge":"108"}},"title":"Machinists","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"375","women":"5.6","white":"84.8","black":"7.0","asian":"4.9","hispanicOrLatino":"11.5"}},"wageData":{"2019":{"workers":"357","median":"888","maleWorkers":"335","maleMedian":"889","femaleWorkers":"22","femaleMedian":"-"}}},"Metal furnace operators, tenders, pourers, and casters":{"ageData":{"2019":{"total":"23","16to19":"0","20to24":"2","25to34":"4","35to44":"2","45to54":"11","55to64":"3","65+":"0","medianAge":"3"}},"title":"Metal furnace operators, tenders, pourers, and casters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"23","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"26","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Model makers and patternmakers, metal and plastic":{"ageData":{"2019":{"total":"5","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Model makers and patternmakers, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"4","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Molders and molding machine setters, operators, and tenders, metal and plastic":{"ageData":{"2019":{"total":"45","16to19":"1","20to24":"6","25to34":"8","35to44":"4","45to54":"15","55to64":"10","65+":"1","medianAge":"10"}},"title":"Molders and molding machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"45","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"37","median":"-","maleWorkers":"32","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Multiple machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2019":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Multiple machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"2","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Tool and die makers":{"ageData":{"2019":{"total":"55","16to19":"2","20to24":"3","25to34":"11","35to44":"7","45to54":"15","55to64":"14","65+":"4","medianAge":"14"}},"title":"Tool and die makers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"55","women":"4.8","white":"95.1","black":"3.7","asian":"0.3","hispanicOrLatino":"3.4"}},"wageData":{"2019":{"workers":"53","median":"952","maleWorkers":"51","maleMedian":"972","femaleWorkers":"2","femaleMedian":"-"}}},"Welding, soldering, and brazing workers":{"ageData":{"2019":{"total":"592","16to19":"16","20to24":"67","25to34":"164","35to44":"127","45to54":"114","55to64":"91","65+":"13","medianAge":"91"}},"title":"Welding, soldering, and brazing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"592","women":"5.3","white":"85.3","black":"8.8","asian":"2.3","hispanicOrLatino":"22.8"}},"wageData":{"2019":{"workers":"549","median":"801","maleWorkers":"518","maleMedian":"810","femaleWorkers":"31","femaleMedian":"-"}}},"Heat treating equipment setters, operators, and tenders, metal and plastic":{"ageData":{"2019":{"total":"4","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Heat treating equipment setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"4","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Layout workers, metal and plastic":{"ageData":{"2019":{"total":"10","16to19":"0","20to24":"2","25to34":"2","35to44":"2","45to54":"1","55to64":"3","65+":"0","medianAge":"3"}},"title":"Layout workers, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"10","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"8","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Plating and coating machine setters, operators, and tenders, metal and plastic":{"ageData":{"2019":{"total":"13","16to19":"0","20to24":"1","25to34":"3","35to44":"1","45to54":"4","55to64":"3","65+":"0","medianAge":"3"}},"title":"Plating and coating machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"13","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"12","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Tool grinders, filers, and sharpeners":{"ageData":{"2019":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Tool grinders, filers, and sharpeners","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"1","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Metal workers and plastic workers, all other":{"ageData":{"2019":{"total":"392","16to19":"3","20to24":"36","25to34":"85","35to44":"88","45to54":"82","55to64":"79","65+":"17","medianAge":"79"}},"title":"Metal workers and plastic workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"392","women":"19.5","white":"72.0","black":"14.5","asian":"8.2","hispanicOrLatino":"26.0"}},"wageData":{"2019":{"workers":"385","median":"736","maleWorkers":"312","maleMedian":"795","femaleWorkers":"74","femaleMedian":"592"}}},"Prepress technicians and workers":{"ageData":{"2019":{"total":"27","16to19":"0","20to24":"7","25to34":"7","35to44":"2","45to54":"6","55to64":"5","65+":"0","medianAge":"5"}},"title":"Prepress technicians and workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"27","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"27","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Printing press operators":{"ageData":{"2019":{"total":"133","16to19":"2","20to24":"15","25to34":"27","35to44":"22","45to54":"38","55to64":"23","65+":"6","medianAge":"23"}},"title":"Printing press operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"133","women":"22.1","white":"84.3","black":"7.2","asian":"4.0","hispanicOrLatino":"23.1"}},"wageData":{"2019":{"workers":"109","median":"814","maleWorkers":"87","maleMedian":"886","femaleWorkers":"22","femaleMedian":"-"}}},"Print binding and finishing workers":{"ageData":{"2019":{"total":"14","16to19":"0","20to24":"1","25to34":"3","35to44":"1","45to54":"3","55to64":"5","65+":"1","medianAge":"5"}},"title":"Print binding and finishing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"14","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"15","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Laundry and dry-cleaning workers":{"ageData":{"2019":{"total":"134","16to19":"4","20to24":"5","25to34":"21","35to44":"32","45to54":"31","55to64":"36","65+":"6","medianAge":"36"}},"title":"Laundry and dry-cleaning workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"134","women":"75.4","white":"55.9","black":"25.1","asian":"12.2","hispanicOrLatino":"37.9"}},"wageData":{"2019":{"workers":"112","median":"490","maleWorkers":"37","maleMedian":"-","femaleWorkers":"74","femaleMedian":"482"}}},"Pressers, textile, garment, and related materials":{"ageData":{"2019":{"total":"28","16to19":"0","20to24":"2","25to34":"7","35to44":"11","45to54":"5","55to64":"2","65+":"1","medianAge":"2"}},"title":"Pressers, textile, garment, and related materials","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"28","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"19","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"14","femaleMedian":"-"}}},"Sewing machine operators":{"ageData":{"2019":{"total":"179","16to19":"2","20to24":"15","25to34":"14","35to44":"37","45to54":"52","55to64":"44","65+":"15","medianAge":"44"}},"title":"Sewing machine operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"179","women":"72.4","white":"69.3","black":"11.0","asian":"15.3","hispanicOrLatino":"35.4"}},"wageData":{"2019":{"workers":"138","median":"524","maleWorkers":"40","maleMedian":"-","femaleWorkers":"98","femaleMedian":"521"}}},"Shoe and leather workers and repairers":{"ageData":{"2019":{"total":"7","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"2","55to64":"2","65+":"3","medianAge":"2"}},"title":"Shoe and leather workers and repairers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"7","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"6","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Shoe machine operators and tenders":{"ageData":{"2019":{"total":"5","16to19":"0","20to24":"0","25to34":"2","35to44":"2","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Shoe machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"4","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Tailors, dressmakers, and sewers":{"ageData":{"2019":{"total":"86","16to19":"0","20to24":"0","25to34":"11","35to44":"16","45to54":"14","55to64":"25","65+":"21","medianAge":"25"}},"title":"Tailors, dressmakers, and sewers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"86","women":"75.4","white":"66.3","black":"9.5","asian":"23.7","hispanicOrLatino":"20.9"}},"wageData":{"2019":{"workers":"55","median":"576","maleWorkers":"19","maleMedian":"-","femaleWorkers":"36","femaleMedian":"-"}}},"Textile bleaching and dyeing machine operators and tenders":{"ageData":{"2019":{"total":"2","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Textile bleaching and dyeing machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"2","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Textile cutting machine setters, operators, and tenders":{"ageData":{"2019":{"total":"4","16to19":"0","20to24":"0","25to34":"2","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Textile cutting machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"4","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Textile knitting and weaving machine setters, operators, and tenders":{"ageData":{"2019":{"total":"9","16to19":"1","20to24":"0","25to34":"0","35to44":"2","45to54":"2","55to64":"3","65+":"1","medianAge":"3"}},"title":"Textile knitting and weaving machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"9","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"6","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Textile winding, twisting, and drawing out machine setters, operators, and tenders":{"ageData":{"2019":{"total":"10","16to19":"0","20to24":"0","25to34":"2","35to44":"2","45to54":"3","55to64":"4","65+":"0","medianAge":"4"}},"title":"Textile winding, twisting, and drawing out machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"10","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"12","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Extruding and forming machine setters, operators, and tenders, synthetic and glass fibers":{"ageData":{"2019":{"total":"1","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Extruding and forming machine setters, operators, and tenders, synthetic and glass fibers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"1","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Fabric and apparel patternmakers":{"ageData":{"2019":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Fabric and apparel patternmakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"0","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Upholsterers":{"ageData":{"2019":{"total":"30","16to19":"1","20to24":"2","25to34":"2","35to44":"5","45to54":"14","55to64":"6","65+":"1","medianAge":"6"}},"title":"Upholsterers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"30","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"21","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Textile, apparel, and furnishings workers, all other":{"ageData":{"2019":{"total":"13","16to19":"0","20to24":"4","25to34":"2","35to44":"0","45to54":"2","55to64":"3","65+":"1","medianAge":"3"}},"title":"Textile, apparel, and furnishings workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"13","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"10","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Cabinetmakers and bench carpenters":{"ageData":{"2019":{"total":"65","16to19":"1","20to24":"3","25to34":"12","35to44":"12","45to54":"17","55to64":"14","65+":"5","medianAge":"14"}},"title":"Cabinetmakers and bench carpenters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"65","women":"8.0","white":"88.2","black":"7.7","asian":"1.1","hispanicOrLatino":"21.3"}},"wageData":{"2019":{"workers":"44","median":"-","maleWorkers":"41","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Furniture finishers":{"ageData":{"2019":{"total":"18","16to19":"1","20to24":"2","25to34":"1","35to44":"5","45to54":"4","55to64":"3","65+":"2","medianAge":"3"}},"title":"Furniture finishers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"18","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"14","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Model makers and patternmakers, wood":{"ageData":{"2019":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Model makers and patternmakers, wood","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"0","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Sawing machine setters, operators, and tenders, wood":{"ageData":{"2019":{"total":"33","16to19":"1","20to24":"6","25to34":"9","35to44":"6","45to54":"5","55to64":"5","65+":"2","medianAge":"5"}},"title":"Sawing machine setters, operators, and tenders, wood","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"33","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"28","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Woodworking machine setters, operators, and tenders, except sawing":{"ageData":{"2019":{"total":"12","16to19":"0","20to24":"2","25to34":"2","35to44":"3","45to54":"3","55to64":"2","65+":"0","medianAge":"2"}},"title":"Woodworking machine setters, operators, and tenders, except sawing","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"12","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"14","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Woodworkers, all other":{"ageData":{"2019":{"total":"23","16to19":"0","20to24":"1","25to34":"3","35to44":"6","45to54":"3","55to64":"5","65+":"4","medianAge":"5"}},"title":"Woodworkers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"23","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"10","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Power plant operators, distributors, and dispatchers":{"ageData":{"2019":{"total":"43","16to19":"0","20to24":"1","25to34":"8","35to44":"11","45to54":"11","55to64":"9","65+":"2","medianAge":"9"}},"title":"Power plant operators, distributors, and dispatchers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"43","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"38","median":"-","maleWorkers":"36","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Stationary engineers and boiler operators":{"ageData":{"2019":{"total":"52","16to19":"0","20to24":"0","25to34":"11","35to44":"5","45to54":"13","55to64":"18","65+":"6","medianAge":"18"}},"title":"Stationary engineers and boiler operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"52","women":"3.0","white":"84.3","black":"5.2","asian":"5.5","hispanicOrLatino":"9.8"}},"wageData":{"2019":{"workers":"51","median":"869","maleWorkers":"50","maleMedian":"862","femaleWorkers":"2","femaleMedian":"-"}}},"Water and wastewater treatment plant and system operators":{"ageData":{"2019":{"total":"110","16to19":"0","20to24":"5","25to34":"25","35to44":"20","45to54":"26","55to64":"29","65+":"5","medianAge":"29"}},"title":"Water and wastewater treatment plant and system operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"110","women":"8.0","white":"84.6","black":"8.4","asian":"3.5","hispanicOrLatino":"9.7"}},"wageData":{"2019":{"workers":"105","median":"931","maleWorkers":"97","maleMedian":"930","femaleWorkers":"8","femaleMedian":"-"}}},"Miscellaneous plant and system operators":{"ageData":{"2019":{"total":"51","16to19":"0","20to24":"3","25to34":"11","35to44":"12","45to54":"15","55to64":"7","65+":"2","medianAge":"7"}},"title":"Miscellaneous plant and system operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"51","women":"4.9","white":"83.2","black":"11.6","asian":"3.9","hispanicOrLatino":"14.7"}},"wageData":{"2019":{"workers":"46","median":"-","maleWorkers":"44","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Chemical processing machine setters, operators, and tenders":{"ageData":{"2019":{"total":"73","16to19":"0","20to24":"5","25to34":"25","35to44":"14","45to54":"12","55to64":"16","65+":"2","medianAge":"16"}},"title":"Chemical processing machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"73","women":"11.1","white":"86.8","black":"11.0","asian":"1.0","hispanicOrLatino":"8.1"}},"wageData":{"2019":{"workers":"75","median":"999","maleWorkers":"67","maleMedian":"1,017","femaleWorkers":"8","femaleMedian":"-"}}},"Crushing, grinding, polishing, mixing, and blending workers":{"ageData":{"2019":{"total":"90","16to19":"1","20to24":"11","25to34":"26","35to44":"13","45to54":"14","55to64":"18","65+":"7","medianAge":"18"}},"title":"Crushing, grinding, polishing, mixing, and blending workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"90","women":"7.5","white":"80.8","black":"11.4","asian":"1.9","hispanicOrLatino":"26.1"}},"wageData":{"2019":{"workers":"79","median":"764","maleWorkers":"74","maleMedian":"772","femaleWorkers":"5","femaleMedian":"-"}}},"Cutting workers":{"ageData":{"2019":{"total":"60","16to19":"4","20to24":"5","25to34":"14","35to44":"15","45to54":"10","55to64":"9","65+":"4","medianAge":"9"}},"title":"Cutting workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"60","women":"12.7","white":"78.3","black":"18.8","asian":"2.5","hispanicOrLatino":"25.2"}},"wageData":{"2019":{"workers":"50","median":"762","maleWorkers":"42","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Extruding, forming, pressing, and compacting machine setters, operators, and tenders":{"ageData":{"2019":{"total":"27","16to19":"1","20to24":"4","25to34":"7","35to44":"2","45to54":"9","55to64":"2","65+":"1","medianAge":"2"}},"title":"Extruding, forming, pressing, and compacting machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"27","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"29","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Furnace, kiln, oven, drier, and kettle operators and tenders":{"ageData":{"2019":{"total":"17","16to19":"0","20to24":"2","25to34":"1","35to44":"3","45to54":"4","55to64":"7","65+":"0","medianAge":"7"}},"title":"Furnace, kiln, oven, drier, and kettle operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"17","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"17","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Inspectors, testers, sorters, samplers, and weighers":{"ageData":{"2019":{"total":"802","16to19":"13","20to24":"69","25to34":"171","35to44":"168","45to54":"171","55to64":"165","65+":"44","medianAge":"165"}},"title":"Inspectors, testers, sorters, samplers, and weighers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"802","women":"35.6","white":"77.6","black":"11.5","asian":"5.4","hispanicOrLatino":"17.5"}},"wageData":{"2019":{"workers":"722","median":"835","maleWorkers":"463","maleMedian":"939","femaleWorkers":"259","femaleMedian":"693"}}},"Jewelers and precious stone and metal workers":{"ageData":{"2019":{"total":"40","16to19":"1","20to24":"2","25to34":"2","35to44":"11","45to54":"7","55to64":"11","65+":"7","medianAge":"11"}},"title":"Jewelers and precious stone and metal workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"40","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"24","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Medical, dental, and ophthalmic laboratory technicians":{"ageData":{"2019":{"total":"91","16to19":"2","20to24":"8","25to34":"22","35to44":"18","45to54":"18","55to64":"16","65+":"6","medianAge":"16"}},"title":"Medical, dental, and ophthalmic laboratory technicians","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"91","women":"60.0","white":"81.8","black":"4.6","asian":"10.5","hispanicOrLatino":"17.7"}},"wageData":{"2019":{"workers":"79","median":"779","maleWorkers":"35","maleMedian":"-","femaleWorkers":"44","femaleMedian":"-"}}},"Packaging and filling machine operators and tenders":{"ageData":{"2019":{"total":"262","16to19":"9","20to24":"26","25to34":"61","35to44":"47","45to54":"56","55to64":"54","65+":"8","medianAge":"54"}},"title":"Packaging and filling machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"262","women":"54.6","white":"68.8","black":"20.4","asian":"6.3","hispanicOrLatino":"37.3"}},"wageData":{"2019":{"workers":"244","median":"575","maleWorkers":"116","maleMedian":"646","femaleWorkers":"128","femaleMedian":"533"}}},"Painting workers":{"ageData":{"2019":{"total":"171","16to19":"3","20to24":"15","25to34":"52","35to44":"37","45to54":"28","55to64":"30","65+":"5","medianAge":"30"}},"title":"Painting workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"171","women":"10.6","white":"81.5","black":"13.0","asian":"1.8","hispanicOrLatino":"41.8"}},"wageData":{"2019":{"workers":"160","median":"780","maleWorkers":"144","maleMedian":"804","femaleWorkers":"15","femaleMedian":"-"}}},"Photographic process workers and processing machine operators":{"ageData":{"2019":{"total":"13","16to19":"0","20to24":"2","25to34":"3","35to44":"2","45to54":"3","55to64":"3","65+":"1","medianAge":"3"}},"title":"Photographic process workers and processing machine operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"13","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"9","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Semiconductor processors":{"ageData":{"2019":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Semiconductor processors","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"0","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Adhesive bonding machine operators and tenders":{"ageData":{"2019":{"total":"10","16to19":"1","20to24":"1","25to34":"1","35to44":"2","45to54":"2","55to64":"3","65+":"0","medianAge":"3"}},"title":"Adhesive bonding machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"10","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"12","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Cleaning, washing, and metal pickling equipment operators and tenders":{"ageData":{"2019":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Cleaning, washing, and metal pickling equipment operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"2","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Cooling and freezing equipment operators and tenders":{"ageData":{"2019":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Cooling and freezing equipment operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"2","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Etchers and engravers":{"ageData":{"2019":{"total":"8","16to19":"0","20to24":"2","25to34":"0","35to44":"0","45to54":"1","55to64":"3","65+":"2","medianAge":"3"}},"title":"Etchers and engravers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"8","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"6","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Molders, shapers, and casters, except metal and plastic":{"ageData":{"2019":{"total":"31","16to19":"0","20to24":"3","25to34":"7","35to44":"11","45to54":"5","55to64":"5","65+":"1","medianAge":"5"}},"title":"Molders, shapers, and casters, except metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"31","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"28","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Paper goods machine setters, operators, and tenders":{"ageData":{"2019":{"total":"24","16to19":"1","20to24":"3","25to34":"3","35to44":"8","45to54":"4","55to64":"2","65+":"3","medianAge":"2"}},"title":"Paper goods machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"24","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"20","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Tire builders":{"ageData":{"2019":{"total":"8","16to19":"0","20to24":"1","25to34":"3","35to44":"2","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Tire builders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"8","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"12","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers--production workers":{"ageData":{"2019":{"total":"54","16to19":"5","20to24":"11","25to34":"12","35to44":"9","45to54":"8","55to64":"7","65+":"2","medianAge":"7"}},"title":"Helpers--production workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"54","women":"32.6","white":"74.9","black":"17.2","asian":"4.0","hispanicOrLatino":"30.3"}},"wageData":{"2019":{"workers":"29","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Production workers, all other":{"ageData":{"2019":{"total":"1,141","16to19":"24","20to24":"123","25to34":"266","35to44":"233","45to54":"236","55to64":"208","65+":"50","medianAge":"208"}},"title":"Production workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2019":{"total":"1,141","women":"28.6","white":"73.8","black":"16.1","asian":"5.7","hispanicOrLatino":"24.6"}},"wageData":{"2019":{"workers":"1,056","median":"704","maleWorkers":"763","maleMedian":"767","femaleWorkers":"293","femaleMedian":"566"}}},"Transportation and material moving occupations":{"ageData":{"2019":{"total":"10,063","16to19":"373","20to24":"1,033","25to34":"2,129","35to44":"1,866","45to54":"2,109","55to64":"1,837","65+":"716","medianAge":"1,837"}},"title":"Transportation and material moving occupations","depth":2,"parent":"Production, transportation, and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"10,063","women":"18.2","white":"72.2","black":"20.0","asian":"4.1","hispanicOrLatino":"22.9"}},"wageData":{"2019":{"workers":"7,612","median":"711","maleWorkers":"6,352","maleMedian":"747","femaleWorkers":"1,260","femaleMedian":"586"}}},"Supervisors of transportation and material moving workers":{"ageData":{"2019":{"total":"206","16to19":"0","20to24":"12","25to34":"59","35to44":"45","45to54":"52","55to64":"33","65+":"5","medianAge":"33"}},"title":"Supervisors of transportation and material moving workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"206","women":"21.5","white":"72.2","black":"19.4","asian":"6.7","hispanicOrLatino":"20.3"}},"wageData":{"2019":{"workers":"184","median":"923","maleWorkers":"156","maleMedian":"978","femaleWorkers":"28","femaleMedian":"-"}}},"Aircraft pilots and flight engineers":{"ageData":{"2019":{"total":"141","16to19":"0","20to24":"3","25to34":"19","35to44":"32","45to54":"41","55to64":"38","65+":"10","medianAge":"38"}},"title":"Aircraft pilots and flight engineers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"141","women":"7.5","white":"93.7","black":"2.6","asian":"3.4","hispanicOrLatino":"2.2"}},"wageData":{"2019":{"workers":"118","median":"1,857","maleWorkers":"109","maleMedian":"1,670","femaleWorkers":"9","femaleMedian":"-"}}},"Air traffic controllers and airfield operations specialists":{"ageData":{"2019":{"total":"43","16to19":"0","20to24":"0","25to34":"14","35to44":"11","45to54":"12","55to64":"6","65+":"0","medianAge":"6"}},"title":"Air traffic controllers and airfield operations specialists","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"43","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"40","median":"-","maleWorkers":"34","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Flight attendants":{"ageData":{"2019":{"total":"110","16to19":"0","20to24":"5","25to34":"27","35to44":"15","45to54":"27","55to64":"28","65+":"9","medianAge":"28"}},"title":"Flight attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"110","women":"81.3","white":"73.7","black":"17.5","asian":"5.4","hispanicOrLatino":"15.3"}},"wageData":{"2019":{"workers":"70","median":"823","maleWorkers":"13","maleMedian":"-","femaleWorkers":"57","femaleMedian":"835"}}},"Ambulance drivers and attendants, except emergency medical technicians":{"ageData":{"2019":{"total":"15","16to19":"0","20to24":"0","25to34":"4","35to44":"0","45to54":"7","55to64":"3","65+":"1","medianAge":"3"}},"title":"Ambulance drivers and attendants, except emergency medical technicians","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"15","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"12","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Bus drivers":{"ageData":{"2019":{"total":"546","16to19":"0","20to24":"2","25to34":"62","35to44":"92","45to54":"130","55to64":"154","65+":"104","medianAge":"154"}},"title":"Bus drivers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"546","women":"45.3","white":"67.2","black":"27.0","asian":"3.1","hispanicOrLatino":"15.0"}},"wageData":{"2019":{"workers":"364","median":"674","maleWorkers":"205","maleMedian":"718","femaleWorkers":"159","femaleMedian":"625"}}},"Driver/sales workers and truck drivers":{"ageData":{"2019":{"total":"3,608","16to19":"45","20to24":"256","25to34":"652","35to44":"724","45to54":"860","55to64":"792","65+":"279","medianAge":"792"}},"title":"Driver/sales workers and truck drivers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"3,608","women":"6.7","white":"75.2","black":"18.1","asian":"2.9","hispanicOrLatino":"20.5"}},"wageData":{"2019":{"workers":"2,723","median":"843","maleWorkers":"2,564","maleMedian":"861","femaleWorkers":"159","femaleMedian":"660"}}},"Taxi drivers and chauffeurs":{"ageData":{"2019":{"total":"790","16to19":"5","20to24":"50","25to34":"167","35to44":"149","45to54":"158","55to64":"159","65+":"102","medianAge":"159"}},"title":"Taxi drivers and chauffeurs","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"790","women":"16.8","white":"55.5","black":"29.5","asian":"13.1","hispanicOrLatino":"23.6"}},"wageData":{"2019":{"workers":"406","median":"614","maleWorkers":"356","maleMedian":"624","femaleWorkers":"50","femaleMedian":"520"}}},"Motor vehicle operators, all other":{"ageData":{"2019":{"total":"66","16to19":"1","20to24":"6","25to34":"8","35to44":"6","45to54":"8","55to64":"12","65+":"26","medianAge":"12"}},"title":"Motor vehicle operators, all other","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"66","women":"17.2","white":"83.6","black":"10.6","asian":"5.5","hispanicOrLatino":"18.6"}},"wageData":{"2019":{"workers":"34","median":"-","maleWorkers":"29","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Locomotive engineers and operators":{"ageData":{"2019":{"total":"42","16to19":"0","20to24":"0","25to34":"7","35to44":"14","45to54":"17","55to64":"4","65+":"0","medianAge":"4"}},"title":"Locomotive engineers and operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"42","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"39","median":"-","maleWorkers":"37","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Railroad brake, signal, and switch operators":{"ageData":{"2019":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Railroad brake, signal, and switch operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"2","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"3","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Railroad conductors and yardmasters":{"ageData":{"2019":{"total":"52","16to19":"2","20to24":"1","25to34":"12","35to44":"16","45to54":"16","55to64":"2","65+":"2","medianAge":"2"}},"title":"Railroad conductors and yardmasters","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"52","women":"2.4","white":"66.7","black":"24.0","asian":"3.1","hispanicOrLatino":"5.4"}},"wageData":{"2019":{"workers":"59","median":"1,160","maleWorkers":"57","maleMedian":"1,170","femaleWorkers":"2","femaleMedian":"-"}}},"Subway, streetcar, and other rail transportation workers":{"ageData":{"2019":{"total":"9","16to19":"0","20to24":"0","25to34":"3","35to44":"1","45to54":"1","55to64":"3","65+":"1","medianAge":"3"}},"title":"Subway, streetcar, and other rail transportation workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"9","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"10","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Sailors and marine oilers":{"ageData":{"2019":{"total":"19","16to19":"2","20to24":"4","25to34":"7","35to44":"2","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Sailors and marine oilers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"19","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"20","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Ship and boat captains and operators":{"ageData":{"2019":{"total":"45","16to19":"0","20to24":"3","25to34":"9","35to44":"12","45to54":"14","55to64":"5","65+":"2","medianAge":"5"}},"title":"Ship and boat captains and operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"45","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"33","median":"-","maleWorkers":"29","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Ship engineers":{"ageData":{"2019":{"total":"5","16to19":"0","20to24":"0","25to34":"2","35to44":"0","45to54":"3","55to64":"0","65+":"1","medianAge":"0"}},"title":"Ship engineers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Bridge and lock tenders":{"ageData":{"2019":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Bridge and lock tenders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"0","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Parking lot attendants":{"ageData":{"2019":{"total":"83","16to19":"6","20to24":"28","25to34":"20","35to44":"6","45to54":"9","55to64":"7","65+":"8","medianAge":"7"}},"title":"Parking lot attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"83","women":"14.8","white":"72.6","black":"19.3","asian":"5.7","hispanicOrLatino":"31.0"}},"wageData":{"2019":{"workers":"58","median":"561","maleWorkers":"50","maleMedian":"581","femaleWorkers":"8","femaleMedian":"-"}}},"Automotive and watercraft service attendants":{"ageData":{"2019":{"total":"88","16to19":"15","20to24":"15","25to34":"26","35to44":"11","45to54":"9","55to64":"9","65+":"3","medianAge":"9"}},"title":"Automotive and watercraft service attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"88","women":"18.4","white":"68.9","black":"12.1","asian":"13.7","hispanicOrLatino":"14.5"}},"wageData":{"2019":{"workers":"67","median":"518","maleWorkers":"59","maleMedian":"520","femaleWorkers":"8","femaleMedian":"-"}}},"Transportation inspectors":{"ageData":{"2019":{"total":"42","16to19":"1","20to24":"2","25to34":"11","35to44":"7","45to54":"10","55to64":"8","65+":"2","medianAge":"8"}},"title":"Transportation inspectors","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"42","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"42","median":"-","maleWorkers":"37","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Transportation attendants, except flight attendants":{"ageData":{"2019":{"total":"43","16to19":"1","20to24":"3","25to34":"7","35to44":"5","45to54":"11","55to64":"11","65+":"6","medianAge":"11"}},"title":"Transportation attendants, except flight attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"43","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"22","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Other transportation workers":{"ageData":{"2019":{"total":"38","16to19":"0","20to24":"2","25to34":"12","35to44":"7","45to54":"10","55to64":"4","65+":"3","medianAge":"4"}},"title":"Other transportation workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"38","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"31","median":"-","maleWorkers":"27","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Conveyor operators and tenders":{"ageData":{"2019":{"total":"2","16to19":"0","20to24":"1","25to34":"0","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Conveyor operators and tenders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"2","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Crane and tower operators":{"ageData":{"2019":{"total":"63","16to19":"1","20to24":"6","25to34":"12","35to44":"13","45to54":"15","55to64":"14","65+":"3","medianAge":"14"}},"title":"Crane and tower operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"63","women":"5.2","white":"90.1","black":"6.3","asian":"0.0","hispanicOrLatino":"10.6"}},"wageData":{"2019":{"workers":"63","median":"1,070","maleWorkers":"59","maleMedian":"1,104","femaleWorkers":"4","femaleMedian":"-"}}},"Dredge, excavating, and loading machine operators":{"ageData":{"2019":{"total":"28","16to19":"0","20to24":"2","25to34":"7","35to44":"6","45to54":"3","55to64":"5","65+":"4","medianAge":"5"}},"title":"Dredge, excavating, and loading machine operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"28","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"19","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Hoist and winch operators":{"ageData":{"2019":{"total":"9","16to19":"1","20to24":"2","25to34":"3","35to44":"1","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Hoist and winch operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"9","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"9","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Industrial truck and tractor operators":{"ageData":{"2019":{"total":"571","16to19":"12","20to24":"76","25to34":"132","35to44":"128","45to54":"121","55to64":"84","65+":"18","medianAge":"84"}},"title":"Industrial truck and tractor operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"571","women":"8.7","white":"69.0","black":"25.8","asian":"1.7","hispanicOrLatino":"31.4"}},"wageData":{"2019":{"workers":"541","median":"677","maleWorkers":"489","maleMedian":"686","femaleWorkers":"52","femaleMedian":"625"}}},"Cleaners of vehicles and equipment":{"ageData":{"2019":{"total":"344","16to19":"43","20to24":"58","25to34":"84","35to44":"52","45to54":"54","55to64":"35","65+":"17","medianAge":"35"}},"title":"Cleaners of vehicles and equipment","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"344","women":"16.0","white":"76.1","black":"19.4","asian":"1.4","hispanicOrLatino":"34.8"}},"wageData":{"2019":{"workers":"254","median":"587","maleWorkers":"225","maleMedian":"595","femaleWorkers":"29","femaleMedian":"-"}}},"Laborers and freight, stock, and material movers, hand":{"ageData":{"2019":{"total":"2,235","16to19":"180","20to24":"377","25to34":"569","35to44":"376","45to54":"359","55to64":"305","65+":"70","medianAge":"305"}},"title":"Laborers and freight, stock, and material movers, hand","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"2,235","women":"21.5","white":"72.4","black":"19.8","asian":"2.7","hispanicOrLatino":"23.1"}},"wageData":{"2019":{"workers":"1,764","median":"634","maleWorkers":"1,402","maleMedian":"657","femaleWorkers":"362","femaleMedian":"567"}}},"Machine feeders and offbearers":{"ageData":{"2019":{"total":"24","16to19":"2","20to24":"4","25to34":"4","35to44":"4","45to54":"3","55to64":"7","65+":"0","medianAge":"7"}},"title":"Machine feeders and offbearers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"24","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"21","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Packers and packagers, hand":{"ageData":{"2019":{"total":"628","16to19":"52","20to24":"90","25to34":"143","35to44":"105","45to54":"121","55to64":"83","65+":"34","medianAge":"83"}},"title":"Packers and packagers, hand","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"628","women":"54.8","white":"69.2","black":"19.0","asian":"7.7","hispanicOrLatino":"41.5"}},"wageData":{"2019":{"workers":"467","median":"530","maleWorkers":"202","maleMedian":"576","femaleWorkers":"265","femaleMedian":"515"}}},"Pumping station operators":{"ageData":{"2019":{"total":"16","16to19":"0","20to24":"2","25to34":"3","35to44":"4","45to54":"5","55to64":"2","65+":"0","medianAge":"2"}},"title":"Pumping station operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"16","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"11","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Refuse and recyclable material collectors":{"ageData":{"2019":{"total":"99","16to19":"4","20to24":"14","25to34":"29","35to44":"14","45to54":"21","55to64":"14","65+":"5","medianAge":"14"}},"title":"Refuse and recyclable material collectors","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"99","women":"7.6","white":"74.0","black":"18.2","asian":"3.6","hispanicOrLatino":"29.7"}},"wageData":{"2019":{"workers":"78","median":"686","maleWorkers":"72","maleMedian":"683","femaleWorkers":"5","femaleMedian":"-"}}},"Mine shuttle car operators":{"ageData":{"2019":{"total":"2","16to19":"1","20to24":"0","25to34":"0","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Mine shuttle car operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"2","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Tank car, truck, and ship loaders":{"ageData":{"2019":{"total":"6","16to19":"0","20to24":"2","25to34":"1","35to44":"1","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Tank car, truck, and ship loaders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"6","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Material moving workers, all other":{"ageData":{"2019":{"total":"41","16to19":"0","20to24":"8","25to34":"11","35to44":"6","45to54":"8","55to64":"6","65+":"2","medianAge":"6"}},"title":"Material moving workers, all other","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2019":{"total":"41","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2019":{"workers":"39","median":"-","maleWorkers":"35","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}}}');


var $46f25f1365a55a00$exports = {};
$46f25f1365a55a00$exports = JSON.parse('{"Total":{"ageData":{"2018":{"total":"155,761","16to19":"5,126","20to24":"14,051","25to34":"35,324","35to44":"32,616","45to54":"32,373","55to64":"26,565","65+":"9,705","medianAge":"26,565"}},"title":"Total","depth":1,"parent":"","sexRaceEthnicityData":{"2018":{"total":"155,761","women":"46.9","white":"78.0","black":"12.3","asian":"6.3","hispanicOrLatino":"17.3"}},"wageData":{"2018":{"workers":"115,567","median":"$886","maleWorkers":"64,142","maleMedian":"$973","femaleWorkers":"51,425","femaleMedian":"$789"}}},"Management, professional, and related occupations":{"ageData":{"2018":{"total":"62,436","16to19":"436","20to24":"3,359","25to34":"14,673","35to44":"14,572","45to54":"13,979","55to64":"11,126","65+":"4,291","medianAge":"11,126"}},"title":"Management, professional, and related occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2018":{"total":"62,436","women":"51.5","white":"79.4","black":"9.6","asian":"8.5","hispanicOrLatino":"9.7"}},"wageData":{"2018":{"workers":"48,808","median":"1,246","maleWorkers":"23,685","maleMedian":"1,468","femaleWorkers":"25,123","femaleMedian":"1,078"}}},"Management, business, and financial operations occupations":{"ageData":{"2018":{"total":"25,850","16to19":"91","20to24":"1,005","25to34":"5,151","35to44":"6,069","45to54":"6,362","55to64":"5,228","65+":"1,945","medianAge":"5,228"}},"title":"Management, business, and financial operations occupations","depth":2,"parent":"Management, professional, and related occupations","sexRaceEthnicityData":{"2018":{"total":"25,850","women":"44.0","white":"82.4","black":"8.2","asian":"6.8","hispanicOrLatino":"9.8"}},"wageData":{"2018":{"workers":"19,863","median":"1,355","maleWorkers":"10,668","maleMedian":"1,537","femaleWorkers":"9,195","femaleMedian":"1,168"}}},"Management occupations":{"ageData":{"2018":{"total":"18,263","16to19":"69","20to24":"565","25to34":"3,259","35to44":"4,411","45to54":"4,666","55to64":"3,874","65+":"1,420","medianAge":"3,874"}},"title":"Management occupations","depth":3,"parent":"Management, business, and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"18,263","women":"40.0","white":"83.9","black":"7.6","asian":"5.9","hispanicOrLatino":"10.3"}},"wageData":{"2018":{"workers":"13,477","median":"1,429","maleWorkers":"7,754","maleMedian":"1,585","femaleWorkers":"5,724","femaleMedian":"1,236"}}},"Chief executives":{"ageData":{"2018":{"total":"1,573","16to19":"0","20to24":"3","25to34":"147","35to44":"349","45to54":"467","55to64":"413","65+":"193","medianAge":"413"}},"title":"Chief executives","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"1,573","women":"26.9","white":"89.5","black":"3.5","asian":"5.9","hispanicOrLatino":"6.1"}},"wageData":{"2018":{"workers":"1,098","median":"2,291","maleWorkers":"790","maleMedian":"2,488","femaleWorkers":"307","femaleMedian":"1,736"}}},"General and operations managers":{"ageData":{"2018":{"total":"1,037","16to19":"1","20to24":"30","25to34":"235","35to44":"279","45to54":"245","55to64":"204","65+":"43","medianAge":"204"}},"title":"General and operations managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"1,037","women":"31.7","white":"84.5","black":"7.5","asian":"4.8","hispanicOrLatino":"10.5"}},"wageData":{"2018":{"workers":"939","median":"1,338","maleWorkers":"656","maleMedian":"1,427","femaleWorkers":"283","femaleMedian":"1,139"}}},"Legislators":{"ageData":{"2018":{"total":"18","16to19":"0","20to24":"1","25to34":"1","35to44":"3","45to54":"2","55to64":"5","65+":"7","medianAge":"5"}},"title":"Legislators","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"18","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"14","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Advertising and promotions managers":{"ageData":{"2018":{"total":"44","16to19":"0","20to24":"5","25to34":"13","35to44":"14","45to54":"8","55to64":"2","65+":"1","medianAge":"2"}},"title":"Advertising and promotions managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"44","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"39","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Marketing and sales managers":{"ageData":{"2018":{"total":"1,083","16to19":"4","20to24":"65","25to34":"269","35to44":"282","45to54":"252","55to64":"176","65+":"35","medianAge":"176"}},"title":"Marketing and sales managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"1,083","women":"47.6","white":"85.8","black":"6.7","asian":"5.4","hispanicOrLatino":"9.7"}},"wageData":{"2018":{"workers":"963","median":"1,567","maleWorkers":"517","maleMedian":"1,852","femaleWorkers":"447","femaleMedian":"1,362"}}},"Public relations and fundraising managers":{"ageData":{"2018":{"total":"69","16to19":"0","20to24":"1","25to34":"13","35to44":"19","45to54":"21","55to64":"10","65+":"6","medianAge":"10"}},"title":"Public relations and fundraising managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"69","women":"72.8","white":"85.8","black":"10.7","asian":"3.1","hispanicOrLatino":"3.1"}},"wageData":{"2018":{"workers":"61","median":"1,415","maleWorkers":"18","maleMedian":"-","femaleWorkers":"43","femaleMedian":"-"}}},"Administrative services managers":{"ageData":{"2018":{"total":"161","16to19":"1","20to24":"5","25to34":"19","35to44":"35","45to54":"48","55to64":"45","65+":"9","medianAge":"45"}},"title":"Administrative services managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"161","women":"34.2","white":"85.4","black":"7.4","asian":"3.0","hispanicOrLatino":"13.0"}},"wageData":{"2018":{"workers":"147","median":"1,215","maleWorkers":"101","maleMedian":"1,266","femaleWorkers":"46","femaleMedian":"-"}}},"Computer and information systems managers":{"ageData":{"2018":{"total":"623","16to19":"0","20to24":"10","25to34":"96","35to44":"188","45to54":"191","55to64":"122","65+":"16","medianAge":"122"}},"title":"Computer and information systems managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"623","women":"27.0","white":"77.0","black":"5.8","asian":"14.3","hispanicOrLatino":"6.6"}},"wageData":{"2018":{"workers":"601","median":"1,877","maleWorkers":"448","maleMedian":"1,920","femaleWorkers":"153","femaleMedian":"1,727"}}},"Financial managers":{"ageData":{"2018":{"total":"1,231","16to19":"3","20to24":"34","25to34":"279","35to44":"338","45to54":"298","55to64":"220","65+":"59","medianAge":"220"}},"title":"Financial managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"1,231","women":"55.2","white":"81.7","black":"8.1","asian":"7.4","hispanicOrLatino":"9.4"}},"wageData":{"2018":{"workers":"1,158","median":"1,466","maleWorkers":"495","maleMedian":"1,784","femaleWorkers":"663","femaleMedian":"1,262"}}},"Compensation and benefits managers":{"ageData":{"2018":{"total":"23","16to19":"1","20to24":"2","25to34":"2","35to44":"5","45to54":"10","55to64":"2","65+":"1","medianAge":"2"}},"title":"Compensation and benefits managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"23","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"21","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Human resources managers":{"ageData":{"2018":{"total":"313","16to19":"0","20to24":"7","25to34":"64","35to44":"95","45to54":"94","55to64":"43","65+":"10","medianAge":"43"}},"title":"Human resources managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"313","women":"77.9","white":"78.1","black":"12.8","asian":"6.3","hispanicOrLatino":"10.2"}},"wageData":{"2018":{"workers":"294","median":"1,381","maleWorkers":"73","maleMedian":"1,761","femaleWorkers":"221","femaleMedian":"1,330"}}},"Training and development managers":{"ageData":{"2018":{"total":"58","16to19":"0","20to24":"1","25to34":"17","35to44":"13","45to54":"15","55to64":"8","65+":"3","medianAge":"8"}},"title":"Training and development managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"58","women":"48.6","white":"86.3","black":"10.1","asian":"0.0","hispanicOrLatino":"15.5"}},"wageData":{"2018":{"workers":"52","median":"1,448","maleWorkers":"21","maleMedian":"-","femaleWorkers":"31","femaleMedian":"-"}}},"Industrial production managers":{"ageData":{"2018":{"total":"264","16to19":"0","20to24":"8","25to34":"45","35to44":"63","45to54":"77","55to64":"61","65+":"8","medianAge":"61"}},"title":"Industrial production managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"264","women":"22.0","white":"85.7","black":"6.3","asian":"6.0","hispanicOrLatino":"12.5"}},"wageData":{"2018":{"workers":"243","median":"1,465","maleWorkers":"188","maleMedian":"1,573","femaleWorkers":"55","femaleMedian":"1,296"}}},"Purchasing managers":{"ageData":{"2018":{"total":"219","16to19":"0","20to24":"9","25to34":"50","35to44":"53","45to54":"49","55to64":"48","65+":"10","medianAge":"48"}},"title":"Purchasing managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"219","women":"45.3","white":"85.3","black":"9.0","asian":"4.0","hispanicOrLatino":"10.7"}},"wageData":{"2018":{"workers":"222","median":"1,362","maleWorkers":"123","maleMedian":"1,431","femaleWorkers":"99","femaleMedian":"1,229"}}},"Transportation, storage, and distribution managers":{"ageData":{"2018":{"total":"303","16to19":"1","20to24":"12","25to34":"66","35to44":"57","45to54":"86","55to64":"66","65+":"15","medianAge":"66"}},"title":"Transportation, storage, and distribution managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"303","women":"16.0","white":"84.9","black":"7.2","asian":"4.4","hispanicOrLatino":"13.7"}},"wageData":{"2018":{"workers":"269","median":"1,131","maleWorkers":"226","maleMedian":"1,138","femaleWorkers":"43","femaleMedian":"-"}}},"Farmers, ranchers, and other agricultural managers":{"ageData":{"2018":{"total":"991","16to19":"4","20to24":"16","25to34":"108","35to44":"124","45to54":"160","55to64":"294","65+":"286","medianAge":"294"}},"title":"Farmers, ranchers, and other agricultural managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"991","women":"25.8","white":"96.1","black":"0.9","asian":"1.4","hispanicOrLatino":"5.1"}},"wageData":{"2018":{"workers":"119","median":"945","maleWorkers":"99","maleMedian":"1,010","femaleWorkers":"21","femaleMedian":"-"}}},"Construction managers":{"ageData":{"2018":{"total":"1,021","16to19":"1","20to24":"27","25to34":"154","35to44":"281","45to54":"261","55to64":"221","65+":"75","medianAge":"221"}},"title":"Construction managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"1,021","women":"7.7","white":"91.8","black":"3.1","asian":"2.4","hispanicOrLatino":"15.3"}},"wageData":{"2018":{"workers":"625","median":"1,431","maleWorkers":"572","maleMedian":"1,467","femaleWorkers":"53","femaleMedian":"1,202"}}},"Education administrators":{"ageData":{"2018":{"total":"955","16to19":"2","20to24":"27","25to34":"149","35to44":"255","45to54":"270","55to64":"191","65+":"60","medianAge":"191"}},"title":"Education administrators","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"955","women":"66.9","white":"79.0","black":"14.4","asian":"3.4","hispanicOrLatino":"10.5"}},"wageData":{"2018":{"workers":"857","median":"1,381","maleWorkers":"294","maleMedian":"1,563","femaleWorkers":"563","femaleMedian":"1,245"}}},"Architectural and engineering managers":{"ageData":{"2018":{"total":"156","16to19":"0","20to24":"1","25to34":"14","35to44":"49","45to54":"48","55to64":"40","65+":"4","medianAge":"40"}},"title":"Architectural and engineering managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"156","women":"11.5","white":"84.5","black":"5.0","asian":"9.9","hispanicOrLatino":"4.6"}},"wageData":{"2018":{"workers":"149","median":"2,226","maleWorkers":"131","maleMedian":"2,285","femaleWorkers":"19","femaleMedian":"-"}}},"Food service managers":{"ageData":{"2018":{"total":"1,273","16to19":"35","20to24":"148","25to34":"324","35to44":"253","45to54":"287","55to64":"177","65+":"48","medianAge":"177"}},"title":"Food service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"1,273","women":"49.2","white":"75.7","black":"10.7","asian":"10.0","hispanicOrLatino":"18.5"}},"wageData":{"2018":{"workers":"827","median":"809","maleWorkers":"420","maleMedian":"922","femaleWorkers":"407","femaleMedian":"708"}}},"Funeral service managers":{"ageData":{"2018":{"total":"3","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"0","65+":"1","medianAge":"0"}},"title":"Funeral service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"3","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Gaming managers":{"ageData":{"2018":{"total":"28","16to19":"0","20to24":"5","25to34":"4","35to44":"9","45to54":"3","55to64":"5","65+":"2","medianAge":"5"}},"title":"Gaming managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"28","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"23","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Lodging managers":{"ageData":{"2018":{"total":"153","16to19":"1","20to24":"5","25to34":"36","35to44":"36","45to54":"35","55to64":"30","65+":"11","medianAge":"30"}},"title":"Lodging managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"153","women":"56.0","white":"76.2","black":"11.1","asian":"10.2","hispanicOrLatino":"11.5"}},"wageData":{"2018":{"workers":"112","median":"955","maleWorkers":"48","maleMedian":"-","femaleWorkers":"64","femaleMedian":"920"}}},"Medical and health services managers":{"ageData":{"2018":{"total":"639","16to19":"1","20to24":"12","25to34":"113","35to44":"167","45to54":"164","55to64":"152","65+":"30","medianAge":"152"}},"title":"Medical and health services managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"639","women":"72.0","white":"80.9","black":"11.5","asian":"5.0","hispanicOrLatino":"9.0"}},"wageData":{"2018":{"workers":"567","median":"1,408","maleWorkers":"149","maleMedian":"1,729","femaleWorkers":"418","femaleMedian":"1,331"}}},"Natural sciences managers":{"ageData":{"2018":{"total":"9","16to19":"0","20to24":"2","25to34":"2","35to44":"3","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Natural sciences managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"9","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"8","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Postmasters and mail superintendents":{"ageData":{"2018":{"total":"24","16to19":"0","20to24":"0","25to34":"1","35to44":"4","45to54":"9","55to64":"8","65+":"2","medianAge":"8"}},"title":"Postmasters and mail superintendents","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"24","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"22","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"15","femaleMedian":"-"}}},"Property, real estate, and community association managers":{"ageData":{"2018":{"total":"717","16to19":"0","20to24":"19","25to34":"125","35to44":"142","45to54":"150","55to64":"178","65+":"102","medianAge":"178"}},"title":"Property, real estate, and community association managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"717","women":"49.7","white":"85.5","black":"7.3","asian":"4.6","hispanicOrLatino":"13.6"}},"wageData":{"2018":{"workers":"390","median":"1,018","maleWorkers":"181","maleMedian":"1,148","femaleWorkers":"208","femaleMedian":"927"}}},"Social and community service managers":{"ageData":{"2018":{"total":"437","16to19":"1","20to24":"7","25to34":"93","35to44":"90","45to54":"120","55to64":"93","65+":"33","medianAge":"93"}},"title":"Social and community service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"437","women":"69.1","white":"78.4","black":"13.8","asian":"4.0","hispanicOrLatino":"7.6"}},"wageData":{"2018":{"workers":"363","median":"1,141","maleWorkers":"112","maleMedian":"1,336","femaleWorkers":"251","femaleMedian":"1,057"}}},"Emergency management directors":{"ageData":{"2018":{"total":"10","16to19":"0","20to24":"0","25to34":"3","35to44":"1","45to54":"4","55to64":"1","65+":"1","medianAge":"1"}},"title":"Emergency management directors","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"10","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"9","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Managers, all other":{"ageData":{"2018":{"total":"4,827","16to19":"12","20to24":"104","25to34":"815","35to44":"1,203","45to54":"1,287","55to64":"1,058","65+":"347","medianAge":"1,058"}},"title":"Managers, all other","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2018":{"total":"4,827","women":"35.4","white":"83.2","black":"7.8","asian":"6.5","hispanicOrLatino":"9.9"}},"wageData":{"2018":{"workers":"3,285","median":"1,525","maleWorkers":"2,022","maleMedian":"1,628","femaleWorkers":"1,263","femaleMedian":"1,341"}}},"Business and financial operations occupations":{"ageData":{"2018":{"total":"7,587","16to19":"23","20to24":"440","25to34":"1,892","35to44":"1,658","45to54":"1,697","55to64":"1,353","65+":"525","medianAge":"1,353"}},"title":"Business and financial operations occupations","depth":3,"parent":"Management, business, and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"7,587","women":"53.8","white":"78.8","black":"9.8","asian":"9.1","hispanicOrLatino":"8.7"}},"wageData":{"2018":{"workers":"6,385","median":"1,216","maleWorkers":"2,914","maleMedian":"1,383","femaleWorkers":"3,471","femaleMedian":"1,105"}}},"Agents and business managers of artists, performers, and athletes":{"ageData":{"2018":{"total":"54","16to19":"2","20to24":"8","25to34":"10","35to44":"13","45to54":"12","55to64":"7","65+":"3","medianAge":"7"}},"title":"Agents and business managers of artists, performers, and athletes","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"54","women":"53.8","white":"79.3","black":"7.5","asian":"11.0","hispanicOrLatino":"12.2"}},"wageData":{"2018":{"workers":"31","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"18","femaleMedian":"-"}}},"Buyers and purchasing agents, farm products":{"ageData":{"2018":{"total":"12","16to19":"0","20to24":"0","25to34":"6","35to44":"2","45to54":"4","55to64":"1","65+":"0","medianAge":"1"}},"title":"Buyers and purchasing agents, farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"12","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"10","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Wholesale and retail buyers, except farm products":{"ageData":{"2018":{"total":"193","16to19":"0","20to24":"13","25to34":"52","35to44":"31","45to54":"40","55to64":"42","65+":"14","medianAge":"42"}},"title":"Wholesale and retail buyers, except farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"193","women":"50.7","white":"80.7","black":"10.7","asian":"5.7","hispanicOrLatino":"11.1"}},"wageData":{"2018":{"workers":"147","median":"878","maleWorkers":"82","maleMedian":"878","femaleWorkers":"65","femaleMedian":"880"}}},"Purchasing agents, except wholesale, retail, and farm products":{"ageData":{"2018":{"total":"244","16to19":"2","20to24":"11","25to34":"47","35to44":"43","45to54":"67","55to64":"56","65+":"18","medianAge":"56"}},"title":"Purchasing agents, except wholesale, retail, and farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"244","women":"46.7","white":"84.3","black":"8.0","asian":"5.0","hispanicOrLatino":"7.6"}},"wageData":{"2018":{"workers":"223","median":"1,160","maleWorkers":"121","maleMedian":"1,209","femaleWorkers":"102","femaleMedian":"1,032"}}},"Claims adjusters, appraisers, examiners, and investigators":{"ageData":{"2018":{"total":"344","16to19":"0","20to24":"18","25to34":"77","35to44":"90","45to54":"80","55to64":"69","65+":"11","medianAge":"69"}},"title":"Claims adjusters, appraisers, examiners, and investigators","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"344","women":"57.4","white":"74.9","black":"19.1","asian":"3.7","hispanicOrLatino":"10.9"}},"wageData":{"2018":{"workers":"334","median":"998","maleWorkers":"145","maleMedian":"1,167","femaleWorkers":"189","femaleMedian":"913"}}},"Compliance officers":{"ageData":{"2018":{"total":"281","16to19":"2","20to24":"12","25to34":"53","35to44":"75","45to54":"70","55to64":"50","65+":"19","medianAge":"50"}},"title":"Compliance officers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"281","women":"53.7","white":"82.3","black":"11.3","asian":"5.4","hispanicOrLatino":"6.9"}},"wageData":{"2018":{"workers":"278","median":"1,296","maleWorkers":"129","maleMedian":"1,450","femaleWorkers":"149","femaleMedian":"1,165"}}},"Cost estimators":{"ageData":{"2018":{"total":"117","16to19":"1","20to24":"7","25to34":"19","35to44":"27","45to54":"27","55to64":"25","65+":"11","medianAge":"25"}},"title":"Cost estimators","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"117","women":"14.1","white":"93.3","black":"1.9","asian":"4.0","hispanicOrLatino":"10.5"}},"wageData":{"2018":{"workers":"109","median":"1,165","maleWorkers":"95","maleMedian":"1,208","femaleWorkers":"14","femaleMedian":"-"}}},"Human resources workers":{"ageData":{"2018":{"total":"664","16to19":"2","20to24":"42","25to34":"180","35to44":"172","45to54":"125","55to64":"114","65+":"28","medianAge":"114"}},"title":"Human resources workers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"664","women":"70.7","white":"79.2","black":"10.5","asian":"7.0","hispanicOrLatino":"13.2"}},"wageData":{"2018":{"workers":"620","median":"1,161","maleWorkers":"190","maleMedian":"1,328","femaleWorkers":"429","femaleMedian":"1,107"}}},"Compensation, benefits, and job analysis specialists":{"ageData":{"2018":{"total":"48","16to19":"0","20to24":"1","25to34":"11","35to44":"14","45to54":"8","55to64":"9","65+":"5","medianAge":"9"}},"title":"Compensation, benefits, and job analysis specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"48","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"48","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"31","femaleMedian":"-"}}},"Training and development specialists":{"ageData":{"2018":{"total":"120","16to19":"2","20to24":"5","25to34":"31","35to44":"21","45to54":"27","55to64":"27","65+":"7","medianAge":"27"}},"title":"Training and development specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"120","women":"54.4","white":"76.2","black":"15.3","asian":"2.9","hispanicOrLatino":"8.7"}},"wageData":{"2018":{"workers":"111","median":"1,092","maleWorkers":"47","maleMedian":"-","femaleWorkers":"64","femaleMedian":"1,086"}}},"Logisticians":{"ageData":{"2018":{"total":"128","16to19":"0","20to24":"11","25to34":"39","35to44":"25","45to54":"28","55to64":"20","65+":"5","medianAge":"20"}},"title":"Logisticians","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"128","women":"37.3","white":"75.7","black":"12.1","asian":"8.1","hispanicOrLatino":"10.1"}},"wageData":{"2018":{"workers":"127","median":"1,019","maleWorkers":"81","maleMedian":"1,131","femaleWorkers":"46","femaleMedian":"-"}}},"Management analysts":{"ageData":{"2018":{"total":"944","16to19":"1","20to24":"33","25to34":"212","35to44":"190","45to54":"217","55to64":"181","65+":"109","medianAge":"181"}},"title":"Management analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"944","women":"41.3","white":"77.6","black":"8.3","asian":"12.3","hispanicOrLatino":"6.5"}},"wageData":{"2018":{"workers":"635","median":"1,532","maleWorkers":"356","maleMedian":"1,642","femaleWorkers":"279","femaleMedian":"1,437"}}},"Meeting, convention, and event planners":{"ageData":{"2018":{"total":"126","16to19":"2","20to24":"20","25to34":"42","35to44":"25","45to54":"21","55to64":"15","65+":"2","medianAge":"15"}},"title":"Meeting, convention, and event planners","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"126","women":"76.3","white":"77.7","black":"8.6","asian":"5.3","hispanicOrLatino":"10.5"}},"wageData":{"2018":{"workers":"89","median":"1,002","maleWorkers":"21","maleMedian":"-","femaleWorkers":"69","femaleMedian":"1,006"}}},"Fundraisers":{"ageData":{"2018":{"total":"96","16to19":"1","20to24":"7","25to34":"28","35to44":"20","45to54":"13","55to64":"20","65+":"8","medianAge":"20"}},"title":"Fundraisers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"96","women":"69.3","white":"86.9","black":"7.7","asian":"3.2","hispanicOrLatino":"5.4"}},"wageData":{"2018":{"workers":"82","median":"1,262","maleWorkers":"22","maleMedian":"-","femaleWorkers":"60","femaleMedian":"1,168"}}},"Market research analysts and marketing specialists":{"ageData":{"2018":{"total":"355","16to19":"1","20to24":"42","25to34":"125","35to44":"79","45to54":"60","55to64":"36","65+":"12","medianAge":"36"}},"title":"Market research analysts and marketing specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"355","women":"60.2","white":"81.8","black":"5.8","asian":"11.6","hispanicOrLatino":"11.4"}},"wageData":{"2018":{"workers":"299","median":"1,246","maleWorkers":"125","maleMedian":"1,503","femaleWorkers":"174","femaleMedian":"1,148"}}},"Business operations specialists, all other":{"ageData":{"2018":{"total":"236","16to19":"1","20to24":"16","25to34":"49","35to44":"63","45to54":"52","55to64":"39","65+":"15","medianAge":"39"}},"title":"Business operations specialists, all other","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"236","women":"59.3","white":"70.6","black":"15.8","asian":"9.0","hispanicOrLatino":"9.4"}},"wageData":{"2018":{"workers":"223","median":"1,150","maleWorkers":"95","maleMedian":"1,234","femaleWorkers":"127","femaleMedian":"1,072"}}},"Accountants and auditors":{"ageData":{"2018":{"total":"1,929","16to19":"2","20to24":"105","25to34":"481","35to44":"404","45to54":"454","55to64":"345","65+":"137","medianAge":"345"}},"title":"Accountants and auditors","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"1,929","women":"60.6","white":"75.8","black":"9.3","asian":"12.7","hispanicOrLatino":"7.6"}},"wageData":{"2018":{"workers":"1,615","median":"1,209","maleWorkers":"646","maleMedian":"1,404","femaleWorkers":"969","femaleMedian":"1,108"}}},"Appraisers and assessors of real estate":{"ageData":{"2018":{"total":"84","16to19":"0","20to24":"2","25to34":"9","35to44":"16","45to54":"24","55to64":"22","65+":"11","medianAge":"22"}},"title":"Appraisers and assessors of real estate","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"84","women":"45.3","white":"83.9","black":"10.7","asian":"4.0","hispanicOrLatino":"4.2"}},"wageData":{"2018":{"workers":"47","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"22","femaleMedian":"-"}}},"Budget analysts":{"ageData":{"2018":{"total":"51","16to19":"0","20to24":"2","25to34":"12","35to44":"11","45to54":"11","55to64":"12","65+":"2","medianAge":"12"}},"title":"Budget analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"51","women":"62.2","white":"72.6","black":"11.2","asian":"14.5","hispanicOrLatino":"13.8"}},"wageData":{"2018":{"workers":"52","median":"1,351","maleWorkers":"17","maleMedian":"-","femaleWorkers":"35","femaleMedian":"-"}}},"Credit analysts":{"ageData":{"2018":{"total":"26","16to19":"0","20to24":"2","25to34":"10","35to44":"4","45to54":"7","55to64":"3","65+":"1","medianAge":"3"}},"title":"Credit analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"26","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"27","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"14","femaleMedian":"-"}}},"Financial analysts":{"ageData":{"2018":{"total":"307","16to19":"1","20to24":"27","25to34":"112","35to44":"76","45to54":"51","55to64":"33","65+":"8","medianAge":"33"}},"title":"Financial analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"307","women":"40.7","white":"76.1","black":"8.1","asian":"14.1","hispanicOrLatino":"5.5"}},"wageData":{"2018":{"workers":"261","median":"1,470","maleWorkers":"138","maleMedian":"1,599","femaleWorkers":"122","femaleMedian":"1,197"}}},"Personal financial advisors":{"ageData":{"2018":{"total":"537","16to19":"1","20to24":"21","25to34":"125","35to44":"128","45to54":"119","55to64":"97","65+":"45","medianAge":"97"}},"title":"Personal financial advisors","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"537","women":"33.5","white":"86.3","black":"5.0","asian":"6.9","hispanicOrLatino":"6.6"}},"wageData":{"2018":{"workers":"414","median":"1,473","maleWorkers":"268","maleMedian":"1,647","femaleWorkers":"146","femaleMedian":"1,207"}}},"Insurance underwriters":{"ageData":{"2018":{"total":"119","16to19":"0","20to24":"10","25to34":"27","35to44":"24","45to54":"29","55to64":"25","65+":"3","medianAge":"25"}},"title":"Insurance underwriters","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"119","women":"59.7","white":"80.7","black":"13.7","asian":"5.3","hispanicOrLatino":"6.2"}},"wageData":{"2018":{"workers":"122","median":"1,268","maleWorkers":"51","maleMedian":"1,413","femaleWorkers":"71","femaleMedian":"1,032"}}},"Financial examiners":{"ageData":{"2018":{"total":"13","16to19":"0","20to24":"1","25to34":"4","35to44":"4","45to54":"2","55to64":"0","65+":"2","medianAge":"0"}},"title":"Financial examiners","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"13","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"11","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Credit counselors and loan officers":{"ageData":{"2018":{"total":"350","16to19":"1","20to24":"15","25to34":"86","35to44":"74","45to54":"93","55to64":"59","65+":"23","medianAge":"59"}},"title":"Credit counselors and loan officers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"350","women":"54.1","white":"85.5","black":"7.6","asian":"4.3","hispanicOrLatino":"13.0"}},"wageData":{"2018":{"workers":"332","median":"1,168","maleWorkers":"155","maleMedian":"1,443","femaleWorkers":"177","femaleMedian":"948"}}},"Tax examiners and collectors, and revenue agents":{"ageData":{"2018":{"total":"47","16to19":"0","20to24":"0","25to34":"8","35to44":"5","45to54":"17","55to64":"12","65+":"5","medianAge":"12"}},"title":"Tax examiners and collectors, and revenue agents","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"47","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"42","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"29","femaleMedian":"-"}}},"Tax preparers":{"ageData":{"2018":{"total":"113","16to19":"0","20to24":"5","25to34":"26","35to44":"12","45to54":"27","55to64":"24","65+":"19","medianAge":"24"}},"title":"Tax preparers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"113","women":"56.8","white":"76.1","black":"16.7","asian":"5.1","hispanicOrLatino":"13.1"}},"wageData":{"2018":{"workers":"62","median":"1,028","maleWorkers":"26","maleMedian":"-","femaleWorkers":"36","femaleMedian":"-"}}},"Financial specialists, all other":{"ageData":{"2018":{"total":"48","16to19":"0","20to24":"6","25to34":"11","35to44":"10","45to54":"10","55to64":"10","65+":"1","medianAge":"10"}},"title":"Financial specialists, all other","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2018":{"total":"48","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"35","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"22","femaleMedian":"-"}}},"Professional and related occupations":{"ageData":{"2018":{"total":"36,586","16to19":"345","20to24":"2,354","25to34":"9,522","35to44":"8,503","45to54":"7,617","55to64":"5,898","65+":"2,347","medianAge":"5,898"}},"title":"Professional and related occupations","depth":2,"parent":"Management, professional, and related occupations","sexRaceEthnicityData":{"2018":{"total":"36,586","women":"56.8","white":"77.2","black":"10.5","asian":"9.6","hispanicOrLatino":"9.6"}},"wageData":{"2018":{"workers":"28,945","median":"1,176","maleWorkers":"13,017","maleMedian":"1,425","femaleWorkers":"15,929","femaleMedian":"1,024"}}},"Computer and mathematical occupations":{"ageData":{"2018":{"total":"5,126","16to19":"25","20to24":"330","25to34":"1,563","35to44":"1,333","45to54":"1,038","55to64":"692","65+":"146","medianAge":"692"}},"title":"Computer and mathematical occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2018":{"total":"5,126","women":"25.6","white":"67.0","black":"8.4","asian":"22.0","hispanicOrLatino":"7.5"}},"wageData":{"2018":{"workers":"4,755","median":"1,539","maleWorkers":"3,571","maleMedian":"1,604","femaleWorkers":"1,184","femaleMedian":"1,345"}}},"Computer and information research scientists":{"ageData":{"2018":{"total":"19","16to19":"0","20to24":"0","25to34":"10","35to44":"4","45to54":"3","55to64":"2","65+":"0","medianAge":"2"}},"title":"Computer and information research scientists","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2018":{"total":"19","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"20","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Computer systems analysts":{"ageData":{"2018":{"total":"652","16to19":"2","20to24":"38","25to34":"193","35to44":"162","45to54":"136","55to64":"92","65+":"29","medianAge":"92"}},"title":"Computer systems analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2018":{"total":"652","women":"37.5","white":"66.5","black":"10.0","asian":"20.4","hispanicOrLatino":"7.9"}},"wageData":{"2018":{"workers":"580","median":"1,521","maleWorkers":"358","maleMedian":"1,647","femaleWorkers":"222","femaleMedian":"1,246"}}},"Information security analysts":{"ageData":{"2018":{"total":"97","16to19":"1","20to24":"5","25to34":"26","35to44":"34","45to54":"17","55to64":"13","65+":"3","medianAge":"13"}},"title":"Information security analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2018":{"total":"97","women":"24.9","white":"76.8","black":"12.3","asian":"8.5","hispanicOrLatino":"6.8"}},"wageData":{"2018":{"workers":"93","median":"1,635","maleWorkers":"75","maleMedian":"1,625","femaleWorkers":"18","femaleMedian":"-"}}},"Computer programmers":{"ageData":{"2018":{"total":"477","16to19":"3","20to24":"28","25to34":"117","35to44":"111","45to54":"126","55to64":"73","65+":"18","medianAge":"73"}},"title":"Computer programmers","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2018":{"total":"477","women":"21.2","white":"68.8","black":"9.3","asian":"19.4","hispanicOrLatino":"7.8"}},"wageData":{"2018":{"workers":"428","median":"1,591","maleWorkers":"338","maleMedian":"1,662","femaleWorkers":"91","femaleMedian":"1,445"}}},"Software developers, applications and systems software":{"ageData":{"2018":{"total":"1,682","16to19":"1","20to24":"99","25to34":"595","35to44":"462","45to54":"291","55to64":"200","65+":"34","medianAge":"200"}},"title":"Software developers, applications and systems software","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2018":{"total":"1,682","women":"19.3","white":"58.6","black":"3.9","asian":"35.4","hispanicOrLatino":"5.3"}},"wageData":{"2018":{"workers":"1,611","median":"1,864","maleWorkers":"1,283","maleMedian":"1,894","femaleWorkers":"327","femaleMedian":"1,644"}}},"Web developers":{"ageData":{"2018":{"total":"208","16to19":"3","20to24":"11","25to34":"74","35to44":"61","45to54":"33","55to64":"23","65+":"4","medianAge":"23"}},"title":"Web developers","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2018":{"total":"208","women":"32.5","white":"81.5","black":"5.4","asian":"8.9","hispanicOrLatino":"7.2"}},"wageData":{"2018":{"workers":"164","median":"1,333","maleWorkers":"115","maleMedian":"1,418","femaleWorkers":"49","femaleMedian":"-"}}},"Computer support specialists":{"ageData":{"2018":{"total":"566","16to19":"5","20to24":"62","25to34":"175","35to44":"128","45to54":"104","55to64":"78","65+":"15","medianAge":"78"}},"title":"Computer support specialists","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2018":{"total":"566","women":"28.1","white":"72.4","black":"12.6","asian":"12.0","hispanicOrLatino":"9.8"}},"wageData":{"2018":{"workers":"516","median":"1,085","maleWorkers":"376","maleMedian":"1,114","femaleWorkers":"140","femaleMedian":"1,015"}}},"Database administrators":{"ageData":{"2018":{"total":"108","16to19":"1","20to24":"7","25to34":"34","35to44":"16","45to54":"24","55to64":"23","65+":"3","medianAge":"23"}},"title":"Database administrators","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2018":{"total":"108","women":"37.9","white":"71.3","black":"8.2","asian":"16.7","hispanicOrLatino":"9.5"}},"wageData":{"2018":{"workers":"108","median":"1,493","maleWorkers":"67","maleMedian":"1,573","femaleWorkers":"40","femaleMedian":"-"}}},"Network and computer systems administrators":{"ageData":{"2018":{"total":"204","16to19":"0","20to24":"4","25to34":"56","35to44":"54","45to54":"52","55to64":"33","65+":"5","medianAge":"33"}},"title":"Network and computer systems administrators","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2018":{"total":"204","women":"21.2","white":"75.8","black":"12.1","asian":"8.5","hispanicOrLatino":"9.3"}},"wageData":{"2018":{"workers":"192","median":"1,430","maleWorkers":"155","maleMedian":"1,478","femaleWorkers":"37","femaleMedian":"-"}}},"Computer network architects":{"ageData":{"2018":{"total":"114","16to19":"0","20to24":"1","25to34":"24","35to44":"34","45to54":"33","55to64":"18","65+":"4","medianAge":"18"}},"title":"Computer network architects","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2018":{"total":"114","women":"10.3","white":"73.0","black":"9.4","asian":"14.7","hispanicOrLatino":"9.9"}},"wageData":{"2018":{"workers":"112","median":"1,765","maleWorkers":"102","maleMedian":"1,771","femaleWorkers":"10","femaleMedian":"-"}}},"Computer occupations, all other":{"ageData":{"2018":{"total":"732","16to19":"8","20to24":"60","25to34":"189","35to44":"197","45to54":"159","55to64":"95","65+":"25","medianAge":"95"}},"title":"Computer occupations, all other","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2018":{"total":"732","women":"21.9","white":"72.1","black":"11.4","asian":"14.9","hispanicOrLatino":"9.5"}},"wageData":{"2018":{"workers":"678","median":"1,226","maleWorkers":"548","maleMedian":"1,238","femaleWorkers":"131","femaleMedian":"1,208"}}},"Actuaries":{"ageData":{"2018":{"total":"33","16to19":"0","20to24":"1","25to34":"9","35to44":"13","45to54":"9","55to64":"1","65+":"0","medianAge":"1"}},"title":"Actuaries","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2018":{"total":"33","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"35","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Mathematicians":{"ageData":{"2018":{"total":"3","16to19":"0","20to24":"0","25to34":"0","35to44":"3","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Mathematicians","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2018":{"total":"3","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"3","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Operations research analysts":{"ageData":{"2018":{"total":"131","16to19":"0","20to24":"4","25to34":"27","35to44":"27","45to54":"39","55to64":"31","65+":"4","medianAge":"31"}},"title":"Operations research analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2018":{"total":"131","women":"49.1","white":"76.9","black":"10.9","asian":"9.8","hispanicOrLatino":"9.9"}},"wageData":{"2018":{"workers":"125","median":"1,418","maleWorkers":"66","maleMedian":"1,566","femaleWorkers":"58","femaleMedian":"1,299"}}},"Statisticians":{"ageData":{"2018":{"total":"90","16to19":"0","20to24":"10","25to34":"30","35to44":"27","45to54":"11","55to64":"8","65+":"3","medianAge":"8"}},"title":"Statisticians","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2018":{"total":"90","women":"53.8","white":"57.0","black":"15.3","asian":"25.5","hispanicOrLatino":"3.7"}},"wageData":{"2018":{"workers":"85","median":"1,437","maleWorkers":"41","maleMedian":"-","femaleWorkers":"43","femaleMedian":"-"}}},"Miscellaneous mathematical science occupations":{"ageData":{"2018":{"total":"8","16to19":"0","20to24":"2","25to34":"3","35to44":"0","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Miscellaneous mathematical science occupations","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2018":{"total":"8","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"5","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Architecture and engineering occupations":{"ageData":{"2018":{"total":"3,263","16to19":"17","20to24":"214","25to34":"864","35to44":"698","45to54":"669","55to64":"636","65+":"165","medianAge":"636"}},"title":"Architecture and engineering occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2018":{"total":"3,263","women":"15.9","white":"79.3","black":"6.5","asian":"11.9","hispanicOrLatino":"8.9"}},"wageData":{"2018":{"workers":"2,994","median":"1,484","maleWorkers":"2,541","maleMedian":"1,528","femaleWorkers":"453","femaleMedian":"1,259"}}},"Architects, except naval":{"ageData":{"2018":{"total":"239","16to19":"0","20to24":"7","25to34":"63","35to44":"55","45to54":"53","55to64":"43","65+":"18","medianAge":"43"}},"title":"Architects, except naval","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2018":{"total":"239","women":"29.7","white":"83.5","black":"4.5","asian":"11.5","hispanicOrLatino":"10.1"}},"wageData":{"2018":{"workers":"170","median":"1,464","maleWorkers":"118","maleMedian":"1,538","femaleWorkers":"52","femaleMedian":"1,301"}}},"Surveyors, cartographers, and photogrammetrists":{"ageData":{"2018":{"total":"47","16to19":"0","20to24":"2","25to34":"8","35to44":"13","45to54":"6","55to64":"12","65+":"5","medianAge":"12"}},"title":"Surveyors, cartographers, and photogrammetrists","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2018":{"total":"47","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"35","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Aerospace engineers":{"ageData":{"2018":{"total":"147","16to19":"0","20to24":"13","25to34":"44","35to44":"25","45to54":"29","55to64":"30","65+":"6","medianAge":"30"}},"title":"Aerospace engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2018":{"total":"147","women":"13.4","white":"70.3","black":"7.1","asian":"17.6","hispanicOrLatino":"7.8"}},"wageData":{"2018":{"workers":"145","median":"1,788","maleWorkers":"129","maleMedian":"1,836","femaleWorkers":"16","femaleMedian":"-"}}},"Agricultural engineers":{"ageData":{"2018":{"total":"5","16to19":"0","20to24":"1","25to34":"2","35to44":"0","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Agricultural engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2018":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Biomedical engineers":{"ageData":{"2018":{"total":"11","16to19":"0","20to24":"2","25to34":"3","35to44":"4","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Biomedical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2018":{"total":"11","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"12","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Chemical engineers":{"ageData":{"2018":{"total":"72","16to19":"0","20to24":"1","25to34":"19","35to44":"20","45to54":"12","55to64":"15","65+":"5","medianAge":"15"}},"title":"Chemical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2018":{"total":"72","women":"16.3","white":"73.7","black":"8.9","asian":"17.3","hispanicOrLatino":"1.9"}},"wageData":{"2018":{"workers":"65","median":"1,858","maleWorkers":"57","maleMedian":"1,858","femaleWorkers":"8","femaleMedian":"-"}}},"Civil engineers":{"ageData":{"2018":{"total":"456","16to19":"1","20to24":"34","25to34":"149","35to44":"89","45to54":"81","55to64":"71","65+":"33","medianAge":"71"}},"title":"Civil engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2018":{"total":"456","women":"14.8","white":"84.8","black":"4.4","asian":"9.3","hispanicOrLatino":"7.9"}},"wageData":{"2018":{"workers":"410","median":"1,495","maleWorkers":"346","maleMedian":"1,551","femaleWorkers":"63","femaleMedian":"1,282"}}},"Computer hardware engineers":{"ageData":{"2018":{"total":"71","16to19":"0","20to24":"5","25to34":"21","35to44":"16","45to54":"15","55to64":"11","65+":"3","medianAge":"11"}},"title":"Computer hardware engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2018":{"total":"71","women":"18.9","white":"58.0","black":"6.9","asian":"30.9","hispanicOrLatino":"14.1"}},"wageData":{"2018":{"workers":"70","median":"1,772","maleWorkers":"60","maleMedian":"1,852","femaleWorkers":"11","femaleMedian":"-"}}},"Electrical and electronics engineers":{"ageData":{"2018":{"total":"269","16to19":"0","20to24":"12","25to34":"66","35to44":"56","45to54":"65","55to64":"56","65+":"14","medianAge":"56"}},"title":"Electrical and electronics engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2018":{"total":"269","women":"9.4","white":"70.2","black":"8.4","asian":"17.8","hispanicOrLatino":"8.1"}},"wageData":{"2018":{"workers":"282","median":"1,646","maleWorkers":"251","maleMedian":"1,661","femaleWorkers":"31","femaleMedian":"-"}}},"Environmental engineers":{"ageData":{"2018":{"total":"36","16to19":"0","20to24":"1","25to34":"8","35to44":"4","45to54":"11","55to64":"9","65+":"3","medianAge":"9"}},"title":"Environmental engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2018":{"total":"36","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"35","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Industrial engineers, including health and safety":{"ageData":{"2018":{"total":"246","16to19":"1","20to24":"12","25to34":"68","35to44":"57","45to54":"42","55to64":"56","65+":"10","medianAge":"56"}},"title":"Industrial engineers, including health and safety","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2018":{"total":"246","women":"23.0","white":"83.2","black":"4.9","asian":"9.0","hispanicOrLatino":"7.4"}},"wageData":{"2018":{"workers":"245","median":"1,499","maleWorkers":"191","maleMedian":"1,571","femaleWorkers":"54","femaleMedian":"1,163"}}},"Marine engineers and naval architects":{"ageData":{"2018":{"total":"17","16to19":"0","20to24":"1","25to34":"7","35to44":"4","45to54":"2","55to64":"4","65+":"0","medianAge":"4"}},"title":"Marine engineers and naval architects","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2018":{"total":"17","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"15","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Materials engineers":{"ageData":{"2018":{"total":"41","16to19":"0","20to24":"3","25to34":"8","35to44":"12","45to54":"9","55to64":"9","65+":"0","medianAge":"9"}},"title":"Materials engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2018":{"total":"41","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"42","median":"-","maleWorkers":"32","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Mechanical engineers":{"ageData":{"2018":{"total":"333","16to19":"1","20to24":"27","25to34":"95","35to44":"73","45to54":"63","55to64":"62","65+":"11","medianAge":"62"}},"title":"Mechanical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2018":{"total":"333","women":"10.9","white":"80.0","black":"3.5","asian":"15.0","hispanicOrLatino":"5.5"}},"wageData":{"2018":{"workers":"313","median":"1,562","maleWorkers":"282","maleMedian":"1,581","femaleWorkers":"31","femaleMedian":"-"}}},"Mining and geological engineers, including mining safety engineers":{"ageData":{"2018":{"total":"8","16to19":"0","20to24":"0","25to34":"2","35to44":"0","45to54":"3","55to64":"2","65+":"0","medianAge":"2"}},"title":"Mining and geological engineers, including mining safety engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2018":{"total":"8","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"8","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Nuclear engineers":{"ageData":{"2018":{"total":"14","16to19":"0","20to24":"1","25to34":"5","35to44":"2","45to54":"3","55to64":"1","65+":"2","medianAge":"1"}},"title":"Nuclear engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2018":{"total":"14","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"13","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Petroleum engineers":{"ageData":{"2018":{"total":"27","16to19":"0","20to24":"4","25to34":"6","35to44":"9","45to54":"4","55to64":"4","65+":"0","medianAge":"4"}},"title":"Petroleum engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2018":{"total":"27","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"27","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Engineers, all other":{"ageData":{"2018":{"total":"576","16to19":"1","20to24":"27","25to34":"157","35to44":"137","45to54":"112","55to64":"115","65+":"27","medianAge":"115"}},"title":"Engineers, all other","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2018":{"total":"576","women":"12.7","white":"77.0","black":"5.9","asian":"15.4","hispanicOrLatino":"9.2"}},"wageData":{"2018":{"workers":"528","median":"1,575","maleWorkers":"463","maleMedian":"1,610","femaleWorkers":"65","femaleMedian":"1,356"}}},"Drafters":{"ageData":{"2018":{"total":"133","16to19":"4","20to24":"15","25to34":"20","35to44":"23","45to54":"35","55to64":"28","65+":"8","medianAge":"28"}},"title":"Drafters","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2018":{"total":"133","women":"20.6","white":"88.5","black":"4.8","asian":"4.6","hispanicOrLatino":"11.0"}},"wageData":{"2018":{"workers":"112","median":"1,021","maleWorkers":"91","maleMedian":"1,029","femaleWorkers":"22","femaleMedian":"-"}}},"Engineering technicians, except drafters":{"ageData":{"2018":{"total":"439","16to19":"7","20to24":"33","25to34":"98","35to44":"88","45to54":"100","55to64":"95","65+":"18","medianAge":"95"}},"title":"Engineering technicians, except drafters","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2018":{"total":"439","women":"18.1","white":"78.4","black":"12.0","asian":"6.2","hispanicOrLatino":"11.1"}},"wageData":{"2018":{"workers":"398","median":"1,129","maleWorkers":"332","maleMedian":"1,154","femaleWorkers":"66","femaleMedian":"934"}}},"Surveying and mapping technicians":{"ageData":{"2018":{"total":"76","16to19":"1","20to24":"13","25to34":"13","35to44":"12","45to54":"23","55to64":"11","65+":"3","medianAge":"11"}},"title":"Surveying and mapping technicians","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2018":{"total":"76","women":"3.2","white":"90.8","black":"4.3","asian":"1.0","hispanicOrLatino":"12.9"}},"wageData":{"2018":{"workers":"63","median":"984","maleWorkers":"60","maleMedian":"995","femaleWorkers":"3","femaleMedian":"-"}}},"Life, physical, and social science occupations":{"ageData":{"2018":{"total":"1,529","16to19":"10","20to24":"135","25to34":"429","35to44":"345","45to54":"283","55to64":"237","65+":"89","medianAge":"237"}},"title":"Life, physical, and social science occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2018":{"total":"1,529","women":"46.7","white":"78.1","black":"7.1","asian":"12.8","hispanicOrLatino":"8.7"}},"wageData":{"2018":{"workers":"1,308","median":"1,270","maleWorkers":"733","maleMedian":"1,357","femaleWorkers":"575","femaleMedian":"1,156"}}},"Agricultural and food scientists":{"ageData":{"2018":{"total":"37","16to19":"0","20to24":"5","25to34":"12","35to44":"7","45to54":"5","55to64":"7","65+":"1","medianAge":"7"}},"title":"Agricultural and food scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2018":{"total":"37","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"30","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Biological scientists":{"ageData":{"2018":{"total":"104","16to19":"0","20to24":"9","25to34":"25","35to44":"31","45to54":"20","55to64":"12","65+":"6","medianAge":"12"}},"title":"Biological scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2018":{"total":"104","women":"47.5","white":"83.6","black":"1.6","asian":"13.7","hispanicOrLatino":"3.6"}},"wageData":{"2018":{"workers":"101","median":"1,250","maleWorkers":"55","maleMedian":"1,164","femaleWorkers":"46","femaleMedian":"-"}}},"Conservation scientists and foresters":{"ageData":{"2018":{"total":"22","16to19":"1","20to24":"3","25to34":"5","35to44":"7","45to54":"3","55to64":"3","65+":"0","medianAge":"3"}},"title":"Conservation scientists and foresters","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2018":{"total":"22","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"17","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Medical scientists":{"ageData":{"2018":{"total":"169","16to19":"2","20to24":"10","25to34":"58","35to44":"43","45to54":"23","55to64":"30","65+":"3","medianAge":"30"}},"title":"Medical scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2018":{"total":"169","women":"52.1","white":"68.8","black":"9.5","asian":"20.7","hispanicOrLatino":"8.6"}},"wageData":{"2018":{"workers":"160","median":"1,319","maleWorkers":"80","maleMedian":"1,416","femaleWorkers":"81","femaleMedian":"1,156"}}},"Life scientists, all other":{"ageData":{"2018":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Life scientists, all other","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2018":{"total":"1","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Astronomers and physicists":{"ageData":{"2018":{"total":"20","16to19":"0","20to24":"2","25to34":"6","35to44":"2","45to54":"5","55to64":"2","65+":"3","medianAge":"2"}},"title":"Astronomers and physicists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2018":{"total":"20","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"14","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Atmospheric and space scientists":{"ageData":{"2018":{"total":"12","16to19":"0","20to24":"0","25to34":"5","35to44":"1","45to54":"3","55to64":"2","65+":"1","medianAge":"2"}},"title":"Atmospheric and space scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2018":{"total":"12","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"7","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Chemists and materials scientists":{"ageData":{"2018":{"total":"118","16to19":"0","20to24":"14","25to34":"29","35to44":"23","45to54":"25","55to64":"21","65+":"5","medianAge":"21"}},"title":"Chemists and materials scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2018":{"total":"118","women":"37.7","white":"78.1","black":"4.2","asian":"16.8","hispanicOrLatino":"7.7"}},"wageData":{"2018":{"workers":"115","median":"1,284","maleWorkers":"70","maleMedian":"1,362","femaleWorkers":"45","femaleMedian":"-"}}},"Environmental scientists and geoscientists":{"ageData":{"2018":{"total":"100","16to19":"1","20to24":"7","25to34":"29","35to44":"23","45to54":"16","55to64":"20","65+":"5","medianAge":"20"}},"title":"Environmental scientists and geoscientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2018":{"total":"100","women":"33.1","white":"90.4","black":"7.8","asian":"1.1","hispanicOrLatino":"8.4"}},"wageData":{"2018":{"workers":"80","median":"1,336","maleWorkers":"52","maleMedian":"1,427","femaleWorkers":"28","femaleMedian":"-"}}},"Physical scientists, all other":{"ageData":{"2018":{"total":"305","16to19":"1","20to24":"19","25to34":"113","35to44":"74","45to54":"51","55to64":"36","65+":"10","medianAge":"36"}},"title":"Physical scientists, all other","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2018":{"total":"305","women":"43.9","white":"65.9","black":"4.7","asian":"26.0","hispanicOrLatino":"6.1"}},"wageData":{"2018":{"workers":"289","median":"1,455","maleWorkers":"169","maleMedian":"1,582","femaleWorkers":"120","femaleMedian":"1,341"}}},"Economists":{"ageData":{"2018":{"total":"36","16to19":"0","20to24":"1","25to34":"11","35to44":"8","45to54":"7","55to64":"8","65+":"1","medianAge":"8"}},"title":"Economists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2018":{"total":"36","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"35","median":"-","maleWorkers":"29","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Survey researchers":{"ageData":{"2018":{"total":"3","16to19":"0","20to24":"1","25to34":"0","35to44":"1","45to54":"0","55to64":"0","65+":"1","medianAge":"0"}},"title":"Survey researchers","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2018":{"total":"3","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Psychologists":{"ageData":{"2018":{"total":"224","16to19":"0","20to24":"1","25to34":"38","35to44":"52","45to54":"63","55to64":"33","65+":"37","medianAge":"33"}},"title":"Psychologists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2018":{"total":"224","women":"75.9","white":"89.0","black":"7.7","asian":"3.0","hispanicOrLatino":"11.2"}},"wageData":{"2018":{"workers":"134","median":"1,331","maleWorkers":"35","maleMedian":"-","femaleWorkers":"99","femaleMedian":"1,255"}}},"Sociologists":{"ageData":{"2018":{"total":"5","16to19":"0","20to24":"0","25to34":"2","35to44":"3","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Sociologists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2018":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"5","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Urban and regional planners":{"ageData":{"2018":{"total":"29","16to19":"0","20to24":"3","25to34":"5","35to44":"8","45to54":"11","55to64":"1","65+":"0","medianAge":"1"}},"title":"Urban and regional planners","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2018":{"total":"29","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"28","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Miscellaneous social scientists and related workers":{"ageData":{"2018":{"total":"46","16to19":"1","20to24":"6","25to34":"7","35to44":"5","45to54":"8","55to64":"12","65+":"7","medianAge":"12"}},"title":"Miscellaneous social scientists and related workers","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2018":{"total":"46","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"39","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"14","femaleMedian":"-"}}},"Agricultural and food science technicians":{"ageData":{"2018":{"total":"36","16to19":"0","20to24":"6","25to34":"6","35to44":"10","45to54":"7","55to64":"4","65+":"3","medianAge":"4"}},"title":"Agricultural and food science technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2018":{"total":"36","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"31","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Biological technicians":{"ageData":{"2018":{"total":"19","16to19":"0","20to24":"4","25to34":"9","35to44":"3","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Biological technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2018":{"total":"19","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"17","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Chemical technicians":{"ageData":{"2018":{"total":"68","16to19":"1","20to24":"8","25to34":"18","35to44":"16","45to54":"11","55to64":"12","65+":"0","medianAge":"12"}},"title":"Chemical technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2018":{"total":"68","women":"25.3","white":"85.7","black":"8.9","asian":"3.0","hispanicOrLatino":"17.6"}},"wageData":{"2018":{"workers":"58","median":"1,002","maleWorkers":"42","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Geological and petroleum technicians":{"ageData":{"2018":{"total":"12","16to19":"0","20to24":"0","25to34":"3","35to44":"4","45to54":"4","55to64":"1","65+":"0","medianAge":"1"}},"title":"Geological and petroleum technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2018":{"total":"12","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"11","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Nuclear technicians":{"ageData":{"2018":{"total":"10","16to19":"0","20to24":"0","25to34":"3","35to44":"0","45to54":"3","55to64":"3","65+":"1","medianAge":"3"}},"title":"Nuclear technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2018":{"total":"10","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"11","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Social science research assistants":{"ageData":{"2018":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Social science research assistants","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2018":{"total":"2","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Miscellaneous life, physical, and social science technicians":{"ageData":{"2018":{"total":"152","16to19":"4","20to24":"33","25to34":"46","35to44":"23","45to54":"15","55to64":"26","65+":"5","medianAge":"26"}},"title":"Miscellaneous life, physical, and social science technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2018":{"total":"152","women":"47.7","white":"77.8","black":"9.1","asian":"11.5","hispanicOrLatino":"11.2"}},"wageData":{"2018":{"workers":"124","median":"862","maleWorkers":"66","maleMedian":"893","femaleWorkers":"58","femaleMedian":"856"}}},"Community and social service occupations":{"ageData":{"2018":{"total":"2,680","16to19":"24","20to24":"145","25to34":"646","35to44":"598","45to54":"561","55to64":"483","65+":"225","medianAge":"483"}},"title":"Community and social service occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2018":{"total":"2,680","women":"66.5","white":"71.8","black":"20.4","asian":"3.9","hispanicOrLatino":"12.1"}},"wageData":{"2018":{"workers":"2,223","median":"913","maleWorkers":"754","maleMedian":"984","femaleWorkers":"1,469","femaleMedian":"886"}}},"Counselors":{"ageData":{"2018":{"total":"895","16to19":"14","20to24":"56","25to34":"223","35to44":"223","45to54":"183","55to64":"140","65+":"56","medianAge":"140"}},"title":"Counselors","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2018":{"total":"895","women":"72.0","white":"70.0","black":"22.2","asian":"3.9","hispanicOrLatino":"12.7"}},"wageData":{"2018":{"workers":"705","median":"941","maleWorkers":"199","maleMedian":"1,004","femaleWorkers":"506","femaleMedian":"913"}}},"Social workers":{"ageData":{"2018":{"total":"835","16to19":"3","20to24":"40","25to34":"227","35to44":"201","45to54":"186","55to64":"132","65+":"46","medianAge":"132"}},"title":"Social workers","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2018":{"total":"835","women":"81.6","white":"68.9","black":"23.6","asian":"3.5","hispanicOrLatino":"13.4"}},"wageData":{"2018":{"workers":"753","median":"907","maleWorkers":"141","maleMedian":"958","femaleWorkers":"611","femaleMedian":"897"}}},"Probation officers and correctional treatment specialists":{"ageData":{"2018":{"total":"104","16to19":"0","20to24":"2","25to34":"36","35to44":"28","45to54":"29","55to64":"9","65+":"2","medianAge":"9"}},"title":"Probation officers and correctional treatment specialists","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2018":{"total":"104","women":"56.9","white":"69.3","black":"27.0","asian":"0.6","hispanicOrLatino":"15.9"}},"wageData":{"2018":{"workers":"105","median":"944","maleWorkers":"45","maleMedian":"-","femaleWorkers":"60","femaleMedian":"930"}}},"Social and human service assistants":{"ageData":{"2018":{"total":"208","16to19":"4","20to24":"24","25to34":"57","35to44":"36","45to54":"41","55to64":"36","65+":"10","medianAge":"36"}},"title":"Social and human service assistants","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2018":{"total":"208","women":"77.7","white":"67.7","black":"21.1","asian":"4.1","hispanicOrLatino":"18.6"}},"wageData":{"2018":{"workers":"166","median":"749","maleWorkers":"33","maleMedian":"-","femaleWorkers":"133","femaleMedian":"752"}}},"Miscellaneous community and social service specialists, including health educators and community health workers":{"ageData":{"2018":{"total":"71","16to19":"0","20to24":"3","25to34":"20","35to44":"16","45to54":"12","55to64":"14","65+":"5","medianAge":"14"}},"title":"Miscellaneous community and social service specialists, including health educators and community health workers","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2018":{"total":"71","women":"76.3","white":"68.8","black":"21.5","asian":"3.3","hispanicOrLatino":"12.4"}},"wageData":{"2018":{"workers":"62","median":"881","maleWorkers":"14","maleMedian":"-","femaleWorkers":"48","femaleMedian":"-"}}},"Clergy":{"ageData":{"2018":{"total":"415","16to19":"0","20to24":"10","25to34":"54","35to44":"67","45to54":"85","55to64":"111","65+":"88","medianAge":"111"}},"title":"Clergy","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2018":{"total":"415","women":"22.4","white":"80.3","black":"12.5","asian":"4.3","hispanicOrLatino":"6.4"}},"wageData":{"2018":{"workers":"337","median":"990","maleWorkers":"268","maleMedian":"1,036","femaleWorkers":"68","femaleMedian":"855"}}},"Directors, religious activities and education":{"ageData":{"2018":{"total":"76","16to19":"0","20to24":"7","25to34":"15","35to44":"16","45to54":"13","55to64":"19","65+":"7","medianAge":"19"}},"title":"Directors, religious activities and education","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2018":{"total":"76","women":"57.8","white":"79.7","black":"8.2","asian":"10.6","hispanicOrLatino":"8.3"}},"wageData":{"2018":{"workers":"51","median":"927","maleWorkers":"27","maleMedian":"-","femaleWorkers":"25","femaleMedian":"-"}}},"Religious workers, all other":{"ageData":{"2018":{"total":"76","16to19":"3","20to24":"4","25to34":"13","35to44":"11","45to54":"12","55to64":"22","65+":"11","medianAge":"22"}},"title":"Religious workers, all other","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2018":{"total":"76","women":"59.2","white":"88.3","black":"6.9","asian":"4.0","hispanicOrLatino":"5.1"}},"wageData":{"2018":{"workers":"45","median":"-","maleWorkers":"27","maleMedian":"-","femaleWorkers":"18","femaleMedian":"-"}}},"Legal occupations":{"ageData":{"2018":{"total":"1,891","16to19":"3","20to24":"39","25to34":"380","35to44":"443","45to54":"424","55to64":"376","65+":"226","medianAge":"376"}},"title":"Legal occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2018":{"total":"1,891","women":"51.6","white":"85.7","black":"7.3","asian":"4.7","hispanicOrLatino":"9.9"}},"wageData":{"2018":{"workers":"1,466","median":"1,467","maleWorkers":"651","maleMedian":"1,910","femaleWorkers":"815","femaleMedian":"1,243"}}},"Lawyers":{"ageData":{"2018":{"total":"1,199","16to19":"1","20to24":"4","25to34":"226","35to44":"307","45to54":"266","55to64":"224","65+":"172","medianAge":"224"}},"title":"Lawyers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2018":{"total":"1,199","women":"37.4","white":"88.0","black":"5.5","asian":"4.9","hispanicOrLatino":"6.1"}},"wageData":{"2018":{"workers":"853","median":"1,947","maleWorkers":"509","maleMedian":"2,202","femaleWorkers":"344","femaleMedian":"1,762"}}},"Judicial law clerks":{"ageData":{"2018":{"total":"13","16to19":"0","20to24":"0","25to34":"9","35to44":"1","45to54":"0","55to64":"1","65+":"1","medianAge":"1"}},"title":"Judicial law clerks","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2018":{"total":"13","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"15","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Judges, magistrates, and other judicial workers":{"ageData":{"2018":{"total":"80","16to19":"0","20to24":"0","25to34":"5","35to44":"12","45to54":"17","55to64":"29","65+":"17","medianAge":"29"}},"title":"Judges, magistrates, and other judicial workers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2018":{"total":"80","women":"32.3","white":"85.4","black":"13.3","asian":"1.2","hispanicOrLatino":"6.7"}},"wageData":{"2018":{"workers":"69","median":"1,602","maleWorkers":"49","maleMedian":"-","femaleWorkers":"19","femaleMedian":"-"}}},"Paralegals and legal assistants":{"ageData":{"2018":{"total":"444","16to19":"2","20to24":"30","25to34":"104","35to44":"92","45to54":"97","55to64":"93","65+":"25","medianAge":"93"}},"title":"Paralegals and legal assistants","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2018":{"total":"444","women":"86.4","white":"79.1","black":"11.3","asian":"5.3","hispanicOrLatino":"18.5"}},"wageData":{"2018":{"workers":"413","median":"948","maleWorkers":"54","maleMedian":"917","femaleWorkers":"359","femaleMedian":"953"}}},"Miscellaneous legal support workers":{"ageData":{"2018":{"total":"156","16to19":"0","20to24":"5","25to34":"36","35to44":"32","45to54":"43","55to64":"28","65+":"11","medianAge":"28"}},"title":"Miscellaneous legal support workers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2018":{"total":"156","women":"73.1","white":"86.8","black":"7.2","asian":"2.9","hispanicOrLatino":"16.6"}},"wageData":{"2018":{"workers":"117","median":"1,143","maleWorkers":"32","maleMedian":"-","femaleWorkers":"85","femaleMedian":"1,109"}}},"Education, training, and library occupations":{"ageData":{"2018":{"total":"9,313","16to19":"122","20to24":"670","25to34":"2,142","35to44":"2,204","45to54":"2,085","55to64":"1,451","65+":"639","medianAge":"1,451"}},"title":"Education, training, and library occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2018":{"total":"9,313","women":"73.2","white":"81.5","black":"10.6","asian":"5.2","hispanicOrLatino":"10.7"}},"wageData":{"2018":{"workers":"7,166","median":"1,002","maleWorkers":"1,915","maleMedian":"1,235","femaleWorkers":"5,251","femaleMedian":"934"}}},"Postsecondary teachers":{"ageData":{"2018":{"total":"1,417","16to19":"10","20to24":"119","25to34":"305","35to44":"304","45to54":"275","55to64":"241","65+":"164","medianAge":"241"}},"title":"Postsecondary teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2018":{"total":"1,417","women":"49.0","white":"75.7","black":"7.9","asian":"13.7","hispanicOrLatino":"7.3"}},"wageData":{"2018":{"workers":"994","median":"1,439","maleWorkers":"534","maleMedian":"1,603","femaleWorkers":"460","femaleMedian":"1,253"}}},"Preschool and kindergarten teachers":{"ageData":{"2018":{"total":"716","16to19":"10","20to24":"83","25to34":"196","35to44":"163","45to54":"149","55to64":"85","65+":"29","medianAge":"85"}},"title":"Preschool and kindergarten teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2018":{"total":"716","women":"97.6","white":"75.8","black":"16.0","asian":"4.0","hispanicOrLatino":"14.5"}},"wageData":{"2018":{"workers":"568","median":"648","maleWorkers":"14","maleMedian":"-","femaleWorkers":"555","femaleMedian":"643"}}},"Elementary and middle school teachers":{"ageData":{"2018":{"total":"3,421","16to19":"11","20to24":"148","25to34":"850","35to44":"925","45to54":"820","55to64":"481","65+":"185","medianAge":"481"}},"title":"Elementary and middle school teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2018":{"total":"3,421","women":"79.8","white":"83.5","black":"11.1","asian":"3.3","hispanicOrLatino":"10.3"}},"wageData":{"2018":{"workers":"3,030","median":"1,010","maleWorkers":"620","maleMedian":"1,148","femaleWorkers":"2,410","femaleMedian":"982"}}},"Secondary school teachers":{"ageData":{"2018":{"total":"1,062","16to19":"3","20to24":"46","25to34":"235","35to44":"300","45to54":"267","55to64":"153","65+":"58","medianAge":"153"}},"title":"Secondary school teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2018":{"total":"1,062","women":"58.0","white":"88.3","black":"7.3","asian":"2.6","hispanicOrLatino":"9.0"}},"wageData":{"2018":{"workers":"948","median":"1,141","maleWorkers":"392","maleMedian":"1,226","femaleWorkers":"556","femaleMedian":"1,092"}}},"Special education teachers":{"ageData":{"2018":{"total":"369","16to19":"0","20to24":"16","25to34":"85","35to44":"98","45to54":"89","55to64":"61","65+":"21","medianAge":"61"}},"title":"Special education teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2018":{"total":"369","women":"87.5","white":"87.8","black":"8.5","asian":"1.6","hispanicOrLatino":"7.6"}},"wageData":{"2018":{"workers":"324","median":"1,039","maleWorkers":"43","maleMedian":"-","femaleWorkers":"281","femaleMedian":"1,042"}}},"Other teachers and instructors":{"ageData":{"2018":{"total":"905","16to19":"49","20to24":"109","25to34":"208","35to44":"139","45to54":"165","55to64":"149","65+":"86","medianAge":"149"}},"title":"Other teachers and instructors","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2018":{"total":"905","women":"61.9","white":"78.8","black":"11.4","asian":"6.1","hispanicOrLatino":"10.5"}},"wageData":{"2018":{"workers":"388","median":"957","maleWorkers":"172","maleMedian":"1,095","femaleWorkers":"215","femaleMedian":"840"}}},"Archivists, curators, and museum technicians":{"ageData":{"2018":{"total":"45","16to19":"1","20to24":"5","25to34":"7","35to44":"9","45to54":"10","55to64":"8","65+":"6","medianAge":"8"}},"title":"Archivists, curators, and museum technicians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2018":{"total":"45","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"37","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"20","femaleMedian":"-"}}},"Librarians":{"ageData":{"2018":{"total":"178","16to19":"2","20to24":"9","25to34":"31","35to44":"38","45to54":"34","55to64":"42","65+":"21","medianAge":"42"}},"title":"Librarians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2018":{"total":"178","women":"78.5","white":"85.5","black":"6.6","asian":"4.7","hispanicOrLatino":"8.4"}},"wageData":{"2018":{"workers":"127","median":"927","maleWorkers":"29","maleMedian":"-","femaleWorkers":"98","femaleMedian":"910"}}},"Library technicians":{"ageData":{"2018":{"total":"33","16to19":"5","20to24":"5","25to34":"6","35to44":"4","45to54":"8","55to64":"5","65+":"2","medianAge":"5"}},"title":"Library technicians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2018":{"total":"33","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"10","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Teacher assistants":{"ageData":{"2018":{"total":"994","16to19":"28","20to24":"115","25to34":"181","35to44":"191","45to54":"228","55to64":"198","65+":"54","medianAge":"198"}},"title":"Teacher assistants","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2018":{"total":"994","women":"88.9","white":"78.7","black":"12.9","asian":"4.6","hispanicOrLatino":"17.4"}},"wageData":{"2018":{"workers":"615","median":"556","maleWorkers":"62","maleMedian":"584","femaleWorkers":"553","femaleMedian":"550"}}},"Other education, training, and library workers":{"ageData":{"2018":{"total":"173","16to19":"3","20to24":"17","25to34":"39","35to44":"32","45to54":"41","55to64":"28","65+":"13","medianAge":"28"}},"title":"Other education, training, and library workers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2018":{"total":"173","women":"73.9","white":"79.1","black":"12.8","asian":"5.4","hispanicOrLatino":"14.3"}},"wageData":{"2018":{"workers":"125","median":"1,095","maleWorkers":"30","maleMedian":"-","femaleWorkers":"95","femaleMedian":"1,036"}}},"Arts, design, entertainment, sports, and media occupations":{"ageData":{"2018":{"total":"3,362","16to19":"111","20to24":"302","25to34":"921","35to44":"667","45to54":"621","55to64":"459","65+":"280","medianAge":"459"}},"title":"Arts, design, entertainment, sports, and media occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2018":{"total":"3,362","women":"46.8","white":"83.6","black":"7.4","asian":"5.5","hispanicOrLatino":"11.8"}},"wageData":{"2018":{"workers":"1,880","median":"1,086","maleWorkers":"1,052","maleMedian":"1,151","femaleWorkers":"828","femaleMedian":"997"}}},"Artists and related workers":{"ageData":{"2018":{"total":"232","16to19":"2","20to24":"19","25to34":"50","35to44":"45","45to54":"41","55to64":"44","65+":"31","medianAge":"44"}},"title":"Artists and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2018":{"total":"232","women":"52.2","white":"82.7","black":"6.0","asian":"5.8","hispanicOrLatino":"9.6"}},"wageData":{"2018":{"workers":"64","median":"1,078","maleWorkers":"46","maleMedian":"-","femaleWorkers":"18","femaleMedian":"-"}}},"Designers":{"ageData":{"2018":{"total":"984","16to19":"15","20to24":"78","25to34":"299","35to44":"200","45to54":"189","55to64":"142","65+":"61","medianAge":"142"}},"title":"Designers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2018":{"total":"984","women":"53.0","white":"86.5","black":"3.7","asian":"7.2","hispanicOrLatino":"13.1"}},"wageData":{"2018":{"workers":"684","median":"1,060","maleWorkers":"357","maleMedian":"1,169","femaleWorkers":"327","femaleMedian":"932"}}},"Actors":{"ageData":{"2018":{"total":"36","16to19":"0","20to24":"3","25to34":"14","35to44":"8","45to54":"7","55to64":"1","65+":"4","medianAge":"1"}},"title":"Actors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2018":{"total":"36","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"7","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Producers and directors":{"ageData":{"2018":{"total":"201","16to19":"0","20to24":"6","25to34":"67","35to44":"55","45to54":"45","55to64":"18","65+":"10","medianAge":"18"}},"title":"Producers and directors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2018":{"total":"201","women":"29.2","white":"83.6","black":"11.3","asian":"2.3","hispanicOrLatino":"7.1"}},"wageData":{"2018":{"workers":"147","median":"1,224","maleWorkers":"98","maleMedian":"1,476","femaleWorkers":"49","femaleMedian":"-"}}},"Athletes, coaches, umpires, and related workers":{"ageData":{"2018":{"total":"359","16to19":"65","20to24":"56","25to34":"89","35to44":"59","45to54":"48","55to64":"22","65+":"19","medianAge":"22"}},"title":"Athletes, coaches, umpires, and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2018":{"total":"359","women":"34.9","white":"81.9","black":"10.7","asian":"2.4","hispanicOrLatino":"11.8"}},"wageData":{"2018":{"workers":"164","median":"1,044","maleWorkers":"129","maleMedian":"1,049","femaleWorkers":"35","femaleMedian":"-"}}},"Dancers and choreographers":{"ageData":{"2018":{"total":"24","16to19":"4","20to24":"7","25to34":"7","35to44":"3","45to54":"0","55to64":"2","65+":"0","medianAge":"2"}},"title":"Dancers and choreographers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2018":{"total":"24","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"11","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Musicians, singers, and related workers":{"ageData":{"2018":{"total":"202","16to19":"4","20to24":"12","25to34":"52","35to44":"41","45to54":"32","55to64":"26","65+":"35","medianAge":"26"}},"title":"Musicians, singers, and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2018":{"total":"202","women":"35.0","white":"75.9","black":"15.1","asian":"5.9","hispanicOrLatino":"10.5"}},"wageData":{"2018":{"workers":"47","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"19","femaleMedian":"-"}}},"Entertainers and performers, sports and related workers, all other":{"ageData":{"2018":{"total":"68","16to19":"2","20to24":"4","25to34":"26","35to44":"10","45to54":"12","55to64":"7","65+":"7","medianAge":"7"}},"title":"Entertainers and performers, sports and related workers, all other","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2018":{"total":"68","women":"51.0","white":"68.3","black":"11.3","asian":"9.7","hispanicOrLatino":"8.0"}},"wageData":{"2018":{"workers":"17","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Announcers":{"ageData":{"2018":{"total":"56","16to19":"3","20to24":"3","25to34":"17","35to44":"10","45to54":"9","55to64":"10","65+":"5","medianAge":"10"}},"title":"Announcers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2018":{"total":"56","women":"17.7","white":"74.5","black":"22.3","asian":"0.5","hispanicOrLatino":"18.7"}},"wageData":{"2018":{"workers":"26","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"News analysts, reporters and correspondents":{"ageData":{"2018":{"total":"79","16to19":"0","20to24":"11","25to34":"24","35to44":"17","45to54":"10","55to64":"14","65+":"4","medianAge":"14"}},"title":"News analysts, reporters and correspondents","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2018":{"total":"79","women":"51.7","white":"80.9","black":"8.7","asian":"4.1","hispanicOrLatino":"15.2"}},"wageData":{"2018":{"workers":"59","median":"1,012","maleWorkers":"29","maleMedian":"-","femaleWorkers":"30","femaleMedian":"-"}}},"Public relations specialists":{"ageData":{"2018":{"total":"140","16to19":"2","20to24":"16","25to34":"42","35to44":"29","45to54":"28","55to64":"17","65+":"6","medianAge":"17"}},"title":"Public relations specialists","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2018":{"total":"140","women":"65.7","white":"86.8","black":"7.1","asian":"4.9","hispanicOrLatino":"10.0"}},"wageData":{"2018":{"workers":"118","median":"1,313","maleWorkers":"40","maleMedian":"-","femaleWorkers":"78","femaleMedian":"1,169"}}},"Editors":{"ageData":{"2018":{"total":"160","16to19":"2","20to24":"10","25to34":"46","35to44":"34","45to54":"31","55to64":"27","65+":"10","medianAge":"27"}},"title":"Editors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2018":{"total":"160","women":"52.2","white":"91.7","black":"1.7","asian":"4.4","hispanicOrLatino":"10.3"}},"wageData":{"2018":{"workers":"124","median":"1,112","maleWorkers":"57","maleMedian":"1,104","femaleWorkers":"67","femaleMedian":"1,138"}}},"Technical writers":{"ageData":{"2018":{"total":"69","16to19":"0","20to24":"1","25to34":"10","35to44":"12","45to54":"15","55to64":"19","65+":"12","medianAge":"19"}},"title":"Technical writers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2018":{"total":"69","women":"55.9","white":"82.4","black":"8.3","asian":"5.6","hispanicOrLatino":"4.8"}},"wageData":{"2018":{"workers":"60","median":"1,318","maleWorkers":"25","maleMedian":"-","femaleWorkers":"35","femaleMedian":"-"}}},"Writers and authors":{"ageData":{"2018":{"total":"227","16to19":"1","20to24":"12","25to34":"50","35to44":"42","45to54":"47","55to64":"43","65+":"33","medianAge":"43"}},"title":"Writers and authors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2018":{"total":"227","women":"59.6","white":"89.1","black":"5.4","asian":"4.0","hispanicOrLatino":"4.5"}},"wageData":{"2018":{"workers":"110","median":"1,233","maleWorkers":"42","maleMedian":"-","femaleWorkers":"68","femaleMedian":"1,036"}}},"Miscellaneous media and communication workers":{"ageData":{"2018":{"total":"111","16to19":"2","20to24":"12","25to34":"13","35to44":"24","45to54":"28","55to64":"19","65+":"13","medianAge":"19"}},"title":"Miscellaneous media and communication workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2018":{"total":"111","women":"70.8","white":"72.9","black":"6.0","asian":"16.0","hispanicOrLatino":"24.9"}},"wageData":{"2018":{"workers":"62","median":"880","maleWorkers":"12","maleMedian":"-","femaleWorkers":"51","femaleMedian":"850"}}},"Broadcast and sound engineering technicians and radio operators":{"ageData":{"2018":{"total":"120","16to19":"8","20to24":"17","25to34":"25","35to44":"24","45to54":"26","55to64":"12","65+":"8","medianAge":"12"}},"title":"Broadcast and sound engineering technicians and radio operators","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2018":{"total":"120","women":"12.4","white":"80.6","black":"11.5","asian":"5.7","hispanicOrLatino":"16.3"}},"wageData":{"2018":{"workers":"73","median":"1,028","maleWorkers":"66","maleMedian":"1,038","femaleWorkers":"7","femaleMedian":"-"}}},"Photographers":{"ageData":{"2018":{"total":"208","16to19":"1","20to24":"21","25to34":"70","35to44":"36","45to54":"37","55to64":"26","65+":"17","medianAge":"26"}},"title":"Photographers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2018":{"total":"208","women":"47.8","white":"83.6","black":"6.8","asian":"5.8","hispanicOrLatino":"11.4"}},"wageData":{"2018":{"workers":"68","median":"904","maleWorkers":"51","maleMedian":"1,006","femaleWorkers":"16","femaleMedian":"-"}}},"Television, video, and motion picture camera operators and editors":{"ageData":{"2018":{"total":"82","16to19":"0","20to24":"13","25to34":"22","35to44":"17","45to54":"15","55to64":"10","65+":"6","medianAge":"10"}},"title":"Television, video, and motion picture camera operators and editors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2018":{"total":"82","women":"16.1","white":"85.6","black":"9.5","asian":"1.7","hispanicOrLatino":"15.7"}},"wageData":{"2018":{"workers":"35","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Media and communication equipment workers, all other":{"ageData":{"2018":{"total":"5","16to19":"0","20to24":"2","25to34":"0","35to44":"0","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Media and communication equipment workers, all other","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2018":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Healthcare practitioners and technical occupations":{"ageData":{"2018":{"total":"9,420","16to19":"33","20to24":"519","25to34":"2,575","35to44":"2,215","45to54":"1,937","55to64":"1,565","65+":"576","medianAge":"1,565"}},"title":"Healthcare practitioners and technical occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2018":{"total":"9,420","women":"75.0","white":"75.2","black":"12.6","asian":"9.9","hispanicOrLatino":"8.5"}},"wageData":{"2018":{"workers":"7,154","median":"1,140","maleWorkers":"1,800","maleMedian":"1,383","femaleWorkers":"5,354","femaleMedian":"1,078"}}},"Chiropractors":{"ageData":{"2018":{"total":"63","16to19":"0","20to24":"2","25to34":"9","35to44":"18","45to54":"15","55to64":"12","65+":"8","medianAge":"12"}},"title":"Chiropractors","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"63","women":"21.1","white":"92.8","black":"0.9","asian":"4.0","hispanicOrLatino":"3.0"}},"wageData":{"2018":{"workers":"15","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Dentists":{"ageData":{"2018":{"total":"162","16to19":"0","20to24":"0","25to34":"39","35to44":"35","45to54":"25","55to64":"35","65+":"28","medianAge":"35"}},"title":"Dentists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"162","women":"35.7","white":"79.0","black":"1.6","asian":"17.6","hispanicOrLatino":"4.3"}},"wageData":{"2018":{"workers":"56","median":"1,884","maleWorkers":"27","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Dietitians and nutritionists":{"ageData":{"2018":{"total":"104","16to19":"1","20to24":"2","25to34":"23","35to44":"19","45to54":"27","55to64":"24","65+":"8","medianAge":"24"}},"title":"Dietitians and nutritionists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"104","women":"93.1","white":"78.6","black":"9.6","asian":"9.1","hispanicOrLatino":"9.6"}},"wageData":{"2018":{"workers":"70","median":"967","maleWorkers":"8","maleMedian":"-","femaleWorkers":"63","femaleMedian":"940"}}},"Optometrists":{"ageData":{"2018":{"total":"54","16to19":"0","20to24":"0","25to34":"9","35to44":"8","45to54":"19","55to64":"9","65+":"9","medianAge":"9"}},"title":"Optometrists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"54","women":"46.0","white":"84.9","black":"2.1","asian":"9.1","hispanicOrLatino":"8.5"}},"wageData":{"2018":{"workers":"29","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"15","femaleMedian":"-"}}},"Pharmacists":{"ageData":{"2018":{"total":"348","16to19":"1","20to24":"17","25to34":"107","35to44":"86","45to54":"62","55to64":"48","65+":"27","medianAge":"48"}},"title":"Pharmacists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"348","women":"63.4","white":"67.9","black":"7.2","asian":"23.1","hispanicOrLatino":"4.4"}},"wageData":{"2018":{"workers":"263","median":"2,071","maleWorkers":"98","maleMedian":"2,271","femaleWorkers":"165","femaleMedian":"1,890"}}},"Physicians and surgeons":{"ageData":{"2018":{"total":"1,094","16to19":"0","20to24":"5","25to34":"239","35to44":"271","45to54":"243","55to64":"211","65+":"125","medianAge":"211"}},"title":"Physicians and surgeons","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"1,094","women":"40.3","white":"70.8","black":"7.6","asian":"19.8","hispanicOrLatino":"7.4"}},"wageData":{"2018":{"workers":"827","median":"2,001","maleWorkers":"475","maleMedian":"2,513","femaleWorkers":"352","femaleMedian":"1,677"}}},"Physician assistants":{"ageData":{"2018":{"total":"132","16to19":"1","20to24":"7","25to34":"55","35to44":"31","45to54":"24","55to64":"12","65+":"3","medianAge":"12"}},"title":"Physician assistants","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"132","women":"72.1","white":"90.3","black":"2.9","asian":"5.1","hispanicOrLatino":"8.2"}},"wageData":{"2018":{"workers":"118","median":"1,752","maleWorkers":"37","maleMedian":"-","femaleWorkers":"80","femaleMedian":"1,646"}}},"Podiatrists":{"ageData":{"2018":{"total":"11","16to19":"0","20to24":"0","25to34":"0","35to44":"4","45to54":"3","55to64":"4","65+":"0","medianAge":"4"}},"title":"Podiatrists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"11","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"4","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Audiologists":{"ageData":{"2018":{"total":"10","16to19":"0","20to24":"2","25to34":"5","35to44":"1","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Audiologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"10","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"8","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Occupational therapists":{"ageData":{"2018":{"total":"116","16to19":"0","20to24":"8","25to34":"39","35to44":"26","45to54":"24","55to64":"12","65+":"6","medianAge":"12"}},"title":"Occupational therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"116","women":"86.8","white":"91.1","black":"2.5","asian":"6.4","hispanicOrLatino":"4.2"}},"wageData":{"2018":{"workers":"80","median":"1,283","maleWorkers":"16","maleMedian":"-","femaleWorkers":"64","femaleMedian":"1,252"}}},"Physical therapists":{"ageData":{"2018":{"total":"286","16to19":"0","20to24":"8","25to34":"96","35to44":"74","45to54":"52","55to64":"43","65+":"12","medianAge":"43"}},"title":"Physical therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"286","women":"69.5","white":"76.4","black":"7.4","asian":"14.3","hispanicOrLatino":"4.3"}},"wageData":{"2018":{"workers":"209","median":"1,395","maleWorkers":"71","maleMedian":"1,410","femaleWorkers":"139","femaleMedian":"1,387"}}},"Radiation therapists":{"ageData":{"2018":{"total":"16","16to19":"0","20to24":"1","25to34":"5","35to44":"3","45to54":"5","55to64":"2","65+":"0","medianAge":"2"}},"title":"Radiation therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"16","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"13","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Recreational therapists":{"ageData":{"2018":{"total":"11","16to19":"0","20to24":"0","25to34":"1","35to44":"3","45to54":"4","55to64":"3","65+":"0","medianAge":"3"}},"title":"Recreational therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"11","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"11","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Respiratory therapists":{"ageData":{"2018":{"total":"108","16to19":"0","20to24":"1","25to34":"33","35to44":"23","45to54":"24","55to64":"17","65+":"10","medianAge":"17"}},"title":"Respiratory therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"108","women":"63.8","white":"64.9","black":"17.3","asian":"13.9","hispanicOrLatino":"11.6"}},"wageData":{"2018":{"workers":"95","median":"1,074","maleWorkers":"36","maleMedian":"-","femaleWorkers":"59","femaleMedian":"1,000"}}},"Speech-language pathologists":{"ageData":{"2018":{"total":"152","16to19":"0","20to24":"4","25to34":"48","35to44":"45","45to54":"32","55to64":"18","65+":"5","medianAge":"18"}},"title":"Speech-language pathologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"152","women":"96.0","white":"94.1","black":"3.5","asian":"1.2","hispanicOrLatino":"4.8"}},"wageData":{"2018":{"workers":"105","median":"1,215","maleWorkers":"6","maleMedian":"-","femaleWorkers":"100","femaleMedian":"1,214"}}},"Exercise physiologists":{"ageData":{"2018":{"total":"5","16to19":"0","20to24":"0","25to34":"1","35to44":"2","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Exercise physiologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"2","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Therapists, all other":{"ageData":{"2018":{"total":"237","16to19":"0","20to24":"10","25to34":"76","35to44":"65","45to54":"45","55to64":"28","65+":"12","medianAge":"28"}},"title":"Therapists, all other","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"237","women":"82.1","white":"75.1","black":"18.1","asian":"5.3","hispanicOrLatino":"8.8"}},"wageData":{"2018":{"workers":"155","median":"1,047","maleWorkers":"33","maleMedian":"-","femaleWorkers":"122","femaleMedian":"1,014"}}},"Veterinarians":{"ageData":{"2018":{"total":"102","16to19":"0","20to24":"1","25to34":"26","35to44":"27","45to54":"22","55to64":"16","65+":"10","medianAge":"16"}},"title":"Veterinarians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"102","women":"71.2","white":"92.9","black":"0.0","asian":"4.1","hispanicOrLatino":"2.3"}},"wageData":{"2018":{"workers":"64","median":"1,677","maleWorkers":"18","maleMedian":"-","femaleWorkers":"46","femaleMedian":"-"}}},"Registered nurses":{"ageData":{"2018":{"total":"3,213","16to19":"2","20to24":"155","25to34":"842","35to44":"745","45to54":"717","55to64":"589","65+":"164","medianAge":"589"}},"title":"Registered nurses","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"3,213","women":"88.6","white":"75.5","black":"13.1","asian":"9.0","hispanicOrLatino":"7.2"}},"wageData":{"2018":{"workers":"2,584","median":"1,167","maleWorkers":"315","maleMedian":"1,271","femaleWorkers":"2,270","femaleMedian":"1,156"}}},"Nurse anesthetists":{"ageData":{"2018":{"total":"26","16to19":"0","20to24":"0","25to34":"10","35to44":"5","45to54":"6","55to64":"4","65+":"1","medianAge":"4"}},"title":"Nurse anesthetists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"26","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"22","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Nurse midwives":{"ageData":{"2018":{"total":"3","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Nurse midwives","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"3","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"2","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Nurse practitioners":{"ageData":{"2018":{"total":"212","16to19":"0","20to24":"1","25to34":"56","35to44":"62","45to54":"47","55to64":"36","65+":"10","medianAge":"36"}},"title":"Nurse practitioners","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"212","women":"87.2","white":"79.1","black":"11.2","asian":"8.8","hispanicOrLatino":"2.6"}},"wageData":{"2018":{"workers":"158","median":"1,894","maleWorkers":"24","maleMedian":"-","femaleWorkers":"134","femaleMedian":"1,891"}}},"Health diagnosing and treating practitioners, all other":{"ageData":{"2018":{"total":"40","16to19":"0","20to24":"0","25to34":"5","35to44":"11","45to54":"11","55to64":"10","65+":"4","medianAge":"10"}},"title":"Health diagnosing and treating practitioners, all other","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"40","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"10","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Clinical laboratory technologists and technicians":{"ageData":{"2018":{"total":"318","16to19":"1","20to24":"18","25to34":"85","35to44":"72","45to54":"65","55to64":"60","65+":"17","medianAge":"60"}},"title":"Clinical laboratory technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"318","women":"75.2","white":"70.0","black":"18.6","asian":"8.5","hispanicOrLatino":"12.9"}},"wageData":{"2018":{"workers":"290","median":"893","maleWorkers":"75","maleMedian":"819","femaleWorkers":"215","femaleMedian":"911"}}},"Dental hygienists":{"ageData":{"2018":{"total":"178","16to19":"0","20to24":"12","25to34":"45","35to44":"33","45to54":"42","55to64":"36","65+":"11","medianAge":"36"}},"title":"Dental hygienists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"178","women":"97.1","white":"88.3","black":"5.6","asian":"3.8","hispanicOrLatino":"8.6"}},"wageData":{"2018":{"workers":"75","median":"1,047","maleWorkers":"3","maleMedian":"-","femaleWorkers":"72","femaleMedian":"1,055"}}},"Diagnostic related technologists and technicians":{"ageData":{"2018":{"total":"346","16to19":"2","20to24":"21","25to34":"90","35to44":"92","45to54":"71","55to64":"62","65+":"7","medianAge":"62"}},"title":"Diagnostic related technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"346","women":"67.9","white":"79.5","black":"11.8","asian":"5.6","hispanicOrLatino":"14.7"}},"wageData":{"2018":{"workers":"269","median":"1,140","maleWorkers":"97","maleMedian":"1,232","femaleWorkers":"172","femaleMedian":"1,061"}}},"Emergency medical technicians and paramedics":{"ageData":{"2018":{"total":"214","16to19":"3","20to24":"33","25to34":"91","35to44":"45","45to54":"25","55to64":"15","65+":"2","medianAge":"15"}},"title":"Emergency medical technicians and paramedics","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"214","women":"33.9","white":"84.3","black":"11.9","asian":"2.2","hispanicOrLatino":"13.9"}},"wageData":{"2018":{"workers":"180","median":"894","maleWorkers":"122","maleMedian":"943","femaleWorkers":"59","femaleMedian":"764"}}},"Health practitioner support technologists and technicians":{"ageData":{"2018":{"total":"694","16to19":"14","20to24":"111","25to34":"251","35to44":"138","45to54":"100","55to64":"66","65+":"14","medianAge":"66"}},"title":"Health practitioner support technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"694","women":"80.6","white":"75.5","black":"14.1","asian":"6.9","hispanicOrLatino":"15.0"}},"wageData":{"2018":{"workers":"542","median":"691","maleWorkers":"112","maleMedian":"807","femaleWorkers":"431","femaleMedian":"655"}}},"Licensed practical and licensed vocational nurses":{"ageData":{"2018":{"total":"658","16to19":"4","20to24":"68","25to34":"156","35to44":"149","45to54":"132","55to64":"101","65+":"47","medianAge":"101"}},"title":"Licensed practical and licensed vocational nurses","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"658","women":"87.8","white":"62.0","black":"30.4","asian":"5.1","hispanicOrLatino":"11.5"}},"wageData":{"2018":{"workers":"490","median":"757","maleWorkers":"56","maleMedian":"936","femaleWorkers":"434","femaleMedian":"743"}}},"Medical records and health information technicians":{"ageData":{"2018":{"total":"171","16to19":"2","20to24":"3","25to34":"28","35to44":"46","45to54":"39","55to64":"42","65+":"10","medianAge":"42"}},"title":"Medical records and health information technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"171","women":"93.6","white":"72.3","black":"15.5","asian":"9.2","hispanicOrLatino":"9.2"}},"wageData":{"2018":{"workers":"140","median":"765","maleWorkers":"11","maleMedian":"-","femaleWorkers":"129","femaleMedian":"739"}}},"Opticians, dispensing":{"ageData":{"2018":{"total":"61","16to19":"0","20to24":"1","25to34":"16","35to44":"14","45to54":"10","55to64":"13","65+":"7","medianAge":"13"}},"title":"Opticians, dispensing","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"61","women":"73.4","white":"85.4","black":"7.3","asian":"4.9","hispanicOrLatino":"6.8"}},"wageData":{"2018":{"workers":"47","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"36","femaleMedian":"-"}}},"Miscellaneous health technologists and technicians":{"ageData":{"2018":{"total":"139","16to19":"1","20to24":"13","25to34":"47","35to44":"26","45to54":"26","55to64":"16","65+":"11","medianAge":"16"}},"title":"Miscellaneous health technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"139","women":"66.5","white":"59.8","black":"24.1","asian":"14.4","hispanicOrLatino":"12.3"}},"wageData":{"2018":{"workers":"117","median":"873","maleWorkers":"44","maleMedian":"-","femaleWorkers":"73","femaleMedian":"791"}}},"Other healthcare practitioners and technical occupations":{"ageData":{"2018":{"total":"137","16to19":"1","20to24":"16","25to34":"41","35to44":"33","45to54":"18","55to64":"21","65+":"8","medianAge":"21"}},"title":"Other healthcare practitioners and technical occupations","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2018":{"total":"137","women":"52.1","white":"81.4","black":"10.2","asian":"4.1","hispanicOrLatino":"10.8"}},"wageData":{"2018":{"workers":"100","median":"1,022","maleWorkers":"48","maleMedian":"-","femaleWorkers":"52","femaleMedian":"961"}}},"Service occupations":{"ageData":{"2018":{"total":"26,854","16to19":"2,092","20to24":"3,668","25to34":"6,150","35to44":"4,898","45to54":"4,816","55to64":"3,772","65+":"1,458","medianAge":"3,772"}},"title":"Service occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2018":{"total":"26,854","women":"57.5","white":"72.0","black":"17.3","asian":"6.1","hispanicOrLatino":"24.4"}},"wageData":{"2018":{"workers":"16,288","median":"569","maleWorkers":"7,948","maleMedian":"641","femaleWorkers":"8,340","femaleMedian":"511"}}},"Healthcare support occupations":{"ageData":{"2018":{"total":"3,629","16to19":"95","20to24":"489","25to34":"951","35to44":"709","45to54":"684","55to64":"560","65+":"141","medianAge":"560"}},"title":"Healthcare support occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2018":{"total":"3,629","women":"87.1","white":"64.3","black":"26.2","asian":"5.7","hispanicOrLatino":"18.3"}},"wageData":{"2018":{"workers":"2,595","median":"561","maleWorkers":"361","maleMedian":"661","femaleWorkers":"2,235","femaleMedian":"548"}}},"Nursing, psychiatric, and home health aides":{"ageData":{"2018":{"total":"2,035","16to19":"61","20to24":"266","25to34":"461","35to44":"397","45to54":"410","55to64":"342","65+":"97","medianAge":"342"}},"title":"Nursing, psychiatric, and home health aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2018":{"total":"2,035","women":"89.3","white":"55.8","black":"35.8","asian":"5.4","hispanicOrLatino":"16.3"}},"wageData":{"2018":{"workers":"1,419","median":"516","maleWorkers":"154","maleMedian":"558","femaleWorkers":"1,265","femaleMedian":"513"}}},"Occupational therapy assistants and aides":{"ageData":{"2018":{"total":"35","16to19":"0","20to24":"0","25to34":"9","35to44":"9","45to54":"8","55to64":"8","65+":"1","medianAge":"8"}},"title":"Occupational therapy assistants and aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2018":{"total":"35","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"24","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"21","femaleMedian":"-"}}},"Physical therapist assistants and aides":{"ageData":{"2018":{"total":"88","16to19":"3","20to24":"15","25to34":"24","35to44":"13","45to54":"21","55to64":"11","65+":"1","medianAge":"11"}},"title":"Physical therapist assistants and aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2018":{"total":"88","women":"67.4","white":"85.0","black":"6.1","asian":"6.7","hispanicOrLatino":"7.1"}},"wageData":{"2018":{"workers":"68","median":"848","maleWorkers":"24","maleMedian":"-","femaleWorkers":"43","femaleMedian":"-"}}},"Massage therapists":{"ageData":{"2018":{"total":"155","16to19":"0","20to24":"8","25to34":"49","35to44":"31","45to54":"26","55to64":"30","65+":"11","medianAge":"30"}},"title":"Massage therapists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2018":{"total":"155","women":"83.2","white":"73.7","black":"9.2","asian":"10.2","hispanicOrLatino":"13.9"}},"wageData":{"2018":{"workers":"40","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"24","femaleMedian":"-"}}},"Dental assistants":{"ageData":{"2018":{"total":"293","16to19":"7","20to24":"45","25to34":"92","35to44":"59","45to54":"53","55to64":"33","65+":"5","medianAge":"33"}},"title":"Dental assistants","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2018":{"total":"293","women":"96.0","white":"80.8","black":"9.9","asian":"3.5","hispanicOrLatino":"27.7"}},"wageData":{"2018":{"workers":"197","median":"606","maleWorkers":"9","maleMedian":"-","femaleWorkers":"187","femaleMedian":"598"}}},"Medical assistants":{"ageData":{"2018":{"total":"570","16to19":"7","20to24":"82","25to34":"202","35to44":"119","45to54":"89","55to64":"56","65+":"14","medianAge":"56"}},"title":"Medical assistants","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2018":{"total":"570","women":"90.6","white":"74.1","black":"15.3","asian":"4.5","hispanicOrLatino":"28.6"}},"wageData":{"2018":{"workers":"499","median":"612","maleWorkers":"45","maleMedian":"-","femaleWorkers":"454","femaleMedian":"607"}}},"Medical transcriptionists":{"ageData":{"2018":{"total":"44","16to19":"2","20to24":"12","25to34":"5","35to44":"4","45to54":"7","55to64":"13","65+":"2","medianAge":"13"}},"title":"Medical transcriptionists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2018":{"total":"44","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"23","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"18","femaleMedian":"-"}}},"Pharmacy aides":{"ageData":{"2018":{"total":"34","16to19":"0","20to24":"4","25to34":"10","35to44":"5","45to54":"6","55to64":"8","65+":"1","medianAge":"8"}},"title":"Pharmacy aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2018":{"total":"34","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"28","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"23","femaleMedian":"-"}}},"Veterinary assistants and laboratory animal caretakers":{"ageData":{"2018":{"total":"56","16to19":"4","20to24":"18","25to34":"19","35to44":"6","45to54":"5","55to64":"4","65+":"0","medianAge":"4"}},"title":"Veterinary assistants and laboratory animal caretakers","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2018":{"total":"56","women":"86.3","white":"84.5","black":"7.0","asian":"2.8","hispanicOrLatino":"9.4"}},"wageData":{"2018":{"workers":"49","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"39","femaleMedian":"-"}}},"Phlebotomists":{"ageData":{"2018":{"total":"115","16to19":"1","20to24":"11","25to34":"36","35to44":"29","45to54":"22","55to64":"15","65+":"2","medianAge":"15"}},"title":"Phlebotomists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2018":{"total":"115","women":"75.0","white":"72.7","black":"16.9","asian":"7.6","hispanicOrLatino":"19.6"}},"wageData":{"2018":{"workers":"96","median":"624","maleWorkers":"29","maleMedian":"-","femaleWorkers":"67","femaleMedian":"602"}}},"Miscellaneous healthcare support occupations, including medical equipment preparers":{"ageData":{"2018":{"total":"204","16to19":"10","20to24":"27","25to34":"42","35to44":"38","45to54":"39","55to64":"41","65+":"7","medianAge":"41"}},"title":"Miscellaneous healthcare support occupations, including medical equipment preparers","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2018":{"total":"204","women":"64.0","white":"63.5","black":"26.4","asian":"8.6","hispanicOrLatino":"11.9"}},"wageData":{"2018":{"workers":"154","median":"598","maleWorkers":"61","maleMedian":"703","femaleWorkers":"93","femaleMedian":"559"}}},"Protective service occupations":{"ageData":{"2018":{"total":"3,203","16to19":"96","20to24":"286","25to34":"829","35to44":"743","45to54":"677","55to64":"416","65+":"155","medianAge":"416"}},"title":"Protective service occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2018":{"total":"3,203","women":"22.5","white":"73.5","black":"20.1","asian":"2.4","hispanicOrLatino":"13.8"}},"wageData":{"2018":{"workers":"2,836","median":"848","maleWorkers":"2,258","maleMedian":"922","femaleWorkers":"578","femaleMedian":"613"}}},"First-line supervisors of correctional officers":{"ageData":{"2018":{"total":"45","16to19":"0","20to24":"1","25to34":"6","35to44":"15","45to54":"17","55to64":"4","65+":"1","medianAge":"4"}},"title":"First-line supervisors of correctional officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2018":{"total":"45","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"47","median":"-","maleWorkers":"35","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"First-line supervisors of police and detectives":{"ageData":{"2018":{"total":"88","16to19":"0","20to24":"0","25to34":"10","35to44":"34","45to54":"28","55to64":"13","65+":"3","medianAge":"13"}},"title":"First-line supervisors of police and detectives","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2018":{"total":"88","women":"17.0","white":"88.8","black":"9.2","asian":"0.4","hispanicOrLatino":"9.4"}},"wageData":{"2018":{"workers":"85","median":"1,460","maleWorkers":"74","maleMedian":"1,461","femaleWorkers":"12","femaleMedian":"-"}}},"First-line supervisors of fire fighting and prevention workers":{"ageData":{"2018":{"total":"49","16to19":"0","20to24":"0","25to34":"3","35to44":"17","45to54":"17","55to64":"11","65+":"1","medianAge":"11"}},"title":"First-line supervisors of fire fighting and prevention workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2018":{"total":"49","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"52","median":"1,304","maleWorkers":"50","maleMedian":"1,321","femaleWorkers":"2","femaleMedian":"-"}}},"First-line supervisors of protective service workers, all other":{"ageData":{"2018":{"total":"86","16to19":"0","20to24":"4","25to34":"16","35to44":"14","45to54":"29","55to64":"18","65+":"6","medianAge":"18"}},"title":"First-line supervisors of protective service workers, all other","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2018":{"total":"86","women":"22.4","white":"72.5","black":"22.1","asian":"1.8","hispanicOrLatino":"8.7"}},"wageData":{"2018":{"workers":"74","median":"839","maleWorkers":"58","maleMedian":"886","femaleWorkers":"16","femaleMedian":"-"}}},"Firefighters":{"ageData":{"2018":{"total":"306","16to19":"2","20to24":"19","25to34":"87","35to44":"117","45to54":"59","55to64":"21","65+":"1","medianAge":"21"}},"title":"Firefighters","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2018":{"total":"306","women":"5.1","white":"87.1","black":"8.9","asian":"1.1","hispanicOrLatino":"7.4"}},"wageData":{"2018":{"workers":"295","median":"1,126","maleWorkers":"280","maleMedian":"1,133","femaleWorkers":"14","femaleMedian":"-"}}},"Fire inspectors":{"ageData":{"2018":{"total":"23","16to19":"0","20to24":"1","25to34":"5","35to44":"6","45to54":"6","55to64":"4","65+":"1","medianAge":"4"}},"title":"Fire inspectors","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2018":{"total":"23","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"18","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Bailiffs, correctional officers, and jailers":{"ageData":{"2018":{"total":"406","16to19":"2","20to24":"38","25to34":"142","35to44":"81","45to54":"79","55to64":"50","65+":"13","medianAge":"50"}},"title":"Bailiffs, correctional officers, and jailers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2018":{"total":"406","women":"29.6","white":"67.0","black":"29.0","asian":"1.2","hispanicOrLatino":"13.7"}},"wageData":{"2018":{"workers":"394","median":"742","maleWorkers":"289","maleMedian":"811","femaleWorkers":"105","femaleMedian":"646"}}},"Detectives and criminal investigators":{"ageData":{"2018":{"total":"164","16to19":"0","20to24":"2","25to34":"34","35to44":"53","45to54":"53","55to64":"19","65+":"3","medianAge":"19"}},"title":"Detectives and criminal investigators","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2018":{"total":"164","women":"24.4","white":"85.3","black":"10.2","asian":"1.0","hispanicOrLatino":"11.2"}},"wageData":{"2018":{"workers":"157","median":"1,331","maleWorkers":"122","maleMedian":"1,317","femaleWorkers":"35","femaleMedian":"-"}}},"Fish and game wardens":{"ageData":{"2018":{"total":"7","16to19":"0","20to24":"0","25to34":"4","35to44":"1","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Fish and game wardens","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2018":{"total":"7","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"6","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Parking enforcement workers":{"ageData":{"2018":{"total":"4","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"3","55to64":"1","65+":"0","medianAge":"1"}},"title":"Parking enforcement workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2018":{"total":"4","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"4","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Police and sheriff\'s patrol officers":{"ageData":{"2018":{"total":"728","16to19":"2","20to24":"46","25to34":"216","35to44":"213","45to54":"178","55to64":"56","65+":"17","medianAge":"56"}},"title":"Police and sheriff\'s patrol officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2018":{"total":"728","women":"15.4","white":"81.7","black":"12.7","asian":"2.1","hispanicOrLatino":"13.5"}},"wageData":{"2018":{"workers":"728","median":"1,092","maleWorkers":"622","maleMedian":"1,131","femaleWorkers":"106","femaleMedian":"816"}}},"Transit and railroad police":{"ageData":{"2018":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Transit and railroad police","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2018":{"total":"2","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Animal control workers":{"ageData":{"2018":{"total":"19","16to19":"0","20to24":"1","25to34":"8","35to44":"2","45to54":"4","55to64":"3","65+":"1","medianAge":"3"}},"title":"Animal control workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2018":{"total":"19","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"13","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Private detectives and investigators":{"ageData":{"2018":{"total":"96","16to19":"0","20to24":"4","25to34":"32","35to44":"23","45to54":"15","55to64":"17","65+":"5","medianAge":"17"}},"title":"Private detectives and investigators","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2018":{"total":"96","women":"49.5","white":"78.2","black":"15.7","asian":"3.3","hispanicOrLatino":"20.2"}},"wageData":{"2018":{"workers":"89","median":"851","maleWorkers":"43","maleMedian":"-","femaleWorkers":"46","femaleMedian":"-"}}},"Security guards and gaming surveillance officers":{"ageData":{"2018":{"total":"958","16to19":"18","20to24":"141","25to34":"237","35to44":"144","45to54":"160","55to64":"174","65+":"84","medianAge":"174"}},"title":"Security guards and gaming surveillance officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2018":{"total":"958","women":"22.4","white":"60.0","black":"30.7","asian":"3.9","hispanicOrLatino":"16.8"}},"wageData":{"2018":{"workers":"781","median":"596","maleWorkers":"594","maleMedian":"636","femaleWorkers":"187","femaleMedian":"506"}}},"Crossing guards":{"ageData":{"2018":{"total":"66","16to19":"0","20to24":"2","25to34":"10","35to44":"10","45to54":"14","55to64":"15","65+":"14","medianAge":"15"}},"title":"Crossing guards","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2018":{"total":"66","women":"53.2","white":"58.4","black":"26.5","asian":"1.9","hispanicOrLatino":"20.9"}},"wageData":{"2018":{"workers":"28","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Transportation security screeners":{"ageData":{"2018":{"total":"41","16to19":"0","20to24":"5","25to34":"13","35to44":"10","45to54":"5","55to64":"5","65+":"2","medianAge":"5"}},"title":"Transportation security screeners","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2018":{"total":"41","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"33","median":"-","maleWorkers":"27","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Lifeguards and other recreational, and all other protective service workers":{"ageData":{"2018":{"total":"117","16to19":"72","20to24":"22","25to34":"6","35to44":"5","45to54":"5","55to64":"3","65+":"3","medianAge":"3"}},"title":"Lifeguards and other recreational, and all other protective service workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2018":{"total":"117","women":"46.3","white":"85.2","black":"6.5","asian":"4.0","hispanicOrLatino":"9.7"}},"wageData":{"2018":{"workers":"31","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Food preparation and serving related occupations":{"ageData":{"2018":{"total":"8,220","16to19":"1,364","20to24":"1,739","25to34":"1,928","35to44":"1,187","45to54":"1,001","55to64":"739","65+":"262","medianAge":"739"}},"title":"Food preparation and serving related occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2018":{"total":"8,220","women":"55.5","white":"73.2","black":"14.8","asian":"6.5","hispanicOrLatino":"25.9"}},"wageData":{"2018":{"workers":"4,394","median":"501","maleWorkers":"2,210","maleMedian":"533","femaleWorkers":"2,184","femaleMedian":"473"}}},"Chefs and head cooks":{"ageData":{"2018":{"total":"427","16to19":"13","20to24":"34","25to34":"122","35to44":"102","45to54":"91","55to64":"47","65+":"18","medianAge":"47"}},"title":"Chefs and head cooks","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2018":{"total":"427","women":"22.0","white":"61.0","black":"17.2","asian":"16.6","hispanicOrLatino":"26.6"}},"wageData":{"2018":{"workers":"365","median":"615","maleWorkers":"300","maleMedian":"624","femaleWorkers":"65","femaleMedian":"562"}}},"First-line supervisors of food preparation and serving workers":{"ageData":{"2018":{"total":"563","16to19":"25","20to24":"89","25to34":"177","35to44":"92","45to54":"88","55to64":"72","65+":"20","medianAge":"72"}},"title":"First-line supervisors of food preparation and serving workers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2018":{"total":"563","women":"57.2","white":"74.5","black":"17.8","asian":"2.8","hispanicOrLatino":"16.8"}},"wageData":{"2018":{"workers":"397","median":"583","maleWorkers":"166","maleMedian":"668","femaleWorkers":"231","femaleMedian":"539"}}},"Cooks":{"ageData":{"2018":{"total":"2,067","16to19":"251","20to24":"312","25to34":"458","35to44":"410","45to54":"339","55to64":"221","65+":"76","medianAge":"221"}},"title":"Cooks","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2018":{"total":"2,067","women":"41.8","white":"71.7","black":"17.6","asian":"6.3","hispanicOrLatino":"34.7"}},"wageData":{"2018":{"workers":"1,325","median":"486","maleWorkers":"804","maleMedian":"518","femaleWorkers":"521","femaleMedian":"437"}}},"Food preparation workers":{"ageData":{"2018":{"total":"988","16to19":"179","20to24":"252","25to34":"195","35to44":"120","45to54":"113","55to64":"92","65+":"35","medianAge":"92"}},"title":"Food preparation workers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2018":{"total":"988","women":"61.0","white":"71.1","black":"15.9","asian":"6.2","hispanicOrLatino":"26.2"}},"wageData":{"2018":{"workers":"473","median":"463","maleWorkers":"206","maleMedian":"486","femaleWorkers":"267","femaleMedian":"446"}}},"Bartenders":{"ageData":{"2018":{"total":"474","16to19":"5","20to24":"87","25to34":"208","35to44":"76","45to54":"54","55to64":"32","65+":"13","medianAge":"32"}},"title":"Bartenders","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2018":{"total":"474","women":"57.2","white":"84.3","black":"7.3","asian":"2.9","hispanicOrLatino":"15.1"}},"wageData":{"2018":{"workers":"275","median":"581","maleWorkers":"124","maleMedian":"601","femaleWorkers":"151","femaleMedian":"560"}}},"Combined food preparation and serving workers, including fast food":{"ageData":{"2018":{"total":"322","16to19":"79","20to24":"71","25to34":"71","35to44":"25","45to54":"28","55to64":"32","65+":"15","medianAge":"32"}},"title":"Combined food preparation and serving workers, including fast food","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2018":{"total":"322","women":"63.0","white":"73.2","black":"17.8","asian":"3.5","hispanicOrLatino":"21.0"}},"wageData":{"2018":{"workers":"147","median":"436","maleWorkers":"64","maleMedian":"410","femaleWorkers":"83","femaleMedian":"475"}}},"Counter attendants, cafeteria, food concession, and coffee shop":{"ageData":{"2018":{"total":"202","16to19":"101","20to24":"46","25to34":"25","35to44":"10","45to54":"6","55to64":"7","65+":"6","medianAge":"7"}},"title":"Counter attendants, cafeteria, food concession, and coffee shop","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2018":{"total":"202","women":"68.8","white":"74.6","black":"15.3","asian":"4.9","hispanicOrLatino":"18.0"}},"wageData":{"2018":{"workers":"41","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"22","femaleMedian":"-"}}},"Waiters and waitresses":{"ageData":{"2018":{"total":"2,020","16to19":"366","20to24":"602","25to34":"494","35to44":"233","45to54":"165","55to64":"129","65+":"31","medianAge":"129"}},"title":"Waiters and waitresses","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2018":{"total":"2,020","women":"69.9","white":"76.0","black":"10.7","asian":"7.6","hispanicOrLatino":"22.6"}},"wageData":{"2018":{"workers":"932","median":"496","maleWorkers":"321","maleMedian":"551","femaleWorkers":"611","femaleMedian":"478"}}},"Food servers, nonrestaurant":{"ageData":{"2018":{"total":"226","16to19":"35","20to24":"49","25to34":"42","35to44":"25","45to54":"27","55to64":"36","65+":"13","medianAge":"36"}},"title":"Food servers, nonrestaurant","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2018":{"total":"226","women":"70.2","white":"61.2","black":"25.5","asian":"8.4","hispanicOrLatino":"22.2"}},"wageData":{"2018":{"workers":"106","median":"484","maleWorkers":"32","maleMedian":"-","femaleWorkers":"74","femaleMedian":"475"}}},"Dining room and cafeteria attendants and bartender helpers":{"ageData":{"2018":{"total":"309","16to19":"81","20to24":"52","25to34":"51","35to44":"36","45to54":"40","55to64":"36","65+":"12","medianAge":"36"}},"title":"Dining room and cafeteria attendants and bartender helpers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2018":{"total":"309","women":"45.7","white":"73.1","black":"13.5","asian":"6.0","hispanicOrLatino":"29.2"}},"wageData":{"2018":{"workers":"118","median":"447","maleWorkers":"59","maleMedian":"500","femaleWorkers":"58","femaleMedian":"408"}}},"Dishwashers":{"ageData":{"2018":{"total":"263","16to19":"66","20to24":"38","25to34":"44","35to44":"41","45to54":"37","55to64":"24","65+":"12","medianAge":"24"}},"title":"Dishwashers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2018":{"total":"263","women":"24.3","white":"74.3","black":"13.2","asian":"5.7","hispanicOrLatino":"27.9"}},"wageData":{"2018":{"workers":"111","median":"441","maleWorkers":"89","maleMedian":"434","femaleWorkers":"22","femaleMedian":"-"}}},"Hosts and hostesses, restaurant, lounge, and coffee shop":{"ageData":{"2018":{"total":"354","16to19":"160","20to24":"105","25to34":"37","35to44":"17","45to54":"13","55to64":"11","65+":"10","medianAge":"11"}},"title":"Hosts and hostesses, restaurant, lounge, and coffee shop","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2018":{"total":"354","women":"81.6","white":"75.1","black":"12.9","asian":"4.5","hispanicOrLatino":"27.0"}},"wageData":{"2018":{"workers":"102","median":"471","maleWorkers":"24","maleMedian":"-","femaleWorkers":"78","femaleMedian":"473"}}},"Food preparation and serving related workers, all other":{"ageData":{"2018":{"total":"5","16to19":"1","20to24":"0","25to34":"3","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Food preparation and serving related workers, all other","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2018":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Building and grounds cleaning and maintenance occupations":{"ageData":{"2018":{"total":"5,854","16to19":"189","20to24":"423","25to34":"1,118","35to44":"1,181","45to54":"1,367","55to64":"1,152","65+":"424","medianAge":"1,152"}},"title":"Building and grounds cleaning and maintenance occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2018":{"total":"5,854","women":"41.3","white":"77.3","black":"14.8","asian":"3.1","hispanicOrLatino":"38.8"}},"wageData":{"2018":{"workers":"3,695","median":"551","maleWorkers":"2,373","maleMedian":"604","femaleWorkers":"1,322","femaleMedian":"477"}}},"First-line supervisors of housekeeping and janitorial workers":{"ageData":{"2018":{"total":"339","16to19":"1","20to24":"11","25to34":"51","35to44":"74","45to54":"106","55to64":"75","65+":"22","medianAge":"75"}},"title":"First-line supervisors of housekeeping and janitorial workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2018":{"total":"339","women":"42.4","white":"75.5","black":"15.9","asian":"3.6","hispanicOrLatino":"25.1"}},"wageData":{"2018":{"workers":"193","median":"711","maleWorkers":"116","maleMedian":"772","femaleWorkers":"77","femaleMedian":"615"}}},"First-line supervisors of landscaping, lawn service, and groundskeeping workers":{"ageData":{"2018":{"total":"254","16to19":"3","20to24":"7","25to34":"48","35to44":"67","45to54":"64","55to64":"45","65+":"20","medianAge":"45"}},"title":"First-line supervisors of landscaping, lawn service, and groundskeeping workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2018":{"total":"254","women":"8.0","white":"88.3","black":"6.5","asian":"1.5","hispanicOrLatino":"26.2"}},"wageData":{"2018":{"workers":"95","median":"770","maleWorkers":"93","maleMedian":"774","femaleWorkers":"2","femaleMedian":"-"}}},"Janitors and building cleaners":{"ageData":{"2018":{"total":"2,342","16to19":"89","20to24":"152","25to34":"403","35to44":"423","45to54":"542","55to64":"535","65+":"197","medianAge":"535"}},"title":"Janitors and building cleaners","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2018":{"total":"2,342","women":"34.1","white":"73.0","black":"19.1","asian":"3.5","hispanicOrLatino":"32.8"}},"wageData":{"2018":{"workers":"1,672","median":"571","maleWorkers":"1,193","maleMedian":"607","femaleWorkers":"480","femaleMedian":"491"}}},"Maids and housekeeping cleaners":{"ageData":{"2018":{"total":"1,512","16to19":"35","20to24":"93","25to34":"247","35to44":"323","45to54":"399","55to64":"309","65+":"107","medianAge":"309"}},"title":"Maids and housekeeping cleaners","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2018":{"total":"1,512","women":"90.1","white":"74.1","black":"16.1","asian":"4.5","hispanicOrLatino":"49.3"}},"wageData":{"2018":{"workers":"825","median":"467","maleWorkers":"102","maleMedian":"559","femaleWorkers":"723","femaleMedian":"457"}}},"Pest control workers":{"ageData":{"2018":{"total":"79","16to19":"1","20to24":"8","25to34":"20","35to44":"16","45to54":"17","55to64":"15","65+":"1","medianAge":"15"}},"title":"Pest control workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2018":{"total":"79","women":"8.4","white":"84.9","black":"10.6","asian":"0.0","hispanicOrLatino":"12.2"}},"wageData":{"2018":{"workers":"75","median":"688","maleWorkers":"70","maleMedian":"725","femaleWorkers":"4","femaleMedian":"-"}}},"Grounds maintenance workers":{"ageData":{"2018":{"total":"1,328","16to19":"61","20to24":"152","25to34":"348","35to44":"277","45to54":"239","55to64":"173","65+":"77","medianAge":"173"}},"title":"Grounds maintenance workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2018":{"total":"1,328","women":"6.7","white":"86.5","black":"7.5","asian":"1.0","hispanicOrLatino":"45.0"}},"wageData":{"2018":{"workers":"834","median":"572","maleWorkers":"798","maleMedian":"576","femaleWorkers":"36","femaleMedian":"-"}}},"Personal care and service occupations":{"ageData":{"2018":{"total":"5,947","16to19":"347","20to24":"730","25to34":"1,324","35to44":"1,077","45to54":"1,088","55to64":"905","65+":"476","medianAge":"905"}},"title":"Personal care and service occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2018":{"total":"5,947","women":"76.9","white":"69.2","black":"16.3","asian":"10.5","hispanicOrLatino":"17.8"}},"wageData":{"2018":{"workers":"2,768","median":"544","maleWorkers":"746","maleMedian":"638","femaleWorkers":"2,022","femaleMedian":"517"}}},"First-line supervisors of gaming workers":{"ageData":{"2018":{"total":"187","16to19":"6","20to24":"18","25to34":"54","35to44":"31","45to54":"41","55to64":"22","65+":"14","medianAge":"22"}},"title":"First-line supervisors of gaming workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2018":{"total":"187","women":"44.4","white":"79.8","black":"10.4","asian":"4.1","hispanicOrLatino":"10.2"}},"wageData":{"2018":{"workers":"125","median":"793","maleWorkers":"83","maleMedian":"914","femaleWorkers":"43","femaleMedian":"-"}}},"First-line supervisors of personal service workers":{"ageData":{"2018":{"total":"208","16to19":"1","20to24":"10","25to34":"47","35to44":"52","45to54":"53","55to64":"31","65+":"14","medianAge":"31"}},"title":"First-line supervisors of personal service workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2018":{"total":"208","women":"73.3","white":"69.5","black":"11.9","asian":"17.8","hispanicOrLatino":"9.5"}},"wageData":{"2018":{"workers":"86","median":"747","maleWorkers":"27","maleMedian":"-","femaleWorkers":"60","femaleMedian":"739"}}},"Animal trainers":{"ageData":{"2018":{"total":"55","16to19":"6","20to24":"4","25to34":"19","35to44":"7","45to54":"10","55to64":"5","65+":"5","medianAge":"5"}},"title":"Animal trainers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2018":{"total":"55","women":"72.6","white":"87.2","black":"1.7","asian":"4.4","hispanicOrLatino":"10.5"}},"wageData":{"2018":{"workers":"11","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Nonfarm animal caretakers":{"ageData":{"2018":{"total":"268","16to19":"29","20to24":"51","25to34":"64","35to44":"41","45to54":"34","55to64":"39","65+":"10","medianAge":"39"}},"title":"Nonfarm animal caretakers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2018":{"total":"268","women":"77.6","white":"92.1","black":"3.8","asian":"1.8","hispanicOrLatino":"9.8"}},"wageData":{"2018":{"workers":"102","median":"555","maleWorkers":"24","maleMedian":"-","femaleWorkers":"79","femaleMedian":"548"}}},"Gaming services workers":{"ageData":{"2018":{"total":"102","16to19":"3","20to24":"6","25to34":"23","35to44":"19","45to54":"21","55to64":"19","65+":"10","medianAge":"19"}},"title":"Gaming services workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2018":{"total":"102","women":"47.8","white":"49.7","black":"10.6","asian":"30.3","hispanicOrLatino":"6.7"}},"wageData":{"2018":{"workers":"73","median":"654","maleWorkers":"37","maleMedian":"-","femaleWorkers":"36","femaleMedian":"-"}}},"Motion picture projectionists":{"ageData":{"2018":{"total":"1","16to19":"1","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Motion picture projectionists","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2018":{"total":"1","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Ushers, lobby attendants, and ticket takers":{"ageData":{"2018":{"total":"35","16to19":"12","20to24":"6","25to34":"5","35to44":"2","45to54":"2","55to64":"3","65+":"4","medianAge":"3"}},"title":"Ushers, lobby attendants, and ticket takers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2018":{"total":"35","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"5","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Miscellaneous entertainment attendants and related workers":{"ageData":{"2018":{"total":"210","16to19":"58","20to24":"59","25to34":"30","35to44":"11","45to54":"13","55to64":"20","65+":"19","medianAge":"20"}},"title":"Miscellaneous entertainment attendants and related workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2018":{"total":"210","women":"38.3","white":"80.5","black":"7.7","asian":"5.5","hispanicOrLatino":"16.8"}},"wageData":{"2018":{"workers":"85","median":"523","maleWorkers":"56","maleMedian":"518","femaleWorkers":"28","femaleMedian":"-"}}},"Embalmers and funeral attendants":{"ageData":{"2018":{"total":"17","16to19":"0","20to24":"1","25to34":"2","35to44":"2","45to54":"1","55to64":"2","65+":"8","medianAge":"2"}},"title":"Embalmers and funeral attendants","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2018":{"total":"17","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"11","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Morticians, undertakers, and funeral directors":{"ageData":{"2018":{"total":"34","16to19":"0","20to24":"1","25to34":"4","35to44":"4","45to54":"6","55to64":"12","65+":"7","medianAge":"12"}},"title":"Morticians, undertakers, and funeral directors","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2018":{"total":"34","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"27","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Barbers":{"ageData":{"2018":{"total":"132","16to19":"0","20to24":"10","25to34":"33","35to44":"29","45to54":"24","55to64":"17","65+":"20","medianAge":"17"}},"title":"Barbers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2018":{"total":"132","women":"21.0","white":"62.0","black":"30.2","asian":"5.3","hispanicOrLatino":"27.3"}},"wageData":{"2018":{"workers":"48","median":"-","maleWorkers":"34","maleMedian":"-","femaleWorkers":"15","femaleMedian":"-"}}},"Hairdressers, hairstylists, and cosmetologists":{"ageData":{"2018":{"total":"834","16to19":"11","20to24":"82","25to34":"210","35to44":"192","45to54":"161","55to64":"107","65+":"70","medianAge":"107"}},"title":"Hairdressers, hairstylists, and cosmetologists","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2018":{"total":"834","women":"92.1","white":"75.7","black":"14.2","asian":"7.3","hispanicOrLatino":"17.6"}},"wageData":{"2018":{"workers":"309","median":"545","maleWorkers":"22","maleMedian":"-","femaleWorkers":"287","femaleMedian":"548"}}},"Miscellaneous personal appearance workers":{"ageData":{"2018":{"total":"449","16to19":"6","20to24":"38","25to34":"104","35to44":"120","45to54":"107","55to64":"57","65+":"17","medianAge":"57"}},"title":"Miscellaneous personal appearance workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2018":{"total":"449","women":"83.6","white":"31.2","black":"9.1","asian":"57.2","hispanicOrLatino":"10.8"}},"wageData":{"2018":{"workers":"258","median":"523","maleWorkers":"52","maleMedian":"615","femaleWorkers":"206","femaleMedian":"512"}}},"Baggage porters, bellhops, and concierges":{"ageData":{"2018":{"total":"92","16to19":"3","20to24":"13","25to34":"21","35to44":"13","45to54":"15","55to64":"22","65+":"5","medianAge":"22"}},"title":"Baggage porters, bellhops, and concierges","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2018":{"total":"92","women":"22.6","white":"49.7","black":"37.7","asian":"10.3","hispanicOrLatino":"26.1"}},"wageData":{"2018":{"workers":"73","median":"620","maleWorkers":"59","maleMedian":"652","femaleWorkers":"13","femaleMedian":"-"}}},"Tour and travel guides":{"ageData":{"2018":{"total":"65","16to19":"5","20to24":"15","25to34":"8","35to44":"9","45to54":"9","55to64":"12","65+":"7","medianAge":"12"}},"title":"Tour and travel guides","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2018":{"total":"65","women":"43.6","white":"85.0","black":"6.4","asian":"2.9","hispanicOrLatino":"13.4"}},"wageData":{"2018":{"workers":"22","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Childcare workers":{"ageData":{"2018":{"total":"1,193","16to19":"127","20to24":"182","25to34":"245","35to44":"185","45to54":"199","55to64":"179","65+":"76","medianAge":"179"}},"title":"Childcare workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2018":{"total":"1,193","women":"94.0","white":"76.7","black":"15.5","asian":"4.1","hispanicOrLatino":"24.3"}},"wageData":{"2018":{"workers":"437","median":"500","maleWorkers":"32","maleMedian":"-","femaleWorkers":"405","femaleMedian":"492"}}},"Personal care aides":{"ageData":{"2018":{"total":"1,354","16to19":"36","20to24":"134","25to34":"269","35to44":"225","45to54":"285","55to64":"267","65+":"139","medianAge":"267"}},"title":"Personal care aides","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2018":{"total":"1,354","women":"84.4","white":"62.3","black":"24.6","asian":"8.3","hispanicOrLatino":"22.4"}},"wageData":{"2018":{"workers":"786","median":"500","maleWorkers":"132","maleMedian":"555","femaleWorkers":"654","femaleMedian":"493"}}},"Recreation and fitness workers":{"ageData":{"2018":{"total":"497","16to19":"33","20to24":"69","25to34":"124","35to44":"99","45to54":"75","55to64":"64","65+":"33","medianAge":"64"}},"title":"Recreation and fitness workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2018":{"total":"497","women":"60.5","white":"76.0","black":"15.6","asian":"4.3","hispanicOrLatino":"9.2"}},"wageData":{"2018":{"workers":"208","median":"603","maleWorkers":"100","maleMedian":"724","femaleWorkers":"109","femaleMedian":"543"}}},"Residential advisors":{"ageData":{"2018":{"total":"41","16to19":"2","20to24":"11","25to34":"11","35to44":"5","45to54":"6","55to64":"5","65+":"2","medianAge":"5"}},"title":"Residential advisors","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2018":{"total":"41","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"29","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"18","femaleMedian":"-"}}},"Personal care and service workers, all other":{"ageData":{"2018":{"total":"171","16to19":"10","20to24":"20","25to34":"49","35to44":"30","45to54":"23","55to64":"22","65+":"17","medianAge":"22"}},"title":"Personal care and service workers, all other","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2018":{"total":"171","women":"68.1","white":"72.2","black":"17.8","asian":"5.4","hispanicOrLatino":"15.3"}},"wageData":{"2018":{"workers":"74","median":"522","maleWorkers":"32","maleMedian":"-","femaleWorkers":"42","femaleMedian":"-"}}},"Sales and office occupations":{"ageData":{"2018":{"total":"33,461","16to19":"1,714","20to24":"3,995","25to34":"7,106","35to44":"6,099","45to54":"6,471","55to64":"5,752","65+":"2,324","medianAge":"5,752"}},"title":"Sales and office occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2018":{"total":"33,461","women":"61.1","white":"78.6","black":"12.8","asian":"4.9","hispanicOrLatino":"16.6"}},"wageData":{"2018":{"workers":"23,714","median":"742","maleWorkers":"9,548","maleMedian":"846","femaleWorkers":"14,166","femaleMedian":"696"}}},"Sales and related occupations":{"ageData":{"2018":{"total":"15,806","16to19":"1,142","20to24":"2,000","25to34":"3,210","35to44":"2,827","45to54":"2,941","55to64":"2,512","65+":"1,174","medianAge":"2,512"}},"title":"Sales and related occupations","depth":2,"parent":"Sales and office occupations","sexRaceEthnicityData":{"2018":{"total":"15,806","women":"49.4","white":"80.2","black":"11.0","asian":"5.3","hispanicOrLatino":"16.3"}},"wageData":{"2018":{"workers":"10,077","median":"798","maleWorkers":"5,621","maleMedian":"949","femaleWorkers":"4,455","femaleMedian":"651"}}},"First-line supervisors of retail sales workers":{"ageData":{"2018":{"total":"3,366","16to19":"30","20to24":"253","25to34":"832","35to44":"745","45to54":"710","55to64":"576","65+":"218","medianAge":"576"}},"title":"First-line supervisors of retail sales workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2018":{"total":"3,366","women":"44.6","white":"80.8","black":"10.2","asian":"5.3","hispanicOrLatino":"13.9"}},"wageData":{"2018":{"workers":"2,421","median":"795","maleWorkers":"1,359","maleMedian":"911","femaleWorkers":"1,062","femaleMedian":"672"}}},"First-line supervisors of non-retail sales workers":{"ageData":{"2018":{"total":"1,257","16to19":"4","20to24":"27","25to34":"218","35to44":"281","45to54":"337","55to64":"270","65+":"119","medianAge":"270"}},"title":"First-line supervisors of non-retail sales workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2018":{"total":"1,257","women":"28.5","white":"84.7","black":"6.9","asian":"6.4","hispanicOrLatino":"15.0"}},"wageData":{"2018":{"workers":"893","median":"1,153","maleWorkers":"588","maleMedian":"1,199","femaleWorkers":"305","femaleMedian":"1,054"}}},"Cashiers":{"ageData":{"2018":{"total":"3,200","16to19":"792","20to24":"774","25to34":"539","35to44":"336","45to54":"298","55to64":"302","65+":"158","medianAge":"302"}},"title":"Cashiers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2018":{"total":"3,200","women":"73.8","white":"70.3","black":"17.3","asian":"6.6","hispanicOrLatino":"24.5"}},"wageData":{"2018":{"workers":"1,390","median":"465","maleWorkers":"377","maleMedian":"468","femaleWorkers":"1,013","femaleMedian":"463"}}},"Counter and rental clerks":{"ageData":{"2018":{"total":"114","16to19":"9","20to24":"19","25to34":"27","35to44":"24","45to54":"14","55to64":"16","65+":"4","medianAge":"16"}},"title":"Counter and rental clerks","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2018":{"total":"114","women":"40.6","white":"71.4","black":"20.4","asian":"5.8","hispanicOrLatino":"24.6"}},"wageData":{"2018":{"workers":"82","median":"729","maleWorkers":"51","maleMedian":"769","femaleWorkers":"30","femaleMedian":"-"}}},"Parts salespersons":{"ageData":{"2018":{"total":"127","16to19":"4","20to24":"11","25to34":"22","35to44":"26","45to54":"23","55to64":"30","65+":"11","medianAge":"30"}},"title":"Parts salespersons","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2018":{"total":"127","women":"10.4","white":"82.2","black":"9.2","asian":"2.8","hispanicOrLatino":"19.3"}},"wageData":{"2018":{"workers":"109","median":"702","maleWorkers":"98","maleMedian":"718","femaleWorkers":"11","femaleMedian":"-"}}},"Retail salespersons":{"ageData":{"2018":{"total":"3,147","16to19":"272","20to24":"607","25to34":"687","35to44":"419","45to54":"476","55to64":"446","65+":"239","medianAge":"446"}},"title":"Retail salespersons","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2018":{"total":"3,147","women":"48.7","white":"78.7","black":"12.6","asian":"5.1","hispanicOrLatino":"18.2"}},"wageData":{"2018":{"workers":"1,860","median":"657","maleWorkers":"1,144","maleMedian":"764","femaleWorkers":"716","femaleMedian":"543"}}},"Advertising sales agents":{"ageData":{"2018":{"total":"221","16to19":"2","20to24":"21","25to34":"58","35to44":"49","45to54":"56","55to64":"28","65+":"8","medianAge":"28"}},"title":"Advertising sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2018":{"total":"221","women":"50.4","white":"81.2","black":"10.4","asian":"4.8","hispanicOrLatino":"14.9"}},"wageData":{"2018":{"workers":"169","median":"998","maleWorkers":"91","maleMedian":"950","femaleWorkers":"79","femaleMedian":"1,053"}}},"Insurance sales agents":{"ageData":{"2018":{"total":"619","16to19":"1","20to24":"40","25to34":"117","35to44":"153","45to54":"115","55to64":"131","65+":"62","medianAge":"131"}},"title":"Insurance sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2018":{"total":"619","women":"51.4","white":"83.3","black":"8.7","asian":"5.3","hispanicOrLatino":"11.6"}},"wageData":{"2018":{"workers":"466","median":"859","maleWorkers":"205","maleMedian":"1,048","femaleWorkers":"261","femaleMedian":"809"}}},"Securities, commodities, and financial services sales agents":{"ageData":{"2018":{"total":"231","16to19":"1","20to24":"14","25to34":"58","35to44":"53","45to54":"46","55to64":"41","65+":"19","medianAge":"41"}},"title":"Securities, commodities, and financial services sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2018":{"total":"231","women":"31.8","white":"85.6","black":"6.3","asian":"6.8","hispanicOrLatino":"11.9"}},"wageData":{"2018":{"workers":"197","median":"1,440","maleWorkers":"131","maleMedian":"1,639","femaleWorkers":"66","femaleMedian":"1,047"}}},"Travel agents":{"ageData":{"2018":{"total":"79","16to19":"0","20to24":"3","25to34":"11","35to44":"13","45to54":"21","55to64":"19","65+":"12","medianAge":"19"}},"title":"Travel agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2018":{"total":"79","women":"85.5","white":"77.9","black":"17.7","asian":"4.4","hispanicOrLatino":"9.9"}},"wageData":{"2018":{"workers":"53","median":"789","maleWorkers":"10","maleMedian":"-","femaleWorkers":"43","femaleMedian":"-"}}},"Sales representatives, services, all other":{"ageData":{"2018":{"total":"516","16to19":"3","20to24":"47","25to34":"124","35to44":"108","45to54":"127","55to64":"79","65+":"28","medianAge":"79"}},"title":"Sales representatives, services, all other","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2018":{"total":"516","women":"30.0","white":"89.0","black":"6.5","asian":"2.9","hispanicOrLatino":"7.5"}},"wageData":{"2018":{"workers":"427","median":"1,230","maleWorkers":"315","maleMedian":"1,345","femaleWorkers":"113","femaleMedian":"933"}}},"Sales representatives, wholesale and manufacturing":{"ageData":{"2018":{"total":"1,273","16to19":"9","20to24":"64","25to34":"228","35to44":"288","45to54":"342","55to64":"262","65+":"80","medianAge":"262"}},"title":"Sales representatives, wholesale and manufacturing","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2018":{"total":"1,273","women":"27.6","white":"90.8","black":"4.1","asian":"2.9","hispanicOrLatino":"11.2"}},"wageData":{"2018":{"workers":"1,112","median":"1,161","maleWorkers":"817","maleMedian":"1,239","femaleWorkers":"295","femaleMedian":"1,009"}}},"Models, demonstrators, and product promoters":{"ageData":{"2018":{"total":"60","16to19":"4","20to24":"9","25to34":"10","35to44":"4","45to54":"8","55to64":"9","65+":"16","medianAge":"9"}},"title":"Models, demonstrators, and product promoters","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2018":{"total":"60","women":"72.1","white":"79.0","black":"8.8","asian":"7.2","hispanicOrLatino":"13.4"}},"wageData":{"2018":{"workers":"15","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Real estate brokers and sales agents":{"ageData":{"2018":{"total":"1,072","16to19":"5","20to24":"51","25to34":"162","35to44":"220","45to54":"265","55to64":"221","65+":"149","medianAge":"221"}},"title":"Real estate brokers and sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2018":{"total":"1,072","women":"56.2","white":"86.0","black":"6.4","asian":"6.1","hispanicOrLatino":"10.8"}},"wageData":{"2018":{"workers":"528","median":"1,019","maleWorkers":"236","maleMedian":"1,264","femaleWorkers":"291","femaleMedian":"883"}}},"Sales engineers":{"ageData":{"2018":{"total":"34","16to19":"0","20to24":"2","25to34":"9","35to44":"4","45to54":"10","55to64":"8","65+":"1","medianAge":"8"}},"title":"Sales engineers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2018":{"total":"34","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"38","median":"-","maleWorkers":"34","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Telemarketers":{"ageData":{"2018":{"total":"58","16to19":"2","20to24":"13","25to34":"19","35to44":"13","45to54":"3","55to64":"6","65+":"2","medianAge":"6"}},"title":"Telemarketers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2018":{"total":"58","women":"65.3","white":"69.3","black":"23.3","asian":"3.7","hispanicOrLatino":"22.9"}},"wageData":{"2018":{"workers":"50","median":"559","maleWorkers":"19","maleMedian":"-","femaleWorkers":"31","femaleMedian":"-"}}},"Door-to-door sales workers, news and street vendors, and related workers":{"ageData":{"2018":{"total":"158","16to19":"1","20to24":"17","25to34":"22","35to44":"32","45to54":"35","55to64":"29","65+":"22","medianAge":"29"}},"title":"Door-to-door sales workers, news and street vendors, and related workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2018":{"total":"158","women":"60.9","white":"86.1","black":"10.6","asian":"1.3","hispanicOrLatino":"22.8"}},"wageData":{"2018":{"workers":"41","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Sales and related workers, all other":{"ageData":{"2018":{"total":"275","16to19":"4","20to24":"27","25to34":"68","35to44":"58","45to54":"55","55to64":"41","65+":"24","medianAge":"41"}},"title":"Sales and related workers, all other","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2018":{"total":"275","women":"48.4","white":"85.0","black":"8.7","asian":"4.5","hispanicOrLatino":"7.2"}},"wageData":{"2018":{"workers":"227","median":"1,036","maleWorkers":"118","maleMedian":"1,323","femaleWorkers":"109","femaleMedian":"873"}}},"Office and administrative support occupations":{"ageData":{"2018":{"total":"17,655","16to19":"572","20to24":"1,995","25to34":"3,896","35to44":"3,272","45to54":"3,530","55to64":"3,240","65+":"1,150","medianAge":"3,240"}},"title":"Office and administrative support occupations","depth":2,"parent":"Sales and office occupations","sexRaceEthnicityData":{"2018":{"total":"17,655","women":"71.6","white":"77.1","black":"14.4","asian":"4.6","hispanicOrLatino":"16.9"}},"wageData":{"2018":{"workers":"13,637","median":"717","maleWorkers":"3,926","maleMedian":"738","femaleWorkers":"9,711","femaleMedian":"711"}}},"First-line supervisors of office and administrative support workers":{"ageData":{"2018":{"total":"1,450","16to19":"3","20to24":"66","25to34":"290","35to44":"335","45to54":"386","55to64":"288","65+":"82","medianAge":"288"}},"title":"First-line supervisors of office and administrative support workers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"1,450","women":"71.7","white":"81.6","black":"11.2","asian":"3.5","hispanicOrLatino":"13.5"}},"wageData":{"2018":{"workers":"1,279","median":"885","maleWorkers":"386","maleMedian":"1,050","femaleWorkers":"892","femaleMedian":"835"}}},"Switchboard operators, including answering service":{"ageData":{"2018":{"total":"23","16to19":"0","20to24":"3","25to34":"2","35to44":"4","45to54":"5","55to64":"5","65+":"3","medianAge":"5"}},"title":"Switchboard operators, including answering service","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"23","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"21","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"19","femaleMedian":"-"}}},"Telephone operators":{"ageData":{"2018":{"total":"30","16to19":"0","20to24":"4","25to34":"10","35to44":"5","45to54":"3","55to64":"4","65+":"3","medianAge":"4"}},"title":"Telephone operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"30","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"29","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"22","femaleMedian":"-"}}},"Communications equipment operators, all other":{"ageData":{"2018":{"total":"9","16to19":"0","20to24":"1","25to34":"2","35to44":"2","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Communications equipment operators, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"9","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"7","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Bill and account collectors":{"ageData":{"2018":{"total":"122","16to19":"2","20to24":"16","25to34":"31","35to44":"36","45to54":"19","55to64":"12","65+":"5","medianAge":"12"}},"title":"Bill and account collectors","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"122","women":"71.1","white":"69.4","black":"24.0","asian":"1.4","hispanicOrLatino":"21.3"}},"wageData":{"2018":{"workers":"114","median":"711","maleWorkers":"28","maleMedian":"-","femaleWorkers":"85","femaleMedian":"694"}}},"Billing and posting clerks":{"ageData":{"2018":{"total":"490","16to19":"2","20to24":"37","25to34":"106","35to44":"112","45to54":"115","55to64":"93","65+":"25","medianAge":"93"}},"title":"Billing and posting clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"490","women":"87.1","white":"77.0","black":"13.8","asian":"5.2","hispanicOrLatino":"18.0"}},"wageData":{"2018":{"workers":"417","median":"721","maleWorkers":"56","maleMedian":"664","femaleWorkers":"361","femaleMedian":"725"}}},"Bookkeeping, accounting, and auditing clerks":{"ageData":{"2018":{"total":"1,045","16to19":"5","20to24":"44","25to34":"139","35to44":"192","45to54":"247","55to64":"281","65+":"137","medianAge":"281"}},"title":"Bookkeeping, accounting, and auditing clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"1,045","women":"86.7","white":"87.5","black":"7.0","asian":"3.7","hispanicOrLatino":"10.2"}},"wageData":{"2018":{"workers":"679","median":"742","maleWorkers":"104","maleMedian":"778","femaleWorkers":"575","femaleMedian":"739"}}},"Gaming cage workers":{"ageData":{"2018":{"total":"8","16to19":"0","20to24":"1","25to34":"4","35to44":"2","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Gaming cage workers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"8","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"7","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Payroll and timekeeping clerks":{"ageData":{"2018":{"total":"121","16to19":"0","20to24":"4","25to34":"24","35to44":"27","45to54":"27","55to64":"31","65+":"7","medianAge":"31"}},"title":"Payroll and timekeeping clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"121","women":"89.8","white":"78.2","black":"13.3","asian":"6.6","hispanicOrLatino":"14.9"}},"wageData":{"2018":{"workers":"111","median":"827","maleWorkers":"11","maleMedian":"-","femaleWorkers":"100","femaleMedian":"807"}}},"Procurement clerks":{"ageData":{"2018":{"total":"31","16to19":"0","20to24":"2","25to34":"8","35to44":"6","45to54":"8","55to64":"6","65+":"0","medianAge":"6"}},"title":"Procurement clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"31","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"30","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"14","femaleMedian":"-"}}},"Tellers":{"ageData":{"2018":{"total":"300","16to19":"10","20to24":"74","25to34":"98","35to44":"36","45to54":"32","55to64":"38","65+":"12","medianAge":"38"}},"title":"Tellers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"300","women":"85.4","white":"77.2","black":"12.7","asian":"6.1","hispanicOrLatino":"17.8"}},"wageData":{"2018":{"workers":"240","median":"584","maleWorkers":"34","maleMedian":"-","femaleWorkers":"206","femaleMedian":"584"}}},"Financial clerks, all other":{"ageData":{"2018":{"total":"92","16to19":"0","20to24":"16","25to34":"30","35to44":"13","45to54":"14","55to64":"17","65+":"2","medianAge":"17"}},"title":"Financial clerks, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"92","women":"61.9","white":"76.7","black":"9.2","asian":"7.7","hispanicOrLatino":"23.2"}},"wageData":{"2018":{"workers":"77","median":"839","maleWorkers":"30","maleMedian":"-","femaleWorkers":"48","femaleMedian":"-"}}},"Brokerage clerks":{"ageData":{"2018":{"total":"4","16to19":"0","20to24":"0","25to34":"0","35to44":"3","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Brokerage clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"4","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"5","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Correspondence clerks":{"ageData":{"2018":{"total":"4","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"1","55to64":"1","65+":"1","medianAge":"1"}},"title":"Correspondence clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"4","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"5","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Court, municipal, and license clerks":{"ageData":{"2018":{"total":"83","16to19":"0","20to24":"2","25to34":"12","35to44":"21","45to54":"19","55to64":"23","65+":"6","medianAge":"23"}},"title":"Court, municipal, and license clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"83","women":"76.5","white":"79.1","black":"12.6","asian":"2.9","hispanicOrLatino":"16.1"}},"wageData":{"2018":{"workers":"78","median":"897","maleWorkers":"17","maleMedian":"-","femaleWorkers":"61","femaleMedian":"804"}}},"Credit authorizers, checkers, and clerks":{"ageData":{"2018":{"total":"54","16to19":"0","20to24":"4","25to34":"14","35to44":"12","45to54":"14","55to64":"8","65+":"1","medianAge":"8"}},"title":"Credit authorizers, checkers, and clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"54","women":"64.5","white":"67.2","black":"28.9","asian":"2.7","hispanicOrLatino":"12.3"}},"wageData":{"2018":{"workers":"50","median":"818","maleWorkers":"21","maleMedian":"-","femaleWorkers":"30","femaleMedian":"-"}}},"Customer service representatives":{"ageData":{"2018":{"total":"2,563","16to19":"177","20to24":"454","25to34":"678","35to44":"404","45to54":"405","55to64":"344","65+":"102","medianAge":"344"}},"title":"Customer service representatives","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"2,563","women":"63.7","white":"72.8","black":"17.8","asian":"4.7","hispanicOrLatino":"19.1"}},"wageData":{"2018":{"workers":"1,904","median":"683","maleWorkers":"678","maleMedian":"689","femaleWorkers":"1,226","femaleMedian":"680"}}},"Eligibility interviewers, government programs":{"ageData":{"2018":{"total":"68","16to19":"1","20to24":"2","25to34":"18","35to44":"16","45to54":"13","55to64":"12","65+":"6","medianAge":"12"}},"title":"Eligibility interviewers, government programs","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"68","women":"80.0","white":"65.9","black":"25.2","asian":"3.1","hispanicOrLatino":"20.5"}},"wageData":{"2018":{"workers":"67","median":"887","maleWorkers":"14","maleMedian":"-","femaleWorkers":"53","femaleMedian":"841"}}},"File clerks":{"ageData":{"2018":{"total":"161","16to19":"10","20to24":"18","25to34":"29","35to44":"33","45to54":"26","55to64":"32","65+":"14","medianAge":"32"}},"title":"File clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"161","women":"76.8","white":"78.3","black":"15.1","asian":"5.5","hispanicOrLatino":"15.5"}},"wageData":{"2018":{"workers":"110","median":"650","maleWorkers":"23","maleMedian":"-","femaleWorkers":"86","femaleMedian":"624"}}},"Hotel, motel, and resort desk clerks":{"ageData":{"2018":{"total":"131","16to19":"6","20to24":"37","25to34":"43","35to44":"15","45to54":"16","55to64":"9","65+":"5","medianAge":"9"}},"title":"Hotel, motel, and resort desk clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"131","women":"68.6","white":"71.2","black":"13.7","asian":"5.9","hispanicOrLatino":"21.8"}},"wageData":{"2018":{"workers":"85","median":"520","maleWorkers":"29","maleMedian":"-","femaleWorkers":"56","femaleMedian":"505"}}},"Interviewers, except eligibility and loan":{"ageData":{"2018":{"total":"152","16to19":"4","20to24":"16","25to34":"32","35to44":"25","45to54":"35","55to64":"26","65+":"15","medianAge":"26"}},"title":"Interviewers, except eligibility and loan","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"152","women":"81.6","white":"70.0","black":"21.7","asian":"3.1","hispanicOrLatino":"16.4"}},"wageData":{"2018":{"workers":"114","median":"702","maleWorkers":"18","maleMedian":"-","femaleWorkers":"96","femaleMedian":"686"}}},"Library assistants, clerical":{"ageData":{"2018":{"total":"103","16to19":"4","20to24":"19","25to34":"21","35to44":"14","45to54":"10","55to64":"24","65+":"9","medianAge":"24"}},"title":"Library assistants, clerical","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"103","women":"78.0","white":"84.9","black":"9.5","asian":"3.8","hispanicOrLatino":"8.3"}},"wageData":{"2018":{"workers":"34","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"26","femaleMedian":"-"}}},"Loan interviewers and clerks":{"ageData":{"2018":{"total":"117","16to19":"1","20to24":"7","25to34":"35","35to44":"25","45to54":"21","55to64":"20","65+":"9","medianAge":"20"}},"title":"Loan interviewers and clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"117","women":"80.8","white":"74.5","black":"13.9","asian":"9.5","hispanicOrLatino":"11.7"}},"wageData":{"2018":{"workers":"115","median":"827","maleWorkers":"16","maleMedian":"-","femaleWorkers":"99","femaleMedian":"797"}}},"New accounts clerks":{"ageData":{"2018":{"total":"23","16to19":"3","20to24":"2","25to34":"4","35to44":"5","45to54":"3","55to64":"5","65+":"1","medianAge":"5"}},"title":"New accounts clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"23","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"21","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Order clerks":{"ageData":{"2018":{"total":"78","16to19":"5","20to24":"11","25to34":"23","35to44":"13","45to54":"12","55to64":"9","65+":"5","medianAge":"9"}},"title":"Order clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"78","women":"49.1","white":"70.3","black":"13.2","asian":"8.2","hispanicOrLatino":"17.7"}},"wageData":{"2018":{"workers":"57","median":"659","maleWorkers":"28","maleMedian":"-","femaleWorkers":"29","femaleMedian":"-"}}},"Human resources assistants, except payroll and timekeeping":{"ageData":{"2018":{"total":"57","16to19":"0","20to24":"5","25to34":"12","35to44":"14","45to54":"17","55to64":"7","65+":"3","medianAge":"7"}},"title":"Human resources assistants, except payroll and timekeeping","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"57","women":"83.3","white":"68.8","black":"20.1","asian":"6.0","hispanicOrLatino":"12.3"}},"wageData":{"2018":{"workers":"53","median":"816","maleWorkers":"7","maleMedian":"-","femaleWorkers":"45","femaleMedian":"-"}}},"Receptionists and information clerks":{"ageData":{"2018":{"total":"1,324","16to19":"66","20to24":"239","25to34":"329","35to44":"197","45to54":"203","55to64":"196","65+":"93","medianAge":"196"}},"title":"Receptionists and information clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"1,324","women":"90.5","white":"79.5","black":"13.2","asian":"3.2","hispanicOrLatino":"20.4"}},"wageData":{"2018":{"workers":"934","median":"605","maleWorkers":"81","maleMedian":"593","femaleWorkers":"853","femaleMedian":"606"}}},"Reservation and transportation ticket agents and travel clerks":{"ageData":{"2018":{"total":"128","16to19":"2","20to24":"13","25to34":"30","35to44":"29","45to54":"25","55to64":"24","65+":"4","medianAge":"24"}},"title":"Reservation and transportation ticket agents and travel clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"128","women":"59.4","white":"67.0","black":"17.3","asian":"5.3","hispanicOrLatino":"21.9"}},"wageData":{"2018":{"workers":"109","median":"745","maleWorkers":"50","maleMedian":"681","femaleWorkers":"60","femaleMedian":"766"}}},"Information and record clerks, all other":{"ageData":{"2018":{"total":"121","16to19":"5","20to24":"9","25to34":"21","35to44":"28","45to54":"23","55to64":"29","65+":"8","medianAge":"29"}},"title":"Information and record clerks, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"121","women":"77.6","white":"79.7","black":"11.7","asian":"6.8","hispanicOrLatino":"15.2"}},"wageData":{"2018":{"workers":"95","median":"733","maleWorkers":"24","maleMedian":"-","femaleWorkers":"71","femaleMedian":"724"}}},"Cargo and freight agents":{"ageData":{"2018":{"total":"30","16to19":"0","20to24":"1","25to34":"8","35to44":"4","45to54":"6","55to64":"10","65+":"1","medianAge":"10"}},"title":"Cargo and freight agents","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"30","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"18","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Couriers and messengers":{"ageData":{"2018":{"total":"293","16to19":"7","20to24":"33","25to34":"74","35to44":"53","45to54":"58","55to64":"50","65+":"17","medianAge":"50"}},"title":"Couriers and messengers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"293","women":"21.1","white":"70.8","black":"21.1","asian":"4.3","hispanicOrLatino":"20.3"}},"wageData":{"2018":{"workers":"192","median":"786","maleWorkers":"164","maleMedian":"821","femaleWorkers":"29","femaleMedian":"-"}}},"Dispatchers":{"ageData":{"2018":{"total":"293","16to19":"4","20to24":"23","25to34":"76","35to44":"70","45to54":"62","55to64":"48","65+":"9","medianAge":"48"}},"title":"Dispatchers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"293","women":"60.7","white":"79.3","black":"15.2","asian":"2.8","hispanicOrLatino":"13.3"}},"wageData":{"2018":{"workers":"270","median":"783","maleWorkers":"108","maleMedian":"926","femaleWorkers":"162","femaleMedian":"725"}}},"Meter readers, utilities":{"ageData":{"2018":{"total":"24","16to19":"0","20to24":"2","25to34":"8","35to44":"7","45to54":"1","55to64":"2","65+":"3","medianAge":"2"}},"title":"Meter readers, utilities","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"24","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"24","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Postal service clerks":{"ageData":{"2018":{"total":"120","16to19":"0","20to24":"6","25to34":"18","35to44":"24","45to54":"37","55to64":"30","65+":"6","medianAge":"30"}},"title":"Postal service clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"120","women":"54.9","white":"46.5","black":"40.9","asian":"8.3","hispanicOrLatino":"8.6"}},"wageData":{"2018":{"workers":"115","median":"765","maleWorkers":"51","maleMedian":"758","femaleWorkers":"63","femaleMedian":"771"}}},"Postal service mail carriers":{"ageData":{"2018":{"total":"302","16to19":"0","20to24":"10","25to34":"63","35to44":"64","45to54":"75","55to64":"73","65+":"16","medianAge":"73"}},"title":"Postal service mail carriers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"302","women":"39.8","white":"64.8","black":"23.6","asian":"6.9","hispanicOrLatino":"13.3"}},"wageData":{"2018":{"workers":"288","median":"931","maleWorkers":"170","maleMedian":"983","femaleWorkers":"118","femaleMedian":"808"}}},"Postal service mail sorters, processors, and processing machine operators":{"ageData":{"2018":{"total":"58","16to19":"0","20to24":"1","25to34":"10","35to44":"12","45to54":"14","55to64":"18","65+":"3","medianAge":"18"}},"title":"Postal service mail sorters, processors, and processing machine operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"58","women":"56.6","white":"50.5","black":"41.1","asian":"4.4","hispanicOrLatino":"11.7"}},"wageData":{"2018":{"workers":"53","median":"980","maleWorkers":"22","maleMedian":"-","femaleWorkers":"32","femaleMedian":"-"}}},"Production, planning, and expediting clerks":{"ageData":{"2018":{"total":"269","16to19":"0","20to24":"12","25to34":"70","35to44":"61","45to54":"65","55to64":"47","65+":"14","medianAge":"47"}},"title":"Production, planning, and expediting clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"269","women":"54.0","white":"80.0","black":"9.4","asian":"7.3","hispanicOrLatino":"12.5"}},"wageData":{"2018":{"workers":"252","median":"870","maleWorkers":"119","maleMedian":"1,004","femaleWorkers":"134","femaleMedian":"790"}}},"Shipping, receiving, and traffic clerks":{"ageData":{"2018":{"total":"578","16to19":"13","20to24":"70","25to34":"134","35to44":"131","45to54":"108","55to64":"102","65+":"20","medianAge":"102"}},"title":"Shipping, receiving, and traffic clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"578","women":"29.1","white":"76.2","black":"15.2","asian":"3.1","hispanicOrLatino":"23.6"}},"wageData":{"2018":{"workers":"524","median":"632","maleWorkers":"365","maleMedian":"654","femaleWorkers":"160","femaleMedian":"590"}}},"Stock clerks and order fillers":{"ageData":{"2018":{"total":"1,527","16to19":"154","20to24":"331","25to34":"379","35to44":"224","45to54":"201","55to64":"173","65+":"66","medianAge":"173"}},"title":"Stock clerks and order fillers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"1,527","women":"37.4","white":"70.2","black":"19.7","asian":"4.5","hispanicOrLatino":"22.9"}},"wageData":{"2018":{"workers":"988","median":"562","maleWorkers":"629","maleMedian":"558","femaleWorkers":"359","femaleMedian":"570"}}},"Weighers, measurers, checkers, and samplers, recordkeeping":{"ageData":{"2018":{"total":"56","16to19":"0","20to24":"9","25to34":"13","35to44":"9","45to54":"10","55to64":"9","65+":"6","medianAge":"9"}},"title":"Weighers, measurers, checkers, and samplers, recordkeeping","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"56","women":"38.9","white":"86.1","black":"9.5","asian":"4.0","hispanicOrLatino":"18.1"}},"wageData":{"2018":{"workers":"44","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"14","femaleMedian":"-"}}},"Secretaries and administrative assistants":{"ageData":{"2018":{"total":"2,569","16to19":"22","20to24":"138","25to34":"427","35to44":"474","45to54":"646","55to64":"633","65+":"228","medianAge":"633"}},"title":"Secretaries and administrative assistants","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"2,569","women":"94.0","white":"84.8","black":"8.9","asian":"3.3","hispanicOrLatino":"13.5"}},"wageData":{"2018":{"workers":"1,977","median":"759","maleWorkers":"122","maleMedian":"903","femaleWorkers":"1,855","femaleMedian":"753"}}},"Computer operators":{"ageData":{"2018":{"total":"73","16to19":"1","20to24":"7","25to34":"17","35to44":"15","45to54":"9","55to64":"14","65+":"9","medianAge":"14"}},"title":"Computer operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"73","women":"63.8","white":"72.4","black":"16.8","asian":"9.5","hispanicOrLatino":"10.7"}},"wageData":{"2018":{"workers":"67","median":"763","maleWorkers":"27","maleMedian":"-","femaleWorkers":"40","femaleMedian":"-"}}},"Data entry keyers":{"ageData":{"2018":{"total":"270","16to19":"2","20to24":"25","25to34":"65","35to44":"57","45to54":"61","55to64":"47","65+":"13","medianAge":"47"}},"title":"Data entry keyers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"270","women":"77.2","white":"71.7","black":"17.0","asian":"9.1","hispanicOrLatino":"18.1"}},"wageData":{"2018":{"workers":"224","median":"655","maleWorkers":"52","maleMedian":"730","femaleWorkers":"173","femaleMedian":"643"}}},"Word processors and typists":{"ageData":{"2018":{"total":"67","16to19":"3","20to24":"7","25to34":"12","35to44":"11","45to54":"11","55to64":"17","65+":"8","medianAge":"17"}},"title":"Word processors and typists","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"67","women":"85.1","white":"62.9","black":"22.2","asian":"8.0","hispanicOrLatino":"15.9"}},"wageData":{"2018":{"workers":"53","median":"858","maleWorkers":"9","maleMedian":"-","femaleWorkers":"43","femaleMedian":"-"}}},"Desktop publishers":{"ageData":{"2018":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Desktop publishers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"1","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Insurance claims and policy processing clerks":{"ageData":{"2018":{"total":"244","16to19":"1","20to24":"20","25to34":"66","35to44":"52","45to54":"51","55to64":"43","65+":"11","medianAge":"43"}},"title":"Insurance claims and policy processing clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"244","women":"82.5","white":"80.7","black":"14.9","asian":"2.6","hispanicOrLatino":"14.8"}},"wageData":{"2018":{"workers":"211","median":"719","maleWorkers":"36","maleMedian":"-","femaleWorkers":"175","femaleMedian":"713"}}},"Mail clerks and mail machine operators, except postal service":{"ageData":{"2018":{"total":"63","16to19":"2","20to24":"5","25to34":"13","35to44":"10","45to54":"17","55to64":"11","65+":"6","medianAge":"11"}},"title":"Mail clerks and mail machine operators, except postal service","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"63","women":"41.5","white":"70.5","black":"20.6","asian":"2.5","hispanicOrLatino":"20.5"}},"wageData":{"2018":{"workers":"44","median":"-","maleWorkers":"31","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Office clerks, general":{"ageData":{"2018":{"total":"1,309","16to19":"48","20to24":"150","25to34":"255","35to44":"235","45to54":"256","55to64":"252","65+":"114","medianAge":"252"}},"title":"Office clerks, general","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"1,309","women":"84.5","white":"75.7","black":"14.2","asian":"7.0","hispanicOrLatino":"19.1"}},"wageData":{"2018":{"workers":"925","median":"697","maleWorkers":"128","maleMedian":"670","femaleWorkers":"797","femaleMedian":"701"}}},"Office machine operators, except computer":{"ageData":{"2018":{"total":"24","16to19":"2","20to24":"2","25to34":"4","35to44":"5","45to54":"5","55to64":"3","65+":"3","medianAge":"3"}},"title":"Office machine operators, except computer","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"24","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"13","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Proofreaders and copy markers":{"ageData":{"2018":{"total":"11","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"3","55to64":"4","65+":"2","medianAge":"4"}},"title":"Proofreaders and copy markers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"11","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"7","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Statistical assistants":{"ageData":{"2018":{"total":"40","16to19":"0","20to24":"3","25to34":"12","35to44":"7","45to54":"5","55to64":"12","65+":"1","medianAge":"12"}},"title":"Statistical assistants","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"40","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"41","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"25","femaleMedian":"-"}}},"Office and administrative support workers, all other":{"ageData":{"2018":{"total":"540","16to19":"4","20to24":"34","25to34":"123","35to44":"124","45to54":"127","55to64":"92","65+":"35","medianAge":"92"}},"title":"Office and administrative support workers, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2018":{"total":"540","women":"78.5","white":"78.1","black":"14.0","asian":"5.0","hispanicOrLatino":"14.1"}},"wageData":{"2018":{"workers":"456","median":"794","maleWorkers":"104","maleMedian":"920","femaleWorkers":"352","femaleMedian":"762"}}},"Natural resources, construction, and maintenance occupations":{"ageData":{"2018":{"total":"14,471","16to19":"356","20to24":"1,241","25to34":"3,383","35to44":"3,434","45to54":"3,041","55to64":"2,433","65+":"584","medianAge":"2,433"}},"title":"Natural resources, construction, and maintenance occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2018":{"total":"14,471","women":"5.1","white":"86.2","black":"7.6","asian":"2.2","hispanicOrLatino":"31.9"}},"wageData":{"2018":{"workers":"11,546","median":"824","maleWorkers":"11,030","maleMedian":"834","femaleWorkers":"516","femaleMedian":"638"}}},"Farming, fishing, and forestry occupations":{"ageData":{"2018":{"total":"1,121","16to19":"89","20to24":"136","25to34":"235","35to44":"226","45to54":"207","55to64":"169","65+":"58","medianAge":"169"}},"title":"Farming, fishing, and forestry occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2018":{"total":"1,121","women":"24.3","white":"89.9","black":"3.8","asian":"2.2","hispanicOrLatino":"46.0"}},"wageData":{"2018":{"workers":"850","median":"581","maleWorkers":"667","maleMedian":"602","femaleWorkers":"183","femaleMedian":"483"}}},"First-line supervisors of farming, fishing, and forestry workers":{"ageData":{"2018":{"total":"60","16to19":"0","20to24":"6","25to34":"7","35to44":"14","45to54":"18","55to64":"12","65+":"4","medianAge":"12"}},"title":"First-line supervisors of farming, fishing, and forestry workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2018":{"total":"60","women":"16.5","white":"96.9","black":"0.4","asian":"0.1","hispanicOrLatino":"33.6"}},"wageData":{"2018":{"workers":"45","median":"-","maleWorkers":"37","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Agricultural inspectors":{"ageData":{"2018":{"total":"22","16to19":"1","20to24":"1","25to34":"3","35to44":"4","45to54":"4","55to64":"5","65+":"4","medianAge":"5"}},"title":"Agricultural inspectors","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2018":{"total":"22","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"18","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Animal breeders":{"ageData":{"2018":{"total":"5","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Animal breeders","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2018":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Graders and sorters, agricultural products":{"ageData":{"2018":{"total":"85","16to19":"2","20to24":"9","25to34":"21","35to44":"13","45to54":"24","55to64":"13","65+":"3","medianAge":"13"}},"title":"Graders and sorters, agricultural products","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2018":{"total":"85","women":"57.8","white":"84.0","black":"7.6","asian":"5.3","hispanicOrLatino":"44.2"}},"wageData":{"2018":{"workers":"75","median":"593","maleWorkers":"38","maleMedian":"-","femaleWorkers":"37","femaleMedian":"-"}}},"Miscellaneous agricultural workers":{"ageData":{"2018":{"total":"833","16to19":"82","20to24":"109","25to34":"173","35to44":"174","45to54":"136","55to64":"119","65+":"39","medianAge":"119"}},"title":"Miscellaneous agricultural workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2018":{"total":"833","women":"23.4","white":"90.3","black":"3.6","asian":"1.7","hispanicOrLatino":"52.8"}},"wageData":{"2018":{"workers":"641","median":"552","maleWorkers":"512","maleMedian":"578","femaleWorkers":"130","femaleMedian":"474"}}},"Fishers and related fishing workers":{"ageData":{"2018":{"total":"39","16to19":"2","20to24":"5","25to34":"11","35to44":"6","45to54":"10","55to64":"4","65+":"2","medianAge":"4"}},"title":"Fishers and related fishing workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2018":{"total":"39","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"12","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Hunters and trappers":{"ageData":{"2018":{"total":"3","16to19":"1","20to24":"0","25to34":"0","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Hunters and trappers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2018":{"total":"3","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Forest and conservation workers":{"ageData":{"2018":{"total":"16","16to19":"0","20to24":"0","25to34":"7","35to44":"3","45to54":"3","55to64":"3","65+":"0","medianAge":"3"}},"title":"Forest and conservation workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2018":{"total":"16","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"17","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Logging workers":{"ageData":{"2018":{"total":"58","16to19":"1","20to24":"7","25to34":"12","35to44":"10","45to54":"11","55to64":"12","65+":"6","medianAge":"12"}},"title":"Logging workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2018":{"total":"58","women":"2.6","white":"94.6","black":"1.0","asian":"3.1","hispanicOrLatino":"8.5"}},"wageData":{"2018":{"workers":"36","median":"-","maleWorkers":"36","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Construction and extraction occupations":{"ageData":{"2018":{"total":"8,338","16to19":"175","20to24":"696","25to34":"2,025","35to44":"2,100","45to54":"1,728","55to64":"1,304","65+":"312","medianAge":"1,304"}},"title":"Construction and extraction occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2018":{"total":"8,338","women":"3.4","white":"87.5","black":"7.1","asian":"1.6","hispanicOrLatino":"37.0"}},"wageData":{"2018":{"workers":"6,414","median":"808","maleWorkers":"6,223","maleMedian":"809","femaleWorkers":"191","femaleMedian":"785"}}},"First-line supervisors of construction trades and extraction workers":{"ageData":{"2018":{"total":"634","16to19":"0","20to24":"21","25to34":"131","35to44":"169","45to54":"166","55to64":"122","65+":"26","medianAge":"122"}},"title":"First-line supervisors of construction trades and extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"634","women":"3.5","white":"92.2","black":"4.2","asian":"0.8","hispanicOrLatino":"23.0"}},"wageData":{"2018":{"workers":"541","median":"1,059","maleWorkers":"521","maleMedian":"1,073","femaleWorkers":"20","femaleMedian":"-"}}},"Boilermakers":{"ageData":{"2018":{"total":"20","16to19":"1","20to24":"1","25to34":"3","35to44":"8","45to54":"7","55to64":"1","65+":"0","medianAge":"1"}},"title":"Boilermakers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"20","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"16","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Brickmasons, blockmasons, and stonemasons":{"ageData":{"2018":{"total":"143","16to19":"1","20to24":"8","25to34":"23","35to44":"42","45to54":"33","55to64":"31","65+":"4","medianAge":"31"}},"title":"Brickmasons, blockmasons, and stonemasons","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"143","women":"1.9","white":"87.1","black":"9.3","asian":"1.5","hispanicOrLatino":"35.5"}},"wageData":{"2018":{"workers":"102","median":"763","maleWorkers":"100","maleMedian":"761","femaleWorkers":"2","femaleMedian":"-"}}},"Carpenters":{"ageData":{"2018":{"total":"1,375","16to19":"27","20to24":"101","25to34":"312","35to44":"379","45to54":"288","55to64":"215","65+":"52","medianAge":"215"}},"title":"Carpenters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"1,375","women":"2.2","white":"86.1","black":"6.2","asian":"2.3","hispanicOrLatino":"39.1"}},"wageData":{"2018":{"workers":"973","median":"756","maleWorkers":"953","maleMedian":"759","femaleWorkers":"20","femaleMedian":"-"}}},"Carpet, floor, and tile installers and finishers":{"ageData":{"2018":{"total":"164","16to19":"1","20to24":"17","25to34":"35","35to44":"41","45to54":"38","55to64":"28","65+":"4","medianAge":"28"}},"title":"Carpet, floor, and tile installers and finishers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"164","women":"1.9","white":"86.5","black":"8.4","asian":"0.7","hispanicOrLatino":"46.4"}},"wageData":{"2018":{"workers":"108","median":"692","maleWorkers":"105","maleMedian":"682","femaleWorkers":"4","femaleMedian":"-"}}},"Cement masons, concrete finishers, and terrazzo workers":{"ageData":{"2018":{"total":"50","16to19":"1","20to24":"3","25to34":"14","35to44":"11","45to54":"9","55to64":"10","65+":"2","medianAge":"10"}},"title":"Cement masons, concrete finishers, and terrazzo workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"50","women":"0.0","white":"79.3","black":"12.5","asian":"0.0","hispanicOrLatino":"46.6"}},"wageData":{"2018":{"workers":"46","median":"-","maleWorkers":"46","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Construction laborers":{"ageData":{"2018":{"total":"2,110","16to19":"76","20to24":"225","25to34":"516","35to44":"532","45to54":"408","55to64":"274","65+":"80","medianAge":"274"}},"title":"Construction laborers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"2,110","women":"3.7","white":"87.4","black":"7.5","asian":"1.6","hispanicOrLatino":"47.6"}},"wageData":{"2018":{"workers":"1,470","median":"717","maleWorkers":"1,421","maleMedian":"717","femaleWorkers":"49","femaleMedian":"-"}}},"Paving, surfacing, and tamping equipment operators":{"ageData":{"2018":{"total":"21","16to19":"0","20to24":"1","25to34":"2","35to44":"5","45to54":"5","55to64":"7","65+":"0","medianAge":"7"}},"title":"Paving, surfacing, and tamping equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"21","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"19","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Pile-driver operators":{"ageData":{"2018":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Pile-driver operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"1","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Operating engineers and other construction equipment operators":{"ageData":{"2018":{"total":"342","16to19":"2","20to24":"21","25to34":"82","35to44":"79","45to54":"76","55to64":"65","65+":"17","medianAge":"65"}},"title":"Operating engineers and other construction equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"342","women":"2.0","white":"89.0","black":"7.5","asian":"0.3","hispanicOrLatino":"17.4"}},"wageData":{"2018":{"workers":"328","median":"905","maleWorkers":"323","maleMedian":"905","femaleWorkers":"5","femaleMedian":"-"}}},"Drywall installers, ceiling tile installers, and tapers":{"ageData":{"2018":{"total":"164","16to19":"4","20to24":"20","25to34":"41","35to44":"46","45to54":"30","55to64":"19","65+":"4","medianAge":"19"}},"title":"Drywall installers, ceiling tile installers, and tapers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"164","women":"1.6","white":"88.1","black":"4.6","asian":"0.6","hispanicOrLatino":"70.2"}},"wageData":{"2018":{"workers":"125","median":"704","maleWorkers":"124","maleMedian":"707","femaleWorkers":"1","femaleMedian":"-"}}},"Electricians":{"ageData":{"2018":{"total":"887","16to19":"16","20to24":"79","25to34":"210","35to44":"204","45to54":"190","55to64":"158","65+":"31","medianAge":"158"}},"title":"Electricians","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"887","women":"2.4","white":"86.9","black":"8.2","asian":"1.8","hispanicOrLatino":"23.3"}},"wageData":{"2018":{"workers":"781","median":"965","maleWorkers":"766","maleMedian":"966","femaleWorkers":"16","femaleMedian":"-"}}},"Glaziers":{"ageData":{"2018":{"total":"45","16to19":"0","20to24":"3","25to34":"16","35to44":"10","45to54":"9","55to64":"6","65+":"1","medianAge":"6"}},"title":"Glaziers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"45","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"35","median":"-","maleWorkers":"35","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Insulation workers":{"ageData":{"2018":{"total":"60","16to19":"4","20to24":"6","25to34":"18","35to44":"18","45to54":"8","55to64":"6","65+":"0","medianAge":"6"}},"title":"Insulation workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"60","women":"2.5","white":"84.2","black":"8.7","asian":"1.9","hispanicOrLatino":"38.9"}},"wageData":{"2018":{"workers":"49","median":"-","maleWorkers":"48","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Painters, construction and maintenance":{"ageData":{"2018":{"total":"607","16to19":"14","20to24":"38","25to34":"150","35to44":"170","45to54":"116","55to64":"93","65+":"27","medianAge":"93"}},"title":"Painters, construction and maintenance","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"607","women":"7.2","white":"87.6","black":"5.7","asian":"2.3","hispanicOrLatino":"54.9"}},"wageData":{"2018":{"workers":"380","median":"679","maleWorkers":"360","maleMedian":"679","femaleWorkers":"20","femaleMedian":"-"}}},"Paperhangers":{"ageData":{"2018":{"total":"5","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Paperhangers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Pipelayers, plumbers, pipefitters, and steamfitters":{"ageData":{"2018":{"total":"641","16to19":"9","20to24":"53","25to34":"155","35to44":"158","45to54":"141","55to64":"103","65+":"22","medianAge":"103"}},"title":"Pipelayers, plumbers, pipefitters, and steamfitters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"641","women":"3.5","white":"88.5","black":"8.2","asian":"1.3","hispanicOrLatino":"26.6"}},"wageData":{"2018":{"workers":"531","median":"921","maleWorkers":"514","maleMedian":"916","femaleWorkers":"17","femaleMedian":"-"}}},"Plasterers and stucco masons":{"ageData":{"2018":{"total":"19","16to19":"0","20to24":"2","25to34":"8","35to44":"5","45to54":"4","55to64":"1","65+":"0","medianAge":"1"}},"title":"Plasterers and stucco masons","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"19","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"15","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Reinforcing iron and rebar workers":{"ageData":{"2018":{"total":"3","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Reinforcing iron and rebar workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"3","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Roofers":{"ageData":{"2018":{"total":"201","16to19":"2","20to24":"20","25to34":"75","35to44":"54","45to54":"31","55to64":"14","65+":"5","medianAge":"14"}},"title":"Roofers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"201","women":"2.6","white":"86.7","black":"6.6","asian":"1.8","hispanicOrLatino":"56.3"}},"wageData":{"2018":{"workers":"148","median":"687","maleWorkers":"146","maleMedian":"686","femaleWorkers":"2","femaleMedian":"-"}}},"Sheet metal workers":{"ageData":{"2018":{"total":"147","16to19":"3","20to24":"13","25to34":"43","35to44":"34","45to54":"32","55to64":"20","65+":"4","medianAge":"20"}},"title":"Sheet metal workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"147","women":"2.8","white":"88.5","black":"7.7","asian":"1.3","hispanicOrLatino":"23.3"}},"wageData":{"2018":{"workers":"129","median":"881","maleWorkers":"127","maleMedian":"882","femaleWorkers":"2","femaleMedian":"-"}}},"Structural iron and steel workers":{"ageData":{"2018":{"total":"60","16to19":"0","20to24":"5","25to34":"17","35to44":"17","45to54":"13","55to64":"7","65+":"0","medianAge":"7"}},"title":"Structural iron and steel workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"60","women":"2.2","white":"81.7","black":"6.3","asian":"4.4","hispanicOrLatino":"22.9"}},"wageData":{"2018":{"workers":"52","median":"934","maleWorkers":"51","maleMedian":"941","femaleWorkers":"1","femaleMedian":"-"}}},"Solar photovoltaic installers":{"ageData":{"2018":{"total":"16","16to19":"0","20to24":"5","25to34":"4","35to44":"3","45to54":"0","55to64":"2","65+":"2","medianAge":"2"}},"title":"Solar photovoltaic installers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"16","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"9","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers, construction trades":{"ageData":{"2018":{"total":"77","16to19":"9","20to24":"13","25to34":"24","35to44":"12","45to54":"10","55to64":"8","65+":"1","medianAge":"8"}},"title":"Helpers, construction trades","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"77","women":"5.6","white":"80.6","black":"13.3","asian":"1.7","hispanicOrLatino":"35.9"}},"wageData":{"2018":{"workers":"68","median":"620","maleWorkers":"67","maleMedian":"622","femaleWorkers":"1","femaleMedian":"-"}}},"Construction and building inspectors":{"ageData":{"2018":{"total":"108","16to19":"0","20to24":"3","25to34":"14","35to44":"20","45to54":"28","55to64":"32","65+":"10","medianAge":"32"}},"title":"Construction and building inspectors","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"108","women":"14.0","white":"85.6","black":"7.7","asian":"2.2","hispanicOrLatino":"8.4"}},"wageData":{"2018":{"workers":"82","median":"996","maleWorkers":"68","maleMedian":"1,015","femaleWorkers":"14","femaleMedian":"-"}}},"Elevator installers and repairers":{"ageData":{"2018":{"total":"25","16to19":"0","20to24":"0","25to34":"8","35to44":"5","45to54":"6","55to64":"7","65+":"0","medianAge":"7"}},"title":"Elevator installers and repairers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"25","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"25","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Fence erectors":{"ageData":{"2018":{"total":"33","16to19":"0","20to24":"3","25to34":"11","35to44":"5","45to54":"5","55to64":"7","65+":"2","medianAge":"7"}},"title":"Fence erectors","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"33","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"21","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Hazardous materials removal workers":{"ageData":{"2018":{"total":"36","16to19":"1","20to24":"1","25to34":"8","35to44":"9","45to54":"4","55to64":"11","65+":"2","medianAge":"11"}},"title":"Hazardous materials removal workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"36","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"30","median":"-","maleWorkers":"27","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Highway maintenance workers":{"ageData":{"2018":{"total":"105","16to19":"1","20to24":"7","25to34":"25","35to44":"21","45to54":"28","55to64":"16","65+":"8","medianAge":"16"}},"title":"Highway maintenance workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"105","women":"3.9","white":"82.8","black":"12.2","asian":"0.7","hispanicOrLatino":"12.7"}},"wageData":{"2018":{"workers":"109","median":"781","maleWorkers":"105","maleMedian":"772","femaleWorkers":"4","femaleMedian":"-"}}},"Rail-track laying and maintenance equipment operators":{"ageData":{"2018":{"total":"10","16to19":"0","20to24":"1","25to34":"3","35to44":"0","45to54":"1","55to64":"3","65+":"1","medianAge":"3"}},"title":"Rail-track laying and maintenance equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"10","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"12","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Septic tank servicers and sewer pipe cleaners":{"ageData":{"2018":{"total":"9","16to19":"0","20to24":"1","25to34":"3","35to44":"0","45to54":"5","55to64":"1","65+":"0","medianAge":"1"}},"title":"Septic tank servicers and sewer pipe cleaners","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"9","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Miscellaneous construction and related workers":{"ageData":{"2018":{"total":"28","16to19":"0","20to24":"3","25to34":"10","35to44":"7","45to54":"6","55to64":"2","65+":"0","medianAge":"2"}},"title":"Miscellaneous construction and related workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"28","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"25","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Derrick, rotary drill, and service unit operators, oil, gas, and mining":{"ageData":{"2018":{"total":"30","16to19":"0","20to24":"5","25to34":"11","35to44":"7","45to54":"3","55to64":"4","65+":"1","medianAge":"4"}},"title":"Derrick, rotary drill, and service unit operators, oil, gas, and mining","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"30","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"29","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Earth drillers, except oil and gas":{"ageData":{"2018":{"total":"22","16to19":"0","20to24":"6","25to34":"6","35to44":"4","45to54":"2","55to64":"2","65+":"2","medianAge":"2"}},"title":"Earth drillers, except oil and gas","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"22","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"23","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Explosives workers, ordnance handling experts, and blasters":{"ageData":{"2018":{"total":"12","16to19":"0","20to24":"1","25to34":"5","35to44":"0","45to54":"2","55to64":"4","65+":"0","medianAge":"4"}},"title":"Explosives workers, ordnance handling experts, and blasters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"12","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"14","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Mining machine operators":{"ageData":{"2018":{"total":"65","16to19":"0","20to24":"5","25to34":"18","35to44":"13","45to54":"12","55to64":"14","65+":"2","medianAge":"14"}},"title":"Mining machine operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"65","women":"4.9","white":"86.0","black":"6.7","asian":"0.8","hispanicOrLatino":"18.1"}},"wageData":{"2018":{"workers":"59","median":"1,402","maleWorkers":"55","maleMedian":"1,389","femaleWorkers":"4","femaleMedian":"-"}}},"Roof bolters, mining":{"ageData":{"2018":{"total":"1","16to19":"0","20to24":"1","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Roof bolters, mining","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"1","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Roustabouts, oil and gas":{"ageData":{"2018":{"total":"10","16to19":"0","20to24":"1","25to34":"5","35to44":"3","45to54":"0","55to64":"0","65+":"1","medianAge":"0"}},"title":"Roustabouts, oil and gas","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"10","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"9","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers--extraction workers":{"ageData":{"2018":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Helpers--extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"2","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Other extraction workers":{"ageData":{"2018":{"total":"49","16to19":"1","20to24":"6","25to34":"17","35to44":"9","45to54":"10","55to64":"5","65+":"1","medianAge":"5"}},"title":"Other extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2018":{"total":"49","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"35","median":"-","maleWorkers":"34","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Installation, maintenance, and repair occupations":{"ageData":{"2018":{"total":"5,012","16to19":"92","20to24":"409","25to34":"1,123","35to44":"1,109","45to54":"1,106","55to64":"961","65+":"213","medianAge":"961"}},"title":"Installation, maintenance, and repair occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2018":{"total":"5,012","women":"3.7","white":"83.4","black":"9.4","asian":"3.3","hispanicOrLatino":"20.1"}},"wageData":{"2018":{"workers":"4,282","median":"934","maleWorkers":"4,140","maleMedian":"936","femaleWorkers":"142","femaleMedian":"823"}}},"First-line supervisors of mechanics, installers, and repairers":{"ageData":{"2018":{"total":"280","16to19":"0","20to24":"7","25to34":"42","35to44":"59","45to54":"80","55to64":"75","65+":"16","medianAge":"75"}},"title":"First-line supervisors of mechanics, installers, and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"280","women":"5.9","white":"87.0","black":"7.4","asian":"1.6","hispanicOrLatino":"12.9"}},"wageData":{"2018":{"workers":"270","median":"1,087","maleWorkers":"255","maleMedian":"1,111","femaleWorkers":"15","femaleMedian":"-"}}},"Computer, automated teller, and office machine repairers":{"ageData":{"2018":{"total":"185","16to19":"2","20to24":"15","25to34":"45","35to44":"39","45to54":"34","55to64":"42","65+":"7","medianAge":"42"}},"title":"Computer, automated teller, and office machine repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"185","women":"13.7","white":"75.6","black":"14.0","asian":"7.6","hispanicOrLatino":"14.7"}},"wageData":{"2018":{"workers":"157","median":"932","maleWorkers":"137","maleMedian":"940","femaleWorkers":"20","femaleMedian":"-"}}},"Radio and telecommunications equipment installers and repairers":{"ageData":{"2018":{"total":"136","16to19":"2","20to24":"6","25to34":"26","35to44":"35","45to54":"40","55to64":"21","65+":"7","medianAge":"21"}},"title":"Radio and telecommunications equipment installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"136","women":"13.6","white":"73.4","black":"16.0","asian":"8.8","hispanicOrLatino":"19.1"}},"wageData":{"2018":{"workers":"125","median":"1,131","maleWorkers":"108","maleMedian":"1,134","femaleWorkers":"18","femaleMedian":"-"}}},"Avionics technicians":{"ageData":{"2018":{"total":"13","16to19":"0","20to24":"0","25to34":"1","35to44":"5","45to54":"4","55to64":"3","65+":"0","medianAge":"3"}},"title":"Avionics technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"13","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"11","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Electric motor, power tool, and related repairers":{"ageData":{"2018":{"total":"26","16to19":"1","20to24":"3","25to34":"7","35to44":"4","45to54":"6","55to64":"4","65+":"1","medianAge":"4"}},"title":"Electric motor, power tool, and related repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"26","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"22","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Electrical and electronics installers and repairers, transportation equipment":{"ageData":{"2018":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Electrical and electronics installers and repairers, transportation equipment","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"1","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electrical and electronics repairers, industrial and utility":{"ageData":{"2018":{"total":"11","16to19":"0","20to24":"2","25to34":"1","35to44":"4","45to54":"3","55to64":"2","65+":"0","medianAge":"2"}},"title":"Electrical and electronics repairers, industrial and utility","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"11","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"12","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Electronic equipment installers and repairers, motor vehicles":{"ageData":{"2018":{"total":"5","16to19":"1","20to24":"1","25to34":"1","35to44":"0","45to54":"2","55to64":"0","65+":"1","medianAge":"0"}},"title":"Electronic equipment installers and repairers, motor vehicles","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electronic home entertainment equipment installers and repairers":{"ageData":{"2018":{"total":"38","16to19":"1","20to24":"5","25to34":"10","35to44":"11","45to54":"6","55to64":"4","65+":"0","medianAge":"4"}},"title":"Electronic home entertainment equipment installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"38","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"29","median":"-","maleWorkers":"29","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Security and fire alarm systems installers":{"ageData":{"2018":{"total":"63","16to19":"0","20to24":"8","25to34":"18","35to44":"13","45to54":"11","55to64":"9","65+":"3","medianAge":"9"}},"title":"Security and fire alarm systems installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"63","women":"0.7","white":"86.9","black":"7.9","asian":"1.0","hispanicOrLatino":"22.7"}},"wageData":{"2018":{"workers":"47","median":"-","maleWorkers":"47","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Aircraft mechanics and service technicians":{"ageData":{"2018":{"total":"164","16to19":"1","20to24":"13","25to34":"37","35to44":"32","45to54":"33","55to64":"38","65+":"8","medianAge":"38"}},"title":"Aircraft mechanics and service technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"164","women":"3.6","white":"82.4","black":"9.1","asian":"5.0","hispanicOrLatino":"19.4"}},"wageData":{"2018":{"workers":"155","median":"1,117","maleWorkers":"147","maleMedian":"1,141","femaleWorkers":"7","femaleMedian":"-"}}},"Automotive body and related repairers":{"ageData":{"2018":{"total":"152","16to19":"5","20to24":"12","25to34":"29","35to44":"36","45to54":"38","55to64":"24","65+":"9","medianAge":"24"}},"title":"Automotive body and related repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"152","women":"1.8","white":"91.3","black":"5.0","asian":"1.6","hispanicOrLatino":"30.9"}},"wageData":{"2018":{"workers":"114","median":"820","maleWorkers":"114","maleMedian":"820","femaleWorkers":"0","femaleMedian":"-"}}},"Automotive glass installers and repairers":{"ageData":{"2018":{"total":"24","16to19":"0","20to24":"4","25to34":"6","35to44":"7","45to54":"5","55to64":"2","65+":"0","medianAge":"2"}},"title":"Automotive glass installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"24","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"22","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Automotive service technicians and mechanics":{"ageData":{"2018":{"total":"916","16to19":"24","20to24":"109","25to34":"246","35to44":"198","45to54":"171","55to64":"142","65+":"26","medianAge":"142"}},"title":"Automotive service technicians and mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"916","women":"2.1","white":"82.9","black":"8.8","asian":"4.1","hispanicOrLatino":"26.0"}},"wageData":{"2018":{"workers":"709","median":"800","maleWorkers":"698","maleMedian":"802","femaleWorkers":"10","femaleMedian":"-"}}},"Bus and truck mechanics and diesel engine specialists":{"ageData":{"2018":{"total":"389","16to19":"6","20to24":"40","25to34":"98","35to44":"74","45to54":"90","55to64":"72","65+":"8","medianAge":"72"}},"title":"Bus and truck mechanics and diesel engine specialists","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"389","women":"0.9","white":"87.9","black":"8.1","asian":"1.8","hispanicOrLatino":"18.7"}},"wageData":{"2018":{"workers":"358","median":"942","maleWorkers":"352","maleMedian":"943","femaleWorkers":"5","femaleMedian":"-"}}},"Heavy vehicle and mobile equipment service technicians and mechanics":{"ageData":{"2018":{"total":"211","16to19":"1","20to24":"17","25to34":"46","35to44":"45","45to54":"49","55to64":"43","65+":"10","medianAge":"43"}},"title":"Heavy vehicle and mobile equipment service technicians and mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"211","women":"0.8","white":"84.2","black":"6.4","asian":"2.1","hispanicOrLatino":"12.4"}},"wageData":{"2018":{"workers":"199","median":"1,013","maleWorkers":"196","maleMedian":"1,011","femaleWorkers":"3","femaleMedian":"-"}}},"Small engine mechanics":{"ageData":{"2018":{"total":"51","16to19":"0","20to24":"1","25to34":"10","35to44":"9","45to54":"15","55to64":"13","65+":"3","medianAge":"13"}},"title":"Small engine mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"51","women":"2.7","white":"98.0","black":"0.6","asian":"0.1","hispanicOrLatino":"15.7"}},"wageData":{"2018":{"workers":"28","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Miscellaneous vehicle and mobile equipment mechanics, installers, and repairers":{"ageData":{"2018":{"total":"93","16to19":"4","20to24":"15","25to34":"26","35to44":"17","45to54":"18","55to64":"12","65+":"2","medianAge":"12"}},"title":"Miscellaneous vehicle and mobile equipment mechanics, installers, and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"93","women":"2.8","white":"78.7","black":"12.9","asian":"2.3","hispanicOrLatino":"31.1"}},"wageData":{"2018":{"workers":"68","median":"611","maleWorkers":"65","maleMedian":"612","femaleWorkers":"3","femaleMedian":"-"}}},"Control and valve installers and repairers":{"ageData":{"2018":{"total":"20","16to19":"0","20to24":"1","25to34":"3","35to44":"6","45to54":"8","55to64":"2","65+":"1","medianAge":"2"}},"title":"Control and valve installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"20","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"20","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Heating, air conditioning, and refrigeration mechanics and installers":{"ageData":{"2018":{"total":"472","16to19":"11","20to24":"47","25to34":"105","35to44":"118","45to54":"96","55to64":"75","65+":"19","medianAge":"75"}},"title":"Heating, air conditioning, and refrigeration mechanics and installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"472","women":"1.4","white":"86.4","black":"7.6","asian":"2.9","hispanicOrLatino":"21.5"}},"wageData":{"2018":{"workers":"384","median":"890","maleWorkers":"381","maleMedian":"891","femaleWorkers":"3","femaleMedian":"-"}}},"Home appliance repairers":{"ageData":{"2018":{"total":"41","16to19":"0","20to24":"5","25to34":"7","35to44":"9","45to54":"7","55to64":"10","65+":"3","medianAge":"10"}},"title":"Home appliance repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"41","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"28","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Industrial and refractory machinery mechanics":{"ageData":{"2018":{"total":"442","16to19":"6","20to24":"24","25to34":"87","35to44":"103","45to54":"100","55to64":"101","65+":"20","medianAge":"101"}},"title":"Industrial and refractory machinery mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"442","women":"2.4","white":"83.9","black":"9.3","asian":"3.3","hispanicOrLatino":"15.4"}},"wageData":{"2018":{"workers":"424","median":"981","maleWorkers":"418","maleMedian":"982","femaleWorkers":"6","femaleMedian":"-"}}},"Maintenance and repair workers, general":{"ageData":{"2018":{"total":"507","16to19":"9","20to24":"26","25to34":"90","35to44":"111","45to54":"121","55to64":"122","65+":"29","medianAge":"122"}},"title":"Maintenance and repair workers, general","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"507","women":"3.5","white":"79.8","black":"12.7","asian":"3.1","hispanicOrLatino":"19.0"}},"wageData":{"2018":{"workers":"456","median":"870","maleWorkers":"439","maleMedian":"874","femaleWorkers":"16","femaleMedian":"-"}}},"Maintenance workers, machinery":{"ageData":{"2018":{"total":"25","16to19":"0","20to24":"0","25to34":"3","35to44":"6","45to54":"6","55to64":"8","65+":"2","medianAge":"8"}},"title":"Maintenance workers, machinery","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"25","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"23","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Millwrights":{"ageData":{"2018":{"total":"46","16to19":"0","20to24":"1","25to34":"8","35to44":"7","45to54":"11","55to64":"16","65+":"2","medianAge":"16"}},"title":"Millwrights","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"46","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"40","median":"-","maleWorkers":"39","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Electrical power-line installers and repairers":{"ageData":{"2018":{"total":"137","16to19":"0","20to24":"6","25to34":"39","35to44":"33","45to54":"29","55to64":"23","65+":"6","medianAge":"23"}},"title":"Electrical power-line installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"137","women":"4.1","white":"86.0","black":"10.0","asian":"0.9","hispanicOrLatino":"12.1"}},"wageData":{"2018":{"workers":"129","median":"1,300","maleWorkers":"124","maleMedian":"1,292","femaleWorkers":"5","femaleMedian":"-"}}},"Telecommunications line installers and repairers":{"ageData":{"2018":{"total":"210","16to19":"1","20to24":"17","25to34":"56","35to44":"56","45to54":"50","55to64":"27","65+":"3","medianAge":"27"}},"title":"Telecommunications line installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"210","women":"3.9","white":"77.4","black":"13.1","asian":"4.2","hispanicOrLatino":"19.2"}},"wageData":{"2018":{"workers":"196","median":"1,014","maleWorkers":"187","maleMedian":"1,026","femaleWorkers":"9","femaleMedian":"-"}}},"Precision instrument and equipment repairers":{"ageData":{"2018":{"total":"65","16to19":"2","20to24":"3","25to34":"13","35to44":"14","45to54":"10","55to64":"17","65+":"7","medianAge":"17"}},"title":"Precision instrument and equipment repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"65","women":"13.2","white":"74.0","black":"12.8","asian":"7.7","hispanicOrLatino":"12.2"}},"wageData":{"2018":{"workers":"46","median":"-","maleWorkers":"39","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Wind turbine service technicians":{"ageData":{"2018":{"total":"3","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Wind turbine service technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"3","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Coin, vending, and amusement machine servicers and repairers":{"ageData":{"2018":{"total":"36","16to19":"1","20to24":"4","25to34":"6","35to44":"9","45to54":"8","55to64":"6","65+":"2","medianAge":"6"}},"title":"Coin, vending, and amusement machine servicers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"36","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"25","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Commercial divers":{"ageData":{"2018":{"total":"1","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Commercial divers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"1","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Locksmiths and safe repairers":{"ageData":{"2018":{"total":"34","16to19":"1","20to24":"0","25to34":"8","35to44":"7","45to54":"6","55to64":"9","65+":"2","medianAge":"9"}},"title":"Locksmiths and safe repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"34","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"18","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Manufactured building and mobile home installers":{"ageData":{"2018":{"total":"7","16to19":"0","20to24":"0","25to34":"0","35to44":"3","45to54":"4","55to64":"0","65+":"0","medianAge":"0"}},"title":"Manufactured building and mobile home installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"7","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Riggers":{"ageData":{"2018":{"total":"14","16to19":"0","20to24":"0","25to34":"2","35to44":"5","45to54":"6","55to64":"1","65+":"0","medianAge":"1"}},"title":"Riggers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"14","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"13","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Signal and track switch repairers":{"ageData":{"2018":{"total":"14","16to19":"0","20to24":"0","25to34":"6","35to44":"3","45to54":"0","55to64":"5","65+":"0","medianAge":"5"}},"title":"Signal and track switch repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"14","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"14","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers--installation, maintenance, and repair workers":{"ageData":{"2018":{"total":"16","16to19":"3","20to24":"3","25to34":"3","35to44":"3","45to54":"1","55to64":"1","65+":"1","medianAge":"1"}},"title":"Helpers--installation, maintenance, and repair workers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"16","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"17","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Other installation, maintenance, and repair workers":{"ageData":{"2018":{"total":"167","16to19":"5","20to24":"13","25to34":"33","35to44":"29","45to54":"38","55to64":"33","65+":"16","medianAge":"33"}},"title":"Other installation, maintenance, and repair workers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2018":{"total":"167","women":"7.0","white":"83.6","black":"9.4","asian":"3.6","hispanicOrLatino":"24.4"}},"wageData":{"2018":{"workers":"111","median":"827","maleWorkers":"108","maleMedian":"837","femaleWorkers":"3","femaleMedian":"-"}}},"Production, transportation, and material moving occupations":{"ageData":{"2018":{"total":"18,539","16to19":"529","20to24":"1,788","25to34":"4,013","35to44":"3,614","45to54":"4,066","55to64":"3,481","65+":"1,048","medianAge":"3,481"}},"title":"Production, transportation, and material moving occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2018":{"total":"18,539","women":"23.1","white":"74.4","black":"16.6","asian":"5.1","hispanicOrLatino":"22.8"}},"wageData":{"2018":{"workers":"15,210","median":"707","maleWorkers":"11,932","maleMedian":"762","femaleWorkers":"3,279","femaleMedian":"561"}}},"Production occupations":{"ageData":{"2018":{"total":"8,621","16to19":"167","20to24":"799","25to34":"1,958","35to44":"1,748","45to54":"1,920","55to64":"1,646","65+":"383","medianAge":"1,646"}},"title":"Production occupations","depth":2,"parent":"Production, transportation, and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"8,621","women":"28.8","white":"76.6","black":"13.5","asian":"5.8","hispanicOrLatino":"23.4"}},"wageData":{"2018":{"workers":"7,668","median":"723","maleWorkers":"5,627","maleMedian":"793","femaleWorkers":"2,041","femaleMedian":"575"}}},"First-line supervisors of production and operating workers":{"ageData":{"2018":{"total":"832","16to19":"3","20to24":"31","25to34":"151","35to44":"202","45to54":"226","55to64":"178","65+":"40","medianAge":"178"}},"title":"First-line supervisors of production and operating workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"832","women":"19.6","white":"81.1","black":"10.2","asian":"4.3","hispanicOrLatino":"18.9"}},"wageData":{"2018":{"workers":"792","median":"980","maleWorkers":"642","maleMedian":"1,050","femaleWorkers":"150","femaleMedian":"745"}}},"Aircraft structure, surfaces, rigging, and systems assemblers":{"ageData":{"2018":{"total":"5","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Aircraft structure, surfaces, rigging, and systems assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"6","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Electrical, electronics, and electromechanical assemblers":{"ageData":{"2018":{"total":"124","16to19":"3","20to24":"9","25to34":"32","35to44":"20","45to54":"29","55to64":"24","65+":"6","medianAge":"24"}},"title":"Electrical, electronics, and electromechanical assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"124","women":"49.2","white":"69.7","black":"12.2","asian":"15.1","hispanicOrLatino":"22.5"}},"wageData":{"2018":{"workers":"110","median":"605","maleWorkers":"57","maleMedian":"706","femaleWorkers":"53","femaleMedian":"518"}}},"Engine and other machine assemblers":{"ageData":{"2018":{"total":"10","16to19":"0","20to24":"1","25to34":"4","35to44":"1","45to54":"3","55to64":"1","65+":"0","medianAge":"1"}},"title":"Engine and other machine assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"10","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"7","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Structural metal fabricators and fitters":{"ageData":{"2018":{"total":"33","16to19":"1","20to24":"4","25to34":"11","35to44":"6","45to54":"8","55to64":"3","65+":"0","medianAge":"3"}},"title":"Structural metal fabricators and fitters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"33","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"27","median":"-","maleWorkers":"27","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Miscellaneous assemblers and fabricators":{"ageData":{"2018":{"total":"1,064","16to19":"19","20to24":"120","25to34":"275","35to44":"199","45to54":"208","55to64":"198","65+":"46","medianAge":"198"}},"title":"Miscellaneous assemblers and fabricators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"1,064","women":"36.6","white":"66.8","black":"19.9","asian":"9.5","hispanicOrLatino":"19.1"}},"wageData":{"2018":{"workers":"989","median":"663","maleWorkers":"641","maleMedian":"723","femaleWorkers":"348","femaleMedian":"583"}}},"Bakers":{"ageData":{"2018":{"total":"219","16to19":"8","20to24":"31","25to34":"50","35to44":"41","45to54":"41","55to64":"35","65+":"12","medianAge":"35"}},"title":"Bakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"219","women":"61.1","white":"74.6","black":"12.8","asian":"7.3","hispanicOrLatino":"29.5"}},"wageData":{"2018":{"workers":"151","median":"549","maleWorkers":"61","maleMedian":"565","femaleWorkers":"89","femaleMedian":"533"}}},"Butchers and other meat, poultry, and fish processing workers":{"ageData":{"2018":{"total":"265","16to19":"5","20to24":"36","25to34":"64","35to44":"59","45to54":"56","55to64":"34","65+":"10","medianAge":"34"}},"title":"Butchers and other meat, poultry, and fish processing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"265","women":"28.3","white":"65.5","black":"20.8","asian":"6.4","hispanicOrLatino":"32.4"}},"wageData":{"2018":{"workers":"223","median":"606","maleWorkers":"158","maleMedian":"632","femaleWorkers":"65","femaleMedian":"557"}}},"Food and tobacco roasting, baking, and drying machine operators and tenders":{"ageData":{"2018":{"total":"6","16to19":"0","20to24":"1","25to34":"1","35to44":"0","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Food and tobacco roasting, baking, and drying machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"6","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Food batchmakers":{"ageData":{"2018":{"total":"80","16to19":"4","20to24":"14","25to34":"18","35to44":"14","45to54":"15","55to64":"8","65+":"6","medianAge":"8"}},"title":"Food batchmakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"80","women":"63.3","white":"78.6","black":"11.2","asian":"7.3","hispanicOrLatino":"22.0"}},"wageData":{"2018":{"workers":"55","median":"557","maleWorkers":"21","maleMedian":"-","femaleWorkers":"34","femaleMedian":"-"}}},"Food cooking machine operators and tenders":{"ageData":{"2018":{"total":"14","16to19":"4","20to24":"1","25to34":"4","35to44":"4","45to54":"0","55to64":"0","65+":"1","medianAge":"0"}},"title":"Food cooking machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"14","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"8","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Food processing workers, all other":{"ageData":{"2018":{"total":"158","16to19":"1","20to24":"13","25to34":"32","35to44":"42","45to54":"42","55to64":"24","65+":"4","medianAge":"24"}},"title":"Food processing workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"158","women":"37.0","white":"67.4","black":"22.6","asian":"4.8","hispanicOrLatino":"39.4"}},"wageData":{"2018":{"workers":"142","median":"624","maleWorkers":"90","maleMedian":"749","femaleWorkers":"52","femaleMedian":"539"}}},"Computer control programmers and operators":{"ageData":{"2018":{"total":"107","16to19":"1","20to24":"12","25to34":"24","35to44":"24","45to54":"25","55to64":"19","65+":"3","medianAge":"19"}},"title":"Computer control programmers and operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"107","women":"9.7","white":"91.4","black":"7.1","asian":"1.5","hispanicOrLatino":"19.1"}},"wageData":{"2018":{"workers":"106","median":"882","maleWorkers":"94","maleMedian":"890","femaleWorkers":"12","femaleMedian":"-"}}},"Extruding and drawing machine setters, operators, and tenders, metal and plastic":{"ageData":{"2018":{"total":"14","16to19":"0","20to24":"5","25to34":"3","35to44":"3","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Extruding and drawing machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"14","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"17","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Forging machine setters, operators, and tenders, metal and plastic":{"ageData":{"2018":{"total":"6","16to19":"0","20to24":"1","25to34":"1","35to44":"1","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Forging machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"6","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Rolling machine setters, operators, and tenders, metal and plastic":{"ageData":{"2018":{"total":"11","16to19":"0","20to24":"0","25to34":"3","35to44":"3","45to54":"0","55to64":"4","65+":"0","medianAge":"4"}},"title":"Rolling machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"11","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"11","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Cutting, punching, and press machine setters, operators, and tenders, metal and plastic":{"ageData":{"2018":{"total":"61","16to19":"0","20to24":"5","25to34":"12","35to44":"9","45to54":"15","55to64":"16","65+":"3","medianAge":"16"}},"title":"Cutting, punching, and press machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"61","women":"9.9","white":"75.0","black":"12.6","asian":"4.1","hispanicOrLatino":"8.2"}},"wageData":{"2018":{"workers":"58","median":"745","maleWorkers":"53","maleMedian":"766","femaleWorkers":"5","femaleMedian":"-"}}},"Drilling and boring machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2018":{"total":"3","16to19":"1","20to24":"0","25to34":"2","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Drilling and boring machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"3","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Grinding, lapping, polishing, and buffing machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2018":{"total":"38","16to19":"0","20to24":"5","25to34":"4","35to44":"7","45to54":"10","55to64":"8","65+":"4","medianAge":"8"}},"title":"Grinding, lapping, polishing, and buffing machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"38","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"35","median":"-","maleWorkers":"33","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Lathe and turning machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2018":{"total":"8","16to19":"0","20to24":"0","25to34":"1","35to44":"2","45to54":"2","55to64":"2","65+":"1","medianAge":"2"}},"title":"Lathe and turning machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"8","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Milling and planing machine setters, operators, and tenders, metal and plastic":{"ageData":{"2018":{"total":"3","16to19":"0","20to24":"0","25to34":"2","35to44":"0","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Milling and planing machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"3","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Machinists":{"ageData":{"2018":{"total":"344","16to19":"7","20to24":"23","25to34":"69","35to44":"59","45to54":"79","55to64":"89","65+":"18","medianAge":"89"}},"title":"Machinists","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"344","women":"6.4","white":"83.7","black":"7.2","asian":"5.8","hispanicOrLatino":"13.6"}},"wageData":{"2018":{"workers":"309","median":"863","maleWorkers":"293","maleMedian":"878","femaleWorkers":"16","femaleMedian":"-"}}},"Metal furnace operators, tenders, pourers, and casters":{"ageData":{"2018":{"total":"20","16to19":"0","20to24":"2","25to34":"6","35to44":"1","45to54":"8","55to64":"2","65+":"1","medianAge":"2"}},"title":"Metal furnace operators, tenders, pourers, and casters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"20","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"17","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Model makers and patternmakers, metal and plastic":{"ageData":{"2018":{"total":"6","16to19":"0","20to24":"0","25to34":"2","35to44":"0","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Model makers and patternmakers, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"6","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Molders and molding machine setters, operators, and tenders, metal and plastic":{"ageData":{"2018":{"total":"40","16to19":"0","20to24":"5","25to34":"5","35to44":"11","45to54":"10","55to64":"9","65+":"0","medianAge":"9"}},"title":"Molders and molding machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"40","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"35","median":"-","maleWorkers":"32","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Multiple machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2018":{"total":"5","16to19":"0","20to24":"0","25to34":"0","35to44":"3","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Multiple machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Tool and die makers":{"ageData":{"2018":{"total":"50","16to19":"1","20to24":"2","25to34":"5","35to44":"6","45to54":"14","55to64":"20","65+":"3","medianAge":"20"}},"title":"Tool and die makers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"50","women":"5.7","white":"96.1","black":"1.8","asian":"1.7","hispanicOrLatino":"12.4"}},"wageData":{"2018":{"workers":"47","median":"-","maleWorkers":"45","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Welding, soldering, and brazing workers":{"ageData":{"2018":{"total":"633","16to19":"17","20to24":"69","25to34":"176","35to44":"141","45to54":"124","55to64":"92","65+":"13","medianAge":"92"}},"title":"Welding, soldering, and brazing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"633","women":"5.4","white":"85.7","black":"8.3","asian":"1.4","hispanicOrLatino":"25.0"}},"wageData":{"2018":{"workers":"562","median":"840","maleWorkers":"530","maleMedian":"847","femaleWorkers":"32","femaleMedian":"-"}}},"Heat treating equipment setters, operators, and tenders, metal and plastic":{"ageData":{"2018":{"total":"9","16to19":"0","20to24":"0","25to34":"0","35to44":"3","45to54":"3","55to64":"3","65+":"0","medianAge":"3"}},"title":"Heat treating equipment setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"9","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"10","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Layout workers, metal and plastic":{"ageData":{"2018":{"total":"9","16to19":"0","20to24":"2","25to34":"1","35to44":"2","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Layout workers, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"9","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"10","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Plating and coating machine setters, operators, and tenders, metal and plastic":{"ageData":{"2018":{"total":"17","16to19":"0","20to24":"2","25to34":"3","35to44":"5","45to54":"2","55to64":"4","65+":"1","medianAge":"4"}},"title":"Plating and coating machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"17","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"17","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Tool grinders, filers, and sharpeners":{"ageData":{"2018":{"total":"3","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"1","65+":"1","medianAge":"1"}},"title":"Tool grinders, filers, and sharpeners","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"3","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Metal workers and plastic workers, all other":{"ageData":{"2018":{"total":"373","16to19":"5","20to24":"27","25to34":"92","35to44":"80","45to54":"83","55to64":"72","65+":"16","medianAge":"72"}},"title":"Metal workers and plastic workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"373","women":"18.3","white":"73.6","black":"15.0","asian":"7.0","hispanicOrLatino":"22.9"}},"wageData":{"2018":{"workers":"356","median":"698","maleWorkers":"290","maleMedian":"724","femaleWorkers":"66","femaleMedian":"611"}}},"Prepress technicians and workers":{"ageData":{"2018":{"total":"18","16to19":"0","20to24":"2","25to34":"6","35to44":"3","45to54":"3","55to64":"4","65+":"1","medianAge":"4"}},"title":"Prepress technicians and workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"18","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"14","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Printing press operators":{"ageData":{"2018":{"total":"164","16to19":"5","20to24":"11","25to34":"27","35to44":"34","45to54":"43","55to64":"36","65+":"8","medianAge":"36"}},"title":"Printing press operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"164","women":"22.7","white":"82.1","black":"10.2","asian":"3.6","hispanicOrLatino":"20.6"}},"wageData":{"2018":{"workers":"137","median":"754","maleWorkers":"111","maleMedian":"804","femaleWorkers":"26","femaleMedian":"-"}}},"Print binding and finishing workers":{"ageData":{"2018":{"total":"13","16to19":"0","20to24":"0","25to34":"2","35to44":"3","45to54":"2","55to64":"5","65+":"2","medianAge":"5"}},"title":"Print binding and finishing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"13","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"12","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Laundry and dry-cleaning workers":{"ageData":{"2018":{"total":"143","16to19":"5","20to24":"7","25to34":"24","35to44":"34","45to54":"34","55to64":"29","65+":"11","medianAge":"29"}},"title":"Laundry and dry-cleaning workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"143","women":"71.5","white":"64.9","black":"20.1","asian":"7.1","hispanicOrLatino":"43.1"}},"wageData":{"2018":{"workers":"108","median":"432","maleWorkers":"32","maleMedian":"-","femaleWorkers":"76","femaleMedian":"416"}}},"Pressers, textile, garment, and related materials":{"ageData":{"2018":{"total":"36","16to19":"1","20to24":"3","25to34":"3","35to44":"14","45to54":"5","55to64":"7","65+":"3","medianAge":"7"}},"title":"Pressers, textile, garment, and related materials","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"36","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"28","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"18","femaleMedian":"-"}}},"Sewing machine operators":{"ageData":{"2018":{"total":"174","16to19":"2","20to24":"6","25to34":"23","35to44":"33","45to54":"47","55to64":"47","65+":"16","medianAge":"47"}},"title":"Sewing machine operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"174","women":"73.4","white":"74.1","black":"9.4","asian":"12.7","hispanicOrLatino":"44.3"}},"wageData":{"2018":{"workers":"131","median":"498","maleWorkers":"37","maleMedian":"-","femaleWorkers":"94","femaleMedian":"497"}}},"Shoe and leather workers and repairers":{"ageData":{"2018":{"total":"8","16to19":"0","20to24":"0","25to34":"1","35to44":"2","45to54":"1","55to64":"4","65+":"2","medianAge":"4"}},"title":"Shoe and leather workers and repairers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"8","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Shoe machine operators and tenders":{"ageData":{"2018":{"total":"4","16to19":"0","20to24":"1","25to34":"1","35to44":"1","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Shoe machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"4","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"6","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Tailors, dressmakers, and sewers":{"ageData":{"2018":{"total":"85","16to19":"0","20to24":"0","25to34":"9","35to44":"13","45to54":"23","55to64":"21","65+":"19","medianAge":"21"}},"title":"Tailors, dressmakers, and sewers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"85","women":"75.1","white":"67.7","black":"3.6","asian":"25.3","hispanicOrLatino":"23.5"}},"wageData":{"2018":{"workers":"43","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"24","femaleMedian":"-"}}},"Textile bleaching and dyeing machine operators and tenders":{"ageData":{"2018":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Textile bleaching and dyeing machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"1","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Textile cutting machine setters, operators, and tenders":{"ageData":{"2018":{"total":"6","16to19":"0","20to24":"0","25to34":"1","35to44":"3","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Textile cutting machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"6","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Textile knitting and weaving machine setters, operators, and tenders":{"ageData":{"2018":{"total":"5","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"0","55to64":"1","65+":"2","medianAge":"1"}},"title":"Textile knitting and weaving machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"5","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Textile winding, twisting, and drawing out machine setters, operators, and tenders":{"ageData":{"2018":{"total":"5","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"4","55to64":"0","65+":"0","medianAge":"0"}},"title":"Textile winding, twisting, and drawing out machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"3","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Extruding and forming machine setters, operators, and tenders, synthetic and glass fibers":{"ageData":{"2018":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Extruding and forming machine setters, operators, and tenders, synthetic and glass fibers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"0","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Fabric and apparel patternmakers":{"ageData":{"2018":{"total":"3","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Fabric and apparel patternmakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"3","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"3","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Upholsterers":{"ageData":{"2018":{"total":"31","16to19":"1","20to24":"2","25to34":"4","35to44":"6","45to54":"11","55to64":"6","65+":"1","medianAge":"6"}},"title":"Upholsterers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"31","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"19","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Textile, apparel, and furnishings workers, all other":{"ageData":{"2018":{"total":"16","16to19":"1","20to24":"3","25to34":"3","35to44":"1","45to54":"2","55to64":"6","65+":"1","medianAge":"6"}},"title":"Textile, apparel, and furnishings workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"16","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"14","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Cabinetmakers and bench carpenters":{"ageData":{"2018":{"total":"65","16to19":"1","20to24":"4","25to34":"15","35to44":"9","45to54":"14","55to64":"17","65+":"5","medianAge":"17"}},"title":"Cabinetmakers and bench carpenters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"65","women":"6.5","white":"88.3","black":"5.7","asian":"3.3","hispanicOrLatino":"14.4"}},"wageData":{"2018":{"workers":"47","median":"-","maleWorkers":"44","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Furniture finishers":{"ageData":{"2018":{"total":"20","16to19":"0","20to24":"1","25to34":"3","35to44":"4","45to54":"4","55to64":"5","65+":"3","medianAge":"5"}},"title":"Furniture finishers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"20","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"15","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Model makers and patternmakers, wood":{"ageData":{"2018":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Model makers and patternmakers, wood","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"0","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Sawing machine setters, operators, and tenders, wood":{"ageData":{"2018":{"total":"37","16to19":"2","20to24":"8","25to34":"8","35to44":"8","45to54":"8","55to64":"2","65+":"1","medianAge":"2"}},"title":"Sawing machine setters, operators, and tenders, wood","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"37","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"32","median":"-","maleWorkers":"27","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Woodworking machine setters, operators, and tenders, except sawing":{"ageData":{"2018":{"total":"27","16to19":"3","20to24":"5","25to34":"7","35to44":"2","45to54":"4","55to64":"6","65+":"1","medianAge":"6"}},"title":"Woodworking machine setters, operators, and tenders, except sawing","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"27","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"23","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Woodworkers, all other":{"ageData":{"2018":{"total":"28","16to19":"1","20to24":"3","25to34":"6","35to44":"3","45to54":"3","55to64":"10","65+":"3","medianAge":"10"}},"title":"Woodworkers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"28","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"11","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Power plant operators, distributors, and dispatchers":{"ageData":{"2018":{"total":"33","16to19":"0","20to24":"1","25to34":"12","35to44":"4","45to54":"8","55to64":"7","65+":"1","medianAge":"7"}},"title":"Power plant operators, distributors, and dispatchers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"33","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"33","median":"-","maleWorkers":"32","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Stationary engineers and boiler operators":{"ageData":{"2018":{"total":"79","16to19":"1","20to24":"1","25to34":"7","35to44":"9","45to54":"31","55to64":"26","65+":"4","medianAge":"26"}},"title":"Stationary engineers and boiler operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"79","women":"1.3","white":"77.8","black":"8.8","asian":"9.4","hispanicOrLatino":"10.6"}},"wageData":{"2018":{"workers":"84","median":"1,073","maleWorkers":"82","maleMedian":"1,086","femaleWorkers":"2","femaleMedian":"-"}}},"Water and wastewater treatment plant and system operators":{"ageData":{"2018":{"total":"101","16to19":"0","20to24":"1","25to34":"17","35to44":"24","45to54":"27","55to64":"26","65+":"4","medianAge":"26"}},"title":"Water and wastewater treatment plant and system operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"101","women":"7.2","white":"85.6","black":"7.6","asian":"1.4","hispanicOrLatino":"9.4"}},"wageData":{"2018":{"workers":"99","median":"943","maleWorkers":"94","maleMedian":"940","femaleWorkers":"5","femaleMedian":"-"}}},"Miscellaneous plant and system operators":{"ageData":{"2018":{"total":"38","16to19":"0","20to24":"5","25to34":"14","35to44":"7","45to54":"6","55to64":"6","65+":"1","medianAge":"6"}},"title":"Miscellaneous plant and system operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"38","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"35","median":"-","maleWorkers":"35","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Chemical processing machine setters, operators, and tenders":{"ageData":{"2018":{"total":"75","16to19":"2","20to24":"5","25to34":"27","35to44":"9","45to54":"17","55to64":"15","65+":"1","medianAge":"15"}},"title":"Chemical processing machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"75","women":"11.3","white":"90.3","black":"7.5","asian":"0.5","hispanicOrLatino":"11.2"}},"wageData":{"2018":{"workers":"65","median":"894","maleWorkers":"57","maleMedian":"899","femaleWorkers":"8","femaleMedian":"-"}}},"Crushing, grinding, polishing, mixing, and blending workers":{"ageData":{"2018":{"total":"79","16to19":"0","20to24":"13","25to34":"25","35to44":"10","45to54":"18","55to64":"13","65+":"1","medianAge":"13"}},"title":"Crushing, grinding, polishing, mixing, and blending workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"79","women":"9.1","white":"79.8","black":"15.7","asian":"0.3","hispanicOrLatino":"20.0"}},"wageData":{"2018":{"workers":"83","median":"672","maleWorkers":"78","maleMedian":"673","femaleWorkers":"5","femaleMedian":"-"}}},"Cutting workers":{"ageData":{"2018":{"total":"60","16to19":"1","20to24":"10","25to34":"12","35to44":"17","45to54":"9","55to64":"8","65+":"3","medianAge":"8"}},"title":"Cutting workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"60","women":"27.5","white":"77.0","black":"11.4","asian":"8.4","hispanicOrLatino":"30.6"}},"wageData":{"2018":{"workers":"56","median":"595","maleWorkers":"43","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Extruding, forming, pressing, and compacting machine setters, operators, and tenders":{"ageData":{"2018":{"total":"22","16to19":"0","20to24":"1","25to34":"4","35to44":"5","45to54":"5","55to64":"4","65+":"2","medianAge":"4"}},"title":"Extruding, forming, pressing, and compacting machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"22","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"17","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Furnace, kiln, oven, drier, and kettle operators and tenders":{"ageData":{"2018":{"total":"25","16to19":"0","20to24":"3","25to34":"2","35to44":"8","45to54":"4","55to64":"7","65+":"1","medianAge":"7"}},"title":"Furnace, kiln, oven, drier, and kettle operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"25","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"20","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Inspectors, testers, sorters, samplers, and weighers":{"ageData":{"2018":{"total":"807","16to19":"9","20to24":"67","25to34":"200","35to44":"154","45to54":"183","55to64":"160","65+":"33","medianAge":"160"}},"title":"Inspectors, testers, sorters, samplers, and weighers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"807","women":"36.6","white":"77.1","black":"13.9","asian":"6.0","hispanicOrLatino":"19.1"}},"wageData":{"2018":{"workers":"756","median":"771","maleWorkers":"490","maleMedian":"868","femaleWorkers":"267","femaleMedian":"679"}}},"Jewelers and precious stone and metal workers":{"ageData":{"2018":{"total":"38","16to19":"0","20to24":"2","25to34":"8","35to44":"9","45to54":"5","55to64":"8","65+":"5","medianAge":"8"}},"title":"Jewelers and precious stone and metal workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"38","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"20","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Medical, dental, and ophthalmic laboratory technicians":{"ageData":{"2018":{"total":"87","16to19":"0","20to24":"10","25to34":"16","35to44":"17","45to54":"20","55to64":"18","65+":"5","medianAge":"18"}},"title":"Medical, dental, and ophthalmic laboratory technicians","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"87","women":"54.2","white":"70.8","black":"10.1","asian":"13.2","hispanicOrLatino":"19.9"}},"wageData":{"2018":{"workers":"74","median":"741","maleWorkers":"33","maleMedian":"-","femaleWorkers":"41","femaleMedian":"-"}}},"Packaging and filling machine operators and tenders":{"ageData":{"2018":{"total":"277","16to19":"10","20to24":"39","25to34":"59","35to44":"74","45to54":"46","55to64":"42","65+":"6","medianAge":"42"}},"title":"Packaging and filling machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"277","women":"55.8","white":"67.0","black":"22.3","asian":"7.6","hispanicOrLatino":"38.9"}},"wageData":{"2018":{"workers":"250","median":"529","maleWorkers":"110","maleMedian":"602","femaleWorkers":"140","femaleMedian":"496"}}},"Painting workers":{"ageData":{"2018":{"total":"165","16to19":"5","20to24":"20","25to34":"44","35to44":"35","45to54":"33","55to64":"25","65+":"4","medianAge":"25"}},"title":"Painting workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"165","women":"9.4","white":"80.7","black":"11.2","asian":"1.8","hispanicOrLatino":"36.0"}},"wageData":{"2018":{"workers":"159","median":"710","maleWorkers":"142","maleMedian":"725","femaleWorkers":"16","femaleMedian":"-"}}},"Photographic process workers and processing machine operators":{"ageData":{"2018":{"total":"17","16to19":"0","20to24":"2","25to34":"5","35to44":"1","45to54":"6","55to64":"2","65+":"1","medianAge":"2"}},"title":"Photographic process workers and processing machine operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"17","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"15","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Semiconductor processors":{"ageData":{"2018":{"total":"1","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Semiconductor processors","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"1","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Adhesive bonding machine operators and tenders":{"ageData":{"2018":{"total":"8","16to19":"0","20to24":"0","25to34":"2","35to44":"2","45to54":"1","55to64":"3","65+":"0","medianAge":"3"}},"title":"Adhesive bonding machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"8","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"8","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Cleaning, washing, and metal pickling equipment operators and tenders":{"ageData":{"2018":{"total":"9","16to19":"0","20to24":"3","25to34":"2","35to44":"0","45to54":"0","55to64":"2","65+":"1","medianAge":"2"}},"title":"Cleaning, washing, and metal pickling equipment operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"9","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Cooling and freezing equipment operators and tenders":{"ageData":{"2018":{"total":"4","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"3","55to64":"0","65+":"0","medianAge":"0"}},"title":"Cooling and freezing equipment operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"4","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Etchers and engravers":{"ageData":{"2018":{"total":"11","16to19":"0","20to24":"1","25to34":"1","35to44":"1","45to54":"1","55to64":"5","65+":"2","medianAge":"5"}},"title":"Etchers and engravers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"11","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"8","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Molders, shapers, and casters, except metal and plastic":{"ageData":{"2018":{"total":"37","16to19":"0","20to24":"3","25to34":"6","35to44":"13","45to54":"6","55to64":"7","65+":"3","medianAge":"7"}},"title":"Molders, shapers, and casters, except metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"37","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"28","median":"-","maleWorkers":"27","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Paper goods machine setters, operators, and tenders":{"ageData":{"2018":{"total":"21","16to19":"0","20to24":"2","25to34":"3","35to44":"5","45to54":"5","55to64":"5","65+":"1","medianAge":"5"}},"title":"Paper goods machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"21","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"20","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Tire builders":{"ageData":{"2018":{"total":"7","16to19":"0","20to24":"0","25to34":"2","35to44":"4","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Tire builders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"7","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers--production workers":{"ageData":{"2018":{"total":"53","16to19":"8","20to24":"9","25to34":"15","35to44":"5","45to54":"9","55to64":"6","65+":"2","medianAge":"6"}},"title":"Helpers--production workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"53","women":"31.8","white":"77.6","black":"13.9","asian":"4.3","hispanicOrLatino":"37.9"}},"wageData":{"2018":{"workers":"37","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Production workers, all other":{"ageData":{"2018":{"total":"1,107","16to19":"26","20to24":"127","25to34":"273","35to44":"213","45to54":"252","55to64":"184","65+":"32","medianAge":"184"}},"title":"Production workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2018":{"total":"1,107","women":"29.5","white":"74.9","black":"16.6","asian":"4.1","hispanicOrLatino":"26.4"}},"wageData":{"2018":{"workers":"992","median":"678","maleWorkers":"729","maleMedian":"725","femaleWorkers":"263","femaleMedian":"566"}}},"Transportation and material moving occupations":{"ageData":{"2018":{"total":"9,918","16to19":"362","20to24":"990","25to34":"2,055","35to44":"1,866","45to54":"2,145","55to64":"1,835","65+":"665","medianAge":"1,835"}},"title":"Transportation and material moving occupations","depth":2,"parent":"Production, transportation, and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"9,918","women":"18.1","white":"72.5","black":"19.2","asian":"4.5","hispanicOrLatino":"22.3"}},"wageData":{"2018":{"workers":"7,542","median":"689","maleWorkers":"6,305","maleMedian":"724","femaleWorkers":"1,237","femaleMedian":"538"}}},"Supervisors of transportation and material moving workers":{"ageData":{"2018":{"total":"217","16to19":"0","20to24":"13","25to34":"49","35to44":"44","45to54":"64","55to64":"39","65+":"7","medianAge":"39"}},"title":"Supervisors of transportation and material moving workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"217","women":"23.2","white":"68.3","black":"19.5","asian":"6.7","hispanicOrLatino":"14.2"}},"wageData":{"2018":{"workers":"197","median":"850","maleWorkers":"152","maleMedian":"878","femaleWorkers":"45","femaleMedian":"-"}}},"Aircraft pilots and flight engineers":{"ageData":{"2018":{"total":"119","16to19":"0","20to24":"3","25to34":"21","35to44":"30","45to54":"26","55to64":"36","65+":"3","medianAge":"36"}},"title":"Aircraft pilots and flight engineers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"119","women":"9.0","white":"92.4","black":"2.7","asian":"4.2","hispanicOrLatino":"6.8"}},"wageData":{"2018":{"workers":"98","median":"1,743","maleWorkers":"91","maleMedian":"1,837","femaleWorkers":"7","femaleMedian":"-"}}},"Air traffic controllers and airfield operations specialists":{"ageData":{"2018":{"total":"37","16to19":"0","20to24":"1","25to34":"17","35to44":"9","45to54":"4","55to64":"6","65+":"0","medianAge":"6"}},"title":"Air traffic controllers and airfield operations specialists","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"37","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"38","median":"-","maleWorkers":"35","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Flight attendants":{"ageData":{"2018":{"total":"104","16to19":"0","20to24":"4","25to34":"16","35to44":"19","45to54":"31","55to64":"25","65+":"10","medianAge":"25"}},"title":"Flight attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"104","women":"74.9","white":"66.1","black":"20.8","asian":"10.6","hispanicOrLatino":"9.7"}},"wageData":{"2018":{"workers":"74","median":"878","maleWorkers":"21","maleMedian":"-","femaleWorkers":"53","femaleMedian":"822"}}},"Ambulance drivers and attendants, except emergency medical technicians":{"ageData":{"2018":{"total":"12","16to19":"0","20to24":"0","25to34":"7","35to44":"1","45to54":"3","55to64":"0","65+":"0","medianAge":"0"}},"title":"Ambulance drivers and attendants, except emergency medical technicians","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"12","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"8","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Bus drivers":{"ageData":{"2018":{"total":"599","16to19":"1","20to24":"9","25to34":"65","35to44":"89","45to54":"161","55to64":"175","65+":"99","medianAge":"175"}},"title":"Bus drivers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"599","women":"43.8","white":"64.8","black":"29.4","asian":"3.8","hispanicOrLatino":"15.1"}},"wageData":{"2018":{"workers":"361","median":"655","maleWorkers":"216","maleMedian":"735","femaleWorkers":"144","femaleMedian":"599"}}},"Driver/sales workers and truck drivers":{"ageData":{"2018":{"total":"3,549","16to19":"64","20to24":"236","25to34":"636","35to44":"701","45to54":"871","55to64":"764","65+":"277","medianAge":"764"}},"title":"Driver/sales workers and truck drivers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"3,549","women":"6.6","white":"77.0","black":"16.3","asian":"3.2","hispanicOrLatino":"20.9"}},"wageData":{"2018":{"workers":"2,791","median":"817","maleWorkers":"2,636","maleMedian":"829","femaleWorkers":"155","femaleMedian":"559"}}},"Taxi drivers and chauffeurs":{"ageData":{"2018":{"total":"777","16to19":"6","20to24":"38","25to34":"168","35to44":"151","45to54":"175","55to64":"148","65+":"91","medianAge":"148"}},"title":"Taxi drivers and chauffeurs","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"777","women":"18.0","white":"52.5","black":"27.9","asian":"14.9","hispanicOrLatino":"18.3"}},"wageData":{"2018":{"workers":"399","median":"611","maleWorkers":"341","maleMedian":"628","femaleWorkers":"58","femaleMedian":"450"}}},"Motor vehicle operators, all other":{"ageData":{"2018":{"total":"63","16to19":"1","20to24":"3","25to34":"9","35to44":"7","45to54":"7","55to64":"16","65+":"19","medianAge":"16"}},"title":"Motor vehicle operators, all other","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"63","women":"18.1","white":"75.7","black":"20.8","asian":"1.2","hispanicOrLatino":"21.0"}},"wageData":{"2018":{"workers":"39","median":"-","maleWorkers":"34","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Locomotive engineers and operators":{"ageData":{"2018":{"total":"36","16to19":"0","20to24":"0","25to34":"9","35to44":"10","45to54":"10","55to64":"7","65+":"1","medianAge":"7"}},"title":"Locomotive engineers and operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"36","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"34","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Railroad brake, signal, and switch operators":{"ageData":{"2018":{"total":"5","16to19":"0","20to24":"1","25to34":"0","35to44":"2","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Railroad brake, signal, and switch operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Railroad conductors and yardmasters":{"ageData":{"2018":{"total":"53","16to19":"0","20to24":"3","25to34":"17","35to44":"17","45to54":"12","55to64":"3","65+":"1","medianAge":"3"}},"title":"Railroad conductors and yardmasters","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"53","women":"7.1","white":"76.1","black":"15.0","asian":"5.6","hispanicOrLatino":"13.4"}},"wageData":{"2018":{"workers":"54","median":"1,132","maleWorkers":"50","maleMedian":"1,143","femaleWorkers":"4","femaleMedian":"-"}}},"Subway, streetcar, and other rail transportation workers":{"ageData":{"2018":{"total":"15","16to19":"0","20to24":"0","25to34":"2","35to44":"4","45to54":"5","55to64":"2","65+":"1","medianAge":"2"}},"title":"Subway, streetcar, and other rail transportation workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"15","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"17","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Sailors and marine oilers":{"ageData":{"2018":{"total":"21","16to19":"2","20to24":"4","25to34":"6","35to44":"3","45to54":"1","55to64":"5","65+":"0","medianAge":"5"}},"title":"Sailors and marine oilers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"21","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"21","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Ship and boat captains and operators":{"ageData":{"2018":{"total":"33","16to19":"0","20to24":"1","25to34":"8","35to44":"9","45to54":"7","55to64":"7","65+":"1","medianAge":"7"}},"title":"Ship and boat captains and operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"33","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"30","median":"-","maleWorkers":"29","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Ship engineers":{"ageData":{"2018":{"total":"6","16to19":"0","20to24":"1","25to34":"3","35to44":"0","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Ship engineers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"6","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Bridge and lock tenders":{"ageData":{"2018":{"total":"7","16to19":"0","20to24":"0","25to34":"3","35to44":"1","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Bridge and lock tenders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"7","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Parking lot attendants":{"ageData":{"2018":{"total":"87","16to19":"4","20to24":"32","25to34":"14","35to44":"12","45to54":"10","55to64":"10","65+":"5","medianAge":"10"}},"title":"Parking lot attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"87","women":"9.7","white":"74.3","black":"17.1","asian":"7.8","hispanicOrLatino":"44.2"}},"wageData":{"2018":{"workers":"61","median":"575","maleWorkers":"54","maleMedian":"575","femaleWorkers":"8","femaleMedian":"-"}}},"Automotive and watercraft service attendants":{"ageData":{"2018":{"total":"102","16to19":"10","20to24":"23","25to34":"22","35to44":"11","45to54":"16","55to64":"15","65+":"4","medianAge":"15"}},"title":"Automotive and watercraft service attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"102","women":"20.5","white":"76.3","black":"9.5","asian":"7.7","hispanicOrLatino":"20.8"}},"wageData":{"2018":{"workers":"70","median":"570","maleWorkers":"56","maleMedian":"575","femaleWorkers":"14","femaleMedian":"-"}}},"Transportation inspectors":{"ageData":{"2018":{"total":"37","16to19":"1","20to24":"1","25to34":"9","35to44":"6","45to54":"11","55to64":"7","65+":"1","medianAge":"7"}},"title":"Transportation inspectors","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"37","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"37","median":"-","maleWorkers":"34","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Transportation attendants, except flight attendants":{"ageData":{"2018":{"total":"40","16to19":"2","20to24":"4","25to34":"5","35to44":"6","45to54":"8","55to64":"11","65+":"4","medianAge":"11"}},"title":"Transportation attendants, except flight attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"40","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"19","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Other transportation workers":{"ageData":{"2018":{"total":"24","16to19":"0","20to24":"3","25to34":"6","35to44":"5","45to54":"6","55to64":"4","65+":"0","medianAge":"4"}},"title":"Other transportation workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"24","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"19","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Conveyor operators and tenders":{"ageData":{"2018":{"total":"2","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Conveyor operators and tenders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"2","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Crane and tower operators":{"ageData":{"2018":{"total":"68","16to19":"0","20to24":"3","25to34":"18","35to44":"15","45to54":"14","55to64":"14","65+":"2","medianAge":"14"}},"title":"Crane and tower operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"68","women":"6.0","white":"82.2","black":"12.3","asian":"3.6","hispanicOrLatino":"8.3"}},"wageData":{"2018":{"workers":"64","median":"1,122","maleWorkers":"60","maleMedian":"1,079","femaleWorkers":"3","femaleMedian":"-"}}},"Dredge, excavating, and loading machine operators":{"ageData":{"2018":{"total":"24","16to19":"0","20to24":"2","25to34":"4","35to44":"6","45to54":"7","55to64":"4","65+":"2","medianAge":"4"}},"title":"Dredge, excavating, and loading machine operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"24","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"19","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Hoist and winch operators":{"ageData":{"2018":{"total":"10","16to19":"2","20to24":"0","25to34":"1","35to44":"5","45to54":"0","55to64":"3","65+":"0","medianAge":"3"}},"title":"Hoist and winch operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"10","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"8","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Industrial truck and tractor operators":{"ageData":{"2018":{"total":"631","16to19":"7","20to24":"71","25to34":"176","35to44":"127","45to54":"137","55to64":"101","65+":"13","medianAge":"101"}},"title":"Industrial truck and tractor operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"631","women":"8.1","white":"71.2","black":"21.5","asian":"1.7","hispanicOrLatino":"30.2"}},"wageData":{"2018":{"workers":"596","median":"641","maleWorkers":"549","maleMedian":"641","femaleWorkers":"48","femaleMedian":"-"}}},"Cleaners of vehicles and equipment":{"ageData":{"2018":{"total":"329","16to19":"41","20to24":"54","25to34":"78","35to44":"59","45to54":"47","55to64":"38","65+":"12","medianAge":"38"}},"title":"Cleaners of vehicles and equipment","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"329","women":"15.2","white":"73.2","black":"19.8","asian":"2.0","hispanicOrLatino":"32.9"}},"wageData":{"2018":{"workers":"232","median":"538","maleWorkers":"192","maleMedian":"536","femaleWorkers":"40","femaleMedian":"-"}}},"Laborers and freight, stock, and material movers, hand":{"ageData":{"2018":{"total":"2,106","16to19":"158","20to24":"366","25to34":"510","35to44":"373","45to54":"355","55to64":"272","65+":"73","medianAge":"272"}},"title":"Laborers and freight, stock, and material movers, hand","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"2,106","women":"21.4","white":"74.0","black":"18.9","asian":"3.1","hispanicOrLatino":"22.0"}},"wageData":{"2018":{"workers":"1,595","median":"603","maleWorkers":"1,277","maleMedian":"620","femaleWorkers":"318","femaleMedian":"541"}}},"Machine feeders and offbearers":{"ageData":{"2018":{"total":"30","16to19":"1","20to24":"5","25to34":"6","35to44":"5","45to54":"5","55to64":"7","65+":"0","medianAge":"7"}},"title":"Machine feeders and offbearers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"30","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"25","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Packers and packagers, hand":{"ageData":{"2018":{"total":"607","16to19":"57","20to24":"92","25to34":"131","35to44":"103","45to54":"113","55to64":"85","65+":"25","medianAge":"85"}},"title":"Packers and packagers, hand","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"607","women":"54.5","white":"68.1","black":"19.8","asian":"7.9","hispanicOrLatino":"42.6"}},"wageData":{"2018":{"workers":"490","median":"495","maleWorkers":"205","maleMedian":"516","femaleWorkers":"285","femaleMedian":"484"}}},"Pumping station operators":{"ageData":{"2018":{"total":"16","16to19":"0","20to24":"0","25to34":"5","35to44":"4","45to54":"2","55to64":"3","65+":"1","medianAge":"3"}},"title":"Pumping station operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"16","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"16","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Refuse and recyclable material collectors":{"ageData":{"2018":{"total":"91","16to19":"5","20to24":"6","25to34":"20","35to44":"20","45to54":"19","55to64":"15","65+":"7","medianAge":"15"}},"title":"Refuse and recyclable material collectors","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"91","women":"14.5","white":"68.8","black":"23.5","asian":"2.8","hispanicOrLatino":"28.6"}},"wageData":{"2018":{"workers":"63","median":"524","maleWorkers":"55","maleMedian":"536","femaleWorkers":"8","femaleMedian":"-"}}},"Mine shuttle car operators":{"ageData":{"2018":{"total":"1","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Mine shuttle car operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"1","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Tank car, truck, and ship loaders":{"ageData":{"2018":{"total":"8","16to19":"0","20to24":"2","25to34":"5","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Tank car, truck, and ship loaders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"8","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2018":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Material moving workers, all other":{"ageData":{"2018":{"total":"51","16to19":"0","20to24":"8","25to34":"7","35to44":"11","45to54":"12","55to64":"10","65+":"3","medianAge":"10"}},"title":"Material moving workers, all other","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2018":{"total":"51","women":"19.9","white":"74.9","black":"24.3","asian":"0.1","hispanicOrLatino":"25.7"}},"wageData":{"2018":{"workers":"41","median":"-","maleWorkers":"37","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}}}');


var $0894db524f4dc2d8$exports = {};
$0894db524f4dc2d8$exports = JSON.parse('{"Total":{"ageData":{"2017":{"total":"153,337","16to19":"5,074","20to24":"14,132","25to34":"34,439","35to44":"31,892","45to54":"32,503","55to64":"26,064","65+":"9,234","medianAge":"26,064"}},"title":"Total","depth":1,"parent":"","sexRaceEthnicityData":{"2017":{"total":"153,337","women":"46.9","white":"78.4","black":"12.1","asian":"6.2","hispanicOrLatino":"16.9"}},"wageData":{"2017":{"workers":"113,272","median":"$860","maleWorkers":"62,980","maleMedian":"$941","femaleWorkers":"50,291","femaleMedian":"$770"}}},"Management, professional, and related occupations":{"ageData":{"2017":{"total":"60,901","16to19":"435","20to24":"3,275","25to34":"14,130","35to44":"14,136","45to54":"13,892","55to64":"11,020","65+":"4,013","medianAge":"11,020"}},"title":"Management, professional, and related occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2017":{"total":"60,901","women":"51.6","white":"80.0","black":"9.4","asian":"8.1","hispanicOrLatino":"9.6"}},"wageData":{"2017":{"workers":"47,207","median":"1,224","maleWorkers":"22,815","maleMedian":"1,442","femaleWorkers":"24,393","femaleMedian":"1,052"}}},"Management, business, and financial operations occupations":{"ageData":{"2017":{"total":"25,379","16to19":"104","20to24":"977","25to34":"5,124","35to44":"5,863","45to54":"6,389","55to64":"5,071","65+":"1,851","medianAge":"5,071"}},"title":"Management, business, and financial operations occupations","depth":2,"parent":"Management, professional, and related occupations","sexRaceEthnicityData":{"2017":{"total":"25,379","women":"44.0","white":"83.0","black":"8.2","asian":"6.4","hispanicOrLatino":"10.0"}},"wageData":{"2017":{"workers":"19,414","median":"1,327","maleWorkers":"10,415","maleMedian":"1,526","femaleWorkers":"8,999","femaleMedian":"1,134"}}},"Management occupations":{"ageData":{"2017":{"total":"17,804","16to19":"75","20to24":"554","25to34":"3,149","35to44":"4,203","45to54":"4,751","55to64":"3,704","65+":"1,369","medianAge":"3,704"}},"title":"Management occupations","depth":3,"parent":"Management, business, and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"17,804","women":"39.8","white":"84.0","black":"7.6","asian":"5.9","hispanicOrLatino":"9.9"}},"wageData":{"2017":{"workers":"13,169","median":"1,392","maleWorkers":"7,568","maleMedian":"1,573","femaleWorkers":"5,600","femaleMedian":"1,173"}}},"Chief executives":{"ageData":{"2017":{"total":"1,639","16to19":"2","20to24":"4","25to34":"145","35to44":"328","45to54":"505","55to64":"455","65+":"201","medianAge":"455"}},"title":"Chief executives","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"1,639","women":"28.0","white":"90.0","black":"3.8","asian":"4.6","hispanicOrLatino":"4.7"}},"wageData":{"2017":{"workers":"1,136","median":"2,296","maleWorkers":"823","maleMedian":"2,415","femaleWorkers":"313","femaleMedian":"1,920"}}},"General and operations managers":{"ageData":{"2017":{"total":"1,005","16to19":"1","20to24":"28","25to34":"227","35to44":"279","45to54":"254","55to64":"184","65+":"32","medianAge":"184"}},"title":"General and operations managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"1,005","women":"34.1","white":"85.0","black":"8.3","asian":"4.5","hispanicOrLatino":"11.4"}},"wageData":{"2017":{"workers":"920","median":"1,328","maleWorkers":"598","maleMedian":"1,488","femaleWorkers":"321","femaleMedian":"1,134"}}},"Legislators":{"ageData":{"2017":{"total":"18","16to19":"0","20to24":"1","25to34":"2","35to44":"2","45to54":"4","55to64":"5","65+":"4","medianAge":"5"}},"title":"Legislators","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"18","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"14","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Advertising and promotions managers":{"ageData":{"2017":{"total":"61","16to19":"0","20to24":"3","25to34":"14","35to44":"20","45to54":"12","55to64":"11","65+":"1","medianAge":"11"}},"title":"Advertising and promotions managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"61","women":"52.7","white":"84.5","black":"8.0","asian":"7.5","hispanicOrLatino":"7.4"}},"wageData":{"2017":{"workers":"53","median":"1,330","maleWorkers":"24","maleMedian":"-","femaleWorkers":"29","femaleMedian":"-"}}},"Marketing and sales managers":{"ageData":{"2017":{"total":"1,078","16to19":"5","20to24":"51","25to34":"267","35to44":"296","45to54":"272","55to64":"155","65+":"33","medianAge":"155"}},"title":"Marketing and sales managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"1,078","women":"45.3","white":"86.4","black":"6.0","asian":"6.1","hispanicOrLatino":"10.2"}},"wageData":{"2017":{"workers":"994","median":"1,509","maleWorkers":"566","maleMedian":"1,747","femaleWorkers":"428","femaleMedian":"1,288"}}},"Public relations and fundraising managers":{"ageData":{"2017":{"total":"73","16to19":"0","20to24":"2","25to34":"23","35to44":"17","45to54":"17","55to64":"12","65+":"1","medianAge":"12"}},"title":"Public relations and fundraising managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"73","women":"63.5","white":"87.9","black":"7.8","asian":"3.2","hispanicOrLatino":"3.7"}},"wageData":{"2017":{"workers":"71","median":"1,318","maleWorkers":"24","maleMedian":"-","femaleWorkers":"47","femaleMedian":"-"}}},"Administrative services managers":{"ageData":{"2017":{"total":"151","16to19":"0","20to24":"1","25to34":"25","35to44":"32","45to54":"42","55to64":"43","65+":"8","medianAge":"43"}},"title":"Administrative services managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"151","women":"40.1","white":"83.5","black":"9.4","asian":"3.2","hispanicOrLatino":"10.3"}},"wageData":{"2017":{"workers":"147","median":"1,233","maleWorkers":"89","maleMedian":"1,629","femaleWorkers":"57","femaleMedian":"1,013"}}},"Computer and information systems managers":{"ageData":{"2017":{"total":"630","16to19":"0","20to24":"13","25to34":"95","35to44":"192","45to54":"192","55to64":"124","65+":"14","medianAge":"124"}},"title":"Computer and information systems managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"630","women":"28.6","white":"78.0","black":"6.6","asian":"13.0","hispanicOrLatino":"6.6"}},"wageData":{"2017":{"workers":"594","median":"1,843","maleWorkers":"428","maleMedian":"1,897","femaleWorkers":"165","femaleMedian":"1,629"}}},"Financial managers":{"ageData":{"2017":{"total":"1,167","16to19":"1","20to24":"34","25to34":"273","35to44":"302","45to54":"297","55to64":"210","65+":"51","medianAge":"210"}},"title":"Financial managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"1,167","women":"55.7","white":"83.5","black":"6.7","asian":"8.2","hispanicOrLatino":"11.2"}},"wageData":{"2017":{"workers":"1,111","median":"1,412","maleWorkers":"500","maleMedian":"1,719","femaleWorkers":"611","femaleMedian":"1,222"}}},"Compensation and benefits managers":{"ageData":{"2017":{"total":"16","16to19":"0","20to24":"0","25to34":"2","35to44":"4","45to54":"5","55to64":"4","65+":"1","medianAge":"4"}},"title":"Compensation and benefits managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"16","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"16","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Human resources managers":{"ageData":{"2017":{"total":"327","16to19":"1","20to24":"5","25to34":"65","35to44":"92","45to54":"96","55to64":"54","65+":"15","medianAge":"54"}},"title":"Human resources managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"327","women":"70.8","white":"81.7","black":"12.3","asian":"4.3","hispanicOrLatino":"7.9"}},"wageData":{"2017":{"workers":"304","median":"1,448","maleWorkers":"92","maleMedian":"1,748","femaleWorkers":"211","femaleMedian":"1,280"}}},"Training and development managers":{"ageData":{"2017":{"total":"63","16to19":"0","20to24":"3","25to34":"10","35to44":"14","45to54":"17","55to64":"17","65+":"1","medianAge":"17"}},"title":"Training and development managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"63","women":"59.8","white":"89.2","black":"5.6","asian":"2.2","hispanicOrLatino":"9.0"}},"wageData":{"2017":{"workers":"58","median":"1,396","maleWorkers":"23","maleMedian":"-","femaleWorkers":"35","femaleMedian":"-"}}},"Industrial production managers":{"ageData":{"2017":{"total":"280","16to19":"0","20to24":"9","25to34":"38","35to44":"67","45to54":"91","55to64":"62","65+":"13","medianAge":"62"}},"title":"Industrial production managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"280","women":"25.7","white":"89.5","black":"3.8","asian":"5.9","hispanicOrLatino":"9.3"}},"wageData":{"2017":{"workers":"265","median":"1,486","maleWorkers":"202","maleMedian":"1,526","femaleWorkers":"63","femaleMedian":"1,312"}}},"Purchasing managers":{"ageData":{"2017":{"total":"205","16to19":"0","20to24":"13","25to34":"41","35to44":"38","45to54":"61","55to64":"41","65+":"11","medianAge":"41"}},"title":"Purchasing managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"205","women":"52.3","white":"84.3","black":"10.6","asian":"3.3","hispanicOrLatino":"9.1"}},"wageData":{"2017":{"workers":"194","median":"1,271","maleWorkers":"90","maleMedian":"1,420","femaleWorkers":"104","femaleMedian":"1,138"}}},"Transportation, storage, and distribution managers":{"ageData":{"2017":{"total":"291","16to19":"1","20to24":"9","25to34":"58","35to44":"61","45to54":"87","55to64":"63","65+":"12","medianAge":"63"}},"title":"Transportation, storage, and distribution managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"291","women":"19.2","white":"79.7","black":"10.7","asian":"5.3","hispanicOrLatino":"13.8"}},"wageData":{"2017":{"workers":"274","median":"1,039","maleWorkers":"225","maleMedian":"1,061","femaleWorkers":"49","femaleMedian":"-"}}},"Farmers, ranchers, and other agricultural managers":{"ageData":{"2017":{"total":"1,018","16to19":"6","20to24":"24","25to34":"103","35to44":"145","45to54":"190","55to64":"257","65+":"293","medianAge":"257"}},"title":"Farmers, ranchers, and other agricultural managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"1,018","women":"25.2","white":"95.4","black":"0.8","asian":"1.4","hispanicOrLatino":"6.1"}},"wageData":{"2017":{"workers":"121","median":"1,001","maleWorkers":"100","maleMedian":"963","femaleWorkers":"21","femaleMedian":"-"}}},"Construction managers":{"ageData":{"2017":{"total":"1,081","16to19":"4","20to24":"27","25to34":"167","35to44":"256","45to54":"320","55to64":"233","65+":"75","medianAge":"233"}},"title":"Construction managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"1,081","women":"7.4","white":"90.2","black":"4.9","asian":"2.3","hispanicOrLatino":"12.4"}},"wageData":{"2017":{"workers":"582","median":"1,428","maleWorkers":"526","maleMedian":"1,439","femaleWorkers":"56","femaleMedian":"1,243"}}},"Education administrators":{"ageData":{"2017":{"total":"918","16to19":"5","20to24":"21","25to34":"146","35to44":"246","45to54":"256","55to64":"183","65+":"60","medianAge":"183"}},"title":"Education administrators","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"918","women":"64.2","white":"81.8","black":"12.9","asian":"2.1","hispanicOrLatino":"10.3"}},"wageData":{"2017":{"workers":"801","median":"1,367","maleWorkers":"304","maleMedian":"1,561","femaleWorkers":"497","femaleMedian":"1,243"}}},"Architectural and engineering managers":{"ageData":{"2017":{"total":"129","16to19":"0","20to24":"2","25to34":"12","35to44":"35","45to54":"39","55to64":"38","65+":"4","medianAge":"38"}},"title":"Architectural and engineering managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"129","women":"8.7","white":"79.7","black":"8.3","asian":"11.2","hispanicOrLatino":"6.2"}},"wageData":{"2017":{"workers":"128","median":"1,999","maleWorkers":"119","maleMedian":"2,020","femaleWorkers":"10","femaleMedian":"-"}}},"Food service managers":{"ageData":{"2017":{"total":"1,210","16to19":"38","20to24":"139","25to34":"336","35to44":"227","45to54":"245","55to64":"180","65+":"44","medianAge":"180"}},"title":"Food service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"1,210","women":"46.3","white":"74.7","black":"9.5","asian":"11.7","hispanicOrLatino":"16.9"}},"wageData":{"2017":{"workers":"816","median":"753","maleWorkers":"421","maleMedian":"894","femaleWorkers":"394","femaleMedian":"674"}}},"Funeral service managers":{"ageData":{"2017":{"total":"15","16to19":"0","20to24":"0","25to34":"1","35to44":"2","45to54":"4","55to64":"4","65+":"5","medianAge":"4"}},"title":"Funeral service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"15","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"9","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Gaming managers":{"ageData":{"2017":{"total":"19","16to19":"0","20to24":"0","25to34":"5","35to44":"4","45to54":"5","55to64":"4","65+":"1","medianAge":"4"}},"title":"Gaming managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"19","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"23","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Lodging managers":{"ageData":{"2017":{"total":"156","16to19":"1","20to24":"7","25to34":"35","35to44":"34","45to54":"39","55to64":"29","65+":"10","medianAge":"29"}},"title":"Lodging managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"156","women":"48.8","white":"72.9","black":"11.2","asian":"12.5","hispanicOrLatino":"12.0"}},"wageData":{"2017":{"workers":"116","median":"882","maleWorkers":"54","maleMedian":"982","femaleWorkers":"62","femaleMedian":"844"}}},"Medical and health services managers":{"ageData":{"2017":{"total":"671","16to19":"2","20to24":"13","25to34":"117","35to44":"171","45to54":"194","55to64":"142","65+":"33","medianAge":"142"}},"title":"Medical and health services managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"671","women":"69.8","white":"77.9","black":"14.0","asian":"5.7","hispanicOrLatino":"9.1"}},"wageData":{"2017":{"workers":"610","median":"1,319","maleWorkers":"177","maleMedian":"1,490","femaleWorkers":"433","femaleMedian":"1,177"}}},"Natural sciences managers":{"ageData":{"2017":{"total":"16","16to19":"0","20to24":"0","25to34":"5","35to44":"3","45to54":"4","55to64":"3","65+":"2","medianAge":"3"}},"title":"Natural sciences managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"16","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"17","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Postmasters and mail superintendents":{"ageData":{"2017":{"total":"27","16to19":"0","20to24":"1","25to34":"1","35to44":"2","45to54":"11","55to64":"11","65+":"1","medianAge":"11"}},"title":"Postmasters and mail superintendents","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"27","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"23","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Property, real estate, and community association managers":{"ageData":{"2017":{"total":"743","16to19":"0","20to24":"20","25to34":"122","35to44":"146","45to54":"193","55to64":"166","65+":"96","medianAge":"166"}},"title":"Property, real estate, and community association managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"743","women":"48.6","white":"81.8","black":"11.6","asian":"3.5","hispanicOrLatino":"14.4"}},"wageData":{"2017":{"workers":"421","median":"957","maleWorkers":"181","maleMedian":"1,163","femaleWorkers":"241","femaleMedian":"873"}}},"Social and community service managers":{"ageData":{"2017":{"total":"390","16to19":"0","20to24":"14","25to34":"79","35to44":"93","45to54":"90","55to64":"79","65+":"34","medianAge":"79"}},"title":"Social and community service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"390","women":"70.2","white":"78.1","black":"13.7","asian":"4.0","hispanicOrLatino":"8.6"}},"wageData":{"2017":{"workers":"337","median":"1,136","maleWorkers":"101","maleMedian":"1,281","femaleWorkers":"236","femaleMedian":"1,052"}}},"Emergency management directors":{"ageData":{"2017":{"total":"11","16to19":"0","20to24":"1","25to34":"3","35to44":"1","45to54":"2","55to64":"3","65+":"1","medianAge":"3"}},"title":"Emergency management directors","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"11","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"10","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Managers, all other":{"ageData":{"2017":{"total":"4,398","16to19":"7","20to24":"110","25to34":"731","35to44":"1,095","45to54":"1,206","55to64":"935","65+":"314","medianAge":"935"}},"title":"Managers, all other","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2017":{"total":"4,398","women":"35.8","white":"83.2","black":"7.4","asian":"7.0","hispanicOrLatino":"9.4"}},"wageData":{"2017":{"workers":"3,004","median":"1,488","maleWorkers":"1,841","maleMedian":"1,629","femaleWorkers":"1,163","femaleMedian":"1,251"}}},"Business and financial operations occupations":{"ageData":{"2017":{"total":"7,574","16to19":"29","20to24":"423","25to34":"1,975","35to44":"1,660","45to54":"1,639","55to64":"1,367","65+":"482","medianAge":"1,367"}},"title":"Business and financial operations occupations","depth":3,"parent":"Management, business, and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"7,574","women":"54.0","white":"80.7","black":"9.4","asian":"7.5","hispanicOrLatino":"10.2"}},"wageData":{"2017":{"workers":"6,245","median":"1,174","maleWorkers":"2,847","maleMedian":"1,390","femaleWorkers":"3,398","femaleMedian":"1,055"}}},"Agents and business managers of artists, performers, and athletes":{"ageData":{"2017":{"total":"50","16to19":"0","20to24":"7","25to34":"14","35to44":"9","45to54":"11","55to64":"6","65+":"4","medianAge":"6"}},"title":"Agents and business managers of artists, performers, and athletes","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"50","women":"44.4","white":"77.3","black":"15.9","asian":"6.1","hispanicOrLatino":"4.0"}},"wageData":{"2017":{"workers":"23","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"15","femaleMedian":"-"}}},"Buyers and purchasing agents, farm products":{"ageData":{"2017":{"total":"11","16to19":"1","20to24":"0","25to34":"3","35to44":"2","45to54":"2","55to64":"1","65+":"1","medianAge":"1"}},"title":"Buyers and purchasing agents, farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"11","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"10","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Wholesale and retail buyers, except farm products":{"ageData":{"2017":{"total":"194","16to19":"2","20to24":"13","25to34":"59","35to44":"40","45to54":"36","55to64":"29","65+":"15","medianAge":"29"}},"title":"Wholesale and retail buyers, except farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"194","women":"55.8","white":"84.2","black":"7.7","asian":"6.2","hispanicOrLatino":"9.0"}},"wageData":{"2017":{"workers":"154","median":"886","maleWorkers":"67","maleMedian":"882","femaleWorkers":"87","femaleMedian":"888"}}},"Purchasing agents, except wholesale, retail, and farm products":{"ageData":{"2017":{"total":"270","16to19":"2","20to24":"11","25to34":"52","35to44":"55","45to54":"70","55to64":"63","65+":"17","medianAge":"63"}},"title":"Purchasing agents, except wholesale, retail, and farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"270","women":"44.1","white":"82.7","black":"9.4","asian":"6.1","hispanicOrLatino":"11.9"}},"wageData":{"2017":{"workers":"240","median":"1,132","maleWorkers":"143","maleMedian":"1,144","femaleWorkers":"96","femaleMedian":"1,085"}}},"Claims adjusters, appraisers, examiners, and investigators":{"ageData":{"2017":{"total":"350","16to19":"1","20to24":"15","25to34":"99","35to44":"79","45to54":"82","55to64":"60","65+":"15","medianAge":"60"}},"title":"Claims adjusters, appraisers, examiners, and investigators","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"350","women":"61.7","white":"77.0","black":"18.2","asian":"3.0","hispanicOrLatino":"11.4"}},"wageData":{"2017":{"workers":"346","median":"1,002","maleWorkers":"128","maleMedian":"1,108","femaleWorkers":"218","femaleMedian":"925"}}},"Compliance officers":{"ageData":{"2017":{"total":"260","16to19":"1","20to24":"2","25to34":"60","35to44":"68","45to54":"54","55to64":"65","65+":"10","medianAge":"65"}},"title":"Compliance officers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"260","women":"57.6","white":"80.1","black":"11.9","asian":"5.9","hispanicOrLatino":"9.0"}},"wageData":{"2017":{"workers":"240","median":"1,391","maleWorkers":"106","maleMedian":"1,501","femaleWorkers":"134","femaleMedian":"1,296"}}},"Cost estimators":{"ageData":{"2017":{"total":"118","16to19":"0","20to24":"5","25to34":"27","35to44":"26","45to54":"25","55to64":"27","65+":"9","medianAge":"27"}},"title":"Cost estimators","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"118","women":"12.9","white":"94.4","black":"3.1","asian":"2.2","hispanicOrLatino":"8.5"}},"wageData":{"2017":{"workers":"113","median":"1,139","maleWorkers":"100","maleMedian":"1,157","femaleWorkers":"13","femaleMedian":"-"}}},"Human resources workers":{"ageData":{"2017":{"total":"736","16to19":"5","20to24":"50","25to34":"219","35to44":"185","45to54":"141","55to64":"114","65+":"22","medianAge":"114"}},"title":"Human resources workers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"736","women":"72.1","white":"80.2","black":"11.8","asian":"5.7","hispanicOrLatino":"13.8"}},"wageData":{"2017":{"workers":"664","median":"1,086","maleWorkers":"182","maleMedian":"1,236","femaleWorkers":"482","femaleMedian":"1,035"}}},"Compensation, benefits, and job analysis specialists":{"ageData":{"2017":{"total":"59","16to19":"0","20to24":"2","25to34":"12","35to44":"17","45to54":"11","55to64":"12","65+":"5","medianAge":"12"}},"title":"Compensation, benefits, and job analysis specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"59","women":"72.3","white":"72.2","black":"21.5","asian":"2.3","hispanicOrLatino":"15.7"}},"wageData":{"2017":{"workers":"60","median":"1,042","maleWorkers":"21","maleMedian":"-","femaleWorkers":"39","femaleMedian":"-"}}},"Training and development specialists":{"ageData":{"2017":{"total":"133","16to19":"1","20to24":"11","25to34":"36","35to44":"28","45to54":"26","55to64":"26","65+":"5","medianAge":"26"}},"title":"Training and development specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"133","women":"47.1","white":"81.6","black":"12.4","asian":"1.1","hispanicOrLatino":"18.2"}},"wageData":{"2017":{"workers":"114","median":"1,099","maleWorkers":"59","maleMedian":"1,255","femaleWorkers":"55","femaleMedian":"937"}}},"Logisticians":{"ageData":{"2017":{"total":"112","16to19":"0","20to24":"7","25to34":"35","35to44":"25","45to54":"24","55to64":"18","65+":"3","medianAge":"18"}},"title":"Logisticians","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"112","women":"34.8","white":"70.9","black":"17.1","asian":"7.4","hispanicOrLatino":"11.7"}},"wageData":{"2017":{"workers":"101","median":"1,230","maleWorkers":"67","maleMedian":"1,358","femaleWorkers":"33","femaleMedian":"-"}}},"Management analysts":{"ageData":{"2017":{"total":"937","16to19":"1","20to24":"37","25to34":"208","35to44":"203","45to54":"204","55to64":"195","65+":"87","medianAge":"195"}},"title":"Management analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"937","women":"42.3","white":"77.2","black":"9.1","asian":"11.2","hispanicOrLatino":"7.4"}},"wageData":{"2017":{"workers":"606","median":"1,499","maleWorkers":"351","maleMedian":"1,651","femaleWorkers":"255","femaleMedian":"1,315"}}},"Meeting, convention, and event planners":{"ageData":{"2017":{"total":"137","16to19":"2","20to24":"13","25to34":"53","35to44":"17","45to54":"24","55to64":"20","65+":"7","medianAge":"20"}},"title":"Meeting, convention, and event planners","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"137","women":"85.1","white":"91.6","black":"4.7","asian":"1.4","hispanicOrLatino":"9.0"}},"wageData":{"2017":{"workers":"102","median":"1,080","maleWorkers":"14","maleMedian":"-","femaleWorkers":"89","femaleMedian":"1,064"}}},"Fundraisers":{"ageData":{"2017":{"total":"84","16to19":"3","20to24":"6","25to34":"24","35to44":"20","45to54":"10","55to64":"17","65+":"5","medianAge":"17"}},"title":"Fundraisers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"84","women":"77.3","white":"88.4","black":"8.8","asian":"0.2","hispanicOrLatino":"2.6"}},"wageData":{"2017":{"workers":"72","median":"1,152","maleWorkers":"17","maleMedian":"-","femaleWorkers":"55","femaleMedian":"1,152"}}},"Market research analysts and marketing specialists":{"ageData":{"2017":{"total":"344","16to19":"6","20to24":"39","25to34":"120","35to44":"71","45to54":"65","55to64":"34","65+":"9","medianAge":"34"}},"title":"Market research analysts and marketing specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"344","women":"60.8","white":"84.2","black":"5.4","asian":"7.7","hispanicOrLatino":"9.0"}},"wageData":{"2017":{"workers":"258","median":"1,174","maleWorkers":"110","maleMedian":"1,357","femaleWorkers":"149","femaleMedian":"1,061"}}},"Business operations specialists, all other":{"ageData":{"2017":{"total":"273","16to19":"0","20to24":"25","25to34":"61","35to44":"75","45to54":"58","55to64":"44","65+":"10","medianAge":"44"}},"title":"Business operations specialists, all other","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"273","women":"52.5","white":"79.2","black":"9.1","asian":"9.3","hispanicOrLatino":"13.6"}},"wageData":{"2017":{"workers":"250","median":"1,136","maleWorkers":"118","maleMedian":"1,361","femaleWorkers":"132","femaleMedian":"1,013"}}},"Accountants and auditors":{"ageData":{"2017":{"total":"1,804","16to19":"2","20to24":"95","25to34":"454","35to44":"358","45to54":"408","55to64":"341","65+":"146","medianAge":"341"}},"title":"Accountants and auditors","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"1,804","women":"60.3","white":"79.5","black":"8.2","asian":"9.7","hispanicOrLatino":"9.6"}},"wageData":{"2017":{"workers":"1,512","median":"1,173","maleWorkers":"622","maleMedian":"1,389","femaleWorkers":"890","femaleMedian":"1,065"}}},"Appraisers and assessors of real estate":{"ageData":{"2017":{"total":"97","16to19":"0","20to24":"2","25to34":"15","35to44":"22","45to54":"28","55to64":"20","65+":"11","medianAge":"20"}},"title":"Appraisers and assessors of real estate","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"97","women":"37.4","white":"88.8","black":"9.0","asian":"1.8","hispanicOrLatino":"11.0"}},"wageData":{"2017":{"workers":"55","median":"1,074","maleWorkers":"35","maleMedian":"-","femaleWorkers":"20","femaleMedian":"-"}}},"Budget analysts":{"ageData":{"2017":{"total":"53","16to19":"0","20to24":"1","25to34":"10","35to44":"11","45to54":"16","55to64":"13","65+":"2","medianAge":"13"}},"title":"Budget analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"53","women":"46.8","white":"71.1","black":"12.5","asian":"9.7","hispanicOrLatino":"11.1"}},"wageData":{"2017":{"workers":"54","median":"1,377","maleWorkers":"29","maleMedian":"-","femaleWorkers":"26","femaleMedian":"-"}}},"Credit analysts":{"ageData":{"2017":{"total":"29","16to19":"0","20to24":"4","25to34":"8","35to44":"9","45to54":"4","55to64":"4","65+":"0","medianAge":"4"}},"title":"Credit analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"29","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"27","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"15","femaleMedian":"-"}}},"Financial analysts":{"ageData":{"2017":{"total":"309","16to19":"0","20to24":"24","25to34":"114","35to44":"59","45to54":"63","55to64":"35","65+":"14","medianAge":"35"}},"title":"Financial analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"309","women":"36.5","white":"75.6","black":"8.8","asian":"12.5","hispanicOrLatino":"6.9"}},"wageData":{"2017":{"workers":"264","median":"1,530","maleWorkers":"156","maleMedian":"1,590","femaleWorkers":"108","femaleMedian":"1,369"}}},"Personal financial advisors":{"ageData":{"2017":{"total":"525","16to19":"0","20to24":"22","25to34":"131","35to44":"129","45to54":"101","55to64":"102","65+":"39","medianAge":"102"}},"title":"Personal financial advisors","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"525","women":"32.0","white":"87.0","black":"4.8","asian":"6.6","hispanicOrLatino":"8.3"}},"wageData":{"2017":{"workers":"398","median":"1,425","maleWorkers":"267","maleMedian":"1,662","femaleWorkers":"131","femaleMedian":"979"}}},"Insurance underwriters":{"ageData":{"2017":{"total":"104","16to19":"0","20to24":"4","25to34":"28","35to44":"27","45to54":"27","55to64":"16","65+":"2","medianAge":"16"}},"title":"Insurance underwriters","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"104","women":"63.8","white":"85.5","black":"8.8","asian":"5.4","hispanicOrLatino":"8.1"}},"wageData":{"2017":{"workers":"92","median":"1,153","maleWorkers":"35","maleMedian":"-","femaleWorkers":"57","femaleMedian":"1,115"}}},"Financial examiners":{"ageData":{"2017":{"total":"15","16to19":"0","20to24":"0","25to34":"6","35to44":"2","45to54":"3","55to64":"3","65+":"0","medianAge":"3"}},"title":"Financial examiners","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"15","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"15","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Credit counselors and loan officers":{"ageData":{"2017":{"total":"353","16to19":"3","20to24":"17","25to34":"88","35to44":"92","45to54":"84","55to64":"55","65+":"13","medianAge":"55"}},"title":"Credit counselors and loan officers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"353","women":"56.5","white":"83.8","black":"8.5","asian":"4.2","hispanicOrLatino":"14.2"}},"wageData":{"2017":{"workers":"320","median":"1,070","maleWorkers":"127","maleMedian":"1,332","femaleWorkers":"193","femaleMedian":"958"}}},"Tax examiners and collectors, and revenue agents":{"ageData":{"2017":{"total":"65","16to19":"0","20to24":"3","25to34":"16","35to44":"6","45to54":"19","55to64":"15","65+":"5","medianAge":"15"}},"title":"Tax examiners and collectors, and revenue agents","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"65","women":"58.4","white":"77.2","black":"11.1","asian":"9.8","hispanicOrLatino":"14.8"}},"wageData":{"2017":{"workers":"62","median":"1,078","maleWorkers":"28","maleMedian":"-","femaleWorkers":"33","femaleMedian":"-"}}},"Tax preparers":{"ageData":{"2017":{"total":"107","16to19":"0","20to24":"4","25to34":"12","35to44":"16","45to54":"29","55to64":"25","65+":"19","medianAge":"25"}},"title":"Tax preparers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"107","women":"63.1","white":"78.3","black":"17.2","asian":"4.0","hispanicOrLatino":"14.9"}},"wageData":{"2017":{"workers":"56","median":"791","maleWorkers":"18","maleMedian":"-","femaleWorkers":"39","femaleMedian":"-"}}},"Financial specialists, all other":{"ageData":{"2017":{"total":"45","16to19":"0","20to24":"4","25to34":"11","35to44":"9","45to54":"11","55to64":"7","65+":"4","medianAge":"7"}},"title":"Financial specialists, all other","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2017":{"total":"45","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"36","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"24","femaleMedian":"-"}}},"Professional and related occupations":{"ageData":{"2017":{"total":"35,522","16to19":"331","20to24":"2,299","25to34":"9,006","35to44":"8,273","45to54":"7,503","55to64":"5,949","65+":"2,162","medianAge":"5,949"}},"title":"Professional and related occupations","depth":2,"parent":"Management, professional, and related occupations","sexRaceEthnicityData":{"2017":{"total":"35,522","women":"57.0","white":"77.9","black":"10.3","asian":"9.3","hispanicOrLatino":"9.3"}},"wageData":{"2017":{"workers":"27,794","median":"1,160","maleWorkers":"12,400","maleMedian":"1,391","femaleWorkers":"15,394","femaleMedian":"1,014"}}},"Computer and mathematical occupations":{"ageData":{"2017":{"total":"4,804","16to19":"28","20to24":"284","25to34":"1,408","35to44":"1,286","45to54":"1,020","55to64":"642","65+":"135","medianAge":"642"}},"title":"Computer and mathematical occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2017":{"total":"4,804","women":"25.5","white":"67.8","black":"8.7","asian":"20.8","hispanicOrLatino":"7.3"}},"wageData":{"2017":{"workers":"4,350","median":"1,465","maleWorkers":"3,240","maleMedian":"1,552","femaleWorkers":"1,110","femaleMedian":"1,235"}}},"Computer and information research scientists":{"ageData":{"2017":{"total":"24","16to19":"0","20to24":"1","25to34":"10","35to44":"6","45to54":"4","55to64":"3","65+":"0","medianAge":"3"}},"title":"Computer and information research scientists","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2017":{"total":"24","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"23","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Computer systems analysts":{"ageData":{"2017":{"total":"554","16to19":"0","20to24":"34","25to34":"137","35to44":"132","45to54":"136","55to64":"96","65+":"19","medianAge":"96"}},"title":"Computer systems analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2017":{"total":"554","women":"38.9","white":"70.9","black":"9.7","asian":"16.6","hispanicOrLatino":"7.2"}},"wageData":{"2017":{"workers":"522","median":"1,409","maleWorkers":"311","maleMedian":"1,495","femaleWorkers":"211","femaleMedian":"1,270"}}},"Information security analysts":{"ageData":{"2017":{"total":"105","16to19":"0","20to24":"6","25to34":"24","35to44":"32","45to54":"26","55to64":"16","65+":"3","medianAge":"16"}},"title":"Information security analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2017":{"total":"105","women":"20.2","white":"68.5","black":"15.6","asian":"12.6","hispanicOrLatino":"4.6"}},"wageData":{"2017":{"workers":"94","median":"1,725","maleWorkers":"74","maleMedian":"1,773","femaleWorkers":"20","femaleMedian":"-"}}},"Computer programmers":{"ageData":{"2017":{"total":"473","16to19":"4","20to24":"27","25to34":"125","35to44":"131","45to54":"113","55to64":"62","65+":"12","medianAge":"62"}},"title":"Computer programmers","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2017":{"total":"473","women":"21.2","white":"65.9","black":"7.1","asian":"25.4","hispanicOrLatino":"5.3"}},"wageData":{"2017":{"workers":"423","median":"1,483","maleWorkers":"333","maleMedian":"1,539","femaleWorkers":"89","femaleMedian":"1,363"}}},"Software developers, applications and systems software":{"ageData":{"2017":{"total":"1,536","16to19":"5","20to24":"80","25to34":"526","35to44":"433","45to54":"277","55to64":"175","65+":"40","medianAge":"175"}},"title":"Software developers, applications and systems software","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2017":{"total":"1,536","women":"18.7","white":"59.3","black":"5.6","asian":"32.4","hispanicOrLatino":"6.2"}},"wageData":{"2017":{"workers":"1,439","median":"1,792","maleWorkers":"1,174","maleMedian":"1,863","femaleWorkers":"265","femaleMedian":"1,543"}}},"Web developers":{"ageData":{"2017":{"total":"204","16to19":"3","20to24":"15","25to34":"65","35to44":"62","45to54":"36","55to64":"19","65+":"4","medianAge":"19"}},"title":"Web developers","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2017":{"total":"204","women":"32.3","white":"82.0","black":"4.5","asian":"9.8","hispanicOrLatino":"5.8"}},"wageData":{"2017":{"workers":"144","median":"1,235","maleWorkers":"98","maleMedian":"1,342","femaleWorkers":"46","femaleMedian":"-"}}},"Computer support specialists":{"ageData":{"2017":{"total":"532","16to19":"7","20to24":"42","25to34":"164","35to44":"123","45to54":"102","55to64":"81","65+":"13","medianAge":"81"}},"title":"Computer support specialists","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2017":{"total":"532","women":"27.1","white":"70.7","black":"14.6","asian":"11.3","hispanicOrLatino":"10.3"}},"wageData":{"2017":{"workers":"443","median":"1,068","maleWorkers":"319","maleMedian":"1,134","femaleWorkers":"124","femaleMedian":"919"}}},"Database administrators":{"ageData":{"2017":{"total":"96","16to19":"0","20to24":"5","25to34":"31","35to44":"17","45to54":"26","55to64":"16","65+":"2","medianAge":"16"}},"title":"Database administrators","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2017":{"total":"96","women":"40.6","white":"70.6","black":"10.1","asian":"18.1","hispanicOrLatino":"6.2"}},"wageData":{"2017":{"workers":"93","median":"1,381","maleWorkers":"56","maleMedian":"1,745","femaleWorkers":"37","femaleMedian":"-"}}},"Network and computer systems administrators":{"ageData":{"2017":{"total":"210","16to19":"4","20to24":"11","25to34":"40","35to44":"62","45to54":"55","55to64":"29","65+":"9","medianAge":"29"}},"title":"Network and computer systems administrators","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2017":{"total":"210","women":"23.5","white":"79.5","black":"6.3","asian":"11.8","hispanicOrLatino":"10.9"}},"wageData":{"2017":{"workers":"193","median":"1,395","maleWorkers":"155","maleMedian":"1,396","femaleWorkers":"38","femaleMedian":"-"}}},"Computer network architects":{"ageData":{"2017":{"total":"106","16to19":"0","20to24":"4","25to34":"23","35to44":"37","45to54":"28","55to64":"10","65+":"4","medianAge":"10"}},"title":"Computer network architects","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2017":{"total":"106","women":"4.2","white":"73.1","black":"10.6","asian":"15.2","hispanicOrLatino":"3.1"}},"wageData":{"2017":{"workers":"100","median":"1,636","maleWorkers":"97","maleMedian":"1,659","femaleWorkers":"3","femaleMedian":"-"}}},"Computer occupations, all other":{"ageData":{"2017":{"total":"693","16to19":"5","20to24":"45","25to34":"189","35to44":"184","45to54":"159","55to64":"90","65+":"20","medianAge":"90"}},"title":"Computer occupations, all other","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2017":{"total":"693","women":"22.6","white":"73.5","black":"11.4","asian":"11.9","hispanicOrLatino":"9.7"}},"wageData":{"2017":{"workers":"627","median":"1,194","maleWorkers":"484","maleMedian":"1,250","femaleWorkers":"142","femaleMedian":"1,059"}}},"Actuaries":{"ageData":{"2017":{"total":"29","16to19":"0","20to24":"2","25to34":"14","35to44":"4","45to54":"7","55to64":"1","65+":"1","medianAge":"1"}},"title":"Actuaries","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2017":{"total":"29","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"23","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Mathematicians":{"ageData":{"2017":{"total":"3","16to19":"0","20to24":"1","25to34":"1","35to44":"2","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Mathematicians","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2017":{"total":"3","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Operations research analysts":{"ageData":{"2017":{"total":"147","16to19":"0","20to24":"3","25to34":"27","35to44":"37","45to54":"42","55to64":"32","65+":"7","medianAge":"32"}},"title":"Operations research analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2017":{"total":"147","women":"51.5","white":"70.9","black":"12.4","asian":"15.3","hispanicOrLatino":"7.3"}},"wageData":{"2017":{"workers":"146","median":"1,396","maleWorkers":"71","maleMedian":"1,570","femaleWorkers":"74","femaleMedian":"1,205"}}},"Statisticians":{"ageData":{"2017":{"total":"87","16to19":"0","20to24":"9","25to34":"33","35to44":"24","45to54":"8","55to64":"11","65+":"2","medianAge":"11"}},"title":"Statisticians","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2017":{"total":"87","women":"48.8","white":"63.1","black":"9.0","asian":"22.4","hispanicOrLatino":"6.4"}},"wageData":{"2017":{"workers":"77","median":"1,433","maleWorkers":"36","maleMedian":"-","femaleWorkers":"41","femaleMedian":"-"}}},"Miscellaneous mathematical science occupations":{"ageData":{"2017":{"total":"3","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Miscellaneous mathematical science occupations","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2017":{"total":"3","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Architecture and engineering occupations":{"ageData":{"2017":{"total":"3,224","16to19":"7","20to24":"221","25to34":"814","35to44":"723","45to54":"690","55to64":"609","65+":"160","medianAge":"609"}},"title":"Architecture and engineering occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2017":{"total":"3,224","women":"16.2","white":"79.3","black":"5.6","asian":"12.7","hispanicOrLatino":"8.7"}},"wageData":{"2017":{"workers":"2,936","median":"1,478","maleWorkers":"2,494","maleMedian":"1,518","femaleWorkers":"442","femaleMedian":"1,307"}}},"Architects, except naval":{"ageData":{"2017":{"total":"253","16to19":"0","20to24":"5","25to34":"66","35to44":"55","45to54":"52","55to64":"53","65+":"21","medianAge":"53"}},"title":"Architects, except naval","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2017":{"total":"253","women":"28.6","white":"82.5","black":"2.1","asian":"14.0","hispanicOrLatino":"7.7"}},"wageData":{"2017":{"workers":"196","median":"1,453","maleWorkers":"150","maleMedian":"1,650","femaleWorkers":"46","femaleMedian":"-"}}},"Surveyors, cartographers, and photogrammetrists":{"ageData":{"2017":{"total":"43","16to19":"0","20to24":"2","25to34":"7","35to44":"17","45to54":"9","55to64":"7","65+":"2","medianAge":"7"}},"title":"Surveyors, cartographers, and photogrammetrists","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2017":{"total":"43","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"30","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Aerospace engineers":{"ageData":{"2017":{"total":"148","16to19":"1","20to24":"7","25to34":"34","35to44":"28","45to54":"33","55to64":"40","65+":"7","medianAge":"40"}},"title":"Aerospace engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2017":{"total":"148","women":"8.9","white":"79.1","black":"8.1","asian":"11.4","hispanicOrLatino":"5.5"}},"wageData":{"2017":{"workers":"137","median":"1,892","maleWorkers":"128","maleMedian":"1,891","femaleWorkers":"9","femaleMedian":"-"}}},"Agricultural engineers":{"ageData":{"2017":{"total":"2","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Agricultural engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2017":{"total":"2","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Biomedical engineers":{"ageData":{"2017":{"total":"17","16to19":"0","20to24":"0","25to34":"2","35to44":"8","45to54":"3","55to64":"2","65+":"1","medianAge":"2"}},"title":"Biomedical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2017":{"total":"17","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"16","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Chemical engineers":{"ageData":{"2017":{"total":"77","16to19":"0","20to24":"6","25to34":"20","35to44":"10","45to54":"20","55to64":"17","65+":"4","medianAge":"17"}},"title":"Chemical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2017":{"total":"77","women":"16.9","white":"91.0","black":"1.7","asian":"7.0","hispanicOrLatino":"4.1"}},"wageData":{"2017":{"workers":"78","median":"1,626","maleWorkers":"66","maleMedian":"1,631","femaleWorkers":"12","femaleMedian":"-"}}},"Civil engineers":{"ageData":{"2017":{"total":"461","16to19":"0","20to24":"37","25to34":"118","35to44":"111","45to54":"89","55to64":"82","65+":"24","medianAge":"82"}},"title":"Civil engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2017":{"total":"461","women":"14.4","white":"82.5","black":"6.4","asian":"7.1","hispanicOrLatino":"10.7"}},"wageData":{"2017":{"workers":"393","median":"1,494","maleWorkers":"332","maleMedian":"1,524","femaleWorkers":"61","femaleMedian":"1,343"}}},"Computer hardware engineers":{"ageData":{"2017":{"total":"80","16to19":"0","20to24":"6","25to34":"18","35to44":"26","45to54":"20","55to64":"8","65+":"2","medianAge":"8"}},"title":"Computer hardware engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2017":{"total":"80","women":"17.2","white":"55.4","black":"5.8","asian":"38.3","hispanicOrLatino":"7.8"}},"wageData":{"2017":{"workers":"73","median":"1,771","maleWorkers":"60","maleMedian":"1,793","femaleWorkers":"13","femaleMedian":"-"}}},"Electrical and electronics engineers":{"ageData":{"2017":{"total":"284","16to19":"1","20to24":"14","25to34":"63","35to44":"67","45to54":"73","55to64":"58","65+":"9","medianAge":"58"}},"title":"Electrical and electronics engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2017":{"total":"284","women":"12.3","white":"74.6","black":"3.5","asian":"19.5","hispanicOrLatino":"9.0"}},"wageData":{"2017":{"workers":"276","median":"1,803","maleWorkers":"245","maleMedian":"1,772","femaleWorkers":"30","femaleMedian":"-"}}},"Environmental engineers":{"ageData":{"2017":{"total":"38","16to19":"0","20to24":"2","25to34":"7","35to44":"6","45to54":"10","55to64":"10","65+":"3","medianAge":"10"}},"title":"Environmental engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2017":{"total":"38","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"32","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Industrial engineers, including health and safety":{"ageData":{"2017":{"total":"221","16to19":"0","20to24":"16","25to34":"65","35to44":"44","45to54":"47","55to64":"43","65+":"6","medianAge":"43"}},"title":"Industrial engineers, including health and safety","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2017":{"total":"221","women":"22.6","white":"80.8","black":"5.3","asian":"11.6","hispanicOrLatino":"6.2"}},"wageData":{"2017":{"workers":"213","median":"1,496","maleWorkers":"168","maleMedian":"1,520","femaleWorkers":"46","femaleMedian":"-"}}},"Marine engineers and naval architects":{"ageData":{"2017":{"total":"12","16to19":"0","20to24":"0","25to34":"5","35to44":"2","45to54":"1","55to64":"3","65+":"2","medianAge":"3"}},"title":"Marine engineers and naval architects","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2017":{"total":"12","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Materials engineers":{"ageData":{"2017":{"total":"32","16to19":"0","20to24":"1","25to34":"4","35to44":"7","45to54":"10","55to64":"8","65+":"1","medianAge":"8"}},"title":"Materials engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2017":{"total":"32","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"32","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Mechanical engineers":{"ageData":{"2017":{"total":"344","16to19":"1","20to24":"36","25to34":"92","35to44":"83","45to54":"70","55to64":"49","65+":"14","medianAge":"49"}},"title":"Mechanical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2017":{"total":"344","women":"9.2","white":"84.2","black":"3.6","asian":"11.1","hispanicOrLatino":"6.0"}},"wageData":{"2017":{"workers":"337","median":"1,534","maleWorkers":"311","maleMedian":"1,533","femaleWorkers":"26","femaleMedian":"-"}}},"Mining and geological engineers, including mining safety engineers":{"ageData":{"2017":{"total":"11","16to19":"0","20to24":"0","25to34":"3","35to44":"2","45to54":"1","55to64":"3","65+":"1","medianAge":"3"}},"title":"Mining and geological engineers, including mining safety engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2017":{"total":"11","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"12","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Nuclear engineers":{"ageData":{"2017":{"total":"8","16to19":"0","20to24":"0","25to34":"2","35to44":"4","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Nuclear engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2017":{"total":"8","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Petroleum engineers":{"ageData":{"2017":{"total":"24","16to19":"0","20to24":"2","25to34":"8","35to44":"6","45to54":"4","55to64":"4","65+":"1","medianAge":"4"}},"title":"Petroleum engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2017":{"total":"24","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"23","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Engineers, all other":{"ageData":{"2017":{"total":"582","16to19":"1","20to24":"30","25to34":"164","35to44":"124","45to54":"127","55to64":"110","65+":"28","medianAge":"110"}},"title":"Engineers, all other","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2017":{"total":"582","women":"14.1","white":"73.1","black":"6.9","asian":"17.8","hispanicOrLatino":"9.4"}},"wageData":{"2017":{"workers":"546","median":"1,561","maleWorkers":"473","maleMedian":"1,571","femaleWorkers":"73","femaleMedian":"1,436"}}},"Drafters":{"ageData":{"2017":{"total":"137","16to19":"1","20to24":"16","25to34":"35","35to44":"25","45to54":"31","55to64":"23","65+":"6","medianAge":"23"}},"title":"Drafters","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2017":{"total":"137","women":"20.8","white":"89.9","black":"6.2","asian":"2.4","hispanicOrLatino":"16.5"}},"wageData":{"2017":{"workers":"122","median":"1,126","maleWorkers":"100","maleMedian":"1,149","femaleWorkers":"21","femaleMedian":"-"}}},"Engineering technicians, except drafters":{"ageData":{"2017":{"total":"375","16to19":"2","20to24":"34","25to34":"82","35to44":"81","45to54":"76","55to64":"76","65+":"24","medianAge":"76"}},"title":"Engineering technicians, except drafters","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2017":{"total":"375","women":"20.0","white":"76.9","black":"8.9","asian":"10.7","hispanicOrLatino":"10.3"}},"wageData":{"2017":{"workers":"339","median":"1,053","maleWorkers":"269","maleMedian":"1,102","femaleWorkers":"70","femaleMedian":"884"}}},"Surveying and mapping technicians":{"ageData":{"2017":{"total":"73","16to19":"0","20to24":"7","25to34":"19","35to44":"15","45to54":"16","55to64":"13","65+":"3","medianAge":"13"}},"title":"Surveying and mapping technicians","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2017":{"total":"73","women":"4.6","white":"90.3","black":"2.1","asian":"1.7","hispanicOrLatino":"10.1"}},"wageData":{"2017":{"workers":"63","median":"1,109","maleWorkers":"61","maleMedian":"1,114","femaleWorkers":"2","femaleMedian":"-"}}},"Life, physical, and social science occupations":{"ageData":{"2017":{"total":"1,431","16to19":"5","20to24":"103","25to34":"399","35to44":"335","45to54":"262","55to64":"241","65+":"86","medianAge":"241"}},"title":"Life, physical, and social science occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2017":{"total":"1,431","women":"47.4","white":"76.4","black":"5.7","asian":"15.8","hispanicOrLatino":"9.0"}},"wageData":{"2017":{"workers":"1,238","median":"1,286","maleWorkers":"674","maleMedian":"1,361","femaleWorkers":"564","femaleMedian":"1,183"}}},"Agricultural and food scientists":{"ageData":{"2017":{"total":"32","16to19":"1","20to24":"4","25to34":"10","35to44":"4","45to54":"5","55to64":"5","65+":"3","medianAge":"5"}},"title":"Agricultural and food scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2017":{"total":"32","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"25","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Biological scientists":{"ageData":{"2017":{"total":"98","16to19":"0","20to24":"6","25to34":"23","35to44":"38","45to54":"17","55to64":"11","65+":"4","medianAge":"11"}},"title":"Biological scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2017":{"total":"98","women":"54.4","white":"81.2","black":"3.1","asian":"13.1","hispanicOrLatino":"7.9"}},"wageData":{"2017":{"workers":"82","median":"1,140","maleWorkers":"41","maleMedian":"-","femaleWorkers":"41","femaleMedian":"-"}}},"Conservation scientists and foresters":{"ageData":{"2017":{"total":"29","16to19":"0","20to24":"2","25to34":"7","35to44":"7","45to54":"7","55to64":"5","65+":"1","medianAge":"5"}},"title":"Conservation scientists and foresters","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2017":{"total":"29","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"26","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Medical scientists":{"ageData":{"2017":{"total":"161","16to19":"1","20to24":"12","25to34":"53","35to44":"35","45to54":"33","55to64":"21","65+":"8","medianAge":"21"}},"title":"Medical scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2017":{"total":"161","women":"52.1","white":"66.4","black":"6.6","asian":"26.2","hispanicOrLatino":"6.7"}},"wageData":{"2017":{"workers":"162","median":"1,378","maleWorkers":"82","maleMedian":"1,383","femaleWorkers":"80","femaleMedian":"1,270"}}},"Life scientists, all other":{"ageData":{"2017":{"total":"3","16to19":"0","20to24":"0","25to34":"2","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Life scientists, all other","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2017":{"total":"3","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"4","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Astronomers and physicists":{"ageData":{"2017":{"total":"18","16to19":"0","20to24":"0","25to34":"4","35to44":"4","45to54":"4","55to64":"4","65+":"1","medianAge":"4"}},"title":"Astronomers and physicists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2017":{"total":"18","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"16","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Atmospheric and space scientists":{"ageData":{"2017":{"total":"7","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"2","55to64":"1","65+":"1","medianAge":"1"}},"title":"Atmospheric and space scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2017":{"total":"7","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"6","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Chemists and materials scientists":{"ageData":{"2017":{"total":"105","16to19":"0","20to24":"3","25to34":"34","35to44":"25","45to54":"21","55to64":"19","65+":"4","medianAge":"19"}},"title":"Chemists and materials scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2017":{"total":"105","women":"38.3","white":"66.7","black":"11.3","asian":"20.8","hispanicOrLatino":"5.9"}},"wageData":{"2017":{"workers":"98","median":"1,425","maleWorkers":"56","maleMedian":"1,451","femaleWorkers":"41","femaleMedian":"-"}}},"Environmental scientists and geoscientists":{"ageData":{"2017":{"total":"84","16to19":"0","20to24":"5","25to34":"19","35to44":"23","45to54":"16","55to64":"19","65+":"3","medianAge":"19"}},"title":"Environmental scientists and geoscientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2017":{"total":"84","women":"35.8","white":"90.8","black":"5.0","asian":"0.7","hispanicOrLatino":"4.8"}},"wageData":{"2017":{"workers":"80","median":"1,639","maleWorkers":"51","maleMedian":"1,746","femaleWorkers":"30","femaleMedian":"-"}}},"Physical scientists, all other":{"ageData":{"2017":{"total":"301","16to19":"0","20to24":"18","25to34":"105","35to44":"81","45to54":"44","55to64":"44","65+":"9","medianAge":"44"}},"title":"Physical scientists, all other","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2017":{"total":"301","women":"47.3","white":"61.2","black":"4.0","asian":"32.1","hispanicOrLatino":"7.9"}},"wageData":{"2017":{"workers":"270","median":"1,529","maleWorkers":"147","maleMedian":"1,565","femaleWorkers":"122","femaleMedian":"1,409"}}},"Economists":{"ageData":{"2017":{"total":"28","16to19":"0","20to24":"1","25to34":"8","35to44":"5","45to54":"8","55to64":"6","65+":"1","medianAge":"6"}},"title":"Economists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2017":{"total":"28","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"29","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Survey researchers":{"ageData":{"2017":{"total":"3","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"0","55to64":"0","65+":"1","medianAge":"0"}},"title":"Survey researchers","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2017":{"total":"3","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Psychologists":{"ageData":{"2017":{"total":"187","16to19":"0","20to24":"1","25to34":"26","35to44":"41","45to54":"43","55to64":"40","65+":"35","medianAge":"40"}},"title":"Psychologists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2017":{"total":"187","women":"68.9","white":"89.5","black":"6.5","asian":"3.6","hispanicOrLatino":"8.5"}},"wageData":{"2017":{"workers":"106","median":"1,454","maleWorkers":"35","maleMedian":"-","femaleWorkers":"71","femaleMedian":"1,437"}}},"Sociologists":{"ageData":{"2017":{"total":"2","16to19":"0","20to24":"0","25to34":"1","35to44":"2","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Sociologists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2017":{"total":"2","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Urban and regional planners":{"ageData":{"2017":{"total":"32","16to19":"0","20to24":"3","25to34":"3","35to44":"13","45to54":"9","55to64":"4","65+":"0","medianAge":"4"}},"title":"Urban and regional planners","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2017":{"total":"32","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"34","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Miscellaneous social scientists and related workers":{"ageData":{"2017":{"total":"41","16to19":"0","20to24":"4","25to34":"10","35to44":"5","45to54":"10","55to64":"8","65+":"5","medianAge":"8"}},"title":"Miscellaneous social scientists and related workers","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2017":{"total":"41","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"27","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Agricultural and food science technicians":{"ageData":{"2017":{"total":"32","16to19":"0","20to24":"2","25to34":"8","35to44":"6","45to54":"7","55to64":"9","65+":"0","medianAge":"9"}},"title":"Agricultural and food science technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2017":{"total":"32","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"30","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Biological technicians":{"ageData":{"2017":{"total":"23","16to19":"0","20to24":"1","25to34":"9","35to44":"6","45to54":"4","55to64":"2","65+":"0","medianAge":"2"}},"title":"Biological technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2017":{"total":"23","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"23","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"15","femaleMedian":"-"}}},"Chemical technicians":{"ageData":{"2017":{"total":"57","16to19":"0","20to24":"10","25to34":"15","35to44":"4","45to54":"10","55to64":"18","65+":"0","medianAge":"18"}},"title":"Chemical technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2017":{"total":"57","women":"27.4","white":"79.8","black":"7.3","asian":"7.8","hispanicOrLatino":"14.3"}},"wageData":{"2017":{"workers":"62","median":"1,013","maleWorkers":"45","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Geological and petroleum technicians":{"ageData":{"2017":{"total":"13","16to19":"0","20to24":"1","25to34":"6","35to44":"1","45to54":"4","55to64":"1","65+":"0","medianAge":"1"}},"title":"Geological and petroleum technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2017":{"total":"13","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"13","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Nuclear technicians":{"ageData":{"2017":{"total":"7","16to19":"0","20to24":"0","25to34":"0","35to44":"4","45to54":"1","55to64":"1","65+":"1","medianAge":"1"}},"title":"Nuclear technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2017":{"total":"7","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"6","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Social science research assistants":{"ageData":{"2017":{"total":"4","16to19":"0","20to24":"0","25to34":"1","35to44":"2","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Social science research assistants","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2017":{"total":"4","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"4","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Miscellaneous life, physical, and social science technicians":{"ageData":{"2017":{"total":"164","16to19":"4","20to24":"32","25to34":"51","35to44":"28","45to54":"20","55to64":"22","65+":"7","medianAge":"22"}},"title":"Miscellaneous life, physical, and social science technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2017":{"total":"164","women":"47.7","white":"80.2","black":"5.7","asian":"11.8","hispanicOrLatino":"13.4"}},"wageData":{"2017":{"workers":"132","median":"826","maleWorkers":"70","maleMedian":"970","femaleWorkers":"63","femaleMedian":"766"}}},"Community and social service occupations":{"ageData":{"2017":{"total":"2,635","16to19":"31","20to24":"161","25to34":"627","35to44":"565","45to54":"553","55to64":"496","65+":"203","medianAge":"496"}},"title":"Community and social service occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2017":{"total":"2,635","women":"66.1","white":"73.1","black":"19.9","asian":"3.8","hispanicOrLatino":"12.4"}},"wageData":{"2017":{"workers":"2,165","median":"900","maleWorkers":"747","maleMedian":"976","femaleWorkers":"1,418","femaleMedian":"857"}}},"Counselors":{"ageData":{"2017":{"total":"853","16to19":"17","20to24":"72","25to34":"232","35to44":"183","45to54":"178","55to64":"119","65+":"52","medianAge":"119"}},"title":"Counselors","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2017":{"total":"853","women":"72.3","white":"72.3","black":"21.4","asian":"2.9","hispanicOrLatino":"13.0"}},"wageData":{"2017":{"workers":"650","median":"897","maleWorkers":"178","maleMedian":"901","femaleWorkers":"472","femaleMedian":"894"}}},"Social workers":{"ageData":{"2017":{"total":"802","16to19":"4","20to24":"40","25to34":"205","35to44":"189","45to54":"188","55to64":"136","65+":"40","medianAge":"136"}},"title":"Social workers","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2017":{"total":"802","women":"82.5","white":"69.5","black":"23.5","asian":"4.0","hispanicOrLatino":"14.0"}},"wageData":{"2017":{"workers":"714","median":"906","maleWorkers":"122","maleMedian":"935","femaleWorkers":"591","femaleMedian":"900"}}},"Probation officers and correctional treatment specialists":{"ageData":{"2017":{"total":"99","16to19":"0","20to24":"2","25to34":"32","35to44":"32","45to54":"19","55to64":"11","65+":"3","medianAge":"11"}},"title":"Probation officers and correctional treatment specialists","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2017":{"total":"99","women":"63.5","white":"63.8","black":"26.7","asian":"5.3","hispanicOrLatino":"11.1"}},"wageData":{"2017":{"workers":"90","median":"881","maleWorkers":"36","maleMedian":"-","femaleWorkers":"55","femaleMedian":"858"}}},"Social and human service assistants":{"ageData":{"2017":{"total":"232","16to19":"5","20to24":"23","25to34":"51","35to44":"52","45to54":"47","55to64":"40","65+":"13","medianAge":"40"}},"title":"Social and human service assistants","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2017":{"total":"232","women":"75.3","white":"68.4","black":"22.8","asian":"3.1","hispanicOrLatino":"19.0"}},"wageData":{"2017":{"workers":"189","median":"739","maleWorkers":"48","maleMedian":"-","femaleWorkers":"141","femaleMedian":"701"}}},"Miscellaneous community and social service specialists, including health educators and community health workers":{"ageData":{"2017":{"total":"76","16to19":"1","20to24":"6","25to34":"25","35to44":"14","45to54":"13","55to64":"14","65+":"3","medianAge":"14"}},"title":"Miscellaneous community and social service specialists, including health educators and community health workers","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2017":{"total":"76","women":"74.8","white":"68.9","black":"19.6","asian":"7.0","hispanicOrLatino":"17.3"}},"wageData":{"2017":{"workers":"68","median":"829","maleWorkers":"17","maleMedian":"-","femaleWorkers":"51","femaleMedian":"791"}}},"Clergy":{"ageData":{"2017":{"total":"406","16to19":"1","20to24":"10","25to34":"53","35to44":"69","45to54":"78","55to64":"126","65+":"69","medianAge":"126"}},"title":"Clergy","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2017":{"total":"406","women":"17.0","white":"81.3","black":"12.1","asian":"4.6","hispanicOrLatino":"6.1"}},"wageData":{"2017":{"workers":"342","median":"1,058","maleWorkers":"297","maleMedian":"1,073","femaleWorkers":"46","femaleMedian":"-"}}},"Directors, religious activities and education":{"ageData":{"2017":{"total":"81","16to19":"2","20to24":"4","25to34":"14","35to44":"12","45to54":"15","55to64":"26","65+":"9","medianAge":"26"}},"title":"Directors, religious activities and education","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2017":{"total":"81","women":"54.1","white":"88.9","black":"7.1","asian":"3.6","hispanicOrLatino":"6.0"}},"wageData":{"2017":{"workers":"61","median":"844","maleWorkers":"36","maleMedian":"-","femaleWorkers":"25","femaleMedian":"-"}}},"Religious workers, all other":{"ageData":{"2017":{"total":"85","16to19":"2","20to24":"4","25to34":"15","35to44":"14","45to54":"14","55to64":"24","65+":"13","medianAge":"24"}},"title":"Religious workers, all other","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2017":{"total":"85","women":"65.3","white":"86.7","black":"5.0","asian":"5.2","hispanicOrLatino":"5.0"}},"wageData":{"2017":{"workers":"50","median":"831","maleWorkers":"13","maleMedian":"-","femaleWorkers":"37","femaleMedian":"-"}}},"Legal occupations":{"ageData":{"2017":{"total":"1,827","16to19":"2","20to24":"43","25to34":"387","35to44":"441","45to54":"395","55to64":"351","65+":"208","medianAge":"351"}},"title":"Legal occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2017":{"total":"1,827","women":"52.8","white":"86.6","black":"6.9","asian":"4.3","hispanicOrLatino":"8.6"}},"wageData":{"2017":{"workers":"1,379","median":"1,443","maleWorkers":"568","maleMedian":"1,896","femaleWorkers":"811","femaleMedian":"1,192"}}},"Lawyers":{"ageData":{"2017":{"total":"1,137","16to19":"0","20to24":"4","25to34":"225","35to44":"304","45to54":"247","55to64":"208","65+":"150","medianAge":"208"}},"title":"Lawyers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2017":{"total":"1,137","women":"37.4","white":"88.6","black":"5.6","asian":"4.4","hispanicOrLatino":"4.8"}},"wageData":{"2017":{"workers":"781","median":"1,901","maleWorkers":"444","maleMedian":"2,105","femaleWorkers":"337","femaleMedian":"1,753"}}},"Judicial law clerks":{"ageData":{"2017":{"total":"14","16to19":"0","20to24":"0","25to34":"10","35to44":"1","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Judicial law clerks","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2017":{"total":"14","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"13","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Judges, magistrates, and other judicial workers":{"ageData":{"2017":{"total":"66","16to19":"0","20to24":"0","25to34":"4","35to44":"8","45to54":"17","55to64":"22","65+":"14","medianAge":"22"}},"title":"Judges, magistrates, and other judicial workers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2017":{"total":"66","women":"28.1","white":"87.3","black":"12.7","asian":"0.0","hispanicOrLatino":"7.0"}},"wageData":{"2017":{"workers":"59","median":"1,742","maleWorkers":"42","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Paralegals and legal assistants":{"ageData":{"2017":{"total":"424","16to19":"1","20to24":"32","25to34":"106","35to44":"90","45to54":"88","55to64":"75","65+":"32","medianAge":"75"}},"title":"Paralegals and legal assistants","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2017":{"total":"424","women":"86.3","white":"82.9","black":"7.7","asian":"4.8","hispanicOrLatino":"17.5"}},"wageData":{"2017":{"workers":"370","median":"945","maleWorkers":"49","maleMedian":"-","femaleWorkers":"321","femaleMedian":"934"}}},"Miscellaneous legal support workers":{"ageData":{"2017":{"total":"186","16to19":"0","20to24":"6","25to34":"42","35to44":"38","45to54":"42","55to64":"45","65+":"13","medianAge":"45"}},"title":"Miscellaneous legal support workers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2017":{"total":"186","women":"80.2","white":"83.7","black":"10.8","asian":"3.0","hispanicOrLatino":"12.9"}},"wageData":{"2017":{"workers":"156","median":"957","maleWorkers":"26","maleMedian":"-","femaleWorkers":"130","femaleMedian":"904"}}},"Education, training, and library occupations":{"ageData":{"2017":{"total":"9,215","16to19":"122","20to24":"664","25to34":"2,114","35to44":"2,159","45to54":"2,024","55to64":"1,530","65+":"601","medianAge":"1,530"}},"title":"Education, training, and library occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2017":{"total":"9,215","women":"73.0","white":"82.0","black":"10.7","asian":"4.9","hispanicOrLatino":"10.5"}},"wageData":{"2017":{"workers":"6,978","median":"1,002","maleWorkers":"1,939","maleMedian":"1,202","femaleWorkers":"5,039","femaleMedian":"935"}}},"Postsecondary teachers":{"ageData":{"2017":{"total":"1,423","16to19":"8","20to24":"117","25to34":"322","35to44":"281","45to54":"274","55to64":"268","65+":"154","medianAge":"268"}},"title":"Postsecondary teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2017":{"total":"1,423","women":"47.0","white":"77.7","black":"8.4","asian":"11.7","hispanicOrLatino":"6.4"}},"wageData":{"2017":{"workers":"985","median":"1,312","maleWorkers":"551","maleMedian":"1,414","femaleWorkers":"434","femaleMedian":"1,208"}}},"Preschool and kindergarten teachers":{"ageData":{"2017":{"total":"712","16to19":"14","20to24":"87","25to34":"198","35to44":"160","45to54":"144","55to64":"88","65+":"23","medianAge":"88"}},"title":"Preschool and kindergarten teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2017":{"total":"712","women":"97.7","white":"77.1","black":"16.2","asian":"3.4","hispanicOrLatino":"14.1"}},"wageData":{"2017":{"workers":"530","median":"657","maleWorkers":"12","maleMedian":"-","femaleWorkers":"518","femaleMedian":"654"}}},"Elementary and middle school teachers":{"ageData":{"2017":{"total":"3,268","16to19":"7","20to24":"151","25to34":"768","35to44":"887","45to54":"787","55to64":"514","65+":"155","medianAge":"514"}},"title":"Elementary and middle school teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2017":{"total":"3,268","women":"79.3","white":"85.2","black":"10.1","asian":"2.9","hispanicOrLatino":"10.1"}},"wageData":{"2017":{"workers":"2,838","median":"1,023","maleWorkers":"614","maleMedian":"1,139","femaleWorkers":"2,224","femaleMedian":"987"}}},"Secondary school teachers":{"ageData":{"2017":{"total":"1,039","16to19":"3","20to24":"32","25to34":"265","35to44":"274","45to54":"245","55to64":"165","65+":"56","medianAge":"165"}},"title":"Secondary school teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2017":{"total":"1,039","women":"58.5","white":"86.2","black":"8.6","asian":"2.8","hispanicOrLatino":"9.4"}},"wageData":{"2017":{"workers":"917","median":"1,139","maleWorkers":"392","maleMedian":"1,226","femaleWorkers":"524","femaleMedian":"1,091"}}},"Special education teachers":{"ageData":{"2017":{"total":"422","16to19":"1","20to24":"19","25to34":"92","35to44":"114","45to54":"99","55to64":"78","65+":"18","medianAge":"78"}},"title":"Special education teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2017":{"total":"422","women":"85.6","white":"86.2","black":"10.0","asian":"2.4","hispanicOrLatino":"7.9"}},"wageData":{"2017":{"workers":"386","median":"1,024","maleWorkers":"54","maleMedian":"1,051","femaleWorkers":"332","femaleMedian":"1,017"}}},"Other teachers and instructors":{"ageData":{"2017":{"total":"907","16to19":"48","20to24":"112","25to34":"204","35to44":"165","45to54":"160","55to64":"133","65+":"84","medianAge":"133"}},"title":"Other teachers and instructors","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2017":{"total":"907","women":"65.4","white":"78.8","black":"11.1","asian":"6.3","hispanicOrLatino":"11.9"}},"wageData":{"2017":{"workers":"419","median":"897","maleWorkers":"155","maleMedian":"1,128","femaleWorkers":"265","femaleMedian":"820"}}},"Archivists, curators, and museum technicians":{"ageData":{"2017":{"total":"59","16to19":"0","20to24":"3","25to34":"17","35to44":"9","45to54":"12","55to64":"9","65+":"8","medianAge":"9"}},"title":"Archivists, curators, and museum technicians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2017":{"total":"59","women":"61.4","white":"80.2","black":"6.4","asian":"7.8","hispanicOrLatino":"1.7"}},"wageData":{"2017":{"workers":"42","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"24","femaleMedian":"-"}}},"Librarians":{"ageData":{"2017":{"total":"194","16to19":"2","20to24":"8","25to34":"33","35to44":"48","45to54":"34","55to64":"42","65+":"28","medianAge":"42"}},"title":"Librarians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2017":{"total":"194","women":"79.5","white":"86.3","black":"6.4","asian":"5.2","hispanicOrLatino":"10.4"}},"wageData":{"2017":{"workers":"135","median":"1,009","maleWorkers":"31","maleMedian":"-","femaleWorkers":"104","femaleMedian":"972"}}},"Library technicians":{"ageData":{"2017":{"total":"40","16to19":"5","20to24":"11","25to34":"1","35to44":"5","45to54":"5","55to64":"9","65+":"4","medianAge":"9"}},"title":"Library technicians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2017":{"total":"40","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"16","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"14","femaleMedian":"-"}}},"Teacher assistants":{"ageData":{"2017":{"total":"989","16to19":"32","20to24":"105","25to34":"187","35to44":"183","45to54":"232","55to64":"190","65+":"59","medianAge":"190"}},"title":"Teacher assistants","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2017":{"total":"989","women":"88.5","white":"78.0","black":"14.6","asian":"4.2","hispanicOrLatino":"17.3"}},"wageData":{"2017":{"workers":"590","median":"550","maleWorkers":"67","maleMedian":"642","femaleWorkers":"523","femaleMedian":"537"}}},"Other education, training, and library workers":{"ageData":{"2017":{"total":"161","16to19":"2","20to24":"20","25to34":"27","35to44":"33","45to54":"33","55to64":"34","65+":"11","medianAge":"34"}},"title":"Other education, training, and library workers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2017":{"total":"161","women":"67.7","white":"78.5","black":"12.6","asian":"5.3","hispanicOrLatino":"6.0"}},"wageData":{"2017":{"workers":"120","median":"1,049","maleWorkers":"44","maleMedian":"-","femaleWorkers":"77","femaleMedian":"956"}}},"Arts, design, entertainment, sports, and media occupations":{"ageData":{"2017":{"total":"3,246","16to19":"98","20to24":"297","25to34":"863","35to44":"680","45to54":"572","55to64":"489","65+":"247","medianAge":"489"}},"title":"Arts, design, entertainment, sports, and media occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2017":{"total":"3,246","women":"46.9","white":"83.9","black":"7.3","asian":"5.3","hispanicOrLatino":"10.2"}},"wageData":{"2017":{"workers":"1,778","median":"1,066","maleWorkers":"1,013","maleMedian":"1,161","femaleWorkers":"765","femaleMedian":"943"}}},"Artists and related workers":{"ageData":{"2017":{"total":"236","16to19":"4","20to24":"15","25to34":"62","35to44":"39","45to54":"37","55to64":"42","65+":"38","medianAge":"42"}},"title":"Artists and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2017":{"total":"236","women":"51.9","white":"89.6","black":"3.5","asian":"4.5","hispanicOrLatino":"10.8"}},"wageData":{"2017":{"workers":"70","median":"1,209","maleWorkers":"43","maleMedian":"-","femaleWorkers":"27","femaleMedian":"-"}}},"Designers":{"ageData":{"2017":{"total":"908","16to19":"10","20to24":"73","25to34":"256","35to44":"205","45to54":"168","55to64":"146","65+":"50","medianAge":"146"}},"title":"Designers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2017":{"total":"908","women":"52.8","white":"84.2","black":"5.1","asian":"7.6","hispanicOrLatino":"12.0"}},"wageData":{"2017":{"workers":"600","median":"1,012","maleWorkers":"327","maleMedian":"1,172","femaleWorkers":"273","femaleMedian":"857"}}},"Actors":{"ageData":{"2017":{"total":"40","16to19":"1","20to24":"6","25to34":"16","35to44":"7","45to54":"4","55to64":"3","65+":"3","medianAge":"3"}},"title":"Actors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2017":{"total":"40","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"17","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Producers and directors":{"ageData":{"2017":{"total":"180","16to19":"0","20to24":"13","25to34":"47","35to44":"55","45to54":"29","55to64":"27","65+":"8","medianAge":"27"}},"title":"Producers and directors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2017":{"total":"180","women":"29.8","white":"87.8","black":"5.2","asian":"4.6","hispanicOrLatino":"8.9"}},"wageData":{"2017":{"workers":"131","median":"1,489","maleWorkers":"89","maleMedian":"1,708","femaleWorkers":"43","femaleMedian":"-"}}},"Athletes, coaches, umpires, and related workers":{"ageData":{"2017":{"total":"345","16to19":"56","20to24":"57","25to34":"90","35to44":"49","45to54":"47","55to64":"30","65+":"17","medianAge":"30"}},"title":"Athletes, coaches, umpires, and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2017":{"total":"345","women":"36.4","white":"88.2","black":"5.0","asian":"3.0","hispanicOrLatino":"8.5"}},"wageData":{"2017":{"workers":"149","median":"898","maleWorkers":"104","maleMedian":"1,031","femaleWorkers":"45","femaleMedian":"-"}}},"Dancers and choreographers":{"ageData":{"2017":{"total":"21","16to19":"1","20to24":"7","25to34":"6","35to44":"5","45to54":"0","55to64":"1","65+":"1","medianAge":"1"}},"title":"Dancers and choreographers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2017":{"total":"21","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"9","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Musicians, singers, and related workers":{"ageData":{"2017":{"total":"188","16to19":"6","20to24":"14","25to34":"48","35to44":"36","45to54":"28","55to64":"28","65+":"28","medianAge":"28"}},"title":"Musicians, singers, and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2017":{"total":"188","women":"37.7","white":"75.6","black":"17.3","asian":"4.3","hispanicOrLatino":"6.7"}},"wageData":{"2017":{"workers":"41","median":"-","maleWorkers":"29","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Entertainers and performers, sports and related workers, all other":{"ageData":{"2017":{"total":"67","16to19":"2","20to24":"8","25to34":"15","35to44":"16","45to54":"13","55to64":"7","65+":"5","medianAge":"7"}},"title":"Entertainers and performers, sports and related workers, all other","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2017":{"total":"67","women":"48.1","white":"74.1","black":"9.2","asian":"9.9","hispanicOrLatino":"7.5"}},"wageData":{"2017":{"workers":"24","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Announcers":{"ageData":{"2017":{"total":"50","16to19":"0","20to24":"5","25to34":"17","35to44":"10","45to54":"8","55to64":"5","65+":"5","medianAge":"5"}},"title":"Announcers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2017":{"total":"50","women":"23.1","white":"77.5","black":"12.0","asian":"7.1","hispanicOrLatino":"8.5"}},"wageData":{"2017":{"workers":"24","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"News analysts, reporters and correspondents":{"ageData":{"2017":{"total":"84","16to19":"1","20to24":"19","25to34":"23","35to44":"17","45to54":"10","55to64":"8","65+":"6","medianAge":"8"}},"title":"News analysts, reporters and correspondents","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2017":{"total":"84","women":"55.3","white":"73.0","black":"13.4","asian":"7.9","hispanicOrLatino":"16.4"}},"wageData":{"2017":{"workers":"72","median":"945","maleWorkers":"30","maleMedian":"-","femaleWorkers":"42","femaleMedian":"-"}}},"Public relations specialists":{"ageData":{"2017":{"total":"118","16to19":"0","20to24":"14","25to34":"32","35to44":"28","45to54":"20","55to64":"15","65+":"9","medianAge":"15"}},"title":"Public relations specialists","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2017":{"total":"118","women":"60.9","white":"87.9","black":"8.3","asian":"2.6","hispanicOrLatino":"5.7"}},"wageData":{"2017":{"workers":"92","median":"1,339","maleWorkers":"35","maleMedian":"-","femaleWorkers":"57","femaleMedian":"1,203"}}},"Editors":{"ageData":{"2017":{"total":"174","16to19":"2","20to24":"9","25to34":"51","35to44":"36","45to54":"40","55to64":"27","65+":"10","medianAge":"27"}},"title":"Editors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2017":{"total":"174","women":"54.1","white":"90.9","black":"3.8","asian":"2.9","hispanicOrLatino":"4.1"}},"wageData":{"2017":{"workers":"124","median":"1,084","maleWorkers":"56","maleMedian":"1,123","femaleWorkers":"68","femaleMedian":"992"}}},"Technical writers":{"ageData":{"2017":{"total":"76","16to19":"0","20to24":"2","25to34":"11","35to44":"19","45to54":"23","55to64":"15","65+":"6","medianAge":"15"}},"title":"Technical writers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2017":{"total":"76","women":"60.2","white":"84.6","black":"6.7","asian":"5.6","hispanicOrLatino":"1.2"}},"wageData":{"2017":{"workers":"67","median":"1,222","maleWorkers":"30","maleMedian":"-","femaleWorkers":"37","femaleMedian":"-"}}},"Writers and authors":{"ageData":{"2017":{"total":"226","16to19":"1","20to24":"9","25to34":"57","35to44":"36","45to54":"50","55to64":"42","65+":"31","medianAge":"42"}},"title":"Writers and authors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2017":{"total":"226","women":"60.9","white":"86.3","black":"6.3","asian":"3.2","hispanicOrLatino":"4.6"}},"wageData":{"2017":{"workers":"106","median":"1,137","maleWorkers":"50","maleMedian":"1,171","femaleWorkers":"57","femaleMedian":"1,045"}}},"Miscellaneous media and communication workers":{"ageData":{"2017":{"total":"112","16to19":"2","20to24":"8","25to34":"23","35to44":"27","45to54":"22","55to64":"19","65+":"10","medianAge":"19"}},"title":"Miscellaneous media and communication workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2017":{"total":"112","women":"64.2","white":"70.6","black":"9.5","asian":"14.3","hispanicOrLatino":"32.9"}},"wageData":{"2017":{"workers":"53","median":"809","maleWorkers":"25","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Broadcast and sound engineering technicians and radio operators":{"ageData":{"2017":{"total":"119","16to19":"2","20to24":"11","25to34":"21","35to44":"29","45to54":"28","55to64":"22","65+":"6","medianAge":"22"}},"title":"Broadcast and sound engineering technicians and radio operators","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2017":{"total":"119","women":"14.4","white":"78.2","black":"14.0","asian":"3.7","hispanicOrLatino":"16.8"}},"wageData":{"2017":{"workers":"81","median":"1,150","maleWorkers":"71","maleMedian":"1,160","femaleWorkers":"10","femaleMedian":"-"}}},"Photographers":{"ageData":{"2017":{"total":"214","16to19":"7","20to24":"15","25to34":"58","35to44":"48","45to54":"34","55to64":"42","65+":"11","medianAge":"42"}},"title":"Photographers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2017":{"total":"214","women":"46.0","white":"84.4","black":"9.1","asian":"3.0","hispanicOrLatino":"8.7"}},"wageData":{"2017":{"workers":"66","median":"931","maleWorkers":"40","maleMedian":"-","femaleWorkers":"25","femaleMedian":"-"}}},"Television, video, and motion picture camera operators and editors":{"ageData":{"2017":{"total":"82","16to19":"2","20to24":"11","25to34":"28","35to44":"19","45to54":"9","55to64":"9","65+":"4","medianAge":"9"}},"title":"Television, video, and motion picture camera operators and editors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2017":{"total":"82","women":"12.2","white":"86.1","black":"7.2","asian":"1.9","hispanicOrLatino":"7.6"}},"wageData":{"2017":{"workers":"46","median":"-","maleWorkers":"38","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Media and communication equipment workers, all other":{"ageData":{"2017":{"total":"5","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"3","55to64":"0","65+":"0","medianAge":"0"}},"title":"Media and communication equipment workers, all other","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2017":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"5","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Healthcare practitioners and technical occupations":{"ageData":{"2017":{"total":"9,141","16to19":"38","20to24":"526","25to34":"2,394","35to44":"2,084","45to54":"1,986","55to64":"1,591","65+":"523","medianAge":"1,591"}},"title":"Healthcare practitioners and technical occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2017":{"total":"9,141","women":"75.0","white":"76.5","black":"11.9","asian":"9.4","hispanicOrLatino":"8.2"}},"wageData":{"2017":{"workers":"6,970","median":"1,124","maleWorkers":"1,724","maleMedian":"1,341","femaleWorkers":"5,246","femaleMedian":"1,068"}}},"Chiropractors":{"ageData":{"2017":{"total":"51","16to19":"0","20to24":"0","25to34":"7","35to44":"10","45to54":"12","55to64":"15","65+":"7","medianAge":"15"}},"title":"Chiropractors","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"51","women":"21.1","white":"97.4","black":"0.1","asian":"1.7","hispanicOrLatino":"5.1"}},"wageData":{"2017":{"workers":"11","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Dentists":{"ageData":{"2017":{"total":"159","16to19":"0","20to24":"0","25to34":"31","35to44":"26","45to54":"32","55to64":"45","65+":"26","medianAge":"45"}},"title":"Dentists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"159","women":"35.8","white":"81.6","black":"3.7","asian":"13.5","hispanicOrLatino":"4.7"}},"wageData":{"2017":{"workers":"41","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"25","femaleMedian":"-"}}},"Dietitians and nutritionists":{"ageData":{"2017":{"total":"114","16to19":"0","20to24":"5","25to34":"30","35to44":"21","45to54":"26","55to64":"24","65+":"9","medianAge":"24"}},"title":"Dietitians and nutritionists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"114","women":"94.1","white":"79.7","black":"12.8","asian":"5.6","hispanicOrLatino":"9.0"}},"wageData":{"2017":{"workers":"88","median":"991","maleWorkers":"8","maleMedian":"-","femaleWorkers":"80","femaleMedian":"996"}}},"Optometrists":{"ageData":{"2017":{"total":"51","16to19":"0","20to24":"0","25to34":"9","35to44":"7","45to54":"23","55to64":"8","65+":"5","medianAge":"8"}},"title":"Optometrists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"51","women":"50.2","white":"91.9","black":"0.0","asian":"7.9","hispanicOrLatino":"3.2"}},"wageData":{"2017":{"workers":"19","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Pharmacists":{"ageData":{"2017":{"total":"342","16to19":"0","20to24":"19","25to34":"119","35to44":"66","45to54":"55","55to64":"58","65+":"24","medianAge":"58"}},"title":"Pharmacists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"342","women":"57.5","white":"68.5","black":"8.2","asian":"21.7","hispanicOrLatino":"4.5"}},"wageData":{"2017":{"workers":"254","median":"1,923","maleWorkers":"107","maleMedian":"2,228","femaleWorkers":"147","femaleMedian":"1,834"}}},"Physicians and surgeons":{"ageData":{"2017":{"total":"1,079","16to19":"0","20to24":"4","25to34":"254","35to44":"249","45to54":"247","55to64":"203","65+":"121","medianAge":"203"}},"title":"Physicians and surgeons","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"1,079","women":"40.0","white":"72.0","black":"8.2","asian":"18.1","hispanicOrLatino":"6.8"}},"wageData":{"2017":{"workers":"815","median":"1,918","maleWorkers":"463","maleMedian":"2,277","femaleWorkers":"352","femaleMedian":"1,759"}}},"Physician assistants":{"ageData":{"2017":{"total":"116","16to19":"0","20to24":"2","25to34":"54","35to44":"26","45to54":"19","55to64":"11","65+":"4","medianAge":"11"}},"title":"Physician assistants","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"116","women":"70.9","white":"86.0","black":"4.7","asian":"7.9","hispanicOrLatino":"5.1"}},"wageData":{"2017":{"workers":"97","median":"1,747","maleWorkers":"31","maleMedian":"-","femaleWorkers":"66","femaleMedian":"1,640"}}},"Podiatrists":{"ageData":{"2017":{"total":"12","16to19":"0","20to24":"1","25to34":"0","35to44":"5","45to54":"3","55to64":"1","65+":"2","medianAge":"1"}},"title":"Podiatrists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"12","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"7","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Audiologists":{"ageData":{"2017":{"total":"15","16to19":"0","20to24":"1","25to34":"5","35to44":"2","45to54":"5","55to64":"2","65+":"0","medianAge":"2"}},"title":"Audiologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"15","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"13","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Occupational therapists":{"ageData":{"2017":{"total":"122","16to19":"0","20to24":"3","25to34":"34","35to44":"41","45to54":"27","55to64":"16","65+":"2","medianAge":"16"}},"title":"Occupational therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"122","women":"87.6","white":"82.9","black":"8.7","asian":"6.4","hispanicOrLatino":"6.2"}},"wageData":{"2017":{"workers":"74","median":"1,301","maleWorkers":"12","maleMedian":"-","femaleWorkers":"62","femaleMedian":"1,273"}}},"Physical therapists":{"ageData":{"2017":{"total":"258","16to19":"1","20to24":"11","25to34":"84","35to44":"70","45to54":"54","55to64":"26","65+":"12","medianAge":"26"}},"title":"Physical therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"258","women":"68.2","white":"78.2","black":"5.3","asian":"14.7","hispanicOrLatino":"5.0"}},"wageData":{"2017":{"workers":"182","median":"1,317","maleWorkers":"64","maleMedian":"1,341","femaleWorkers":"118","femaleMedian":"1,297"}}},"Radiation therapists":{"ageData":{"2017":{"total":"10","16to19":"0","20to24":"0","25to34":"5","35to44":"4","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Radiation therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"10","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"11","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Recreational therapists":{"ageData":{"2017":{"total":"7","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"3","55to64":"1","65+":"0","medianAge":"1"}},"title":"Recreational therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"7","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"5","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Respiratory therapists":{"ageData":{"2017":{"total":"100","16to19":"0","20to24":"2","25to34":"28","35to44":"25","45to54":"19","55to64":"17","65+":"10","medianAge":"17"}},"title":"Respiratory therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"100","women":"72.4","white":"73.3","black":"16.6","asian":"10.0","hispanicOrLatino":"8.8"}},"wageData":{"2017":{"workers":"83","median":"961","maleWorkers":"27","maleMedian":"-","femaleWorkers":"56","femaleMedian":"904"}}},"Speech-language pathologists":{"ageData":{"2017":{"total":"141","16to19":"1","20to24":"5","25to34":"43","35to44":"45","45to54":"23","55to64":"16","65+":"8","medianAge":"16"}},"title":"Speech-language pathologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"141","women":"98.0","white":"93.0","black":"2.8","asian":"2.7","hispanicOrLatino":"10.5"}},"wageData":{"2017":{"workers":"106","median":"1,213","maleWorkers":"4","maleMedian":"-","femaleWorkers":"102","femaleMedian":"1,214"}}},"Exercise physiologists":{"ageData":{"2017":{"total":"5","16to19":"0","20to24":"0","25to34":"3","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Exercise physiologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"5","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Therapists, all other":{"ageData":{"2017":{"total":"221","16to19":"1","20to24":"9","25to34":"73","35to44":"53","45to54":"43","55to64":"28","65+":"15","medianAge":"28"}},"title":"Therapists, all other","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"221","women":"83.3","white":"81.8","black":"12.5","asian":"3.3","hispanicOrLatino":"10.2"}},"wageData":{"2017":{"workers":"142","median":"983","maleWorkers":"29","maleMedian":"-","femaleWorkers":"114","femaleMedian":"947"}}},"Veterinarians":{"ageData":{"2017":{"total":"89","16to19":"1","20to24":"2","25to34":"22","35to44":"18","45to54":"22","55to64":"15","65+":"10","medianAge":"15"}},"title":"Veterinarians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"89","women":"62.5","white":"91.2","black":"2.1","asian":"3.7","hispanicOrLatino":"3.6"}},"wageData":{"2017":{"workers":"60","median":"1,840","maleWorkers":"20","maleMedian":"-","femaleWorkers":"40","femaleMedian":"-"}}},"Registered nurses":{"ageData":{"2017":{"total":"3,159","16to19":"2","20to24":"159","25to34":"801","35to44":"707","45to54":"735","55to64":"617","65+":"137","medianAge":"617"}},"title":"Registered nurses","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"3,159","women":"89.9","white":"76.7","black":"12.3","asian":"8.7","hispanicOrLatino":"6.9"}},"wageData":{"2017":{"workers":"2,536","median":"1,150","maleWorkers":"283","maleMedian":"1,260","femaleWorkers":"2,253","femaleMedian":"1,143"}}},"Nurse anesthetists":{"ageData":{"2017":{"total":"35","16to19":"0","20to24":"0","25to34":"8","35to44":"9","45to54":"8","55to64":"9","65+":"2","medianAge":"9"}},"title":"Nurse anesthetists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"35","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"30","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Nurse midwives":{"ageData":{"2017":{"total":"7","16to19":"0","20to24":"0","25to34":"2","35to44":"4","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Nurse midwives","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"7","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"5","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Nurse practitioners":{"ageData":{"2017":{"total":"175","16to19":"0","20to24":"1","25to34":"35","35to44":"50","45to54":"42","55to64":"36","65+":"12","medianAge":"36"}},"title":"Nurse practitioners","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"175","women":"92.2","white":"84.7","black":"10.6","asian":"4.0","hispanicOrLatino":"3.4"}},"wageData":{"2017":{"workers":"141","median":"1,841","maleWorkers":"12","maleMedian":"-","femaleWorkers":"129","femaleMedian":"1,832"}}},"Health diagnosing and treating practitioners, all other":{"ageData":{"2017":{"total":"39","16to19":"0","20to24":"1","25to34":"6","35to44":"9","45to54":"12","55to64":"9","65+":"3","medianAge":"9"}},"title":"Health diagnosing and treating practitioners, all other","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"39","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"15","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Clinical laboratory technologists and technicians":{"ageData":{"2017":{"total":"376","16to19":"3","20to24":"42","25to34":"98","35to44":"71","45to54":"85","55to64":"58","65+":"19","medianAge":"58"}},"title":"Clinical laboratory technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"376","women":"69.3","white":"71.2","black":"17.1","asian":"9.4","hispanicOrLatino":"11.0"}},"wageData":{"2017":{"workers":"297","median":"890","maleWorkers":"94","maleMedian":"1,061","femaleWorkers":"203","femaleMedian":"845"}}},"Dental hygienists":{"ageData":{"2017":{"total":"168","16to19":"0","20to24":"10","25to34":"46","35to44":"34","45to54":"36","55to64":"35","65+":"7","medianAge":"35"}},"title":"Dental hygienists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"168","women":"94.9","white":"88.6","black":"7.0","asian":"2.4","hispanicOrLatino":"11.9"}},"wageData":{"2017":{"workers":"78","median":"1,033","maleWorkers":"5","maleMedian":"-","femaleWorkers":"73","femaleMedian":"1,028"}}},"Diagnostic related technologists and technicians":{"ageData":{"2017":{"total":"319","16to19":"0","20to24":"19","25to34":"79","35to44":"76","45to54":"80","55to64":"56","65+":"9","medianAge":"56"}},"title":"Diagnostic related technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"319","women":"70.8","white":"84.3","black":"8.2","asian":"6.4","hispanicOrLatino":"12.5"}},"wageData":{"2017":{"workers":"271","median":"1,162","maleWorkers":"85","maleMedian":"1,404","femaleWorkers":"186","femaleMedian":"1,041"}}},"Emergency medical technicians and paramedics":{"ageData":{"2017":{"total":"223","16to19":"4","20to24":"40","25to34":"71","35to44":"53","45to54":"31","55to64":"20","65+":"4","medianAge":"20"}},"title":"Emergency medical technicians and paramedics","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"223","women":"30.6","white":"83.9","black":"9.7","asian":"3.1","hispanicOrLatino":"8.4"}},"wageData":{"2017":{"workers":"203","median":"984","maleWorkers":"145","maleMedian":"1,119","femaleWorkers":"58","femaleMedian":"733"}}},"Health practitioner support technologists and technicians":{"ageData":{"2017":{"total":"632","16to19":"13","20to24":"108","25to34":"190","35to44":"152","45to54":"100","55to64":"58","65+":"11","medianAge":"58"}},"title":"Health practitioner support technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"632","women":"79.4","white":"75.6","black":"13.5","asian":"7.3","hispanicOrLatino":"14.3"}},"wageData":{"2017":{"workers":"469","median":"710","maleWorkers":"98","maleMedian":"858","femaleWorkers":"371","femaleMedian":"678"}}},"Licensed practical and licensed vocational nurses":{"ageData":{"2017":{"total":"630","16to19":"5","20to24":"50","25to34":"148","35to44":"145","45to54":"141","55to64":"105","65+":"37","medianAge":"105"}},"title":"Licensed practical and licensed vocational nurses","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"630","women":"89.5","white":"64.0","black":"28.4","asian":"5.4","hispanicOrLatino":"12.4"}},"wageData":{"2017":{"workers":"501","median":"815","maleWorkers":"62","maleMedian":"817","femaleWorkers":"438","femaleMedian":"814"}}},"Medical records and health information technicians":{"ageData":{"2017":{"total":"167","16to19":"1","20to24":"7","25to34":"30","35to44":"34","45to54":"45","55to64":"42","65+":"7","medianAge":"42"}},"title":"Medical records and health information technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"167","women":"91.7","white":"74.6","black":"13.2","asian":"6.9","hispanicOrLatino":"9.8"}},"wageData":{"2017":{"workers":"151","median":"763","maleWorkers":"11","maleMedian":"-","femaleWorkers":"140","femaleMedian":"761"}}},"Opticians, dispensing":{"ageData":{"2017":{"total":"48","16to19":"1","20to24":"4","25to34":"11","35to44":"5","45to54":"10","55to64":"12","65+":"6","medianAge":"12"}},"title":"Opticians, dispensing","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"48","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"43","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"30","femaleMedian":"-"}}},"Miscellaneous health technologists and technicians":{"ageData":{"2017":{"total":"160","16to19":"3","20to24":"12","25to34":"41","35to44":"42","45to54":"24","55to64":"29","65+":"8","medianAge":"29"}},"title":"Miscellaneous health technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"160","women":"66.0","white":"66.8","black":"18.5","asian":"10.4","hispanicOrLatino":"10.0"}},"wageData":{"2017":{"workers":"143","median":"811","maleWorkers":"48","maleMedian":"-","femaleWorkers":"95","femaleMedian":"746"}}},"Other healthcare practitioners and technical occupations":{"ageData":{"2017":{"total":"110","16to19":"2","20to24":"10","25to34":"27","35to44":"24","45to54":"24","55to64":"18","65+":"5","medianAge":"18"}},"title":"Other healthcare practitioners and technical occupations","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2017":{"total":"110","women":"46.5","white":"84.0","black":"9.0","asian":"6.5","hispanicOrLatino":"9.4"}},"wageData":{"2017":{"workers":"77","median":"1,183","maleWorkers":"49","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Service occupations":{"ageData":{"2017":{"total":"26,751","16to19":"2,091","20to24":"3,818","25to34":"6,066","35to44":"4,935","45to54":"4,782","55to64":"3,675","65+":"1,385","medianAge":"3,675"}},"title":"Service occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2017":{"total":"26,751","women":"56.6","white":"72.6","black":"16.8","asian":"5.9","hispanicOrLatino":"24.0"}},"wageData":{"2017":{"workers":"16,044","median":"544","maleWorkers":"7,985","maleMedian":"608","femaleWorkers":"8,059","femaleMedian":"501"}}},"Healthcare support occupations":{"ageData":{"2017":{"total":"3,506","16to19":"91","20to24":"513","25to34":"916","35to44":"698","45to54":"657","55to64":"472","65+":"160","medianAge":"472"}},"title":"Healthcare support occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2017":{"total":"3,506","women":"87.1","white":"65.6","black":"25.1","asian":"5.2","hispanicOrLatino":"18.8"}},"wageData":{"2017":{"workers":"2,500","median":"542","maleWorkers":"320","maleMedian":"597","femaleWorkers":"2,180","femaleMedian":"533"}}},"Nursing, psychiatric, and home health aides":{"ageData":{"2017":{"total":"1,936","16to19":"56","20to24":"260","25to34":"441","35to44":"381","45to54":"393","55to64":"294","65+":"111","medianAge":"294"}},"title":"Nursing, psychiatric, and home health aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2017":{"total":"1,936","women":"88.6","white":"56.4","black":"33.9","asian":"5.6","hispanicOrLatino":"16.7"}},"wageData":{"2017":{"workers":"1,387","median":"500","maleWorkers":"164","maleMedian":"583","femaleWorkers":"1,223","femaleMedian":"493"}}},"Occupational therapy assistants and aides":{"ageData":{"2017":{"total":"27","16to19":"0","20to24":"2","25to34":"8","35to44":"5","45to54":"7","55to64":"5","65+":"0","medianAge":"5"}},"title":"Occupational therapy assistants and aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2017":{"total":"27","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"13","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Physical therapist assistants and aides":{"ageData":{"2017":{"total":"83","16to19":"0","20to24":"19","25to34":"22","35to44":"14","45to54":"17","55to64":"8","65+":"3","medianAge":"8"}},"title":"Physical therapist assistants and aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2017":{"total":"83","women":"67.2","white":"88.0","black":"5.2","asian":"5.6","hispanicOrLatino":"11.0"}},"wageData":{"2017":{"workers":"47","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"33","femaleMedian":"-"}}},"Massage therapists":{"ageData":{"2017":{"total":"172","16to19":"0","20to24":"17","25to34":"42","35to44":"34","45to54":"38","55to64":"32","65+":"9","medianAge":"32"}},"title":"Massage therapists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2017":{"total":"172","women":"82.7","white":"83.7","black":"4.6","asian":"6.7","hispanicOrLatino":"12.4"}},"wageData":{"2017":{"workers":"51","median":"632","maleWorkers":"15","maleMedian":"-","femaleWorkers":"36","femaleMedian":"-"}}},"Dental assistants":{"ageData":{"2017":{"total":"299","16to19":"9","20to24":"43","25to34":"93","35to44":"57","45to54":"53","55to64":"34","65+":"9","medianAge":"34"}},"title":"Dental assistants","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2017":{"total":"299","women":"95.9","white":"82.9","black":"7.9","asian":"5.0","hispanicOrLatino":"29.1"}},"wageData":{"2017":{"workers":"215","median":"608","maleWorkers":"12","maleMedian":"-","femaleWorkers":"203","femaleMedian":"602"}}},"Medical assistants":{"ageData":{"2017":{"total":"539","16to19":"4","20to24":"73","25to34":"186","35to44":"137","45to54":"83","55to64":"42","65+":"15","medianAge":"42"}},"title":"Medical assistants","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2017":{"total":"539","women":"91.6","white":"76.2","black":"15.0","asian":"4.0","hispanicOrLatino":"27.9"}},"wageData":{"2017":{"workers":"457","median":"594","maleWorkers":"39","maleMedian":"-","femaleWorkers":"418","femaleMedian":"597"}}},"Medical transcriptionists":{"ageData":{"2017":{"total":"36","16to19":"1","20to24":"10","25to34":"7","35to44":"3","45to54":"4","55to64":"8","65+":"3","medianAge":"8"}},"title":"Medical transcriptionists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2017":{"total":"36","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"21","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"18","femaleMedian":"-"}}},"Pharmacy aides":{"ageData":{"2017":{"total":"39","16to19":"2","20to24":"11","25to34":"11","35to44":"7","45to54":"4","55to64":"4","65+":"1","medianAge":"4"}},"title":"Pharmacy aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2017":{"total":"39","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"25","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"14","femaleMedian":"-"}}},"Veterinary assistants and laboratory animal caretakers":{"ageData":{"2017":{"total":"61","16to19":"7","20to24":"20","25to34":"16","35to44":"5","45to54":"8","55to64":"4","65+":"1","medianAge":"4"}},"title":"Veterinary assistants and laboratory animal caretakers","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2017":{"total":"61","women":"84.2","white":"86.4","black":"2.3","asian":"6.0","hispanicOrLatino":"8.4"}},"wageData":{"2017":{"workers":"37","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"33","femaleMedian":"-"}}},"Phlebotomists":{"ageData":{"2017":{"total":"112","16to19":"2","20to24":"21","25to34":"35","35to44":"23","45to54":"19","55to64":"10","65+":"3","medianAge":"10"}},"title":"Phlebotomists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2017":{"total":"112","women":"83.8","white":"64.7","black":"27.6","asian":"5.9","hispanicOrLatino":"17.2"}},"wageData":{"2017":{"workers":"97","median":"635","maleWorkers":"16","maleMedian":"-","femaleWorkers":"82","femaleMedian":"639"}}},"Miscellaneous healthcare support occupations, including medical equipment preparers":{"ageData":{"2017":{"total":"200","16to19":"10","20to24":"37","25to34":"55","35to44":"33","45to54":"31","55to64":"30","65+":"5","medianAge":"30"}},"title":"Miscellaneous healthcare support occupations, including medical equipment preparers","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2017":{"total":"200","women":"70.5","white":"60.3","black":"31.4","asian":"4.1","hispanicOrLatino":"16.1"}},"wageData":{"2017":{"workers":"150","median":"587","maleWorkers":"40","maleMedian":"-","femaleWorkers":"110","femaleMedian":"603"}}},"Protective service occupations":{"ageData":{"2017":{"total":"3,113","16to19":"98","20to24":"265","25to34":"805","35to44":"718","45to54":"666","55to64":"396","65+":"165","medianAge":"396"}},"title":"Protective service occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2017":{"total":"3,113","women":"22.3","white":"72.6","black":"20.5","asian":"2.9","hispanicOrLatino":"12.8"}},"wageData":{"2017":{"workers":"2,739","median":"852","maleWorkers":"2,204","maleMedian":"894","femaleWorkers":"535","femaleMedian":"690"}}},"First-line supervisors of correctional officers":{"ageData":{"2017":{"total":"52","16to19":"0","20to24":"0","25to34":"8","35to44":"12","45to54":"20","55to64":"10","65+":"2","medianAge":"10"}},"title":"First-line supervisors of correctional officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2017":{"total":"52","women":"29.9","white":"77.7","black":"13.1","asian":"3.8","hispanicOrLatino":"10.1"}},"wageData":{"2017":{"workers":"50","median":"899","maleWorkers":"38","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"First-line supervisors of police and detectives":{"ageData":{"2017":{"total":"95","16to19":"0","20to24":"0","25to34":"11","35to44":"31","45to54":"36","55to64":"14","65+":"3","medianAge":"14"}},"title":"First-line supervisors of police and detectives","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2017":{"total":"95","women":"12.5","white":"81.1","black":"14.1","asian":"0.9","hispanicOrLatino":"7.1"}},"wageData":{"2017":{"workers":"94","median":"1,348","maleWorkers":"81","maleMedian":"1,347","femaleWorkers":"13","femaleMedian":"-"}}},"First-line supervisors of fire fighting and prevention workers":{"ageData":{"2017":{"total":"44","16to19":"0","20to24":"1","25to34":"2","35to44":"12","45to54":"20","55to64":"7","65+":"2","medianAge":"7"}},"title":"First-line supervisors of fire fighting and prevention workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2017":{"total":"44","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"43","median":"-","maleWorkers":"42","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"First-line supervisors of protective service workers, all other":{"ageData":{"2017":{"total":"72","16to19":"0","20to24":"2","25to34":"11","35to44":"16","45to54":"21","55to64":"16","65+":"6","medianAge":"16"}},"title":"First-line supervisors of protective service workers, all other","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2017":{"total":"72","women":"22.0","white":"74.7","black":"15.0","asian":"5.4","hispanicOrLatino":"10.0"}},"wageData":{"2017":{"workers":"69","median":"953","maleWorkers":"58","maleMedian":"938","femaleWorkers":"11","femaleMedian":"-"}}},"Firefighters":{"ageData":{"2017":{"total":"283","16to19":"1","20to24":"18","25to34":"103","35to44":"87","45to54":"48","55to64":"25","65+":"1","medianAge":"25"}},"title":"Firefighters","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2017":{"total":"283","women":"3.5","white":"88.5","black":"7.5","asian":"1.0","hispanicOrLatino":"7.7"}},"wageData":{"2017":{"workers":"272","median":"1,123","maleWorkers":"264","maleMedian":"1,136","femaleWorkers":"8","femaleMedian":"-"}}},"Fire inspectors":{"ageData":{"2017":{"total":"27","16to19":"0","20to24":"2","25to34":"3","35to44":"6","45to54":"8","55to64":"5","65+":"4","medianAge":"5"}},"title":"Fire inspectors","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2017":{"total":"27","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"22","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Bailiffs, correctional officers, and jailers":{"ageData":{"2017":{"total":"408","16to19":"2","20to24":"34","25to34":"136","35to44":"88","45to54":"86","55to64":"43","65+":"18","medianAge":"43"}},"title":"Bailiffs, correctional officers, and jailers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2017":{"total":"408","women":"28.5","white":"67.4","black":"29.0","asian":"1.8","hispanicOrLatino":"13.5"}},"wageData":{"2017":{"workers":"390","median":"771","maleWorkers":"284","maleMedian":"825","femaleWorkers":"106","femaleMedian":"669"}}},"Detectives and criminal investigators":{"ageData":{"2017":{"total":"136","16to19":"1","20to24":"3","25to34":"28","35to44":"43","45to54":"43","55to64":"16","65+":"2","medianAge":"16"}},"title":"Detectives and criminal investigators","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2017":{"total":"136","women":"23.2","white":"87.1","black":"11.6","asian":"0.9","hispanicOrLatino":"14.1"}},"wageData":{"2017":{"workers":"142","median":"1,256","maleWorkers":"110","maleMedian":"1,291","femaleWorkers":"32","femaleMedian":"-"}}},"Fish and game wardens":{"ageData":{"2017":{"total":"4","16to19":"0","20to24":"0","25to34":"1","35to44":"2","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Fish and game wardens","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2017":{"total":"4","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Parking enforcement workers":{"ageData":{"2017":{"total":"6","16to19":"0","20to24":"1","25to34":"0","35to44":"2","45to54":"3","55to64":"0","65+":"0","medianAge":"0"}},"title":"Parking enforcement workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2017":{"total":"6","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"4","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Police and sheriff\'s patrol officers":{"ageData":{"2017":{"total":"704","16to19":"1","20to24":"35","25to34":"211","35to44":"212","45to54":"167","55to64":"54","65+":"24","medianAge":"54"}},"title":"Police and sheriff\'s patrol officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2017":{"total":"704","women":"13.6","white":"79.8","black":"13.9","asian":"2.4","hispanicOrLatino":"10.9"}},"wageData":{"2017":{"workers":"688","median":"1,015","maleWorkers":"595","maleMedian":"1,024","femaleWorkers":"94","femaleMedian":"985"}}},"Transit and railroad police":{"ageData":{"2017":{"total":"7","16to19":"0","20to24":"0","25to34":"1","35to44":"2","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Transit and railroad police","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2017":{"total":"7","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"6","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Animal control workers":{"ageData":{"2017":{"total":"15","16to19":"0","20to24":"0","25to34":"5","35to44":"2","45to54":"5","55to64":"3","65+":"1","medianAge":"3"}},"title":"Animal control workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2017":{"total":"15","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"12","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Private detectives and investigators":{"ageData":{"2017":{"total":"94","16to19":"1","20to24":"3","25to34":"15","35to44":"29","45to54":"20","55to64":"20","65+":"7","medianAge":"20"}},"title":"Private detectives and investigators","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2017":{"total":"94","women":"48.8","white":"79.0","black":"13.8","asian":"4.6","hispanicOrLatino":"11.3"}},"wageData":{"2017":{"workers":"86","median":"963","maleWorkers":"42","maleMedian":"-","femaleWorkers":"44","femaleMedian":"-"}}},"Security guards and gaming surveillance officers":{"ageData":{"2017":{"total":"920","16to19":"13","20to24":"122","25to34":"242","35to44":"152","45to54":"159","55to64":"153","65+":"79","medianAge":"153"}},"title":"Security guards and gaming surveillance officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2017":{"total":"920","women":"24.3","white":"57.5","black":"32.3","asian":"4.4","hispanicOrLatino":"17.0"}},"wageData":{"2017":{"workers":"740","median":"596","maleWorkers":"570","maleMedian":"616","femaleWorkers":"170","femaleMedian":"548"}}},"Crossing guards":{"ageData":{"2017":{"total":"63","16to19":"2","20to24":"2","25to34":"6","35to44":"11","45to54":"8","55to64":"20","65+":"13","medianAge":"20"}},"title":"Crossing guards","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2017":{"total":"63","women":"52.2","white":"69.4","black":"21.5","asian":"4.7","hispanicOrLatino":"20.9"}},"wageData":{"2017":{"workers":"23","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Transportation security screeners":{"ageData":{"2017":{"total":"46","16to19":"0","20to24":"9","25to34":"13","35to44":"6","45to54":"10","55to64":"7","65+":"1","medianAge":"7"}},"title":"Transportation security screeners","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2017":{"total":"46","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"43","median":"-","maleWorkers":"32","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Lifeguards and other recreational, and all other protective service workers":{"ageData":{"2017":{"total":"136","16to19":"77","20to24":"33","25to34":"8","35to44":"5","45to54":"7","55to64":"3","65+":"3","medianAge":"3"}},"title":"Lifeguards and other recreational, and all other protective service workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2017":{"total":"136","women":"49.6","white":"88.5","black":"4.1","asian":"2.5","hispanicOrLatino":"9.4"}},"wageData":{"2017":{"workers":"49","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"19","femaleMedian":"-"}}},"Food preparation and serving related occupations":{"ageData":{"2017":{"total":"8,305","16to19":"1,346","20to24":"1,765","25to34":"1,975","35to44":"1,204","45to54":"1,028","55to64":"749","65+":"239","medianAge":"749"}},"title":"Food preparation and serving related occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2017":{"total":"8,305","women":"53.8","white":"74.4","black":"13.9","asian":"6.2","hispanicOrLatino":"25.5"}},"wageData":{"2017":{"workers":"4,465","median":"484","maleWorkers":"2,359","maleMedian":"502","femaleWorkers":"2,106","femaleMedian":"459"}}},"Chefs and head cooks":{"ageData":{"2017":{"total":"465","16to19":"5","20to24":"40","25to34":"149","35to44":"116","45to54":"79","55to64":"63","65+":"14","medianAge":"63"}},"title":"Chefs and head cooks","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2017":{"total":"465","women":"19.7","white":"65.0","black":"16.4","asian":"13.9","hispanicOrLatino":"21.0"}},"wageData":{"2017":{"workers":"382","median":"634","maleWorkers":"310","maleMedian":"655","femaleWorkers":"72","femaleMedian":"514"}}},"First-line supervisors of food preparation and serving workers":{"ageData":{"2017":{"total":"519","16to19":"29","20to24":"81","25to34":"158","35to44":"83","45to54":"88","55to64":"65","65+":"15","medianAge":"65"}},"title":"First-line supervisors of food preparation and serving workers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2017":{"total":"519","women":"54.8","white":"74.8","black":"17.0","asian":"3.7","hispanicOrLatino":"18.9"}},"wageData":{"2017":{"workers":"427","median":"537","maleWorkers":"200","maleMedian":"613","femaleWorkers":"227","femaleMedian":"500"}}},"Cooks":{"ageData":{"2017":{"total":"2,079","16to19":"236","20to24":"328","25to34":"482","35to44":"415","45to54":"331","55to64":"224","65+":"63","medianAge":"224"}},"title":"Cooks","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2017":{"total":"2,079","women":"39.3","white":"73.2","black":"16.8","asian":"5.1","hispanicOrLatino":"35.4"}},"wageData":{"2017":{"workers":"1,365","median":"466","maleWorkers":"859","maleMedian":"481","femaleWorkers":"506","femaleMedian":"436"}}},"Food preparation workers":{"ageData":{"2017":{"total":"1,068","16to19":"192","20to24":"254","25to34":"217","35to44":"116","45to54":"131","55to64":"109","65+":"49","medianAge":"109"}},"title":"Food preparation workers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2017":{"total":"1,068","women":"58.9","white":"72.2","black":"14.5","asian":"6.5","hispanicOrLatino":"27.4"}},"wageData":{"2017":{"workers":"510","median":"425","maleWorkers":"242","maleMedian":"449","femaleWorkers":"269","femaleMedian":"410"}}},"Bartenders":{"ageData":{"2017":{"total":"417","16to19":"8","20to24":"78","25to34":"172","35to44":"72","45to54":"49","55to64":"27","65+":"11","medianAge":"27"}},"title":"Bartenders","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2017":{"total":"417","women":"57.3","white":"85.5","black":"7.2","asian":"2.8","hispanicOrLatino":"14.1"}},"wageData":{"2017":{"workers":"210","median":"554","maleWorkers":"98","maleMedian":"600","femaleWorkers":"112","femaleMedian":"515"}}},"Combined food preparation and serving workers, including fast food":{"ageData":{"2017":{"total":"372","16to19":"95","20to24":"89","25to34":"67","35to44":"38","45to54":"39","55to64":"29","65+":"13","medianAge":"29"}},"title":"Combined food preparation and serving workers, including fast food","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2017":{"total":"372","women":"60.0","white":"70.0","black":"17.3","asian":"4.4","hispanicOrLatino":"22.8"}},"wageData":{"2017":{"workers":"175","median":"407","maleWorkers":"75","maleMedian":"415","femaleWorkers":"100","femaleMedian":"401"}}},"Counter attendants, cafeteria, food concession, and coffee shop":{"ageData":{"2017":{"total":"225","16to19":"105","20to24":"52","25to34":"26","35to44":"12","45to54":"15","55to64":"13","65+":"3","medianAge":"13"}},"title":"Counter attendants, cafeteria, food concession, and coffee shop","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2017":{"total":"225","women":"62.1","white":"72.0","black":"16.9","asian":"5.0","hispanicOrLatino":"21.3"}},"wageData":{"2017":{"workers":"65","median":"460","maleWorkers":"29","maleMedian":"-","femaleWorkers":"36","femaleMedian":"-"}}},"Waiters and waitresses":{"ageData":{"2017":{"total":"2,016","16to19":"324","20to24":"597","25to34":"540","35to44":"233","45to54":"176","55to64":"112","65+":"34","medianAge":"112"}},"title":"Waiters and waitresses","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2017":{"total":"2,016","women":"69.9","white":"78.2","black":"9.2","asian":"7.6","hispanicOrLatino":"20.9"}},"wageData":{"2017":{"workers":"911","median":"493","maleWorkers":"319","maleMedian":"533","femaleWorkers":"592","femaleMedian":"475"}}},"Food servers, nonrestaurant":{"ageData":{"2017":{"total":"207","16to19":"41","20to24":"40","25to34":"36","35to44":"25","45to54":"31","55to64":"27","65+":"7","medianAge":"27"}},"title":"Food servers, nonrestaurant","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2017":{"total":"207","women":"69.9","white":"69.9","black":"18.5","asian":"7.0","hispanicOrLatino":"21.8"}},"wageData":{"2017":{"workers":"88","median":"473","maleWorkers":"28","maleMedian":"-","femaleWorkers":"59","femaleMedian":"468"}}},"Dining room and cafeteria attendants and bartender helpers":{"ageData":{"2017":{"total":"334","16to19":"94","20to24":"65","25to34":"44","35to44":"44","45to54":"36","55to64":"38","65+":"13","medianAge":"38"}},"title":"Dining room and cafeteria attendants and bartender helpers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2017":{"total":"334","women":"45.9","white":"76.4","black":"9.9","asian":"7.8","hispanicOrLatino":"27.9"}},"wageData":{"2017":{"workers":"134","median":"458","maleWorkers":"79","maleMedian":"444","femaleWorkers":"55","femaleMedian":"481"}}},"Dishwashers":{"ageData":{"2017":{"total":"274","16to19":"67","20to24":"52","25to34":"45","35to44":"37","45to54":"41","55to64":"26","65+":"7","medianAge":"26"}},"title":"Dishwashers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2017":{"total":"274","women":"19.5","white":"70.9","black":"19.9","asian":"2.9","hispanicOrLatino":"31.2"}},"wageData":{"2017":{"workers":"131","median":"401","maleWorkers":"111","maleMedian":"408","femaleWorkers":"19","femaleMedian":"-"}}},"Hosts and hostesses, restaurant, lounge, and coffee shop":{"ageData":{"2017":{"total":"324","16to19":"149","20to24":"88","25to34":"38","35to44":"13","45to54":"10","55to64":"17","65+":"10","medianAge":"17"}},"title":"Hosts and hostesses, restaurant, lounge, and coffee shop","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2017":{"total":"324","women":"85.9","white":"74.8","black":"12.9","asian":"3.3","hispanicOrLatino":"17.1"}},"wageData":{"2017":{"workers":"67","median":"401","maleWorkers":"9","maleMedian":"-","femaleWorkers":"58","femaleMedian":"400"}}},"Food preparation and serving related workers, all other":{"ageData":{"2017":{"total":"4","16to19":"0","20to24":"2","25to34":"1","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Food preparation and serving related workers, all other","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2017":{"total":"4","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Building and grounds cleaning and maintenance occupations":{"ageData":{"2017":{"total":"5,888","16to19":"200","20to24":"451","25to34":"1,099","35to44":"1,236","45to54":"1,338","55to64":"1,183","65+":"381","medianAge":"1,183"}},"title":"Building and grounds cleaning and maintenance occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2017":{"total":"5,888","women":"40.7","white":"77.4","black":"14.9","asian":"3.3","hispanicOrLatino":"38.0"}},"wageData":{"2017":{"workers":"3,641","median":"522","maleWorkers":"2,373","maleMedian":"573","femaleWorkers":"1,268","femaleMedian":"463"}}},"First-line supervisors of housekeeping and janitorial workers":{"ageData":{"2017":{"total":"326","16to19":"1","20to24":"11","25to34":"48","35to44":"75","45to54":"104","55to64":"68","65+":"20","medianAge":"68"}},"title":"First-line supervisors of housekeeping and janitorial workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2017":{"total":"326","women":"41.1","white":"79.9","black":"12.0","asian":"4.6","hispanicOrLatino":"28.5"}},"wageData":{"2017":{"workers":"190","median":"661","maleWorkers":"113","maleMedian":"749","femaleWorkers":"77","femaleMedian":"515"}}},"First-line supervisors of landscaping, lawn service, and groundskeeping workers":{"ageData":{"2017":{"total":"255","16to19":"1","20to24":"16","25to34":"48","35to44":"67","45to54":"60","55to64":"50","65+":"13","medianAge":"50"}},"title":"First-line supervisors of landscaping, lawn service, and groundskeeping workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2017":{"total":"255","women":"8.0","white":"91.6","black":"5.4","asian":"1.2","hispanicOrLatino":"21.5"}},"wageData":{"2017":{"workers":"111","median":"723","maleWorkers":"102","maleMedian":"760","femaleWorkers":"9","femaleMedian":"-"}}},"Janitors and building cleaners":{"ageData":{"2017":{"total":"2,307","16to19":"87","20to24":"176","25to34":"364","35to44":"402","45to54":"526","55to64":"562","65+":"191","medianAge":"562"}},"title":"Janitors and building cleaners","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2017":{"total":"2,307","women":"35.2","white":"72.5","black":"18.6","asian":"3.8","hispanicOrLatino":"31.7"}},"wageData":{"2017":{"workers":"1,595","median":"539","maleWorkers":"1,136","maleMedian":"574","femaleWorkers":"459","femaleMedian":"481"}}},"Maids and housekeeping cleaners":{"ageData":{"2017":{"total":"1,527","16to19":"34","20to24":"91","25to34":"253","35to44":"397","45to54":"359","55to64":"302","65+":"91","medianAge":"302"}},"title":"Maids and housekeeping cleaners","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2017":{"total":"1,527","women":"88.0","white":"74.3","black":"17.9","asian":"3.9","hispanicOrLatino":"49.4"}},"wageData":{"2017":{"workers":"815","median":"450","maleWorkers":"128","maleMedian":"508","femaleWorkers":"687","femaleMedian":"439"}}},"Pest control workers":{"ageData":{"2017":{"total":"108","16to19":"1","20to24":"12","25to34":"32","35to44":"19","45to54":"23","55to64":"21","65+":"2","medianAge":"21"}},"title":"Pest control workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2017":{"total":"108","women":"6.5","white":"82.0","black":"11.4","asian":"1.4","hispanicOrLatino":"13.3"}},"wageData":{"2017":{"workers":"94","median":"616","maleWorkers":"89","maleMedian":"617","femaleWorkers":"5","femaleMedian":"-"}}},"Grounds maintenance workers":{"ageData":{"2017":{"total":"1,365","16to19":"78","20to24":"147","25to34":"355","35to44":"276","45to54":"266","55to64":"179","65+":"64","medianAge":"179"}},"title":"Grounds maintenance workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2017":{"total":"1,365","women":"5.9","white":"85.6","black":"7.9","asian":"2.0","hispanicOrLatino":"43.1"}},"wageData":{"2017":{"workers":"837","median":"525","maleWorkers":"805","maleMedian":"526","femaleWorkers":"31","femaleMedian":"-"}}},"Personal care and service occupations":{"ageData":{"2017":{"total":"5,939","16to19":"357","20to24":"824","25to34":"1,271","35to44":"1,079","45to54":"1,094","55to64":"876","65+":"439","medianAge":"876"}},"title":"Personal care and service occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2017":{"total":"5,939","women":"76.1","white":"69.5","black":"16.1","asian":"10.2","hispanicOrLatino":"17.1"}},"wageData":{"2017":{"workers":"2,699","median":"520","maleWorkers":"728","maleMedian":"612","femaleWorkers":"1,971","femaleMedian":"503"}}},"First-line supervisors of gaming workers":{"ageData":{"2017":{"total":"208","16to19":"6","20to24":"17","25to34":"55","35to44":"47","45to54":"45","55to64":"21","65+":"17","medianAge":"21"}},"title":"First-line supervisors of gaming workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2017":{"total":"208","women":"44.3","white":"82.4","black":"7.7","asian":"4.7","hispanicOrLatino":"6.8"}},"wageData":{"2017":{"workers":"126","median":"797","maleWorkers":"73","maleMedian":"837","femaleWorkers":"53","femaleMedian":"763"}}},"First-line supervisors of personal service workers":{"ageData":{"2017":{"total":"232","16to19":"0","20to24":"10","25to34":"49","35to44":"68","45to54":"57","55to64":"34","65+":"15","medianAge":"34"}},"title":"First-line supervisors of personal service workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2017":{"total":"232","women":"66.2","white":"63.8","black":"15.4","asian":"18.8","hispanicOrLatino":"11.1"}},"wageData":{"2017":{"workers":"76","median":"619","maleWorkers":"31","maleMedian":"-","femaleWorkers":"45","femaleMedian":"-"}}},"Animal trainers":{"ageData":{"2017":{"total":"49","16to19":"1","20to24":"7","25to34":"12","35to44":"8","45to54":"9","55to64":"8","65+":"3","medianAge":"8"}},"title":"Animal trainers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2017":{"total":"49","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"23","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Nonfarm animal caretakers":{"ageData":{"2017":{"total":"263","16to19":"29","20to24":"67","25to34":"52","35to44":"44","45to54":"31","55to64":"27","65+":"12","medianAge":"27"}},"title":"Nonfarm animal caretakers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2017":{"total":"263","women":"78.4","white":"90.8","black":"2.8","asian":"1.6","hispanicOrLatino":"13.6"}},"wageData":{"2017":{"workers":"99","median":"506","maleWorkers":"21","maleMedian":"-","femaleWorkers":"78","femaleMedian":"504"}}},"Gaming services workers":{"ageData":{"2017":{"total":"90","16to19":"4","20to24":"4","25to34":"21","35to44":"19","45to54":"19","55to64":"15","65+":"8","medianAge":"15"}},"title":"Gaming services workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2017":{"total":"90","women":"46.7","white":"45.1","black":"8.9","asian":"34.0","hispanicOrLatino":"10.2"}},"wageData":{"2017":{"workers":"66","median":"692","maleWorkers":"37","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Motion picture projectionists":{"ageData":{"2017":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Motion picture projectionists","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2017":{"total":"1","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Ushers, lobby attendants, and ticket takers":{"ageData":{"2017":{"total":"37","16to19":"14","20to24":"7","25to34":"5","35to44":"2","45to54":"2","55to64":"3","65+":"5","medianAge":"3"}},"title":"Ushers, lobby attendants, and ticket takers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2017":{"total":"37","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"8","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Miscellaneous entertainment attendants and related workers":{"ageData":{"2017":{"total":"224","16to19":"60","20to24":"54","25to34":"37","35to44":"14","45to54":"17","55to64":"20","65+":"21","medianAge":"20"}},"title":"Miscellaneous entertainment attendants and related workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2017":{"total":"224","women":"42.9","white":"75.9","black":"16.1","asian":"1.8","hispanicOrLatino":"18.6"}},"wageData":{"2017":{"workers":"74","median":"517","maleWorkers":"39","maleMedian":"-","femaleWorkers":"36","femaleMedian":"-"}}},"Embalmers and funeral attendants":{"ageData":{"2017":{"total":"17","16to19":"1","20to24":"2","25to34":"0","35to44":"1","45to54":"4","55to64":"4","65+":"6","medianAge":"4"}},"title":"Embalmers and funeral attendants","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2017":{"total":"17","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"15","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Morticians, undertakers, and funeral directors":{"ageData":{"2017":{"total":"42","16to19":"0","20to24":"0","25to34":"5","35to44":"9","45to54":"8","55to64":"12","65+":"8","medianAge":"12"}},"title":"Morticians, undertakers, and funeral directors","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2017":{"total":"42","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"22","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Barbers":{"ageData":{"2017":{"total":"135","16to19":"0","20to24":"9","25to34":"42","35to44":"32","45to54":"21","55to64":"15","65+":"17","medianAge":"15"}},"title":"Barbers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2017":{"total":"135","women":"15.6","white":"50.7","black":"38.1","asian":"5.1","hispanicOrLatino":"24.1"}},"wageData":{"2017":{"workers":"54","median":"590","maleWorkers":"47","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Hairdressers, hairstylists, and cosmetologists":{"ageData":{"2017":{"total":"806","16to19":"14","20to24":"79","25to34":"231","35to44":"156","45to54":"162","55to64":"98","65+":"67","medianAge":"98"}},"title":"Hairdressers, hairstylists, and cosmetologists","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2017":{"total":"806","women":"92.6","white":"76.7","black":"13.5","asian":"5.6","hispanicOrLatino":"16.3"}},"wageData":{"2017":{"workers":"324","median":"528","maleWorkers":"22","maleMedian":"-","femaleWorkers":"302","femaleMedian":"521"}}},"Miscellaneous personal appearance workers":{"ageData":{"2017":{"total":"397","16to19":"5","20to24":"39","25to34":"76","35to44":"115","45to54":"104","55to64":"47","65+":"12","medianAge":"47"}},"title":"Miscellaneous personal appearance workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2017":{"total":"397","women":"81.8","white":"27.2","black":"8.3","asian":"62.3","hispanicOrLatino":"9.1"}},"wageData":{"2017":{"workers":"235","median":"567","maleWorkers":"48","maleMedian":"-","femaleWorkers":"187","femaleMedian":"538"}}},"Baggage porters, bellhops, and concierges":{"ageData":{"2017":{"total":"89","16to19":"2","20to24":"18","25to34":"23","35to44":"13","45to54":"13","55to64":"12","65+":"7","medianAge":"12"}},"title":"Baggage porters, bellhops, and concierges","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2017":{"total":"89","women":"31.1","white":"60.1","black":"24.9","asian":"8.3","hispanicOrLatino":"27.5"}},"wageData":{"2017":{"workers":"70","median":"547","maleWorkers":"56","maleMedian":"543","femaleWorkers":"14","femaleMedian":"-"}}},"Tour and travel guides":{"ageData":{"2017":{"total":"68","16to19":"6","20to24":"15","25to34":"11","35to44":"8","45to54":"4","55to64":"14","65+":"10","medianAge":"14"}},"title":"Tour and travel guides","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2017":{"total":"68","women":"46.4","white":"81.2","black":"4.5","asian":"5.3","hispanicOrLatino":"8.8"}},"wageData":{"2017":{"workers":"21","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Childcare workers":{"ageData":{"2017":{"total":"1,225","16to19":"131","20to24":"222","25to34":"240","35to44":"180","45to54":"209","55to64":"182","65+":"60","medianAge":"182"}},"title":"Childcare workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2017":{"total":"1,225","women":"93.7","white":"77.3","black":"15.4","asian":"4.3","hispanicOrLatino":"22.3"}},"wageData":{"2017":{"workers":"448","median":"482","maleWorkers":"35","maleMedian":"-","femaleWorkers":"413","femaleMedian":"474"}}},"Personal care aides":{"ageData":{"2017":{"total":"1,365","16to19":"38","20to24":"148","25to34":"253","35to44":"238","45to54":"275","55to64":"274","65+":"140","medianAge":"274"}},"title":"Personal care aides","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2017":{"total":"1,365","women":"83.7","white":"62.0","black":"24.8","asian":"9.1","hispanicOrLatino":"20.7"}},"wageData":{"2017":{"workers":"735","median":"486","maleWorkers":"127","maleMedian":"520","femaleWorkers":"608","femaleMedian":"479"}}},"Recreation and fitness workers":{"ageData":{"2017":{"total":"480","16to19":"38","20to24":"82","25to34":"104","35to44":"91","45to54":"82","55to64":"60","65+":"23","medianAge":"60"}},"title":"Recreation and fitness workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2017":{"total":"480","women":"62.3","white":"80.1","black":"11.4","asian":"3.5","hispanicOrLatino":"9.6"}},"wageData":{"2017":{"workers":"200","median":"616","maleWorkers":"82","maleMedian":"726","femaleWorkers":"118","femaleMedian":"565"}}},"Residential advisors":{"ageData":{"2017":{"total":"44","16to19":"1","20to24":"15","25to34":"12","35to44":"2","45to54":"9","55to64":"4","65+":"0","medianAge":"4"}},"title":"Residential advisors","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2017":{"total":"44","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"27","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Personal care and service workers, all other":{"ageData":{"2017":{"total":"167","16to19":"7","20to24":"31","25to34":"42","35to44":"33","45to54":"19","55to64":"24","65+":"11","medianAge":"24"}},"title":"Personal care and service workers, all other","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2017":{"total":"167","women":"60.1","white":"74.6","black":"14.6","asian":"4.9","hispanicOrLatino":"17.8"}},"wageData":{"2017":{"workers":"76","median":"570","maleWorkers":"37","maleMedian":"-","femaleWorkers":"40","femaleMedian":"-"}}},"Sales and office occupations":{"ageData":{"2017":{"total":"33,566","16to19":"1,715","20to24":"4,071","25to34":"7,186","35to44":"5,974","45to54":"6,582","55to64":"5,761","65+":"2,277","medianAge":"5,761"}},"title":"Sales and office occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2017":{"total":"33,566","women":"61.3","white":"78.5","black":"13.0","asian":"5.0","hispanicOrLatino":"15.9"}},"wageData":{"2017":{"workers":"23,686","median":"718","maleWorkers":"9,481","maleMedian":"834","femaleWorkers":"14,205","femaleMedian":"672"}}},"Sales and related occupations":{"ageData":{"2017":{"total":"15,815","16to19":"1,167","20to24":"2,074","25to34":"3,292","35to44":"2,723","45to54":"2,879","55to64":"2,507","65+":"1,174","medianAge":"2,507"}},"title":"Sales and related occupations","depth":2,"parent":"Sales and office occupations","sexRaceEthnicityData":{"2017":{"total":"15,815","women":"49.1","white":"79.9","black":"11.1","asian":"5.6","hispanicOrLatino":"15.9"}},"wageData":{"2017":{"workers":"9,953","median":"763","maleWorkers":"5,598","maleMedian":"934","femaleWorkers":"4,355","femaleMedian":"609"}}},"First-line supervisors of retail sales workers":{"ageData":{"2017":{"total":"3,272","16to19":"35","20to24":"256","25to34":"823","35to44":"699","45to54":"677","55to64":"568","65+":"214","medianAge":"568"}},"title":"First-line supervisors of retail sales workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2017":{"total":"3,272","women":"43.4","white":"81.6","black":"9.4","asian":"6.2","hispanicOrLatino":"15.0"}},"wageData":{"2017":{"workers":"2,388","median":"764","maleWorkers":"1,376","maleMedian":"891","femaleWorkers":"1,013","femaleMedian":"639"}}},"First-line supervisors of non-retail sales workers":{"ageData":{"2017":{"total":"1,220","16to19":"5","20to24":"43","25to34":"212","35to44":"260","45to54":"325","55to64":"265","65+":"109","medianAge":"265"}},"title":"First-line supervisors of non-retail sales workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2017":{"total":"1,220","women":"30.0","white":"84.6","black":"6.8","asian":"5.4","hispanicOrLatino":"13.3"}},"wageData":{"2017":{"workers":"815","median":"1,062","maleWorkers":"541","maleMedian":"1,151","femaleWorkers":"274","femaleMedian":"965"}}},"Cashiers":{"ageData":{"2017":{"total":"3,253","16to19":"777","20to24":"798","25to34":"590","35to44":"335","45to54":"304","55to64":"285","65+":"163","medianAge":"285"}},"title":"Cashiers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2017":{"total":"3,253","women":"72.7","white":"70.2","black":"17.9","asian":"6.4","hispanicOrLatino":"22.3"}},"wageData":{"2017":{"workers":"1,360","median":"438","maleWorkers":"378","maleMedian":"493","femaleWorkers":"982","femaleMedian":"422"}}},"Counter and rental clerks":{"ageData":{"2017":{"total":"109","16to19":"11","20to24":"14","25to34":"27","35to44":"18","45to54":"20","55to64":"13","65+":"6","medianAge":"13"}},"title":"Counter and rental clerks","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2017":{"total":"109","women":"48.9","white":"78.4","black":"12.7","asian":"7.0","hispanicOrLatino":"18.6"}},"wageData":{"2017":{"workers":"78","median":"607","maleWorkers":"48","maleMedian":"-","femaleWorkers":"31","femaleMedian":"-"}}},"Parts salespersons":{"ageData":{"2017":{"total":"130","16to19":"5","20to24":"13","25to34":"28","35to44":"24","45to54":"25","55to64":"26","65+":"8","medianAge":"26"}},"title":"Parts salespersons","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2017":{"total":"130","women":"7.2","white":"88.8","black":"4.5","asian":"2.5","hispanicOrLatino":"21.9"}},"wageData":{"2017":{"workers":"115","median":"786","maleWorkers":"108","maleMedian":"800","femaleWorkers":"7","femaleMedian":"-"}}},"Retail salespersons":{"ageData":{"2017":{"total":"3,235","16to19":"292","20to24":"649","25to34":"651","35to44":"455","45to54":"488","55to64":"463","65+":"237","medianAge":"463"}},"title":"Retail salespersons","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2017":{"total":"3,235","women":"48.2","white":"77.6","black":"12.8","asian":"5.7","hispanicOrLatino":"17.2"}},"wageData":{"2017":{"workers":"1,896","median":"615","maleWorkers":"1,160","maleMedian":"704","femaleWorkers":"736","femaleMedian":"523"}}},"Advertising sales agents":{"ageData":{"2017":{"total":"241","16to19":"3","20to24":"30","25to34":"77","35to44":"52","45to54":"41","55to64":"29","65+":"9","medianAge":"29"}},"title":"Advertising sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2017":{"total":"241","women":"50.4","white":"80.7","black":"14.8","asian":"3.9","hispanicOrLatino":"10.6"}},"wageData":{"2017":{"workers":"193","median":"887","maleWorkers":"87","maleMedian":"895","femaleWorkers":"106","femaleMedian":"882"}}},"Insurance sales agents":{"ageData":{"2017":{"total":"624","16to19":"4","20to24":"33","25to34":"123","35to44":"131","45to54":"142","55to64":"127","65+":"65","medianAge":"127"}},"title":"Insurance sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2017":{"total":"624","women":"51.8","white":"81.3","black":"10.0","asian":"5.9","hispanicOrLatino":"11.9"}},"wageData":{"2017":{"workers":"440","median":"897","maleWorkers":"198","maleMedian":"1,058","femaleWorkers":"242","femaleMedian":"795"}}},"Securities, commodities, and financial services sales agents":{"ageData":{"2017":{"total":"262","16to19":"2","20to24":"10","25to34":"59","35to44":"65","45to54":"68","55to64":"43","65+":"15","medianAge":"43"}},"title":"Securities, commodities, and financial services sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2017":{"total":"262","women":"34.0","white":"85.8","black":"6.0","asian":"5.1","hispanicOrLatino":"10.3"}},"wageData":{"2017":{"workers":"231","median":"1,332","maleWorkers":"154","maleMedian":"1,416","femaleWorkers":"77","femaleMedian":"911"}}},"Travel agents":{"ageData":{"2017":{"total":"89","16to19":"0","20to24":"6","25to34":"17","35to44":"16","45to54":"15","55to64":"17","65+":"17","medianAge":"17"}},"title":"Travel agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2017":{"total":"89","women":"82.7","white":"81.9","black":"11.2","asian":"6.4","hispanicOrLatino":"13.0"}},"wageData":{"2017":{"workers":"57","median":"665","maleWorkers":"10","maleMedian":"-","femaleWorkers":"47","femaleMedian":"-"}}},"Sales representatives, services, all other":{"ageData":{"2017":{"total":"525","16to19":"4","20to24":"52","25to34":"148","35to44":"108","45to54":"102","55to64":"87","65+":"23","medianAge":"87"}},"title":"Sales representatives, services, all other","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2017":{"total":"525","women":"27.1","white":"88.5","black":"6.4","asian":"3.2","hispanicOrLatino":"12.9"}},"wageData":{"2017":{"workers":"458","median":"1,147","maleWorkers":"339","maleMedian":"1,332","femaleWorkers":"120","femaleMedian":"902"}}},"Sales representatives, wholesale and manufacturing":{"ageData":{"2017":{"total":"1,264","16to19":"11","20to24":"76","25to34":"265","35to44":"257","45to54":"300","55to64":"271","65+":"84","medianAge":"271"}},"title":"Sales representatives, wholesale and manufacturing","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2017":{"total":"1,264","women":"28.0","white":"89.9","black":"4.6","asian":"3.7","hispanicOrLatino":"10.1"}},"wageData":{"2017":{"workers":"1,105","median":"1,157","maleWorkers":"796","maleMedian":"1,222","femaleWorkers":"308","femaleMedian":"956"}}},"Models, demonstrators, and product promoters":{"ageData":{"2017":{"total":"61","16to19":"2","20to24":"9","25to34":"8","35to44":"9","45to54":"10","55to64":"11","65+":"12","medianAge":"11"}},"title":"Models, demonstrators, and product promoters","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2017":{"total":"61","women":"78.4","white":"82.4","black":"6.0","asian":"8.7","hispanicOrLatino":"12.8"}},"wageData":{"2017":{"workers":"16","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Real estate brokers and sales agents":{"ageData":{"2017":{"total":"997","16to19":"4","20to24":"30","25to34":"145","35to44":"194","45to54":"240","55to64":"216","65+":"169","medianAge":"216"}},"title":"Real estate brokers and sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2017":{"total":"997","women":"57.1","white":"85.7","black":"7.2","asian":"4.8","hispanicOrLatino":"11.5"}},"wageData":{"2017":{"workers":"488","median":"953","maleWorkers":"219","maleMedian":"1,159","femaleWorkers":"269","femaleMedian":"818"}}},"Sales engineers":{"ageData":{"2017":{"total":"35","16to19":"0","20to24":"1","25to34":"7","35to44":"6","45to54":"13","55to64":"6","65+":"2","medianAge":"6"}},"title":"Sales engineers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2017":{"total":"35","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"39","median":"-","maleWorkers":"36","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Telemarketers":{"ageData":{"2017":{"total":"58","16to19":"3","20to24":"9","25to34":"20","35to44":"9","45to54":"8","55to64":"6","65+":"3","medianAge":"6"}},"title":"Telemarketers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2017":{"total":"58","women":"69.4","white":"61.3","black":"24.7","asian":"7.0","hispanicOrLatino":"25.8"}},"wageData":{"2017":{"workers":"37","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"27","femaleMedian":"-"}}},"Door-to-door sales workers, news and street vendors, and related workers":{"ageData":{"2017":{"total":"166","16to19":"4","20to24":"11","25to34":"35","35to44":"30","45to54":"43","55to64":"26","65+":"18","medianAge":"26"}},"title":"Door-to-door sales workers, news and street vendors, and related workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2017":{"total":"166","women":"58.4","white":"82.9","black":"11.0","asian":"5.4","hispanicOrLatino":"22.0"}},"wageData":{"2017":{"workers":"41","median":"-","maleWorkers":"27","maleMedian":"-","femaleWorkers":"15","femaleMedian":"-"}}},"Sales and related workers, all other":{"ageData":{"2017":{"total":"276","16to19":"4","20to24":"34","25to34":"58","35to44":"56","45to54":"58","55to64":"48","65+":"18","medianAge":"48"}},"title":"Sales and related workers, all other","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2017":{"total":"276","women":"50.3","white":"84.2","black":"9.5","asian":"4.9","hispanicOrLatino":"8.1"}},"wageData":{"2017":{"workers":"195","median":"971","maleWorkers":"107","maleMedian":"1,147","femaleWorkers":"89","femaleMedian":"799"}}},"Office and administrative support occupations":{"ageData":{"2017":{"total":"17,751","16to19":"548","20to24":"1,997","25to34":"3,895","35to44":"3,251","45to54":"3,703","55to64":"3,254","65+":"1,104","medianAge":"3,254"}},"title":"Office and administrative support occupations","depth":2,"parent":"Sales and office occupations","sexRaceEthnicityData":{"2017":{"total":"17,751","women":"72.2","white":"77.3","black":"14.6","asian":"4.5","hispanicOrLatino":"15.9"}},"wageData":{"2017":{"workers":"13,733","median":"701","maleWorkers":"3,884","maleMedian":"735","femaleWorkers":"9,850","femaleMedian":"691"}}},"First-line supervisors of office and administrative support workers":{"ageData":{"2017":{"total":"1,425","16to19":"3","20to24":"58","25to34":"300","35to44":"326","45to54":"378","55to64":"279","65+":"80","medianAge":"279"}},"title":"First-line supervisors of office and administrative support workers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"1,425","women":"70.1","white":"80.3","black":"13.4","asian":"4.0","hispanicOrLatino":"11.6"}},"wageData":{"2017":{"workers":"1,261","median":"867","maleWorkers":"408","maleMedian":"987","femaleWorkers":"854","femaleMedian":"819"}}},"Switchboard operators, including answering service":{"ageData":{"2017":{"total":"23","16to19":"1","20to24":"0","25to34":"6","35to44":"5","45to54":"3","55to64":"2","65+":"5","medianAge":"2"}},"title":"Switchboard operators, including answering service","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"23","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"16","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Telephone operators":{"ageData":{"2017":{"total":"47","16to19":"0","20to24":"12","25to34":"11","35to44":"9","45to54":"7","55to64":"5","65+":"3","medianAge":"5"}},"title":"Telephone operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"47","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"35","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"27","femaleMedian":"-"}}},"Communications equipment operators, all other":{"ageData":{"2017":{"total":"9","16to19":"0","20to24":"0","25to34":"3","35to44":"1","45to54":"4","55to64":"2","65+":"0","medianAge":"2"}},"title":"Communications equipment operators, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"9","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"5","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Bill and account collectors":{"ageData":{"2017":{"total":"139","16to19":"3","20to24":"19","25to34":"35","35to44":"33","45to54":"25","55to64":"15","65+":"10","medianAge":"15"}},"title":"Bill and account collectors","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"139","women":"71.3","white":"70.7","black":"22.9","asian":"3.1","hispanicOrLatino":"18.9"}},"wageData":{"2017":{"workers":"130","median":"674","maleWorkers":"38","maleMedian":"-","femaleWorkers":"92","femaleMedian":"655"}}},"Billing and posting clerks":{"ageData":{"2017":{"total":"473","16to19":"4","20to24":"31","25to34":"110","35to44":"102","45to54":"115","55to64":"92","65+":"19","medianAge":"92"}},"title":"Billing and posting clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"473","women":"85.9","white":"79.4","black":"13.6","asian":"3.8","hispanicOrLatino":"13.1"}},"wageData":{"2017":{"workers":"405","median":"696","maleWorkers":"58","maleMedian":"718","femaleWorkers":"347","femaleMedian":"691"}}},"Bookkeeping, accounting, and auditing clerks":{"ageData":{"2017":{"total":"1,089","16to19":"5","20to24":"59","25to34":"146","35to44":"204","45to54":"273","55to64":"268","65+":"135","medianAge":"268"}},"title":"Bookkeeping, accounting, and auditing clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"1,089","women":"88.7","white":"87.4","black":"6.9","asian":"3.7","hispanicOrLatino":"11.3"}},"wageData":{"2017":{"workers":"718","median":"719","maleWorkers":"92","maleMedian":"743","femaleWorkers":"625","femaleMedian":"716"}}},"Gaming cage workers":{"ageData":{"2017":{"total":"14","16to19":"0","20to24":"1","25to34":"3","35to44":"4","45to54":"6","55to64":"1","65+":"0","medianAge":"1"}},"title":"Gaming cage workers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"14","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"11","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Payroll and timekeeping clerks":{"ageData":{"2017":{"total":"129","16to19":"0","20to24":"6","25to34":"25","35to44":"27","45to54":"31","55to64":"31","65+":"9","medianAge":"31"}},"title":"Payroll and timekeeping clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"129","women":"89.5","white":"75.6","black":"14.3","asian":"4.2","hispanicOrLatino":"17.7"}},"wageData":{"2017":{"workers":"103","median":"765","maleWorkers":"13","maleMedian":"-","femaleWorkers":"89","femaleMedian":"767"}}},"Procurement clerks":{"ageData":{"2017":{"total":"30","16to19":"0","20to24":"2","25to34":"7","35to44":"6","45to54":"4","55to64":"9","65+":"2","medianAge":"9"}},"title":"Procurement clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"30","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"29","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"15","femaleMedian":"-"}}},"Tellers":{"ageData":{"2017":{"total":"306","16to19":"13","20to24":"73","25to34":"96","35to44":"41","45to54":"30","55to64":"41","65+":"13","medianAge":"41"}},"title":"Tellers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"306","women":"85.2","white":"79.9","black":"12.6","asian":"5.0","hispanicOrLatino":"16.4"}},"wageData":{"2017":{"workers":"209","median":"572","maleWorkers":"25","maleMedian":"-","femaleWorkers":"184","femaleMedian":"562"}}},"Financial clerks, all other":{"ageData":{"2017":{"total":"82","16to19":"0","20to24":"7","25to34":"18","35to44":"24","45to54":"17","55to64":"12","65+":"4","medianAge":"12"}},"title":"Financial clerks, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"82","women":"60.8","white":"78.3","black":"16.0","asian":"3.9","hispanicOrLatino":"17.8"}},"wageData":{"2017":{"workers":"74","median":"902","maleWorkers":"26","maleMedian":"-","femaleWorkers":"48","femaleMedian":"-"}}},"Brokerage clerks":{"ageData":{"2017":{"total":"7","16to19":"0","20to24":"2","25to34":"0","35to44":"1","45to54":"0","55to64":"3","65+":"1","medianAge":"3"}},"title":"Brokerage clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"7","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"5","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Correspondence clerks":{"ageData":{"2017":{"total":"7","16to19":"0","20to24":"1","25to34":"1","35to44":"3","45to54":"0","55to64":"2","65+":"0","medianAge":"2"}},"title":"Correspondence clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"7","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"6","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Court, municipal, and license clerks":{"ageData":{"2017":{"total":"90","16to19":"1","20to24":"1","25to34":"13","35to44":"20","45to54":"24","55to64":"25","65+":"5","medianAge":"25"}},"title":"Court, municipal, and license clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"90","women":"75.2","white":"75.8","black":"15.6","asian":"2.0","hispanicOrLatino":"16.6"}},"wageData":{"2017":{"workers":"79","median":"738","maleWorkers":"17","maleMedian":"-","femaleWorkers":"62","femaleMedian":"718"}}},"Credit authorizers, checkers, and clerks":{"ageData":{"2017":{"total":"55","16to19":"1","20to24":"6","25to34":"14","35to44":"10","45to54":"13","55to64":"8","65+":"2","medianAge":"8"}},"title":"Credit authorizers, checkers, and clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"55","women":"63.8","white":"90.5","black":"3.2","asian":"5.7","hispanicOrLatino":"17.3"}},"wageData":{"2017":{"workers":"50","median":"807","maleWorkers":"20","maleMedian":"-","femaleWorkers":"31","femaleMedian":"-"}}},"Customer service representatives":{"ageData":{"2017":{"total":"2,494","16to19":"163","20to24":"401","25to34":"667","35to44":"413","45to54":"423","55to64":"319","65+":"108","medianAge":"319"}},"title":"Customer service representatives","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"2,494","women":"65.1","white":"73.2","black":"17.2","asian":"5.4","hispanicOrLatino":"17.4"}},"wageData":{"2017":{"workers":"1,881","median":"654","maleWorkers":"646","maleMedian":"712","femaleWorkers":"1,234","femaleMedian":"637"}}},"Eligibility interviewers, government programs":{"ageData":{"2017":{"total":"62","16to19":"0","20to24":"2","25to34":"13","35to44":"15","45to54":"19","55to64":"13","65+":"1","medianAge":"13"}},"title":"Eligibility interviewers, government programs","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"62","women":"76.7","white":"58.8","black":"26.8","asian":"10.0","hispanicOrLatino":"21.9"}},"wageData":{"2017":{"workers":"66","median":"849","maleWorkers":"16","maleMedian":"-","femaleWorkers":"50","femaleMedian":"779"}}},"File clerks":{"ageData":{"2017":{"total":"182","16to19":"16","20to24":"21","25to34":"34","35to44":"34","45to54":"30","55to64":"34","65+":"13","medianAge":"34"}},"title":"File clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"182","women":"81.4","white":"77.2","black":"13.6","asian":"6.9","hispanicOrLatino":"17.8"}},"wageData":{"2017":{"workers":"135","median":"704","maleWorkers":"26","maleMedian":"-","femaleWorkers":"109","femaleMedian":"706"}}},"Hotel, motel, and resort desk clerks":{"ageData":{"2017":{"total":"125","16to19":"8","20to24":"29","25to34":"36","35to44":"20","45to54":"12","55to64":"13","65+":"6","medianAge":"13"}},"title":"Hotel, motel, and resort desk clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"125","women":"60.9","white":"64.8","black":"21.5","asian":"7.8","hispanicOrLatino":"15.7"}},"wageData":{"2017":{"workers":"84","median":"486","maleWorkers":"35","maleMedian":"-","femaleWorkers":"49","femaleMedian":"-"}}},"Interviewers, except eligibility and loan":{"ageData":{"2017":{"total":"142","16to19":"1","20to24":"21","25to34":"31","35to44":"30","45to54":"23","55to64":"26","65+":"10","medianAge":"26"}},"title":"Interviewers, except eligibility and loan","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"142","women":"85.0","white":"71.9","black":"18.0","asian":"2.8","hispanicOrLatino":"21.2"}},"wageData":{"2017":{"workers":"106","median":"671","maleWorkers":"16","maleMedian":"-","femaleWorkers":"89","femaleMedian":"683"}}},"Library assistants, clerical":{"ageData":{"2017":{"total":"96","16to19":"5","20to24":"15","25to34":"14","35to44":"15","45to54":"13","55to64":"22","65+":"12","medianAge":"22"}},"title":"Library assistants, clerical","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"96","women":"80.1","white":"81.3","black":"8.6","asian":"5.1","hispanicOrLatino":"10.4"}},"wageData":{"2017":{"workers":"45","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"37","femaleMedian":"-"}}},"Loan interviewers and clerks":{"ageData":{"2017":{"total":"120","16to19":"0","20to24":"7","25to34":"34","35to44":"26","45to54":"22","55to64":"28","65+":"3","medianAge":"28"}},"title":"Loan interviewers and clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"120","women":"80.4","white":"77.6","black":"15.3","asian":"5.1","hispanicOrLatino":"14.6"}},"wageData":{"2017":{"workers":"114","median":"742","maleWorkers":"19","maleMedian":"-","femaleWorkers":"95","femaleMedian":"725"}}},"New accounts clerks":{"ageData":{"2017":{"total":"32","16to19":"0","20to24":"2","25to34":"10","35to44":"10","45to54":"2","55to64":"7","65+":"1","medianAge":"7"}},"title":"New accounts clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"32","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"36","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Order clerks":{"ageData":{"2017":{"total":"107","16to19":"3","20to24":"12","25to34":"27","35to44":"24","45to54":"23","55to64":"15","65+":"4","medianAge":"15"}},"title":"Order clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"107","women":"54.9","white":"66.2","black":"18.8","asian":"8.0","hispanicOrLatino":"14.4"}},"wageData":{"2017":{"workers":"80","median":"629","maleWorkers":"38","maleMedian":"-","femaleWorkers":"42","femaleMedian":"-"}}},"Human resources assistants, except payroll and timekeeping":{"ageData":{"2017":{"total":"45","16to19":"1","20to24":"2","25to34":"14","35to44":"13","45to54":"12","55to64":"4","65+":"1","medianAge":"4"}},"title":"Human resources assistants, except payroll and timekeeping","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"45","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"45","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"37","femaleMedian":"-"}}},"Receptionists and information clerks":{"ageData":{"2017":{"total":"1,267","16to19":"60","20to24":"224","25to34":"313","35to44":"185","45to54":"196","55to64":"199","65+":"91","medianAge":"199"}},"title":"Receptionists and information clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"1,267","women":"91.0","white":"79.9","black":"12.8","asian":"3.5","hispanicOrLatino":"19.7"}},"wageData":{"2017":{"workers":"892","median":"602","maleWorkers":"66","maleMedian":"652","femaleWorkers":"826","femaleMedian":"599"}}},"Reservation and transportation ticket agents and travel clerks":{"ageData":{"2017":{"total":"127","16to19":"1","20to24":"15","25to34":"29","35to44":"23","45to54":"30","55to64":"23","65+":"6","medianAge":"23"}},"title":"Reservation and transportation ticket agents and travel clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"127","women":"58.0","white":"60.8","black":"25.3","asian":"5.9","hispanicOrLatino":"15.1"}},"wageData":{"2017":{"workers":"99","median":"739","maleWorkers":"43","maleMedian":"-","femaleWorkers":"56","femaleMedian":"691"}}},"Information and record clerks, all other":{"ageData":{"2017":{"total":"110","16to19":"2","20to24":"13","25to34":"27","35to44":"21","45to54":"18","55to64":"23","65+":"6","medianAge":"23"}},"title":"Information and record clerks, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"110","women":"78.1","white":"75.5","black":"10.1","asian":"5.2","hispanicOrLatino":"15.0"}},"wageData":{"2017":{"workers":"92","median":"691","maleWorkers":"19","maleMedian":"-","femaleWorkers":"74","femaleMedian":"683"}}},"Cargo and freight agents":{"ageData":{"2017":{"total":"16","16to19":"0","20to24":"1","25to34":"6","35to44":"5","45to54":"2","55to64":"1","65+":"1","medianAge":"1"}},"title":"Cargo and freight agents","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"16","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"14","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Couriers and messengers":{"ageData":{"2017":{"total":"239","16to19":"4","20to24":"19","25to34":"60","35to44":"38","45to54":"62","55to64":"37","65+":"19","medianAge":"37"}},"title":"Couriers and messengers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"239","women":"19.4","white":"67.3","black":"25.5","asian":"5.5","hispanicOrLatino":"18.1"}},"wageData":{"2017":{"workers":"155","median":"725","maleWorkers":"131","maleMedian":"751","femaleWorkers":"24","femaleMedian":"-"}}},"Dispatchers":{"ageData":{"2017":{"total":"292","16to19":"2","20to24":"29","25to34":"80","35to44":"67","45to54":"62","55to64":"41","65+":"10","medianAge":"41"}},"title":"Dispatchers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"292","women":"57.4","white":"81.7","black":"11.6","asian":"2.0","hispanicOrLatino":"16.9"}},"wageData":{"2017":{"workers":"255","median":"710","maleWorkers":"110","maleMedian":"753","femaleWorkers":"145","femaleMedian":"691"}}},"Meter readers, utilities":{"ageData":{"2017":{"total":"18","16to19":"1","20to24":"1","25to34":"5","35to44":"3","45to54":"2","55to64":"4","65+":"2","medianAge":"4"}},"title":"Meter readers, utilities","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"18","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"14","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Postal service clerks":{"ageData":{"2017":{"total":"111","16to19":"0","20to24":"2","25to34":"17","35to44":"18","45to54":"31","55to64":"40","65+":"3","medianAge":"40"}},"title":"Postal service clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"111","women":"55.3","white":"70.8","black":"22.4","asian":"4.8","hispanicOrLatino":"15.9"}},"wageData":{"2017":{"workers":"104","median":"940","maleWorkers":"48","maleMedian":"-","femaleWorkers":"56","femaleMedian":"925"}}},"Postal service mail carriers":{"ageData":{"2017":{"total":"306","16to19":"0","20to24":"18","25to34":"67","35to44":"52","45to54":"83","55to64":"75","65+":"11","medianAge":"75"}},"title":"Postal service mail carriers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"306","women":"40.8","white":"67.4","black":"22.2","asian":"5.6","hispanicOrLatino":"14.4"}},"wageData":{"2017":{"workers":"266","median":"944","maleWorkers":"158","maleMedian":"965","femaleWorkers":"108","femaleMedian":"856"}}},"Postal service mail sorters, processors, and processing machine operators":{"ageData":{"2017":{"total":"50","16to19":"0","20to24":"6","25to34":"8","35to44":"10","45to54":"13","55to64":"11","65+":"3","medianAge":"11"}},"title":"Postal service mail sorters, processors, and processing machine operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"50","women":"56.7","white":"51.0","black":"38.4","asian":"7.9","hispanicOrLatino":"3.8"}},"wageData":{"2017":{"workers":"49","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"23","femaleMedian":"-"}}},"Production, planning, and expediting clerks":{"ageData":{"2017":{"total":"270","16to19":"2","20to24":"23","25to34":"64","35to44":"56","45to54":"76","55to64":"37","65+":"13","medianAge":"37"}},"title":"Production, planning, and expediting clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"270","women":"53.9","white":"81.6","black":"7.8","asian":"6.7","hispanicOrLatino":"9.7"}},"wageData":{"2017":{"workers":"238","median":"911","maleWorkers":"118","maleMedian":"1,043","femaleWorkers":"120","femaleMedian":"798"}}},"Shipping, receiving, and traffic clerks":{"ageData":{"2017":{"total":"623","16to19":"9","20to24":"79","25to34":"147","35to44":"141","45to54":"113","55to64":"114","65+":"20","medianAge":"114"}},"title":"Shipping, receiving, and traffic clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"623","women":"31.3","white":"72.2","black":"20.4","asian":"3.7","hispanicOrLatino":"27.0"}},"wageData":{"2017":{"workers":"544","median":"611","maleWorkers":"379","maleMedian":"616","femaleWorkers":"165","femaleMedian":"596"}}},"Stock clerks and order fillers":{"ageData":{"2017":{"total":"1,525","16to19":"160","20to24":"328","25to34":"346","35to44":"212","45to54":"227","55to64":"181","65+":"72","medianAge":"181"}},"title":"Stock clerks and order fillers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"1,525","women":"37.9","white":"74.0","black":"18.4","asian":"4.2","hispanicOrLatino":"20.6"}},"wageData":{"2017":{"workers":"982","median":"559","maleWorkers":"643","maleMedian":"571","femaleWorkers":"339","femaleMedian":"538"}}},"Weighers, measurers, checkers, and samplers, recordkeeping":{"ageData":{"2017":{"total":"52","16to19":"3","20to24":"4","25to34":"13","35to44":"12","45to54":"6","55to64":"10","65+":"4","medianAge":"10"}},"title":"Weighers, measurers, checkers, and samplers, recordkeeping","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"52","women":"46.8","white":"85.9","black":"7.4","asian":"3.5","hispanicOrLatino":"29.0"}},"wageData":{"2017":{"workers":"43","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"21","femaleMedian":"-"}}},"Secretaries and administrative assistants":{"ageData":{"2017":{"total":"2,769","16to19":"15","20to24":"161","25to34":"478","35to44":"497","45to54":"712","55to64":"685","65+":"220","medianAge":"685"}},"title":"Secretaries and administrative assistants","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"2,769","women":"95.0","white":"83.7","black":"9.3","asian":"3.6","hispanicOrLatino":"12.4"}},"wageData":{"2017":{"workers":"2,165","median":"739","maleWorkers":"119","maleMedian":"852","femaleWorkers":"2,046","femaleMedian":"735"}}},"Computer operators":{"ageData":{"2017":{"total":"73","16to19":"1","20to24":"4","25to34":"14","35to44":"12","45to54":"14","55to64":"20","65+":"9","medianAge":"20"}},"title":"Computer operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"73","women":"60.2","white":"74.8","black":"14.0","asian":"6.3","hispanicOrLatino":"7.4"}},"wageData":{"2017":{"workers":"63","median":"809","maleWorkers":"27","maleMedian":"-","femaleWorkers":"35","femaleMedian":"-"}}},"Data entry keyers":{"ageData":{"2017":{"total":"267","16to19":"5","20to24":"37","25to34":"68","35to44":"46","45to54":"47","55to64":"52","65+":"12","medianAge":"52"}},"title":"Data entry keyers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"267","women":"79.6","white":"72.4","black":"16.5","asian":"8.5","hispanicOrLatino":"15.2"}},"wageData":{"2017":{"workers":"224","median":"650","maleWorkers":"48","maleMedian":"-","femaleWorkers":"176","femaleMedian":"640"}}},"Word processors and typists":{"ageData":{"2017":{"total":"94","16to19":"1","20to24":"8","25to34":"16","35to44":"18","45to54":"14","55to64":"28","65+":"8","medianAge":"28"}},"title":"Word processors and typists","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"94","women":"89.8","white":"69.7","black":"21.1","asian":"6.8","hispanicOrLatino":"13.9"}},"wageData":{"2017":{"workers":"80","median":"683","maleWorkers":"8","maleMedian":"-","femaleWorkers":"72","femaleMedian":"667"}}},"Desktop publishers":{"ageData":{"2017":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Desktop publishers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"2","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Insurance claims and policy processing clerks":{"ageData":{"2017":{"total":"237","16to19":"0","20to24":"19","25to34":"63","35to44":"54","45to54":"52","55to64":"39","65+":"9","medianAge":"39"}},"title":"Insurance claims and policy processing clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"237","women":"84.3","white":"70.8","black":"20.3","asian":"4.2","hispanicOrLatino":"14.9"}},"wageData":{"2017":{"workers":"223","median":"714","maleWorkers":"34","maleMedian":"-","femaleWorkers":"189","femaleMedian":"711"}}},"Mail clerks and mail machine operators, except postal service":{"ageData":{"2017":{"total":"61","16to19":"4","20to24":"7","25to34":"9","35to44":"11","45to54":"17","55to64":"10","65+":"4","medianAge":"10"}},"title":"Mail clerks and mail machine operators, except postal service","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"61","women":"36.8","white":"67.4","black":"24.4","asian":"3.0","hispanicOrLatino":"11.9"}},"wageData":{"2017":{"workers":"46","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Office clerks, general":{"ageData":{"2017":{"total":"1,271","16to19":"42","20to24":"152","25to34":"249","35to44":"221","45to54":"259","55to64":"253","65+":"95","medianAge":"253"}},"title":"Office clerks, general","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"1,271","women":"83.1","white":"75.1","black":"14.8","asian":"6.3","hispanicOrLatino":"18.4"}},"wageData":{"2017":{"workers":"935","median":"682","maleWorkers":"142","maleMedian":"780","femaleWorkers":"793","femaleMedian":"670"}}},"Office machine operators, except computer":{"ageData":{"2017":{"total":"33","16to19":"3","20to24":"4","25to34":"4","35to44":"5","45to54":"7","55to64":"5","65+":"4","medianAge":"5"}},"title":"Office machine operators, except computer","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"33","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"27","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Proofreaders and copy markers":{"ageData":{"2017":{"total":"10","16to19":"0","20to24":"1","25to34":"2","35to44":"0","45to54":"4","55to64":"2","65+":"2","medianAge":"2"}},"title":"Proofreaders and copy markers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"10","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"6","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Statistical assistants":{"ageData":{"2017":{"total":"21","16to19":"0","20to24":"1","25to34":"5","35to44":"4","45to54":"5","55to64":"4","65+":"1","medianAge":"4"}},"title":"Statistical assistants","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"21","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"17","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Office and administrative support workers, all other":{"ageData":{"2017":{"total":"576","16to19":"3","20to24":"51","25to34":"138","35to44":"121","45to54":"142","55to64":"88","65+":"33","medianAge":"88"}},"title":"Office and administrative support workers, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2017":{"total":"576","women":"75.2","white":"77.6","black":"15.1","asian":"3.7","hispanicOrLatino":"12.5"}},"wageData":{"2017":{"workers":"473","median":"758","maleWorkers":"122","maleMedian":"768","femaleWorkers":"352","femaleMedian":"756"}}},"Natural resources, construction, and maintenance occupations":{"ageData":{"2017":{"total":"14,193","16to19":"337","20to24":"1,231","25to34":"3,336","35to44":"3,322","45to54":"3,152","55to64":"2,274","65+":"540","medianAge":"2,274"}},"title":"Natural resources, construction, and maintenance occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2017":{"total":"14,193","women":"5.1","white":"86.9","black":"7.3","asian":"2.2","hispanicOrLatino":"30.7"}},"wageData":{"2017":{"workers":"11,509","median":"801","maleWorkers":"10,994","maleMedian":"809","femaleWorkers":"515","femaleMedian":"579"}}},"Farming, fishing, and forestry occupations":{"ageData":{"2017":{"total":"1,184","16to19":"80","20to24":"141","25to34":"263","35to44":"240","45to54":"227","55to64":"162","65+":"71","medianAge":"162"}},"title":"Farming, fishing, and forestry occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2017":{"total":"1,184","women":"23.4","white":"89.3","black":"4.9","asian":"1.7","hispanicOrLatino":"44.3"}},"wageData":{"2017":{"workers":"962","median":"539","maleWorkers":"756","maleMedian":"585","femaleWorkers":"206","femaleMedian":"471"}}},"First-line supervisors of farming, fishing, and forestry workers":{"ageData":{"2017":{"total":"62","16to19":"0","20to24":"5","25to34":"8","35to44":"14","45to54":"16","55to64":"11","65+":"7","medianAge":"11"}},"title":"First-line supervisors of farming, fishing, and forestry workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2017":{"total":"62","women":"8.7","white":"87.2","black":"6.6","asian":"4.4","hispanicOrLatino":"27.1"}},"wageData":{"2017":{"workers":"51","median":"711","maleWorkers":"47","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Agricultural inspectors":{"ageData":{"2017":{"total":"18","16to19":"0","20to24":"1","25to34":"1","35to44":"3","45to54":"9","55to64":"3","65+":"1","medianAge":"3"}},"title":"Agricultural inspectors","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2017":{"total":"18","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"14","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Animal breeders":{"ageData":{"2017":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Animal breeders","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2017":{"total":"2","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Graders and sorters, agricultural products":{"ageData":{"2017":{"total":"110","16to19":"4","20to24":"11","25to34":"24","35to44":"25","45to54":"23","55to64":"17","65+":"5","medianAge":"17"}},"title":"Graders and sorters, agricultural products","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2017":{"total":"110","women":"67.1","white":"80.4","black":"12.4","asian":"4.2","hispanicOrLatino":"48.8"}},"wageData":{"2017":{"workers":"99","median":"500","maleWorkers":"32","maleMedian":"-","femaleWorkers":"67","femaleMedian":"487"}}},"Miscellaneous agricultural workers":{"ageData":{"2017":{"total":"854","16to19":"71","20to24":"107","25to34":"197","35to44":"177","45to54":"156","55to64":"100","65+":"46","medianAge":"100"}},"title":"Miscellaneous agricultural workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2017":{"total":"854","women":"21.5","white":"91.7","black":"3.3","asian":"1.3","hispanicOrLatino":"51.1"}},"wageData":{"2017":{"workers":"701","median":"517","maleWorkers":"574","maleMedian":"553","femaleWorkers":"127","femaleMedian":"453"}}},"Fishers and related fishing workers":{"ageData":{"2017":{"total":"44","16to19":"2","20to24":"5","25to34":"13","35to44":"7","45to54":"7","55to64":"7","65+":"3","medianAge":"7"}},"title":"Fishers and related fishing workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2017":{"total":"44","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"21","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Hunters and trappers":{"ageData":{"2017":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Hunters and trappers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2017":{"total":"1","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"2","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Forest and conservation workers":{"ageData":{"2017":{"total":"27","16to19":"1","20to24":"5","25to34":"6","35to44":"2","45to54":"3","55to64":"9","65+":"2","medianAge":"9"}},"title":"Forest and conservation workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2017":{"total":"27","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"25","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Logging workers":{"ageData":{"2017":{"total":"66","16to19":"2","20to24":"7","25to34":"13","35to44":"13","45to54":"13","55to64":"13","65+":"6","medianAge":"13"}},"title":"Logging workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2017":{"total":"66","women":"2.0","white":"82.9","black":"10.3","asian":"0.0","hispanicOrLatino":"9.1"}},"wageData":{"2017":{"workers":"47","median":"-","maleWorkers":"46","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Construction and extraction occupations":{"ageData":{"2017":{"total":"8,031","16to19":"176","20to24":"701","25to34":"1,914","35to44":"1,997","45to54":"1,760","55to64":"1,220","65+":"263","medianAge":"1,220"}},"title":"Construction and extraction occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2017":{"total":"8,031","women":"3.0","white":"87.8","black":"6.9","asian":"1.6","hispanicOrLatino":"36.0"}},"wageData":{"2017":{"workers":"6,147","median":"796","maleWorkers":"5,987","maleMedian":"796","femaleWorkers":"160","femaleMedian":"802"}}},"First-line supervisors of construction trades and extraction workers":{"ageData":{"2017":{"total":"639","16to19":"2","20to24":"12","25to34":"122","35to44":"178","45to54":"181","55to64":"117","65+":"27","medianAge":"117"}},"title":"First-line supervisors of construction trades and extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"639","women":"3.0","white":"89.8","black":"5.4","asian":"1.2","hispanicOrLatino":"24.5"}},"wageData":{"2017":{"workers":"520","median":"1,158","maleWorkers":"506","maleMedian":"1,166","femaleWorkers":"14","femaleMedian":"-"}}},"Boilermakers":{"ageData":{"2017":{"total":"15","16to19":"0","20to24":"1","25to34":"2","35to44":"4","45to54":"5","55to64":"2","65+":"1","medianAge":"2"}},"title":"Boilermakers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"15","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"15","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Brickmasons, blockmasons, and stonemasons":{"ageData":{"2017":{"total":"166","16to19":"2","20to24":"13","25to34":"43","35to44":"39","45to54":"48","55to64":"20","65+":"2","medianAge":"20"}},"title":"Brickmasons, blockmasons, and stonemasons","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"166","women":"0.7","white":"84.6","black":"7.1","asian":"1.2","hispanicOrLatino":"45.1"}},"wageData":{"2017":{"workers":"121","median":"787","maleWorkers":"121","maleMedian":"787","femaleWorkers":"0","femaleMedian":"-"}}},"Carpenters":{"ageData":{"2017":{"total":"1,351","16to19":"26","20to24":"99","25to34":"317","35to44":"361","45to54":"290","55to64":"211","65+":"47","medianAge":"211"}},"title":"Carpenters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"1,351","women":"2.2","white":"89.3","black":"5.3","asian":"1.7","hispanicOrLatino":"35.4"}},"wageData":{"2017":{"workers":"870","median":"789","maleWorkers":"851","maleMedian":"789","femaleWorkers":"19","femaleMedian":"-"}}},"Carpet, floor, and tile installers and finishers":{"ageData":{"2017":{"total":"183","16to19":"2","20to24":"16","25to34":"45","35to44":"51","45to54":"38","55to64":"28","65+":"3","medianAge":"28"}},"title":"Carpet, floor, and tile installers and finishers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"183","women":"2.4","white":"87.2","black":"6.9","asian":"1.3","hispanicOrLatino":"47.4"}},"wageData":{"2017":{"workers":"115","median":"631","maleWorkers":"114","maleMedian":"628","femaleWorkers":"1","femaleMedian":"-"}}},"Cement masons, concrete finishers, and terrazzo workers":{"ageData":{"2017":{"total":"54","16to19":"1","20to24":"8","25to34":"10","35to44":"17","45to54":"10","55to64":"8","65+":"1","medianAge":"8"}},"title":"Cement masons, concrete finishers, and terrazzo workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"54","women":"1.0","white":"90.4","black":"8.5","asian":"0.0","hispanicOrLatino":"46.7"}},"wageData":{"2017":{"workers":"47","median":"-","maleWorkers":"45","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Construction laborers":{"ageData":{"2017":{"total":"1,946","16to19":"82","20to24":"216","25to34":"480","35to44":"446","45to54":"403","55to64":"256","65+":"65","medianAge":"256"}},"title":"Construction laborers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"1,946","women":"3.3","white":"85.9","black":"8.6","asian":"1.7","hispanicOrLatino":"46.9"}},"wageData":{"2017":{"workers":"1,443","median":"670","maleWorkers":"1,400","maleMedian":"667","femaleWorkers":"43","femaleMedian":"-"}}},"Paving, surfacing, and tamping equipment operators":{"ageData":{"2017":{"total":"15","16to19":"0","20to24":"4","25to34":"1","35to44":"3","45to54":"1","55to64":"5","65+":"1","medianAge":"5"}},"title":"Paving, surfacing, and tamping equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"15","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"12","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Pile-driver operators":{"ageData":{"2017":{"total":"2","16to19":"0","20to24":"0","25to34":"2","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Pile-driver operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"2","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Operating engineers and other construction equipment operators":{"ageData":{"2017":{"total":"358","16to19":"2","20to24":"24","25to34":"94","35to44":"81","45to54":"75","55to64":"66","65+":"14","medianAge":"66"}},"title":"Operating engineers and other construction equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"358","women":"1.5","white":"90.4","black":"5.2","asian":"0.8","hispanicOrLatino":"19.3"}},"wageData":{"2017":{"workers":"324","median":"868","maleWorkers":"318","maleMedian":"868","femaleWorkers":"6","femaleMedian":"-"}}},"Drywall installers, ceiling tile installers, and tapers":{"ageData":{"2017":{"total":"156","16to19":"5","20to24":"16","25to34":"36","35to44":"46","45to54":"26","55to64":"23","65+":"5","medianAge":"23"}},"title":"Drywall installers, ceiling tile installers, and tapers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"156","women":"2.7","white":"91.7","black":"3.8","asian":"0.6","hispanicOrLatino":"63.9"}},"wageData":{"2017":{"workers":"114","median":"634","maleWorkers":"112","maleMedian":"628","femaleWorkers":"1","femaleMedian":"-"}}},"Electricians":{"ageData":{"2017":{"total":"857","16to19":"13","20to24":"77","25to34":"205","35to44":"200","45to54":"195","55to64":"143","65+":"24","medianAge":"143"}},"title":"Electricians","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"857","women":"2.5","white":"87.9","black":"6.7","asian":"2.5","hispanicOrLatino":"19.1"}},"wageData":{"2017":{"workers":"726","median":"979","maleWorkers":"711","maleMedian":"974","femaleWorkers":"15","femaleMedian":"-"}}},"Glaziers":{"ageData":{"2017":{"total":"44","16to19":"1","20to24":"5","25to34":"12","35to44":"9","45to54":"9","55to64":"8","65+":"2","medianAge":"8"}},"title":"Glaziers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"44","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"39","median":"-","maleWorkers":"39","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Insulation workers":{"ageData":{"2017":{"total":"58","16to19":"0","20to24":"7","25to34":"20","35to44":"14","45to54":"12","55to64":"5","65+":"0","medianAge":"5"}},"title":"Insulation workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"58","women":"3.1","white":"82.1","black":"9.6","asian":"0.0","hispanicOrLatino":"42.6"}},"wageData":{"2017":{"workers":"52","median":"768","maleWorkers":"49","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Painters, construction and maintenance":{"ageData":{"2017":{"total":"540","16to19":"11","20to24":"49","25to34":"126","35to44":"147","45to54":"109","55to64":"85","65+":"13","medianAge":"85"}},"title":"Painters, construction and maintenance","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"540","women":"6.6","white":"89.7","black":"5.9","asian":"1.5","hispanicOrLatino":"53.4"}},"wageData":{"2017":{"workers":"347","median":"683","maleWorkers":"328","maleMedian":"689","femaleWorkers":"20","femaleMedian":"-"}}},"Paperhangers":{"ageData":{"2017":{"total":"4","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"2","55to64":"0","65+":"1","medianAge":"0"}},"title":"Paperhangers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"4","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Pipelayers, plumbers, pipefitters, and steamfitters":{"ageData":{"2017":{"total":"600","16to19":"9","20to24":"56","25to34":"147","35to44":"148","45to54":"142","55to64":"87","65+":"12","medianAge":"87"}},"title":"Pipelayers, plumbers, pipefitters, and steamfitters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"600","women":"2.2","white":"86.6","black":"9.0","asian":"1.5","hispanicOrLatino":"27.1"}},"wageData":{"2017":{"workers":"497","median":"866","maleWorkers":"489","maleMedian":"865","femaleWorkers":"8","femaleMedian":"-"}}},"Plasterers and stucco masons":{"ageData":{"2017":{"total":"27","16to19":"0","20to24":"3","25to34":"8","35to44":"6","45to54":"6","55to64":"2","65+":"1","medianAge":"2"}},"title":"Plasterers and stucco masons","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"27","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"24","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Reinforcing iron and rebar workers":{"ageData":{"2017":{"total":"12","16to19":"0","20to24":"2","25to34":"2","35to44":"3","45to54":"3","55to64":"0","65+":"0","medianAge":"0"}},"title":"Reinforcing iron and rebar workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"12","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"13","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Roofers":{"ageData":{"2017":{"total":"220","16to19":"6","20to24":"25","25to34":"61","35to44":"65","45to54":"44","55to64":"14","65+":"5","medianAge":"14"}},"title":"Roofers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"220","women":"0.6","white":"86.6","black":"6.9","asian":"2.5","hispanicOrLatino":"56.1"}},"wageData":{"2017":{"workers":"174","median":"621","maleWorkers":"174","maleMedian":"621","femaleWorkers":"0","femaleMedian":"-"}}},"Sheet metal workers":{"ageData":{"2017":{"total":"137","16to19":"2","20to24":"7","25to34":"35","35to44":"32","45to54":"30","55to64":"26","65+":"5","medianAge":"26"}},"title":"Sheet metal workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"137","women":"2.6","white":"91.4","black":"4.3","asian":"1.6","hispanicOrLatino":"18.7"}},"wageData":{"2017":{"workers":"136","median":"865","maleWorkers":"132","maleMedian":"866","femaleWorkers":"3","femaleMedian":"-"}}},"Structural iron and steel workers":{"ageData":{"2017":{"total":"43","16to19":"0","20to24":"3","25to34":"8","35to44":"14","45to54":"10","55to64":"7","65+":"0","medianAge":"7"}},"title":"Structural iron and steel workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"43","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"43","median":"-","maleWorkers":"41","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Solar photovoltaic installers":{"ageData":{"2017":{"total":"11","16to19":"0","20to24":"1","25to34":"5","35to44":"2","45to54":"1","55to64":"1","65+":"1","medianAge":"1"}},"title":"Solar photovoltaic installers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"11","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers, construction trades":{"ageData":{"2017":{"total":"69","16to19":"6","20to24":"17","25to34":"18","35to44":"12","45to54":"9","55to64":"7","65+":"0","medianAge":"7"}},"title":"Helpers, construction trades","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"69","women":"9.4","white":"88.2","black":"3.8","asian":"2.1","hispanicOrLatino":"38.3"}},"wageData":{"2017":{"workers":"57","median":"621","maleWorkers":"53","maleMedian":"627","femaleWorkers":"4","femaleMedian":"-"}}},"Construction and building inspectors":{"ageData":{"2017":{"total":"89","16to19":"0","20to24":"1","25to34":"8","35to44":"13","45to54":"27","55to64":"26","65+":"13","medianAge":"26"}},"title":"Construction and building inspectors","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"89","women":"10.2","white":"85.5","black":"9.8","asian":"2.2","hispanicOrLatino":"11.2"}},"wageData":{"2017":{"workers":"63","median":"974","maleWorkers":"60","maleMedian":"1,068","femaleWorkers":"4","femaleMedian":"-"}}},"Elevator installers and repairers":{"ageData":{"2017":{"total":"40","16to19":"0","20to24":"0","25to34":"9","35to44":"9","45to54":"8","55to64":"9","65+":"4","medianAge":"9"}},"title":"Elevator installers and repairers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"40","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"38","median":"-","maleWorkers":"38","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Fence erectors":{"ageData":{"2017":{"total":"34","16to19":"2","20to24":"4","25to34":"7","35to44":"8","45to54":"6","55to64":"5","65+":"2","medianAge":"5"}},"title":"Fence erectors","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"34","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"26","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Hazardous materials removal workers":{"ageData":{"2017":{"total":"30","16to19":"0","20to24":"1","25to34":"7","35to44":"9","45to54":"5","55to64":"7","65+":"1","medianAge":"7"}},"title":"Hazardous materials removal workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"30","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"27","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Highway maintenance workers":{"ageData":{"2017":{"total":"101","16to19":"2","20to24":"8","25to34":"17","35to44":"24","45to54":"26","55to64":"21","65+":"3","medianAge":"21"}},"title":"Highway maintenance workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"101","women":"2.7","white":"79.4","black":"13.7","asian":"0.1","hispanicOrLatino":"15.5"}},"wageData":{"2017":{"workers":"91","median":"761","maleWorkers":"88","maleMedian":"770","femaleWorkers":"4","femaleMedian":"-"}}},"Rail-track laying and maintenance equipment operators":{"ageData":{"2017":{"total":"17","16to19":"0","20to24":"4","25to34":"4","35to44":"5","45to54":"1","55to64":"2","65+":"1","medianAge":"2"}},"title":"Rail-track laying and maintenance equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"17","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"10","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Septic tank servicers and sewer pipe cleaners":{"ageData":{"2017":{"total":"10","16to19":"0","20to24":"0","25to34":"2","35to44":"3","45to54":"3","55to64":"0","65+":"1","medianAge":"0"}},"title":"Septic tank servicers and sewer pipe cleaners","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"10","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Miscellaneous construction and related workers":{"ageData":{"2017":{"total":"24","16to19":"0","20to24":"1","25to34":"7","35to44":"6","45to54":"4","55to64":"4","65+":"1","medianAge":"4"}},"title":"Miscellaneous construction and related workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"24","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"15","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Derrick, rotary drill, and service unit operators, oil, gas, and mining":{"ageData":{"2017":{"total":"30","16to19":"0","20to24":"3","25to34":"15","35to44":"8","45to54":"3","55to64":"0","65+":"0","medianAge":"0"}},"title":"Derrick, rotary drill, and service unit operators, oil, gas, and mining","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"30","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"27","median":"-","maleWorkers":"27","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Earth drillers, except oil and gas":{"ageData":{"2017":{"total":"23","16to19":"0","20to24":"3","25to34":"4","35to44":"5","45to54":"3","55to64":"6","65+":"2","medianAge":"6"}},"title":"Earth drillers, except oil and gas","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"23","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"17","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Explosives workers, ordnance handling experts, and blasters":{"ageData":{"2017":{"total":"10","16to19":"1","20to24":"1","25to34":"1","35to44":"2","45to54":"1","55to64":"2","65+":"1","medianAge":"2"}},"title":"Explosives workers, ordnance handling experts, and blasters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"10","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"12","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Mining machine operators":{"ageData":{"2017":{"total":"51","16to19":"0","20to24":"2","25to34":"15","35to44":"14","45to54":"12","55to64":"7","65+":"2","medianAge":"7"}},"title":"Mining machine operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"51","women":"1.1","white":"85.8","black":"7.8","asian":"2.7","hispanicOrLatino":"23.9"}},"wageData":{"2017":{"workers":"49","median":"-","maleWorkers":"49","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Roof bolters, mining":{"ageData":{"2017":{"total":"2","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Roof bolters, mining","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"2","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Roustabouts, oil and gas":{"ageData":{"2017":{"total":"4","16to19":"0","20to24":"1","25to34":"2","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Roustabouts, oil and gas","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"4","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers--extraction workers":{"ageData":{"2017":{"total":"4","16to19":"0","20to24":"1","25to34":"1","35to44":"1","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Helpers--extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"4","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Other extraction workers":{"ageData":{"2017":{"total":"54","16to19":"1","20to24":"7","25to34":"17","35to44":"11","45to54":"9","55to64":"8","65+":"2","medianAge":"8"}},"title":"Other extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2017":{"total":"54","women":"2.9","white":"93.1","black":"2.0","asian":"0.0","hispanicOrLatino":"35.7"}},"wageData":{"2017":{"workers":"54","median":"900","maleWorkers":"52","maleMedian":"907","femaleWorkers":"2","femaleMedian":"-"}}},"Installation, maintenance, and repair occupations":{"ageData":{"2017":{"total":"4,977","16to19":"80","20to24":"389","25to34":"1,159","35to44":"1,085","45to54":"1,166","55to64":"892","65+":"206","medianAge":"892"}},"title":"Installation, maintenance, and repair occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2017":{"total":"4,977","women":"4.0","white":"85.0","black":"8.6","asian":"3.3","hispanicOrLatino":"19.0"}},"wageData":{"2017":{"workers":"4,400","median":"878","maleWorkers":"4,251","maleMedian":"883","femaleWorkers":"149","femaleMedian":"736"}}},"First-line supervisors of mechanics, installers, and repairers":{"ageData":{"2017":{"total":"253","16to19":"0","20to24":"2","25to34":"40","35to44":"58","45to54":"78","55to64":"66","65+":"10","medianAge":"66"}},"title":"First-line supervisors of mechanics, installers, and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"253","women":"8.4","white":"84.0","black":"9.4","asian":"4.1","hispanicOrLatino":"12.8"}},"wageData":{"2017":{"workers":"244","median":"1,092","maleWorkers":"225","maleMedian":"1,089","femaleWorkers":"19","femaleMedian":"-"}}},"Computer, automated teller, and office machine repairers":{"ageData":{"2017":{"total":"212","16to19":"2","20to24":"15","25to34":"57","35to44":"48","45to54":"55","55to64":"29","65+":"6","medianAge":"29"}},"title":"Computer, automated teller, and office machine repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"212","women":"11.3","white":"73.8","black":"12.7","asian":"10.2","hispanicOrLatino":"17.1"}},"wageData":{"2017":{"workers":"173","median":"819","maleWorkers":"156","maleMedian":"833","femaleWorkers":"17","femaleMedian":"-"}}},"Radio and telecommunications equipment installers and repairers":{"ageData":{"2017":{"total":"134","16to19":"2","20to24":"7","25to34":"31","35to44":"44","45to54":"25","55to64":"21","65+":"3","medianAge":"21"}},"title":"Radio and telecommunications equipment installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"134","women":"8.1","white":"85.3","black":"7.3","asian":"6.1","hispanicOrLatino":"19.7"}},"wageData":{"2017":{"workers":"121","median":"1,010","maleWorkers":"113","maleMedian":"1,069","femaleWorkers":"8","femaleMedian":"-"}}},"Avionics technicians":{"ageData":{"2017":{"total":"9","16to19":"0","20to24":"0","25to34":"2","35to44":"3","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Avionics technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"9","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electric motor, power tool, and related repairers":{"ageData":{"2017":{"total":"28","16to19":"0","20to24":"1","25to34":"6","35to44":"5","45to54":"9","55to64":"6","65+":"1","medianAge":"6"}},"title":"Electric motor, power tool, and related repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"28","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"30","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electrical and electronics installers and repairers, transportation equipment":{"ageData":{"2017":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Electrical and electronics installers and repairers, transportation equipment","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"1","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electrical and electronics repairers, industrial and utility":{"ageData":{"2017":{"total":"12","16to19":"0","20to24":"0","25to34":"5","35to44":"3","45to54":"1","55to64":"3","65+":"0","medianAge":"3"}},"title":"Electrical and electronics repairers, industrial and utility","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"12","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"14","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electronic equipment installers and repairers, motor vehicles":{"ageData":{"2017":{"total":"11","16to19":"0","20to24":"2","25to34":"1","35to44":"2","45to54":"3","55to64":"2","65+":"0","medianAge":"2"}},"title":"Electronic equipment installers and repairers, motor vehicles","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"11","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"11","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electronic home entertainment equipment installers and repairers":{"ageData":{"2017":{"total":"50","16to19":"1","20to24":"7","25to34":"13","35to44":"14","45to54":"10","55to64":"3","65+":"3","medianAge":"3"}},"title":"Electronic home entertainment equipment installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"50","women":"2.8","white":"81.9","black":"14.2","asian":"3.7","hispanicOrLatino":"26.5"}},"wageData":{"2017":{"workers":"38","median":"-","maleWorkers":"38","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Security and fire alarm systems installers":{"ageData":{"2017":{"total":"77","16to19":"1","20to24":"10","25to34":"20","35to44":"16","45to54":"17","55to64":"11","65+":"3","medianAge":"11"}},"title":"Security and fire alarm systems installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"77","women":"2.6","white":"78.4","black":"11.0","asian":"5.8","hispanicOrLatino":"24.1"}},"wageData":{"2017":{"workers":"71","median":"945","maleWorkers":"68","maleMedian":"943","femaleWorkers":"3","femaleMedian":"-"}}},"Aircraft mechanics and service technicians":{"ageData":{"2017":{"total":"150","16to19":"1","20to24":"9","25to34":"34","35to44":"24","45to54":"41","55to64":"38","65+":"4","medianAge":"38"}},"title":"Aircraft mechanics and service technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"150","women":"5.2","white":"83.0","black":"5.6","asian":"7.8","hispanicOrLatino":"13.9"}},"wageData":{"2017":{"workers":"153","median":"1,169","maleWorkers":"146","maleMedian":"1,175","femaleWorkers":"6","femaleMedian":"-"}}},"Automotive body and related repairers":{"ageData":{"2017":{"total":"140","16to19":"3","20to24":"13","25to34":"36","35to44":"27","45to54":"35","55to64":"18","65+":"7","medianAge":"18"}},"title":"Automotive body and related repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"140","women":"1.1","white":"86.0","black":"6.1","asian":"2.9","hispanicOrLatino":"31.6"}},"wageData":{"2017":{"workers":"124","median":"821","maleWorkers":"122","maleMedian":"832","femaleWorkers":"1","femaleMedian":"-"}}},"Automotive glass installers and repairers":{"ageData":{"2017":{"total":"22","16to19":"0","20to24":"2","25to34":"7","35to44":"5","45to54":"3","55to64":"4","65+":"0","medianAge":"4"}},"title":"Automotive glass installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"22","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"21","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Automotive service technicians and mechanics":{"ageData":{"2017":{"total":"902","16to19":"21","20to24":"97","25to34":"248","35to44":"189","45to54":"196","55to64":"126","65+":"25","medianAge":"126"}},"title":"Automotive service technicians and mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"902","women":"2.4","white":"84.1","black":"8.7","asian":"3.8","hispanicOrLatino":"23.2"}},"wageData":{"2017":{"workers":"752","median":"761","maleWorkers":"737","maleMedian":"764","femaleWorkers":"15","femaleMedian":"-"}}},"Bus and truck mechanics and diesel engine specialists":{"ageData":{"2017":{"total":"401","16to19":"10","20to24":"43","25to34":"93","35to44":"83","45to54":"88","55to64":"70","65+":"15","medianAge":"70"}},"title":"Bus and truck mechanics and diesel engine specialists","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"401","women":"1.8","white":"85.6","black":"9.4","asian":"1.3","hispanicOrLatino":"18.1"}},"wageData":{"2017":{"workers":"367","median":"887","maleWorkers":"362","maleMedian":"887","femaleWorkers":"4","femaleMedian":"-"}}},"Heavy vehicle and mobile equipment service technicians and mechanics":{"ageData":{"2017":{"total":"201","16to19":"2","20to24":"19","25to34":"36","35to44":"45","45to54":"51","55to64":"36","65+":"11","medianAge":"36"}},"title":"Heavy vehicle and mobile equipment service technicians and mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"201","women":"2.6","white":"91.8","black":"4.5","asian":"1.4","hispanicOrLatino":"11.5"}},"wageData":{"2017":{"workers":"177","median":"993","maleWorkers":"173","maleMedian":"1,005","femaleWorkers":"4","femaleMedian":"-"}}},"Small engine mechanics":{"ageData":{"2017":{"total":"44","16to19":"2","20to24":"2","25to34":"8","35to44":"8","45to54":"13","55to64":"7","65+":"4","medianAge":"7"}},"title":"Small engine mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"44","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"26","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Miscellaneous vehicle and mobile equipment mechanics, installers, and repairers":{"ageData":{"2017":{"total":"83","16to19":"6","20to24":"13","25to34":"27","35to44":"16","45to54":"13","55to64":"6","65+":"2","medianAge":"6"}},"title":"Miscellaneous vehicle and mobile equipment mechanics, installers, and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"83","women":"1.8","white":"85.6","black":"7.5","asian":"4.4","hispanicOrLatino":"32.2"}},"wageData":{"2017":{"workers":"64","median":"613","maleWorkers":"64","maleMedian":"613","femaleWorkers":"0","femaleMedian":"-"}}},"Control and valve installers and repairers":{"ageData":{"2017":{"total":"26","16to19":"0","20to24":"2","25to34":"5","35to44":"7","45to54":"6","55to64":"5","65+":"1","medianAge":"5"}},"title":"Control and valve installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"26","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"25","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Heating, air conditioning, and refrigeration mechanics and installers":{"ageData":{"2017":{"total":"448","16to19":"9","20to24":"38","25to34":"114","35to44":"90","45to54":"106","55to64":"72","65+":"19","medianAge":"72"}},"title":"Heating, air conditioning, and refrigeration mechanics and installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"448","women":"2.0","white":"90.6","black":"5.4","asian":"2.4","hispanicOrLatino":"17.9"}},"wageData":{"2017":{"workers":"376","median":"830","maleWorkers":"369","maleMedian":"832","femaleWorkers":"7","femaleMedian":"-"}}},"Home appliance repairers":{"ageData":{"2017":{"total":"41","16to19":"0","20to24":"4","25to34":"10","35to44":"9","45to54":"4","55to64":"10","65+":"5","medianAge":"10"}},"title":"Home appliance repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"41","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"26","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Industrial and refractory machinery mechanics":{"ageData":{"2017":{"total":"424","16to19":"4","20to24":"23","25to34":"88","35to44":"78","45to54":"120","55to64":"98","65+":"13","medianAge":"98"}},"title":"Industrial and refractory machinery mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"424","women":"3.9","white":"85.8","black":"7.8","asian":"3.4","hispanicOrLatino":"16.5"}},"wageData":{"2017":{"workers":"395","median":"923","maleWorkers":"379","maleMedian":"932","femaleWorkers":"16","femaleMedian":"-"}}},"Maintenance and repair workers, general":{"ageData":{"2017":{"total":"528","16to19":"5","20to24":"29","25to34":"101","35to44":"115","45to54":"126","55to64":"122","65+":"30","medianAge":"122"}},"title":"Maintenance and repair workers, general","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"528","women":"4.5","white":"85.9","black":"8.9","asian":"2.1","hispanicOrLatino":"19.7"}},"wageData":{"2017":{"workers":"511","median":"828","maleWorkers":"490","maleMedian":"834","femaleWorkers":"20","femaleMedian":"-"}}},"Maintenance workers, machinery":{"ageData":{"2017":{"total":"27","16to19":"0","20to24":"0","25to34":"4","35to44":"8","45to54":"7","55to64":"7","65+":"1","medianAge":"7"}},"title":"Maintenance workers, machinery","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"27","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"25","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Millwrights":{"ageData":{"2017":{"total":"40","16to19":"1","20to24":"1","25to34":"6","35to44":"14","45to54":"9","55to64":"8","65+":"1","medianAge":"8"}},"title":"Millwrights","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"40","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"40","median":"-","maleWorkers":"39","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Electrical power-line installers and repairers":{"ageData":{"2017":{"total":"129","16to19":"2","20to24":"10","25to34":"28","35to44":"37","45to54":"28","55to64":"21","65+":"5","medianAge":"21"}},"title":"Electrical power-line installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"129","women":"0.6","white":"89.8","black":"7.8","asian":"0.0","hispanicOrLatino":"11.6"}},"wageData":{"2017":{"workers":"132","median":"1,191","maleWorkers":"132","maleMedian":"1,191","femaleWorkers":"0","femaleMedian":"-"}}},"Telecommunications line installers and repairers":{"ageData":{"2017":{"total":"189","16to19":"1","20to24":"14","25to34":"48","35to44":"55","45to54":"43","55to64":"22","65+":"6","medianAge":"22"}},"title":"Telecommunications line installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"189","women":"2.7","white":"78.3","black":"18.4","asian":"1.7","hispanicOrLatino":"19.1"}},"wageData":{"2017":{"workers":"187","median":"879","maleWorkers":"181","maleMedian":"876","femaleWorkers":"5","femaleMedian":"-"}}},"Precision instrument and equipment repairers":{"ageData":{"2017":{"total":"63","16to19":"1","20to24":"1","25to34":"16","35to44":"10","45to54":"12","55to64":"16","65+":"6","medianAge":"16"}},"title":"Precision instrument and equipment repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"63","women":"14.6","white":"80.9","black":"14.7","asian":"1.4","hispanicOrLatino":"10.9"}},"wageData":{"2017":{"workers":"44","median":"-","maleWorkers":"34","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Wind turbine service technicians":{"ageData":{"2017":{"total":"5","16to19":"0","20to24":"1","25to34":"1","35to44":"2","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Wind turbine service technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Coin, vending, and amusement machine servicers and repairers":{"ageData":{"2017":{"total":"34","16to19":"0","20to24":"1","25to34":"9","35to44":"10","45to54":"7","55to64":"4","65+":"3","medianAge":"4"}},"title":"Coin, vending, and amusement machine servicers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"34","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"24","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Commercial divers":{"ageData":{"2017":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Commercial divers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"0","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Locksmiths and safe repairers":{"ageData":{"2017":{"total":"35","16to19":"0","20to24":"3","25to34":"7","35to44":"7","45to54":"7","55to64":"7","65+":"5","medianAge":"7"}},"title":"Locksmiths and safe repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"35","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"20","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Manufactured building and mobile home installers":{"ageData":{"2017":{"total":"4","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Manufactured building and mobile home installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"4","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Riggers":{"ageData":{"2017":{"total":"14","16to19":"0","20to24":"1","25to34":"6","35to44":"3","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Riggers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"14","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"13","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Signal and track switch repairers":{"ageData":{"2017":{"total":"9","16to19":"0","20to24":"0","25to34":"3","35to44":"4","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Signal and track switch repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"9","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"11","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers--installation, maintenance, and repair workers":{"ageData":{"2017":{"total":"18","16to19":"1","20to24":"2","25to34":"3","35to44":"5","45to54":"2","55to64":"2","65+":"1","medianAge":"2"}},"title":"Helpers--installation, maintenance, and repair workers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"18","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"15","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Other installation, maintenance, and repair workers":{"ageData":{"2017":{"total":"215","16to19":"3","20to24":"19","25to34":"46","35to44":"43","45to54":"45","55to64":"45","65+":"14","medianAge":"45"}},"title":"Other installation, maintenance, and repair workers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2017":{"total":"215","women":"5.9","white":"86.7","black":"6.4","asian":"2.3","hispanicOrLatino":"23.5"}},"wageData":{"2017":{"workers":"156","median":"774","maleWorkers":"150","maleMedian":"772","femaleWorkers":"6","femaleMedian":"-"}}},"Production, transportation, and material moving occupations":{"ageData":{"2017":{"total":"17,927","16to19":"497","20to24":"1,736","25to34":"3,721","35to44":"3,525","45to54":"4,094","55to64":"3,335","65+":"1,019","medianAge":"3,335"}},"title":"Production, transportation, and material moving occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2017":{"total":"17,927","women":"22.8","white":"74.2","black":"16.6","asian":"5.3","hispanicOrLatino":"22.2"}},"wageData":{"2017":{"workers":"14,825","median":"692","maleWorkers":"11,705","maleMedian":"736","femaleWorkers":"3,119","femaleMedian":"545"}}},"Production occupations":{"ageData":{"2017":{"total":"8,482","16to19":"155","20to24":"783","25to34":"1,841","35to44":"1,737","45to54":"1,976","55to64":"1,608","65+":"382","medianAge":"1,608"}},"title":"Production occupations","depth":2,"parent":"Production, transportation, and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"8,482","women":"28.9","white":"76.8","black":"13.3","asian":"6.2","hispanicOrLatino":"22.8"}},"wageData":{"2017":{"workers":"7,589","median":"701","maleWorkers":"5,545","maleMedian":"769","femaleWorkers":"2,044","femaleMedian":"564"}}},"First-line supervisors of production and operating workers":{"ageData":{"2017":{"total":"768","16to19":"4","20to24":"23","25to34":"133","35to44":"179","45to54":"226","55to64":"173","65+":"30","medianAge":"173"}},"title":"First-line supervisors of production and operating workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"768","women":"19.1","white":"82.2","black":"10.4","asian":"3.7","hispanicOrLatino":"16.7"}},"wageData":{"2017":{"workers":"722","median":"966","maleWorkers":"588","maleMedian":"1,007","femaleWorkers":"133","femaleMedian":"716"}}},"Aircraft structure, surfaces, rigging, and systems assemblers":{"ageData":{"2017":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Aircraft structure, surfaces, rigging, and systems assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"1","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Electrical, electronics, and electromechanical assemblers":{"ageData":{"2017":{"total":"128","16to19":"2","20to24":"16","25to34":"26","35to44":"23","45to54":"31","55to64":"22","65+":"7","medianAge":"22"}},"title":"Electrical, electronics, and electromechanical assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"128","women":"42.1","white":"63.5","black":"15.3","asian":"17.2","hispanicOrLatino":"18.2"}},"wageData":{"2017":{"workers":"123","median":"624","maleWorkers":"73","maleMedian":"682","femaleWorkers":"50","femaleMedian":"587"}}},"Engine and other machine assemblers":{"ageData":{"2017":{"total":"13","16to19":"0","20to24":"2","25to34":"7","35to44":"0","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Engine and other machine assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"13","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"14","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Structural metal fabricators and fitters":{"ageData":{"2017":{"total":"30","16to19":"1","20to24":"2","25to34":"8","35to44":"7","45to54":"6","55to64":"5","65+":"1","medianAge":"5"}},"title":"Structural metal fabricators and fitters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"30","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"25","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Miscellaneous assemblers and fabricators":{"ageData":{"2017":{"total":"1,033","16to19":"20","20to24":"119","25to34":"221","35to44":"212","45to54":"239","55to64":"178","65+":"45","medianAge":"178"}},"title":"Miscellaneous assemblers and fabricators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"1,033","women":"37.7","white":"68.0","black":"20.8","asian":"8.0","hispanicOrLatino":"18.9"}},"wageData":{"2017":{"workers":"957","median":"630","maleWorkers":"595","maleMedian":"700","femaleWorkers":"362","femaleMedian":"559"}}},"Bakers":{"ageData":{"2017":{"total":"215","16to19":"9","20to24":"25","25to34":"40","35to44":"45","45to54":"41","55to64":"46","65+":"8","medianAge":"46"}},"title":"Bakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"215","women":"60.1","white":"71.3","black":"15.6","asian":"8.5","hispanicOrLatino":"31.5"}},"wageData":{"2017":{"workers":"135","median":"472","maleWorkers":"67","maleMedian":"488","femaleWorkers":"68","femaleMedian":"464"}}},"Butchers and other meat, poultry, and fish processing workers":{"ageData":{"2017":{"total":"269","16to19":"10","20to24":"34","25to34":"64","35to44":"55","45to54":"58","55to64":"32","65+":"17","medianAge":"32"}},"title":"Butchers and other meat, poultry, and fish processing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"269","women":"24.3","white":"68.5","black":"19.8","asian":"7.2","hispanicOrLatino":"35.3"}},"wageData":{"2017":{"workers":"259","median":"587","maleWorkers":"196","maleMedian":"621","femaleWorkers":"63","femaleMedian":"487"}}},"Food and tobacco roasting, baking, and drying machine operators and tenders":{"ageData":{"2017":{"total":"12","16to19":"0","20to24":"3","25to34":"1","35to44":"2","45to54":"2","55to64":"2","65+":"1","medianAge":"2"}},"title":"Food and tobacco roasting, baking, and drying machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"12","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"7","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Food batchmakers":{"ageData":{"2017":{"total":"89","16to19":"8","20to24":"15","25to34":"14","35to44":"18","45to54":"10","55to64":"17","65+":"5","medianAge":"17"}},"title":"Food batchmakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"89","women":"58.1","white":"77.2","black":"12.4","asian":"6.6","hispanicOrLatino":"26.2"}},"wageData":{"2017":{"workers":"70","median":"575","maleWorkers":"32","maleMedian":"-","femaleWorkers":"38","femaleMedian":"-"}}},"Food cooking machine operators and tenders":{"ageData":{"2017":{"total":"15","16to19":"2","20to24":"0","25to34":"5","35to44":"2","45to54":"3","55to64":"2","65+":"0","medianAge":"2"}},"title":"Food cooking machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"15","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"8","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Food processing workers, all other":{"ageData":{"2017":{"total":"175","16to19":"4","20to24":"19","25to34":"41","35to44":"37","45to54":"43","55to64":"22","65+":"11","medianAge":"22"}},"title":"Food processing workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"175","women":"32.5","white":"62.8","black":"24.1","asian":"7.0","hispanicOrLatino":"37.3"}},"wageData":{"2017":{"workers":"171","median":"676","maleWorkers":"119","maleMedian":"701","femaleWorkers":"52","femaleMedian":"545"}}},"Computer control programmers and operators":{"ageData":{"2017":{"total":"99","16to19":"1","20to24":"6","25to34":"26","35to44":"19","45to54":"23","55to64":"20","65+":"3","medianAge":"20"}},"title":"Computer control programmers and operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"99","women":"9.8","white":"82.8","black":"9.8","asian":"5.6","hispanicOrLatino":"10.7"}},"wageData":{"2017":{"workers":"100","median":"868","maleWorkers":"88","maleMedian":"912","femaleWorkers":"12","femaleMedian":"-"}}},"Extruding and drawing machine setters, operators, and tenders, metal and plastic":{"ageData":{"2017":{"total":"19","16to19":"0","20to24":"3","25to34":"5","35to44":"6","45to54":"3","55to64":"1","65+":"0","medianAge":"1"}},"title":"Extruding and drawing machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"19","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"18","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Forging machine setters, operators, and tenders, metal and plastic":{"ageData":{"2017":{"total":"8","16to19":"0","20to24":"0","25to34":"3","35to44":"2","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Forging machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"8","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"9","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Rolling machine setters, operators, and tenders, metal and plastic":{"ageData":{"2017":{"total":"8","16to19":"0","20to24":"0","25to34":"1","35to44":"4","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Rolling machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"8","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"9","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Cutting, punching, and press machine setters, operators, and tenders, metal and plastic":{"ageData":{"2017":{"total":"80","16to19":"2","20to24":"7","25to34":"22","35to44":"12","45to54":"17","55to64":"15","65+":"5","medianAge":"15"}},"title":"Cutting, punching, and press machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"80","women":"11.0","white":"82.6","black":"10.0","asian":"4.7","hispanicOrLatino":"12.5"}},"wageData":{"2017":{"workers":"84","median":"665","maleWorkers":"74","maleMedian":"688","femaleWorkers":"9","femaleMedian":"-"}}},"Drilling and boring machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2017":{"total":"4","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Drilling and boring machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"4","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Grinding, lapping, polishing, and buffing machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2017":{"total":"38","16to19":"1","20to24":"3","25to34":"5","35to44":"7","45to54":"11","55to64":"10","65+":"1","medianAge":"10"}},"title":"Grinding, lapping, polishing, and buffing machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"38","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"40","median":"-","maleWorkers":"35","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Lathe and turning machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2017":{"total":"14","16to19":"1","20to24":"0","25to34":"2","35to44":"2","45to54":"3","55to64":"4","65+":"2","medianAge":"4"}},"title":"Lathe and turning machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"14","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"14","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Milling and planing machine setters, operators, and tenders, metal and plastic":{"ageData":{"2017":{"total":"5","16to19":"0","20to24":"1","25to34":"1","35to44":"1","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Milling and planing machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"5","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Machinists":{"ageData":{"2017":{"total":"366","16to19":"3","20to24":"28","25to34":"68","35to44":"68","45to54":"93","55to64":"93","65+":"13","medianAge":"93"}},"title":"Machinists","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"366","women":"5.0","white":"86.1","black":"4.4","asian":"6.3","hispanicOrLatino":"13.9"}},"wageData":{"2017":{"workers":"343","median":"831","maleWorkers":"326","maleMedian":"834","femaleWorkers":"16","femaleMedian":"-"}}},"Metal furnace operators, tenders, pourers, and casters":{"ageData":{"2017":{"total":"19","16to19":"0","20to24":"4","25to34":"3","35to44":"5","45to54":"1","55to64":"5","65+":"0","medianAge":"5"}},"title":"Metal furnace operators, tenders, pourers, and casters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"19","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"23","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Model makers and patternmakers, metal and plastic":{"ageData":{"2017":{"total":"5","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"1","65+":"3","medianAge":"1"}},"title":"Model makers and patternmakers, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"3","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Molders and molding machine setters, operators, and tenders, metal and plastic":{"ageData":{"2017":{"total":"45","16to19":"4","20to24":"6","25to34":"6","35to44":"11","45to54":"8","55to64":"8","65+":"2","medianAge":"8"}},"title":"Molders and molding machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"45","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"43","median":"-","maleWorkers":"38","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Multiple machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2017":{"total":"5","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Multiple machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"5","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Tool and die makers":{"ageData":{"2017":{"total":"62","16to19":"1","20to24":"2","25to34":"10","35to44":"7","45to54":"15","55to64":"26","65+":"2","medianAge":"26"}},"title":"Tool and die makers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"62","women":"3.2","white":"97.6","black":"1.1","asian":"0.7","hispanicOrLatino":"6.9"}},"wageData":{"2017":{"workers":"59","median":"1,007","maleWorkers":"56","maleMedian":"1,021","femaleWorkers":"3","femaleMedian":"-"}}},"Welding, soldering, and brazing workers":{"ageData":{"2017":{"total":"600","16to19":"9","20to24":"80","25to34":"156","35to44":"129","45to54":"130","55to64":"85","65+":"11","medianAge":"85"}},"title":"Welding, soldering, and brazing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"600","women":"4.5","white":"87.4","black":"7.5","asian":"1.1","hispanicOrLatino":"24.3"}},"wageData":{"2017":{"workers":"541","median":"812","maleWorkers":"517","maleMedian":"821","femaleWorkers":"24","femaleMedian":"-"}}},"Heat treating equipment setters, operators, and tenders, metal and plastic":{"ageData":{"2017":{"total":"3","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Heat treating equipment setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"3","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Layout workers, metal and plastic":{"ageData":{"2017":{"total":"12","16to19":"0","20to24":"2","25to34":"4","35to44":"3","45to54":"2","55to64":"0","65+":"1","medianAge":"0"}},"title":"Layout workers, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"12","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"11","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Plating and coating machine setters, operators, and tenders, metal and plastic":{"ageData":{"2017":{"total":"17","16to19":"0","20to24":"3","25to34":"2","35to44":"4","45to54":"3","55to64":"5","65+":"0","medianAge":"5"}},"title":"Plating and coating machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"17","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"16","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Tool grinders, filers, and sharpeners":{"ageData":{"2017":{"total":"6","16to19":"0","20to24":"1","25to34":"2","35to44":"0","45to54":"1","55to64":"1","65+":"1","medianAge":"1"}},"title":"Tool grinders, filers, and sharpeners","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"6","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Metal workers and plastic workers, all other":{"ageData":{"2017":{"total":"388","16to19":"3","20to24":"21","25to34":"95","35to44":"79","45to54":"91","55to64":"83","65+":"15","medianAge":"83"}},"title":"Metal workers and plastic workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"388","women":"20.5","white":"71.1","black":"14.9","asian":"9.5","hispanicOrLatino":"23.1"}},"wageData":{"2017":{"workers":"381","median":"654","maleWorkers":"303","maleMedian":"679","femaleWorkers":"78","femaleMedian":"574"}}},"Prepress technicians and workers":{"ageData":{"2017":{"total":"24","16to19":"0","20to24":"2","25to34":"4","35to44":"5","45to54":"8","55to64":"4","65+":"1","medianAge":"4"}},"title":"Prepress technicians and workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"24","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"13","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Printing press operators":{"ageData":{"2017":{"total":"173","16to19":"4","20to24":"14","25to34":"29","35to44":"39","45to54":"45","55to64":"35","65+":"6","medianAge":"35"}},"title":"Printing press operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"173","women":"17.7","white":"85.0","black":"6.6","asian":"5.8","hispanicOrLatino":"22.2"}},"wageData":{"2017":{"workers":"151","median":"758","maleWorkers":"126","maleMedian":"789","femaleWorkers":"26","femaleMedian":"-"}}},"Print binding and finishing workers":{"ageData":{"2017":{"total":"11","16to19":"0","20to24":"2","25to34":"1","35to44":"3","45to54":"1","55to64":"3","65+":"2","medianAge":"3"}},"title":"Print binding and finishing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"11","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"8","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Laundry and dry-cleaning workers":{"ageData":{"2017":{"total":"151","16to19":"4","20to24":"12","25to34":"21","35to44":"36","45to54":"36","55to64":"33","65+":"9","medianAge":"33"}},"title":"Laundry and dry-cleaning workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"151","women":"68.0","white":"66.1","black":"18.5","asian":"8.0","hispanicOrLatino":"38.7"}},"wageData":{"2017":{"workers":"106","median":"450","maleWorkers":"27","maleMedian":"-","femaleWorkers":"79","femaleMedian":"443"}}},"Pressers, textile, garment, and related materials":{"ageData":{"2017":{"total":"30","16to19":"0","20to24":"2","25to34":"3","35to44":"11","45to54":"12","55to64":"2","65+":"1","medianAge":"2"}},"title":"Pressers, textile, garment, and related materials","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"30","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"19","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Sewing machine operators":{"ageData":{"2017":{"total":"197","16to19":"3","20to24":"15","25to34":"31","35to44":"40","45to54":"49","55to64":"48","65+":"11","medianAge":"48"}},"title":"Sewing machine operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"197","women":"73.2","white":"72.0","black":"8.0","asian":"16.0","hispanicOrLatino":"42.2"}},"wageData":{"2017":{"workers":"157","median":"519","maleWorkers":"49","maleMedian":"-","femaleWorkers":"108","femaleMedian":"521"}}},"Shoe and leather workers and repairers":{"ageData":{"2017":{"total":"5","16to19":"0","20to24":"1","25to34":"1","35to44":"0","45to54":"0","55to64":"1","65+":"2","medianAge":"1"}},"title":"Shoe and leather workers and repairers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Shoe machine operators and tenders":{"ageData":{"2017":{"total":"5","16to19":"0","20to24":"1","25to34":"1","35to44":"2","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Shoe machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"3","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Tailors, dressmakers, and sewers":{"ageData":{"2017":{"total":"77","16to19":"2","20to24":"2","25to34":"10","35to44":"15","45to54":"17","55to64":"17","65+":"14","medianAge":"17"}},"title":"Tailors, dressmakers, and sewers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"77","women":"75.9","white":"79.1","black":"9.5","asian":"8.9","hispanicOrLatino":"29.6"}},"wageData":{"2017":{"workers":"31","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"21","femaleMedian":"-"}}},"Textile bleaching and dyeing machine operators and tenders":{"ageData":{"2017":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Textile bleaching and dyeing machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"1","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Textile cutting machine setters, operators, and tenders":{"ageData":{"2017":{"total":"8","16to19":"0","20to24":"0","25to34":"1","35to44":"3","45to54":"3","55to64":"0","65+":"2","medianAge":"0"}},"title":"Textile cutting machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"8","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"6","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Textile knitting and weaving machine setters, operators, and tenders":{"ageData":{"2017":{"total":"19","16to19":"0","20to24":"0","25to34":"3","35to44":"2","45to54":"7","55to64":"6","65+":"2","medianAge":"6"}},"title":"Textile knitting and weaving machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"19","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"17","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Textile winding, twisting, and drawing out machine setters, operators, and tenders":{"ageData":{"2017":{"total":"16","16to19":"1","20to24":"1","25to34":"1","35to44":"7","45to54":"3","55to64":"2","65+":"0","medianAge":"2"}},"title":"Textile winding, twisting, and drawing out machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"16","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"12","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Extruding and forming machine setters, operators, and tenders, synthetic and glass fibers":{"ageData":{"2017":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Extruding and forming machine setters, operators, and tenders, synthetic and glass fibers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"0","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Fabric and apparel patternmakers":{"ageData":{"2017":{"total":"3","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Fabric and apparel patternmakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"3","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Upholsterers":{"ageData":{"2017":{"total":"31","16to19":"0","20to24":"2","25to34":"4","35to44":"7","45to54":"11","55to64":"4","65+":"3","medianAge":"4"}},"title":"Upholsterers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"31","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"22","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Textile, apparel, and furnishings workers, all other":{"ageData":{"2017":{"total":"18","16to19":"1","20to24":"2","25to34":"3","35to44":"2","45to54":"5","55to64":"3","65+":"3","medianAge":"3"}},"title":"Textile, apparel, and furnishings workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"18","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"19","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Cabinetmakers and bench carpenters":{"ageData":{"2017":{"total":"49","16to19":"0","20to24":"2","25to34":"13","35to44":"12","45to54":"7","55to64":"11","65+":"4","medianAge":"11"}},"title":"Cabinetmakers and bench carpenters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"49","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"38","median":"-","maleWorkers":"36","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Furniture finishers":{"ageData":{"2017":{"total":"15","16to19":"0","20to24":"0","25to34":"3","35to44":"2","45to54":"4","55to64":"3","65+":"3","medianAge":"3"}},"title":"Furniture finishers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"15","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"8","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Model makers and patternmakers, wood":{"ageData":{"2017":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Model makers and patternmakers, wood","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"1","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Sawing machine setters, operators, and tenders, wood":{"ageData":{"2017":{"total":"27","16to19":"1","20to24":"3","25to34":"8","35to44":"6","45to54":"5","55to64":"4","65+":"0","medianAge":"4"}},"title":"Sawing machine setters, operators, and tenders, wood","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"27","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"26","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Woodworking machine setters, operators, and tenders, except sawing":{"ageData":{"2017":{"total":"19","16to19":"0","20to24":"4","25to34":"5","35to44":"2","45to54":"2","55to64":"6","65+":"1","medianAge":"6"}},"title":"Woodworking machine setters, operators, and tenders, except sawing","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"19","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"16","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Woodworkers, all other":{"ageData":{"2017":{"total":"28","16to19":"1","20to24":"2","25to34":"3","35to44":"6","45to54":"5","55to64":"8","65+":"4","medianAge":"8"}},"title":"Woodworkers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"28","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"19","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Power plant operators, distributors, and dispatchers":{"ageData":{"2017":{"total":"38","16to19":"0","20to24":"2","25to34":"7","35to44":"8","45to54":"12","55to64":"9","65+":"0","medianAge":"9"}},"title":"Power plant operators, distributors, and dispatchers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"38","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"47","median":"-","maleWorkers":"45","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Stationary engineers and boiler operators":{"ageData":{"2017":{"total":"76","16to19":"0","20to24":"2","25to34":"11","35to44":"15","45to54":"24","55to64":"20","65+":"5","medianAge":"20"}},"title":"Stationary engineers and boiler operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"76","women":"3.3","white":"84.8","black":"8.2","asian":"5.5","hispanicOrLatino":"13.0"}},"wageData":{"2017":{"workers":"76","median":"1,088","maleWorkers":"72","maleMedian":"1,142","femaleWorkers":"4","femaleMedian":"-"}}},"Water and wastewater treatment plant and system operators":{"ageData":{"2017":{"total":"107","16to19":"0","20to24":"5","25to34":"24","35to44":"22","45to54":"26","55to64":"25","65+":"5","medianAge":"25"}},"title":"Water and wastewater treatment plant and system operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"107","women":"3.8","white":"90.2","black":"6.3","asian":"1.0","hispanicOrLatino":"11.5"}},"wageData":{"2017":{"workers":"107","median":"907","maleWorkers":"102","maleMedian":"910","femaleWorkers":"5","femaleMedian":"-"}}},"Miscellaneous plant and system operators":{"ageData":{"2017":{"total":"42","16to19":"0","20to24":"3","25to34":"13","35to44":"9","45to54":"9","55to64":"8","65+":"0","medianAge":"8"}},"title":"Miscellaneous plant and system operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"42","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"41","median":"-","maleWorkers":"34","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Chemical processing machine setters, operators, and tenders":{"ageData":{"2017":{"total":"55","16to19":"1","20to24":"5","25to34":"18","35to44":"6","45to54":"14","55to64":"11","65+":"0","medianAge":"11"}},"title":"Chemical processing machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"55","women":"5.7","white":"79.3","black":"15.7","asian":"3.0","hispanicOrLatino":"15.8"}},"wageData":{"2017":{"workers":"58","median":"877","maleWorkers":"55","maleMedian":"879","femaleWorkers":"3","femaleMedian":"-"}}},"Crushing, grinding, polishing, mixing, and blending workers":{"ageData":{"2017":{"total":"72","16to19":"2","20to24":"7","25to34":"21","35to44":"10","45to54":"19","55to64":"11","65+":"2","medianAge":"11"}},"title":"Crushing, grinding, polishing, mixing, and blending workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"72","women":"14.0","white":"75.4","black":"15.3","asian":"2.2","hispanicOrLatino":"15.0"}},"wageData":{"2017":{"workers":"70","median":"771","maleWorkers":"62","maleMedian":"795","femaleWorkers":"8","femaleMedian":"-"}}},"Cutting workers":{"ageData":{"2017":{"total":"62","16to19":"2","20to24":"9","25to34":"14","35to44":"8","45to54":"12","55to64":"13","65+":"3","medianAge":"13"}},"title":"Cutting workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"62","women":"25.3","white":"78.7","black":"12.4","asian":"5.2","hispanicOrLatino":"30.1"}},"wageData":{"2017":{"workers":"51","median":"521","maleWorkers":"40","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Extruding, forming, pressing, and compacting machine setters, operators, and tenders":{"ageData":{"2017":{"total":"21","16to19":"1","20to24":"1","25to34":"4","35to44":"3","45to54":"10","55to64":"2","65+":"1","medianAge":"2"}},"title":"Extruding, forming, pressing, and compacting machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"21","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"13","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Furnace, kiln, oven, drier, and kettle operators and tenders":{"ageData":{"2017":{"total":"10","16to19":"1","20to24":"0","25to34":"3","35to44":"2","45to54":"3","55to64":"0","65+":"0","medianAge":"0"}},"title":"Furnace, kiln, oven, drier, and kettle operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"10","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Inspectors, testers, sorters, samplers, and weighers":{"ageData":{"2017":{"total":"793","16to19":"7","20to24":"64","25to34":"195","35to44":"152","45to54":"173","55to64":"157","65+":"45","medianAge":"157"}},"title":"Inspectors, testers, sorters, samplers, and weighers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"793","women":"37.9","white":"74.7","black":"13.6","asian":"8.8","hispanicOrLatino":"18.9"}},"wageData":{"2017":{"workers":"717","median":"765","maleWorkers":"443","maleMedian":"853","femaleWorkers":"275","femaleMedian":"637"}}},"Jewelers and precious stone and metal workers":{"ageData":{"2017":{"total":"43","16to19":"0","20to24":"4","25to34":"6","35to44":"9","45to54":"7","55to64":"13","65+":"3","medianAge":"13"}},"title":"Jewelers and precious stone and metal workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"43","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"24","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Medical, dental, and ophthalmic laboratory technicians":{"ageData":{"2017":{"total":"70","16to19":"1","20to24":"8","25to34":"17","35to44":"14","45to54":"17","55to64":"7","65+":"6","medianAge":"7"}},"title":"Medical, dental, and ophthalmic laboratory technicians","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"70","women":"63.1","white":"73.3","black":"14.6","asian":"9.7","hispanicOrLatino":"14.4"}},"wageData":{"2017":{"workers":"57","median":"598","maleWorkers":"16","maleMedian":"-","femaleWorkers":"40","femaleMedian":"-"}}},"Packaging and filling machine operators and tenders":{"ageData":{"2017":{"total":"292","16to19":"6","20to24":"27","25to34":"75","35to44":"55","45to54":"68","55to64":"49","65+":"13","medianAge":"49"}},"title":"Packaging and filling machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"292","women":"52.8","white":"68.5","black":"17.6","asian":"9.2","hispanicOrLatino":"41.8"}},"wageData":{"2017":{"workers":"275","median":"553","maleWorkers":"128","maleMedian":"598","femaleWorkers":"147","femaleMedian":"516"}}},"Painting workers":{"ageData":{"2017":{"total":"157","16to19":"5","20to24":"16","25to34":"36","35to44":"40","45to54":"31","55to64":"26","65+":"3","medianAge":"26"}},"title":"Painting workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"157","women":"12.6","white":"82.1","black":"9.6","asian":"2.5","hispanicOrLatino":"32.9"}},"wageData":{"2017":{"workers":"131","median":"693","maleWorkers":"117","maleMedian":"705","femaleWorkers":"14","femaleMedian":"-"}}},"Photographic process workers and processing machine operators":{"ageData":{"2017":{"total":"31","16to19":"2","20to24":"4","25to34":"6","35to44":"6","45to54":"9","55to64":"3","65+":"1","medianAge":"3"}},"title":"Photographic process workers and processing machine operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"31","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"23","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Semiconductor processors":{"ageData":{"2017":{"total":"3","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Semiconductor processors","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"3","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"2","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Adhesive bonding machine operators and tenders":{"ageData":{"2017":{"total":"6","16to19":"0","20to24":"3","25to34":"0","35to44":"0","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Adhesive bonding machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"6","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Cleaning, washing, and metal pickling equipment operators and tenders":{"ageData":{"2017":{"total":"11","16to19":"0","20to24":"2","25to34":"1","35to44":"0","45to54":"3","55to64":"4","65+":"0","medianAge":"4"}},"title":"Cleaning, washing, and metal pickling equipment operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"11","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"10","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Cooling and freezing equipment operators and tenders":{"ageData":{"2017":{"total":"3","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Cooling and freezing equipment operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"3","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Etchers and engravers":{"ageData":{"2017":{"total":"11","16to19":"0","20to24":"1","25to34":"3","35to44":"1","45to54":"1","55to64":"3","65+":"1","medianAge":"3"}},"title":"Etchers and engravers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"11","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"5","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Molders, shapers, and casters, except metal and plastic":{"ageData":{"2017":{"total":"35","16to19":"0","20to24":"4","25to34":"9","35to44":"10","45to54":"6","55to64":"5","65+":"0","medianAge":"5"}},"title":"Molders, shapers, and casters, except metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"35","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"25","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Paper goods machine setters, operators, and tenders":{"ageData":{"2017":{"total":"29","16to19":"0","20to24":"4","25to34":"12","35to44":"3","45to54":"7","55to64":"4","65+":"0","medianAge":"4"}},"title":"Paper goods machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"29","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"28","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Tire builders":{"ageData":{"2017":{"total":"10","16to19":"0","20to24":"0","25to34":"5","35to44":"3","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Tire builders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"10","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"10","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers--production workers":{"ageData":{"2017":{"total":"50","16to19":"5","20to24":"10","25to34":"12","35to44":"5","45to54":"11","55to64":"6","65+":"1","medianAge":"6"}},"title":"Helpers--production workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"50","women":"37.1","white":"73.5","black":"8.8","asian":"11.9","hispanicOrLatino":"31.2"}},"wageData":{"2017":{"workers":"30","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Production workers, all other":{"ageData":{"2017":{"total":"995","16to19":"19","20to24":"107","25to34":"225","35to44":"212","45to54":"218","55to64":"176","65+":"39","medianAge":"176"}},"title":"Production workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2017":{"total":"995","women":"29.5","white":"76.5","black":"15.7","asian":"4.4","hispanicOrLatino":"25.4"}},"wageData":{"2017":{"workers":"890","median":"663","maleWorkers":"653","maleMedian":"716","femaleWorkers":"238","femaleMedian":"570"}}},"Transportation and material moving occupations":{"ageData":{"2017":{"total":"9,445","16to19":"342","20to24":"954","25to34":"1,880","35to44":"1,788","45to54":"2,118","55to64":"1,727","65+":"637","medianAge":"1,727"}},"title":"Transportation and material moving occupations","depth":2,"parent":"Production, transportation, and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"9,445","women":"17.3","white":"71.9","black":"19.5","asian":"4.5","hispanicOrLatino":"21.7"}},"wageData":{"2017":{"workers":"7,236","median":"681","maleWorkers":"6,160","maleMedian":"710","femaleWorkers":"1,075","femaleMedian":"514"}}},"Supervisors of transportation and material moving workers":{"ageData":{"2017":{"total":"205","16to19":"2","20to24":"7","25to34":"44","35to44":"57","45to54":"49","55to64":"36","65+":"10","medianAge":"36"}},"title":"Supervisors of transportation and material moving workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"205","women":"19.5","white":"74.0","black":"18.4","asian":"4.0","hispanicOrLatino":"17.4"}},"wageData":{"2017":{"workers":"192","median":"881","maleWorkers":"160","maleMedian":"919","femaleWorkers":"31","femaleMedian":"-"}}},"Aircraft pilots and flight engineers":{"ageData":{"2017":{"total":"120","16to19":"0","20to24":"2","25to34":"19","35to44":"24","45to54":"40","55to64":"30","65+":"4","medianAge":"30"}},"title":"Aircraft pilots and flight engineers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"120","women":"6.2","white":"94.9","black":"1.8","asian":"1.5","hispanicOrLatino":"8.0"}},"wageData":{"2017":{"workers":"112","median":"1,736","maleWorkers":"105","maleMedian":"1,750","femaleWorkers":"7","femaleMedian":"-"}}},"Air traffic controllers and airfield operations specialists":{"ageData":{"2017":{"total":"17","16to19":"0","20to24":"0","25to34":"7","35to44":"3","45to54":"3","55to64":"4","65+":"0","medianAge":"4"}},"title":"Air traffic controllers and airfield operations specialists","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"17","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"16","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Flight attendants":{"ageData":{"2017":{"total":"98","16to19":"0","20to24":"2","25to34":"18","35to44":"18","45to54":"29","55to64":"24","65+":"7","medianAge":"24"}},"title":"Flight attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"98","women":"72.9","white":"71.6","black":"15.1","asian":"10.1","hispanicOrLatino":"18.4"}},"wageData":{"2017":{"workers":"71","median":"860","maleWorkers":"20","maleMedian":"-","femaleWorkers":"51","femaleMedian":"873"}}},"Ambulance drivers and attendants, except emergency medical technicians":{"ageData":{"2017":{"total":"11","16to19":"0","20to24":"4","25to34":"2","35to44":"0","45to54":"0","55to64":"2","65+":"2","medianAge":"2"}},"title":"Ambulance drivers and attendants, except emergency medical technicians","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"11","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"8","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Bus drivers":{"ageData":{"2017":{"total":"578","16to19":"1","20to24":"20","25to34":"62","35to44":"82","45to54":"155","55to64":"161","65+":"97","medianAge":"161"}},"title":"Bus drivers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"578","women":"47.8","white":"65.9","black":"26.7","asian":"4.8","hispanicOrLatino":"12.6"}},"wageData":{"2017":{"workers":"356","median":"605","maleWorkers":"209","maleMedian":"671","femaleWorkers":"148","femaleMedian":"517"}}},"Driver/sales workers and truck drivers":{"ageData":{"2017":{"total":"3,506","16to19":"47","20to24":"232","25to34":"601","35to44":"736","45to54":"916","55to64":"721","65+":"251","medianAge":"721"}},"title":"Driver/sales workers and truck drivers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"3,506","women":"6.2","white":"76.3","black":"16.6","asian":"3.2","hispanicOrLatino":"20.8"}},"wageData":{"2017":{"workers":"2,828","median":"797","maleWorkers":"2,689","maleMedian":"807","femaleWorkers":"139","femaleMedian":"589"}}},"Taxi drivers and chauffeurs":{"ageData":{"2017":{"total":"674","16to19":"5","20to24":"30","25to34":"136","35to44":"135","45to54":"158","55to64":"133","65+":"76","medianAge":"133"}},"title":"Taxi drivers and chauffeurs","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"674","women":"18.9","white":"55.0","black":"28.4","asian":"12.8","hispanicOrLatino":"17.0"}},"wageData":{"2017":{"workers":"362","median":"604","maleWorkers":"308","maleMedian":"623","femaleWorkers":"54","femaleMedian":"453"}}},"Motor vehicle operators, all other":{"ageData":{"2017":{"total":"76","16to19":"2","20to24":"10","25to34":"12","35to44":"5","45to54":"10","55to64":"17","65+":"20","medianAge":"17"}},"title":"Motor vehicle operators, all other","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"76","women":"17.5","white":"72.6","black":"19.4","asian":"4.8","hispanicOrLatino":"14.7"}},"wageData":{"2017":{"workers":"33","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Locomotive engineers and operators":{"ageData":{"2017":{"total":"42","16to19":"0","20to24":"1","25to34":"9","35to44":"11","45to54":"11","55to64":"10","65+":"0","medianAge":"10"}},"title":"Locomotive engineers and operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"42","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"43","median":"-","maleWorkers":"36","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Railroad brake, signal, and switch operators":{"ageData":{"2017":{"total":"4","16to19":"0","20to24":"0","25to34":"0","35to44":"2","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Railroad brake, signal, and switch operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"4","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Railroad conductors and yardmasters":{"ageData":{"2017":{"total":"50","16to19":"0","20to24":"2","25to34":"14","35to44":"13","45to54":"14","55to64":"5","65+":"0","medianAge":"5"}},"title":"Railroad conductors and yardmasters","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"50","women":"5.2","white":"73.8","black":"17.6","asian":"5.3","hispanicOrLatino":"8.4"}},"wageData":{"2017":{"workers":"42","median":"-","maleWorkers":"39","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Subway, streetcar, and other rail transportation workers":{"ageData":{"2017":{"total":"15","16to19":"0","20to24":"1","25to34":"4","35to44":"2","45to54":"4","55to64":"2","65+":"1","medianAge":"2"}},"title":"Subway, streetcar, and other rail transportation workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"15","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"9","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Sailors and marine oilers":{"ageData":{"2017":{"total":"19","16to19":"0","20to24":"3","25to34":"4","35to44":"6","45to54":"3","55to64":"2","65+":"0","medianAge":"2"}},"title":"Sailors and marine oilers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"19","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"19","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Ship and boat captains and operators":{"ageData":{"2017":{"total":"35","16to19":"0","20to24":"1","25to34":"9","35to44":"8","45to54":"9","55to64":"5","65+":"3","medianAge":"5"}},"title":"Ship and boat captains and operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"35","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"29","median":"-","maleWorkers":"29","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Ship engineers":{"ageData":{"2017":{"total":"2","16to19":"0","20to24":"1","25to34":"0","35to44":"0","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Ship engineers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"2","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Bridge and lock tenders":{"ageData":{"2017":{"total":"5","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"2","55to64":"0","65+":"2","medianAge":"0"}},"title":"Bridge and lock tenders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"5","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"5","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Parking lot attendants":{"ageData":{"2017":{"total":"95","16to19":"8","20to24":"21","25to34":"19","35to44":"17","45to54":"14","55to64":"8","65+":"8","medianAge":"8"}},"title":"Parking lot attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"95","women":"16.7","white":"67.4","black":"23.3","asian":"6.7","hispanicOrLatino":"38.4"}},"wageData":{"2017":{"workers":"65","median":"560","maleWorkers":"49","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Automotive and watercraft service attendants":{"ageData":{"2017":{"total":"94","16to19":"15","20to24":"16","25to34":"19","35to44":"15","45to54":"15","55to64":"12","65+":"2","medianAge":"12"}},"title":"Automotive and watercraft service attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"94","women":"8.8","white":"73.6","black":"9.6","asian":"8.9","hispanicOrLatino":"21.1"}},"wageData":{"2017":{"workers":"80","median":"514","maleWorkers":"73","maleMedian":"535","femaleWorkers":"7","femaleMedian":"-"}}},"Transportation inspectors":{"ageData":{"2017":{"total":"41","16to19":"0","20to24":"0","25to34":"8","35to44":"4","45to54":"12","55to64":"14","65+":"2","medianAge":"14"}},"title":"Transportation inspectors","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"41","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"41","median":"-","maleWorkers":"33","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Transportation attendants, except flight attendants":{"ageData":{"2017":{"total":"35","16to19":"0","20to24":"2","25to34":"8","35to44":"6","45to54":"6","55to64":"7","65+":"7","medianAge":"7"}},"title":"Transportation attendants, except flight attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"35","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"21","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Other transportation workers":{"ageData":{"2017":{"total":"24","16to19":"1","20to24":"2","25to34":"5","35to44":"3","45to54":"9","55to64":"5","65+":"0","medianAge":"5"}},"title":"Other transportation workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"24","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"20","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Conveyor operators and tenders":{"ageData":{"2017":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Conveyor operators and tenders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"1","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Crane and tower operators":{"ageData":{"2017":{"total":"53","16to19":"0","20to24":"4","25to34":"17","35to44":"9","45to54":"12","55to64":"5","65+":"6","medianAge":"5"}},"title":"Crane and tower operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"53","women":"4.1","white":"76.8","black":"20.9","asian":"0.1","hispanicOrLatino":"10.5"}},"wageData":{"2017":{"workers":"52","median":"902","maleWorkers":"51","maleMedian":"898","femaleWorkers":"1","femaleMedian":"-"}}},"Dredge, excavating, and loading machine operators":{"ageData":{"2017":{"total":"30","16to19":"0","20to24":"2","25to34":"7","35to44":"7","45to54":"6","55to64":"4","65+":"3","medianAge":"4"}},"title":"Dredge, excavating, and loading machine operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"30","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"29","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Hoist and winch operators":{"ageData":{"2017":{"total":"7","16to19":"0","20to24":"0","25to34":"3","35to44":"1","45to54":"0","55to64":"3","65+":"0","medianAge":"3"}},"title":"Hoist and winch operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"7","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Industrial truck and tractor operators":{"ageData":{"2017":{"total":"611","16to19":"6","20to24":"68","25to34":"151","35to44":"112","45to54":"142","55to64":"119","65+":"13","medianAge":"119"}},"title":"Industrial truck and tractor operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"611","women":"8.2","white":"69.4","black":"25.0","asian":"1.8","hispanicOrLatino":"25.7"}},"wageData":{"2017":{"workers":"584","median":"624","maleWorkers":"538","maleMedian":"632","femaleWorkers":"46","femaleMedian":"-"}}},"Cleaners of vehicles and equipment":{"ageData":{"2017":{"total":"331","16to19":"42","20to24":"72","25to34":"74","35to44":"49","45to54":"45","55to64":"42","65+":"9","medianAge":"42"}},"title":"Cleaners of vehicles and equipment","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"331","women":"14.0","white":"69.7","black":"20.7","asian":"3.0","hispanicOrLatino":"33.3"}},"wageData":{"2017":{"workers":"237","median":"530","maleWorkers":"197","maleMedian":"531","femaleWorkers":"40","femaleMedian":"-"}}},"Laborers and freight, stock, and material movers, hand":{"ageData":{"2017":{"total":"1,930","16to19":"146","20to24":"360","25to34":"479","35to44":"314","45to54":"309","55to64":"256","65+":"67","medianAge":"256"}},"title":"Laborers and freight, stock, and material movers, hand","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"1,930","women":"19.9","white":"70.2","black":"20.2","asian":"3.8","hispanicOrLatino":"22.2"}},"wageData":{"2017":{"workers":"1,450","median":"578","maleWorkers":"1,196","maleMedian":"595","femaleWorkers":"254","femaleMedian":"500"}}},"Machine feeders and offbearers":{"ageData":{"2017":{"total":"31","16to19":"2","20to24":"5","25to34":"6","35to44":"5","45to54":"5","55to64":"6","65+":"2","medianAge":"6"}},"title":"Machine feeders and offbearers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"31","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"29","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"15","femaleMedian":"-"}}},"Packers and packagers, hand":{"ageData":{"2017":{"total":"539","16to19":"60","20to24":"70","25to34":"112","35to44":"106","45to54":"98","55to64":"68","65+":"24","medianAge":"68"}},"title":"Packers and packagers, hand","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"539","women":"52.7","white":"69.9","black":"18.9","asian":"8.4","hispanicOrLatino":"41.8"}},"wageData":{"2017":{"workers":"368","median":"480","maleWorkers":"158","maleMedian":"500","femaleWorkers":"210","femaleMedian":"462"}}},"Pumping station operators":{"ageData":{"2017":{"total":"21","16to19":"0","20to24":"1","25to34":"6","35to44":"5","45to54":"4","55to64":"3","65+":"2","medianAge":"3"}},"title":"Pumping station operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"21","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"19","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Refuse and recyclable material collectors":{"ageData":{"2017":{"total":"94","16to19":"3","20to24":"7","25to34":"18","35to44":"20","45to54":"25","55to64":"12","65+":"9","medianAge":"12"}},"title":"Refuse and recyclable material collectors","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"94","women":"11.7","white":"70.2","black":"26.8","asian":"2.1","hispanicOrLatino":"24.2"}},"wageData":{"2017":{"workers":"56","median":"522","maleWorkers":"49","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Mine shuttle car operators":{"ageData":{"2017":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Mine shuttle car operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"0","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Tank car, truck, and ship loaders":{"ageData":{"2017":{"total":"6","16to19":"0","20to24":"2","25to34":"0","35to44":"2","45to54":"0","55to64":"0","65+":"1","medianAge":"0"}},"title":"Tank car, truck, and ship loaders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"6","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Material moving workers, all other":{"ageData":{"2017":{"total":"40","16to19":"0","20to24":"5","25to34":"5","35to44":"8","45to54":"9","55to64":"7","65+":"6","medianAge":"7"}},"title":"Material moving workers, all other","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2017":{"total":"40","women":"-","white":"-","black":"-","asian":"-","hispanicOrLatino":"-"}},"wageData":{"2017":{"workers":"41","median":"-","maleWorkers":"34","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}}}');


var $7475598ace082300$exports = {};
$7475598ace082300$exports = JSON.parse('{"Total":{"ageData":{"2016":{"total":"151,436","16to19":"4,965","20to24":"14,027","25to34":"33,722","35to44":"31,562","45to54":"32,720","55to64":"25,524","65+":"8,916","medianAge":"25,524"}},"title":"Total","depth":1,"parent":"","sexRaceEthnicityData":{"2016":{"total":"151,436","women":"46.8","white":"11.9","black":"6.1","asian":"16.7"}},"wageData":{"2016":{"workers":"111,091","median":"$832","maleWorkers":"61,930","maleMedian":"$915","femaleWorkers":"49,161","femaleMedian":"$749"}}},"Management, professional, and related occupations":{"ageData":{"2016":{"total":"59,438","16to19":"396","20to24":"3,118","25to34":"13,561","35to44":"13,926","45to54":"13,818","55to64":"10,689","65+":"3,931","medianAge":"10,689"}},"title":"Management, professional, and related occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2016":{"total":"59,438","women":"51.5","white":"9.1","black":"8.1","asian":"9.3"}},"wageData":{"2016":{"workers":"45,930","median":"1,188","maleWorkers":"22,256","maleMedian":"1,420","femaleWorkers":"23,674","femaleMedian":"1,027"}}},"Management, business, and financial operations occupations":{"ageData":{"2016":{"total":"24,941","16to19":"87","20to24":"938","25to34":"4,931","35to44":"5,772","45to54":"6,424","55to64":"4,929","65+":"1,860","medianAge":"4,929"}},"title":"Management, business, and financial operations occupations","depth":2,"parent":"Management, professional, and related occupations","sexRaceEthnicityData":{"2016":{"total":"24,941","women":"43.8","white":"8.2","black":"6.6","asian":"9.8"}},"wageData":{"2016":{"workers":"19,023","median":"1,284","maleWorkers":"10,261","maleMedian":"1,491","femaleWorkers":"8,761","femaleMedian":"1,099"}}},"Management occupations":{"ageData":{"2016":{"total":"17,418","16to19":"64","20to24":"532","25to34":"3,031","35to44":"4,097","45to54":"4,758","55to64":"3,539","65+":"1,395","medianAge":"3,539"}},"title":"Management occupations","depth":3,"parent":"Management, business, and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"17,418","women":"39.1","white":"7.5","black":"6.1","asian":"9.9"}},"wageData":{"2016":{"workers":"12,828","median":"1,370","maleWorkers":"7,514","maleMedian":"1,539","femaleWorkers":"5,314","femaleMedian":"1,148"}}},"Chief executives":{"ageData":{"2016":{"total":"1,649","16to19":"2","20to24":"11","25to34":"120","35to44":"309","45to54":"560","55to64":"449","65+":"198","medianAge":"449"}},"title":"Chief executives","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"1,649","women":"27.3","white":"3.4","black":"6.0","asian":"5.6"}},"wageData":{"2016":{"workers":"1,150","median":"2,303","maleWorkers":"832","maleMedian":"2,419","femaleWorkers":"318","femaleMedian":"1,876"}}},"General and operations managers":{"ageData":{"2016":{"total":"949","16to19":"2","20to24":"34","25to34":"231","35to44":"261","45to54":"245","55to64":"141","65+":"35","medianAge":"141"}},"title":"General and operations managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"949","women":"29.8","white":"7.1","black":"5.6","asian":"11.3"}},"wageData":{"2016":{"workers":"876","median":"1,266","maleWorkers":"626","maleMedian":"1,358","femaleWorkers":"250","femaleMedian":"1,037"}}},"Legislators":{"ageData":{"2016":{"total":"20","16to19":"0","20to24":"0","25to34":"2","35to44":"7","45to54":"3","55to64":"2","65+":"6","medianAge":"2"}},"title":"Legislators","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"20","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"11","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Advertising and promotions managers":{"ageData":{"2016":{"total":"67","16to19":"0","20to24":"2","25to34":"27","35to44":"12","45to54":"18","55to64":"2","65+":"4","medianAge":"2"}},"title":"Advertising and promotions managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"67","women":"56.5","white":"7.1","black":"1.3","asian":"4.8"}},"wageData":{"2016":{"workers":"56","median":"1,332","maleWorkers":"24","maleMedian":"-","femaleWorkers":"32","femaleMedian":"-"}}},"Marketing and sales managers":{"ageData":{"2016":{"total":"1,066","16to19":"7","20to24":"52","25to34":"261","35to44":"283","45to54":"263","55to64":"166","65+":"35","medianAge":"166"}},"title":"Marketing and sales managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"1,066","women":"45.3","white":"5.3","black":"6.0","asian":"9.9"}},"wageData":{"2016":{"workers":"921","median":"1,468","maleWorkers":"518","maleMedian":"1,745","femaleWorkers":"403","femaleMedian":"1,142"}}},"Public relations and fundraising managers":{"ageData":{"2016":{"total":"62","16to19":"0","20to24":"2","25to34":"19","35to44":"17","45to54":"16","55to64":"8","65+":"1","medianAge":"8"}},"title":"Public relations and fundraising managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"62","women":"70.9","white":"10.3","black":"5.4","asian":"3.3"}},"wageData":{"2016":{"workers":"60","median":"1,532","maleWorkers":"21","maleMedian":"-","femaleWorkers":"38","femaleMedian":"-"}}},"Administrative services managers":{"ageData":{"2016":{"total":"181","16to19":"1","20to24":"6","25to34":"29","35to44":"29","45to54":"63","55to64":"44","65+":"9","medianAge":"44"}},"title":"Administrative services managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"181","women":"42.6","white":"13.2","black":"3.4","asian":"10.0"}},"wageData":{"2016":{"workers":"172","median":"1,261","maleWorkers":"101","maleMedian":"1,398","femaleWorkers":"71","femaleMedian":"952"}}},"Computer and information systems managers":{"ageData":{"2016":{"total":"597","16to19":"1","20to24":"9","25to34":"95","35to44":"178","45to54":"202","55to64":"95","65+":"18","medianAge":"95"}},"title":"Computer and information systems managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"597","women":"25.5","white":"6.2","black":"15.2","asian":"6.7"}},"wageData":{"2016":{"workers":"592","median":"1,738","maleWorkers":"443","maleMedian":"1,756","femaleWorkers":"150","femaleMedian":"1,680"}}},"Financial managers":{"ageData":{"2016":{"total":"1,197","16to19":"2","20to24":"31","25to34":"251","35to44":"340","45to54":"321","55to64":"196","65+":"57","medianAge":"196"}},"title":"Financial managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"1,197","women":"52.5","white":"6.9","black":"8.3","asian":"10.3"}},"wageData":{"2016":{"workers":"1,105","median":"1,423","maleWorkers":"527","maleMedian":"1,670","femaleWorkers":"578","femaleMedian":"1,157"}}},"Compensation and benefits managers":{"ageData":{"2016":{"total":"20","16to19":"0","20to24":"0","25to34":"5","35to44":"6","45to54":"5","55to64":"4","65+":"0","medianAge":"4"}},"title":"Compensation and benefits managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"20","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"16","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Human resources managers":{"ageData":{"2016":{"total":"287","16to19":"0","20to24":"6","25to34":"44","35to44":"97","45to54":"84","55to64":"44","65+":"11","medianAge":"44"}},"title":"Human resources managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"287","women":"74.2","white":"13.5","black":"4.9","asian":"11.2"}},"wageData":{"2016":{"workers":"263","median":"1,340","maleWorkers":"73","maleMedian":"1,737","femaleWorkers":"190","femaleMedian":"1,283"}}},"Training and development managers":{"ageData":{"2016":{"total":"58","16to19":"1","20to24":"2","25to34":"10","35to44":"14","45to54":"18","55to64":"11","65+":"0","medianAge":"11"}},"title":"Training and development managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"58","women":"58.5","white":"8.3","black":"2.1","asian":"8.5"}},"wageData":{"2016":{"workers":"58","median":"1,507","maleWorkers":"27","maleMedian":"-","femaleWorkers":"31","femaleMedian":"-"}}},"Industrial production managers":{"ageData":{"2016":{"total":"275","16to19":"0","20to24":"6","25to34":"44","35to44":"66","45to54":"85","55to64":"63","65+":"11","medianAge":"63"}},"title":"Industrial production managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"275","women":"23.2","white":"4.9","black":"9.2","asian":"7.4"}},"wageData":{"2016":{"workers":"267","median":"1,361","maleWorkers":"201","maleMedian":"1,409","femaleWorkers":"66","femaleMedian":"1,219"}}},"Purchasing managers":{"ageData":{"2016":{"total":"203","16to19":"0","20to24":"8","25to34":"29","35to44":"45","45to54":"50","55to64":"56","65+":"14","medianAge":"56"}},"title":"Purchasing managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"203","women":"47.4","white":"9.1","black":"2.9","asian":"10.6"}},"wageData":{"2016":{"workers":"187","median":"1,274","maleWorkers":"95","maleMedian":"1,400","femaleWorkers":"92","femaleMedian":"1,169"}}},"Transportation, storage, and distribution managers":{"ageData":{"2016":{"total":"299","16to19":"1","20to24":"15","25to34":"60","35to44":"78","45to54":"80","55to64":"51","65+":"13","medianAge":"51"}},"title":"Transportation, storage, and distribution managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"299","women":"17.1","white":"11.4","black":"4.8","asian":"18.4"}},"wageData":{"2016":{"workers":"288","median":"990","maleWorkers":"237","maleMedian":"990","femaleWorkers":"51","femaleMedian":"988"}}},"Farmers, ranchers, and other agricultural managers":{"ageData":{"2016":{"total":"1,042","16to19":"8","20to24":"25","25to34":"122","35to44":"139","45to54":"192","55to64":"264","65+":"293","medianAge":"264"}},"title":"Farmers, ranchers, and other agricultural managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"1,042","women":"24.8","white":"1.0","black":"1.0","asian":"4.7"}},"wageData":{"2016":{"workers":"119","median":"892","maleWorkers":"102","maleMedian":"906","femaleWorkers":"17","femaleMedian":"-"}}},"Construction managers":{"ageData":{"2016":{"total":"812","16to19":"4","20to24":"14","25to34":"140","35to44":"177","45to54":"237","55to64":"188","65+":"54","medianAge":"188"}},"title":"Construction managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"812","women":"7.4","white":"3.8","black":"2.0","asian":"11.0"}},"wageData":{"2016":{"workers":"487","median":"1,395","maleWorkers":"452","maleMedian":"1,401","femaleWorkers":"35","femaleMedian":"-"}}},"Education administrators":{"ageData":{"2016":{"total":"954","16to19":"5","20to24":"24","25to34":"134","35to44":"260","45to54":"280","55to64":"176","65+":"76","medianAge":"176"}},"title":"Education administrators","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"954","women":"65.1","white":"14.3","black":"2.2","asian":"8.8"}},"wageData":{"2016":{"workers":"838","median":"1,381","maleWorkers":"297","maleMedian":"1,528","femaleWorkers":"541","femaleMedian":"1,280"}}},"Architectural and engineering managers":{"ageData":{"2016":{"total":"136","16to19":"0","20to24":"0","25to34":"16","35to44":"39","45to54":"39","55to64":"34","65+":"7","medianAge":"34"}},"title":"Architectural and engineering managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"136","women":"5.3","white":"4.2","black":"10.6","asian":"3.8"}},"wageData":{"2016":{"workers":"143","median":"2,258","maleWorkers":"134","maleMedian":"2,265","femaleWorkers":"9","femaleMedian":"-"}}},"Food service managers":{"ageData":{"2016":{"total":"1,157","16to19":"20","20to24":"140","25to34":"303","35to44":"228","45to54":"254","55to64":"165","65+":"47","medianAge":"165"}},"title":"Food service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"1,157","women":"45.9","white":"10.2","black":"12.0","asian":"17.7"}},"wageData":{"2016":{"workers":"760","median":"739","maleWorkers":"410","maleMedian":"853","femaleWorkers":"350","femaleMedian":"632"}}},"Funeral service managers":{"ageData":{"2016":{"total":"15","16to19":"0","20to24":"0","25to34":"3","35to44":"4","45to54":"2","55to64":"4","65+":"2","medianAge":"4"}},"title":"Funeral service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"15","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"13","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Gaming managers":{"ageData":{"2016":{"total":"16","16to19":"0","20to24":"1","25to34":"5","35to44":"4","45to54":"3","55to64":"2","65+":"1","medianAge":"2"}},"title":"Gaming managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"16","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"18","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Lodging managers":{"ageData":{"2016":{"total":"166","16to19":"2","20to24":"9","25to34":"35","35to44":"42","45to54":"39","55to64":"28","65+":"11","medianAge":"28"}},"title":"Lodging managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"166","women":"52.2","white":"9.7","black":"15.8","asian":"9.0"}},"wageData":{"2016":{"workers":"124","median":"929","maleWorkers":"59","maleMedian":"1,068","femaleWorkers":"64","femaleMedian":"764"}}},"Medical and health services managers":{"ageData":{"2016":{"total":"593","16to19":"0","20to24":"11","25to34":"102","35to44":"148","45to54":"165","55to64":"132","65+":"35","medianAge":"132"}},"title":"Medical and health services managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"593","women":"72.3","white":"13.2","black":"5.4","asian":"10.2"}},"wageData":{"2016":{"workers":"533","median":"1,402","maleWorkers":"133","maleMedian":"1,610","femaleWorkers":"399","femaleMedian":"1,254"}}},"Natural sciences managers":{"ageData":{"2016":{"total":"14","16to19":"0","20to24":"2","25to34":"4","35to44":"4","45to54":"1","55to64":"4","65+":"0","medianAge":"4"}},"title":"Natural sciences managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"14","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Postmasters and mail superintendents":{"ageData":{"2016":{"total":"25","16to19":"0","20to24":"1","25to34":"0","35to44":"3","45to54":"10","55to64":"10","65+":"1","medianAge":"10"}},"title":"Postmasters and mail superintendents","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"25","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"23","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Property, real estate, and community association managers":{"ageData":{"2016":{"total":"709","16to19":"1","20to24":"11","25to34":"114","35to44":"141","45to54":"173","55to64":"164","65+":"106","medianAge":"164"}},"title":"Property, real estate, and community association managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"709","women":"46.5","white":"9.0","black":"3.6","asian":"11.3"}},"wageData":{"2016":{"workers":"402","median":"959","maleWorkers":"181","maleMedian":"1,157","femaleWorkers":"221","femaleMedian":"815"}}},"Social and community service managers":{"ageData":{"2016":{"total":"421","16to19":"0","20to24":"20","25to34":"96","35to44":"92","45to54":"93","55to64":"87","65+":"32","medianAge":"87"}},"title":"Social and community service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"421","women":"70.5","white":"15.4","black":"4.8","asian":"11.0"}},"wageData":{"2016":{"workers":"363","median":"1,079","maleWorkers":"115","maleMedian":"1,206","femaleWorkers":"248","femaleMedian":"992"}}},"Emergency management directors":{"ageData":{"2016":{"total":"10","16to19":"0","20to24":"0","25to34":"1","35to44":"2","45to54":"4","55to64":"3","65+":"0","medianAge":"3"}},"title":"Emergency management directors","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"8","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Managers, all other":{"ageData":{"2016":{"total":"4,420","16to19":"7","20to24":"91","25to34":"728","35to44":"1,073","45to54":"1,254","55to64":"947","65+":"320","medianAge":"947"}},"title":"Managers, all other","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2016":{"total":"4,420","women":"34.4","white":"7.2","black":"6.3","asian":"10.2"}},"wageData":{"2016":{"workers":"2,960","median":"1,422","maleWorkers":"1,845","maleMedian":"1,542","femaleWorkers":"1,115","femaleMedian":"1,188"}}},"Business and financial operations occupations":{"ageData":{"2016":{"total":"7,523","16to19":"22","20to24":"406","25to34":"1,900","35to44":"1,675","45to54":"1,666","55to64":"1,389","65+":"465","medianAge":"1,389"}},"title":"Business and financial operations occupations","depth":3,"parent":"Management, business, and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"7,523","women":"54.7","white":"9.7","black":"7.8","asian":"9.8"}},"wageData":{"2016":{"workers":"6,195","median":"1,161","maleWorkers":"2,747","maleMedian":"1,373","femaleWorkers":"3,448","femaleMedian":"1,018"}}},"Agents and business managers of artists, performers, and athletes":{"ageData":{"2016":{"total":"38","16to19":"0","20to24":"3","25to34":"12","35to44":"8","45to54":"6","55to64":"3","65+":"5","medianAge":"3"}},"title":"Agents and business managers of artists, performers, and athletes","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"38","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"23","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Buyers and purchasing agents, farm products":{"ageData":{"2016":{"total":"11","16to19":"1","20to24":"1","25to34":"2","35to44":"1","45to54":"1","55to64":"5","65+":"1","medianAge":"5"}},"title":"Buyers and purchasing agents, farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"8","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Wholesale and retail buyers, except farm products":{"ageData":{"2016":{"total":"207","16to19":"4","20to24":"18","25to34":"43","35to44":"33","45to54":"44","55to64":"49","65+":"17","medianAge":"49"}},"title":"Wholesale and retail buyers, except farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"207","women":"53.1","white":"6.4","black":"4.4","asian":"11.8"}},"wageData":{"2016":{"workers":"152","median":"838","maleWorkers":"68","maleMedian":"942","femaleWorkers":"83","femaleMedian":"765"}}},"Purchasing agents, except wholesale, retail, and farm products":{"ageData":{"2016":{"total":"272","16to19":"1","20to24":"13","25to34":"63","35to44":"57","45to54":"65","55to64":"59","65+":"13","medianAge":"59"}},"title":"Purchasing agents, except wholesale, retail, and farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"272","women":"48.0","white":"9.9","black":"6.2","asian":"11.6"}},"wageData":{"2016":{"workers":"253","median":"1,024","maleWorkers":"128","maleMedian":"1,037","femaleWorkers":"125","femaleMedian":"974"}}},"Claims adjusters, appraisers, examiners, and investigators":{"ageData":{"2016":{"total":"349","16to19":"0","20to24":"15","25to34":"88","35to44":"87","45to54":"83","55to64":"63","65+":"14","medianAge":"63"}},"title":"Claims adjusters, appraisers, examiners, and investigators","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"349","women":"62.2","white":"15.1","black":"1.6","asian":"12.7"}},"wageData":{"2016":{"workers":"321","median":"969","maleWorkers":"114","maleMedian":"1,139","femaleWorkers":"206","femaleMedian":"912"}}},"Compliance officers":{"ageData":{"2016":{"total":"270","16to19":"0","20to24":"10","25to34":"50","35to44":"72","45to54":"58","55to64":"65","65+":"14","medianAge":"65"}},"title":"Compliance officers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"270","women":"57.1","white":"12.4","black":"7.9","asian":"10.0"}},"wageData":{"2016":{"workers":"252","median":"1,243","maleWorkers":"106","maleMedian":"1,274","femaleWorkers":"146","femaleMedian":"1,163"}}},"Cost estimators":{"ageData":{"2016":{"total":"113","16to19":"0","20to24":"5","25to34":"25","35to44":"20","45to54":"26","55to64":"29","65+":"9","medianAge":"29"}},"title":"Cost estimators","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"113","women":"12.0","white":"2.9","black":"3.2","asian":"8.3"}},"wageData":{"2016":{"workers":"104","median":"1,159","maleWorkers":"96","maleMedian":"1,172","femaleWorkers":"9","femaleMedian":"-"}}},"Human resources workers":{"ageData":{"2016":{"total":"693","16to19":"4","20to24":"34","25to34":"210","35to44":"180","45to54":"135","55to64":"105","65+":"25","medianAge":"105"}},"title":"Human resources workers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"693","women":"74.6","white":"12.8","black":"5.2","asian":"11.3"}},"wageData":{"2016":{"workers":"631","median":"1,139","maleWorkers":"166","maleMedian":"1,364","femaleWorkers":"465","femaleMedian":"1,089"}}},"Compensation, benefits, and job analysis specialists":{"ageData":{"2016":{"total":"77","16to19":"0","20to24":"3","25to34":"19","35to44":"19","45to54":"21","55to64":"15","65+":"1","medianAge":"15"}},"title":"Compensation, benefits, and job analysis specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"77","women":"72.1","white":"17.8","black":"7.2","asian":"8.5"}},"wageData":{"2016":{"workers":"72","median":"1,069","maleWorkers":"21","maleMedian":"-","femaleWorkers":"51","femaleMedian":"1,001"}}},"Training and development specialists":{"ageData":{"2016":{"total":"156","16to19":"1","20to24":"10","25to34":"35","35to44":"33","45to54":"38","55to64":"30","65+":"8","medianAge":"30"}},"title":"Training and development specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"156","women":"60.7","white":"12.0","black":"3.0","asian":"10.3"}},"wageData":{"2016":{"workers":"129","median":"1,103","maleWorkers":"47","maleMedian":"-","femaleWorkers":"82","femaleMedian":"959"}}},"Logisticians":{"ageData":{"2016":{"total":"115","16to19":"0","20to24":"10","25to34":"38","35to44":"21","45to54":"22","55to64":"22","65+":"2","medianAge":"22"}},"title":"Logisticians","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"115","women":"32.3","white":"17.0","black":"6.9","asian":"12.0"}},"wageData":{"2016":{"workers":"111","median":"1,011","maleWorkers":"75","maleMedian":"1,116","femaleWorkers":"37","femaleMedian":"-"}}},"Management analysts":{"ageData":{"2016":{"total":"902","16to19":"1","20to24":"37","25to34":"207","35to44":"202","45to54":"199","55to64":"171","65+":"86","medianAge":"171"}},"title":"Management analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"902","women":"41.7","white":"9.0","black":"10.7","asian":"7.9"}},"wageData":{"2016":{"workers":"585","median":"1,476","maleWorkers":"332","maleMedian":"1,586","femaleWorkers":"253","femaleMedian":"1,342"}}},"Meeting, convention, and event planners":{"ageData":{"2016":{"total":"162","16to19":"1","20to24":"21","25to34":"50","35to44":"33","45to54":"23","55to64":"25","65+":"8","medianAge":"25"}},"title":"Meeting, convention, and event planners","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"162","women":"77.6","white":"8.6","black":"4.5","asian":"11.1"}},"wageData":{"2016":{"workers":"119","median":"867","maleWorkers":"30","maleMedian":"-","femaleWorkers":"88","femaleMedian":"852"}}},"Fundraisers":{"ageData":{"2016":{"total":"86","16to19":"1","20to24":"9","25to34":"21","35to44":"17","45to54":"19","55to64":"15","65+":"5","medianAge":"15"}},"title":"Fundraisers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"86","women":"66.5","white":"4.3","black":"1.9","asian":"4.8"}},"wageData":{"2016":{"workers":"64","median":"1,111","maleWorkers":"22","maleMedian":"-","femaleWorkers":"42","femaleMedian":"-"}}},"Market research analysts and marketing specialists":{"ageData":{"2016":{"total":"302","16to19":"2","20to24":"31","25to34":"112","35to44":"64","45to54":"47","55to64":"37","65+":"9","medianAge":"37"}},"title":"Market research analysts and marketing specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"302","women":"55.0","white":"5.0","black":"8.8","asian":"8.3"}},"wageData":{"2016":{"workers":"246","median":"1,171","maleWorkers":"116","maleMedian":"1,345","femaleWorkers":"130","femaleMedian":"1,097"}}},"Business operations specialists, all other":{"ageData":{"2016":{"total":"290","16to19":"3","20to24":"20","25to34":"54","35to44":"63","45to54":"72","55to64":"59","65+":"20","medianAge":"59"}},"title":"Business operations specialists, all other","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"290","women":"60.9","white":"13.7","black":"4.7","asian":"13.5"}},"wageData":{"2016":{"workers":"257","median":"1,125","maleWorkers":"110","maleMedian":"1,263","femaleWorkers":"146","femaleMedian":"1,001"}}},"Accountants and auditors":{"ageData":{"2016":{"total":"1,777","16to19":"1","20to24":"87","25to34":"430","35to44":"356","45to54":"433","55to64":"343","65+":"126","medianAge":"343"}},"title":"Accountants and auditors","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"1,777","women":"61.3","white":"8.5","black":"10.9","asian":"9.0"}},"wageData":{"2016":{"workers":"1,451","median":"1,153","maleWorkers":"559","maleMedian":"1,441","femaleWorkers":"892","femaleMedian":"1,018"}}},"Appraisers and assessors of real estate":{"ageData":{"2016":{"total":"73","16to19":"0","20to24":"1","25to34":"6","35to44":"16","45to54":"20","55to64":"22","65+":"7","medianAge":"22"}},"title":"Appraisers and assessors of real estate","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"73","women":"35.6","white":"5.5","black":"2.2","asian":"9.5"}},"wageData":{"2016":{"workers":"31","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Budget analysts":{"ageData":{"2016":{"total":"53","16to19":"0","20to24":"1","25to34":"8","35to44":"12","45to54":"17","55to64":"12","65+":"2","medianAge":"12"}},"title":"Budget analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"53","women":"51.3","white":"16.8","black":"8.6","asian":"5.6"}},"wageData":{"2016":{"workers":"48","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"26","femaleMedian":"-"}}},"Credit analysts":{"ageData":{"2016":{"total":"27","16to19":"0","20to24":"2","25to34":"6","35to44":"12","45to54":"4","55to64":"4","65+":"0","medianAge":"4"}},"title":"Credit analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"27","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"28","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Financial analysts":{"ageData":{"2016":{"total":"307","16to19":"0","20to24":"22","25to34":"126","35to44":"69","45to54":"49","55to64":"32","65+":"10","medianAge":"32"}},"title":"Financial analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"307","women":"36.9","white":"6.5","black":"12.8","asian":"10.9"}},"wageData":{"2016":{"workers":"277","median":"1,525","maleWorkers":"173","maleMedian":"1,747","femaleWorkers":"104","femaleMedian":"1,252"}}},"Personal financial advisors":{"ageData":{"2016":{"total":"513","16to19":"0","20to24":"20","25to34":"129","35to44":"129","45to54":"106","55to64":"92","65+":"37","medianAge":"92"}},"title":"Personal financial advisors","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"513","women":"31.6","white":"6.0","black":"7.7","asian":"7.1"}},"wageData":{"2016":{"workers":"399","median":"1,404","maleWorkers":"258","maleMedian":"1,714","femaleWorkers":"142","femaleMedian":"953"}}},"Insurance underwriters":{"ageData":{"2016":{"total":"104","16to19":"0","20to24":"4","25to34":"28","35to44":"22","45to54":"27","55to64":"20","65+":"3","medianAge":"20"}},"title":"Insurance underwriters","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"104","women":"62.5","white":"9.6","black":"6.3","asian":"4.9"}},"wageData":{"2016":{"workers":"102","median":"1,113","maleWorkers":"34","maleMedian":"-","femaleWorkers":"68","femaleMedian":"910"}}},"Financial examiners":{"ageData":{"2016":{"total":"14","16to19":"0","20to24":"1","25to34":"2","35to44":"2","45to54":"4","55to64":"3","65+":"1","medianAge":"3"}},"title":"Financial examiners","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"13","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Credit counselors and loan officers":{"ageData":{"2016":{"total":"367","16to19":"2","20to24":"19","25to34":"89","35to44":"97","45to54":"91","55to64":"54","65+":"16","medianAge":"54"}},"title":"Credit counselors and loan officers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"367","women":"57.7","white":"11.5","black":"5.6","asian":"10.9"}},"wageData":{"2016":{"workers":"351","median":"1,054","maleWorkers":"151","maleMedian":"1,331","femaleWorkers":"200","femaleMedian":"926"}}},"Tax examiners and collectors, and revenue agents":{"ageData":{"2016":{"total":"68","16to19":"0","20to24":"1","25to34":"16","35to44":"11","45to54":"20","55to64":"18","65+":"3","medianAge":"18"}},"title":"Tax examiners and collectors, and revenue agents","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"68","women":"63.8","white":"15.8","black":"8.1","asian":"13.3"}},"wageData":{"2016":{"workers":"58","median":"1,138","maleWorkers":"20","maleMedian":"-","femaleWorkers":"38","femaleMedian":"-"}}},"Tax preparers":{"ageData":{"2016":{"total":"108","16to19":"0","20to24":"5","25to34":"16","35to44":"19","45to54":"23","55to64":"27","65+":"19","medianAge":"27"}},"title":"Tax preparers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"108","women":"63.2","white":"8.5","black":"5.3","asian":"14.9"}},"wageData":{"2016":{"workers":"53","median":"1,049","maleWorkers":"20","maleMedian":"-","femaleWorkers":"33","femaleMedian":"-"}}},"Financial specialists, all other":{"ageData":{"2016":{"total":"68","16to19":"0","20to24":"2","25to34":"16","35to44":"22","45to54":"13","55to64":"11","65+":"4","medianAge":"11"}},"title":"Financial specialists, all other","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2016":{"total":"68","women":"55.7","white":"16.8","black":"5.4","asian":"13.6"}},"wageData":{"2016":{"workers":"56","median":"1,155","maleWorkers":"20","maleMedian":"-","femaleWorkers":"37","femaleMedian":"-"}}},"Professional and related occupations":{"ageData":{"2016":{"total":"34,498","16to19":"309","20to24":"2,180","25to34":"8,630","35to44":"8,154","45to54":"7,394","55to64":"5,760","65+":"2,071","medianAge":"5,760"}},"title":"Professional and related occupations","depth":2,"parent":"Management, professional, and related occupations","sexRaceEthnicityData":{"2016":{"total":"34,498","women":"57.0","white":"9.8","black":"9.2","asian":"9.0"}},"wageData":{"2016":{"workers":"26,907","median":"1,141","maleWorkers":"11,995","maleMedian":"1,364","femaleWorkers":"14,912","femaleMedian":"998"}}},"Computer and mathematical occupations":{"ageData":{"2016":{"total":"4,601","16to19":"29","20to24":"279","25to34":"1,332","35to44":"1,250","45to54":"995","55to64":"592","65+":"123","medianAge":"592"}},"title":"Computer and mathematical occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2016":{"total":"4,601","women":"25.5","white":"7.9","black":"21.3","asian":"6.8"}},"wageData":{"2016":{"workers":"4,104","median":"1,443","maleWorkers":"3,068","maleMedian":"1,518","femaleWorkers":"1,035","femaleMedian":"1,325"}}},"Computer and information research scientists":{"ageData":{"2016":{"total":"20","16to19":"0","20to24":"1","25to34":"4","35to44":"7","45to54":"6","55to64":"2","65+":"0","medianAge":"2"}},"title":"Computer and information research scientists","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2016":{"total":"20","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"20","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Computer systems analysts":{"ageData":{"2016":{"total":"526","16to19":"1","20to24":"30","25to34":"138","35to44":"137","45to54":"129","55to64":"79","65+":"12","medianAge":"79"}},"title":"Computer systems analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2016":{"total":"526","women":"35.7","white":"10.8","black":"17.6","asian":"6.7"}},"wageData":{"2016":{"workers":"496","median":"1,393","maleWorkers":"314","maleMedian":"1,475","femaleWorkers":"182","femaleMedian":"1,328"}}},"Information security analysts":{"ageData":{"2016":{"total":"89","16to19":"0","20to24":"7","25to34":"15","35to44":"25","45to54":"24","55to64":"17","65+":"1","medianAge":"17"}},"title":"Information security analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2016":{"total":"89","women":"21.8","white":"9.2","black":"7.7","asian":"8.9"}},"wageData":{"2016":{"workers":"85","median":"1,617","maleWorkers":"65","maleMedian":"1,826","femaleWorkers":"20","femaleMedian":"-"}}},"Computer programmers":{"ageData":{"2016":{"total":"466","16to19":"3","20to24":"26","25to34":"109","35to44":"124","45to54":"119","55to64":"66","65+":"19","medianAge":"66"}},"title":"Computer programmers","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2016":{"total":"466","women":"22.6","white":"7.6","black":"19.8","asian":"6.7"}},"wageData":{"2016":{"workers":"403","median":"1,398","maleWorkers":"300","maleMedian":"1,466","femaleWorkers":"104","femaleMedian":"1,312"}}},"Software developers, applications and systems software":{"ageData":{"2016":{"total":"1,483","16to19":"6","20to24":"79","25to34":"490","35to44":"404","45to54":"302","55to64":"168","65+":"35","medianAge":"168"}},"title":"Software developers, applications and systems software","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2016":{"total":"1,483","women":"20.0","white":"4.1","black":"35.7","asian":"4.8"}},"wageData":{"2016":{"workers":"1,351","median":"1,776","maleWorkers":"1,084","maleMedian":"1,863","femaleWorkers":"266","femaleMedian":"1,553"}}},"Web developers":{"ageData":{"2016":{"total":"205","16to19":"2","20to24":"16","25to34":"77","35to44":"64","45to54":"30","55to64":"14","65+":"3","medianAge":"14"}},"title":"Web developers","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2016":{"total":"205","women":"33.6","white":"8.4","black":"9.3","asian":"5.8"}},"wageData":{"2016":{"workers":"142","median":"1,236","maleWorkers":"97","maleMedian":"1,284","femaleWorkers":"45","femaleMedian":"-"}}},"Computer support specialists":{"ageData":{"2016":{"total":"570","16to19":"8","20to24":"44","25to34":"163","35to44":"143","45to54":"110","55to64":"84","65+":"18","medianAge":"84"}},"title":"Computer support specialists","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2016":{"total":"570","women":"25.5","white":"9.8","black":"12.6","asian":"7.8"}},"wageData":{"2016":{"workers":"491","median":"1,060","maleWorkers":"367","maleMedian":"1,078","femaleWorkers":"124","femaleMedian":"1,014"}}},"Database administrators":{"ageData":{"2016":{"total":"90","16to19":"0","20to24":"5","25to34":"23","35to44":"20","45to54":"19","55to64":"20","65+":"2","medianAge":"20"}},"title":"Database administrators","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2016":{"total":"90","women":"46.2","white":"4.4","black":"16.2","asian":"2.9"}},"wageData":{"2016":{"workers":"83","median":"1,731","maleWorkers":"46","maleMedian":"-","femaleWorkers":"37","femaleMedian":"-"}}},"Network and computer systems administrators":{"ageData":{"2016":{"total":"218","16to19":"0","20to24":"10","25to34":"52","35to44":"68","45to54":"61","55to64":"22","65+":"5","medianAge":"22"}},"title":"Network and computer systems administrators","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2016":{"total":"218","women":"17.1","white":"9.6","black":"10.8","asian":"9.4"}},"wageData":{"2016":{"workers":"197","median":"1,232","maleWorkers":"168","maleMedian":"1,250","femaleWorkers":"29","femaleMedian":"-"}}},"Computer network architects":{"ageData":{"2016":{"total":"115","16to19":"0","20to24":"5","25to34":"31","35to44":"42","45to54":"26","55to64":"9","65+":"3","medianAge":"9"}},"title":"Computer network architects","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2016":{"total":"115","women":"9.7","white":"13.0","black":"11.8","asian":"9.3"}},"wageData":{"2016":{"workers":"105","median":"1,502","maleWorkers":"93","maleMedian":"1,535","femaleWorkers":"12","femaleMedian":"-"}}},"Computer occupations, all other":{"ageData":{"2016":{"total":"596","16to19":"10","20to24":"41","25to34":"157","35to44":"165","45to54":"125","55to64":"82","65+":"16","medianAge":"82"}},"title":"Computer occupations, all other","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2016":{"total":"596","women":"23.4","white":"11.0","black":"12.7","asian":"10.6"}},"wageData":{"2016":{"workers":"524","median":"1,195","maleWorkers":"418","maleMedian":"1,244","femaleWorkers":"106","femaleMedian":"1,055"}}},"Actuaries":{"ageData":{"2016":{"total":"14","16to19":"0","20to24":"0","25to34":"7","35to44":"1","45to54":"4","55to64":"0","65+":"1","medianAge":"0"}},"title":"Actuaries","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2016":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"12","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Mathematicians":{"ageData":{"2016":{"total":"4","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"3","55to64":"1","65+":"0","medianAge":"1"}},"title":"Mathematicians","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2016":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"4","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Operations research analysts":{"ageData":{"2016":{"total":"129","16to19":"0","20to24":"5","25to34":"30","35to44":"39","45to54":"30","55to64":"19","65+":"6","medianAge":"19"}},"title":"Operations research analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2016":{"total":"129","women":"55.4","white":"11.2","black":"12.9","asian":"10.4"}},"wageData":{"2016":{"workers":"125","median":"1,315","maleWorkers":"59","maleMedian":"1,382","femaleWorkers":"66","femaleMedian":"1,300"}}},"Statisticians":{"ageData":{"2016":{"total":"74","16to19":"0","20to24":"10","25to34":"33","35to44":"10","45to54":"9","55to64":"9","65+":"2","medianAge":"9"}},"title":"Statisticians","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2016":{"total":"74","women":"52.5","white":"8.4","black":"19.8","asian":"3.9"}},"wageData":{"2016":{"workers":"65","median":"1,405","maleWorkers":"30","maleMedian":"-","femaleWorkers":"35","femaleMedian":"-"}}},"Miscellaneous mathematical science occupations":{"ageData":{"2016":{"total":"2","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Miscellaneous mathematical science occupations","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2016":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Architecture and engineering occupations":{"ageData":{"2016":{"total":"3,106","16to19":"17","20to24":"186","25to34":"768","35to44":"681","45to54":"702","55to64":"580","65+":"172","medianAge":"580"}},"title":"Architecture and engineering occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2016":{"total":"3,106","women":"14.2","white":"5.6","black":"11.6","asian":"8.8"}},"wageData":{"2016":{"workers":"2,835","median":"1,482","maleWorkers":"2,437","maleMedian":"1,529","femaleWorkers":"398","femaleMedian":"1,207"}}},"Architects, except naval":{"ageData":{"2016":{"total":"246","16to19":"1","20to24":"9","25to34":"66","35to44":"45","45to54":"67","55to64":"35","65+":"24","medianAge":"35"}},"title":"Architects, except naval","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2016":{"total":"246","women":"26.0","white":"3.0","black":"11.1","asian":"8.0"}},"wageData":{"2016":{"workers":"178","median":"1,339","maleWorkers":"135","maleMedian":"1,462","femaleWorkers":"43","femaleMedian":"-"}}},"Surveyors, cartographers, and photogrammetrists":{"ageData":{"2016":{"total":"34","16to19":"0","20to24":"2","25to34":"9","35to44":"9","45to54":"6","55to64":"7","65+":"2","medianAge":"7"}},"title":"Surveyors, cartographers, and photogrammetrists","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2016":{"total":"34","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"28","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Aerospace engineers":{"ageData":{"2016":{"total":"130","16to19":"1","20to24":"3","25to34":"31","35to44":"27","45to54":"28","55to64":"33","65+":"7","medianAge":"33"}},"title":"Aerospace engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2016":{"total":"130","women":"7.8","white":"2.6","black":"9.3","asian":"7.3"}},"wageData":{"2016":{"workers":"124","median":"1,854","maleWorkers":"114","maleMedian":"1,846","femaleWorkers":"10","femaleMedian":"-"}}},"Agricultural engineers":{"ageData":{"2016":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Agricultural engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2016":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Biomedical engineers":{"ageData":{"2016":{"total":"13","16to19":"0","20to24":"2","25to34":"6","35to44":"3","45to54":"0","55to64":"1","65+":"2","medianAge":"1"}},"title":"Biomedical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2016":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"14","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Chemical engineers":{"ageData":{"2016":{"total":"79","16to19":"0","20to24":"7","25to34":"19","35to44":"15","45to54":"17","55to64":"17","65+":"3","medianAge":"17"}},"title":"Chemical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2016":{"total":"79","women":"20.1","white":"4.1","black":"10.3","asian":"6.6"}},"wageData":{"2016":{"workers":"91","median":"1,877","maleWorkers":"73","maleMedian":"1,901","femaleWorkers":"18","femaleMedian":"-"}}},"Civil engineers":{"ageData":{"2016":{"total":"425","16to19":"2","20to24":"30","25to34":"114","35to44":"89","45to54":"92","55to64":"77","65+":"21","medianAge":"77"}},"title":"Civil engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2016":{"total":"425","women":"10.8","white":"3.6","black":"7.7","asian":"10.4"}},"wageData":{"2016":{"workers":"389","median":"1,504","maleWorkers":"350","maleMedian":"1,526","femaleWorkers":"39","femaleMedian":"-"}}},"Computer hardware engineers":{"ageData":{"2016":{"total":"69","16to19":"0","20to24":"4","25to34":"17","35to44":"19","45to54":"18","55to64":"8","65+":"2","medianAge":"8"}},"title":"Computer hardware engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2016":{"total":"69","women":"24.7","white":"5.3","black":"29.2","asian":"12.0"}},"wageData":{"2016":{"workers":"58","median":"1,843","maleWorkers":"46","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Electrical and electronics engineers":{"ageData":{"2016":{"total":"293","16to19":"1","20to24":"16","25to34":"68","35to44":"67","45to54":"63","55to64":"65","65+":"13","medianAge":"65"}},"title":"Electrical and electronics engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2016":{"total":"293","women":"10.8","white":"7.5","black":"15.1","asian":"9.3"}},"wageData":{"2016":{"workers":"271","median":"1,729","maleWorkers":"245","maleMedian":"1,736","femaleWorkers":"26","femaleMedian":"-"}}},"Environmental engineers":{"ageData":{"2016":{"total":"33","16to19":"1","20to24":"1","25to34":"5","35to44":"13","45to54":"6","55to64":"7","65+":"1","medianAge":"7"}},"title":"Environmental engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2016":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"31","median":"-","maleWorkers":"27","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Industrial engineers, including health and safety":{"ageData":{"2016":{"total":"220","16to19":"0","20to24":"13","25to34":"64","35to44":"42","45to54":"48","55to64":"44","65+":"9","medianAge":"44"}},"title":"Industrial engineers, including health and safety","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2016":{"total":"220","women":"20.3","white":"2.7","black":"6.6","asian":"11.2"}},"wageData":{"2016":{"workers":"215","median":"1,526","maleWorkers":"169","maleMedian":"1,580","femaleWorkers":"46","femaleMedian":"-"}}},"Marine engineers and naval architects":{"ageData":{"2016":{"total":"13","16to19":"0","20to24":"1","25to34":"3","35to44":"4","45to54":"3","55to64":"3","65+":"0","medianAge":"3"}},"title":"Marine engineers and naval architects","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2016":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"19","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Materials engineers":{"ageData":{"2016":{"total":"31","16to19":"0","20to24":"0","25to34":"5","35to44":"8","45to54":"6","55to64":"8","65+":"3","medianAge":"8"}},"title":"Materials engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2016":{"total":"31","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"26","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Mechanical engineers":{"ageData":{"2016":{"total":"350","16to19":"1","20to24":"24","25to34":"93","35to44":"82","45to54":"70","55to64":"60","65+":"19","medianAge":"60"}},"title":"Mechanical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2016":{"total":"350","women":"6.4","white":"4.2","black":"10.5","asian":"5.5"}},"wageData":{"2016":{"workers":"335","median":"1,560","maleWorkers":"311","maleMedian":"1,567","femaleWorkers":"24","femaleMedian":"-"}}},"Mining and geological engineers, including mining safety engineers":{"ageData":{"2016":{"total":"9","16to19":"0","20to24":"0","25to34":"3","35to44":"3","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Mining and geological engineers, including mining safety engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2016":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"8","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Nuclear engineers":{"ageData":{"2016":{"total":"7","16to19":"0","20to24":"1","25to34":"1","35to44":"3","45to54":"0","55to64":"1","65+":"1","medianAge":"1"}},"title":"Nuclear engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2016":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"8","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Petroleum engineers":{"ageData":{"2016":{"total":"36","16to19":"0","20to24":"2","25to34":"15","35to44":"7","45to54":"5","55to64":"6","65+":"2","medianAge":"6"}},"title":"Petroleum engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2016":{"total":"36","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"35","median":"-","maleWorkers":"32","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Engineers, all other":{"ageData":{"2016":{"total":"539","16to19":"1","20to24":"24","25to34":"131","35to44":"125","45to54":"141","55to64":"87","65+":"31","medianAge":"87"}},"title":"Engineers, all other","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2016":{"total":"539","women":"12.2","white":"7.2","black":"18.2","asian":"6.1"}},"wageData":{"2016":{"workers":"493","median":"1,573","maleWorkers":"430","maleMedian":"1,659","femaleWorkers":"63","femaleMedian":"1,401"}}},"Drafters":{"ageData":{"2016":{"total":"109","16to19":"2","20to24":"9","25to34":"23","35to44":"23","45to54":"28","55to64":"22","65+":"3","medianAge":"22"}},"title":"Drafters","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2016":{"total":"109","women":"15.0","white":"4.9","black":"4.9","asian":"22.7"}},"wageData":{"2016":{"workers":"93","median":"990","maleWorkers":"83","maleMedian":"1,030","femaleWorkers":"10","femaleMedian":"-"}}},"Engineering technicians, except drafters":{"ageData":{"2016":{"total":"385","16to19":"6","20to24":"29","25to34":"75","35to44":"87","45to54":"89","55to64":"78","65+":"20","medianAge":"78"}},"title":"Engineering technicians, except drafters","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2016":{"total":"385","women":"19.8","white":"11.2","black":"8.8","asian":"10.6"}},"wageData":{"2016":{"workers":"350","median":"997","maleWorkers":"275","maleMedian":"1,075","femaleWorkers":"75","femaleMedian":"793"}}},"Surveying and mapping technicians":{"ageData":{"2016":{"total":"83","16to19":"2","20to24":"9","25to34":"22","35to44":"11","45to54":"13","55to64":"18","65+":"8","medianAge":"18"}},"title":"Surveying and mapping technicians","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2016":{"total":"83","women":"7.9","white":"3.7","black":"3.2","asian":"7.4"}},"wageData":{"2016":{"workers":"67","median":"811","maleWorkers":"61","maleMedian":"790","femaleWorkers":"5","femaleMedian":"-"}}},"Life, physical, and social science occupations":{"ageData":{"2016":{"total":"1,367","16to19":"6","20to24":"103","25to34":"381","35to44":"292","45to54":"273","55to64":"209","65+":"103","medianAge":"209"}},"title":"Life, physical, and social science occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2016":{"total":"1,367","women":"44.0","white":"6.4","black":"16.0","asian":"8.2"}},"wageData":{"2016":{"workers":"1,151","median":"1,209","maleWorkers":"665","maleMedian":"1,319","femaleWorkers":"486","femaleMedian":"1,119"}}},"Agricultural and food scientists":{"ageData":{"2016":{"total":"35","16to19":"0","20to24":"6","25to34":"9","35to44":"4","45to54":"7","55to64":"5","65+":"4","medianAge":"5"}},"title":"Agricultural and food scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2016":{"total":"35","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"32","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Biological scientists":{"ageData":{"2016":{"total":"96","16to19":"0","20to24":"5","25to34":"27","35to44":"30","45to54":"13","55to64":"15","65+":"5","medianAge":"15"}},"title":"Biological scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2016":{"total":"96","women":"43.4","white":"6.5","black":"17.2","asian":"7.0"}},"wageData":{"2016":{"workers":"81","median":"1,346","maleWorkers":"46","maleMedian":"-","femaleWorkers":"35","femaleMedian":"-"}}},"Conservation scientists and foresters":{"ageData":{"2016":{"total":"31","16to19":"0","20to24":"1","25to34":"8","35to44":"5","45to54":"8","55to64":"7","65+":"2","medianAge":"7"}},"title":"Conservation scientists and foresters","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2016":{"total":"31","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"26","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Medical scientists":{"ageData":{"2016":{"total":"154","16to19":"0","20to24":"17","25to34":"46","35to44":"37","45to54":"30","55to64":"13","65+":"10","medianAge":"13"}},"title":"Medical scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2016":{"total":"154","women":"46.9","white":"3.7","black":"37.3","asian":"4.6"}},"wageData":{"2016":{"workers":"127","median":"1,211","maleWorkers":"69","maleMedian":"1,250","femaleWorkers":"57","femaleMedian":"1,169"}}},"Life scientists, all other":{"ageData":{"2016":{"total":"3","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Life scientists, all other","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2016":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"3","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Astronomers and physicists":{"ageData":{"2016":{"total":"19","16to19":"0","20to24":"2","25to34":"8","35to44":"2","45to54":"1","55to64":"6","65+":"1","medianAge":"6"}},"title":"Astronomers and physicists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2016":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"20","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Atmospheric and space scientists":{"ageData":{"2016":{"total":"6","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"3","55to64":"1","65+":"0","medianAge":"1"}},"title":"Atmospheric and space scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2016":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"6","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Chemists and materials scientists":{"ageData":{"2016":{"total":"95","16to19":"0","20to24":"4","25to34":"33","35to44":"20","45to54":"15","55to64":"16","65+":"8","medianAge":"16"}},"title":"Chemists and materials scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2016":{"total":"95","women":"34.6","white":"10.6","black":"18.4","asian":"2.7"}},"wageData":{"2016":{"workers":"93","median":"1,306","maleWorkers":"56","maleMedian":"1,504","femaleWorkers":"36","femaleMedian":"-"}}},"Environmental scientists and geoscientists":{"ageData":{"2016":{"total":"89","16to19":"0","20to24":"2","25to34":"27","35to44":"15","45to54":"18","55to64":"18","65+":"8","medianAge":"18"}},"title":"Environmental scientists and geoscientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2016":{"total":"89","women":"30.0","white":"3.4","black":"8.0","asian":"5.6"}},"wageData":{"2016":{"workers":"79","median":"1,555","maleWorkers":"58","maleMedian":"1,591","femaleWorkers":"21","femaleMedian":"-"}}},"Physical scientists, all other":{"ageData":{"2016":{"total":"261","16to19":"0","20to24":"10","25to34":"84","35to44":"58","45to54":"60","55to64":"34","65+":"14","medianAge":"34"}},"title":"Physical scientists, all other","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2016":{"total":"261","women":"45.0","white":"4.9","black":"26.9","asian":"9.7"}},"wageData":{"2016":{"workers":"241","median":"1,416","maleWorkers":"131","maleMedian":"1,727","femaleWorkers":"111","femaleMedian":"1,323"}}},"Economists":{"ageData":{"2016":{"total":"26","16to19":"1","20to24":"0","25to34":"8","35to44":"10","45to54":"3","55to64":"4","65+":"0","medianAge":"4"}},"title":"Economists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2016":{"total":"26","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"22","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Survey researchers":{"ageData":{"2016":{"total":"3","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Survey researchers","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2016":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Psychologists":{"ageData":{"2016":{"total":"161","16to19":"0","20to24":"2","25to34":"33","35to44":"33","45to54":"31","55to64":"32","65+":"31","medianAge":"32"}},"title":"Psychologists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2016":{"total":"161","women":"67.5","white":"5.8","black":"4.2","asian":"6.9"}},"wageData":{"2016":{"workers":"91","median":"1,260","maleWorkers":"25","maleMedian":"-","femaleWorkers":"66","femaleMedian":"1,187"}}},"Sociologists":{"ageData":{"2016":{"total":"3","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Sociologists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2016":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"4","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Urban and regional planners":{"ageData":{"2016":{"total":"38","16to19":"0","20to24":"0","25to34":"6","35to44":"14","45to54":"11","55to64":"6","65+":"1","medianAge":"6"}},"title":"Urban and regional planners","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2016":{"total":"38","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"34","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Miscellaneous social scientists and related workers":{"ageData":{"2016":{"total":"39","16to19":"0","20to24":"3","25to34":"16","35to44":"5","45to54":"7","55to64":"3","65+":"5","medianAge":"3"}},"title":"Miscellaneous social scientists and related workers","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2016":{"total":"39","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"30","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Agricultural and food science technicians":{"ageData":{"2016":{"total":"35","16to19":"0","20to24":"6","25to34":"6","35to44":"7","45to54":"8","55to64":"7","65+":"1","medianAge":"7"}},"title":"Agricultural and food science technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2016":{"total":"35","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"24","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Biological technicians":{"ageData":{"2016":{"total":"17","16to19":"0","20to24":"3","25to34":"5","35to44":"4","45to54":"3","55to64":"1","65+":"0","medianAge":"1"}},"title":"Biological technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2016":{"total":"17","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"19","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Chemical technicians":{"ageData":{"2016":{"total":"76","16to19":"1","20to24":"9","25to34":"13","35to44":"16","45to54":"17","55to64":"17","65+":"3","medianAge":"17"}},"title":"Chemical technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2016":{"total":"76","women":"34.6","white":"14.9","black":"8.2","asian":"12.9"}},"wageData":{"2016":{"workers":"75","median":"919","maleWorkers":"50","maleMedian":"919","femaleWorkers":"25","femaleMedian":"-"}}},"Geological and petroleum technicians":{"ageData":{"2016":{"total":"18","16to19":"1","20to24":"0","25to34":"6","35to44":"2","45to54":"5","55to64":"4","65+":"0","medianAge":"4"}},"title":"Geological and petroleum technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2016":{"total":"18","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"17","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Nuclear technicians":{"ageData":{"2016":{"total":"5","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"3","55to64":"1","65+":"0","medianAge":"1"}},"title":"Nuclear technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2016":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"4","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Social science research assistants":{"ageData":{"2016":{"total":"2","16to19":"0","20to24":"0","25to34":"2","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Social science research assistants","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2016":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Miscellaneous life, physical, and social science technicians":{"ageData":{"2016":{"total":"155","16to19":"3","20to24":"32","25to34":"40","35to44":"25","45to54":"25","55to64":"20","65+":"9","medianAge":"20"}},"title":"Miscellaneous life, physical, and social science technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2016":{"total":"155","women":"51.0","white":"8.0","black":"13.0","asian":"11.6"}},"wageData":{"2016":{"workers":"119","median":"894","maleWorkers":"62","maleMedian":"949","femaleWorkers":"57","femaleMedian":"826"}}},"Community and social service occupations":{"ageData":{"2016":{"total":"2,612","16to19":"19","20to24":"153","25to34":"614","35to44":"583","45to54":"548","55to64":"488","65+":"207","medianAge":"488"}},"title":"Community and social service occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2016":{"total":"2,612","women":"65.5","white":"18.6","black":"3.4","asian":"12.1"}},"wageData":{"2016":{"workers":"2,136","median":"919","maleWorkers":"759","maleMedian":"1,004","femaleWorkers":"1,377","femaleMedian":"880"}}},"Counselors":{"ageData":{"2016":{"total":"869","16to19":"10","20to24":"77","25to34":"251","35to44":"183","45to54":"171","55to64":"136","65+":"42","medianAge":"136"}},"title":"Counselors","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2016":{"total":"869","women":"73.0","white":"19.6","black":"2.7","asian":"11.6"}},"wageData":{"2016":{"workers":"657","median":"904","maleWorkers":"184","maleMedian":"892","femaleWorkers":"473","femaleMedian":"907"}}},"Social workers":{"ageData":{"2016":{"total":"781","16to19":"3","20to24":"31","25to34":"199","35to44":"194","45to54":"171","55to64":"137","65+":"46","medianAge":"137"}},"title":"Social workers","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2016":{"total":"781","women":"81.5","white":"22.7","black":"3.0","asian":"13.8"}},"wageData":{"2016":{"workers":"684","median":"906","maleWorkers":"127","maleMedian":"1,039","femaleWorkers":"557","femaleMedian":"884"}}},"Probation officers and correctional treatment specialists":{"ageData":{"2016":{"total":"102","16to19":"0","20to24":"3","25to34":"19","35to44":"34","45to54":"27","55to64":"14","65+":"6","medianAge":"14"}},"title":"Probation officers and correctional treatment specialists","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2016":{"total":"102","women":"57.4","white":"21.0","black":"1.3","asian":"14.3"}},"wageData":{"2016":{"workers":"100","median":"992","maleWorkers":"39","maleMedian":"-","femaleWorkers":"61","femaleMedian":"1,004"}}},"Social and human service assistants":{"ageData":{"2016":{"total":"184","16to19":"2","20to24":"14","25to34":"46","35to44":"41","45to54":"42","55to64":"26","65+":"12","medianAge":"26"}},"title":"Social and human service assistants","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2016":{"total":"184","women":"80.5","white":"21.6","black":"2.6","asian":"14.1"}},"wageData":{"2016":{"workers":"151","median":"736","maleWorkers":"29","maleMedian":"-","femaleWorkers":"122","femaleMedian":"727"}}},"Miscellaneous community and social service specialists, including health educators and community health workers":{"ageData":{"2016":{"total":"89","16to19":"1","20to24":"7","25to34":"24","35to44":"22","45to54":"13","55to64":"17","65+":"6","medianAge":"17"}},"title":"Miscellaneous community and social service specialists, including health educators and community health workers","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2016":{"total":"89","women":"74.9","white":"20.4","black":"2.5","asian":"16.1"}},"wageData":{"2016":{"workers":"83","median":"831","maleWorkers":"20","maleMedian":"-","femaleWorkers":"63","femaleMedian":"767"}}},"Clergy":{"ageData":{"2016":{"total":"436","16to19":"0","20to24":"8","25to34":"50","35to44":"81","45to54":"100","55to64":"120","65+":"77","medianAge":"120"}},"title":"Clergy","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2016":{"total":"436","women":"17.6","white":"11.8","black":"5.9","asian":"9.1"}},"wageData":{"2016":{"workers":"368","median":"1,039","maleWorkers":"315","maleMedian":"1,070","femaleWorkers":"53","femaleMedian":"893"}}},"Directors, religious activities and education":{"ageData":{"2016":{"total":"78","16to19":"1","20to24":"8","25to34":"12","35to44":"16","45to54":"11","55to64":"22","65+":"9","medianAge":"22"}},"title":"Directors, religious activities and education","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2016":{"total":"78","women":"55.0","white":"3.1","black":"4.2","asian":"9.9"}},"wageData":{"2016":{"workers":"49","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"26","femaleMedian":"-"}}},"Religious workers, all other":{"ageData":{"2016":{"total":"73","16to19":"1","20to24":"6","25to34":"13","35to44":"12","45to54":"14","55to64":"17","65+":"10","medianAge":"17"}},"title":"Religious workers, all other","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2016":{"total":"73","women":"64.4","white":"7.4","black":"7.9","asian":"8.0"}},"wageData":{"2016":{"workers":"42","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"21","femaleMedian":"-"}}},"Legal occupations":{"ageData":{"2016":{"total":"1,808","16to19":"3","20to24":"35","25to34":"404","35to44":"436","45to54":"395","55to64":"332","65+":"201","medianAge":"332"}},"title":"Legal occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2016":{"total":"1,808","women":"51.8","white":"6.3","black":"4.1","asian":"8.4"}},"wageData":{"2016":{"workers":"1,294","median":"1,431","maleWorkers":"562","maleMedian":"1,904","femaleWorkers":"732","femaleMedian":"1,152"}}},"Lawyers":{"ageData":{"2016":{"total":"1,133","16to19":"0","20to24":"0","25to34":"272","35to44":"288","45to54":"237","55to64":"197","65+":"140","medianAge":"197"}},"title":"Lawyers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2016":{"total":"1,133","women":"35.7","white":"4.4","black":"4.7","asian":"5.6"}},"wageData":{"2016":{"workers":"745","median":"1,897","maleWorkers":"446","maleMedian":"2,086","femaleWorkers":"299","femaleMedian":"1,619"}}},"Judicial law clerks":{"ageData":{"2016":{"total":"15","16to19":"0","20to24":"1","25to34":"9","35to44":"3","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Judicial law clerks","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2016":{"total":"15","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"14","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Judges, magistrates, and other judicial workers":{"ageData":{"2016":{"total":"59","16to19":"0","20to24":"0","25to34":"4","35to44":"7","45to54":"16","55to64":"17","65+":"15","medianAge":"17"}},"title":"Judges, magistrates, and other judicial workers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2016":{"total":"59","women":"34.2","white":"11.0","black":"1.2","asian":"3.5"}},"wageData":{"2016":{"workers":"56","median":"1,560","maleWorkers":"35","maleMedian":"-","femaleWorkers":"21","femaleMedian":"-"}}},"Paralegals and legal assistants":{"ageData":{"2016":{"total":"433","16to19":"3","20to24":"30","25to34":"96","35to44":"101","45to54":"101","55to64":"72","65+":"30","medianAge":"72"}},"title":"Paralegals and legal assistants","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2016":{"total":"433","women":"86.7","white":"10.2","black":"3.5","asian":"16.2"}},"wageData":{"2016":{"workers":"351","median":"874","maleWorkers":"43","maleMedian":"-","femaleWorkers":"308","femaleMedian":"863"}}},"Miscellaneous legal support workers":{"ageData":{"2016":{"total":"168","16to19":"0","20to24":"3","25to34":"23","35to44":"37","45to54":"42","55to64":"46","65+":"16","medianAge":"46"}},"title":"Miscellaneous legal support workers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2016":{"total":"168","women":"77.0","white":"8.4","black":"1.9","asian":"8.7"}},"wageData":{"2016":{"workers":"128","median":"1,009","maleWorkers":"30","maleMedian":"-","femaleWorkers":"98","femaleMedian":"867"}}},"Education, training, and library occupations":{"ageData":{"2016":{"total":"8,948","16to19":"111","20to24":"651","25to34":"2,012","35to44":"2,159","45to54":"1,935","55to64":"1,523","65+":"557","medianAge":"1,523"}},"title":"Education, training, and library occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2016":{"total":"8,948","women":"73.1","white":"10.0","black":"4.7","asian":"10.0"}},"wageData":{"2016":{"workers":"6,859","median":"984","maleWorkers":"1,877","maleMedian":"1,154","femaleWorkers":"4,982","femaleMedian":"933"}}},"Postsecondary teachers":{"ageData":{"2016":{"total":"1,420","16to19":"13","20to24":"108","25to34":"334","35to44":"292","45to54":"251","55to64":"269","65+":"152","medianAge":"269"}},"title":"Postsecondary teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2016":{"total":"1,420","women":"48.3","white":"7.0","black":"12.3","asian":"6.9"}},"wageData":{"2016":{"workers":"980","median":"1,247","maleWorkers":"535","maleMedian":"1,356","femaleWorkers":"445","femaleMedian":"1,152"}}},"Preschool and kindergarten teachers":{"ageData":{"2016":{"total":"692","16to19":"6","20to24":"68","25to34":"206","35to44":"164","45to54":"140","55to64":"92","65+":"17","medianAge":"92"}},"title":"Preschool and kindergarten teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2016":{"total":"692","women":"97.5","white":"12.5","black":"3.4","asian":"13.3"}},"wageData":{"2016":{"workers":"530","median":"626","maleWorkers":"13","maleMedian":"-","femaleWorkers":"518","femaleMedian":"621"}}},"Elementary and middle school teachers":{"ageData":{"2016":{"total":"3,186","16to19":"8","20to24":"151","25to34":"729","35to44":"903","45to54":"737","55to64":"506","65+":"152","medianAge":"506"}},"title":"Elementary and middle school teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2016":{"total":"3,186","women":"78.5","white":"10.3","black":"2.4","asian":"9.8"}},"wageData":{"2016":{"workers":"2,836","median":"1,009","maleWorkers":"605","maleMedian":"1,126","femaleWorkers":"2,231","femaleMedian":"981"}}},"Secondary school teachers":{"ageData":{"2016":{"total":"1,078","16to19":"4","20to24":"47","25to34":"265","35to44":"274","45to54":"265","55to64":"173","65+":"49","medianAge":"173"}},"title":"Secondary school teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2016":{"total":"1,078","women":"60.5","white":"8.0","black":"2.0","asian":"7.9"}},"wageData":{"2016":{"workers":"965","median":"1,111","maleWorkers":"403","maleMedian":"1,146","femaleWorkers":"562","femaleMedian":"1,074"}}},"Special education teachers":{"ageData":{"2016":{"total":"353","16to19":"1","20to24":"18","25to34":"83","35to44":"95","45to54":"80","55to64":"62","65+":"14","medianAge":"62"}},"title":"Special education teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2016":{"total":"353","women":"85.2","white":"8.6","black":"2.2","asian":"6.5"}},"wageData":{"2016":{"workers":"313","median":"1,021","maleWorkers":"49","maleMedian":"-","femaleWorkers":"264","femaleMedian":"1,018"}}},"Other teachers and instructors":{"ageData":{"2016":{"total":"868","16to19":"51","20to24":"126","25to34":"163","35to44":"164","45to54":"134","55to64":"151","65+":"78","medianAge":"151"}},"title":"Other teachers and instructors","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2016":{"total":"868","women":"65.3","white":"10.3","black":"7.2","asian":"10.6"}},"wageData":{"2016":{"workers":"370","median":"938","maleWorkers":"156","maleMedian":"1,135","femaleWorkers":"214","femaleMedian":"786"}}},"Archivists, curators, and museum technicians":{"ageData":{"2016":{"total":"43","16to19":"1","20to24":"2","25to34":"10","35to44":"10","45to54":"4","55to64":"8","65+":"7","medianAge":"8"}},"title":"Archivists, curators, and museum technicians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2016":{"total":"43","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"36","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"25","femaleMedian":"-"}}},"Librarians":{"ageData":{"2016":{"total":"190","16to19":"1","20to24":"6","25to34":"35","35to44":"29","45to54":"46","55to64":"46","65+":"27","medianAge":"46"}},"title":"Librarians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2016":{"total":"190","women":"83.8","white":"7.5","black":"5.8","asian":"7.1"}},"wageData":{"2016":{"workers":"140","median":"987","maleWorkers":"23","maleMedian":"-","femaleWorkers":"117","femaleMedian":"980"}}},"Library technicians":{"ageData":{"2016":{"total":"37","16to19":"2","20to24":"6","25to34":"6","35to44":"8","45to54":"5","55to64":"6","65+":"2","medianAge":"6"}},"title":"Library technicians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2016":{"total":"37","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"10","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Teacher assistants":{"ageData":{"2016":{"total":"950","16to19":"23","20to24":"108","25to34":"158","35to44":"192","45to54":"243","55to64":"184","65+":"42","medianAge":"184"}},"title":"Teacher assistants","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2016":{"total":"950","women":"89.3","white":"14.8","black":"3.4","asian":"17.3"}},"wageData":{"2016":{"workers":"588","median":"523","maleWorkers":"56","maleMedian":"501","femaleWorkers":"532","femaleMedian":"525"}}},"Other education, training, and library workers":{"ageData":{"2016":{"total":"132","16to19":"3","20to24":"11","25to34":"23","35to44":"27","45to54":"28","55to64":"24","65+":"16","medianAge":"24"}},"title":"Other education, training, and library workers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2016":{"total":"132","women":"71.4","white":"12.2","black":"6.3","asian":"9.7"}},"wageData":{"2016":{"workers":"91","median":"1,107","maleWorkers":"24","maleMedian":"-","femaleWorkers":"67","femaleMedian":"1,068"}}},"Arts, design, entertainment, sports, and media occupations":{"ageData":{"2016":{"total":"3,097","16to19":"88","20to24":"285","25to34":"801","35to44":"655","45to54":"578","55to64":"458","65+":"232","medianAge":"458"}},"title":"Arts, design, entertainment, sports, and media occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2016":{"total":"3,097","women":"48.5","white":"6.6","black":"5.5","asian":"10.6"}},"wageData":{"2016":{"workers":"1,671","median":"1,040","maleWorkers":"919","maleMedian":"1,139","femaleWorkers":"752","femaleMedian":"951"}}},"Artists and related workers":{"ageData":{"2016":{"total":"232","16to19":"3","20to24":"9","25to34":"46","35to44":"43","45to54":"47","55to64":"48","65+":"36","medianAge":"48"}},"title":"Artists and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2016":{"total":"232","women":"56.6","white":"3.6","black":"3.6","asian":"9.9"}},"wageData":{"2016":{"workers":"61","median":"1,236","maleWorkers":"38","maleMedian":"-","femaleWorkers":"23","femaleMedian":"-"}}},"Designers":{"ageData":{"2016":{"total":"878","16to19":"5","20to24":"80","25to34":"250","35to44":"179","45to54":"188","55to64":"121","65+":"55","medianAge":"121"}},"title":"Designers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2016":{"total":"878","women":"54.8","white":"5.1","black":"8.4","asian":"10.6"}},"wageData":{"2016":{"workers":"586","median":"1,086","maleWorkers":"290","maleMedian":"1,267","femaleWorkers":"297","femaleMedian":"922"}}},"Actors":{"ageData":{"2016":{"total":"47","16to19":"1","20to24":"4","25to34":"17","35to44":"8","45to54":"7","55to64":"3","65+":"7","medianAge":"3"}},"title":"Actors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2016":{"total":"47","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"13","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Producers and directors":{"ageData":{"2016":{"total":"173","16to19":"1","20to24":"8","25to34":"56","35to44":"44","45to54":"30","55to64":"26","65+":"7","medianAge":"26"}},"title":"Producers and directors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2016":{"total":"173","women":"38.5","white":"3.6","black":"4.6","asian":"6.3"}},"wageData":{"2016":{"workers":"128","median":"1,163","maleWorkers":"78","maleMedian":"1,228","femaleWorkers":"50","femaleMedian":"1,030"}}},"Athletes, coaches, umpires, and related workers":{"ageData":{"2016":{"total":"312","16to19":"51","20to24":"58","25to34":"68","35to44":"43","45to54":"40","55to64":"34","65+":"18","medianAge":"34"}},"title":"Athletes, coaches, umpires, and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2016":{"total":"312","women":"34.2","white":"8.4","black":"2.2","asian":"11.7"}},"wageData":{"2016":{"workers":"141","median":"826","maleWorkers":"106","maleMedian":"862","femaleWorkers":"35","femaleMedian":"-"}}},"Dancers and choreographers":{"ageData":{"2016":{"total":"17","16to19":"0","20to24":"7","25to34":"5","35to44":"4","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Dancers and choreographers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2016":{"total":"17","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"5","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Musicians, singers, and related workers":{"ageData":{"2016":{"total":"192","16to19":"3","20to24":"13","25to34":"51","35to44":"44","45to54":"19","55to64":"36","65+":"24","medianAge":"36"}},"title":"Musicians, singers, and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2016":{"total":"192","women":"40.4","white":"14.6","black":"3.7","asian":"9.3"}},"wageData":{"2016":{"workers":"37","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Entertainers and performers, sports and related workers, all other":{"ageData":{"2016":{"total":"49","16to19":"3","20to24":"8","25to34":"10","35to44":"10","45to54":"9","55to64":"7","65+":"1","medianAge":"7"}},"title":"Entertainers and performers, sports and related workers, all other","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2016":{"total":"49","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"13","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Announcers":{"ageData":{"2016":{"total":"59","16to19":"2","20to24":"5","25to34":"15","35to44":"14","45to54":"11","55to64":"8","65+":"5","medianAge":"8"}},"title":"Announcers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2016":{"total":"59","women":"20.9","white":"16.6","black":"4.0","asian":"20.7"}},"wageData":{"2016":{"workers":"32","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"News analysts, reporters and correspondents":{"ageData":{"2016":{"total":"73","16to19":"0","20to24":"8","25to34":"20","35to44":"11","45to54":"18","55to64":"12","65+":"3","medianAge":"12"}},"title":"News analysts, reporters and correspondents","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2016":{"total":"73","women":"48.8","white":"3.6","black":"9.6","asian":"10.5"}},"wageData":{"2016":{"workers":"58","median":"1,166","maleWorkers":"30","maleMedian":"-","femaleWorkers":"27","femaleMedian":"-"}}},"Public relations specialists":{"ageData":{"2016":{"total":"121","16to19":"1","20to24":"13","25to34":"32","35to44":"34","45to54":"21","55to64":"17","65+":"2","medianAge":"17"}},"title":"Public relations specialists","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2016":{"total":"121","women":"58.9","white":"8.2","black":"1.7","asian":"7.3"}},"wageData":{"2016":{"workers":"107","median":"1,228","maleWorkers":"40","maleMedian":"-","femaleWorkers":"67","femaleMedian":"1,134"}}},"Editors":{"ageData":{"2016":{"total":"167","16to19":"1","20to24":"15","25to34":"42","35to44":"35","45to54":"38","55to64":"28","65+":"7","medianAge":"28"}},"title":"Editors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2016":{"total":"167","women":"52.4","white":"1.9","black":"6.6","asian":"6.0"}},"wageData":{"2016":{"workers":"120","median":"1,053","maleWorkers":"64","maleMedian":"1,112","femaleWorkers":"56","femaleMedian":"1,035"}}},"Technical writers":{"ageData":{"2016":{"total":"61","16to19":"0","20to24":"2","25to34":"11","35to44":"12","45to54":"13","55to64":"16","65+":"7","medianAge":"16"}},"title":"Technical writers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2016":{"total":"61","women":"55.7","white":"7.8","black":"4.1","asian":"7.8"}},"wageData":{"2016":{"workers":"56","median":"1,253","maleWorkers":"29","maleMedian":"-","femaleWorkers":"27","femaleMedian":"-"}}},"Writers and authors":{"ageData":{"2016":{"total":"229","16to19":"2","20to24":"15","25to34":"48","35to44":"45","45to54":"58","55to64":"29","65+":"32","medianAge":"29"}},"title":"Writers and authors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2016":{"total":"229","women":"62.8","white":"3.4","black":"2.5","asian":"5.6"}},"wageData":{"2016":{"workers":"99","median":"1,070","maleWorkers":"39","maleMedian":"-","femaleWorkers":"60","femaleMedian":"983"}}},"Miscellaneous media and communication workers":{"ageData":{"2016":{"total":"116","16to19":"1","20to24":"7","25to34":"31","35to44":"32","45to54":"19","55to64":"17","65+":"9","medianAge":"17"}},"title":"Miscellaneous media and communication workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2016":{"total":"116","women":"68.7","white":"11.3","black":"13.0","asian":"37.8"}},"wageData":{"2016":{"workers":"59","median":"745","maleWorkers":"24","maleMedian":"-","femaleWorkers":"36","femaleMedian":"-"}}},"Broadcast and sound engineering technicians and radio operators":{"ageData":{"2016":{"total":"111","16to19":"3","20to24":"9","25to34":"34","35to44":"30","45to54":"18","55to64":"15","65+":"2","medianAge":"15"}},"title":"Broadcast and sound engineering technicians and radio operators","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2016":{"total":"111","women":"15.2","white":"13.1","black":"2.4","asian":"12.1"}},"wageData":{"2016":{"workers":"80","median":"1,020","maleWorkers":"67","maleMedian":"1,099","femaleWorkers":"13","femaleMedian":"-"}}},"Photographers":{"ageData":{"2016":{"total":"205","16to19":"8","20to24":"17","25to34":"44","35to44":"51","45to54":"36","55to64":"35","65+":"13","medianAge":"35"}},"title":"Photographers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2016":{"total":"205","women":"47.7","white":"5.7","black":"5.7","asian":"8.4"}},"wageData":{"2016":{"workers":"43","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"19","femaleMedian":"-"}}},"Television, video, and motion picture camera operators and editors":{"ageData":{"2016":{"total":"54","16to19":"2","20to24":"6","25to34":"20","35to44":"15","45to54":"4","55to64":"4","65+":"3","medianAge":"4"}},"title":"Television, video, and motion picture camera operators and editors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2016":{"total":"54","women":"21.4","white":"3.1","black":"3.8","asian":"11.4"}},"wageData":{"2016":{"workers":"31","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Media and communication equipment workers, all other":{"ageData":{"2016":{"total":"1","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Media and communication equipment workers, all other","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2016":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Healthcare practitioners and technical occupations":{"ageData":{"2016":{"total":"8,960","16to19":"36","20to24":"487","25to34":"2,317","35to44":"2,097","45to54":"1,967","55to64":"1,578","65+":"475","medianAge":"1,578"}},"title":"Healthcare practitioners and technical occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2016":{"total":"8,960","women":"75.6","white":"11.8","black":"9.6","asian":"7.8"}},"wageData":{"2016":{"workers":"6,857","median":"1,104","maleWorkers":"1,706","maleMedian":"1,332","femaleWorkers":"5,150","femaleMedian":"1,036"}}},"Chiropractors":{"ageData":{"2016":{"total":"51","16to19":"0","20to24":"1","25to34":"9","35to44":"11","45to54":"15","55to64":"11","65+":"5","medianAge":"11"}},"title":"Chiropractors","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"51","women":"27.4","white":"1.7","black":"4.6","asian":"9.8"}},"wageData":{"2016":{"workers":"18","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Dentists":{"ageData":{"2016":{"total":"163","16to19":"0","20to24":"1","25to34":"41","35to44":"31","45to54":"33","55to64":"42","65+":"15","medianAge":"42"}},"title":"Dentists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"163","women":"34.4","white":"3.2","black":"20.2","asian":"9.5"}},"wageData":{"2016":{"workers":"61","median":"1,850","maleWorkers":"34","maleMedian":"-","femaleWorkers":"27","femaleMedian":"-"}}},"Dietitians and nutritionists":{"ageData":{"2016":{"total":"120","16to19":"0","20to24":"8","25to34":"34","35to44":"29","45to54":"22","55to64":"20","65+":"7","medianAge":"20"}},"title":"Dietitians and nutritionists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"120","women":"89.4","white":"15.9","black":"6.1","asian":"4.9"}},"wageData":{"2016":{"workers":"82","median":"986","maleWorkers":"11","maleMedian":"-","femaleWorkers":"71","femaleMedian":"997"}}},"Optometrists":{"ageData":{"2016":{"total":"36","16to19":"0","20to24":"1","25to34":"12","35to44":"6","45to54":"11","55to64":"4","65+":"3","medianAge":"4"}},"title":"Optometrists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"36","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"18","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"15","femaleMedian":"-"}}},"Pharmacists":{"ageData":{"2016":{"total":"306","16to19":"0","20to24":"14","25to34":"101","35to44":"71","45to54":"49","55to64":"50","65+":"19","medianAge":"50"}},"title":"Pharmacists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"306","women":"59.9","white":"10.1","black":"18.1","asian":"4.6"}},"wageData":{"2016":{"workers":"222","median":"1,924","maleWorkers":"89","maleMedian":"2,096","femaleWorkers":"133","femaleMedian":"1,839"}}},"Physicians and surgeons":{"ageData":{"2016":{"total":"1,061","16to19":"1","20to24":"2","25to34":"240","35to44":"263","45to54":"247","55to64":"205","65+":"103","medianAge":"205"}},"title":"Physicians and surgeons","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"1,061","women":"38.2","white":"7.5","black":"19.3","asian":"5.9"}},"wageData":{"2016":{"workers":"806","median":"1,916","maleWorkers":"497","maleMedian":"2,343","femaleWorkers":"308","femaleMedian":"1,476"}}},"Physician assistants":{"ageData":{"2016":{"total":"92","16to19":"0","20to24":"2","25to34":"35","35to44":"28","45to54":"15","55to64":"9","65+":"3","medianAge":"9"}},"title":"Physician assistants","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"92","women":"70.0","white":"3.2","black":"11.5","asian":"6.0"}},"wageData":{"2016":{"workers":"75","median":"1,544","maleWorkers":"25","maleMedian":"-","femaleWorkers":"50","femaleMedian":"1,547"}}},"Podiatrists":{"ageData":{"2016":{"total":"12","16to19":"0","20to24":"0","25to34":"0","35to44":"3","45to54":"4","55to64":"4","65+":"1","medianAge":"4"}},"title":"Podiatrists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"4","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Audiologists":{"ageData":{"2016":{"total":"15","16to19":"0","20to24":"0","25to34":"4","35to44":"3","45to54":"5","55to64":"2","65+":"1","medianAge":"2"}},"title":"Audiologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"15","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"11","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Occupational therapists":{"ageData":{"2016":{"total":"118","16to19":"0","20to24":"5","25to34":"37","35to44":"31","45to54":"29","55to64":"12","65+":"4","medianAge":"12"}},"title":"Occupational therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"118","women":"89.2","white":"7.5","black":"8.2","asian":"6.3"}},"wageData":{"2016":{"workers":"71","median":"1,365","maleWorkers":"10","maleMedian":"-","femaleWorkers":"61","femaleMedian":"1,315"}}},"Physical therapists":{"ageData":{"2016":{"total":"290","16to19":"0","20to24":"5","25to34":"90","35to44":"75","45to54":"70","55to64":"38","65+":"11","medianAge":"38"}},"title":"Physical therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"290","women":"69.3","white":"5.2","black":"9.5","asian":"5.3"}},"wageData":{"2016":{"workers":"197","median":"1,325","maleWorkers":"69","maleMedian":"1,348","femaleWorkers":"128","femaleMedian":"1,306"}}},"Radiation therapists":{"ageData":{"2016":{"total":"13","16to19":"0","20to24":"0","25to34":"7","35to44":"2","45to54":"2","55to64":"3","65+":"0","medianAge":"3"}},"title":"Radiation therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"11","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Recreational therapists":{"ageData":{"2016":{"total":"11","16to19":"0","20to24":"0","25to34":"2","35to44":"4","45to54":"2","55to64":"3","65+":"0","medianAge":"3"}},"title":"Recreational therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"9","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Respiratory therapists":{"ageData":{"2016":{"total":"84","16to19":"0","20to24":"1","25to34":"24","35to44":"20","45to54":"22","55to64":"13","65+":"3","medianAge":"13"}},"title":"Respiratory therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"84","women":"73.5","white":"8.5","black":"5.2","asian":"8.7"}},"wageData":{"2016":{"workers":"76","median":"998","maleWorkers":"22","maleMedian":"-","femaleWorkers":"54","femaleMedian":"993"}}},"Speech-language pathologists":{"ageData":{"2016":{"total":"162","16to19":"0","20to24":"7","25to34":"45","35to44":"50","45to54":"27","55to64":"27","65+":"5","medianAge":"27"}},"title":"Speech-language pathologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"162","women":"97.5","white":"2.9","black":"3.2","asian":"9.0"}},"wageData":{"2016":{"workers":"112","median":"1,200","maleWorkers":"3","maleMedian":"-","femaleWorkers":"109","femaleMedian":"1,172"}}},"Exercise physiologists":{"ageData":{"2016":{"total":"2","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Exercise physiologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Therapists, all other":{"ageData":{"2016":{"total":"205","16to19":"2","20to24":"20","25to34":"62","35to44":"48","45to54":"36","55to64":"23","65+":"15","medianAge":"23"}},"title":"Therapists, all other","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"205","women":"82.6","white":"9.2","black":"6.1","asian":"15.7"}},"wageData":{"2016":{"workers":"137","median":"920","maleWorkers":"32","maleMedian":"-","femaleWorkers":"106","femaleMedian":"913"}}},"Veterinarians":{"ageData":{"2016":{"total":"101","16to19":"0","20to24":"1","25to34":"26","35to44":"26","45to54":"22","55to64":"19","65+":"7","medianAge":"19"}},"title":"Veterinarians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"101","women":"63.2","white":"2.1","black":"3.7","asian":"0.3"}},"wageData":{"2016":{"workers":"65","median":"1,338","maleWorkers":"19","maleMedian":"-","femaleWorkers":"46","femaleMedian":"-"}}},"Registered nurses":{"ageData":{"2016":{"total":"3,102","16to19":"4","20to24":"140","25to34":"766","35to44":"711","45to54":"709","55to64":"621","65+":"150","medianAge":"621"}},"title":"Registered nurses","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"3,102","women":"90.0","white":"11.9","black":"9.0","asian":"6.6"}},"wageData":{"2016":{"workers":"2,498","median":"1,154","maleWorkers":"285","maleMedian":"1,261","femaleWorkers":"2,213","femaleMedian":"1,143"}}},"Nurse anesthetists":{"ageData":{"2016":{"total":"23","16to19":"0","20to24":"0","25to34":"8","35to44":"8","45to54":"4","55to64":"2","65+":"1","medianAge":"2"}},"title":"Nurse anesthetists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"23","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"14","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Nurse midwives":{"ageData":{"2016":{"total":"6","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"3","55to64":"2","65+":"0","medianAge":"2"}},"title":"Nurse midwives","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"5","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Nurse practitioners":{"ageData":{"2016":{"total":"176","16to19":"0","20to24":"1","25to34":"35","35to44":"51","45to54":"39","55to64":"38","65+":"12","medianAge":"38"}},"title":"Nurse practitioners","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"176","women":"94.0","white":"8.5","black":"6.2","asian":"3.5"}},"wageData":{"2016":{"workers":"144","median":"1,750","maleWorkers":"11","maleMedian":"-","femaleWorkers":"133","femaleMedian":"1,753"}}},"Health diagnosing and treating practitioners, all other":{"ageData":{"2016":{"total":"32","16to19":"0","20to24":"0","25to34":"5","35to44":"7","45to54":"10","55to64":"5","65+":"5","medianAge":"5"}},"title":"Health diagnosing and treating practitioners, all other","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"32","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"8","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Clinical laboratory technologists and technicians":{"ageData":{"2016":{"total":"361","16to19":"3","20to24":"37","25to34":"87","35to44":"81","45to54":"73","55to64":"59","65+":"22","medianAge":"59"}},"title":"Clinical laboratory technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"361","women":"68.5","white":"16.5","black":"10.6","asian":"13.0"}},"wageData":{"2016":{"workers":"295","median":"887","maleWorkers":"97","maleMedian":"1,071","femaleWorkers":"198","femaleMedian":"834"}}},"Dental hygienists":{"ageData":{"2016":{"total":"169","16to19":"1","20to24":"9","25to34":"44","35to44":"40","45to54":"42","55to64":"28","65+":"5","medianAge":"28"}},"title":"Dental hygienists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"169","women":"97.1","white":"5.2","black":"2.7","asian":"9.2"}},"wageData":{"2016":{"workers":"75","median":"1,034","maleWorkers":"2","maleMedian":"-","femaleWorkers":"73","femaleMedian":"1,045"}}},"Diagnostic related technologists and technicians":{"ageData":{"2016":{"total":"311","16to19":"1","20to24":"16","25to34":"73","35to44":"69","45to54":"87","55to64":"54","65+":"11","medianAge":"54"}},"title":"Diagnostic related technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"311","women":"73.0","white":"9.8","black":"5.4","asian":"8.8"}},"wageData":{"2016":{"workers":"254","median":"1,041","maleWorkers":"79","maleMedian":"1,156","femaleWorkers":"175","femaleMedian":"936"}}},"Emergency medical technicians and paramedics":{"ageData":{"2016":{"total":"194","16to19":"1","20to24":"32","25to34":"75","35to44":"40","45to54":"34","55to64":"10","65+":"2","medianAge":"10"}},"title":"Emergency medical technicians and paramedics","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"194","women":"35.7","white":"12.4","black":"2.3","asian":"12.1"}},"wageData":{"2016":{"workers":"174","median":"779","maleWorkers":"114","maleMedian":"821","femaleWorkers":"60","femaleMedian":"650"}}},"Health practitioner support technologists and technicians":{"ageData":{"2016":{"total":"610","16to19":"12","20to24":"94","25to34":"201","35to44":"130","45to54":"95","55to64":"64","65+":"13","medianAge":"64"}},"title":"Health practitioner support technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"610","women":"79.5","white":"12.7","black":"8.8","asian":"12.2"}},"wageData":{"2016":{"workers":"474","median":"662","maleWorkers":"113","maleMedian":"712","femaleWorkers":"361","femaleMedian":"643"}}},"Licensed practical and licensed vocational nurses":{"ageData":{"2016":{"total":"653","16to19":"9","20to24":"56","25to34":"150","35to44":"153","45to54":"149","55to64":"110","65+":"25","medianAge":"110"}},"title":"Licensed practical and licensed vocational nurses","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"653","women":"90.0","white":"30.3","black":"4.2","asian":"10.1"}},"wageData":{"2016":{"workers":"525","median":"749","maleWorkers":"44","maleMedian":"-","femaleWorkers":"481","femaleMedian":"743"}}},"Medical records and health information technicians":{"ageData":{"2016":{"total":"184","16to19":"1","20to24":"6","25to34":"31","35to44":"38","45to54":"53","55to64":"49","65+":"7","medianAge":"49"}},"title":"Medical records and health information technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"184","women":"92.1","white":"10.7","black":"5.3","asian":"6.4"}},"wageData":{"2016":{"workers":"170","median":"798","maleWorkers":"11","maleMedian":"-","femaleWorkers":"159","femaleMedian":"793"}}},"Opticians, dispensing":{"ageData":{"2016":{"total":"55","16to19":"0","20to24":"3","25to34":"13","35to44":"7","45to54":"14","55to64":"12","65+":"6","medianAge":"12"}},"title":"Opticians, dispensing","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"55","women":"69.7","white":"7.3","black":"2.2","asian":"11.6"}},"wageData":{"2016":{"workers":"42","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Miscellaneous health technologists and technicians":{"ageData":{"2016":{"total":"130","16to19":"0","20to24":"13","25to34":"32","35to44":"34","45to54":"26","55to64":"18","65+":"6","medianAge":"18"}},"title":"Miscellaneous health technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"130","women":"65.6","white":"24.3","black":"11.9","asian":"9.7"}},"wageData":{"2016":{"workers":"107","median":"745","maleWorkers":"43","maleMedian":"-","femaleWorkers":"64","femaleMedian":"714"}}},"Other healthcare practitioners and technical occupations":{"ageData":{"2016":{"total":"114","16to19":"1","20to24":"12","25to34":"25","35to44":"28","45to54":"19","55to64":"21","65+":"7","medianAge":"21"}},"title":"Other healthcare practitioners and technical occupations","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2016":{"total":"114","women":"51.7","white":"13.5","black":"3.4","asian":"11.9"}},"wageData":{"2016":{"workers":"96","median":"1,083","maleWorkers":"49","maleMedian":"-","femaleWorkers":"47","femaleMedian":"-"}}},"Service occupations":{"ageData":{"2016":{"total":"26,811","16to19":"2,070","20to24":"4,007","25to34":"6,077","35to44":"4,889","45to54":"4,821","55to64":"3,655","65+":"1,292","medianAge":"3,655"}},"title":"Service occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2016":{"total":"26,811","women":"56.6","white":"16.8","black":"5.5","asian":"23.9"}},"wageData":{"2016":{"workers":"15,908","median":"523","maleWorkers":"7,994","maleMedian":"595","femaleWorkers":"7,914","femaleMedian":"487"}}},"Healthcare support occupations":{"ageData":{"2016":{"total":"3,554","16to19":"82","20to24":"504","25to34":"975","35to44":"681","45to54":"665","55to64":"500","65+":"146","medianAge":"500"}},"title":"Healthcare support occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2016":{"total":"3,554","women":"87.7","white":"27.3","black":"5.5","asian":"16.9"}},"wageData":{"2016":{"workers":"2,423","median":"525","maleWorkers":"329","maleMedian":"602","femaleWorkers":"2,094","femaleMedian":"519"}}},"Nursing, psychiatric, and home health aides":{"ageData":{"2016":{"total":"2,058","16to19":"46","20to24":"285","25to34":"519","35to44":"373","45to54":"408","55to64":"330","65+":"97","medianAge":"330"}},"title":"Nursing, psychiatric, and home health aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2016":{"total":"2,058","women":"88.1","white":"37.5","black":"5.8","asian":"14.6"}},"wageData":{"2016":{"workers":"1,386","median":"503","maleWorkers":"194","maleMedian":"534","femaleWorkers":"1,192","femaleMedian":"498"}}},"Occupational therapy assistants and aides":{"ageData":{"2016":{"total":"20","16to19":"0","20to24":"5","25to34":"3","35to44":"5","45to54":"5","55to64":"2","65+":"0","medianAge":"2"}},"title":"Occupational therapy assistants and aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2016":{"total":"20","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"13","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Physical therapist assistants and aides":{"ageData":{"2016":{"total":"70","16to19":"1","20to24":"14","25to34":"22","35to44":"14","45to54":"12","55to64":"6","65+":"1","medianAge":"6"}},"title":"Physical therapist assistants and aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2016":{"total":"70","women":"69.4","white":"6.4","black":"6.3","asian":"10.4"}},"wageData":{"2016":{"workers":"48","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"32","femaleMedian":"-"}}},"Massage therapists":{"ageData":{"2016":{"total":"170","16to19":"0","20to24":"9","25to34":"41","35to44":"37","45to54":"38","55to64":"36","65+":"9","medianAge":"36"}},"title":"Massage therapists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2016":{"total":"170","women":"80.7","white":"6.8","black":"7.7","asian":"9.6"}},"wageData":{"2016":{"workers":"45","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"30","femaleMedian":"-"}}},"Dental assistants":{"ageData":{"2016":{"total":"294","16to19":"9","20to24":"44","25to34":"90","35to44":"69","45to54":"45","55to64":"30","65+":"7","medianAge":"30"}},"title":"Dental assistants","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2016":{"total":"294","women":"93.3","white":"11.4","black":"6.5","asian":"24.1"}},"wageData":{"2016":{"workers":"199","median":"592","maleWorkers":"19","maleMedian":"-","femaleWorkers":"180","femaleMedian":"583"}}},"Medical assistants":{"ageData":{"2016":{"total":"570","16to19":"3","20to24":"86","25to34":"203","35to44":"124","45to54":"91","55to64":"50","65+":"13","medianAge":"50"}},"title":"Medical assistants","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2016":{"total":"570","women":"92.9","white":"14.3","black":"4.1","asian":"28.6"}},"wageData":{"2016":{"workers":"488","median":"572","maleWorkers":"36","maleMedian":"-","femaleWorkers":"452","femaleMedian":"562"}}},"Medical transcriptionists":{"ageData":{"2016":{"total":"39","16to19":"0","20to24":"5","25to34":"5","35to44":"4","45to54":"9","55to64":"10","65+":"6","medianAge":"10"}},"title":"Medical transcriptionists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2016":{"total":"39","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"23","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"23","femaleMedian":"-"}}},"Pharmacy aides":{"ageData":{"2016":{"total":"36","16to19":"1","20to24":"10","25to34":"8","35to44":"2","45to54":"3","55to64":"7","65+":"4","medianAge":"7"}},"title":"Pharmacy aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2016":{"total":"36","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"21","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"19","femaleMedian":"-"}}},"Veterinary assistants and laboratory animal caretakers":{"ageData":{"2016":{"total":"39","16to19":"4","20to24":"10","25to34":"14","35to44":"4","45to54":"4","55to64":"2","65+":"1","medianAge":"2"}},"title":"Veterinary assistants and laboratory animal caretakers","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2016":{"total":"39","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"24","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Phlebotomists":{"ageData":{"2016":{"total":"101","16to19":"2","20to24":"13","25to34":"31","35to44":"20","45to54":"24","55to64":"10","65+":"3","medianAge":"10"}},"title":"Phlebotomists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2016":{"total":"101","women":"86.5","white":"22.0","black":"3.6","asian":"16.2"}},"wageData":{"2016":{"workers":"84","median":"586","maleWorkers":"12","maleMedian":"-","femaleWorkers":"71","femaleMedian":"570"}}},"Miscellaneous healthcare support occupations, including medical equipment preparers":{"ageData":{"2016":{"total":"156","16to19":"16","20to24":"22","25to34":"38","35to44":"29","45to54":"27","55to64":"18","65+":"6","medianAge":"18"}},"title":"Miscellaneous healthcare support occupations, including medical equipment preparers","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2016":{"total":"156","women":"73.9","white":"26.0","black":"4.0","asian":"7.9"}},"wageData":{"2016":{"workers":"94","median":"537","maleWorkers":"29","maleMedian":"-","femaleWorkers":"65","femaleMedian":"504"}}},"Protective service occupations":{"ageData":{"2016":{"total":"3,117","16to19":"114","20to24":"292","25to34":"773","35to44":"689","45to54":"676","55to64":"410","65+":"163","medianAge":"410"}},"title":"Protective service occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2016":{"total":"3,117","women":"22.3","white":"19.0","black":"2.8","asian":"14.1"}},"wageData":{"2016":{"workers":"2,697","median":"809","maleWorkers":"2,173","maleMedian":"854","femaleWorkers":"524","femaleMedian":"688"}}},"First-line supervisors of correctional officers":{"ageData":{"2016":{"total":"61","16to19":"0","20to24":"2","25to34":"8","35to44":"17","45to54":"24","55to64":"9","65+":"0","medianAge":"9"}},"title":"First-line supervisors of correctional officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2016":{"total":"61","women":"34.0","white":"23.3","black":"2.6","asian":"17.3"}},"wageData":{"2016":{"workers":"55","median":"873","maleWorkers":"35","maleMedian":"-","femaleWorkers":"20","femaleMedian":"-"}}},"First-line supervisors of police and detectives":{"ageData":{"2016":{"total":"114","16to19":"0","20to24":"0","25to34":"11","35to44":"34","45to54":"46","55to64":"21","65+":"3","medianAge":"21"}},"title":"First-line supervisors of police and detectives","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2016":{"total":"114","women":"18.3","white":"12.3","black":"0.2","asian":"10.6"}},"wageData":{"2016":{"workers":"120","median":"1,324","maleWorkers":"97","maleMedian":"1,361","femaleWorkers":"23","femaleMedian":"-"}}},"First-line supervisors of fire fighting and prevention workers":{"ageData":{"2016":{"total":"44","16to19":"0","20to24":"0","25to34":"3","35to44":"10","45to54":"17","55to64":"13","65+":"1","medianAge":"13"}},"title":"First-line supervisors of fire fighting and prevention workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2016":{"total":"44","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"45","median":"-","maleWorkers":"41","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"First-line supervisors of protective service workers, all other":{"ageData":{"2016":{"total":"88","16to19":"0","20to24":"5","25to34":"17","35to44":"13","45to54":"24","55to64":"22","65+":"7","medianAge":"22"}},"title":"First-line supervisors of protective service workers, all other","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2016":{"total":"88","women":"23.5","white":"16.9","black":"3.0","asian":"11.7"}},"wageData":{"2016":{"workers":"89","median":"880","maleWorkers":"66","maleMedian":"895","femaleWorkers":"23","femaleMedian":"-"}}},"Firefighters":{"ageData":{"2016":{"total":"252","16to19":"0","20to24":"12","25to34":"90","35to44":"74","45to54":"48","55to64":"24","65+":"5","medianAge":"24"}},"title":"Firefighters","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2016":{"total":"252","women":"3.5","white":"6.8","black":"1.4","asian":"7.7"}},"wageData":{"2016":{"workers":"252","median":"1,065","maleWorkers":"244","maleMedian":"1,056","femaleWorkers":"8","femaleMedian":"-"}}},"Fire inspectors":{"ageData":{"2016":{"total":"27","16to19":"1","20to24":"4","25to34":"2","35to44":"6","45to54":"9","55to64":"4","65+":"1","medianAge":"4"}},"title":"Fire inspectors","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2016":{"total":"27","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"16","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Bailiffs, correctional officers, and jailers":{"ageData":{"2016":{"total":"383","16to19":"3","20to24":"43","25to34":"114","35to44":"81","45to54":"93","55to64":"37","65+":"12","medianAge":"37"}},"title":"Bailiffs, correctional officers, and jailers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2016":{"total":"383","women":"28.2","white":"25.5","black":"1.9","asian":"12.9"}},"wageData":{"2016":{"workers":"365","median":"749","maleWorkers":"275","maleMedian":"793","femaleWorkers":"91","femaleMedian":"672"}}},"Detectives and criminal investigators":{"ageData":{"2016":{"total":"130","16to19":"0","20to24":"4","25to34":"25","35to44":"40","45to54":"40","55to64":"20","65+":"1","medianAge":"20"}},"title":"Detectives and criminal investigators","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2016":{"total":"130","women":"23.6","white":"6.9","black":"4.0","asian":"7.6"}},"wageData":{"2016":{"workers":"132","median":"1,182","maleWorkers":"104","maleMedian":"1,251","femaleWorkers":"28","femaleMedian":"-"}}},"Fish and game wardens":{"ageData":{"2016":{"total":"9","16to19":"0","20to24":"0","25to34":"2","35to44":"4","45to54":"2","55to64":"1","65+":"1","medianAge":"1"}},"title":"Fish and game wardens","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2016":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"8","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Parking enforcement workers":{"ageData":{"2016":{"total":"8","16to19":"1","20to24":"0","25to34":"3","35to44":"1","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Parking enforcement workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2016":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"6","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Police and sheriff\'s patrol officers":{"ageData":{"2016":{"total":"708","16to19":"1","20to24":"42","25to34":"196","35to44":"230","45to54":"159","55to64":"60","65+":"19","medianAge":"60"}},"title":"Police and sheriff\'s patrol officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2016":{"total":"708","women":"14.1","white":"12.0","black":"2.7","asian":"16.0"}},"wageData":{"2016":{"workers":"709","median":"1,004","maleWorkers":"609","maleMedian":"1,008","femaleWorkers":"100","femaleMedian":"938"}}},"Transit and railroad police":{"ageData":{"2016":{"total":"2","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Transit and railroad police","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2016":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Animal control workers":{"ageData":{"2016":{"total":"9","16to19":"0","20to24":"2","25to34":"2","35to44":"1","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Animal control workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2016":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"6","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Private detectives and investigators":{"ageData":{"2016":{"total":"94","16to19":"0","20to24":"4","25to34":"16","35to44":"22","45to54":"19","55to64":"18","65+":"13","medianAge":"18"}},"title":"Private detectives and investigators","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2016":{"total":"94","women":"44.0","white":"11.5","black":"4.5","asian":"6.7"}},"wageData":{"2016":{"workers":"60","median":"904","maleWorkers":"31","maleMedian":"-","femaleWorkers":"29","femaleMedian":"-"}}},"Security guards and gaming surveillance officers":{"ageData":{"2016":{"total":"923","16to19":"18","20to24":"139","25to34":"241","35to44":"139","45to54":"159","55to64":"149","65+":"78","medianAge":"149"}},"title":"Security guards and gaming surveillance officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2016":{"total":"923","women":"22.0","white":"30.4","black":"4.0","asian":"17.6"}},"wageData":{"2016":{"workers":"727","median":"585","maleWorkers":"576","maleMedian":"597","femaleWorkers":"152","femaleMedian":"516"}}},"Crossing guards":{"ageData":{"2016":{"total":"72","16to19":"2","20to24":"5","25to34":"12","35to44":"9","45to54":"10","55to64":"18","65+":"16","medianAge":"18"}},"title":"Crossing guards","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2016":{"total":"72","women":"60.4","white":"26.4","black":"1.5","asian":"15.5"}},"wageData":{"2016":{"workers":"23","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Transportation security screeners":{"ageData":{"2016":{"total":"44","16to19":"0","20to24":"2","25to34":"13","35to44":"4","45to54":"14","55to64":"10","65+":"2","medianAge":"10"}},"title":"Transportation security screeners","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2016":{"total":"44","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"40","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Lifeguards and other recreational, and all other protective service workers":{"ageData":{"2016":{"total":"149","16to19":"88","20to24":"29","25to34":"15","35to44":"4","45to54":"8","55to64":"1","65+":"4","medianAge":"1"}},"title":"Lifeguards and other recreational, and all other protective service workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2016":{"total":"149","women":"44.2","white":"8.7","black":"1.2","asian":"11.4"}},"wageData":{"2016":{"workers":"42","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"14","femaleMedian":"-"}}},"Food preparation and serving related occupations":{"ageData":{"2016":{"total":"8,542","16to19":"1,347","20to24":"1,936","25to34":"2,015","35to44":"1,221","45to54":"1,050","55to64":"743","65+":"229","medianAge":"743"}},"title":"Food preparation and serving related occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2016":{"total":"8,542","women":"53.5","white":"13.8","black":"5.8","asian":"25.8"}},"wageData":{"2016":{"workers":"4,619","median":"465","maleWorkers":"2,417","maleMedian":"491","femaleWorkers":"2,202","femaleMedian":"434"}}},"Chefs and head cooks":{"ageData":{"2016":{"total":"460","16to19":"6","20to24":"53","25to34":"141","35to44":"108","45to54":"88","55to64":"55","65+":"10","medianAge":"55"}},"title":"Chefs and head cooks","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2016":{"total":"460","women":"21.4","white":"14.7","black":"11.6","asian":"23.0"}},"wageData":{"2016":{"workers":"356","median":"614","maleWorkers":"288","maleMedian":"632","femaleWorkers":"68","femaleMedian":"519"}}},"First-line supervisors of food preparation and serving workers":{"ageData":{"2016":{"total":"543","16to19":"25","20to24":"89","25to34":"147","35to44":"97","45to54":"98","55to64":"72","65+":"14","medianAge":"72"}},"title":"First-line supervisors of food preparation and serving workers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2016":{"total":"543","women":"57.7","white":"15.5","black":"5.3","asian":"17.6"}},"wageData":{"2016":{"workers":"425","median":"528","maleWorkers":"174","maleMedian":"666","femaleWorkers":"251","femaleMedian":"485"}}},"Cooks":{"ageData":{"2016":{"total":"2,179","16to19":"254","20to24":"359","25to34":"527","35to44":"409","45to54":"331","55to64":"231","65+":"68","medianAge":"231"}},"title":"Cooks","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2016":{"total":"2,179","women":"38.7","white":"17.3","black":"4.8","asian":"35.0"}},"wageData":{"2016":{"workers":"1,408","median":"444","maleWorkers":"892","maleMedian":"459","femaleWorkers":"515","femaleMedian":"421"}}},"Food preparation workers":{"ageData":{"2016":{"total":"1,000","16to19":"187","20to24":"252","25to34":"183","35to44":"123","45to54":"127","55to64":"89","65+":"39","medianAge":"89"}},"title":"Food preparation workers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2016":{"total":"1,000","women":"58.2","white":"14.9","black":"6.7","asian":"29.3"}},"wageData":{"2016":{"workers":"477","median":"419","maleWorkers":"215","maleMedian":"432","femaleWorkers":"262","femaleMedian":"413"}}},"Bartenders":{"ageData":{"2016":{"total":"454","16to19":"4","20to24":"85","25to34":"190","35to44":"80","45to54":"57","55to64":"31","65+":"9","medianAge":"31"}},"title":"Bartenders","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2016":{"total":"454","women":"56.1","white":"7.4","black":"2.5","asian":"17.0"}},"wageData":{"2016":{"workers":"253","median":"602","maleWorkers":"131","maleMedian":"701","femaleWorkers":"122","femaleMedian":"498"}}},"Combined food preparation and serving workers, including fast food":{"ageData":{"2016":{"total":"420","16to19":"92","20to24":"116","25to34":"82","35to44":"38","45to54":"42","55to64":"38","65+":"11","medianAge":"38"}},"title":"Combined food preparation and serving workers, including fast food","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2016":{"total":"420","women":"63.5","white":"18.0","black":"3.3","asian":"20.2"}},"wageData":{"2016":{"workers":"196","median":"396","maleWorkers":"72","maleMedian":"381","femaleWorkers":"125","femaleMedian":"402"}}},"Counter attendants, cafeteria, food concession, and coffee shop":{"ageData":{"2016":{"total":"214","16to19":"108","20to24":"47","25to34":"20","35to44":"9","45to54":"16","55to64":"8","65+":"5","medianAge":"8"}},"title":"Counter attendants, cafeteria, food concession, and coffee shop","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2016":{"total":"214","women":"67.2","white":"11.4","black":"5.7","asian":"18.0"}},"wageData":{"2016":{"workers":"68","median":"374","maleWorkers":"20","maleMedian":"-","femaleWorkers":"49","femaleMedian":"-"}}},"Waiters and waitresses":{"ageData":{"2016":{"total":"2,085","16to19":"326","20to24":"672","25to34":"538","35to44":"242","45to54":"174","55to64":"104","65+":"30","medianAge":"104"}},"title":"Waiters and waitresses","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2016":{"total":"2,085","women":"70.0","white":"9.4","black":"6.6","asian":"20.9"}},"wageData":{"2016":{"workers":"949","median":"470","maleWorkers":"342","maleMedian":"504","femaleWorkers":"607","femaleMedian":"441"}}},"Food servers, nonrestaurant":{"ageData":{"2016":{"total":"213","16to19":"43","20to24":"37","25to34":"44","35to44":"15","45to54":"28","55to64":"35","65+":"11","medianAge":"35"}},"title":"Food servers, nonrestaurant","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2016":{"total":"213","women":"71.3","white":"16.3","black":"5.7","asian":"22.5"}},"wageData":{"2016":{"workers":"104","median":"479","maleWorkers":"33","maleMedian":"-","femaleWorkers":"71","femaleMedian":"445"}}},"Dining room and cafeteria attendants and bartender helpers":{"ageData":{"2016":{"total":"331","16to19":"87","20to24":"67","25to34":"51","35to44":"37","45to54":"37","55to64":"37","65+":"15","medianAge":"37"}},"title":"Dining room and cafeteria attendants and bartender helpers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2016":{"total":"331","women":"42.9","white":"15.3","black":"6.4","asian":"27.8"}},"wageData":{"2016":{"workers":"133","median":"420","maleWorkers":"82","maleMedian":"465","femaleWorkers":"51","femaleMedian":"407"}}},"Dishwashers":{"ageData":{"2016":{"total":"319","16to19":"58","20to24":"72","25to34":"58","35to44":"46","45to54":"42","55to64":"32","65+":"11","medianAge":"32"}},"title":"Dishwashers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2016":{"total":"319","women":"18.0","white":"16.3","black":"5.9","asian":"35.4"}},"wageData":{"2016":{"workers":"172","median":"389","maleWorkers":"142","maleMedian":"388","femaleWorkers":"30","femaleMedian":"-"}}},"Hosts and hostesses, restaurant, lounge, and coffee shop":{"ageData":{"2016":{"total":"319","16to19":"156","20to24":"86","25to34":"34","35to44":"17","45to54":"11","55to64":"11","65+":"5","medianAge":"11"}},"title":"Hosts and hostesses, restaurant, lounge, and coffee shop","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2016":{"total":"319","women":"80.8","white":"8.8","black":"3.8","asian":"16.3"}},"wageData":{"2016":{"workers":"74","median":"442","maleWorkers":"24","maleMedian":"-","femaleWorkers":"50","femaleMedian":"432"}}},"Food preparation and serving related workers, all other":{"ageData":{"2016":{"total":"3","16to19":"1","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"1","medianAge":"0"}},"title":"Food preparation and serving related workers, all other","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2016":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"3","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Building and grounds cleaning and maintenance occupations":{"ageData":{"2016":{"total":"5,804","16to19":"202","20to24":"485","25to34":"1,069","35to44":"1,248","45to54":"1,306","55to64":"1,144","65+":"351","medianAge":"1,144"}},"title":"Building and grounds cleaning and maintenance occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2016":{"total":"5,804","women":"40.1","white":"14.6","black":"2.9","asian":"38.2"}},"wageData":{"2016":{"workers":"3,602","median":"510","maleWorkers":"2,392","maleMedian":"548","femaleWorkers":"1,210","femaleMedian":"454"}}},"First-line supervisors of housekeeping and janitorial workers":{"ageData":{"2016":{"total":"323","16to19":"1","20to24":"12","25to34":"47","35to44":"78","45to54":"88","55to64":"80","65+":"17","medianAge":"80"}},"title":"First-line supervisors of housekeeping and janitorial workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2016":{"total":"323","women":"39.9","white":"16.0","black":"1.2","asian":"28.4"}},"wageData":{"2016":{"workers":"189","median":"655","maleWorkers":"119","maleMedian":"702","femaleWorkers":"71","femaleMedian":"524"}}},"First-line supervisors of landscaping, lawn service, and groundskeeping workers":{"ageData":{"2016":{"total":"231","16to19":"0","20to24":"17","25to34":"62","35to44":"63","45to54":"45","55to64":"36","65+":"8","medianAge":"36"}},"title":"First-line supervisors of landscaping, lawn service, and groundskeeping workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2016":{"total":"231","women":"4.6","white":"5.1","black":"1.0","asian":"24.6"}},"wageData":{"2016":{"workers":"113","median":"707","maleWorkers":"112","maleMedian":"710","femaleWorkers":"1","femaleMedian":"-"}}},"Janitors and building cleaners":{"ageData":{"2016":{"total":"2,276","16to19":"86","20to24":"176","25to34":"379","35to44":"402","45to54":"498","55to64":"555","65+":"180","medianAge":"555"}},"title":"Janitors and building cleaners","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2016":{"total":"2,276","women":"34.2","white":"17.9","black":"3.4","asian":"32.8"}},"wageData":{"2016":{"workers":"1,580","median":"526","maleWorkers":"1,139","maleMedian":"564","femaleWorkers":"441","femaleMedian":"476"}}},"Maids and housekeeping cleaners":{"ageData":{"2016":{"total":"1,485","16to19":"35","20to24":"98","25to34":"239","35to44":"372","45to54":"387","55to64":"278","65+":"75","medianAge":"278"}},"title":"Maids and housekeeping cleaners","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2016":{"total":"1,485","women":"89.6","white":"17.3","black":"4.2","asian":"47.3"}},"wageData":{"2016":{"workers":"781","median":"441","maleWorkers":"120","maleMedian":"497","femaleWorkers":"661","femaleMedian":"427"}}},"Pest control workers":{"ageData":{"2016":{"total":"79","16to19":"3","20to24":"7","25to34":"16","35to44":"19","45to54":"16","55to64":"14","65+":"4","medianAge":"14"}},"title":"Pest control workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2016":{"total":"79","women":"2.6","white":"6.2","black":"0.2","asian":"14.6"}},"wageData":{"2016":{"workers":"61","median":"655","maleWorkers":"59","maleMedian":"649","femaleWorkers":"2","femaleMedian":"-"}}},"Grounds maintenance workers":{"ageData":{"2016":{"total":"1,411","16to19":"77","20to24":"176","25to34":"327","35to44":"315","45to54":"272","55to64":"180","65+":"65","medianAge":"180"}},"title":"Grounds maintenance workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2016":{"total":"1,411","women":"5.4","white":"8.1","black":"1.4","asian":"43.1"}},"wageData":{"2016":{"workers":"878","median":"502","maleWorkers":"844","maleMedian":"503","femaleWorkers":"34","femaleMedian":"-"}}},"Personal care and service occupations":{"ageData":{"2016":{"total":"5,795","16to19":"325","20to24":"789","25to34":"1,245","35to44":"1,050","45to54":"1,124","55to64":"858","65+":"403","medianAge":"858"}},"title":"Personal care and service occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2016":{"total":"5,795","women":"77.3","white":"15.9","black":"9.3","asian":"16.3"}},"wageData":{"2016":{"workers":"2,568","median":"505","maleWorkers":"684","maleMedian":"613","femaleWorkers":"1,884","femaleMedian":"482"}}},"First-line supervisors of gaming workers":{"ageData":{"2016":{"total":"206","16to19":"4","20to24":"17","25to34":"46","35to44":"47","45to54":"53","55to64":"25","65+":"15","medianAge":"25"}},"title":"First-line supervisors of gaming workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2016":{"total":"206","women":"46.4","white":"4.8","black":"4.1","asian":"11.6"}},"wageData":{"2016":{"workers":"127","median":"792","maleWorkers":"68","maleMedian":"840","femaleWorkers":"59","femaleMedian":"717"}}},"First-line supervisors of personal service workers":{"ageData":{"2016":{"total":"191","16to19":"0","20to24":"6","25to34":"45","35to44":"53","45to54":"50","55to64":"25","65+":"11","medianAge":"25"}},"title":"First-line supervisors of personal service workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2016":{"total":"191","women":"70.5","white":"9.2","black":"15.5","asian":"10.6"}},"wageData":{"2016":{"workers":"62","median":"651","maleWorkers":"25","maleMedian":"-","femaleWorkers":"37","femaleMedian":"-"}}},"Animal trainers":{"ageData":{"2016":{"total":"61","16to19":"1","20to24":"7","25to34":"11","35to44":"13","45to54":"14","55to64":"13","65+":"1","medianAge":"13"}},"title":"Animal trainers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2016":{"total":"61","women":"47.3","white":"1.2","black":"1.3","asian":"11.7"}},"wageData":{"2016":{"workers":"24","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Nonfarm animal caretakers":{"ageData":{"2016":{"total":"233","16to19":"24","20to24":"49","25to34":"57","35to44":"32","45to54":"36","55to64":"26","65+":"9","medianAge":"26"}},"title":"Nonfarm animal caretakers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2016":{"total":"233","women":"76.9","white":"4.7","black":"2.4","asian":"11.7"}},"wageData":{"2016":{"workers":"88","median":"485","maleWorkers":"17","maleMedian":"-","femaleWorkers":"71","femaleMedian":"489"}}},"Gaming services workers":{"ageData":{"2016":{"total":"92","16to19":"2","20to24":"8","25to34":"20","35to44":"19","45to54":"24","55to64":"14","65+":"6","medianAge":"14"}},"title":"Gaming services workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2016":{"total":"92","women":"47.9","white":"8.0","black":"28.2","asian":"9.8"}},"wageData":{"2016":{"workers":"64","median":"624","maleWorkers":"33","maleMedian":"-","femaleWorkers":"31","femaleMedian":"-"}}},"Motion picture projectionists":{"ageData":{"2016":{"total":"6","16to19":"0","20to24":"0","25to34":"2","35to44":"2","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Motion picture projectionists","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2016":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Ushers, lobby attendants, and ticket takers":{"ageData":{"2016":{"total":"40","16to19":"14","20to24":"9","25to34":"5","35to44":"1","45to54":"1","55to64":"4","65+":"5","medianAge":"4"}},"title":"Ushers, lobby attendants, and ticket takers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2016":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"14","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Miscellaneous entertainment attendants and related workers":{"ageData":{"2016":{"total":"199","16to19":"47","20to24":"50","25to34":"32","35to44":"11","45to54":"16","55to64":"27","65+":"16","medianAge":"27"}},"title":"Miscellaneous entertainment attendants and related workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2016":{"total":"199","women":"41.0","white":"15.7","black":"6.4","asian":"9.8"}},"wageData":{"2016":{"workers":"79","median":"481","maleWorkers":"48","maleMedian":"-","femaleWorkers":"31","femaleMedian":"-"}}},"Embalmers and funeral attendants":{"ageData":{"2016":{"total":"12","16to19":"0","20to24":"0","25to34":"1","35to44":"2","45to54":"3","55to64":"3","65+":"3","medianAge":"3"}},"title":"Embalmers and funeral attendants","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2016":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"3","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Morticians, undertakers, and funeral directors":{"ageData":{"2016":{"total":"40","16to19":"0","20to24":"2","25to34":"6","35to44":"8","45to54":"10","55to64":"6","65+":"8","medianAge":"6"}},"title":"Morticians, undertakers, and funeral directors","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2016":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"23","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Barbers":{"ageData":{"2016":{"total":"126","16to19":"1","20to24":"9","25to34":"32","35to44":"39","45to54":"21","55to64":"14","65+":"10","medianAge":"14"}},"title":"Barbers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2016":{"total":"126","women":"11.7","white":"39.9","black":"3.3","asian":"19.6"}},"wageData":{"2016":{"workers":"56","median":"584","maleWorkers":"48","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Hairdressers, hairstylists, and cosmetologists":{"ageData":{"2016":{"total":"806","16to19":"10","20to24":"74","25to34":"220","35to44":"169","45to54":"178","55to64":"93","65+":"62","medianAge":"93"}},"title":"Hairdressers, hairstylists, and cosmetologists","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2016":{"total":"806","women":"92.4","white":"12.4","black":"5.2","asian":"16.5"}},"wageData":{"2016":{"workers":"307","median":"510","maleWorkers":"27","maleMedian":"-","femaleWorkers":"281","femaleMedian":"500"}}},"Miscellaneous personal appearance workers":{"ageData":{"2016":{"total":"364","16to19":"4","20to24":"31","25to34":"84","35to44":"96","45to54":"91","55to64":"51","65+":"6","medianAge":"51"}},"title":"Miscellaneous personal appearance workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2016":{"total":"364","women":"86.1","white":"9.5","black":"57.8","asian":"9.2"}},"wageData":{"2016":{"workers":"205","median":"490","maleWorkers":"37","maleMedian":"-","femaleWorkers":"167","femaleMedian":"466"}}},"Baggage porters, bellhops, and concierges":{"ageData":{"2016":{"total":"66","16to19":"4","20to24":"12","25to34":"13","35to44":"10","45to54":"15","55to64":"9","65+":"4","medianAge":"9"}},"title":"Baggage porters, bellhops, and concierges","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2016":{"total":"66","women":"17.5","white":"18.4","black":"8.1","asian":"31.8"}},"wageData":{"2016":{"workers":"56","median":"625","maleWorkers":"46","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Tour and travel guides":{"ageData":{"2016":{"total":"53","16to19":"4","20to24":"10","25to34":"7","35to44":"7","45to54":"7","55to64":"7","65+":"9","medianAge":"7"}},"title":"Tour and travel guides","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2016":{"total":"53","women":"40.2","white":"13.0","black":"5.7","asian":"11.4"}},"wageData":{"2016":{"workers":"18","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Childcare workers":{"ageData":{"2016":{"total":"1,280","16to19":"129","20to24":"230","25to34":"275","35to44":"189","45to54":"215","55to64":"178","65+":"63","medianAge":"178"}},"title":"Childcare workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2016":{"total":"1,280","women":"94.4","white":"17.1","black":"2.8","asian":"20.9"}},"wageData":{"2016":{"workers":"405","median":"452","maleWorkers":"24","maleMedian":"-","femaleWorkers":"381","femaleMedian":"451"}}},"Personal care aides":{"ageData":{"2016":{"total":"1,396","16to19":"33","20to24":"164","25to34":"255","35to44":"231","45to54":"294","55to64":"286","65+":"133","medianAge":"286"}},"title":"Personal care aides","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2016":{"total":"1,396","women":"84.9","white":"24.4","black":"10.2","asian":"20.6"}},"wageData":{"2016":{"workers":"762","median":"477","maleWorkers":"125","maleMedian":"514","femaleWorkers":"636","femaleMedian":"469"}}},"Recreation and fitness workers":{"ageData":{"2016":{"total":"440","16to19":"34","20to24":"67","25to34":"91","35to44":"90","45to54":"75","55to64":"56","65+":"27","medianAge":"56"}},"title":"Recreation and fitness workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2016":{"total":"440","women":"62.2","white":"10.0","black":"1.0","asian":"7.8"}},"wageData":{"2016":{"workers":"192","median":"596","maleWorkers":"92","maleMedian":"668","femaleWorkers":"100","femaleMedian":"517"}}},"Residential advisors":{"ageData":{"2016":{"total":"42","16to19":"5","20to24":"16","25to34":"9","35to44":"7","45to54":"2","55to64":"4","65+":"1","medianAge":"4"}},"title":"Residential advisors","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2016":{"total":"42","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"19","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Personal care and service workers, all other":{"ageData":{"2016":{"total":"142","16to19":"8","20to24":"29","25to34":"34","35to44":"25","45to54":"17","55to64":"15","65+":"14","medianAge":"15"}},"title":"Personal care and service workers, all other","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2016":{"total":"142","women":"56.5","white":"14.4","black":"4.4","asian":"12.6"}},"wageData":{"2016":{"workers":"61","median":"573","maleWorkers":"35","maleMedian":"-","femaleWorkers":"26","femaleMedian":"-"}}},"Sales and office occupations":{"ageData":{"2016":{"total":"33,539","16to19":"1,682","20to24":"4,052","25to34":"7,159","35to44":"5,907","45to54":"6,748","55to64":"5,754","65+":"2,237","medianAge":"5,754"}},"title":"Sales and office occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2016":{"total":"33,539","women":"61.2","white":"12.6","black":"5.2","asian":"15.6"}},"wageData":{"2016":{"workers":"23,625","median":"698","maleWorkers":"9,461","maleMedian":"805","femaleWorkers":"14,163","femaleMedian":"649"}}},"Sales and related occupations":{"ageData":{"2016":{"total":"15,848","16to19":"1,130","20to24":"2,079","25to34":"3,321","35to44":"2,793","45to54":"2,926","55to64":"2,434","65+":"1,165","medianAge":"2,434"}},"title":"Sales and related occupations","depth":2,"parent":"Sales and office occupations","sexRaceEthnicityData":{"2016":{"total":"15,848","women":"49.0","white":"11.0","black":"5.7","asian":"15.7"}},"wageData":{"2016":{"workers":"9,759","median":"744","maleWorkers":"5,509","maleMedian":"904","femaleWorkers":"4,250","femaleMedian":"590"}}},"First-line supervisors of retail sales workers":{"ageData":{"2016":{"total":"3,282","16to19":"33","20to24":"254","25to34":"815","35to44":"720","45to54":"723","55to64":"540","65+":"197","medianAge":"540"}},"title":"First-line supervisors of retail sales workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2016":{"total":"3,282","women":"44.1","white":"8.9","black":"6.1","asian":"14.7"}},"wageData":{"2016":{"workers":"2,368","median":"743","maleWorkers":"1,321","maleMedian":"857","femaleWorkers":"1,047","femaleMedian":"630"}}},"First-line supervisors of non-retail sales workers":{"ageData":{"2016":{"total":"1,180","16to19":"3","20to24":"40","25to34":"201","35to44":"251","45to54":"316","55to64":"280","65+":"89","medianAge":"280"}},"title":"First-line supervisors of non-retail sales workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2016":{"total":"1,180","women":"26.8","white":"6.8","black":"6.7","asian":"13.6"}},"wageData":{"2016":{"workers":"781","median":"1,137","maleWorkers":"552","maleMedian":"1,161","femaleWorkers":"230","femaleMedian":"1,004"}}},"Cashiers":{"ageData":{"2016":{"total":"3,260","16to19":"738","20to24":"799","25to34":"617","35to44":"335","45to54":"344","55to64":"281","65+":"146","medianAge":"281"}},"title":"Cashiers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2016":{"total":"3,260","women":"73.2","white":"17.8","black":"7.2","asian":"20.7"}},"wageData":{"2016":{"workers":"1,367","median":"414","maleWorkers":"402","maleMedian":"475","femaleWorkers":"965","femaleMedian":"403"}}},"Counter and rental clerks":{"ageData":{"2016":{"total":"105","16to19":"9","20to24":"13","25to34":"33","35to44":"16","45to54":"17","55to64":"10","65+":"7","medianAge":"10"}},"title":"Counter and rental clerks","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2016":{"total":"105","women":"46.6","white":"14.0","black":"3.2","asian":"22.6"}},"wageData":{"2016":{"workers":"84","median":"517","maleWorkers":"47","maleMedian":"-","femaleWorkers":"36","femaleMedian":"-"}}},"Parts salespersons":{"ageData":{"2016":{"total":"117","16to19":"7","20to24":"12","25to34":"31","35to44":"15","45to54":"24","55to64":"21","65+":"8","medianAge":"21"}},"title":"Parts salespersons","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2016":{"total":"117","women":"13.8","white":"7.5","black":"3.1","asian":"17.9"}},"wageData":{"2016":{"workers":"96","median":"639","maleWorkers":"85","maleMedian":"643","femaleWorkers":"11","femaleMedian":"-"}}},"Retail salespersons":{"ageData":{"2016":{"total":"3,312","16to19":"290","20to24":"675","25to34":"650","35to44":"485","45to54":"482","55to64":"461","65+":"269","medianAge":"461"}},"title":"Retail salespersons","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2016":{"total":"3,312","women":"48.4","white":"12.3","black":"5.3","asian":"18.2"}},"wageData":{"2016":{"workers":"1,831","median":"623","maleWorkers":"1,103","maleMedian":"730","femaleWorkers":"728","femaleMedian":"514"}}},"Advertising sales agents":{"ageData":{"2016":{"total":"222","16to19":"4","20to24":"21","25to34":"59","35to44":"44","45to54":"48","55to64":"34","65+":"12","medianAge":"34"}},"title":"Advertising sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2016":{"total":"222","women":"45.5","white":"12.0","black":"4.0","asian":"11.7"}},"wageData":{"2016":{"workers":"203","median":"1,023","maleWorkers":"122","maleMedian":"1,034","femaleWorkers":"81","femaleMedian":"999"}}},"Insurance sales agents":{"ageData":{"2016":{"total":"630","16to19":"5","20to24":"38","25to34":"135","35to44":"138","45to54":"140","55to64":"108","65+":"66","medianAge":"108"}},"title":"Insurance sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2016":{"total":"630","women":"46.5","white":"11.0","black":"4.6","asian":"11.7"}},"wageData":{"2016":{"workers":"423","median":"839","maleWorkers":"218","maleMedian":"1,166","femaleWorkers":"205","femaleMedian":"676"}}},"Securities, commodities, and financial services sales agents":{"ageData":{"2016":{"total":"263","16to19":"1","20to24":"15","25to34":"70","35to44":"66","45to54":"59","55to64":"36","65+":"15","medianAge":"36"}},"title":"Securities, commodities, and financial services sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2016":{"total":"263","women":"30.4","white":"7.1","black":"7.2","asian":"8.9"}},"wageData":{"2016":{"workers":"219","median":"1,351","maleWorkers":"155","maleMedian":"1,458","femaleWorkers":"63","femaleMedian":"951"}}},"Travel agents":{"ageData":{"2016":{"total":"83","16to19":"0","20to24":"6","25to34":"10","35to44":"15","45to54":"18","55to64":"21","65+":"13","medianAge":"21"}},"title":"Travel agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2016":{"total":"83","women":"84.7","white":"2.6","black":"10.3","asian":"11.3"}},"wageData":{"2016":{"workers":"46","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"38","femaleMedian":"-"}}},"Sales representatives, services, all other":{"ageData":{"2016":{"total":"512","16to19":"6","20to24":"45","25to34":"142","35to44":"122","45to54":"101","55to64":"65","65+":"31","medianAge":"65"}},"title":"Sales representatives, services, all other","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2016":{"total":"512","women":"31.8","white":"8.5","black":"3.9","asian":"11.3"}},"wageData":{"2016":{"workers":"427","median":"1,040","maleWorkers":"282","maleMedian":"1,202","femaleWorkers":"145","femaleMedian":"826"}}},"Sales representatives, wholesale and manufacturing":{"ageData":{"2016":{"total":"1,308","16to19":"11","20to24":"65","25to34":"300","35to44":"276","45to54":"320","55to64":"263","65+":"73","medianAge":"263"}},"title":"Sales representatives, wholesale and manufacturing","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2016":{"total":"1,308","women":"29.1","white":"4.8","black":"4.3","asian":"10.7"}},"wageData":{"2016":{"workers":"1,121","median":"1,047","maleWorkers":"819","maleMedian":"1,140","femaleWorkers":"302","femaleMedian":"872"}}},"Models, demonstrators, and product promoters":{"ageData":{"2016":{"total":"59","16to19":"4","20to24":"7","25to34":"15","35to44":"7","45to54":"4","55to64":"12","65+":"10","medianAge":"12"}},"title":"Models, demonstrators, and product promoters","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2016":{"total":"59","women":"67.4","white":"9.6","black":"3.0","asian":"9.3"}},"wageData":{"2016":{"workers":"14","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Real estate brokers and sales agents":{"ageData":{"2016":{"total":"977","16to19":"4","20to24":"30","25to34":"134","35to44":"198","45to54":"222","55to64":"209","65+":"179","medianAge":"209"}},"title":"Real estate brokers and sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2016":{"total":"977","women":"55.5","white":"6.9","black":"4.6","asian":"10.2"}},"wageData":{"2016":{"workers":"493","median":"983","maleWorkers":"209","maleMedian":"1,222","femaleWorkers":"284","femaleMedian":"780"}}},"Sales engineers":{"ageData":{"2016":{"total":"43","16to19":"0","20to24":"1","25to34":"7","35to44":"11","45to54":"14","55to64":"8","65+":"2","medianAge":"8"}},"title":"Sales engineers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2016":{"total":"43","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"40","median":"-","maleWorkers":"35","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Telemarketers":{"ageData":{"2016":{"total":"61","16to19":"3","20to24":"9","25to34":"20","35to44":"9","45to54":"11","55to64":"6","65+":"3","medianAge":"6"}},"title":"Telemarketers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2016":{"total":"61","women":"64.0","white":"34.9","black":"4.8","asian":"19.7"}},"wageData":{"2016":{"workers":"42","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"25","femaleMedian":"-"}}},"Door-to-door sales workers, news and street vendors, and related workers":{"ageData":{"2016":{"total":"160","16to19":"5","20to24":"16","25to34":"25","35to44":"36","45to54":"33","55to64":"26","65+":"19","medianAge":"26"}},"title":"Door-to-door sales workers, news and street vendors, and related workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2016":{"total":"160","women":"62.5","white":"9.1","black":"3.4","asian":"22.3"}},"wageData":{"2016":{"workers":"34","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Sales and related workers, all other":{"ageData":{"2016":{"total":"274","16to19":"8","20to24":"33","25to34":"58","35to44":"50","45to54":"49","55to64":"53","65+":"24","medianAge":"53"}},"title":"Sales and related workers, all other","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2016":{"total":"274","women":"47.2","white":"9.7","black":"3.2","asian":"12.1"}},"wageData":{"2016":{"workers":"171","median":"805","maleWorkers":"103","maleMedian":"946","femaleWorkers":"68","femaleMedian":"709"}}},"Office and administrative support occupations":{"ageData":{"2016":{"total":"17,691","16to19":"552","20to24":"1,973","25to34":"3,838","35to44":"3,114","45to54":"3,822","55to64":"3,321","65+":"1,071","medianAge":"3,321"}},"title":"Office and administrative support occupations","depth":2,"parent":"Sales and office occupations","sexRaceEthnicityData":{"2016":{"total":"17,691","women":"72.1","white":"14.1","black":"4.7","asian":"15.6"}},"wageData":{"2016":{"workers":"13,866","median":"679","maleWorkers":"3,952","maleMedian":"708","femaleWorkers":"9,913","femaleMedian":"669"}}},"First-line supervisors of office and administrative support workers":{"ageData":{"2016":{"total":"1,352","16to19":"2","20to24":"48","25to34":"285","35to44":"300","45to54":"370","55to64":"283","65+":"64","medianAge":"283"}},"title":"First-line supervisors of office and administrative support workers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"1,352","women":"68.5","white":"11.1","black":"4.6","asian":"13.6"}},"wageData":{"2016":{"workers":"1,203","median":"848","maleWorkers":"383","maleMedian":"942","femaleWorkers":"819","femaleMedian":"809"}}},"Switchboard operators, including answering service":{"ageData":{"2016":{"total":"25","16to19":"0","20to24":"5","25to34":"7","35to44":"5","45to54":"3","55to64":"1","65+":"4","medianAge":"1"}},"title":"Switchboard operators, including answering service","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"25","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"17","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"14","femaleMedian":"-"}}},"Telephone operators":{"ageData":{"2016":{"total":"41","16to19":"1","20to24":"9","25to34":"6","35to44":"4","45to54":"10","55to64":"8","65+":"3","medianAge":"8"}},"title":"Telephone operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"41","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"36","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"31","femaleMedian":"-"}}},"Communications equipment operators, all other":{"ageData":{"2016":{"total":"5","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Communications equipment operators, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"5","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Bill and account collectors":{"ageData":{"2016":{"total":"152","16to19":"1","20to24":"10","25to34":"43","35to44":"41","45to54":"30","55to64":"21","65+":"6","medianAge":"21"}},"title":"Bill and account collectors","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"152","women":"67.4","white":"25.1","black":"2.0","asian":"19.3"}},"wageData":{"2016":{"workers":"144","median":"625","maleWorkers":"39","maleMedian":"-","femaleWorkers":"105","femaleMedian":"650"}}},"Billing and posting clerks":{"ageData":{"2016":{"total":"452","16to19":"2","20to24":"23","25to34":"96","35to44":"93","45to54":"129","55to64":"95","65+":"14","medianAge":"95"}},"title":"Billing and posting clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"452","women":"89.0","white":"14.0","black":"4.6","asian":"15.8"}},"wageData":{"2016":{"workers":"404","median":"666","maleWorkers":"44","maleMedian":"-","femaleWorkers":"360","femaleMedian":"660"}}},"Bookkeeping, accounting, and auditing clerks":{"ageData":{"2016":{"total":"1,137","16to19":"4","20to24":"62","25to34":"173","35to44":"211","45to54":"279","55to64":"275","65+":"133","medianAge":"275"}},"title":"Bookkeeping, accounting, and auditing clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"1,137","women":"88.5","white":"7.7","black":"4.9","asian":"11.9"}},"wageData":{"2016":{"workers":"756","median":"722","maleWorkers":"115","maleMedian":"790","femaleWorkers":"641","femaleMedian":"716"}}},"Gaming cage workers":{"ageData":{"2016":{"total":"12","16to19":"1","20to24":"1","25to34":"5","35to44":"2","45to54":"2","55to64":"1","65+":"1","medianAge":"1"}},"title":"Gaming cage workers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"9","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Payroll and timekeeping clerks":{"ageData":{"2016":{"total":"129","16to19":"0","20to24":"3","25to34":"26","35to44":"31","45to54":"33","55to64":"29","65+":"7","medianAge":"29"}},"title":"Payroll and timekeeping clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"129","women":"90.7","white":"10.4","black":"8.1","asian":"13.2"}},"wageData":{"2016":{"workers":"125","median":"786","maleWorkers":"15","maleMedian":"-","femaleWorkers":"110","femaleMedian":"785"}}},"Procurement clerks":{"ageData":{"2016":{"total":"27","16to19":"0","20to24":"3","25to34":"3","35to44":"7","45to54":"5","55to64":"9","65+":"0","medianAge":"9"}},"title":"Procurement clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"27","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"25","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Tellers":{"ageData":{"2016":{"total":"342","16to19":"15","20to24":"91","25to34":"97","35to44":"43","45to54":"45","55to64":"41","65+":"10","medianAge":"41"}},"title":"Tellers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"342","women":"81.7","white":"12.5","black":"5.3","asian":"17.5"}},"wageData":{"2016":{"workers":"235","median":"542","maleWorkers":"39","maleMedian":"-","femaleWorkers":"195","femaleMedian":"539"}}},"Financial clerks, all other":{"ageData":{"2016":{"total":"69","16to19":"1","20to24":"5","25to34":"19","35to44":"15","45to54":"16","55to64":"11","65+":"2","medianAge":"11"}},"title":"Financial clerks, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"69","women":"63.9","white":"14.6","black":"9.1","asian":"14.2"}},"wageData":{"2016":{"workers":"62","median":"708","maleWorkers":"18","maleMedian":"-","femaleWorkers":"44","femaleMedian":"-"}}},"Brokerage clerks":{"ageData":{"2016":{"total":"3","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Brokerage clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"3","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Correspondence clerks":{"ageData":{"2016":{"total":"7","16to19":"0","20to24":"1","25to34":"1","35to44":"2","45to54":"0","55to64":"3","65+":"0","medianAge":"3"}},"title":"Correspondence clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"5","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Court, municipal, and license clerks":{"ageData":{"2016":{"total":"80","16to19":"0","20to24":"1","25to34":"14","35to44":"18","45to54":"24","55to64":"18","65+":"4","medianAge":"18"}},"title":"Court, municipal, and license clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"80","women":"71.1","white":"18.9","black":"2.4","asian":"19.6"}},"wageData":{"2016":{"workers":"79","median":"691","maleWorkers":"19","maleMedian":"-","femaleWorkers":"60","femaleMedian":"681"}}},"Credit authorizers, checkers, and clerks":{"ageData":{"2016":{"total":"44","16to19":"1","20to24":"5","25to34":"10","35to44":"11","45to54":"10","55to64":"6","65+":"1","medianAge":"6"}},"title":"Credit authorizers, checkers, and clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"44","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"41","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"33","femaleMedian":"-"}}},"Customer service representatives":{"ageData":{"2016":{"total":"2,388","16to19":"152","20to24":"367","25to34":"637","35to44":"406","45to54":"418","55to64":"299","65+":"108","medianAge":"299"}},"title":"Customer service representatives","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"2,388","women":"65.0","white":"16.9","black":"4.5","asian":"18.3"}},"wageData":{"2016":{"workers":"1,850","median":"640","maleWorkers":"664","maleMedian":"676","femaleWorkers":"1,185","femaleMedian":"623"}}},"Eligibility interviewers, government programs":{"ageData":{"2016":{"total":"77","16to19":"1","20to24":"1","25to34":"18","35to44":"16","45to54":"20","55to64":"17","65+":"2","medianAge":"17"}},"title":"Eligibility interviewers, government programs","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"77","women":"75.2","white":"27.6","black":"6.6","asian":"19.4"}},"wageData":{"2016":{"workers":"72","median":"828","maleWorkers":"17","maleMedian":"-","femaleWorkers":"55","femaleMedian":"735"}}},"File clerks":{"ageData":{"2016":{"total":"183","16to19":"13","20to24":"27","25to34":"43","35to44":"32","45to54":"23","55to64":"36","65+":"9","medianAge":"36"}},"title":"File clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"183","women":"82.7","white":"21.2","black":"5.7","asian":"11.6"}},"wageData":{"2016":{"workers":"134","median":"676","maleWorkers":"21","maleMedian":"-","femaleWorkers":"113","femaleMedian":"680"}}},"Hotel, motel, and resort desk clerks":{"ageData":{"2016":{"total":"138","16to19":"9","20to24":"30","25to34":"43","35to44":"21","45to54":"14","55to64":"14","65+":"6","medianAge":"14"}},"title":"Hotel, motel, and resort desk clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"138","women":"66.1","white":"17.2","black":"9.7","asian":"21.5"}},"wageData":{"2016":{"workers":"102","median":"513","maleWorkers":"36","maleMedian":"-","femaleWorkers":"66","femaleMedian":"500"}}},"Interviewers, except eligibility and loan":{"ageData":{"2016":{"total":"152","16to19":"2","20to24":"20","25to34":"31","35to44":"29","45to54":"33","55to64":"25","65+":"10","medianAge":"25"}},"title":"Interviewers, except eligibility and loan","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"152","women":"88.1","white":"20.7","black":"5.2","asian":"11.6"}},"wageData":{"2016":{"workers":"105","median":"639","maleWorkers":"7","maleMedian":"-","femaleWorkers":"98","femaleMedian":"634"}}},"Library assistants, clerical":{"ageData":{"2016":{"total":"87","16to19":"5","20to24":"12","25to34":"10","35to44":"16","45to54":"18","55to64":"19","65+":"8","medianAge":"19"}},"title":"Library assistants, clerical","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"87","women":"86.2","white":"12.5","black":"1.4","asian":"10.5"}},"wageData":{"2016":{"workers":"45","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"38","femaleMedian":"-"}}},"Loan interviewers and clerks":{"ageData":{"2016":{"total":"132","16to19":"0","20to24":"5","25to34":"37","35to44":"32","45to54":"28","55to64":"25","65+":"5","medianAge":"25"}},"title":"Loan interviewers and clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"132","women":"79.0","white":"10.8","black":"5.4","asian":"13.8"}},"wageData":{"2016":{"workers":"124","median":"774","maleWorkers":"25","maleMedian":"-","femaleWorkers":"100","femaleMedian":"756"}}},"New accounts clerks":{"ageData":{"2016":{"total":"24","16to19":"0","20to24":"3","25to34":"10","35to44":"6","45to54":"3","55to64":"2","65+":"0","medianAge":"2"}},"title":"New accounts clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"24","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"21","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"21","femaleMedian":"-"}}},"Order clerks":{"ageData":{"2016":{"total":"105","16to19":"5","20to24":"16","25to34":"23","35to44":"14","45to54":"25","55to64":"19","65+":"3","medianAge":"19"}},"title":"Order clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"105","women":"57.3","white":"8.1","black":"4.1","asian":"21.5"}},"wageData":{"2016":{"workers":"85","median":"646","maleWorkers":"40","maleMedian":"-","femaleWorkers":"45","femaleMedian":"-"}}},"Human resources assistants, except payroll and timekeeping":{"ageData":{"2016":{"total":"42","16to19":"0","20to24":"5","25to34":"10","35to44":"8","45to54":"11","55to64":"7","65+":"0","medianAge":"7"}},"title":"Human resources assistants, except payroll and timekeeping","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"42","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"36","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"32","femaleMedian":"-"}}},"Receptionists and information clerks":{"ageData":{"2016":{"total":"1,331","16to19":"64","20to24":"260","25to34":"316","35to44":"200","45to54":"191","55to64":"203","65+":"97","medianAge":"203"}},"title":"Receptionists and information clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"1,331","women":"90.1","white":"13.0","black":"3.7","asian":"18.4"}},"wageData":{"2016":{"workers":"951","median":"583","maleWorkers":"103","maleMedian":"600","femaleWorkers":"848","femaleMedian":"581"}}},"Reservation and transportation ticket agents and travel clerks":{"ageData":{"2016":{"total":"144","16to19":"3","20to24":"18","25to34":"36","35to44":"24","45to54":"36","55to64":"23","65+":"5","medianAge":"23"}},"title":"Reservation and transportation ticket agents and travel clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"144","women":"55.1","white":"24.8","black":"8.2","asian":"20.0"}},"wageData":{"2016":{"workers":"102","median":"705","maleWorkers":"46","maleMedian":"-","femaleWorkers":"56","femaleMedian":"646"}}},"Information and record clerks, all other":{"ageData":{"2016":{"total":"118","16to19":"1","20to24":"14","25to34":"23","35to44":"21","45to54":"28","55to64":"20","65+":"10","medianAge":"20"}},"title":"Information and record clerks, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"118","women":"71.9","white":"19.8","black":"3.6","asian":"7.9"}},"wageData":{"2016":{"workers":"104","median":"654","maleWorkers":"31","maleMedian":"-","femaleWorkers":"73","femaleMedian":"631"}}},"Cargo and freight agents":{"ageData":{"2016":{"total":"27","16to19":"0","20to24":"3","25to34":"4","35to44":"5","45to54":"10","55to64":"4","65+":"0","medianAge":"4"}},"title":"Cargo and freight agents","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"27","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"23","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Couriers and messengers":{"ageData":{"2016":{"total":"227","16to19":"6","20to24":"18","25to34":"40","35to44":"42","45to54":"55","55to64":"45","65+":"21","medianAge":"45"}},"title":"Couriers and messengers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"227","women":"18.4","white":"22.1","black":"6.0","asian":"19.3"}},"wageData":{"2016":{"workers":"160","median":"726","maleWorkers":"135","maleMedian":"739","femaleWorkers":"25","femaleMedian":"-"}}},"Dispatchers":{"ageData":{"2016":{"total":"292","16to19":"3","20to24":"26","25to34":"84","35to44":"67","45to54":"69","55to64":"37","65+":"7","medianAge":"37"}},"title":"Dispatchers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"292","women":"55.7","white":"12.8","black":"3.1","asian":"16.6"}},"wageData":{"2016":{"workers":"279","median":"704","maleWorkers":"126","maleMedian":"734","femaleWorkers":"153","femaleMedian":"671"}}},"Meter readers, utilities":{"ageData":{"2016":{"total":"31","16to19":"0","20to24":"3","25to34":"5","35to44":"4","45to54":"11","55to64":"7","65+":"2","medianAge":"7"}},"title":"Meter readers, utilities","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"31","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"30","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Postal service clerks":{"ageData":{"2016":{"total":"121","16to19":"0","20to24":"4","25to34":"14","35to44":"15","45to54":"35","55to64":"46","65+":"7","medianAge":"46"}},"title":"Postal service clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"121","women":"53.7","white":"23.9","black":"12.1","asian":"8.7"}},"wageData":{"2016":{"workers":"111","median":"901","maleWorkers":"58","maleMedian":"999","femaleWorkers":"53","femaleMedian":"805"}}},"Postal service mail carriers":{"ageData":{"2016":{"total":"320","16to19":"0","20to24":"13","25to34":"61","35to44":"52","45to54":"103","55to64":"78","65+":"13","medianAge":"78"}},"title":"Postal service mail carriers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"320","women":"38.9","white":"18.6","black":"8.3","asian":"12.3"}},"wageData":{"2016":{"workers":"304","median":"981","maleWorkers":"185","maleMedian":"1,020","femaleWorkers":"119","femaleMedian":"931"}}},"Postal service mail sorters, processors, and processing machine operators":{"ageData":{"2016":{"total":"60","16to19":"0","20to24":"5","25to34":"8","35to44":"10","45to54":"19","55to64":"14","65+":"3","medianAge":"14"}},"title":"Postal service mail sorters, processors, and processing machine operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"60","women":"42.4","white":"34.3","black":"7.5","asian":"9.7"}},"wageData":{"2016":{"workers":"56","median":"783","maleWorkers":"33","maleMedian":"-","femaleWorkers":"23","femaleMedian":"-"}}},"Production, planning, and expediting clerks":{"ageData":{"2016":{"total":"245","16to19":"3","20to24":"15","25to34":"64","35to44":"56","45to54":"68","55to64":"33","65+":"6","medianAge":"33"}},"title":"Production, planning, and expediting clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"245","women":"51.5","white":"8.6","black":"4.2","asian":"9.1"}},"wageData":{"2016":{"workers":"224","median":"853","maleWorkers":"113","maleMedian":"935","femaleWorkers":"111","femaleMedian":"765"}}},"Shipping, receiving, and traffic clerks":{"ageData":{"2016":{"total":"546","16to19":"24","20to24":"72","25to34":"141","35to44":"81","45to54":"111","55to64":"99","65+":"19","medianAge":"99"}},"title":"Shipping, receiving, and traffic clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"546","women":"33.9","white":"16.1","black":"2.2","asian":"21.7"}},"wageData":{"2016":{"workers":"473","median":"596","maleWorkers":"322","maleMedian":"602","femaleWorkers":"151","femaleMedian":"583"}}},"Stock clerks and order fillers":{"ageData":{"2016":{"total":"1,530","16to19":"135","20to24":"317","25to34":"344","35to44":"206","45to54":"238","55to64":"225","65+":"66","medianAge":"225"}},"title":"Stock clerks and order fillers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"1,530","women":"37.0","white":"18.8","black":"4.8","asian":"19.5"}},"wageData":{"2016":{"workers":"1,014","median":"530","maleWorkers":"643","maleMedian":"533","femaleWorkers":"371","femaleMedian":"526"}}},"Weighers, measurers, checkers, and samplers, recordkeeping":{"ageData":{"2016":{"total":"51","16to19":"0","20to24":"4","25to34":"10","35to44":"7","45to54":"15","55to64":"12","65+":"1","medianAge":"12"}},"title":"Weighers, measurers, checkers, and samplers, recordkeeping","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"51","women":"52.0","white":"17.8","black":"1.7","asian":"19.2"}},"wageData":{"2016":{"workers":"45","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"24","femaleMedian":"-"}}},"Secretaries and administrative assistants":{"ageData":{"2016":{"total":"2,744","16to19":"25","20to24":"143","25to34":"443","35to44":"496","45to54":"696","55to64":"695","65+":"246","medianAge":"695"}},"title":"Secretaries and administrative assistants","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"2,744","women":"94.6","white":"8.6","black":"3.2","asian":"11.8"}},"wageData":{"2016":{"workers":"2,210","median":"713","maleWorkers":"133","maleMedian":"831","femaleWorkers":"2,078","femaleMedian":"708"}}},"Computer operators":{"ageData":{"2016":{"total":"91","16to19":"1","20to24":"7","25to34":"18","35to44":"15","45to54":"28","55to64":"19","65+":"3","medianAge":"19"}},"title":"Computer operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"91","women":"50.8","white":"13.8","black":"4.1","asian":"14.3"}},"wageData":{"2016":{"workers":"78","median":"811","maleWorkers":"41","maleMedian":"-","femaleWorkers":"37","femaleMedian":"-"}}},"Data entry keyers":{"ageData":{"2016":{"total":"272","16to19":"9","20to24":"42","25to34":"71","35to44":"50","45to54":"50","55to64":"39","65+":"10","medianAge":"39"}},"title":"Data entry keyers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"272","women":"77.6","white":"13.4","black":"9.1","asian":"20.9"}},"wageData":{"2016":{"workers":"221","median":"638","maleWorkers":"51","maleMedian":"655","femaleWorkers":"170","femaleMedian":"630"}}},"Word processors and typists":{"ageData":{"2016":{"total":"82","16to19":"1","20to24":"7","25to34":"11","35to44":"19","45to54":"23","55to64":"17","65+":"5","medianAge":"17"}},"title":"Word processors and typists","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"82","women":"88.9","white":"14.3","black":"4.1","asian":"11.2"}},"wageData":{"2016":{"workers":"56","median":"730","maleWorkers":"7","maleMedian":"-","femaleWorkers":"48","femaleMedian":"-"}}},"Desktop publishers":{"ageData":{"2016":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Desktop publishers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"0","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Insurance claims and policy processing clerks":{"ageData":{"2016":{"total":"273","16to19":"2","20to24":"17","25to34":"84","35to44":"46","45to54":"55","55to64":"55","65+":"14","medianAge":"55"}},"title":"Insurance claims and policy processing clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"273","women":"85.2","white":"17.9","black":"6.7","asian":"11.4"}},"wageData":{"2016":{"workers":"251","median":"665","maleWorkers":"40","maleMedian":"-","femaleWorkers":"210","femaleMedian":"658"}}},"Mail clerks and mail machine operators, except postal service":{"ageData":{"2016":{"total":"77","16to19":"3","20to24":"9","25to34":"15","35to44":"14","45to54":"14","55to64":"18","65+":"5","medianAge":"18"}},"title":"Mail clerks and mail machine operators, except postal service","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"77","women":"43.5","white":"21.7","black":"1.0","asian":"21.2"}},"wageData":{"2016":{"workers":"56","median":"619","maleWorkers":"33","maleMedian":"-","femaleWorkers":"23","femaleMedian":"-"}}},"Office clerks, general":{"ageData":{"2016":{"total":"1,295","16to19":"48","20to24":"167","25to34":"258","35to44":"197","45to54":"271","55to64":"259","65+":"95","medianAge":"259"}},"title":"Office clerks, general","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"1,295","women":"82.8","white":"14.6","black":"6.9","asian":"16.9"}},"wageData":{"2016":{"workers":"900","median":"654","maleWorkers":"140","maleMedian":"707","femaleWorkers":"760","femaleMedian":"648"}}},"Office machine operators, except computer":{"ageData":{"2016":{"total":"35","16to19":"2","20to24":"9","25to34":"6","35to44":"4","45to54":"8","55to64":"5","65+":"1","medianAge":"5"}},"title":"Office machine operators, except computer","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"35","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"30","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Proofreaders and copy markers":{"ageData":{"2016":{"total":"12","16to19":"0","20to24":"2","25to34":"3","35to44":"2","45to54":"1","55to64":"3","65+":"2","medianAge":"3"}},"title":"Proofreaders and copy markers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"5","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Statistical assistants":{"ageData":{"2016":{"total":"9","16to19":"0","20to24":"0","25to34":"3","35to44":"0","45to54":"1","55to64":"3","65+":"1","medianAge":"3"}},"title":"Statistical assistants","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"7","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Office and administrative support workers, all other":{"ageData":{"2016":{"total":"551","16to19":"3","20to24":"45","25to34":"127","35to44":"115","45to54":"135","55to64":"97","65+":"29","medianAge":"97"}},"title":"Office and administrative support workers, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2016":{"total":"551","women":"75.8","white":"13.6","black":"4.3","asian":"11.6"}},"wageData":{"2016":{"workers":"457","median":"768","maleWorkers":"107","maleMedian":"855","femaleWorkers":"351","femaleMedian":"751"}}},"Natural resources, construction, and maintenance occupations":{"ageData":{"2016":{"total":"13,904","16to19":"317","20to24":"1,162","25to34":"3,245","35to44":"3,294","45to54":"3,194","55to64":"2,177","65+":"515","medianAge":"2,177"}},"title":"Natural resources, construction, and maintenance occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2016":{"total":"13,904","women":"4.7","white":"7.3","black":"2.2","asian":"29.6"}},"wageData":{"2016":{"workers":"11,022","median":"786","maleWorkers":"10,558","maleMedian":"794","femaleWorkers":"464","femaleMedian":"580"}}},"Farming, fishing, and forestry occupations":{"ageData":{"2016":{"total":"1,096","16to19":"77","20to24":"112","25to34":"257","35to44":"225","45to54":"229","55to64":"139","65+":"57","medianAge":"139"}},"title":"Farming, fishing, and forestry occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2016":{"total":"1,096","women":"22.3","white":"4.9","black":"1.8","asian":"45.0"}},"wageData":{"2016":{"workers":"842","median":"520","maleWorkers":"673","maleMedian":"544","femaleWorkers":"169","femaleMedian":"465"}}},"First-line supervisors of farming, fishing, and forestry workers":{"ageData":{"2016":{"total":"48","16to19":"0","20to24":"2","25to34":"6","35to44":"16","45to54":"14","55to64":"6","65+":"4","medianAge":"6"}},"title":"First-line supervisors of farming, fishing, and forestry workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2016":{"total":"48","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"28","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Agricultural inspectors":{"ageData":{"2016":{"total":"19","16to19":"0","20to24":"0","25to34":"1","35to44":"3","45to54":"8","55to64":"4","65+":"3","medianAge":"4"}},"title":"Agricultural inspectors","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2016":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"18","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Animal breeders":{"ageData":{"2016":{"total":"7","16to19":"0","20to24":"2","25to34":"2","35to44":"3","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Animal breeders","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2016":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Graders and sorters, agricultural products":{"ageData":{"2016":{"total":"85","16to19":"2","20to24":"7","25to34":"23","35to44":"17","45to54":"18","55to64":"17","65+":"3","medianAge":"17"}},"title":"Graders and sorters, agricultural products","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2016":{"total":"85","women":"65.5","white":"20.4","black":"6.3","asian":"40.7"}},"wageData":{"2016":{"workers":"74","median":"511","maleWorkers":"25","maleMedian":"-","femaleWorkers":"48","femaleMedian":"-"}}},"Miscellaneous agricultural workers":{"ageData":{"2016":{"total":"818","16to19":"73","20to24":"92","25to34":"202","35to44":"167","45to54":"159","55to64":"87","65+":"39","medianAge":"87"}},"title":"Miscellaneous agricultural workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2016":{"total":"818","women":"21.0","white":"2.7","black":"1.3","asian":"52.5"}},"wageData":{"2016":{"workers":"659","median":"508","maleWorkers":"547","maleMedian":"524","femaleWorkers":"111","femaleMedian":"423"}}},"Fishers and related fishing workers":{"ageData":{"2016":{"total":"29","16to19":"2","20to24":"1","25to34":"8","35to44":"5","45to54":"5","55to64":"8","65+":"0","medianAge":"8"}},"title":"Fishers and related fishing workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2016":{"total":"29","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Hunters and trappers":{"ageData":{"2016":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Hunters and trappers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2016":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Forest and conservation workers":{"ageData":{"2016":{"total":"21","16to19":"0","20to24":"3","25to34":"4","35to44":"2","45to54":"5","55to64":"5","65+":"2","medianAge":"5"}},"title":"Forest and conservation workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2016":{"total":"21","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"17","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Logging workers":{"ageData":{"2016":{"total":"68","16to19":"1","20to24":"6","25to34":"12","35to44":"11","45to54":"19","55to64":"13","65+":"6","medianAge":"13"}},"title":"Logging workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2016":{"total":"68","women":"0.9","white":"11.2","black":"0.0","asian":"5.1"}},"wageData":{"2016":{"workers":"39","median":"-","maleWorkers":"39","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Construction and extraction occupations":{"ageData":{"2016":{"total":"7,929","16to19":"151","20to24":"665","25to34":"1,889","35to44":"1,984","45to54":"1,773","55to64":"1,201","65+":"266","medianAge":"1,201"}},"title":"Construction and extraction occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2016":{"total":"7,929","women":"3.0","white":"6.8","black":"1.7","asian":"34.0"}},"wageData":{"2016":{"workers":"5,979","median":"784","maleWorkers":"5,828","maleMedian":"786","femaleWorkers":"151","femaleMedian":"639"}}},"First-line supervisors of construction trades and extraction workers":{"ageData":{"2016":{"total":"680","16to19":"1","20to24":"20","25to34":"135","35to44":"186","45to54":"184","55to64":"129","65+":"23","medianAge":"129"}},"title":"First-line supervisors of construction trades and extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"680","women":"2.6","white":"5.5","black":"1.5","asian":"22.5"}},"wageData":{"2016":{"workers":"558","median":"1,091","maleWorkers":"540","maleMedian":"1,101","femaleWorkers":"18","femaleMedian":"-"}}},"Boilermakers":{"ageData":{"2016":{"total":"23","16to19":"0","20to24":"1","25to34":"3","35to44":"8","45to54":"7","55to64":"2","65+":"0","medianAge":"2"}},"title":"Boilermakers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"23","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"26","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Brickmasons, blockmasons, and stonemasons":{"ageData":{"2016":{"total":"160","16to19":"2","20to24":"12","25to34":"39","35to44":"47","45to54":"38","55to64":"18","65+":"3","medianAge":"18"}},"title":"Brickmasons, blockmasons, and stonemasons","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"160","women":"0.5","white":"6.4","black":"0.5","asian":"45.5"}},"wageData":{"2016":{"workers":"119","median":"741","maleWorkers":"119","maleMedian":"741","femaleWorkers":"0","femaleMedian":"-"}}},"Carpenters":{"ageData":{"2016":{"total":"1,359","16to19":"20","20to24":"94","25to34":"312","35to44":"359","45to54":"313","55to64":"211","65+":"51","medianAge":"211"}},"title":"Carpenters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"1,359","women":"2.1","white":"5.4","black":"1.2","asian":"33.9"}},"wageData":{"2016":{"workers":"839","median":"730","maleWorkers":"828","maleMedian":"733","femaleWorkers":"11","femaleMedian":"-"}}},"Carpet, floor, and tile installers and finishers":{"ageData":{"2016":{"total":"168","16to19":"2","20to24":"14","25to34":"50","35to44":"45","45to54":"37","55to64":"14","65+":"5","medianAge":"14"}},"title":"Carpet, floor, and tile installers and finishers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"168","women":"1.9","white":"3.5","black":"0.9","asian":"50.8"}},"wageData":{"2016":{"workers":"93","median":"593","maleWorkers":"91","maleMedian":"597","femaleWorkers":"2","femaleMedian":"-"}}},"Cement masons, concrete finishers, and terrazzo workers":{"ageData":{"2016":{"total":"56","16to19":"0","20to24":"8","25to34":"9","35to44":"14","45to54":"15","55to64":"8","65+":"2","medianAge":"8"}},"title":"Cement masons, concrete finishers, and terrazzo workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"56","women":"2.2","white":"10.5","black":"1.6","asian":"48.8"}},"wageData":{"2016":{"workers":"47","median":"-","maleWorkers":"47","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Construction laborers":{"ageData":{"2016":{"total":"1,801","16to19":"57","20to24":"200","25to34":"492","35to44":"419","45to54":"366","55to64":"220","65+":"48","medianAge":"220"}},"title":"Construction laborers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"1,801","women":"3.5","white":"8.1","black":"2.2","asian":"45.5"}},"wageData":{"2016":{"workers":"1,322","median":"692","maleWorkers":"1,281","maleMedian":"697","femaleWorkers":"41","femaleMedian":"-"}}},"Paving, surfacing, and tamping equipment operators":{"ageData":{"2016":{"total":"13","16to19":"0","20to24":"1","25to34":"1","35to44":"5","45to54":"2","55to64":"2","65+":"1","medianAge":"2"}},"title":"Paving, surfacing, and tamping equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"11","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Pile-driver operators":{"ageData":{"2016":{"total":"2","16to19":"0","20to24":"0","25to34":"2","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Pile-driver operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Operating engineers and other construction equipment operators":{"ageData":{"2016":{"total":"351","16to19":"6","20to24":"26","25to34":"62","35to44":"83","45to54":"85","55to64":"71","65+":"18","medianAge":"71"}},"title":"Operating engineers and other construction equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"351","women":"2.3","white":"8.7","black":"0.2","asian":"19.3"}},"wageData":{"2016":{"workers":"334","median":"920","maleWorkers":"328","maleMedian":"922","femaleWorkers":"6","femaleMedian":"-"}}},"Drywall installers, ceiling tile installers, and tapers":{"ageData":{"2016":{"total":"180","16to19":"4","20to24":"16","25to34":"37","35to44":"61","45to54":"30","55to64":"25","65+":"7","medianAge":"25"}},"title":"Drywall installers, ceiling tile installers, and tapers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"180","women":"1.1","white":"6.7","black":"0.5","asian":"62.7"}},"wageData":{"2016":{"workers":"138","median":"600","maleWorkers":"137","maleMedian":"601","femaleWorkers":"1","femaleMedian":"-"}}},"Electricians":{"ageData":{"2016":{"total":"774","16to19":"15","20to24":"62","25to34":"179","35to44":"189","45to54":"172","55to64":"133","65+":"23","medianAge":"133"}},"title":"Electricians","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"774","women":"3.0","white":"5.9","black":"3.1","asian":"16.8"}},"wageData":{"2016":{"workers":"667","median":"952","maleWorkers":"649","maleMedian":"951","femaleWorkers":"18","femaleMedian":"-"}}},"Glaziers":{"ageData":{"2016":{"total":"54","16to19":"0","20to24":"7","25to34":"11","35to44":"13","45to54":"10","55to64":"13","65+":"1","medianAge":"13"}},"title":"Glaziers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"54","women":"1.4","white":"5.0","black":"0.0","asian":"21.2"}},"wageData":{"2016":{"workers":"48","median":"-","maleWorkers":"47","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Insulation workers":{"ageData":{"2016":{"total":"50","16to19":"1","20to24":"4","25to34":"18","35to44":"9","45to54":"13","55to64":"5","65+":"0","medianAge":"5"}},"title":"Insulation workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"50","women":"5.2","white":"7.7","black":"0.5","asian":"33.8"}},"wageData":{"2016":{"workers":"42","median":"-","maleWorkers":"40","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Painters, construction and maintenance":{"ageData":{"2016":{"total":"612","16to19":"10","20to24":"53","25to34":"142","35to44":"157","45to54":"140","55to64":"94","65+":"16","medianAge":"94"}},"title":"Painters, construction and maintenance","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"612","women":"6.2","white":"5.7","black":"3.6","asian":"50.7"}},"wageData":{"2016":{"workers":"392","median":"612","maleWorkers":"375","maleMedian":"615","femaleWorkers":"17","femaleMedian":"-"}}},"Paperhangers":{"ageData":{"2016":{"total":"4","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"3","65+":"0","medianAge":"3"}},"title":"Paperhangers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Pipelayers, plumbers, pipefitters, and steamfitters":{"ageData":{"2016":{"total":"583","16to19":"5","20to24":"43","25to34":"141","35to44":"121","45to54":"145","55to64":"100","65+":"29","medianAge":"100"}},"title":"Pipelayers, plumbers, pipefitters, and steamfitters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"583","women":"1.4","white":"7.5","black":"0.9","asian":"21.2"}},"wageData":{"2016":{"workers":"475","median":"927","maleWorkers":"464","maleMedian":"925","femaleWorkers":"11","femaleMedian":"-"}}},"Plasterers and stucco masons":{"ageData":{"2016":{"total":"34","16to19":"1","20to24":"2","25to34":"7","35to44":"9","45to54":"8","55to64":"4","65+":"2","medianAge":"4"}},"title":"Plasterers and stucco masons","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"34","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"25","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Reinforcing iron and rebar workers":{"ageData":{"2016":{"total":"12","16to19":"1","20to24":"2","25to34":"3","35to44":"2","45to54":"3","55to64":"1","65+":"0","medianAge":"1"}},"title":"Reinforcing iron and rebar workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"12","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Roofers":{"ageData":{"2016":{"total":"230","16to19":"8","20to24":"31","25to34":"59","35to44":"64","45to54":"47","55to64":"18","65+":"3","medianAge":"18"}},"title":"Roofers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"230","women":"1.7","white":"4.9","black":"1.1","asian":"51.7"}},"wageData":{"2016":{"workers":"161","median":"623","maleWorkers":"158","maleMedian":"624","femaleWorkers":"3","femaleMedian":"-"}}},"Sheet metal workers":{"ageData":{"2016":{"total":"126","16to19":"1","20to24":"8","25to34":"33","35to44":"36","45to54":"18","55to64":"26","65+":"3","medianAge":"26"}},"title":"Sheet metal workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"126","women":"2.9","white":"6.7","black":"2.1","asian":"16.7"}},"wageData":{"2016":{"workers":"117","median":"819","maleWorkers":"115","maleMedian":"820","femaleWorkers":"3","femaleMedian":"-"}}},"Structural iron and steel workers":{"ageData":{"2016":{"total":"60","16to19":"0","20to24":"4","25to34":"14","35to44":"14","45to54":"20","55to64":"7","65+":"0","medianAge":"7"}},"title":"Structural iron and steel workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"60","women":"2.0","white":"10.7","black":"1.9","asian":"10.8"}},"wageData":{"2016":{"workers":"61","median":"976","maleWorkers":"60","maleMedian":"983","femaleWorkers":"1","femaleMedian":"-"}}},"Solar photovoltaic installers":{"ageData":{"2016":{"total":"10","16to19":"0","20to24":"2","25to34":"2","35to44":"4","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Solar photovoltaic installers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"10","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers, construction trades":{"ageData":{"2016":{"total":"57","16to19":"8","20to24":"19","25to34":"13","35to44":"8","45to54":"4","55to64":"4","65+":"0","medianAge":"4"}},"title":"Helpers, construction trades","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"57","women":"6.2","white":"9.2","black":"0.9","asian":"42.5"}},"wageData":{"2016":{"workers":"42","median":"-","maleWorkers":"40","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Construction and building inspectors":{"ageData":{"2016":{"total":"93","16to19":"0","20to24":"4","25to34":"10","35to44":"20","45to54":"24","55to64":"25","65+":"9","medianAge":"25"}},"title":"Construction and building inspectors","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"93","women":"6.4","white":"11.8","black":"2.4","asian":"9.9"}},"wageData":{"2016":{"workers":"68","median":"996","maleWorkers":"62","maleMedian":"1,040","femaleWorkers":"6","femaleMedian":"-"}}},"Elevator installers and repairers":{"ageData":{"2016":{"total":"44","16to19":"0","20to24":"2","25to34":"12","35to44":"14","45to54":"7","55to64":"8","65+":"2","medianAge":"8"}},"title":"Elevator installers and repairers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"44","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"41","median":"-","maleWorkers":"41","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Fence erectors":{"ageData":{"2016":{"total":"43","16to19":"3","20to24":"8","25to34":"8","35to44":"12","45to54":"9","55to64":"3","65+":"1","medianAge":"3"}},"title":"Fence erectors","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"43","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"30","median":"-","maleWorkers":"29","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Hazardous materials removal workers":{"ageData":{"2016":{"total":"34","16to19":"1","20to24":"2","25to34":"8","35to44":"11","45to54":"6","55to64":"4","65+":"2","medianAge":"4"}},"title":"Hazardous materials removal workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"34","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"28","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Highway maintenance workers":{"ageData":{"2016":{"total":"92","16to19":"2","20to24":"4","25to34":"14","35to44":"17","45to54":"31","55to64":"21","65+":"4","medianAge":"21"}},"title":"Highway maintenance workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"92","women":"3.2","white":"9.6","black":"0.2","asian":"15.1"}},"wageData":{"2016":{"workers":"85","median":"745","maleWorkers":"83","maleMedian":"723","femaleWorkers":"2","femaleMedian":"-"}}},"Rail-track laying and maintenance equipment operators":{"ageData":{"2016":{"total":"10","16to19":"0","20to24":"0","25to34":"3","35to44":"6","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Rail-track laying and maintenance equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"8","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Septic tank servicers and sewer pipe cleaners":{"ageData":{"2016":{"total":"10","16to19":"0","20to24":"1","25to34":"2","35to44":"1","45to54":"1","55to64":"4","65+":"0","medianAge":"4"}},"title":"Septic tank servicers and sewer pipe cleaners","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"9","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Miscellaneous construction and related workers":{"ageData":{"2016":{"total":"34","16to19":"0","20to24":"2","25to34":"8","35to44":"9","45to54":"5","55to64":"6","65+":"3","medianAge":"6"}},"title":"Miscellaneous construction and related workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"34","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"17","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Derrick, rotary drill, and service unit operators, oil, gas, and mining":{"ageData":{"2016":{"total":"25","16to19":"0","20to24":"2","25to34":"10","35to44":"5","45to54":"4","55to64":"3","65+":"0","medianAge":"3"}},"title":"Derrick, rotary drill, and service unit operators, oil, gas, and mining","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"25","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"29","median":"-","maleWorkers":"29","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Earth drillers, except oil and gas":{"ageData":{"2016":{"total":"33","16to19":"0","20to24":"3","25to34":"7","35to44":"9","45to54":"8","55to64":"5","65+":"1","medianAge":"5"}},"title":"Earth drillers, except oil and gas","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"23","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Explosives workers, ordnance handling experts, and blasters":{"ageData":{"2016":{"total":"11","16to19":"0","20to24":"0","25to34":"4","35to44":"2","45to54":"2","55to64":"1","65+":"2","medianAge":"1"}},"title":"Explosives workers, ordnance handling experts, and blasters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"10","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Mining machine operators":{"ageData":{"2016":{"total":"55","16to19":"0","20to24":"3","25to34":"17","35to44":"16","45to54":"7","55to64":"10","65+":"3","medianAge":"10"}},"title":"Mining machine operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"55","women":"1.5","white":"7.1","black":"0.0","asian":"11.6"}},"wageData":{"2016":{"workers":"48","median":"-","maleWorkers":"48","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Roof bolters, mining":{"ageData":{"2016":{"total":"4","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Roof bolters, mining","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Roustabouts, oil and gas":{"ageData":{"2016":{"total":"6","16to19":"0","20to24":"1","25to34":"5","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Roustabouts, oil and gas","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers--extraction workers":{"ageData":{"2016":{"total":"4","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Helpers--extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Other extraction workers":{"ageData":{"2016":{"total":"32","16to19":"1","20to24":"4","25to34":"9","35to44":"6","45to54":"8","55to64":"3","65+":"2","medianAge":"3"}},"title":"Other extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2016":{"total":"32","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"29","median":"-","maleWorkers":"29","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Installation, maintenance, and repair occupations":{"ageData":{"2016":{"total":"4,879","16to19":"89","20to24":"385","25to34":"1,099","35to44":"1,085","45to54":"1,192","55to64":"837","65+":"193","medianAge":"837"}},"title":"Installation, maintenance, and repair occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2016":{"total":"4,879","women":"3.6","white":"8.8","black":"3.2","asian":"19.0"}},"wageData":{"2016":{"workers":"4,201","median":"861","maleWorkers":"4,057","maleMedian":"863","femaleWorkers":"144","femaleMedian":"783"}}},"First-line supervisors of mechanics, installers, and repairers":{"ageData":{"2016":{"total":"264","16to19":"0","20to24":"4","25to34":"37","35to44":"57","45to54":"96","55to64":"60","65+":"10","medianAge":"60"}},"title":"First-line supervisors of mechanics, installers, and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"264","women":"10.1","white":"10.2","black":"2.0","asian":"10.4"}},"wageData":{"2016":{"workers":"246","median":"1,020","maleWorkers":"221","maleMedian":"1,016","femaleWorkers":"25","femaleMedian":"-"}}},"Computer, automated teller, and office machine repairers":{"ageData":{"2016":{"total":"212","16to19":"5","20to24":"22","25to34":"59","35to44":"45","45to54":"36","55to64":"35","65+":"9","medianAge":"35"}},"title":"Computer, automated teller, and office machine repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"212","women":"9.6","white":"13.0","black":"10.0","asian":"12.0"}},"wageData":{"2016":{"workers":"165","median":"851","maleWorkers":"150","maleMedian":"861","femaleWorkers":"15","femaleMedian":"-"}}},"Radio and telecommunications equipment installers and repairers":{"ageData":{"2016":{"total":"143","16to19":"0","20to24":"8","25to34":"31","35to44":"44","45to54":"31","55to64":"23","65+":"5","medianAge":"23"}},"title":"Radio and telecommunications equipment installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"143","women":"16.1","white":"16.3","black":"5.3","asian":"15.8"}},"wageData":{"2016":{"workers":"132","median":"950","maleWorkers":"110","maleMedian":"975","femaleWorkers":"22","femaleMedian":"-"}}},"Avionics technicians":{"ageData":{"2016":{"total":"7","16to19":"0","20to24":"0","25to34":"1","35to44":"4","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Avionics technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"8","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electric motor, power tool, and related repairers":{"ageData":{"2016":{"total":"25","16to19":"0","20to24":"0","25to34":"10","35to44":"4","45to54":"6","55to64":"4","65+":"1","medianAge":"4"}},"title":"Electric motor, power tool, and related repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"25","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"26","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Electrical and electronics installers and repairers, transportation equipment":{"ageData":{"2016":{"total":"2","16to19":"0","20to24":"2","25to34":"0","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Electrical and electronics installers and repairers, transportation equipment","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electrical and electronics repairers, industrial and utility":{"ageData":{"2016":{"total":"13","16to19":"0","20to24":"1","25to34":"4","35to44":"4","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Electrical and electronics repairers, industrial and utility","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"15","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Electronic equipment installers and repairers, motor vehicles":{"ageData":{"2016":{"total":"10","16to19":"0","20to24":"1","25to34":"3","35to44":"3","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Electronic equipment installers and repairers, motor vehicles","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"8","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electronic home entertainment equipment installers and repairers":{"ageData":{"2016":{"total":"44","16to19":"2","20to24":"6","25to34":"13","35to44":"8","45to54":"8","55to64":"4","65+":"4","medianAge":"4"}},"title":"Electronic home entertainment equipment installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"44","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"33","median":"-","maleWorkers":"32","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Security and fire alarm systems installers":{"ageData":{"2016":{"total":"79","16to19":"0","20to24":"12","25to34":"11","35to44":"24","45to54":"17","55to64":"12","65+":"2","medianAge":"12"}},"title":"Security and fire alarm systems installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"79","women":"1.8","white":"5.6","black":"4.2","asian":"24.2"}},"wageData":{"2016":{"workers":"69","median":"927","maleWorkers":"68","maleMedian":"909","femaleWorkers":"1","femaleMedian":"-"}}},"Aircraft mechanics and service technicians":{"ageData":{"2016":{"total":"140","16to19":"1","20to24":"6","25to34":"28","35to44":"25","45to54":"42","55to64":"37","65+":"2","medianAge":"37"}},"title":"Aircraft mechanics and service technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"140","women":"1.7","white":"3.3","black":"6.0","asian":"18.5"}},"wageData":{"2016":{"workers":"136","median":"1,047","maleWorkers":"134","maleMedian":"1,053","femaleWorkers":"2","femaleMedian":"-"}}},"Automotive body and related repairers":{"ageData":{"2016":{"total":"147","16to19":"4","20to24":"13","25to34":"33","35to44":"36","45to54":"31","55to64":"21","65+":"9","medianAge":"21"}},"title":"Automotive body and related repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"147","women":"3.6","white":"5.2","black":"3.0","asian":"24.1"}},"wageData":{"2016":{"workers":"117","median":"761","maleWorkers":"112","maleMedian":"770","femaleWorkers":"5","femaleMedian":"-"}}},"Automotive glass installers and repairers":{"ageData":{"2016":{"total":"22","16to19":"1","20to24":"1","25to34":"2","35to44":"9","45to54":"5","55to64":"1","65+":"3","medianAge":"1"}},"title":"Automotive glass installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"22","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"14","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Automotive service technicians and mechanics":{"ageData":{"2016":{"total":"879","16to19":"21","20to24":"102","25to34":"226","35to44":"189","45to54":"197","55to64":"118","65+":"26","medianAge":"118"}},"title":"Automotive service technicians and mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"879","women":"1.7","white":"9.6","black":"4.3","asian":"23.3"}},"wageData":{"2016":{"workers":"688","median":"730","maleWorkers":"677","maleMedian":"729","femaleWorkers":"11","femaleMedian":"-"}}},"Bus and truck mechanics and diesel engine specialists":{"ageData":{"2016":{"total":"342","16to19":"7","20to24":"32","25to34":"77","35to44":"74","45to54":"85","55to64":"55","65+":"12","medianAge":"55"}},"title":"Bus and truck mechanics and diesel engine specialists","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"342","women":"0.8","white":"7.0","black":"1.9","asian":"16.1"}},"wageData":{"2016":{"workers":"298","median":"874","maleWorkers":"297","maleMedian":"875","femaleWorkers":"1","femaleMedian":"-"}}},"Heavy vehicle and mobile equipment service technicians and mechanics":{"ageData":{"2016":{"total":"203","16to19":"1","20to24":"15","25to34":"42","35to44":"51","45to54":"45","55to64":"41","65+":"8","medianAge":"41"}},"title":"Heavy vehicle and mobile equipment service technicians and mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"203","women":"0.5","white":"3.8","black":"1.9","asian":"16.9"}},"wageData":{"2016":{"workers":"198","median":"964","maleWorkers":"198","maleMedian":"964","femaleWorkers":"0","femaleMedian":"-"}}},"Small engine mechanics":{"ageData":{"2016":{"total":"51","16to19":"3","20to24":"3","25to34":"15","35to44":"9","45to54":"10","55to64":"7","65+":"3","medianAge":"7"}},"title":"Small engine mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"51","women":"3.5","white":"11.0","black":"0.0","asian":"6.6"}},"wageData":{"2016":{"workers":"32","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Miscellaneous vehicle and mobile equipment mechanics, installers, and repairers":{"ageData":{"2016":{"total":"87","16to19":"5","20to24":"15","25to34":"33","35to44":"19","45to54":"8","55to64":"5","65+":"2","medianAge":"5"}},"title":"Miscellaneous vehicle and mobile equipment mechanics, installers, and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"87","women":"1.7","white":"10.8","black":"2.0","asian":"31.6"}},"wageData":{"2016":{"workers":"74","median":"641","maleWorkers":"73","maleMedian":"646","femaleWorkers":"0","femaleMedian":"-"}}},"Control and valve installers and repairers":{"ageData":{"2016":{"total":"33","16to19":"0","20to24":"3","25to34":"6","35to44":"8","45to54":"10","55to64":"5","65+":"1","medianAge":"5"}},"title":"Control and valve installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"33","median":"-","maleWorkers":"32","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Heating, air conditioning, and refrigeration mechanics and installers":{"ageData":{"2016":{"total":"427","16to19":"8","20to24":"36","25to34":"115","35to44":"84","45to54":"105","55to64":"62","65+":"16","medianAge":"62"}},"title":"Heating, air conditioning, and refrigeration mechanics and installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"427","women":"1.4","white":"7.0","black":"1.3","asian":"21.9"}},"wageData":{"2016":{"workers":"361","median":"864","maleWorkers":"357","maleMedian":"868","femaleWorkers":"4","femaleMedian":"-"}}},"Home appliance repairers":{"ageData":{"2016":{"total":"49","16to19":"0","20to24":"3","25to34":"9","35to44":"9","45to54":"10","55to64":"12","65+":"6","medianAge":"12"}},"title":"Home appliance repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"49","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"25","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Industrial and refractory machinery mechanics":{"ageData":{"2016":{"total":"393","16to19":"4","20to24":"14","25to34":"66","35to44":"90","45to54":"126","55to64":"79","65+":"15","medianAge":"79"}},"title":"Industrial and refractory machinery mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"393","women":"3.3","white":"8.5","black":"1.9","asian":"15.0"}},"wageData":{"2016":{"workers":"385","median":"968","maleWorkers":"374","maleMedian":"973","femaleWorkers":"11","femaleMedian":"-"}}},"Maintenance and repair workers, general":{"ageData":{"2016":{"total":"552","16to19":"9","20to24":"31","25to34":"109","35to44":"102","45to54":"149","55to64":"121","65+":"31","medianAge":"121"}},"title":"Maintenance and repair workers, general","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"552","women":"3.0","white":"10.6","black":"2.2","asian":"19.8"}},"wageData":{"2016":{"workers":"514","median":"796","maleWorkers":"502","maleMedian":"797","femaleWorkers":"13","femaleMedian":"-"}}},"Maintenance workers, machinery":{"ageData":{"2016":{"total":"21","16to19":"2","20to24":"2","25to34":"2","35to44":"2","45to54":"4","55to64":"7","65+":"1","medianAge":"7"}},"title":"Maintenance workers, machinery","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"21","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"20","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Millwrights":{"ageData":{"2016":{"total":"40","16to19":"1","20to24":"0","25to34":"8","35to44":"9","45to54":"9","55to64":"9","65+":"2","medianAge":"9"}},"title":"Millwrights","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"35","median":"-","maleWorkers":"35","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electrical power-line installers and repairers":{"ageData":{"2016":{"total":"136","16to19":"0","20to24":"8","25to34":"28","35to44":"40","45to54":"31","55to64":"23","65+":"5","medianAge":"23"}},"title":"Electrical power-line installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"136","women":"0.6","white":"7.7","black":"0.9","asian":"10.5"}},"wageData":{"2016":{"workers":"126","median":"1,161","maleWorkers":"125","maleMedian":"1,165","femaleWorkers":"1","femaleMedian":"-"}}},"Telecommunications line installers and repairers":{"ageData":{"2016":{"total":"171","16to19":"6","20to24":"13","25to34":"39","35to44":"53","45to54":"43","55to64":"15","65+":"2","medianAge":"15"}},"title":"Telecommunications line installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"171","women":"2.5","white":"16.1","black":"5.2","asian":"20.9"}},"wageData":{"2016":{"workers":"172","median":"850","maleWorkers":"168","maleMedian":"824","femaleWorkers":"4","femaleMedian":"-"}}},"Precision instrument and equipment repairers":{"ageData":{"2016":{"total":"66","16to19":"1","20to24":"2","25to34":"9","35to44":"18","45to54":"14","55to64":"19","65+":"4","medianAge":"19"}},"title":"Precision instrument and equipment repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"66","women":"14.9","white":"4.5","black":"3.9","asian":"13.9"}},"wageData":{"2016":{"workers":"56","median":"910","maleWorkers":"46","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Wind turbine service technicians":{"ageData":{"2016":{"total":"5","16to19":"0","20to24":"1","25to34":"1","35to44":"2","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Wind turbine service technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Coin, vending, and amusement machine servicers and repairers":{"ageData":{"2016":{"total":"38","16to19":"1","20to24":"4","25to34":"10","35to44":"7","45to54":"10","55to64":"5","65+":"2","medianAge":"5"}},"title":"Coin, vending, and amusement machine servicers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"38","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"27","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Commercial divers":{"ageData":{"2016":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Commercial divers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Locksmiths and safe repairers":{"ageData":{"2016":{"total":"30","16to19":"1","20to24":"3","25to34":"7","35to44":"6","45to54":"6","55to64":"5","65+":"3","medianAge":"5"}},"title":"Locksmiths and safe repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"30","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"12","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Manufactured building and mobile home installers":{"ageData":{"2016":{"total":"10","16to19":"0","20to24":"1","25to34":"1","35to44":"3","45to54":"3","55to64":"3","65+":"0","medianAge":"3"}},"title":"Manufactured building and mobile home installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Riggers":{"ageData":{"2016":{"total":"13","16to19":"0","20to24":"1","25to34":"6","35to44":"3","45to54":"0","55to64":"4","65+":"0","medianAge":"4"}},"title":"Riggers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"11","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Signal and track switch repairers":{"ageData":{"2016":{"total":"7","16to19":"0","20to24":"0","25to34":"3","35to44":"1","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Signal and track switch repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers--installation, maintenance, and repair workers":{"ageData":{"2016":{"total":"19","16to19":"1","20to24":"5","25to34":"6","35to44":"2","45to54":"4","55to64":"2","65+":"0","medianAge":"2"}},"title":"Helpers--installation, maintenance, and repair workers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"10","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Other installation, maintenance, and repair workers":{"ageData":{"2016":{"total":"198","16to19":"5","20to24":"17","25to34":"50","35to44":"38","45to54":"39","55to64":"40","65+":"8","medianAge":"40"}},"title":"Other installation, maintenance, and repair workers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2016":{"total":"198","women":"6.1","white":"5.8","black":"3.9","asian":"22.9"}},"wageData":{"2016":{"workers":"137","median":"773","maleWorkers":"130","maleMedian":"782","femaleWorkers":"8","femaleMedian":"-"}}},"Production, transportation, and material moving occupations":{"ageData":{"2016":{"total":"17,743","16to19":"500","20to24":"1,687","25to34":"3,681","35to44":"3,547","45to54":"4,138","55to64":"3,249","65+":"942","medianAge":"3,249"}},"title":"Production, transportation, and material moving occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2016":{"total":"17,743","women":"22.1","white":"15.8","black":"4.8","asian":"22.2"}},"wageData":{"2016":{"workers":"14,606","median":"665","maleWorkers":"11,661","maleMedian":"704","femaleWorkers":"2,945","femaleMedian":"531"}}},"Production occupations":{"ageData":{"2016":{"total":"8,459","16to19":"161","20to24":"760","25to34":"1,851","35to44":"1,735","45to54":"2,026","55to64":"1,559","65+":"367","medianAge":"1,559"}},"title":"Production occupations","depth":2,"parent":"Production, transportation, and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"8,459","women":"28.2","white":"12.9","black":"5.9","asian":"22.3"}},"wageData":{"2016":{"workers":"7,513","median":"668","maleWorkers":"5,564","maleMedian":"723","femaleWorkers":"1,949","femaleMedian":"527"}}},"First-line supervisors of production and operating workers":{"ageData":{"2016":{"total":"763","16to19":"4","20to24":"22","25to34":"139","35to44":"169","45to54":"244","55to64":"157","65+":"27","medianAge":"157"}},"title":"First-line supervisors of production and operating workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"763","women":"18.7","white":"9.7","black":"3.9","asian":"15.0"}},"wageData":{"2016":{"workers":"729","median":"923","maleWorkers":"599","maleMedian":"972","femaleWorkers":"131","femaleMedian":"723"}}},"Aircraft structure, surfaces, rigging, and systems assemblers":{"ageData":{"2016":{"total":"5","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Aircraft structure, surfaces, rigging, and systems assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"6","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Electrical, electronics, and electromechanical assemblers":{"ageData":{"2016":{"total":"117","16to19":"4","20to24":"10","25to34":"26","35to44":"15","45to54":"27","55to64":"29","65+":"7","medianAge":"29"}},"title":"Electrical, electronics, and electromechanical assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"117","women":"49.3","white":"14.1","black":"16.9","asian":"22.5"}},"wageData":{"2016":{"workers":"105","median":"590","maleWorkers":"55","maleMedian":"618","femaleWorkers":"50","femaleMedian":"554"}}},"Engine and other machine assemblers":{"ageData":{"2016":{"total":"9","16to19":"0","20to24":"0","25to34":"2","35to44":"4","45to54":"0","55to64":"2","65+":"0","medianAge":"2"}},"title":"Engine and other machine assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Structural metal fabricators and fitters":{"ageData":{"2016":{"total":"22","16to19":"0","20to24":"1","25to34":"5","35to44":"3","45to54":"7","55to64":"5","65+":"1","medianAge":"5"}},"title":"Structural metal fabricators and fitters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"22","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"22","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Miscellaneous assemblers and fabricators":{"ageData":{"2016":{"total":"1,082","16to19":"21","20to24":"128","25to34":"256","35to44":"220","45to54":"239","55to64":"179","65+":"38","medianAge":"179"}},"title":"Miscellaneous assemblers and fabricators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"1,082","women":"34.4","white":"17.8","black":"7.2","asian":"19.6"}},"wageData":{"2016":{"workers":"990","median":"601","maleWorkers":"645","maleMedian":"625","femaleWorkers":"345","femaleMedian":"559"}}},"Bakers":{"ageData":{"2016":{"total":"224","16to19":"11","20to24":"28","25to34":"65","35to44":"30","45to54":"43","55to64":"32","65+":"15","medianAge":"32"}},"title":"Bakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"224","women":"64.8","white":"13.9","black":"7.2","asian":"27.3"}},"wageData":{"2016":{"workers":"138","median":"494","maleWorkers":"55","maleMedian":"562","femaleWorkers":"83","femaleMedian":"480"}}},"Butchers and other meat, poultry, and fish processing workers":{"ageData":{"2016":{"total":"277","16to19":"8","20to24":"26","25to34":"77","35to44":"45","45to54":"65","55to64":"40","65+":"15","medianAge":"40"}},"title":"Butchers and other meat, poultry, and fish processing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"277","women":"26.9","white":"19.8","black":"9.9","asian":"34.6"}},"wageData":{"2016":{"workers":"244","median":"526","maleWorkers":"183","maleMedian":"571","femaleWorkers":"61","femaleMedian":"449"}}},"Food and tobacco roasting, baking, and drying machine operators and tenders":{"ageData":{"2016":{"total":"24","16to19":"0","20to24":"4","25to34":"3","35to44":"3","45to54":"9","55to64":"5","65+":"0","medianAge":"5"}},"title":"Food and tobacco roasting, baking, and drying machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"24","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"16","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Food batchmakers":{"ageData":{"2016":{"total":"107","16to19":"7","20to24":"16","25to34":"31","35to44":"21","45to54":"18","55to64":"13","65+":"3","medianAge":"13"}},"title":"Food batchmakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"107","women":"58.7","white":"14.2","black":"3.1","asian":"30.6"}},"wageData":{"2016":{"workers":"81","median":"537","maleWorkers":"40","maleMedian":"-","femaleWorkers":"42","femaleMedian":"-"}}},"Food cooking machine operators and tenders":{"ageData":{"2016":{"total":"10","16to19":"1","20to24":"2","25to34":"2","35to44":"2","45to54":"1","55to64":"3","65+":"0","medianAge":"3"}},"title":"Food cooking machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"7","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Food processing workers, all other":{"ageData":{"2016":{"total":"138","16to19":"4","20to24":"11","25to34":"26","35to44":"32","45to54":"33","55to64":"27","65+":"5","medianAge":"27"}},"title":"Food processing workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"138","women":"37.4","white":"23.3","black":"7.4","asian":"35.3"}},"wageData":{"2016":{"workers":"129","median":"547","maleWorkers":"88","maleMedian":"579","femaleWorkers":"41","femaleMedian":"-"}}},"Computer control programmers and operators":{"ageData":{"2016":{"total":"87","16to19":"0","20to24":"5","25to34":"22","35to44":"22","45to54":"22","55to64":"14","65+":"2","medianAge":"14"}},"title":"Computer control programmers and operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"87","women":"5.2","white":"6.3","black":"4.3","asian":"12.3"}},"wageData":{"2016":{"workers":"85","median":"802","maleWorkers":"80","maleMedian":"843","femaleWorkers":"6","femaleMedian":"-"}}},"Extruding and drawing machine setters, operators, and tenders, metal and plastic":{"ageData":{"2016":{"total":"13","16to19":"0","20to24":"0","25to34":"3","35to44":"2","45to54":"6","55to64":"2","65+":"0","medianAge":"2"}},"title":"Extruding and drawing machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"13","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Forging machine setters, operators, and tenders, metal and plastic":{"ageData":{"2016":{"total":"5","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Forging machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Rolling machine setters, operators, and tenders, metal and plastic":{"ageData":{"2016":{"total":"13","16to19":"0","20to24":"1","25to34":"5","35to44":"4","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Rolling machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"13","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Cutting, punching, and press machine setters, operators, and tenders, metal and plastic":{"ageData":{"2016":{"total":"83","16to19":"0","20to24":"10","25to34":"23","35to44":"15","45to54":"15","55to64":"17","65+":"4","medianAge":"17"}},"title":"Cutting, punching, and press machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"83","women":"18.3","white":"5.8","black":"0.6","asian":"22.3"}},"wageData":{"2016":{"workers":"86","median":"639","maleWorkers":"68","maleMedian":"672","femaleWorkers":"18","femaleMedian":"-"}}},"Drilling and boring machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2016":{"total":"8","16to19":"0","20to24":"0","25to34":"3","35to44":"1","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Drilling and boring machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"8","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Grinding, lapping, polishing, and buffing machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2016":{"total":"48","16to19":"1","20to24":"2","25to34":"6","35to44":"16","45to54":"10","55to64":"12","65+":"0","medianAge":"12"}},"title":"Grinding, lapping, polishing, and buffing machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"48","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"45","median":"-","maleWorkers":"42","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Lathe and turning machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2016":{"total":"14","16to19":"1","20to24":"0","25to34":"4","35to44":"2","45to54":"3","55to64":"4","65+":"0","medianAge":"4"}},"title":"Lathe and turning machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"13","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Milling and planing machine setters, operators, and tenders, metal and plastic":{"ageData":{"2016":{"total":"6","16to19":"0","20to24":"0","25to34":"2","35to44":"2","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Milling and planing machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Machinists":{"ageData":{"2016":{"total":"356","16to19":"3","20to24":"25","25to34":"66","35to44":"60","45to54":"96","55to64":"94","65+":"12","medianAge":"94"}},"title":"Machinists","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"356","women":"3.4","white":"5.4","black":"6.8","asian":"13.0"}},"wageData":{"2016":{"workers":"326","median":"824","maleWorkers":"313","maleMedian":"844","femaleWorkers":"13","femaleMedian":"-"}}},"Metal furnace operators, tenders, pourers, and casters":{"ageData":{"2016":{"total":"31","16to19":"0","20to24":"1","25to34":"9","35to44":"6","45to54":"7","55to64":"6","65+":"2","medianAge":"6"}},"title":"Metal furnace operators, tenders, pourers, and casters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"31","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"31","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Model makers and patternmakers, metal and plastic":{"ageData":{"2016":{"total":"4","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"3","55to64":"1","65+":"0","medianAge":"1"}},"title":"Model makers and patternmakers, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Molders and molding machine setters, operators, and tenders, metal and plastic":{"ageData":{"2016":{"total":"33","16to19":"1","20to24":"5","25to34":"7","35to44":"6","45to54":"8","55to64":"4","65+":"1","medianAge":"4"}},"title":"Molders and molding machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"28","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Multiple machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2016":{"total":"3","16to19":"0","20to24":"2","25to34":"0","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Multiple machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Tool and die makers":{"ageData":{"2016":{"total":"50","16to19":"1","20to24":"0","25to34":"9","35to44":"7","45to54":"13","55to64":"16","65+":"5","medianAge":"16"}},"title":"Tool and die makers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"50","women":"3.0","white":"2.4","black":"0.0","asian":"12.3"}},"wageData":{"2016":{"workers":"43","median":"-","maleWorkers":"43","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Welding, soldering, and brazing workers":{"ageData":{"2016":{"total":"603","16to19":"10","20to24":"76","25to34":"144","35to44":"148","45to54":"131","55to64":"84","65+":"9","medianAge":"84"}},"title":"Welding, soldering, and brazing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"603","women":"4.1","white":"10.0","black":"2.8","asian":"23.6"}},"wageData":{"2016":{"workers":"558","median":"743","maleWorkers":"535","maleMedian":"753","femaleWorkers":"23","femaleMedian":"-"}}},"Heat treating equipment setters, operators, and tenders, metal and plastic":{"ageData":{"2016":{"total":"3","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Heat treating equipment setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Layout workers, metal and plastic":{"ageData":{"2016":{"total":"7","16to19":"0","20to24":"0","25to34":"3","35to44":"2","45to54":"1","55to64":"0","65+":"1","medianAge":"0"}},"title":"Layout workers, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Plating and coating machine setters, operators, and tenders, metal and plastic":{"ageData":{"2016":{"total":"20","16to19":"0","20to24":"2","25to34":"5","35to44":"2","45to54":"7","55to64":"4","65+":"0","medianAge":"4"}},"title":"Plating and coating machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"20","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"21","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Tool grinders, filers, and sharpeners":{"ageData":{"2016":{"total":"5","16to19":"0","20to24":"1","25to34":"3","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Tool grinders, filers, and sharpeners","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Metal workers and plastic workers, all other":{"ageData":{"2016":{"total":"379","16to19":"7","20to24":"43","25to34":"84","35to44":"73","45to54":"92","55to64":"64","65+":"16","medianAge":"64"}},"title":"Metal workers and plastic workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"379","women":"20.0","white":"15.3","black":"7.3","asian":"22.1"}},"wageData":{"2016":{"workers":"380","median":"626","maleWorkers":"306","maleMedian":"658","femaleWorkers":"74","femaleMedian":"565"}}},"Prepress technicians and workers":{"ageData":{"2016":{"total":"22","16to19":"0","20to24":"1","25to34":"3","35to44":"7","45to54":"6","55to64":"4","65+":"1","medianAge":"4"}},"title":"Prepress technicians and workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"22","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"15","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Printing press operators":{"ageData":{"2016":{"total":"205","16to19":"6","20to24":"11","25to34":"34","35to44":"50","45to54":"49","55to64":"47","65+":"8","medianAge":"47"}},"title":"Printing press operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"205","women":"20.3","white":"6.7","black":"4.7","asian":"15.9"}},"wageData":{"2016":{"workers":"170","median":"701","maleWorkers":"137","maleMedian":"748","femaleWorkers":"33","femaleMedian":"-"}}},"Print binding and finishing workers":{"ageData":{"2016":{"total":"14","16to19":"0","20to24":"4","25to34":"1","35to44":"2","45to54":"2","55to64":"4","65+":"2","medianAge":"4"}},"title":"Print binding and finishing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"11","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Laundry and dry-cleaning workers":{"ageData":{"2016":{"total":"188","16to19":"2","20to24":"9","25to34":"26","35to44":"41","45to54":"53","55to64":"38","65+":"18","medianAge":"38"}},"title":"Laundry and dry-cleaning workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"188","women":"58.1","white":"21.4","black":"7.9","asian":"34.0"}},"wageData":{"2016":{"workers":"135","median":"454","maleWorkers":"55","maleMedian":"486","femaleWorkers":"80","femaleMedian":"436"}}},"Pressers, textile, garment, and related materials":{"ageData":{"2016":{"total":"36","16to19":"0","20to24":"3","25to34":"5","35to44":"8","45to54":"12","55to64":"4","65+":"2","medianAge":"4"}},"title":"Pressers, textile, garment, and related materials","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"36","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"30","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"20","femaleMedian":"-"}}},"Sewing machine operators":{"ageData":{"2016":{"total":"208","16to19":"4","20to24":"11","25to34":"35","35to44":"50","45to54":"54","55to64":"49","65+":"5","medianAge":"49"}},"title":"Sewing machine operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"208","women":"71.5","white":"8.0","black":"12.1","asian":"46.9"}},"wageData":{"2016":{"workers":"165","median":"437","maleWorkers":"52","maleMedian":"407","femaleWorkers":"114","femaleMedian":"452"}}},"Shoe and leather workers and repairers":{"ageData":{"2016":{"total":"8","16to19":"0","20to24":"1","25to34":"1","35to44":"2","45to54":"0","55to64":"2","65+":"1","medianAge":"2"}},"title":"Shoe and leather workers and repairers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"4","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Shoe machine operators and tenders":{"ageData":{"2016":{"total":"2","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Shoe machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Tailors, dressmakers, and sewers":{"ageData":{"2016":{"total":"79","16to19":"1","20to24":"3","25to34":"7","35to44":"12","45to54":"12","55to64":"21","65+":"23","medianAge":"21"}},"title":"Tailors, dressmakers, and sewers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"79","women":"79.7","white":"7.8","black":"22.6","asian":"19.3"}},"wageData":{"2016":{"workers":"32","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"25","femaleMedian":"-"}}},"Textile bleaching and dyeing machine operators and tenders":{"ageData":{"2016":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Textile bleaching and dyeing machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Textile cutting machine setters, operators, and tenders":{"ageData":{"2016":{"total":"9","16to19":"0","20to24":"1","25to34":"0","35to44":"2","45to54":"3","55to64":"1","65+":"2","medianAge":"1"}},"title":"Textile cutting machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"7","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Textile knitting and weaving machine setters, operators, and tenders":{"ageData":{"2016":{"total":"13","16to19":"0","20to24":"0","25to34":"2","35to44":"3","45to54":"3","55to64":"3","65+":"1","medianAge":"3"}},"title":"Textile knitting and weaving machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"13","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Textile winding, twisting, and drawing out machine setters, operators, and tenders":{"ageData":{"2016":{"total":"11","16to19":"0","20to24":"0","25to34":"2","35to44":"3","45to54":"3","55to64":"3","65+":"0","medianAge":"3"}},"title":"Textile winding, twisting, and drawing out machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"6","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Extruding and forming machine setters, operators, and tenders, synthetic and glass fibers":{"ageData":{"2016":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Extruding and forming machine setters, operators, and tenders, synthetic and glass fibers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"0","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Fabric and apparel patternmakers":{"ageData":{"2016":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Fabric and apparel patternmakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Upholsterers":{"ageData":{"2016":{"total":"36","16to19":"0","20to24":"5","25to34":"5","35to44":"7","45to54":"10","55to64":"8","65+":"2","medianAge":"8"}},"title":"Upholsterers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"36","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"20","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Textile, apparel, and furnishings workers, all other":{"ageData":{"2016":{"total":"20","16to19":"2","20to24":"3","25to34":"4","35to44":"4","45to54":"3","55to64":"4","65+":"1","medianAge":"4"}},"title":"Textile, apparel, and furnishings workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"20","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"13","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Cabinetmakers and bench carpenters":{"ageData":{"2016":{"total":"56","16to19":"1","20to24":"8","25to34":"9","35to44":"5","45to54":"12","55to64":"15","65+":"6","medianAge":"15"}},"title":"Cabinetmakers and bench carpenters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"56","women":"11.9","white":"6.7","black":"0.0","asian":"15.7"}},"wageData":{"2016":{"workers":"35","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Furniture finishers":{"ageData":{"2016":{"total":"19","16to19":"0","20to24":"0","25to34":"2","35to44":"6","45to54":"2","55to64":"6","65+":"3","medianAge":"6"}},"title":"Furniture finishers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"9","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Model makers and patternmakers, wood":{"ageData":{"2016":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Model makers and patternmakers, wood","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"0","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Sawing machine setters, operators, and tenders, wood":{"ageData":{"2016":{"total":"35","16to19":"1","20to24":"2","25to34":"13","35to44":"5","45to54":"5","55to64":"9","65+":"1","medianAge":"9"}},"title":"Sawing machine setters, operators, and tenders, wood","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"35","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"31","median":"-","maleWorkers":"27","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Woodworking machine setters, operators, and tenders, except sawing":{"ageData":{"2016":{"total":"23","16to19":"0","20to24":"2","25to34":"7","35to44":"5","45to54":"3","55to64":"4","65+":"1","medianAge":"4"}},"title":"Woodworking machine setters, operators, and tenders, except sawing","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"23","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"23","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Woodworkers, all other":{"ageData":{"2016":{"total":"34","16to19":"0","20to24":"2","25to34":"8","35to44":"5","45to54":"5","55to64":"11","65+":"3","medianAge":"11"}},"title":"Woodworkers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"34","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"17","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Power plant operators, distributors, and dispatchers":{"ageData":{"2016":{"total":"44","16to19":"0","20to24":"0","25to34":"9","35to44":"9","45to54":"14","55to64":"11","65+":"1","medianAge":"11"}},"title":"Power plant operators, distributors, and dispatchers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"44","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"39","median":"-","maleWorkers":"37","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Stationary engineers and boiler operators":{"ageData":{"2016":{"total":"78","16to19":"1","20to24":"3","25to34":"11","35to44":"13","45to54":"23","55to64":"23","65+":"4","medianAge":"23"}},"title":"Stationary engineers and boiler operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"78","women":"4.7","white":"9.6","black":"5.0","asian":"14.1"}},"wageData":{"2016":{"workers":"77","median":"924","maleWorkers":"72","maleMedian":"954","femaleWorkers":"4","femaleMedian":"-"}}},"Water and wastewater treatment plant and system operators":{"ageData":{"2016":{"total":"77","16to19":"0","20to24":"2","25to34":"14","35to44":"20","45to54":"22","55to64":"17","65+":"2","medianAge":"17"}},"title":"Water and wastewater treatment plant and system operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"77","women":"5.2","white":"13.9","black":"2.1","asian":"6.8"}},"wageData":{"2016":{"workers":"76","median":"883","maleWorkers":"72","maleMedian":"885","femaleWorkers":"3","femaleMedian":"-"}}},"Miscellaneous plant and system operators":{"ageData":{"2016":{"total":"38","16to19":"0","20to24":"3","25to34":"10","35to44":"7","45to54":"13","55to64":"4","65+":"1","medianAge":"4"}},"title":"Miscellaneous plant and system operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"38","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"42","median":"-","maleWorkers":"38","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Chemical processing machine setters, operators, and tenders":{"ageData":{"2016":{"total":"54","16to19":"0","20to24":"3","25to34":"14","35to44":"9","45to54":"18","55to64":"9","65+":"1","medianAge":"9"}},"title":"Chemical processing machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"54","women":"10.2","white":"3.7","black":"1.5","asian":"15.8"}},"wageData":{"2016":{"workers":"50","median":"924","maleWorkers":"46","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Crushing, grinding, polishing, mixing, and blending workers":{"ageData":{"2016":{"total":"94","16to19":"1","20to24":"12","25to34":"21","35to44":"22","45to54":"21","55to64":"14","65+":"4","medianAge":"14"}},"title":"Crushing, grinding, polishing, mixing, and blending workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"94","women":"11.9","white":"12.2","black":"1.5","asian":"35.3"}},"wageData":{"2016":{"workers":"88","median":"643","maleWorkers":"82","maleMedian":"642","femaleWorkers":"6","femaleMedian":"-"}}},"Cutting workers":{"ageData":{"2016":{"total":"67","16to19":"1","20to24":"8","25to34":"17","35to44":"22","45to54":"10","55to64":"7","65+":"2","medianAge":"7"}},"title":"Cutting workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"67","women":"22.3","white":"7.2","black":"4.1","asian":"37.2"}},"wageData":{"2016":{"workers":"62","median":"576","maleWorkers":"50","maleMedian":"546","femaleWorkers":"13","femaleMedian":"-"}}},"Extruding, forming, pressing, and compacting machine setters, operators, and tenders":{"ageData":{"2016":{"total":"29","16to19":"1","20to24":"5","25to34":"4","35to44":"4","45to54":"11","55to64":"3","65+":"1","medianAge":"3"}},"title":"Extruding, forming, pressing, and compacting machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"29","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"24","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Furnace, kiln, oven, drier, and kettle operators and tenders":{"ageData":{"2016":{"total":"16","16to19":"0","20to24":"0","25to34":"4","35to44":"2","45to54":"4","55to64":"4","65+":"1","medianAge":"4"}},"title":"Furnace, kiln, oven, drier, and kettle operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"16","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"11","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Inspectors, testers, sorters, samplers, and weighers":{"ageData":{"2016":{"total":"734","16to19":"10","20to24":"55","25to34":"162","35to44":"147","45to54":"170","55to64":"145","65+":"45","medianAge":"145"}},"title":"Inspectors, testers, sorters, samplers, and weighers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"734","women":"37.9","white":"12.8","black":"7.4","asian":"17.7"}},"wageData":{"2016":{"workers":"686","median":"714","maleWorkers":"445","maleMedian":"834","femaleWorkers":"241","femaleMedian":"584"}}},"Jewelers and precious stone and metal workers":{"ageData":{"2016":{"total":"40","16to19":"0","20to24":"3","25to34":"5","35to44":"8","45to54":"7","55to64":"11","65+":"6","medianAge":"11"}},"title":"Jewelers and precious stone and metal workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"18","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Medical, dental, and ophthalmic laboratory technicians":{"ageData":{"2016":{"total":"85","16to19":"3","20to24":"8","25to34":"17","35to44":"22","45to54":"15","55to64":"13","65+":"7","medianAge":"13"}},"title":"Medical, dental, and ophthalmic laboratory technicians","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"85","women":"51.4","white":"8.4","black":"11.8","asian":"11.3"}},"wageData":{"2016":{"workers":"64","median":"615","maleWorkers":"33","maleMedian":"-","femaleWorkers":"31","femaleMedian":"-"}}},"Packaging and filling machine operators and tenders":{"ageData":{"2016":{"total":"236","16to19":"11","20to24":"26","25to34":"53","35to44":"43","45to54":"61","55to64":"36","65+":"6","medianAge":"36"}},"title":"Packaging and filling machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"236","women":"50.5","white":"16.1","black":"6.2","asian":"43.1"}},"wageData":{"2016":{"workers":"224","median":"488","maleWorkers":"112","maleMedian":"574","femaleWorkers":"113","femaleMedian":"425"}}},"Painting workers":{"ageData":{"2016":{"total":"173","16to19":"5","20to24":"18","25to34":"47","35to44":"42","45to54":"38","55to64":"19","65+":"4","medianAge":"19"}},"title":"Painting workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"173","women":"8.9","white":"8.8","black":"1.8","asian":"28.4"}},"wageData":{"2016":{"workers":"158","median":"701","maleWorkers":"147","maleMedian":"713","femaleWorkers":"11","femaleMedian":"-"}}},"Photographic process workers and processing machine operators":{"ageData":{"2016":{"total":"29","16to19":"2","20to24":"6","25to34":"6","35to44":"5","45to54":"3","55to64":"5","65+":"2","medianAge":"5"}},"title":"Photographic process workers and processing machine operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"29","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"23","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Semiconductor processors":{"ageData":{"2016":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Semiconductor processors","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Adhesive bonding machine operators and tenders":{"ageData":{"2016":{"total":"11","16to19":"0","20to24":"1","25to34":"1","35to44":"1","45to54":"3","55to64":"3","65+":"1","medianAge":"3"}},"title":"Adhesive bonding machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"12","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Cleaning, washing, and metal pickling equipment operators and tenders":{"ageData":{"2016":{"total":"3","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Cleaning, washing, and metal pickling equipment operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Cooling and freezing equipment operators and tenders":{"ageData":{"2016":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Cooling and freezing equipment operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"0","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Etchers and engravers":{"ageData":{"2016":{"total":"6","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"4","65+":"0","medianAge":"4"}},"title":"Etchers and engravers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Molders, shapers, and casters, except metal and plastic":{"ageData":{"2016":{"total":"24","16to19":"0","20to24":"2","25to34":"9","35to44":"7","45to54":"2","55to64":"3","65+":"1","medianAge":"3"}},"title":"Molders, shapers, and casters, except metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"24","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"16","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Paper goods machine setters, operators, and tenders":{"ageData":{"2016":{"total":"33","16to19":"0","20to24":"3","25to34":"6","35to44":"5","45to54":"13","55to64":"5","65+":"2","medianAge":"5"}},"title":"Paper goods machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"27","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Tire builders":{"ageData":{"2016":{"total":"10","16to19":"0","20to24":"1","25to34":"1","35to44":"4","45to54":"3","55to64":"1","65+":"0","medianAge":"1"}},"title":"Tire builders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"11","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Helpers--production workers":{"ageData":{"2016":{"total":"40","16to19":"6","20to24":"12","25to34":"12","35to44":"3","45to54":"4","55to64":"3","65+":"1","medianAge":"3"}},"title":"Helpers--production workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"25","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Production workers, all other":{"ageData":{"2016":{"total":"968","16to19":"19","20to24":"98","25to34":"227","35to44":"209","45to54":"223","55to64":"162","65+":"31","medianAge":"162"}},"title":"Production workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2016":{"total":"968","women":"29.4","white":"17.1","black":"5.4","asian":"22.1"}},"wageData":{"2016":{"workers":"887","median":"622","maleWorkers":"641","maleMedian":"690","femaleWorkers":"246","femaleMedian":"515"}}},"Transportation and material moving occupations":{"ageData":{"2016":{"total":"9,284","16to19":"339","20to24":"928","25to34":"1,829","35to44":"1,812","45to54":"2,113","55to64":"1,690","65+":"574","medianAge":"1,690"}},"title":"Transportation and material moving occupations","depth":2,"parent":"Production, transportation, and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"9,284","women":"16.5","white":"18.4","black":"3.8","asian":"22.1"}},"wageData":{"2016":{"workers":"7,093","median":"662","maleWorkers":"6,097","maleMedian":"685","femaleWorkers":"997","femaleMedian":"540"}}},"Supervisors of transportation and material moving workers":{"ageData":{"2016":{"total":"190","16to19":"0","20to24":"8","25to34":"42","35to44":"53","45to54":"47","55to64":"31","65+":"10","medianAge":"31"}},"title":"Supervisors of transportation and material moving workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"190","women":"21.4","white":"13.4","black":"3.2","asian":"21.2"}},"wageData":{"2016":{"workers":"165","median":"807","maleWorkers":"126","maleMedian":"843","femaleWorkers":"39","femaleMedian":"-"}}},"Aircraft pilots and flight engineers":{"ageData":{"2016":{"total":"141","16to19":"0","20to24":"1","25to34":"23","35to44":"32","45to54":"52","55to64":"27","65+":"6","medianAge":"27"}},"title":"Aircraft pilots and flight engineers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"141","women":"5.2","white":"3.0","black":"0.5","asian":"7.7"}},"wageData":{"2016":{"workers":"119","median":"1,582","maleWorkers":"112","maleMedian":"1,600","femaleWorkers":"7","femaleMedian":"-"}}},"Air traffic controllers and airfield operations specialists":{"ageData":{"2016":{"total":"26","16to19":"1","20to24":"1","25to34":"9","35to44":"5","45to54":"4","55to64":"4","65+":"2","medianAge":"4"}},"title":"Air traffic controllers and airfield operations specialists","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"26","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"28","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Flight attendants":{"ageData":{"2016":{"total":"93","16to19":"1","20to24":"4","25to34":"18","35to44":"13","45to54":"34","55to64":"19","65+":"5","medianAge":"19"}},"title":"Flight attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"93","women":"75.8","white":"13.7","black":"6.4","asian":"16.1"}},"wageData":{"2016":{"workers":"68","median":"873","maleWorkers":"19","maleMedian":"-","femaleWorkers":"49","femaleMedian":"-"}}},"Ambulance drivers and attendants, except emergency medical technicians":{"ageData":{"2016":{"total":"19","16to19":"0","20to24":"2","25to34":"4","35to44":"1","45to54":"2","55to64":"7","65+":"2","medianAge":"7"}},"title":"Ambulance drivers and attendants, except emergency medical technicians","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"15","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Bus drivers":{"ageData":{"2016":{"total":"553","16to19":"2","20to24":"7","25to34":"54","35to44":"99","45to54":"156","55to64":"152","65+":"82","medianAge":"152"}},"title":"Bus drivers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"553","women":"48.7","white":"29.4","black":"3.3","asian":"11.8"}},"wageData":{"2016":{"workers":"343","median":"641","maleWorkers":"197","maleMedian":"691","femaleWorkers":"146","femaleMedian":"589"}}},"Driver/sales workers and truck drivers":{"ageData":{"2016":{"total":"3,542","16to19":"46","20to24":"227","25to34":"611","35to44":"755","45to54":"920","55to64":"739","65+":"245","medianAge":"739"}},"title":"Driver/sales workers and truck drivers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"3,542","women":"6.0","white":"14.8","black":"2.6","asian":"21.3"}},"wageData":{"2016":{"workers":"2,809","median":"780","maleWorkers":"2,689","maleMedian":"787","femaleWorkers":"120","femaleMedian":"630"}}},"Taxi drivers and chauffeurs":{"ageData":{"2016":{"total":"500","16to19":"3","20to24":"24","25to34":"88","35to44":"100","45to54":"112","55to64":"112","65+":"60","medianAge":"112"}},"title":"Taxi drivers and chauffeurs","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"500","women":"14.3","white":"28.7","black":"16.0","asian":"12.6"}},"wageData":{"2016":{"workers":"261","median":"580","maleWorkers":"222","maleMedian":"595","femaleWorkers":"38","femaleMedian":"-"}}},"Motor vehicle operators, all other":{"ageData":{"2016":{"total":"63","16to19":"1","20to24":"5","25to34":"10","35to44":"6","45to54":"10","55to64":"16","65+":"17","medianAge":"16"}},"title":"Motor vehicle operators, all other","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"63","women":"8.8","white":"13.7","black":"2.3","asian":"14.6"}},"wageData":{"2016":{"workers":"25","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Locomotive engineers and operators":{"ageData":{"2016":{"total":"52","16to19":"0","20to24":"0","25to34":"10","35to44":"15","45to54":"15","55to64":"11","65+":"1","medianAge":"11"}},"title":"Locomotive engineers and operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"52","women":"3.2","white":"20.8","black":"0.6","asian":"7.8"}},"wageData":{"2016":{"workers":"45","median":"-","maleWorkers":"45","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Railroad brake, signal, and switch operators":{"ageData":{"2016":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Railroad brake, signal, and switch operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Railroad conductors and yardmasters":{"ageData":{"2016":{"total":"55","16to19":"2","20to24":"3","25to34":"9","35to44":"18","45to54":"16","55to64":"5","65+":"1","medianAge":"5"}},"title":"Railroad conductors and yardmasters","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"55","women":"4.7","white":"21.3","black":"4.3","asian":"6.0"}},"wageData":{"2016":{"workers":"52","median":"1,160","maleWorkers":"51","maleMedian":"1,148","femaleWorkers":"1","femaleMedian":"-"}}},"Subway, streetcar, and other rail transportation workers":{"ageData":{"2016":{"total":"15","16to19":"0","20to24":"2","25to34":"2","35to44":"6","45to54":"4","55to64":"1","65+":"1","medianAge":"1"}},"title":"Subway, streetcar, and other rail transportation workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"15","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"13","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Sailors and marine oilers":{"ageData":{"2016":{"total":"16","16to19":"1","20to24":"2","25to34":"5","35to44":"5","45to54":"2","55to64":"1","65+":"1","medianAge":"1"}},"title":"Sailors and marine oilers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"16","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"15","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Ship and boat captains and operators":{"ageData":{"2016":{"total":"31","16to19":"1","20to24":"2","25to34":"5","35to44":"10","45to54":"3","55to64":"7","65+":"2","medianAge":"7"}},"title":"Ship and boat captains and operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"31","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"28","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Ship engineers":{"ageData":{"2016":{"total":"4","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Ship engineers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Bridge and lock tenders":{"ageData":{"2016":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"0","55to64":"1","65+":"1","medianAge":"1"}},"title":"Bridge and lock tenders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Parking lot attendants":{"ageData":{"2016":{"total":"89","16to19":"6","20to24":"24","25to34":"13","35to44":"12","45to54":"13","55to64":"14","65+":"7","medianAge":"14"}},"title":"Parking lot attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"89","women":"10.7","white":"24.3","black":"7.3","asian":"28.5"}},"wageData":{"2016":{"workers":"67","median":"519","maleWorkers":"62","maleMedian":"513","femaleWorkers":"4","femaleMedian":"-"}}},"Automotive and watercraft service attendants":{"ageData":{"2016":{"total":"97","16to19":"11","20to24":"27","25to34":"21","35to44":"9","45to54":"9","55to64":"13","65+":"6","medianAge":"13"}},"title":"Automotive and watercraft service attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"97","women":"8.6","white":"9.9","black":"6.4","asian":"18.1"}},"wageData":{"2016":{"workers":"73","median":"462","maleWorkers":"67","maleMedian":"456","femaleWorkers":"5","femaleMedian":"-"}}},"Transportation inspectors":{"ageData":{"2016":{"total":"26","16to19":"0","20to24":"2","25to34":"4","35to44":"3","45to54":"8","55to64":"9","65+":"1","medianAge":"9"}},"title":"Transportation inspectors","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"26","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"25","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Transportation attendants, except flight attendants":{"ageData":{"2016":{"total":"41","16to19":"1","20to24":"4","25to34":"7","35to44":"8","45to54":"10","55to64":"6","65+":"6","medianAge":"6"}},"title":"Transportation attendants, except flight attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"41","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"20","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Other transportation workers":{"ageData":{"2016":{"total":"34","16to19":"1","20to24":"1","25to34":"10","35to44":"7","45to54":"8","55to64":"7","65+":"1","medianAge":"7"}},"title":"Other transportation workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"34","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"31","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Conveyor operators and tenders":{"ageData":{"2016":{"total":"3","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Conveyor operators and tenders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Crane and tower operators":{"ageData":{"2016":{"total":"63","16to19":"0","20to24":"1","25to34":"15","35to44":"12","45to54":"23","55to64":"8","65+":"3","medianAge":"8"}},"title":"Crane and tower operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"63","women":"0.8","white":"13.0","black":"0.5","asian":"13.7"}},"wageData":{"2016":{"workers":"66","median":"909","maleWorkers":"66","maleMedian":"909","femaleWorkers":"0","femaleMedian":"-"}}},"Dredge, excavating, and loading machine operators":{"ageData":{"2016":{"total":"37","16to19":"0","20to24":"1","25to34":"7","35to44":"9","45to54":"9","55to64":"6","65+":"4","medianAge":"6"}},"title":"Dredge, excavating, and loading machine operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"37","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"27","median":"-","maleWorkers":"27","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Hoist and winch operators":{"ageData":{"2016":{"total":"9","16to19":"1","20to24":"1","25to34":"2","35to44":"1","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Hoist and winch operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"11","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Industrial truck and tractor operators":{"ageData":{"2016":{"total":"605","16to19":"11","20to24":"57","25to34":"174","35to44":"117","45to54":"129","55to64":"103","65+":"14","medianAge":"103"}},"title":"Industrial truck and tractor operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"605","women":"9.6","white":"26.0","black":"2.3","asian":"28.0"}},"wageData":{"2016":{"workers":"564","median":"602","maleWorkers":"510","maleMedian":"604","femaleWorkers":"54","femaleMedian":"563"}}},"Cleaners of vehicles and equipment":{"ageData":{"2016":{"total":"328","16to19":"37","20to24":"59","25to34":"76","35to44":"59","45to54":"51","55to64":"36","65+":"9","medianAge":"36"}},"title":"Cleaners of vehicles and equipment","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"328","women":"13.0","white":"18.0","black":"2.5","asian":"29.4"}},"wageData":{"2016":{"workers":"252","median":"491","maleWorkers":"224","maleMedian":"487","femaleWorkers":"28","femaleMedian":"-"}}},"Laborers and freight, stock, and material movers, hand":{"ageData":{"2016":{"total":"1,900","16to19":"138","20to24":"357","25to34":"449","35to44":"305","45to54":"331","55to64":"261","65+":"59","medianAge":"261"}},"title":"Laborers and freight, stock, and material movers, hand","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"1,900","women":"18.1","white":"19.9","black":"3.2","asian":"23.4"}},"wageData":{"2016":{"workers":"1,417","median":"566","maleWorkers":"1,196","maleMedian":"580","femaleWorkers":"221","femaleMedian":"509"}}},"Machine feeders and offbearers":{"ageData":{"2016":{"total":"30","16to19":"0","20to24":"4","25to34":"4","35to44":"8","45to54":"5","55to64":"7","65+":"1","medianAge":"7"}},"title":"Machine feeders and offbearers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"30","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"27","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Packers and packagers, hand":{"ageData":{"2016":{"total":"550","16to19":"70","20to24":"85","25to34":"123","35to44":"99","45to54":"99","55to64":"58","65+":"17","medianAge":"58"}},"title":"Packers and packagers, hand","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"550","women":"54.5","white":"18.9","black":"7.1","asian":"43.6"}},"wageData":{"2016":{"workers":"383","median":"456","maleWorkers":"166","maleMedian":"468","femaleWorkers":"216","femaleMedian":"437"}}},"Pumping station operators":{"ageData":{"2016":{"total":"16","16to19":"0","20to24":"0","25to34":"5","35to44":"4","45to54":"2","55to64":"3","65+":"1","medianAge":"3"}},"title":"Pumping station operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"16","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"13","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Refuse and recyclable material collectors":{"ageData":{"2016":{"total":"101","16to19":"2","20to24":"11","25to34":"23","35to44":"20","45to54":"27","55to64":"14","65+":"4","medianAge":"14"}},"title":"Refuse and recyclable material collectors","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"101","women":"8.6","white":"16.4","black":"0.5","asian":"23.5"}},"wageData":{"2016":{"workers":"68","median":"562","maleWorkers":"64","maleMedian":"584","femaleWorkers":"4","femaleMedian":"-"}}},"Mine shuttle car operators":{"ageData":{"2016":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Mine shuttle car operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"0","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Tank car, truck, and ship loaders":{"ageData":{"2016":{"total":"4","16to19":"0","20to24":"0","25to34":"1","35to44":"3","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Tank car, truck, and ship loaders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"3","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Material moving workers, all other":{"ageData":{"2016":{"total":"45","16to19":"1","20to24":"6","25to34":"5","35to44":"14","45to54":"8","55to64":"7","65+":"3","medianAge":"7"}},"title":"Material moving workers, all other","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2016":{"total":"45","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2016":{"workers":"46","median":"-","maleWorkers":"40","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}}}');


var $b40301d0d2c81e1e$exports = {};
$b40301d0d2c81e1e$exports = JSON.parse('{"Total":{"ageData":{"2015":{"total":"148,834","16to19":"4,734","20to24":"14,022","25to34":"32,742","35to44":"31,252","45to54":"32,643","55to64":"24,975","65+":"8,465","medianAge":"24,975"}},"title":"Total","depth":1,"parent":"","sexRaceEthnicityData":{"2015":{"total":"148,834","women":"46.8","white":"11.7","black":"5.8","asian":"16.4"}},"wageData":{"2015":{"workers":"109,080","median":"$809","maleWorkers":"60,746","maleMedian":"$895","femaleWorkers":"48,334","femaleMedian":"$726"}}},"Management, professional, and related occupations":{"ageData":{"2015":{"total":"57,960","16to19":"384","20to24":"3,073","25to34":"13,154","35to44":"13,553","45to54":"13,668","55to64":"10,392","65+":"3,737","medianAge":"10,392"}},"title":"Management, professional, and related occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2015":{"total":"57,960","women":"51.5","white":"9.2","black":"7.7","asian":"9.1"}},"wageData":{"2015":{"workers":"44,844","median":"1,158","maleWorkers":"21,807","maleMedian":"1,383","femaleWorkers":"23,038","femaleMedian":"996"}}},"Management, business, and financial operations occupations":{"ageData":{"2015":{"total":"24,108","16to19":"85","20to24":"930","25to34":"4,787","35to44":"5,567","45to54":"6,279","55to64":"4,697","65+":"1,764","medianAge":"4,697"}},"title":"Management, business, and financial operations occupations","depth":2,"parent":"Management, professional, and related occupations","sexRaceEthnicityData":{"2015":{"total":"24,108","women":"43.6","white":"8.2","black":"6.3","asian":"9.4"}},"wageData":{"2015":{"workers":"18,422","median":"1,258","maleWorkers":"10,018","maleMedian":"1,436","femaleWorkers":"8,404","femaleMedian":"1,073"}}},"Management occupations":{"ageData":{"2015":{"total":"16,994","16to19":"60","20to24":"534","25to34":"3,000","35to44":"3,972","45to54":"4,643","55to64":"3,452","65+":"1,334","medianAge":"3,452"}},"title":"Management occupations","depth":3,"parent":"Management, business, and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"16,994","women":"39.2","white":"7.3","black":"5.6","asian":"9.7"}},"wageData":{"2015":{"workers":"12,480","median":"1,351","maleWorkers":"7,332","maleMedian":"1,486","femaleWorkers":"5,147","femaleMedian":"1,139"}}},"Chief executives":{"ageData":{"2015":{"total":"1,517","16to19":"0","20to24":"6","25to34":"121","35to44":"286","45to54":"493","55to64":"436","65+":"176","medianAge":"436"}},"title":"Chief executives","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"1,517","women":"27.9","white":"3.6","black":"4.7","asian":"5.5"}},"wageData":{"2015":{"workers":"1,046","median":"2,041","maleWorkers":"763","maleMedian":"2,251","femaleWorkers":"283","femaleMedian":"1,836"}}},"General and operations managers":{"ageData":{"2015":{"total":"899","16to19":"2","20to24":"27","25to34":"211","35to44":"238","45to54":"247","55to64":"146","65+":"28","medianAge":"146"}},"title":"General and operations managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"899","women":"27.6","white":"6.9","black":"4.7","asian":"10.8"}},"wageData":{"2015":{"workers":"823","median":"1,260","maleWorkers":"621","maleMedian":"1,347","femaleWorkers":"202","femaleMedian":"1,002"}}},"Legislators":{"ageData":{"2015":{"total":"13","16to19":"0","20to24":"0","25to34":"1","35to44":"4","45to54":"4","55to64":"2","65+":"2","medianAge":"2"}},"title":"Legislators","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"8","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Advertising and promotions managers":{"ageData":{"2015":{"total":"67","16to19":"0","20to24":"10","25to34":"15","35to44":"16","45to54":"13","55to64":"9","65+":"4","medianAge":"9"}},"title":"Advertising and promotions managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"67","women":"53.6","white":"0.0","black":"5.5","asian":"6.6"}},"wageData":{"2015":{"workers":"55","median":"1,050","maleWorkers":"29","maleMedian":"-","femaleWorkers":"26","femaleMedian":"-"}}},"Marketing and sales managers":{"ageData":{"2015":{"total":"1,006","16to19":"3","20to24":"55","25to34":"260","35to44":"261","45to54":"242","55to64":"155","65+":"30","medianAge":"155"}},"title":"Marketing and sales managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"1,006","women":"43.2","white":"6.2","black":"5.8","asian":"9.7"}},"wageData":{"2015":{"workers":"948","median":"1,462","maleWorkers":"570","maleMedian":"1,603","femaleWorkers":"378","femaleMedian":"1,258"}}},"Public relations and fundraising managers":{"ageData":{"2015":{"total":"61","16to19":"0","20to24":"2","25to34":"18","35to44":"15","45to54":"15","55to64":"10","65+":"1","medianAge":"10"}},"title":"Public relations and fundraising managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"61","women":"59.2","white":"10.6","black":"5.2","asian":"5.6"}},"wageData":{"2015":{"workers":"59","median":"1,557","maleWorkers":"24","maleMedian":"-","femaleWorkers":"35","femaleMedian":"-"}}},"Administrative services managers":{"ageData":{"2015":{"total":"195","16to19":"1","20to24":"3","25to34":"29","35to44":"44","45to54":"59","55to64":"46","65+":"14","medianAge":"46"}},"title":"Administrative services managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"195","women":"47.7","white":"9.9","black":"3.0","asian":"7.2"}},"wageData":{"2015":{"workers":"170","median":"1,191","maleWorkers":"96","maleMedian":"1,451","femaleWorkers":"73","femaleMedian":"981"}}},"Computer and information systems managers":{"ageData":{"2015":{"total":"652","16to19":"1","20to24":"11","25to34":"104","35to44":"217","45to54":"197","55to64":"102","65+":"20","medianAge":"102"}},"title":"Computer and information systems managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"652","women":"27.2","white":"5.6","black":"14.2","asian":"4.8"}},"wageData":{"2015":{"workers":"636","median":"1,728","maleWorkers":"466","maleMedian":"1,817","femaleWorkers":"169","femaleMedian":"1,563"}}},"Financial managers":{"ageData":{"2015":{"total":"1,197","16to19":"1","20to24":"31","25to34":"243","35to44":"317","45to54":"347","55to64":"200","65+":"58","medianAge":"200"}},"title":"Financial managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"1,197","women":"49.6","white":"7.2","black":"7.9","asian":"9.4"}},"wageData":{"2015":{"workers":"1,124","median":"1,408","maleWorkers":"551","maleMedian":"1,732","femaleWorkers":"573","femaleMedian":"1,130"}}},"Compensation and benefits managers":{"ageData":{"2015":{"total":"23","16to19":"0","20to24":"0","25to34":"5","35to44":"4","45to54":"8","55to64":"5","65+":"0","medianAge":"5"}},"title":"Compensation and benefits managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"23","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"23","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Human resources managers":{"ageData":{"2015":{"total":"290","16to19":"0","20to24":"5","25to34":"49","35to44":"89","45to54":"90","55to64":"47","65+":"9","medianAge":"47"}},"title":"Human resources managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"290","women":"73.3","white":"11.9","black":"2.2","asian":"10.8"}},"wageData":{"2015":{"workers":"254","median":"1,365","maleWorkers":"68","maleMedian":"1,495","femaleWorkers":"186","femaleMedian":"1,274"}}},"Training and development managers":{"ageData":{"2015":{"total":"41","16to19":"0","20to24":"2","25to34":"3","35to44":"15","45to54":"11","55to64":"8","65+":"2","medianAge":"8"}},"title":"Training and development managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"41","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"37","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"20","femaleMedian":"-"}}},"Industrial production managers":{"ageData":{"2015":{"total":"280","16to19":"2","20to24":"1","25to34":"48","35to44":"70","45to54":"93","55to64":"59","65+":"7","medianAge":"59"}},"title":"Industrial production managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"280","women":"18.3","white":"5.1","black":"4.3","asian":"6.7"}},"wageData":{"2015":{"workers":"267","median":"1,485","maleWorkers":"221","maleMedian":"1,528","femaleWorkers":"45","femaleMedian":"-"}}},"Purchasing managers":{"ageData":{"2015":{"total":"198","16to19":"0","20to24":"6","25to34":"28","35to44":"58","45to54":"49","55to64":"42","65+":"13","medianAge":"42"}},"title":"Purchasing managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"198","women":"44.8","white":"11.4","black":"7.2","asian":"12.9"}},"wageData":{"2015":{"workers":"193","median":"1,348","maleWorkers":"109","maleMedian":"1,404","femaleWorkers":"84","femaleMedian":"1,226"}}},"Transportation, storage, and distribution managers":{"ageData":{"2015":{"total":"263","16to19":"1","20to24":"7","25to34":"57","35to44":"66","45to54":"70","55to64":"52","65+":"10","medianAge":"52"}},"title":"Transportation, storage, and distribution managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"263","women":"21.1","white":"8.2","black":"3.4","asian":"19.2"}},"wageData":{"2015":{"workers":"276","median":"966","maleWorkers":"224","maleMedian":"1,006","femaleWorkers":"52","femaleMedian":"749"}}},"Farmers, ranchers, and other agricultural managers":{"ageData":{"2015":{"total":"1,052","16to19":"7","20to24":"30","25to34":"128","35to44":"137","45to54":"201","55to64":"272","65+":"276","medianAge":"272"}},"title":"Farmers, ranchers, and other agricultural managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"1,052","women":"23.9","white":"0.9","black":"0.6","asian":"4.3"}},"wageData":{"2015":{"workers":"129","median":"769","maleWorkers":"106","maleMedian":"847","femaleWorkers":"23","femaleMedian":"-"}}},"Construction managers":{"ageData":{"2015":{"total":"737","16to19":"0","20to24":"22","25to34":"134","35to44":"173","45to54":"194","55to64":"180","65+":"34","medianAge":"180"}},"title":"Construction managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"737","women":"6.7","white":"3.3","black":"3.2","asian":"12.9"}},"wageData":{"2015":{"workers":"471","median":"1,329","maleWorkers":"429","maleMedian":"1,357","femaleWorkers":"42","femaleMedian":"-"}}},"Education administrators":{"ageData":{"2015":{"total":"928","16to19":"4","20to24":"21","25to34":"138","35to44":"261","45to54":"261","55to64":"186","65+":"56","medianAge":"186"}},"title":"Education administrators","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"928","women":"65.7","white":"13.4","black":"3.8","asian":"9.3"}},"wageData":{"2015":{"workers":"778","median":"1,423","maleWorkers":"282","maleMedian":"1,585","femaleWorkers":"496","femaleMedian":"1,252"}}},"Architectural and engineering managers":{"ageData":{"2015":{"total":"110","16to19":"0","20to24":"0","25to34":"16","35to44":"26","45to54":"40","55to64":"23","65+":"5","medianAge":"23"}},"title":"Architectural and engineering managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"110","women":"7.4","white":"6.3","black":"7.6","asian":"9.0"}},"wageData":{"2015":{"workers":"110","median":"1,899","maleWorkers":"101","maleMedian":"1,892","femaleWorkers":"10","femaleMedian":"-"}}},"Food service managers":{"ageData":{"2015":{"total":"1,192","16to19":"23","20to24":"151","25to34":"321","35to44":"253","45to54":"257","55to64":"138","65+":"49","medianAge":"138"}},"title":"Food service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"1,192","women":"47.1","white":"11.1","black":"10.6","asian":"17.0"}},"wageData":{"2015":{"workers":"763","median":"742","maleWorkers":"389","maleMedian":"820","femaleWorkers":"374","femaleMedian":"680"}}},"Funeral service managers":{"ageData":{"2015":{"total":"15","16to19":"0","20to24":"0","25to34":"4","35to44":"4","45to54":"4","55to64":"2","65+":"1","medianAge":"2"}},"title":"Funeral service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"15","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"13","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Gaming managers":{"ageData":{"2015":{"total":"23","16to19":"0","20to24":"1","25to34":"8","35to44":"7","45to54":"3","55to64":"4","65+":"1","medianAge":"4"}},"title":"Gaming managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"23","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"19","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Lodging managers":{"ageData":{"2015":{"total":"159","16to19":"1","20to24":"9","25to34":"31","35to44":"36","45to54":"39","55to64":"25","65+":"19","medianAge":"25"}},"title":"Lodging managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"159","women":"53.5","white":"7.2","black":"10.9","asian":"16.8"}},"wageData":{"2015":{"workers":"123","median":"985","maleWorkers":"54","maleMedian":"1,171","femaleWorkers":"68","femaleMedian":"902"}}},"Medical and health services managers":{"ageData":{"2015":{"total":"636","16to19":"0","20to24":"11","25to34":"127","35to44":"140","45to54":"184","55to64":"135","65+":"40","medianAge":"135"}},"title":"Medical and health services managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"636","women":"73.7","white":"13.1","black":"5.2","asian":"8.0"}},"wageData":{"2015":{"workers":"592","median":"1,210","maleWorkers":"154","maleMedian":"1,422","femaleWorkers":"438","femaleMedian":"1,156"}}},"Natural sciences managers":{"ageData":{"2015":{"total":"25","16to19":"0","20to24":"2","25to34":"5","35to44":"8","45to54":"6","55to64":"3","65+":"1","medianAge":"3"}},"title":"Natural sciences managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"25","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"24","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Postmasters and mail superintendents":{"ageData":{"2015":{"total":"24","16to19":"0","20to24":"0","25to34":"1","35to44":"2","45to54":"12","55to64":"5","65+":"4","medianAge":"5"}},"title":"Postmasters and mail superintendents","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"24","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"20","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Property, real estate, and community association managers":{"ageData":{"2015":{"total":"685","16to19":"2","20to24":"21","25to34":"111","35to44":"128","45to54":"144","55to64":"166","65+":"113","medianAge":"166"}},"title":"Property, real estate, and community association managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"685","women":"50.9","white":"7.6","black":"3.6","asian":"11.1"}},"wageData":{"2015":{"workers":"401","median":"914","maleWorkers":"171","maleMedian":"1,137","femaleWorkers":"230","femaleMedian":"823"}}},"Social and community service managers":{"ageData":{"2015":{"total":"378","16to19":"2","20to24":"10","25to34":"93","35to44":"66","45to54":"89","55to64":"81","65+":"36","medianAge":"81"}},"title":"Social and community service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"378","women":"67.4","white":"12.1","black":"5.3","asian":"9.9"}},"wageData":{"2015":{"workers":"305","median":"1,022","maleWorkers":"105","maleMedian":"1,142","femaleWorkers":"200","femaleMedian":"965"}}},"Emergency management directors":{"ageData":{"2015":{"total":"10","16to19":"0","20to24":"0","25to34":"0","35to44":"3","45to54":"1","55to64":"4","65+":"1","medianAge":"4"}},"title":"Emergency management directors","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"9","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Managers, all other":{"ageData":{"2015":{"total":"4,315","16to19":"11","20to24":"87","25to34":"692","35to44":"1,027","45to54":"1,269","55to64":"908","65+":"320","medianAge":"908"}},"title":"Managers, all other","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2015":{"total":"4,315","women":"34.3","white":"7.2","black":"5.4","asian":"10.1"}},"wageData":{"2015":{"workers":"2,803","median":"1,408","maleWorkers":"1,717","maleMedian":"1,525","femaleWorkers":"1,085","femaleMedian":"1,213"}}},"Business and financial operations occupations":{"ageData":{"2015":{"total":"7,114","16to19":"25","20to24":"396","25to34":"1,788","35to44":"1,595","45to54":"1,636","55to64":"1,245","65+":"430","medianAge":"1,245"}},"title":"Business and financial operations occupations","depth":3,"parent":"Management, business, and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"7,114","women":"54.3","white":"10.3","black":"7.9","asian":"8.8"}},"wageData":{"2015":{"workers":"5,942","median":"1,137","maleWorkers":"2,686","maleMedian":"1,327","femaleWorkers":"3,256","femaleMedian":"1,004"}}},"Agents and business managers of artists, performers, and athletes":{"ageData":{"2015":{"total":"46","16to19":"1","20to24":"7","25to34":"14","35to44":"8","45to54":"9","55to64":"3","65+":"3","medianAge":"3"}},"title":"Agents and business managers of artists, performers, and athletes","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"46","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"27","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"14","femaleMedian":"-"}}},"Buyers and purchasing agents, farm products":{"ageData":{"2015":{"total":"10","16to19":"0","20to24":"0","25to34":"3","35to44":"0","45to54":"1","55to64":"4","65+":"2","medianAge":"4"}},"title":"Buyers and purchasing agents, farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"11","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Wholesale and retail buyers, except farm products":{"ageData":{"2015":{"total":"190","16to19":"2","20to24":"18","25to34":"45","35to44":"32","45to54":"37","55to64":"43","65+":"13","medianAge":"43"}},"title":"Wholesale and retail buyers, except farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"190","women":"52.7","white":"6.3","black":"7.5","asian":"11.0"}},"wageData":{"2015":{"workers":"142","median":"926","maleWorkers":"73","maleMedian":"886","femaleWorkers":"69","femaleMedian":"985"}}},"Purchasing agents, except wholesale, retail, and farm products":{"ageData":{"2015":{"total":"280","16to19":"0","20to24":"16","25to34":"51","35to44":"63","45to54":"71","55to64":"59","65+":"20","medianAge":"59"}},"title":"Purchasing agents, except wholesale, retail, and farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"280","women":"49.7","white":"6.7","black":"5.8","asian":"11.5"}},"wageData":{"2015":{"workers":"260","median":"1,009","maleWorkers":"136","maleMedian":"1,020","femaleWorkers":"124","femaleMedian":"986"}}},"Claims adjusters, appraisers, examiners, and investigators":{"ageData":{"2015":{"total":"321","16to19":"1","20to24":"11","25to34":"89","35to44":"80","45to54":"81","55to64":"48","65+":"11","medianAge":"48"}},"title":"Claims adjusters, appraisers, examiners, and investigators","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"321","women":"55.3","white":"14.6","black":"3.1","asian":"10.4"}},"wageData":{"2015":{"workers":"317","median":"963","maleWorkers":"141","maleMedian":"1,134","femaleWorkers":"176","femaleMedian":"824"}}},"Compliance officers":{"ageData":{"2015":{"total":"246","16to19":"2","20to24":"6","25to34":"45","35to44":"59","45to54":"63","55to64":"58","65+":"13","medianAge":"58"}},"title":"Compliance officers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"246","women":"49.0","white":"11.4","black":"4.2","asian":"9.5"}},"wageData":{"2015":{"workers":"235","median":"1,198","maleWorkers":"126","maleMedian":"1,375","femaleWorkers":"109","femaleMedian":"1,025"}}},"Cost estimators":{"ageData":{"2015":{"total":"112","16to19":"0","20to24":"5","25to34":"21","35to44":"23","45to54":"25","55to64":"28","65+":"10","medianAge":"28"}},"title":"Cost estimators","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"112","women":"17.8","white":"0.4","black":"3.0","asian":"8.1"}},"wageData":{"2015":{"workers":"95","median":"1,232","maleWorkers":"83","maleMedian":"1,264","femaleWorkers":"12","femaleMedian":"-"}}},"Human resources workers":{"ageData":{"2015":{"total":"662","16to19":"4","20to24":"42","25to34":"193","35to44":"160","45to54":"152","55to64":"88","65+":"23","medianAge":"88"}},"title":"Human resources workers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"662","women":"74.0","white":"15.4","black":"4.9","asian":"10.7"}},"wageData":{"2015":{"workers":"592","median":"1,002","maleWorkers":"151","maleMedian":"1,158","femaleWorkers":"441","femaleMedian":"984"}}},"Compensation, benefits, and job analysis specialists":{"ageData":{"2015":{"total":"68","16to19":"0","20to24":"3","25to34":"13","35to44":"14","45to54":"22","55to64":"15","65+":"2","medianAge":"15"}},"title":"Compensation, benefits, and job analysis specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"68","women":"73.0","white":"14.1","black":"6.9","asian":"8.4"}},"wageData":{"2015":{"workers":"63","median":"998","maleWorkers":"12","maleMedian":"-","femaleWorkers":"50","femaleMedian":"898"}}},"Training and development specialists":{"ageData":{"2015":{"total":"118","16to19":"1","20to24":"9","25to34":"29","35to44":"22","45to54":"30","55to64":"24","65+":"4","medianAge":"24"}},"title":"Training and development specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"118","women":"62.1","white":"13.7","black":"2.0","asian":"7.0"}},"wageData":{"2015":{"workers":"107","median":"990","maleWorkers":"42","maleMedian":"-","femaleWorkers":"65","femaleMedian":"1,037"}}},"Logisticians":{"ageData":{"2015":{"total":"117","16to19":"1","20to24":"14","25to34":"34","35to44":"28","45to54":"21","55to64":"18","65+":"2","medianAge":"18"}},"title":"Logisticians","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"117","women":"40.9","white":"14.4","black":"4.2","asian":"20.2"}},"wageData":{"2015":{"workers":"111","median":"1,028","maleWorkers":"66","maleMedian":"1,075","femaleWorkers":"44","femaleMedian":"-"}}},"Management analysts":{"ageData":{"2015":{"total":"848","16to19":"2","20to24":"27","25to34":"162","35to44":"187","45to54":"215","55to64":"168","65+":"86","medianAge":"168"}},"title":"Management analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"848","women":"39.7","white":"9.3","black":"10.1","asian":"5.9"}},"wageData":{"2015":{"workers":"529","median":"1,431","maleWorkers":"291","maleMedian":"1,519","femaleWorkers":"237","femaleMedian":"1,348"}}},"Meeting, convention, and event planners":{"ageData":{"2015":{"total":"159","16to19":"4","20to24":"28","25to34":"52","35to44":"26","45to54":"21","55to64":"22","65+":"5","medianAge":"22"}},"title":"Meeting, convention, and event planners","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"159","women":"78.6","white":"11.1","black":"5.6","asian":"12.3"}},"wageData":{"2015":{"workers":"117","median":"859","maleWorkers":"27","maleMedian":"-","femaleWorkers":"90","femaleMedian":"840"}}},"Fundraisers":{"ageData":{"2015":{"total":"77","16to19":"0","20to24":"8","25to34":"19","35to44":"11","45to54":"20","55to64":"13","65+":"4","medianAge":"13"}},"title":"Fundraisers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"77","women":"73.4","white":"7.2","black":"1.1","asian":"1.9"}},"wageData":{"2015":{"workers":"62","median":"1,136","maleWorkers":"14","maleMedian":"-","femaleWorkers":"48","femaleMedian":"-"}}},"Market research analysts and marketing specialists":{"ageData":{"2015":{"total":"261","16to19":"1","20to24":"27","25to34":"83","35to44":"56","45to54":"59","55to64":"25","65+":"9","medianAge":"25"}},"title":"Market research analysts and marketing specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"261","women":"58.8","white":"4.8","black":"6.9","asian":"9.7"}},"wageData":{"2015":{"workers":"203","median":"1,284","maleWorkers":"85","maleMedian":"1,411","femaleWorkers":"118","femaleMedian":"1,239"}}},"Business operations specialists, all other":{"ageData":{"2015":{"total":"213","16to19":"1","20to24":"10","25to34":"46","35to44":"53","45to54":"54","55to64":"42","65+":"7","medianAge":"42"}},"title":"Business operations specialists, all other","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"213","women":"56.7","white":"9.2","black":"7.0","asian":"9.0"}},"wageData":{"2015":{"workers":"186","median":"1,090","maleWorkers":"74","maleMedian":"1,461","femaleWorkers":"112","femaleMedian":"969"}}},"Accountants and auditors":{"ageData":{"2015":{"total":"1,732","16to19":"1","20to24":"79","25to34":"450","35to44":"388","45to54":"397","55to64":"302","65+":"115","medianAge":"302"}},"title":"Accountants and auditors","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"1,732","women":"59.7","white":"9.5","black":"11.3","asian":"7.4"}},"wageData":{"2015":{"workers":"1,464","median":"1,132","maleWorkers":"618","maleMedian":"1,345","femaleWorkers":"846","femaleMedian":"988"}}},"Appraisers and assessors of real estate":{"ageData":{"2015":{"total":"76","16to19":"0","20to24":"0","25to34":"6","35to44":"18","45to54":"21","55to64":"23","65+":"8","medianAge":"23"}},"title":"Appraisers and assessors of real estate","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"76","women":"39.3","white":"5.9","black":"0.9","asian":"3.9"}},"wageData":{"2015":{"workers":"42","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"21","femaleMedian":"-"}}},"Budget analysts":{"ageData":{"2015":{"total":"44","16to19":"0","20to24":"1","25to34":"9","35to44":"8","45to54":"10","55to64":"12","65+":"4","medianAge":"12"}},"title":"Budget analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"44","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"44","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Credit analysts":{"ageData":{"2015":{"total":"21","16to19":"0","20to24":"2","25to34":"5","35to44":"6","45to54":"4","55to64":"3","65+":"1","medianAge":"3"}},"title":"Credit analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"21","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"17","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Financial analysts":{"ageData":{"2015":{"total":"322","16to19":"1","20to24":"25","25to34":"114","35to44":"80","45to54":"54","55to64":"37","65+":"10","medianAge":"37"}},"title":"Financial analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"322","women":"43.0","white":"11.1","black":"16.2","asian":"6.4"}},"wageData":{"2015":{"workers":"295","median":"1,426","maleWorkers":"168","maleMedian":"1,680","femaleWorkers":"127","femaleMedian":"1,171"}}},"Personal financial advisors":{"ageData":{"2015":{"total":"498","16to19":"1","20to24":"23","25to34":"136","35to44":"119","45to54":"99","55to64":"87","65+":"34","medianAge":"87"}},"title":"Personal financial advisors","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"498","women":"37.9","white":"7.6","black":"7.4","asian":"9.4"}},"wageData":{"2015":{"workers":"407","median":"1,419","maleWorkers":"248","maleMedian":"1,738","femaleWorkers":"159","femaleMedian":"1,033"}}},"Insurance underwriters":{"ageData":{"2015":{"total":"107","16to19":"0","20to24":"4","25to34":"26","35to44":"22","45to54":"26","55to64":"27","65+":"2","medianAge":"27"}},"title":"Insurance underwriters","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"107","women":"58.6","white":"8.9","black":"5.8","asian":"5.3"}},"wageData":{"2015":{"workers":"106","median":"1,149","maleWorkers":"44","maleMedian":"-","femaleWorkers":"63","femaleMedian":"956"}}},"Financial examiners":{"ageData":{"2015":{"total":"15","16to19":"0","20to24":"1","25to34":"1","35to44":"4","45to54":"6","55to64":"2","65+":"1","medianAge":"2"}},"title":"Financial examiners","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"15","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"17","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Credit counselors and loan officers":{"ageData":{"2015":{"total":"332","16to19":"2","20to24":"14","25to34":"88","35to44":"85","45to54":"92","55to64":"43","65+":"9","medianAge":"43"}},"title":"Credit counselors and loan officers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"332","women":"54.6","white":"14.0","black":"6.0","asian":"10.6"}},"wageData":{"2015":{"workers":"313","median":"997","maleWorkers":"146","maleMedian":"1,186","femaleWorkers":"166","femaleMedian":"906"}}},"Tax examiners and collectors, and revenue agents":{"ageData":{"2015":{"total":"58","16to19":"0","20to24":"0","25to34":"16","35to44":"7","45to54":"15","55to64":"15","65+":"5","medianAge":"15"}},"title":"Tax examiners and collectors, and revenue agents","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"58","women":"65.5","white":"17.0","black":"9.4","asian":"13.5"}},"wageData":{"2015":{"workers":"59","median":"1,051","maleWorkers":"20","maleMedian":"-","femaleWorkers":"39","femaleMedian":"-"}}},"Tax preparers":{"ageData":{"2015":{"total":"109","16to19":"1","20to24":"9","25to34":"21","35to44":"19","45to54":"15","55to64":"23","65+":"20","medianAge":"23"}},"title":"Tax preparers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"109","women":"61.4","white":"14.4","black":"4.7","asian":"18.8"}},"wageData":{"2015":{"workers":"56","median":"892","maleWorkers":"19","maleMedian":"-","femaleWorkers":"37","femaleMedian":"-"}}},"Financial specialists, all other":{"ageData":{"2015":{"total":"71","16to19":"0","20to24":"7","25to34":"17","35to44":"17","45to54":"13","55to64":"11","65+":"6","medianAge":"11"}},"title":"Financial specialists, all other","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2015":{"total":"71","women":"54.6","white":"6.7","black":"8.5","asian":"7.6"}},"wageData":{"2015":{"workers":"66","median":"1,162","maleWorkers":"25","maleMedian":"-","femaleWorkers":"40","femaleMedian":"-"}}},"Professional and related occupations":{"ageData":{"2015":{"total":"33,852","16to19":"299","20to24":"2,143","25to34":"8,366","35to44":"7,986","45to54":"7,390","55to64":"5,695","65+":"1,973","medianAge":"5,695"}},"title":"Professional and related occupations","depth":2,"parent":"Management, professional, and related occupations","sexRaceEthnicityData":{"2015":{"total":"33,852","women":"57.2","white":"9.8","black":"8.7","asian":"8.8"}},"wageData":{"2015":{"workers":"26,423","median":"1,112","maleWorkers":"11,789","maleMedian":"1,343","femaleWorkers":"14,634","femaleMedian":"963"}}},"Computer and mathematical occupations":{"ageData":{"2015":{"total":"4,369","16to19":"20","20to24":"266","25to34":"1,234","35to44":"1,224","45to54":"951","55to64":"565","65+":"109","medianAge":"565"}},"title":"Computer and mathematical occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2015":{"total":"4,369","women":"24.7","white":"8.6","black":"19.9","asian":"6.8"}},"wageData":{"2015":{"workers":"4,009","median":"1,428","maleWorkers":"3,036","maleMedian":"1,503","femaleWorkers":"973","femaleMedian":"1,245"}}},"Computer and information research scientists":{"ageData":{"2015":{"total":"24","16to19":"0","20to24":"1","25to34":"7","35to44":"8","45to54":"4","55to64":"3","65+":"0","medianAge":"3"}},"title":"Computer and information research scientists","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2015":{"total":"24","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"28","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Computer systems analysts":{"ageData":{"2015":{"total":"552","16to19":"1","20to24":"26","25to34":"142","35to44":"160","45to54":"125","55to64":"82","65+":"17","medianAge":"82"}},"title":"Computer systems analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2015":{"total":"552","women":"34.2","white":"9.6","black":"19.6","asian":"6.9"}},"wageData":{"2015":{"workers":"499","median":"1,389","maleWorkers":"325","maleMedian":"1,462","femaleWorkers":"173","femaleMedian":"1,256"}}},"Information security analysts":{"ageData":{"2015":{"total":"70","16to19":"0","20to24":"2","25to34":"17","35to44":"19","45to54":"16","55to64":"12","65+":"4","medianAge":"12"}},"title":"Information security analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2015":{"total":"70","women":"19.7","white":"3.0","black":"3.4","asian":"5.2"}},"wageData":{"2015":{"workers":"67","median":"1,538","maleWorkers":"56","maleMedian":"1,562","femaleWorkers":"11","femaleMedian":"-"}}},"Computer programmers":{"ageData":{"2015":{"total":"480","16to19":"2","20to24":"28","25to34":"108","35to44":"127","45to54":"123","55to64":"77","65+":"15","medianAge":"77"}},"title":"Computer programmers","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2015":{"total":"480","women":"21.0","white":"7.0","black":"18.9","asian":"6.9"}},"wageData":{"2015":{"workers":"450","median":"1,438","maleWorkers":"357","maleMedian":"1,501","femaleWorkers":"93","femaleMedian":"1,302"}}},"Software developers, applications and systems software":{"ageData":{"2015":{"total":"1,353","16to19":"1","20to24":"74","25to34":"438","35to44":"387","45to54":"280","55to64":"148","65+":"25","medianAge":"148"}},"title":"Software developers, applications and systems software","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2015":{"total":"1,353","women":"17.9","white":"5.0","black":"33.8","asian":"5.4"}},"wageData":{"2015":{"workers":"1,287","median":"1,682","maleWorkers":"1,054","maleMedian":"1,751","femaleWorkers":"232","femaleMedian":"1,415"}}},"Web developers":{"ageData":{"2015":{"total":"204","16to19":"3","20to24":"29","25to34":"73","35to44":"57","45to54":"28","55to64":"11","65+":"2","medianAge":"11"}},"title":"Web developers","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2015":{"total":"204","women":"34.3","white":"9.1","black":"9.6","asian":"6.2"}},"wageData":{"2015":{"workers":"151","median":"1,165","maleWorkers":"98","maleMedian":"1,233","femaleWorkers":"53","femaleMedian":"1,026"}}},"Computer support specialists":{"ageData":{"2015":{"total":"475","16to19":"6","20to24":"40","25to34":"129","35to44":"122","45to54":"96","55to64":"71","65+":"12","medianAge":"71"}},"title":"Computer support specialists","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2015":{"total":"475","women":"26.4","white":"12.5","black":"9.6","asian":"8.4"}},"wageData":{"2015":{"workers":"396","median":"1,079","maleWorkers":"291","maleMedian":"1,135","femaleWorkers":"105","femaleMedian":"908"}}},"Database administrators":{"ageData":{"2015":{"total":"93","16to19":"0","20to24":"1","25to34":"17","35to44":"20","45to54":"31","55to64":"20","65+":"4","medianAge":"20"}},"title":"Database administrators","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2015":{"total":"93","women":"38.0","white":"6.2","black":"9.6","asian":"2.1"}},"wageData":{"2015":{"workers":"90","median":"1,536","maleWorkers":"58","maleMedian":"1,829","femaleWorkers":"32","femaleMedian":"-"}}},"Network and computer systems administrators":{"ageData":{"2015":{"total":"218","16to19":"0","20to24":"8","25to34":"64","35to44":"65","45to54":"55","55to64":"23","65+":"3","medianAge":"23"}},"title":"Network and computer systems administrators","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2015":{"total":"218","women":"15.9","white":"11.5","black":"10.4","asian":"9.4"}},"wageData":{"2015":{"workers":"208","median":"1,242","maleWorkers":"179","maleMedian":"1,266","femaleWorkers":"28","femaleMedian":"-"}}},"Computer network architects":{"ageData":{"2015":{"total":"114","16to19":"0","20to24":"1","25to34":"24","35to44":"45","45to54":"28","55to64":"10","65+":"6","medianAge":"10"}},"title":"Computer network architects","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2015":{"total":"114","women":"12.1","white":"8.9","black":"16.5","asian":"6.5"}},"wageData":{"2015":{"workers":"115","median":"1,552","maleWorkers":"100","maleMedian":"1,577","femaleWorkers":"15","femaleMedian":"-"}}},"Computer occupations, all other":{"ageData":{"2015":{"total":"547","16to19":"8","20to24":"42","25to34":"141","35to44":"148","45to54":"121","55to64":"77","65+":"12","medianAge":"77"}},"title":"Computer occupations, all other","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2015":{"total":"547","women":"24.3","white":"11.8","black":"12.0","asian":"9.5"}},"wageData":{"2015":{"workers":"490","median":"1,227","maleWorkers":"374","maleMedian":"1,252","femaleWorkers":"116","femaleMedian":"1,145"}}},"Actuaries":{"ageData":{"2015":{"total":"21","16to19":"0","20to24":"0","25to34":"9","35to44":"5","45to54":"4","55to64":"2","65+":"1","medianAge":"2"}},"title":"Actuaries","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2015":{"total":"21","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"24","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Mathematicians":{"ageData":{"2015":{"total":"6","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"5","55to64":"1","65+":"1","medianAge":"1"}},"title":"Mathematicians","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2015":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Operations research analysts":{"ageData":{"2015":{"total":"123","16to19":"0","20to24":"4","25to34":"34","35to44":"39","45to54":"23","55to64":"18","65+":"5","medianAge":"18"}},"title":"Operations research analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2015":{"total":"123","women":"50.7","white":"15.3","black":"10.2","asian":"9.3"}},"wageData":{"2015":{"workers":"122","median":"1,441","maleWorkers":"59","maleMedian":"1,574","femaleWorkers":"63","femaleMedian":"1,325"}}},"Statisticians":{"ageData":{"2015":{"total":"86","16to19":"0","20to24":"9","25to34":"30","35to44":"23","45to54":"13","55to64":"9","65+":"3","medianAge":"9"}},"title":"Statisticians","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2015":{"total":"86","women":"52.9","white":"12.4","black":"11.4","asian":"3.7"}},"wageData":{"2015":{"workers":"76","median":"1,275","maleWorkers":"37","maleMedian":"-","femaleWorkers":"39","femaleMedian":"-"}}},"Miscellaneous mathematical science occupations":{"ageData":{"2015":{"total":"4","16to19":"0","20to24":"1","25to34":"1","35to44":"0","45to54":"0","55to64":"0","65+":"1","medianAge":"0"}},"title":"Miscellaneous mathematical science occupations","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2015":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Architecture and engineering occupations":{"ageData":{"2015":{"total":"2,954","16to19":"15","20to24":"189","25to34":"719","35to44":"636","45to54":"708","55to64":"535","65+":"153","medianAge":"535"}},"title":"Architecture and engineering occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2015":{"total":"2,954","women":"15.1","white":"6.0","black":"11.4","asian":"8.2"}},"wageData":{"2015":{"workers":"2,656","median":"1,424","maleWorkers":"2,272","maleMedian":"1,452","femaleWorkers":"383","femaleMedian":"1,257"}}},"Architects, except naval":{"ageData":{"2015":{"total":"203","16to19":"2","20to24":"3","25to34":"51","35to44":"43","45to54":"51","55to64":"34","65+":"19","medianAge":"34"}},"title":"Architects, except naval","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2015":{"total":"203","women":"25.7","white":"5.8","black":"7.6","asian":"5.7"}},"wageData":{"2015":{"workers":"138","median":"1,441","maleWorkers":"106","maleMedian":"1,492","femaleWorkers":"31","femaleMedian":"-"}}},"Surveyors, cartographers, and photogrammetrists":{"ageData":{"2015":{"total":"38","16to19":"0","20to24":"2","25to34":"7","35to44":"10","45to54":"7","55to64":"10","65+":"2","medianAge":"10"}},"title":"Surveyors, cartographers, and photogrammetrists","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2015":{"total":"38","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"29","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Aerospace engineers":{"ageData":{"2015":{"total":"138","16to19":"0","20to24":"7","25to34":"33","35to44":"22","45to54":"35","55to64":"33","65+":"7","medianAge":"33"}},"title":"Aerospace engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2015":{"total":"138","women":"11.3","white":"2.1","black":"18.6","asian":"13.1"}},"wageData":{"2015":{"workers":"140","median":"1,662","maleWorkers":"122","maleMedian":"1,668","femaleWorkers":"18","femaleMedian":"-"}}},"Agricultural engineers":{"ageData":{"2015":{"total":"6","16to19":"0","20to24":"0","25to34":"2","35to44":"2","45to54":"0","55to64":"2","65+":"0","medianAge":"2"}},"title":"Agricultural engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2015":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Biomedical engineers":{"ageData":{"2015":{"total":"16","16to19":"0","20to24":"1","25to34":"6","35to44":"2","45to54":"4","55to64":"2","65+":"1","medianAge":"2"}},"title":"Biomedical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2015":{"total":"16","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"12","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Chemical engineers":{"ageData":{"2015":{"total":"84","16to19":"0","20to24":"7","25to34":"23","35to44":"19","45to54":"17","55to64":"14","65+":"4","medianAge":"14"}},"title":"Chemical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2015":{"total":"84","women":"14.7","white":"2.8","black":"16.3","asian":"6.5"}},"wageData":{"2015":{"workers":"79","median":"1,532","maleWorkers":"69","maleMedian":"1,583","femaleWorkers":"10","femaleMedian":"-"}}},"Civil engineers":{"ageData":{"2015":{"total":"360","16to19":"0","20to24":"26","25to34":"100","35to44":"64","45to54":"87","55to64":"56","65+":"27","medianAge":"56"}},"title":"Civil engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2015":{"total":"360","women":"12.6","white":"3.6","black":"10.2","asian":"9.0"}},"wageData":{"2015":{"workers":"316","median":"1,460","maleWorkers":"275","maleMedian":"1,474","femaleWorkers":"41","femaleMedian":"-"}}},"Computer hardware engineers":{"ageData":{"2015":{"total":"72","16to19":"0","20to24":"2","25to34":"11","35to44":"19","45to54":"23","55to64":"14","65+":"2","medianAge":"14"}},"title":"Computer hardware engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2015":{"total":"72","women":"12.8","white":"12.1","black":"23.4","asian":"11.0"}},"wageData":{"2015":{"workers":"72","median":"1,876","maleWorkers":"62","maleMedian":"1,871","femaleWorkers":"10","femaleMedian":"-"}}},"Electrical and electronics engineers":{"ageData":{"2015":{"total":"302","16to19":"1","20to24":"8","25to34":"61","35to44":"66","45to54":"88","55to64":"60","65+":"16","medianAge":"60"}},"title":"Electrical and electronics engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2015":{"total":"302","women":"12.5","white":"6.0","black":"14.3","asian":"7.2"}},"wageData":{"2015":{"workers":"283","median":"1,778","maleWorkers":"246","maleMedian":"1,819","femaleWorkers":"37","femaleMedian":"-"}}},"Environmental engineers":{"ageData":{"2015":{"total":"40","16to19":"1","20to24":"2","25to34":"14","35to44":"11","45to54":"5","55to64":"6","65+":"2","medianAge":"6"}},"title":"Environmental engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2015":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"35","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Industrial engineers, including health and safety":{"ageData":{"2015":{"total":"214","16to19":"0","20to24":"14","25to34":"58","35to44":"44","45to54":"48","55to64":"41","65+":"8","medianAge":"41"}},"title":"Industrial engineers, including health and safety","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2015":{"total":"214","women":"20.2","white":"4.2","black":"8.9","asian":"7.3"}},"wageData":{"2015":{"workers":"205","median":"1,447","maleWorkers":"168","maleMedian":"1,430","femaleWorkers":"37","femaleMedian":"-"}}},"Marine engineers and naval architects":{"ageData":{"2015":{"total":"11","16to19":"0","20to24":"0","25to34":"2","35to44":"4","45to54":"2","55to64":"2","65+":"1","medianAge":"2"}},"title":"Marine engineers and naval architects","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2015":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"9","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Materials engineers":{"ageData":{"2015":{"total":"40","16to19":"0","20to24":"3","25to34":"12","35to44":"7","45to54":"6","55to64":"8","65+":"2","medianAge":"8"}},"title":"Materials engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2015":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"36","median":"-","maleWorkers":"33","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Mechanical engineers":{"ageData":{"2015":{"total":"323","16to19":"0","20to24":"22","25to34":"96","35to44":"75","45to54":"74","55to64":"44","65+":"12","medianAge":"44"}},"title":"Mechanical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2015":{"total":"323","women":"8.3","white":"6.2","black":"11.2","asian":"5.6"}},"wageData":{"2015":{"workers":"316","median":"1,534","maleWorkers":"294","maleMedian":"1,550","femaleWorkers":"23","femaleMedian":"-"}}},"Mining and geological engineers, including mining safety engineers":{"ageData":{"2015":{"total":"15","16to19":"0","20to24":"1","25to34":"7","35to44":"2","45to54":"2","55to64":"3","65+":"1","medianAge":"3"}},"title":"Mining and geological engineers, including mining safety engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2015":{"total":"15","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"15","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Nuclear engineers":{"ageData":{"2015":{"total":"6","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Nuclear engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2015":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"5","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Petroleum engineers":{"ageData":{"2015":{"total":"44","16to19":"0","20to24":"4","25to34":"13","35to44":"12","45to54":"7","55to64":"9","65+":"1","medianAge":"9"}},"title":"Petroleum engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2015":{"total":"44","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"43","median":"-","maleWorkers":"39","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Engineers, all other":{"ageData":{"2015":{"total":"440","16to19":"1","20to24":"20","25to34":"95","35to44":"101","45to54":"108","55to64":"91","65+":"23","medianAge":"91"}},"title":"Engineers, all other","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2015":{"total":"440","women":"13.6","white":"7.6","black":"14.7","asian":"5.9"}},"wageData":{"2015":{"workers":"393","median":"1,527","maleWorkers":"339","maleMedian":"1,537","femaleWorkers":"54","femaleMedian":"1,448"}}},"Drafters":{"ageData":{"2015":{"total":"133","16to19":"1","20to24":"12","25to34":"37","35to44":"27","45to54":"31","55to64":"19","65+":"6","medianAge":"19"}},"title":"Drafters","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2015":{"total":"133","women":"21.2","white":"3.7","black":"1.1","asian":"15.0"}},"wageData":{"2015":{"workers":"114","median":"977","maleWorkers":"91","maleMedian":"977","femaleWorkers":"23","femaleMedian":"-"}}},"Engineering technicians, except drafters":{"ageData":{"2015":{"total":"403","16to19":"8","20to24":"49","25to34":"72","35to44":"91","45to54":"97","55to64":"75","65+":"11","medianAge":"75"}},"title":"Engineering technicians, except drafters","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2015":{"total":"403","women":"20.3","white":"10.0","black":"10.7","asian":"9.7"}},"wageData":{"2015":{"workers":"352","median":"963","maleWorkers":"284","maleMedian":"984","femaleWorkers":"68","femaleMedian":"827"}}},"Surveying and mapping technicians":{"ageData":{"2015":{"total":"65","16to19":"1","20to24":"6","25to34":"17","35to44":"13","45to54":"13","55to64":"8","65+":"7","medianAge":"8"}},"title":"Surveying and mapping technicians","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2015":{"total":"65","women":"5.2","white":"3.5","black":"4.1","asian":"7.2"}},"wageData":{"2015":{"workers":"58","median":"1,012","maleWorkers":"54","maleMedian":"1,031","femaleWorkers":"4","femaleMedian":"-"}}},"Life, physical, and social science occupations":{"ageData":{"2015":{"total":"1,404","16to19":"11","20to24":"118","25to34":"358","35to44":"331","45to54":"267","55to64":"226","65+":"94","medianAge":"226"}},"title":"Life, physical, and social science occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2015":{"total":"1,404","women":"46.6","white":"6.1","black":"14.5","asian":"7.0"}},"wageData":{"2015":{"workers":"1,176","median":"1,206","maleWorkers":"662","maleMedian":"1,379","femaleWorkers":"514","femaleMedian":"1,067"}}},"Agricultural and food scientists":{"ageData":{"2015":{"total":"25","16to19":"0","20to24":"2","25to34":"7","35to44":"4","45to54":"7","55to64":"3","65+":"1","medianAge":"3"}},"title":"Agricultural and food scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2015":{"total":"25","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"22","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Biological scientists":{"ageData":{"2015":{"total":"86","16to19":"0","20to24":"9","25to34":"19","35to44":"22","45to54":"13","55to64":"20","65+":"3","medianAge":"20"}},"title":"Biological scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2015":{"total":"86","women":"42.6","white":"6.6","black":"10.8","asian":"8.2"}},"wageData":{"2015":{"workers":"74","median":"1,233","maleWorkers":"46","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Conservation scientists and foresters":{"ageData":{"2015":{"total":"25","16to19":"0","20to24":"1","25to34":"5","35to44":"7","45to54":"5","55to64":"5","65+":"1","medianAge":"5"}},"title":"Conservation scientists and foresters","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2015":{"total":"25","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"23","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Medical scientists":{"ageData":{"2015":{"total":"157","16to19":"0","20to24":"13","25to34":"54","35to44":"43","45to54":"27","55to64":"12","65+":"8","medianAge":"12"}},"title":"Medical scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2015":{"total":"157","women":"54.9","white":"5.9","black":"35.1","asian":"5.4"}},"wageData":{"2015":{"workers":"151","median":"1,250","maleWorkers":"68","maleMedian":"1,362","femaleWorkers":"84","femaleMedian":"1,082"}}},"Life scientists, all other":{"ageData":{"2015":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Life scientists, all other","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2015":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Astronomers and physicists":{"ageData":{"2015":{"total":"19","16to19":"0","20to24":"1","25to34":"6","35to44":"2","45to54":"2","55to64":"4","65+":"4","medianAge":"4"}},"title":"Astronomers and physicists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2015":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"14","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Atmospheric and space scientists":{"ageData":{"2015":{"total":"12","16to19":"0","20to24":"0","25to34":"1","35to44":"2","45to54":"3","55to64":"4","65+":"1","medianAge":"4"}},"title":"Atmospheric and space scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2015":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"8","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Chemists and materials scientists":{"ageData":{"2015":{"total":"99","16to19":"0","20to24":"3","25to34":"23","35to44":"25","45to54":"19","55to64":"19","65+":"9","medianAge":"19"}},"title":"Chemists and materials scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2015":{"total":"99","women":"36.1","white":"8.4","black":"13.5","asian":"5.9"}},"wageData":{"2015":{"workers":"93","median":"1,432","maleWorkers":"61","maleMedian":"1,496","femaleWorkers":"33","femaleMedian":"-"}}},"Environmental scientists and geoscientists":{"ageData":{"2015":{"total":"92","16to19":"0","20to24":"4","25to34":"23","35to44":"17","45to54":"18","55to64":"23","65+":"7","medianAge":"23"}},"title":"Environmental scientists and geoscientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2015":{"total":"92","women":"27.5","white":"1.3","black":"6.2","asian":"7.3"}},"wageData":{"2015":{"workers":"90","median":"1,423","maleWorkers":"65","maleMedian":"1,740","femaleWorkers":"25","femaleMedian":"-"}}},"Physical scientists, all other":{"ageData":{"2015":{"total":"232","16to19":"0","20to24":"18","25to34":"62","35to44":"52","45to54":"51","55to64":"35","65+":"14","medianAge":"35"}},"title":"Physical scientists, all other","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2015":{"total":"232","women":"41.4","white":"4.4","black":"23.9","asian":"6.2"}},"wageData":{"2015":{"workers":"189","median":"1,553","maleWorkers":"121","maleMedian":"1,770","femaleWorkers":"68","femaleMedian":"1,170"}}},"Economists":{"ageData":{"2015":{"total":"34","16to19":"0","20to24":"1","25to34":"10","35to44":"11","45to54":"6","55to64":"5","65+":"2","medianAge":"5"}},"title":"Economists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2015":{"total":"34","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"29","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Survey researchers":{"ageData":{"2015":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Survey researchers","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2015":{"total":"0","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Psychologists":{"ageData":{"2015":{"total":"193","16to19":"0","20to24":"0","25to34":"42","35to44":"53","45to54":"33","55to64":"44","65+":"22","medianAge":"44"}},"title":"Psychologists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2015":{"total":"193","women":"70.3","white":"4.1","black":"2.5","asian":"5.8"}},"wageData":{"2015":{"workers":"114","median":"1,367","maleWorkers":"31","maleMedian":"-","femaleWorkers":"83","femaleMedian":"1,189"}}},"Sociologists":{"ageData":{"2015":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"1","medianAge":"0"}},"title":"Sociologists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2015":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Urban and regional planners":{"ageData":{"2015":{"total":"25","16to19":"0","20to24":"2","25to34":"4","35to44":"7","45to54":"3","55to64":"7","65+":"2","medianAge":"7"}},"title":"Urban and regional planners","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2015":{"total":"25","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"22","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Miscellaneous social scientists and related workers":{"ageData":{"2015":{"total":"45","16to19":"0","20to24":"4","25to34":"9","35to44":"10","45to54":"12","55to64":"6","65+":"4","medianAge":"6"}},"title":"Miscellaneous social scientists and related workers","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2015":{"total":"45","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"37","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"19","femaleMedian":"-"}}},"Agricultural and food science technicians":{"ageData":{"2015":{"total":"25","16to19":"0","20to24":"2","25to34":"9","35to44":"6","45to54":"3","55to64":"5","65+":"1","medianAge":"5"}},"title":"Agricultural and food science technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2015":{"total":"25","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"28","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Biological technicians":{"ageData":{"2015":{"total":"18","16to19":"0","20to24":"1","25to34":"7","35to44":"5","45to54":"4","55to64":"0","65+":"1","medianAge":"0"}},"title":"Biological technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2015":{"total":"18","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"20","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Chemical technicians":{"ageData":{"2015":{"total":"82","16to19":"0","20to24":"11","25to34":"18","35to44":"26","45to54":"14","55to64":"10","65+":"3","medianAge":"10"}},"title":"Chemical technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2015":{"total":"82","women":"40.0","white":"11.7","black":"7.5","asian":"9.7"}},"wageData":{"2015":{"workers":"75","median":"944","maleWorkers":"43","maleMedian":"-","femaleWorkers":"32","femaleMedian":"-"}}},"Geological and petroleum technicians":{"ageData":{"2015":{"total":"21","16to19":"0","20to24":"0","25to34":"4","35to44":"2","45to54":"7","55to64":"6","65+":"2","medianAge":"6"}},"title":"Geological and petroleum technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2015":{"total":"21","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"22","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Nuclear technicians":{"ageData":{"2015":{"total":"3","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Nuclear technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2015":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Social science research assistants":{"ageData":{"2015":{"total":"4","16to19":"0","20to24":"1","25to34":"1","35to44":"0","45to54":"1","55to64":"0","65+":"1","medianAge":"0"}},"title":"Social science research assistants","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2015":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"3","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Miscellaneous life, physical, and social science technicians":{"ageData":{"2015":{"total":"203","16to19":"9","20to24":"44","25to34":"53","35to44":"34","45to54":"36","55to64":"18","65+":"9","medianAge":"18"}},"title":"Miscellaneous life, physical, and social science technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2015":{"total":"203","women":"53.9","white":"7.7","black":"12.5","asian":"6.6"}},"wageData":{"2015":{"workers":"157","median":"846","maleWorkers":"79","maleMedian":"1,001","femaleWorkers":"78","femaleMedian":"780"}}},"Community and social service occupations":{"ageData":{"2015":{"total":"2,596","16to19":"16","20to24":"134","25to34":"595","35to44":"569","45to54":"599","55to64":"466","65+":"216","medianAge":"466"}},"title":"Community and social service occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2015":{"total":"2,596","women":"65.3","white":"17.4","black":"3.6","asian":"10.7"}},"wageData":{"2015":{"workers":"2,143","median":"889","maleWorkers":"776","maleMedian":"973","femaleWorkers":"1,367","femaleMedian":"845"}}},"Counselors":{"ageData":{"2015":{"total":"802","16to19":"8","20to24":"55","25to34":"195","35to44":"195","45to54":"158","55to64":"144","65+":"47","medianAge":"144"}},"title":"Counselors","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2015":{"total":"802","women":"71.4","white":"18.4","black":"2.5","asian":"9.5"}},"wageData":{"2015":{"workers":"635","median":"904","maleWorkers":"184","maleMedian":"908","femaleWorkers":"451","femaleMedian":"902"}}},"Social workers":{"ageData":{"2015":{"total":"765","16to19":"2","20to24":"38","25to34":"200","35to44":"190","45to54":"183","55to64":"107","65+":"45","medianAge":"107"}},"title":"Social workers","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2015":{"total":"765","women":"83.8","white":"22.0","black":"3.0","asian":"12.5"}},"wageData":{"2015":{"workers":"677","median":"877","maleWorkers":"127","maleMedian":"943","femaleWorkers":"549","femaleMedian":"862"}}},"Probation officers and correctional treatment specialists":{"ageData":{"2015":{"total":"99","16to19":"1","20to24":"2","25to34":"22","35to44":"29","45to54":"29","55to64":"12","65+":"4","medianAge":"12"}},"title":"Probation officers and correctional treatment specialists","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2015":{"total":"99","women":"55.4","white":"23.3","black":"4.0","asian":"12.1"}},"wageData":{"2015":{"workers":"85","median":"967","maleWorkers":"42","maleMedian":"-","femaleWorkers":"43","femaleMedian":"-"}}},"Social and human service assistants":{"ageData":{"2015":{"total":"194","16to19":"2","20to24":"12","25to34":"53","35to44":"38","45to54":"48","55to64":"33","65+":"9","medianAge":"33"}},"title":"Social and human service assistants","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2015":{"total":"194","women":"82.6","white":"21.2","black":"2.2","asian":"16.0"}},"wageData":{"2015":{"workers":"173","median":"676","maleWorkers":"23","maleMedian":"-","femaleWorkers":"149","femaleMedian":"673"}}},"Miscellaneous community and social service specialists, including health educators and community health workers":{"ageData":{"2015":{"total":"117","16to19":"0","20to24":"8","25to34":"37","35to44":"22","45to54":"25","55to64":"19","65+":"5","medianAge":"19"}},"title":"Miscellaneous community and social service specialists, including health educators and community health workers","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2015":{"total":"117","women":"70.8","white":"14.2","black":"5.2","asian":"16.5"}},"wageData":{"2015":{"workers":"92","median":"831","maleWorkers":"29","maleMedian":"-","femaleWorkers":"63","femaleMedian":"728"}}},"Clergy":{"ageData":{"2015":{"total":"469","16to19":"0","20to24":"10","25to34":"58","35to44":"74","45to54":"125","55to64":"115","65+":"87","medianAge":"115"}},"title":"Clergy","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2015":{"total":"469","women":"20.6","white":"10.2","black":"6.6","asian":"7.3"}},"wageData":{"2015":{"workers":"376","median":"1,002","maleWorkers":"316","maleMedian":"1,021","femaleWorkers":"60","femaleMedian":"924"}}},"Directors, religious activities and education":{"ageData":{"2015":{"total":"78","16to19":"0","20to24":"6","25to34":"21","35to44":"12","45to54":"15","55to64":"17","65+":"6","medianAge":"17"}},"title":"Directors, religious activities and education","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2015":{"total":"78","women":"57.8","white":"7.5","black":"1.1","asian":"5.1"}},"wageData":{"2015":{"workers":"62","median":"929","maleWorkers":"31","maleMedian":"-","femaleWorkers":"31","femaleMedian":"-"}}},"Religious workers, all other":{"ageData":{"2015":{"total":"73","16to19":"3","20to24":"3","25to34":"9","35to44":"10","45to54":"16","55to64":"20","65+":"12","medianAge":"20"}},"title":"Religious workers, all other","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2015":{"total":"73","women":"59.0","white":"2.3","black":"5.2","asian":"6.2"}},"wageData":{"2015":{"workers":"44","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"21","femaleMedian":"-"}}},"Legal occupations":{"ageData":{"2015":{"total":"1,803","16to19":"4","20to24":"38","25to34":"402","35to44":"427","45to54":"391","55to64":"347","65+":"193","medianAge":"347"}},"title":"Legal occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2015":{"total":"1,803","women":"50.2","white":"6.8","black":"4.5","asian":"7.5"}},"wageData":{"2015":{"workers":"1,346","median":"1,391","maleWorkers":"624","maleMedian":"1,877","femaleWorkers":"722","femaleMedian":"1,135"}}},"Lawyers":{"ageData":{"2015":{"total":"1,160","16to19":"0","20to24":"4","25to34":"246","35to44":"290","45to54":"256","55to64":"222","65+":"143","medianAge":"222"}},"title":"Lawyers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2015":{"total":"1,160","women":"34.5","white":"4.6","black":"4.8","asian":"5.1"}},"wageData":{"2015":{"workers":"803","median":"1,886","maleWorkers":"503","maleMedian":"1,914","femaleWorkers":"300","femaleMedian":"1,717"}}},"Judicial law clerks":{"ageData":{"2015":{"total":"13","16to19":"0","20to24":"0","25to34":"10","35to44":"1","45to54":"1","55to64":"0","65+":"1","medianAge":"0"}},"title":"Judicial law clerks","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2015":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"11","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Judges, magistrates, and other judicial workers":{"ageData":{"2015":{"total":"58","16to19":"0","20to24":"0","25to34":"7","35to44":"6","45to54":"13","55to64":"18","65+":"13","medianAge":"18"}},"title":"Judges, magistrates, and other judicial workers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2015":{"total":"58","women":"39.0","white":"11.8","black":"6.2","asian":"6.4"}},"wageData":{"2015":{"workers":"54","median":"1,952","maleWorkers":"33","maleMedian":"-","femaleWorkers":"20","femaleMedian":"-"}}},"Paralegals and legal assistants":{"ageData":{"2015":{"total":"400","16to19":"4","20to24":"27","25to34":"97","35to44":"93","45to54":"89","55to64":"68","65+":"24","medianAge":"68"}},"title":"Paralegals and legal assistants","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2015":{"total":"400","women":"85.4","white":"10.3","black":"3.9","asian":"13.4"}},"wageData":{"2015":{"workers":"341","median":"927","maleWorkers":"47","maleMedian":"-","femaleWorkers":"294","femaleMedian":"910"}}},"Miscellaneous legal support workers":{"ageData":{"2015":{"total":"172","16to19":"1","20to24":"7","25to34":"42","35to44":"38","45to54":"32","55to64":"39","65+":"13","medianAge":"39"}},"title":"Miscellaneous legal support workers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2015":{"total":"172","women":"76.4","white":"10.9","black":"4.1","asian":"10.8"}},"wageData":{"2015":{"workers":"136","median":"770","maleWorkers":"40","maleMedian":"-","femaleWorkers":"97","femaleMedian":"746"}}},"Education, training, and library occupations":{"ageData":{"2015":{"total":"8,908","16to19":"120","20to24":"664","25to34":"1,981","35to44":"2,074","45to54":"1,965","55to64":"1,545","65+":"559","medianAge":"1,545"}},"title":"Education, training, and library occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2015":{"total":"8,908","women":"73.4","white":"10.4","black":"4.5","asian":"9.9"}},"wageData":{"2015":{"workers":"6,884","median":"956","maleWorkers":"1,849","maleMedian":"1,144","femaleWorkers":"5,034","femaleMedian":"907"}}},"Postsecondary teachers":{"ageData":{"2015":{"total":"1,341","16to19":"7","20to24":"101","25to34":"289","35to44":"267","45to54":"259","55to64":"262","65+":"155","medianAge":"262"}},"title":"Postsecondary teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2015":{"total":"1,341","women":"46.5","white":"5.1","black":"12.6","asian":"7.6"}},"wageData":{"2015":{"workers":"917","median":"1,258","maleWorkers":"516","maleMedian":"1,405","femaleWorkers":"401","femaleMedian":"1,144"}}},"Preschool and kindergarten teachers":{"ageData":{"2015":{"total":"695","16to19":"12","20to24":"78","25to34":"201","35to44":"160","45to54":"134","55to64":"85","65+":"25","medianAge":"85"}},"title":"Preschool and kindergarten teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2015":{"total":"695","women":"96.8","white":"16.1","black":"3.4","asian":"12.2"}},"wageData":{"2015":{"workers":"517","median":"616","maleWorkers":"11","maleMedian":"-","femaleWorkers":"506","femaleMedian":"618"}}},"Elementary and middle school teachers":{"ageData":{"2015":{"total":"3,152","16to19":"11","20to24":"147","25to34":"761","35to44":"838","45to54":"744","55to64":"504","65+":"146","medianAge":"504"}},"title":"Elementary and middle school teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2015":{"total":"3,152","women":"80.7","white":"10.8","black":"2.5","asian":"8.5"}},"wageData":{"2015":{"workers":"2,806","median":"974","maleWorkers":"543","maleMedian":"1,077","femaleWorkers":"2,262","femaleMedian":"957"}}},"Secondary school teachers":{"ageData":{"2015":{"total":"1,144","16to19":"6","20to24":"59","25to34":"262","35to44":"291","45to54":"260","55to64":"210","65+":"55","medianAge":"210"}},"title":"Secondary school teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2015":{"total":"1,144","women":"59.2","white":"8.7","black":"2.5","asian":"7.8"}},"wageData":{"2015":{"workers":"1,048","median":"1,066","maleWorkers":"438","maleMedian":"1,149","femaleWorkers":"610","femaleMedian":"1,006"}}},"Special education teachers":{"ageData":{"2015":{"total":"330","16to19":"1","20to24":"9","25to34":"73","35to44":"87","45to54":"82","55to64":"64","65+":"14","medianAge":"64"}},"title":"Special education teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2015":{"total":"330","women":"87.5","white":"9.5","black":"2.3","asian":"7.5"}},"wageData":{"2015":{"workers":"297","median":"987","maleWorkers":"38","maleMedian":"-","femaleWorkers":"258","femaleMedian":"990"}}},"Other teachers and instructors":{"ageData":{"2015":{"total":"876","16to19":"52","20to24":"133","25to34":"170","35to44":"153","45to54":"151","55to64":"137","65+":"81","medianAge":"137"}},"title":"Other teachers and instructors","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2015":{"total":"876","women":"62.3","white":"12.1","black":"6.1","asian":"11.2"}},"wageData":{"2015":{"workers":"378","median":"896","maleWorkers":"179","maleMedian":"1,024","femaleWorkers":"199","femaleMedian":"817"}}},"Archivists, curators, and museum technicians":{"ageData":{"2015":{"total":"53","16to19":"0","20to24":"5","25to34":"11","35to44":"14","45to54":"10","55to64":"12","65+":"2","medianAge":"12"}},"title":"Archivists, curators, and museum technicians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2015":{"total":"53","women":"60.1","white":"2.7","black":"0.0","asian":"8.5"}},"wageData":{"2015":{"workers":"38","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"20","femaleMedian":"-"}}},"Librarians":{"ageData":{"2015":{"total":"166","16to19":"1","20to24":"4","25to34":"25","35to44":"35","45to54":"44","55to64":"39","65+":"18","medianAge":"39"}},"title":"Librarians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2015":{"total":"166","women":"83.0","white":"8.5","black":"2.8","asian":"4.8"}},"wageData":{"2015":{"workers":"130","median":"991","maleWorkers":"27","maleMedian":"-","femaleWorkers":"102","femaleMedian":"966"}}},"Library technicians":{"ageData":{"2015":{"total":"31","16to19":"6","20to24":"3","25to34":"5","35to44":"5","45to54":"4","55to64":"5","65+":"2","medianAge":"5"}},"title":"Library technicians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2015":{"total":"31","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"18","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"15","femaleMedian":"-"}}},"Teacher assistants":{"ageData":{"2015":{"total":"960","16to19":"21","20to24":"113","25to34":"154","35to44":"183","45to54":"241","55to64":"202","65+":"46","medianAge":"202"}},"title":"Teacher assistants","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2015":{"total":"960","women":"91.4","white":"13.8","black":"3.0","asian":"18.7"}},"wageData":{"2015":{"workers":"614","median":"541","maleWorkers":"48","maleMedian":"-","femaleWorkers":"565","femaleMedian":"530"}}},"Other education, training, and library workers":{"ageData":{"2015":{"total":"161","16to19":"3","20to24":"13","25to34":"30","35to44":"40","45to54":"34","55to64":"25","65+":"15","medianAge":"25"}},"title":"Other education, training, and library workers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2015":{"total":"161","women":"73.7","white":"12.5","black":"4.1","asian":"12.0"}},"wageData":{"2015":{"workers":"123","median":"1,001","maleWorkers":"28","maleMedian":"-","femaleWorkers":"95","femaleMedian":"1,031"}}},"Arts, design, entertainment, sports, and media occupations":{"ageData":{"2015":{"total":"3,051","16to19":"79","20to24":"248","25to34":"783","35to44":"662","45to54":"592","55to64":"464","65+":"223","medianAge":"464"}},"title":"Arts, design, entertainment, sports, and media occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2015":{"total":"3,051","women":"47.6","white":"6.3","black":"5.2","asian":"10.8"}},"wageData":{"2015":{"workers":"1,643","median":"1,001","maleWorkers":"930","maleMedian":"1,088","femaleWorkers":"713","femaleMedian":"942"}}},"Artists and related workers":{"ageData":{"2015":{"total":"222","16to19":"0","20to24":"10","25to34":"39","35to44":"41","45to54":"60","55to64":"50","65+":"23","medianAge":"50"}},"title":"Artists and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2015":{"total":"222","women":"56.9","white":"2.7","black":"4.1","asian":"9.4"}},"wageData":{"2015":{"workers":"58","median":"1,166","maleWorkers":"39","maleMedian":"-","femaleWorkers":"20","femaleMedian":"-"}}},"Designers":{"ageData":{"2015":{"total":"899","16to19":"7","20to24":"63","25to34":"257","35to44":"197","45to54":"186","55to64":"127","65+":"62","medianAge":"127"}},"title":"Designers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2015":{"total":"899","women":"54.9","white":"3.5","black":"6.9","asian":"12.3"}},"wageData":{"2015":{"workers":"593","median":"993","maleWorkers":"301","maleMedian":"1,099","femaleWorkers":"291","femaleMedian":"918"}}},"Actors":{"ageData":{"2015":{"total":"49","16to19":"2","20to24":"5","25to34":"14","35to44":"10","45to54":"8","55to64":"7","65+":"4","medianAge":"7"}},"title":"Actors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2015":{"total":"49","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"12","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Producers and directors":{"ageData":{"2015":{"total":"169","16to19":"1","20to24":"9","25to34":"55","35to44":"38","45to54":"37","55to64":"25","65+":"4","medianAge":"25"}},"title":"Producers and directors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2015":{"total":"169","women":"36.9","white":"5.3","black":"5.6","asian":"6.8"}},"wageData":{"2015":{"workers":"120","median":"1,270","maleWorkers":"67","maleMedian":"1,340","femaleWorkers":"53","femaleMedian":"1,234"}}},"Athletes, coaches, umpires, and related workers":{"ageData":{"2015":{"total":"296","16to19":"52","20to24":"50","25to34":"68","35to44":"57","45to54":"32","55to64":"28","65+":"10","medianAge":"28"}},"title":"Athletes, coaches, umpires, and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2015":{"total":"296","women":"36.1","white":"11.1","black":"2.7","asian":"10.1"}},"wageData":{"2015":{"workers":"147","median":"780","maleWorkers":"108","maleMedian":"818","femaleWorkers":"39","femaleMedian":"-"}}},"Dancers and choreographers":{"ageData":{"2015":{"total":"19","16to19":"1","20to24":"5","25to34":"7","35to44":"3","45to54":"2","55to64":"0","65+":"1","medianAge":"0"}},"title":"Dancers and choreographers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2015":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"11","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Musicians, singers, and related workers":{"ageData":{"2015":{"total":"202","16to19":"3","20to24":"12","25to34":"42","35to44":"41","45to54":"28","55to64":"46","65+":"28","medianAge":"46"}},"title":"Musicians, singers, and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2015":{"total":"202","women":"34.5","white":"10.5","black":"2.6","asian":"8.8"}},"wageData":{"2015":{"workers":"42","median":"-","maleWorkers":"33","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Entertainers and performers, sports and related workers, all other":{"ageData":{"2015":{"total":"41","16to19":"2","20to24":"7","25to34":"12","35to44":"9","45to54":"5","55to64":"2","65+":"4","medianAge":"2"}},"title":"Entertainers and performers, sports and related workers, all other","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2015":{"total":"41","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"14","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Announcers":{"ageData":{"2015":{"total":"55","16to19":"1","20to24":"4","25to34":"11","35to44":"15","45to54":"10","55to64":"12","65+":"2","medianAge":"12"}},"title":"Announcers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2015":{"total":"55","women":"16.5","white":"14.8","black":"5.6","asian":"19.1"}},"wageData":{"2015":{"workers":"25","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"News analysts, reporters and correspondents":{"ageData":{"2015":{"total":"68","16to19":"0","20to24":"2","25to34":"20","35to44":"14","45to54":"16","55to64":"9","65+":"6","medianAge":"9"}},"title":"News analysts, reporters and correspondents","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2015":{"total":"68","women":"46.7","white":"6.5","black":"1.7","asian":"13.7"}},"wageData":{"2015":{"workers":"56","median":"1,218","maleWorkers":"29","maleMedian":"-","femaleWorkers":"27","femaleMedian":"-"}}},"Public relations specialists":{"ageData":{"2015":{"total":"147","16to19":"0","20to24":"10","25to34":"51","35to44":"31","45to54":"27","55to64":"21","65+":"8","medianAge":"21"}},"title":"Public relations specialists","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2015":{"total":"147","women":"61.3","white":"9.8","black":"4.8","asian":"7.7"}},"wageData":{"2015":{"workers":"120","median":"1,211","maleWorkers":"49","maleMedian":"-","femaleWorkers":"71","femaleMedian":"971"}}},"Editors":{"ageData":{"2015":{"total":"160","16to19":"2","20to24":"9","25to34":"36","35to44":"47","45to54":"26","55to64":"27","65+":"13","medianAge":"27"}},"title":"Editors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2015":{"total":"160","women":"51.0","white":"2.0","black":"7.7","asian":"7.9"}},"wageData":{"2015":{"workers":"108","median":"1,148","maleWorkers":"58","maleMedian":"1,205","femaleWorkers":"50","femaleMedian":"1,125"}}},"Technical writers":{"ageData":{"2015":{"total":"68","16to19":"0","20to24":"2","25to34":"11","35to44":"16","45to54":"17","55to64":"16","65+":"5","medianAge":"16"}},"title":"Technical writers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2015":{"total":"68","women":"58.2","white":"9.2","black":"1.2","asian":"6.0"}},"wageData":{"2015":{"workers":"52","median":"1,158","maleWorkers":"22","maleMedian":"-","femaleWorkers":"30","femaleMedian":"-"}}},"Writers and authors":{"ageData":{"2015":{"total":"208","16to19":"1","20to24":"12","25to34":"34","35to44":"41","45to54":"55","55to64":"36","65+":"28","medianAge":"36"}},"title":"Writers and authors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2015":{"total":"208","women":"59.4","white":"4.9","black":"3.5","asian":"5.3"}},"wageData":{"2015":{"workers":"79","median":"1,232","maleWorkers":"36","maleMedian":"-","femaleWorkers":"42","femaleMedian":"-"}}},"Miscellaneous media and communication workers":{"ageData":{"2015":{"total":"84","16to19":"0","20to24":"7","25to34":"16","35to44":"19","45to54":"21","55to64":"14","65+":"7","medianAge":"14"}},"title":"Miscellaneous media and communication workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2015":{"total":"84","women":"67.9","white":"5.8","black":"13.4","asian":"35.8"}},"wageData":{"2015":{"workers":"46","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"30","femaleMedian":"-"}}},"Broadcast and sound engineering technicians and radio operators":{"ageData":{"2015":{"total":"119","16to19":"3","20to24":"11","25to34":"31","35to44":"26","45to54":"30","55to64":"14","65+":"4","medianAge":"14"}},"title":"Broadcast and sound engineering technicians and radio operators","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2015":{"total":"119","women":"9.2","white":"11.3","black":"0.8","asian":"14.5"}},"wageData":{"2015":{"workers":"83","median":"954","maleWorkers":"77","maleMedian":"937","femaleWorkers":"7","femaleMedian":"-"}}},"Photographers":{"ageData":{"2015":{"total":"180","16to19":"4","20to24":"18","25to34":"57","35to44":"45","45to54":"23","55to64":"23","65+":"11","medianAge":"23"}},"title":"Photographers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2015":{"total":"180","women":"49.9","white":"3.3","black":"7.8","asian":"9.5"}},"wageData":{"2015":{"workers":"45","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"21","femaleMedian":"-"}}},"Television, video, and motion picture camera operators and editors":{"ageData":{"2015":{"total":"64","16to19":"1","20to24":"13","25to34":"21","35to44":"12","45to54":"9","55to64":"6","65+":"2","medianAge":"6"}},"title":"Television, video, and motion picture camera operators and editors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2015":{"total":"64","women":"14.8","white":"4.5","black":"6.0","asian":"15.4"}},"wageData":{"2015":{"workers":"30","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Media and communication equipment workers, all other":{"ageData":{"2015":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Media and communication equipment workers, all other","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2015":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Healthcare practitioners and technical occupations":{"ageData":{"2015":{"total":"8,766","16to19":"33","20to24":"487","25to34":"2,295","35to44":"2,064","45to54":"1,916","55to64":"1,546","65+":"425","medianAge":"1,546"}},"title":"Healthcare practitioners and technical occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2015":{"total":"8,766","women":"75.1","white":"11.5","black":"9.2","asian":"8.1"}},"wageData":{"2015":{"workers":"6,566","median":"1,041","maleWorkers":"1,639","maleMedian":"1,272","femaleWorkers":"4,928","femaleMedian":"991"}}},"Chiropractors":{"ageData":{"2015":{"total":"75","16to19":"0","20to24":"2","25to34":"10","35to44":"18","45to54":"24","55to64":"14","65+":"7","medianAge":"14"}},"title":"Chiropractors","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"75","women":"29.5","white":"3.2","black":"3.2","asian":"8.7"}},"wageData":{"2015":{"workers":"22","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Dentists":{"ageData":{"2015":{"total":"196","16to19":"0","20to24":"1","25to34":"31","35to44":"49","45to54":"38","55to64":"51","65+":"26","medianAge":"51"}},"title":"Dentists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"196","women":"25.9","white":"2.9","black":"16.8","asian":"8.6"}},"wageData":{"2015":{"workers":"59","median":"1,656","maleWorkers":"39","maleMedian":"-","femaleWorkers":"20","femaleMedian":"-"}}},"Dietitians and nutritionists":{"ageData":{"2015":{"total":"108","16to19":"0","20to24":"8","25to34":"26","35to44":"18","45to54":"23","55to64":"27","65+":"6","medianAge":"27"}},"title":"Dietitians and nutritionists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"108","women":"94.6","white":"14.2","black":"9.6","asian":"5.3"}},"wageData":{"2015":{"workers":"79","median":"886","maleWorkers":"9","maleMedian":"-","femaleWorkers":"69","femaleMedian":"879"}}},"Optometrists":{"ageData":{"2015":{"total":"39","16to19":"0","20to24":"0","25to34":"12","35to44":"7","45to54":"11","55to64":"4","65+":"3","medianAge":"4"}},"title":"Optometrists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"39","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"19","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Pharmacists":{"ageData":{"2015":{"total":"282","16to19":"0","20to24":"15","25to34":"87","35to44":"61","45to54":"52","55to64":"51","65+":"16","medianAge":"51"}},"title":"Pharmacists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"282","women":"57.0","white":"8.7","black":"15.3","asian":"5.4"}},"wageData":{"2015":{"workers":"206","median":"1,920","maleWorkers":"98","maleMedian":"2,117","femaleWorkers":"108","femaleMedian":"1,811"}}},"Physicians and surgeons":{"ageData":{"2015":{"total":"1,007","16to19":"0","20to24":"2","25to34":"223","35to44":"256","45to54":"231","55to64":"192","65+":"103","medianAge":"192"}},"title":"Physicians and surgeons","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"1,007","women":"37.9","white":"6.4","black":"18.4","asian":"6.4"}},"wageData":{"2015":{"workers":"740","median":"1,824","maleWorkers":"457","maleMedian":"1,915","femaleWorkers":"283","femaleMedian":"1,533"}}},"Physician assistants":{"ageData":{"2015":{"total":"74","16to19":"0","20to24":"5","25to34":"29","35to44":"19","45to54":"8","55to64":"10","65+":"3","medianAge":"10"}},"title":"Physician assistants","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"74","women":"72.6","white":"3.7","black":"7.1","asian":"6.5"}},"wageData":{"2015":{"workers":"57","median":"1,368","maleWorkers":"17","maleMedian":"-","femaleWorkers":"40","femaleMedian":"-"}}},"Podiatrists":{"ageData":{"2015":{"total":"15","16to19":"0","20to24":"2","25to34":"2","35to44":"4","45to54":"3","55to64":"3","65+":"1","medianAge":"3"}},"title":"Podiatrists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"15","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"9","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Audiologists":{"ageData":{"2015":{"total":"16","16to19":"0","20to24":"0","25to34":"6","35to44":"2","45to54":"5","55to64":"2","65+":"1","medianAge":"2"}},"title":"Audiologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"16","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"8","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Occupational therapists":{"ageData":{"2015":{"total":"116","16to19":"0","20to24":"1","25to34":"38","35to44":"31","45to54":"29","55to64":"13","65+":"3","medianAge":"13"}},"title":"Occupational therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"116","women":"88.0","white":"7.2","black":"8.6","asian":"6.5"}},"wageData":{"2015":{"workers":"74","median":"1,210","maleWorkers":"10","maleMedian":"-","femaleWorkers":"64","femaleMedian":"1,199"}}},"Physical therapists":{"ageData":{"2015":{"total":"274","16to19":"0","20to24":"6","25to34":"84","35to44":"68","45to54":"68","55to64":"40","65+":"9","medianAge":"40"}},"title":"Physical therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"274","women":"72.1","white":"4.3","black":"12.5","asian":"4.9"}},"wageData":{"2015":{"workers":"178","median":"1,265","maleWorkers":"56","maleMedian":"1,347","femaleWorkers":"123","femaleMedian":"1,215"}}},"Radiation therapists":{"ageData":{"2015":{"total":"13","16to19":"0","20to24":"0","25to34":"5","35to44":"1","45to54":"4","55to64":"2","65+":"1","medianAge":"2"}},"title":"Radiation therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"12","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Recreational therapists":{"ageData":{"2015":{"total":"11","16to19":"0","20to24":"2","25to34":"3","35to44":"3","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Recreational therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"6","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Respiratory therapists":{"ageData":{"2015":{"total":"108","16to19":"0","20to24":"1","25to34":"29","35to44":"25","45to54":"32","55to64":"18","65+":"3","medianAge":"18"}},"title":"Respiratory therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"108","women":"66.8","white":"15.2","black":"6.0","asian":"9.2"}},"wageData":{"2015":{"workers":"99","median":"1,000","maleWorkers":"32","maleMedian":"-","femaleWorkers":"67","femaleMedian":"937"}}},"Speech-language pathologists":{"ageData":{"2015":{"total":"158","16to19":"0","20to24":"9","25to34":"49","35to44":"43","45to54":"28","55to64":"23","65+":"5","medianAge":"23"}},"title":"Speech-language pathologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"158","women":"98.6","white":"4.9","black":"2.9","asian":"7.1"}},"wageData":{"2015":{"workers":"108","median":"1,147","maleWorkers":"1","maleMedian":"-","femaleWorkers":"106","femaleMedian":"1,148"}}},"Exercise physiologists":{"ageData":{"2015":{"total":"5","16to19":"0","20to24":"1","25to34":"2","35to44":"1","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Exercise physiologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Therapists, all other":{"ageData":{"2015":{"total":"189","16to19":"1","20to24":"15","25to34":"60","35to44":"39","45to54":"37","55to64":"26","65+":"12","medianAge":"26"}},"title":"Therapists, all other","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"189","women":"80.9","white":"7.9","black":"3.8","asian":"15.4"}},"wageData":{"2015":{"workers":"132","median":"944","maleWorkers":"31","maleMedian":"-","femaleWorkers":"101","femaleMedian":"951"}}},"Veterinarians":{"ageData":{"2015":{"total":"90","16to19":"1","20to24":"0","25to34":"24","35to44":"23","45to54":"18","55to64":"17","65+":"6","medianAge":"17"}},"title":"Veterinarians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"90","women":"60.5","white":"3.4","black":"4.7","asian":"2.5"}},"wageData":{"2015":{"workers":"55","median":"1,455","maleWorkers":"16","maleMedian":"-","femaleWorkers":"39","femaleMedian":"-"}}},"Registered nurses":{"ageData":{"2015":{"total":"2,973","16to19":"7","20to24":"121","25to34":"715","35to44":"727","45to54":"705","55to64":"577","65+":"120","medianAge":"577"}},"title":"Registered nurses","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"2,973","women":"89.4","white":"12.2","black":"8.7","asian":"6.6"}},"wageData":{"2015":{"workers":"2,382","median":"1,116","maleWorkers":"278","maleMedian":"1,222","femaleWorkers":"2,104","femaleMedian":"1,098"}}},"Nurse anesthetists":{"ageData":{"2015":{"total":"27","16to19":"0","20to24":"0","25to34":"7","35to44":"8","45to54":"4","55to64":"6","65+":"1","medianAge":"6"}},"title":"Nurse anesthetists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"27","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"23","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Nurse midwives":{"ageData":{"2015":{"total":"7","16to19":"0","20to24":"0","25to34":"3","35to44":"0","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Nurse midwives","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"6","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Nurse practitioners":{"ageData":{"2015":{"total":"149","16to19":"0","20to24":"3","25to34":"37","35to44":"42","45to54":"26","55to64":"36","65+":"6","medianAge":"36"}},"title":"Nurse practitioners","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"149","women":"90.8","white":"8.2","black":"3.5","asian":"2.5"}},"wageData":{"2015":{"workers":"115","median":"1,532","maleWorkers":"11","maleMedian":"-","femaleWorkers":"103","femaleMedian":"1,522"}}},"Health diagnosing and treating practitioners, all other":{"ageData":{"2015":{"total":"17","16to19":"0","20to24":"0","25to34":"1","35to44":"4","45to54":"4","55to64":"5","65+":"3","medianAge":"5"}},"title":"Health diagnosing and treating practitioners, all other","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"17","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"2","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Clinical laboratory technologists and technicians":{"ageData":{"2015":{"total":"327","16to19":"1","20to24":"29","25to34":"90","35to44":"72","45to54":"57","55to64":"62","65+":"17","medianAge":"62"}},"title":"Clinical laboratory technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"327","women":"76.1","white":"17.3","black":"13.5","asian":"12.4"}},"wageData":{"2015":{"workers":"270","median":"901","maleWorkers":"69","maleMedian":"1,089","femaleWorkers":"201","femaleMedian":"796"}}},"Dental hygienists":{"ageData":{"2015":{"total":"177","16to19":"1","20to24":"11","25to34":"47","35to44":"52","45to54":"38","55to64":"25","65+":"4","medianAge":"25"}},"title":"Dental hygienists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"177","women":"96.4","white":"3.6","black":"6.6","asian":"5.4"}},"wageData":{"2015":{"workers":"86","median":"914","maleWorkers":"6","maleMedian":"-","femaleWorkers":"80","femaleMedian":"953"}}},"Diagnostic related technologists and technicians":{"ageData":{"2015":{"total":"322","16to19":"1","20to24":"13","25to34":"90","35to44":"82","45to54":"78","55to64":"49","65+":"9","medianAge":"49"}},"title":"Diagnostic related technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"322","women":"73.7","white":"7.9","black":"5.2","asian":"8.7"}},"wageData":{"2015":{"workers":"253","median":"964","maleWorkers":"76","maleMedian":"1,106","femaleWorkers":"177","femaleMedian":"908"}}},"Emergency medical technicians and paramedics":{"ageData":{"2015":{"total":"220","16to19":"3","20to24":"36","25to34":"83","35to44":"50","45to54":"34","55to64":"10","65+":"3","medianAge":"10"}},"title":"Emergency medical technicians and paramedics","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"220","women":"32.9","white":"10.6","black":"1.2","asian":"8.3"}},"wageData":{"2015":{"workers":"175","median":"811","maleWorkers":"126","maleMedian":"899","femaleWorkers":"49","femaleMedian":"-"}}},"Health practitioner support technologists and technicians":{"ageData":{"2015":{"total":"626","16to19":"7","20to24":"112","25to34":"221","35to44":"116","45to54":"97","55to64":"61","65+":"12","medianAge":"61"}},"title":"Health practitioner support technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"626","women":"81.5","white":"14.2","black":"7.5","asian":"13.0"}},"wageData":{"2015":{"workers":"487","median":"636","maleWorkers":"99","maleMedian":"652","femaleWorkers":"389","femaleMedian":"633"}}},"Licensed practical and licensed vocational nurses":{"ageData":{"2015":{"total":"670","16to19":"6","20to24":"65","25to34":"165","35to44":"138","45to54":"150","55to64":"117","65+":"29","medianAge":"117"}},"title":"Licensed practical and licensed vocational nurses","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"670","women":"90.1","white":"28.5","black":"5.7","asian":"13.9"}},"wageData":{"2015":{"workers":"508","median":"743","maleWorkers":"48","maleMedian":"-","femaleWorkers":"459","femaleMedian":"737"}}},"Medical records and health information technicians":{"ageData":{"2015":{"total":"200","16to19":"3","20to24":"11","25to34":"43","35to44":"41","45to54":"52","55to64":"45","65+":"5","medianAge":"45"}},"title":"Medical records and health information technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"200","women":"89.6","white":"12.1","black":"3.6","asian":"8.4"}},"wageData":{"2015":{"workers":"174","median":"740","maleWorkers":"17","maleMedian":"-","femaleWorkers":"157","femaleMedian":"723"}}},"Opticians, dispensing":{"ageData":{"2015":{"total":"52","16to19":"0","20to24":"3","25to34":"9","35to44":"14","45to54":"13","55to64":"11","65+":"2","medianAge":"11"}},"title":"Opticians, dispensing","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"52","women":"60.4","white":"8.4","black":"4.0","asian":"13.3"}},"wageData":{"2015":{"workers":"44","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"23","femaleMedian":"-"}}},"Miscellaneous health technologists and technicians":{"ageData":{"2015":{"total":"117","16to19":"1","20to24":"8","25to34":"29","35to44":"27","45to54":"26","55to64":"23","65+":"4","medianAge":"23"}},"title":"Miscellaneous health technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"117","women":"67.5","white":"14.2","black":"7.8","asian":"11.4"}},"wageData":{"2015":{"workers":"99","median":"671","maleWorkers":"32","maleMedian":"-","femaleWorkers":"66","femaleMedian":"642"}}},"Other healthcare practitioners and technical occupations":{"ageData":{"2015":{"total":"108","16to19":"0","20to24":"5","25to34":"35","35to44":"25","45to54":"16","55to64":"22","65+":"5","medianAge":"22"}},"title":"Other healthcare practitioners and technical occupations","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2015":{"total":"108","women":"52.7","white":"8.8","black":"3.3","asian":"9.0"}},"wageData":{"2015":{"workers":"78","median":"1,128","maleWorkers":"40","maleMedian":"-","femaleWorkers":"38","femaleMedian":"-"}}},"Service occupations":{"ageData":{"2015":{"total":"25,896","16to19":"1,964","20to24":"3,890","25to34":"5,722","35to44":"4,781","45to54":"4,763","55to64":"3,504","65+":"1,272","medianAge":"3,504"}},"title":"Service occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2015":{"total":"25,896","women":"56.7","white":"16.8","black":"5.4","asian":"23.5"}},"wageData":{"2015":{"workers":"15,279","median":"509","maleWorkers":"7,629","maleMedian":"585","femaleWorkers":"7,650","femaleMedian":"463"}}},"Healthcare support occupations":{"ageData":{"2015":{"total":"3,514","16to19":"94","20to24":"459","25to34":"962","35to44":"713","45to54":"685","55to64":"460","65+":"141","medianAge":"460"}},"title":"Healthcare support occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2015":{"total":"3,514","women":"87.6","white":"27.1","black":"5.7","asian":"16.5"}},"wageData":{"2015":{"workers":"2,395","median":"498","maleWorkers":"320","maleMedian":"577","femaleWorkers":"2,074","femaleMedian":"490"}}},"Nursing, psychiatric, and home health aides":{"ageData":{"2015":{"total":"2,032","16to19":"66","20to24":"257","25to34":"497","35to44":"414","45to54":"420","55to64":"284","65+":"93","medianAge":"284"}},"title":"Nursing, psychiatric, and home health aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2015":{"total":"2,032","women":"89.4","white":"37.7","black":"5.6","asian":"14.8"}},"wageData":{"2015":{"workers":"1,400","median":"467","maleWorkers":"163","maleMedian":"526","femaleWorkers":"1,237","femaleMedian":"457"}}},"Occupational therapy assistants and aides":{"ageData":{"2015":{"total":"23","16to19":"0","20to24":"6","25to34":"8","35to44":"5","45to54":"2","55to64":"2","65+":"1","medianAge":"2"}},"title":"Occupational therapy assistants and aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2015":{"total":"23","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"17","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Physical therapist assistants and aides":{"ageData":{"2015":{"total":"68","16to19":"1","20to24":"8","25to34":"25","35to44":"13","45to54":"14","55to64":"5","65+":"2","medianAge":"5"}},"title":"Physical therapist assistants and aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2015":{"total":"68","women":"67.7","white":"5.6","black":"6.0","asian":"10.8"}},"wageData":{"2015":{"workers":"53","median":"742","maleWorkers":"18","maleMedian":"-","femaleWorkers":"35","femaleMedian":"-"}}},"Massage therapists":{"ageData":{"2015":{"total":"189","16to19":"1","20to24":"11","25to34":"64","35to44":"42","45to54":"31","55to64":"30","65+":"10","medianAge":"30"}},"title":"Massage therapists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2015":{"total":"189","women":"77.9","white":"4.8","black":"9.1","asian":"9.1"}},"wageData":{"2015":{"workers":"37","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"22","femaleMedian":"-"}}},"Dental assistants":{"ageData":{"2015":{"total":"286","16to19":"5","20to24":"43","25to34":"91","35to44":"62","45to54":"54","55to64":"25","65+":"6","medianAge":"25"}},"title":"Dental assistants","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2015":{"total":"286","women":"94.1","white":"9.6","black":"6.6","asian":"23.8"}},"wageData":{"2015":{"workers":"188","median":"531","maleWorkers":"14","maleMedian":"-","femaleWorkers":"175","femaleMedian":"522"}}},"Medical assistants":{"ageData":{"2015":{"total":"524","16to19":"6","20to24":"71","25to34":"181","35to44":"110","45to54":"91","55to64":"51","65+":"13","medianAge":"51"}},"title":"Medical assistants","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2015":{"total":"524","women":"90.7","white":"13.0","black":"5.6","asian":"27.5"}},"wageData":{"2015":{"workers":"422","median":"539","maleWorkers":"35","maleMedian":"-","femaleWorkers":"387","femaleMedian":"530"}}},"Medical transcriptionists":{"ageData":{"2015":{"total":"42","16to19":"0","20to24":"4","25to34":"4","35to44":"3","45to54":"13","55to64":"12","65+":"5","medianAge":"12"}},"title":"Medical transcriptionists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2015":{"total":"42","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"28","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"26","femaleMedian":"-"}}},"Pharmacy aides":{"ageData":{"2015":{"total":"36","16to19":"1","20to24":"6","25to34":"11","35to44":"7","45to54":"3","55to64":"5","65+":"2","medianAge":"5"}},"title":"Pharmacy aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2015":{"total":"36","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"22","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"18","femaleMedian":"-"}}},"Veterinary assistants and laboratory animal caretakers":{"ageData":{"2015":{"total":"38","16to19":"3","20to24":"10","25to34":"9","35to44":"10","45to54":"4","55to64":"2","65+":"1","medianAge":"2"}},"title":"Veterinary assistants and laboratory animal caretakers","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2015":{"total":"38","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"21","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Phlebotomists":{"ageData":{"2015":{"total":"106","16to19":"2","20to24":"11","25to34":"29","35to44":"22","45to54":"21","55to64":"18","65+":"3","medianAge":"18"}},"title":"Phlebotomists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2015":{"total":"106","women":"84.1","white":"25.2","black":"3.5","asian":"13.8"}},"wageData":{"2015":{"workers":"91","median":"551","maleWorkers":"15","maleMedian":"-","femaleWorkers":"76","femaleMedian":"534"}}},"Miscellaneous healthcare support occupations, including medical equipment preparers":{"ageData":{"2015":{"total":"170","16to19":"8","20to24":"32","25to34":"42","35to44":"25","45to54":"33","55to64":"25","65+":"6","medianAge":"25"}},"title":"Miscellaneous healthcare support occupations, including medical equipment preparers","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2015":{"total":"170","women":"69.6","white":"25.1","black":"4.1","asian":"8.5"}},"wageData":{"2015":{"workers":"115","median":"524","maleWorkers":"44","maleMedian":"-","femaleWorkers":"71","femaleMedian":"511"}}},"Protective service occupations":{"ageData":{"2015":{"total":"3,109","16to19":"100","20to24":"273","25to34":"723","35to44":"720","45to54":"702","55to64":"430","65+":"161","medianAge":"430"}},"title":"Protective service occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2015":{"total":"3,109","women":"21.3","white":"19.2","black":"2.4","asian":"13.9"}},"wageData":{"2015":{"workers":"2,729","median":"796","maleWorkers":"2,181","maleMedian":"851","femaleWorkers":"547","femaleMedian":"655"}}},"First-line supervisors of correctional officers":{"ageData":{"2015":{"total":"52","16to19":"0","20to24":"0","25to34":"11","35to44":"11","45to54":"22","55to64":"8","65+":"0","medianAge":"8"}},"title":"First-line supervisors of correctional officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2015":{"total":"52","women":"31.4","white":"24.7","black":"2.7","asian":"6.3"}},"wageData":{"2015":{"workers":"57","median":"856","maleWorkers":"41","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"First-line supervisors of police and detectives":{"ageData":{"2015":{"total":"110","16to19":"0","20to24":"0","25to34":"8","35to44":"30","45to54":"52","55to64":"15","65+":"5","medianAge":"15"}},"title":"First-line supervisors of police and detectives","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2015":{"total":"110","women":"12.8","white":"14.0","black":"1.3","asian":"6.6"}},"wageData":{"2015":{"workers":"114","median":"1,427","maleWorkers":"97","maleMedian":"1,425","femaleWorkers":"17","femaleMedian":"-"}}},"First-line supervisors of fire fighting and prevention workers":{"ageData":{"2015":{"total":"49","16to19":"0","20to24":"0","25to34":"3","35to44":"12","45to54":"16","55to64":"16","65+":"1","medianAge":"16"}},"title":"First-line supervisors of fire fighting and prevention workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2015":{"total":"49","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"42","median":"-","maleWorkers":"39","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"First-line supervisors of protective service workers, all other":{"ageData":{"2015":{"total":"81","16to19":"0","20to24":"0","25to34":"13","35to44":"14","45to54":"24","55to64":"19","65+":"11","medianAge":"19"}},"title":"First-line supervisors of protective service workers, all other","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2015":{"total":"81","women":"23.2","white":"14.7","black":"2.0","asian":"10.5"}},"wageData":{"2015":{"workers":"72","median":"808","maleWorkers":"56","maleMedian":"825","femaleWorkers":"16","femaleMedian":"-"}}},"Firefighters":{"ageData":{"2015":{"total":"293","16to19":"2","20to24":"14","25to34":"90","35to44":"96","45to54":"63","55to64":"22","65+":"6","medianAge":"22"}},"title":"Firefighters","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2015":{"total":"293","women":"5.9","white":"8.4","black":"1.1","asian":"7.8"}},"wageData":{"2015":{"workers":"260","median":"1,033","maleWorkers":"245","maleMedian":"1,052","femaleWorkers":"16","femaleMedian":"-"}}},"Fire inspectors":{"ageData":{"2015":{"total":"19","16to19":"0","20to24":"0","25to34":"8","35to44":"3","45to54":"4","55to64":"3","65+":"1","medianAge":"3"}},"title":"Fire inspectors","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2015":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"18","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Bailiffs, correctional officers, and jailers":{"ageData":{"2015":{"total":"443","16to19":"5","20to24":"54","25to34":"117","35to44":"102","45to54":"106","55to64":"49","65+":"10","medianAge":"49"}},"title":"Bailiffs, correctional officers, and jailers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2015":{"total":"443","women":"23.8","white":"26.0","black":"1.2","asian":"11.8"}},"wageData":{"2015":{"workers":"453","median":"754","maleWorkers":"341","maleMedian":"779","femaleWorkers":"112","femaleMedian":"686"}}},"Detectives and criminal investigators":{"ageData":{"2015":{"total":"144","16to19":"0","20to24":"3","25to34":"25","35to44":"43","45to54":"44","55to64":"25","65+":"3","medianAge":"25"}},"title":"Detectives and criminal investigators","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2015":{"total":"144","women":"27.2","white":"8.5","black":"0.8","asian":"11.9"}},"wageData":{"2015":{"workers":"141","median":"1,159","maleWorkers":"100","maleMedian":"1,265","femaleWorkers":"41","femaleMedian":"-"}}},"Fish and game wardens":{"ageData":{"2015":{"total":"6","16to19":"0","20to24":"0","25to34":"2","35to44":"2","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Fish and game wardens","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2015":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"6","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Parking enforcement workers":{"ageData":{"2015":{"total":"10","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"2","55to64":"4","65+":"1","medianAge":"4"}},"title":"Parking enforcement workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2015":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"9","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Police and sheriff\'s patrol officers":{"ageData":{"2015":{"total":"688","16to19":"1","20to24":"39","25to34":"191","35to44":"215","45to54":"165","55to64":"61","65+":"16","medianAge":"61"}},"title":"Police and sheriff\'s patrol officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2015":{"total":"688","women":"13.6","white":"13.5","black":"2.0","asian":"15.5"}},"wageData":{"2015":{"workers":"655","median":"1,002","maleWorkers":"569","maleMedian":"1,001","femaleWorkers":"86","femaleMedian":"1,009"}}},"Transit and railroad police":{"ageData":{"2015":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Transit and railroad police","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2015":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Animal control workers":{"ageData":{"2015":{"total":"5","16to19":"0","20to24":"1","25to34":"1","35to44":"2","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Animal control workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2015":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"4","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Private detectives and investigators":{"ageData":{"2015":{"total":"100","16to19":"0","20to24":"4","25to34":"23","35to44":"24","45to54":"18","55to64":"20","65+":"10","medianAge":"20"}},"title":"Private detectives and investigators","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2015":{"total":"100","women":"38.4","white":"12.7","black":"5.0","asian":"14.6"}},"wageData":{"2015":{"workers":"85","median":"843","maleWorkers":"49","maleMedian":"-","femaleWorkers":"36","femaleMedian":"-"}}},"Security guards and gaming surveillance officers":{"ageData":{"2015":{"total":"869","16to19":"18","20to24":"114","25to34":"202","35to44":"142","45to54":"163","55to64":"160","65+":"72","medianAge":"160"}},"title":"Security guards and gaming surveillance officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2015":{"total":"869","women":"22.0","white":"28.8","black":"4.0","asian":"18.6"}},"wageData":{"2015":{"workers":"708","median":"567","maleWorkers":"555","maleMedian":"592","femaleWorkers":"153","femaleMedian":"515"}}},"Crossing guards":{"ageData":{"2015":{"total":"57","16to19":"0","20to24":"4","25to34":"5","35to44":"9","45to54":"6","55to64":"16","65+":"17","medianAge":"16"}},"title":"Crossing guards","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2015":{"total":"57","women":"59.8","white":"33.2","black":"3.1","asian":"17.3"}},"wageData":{"2015":{"workers":"26","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Transportation security screeners":{"ageData":{"2015":{"total":"38","16to19":"0","20to24":"4","25to34":"12","35to44":"5","45to54":"11","55to64":"5","65+":"1","medianAge":"5"}},"title":"Transportation security screeners","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2015":{"total":"38","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"33","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Lifeguards and other recreational, and all other protective service workers":{"ageData":{"2015":{"total":"144","16to19":"74","20to24":"36","25to34":"10","35to44":"8","45to54":"5","55to64":"5","65+":"6","medianAge":"5"}},"title":"Lifeguards and other recreational, and all other protective service workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2015":{"total":"144","women":"43.7","white":"9.1","black":"1.5","asian":"12.6"}},"wageData":{"2015":{"workers":"42","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"18","femaleMedian":"-"}}},"Food preparation and serving related occupations":{"ageData":{"2015":{"total":"8,142","16to19":"1,281","20to24":"1,917","25to34":"1,837","35to44":"1,181","45to54":"1,048","55to64":"648","65+":"230","medianAge":"648"}},"title":"Food preparation and serving related occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2015":{"total":"8,142","women":"54.5","white":"13.8","black":"6.1","asian":"25.3"}},"wageData":{"2015":{"workers":"4,124","median":"441","maleWorkers":"2,133","maleMedian":"481","femaleWorkers":"1,991","femaleMedian":"414"}}},"Chefs and head cooks":{"ageData":{"2015":{"total":"415","16to19":"8","20to24":"43","25to34":"124","35to44":"99","45to54":"79","55to64":"53","65+":"10","medianAge":"53"}},"title":"Chefs and head cooks","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2015":{"total":"415","women":"19.6","white":"15.2","black":"16.8","asian":"19.3"}},"wageData":{"2015":{"workers":"340","median":"619","maleWorkers":"285","maleMedian":"656","femaleWorkers":"55","femaleMedian":"492"}}},"First-line supervisors of food preparation and serving workers":{"ageData":{"2015":{"total":"527","16to19":"21","20to24":"95","25to34":"141","35to44":"89","45to54":"103","55to64":"63","65+":"15","medianAge":"63"}},"title":"First-line supervisors of food preparation and serving workers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2015":{"total":"527","women":"57.4","white":"14.9","black":"3.8","asian":"16.5"}},"wageData":{"2015":{"workers":"378","median":"498","maleWorkers":"156","maleMedian":"621","femaleWorkers":"222","femaleMedian":"458"}}},"Cooks":{"ageData":{"2015":{"total":"2,091","16to19":"251","20to24":"371","25to34":"483","35to44":"371","45to54":"362","55to64":"180","65+":"73","medianAge":"180"}},"title":"Cooks","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2015":{"total":"2,091","women":"39.9","white":"18.5","black":"5.3","asian":"35.7"}},"wageData":{"2015":{"workers":"1,302","median":"416","maleWorkers":"808","maleMedian":"427","femaleWorkers":"494","femaleMedian":"400"}}},"Food preparation workers":{"ageData":{"2015":{"total":"858","16to19":"172","20to24":"206","25to34":"152","35to44":"111","45to54":"112","55to64":"75","65+":"30","medianAge":"75"}},"title":"Food preparation workers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2015":{"total":"858","women":"59.1","white":"15.1","black":"5.6","asian":"27.4"}},"wageData":{"2015":{"workers":"366","median":"402","maleWorkers":"174","maleMedian":"414","femaleWorkers":"192","femaleMedian":"388"}}},"Bartenders":{"ageData":{"2015":{"total":"451","16to19":"3","20to24":"82","25to34":"174","35to44":"91","45to54":"59","55to64":"32","65+":"11","medianAge":"32"}},"title":"Bartenders","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2015":{"total":"451","women":"59.8","white":"4.4","black":"3.3","asian":"13.2"}},"wageData":{"2015":{"workers":"252","median":"521","maleWorkers":"110","maleMedian":"569","femaleWorkers":"142","femaleMedian":"493"}}},"Combined food preparation and serving workers, including fast food":{"ageData":{"2015":{"total":"420","16to19":"95","20to24":"126","25to34":"69","35to44":"39","45to54":"38","55to64":"34","65+":"18","medianAge":"34"}},"title":"Combined food preparation and serving workers, including fast food","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2015":{"total":"420","women":"63.4","white":"21.6","black":"3.7","asian":"17.3"}},"wageData":{"2015":{"workers":"173","median":"391","maleWorkers":"67","maleMedian":"401","femaleWorkers":"107","femaleMedian":"380"}}},"Counter attendants, cafeteria, food concession, and coffee shop":{"ageData":{"2015":{"total":"233","16to19":"116","20to24":"51","25to34":"27","35to44":"16","45to54":"11","55to64":"7","65+":"5","medianAge":"7"}},"title":"Counter attendants, cafeteria, food concession, and coffee shop","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2015":{"total":"233","women":"66.7","white":"10.7","black":"6.2","asian":"18.2"}},"wageData":{"2015":{"workers":"56","median":"354","maleWorkers":"28","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Waiters and waitresses":{"ageData":{"2015":{"total":"2,057","16to19":"310","20to24":"686","25to34":"522","35to44":"241","45to54":"155","55to64":"113","65+":"30","medianAge":"113"}},"title":"Waiters and waitresses","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2015":{"total":"2,057","women":"70.1","white":"8.2","black":"6.9","asian":"21.1"}},"wageData":{"2015":{"workers":"868","median":"451","maleWorkers":"305","maleMedian":"501","femaleWorkers":"563","femaleMedian":"411"}}},"Food servers, nonrestaurant":{"ageData":{"2015":{"total":"190","16to19":"22","20to24":"35","25to34":"34","35to44":"31","45to54":"34","55to64":"24","65+":"10","medianAge":"24"}},"title":"Food servers, nonrestaurant","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2015":{"total":"190","women":"70.9","white":"20.6","black":"8.7","asian":"19.4"}},"wageData":{"2015":{"workers":"93","median":"509","maleWorkers":"31","maleMedian":"-","femaleWorkers":"62","femaleMedian":"485"}}},"Dining room and cafeteria attendants and bartender helpers":{"ageData":{"2015":{"total":"321","16to19":"93","20to24":"61","25to34":"44","35to44":"36","45to54":"41","55to64":"31","65+":"13","medianAge":"31"}},"title":"Dining room and cafeteria attendants and bartender helpers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2015":{"total":"321","women":"44.2","white":"13.9","black":"6.1","asian":"29.1"}},"wageData":{"2015":{"workers":"107","median":"403","maleWorkers":"59","maleMedian":"389","femaleWorkers":"48","femaleMedian":"-"}}},"Dishwashers":{"ageData":{"2015":{"total":"281","16to19":"62","20to24":"64","25to34":"39","35to44":"39","45to54":"44","55to64":"25","65+":"8","medianAge":"25"}},"title":"Dishwashers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2015":{"total":"281","women":"21.3","white":"14.7","black":"5.1","asian":"39.7"}},"wageData":{"2015":{"workers":"117","median":"398","maleWorkers":"98","maleMedian":"401","femaleWorkers":"19","femaleMedian":"-"}}},"Hosts and hostesses, restaurant, lounge, and coffee shop":{"ageData":{"2015":{"total":"293","16to19":"127","20to24":"95","25to34":"28","35to44":"17","45to54":"11","55to64":"10","65+":"6","medianAge":"10"}},"title":"Hosts and hostesses, restaurant, lounge, and coffee shop","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2015":{"total":"293","women":"82.1","white":"11.2","black":"3.6","asian":"19.2"}},"wageData":{"2015":{"workers":"66","median":"400","maleWorkers":"8","maleMedian":"-","femaleWorkers":"58","femaleMedian":"397"}}},"Food preparation and serving related workers, all other":{"ageData":{"2015":{"total":"5","16to19":"1","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"1","65+":"2","medianAge":"1"}},"title":"Food preparation and serving related workers, all other","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2015":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"6","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Building and grounds cleaning and maintenance occupations":{"ageData":{"2015":{"total":"5,716","16to19":"191","20to24":"469","25to34":"1,064","35to44":"1,144","45to54":"1,350","55to64":"1,136","65+":"361","medianAge":"1,136"}},"title":"Building and grounds cleaning and maintenance occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2015":{"total":"5,716","women":"41.1","white":"14.5","black":"2.9","asian":"38.0"}},"wageData":{"2015":{"workers":"3,605","median":"486","maleWorkers":"2,330","maleMedian":"517","femaleWorkers":"1,275","femaleMedian":"419"}}},"First-line supervisors of housekeeping and janitorial workers":{"ageData":{"2015":{"total":"293","16to19":"0","20to24":"9","25to34":"48","35to44":"63","45to54":"84","55to64":"69","65+":"20","medianAge":"69"}},"title":"First-line supervisors of housekeeping and janitorial workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2015":{"total":"293","women":"40.6","white":"19.7","black":"2.4","asian":"20.5"}},"wageData":{"2015":{"workers":"172","median":"620","maleWorkers":"108","maleMedian":"700","femaleWorkers":"64","femaleMedian":"571"}}},"First-line supervisors of landscaping, lawn service, and groundskeeping workers":{"ageData":{"2015":{"total":"215","16to19":"1","20to24":"12","25to34":"47","35to44":"56","45to54":"53","55to64":"37","65+":"9","medianAge":"37"}},"title":"First-line supervisors of landscaping, lawn service, and groundskeeping workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2015":{"total":"215","women":"6.6","white":"4.0","black":"2.0","asian":"23.6"}},"wageData":{"2015":{"workers":"80","median":"649","maleWorkers":"79","maleMedian":"653","femaleWorkers":"1","femaleMedian":"-"}}},"Janitors and building cleaners":{"ageData":{"2015":{"total":"2,263","16to19":"75","20to24":"174","25to34":"375","35to44":"384","45to54":"535","55to64":"543","65+":"178","medianAge":"543"}},"title":"Janitors and building cleaners","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2015":{"total":"2,263","women":"34.3","white":"17.6","black":"3.4","asian":"31.4"}},"wageData":{"2015":{"workers":"1,536","median":"507","maleWorkers":"1,111","maleMedian":"547","femaleWorkers":"425","femaleMedian":"429"}}},"Maids and housekeeping cleaners":{"ageData":{"2015":{"total":"1,510","16to19":"36","20to24":"99","25to34":"243","35to44":"355","45to54":"413","55to64":"284","65+":"81","medianAge":"284"}},"title":"Maids and housekeeping cleaners","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2015":{"total":"1,510","women":"89.3","white":"16.1","black":"4.4","asian":"48.9"}},"wageData":{"2015":{"workers":"876","median":"416","maleWorkers":"134","maleMedian":"475","femaleWorkers":"742","femaleMedian":"407"}}},"Pest control workers":{"ageData":{"2015":{"total":"85","16to19":"3","20to24":"5","25to34":"20","35to44":"18","45to54":"21","55to64":"14","65+":"4","medianAge":"14"}},"title":"Pest control workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2015":{"total":"85","women":"4.7","white":"13.0","black":"1.3","asian":"14.0"}},"wageData":{"2015":{"workers":"77","median":"585","maleWorkers":"74","maleMedian":"591","femaleWorkers":"3","femaleMedian":"-"}}},"Grounds maintenance workers":{"ageData":{"2015":{"total":"1,349","16to19":"76","20to24":"170","25to34":"332","35to44":"269","45to54":"244","55to64":"190","65+":"69","medianAge":"190"}},"title":"Grounds maintenance workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2015":{"total":"1,349","women":"6.4","white":"7.9","black":"0.9","asian":"44.5"}},"wageData":{"2015":{"workers":"862","median":"469","maleWorkers":"824","maleMedian":"473","femaleWorkers":"39","femaleMedian":"-"}}},"Personal care and service occupations":{"ageData":{"2015":{"total":"5,415","16to19":"297","20to24":"772","25to34":"1,136","35to44":"1,023","45to54":"978","55to64":"830","65+":"378","medianAge":"830"}},"title":"Personal care and service occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2015":{"total":"5,415","women":"76.8","white":"15.6","black":"8.5","asian":"15.5"}},"wageData":{"2015":{"workers":"2,427","median":"498","maleWorkers":"664","maleMedian":"597","femaleWorkers":"1,763","femaleMedian":"475"}}},"First-line supervisors of gaming workers":{"ageData":{"2015":{"total":"168","16to19":"6","20to24":"10","25to34":"41","35to44":"43","45to54":"32","55to64":"23","65+":"14","medianAge":"23"}},"title":"First-line supervisors of gaming workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2015":{"total":"168","women":"46.6","white":"4.8","black":"5.1","asian":"8.7"}},"wageData":{"2015":{"workers":"117","median":"769","maleWorkers":"65","maleMedian":"900","femaleWorkers":"52","femaleMedian":"680"}}},"First-line supervisors of personal service workers":{"ageData":{"2015":{"total":"185","16to19":"0","20to24":"4","25to34":"44","35to44":"50","45to54":"41","55to64":"34","65+":"12","medianAge":"34"}},"title":"First-line supervisors of personal service workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2015":{"total":"185","women":"71.0","white":"11.9","black":"16.2","asian":"8.9"}},"wageData":{"2015":{"workers":"60","median":"608","maleWorkers":"25","maleMedian":"-","femaleWorkers":"35","femaleMedian":"-"}}},"Animal trainers":{"ageData":{"2015":{"total":"54","16to19":"1","20to24":"4","25to34":"12","35to44":"12","45to54":"8","55to64":"14","65+":"3","medianAge":"14"}},"title":"Animal trainers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2015":{"total":"54","women":"50.9","white":"1.2","black":"0.0","asian":"11.5"}},"wageData":{"2015":{"workers":"26","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Nonfarm animal caretakers":{"ageData":{"2015":{"total":"252","16to19":"20","20to24":"56","25to34":"58","35to44":"38","45to54":"41","55to64":"29","65+":"10","medianAge":"29"}},"title":"Nonfarm animal caretakers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2015":{"total":"252","women":"67.9","white":"5.4","black":"1.8","asian":"13.0"}},"wageData":{"2015":{"workers":"100","median":"505","maleWorkers":"32","maleMedian":"-","femaleWorkers":"68","femaleMedian":"501"}}},"Gaming services workers":{"ageData":{"2015":{"total":"89","16to19":"1","20to24":"7","25to34":"17","35to44":"21","45to54":"17","55to64":"19","65+":"6","medianAge":"19"}},"title":"Gaming services workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2015":{"total":"89","women":"52.2","white":"8.0","black":"22.0","asian":"8.2"}},"wageData":{"2015":{"workers":"69","median":"676","maleWorkers":"30","maleMedian":"-","femaleWorkers":"39","femaleMedian":"-"}}},"Motion picture projectionists":{"ageData":{"2015":{"total":"6","16to19":"0","20to24":"1","25to34":"1","35to44":"2","45to54":"2","55to64":"0","65+":"1","medianAge":"0"}},"title":"Motion picture projectionists","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2015":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Ushers, lobby attendants, and ticket takers":{"ageData":{"2015":{"total":"44","16to19":"12","20to24":"15","25to34":"6","35to44":"2","45to54":"2","55to64":"2","65+":"5","medianAge":"2"}},"title":"Ushers, lobby attendants, and ticket takers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2015":{"total":"44","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"9","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Miscellaneous entertainment attendants and related workers":{"ageData":{"2015":{"total":"221","16to19":"52","20to24":"62","25to34":"35","35to44":"15","45to54":"16","55to64":"21","65+":"21","medianAge":"21"}},"title":"Miscellaneous entertainment attendants and related workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2015":{"total":"221","women":"39.2","white":"12.8","black":"2.1","asian":"15.7"}},"wageData":{"2015":{"workers":"69","median":"485","maleWorkers":"42","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Embalmers and funeral attendants":{"ageData":{"2015":{"total":"9","16to19":"0","20to24":"1","25to34":"1","35to44":"3","45to54":"1","55to64":"1","65+":"3","medianAge":"1"}},"title":"Embalmers and funeral attendants","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2015":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Morticians, undertakers, and funeral directors":{"ageData":{"2015":{"total":"35","16to19":"0","20to24":"1","25to34":"6","35to44":"7","45to54":"8","55to64":"8","65+":"5","medianAge":"8"}},"title":"Morticians, undertakers, and funeral directors","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2015":{"total":"35","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"23","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Barbers":{"ageData":{"2015":{"total":"116","16to19":"1","20to24":"4","25to34":"28","35to44":"38","45to54":"24","55to64":"11","65+":"10","medianAge":"11"}},"title":"Barbers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2015":{"total":"116","women":"22.1","white":"40.7","black":"6.4","asian":"20.7"}},"wageData":{"2015":{"workers":"46","median":"-","maleWorkers":"33","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Hairdressers, hairstylists, and cosmetologists":{"ageData":{"2015":{"total":"707","16to19":"6","20to24":"80","25to34":"182","35to44":"154","45to54":"133","55to64":"97","65+":"55","medianAge":"97"}},"title":"Hairdressers, hairstylists, and cosmetologists","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2015":{"total":"707","women":"94.2","white":"12.3","black":"3.9","asian":"15.3"}},"wageData":{"2015":{"workers":"253","median":"461","maleWorkers":"23","maleMedian":"-","femaleWorkers":"229","femaleMedian":"463"}}},"Miscellaneous personal appearance workers":{"ageData":{"2015":{"total":"324","16to19":"2","20to24":"26","25to34":"74","35to44":"102","45to54":"78","55to64":"34","65+":"7","medianAge":"34"}},"title":"Miscellaneous personal appearance workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2015":{"total":"324","women":"85.3","white":"7.0","black":"56.5","asian":"8.5"}},"wageData":{"2015":{"workers":"191","median":"501","maleWorkers":"32","maleMedian":"-","femaleWorkers":"159","femaleMedian":"497"}}},"Baggage porters, bellhops, and concierges":{"ageData":{"2015":{"total":"76","16to19":"2","20to24":"11","25to34":"19","35to44":"13","45to54":"19","55to64":"8","65+":"3","medianAge":"8"}},"title":"Baggage porters, bellhops, and concierges","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2015":{"total":"76","women":"16.1","white":"21.0","black":"10.5","asian":"32.9"}},"wageData":{"2015":{"workers":"75","median":"608","maleWorkers":"63","maleMedian":"606","femaleWorkers":"12","femaleMedian":"-"}}},"Tour and travel guides":{"ageData":{"2015":{"total":"54","16to19":"3","20to24":"14","25to34":"6","35to44":"10","45to54":"6","55to64":"8","65+":"8","medianAge":"8"}},"title":"Tour and travel guides","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2015":{"total":"54","women":"54.3","white":"3.4","black":"10.1","asian":"5.3"}},"wageData":{"2015":{"workers":"21","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Childcare workers":{"ageData":{"2015":{"total":"1,206","16to19":"113","20to24":"236","25to34":"250","35to44":"179","45to54":"182","55to64":"176","65+":"70","medianAge":"176"}},"title":"Childcare workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2015":{"total":"1,206","women":"94.9","white":"15.3","black":"3.3","asian":"19.1"}},"wageData":{"2015":{"workers":"407","median":"437","maleWorkers":"14","maleMedian":"-","femaleWorkers":"393","femaleMedian":"430"}}},"Personal care aides":{"ageData":{"2015":{"total":"1,251","16to19":"29","20to24":"140","25to34":"226","35to44":"215","45to54":"269","55to64":"263","65+":"109","medianAge":"263"}},"title":"Personal care aides","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2015":{"total":"1,251","women":"85.1","white":"24.2","black":"8.1","asian":"17.9"}},"wageData":{"2015":{"workers":"680","median":"462","maleWorkers":"128","maleMedian":"537","femaleWorkers":"552","femaleMedian":"441"}}},"Recreation and fitness workers":{"ageData":{"2015":{"total":"429","16to19":"35","20to24":"65","25to34":"86","35to44":"83","45to54":"73","55to64":"65","65+":"22","medianAge":"65"}},"title":"Recreation and fitness workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2015":{"total":"429","women":"61.6","white":"10.7","black":"2.1","asian":"10.4"}},"wageData":{"2015":{"workers":"185","median":"555","maleWorkers":"78","maleMedian":"684","femaleWorkers":"107","femaleMedian":"526"}}},"Residential advisors":{"ageData":{"2015":{"total":"38","16to19":"5","20to24":"13","25to34":"6","35to44":"5","45to54":"4","55to64":"5","65+":"1","medianAge":"5"}},"title":"Residential advisors","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2015":{"total":"38","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"24","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Personal care and service workers, all other":{"ageData":{"2015":{"total":"149","16to19":"8","20to24":"22","25to34":"42","35to44":"33","45to54":"21","55to64":"12","65+":"11","medianAge":"12"}},"title":"Personal care and service workers, all other","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2015":{"total":"149","women":"49.8","white":"15.6","black":"4.9","asian":"20.8"}},"wageData":{"2015":{"workers":"67","median":"499","maleWorkers":"35","maleMedian":"-","femaleWorkers":"32","femaleMedian":"-"}}},"Sales and office occupations":{"ageData":{"2015":{"total":"33,598","16to19":"1,617","20to24":"4,181","25to34":"7,017","35to44":"6,016","45to54":"6,940","55to64":"5,738","65+":"2,090","medianAge":"5,738"}},"title":"Sales and office occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2015":{"total":"33,598","women":"61.5","white":"12.3","black":"5.2","asian":"15.3"}},"wageData":{"2015":{"workers":"23,620","median":"673","maleWorkers":"9,384","maleMedian":"777","femaleWorkers":"14,236","femaleMedian":"627"}}},"Sales and related occupations":{"ageData":{"2015":{"total":"15,700","16to19":"1,113","20to24":"2,118","25to34":"3,215","35to44":"2,667","45to54":"3,057","55to64":"2,459","65+":"1,071","medianAge":"2,459"}},"title":"Sales and related occupations","depth":2,"parent":"Sales and office occupations","sexRaceEthnicityData":{"2015":{"total":"15,700","women":"49.3","white":"10.6","black":"5.7","asian":"15.0"}},"wageData":{"2015":{"workers":"9,725","median":"716","maleWorkers":"5,423","maleMedian":"880","femaleWorkers":"4,303","femaleMedian":"578"}}},"First-line supervisors of retail sales workers":{"ageData":{"2015":{"total":"3,245","16to19":"29","20to24":"274","25to34":"750","35to44":"689","45to54":"766","55to64":"544","65+":"192","medianAge":"544"}},"title":"First-line supervisors of retail sales workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2015":{"total":"3,245","women":"44.0","white":"9.5","black":"6.1","asian":"13.0"}},"wageData":{"2015":{"workers":"2,326","median":"711","maleWorkers":"1,296","maleMedian":"825","femaleWorkers":"1,030","femaleMedian":"614"}}},"First-line supervisors of non-retail sales workers":{"ageData":{"2015":{"total":"1,242","16to19":"4","20to24":"29","25to34":"195","35to44":"297","45to54":"359","55to64":"277","65+":"81","medianAge":"277"}},"title":"First-line supervisors of non-retail sales workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2015":{"total":"1,242","women":"28.7","white":"6.2","black":"5.9","asian":"12.8"}},"wageData":{"2015":{"workers":"835","median":"1,028","maleWorkers":"556","maleMedian":"1,140","femaleWorkers":"280","femaleMedian":"896"}}},"Cashiers":{"ageData":{"2015":{"total":"3,246","16to19":"714","20to24":"833","25to34":"594","35to44":"302","45to54":"355","55to64":"310","65+":"139","medianAge":"310"}},"title":"Cashiers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2015":{"total":"3,246","women":"72.5","white":"17.4","black":"6.8","asian":"20.6"}},"wageData":{"2015":{"workers":"1,342","median":"415","maleWorkers":"411","maleMedian":"471","femaleWorkers":"931","femaleMedian":"405"}}},"Counter and rental clerks":{"ageData":{"2015":{"total":"109","16to19":"10","20to24":"16","25to34":"29","35to44":"17","45to54":"20","55to64":"10","65+":"7","medianAge":"10"}},"title":"Counter and rental clerks","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2015":{"total":"109","women":"50.9","white":"12.2","black":"2.9","asian":"18.8"}},"wageData":{"2015":{"workers":"73","median":"594","maleWorkers":"35","maleMedian":"-","femaleWorkers":"37","femaleMedian":"-"}}},"Parts salespersons":{"ageData":{"2015":{"total":"124","16to19":"4","20to24":"22","25to34":"28","35to44":"23","45to54":"18","55to64":"22","65+":"7","medianAge":"22"}},"title":"Parts salespersons","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2015":{"total":"124","women":"12.4","white":"5.0","black":"1.5","asian":"18.1"}},"wageData":{"2015":{"workers":"92","median":"601","maleWorkers":"82","maleMedian":"600","femaleWorkers":"11","femaleMedian":"-"}}},"Retail salespersons":{"ageData":{"2015":{"total":"3,346","16to19":"304","20to24":"668","25to34":"710","35to44":"461","45to54":"483","55to64":"473","65+":"247","medianAge":"473"}},"title":"Retail salespersons","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2015":{"total":"3,346","women":"49.4","white":"12.8","black":"6.3","asian":"17.3"}},"wageData":{"2015":{"workers":"1,918","median":"590","maleWorkers":"1,159","maleMedian":"694","femaleWorkers":"759","femaleMedian":"494"}}},"Advertising sales agents":{"ageData":{"2015":{"total":"200","16to19":"1","20to24":"18","25to34":"54","35to44":"41","45to54":"47","55to64":"28","65+":"11","medianAge":"28"}},"title":"Advertising sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2015":{"total":"200","women":"49.7","white":"9.4","black":"4.8","asian":"11.3"}},"wageData":{"2015":{"workers":"161","median":"925","maleWorkers":"78","maleMedian":"1,155","femaleWorkers":"83","femaleMedian":"729"}}},"Insurance sales agents":{"ageData":{"2015":{"total":"615","16to19":"3","20to24":"35","25to34":"126","35to44":"116","45to54":"155","55to64":"113","65+":"68","medianAge":"113"}},"title":"Insurance sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2015":{"total":"615","women":"51.2","white":"7.3","black":"3.5","asian":"12.7"}},"wageData":{"2015":{"workers":"427","median":"815","maleWorkers":"194","maleMedian":"1,028","femaleWorkers":"232","femaleMedian":"717"}}},"Securities, commodities, and financial services sales agents":{"ageData":{"2015":{"total":"258","16to19":"1","20to24":"19","25to34":"59","35to44":"58","45to54":"61","55to64":"45","65+":"15","medianAge":"45"}},"title":"Securities, commodities, and financial services sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2015":{"total":"258","women":"26.2","white":"4.8","black":"5.8","asian":"7.0"}},"wageData":{"2015":{"workers":"211","median":"1,155","maleWorkers":"146","maleMedian":"1,461","femaleWorkers":"65","femaleMedian":"767"}}},"Travel agents":{"ageData":{"2015":{"total":"89","16to19":"0","20to24":"2","25to34":"18","35to44":"11","45to54":"21","55to64":"26","65+":"11","medianAge":"26"}},"title":"Travel agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2015":{"total":"89","women":"75.9","white":"3.3","black":"17.7","asian":"8.7"}},"wageData":{"2015":{"workers":"62","median":"711","maleWorkers":"9","maleMedian":"-","femaleWorkers":"53","femaleMedian":"685"}}},"Sales representatives, services, all other":{"ageData":{"2015":{"total":"479","16to19":"7","20to24":"35","25to34":"119","35to44":"118","45to54":"103","55to64":"81","65+":"17","medianAge":"81"}},"title":"Sales representatives, services, all other","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2015":{"total":"479","women":"34.8","white":"5.7","black":"2.8","asian":"13.3"}},"wageData":{"2015":{"workers":"406","median":"966","maleWorkers":"268","maleMedian":"1,147","femaleWorkers":"139","femaleMedian":"699"}}},"Sales representatives, wholesale and manufacturing":{"ageData":{"2015":{"total":"1,281","16to19":"10","20to24":"69","25to34":"276","35to44":"253","45to54":"341","55to64":"256","65+":"77","medianAge":"256"}},"title":"Sales representatives, wholesale and manufacturing","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2015":{"total":"1,281","women":"27.9","white":"4.0","black":"3.3","asian":"10.0"}},"wageData":{"2015":{"workers":"1,138","median":"1,020","maleWorkers":"843","maleMedian":"1,066","femaleWorkers":"295","femaleMedian":"917"}}},"Models, demonstrators, and product promoters":{"ageData":{"2015":{"total":"68","16to19":"4","20to24":"14","25to34":"10","35to44":"11","45to54":"5","55to64":"9","65+":"15","medianAge":"9"}},"title":"Models, demonstrators, and product promoters","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2015":{"total":"68","women":"70.7","white":"5.6","black":"6.5","asian":"15.1"}},"wageData":{"2015":{"workers":"15","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Real estate brokers and sales agents":{"ageData":{"2015":{"total":"906","16to19":"5","20to24":"32","25to34":"134","35to44":"187","45to54":"204","55to64":"196","65+":"148","medianAge":"196"}},"title":"Real estate brokers and sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2015":{"total":"906","women":"55.5","white":"5.7","black":"4.9","asian":"9.4"}},"wageData":{"2015":{"workers":"463","median":"837","maleWorkers":"197","maleMedian":"1,052","femaleWorkers":"266","femaleMedian":"735"}}},"Sales engineers":{"ageData":{"2015":{"total":"42","16to19":"0","20to24":"0","25to34":"8","35to44":"11","45to54":"14","55to64":"7","65+":"3","medianAge":"7"}},"title":"Sales engineers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2015":{"total":"42","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"33","median":"-","maleWorkers":"31","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Telemarketers":{"ageData":{"2015":{"total":"60","16to19":"4","20to24":"14","25to34":"19","35to44":"6","45to54":"7","55to64":"6","65+":"2","medianAge":"6"}},"title":"Telemarketers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2015":{"total":"60","women":"64.3","white":"25.9","black":"2.2","asian":"27.3"}},"wageData":{"2015":{"workers":"39","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"21","femaleMedian":"-"}}},"Door-to-door sales workers, news and street vendors, and related workers":{"ageData":{"2015":{"total":"156","16to19":"3","20to24":"15","25to34":"37","35to44":"28","45to54":"40","55to64":"21","65+":"11","medianAge":"21"}},"title":"Door-to-door sales workers, news and street vendors, and related workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2015":{"total":"156","women":"67.0","white":"10.5","black":"2.5","asian":"21.7"}},"wageData":{"2015":{"workers":"28","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"18","femaleMedian":"-"}}},"Sales and related workers, all other":{"ageData":{"2015":{"total":"236","16to19":"11","20to24":"23","25to34":"49","35to44":"39","45to54":"59","55to64":"34","65+":"21","medianAge":"34"}},"title":"Sales and related workers, all other","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2015":{"total":"236","women":"46.8","white":"6.5","black":"3.9","asian":"10.6"}},"wageData":{"2015":{"workers":"158","median":"916","maleWorkers":"89","maleMedian":"1,088","femaleWorkers":"70","femaleMedian":"727"}}},"Office and administrative support occupations":{"ageData":{"2015":{"total":"17,897","16to19":"504","20to24":"2,063","25to34":"3,801","35to44":"3,349","45to54":"3,883","55to64":"3,278","65+":"1,020","medianAge":"3,278"}},"title":"Office and administrative support occupations","depth":2,"parent":"Sales and office occupations","sexRaceEthnicityData":{"2015":{"total":"17,897","women":"72.2","white":"13.9","black":"4.7","asian":"15.6"}},"wageData":{"2015":{"workers":"13,894","median":"656","maleWorkers":"3,961","maleMedian":"693","femaleWorkers":"9,933","femaleMedian":"646"}}},"First-line supervisors of office and administrative support workers":{"ageData":{"2015":{"total":"1,474","16to19":"5","20to24":"61","25to34":"274","35to44":"353","45to54":"397","55to64":"315","65+":"68","medianAge":"315"}},"title":"First-line supervisors of office and administrative support workers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"1,474","women":"68.3","white":"11.7","black":"4.7","asian":"13.1"}},"wageData":{"2015":{"workers":"1,297","median":"812","maleWorkers":"434","maleMedian":"878","femaleWorkers":"863","femaleMedian":"781"}}},"Switchboard operators, including answering service":{"ageData":{"2015":{"total":"16","16to19":"0","20to24":"2","25to34":"3","35to44":"3","45to54":"3","55to64":"3","65+":"2","medianAge":"3"}},"title":"Switchboard operators, including answering service","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"16","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"17","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Telephone operators":{"ageData":{"2015":{"total":"34","16to19":"0","20to24":"10","25to34":"6","35to44":"7","45to54":"3","55to64":"6","65+":"1","medianAge":"6"}},"title":"Telephone operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"34","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"22","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"18","femaleMedian":"-"}}},"Communications equipment operators, all other":{"ageData":{"2015":{"total":"5","16to19":"0","20to24":"0","25to34":"2","35to44":"0","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Communications equipment operators, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"5","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Bill and account collectors":{"ageData":{"2015":{"total":"168","16to19":"1","20to24":"16","25to34":"45","35to44":"49","45to54":"23","55to64":"28","65+":"6","medianAge":"28"}},"title":"Bill and account collectors","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"168","women":"68.3","white":"20.6","black":"3.9","asian":"18.4"}},"wageData":{"2015":{"workers":"152","median":"657","maleWorkers":"54","maleMedian":"674","femaleWorkers":"98","femaleMedian":"648"}}},"Billing and posting clerks":{"ageData":{"2015":{"total":"473","16to19":"3","20to24":"24","25to34":"98","35to44":"119","45to54":"125","55to64":"79","65+":"25","medianAge":"79"}},"title":"Billing and posting clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"473","women":"90.1","white":"13.0","black":"3.3","asian":"13.5"}},"wageData":{"2015":{"workers":"406","median":"657","maleWorkers":"39","maleMedian":"-","femaleWorkers":"366","femaleMedian":"664"}}},"Bookkeeping, accounting, and auditing clerks":{"ageData":{"2015":{"total":"1,182","16to19":"4","20to24":"59","25to34":"164","35to44":"229","45to54":"302","55to64":"284","65+":"140","medianAge":"284"}},"title":"Bookkeeping, accounting, and auditing clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"1,182","women":"89.8","white":"7.5","black":"4.9","asian":"10.6"}},"wageData":{"2015":{"workers":"769","median":"692","maleWorkers":"87","maleMedian":"690","femaleWorkers":"682","femaleMedian":"692"}}},"Gaming cage workers":{"ageData":{"2015":{"total":"14","16to19":"0","20to24":"4","25to34":"4","35to44":"2","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Gaming cage workers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"11","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Payroll and timekeeping clerks":{"ageData":{"2015":{"total":"138","16to19":"1","20to24":"9","25to34":"23","35to44":"31","45to54":"45","55to64":"24","65+":"6","medianAge":"24"}},"title":"Payroll and timekeeping clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"138","women":"89.3","white":"7.3","black":"4.8","asian":"15.5"}},"wageData":{"2015":{"workers":"128","median":"757","maleWorkers":"17","maleMedian":"-","femaleWorkers":"111","femaleMedian":"751"}}},"Procurement clerks":{"ageData":{"2015":{"total":"40","16to19":"0","20to24":"6","25to34":"6","35to44":"4","45to54":"10","55to64":"11","65+":"2","medianAge":"11"}},"title":"Procurement clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"35","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"21","femaleMedian":"-"}}},"Tellers":{"ageData":{"2015":{"total":"357","16to19":"10","20to24":"92","25to34":"102","35to44":"46","45to54":"56","55to64":"40","65+":"12","medianAge":"40"}},"title":"Tellers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"357","women":"87.3","white":"8.4","black":"6.4","asian":"20.7"}},"wageData":{"2015":{"workers":"264","median":"514","maleWorkers":"33","maleMedian":"-","femaleWorkers":"231","femaleMedian":"516"}}},"Financial clerks, all other":{"ageData":{"2015":{"total":"69","16to19":"0","20to24":"6","25to34":"18","35to44":"13","45to54":"19","55to64":"9","65+":"3","medianAge":"9"}},"title":"Financial clerks, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"69","women":"63.3","white":"24.6","black":"7.6","asian":"7.0"}},"wageData":{"2015":{"workers":"61","median":"767","maleWorkers":"30","maleMedian":"-","femaleWorkers":"32","femaleMedian":"-"}}},"Brokerage clerks":{"ageData":{"2015":{"total":"3","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Brokerage clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"3","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Correspondence clerks":{"ageData":{"2015":{"total":"3","16to19":"0","20to24":"1","25to34":"2","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Correspondence clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"3","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Court, municipal, and license clerks":{"ageData":{"2015":{"total":"71","16to19":"0","20to24":"2","25to34":"15","35to44":"15","45to54":"18","55to64":"16","65+":"6","medianAge":"16"}},"title":"Court, municipal, and license clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"71","women":"87.0","white":"11.9","black":"3.3","asian":"16.6"}},"wageData":{"2015":{"workers":"60","median":"755","maleWorkers":"9","maleMedian":"-","femaleWorkers":"51","femaleMedian":"743"}}},"Credit authorizers, checkers, and clerks":{"ageData":{"2015":{"total":"52","16to19":"1","20to24":"3","25to34":"15","35to44":"12","45to54":"13","55to64":"7","65+":"1","medianAge":"7"}},"title":"Credit authorizers, checkers, and clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"52","women":"72.9","white":"10.4","black":"2.5","asian":"15.8"}},"wageData":{"2015":{"workers":"42","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"29","femaleMedian":"-"}}},"Customer service representatives":{"ageData":{"2015":{"total":"2,271","16to19":"124","20to24":"403","25to34":"583","35to44":"390","45to54":"402","55to64":"287","65+":"83","medianAge":"287"}},"title":"Customer service representatives","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"2,271","women":"65.1","white":"16.6","black":"4.7","asian":"18.0"}},"wageData":{"2015":{"workers":"1,760","median":"621","maleWorkers":"611","maleMedian":"690","femaleWorkers":"1,149","femaleMedian":"604"}}},"Eligibility interviewers, government programs":{"ageData":{"2015":{"total":"74","16to19":"0","20to24":"2","25to34":"19","35to44":"21","45to54":"14","55to64":"15","65+":"4","medianAge":"15"}},"title":"Eligibility interviewers, government programs","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"74","women":"77.3","white":"25.1","black":"2.3","asian":"33.3"}},"wageData":{"2015":{"workers":"67","median":"781","maleWorkers":"17","maleMedian":"-","femaleWorkers":"50","femaleMedian":"805"}}},"File clerks":{"ageData":{"2015":{"total":"203","16to19":"11","20to24":"28","25to34":"45","35to44":"35","45to54":"36","55to64":"31","65+":"17","medianAge":"31"}},"title":"File clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"203","women":"82.2","white":"12.9","black":"4.2","asian":"13.4"}},"wageData":{"2015":{"workers":"145","median":"634","maleWorkers":"25","maleMedian":"-","femaleWorkers":"120","femaleMedian":"627"}}},"Hotel, motel, and resort desk clerks":{"ageData":{"2015":{"total":"156","16to19":"5","20to24":"37","25to34":"58","35to44":"24","45to54":"15","55to64":"11","65+":"6","medianAge":"11"}},"title":"Hotel, motel, and resort desk clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"156","women":"59.5","white":"18.0","black":"10.7","asian":"18.7"}},"wageData":{"2015":{"workers":"127","median":"481","maleWorkers":"58","maleMedian":"486","femaleWorkers":"69","femaleMedian":"467"}}},"Interviewers, except eligibility and loan":{"ageData":{"2015":{"total":"151","16to19":"3","20to24":"22","25to34":"33","35to44":"28","45to54":"33","55to64":"23","65+":"10","medianAge":"23"}},"title":"Interviewers, except eligibility and loan","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"151","women":"83.2","white":"16.1","black":"3.7","asian":"18.3"}},"wageData":{"2015":{"workers":"105","median":"615","maleWorkers":"16","maleMedian":"-","femaleWorkers":"89","femaleMedian":"617"}}},"Library assistants, clerical":{"ageData":{"2015":{"total":"98","16to19":"8","20to24":"23","25to34":"15","35to44":"13","45to54":"20","55to64":"10","65+":"9","medianAge":"10"}},"title":"Library assistants, clerical","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"98","women":"77.3","white":"8.0","black":"7.5","asian":"10.6"}},"wageData":{"2015":{"workers":"35","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Loan interviewers and clerks":{"ageData":{"2015":{"total":"139","16to19":"0","20to24":"9","25to34":"42","35to44":"40","45to54":"26","55to64":"18","65+":"4","medianAge":"18"}},"title":"Loan interviewers and clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"139","women":"83.5","white":"12.8","black":"4.1","asian":"16.5"}},"wageData":{"2015":{"workers":"134","median":"710","maleWorkers":"25","maleMedian":"-","femaleWorkers":"109","femaleMedian":"722"}}},"New accounts clerks":{"ageData":{"2015":{"total":"26","16to19":"1","20to24":"3","25to34":"6","35to44":"4","45to54":"4","55to64":"8","65+":"0","medianAge":"8"}},"title":"New accounts clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"26","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"20","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Order clerks":{"ageData":{"2015":{"total":"84","16to19":"2","20to24":"9","25to34":"23","35to44":"17","45to54":"15","55to64":"14","65+":"4","medianAge":"14"}},"title":"Order clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"84","women":"65.6","white":"14.5","black":"4.4","asian":"16.6"}},"wageData":{"2015":{"workers":"74","median":"599","maleWorkers":"26","maleMedian":"-","femaleWorkers":"48","femaleMedian":"-"}}},"Human resources assistants, except payroll and timekeeping":{"ageData":{"2015":{"total":"59","16to19":"0","20to24":"8","25to34":"17","35to44":"13","45to54":"12","55to64":"7","65+":"2","medianAge":"7"}},"title":"Human resources assistants, except payroll and timekeeping","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"59","women":"82.9","white":"18.9","black":"3.5","asian":"7.1"}},"wageData":{"2015":{"workers":"50","median":"737","maleWorkers":"11","maleMedian":"-","femaleWorkers":"40","femaleMedian":"-"}}},"Receptionists and information clerks":{"ageData":{"2015":{"total":"1,232","16to19":"52","20to24":"222","25to34":"278","35to44":"200","45to54":"203","55to64":"188","65+":"89","medianAge":"188"}},"title":"Receptionists and information clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"1,232","women":"90.6","white":"13.4","black":"3.7","asian":"17.7"}},"wageData":{"2015":{"workers":"852","median":"575","maleWorkers":"72","maleMedian":"619","femaleWorkers":"781","femaleMedian":"569"}}},"Reservation and transportation ticket agents and travel clerks":{"ageData":{"2015":{"total":"111","16to19":"2","20to24":"14","25to34":"28","35to44":"20","45to54":"25","55to64":"18","65+":"4","medianAge":"18"}},"title":"Reservation and transportation ticket agents and travel clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"111","women":"61.3","white":"16.4","black":"6.4","asian":"18.6"}},"wageData":{"2015":{"workers":"95","median":"713","maleWorkers":"34","maleMedian":"-","femaleWorkers":"61","femaleMedian":"680"}}},"Information and record clerks, all other":{"ageData":{"2015":{"total":"127","16to19":"1","20to24":"15","25to34":"27","35to44":"27","45to54":"27","55to64":"24","65+":"6","medianAge":"24"}},"title":"Information and record clerks, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"127","women":"76.9","white":"17.7","black":"7.5","asian":"13.4"}},"wageData":{"2015":{"workers":"100","median":"618","maleWorkers":"22","maleMedian":"-","femaleWorkers":"78","femaleMedian":"616"}}},"Cargo and freight agents":{"ageData":{"2015":{"total":"21","16to19":"0","20to24":"2","25to34":"4","35to44":"3","45to54":"7","55to64":"4","65+":"0","medianAge":"4"}},"title":"Cargo and freight agents","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"21","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"20","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Couriers and messengers":{"ageData":{"2015":{"total":"235","16to19":"7","20to24":"21","25to34":"51","35to44":"41","45to54":"58","55to64":"44","65+":"12","medianAge":"44"}},"title":"Couriers and messengers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"235","women":"14.3","white":"20.4","black":"4.0","asian":"18.6"}},"wageData":{"2015":{"workers":"153","median":"752","maleWorkers":"134","maleMedian":"750","femaleWorkers":"19","femaleMedian":"-"}}},"Dispatchers":{"ageData":{"2015":{"total":"277","16to19":"3","20to24":"28","25to34":"72","35to44":"63","45to54":"67","55to64":"37","65+":"8","medianAge":"37"}},"title":"Dispatchers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"277","women":"56.3","white":"13.4","black":"2.3","asian":"12.8"}},"wageData":{"2015":{"workers":"250","median":"698","maleWorkers":"109","maleMedian":"759","femaleWorkers":"141","femaleMedian":"655"}}},"Meter readers, utilities":{"ageData":{"2015":{"total":"41","16to19":"1","20to24":"4","25to34":"6","35to44":"11","45to54":"12","55to64":"5","65+":"1","medianAge":"5"}},"title":"Meter readers, utilities","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"41","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"39","median":"-","maleWorkers":"34","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Postal service clerks":{"ageData":{"2015":{"total":"130","16to19":"0","20to24":"9","25to34":"15","35to44":"16","45to54":"33","55to64":"48","65+":"8","medianAge":"48"}},"title":"Postal service clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"130","women":"46.0","white":"33.5","black":"8.7","asian":"6.3"}},"wageData":{"2015":{"workers":"127","median":"927","maleWorkers":"76","maleMedian":"974","femaleWorkers":"51","femaleMedian":"833"}}},"Postal service mail carriers":{"ageData":{"2015":{"total":"320","16to19":"2","20to24":"10","25to34":"54","35to44":"50","45to54":"100","55to64":"93","65+":"13","medianAge":"93"}},"title":"Postal service mail carriers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"320","women":"41.2","white":"20.3","black":"6.8","asian":"13.1"}},"wageData":{"2015":{"workers":"302","median":"954","maleWorkers":"187","maleMedian":"1,021","femaleWorkers":"115","femaleMedian":"854"}}},"Postal service mail sorters, processors, and processing machine operators":{"ageData":{"2015":{"total":"64","16to19":"0","20to24":"6","25to34":"7","35to44":"8","45to54":"23","55to64":"17","65+":"3","medianAge":"17"}},"title":"Postal service mail sorters, processors, and processing machine operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"64","women":"50.0","white":"29.9","black":"8.1","asian":"9.4"}},"wageData":{"2015":{"workers":"53","median":"828","maleWorkers":"27","maleMedian":"-","femaleWorkers":"26","femaleMedian":"-"}}},"Production, planning, and expediting clerks":{"ageData":{"2015":{"total":"286","16to19":"2","20to24":"19","25to34":"68","35to44":"63","45to54":"72","55to64":"56","65+":"7","medianAge":"56"}},"title":"Production, planning, and expediting clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"286","women":"55.0","white":"10.3","black":"4.6","asian":"12.0"}},"wageData":{"2015":{"workers":"256","median":"838","maleWorkers":"116","maleMedian":"978","femaleWorkers":"141","femaleMedian":"732"}}},"Shipping, receiving, and traffic clerks":{"ageData":{"2015":{"total":"575","16to19":"11","20to24":"78","25to34":"145","35to44":"110","45to54":"117","55to64":"91","65+":"22","medianAge":"91"}},"title":"Shipping, receiving, and traffic clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"575","women":"29.5","white":"14.7","black":"3.5","asian":"27.0"}},"wageData":{"2015":{"workers":"502","median":"591","maleWorkers":"354","maleMedian":"604","femaleWorkers":"148","femaleMedian":"566"}}},"Stock clerks and order fillers":{"ageData":{"2015":{"total":"1,529","16to19":"142","20to24":"325","25to34":"331","35to44":"223","45to54":"256","55to64":"187","65+":"65","medianAge":"187"}},"title":"Stock clerks and order fillers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"1,529","women":"35.8","white":"18.2","black":"4.5","asian":"20.2"}},"wageData":{"2015":{"workers":"1,027","median":"520","maleWorkers":"651","maleMedian":"537","femaleWorkers":"376","femaleMedian":"506"}}},"Weighers, measurers, checkers, and samplers, recordkeeping":{"ageData":{"2015":{"total":"72","16to19":"1","20to24":"7","25to34":"18","35to44":"17","45to54":"17","55to64":"11","65+":"0","medianAge":"11"}},"title":"Weighers, measurers, checkers, and samplers, recordkeeping","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"72","women":"57.8","white":"13.1","black":"6.6","asian":"23.7"}},"wageData":{"2015":{"workers":"59","median":"629","maleWorkers":"29","maleMedian":"-","femaleWorkers":"31","femaleMedian":"-"}}},"Secretaries and administrative assistants":{"ageData":{"2015":{"total":"2,870","16to19":"20","20to24":"169","25to34":"497","35to44":"552","45to54":"724","55to64":"687","65+":"221","medianAge":"687"}},"title":"Secretaries and administrative assistants","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"2,870","women":"94.5","white":"10.4","black":"3.5","asian":"11.9"}},"wageData":{"2015":{"workers":"2,223","median":"687","maleWorkers":"124","maleMedian":"786","femaleWorkers":"2,099","femaleMedian":"683"}}},"Computer operators":{"ageData":{"2015":{"total":"69","16to19":"0","20to24":"5","25to34":"15","35to44":"14","45to54":"17","55to64":"15","65+":"2","medianAge":"15"}},"title":"Computer operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"69","women":"46.8","white":"13.5","black":"5.3","asian":"13.7"}},"wageData":{"2015":{"workers":"58","median":"751","maleWorkers":"25","maleMedian":"-","femaleWorkers":"33","femaleMedian":"-"}}},"Data entry keyers":{"ageData":{"2015":{"total":"281","16to19":"7","20to24":"34","25to34":"75","35to44":"52","45to54":"50","55to64":"45","65+":"19","medianAge":"45"}},"title":"Data entry keyers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"281","women":"74.3","white":"13.8","black":"7.7","asian":"15.1"}},"wageData":{"2015":{"workers":"223","median":"619","maleWorkers":"55","maleMedian":"589","femaleWorkers":"169","femaleMedian":"638"}}},"Word processors and typists":{"ageData":{"2015":{"total":"103","16to19":"2","20to24":"7","25to34":"15","35to44":"20","45to54":"21","55to64":"28","65+":"11","medianAge":"28"}},"title":"Word processors and typists","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"103","women":"92.1","white":"15.0","black":"5.0","asian":"9.9"}},"wageData":{"2015":{"workers":"68","median":"650","maleWorkers":"6","maleMedian":"-","femaleWorkers":"62","femaleMedian":"639"}}},"Desktop publishers":{"ageData":{"2015":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"1","medianAge":"0"}},"title":"Desktop publishers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Insurance claims and policy processing clerks":{"ageData":{"2015":{"total":"287","16to19":"1","20to24":"23","25to34":"76","35to44":"62","45to54":"59","55to64":"53","65+":"12","medianAge":"53"}},"title":"Insurance claims and policy processing clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"287","women":"77.1","white":"17.7","black":"5.0","asian":"7.7"}},"wageData":{"2015":{"workers":"259","median":"689","maleWorkers":"56","maleMedian":"762","femaleWorkers":"203","femaleMedian":"675"}}},"Mail clerks and mail machine operators, except postal service":{"ageData":{"2015":{"total":"81","16to19":"2","20to24":"10","25to34":"10","35to44":"10","45to54":"21","55to64":"24","65+":"4","medianAge":"24"}},"title":"Mail clerks and mail machine operators, except postal service","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"81","women":"59.4","white":"25.1","black":"10.9","asian":"18.4"}},"wageData":{"2015":{"workers":"63","median":"563","maleWorkers":"24","maleMedian":"-","femaleWorkers":"39","femaleMedian":"-"}}},"Office clerks, general":{"ageData":{"2015":{"total":"1,288","16to19":"57","20to24":"173","25to34":"255","35to44":"219","45to54":"256","55to64":"245","65+":"84","medianAge":"245"}},"title":"Office clerks, general","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"1,288","women":"82.3","white":"13.4","black":"6.7","asian":"18.6"}},"wageData":{"2015":{"workers":"929","median":"620","maleWorkers":"156","maleMedian":"609","femaleWorkers":"773","femaleMedian":"622"}}},"Office machine operators, except computer":{"ageData":{"2015":{"total":"37","16to19":"1","20to24":"4","25to34":"7","35to44":"6","45to54":"13","55to64":"5","65+":"1","medianAge":"5"}},"title":"Office machine operators, except computer","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"37","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"31","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Proofreaders and copy markers":{"ageData":{"2015":{"total":"8","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"0","55to64":"4","65+":"1","medianAge":"4"}},"title":"Proofreaders and copy markers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"2","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Statistical assistants":{"ageData":{"2015":{"total":"17","16to19":"0","20to24":"4","25to34":"2","35to44":"5","45to54":"2","55to64":"4","65+":"0","medianAge":"4"}},"title":"Statistical assistants","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"17","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"15","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Office and administrative support workers, all other":{"ageData":{"2015":{"total":"477","16to19":"7","20to24":"35","25to34":"126","35to44":"87","45to54":"108","55to64":"94","65+":"19","medianAge":"94"}},"title":"Office and administrative support workers, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2015":{"total":"477","women":"77.4","white":"12.9","black":"3.9","asian":"13.8"}},"wageData":{"2015":{"workers":"391","median":"745","maleWorkers":"93","maleMedian":"852","femaleWorkers":"298","femaleMedian":"718"}}},"Natural resources, construction, and maintenance occupations":{"ageData":{"2015":{"total":"13,733","16to19":"293","20to24":"1,169","25to34":"3,248","35to44":"3,258","45to54":"3,099","55to64":"2,187","65+":"478","medianAge":"2,187"}},"title":"Natural resources, construction, and maintenance occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2015":{"total":"13,733","women":"4.7","white":"7.3","black":"1.9","asian":"29.0"}},"wageData":{"2015":{"workers":"10,834","median":"761","maleWorkers":"10,381","maleMedian":"770","femaleWorkers":"453","femaleMedian":"580"}}},"Farming, fishing, and forestry occupations":{"ageData":{"2015":{"total":"1,073","16to19":"78","20to24":"113","25to34":"268","35to44":"226","45to54":"193","55to64":"145","65+":"50","medianAge":"145"}},"title":"Farming, fishing, and forestry occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2015":{"total":"1,073","women":"24.2","white":"5.1","black":"1.3","asian":"45.7"}},"wageData":{"2015":{"workers":"810","median":"464","maleWorkers":"637","maleMedian":"477","femaleWorkers":"174","femaleMedian":"437"}}},"First-line supervisors of farming, fishing, and forestry workers":{"ageData":{"2015":{"total":"54","16to19":"0","20to24":"3","25to34":"14","35to44":"10","45to54":"9","55to64":"13","65+":"4","medianAge":"13"}},"title":"First-line supervisors of farming, fishing, and forestry workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2015":{"total":"54","women":"21.2","white":"1.4","black":"0.0","asian":"41.6"}},"wageData":{"2015":{"workers":"42","median":"-","maleWorkers":"32","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Agricultural inspectors":{"ageData":{"2015":{"total":"18","16to19":"0","20to24":"1","25to34":"5","35to44":"2","45to54":"3","55to64":"6","65+":"1","medianAge":"6"}},"title":"Agricultural inspectors","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2015":{"total":"18","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"12","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Animal breeders":{"ageData":{"2015":{"total":"8","16to19":"0","20to24":"0","25to34":"3","35to44":"2","45to54":"1","55to64":"1","65+":"1","medianAge":"1"}},"title":"Animal breeders","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2015":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Graders and sorters, agricultural products":{"ageData":{"2015":{"total":"97","16to19":"3","20to24":"10","25to34":"27","35to44":"20","45to54":"16","55to64":"18","65+":"2","medianAge":"18"}},"title":"Graders and sorters, agricultural products","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2015":{"total":"97","women":"61.7","white":"18.6","black":"3.8","asian":"54.3"}},"wageData":{"2015":{"workers":"83","median":"486","maleWorkers":"32","maleMedian":"-","femaleWorkers":"51","femaleMedian":"468"}}},"Miscellaneous agricultural workers":{"ageData":{"2015":{"total":"789","16to19":"71","20to24":"93","25to34":"198","35to44":"167","45to54":"135","55to64":"89","65+":"36","medianAge":"89"}},"title":"Miscellaneous agricultural workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2015":{"total":"789","women":"21.9","white":"3.5","black":"1.1","asian":"50.7"}},"wageData":{"2015":{"workers":"613","median":"445","maleWorkers":"511","maleMedian":"460","femaleWorkers":"102","femaleMedian":"398"}}},"Fishers and related fishing workers":{"ageData":{"2015":{"total":"39","16to19":"3","20to24":"3","25to34":"8","35to44":"7","45to54":"11","55to64":"7","65+":"0","medianAge":"7"}},"title":"Fishers and related fishing workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2015":{"total":"39","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"11","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Hunters and trappers":{"ageData":{"2015":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Hunters and trappers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2015":{"total":"0","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Forest and conservation workers":{"ageData":{"2015":{"total":"18","16to19":"1","20to24":"1","25to34":"5","35to44":"4","45to54":"4","55to64":"2","65+":"1","medianAge":"2"}},"title":"Forest and conservation workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2015":{"total":"18","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"15","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Logging workers":{"ageData":{"2015":{"total":"51","16to19":"0","20to24":"3","25to34":"9","35to44":"13","45to54":"15","55to64":"7","65+":"5","medianAge":"7"}},"title":"Logging workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2015":{"total":"51","women":"2.8","white":"10.4","black":"0.0","asian":"11.0"}},"wageData":{"2015":{"workers":"31","median":"-","maleWorkers":"31","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Construction and extraction occupations":{"ageData":{"2015":{"total":"7,652","16to19":"142","20to24":"630","25to34":"1,857","35to44":"1,918","45to54":"1,702","55to64":"1,155","65+":"248","medianAge":"1,155"}},"title":"Construction and extraction occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2015":{"total":"7,652","women":"2.7","white":"6.9","black":"1.3","asian":"33.3"}},"wageData":{"2015":{"workers":"5,722","median":"749","maleWorkers":"5,586","maleMedian":"751","femaleWorkers":"137","femaleMedian":"704"}}},"First-line supervisors of construction trades and extraction workers":{"ageData":{"2015":{"total":"712","16to19":"3","20to24":"18","25to34":"120","35to44":"180","45to54":"215","55to64":"147","65+":"28","medianAge":"147"}},"title":"First-line supervisors of construction trades and extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"712","women":"3.3","white":"6.2","black":"1.2","asian":"16.7"}},"wageData":{"2015":{"workers":"560","median":"1,040","maleWorkers":"540","maleMedian":"1,047","femaleWorkers":"20","femaleMedian":"-"}}},"Boilermakers":{"ageData":{"2015":{"total":"20","16to19":"0","20to24":"1","25to34":"5","35to44":"5","45to54":"4","55to64":"5","65+":"0","medianAge":"5"}},"title":"Boilermakers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"20","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"21","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Brickmasons, blockmasons, and stonemasons":{"ageData":{"2015":{"total":"172","16to19":"3","20to24":"11","25to34":"54","35to44":"49","45to54":"31","55to64":"20","65+":"5","medianAge":"20"}},"title":"Brickmasons, blockmasons, and stonemasons","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"172","women":"0.7","white":"5.3","black":"0.0","asian":"43.3"}},"wageData":{"2015":{"workers":"122","median":"652","maleWorkers":"122","maleMedian":"652","femaleWorkers":"0","femaleMedian":"-"}}},"Carpenters":{"ageData":{"2015":{"total":"1,281","16to19":"15","20to24":"96","25to34":"295","35to44":"336","45to54":"302","55to64":"195","65+":"41","medianAge":"195"}},"title":"Carpenters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"1,281","women":"1.8","white":"5.4","black":"1.2","asian":"32.8"}},"wageData":{"2015":{"workers":"802","median":"687","maleWorkers":"792","maleMedian":"687","femaleWorkers":"10","femaleMedian":"-"}}},"Carpet, floor, and tile installers and finishers":{"ageData":{"2015":{"total":"156","16to19":"2","20to24":"7","25to34":"45","35to44":"45","45to54":"29","55to64":"22","65+":"7","medianAge":"22"}},"title":"Carpet, floor, and tile installers and finishers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"156","women":"1.7","white":"6.2","black":"2.1","asian":"47.1"}},"wageData":{"2015":{"workers":"89","median":"637","maleWorkers":"89","maleMedian":"634","femaleWorkers":"1","femaleMedian":"-"}}},"Cement masons, concrete finishers, and terrazzo workers":{"ageData":{"2015":{"total":"54","16to19":"1","20to24":"5","25to34":"15","35to44":"14","45to54":"9","55to64":"7","65+":"3","medianAge":"7"}},"title":"Cement masons, concrete finishers, and terrazzo workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"54","women":"0.2","white":"12.1","black":"0.0","asian":"49.2"}},"wageData":{"2015":{"workers":"44","median":"-","maleWorkers":"44","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Construction laborers":{"ageData":{"2015":{"total":"1,649","16to19":"52","20to24":"179","25to34":"435","35to44":"425","45to54":"318","55to64":"198","65+":"41","medianAge":"198"}},"title":"Construction laborers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"1,649","women":"2.9","white":"8.1","black":"1.9","asian":"45.5"}},"wageData":{"2015":{"workers":"1,181","median":"639","maleWorkers":"1,155","maleMedian":"642","femaleWorkers":"25","femaleMedian":"-"}}},"Paving, surfacing, and tamping equipment operators":{"ageData":{"2015":{"total":"12","16to19":"0","20to24":"2","25to34":"1","35to44":"2","45to54":"4","55to64":"4","65+":"0","medianAge":"4"}},"title":"Paving, surfacing, and tamping equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"10","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Pile-driver operators":{"ageData":{"2015":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Pile-driver operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Operating engineers and other construction equipment operators":{"ageData":{"2015":{"total":"357","16to19":"3","20to24":"25","25to34":"85","35to44":"69","45to54":"89","55to64":"68","65+":"19","medianAge":"68"}},"title":"Operating engineers and other construction equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"357","women":"1.9","white":"7.5","black":"0.1","asian":"21.1"}},"wageData":{"2015":{"workers":"324","median":"856","maleWorkers":"318","maleMedian":"859","femaleWorkers":"6","femaleMedian":"-"}}},"Drywall installers, ceiling tile installers, and tapers":{"ageData":{"2015":{"total":"151","16to19":"0","20to24":"11","25to34":"43","35to44":"59","45to54":"22","55to64":"11","65+":"4","medianAge":"11"}},"title":"Drywall installers, ceiling tile installers, and tapers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"151","women":"1.6","white":"5.5","black":"0.2","asian":"61.8"}},"wageData":{"2015":{"workers":"121","median":"596","maleWorkers":"119","maleMedian":"595","femaleWorkers":"2","femaleMedian":"-"}}},"Electricians":{"ageData":{"2015":{"total":"773","16to19":"14","20to24":"78","25to34":"185","35to44":"178","45to54":"173","55to64":"122","65+":"23","medianAge":"122"}},"title":"Electricians","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"773","women":"2.3","white":"8.8","black":"1.9","asian":"19.3"}},"wageData":{"2015":{"workers":"651","median":"888","maleWorkers":"632","maleMedian":"891","femaleWorkers":"19","femaleMedian":"-"}}},"Glaziers":{"ageData":{"2015":{"total":"47","16to19":"1","20to24":"8","25to34":"8","35to44":"12","45to54":"9","55to64":"8","65+":"1","medianAge":"8"}},"title":"Glaziers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"47","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"33","median":"-","maleWorkers":"32","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Insulation workers":{"ageData":{"2015":{"total":"49","16to19":"1","20to24":"4","25to34":"14","35to44":"13","45to54":"9","55to64":"7","65+":"0","medianAge":"7"}},"title":"Insulation workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"49","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"43","median":"-","maleWorkers":"41","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Painters, construction and maintenance":{"ageData":{"2015":{"total":"572","16to19":"10","20to24":"39","25to34":"124","35to44":"158","45to54":"136","55to64":"86","65+":"19","medianAge":"86"}},"title":"Painters, construction and maintenance","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"572","women":"5.7","white":"5.6","black":"1.8","asian":"49.3"}},"wageData":{"2015":{"workers":"344","median":"585","maleWorkers":"330","maleMedian":"587","femaleWorkers":"14","femaleMedian":"-"}}},"Paperhangers":{"ageData":{"2015":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Paperhangers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Pipelayers, plumbers, pipefitters, and steamfitters":{"ageData":{"2015":{"total":"573","16to19":"9","20to24":"37","25to34":"143","35to44":"140","45to54":"132","55to64":"89","65+":"24","medianAge":"89"}},"title":"Pipelayers, plumbers, pipefitters, and steamfitters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"573","women":"0.7","white":"6.8","black":"1.1","asian":"25.0"}},"wageData":{"2015":{"workers":"456","median":"863","maleWorkers":"455","maleMedian":"862","femaleWorkers":"2","femaleMedian":"-"}}},"Plasterers and stucco masons":{"ageData":{"2015":{"total":"28","16to19":"1","20to24":"3","25to34":"8","35to44":"9","45to54":"3","55to64":"4","65+":"1","medianAge":"4"}},"title":"Plasterers and stucco masons","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"28","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"20","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Reinforcing iron and rebar workers":{"ageData":{"2015":{"total":"10","16to19":"0","20to24":"2","25to34":"3","35to44":"1","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Reinforcing iron and rebar workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"9","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Roofers":{"ageData":{"2015":{"total":"221","16to19":"6","20to24":"22","25to34":"73","35to44":"59","45to54":"37","55to64":"21","65+":"4","medianAge":"21"}},"title":"Roofers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"221","women":"2.3","white":"6.0","black":"1.4","asian":"51.2"}},"wageData":{"2015":{"workers":"171","median":"584","maleWorkers":"170","maleMedian":"580","femaleWorkers":"2","femaleMedian":"-"}}},"Sheet metal workers":{"ageData":{"2015":{"total":"122","16to19":"3","20to24":"11","25to34":"28","35to44":"31","45to54":"24","55to64":"23","65+":"3","medianAge":"23"}},"title":"Sheet metal workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"122","women":"4.5","white":"2.4","black":"0.7","asian":"15.7"}},"wageData":{"2015":{"workers":"106","median":"766","maleWorkers":"100","maleMedian":"776","femaleWorkers":"6","femaleMedian":"-"}}},"Structural iron and steel workers":{"ageData":{"2015":{"total":"58","16to19":"1","20to24":"2","25to34":"14","35to44":"12","45to54":"18","55to64":"10","65+":"1","medianAge":"10"}},"title":"Structural iron and steel workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"58","women":"2.2","white":"6.4","black":"2.8","asian":"19.8"}},"wageData":{"2015":{"workers":"54","median":"869","maleWorkers":"52","maleMedian":"864","femaleWorkers":"2","femaleMedian":"-"}}},"Solar photovoltaic installers":{"ageData":{"2015":{"total":"11","16to19":"0","20to24":"1","25to34":"3","35to44":"3","45to54":"2","55to64":"2","65+":"1","medianAge":"2"}},"title":"Solar photovoltaic installers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"8","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers, construction trades":{"ageData":{"2015":{"total":"52","16to19":"5","20to24":"13","25to34":"13","35to44":"8","45to54":"8","55to64":"5","65+":"0","medianAge":"5"}},"title":"Helpers, construction trades","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"52","women":"1.3","white":"7.0","black":"2.8","asian":"44.7"}},"wageData":{"2015":{"workers":"47","median":"-","maleWorkers":"47","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Construction and building inspectors":{"ageData":{"2015":{"total":"90","16to19":"0","20to24":"2","25to34":"14","35to44":"18","45to54":"24","55to64":"22","65+":"10","medianAge":"22"}},"title":"Construction and building inspectors","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"90","women":"9.9","white":"9.5","black":"1.0","asian":"8.2"}},"wageData":{"2015":{"workers":"67","median":"939","maleWorkers":"58","maleMedian":"965","femaleWorkers":"9","femaleMedian":"-"}}},"Elevator installers and repairers":{"ageData":{"2015":{"total":"30","16to19":"0","20to24":"2","25to34":"8","35to44":"8","45to54":"6","55to64":"5","65+":"0","medianAge":"5"}},"title":"Elevator installers and repairers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"30","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"23","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Fence erectors":{"ageData":{"2015":{"total":"34","16to19":"2","20to24":"3","25to34":"8","35to44":"11","45to54":"6","55to64":"1","65+":"2","medianAge":"1"}},"title":"Fence erectors","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"34","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"33","median":"-","maleWorkers":"33","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Hazardous materials removal workers":{"ageData":{"2015":{"total":"42","16to19":"1","20to24":"4","25to34":"11","35to44":"6","45to54":"12","55to64":"8","65+":"0","medianAge":"8"}},"title":"Hazardous materials removal workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"42","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"39","median":"-","maleWorkers":"35","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Highway maintenance workers":{"ageData":{"2015":{"total":"103","16to19":"4","20to24":"8","25to34":"15","35to44":"10","45to54":"33","55to64":"29","65+":"4","medianAge":"29"}},"title":"Highway maintenance workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"103","women":"2.0","white":"13.4","black":"0.9","asian":"16.5"}},"wageData":{"2015":{"workers":"91","median":"754","maleWorkers":"91","maleMedian":"755","femaleWorkers":"0","femaleMedian":"-"}}},"Rail-track laying and maintenance equipment operators":{"ageData":{"2015":{"total":"11","16to19":"0","20to24":"2","25to34":"1","35to44":"2","45to54":"3","55to64":"3","65+":"0","medianAge":"3"}},"title":"Rail-track laying and maintenance equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"9","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Septic tank servicers and sewer pipe cleaners":{"ageData":{"2015":{"total":"12","16to19":"0","20to24":"2","25to34":"3","35to44":"1","45to54":"3","55to64":"3","65+":"0","medianAge":"3"}},"title":"Septic tank servicers and sewer pipe cleaners","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"8","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Miscellaneous construction and related workers":{"ageData":{"2015":{"total":"32","16to19":"0","20to24":"2","25to34":"8","35to44":"7","45to54":"9","55to64":"6","65+":"1","medianAge":"6"}},"title":"Miscellaneous construction and related workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"32","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"25","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Derrick, rotary drill, and service unit operators, oil, gas, and mining":{"ageData":{"2015":{"total":"34","16to19":"1","20to24":"4","25to34":"14","35to44":"7","45to54":"5","55to64":"3","65+":"1","medianAge":"3"}},"title":"Derrick, rotary drill, and service unit operators, oil, gas, and mining","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"34","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"28","median":"-","maleWorkers":"27","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Earth drillers, except oil and gas":{"ageData":{"2015":{"total":"29","16to19":"1","20to24":"2","25to34":"7","35to44":"9","45to54":"6","55to64":"3","65+":"1","medianAge":"3"}},"title":"Earth drillers, except oil and gas","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"29","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"30","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Explosives workers, ordnance handling experts, and blasters":{"ageData":{"2015":{"total":"9","16to19":"1","20to24":"0","25to34":"3","35to44":"1","45to54":"3","55to64":"0","65+":"1","medianAge":"0"}},"title":"Explosives workers, ordnance handling experts, and blasters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Mining machine operators":{"ageData":{"2015":{"total":"67","16to19":"1","20to24":"11","25to34":"20","35to44":"19","45to54":"9","55to64":"7","65+":"0","medianAge":"7"}},"title":"Mining machine operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"67","women":"2.5","white":"4.1","black":"0.0","asian":"16.3"}},"wageData":{"2015":{"workers":"68","median":"1,106","maleWorkers":"65","maleMedian":"1,098","femaleWorkers":"2","femaleMedian":"-"}}},"Roof bolters, mining":{"ageData":{"2015":{"total":"2","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Roof bolters, mining","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Roustabouts, oil and gas":{"ageData":{"2015":{"total":"9","16to19":"1","20to24":"1","25to34":"3","35to44":"2","45to54":"0","55to64":"1","65+":"1","medianAge":"1"}},"title":"Roustabouts, oil and gas","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers--extraction workers":{"ageData":{"2015":{"total":"4","16to19":"0","20to24":"2","25to34":"1","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Helpers--extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Other extraction workers":{"ageData":{"2015":{"total":"64","16to19":"2","20to24":"9","25to34":"26","35to44":"9","45to54":"7","55to64":"9","65+":"1","medianAge":"9"}},"title":"Other extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2015":{"total":"64","women":"3.8","white":"3.1","black":"0.5","asian":"26.8"}},"wageData":{"2015":{"workers":"61","median":"900","maleWorkers":"58","maleMedian":"918","femaleWorkers":"3","femaleMedian":"-"}}},"Installation, maintenance, and repair occupations":{"ageData":{"2015":{"total":"5,008","16to19":"73","20to24":"426","25to34":"1,123","35to44":"1,114","45to54":"1,204","55to64":"888","65+":"180","medianAge":"888"}},"title":"Installation, maintenance, and repair occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2015":{"total":"5,008","women":"3.5","white":"8.3","black":"3.1","asian":"18.9"}},"wageData":{"2015":{"workers":"4,301","median":"839","maleWorkers":"4,159","maleMedian":"842","femaleWorkers":"143","femaleMedian":"761"}}},"First-line supervisors of mechanics, installers, and repairers":{"ageData":{"2015":{"total":"262","16to19":"0","20to24":"1","25to34":"32","35to44":"63","45to54":"86","55to64":"72","65+":"7","medianAge":"72"}},"title":"First-line supervisors of mechanics, installers, and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"262","women":"6.1","white":"8.5","black":"3.3","asian":"11.4"}},"wageData":{"2015":{"workers":"270","median":"1,032","maleWorkers":"252","maleMedian":"1,033","femaleWorkers":"18","femaleMedian":"-"}}},"Computer, automated teller, and office machine repairers":{"ageData":{"2015":{"total":"241","16to19":"6","20to24":"22","25to34":"63","35to44":"54","45to54":"47","55to64":"40","65+":"7","medianAge":"40"}},"title":"Computer, automated teller, and office machine repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"241","women":"13.2","white":"18.4","black":"8.2","asian":"9.8"}},"wageData":{"2015":{"workers":"194","median":"856","maleWorkers":"166","maleMedian":"865","femaleWorkers":"28","femaleMedian":"-"}}},"Radio and telecommunications equipment installers and repairers":{"ageData":{"2015":{"total":"158","16to19":"2","20to24":"19","25to34":"42","35to44":"36","45to54":"33","55to64":"22","65+":"4","medianAge":"22"}},"title":"Radio and telecommunications equipment installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"158","women":"8.5","white":"11.7","black":"8.2","asian":"11.8"}},"wageData":{"2015":{"workers":"139","median":"862","maleWorkers":"126","maleMedian":"879","femaleWorkers":"13","femaleMedian":"-"}}},"Avionics technicians":{"ageData":{"2015":{"total":"5","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Avionics technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electric motor, power tool, and related repairers":{"ageData":{"2015":{"total":"23","16to19":"0","20to24":"3","25to34":"4","35to44":"6","45to54":"7","55to64":"3","65+":"0","medianAge":"3"}},"title":"Electric motor, power tool, and related repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"23","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"22","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Electrical and electronics installers and repairers, transportation equipment":{"ageData":{"2015":{"total":"1","16to19":"0","20to24":"1","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Electrical and electronics installers and repairers, transportation equipment","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electrical and electronics repairers, industrial and utility":{"ageData":{"2015":{"total":"20","16to19":"0","20to24":"0","25to34":"5","35to44":"5","45to54":"5","55to64":"5","65+":"0","medianAge":"5"}},"title":"Electrical and electronics repairers, industrial and utility","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"20","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"18","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electronic equipment installers and repairers, motor vehicles":{"ageData":{"2015":{"total":"18","16to19":"0","20to24":"3","25to34":"4","35to44":"1","45to54":"5","55to64":"5","65+":"0","medianAge":"5"}},"title":"Electronic equipment installers and repairers, motor vehicles","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"18","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"17","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electronic home entertainment equipment installers and repairers":{"ageData":{"2015":{"total":"38","16to19":"1","20to24":"3","25to34":"11","35to44":"8","45to54":"8","55to64":"5","65+":"2","medianAge":"5"}},"title":"Electronic home entertainment equipment installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"38","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"30","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Security and fire alarm systems installers":{"ageData":{"2015":{"total":"74","16to19":"1","20to24":"8","25to34":"14","35to44":"21","45to54":"13","55to64":"15","65+":"2","medianAge":"15"}},"title":"Security and fire alarm systems installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"74","women":"3.8","white":"6.0","black":"1.0","asian":"23.1"}},"wageData":{"2015":{"workers":"67","median":"911","maleWorkers":"65","maleMedian":"913","femaleWorkers":"2","femaleMedian":"-"}}},"Aircraft mechanics and service technicians":{"ageData":{"2015":{"total":"140","16to19":"0","20to24":"7","25to34":"32","35to44":"27","45to54":"34","55to64":"35","65+":"6","medianAge":"35"}},"title":"Aircraft mechanics and service technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"140","women":"5.2","white":"8.3","black":"3.1","asian":"13.6"}},"wageData":{"2015":{"workers":"133","median":"1,025","maleWorkers":"125","maleMedian":"1,032","femaleWorkers":"7","femaleMedian":"-"}}},"Automotive body and related repairers":{"ageData":{"2015":{"total":"154","16to19":"5","20to24":"15","25to34":"30","35to44":"37","45to54":"42","55to64":"18","65+":"7","medianAge":"18"}},"title":"Automotive body and related repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"154","women":"0.6","white":"5.4","black":"0.6","asian":"22.9"}},"wageData":{"2015":{"workers":"120","median":"846","maleWorkers":"118","maleMedian":"849","femaleWorkers":"2","femaleMedian":"-"}}},"Automotive glass installers and repairers":{"ageData":{"2015":{"total":"22","16to19":"1","20to24":"4","25to34":"4","35to44":"4","45to54":"5","55to64":"3","65+":"2","medianAge":"3"}},"title":"Automotive glass installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"22","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"21","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Automotive service technicians and mechanics":{"ageData":{"2015":{"total":"924","16to19":"20","20to24":"109","25to34":"214","35to44":"222","45to54":"195","55to64":"136","65+":"28","medianAge":"136"}},"title":"Automotive service technicians and mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"924","women":"1.5","white":"8.2","black":"4.0","asian":"25.7"}},"wageData":{"2015":{"workers":"710","median":"722","maleWorkers":"694","maleMedian":"724","femaleWorkers":"16","femaleMedian":"-"}}},"Bus and truck mechanics and diesel engine specialists":{"ageData":{"2015":{"total":"345","16to19":"3","20to24":"31","25to34":"84","35to44":"82","45to54":"82","55to64":"51","65+":"12","medianAge":"51"}},"title":"Bus and truck mechanics and diesel engine specialists","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"345","women":"0.1","white":"7.5","black":"2.6","asian":"15.8"}},"wageData":{"2015":{"workers":"327","median":"831","maleWorkers":"327","maleMedian":"830","femaleWorkers":"0","femaleMedian":"-"}}},"Heavy vehicle and mobile equipment service technicians and mechanics":{"ageData":{"2015":{"total":"233","16to19":"2","20to24":"21","25to34":"55","35to44":"41","45to54":"66","55to64":"39","65+":"10","medianAge":"39"}},"title":"Heavy vehicle and mobile equipment service technicians and mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"233","women":"0.0","white":"4.8","black":"1.5","asian":"14.3"}},"wageData":{"2015":{"workers":"206","median":"928","maleWorkers":"206","maleMedian":"928","femaleWorkers":"0","femaleMedian":"-"}}},"Small engine mechanics":{"ageData":{"2015":{"total":"54","16to19":"0","20to24":"6","25to34":"17","35to44":"6","45to54":"12","55to64":"7","65+":"5","medianAge":"7"}},"title":"Small engine mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"54","women":"3.1","white":"0.0","black":"1.3","asian":"10.4"}},"wageData":{"2015":{"workers":"39","median":"-","maleWorkers":"39","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Miscellaneous vehicle and mobile equipment mechanics, installers, and repairers":{"ageData":{"2015":{"total":"81","16to19":"8","20to24":"15","25to34":"26","35to44":"15","45to54":"8","55to64":"5","65+":"4","medianAge":"5"}},"title":"Miscellaneous vehicle and mobile equipment mechanics, installers, and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"81","women":"1.9","white":"4.5","black":"1.0","asian":"24.4"}},"wageData":{"2015":{"workers":"66","median":"592","maleWorkers":"65","maleMedian":"591","femaleWorkers":"1","femaleMedian":"-"}}},"Control and valve installers and repairers":{"ageData":{"2015":{"total":"29","16to19":"0","20to24":"1","25to34":"7","35to44":"6","45to54":"8","55to64":"6","65+":"1","medianAge":"6"}},"title":"Control and valve installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"29","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"23","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Heating, air conditioning, and refrigeration mechanics and installers":{"ageData":{"2015":{"total":"408","16to19":"3","20to24":"40","25to34":"115","35to44":"92","45to54":"88","55to64":"61","65+":"9","medianAge":"61"}},"title":"Heating, air conditioning, and refrigeration mechanics and installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"408","women":"1.7","white":"7.6","black":"2.2","asian":"21.6"}},"wageData":{"2015":{"workers":"341","median":"806","maleWorkers":"337","maleMedian":"810","femaleWorkers":"4","femaleMedian":"-"}}},"Home appliance repairers":{"ageData":{"2015":{"total":"53","16to19":"1","20to24":"2","25to34":"10","35to44":"11","45to54":"10","55to64":"13","65+":"5","medianAge":"13"}},"title":"Home appliance repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"53","women":"3.8","white":"3.7","black":"6.0","asian":"26.8"}},"wageData":{"2015":{"workers":"36","median":"-","maleWorkers":"36","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Industrial and refractory machinery mechanics":{"ageData":{"2015":{"total":"425","16to19":"3","20to24":"27","25to34":"72","35to44":"82","45to54":"130","55to64":"102","65+":"10","medianAge":"102"}},"title":"Industrial and refractory machinery mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"425","women":"3.6","white":"6.6","black":"1.5","asian":"13.6"}},"wageData":{"2015":{"workers":"394","median":"895","maleWorkers":"383","maleMedian":"894","femaleWorkers":"11","femaleMedian":"-"}}},"Maintenance and repair workers, general":{"ageData":{"2015":{"total":"527","16to19":"4","20to24":"33","25to34":"97","35to44":"104","45to54":"137","55to64":"119","65+":"32","medianAge":"119"}},"title":"Maintenance and repair workers, general","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"527","women":"3.2","white":"11.2","black":"2.4","asian":"21.9"}},"wageData":{"2015":{"workers":"469","median":"773","maleWorkers":"459","maleMedian":"771","femaleWorkers":"10","femaleMedian":"-"}}},"Maintenance workers, machinery":{"ageData":{"2015":{"total":"29","16to19":"1","20to24":"2","25to34":"8","35to44":"6","45to54":"6","55to64":"5","65+":"2","medianAge":"5"}},"title":"Maintenance workers, machinery","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"29","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"31","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Millwrights":{"ageData":{"2015":{"total":"57","16to19":"0","20to24":"2","25to34":"14","35to44":"15","45to54":"16","55to64":"9","65+":"1","medianAge":"9"}},"title":"Millwrights","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"57","women":"3.3","white":"5.6","black":"0.5","asian":"8.4"}},"wageData":{"2015":{"workers":"49","median":"-","maleWorkers":"48","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Electrical power-line installers and repairers":{"ageData":{"2015":{"total":"119","16to19":"0","20to24":"12","25to34":"25","35to44":"29","45to54":"31","55to64":"18","65+":"4","medianAge":"18"}},"title":"Electrical power-line installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"119","women":"1.2","white":"5.2","black":"1.7","asian":"11.1"}},"wageData":{"2015":{"workers":"113","median":"1,105","maleWorkers":"112","maleMedian":"1,105","femaleWorkers":"0","femaleMedian":"-"}}},"Telecommunications line installers and repairers":{"ageData":{"2015":{"total":"177","16to19":"1","20to24":"12","25to34":"49","35to44":"60","45to54":"32","55to64":"23","65+":"0","medianAge":"23"}},"title":"Telecommunications line installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"177","women":"6.0","white":"12.9","black":"3.1","asian":"19.7"}},"wageData":{"2015":{"workers":"157","median":"882","maleWorkers":"148","maleMedian":"880","femaleWorkers":"9","femaleMedian":"-"}}},"Precision instrument and equipment repairers":{"ageData":{"2015":{"total":"66","16to19":"0","20to24":"2","25to34":"8","35to44":"17","45to54":"20","55to64":"14","65+":"5","medianAge":"14"}},"title":"Precision instrument and equipment repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"66","women":"4.8","white":"6.3","black":"3.3","asian":"10.5"}},"wageData":{"2015":{"workers":"64","median":"996","maleWorkers":"60","maleMedian":"1,009","femaleWorkers":"4","femaleMedian":"-"}}},"Wind turbine service technicians":{"ageData":{"2015":{"total":"4","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Wind turbine service technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Coin, vending, and amusement machine servicers and repairers":{"ageData":{"2015":{"total":"48","16to19":"1","20to24":"3","25to34":"11","35to44":"11","45to54":"9","55to64":"11","65+":"2","medianAge":"11"}},"title":"Coin, vending, and amusement machine servicers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"48","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"38","median":"-","maleWorkers":"34","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Commercial divers":{"ageData":{"2015":{"total":"1","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Commercial divers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Locksmiths and safe repairers":{"ageData":{"2015":{"total":"21","16to19":"0","20to24":"1","25to34":"5","35to44":"4","45to54":"3","55to64":"5","65+":"2","medianAge":"5"}},"title":"Locksmiths and safe repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"21","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"12","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Manufactured building and mobile home installers":{"ageData":{"2015":{"total":"5","16to19":"0","20to24":"1","25to34":"2","35to44":"1","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Manufactured building and mobile home installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Riggers":{"ageData":{"2015":{"total":"10","16to19":"0","20to24":"1","25to34":"3","35to44":"1","45to54":"1","55to64":"3","65+":"0","medianAge":"3"}},"title":"Riggers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Signal and track switch repairers":{"ageData":{"2015":{"total":"8","16to19":"0","20to24":"0","25to34":"2","35to44":"3","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Signal and track switch repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"9","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers--installation, maintenance, and repair workers":{"ageData":{"2015":{"total":"28","16to19":"7","20to24":"5","25to34":"6","35to44":"2","45to54":"7","55to64":"2","65+":"0","medianAge":"2"}},"title":"Helpers--installation, maintenance, and repair workers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"28","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"17","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Other installation, maintenance, and repair workers":{"ageData":{"2015":{"total":"200","16to19":"2","20to24":"15","25to34":"46","35to44":"40","45to54":"52","55to64":"35","65+":"10","medianAge":"35"}},"title":"Other installation, maintenance, and repair workers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2015":{"total":"200","women":"5.8","white":"5.1","black":"2.1","asian":"25.3"}},"wageData":{"2015":{"workers":"150","median":"792","maleWorkers":"144","maleMedian":"810","femaleWorkers":"6","femaleMedian":"-"}}},"Production, transportation, and material moving occupations":{"ageData":{"2015":{"total":"17,647","16to19":"477","20to24":"1,709","25to34":"3,601","35to44":"3,645","45to54":"4,172","55to64":"3,154","65+":"888","medianAge":"3,154"}},"title":"Production, transportation, and material moving occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2015":{"total":"17,647","women":"21.8","white":"15.3","black":"4.7","asian":"22.3"}},"wageData":{"2015":{"workers":"14,504","median":"656","maleWorkers":"11,546","maleMedian":"704","femaleWorkers":"2,958","femaleMedian":"512"}}},"Production occupations":{"ageData":{"2015":{"total":"8,522","16to19":"156","20to24":"776","25to34":"1,860","35to44":"1,809","45to54":"2,051","55to64":"1,517","65+":"354","medianAge":"1,517"}},"title":"Production occupations","depth":2,"parent":"Production, transportation, and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"8,522","women":"28.8","white":"12.5","black":"6.2","asian":"22.3"}},"wageData":{"2015":{"workers":"7,551","median":"663","maleWorkers":"5,548","maleMedian":"729","femaleWorkers":"2,003","femaleMedian":"519"}}},"First-line supervisors of production and operating workers":{"ageData":{"2015":{"total":"817","16to19":"1","20to24":"24","25to34":"159","35to44":"182","45to54":"264","55to64":"159","65+":"28","medianAge":"159"}},"title":"First-line supervisors of production and operating workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"817","women":"18.6","white":"8.0","black":"4.6","asian":"16.3"}},"wageData":{"2015":{"workers":"783","median":"875","maleWorkers":"650","maleMedian":"924","femaleWorkers":"133","femaleMedian":"623"}}},"Aircraft structure, surfaces, rigging, and systems assemblers":{"ageData":{"2015":{"total":"14","16to19":"0","20to24":"0","25to34":"4","35to44":"2","45to54":"3","55to64":"5","65+":"1","medianAge":"5"}},"title":"Aircraft structure, surfaces, rigging, and systems assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"15","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Electrical, electronics, and electromechanical assemblers":{"ageData":{"2015":{"total":"133","16to19":"2","20to24":"18","25to34":"25","35to44":"23","45to54":"29","55to64":"27","65+":"9","medianAge":"27"}},"title":"Electrical, electronics, and electromechanical assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"133","women":"51.4","white":"16.9","black":"22.0","asian":"22.5"}},"wageData":{"2015":{"workers":"123","median":"554","maleWorkers":"59","maleMedian":"566","femaleWorkers":"64","femaleMedian":"544"}}},"Engine and other machine assemblers":{"ageData":{"2015":{"total":"11","16to19":"0","20to24":"0","25to34":"3","35to44":"3","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Engine and other machine assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"14","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Structural metal fabricators and fitters":{"ageData":{"2015":{"total":"32","16to19":"0","20to24":"4","25to34":"10","35to44":"5","45to54":"6","55to64":"6","65+":"1","medianAge":"6"}},"title":"Structural metal fabricators and fitters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"32","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"31","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Miscellaneous assemblers and fabricators":{"ageData":{"2015":{"total":"1,026","16to19":"23","20to24":"114","25to34":"244","35to44":"219","45to54":"216","55to64":"169","65+":"41","medianAge":"169"}},"title":"Miscellaneous assemblers and fabricators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"1,026","women":"38.6","white":"16.1","black":"6.9","asian":"22.2"}},"wageData":{"2015":{"workers":"950","median":"581","maleWorkers":"573","maleMedian":"637","femaleWorkers":"377","femaleMedian":"512"}}},"Bakers":{"ageData":{"2015":{"total":"231","16to19":"10","20to24":"33","25to34":"55","35to44":"30","45to54":"56","55to64":"35","65+":"12","medianAge":"35"}},"title":"Bakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"231","women":"60.8","white":"15.4","black":"9.6","asian":"23.5"}},"wageData":{"2015":{"workers":"150","median":"505","maleWorkers":"69","maleMedian":"570","femaleWorkers":"80","femaleMedian":"475"}}},"Butchers and other meat, poultry, and fish processing workers":{"ageData":{"2015":{"total":"302","16to19":"5","20to24":"35","25to34":"78","35to44":"65","45to54":"63","55to64":"43","65+":"13","medianAge":"43"}},"title":"Butchers and other meat, poultry, and fish processing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"302","women":"25.7","white":"22.4","black":"8.0","asian":"35.4"}},"wageData":{"2015":{"workers":"247","median":"542","maleWorkers":"187","maleMedian":"582","femaleWorkers":"60","femaleMedian":"463"}}},"Food and tobacco roasting, baking, and drying machine operators and tenders":{"ageData":{"2015":{"total":"14","16to19":"0","20to24":"3","25to34":"6","35to44":"2","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Food and tobacco roasting, baking, and drying machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"9","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Food batchmakers":{"ageData":{"2015":{"total":"101","16to19":"6","20to24":"13","25to34":"31","35to44":"22","45to54":"20","55to64":"8","65+":"2","medianAge":"8"}},"title":"Food batchmakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"101","women":"72.3","white":"14.1","black":"7.0","asian":"29.6"}},"wageData":{"2015":{"workers":"79","median":"500","maleWorkers":"25","maleMedian":"-","femaleWorkers":"54","femaleMedian":"489"}}},"Food cooking machine operators and tenders":{"ageData":{"2015":{"total":"13","16to19":"1","20to24":"1","25to34":"5","35to44":"2","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Food cooking machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"7","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Food processing workers, all other":{"ageData":{"2015":{"total":"135","16to19":"2","20to24":"17","25to34":"39","35to44":"31","45to54":"25","55to64":"16","65+":"6","medianAge":"16"}},"title":"Food processing workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"135","women":"34.2","white":"16.6","black":"7.6","asian":"35.1"}},"wageData":{"2015":{"workers":"132","median":"594","maleWorkers":"82","maleMedian":"679","femaleWorkers":"50","femaleMedian":"508"}}},"Computer control programmers and operators":{"ageData":{"2015":{"total":"88","16to19":"2","20to24":"10","25to34":"15","35to44":"26","45to54":"22","55to64":"13","65+":"1","medianAge":"13"}},"title":"Computer control programmers and operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"88","women":"3.9","white":"8.4","black":"3.7","asian":"9.8"}},"wageData":{"2015":{"workers":"83","median":"833","maleWorkers":"81","maleMedian":"857","femaleWorkers":"2","femaleMedian":"-"}}},"Extruding and drawing machine setters, operators, and tenders, metal and plastic":{"ageData":{"2015":{"total":"9","16to19":"0","20to24":"1","25to34":"3","35to44":"1","45to54":"3","55to64":"1","65+":"0","medianAge":"1"}},"title":"Extruding and drawing machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"8","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Forging machine setters, operators, and tenders, metal and plastic":{"ageData":{"2015":{"total":"8","16to19":"0","20to24":"1","25to34":"3","35to44":"1","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Forging machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Rolling machine setters, operators, and tenders, metal and plastic":{"ageData":{"2015":{"total":"15","16to19":"0","20to24":"0","25to34":"4","35to44":"3","45to54":"4","55to64":"4","65+":"0","medianAge":"4"}},"title":"Rolling machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"15","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"15","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Cutting, punching, and press machine setters, operators, and tenders, metal and plastic":{"ageData":{"2015":{"total":"82","16to19":"2","20to24":"11","25to34":"16","35to44":"20","45to54":"18","55to64":"14","65+":"1","medianAge":"14"}},"title":"Cutting, punching, and press machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"82","women":"21.6","white":"20.1","black":"1.4","asian":"14.5"}},"wageData":{"2015":{"workers":"78","median":"633","maleWorkers":"62","maleMedian":"674","femaleWorkers":"15","femaleMedian":"-"}}},"Drilling and boring machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2015":{"total":"5","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Drilling and boring machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Grinding, lapping, polishing, and buffing machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2015":{"total":"51","16to19":"2","20to24":"9","25to34":"13","35to44":"9","45to54":"12","55to64":"5","65+":"2","medianAge":"5"}},"title":"Grinding, lapping, polishing, and buffing machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"51","women":"10.3","white":"11.5","black":"0.2","asian":"29.0"}},"wageData":{"2015":{"workers":"41","median":"-","maleWorkers":"39","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Lathe and turning machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2015":{"total":"11","16to19":"0","20to24":"0","25to34":"3","35to44":"1","45to54":"4","55to64":"3","65+":"0","medianAge":"3"}},"title":"Lathe and turning machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"12","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Milling and planing machine setters, operators, and tenders, metal and plastic":{"ageData":{"2015":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Milling and planing machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"0","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Machinists":{"ageData":{"2015":{"total":"363","16to19":"3","20to24":"29","25to34":"73","35to44":"68","45to54":"92","55to64":"85","65+":"14","medianAge":"85"}},"title":"Machinists","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"363","women":"6.7","white":"3.1","black":"6.1","asian":"13.8"}},"wageData":{"2015":{"workers":"338","median":"834","maleWorkers":"320","maleMedian":"840","femaleWorkers":"17","femaleMedian":"-"}}},"Metal furnace operators, tenders, pourers, and casters":{"ageData":{"2015":{"total":"30","16to19":"0","20to24":"1","25to34":"5","35to44":"7","45to54":"9","55to64":"6","65+":"2","medianAge":"6"}},"title":"Metal furnace operators, tenders, pourers, and casters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"30","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"29","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Model makers and patternmakers, metal and plastic":{"ageData":{"2015":{"total":"5","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"3","55to64":"1","65+":"0","medianAge":"1"}},"title":"Model makers and patternmakers, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"6","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Molders and molding machine setters, operators, and tenders, metal and plastic":{"ageData":{"2015":{"total":"46","16to19":"1","20to24":"3","25to34":"15","35to44":"9","45to54":"7","55to64":"9","65+":"1","medianAge":"9"}},"title":"Molders and molding machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"46","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"47","median":"-","maleWorkers":"39","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Multiple machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2015":{"total":"1","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Multiple machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Tool and die makers":{"ageData":{"2015":{"total":"47","16to19":"0","20to24":"0","25to34":"1","35to44":"10","45to54":"15","55to64":"17","65+":"3","medianAge":"17"}},"title":"Tool and die makers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"47","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"49","median":"-","maleWorkers":"49","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Welding, soldering, and brazing workers":{"ageData":{"2015":{"total":"615","16to19":"15","20to24":"69","25to34":"162","35to44":"140","45to54":"140","55to64":"76","65+":"13","medianAge":"76"}},"title":"Welding, soldering, and brazing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"615","women":"4.2","white":"7.1","black":"3.3","asian":"23.1"}},"wageData":{"2015":{"workers":"568","median":"760","maleWorkers":"545","maleMedian":"767","femaleWorkers":"23","femaleMedian":"-"}}},"Heat treating equipment setters, operators, and tenders, metal and plastic":{"ageData":{"2015":{"total":"5","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Heat treating equipment setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Layout workers, metal and plastic":{"ageData":{"2015":{"total":"5","16to19":"0","20to24":"1","25to34":"1","35to44":"1","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Layout workers, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Plating and coating machine setters, operators, and tenders, metal and plastic":{"ageData":{"2015":{"total":"23","16to19":"1","20to24":"4","25to34":"4","35to44":"8","45to54":"5","55to64":"2","65+":"0","medianAge":"2"}},"title":"Plating and coating machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"23","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"24","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Tool grinders, filers, and sharpeners":{"ageData":{"2015":{"total":"6","16to19":"0","20to24":"0","25to34":"4","35to44":"0","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Tool grinders, filers, and sharpeners","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Metal workers and plastic workers, all other":{"ageData":{"2015":{"total":"376","16to19":"4","20to24":"46","25to34":"80","35to44":"72","45to54":"95","55to64":"68","65+":"12","medianAge":"68"}},"title":"Metal workers and plastic workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"376","women":"22.5","white":"17.6","black":"6.3","asian":"22.6"}},"wageData":{"2015":{"workers":"351","median":"639","maleWorkers":"278","maleMedian":"678","femaleWorkers":"72","femaleMedian":"581"}}},"Prepress technicians and workers":{"ageData":{"2015":{"total":"22","16to19":"0","20to24":"2","25to34":"3","35to44":"4","45to54":"7","55to64":"4","65+":"1","medianAge":"4"}},"title":"Prepress technicians and workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"22","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"14","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Printing press operators":{"ageData":{"2015":{"total":"180","16to19":"4","20to24":"13","25to34":"37","35to44":"44","45to54":"42","55to64":"34","65+":"5","medianAge":"34"}},"title":"Printing press operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"180","women":"20.0","white":"9.0","black":"3.6","asian":"22.7"}},"wageData":{"2015":{"workers":"160","median":"707","maleWorkers":"134","maleMedian":"729","femaleWorkers":"26","femaleMedian":"-"}}},"Print binding and finishing workers":{"ageData":{"2015":{"total":"20","16to19":"0","20to24":"0","25to34":"2","35to44":"5","45to54":"3","55to64":"6","65+":"5","medianAge":"6"}},"title":"Print binding and finishing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"20","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"16","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Laundry and dry-cleaning workers":{"ageData":{"2015":{"total":"192","16to19":"3","20to24":"16","25to34":"33","35to44":"31","45to54":"48","55to64":"39","65+":"23","medianAge":"39"}},"title":"Laundry and dry-cleaning workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"192","women":"60.8","white":"17.7","black":"10.8","asian":"31.8"}},"wageData":{"2015":{"workers":"133","median":"466","maleWorkers":"53","maleMedian":"487","femaleWorkers":"80","femaleMedian":"460"}}},"Pressers, textile, garment, and related materials":{"ageData":{"2015":{"total":"34","16to19":"0","20to24":"3","25to34":"7","35to44":"7","45to54":"9","55to64":"7","65+":"1","medianAge":"7"}},"title":"Pressers, textile, garment, and related materials","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"34","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"21","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Sewing machine operators":{"ageData":{"2015":{"total":"196","16to19":"1","20to24":"7","25to34":"24","35to44":"54","45to54":"48","55to64":"52","65+":"10","medianAge":"52"}},"title":"Sewing machine operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"196","women":"74.8","white":"9.7","black":"12.4","asian":"41.8"}},"wageData":{"2015":{"workers":"147","median":"493","maleWorkers":"42","maleMedian":"-","femaleWorkers":"105","femaleMedian":"476"}}},"Shoe and leather workers and repairers":{"ageData":{"2015":{"total":"7","16to19":"0","20to24":"0","25to34":"1","35to44":"2","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Shoe and leather workers and repairers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"5","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Shoe machine operators and tenders":{"ageData":{"2015":{"total":"2","16to19":"1","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"1","medianAge":"0"}},"title":"Shoe machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Tailors, dressmakers, and sewers":{"ageData":{"2015":{"total":"83","16to19":"2","20to24":"4","25to34":"6","35to44":"13","45to54":"18","55to64":"25","65+":"16","medianAge":"25"}},"title":"Tailors, dressmakers, and sewers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"83","women":"82.2","white":"5.3","black":"17.1","asian":"22.2"}},"wageData":{"2015":{"workers":"37","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"27","femaleMedian":"-"}}},"Textile bleaching and dyeing machine operators and tenders":{"ageData":{"2015":{"total":"3","16to19":"0","20to24":"0","25to34":"2","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Textile bleaching and dyeing machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Textile cutting machine setters, operators, and tenders":{"ageData":{"2015":{"total":"9","16to19":"0","20to24":"1","25to34":"2","35to44":"2","45to54":"1","55to64":"2","65+":"1","medianAge":"2"}},"title":"Textile cutting machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"9","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Textile knitting and weaving machine setters, operators, and tenders":{"ageData":{"2015":{"total":"9","16to19":"0","20to24":"3","25to34":"2","35to44":"2","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Textile knitting and weaving machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"8","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Textile winding, twisting, and drawing out machine setters, operators, and tenders":{"ageData":{"2015":{"total":"9","16to19":"0","20to24":"0","25to34":"0","35to44":"2","45to54":"3","55to64":"2","65+":"1","medianAge":"2"}},"title":"Textile winding, twisting, and drawing out machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"7","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Extruding and forming machine setters, operators, and tenders, synthetic and glass fibers":{"ageData":{"2015":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Extruding and forming machine setters, operators, and tenders, synthetic and glass fibers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"0","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Fabric and apparel patternmakers":{"ageData":{"2015":{"total":"4","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"2","55to64":"1","65+":"1","medianAge":"1"}},"title":"Fabric and apparel patternmakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"4","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Upholsterers":{"ageData":{"2015":{"total":"40","16to19":"0","20to24":"2","25to34":"7","35to44":"10","45to54":"7","55to64":"12","65+":"1","medianAge":"12"}},"title":"Upholsterers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"29","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Textile, apparel, and furnishings workers, all other":{"ageData":{"2015":{"total":"16","16to19":"0","20to24":"1","25to34":"4","35to44":"2","45to54":"4","55to64":"4","65+":"1","medianAge":"4"}},"title":"Textile, apparel, and furnishings workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"16","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"16","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Cabinetmakers and bench carpenters":{"ageData":{"2015":{"total":"60","16to19":"2","20to24":"1","25to34":"12","35to44":"11","45to54":"11","55to64":"18","65+":"5","medianAge":"18"}},"title":"Cabinetmakers and bench carpenters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"60","women":"7.9","white":"4.3","black":"1.2","asian":"20.5"}},"wageData":{"2015":{"workers":"40","median":"-","maleWorkers":"38","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Furniture finishers":{"ageData":{"2015":{"total":"15","16to19":"0","20to24":"0","25to34":"1","35to44":"5","45to54":"1","55to64":"6","65+":"2","medianAge":"6"}},"title":"Furniture finishers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"15","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Model makers and patternmakers, wood":{"ageData":{"2015":{"total":"1","16to19":"0","20to24":"1","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Model makers and patternmakers, wood","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Sawing machine setters, operators, and tenders, wood":{"ageData":{"2015":{"total":"29","16to19":"1","20to24":"2","25to34":"7","35to44":"6","45to54":"6","55to64":"6","65+":"1","medianAge":"6"}},"title":"Sawing machine setters, operators, and tenders, wood","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"29","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"26","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Woodworking machine setters, operators, and tenders, except sawing":{"ageData":{"2015":{"total":"24","16to19":"1","20to24":"3","25to34":"3","35to44":"4","45to54":"9","55to64":"4","65+":"1","medianAge":"4"}},"title":"Woodworking machine setters, operators, and tenders, except sawing","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"24","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"23","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Woodworkers, all other":{"ageData":{"2015":{"total":"31","16to19":"1","20to24":"1","25to34":"6","35to44":"6","45to54":"5","55to64":"9","65+":"3","medianAge":"9"}},"title":"Woodworkers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"31","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"17","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Power plant operators, distributors, and dispatchers":{"ageData":{"2015":{"total":"33","16to19":"0","20to24":"1","25to34":"10","35to44":"6","45to54":"8","55to64":"7","65+":"1","medianAge":"7"}},"title":"Power plant operators, distributors, and dispatchers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"35","median":"-","maleWorkers":"34","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Stationary engineers and boiler operators":{"ageData":{"2015":{"total":"81","16to19":"0","20to24":"2","25to34":"11","35to44":"20","45to54":"23","55to64":"22","65+":"3","medianAge":"22"}},"title":"Stationary engineers and boiler operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"81","women":"3.4","white":"9.4","black":"5.2","asian":"10.2"}},"wageData":{"2015":{"workers":"84","median":"996","maleWorkers":"81","maleMedian":"1,012","femaleWorkers":"3","femaleMedian":"-"}}},"Water and wastewater treatment plant and system operators":{"ageData":{"2015":{"total":"89","16to19":"0","20to24":"4","25to34":"12","35to44":"23","45to54":"28","55to64":"18","65+":"4","medianAge":"18"}},"title":"Water and wastewater treatment plant and system operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"89","women":"4.4","white":"7.1","black":"1.5","asian":"6.5"}},"wageData":{"2015":{"workers":"82","median":"880","maleWorkers":"79","maleMedian":"868","femaleWorkers":"3","femaleMedian":"-"}}},"Miscellaneous plant and system operators":{"ageData":{"2015":{"total":"36","16to19":"0","20to24":"3","25to34":"9","35to44":"10","45to54":"9","55to64":"5","65+":"1","medianAge":"5"}},"title":"Miscellaneous plant and system operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"36","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"35","median":"-","maleWorkers":"33","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Chemical processing machine setters, operators, and tenders":{"ageData":{"2015":{"total":"63","16to19":"1","20to24":"3","25to34":"23","35to44":"11","45to54":"12","55to64":"12","65+":"1","medianAge":"12"}},"title":"Chemical processing machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"63","women":"13.0","white":"4.3","black":"0.4","asian":"10.6"}},"wageData":{"2015":{"workers":"62","median":"1,052","maleWorkers":"57","maleMedian":"1,082","femaleWorkers":"5","femaleMedian":"-"}}},"Crushing, grinding, polishing, mixing, and blending workers":{"ageData":{"2015":{"total":"86","16to19":"2","20to24":"13","25to34":"21","35to44":"18","45to54":"18","55to64":"13","65+":"2","medianAge":"13"}},"title":"Crushing, grinding, polishing, mixing, and blending workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"86","women":"11.0","white":"10.5","black":"3.1","asian":"37.2"}},"wageData":{"2015":{"workers":"82","median":"652","maleWorkers":"75","maleMedian":"668","femaleWorkers":"7","femaleMedian":"-"}}},"Cutting workers":{"ageData":{"2015":{"total":"64","16to19":"2","20to24":"10","25to34":"14","35to44":"17","45to54":"11","55to64":"8","65+":"2","medianAge":"8"}},"title":"Cutting workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"64","women":"16.7","white":"13.4","black":"2.6","asian":"24.2"}},"wageData":{"2015":{"workers":"51","median":"685","maleWorkers":"41","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Extruding, forming, pressing, and compacting machine setters, operators, and tenders":{"ageData":{"2015":{"total":"28","16to19":"1","20to24":"4","25to34":"3","35to44":"7","45to54":"7","55to64":"4","65+":"1","medianAge":"4"}},"title":"Extruding, forming, pressing, and compacting machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"28","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"31","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Furnace, kiln, oven, drier, and kettle operators and tenders":{"ageData":{"2015":{"total":"7","16to19":"1","20to24":"0","25to34":"1","35to44":"2","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Furnace, kiln, oven, drier, and kettle operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"6","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Inspectors, testers, sorters, samplers, and weighers":{"ageData":{"2015":{"total":"752","16to19":"12","20to24":"54","25to34":"161","35to44":"157","45to54":"185","55to64":"148","65+":"35","medianAge":"148"}},"title":"Inspectors, testers, sorters, samplers, and weighers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"752","women":"37.3","white":"12.5","black":"6.9","asian":"17.7"}},"wageData":{"2015":{"workers":"701","median":"710","maleWorkers":"440","maleMedian":"844","femaleWorkers":"260","femaleMedian":"583"}}},"Jewelers and precious stone and metal workers":{"ageData":{"2015":{"total":"44","16to19":"0","20to24":"2","25to34":"5","35to44":"10","45to54":"14","55to64":"10","65+":"4","medianAge":"10"}},"title":"Jewelers and precious stone and metal workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"44","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"19","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Medical, dental, and ophthalmic laboratory technicians":{"ageData":{"2015":{"total":"110","16to19":"1","20to24":"6","25to34":"24","35to44":"26","45to54":"27","55to64":"14","65+":"11","medianAge":"14"}},"title":"Medical, dental, and ophthalmic laboratory technicians","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"110","women":"48.6","white":"7.8","black":"13.4","asian":"19.1"}},"wageData":{"2015":{"workers":"86","median":"648","maleWorkers":"44","maleMedian":"-","femaleWorkers":"42","femaleMedian":"-"}}},"Packaging and filling machine operators and tenders":{"ageData":{"2015":{"total":"250","16to19":"4","20to24":"35","25to34":"45","35to44":"54","45to54":"59","55to64":"47","65+":"6","medianAge":"47"}},"title":"Packaging and filling machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"250","women":"49.9","white":"20.4","black":"7.5","asian":"36.7"}},"wageData":{"2015":{"workers":"239","median":"518","maleWorkers":"118","maleMedian":"605","femaleWorkers":"120","femaleMedian":"482"}}},"Painting workers":{"ageData":{"2015":{"total":"151","16to19":"3","20to24":"16","25to34":"36","35to44":"44","45to54":"31","55to64":"17","65+":"4","medianAge":"17"}},"title":"Painting workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"151","women":"12.9","white":"14.2","black":"5.2","asian":"23.0"}},"wageData":{"2015":{"workers":"129","median":"708","maleWorkers":"110","maleMedian":"733","femaleWorkers":"18","femaleMedian":"-"}}},"Photographic process workers and processing machine operators":{"ageData":{"2015":{"total":"33","16to19":"0","20to24":"5","25to34":"13","35to44":"3","45to54":"8","55to64":"2","65+":"2","medianAge":"2"}},"title":"Photographic process workers and processing machine operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"26","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"14","femaleMedian":"-"}}},"Semiconductor processors":{"ageData":{"2015":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Semiconductor processors","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Adhesive bonding machine operators and tenders":{"ageData":{"2015":{"total":"11","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"4","55to64":"2","65+":"1","medianAge":"2"}},"title":"Adhesive bonding machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"9","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Cleaning, washing, and metal pickling equipment operators and tenders":{"ageData":{"2015":{"total":"4","16to19":"1","20to24":"0","25to34":"1","35to44":"0","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Cleaning, washing, and metal pickling equipment operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"4","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Cooling and freezing equipment operators and tenders":{"ageData":{"2015":{"total":"4","16to19":"0","20to24":"0","25to34":"3","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Cooling and freezing equipment operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"4","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Etchers and engravers":{"ageData":{"2015":{"total":"19","16to19":"3","20to24":"0","25to34":"3","35to44":"2","45to54":"5","55to64":"5","65+":"2","medianAge":"5"}},"title":"Etchers and engravers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"12","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Molders, shapers, and casters, except metal and plastic":{"ageData":{"2015":{"total":"27","16to19":"0","20to24":"2","25to34":"10","35to44":"4","45to54":"1","55to64":"8","65+":"1","medianAge":"8"}},"title":"Molders, shapers, and casters, except metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"27","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"14","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Paper goods machine setters, operators, and tenders":{"ageData":{"2015":{"total":"30","16to19":"1","20to24":"1","25to34":"6","35to44":"11","45to54":"6","55to64":"4","65+":"0","medianAge":"4"}},"title":"Paper goods machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"30","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"27","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Tire builders":{"ageData":{"2015":{"total":"10","16to19":"0","20to24":"1","25to34":"3","35to44":"2","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Tire builders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"8","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers--production workers":{"ageData":{"2015":{"total":"40","16to19":"5","20to24":"10","25to34":"7","35to44":"4","45to54":"7","55to64":"6","65+":"1","medianAge":"6"}},"title":"Helpers--production workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"24","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Production workers, all other":{"ageData":{"2015":{"total":"944","16to19":"24","20to24":"95","25to34":"216","35to44":"200","45to54":"230","55to64":"148","65+":"32","medianAge":"148"}},"title":"Production workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2015":{"total":"944","women":"25.5","white":"14.4","black":"4.9","asian":"24.9"}},"wageData":{"2015":{"workers":"846","median":"625","maleWorkers":"643","maleMedian":"666","femaleWorkers":"203","femaleMedian":"501"}}},"Transportation and material moving occupations":{"ageData":{"2015":{"total":"9,125","16to19":"321","20to24":"933","25to34":"1,742","35to44":"1,836","45to54":"2,121","55to64":"1,637","65+":"534","medianAge":"1,637"}},"title":"Transportation and material moving occupations","depth":2,"parent":"Production, transportation, and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"9,125","women":"15.3","white":"17.8","black":"3.4","asian":"22.4"}},"wageData":{"2015":{"workers":"6,953","median":"646","maleWorkers":"5,998","maleMedian":"679","femaleWorkers":"955","femaleMedian":"494"}}},"Supervisors of transportation and material moving workers":{"ageData":{"2015":{"total":"205","16to19":"1","20to24":"14","25to34":"46","35to44":"48","45to54":"56","55to64":"36","65+":"5","medianAge":"36"}},"title":"Supervisors of transportation and material moving workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"205","women":"18.1","white":"15.0","black":"1.6","asian":"20.6"}},"wageData":{"2015":{"workers":"186","median":"894","maleWorkers":"153","maleMedian":"898","femaleWorkers":"33","femaleMedian":"-"}}},"Aircraft pilots and flight engineers":{"ageData":{"2015":{"total":"140","16to19":"0","20to24":"1","25to34":"18","35to44":"42","45to54":"47","55to64":"27","65+":"6","medianAge":"27"}},"title":"Aircraft pilots and flight engineers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"140","women":"9.4","white":"2.6","black":"0.7","asian":"5.7"}},"wageData":{"2015":{"workers":"114","median":"1,735","maleWorkers":"104","maleMedian":"1,830","femaleWorkers":"9","femaleMedian":"-"}}},"Air traffic controllers and airfield operations specialists":{"ageData":{"2015":{"total":"30","16to19":"1","20to24":"2","25to34":"10","35to44":"2","45to54":"9","55to64":"4","65+":"2","medianAge":"4"}},"title":"Air traffic controllers and airfield operations specialists","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"30","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"32","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Flight attendants":{"ageData":{"2015":{"total":"86","16to19":"0","20to24":"1","25to34":"18","35to44":"12","45to54":"34","55to64":"19","65+":"2","medianAge":"19"}},"title":"Flight attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"86","women":"74.9","white":"12.0","black":"4.5","asian":"9.8"}},"wageData":{"2015":{"workers":"63","median":"846","maleWorkers":"20","maleMedian":"-","femaleWorkers":"43","femaleMedian":"-"}}},"Ambulance drivers and attendants, except emergency medical technicians":{"ageData":{"2015":{"total":"19","16to19":"0","20to24":"4","25to34":"6","35to44":"3","45to54":"1","55to64":"3","65+":"2","medianAge":"3"}},"title":"Ambulance drivers and attendants, except emergency medical technicians","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"18","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Bus drivers":{"ageData":{"2015":{"total":"550","16to19":"1","20to24":"11","25to34":"51","35to44":"96","45to54":"167","55to64":"149","65+":"75","medianAge":"149"}},"title":"Bus drivers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"550","women":"47.1","white":"28.0","black":"2.7","asian":"14.3"}},"wageData":{"2015":{"workers":"323","median":"615","maleWorkers":"184","maleMedian":"681","femaleWorkers":"138","femaleMedian":"572"}}},"Driver/sales workers and truck drivers":{"ageData":{"2015":{"total":"3,469","16to19":"45","20to24":"216","25to34":"593","35to44":"738","45to54":"919","55to64":"730","65+":"228","medianAge":"730"}},"title":"Driver/sales workers and truck drivers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"3,469","women":"5.1","white":"15.1","black":"2.7","asian":"21.5"}},"wageData":{"2015":{"workers":"2,687","median":"747","maleWorkers":"2,582","maleMedian":"751","femaleWorkers":"105","femaleMedian":"632"}}},"Taxi drivers and chauffeurs":{"ageData":{"2015":{"total":"446","16to19":"1","20to24":"16","25to34":"75","35to44":"98","45to54":"115","55to64":"84","65+":"57","medianAge":"84"}},"title":"Taxi drivers and chauffeurs","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"446","women":"14.6","white":"27.0","black":"15.1","asian":"17.0"}},"wageData":{"2015":{"workers":"253","median":"585","maleWorkers":"216","maleMedian":"600","femaleWorkers":"38","femaleMedian":"-"}}},"Motor vehicle operators, all other":{"ageData":{"2015":{"total":"51","16to19":"2","20to24":"5","25to34":"4","35to44":"5","45to54":"6","55to64":"12","65+":"18","medianAge":"12"}},"title":"Motor vehicle operators, all other","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"51","women":"9.4","white":"14.2","black":"5.5","asian":"21.5"}},"wageData":{"2015":{"workers":"21","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Locomotive engineers and operators":{"ageData":{"2015":{"total":"50","16to19":"0","20to24":"0","25to34":"6","35to44":"17","45to54":"16","55to64":"11","65+":"0","medianAge":"11"}},"title":"Locomotive engineers and operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"50","women":"3.5","white":"21.3","black":"1.4","asian":"8.2"}},"wageData":{"2015":{"workers":"44","median":"-","maleWorkers":"42","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Railroad brake, signal, and switch operators":{"ageData":{"2015":{"total":"6","16to19":"0","20to24":"0","25to34":"0","35to44":"3","45to54":"3","55to64":"0","65+":"0","medianAge":"0"}},"title":"Railroad brake, signal, and switch operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Railroad conductors and yardmasters":{"ageData":{"2015":{"total":"52","16to19":"1","20to24":"3","25to34":"13","35to44":"17","45to54":"13","55to64":"4","65+":"1","medianAge":"4"}},"title":"Railroad conductors and yardmasters","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"52","women":"7.7","white":"18.6","black":"1.7","asian":"2.1"}},"wageData":{"2015":{"workers":"55","median":"1,117","maleWorkers":"52","maleMedian":"1,137","femaleWorkers":"4","femaleMedian":"-"}}},"Subway, streetcar, and other rail transportation workers":{"ageData":{"2015":{"total":"15","16to19":"0","20to24":"0","25to34":"4","35to44":"7","45to54":"3","55to64":"0","65+":"1","medianAge":"0"}},"title":"Subway, streetcar, and other rail transportation workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"15","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"15","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Sailors and marine oilers":{"ageData":{"2015":{"total":"11","16to19":"0","20to24":"5","25to34":"2","35to44":"2","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Sailors and marine oilers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"10","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Ship and boat captains and operators":{"ageData":{"2015":{"total":"35","16to19":"0","20to24":"1","25to34":"5","35to44":"12","45to54":"8","55to64":"6","65+":"3","medianAge":"6"}},"title":"Ship and boat captains and operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"35","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"29","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Ship engineers":{"ageData":{"2015":{"total":"6","16to19":"0","20to24":"1","25to34":"0","35to44":"0","45to54":"0","55to64":"3","65+":"1","medianAge":"3"}},"title":"Ship engineers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"5","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Bridge and lock tenders":{"ageData":{"2015":{"total":"5","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"0","55to64":"1","65+":"2","medianAge":"1"}},"title":"Bridge and lock tenders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Parking lot attendants":{"ageData":{"2015":{"total":"91","16to19":"5","20to24":"19","25to34":"24","35to44":"14","45to54":"10","55to64":"13","65+":"6","medianAge":"13"}},"title":"Parking lot attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"91","women":"10.0","white":"32.1","black":"5.3","asian":"26.5"}},"wageData":{"2015":{"workers":"57","median":"492","maleWorkers":"49","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Automotive and watercraft service attendants":{"ageData":{"2015":{"total":"99","16to19":"16","20to24":"30","25to34":"26","35to44":"10","45to54":"7","55to64":"8","65+":"2","medianAge":"8"}},"title":"Automotive and watercraft service attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"99","women":"11.0","white":"8.2","black":"3.8","asian":"12.7"}},"wageData":{"2015":{"workers":"63","median":"452","maleWorkers":"58","maleMedian":"470","femaleWorkers":"5","femaleMedian":"-"}}},"Transportation inspectors":{"ageData":{"2015":{"total":"29","16to19":"0","20to24":"0","25to34":"7","35to44":"4","45to54":"9","55to64":"8","65+":"1","medianAge":"8"}},"title":"Transportation inspectors","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"29","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"21","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Transportation attendants, except flight attendants":{"ageData":{"2015":{"total":"22","16to19":"0","20to24":"1","25to34":"3","35to44":"5","45to54":"5","55to64":"4","65+":"3","medianAge":"4"}},"title":"Transportation attendants, except flight attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"22","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"17","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Other transportation workers":{"ageData":{"2015":{"total":"43","16to19":"0","20to24":"8","25to34":"15","35to44":"5","45to54":"6","55to64":"9","65+":"0","medianAge":"9"}},"title":"Other transportation workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"43","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"39","median":"-","maleWorkers":"35","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Conveyor operators and tenders":{"ageData":{"2015":{"total":"7","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"2","55to64":"1","65+":"1","medianAge":"1"}},"title":"Conveyor operators and tenders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Crane and tower operators":{"ageData":{"2015":{"total":"76","16to19":"0","20to24":"2","25to34":"13","35to44":"21","45to54":"18","55to64":"17","65+":"5","medianAge":"17"}},"title":"Crane and tower operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"76","women":"3.4","white":"9.1","black":"0.2","asian":"10.3"}},"wageData":{"2015":{"workers":"75","median":"988","maleWorkers":"71","maleMedian":"1,016","femaleWorkers":"4","femaleMedian":"-"}}},"Dredge, excavating, and loading machine operators":{"ageData":{"2015":{"total":"35","16to19":"0","20to24":"5","25to34":"3","35to44":"11","45to54":"10","55to64":"4","65+":"2","medianAge":"4"}},"title":"Dredge, excavating, and loading machine operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"35","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"25","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Hoist and winch operators":{"ageData":{"2015":{"total":"6","16to19":"0","20to24":"0","25to34":"3","35to44":"1","45to54":"0","55to64":"1","65+":"1","medianAge":"1"}},"title":"Hoist and winch operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Industrial truck and tractor operators":{"ageData":{"2015":{"total":"589","16to19":"5","20to24":"60","25to34":"145","35to44":"131","45to54":"136","55to64":"97","65+":"15","medianAge":"97"}},"title":"Industrial truck and tractor operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"589","women":"7.1","white":"21.6","black":"2.3","asian":"25.9"}},"wageData":{"2015":{"workers":"579","median":"609","maleWorkers":"541","maleMedian":"612","femaleWorkers":"37","femaleMedian":"-"}}},"Cleaners of vehicles and equipment":{"ageData":{"2015":{"total":"338","16to19":"40","20to24":"60","25to34":"72","35to44":"63","45to54":"65","55to64":"31","65+":"7","medianAge":"31"}},"title":"Cleaners of vehicles and equipment","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"338","women":"11.1","white":"12.3","black":"1.4","asian":"39.4"}},"wageData":{"2015":{"workers":"222","median":"485","maleWorkers":"200","maleMedian":"498","femaleWorkers":"22","femaleMedian":"-"}}},"Laborers and freight, stock, and material movers, hand":{"ageData":{"2015":{"total":"1,908","16to19":"126","20to24":"360","25to34":"447","35to44":"338","45to54":"322","55to64":"255","65+":"59","medianAge":"255"}},"title":"Laborers and freight, stock, and material movers, hand","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"1,908","women":"17.6","white":"19.0","black":"2.9","asian":"24.1"}},"wageData":{"2015":{"workers":"1,433","median":"526","maleWorkers":"1,214","maleMedian":"547","femaleWorkers":"219","femaleMedian":"455"}}},"Machine feeders and offbearers":{"ageData":{"2015":{"total":"33","16to19":"1","20to24":"9","25to34":"9","35to44":"3","45to54":"5","55to64":"7","65+":"0","medianAge":"7"}},"title":"Machine feeders and offbearers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"30","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Packers and packagers, hand":{"ageData":{"2015":{"total":"505","16to19":"70","20to24":"76","25to34":"89","35to44":"94","45to54":"92","55to64":"66","65+":"18","medianAge":"66"}},"title":"Packers and packagers, hand","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"505","women":"51.9","white":"19.0","black":"5.6","asian":"37.5"}},"wageData":{"2015":{"workers":"385","median":"438","maleWorkers":"158","maleMedian":"462","femaleWorkers":"227","femaleMedian":"424"}}},"Pumping station operators":{"ageData":{"2015":{"total":"23","16to19":"0","20to24":"3","25to34":"8","35to44":"2","45to54":"5","55to64":"2","65+":"3","medianAge":"2"}},"title":"Pumping station operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"23","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"18","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Refuse and recyclable material collectors":{"ageData":{"2015":{"total":"97","16to19":"3","20to24":"13","25to34":"18","35to44":"18","45to54":"24","55to64":"18","65+":"4","medianAge":"18"}},"title":"Refuse and recyclable material collectors","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"97","women":"10.4","white":"19.1","black":"2.1","asian":"30.8"}},"wageData":{"2015":{"workers":"72","median":"501","maleWorkers":"66","maleMedian":"496","femaleWorkers":"6","femaleMedian":"-"}}},"Mine shuttle car operators":{"ageData":{"2015":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Mine shuttle car operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Tank car, truck, and ship loaders":{"ageData":{"2015":{"total":"5","16to19":"0","20to24":"1","25to34":"1","35to44":"2","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Tank car, truck, and ship loaders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Material moving workers, all other":{"ageData":{"2015":{"total":"43","16to19":"3","20to24":"6","25to34":"9","35to44":"9","45to54":"7","55to64":"8","65+":"2","medianAge":"8"}},"title":"Material moving workers, all other","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2015":{"total":"43","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2015":{"workers":"37","median":"-","maleWorkers":"32","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}}}');


var $62ee90ffcb92ff51$exports = {};
$62ee90ffcb92ff51$exports = JSON.parse('{"Total":{"ageData":{"2014":{"total":"146,305","16to19":"4,548","20to24":"13,894","25to34":"31,975","35to44":"30,966","45to54":"32,556","55to64":"24,395","65+":"7,971","medianAge":"24,395"}},"title":"Total","depth":1,"parent":"","sexRaceEthnicityData":{"2014":{"total":"146,305","women":"46.9","white":"11.4","black":"5.7","asian":"16.1"}},"wageData":{"2014":{"workers":"106,526","median":"$791","maleWorkers":"59,450","maleMedian":"$871","femaleWorkers":"47,076","femaleMedian":"$719"}}},"Management, professional, and related occupations":{"ageData":{"2014":{"total":"56,050","16to19":"323","20to24":"3,052","25to34":"12,587","35to44":"13,278","45to54":"13,205","55to64":"10,164","65+":"3,441","medianAge":"10,164"}},"title":"Management, professional, and related occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2014":{"total":"56,050","women":"51.6","white":"8.8","black":"7.5","asian":"8.7"}},"wageData":{"2014":{"workers":"43,016","median":"1,137","maleWorkers":"20,758","maleMedian":"1,346","femaleWorkers":"22,258","femaleMedian":"981"}}},"Management, business, and financial operations occupations":{"ageData":{"2014":{"total":"23,171","16to19":"64","20to24":"963","25to34":"4,431","35to44":"5,471","45to54":"6,058","55to64":"4,588","65+":"1,596","medianAge":"4,588"}},"title":"Management, business, and financial operations occupations","depth":2,"parent":"Management, professional, and related occupations","sexRaceEthnicityData":{"2014":{"total":"23,171","women":"43.7","white":"7.5","black":"6.1","asian":"8.9"}},"wageData":{"2014":{"workers":"17,561","median":"1,227","maleWorkers":"9,385","maleMedian":"1,416","femaleWorkers":"8,176","femaleMedian":"1,056"}}},"Management occupations":{"ageData":{"2014":{"total":"16,199","16to19":"45","20to24":"520","25to34":"2,753","35to44":"3,847","45to54":"4,484","55to64":"3,366","65+":"1,183","medianAge":"3,366"}},"title":"Management occupations","depth":3,"parent":"Management, business, and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"16,199","women":"38.6","white":"6.7","black":"5.4","asian":"9.1"}},"wageData":{"2014":{"workers":"11,881","median":"1,295","maleWorkers":"6,943","maleMedian":"1,454","femaleWorkers":"4,938","femaleMedian":"1,127"}}},"Chief executives":{"ageData":{"2014":{"total":"1,603","16to19":"1","20to24":"11","25to34":"134","35to44":"289","45to54":"518","55to64":"487","65+":"163","medianAge":"487"}},"title":"Chief executives","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"1,603","women":"26.3","white":"3.0","black":"4.7","asian":"4.7"}},"wageData":{"2014":{"workers":"1,077","median":"2,023","maleWorkers":"795","maleMedian":"2,246","femaleWorkers":"283","femaleMedian":"1,572"}}},"General and operations managers":{"ageData":{"2014":{"total":"887","16to19":"0","20to24":"25","25to34":"177","35to44":"233","45to54":"260","55to64":"161","65+":"31","medianAge":"161"}},"title":"General and operations managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"887","women":"29.5","white":"6.2","black":"3.9","asian":"11.5"}},"wageData":{"2014":{"workers":"843","median":"1,276","maleWorkers":"587","maleMedian":"1,350","femaleWorkers":"256","femaleMedian":"1,136"}}},"Legislators":{"ageData":{"2014":{"total":"17","16to19":"0","20to24":"1","25to34":"1","35to44":"5","45to54":"3","55to64":"3","65+":"5","medianAge":"3"}},"title":"Legislators","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"17","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"16","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Advertising and promotions managers":{"ageData":{"2014":{"total":"52","16to19":"0","20to24":"4","25to34":"23","35to44":"11","45to54":"8","55to64":"5","65+":"1","medianAge":"5"}},"title":"Advertising and promotions managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"52","women":"57.9","white":"6.7","black":"4.9","asian":"4.6"}},"wageData":{"2014":{"workers":"47","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"27","femaleMedian":"-"}}},"Marketing and sales managers":{"ageData":{"2014":{"total":"917","16to19":"0","20to24":"40","25to34":"227","35to44":"263","45to54":"225","55to64":"137","65+":"26","medianAge":"137"}},"title":"Marketing and sales managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"917","women":"46.1","white":"3.9","black":"5.9","asian":"8.3"}},"wageData":{"2014":{"workers":"823","median":"1,405","maleWorkers":"451","maleMedian":"1,624","femaleWorkers":"372","femaleMedian":"1,150"}}},"Public relations and fundraising managers":{"ageData":{"2014":{"total":"71","16to19":"0","20to24":"4","25to34":"21","35to44":"13","45to54":"16","55to64":"17","65+":"2","medianAge":"17"}},"title":"Public relations and fundraising managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"71","women":"60.0","white":"7.7","black":"7.9","asian":"12.9"}},"wageData":{"2014":{"workers":"69","median":"1,344","maleWorkers":"28","maleMedian":"-","femaleWorkers":"41","femaleMedian":"-"}}},"Administrative services managers":{"ageData":{"2014":{"total":"134","16to19":"1","20to24":"3","25to34":"15","35to44":"29","45to54":"39","55to64":"40","65+":"8","medianAge":"40"}},"title":"Administrative services managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"134","women":"40.8","white":"8.1","black":"2.7","asian":"9.0"}},"wageData":{"2014":{"workers":"114","median":"1,163","maleWorkers":"66","maleMedian":"1,165","femaleWorkers":"48","femaleMedian":"-"}}},"Computer and information systems managers":{"ageData":{"2014":{"total":"629","16to19":"1","20to24":"5","25to34":"111","35to44":"195","45to54":"195","55to64":"103","65+":"18","medianAge":"103"}},"title":"Computer and information systems managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"629","women":"26.7","white":"6.3","black":"11.6","asian":"4.9"}},"wageData":{"2014":{"workers":"623","median":"1,730","maleWorkers":"453","maleMedian":"1,763","femaleWorkers":"169","femaleMedian":"1,529"}}},"Financial managers":{"ageData":{"2014":{"total":"1,194","16to19":"0","20to24":"41","25to34":"259","35to44":"303","45to54":"330","55to64":"210","65+":"50","medianAge":"210"}},"title":"Financial managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"1,194","women":"53.4","white":"7.8","black":"6.9","asian":"10.5"}},"wageData":{"2014":{"workers":"1,133","median":"1,325","maleWorkers":"527","maleMedian":"1,671","femaleWorkers":"606","femaleMedian":"1,127"}}},"Compensation and benefits managers":{"ageData":{"2014":{"total":"17","16to19":"0","20to24":"0","25to34":"2","35to44":"2","45to54":"9","55to64":"4","65+":"0","medianAge":"4"}},"title":"Compensation and benefits managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"17","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"16","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Human resources managers":{"ageData":{"2014":{"total":"236","16to19":"0","20to24":"5","25to34":"30","35to44":"72","45to54":"80","55to64":"39","65+":"10","medianAge":"39"}},"title":"Human resources managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"236","women":"74.4","white":"11.8","black":"3.3","asian":"10.0"}},"wageData":{"2014":{"workers":"234","median":"1,382","maleWorkers":"56","maleMedian":"1,827","femaleWorkers":"178","femaleMedian":"1,300"}}},"Training and development managers":{"ageData":{"2014":{"total":"38","16to19":"0","20to24":"2","25to34":"8","35to44":"14","45to54":"8","55to64":"6","65+":"0","medianAge":"6"}},"title":"Training and development managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"38","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"40","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"20","femaleMedian":"-"}}},"Industrial production managers":{"ageData":{"2014":{"total":"273","16to19":"0","20to24":"5","25to34":"39","35to44":"70","45to54":"88","55to64":"63","65+":"8","medianAge":"63"}},"title":"Industrial production managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"273","women":"17.8","white":"4.2","black":"3.6","asian":"8.4"}},"wageData":{"2014":{"workers":"263","median":"1,331","maleWorkers":"220","maleMedian":"1,383","femaleWorkers":"42","femaleMedian":"-"}}},"Purchasing managers":{"ageData":{"2014":{"total":"193","16to19":"0","20to24":"5","25to34":"35","35to44":"51","45to54":"49","55to64":"44","65+":"9","medianAge":"44"}},"title":"Purchasing managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"193","women":"42.6","white":"7.6","black":"8.9","asian":"11.6"}},"wageData":{"2014":{"workers":"180","median":"1,329","maleWorkers":"103","maleMedian":"1,366","femaleWorkers":"77","femaleMedian":"1,276"}}},"Transportation, storage, and distribution managers":{"ageData":{"2014":{"total":"260","16to19":"1","20to24":"11","25to34":"59","35to44":"74","45to54":"64","55to64":"41","65+":"10","medianAge":"41"}},"title":"Transportation, storage, and distribution managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"260","women":"21.6","white":"7.0","black":"6.1","asian":"12.4"}},"wageData":{"2014":{"workers":"239","median":"991","maleWorkers":"188","maleMedian":"1,014","femaleWorkers":"51","femaleMedian":"836"}}},"Farmers, ranchers, and other agricultural managers":{"ageData":{"2014":{"total":"941","16to19":"5","20to24":"24","25to34":"99","35to44":"123","45to54":"182","55to64":"237","65+":"271","medianAge":"237"}},"title":"Farmers, ranchers, and other agricultural managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"941","women":"23.8","white":"0.9","black":"0.8","asian":"4.2"}},"wageData":{"2014":{"workers":"106","median":"812","maleWorkers":"91","maleMedian":"818","femaleWorkers":"15","femaleMedian":"-"}}},"Construction managers":{"ageData":{"2014":{"total":"711","16to19":"1","20to24":"14","25to34":"123","35to44":"198","45to54":"200","55to64":"142","65+":"33","medianAge":"142"}},"title":"Construction managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"711","women":"7.4","white":"3.7","black":"2.3","asian":"10.2"}},"wageData":{"2014":{"workers":"428","median":"1,304","maleWorkers":"395","maleMedian":"1,332","femaleWorkers":"33","femaleMedian":"-"}}},"Education administrators":{"ageData":{"2014":{"total":"838","16to19":"1","20to24":"17","25to34":"133","35to44":"236","45to54":"226","55to64":"187","65+":"38","medianAge":"187"}},"title":"Education administrators","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"838","women":"63.3","white":"13.3","black":"2.1","asian":"9.1"}},"wageData":{"2014":{"workers":"730","median":"1,272","maleWorkers":"279","maleMedian":"1,439","femaleWorkers":"451","femaleMedian":"1,171"}}},"Architectural and engineering managers":{"ageData":{"2014":{"total":"122","16to19":"0","20to24":"0","25to34":"16","35to44":"26","45to54":"48","55to64":"29","65+":"2","medianAge":"29"}},"title":"Architectural and engineering managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"122","women":"7.6","white":"2.7","black":"9.9","asian":"8.4"}},"wageData":{"2014":{"workers":"110","median":"1,945","maleWorkers":"103","maleMedian":"1,975","femaleWorkers":"7","femaleMedian":"-"}}},"Food service managers":{"ageData":{"2014":{"total":"1,113","16to19":"21","20to24":"143","25to34":"287","35to44":"269","45to54":"208","55to64":"144","65+":"41","medianAge":"144"}},"title":"Food service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"1,113","women":"44.9","white":"9.8","black":"10.0","asian":"16.4"}},"wageData":{"2014":{"workers":"740","median":"704","maleWorkers":"398","maleMedian":"806","femaleWorkers":"342","femaleMedian":"595"}}},"Funeral service managers":{"ageData":{"2014":{"total":"13","16to19":"0","20to24":"0","25to34":"2","35to44":"2","45to54":"4","55to64":"2","65+":"4","medianAge":"2"}},"title":"Funeral service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"7","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Gaming managers":{"ageData":{"2014":{"total":"28","16to19":"0","20to24":"3","25to34":"3","35to44":"8","45to54":"8","55to64":"5","65+":"1","medianAge":"5"}},"title":"Gaming managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"28","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"15","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Lodging managers":{"ageData":{"2014":{"total":"146","16to19":"1","20to24":"13","25to34":"28","35to44":"32","45to54":"36","55to64":"25","65+":"11","medianAge":"25"}},"title":"Lodging managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"146","women":"54.6","white":"8.1","black":"15.5","asian":"7.1"}},"wageData":{"2014":{"workers":"107","median":"764","maleWorkers":"47","maleMedian":"-","femaleWorkers":"60","femaleMedian":"809"}}},"Medical and health services managers":{"ageData":{"2014":{"total":"593","16to19":"0","20to24":"9","25to34":"99","35to44":"155","45to54":"160","55to64":"137","65+":"33","medianAge":"137"}},"title":"Medical and health services managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"593","women":"71.8","white":"11.0","black":"5.5","asian":"8.1"}},"wageData":{"2014":{"workers":"541","median":"1,266","maleWorkers":"153","maleMedian":"1,448","femaleWorkers":"388","femaleMedian":"1,215"}}},"Natural sciences managers":{"ageData":{"2014":{"total":"18","16to19":"0","20to24":"0","25to34":"1","35to44":"7","45to54":"5","55to64":"2","65+":"2","medianAge":"2"}},"title":"Natural sciences managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"18","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"18","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Postmasters and mail superintendents":{"ageData":{"2014":{"total":"33","16to19":"0","20to24":"3","25to34":"3","35to44":"7","45to54":"11","55to64":"7","65+":"1","medianAge":"7"}},"title":"Postmasters and mail superintendents","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"29","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Property, real estate, and community association managers":{"ageData":{"2014":{"total":"674","16to19":"1","20to24":"23","25to34":"117","35to44":"133","45to54":"148","55to64":"164","65+":"89","medianAge":"164"}},"title":"Property, real estate, and community association managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"674","women":"48.9","white":"7.5","black":"3.1","asian":"12.9"}},"wageData":{"2014":{"workers":"385","median":"919","maleWorkers":"167","maleMedian":"976","femaleWorkers":"218","femaleMedian":"865"}}},"Social and community service managers":{"ageData":{"2014":{"total":"362","16to19":"2","20to24":"13","25to34":"76","35to44":"77","45to54":"89","55to64":"74","65+":"30","medianAge":"74"}},"title":"Social and community service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"362","women":"65.3","white":"14.6","black":"5.3","asian":"7.6"}},"wageData":{"2014":{"workers":"332","median":"1,008","maleWorkers":"125","maleMedian":"1,142","femaleWorkers":"207","femaleMedian":"978"}}},"Emergency management directors":{"ageData":{"2014":{"total":"8","16to19":"0","20to24":"0","25to34":"0","35to44":"3","45to54":"1","55to64":"3","65+":"1","medianAge":"3"}},"title":"Emergency management directors","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"7","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Managers, all other":{"ageData":{"2014":{"total":"4,075","16to19":"9","20to24":"96","25to34":"626","35to44":"948","45to54":"1,265","55to64":"848","65+":"284","medianAge":"848"}},"title":"Managers, all other","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2014":{"total":"4,075","women":"33.3","white":"6.6","black":"5.5","asian":"9.2"}},"wageData":{"2014":{"workers":"2,609","median":"1,322","maleWorkers":"1,626","maleMedian":"1,412","femaleWorkers":"983","femaleMedian":"1,153"}}},"Business and financial operations occupations":{"ageData":{"2014":{"total":"6,972","16to19":"19","20to24":"442","25to34":"1,678","35to44":"1,623","45to54":"1,574","55to64":"1,222","65+":"413","medianAge":"1,222"}},"title":"Business and financial operations occupations","depth":3,"parent":"Management, business, and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"6,972","women":"55.7","white":"9.5","black":"7.6","asian":"8.4"}},"wageData":{"2014":{"workers":"5,681","median":"1,107","maleWorkers":"2,442","maleMedian":"1,310","femaleWorkers":"3,238","femaleMedian":"982"}}},"Agents and business managers of artists, performers, and athletes":{"ageData":{"2014":{"total":"52","16to19":"0","20to24":"4","25to34":"18","35to44":"9","45to54":"9","55to64":"11","65+":"2","medianAge":"11"}},"title":"Agents and business managers of artists, performers, and athletes","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"52","women":"48.9","white":"9.7","black":"5.7","asian":"8.3"}},"wageData":{"2014":{"workers":"35","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"14","femaleMedian":"-"}}},"Buyers and purchasing agents, farm products":{"ageData":{"2014":{"total":"15","16to19":"0","20to24":"2","25to34":"3","35to44":"3","45to54":"2","55to64":"3","65+":"2","medianAge":"3"}},"title":"Buyers and purchasing agents, farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"15","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"12","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Wholesale and retail buyers, except farm products":{"ageData":{"2014":{"total":"216","16to19":"2","20to24":"25","25to34":"43","35to44":"51","45to54":"47","55to64":"36","65+":"11","medianAge":"36"}},"title":"Wholesale and retail buyers, except farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"216","women":"53.4","white":"6.1","black":"7.0","asian":"8.8"}},"wageData":{"2014":{"workers":"143","median":"859","maleWorkers":"69","maleMedian":"970","femaleWorkers":"74","femaleMedian":"806"}}},"Purchasing agents, except wholesale, retail, and farm products":{"ageData":{"2014":{"total":"271","16to19":"1","20to24":"13","25to34":"52","35to44":"56","45to54":"72","55to64":"60","65+":"15","medianAge":"60"}},"title":"Purchasing agents, except wholesale, retail, and farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"271","women":"55.3","white":"10.8","black":"3.5","asian":"9.0"}},"wageData":{"2014":{"workers":"244","median":"945","maleWorkers":"105","maleMedian":"1,054","femaleWorkers":"139","femaleMedian":"897"}}},"Claims adjusters, appraisers, examiners, and investigators":{"ageData":{"2014":{"total":"311","16to19":"0","20to24":"13","25to34":"68","35to44":"90","45to54":"75","55to64":"52","65+":"13","medianAge":"52"}},"title":"Claims adjusters, appraisers, examiners, and investigators","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"311","women":"60.3","white":"15.2","black":"3.3","asian":"9.7"}},"wageData":{"2014":{"workers":"285","median":"989","maleWorkers":"110","maleMedian":"1,093","femaleWorkers":"175","femaleMedian":"908"}}},"Compliance officers":{"ageData":{"2014":{"total":"239","16to19":"0","20to24":"6","25to34":"46","35to44":"58","45to54":"64","55to64":"52","65+":"13","medianAge":"52"}},"title":"Compliance officers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"239","women":"46.4","white":"10.4","black":"5.3","asian":"9.3"}},"wageData":{"2014":{"workers":"226","median":"1,157","maleWorkers":"118","maleMedian":"1,237","femaleWorkers":"108","femaleMedian":"1,092"}}},"Cost estimators":{"ageData":{"2014":{"total":"105","16to19":"0","20to24":"4","25to34":"24","35to44":"19","45to54":"20","55to64":"30","65+":"7","medianAge":"30"}},"title":"Cost estimators","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"105","women":"13.7","white":"2.4","black":"3.8","asian":"5.6"}},"wageData":{"2014":{"workers":"97","median":"1,059","maleWorkers":"85","maleMedian":"1,074","femaleWorkers":"12","femaleMedian":"-"}}},"Human resources workers":{"ageData":{"2014":{"total":"615","16to19":"2","20to24":"43","25to34":"172","35to44":"147","45to54":"126","55to64":"93","65+":"32","medianAge":"93"}},"title":"Human resources workers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"615","women":"71.8","white":"13.3","black":"4.0","asian":"12.1"}},"wageData":{"2014":{"workers":"550","median":"962","maleWorkers":"147","maleMedian":"1,257","femaleWorkers":"403","femaleMedian":"912"}}},"Compensation, benefits, and job analysis specialists":{"ageData":{"2014":{"total":"71","16to19":"0","20to24":"3","25to34":"21","35to44":"14","45to54":"20","55to64":"12","65+":"2","medianAge":"12"}},"title":"Compensation, benefits, and job analysis specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"71","women":"77.3","white":"16.3","black":"8.6","asian":"9.1"}},"wageData":{"2014":{"workers":"66","median":"1,022","maleWorkers":"17","maleMedian":"-","femaleWorkers":"49","femaleMedian":"-"}}},"Training and development specialists":{"ageData":{"2014":{"total":"128","16to19":"1","20to24":"1","25to34":"38","35to44":"29","45to54":"30","55to64":"24","65+":"4","medianAge":"24"}},"title":"Training and development specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"128","women":"58.3","white":"11.0","black":"2.1","asian":"7.6"}},"wageData":{"2014":{"workers":"118","median":"1,091","maleWorkers":"53","maleMedian":"1,280","femaleWorkers":"65","femaleMedian":"955"}}},"Logisticians":{"ageData":{"2014":{"total":"100","16to19":"0","20to24":"6","25to34":"31","35to44":"20","45to54":"22","55to64":"18","65+":"3","medianAge":"18"}},"title":"Logisticians","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"100","women":"41.4","white":"12.0","black":"4.2","asian":"15.6"}},"wageData":{"2014":{"workers":"83","median":"946","maleWorkers":"43","maleMedian":"-","femaleWorkers":"39","femaleMedian":"-"}}},"Management analysts":{"ageData":{"2014":{"total":"850","16to19":"1","20to24":"38","25to34":"174","35to44":"187","45to54":"199","55to64":"161","65+":"90","medianAge":"161"}},"title":"Management analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"850","women":"41.3","white":"7.7","black":"9.6","asian":"5.8"}},"wageData":{"2014":{"workers":"551","median":"1,470","maleWorkers":"322","maleMedian":"1,665","femaleWorkers":"229","femaleMedian":"1,239"}}},"Meeting, convention, and event planners":{"ageData":{"2014":{"total":"156","16to19":"3","20to24":"30","25to34":"49","35to44":"31","45to54":"22","55to64":"16","65+":"5","medianAge":"16"}},"title":"Meeting, convention, and event planners","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"156","women":"79.2","white":"12.8","black":"3.3","asian":"6.8"}},"wageData":{"2014":{"workers":"107","median":"997","maleWorkers":"20","maleMedian":"-","femaleWorkers":"88","femaleMedian":"981"}}},"Fundraisers":{"ageData":{"2014":{"total":"92","16to19":"1","20to24":"10","25to34":"23","35to44":"20","45to54":"18","55to64":"17","65+":"4","medianAge":"17"}},"title":"Fundraisers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"92","women":"72.6","white":"4.4","black":"2.3","asian":"3.5"}},"wageData":{"2014":{"workers":"72","median":"1,122","maleWorkers":"21","maleMedian":"-","femaleWorkers":"51","femaleMedian":"1,013"}}},"Market research analysts and marketing specialists":{"ageData":{"2014":{"total":"284","16to19":"0","20to24":"38","25to34":"86","35to44":"68","45to54":"50","55to64":"34","65+":"9","medianAge":"34"}},"title":"Market research analysts and marketing specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"284","women":"60.8","white":"5.6","black":"12.1","asian":"7.3"}},"wageData":{"2014":{"workers":"219","median":"1,135","maleWorkers":"85","maleMedian":"1,269","femaleWorkers":"134","femaleMedian":"1,002"}}},"Business operations specialists, all other":{"ageData":{"2014":{"total":"194","16to19":"1","20to24":"13","25to34":"47","35to44":"50","45to54":"46","55to64":"31","65+":"7","medianAge":"31"}},"title":"Business operations specialists, all other","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"194","women":"57.2","white":"10.7","black":"7.4","asian":"11.0"}},"wageData":{"2014":{"workers":"174","median":"1,098","maleWorkers":"74","maleMedian":"1,229","femaleWorkers":"99","femaleMedian":"944"}}},"Accountants and auditors":{"ageData":{"2014":{"total":"1,724","16to19":"2","20to24":"94","25to34":"407","35to44":"403","45to54":"417","55to64":"296","65+":"105","medianAge":"296"}},"title":"Accountants and auditors","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"1,724","women":"63.0","white":"8.2","black":"10.7","asian":"7.8"}},"wageData":{"2014":{"workers":"1,437","median":"1,072","maleWorkers":"526","maleMedian":"1,236","femaleWorkers":"910","femaleMedian":"999"}}},"Appraisers and assessors of real estate":{"ageData":{"2014":{"total":"95","16to19":"0","20to24":"1","25to34":"20","35to44":"15","45to54":"28","55to64":"22","65+":"9","medianAge":"22"}},"title":"Appraisers and assessors of real estate","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"95","women":"40.1","white":"5.4","black":"1.6","asian":"4.2"}},"wageData":{"2014":{"workers":"51","median":"1,009","maleWorkers":"27","maleMedian":"-","femaleWorkers":"24","femaleMedian":"-"}}},"Budget analysts":{"ageData":{"2014":{"total":"48","16to19":"0","20to24":"2","25to34":"12","35to44":"12","45to54":"12","55to64":"9","65+":"0","medianAge":"9"}},"title":"Budget analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"48","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"44","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"23","femaleMedian":"-"}}},"Credit analysts":{"ageData":{"2014":{"total":"28","16to19":"0","20to24":"3","25to34":"9","35to44":"6","45to54":"6","55to64":"3","65+":"1","medianAge":"3"}},"title":"Credit analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"28","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"24","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Financial analysts":{"ageData":{"2014":{"total":"261","16to19":"0","20to24":"27","25to34":"79","35to44":"74","45to54":"38","55to64":"38","65+":"5","medianAge":"38"}},"title":"Financial analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"261","women":"40.5","white":"4.9","black":"15.8","asian":"7.2"}},"wageData":{"2014":{"workers":"226","median":"1,434","maleWorkers":"133","maleMedian":"1,493","femaleWorkers":"93","femaleMedian":"1,224"}}},"Personal financial advisors":{"ageData":{"2014":{"total":"434","16to19":"1","20to24":"33","25to34":"100","35to44":"101","45to54":"91","55to64":"82","65+":"27","medianAge":"82"}},"title":"Personal financial advisors","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"434","women":"35.5","white":"8.1","black":"5.7","asian":"7.1"}},"wageData":{"2014":{"workers":"335","median":"1,337","maleWorkers":"201","maleMedian":"1,637","femaleWorkers":"134","femaleMedian":"1,004"}}},"Insurance underwriters":{"ageData":{"2014":{"total":"113","16to19":"0","20to24":"3","25to34":"33","35to44":"21","45to54":"27","55to64":"26","65+":"3","medianAge":"26"}},"title":"Insurance underwriters","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"113","women":"60.5","white":"12.3","black":"2.4","asian":"7.6"}},"wageData":{"2014":{"workers":"106","median":"1,142","maleWorkers":"42","maleMedian":"-","femaleWorkers":"64","femaleMedian":"1,003"}}},"Financial examiners":{"ageData":{"2014":{"total":"16","16to19":"0","20to24":"2","25to34":"3","35to44":"6","45to54":"3","55to64":"2","65+":"0","medianAge":"2"}},"title":"Financial examiners","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"16","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"16","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Credit counselors and loan officers":{"ageData":{"2014":{"total":"288","16to19":"1","20to24":"22","25to34":"74","35to44":"72","45to54":"67","55to64":"46","65+":"7","medianAge":"46"}},"title":"Credit counselors and loan officers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"288","women":"59.4","white":"10.3","black":"6.3","asian":"11.0"}},"wageData":{"2014":{"workers":"269","median":"997","maleWorkers":"108","maleMedian":"1,188","femaleWorkers":"161","femaleMedian":"915"}}},"Tax examiners and collectors, and revenue agents":{"ageData":{"2014":{"total":"70","16to19":"0","20to24":"0","25to34":"15","35to44":"21","45to54":"19","55to64":"11","65+":"5","medianAge":"11"}},"title":"Tax examiners and collectors, and revenue agents","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"70","women":"60.2","white":"18.3","black":"7.3","asian":"6.4"}},"wageData":{"2014":{"workers":"60","median":"1,183","maleWorkers":"23","maleMedian":"-","femaleWorkers":"37","femaleMedian":"-"}}},"Tax preparers":{"ageData":{"2014":{"total":"103","16to19":"1","20to24":"0","25to34":"17","35to44":"18","45to54":"18","55to64":"22","65+":"26","medianAge":"22"}},"title":"Tax preparers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"103","women":"67.8","white":"16.5","black":"5.7","asian":"13.1"}},"wageData":{"2014":{"workers":"51","median":"904","maleWorkers":"13","maleMedian":"-","femaleWorkers":"38","femaleMedian":"-"}}},"Financial specialists, all other":{"ageData":{"2014":{"total":"93","16to19":"0","20to24":"7","25to34":"16","35to44":"24","45to54":"25","55to64":"16","65+":"5","medianAge":"16"}},"title":"Financial specialists, all other","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2014":{"total":"93","women":"60.1","white":"11.1","black":"8.1","asian":"11.2"}},"wageData":{"2014":{"workers":"79","median":"949","maleWorkers":"30","maleMedian":"-","femaleWorkers":"48","femaleMedian":"-"}}},"Professional and related occupations":{"ageData":{"2014":{"total":"32,879","16to19":"259","20to24":"2,090","25to34":"8,156","35to44":"7,807","45to54":"7,147","55to64":"5,576","65+":"1,845","medianAge":"5,576"}},"title":"Professional and related occupations","depth":2,"parent":"Management, professional, and related occupations","sexRaceEthnicityData":{"2014":{"total":"32,879","women":"57.2","white":"9.7","black":"8.6","asian":"8.6"}},"wageData":{"2014":{"workers":"25,455","median":"1,078","maleWorkers":"11,373","maleMedian":"1,286","femaleWorkers":"14,082","femaleMedian":"948"}}},"Computer and mathematical occupations":{"ageData":{"2014":{"total":"4,303","16to19":"25","20to24":"261","25to34":"1,190","35to44":"1,177","45to54":"989","55to64":"549","65+":"112","medianAge":"549"}},"title":"Computer and mathematical occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2014":{"total":"4,303","women":"25.6","white":"8.3","black":"19.2","asian":"6.6"}},"wageData":{"2014":{"workers":"3,879","median":"1,368","maleWorkers":"2,900","maleMedian":"1,435","femaleWorkers":"979","femaleMedian":"1,165"}}},"Computer and information research scientists":{"ageData":{"2014":{"total":"29","16to19":"0","20to24":"1","25to34":"12","35to44":"5","45to54":"5","55to64":"5","65+":"1","medianAge":"5"}},"title":"Computer and information research scientists","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2014":{"total":"29","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"27","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Computer systems analysts":{"ageData":{"2014":{"total":"511","16to19":"1","20to24":"37","25to34":"122","35to44":"140","45to54":"120","55to64":"74","65+":"17","medianAge":"74"}},"title":"Computer systems analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2014":{"total":"511","women":"34.2","white":"9.7","black":"20.9","asian":"4.8"}},"wageData":{"2014":{"workers":"419","median":"1,385","maleWorkers":"272","maleMedian":"1,460","femaleWorkers":"147","femaleMedian":"1,259"}}},"Information security analysts":{"ageData":{"2014":{"total":"68","16to19":"0","20to24":"4","25to34":"12","35to44":"18","45to54":"17","55to64":"14","65+":"2","medianAge":"14"}},"title":"Information security analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2014":{"total":"68","women":"18.1","white":"9.7","black":"5.7","asian":"6.1"}},"wageData":{"2014":{"workers":"55","median":"1,419","maleWorkers":"47","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Computer programmers":{"ageData":{"2014":{"total":"509","16to19":"3","20to24":"31","25to34":"127","35to44":"131","45to54":"130","55to64":"73","65+":"15","medianAge":"73"}},"title":"Computer programmers","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2014":{"total":"509","women":"21.4","white":"5.7","black":"19.7","asian":"6.4"}},"wageData":{"2014":{"workers":"438","median":"1,409","maleWorkers":"354","maleMedian":"1,447","femaleWorkers":"84","femaleMedian":"1,253"}}},"Software developers, applications and systems software":{"ageData":{"2014":{"total":"1,235","16to19":"2","20to24":"64","25to34":"373","35to44":"360","45to54":"290","55to64":"121","65+":"26","medianAge":"121"}},"title":"Software developers, applications and systems software","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2014":{"total":"1,235","women":"19.8","white":"5.3","black":"31.9","asian":"5.2"}},"wageData":{"2014":{"workers":"1,141","median":"1,693","maleWorkers":"917","maleMedian":"1,736","femaleWorkers":"224","femaleMedian":"1,457"}}},"Web developers":{"ageData":{"2014":{"total":"220","16to19":"4","20to24":"23","25to34":"88","35to44":"56","45to54":"27","55to64":"16","65+":"5","medianAge":"16"}},"title":"Web developers","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2014":{"total":"220","women":"35.2","white":"6.3","black":"5.7","asian":"8.6"}},"wageData":{"2014":{"workers":"163","median":"1,129","maleWorkers":"105","maleMedian":"1,245","femaleWorkers":"57","femaleMedian":"988"}}},"Computer support specialists":{"ageData":{"2014":{"total":"524","16to19":"7","20to24":"50","25to34":"142","35to44":"135","45to54":"110","55to64":"66","65+":"13","medianAge":"66"}},"title":"Computer support specialists","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2014":{"total":"524","women":"26.6","white":"14.3","black":"8.1","asian":"9.4"}},"wageData":{"2014":{"workers":"503","median":"966","maleWorkers":"371","maleMedian":"1,049","femaleWorkers":"132","femaleMedian":"837"}}},"Database administrators":{"ageData":{"2014":{"total":"108","16to19":"0","20to24":"1","25to34":"21","35to44":"35","45to54":"23","55to64":"24","65+":"5","medianAge":"24"}},"title":"Database administrators","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2014":{"total":"108","women":"28.0","white":"11.7","black":"13.3","asian":"4.6"}},"wageData":{"2014":{"workers":"101","median":"1,517","maleWorkers":"76","maleMedian":"1,662","femaleWorkers":"25","femaleMedian":"-"}}},"Network and computer systems administrators":{"ageData":{"2014":{"total":"205","16to19":"0","20to24":"7","25to34":"53","35to44":"66","45to54":"53","55to64":"23","65+":"3","medianAge":"23"}},"title":"Network and computer systems administrators","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2014":{"total":"205","women":"19.1","white":"9.5","black":"8.4","asian":"7.9"}},"wageData":{"2014":{"workers":"204","median":"1,263","maleWorkers":"162","maleMedian":"1,286","femaleWorkers":"42","femaleMedian":"-"}}},"Computer network architects":{"ageData":{"2014":{"total":"123","16to19":"0","20to24":"3","25to34":"33","35to44":"38","45to54":"31","55to64":"12","65+":"5","medianAge":"12"}},"title":"Computer network architects","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2014":{"total":"123","women":"12.4","white":"7.4","black":"17.3","asian":"6.3"}},"wageData":{"2014":{"workers":"126","median":"1,633","maleWorkers":"111","maleMedian":"1,650","femaleWorkers":"15","femaleMedian":"-"}}},"Computer occupations, all other":{"ageData":{"2014":{"total":"512","16to19":"9","20to24":"29","25to34":"124","35to44":"135","45to54":"120","55to64":"82","65+":"13","medianAge":"82"}},"title":"Computer occupations, all other","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2014":{"total":"512","women":"23.1","white":"9.7","black":"12.5","asian":"8.5"}},"wageData":{"2014":{"workers":"452","median":"1,088","maleWorkers":"343","maleMedian":"1,122","femaleWorkers":"109","femaleMedian":"984"}}},"Actuaries":{"ageData":{"2014":{"total":"28","16to19":"0","20to24":"4","25to34":"12","35to44":"4","45to54":"6","55to64":"2","65+":"0","medianAge":"2"}},"title":"Actuaries","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2014":{"total":"28","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"29","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"14","femaleMedian":"-"}}},"Mathematicians":{"ageData":{"2014":{"total":"3","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Mathematicians","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2014":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Operations research analysts":{"ageData":{"2014":{"total":"138","16to19":"0","20to24":"3","25to34":"36","35to44":"30","45to54":"38","55to64":"27","65+":"4","medianAge":"27"}},"title":"Operations research analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2014":{"total":"138","women":"55.4","white":"11.0","black":"11.9","asian":"10.5"}},"wageData":{"2014":{"workers":"134","median":"1,276","maleWorkers":"61","maleMedian":"1,457","femaleWorkers":"72","femaleMedian":"1,233"}}},"Statisticians":{"ageData":{"2014":{"total":"85","16to19":"0","20to24":"4","25to34":"33","35to44":"21","45to54":"17","55to64":"7","65+":"3","medianAge":"7"}},"title":"Statisticians","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2014":{"total":"85","women":"49.9","white":"5.8","black":"24.5","asian":"4.1"}},"wageData":{"2014":{"workers":"78","median":"1,349","maleWorkers":"39","maleMedian":"-","femaleWorkers":"39","femaleMedian":"-"}}},"Miscellaneous mathematical science occupations":{"ageData":{"2014":{"total":"5","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"2","55to64":"0","65+":"1","medianAge":"0"}},"title":"Miscellaneous mathematical science occupations","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2014":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"6","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Architecture and engineering occupations":{"ageData":{"2014":{"total":"2,798","16to19":"13","20to24":"195","25to34":"652","35to44":"603","45to54":"660","55to64":"544","65+":"132","medianAge":"544"}},"title":"Architecture and engineering occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2014":{"total":"2,798","women":"15.4","white":"5.2","black":"11.7","asian":"8.2"}},"wageData":{"2014":{"workers":"2,527","median":"1,377","maleWorkers":"2,150","maleMedian":"1,413","femaleWorkers":"377","femaleMedian":"1,158"}}},"Architects, except naval":{"ageData":{"2014":{"total":"178","16to19":"0","20to24":"7","25to34":"46","35to44":"44","45to54":"34","55to64":"32","65+":"15","medianAge":"32"}},"title":"Architects, except naval","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2014":{"total":"178","women":"25.3","white":"4.1","black":"10.0","asian":"7.2"}},"wageData":{"2014":{"workers":"122","median":"1,329","maleWorkers":"94","maleMedian":"1,391","femaleWorkers":"29","femaleMedian":"-"}}},"Surveyors, cartographers, and photogrammetrists":{"ageData":{"2014":{"total":"41","16to19":"0","20to24":"4","25to34":"12","35to44":"6","45to54":"8","55to64":"8","65+":"3","medianAge":"8"}},"title":"Surveyors, cartographers, and photogrammetrists","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2014":{"total":"41","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"33","median":"-","maleWorkers":"27","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Aerospace engineers":{"ageData":{"2014":{"total":"147","16to19":"0","20to24":"6","25to34":"31","35to44":"33","45to54":"34","55to64":"38","65+":"5","medianAge":"38"}},"title":"Aerospace engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2014":{"total":"147","women":"15.6","white":"6.2","black":"10.7","asian":"11.4"}},"wageData":{"2014":{"workers":"143","median":"1,642","maleWorkers":"121","maleMedian":"1,727","femaleWorkers":"22","femaleMedian":"-"}}},"Agricultural engineers":{"ageData":{"2014":{"total":"4","16to19":"0","20to24":"0","25to34":"1","35to44":"2","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Agricultural engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2014":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Biomedical engineers":{"ageData":{"2014":{"total":"14","16to19":"0","20to24":"1","25to34":"5","35to44":"1","45to54":"4","55to64":"2","65+":"1","medianAge":"2"}},"title":"Biomedical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2014":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"12","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Chemical engineers":{"ageData":{"2014":{"total":"79","16to19":"0","20to24":"10","25to34":"23","35to44":"10","45to54":"23","55to64":"13","65+":"1","medianAge":"13"}},"title":"Chemical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2014":{"total":"79","women":"13.0","white":"3.0","black":"12.6","asian":"3.6"}},"wageData":{"2014":{"workers":"75","median":"1,465","maleWorkers":"64","maleMedian":"1,570","femaleWorkers":"11","femaleMedian":"-"}}},"Civil engineers":{"ageData":{"2014":{"total":"349","16to19":"0","20to24":"24","25to34":"89","35to44":"64","45to54":"81","55to64":"64","65+":"27","medianAge":"64"}},"title":"Civil engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2014":{"total":"349","women":"16.5","white":"6.1","black":"9.7","asian":"8.8"}},"wageData":{"2014":{"workers":"317","median":"1,383","maleWorkers":"263","maleMedian":"1,406","femaleWorkers":"53","femaleMedian":"1,275"}}},"Computer hardware engineers":{"ageData":{"2014":{"total":"84","16to19":"0","20to24":"3","25to34":"17","35to44":"24","45to54":"20","55to64":"15","65+":"4","medianAge":"15"}},"title":"Computer hardware engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2014":{"total":"84","women":"15.3","white":"7.4","black":"22.8","asian":"9.5"}},"wageData":{"2014":{"workers":"79","median":"1,744","maleWorkers":"70","maleMedian":"1,795","femaleWorkers":"9","femaleMedian":"-"}}},"Electrical and electronics engineers":{"ageData":{"2014":{"total":"271","16to19":"0","20to24":"15","25to34":"62","35to44":"57","45to54":"72","55to64":"51","65+":"12","medianAge":"51"}},"title":"Electrical and electronics engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2014":{"total":"271","women":"12.3","white":"3.9","black":"21.4","asian":"5.3"}},"wageData":{"2014":{"workers":"271","median":"1,572","maleWorkers":"242","maleMedian":"1,568","femaleWorkers":"29","femaleMedian":"-"}}},"Environmental engineers":{"ageData":{"2014":{"total":"42","16to19":"0","20to24":"2","25to34":"11","35to44":"13","45to54":"10","55to64":"4","65+":"2","medianAge":"4"}},"title":"Environmental engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2014":{"total":"42","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"40","median":"-","maleWorkers":"31","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Industrial engineers, including health and safety":{"ageData":{"2014":{"total":"194","16to19":"0","20to24":"17","25to34":"44","35to44":"35","45to54":"50","55to64":"40","65+":"8","medianAge":"40"}},"title":"Industrial engineers, including health and safety","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2014":{"total":"194","women":"16.0","white":"5.5","black":"9.7","asian":"8.6"}},"wageData":{"2014":{"workers":"187","median":"1,404","maleWorkers":"155","maleMedian":"1,464","femaleWorkers":"32","femaleMedian":"-"}}},"Marine engineers and naval architects":{"ageData":{"2014":{"total":"9","16to19":"0","20to24":"1","25to34":"2","35to44":"1","45to54":"5","55to64":"0","65+":"0","medianAge":"0"}},"title":"Marine engineers and naval architects","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2014":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Materials engineers":{"ageData":{"2014":{"total":"35","16to19":"0","20to24":"0","25to34":"9","35to44":"8","45to54":"10","55to64":"7","65+":"1","medianAge":"7"}},"title":"Materials engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2014":{"total":"35","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"33","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Mechanical engineers":{"ageData":{"2014":{"total":"303","16to19":"0","20to24":"23","25to34":"77","35to44":"72","45to54":"72","55to64":"47","65+":"12","medianAge":"47"}},"title":"Mechanical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2014":{"total":"303","women":"8.8","white":"3.3","black":"9.9","asian":"5.6"}},"wageData":{"2014":{"workers":"286","median":"1,434","maleWorkers":"259","maleMedian":"1,453","femaleWorkers":"27","femaleMedian":"-"}}},"Mining and geological engineers, including mining safety engineers":{"ageData":{"2014":{"total":"15","16to19":"0","20to24":"1","25to34":"3","35to44":"5","45to54":"4","55to64":"3","65+":"0","medianAge":"3"}},"title":"Mining and geological engineers, including mining safety engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2014":{"total":"15","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"18","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Nuclear engineers":{"ageData":{"2014":{"total":"5","16to19":"0","20to24":"1","25to34":"2","35to44":"2","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Nuclear engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2014":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Petroleum engineers":{"ageData":{"2014":{"total":"37","16to19":"0","20to24":"1","25to34":"12","35to44":"10","45to54":"6","55to64":"8","65+":"1","medianAge":"8"}},"title":"Petroleum engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2014":{"total":"37","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"36","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Engineers, all other":{"ageData":{"2014":{"total":"406","16to19":"3","20to24":"14","25to34":"92","35to44":"88","45to54":"96","55to64":"88","65+":"25","medianAge":"88"}},"title":"Engineers, all other","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2014":{"total":"406","women":"11.7","white":"4.4","black":"18.2","asian":"8.0"}},"wageData":{"2014":{"workers":"362","median":"1,463","maleWorkers":"317","maleMedian":"1,488","femaleWorkers":"44","femaleMedian":"-"}}},"Drafters":{"ageData":{"2014":{"total":"138","16to19":"0","20to24":"17","25to34":"26","35to44":"36","45to54":"32","55to64":"24","65+":"2","medianAge":"24"}},"title":"Drafters","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2014":{"total":"138","women":"18.1","white":"5.3","black":"4.3","asian":"6.5"}},"wageData":{"2014":{"workers":"122","median":"979","maleWorkers":"102","maleMedian":"986","femaleWorkers":"20","femaleMedian":"-"}}},"Engineering technicians, except drafters":{"ageData":{"2014":{"total":"369","16to19":"5","20to24":"38","25to34":"69","35to44":"75","45to54":"85","55to64":"84","65+":"12","medianAge":"84"}},"title":"Engineering technicians, except drafters","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2014":{"total":"369","women":"20.5","white":"8.2","black":"8.7","asian":"13.2"}},"wageData":{"2014":{"workers":"321","median":"989","maleWorkers":"253","maleMedian":"1,066","femaleWorkers":"68","femaleMedian":"785"}}},"Surveying and mapping technicians":{"ageData":{"2014":{"total":"77","16to19":"3","20to24":"10","25to34":"17","35to44":"17","45to54":"14","55to64":"15","65+":"1","medianAge":"15"}},"title":"Surveying and mapping technicians","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2014":{"total":"77","women":"9.7","white":"6.8","black":"0.8","asian":"9.4"}},"wageData":{"2014":{"workers":"56","median":"879","maleWorkers":"54","maleMedian":"882","femaleWorkers":"2","femaleMedian":"-"}}},"Life, physical, and social science occupations":{"ageData":{"2014":{"total":"1,355","16to19":"4","20to24":"105","25to34":"336","35to44":"337","45to54":"262","55to64":"213","65+":"98","medianAge":"213"}},"title":"Life, physical, and social science occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2014":{"total":"1,355","women":"45.6","white":"6.4","black":"12.3","asian":"7.5"}},"wageData":{"2014":{"workers":"1,124","median":"1,168","maleWorkers":"658","maleMedian":"1,247","femaleWorkers":"466","femaleMedian":"1,062"}}},"Agricultural and food scientists":{"ageData":{"2014":{"total":"31","16to19":"0","20to24":"2","25to34":"11","35to44":"7","45to54":"8","55to64":"2","65+":"1","medianAge":"2"}},"title":"Agricultural and food scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2014":{"total":"31","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"26","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Biological scientists":{"ageData":{"2014":{"total":"110","16to19":"0","20to24":"9","25to34":"23","35to44":"33","45to54":"19","55to64":"20","65+":"6","medianAge":"20"}},"title":"Biological scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2014":{"total":"110","women":"45.9","white":"5.3","black":"10.5","asian":"6.0"}},"wageData":{"2014":{"workers":"94","median":"1,152","maleWorkers":"54","maleMedian":"1,356","femaleWorkers":"41","femaleMedian":"-"}}},"Conservation scientists and foresters":{"ageData":{"2014":{"total":"27","16to19":"0","20to24":"1","25to34":"7","35to44":"8","45to54":"3","55to64":"7","65+":"1","medianAge":"7"}},"title":"Conservation scientists and foresters","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2014":{"total":"27","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"25","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Medical scientists":{"ageData":{"2014":{"total":"143","16to19":"0","20to24":"7","25to34":"43","35to44":"40","45to54":"24","55to64":"20","65+":"9","medianAge":"20"}},"title":"Medical scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2014":{"total":"143","women":"52.5","white":"5.1","black":"33.8","asian":"7.9"}},"wageData":{"2014":{"workers":"137","median":"1,267","maleWorkers":"69","maleMedian":"1,449","femaleWorkers":"68","femaleMedian":"1,141"}}},"Life scientists, all other":{"ageData":{"2014":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Life scientists, all other","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2014":{"total":"0","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Astronomers and physicists":{"ageData":{"2014":{"total":"12","16to19":"0","20to24":"1","25to34":"2","35to44":"1","45to54":"2","55to64":"3","65+":"3","medianAge":"3"}},"title":"Astronomers and physicists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2014":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"8","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Atmospheric and space scientists":{"ageData":{"2014":{"total":"7","16to19":"0","20to24":"2","25to34":"1","35to44":"1","45to54":"3","55to64":"1","65+":"0","medianAge":"1"}},"title":"Atmospheric and space scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2014":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Chemists and materials scientists":{"ageData":{"2014":{"total":"102","16to19":"0","20to24":"6","25to34":"25","35to44":"26","45to54":"24","55to64":"15","65+":"5","medianAge":"15"}},"title":"Chemists and materials scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2014":{"total":"102","women":"29.8","white":"8.1","black":"12.7","asian":"6.0"}},"wageData":{"2014":{"workers":"98","median":"1,251","maleWorkers":"70","maleMedian":"1,369","femaleWorkers":"28","femaleMedian":"-"}}},"Environmental scientists and geoscientists":{"ageData":{"2014":{"total":"91","16to19":"0","20to24":"7","25to34":"17","35to44":"24","45to54":"20","55to64":"19","65+":"4","medianAge":"19"}},"title":"Environmental scientists and geoscientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2014":{"total":"91","women":"24.5","white":"1.3","black":"3.9","asian":"6.6"}},"wageData":{"2014":{"workers":"72","median":"1,358","maleWorkers":"55","maleMedian":"1,388","femaleWorkers":"17","femaleMedian":"-"}}},"Physical scientists, all other":{"ageData":{"2014":{"total":"183","16to19":"0","20to24":"8","25to34":"45","35to44":"53","45to54":"39","55to64":"25","65+":"13","medianAge":"25"}},"title":"Physical scientists, all other","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2014":{"total":"183","women":"37.6","white":"3.0","black":"25.4","asian":"5.7"}},"wageData":{"2014":{"workers":"179","median":"1,447","maleWorkers":"116","maleMedian":"1,547","femaleWorkers":"63","femaleMedian":"1,262"}}},"Economists":{"ageData":{"2014":{"total":"33","16to19":"0","20to24":"2","25to34":"8","35to44":"12","45to54":"5","55to64":"3","65+":"3","medianAge":"3"}},"title":"Economists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2014":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"27","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Survey researchers":{"ageData":{"2014":{"total":"4","16to19":"1","20to24":"0","25to34":"1","35to44":"1","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Survey researchers","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2014":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Psychologists":{"ageData":{"2014":{"total":"232","16to19":"0","20to24":"2","25to34":"45","35to44":"53","45to54":"46","55to64":"47","65+":"39","medianAge":"47"}},"title":"Psychologists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2014":{"total":"232","women":"71.9","white":"5.7","black":"1.3","asian":"8.0"}},"wageData":{"2014":{"workers":"124","median":"1,232","maleWorkers":"31","maleMedian":"-","femaleWorkers":"94","femaleMedian":"1,212"}}},"Sociologists":{"ageData":{"2014":{"total":"3","16to19":"0","20to24":"0","25to34":"3","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Sociologists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2014":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"5","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Urban and regional planners":{"ageData":{"2014":{"total":"24","16to19":"0","20to24":"1","25to34":"5","35to44":"8","45to54":"5","55to64":"5","65+":"1","medianAge":"5"}},"title":"Urban and regional planners","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2014":{"total":"24","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"23","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Miscellaneous social scientists and related workers":{"ageData":{"2014":{"total":"42","16to19":"0","20to24":"3","25to34":"12","35to44":"10","45to54":"8","55to64":"5","65+":"4","medianAge":"5"}},"title":"Miscellaneous social scientists and related workers","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2014":{"total":"42","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"36","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Agricultural and food science technicians":{"ageData":{"2014":{"total":"39","16to19":"0","20to24":"2","25to34":"16","35to44":"8","45to54":"8","55to64":"3","65+":"3","medianAge":"3"}},"title":"Agricultural and food science technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2014":{"total":"39","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"36","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Biological technicians":{"ageData":{"2014":{"total":"25","16to19":"0","20to24":"10","25to34":"7","35to44":"5","45to54":"3","55to64":"0","65+":"1","medianAge":"0"}},"title":"Biological technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2014":{"total":"25","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"21","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Chemical technicians":{"ageData":{"2014":{"total":"71","16to19":"0","20to24":"6","25to34":"21","35to44":"17","45to54":"13","55to64":"11","65+":"3","medianAge":"11"}},"title":"Chemical technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2014":{"total":"71","women":"32.3","white":"16.4","black":"4.6","asian":"8.9"}},"wageData":{"2014":{"workers":"67","median":"910","maleWorkers":"45","maleMedian":"-","femaleWorkers":"22","femaleMedian":"-"}}},"Geological and petroleum technicians":{"ageData":{"2014":{"total":"20","16to19":"0","20to24":"1","25to34":"7","35to44":"2","45to54":"7","55to64":"3","65+":"0","medianAge":"3"}},"title":"Geological and petroleum technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2014":{"total":"20","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"23","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Nuclear technicians":{"ageData":{"2014":{"total":"6","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"3","55to64":"1","65+":"1","medianAge":"1"}},"title":"Nuclear technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2014":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"3","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Social science research assistants":{"ageData":{"2014":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Social science research assistants","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2014":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Miscellaneous life, physical, and social science technicians":{"ageData":{"2014":{"total":"149","16to19":"2","20to24":"37","25to34":"36","35to44":"27","45to54":"22","55to64":"23","65+":"2","medianAge":"23"}},"title":"Miscellaneous life, physical, and social science technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2014":{"total":"149","women":"51.4","white":"7.4","black":"11.6","asian":"7.7"}},"wageData":{"2014":{"workers":"110","median":"851","maleWorkers":"58","maleMedian":"872","femaleWorkers":"53","femaleMedian":"805"}}},"Community and social service occupations":{"ageData":{"2014":{"total":"2,495","16to19":"20","20to24":"142","25to34":"586","35to44":"588","45to54":"542","55to64":"446","65+":"172","medianAge":"446"}},"title":"Community and social service occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2014":{"total":"2,495","women":"64.3","white":"17.5","black":"3.4","asian":"11.6"}},"wageData":{"2014":{"workers":"2,005","median":"858","maleWorkers":"741","maleMedian":"934","femaleWorkers":"1,264","femaleMedian":"824"}}},"Counselors":{"ageData":{"2014":{"total":"737","16to19":"16","20to24":"50","25to34":"189","35to44":"164","45to54":"144","55to64":"134","65+":"39","medianAge":"134"}},"title":"Counselors","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2014":{"total":"737","women":"71.1","white":"18.7","black":"2.8","asian":"10.6"}},"wageData":{"2014":{"workers":"552","median":"849","maleWorkers":"174","maleMedian":"885","femaleWorkers":"378","femaleMedian":"831"}}},"Social workers":{"ageData":{"2014":{"total":"799","16to19":"0","20to24":"33","25to34":"219","35to44":"215","45to54":"178","55to64":"117","65+":"36","medianAge":"117"}},"title":"Social workers","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2014":{"total":"799","women":"81.9","white":"21.3","black":"2.4","asian":"13.2"}},"wageData":{"2014":{"workers":"690","median":"844","maleWorkers":"127","maleMedian":"892","femaleWorkers":"563","femaleMedian":"839"}}},"Probation officers and correctional treatment specialists":{"ageData":{"2014":{"total":"100","16to19":"0","20to24":"2","25to34":"24","35to44":"39","45to54":"24","55to64":"11","65+":"0","medianAge":"11"}},"title":"Probation officers and correctional treatment specialists","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2014":{"total":"100","women":"52.5","white":"21.0","black":"3.2","asian":"16.4"}},"wageData":{"2014":{"workers":"95","median":"999","maleWorkers":"45","maleMedian":"-","femaleWorkers":"50","femaleMedian":"1,141"}}},"Social and human service assistants":{"ageData":{"2014":{"total":"180","16to19":"1","20to24":"16","25to34":"40","35to44":"42","45to54":"36","55to64":"34","65+":"11","medianAge":"34"}},"title":"Social and human service assistants","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2014":{"total":"180","women":"77.9","white":"25.5","black":"2.2","asian":"16.5"}},"wageData":{"2014":{"workers":"142","median":"716","maleWorkers":"29","maleMedian":"-","femaleWorkers":"113","femaleMedian":"673"}}},"Miscellaneous community and social service specialists, including health educators and community health workers":{"ageData":{"2014":{"total":"114","16to19":"2","20to24":"10","25to34":"27","35to44":"22","45to54":"22","55to64":"23","65+":"9","medianAge":"23"}},"title":"Miscellaneous community and social service specialists, including health educators and community health workers","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2014":{"total":"114","women":"69.3","white":"14.6","black":"1.7","asian":"17.4"}},"wageData":{"2014":{"workers":"93","median":"773","maleWorkers":"26","maleMedian":"-","femaleWorkers":"66","femaleMedian":"747"}}},"Clergy":{"ageData":{"2014":{"total":"433","16to19":"1","20to24":"16","25to34":"61","35to44":"80","45to54":"109","55to64":"101","65+":"67","medianAge":"101"}},"title":"Clergy","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2014":{"total":"433","women":"18.6","white":"8.3","black":"6.9","asian":"7.5"}},"wageData":{"2014":{"workers":"356","median":"958","maleWorkers":"303","maleMedian":"1,007","femaleWorkers":"53","femaleMedian":"763"}}},"Directors, religious activities and education":{"ageData":{"2014":{"total":"64","16to19":"0","20to24":"6","25to34":"18","35to44":"11","45to54":"11","55to64":"15","65+":"3","medianAge":"15"}},"title":"Directors, religious activities and education","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2014":{"total":"64","women":"53.0","white":"4.1","black":"1.1","asian":"7.1"}},"wageData":{"2014":{"workers":"37","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"18","femaleMedian":"-"}}},"Religious workers, all other":{"ageData":{"2014":{"total":"68","16to19":"1","20to24":"8","25to34":"9","35to44":"15","45to54":"19","55to64":"10","65+":"6","medianAge":"10"}},"title":"Religious workers, all other","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2014":{"total":"68","women":"58.8","white":"7.3","black":"6.3","asian":"6.1"}},"wageData":{"2014":{"workers":"40","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"23","femaleMedian":"-"}}},"Legal occupations":{"ageData":{"2014":{"total":"1,814","16to19":"5","20to24":"37","25to34":"388","35to44":"405","45to54":"431","55to64":"387","65+":"160","medianAge":"387"}},"title":"Legal occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2014":{"total":"1,814","women":"50.8","white":"7.5","black":"4.5","asian":"7.9"}},"wageData":{"2014":{"workers":"1,313","median":"1,271","maleWorkers":"591","maleMedian":"1,765","femaleWorkers":"722","femaleMedian":"1,001"}}},"Lawyers":{"ageData":{"2014":{"total":"1,132","16to19":"0","20to24":"5","25to34":"223","35to44":"276","45to54":"254","55to64":"250","65+":"123","medianAge":"250"}},"title":"Lawyers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2014":{"total":"1,132","women":"32.9","white":"5.7","black":"4.4","asian":"5.6"}},"wageData":{"2014":{"workers":"737","median":"1,807","maleWorkers":"486","maleMedian":"1,915","femaleWorkers":"251","femaleMedian":"1,590"}}},"Judicial law clerks":{"ageData":{"2014":{"total":"12","16to19":"0","20to24":"0","25to34":"6","35to44":"3","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Judicial law clerks","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2014":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"12","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Judges, magistrates, and other judicial workers":{"ageData":{"2014":{"total":"53","16to19":"0","20to24":"1","25to34":"5","35to44":"7","45to54":"17","55to64":"16","65+":"8","medianAge":"16"}},"title":"Judges, magistrates, and other judicial workers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2014":{"total":"53","women":"51.7","white":"10.9","black":"3.2","asian":"4.8"}},"wageData":{"2014":{"workers":"48","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"26","femaleMedian":"-"}}},"Paralegals and legal assistants":{"ageData":{"2014":{"total":"417","16to19":"2","20to24":"25","25to34":"110","35to44":"86","45to54":"104","55to64":"72","65+":"18","medianAge":"72"}},"title":"Paralegals and legal assistants","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2014":{"total":"417","women":"87.3","white":"9.5","black":"4.3","asian":"14.2"}},"wageData":{"2014":{"workers":"359","median":"831","maleWorkers":"37","maleMedian":"-","femaleWorkers":"321","femaleMedian":"840"}}},"Miscellaneous legal support workers":{"ageData":{"2014":{"total":"200","16to19":"3","20to24":"7","25to34":"45","35to44":"33","45to54":"55","55to64":"47","65+":"10","medianAge":"47"}},"title":"Miscellaneous legal support workers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2014":{"total":"200","women":"75.8","white":"12.8","black":"5.1","asian":"8.9"}},"wageData":{"2014":{"workers":"158","median":"870","maleWorkers":"39","maleMedian":"-","femaleWorkers":"118","femaleMedian":"817"}}},"Education, training, and library occupations":{"ageData":{"2014":{"total":"8,686","16to19":"97","20to24":"617","25to34":"2,027","35to44":"2,034","45to54":"1,857","55to64":"1,508","65+":"545","medianAge":"1,508"}},"title":"Education, training, and library occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2014":{"total":"8,686","women":"74.1","white":"10.3","black":"4.4","asian":"9.5"}},"wageData":{"2014":{"workers":"6,595","median":"953","maleWorkers":"1,763","maleMedian":"1,141","femaleWorkers":"4,832","femaleMedian":"897"}}},"Postsecondary teachers":{"ageData":{"2014":{"total":"1,259","16to19":"5","20to24":"84","25to34":"296","35to44":"229","45to54":"236","55to64":"260","65+":"150","medianAge":"260"}},"title":"Postsecondary teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2014":{"total":"1,259","women":"50.2","white":"6.1","black":"12.2","asian":"6.1"}},"wageData":{"2014":{"workers":"860","median":"1,256","maleWorkers":"454","maleMedian":"1,409","femaleWorkers":"405","femaleMedian":"1,143"}}},"Preschool and kindergarten teachers":{"ageData":{"2014":{"total":"664","16to19":"6","20to24":"67","25to34":"192","35to44":"158","45to54":"135","55to64":"77","65+":"29","medianAge":"77"}},"title":"Preschool and kindergarten teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2014":{"total":"664","women":"97.2","white":"15.8","black":"3.4","asian":"13.9"}},"wageData":{"2014":{"workers":"499","median":"634","maleWorkers":"13","maleMedian":"-","femaleWorkers":"486","femaleMedian":"625"}}},"Elementary and middle school teachers":{"ageData":{"2014":{"total":"3,102","16to19":"8","20to24":"139","25to34":"766","35to44":"855","45to54":"709","55to64":"479","65+":"146","medianAge":"479"}},"title":"Elementary and middle school teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2014":{"total":"3,102","women":"80.9","white":"10.2","black":"2.5","asian":"8.7"}},"wageData":{"2014":{"workers":"2,730","median":"980","maleWorkers":"534","maleMedian":"1,096","femaleWorkers":"2,196","femaleMedian":"956"}}},"Secondary school teachers":{"ageData":{"2014":{"total":"1,099","16to19":"2","20to24":"53","25to34":"296","35to44":"282","45to54":"233","55to64":"189","65+":"43","medianAge":"189"}},"title":"Secondary school teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2014":{"total":"1,099","women":"57.0","white":"10.0","black":"2.2","asian":"7.6"}},"wageData":{"2014":{"workers":"981","median":"1,037","maleWorkers":"432","maleMedian":"1,108","femaleWorkers":"549","femaleMedian":"984"}}},"Special education teachers":{"ageData":{"2014":{"total":"336","16to19":"0","20to24":"15","25to34":"78","35to44":"80","45to54":"72","55to64":"80","65+":"11","medianAge":"80"}},"title":"Special education teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2014":{"total":"336","women":"83.7","white":"8.9","black":"1.5","asian":"6.8"}},"wageData":{"2014":{"workers":"295","median":"1,001","maleWorkers":"57","maleMedian":"1,078","femaleWorkers":"239","femaleMedian":"987"}}},"Other teachers and instructors":{"ageData":{"2014":{"total":"836","16to19":"49","20to24":"119","25to34":"182","35to44":"142","45to54":"140","55to64":"129","65+":"75","medianAge":"129"}},"title":"Other teachers and instructors","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2014":{"total":"836","women":"65.4","white":"11.5","black":"6.0","asian":"11.1"}},"wageData":{"2014":{"workers":"340","median":"846","maleWorkers":"142","maleMedian":"1,096","femaleWorkers":"198","femaleMedian":"772"}}},"Archivists, curators, and museum technicians":{"ageData":{"2014":{"total":"47","16to19":"0","20to24":"6","25to34":"6","35to44":"15","45to54":"10","55to64":"7","65+":"3","medianAge":"7"}},"title":"Archivists, curators, and museum technicians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2014":{"total":"47","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"32","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"20","femaleMedian":"-"}}},"Librarians":{"ageData":{"2014":{"total":"198","16to19":"2","20to24":"6","25to34":"25","35to44":"47","45to54":"41","55to64":"55","65+":"21","medianAge":"55"}},"title":"Librarians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2014":{"total":"198","women":"84.8","white":"3.6","black":"4.0","asian":"5.7"}},"wageData":{"2014":{"workers":"155","median":"889","maleWorkers":"27","maleMedian":"-","femaleWorkers":"129","femaleMedian":"849"}}},"Library technicians":{"ageData":{"2014":{"total":"36","16to19":"6","20to24":"10","25to34":"4","35to44":"4","45to54":"5","55to64":"6","65+":"1","medianAge":"6"}},"title":"Library technicians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2014":{"total":"36","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"9","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Teacher assistants":{"ageData":{"2014":{"total":"904","16to19":"18","20to24":"105","25to34":"142","35to44":"179","45to54":"226","55to64":"185","65+":"47","medianAge":"185"}},"title":"Teacher assistants","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2014":{"total":"904","women":"90.3","white":"14.4","black":"3.0","asian":"17.1"}},"wageData":{"2014":{"workers":"545","median":"498","maleWorkers":"52","maleMedian":"580","femaleWorkers":"492","femaleMedian":"494"}}},"Other education, training, and library workers":{"ageData":{"2014":{"total":"206","16to19":"0","20to24":"14","25to34":"39","35to44":"42","45to54":"50","55to64":"43","65+":"17","medianAge":"43"}},"title":"Other education, training, and library workers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2014":{"total":"206","women":"74.0","white":"10.9","black":"2.9","asian":"8.7"}},"wageData":{"2014":{"workers":"149","median":"956","maleWorkers":"37","maleMedian":"-","femaleWorkers":"111","femaleMedian":"983"}}},"Arts, design, entertainment, sports, and media occupations":{"ageData":{"2014":{"total":"2,935","16to19":"66","20to24":"297","25to34":"760","35to44":"620","45to54":"565","55to64":"440","65+":"188","medianAge":"440"}},"title":"Arts, design, entertainment, sports, and media occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2014":{"total":"2,935","women":"47.4","white":"6.3","black":"5.0","asian":"9.8"}},"wageData":{"2014":{"workers":"1,573","median":"956","maleWorkers":"906","maleMedian":"1,024","femaleWorkers":"667","femaleMedian":"870"}}},"Artists and related workers":{"ageData":{"2014":{"total":"203","16to19":"2","20to24":"9","25to34":"38","35to44":"37","45to54":"44","55to64":"49","65+":"24","medianAge":"49"}},"title":"Artists and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2014":{"total":"203","women":"48.8","white":"2.1","black":"5.7","asian":"9.1"}},"wageData":{"2014":{"workers":"65","median":"1,166","maleWorkers":"43","maleMedian":"-","femaleWorkers":"22","femaleMedian":"-"}}},"Designers":{"ageData":{"2014":{"total":"830","16to19":"5","20to24":"72","25to34":"216","35to44":"187","45to54":"179","55to64":"125","65+":"46","medianAge":"125"}},"title":"Designers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2014":{"total":"830","women":"56.3","white":"4.1","black":"7.1","asian":"11.1"}},"wageData":{"2014":{"workers":"546","median":"921","maleWorkers":"289","maleMedian":"1,020","femaleWorkers":"257","femaleMedian":"812"}}},"Actors":{"ageData":{"2014":{"total":"43","16to19":"3","20to24":"4","25to34":"9","35to44":"10","45to54":"9","55to64":"4","65+":"4","medianAge":"4"}},"title":"Actors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2014":{"total":"43","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"13","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Producers and directors":{"ageData":{"2014":{"total":"161","16to19":"0","20to24":"15","25to34":"48","35to44":"31","45to54":"35","55to64":"24","65+":"8","medianAge":"24"}},"title":"Producers and directors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2014":{"total":"161","women":"36.5","white":"4.6","black":"4.0","asian":"11.7"}},"wageData":{"2014":{"workers":"101","median":"1,192","maleWorkers":"66","maleMedian":"1,224","femaleWorkers":"35","femaleMedian":"-"}}},"Athletes, coaches, umpires, and related workers":{"ageData":{"2014":{"total":"294","16to19":"37","20to24":"61","25to34":"71","35to44":"55","45to54":"33","55to64":"27","65+":"10","medianAge":"27"}},"title":"Athletes, coaches, umpires, and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2014":{"total":"294","women":"34.3","white":"6.5","black":"2.5","asian":"8.8"}},"wageData":{"2014":{"workers":"113","median":"871","maleWorkers":"83","maleMedian":"974","femaleWorkers":"29","femaleMedian":"-"}}},"Dancers and choreographers":{"ageData":{"2014":{"total":"18","16to19":"2","20to24":"6","25to34":"5","35to44":"1","45to54":"2","55to64":"2","65+":"1","medianAge":"2"}},"title":"Dancers and choreographers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2014":{"total":"18","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"8","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Musicians, singers, and related workers":{"ageData":{"2014":{"total":"194","16to19":"4","20to24":"13","25to34":"40","35to44":"37","45to54":"39","55to64":"37","65+":"24","medianAge":"37"}},"title":"Musicians, singers, and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2014":{"total":"194","women":"34.0","white":"12.6","black":"3.0","asian":"6.1"}},"wageData":{"2014":{"workers":"39","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Entertainers and performers, sports and related workers, all other":{"ageData":{"2014":{"total":"38","16to19":"2","20to24":"6","25to34":"9","35to44":"9","45to54":"3","55to64":"6","65+":"3","medianAge":"6"}},"title":"Entertainers and performers, sports and related workers, all other","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2014":{"total":"38","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"10","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Announcers":{"ageData":{"2014":{"total":"60","16to19":"0","20to24":"9","25to34":"19","35to44":"15","45to54":"8","55to64":"7","65+":"2","medianAge":"7"}},"title":"Announcers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2014":{"total":"60","women":"25.7","white":"17.1","black":"5.1","asian":"10.5"}},"wageData":{"2014":{"workers":"28","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"News analysts, reporters and correspondents":{"ageData":{"2014":{"total":"80","16to19":"1","20to24":"16","25to34":"30","35to44":"16","45to54":"9","55to64":"5","65+":"3","medianAge":"5"}},"title":"News analysts, reporters and correspondents","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2014":{"total":"80","women":"43.9","white":"7.5","black":"6.3","asian":"13.8"}},"wageData":{"2014":{"workers":"59","median":"802","maleWorkers":"35","maleMedian":"-","femaleWorkers":"24","femaleMedian":"-"}}},"Public relations specialists":{"ageData":{"2014":{"total":"136","16to19":"0","20to24":"12","25to34":"48","35to44":"31","45to54":"23","55to64":"16","65+":"5","medianAge":"16"}},"title":"Public relations specialists","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2014":{"total":"136","women":"60.5","white":"9.0","black":"4.0","asian":"9.2"}},"wageData":{"2014":{"workers":"111","median":"982","maleWorkers":"42","maleMedian":"-","femaleWorkers":"69","femaleMedian":"933"}}},"Editors":{"ageData":{"2014":{"total":"163","16to19":"2","20to24":"15","25to34":"40","35to44":"35","45to54":"34","55to64":"26","65+":"11","medianAge":"26"}},"title":"Editors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2014":{"total":"163","women":"48.2","white":"2.8","black":"5.5","asian":"7.1"}},"wageData":{"2014":{"workers":"120","median":"1,018","maleWorkers":"73","maleMedian":"1,051","femaleWorkers":"47","femaleMedian":"-"}}},"Technical writers":{"ageData":{"2014":{"total":"61","16to19":"0","20to24":"3","25to34":"14","35to44":"10","45to54":"17","55to64":"15","65+":"1","medianAge":"15"}},"title":"Technical writers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2014":{"total":"61","women":"48.9","white":"5.7","black":"3.6","asian":"2.6"}},"wageData":{"2014":{"workers":"51","median":"1,297","maleWorkers":"27","maleMedian":"-","femaleWorkers":"23","femaleMedian":"-"}}},"Writers and authors":{"ageData":{"2014":{"total":"221","16to19":"1","20to24":"17","25to34":"49","35to44":"42","45to54":"45","55to64":"44","65+":"24","medianAge":"44"}},"title":"Writers and authors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2014":{"total":"221","women":"59.1","white":"6.2","black":"3.2","asian":"5.6"}},"wageData":{"2014":{"workers":"103","median":"1,016","maleWorkers":"42","maleMedian":"-","femaleWorkers":"60","femaleMedian":"863"}}},"Miscellaneous media and communication workers":{"ageData":{"2014":{"total":"78","16to19":"0","20to24":"6","25to34":"9","35to44":"23","45to54":"21","55to64":"13","65+":"7","medianAge":"13"}},"title":"Miscellaneous media and communication workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2014":{"total":"78","women":"73.6","white":"4.8","black":"11.6","asian":"33.3"}},"wageData":{"2014":{"workers":"39","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"25","femaleMedian":"-"}}},"Broadcast and sound engineering technicians and radio operators":{"ageData":{"2014":{"total":"108","16to19":"2","20to24":"16","25to34":"29","35to44":"21","45to54":"26","55to64":"11","65+":"3","medianAge":"11"}},"title":"Broadcast and sound engineering technicians and radio operators","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2014":{"total":"108","women":"13.0","white":"15.2","black":"4.8","asian":"10.5"}},"wageData":{"2014":{"workers":"79","median":"948","maleWorkers":"67","maleMedian":"958","femaleWorkers":"11","femaleMedian":"-"}}},"Photographers":{"ageData":{"2014":{"total":"174","16to19":"3","20to24":"11","25to34":"64","35to44":"42","45to54":"25","55to64":"18","65+":"11","medianAge":"18"}},"title":"Photographers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2014":{"total":"174","women":"51.0","white":"4.3","black":"3.7","asian":"10.1"}},"wageData":{"2014":{"workers":"55","median":"938","maleWorkers":"32","maleMedian":"-","femaleWorkers":"22","femaleMedian":"-"}}},"Television, video, and motion picture camera operators and editors":{"ageData":{"2014":{"total":"72","16to19":"3","20to24":"7","25to34":"22","35to44":"18","45to54":"10","55to64":"11","65+":"1","medianAge":"11"}},"title":"Television, video, and motion picture camera operators and editors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2014":{"total":"72","women":"18.1","white":"4.4","black":"0.0","asian":"5.7"}},"wageData":{"2014":{"workers":"34","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Media and communication equipment workers, all other":{"ageData":{"2014":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Media and communication equipment workers, all other","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2014":{"total":"0","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Healthcare practitioners and technical occupations":{"ageData":{"2014":{"total":"8,493","16to19":"29","20to24":"435","25to34":"2,218","35to44":"2,044","45to54":"1,840","55to64":"1,490","65+":"438","medianAge":"1,490"}},"title":"Healthcare practitioners and technical occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2014":{"total":"8,493","women":"74.2","white":"11.2","black":"9.4","asian":"7.7"}},"wageData":{"2014":{"workers":"6,438","median":"1,033","maleWorkers":"1,663","maleMedian":"1,256","femaleWorkers":"4,775","femaleMedian":"983"}}},"Chiropractors":{"ageData":{"2014":{"total":"66","16to19":"0","20to24":"0","25to34":"12","35to44":"16","45to54":"17","55to64":"14","65+":"8","medianAge":"14"}},"title":"Chiropractors","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"66","women":"22.4","white":"0.0","black":"7.0","asian":"2.9"}},"wageData":{"2014":{"workers":"18","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Dentists":{"ageData":{"2014":{"total":"192","16to19":"0","20to24":"2","25to34":"28","35to44":"51","45to54":"34","55to64":"47","65+":"30","medianAge":"47"}},"title":"Dentists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"192","women":"29.1","white":"5.6","black":"15.5","asian":"6.8"}},"wageData":{"2014":{"workers":"61","median":"1,908","maleWorkers":"38","maleMedian":"-","femaleWorkers":"22","femaleMedian":"-"}}},"Dietitians and nutritionists":{"ageData":{"2014":{"total":"123","16to19":"1","20to24":"9","25to34":"34","35to44":"20","45to54":"27","55to64":"25","65+":"6","medianAge":"25"}},"title":"Dietitians and nutritionists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"123","women":"92.4","white":"10.6","black":"10.2","asian":"5.1"}},"wageData":{"2014":{"workers":"86","median":"919","maleWorkers":"6","maleMedian":"-","femaleWorkers":"80","femaleMedian":"875"}}},"Optometrists":{"ageData":{"2014":{"total":"48","16to19":"0","20to24":"0","25to34":"8","35to44":"12","45to54":"12","55to64":"12","65+":"4","medianAge":"12"}},"title":"Optometrists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"48","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"28","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Pharmacists":{"ageData":{"2014":{"total":"293","16to19":"0","20to24":"12","25to34":"90","35to44":"70","45to54":"54","55to64":"47","65+":"20","medianAge":"47"}},"title":"Pharmacists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"293","women":"56.3","white":"8.1","black":"18.9","asian":"5.6"}},"wageData":{"2014":{"workers":"214","median":"1,995","maleWorkers":"103","maleMedian":"2,176","femaleWorkers":"111","femaleMedian":"1,902"}}},"Physicians and surgeons":{"ageData":{"2014":{"total":"1,014","16to19":"0","20to24":"9","25to34":"224","35to44":"262","45to54":"221","55to64":"189","65+":"108","medianAge":"189"}},"title":"Physicians and surgeons","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"1,014","women":"36.7","white":"5.5","black":"21.0","asian":"6.3"}},"wageData":{"2014":{"workers":"759","median":"1,661","maleWorkers":"475","maleMedian":"2,002","femaleWorkers":"284","femaleMedian":"1,246"}}},"Physician assistants":{"ageData":{"2014":{"total":"84","16to19":"0","20to24":"4","25to34":"34","35to44":"19","45to54":"11","55to64":"14","65+":"2","medianAge":"14"}},"title":"Physician assistants","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"84","women":"74.5","white":"6.4","black":"11.3","asian":"5.9"}},"wageData":{"2014":{"workers":"71","median":"1,619","maleWorkers":"22","maleMedian":"-","femaleWorkers":"49","femaleMedian":"-"}}},"Podiatrists":{"ageData":{"2014":{"total":"8","16to19":"0","20to24":"0","25to34":"1","35to44":"4","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Podiatrists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Audiologists":{"ageData":{"2014":{"total":"20","16to19":"0","20to24":"0","25to34":"6","35to44":"3","45to54":"4","55to64":"4","65+":"3","medianAge":"4"}},"title":"Audiologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"20","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"11","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Occupational therapists":{"ageData":{"2014":{"total":"111","16to19":"1","20to24":"3","25to34":"36","35to44":"28","45to54":"26","55to64":"14","65+":"3","medianAge":"14"}},"title":"Occupational therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"111","women":"92.4","white":"5.7","black":"3.0","asian":"5.2"}},"wageData":{"2014":{"workers":"80","median":"1,146","maleWorkers":"7","maleMedian":"-","femaleWorkers":"72","femaleMedian":"1,139"}}},"Physical therapists":{"ageData":{"2014":{"total":"244","16to19":"0","20to24":"5","25to34":"76","35to44":"71","45to54":"57","55to64":"27","65+":"8","medianAge":"27"}},"title":"Physical therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"244","women":"69.8","white":"6.7","black":"12.5","asian":"4.6"}},"wageData":{"2014":{"workers":"193","median":"1,387","maleWorkers":"74","maleMedian":"1,478","femaleWorkers":"118","femaleMedian":"1,307"}}},"Radiation therapists":{"ageData":{"2014":{"total":"17","16to19":"0","20to24":"0","25to34":"4","35to44":"2","45to54":"6","55to64":"5","65+":"0","medianAge":"5"}},"title":"Radiation therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"17","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"12","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Recreational therapists":{"ageData":{"2014":{"total":"10","16to19":"0","20to24":"0","25to34":"4","35to44":"2","45to54":"2","55to64":"1","65+":"1","medianAge":"1"}},"title":"Recreational therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"10","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Respiratory therapists":{"ageData":{"2014":{"total":"112","16to19":"0","20to24":"1","25to34":"26","35to44":"31","45to54":"25","55to64":"24","65+":"4","medianAge":"24"}},"title":"Respiratory therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"112","women":"62.4","white":"13.7","black":"9.8","asian":"4.9"}},"wageData":{"2014":{"workers":"95","median":"1,037","maleWorkers":"38","maleMedian":"-","femaleWorkers":"57","femaleMedian":"906"}}},"Speech-language pathologists":{"ageData":{"2014":{"total":"137","16to19":"0","20to24":"2","25to34":"43","35to44":"42","45to54":"25","55to64":"21","65+":"4","medianAge":"21"}},"title":"Speech-language pathologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"137","women":"98.4","white":"7.2","black":"3.2","asian":"8.4"}},"wageData":{"2014":{"workers":"101","median":"1,086","maleWorkers":"3","maleMedian":"-","femaleWorkers":"98","femaleMedian":"1,089"}}},"Exercise physiologists":{"ageData":{"2014":{"total":"5","16to19":"0","20to24":"1","25to34":"1","35to44":"1","45to54":"0","55to64":"2","65+":"0","medianAge":"2"}},"title":"Exercise physiologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Therapists, all other":{"ageData":{"2014":{"total":"186","16to19":"0","20to24":"10","25to34":"59","35to44":"51","45to54":"33","55to64":"21","65+":"12","medianAge":"21"}},"title":"Therapists, all other","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"186","women":"79.9","white":"9.7","black":"2.4","asian":"13.1"}},"wageData":{"2014":{"workers":"119","median":"908","maleWorkers":"28","maleMedian":"-","femaleWorkers":"91","femaleMedian":"863"}}},"Veterinarians":{"ageData":{"2014":{"total":"81","16to19":"0","20to24":"1","25to34":"14","35to44":"23","45to54":"17","55to64":"20","65+":"6","medianAge":"20"}},"title":"Veterinarians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"81","women":"56.2","white":"3.1","black":"1.1","asian":"4.9"}},"wageData":{"2014":{"workers":"38","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"29","femaleMedian":"-"}}},"Registered nurses":{"ageData":{"2014":{"total":"2,888","16to19":"2","20to24":"121","25to34":"733","35to44":"687","45to54":"686","55to64":"535","65+":"124","medianAge":"535"}},"title":"Registered nurses","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"2,888","women":"90.0","white":"11.8","black":"8.2","asian":"6.7"}},"wageData":{"2014":{"workers":"2,309","median":"1,090","maleWorkers":"245","maleMedian":"1,190","femaleWorkers":"2,064","femaleMedian":"1,076"}}},"Nurse anesthetists":{"ageData":{"2014":{"total":"30","16to19":"0","20to24":"0","25to34":"6","35to44":"12","45to54":"9","55to64":"3","65+":"0","medianAge":"3"}},"title":"Nurse anesthetists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"30","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"24","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"15","femaleMedian":"-"}}},"Nurse midwives":{"ageData":{"2014":{"total":"4","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"0","55to64":"1","65+":"1","medianAge":"1"}},"title":"Nurse midwives","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"2","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Nurse practitioners":{"ageData":{"2014":{"total":"128","16to19":"0","20to24":"0","25to34":"31","35to44":"26","45to54":"31","55to64":"32","65+":"7","medianAge":"32"}},"title":"Nurse practitioners","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"128","women":"91.5","white":"7.7","black":"5.2","asian":"3.9"}},"wageData":{"2014":{"workers":"100","median":"1,683","maleWorkers":"9","maleMedian":"-","femaleWorkers":"90","femaleMedian":"1,682"}}},"Health diagnosing and treating practitioners, all other":{"ageData":{"2014":{"total":"24","16to19":"0","20to24":"1","25to34":"4","35to44":"4","45to54":"7","55to64":"5","65+":"3","medianAge":"5"}},"title":"Health diagnosing and treating practitioners, all other","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"24","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"7","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Clinical laboratory technologists and technicians":{"ageData":{"2014":{"total":"293","16to19":"1","20to24":"18","25to34":"76","35to44":"66","45to54":"60","55to64":"57","65+":"15","medianAge":"57"}},"title":"Clinical laboratory technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"293","women":"74.0","white":"18.2","black":"12.8","asian":"10.9"}},"wageData":{"2014":{"workers":"264","median":"824","maleWorkers":"70","maleMedian":"878","femaleWorkers":"194","femaleMedian":"818"}}},"Dental hygienists":{"ageData":{"2014":{"total":"175","16to19":"0","20to24":"8","25to34":"56","35to44":"47","45to54":"37","55to64":"25","65+":"3","medianAge":"25"}},"title":"Dental hygienists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"175","women":"97.1","white":"4.3","black":"5.5","asian":"9.9"}},"wageData":{"2014":{"workers":"87","median":"957","maleWorkers":"5","maleMedian":"-","femaleWorkers":"82","femaleMedian":"951"}}},"Diagnostic related technologists and technicians":{"ageData":{"2014":{"total":"331","16to19":"0","20to24":"16","25to34":"88","35to44":"84","45to54":"72","55to64":"64","65+":"8","medianAge":"64"}},"title":"Diagnostic related technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"331","women":"73.6","white":"6.5","black":"5.3","asian":"8.0"}},"wageData":{"2014":{"workers":"256","median":"991","maleWorkers":"70","maleMedian":"1,156","femaleWorkers":"187","femaleMedian":"940"}}},"Emergency medical technicians and paramedics":{"ageData":{"2014":{"total":"232","16to19":"3","20to24":"37","25to34":"86","35to44":"55","45to54":"33","55to64":"14","65+":"3","medianAge":"14"}},"title":"Emergency medical technicians and paramedics","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"232","women":"25.8","white":"7.7","black":"1.2","asian":"8.4"}},"wageData":{"2014":{"workers":"207","median":"754","maleWorkers":"152","maleMedian":"791","femaleWorkers":"55","femaleMedian":"709"}}},"Health practitioner support technologists and technicians":{"ageData":{"2014":{"total":"583","16to19":"13","20to24":"87","25to34":"200","35to44":"120","45to54":"92","55to64":"59","65+":"11","medianAge":"59"}},"title":"Health practitioner support technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"583","women":"81.4","white":"13.2","black":"6.8","asian":"13.2"}},"wageData":{"2014":{"workers":"443","median":"618","maleWorkers":"93","maleMedian":"618","femaleWorkers":"350","femaleMedian":"618"}}},"Licensed practical and licensed vocational nurses":{"ageData":{"2014":{"total":"641","16to19":"5","20to24":"63","25to34":"140","35to44":"141","45to54":"138","55to64":"126","65+":"28","medianAge":"126"}},"title":"Licensed practical and licensed vocational nurses","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"641","women":"89.0","white":"27.9","black":"5.0","asian":"9.9"}},"wageData":{"2014":{"workers":"506","median":"751","maleWorkers":"55","maleMedian":"868","femaleWorkers":"451","femaleMedian":"737"}}},"Medical records and health information technicians":{"ageData":{"2014":{"total":"138","16to19":"0","20to24":"5","25to34":"27","35to44":"30","45to54":"39","55to64":"32","65+":"6","medianAge":"32"}},"title":"Medical records and health information technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"138","women":"90.2","white":"19.8","black":"4.4","asian":"12.7"}},"wageData":{"2014":{"workers":"120","median":"790","maleWorkers":"16","maleMedian":"-","femaleWorkers":"104","femaleMedian":"796"}}},"Opticians, dispensing":{"ageData":{"2014":{"total":"46","16to19":"0","20to24":"2","25to34":"11","35to44":"7","45to54":"10","55to64":"11","65+":"4","medianAge":"11"}},"title":"Opticians, dispensing","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"46","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"28","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Miscellaneous health technologists and technicians":{"ageData":{"2014":{"total":"123","16to19":"1","20to24":"11","25to34":"27","35to44":"25","45to54":"35","55to64":"20","65+":"5","medianAge":"20"}},"title":"Miscellaneous health technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"123","women":"65.3","white":"18.0","black":"6.5","asian":"11.6"}},"wageData":{"2014":{"workers":"92","median":"820","maleWorkers":"33","maleMedian":"-","femaleWorkers":"58","femaleMedian":"690"}}},"Other healthcare practitioners and technical occupations":{"ageData":{"2014":{"total":"108","16to19":"0","20to24":"5","25to34":"32","35to44":"30","45to54":"19","55to64":"19","65+":"3","medianAge":"19"}},"title":"Other healthcare practitioners and technical occupations","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2014":{"total":"108","women":"53.7","white":"8.7","black":"4.0","asian":"9.1"}},"wageData":{"2014":{"workers":"93","median":"1,000","maleWorkers":"43","maleMedian":"-","femaleWorkers":"50","femaleMedian":"930"}}},"Service occupations":{"ageData":{"2014":{"total":"25,854","16to19":"1,881","20to24":"3,960","25to34":"5,677","35to44":"4,830","45to54":"4,872","55to64":"3,423","65+":"1,212","medianAge":"3,423"}},"title":"Service occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2014":{"total":"25,854","women":"56.7","white":"16.2","black":"5.4","asian":"23.4"}},"wageData":{"2014":{"workers":"15,019","median":"505","maleWorkers":"7,622","maleMedian":"583","femaleWorkers":"7,398","femaleMedian":"461"}}},"Healthcare support occupations":{"ageData":{"2014":{"total":"3,461","16to19":"83","20to24":"475","25to34":"854","35to44":"716","45to54":"708","55to64":"487","65+":"138","medianAge":"487"}},"title":"Healthcare support occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2014":{"total":"3,461","women":"87.6","white":"25.7","black":"5.2","asian":"16.2"}},"wageData":{"2014":{"workers":"2,368","median":"498","maleWorkers":"307","maleMedian":"560","femaleWorkers":"2,060","femaleMedian":"492"}}},"Nursing, psychiatric, and home health aides":{"ageData":{"2014":{"total":"1,980","16to19":"51","20to24":"267","25to34":"435","35to44":"370","45to54":"445","55to64":"303","65+":"107","medianAge":"303"}},"title":"Nursing, psychiatric, and home health aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2014":{"total":"1,980","women":"88.5","white":"35.9","black":"4.5","asian":"15.4"}},"wageData":{"2014":{"workers":"1,364","median":"472","maleWorkers":"164","maleMedian":"528","femaleWorkers":"1,200","femaleMedian":"466"}}},"Occupational therapy assistants and aides":{"ageData":{"2014":{"total":"17","16to19":"0","20to24":"1","25to34":"3","35to44":"6","45to54":"4","55to64":"3","65+":"0","medianAge":"3"}},"title":"Occupational therapy assistants and aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2014":{"total":"17","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"8","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Physical therapist assistants and aides":{"ageData":{"2014":{"total":"70","16to19":"0","20to24":"9","25to34":"22","35to44":"15","45to54":"15","55to64":"9","65+":"0","medianAge":"9"}},"title":"Physical therapist assistants and aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2014":{"total":"70","women":"64.6","white":"7.8","black":"8.8","asian":"5.5"}},"wageData":{"2014":{"workers":"50","median":"693","maleWorkers":"23","maleMedian":"-","femaleWorkers":"26","femaleMedian":"-"}}},"Massage therapists":{"ageData":{"2014":{"total":"172","16to19":"1","20to24":"12","25to34":"41","35to44":"46","45to54":"40","55to64":"26","65+":"7","medianAge":"26"}},"title":"Massage therapists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2014":{"total":"172","women":"82.7","white":"4.3","black":"10.6","asian":"8.4"}},"wageData":{"2014":{"workers":"41","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"30","femaleMedian":"-"}}},"Dental assistants":{"ageData":{"2014":{"total":"273","16to19":"6","20to24":"45","25to34":"78","35to44":"67","45to54":"47","55to64":"24","65+":"5","medianAge":"24"}},"title":"Dental assistants","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2014":{"total":"273","women":"96.6","white":"5.1","black":"5.4","asian":"23.5"}},"wageData":{"2014":{"workers":"185","median":"535","maleWorkers":"6","maleMedian":"-","femaleWorkers":"179","femaleMedian":"535"}}},"Medical assistants":{"ageData":{"2014":{"total":"508","16to19":"7","20to24":"63","25to34":"173","35to44":"129","45to54":"78","55to64":"50","65+":"8","medianAge":"50"}},"title":"Medical assistants","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2014":{"total":"508","women":"92.8","white":"14.3","black":"5.0","asian":"21.9"}},"wageData":{"2014":{"workers":"412","median":"546","maleWorkers":"29","maleMedian":"-","femaleWorkers":"383","femaleMedian":"539"}}},"Medical transcriptionists":{"ageData":{"2014":{"total":"58","16to19":"1","20to24":"4","25to34":"6","35to44":"12","45to54":"15","55to64":"17","65+":"4","medianAge":"17"}},"title":"Medical transcriptionists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2014":{"total":"58","women":"97.1","white":"3.9","black":"0.4","asian":"4.7"}},"wageData":{"2014":{"workers":"32","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"31","femaleMedian":"-"}}},"Pharmacy aides":{"ageData":{"2014":{"total":"45","16to19":"2","20to24":"10","25to34":"17","35to44":"7","45to54":"5","55to64":"3","65+":"1","medianAge":"3"}},"title":"Pharmacy aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2014":{"total":"45","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"24","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Veterinary assistants and laboratory animal caretakers":{"ageData":{"2014":{"total":"41","16to19":"5","20to24":"13","25to34":"9","35to44":"6","45to54":"4","55to64":"4","65+":"0","medianAge":"4"}},"title":"Veterinary assistants and laboratory animal caretakers","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2014":{"total":"41","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"26","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"22","femaleMedian":"-"}}},"Phlebotomists":{"ageData":{"2014":{"total":"118","16to19":"2","20to24":"9","25to34":"33","35to44":"32","45to54":"21","55to64":"18","65+":"2","medianAge":"18"}},"title":"Phlebotomists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2014":{"total":"118","women":"83.4","white":"17.9","black":"3.8","asian":"18.0"}},"wageData":{"2014":{"workers":"103","median":"533","maleWorkers":"19","maleMedian":"-","femaleWorkers":"84","femaleMedian":"526"}}},"Miscellaneous healthcare support occupations, including medical equipment preparers":{"ageData":{"2014":{"total":"179","16to19":"8","20to24":"41","25to34":"37","35to44":"25","45to54":"33","55to64":"30","65+":"4","medianAge":"30"}},"title":"Miscellaneous healthcare support occupations, including medical equipment preparers","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2014":{"total":"179","women":"65.5","white":"26.9","black":"6.6","asian":"11.4"}},"wageData":{"2014":{"workers":"123","median":"509","maleWorkers":"40","maleMedian":"-","femaleWorkers":"83","femaleMedian":"493"}}},"Protective service occupations":{"ageData":{"2014":{"total":"3,140","16to19":"92","20to24":"264","25to34":"743","35to44":"742","45to54":"719","55to64":"416","65+":"163","medianAge":"416"}},"title":"Protective service occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2014":{"total":"3,140","women":"21.8","white":"19.7","black":"2.3","asian":"14.4"}},"wageData":{"2014":{"workers":"2,740","median":"833","maleWorkers":"2,211","maleMedian":"886","femaleWorkers":"530","femaleMedian":"617"}}},"First-line supervisors of correctional officers":{"ageData":{"2014":{"total":"49","16to19":"0","20to24":"0","25to34":"9","35to44":"15","45to54":"16","55to64":"8","65+":"1","medianAge":"8"}},"title":"First-line supervisors of correctional officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2014":{"total":"49","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"46","median":"-","maleWorkers":"33","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"First-line supervisors of police and detectives":{"ageData":{"2014":{"total":"126","16to19":"0","20to24":"0","25to34":"5","35to44":"39","45to54":"54","55to64":"24","65+":"4","medianAge":"24"}},"title":"First-line supervisors of police and detectives","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2014":{"total":"126","women":"15.9","white":"14.4","black":"0.7","asian":"7.0"}},"wageData":{"2014":{"workers":"120","median":"1,127","maleWorkers":"103","maleMedian":"1,149","femaleWorkers":"17","femaleMedian":"-"}}},"First-line supervisors of fire fighting and prevention workers":{"ageData":{"2014":{"total":"58","16to19":"0","20to24":"0","25to34":"6","35to44":"17","45to54":"26","55to64":"10","65+":"0","medianAge":"10"}},"title":"First-line supervisors of fire fighting and prevention workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2014":{"total":"58","women":"7.8","white":"6.2","black":"1.6","asian":"9.3"}},"wageData":{"2014":{"workers":"56","median":"1,438","maleWorkers":"54","maleMedian":"1,448","femaleWorkers":"2","femaleMedian":"-"}}},"First-line supervisors of protective service workers, all other":{"ageData":{"2014":{"total":"91","16to19":"0","20to24":"4","25to34":"20","35to44":"20","45to54":"23","55to64":"17","65+":"6","medianAge":"17"}},"title":"First-line supervisors of protective service workers, all other","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2014":{"total":"91","women":"20.9","white":"10.9","black":"1.6","asian":"10.3"}},"wageData":{"2014":{"workers":"90","median":"913","maleWorkers":"74","maleMedian":"1,004","femaleWorkers":"16","femaleMedian":"-"}}},"Firefighters":{"ageData":{"2014":{"total":"300","16to19":"3","20to24":"14","25to34":"91","35to44":"98","45to54":"68","55to64":"22","65+":"4","medianAge":"22"}},"title":"Firefighters","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2014":{"total":"300","women":"5.7","white":"10.2","black":"0.7","asian":"9.6"}},"wageData":{"2014":{"workers":"291","median":"1,138","maleWorkers":"274","maleMedian":"1,142","femaleWorkers":"16","femaleMedian":"-"}}},"Fire inspectors":{"ageData":{"2014":{"total":"13","16to19":"0","20to24":"0","25to34":"5","35to44":"2","45to54":"2","55to64":"3","65+":"1","medianAge":"3"}},"title":"Fire inspectors","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2014":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"11","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Bailiffs, correctional officers, and jailers":{"ageData":{"2014":{"total":"395","16to19":"4","20to24":"39","25to34":"96","35to44":"93","45to54":"103","55to64":"50","65+":"11","medianAge":"50"}},"title":"Bailiffs, correctional officers, and jailers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2014":{"total":"395","women":"28.6","white":"20.6","black":"1.7","asian":"16.0"}},"wageData":{"2014":{"workers":"392","median":"730","maleWorkers":"279","maleMedian":"755","femaleWorkers":"113","femaleMedian":"687"}}},"Detectives and criminal investigators":{"ageData":{"2014":{"total":"164","16to19":"1","20to24":"4","25to34":"33","35to44":"54","45to54":"40","55to64":"28","65+":"3","medianAge":"28"}},"title":"Detectives and criminal investigators","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2014":{"total":"164","women":"21.0","white":"14.6","black":"1.6","asian":"13.2"}},"wageData":{"2014":{"workers":"162","median":"1,173","maleWorkers":"130","maleMedian":"1,183","femaleWorkers":"32","femaleMedian":"-"}}},"Fish and game wardens":{"ageData":{"2014":{"total":"3","16to19":"0","20to24":"1","25to34":"0","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Fish and game wardens","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2014":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Parking enforcement workers":{"ageData":{"2014":{"total":"10","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"6","55to64":"2","65+":"1","medianAge":"2"}},"title":"Parking enforcement workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2014":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"9","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Police and sheriff\'s patrol officers":{"ageData":{"2014":{"total":"680","16to19":"2","20to24":"32","25to34":"198","35to44":"204","45to54":"178","55to64":"49","65+":"17","medianAge":"49"}},"title":"Police and sheriff\'s patrol officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2014":{"total":"680","women":"12.4","white":"15.6","black":"1.8","asian":"13.2"}},"wageData":{"2014":{"workers":"671","median":"1,018","maleWorkers":"593","maleMedian":"1,043","femaleWorkers":"78","femaleMedian":"743"}}},"Transit and railroad police":{"ageData":{"2014":{"total":"3","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Transit and railroad police","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2014":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Animal control workers":{"ageData":{"2014":{"total":"9","16to19":"0","20to24":"2","25to34":"2","35to44":"1","45to54":"1","55to64":"2","65+":"1","medianAge":"2"}},"title":"Animal control workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2014":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"10","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Private detectives and investigators":{"ageData":{"2014":{"total":"98","16to19":"0","20to24":"3","25to34":"25","35to44":"27","45to54":"21","55to64":"16","65+":"5","medianAge":"16"}},"title":"Private detectives and investigators","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2014":{"total":"98","women":"37.7","white":"14.5","black":"3.0","asian":"13.5"}},"wageData":{"2014":{"workers":"78","median":"1,025","maleWorkers":"49","maleMedian":"-","femaleWorkers":"29","femaleMedian":"-"}}},"Security guards and gaming surveillance officers":{"ageData":{"2014":{"total":"899","16to19":"12","20to24":"122","25to34":"228","35to44":"151","45to54":"149","55to64":"156","65+":"81","medianAge":"156"}},"title":"Security guards and gaming surveillance officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2014":{"total":"899","women":"22.6","white":"30.3","black":"3.7","asian":"19.0"}},"wageData":{"2014":{"workers":"710","median":"569","maleWorkers":"541","maleMedian":"589","femaleWorkers":"169","femaleMedian":"514"}}},"Crossing guards":{"ageData":{"2014":{"total":"66","16to19":"0","20to24":"6","25to34":"6","35to44":"8","45to54":"11","55to64":"18","65+":"17","medianAge":"18"}},"title":"Crossing guards","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2014":{"total":"66","women":"66.3","white":"21.6","black":"6.2","asian":"6.1"}},"wageData":{"2014":{"workers":"19","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Transportation security screeners":{"ageData":{"2014":{"total":"33","16to19":"1","20to24":"1","25to34":"10","35to44":"9","45to54":"6","55to64":"4","65+":"3","medianAge":"4"}},"title":"Transportation security screeners","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2014":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"28","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Lifeguards and other recreational, and all other protective service workers":{"ageData":{"2014":{"total":"141","16to19":"68","20to24":"37","25to34":"8","35to44":"2","45to54":"10","55to64":"7","65+":"7","medianAge":"7"}},"title":"Lifeguards and other recreational, and all other protective service workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2014":{"total":"141","women":"49.7","white":"12.6","black":"1.8","asian":"11.1"}},"wageData":{"2014":{"workers":"43","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"18","femaleMedian":"-"}}},"Food preparation and serving related occupations":{"ageData":{"2014":{"total":"8,112","16to19":"1,240","20to24":"1,934","25to34":"1,872","35to44":"1,191","45to54":"1,023","55to64":"634","65+":"219","medianAge":"634"}},"title":"Food preparation and serving related occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2014":{"total":"8,112","women":"55.1","white":"12.6","black":"6.0","asian":"24.9"}},"wageData":{"2014":{"workers":"4,017","median":"439","maleWorkers":"2,140","maleMedian":"463","femaleWorkers":"1,877","femaleMedian":"419"}}},"Chefs and head cooks":{"ageData":{"2014":{"total":"430","16to19":"5","20to24":"54","25to34":"124","35to44":"96","45to54":"97","55to64":"47","65+":"7","medianAge":"47"}},"title":"Chefs and head cooks","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2014":{"total":"430","women":"21.4","white":"15.3","black":"16.4","asian":"18.3"}},"wageData":{"2014":{"workers":"364","median":"590","maleWorkers":"302","maleMedian":"601","femaleWorkers":"61","femaleMedian":"531"}}},"First-line supervisors of food preparation and serving workers":{"ageData":{"2014":{"total":"545","16to19":"25","20to24":"106","25to34":"139","35to44":"110","45to54":"95","55to64":"53","65+":"17","medianAge":"53"}},"title":"First-line supervisors of food preparation and serving workers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2014":{"total":"545","women":"59.1","white":"13.7","black":"4.7","asian":"19.1"}},"wageData":{"2014":{"workers":"403","median":"516","maleWorkers":"184","maleMedian":"583","femaleWorkers":"219","femaleMedian":"485"}}},"Cooks":{"ageData":{"2014":{"total":"1,992","16to19":"229","20to24":"330","25to34":"504","35to44":"348","45to54":"326","55to64":"198","65+":"56","medianAge":"198"}},"title":"Cooks","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2014":{"total":"1,992","women":"40.6","white":"16.5","black":"4.9","asian":"34.0"}},"wageData":{"2014":{"workers":"1,166","median":"413","maleWorkers":"773","maleMedian":"416","femaleWorkers":"392","femaleMedian":"405"}}},"Food preparation workers":{"ageData":{"2014":{"total":"885","16to19":"167","20to24":"243","25to34":"178","35to44":"107","45to54":"96","55to64":"61","65+":"33","medianAge":"61"}},"title":"Food preparation workers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2014":{"total":"885","women":"54.7","white":"13.4","black":"6.9","asian":"27.2"}},"wageData":{"2014":{"workers":"359","median":"406","maleWorkers":"178","maleMedian":"411","femaleWorkers":"181","femaleMedian":"401"}}},"Bartenders":{"ageData":{"2014":{"total":"416","16to19":"5","20to24":"79","25to34":"161","35to44":"83","45to54":"42","55to64":"33","65+":"12","medianAge":"33"}},"title":"Bartenders","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2014":{"total":"416","women":"57.5","white":"6.0","black":"1.9","asian":"15.5"}},"wageData":{"2014":{"workers":"216","median":"522","maleWorkers":"103","maleMedian":"634","femaleWorkers":"113","femaleMedian":"459"}}},"Combined food preparation and serving workers, including fast food":{"ageData":{"2014":{"total":"428","16to19":"92","20to24":"116","25to34":"76","35to44":"41","45to54":"45","55to64":"38","65+":"20","medianAge":"38"}},"title":"Combined food preparation and serving workers, including fast food","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2014":{"total":"428","women":"61.9","white":"20.5","black":"3.3","asian":"18.7"}},"wageData":{"2014":{"workers":"169","median":"379","maleWorkers":"66","maleMedian":"384","femaleWorkers":"102","femaleMedian":"373"}}},"Counter attendants, cafeteria, food concession, and coffee shop":{"ageData":{"2014":{"total":"254","16to19":"119","20to24":"75","25to34":"26","35to44":"14","45to54":"13","55to64":"5","65+":"2","medianAge":"5"}},"title":"Counter attendants, cafeteria, food concession, and coffee shop","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2014":{"total":"254","women":"70.4","white":"13.9","black":"4.3","asian":"21.6"}},"wageData":{"2014":{"workers":"60","median":"349","maleWorkers":"19","maleMedian":"-","femaleWorkers":"41","femaleMedian":"-"}}},"Waiters and waitresses":{"ageData":{"2014":{"total":"2,054","16to19":"300","20to24":"679","25to34":"492","35to44":"275","45to54":"178","55to64":"102","65+":"29","medianAge":"102"}},"title":"Waiters and waitresses","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2014":{"total":"2,054","women":"71.8","white":"7.5","black":"6.6","asian":"19.4"}},"wageData":{"2014":{"workers":"826","median":"436","maleWorkers":"283","maleMedian":"501","femaleWorkers":"542","femaleMedian":"415"}}},"Food servers, nonrestaurant":{"ageData":{"2014":{"total":"185","16to19":"22","20to24":"31","25to34":"34","35to44":"24","45to54":"41","55to64":"25","65+":"8","medianAge":"25"}},"title":"Food servers, nonrestaurant","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2014":{"total":"185","women":"61.9","white":"23.5","black":"6.1","asian":"20.8"}},"wageData":{"2014":{"workers":"111","median":"502","maleWorkers":"47","maleMedian":"-","femaleWorkers":"64","femaleMedian":"495"}}},"Dining room and cafeteria attendants and bartender helpers":{"ageData":{"2014":{"total":"375","16to19":"92","20to24":"75","25to34":"60","35to44":"48","45to54":"49","55to64":"36","65+":"15","medianAge":"36"}},"title":"Dining room and cafeteria attendants and bartender helpers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2014":{"total":"375","women":"49.2","white":"7.6","black":"5.5","asian":"34.1"}},"wageData":{"2014":{"workers":"151","median":"451","maleWorkers":"73","maleMedian":"509","femaleWorkers":"78","femaleMedian":"420"}}},"Dishwashers":{"ageData":{"2014":{"total":"246","16to19":"60","20to24":"51","25to34":"43","35to44":"31","45to54":"30","55to64":"25","65+":"7","medianAge":"25"}},"title":"Dishwashers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2014":{"total":"246","women":"21.2","white":"12.3","black":"5.7","asian":"40.2"}},"wageData":{"2014":{"workers":"128","median":"368","maleWorkers":"101","maleMedian":"364","femaleWorkers":"27","femaleMedian":"-"}}},"Hosts and hostesses, restaurant, lounge, and coffee shop":{"ageData":{"2014":{"total":"297","16to19":"124","20to24":"93","25to34":"34","35to44":"13","45to54":"12","55to64":"9","65+":"13","medianAge":"9"}},"title":"Hosts and hostesses, restaurant, lounge, and coffee shop","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2014":{"total":"297","women":"85.2","white":"10.9","black":"6.5","asian":"18.2"}},"wageData":{"2014":{"workers":"62","median":"433","maleWorkers":"9","maleMedian":"-","femaleWorkers":"53","femaleMedian":"418"}}},"Food preparation and serving related workers, all other":{"ageData":{"2014":{"total":"6","16to19":"2","20to24":"1","25to34":"1","35to44":"0","45to54":"0","55to64":"2","65+":"0","medianAge":"2"}},"title":"Food preparation and serving related workers, all other","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2014":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"3","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Building and grounds cleaning and maintenance occupations":{"ageData":{"2014":{"total":"5,803","16to19":"198","20to24":"506","25to34":"1,081","35to44":"1,192","45to54":"1,401","55to64":"1,089","65+":"336","medianAge":"1,089"}},"title":"Building and grounds cleaning and maintenance occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2014":{"total":"5,803","women":"40.2","white":"14.6","black":"3.4","asian":"36.7"}},"wageData":{"2014":{"workers":"3,568","median":"480","maleWorkers":"2,331","maleMedian":"517","femaleWorkers":"1,236","femaleMedian":"413"}}},"First-line supervisors of housekeeping and janitorial workers":{"ageData":{"2014":{"total":"282","16to19":"4","20to24":"6","25to34":"42","35to44":"62","45to54":"92","55to64":"61","65+":"15","medianAge":"61"}},"title":"First-line supervisors of housekeeping and janitorial workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2014":{"total":"282","women":"42.3","white":"14.7","black":"2.8","asian":"24.1"}},"wageData":{"2014":{"workers":"153","median":"596","maleWorkers":"89","maleMedian":"720","femaleWorkers":"64","femaleMedian":"500"}}},"First-line supervisors of landscaping, lawn service, and groundskeeping workers":{"ageData":{"2014":{"total":"210","16to19":"2","20to24":"7","25to34":"40","35to44":"55","45to54":"58","55to64":"43","65+":"6","medianAge":"43"}},"title":"First-line supervisors of landscaping, lawn service, and groundskeeping workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2014":{"total":"210","women":"4.8","white":"8.3","black":"1.4","asian":"22.7"}},"wageData":{"2014":{"workers":"91","median":"717","maleWorkers":"90","maleMedian":"716","femaleWorkers":"1","femaleMedian":"-"}}},"Janitors and building cleaners":{"ageData":{"2014":{"total":"2,328","16to19":"92","20to24":"213","25to34":"377","35to44":"408","45to54":"561","55to64":"519","65+":"160","medianAge":"519"}},"title":"Janitors and building cleaners","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2014":{"total":"2,328","women":"33.2","white":"17.5","black":"3.4","asian":"31.5"}},"wageData":{"2014":{"workers":"1,598","median":"502","maleWorkers":"1,160","maleMedian":"540","femaleWorkers":"438","femaleMedian":"415"}}},"Maids and housekeeping cleaners":{"ageData":{"2014":{"total":"1,514","16to19":"27","20to24":"99","25to34":"282","35to44":"360","45to54":"404","55to64":"258","65+":"85","medianAge":"258"}},"title":"Maids and housekeeping cleaners","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2014":{"total":"1,514","women":"88.6","white":"16.8","black":"5.5","asian":"43.8"}},"wageData":{"2014":{"workers":"816","median":"401","maleWorkers":"131","maleMedian":"404","femaleWorkers":"685","femaleMedian":"400"}}},"Pest control workers":{"ageData":{"2014":{"total":"80","16to19":"1","20to24":"8","25to34":"19","35to44":"14","45to54":"20","55to64":"16","65+":"2","medianAge":"16"}},"title":"Pest control workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2014":{"total":"80","women":"3.7","white":"10.9","black":"0.5","asian":"17.0"}},"wageData":{"2014":{"workers":"64","median":"653","maleWorkers":"62","maleMedian":"653","femaleWorkers":"1","femaleMedian":"-"}}},"Grounds maintenance workers":{"ageData":{"2014":{"total":"1,389","16to19":"73","20to24":"173","25to34":"321","35to44":"293","45to54":"266","55to64":"193","65+":"70","medianAge":"193"}},"title":"Grounds maintenance workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2014":{"total":"1,389","women":"6.3","white":"8.3","black":"1.7","asian":"43.6"}},"wageData":{"2014":{"workers":"847","median":"459","maleWorkers":"800","maleMedian":"454","femaleWorkers":"47","femaleMedian":"-"}}},"Personal care and service occupations":{"ageData":{"2014":{"total":"5,337","16to19":"267","20to24":"781","25to34":"1,127","35to44":"989","45to54":"1,022","55to64":"796","65+":"355","medianAge":"796"}},"title":"Personal care and service occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2014":{"total":"5,337","women":"77.4","white":"15.0","black":"8.4","asian":"16.6"}},"wageData":{"2014":{"workers":"2,326","median":"487","maleWorkers":"632","maleMedian":"607","femaleWorkers":"1,695","femaleMedian":"455"}}},"First-line supervisors of gaming workers":{"ageData":{"2014":{"total":"151","16to19":"1","20to24":"14","25to34":"39","35to44":"43","45to54":"22","55to64":"24","65+":"8","medianAge":"24"}},"title":"First-line supervisors of gaming workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2014":{"total":"151","women":"45.2","white":"4.4","black":"6.4","asian":"7.3"}},"wageData":{"2014":{"workers":"93","median":"789","maleWorkers":"51","maleMedian":"810","femaleWorkers":"43","femaleMedian":"-"}}},"First-line supervisors of personal service workers":{"ageData":{"2014":{"total":"202","16to19":"0","20to24":"10","25to34":"40","35to44":"49","45to54":"59","55to64":"31","65+":"13","medianAge":"31"}},"title":"First-line supervisors of personal service workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2014":{"total":"202","women":"71.3","white":"11.5","black":"18.2","asian":"13.7"}},"wageData":{"2014":{"workers":"73","median":"567","maleWorkers":"27","maleMedian":"-","femaleWorkers":"46","femaleMedian":"-"}}},"Animal trainers":{"ageData":{"2014":{"total":"41","16to19":"0","20to24":"7","25to34":"4","35to44":"6","45to54":"9","55to64":"12","65+":"2","medianAge":"12"}},"title":"Animal trainers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2014":{"total":"41","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"10","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Nonfarm animal caretakers":{"ageData":{"2014":{"total":"201","16to19":"17","20to24":"47","25to34":"50","35to44":"24","45to54":"36","55to64":"21","65+":"7","medianAge":"21"}},"title":"Nonfarm animal caretakers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2014":{"total":"201","women":"69.9","white":"2.8","black":"0.9","asian":"12.2"}},"wageData":{"2014":{"workers":"89","median":"489","maleWorkers":"29","maleMedian":"-","femaleWorkers":"60","femaleMedian":"452"}}},"Gaming services workers":{"ageData":{"2014":{"total":"99","16to19":"3","20to24":"10","25to34":"22","35to44":"25","45to54":"18","55to64":"16","65+":"5","medianAge":"16"}},"title":"Gaming services workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2014":{"total":"99","women":"41.8","white":"8.0","black":"19.4","asian":"12.5"}},"wageData":{"2014":{"workers":"78","median":"627","maleWorkers":"47","maleMedian":"-","femaleWorkers":"31","femaleMedian":"-"}}},"Motion picture projectionists":{"ageData":{"2014":{"total":"4","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Motion picture projectionists","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2014":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Ushers, lobby attendants, and ticket takers":{"ageData":{"2014":{"total":"54","16to19":"16","20to24":"18","25to34":"5","35to44":"0","45to54":"3","55to64":"5","65+":"7","medianAge":"5"}},"title":"Ushers, lobby attendants, and ticket takers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2014":{"total":"54","women":"48.9","white":"24.3","black":"3.6","asian":"13.1"}},"wageData":{"2014":{"workers":"6","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Miscellaneous entertainment attendants and related workers":{"ageData":{"2014":{"total":"189","16to19":"38","20to24":"53","25to34":"35","35to44":"14","45to54":"16","55to64":"14","65+":"19","medianAge":"14"}},"title":"Miscellaneous entertainment attendants and related workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2014":{"total":"189","women":"41.5","white":"13.3","black":"3.3","asian":"17.3"}},"wageData":{"2014":{"workers":"69","median":"473","maleWorkers":"41","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Embalmers and funeral attendants":{"ageData":{"2014":{"total":"13","16to19":"0","20to24":"1","25to34":"2","35to44":"1","45to54":"1","55to64":"4","65+":"3","medianAge":"4"}},"title":"Embalmers and funeral attendants","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2014":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"7","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Morticians, undertakers, and funeral directors":{"ageData":{"2014":{"total":"29","16to19":"0","20to24":"1","25to34":"8","35to44":"3","45to54":"6","55to64":"4","65+":"6","medianAge":"4"}},"title":"Morticians, undertakers, and funeral directors","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2014":{"total":"29","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"17","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Barbers":{"ageData":{"2014":{"total":"110","16to19":"0","20to24":"6","25to34":"29","35to44":"32","45to54":"19","55to64":"12","65+":"11","medianAge":"12"}},"title":"Barbers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2014":{"total":"110","women":"16.8","white":"36.3","black":"5.4","asian":"23.7"}},"wageData":{"2014":{"workers":"42","median":"-","maleWorkers":"39","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Hairdressers, hairstylists, and cosmetologists":{"ageData":{"2014":{"total":"760","16to19":"8","20to24":"93","25to34":"193","35to44":"154","45to54":"154","55to64":"102","65+":"55","medianAge":"102"}},"title":"Hairdressers, hairstylists, and cosmetologists","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2014":{"total":"760","women":"94.6","white":"12.4","black":"4.8","asian":"15.3"}},"wageData":{"2014":{"workers":"284","median":"482","maleWorkers":"12","maleMedian":"-","femaleWorkers":"271","femaleMedian":"476"}}},"Miscellaneous personal appearance workers":{"ageData":{"2014":{"total":"296","16to19":"3","20to24":"28","25to34":"81","35to44":"86","45to54":"63","55to64":"27","65+":"7","medianAge":"27"}},"title":"Miscellaneous personal appearance workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2014":{"total":"296","women":"88.9","white":"5.9","black":"55.3","asian":"10.3"}},"wageData":{"2014":{"workers":"166","median":"432","maleWorkers":"22","maleMedian":"-","femaleWorkers":"144","femaleMedian":"422"}}},"Baggage porters, bellhops, and concierges":{"ageData":{"2014":{"total":"85","16to19":"2","20to24":"11","25to34":"20","35to44":"12","45to54":"22","55to64":"12","65+":"6","medianAge":"12"}},"title":"Baggage porters, bellhops, and concierges","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2014":{"total":"85","women":"20.2","white":"17.2","black":"6.0","asian":"24.8"}},"wageData":{"2014":{"workers":"66","median":"633","maleWorkers":"58","maleMedian":"664","femaleWorkers":"9","femaleMedian":"-"}}},"Tour and travel guides":{"ageData":{"2014":{"total":"54","16to19":"6","20to24":"15","25to34":"7","35to44":"9","45to54":"5","55to64":"7","65+":"7","medianAge":"7"}},"title":"Tour and travel guides","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2014":{"total":"54","women":"46.9","white":"5.9","black":"5.8","asian":"11.3"}},"wageData":{"2014":{"workers":"19","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Childcare workers":{"ageData":{"2014":{"total":"1,218","16to19":"107","20to24":"216","25to34":"251","35to44":"183","45to54":"209","55to64":"195","65+":"56","medianAge":"195"}},"title":"Childcare workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2014":{"total":"1,218","women":"95.5","white":"15.9","black":"3.5","asian":"21.6"}},"wageData":{"2014":{"workers":"406","median":"442","maleWorkers":"21","maleMedian":"-","femaleWorkers":"385","femaleMedian":"444"}}},"Personal care aides":{"ageData":{"2014":{"total":"1,254","16to19":"24","20to24":"148","25to34":"221","35to44":"220","45to54":"290","55to64":"238","65+":"114","medianAge":"238"}},"title":"Personal care aides","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2014":{"total":"1,254","women":"83.9","white":"23.0","black":"7.9","asian":"18.2"}},"wageData":{"2014":{"workers":"667","median":"434","maleWorkers":"133","maleMedian":"465","femaleWorkers":"534","femaleMedian":"425"}}},"Recreation and fitness workers":{"ageData":{"2014":{"total":"404","16to19":"29","20to24":"71","25to34":"79","35to44":"91","45to54":"71","55to64":"51","65+":"12","medianAge":"51"}},"title":"Recreation and fitness workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2014":{"total":"404","women":"63.0","white":"9.2","black":"2.9","asian":"11.6"}},"wageData":{"2014":{"workers":"167","median":"599","maleWorkers":"76","maleMedian":"716","femaleWorkers":"91","femaleMedian":"521"}}},"Residential advisors":{"ageData":{"2014":{"total":"43","16to19":"4","20to24":"13","25to34":"9","35to44":"6","45to54":"3","55to64":"5","65+":"3","medianAge":"5"}},"title":"Residential advisors","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2014":{"total":"43","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"22","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"14","femaleMedian":"-"}}},"Personal care and service workers, all other":{"ageData":{"2014":{"total":"131","16to19":"7","20to24":"21","25to34":"28","35to44":"31","45to54":"16","55to64":"16","65+":"13","medianAge":"16"}},"title":"Personal care and service workers, all other","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2014":{"total":"131","women":"42.6","white":"8.2","black":"3.1","asian":"15.3"}},"wageData":{"2014":{"workers":"42","median":"-","maleWorkers":"29","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Sales and office occupations":{"ageData":{"2014":{"total":"33,416","16to19":"1,572","20to24":"4,066","25to34":"6,897","35to44":"6,092","45to54":"7,115","55to64":"5,650","65+":"2,023","medianAge":"5,650"}},"title":"Sales and office occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2014":{"total":"33,416","women":"61.8","white":"12.0","black":"4.8","asian":"14.9"}},"wageData":{"2014":{"workers":"23,402","median":"666","maleWorkers":"9,251","maleMedian":"766","femaleWorkers":"14,151","femaleMedian":"620"}}},"Sales and related occupations":{"ageData":{"2014":{"total":"15,646","16to19":"1,056","20to24":"2,171","25to34":"3,220","35to44":"2,698","45to54":"3,102","55to64":"2,364","65+":"1,035","medianAge":"2,364"}},"title":"Sales and related occupations","depth":2,"parent":"Sales and office occupations","sexRaceEthnicityData":{"2014":{"total":"15,646","women":"49.2","white":"10.7","black":"5.3","asian":"14.7"}},"wageData":{"2014":{"workers":"9,626","median":"705","maleWorkers":"5,411","maleMedian":"841","femaleWorkers":"4,215","femaleMedian":"570"}}},"First-line supervisors of retail sales workers":{"ageData":{"2014":{"total":"3,285","16to19":"26","20to24":"288","25to34":"766","35to44":"708","45to54":"780","55to64":"525","65+":"192","medianAge":"525"}},"title":"First-line supervisors of retail sales workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2014":{"total":"3,285","women":"44.3","white":"8.8","black":"6.1","asian":"12.1"}},"wageData":{"2014":{"workers":"2,317","median":"696","maleWorkers":"1,295","maleMedian":"793","femaleWorkers":"1,022","femaleMedian":"595"}}},"First-line supervisors of non-retail sales workers":{"ageData":{"2014":{"total":"1,200","16to19":"2","20to24":"39","25to34":"191","35to44":"298","45to54":"332","55to64":"243","65+":"95","medianAge":"243"}},"title":"First-line supervisors of non-retail sales workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2014":{"total":"1,200","women":"26.0","white":"5.6","black":"4.8","asian":"11.2"}},"wageData":{"2014":{"workers":"768","median":"969","maleWorkers":"530","maleMedian":"1,004","femaleWorkers":"238","femaleMedian":"878"}}},"Cashiers":{"ageData":{"2014":{"total":"3,242","16to19":"681","20to24":"855","25to34":"566","35to44":"334","45to54":"374","55to64":"304","65+":"129","medianAge":"304"}},"title":"Cashiers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2014":{"total":"3,242","women":"72.2","white":"18.3","black":"6.9","asian":"22.0"}},"wageData":{"2014":{"workers":"1,305","median":"394","maleWorkers":"384","maleMedian":"412","femaleWorkers":"921","femaleMedian":"387"}}},"Counter and rental clerks":{"ageData":{"2014":{"total":"113","16to19":"8","20to24":"23","25to34":"29","35to44":"20","45to54":"16","55to64":"15","65+":"3","medianAge":"15"}},"title":"Counter and rental clerks","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2014":{"total":"113","women":"49.8","white":"11.8","black":"4.5","asian":"22.5"}},"wageData":{"2014":{"workers":"75","median":"547","maleWorkers":"45","maleMedian":"-","femaleWorkers":"31","femaleMedian":"-"}}},"Parts salespersons":{"ageData":{"2014":{"total":"93","16to19":"3","20to24":"9","25to34":"28","35to44":"9","45to54":"18","55to64":"21","65+":"5","medianAge":"21"}},"title":"Parts salespersons","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2014":{"total":"93","women":"15.3","white":"4.8","black":"0.5","asian":"12.2"}},"wageData":{"2014":{"workers":"88","median":"617","maleWorkers":"74","maleMedian":"643","femaleWorkers":"14","femaleMedian":"-"}}},"Retail salespersons":{"ageData":{"2014":{"total":"3,316","16to19":"293","20to24":"668","25to34":"713","35to44":"421","45to54":"526","55to64":"476","65+":"217","medianAge":"476"}},"title":"Retail salespersons","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2014":{"total":"3,316","women":"49.8","white":"12.3","black":"4.6","asian":"16.2"}},"wageData":{"2014":{"workers":"1,870","median":"596","maleWorkers":"1,137","maleMedian":"698","femaleWorkers":"733","femaleMedian":"491"}}},"Advertising sales agents":{"ageData":{"2014":{"total":"227","16to19":"2","20to24":"24","25to34":"71","35to44":"42","45to54":"47","55to64":"32","65+":"9","medianAge":"32"}},"title":"Advertising sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2014":{"total":"227","women":"48.7","white":"7.9","black":"4.5","asian":"12.7"}},"wageData":{"2014":{"workers":"194","median":"942","maleWorkers":"100","maleMedian":"1,041","femaleWorkers":"94","femaleMedian":"871"}}},"Insurance sales agents":{"ageData":{"2014":{"total":"562","16to19":"0","20to24":"28","25to34":"117","35to44":"113","45to54":"132","55to64":"122","65+":"50","medianAge":"122"}},"title":"Insurance sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2014":{"total":"562","women":"47.0","white":"8.3","black":"4.9","asian":"13.2"}},"wageData":{"2014":{"workers":"433","median":"765","maleWorkers":"204","maleMedian":"946","femaleWorkers":"230","femaleMedian":"698"}}},"Securities, commodities, and financial services sales agents":{"ageData":{"2014":{"total":"256","16to19":"0","20to24":"11","25to34":"81","35to44":"64","45to54":"61","55to64":"27","65+":"12","medianAge":"27"}},"title":"Securities, commodities, and financial services sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2014":{"total":"256","women":"32.5","white":"4.9","black":"4.6","asian":"9.5"}},"wageData":{"2014":{"workers":"235","median":"1,122","maleWorkers":"152","maleMedian":"1,356","femaleWorkers":"83","femaleMedian":"883"}}},"Travel agents":{"ageData":{"2014":{"total":"82","16to19":"0","20to24":"3","25to34":"10","35to44":"15","45to54":"25","55to64":"17","65+":"11","medianAge":"17"}},"title":"Travel agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2014":{"total":"82","women":"81.4","white":"7.9","black":"13.2","asian":"9.9"}},"wageData":{"2014":{"workers":"46","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"36","femaleMedian":"-"}}},"Sales representatives, services, all other":{"ageData":{"2014":{"total":"480","16to19":"3","20to24":"39","25to34":"132","35to44":"105","45to54":"104","55to64":"74","65+":"22","medianAge":"74"}},"title":"Sales representatives, services, all other","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2014":{"total":"480","women":"29.5","white":"6.6","black":"4.3","asian":"11.0"}},"wageData":{"2014":{"workers":"413","median":"948","maleWorkers":"296","maleMedian":"986","femaleWorkers":"117","femaleMedian":"766"}}},"Sales representatives, wholesale and manufacturing":{"ageData":{"2014":{"total":"1,309","16to19":"12","20to24":"83","25to34":"276","35to44":"274","45to54":"343","55to64":"232","65+":"89","medianAge":"232"}},"title":"Sales representatives, wholesale and manufacturing","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2014":{"total":"1,309","women":"29.3","white":"5.3","black":"3.8","asian":"9.3"}},"wageData":{"2014":{"workers":"1,133","median":"1,015","maleWorkers":"817","maleMedian":"1,120","femaleWorkers":"317","femaleMedian":"873"}}},"Models, demonstrators, and product promoters":{"ageData":{"2014":{"total":"66","16to19":"6","20to24":"9","25to34":"10","35to44":"9","45to54":"10","55to64":"8","65+":"14","medianAge":"8"}},"title":"Models, demonstrators, and product promoters","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2014":{"total":"66","women":"68.4","white":"5.5","black":"4.0","asian":"15.9"}},"wageData":{"2014":{"workers":"16","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Real estate brokers and sales agents":{"ageData":{"2014":{"total":"868","16to19":"3","20to24":"33","25to34":"109","35to44":"174","45to54":"223","55to64":"190","65+":"138","medianAge":"190"}},"title":"Real estate brokers and sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2014":{"total":"868","women":"54.9","white":"5.4","black":"4.2","asian":"10.5"}},"wageData":{"2014":{"workers":"416","median":"852","maleWorkers":"189","maleMedian":"991","femaleWorkers":"227","femaleMedian":"726"}}},"Sales engineers":{"ageData":{"2014":{"total":"43","16to19":"0","20to24":"2","25to34":"7","35to44":"11","45to54":"12","55to64":"9","65+":"2","medianAge":"9"}},"title":"Sales engineers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2014":{"total":"43","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"41","median":"-","maleWorkers":"39","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Telemarketers":{"ageData":{"2014":{"total":"75","16to19":"4","20to24":"16","25to34":"19","35to44":"15","45to54":"10","55to64":"6","65+":"4","medianAge":"6"}},"title":"Telemarketers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2014":{"total":"75","women":"67.4","white":"19.6","black":"3.6","asian":"18.5"}},"wageData":{"2014":{"workers":"55","median":"526","maleWorkers":"18","maleMedian":"-","femaleWorkers":"37","femaleMedian":"-"}}},"Door-to-door sales workers, news and street vendors, and related workers":{"ageData":{"2014":{"total":"175","16to19":"6","20to24":"14","25to34":"43","35to44":"36","45to54":"39","55to64":"20","65+":"18","medianAge":"20"}},"title":"Door-to-door sales workers, news and street vendors, and related workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2014":{"total":"175","women":"64.0","white":"10.6","black":"3.5","asian":"21.7"}},"wageData":{"2014":{"workers":"38","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Sales and related workers, all other":{"ageData":{"2014":{"total":"253","16to19":"8","20to24":"28","25to34":"52","35to44":"48","45to54":"50","55to64":"42","65+":"26","medianAge":"42"}},"title":"Sales and related workers, all other","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2014":{"total":"253","women":"52.0","white":"10.6","black":"6.2","asian":"5.7"}},"wageData":{"2014":{"workers":"183","median":"807","maleWorkers":"92","maleMedian":"949","femaleWorkers":"91","femaleMedian":"664"}}},"Office and administrative support occupations":{"ageData":{"2014":{"total":"17,771","16to19":"517","20to24":"1,895","25to34":"3,677","35to44":"3,394","45to54":"4,013","55to64":"3,286","65+":"989","medianAge":"3,286"}},"title":"Office and administrative support occupations","depth":2,"parent":"Sales and office occupations","sexRaceEthnicityData":{"2014":{"total":"17,771","women":"72.9","white":"13.1","black":"4.4","asian":"15.1"}},"wageData":{"2014":{"workers":"13,776","median":"651","maleWorkers":"3,840","maleMedian":"701","femaleWorkers":"9,936","femaleMedian":"637"}}},"First-line supervisors of office and administrative support workers":{"ageData":{"2014":{"total":"1,351","16to19":"3","20to24":"46","25to34":"255","35to44":"347","45to54":"362","55to64":"272","65+":"64","medianAge":"272"}},"title":"First-line supervisors of office and administrative support workers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"1,351","women":"67.4","white":"11.1","black":"3.6","asian":"12.2"}},"wageData":{"2014":{"workers":"1,185","median":"808","maleWorkers":"410","maleMedian":"919","femaleWorkers":"775","femaleMedian":"763"}}},"Switchboard operators, including answering service":{"ageData":{"2014":{"total":"19","16to19":"0","20to24":"4","25to34":"5","35to44":"3","45to54":"1","55to64":"5","65+":"2","medianAge":"5"}},"title":"Switchboard operators, including answering service","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"18","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"15","femaleMedian":"-"}}},"Telephone operators":{"ageData":{"2014":{"total":"33","16to19":"0","20to24":"8","25to34":"4","35to44":"8","45to54":"8","55to64":"3","65+":"2","medianAge":"3"}},"title":"Telephone operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"27","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Communications equipment operators, all other":{"ageData":{"2014":{"total":"9","16to19":"0","20to24":"1","25to34":"3","35to44":"2","45to54":"0","55to64":"2","65+":"1","medianAge":"2"}},"title":"Communications equipment operators, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"9","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Bill and account collectors":{"ageData":{"2014":{"total":"165","16to19":"2","20to24":"23","25to34":"39","35to44":"42","45to54":"29","55to64":"27","65+":"4","medianAge":"27"}},"title":"Bill and account collectors","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"165","women":"66.6","white":"20.3","black":"1.5","asian":"13.9"}},"wageData":{"2014":{"workers":"146","median":"619","maleWorkers":"44","maleMedian":"-","femaleWorkers":"102","femaleMedian":"592"}}},"Billing and posting clerks":{"ageData":{"2014":{"total":"507","16to19":"3","20to24":"29","25to34":"104","35to44":"117","45to54":"139","55to64":"91","65+":"24","medianAge":"91"}},"title":"Billing and posting clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"507","women":"91.2","white":"13.3","black":"5.2","asian":"12.2"}},"wageData":{"2014":{"workers":"412","median":"642","maleWorkers":"32","maleMedian":"-","femaleWorkers":"380","femaleMedian":"640"}}},"Bookkeeping, accounting, and auditing clerks":{"ageData":{"2014":{"total":"1,231","16to19":"8","20to24":"54","25to34":"172","35to44":"240","45to54":"333","55to64":"291","65+":"135","medianAge":"291"}},"title":"Bookkeeping, accounting, and auditing clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"1,231","women":"90.2","white":"8.0","black":"4.8","asian":"10.9"}},"wageData":{"2014":{"workers":"830","median":"665","maleWorkers":"85","maleMedian":"732","femaleWorkers":"745","femaleMedian":"660"}}},"Gaming cage workers":{"ageData":{"2014":{"total":"14","16to19":"0","20to24":"1","25to34":"4","35to44":"5","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Gaming cage workers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"14","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Payroll and timekeeping clerks":{"ageData":{"2014":{"total":"146","16to19":"0","20to24":"7","25to34":"28","35to44":"30","45to54":"42","55to64":"33","65+":"5","medianAge":"33"}},"title":"Payroll and timekeeping clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"146","women":"89.4","white":"15.1","black":"3.9","asian":"12.1"}},"wageData":{"2014":{"workers":"124","median":"757","maleWorkers":"11","maleMedian":"-","femaleWorkers":"113","femaleMedian":"762"}}},"Procurement clerks":{"ageData":{"2014":{"total":"31","16to19":"0","20to24":"3","25to34":"5","35to44":"6","45to54":"8","55to64":"7","65+":"0","medianAge":"7"}},"title":"Procurement clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"31","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"30","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"19","femaleMedian":"-"}}},"Tellers":{"ageData":{"2014":{"total":"361","16to19":"10","20to24":"96","25to34":"105","35to44":"53","45to54":"47","55to64":"37","65+":"14","medianAge":"37"}},"title":"Tellers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"361","women":"81.6","white":"10.5","black":"7.1","asian":"16.8"}},"wageData":{"2014":{"workers":"284","median":"510","maleWorkers":"55","maleMedian":"544","femaleWorkers":"229","femaleMedian":"507"}}},"Financial clerks, all other":{"ageData":{"2014":{"total":"65","16to19":"0","20to24":"5","25to34":"16","35to44":"13","45to54":"20","55to64":"9","65+":"3","medianAge":"9"}},"title":"Financial clerks, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"65","women":"66.6","white":"11.8","black":"6.4","asian":"7.8"}},"wageData":{"2014":{"workers":"63","median":"752","maleWorkers":"23","maleMedian":"-","femaleWorkers":"40","femaleMedian":"-"}}},"Brokerage clerks":{"ageData":{"2014":{"total":"5","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Brokerage clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"4","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Correspondence clerks":{"ageData":{"2014":{"total":"6","16to19":"1","20to24":"1","25to34":"2","35to44":"0","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Correspondence clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"6","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Court, municipal, and license clerks":{"ageData":{"2014":{"total":"69","16to19":"1","20to24":"2","25to34":"9","35to44":"14","45to54":"23","55to64":"13","65+":"7","medianAge":"13"}},"title":"Court, municipal, and license clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"69","women":"77.4","white":"12.7","black":"0.8","asian":"14.1"}},"wageData":{"2014":{"workers":"58","median":"738","maleWorkers":"10","maleMedian":"-","femaleWorkers":"48","femaleMedian":"-"}}},"Credit authorizers, checkers, and clerks":{"ageData":{"2014":{"total":"44","16to19":"0","20to24":"5","25to34":"17","35to44":"5","45to54":"11","55to64":"3","65+":"2","medianAge":"3"}},"title":"Credit authorizers, checkers, and clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"44","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"36","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"24","femaleMedian":"-"}}},"Customer service representatives":{"ageData":{"2014":{"total":"2,086","16to19":"122","20to24":"341","25to34":"531","35to44":"373","45to54":"377","55to64":"277","65+":"66","medianAge":"277"}},"title":"Customer service representatives","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"2,086","women":"64.6","white":"17.0","black":"4.5","asian":"16.5"}},"wageData":{"2014":{"workers":"1,550","median":"627","maleWorkers":"537","maleMedian":"698","femaleWorkers":"1,014","femaleMedian":"606"}}},"Eligibility interviewers, government programs":{"ageData":{"2014":{"total":"70","16to19":"1","20to24":"0","25to34":"14","35to44":"22","45to54":"16","55to64":"15","65+":"2","medianAge":"15"}},"title":"Eligibility interviewers, government programs","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"70","women":"82.1","white":"26.3","black":"3.2","asian":"20.6"}},"wageData":{"2014":{"workers":"66","median":"783","maleWorkers":"14","maleMedian":"-","femaleWorkers":"52","femaleMedian":"766"}}},"File clerks":{"ageData":{"2014":{"total":"226","16to19":"11","20to24":"29","25to34":"40","35to44":"40","45to54":"51","55to64":"35","65+":"20","medianAge":"35"}},"title":"File clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"226","women":"81.6","white":"15.6","black":"3.8","asian":"18.3"}},"wageData":{"2014":{"workers":"160","median":"610","maleWorkers":"29","maleMedian":"-","femaleWorkers":"130","femaleMedian":"613"}}},"Hotel, motel, and resort desk clerks":{"ageData":{"2014":{"total":"120","16to19":"7","20to24":"31","25to34":"34","35to44":"20","45to54":"14","55to64":"10","65+":"4","medianAge":"10"}},"title":"Hotel, motel, and resort desk clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"120","women":"63.5","white":"12.4","black":"9.3","asian":"25.1"}},"wageData":{"2014":{"workers":"82","median":"426","maleWorkers":"30","maleMedian":"-","femaleWorkers":"52","femaleMedian":"417"}}},"Interviewers, except eligibility and loan":{"ageData":{"2014":{"total":"160","16to19":"1","20to24":"11","25to34":"48","35to44":"30","45to54":"34","55to64":"21","65+":"13","medianAge":"21"}},"title":"Interviewers, except eligibility and loan","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"160","women":"80.5","white":"23.9","black":"4.8","asian":"11.3"}},"wageData":{"2014":{"workers":"124","median":"636","maleWorkers":"27","maleMedian":"-","femaleWorkers":"97","femaleMedian":"620"}}},"Library assistants, clerical":{"ageData":{"2014":{"total":"98","16to19":"7","20to24":"16","25to34":"17","35to44":"14","45to54":"16","55to64":"16","65+":"12","medianAge":"16"}},"title":"Library assistants, clerical","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"98","women":"84.0","white":"7.3","black":"3.2","asian":"10.2"}},"wageData":{"2014":{"workers":"41","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"33","femaleMedian":"-"}}},"Loan interviewers and clerks":{"ageData":{"2014":{"total":"143","16to19":"1","20to24":"15","25to34":"46","35to44":"32","45to54":"27","55to64":"16","65+":"6","medianAge":"16"}},"title":"Loan interviewers and clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"143","women":"78.1","white":"11.4","black":"3.9","asian":"9.6"}},"wageData":{"2014":{"workers":"131","median":"710","maleWorkers":"31","maleMedian":"-","femaleWorkers":"99","femaleMedian":"692"}}},"New accounts clerks":{"ageData":{"2014":{"total":"27","16to19":"1","20to24":"1","25to34":"9","35to44":"7","45to54":"7","55to64":"3","65+":"1","medianAge":"3"}},"title":"New accounts clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"27","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"25","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"21","femaleMedian":"-"}}},"Order clerks":{"ageData":{"2014":{"total":"104","16to19":"3","20to24":"17","25to34":"35","35to44":"15","45to54":"17","55to64":"14","65+":"4","medianAge":"14"}},"title":"Order clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"104","women":"59.9","white":"9.5","black":"5.8","asian":"19.1"}},"wageData":{"2014":{"workers":"79","median":"600","maleWorkers":"29","maleMedian":"-","femaleWorkers":"51","femaleMedian":"574"}}},"Human resources assistants, except payroll and timekeeping":{"ageData":{"2014":{"total":"101","16to19":"0","20to24":"7","25to34":"25","35to44":"21","45to54":"28","55to64":"15","65+":"4","medianAge":"15"}},"title":"Human resources assistants, except payroll and timekeeping","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"101","women":"87.6","white":"17.1","black":"1.9","asian":"15.1"}},"wageData":{"2014":{"workers":"91","median":"754","maleWorkers":"11","maleMedian":"-","femaleWorkers":"80","femaleMedian":"711"}}},"Receptionists and information clerks":{"ageData":{"2014":{"total":"1,301","16to19":"64","20to24":"232","25to34":"327","35to44":"195","45to54":"212","55to64":"200","65+":"72","medianAge":"200"}},"title":"Receptionists and information clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"1,301","women":"91.3","white":"10.5","black":"4.1","asian":"18.7"}},"wageData":{"2014":{"workers":"910","median":"540","maleWorkers":"85","maleMedian":"616","femaleWorkers":"825","femaleMedian":"532"}}},"Reservation and transportation ticket agents and travel clerks":{"ageData":{"2014":{"total":"94","16to19":"1","20to24":"13","25to34":"20","35to44":"14","45to54":"22","55to64":"21","65+":"3","medianAge":"21"}},"title":"Reservation and transportation ticket agents and travel clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"94","women":"57.4","white":"16.0","black":"9.9","asian":"18.5"}},"wageData":{"2014":{"workers":"85","median":"687","maleWorkers":"37","maleMedian":"-","femaleWorkers":"48","femaleMedian":"-"}}},"Information and record clerks, all other":{"ageData":{"2014":{"total":"95","16to19":"1","20to24":"4","25to34":"27","35to44":"16","45to54":"21","55to64":"17","65+":"9","medianAge":"17"}},"title":"Information and record clerks, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"95","women":"81.6","white":"9.7","black":"6.5","asian":"15.0"}},"wageData":{"2014":{"workers":"75","median":"660","maleWorkers":"17","maleMedian":"-","femaleWorkers":"59","femaleMedian":"658"}}},"Cargo and freight agents":{"ageData":{"2014":{"total":"23","16to19":"0","20to24":"3","25to34":"5","35to44":"5","45to54":"4","55to64":"6","65+":"0","medianAge":"6"}},"title":"Cargo and freight agents","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"23","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"17","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Couriers and messengers":{"ageData":{"2014":{"total":"233","16to19":"6","20to24":"18","25to34":"41","35to44":"53","45to54":"49","55to64":"52","65+":"14","medianAge":"52"}},"title":"Couriers and messengers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"233","women":"16.0","white":"14.4","black":"3.2","asian":"20.4"}},"wageData":{"2014":{"workers":"167","median":"727","maleWorkers":"142","maleMedian":"737","femaleWorkers":"25","femaleMedian":"-"}}},"Dispatchers":{"ageData":{"2014":{"total":"267","16to19":"6","20to24":"23","25to34":"71","35to44":"64","45to54":"58","55to64":"39","65+":"6","medianAge":"39"}},"title":"Dispatchers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"267","women":"60.9","white":"14.0","black":"1.8","asian":"14.9"}},"wageData":{"2014":{"workers":"234","median":"710","maleWorkers":"96","maleMedian":"764","femaleWorkers":"138","femaleMedian":"669"}}},"Meter readers, utilities":{"ageData":{"2014":{"total":"23","16to19":"3","20to24":"0","25to34":"3","35to44":"6","45to54":"5","55to64":"5","65+":"2","medianAge":"5"}},"title":"Meter readers, utilities","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"23","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"25","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Postal service clerks":{"ageData":{"2014":{"total":"117","16to19":"1","20to24":"8","25to34":"9","35to44":"16","45to54":"34","55to64":"46","65+":"3","medianAge":"46"}},"title":"Postal service clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"117","women":"52.3","white":"30.8","black":"8.7","asian":"7.9"}},"wageData":{"2014":{"workers":"98","median":"978","maleWorkers":"43","maleMedian":"-","femaleWorkers":"56","femaleMedian":"935"}}},"Postal service mail carriers":{"ageData":{"2014":{"total":"311","16to19":"1","20to24":"10","25to34":"35","35to44":"55","45to54":"109","55to64":"85","65+":"16","medianAge":"85"}},"title":"Postal service mail carriers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"311","women":"38.7","white":"19.2","black":"5.3","asian":"12.9"}},"wageData":{"2014":{"workers":"274","median":"966","maleWorkers":"178","maleMedian":"1,025","femaleWorkers":"95","femaleMedian":"851"}}},"Postal service mail sorters, processors, and processing machine operators":{"ageData":{"2014":{"total":"61","16to19":"1","20to24":"5","25to34":"5","35to44":"10","45to54":"15","55to64":"23","65+":"1","medianAge":"23"}},"title":"Postal service mail sorters, processors, and processing machine operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"61","women":"59.1","white":"27.5","black":"5.7","asian":"9.5"}},"wageData":{"2014":{"workers":"51","median":"979","maleWorkers":"22","maleMedian":"-","femaleWorkers":"29","femaleMedian":"-"}}},"Production, planning, and expediting clerks":{"ageData":{"2014":{"total":"244","16to19":"1","20to24":"15","25to34":"42","35to44":"58","45to54":"65","55to64":"53","65+":"10","medianAge":"53"}},"title":"Production, planning, and expediting clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"244","women":"54.3","white":"11.4","black":"4.5","asian":"13.5"}},"wageData":{"2014":{"workers":"208","median":"837","maleWorkers":"96","maleMedian":"1,024","femaleWorkers":"111","femaleMedian":"738"}}},"Shipping, receiving, and traffic clerks":{"ageData":{"2014":{"total":"606","16to19":"13","20to24":"69","25to34":"151","35to44":"114","45to54":"130","55to64":"102","65+":"29","medianAge":"102"}},"title":"Shipping, receiving, and traffic clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"606","women":"32.3","white":"13.3","black":"3.2","asian":"23.2"}},"wageData":{"2014":{"workers":"545","median":"592","maleWorkers":"376","maleMedian":"603","femaleWorkers":"169","femaleMedian":"576"}}},"Stock clerks and order fillers":{"ageData":{"2014":{"total":"1,483","16to19":"123","20to24":"312","25to34":"306","35to44":"230","45to54":"253","55to64":"188","65+":"71","medianAge":"188"}},"title":"Stock clerks and order fillers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"1,483","women":"35.9","white":"16.0","black":"4.2","asian":"22.3"}},"wageData":{"2014":{"workers":"995","median":"508","maleWorkers":"658","maleMedian":"504","femaleWorkers":"337","femaleMedian":"514"}}},"Weighers, measurers, checkers, and samplers, recordkeeping":{"ageData":{"2014":{"total":"75","16to19":"1","20to24":"7","25to34":"21","35to44":"13","45to54":"18","55to64":"14","65+":"2","medianAge":"14"}},"title":"Weighers, measurers, checkers, and samplers, recordkeeping","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"75","women":"41.8","white":"14.7","black":"1.5","asian":"22.2"}},"wageData":{"2014":{"workers":"77","median":"646","maleWorkers":"45","maleMedian":"-","femaleWorkers":"32","femaleMedian":"-"}}},"Secretaries and administrative assistants":{"ageData":{"2014":{"total":"2,995","16to19":"34","20to24":"160","25to34":"504","35to44":"576","45to54":"805","55to64":"727","65+":"190","medianAge":"727"}},"title":"Secretaries and administrative assistants","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"2,995","women":"94.2","white":"9.8","black":"3.3","asian":"12.7"}},"wageData":{"2014":{"workers":"2,342","median":"691","maleWorkers":"126","maleMedian":"811","femaleWorkers":"2,215","femaleMedian":"685"}}},"Computer operators":{"ageData":{"2014":{"total":"87","16to19":"1","20to24":"4","25to34":"21","35to44":"17","45to54":"26","55to64":"14","65+":"5","medianAge":"14"}},"title":"Computer operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"87","women":"55.0","white":"12.5","black":"4.3","asian":"8.5"}},"wageData":{"2014":{"workers":"72","median":"764","maleWorkers":"34","maleMedian":"-","femaleWorkers":"37","femaleMedian":"-"}}},"Data entry keyers":{"ageData":{"2014":{"total":"292","16to19":"7","20to24":"30","25to34":"71","35to44":"53","45to54":"67","55to64":"50","65+":"15","medianAge":"50"}},"title":"Data entry keyers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"292","women":"78.7","white":"16.1","black":"8.4","asian":"12.9"}},"wageData":{"2014":{"workers":"246","median":"626","maleWorkers":"51","maleMedian":"673","femaleWorkers":"195","femaleMedian":"618"}}},"Word processors and typists":{"ageData":{"2014":{"total":"101","16to19":"2","20to24":"11","25to34":"20","35to44":"24","45to54":"20","55to64":"17","65+":"7","medianAge":"17"}},"title":"Word processors and typists","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"101","women":"88.4","white":"18.4","black":"5.3","asian":"10.7"}},"wageData":{"2014":{"workers":"77","median":"622","maleWorkers":"14","maleMedian":"-","femaleWorkers":"63","femaleMedian":"629"}}},"Desktop publishers":{"ageData":{"2014":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"0","65+":"1","medianAge":"0"}},"title":"Desktop publishers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Insurance claims and policy processing clerks":{"ageData":{"2014":{"total":"288","16to19":"3","20to24":"22","25to34":"62","35to44":"72","45to54":"68","55to64":"50","65+":"12","medianAge":"50"}},"title":"Insurance claims and policy processing clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"288","women":"82.8","white":"15.2","black":"2.9","asian":"10.1"}},"wageData":{"2014":{"workers":"275","median":"647","maleWorkers":"50","maleMedian":"709","femaleWorkers":"225","femaleMedian":"632"}}},"Mail clerks and mail machine operators, except postal service":{"ageData":{"2014":{"total":"79","16to19":"2","20to24":"13","25to34":"15","35to44":"13","45to54":"15","55to64":"18","65+":"3","medianAge":"18"}},"title":"Mail clerks and mail machine operators, except postal service","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"79","women":"53.0","white":"20.0","black":"10.3","asian":"13.8"}},"wageData":{"2014":{"workers":"61","median":"567","maleWorkers":"28","maleMedian":"-","femaleWorkers":"33","femaleMedian":"-"}}},"Office clerks, general":{"ageData":{"2014":{"total":"1,230","16to19":"51","20to24":"140","25to34":"225","35to44":"214","45to54":"276","55to64":"238","65+":"86","medianAge":"238"}},"title":"Office clerks, general","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"1,230","women":"84.6","white":"13.3","black":"6.1","asian":"15.5"}},"wageData":{"2014":{"workers":"888","median":"630","maleWorkers":"135","maleMedian":"662","femaleWorkers":"753","femaleMedian":"626"}}},"Office machine operators, except computer":{"ageData":{"2014":{"total":"39","16to19":"2","20to24":"4","25to34":"9","35to44":"4","45to54":"11","55to64":"7","65+":"2","medianAge":"7"}},"title":"Office machine operators, except computer","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"39","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"25","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Proofreaders and copy markers":{"ageData":{"2014":{"total":"10","16to19":"0","20to24":"1","25to34":"1","35to44":"0","45to54":"3","55to64":"4","65+":"1","medianAge":"4"}},"title":"Proofreaders and copy markers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"4","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Statistical assistants":{"ageData":{"2014":{"total":"23","16to19":"0","20to24":"4","25to34":"4","35to44":"5","45to54":"6","55to64":"4","65+":"1","medianAge":"4"}},"title":"Statistical assistants","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"23","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"19","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Office and administrative support workers, all other":{"ageData":{"2014":{"total":"497","16to19":"13","20to24":"36","25to34":"113","35to44":"106","45to54":"109","55to64":"94","65+":"27","medianAge":"94"}},"title":"Office and administrative support workers, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2014":{"total":"497","women":"73.8","white":"12.9","black":"3.9","asian":"12.2"}},"wageData":{"2014":{"workers":"410","median":"731","maleWorkers":"114","maleMedian":"878","femaleWorkers":"296","femaleMedian":"692"}}},"Natural resources, construction, and maintenance occupations":{"ageData":{"2014":{"total":"13,537","16to19":"283","20to24":"1,158","25to34":"3,308","35to44":"3,100","45to54":"3,172","55to64":"2,063","65+":"453","medianAge":"2,063"}},"title":"Natural resources, construction, and maintenance occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2014":{"total":"13,537","women":"4.4","white":"7.3","black":"2.1","asian":"27.6"}},"wageData":{"2014":{"workers":"10,763","median":"756","maleWorkers":"10,346","maleMedian":"764","femaleWorkers":"417","femaleMedian":"509"}}},"Farming, fishing, and forestry occupations":{"ageData":{"2014":{"total":"1,022","16to19":"77","20to24":"113","25to34":"246","35to44":"201","45to54":"192","55to64":"141","65+":"50","medianAge":"141"}},"title":"Farming, fishing, and forestry occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2014":{"total":"1,022","women":"22.4","white":"6.0","black":"1.6","asian":"43.4"}},"wageData":{"2014":{"workers":"776","median":"429","maleWorkers":"625","maleMedian":"457","femaleWorkers":"151","femaleMedian":"375"}}},"First-line supervisors of farming, fishing, and forestry workers":{"ageData":{"2014":{"total":"44","16to19":"0","20to24":"2","25to34":"6","35to44":"12","45to54":"8","55to64":"10","65+":"7","medianAge":"10"}},"title":"First-line supervisors of farming, fishing, and forestry workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2014":{"total":"44","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"23","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Agricultural inspectors":{"ageData":{"2014":{"total":"17","16to19":"0","20to24":"0","25to34":"4","35to44":"2","45to54":"5","55to64":"4","65+":"1","medianAge":"4"}},"title":"Agricultural inspectors","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2014":{"total":"17","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"16","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Animal breeders":{"ageData":{"2014":{"total":"6","16to19":"0","20to24":"1","25to34":"1","35to44":"1","45to54":"2","55to64":"0","65+":"1","medianAge":"0"}},"title":"Animal breeders","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2014":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Graders and sorters, agricultural products":{"ageData":{"2014":{"total":"93","16to19":"2","20to24":"10","25to34":"26","35to44":"24","45to54":"15","55to64":"14","65+":"2","medianAge":"14"}},"title":"Graders and sorters, agricultural products","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2014":{"total":"93","women":"59.9","white":"13.4","black":"2.1","asian":"54.0"}},"wageData":{"2014":{"workers":"98","median":"389","maleWorkers":"45","maleMedian":"-","femaleWorkers":"53","femaleMedian":"386"}}},"Miscellaneous agricultural workers":{"ageData":{"2014":{"total":"739","16to19":"71","20to24":"94","25to34":"185","35to44":"138","45to54":"130","55to64":"90","65+":"31","medianAge":"90"}},"title":"Miscellaneous agricultural workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2014":{"total":"739","women":"20.2","white":"5.1","black":"1.5","asian":"49.2"}},"wageData":{"2014":{"workers":"569","median":"421","maleWorkers":"485","maleMedian":"437","femaleWorkers":"84","femaleMedian":"369"}}},"Fishers and related fishing workers":{"ageData":{"2014":{"total":"32","16to19":"2","20to24":"2","25to34":"5","35to44":"4","45to54":"11","55to64":"7","65+":"2","medianAge":"7"}},"title":"Fishers and related fishing workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2014":{"total":"32","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"9","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Hunters and trappers":{"ageData":{"2014":{"total":"2","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"0","65+":"1","medianAge":"0"}},"title":"Hunters and trappers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2014":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Forest and conservation workers":{"ageData":{"2014":{"total":"18","16to19":"0","20to24":"1","25to34":"3","35to44":"6","45to54":"1","55to64":"5","65+":"1","medianAge":"5"}},"title":"Forest and conservation workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2014":{"total":"18","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"13","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Logging workers":{"ageData":{"2014":{"total":"71","16to19":"2","20to24":"4","25to34":"15","35to44":"14","45to54":"20","55to64":"11","65+":"5","medianAge":"11"}},"title":"Logging workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2014":{"total":"71","women":"5.4","white":"8.4","black":"1.5","asian":"11.8"}},"wageData":{"2014":{"workers":"44","median":"-","maleWorkers":"42","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Construction and extraction occupations":{"ageData":{"2014":{"total":"7,637","16to19":"139","20to24":"649","25to34":"1,941","35to44":"1,824","45to54":"1,773","55to64":"1,084","65+":"226","medianAge":"1,084"}},"title":"Construction and extraction occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2014":{"total":"7,637","women":"2.6","white":"6.9","black":"1.3","asian":"32.3"}},"wageData":{"2014":{"workers":"5,756","median":"756","maleWorkers":"5,635","maleMedian":"757","femaleWorkers":"121","femaleMedian":"691"}}},"First-line supervisors of construction trades and extraction workers":{"ageData":{"2014":{"total":"696","16to19":"1","20to24":"19","25to34":"132","35to44":"157","45to54":"204","55to64":"152","65+":"30","medianAge":"152"}},"title":"First-line supervisors of construction trades and extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"696","women":"2.4","white":"5.7","black":"1.1","asian":"18.9"}},"wageData":{"2014":{"workers":"540","median":"1,027","maleWorkers":"528","maleMedian":"1,033","femaleWorkers":"12","femaleMedian":"-"}}},"Boilermakers":{"ageData":{"2014":{"total":"17","16to19":"0","20to24":"3","25to34":"4","35to44":"4","45to54":"4","55to64":"1","65+":"0","medianAge":"1"}},"title":"Boilermakers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"17","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"17","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Brickmasons, blockmasons, and stonemasons":{"ageData":{"2014":{"total":"142","16to19":"3","20to24":"9","25to34":"45","35to44":"37","45to54":"24","55to64":"18","65+":"6","medianAge":"18"}},"title":"Brickmasons, blockmasons, and stonemasons","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"142","women":"0.7","white":"8.1","black":"0.3","asian":"43.9"}},"wageData":{"2014":{"workers":"105","median":"657","maleWorkers":"105","maleMedian":"656","femaleWorkers":"0","femaleMedian":"-"}}},"Carpenters":{"ageData":{"2014":{"total":"1,282","16to19":"21","20to24":"109","25to34":"311","35to44":"313","45to54":"302","55to64":"185","65+":"40","medianAge":"185"}},"title":"Carpenters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"1,282","women":"1.7","white":"5.0","black":"1.4","asian":"31.9"}},"wageData":{"2014":{"workers":"801","median":"696","maleWorkers":"786","maleMedian":"699","femaleWorkers":"15","femaleMedian":"-"}}},"Carpet, floor, and tile installers and finishers":{"ageData":{"2014":{"total":"170","16to19":"2","20to24":"11","25to34":"48","35to44":"41","45to54":"39","55to64":"26","65+":"3","medianAge":"26"}},"title":"Carpet, floor, and tile installers and finishers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"170","women":"2.3","white":"4.8","black":"3.6","asian":"44.2"}},"wageData":{"2014":{"workers":"94","median":"683","maleWorkers":"92","maleMedian":"687","femaleWorkers":"2","femaleMedian":"-"}}},"Cement masons, concrete finishers, and terrazzo workers":{"ageData":{"2014":{"total":"58","16to19":"1","20to24":"4","25to34":"14","35to44":"18","45to54":"16","55to64":"2","65+":"3","medianAge":"2"}},"title":"Cement masons, concrete finishers, and terrazzo workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"58","women":"0.0","white":"9.5","black":"0.0","asian":"48.7"}},"wageData":{"2014":{"workers":"41","median":"-","maleWorkers":"41","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Construction laborers":{"ageData":{"2014":{"total":"1,686","16to19":"57","20to24":"187","25to34":"469","35to44":"389","45to54":"347","55to64":"191","65+":"46","medianAge":"191"}},"title":"Construction laborers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"1,686","women":"2.5","white":"9.4","black":"1.8","asian":"42.1"}},"wageData":{"2014":{"workers":"1,221","median":"605","maleWorkers":"1,199","maleMedian":"605","femaleWorkers":"22","femaleMedian":"-"}}},"Paving, surfacing, and tamping equipment operators":{"ageData":{"2014":{"total":"19","16to19":"0","20to24":"1","25to34":"6","35to44":"3","45to54":"6","55to64":"3","65+":"0","medianAge":"3"}},"title":"Paving, surfacing, and tamping equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"12","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Pile-driver operators":{"ageData":{"2014":{"total":"1","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Pile-driver operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Operating engineers and other construction equipment operators":{"ageData":{"2014":{"total":"336","16to19":"2","20to24":"22","25to34":"75","35to44":"74","45to54":"82","55to64":"68","65+":"13","medianAge":"68"}},"title":"Operating engineers and other construction equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"336","women":"1.8","white":"6.8","black":"0.1","asian":"16.9"}},"wageData":{"2014":{"workers":"310","median":"864","maleWorkers":"305","maleMedian":"862","femaleWorkers":"6","femaleMedian":"-"}}},"Drywall installers, ceiling tile installers, and tapers":{"ageData":{"2014":{"total":"162","16to19":"1","20to24":"9","25to34":"47","35to44":"59","45to54":"31","55to64":"13","65+":"2","medianAge":"13"}},"title":"Drywall installers, ceiling tile installers, and tapers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"162","women":"2.1","white":"1.8","black":"0.3","asian":"61.5"}},"wageData":{"2014":{"workers":"119","median":"597","maleWorkers":"118","maleMedian":"595","femaleWorkers":"1","femaleMedian":"-"}}},"Electricians":{"ageData":{"2014":{"total":"769","16to19":"9","20to24":"62","25to34":"187","35to44":"198","45to54":"199","55to64":"94","65+":"20","medianAge":"94"}},"title":"Electricians","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"769","women":"2.4","white":"6.5","black":"1.8","asian":"18.2"}},"wageData":{"2014":{"workers":"640","median":"883","maleWorkers":"624","maleMedian":"884","femaleWorkers":"16","femaleMedian":"-"}}},"Glaziers":{"ageData":{"2014":{"total":"35","16to19":"0","20to24":"1","25to34":"9","35to44":"10","45to54":"8","55to64":"5","65+":"2","medianAge":"5"}},"title":"Glaziers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"35","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"28","median":"-","maleWorkers":"27","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Insulation workers":{"ageData":{"2014":{"total":"44","16to19":"0","20to24":"2","25to34":"16","35to44":"10","45to54":"9","55to64":"6","65+":"0","medianAge":"6"}},"title":"Insulation workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"44","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"41","median":"-","maleWorkers":"38","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Painters, construction and maintenance":{"ageData":{"2014":{"total":"561","16to19":"8","20to24":"47","25to34":"131","35to44":"144","45to54":"143","55to64":"72","65+":"16","medianAge":"72"}},"title":"Painters, construction and maintenance","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"561","women":"6.0","white":"7.3","black":"1.4","asian":"48.2"}},"wageData":{"2014":{"workers":"358","median":"563","maleWorkers":"342","maleMedian":"562","femaleWorkers":"16","femaleMedian":"-"}}},"Paperhangers":{"ageData":{"2014":{"total":"4","16to19":"0","20to24":"1","25to34":"0","35to44":"0","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Paperhangers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Pipelayers, plumbers, pipefitters, and steamfitters":{"ageData":{"2014":{"total":"564","16to19":"9","20to24":"40","25to34":"139","35to44":"141","45to54":"124","55to64":"93","65+":"19","medianAge":"93"}},"title":"Pipelayers, plumbers, pipefitters, and steamfitters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"564","women":"1.6","white":"6.9","black":"1.6","asian":"21.4"}},"wageData":{"2014":{"workers":"486","median":"913","maleWorkers":"478","maleMedian":"916","femaleWorkers":"8","femaleMedian":"-"}}},"Plasterers and stucco masons":{"ageData":{"2014":{"total":"31","16to19":"1","20to24":"1","25to34":"11","35to44":"7","45to54":"7","55to64":"5","65+":"0","medianAge":"5"}},"title":"Plasterers and stucco masons","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"31","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"22","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Reinforcing iron and rebar workers":{"ageData":{"2014":{"total":"9","16to19":"0","20to24":"2","25to34":"5","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Reinforcing iron and rebar workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"8","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Roofers":{"ageData":{"2014":{"total":"206","16to19":"6","20to24":"21","25to34":"79","35to44":"50","45to54":"33","55to64":"17","65+":"1","medianAge":"17"}},"title":"Roofers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"206","women":"0.5","white":"4.3","black":"0.5","asian":"58.1"}},"wageData":{"2014":{"workers":"136","median":"618","maleWorkers":"135","maleMedian":"620","femaleWorkers":"1","femaleMedian":"-"}}},"Sheet metal workers":{"ageData":{"2014":{"total":"110","16to19":"1","20to24":"10","25to34":"21","35to44":"24","45to54":"29","55to64":"22","65+":"3","medianAge":"22"}},"title":"Sheet metal workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"110","women":"5.2","white":"5.2","black":"0.8","asian":"10.2"}},"wageData":{"2014":{"workers":"113","median":"868","maleWorkers":"111","maleMedian":"857","femaleWorkers":"2","femaleMedian":"-"}}},"Structural iron and steel workers":{"ageData":{"2014":{"total":"52","16to19":"1","20to24":"5","25to34":"15","35to44":"9","45to54":"14","55to64":"8","65+":"1","medianAge":"8"}},"title":"Structural iron and steel workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"52","women":"2.0","white":"10.8","black":"0.0","asian":"23.4"}},"wageData":{"2014":{"workers":"47","median":"-","maleWorkers":"47","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Solar photovoltaic installers":{"ageData":{"2014":{"total":"14","16to19":"0","20to24":"2","25to34":"6","35to44":"2","45to54":"3","55to64":"1","65+":"0","medianAge":"1"}},"title":"Solar photovoltaic installers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"12","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers, construction trades":{"ageData":{"2014":{"total":"57","16to19":"6","20to24":"16","25to34":"13","35to44":"10","45to54":"6","55to64":"5","65+":"1","medianAge":"5"}},"title":"Helpers, construction trades","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"57","women":"4.7","white":"12.1","black":"0.0","asian":"45.6"}},"wageData":{"2014":{"workers":"51","median":"513","maleWorkers":"48","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Construction and building inspectors":{"ageData":{"2014":{"total":"78","16to19":"0","20to24":"1","25to34":"7","35to44":"17","45to54":"22","55to64":"24","65+":"6","medianAge":"24"}},"title":"Construction and building inspectors","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"78","women":"12.2","white":"3.3","black":"2.3","asian":"5.3"}},"wageData":{"2014":{"workers":"59","median":"1,031","maleWorkers":"54","maleMedian":"1,028","femaleWorkers":"5","femaleMedian":"-"}}},"Elevator installers and repairers":{"ageData":{"2014":{"total":"22","16to19":"0","20to24":"0","25to34":"9","35to44":"4","45to54":"4","55to64":"3","65+":"1","medianAge":"3"}},"title":"Elevator installers and repairers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"22","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"21","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Fence erectors":{"ageData":{"2014":{"total":"33","16to19":"1","20to24":"3","25to34":"11","35to44":"8","45to54":"8","55to64":"2","65+":"1","medianAge":"2"}},"title":"Fence erectors","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"31","median":"-","maleWorkers":"31","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Hazardous materials removal workers":{"ageData":{"2014":{"total":"23","16to19":"0","20to24":"4","25to34":"3","35to44":"5","45to54":"7","55to64":"2","65+":"2","medianAge":"2"}},"title":"Hazardous materials removal workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"23","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"22","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Highway maintenance workers":{"ageData":{"2014":{"total":"123","16to19":"1","20to24":"6","25to34":"19","35to44":"23","45to54":"39","55to64":"28","65+":"6","medianAge":"28"}},"title":"Highway maintenance workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"123","women":"1.5","white":"9.3","black":"0.0","asian":"17.1"}},"wageData":{"2014":{"workers":"116","median":"794","maleWorkers":"115","maleMedian":"794","femaleWorkers":"1","femaleMedian":"-"}}},"Rail-track laying and maintenance equipment operators":{"ageData":{"2014":{"total":"17","16to19":"0","20to24":"1","25to34":"4","35to44":"4","45to54":"2","55to64":"4","65+":"1","medianAge":"4"}},"title":"Rail-track laying and maintenance equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"17","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"16","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Septic tank servicers and sewer pipe cleaners":{"ageData":{"2014":{"total":"14","16to19":"0","20to24":"1","25to34":"4","35to44":"4","45to54":"4","55to64":"1","65+":"0","medianAge":"1"}},"title":"Septic tank servicers and sewer pipe cleaners","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"13","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Miscellaneous construction and related workers":{"ageData":{"2014":{"total":"33","16to19":"1","20to24":"4","25to34":"12","35to44":"6","45to54":"6","55to64":"4","65+":"2","medianAge":"4"}},"title":"Miscellaneous construction and related workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"19","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Derrick, rotary drill, and service unit operators, oil, gas, and mining":{"ageData":{"2014":{"total":"54","16to19":"1","20to24":"8","25to34":"23","35to44":"10","45to54":"8","55to64":"5","65+":"0","medianAge":"5"}},"title":"Derrick, rotary drill, and service unit operators, oil, gas, and mining","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"54","women":"0.0","white":"3.9","black":"0.0","asian":"32.1"}},"wageData":{"2014":{"workers":"53","median":"1,187","maleWorkers":"53","maleMedian":"1,187","femaleWorkers":"0","femaleMedian":"-"}}},"Earth drillers, except oil and gas":{"ageData":{"2014":{"total":"29","16to19":"1","20to24":"2","25to34":"8","35to44":"8","45to54":"8","55to64":"3","65+":"0","medianAge":"3"}},"title":"Earth drillers, except oil and gas","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"29","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"25","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Explosives workers, ordnance handling experts, and blasters":{"ageData":{"2014":{"total":"5","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Explosives workers, ordnance handling experts, and blasters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Mining machine operators":{"ageData":{"2014":{"total":"68","16to19":"1","20to24":"11","25to34":"17","35to44":"13","45to54":"14","55to64":"10","65+":"0","medianAge":"10"}},"title":"Mining machine operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"68","women":"1.5","white":"2.3","black":"0.0","asian":"22.4"}},"wageData":{"2014":{"workers":"59","median":"1,042","maleWorkers":"59","maleMedian":"1,047","femaleWorkers":"1","femaleMedian":"-"}}},"Roof bolters, mining":{"ageData":{"2014":{"total":"3","16to19":"0","20to24":"0","25to34":"2","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Roof bolters, mining","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Roustabouts, oil and gas":{"ageData":{"2014":{"total":"11","16to19":"2","20to24":"2","25to34":"4","35to44":"1","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Roustabouts, oil and gas","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"11","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Helpers--extraction workers":{"ageData":{"2014":{"total":"7","16to19":"0","20to24":"2","25to34":"1","35to44":"2","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Helpers--extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"8","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Other extraction workers":{"ageData":{"2014":{"total":"92","16to19":"3","20to24":"19","25to34":"29","35to44":"19","45to54":"14","55to64":"7","65+":"2","medianAge":"7"}},"title":"Other extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2014":{"total":"92","women":"1.5","white":"5.7","black":"0.0","asian":"29.1"}},"wageData":{"2014":{"workers":"86","median":"1,120","maleWorkers":"85","maleMedian":"1,126","femaleWorkers":"1","femaleMedian":"-"}}},"Installation, maintenance, and repair occupations":{"ageData":{"2014":{"total":"4,879","16to19":"66","20to24":"396","25to34":"1,122","35to44":"1,075","45to54":"1,206","55to64":"838","65+":"176","medianAge":"838"}},"title":"Installation, maintenance, and repair occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2014":{"total":"4,879","women":"3.5","white":"8.4","black":"3.3","asian":"16.8"}},"wageData":{"2014":{"workers":"4,231","median":"821","maleWorkers":"4,085","maleMedian":"824","femaleWorkers":"146","femaleMedian":"725"}}},"First-line supervisors of mechanics, installers, and repairers":{"ageData":{"2014":{"total":"284","16to19":"0","20to24":"3","25to34":"40","35to44":"69","45to54":"93","55to64":"67","65+":"11","medianAge":"67"}},"title":"First-line supervisors of mechanics, installers, and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"284","women":"4.8","white":"8.4","black":"3.3","asian":"11.2"}},"wageData":{"2014":{"workers":"289","median":"1,022","maleWorkers":"272","maleMedian":"1,040","femaleWorkers":"17","femaleMedian":"-"}}},"Computer, automated teller, and office machine repairers":{"ageData":{"2014":{"total":"265","16to19":"5","20to24":"22","25to34":"68","35to44":"64","45to54":"57","55to64":"44","65+":"5","medianAge":"44"}},"title":"Computer, automated teller, and office machine repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"265","women":"13.3","white":"12.2","black":"7.9","asian":"12.3"}},"wageData":{"2014":{"workers":"232","median":"880","maleWorkers":"201","maleMedian":"889","femaleWorkers":"31","femaleMedian":"-"}}},"Radio and telecommunications equipment installers and repairers":{"ageData":{"2014":{"total":"134","16to19":"1","20to24":"12","25to34":"29","35to44":"33","45to54":"30","55to64":"27","65+":"3","medianAge":"27"}},"title":"Radio and telecommunications equipment installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"134","women":"7.4","white":"12.5","black":"6.3","asian":"8.7"}},"wageData":{"2014":{"workers":"118","median":"859","maleWorkers":"109","maleMedian":"846","femaleWorkers":"9","femaleMedian":"-"}}},"Avionics technicians":{"ageData":{"2014":{"total":"8","16to19":"0","20to24":"0","25to34":"2","35to44":"0","45to54":"3","55to64":"2","65+":"0","medianAge":"2"}},"title":"Avionics technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"8","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Electric motor, power tool, and related repairers":{"ageData":{"2014":{"total":"35","16to19":"0","20to24":"4","25to34":"8","35to44":"8","45to54":"7","55to64":"6","65+":"2","medianAge":"6"}},"title":"Electric motor, power tool, and related repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"35","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"25","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electrical and electronics installers and repairers, transportation equipment":{"ageData":{"2014":{"total":"5","16to19":"0","20to24":"1","25to34":"1","35to44":"1","45to54":"1","55to64":"1","65+":"1","medianAge":"1"}},"title":"Electrical and electronics installers and repairers, transportation equipment","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electrical and electronics repairers, industrial and utility":{"ageData":{"2014":{"total":"15","16to19":"0","20to24":"0","25to34":"4","35to44":"2","45to54":"6","55to64":"2","65+":"0","medianAge":"2"}},"title":"Electrical and electronics repairers, industrial and utility","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"15","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"20","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electronic equipment installers and repairers, motor vehicles":{"ageData":{"2014":{"total":"17","16to19":"0","20to24":"0","25to34":"5","35to44":"4","45to54":"4","55to64":"4","65+":"0","medianAge":"4"}},"title":"Electronic equipment installers and repairers, motor vehicles","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"17","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"18","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electronic home entertainment equipment installers and repairers":{"ageData":{"2014":{"total":"34","16to19":"0","20to24":"2","25to34":"13","35to44":"10","45to54":"5","55to64":"3","65+":"1","medianAge":"3"}},"title":"Electronic home entertainment equipment installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"34","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"23","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Security and fire alarm systems installers":{"ageData":{"2014":{"total":"58","16to19":"0","20to24":"3","25to34":"20","35to44":"10","45to54":"15","55to64":"8","65+":"1","medianAge":"8"}},"title":"Security and fire alarm systems installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"58","women":"7.5","white":"9.0","black":"1.7","asian":"26.2"}},"wageData":{"2014":{"workers":"45","median":"-","maleWorkers":"43","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Aircraft mechanics and service technicians":{"ageData":{"2014":{"total":"127","16to19":"0","20to24":"6","25to34":"35","35to44":"22","45to54":"37","55to64":"21","65+":"5","medianAge":"21"}},"title":"Aircraft mechanics and service technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"127","women":"3.3","white":"9.0","black":"6.9","asian":"12.5"}},"wageData":{"2014":{"workers":"121","median":"1,080","maleWorkers":"117","maleMedian":"1,062","femaleWorkers":"4","femaleMedian":"-"}}},"Automotive body and related repairers":{"ageData":{"2014":{"total":"133","16to19":"3","20to24":"14","25to34":"30","35to44":"26","45to54":"38","55to64":"17","65+":"5","medianAge":"17"}},"title":"Automotive body and related repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"133","women":"1.6","white":"5.9","black":"1.7","asian":"18.3"}},"wageData":{"2014":{"workers":"109","median":"665","maleWorkers":"106","maleMedian":"668","femaleWorkers":"3","femaleMedian":"-"}}},"Automotive glass installers and repairers":{"ageData":{"2014":{"total":"21","16to19":"1","20to24":"2","25to34":"6","35to44":"5","45to54":"3","55to64":"2","65+":"1","medianAge":"2"}},"title":"Automotive glass installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"21","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"17","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Automotive service technicians and mechanics":{"ageData":{"2014":{"total":"883","16to19":"17","20to24":"96","25to34":"222","35to44":"214","45to54":"198","55to64":"111","65+":"25","medianAge":"111"}},"title":"Automotive service technicians and mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"883","women":"1.4","white":"9.0","black":"4.5","asian":"24.1"}},"wageData":{"2014":{"workers":"722","median":"734","maleWorkers":"706","maleMedian":"737","femaleWorkers":"16","femaleMedian":"-"}}},"Bus and truck mechanics and diesel engine specialists":{"ageData":{"2014":{"total":"323","16to19":"4","20to24":"32","25to34":"78","35to44":"66","45to54":"86","55to64":"44","65+":"13","medianAge":"44"}},"title":"Bus and truck mechanics and diesel engine specialists","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"323","women":"0.3","white":"7.8","black":"0.6","asian":"15.6"}},"wageData":{"2014":{"workers":"285","median":"813","maleWorkers":"283","maleMedian":"811","femaleWorkers":"2","femaleMedian":"-"}}},"Heavy vehicle and mobile equipment service technicians and mechanics":{"ageData":{"2014":{"total":"211","16to19":"1","20to24":"23","25to34":"54","35to44":"40","45to54":"51","55to64":"30","65+":"12","medianAge":"30"}},"title":"Heavy vehicle and mobile equipment service technicians and mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"211","women":"0.5","white":"3.8","black":"0.6","asian":"15.5"}},"wageData":{"2014":{"workers":"210","median":"885","maleWorkers":"209","maleMedian":"886","femaleWorkers":"1","femaleMedian":"-"}}},"Small engine mechanics":{"ageData":{"2014":{"total":"50","16to19":"2","20to24":"4","25to34":"19","35to44":"8","45to54":"9","55to64":"6","65+":"2","medianAge":"6"}},"title":"Small engine mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"50","women":"2.1","white":"5.3","black":"3.2","asian":"9.5"}},"wageData":{"2014":{"workers":"38","median":"-","maleWorkers":"37","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Miscellaneous vehicle and mobile equipment mechanics, installers, and repairers":{"ageData":{"2014":{"total":"93","16to19":"6","20to24":"23","25to34":"21","35to44":"19","45to54":"13","55to64":"9","65+":"2","medianAge":"9"}},"title":"Miscellaneous vehicle and mobile equipment mechanics, installers, and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"93","women":"0.3","white":"10.1","black":"2.4","asian":"28.0"}},"wageData":{"2014":{"workers":"64","median":"559","maleWorkers":"64","maleMedian":"559","femaleWorkers":"0","femaleMedian":"-"}}},"Control and valve installers and repairers":{"ageData":{"2014":{"total":"19","16to19":"0","20to24":"2","25to34":"5","35to44":"4","45to54":"4","55to64":"4","65+":"0","medianAge":"4"}},"title":"Control and valve installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"21","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Heating, air conditioning, and refrigeration mechanics and installers":{"ageData":{"2014":{"total":"378","16to19":"5","20to24":"32","25to34":"93","35to44":"99","45to54":"74","55to64":"64","65+":"11","medianAge":"64"}},"title":"Heating, air conditioning, and refrigeration mechanics and installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"378","women":"1.2","white":"8.5","black":"2.4","asian":"16.4"}},"wageData":{"2014":{"workers":"322","median":"769","maleWorkers":"318","maleMedian":"773","femaleWorkers":"3","femaleMedian":"-"}}},"Home appliance repairers":{"ageData":{"2014":{"total":"51","16to19":"0","20to24":"2","25to34":"10","35to44":"9","45to54":"16","55to64":"10","65+":"4","medianAge":"10"}},"title":"Home appliance repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"51","women":"5.6","white":"13.4","black":"1.9","asian":"19.2"}},"wageData":{"2014":{"workers":"32","median":"-","maleWorkers":"32","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Industrial and refractory machinery mechanics":{"ageData":{"2014":{"total":"454","16to19":"3","20to24":"23","25to34":"84","35to44":"96","45to54":"129","55to64":"103","65+":"16","medianAge":"103"}},"title":"Industrial and refractory machinery mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"454","women":"2.8","white":"6.3","black":"1.7","asian":"13.3"}},"wageData":{"2014":{"workers":"409","median":"876","maleWorkers":"398","maleMedian":"876","femaleWorkers":"11","femaleMedian":"-"}}},"Maintenance and repair workers, general":{"ageData":{"2014":{"total":"471","16to19":"5","20to24":"26","25to34":"83","35to44":"77","45to54":"143","55to64":"117","65+":"20","medianAge":"117"}},"title":"Maintenance and repair workers, general","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"471","women":"3.2","white":"9.9","black":"3.6","asian":"17.2"}},"wageData":{"2014":{"workers":"403","median":"813","maleWorkers":"391","maleMedian":"812","femaleWorkers":"12","femaleMedian":"-"}}},"Maintenance workers, machinery":{"ageData":{"2014":{"total":"37","16to19":"1","20to24":"4","25to34":"2","35to44":"8","45to54":"9","55to64":"7","65+":"4","medianAge":"7"}},"title":"Maintenance workers, machinery","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"37","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"32","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Millwrights":{"ageData":{"2014":{"total":"48","16to19":"0","20to24":"2","25to34":"8","35to44":"9","45to54":"11","55to64":"13","65+":"4","medianAge":"13"}},"title":"Millwrights","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"48","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"49","median":"-","maleWorkers":"49","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Electrical power-line installers and repairers":{"ageData":{"2014":{"total":"115","16to19":"1","20to24":"6","25to34":"41","35to44":"28","45to54":"25","55to64":"11","65+":"3","medianAge":"11"}},"title":"Electrical power-line installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"115","women":"3.0","white":"5.2","black":"0.9","asian":"7.8"}},"wageData":{"2014":{"workers":"108","median":"1,013","maleWorkers":"105","maleMedian":"1,018","femaleWorkers":"4","femaleMedian":"-"}}},"Telecommunications line installers and repairers":{"ageData":{"2014":{"total":"184","16to19":"2","20to24":"13","25to34":"55","35to44":"56","45to54":"37","55to64":"20","65+":"1","medianAge":"20"}},"title":"Telecommunications line installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"184","women":"4.4","white":"12.1","black":"4.7","asian":"17.3"}},"wageData":{"2014":{"workers":"170","median":"869","maleWorkers":"163","maleMedian":"877","femaleWorkers":"7","femaleMedian":"-"}}},"Precision instrument and equipment repairers":{"ageData":{"2014":{"total":"85","16to19":"0","20to24":"3","25to34":"16","35to44":"21","45to54":"20","55to64":"18","65+":"7","medianAge":"18"}},"title":"Precision instrument and equipment repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"85","women":"14.2","white":"7.2","black":"4.7","asian":"11.6"}},"wageData":{"2014":{"workers":"68","median":"818","maleWorkers":"60","maleMedian":"836","femaleWorkers":"8","femaleMedian":"-"}}},"Wind turbine service technicians":{"ageData":{"2014":{"total":"4","16to19":"0","20to24":"1","25to34":"0","35to44":"0","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Wind turbine service technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"5","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Coin, vending, and amusement machine servicers and repairers":{"ageData":{"2014":{"total":"43","16to19":"0","20to24":"4","25to34":"5","35to44":"10","45to54":"7","55to64":"14","65+":"3","medianAge":"14"}},"title":"Coin, vending, and amusement machine servicers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"43","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"32","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Commercial divers":{"ageData":{"2014":{"total":"3","16to19":"0","20to24":"0","25to34":"0","35to44":"2","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Commercial divers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Locksmiths and safe repairers":{"ageData":{"2014":{"total":"30","16to19":"1","20to24":"0","25to34":"6","35to44":"4","45to54":"6","55to64":"10","65+":"3","medianAge":"10"}},"title":"Locksmiths and safe repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"30","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"19","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Manufactured building and mobile home installers":{"ageData":{"2014":{"total":"4","16to19":"0","20to24":"1","25to34":"0","35to44":"1","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Manufactured building and mobile home installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Riggers":{"ageData":{"2014":{"total":"13","16to19":"0","20to24":"2","25to34":"5","35to44":"3","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Riggers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"14","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Signal and track switch repairers":{"ageData":{"2014":{"total":"7","16to19":"0","20to24":"0","25to34":"3","35to44":"2","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Signal and track switch repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"8","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers--installation, maintenance, and repair workers":{"ageData":{"2014":{"total":"14","16to19":"1","20to24":"5","25to34":"2","35to44":"3","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Helpers--installation, maintenance, and repair workers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"12","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Other installation, maintenance, and repair workers":{"ageData":{"2014":{"total":"224","16to19":"4","20to24":"20","25to34":"46","35to44":"44","45to54":"60","55to64":"41","65+":"9","medianAge":"41"}},"title":"Other installation, maintenance, and repair workers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2014":{"total":"224","women":"5.2","white":"5.1","black":"2.7","asian":"23.4"}},"wageData":{"2014":{"workers":"177","median":"804","maleWorkers":"170","maleMedian":"811","femaleWorkers":"6","femaleMedian":"-"}}},"Production, transportation, and material moving occupations":{"ageData":{"2014":{"total":"17,448","16to19":"490","20to24":"1,657","25to34":"3,505","35to44":"3,667","45to54":"4,192","55to64":"3,095","65+":"842","medianAge":"3,095"}},"title":"Production, transportation, and material moving occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2014":{"total":"17,448","women":"21.7","white":"15.0","black":"4.7","asian":"22.0"}},"wageData":{"2014":{"workers":"14,326","median":"642","maleWorkers":"11,474","maleMedian":"689","femaleWorkers":"2,852","femaleMedian":"504"}}},"Production occupations":{"ageData":{"2014":{"total":"8,438","16to19":"152","20to24":"780","25to34":"1,806","35to44":"1,826","45to54":"2,043","55to64":"1,513","65+":"319","medianAge":"1,513"}},"title":"Production occupations","depth":2,"parent":"Production, transportation, and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"8,438","women":"28.0","white":"12.5","black":"6.2","asian":"21.9"}},"wageData":{"2014":{"workers":"7,481","median":"646","maleWorkers":"5,546","maleMedian":"711","femaleWorkers":"1,935","femaleMedian":"502"}}},"First-line supervisors of production and operating workers":{"ageData":{"2014":{"total":"789","16to19":"4","20to24":"24","25to34":"146","35to44":"194","45to54":"241","55to64":"158","65+":"22","medianAge":"158"}},"title":"First-line supervisors of production and operating workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"789","women":"18.6","white":"11.0","black":"3.4","asian":"17.0"}},"wageData":{"2014":{"workers":"766","median":"903","maleWorkers":"631","maleMedian":"942","femaleWorkers":"134","femaleMedian":"659"}}},"Aircraft structure, surfaces, rigging, and systems assemblers":{"ageData":{"2014":{"total":"15","16to19":"0","20to24":"2","25to34":"1","35to44":"1","45to54":"4","55to64":"5","65+":"2","medianAge":"5"}},"title":"Aircraft structure, surfaces, rigging, and systems assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"15","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"16","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Electrical, electronics, and electromechanical assemblers":{"ageData":{"2014":{"total":"164","16to19":"4","20to24":"10","25to34":"31","35to44":"34","45to54":"48","55to64":"30","65+":"7","medianAge":"30"}},"title":"Electrical, electronics, and electromechanical assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"164","women":"46.7","white":"15.3","black":"16.8","asian":"22.9"}},"wageData":{"2014":{"workers":"159","median":"547","maleWorkers":"91","maleMedian":"598","femaleWorkers":"68","femaleMedian":"506"}}},"Engine and other machine assemblers":{"ageData":{"2014":{"total":"10","16to19":"0","20to24":"0","25to34":"3","35to44":"1","45to54":"2","55to64":"3","65+":"0","medianAge":"3"}},"title":"Engine and other machine assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"9","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Structural metal fabricators and fitters":{"ageData":{"2014":{"total":"24","16to19":"0","20to24":"3","25to34":"6","35to44":"7","45to54":"5","55to64":"3","65+":"0","medianAge":"3"}},"title":"Structural metal fabricators and fitters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"24","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"24","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Miscellaneous assemblers and fabricators":{"ageData":{"2014":{"total":"1,002","16to19":"24","20to24":"123","25to34":"238","35to44":"204","45to54":"204","55to64":"176","65+":"33","medianAge":"176"}},"title":"Miscellaneous assemblers and fabricators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"1,002","women":"37.5","white":"17.0","black":"8.7","asian":"21.0"}},"wageData":{"2014":{"workers":"926","median":"592","maleWorkers":"589","maleMedian":"633","femaleWorkers":"337","femaleMedian":"506"}}},"Bakers":{"ageData":{"2014":{"total":"224","16to19":"8","20to24":"36","25to34":"58","35to44":"32","45to54":"52","55to64":"27","65+":"11","medianAge":"27"}},"title":"Bakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"224","women":"62.8","white":"10.1","black":"7.5","asian":"22.9"}},"wageData":{"2014":{"workers":"148","median":"492","maleWorkers":"64","maleMedian":"518","femaleWorkers":"84","femaleMedian":"469"}}},"Butchers and other meat, poultry, and fish processing workers":{"ageData":{"2014":{"total":"331","16to19":"10","20to24":"50","25to34":"89","35to44":"61","45to54":"69","55to64":"42","65+":"11","medianAge":"42"}},"title":"Butchers and other meat, poultry, and fish processing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"331","women":"23.5","white":"20.2","black":"8.0","asian":"35.4"}},"wageData":{"2014":{"workers":"287","median":"512","maleWorkers":"217","maleMedian":"537","femaleWorkers":"70","femaleMedian":"457"}}},"Food and tobacco roasting, baking, and drying machine operators and tenders":{"ageData":{"2014":{"total":"10","16to19":"0","20to24":"2","25to34":"2","35to44":"3","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Food and tobacco roasting, baking, and drying machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"5","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Food batchmakers":{"ageData":{"2014":{"total":"95","16to19":"3","20to24":"18","25to34":"19","35to44":"20","45to54":"22","55to64":"11","65+":"3","medianAge":"11"}},"title":"Food batchmakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"95","women":"61.5","white":"13.1","black":"6.1","asian":"25.3"}},"wageData":{"2014":{"workers":"82","median":"473","maleWorkers":"38","maleMedian":"-","femaleWorkers":"44","femaleMedian":"-"}}},"Food cooking machine operators and tenders":{"ageData":{"2014":{"total":"16","16to19":"1","20to24":"4","25to34":"3","35to44":"3","45to54":"4","55to64":"2","65+":"0","medianAge":"2"}},"title":"Food cooking machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"16","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"11","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Food processing workers, all other":{"ageData":{"2014":{"total":"128","16to19":"1","20to24":"10","25to34":"30","35to44":"30","45to54":"33","55to64":"20","65+":"4","medianAge":"20"}},"title":"Food processing workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"128","women":"32.0","white":"18.1","black":"7.6","asian":"31.7"}},"wageData":{"2014":{"workers":"110","median":"637","maleWorkers":"80","maleMedian":"651","femaleWorkers":"30","femaleMedian":"-"}}},"Computer control programmers and operators":{"ageData":{"2014":{"total":"71","16to19":"2","20to24":"5","25to34":"19","35to44":"25","45to54":"12","55to64":"9","65+":"1","medianAge":"9"}},"title":"Computer control programmers and operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"71","women":"8.1","white":"2.3","black":"2.2","asian":"14.7"}},"wageData":{"2014":{"workers":"79","median":"759","maleWorkers":"73","maleMedian":"790","femaleWorkers":"6","femaleMedian":"-"}}},"Extruding and drawing machine setters, operators, and tenders, metal and plastic":{"ageData":{"2014":{"total":"14","16to19":"0","20to24":"2","25to34":"1","35to44":"5","45to54":"4","55to64":"2","65+":"0","medianAge":"2"}},"title":"Extruding and drawing machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"13","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Forging machine setters, operators, and tenders, metal and plastic":{"ageData":{"2014":{"total":"5","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"1","55to64":"1","65+":"1","medianAge":"1"}},"title":"Forging machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"5","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Rolling machine setters, operators, and tenders, metal and plastic":{"ageData":{"2014":{"total":"10","16to19":"0","20to24":"0","25to34":"3","35to44":"1","45to54":"3","55to64":"3","65+":"0","medianAge":"3"}},"title":"Rolling machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"9","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Cutting, punching, and press machine setters, operators, and tenders, metal and plastic":{"ageData":{"2014":{"total":"85","16to19":"1","20to24":"11","25to34":"15","35to44":"17","45to54":"22","55to64":"17","65+":"2","medianAge":"17"}},"title":"Cutting, punching, and press machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"85","women":"24.2","white":"14.0","black":"0.9","asian":"15.9"}},"wageData":{"2014":{"workers":"83","median":"620","maleWorkers":"63","maleMedian":"663","femaleWorkers":"20","femaleMedian":"-"}}},"Drilling and boring machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2014":{"total":"2","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Drilling and boring machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Grinding, lapping, polishing, and buffing machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2014":{"total":"45","16to19":"1","20to24":"5","25to34":"6","35to44":"7","45to54":"14","55to64":"9","65+":"3","medianAge":"9"}},"title":"Grinding, lapping, polishing, and buffing machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"45","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"45","median":"-","maleWorkers":"38","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Lathe and turning machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2014":{"total":"9","16to19":"0","20to24":"4","25to34":"2","35to44":"1","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Lathe and turning machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Milling and planing machine setters, operators, and tenders, metal and plastic":{"ageData":{"2014":{"total":"5","16to19":"0","20to24":"0","25to34":"2","35to44":"0","45to54":"2","55to64":"0","65+":"1","medianAge":"0"}},"title":"Milling and planing machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Machinists":{"ageData":{"2014":{"total":"391","16to19":"6","20to24":"33","25to34":"66","35to44":"90","45to54":"99","55to64":"83","65+":"13","medianAge":"83"}},"title":"Machinists","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"391","women":"4.5","white":"3.9","black":"4.1","asian":"15.4"}},"wageData":{"2014":{"workers":"351","median":"764","maleWorkers":"339","maleMedian":"770","femaleWorkers":"12","femaleMedian":"-"}}},"Metal furnace operators, tenders, pourers, and casters":{"ageData":{"2014":{"total":"27","16to19":"0","20to24":"5","25to34":"6","35to44":"6","45to54":"5","55to64":"4","65+":"0","medianAge":"4"}},"title":"Metal furnace operators, tenders, pourers, and casters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"27","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"26","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Model makers and patternmakers, metal and plastic":{"ageData":{"2014":{"total":"5","16to19":"0","20to24":"1","25to34":"1","35to44":"1","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Model makers and patternmakers, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"4","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Molders and molding machine setters, operators, and tenders, metal and plastic":{"ageData":{"2014":{"total":"38","16to19":"1","20to24":"2","25to34":"11","35to44":"10","45to54":"5","55to64":"10","65+":"1","medianAge":"10"}},"title":"Molders and molding machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"38","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"34","median":"-","maleWorkers":"31","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Multiple machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2014":{"total":"4","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Multiple machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"4","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Tool and die makers":{"ageData":{"2014":{"total":"67","16to19":"0","20to24":"1","25to34":"8","35to44":"18","45to54":"15","55to64":"20","65+":"5","medianAge":"20"}},"title":"Tool and die makers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"67","women":"1.3","white":"0.7","black":"0.0","asian":"3.8"}},"wageData":{"2014":{"workers":"60","median":"1,020","maleWorkers":"59","maleMedian":"1,025","femaleWorkers":"1","femaleMedian":"-"}}},"Welding, soldering, and brazing workers":{"ageData":{"2014":{"total":"615","16to19":"14","20to24":"67","25to34":"173","35to44":"142","45to54":"135","55to64":"73","65+":"13","medianAge":"73"}},"title":"Welding, soldering, and brazing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"615","women":"4.8","white":"8.8","black":"2.0","asian":"22.4"}},"wageData":{"2014":{"workers":"551","median":"723","maleWorkers":"526","maleMedian":"733","femaleWorkers":"25","femaleMedian":"-"}}},"Heat treating equipment setters, operators, and tenders, metal and plastic":{"ageData":{"2014":{"total":"4","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Heat treating equipment setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"4","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Layout workers, metal and plastic":{"ageData":{"2014":{"total":"9","16to19":"1","20to24":"1","25to34":"3","35to44":"1","45to54":"0","55to64":"3","65+":"0","medianAge":"3"}},"title":"Layout workers, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"9","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Plating and coating machine setters, operators, and tenders, metal and plastic":{"ageData":{"2014":{"total":"29","16to19":"0","20to24":"1","25to34":"4","35to44":"4","45to54":"16","55to64":"4","65+":"1","medianAge":"4"}},"title":"Plating and coating machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"29","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"24","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Tool grinders, filers, and sharpeners":{"ageData":{"2014":{"total":"10","16to19":"0","20to24":"1","25to34":"1","35to44":"4","45to54":"2","55to64":"2","65+":"1","medianAge":"2"}},"title":"Tool grinders, filers, and sharpeners","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Metal workers and plastic workers, all other":{"ageData":{"2014":{"total":"342","16to19":"6","20to24":"29","25to34":"65","35to44":"68","45to54":"90","55to64":"73","65+":"10","medianAge":"73"}},"title":"Metal workers and plastic workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"342","women":"20.4","white":"13.5","black":"5.9","asian":"23.0"}},"wageData":{"2014":{"workers":"333","median":"624","maleWorkers":"262","maleMedian":"647","femaleWorkers":"71","femaleMedian":"511"}}},"Prepress technicians and workers":{"ageData":{"2014":{"total":"25","16to19":"0","20to24":"2","25to34":"5","35to44":"3","45to54":"7","55to64":"4","65+":"3","medianAge":"4"}},"title":"Prepress technicians and workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"25","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"20","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Printing press operators":{"ageData":{"2014":{"total":"187","16to19":"1","20to24":"18","25to34":"41","35to44":"40","45to54":"52","55to64":"27","65+":"7","medianAge":"27"}},"title":"Printing press operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"187","women":"19.6","white":"13.2","black":"5.7","asian":"21.7"}},"wageData":{"2014":{"workers":"173","median":"646","maleWorkers":"140","maleMedian":"686","femaleWorkers":"32","femaleMedian":"-"}}},"Print binding and finishing workers":{"ageData":{"2014":{"total":"21","16to19":"0","20to24":"1","25to34":"1","35to44":"4","45to54":"5","55to64":"8","65+":"2","medianAge":"8"}},"title":"Print binding and finishing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"21","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"18","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Laundry and dry-cleaning workers":{"ageData":{"2014":{"total":"156","16to19":"4","20to24":"7","25to34":"33","35to44":"29","45to54":"36","55to64":"35","65+":"12","medianAge":"35"}},"title":"Laundry and dry-cleaning workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"156","women":"59.7","white":"16.1","black":"11.5","asian":"38.0"}},"wageData":{"2014":{"workers":"128","median":"417","maleWorkers":"48","maleMedian":"-","femaleWorkers":"80","femaleMedian":"410"}}},"Pressers, textile, garment, and related materials":{"ageData":{"2014":{"total":"48","16to19":"0","20to24":"1","25to34":"16","35to44":"10","45to54":"12","55to64":"5","65+":"3","medianAge":"5"}},"title":"Pressers, textile, garment, and related materials","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"48","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"30","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Sewing machine operators":{"ageData":{"2014":{"total":"158","16to19":"2","20to24":"6","25to34":"18","35to44":"27","45to54":"44","55to64":"48","65+":"13","medianAge":"48"}},"title":"Sewing machine operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"158","women":"81.9","white":"15.0","black":"21.1","asian":"34.6"}},"wageData":{"2014":{"workers":"114","median":"440","maleWorkers":"19","maleMedian":"-","femaleWorkers":"95","femaleMedian":"432"}}},"Shoe and leather workers and repairers":{"ageData":{"2014":{"total":"4","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"1","65+":"1","medianAge":"1"}},"title":"Shoe and leather workers and repairers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Shoe machine operators and tenders":{"ageData":{"2014":{"total":"3","16to19":"1","20to24":"0","25to34":"0","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Shoe machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Tailors, dressmakers, and sewers":{"ageData":{"2014":{"total":"92","16to19":"1","20to24":"1","25to34":"10","35to44":"15","45to54":"27","55to64":"28","65+":"9","medianAge":"28"}},"title":"Tailors, dressmakers, and sewers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"92","women":"80.6","white":"9.5","black":"16.7","asian":"30.4"}},"wageData":{"2014":{"workers":"42","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"31","femaleMedian":"-"}}},"Textile bleaching and dyeing machine operators and tenders":{"ageData":{"2014":{"total":"3","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Textile bleaching and dyeing machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Textile cutting machine setters, operators, and tenders":{"ageData":{"2014":{"total":"6","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"0","55to64":"2","65+":"0","medianAge":"2"}},"title":"Textile cutting machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"8","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Textile knitting and weaving machine setters, operators, and tenders":{"ageData":{"2014":{"total":"12","16to19":"0","20to24":"1","25to34":"2","35to44":"2","45to54":"3","55to64":"2","65+":"2","medianAge":"2"}},"title":"Textile knitting and weaving machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"6","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Textile winding, twisting, and drawing out machine setters, operators, and tenders":{"ageData":{"2014":{"total":"12","16to19":"0","20to24":"1","25to34":"1","35to44":"7","45to54":"2","55to64":"0","65+":"1","medianAge":"0"}},"title":"Textile winding, twisting, and drawing out machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"12","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Extruding and forming machine setters, operators, and tenders, synthetic and glass fibers":{"ageData":{"2014":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Extruding and forming machine setters, operators, and tenders, synthetic and glass fibers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"0","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Fabric and apparel patternmakers":{"ageData":{"2014":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Fabric and apparel patternmakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Upholsterers":{"ageData":{"2014":{"total":"40","16to19":"1","20to24":"4","25to34":"4","35to44":"4","45to54":"17","55to64":"7","65+":"5","medianAge":"7"}},"title":"Upholsterers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"22","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Textile, apparel, and furnishings workers, all other":{"ageData":{"2014":{"total":"14","16to19":"1","20to24":"1","25to34":"1","35to44":"5","45to54":"2","55to64":"4","65+":"0","medianAge":"4"}},"title":"Textile, apparel, and furnishings workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"11","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Cabinetmakers and bench carpenters":{"ageData":{"2014":{"total":"51","16to19":"2","20to24":"2","25to34":"10","35to44":"12","45to54":"14","55to64":"8","65+":"2","medianAge":"8"}},"title":"Cabinetmakers and bench carpenters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"51","women":"9.9","white":"5.6","black":"2.4","asian":"27.8"}},"wageData":{"2014":{"workers":"30","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Furniture finishers":{"ageData":{"2014":{"total":"7","16to19":"1","20to24":"0","25to34":"2","35to44":"0","45to54":"3","55to64":"1","65+":"0","medianAge":"1"}},"title":"Furniture finishers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Model makers and patternmakers, wood":{"ageData":{"2014":{"total":"1","16to19":"0","20to24":"1","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Model makers and patternmakers, wood","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Sawing machine setters, operators, and tenders, wood":{"ageData":{"2014":{"total":"32","16to19":"1","20to24":"2","25to34":"7","35to44":"7","45to54":"4","55to64":"6","65+":"4","medianAge":"6"}},"title":"Sawing machine setters, operators, and tenders, wood","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"32","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"27","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Woodworking machine setters, operators, and tenders, except sawing":{"ageData":{"2014":{"total":"19","16to19":"1","20to24":"1","25to34":"5","35to44":"6","45to54":"5","55to64":"1","65+":"0","medianAge":"1"}},"title":"Woodworking machine setters, operators, and tenders, except sawing","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"19","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Woodworkers, all other":{"ageData":{"2014":{"total":"28","16to19":"0","20to24":"2","25to34":"2","35to44":"4","45to54":"9","55to64":"7","65+":"4","medianAge":"7"}},"title":"Woodworkers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"28","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"16","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Power plant operators, distributors, and dispatchers":{"ageData":{"2014":{"total":"45","16to19":"0","20to24":"1","25to34":"14","35to44":"10","45to54":"10","55to64":"10","65+":"1","medianAge":"10"}},"title":"Power plant operators, distributors, and dispatchers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"45","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"47","median":"-","maleWorkers":"43","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Stationary engineers and boiler operators":{"ageData":{"2014":{"total":"96","16to19":"0","20to24":"3","25to34":"12","35to44":"21","45to54":"30","55to64":"27","65+":"4","medianAge":"27"}},"title":"Stationary engineers and boiler operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"96","women":"2.0","white":"7.0","black":"4.3","asian":"15.2"}},"wageData":{"2014":{"workers":"93","median":"1,044","maleWorkers":"92","maleMedian":"1,051","femaleWorkers":"2","femaleMedian":"-"}}},"Water and wastewater treatment plant and system operators":{"ageData":{"2014":{"total":"72","16to19":"0","20to24":"2","25to34":"11","35to44":"14","45to54":"24","55to64":"19","65+":"2","medianAge":"19"}},"title":"Water and wastewater treatment plant and system operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"72","women":"4.5","white":"10.7","black":"2.3","asian":"14.7"}},"wageData":{"2014":{"workers":"69","median":"833","maleWorkers":"66","maleMedian":"835","femaleWorkers":"3","femaleMedian":"-"}}},"Miscellaneous plant and system operators":{"ageData":{"2014":{"total":"41","16to19":"0","20to24":"2","25to34":"13","35to44":"10","45to54":"5","55to64":"11","65+":"0","medianAge":"11"}},"title":"Miscellaneous plant and system operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"41","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"39","median":"-","maleWorkers":"36","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Chemical processing machine setters, operators, and tenders":{"ageData":{"2014":{"total":"63","16to19":"0","20to24":"4","25to34":"18","35to44":"15","45to54":"17","55to64":"7","65+":"1","medianAge":"7"}},"title":"Chemical processing machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"63","women":"5.8","white":"10.7","black":"0.5","asian":"10.3"}},"wageData":{"2014":{"workers":"55","median":"818","maleWorkers":"53","maleMedian":"831","femaleWorkers":"2","femaleMedian":"-"}}},"Crushing, grinding, polishing, mixing, and blending workers":{"ageData":{"2014":{"total":"69","16to19":"1","20to24":"8","25to34":"15","35to44":"15","45to54":"17","55to64":"12","65+":"1","medianAge":"12"}},"title":"Crushing, grinding, polishing, mixing, and blending workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"69","women":"11.7","white":"14.1","black":"3.5","asian":"22.4"}},"wageData":{"2014":{"workers":"67","median":"686","maleWorkers":"60","maleMedian":"694","femaleWorkers":"7","femaleMedian":"-"}}},"Cutting workers":{"ageData":{"2014":{"total":"60","16to19":"2","20to24":"9","25to34":"7","35to44":"17","45to54":"15","55to64":"9","65+":"2","medianAge":"9"}},"title":"Cutting workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"60","women":"21.9","white":"10.3","black":"4.7","asian":"22.0"}},"wageData":{"2014":{"workers":"43","median":"-","maleWorkers":"36","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Extruding, forming, pressing, and compacting machine setters, operators, and tenders":{"ageData":{"2014":{"total":"40","16to19":"1","20to24":"5","25to34":"6","35to44":"13","45to54":"7","55to64":"7","65+":"1","medianAge":"7"}},"title":"Extruding, forming, pressing, and compacting machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"39","median":"-","maleWorkers":"29","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Furnace, kiln, oven, drier, and kettle operators and tenders":{"ageData":{"2014":{"total":"9","16to19":"0","20to24":"0","25to34":"4","35to44":"1","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Furnace, kiln, oven, drier, and kettle operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"11","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Inspectors, testers, sorters, samplers, and weighers":{"ageData":{"2014":{"total":"752","16to19":"6","20to24":"63","25to34":"181","35to44":"153","45to54":"171","55to64":"146","65+":"31","medianAge":"146"}},"title":"Inspectors, testers, sorters, samplers, and weighers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"752","women":"35.1","white":"12.7","black":"6.8","asian":"16.8"}},"wageData":{"2014":{"workers":"675","median":"728","maleWorkers":"443","maleMedian":"820","femaleWorkers":"231","femaleMedian":"578"}}},"Jewelers and precious stone and metal workers":{"ageData":{"2014":{"total":"44","16to19":"0","20to24":"2","25to34":"7","35to44":"8","45to54":"12","55to64":"13","65+":"2","medianAge":"13"}},"title":"Jewelers and precious stone and metal workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"44","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"24","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Medical, dental, and ophthalmic laboratory technicians":{"ageData":{"2014":{"total":"85","16to19":"1","20to24":"8","25to34":"15","35to44":"22","45to54":"14","55to64":"20","65+":"6","medianAge":"20"}},"title":"Medical, dental, and ophthalmic laboratory technicians","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"85","women":"52.3","white":"3.0","black":"14.3","asian":"12.3"}},"wageData":{"2014":{"workers":"71","median":"626","maleWorkers":"29","maleMedian":"-","femaleWorkers":"43","femaleMedian":"-"}}},"Packaging and filling machine operators and tenders":{"ageData":{"2014":{"total":"259","16to19":"6","20to24":"31","25to34":"47","35to44":"64","45to54":"62","55to64":"41","65+":"8","medianAge":"41"}},"title":"Packaging and filling machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"259","women":"56.2","white":"19.0","black":"8.9","asian":"36.0"}},"wageData":{"2014":{"workers":"239","median":"490","maleWorkers":"106","maleMedian":"522","femaleWorkers":"133","femaleMedian":"477"}}},"Painting workers":{"ageData":{"2014":{"total":"156","16to19":"4","20to24":"15","25to34":"38","35to44":"40","45to54":"33","55to64":"23","65+":"3","medianAge":"23"}},"title":"Painting workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"156","women":"12.7","white":"8.1","black":"4.3","asian":"27.0"}},"wageData":{"2014":{"workers":"132","median":"694","maleWorkers":"120","maleMedian":"703","femaleWorkers":"12","femaleMedian":"-"}}},"Photographic process workers and processing machine operators":{"ageData":{"2014":{"total":"27","16to19":"0","20to24":"6","25to34":"8","35to44":"4","45to54":"5","55to64":"4","65+":"0","medianAge":"4"}},"title":"Photographic process workers and processing machine operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"27","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"21","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Semiconductor processors":{"ageData":{"2014":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Semiconductor processors","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Adhesive bonding machine operators and tenders":{"ageData":{"2014":{"total":"6","16to19":"0","20to24":"1","25to34":"0","35to44":"2","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Adhesive bonding machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"5","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Cleaning, washing, and metal pickling equipment operators and tenders":{"ageData":{"2014":{"total":"6","16to19":"0","20to24":"1","25to34":"0","35to44":"3","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Cleaning, washing, and metal pickling equipment operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"5","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Cooling and freezing equipment operators and tenders":{"ageData":{"2014":{"total":"4","16to19":"0","20to24":"0","25to34":"3","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Cooling and freezing equipment operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Etchers and engravers":{"ageData":{"2014":{"total":"13","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"5","55to64":"4","65+":"0","medianAge":"4"}},"title":"Etchers and engravers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"9","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Molders, shapers, and casters, except metal and plastic":{"ageData":{"2014":{"total":"31","16to19":"0","20to24":"2","25to34":"6","35to44":"7","45to54":"7","55to64":"7","65+":"2","medianAge":"7"}},"title":"Molders, shapers, and casters, except metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"31","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"21","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Paper goods machine setters, operators, and tenders":{"ageData":{"2014":{"total":"31","16to19":"0","20to24":"0","25to34":"9","35to44":"9","45to54":"6","55to64":"5","65+":"2","medianAge":"5"}},"title":"Paper goods machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"31","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"29","median":"-","maleWorkers":"27","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Tire builders":{"ageData":{"2014":{"total":"12","16to19":"0","20to24":"1","25to34":"2","35to44":"6","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Tire builders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"11","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers--production workers":{"ageData":{"2014":{"total":"54","16to19":"5","20to24":"8","25to34":"17","35to44":"8","45to54":"7","55to64":"8","65+":"1","medianAge":"8"}},"title":"Helpers--production workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"54","women":"25.1","white":"10.9","black":"9.6","asian":"32.9"}},"wageData":{"2014":{"workers":"42","median":"-","maleWorkers":"31","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Production workers, all other":{"ageData":{"2014":{"total":"947","16to19":"21","20to24":"106","25to34":"198","35to44":"215","45to54":"223","55to64":"146","65+":"40","medianAge":"146"}},"title":"Production workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2014":{"total":"947","women":"24.7","white":"15.1","black":"5.5","asian":"23.1"}},"wageData":{"2014":{"workers":"850","median":"621","maleWorkers":"659","maleMedian":"676","femaleWorkers":"191","femaleMedian":"492"}}},"Transportation and material moving occupations":{"ageData":{"2014":{"total":"9,010","16to19":"337","20to24":"877","25to34":"1,700","35to44":"1,841","45to54":"2,149","55to64":"1,582","65+":"523","medianAge":"1,582"}},"title":"Transportation and material moving occupations","depth":2,"parent":"Production, transportation, and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"9,010","women":"15.7","white":"17.3","black":"3.4","asian":"22.1"}},"wageData":{"2014":{"workers":"6,845","median":"637","maleWorkers":"5,927","maleMedian":"664","femaleWorkers":"918","femaleMedian":"510"}}},"Supervisors of transportation and material moving workers":{"ageData":{"2014":{"total":"199","16to19":"1","20to24":"10","25to34":"45","35to44":"39","45to54":"61","55to64":"36","65+":"8","medianAge":"36"}},"title":"Supervisors of transportation and material moving workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"199","women":"18.3","white":"9.0","black":"2.0","asian":"22.1"}},"wageData":{"2014":{"workers":"181","median":"829","maleWorkers":"148","maleMedian":"925","femaleWorkers":"33","femaleMedian":"-"}}},"Aircraft pilots and flight engineers":{"ageData":{"2014":{"total":"133","16to19":"0","20to24":"3","25to34":"17","35to44":"39","45to54":"41","55to64":"28","65+":"6","medianAge":"28"}},"title":"Aircraft pilots and flight engineers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"133","women":"7.2","white":"1.9","black":"0.5","asian":"2.7"}},"wageData":{"2014":{"workers":"113","median":"1,427","maleWorkers":"106","maleMedian":"1,446","femaleWorkers":"7","femaleMedian":"-"}}},"Air traffic controllers and airfield operations specialists":{"ageData":{"2014":{"total":"31","16to19":"0","20to24":"0","25to34":"10","35to44":"5","45to54":"11","55to64":"4","65+":"1","medianAge":"4"}},"title":"Air traffic controllers and airfield operations specialists","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"31","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"31","median":"-","maleWorkers":"27","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Flight attendants":{"ageData":{"2014":{"total":"92","16to19":"0","20to24":"6","25to34":"10","35to44":"19","45to54":"33","55to64":"21","65+":"3","medianAge":"21"}},"title":"Flight attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"92","women":"75.8","white":"10.2","black":"2.5","asian":"7.9"}},"wageData":{"2014":{"workers":"65","median":"857","maleWorkers":"17","maleMedian":"-","femaleWorkers":"48","femaleMedian":"-"}}},"Ambulance drivers and attendants, except emergency medical technicians":{"ageData":{"2014":{"total":"19","16to19":"0","20to24":"1","25to34":"5","35to44":"2","45to54":"5","55to64":"4","65+":"2","medianAge":"4"}},"title":"Ambulance drivers and attendants, except emergency medical technicians","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"15","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Bus drivers":{"ageData":{"2014":{"total":"584","16to19":"1","20to24":"11","25to34":"56","35to44":"98","45to54":"159","55to64":"165","65+":"95","medianAge":"165"}},"title":"Bus drivers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"584","women":"45.0","white":"25.9","black":"2.5","asian":"12.8"}},"wageData":{"2014":{"workers":"327","median":"602","maleWorkers":"191","maleMedian":"616","femaleWorkers":"136","femaleMedian":"582"}}},"Driver/sales workers and truck drivers":{"ageData":{"2014":{"total":"3,406","16to19":"53","20to24":"193","25to34":"559","35to44":"772","45to54":"933","55to64":"684","65+":"211","medianAge":"684"}},"title":"Driver/sales workers and truck drivers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"3,406","women":"5.8","white":"15.6","black":"2.5","asian":"20.5"}},"wageData":{"2014":{"workers":"2,658","median":"732","maleWorkers":"2,555","maleMedian":"739","femaleWorkers":"103","femaleMedian":"545"}}},"Taxi drivers and chauffeurs":{"ageData":{"2014":{"total":"383","16to19":"0","20to24":"10","25to34":"69","35to44":"78","45to54":"91","55to64":"88","65+":"47","medianAge":"88"}},"title":"Taxi drivers and chauffeurs","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"383","women":"12.7","white":"28.8","black":"13.9","asian":"16.5"}},"wageData":{"2014":{"workers":"250","median":"608","maleWorkers":"221","maleMedian":"609","femaleWorkers":"29","femaleMedian":"-"}}},"Motor vehicle operators, all other":{"ageData":{"2014":{"total":"61","16to19":"0","20to24":"4","25to34":"5","35to44":"8","45to54":"15","55to64":"8","65+":"21","medianAge":"8"}},"title":"Motor vehicle operators, all other","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"61","women":"8.9","white":"16.1","black":"2.3","asian":"16.1"}},"wageData":{"2014":{"workers":"26","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Locomotive engineers and operators":{"ageData":{"2014":{"total":"55","16to19":"0","20to24":"2","25to34":"7","35to44":"22","45to54":"13","55to64":"11","65+":"1","medianAge":"11"}},"title":"Locomotive engineers and operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"55","women":"1.4","white":"14.0","black":"0.0","asian":"5.6"}},"wageData":{"2014":{"workers":"56","median":"1,187","maleWorkers":"55","maleMedian":"1,197","femaleWorkers":"2","femaleMedian":"-"}}},"Railroad brake, signal, and switch operators":{"ageData":{"2014":{"total":"9","16to19":"0","20to24":"0","25to34":"1","35to44":"2","45to54":"3","55to64":"4","65+":"0","medianAge":"4"}},"title":"Railroad brake, signal, and switch operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"8","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Railroad conductors and yardmasters":{"ageData":{"2014":{"total":"46","16to19":"0","20to24":"3","25to34":"13","35to44":"12","45to54":"13","55to64":"5","65+":"1","medianAge":"5"}},"title":"Railroad conductors and yardmasters","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"46","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"48","median":"-","maleWorkers":"44","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Subway, streetcar, and other rail transportation workers":{"ageData":{"2014":{"total":"19","16to19":"0","20to24":"2","25to34":"5","35to44":"6","45to54":"3","55to64":"2","65+":"2","medianAge":"2"}},"title":"Subway, streetcar, and other rail transportation workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"16","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Sailors and marine oilers":{"ageData":{"2014":{"total":"27","16to19":"2","20to24":"9","25to34":"4","35to44":"4","45to54":"3","55to64":"4","65+":"1","medianAge":"4"}},"title":"Sailors and marine oilers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"27","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"21","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Ship and boat captains and operators":{"ageData":{"2014":{"total":"41","16to19":"0","20to24":"2","25to34":"7","35to44":"10","45to54":"14","55to64":"7","65+":"2","medianAge":"7"}},"title":"Ship and boat captains and operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"41","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"38","median":"-","maleWorkers":"38","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Ship engineers":{"ageData":{"2014":{"total":"7","16to19":"0","20to24":"0","25to34":"1","35to44":"3","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Ship engineers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Bridge and lock tenders":{"ageData":{"2014":{"total":"6","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"4","65+":"0","medianAge":"4"}},"title":"Bridge and lock tenders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Parking lot attendants":{"ageData":{"2014":{"total":"78","16to19":"4","20to24":"24","25to34":"17","35to44":"9","45to54":"10","55to64":"11","65+":"3","medianAge":"11"}},"title":"Parking lot attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"78","women":"10.5","white":"26.3","black":"9.9","asian":"28.7"}},"wageData":{"2014":{"workers":"60","median":"440","maleWorkers":"55","maleMedian":"441","femaleWorkers":"5","femaleMedian":"-"}}},"Automotive and watercraft service attendants":{"ageData":{"2014":{"total":"97","16to19":"5","20to24":"30","25to34":"24","35to44":"18","45to54":"9","55to64":"10","65+":"1","medianAge":"10"}},"title":"Automotive and watercraft service attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"97","women":"7.5","white":"13.7","black":"15.7","asian":"21.9"}},"wageData":{"2014":{"workers":"77","median":"512","maleWorkers":"72","maleMedian":"518","femaleWorkers":"4","femaleMedian":"-"}}},"Transportation inspectors":{"ageData":{"2014":{"total":"47","16to19":"0","20to24":"4","25to34":"7","35to44":"13","45to54":"13","55to64":"9","65+":"3","medianAge":"9"}},"title":"Transportation inspectors","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"47","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"53","median":"909","maleWorkers":"41","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Transportation attendants, except flight attendants":{"ageData":{"2014":{"total":"27","16to19":"0","20to24":"4","25to34":"4","35to44":"3","45to54":"5","55to64":"7","65+":"4","medianAge":"7"}},"title":"Transportation attendants, except flight attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"27","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"24","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Other transportation workers":{"ageData":{"2014":{"total":"25","16to19":"0","20to24":"4","25to34":"6","35to44":"6","45to54":"6","55to64":"2","65+":"2","medianAge":"2"}},"title":"Other transportation workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"25","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"21","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Conveyor operators and tenders":{"ageData":{"2014":{"total":"6","16to19":"0","20to24":"1","25to34":"0","35to44":"1","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Conveyor operators and tenders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"7","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Crane and tower operators":{"ageData":{"2014":{"total":"74","16to19":"0","20to24":"3","25to34":"19","35to44":"19","45to54":"18","55to64":"13","65+":"2","medianAge":"13"}},"title":"Crane and tower operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"74","women":"0.2","white":"8.4","black":"1.0","asian":"11.2"}},"wageData":{"2014":{"workers":"73","median":"959","maleWorkers":"73","maleMedian":"959","femaleWorkers":"0","femaleMedian":"-"}}},"Dredge, excavating, and loading machine operators":{"ageData":{"2014":{"total":"44","16to19":"1","20to24":"5","25to34":"8","35to44":"6","45to54":"13","55to64":"7","65+":"4","medianAge":"7"}},"title":"Dredge, excavating, and loading machine operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"44","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"30","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Hoist and winch operators":{"ageData":{"2014":{"total":"7","16to19":"0","20to24":"2","25to34":"1","35to44":"1","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Hoist and winch operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"6","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Industrial truck and tractor operators":{"ageData":{"2014":{"total":"564","16to19":"6","20to24":"52","25to34":"143","35to44":"130","45to54":"140","55to64":"80","65+":"12","medianAge":"80"}},"title":"Industrial truck and tractor operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"564","women":"7.4","white":"24.4","black":"2.2","asian":"29.3"}},"wageData":{"2014":{"workers":"534","median":"594","maleWorkers":"497","maleMedian":"595","femaleWorkers":"38","femaleMedian":"-"}}},"Cleaners of vehicles and equipment":{"ageData":{"2014":{"total":"375","16to19":"50","20to24":"83","25to34":"85","35to44":"58","45to54":"53","55to64":"35","65+":"12","medianAge":"35"}},"title":"Cleaners of vehicles and equipment","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"375","women":"12.4","white":"22.5","black":"1.9","asian":"33.4"}},"wageData":{"2014":{"workers":"255","median":"482","maleWorkers":"221","maleMedian":"480","femaleWorkers":"34","femaleMedian":"-"}}},"Laborers and freight, stock, and material movers, hand":{"ageData":{"2014":{"total":"1,867","16to19":"154","20to24":"324","25to34":"430","35to44":"335","45to54":"330","55to64":"238","65+":"55","medianAge":"238"}},"title":"Laborers and freight, stock, and material movers, hand","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"1,867","women":"18.3","white":"15.6","black":"3.2","asian":"23.8"}},"wageData":{"2014":{"workers":"1,358","median":"533","maleWorkers":"1,138","maleMedian":"546","femaleWorkers":"221","femaleMedian":"476"}}},"Machine feeders and offbearers":{"ageData":{"2014":{"total":"17","16to19":"0","20to24":"3","25to34":"3","35to44":"5","45to54":"1","55to64":"4","65+":"0","medianAge":"4"}},"title":"Machine feeders and offbearers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"17","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"14","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Packers and packagers, hand":{"ageData":{"2014":{"total":"505","16to19":"57","20to24":"72","25to34":"100","35to44":"94","45to54":"110","55to64":"57","65+":"16","medianAge":"57"}},"title":"Packers and packagers, hand","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"505","women":"53.8","white":"18.2","black":"5.9","asian":"43.3"}},"wageData":{"2014":{"workers":"347","median":"413","maleWorkers":"140","maleMedian":"459","femaleWorkers":"207","femaleMedian":"395"}}},"Pumping station operators":{"ageData":{"2014":{"total":"27","16to19":"0","20to24":"2","25to34":"9","35to44":"1","45to54":"8","55to64":"5","65+":"1","medianAge":"5"}},"title":"Pumping station operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"27","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"21","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Refuse and recyclable material collectors":{"ageData":{"2014":{"total":"84","16to19":"2","20to24":"8","25to34":"20","35to44":"17","45to54":"21","55to64":"10","65+":"5","medianAge":"10"}},"title":"Refuse and recyclable material collectors","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"84","women":"8.6","white":"19.0","black":"0.8","asian":"36.8"}},"wageData":{"2014":{"workers":"54","median":"550","maleWorkers":"51","maleMedian":"564","femaleWorkers":"3","femaleMedian":"-"}}},"Mine shuttle car operators":{"ageData":{"2014":{"total":"1","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Mine shuttle car operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Tank car, truck, and ship loaders":{"ageData":{"2014":{"total":"6","16to19":"0","20to24":"0","25to34":"3","35to44":"0","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Tank car, truck, and ship loaders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Material moving workers, all other":{"ageData":{"2014":{"total":"41","16to19":"1","20to24":"2","25to34":"8","35to44":"8","45to54":"8","55to64":"14","65+":"1","medianAge":"14"}},"title":"Material moving workers, all other","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2014":{"total":"41","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2014":{"workers":"39","median":"-","maleWorkers":"36","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}}}');


var $ef9839ab9dc2d130$exports = {};
$ef9839ab9dc2d130$exports = JSON.parse('{"Total":{"ageData":{"2013":{"total":"143,929","16to19":"4,458","20to24":"13,599","25to34":"31,242","35to44":"30,650","45to54":"32,523","55to64":"23,776","65+":"7,681","medianAge":"23,776"}},"title":"Total","depth":1,"parent":"","sexRaceEthnicityData":{"2013":{"total":"143,929","women":"47.0","white":"11.2","black":"5.7","asian":"15.6"}},"wageData":{"2013":{"workers":"104,262","median":"$776","maleWorkers":"57,994","maleMedian":"$860","femaleWorkers":"46,268","femaleMedian":"$706"}}},"Management, professional, and related occupations":{"ageData":{"2013":{"total":"54,712","16to19":"326","20to24":"2,777","25to34":"12,084","35to44":"12,993","45to54":"13,206","55to64":"10,055","65+":"3,271","medianAge":"10,055"}},"title":"Management, professional, and related occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2013":{"total":"54,712","women":"51.4","white":"8.5","black":"7.4","asian":"8.3"}},"wageData":{"2013":{"workers":"41,820","median":"1,132","maleWorkers":"20,290","maleMedian":"1,349","femaleWorkers":"21,530","femaleMedian":"973"}}},"Management, business, and financial operations occupations":{"ageData":{"2013":{"total":"22,794","16to19":"71","20to24":"840","25to34":"4,321","35to44":"5,342","45to54":"6,117","55to64":"4,544","65+":"1,558","medianAge":"4,544"}},"title":"Management, business, and financial operations occupations","depth":2,"parent":"Management, professional, and related occupations","sexRaceEthnicityData":{"2013":{"total":"22,794","women":"43.4","white":"7.4","black":"6.1","asian":"8.4"}},"wageData":{"2013":{"workers":"17,137","median":"1,208","maleWorkers":"9,200","maleMedian":"1,412","femaleWorkers":"7,937","femaleMedian":"1,049"}}},"Management occupations":{"ageData":{"2013":{"total":"16,037","16to19":"51","20to24":"463","25to34":"2,702","35to44":"3,762","45to54":"4,501","55to64":"3,378","65+":"1,180","medianAge":"3,378"}},"title":"Management occupations","depth":3,"parent":"Management, business, and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"16,037","women":"38.2","white":"6.5","black":"5.4","asian":"8.5"}},"wageData":{"2013":{"workers":"11,501","median":"1,285","maleWorkers":"6,764","maleMedian":"1,456","femaleWorkers":"4,737","femaleMedian":"1,103"}}},"Chief executives":{"ageData":{"2013":{"total":"1,520","16to19":"0","20to24":"9","25to34":"107","35to44":"312","45to54":"505","55to64":"420","65+":"167","medianAge":"420"}},"title":"Chief executives","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"1,520","women":"26.8","white":"2.9","black":"4.8","asian":"4.3"}},"wageData":{"2013":{"workers":"1,051","median":"2,069","maleWorkers":"764","maleMedian":"2,266","femaleWorkers":"286","femaleMedian":"1,811"}}},"General and operations managers":{"ageData":{"2013":{"total":"1,075","16to19":"0","20to24":"22","25to34":"202","35to44":"283","45to54":"337","55to64":"187","65+":"44","medianAge":"187"}},"title":"General and operations managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"1,075","women":"28.1","white":"5.1","black":"5.0","asian":"8.7"}},"wageData":{"2013":{"workers":"947","median":"1,370","maleWorkers":"698","maleMedian":"1,444","femaleWorkers":"250","femaleMedian":"1,161"}}},"Legislators":{"ageData":{"2013":{"total":"13","16to19":"0","20to24":"1","25to34":"1","35to44":"1","45to54":"5","55to64":"2","65+":"3","medianAge":"2"}},"title":"Legislators","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"10","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Advertising and promotions managers":{"ageData":{"2013":{"total":"51","16to19":"0","20to24":"4","25to34":"17","35to44":"11","45to54":"8","55to64":"9","65+":"1","medianAge":"9"}},"title":"Advertising and promotions managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"51","women":"67.8","white":"0.1","black":"3.5","asian":"16.1"}},"wageData":{"2013":{"workers":"53","median":"1,526","maleWorkers":"18","maleMedian":"-","femaleWorkers":"35","femaleMedian":"-"}}},"Marketing and sales managers":{"ageData":{"2013":{"total":"907","16to19":"5","20to24":"30","25to34":"225","35to44":"249","45to54":"241","55to64":"133","65+":"24","medianAge":"133"}},"title":"Marketing and sales managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"907","women":"43.1","white":"5.0","black":"4.7","asian":"6.6"}},"wageData":{"2013":{"workers":"829","median":"1,389","maleWorkers":"476","maleMedian":"1,658","femaleWorkers":"353","femaleMedian":"1,124"}}},"Public relations and fundraising managers":{"ageData":{"2013":{"total":"55","16to19":"0","20to24":"2","25to34":"23","35to44":"9","45to54":"13","55to64":"6","65+":"1","medianAge":"6"}},"title":"Public relations and fundraising managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"55","women":"61.1","white":"3.6","black":"6.5","asian":"13.8"}},"wageData":{"2013":{"workers":"51","median":"1,159","maleWorkers":"21","maleMedian":"-","femaleWorkers":"29","femaleMedian":"-"}}},"Administrative services managers":{"ageData":{"2013":{"total":"113","16to19":"0","20to24":"3","25to34":"10","35to44":"29","45to54":"32","55to64":"31","65+":"8","medianAge":"31"}},"title":"Administrative services managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"113","women":"36.8","white":"9.4","black":"2.6","asian":"8.2"}},"wageData":{"2013":{"workers":"109","median":"1,198","maleWorkers":"71","maleMedian":"1,232","femaleWorkers":"38","femaleMedian":"-"}}},"Computer and information systems managers":{"ageData":{"2013":{"total":"602","16to19":"0","20to24":"12","25to34":"108","35to44":"199","45to54":"182","55to64":"90","65+":"12","medianAge":"90"}},"title":"Computer and information systems managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"602","women":"28.6","white":"5.0","black":"14.1","asian":"4.3"}},"wageData":{"2013":{"workers":"570","median":"1,728","maleWorkers":"407","maleMedian":"1,769","femaleWorkers":"163","femaleMedian":"1,549"}}},"Financial managers":{"ageData":{"2013":{"total":"1,218","16to19":"4","20to24":"41","25to34":"299","35to44":"296","45to54":"328","55to64":"208","65+":"41","medianAge":"208"}},"title":"Financial managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"1,218","women":"55.3","white":"8.8","black":"6.8","asian":"10.5"}},"wageData":{"2013":{"workers":"1,127","median":"1,236","maleWorkers":"514","maleMedian":"1,518","femaleWorkers":"613","femaleMedian":"1,064"}}},"Compensation and benefits managers":{"ageData":{"2013":{"total":"12","16to19":"0","20to24":"0","25to34":"0","35to44":"3","45to54":"6","55to64":"3","65+":"0","medianAge":"3"}},"title":"Compensation and benefits managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"11","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Human resources managers":{"ageData":{"2013":{"total":"219","16to19":"0","20to24":"6","25to34":"42","35to44":"66","45to54":"61","55to64":"37","65+":"7","medianAge":"37"}},"title":"Human resources managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"219","women":"71.9","white":"12.0","black":"4.2","asian":"11.6"}},"wageData":{"2013":{"workers":"211","median":"1,327","maleWorkers":"60","maleMedian":"1,536","femaleWorkers":"152","femaleMedian":"1,240"}}},"Training and development managers":{"ageData":{"2013":{"total":"34","16to19":"0","20to24":"4","25to34":"6","35to44":"10","45to54":"8","55to64":"5","65+":"1","medianAge":"5"}},"title":"Training and development managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"34","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"33","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Industrial production managers":{"ageData":{"2013":{"total":"256","16to19":"0","20to24":"5","25to34":"37","35to44":"70","45to54":"82","55to64":"56","65+":"7","medianAge":"56"}},"title":"Industrial production managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"256","women":"16.8","white":"4.4","black":"3.0","asian":"10.4"}},"wageData":{"2013":{"workers":"256","median":"1,338","maleWorkers":"215","maleMedian":"1,352","femaleWorkers":"41","femaleMedian":"-"}}},"Purchasing managers":{"ageData":{"2013":{"total":"184","16to19":"0","20to24":"3","25to34":"33","35to44":"47","45to54":"50","55to64":"42","65+":"9","medianAge":"42"}},"title":"Purchasing managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"184","women":"47.8","white":"10.9","black":"7.0","asian":"6.5"}},"wageData":{"2013":{"workers":"181","median":"1,358","maleWorkers":"92","maleMedian":"1,441","femaleWorkers":"89","femaleMedian":"1,290"}}},"Transportation, storage, and distribution managers":{"ageData":{"2013":{"total":"264","16to19":"1","20to24":"8","25to34":"53","35to44":"62","45to54":"88","55to64":"46","65+":"7","medianAge":"46"}},"title":"Transportation, storage, and distribution managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"264","women":"22.5","white":"9.6","black":"4.7","asian":"13.7"}},"wageData":{"2013":{"workers":"252","median":"1,005","maleWorkers":"194","maleMedian":"1,029","femaleWorkers":"58","femaleMedian":"920"}}},"Farmers, ranchers, and other agricultural managers":{"ageData":{"2013":{"total":"929","16to19":"8","20to24":"27","25to34":"95","35to44":"111","45to54":"177","55to64":"242","65+":"270","medianAge":"242"}},"title":"Farmers, ranchers, and other agricultural managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"929","women":"25.3","white":"0.7","black":"1.5","asian":"3.4"}},"wageData":{"2013":{"workers":"97","median":"731","maleWorkers":"78","maleMedian":"716","femaleWorkers":"19","femaleMedian":"-"}}},"Construction managers":{"ageData":{"2013":{"total":"821","16to19":"1","20to24":"20","25to34":"151","35to44":"191","45to54":"224","55to64":"184","65+":"50","medianAge":"184"}},"title":"Construction managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"821","women":"7.3","white":"3.1","black":"2.5","asian":"10.1"}},"wageData":{"2013":{"workers":"414","median":"1,275","maleWorkers":"376","maleMedian":"1,328","femaleWorkers":"38","femaleMedian":"-"}}},"Education administrators":{"ageData":{"2013":{"total":"804","16to19":"0","20to24":"17","25to34":"112","35to44":"197","45to54":"233","55to64":"200","65+":"45","medianAge":"200"}},"title":"Education administrators","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"804","women":"63.8","white":"13.4","black":"2.6","asian":"6.8"}},"wageData":{"2013":{"workers":"698","median":"1,259","maleWorkers":"248","maleMedian":"1,543","femaleWorkers":"450","femaleMedian":"1,130"}}},"Architectural and engineering managers":{"ageData":{"2013":{"total":"121","16to19":"0","20to24":"0","25to34":"12","35to44":"32","45to54":"48","55to64":"26","65+":"3","medianAge":"26"}},"title":"Architectural and engineering managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"121","women":"10.7","white":"3.2","black":"6.2","asian":"5.5"}},"wageData":{"2013":{"workers":"117","median":"1,894","maleWorkers":"104","maleMedian":"1,898","femaleWorkers":"13","femaleMedian":"-"}}},"Food service managers":{"ageData":{"2013":{"total":"1,077","16to19":"22","20to24":"127","25to34":"269","35to44":"249","45to54":"224","55to64":"146","65+":"40","medianAge":"146"}},"title":"Food service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"1,077","women":"45.3","white":"8.6","black":"11.5","asian":"14.6"}},"wageData":{"2013":{"workers":"716","median":"701","maleWorkers":"381","maleMedian":"801","femaleWorkers":"335","femaleMedian":"620"}}},"Funeral service managers":{"ageData":{"2013":{"total":"12","16to19":"0","20to24":"0","25to34":"2","35to44":"0","45to54":"4","55to64":"3","65+":"3","medianAge":"3"}},"title":"Funeral service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"4","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Gaming managers":{"ageData":{"2013":{"total":"17","16to19":"0","20to24":"2","25to34":"3","35to44":"6","45to54":"3","55to64":"2","65+":"1","medianAge":"2"}},"title":"Gaming managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"17","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"16","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Lodging managers":{"ageData":{"2013":{"total":"143","16to19":"0","20to24":"4","25to34":"26","35to44":"33","45to54":"29","55to64":"31","65+":"20","medianAge":"31"}},"title":"Lodging managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"143","women":"52.5","white":"9.7","black":"16.9","asian":"6.8"}},"wageData":{"2013":{"workers":"98","median":"901","maleWorkers":"45","maleMedian":"-","femaleWorkers":"53","femaleMedian":"858"}}},"Medical and health services managers":{"ageData":{"2013":{"total":"585","16to19":"1","20to24":"13","25to34":"83","35to44":"147","45to54":"162","55to64":"145","65+":"34","medianAge":"145"}},"title":"Medical and health services managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"585","women":"69.7","white":"10.6","black":"4.7","asian":"9.6"}},"wageData":{"2013":{"workers":"529","median":"1,258","maleWorkers":"154","maleMedian":"1,412","femaleWorkers":"375","femaleMedian":"1,224"}}},"Natural sciences managers":{"ageData":{"2013":{"total":"14","16to19":"0","20to24":"0","25to34":"2","35to44":"3","45to54":"5","55to64":"3","65+":"1","medianAge":"3"}},"title":"Natural sciences managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"12","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Postmasters and mail superintendents":{"ageData":{"2013":{"total":"31","16to19":"0","20to24":"1","25to34":"3","35to44":"5","45to54":"10","55to64":"10","65+":"1","medianAge":"10"}},"title":"Postmasters and mail superintendents","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"31","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"30","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Property, real estate, and community association managers":{"ageData":{"2013":{"total":"654","16to19":"0","20to24":"15","25to34":"96","35to44":"128","45to54":"172","55to64":"154","65+":"90","medianAge":"154"}},"title":"Property, real estate, and community association managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"654","women":"47.6","white":"8.1","black":"4.5","asian":"11.0"}},"wageData":{"2013":{"workers":"358","median":"862","maleWorkers":"161","maleMedian":"1,068","femaleWorkers":"198","femaleMedian":"784"}}},"Social and community service managers":{"ageData":{"2013":{"total":"332","16to19":"1","20to24":"10","25to34":"66","35to44":"75","45to54":"76","55to64":"78","65+":"27","medianAge":"78"}},"title":"Social and community service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"332","women":"65.6","white":"13.2","black":"3.3","asian":"6.9"}},"wageData":{"2013":{"workers":"280","median":"1,042","maleWorkers":"94","maleMedian":"1,150","femaleWorkers":"185","femaleMedian":"1,004"}}},"Emergency management directors":{"ageData":{"2013":{"total":"7","16to19":"0","20to24":"1","25to34":"0","35to44":"2","45to54":"0","55to64":"4","65+":"0","medianAge":"4"}},"title":"Emergency management directors","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"9","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Managers, all other":{"ageData":{"2013":{"total":"3,969","16to19":"8","20to24":"79","25to34":"618","35to44":"934","45to54":"1,191","55to64":"876","65+":"263","medianAge":"876"}},"title":"Managers, all other","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2013":{"total":"3,969","women":"33.7","white":"6.2","black":"4.8","asian":"9.1"}},"wageData":{"2013":{"workers":"2,431","median":"1,264","maleWorkers":"1,527","maleMedian":"1,399","femaleWorkers":"905","femaleMedian":"1,105"}}},"Business and financial operations occupations":{"ageData":{"2013":{"total":"6,757","16to19":"20","20to24":"377","25to34":"1,620","35to44":"1,580","45to54":"1,616","55to64":"1,166","65+":"378","medianAge":"1,166"}},"title":"Business and financial operations occupations","depth":3,"parent":"Management, business, and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"6,757","women":"55.7","white":"9.4","black":"7.7","asian":"8.3"}},"wageData":{"2013":{"workers":"5,636","median":"1,091","maleWorkers":"2,436","maleMedian":"1,263","femaleWorkers":"3,199","femaleMedian":"979"}}},"Agents and business managers of artists, performers, and athletes":{"ageData":{"2013":{"total":"59","16to19":"2","20to24":"10","25to34":"17","35to44":"12","45to54":"6","55to64":"8","65+":"4","medianAge":"8"}},"title":"Agents and business managers of artists, performers, and athletes","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"59","women":"51.3","white":"2.6","black":"7.8","asian":"10.5"}},"wageData":{"2013":{"workers":"38","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"18","femaleMedian":"-"}}},"Buyers and purchasing agents, farm products":{"ageData":{"2013":{"total":"14","16to19":"0","20to24":"0","25to34":"6","35to44":"2","45to54":"1","55to64":"3","65+":"1","medianAge":"3"}},"title":"Buyers and purchasing agents, farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"17","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Wholesale and retail buyers, except farm products":{"ageData":{"2013":{"total":"215","16to19":"2","20to24":"18","25to34":"55","35to44":"42","45to54":"52","55to64":"37","65+":"9","medianAge":"37"}},"title":"Wholesale and retail buyers, except farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"215","women":"55.1","white":"6.0","black":"6.4","asian":"9.8"}},"wageData":{"2013":{"workers":"158","median":"899","maleWorkers":"71","maleMedian":"871","femaleWorkers":"88","femaleMedian":"930"}}},"Purchasing agents, except wholesale, retail, and farm products":{"ageData":{"2013":{"total":"271","16to19":"1","20to24":"10","25to34":"46","35to44":"64","45to54":"79","55to64":"59","65+":"12","medianAge":"59"}},"title":"Purchasing agents, except wholesale, retail, and farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"271","women":"57.4","white":"9.6","black":"3.0","asian":"11.2"}},"wageData":{"2013":{"workers":"263","median":"984","maleWorkers":"112","maleMedian":"1,116","femaleWorkers":"151","femaleMedian":"912"}}},"Claims adjusters, appraisers, examiners, and investigators":{"ageData":{"2013":{"total":"329","16to19":"0","20to24":"9","25to34":"81","35to44":"92","45to54":"80","55to64":"55","65+":"12","medianAge":"55"}},"title":"Claims adjusters, appraisers, examiners, and investigators","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"329","women":"63.3","white":"13.9","black":"4.3","asian":"7.7"}},"wageData":{"2013":{"workers":"300","median":"931","maleWorkers":"104","maleMedian":"1,144","femaleWorkers":"195","femaleMedian":"838"}}},"Compliance officers":{"ageData":{"2013":{"total":"195","16to19":"0","20to24":"4","25to34":"41","35to44":"40","45to54":"53","55to64":"45","65+":"12","medianAge":"45"}},"title":"Compliance officers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"195","women":"53.4","white":"11.7","black":"7.1","asian":"7.8"}},"wageData":{"2013":{"workers":"182","median":"1,124","maleWorkers":"83","maleMedian":"1,170","femaleWorkers":"99","femaleMedian":"1,081"}}},"Cost estimators":{"ageData":{"2013":{"total":"123","16to19":"0","20to24":"5","25to34":"18","35to44":"32","45to54":"29","55to64":"32","65+":"8","medianAge":"32"}},"title":"Cost estimators","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"123","women":"10.8","white":"2.2","black":"3.8","asian":"10.1"}},"wageData":{"2013":{"workers":"102","median":"1,050","maleWorkers":"89","maleMedian":"1,071","femaleWorkers":"13","femaleMedian":"-"}}},"Human resources workers":{"ageData":{"2013":{"total":"584","16to19":"1","20to24":"34","25to34":"150","35to44":"158","45to54":"133","55to64":"81","65+":"26","medianAge":"81"}},"title":"Human resources workers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"584","women":"72.4","white":"12.3","black":"4.1","asian":"11.7"}},"wageData":{"2013":{"workers":"498","median":"981","maleWorkers":"131","maleMedian":"1,139","femaleWorkers":"366","femaleMedian":"958"}}},"Compensation, benefits, and job analysis specialists":{"ageData":{"2013":{"total":"83","16to19":"0","20to24":"4","25to34":"17","35to44":"26","45to54":"17","55to64":"15","65+":"3","medianAge":"15"}},"title":"Compensation, benefits, and job analysis specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"83","women":"80.0","white":"11.0","black":"3.6","asian":"12.6"}},"wageData":{"2013":{"workers":"72","median":"1,033","maleWorkers":"14","maleMedian":"-","femaleWorkers":"59","femaleMedian":"1,010"}}},"Training and development specialists":{"ageData":{"2013":{"total":"119","16to19":"0","20to24":"7","25to34":"34","35to44":"24","45to54":"27","55to64":"22","65+":"4","medianAge":"22"}},"title":"Training and development specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"119","women":"59.0","white":"12.4","black":"2.9","asian":"13.8"}},"wageData":{"2013":{"workers":"109","median":"1,079","maleWorkers":"47","maleMedian":"-","femaleWorkers":"62","femaleMedian":"979"}}},"Logisticians":{"ageData":{"2013":{"total":"88","16to19":"0","20to24":"8","25to34":"22","35to44":"9","45to54":"27","55to64":"20","65+":"3","medianAge":"20"}},"title":"Logisticians","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"88","women":"40.0","white":"12.8","black":"6.5","asian":"17.2"}},"wageData":{"2013":{"workers":"91","median":"993","maleWorkers":"58","maleMedian":"1,045","femaleWorkers":"33","femaleMedian":"-"}}},"Management analysts":{"ageData":{"2013":{"total":"811","16to19":"1","20to24":"34","25to34":"156","35to44":"168","45to54":"203","55to64":"167","65+":"82","medianAge":"167"}},"title":"Management analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"811","women":"41.8","white":"7.1","black":"8.5","asian":"5.7"}},"wageData":{"2013":{"workers":"547","median":"1,450","maleWorkers":"318","maleMedian":"1,614","femaleWorkers":"229","femaleMedian":"1,319"}}},"Meeting, convention, and event planners":{"ageData":{"2013":{"total":"130","16to19":"0","20to24":"15","25to34":"45","35to44":"22","45to54":"28","55to64":"14","65+":"7","medianAge":"14"}},"title":"Meeting, convention, and event planners","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"130","women":"74.7","white":"10.2","black":"6.1","asian":"6.1"}},"wageData":{"2013":{"workers":"95","median":"930","maleWorkers":"15","maleMedian":"-","femaleWorkers":"80","femaleMedian":"901"}}},"Fundraisers":{"ageData":{"2013":{"total":"81","16to19":"2","20to24":"5","25to34":"17","35to44":"24","45to54":"13","55to64":"17","65+":"3","medianAge":"17"}},"title":"Fundraisers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"81","women":"71.4","white":"3.4","black":"0.4","asian":"5.4"}},"wageData":{"2013":{"workers":"80","median":"1,124","maleWorkers":"22","maleMedian":"-","femaleWorkers":"58","femaleMedian":"1,084"}}},"Market research analysts and marketing specialists":{"ageData":{"2013":{"total":"241","16to19":"1","20to24":"24","25to34":"75","35to44":"54","45to54":"50","55to64":"26","65+":"9","medianAge":"26"}},"title":"Market research analysts and marketing specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"241","women":"58.1","white":"7.1","black":"10.4","asian":"5.1"}},"wageData":{"2013":{"workers":"190","median":"1,139","maleWorkers":"80","maleMedian":"1,171","femaleWorkers":"110","femaleMedian":"967"}}},"Business operations specialists, all other":{"ageData":{"2013":{"total":"195","16to19":"2","20to24":"13","25to34":"46","35to44":"43","45to54":"46","55to64":"37","65+":"9","medianAge":"37"}},"title":"Business operations specialists, all other","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"195","women":"62.7","white":"11.3","black":"6.2","asian":"8.2"}},"wageData":{"2013":{"workers":"180","median":"1,044","maleWorkers":"69","maleMedian":"1,226","femaleWorkers":"110","femaleMedian":"899"}}},"Accountants and auditors":{"ageData":{"2013":{"total":"1,814","16to19":"4","20to24":"87","25to34":"451","35to44":"442","45to54":"443","55to64":"293","65+":"94","medianAge":"293"}},"title":"Accountants and auditors","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"1,814","women":"62.1","white":"8.6","black":"11.9","asian":"7.3"}},"wageData":{"2013":{"workers":"1,516","median":"1,109","maleWorkers":"571","maleMedian":"1,268","femaleWorkers":"945","femaleMedian":"1,029"}}},"Appraisers and assessors of real estate":{"ageData":{"2013":{"total":"98","16to19":"0","20to24":"3","25to34":"19","35to44":"16","45to54":"29","55to64":"24","65+":"7","medianAge":"24"}},"title":"Appraisers and assessors of real estate","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"98","women":"42.4","white":"5.5","black":"3.0","asian":"5.5"}},"wageData":{"2013":{"workers":"60","median":"1,142","maleWorkers":"33","maleMedian":"-","femaleWorkers":"27","femaleMedian":"-"}}},"Budget analysts":{"ageData":{"2013":{"total":"62","16to19":"0","20to24":"3","25to34":"14","35to44":"14","45to54":"19","55to64":"11","65+":"2","medianAge":"11"}},"title":"Budget analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"62","women":"49.3","white":"14.2","black":"2.8","asian":"11.0"}},"wageData":{"2013":{"workers":"58","median":"1,389","maleWorkers":"31","maleMedian":"-","femaleWorkers":"26","femaleMedian":"-"}}},"Credit analysts":{"ageData":{"2013":{"total":"30","16to19":"0","20to24":"3","25to34":"11","35to44":"7","45to54":"6","55to64":"3","65+":"0","medianAge":"3"}},"title":"Credit analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"30","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"31","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"19","femaleMedian":"-"}}},"Financial analysts":{"ageData":{"2013":{"total":"105","16to19":"0","20to24":"9","25to34":"33","35to44":"32","45to54":"20","55to64":"10","65+":"2","medianAge":"10"}},"title":"Financial analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"105","women":"32.6","white":"8.5","black":"13.7","asian":"5.5"}},"wageData":{"2013":{"workers":"89","median":"1,466","maleWorkers":"56","maleMedian":"1,757","femaleWorkers":"33","femaleMedian":"-"}}},"Personal financial advisors":{"ageData":{"2013":{"total":"383","16to19":"1","20to24":"25","25to34":"89","35to44":"92","45to54":"85","55to64":"60","65+":"31","medianAge":"60"}},"title":"Personal financial advisors","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"383","women":"25.7","white":"6.5","black":"8.0","asian":"5.2"}},"wageData":{"2013":{"workers":"288","median":"1,424","maleWorkers":"215","maleMedian":"1,565","femaleWorkers":"72","femaleMedian":"1,149"}}},"Insurance underwriters":{"ageData":{"2013":{"total":"94","16to19":"0","20to24":"5","25to34":"22","35to44":"20","45to54":"22","55to64":"22","65+":"3","medianAge":"22"}},"title":"Insurance underwriters","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"94","women":"63.6","white":"13.7","black":"2.1","asian":"8.7"}},"wageData":{"2013":{"workers":"98","median":"1,045","maleWorkers":"37","maleMedian":"-","femaleWorkers":"61","femaleMedian":"879"}}},"Financial examiners":{"ageData":{"2013":{"total":"14","16to19":"0","20to24":"4","25to34":"1","35to44":"3","45to54":"2","55to64":"4","65+":"1","medianAge":"4"}},"title":"Financial examiners","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"10","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Credit counselors and loan officers":{"ageData":{"2013":{"total":"365","16to19":"1","20to24":"24","25to34":"97","35to44":"94","45to54":"82","55to64":"59","65+":"9","medianAge":"59"}},"title":"Credit counselors and loan officers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"365","women":"56.6","white":"10.6","black":"6.0","asian":"9.6"}},"wageData":{"2013":{"workers":"360","median":"970","maleWorkers":"152","maleMedian":"1,162","femaleWorkers":"208","femaleMedian":"864"}}},"Tax examiners and collectors, and revenue agents":{"ageData":{"2013":{"total":"60","16to19":"0","20to24":"0","25to34":"14","35to44":"13","45to54":"25","55to64":"7","65+":"1","medianAge":"7"}},"title":"Tax examiners and collectors, and revenue agents","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"60","women":"70.2","white":"20.9","black":"9.1","asian":"7.1"}},"wageData":{"2013":{"workers":"62","median":"952","maleWorkers":"19","maleMedian":"-","femaleWorkers":"43","femaleMedian":"-"}}},"Tax preparers":{"ageData":{"2013":{"total":"97","16to19":"0","20to24":"2","25to34":"17","35to44":"15","45to54":"22","55to64":"21","65+":"20","medianAge":"21"}},"title":"Tax preparers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"97","women":"62.1","white":"21.4","black":"9.6","asian":"17.9"}},"wageData":{"2013":{"workers":"56","median":"767","maleWorkers":"22","maleMedian":"-","femaleWorkers":"34","femaleMedian":"-"}}},"Financial specialists, all other":{"ageData":{"2013":{"total":"94","16to19":"1","20to24":"11","25to34":"26","35to44":"21","45to54":"18","55to64":"13","65+":"5","medianAge":"13"}},"title":"Financial specialists, all other","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2013":{"total":"94","women":"56.5","white":"12.5","black":"6.4","asian":"10.8"}},"wageData":{"2013":{"workers":"87","median":"962","maleWorkers":"38","maleMedian":"-","femaleWorkers":"49","femaleMedian":"-"}}},"Professional and related occupations":{"ageData":{"2013":{"total":"31,917","16to19":"255","20to24":"1,936","25to34":"7,762","35to44":"7,651","45to54":"7,089","55to64":"5,511","65+":"1,713","medianAge":"5,511"}},"title":"Professional and related occupations","depth":2,"parent":"Management, professional, and related occupations","sexRaceEthnicityData":{"2013":{"total":"31,917","women":"57.1","white":"9.3","black":"8.3","asian":"8.2"}},"wageData":{"2013":{"workers":"24,683","median":"1,071","maleWorkers":"11,089","maleMedian":"1,295","femaleWorkers":"13,594","femaleMedian":"944"}}},"Computer and mathematical occupations":{"ageData":{"2013":{"total":"3,980","16to19":"20","20to24":"235","25to34":"1,062","35to44":"1,143","45to54":"946","55to64":"476","65+":"98","medianAge":"476"}},"title":"Computer and mathematical occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2013":{"total":"3,980","women":"26.1","white":"8.3","black":"18.5","asian":"6.3"}},"wageData":{"2013":{"workers":"3,621","median":"1,365","maleWorkers":"2,693","maleMedian":"1,452","femaleWorkers":"928","femaleMedian":"1,174"}}},"Computer and information research scientists":{"ageData":{"2013":{"total":"18","16to19":"0","20to24":"1","25to34":"4","35to44":"4","45to54":"5","55to64":"3","65+":"0","medianAge":"3"}},"title":"Computer and information research scientists","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2013":{"total":"18","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"15","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Computer systems analysts":{"ageData":{"2013":{"total":"534","16to19":"1","20to24":"36","25to34":"132","35to44":"152","45to54":"125","55to64":"76","65+":"11","medianAge":"76"}},"title":"Computer systems analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2013":{"total":"534","women":"34.9","white":"9.5","black":"20.5","asian":"5.9"}},"wageData":{"2013":{"workers":"443","median":"1,367","maleWorkers":"285","maleMedian":"1,455","femaleWorkers":"158","femaleMedian":"1,216"}}},"Information security analysts":{"ageData":{"2013":{"total":"48","16to19":"0","20to24":"4","25to34":"8","35to44":"16","45to54":"12","55to64":"7","65+":"2","medianAge":"7"}},"title":"Information security analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2013":{"total":"48","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"53","median":"1,460","maleWorkers":"43","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Computer programmers":{"ageData":{"2013":{"total":"489","16to19":"2","20to24":"25","25to34":"105","35to44":"146","45to54":"129","55to64":"68","65+":"14","medianAge":"68"}},"title":"Computer programmers","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2013":{"total":"489","women":"23.0","white":"8.1","black":"18.8","asian":"5.6"}},"wageData":{"2013":{"workers":"437","median":"1,372","maleWorkers":"332","maleMedian":"1,428","femaleWorkers":"106","femaleMedian":"1,162"}}},"Software developers, applications and systems software":{"ageData":{"2013":{"total":"1,103","16to19":"6","20to24":"49","25to34":"332","35to44":"320","45to54":"260","55to64":"117","65+":"19","medianAge":"117"}},"title":"Software developers, applications and systems software","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2013":{"total":"1,103","women":"19.7","white":"4.1","black":"28.8","asian":"5.3"}},"wageData":{"2013":{"workers":"1,053","median":"1,643","maleWorkers":"844","maleMedian":"1,737","femaleWorkers":"209","femaleMedian":"1,370"}}},"Web developers":{"ageData":{"2013":{"total":"192","16to19":"1","20to24":"22","25to34":"60","35to44":"60","45to54":"36","55to64":"12","65+":"2","medianAge":"12"}},"title":"Web developers","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2013":{"total":"192","women":"39.5","white":"8.0","black":"8.7","asian":"6.5"}},"wageData":{"2013":{"workers":"137","median":"1,060","maleWorkers":"84","maleMedian":"1,157","femaleWorkers":"53","femaleMedian":"937"}}},"Computer support specialists":{"ageData":{"2013":{"total":"517","16to19":"5","20to24":"46","25to34":"150","35to44":"125","45to54":"107","55to64":"71","65+":"12","medianAge":"71"}},"title":"Computer support specialists","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2013":{"total":"517","women":"29.0","white":"13.2","black":"7.6","asian":"7.6"}},"wageData":{"2013":{"workers":"474","median":"980","maleWorkers":"340","maleMedian":"1,019","femaleWorkers":"134","femaleMedian":"901"}}},"Database administrators":{"ageData":{"2013":{"total":"98","16to19":"0","20to24":"2","25to34":"24","35to44":"30","45to54":"30","55to64":"11","65+":"1","medianAge":"11"}},"title":"Database administrators","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2013":{"total":"98","women":"37.4","white":"14.2","black":"10.8","asian":"6.8"}},"wageData":{"2013":{"workers":"95","median":"1,345","maleWorkers":"65","maleMedian":"1,563","femaleWorkers":"30","femaleMedian":"-"}}},"Network and computer systems administrators":{"ageData":{"2013":{"total":"205","16to19":"0","20to24":"10","25to34":"61","35to44":"68","45to54":"38","55to64":"25","65+":"2","medianAge":"25"}},"title":"Network and computer systems administrators","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2013":{"total":"205","women":"17.3","white":"9.3","black":"11.3","asian":"7.4"}},"wageData":{"2013":{"workers":"210","median":"1,237","maleWorkers":"173","maleMedian":"1,252","femaleWorkers":"37","femaleMedian":"-"}}},"Computer network architects":{"ageData":{"2013":{"total":"135","16to19":"0","20to24":"2","25to34":"27","35to44":"50","45to54":"41","55to64":"12","65+":"3","medianAge":"12"}},"title":"Computer network architects","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2013":{"total":"135","women":"7.5","white":"9.4","black":"14.5","asian":"5.1"}},"wageData":{"2013":{"workers":"131","median":"1,630","maleWorkers":"122","maleMedian":"1,593","femaleWorkers":"9","femaleMedian":"-"}}},"Computer occupations, all other":{"ageData":{"2013":{"total":"410","16to19":"4","20to24":"28","25to34":"96","35to44":"116","45to54":"105","55to64":"43","65+":"19","medianAge":"43"}},"title":"Computer occupations, all other","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2013":{"total":"410","women":"22.8","white":"9.9","black":"16.5","asian":"8.1"}},"wageData":{"2013":{"workers":"359","median":"1,149","maleWorkers":"277","maleMedian":"1,136","femaleWorkers":"81","femaleMedian":"1,176"}}},"Actuaries":{"ageData":{"2013":{"total":"28","16to19":"0","20to24":"4","25to34":"7","35to44":"7","45to54":"6","55to64":"3","65+":"1","medianAge":"3"}},"title":"Actuaries","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2013":{"total":"28","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"25","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Mathematicians":{"ageData":{"2013":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Mathematicians","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2013":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Operations research analysts":{"ageData":{"2013":{"total":"128","16to19":"0","20to24":"3","25to34":"35","35to44":"26","45to54":"35","55to64":"17","65+":"11","medianAge":"17"}},"title":"Operations research analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2013":{"total":"128","women":"52.0","white":"7.8","black":"8.3","asian":"11.2"}},"wageData":{"2013":{"workers":"119","median":"1,444","maleWorkers":"56","maleMedian":"1,569","femaleWorkers":"63","femaleMedian":"1,313"}}},"Statisticians":{"ageData":{"2013":{"total":"72","16to19":"0","20to24":"5","25to34":"21","35to44":"21","45to54":"13","55to64":"11","65+":"1","medianAge":"11"}},"title":"Statisticians","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2013":{"total":"72","women":"38.3","white":"11.4","black":"25.4","asian":"3.0"}},"wageData":{"2013":{"workers":"65","median":"1,414","maleWorkers":"42","maleMedian":"-","femaleWorkers":"23","femaleMedian":"-"}}},"Miscellaneous mathematical science occupations":{"ageData":{"2013":{"total":"3","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Miscellaneous mathematical science occupations","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2013":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Architecture and engineering occupations":{"ageData":{"2013":{"total":"2,806","16to19":"11","20to24":"163","25to34":"672","35to44":"605","45to54":"712","55to64":"512","65+":"130","medianAge":"512"}},"title":"Architecture and engineering occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2013":{"total":"2,806","women":"14.1","white":"5.5","black":"11.3","asian":"7.5"}},"wageData":{"2013":{"workers":"2,540","median":"1,365","maleWorkers":"2,209","maleMedian":"1,403","femaleWorkers":"330","femaleMedian":"1,143"}}},"Architects, except naval":{"ageData":{"2013":{"total":"193","16to19":"0","20to24":"2","25to34":"44","35to44":"49","45to54":"41","55to64":"40","65+":"18","medianAge":"40"}},"title":"Architects, except naval","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2013":{"total":"193","women":"25.0","white":"1.6","black":"5.8","asian":"7.9"}},"wageData":{"2013":{"workers":"118","median":"1,292","maleWorkers":"88","maleMedian":"1,347","femaleWorkers":"30","femaleMedian":"-"}}},"Surveyors, cartographers, and photogrammetrists":{"ageData":{"2013":{"total":"39","16to19":"0","20to24":"2","25to34":"16","35to44":"7","45to54":"9","55to64":"6","65+":"0","medianAge":"6"}},"title":"Surveyors, cartographers, and photogrammetrists","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2013":{"total":"39","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"32","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Aerospace engineers":{"ageData":{"2013":{"total":"144","16to19":"1","20to24":"5","25to34":"32","35to44":"34","45to54":"40","55to64":"27","65+":"6","medianAge":"27"}},"title":"Aerospace engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2013":{"total":"144","women":"12.2","white":"4.9","black":"10.9","asian":"4.7"}},"wageData":{"2013":{"workers":"137","median":"1,865","maleWorkers":"124","maleMedian":"1,873","femaleWorkers":"13","femaleMedian":"-"}}},"Agricultural engineers":{"ageData":{"2013":{"total":"3","16to19":"0","20to24":"0","25to34":"0","35to44":"2","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Agricultural engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2013":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Biomedical engineers":{"ageData":{"2013":{"total":"11","16to19":"0","20to24":"0","25to34":"7","35to44":"0","45to54":"2","55to64":"0","65+":"1","medianAge":"0"}},"title":"Biomedical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2013":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"10","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Chemical engineers":{"ageData":{"2013":{"total":"61","16to19":"0","20to24":"5","25to34":"14","35to44":"11","45to54":"12","55to64":"13","65+":"5","medianAge":"13"}},"title":"Chemical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2013":{"total":"61","women":"15.6","white":"5.9","black":"7.5","asian":"6.0"}},"wageData":{"2013":{"workers":"56","median":"1,568","maleWorkers":"48","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Civil engineers":{"ageData":{"2013":{"total":"360","16to19":"0","20to24":"23","25to34":"93","35to44":"74","45to54":"93","55to64":"55","65+":"20","medianAge":"55"}},"title":"Civil engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2013":{"total":"360","women":"12.1","white":"6.4","black":"10.4","asian":"4.9"}},"wageData":{"2013":{"workers":"324","median":"1,373","maleWorkers":"288","maleMedian":"1,417","femaleWorkers":"36","femaleMedian":"-"}}},"Computer hardware engineers":{"ageData":{"2013":{"total":"90","16to19":"0","20to24":"5","25to34":"24","35to44":"26","45to54":"23","55to64":"11","65+":"1","medianAge":"11"}},"title":"Computer hardware engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2013":{"total":"90","women":"9.2","white":"6.3","black":"25.6","asian":"10.4"}},"wageData":{"2013":{"workers":"92","median":"1,507","maleWorkers":"82","maleMedian":"1,544","femaleWorkers":"10","femaleMedian":"-"}}},"Electrical and electronics engineers":{"ageData":{"2013":{"total":"300","16to19":"1","20to24":"19","25to34":"66","35to44":"60","45to54":"81","55to64":"59","65+":"14","medianAge":"59"}},"title":"Electrical and electronics engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2013":{"total":"300","women":"8.3","white":"4.2","black":"18.5","asian":"7.6"}},"wageData":{"2013":{"workers":"268","median":"1,522","maleWorkers":"247","maleMedian":"1,514","femaleWorkers":"21","femaleMedian":"-"}}},"Environmental engineers":{"ageData":{"2013":{"total":"33","16to19":"1","20to24":"2","25to34":"6","35to44":"7","45to54":"5","55to64":"7","65+":"3","medianAge":"7"}},"title":"Environmental engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2013":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"28","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Industrial engineers, including health and safety":{"ageData":{"2013":{"total":"190","16to19":"1","20to24":"9","25to34":"31","35to44":"43","45to54":"57","55to64":"42","65+":"7","medianAge":"42"}},"title":"Industrial engineers, including health and safety","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2013":{"total":"190","women":"17.2","white":"5.9","black":"10.5","asian":"8.8"}},"wageData":{"2013":{"workers":"181","median":"1,385","maleWorkers":"151","maleMedian":"1,417","femaleWorkers":"30","femaleMedian":"-"}}},"Marine engineers and naval architects":{"ageData":{"2013":{"total":"11","16to19":"0","20to24":"0","25to34":"3","35to44":"4","45to54":"3","55to64":"2","65+":"0","medianAge":"2"}},"title":"Marine engineers and naval architects","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2013":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"12","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Materials engineers":{"ageData":{"2013":{"total":"46","16to19":"0","20to24":"3","25to34":"11","35to44":"8","45to54":"17","55to64":"4","65+":"3","medianAge":"4"}},"title":"Materials engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2013":{"total":"46","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"43","median":"-","maleWorkers":"36","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Mechanical engineers":{"ageData":{"2013":{"total":"327","16to19":"1","20to24":"27","25to34":"80","35to44":"75","45to54":"84","55to64":"50","65+":"10","medianAge":"50"}},"title":"Mechanical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2013":{"total":"327","women":"7.2","white":"3.3","black":"12.6","asian":"6.8"}},"wageData":{"2013":{"workers":"297","median":"1,496","maleWorkers":"273","maleMedian":"1,554","femaleWorkers":"24","femaleMedian":"-"}}},"Mining and geological engineers, including mining safety engineers":{"ageData":{"2013":{"total":"18","16to19":"0","20to24":"1","25to34":"6","35to44":"2","45to54":"3","55to64":"6","65+":"0","medianAge":"6"}},"title":"Mining and geological engineers, including mining safety engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2013":{"total":"18","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"16","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Nuclear engineers":{"ageData":{"2013":{"total":"4","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"1","55to64":"0","65+":"1","medianAge":"0"}},"title":"Nuclear engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2013":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Petroleum engineers":{"ageData":{"2013":{"total":"33","16to19":"0","20to24":"5","25to34":"10","35to44":"8","45to54":"5","55to64":"5","65+":"0","medianAge":"5"}},"title":"Petroleum engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2013":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"34","median":"-","maleWorkers":"33","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Engineers, all other":{"ageData":{"2013":{"total":"398","16to19":"0","20to24":"16","25to34":"105","35to44":"92","45to54":"92","55to64":"70","65+":"24","medianAge":"70"}},"title":"Engineers, all other","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2013":{"total":"398","women":"14.4","white":"5.8","black":"12.6","asian":"6.7"}},"wageData":{"2013":{"workers":"371","median":"1,528","maleWorkers":"322","maleMedian":"1,561","femaleWorkers":"48","femaleMedian":"-"}}},"Drafters":{"ageData":{"2013":{"total":"125","16to19":"1","20to24":"10","25to34":"33","35to44":"26","45to54":"33","55to64":"21","65+":"1","medianAge":"21"}},"title":"Drafters","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2013":{"total":"125","women":"21.2","white":"2.1","black":"8.7","asian":"7.1"}},"wageData":{"2013":{"workers":"104","median":"974","maleWorkers":"85","maleMedian":"991","femaleWorkers":"20","femaleMedian":"-"}}},"Engineering technicians, except drafters":{"ageData":{"2013":{"total":"365","16to19":"4","20to24":"26","25to34":"78","35to44":"66","45to54":"97","55to64":"83","65+":"12","medianAge":"83"}},"title":"Engineering technicians, except drafters","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2013":{"total":"365","women":"17.6","white":"8.3","black":"6.7","asian":"13.0"}},"wageData":{"2013":{"workers":"361","median":"1,011","maleWorkers":"302","maleMedian":"1,027","femaleWorkers":"59","femaleMedian":"934"}}},"Surveying and mapping technicians":{"ageData":{"2013":{"total":"54","16to19":"1","20to24":"2","25to34":"14","35to44":"10","45to54":"14","55to64":"10","65+":"4","medianAge":"10"}},"title":"Surveying and mapping technicians","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2013":{"total":"54","women":"10.8","white":"4.1","black":"4.3","asian":"3.4"}},"wageData":{"2013":{"workers":"48","median":"-","maleWorkers":"43","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Life, physical, and social science occupations":{"ageData":{"2013":{"total":"1,307","16to19":"5","20to24":"79","25to34":"330","35to44":"325","45to54":"258","55to64":"236","65+":"75","medianAge":"236"}},"title":"Life, physical, and social science occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2013":{"total":"1,307","women":"46.1","white":"5.6","black":"11.8","asian":"7.9"}},"wageData":{"2013":{"workers":"1,063","median":"1,152","maleWorkers":"608","maleMedian":"1,271","femaleWorkers":"456","femaleMedian":"1,030"}}},"Agricultural and food scientists":{"ageData":{"2013":{"total":"44","16to19":"0","20to24":"2","25to34":"14","35to44":"12","45to54":"3","55to64":"10","65+":"2","medianAge":"10"}},"title":"Agricultural and food scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2013":{"total":"44","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"30","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Biological scientists":{"ageData":{"2013":{"total":"112","16to19":"0","20to24":"8","25to34":"26","35to44":"31","45to54":"21","55to64":"19","65+":"6","medianAge":"19"}},"title":"Biological scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2013":{"total":"112","women":"52.7","white":"2.6","black":"17.0","asian":"4.8"}},"wageData":{"2013":{"workers":"107","median":"1,157","maleWorkers":"54","maleMedian":"1,233","femaleWorkers":"53","femaleMedian":"1,104"}}},"Conservation scientists and foresters":{"ageData":{"2013":{"total":"32","16to19":"0","20to24":"1","25to34":"7","35to44":"6","45to54":"8","55to64":"8","65+":"2","medianAge":"8"}},"title":"Conservation scientists and foresters","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2013":{"total":"32","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"27","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Medical scientists":{"ageData":{"2013":{"total":"144","16to19":"0","20to24":"4","25to34":"39","35to44":"50","45to54":"26","55to64":"23","65+":"2","medianAge":"23"}},"title":"Medical scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2013":{"total":"144","women":"52.4","white":"6.5","black":"26.3","asian":"6.9"}},"wageData":{"2013":{"workers":"131","median":"1,216","maleWorkers":"58","maleMedian":"1,430","femaleWorkers":"73","femaleMedian":"1,142"}}},"Life scientists, all other":{"ageData":{"2013":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Life scientists, all other","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2013":{"total":"0","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Astronomers and physicists":{"ageData":{"2013":{"total":"14","16to19":"0","20to24":"0","25to34":"4","35to44":"1","45to54":"3","55to64":"1","65+":"4","medianAge":"1"}},"title":"Astronomers and physicists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2013":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"13","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Atmospheric and space scientists":{"ageData":{"2013":{"total":"14","16to19":"0","20to24":"1","25to34":"1","35to44":"5","45to54":"3","55to64":"2","65+":"0","medianAge":"2"}},"title":"Atmospheric and space scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2013":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"11","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Chemists and materials scientists":{"ageData":{"2013":{"total":"121","16to19":"0","20to24":"7","25to34":"38","35to44":"31","45to54":"24","55to64":"18","65+":"3","medianAge":"18"}},"title":"Chemists and materials scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2013":{"total":"121","women":"39.0","white":"7.3","black":"10.4","asian":"12.3"}},"wageData":{"2013":{"workers":"109","median":"1,182","maleWorkers":"68","maleMedian":"1,380","femaleWorkers":"42","femaleMedian":"-"}}},"Environmental scientists and geoscientists":{"ageData":{"2013":{"total":"94","16to19":"0","20to24":"4","25to34":"25","35to44":"17","45to54":"28","55to64":"16","65+":"4","medianAge":"16"}},"title":"Environmental scientists and geoscientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2013":{"total":"94","women":"27.9","white":"4.0","black":"6.3","asian":"3.8"}},"wageData":{"2013":{"workers":"76","median":"1,330","maleWorkers":"58","maleMedian":"1,392","femaleWorkers":"18","femaleMedian":"-"}}},"Physical scientists, all other":{"ageData":{"2013":{"total":"158","16to19":"0","20to24":"6","25to34":"31","35to44":"52","45to54":"39","55to64":"21","65+":"9","medianAge":"21"}},"title":"Physical scientists, all other","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2013":{"total":"158","women":"34.5","white":"6.8","black":"22.5","asian":"3.9"}},"wageData":{"2013":{"workers":"132","median":"1,517","maleWorkers":"88","maleMedian":"1,597","femaleWorkers":"44","femaleMedian":"-"}}},"Economists":{"ageData":{"2013":{"total":"34","16to19":"0","20to24":"0","25to34":"7","35to44":"12","45to54":"6","55to64":"6","65+":"3","medianAge":"6"}},"title":"Economists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2013":{"total":"34","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"29","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"14","femaleMedian":"-"}}},"Survey researchers":{"ageData":{"2013":{"total":"3","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Survey researchers","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2013":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Psychologists":{"ageData":{"2013":{"total":"186","16to19":"1","20to24":"2","25to34":"32","35to44":"41","45to54":"37","55to64":"49","65+":"25","medianAge":"49"}},"title":"Psychologists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2013":{"total":"186","women":"73.8","white":"3.6","black":"2.5","asian":"8.6"}},"wageData":{"2013":{"workers":"96","median":"1,267","maleWorkers":"27","maleMedian":"-","femaleWorkers":"69","femaleMedian":"1,178"}}},"Sociologists":{"ageData":{"2013":{"total":"5","16to19":"0","20to24":"0","25to34":"5","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Sociologists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2013":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"4","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Urban and regional planners":{"ageData":{"2013":{"total":"20","16to19":"0","20to24":"0","25to34":"5","35to44":"8","45to54":"2","55to64":"3","65+":"0","medianAge":"3"}},"title":"Urban and regional planners","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2013":{"total":"20","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"20","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Miscellaneous social scientists and related workers":{"ageData":{"2013":{"total":"57","16to19":"0","20to24":"3","25to34":"14","35to44":"15","45to54":"10","55to64":"9","65+":"6","medianAge":"9"}},"title":"Miscellaneous social scientists and related workers","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2013":{"total":"57","women":"52.7","white":"11.3","black":"3.8","asian":"7.0"}},"wageData":{"2013":{"workers":"40","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"18","femaleMedian":"-"}}},"Agricultural and food science technicians":{"ageData":{"2013":{"total":"28","16to19":"1","20to24":"3","25to34":"13","35to44":"2","45to54":"3","55to64":"6","65+":"0","medianAge":"6"}},"title":"Agricultural and food science technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2013":{"total":"28","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"23","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Biological technicians":{"ageData":{"2013":{"total":"21","16to19":"0","20to24":"1","25to34":"7","35to44":"4","45to54":"6","55to64":"3","65+":"0","medianAge":"3"}},"title":"Biological technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2013":{"total":"21","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"16","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Chemical technicians":{"ageData":{"2013":{"total":"61","16to19":"0","20to24":"3","25to34":"17","35to44":"10","45to54":"12","55to64":"14","65+":"4","medianAge":"14"}},"title":"Chemical technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2013":{"total":"61","women":"41.3","white":"16.3","black":"6.3","asian":"9.7"}},"wageData":{"2013":{"workers":"62","median":"849","maleWorkers":"41","maleMedian":"-","femaleWorkers":"21","femaleMedian":"-"}}},"Geological and petroleum technicians":{"ageData":{"2013":{"total":"22","16to19":"0","20to24":"2","25to34":"7","35to44":"3","45to54":"5","55to64":"5","65+":"1","medianAge":"5"}},"title":"Geological and petroleum technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2013":{"total":"22","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"23","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Nuclear technicians":{"ageData":{"2013":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Nuclear technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2013":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Social science research assistants":{"ageData":{"2013":{"total":"2","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Social science research assistants","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2013":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Miscellaneous life, physical, and social science technicians":{"ageData":{"2013":{"total":"133","16to19":"2","20to24":"30","25to34":"34","35to44":"22","45to54":"20","55to64":"20","65+":"2","medianAge":"20"}},"title":"Miscellaneous life, physical, and social science technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2013":{"total":"133","women":"49.3","white":"4.0","black":"11.1","asian":"10.0"}},"wageData":{"2013":{"workers":"105","median":"761","maleWorkers":"59","maleMedian":"911","femaleWorkers":"47","femaleMedian":"-"}}},"Community and social service occupations":{"ageData":{"2013":{"total":"2,332","16to19":"24","20to24":"117","25to34":"551","35to44":"546","45to54":"482","55to64":"439","65+":"173","medianAge":"439"}},"title":"Community and social service occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2013":{"total":"2,332","women":"62.3","white":"18.6","black":"2.9","asian":"10.0"}},"wageData":{"2013":{"workers":"1,913","median":"847","maleWorkers":"755","maleMedian":"930","femaleWorkers":"1,158","femaleMedian":"808"}}},"Counselors":{"ageData":{"2013":{"total":"727","16to19":"11","20to24":"35","25to34":"181","35to44":"171","45to54":"152","55to64":"130","65+":"46","medianAge":"130"}},"title":"Counselors","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2013":{"total":"727","women":"69.3","white":"20.4","black":"1.9","asian":"9.1"}},"wageData":{"2013":{"workers":"568","median":"885","maleWorkers":"178","maleMedian":"889","femaleWorkers":"391","femaleMedian":"884"}}},"Social workers":{"ageData":{"2013":{"total":"727","16to19":"1","20to24":"36","25to34":"203","35to44":"195","45to54":"150","55to64":"111","65+":"32","medianAge":"111"}},"title":"Social workers","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2013":{"total":"727","women":"80.3","white":"21.9","black":"3.1","asian":"13.3"}},"wageData":{"2013":{"workers":"636","median":"845","maleWorkers":"129","maleMedian":"978","femaleWorkers":"507","femaleMedian":"818"}}},"Probation officers and correctional treatment specialists":{"ageData":{"2013":{"total":"105","16to19":"0","20to24":"2","25to34":"25","35to44":"39","45to54":"28","55to64":"9","65+":"1","medianAge":"9"}},"title":"Probation officers and correctional treatment specialists","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2013":{"total":"105","women":"45.7","white":"21.8","black":"1.3","asian":"12.3"}},"wageData":{"2013":{"workers":"105","median":"888","maleWorkers":"62","maleMedian":"927","femaleWorkers":"43","femaleMedian":"-"}}},"Social and human service assistants":{"ageData":{"2013":{"total":"127","16to19":"4","20to24":"14","25to34":"30","35to44":"26","45to54":"21","55to64":"26","65+":"7","medianAge":"26"}},"title":"Social and human service assistants","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2013":{"total":"127","women":"73.2","white":"27.7","black":"0.8","asian":"14.2"}},"wageData":{"2013":{"workers":"102","median":"668","maleWorkers":"34","maleMedian":"-","femaleWorkers":"68","femaleMedian":"641"}}},"Miscellaneous community and social service specialists, including health educators and community health workers":{"ageData":{"2013":{"total":"106","16to19":"2","20to24":"7","25to34":"24","35to44":"27","45to54":"22","55to64":"20","65+":"4","medianAge":"20"}},"title":"Miscellaneous community and social service specialists, including health educators and community health workers","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2013":{"total":"106","women":"73.5","white":"19.8","black":"1.1","asian":"6.8"}},"wageData":{"2013":{"workers":"83","median":"756","maleWorkers":"19","maleMedian":"-","femaleWorkers":"64","femaleMedian":"740"}}},"Clergy":{"ageData":{"2013":{"total":"410","16to19":"2","20to24":"12","25to34":"61","35to44":"67","45to54":"91","55to64":"113","65+":"64","medianAge":"113"}},"title":"Clergy","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2013":{"total":"410","women":"15.5","white":"9.1","black":"6.5","asian":"6.4"}},"wageData":{"2013":{"workers":"343","median":"935","maleWorkers":"296","maleMedian":"968","femaleWorkers":"47","femaleMedian":"-"}}},"Directors, religious activities and education":{"ageData":{"2013":{"total":"57","16to19":"0","20to24":"5","25to34":"13","35to44":"11","45to54":"11","55to64":"13","65+":"4","medianAge":"13"}},"title":"Directors, religious activities and education","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2013":{"total":"57","women":"64.8","white":"3.7","black":"1.0","asian":"1.1"}},"wageData":{"2013":{"workers":"41","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"21","femaleMedian":"-"}}},"Religious workers, all other":{"ageData":{"2013":{"total":"74","16to19":"4","20to24":"5","25to34":"14","35to44":"11","45to54":"9","55to64":"17","65+":"14","medianAge":"17"}},"title":"Religious workers, all other","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2013":{"total":"74","women":"63.1","white":"9.3","black":"1.4","asian":"6.7"}},"wageData":{"2013":{"workers":"34","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Legal occupations":{"ageData":{"2013":{"total":"1,809","16to19":"6","20to24":"56","25to34":"367","35to44":"419","45to54":"446","55to64":"372","65+":"144","medianAge":"372"}},"title":"Legal occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2013":{"total":"1,809","women":"50.8","white":"6.2","black":"4.9","asian":"8.2"}},"wageData":{"2013":{"workers":"1,305","median":"1,253","maleWorkers":"598","maleMedian":"1,764","femaleWorkers":"707","femaleMedian":"1,010"}}},"Lawyers":{"ageData":{"2013":{"total":"1,092","16to19":"1","20to24":"4","25to34":"205","35to44":"279","45to54":"258","55to64":"232","65+":"113","medianAge":"232"}},"title":"Lawyers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2013":{"total":"1,092","women":"33.1","white":"4.2","black":"5.1","asian":"5.1"}},"wageData":{"2013":{"workers":"710","median":"1,880","maleWorkers":"463","maleMedian":"1,986","femaleWorkers":"247","femaleMedian":"1,566"}}},"Judicial law clerks":{"ageData":{"2013":{"total":"13","16to19":"0","20to24":"2","25to34":"4","35to44":"2","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Judicial law clerks","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2013":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"9","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Judges, magistrates, and other judicial workers":{"ageData":{"2013":{"total":"55","16to19":"0","20to24":"0","25to34":"3","35to44":"10","45to54":"13","55to64":"20","65+":"10","medianAge":"20"}},"title":"Judges, magistrates, and other judicial workers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2013":{"total":"55","women":"35.6","white":"7.8","black":"0.1","asian":"6.3"}},"wageData":{"2013":{"workers":"49","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"19","femaleMedian":"-"}}},"Paralegals and legal assistants":{"ageData":{"2013":{"total":"404","16to19":"2","20to24":"36","25to34":"101","35to44":"83","45to54":"101","55to64":"72","65+":"9","medianAge":"72"}},"title":"Paralegals and legal assistants","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2013":{"total":"404","women":"86.1","white":"9.5","black":"4.5","asian":"15.2"}},"wageData":{"2013":{"workers":"337","median":"846","maleWorkers":"50","maleMedian":"923","femaleWorkers":"287","femaleMedian":"825"}}},"Miscellaneous legal support workers":{"ageData":{"2013":{"total":"244","16to19":"3","20to24":"14","25to34":"54","35to44":"45","45to54":"73","55to64":"45","65+":"11","medianAge":"45"}},"title":"Miscellaneous legal support workers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2013":{"total":"244","women":"74.6","white":"9.5","black":"5.6","asian":"11.4"}},"wageData":{"2013":{"workers":"199","median":"873","maleWorkers":"51","maleMedian":"1,013","femaleWorkers":"148","femaleMedian":"787"}}},"Education, training, and library occupations":{"ageData":{"2013":{"total":"8,623","16to19":"90","20to24":"579","25to34":"2,029","35to44":"2,008","45to54":"1,879","55to64":"1,529","65+":"509","medianAge":"1,529"}},"title":"Education, training, and library occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2013":{"total":"8,623","women":"73.8","white":"9.4","black":"4.5","asian":"9.6"}},"wageData":{"2013":{"workers":"6,589","median":"937","maleWorkers":"1,808","maleMedian":"1,091","femaleWorkers":"4,782","femaleMedian":"888"}}},"Postsecondary teachers":{"ageData":{"2013":{"total":"1,313","16to19":"5","20to24":"100","25to34":"285","35to44":"255","45to54":"248","55to64":"269","65+":"152","medianAge":"269"}},"title":"Postsecondary teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2013":{"total":"1,313","women":"50.2","white":"6.8","black":"13.0","asian":"5.9"}},"wageData":{"2013":{"workers":"893","median":"1,172","maleWorkers":"469","maleMedian":"1,338","femaleWorkers":"424","femaleMedian":"1,100"}}},"Preschool and kindergarten teachers":{"ageData":{"2013":{"total":"695","16to19":"8","20to24":"75","25to34":"195","35to44":"160","45to54":"143","55to64":"91","65+":"23","medianAge":"91"}},"title":"Preschool and kindergarten teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2013":{"total":"695","women":"97.8","white":"12.1","black":"4.5","asian":"12.9"}},"wageData":{"2013":{"workers":"496","median":"638","maleWorkers":"12","maleMedian":"-","femaleWorkers":"484","femaleMedian":"624"}}},"Elementary and middle school teachers":{"ageData":{"2013":{"total":"3,038","16to19":"6","20to24":"132","25to34":"743","35to44":"838","45to54":"683","55to64":"506","65+":"130","medianAge":"506"}},"title":"Elementary and middle school teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2013":{"total":"3,038","women":"81.0","white":"9.4","black":"2.0","asian":"9.8"}},"wageData":{"2013":{"workers":"2,669","median":"954","maleWorkers":"531","maleMedian":"1,025","femaleWorkers":"2,138","femaleMedian":"937"}}},"Secondary school teachers":{"ageData":{"2013":{"total":"1,063","16to19":"2","20to24":"45","25to34":"303","35to44":"258","45to54":"229","55to64":"188","65+":"36","medianAge":"188"}},"title":"Secondary school teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2013":{"total":"1,063","women":"56.7","white":"6.6","black":"2.8","asian":"7.1"}},"wageData":{"2013":{"workers":"956","median":"1,031","maleWorkers":"427","maleMedian":"1,093","femaleWorkers":"529","femaleMedian":"986"}}},"Special education teachers":{"ageData":{"2013":{"total":"377","16to19":"3","20to24":"11","25to34":"99","35to44":"96","45to54":"95","55to64":"64","65+":"10","medianAge":"64"}},"title":"Special education teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2013":{"total":"377","women":"80.4","white":"9.9","black":"2.8","asian":"8.9"}},"wageData":{"2013":{"workers":"337","median":"951","maleWorkers":"65","maleMedian":"977","femaleWorkers":"271","femaleMedian":"944"}}},"Other teachers and instructors":{"ageData":{"2013":{"total":"753","16to19":"32","20to24":"107","25to34":"159","35to44":"136","45to54":"117","55to64":"130","65+":"71","medianAge":"130"}},"title":"Other teachers and instructors","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2013":{"total":"753","women":"63.8","white":"8.6","black":"5.5","asian":"9.1"}},"wageData":{"2013":{"workers":"336","median":"905","maleWorkers":"149","maleMedian":"1,055","femaleWorkers":"187","femaleMedian":"729"}}},"Archivists, curators, and museum technicians":{"ageData":{"2013":{"total":"41","16to19":"0","20to24":"1","25to34":"10","35to44":"6","45to54":"11","55to64":"8","65+":"5","medianAge":"8"}},"title":"Archivists, curators, and museum technicians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2013":{"total":"41","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"33","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"20","femaleMedian":"-"}}},"Librarians":{"ageData":{"2013":{"total":"194","16to19":"2","20to24":"7","25to34":"27","35to44":"35","45to54":"54","55to64":"53","65+":"17","medianAge":"53"}},"title":"Librarians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2013":{"total":"194","women":"84.1","white":"7.7","black":"2.1","asian":"5.1"}},"wageData":{"2013":{"workers":"149","median":"919","maleWorkers":"28","maleMedian":"-","femaleWorkers":"121","femaleMedian":"905"}}},"Library technicians":{"ageData":{"2013":{"total":"39","16to19":"4","20to24":"9","25to34":"6","35to44":"7","45to54":"5","55to64":"7","65+":"1","medianAge":"7"}},"title":"Library technicians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2013":{"total":"39","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"18","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"14","femaleMedian":"-"}}},"Teacher assistants":{"ageData":{"2013":{"total":"918","16to19":"26","20to24":"80","25to34":"164","35to44":"178","45to54":"255","55to64":"169","65+":"47","medianAge":"169"}},"title":"Teacher assistants","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2013":{"total":"918","women":"89.2","white":"14.5","black":"3.7","asian":"16.6"}},"wageData":{"2013":{"workers":"571","median":"479","maleWorkers":"70","maleMedian":"501","femaleWorkers":"501","femaleMedian":"475"}}},"Other education, training, and library workers":{"ageData":{"2013":{"total":"192","16to19":"2","20to24":"13","25to34":"37","35to44":"38","45to54":"40","55to64":"46","65+":"17","medianAge":"46"}},"title":"Other education, training, and library workers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2013":{"total":"192","women":"72.4","white":"14.3","black":"2.8","asian":"8.3"}},"wageData":{"2013":{"workers":"131","median":"1,031","maleWorkers":"39","maleMedian":"-","femaleWorkers":"91","femaleMedian":"992"}}},"Arts, design, entertainment, sports, and media occupations":{"ageData":{"2013":{"total":"2,879","16to19":"77","20to24":"300","25to34":"752","35to44":"594","45to54":"537","55to64":"435","65+":"183","medianAge":"435"}},"title":"Arts, design, entertainment, sports, and media occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2013":{"total":"2,879","women":"47.2","white":"6.5","black":"5.0","asian":"8.4"}},"wageData":{"2013":{"workers":"1,510","median":"988","maleWorkers":"861","maleMedian":"1,118","femaleWorkers":"649","femaleMedian":"884"}}},"Artists and related workers":{"ageData":{"2013":{"total":"194","16to19":"2","20to24":"7","25to34":"43","35to44":"32","45to54":"34","55to64":"48","65+":"27","medianAge":"48"}},"title":"Artists and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2013":{"total":"194","women":"56.4","white":"1.8","black":"5.6","asian":"5.1"}},"wageData":{"2013":{"workers":"63","median":"1,032","maleWorkers":"38","maleMedian":"-","femaleWorkers":"25","femaleMedian":"-"}}},"Designers":{"ageData":{"2013":{"total":"784","16to19":"5","20to24":"64","25to34":"214","35to44":"179","45to54":"170","55to64":"111","65+":"41","medianAge":"111"}},"title":"Designers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2013":{"total":"784","women":"53.5","white":"5.4","black":"6.9","asian":"9.9"}},"wageData":{"2013":{"workers":"514","median":"961","maleWorkers":"270","maleMedian":"1,095","femaleWorkers":"244","femaleMedian":"866"}}},"Actors":{"ageData":{"2013":{"total":"46","16to19":"0","20to24":"13","25to34":"10","35to44":"10","45to54":"10","55to64":"1","65+":"2","medianAge":"1"}},"title":"Actors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2013":{"total":"46","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"18","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Producers and directors":{"ageData":{"2013":{"total":"150","16to19":"0","20to24":"9","25to34":"46","35to44":"35","45to54":"33","55to64":"24","65+":"4","medianAge":"24"}},"title":"Producers and directors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2013":{"total":"150","women":"37.3","white":"6.3","black":"1.9","asian":"7.3"}},"wageData":{"2013":{"workers":"104","median":"1,166","maleWorkers":"66","maleMedian":"1,331","femaleWorkers":"38","femaleMedian":"-"}}},"Athletes, coaches, umpires, and related workers":{"ageData":{"2013":{"total":"288","16to19":"44","20to24":"66","25to34":"57","35to44":"40","45to54":"40","55to64":"28","65+":"12","medianAge":"28"}},"title":"Athletes, coaches, umpires, and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2013":{"total":"288","women":"34.8","white":"7.4","black":"2.1","asian":"5.5"}},"wageData":{"2013":{"workers":"115","median":"889","maleWorkers":"86","maleMedian":"934","femaleWorkers":"29","femaleMedian":"-"}}},"Dancers and choreographers":{"ageData":{"2013":{"total":"19","16to19":"1","20to24":"6","25to34":"6","35to44":"5","45to54":"1","55to64":"0","65+":"1","medianAge":"0"}},"title":"Dancers and choreographers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2013":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Musicians, singers, and related workers":{"ageData":{"2013":{"total":"202","16to19":"10","20to24":"11","25to34":"51","35to44":"36","45to54":"30","55to64":"45","65+":"18","medianAge":"45"}},"title":"Musicians, singers, and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2013":{"total":"202","women":"29.6","white":"12.2","black":"3.3","asian":"5.9"}},"wageData":{"2013":{"workers":"46","median":"-","maleWorkers":"33","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Entertainers and performers, sports and related workers, all other":{"ageData":{"2013":{"total":"35","16to19":"2","20to24":"3","25to34":"12","35to44":"5","45to54":"5","55to64":"8","65+":"1","medianAge":"8"}},"title":"Entertainers and performers, sports and related workers, all other","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2013":{"total":"35","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"9","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Announcers":{"ageData":{"2013":{"total":"48","16to19":"0","20to24":"7","25to34":"13","35to44":"12","45to54":"9","55to64":"2","65+":"5","medianAge":"2"}},"title":"Announcers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2013":{"total":"48","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"18","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"News analysts, reporters and correspondents":{"ageData":{"2013":{"total":"88","16to19":"0","20to24":"10","25to34":"28","35to44":"15","45to54":"10","55to64":"18","65+":"8","medianAge":"18"}},"title":"News analysts, reporters and correspondents","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2013":{"total":"88","women":"38.5","white":"7.8","black":"1.0","asian":"6.3"}},"wageData":{"2013":{"workers":"68","median":"1,041","maleWorkers":"46","maleMedian":"-","femaleWorkers":"22","femaleMedian":"-"}}},"Public relations specialists":{"ageData":{"2013":{"total":"149","16to19":"1","20to24":"14","25to34":"48","35to44":"37","45to54":"22","55to64":"22","65+":"5","medianAge":"22"}},"title":"Public relations specialists","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2013":{"total":"149","women":"63.3","white":"7.1","black":"4.2","asian":"5.7"}},"wageData":{"2013":{"workers":"109","median":"1,129","maleWorkers":"41","maleMedian":"-","femaleWorkers":"68","femaleMedian":"921"}}},"Editors":{"ageData":{"2013":{"total":"150","16to19":"3","20to24":"24","25to34":"34","35to44":"30","45to54":"30","55to64":"22","65+":"7","medianAge":"22"}},"title":"Editors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2013":{"total":"150","women":"54.6","white":"2.8","black":"4.3","asian":"4.9"}},"wageData":{"2013":{"workers":"112","median":"1,092","maleWorkers":"53","maleMedian":"1,239","femaleWorkers":"59","femaleMedian":"988"}}},"Technical writers":{"ageData":{"2013":{"total":"70","16to19":"0","20to24":"2","25to34":"13","35to44":"18","45to54":"20","55to64":"14","65+":"3","medianAge":"14"}},"title":"Technical writers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2013":{"total":"70","women":"55.5","white":"9.6","black":"3.7","asian":"3.4"}},"wageData":{"2013":{"workers":"57","median":"1,364","maleWorkers":"27","maleMedian":"-","femaleWorkers":"30","femaleMedian":"-"}}},"Writers and authors":{"ageData":{"2013":{"total":"209","16to19":"0","20to24":"14","25to34":"52","35to44":"35","45to54":"47","55to64":"34","65+":"27","medianAge":"34"}},"title":"Writers and authors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2013":{"total":"209","women":"57.8","white":"4.8","black":"3.9","asian":"4.9"}},"wageData":{"2013":{"workers":"79","median":"996","maleWorkers":"39","maleMedian":"-","femaleWorkers":"40","femaleMedian":"-"}}},"Miscellaneous media and communication workers":{"ageData":{"2013":{"total":"90","16to19":"1","20to24":"6","25to34":"24","35to44":"24","45to54":"17","55to64":"13","65+":"4","medianAge":"13"}},"title":"Miscellaneous media and communication workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2013":{"total":"90","women":"76.6","white":"6.4","black":"12.0","asian":"31.5"}},"wageData":{"2013":{"workers":"32","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"24","femaleMedian":"-"}}},"Broadcast and sound engineering technicians and radio operators":{"ageData":{"2013":{"total":"99","16to19":"2","20to24":"8","25to34":"34","35to44":"18","45to54":"22","55to64":"12","65+":"2","medianAge":"12"}},"title":"Broadcast and sound engineering technicians and radio operators","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2013":{"total":"99","women":"9.4","white":"8.2","black":"5.1","asian":"15.3"}},"wageData":{"2013":{"workers":"68","median":"947","maleWorkers":"61","maleMedian":"1,029","femaleWorkers":"7","femaleMedian":"-"}}},"Photographers":{"ageData":{"2013":{"total":"180","16to19":"5","20to24":"19","25to34":"46","35to44":"46","45to54":"26","55to64":"26","65+":"11","medianAge":"26"}},"title":"Photographers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2013":{"total":"180","women":"50.0","white":"6.4","black":"4.6","asian":"8.3"}},"wageData":{"2013":{"workers":"48","median":"-","maleWorkers":"31","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Television, video, and motion picture camera operators and editors":{"ageData":{"2013":{"total":"76","16to19":"2","20to24":"16","25to34":"23","35to44":"16","45to54":"9","55to64":"6","65+":"5","medianAge":"6"}},"title":"Television, video, and motion picture camera operators and editors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2013":{"total":"76","women":"15.9","white":"8.7","black":"6.5","asian":"10.7"}},"wageData":{"2013":{"workers":"45","median":"-","maleWorkers":"38","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Media and communication equipment workers, all other":{"ageData":{"2013":{"total":"1","16to19":"0","20to24":"1","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Media and communication equipment workers, all other","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2013":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Healthcare practitioners and technical occupations":{"ageData":{"2013":{"total":"8,182","16to19":"22","20to24":"408","25to34":"2,000","35to44":"2,010","45to54":"1,828","55to64":"1,512","65+":"403","medianAge":"1,512"}},"title":"Healthcare practitioners and technical occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2013":{"total":"8,182","women":"74.4","white":"10.5","black":"9.3","asian":"7.4"}},"wageData":{"2013":{"workers":"6,142","median":"1,048","maleWorkers":"1,558","maleMedian":"1,312","femaleWorkers":"4,585","femaleMedian":"994"}}},"Chiropractors":{"ageData":{"2013":{"total":"58","16to19":"0","20to24":"0","25to34":"10","35to44":"19","45to54":"15","55to64":"7","65+":"6","medianAge":"7"}},"title":"Chiropractors","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"58","women":"18.6","white":"0.0","black":"2.3","asian":"2.3"}},"wageData":{"2013":{"workers":"13","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Dentists":{"ageData":{"2013":{"total":"183","16to19":"0","20to24":"2","25to34":"28","35to44":"46","45to54":"47","55to64":"42","65+":"18","medianAge":"42"}},"title":"Dentists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"183","women":"30.8","white":"4.7","black":"13.1","asian":"7.2"}},"wageData":{"2013":{"workers":"55","median":"1,533","maleWorkers":"37","maleMedian":"-","femaleWorkers":"18","femaleMedian":"-"}}},"Dietitians and nutritionists":{"ageData":{"2013":{"total":"110","16to19":"0","20to24":"7","25to34":"23","35to44":"25","45to54":"25","55to64":"22","65+":"8","medianAge":"22"}},"title":"Dietitians and nutritionists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"110","women":"89.7","white":"14.6","black":"5.3","asian":"8.1"}},"wageData":{"2013":{"workers":"82","median":"885","maleWorkers":"10","maleMedian":"-","femaleWorkers":"71","femaleMedian":"864"}}},"Optometrists":{"ageData":{"2013":{"total":"41","16to19":"0","20to24":"0","25to34":"6","35to44":"8","45to54":"9","55to64":"15","65+":"3","medianAge":"15"}},"title":"Optometrists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"41","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"14","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Pharmacists":{"ageData":{"2013":{"total":"277","16to19":"0","20to24":"11","25to34":"75","35to44":"73","45to54":"55","55to64":"45","65+":"18","medianAge":"45"}},"title":"Pharmacists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"277","women":"56.0","white":"5.4","black":"22.0","asian":"4.4"}},"wageData":{"2013":{"workers":"215","median":"1,960","maleWorkers":"98","maleMedian":"2,092","femaleWorkers":"117","femaleMedian":"1,802"}}},"Physicians and surgeons":{"ageData":{"2013":{"total":"934","16to19":"0","20to24":"5","25to34":"192","35to44":"243","45to54":"213","55to64":"170","65+":"111","medianAge":"170"}},"title":"Physicians and surgeons","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"934","women":"35.5","white":"6.4","black":"21.6","asian":"3.8"}},"wageData":{"2013":{"workers":"667","median":"1,885","maleWorkers":"426","maleMedian":"2,087","femaleWorkers":"241","femaleMedian":"1,497"}}},"Physician assistants":{"ageData":{"2013":{"total":"129","16to19":"1","20to24":"7","25to34":"41","35to44":"35","45to54":"22","55to64":"18","65+":"4","medianAge":"18"}},"title":"Physician assistants","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"129","women":"64.6","white":"4.9","black":"4.3","asian":"10.4"}},"wageData":{"2013":{"workers":"103","median":"1,456","maleWorkers":"36","maleMedian":"-","femaleWorkers":"67","femaleMedian":"1,491"}}},"Podiatrists":{"ageData":{"2013":{"total":"12","16to19":"0","20to24":"0","25to34":"1","35to44":"4","45to54":"3","55to64":"1","65+":"2","medianAge":"1"}},"title":"Podiatrists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"4","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Audiologists":{"ageData":{"2013":{"total":"16","16to19":"0","20to24":"0","25to34":"2","35to44":"5","45to54":"3","55to64":"4","65+":"2","medianAge":"4"}},"title":"Audiologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"16","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"10","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Occupational therapists":{"ageData":{"2013":{"total":"112","16to19":"0","20to24":"3","25to34":"35","35to44":"35","45to54":"24","55to64":"13","65+":"2","medianAge":"13"}},"title":"Occupational therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"112","women":"88.4","white":"2.5","black":"5.4","asian":"4.8"}},"wageData":{"2013":{"workers":"78","median":"1,295","maleWorkers":"11","maleMedian":"-","femaleWorkers":"68","femaleMedian":"1,240"}}},"Physical therapists":{"ageData":{"2013":{"total":"224","16to19":"0","20to24":"7","25to34":"71","35to44":"57","45to54":"50","55to64":"28","65+":"10","medianAge":"28"}},"title":"Physical therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"224","women":"60.6","white":"6.5","black":"8.7","asian":"6.5"}},"wageData":{"2013":{"workers":"161","median":"1,382","maleWorkers":"74","maleMedian":"1,457","femaleWorkers":"87","femaleMedian":"1,300"}}},"Radiation therapists":{"ageData":{"2013":{"total":"13","16to19":"0","20to24":"1","25to34":"4","35to44":"4","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Radiation therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"12","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Recreational therapists":{"ageData":{"2013":{"total":"9","16to19":"0","20to24":"1","25to34":"2","35to44":"2","45to54":"4","55to64":"1","65+":"0","medianAge":"1"}},"title":"Recreational therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"10","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Respiratory therapists":{"ageData":{"2013":{"total":"110","16to19":"0","20to24":"2","25to34":"20","35to44":"25","45to54":"28","55to64":"28","65+":"7","medianAge":"28"}},"title":"Respiratory therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"110","women":"60.0","white":"11.6","black":"8.2","asian":"6.3"}},"wageData":{"2013":{"workers":"96","median":"1,095","maleWorkers":"44","maleMedian":"-","femaleWorkers":"52","femaleMedian":"1,059"}}},"Speech-language pathologists":{"ageData":{"2013":{"total":"137","16to19":"0","20to24":"2","25to34":"44","35to44":"34","45to54":"26","55to64":"26","65+":"5","medianAge":"26"}},"title":"Speech-language pathologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"137","women":"93.4","white":"3.2","black":"3.5","asian":"6.7"}},"wageData":{"2013":{"workers":"98","median":"1,218","maleWorkers":"5","maleMedian":"-","femaleWorkers":"93","femaleMedian":"1,191"}}},"Exercise physiologists":{"ageData":{"2013":{"total":"6","16to19":"0","20to24":"0","25to34":"1","35to44":"2","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Exercise physiologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"4","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Therapists, all other":{"ageData":{"2013":{"total":"147","16to19":"0","20to24":"8","25to34":"45","35to44":"34","45to54":"21","55to64":"31","65+":"9","medianAge":"31"}},"title":"Therapists, all other","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"147","women":"79.0","white":"10.5","black":"3.4","asian":"12.7"}},"wageData":{"2013":{"workers":"96","median":"864","maleWorkers":"19","maleMedian":"-","femaleWorkers":"77","femaleMedian":"870"}}},"Veterinarians":{"ageData":{"2013":{"total":"87","16to19":"1","20to24":"1","25to34":"16","35to44":"26","45to54":"18","55to64":"24","65+":"3","medianAge":"24"}},"title":"Veterinarians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"87","women":"54.7","white":"1.5","black":"0.6","asian":"7.7"}},"wageData":{"2013":{"workers":"41","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"23","femaleMedian":"-"}}},"Registered nurses":{"ageData":{"2013":{"total":"2,892","16to19":"2","20to24":"127","25to34":"685","35to44":"710","45to54":"667","55to64":"597","65+":"105","medianAge":"597"}},"title":"Registered nurses","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"2,892","women":"90.1","white":"10.5","black":"8.0","asian":"6.5"}},"wageData":{"2013":{"workers":"2,278","median":"1,099","maleWorkers":"254","maleMedian":"1,236","femaleWorkers":"2,023","femaleMedian":"1,086"}}},"Nurse anesthetists":{"ageData":{"2013":{"total":"24","16to19":"0","20to24":"0","25to34":"3","35to44":"10","45to54":"5","55to64":"6","65+":"0","medianAge":"6"}},"title":"Nurse anesthetists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"24","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"22","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"14","femaleMedian":"-"}}},"Nurse midwives":{"ageData":{"2013":{"total":"2","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Nurse midwives","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"3","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Nurse practitioners":{"ageData":{"2013":{"total":"126","16to19":"0","20to24":"0","25to34":"26","35to44":"32","45to54":"36","55to64":"26","65+":"6","medianAge":"26"}},"title":"Nurse practitioners","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"126","women":"91.8","white":"5.8","black":"5.9","asian":"7.1"}},"wageData":{"2013":{"workers":"102","median":"1,615","maleWorkers":"11","maleMedian":"-","femaleWorkers":"91","femaleMedian":"1,539"}}},"Health diagnosing and treating practitioners, all other":{"ageData":{"2013":{"total":"25","16to19":"0","20to24":"0","25to34":"3","35to44":"7","45to54":"10","55to64":"4","65+":"2","medianAge":"4"}},"title":"Health diagnosing and treating practitioners, all other","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"25","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"7","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Clinical laboratory technologists and technicians":{"ageData":{"2013":{"total":"340","16to19":"2","20to24":"19","25to34":"87","35to44":"69","45to54":"75","55to64":"72","65+":"17","medianAge":"72"}},"title":"Clinical laboratory technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"340","women":"72.9","white":"17.6","black":"12.3","asian":"11.3"}},"wageData":{"2013":{"workers":"307","median":"891","maleWorkers":"81","maleMedian":"980","femaleWorkers":"226","femaleMedian":"858"}}},"Dental hygienists":{"ageData":{"2013":{"total":"184","16to19":"0","20to24":"10","25to34":"44","35to44":"46","45to54":"51","55to64":"28","65+":"5","medianAge":"28"}},"title":"Dental hygienists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"184","women":"98.3","white":"4.8","black":"5.3","asian":"5.9"}},"wageData":{"2013":{"workers":"82","median":"1,005","maleWorkers":"2","maleMedian":"-","femaleWorkers":"80","femaleMedian":"1,011"}}},"Diagnostic related technologists and technicians":{"ageData":{"2013":{"total":"362","16to19":"0","20to24":"19","25to34":"107","35to44":"86","45to54":"73","55to64":"70","65+":"7","medianAge":"70"}},"title":"Diagnostic related technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"362","women":"72.0","white":"8.3","black":"3.7","asian":"8.5"}},"wageData":{"2013":{"workers":"287","median":"919","maleWorkers":"92","maleMedian":"959","femaleWorkers":"195","femaleMedian":"909"}}},"Emergency medical technicians and paramedics":{"ageData":{"2013":{"total":"176","16to19":"2","20to24":"26","25to34":"59","35to44":"50","45to54":"26","55to64":"11","65+":"1","medianAge":"11"}},"title":"Emergency medical technicians and paramedics","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"176","women":"39.2","white":"5.5","black":"2.2","asian":"9.2"}},"wageData":{"2013":{"workers":"140","median":"796","maleWorkers":"82","maleMedian":"832","femaleWorkers":"58","femaleMedian":"785"}}},"Health practitioner support technologists and technicians":{"ageData":{"2013":{"total":"554","16to19":"11","20to24":"91","25to34":"172","35to44":"110","45to54":"98","55to64":"55","65+":"16","medianAge":"55"}},"title":"Health practitioner support technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"554","women":"80.5","white":"14.6","black":"6.6","asian":"12.7"}},"wageData":{"2013":{"workers":"416","median":"619","maleWorkers":"78","maleMedian":"664","femaleWorkers":"337","femaleMedian":"613"}}},"Licensed practical and licensed vocational nurses":{"ageData":{"2013":{"total":"558","16to19":"2","20to24":"35","25to34":"115","35to44":"143","45to54":"141","55to64":"103","65+":"19","medianAge":"103"}},"title":"Licensed practical and licensed vocational nurses","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"558","women":"91.5","white":"25.2","black":"5.1","asian":"10.6"}},"wageData":{"2013":{"workers":"444","median":"741","maleWorkers":"40","maleMedian":"-","femaleWorkers":"404","femaleMedian":"732"}}},"Medical records and health information technicians":{"ageData":{"2013":{"total":"88","16to19":"0","20to24":"5","25to34":"12","35to44":"18","45to54":"26","55to64":"21","65+":"6","medianAge":"21"}},"title":"Medical records and health information technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"88","women":"92.4","white":"22.4","black":"4.4","asian":"14.6"}},"wageData":{"2013":{"workers":"78","median":"612","maleWorkers":"6","maleMedian":"-","femaleWorkers":"72","femaleMedian":"595"}}},"Opticians, dispensing":{"ageData":{"2013":{"total":"47","16to19":"0","20to24":"6","25to34":"9","35to44":"8","45to54":"12","55to64":"8","65+":"4","medianAge":"8"}},"title":"Opticians, dispensing","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"47","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"37","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"25","femaleMedian":"-"}}},"Miscellaneous health technologists and technicians":{"ageData":{"2013":{"total":"122","16to19":"0","20to24":"8","25to34":"33","35to44":"25","45to54":"31","55to64":"20","65+":"5","medianAge":"20"}},"title":"Miscellaneous health technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"122","women":"70.1","white":"21.2","black":"12.1","asian":"11.2"}},"wageData":{"2013":{"workers":"114","median":"849","maleWorkers":"41","maleMedian":"-","femaleWorkers":"73","femaleMedian":"782"}}},"Other healthcare practitioners and technical occupations":{"ageData":{"2013":{"total":"76","16to19":"0","20to24":"6","25to34":"25","35to44":"20","45to54":"12","55to64":"12","65+":"1","medianAge":"12"}},"title":"Other healthcare practitioners and technical occupations","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2013":{"total":"76","women":"52.6","white":"6.9","black":"3.5","asian":"9.3"}},"wageData":{"2013":{"workers":"69","median":"1,065","maleWorkers":"37","maleMedian":"-","femaleWorkers":"31","femaleMedian":"-"}}},"Service occupations":{"ageData":{"2013":{"total":"25,929","16to19":"1,897","20to24":"3,939","25to34":"5,774","35to44":"4,956","45to54":"4,930","55to64":"3,241","65+":"1,192","medianAge":"3,241"}},"title":"Service occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2013":{"total":"25,929","women":"56.6","white":"15.9","black":"5.4","asian":"23.1"}},"wageData":{"2013":{"workers":"15,052","median":"493","maleWorkers":"7,597","maleMedian":"555","femaleWorkers":"7,456","femaleMedian":"452"}}},"Healthcare support occupations":{"ageData":{"2013":{"total":"3,537","16to19":"74","20to24":"529","25to34":"900","35to44":"726","45to54":"708","55to64":"473","65+":"127","medianAge":"473"}},"title":"Healthcare support occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2013":{"total":"3,537","women":"88.9","white":"26.4","black":"4.7","asian":"16.0"}},"wageData":{"2013":{"workers":"2,324","median":"491","maleWorkers":"304","maleMedian":"546","femaleWorkers":"2,020","femaleMedian":"486"}}},"Nursing, psychiatric, and home health aides":{"ageData":{"2013":{"total":"2,134","16to19":"43","20to24":"300","25to34":"495","35to44":"433","45to54":"458","55to64":"315","65+":"90","medianAge":"315"}},"title":"Nursing, psychiatric, and home health aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2013":{"total":"2,134","women":"89.0","white":"36.4","black":"4.7","asian":"14.9"}},"wageData":{"2013":{"workers":"1,393","median":"457","maleWorkers":"186","maleMedian":"499","femaleWorkers":"1,207","femaleMedian":"450"}}},"Occupational therapy assistants and aides":{"ageData":{"2013":{"total":"19","16to19":"0","20to24":"1","25to34":"9","35to44":"3","45to54":"3","55to64":"2","65+":"1","medianAge":"2"}},"title":"Occupational therapy assistants and aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2013":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"11","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Physical therapist assistants and aides":{"ageData":{"2013":{"total":"68","16to19":"3","20to24":"15","25to34":"16","35to44":"10","45to54":"15","55to64":"9","65+":"0","medianAge":"9"}},"title":"Physical therapist assistants and aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2013":{"total":"68","women":"70.1","white":"6.2","black":"5.7","asian":"9.1"}},"wageData":{"2013":{"workers":"39","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"26","femaleMedian":"-"}}},"Massage therapists":{"ageData":{"2013":{"total":"172","16to19":"0","20to24":"21","25to34":"42","35to44":"40","45to54":"33","55to64":"28","65+":"9","medianAge":"28"}},"title":"Massage therapists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2013":{"total":"172","women":"82.0","white":"4.3","black":"9.3","asian":"9.2"}},"wageData":{"2013":{"workers":"48","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"32","femaleMedian":"-"}}},"Dental assistants":{"ageData":{"2013":{"total":"279","16to19":"3","20to24":"43","25to34":"90","35to44":"64","45to54":"56","55to64":"19","65+":"4","medianAge":"19"}},"title":"Dental assistants","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2013":{"total":"279","women":"95.7","white":"5.7","black":"5.4","asian":"22.9"}},"wageData":{"2013":{"workers":"181","median":"571","maleWorkers":"7","maleMedian":"-","femaleWorkers":"174","femaleMedian":"571"}}},"Medical assistants":{"ageData":{"2013":{"total":"458","16to19":"3","20to24":"91","25to34":"144","35to44":"103","45to54":"63","55to64":"47","65+":"8","medianAge":"47"}},"title":"Medical assistants","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2013":{"total":"458","women":"94.1","white":"13.1","black":"4.0","asian":"24.8"}},"wageData":{"2013":{"workers":"365","median":"531","maleWorkers":"26","maleMedian":"-","femaleWorkers":"339","femaleMedian":"523"}}},"Medical transcriptionists":{"ageData":{"2013":{"total":"52","16to19":"0","20to24":"2","25to34":"5","35to44":"10","45to54":"14","55to64":"17","65+":"4","medianAge":"17"}},"title":"Medical transcriptionists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2013":{"total":"52","women":"97.8","white":"4.6","black":"0.0","asian":"8.0"}},"wageData":{"2013":{"workers":"34","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"33","femaleMedian":"-"}}},"Pharmacy aides":{"ageData":{"2013":{"total":"36","16to19":"2","20to24":"10","25to34":"9","35to44":"3","45to54":"4","55to64":"5","65+":"3","medianAge":"5"}},"title":"Pharmacy aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2013":{"total":"36","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"22","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"19","femaleMedian":"-"}}},"Veterinary assistants and laboratory animal caretakers":{"ageData":{"2013":{"total":"40","16to19":"5","20to24":"11","25to34":"14","35to44":"3","45to54":"4","55to64":"3","65+":"0","medianAge":"3"}},"title":"Veterinary assistants and laboratory animal caretakers","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2013":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"23","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"20","femaleMedian":"-"}}},"Phlebotomists":{"ageData":{"2013":{"total":"119","16to19":"0","20to24":"12","25to34":"44","35to44":"28","45to54":"25","55to64":"8","65+":"2","medianAge":"8"}},"title":"Phlebotomists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2013":{"total":"119","women":"81.8","white":"29.1","black":"3.7","asian":"14.3"}},"wageData":{"2013":{"workers":"97","median":"583","maleWorkers":"19","maleMedian":"-","femaleWorkers":"77","femaleMedian":"573"}}},"Miscellaneous healthcare support occupations, including medical equipment preparers":{"ageData":{"2013":{"total":"160","16to19":"13","20to24":"23","25to34":"34","35to44":"30","45to54":"33","55to64":"21","65+":"6","medianAge":"21"}},"title":"Miscellaneous healthcare support occupations, including medical equipment preparers","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2013":{"total":"160","women":"77.8","white":"17.6","black":"4.8","asian":"7.6"}},"wageData":{"2013":{"workers":"112","median":"462","maleWorkers":"31","maleMedian":"-","femaleWorkers":"81","femaleMedian":"440"}}},"Protective service occupations":{"ageData":{"2013":{"total":"3,130","16to19":"108","20to24":"246","25to34":"746","35to44":"807","45to54":"706","55to64":"370","65+":"146","medianAge":"370"}},"title":"Protective service occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2013":{"total":"3,130","women":"21.1","white":"18.6","black":"2.4","asian":"15.1"}},"wageData":{"2013":{"workers":"2,685","median":"783","maleWorkers":"2,172","maleMedian":"824","femaleWorkers":"512","femaleMedian":"643"}}},"First-line supervisors of correctional officers":{"ageData":{"2013":{"total":"36","16to19":"0","20to24":"1","25to34":"10","35to44":"8","45to54":"12","55to64":"4","65+":"0","medianAge":"4"}},"title":"First-line supervisors of correctional officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2013":{"total":"36","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"33","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"First-line supervisors of police and detectives":{"ageData":{"2013":{"total":"115","16to19":"0","20to24":"1","25to34":"7","35to44":"37","45to54":"48","55to64":"20","65+":"2","medianAge":"20"}},"title":"First-line supervisors of police and detectives","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2013":{"total":"115","women":"15.3","white":"8.6","black":"1.5","asian":"10.5"}},"wageData":{"2013":{"workers":"114","median":"1,139","maleWorkers":"97","maleMedian":"1,182","femaleWorkers":"17","femaleMedian":"-"}}},"First-line supervisors of fire fighting and prevention workers":{"ageData":{"2013":{"total":"58","16to19":"0","20to24":"0","25to34":"8","35to44":"17","45to54":"19","55to64":"12","65+":"2","medianAge":"12"}},"title":"First-line supervisors of fire fighting and prevention workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2013":{"total":"58","women":"0.1","white":"4.5","black":"0.2","asian":"3.5"}},"wageData":{"2013":{"workers":"60","median":"1,082","maleWorkers":"60","maleMedian":"1,082","femaleWorkers":"0","femaleMedian":"-"}}},"First-line supervisors of protective service workers, all other":{"ageData":{"2013":{"total":"100","16to19":"0","20to24":"1","25to34":"23","35to44":"21","45to54":"29","55to64":"19","65+":"6","medianAge":"19"}},"title":"First-line supervisors of protective service workers, all other","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2013":{"total":"100","women":"21.7","white":"29.4","black":"1.5","asian":"11.6"}},"wageData":{"2013":{"workers":"82","median":"785","maleWorkers":"57","maleMedian":"788","femaleWorkers":"25","femaleMedian":"-"}}},"Firefighters":{"ageData":{"2013":{"total":"306","16to19":"3","20to24":"18","25to34":"92","35to44":"95","45to54":"68","55to64":"26","65+":"3","medianAge":"26"}},"title":"Firefighters","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2013":{"total":"306","women":"3.5","white":"11.4","black":"0.7","asian":"8.5"}},"wageData":{"2013":{"workers":"294","median":"996","maleWorkers":"285","maleMedian":"1,000","femaleWorkers":"9","femaleMedian":"-"}}},"Fire inspectors":{"ageData":{"2013":{"total":"19","16to19":"0","20to24":"1","25to34":"2","35to44":"3","45to54":"7","55to64":"5","65+":"1","medianAge":"5"}},"title":"Fire inspectors","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2013":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"18","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Bailiffs, correctional officers, and jailers":{"ageData":{"2013":{"total":"413","16to19":"2","20to24":"37","25to34":"96","35to44":"133","45to54":"94","55to64":"40","65+":"11","medianAge":"40"}},"title":"Bailiffs, correctional officers, and jailers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2013":{"total":"413","women":"27.2","white":"23.6","black":"1.1","asian":"20.9"}},"wageData":{"2013":{"workers":"418","median":"683","maleWorkers":"298","maleMedian":"729","femaleWorkers":"120","femaleMedian":"599"}}},"Detectives and criminal investigators":{"ageData":{"2013":{"total":"158","16to19":"0","20to24":"2","25to34":"28","35to44":"59","45to54":"41","55to64":"25","65+":"3","medianAge":"25"}},"title":"Detectives and criminal investigators","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2013":{"total":"158","women":"20.1","white":"13.8","black":"1.0","asian":"14.9"}},"wageData":{"2013":{"workers":"159","median":"1,054","maleWorkers":"128","maleMedian":"1,120","femaleWorkers":"30","femaleMedian":"-"}}},"Fish and game wardens":{"ageData":{"2013":{"total":"2","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Fish and game wardens","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2013":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Parking enforcement workers":{"ageData":{"2013":{"total":"9","16to19":"0","20to24":"0","25to34":"2","35to44":"2","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Parking enforcement workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2013":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"5","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Police and sheriff\'s patrol officers":{"ageData":{"2013":{"total":"697","16to19":"2","20to24":"26","25to34":"212","35to44":"235","45to54":"157","55to64":"51","65+":"14","medianAge":"51"}},"title":"Police and sheriff\'s patrol officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2013":{"total":"697","women":"13.4","white":"14.2","black":"2.4","asian":"15.3"}},"wageData":{"2013":{"workers":"682","median":"1,007","maleWorkers":"593","maleMedian":"1,032","femaleWorkers":"89","femaleMedian":"881"}}},"Transit and railroad police":{"ageData":{"2013":{"total":"1","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Transit and railroad police","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2013":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Animal control workers":{"ageData":{"2013":{"total":"11","16to19":"0","20to24":"0","25to34":"3","35to44":"4","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Animal control workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2013":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"10","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Private detectives and investigators":{"ageData":{"2013":{"total":"86","16to19":"1","20to24":"3","25to34":"20","35to44":"26","45to54":"16","55to64":"13","65+":"7","medianAge":"13"}},"title":"Private detectives and investigators","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2013":{"total":"86","women":"38.5","white":"6.6","black":"4.4","asian":"15.9"}},"wageData":{"2013":{"workers":"72","median":"948","maleWorkers":"40","maleMedian":"-","femaleWorkers":"32","femaleMedian":"-"}}},"Security guards and gaming surveillance officers":{"ageData":{"2013":{"total":"858","16to19":"13","20to24":"115","25to34":"218","35to44":"142","45to54":"171","55to64":"121","65+":"77","medianAge":"121"}},"title":"Security guards and gaming surveillance officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2013":{"total":"858","women":"20.4","white":"26.5","black":"4.0","asian":"17.1"}},"wageData":{"2013":{"workers":"643","median":"532","maleWorkers":"517","maleMedian":"549","femaleWorkers":"125","femaleMedian":"500"}}},"Crossing guards":{"ageData":{"2013":{"total":"61","16to19":"1","20to24":"6","25to34":"6","35to44":"12","45to54":"13","55to64":"12","65+":"11","medianAge":"12"}},"title":"Crossing guards","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2013":{"total":"61","women":"69.1","white":"28.3","black":"3.3","asian":"9.1"}},"wageData":{"2013":{"workers":"14","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Transportation security screeners":{"ageData":{"2013":{"total":"28","16to19":"0","20to24":"1","25to34":"6","35to44":"8","45to54":"10","55to64":"3","65+":"0","medianAge":"3"}},"title":"Transportation security screeners","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2013":{"total":"28","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"25","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Lifeguards and other recreational, and all other protective service workers":{"ageData":{"2013":{"total":"175","16to19":"85","20to24":"34","25to34":"11","35to44":"7","45to54":"16","55to64":"14","65+":"9","medianAge":"14"}},"title":"Lifeguards and other recreational, and all other protective service workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2013":{"total":"175","women":"56.4","white":"10.4","black":"2.2","asian":"9.2"}},"wageData":{"2013":{"workers":"52","median":"484","maleWorkers":"16","maleMedian":"-","femaleWorkers":"36","femaleMedian":"-"}}},"Food preparation and serving related occupations":{"ageData":{"2013":{"total":"8,209","16to19":"1,210","20to24":"1,971","25to34":"1,946","35to44":"1,188","45to54":"1,057","55to64":"616","65+":"221","medianAge":"616"}},"title":"Food preparation and serving related occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2013":{"total":"8,209","women":"54.7","white":"12.2","black":"5.7","asian":"24.4"}},"wageData":{"2013":{"workers":"4,140","median":"416","maleWorkers":"2,187","maleMedian":"437","femaleWorkers":"1,953","femaleMedian":"400"}}},"Chefs and head cooks":{"ageData":{"2013":{"total":"425","16to19":"9","20to24":"46","25to34":"125","35to44":"106","45to54":"92","55to64":"36","65+":"11","medianAge":"36"}},"title":"Chefs and head cooks","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2013":{"total":"425","women":"20.0","white":"13.7","black":"13.6","asian":"19.1"}},"wageData":{"2013":{"workers":"351","median":"574","maleWorkers":"282","maleMedian":"589","femaleWorkers":"69","femaleMedian":"510"}}},"First-line supervisors of food preparation and serving workers":{"ageData":{"2013":{"total":"581","16to19":"27","20to24":"123","25to34":"153","35to44":"106","45to54":"98","55to64":"54","65+":"20","medianAge":"54"}},"title":"First-line supervisors of food preparation and serving workers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2013":{"total":"581","women":"58.0","white":"13.1","black":"4.6","asian":"18.5"}},"wageData":{"2013":{"workers":"423","median":"491","maleWorkers":"174","maleMedian":"580","femaleWorkers":"249","femaleMedian":"448"}}},"Cooks":{"ageData":{"2013":{"total":"1,988","16to19":"197","20to24":"371","25to34":"502","35to44":"355","45to54":"305","55to64":"205","65+":"53","medianAge":"205"}},"title":"Cooks","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2013":{"total":"1,988","women":"39.7","white":"15.3","black":"5.5","asian":"34.0"}},"wageData":{"2013":{"workers":"1,209","median":"402","maleWorkers":"791","maleMedian":"411","femaleWorkers":"418","femaleMedian":"382"}}},"Food preparation workers":{"ageData":{"2013":{"total":"885","16to19":"175","20to24":"216","25to34":"183","35to44":"114","45to54":"113","55to64":"58","65+":"27","medianAge":"58"}},"title":"Food preparation workers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2013":{"total":"885","women":"55.8","white":"12.7","black":"5.9","asian":"29.3"}},"wageData":{"2013":{"workers":"398","median":"387","maleWorkers":"206","maleMedian":"392","femaleWorkers":"191","femaleMedian":"380"}}},"Bartenders":{"ageData":{"2013":{"total":"417","16to19":"4","20to24":"85","25to34":"165","35to44":"75","45to54":"44","55to64":"35","65+":"11","medianAge":"35"}},"title":"Bartenders","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2013":{"total":"417","women":"58.0","white":"5.5","black":"2.4","asian":"13.5"}},"wageData":{"2013":{"workers":"207","median":"513","maleWorkers":"98","maleMedian":"594","femaleWorkers":"109","femaleMedian":"483"}}},"Combined food preparation and serving workers, including fast food":{"ageData":{"2013":{"total":"377","16to19":"69","20to24":"101","25to34":"78","35to44":"37","45to54":"49","55to64":"30","65+":"14","medianAge":"30"}},"title":"Combined food preparation and serving workers, including fast food","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2013":{"total":"377","women":"65.3","white":"16.4","black":"3.2","asian":"16.1"}},"wageData":{"2013":{"workers":"175","median":"384","maleWorkers":"68","maleMedian":"413","femaleWorkers":"107","femaleMedian":"370"}}},"Counter attendants, cafeteria, food concession, and coffee shop":{"ageData":{"2013":{"total":"221","16to19":"110","20to24":"57","25to34":"24","35to44":"15","45to54":"7","55to64":"4","65+":"3","medianAge":"4"}},"title":"Counter attendants, cafeteria, food concession, and coffee shop","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2013":{"total":"221","women":"70.1","white":"12.2","black":"3.0","asian":"15.4"}},"wageData":{"2013":{"workers":"57","median":"320","maleWorkers":"14","maleMedian":"-","femaleWorkers":"43","femaleMedian":"-"}}},"Waiters and waitresses":{"ageData":{"2013":{"total":"2,124","16to19":"323","20to24":"708","25to34":"524","35to44":"250","45to54":"196","55to64":"87","65+":"35","medianAge":"87"}},"title":"Waiters and waitresses","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2013":{"total":"2,124","women":"70.4","white":"8.1","black":"6.5","asian":"19.4"}},"wageData":{"2013":{"workers":"883","median":"413","maleWorkers":"325","maleMedian":"449","femaleWorkers":"558","femaleMedian":"400"}}},"Food servers, nonrestaurant":{"ageData":{"2013":{"total":"229","16to19":"29","20to24":"46","25to34":"41","35to44":"39","45to54":"36","55to64":"26","65+":"12","medianAge":"26"}},"title":"Food servers, nonrestaurant","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2013":{"total":"229","women":"67.2","white":"18.5","black":"6.3","asian":"17.4"}},"wageData":{"2013":{"workers":"109","median":"458","maleWorkers":"36","maleMedian":"-","femaleWorkers":"74","femaleMedian":"410"}}},"Dining room and cafeteria attendants and bartender helpers":{"ageData":{"2013":{"total":"358","16to19":"81","20to24":"66","25to34":"59","35to44":"40","45to54":"54","55to64":"39","65+":"19","medianAge":"39"}},"title":"Dining room and cafeteria attendants and bartender helpers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2013":{"total":"358","women":"45.6","white":"11.0","black":"4.3","asian":"31.4"}},"wageData":{"2013":{"workers":"130","median":"412","maleWorkers":"76","maleMedian":"426","femaleWorkers":"55","femaleMedian":"398"}}},"Dishwashers":{"ageData":{"2013":{"total":"301","16to19":"62","20to24":"61","25to34":"63","35to44":"33","45to54":"47","55to64":"26","65+":"9","medianAge":"26"}},"title":"Dishwashers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2013":{"total":"301","women":"20.6","white":"15.6","black":"5.8","asian":"37.9"}},"wageData":{"2013":{"workers":"127","median":"356","maleWorkers":"106","maleMedian":"359","femaleWorkers":"21","femaleMedian":"-"}}},"Hosts and hostesses, restaurant, lounge, and coffee shop":{"ageData":{"2013":{"total":"299","16to19":"124","20to24":"90","25to34":"30","35to44":"18","45to54":"14","55to64":"16","65+":"8","medianAge":"16"}},"title":"Hosts and hostesses, restaurant, lounge, and coffee shop","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2013":{"total":"299","women":"88.5","white":"12.5","black":"3.0","asian":"16.0"}},"wageData":{"2013":{"workers":"69","median":"393","maleWorkers":"9","maleMedian":"-","femaleWorkers":"60","femaleMedian":"391"}}},"Food preparation and serving related workers, all other":{"ageData":{"2013":{"total":"4","16to19":"2","20to24":"1","25to34":"0","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Food preparation and serving related workers, all other","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2013":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Building and grounds cleaning and maintenance occupations":{"ageData":{"2013":{"total":"5,661","16to19":"207","20to24":"457","25to34":"1,027","35to44":"1,220","45to54":"1,380","55to64":"1,015","65+":"355","medianAge":"1,015"}},"title":"Building and grounds cleaning and maintenance occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2013":{"total":"5,661","women":"38.7","white":"14.6","black":"3.4","asian":"35.9"}},"wageData":{"2013":{"workers":"3,421","median":"475","maleWorkers":"2,279","maleMedian":"505","femaleWorkers":"1,142","femaleMedian":"417"}}},"First-line supervisors of housekeeping and janitorial workers":{"ageData":{"2013":{"total":"322","16to19":"1","20to24":"7","25to34":"45","35to44":"72","45to54":"112","55to64":"64","65+":"20","medianAge":"64"}},"title":"First-line supervisors of housekeeping and janitorial workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2013":{"total":"322","women":"41.4","white":"14.6","black":"2.8","asian":"20.0"}},"wageData":{"2013":{"workers":"186","median":"638","maleWorkers":"108","maleMedian":"801","femaleWorkers":"78","femaleMedian":"511"}}},"First-line supervisors of landscaping, lawn service, and groundskeeping workers":{"ageData":{"2013":{"total":"259","16to19":"1","20to24":"10","25to34":"45","35to44":"67","45to54":"77","55to64":"46","65+":"13","medianAge":"46"}},"title":"First-line supervisors of landscaping, lawn service, and groundskeeping workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2013":{"total":"259","women":"7.4","white":"7.2","black":"2.0","asian":"19.3"}},"wageData":{"2013":{"workers":"104","median":"766","maleWorkers":"99","maleMedian":"759","femaleWorkers":"5","femaleMedian":"-"}}},"Janitors and building cleaners":{"ageData":{"2013":{"total":"2,275","16to19":"83","20to24":"181","25to34":"364","35to44":"410","45to54":"561","55to64":"495","65+":"181","medianAge":"495"}},"title":"Janitors and building cleaners","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2013":{"total":"2,275","women":"32.6","white":"18.4","black":"3.9","asian":"30.3"}},"wageData":{"2013":{"workers":"1,537","median":"487","maleWorkers":"1,116","maleMedian":"517","femaleWorkers":"421","femaleMedian":"418"}}},"Maids and housekeeping cleaners":{"ageData":{"2013":{"total":"1,401","16to19":"38","20to24":"96","25to34":"241","35to44":"342","45to54":"364","55to64":"245","65+":"76","medianAge":"245"}},"title":"Maids and housekeeping cleaners","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2013":{"total":"1,401","women":"87.7","white":"16.8","black":"5.2","asian":"44.3"}},"wageData":{"2013":{"workers":"733","median":"413","maleWorkers":"128","maleMedian":"467","femaleWorkers":"605","femaleMedian":"406"}}},"Pest control workers":{"ageData":{"2013":{"total":"77","16to19":"1","20to24":"3","25to34":"19","35to44":"25","45to54":"11","55to64":"14","65+":"4","medianAge":"14"}},"title":"Pest control workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2013":{"total":"77","women":"3.5","white":"11.8","black":"1.5","asian":"19.3"}},"wageData":{"2013":{"workers":"62","median":"609","maleWorkers":"60","maleMedian":"606","femaleWorkers":"2","femaleMedian":"-"}}},"Grounds maintenance workers":{"ageData":{"2013":{"total":"1,327","16to19":"84","20to24":"161","25to34":"312","35to44":"304","45to54":"254","55to64":"150","65+":"62","medianAge":"150"}},"title":"Grounds maintenance workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2013":{"total":"1,327","women":"4.7","white":"7.4","black":"1.3","asian":"44.8"}},"wageData":{"2013":{"workers":"799","median":"445","maleWorkers":"768","maleMedian":"441","femaleWorkers":"31","femaleMedian":"-"}}},"Personal care and service occupations":{"ageData":{"2013":{"total":"5,392","16to19":"298","20to24":"736","25to34":"1,155","35to44":"1,015","45to54":"1,080","55to64":"767","65+":"343","medianAge":"767"}},"title":"Personal care and service occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2013":{"total":"5,392","women":"77.7","white":"14.6","black":"9.0","asian":"16.9"}},"wageData":{"2013":{"workers":"2,482","median":"481","maleWorkers":"654","maleMedian":"549","femaleWorkers":"1,829","femaleMedian":"464"}}},"First-line supervisors of gaming workers":{"ageData":{"2013":{"total":"157","16to19":"2","20to24":"16","25to34":"41","35to44":"39","45to54":"30","55to64":"21","65+":"7","medianAge":"21"}},"title":"First-line supervisors of gaming workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2013":{"total":"157","women":"47.7","white":"3.6","black":"11.0","asian":"6.9"}},"wageData":{"2013":{"workers":"97","median":"755","maleWorkers":"49","maleMedian":"-","femaleWorkers":"48","femaleMedian":"-"}}},"First-line supervisors of personal service workers":{"ageData":{"2013":{"total":"228","16to19":"1","20to24":"11","25to34":"45","35to44":"54","45to54":"65","55to64":"39","65+":"14","medianAge":"39"}},"title":"First-line supervisors of personal service workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2013":{"total":"228","women":"70.3","white":"11.7","black":"17.6","asian":"13.2"}},"wageData":{"2013":{"workers":"72","median":"595","maleWorkers":"28","maleMedian":"-","femaleWorkers":"44","femaleMedian":"-"}}},"Animal trainers":{"ageData":{"2013":{"total":"36","16to19":"2","20to24":"3","25to34":"7","35to44":"6","45to54":"9","55to64":"6","65+":"4","medianAge":"6"}},"title":"Animal trainers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2013":{"total":"36","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"8","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Nonfarm animal caretakers":{"ageData":{"2013":{"total":"175","16to19":"9","20to24":"45","25to34":"49","35to44":"19","45to54":"28","55to64":"21","65+":"4","medianAge":"21"}},"title":"Nonfarm animal caretakers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2013":{"total":"175","women":"73.6","white":"4.1","black":"1.3","asian":"12.0"}},"wageData":{"2013":{"workers":"78","median":"458","maleWorkers":"22","maleMedian":"-","femaleWorkers":"57","femaleMedian":"468"}}},"Gaming services workers":{"ageData":{"2013":{"total":"102","16to19":"2","20to24":"10","25to34":"20","35to44":"24","45to54":"19","55to64":"15","65+":"12","medianAge":"15"}},"title":"Gaming services workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2013":{"total":"102","women":"47.7","white":"10.3","black":"26.1","asian":"15.1"}},"wageData":{"2013":{"workers":"74","median":"651","maleWorkers":"35","maleMedian":"-","femaleWorkers":"39","femaleMedian":"-"}}},"Motion picture projectionists":{"ageData":{"2013":{"total":"5","16to19":"0","20to24":"3","25to34":"1","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Motion picture projectionists","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2013":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"3","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Ushers, lobby attendants, and ticket takers":{"ageData":{"2013":{"total":"39","16to19":"11","20to24":"12","25to34":"6","35to44":"1","45to54":"1","55to64":"5","65+":"4","medianAge":"5"}},"title":"Ushers, lobby attendants, and ticket takers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2013":{"total":"39","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"9","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Miscellaneous entertainment attendants and related workers":{"ageData":{"2013":{"total":"174","16to19":"42","20to24":"44","25to34":"25","35to44":"12","45to54":"16","55to64":"18","65+":"16","medianAge":"18"}},"title":"Miscellaneous entertainment attendants and related workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2013":{"total":"174","women":"44.0","white":"9.9","black":"4.3","asian":"18.3"}},"wageData":{"2013":{"workers":"74","median":"419","maleWorkers":"37","maleMedian":"-","femaleWorkers":"37","femaleMedian":"-"}}},"Embalmers and funeral attendants":{"ageData":{"2013":{"total":"16","16to19":"0","20to24":"4","25to34":"1","35to44":"3","45to54":"2","55to64":"4","65+":"2","medianAge":"4"}},"title":"Embalmers and funeral attendants","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2013":{"total":"16","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"10","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Morticians, undertakers, and funeral directors":{"ageData":{"2013":{"total":"39","16to19":"0","20to24":"1","25to34":"7","35to44":"7","45to54":"9","55to64":"9","65+":"6","medianAge":"9"}},"title":"Morticians, undertakers, and funeral directors","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2013":{"total":"39","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"28","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Barbers":{"ageData":{"2013":{"total":"127","16to19":"2","20to24":"6","25to34":"35","35to44":"33","45to54":"24","55to64":"16","65+":"12","medianAge":"16"}},"title":"Barbers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2013":{"total":"127","women":"19.2","white":"34.5","black":"3.4","asian":"30.0"}},"wageData":{"2013":{"workers":"60","median":"389","maleWorkers":"51","maleMedian":"369","femaleWorkers":"9","femaleMedian":"-"}}},"Hairdressers, hairstylists, and cosmetologists":{"ageData":{"2013":{"total":"786","16to19":"10","20to24":"77","25to34":"217","35to44":"175","45to54":"149","55to64":"108","65+":"50","medianAge":"108"}},"title":"Hairdressers, hairstylists, and cosmetologists","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2013":{"total":"786","women":"94.8","white":"12.8","black":"5.2","asian":"14.6"}},"wageData":{"2013":{"workers":"329","median":"488","maleWorkers":"21","maleMedian":"-","femaleWorkers":"308","femaleMedian":"485"}}},"Miscellaneous personal appearance workers":{"ageData":{"2013":{"total":"316","16to19":"5","20to24":"26","25to34":"81","35to44":"97","45to54":"62","55to64":"37","65+":"8","medianAge":"37"}},"title":"Miscellaneous personal appearance workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2013":{"total":"316","women":"85.1","white":"6.1","black":"56.7","asian":"7.8"}},"wageData":{"2013":{"workers":"170","median":"495","maleWorkers":"34","maleMedian":"-","femaleWorkers":"136","femaleMedian":"480"}}},"Baggage porters, bellhops, and concierges":{"ageData":{"2013":{"total":"87","16to19":"1","20to24":"14","25to34":"18","35to44":"13","45to54":"21","55to64":"10","65+":"9","medianAge":"10"}},"title":"Baggage porters, bellhops, and concierges","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2013":{"total":"87","women":"15.9","white":"22.7","black":"7.6","asian":"25.7"}},"wageData":{"2013":{"workers":"71","median":"491","maleWorkers":"60","maleMedian":"495","femaleWorkers":"10","femaleMedian":"-"}}},"Tour and travel guides":{"ageData":{"2013":{"total":"45","16to19":"4","20to24":"10","25to34":"7","35to44":"6","45to54":"8","55to64":"7","65+":"4","medianAge":"7"}},"title":"Tour and travel guides","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2013":{"total":"45","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"21","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Childcare workers":{"ageData":{"2013":{"total":"1,230","16to19":"122","20to24":"211","25to34":"226","35to44":"200","45to54":"238","55to64":"170","65+":"62","medianAge":"170"}},"title":"Childcare workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2013":{"total":"1,230","women":"94.8","white":"13.2","black":"3.4","asian":"22.4"}},"wageData":{"2013":{"workers":"441","median":"418","maleWorkers":"31","maleMedian":"-","femaleWorkers":"410","femaleMedian":"418"}}},"Personal care aides":{"ageData":{"2013":{"total":"1,242","16to19":"31","20to24":"148","25to34":"232","35to44":"212","45to54":"286","55to64":"228","65+":"105","medianAge":"228"}},"title":"Personal care aides","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2013":{"total":"1,242","women":"84.2","white":"22.1","black":"6.5","asian":"19.7"}},"wageData":{"2013":{"workers":"657","median":"449","maleWorkers":"119","maleMedian":"470","femaleWorkers":"539","femaleMedian":"445"}}},"Recreation and fitness workers":{"ageData":{"2013":{"total":"444","16to19":"44","20to24":"71","25to34":"99","35to44":"85","45to54":"91","55to64":"39","65+":"15","medianAge":"39"}},"title":"Recreation and fitness workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2013":{"total":"444","women":"63.2","white":"14.2","black":"5.5","asian":"10.1"}},"wageData":{"2013":{"workers":"213","median":"538","maleWorkers":"90","maleMedian":"561","femaleWorkers":"123","femaleMedian":"523"}}},"Residential advisors":{"ageData":{"2013":{"total":"40","16to19":"1","20to24":"9","25to34":"11","35to44":"6","45to54":"8","55to64":"5","65+":"1","medianAge":"5"}},"title":"Residential advisors","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2013":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"32","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"18","femaleMedian":"-"}}},"Personal care and service workers, all other":{"ageData":{"2013":{"total":"105","16to19":"7","20to24":"18","25to34":"29","35to44":"21","45to54":"11","55to64":"10","65+":"9","medianAge":"10"}},"title":"Personal care and service workers, all other","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2013":{"total":"105","women":"48.6","white":"5.6","black":"6.3","asian":"11.9"}},"wageData":{"2013":{"workers":"36","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Sales and office occupations":{"ageData":{"2013":{"total":"33,246","16to19":"1,500","20to24":"4,081","25to34":"6,891","35to44":"6,136","45to54":"7,083","55to64":"5,596","65+":"1,960","medianAge":"5,596"}},"title":"Sales and office occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2013":{"total":"33,246","women":"61.9","white":"11.8","black":"4.9","asian":"14.4"}},"wageData":{"2013":{"workers":"23,120","median":"659","maleWorkers":"9,112","maleMedian":"756","femaleWorkers":"14,008","femaleMedian":"615"}}},"Sales and related occupations":{"ageData":{"2013":{"total":"15,444","16to19":"1,012","20to24":"2,216","25to34":"3,147","35to44":"2,738","45to54":"3,007","55to64":"2,349","65+":"975","medianAge":"2,349"}},"title":"Sales and related occupations","depth":2,"parent":"Sales and office occupations","sexRaceEthnicityData":{"2013":{"total":"15,444","women":"48.6","white":"10.4","black":"5.6","asian":"14.5"}},"wageData":{"2013":{"workers":"9,376","median":"708","maleWorkers":"5,371","maleMedian":"835","femaleWorkers":"4,005","femaleMedian":"566"}}},"First-line supervisors of retail sales workers":{"ageData":{"2013":{"total":"3,223","16to19":"25","20to24":"262","25to34":"750","35to44":"713","45to54":"746","55to64":"528","65+":"200","medianAge":"528"}},"title":"First-line supervisors of retail sales workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2013":{"total":"3,223","women":"43.2","white":"8.5","black":"6.9","asian":"11.9"}},"wageData":{"2013":{"workers":"2,320","median":"709","maleWorkers":"1,338","maleMedian":"778","femaleWorkers":"981","femaleMedian":"612"}}},"First-line supervisors of non-retail sales workers":{"ageData":{"2013":{"total":"1,188","16to19":"2","20to24":"35","25to34":"206","35to44":"286","45to54":"347","55to64":"223","65+":"89","medianAge":"223"}},"title":"First-line supervisors of non-retail sales workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2013":{"total":"1,188","women":"24.8","white":"6.5","black":"6.0","asian":"11.6"}},"wageData":{"2013":{"workers":"757","median":"980","maleWorkers":"540","maleMedian":"1,004","femaleWorkers":"217","femaleMedian":"934"}}},"Cashiers":{"ageData":{"2013":{"total":"3,254","16to19":"664","20to24":"887","25to34":"592","35to44":"355","45to54":"343","55to64":"289","65+":"124","medianAge":"289"}},"title":"Cashiers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2013":{"total":"3,254","women":"71.7","white":"18.0","black":"6.8","asian":"21.3"}},"wageData":{"2013":{"workers":"1,350","median":"392","maleWorkers":"418","maleMedian":"426","femaleWorkers":"932","femaleMedian":"379"}}},"Counter and rental clerks":{"ageData":{"2013":{"total":"101","16to19":"8","20to24":"14","25to34":"15","35to44":"16","45to54":"20","55to64":"22","65+":"6","medianAge":"22"}},"title":"Counter and rental clerks","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2013":{"total":"101","women":"51.4","white":"11.2","black":"5.2","asian":"11.2"}},"wageData":{"2013":{"workers":"58","median":"612","maleWorkers":"35","maleMedian":"-","femaleWorkers":"24","femaleMedian":"-"}}},"Parts salespersons":{"ageData":{"2013":{"total":"98","16to19":"1","20to24":"10","25to34":"25","35to44":"19","45to54":"18","55to64":"23","65+":"2","medianAge":"23"}},"title":"Parts salespersons","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2013":{"total":"98","women":"10.4","white":"4.6","black":"3.2","asian":"18.7"}},"wageData":{"2013":{"workers":"83","median":"663","maleWorkers":"75","maleMedian":"665","femaleWorkers":"8","femaleMedian":"-"}}},"Retail salespersons":{"ageData":{"2013":{"total":"3,230","16to19":"260","20to24":"739","25to34":"644","35to44":"446","45to54":"476","55to64":"455","65+":"209","medianAge":"455"}},"title":"Retail salespersons","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2013":{"total":"3,230","women":"49.7","white":"11.7","black":"4.8","asian":"15.7"}},"wageData":{"2013":{"workers":"1,829","median":"598","maleWorkers":"1,092","maleMedian":"719","femaleWorkers":"737","femaleMedian":"485"}}},"Advertising sales agents":{"ageData":{"2013":{"total":"238","16to19":"4","20to24":"18","25to34":"78","35to44":"51","45to54":"41","55to64":"35","65+":"11","medianAge":"35"}},"title":"Advertising sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2013":{"total":"238","women":"47.2","white":"8.2","black":"5.0","asian":"13.4"}},"wageData":{"2013":{"workers":"207","median":"938","maleWorkers":"110","maleMedian":"1,005","femaleWorkers":"96","femaleMedian":"868"}}},"Insurance sales agents":{"ageData":{"2013":{"total":"602","16to19":"4","20to24":"36","25to34":"148","35to44":"108","45to54":"140","55to64":"117","65+":"49","medianAge":"117"}},"title":"Insurance sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2013":{"total":"602","women":"45.2","white":"7.3","black":"5.8","asian":"11.3"}},"wageData":{"2013":{"workers":"431","median":"838","maleWorkers":"216","maleMedian":"1,029","femaleWorkers":"216","femaleMedian":"733"}}},"Securities, commodities, and financial services sales agents":{"ageData":{"2013":{"total":"278","16to19":"1","20to24":"18","25to34":"77","35to44":"66","45to54":"66","55to64":"35","65+":"13","medianAge":"35"}},"title":"Securities, commodities, and financial services sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2013":{"total":"278","women":"32.9","white":"5.3","black":"5.7","asian":"8.1"}},"wageData":{"2013":{"workers":"219","median":"1,119","maleWorkers":"145","maleMedian":"1,389","femaleWorkers":"75","femaleMedian":"863"}}},"Travel agents":{"ageData":{"2013":{"total":"77","16to19":"0","20to24":"2","25to34":"7","35to44":"15","45to54":"22","55to64":"16","65+":"16","medianAge":"16"}},"title":"Travel agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2013":{"total":"77","women":"73.1","white":"7.5","black":"8.8","asian":"8.0"}},"wageData":{"2013":{"workers":"42","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"32","femaleMedian":"-"}}},"Sales representatives, services, all other":{"ageData":{"2013":{"total":"432","16to19":"4","20to24":"34","25to34":"113","35to44":"96","45to54":"101","55to64":"69","65+":"14","medianAge":"69"}},"title":"Sales representatives, services, all other","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2013":{"total":"432","women":"34.1","white":"6.4","black":"3.4","asian":"11.5"}},"wageData":{"2013":{"workers":"348","median":"948","maleWorkers":"242","maleMedian":"1,013","femaleWorkers":"106","femaleMedian":"766"}}},"Sales representatives, wholesale and manufacturing":{"ageData":{"2013":{"total":"1,319","16to19":"8","20to24":"63","25to34":"258","35to44":"332","45to54":"351","55to64":"241","65+":"66","medianAge":"241"}},"title":"Sales representatives, wholesale and manufacturing","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2013":{"total":"1,319","women":"26.3","white":"4.2","black":"3.1","asian":"10.5"}},"wageData":{"2013":{"workers":"1,085","median":"1,042","maleWorkers":"838","maleMedian":"1,131","femaleWorkers":"247","femaleMedian":"859"}}},"Models, demonstrators, and product promoters":{"ageData":{"2013":{"total":"82","16to19":"5","20to24":"11","25to34":"19","35to44":"10","45to54":"14","55to64":"10","65+":"13","medianAge":"10"}},"title":"Models, demonstrators, and product promoters","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2013":{"total":"82","women":"72.5","white":"13.4","black":"5.0","asian":"8.2"}},"wageData":{"2013":{"workers":"24","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Real estate brokers and sales agents":{"ageData":{"2013":{"total":"769","16to19":"3","20to24":"22","25to34":"105","35to44":"140","45to54":"195","55to64":"195","65+":"108","medianAge":"195"}},"title":"Real estate brokers and sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2013":{"total":"769","women":"57.6","white":"4.2","black":"4.6","asian":"11.2"}},"wageData":{"2013":{"workers":"357","median":"809","maleWorkers":"148","maleMedian":"928","femaleWorkers":"209","femaleMedian":"756"}}},"Sales engineers":{"ageData":{"2013":{"total":"36","16to19":"0","20to24":"2","25to34":"7","35to44":"7","45to54":"9","55to64":"11","65+":"0","medianAge":"11"}},"title":"Sales engineers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2013":{"total":"36","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"33","median":"-","maleWorkers":"29","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Telemarketers":{"ageData":{"2013":{"total":"93","16to19":"6","20to24":"26","25to34":"26","35to44":"10","45to54":"17","55to64":"6","65+":"2","medianAge":"6"}},"title":"Telemarketers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2013":{"total":"93","women":"70.0","white":"26.1","black":"1.4","asian":"15.4"}},"wageData":{"2013":{"workers":"49","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"32","femaleMedian":"-"}}},"Door-to-door sales workers, news and street vendors, and related workers":{"ageData":{"2013":{"total":"191","16to19":"5","20to24":"14","25to34":"36","35to44":"32","45to54":"42","55to64":"38","65+":"25","medianAge":"38"}},"title":"Door-to-door sales workers, news and street vendors, and related workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2013":{"total":"191","women":"59.6","white":"6.6","black":"3.9","asian":"18.8"}},"wageData":{"2013":{"workers":"34","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Sales and related workers, all other":{"ageData":{"2013":{"total":"234","16to19":"12","20to24":"25","25to34":"41","35to44":"35","45to54":"57","55to64":"36","65+":"28","medianAge":"36"}},"title":"Sales and related workers, all other","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2013":{"total":"234","women":"47.7","white":"8.9","black":"3.5","asian":"9.4"}},"wageData":{"2013":{"workers":"150","median":"915","maleWorkers":"85","maleMedian":"1,161","femaleWorkers":"65","femaleMedian":"724"}}},"Office and administrative support occupations":{"ageData":{"2013":{"total":"17,802","16to19":"488","20to24":"1,864","25to34":"3,743","35to44":"3,398","45to54":"4,076","55to64":"3,247","65+":"985","medianAge":"3,247"}},"title":"Office and administrative support occupations","depth":2,"parent":"Sales and office occupations","sexRaceEthnicityData":{"2013":{"total":"17,802","women":"73.3","white":"13.1","black":"4.3","asian":"14.4"}},"wageData":{"2013":{"workers":"13,744","median":"638","maleWorkers":"3,741","maleMedian":"673","femaleWorkers":"10,003","femaleMedian":"628"}}},"First-line supervisors of office and administrative support workers":{"ageData":{"2013":{"total":"1,363","16to19":"2","20to24":"54","25to34":"262","35to44":"338","45to54":"361","55to64":"286","65+":"60","medianAge":"286"}},"title":"First-line supervisors of office and administrative support workers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"1,363","women":"69.5","white":"10.4","black":"3.7","asian":"12.6"}},"wageData":{"2013":{"workers":"1,224","median":"772","maleWorkers":"395","maleMedian":"846","femaleWorkers":"828","femaleMedian":"748"}}},"Switchboard operators, including answering service":{"ageData":{"2013":{"total":"32","16to19":"1","20to24":"7","25to34":"3","35to44":"6","45to54":"7","55to64":"5","65+":"3","medianAge":"5"}},"title":"Switchboard operators, including answering service","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"32","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"22","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Telephone operators":{"ageData":{"2013":{"total":"29","16to19":"1","20to24":"3","25to34":"7","35to44":"4","45to54":"7","55to64":"5","65+":"1","medianAge":"5"}},"title":"Telephone operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"29","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"20","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Communications equipment operators, all other":{"ageData":{"2013":{"total":"3","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Communications equipment operators, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"2","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Bill and account collectors":{"ageData":{"2013":{"total":"177","16to19":"3","20to24":"15","25to34":"54","35to44":"39","45to54":"36","55to64":"23","65+":"6","medianAge":"23"}},"title":"Bill and account collectors","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"177","women":"66.1","white":"20.3","black":"2.0","asian":"12.0"}},"wageData":{"2013":{"workers":"156","median":"599","maleWorkers":"45","maleMedian":"-","femaleWorkers":"111","femaleMedian":"586"}}},"Billing and posting clerks":{"ageData":{"2013":{"total":"497","16to19":"2","20to24":"29","25to34":"105","35to44":"122","45to54":"127","55to64":"87","65+":"25","medianAge":"87"}},"title":"Billing and posting clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"497","women":"91.7","white":"13.2","black":"4.0","asian":"11.2"}},"wageData":{"2013":{"workers":"422","median":"637","maleWorkers":"42","maleMedian":"-","femaleWorkers":"380","femaleMedian":"629"}}},"Bookkeeping, accounting, and auditing clerks":{"ageData":{"2013":{"total":"1,241","16to19":"5","20to24":"59","25to34":"187","35to44":"236","45to54":"319","55to64":"296","65+":"138","medianAge":"296"}},"title":"Bookkeeping, accounting, and auditing clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"1,241","women":"88.7","white":"6.4","black":"5.7","asian":"8.5"}},"wageData":{"2013":{"workers":"804","median":"677","maleWorkers":"102","maleMedian":"751","femaleWorkers":"702","femaleMedian":"670"}}},"Gaming cage workers":{"ageData":{"2013":{"total":"14","16to19":"0","20to24":"2","25to34":"4","35to44":"5","45to54":"3","55to64":"0","65+":"0","medianAge":"0"}},"title":"Gaming cage workers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"12","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Payroll and timekeeping clerks":{"ageData":{"2013":{"total":"156","16to19":"0","20to24":"6","25to34":"24","35to44":"33","45to54":"46","55to64":"39","65+":"7","medianAge":"39"}},"title":"Payroll and timekeeping clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"156","women":"92.4","white":"14.4","black":"3.9","asian":"12.2"}},"wageData":{"2013":{"workers":"128","median":"731","maleWorkers":"9","maleMedian":"-","femaleWorkers":"118","femaleMedian":"727"}}},"Procurement clerks":{"ageData":{"2013":{"total":"27","16to19":"0","20to24":"0","25to34":"5","35to44":"6","45to54":"7","55to64":"8","65+":"0","medianAge":"8"}},"title":"Procurement clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"27","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"30","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"18","femaleMedian":"-"}}},"Tellers":{"ageData":{"2013":{"total":"369","16to19":"19","20to24":"101","25to34":"94","35to44":"44","45to54":"50","55to64":"51","65+":"11","medianAge":"51"}},"title":"Tellers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"369","women":"84.3","white":"11.3","black":"4.9","asian":"21.1"}},"wageData":{"2013":{"workers":"265","median":"494","maleWorkers":"36","maleMedian":"-","femaleWorkers":"229","femaleMedian":"494"}}},"Financial clerks, all other":{"ageData":{"2013":{"total":"55","16to19":"0","20to24":"6","25to34":"10","35to44":"13","45to54":"11","55to64":"11","65+":"3","medianAge":"11"}},"title":"Financial clerks, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"55","women":"66.4","white":"19.7","black":"7.9","asian":"10.0"}},"wageData":{"2013":{"workers":"54","median":"686","maleWorkers":"20","maleMedian":"-","femaleWorkers":"34","femaleMedian":"-"}}},"Brokerage clerks":{"ageData":{"2013":{"total":"2","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Brokerage clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Correspondence clerks":{"ageData":{"2013":{"total":"11","16to19":"0","20to24":"1","25to34":"4","35to44":"3","45to54":"1","55to64":"2","65+":"1","medianAge":"2"}},"title":"Correspondence clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"12","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Court, municipal, and license clerks":{"ageData":{"2013":{"total":"81","16to19":"0","20to24":"3","25to34":"14","35to44":"16","45to54":"28","55to64":"19","65+":"2","medianAge":"19"}},"title":"Court, municipal, and license clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"81","women":"69.4","white":"19.7","black":"3.0","asian":"13.9"}},"wageData":{"2013":{"workers":"74","median":"676","maleWorkers":"21","maleMedian":"-","femaleWorkers":"53","femaleMedian":"665"}}},"Credit authorizers, checkers, and clerks":{"ageData":{"2013":{"total":"40","16to19":"0","20to24":"2","25to34":"10","35to44":"6","45to54":"11","55to64":"10","65+":"1","medianAge":"10"}},"title":"Credit authorizers, checkers, and clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"40","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"30","femaleMedian":"-"}}},"Customer service representatives":{"ageData":{"2013":{"total":"2,069","16to19":"109","20to24":"306","25to34":"566","35to44":"388","45to54":"380","55to64":"255","65+":"67","medianAge":"255"}},"title":"Customer service representatives","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"2,069","women":"65.8","white":"17.0","black":"4.7","asian":"16.6"}},"wageData":{"2013":{"workers":"1,615","median":"621","maleWorkers":"547","maleMedian":"639","femaleWorkers":"1,068","femaleMedian":"616"}}},"Eligibility interviewers, government programs":{"ageData":{"2013":{"total":"75","16to19":"1","20to24":"1","25to34":"17","35to44":"17","45to54":"22","55to64":"13","65+":"4","medianAge":"13"}},"title":"Eligibility interviewers, government programs","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"75","women":"80.5","white":"20.2","black":"4.3","asian":"21.6"}},"wageData":{"2013":{"workers":"75","median":"778","maleWorkers":"15","maleMedian":"-","femaleWorkers":"60","femaleMedian":"746"}}},"File clerks":{"ageData":{"2013":{"total":"257","16to19":"19","20to24":"34","25to34":"48","35to44":"46","45to54":"50","55to64":"44","65+":"16","medianAge":"44"}},"title":"File clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"257","women":"80.1","white":"10.6","black":"5.5","asian":"18.3"}},"wageData":{"2013":{"workers":"182","median":"625","maleWorkers":"42","maleMedian":"-","femaleWorkers":"140","femaleMedian":"604"}}},"Hotel, motel, and resort desk clerks":{"ageData":{"2013":{"total":"112","16to19":"5","20to24":"38","25to34":"30","35to44":"12","45to54":"12","55to64":"11","65+":"4","medianAge":"11"}},"title":"Hotel, motel, and resort desk clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"112","women":"72.8","white":"17.1","black":"6.1","asian":"20.7"}},"wageData":{"2013":{"workers":"71","median":"418","maleWorkers":"21","maleMedian":"-","femaleWorkers":"50","femaleMedian":"417"}}},"Interviewers, except eligibility and loan":{"ageData":{"2013":{"total":"146","16to19":"2","20to24":"13","25to34":"38","35to44":"26","45to54":"40","55to64":"21","65+":"6","medianAge":"21"}},"title":"Interviewers, except eligibility and loan","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"146","women":"80.9","white":"24.9","black":"6.4","asian":"15.3"}},"wageData":{"2013":{"workers":"110","median":"621","maleWorkers":"21","maleMedian":"-","femaleWorkers":"89","femaleMedian":"605"}}},"Library assistants, clerical":{"ageData":{"2013":{"total":"87","16to19":"9","20to24":"15","25to34":"15","35to44":"9","45to54":"16","55to64":"17","65+":"7","medianAge":"17"}},"title":"Library assistants, clerical","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"87","women":"79.2","white":"9.6","black":"5.0","asian":"13.2"}},"wageData":{"2013":{"workers":"50","median":"559","maleWorkers":"8","maleMedian":"-","femaleWorkers":"42","femaleMedian":"-"}}},"Loan interviewers and clerks":{"ageData":{"2013":{"total":"168","16to19":"0","20to24":"10","25to34":"57","35to44":"43","45to54":"31","55to64":"18","65+":"8","medianAge":"18"}},"title":"Loan interviewers and clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"168","women":"78.0","white":"10.2","black":"2.7","asian":"16.6"}},"wageData":{"2013":{"workers":"158","median":"719","maleWorkers":"29","maleMedian":"-","femaleWorkers":"129","femaleMedian":"688"}}},"New accounts clerks":{"ageData":{"2013":{"total":"25","16to19":"1","20to24":"2","25to34":"8","35to44":"5","45to54":"4","55to64":"4","65+":"1","medianAge":"4"}},"title":"New accounts clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"25","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"29","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"26","femaleMedian":"-"}}},"Order clerks":{"ageData":{"2013":{"total":"94","16to19":"5","20to24":"12","25to34":"23","35to44":"17","45to54":"18","55to64":"14","65+":"4","medianAge":"14"}},"title":"Order clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"94","women":"61.2","white":"11.9","black":"6.9","asian":"23.9"}},"wageData":{"2013":{"workers":"79","median":"583","maleWorkers":"37","maleMedian":"-","femaleWorkers":"42","femaleMedian":"-"}}},"Human resources assistants, except payroll and timekeeping":{"ageData":{"2013":{"total":"133","16to19":"1","20to24":"5","25to34":"37","35to44":"34","45to54":"31","55to64":"20","65+":"5","medianAge":"20"}},"title":"Human resources assistants, except payroll and timekeeping","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"133","women":"82.0","white":"15.6","black":"4.2","asian":"11.2"}},"wageData":{"2013":{"workers":"129","median":"877","maleWorkers":"26","maleMedian":"-","femaleWorkers":"103","femaleMedian":"873"}}},"Receptionists and information clerks":{"ageData":{"2013":{"total":"1,326","16to19":"63","20to24":"243","25to34":"311","35to44":"206","45to54":"234","55to64":"191","65+":"79","medianAge":"191"}},"title":"Receptionists and information clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"1,326","women":"92.2","white":"11.0","black":"4.7","asian":"18.4"}},"wageData":{"2013":{"workers":"901","median":"536","maleWorkers":"73","maleMedian":"600","femaleWorkers":"828","femaleMedian":"527"}}},"Reservation and transportation ticket agents and travel clerks":{"ageData":{"2013":{"total":"119","16to19":"0","20to24":"9","25to34":"32","35to44":"19","45to54":"31","55to64":"24","65+":"5","medianAge":"24"}},"title":"Reservation and transportation ticket agents and travel clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"119","women":"58.9","white":"17.6","black":"9.1","asian":"15.8"}},"wageData":{"2013":{"workers":"100","median":"699","maleWorkers":"46","maleMedian":"-","femaleWorkers":"54","femaleMedian":"620"}}},"Information and record clerks, all other":{"ageData":{"2013":{"total":"103","16to19":"2","20to24":"11","25to34":"22","35to44":"16","45to54":"24","55to64":"22","65+":"7","medianAge":"22"}},"title":"Information and record clerks, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"103","women":"74.9","white":"14.1","black":"3.3","asian":"11.4"}},"wageData":{"2013":{"workers":"85","median":"710","maleWorkers":"23","maleMedian":"-","femaleWorkers":"62","femaleMedian":"727"}}},"Cargo and freight agents":{"ageData":{"2013":{"total":"28","16to19":"0","20to24":"2","25to34":"8","35to44":"7","45to54":"7","55to64":"3","65+":"0","medianAge":"3"}},"title":"Cargo and freight agents","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"28","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"26","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Couriers and messengers":{"ageData":{"2013":{"total":"198","16to19":"4","20to24":"15","25to34":"34","35to44":"41","45to54":"45","55to64":"36","65+":"22","medianAge":"36"}},"title":"Couriers and messengers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"198","women":"15.3","white":"14.2","black":"3.2","asian":"18.5"}},"wageData":{"2013":{"workers":"127","median":"624","maleWorkers":"112","maleMedian":"616","femaleWorkers":"16","femaleMedian":"-"}}},"Dispatchers":{"ageData":{"2013":{"total":"272","16to19":"4","20to24":"20","25to34":"76","35to44":"65","45to54":"53","55to64":"45","65+":"9","medianAge":"45"}},"title":"Dispatchers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"272","women":"57.0","white":"15.0","black":"1.3","asian":"12.7"}},"wageData":{"2013":{"workers":"246","median":"676","maleWorkers":"107","maleMedian":"747","femaleWorkers":"140","femaleMedian":"617"}}},"Meter readers, utilities":{"ageData":{"2013":{"total":"29","16to19":"0","20to24":"5","25to34":"7","35to44":"5","45to54":"3","55to64":"5","65+":"3","medianAge":"5"}},"title":"Meter readers, utilities","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"29","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"24","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Postal service clerks":{"ageData":{"2013":{"total":"100","16to19":"0","20to24":"3","25to34":"6","35to44":"18","45to54":"33","55to64":"37","65+":"3","medianAge":"37"}},"title":"Postal service clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"100","women":"54.8","white":"21.6","black":"7.2","asian":"13.6"}},"wageData":{"2013":{"workers":"90","median":"968","maleWorkers":"45","maleMedian":"-","femaleWorkers":"45","femaleMedian":"-"}}},"Postal service mail carriers":{"ageData":{"2013":{"total":"316","16to19":"1","20to24":"10","25to34":"38","35to44":"69","45to54":"101","55to64":"85","65+":"13","medianAge":"85"}},"title":"Postal service mail carriers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"316","women":"39.1","white":"14.6","black":"6.7","asian":"12.9"}},"wageData":{"2013":{"workers":"277","median":"964","maleWorkers":"176","maleMedian":"1,012","femaleWorkers":"101","femaleMedian":"878"}}},"Postal service mail sorters, processors, and processing machine operators":{"ageData":{"2013":{"total":"74","16to19":"1","20to24":"5","25to34":"8","35to44":"11","45to54":"25","55to64":"21","65+":"3","medianAge":"21"}},"title":"Postal service mail sorters, processors, and processing machine operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"74","women":"54.6","white":"31.0","black":"12.6","asian":"6.4"}},"wageData":{"2013":{"workers":"70","median":"873","maleWorkers":"35","maleMedian":"-","femaleWorkers":"35","femaleMedian":"-"}}},"Production, planning, and expediting clerks":{"ageData":{"2013":{"total":"282","16to19":"3","20to24":"27","25to34":"47","35to44":"60","45to54":"73","55to64":"61","65+":"10","medianAge":"61"}},"title":"Production, planning, and expediting clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"282","women":"54.8","white":"11.9","black":"4.4","asian":"10.8"}},"wageData":{"2013":{"workers":"272","median":"745","maleWorkers":"124","maleMedian":"864","femaleWorkers":"148","femaleMedian":"690"}}},"Shipping, receiving, and traffic clerks":{"ageData":{"2013":{"total":"563","16to19":"10","20to24":"81","25to34":"120","35to44":"107","45to54":"141","55to64":"86","65+":"18","medianAge":"86"}},"title":"Shipping, receiving, and traffic clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"563","women":"30.2","white":"16.6","black":"3.0","asian":"24.5"}},"wageData":{"2013":{"workers":"493","median":"539","maleWorkers":"342","maleMedian":"547","femaleWorkers":"151","femaleMedian":"524"}}},"Stock clerks and order fillers":{"ageData":{"2013":{"total":"1,508","16to19":"121","20to24":"303","25to34":"353","35to44":"226","45to54":"241","55to64":"190","65+":"72","medianAge":"190"}},"title":"Stock clerks and order fillers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"1,508","women":"36.7","white":"17.9","black":"3.7","asian":"18.9"}},"wageData":{"2013":{"workers":"918","median":"496","maleWorkers":"596","maleMedian":"503","femaleWorkers":"321","femaleMedian":"484"}}},"Weighers, measurers, checkers, and samplers, recordkeeping":{"ageData":{"2013":{"total":"84","16to19":"1","20to24":"4","25to34":"16","35to44":"15","45to54":"22","55to64":"21","65+":"3","medianAge":"21"}},"title":"Weighers, measurers, checkers, and samplers, recordkeeping","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"84","women":"50.3","white":"10.8","black":"0.5","asian":"18.3"}},"wageData":{"2013":{"workers":"74","median":"624","maleWorkers":"37","maleMedian":"-","femaleWorkers":"37","femaleMedian":"-"}}},"Secretaries and administrative assistants":{"ageData":{"2013":{"total":"2,922","16to19":"28","20to24":"135","25to34":"504","35to44":"543","45to54":"821","55to64":"690","65+":"200","medianAge":"690"}},"title":"Secretaries and administrative assistants","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"2,922","women":"94.4","white":"9.3","black":"3.3","asian":"10.5"}},"wageData":{"2013":{"workers":"2,232","median":"681","maleWorkers":"120","maleMedian":"772","femaleWorkers":"2,113","femaleMedian":"677"}}},"Computer operators":{"ageData":{"2013":{"total":"95","16to19":"1","20to24":"5","25to34":"15","35to44":"21","45to54":"31","55to64":"18","65+":"4","medianAge":"18"}},"title":"Computer operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"95","women":"52.4","white":"11.0","black":"6.3","asian":"13.1"}},"wageData":{"2013":{"workers":"80","median":"732","maleWorkers":"41","maleMedian":"-","femaleWorkers":"39","femaleMedian":"-"}}},"Data entry keyers":{"ageData":{"2013":{"total":"307","16to19":"8","20to24":"39","25to34":"60","35to44":"68","45to54":"62","55to64":"59","65+":"12","medianAge":"59"}},"title":"Data entry keyers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"307","women":"80.3","white":"15.1","black":"5.7","asian":"11.6"}},"wageData":{"2013":{"workers":"235","median":"634","maleWorkers":"46","maleMedian":"-","femaleWorkers":"189","femaleMedian":"632"}}},"Word processors and typists":{"ageData":{"2013":{"total":"101","16to19":"2","20to24":"7","25to34":"20","35to44":"17","45to54":"24","55to64":"22","65+":"10","medianAge":"22"}},"title":"Word processors and typists","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"101","women":"94.1","white":"16.3","black":"2.1","asian":"10.8"}},"wageData":{"2013":{"workers":"90","median":"621","maleWorkers":"8","maleMedian":"-","femaleWorkers":"82","femaleMedian":"607"}}},"Desktop publishers":{"ageData":{"2013":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"1","medianAge":"0"}},"title":"Desktop publishers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Insurance claims and policy processing clerks":{"ageData":{"2013":{"total":"287","16to19":"2","20to24":"28","25to34":"72","35to44":"62","45to54":"72","55to64":"42","65+":"10","medianAge":"42"}},"title":"Insurance claims and policy processing clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"287","women":"81.0","white":"17.3","black":"2.7","asian":"10.2"}},"wageData":{"2013":{"workers":"252","median":"652","maleWorkers":"46","maleMedian":"-","femaleWorkers":"206","femaleMedian":"631"}}},"Mail clerks and mail machine operators, except postal service":{"ageData":{"2013":{"total":"75","16to19":"1","20to24":"6","25to34":"9","35to44":"12","45to54":"19","55to64":"22","65+":"7","medianAge":"22"}},"title":"Mail clerks and mail machine operators, except postal service","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"75","women":"53.5","white":"17.9","black":"7.1","asian":"16.7"}},"wageData":{"2013":{"workers":"48","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"22","femaleMedian":"-"}}},"Office clerks, general":{"ageData":{"2013":{"total":"1,184","16to19":"41","20to24":"135","25to34":"237","35to44":"227","45to54":"257","55to64":"202","65+":"85","medianAge":"202"}},"title":"Office clerks, general","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"1,184","women":"84.4","white":"13.5","black":"5.1","asian":"17.1"}},"wageData":{"2013":{"workers":"852","median":"598","maleWorkers":"118","maleMedian":"620","femaleWorkers":"734","femaleMedian":"596"}}},"Office machine operators, except computer":{"ageData":{"2013":{"total":"41","16to19":"0","20to24":"5","25to34":"12","35to44":"4","45to54":"10","55to64":"10","65+":"1","medianAge":"10"}},"title":"Office machine operators, except computer","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"41","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"35","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"21","femaleMedian":"-"}}},"Proofreaders and copy markers":{"ageData":{"2013":{"total":"7","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"2","55to64":"3","65+":"1","medianAge":"3"}},"title":"Proofreaders and copy markers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"3","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Statistical assistants":{"ageData":{"2013":{"total":"24","16to19":"0","20to24":"3","25to34":"5","35to44":"5","45to54":"6","55to64":"3","65+":"2","medianAge":"3"}},"title":"Statistical assistants","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"24","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"18","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Office and administrative support workers, all other":{"ageData":{"2013":{"total":"494","16to19":"9","20to24":"39","25to34":"110","35to44":"103","45to54":"118","55to64":"91","65+":"24","medianAge":"91"}},"title":"Office and administrative support workers, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2013":{"total":"494","women":"77.4","white":"10.8","black":"3.5","asian":"10.2"}},"wageData":{"2013":{"workers":"431","median":"724","maleWorkers":"100","maleMedian":"795","femaleWorkers":"331","femaleMedian":"695"}}},"Natural resources, construction, and maintenance occupations":{"ageData":{"2013":{"total":"13,058","16to19":"295","20to24":"1,138","25to34":"3,052","35to44":"3,014","45to54":"3,185","55to64":"1,929","65+":"446","medianAge":"1,929"}},"title":"Natural resources, construction, and maintenance occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2013":{"total":"13,058","women":"4.6","white":"7.0","black":"2.2","asian":"26.6"}},"wageData":{"2013":{"workers":"10,341","median":"747","maleWorkers":"9,906","maleMedian":"757","femaleWorkers":"434","femaleMedian":"578"}}},"Farming, fishing, and forestry occupations":{"ageData":{"2013":{"total":"964","16to19":"89","20to24":"138","25to34":"225","35to44":"189","45to54":"165","55to64":"114","65+":"44","medianAge":"114"}},"title":"Farming, fishing, and forestry occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2013":{"total":"964","women":"21.7","white":"5.6","black":"1.8","asian":"42.8"}},"wageData":{"2013":{"workers":"720","median":"448","maleWorkers":"576","maleMedian":"472","femaleWorkers":"144","femaleMedian":"368"}}},"First-line supervisors of farming, fishing, and forestry workers":{"ageData":{"2013":{"total":"48","16to19":"1","20to24":"3","25to34":"11","35to44":"10","45to54":"12","55to64":"8","65+":"4","medianAge":"8"}},"title":"First-line supervisors of farming, fishing, and forestry workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2013":{"total":"48","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"34","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Agricultural inspectors":{"ageData":{"2013":{"total":"12","16to19":"0","20to24":"0","25to34":"1","35to44":"4","45to54":"4","55to64":"1","65+":"2","medianAge":"1"}},"title":"Agricultural inspectors","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2013":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"11","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Animal breeders":{"ageData":{"2013":{"total":"4","16to19":"0","20to24":"0","25to34":"0","35to44":"2","45to54":"1","55to64":"0","65+":"1","medianAge":"0"}},"title":"Animal breeders","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2013":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Graders and sorters, agricultural products":{"ageData":{"2013":{"total":"94","16to19":"3","20to24":"10","25to34":"19","35to44":"21","45to54":"19","55to64":"18","65+":"4","medianAge":"18"}},"title":"Graders and sorters, agricultural products","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2013":{"total":"94","women":"61.5","white":"15.5","black":"4.4","asian":"47.0"}},"wageData":{"2013":{"workers":"91","median":"416","maleWorkers":"34","maleMedian":"-","femaleWorkers":"57","femaleMedian":"389"}}},"Miscellaneous agricultural workers":{"ageData":{"2013":{"total":"679","16to19":"79","20to24":"112","25to34":"179","35to44":"122","45to54":"98","55to64":"67","65+":"23","medianAge":"67"}},"title":"Miscellaneous agricultural workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2013":{"total":"679","women":"19.1","white":"4.0","black":"1.3","asian":"50.0"}},"wageData":{"2013":{"workers":"516","median":"428","maleWorkers":"445","maleMedian":"447","femaleWorkers":"71","femaleMedian":"352"}}},"Fishers and related fishing workers":{"ageData":{"2013":{"total":"40","16to19":"2","20to24":"2","25to34":"6","35to44":"9","45to54":"11","55to64":"6","65+":"5","medianAge":"6"}},"title":"Fishers and related fishing workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2013":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"16","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Hunters and trappers":{"ageData":{"2013":{"total":"3","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"0","55to64":"0","65+":"1","medianAge":"0"}},"title":"Hunters and trappers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2013":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Forest and conservation workers":{"ageData":{"2013":{"total":"18","16to19":"0","20to24":"2","25to34":"2","35to44":"4","45to54":"4","55to64":"2","65+":"3","medianAge":"2"}},"title":"Forest and conservation workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2013":{"total":"18","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"11","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Logging workers":{"ageData":{"2013":{"total":"67","16to19":"4","20to24":"9","25to34":"6","35to44":"18","45to54":"17","55to64":"12","65+":"1","medianAge":"12"}},"title":"Logging workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2013":{"total":"67","women":"2.1","white":"8.6","black":"0.0","asian":"6.9"}},"wageData":{"2013":{"workers":"39","median":"-","maleWorkers":"37","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Construction and extraction occupations":{"ageData":{"2013":{"total":"7,130","16to19":"139","20to24":"582","25to34":"1,755","35to44":"1,716","45to54":"1,729","55to64":"998","65+":"213","medianAge":"998"}},"title":"Construction and extraction occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2013":{"total":"7,130","women":"2.6","white":"6.2","black":"1.6","asian":"31.0"}},"wageData":{"2013":{"workers":"5,353","median":"732","maleWorkers":"5,242","maleMedian":"736","femaleWorkers":"112","femaleMedian":"654"}}},"First-line supervisors of construction trades and extraction workers":{"ageData":{"2013":{"total":"631","16to19":"0","20to24":"18","25to34":"119","35to44":"155","45to54":"191","55to64":"121","65+":"26","medianAge":"121"}},"title":"First-line supervisors of construction trades and extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"631","women":"2.1","white":"3.5","black":"1.2","asian":"15.7"}},"wageData":{"2013":{"workers":"509","median":"990","maleWorkers":"501","maleMedian":"996","femaleWorkers":"8","femaleMedian":"-"}}},"Boilermakers":{"ageData":{"2013":{"total":"18","16to19":"0","20to24":"0","25to34":"5","35to44":"5","45to54":"5","55to64":"2","65+":"0","medianAge":"2"}},"title":"Boilermakers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"18","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"14","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Brickmasons, blockmasons, and stonemasons":{"ageData":{"2013":{"total":"130","16to19":"2","20to24":"7","25to34":"35","35to44":"43","45to54":"25","55to64":"14","65+":"4","medianAge":"14"}},"title":"Brickmasons, blockmasons, and stonemasons","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"130","women":"0.7","white":"2.5","black":"0.3","asian":"41.0"}},"wageData":{"2013":{"workers":"106","median":"768","maleWorkers":"106","maleMedian":"766","femaleWorkers":"0","femaleMedian":"-"}}},"Carpenters":{"ageData":{"2013":{"total":"1,164","16to19":"16","20to24":"84","25to34":"292","35to44":"274","45to54":"294","55to64":"162","65+":"42","medianAge":"162"}},"title":"Carpenters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"1,164","women":"1.6","white":"5.4","black":"1.4","asian":"27.3"}},"wageData":{"2013":{"workers":"712","median":"657","maleWorkers":"703","maleMedian":"659","femaleWorkers":"10","femaleMedian":"-"}}},"Carpet, floor, and tile installers and finishers":{"ageData":{"2013":{"total":"142","16to19":"3","20to24":"11","25to34":"38","35to44":"38","45to54":"34","55to64":"16","65+":"2","medianAge":"16"}},"title":"Carpet, floor, and tile installers and finishers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"142","women":"3.5","white":"4.3","black":"1.5","asian":"46.3"}},"wageData":{"2013":{"workers":"80","median":"582","maleWorkers":"78","maleMedian":"579","femaleWorkers":"2","femaleMedian":"-"}}},"Cement masons, concrete finishers, and terrazzo workers":{"ageData":{"2013":{"total":"52","16to19":"2","20to24":"4","25to34":"11","35to44":"14","45to54":"18","55to64":"2","65+":"1","medianAge":"2"}},"title":"Cement masons, concrete finishers, and terrazzo workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"52","women":"0.0","white":"5.2","black":"0.0","asian":"52.5"}},"wageData":{"2013":{"workers":"46","median":"-","maleWorkers":"46","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Construction laborers":{"ageData":{"2013":{"total":"1,536","16to19":"55","20to24":"175","25to34":"416","35to44":"346","45to54":"322","55to64":"181","65+":"41","medianAge":"181"}},"title":"Construction laborers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"1,536","women":"3.6","white":"6.8","black":"1.9","asian":"44.3"}},"wageData":{"2013":{"workers":"1,087","median":"594","maleWorkers":"1,058","maleMedian":"592","femaleWorkers":"29","femaleMedian":"-"}}},"Paving, surfacing, and tamping equipment operators":{"ageData":{"2013":{"total":"22","16to19":"0","20to24":"3","25to34":"6","35to44":"4","45to54":"3","55to64":"5","65+":"0","medianAge":"5"}},"title":"Paving, surfacing, and tamping equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"22","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"18","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Pile-driver operators":{"ageData":{"2013":{"total":"1","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Pile-driver operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Operating engineers and other construction equipment operators":{"ageData":{"2013":{"total":"352","16to19":"6","20to24":"18","25to34":"74","35to44":"79","45to54":"99","55to64":"68","65+":"9","medianAge":"68"}},"title":"Operating engineers and other construction equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"352","women":"1.4","white":"5.8","black":"0.6","asian":"16.5"}},"wageData":{"2013":{"workers":"322","median":"801","maleWorkers":"317","maleMedian":"804","femaleWorkers":"4","femaleMedian":"-"}}},"Drywall installers, ceiling tile installers, and tapers":{"ageData":{"2013":{"total":"126","16to19":"2","20to24":"4","25to34":"43","35to44":"39","45to54":"26","55to64":"10","65+":"2","medianAge":"10"}},"title":"Drywall installers, ceiling tile installers, and tapers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"126","women":"0.6","white":"2.7","black":"0.0","asian":"55.1"}},"wageData":{"2013":{"workers":"81","median":"521","maleWorkers":"81","maleMedian":"522","femaleWorkers":"0","femaleMedian":"-"}}},"Electricians":{"ageData":{"2013":{"total":"730","16to19":"8","20to24":"48","25to34":"161","35to44":"191","45to54":"194","55to64":"111","65+":"17","medianAge":"111"}},"title":"Electricians","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"730","women":"1.8","white":"7.5","black":"2.0","asian":"17.3"}},"wageData":{"2013":{"workers":"641","median":"949","maleWorkers":"630","maleMedian":"952","femaleWorkers":"11","femaleMedian":"-"}}},"Glaziers":{"ageData":{"2013":{"total":"37","16to19":"1","20to24":"1","25to34":"13","35to44":"8","45to54":"7","55to64":"6","65+":"1","medianAge":"6"}},"title":"Glaziers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"37","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"31","median":"-","maleWorkers":"31","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Insulation workers":{"ageData":{"2013":{"total":"50","16to19":"1","20to24":"6","25to34":"10","35to44":"15","45to54":"13","55to64":"4","65+":"1","medianAge":"4"}},"title":"Insulation workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"50","women":"2.5","white":"15.6","black":"0.1","asian":"37.7"}},"wageData":{"2013":{"workers":"44","median":"-","maleWorkers":"42","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Painters, construction and maintenance":{"ageData":{"2013":{"total":"517","16to19":"12","20to24":"45","25to34":"123","35to44":"125","45to54":"121","55to64":"75","65+":"15","medianAge":"75"}},"title":"Painters, construction and maintenance","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"517","women":"5.7","white":"7.0","black":"1.3","asian":"47.3"}},"wageData":{"2013":{"workers":"331","median":"576","maleWorkers":"318","maleMedian":"579","femaleWorkers":"14","femaleMedian":"-"}}},"Paperhangers":{"ageData":{"2013":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"1","65+":"1","medianAge":"1"}},"title":"Paperhangers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Pipelayers, plumbers, pipefitters, and steamfitters":{"ageData":{"2013":{"total":"553","16to19":"5","20to24":"46","25to34":"141","35to44":"130","45to54":"137","55to64":"79","65+":"16","medianAge":"79"}},"title":"Pipelayers, plumbers, pipefitters, and steamfitters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"553","women":"1.1","white":"7.9","black":"3.2","asian":"20.8"}},"wageData":{"2013":{"workers":"450","median":"909","maleWorkers":"447","maleMedian":"912","femaleWorkers":"4","femaleMedian":"-"}}},"Plasterers and stucco masons":{"ageData":{"2013":{"total":"27","16to19":"1","20to24":"5","25to34":"6","35to44":"5","45to54":"9","55to64":"1","65+":"1","medianAge":"1"}},"title":"Plasterers and stucco masons","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"27","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"24","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Reinforcing iron and rebar workers":{"ageData":{"2013":{"total":"9","16to19":"0","20to24":"2","25to34":"2","35to44":"3","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Reinforcing iron and rebar workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"8","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Roofers":{"ageData":{"2013":{"total":"203","16to19":"6","20to24":"23","25to34":"68","35to44":"55","45to54":"28","55to64":"17","65+":"7","medianAge":"17"}},"title":"Roofers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"203","women":"0.7","white":"4.2","black":"1.1","asian":"51.2"}},"wageData":{"2013":{"workers":"133","median":"566","maleWorkers":"133","maleMedian":"566","femaleWorkers":"0","femaleMedian":"-"}}},"Sheet metal workers":{"ageData":{"2013":{"total":"113","16to19":"0","20to24":"8","25to34":"23","35to44":"30","45to54":"29","55to64":"18","65+":"5","medianAge":"18"}},"title":"Sheet metal workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"113","women":"5.5","white":"2.2","black":"1.8","asian":"19.2"}},"wageData":{"2013":{"workers":"100","median":"789","maleWorkers":"93","maleMedian":"797","femaleWorkers":"7","femaleMedian":"-"}}},"Structural iron and steel workers":{"ageData":{"2013":{"total":"49","16to19":"2","20to24":"5","25to34":"14","35to44":"14","45to54":"10","55to64":"2","65+":"2","medianAge":"2"}},"title":"Structural iron and steel workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"49","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"38","median":"-","maleWorkers":"38","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Solar photovoltaic installers":{"ageData":{"2013":{"total":"5","16to19":"0","20to24":"1","25to34":"2","35to44":"0","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Solar photovoltaic installers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"6","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers, construction trades":{"ageData":{"2013":{"total":"63","16to19":"4","20to24":"20","25to34":"14","35to44":"15","45to54":"7","55to64":"2","65+":"1","medianAge":"2"}},"title":"Helpers, construction trades","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"63","women":"2.9","white":"14.0","black":"0.1","asian":"43.9"}},"wageData":{"2013":{"workers":"46","median":"-","maleWorkers":"44","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Construction and building inspectors":{"ageData":{"2013":{"total":"101","16to19":"0","20to24":"2","25to34":"8","35to44":"13","45to54":"36","55to64":"34","65+":"8","medianAge":"34"}},"title":"Construction and building inspectors","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"101","women":"7.1","white":"6.2","black":"4.3","asian":"5.2"}},"wageData":{"2013":{"workers":"73","median":"903","maleWorkers":"67","maleMedian":"920","femaleWorkers":"5","femaleMedian":"-"}}},"Elevator installers and repairers":{"ageData":{"2013":{"total":"24","16to19":"0","20to24":"0","25to34":"3","35to44":"4","45to54":"9","55to64":"6","65+":"1","medianAge":"6"}},"title":"Elevator installers and repairers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"24","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"25","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Fence erectors":{"ageData":{"2013":{"total":"35","16to19":"1","20to24":"2","25to34":"13","35to44":"7","45to54":"8","55to64":"2","65+":"1","medianAge":"2"}},"title":"Fence erectors","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"35","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"24","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Hazardous materials removal workers":{"ageData":{"2013":{"total":"32","16to19":"0","20to24":"4","25to34":"7","35to44":"10","45to54":"6","55to64":"6","65+":"1","medianAge":"6"}},"title":"Hazardous materials removal workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"32","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"28","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Highway maintenance workers":{"ageData":{"2013":{"total":"97","16to19":"2","20to24":"5","25to34":"17","35to44":"18","45to54":"30","55to64":"22","65+":"3","medianAge":"22"}},"title":"Highway maintenance workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"97","women":"1.1","white":"8.6","black":"0.8","asian":"9.9"}},"wageData":{"2013":{"workers":"95","median":"709","maleWorkers":"95","maleMedian":"709","femaleWorkers":"0","femaleMedian":"-"}}},"Rail-track laying and maintenance equipment operators":{"ageData":{"2013":{"total":"13","16to19":"1","20to24":"1","25to34":"3","35to44":"2","45to54":"4","55to64":"3","65+":"0","medianAge":"3"}},"title":"Rail-track laying and maintenance equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"16","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Septic tank servicers and sewer pipe cleaners":{"ageData":{"2013":{"total":"10","16to19":"0","20to24":"2","25to34":"0","35to44":"6","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Septic tank servicers and sewer pipe cleaners","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Miscellaneous construction and related workers":{"ageData":{"2013":{"total":"29","16to19":"1","20to24":"2","25to34":"7","35to44":"5","45to54":"8","55to64":"4","65+":"2","medianAge":"4"}},"title":"Miscellaneous construction and related workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"29","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"21","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Derrick, rotary drill, and service unit operators, oil, gas, and mining":{"ageData":{"2013":{"total":"43","16to19":"0","20to24":"5","25to34":"15","35to44":"10","45to54":"9","55to64":"5","65+":"0","medianAge":"5"}},"title":"Derrick, rotary drill, and service unit operators, oil, gas, and mining","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"43","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"38","median":"-","maleWorkers":"38","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Earth drillers, except oil and gas":{"ageData":{"2013":{"total":"33","16to19":"0","20to24":"4","25to34":"9","35to44":"8","45to54":"10","55to64":"2","65+":"0","medianAge":"2"}},"title":"Earth drillers, except oil and gas","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"26","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Explosives workers, ordnance handling experts, and blasters":{"ageData":{"2013":{"total":"8","16to19":"0","20to24":"0","25to34":"3","35to44":"2","45to54":"3","55to64":"1","65+":"0","medianAge":"1"}},"title":"Explosives workers, ordnance handling experts, and blasters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"8","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Mining machine operators":{"ageData":{"2013":{"total":"58","16to19":"1","20to24":"4","25to34":"23","35to44":"13","45to54":"10","55to64":"8","65+":"0","medianAge":"8"}},"title":"Mining machine operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"58","women":"5.0","white":"4.4","black":"0.4","asian":"21.3"}},"wageData":{"2013":{"workers":"60","median":"1,014","maleWorkers":"58","maleMedian":"1,084","femaleWorkers":"2","femaleMedian":"-"}}},"Roof bolters, mining":{"ageData":{"2013":{"total":"3","16to19":"0","20to24":"0","25to34":"2","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Roof bolters, mining","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Roustabouts, oil and gas":{"ageData":{"2013":{"total":"12","16to19":"0","20to24":"4","25to34":"3","35to44":"3","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Roustabouts, oil and gas","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"12","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers--extraction workers":{"ageData":{"2013":{"total":"3","16to19":"1","20to24":"1","25to34":"0","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Helpers--extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Other extraction workers":{"ageData":{"2013":{"total":"95","16to19":"7","20to24":"12","25to34":"25","35to44":"26","45to54":"16","55to64":"7","65+":"3","medianAge":"7"}},"title":"Other extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2013":{"total":"95","women":"2.5","white":"4.3","black":"1.4","asian":"39.6"}},"wageData":{"2013":{"workers":"86","median":"920","maleWorkers":"83","maleMedian":"909","femaleWorkers":"3","femaleMedian":"-"}}},"Installation, maintenance, and repair occupations":{"ageData":{"2013":{"total":"4,964","16to19":"67","20to24":"419","25to34":"1,072","35to44":"1,109","45to54":"1,291","55to64":"817","65+":"189","medianAge":"817"}},"title":"Installation, maintenance, and repair occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2013":{"total":"4,964","women":"4.2","white":"8.5","black":"3.2","asian":"17.0"}},"wageData":{"2013":{"workers":"4,268","median":"821","maleWorkers":"4,089","maleMedian":"824","femaleWorkers":"179","femaleMedian":"710"}}},"First-line supervisors of mechanics, installers, and repairers":{"ageData":{"2013":{"total":"266","16to19":"0","20to24":"8","25to34":"41","35to44":"55","45to54":"87","55to64":"63","65+":"12","medianAge":"63"}},"title":"First-line supervisors of mechanics, installers, and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"266","women":"10.2","white":"7.8","black":"2.5","asian":"10.4"}},"wageData":{"2013":{"workers":"258","median":"980","maleWorkers":"229","maleMedian":"990","femaleWorkers":"29","femaleMedian":"-"}}},"Computer, automated teller, and office machine repairers":{"ageData":{"2013":{"total":"285","16to19":"2","20to24":"21","25to34":"67","35to44":"82","45to54":"61","55to64":"40","65+":"12","medianAge":"40"}},"title":"Computer, automated teller, and office machine repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"285","women":"13.3","white":"13.0","black":"8.6","asian":"10.1"}},"wageData":{"2013":{"workers":"240","median":"875","maleWorkers":"211","maleMedian":"894","femaleWorkers":"29","femaleMedian":"-"}}},"Radio and telecommunications equipment installers and repairers":{"ageData":{"2013":{"total":"129","16to19":"1","20to24":"6","25to34":"31","35to44":"28","45to54":"42","55to64":"20","65+":"2","medianAge":"20"}},"title":"Radio and telecommunications equipment installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"129","women":"10.0","white":"9.5","black":"3.3","asian":"12.9"}},"wageData":{"2013":{"workers":"122","median":"1,025","maleWorkers":"108","maleMedian":"1,021","femaleWorkers":"13","femaleMedian":"-"}}},"Avionics technicians":{"ageData":{"2013":{"total":"10","16to19":"0","20to24":"2","25to34":"3","35to44":"2","45to54":"3","55to64":"1","65+":"0","medianAge":"1"}},"title":"Avionics technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"10","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Electric motor, power tool, and related repairers":{"ageData":{"2013":{"total":"30","16to19":"0","20to24":"1","25to34":"6","35to44":"4","45to54":"4","55to64":"9","65+":"5","medianAge":"9"}},"title":"Electric motor, power tool, and related repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"30","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"24","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Electrical and electronics installers and repairers, transportation equipment":{"ageData":{"2013":{"total":"7","16to19":"0","20to24":"2","25to34":"0","35to44":"2","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Electrical and electronics installers and repairers, transportation equipment","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electrical and electronics repairers, industrial and utility":{"ageData":{"2013":{"total":"13","16to19":"0","20to24":"0","25to34":"3","35to44":"1","45to54":"6","55to64":"1","65+":"2","medianAge":"1"}},"title":"Electrical and electronics repairers, industrial and utility","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"13","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Electronic equipment installers and repairers, motor vehicles":{"ageData":{"2013":{"total":"23","16to19":"0","20to24":"3","25to34":"5","35to44":"5","45to54":"5","55to64":"5","65+":"0","medianAge":"5"}},"title":"Electronic equipment installers and repairers, motor vehicles","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"23","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"24","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Electronic home entertainment equipment installers and repairers":{"ageData":{"2013":{"total":"54","16to19":"0","20to24":"5","25to34":"18","35to44":"12","45to54":"10","55to64":"9","65+":"0","medianAge":"9"}},"title":"Electronic home entertainment equipment installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"54","women":"5.1","white":"2.5","black":"4.6","asian":"19.9"}},"wageData":{"2013":{"workers":"42","median":"-","maleWorkers":"41","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Security and fire alarm systems installers":{"ageData":{"2013":{"total":"72","16to19":"0","20to24":"9","25to34":"23","35to44":"14","45to54":"13","55to64":"8","65+":"5","medianAge":"8"}},"title":"Security and fire alarm systems installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"72","women":"3.5","white":"10.0","black":"1.9","asian":"20.3"}},"wageData":{"2013":{"workers":"60","median":"780","maleWorkers":"58","maleMedian":"780","femaleWorkers":"2","femaleMedian":"-"}}},"Aircraft mechanics and service technicians":{"ageData":{"2013":{"total":"162","16to19":"1","20to24":"6","25to34":"27","35to44":"39","45to54":"48","55to64":"36","65+":"6","medianAge":"36"}},"title":"Aircraft mechanics and service technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"162","women":"2.2","white":"7.9","black":"9.0","asian":"9.0"}},"wageData":{"2013":{"workers":"155","median":"978","maleWorkers":"152","maleMedian":"974","femaleWorkers":"3","femaleMedian":"-"}}},"Automotive body and related repairers":{"ageData":{"2013":{"total":"168","16to19":"4","20to24":"15","25to34":"36","35to44":"36","45to54":"36","55to64":"31","65+":"10","medianAge":"31"}},"title":"Automotive body and related repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"168","women":"1.5","white":"3.3","black":"2.2","asian":"32.9"}},"wageData":{"2013":{"workers":"124","median":"687","maleWorkers":"123","maleMedian":"688","femaleWorkers":"1","femaleMedian":"-"}}},"Automotive glass installers and repairers":{"ageData":{"2013":{"total":"27","16to19":"0","20to24":"1","25to34":"10","35to44":"9","45to54":"4","55to64":"2","65+":"1","medianAge":"2"}},"title":"Automotive glass installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"27","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"20","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Automotive service technicians and mechanics":{"ageData":{"2013":{"total":"863","16to19":"16","20to24":"117","25to34":"195","35to44":"194","45to54":"215","55to64":"99","65+":"26","medianAge":"99"}},"title":"Automotive service technicians and mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"863","women":"1.8","white":"11.4","black":"4.0","asian":"21.7"}},"wageData":{"2013":{"workers":"672","median":"713","maleWorkers":"659","maleMedian":"714","femaleWorkers":"13","femaleMedian":"-"}}},"Bus and truck mechanics and diesel engine specialists":{"ageData":{"2013":{"total":"316","16to19":"6","20to24":"36","25to34":"64","35to44":"67","45to54":"91","55to64":"44","65+":"8","medianAge":"44"}},"title":"Bus and truck mechanics and diesel engine specialists","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"316","women":"0.8","white":"6.2","black":"0.6","asian":"15.9"}},"wageData":{"2013":{"workers":"302","median":"794","maleWorkers":"301","maleMedian":"795","femaleWorkers":"0","femaleMedian":"-"}}},"Heavy vehicle and mobile equipment service technicians and mechanics":{"ageData":{"2013":{"total":"218","16to19":"3","20to24":"13","25to34":"56","35to44":"50","45to54":"47","55to64":"43","65+":"7","medianAge":"43"}},"title":"Heavy vehicle and mobile equipment service technicians and mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"218","women":"0.6","white":"7.5","black":"1.4","asian":"15.7"}},"wageData":{"2013":{"workers":"196","median":"867","maleWorkers":"195","maleMedian":"868","femaleWorkers":"1","femaleMedian":"-"}}},"Small engine mechanics":{"ageData":{"2013":{"total":"41","16to19":"1","20to24":"2","25to34":"15","35to44":"9","45to54":"6","55to64":"8","65+":"1","medianAge":"8"}},"title":"Small engine mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"41","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"32","median":"-","maleWorkers":"31","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Miscellaneous vehicle and mobile equipment mechanics, installers, and repairers":{"ageData":{"2013":{"total":"98","16to19":"11","20to24":"22","25to34":"27","35to44":"18","45to54":"12","55to64":"6","65+":"2","medianAge":"6"}},"title":"Miscellaneous vehicle and mobile equipment mechanics, installers, and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"98","women":"1.8","white":"11.6","black":"0.9","asian":"31.6"}},"wageData":{"2013":{"workers":"74","median":"468","maleWorkers":"72","maleMedian":"480","femaleWorkers":"2","femaleMedian":"-"}}},"Control and valve installers and repairers":{"ageData":{"2013":{"total":"23","16to19":"0","20to24":"2","25to34":"4","35to44":"3","45to54":"10","55to64":"4","65+":"0","medianAge":"4"}},"title":"Control and valve installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"23","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"24","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Heating, air conditioning, and refrigeration mechanics and installers":{"ageData":{"2013":{"total":"384","16to19":"4","20to24":"34","25to34":"100","35to44":"94","45to54":"89","55to64":"55","65+":"6","medianAge":"55"}},"title":"Heating, air conditioning, and refrigeration mechanics and installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"384","women":"1.2","white":"7.4","black":"2.5","asian":"16.9"}},"wageData":{"2013":{"workers":"316","median":"792","maleWorkers":"313","maleMedian":"791","femaleWorkers":"3","femaleMedian":"-"}}},"Home appliance repairers":{"ageData":{"2013":{"total":"52","16to19":"0","20to24":"4","25to34":"11","35to44":"10","45to54":"15","55to64":"10","65+":"3","medianAge":"10"}},"title":"Home appliance repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"52","women":"0.4","white":"12.5","black":"2.1","asian":"20.1"}},"wageData":{"2013":{"workers":"38","median":"-","maleWorkers":"38","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Industrial and refractory machinery mechanics":{"ageData":{"2013":{"total":"437","16to19":"3","20to24":"17","25to34":"72","35to44":"93","45to54":"134","55to64":"103","65+":"16","medianAge":"103"}},"title":"Industrial and refractory machinery mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"437","women":"4.6","white":"4.6","black":"3.3","asian":"12.8"}},"wageData":{"2013":{"workers":"434","median":"896","maleWorkers":"414","maleMedian":"899","femaleWorkers":"20","femaleMedian":"-"}}},"Maintenance and repair workers, general":{"ageData":{"2013":{"total":"462","16to19":"5","20to24":"18","25to34":"76","35to44":"103","45to54":"141","55to64":"87","65+":"30","medianAge":"87"}},"title":"Maintenance and repair workers, general","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"462","women":"4.0","white":"10.4","black":"2.7","asian":"19.3"}},"wageData":{"2013":{"workers":"405","median":"805","maleWorkers":"386","maleMedian":"807","femaleWorkers":"18","femaleMedian":"-"}}},"Maintenance workers, machinery":{"ageData":{"2013":{"total":"40","16to19":"1","20to24":"7","25to34":"6","35to44":"8","45to54":"12","55to64":"4","65+":"3","medianAge":"4"}},"title":"Maintenance workers, machinery","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"33","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Millwrights":{"ageData":{"2013":{"total":"66","16to19":"1","20to24":"4","25to34":"11","35to44":"12","45to54":"20","55to64":"15","65+":"2","medianAge":"15"}},"title":"Millwrights","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"66","women":"1.2","white":"3.6","black":"0.8","asian":"8.7"}},"wageData":{"2013":{"workers":"62","median":"1,019","maleWorkers":"61","maleMedian":"1,025","femaleWorkers":"1","femaleMedian":"-"}}},"Electrical power-line installers and repairers":{"ageData":{"2013":{"total":"117","16to19":"0","20to24":"15","25to34":"33","35to44":"24","45to54":"28","55to64":"13","65+":"2","medianAge":"13"}},"title":"Electrical power-line installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"117","women":"1.1","white":"5.7","black":"1.7","asian":"12.6"}},"wageData":{"2013":{"workers":"113","median":"922","maleWorkers":"112","maleMedian":"929","femaleWorkers":"1","femaleMedian":"-"}}},"Telecommunications line installers and repairers":{"ageData":{"2013":{"total":"183","16to19":"0","20to24":"13","25to34":"46","35to44":"58","45to54":"43","55to64":"18","65+":"5","medianAge":"18"}},"title":"Telecommunications line installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"183","women":"2.8","white":"13.5","black":"3.0","asian":"15.5"}},"wageData":{"2013":{"workers":"177","median":"930","maleWorkers":"172","maleMedian":"929","femaleWorkers":"6","femaleMedian":"-"}}},"Precision instrument and equipment repairers":{"ageData":{"2013":{"total":"76","16to19":"0","20to24":"3","25to34":"19","35to44":"14","45to54":"19","55to64":"16","65+":"5","medianAge":"16"}},"title":"Precision instrument and equipment repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"76","women":"11.8","white":"6.9","black":"8.2","asian":"6.1"}},"wageData":{"2013":{"workers":"58","median":"951","maleWorkers":"51","maleMedian":"956","femaleWorkers":"7","femaleMedian":"-"}}},"Wind turbine service technicians":{"ageData":{"2013":{"total":"3","16to19":"0","20to24":"1","25to34":"1","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Wind turbine service technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"3","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Coin, vending, and amusement machine servicers and repairers":{"ageData":{"2013":{"total":"40","16to19":"1","20to24":"4","25to34":"5","35to44":"8","45to54":"12","55to64":"8","65+":"2","medianAge":"8"}},"title":"Coin, vending, and amusement machine servicers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"32","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Commercial divers":{"ageData":{"2013":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Commercial divers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Locksmiths and safe repairers":{"ageData":{"2013":{"total":"29","16to19":"0","20to24":"4","25to34":"2","35to44":"2","45to54":"10","55to64":"9","65+":"3","medianAge":"9"}},"title":"Locksmiths and safe repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"29","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"17","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Manufactured building and mobile home installers":{"ageData":{"2013":{"total":"8","16to19":"0","20to24":"1","25to34":"1","35to44":"4","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Manufactured building and mobile home installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"10","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Riggers":{"ageData":{"2013":{"total":"13","16to19":"0","20to24":"2","25to34":"1","35to44":"4","45to54":"5","55to64":"1","65+":"0","medianAge":"1"}},"title":"Riggers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"13","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Signal and track switch repairers":{"ageData":{"2013":{"total":"6","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Signal and track switch repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers--installation, maintenance, and repair workers":{"ageData":{"2013":{"total":"22","16to19":"2","20to24":"5","25to34":"5","35to44":"2","45to54":"4","55to64":"3","65+":"1","medianAge":"3"}},"title":"Helpers--installation, maintenance, and repair workers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"22","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"18","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Other installation, maintenance, and repair workers":{"ageData":{"2013":{"total":"215","16to19":"2","20to24":"17","25to34":"49","35to44":"41","45to54":"54","55to64":"40","65+":"13","medianAge":"40"}},"title":"Other installation, maintenance, and repair workers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2013":{"total":"215","women":"5.9","white":"7.3","black":"1.0","asian":"22.2"}},"wageData":{"2013":{"workers":"135","median":"667","maleWorkers":"129","maleMedian":"674","femaleWorkers":"6","femaleMedian":"-"}}},"Production, transportation, and material moving occupations":{"ageData":{"2013":{"total":"16,984","16to19":"441","20to24":"1,664","25to34":"3,442","35to44":"3,551","45to54":"4,119","55to64":"2,955","65+":"812","medianAge":"2,955"}},"title":"Production, transportation, and material moving occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2013":{"total":"16,984","women":"21.4","white":"14.9","black":"4.7","asian":"21.9"}},"wageData":{"2013":{"workers":"13,930","median":"621","maleWorkers":"11,090","maleMedian":"674","femaleWorkers":"2,840","femaleMedian":"498"}}},"Production occupations":{"ageData":{"2013":{"total":"8,275","16to19":"144","20to24":"767","25to34":"1,745","35to44":"1,783","45to54":"2,059","55to64":"1,475","65+":"302","medianAge":"1,475"}},"title":"Production occupations","depth":2,"parent":"Production, transportation, and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"8,275","women":"27.6","white":"12.3","black":"6.3","asian":"22.5"}},"wageData":{"2013":{"workers":"7,307","median":"623","maleWorkers":"5,382","maleMedian":"697","femaleWorkers":"1,925","femaleMedian":"498"}}},"First-line supervisors of production and operating workers":{"ageData":{"2013":{"total":"731","16to19":"1","20to24":"17","25to34":"124","35to44":"171","45to54":"235","55to64":"154","65+":"29","medianAge":"154"}},"title":"First-line supervisors of production and operating workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"731","women":"18.6","white":"9.5","black":"4.9","asian":"14.4"}},"wageData":{"2013":{"workers":"675","median":"902","maleWorkers":"550","maleMedian":"952","femaleWorkers":"125","femaleMedian":"682"}}},"Aircraft structure, surfaces, rigging, and systems assemblers":{"ageData":{"2013":{"total":"14","16to19":"0","20to24":"1","25to34":"4","35to44":"4","45to54":"2","55to64":"2","65+":"1","medianAge":"2"}},"title":"Aircraft structure, surfaces, rigging, and systems assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"16","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Electrical, electronics, and electromechanical assemblers":{"ageData":{"2013":{"total":"141","16to19":"1","20to24":"12","25to34":"23","35to44":"26","45to54":"44","55to64":"28","65+":"7","medianAge":"28"}},"title":"Electrical, electronics, and electromechanical assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"141","women":"47.0","white":"11.4","black":"18.2","asian":"21.3"}},"wageData":{"2013":{"workers":"126","median":"503","maleWorkers":"64","maleMedian":"522","femaleWorkers":"61","femaleMedian":"490"}}},"Engine and other machine assemblers":{"ageData":{"2013":{"total":"20","16to19":"0","20to24":"2","25to34":"5","35to44":"4","45to54":"5","55to64":"3","65+":"1","medianAge":"3"}},"title":"Engine and other machine assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"20","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"19","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Structural metal fabricators and fitters":{"ageData":{"2013":{"total":"23","16to19":"0","20to24":"0","25to34":"4","35to44":"6","45to54":"9","55to64":"4","65+":"0","medianAge":"4"}},"title":"Structural metal fabricators and fitters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"23","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"21","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Miscellaneous assemblers and fabricators":{"ageData":{"2013":{"total":"1,013","16to19":"21","20to24":"120","25to34":"214","35to44":"235","45to54":"230","55to64":"156","65+":"36","medianAge":"156"}},"title":"Miscellaneous assemblers and fabricators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"1,013","women":"37.0","white":"16.5","black":"7.7","asian":"19.6"}},"wageData":{"2013":{"workers":"900","median":"564","maleWorkers":"566","maleMedian":"610","femaleWorkers":"335","femaleMedian":"493"}}},"Bakers":{"ageData":{"2013":{"total":"207","16to19":"9","20to24":"34","25to34":"47","35to44":"30","45to54":"44","55to64":"34","65+":"9","medianAge":"34"}},"title":"Bakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"207","women":"59.8","white":"9.0","black":"7.1","asian":"25.9"}},"wageData":{"2013":{"workers":"117","median":"505","maleWorkers":"56","maleMedian":"488","femaleWorkers":"61","femaleMedian":"524"}}},"Butchers and other meat, poultry, and fish processing workers":{"ageData":{"2013":{"total":"323","16to19":"11","20to24":"45","25to34":"80","35to44":"74","45to54":"66","55to64":"37","65+":"10","medianAge":"37"}},"title":"Butchers and other meat, poultry, and fish processing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"323","women":"25.5","white":"14.8","black":"11.2","asian":"34.7"}},"wageData":{"2013":{"workers":"284","median":"506","maleWorkers":"211","maleMedian":"525","femaleWorkers":"73","femaleMedian":"476"}}},"Food and tobacco roasting, baking, and drying machine operators and tenders":{"ageData":{"2013":{"total":"10","16to19":"1","20to24":"1","25to34":"2","35to44":"3","45to54":"2","55to64":"1","65+":"1","medianAge":"1"}},"title":"Food and tobacco roasting, baking, and drying machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"6","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Food batchmakers":{"ageData":{"2013":{"total":"93","16to19":"8","20to24":"11","25to34":"20","35to44":"17","45to54":"18","55to64":"16","65+":"4","medianAge":"16"}},"title":"Food batchmakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"93","women":"51.4","white":"8.4","black":"4.4","asian":"28.2"}},"wageData":{"2013":{"workers":"66","median":"516","maleWorkers":"33","maleMedian":"-","femaleWorkers":"33","femaleMedian":"-"}}},"Food cooking machine operators and tenders":{"ageData":{"2013":{"total":"9","16to19":"1","20to24":"1","25to34":"1","35to44":"4","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Food cooking machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"6","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Food processing workers, all other":{"ageData":{"2013":{"total":"123","16to19":"1","20to24":"17","25to34":"29","35to44":"27","45to54":"27","55to64":"20","65+":"2","medianAge":"20"}},"title":"Food processing workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"123","women":"31.4","white":"11.5","black":"7.7","asian":"33.8"}},"wageData":{"2013":{"workers":"113","median":"571","maleWorkers":"78","maleMedian":"635","femaleWorkers":"35","femaleMedian":"-"}}},"Computer control programmers and operators":{"ageData":{"2013":{"total":"85","16to19":"1","20to24":"5","25to34":"23","35to44":"24","45to54":"17","55to64":"14","65+":"1","medianAge":"14"}},"title":"Computer control programmers and operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"85","women":"5.1","white":"3.6","black":"2.3","asian":"12.6"}},"wageData":{"2013":{"workers":"69","median":"849","maleWorkers":"66","maleMedian":"859","femaleWorkers":"2","femaleMedian":"-"}}},"Extruding and drawing machine setters, operators, and tenders, metal and plastic":{"ageData":{"2013":{"total":"13","16to19":"0","20to24":"0","25to34":"4","35to44":"4","45to54":"3","55to64":"2","65+":"0","medianAge":"2"}},"title":"Extruding and drawing machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"16","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Forging machine setters, operators, and tenders, metal and plastic":{"ageData":{"2013":{"total":"8","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"3","55to64":"4","65+":"0","medianAge":"4"}},"title":"Forging machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"9","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Rolling machine setters, operators, and tenders, metal and plastic":{"ageData":{"2013":{"total":"4","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Rolling machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Cutting, punching, and press machine setters, operators, and tenders, metal and plastic":{"ageData":{"2013":{"total":"76","16to19":"3","20to24":"8","25to34":"18","35to44":"18","45to54":"20","55to64":"9","65+":"1","medianAge":"9"}},"title":"Cutting, punching, and press machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"76","women":"16.4","white":"8.9","black":"2.8","asian":"24.7"}},"wageData":{"2013":{"workers":"70","median":"545","maleWorkers":"60","maleMedian":"532","femaleWorkers":"10","femaleMedian":"-"}}},"Drilling and boring machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2013":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Drilling and boring machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Grinding, lapping, polishing, and buffing machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2013":{"total":"57","16to19":"0","20to24":"5","25to34":"12","35to44":"12","45to54":"12","55to64":"12","65+":"4","medianAge":"12"}},"title":"Grinding, lapping, polishing, and buffing machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"57","women":"14.2","white":"9.1","black":"5.1","asian":"25.8"}},"wageData":{"2013":{"workers":"50","median":"610","maleWorkers":"44","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Lathe and turning machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2013":{"total":"11","16to19":"0","20to24":"1","25to34":"1","35to44":"1","45to54":"4","55to64":"2","65+":"1","medianAge":"2"}},"title":"Lathe and turning machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"11","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Milling and planing machine setters, operators, and tenders, metal and plastic":{"ageData":{"2013":{"total":"5","16to19":"0","20to24":"0","25to34":"2","35to44":"2","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Milling and planing machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Machinists":{"ageData":{"2013":{"total":"398","16to19":"5","20to24":"25","25to34":"75","35to44":"79","45to54":"102","55to64":"92","65+":"20","medianAge":"92"}},"title":"Machinists","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"398","women":"5.3","white":"4.4","black":"6.3","asian":"15.1"}},"wageData":{"2013":{"workers":"388","median":"777","maleWorkers":"367","maleMedian":"795","femaleWorkers":"21","femaleMedian":"-"}}},"Metal furnace operators, tenders, pourers, and casters":{"ageData":{"2013":{"total":"24","16to19":"0","20to24":"2","25to34":"4","35to44":"7","45to54":"4","55to64":"5","65+":"1","medianAge":"5"}},"title":"Metal furnace operators, tenders, pourers, and casters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"24","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"23","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Model makers and patternmakers, metal and plastic":{"ageData":{"2013":{"total":"7","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"2","55to64":"0","65+":"2","medianAge":"0"}},"title":"Model makers and patternmakers, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"3","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Molders and molding machine setters, operators, and tenders, metal and plastic":{"ageData":{"2013":{"total":"50","16to19":"1","20to24":"6","25to34":"10","35to44":"11","45to54":"14","55to64":"8","65+":"1","medianAge":"8"}},"title":"Molders and molding machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"50","women":"25.6","white":"3.6","black":"1.1","asian":"23.5"}},"wageData":{"2013":{"workers":"51","median":"717","maleWorkers":"38","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Multiple machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2013":{"total":"4","16to19":"0","20to24":"0","25to34":"0","35to44":"2","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Multiple machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"4","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Tool and die makers":{"ageData":{"2013":{"total":"53","16to19":"0","20to24":"1","25to34":"5","35to44":"9","45to54":"18","55to64":"17","65+":"2","medianAge":"17"}},"title":"Tool and die makers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"53","women":"0.3","white":"0.9","black":"1.1","asian":"4.4"}},"wageData":{"2013":{"workers":"55","median":"908","maleWorkers":"55","maleMedian":"911","femaleWorkers":"1","femaleMedian":"-"}}},"Welding, soldering, and brazing workers":{"ageData":{"2013":{"total":"575","16to19":"8","20to24":"67","25to34":"162","35to44":"132","45to54":"122","55to64":"72","65+":"13","medianAge":"72"}},"title":"Welding, soldering, and brazing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"575","women":"4.6","white":"8.1","black":"3.3","asian":"22.9"}},"wageData":{"2013":{"workers":"524","median":"723","maleWorkers":"499","maleMedian":"730","femaleWorkers":"25","femaleMedian":"-"}}},"Heat treating equipment setters, operators, and tenders, metal and plastic":{"ageData":{"2013":{"total":"9","16to19":"1","20to24":"2","25to34":"4","35to44":"1","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Heat treating equipment setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"9","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Layout workers, metal and plastic":{"ageData":{"2013":{"total":"5","16to19":"0","20to24":"0","25to34":"0","35to44":"2","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Layout workers, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"4","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Plating and coating machine setters, operators, and tenders, metal and plastic":{"ageData":{"2013":{"total":"18","16to19":"0","20to24":"2","25to34":"5","35to44":"5","45to54":"4","55to64":"1","65+":"1","medianAge":"1"}},"title":"Plating and coating machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"18","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"16","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Tool grinders, filers, and sharpeners":{"ageData":{"2013":{"total":"5","16to19":"0","20to24":"0","25to34":"1","35to44":"2","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Tool grinders, filers, and sharpeners","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Metal workers and plastic workers, all other":{"ageData":{"2013":{"total":"338","16to19":"5","20to24":"31","25to34":"63","35to44":"86","45to54":"85","55to64":"61","65+":"8","medianAge":"61"}},"title":"Metal workers and plastic workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"338","women":"22.0","white":"17.2","black":"6.1","asian":"25.3"}},"wageData":{"2013":{"workers":"323","median":"592","maleWorkers":"257","maleMedian":"606","femaleWorkers":"66","femaleMedian":"557"}}},"Prepress technicians and workers":{"ageData":{"2013":{"total":"29","16to19":"1","20to24":"0","25to34":"5","35to44":"7","45to54":"11","55to64":"3","65+":"2","medianAge":"3"}},"title":"Prepress technicians and workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"29","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"25","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Printing press operators":{"ageData":{"2013":{"total":"193","16to19":"1","20to24":"13","25to34":"44","35to44":"33","45to54":"61","55to64":"35","65+":"7","medianAge":"35"}},"title":"Printing press operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"193","women":"18.1","white":"7.4","black":"4.2","asian":"18.1"}},"wageData":{"2013":{"workers":"175","median":"656","maleWorkers":"145","maleMedian":"703","femaleWorkers":"30","femaleMedian":"-"}}},"Print binding and finishing workers":{"ageData":{"2013":{"total":"26","16to19":"0","20to24":"3","25to34":"4","35to44":"2","45to54":"8","55to64":"7","65+":"2","medianAge":"7"}},"title":"Print binding and finishing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"26","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"22","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Laundry and dry-cleaning workers":{"ageData":{"2013":{"total":"167","16to19":"7","20to24":"16","25to34":"31","35to44":"34","45to54":"37","55to64":"32","65+":"9","medianAge":"32"}},"title":"Laundry and dry-cleaning workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"167","women":"60.1","white":"20.6","black":"6.1","asian":"42.5"}},"wageData":{"2013":{"workers":"121","median":"385","maleWorkers":"50","maleMedian":"425","femaleWorkers":"71","femaleMedian":"360"}}},"Pressers, textile, garment, and related materials":{"ageData":{"2013":{"total":"55","16to19":"1","20to24":"0","25to34":"15","35to44":"10","45to54":"16","55to64":"9","65+":"4","medianAge":"9"}},"title":"Pressers, textile, garment, and related materials","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"55","women":"55.7","white":"27.6","black":"4.7","asian":"52.6"}},"wageData":{"2013":{"workers":"35","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Sewing machine operators":{"ageData":{"2013":{"total":"158","16to19":"0","20to24":"16","25to34":"21","35to44":"26","45to54":"47","55to64":"41","65+":"6","medianAge":"41"}},"title":"Sewing machine operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"158","women":"76.1","white":"12.1","black":"17.3","asian":"41.4"}},"wageData":{"2013":{"workers":"121","median":"405","maleWorkers":"29","maleMedian":"-","femaleWorkers":"91","femaleMedian":"405"}}},"Shoe and leather workers and repairers":{"ageData":{"2013":{"total":"15","16to19":"0","20to24":"0","25to34":"4","35to44":"2","45to54":"4","55to64":"2","65+":"4","medianAge":"2"}},"title":"Shoe and leather workers and repairers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"15","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"5","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Shoe machine operators and tenders":{"ageData":{"2013":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Shoe machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"3","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Tailors, dressmakers, and sewers":{"ageData":{"2013":{"total":"84","16to19":"0","20to24":"5","25to34":"7","35to44":"15","45to54":"23","55to64":"23","65+":"10","medianAge":"23"}},"title":"Tailors, dressmakers, and sewers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"84","women":"72.0","white":"9.7","black":"21.8","asian":"24.6"}},"wageData":{"2013":{"workers":"42","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Textile bleaching and dyeing machine operators and tenders":{"ageData":{"2013":{"total":"2","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Textile bleaching and dyeing machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Textile cutting machine setters, operators, and tenders":{"ageData":{"2013":{"total":"6","16to19":"0","20to24":"0","25to34":"1","35to44":"2","45to54":"2","55to64":"0","65+":"1","medianAge":"0"}},"title":"Textile cutting machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Textile knitting and weaving machine setters, operators, and tenders":{"ageData":{"2013":{"total":"6","16to19":"0","20to24":"1","25to34":"1","35to44":"1","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Textile knitting and weaving machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"3","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Textile winding, twisting, and drawing out machine setters, operators, and tenders":{"ageData":{"2013":{"total":"16","16to19":"0","20to24":"0","25to34":"2","35to44":"9","45to54":"2","55to64":"2","65+":"1","medianAge":"2"}},"title":"Textile winding, twisting, and drawing out machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"16","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"12","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Extruding and forming machine setters, operators, and tenders, synthetic and glass fibers":{"ageData":{"2013":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Extruding and forming machine setters, operators, and tenders, synthetic and glass fibers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Fabric and apparel patternmakers":{"ageData":{"2013":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Fabric and apparel patternmakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Upholsterers":{"ageData":{"2013":{"total":"35","16to19":"1","20to24":"0","25to34":"3","35to44":"5","45to54":"17","55to64":"8","65+":"1","medianAge":"8"}},"title":"Upholsterers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"35","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"19","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Textile, apparel, and furnishings workers, all other":{"ageData":{"2013":{"total":"14","16to19":"1","20to24":"0","25to34":"3","35to44":"3","45to54":"2","55to64":"3","65+":"2","medianAge":"3"}},"title":"Textile, apparel, and furnishings workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"12","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Cabinetmakers and bench carpenters":{"ageData":{"2013":{"total":"47","16to19":"2","20to24":"4","25to34":"7","35to44":"8","45to54":"14","55to64":"11","65+":"1","medianAge":"11"}},"title":"Cabinetmakers and bench carpenters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"47","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"28","median":"-","maleWorkers":"27","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Furniture finishers":{"ageData":{"2013":{"total":"7","16to19":"0","20to24":"1","25to34":"1","35to44":"1","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Furniture finishers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"5","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Model makers and patternmakers, wood":{"ageData":{"2013":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Model makers and patternmakers, wood","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"0","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Sawing machine setters, operators, and tenders, wood":{"ageData":{"2013":{"total":"33","16to19":"2","20to24":"3","25to34":"8","35to44":"4","45to54":"7","55to64":"8","65+":"1","medianAge":"8"}},"title":"Sawing machine setters, operators, and tenders, wood","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"25","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Woodworking machine setters, operators, and tenders, except sawing":{"ageData":{"2013":{"total":"19","16to19":"1","20to24":"3","25to34":"3","35to44":"4","45to54":"5","55to64":"3","65+":"0","medianAge":"3"}},"title":"Woodworking machine setters, operators, and tenders, except sawing","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"18","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Woodworkers, all other":{"ageData":{"2013":{"total":"19","16to19":"0","20to24":"1","25to34":"3","35to44":"2","45to54":"8","55to64":"3","65+":"2","medianAge":"3"}},"title":"Woodworkers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"9","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Power plant operators, distributors, and dispatchers":{"ageData":{"2013":{"total":"45","16to19":"0","20to24":"1","25to34":"6","35to44":"15","45to54":"13","55to64":"7","65+":"2","medianAge":"7"}},"title":"Power plant operators, distributors, and dispatchers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"45","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"41","median":"-","maleWorkers":"35","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Stationary engineers and boiler operators":{"ageData":{"2013":{"total":"91","16to19":"0","20to24":"1","25to34":"19","35to44":"19","45to54":"23","55to64":"23","65+":"5","medianAge":"23"}},"title":"Stationary engineers and boiler operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"91","women":"5.8","white":"11.2","black":"4.7","asian":"26.1"}},"wageData":{"2013":{"workers":"90","median":"903","maleWorkers":"84","maleMedian":"922","femaleWorkers":"5","femaleMedian":"-"}}},"Water and wastewater treatment plant and system operators":{"ageData":{"2013":{"total":"68","16to19":"0","20to24":"4","25to34":"8","35to44":"11","45to54":"26","55to64":"16","65+":"2","medianAge":"16"}},"title":"Water and wastewater treatment plant and system operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"68","women":"6.9","white":"9.1","black":"3.1","asian":"15.2"}},"wageData":{"2013":{"workers":"68","median":"828","maleWorkers":"64","maleMedian":"829","femaleWorkers":"4","femaleMedian":"-"}}},"Miscellaneous plant and system operators":{"ageData":{"2013":{"total":"37","16to19":"0","20to24":"2","25to34":"7","35to44":"8","45to54":"11","55to64":"10","65+":"1","medianAge":"10"}},"title":"Miscellaneous plant and system operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"37","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"41","median":"-","maleWorkers":"40","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Chemical processing machine setters, operators, and tenders":{"ageData":{"2013":{"total":"54","16to19":"2","20to24":"3","25to34":"9","35to44":"9","45to54":"23","55to64":"6","65+":"1","medianAge":"6"}},"title":"Chemical processing machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"54","women":"8.1","white":"5.2","black":"2.5","asian":"11.7"}},"wageData":{"2013":{"workers":"46","median":"-","maleWorkers":"41","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Crushing, grinding, polishing, mixing, and blending workers":{"ageData":{"2013":{"total":"87","16to19":"2","20to24":"10","25to34":"19","35to44":"21","45to54":"20","55to64":"13","65+":"3","medianAge":"13"}},"title":"Crushing, grinding, polishing, mixing, and blending workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"87","women":"12.8","white":"13.3","black":"5.3","asian":"22.1"}},"wageData":{"2013":{"workers":"88","median":"716","maleWorkers":"77","maleMedian":"807","femaleWorkers":"11","femaleMedian":"-"}}},"Cutting workers":{"ageData":{"2013":{"total":"59","16to19":"2","20to24":"6","25to34":"17","35to44":"11","45to54":"12","55to64":"11","65+":"2","medianAge":"11"}},"title":"Cutting workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"59","women":"24.2","white":"10.8","black":"3.9","asian":"36.5"}},"wageData":{"2013":{"workers":"40","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Extruding, forming, pressing, and compacting machine setters, operators, and tenders":{"ageData":{"2013":{"total":"26","16to19":"0","20to24":"3","25to34":"3","35to44":"6","45to54":"7","55to64":"7","65+":"0","medianAge":"7"}},"title":"Extruding, forming, pressing, and compacting machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"26","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"31","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Furnace, kiln, oven, drier, and kettle operators and tenders":{"ageData":{"2013":{"total":"15","16to19":"0","20to24":"1","25to34":"2","35to44":"6","45to54":"5","55to64":"1","65+":"0","medianAge":"1"}},"title":"Furnace, kiln, oven, drier, and kettle operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"15","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"10","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Inspectors, testers, sorters, samplers, and weighers":{"ageData":{"2013":{"total":"686","16to19":"8","20to24":"58","25to34":"153","35to44":"144","45to54":"152","55to64":"151","65+":"22","medianAge":"151"}},"title":"Inspectors, testers, sorters, samplers, and weighers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"686","women":"32.8","white":"12.9","black":"6.8","asian":"15.7"}},"wageData":{"2013":{"workers":"650","median":"741","maleWorkers":"439","maleMedian":"835","femaleWorkers":"211","femaleMedian":"583"}}},"Jewelers and precious stone and metal workers":{"ageData":{"2013":{"total":"54","16to19":"0","20to24":"2","25to34":"8","35to44":"13","45to54":"11","55to64":"10","65+":"10","medianAge":"10"}},"title":"Jewelers and precious stone and metal workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"54","women":"45.1","white":"9.2","black":"11.7","asian":"16.7"}},"wageData":{"2013":{"workers":"23","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Medical, dental, and ophthalmic laboratory technicians":{"ageData":{"2013":{"total":"85","16to19":"0","20to24":"8","25to34":"17","35to44":"20","45to54":"17","55to64":"21","65+":"3","medianAge":"21"}},"title":"Medical, dental, and ophthalmic laboratory technicians","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"85","women":"48.9","white":"4.9","black":"6.3","asian":"15.7"}},"wageData":{"2013":{"workers":"67","median":"701","maleWorkers":"34","maleMedian":"-","femaleWorkers":"33","femaleMedian":"-"}}},"Packaging and filling machine operators and tenders":{"ageData":{"2013":{"total":"304","16to19":"6","20to24":"37","25to34":"73","35to44":"66","45to54":"78","55to64":"35","65+":"10","medianAge":"35"}},"title":"Packaging and filling machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"304","women":"51.5","white":"19.7","black":"9.6","asian":"37.4"}},"wageData":{"2013":{"workers":"297","median":"488","maleWorkers":"137","maleMedian":"537","femaleWorkers":"159","femaleMedian":"429"}}},"Painting workers":{"ageData":{"2013":{"total":"147","16to19":"1","20to24":"16","25to34":"38","35to44":"24","45to54":"35","55to64":"26","65+":"5","medianAge":"26"}},"title":"Painting workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"147","women":"12.8","white":"8.8","black":"3.1","asian":"31.8"}},"wageData":{"2013":{"workers":"125","median":"664","maleWorkers":"108","maleMedian":"673","femaleWorkers":"17","femaleMedian":"-"}}},"Photographic process workers and processing machine operators":{"ageData":{"2013":{"total":"43","16to19":"4","20to24":"13","25to34":"8","35to44":"7","45to54":"6","55to64":"4","65+":"0","medianAge":"4"}},"title":"Photographic process workers and processing machine operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"43","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"26","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Semiconductor processors":{"ageData":{"2013":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Semiconductor processors","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Adhesive bonding machine operators and tenders":{"ageData":{"2013":{"total":"12","16to19":"0","20to24":"2","25to34":"1","35to44":"4","45to54":"4","55to64":"1","65+":"0","medianAge":"1"}},"title":"Adhesive bonding machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"11","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Cleaning, washing, and metal pickling equipment operators and tenders":{"ageData":{"2013":{"total":"4","16to19":"0","20to24":"1","25to34":"2","35to44":"0","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Cleaning, washing, and metal pickling equipment operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"3","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Cooling and freezing equipment operators and tenders":{"ageData":{"2013":{"total":"3","16to19":"0","20to24":"0","25to34":"0","35to44":"2","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Cooling and freezing equipment operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Etchers and engravers":{"ageData":{"2013":{"total":"7","16to19":"0","20to24":"1","25to34":"1","35to44":"1","45to54":"3","55to64":"1","65+":"0","medianAge":"1"}},"title":"Etchers and engravers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Molders, shapers, and casters, except metal and plastic":{"ageData":{"2013":{"total":"41","16to19":"0","20to24":"8","25to34":"7","35to44":"9","45to54":"11","55to64":"4","65+":"1","medianAge":"4"}},"title":"Molders, shapers, and casters, except metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"41","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"31","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Paper goods machine setters, operators, and tenders":{"ageData":{"2013":{"total":"24","16to19":"0","20to24":"2","25to34":"6","35to44":"8","45to54":"3","55to64":"5","65+":"0","medianAge":"5"}},"title":"Paper goods machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"24","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"21","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Tire builders":{"ageData":{"2013":{"total":"21","16to19":"1","20to24":"5","25to34":"3","35to44":"6","45to54":"2","55to64":"3","65+":"1","medianAge":"3"}},"title":"Tire builders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"21","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"23","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Helpers--production workers":{"ageData":{"2013":{"total":"39","16to19":"6","20to24":"7","25to34":"8","35to44":"6","45to54":"4","55to64":"7","65+":"1","medianAge":"7"}},"title":"Helpers--production workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"39","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"29","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Production workers, all other":{"ageData":{"2013":{"total":"933","16to19":"17","20to24":"93","25to34":"222","35to44":"197","45to54":"224","55to64":"154","65+":"25","medianAge":"154"}},"title":"Production workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2013":{"total":"933","women":"26.4","white":"15.7","black":"5.2","asian":"22.5"}},"wageData":{"2013":{"workers":"866","median":"586","maleWorkers":"630","maleMedian":"619","femaleWorkers":"236","femaleMedian":"501"}}},"Transportation and material moving occupations":{"ageData":{"2013":{"total":"8,709","16to19":"297","20to24":"897","25to34":"1,697","35to44":"1,768","45to54":"2,060","55to64":"1,479","65+":"510","medianAge":"1,479"}},"title":"Transportation and material moving occupations","depth":2,"parent":"Production, transportation, and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"8,709","women":"15.5","white":"17.4","black":"3.1","asian":"21.3"}},"wageData":{"2013":{"workers":"6,623","median":"619","maleWorkers":"5,707","maleMedian":"645","femaleWorkers":"916","femaleMedian":"497"}}},"Supervisors of transportation and material moving workers":{"ageData":{"2013":{"total":"194","16to19":"1","20to24":"13","25to34":"42","35to44":"50","45to54":"52","55to64":"34","65+":"2","medianAge":"34"}},"title":"Supervisors of transportation and material moving workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"194","women":"21.4","white":"14.5","black":"1.6","asian":"18.9"}},"wageData":{"2013":{"workers":"165","median":"882","maleWorkers":"126","maleMedian":"930","femaleWorkers":"38","femaleMedian":"-"}}},"Aircraft pilots and flight engineers":{"ageData":{"2013":{"total":"135","16to19":"0","20to24":"2","25to34":"21","35to44":"34","45to54":"41","55to64":"32","65+":"4","medianAge":"32"}},"title":"Aircraft pilots and flight engineers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"135","women":"5.5","white":"3.4","black":"3.7","asian":"4.5"}},"wageData":{"2013":{"workers":"100","median":"1,845","maleWorkers":"93","maleMedian":"1,859","femaleWorkers":"7","femaleMedian":"-"}}},"Air traffic controllers and airfield operations specialists":{"ageData":{"2013":{"total":"40","16to19":"0","20to24":"0","25to34":"14","35to44":"6","45to54":"15","55to64":"3","65+":"2","medianAge":"3"}},"title":"Air traffic controllers and airfield operations specialists","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"41","median":"-","maleWorkers":"37","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Flight attendants":{"ageData":{"2013":{"total":"89","16to19":"0","20to24":"1","25to34":"10","35to44":"18","45to54":"30","55to64":"24","65+":"5","medianAge":"24"}},"title":"Flight attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"89","women":"80.9","white":"12.4","black":"4.9","asian":"10.1"}},"wageData":{"2013":{"workers":"69","median":"767","maleWorkers":"16","maleMedian":"-","femaleWorkers":"54","femaleMedian":"749"}}},"Ambulance drivers and attendants, except emergency medical technicians":{"ageData":{"2013":{"total":"17","16to19":"1","20to24":"4","25to34":"4","35to44":"1","45to54":"2","55to64":"3","65+":"2","medianAge":"3"}},"title":"Ambulance drivers and attendants, except emergency medical technicians","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"17","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"12","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Bus drivers":{"ageData":{"2013":{"total":"582","16to19":"1","20to24":"21","25to34":"53","35to44":"99","45to54":"161","55to64":"158","65+":"90","medianAge":"158"}},"title":"Bus drivers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"582","women":"45.7","white":"27.3","black":"2.1","asian":"13.9"}},"wageData":{"2013":{"workers":"339","median":"579","maleWorkers":"192","maleMedian":"597","femaleWorkers":"147","femaleMedian":"556"}}},"Driver/sales workers and truck drivers":{"ageData":{"2013":{"total":"3,252","16to19":"39","20to24":"199","25to34":"545","35to44":"741","45to54":"903","55to64":"622","65+":"203","medianAge":"622"}},"title":"Driver/sales workers and truck drivers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"3,252","women":"5.2","white":"15.3","black":"2.3","asian":"18.9"}},"wageData":{"2013":{"workers":"2,587","median":"730","maleWorkers":"2,482","maleMedian":"738","femaleWorkers":"106","femaleMedian":"583"}}},"Taxi drivers and chauffeurs":{"ageData":{"2013":{"total":"338","16to19":"2","20to24":"9","25to34":"55","35to44":"60","45to54":"96","55to64":"72","65+":"43","medianAge":"72"}},"title":"Taxi drivers and chauffeurs","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"338","women":"14.9","white":"24.7","black":"11.7","asian":"14.3"}},"wageData":{"2013":{"workers":"202","median":"521","maleWorkers":"172","maleMedian":"540","femaleWorkers":"30","femaleMedian":"-"}}},"Motor vehicle operators, all other":{"ageData":{"2013":{"total":"74","16to19":"4","20to24":"7","25to34":"6","35to44":"7","45to54":"8","55to64":"10","65+":"33","medianAge":"10"}},"title":"Motor vehicle operators, all other","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"74","women":"11.1","white":"11.4","black":"2.8","asian":"20.7"}},"wageData":{"2013":{"workers":"39","median":"-","maleWorkers":"37","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Locomotive engineers and operators":{"ageData":{"2013":{"total":"58","16to19":"0","20to24":"2","25to34":"7","35to44":"19","45to54":"16","55to64":"13","65+":"0","medianAge":"13"}},"title":"Locomotive engineers and operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"58","women":"6.1","white":"10.3","black":"2.4","asian":"12.2"}},"wageData":{"2013":{"workers":"50","median":"1,396","maleWorkers":"48","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Railroad brake, signal, and switch operators":{"ageData":{"2013":{"total":"10","16to19":"0","20to24":"1","25to34":"1","35to44":"4","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Railroad brake, signal, and switch operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"12","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Railroad conductors and yardmasters":{"ageData":{"2013":{"total":"50","16to19":"0","20to24":"2","25to34":"16","35to44":"18","45to54":"8","55to64":"5","65+":"1","medianAge":"5"}},"title":"Railroad conductors and yardmasters","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"50","women":"6.4","white":"17.7","black":"1.5","asian":"9.3"}},"wageData":{"2013":{"workers":"46","median":"-","maleWorkers":"43","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Subway, streetcar, and other rail transportation workers":{"ageData":{"2013":{"total":"9","16to19":"0","20to24":"0","25to34":"3","35to44":"2","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Subway, streetcar, and other rail transportation workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Sailors and marine oilers":{"ageData":{"2013":{"total":"30","16to19":"2","20to24":"2","25to34":"10","35to44":"6","45to54":"6","55to64":"5","65+":"1","medianAge":"5"}},"title":"Sailors and marine oilers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"30","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"29","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Ship and boat captains and operators":{"ageData":{"2013":{"total":"40","16to19":"0","20to24":"3","25to34":"9","35to44":"8","45to54":"10","55to64":"7","65+":"3","medianAge":"7"}},"title":"Ship and boat captains and operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"32","median":"-","maleWorkers":"32","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Ship engineers":{"ageData":{"2013":{"total":"4","16to19":"0","20to24":"0","25to34":"0","35to44":"3","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Ship engineers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Bridge and lock tenders":{"ageData":{"2013":{"total":"5","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"2","55to64":"3","65+":"0","medianAge":"3"}},"title":"Bridge and lock tenders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Parking lot attendants":{"ageData":{"2013":{"total":"88","16to19":"5","20to24":"35","25to34":"18","35to44":"6","45to54":"11","55to64":"7","65+":"6","medianAge":"7"}},"title":"Parking lot attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"88","women":"12.9","white":"22.0","black":"4.3","asian":"37.9"}},"wageData":{"2013":{"workers":"50","median":"423","maleWorkers":"43","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Automotive and watercraft service attendants":{"ageData":{"2013":{"total":"92","16to19":"13","20to24":"29","25to34":"19","35to44":"12","45to54":"9","55to64":"7","65+":"3","medianAge":"7"}},"title":"Automotive and watercraft service attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"92","women":"11.9","white":"11.4","black":"7.7","asian":"19.7"}},"wageData":{"2013":{"workers":"78","median":"398","maleWorkers":"67","maleMedian":"403","femaleWorkers":"12","femaleMedian":"-"}}},"Transportation inspectors":{"ageData":{"2013":{"total":"45","16to19":"0","20to24":"4","25to34":"9","35to44":"3","45to54":"13","55to64":"12","65+":"3","medianAge":"12"}},"title":"Transportation inspectors","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"45","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"41","median":"-","maleWorkers":"35","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Transportation attendants, except flight attendants":{"ageData":{"2013":{"total":"37","16to19":"1","20to24":"2","25to34":"6","35to44":"7","45to54":"9","55to64":"8","65+":"4","medianAge":"8"}},"title":"Transportation attendants, except flight attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"37","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"30","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Other transportation workers":{"ageData":{"2013":{"total":"21","16to19":"1","20to24":"5","25to34":"1","35to44":"3","45to54":"7","55to64":"4","65+":"0","medianAge":"4"}},"title":"Other transportation workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"21","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"17","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Conveyor operators and tenders":{"ageData":{"2013":{"total":"5","16to19":"0","20to24":"1","25to34":"1","35to44":"1","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Conveyor operators and tenders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"4","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Crane and tower operators":{"ageData":{"2013":{"total":"72","16to19":"0","20to24":"8","25to34":"10","35to44":"20","45to54":"14","55to64":"18","65+":"2","medianAge":"18"}},"title":"Crane and tower operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"72","women":"0.7","white":"12.3","black":"1.9","asian":"16.0"}},"wageData":{"2013":{"workers":"70","median":"846","maleWorkers":"69","maleMedian":"871","femaleWorkers":"1","femaleMedian":"-"}}},"Dredge, excavating, and loading machine operators":{"ageData":{"2013":{"total":"40","16to19":"1","20to24":"1","25to34":"9","35to44":"6","45to54":"9","55to64":"8","65+":"5","medianAge":"8"}},"title":"Dredge, excavating, and loading machine operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"28","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Hoist and winch operators":{"ageData":{"2013":{"total":"7","16to19":"0","20to24":"0","25to34":"3","35to44":"1","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Hoist and winch operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Industrial truck and tractor operators":{"ageData":{"2013":{"total":"557","16to19":"7","20to24":"54","25to34":"163","35to44":"118","45to54":"128","55to64":"77","65+":"10","medianAge":"77"}},"title":"Industrial truck and tractor operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"557","women":"6.2","white":"20.7","black":"1.9","asian":"30.9"}},"wageData":{"2013":{"workers":"542","median":"559","maleWorkers":"510","maleMedian":"559","femaleWorkers":"32","femaleMedian":"-"}}},"Cleaners of vehicles and equipment":{"ageData":{"2013":{"total":"348","16to19":"43","20to24":"78","25to34":"87","35to44":"56","45to54":"49","55to64":"28","65+":"8","medianAge":"28"}},"title":"Cleaners of vehicles and equipment","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"348","women":"15.4","white":"21.2","black":"2.8","asian":"33.1"}},"wageData":{"2013":{"workers":"235","median":"429","maleWorkers":"206","maleMedian":"434","femaleWorkers":"28","femaleMedian":"-"}}},"Laborers and freight, stock, and material movers, hand":{"ageData":{"2013":{"total":"1,752","16to19":"123","20to24":"315","25to34":"420","35to44":"335","45to54":"303","55to64":"208","65+":"49","medianAge":"208"}},"title":"Laborers and freight, stock, and material movers, hand","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"1,752","women":"17.9","white":"18.0","black":"3.1","asian":"23.1"}},"wageData":{"2013":{"workers":"1,277","median":"511","maleWorkers":"1,056","maleMedian":"524","femaleWorkers":"221","femaleMedian":"421"}}},"Machine feeders and offbearers":{"ageData":{"2013":{"total":"21","16to19":"1","20to24":"1","25to34":"5","35to44":"5","45to54":"5","55to64":"4","65+":"0","medianAge":"4"}},"title":"Machine feeders and offbearers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"21","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"20","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Packers and packagers, hand":{"ageData":{"2013":{"total":"493","16to19":"48","20to24":"81","25to34":"96","35to44":"82","45to54":"98","55to64":"68","65+":"20","medianAge":"68"}},"title":"Packers and packagers, hand","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"493","women":"49.4","white":"18.0","black":"4.6","asian":"37.7"}},"wageData":{"2013":{"workers":"331","median":"422","maleWorkers":"149","maleMedian":"434","femaleWorkers":"182","femaleMedian":"416"}}},"Pumping station operators":{"ageData":{"2013":{"total":"30","16to19":"0","20to24":"3","25to34":"10","35to44":"4","45to54":"6","55to64":"6","65+":"2","medianAge":"6"}},"title":"Pumping station operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"30","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"24","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Refuse and recyclable material collectors":{"ageData":{"2013":{"total":"108","16to19":"2","20to24":"10","25to34":"32","35to44":"20","45to54":"24","55to64":"15","65+":"6","medianAge":"15"}},"title":"Refuse and recyclable material collectors","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"108","women":"4.8","white":"15.3","black":"1.8","asian":"24.7"}},"wageData":{"2013":{"workers":"75","median":"550","maleWorkers":"74","maleMedian":"555","femaleWorkers":"1","femaleMedian":"-"}}},"Mine shuttle car operators":{"ageData":{"2013":{"total":"4","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Mine shuttle car operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Tank car, truck, and ship loaders":{"ageData":{"2013":{"total":"7","16to19":"0","20to24":"0","25to34":"4","35to44":"1","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Tank car, truck, and ship loaders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2013":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Material moving workers, all other":{"ageData":{"2013":{"total":"51","16to19":"3","20to24":"4","25to34":"8","35to44":"9","45to54":"12","55to64":"12","65+":"2","medianAge":"12"}},"title":"Material moving workers, all other","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2013":{"total":"51","women":"13.1","white":"20.8","black":"0.8","asian":"22.3"}},"wageData":{"2013":{"workers":"45","median":"-","maleWorkers":"41","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}}}');


var $b278c546eac81c0f$exports = {};
$b278c546eac81c0f$exports = JSON.parse('{"Total":{"ageData":{"2012":{"total":"142,469","16to19":"4,426","20to24":"13,408","25to34":"30,701","35to44":"30,576","45to54":"32,874","55to64":"23,239","65+":"7,245","medianAge":"23,239"}},"title":"Total","depth":1,"parent":"","sexRaceEthnicityData":{"2012":{"total":"142,469","women":"47.0","white":"11.1","black":"5.4","asian":"15.4"}},"wageData":{"2012":{"workers":"102,749","median":"$768","maleWorkers":"57,286","maleMedian":"$854","femaleWorkers":"45,462","femaleMedian":"$691"}}},"Management, professional, and related occupations":{"ageData":{"2012":{"total":"54,043","16to19":"339","20to24":"2,690","25to34":"11,894","35to44":"12,810","45to54":"13,329","55to64":"9,908","65+":"3,074","medianAge":"9,908"}},"title":"Management, professional, and related occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2012":{"total":"54,043","women":"51.5","white":"8.7","black":"6.9","asian":"8.4"}},"wageData":{"2012":{"workers":"40,984","median":"1,108","maleWorkers":"19,926","maleMedian":"1,328","femaleWorkers":"21,059","femaleMedian":"951"}}},"Management, business, and financial operations occupations":{"ageData":{"2012":{"total":"22,678","16to19":"67","20to24":"817","25to34":"4,236","35to44":"5,436","45to54":"6,171","55to64":"4,457","65+":"1,494","medianAge":"4,457"}},"title":"Management, business, and financial operations occupations","depth":2,"parent":"Management, professional, and related occupations","sexRaceEthnicityData":{"2012":{"total":"22,678","women":"43.6","white":"7.8","black":"5.8","asian":"8.6"}},"wageData":{"2012":{"workers":"16,991","median":"1,171","maleWorkers":"9,121","maleMedian":"1,387","femaleWorkers":"7,869","femaleMedian":"993"}}},"Management occupations":{"ageData":{"2012":{"total":"16,042","16to19":"52","20to24":"500","25to34":"2,691","35to44":"3,829","45to54":"4,571","55to64":"3,260","65+":"1,140","medianAge":"3,260"}},"title":"Management occupations","depth":3,"parent":"Management, business, and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"16,042","women":"38.6","white":"6.9","black":"5.1","asian":"8.8"}},"wageData":{"2012":{"workers":"11,547","median":"1,248","maleWorkers":"6,783","maleMedian":"1,428","femaleWorkers":"4,765","femaleMedian":"1,036"}}},"Chief executives":{"ageData":{"2012":{"total":"1,513","16to19":"1","20to24":"5","25to34":"107","35to44":"318","45to54":"532","55to64":"413","65+":"136","medianAge":"413"}},"title":"Chief executives","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"1,513","women":"27.4","white":"3.7","black":"4.2","asian":"4.7"}},"wageData":{"2012":{"workers":"1,004","median":"2,060","maleWorkers":"739","maleMedian":"2,275","femaleWorkers":"265","femaleMedian":"1,730"}}},"General and operations managers":{"ageData":{"2012":{"total":"1,064","16to19":"0","20to24":"30","25to34":"193","35to44":"283","45to54":"326","55to64":"195","65+":"37","medianAge":"195"}},"title":"General and operations managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"1,064","women":"29.1","white":"6.2","black":"4.7","asian":"9.3"}},"wageData":{"2012":{"workers":"983","median":"1,264","maleWorkers":"705","maleMedian":"1,436","femaleWorkers":"278","femaleMedian":"971"}}},"Legislators":{"ageData":{"2012":{"total":"11","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"3","55to64":"3","65+":"3","medianAge":"3"}},"title":"Legislators","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"7","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Advertising and promotions managers":{"ageData":{"2012":{"total":"77","16to19":"0","20to24":"8","25to34":"19","35to44":"23","45to54":"15","55to64":"9","65+":"3","medianAge":"9"}},"title":"Advertising and promotions managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"77","women":"49.4","white":"6.7","black":"4.3","asian":"10.0"}},"wageData":{"2012":{"workers":"65","median":"1,334","maleWorkers":"36","maleMedian":"-","femaleWorkers":"29","femaleMedian":"-"}}},"Marketing and sales managers":{"ageData":{"2012":{"total":"967","16to19":"2","20to24":"43","25to34":"238","35to44":"284","45to54":"244","55to64":"136","65+":"21","medianAge":"136"}},"title":"Marketing and sales managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"967","women":"45.2","white":"4.2","black":"6.0","asian":"6.1"}},"wageData":{"2012":{"workers":"916","median":"1,396","maleWorkers":"514","maleMedian":"1,640","femaleWorkers":"402","femaleMedian":"1,110"}}},"Public relations and fundraising managers":{"ageData":{"2012":{"total":"58","16to19":"0","20to24":"1","25to34":"19","35to44":"12","45to54":"13","55to64":"11","65+":"2","medianAge":"11"}},"title":"Public relations and fundraising managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"58","women":"69.3","white":"5.8","black":"3.4","asian":"8.0"}},"wageData":{"2012":{"workers":"56","median":"1,237","maleWorkers":"17","maleMedian":"-","femaleWorkers":"39","femaleMedian":"-"}}},"Administrative services managers":{"ageData":{"2012":{"total":"144","16to19":"0","20to24":"5","25to34":"17","35to44":"25","45to54":"55","55to64":"35","65+":"7","medianAge":"35"}},"title":"Administrative services managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"144","women":"44.1","white":"6.4","black":"4.4","asian":"9.5"}},"wageData":{"2012":{"workers":"133","median":"1,103","maleWorkers":"76","maleMedian":"1,212","femaleWorkers":"57","femaleMedian":"1,038"}}},"Computer and information systems managers":{"ageData":{"2012":{"total":"605","16to19":"1","20to24":"6","25to34":"106","35to44":"222","45to54":"172","55to64":"89","65+":"11","medianAge":"89"}},"title":"Computer and information systems managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"605","women":"26.8","white":"5.6","black":"14.5","asian":"5.8"}},"wageData":{"2012":{"workers":"568","median":"1,672","maleWorkers":"423","maleMedian":"1,740","femaleWorkers":"145","femaleMedian":"1,527"}}},"Financial managers":{"ageData":{"2012":{"total":"1,228","16to19":"1","20to24":"37","25to34":"287","35to44":"296","45to54":"331","55to64":"220","65+":"55","medianAge":"220"}},"title":"Financial managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"1,228","women":"53.5","white":"8.6","black":"5.7","asian":"10.3"}},"wageData":{"2012":{"workers":"1,125","median":"1,169","maleWorkers":"509","maleMedian":"1,405","femaleWorkers":"616","femaleMedian":"988"}}},"Compensation and benefits managers":{"ageData":{"2012":{"total":"15","16to19":"0","20to24":"0","25to34":"4","35to44":"4","45to54":"4","55to64":"4","65+":"0","medianAge":"4"}},"title":"Compensation and benefits managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"15","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"16","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Human resources managers":{"ageData":{"2012":{"total":"224","16to19":"1","20to24":"4","25to34":"40","35to44":"58","45to54":"72","55to64":"43","65+":"6","medianAge":"43"}},"title":"Human resources managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"224","women":"72.7","white":"11.3","black":"2.4","asian":"9.5"}},"wageData":{"2012":{"workers":"216","median":"1,271","maleWorkers":"56","maleMedian":"1,447","femaleWorkers":"160","femaleMedian":"1,208"}}},"Training and development managers":{"ageData":{"2012":{"total":"36","16to19":"1","20to24":"2","25to34":"6","35to44":"5","45to54":"14","55to64":"8","65+":"1","medianAge":"8"}},"title":"Training and development managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"36","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"33","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Industrial production managers":{"ageData":{"2012":{"total":"261","16to19":"1","20to24":"5","25to34":"39","35to44":"59","45to54":"94","55to64":"50","65+":"12","medianAge":"50"}},"title":"Industrial production managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"261","women":"17.6","white":"3.4","black":"5.1","asian":"11.4"}},"wageData":{"2012":{"workers":"219","median":"1,183","maleWorkers":"185","maleMedian":"1,181","femaleWorkers":"34","femaleMedian":"-"}}},"Purchasing managers":{"ageData":{"2012":{"total":"218","16to19":"0","20to24":"7","25to34":"33","35to44":"48","45to54":"81","55to64":"44","65+":"6","medianAge":"44"}},"title":"Purchasing managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"218","women":"50.9","white":"8.4","black":"4.6","asian":"10.4"}},"wageData":{"2012":{"workers":"204","median":"1,319","maleWorkers":"104","maleMedian":"1,467","femaleWorkers":"99","femaleMedian":"1,072"}}},"Transportation, storage, and distribution managers":{"ageData":{"2012":{"total":"287","16to19":"1","20to24":"10","25to34":"57","35to44":"76","45to54":"78","55to64":"52","65+":"13","medianAge":"52"}},"title":"Transportation, storage, and distribution managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"287","women":"15.6","white":"11.1","black":"3.3","asian":"11.3"}},"wageData":{"2012":{"workers":"276","median":"953","maleWorkers":"240","maleMedian":"938","femaleWorkers":"36","femaleMedian":"-"}}},"Farmers, ranchers, and other agricultural managers":{"ageData":{"2012":{"total":"944","16to19":"12","20to24":"31","25to34":"88","35to44":"111","45to54":"201","55to64":"249","65+":"252","medianAge":"249"}},"title":"Farmers, ranchers, and other agricultural managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"944","women":"24.5","white":"0.8","black":"1.2","asian":"4.0"}},"wageData":{"2012":{"workers":"104","median":"708","maleWorkers":"89","maleMedian":"699","femaleWorkers":"14","femaleMedian":"-"}}},"Construction managers":{"ageData":{"2012":{"total":"983","16to19":"1","20to24":"24","25to34":"150","35to44":"239","45to54":"318","55to64":"200","65+":"52","medianAge":"200"}},"title":"Construction managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"983","women":"6.4","white":"3.7","black":"2.2","asian":"9.4"}},"wageData":{"2012":{"workers":"460","median":"1,208","maleWorkers":"425","maleMedian":"1,233","femaleWorkers":"35","femaleMedian":"-"}}},"Education administrators":{"ageData":{"2012":{"total":"811","16to19":"1","20to24":"18","25to34":"117","35to44":"221","45to54":"218","55to64":"191","65+":"45","medianAge":"191"}},"title":"Education administrators","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"811","women":"64.4","white":"13.8","black":"2.2","asian":"7.9"}},"wageData":{"2012":{"workers":"704","median":"1,255","maleWorkers":"250","maleMedian":"1,566","femaleWorkers":"454","femaleMedian":"1,052"}}},"Architectural and engineering managers":{"ageData":{"2012":{"total":"120","16to19":"0","20to24":"0","25to34":"16","35to44":"31","45to54":"40","55to64":"28","65+":"5","medianAge":"28"}},"title":"Architectural and engineering managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"120","women":"10.9","white":"2.8","black":"7.7","asian":"2.9"}},"wageData":{"2012":{"workers":"111","median":"2,122","maleWorkers":"101","maleMedian":"2,116","femaleWorkers":"9","femaleMedian":"-"}}},"Food service managers":{"ageData":{"2012":{"total":"1,085","16to19":"22","20to24":"140","25to34":"273","35to44":"234","45to54":"245","55to64":"135","65+":"36","medianAge":"135"}},"title":"Food service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"1,085","women":"47.2","white":"8.8","black":"9.5","asian":"16.5"}},"wageData":{"2012":{"workers":"678","median":"689","maleWorkers":"351","maleMedian":"744","femaleWorkers":"327","femaleMedian":"601"}}},"Funeral service managers":{"ageData":{"2012":{"total":"13","16to19":"0","20to24":"0","25to34":"0","35to44":"2","45to54":"4","55to64":"3","65+":"5","medianAge":"3"}},"title":"Funeral service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"8","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Gaming managers":{"ageData":{"2012":{"total":"26","16to19":"0","20to24":"4","25to34":"6","35to44":"6","45to54":"7","55to64":"1","65+":"1","medianAge":"1"}},"title":"Gaming managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"26","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"21","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Lodging managers":{"ageData":{"2012":{"total":"154","16to19":"0","20to24":"6","25to34":"32","35to44":"26","45to54":"37","55to64":"34","65+":"19","medianAge":"34"}},"title":"Lodging managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"154","women":"45.0","white":"8.0","black":"13.9","asian":"11.5"}},"wageData":{"2012":{"workers":"100","median":"774","maleWorkers":"53","maleMedian":"1,131","femaleWorkers":"47","femaleMedian":"-"}}},"Medical and health services managers":{"ageData":{"2012":{"total":"585","16to19":"0","20to24":"8","25to34":"89","35to44":"125","45to54":"176","55to64":"148","65+":"40","medianAge":"148"}},"title":"Medical and health services managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"585","women":"69.7","white":"10.9","black":"5.1","asian":"8.1"}},"wageData":{"2012":{"workers":"502","median":"1,280","maleWorkers":"144","maleMedian":"1,544","femaleWorkers":"358","femaleMedian":"1,190"}}},"Natural sciences managers":{"ageData":{"2012":{"total":"18","16to19":"0","20to24":"0","25to34":"3","35to44":"6","45to54":"5","55to64":"4","65+":"0","medianAge":"4"}},"title":"Natural sciences managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"18","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"18","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Postmasters and mail superintendents":{"ageData":{"2012":{"total":"39","16to19":"0","20to24":"1","25to34":"2","35to44":"8","45to54":"13","55to64":"13","65+":"3","medianAge":"13"}},"title":"Postmasters and mail superintendents","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"39","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"35","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"21","femaleMedian":"-"}}},"Property, real estate, and community association managers":{"ageData":{"2012":{"total":"644","16to19":"1","20to24":"10","25to34":"109","35to44":"125","45to54":"172","55to64":"139","65+":"87","medianAge":"139"}},"title":"Property, real estate, and community association managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"644","women":"50.7","white":"8.5","black":"3.4","asian":"11.4"}},"wageData":{"2012":{"workers":"353","median":"907","maleWorkers":"153","maleMedian":"1,045","femaleWorkers":"200","femaleMedian":"817"}}},"Social and community service managers":{"ageData":{"2012":{"total":"315","16to19":"0","20to24":"15","25to34":"56","35to44":"84","45to54":"72","55to64":"59","65+":"28","medianAge":"59"}},"title":"Social and community service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"315","women":"70.5","white":"14.6","black":"3.7","asian":"8.5"}},"wageData":{"2012":{"workers":"260","median":"947","maleWorkers":"76","maleMedian":"1,151","femaleWorkers":"184","femaleMedian":"883"}}},"Emergency management directors":{"ageData":{"2012":{"total":"6","16to19":"0","20to24":"1","25to34":"0","35to44":"1","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Emergency management directors","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"5","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Managers, all other":{"ageData":{"2012":{"total":"3,594","16to19":"7","20to24":"79","25to34":"583","35to44":"897","45to54":"1,028","55to64":"748","65+":"253","medianAge":"748"}},"title":"Managers, all other","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2012":{"total":"3,594","women":"35.0","white":"7.3","black":"5.0","asian":"9.3"}},"wageData":{"2012":{"workers":"2,367","median":"1,258","maleWorkers":"1,465","maleMedian":"1,409","femaleWorkers":"902","femaleMedian":"1,078"}}},"Business and financial operations occupations":{"ageData":{"2012":{"total":"6,636","16to19":"15","20to24":"317","25to34":"1,546","35to44":"1,607","45to54":"1,600","55to64":"1,197","65+":"355","medianAge":"1,197"}},"title":"Business and financial operations occupations","depth":3,"parent":"Management, business, and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"6,636","women":"55.8","white":"9.8","black":"7.4","asian":"8.0"}},"wageData":{"2012":{"workers":"5,443","median":"1,058","maleWorkers":"2,339","maleMedian":"1,274","femaleWorkers":"3,105","femaleMedian":"952"}}},"Agents and business managers of artists, performers, and athletes":{"ageData":{"2012":{"total":"47","16to19":"1","20to24":"3","25to34":"10","35to44":"13","45to54":"7","55to64":"7","65+":"4","medianAge":"7"}},"title":"Agents and business managers of artists, performers, and athletes","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"47","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"31","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Buyers and purchasing agents, farm products":{"ageData":{"2012":{"total":"13","16to19":"0","20to24":"0","25to34":"2","35to44":"3","45to54":"3","55to64":"3","65+":"2","medianAge":"3"}},"title":"Buyers and purchasing agents, farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"8","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Wholesale and retail buyers, except farm products":{"ageData":{"2012":{"total":"198","16to19":"3","20to24":"14","25to34":"47","35to44":"38","45to54":"39","55to64":"47","65+":"11","medianAge":"47"}},"title":"Wholesale and retail buyers, except farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"198","women":"55.2","white":"7.1","black":"7.7","asian":"10.9"}},"wageData":{"2012":{"workers":"141","median":"850","maleWorkers":"66","maleMedian":"853","femaleWorkers":"75","femaleMedian":"847"}}},"Purchasing agents, except wholesale, retail, and farm products":{"ageData":{"2012":{"total":"261","16to19":"1","20to24":"11","25to34":"40","35to44":"65","45to54":"71","55to64":"65","65+":"9","medianAge":"65"}},"title":"Purchasing agents, except wholesale, retail, and farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"261","women":"55.1","white":"6.1","black":"4.4","asian":"9.8"}},"wageData":{"2012":{"workers":"239","median":"987","maleWorkers":"109","maleMedian":"1,057","femaleWorkers":"130","femaleMedian":"942"}}},"Claims adjusters, appraisers, examiners, and investigators":{"ageData":{"2012":{"total":"323","16to19":"0","20to24":"12","25to34":"75","35to44":"86","45to54":"73","55to64":"61","65+":"16","medianAge":"61"}},"title":"Claims adjusters, appraisers, examiners, and investigators","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"323","women":"63.4","white":"17.5","black":"3.1","asian":"10.3"}},"wageData":{"2012":{"workers":"307","median":"909","maleWorkers":"104","maleMedian":"1,158","femaleWorkers":"203","femaleMedian":"803"}}},"Compliance officers":{"ageData":{"2012":{"total":"199","16to19":"0","20to24":"1","25to34":"36","35to44":"47","45to54":"57","55to64":"51","65+":"6","medianAge":"51"}},"title":"Compliance officers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"199","women":"50.6","white":"9.1","black":"3.3","asian":"8.2"}},"wageData":{"2012":{"workers":"192","median":"1,183","maleWorkers":"101","maleMedian":"1,304","femaleWorkers":"91","femaleMedian":"999"}}},"Cost estimators":{"ageData":{"2012":{"total":"114","16to19":"0","20to24":"7","25to34":"20","35to44":"30","45to54":"23","55to64":"24","65+":"9","medianAge":"24"}},"title":"Cost estimators","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"114","women":"11.7","white":"1.5","black":"2.0","asian":"6.8"}},"wageData":{"2012":{"workers":"91","median":"1,154","maleWorkers":"81","maleMedian":"1,164","femaleWorkers":"10","femaleMedian":"-"}}},"Human resources workers":{"ageData":{"2012":{"total":"603","16to19":"1","20to24":"31","25to34":"148","35to44":"168","45to54":"141","55to64":"97","65+":"16","medianAge":"97"}},"title":"Human resources workers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"603","women":"71.8","white":"15.4","black":"4.4","asian":"11.8"}},"wageData":{"2012":{"workers":"559","median":"994","maleWorkers":"158","maleMedian":"1,249","femaleWorkers":"401","femaleMedian":"944"}}},"Compensation, benefits, and job analysis specialists":{"ageData":{"2012":{"total":"71","16to19":"0","20to24":"2","25to34":"13","35to44":"19","45to54":"16","55to64":"20","65+":"1","medianAge":"20"}},"title":"Compensation, benefits, and job analysis specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"71","women":"81.1","white":"6.9","black":"4.2","asian":"11.8"}},"wageData":{"2012":{"workers":"72","median":"961","maleWorkers":"13","maleMedian":"-","femaleWorkers":"59","femaleMedian":"866"}}},"Training and development specialists":{"ageData":{"2012":{"total":"126","16to19":"0","20to24":"4","25to34":"28","35to44":"34","45to54":"30","55to64":"25","65+":"4","medianAge":"25"}},"title":"Training and development specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"126","women":"56.4","white":"15.9","black":"0.8","asian":"10.8"}},"wageData":{"2012":{"workers":"120","median":"983","maleWorkers":"51","maleMedian":"1,144","femaleWorkers":"69","femaleMedian":"866"}}},"Logisticians":{"ageData":{"2012":{"total":"94","16to19":"0","20to24":"4","25to34":"26","35to44":"20","45to54":"28","55to64":"12","65+":"4","medianAge":"12"}},"title":"Logisticians","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"94","women":"36.8","white":"12.3","black":"2.2","asian":"11.9"}},"wageData":{"2012":{"workers":"88","median":"1,009","maleWorkers":"57","maleMedian":"1,225","femaleWorkers":"30","femaleMedian":"-"}}},"Management analysts":{"ageData":{"2012":{"total":"773","16to19":"1","20to24":"25","25to34":"151","35to44":"178","45to54":"181","55to64":"160","65+":"77","medianAge":"160"}},"title":"Management analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"773","women":"39.8","white":"6.8","black":"8.8","asian":"4.4"}},"wageData":{"2012":{"workers":"479","median":"1,452","maleWorkers":"277","maleMedian":"1,535","femaleWorkers":"202","femaleMedian":"1,325"}}},"Meeting, convention, and event planners":{"ageData":{"2012":{"total":"127","16to19":"2","20to24":"15","25to34":"41","35to44":"28","45to54":"24","55to64":"11","65+":"7","medianAge":"11"}},"title":"Meeting, convention, and event planners","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"127","women":"73.3","white":"8.1","black":"4.2","asian":"10.3"}},"wageData":{"2012":{"workers":"86","median":"819","maleWorkers":"15","maleMedian":"-","femaleWorkers":"72","femaleMedian":"824"}}},"Fundraisers":{"ageData":{"2012":{"total":"86","16to19":"2","20to24":"8","25to34":"24","35to44":"19","45to54":"18","55to64":"12","65+":"3","medianAge":"12"}},"title":"Fundraisers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"86","women":"75.3","white":"5.1","black":"4.6","asian":"3.4"}},"wageData":{"2012":{"workers":"61","median":"1,058","maleWorkers":"16","maleMedian":"-","femaleWorkers":"45","femaleMedian":"-"}}},"Market research analysts and marketing specialists":{"ageData":{"2012":{"total":"219","16to19":"0","20to24":"14","25to34":"68","35to44":"57","45to54":"48","55to64":"27","65+":"6","medianAge":"27"}},"title":"Market research analysts and marketing specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"219","women":"54.2","white":"5.4","black":"9.1","asian":"4.7"}},"wageData":{"2012":{"workers":"175","median":"1,148","maleWorkers":"85","maleMedian":"1,197","femaleWorkers":"90","femaleMedian":"1,073"}}},"Business operations specialists, all other":{"ageData":{"2012":{"total":"251","16to19":"2","20to24":"9","25to34":"59","35to44":"59","45to54":"71","55to64":"41","65+":"10","medianAge":"41"}},"title":"Business operations specialists, all other","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"251","women":"67.3","white":"14.2","black":"5.6","asian":"9.2"}},"wageData":{"2012":{"workers":"220","median":"970","maleWorkers":"73","maleMedian":"1,271","femaleWorkers":"147","femaleMedian":"904"}}},"Accountants and auditors":{"ageData":{"2012":{"total":"1,765","16to19":"1","20to24":"95","25to34":"443","35to44":"436","45to54":"424","55to64":"274","65+":"91","medianAge":"274"}},"title":"Accountants and auditors","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"1,765","women":"60.9","white":"9.7","black":"12.0","asian":"6.8"}},"wageData":{"2012":{"workers":"1,471","median":"1,110","maleWorkers":"585","maleMedian":"1,350","femaleWorkers":"886","femaleMedian":"996"}}},"Appraisers and assessors of real estate":{"ageData":{"2012":{"total":"93","16to19":"0","20to24":"1","25to34":"16","35to44":"16","45to54":"27","55to64":"25","65+":"7","medianAge":"25"}},"title":"Appraisers and assessors of real estate","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"93","women":"40.6","white":"9.8","black":"2.7","asian":"1.0"}},"wageData":{"2012":{"workers":"48","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"25","femaleMedian":"-"}}},"Budget analysts":{"ageData":{"2012":{"total":"55","16to19":"0","20to24":"0","25to34":"11","35to44":"14","45to54":"17","55to64":"10","65+":"3","medianAge":"10"}},"title":"Budget analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"55","women":"52.5","white":"11.5","black":"8.7","asian":"8.2"}},"wageData":{"2012":{"workers":"52","median":"1,207","maleWorkers":"24","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Credit analysts":{"ageData":{"2012":{"total":"30","16to19":"0","20to24":"4","25to34":"13","35to44":"6","45to54":"5","55to64":"2","65+":"0","medianAge":"2"}},"title":"Credit analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"30","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"33","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"18","femaleMedian":"-"}}},"Financial analysts":{"ageData":{"2012":{"total":"89","16to19":"0","20to24":"7","25to34":"25","35to44":"27","45to54":"21","55to64":"7","65+":"2","medianAge":"7"}},"title":"Financial analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"89","women":"36.8","white":"3.7","black":"9.0","asian":"6.3"}},"wageData":{"2012":{"workers":"77","median":"1,487","maleWorkers":"48","maleMedian":"-","femaleWorkers":"30","femaleMedian":"-"}}},"Personal financial advisors":{"ageData":{"2012":{"total":"378","16to19":"0","20to24":"19","25to34":"79","35to44":"87","45to54":"83","55to64":"78","65+":"31","medianAge":"78"}},"title":"Personal financial advisors","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"378","women":"31.2","white":"4.8","black":"6.2","asian":"4.5"}},"wageData":{"2012":{"workers":"278","median":"1,327","maleWorkers":"182","maleMedian":"1,532","femaleWorkers":"96","femaleMedian":"1,016"}}},"Insurance underwriters":{"ageData":{"2012":{"total":"103","16to19":"0","20to24":"2","25to34":"23","35to44":"24","45to54":"30","55to64":"21","65+":"3","medianAge":"21"}},"title":"Insurance underwriters","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"103","women":"70.4","white":"10.7","black":"0.7","asian":"10.2"}},"wageData":{"2012":{"workers":"91","median":"954","maleWorkers":"24","maleMedian":"-","femaleWorkers":"66","femaleMedian":"933"}}},"Financial examiners":{"ageData":{"2012":{"total":"14","16to19":"0","20to24":"2","25to34":"6","35to44":"1","45to54":"2","55to64":"2","65+":"1","medianAge":"2"}},"title":"Financial examiners","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"11","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Credit counselors and loan officers":{"ageData":{"2012":{"total":"333","16to19":"1","20to24":"13","25to34":"98","35to44":"75","45to54":"83","55to64":"57","65+":"6","medianAge":"57"}},"title":"Credit counselors and loan officers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"333","women":"59.2","white":"13.2","black":"6.0","asian":"9.3"}},"wageData":{"2012":{"workers":"310","median":"934","maleWorkers":"130","maleMedian":"1,074","femaleWorkers":"181","femaleMedian":"850"}}},"Tax examiners and collectors, and revenue agents":{"ageData":{"2012":{"total":"82","16to19":"0","20to24":"1","25to34":"14","35to44":"14","45to54":"32","55to64":"17","65+":"4","medianAge":"17"}},"title":"Tax examiners and collectors, and revenue agents","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"82","women":"62.4","white":"13.9","black":"11.5","asian":"13.9"}},"wageData":{"2012":{"workers":"87","median":"937","maleWorkers":"33","maleMedian":"-","femaleWorkers":"54","femaleMedian":"849"}}},"Tax preparers":{"ageData":{"2012":{"total":"107","16to19":"0","20to24":"6","25to34":"12","35to44":"25","45to54":"23","55to64":"23","65+":"17","medianAge":"23"}},"title":"Tax preparers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"107","women":"59.6","white":"10.4","black":"7.1","asian":"15.9"}},"wageData":{"2012":{"workers":"48","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"25","femaleMedian":"-"}}},"Financial specialists, all other":{"ageData":{"2012":{"total":"82","16to19":"0","20to24":"6","25to34":"18","35to44":"19","45to54":"23","55to64":"14","65+":"3","medianAge":"14"}},"title":"Financial specialists, all other","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2012":{"total":"82","women":"66.5","white":"10.9","black":"8.4","asian":"11.5"}},"wageData":{"2012":{"workers":"68","median":"1,025","maleWorkers":"20","maleMedian":"-","femaleWorkers":"48","femaleMedian":"-"}}},"Professional and related occupations":{"ageData":{"2012":{"total":"31,365","16to19":"272","20to24":"1,874","25to34":"7,657","35to44":"7,373","45to54":"7,158","55to64":"5,451","65+":"1,580","medianAge":"5,451"}},"title":"Professional and related occupations","depth":2,"parent":"Management, professional, and related occupations","sexRaceEthnicityData":{"2012":{"total":"31,365","women":"57.2","white":"9.3","black":"7.8","asian":"8.2"}},"wageData":{"2012":{"workers":"23,993","median":"1,053","maleWorkers":"10,804","maleMedian":"1,267","femaleWorkers":"13,189","femaleMedian":"928"}}},"Computer and mathematical occupations":{"ageData":{"2012":{"total":"3,816","16to19":"11","20to24":"213","25to34":"1,062","35to44":"1,103","45to54":"873","55to64":"461","65+":"94","medianAge":"461"}},"title":"Computer and mathematical occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2012":{"total":"3,816","women":"25.6","white":"7.4","black":"17.5","asian":"6.1"}},"wageData":{"2012":{"workers":"3,416","median":"1,349","maleWorkers":"2,544","maleMedian":"1,414","femaleWorkers":"872","femaleMedian":"1,146"}}},"Computer and information research scientists":{"ageData":{"2012":{"total":"29","16to19":"0","20to24":"3","25to34":"10","35to44":"4","45to54":"10","55to64":"2","65+":"0","medianAge":"2"}},"title":"Computer and information research scientists","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2012":{"total":"29","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"27","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Computer systems analysts":{"ageData":{"2012":{"total":"499","16to19":"1","20to24":"17","25to34":"126","35to44":"123","45to54":"134","55to64":"80","65+":"19","medianAge":"80"}},"title":"Computer systems analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2012":{"total":"499","women":"30.9","white":"8.8","black":"15.8","asian":"4.5"}},"wageData":{"2012":{"workers":"440","median":"1,406","maleWorkers":"295","maleMedian":"1,477","femaleWorkers":"145","femaleMedian":"1,254"}}},"Information security analysts":{"ageData":{"2012":{"total":"52","16to19":"0","20to24":"2","25to34":"14","35to44":"17","45to54":"11","55to64":"6","65+":"1","medianAge":"6"}},"title":"Information security analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2012":{"total":"52","women":"15.1","white":"11.8","black":"14.2","asian":"4.0"}},"wageData":{"2012":{"workers":"51","median":"1,592","maleWorkers":"43","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Computer programmers":{"ageData":{"2012":{"total":"480","16to19":"2","20to24":"33","25to34":"113","35to44":"132","45to54":"124","55to64":"66","65+":"11","medianAge":"66"}},"title":"Computer programmers","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2012":{"total":"480","women":"22.5","white":"5.9","black":"17.3","asian":"5.3"}},"wageData":{"2012":{"workers":"439","median":"1,324","maleWorkers":"340","maleMedian":"1,363","femaleWorkers":"100","femaleMedian":"1,148"}}},"Software developers, applications and systems software":{"ageData":{"2012":{"total":"1,084","16to19":"1","20to24":"53","25to34":"338","35to44":"348","45to54":"226","55to64":"102","65+":"16","medianAge":"102"}},"title":"Software developers, applications and systems software","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2012":{"total":"1,084","women":"19.7","white":"4.0","black":"29.4","asian":"5.2"}},"wageData":{"2012":{"workers":"1,005","median":"1,591","maleWorkers":"808","maleMedian":"1,674","femaleWorkers":"197","femaleMedian":"1,362"}}},"Web developers":{"ageData":{"2012":{"total":"190","16to19":"1","20to24":"21","25to34":"72","35to44":"48","45to54":"28","55to64":"16","65+":"4","medianAge":"16"}},"title":"Web developers","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2012":{"total":"190","women":"33.7","white":"4.1","black":"8.0","asian":"5.6"}},"wageData":{"2012":{"workers":"123","median":"1,082","maleWorkers":"86","maleMedian":"1,204","femaleWorkers":"36","femaleMedian":"-"}}},"Computer support specialists":{"ageData":{"2012":{"total":"476","16to19":"3","20to24":"45","25to34":"130","35to44":"127","45to54":"90","55to64":"72","65+":"9","medianAge":"72"}},"title":"Computer support specialists","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2012":{"total":"476","women":"27.1","white":"12.0","black":"7.7","asian":"9.7"}},"wageData":{"2012":{"workers":"429","median":"960","maleWorkers":"313","maleMedian":"985","femaleWorkers":"116","femaleMedian":"881"}}},"Database administrators":{"ageData":{"2012":{"total":"101","16to19":"0","20to24":"1","25to34":"14","35to44":"35","45to54":"36","55to64":"12","65+":"3","medianAge":"12"}},"title":"Database administrators","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2012":{"total":"101","women":"36.6","white":"4.1","black":"10.0","asian":"9.8"}},"wageData":{"2012":{"workers":"97","median":"1,376","maleWorkers":"57","maleMedian":"1,657","femaleWorkers":"40","femaleMedian":"-"}}},"Network and computer systems administrators":{"ageData":{"2012":{"total":"226","16to19":"0","20to24":"9","25to34":"70","35to44":"81","45to54":"38","55to64":"24","65+":"4","medianAge":"24"}},"title":"Network and computer systems administrators","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2012":{"total":"226","women":"25.0","white":"10.0","black":"11.0","asian":"10.7"}},"wageData":{"2012":{"workers":"204","median":"1,191","maleWorkers":"153","maleMedian":"1,253","femaleWorkers":"51","femaleMedian":"1,056"}}},"Computer network architects":{"ageData":{"2012":{"total":"127","16to19":"1","20to24":"1","25to34":"26","35to44":"49","45to54":"39","55to64":"5","65+":"6","medianAge":"5"}},"title":"Computer network architects","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2012":{"total":"127","women":"8.1","white":"10.0","black":"14.6","asian":"4.6"}},"wageData":{"2012":{"workers":"115","median":"1,548","maleWorkers":"104","maleMedian":"1,569","femaleWorkers":"11","femaleMedian":"-"}}},"Computer occupations, all other":{"ageData":{"2012":{"total":"341","16to19":"3","20to24":"20","25to34":"86","35to44":"89","45to54":"88","55to64":"44","65+":"12","medianAge":"44"}},"title":"Computer occupations, all other","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2012":{"total":"341","women":"24.4","white":"11.4","black":"11.7","asian":"5.9"}},"wageData":{"2012":{"workers":"288","median":"1,110","maleWorkers":"223","maleMedian":"1,155","femaleWorkers":"65","femaleMedian":"887"}}},"Actuaries":{"ageData":{"2012":{"total":"26","16to19":"0","20to24":"1","25to34":"8","35to44":"4","45to54":"6","55to64":"5","65+":"2","medianAge":"5"}},"title":"Actuaries","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2012":{"total":"26","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"19","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Mathematicians":{"ageData":{"2012":{"total":"4","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Mathematicians","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2012":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"4","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Operations research analysts":{"ageData":{"2012":{"total":"130","16to19":"0","20to24":"3","25to34":"38","35to44":"29","45to54":"32","55to64":"21","65+":"7","medianAge":"21"}},"title":"Operations research analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2012":{"total":"130","women":"54.9","white":"8.3","black":"9.3","asian":"6.5"}},"wageData":{"2012":{"workers":"127","median":"1,334","maleWorkers":"57","maleMedian":"1,551","femaleWorkers":"70","femaleMedian":"1,169"}}},"Statisticians":{"ageData":{"2012":{"total":"47","16to19":"0","20to24":"1","25to34":"16","35to44":"15","45to54":"10","55to64":"4","65+":"1","medianAge":"4"}},"title":"Statisticians","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2012":{"total":"47","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"44","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"18","femaleMedian":"-"}}},"Miscellaneous mathematical science occupations":{"ageData":{"2012":{"total":"3","16to19":"0","20to24":"1","25to34":"0","35to44":"0","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Miscellaneous mathematical science occupations","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2012":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"4","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Architecture and engineering occupations":{"ageData":{"2012":{"total":"2,846","16to19":"11","20to24":"158","25to34":"650","35to44":"628","45to54":"768","55to64":"513","65+":"120","medianAge":"513"}},"title":"Architecture and engineering occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2012":{"total":"2,846","women":"13.7","white":"5.6","black":"10.8","asian":"7.4"}},"wageData":{"2012":{"workers":"2,588","median":"1,337","maleWorkers":"2,269","maleMedian":"1,358","femaleWorkers":"319","femaleMedian":"1,136"}}},"Architects, except naval":{"ageData":{"2012":{"total":"195","16to19":"0","20to24":"3","25to34":"45","35to44":"42","45to54":"55","55to64":"42","65+":"8","medianAge":"42"}},"title":"Architects, except naval","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2012":{"total":"195","women":"23.5","white":"1.3","black":"6.2","asian":"8.2"}},"wageData":{"2012":{"workers":"130","median":"1,325","maleWorkers":"102","maleMedian":"1,415","femaleWorkers":"29","femaleMedian":"-"}}},"Surveyors, cartographers, and photogrammetrists":{"ageData":{"2012":{"total":"51","16to19":"0","20to24":"2","25to34":"12","35to44":"11","45to54":"13","55to64":"10","65+":"1","medianAge":"10"}},"title":"Surveyors, cartographers, and photogrammetrists","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2012":{"total":"51","women":"27.8","white":"4.3","black":"5.4","asian":"8.1"}},"wageData":{"2012":{"workers":"45","median":"-","maleWorkers":"32","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Aerospace engineers":{"ageData":{"2012":{"total":"119","16to19":"0","20to24":"4","25to34":"23","35to44":"30","45to54":"34","55to64":"24","65+":"5","medianAge":"24"}},"title":"Aerospace engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2012":{"total":"119","women":"9.0","white":"1.8","black":"13.4","asian":"4.6"}},"wageData":{"2012":{"workers":"120","median":"1,645","maleWorkers":"111","maleMedian":"1,665","femaleWorkers":"10","femaleMedian":"-"}}},"Agricultural engineers":{"ageData":{"2012":{"total":"4","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Agricultural engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2012":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"4","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Biomedical engineers":{"ageData":{"2012":{"total":"10","16to19":"0","20to24":"1","25to34":"3","35to44":"3","45to54":"4","55to64":"0","65+":"0","medianAge":"0"}},"title":"Biomedical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2012":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"11","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Chemical engineers":{"ageData":{"2012":{"total":"71","16to19":"0","20to24":"6","25to34":"17","35to44":"20","45to54":"14","55to64":"12","65+":"2","medianAge":"12"}},"title":"Chemical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2012":{"total":"71","women":"17.7","white":"5.9","black":"9.3","asian":"6.7"}},"wageData":{"2012":{"workers":"71","median":"1,509","maleWorkers":"61","maleMedian":"1,582","femaleWorkers":"10","femaleMedian":"-"}}},"Civil engineers":{"ageData":{"2012":{"total":"358","16to19":"1","20to24":"25","25to34":"91","35to44":"81","45to54":"85","55to64":"57","65+":"18","medianAge":"57"}},"title":"Civil engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2012":{"total":"358","women":"13.7","white":"5.4","black":"9.0","asian":"3.7"}},"wageData":{"2012":{"workers":"334","median":"1,367","maleWorkers":"287","maleMedian":"1,428","femaleWorkers":"47","femaleMedian":"-"}}},"Computer hardware engineers":{"ageData":{"2012":{"total":"91","16to19":"0","20to24":"3","25to34":"34","35to44":"16","45to54":"26","55to64":"11","65+":"1","medianAge":"11"}},"title":"Computer hardware engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2012":{"total":"91","women":"15.1","white":"8.5","black":"20.8","asian":"6.5"}},"wageData":{"2012":{"workers":"73","median":"1,548","maleWorkers":"66","maleMedian":"1,571","femaleWorkers":"7","femaleMedian":"-"}}},"Electrical and electronics engineers":{"ageData":{"2012":{"total":"335","16to19":"0","20to24":"10","25to34":"66","35to44":"78","45to54":"102","55to64":"60","65+":"19","medianAge":"60"}},"title":"Electrical and electronics engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2012":{"total":"335","women":"9.0","white":"3.5","black":"16.6","asian":"6.7"}},"wageData":{"2012":{"workers":"311","median":"1,550","maleWorkers":"284","maleMedian":"1,614","femaleWorkers":"27","femaleMedian":"-"}}},"Environmental engineers":{"ageData":{"2012":{"total":"43","16to19":"0","20to24":"1","25to34":"5","35to44":"14","45to54":"10","55to64":"9","65+":"4","medianAge":"9"}},"title":"Environmental engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2012":{"total":"43","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"39","median":"-","maleWorkers":"33","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Industrial engineers, including health and safety":{"ageData":{"2012":{"total":"197","16to19":"0","20to24":"16","25to34":"43","35to44":"41","45to54":"54","55to64":"39","65+":"4","medianAge":"39"}},"title":"Industrial engineers, including health and safety","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2012":{"total":"197","women":"18.8","white":"6.2","black":"9.6","asian":"10.5"}},"wageData":{"2012":{"workers":"202","median":"1,393","maleWorkers":"167","maleMedian":"1,408","femaleWorkers":"34","femaleMedian":"-"}}},"Marine engineers and naval architects":{"ageData":{"2012":{"total":"8","16to19":"0","20to24":"0","25to34":"2","35to44":"3","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Marine engineers and naval architects","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2012":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"10","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Materials engineers":{"ageData":{"2012":{"total":"40","16to19":"1","20to24":"2","25to34":"12","35to44":"7","45to54":"12","55to64":"4","65+":"2","medianAge":"4"}},"title":"Materials engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2012":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"36","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Mechanical engineers":{"ageData":{"2012":{"total":"288","16to19":"1","20to24":"26","25to34":"63","35to44":"63","45to54":"83","55to64":"43","65+":"10","medianAge":"43"}},"title":"Mechanical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2012":{"total":"288","women":"4.5","white":"6.3","black":"12.3","asian":"4.9"}},"wageData":{"2012":{"workers":"280","median":"1,434","maleWorkers":"270","maleMedian":"1,442","femaleWorkers":"10","femaleMedian":"-"}}},"Mining and geological engineers, including mining safety engineers":{"ageData":{"2012":{"total":"9","16to19":"0","20to24":"0","25to34":"4","35to44":"1","45to54":"2","55to64":"2","65+":"1","medianAge":"2"}},"title":"Mining and geological engineers, including mining safety engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2012":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"9","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Nuclear engineers":{"ageData":{"2012":{"total":"11","16to19":"0","20to24":"0","25to34":"3","35to44":"1","45to54":"5","55to64":"3","65+":"0","medianAge":"3"}},"title":"Nuclear engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2012":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"10","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Petroleum engineers":{"ageData":{"2012":{"total":"38","16to19":"0","20to24":"7","25to34":"8","35to44":"8","45to54":"6","55to64":"7","65+":"2","medianAge":"7"}},"title":"Petroleum engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2012":{"total":"38","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"33","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Engineers, all other":{"ageData":{"2012":{"total":"359","16to19":"1","20to24":"10","25to34":"90","35to44":"84","45to54":"97","55to64":"55","65+":"22","medianAge":"55"}},"title":"Engineers, all other","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2012":{"total":"359","women":"13.2","white":"3.9","black":"15.4","asian":"5.9"}},"wageData":{"2012":{"workers":"315","median":"1,439","maleWorkers":"275","maleMedian":"1,456","femaleWorkers":"40","femaleMedian":"-"}}},"Drafters":{"ageData":{"2012":{"total":"149","16to19":"1","20to24":"6","25to34":"41","35to44":"35","45to54":"32","55to64":"30","65+":"4","medianAge":"30"}},"title":"Drafters","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2012":{"total":"149","women":"16.6","white":"3.0","black":"7.7","asian":"9.9"}},"wageData":{"2012":{"workers":"129","median":"962","maleWorkers":"108","maleMedian":"958","femaleWorkers":"21","femaleMedian":"-"}}},"Engineering technicians, except drafters":{"ageData":{"2012":{"total":"395","16to19":"5","20to24":"32","25to34":"66","35to44":"77","45to54":"114","55to64":"87","65+":"14","medianAge":"87"}},"title":"Engineering technicians, except drafters","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2012":{"total":"395","women":"16.3","white":"10.8","black":"5.0","asian":"12.3"}},"wageData":{"2012":{"workers":"360","median":"989","maleWorkers":"312","maleMedian":"1,008","femaleWorkers":"48","femaleMedian":"-"}}},"Surveying and mapping technicians":{"ageData":{"2012":{"total":"77","16to19":"0","20to24":"4","25to34":"20","35to44":"14","45to54":"18","55to64":"18","65+":"3","medianAge":"18"}},"title":"Surveying and mapping technicians","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2012":{"total":"77","women":"4.3","white":"5.3","black":"2.5","asian":"13.5"}},"wageData":{"2012":{"workers":"67","median":"885","maleWorkers":"63","maleMedian":"891","femaleWorkers":"4","femaleMedian":"-"}}},"Life, physical, and social science occupations":{"ageData":{"2012":{"total":"1,316","16to19":"8","20to24":"82","25to34":"375","35to44":"284","45to54":"295","55to64":"210","65+":"62","medianAge":"210"}},"title":"Life, physical, and social science occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2012":{"total":"1,316","women":"45.3","white":"6.5","black":"9.9","asian":"6.7"}},"wageData":{"2012":{"workers":"1,098","median":"1,134","maleWorkers":"631","maleMedian":"1,226","femaleWorkers":"467","femaleMedian":"1,015"}}},"Agricultural and food scientists":{"ageData":{"2012":{"total":"42","16to19":"0","20to24":"3","25to34":"8","35to44":"9","45to54":"9","55to64":"9","65+":"4","medianAge":"9"}},"title":"Agricultural and food scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2012":{"total":"42","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"34","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Biological scientists":{"ageData":{"2012":{"total":"101","16to19":"0","20to24":"7","25to34":"28","35to44":"21","45to54":"22","55to64":"20","65+":"3","medianAge":"20"}},"title":"Biological scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2012":{"total":"101","women":"50.1","white":"3.7","black":"11.7","asian":"7.2"}},"wageData":{"2012":{"workers":"94","median":"1,181","maleWorkers":"51","maleMedian":"1,331","femaleWorkers":"43","femaleMedian":"-"}}},"Conservation scientists and foresters":{"ageData":{"2012":{"total":"25","16to19":"0","20to24":"0","25to34":"6","35to44":"6","45to54":"5","55to64":"7","65+":"1","medianAge":"7"}},"title":"Conservation scientists and foresters","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2012":{"total":"25","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"18","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Medical scientists":{"ageData":{"2012":{"total":"136","16to19":"0","20to24":"4","25to34":"39","35to44":"38","45to54":"32","55to64":"20","65+":"3","medianAge":"20"}},"title":"Medical scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2012":{"total":"136","women":"52.8","white":"5.3","black":"22.4","asian":"5.8"}},"wageData":{"2012":{"workers":"123","median":"1,163","maleWorkers":"64","maleMedian":"1,331","femaleWorkers":"59","femaleMedian":"1,060"}}},"Life scientists, all other":{"ageData":{"2012":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Life scientists, all other","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2012":{"total":"0","women":"-","white":"-","black":"-","asian":"-"}}},"Astronomers and physicists":{"ageData":{"2012":{"total":"25","16to19":"0","20to24":"0","25to34":"2","35to44":"3","45to54":"10","55to64":"4","65+":"5","medianAge":"4"}},"title":"Astronomers and physicists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2012":{"total":"25","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"22","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Atmospheric and space scientists":{"ageData":{"2012":{"total":"15","16to19":"0","20to24":"0","25to34":"3","35to44":"3","45to54":"6","55to64":"2","65+":"1","medianAge":"2"}},"title":"Atmospheric and space scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2012":{"total":"15","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"14","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Chemists and materials scientists":{"ageData":{"2012":{"total":"105","16to19":"0","20to24":"9","25to34":"32","35to44":"22","45to54":"29","55to64":"11","65+":"2","medianAge":"11"}},"title":"Chemists and materials scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2012":{"total":"105","women":"44.2","white":"4.0","black":"9.2","asian":"9.4"}},"wageData":{"2012":{"workers":"98","median":"1,163","maleWorkers":"56","maleMedian":"1,226","femaleWorkers":"42","femaleMedian":"-"}}},"Environmental scientists and geoscientists":{"ageData":{"2012":{"total":"105","16to19":"0","20to24":"3","25to34":"31","35to44":"22","45to54":"28","55to64":"16","65+":"5","medianAge":"16"}},"title":"Environmental scientists and geoscientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2012":{"total":"105","women":"25.7","white":"7.0","black":"1.3","asian":"1.7"}},"wageData":{"2012":{"workers":"93","median":"1,266","maleWorkers":"68","maleMedian":"1,390","femaleWorkers":"25","femaleMedian":"-"}}},"Physical scientists, all other":{"ageData":{"2012":{"total":"154","16to19":"0","20to24":"9","25to34":"48","35to44":"42","45to54":"24","55to64":"22","65+":"9","medianAge":"22"}},"title":"Physical scientists, all other","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2012":{"total":"154","women":"35.1","white":"2.7","black":"20.4","asian":"3.8"}},"wageData":{"2012":{"workers":"145","median":"1,456","maleWorkers":"96","maleMedian":"1,522","femaleWorkers":"50","femaleMedian":"1,171"}}},"Economists":{"ageData":{"2012":{"total":"26","16to19":"0","20to24":"1","25to34":"5","35to44":"6","45to54":"5","55to64":"6","65+":"3","medianAge":"6"}},"title":"Economists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2012":{"total":"26","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"23","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Survey researchers":{"ageData":{"2012":{"total":"2","16to19":"0","20to24":"0","25to34":"2","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Survey researchers","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2012":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"3","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Psychologists":{"ageData":{"2012":{"total":"178","16to19":"0","20to24":"0","25to34":"43","35to44":"38","45to54":"34","55to64":"46","65+":"18","medianAge":"46"}},"title":"Psychologists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2012":{"total":"178","women":"72.7","white":"6.0","black":"3.9","asian":"6.3"}},"wageData":{"2012":{"workers":"93","median":"1,228","maleWorkers":"21","maleMedian":"-","femaleWorkers":"72","femaleMedian":"1,155"}}},"Sociologists":{"ageData":{"2012":{"total":"7","16to19":"0","20to24":"0","25to34":"2","35to44":"0","45to54":"2","55to64":"2","65+":"1","medianAge":"2"}},"title":"Sociologists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2012":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"4","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Urban and regional planners":{"ageData":{"2012":{"total":"28","16to19":"0","20to24":"0","25to34":"13","35to44":"7","45to54":"4","55to64":"4","65+":"0","medianAge":"4"}},"title":"Urban and regional planners","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2012":{"total":"28","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"28","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Miscellaneous social scientists and related workers":{"ageData":{"2012":{"total":"57","16to19":"0","20to24":"1","25to34":"17","35to44":"16","45to54":"13","55to64":"9","65+":"1","medianAge":"9"}},"title":"Miscellaneous social scientists and related workers","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2012":{"total":"57","women":"54.3","white":"10.8","black":"5.5","asian":"7.0"}},"wageData":{"2012":{"workers":"44","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"22","femaleMedian":"-"}}},"Agricultural and food science technicians":{"ageData":{"2012":{"total":"32","16to19":"0","20to24":"2","25to34":"11","35to44":"4","45to54":"8","55to64":"5","65+":"2","medianAge":"5"}},"title":"Agricultural and food science technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2012":{"total":"32","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"29","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"15","femaleMedian":"-"}}},"Biological technicians":{"ageData":{"2012":{"total":"19","16to19":"0","20to24":"2","25to34":"5","35to44":"3","45to54":"6","55to64":"1","65+":"0","medianAge":"1"}},"title":"Biological technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2012":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"14","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Chemical technicians":{"ageData":{"2012":{"total":"70","16to19":"0","20to24":"5","25to34":"26","35to44":"8","45to54":"18","55to64":"10","65+":"2","medianAge":"10"}},"title":"Chemical technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2012":{"total":"70","women":"29.9","white":"15.4","black":"4.8","asian":"7.4"}},"wageData":{"2012":{"workers":"62","median":"779","maleWorkers":"45","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Geological and petroleum technicians":{"ageData":{"2012":{"total":"21","16to19":"0","20to24":"2","25to34":"7","35to44":"3","45to54":"8","55to64":"1","65+":"0","medianAge":"1"}},"title":"Geological and petroleum technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2012":{"total":"21","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"22","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Nuclear technicians":{"ageData":{"2012":{"total":"3","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Nuclear technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2012":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Social science research assistants":{"ageData":{"2012":{"total":"3","16to19":"0","20to24":"1","25to34":"1","35to44":"0","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Social science research assistants","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2012":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"3","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Miscellaneous life, physical, and social science technicians":{"ageData":{"2012":{"total":"160","16to19":"7","20to24":"31","25to34":"44","35to44":"30","45to54":"30","55to64":"15","65+":"3","medianAge":"15"}},"title":"Miscellaneous life, physical, and social science technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2012":{"total":"160","women":"52.8","white":"12.8","black":"14.4","asian":"10.4"}},"wageData":{"2012":{"workers":"128","median":"745","maleWorkers":"62","maleMedian":"825","femaleWorkers":"66","femaleMedian":"620"}}},"Community and social service occupations":{"ageData":{"2012":{"total":"2,265","16to19":"15","20to24":"127","25to34":"508","35to44":"507","45to54":"477","55to64":"468","65+":"162","medianAge":"468"}},"title":"Community and social service occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2012":{"total":"2,265","women":"63.8","white":"18.8","black":"3.2","asian":"11.1"}},"wageData":{"2012":{"workers":"1,891","median":"838","maleWorkers":"714","maleMedian":"869","femaleWorkers":"1,177","femaleMedian":"820"}}},"Counselors":{"ageData":{"2012":{"total":"661","16to19":"5","20to24":"43","25to34":"157","35to44":"152","45to54":"127","55to64":"140","65+":"35","medianAge":"140"}},"title":"Counselors","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2012":{"total":"661","women":"69.3","white":"19.4","black":"2.9","asian":"10.7"}},"wageData":{"2012":{"workers":"519","median":"848","maleWorkers":"172","maleMedian":"833","femaleWorkers":"347","femaleMedian":"855"}}},"Social workers":{"ageData":{"2012":{"total":"734","16to19":"2","20to24":"34","25to34":"195","35to44":"205","45to54":"159","55to64":"115","65+":"23","medianAge":"115"}},"title":"Social workers","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2012":{"total":"734","women":"80.6","white":"23.0","black":"3.1","asian":"12.6"}},"wageData":{"2012":{"workers":"668","median":"847","maleWorkers":"134","maleMedian":"856","femaleWorkers":"535","femaleMedian":"845"}}},"Probation officers and correctional treatment specialists":{"ageData":{"2012":{"total":"88","16to19":"0","20to24":"3","25to34":"26","35to44":"30","45to54":"17","55to64":"11","65+":"1","medianAge":"11"}},"title":"Probation officers and correctional treatment specialists","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2012":{"total":"88","women":"47.5","white":"20.7","black":"1.3","asian":"15.0"}},"wageData":{"2012":{"workers":"85","median":"948","maleWorkers":"44","maleMedian":"-","femaleWorkers":"40","femaleMedian":"-"}}},"Social and human service assistants":{"ageData":{"2012":{"total":"151","16to19":"1","20to24":"18","25to34":"39","35to44":"27","45to54":"22","55to64":"35","65+":"9","medianAge":"35"}},"title":"Social and human service assistants","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2012":{"total":"151","women":"77.1","white":"24.4","black":"3.8","asian":"15.5"}},"wageData":{"2012":{"workers":"124","median":"637","maleWorkers":"25","maleMedian":"-","femaleWorkers":"99","femaleMedian":"656"}}},"Miscellaneous community and social service specialists, including health educators and community health workers":{"ageData":{"2012":{"total":"94","16to19":"1","20to24":"7","25to34":"21","35to44":"15","45to54":"30","55to64":"14","65+":"5","medianAge":"14"}},"title":"Miscellaneous community and social service specialists, including health educators and community health workers","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2012":{"total":"94","women":"75.7","white":"16.9","black":"2.4","asian":"18.4"}},"wageData":{"2012":{"workers":"74","median":"667","maleWorkers":"24","maleMedian":"-","femaleWorkers":"51","femaleMedian":"642"}}},"Clergy":{"ageData":{"2012":{"total":"408","16to19":"2","20to24":"10","25to34":"49","35to44":"62","45to54":"94","55to64":"120","65+":"70","medianAge":"120"}},"title":"Clergy","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2012":{"total":"408","women":"20.5","white":"11.2","black":"4.2","asian":"6.1"}},"wageData":{"2012":{"workers":"344","median":"895","maleWorkers":"281","maleMedian":"959","femaleWorkers":"63","femaleMedian":"777"}}},"Directors, religious activities and education":{"ageData":{"2012":{"total":"61","16to19":"0","20to24":"2","25to34":"13","35to44":"9","45to54":"16","55to64":"15","65+":"6","medianAge":"15"}},"title":"Directors, religious activities and education","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2012":{"total":"61","women":"66.3","white":"7.4","black":"2.1","asian":"5.9"}},"wageData":{"2012":{"workers":"37","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"23","femaleMedian":"-"}}},"Religious workers, all other":{"ageData":{"2012":{"total":"69","16to19":"3","20to24":"9","25to34":"8","35to44":"7","45to54":"13","55to64":"17","65+":"12","medianAge":"17"}},"title":"Religious workers, all other","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2012":{"total":"69","women":"62.4","white":"10.0","black":"2.8","asian":"8.9"}},"wageData":{"2012":{"workers":"40","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"20","femaleMedian":"-"}}},"Legal occupations":{"ageData":{"2012":{"total":"1,786","16to19":"5","20to24":"49","25to34":"385","35to44":"415","45to54":"421","55to64":"354","65+":"156","medianAge":"354"}},"title":"Legal occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2012":{"total":"1,786","women":"50.4","white":"7.1","black":"3.9","asian":"7.4"}},"wageData":{"2012":{"workers":"1,315","median":"1,328","maleWorkers":"600","maleMedian":"1,884","femaleWorkers":"716","femaleMedian":"1,013"}}},"Lawyers":{"ageData":{"2012":{"total":"1,061","16to19":"0","20to24":"1","25to34":"213","35to44":"258","45to54":"240","55to64":"223","65+":"125","medianAge":"223"}},"title":"Lawyers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2012":{"total":"1,061","women":"31.1","white":"4.4","black":"4.3","asian":"4.0"}},"wageData":{"2012":{"workers":"690","median":"1,909","maleWorkers":"462","maleMedian":"2,055","femaleWorkers":"228","femaleMedian":"1,636"}}},"Judicial law clerks":{"ageData":{"2012":{"total":"17","16to19":"0","20to24":"2","25to34":"5","35to44":"2","45to54":"2","55to64":"6","65+":"1","medianAge":"6"}},"title":"Judicial law clerks","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2012":{"total":"17","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"9","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Judges, magistrates, and other judicial workers":{"ageData":{"2012":{"total":"67","16to19":"0","20to24":"0","25to34":"9","35to44":"9","45to54":"16","55to64":"26","65+":"8","medianAge":"26"}},"title":"Judges, magistrates, and other judicial workers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2012":{"total":"67","women":"39.0","white":"12.8","black":"0.7","asian":"4.5"}},"wageData":{"2012":{"workers":"64","median":"1,637","maleWorkers":"38","maleMedian":"-","femaleWorkers":"26","femaleMedian":"-"}}},"Paralegals and legal assistants":{"ageData":{"2012":{"total":"418","16to19":"3","20to24":"38","25to34":"104","35to44":"97","45to54":"100","55to64":"62","65+":"13","medianAge":"62"}},"title":"Paralegals and legal assistants","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2012":{"total":"418","women":"85.9","white":"10.7","black":"4.6","asian":"17.0"}},"wageData":{"2012":{"workers":"372","median":"872","maleWorkers":"54","maleMedian":"919","femaleWorkers":"317","femaleMedian":"865"}}},"Miscellaneous legal support workers":{"ageData":{"2012":{"total":"223","16to19":"1","20to24":"8","25to34":"55","35to44":"49","45to54":"63","55to64":"38","65+":"9","medianAge":"38"}},"title":"Miscellaneous legal support workers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2012":{"total":"223","women":"79.0","white":"11.9","black":"1.4","asian":"7.0"}},"wageData":{"2012":{"workers":"181","median":"815","maleWorkers":"42","maleMedian":"-","femaleWorkers":"139","femaleMedian":"754"}}},"Education, training, and library occupations":{"ageData":{"2012":{"total":"8,543","16to19":"114","20to24":"602","25to34":"2,003","35to44":"1,877","45to54":"1,937","55to64":"1,543","65+":"468","medianAge":"1,543"}},"title":"Education, training, and library occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2012":{"total":"8,543","women":"73.6","white":"9.5","black":"4.3","asian":"9.7"}},"wageData":{"2012":{"workers":"6,454","median":"915","maleWorkers":"1,766","maleMedian":"1,133","femaleWorkers":"4,687","femaleMedian":"858"}}},"Postsecondary teachers":{"ageData":{"2012":{"total":"1,350","16to19":"6","20to24":"95","25to34":"304","35to44":"262","45to54":"274","55to64":"274","65+":"136","medianAge":"274"}},"title":"Postsecondary teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2012":{"total":"1,350","women":"48.2","white":"7.9","black":"11.3","asian":"6.2"}},"wageData":{"2012":{"workers":"920","median":"1,216","maleWorkers":"497","maleMedian":"1,366","femaleWorkers":"424","femaleMedian":"1,055"}}},"Preschool and kindergarten teachers":{"ageData":{"2012":{"total":"678","16to19":"15","20to24":"70","25to34":"183","35to44":"161","45to54":"145","55to64":"82","65+":"22","medianAge":"82"}},"title":"Preschool and kindergarten teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2012":{"total":"678","women":"98.1","white":"11.8","black":"4.2","asian":"12.0"}},"wageData":{"2012":{"workers":"494","median":"589","maleWorkers":"9","maleMedian":"-","femaleWorkers":"485","femaleMedian":"588"}}},"Elementary and middle school teachers":{"ageData":{"2012":{"total":"2,838","16to19":"8","20to24":"117","25to34":"722","35to44":"731","45to54":"647","55to64":"502","65+":"111","medianAge":"502"}},"title":"Elementary and middle school teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2012":{"total":"2,838","women":"81.4","white":"9.8","black":"2.1","asian":"10.3"}},"wageData":{"2012":{"workers":"2,435","median":"942","maleWorkers":"464","maleMedian":"1,128","femaleWorkers":"1,971","femaleMedian":"921"}}},"Secondary school teachers":{"ageData":{"2012":{"total":"1,127","16to19":"3","20to24":"53","25to34":"303","35to44":"272","45to54":"268","55to64":"184","65+":"44","medianAge":"184"}},"title":"Secondary school teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2012":{"total":"1,127","women":"57.3","white":"6.0","black":"3.1","asian":"7.6"}},"wageData":{"2012":{"workers":"1,043","median":"1,009","maleWorkers":"465","maleMedian":"1,050","femaleWorkers":"578","femaleMedian":"978"}}},"Special education teachers":{"ageData":{"2012":{"total":"366","16to19":"3","20to24":"13","25to34":"94","35to44":"70","45to54":"106","55to64":"67","65+":"14","medianAge":"67"}},"title":"Special education teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2012":{"total":"366","women":"86.2","white":"6.9","black":"1.1","asian":"9.4"}},"wageData":{"2012":{"workers":"307","median":"944","maleWorkers":"43","maleMedian":"-","femaleWorkers":"264","femaleMedian":"940"}}},"Other teachers and instructors":{"ageData":{"2012":{"total":"860","16to19":"48","20to24":"137","25to34":"178","35to44":"126","45to54":"144","55to64":"158","65+":"69","medianAge":"158"}},"title":"Other teachers and instructors","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2012":{"total":"860","women":"65.6","white":"10.7","black":"5.9","asian":"9.5"}},"wageData":{"2012":{"workers":"372","median":"785","maleWorkers":"151","maleMedian":"917","femaleWorkers":"220","femaleMedian":"729"}}},"Archivists, curators, and museum technicians":{"ageData":{"2012":{"total":"46","16to19":"1","20to24":"3","25to34":"5","35to44":"10","45to54":"10","55to64":"12","65+":"6","medianAge":"12"}},"title":"Archivists, curators, and museum technicians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2012":{"total":"46","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"40","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"21","femaleMedian":"-"}}},"Librarians":{"ageData":{"2012":{"total":"181","16to19":"1","20to24":"7","25to34":"24","35to44":"31","45to54":"46","55to64":"57","65+":"15","medianAge":"57"}},"title":"Librarians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2012":{"total":"181","women":"86.8","white":"7.9","black":"2.5","asian":"2.8"}},"wageData":{"2012":{"workers":"143","median":"966","maleWorkers":"24","maleMedian":"-","femaleWorkers":"120","femaleMedian":"960"}}},"Library technicians":{"ageData":{"2012":{"total":"45","16to19":"6","20to24":"7","25to34":"8","35to44":"6","45to54":"5","55to64":"12","65+":"1","medianAge":"12"}},"title":"Library technicians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2012":{"total":"45","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"21","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"Teacher assistants":{"ageData":{"2012":{"total":"898","16to19":"18","20to24":"92","25to34":"152","35to44":"180","45to54":"254","55to64":"164","65+":"36","medianAge":"164"}},"title":"Teacher assistants","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2012":{"total":"898","women":"91.1","white":"14.5","black":"2.7","asian":"15.7"}},"wageData":{"2012":{"workers":"567","median":"458","maleWorkers":"51","maleMedian":"493","femaleWorkers":"515","femaleMedian":"452"}}},"Other education, training, and library workers":{"ageData":{"2012":{"total":"153","16to19":"3","20to24":"8","25to34":"31","35to44":"29","45to54":"37","55to64":"31","65+":"14","medianAge":"31"}},"title":"Other education, training, and library workers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2012":{"total":"153","women":"67.3","white":"11.7","black":"2.5","asian":"11.8"}},"wageData":{"2012":{"workers":"110","median":"1,011","maleWorkers":"38","maleMedian":"-","femaleWorkers":"72","femaleMedian":"932"}}},"Arts, design, entertainment, sports, and media occupations":{"ageData":{"2012":{"total":"2,814","16to19":"78","20to24":"285","25to34":"706","35to44":"592","45to54":"564","55to64":"415","65+":"175","medianAge":"415"}},"title":"Arts, design, entertainment, sports, and media occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2012":{"total":"2,814","women":"48.3","white":"6.0","black":"5.2","asian":"8.9"}},"wageData":{"2012":{"workers":"1,440","median":"969","maleWorkers":"809","maleMedian":"1,055","femaleWorkers":"631","femaleMedian":"885"}}},"Artists and related workers":{"ageData":{"2012":{"total":"212","16to19":"0","20to24":"10","25to34":"44","35to44":"53","45to54":"42","55to64":"46","65+":"17","medianAge":"46"}},"title":"Artists and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2012":{"total":"212","women":"51.6","white":"4.0","black":"9.3","asian":"6.6"}},"wageData":{"2012":{"workers":"68","median":"1,131","maleWorkers":"44","maleMedian":"-","femaleWorkers":"24","femaleMedian":"-"}}},"Designers":{"ageData":{"2012":{"total":"756","16to19":"7","20to24":"61","25to34":"196","35to44":"174","45to54":"176","55to64":"107","65+":"35","medianAge":"107"}},"title":"Designers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2012":{"total":"756","women":"55.3","white":"3.9","black":"5.9","asian":"8.9"}},"wageData":{"2012":{"workers":"467","median":"953","maleWorkers":"241","maleMedian":"1,028","femaleWorkers":"226","femaleMedian":"855"}}},"Actors":{"ageData":{"2012":{"total":"37","16to19":"2","20to24":"7","25to34":"10","35to44":"9","45to54":"5","55to64":"3","65+":"1","medianAge":"3"}},"title":"Actors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2012":{"total":"37","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"10","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Producers and directors":{"ageData":{"2012":{"total":"121","16to19":"0","20to24":"10","25to34":"37","35to44":"28","45to54":"22","55to64":"19","65+":"4","medianAge":"19"}},"title":"Producers and directors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2012":{"total":"121","women":"40.8","white":"8.2","black":"3.3","asian":"4.9"}},"wageData":{"2012":{"workers":"75","median":"1,048","maleWorkers":"41","maleMedian":"-","femaleWorkers":"34","femaleMedian":"-"}}},"Athletes, coaches, umpires, and related workers":{"ageData":{"2012":{"total":"267","16to19":"44","20to24":"60","25to34":"48","35to44":"38","45to54":"38","55to64":"30","65+":"9","medianAge":"30"}},"title":"Athletes, coaches, umpires, and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2012":{"total":"267","women":"36.5","white":"6.4","black":"1.4","asian":"9.0"}},"wageData":{"2012":{"workers":"89","median":"958","maleWorkers":"63","maleMedian":"1,018","femaleWorkers":"25","femaleMedian":"-"}}},"Dancers and choreographers":{"ageData":{"2012":{"total":"21","16to19":"4","20to24":"5","25to34":"9","35to44":"3","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Dancers and choreographers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2012":{"total":"21","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"5","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Musicians, singers, and related workers":{"ageData":{"2012":{"total":"203","16to19":"7","20to24":"18","25to34":"51","35to44":"35","45to54":"34","55to64":"38","65+":"20","medianAge":"38"}},"title":"Musicians, singers, and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2012":{"total":"203","women":"35.5","white":"10.9","black":"2.8","asian":"6.7"}},"wageData":{"2012":{"workers":"49","median":"-","maleWorkers":"36","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Entertainers and performers, sports and related workers, all other":{"ageData":{"2012":{"total":"41","16to19":"2","20to24":"5","25to34":"14","35to44":"6","45to54":"6","55to64":"2","65+":"5","medianAge":"2"}},"title":"Entertainers and performers, sports and related workers, all other","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2012":{"total":"41","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"14","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Announcers":{"ageData":{"2012":{"total":"50","16to19":"0","20to24":"5","25to34":"9","35to44":"14","45to54":"13","55to64":"5","65+":"5","medianAge":"5"}},"title":"Announcers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2012":{"total":"50","women":"23.6","white":"12.0","black":"8.3","asian":"15.3"}},"wageData":{"2012":{"workers":"20","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"News analysts, reporters and correspondents":{"ageData":{"2012":{"total":"82","16to19":"1","20to24":"12","25to34":"20","35to44":"11","45to54":"20","55to64":"15","65+":"5","medianAge":"15"}},"title":"News analysts, reporters and correspondents","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2012":{"total":"82","women":"45.7","white":"9.2","black":"6.1","asian":"5.9"}},"wageData":{"2012":{"workers":"63","median":"1,021","maleWorkers":"39","maleMedian":"-","femaleWorkers":"24","femaleMedian":"-"}}},"Public relations specialists":{"ageData":{"2012":{"total":"155","16to19":"0","20to24":"11","25to34":"46","35to44":"39","45to54":"25","55to64":"27","65+":"8","medianAge":"27"}},"title":"Public relations specialists","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2012":{"total":"155","women":"58.2","white":"7.3","black":"5.8","asian":"8.0"}},"wageData":{"2012":{"workers":"133","median":"1,127","maleWorkers":"55","maleMedian":"1,351","femaleWorkers":"79","femaleMedian":"989"}}},"Editors":{"ageData":{"2012":{"total":"159","16to19":"2","20to24":"21","25to34":"41","35to44":"30","45to54":"30","55to64":"23","65+":"11","medianAge":"23"}},"title":"Editors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2012":{"total":"159","women":"50.7","white":"4.8","black":"3.2","asian":"6.5"}},"wageData":{"2012":{"workers":"121","median":"946","maleWorkers":"59","maleMedian":"993","femaleWorkers":"62","femaleMedian":"889"}}},"Technical writers":{"ageData":{"2012":{"total":"58","16to19":"0","20to24":"1","25to34":"8","35to44":"17","45to54":"18","55to64":"10","65+":"3","medianAge":"10"}},"title":"Technical writers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2012":{"total":"58","women":"55.5","white":"2.7","black":"6.7","asian":"3.7"}},"wageData":{"2012":{"workers":"52","median":"1,227","maleWorkers":"24","maleMedian":"-","femaleWorkers":"27","femaleMedian":"-"}}},"Writers and authors":{"ageData":{"2012":{"total":"208","16to19":"1","20to24":"13","25to34":"48","35to44":"27","45to54":"49","55to64":"42","65+":"28","medianAge":"42"}},"title":"Writers and authors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2012":{"total":"208","women":"55.6","white":"5.4","black":"4.2","asian":"2.9"}},"wageData":{"2012":{"workers":"86","median":"899","maleWorkers":"40","maleMedian":"-","femaleWorkers":"46","femaleMedian":"-"}}},"Miscellaneous media and communication workers":{"ageData":{"2012":{"total":"98","16to19":"2","20to24":"8","25to34":"27","35to44":"21","45to54":"21","55to64":"13","65+":"7","medianAge":"13"}},"title":"Miscellaneous media and communication workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2012":{"total":"98","women":"79.2","white":"5.6","black":"15.0","asian":"35.0"}},"wageData":{"2012":{"workers":"43","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Broadcast and sound engineering technicians and radio operators":{"ageData":{"2012":{"total":"108","16to19":"2","20to24":"14","25to34":"32","35to44":"23","45to54":"22","55to64":"12","65+":"3","medianAge":"12"}},"title":"Broadcast and sound engineering technicians and radio operators","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2012":{"total":"108","women":"8.4","white":"4.1","black":"1.6","asian":"12.6"}},"wageData":{"2012":{"workers":"70","median":"875","maleWorkers":"64","maleMedian":"924","femaleWorkers":"5","femaleMedian":"-"}}},"Photographers":{"ageData":{"2012":{"total":"178","16to19":"4","20to24":"19","25to34":"49","35to44":"44","45to54":"30","55to64":"20","65+":"12","medianAge":"20"}},"title":"Photographers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2012":{"total":"178","women":"52.2","white":"6.2","black":"4.3","asian":"10.7"}},"wageData":{"2012":{"workers":"37","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"14","femaleMedian":"-"}}},"Television, video, and motion picture camera operators and editors":{"ageData":{"2012":{"total":"57","16to19":"1","20to24":"5","25to34":"16","35to44":"18","45to54":"12","55to64":"3","65+":"2","medianAge":"3"}},"title":"Television, video, and motion picture camera operators and editors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2012":{"total":"57","women":"21.4","white":"4.4","black":"5.6","asian":"10.7"}},"wageData":{"2012":{"workers":"34","median":"-","maleWorkers":"29","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Media and communication equipment workers, all other":{"ageData":{"2012":{"total":"2","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Media and communication equipment workers, all other","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2012":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"3","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Healthcare practitioners and technical occupations":{"ageData":{"2012":{"total":"7,977","16to19":"31","20to24":"358","25to34":"1,969","35to44":"1,968","45to54":"1,823","55to64":"1,487","65+":"341","medianAge":"1,487"}},"title":"Healthcare practitioners and technical occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2012":{"total":"7,977","women":"75.0","white":"10.6","black":"8.4","asian":"7.3"}},"wageData":{"2012":{"workers":"5,791","median":"1,028","maleWorkers":"1,471","maleMedian":"1,245","femaleWorkers":"4,320","femaleMedian":"980"}}},"Chiropractors":{"ageData":{"2012":{"total":"58","16to19":"0","20to24":"0","25to34":"9","35to44":"17","45to54":"15","55to64":"10","65+":"6","medianAge":"10"}},"title":"Chiropractors","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"58","women":"22.3","white":"0.0","black":"3.5","asian":"4.0"}},"wageData":{"2012":{"workers":"7","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Dentists":{"ageData":{"2012":{"total":"167","16to19":"0","20to24":"0","25to34":"17","35to44":"39","45to54":"51","55to64":"37","65+":"22","medianAge":"37"}},"title":"Dentists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"167","women":"24.2","white":"1.7","black":"10.6","asian":"2.5"}},"wageData":{"2012":{"workers":"49","median":"-","maleWorkers":"37","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Dietitians and nutritionists":{"ageData":{"2012":{"total":"116","16to19":"2","20to24":"4","25to34":"24","35to44":"22","45to54":"26","55to64":"32","65+":"6","medianAge":"32"}},"title":"Dietitians and nutritionists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"116","women":"93.3","white":"13.7","black":"5.1","asian":"7.2"}},"wageData":{"2012":{"workers":"79","median":"840","maleWorkers":"6","maleMedian":"-","femaleWorkers":"73","femaleMedian":"845"}}},"Optometrists":{"ageData":{"2012":{"total":"33","16to19":"0","20to24":"0","25to34":"8","35to44":"3","45to54":"10","55to64":"7","65+":"4","medianAge":"7"}},"title":"Optometrists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"7","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Pharmacists":{"ageData":{"2012":{"total":"286","16to19":"0","20to24":"8","25to34":"94","35to44":"73","45to54":"49","55to64":"45","65+":"16","medianAge":"45"}},"title":"Pharmacists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"286","women":"53.7","white":"6.8","black":"18.5","asian":"5.1"}},"wageData":{"2012":{"workers":"223","median":"1,877","maleWorkers":"107","maleMedian":"1,879","femaleWorkers":"116","femaleMedian":"1,871"}}},"Physicians and surgeons":{"ageData":{"2012":{"total":"911","16to19":"0","20to24":"3","25to34":"179","35to44":"238","45to54":"218","55to64":"181","65+":"92","medianAge":"181"}},"title":"Physicians and surgeons","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"911","women":"34.3","white":"7.2","black":"18.1","asian":"5.2"}},"wageData":{"2012":{"workers":"655","median":"1,887","maleWorkers":"429","maleMedian":"2,099","femaleWorkers":"226","femaleMedian":"1,418"}}},"Physician assistants":{"ageData":{"2012":{"total":"108","16to19":"0","20to24":"5","25to34":"34","35to44":"35","45to54":"22","55to64":"11","65+":"2","medianAge":"11"}},"title":"Physician assistants","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"108","women":"69.4","white":"8.2","black":"9.0","asian":"8.8"}},"wageData":{"2012":{"workers":"88","median":"1,329","maleWorkers":"27","maleMedian":"-","femaleWorkers":"61","femaleMedian":"1,364"}}},"Podiatrists":{"ageData":{"2012":{"total":"9","16to19":"0","20to24":"0","25to34":"0","35to44":"3","45to54":"3","55to64":"3","65+":"0","medianAge":"3"}},"title":"Podiatrists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Audiologists":{"ageData":{"2012":{"total":"14","16to19":"0","20to24":"0","25to34":"5","35to44":"5","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Audiologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"7","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Occupational therapists":{"ageData":{"2012":{"total":"118","16to19":"0","20to24":"2","25to34":"38","35to44":"34","45to54":"26","55to64":"16","65+":"3","medianAge":"16"}},"title":"Occupational therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"118","women":"94.0","white":"2.5","black":"4.0","asian":"5.8"}},"wageData":{"2012":{"workers":"85","median":"1,189","maleWorkers":"3","maleMedian":"-","femaleWorkers":"82","femaleMedian":"1,200"}}},"Physical therapists":{"ageData":{"2012":{"total":"211","16to19":"1","20to24":"6","25to34":"74","35to44":"53","45to54":"46","55to64":"27","65+":"5","medianAge":"27"}},"title":"Physical therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"211","women":"70.7","white":"4.4","black":"9.1","asian":"9.4"}},"wageData":{"2012":{"workers":"144","median":"1,287","maleWorkers":"56","maleMedian":"1,362","femaleWorkers":"88","femaleMedian":"1,190"}}},"Radiation therapists":{"ageData":{"2012":{"total":"14","16to19":"0","20to24":"0","25to34":"5","35to44":"5","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Radiation therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"11","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Recreational therapists":{"ageData":{"2012":{"total":"13","16to19":"0","20to24":"0","25to34":"6","35to44":"2","45to54":"4","55to64":"1","65+":"1","medianAge":"1"}},"title":"Recreational therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"10","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Respiratory therapists":{"ageData":{"2012":{"total":"111","16to19":"0","20to24":"3","25to34":"27","35to44":"34","45to54":"24","55to64":"20","65+":"3","medianAge":"20"}},"title":"Respiratory therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"111","women":"60.4","white":"12.1","black":"5.6","asian":"10.6"}},"wageData":{"2012":{"workers":"92","median":"979","maleWorkers":"36","maleMedian":"-","femaleWorkers":"56","femaleMedian":"936"}}},"Speech-language pathologists":{"ageData":{"2012":{"total":"146","16to19":"0","20to24":"4","25to34":"50","35to44":"40","45to54":"21","55to64":"29","65+":"1","medianAge":"29"}},"title":"Speech-language pathologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"146","women":"95.2","white":"3.1","black":"1.7","asian":"8.3"}},"wageData":{"2012":{"workers":"88","median":"1,128","maleWorkers":"3","maleMedian":"-","femaleWorkers":"86","femaleMedian":"1,121"}}},"Exercise physiologists":{"ageData":{"2012":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Exercise physiologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Therapists, all other":{"ageData":{"2012":{"total":"148","16to19":"1","20to24":"12","25to34":"41","35to44":"40","45to54":"25","55to64":"23","65+":"6","medianAge":"23"}},"title":"Therapists, all other","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"148","women":"83.6","white":"10.3","black":"2.9","asian":"8.7"}},"wageData":{"2012":{"workers":"88","median":"926","maleWorkers":"16","maleMedian":"-","femaleWorkers":"71","femaleMedian":"877"}}},"Veterinarians":{"ageData":{"2012":{"total":"85","16to19":"1","20to24":"1","25to34":"19","35to44":"30","45to54":"16","55to64":"14","65+":"3","medianAge":"14"}},"title":"Veterinarians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"85","women":"54.7","white":"1.9","black":"1.3","asian":"6.1"}},"wageData":{"2012":{"workers":"49","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"29","femaleMedian":"-"}}},"Registered nurses":{"ageData":{"2012":{"total":"2,875","16to19":"1","20to24":"104","25to34":"655","35to44":"695","45to54":"699","55to64":"626","65+":"95","medianAge":"626"}},"title":"Registered nurses","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"2,875","women":"90.6","white":"11.5","black":"7.3","asian":"6.2"}},"wageData":{"2012":{"workers":"2,176","median":"1,097","maleWorkers":"230","maleMedian":"1,189","femaleWorkers":"1,946","femaleMedian":"1,086"}}},"Nurse anesthetists":{"ageData":{"2012":{"total":"27","16to19":"0","20to24":"0","25to34":"1","35to44":"9","45to54":"8","55to64":"9","65+":"0","medianAge":"9"}},"title":"Nurse anesthetists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"27","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"24","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Nurse midwives":{"ageData":{"2012":{"total":"3","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"0","55to64":"2","65+":"0","medianAge":"2"}},"title":"Nurse midwives","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"2","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Nurse practitioners":{"ageData":{"2012":{"total":"103","16to19":"0","20to24":"0","25to34":"15","35to44":"38","45to54":"26","55to64":"23","65+":"2","medianAge":"23"}},"title":"Nurse practitioners","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"103","women":"86.1","white":"4.5","black":"4.6","asian":"2.9"}},"wageData":{"2012":{"workers":"77","median":"1,610","maleWorkers":"12","maleMedian":"-","femaleWorkers":"65","femaleMedian":"1,530"}}},"Health diagnosing and treating practitioners, all other":{"ageData":{"2012":{"total":"23","16to19":"0","20to24":"0","25to34":"3","35to44":"3","45to54":"9","55to64":"7","65+":"1","medianAge":"7"}},"title":"Health diagnosing and treating practitioners, all other","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"23","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Clinical laboratory technologists and technicians":{"ageData":{"2012":{"total":"319","16to19":"1","20to24":"17","25to34":"81","35to44":"62","45to54":"86","55to64":"57","65+":"15","medianAge":"57"}},"title":"Clinical laboratory technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"319","women":"72.8","white":"13.5","black":"14.0","asian":"10.7"}},"wageData":{"2012":{"workers":"256","median":"869","maleWorkers":"76","maleMedian":"943","femaleWorkers":"180","femaleMedian":"842"}}},"Dental hygienists":{"ageData":{"2012":{"total":"163","16to19":"0","20to24":"8","25to34":"47","35to44":"42","45to54":"38","55to64":"25","65+":"2","medianAge":"25"}},"title":"Dental hygienists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"163","women":"99.3","white":"3.3","black":"5.6","asian":"8.1"}},"wageData":{"2012":{"workers":"51","median":"1,045","maleWorkers":"0","maleMedian":"-","femaleWorkers":"50","femaleMedian":"1,047"}}},"Diagnostic related technologists and technicians":{"ageData":{"2012":{"total":"308","16to19":"2","20to24":"14","25to34":"80","35to44":"89","45to54":"64","55to64":"52","65+":"6","medianAge":"52"}},"title":"Diagnostic related technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"308","women":"74.5","white":"9.0","black":"4.1","asian":"7.8"}},"wageData":{"2012":{"workers":"241","median":"961","maleWorkers":"67","maleMedian":"1,131","femaleWorkers":"174","femaleMedian":"912"}}},"Emergency medical technicians and paramedics":{"ageData":{"2012":{"total":"172","16to19":"5","20to24":"17","25to34":"73","35to44":"40","45to54":"25","55to64":"10","65+":"1","medianAge":"10"}},"title":"Emergency medical technicians and paramedics","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"172","women":"31.2","white":"5.0","black":"1.6","asian":"8.1"}},"wageData":{"2012":{"workers":"145","median":"780","maleWorkers":"100","maleMedian":"809","femaleWorkers":"44","femaleMedian":"-"}}},"Health practitioner support technologists and technicians":{"ageData":{"2012":{"total":"544","16to19":"9","20to24":"96","25to34":"179","35to44":"106","45to54":"90","55to64":"50","65+":"14","medianAge":"50"}},"title":"Health practitioner support technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"544","women":"83.6","white":"15.8","black":"5.9","asian":"12.2"}},"wageData":{"2012":{"workers":"403","median":"615","maleWorkers":"82","maleMedian":"599","femaleWorkers":"322","femaleMedian":"621"}}},"Licensed practical and licensed vocational nurses":{"ageData":{"2012":{"total":"531","16to19":"3","20to24":"25","25to34":"127","35to44":"133","45to54":"140","55to64":"85","65+":"18","medianAge":"85"}},"title":"Licensed practical and licensed vocational nurses","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"531","women":"94.2","white":"23.3","black":"5.1","asian":"9.4"}},"wageData":{"2012":{"workers":"433","median":"731","maleWorkers":"33","maleMedian":"-","femaleWorkers":"400","femaleMedian":"730"}}},"Medical records and health information technicians":{"ageData":{"2012":{"total":"90","16to19":"1","20to24":"4","25to34":"19","35to44":"17","45to54":"25","55to64":"19","65+":"4","medianAge":"19"}},"title":"Medical records and health information technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"90","women":"89.3","white":"17.1","black":"4.3","asian":"15.6"}},"wageData":{"2012":{"workers":"74","median":"618","maleWorkers":"9","maleMedian":"-","femaleWorkers":"65","femaleMedian":"663"}}},"Opticians, dispensing":{"ageData":{"2012":{"total":"54","16to19":"0","20to24":"7","25to34":"7","35to44":"10","45to54":"12","55to64":"17","65+":"2","medianAge":"17"}},"title":"Opticians, dispensing","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"54","women":"59.6","white":"8.2","black":"3.8","asian":"4.1"}},"wageData":{"2012":{"workers":"41","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"24","femaleMedian":"-"}}},"Miscellaneous health technologists and technicians":{"ageData":{"2012":{"total":"140","16to19":"2","20to24":"10","25to34":"31","35to44":"33","45to54":"31","55to64":"26","65+":"7","medianAge":"26"}},"title":"Miscellaneous health technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"140","women":"60.2","white":"18.7","black":"11.0","asian":"10.0"}},"wageData":{"2012":{"workers":"113","median":"772","maleWorkers":"42","maleMedian":"-","femaleWorkers":"71","femaleMedian":"714"}}},"Other healthcare practitioners and technical occupations":{"ageData":{"2012":{"total":"75","16to19":"1","20to24":"6","25to34":"19","35to44":"17","45to54":"9","55to64":"19","65+":"3","medianAge":"19"}},"title":"Other healthcare practitioners and technical occupations","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2012":{"total":"75","women":"50.3","white":"8.8","black":"3.1","asian":"5.6"}},"wageData":{"2012":{"workers":"69","median":"900","maleWorkers":"36","maleMedian":"-","femaleWorkers":"34","femaleMedian":"-"}}},"Service occupations":{"ageData":{"2012":{"total":"25,459","16to19":"1,812","20to24":"3,917","25to34":"5,658","35to44":"4,800","45to54":"4,949","55to64":"3,190","65+":"1,133","medianAge":"3,190"}},"title":"Service occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2012":{"total":"25,459","women":"56.3","white":"15.9","black":"5.6","asian":"22.6"}},"wageData":{"2012":{"workers":"14,839","median":"485","maleWorkers":"7,511","maleMedian":"543","femaleWorkers":"7,328","femaleMedian":"435"}}},"Healthcare support occupations":{"ageData":{"2012":{"total":"3,496","16to19":"69","20to24":"528","25to34":"911","35to44":"667","45to54":"710","55to64":"478","65+":"133","medianAge":"478"}},"title":"Healthcare support occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2012":{"total":"3,496","women":"87.6","white":"26.5","black":"4.5","asian":"15.3"}},"wageData":{"2012":{"workers":"2,350","median":"482","maleWorkers":"290","maleMedian":"529","femaleWorkers":"2,060","femaleMedian":"477"}}},"Nursing, psychiatric, and home health aides":{"ageData":{"2012":{"total":"2,119","16to19":"41","20to24":"311","25to34":"489","35to44":"393","45to54":"463","55to64":"323","65+":"98","medianAge":"323"}},"title":"Nursing, psychiatric, and home health aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2012":{"total":"2,119","women":"87.9","white":"34.5","black":"4.6","asian":"14.2"}},"wageData":{"2012":{"workers":"1,458","median":"451","maleWorkers":"173","maleMedian":"508","femaleWorkers":"1,285","femaleMedian":"445"}}},"Occupational therapy assistants and aides":{"ageData":{"2012":{"total":"18","16to19":"0","20to24":"4","25to34":"9","35to44":"2","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Occupational therapy assistants and aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2012":{"total":"18","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"11","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Physical therapist assistants and aides":{"ageData":{"2012":{"total":"66","16to19":"0","20to24":"14","25to34":"20","35to44":"14","45to54":"9","55to64":"7","65+":"2","medianAge":"7"}},"title":"Physical therapist assistants and aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2012":{"total":"66","women":"66.4","white":"14.7","black":"3.6","asian":"5.6"}},"wageData":{"2012":{"workers":"45","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"26","femaleMedian":"-"}}},"Massage therapists":{"ageData":{"2012":{"total":"158","16to19":"1","20to24":"17","25to34":"46","35to44":"32","45to54":"27","55to64":"25","65+":"9","medianAge":"25"}},"title":"Massage therapists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2012":{"total":"158","women":"81.5","white":"5.4","black":"7.7","asian":"12.0"}},"wageData":{"2012":{"workers":"42","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"32","femaleMedian":"-"}}},"Dental assistants":{"ageData":{"2012":{"total":"274","16to19":"5","20to24":"39","25to34":"87","35to44":"61","45to54":"51","55to64":"26","65+":"4","medianAge":"26"}},"title":"Dental assistants","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2012":{"total":"274","women":"97.9","white":"9.6","black":"3.6","asian":"21.2"}},"wageData":{"2012":{"workers":"174","median":"579","maleWorkers":"2","maleMedian":"-","femaleWorkers":"172","femaleMedian":"581"}}},"Medical assistants":{"ageData":{"2012":{"total":"429","16to19":"3","20to24":"67","25to34":"163","35to44":"96","45to54":"59","55to64":"36","65+":"5","medianAge":"36"}},"title":"Medical assistants","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2012":{"total":"429","women":"93.8","white":"15.0","black":"3.8","asian":"22.9"}},"wageData":{"2012":{"workers":"323","median":"514","maleWorkers":"21","maleMedian":"-","femaleWorkers":"302","femaleMedian":"515"}}},"Medical transcriptionists":{"ageData":{"2012":{"total":"55","16to19":"0","20to24":"2","25to34":"6","35to44":"10","45to54":"20","55to64":"13","65+":"5","medianAge":"13"}},"title":"Medical transcriptionists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2012":{"total":"55","women":"98.2","white":"7.0","black":"0.3","asian":"4.0"}},"wageData":{"2012":{"workers":"30","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"29","femaleMedian":"-"}}},"Pharmacy aides":{"ageData":{"2012":{"total":"45","16to19":"1","20to24":"13","25to34":"11","35to44":"7","45to54":"4","55to64":"9","65+":"0","medianAge":"9"}},"title":"Pharmacy aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2012":{"total":"45","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"30","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Veterinary assistants and laboratory animal caretakers":{"ageData":{"2012":{"total":"47","16to19":"4","20to24":"14","25to34":"14","35to44":"6","45to54":"3","55to64":"6","65+":"0","medianAge":"6"}},"title":"Veterinary assistants and laboratory animal caretakers","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2012":{"total":"47","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"22","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"15","femaleMedian":"-"}}},"Phlebotomists":{"ageData":{"2012":{"total":"119","16to19":"1","20to24":"14","25to34":"38","35to44":"21","45to54":"32","55to64":"10","65+":"3","medianAge":"10"}},"title":"Phlebotomists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2012":{"total":"119","women":"80.2","white":"26.5","black":"4.8","asian":"15.7"}},"wageData":{"2012":{"workers":"101","median":"520","maleWorkers":"19","maleMedian":"-","femaleWorkers":"82","femaleMedian":"516"}}},"Miscellaneous healthcare support occupations, including medical equipment preparers":{"ageData":{"2012":{"total":"166","16to19":"13","20to24":"32","25to34":"27","35to44":"26","45to54":"40","55to64":"22","65+":"7","medianAge":"22"}},"title":"Miscellaneous healthcare support occupations, including medical equipment preparers","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2012":{"total":"166","women":"69.0","white":"21.9","black":"4.0","asian":"9.9"}},"wageData":{"2012":{"workers":"112","median":"487","maleWorkers":"35","maleMedian":"-","femaleWorkers":"77","femaleMedian":"462"}}},"Protective service occupations":{"ageData":{"2012":{"total":"3,096","16to19":"92","20to24":"231","25to34":"754","35to44":"792","45to54":"684","55to64":"402","65+":"140","medianAge":"402"}},"title":"Protective service occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2012":{"total":"3,096","women":"20.9","white":"17.2","black":"2.7","asian":"13.7"}},"wageData":{"2012":{"workers":"2,655","median":"791","maleWorkers":"2,154","maleMedian":"841","femaleWorkers":"500","femaleMedian":"658"}}},"First-line supervisors of correctional officers":{"ageData":{"2012":{"total":"46","16to19":"0","20to24":"0","25to34":"8","35to44":"13","45to54":"17","55to64":"5","65+":"3","medianAge":"5"}},"title":"First-line supervisors of correctional officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2012":{"total":"46","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"51","median":"820","maleWorkers":"33","maleMedian":"-","femaleWorkers":"17","femaleMedian":"-"}}},"First-line supervisors of police and detectives":{"ageData":{"2012":{"total":"112","16to19":"0","20to24":"0","25to34":"8","35to44":"41","45to54":"44","55to64":"17","65+":"3","medianAge":"17"}},"title":"First-line supervisors of police and detectives","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2012":{"total":"112","women":"15.2","white":"9.2","black":"4.4","asian":"10.6"}},"wageData":{"2012":{"workers":"105","median":"1,216","maleWorkers":"89","maleMedian":"1,240","femaleWorkers":"16","femaleMedian":"-"}}},"First-line supervisors of fire fighting and prevention workers":{"ageData":{"2012":{"total":"64","16to19":"0","20to24":"0","25to34":"6","35to44":"21","45to54":"23","55to64":"15","65+":"0","medianAge":"15"}},"title":"First-line supervisors of fire fighting and prevention workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2012":{"total":"64","women":"0.5","white":"10.7","black":"0.0","asian":"6.6"}},"wageData":{"2012":{"workers":"59","median":"1,271","maleWorkers":"59","maleMedian":"1,272","femaleWorkers":"0","femaleMedian":"-"}}},"First-line supervisors of protective service workers, all other":{"ageData":{"2012":{"total":"93","16to19":"0","20to24":"2","25to34":"13","35to44":"24","45to54":"23","55to64":"24","65+":"8","medianAge":"24"}},"title":"First-line supervisors of protective service workers, all other","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2012":{"total":"93","women":"29.9","white":"17.4","black":"0.4","asian":"12.5"}},"wageData":{"2012":{"workers":"80","median":"881","maleWorkers":"54","maleMedian":"806","femaleWorkers":"26","femaleMedian":"-"}}},"Firefighters":{"ageData":{"2012":{"total":"295","16to19":"0","20to24":"21","25to34":"97","35to44":"97","45to54":"59","55to64":"20","65+":"1","medianAge":"20"}},"title":"Firefighters","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2012":{"total":"295","women":"3.4","white":"7.7","black":"1.1","asian":"9.9"}},"wageData":{"2012":{"workers":"276","median":"1,068","maleWorkers":"268","maleMedian":"1,073","femaleWorkers":"8","femaleMedian":"-"}}},"Fire inspectors":{"ageData":{"2012":{"total":"18","16to19":"0","20to24":"2","25to34":"4","35to44":"4","45to54":"6","55to64":"3","65+":"0","medianAge":"3"}},"title":"Fire inspectors","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2012":{"total":"18","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"15","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Bailiffs, correctional officers, and jailers":{"ageData":{"2012":{"total":"371","16to19":"5","20to24":"22","25to34":"95","35to44":"124","45to54":"89","55to64":"32","65+":"4","medianAge":"32"}},"title":"Bailiffs, correctional officers, and jailers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2012":{"total":"371","women":"28.0","white":"22.7","black":"1.1","asian":"18.3"}},"wageData":{"2012":{"workers":"363","median":"722","maleWorkers":"261","maleMedian":"768","femaleWorkers":"102","femaleMedian":"643"}}},"Detectives and criminal investigators":{"ageData":{"2012":{"total":"160","16to19":"0","20to24":"1","25to34":"30","35to44":"56","45to54":"47","55to64":"20","65+":"5","medianAge":"20"}},"title":"Detectives and criminal investigators","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2012":{"total":"160","women":"24.8","white":"9.8","black":"3.5","asian":"10.4"}},"wageData":{"2012":{"workers":"151","median":"1,062","maleWorkers":"114","maleMedian":"1,171","femaleWorkers":"37","femaleMedian":"-"}}},"Fish and game wardens":{"ageData":{"2012":{"total":"7","16to19":"0","20to24":"0","25to34":"1","35to44":"3","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Fish and game wardens","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2012":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"5","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Parking enforcement workers":{"ageData":{"2012":{"total":"4","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Parking enforcement workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2012":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"3","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Police and sheriff\'s patrol officers":{"ageData":{"2012":{"total":"657","16to19":"2","20to24":"25","25to34":"200","35to44":"216","45to54":"148","55to64":"53","65+":"14","medianAge":"53"}},"title":"Police and sheriff\'s patrol officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2012":{"total":"657","women":"12.6","white":"12.8","black":"3.1","asian":"13.8"}},"wageData":{"2012":{"workers":"629","median":"979","maleWorkers":"554","maleMedian":"1,016","femaleWorkers":"76","femaleMedian":"815"}}},"Transit and railroad police":{"ageData":{"2012":{"total":"3","16to19":"0","20to24":"0","25to34":"0","35to44":"2","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Transit and railroad police","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2012":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Animal control workers":{"ageData":{"2012":{"total":"11","16to19":"0","20to24":"0","25to34":"5","35to44":"2","45to54":"2","55to64":"1","65+":"1","medianAge":"1"}},"title":"Animal control workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2012":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"8","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Private detectives and investigators":{"ageData":{"2012":{"total":"103","16to19":"1","20to24":"5","25to34":"25","35to44":"25","45to54":"23","55to64":"17","65+":"7","medianAge":"17"}},"title":"Private detectives and investigators","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2012":{"total":"103","women":"44.0","white":"8.0","black":"2.2","asian":"11.1"}},"wageData":{"2012":{"workers":"76","median":"848","maleWorkers":"42","maleMedian":"-","femaleWorkers":"34","femaleMedian":"-"}}},"Security guards and gaming surveillance officers":{"ageData":{"2012":{"total":"903","16to19":"16","20to24":"114","25to34":"231","35to44":"146","45to54":"163","55to64":"163","65+":"70","medianAge":"163"}},"title":"Security guards and gaming surveillance officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2012":{"total":"903","women":"18.5","white":"26.6","black":"4.1","asian":"15.8"}},"wageData":{"2012":{"workers":"742","median":"528","maleWorkers":"603","maleMedian":"537","femaleWorkers":"138","femaleMedian":"501"}}},"Crossing guards":{"ageData":{"2012":{"total":"61","16to19":"1","20to24":"3","25to34":"7","35to44":"6","45to54":"17","55to64":"14","65+":"14","medianAge":"14"}},"title":"Crossing guards","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2012":{"total":"61","women":"55.3","white":"19.7","black":"1.8","asian":"16.1"}},"wageData":{"2012":{"workers":"17","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Transportation security screeners":{"ageData":{"2012":{"total":"25","16to19":"0","20to24":"2","25to34":"8","35to44":"6","45to54":"7","55to64":"1","65+":"0","medianAge":"1"}},"title":"Transportation security screeners","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2012":{"total":"25","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"18","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Lifeguards and other recreational, and all other protective service workers":{"ageData":{"2012":{"total":"162","16to19":"67","20to24":"35","25to34":"15","35to44":"6","45to54":"13","55to64":"16","65+":"10","medianAge":"16"}},"title":"Lifeguards and other recreational, and all other protective service workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2012":{"total":"162","women":"52.6","white":"7.8","black":"1.2","asian":"9.2"}},"wageData":{"2012":{"workers":"55","median":"472","maleWorkers":"32","maleMedian":"-","femaleWorkers":"24","femaleMedian":"-"}}},"Food preparation and serving related occupations":{"ageData":{"2012":{"total":"8,018","16to19":"1,143","20to24":"1,939","25to34":"1,896","35to44":"1,151","45to54":"1,077","55to64":"609","65+":"203","medianAge":"609"}},"title":"Food preparation and serving related occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2012":{"total":"8,018","women":"54.5","white":"12.1","black":"6.2","asian":"23.8"}},"wageData":{"2012":{"workers":"4,164","median":"410","maleWorkers":"2,189","maleMedian":"433","femaleWorkers":"1,975","femaleMedian":"389"}}},"Chefs and head cooks":{"ageData":{"2012":{"total":"403","16to19":"7","20to24":"45","25to34":"125","35to44":"96","45to54":"77","55to64":"48","65+":"6","medianAge":"48"}},"title":"Chefs and head cooks","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2012":{"total":"403","women":"21.5","white":"11.9","black":"14.2","asian":"18.6"}},"wageData":{"2012":{"workers":"318","median":"562","maleWorkers":"261","maleMedian":"582","femaleWorkers":"56","femaleMedian":"462"}}},"First-line supervisors of food preparation and serving workers":{"ageData":{"2012":{"total":"552","16to19":"23","20to24":"113","25to34":"149","35to44":"103","45to54":"93","55to64":"57","65+":"14","medianAge":"57"}},"title":"First-line supervisors of food preparation and serving workers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2012":{"total":"552","women":"59.3","white":"13.9","black":"4.0","asian":"17.2"}},"wageData":{"2012":{"workers":"415","median":"491","maleWorkers":"170","maleMedian":"561","femaleWorkers":"245","femaleMedian":"451"}}},"Cooks":{"ageData":{"2012":{"total":"1,970","16to19":"202","20to24":"358","25to34":"506","35to44":"349","45to54":"313","55to64":"178","65+":"63","medianAge":"178"}},"title":"Cooks","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2012":{"total":"1,970","women":"37.7","white":"16.6","black":"6.0","asian":"31.7"}},"wageData":{"2012":{"workers":"1,240","median":"389","maleWorkers":"833","maleMedian":"403","femaleWorkers":"408","femaleMedian":"361"}}},"Food preparation workers":{"ageData":{"2012":{"total":"868","16to19":"144","20to24":"233","25to34":"178","35to44":"100","45to54":"110","55to64":"80","65+":"22","medianAge":"80"}},"title":"Food preparation workers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2012":{"total":"868","women":"58.0","white":"12.1","black":"5.7","asian":"27.5"}},"wageData":{"2012":{"workers":"432","median":"383","maleWorkers":"191","maleMedian":"408","femaleWorkers":"241","femaleMedian":"357"}}},"Bartenders":{"ageData":{"2012":{"total":"412","16to19":"5","20to24":"82","25to34":"148","35to44":"66","45to54":"69","55to64":"30","65+":"12","medianAge":"30"}},"title":"Bartenders","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2012":{"total":"412","women":"59.9","white":"5.2","black":"3.5","asian":"13.2"}},"wageData":{"2012":{"workers":"209","median":"460","maleWorkers":"97","maleMedian":"520","femaleWorkers":"112","femaleMedian":"421"}}},"Combined food preparation and serving workers, including fast food":{"ageData":{"2012":{"total":"343","16to19":"57","20to24":"89","25to34":"55","35to44":"44","45to54":"56","55to64":"32","65+":"11","medianAge":"32"}},"title":"Combined food preparation and serving workers, including fast food","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2012":{"total":"343","women":"64.9","white":"14.1","black":"3.1","asian":"18.0"}},"wageData":{"2012":{"workers":"166","median":"382","maleWorkers":"57","maleMedian":"406","femaleWorkers":"109","femaleMedian":"368"}}},"Counter attendants, cafeteria, food concession, and coffee shop":{"ageData":{"2012":{"total":"233","16to19":"109","20to24":"62","25to34":"21","35to44":"17","45to54":"14","55to64":"7","65+":"3","medianAge":"7"}},"title":"Counter attendants, cafeteria, food concession, and coffee shop","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2012":{"total":"233","women":"70.8","white":"10.9","black":"4.8","asian":"16.6"}},"wageData":{"2012":{"workers":"56","median":"350","maleWorkers":"17","maleMedian":"-","femaleWorkers":"40","femaleMedian":"-"}}},"Waiters and waitresses":{"ageData":{"2012":{"total":"2,124","16to19":"307","20to24":"697","25to34":"544","35to44":"250","45to54":"212","55to64":"87","65+":"28","medianAge":"87"}},"title":"Waiters and waitresses","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2012":{"total":"2,124","women":"71.2","white":"7.9","black":"7.1","asian":"19.6"}},"wageData":{"2012":{"workers":"891","median":"411","maleWorkers":"322","maleMedian":"456","femaleWorkers":"569","femaleMedian":"396"}}},"Food servers, nonrestaurant":{"ageData":{"2012":{"total":"217","16to19":"28","20to24":"48","25to34":"38","35to44":"32","45to54":"37","55to64":"24","65+":"10","medianAge":"24"}},"title":"Food servers, nonrestaurant","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2012":{"total":"217","women":"64.9","white":"22.2","black":"6.4","asian":"20.1"}},"wageData":{"2012":{"workers":"112","median":"456","maleWorkers":"49","maleMedian":"-","femaleWorkers":"63","femaleMedian":"434"}}},"Dining room and cafeteria attendants and bartender helpers":{"ageData":{"2012":{"total":"359","16to19":"94","20to24":"76","25to34":"52","35to44":"40","45to54":"47","55to64":"30","65+":"20","medianAge":"30"}},"title":"Dining room and cafeteria attendants and bartender helpers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2012":{"total":"359","women":"43.4","white":"10.0","black":"5.5","asian":"31.7"}},"wageData":{"2012":{"workers":"137","median":"370","maleWorkers":"70","maleMedian":"374","femaleWorkers":"67","femaleMedian":"366"}}},"Dishwashers":{"ageData":{"2012":{"total":"271","16to19":"56","20to24":"52","25to34":"57","35to44":"40","45to54":"35","55to64":"23","65+":"8","medianAge":"23"}},"title":"Dishwashers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2012":{"total":"271","women":"18.7","white":"12.9","black":"5.5","asian":"40.5"}},"wageData":{"2012":{"workers":"127","median":"345","maleWorkers":"106","maleMedian":"337","femaleWorkers":"21","femaleMedian":"-"}}},"Hosts and hostesses, restaurant, lounge, and coffee shop":{"ageData":{"2012":{"total":"260","16to19":"111","20to24":"81","25to34":"23","35to44":"12","45to54":"13","55to64":"13","65+":"7","medianAge":"13"}},"title":"Hosts and hostesses, restaurant, lounge, and coffee shop","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2012":{"total":"260","women":"81.5","white":"10.2","black":"5.4","asian":"14.8"}},"wageData":{"2012":{"workers":"59","median":"391","maleWorkers":"15","maleMedian":"-","femaleWorkers":"44","femaleMedian":"-"}}},"Food preparation and serving related workers, all other":{"ageData":{"2012":{"total":"6","16to19":"1","20to24":"3","25to34":"0","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Food preparation and serving related workers, all other","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2012":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Building and grounds cleaning and maintenance occupations":{"ageData":{"2012":{"total":"5,591","16to19":"196","20to24":"481","25to34":"990","35to44":"1,185","45to54":"1,431","55to64":"970","65+":"338","medianAge":"970"}},"title":"Building and grounds cleaning and maintenance occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2012":{"total":"5,591","women":"38.6","white":"15.0","black":"3.3","asian":"36.1"}},"wageData":{"2012":{"workers":"3,430","median":"465","maleWorkers":"2,275","maleMedian":"501","femaleWorkers":"1,156","femaleMedian":"407"}}},"First-line supervisors of housekeeping and janitorial workers":{"ageData":{"2012":{"total":"277","16to19":"3","20to24":"8","25to34":"39","35to44":"56","45to54":"92","55to64":"65","65+":"14","medianAge":"65"}},"title":"First-line supervisors of housekeeping and janitorial workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2012":{"total":"277","women":"47.1","white":"16.9","black":"3.3","asian":"21.7"}},"wageData":{"2012":{"workers":"159","median":"569","maleWorkers":"88","maleMedian":"687","femaleWorkers":"72","femaleMedian":"505"}}},"First-line supervisors of landscaping, lawn service, and groundskeeping workers":{"ageData":{"2012":{"total":"281","16to19":"3","20to24":"7","25to34":"48","35to44":"83","45to54":"68","55to64":"57","65+":"15","medianAge":"57"}},"title":"First-line supervisors of landscaping, lawn service, and groundskeeping workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2012":{"total":"281","women":"7.6","white":"6.6","black":"1.1","asian":"19.8"}},"wageData":{"2012":{"workers":"109","median":"745","maleWorkers":"105","maleMedian":"748","femaleWorkers":"4","femaleMedian":"-"}}},"Janitors and building cleaners":{"ageData":{"2012":{"total":"2,205","16to19":"80","20to24":"182","25to34":"334","35to44":"394","45to54":"585","55to64":"454","65+":"176","medianAge":"454"}},"title":"Janitors and building cleaners","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2012":{"total":"2,205","women":"29.7","white":"18.4","black":"3.6","asian":"30.9"}},"wageData":{"2012":{"workers":"1,514","median":"484","maleWorkers":"1,134","maleMedian":"511","femaleWorkers":"380","femaleMedian":"408"}}},"Maids and housekeeping cleaners":{"ageData":{"2012":{"total":"1,457","16to19":"32","20to24":"108","25to34":"249","35to44":"354","45to54":"391","55to64":"242","65+":"81","medianAge":"242"}},"title":"Maids and housekeeping cleaners","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2012":{"total":"1,457","women":"88.1","white":"17.2","black":"4.8","asian":"43.3"}},"wageData":{"2012":{"workers":"791","median":"399","maleWorkers":"123","maleMedian":"425","femaleWorkers":"668","femaleMedian":"395"}}},"Pest control workers":{"ageData":{"2012":{"total":"73","16to19":"1","20to24":"4","25to34":"16","35to44":"18","45to54":"21","55to64":"10","65+":"4","medianAge":"10"}},"title":"Pest control workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2012":{"total":"73","women":"4.7","white":"7.7","black":"0.1","asian":"20.4"}},"wageData":{"2012":{"workers":"62","median":"571","maleWorkers":"59","maleMedian":"570","femaleWorkers":"3","femaleMedian":"-"}}},"Grounds maintenance workers":{"ageData":{"2012":{"total":"1,298","16to19":"77","20to24":"171","25to34":"303","35to44":"280","45to54":"275","55to64":"143","65+":"48","medianAge":"143"}},"title":"Grounds maintenance workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2012":{"total":"1,298","women":"5.1","white":"8.7","black":"1.7","asian":"44.4"}},"wageData":{"2012":{"workers":"795","median":"455","maleWorkers":"766","maleMedian":"452","femaleWorkers":"29","femaleMedian":"-"}}},"Personal care and service occupations":{"ageData":{"2012":{"total":"5,258","16to19":"312","20to24":"738","25to34":"1,107","35to44":"1,004","45to54":"1,047","55to64":"731","65+":"319","medianAge":"731"}},"title":"Personal care and service occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2012":{"total":"5,258","women":"77.7","white":"14.7","black":"9.5","asian":"16.4"}},"wageData":{"2012":{"workers":"2,241","median":"468","maleWorkers":"603","maleMedian":"569","femaleWorkers":"1,637","femaleMedian":"428"}}},"First-line supervisors of gaming workers":{"ageData":{"2012":{"total":"146","16to19":"1","20to24":"16","25to34":"29","35to44":"37","45to54":"37","55to64":"21","65+":"4","medianAge":"21"}},"title":"First-line supervisors of gaming workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2012":{"total":"146","women":"43.0","white":"5.2","black":"9.2","asian":"10.1"}},"wageData":{"2012":{"workers":"92","median":"752","maleWorkers":"59","maleMedian":"864","femaleWorkers":"34","femaleMedian":"-"}}},"First-line supervisors of personal service workers":{"ageData":{"2012":{"total":"246","16to19":"1","20to24":"13","25to34":"49","35to44":"75","45to54":"63","55to64":"34","65+":"11","medianAge":"34"}},"title":"First-line supervisors of personal service workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2012":{"total":"246","women":"70.3","white":"10.7","black":"19.8","asian":"9.3"}},"wageData":{"2012":{"workers":"83","median":"600","maleWorkers":"30","maleMedian":"-","femaleWorkers":"53","femaleMedian":"518"}}},"Animal trainers":{"ageData":{"2012":{"total":"44","16to19":"1","20to24":"9","25to34":"9","35to44":"8","45to54":"12","55to64":"3","65+":"3","medianAge":"3"}},"title":"Animal trainers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2012":{"total":"44","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"11","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Nonfarm animal caretakers":{"ageData":{"2012":{"total":"179","16to19":"16","20to24":"50","25to34":"33","35to44":"25","45to54":"29","55to64":"21","65+":"5","medianAge":"21"}},"title":"Nonfarm animal caretakers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2012":{"total":"179","women":"74.2","white":"4.3","black":"1.8","asian":"12.2"}},"wageData":{"2012":{"workers":"78","median":"414","maleWorkers":"21","maleMedian":"-","femaleWorkers":"57","femaleMedian":"417"}}},"Gaming services workers":{"ageData":{"2012":{"total":"106","16to19":"2","20to24":"8","25to34":"25","35to44":"28","45to54":"22","55to64":"15","65+":"6","medianAge":"15"}},"title":"Gaming services workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2012":{"total":"106","women":"51.0","white":"9.4","black":"24.3","asian":"13.5"}},"wageData":{"2012":{"workers":"74","median":"604","maleWorkers":"36","maleMedian":"-","femaleWorkers":"38","femaleMedian":"-"}}},"Motion picture projectionists":{"ageData":{"2012":{"total":"2","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Motion picture projectionists","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2012":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Ushers, lobby attendants, and ticket takers":{"ageData":{"2012":{"total":"43","16to19":"14","20to24":"17","25to34":"5","35to44":"2","45to54":"1","55to64":"3","65+":"2","medianAge":"3"}},"title":"Ushers, lobby attendants, and ticket takers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2012":{"total":"43","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"10","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Miscellaneous entertainment attendants and related workers":{"ageData":{"2012":{"total":"180","16to19":"45","20to24":"45","25to34":"25","35to44":"16","45to54":"18","55to64":"16","65+":"14","medianAge":"16"}},"title":"Miscellaneous entertainment attendants and related workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2012":{"total":"180","women":"45.4","white":"14.0","black":"5.1","asian":"17.6"}},"wageData":{"2012":{"workers":"61","median":"470","maleWorkers":"35","maleMedian":"-","femaleWorkers":"26","femaleMedian":"-"}}},"Embalmers and funeral attendants":{"ageData":{"2012":{"total":"16","16to19":"1","20to24":"0","25to34":"1","35to44":"3","45to54":"4","55to64":"1","65+":"6","medianAge":"1"}},"title":"Embalmers and funeral attendants","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2012":{"total":"16","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"8","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Morticians, undertakers, and funeral directors":{"ageData":{"2012":{"total":"38","16to19":"0","20to24":"2","25to34":"11","35to44":"4","45to54":"7","55to64":"10","65+":"4","medianAge":"10"}},"title":"Morticians, undertakers, and funeral directors","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2012":{"total":"38","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"23","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Barbers":{"ageData":{"2012":{"total":"109","16to19":"2","20to24":"6","25to34":"34","35to44":"22","45to54":"17","55to64":"14","65+":"14","medianAge":"14"}},"title":"Barbers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2012":{"total":"109","women":"21.9","white":"38.2","black":"2.5","asian":"24.1"}},"wageData":{"2012":{"workers":"57","median":"466","maleWorkers":"42","maleMedian":"-","femaleWorkers":"15","femaleMedian":"-"}}},"Hairdressers, hairstylists, and cosmetologists":{"ageData":{"2012":{"total":"785","16to19":"12","20to24":"79","25to34":"209","35to44":"170","45to54":"159","55to64":"111","65+":"46","medianAge":"111"}},"title":"Hairdressers, hairstylists, and cosmetologists","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2012":{"total":"785","women":"92.8","white":"13.2","black":"6.5","asian":"15.0"}},"wageData":{"2012":{"workers":"294","median":"473","maleWorkers":"22","maleMedian":"-","femaleWorkers":"272","femaleMedian":"468"}}},"Miscellaneous personal appearance workers":{"ageData":{"2012":{"total":"300","16to19":"4","20to24":"17","25to34":"80","35to44":"96","45to54":"61","55to64":"35","65+":"8","medianAge":"35"}},"title":"Miscellaneous personal appearance workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2012":{"total":"300","women":"81.5","white":"5.3","black":"59.6","asian":"9.5"}},"wageData":{"2012":{"workers":"154","median":"427","maleWorkers":"31","maleMedian":"-","femaleWorkers":"123","femaleMedian":"430"}}},"Baggage porters, bellhops, and concierges":{"ageData":{"2012":{"total":"68","16to19":"1","20to24":"7","25to34":"15","35to44":"10","45to54":"19","55to64":"8","65+":"7","medianAge":"8"}},"title":"Baggage porters, bellhops, and concierges","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2012":{"total":"68","women":"25.0","white":"20.8","black":"13.1","asian":"18.0"}},"wageData":{"2012":{"workers":"49","median":"-","maleWorkers":"41","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Tour and travel guides":{"ageData":{"2012":{"total":"51","16to19":"3","20to24":"14","25to34":"9","35to44":"6","45to54":"6","55to64":"6","65+":"8","medianAge":"6"}},"title":"Tour and travel guides","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2012":{"total":"51","women":"36.9","white":"3.6","black":"7.1","asian":"15.1"}},"wageData":{"2012":{"workers":"20","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Childcare workers":{"ageData":{"2012":{"total":"1,314","16to19":"139","20to24":"221","25to34":"242","35to44":"214","45to54":"258","55to64":"166","65+":"74","medianAge":"166"}},"title":"Childcare workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2012":{"total":"1,314","women":"94.1","white":"15.3","black":"3.3","asian":"20.3"}},"wageData":{"2012":{"workers":"425","median":"390","maleWorkers":"31","maleMedian":"-","femaleWorkers":"395","femaleMedian":"386"}}},"Personal care aides":{"ageData":{"2012":{"total":"1,071","16to19":"29","20to24":"129","25to34":"200","35to44":"185","45to54":"253","55to64":"192","65+":"84","medianAge":"192"}},"title":"Personal care aides","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2012":{"total":"1,071","women":"84.7","white":"21.8","black":"7.9","asian":"21.2"}},"wageData":{"2012":{"workers":"549","median":"422","maleWorkers":"99","maleMedian":"465","femaleWorkers":"450","femaleMedian":"412"}}},"Recreation and fitness workers":{"ageData":{"2012":{"total":"406","16to19":"33","20to24":"69","25to34":"100","35to44":"75","45to54":"57","55to64":"56","65+":"15","medianAge":"56"}},"title":"Recreation and fitness workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2012":{"total":"406","women":"66.5","white":"10.0","black":"4.5","asian":"9.7"}},"wageData":{"2012":{"workers":"174","median":"575","maleWorkers":"71","maleMedian":"675","femaleWorkers":"102","femaleMedian":"542"}}},"Residential advisors":{"ageData":{"2012":{"total":"58","16to19":"1","20to24":"14","25to34":"11","35to44":"9","45to54":"15","55to64":"7","65+":"1","medianAge":"7"}},"title":"Residential advisors","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2012":{"total":"58","women":"61.4","white":"29.1","black":"1.4","asian":"5.4"}},"wageData":{"2012":{"workers":"48","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"27","femaleMedian":"-"}}},"Personal care and service workers, all other":{"ageData":{"2012":{"total":"95","16to19":"8","20to24":"21","25to34":"22","35to44":"19","45to54":"8","55to64":"12","65+":"6","medianAge":"12"}},"title":"Personal care and service workers, all other","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2012":{"total":"95","women":"45.7","white":"5.5","black":"3.3","asian":"17.5"}},"wageData":{"2012":{"workers":"32","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Sales and office occupations":{"ageData":{"2012":{"total":"33,152","16to19":"1,534","20to24":"4,157","25to34":"6,712","35to44":"6,318","45to54":"7,207","55to64":"5,398","65+":"1,826","medianAge":"5,398"}},"title":"Sales and office occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2012":{"total":"33,152","women":"61.8","white":"11.8","black":"4.7","asian":"14.0"}},"wageData":{"2012":{"workers":"23,115","median":"655","maleWorkers":"9,202","maleMedian":"768","femaleWorkers":"13,914","femaleMedian":"610"}}},"Sales and related occupations":{"ageData":{"2012":{"total":"15,457","16to19":"1,051","20to24":"2,226","25to34":"3,065","35to44":"2,870","45to54":"3,098","55to64":"2,234","65+":"914","medianAge":"2,234"}},"title":"Sales and related occupations","depth":2,"parent":"Sales and office occupations","sexRaceEthnicityData":{"2012":{"total":"15,457","women":"48.7","white":"10.5","black":"5.3","asian":"13.5"}},"wageData":{"2012":{"workers":"9,433","median":"689","maleWorkers":"5,428","maleMedian":"838","femaleWorkers":"4,005","femaleMedian":"521"}}},"First-line supervisors of retail sales workers":{"ageData":{"2012":{"total":"3,237","16to19":"23","20to24":"259","25to34":"773","35to44":"732","45to54":"791","55to64":"485","65+":"174","medianAge":"485"}},"title":"First-line supervisors of retail sales workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2012":{"total":"3,237","women":"43.4","white":"8.6","black":"5.9","asian":"11.3"}},"wageData":{"2012":{"workers":"2,295","median":"711","maleWorkers":"1,317","maleMedian":"792","femaleWorkers":"977","femaleMedian":"598"}}},"First-line supervisors of non-retail sales workers":{"ageData":{"2012":{"total":"1,151","16to19":"0","20to24":"25","25to34":"186","35to44":"319","45to54":"326","55to64":"223","65+":"72","medianAge":"223"}},"title":"First-line supervisors of non-retail sales workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2012":{"total":"1,151","women":"24.7","white":"7.2","black":"5.0","asian":"10.4"}},"wageData":{"2012":{"workers":"791","median":"1,045","maleWorkers":"571","maleMedian":"1,130","femaleWorkers":"220","femaleMedian":"847"}}},"Cashiers":{"ageData":{"2012":{"total":"3,275","16to19":"677","20to24":"913","25to34":"559","35to44":"371","45to54":"354","55to64":"288","65+":"113","medianAge":"288"}},"title":"Cashiers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2012":{"total":"3,275","women":"71.8","white":"17.2","black":"7.3","asian":"19.9"}},"wageData":{"2012":{"workers":"1,348","median":"376","maleWorkers":"407","maleMedian":"400","femaleWorkers":"941","femaleMedian":"368"}}},"Counter and rental clerks":{"ageData":{"2012":{"total":"139","16to19":"10","20to24":"28","25to34":"32","35to44":"24","45to54":"22","55to64":"18","65+":"4","medianAge":"18"}},"title":"Counter and rental clerks","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2012":{"total":"139","women":"53.4","white":"8.9","black":"5.2","asian":"19.6"}},"wageData":{"2012":{"workers":"96","median":"495","maleWorkers":"54","maleMedian":"591","femaleWorkers":"42","femaleMedian":"-"}}},"Parts salespersons":{"ageData":{"2012":{"total":"106","16to19":"3","20to24":"15","25to34":"21","35to44":"22","45to54":"26","55to64":"17","65+":"2","medianAge":"17"}},"title":"Parts salespersons","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2012":{"total":"106","women":"13.3","white":"8.3","black":"4.1","asian":"12.3"}},"wageData":{"2012":{"workers":"88","median":"643","maleWorkers":"79","maleMedian":"661","femaleWorkers":"9","femaleMedian":"-"}}},"Retail salespersons":{"ageData":{"2012":{"total":"3,341","16to19":"294","20to24":"708","25to34":"658","35to44":"486","45to54":"543","55to64":"450","65+":"201","medianAge":"450"}},"title":"Retail salespersons","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2012":{"total":"3,341","women":"50.2","white":"12.5","black":"4.4","asian":"15.3"}},"wageData":{"2012":{"workers":"1,842","median":"576","maleWorkers":"1,135","maleMedian":"678","femaleWorkers":"707","femaleMedian":"436"}}},"Advertising sales agents":{"ageData":{"2012":{"total":"230","16to19":"2","20to24":"23","25to34":"73","35to44":"50","45to54":"49","55to64":"24","65+":"9","medianAge":"24"}},"title":"Advertising sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2012":{"total":"230","women":"47.4","white":"9.9","black":"2.3","asian":"7.6"}},"wageData":{"2012":{"workers":"191","median":"909","maleWorkers":"100","maleMedian":"945","femaleWorkers":"91","femaleMedian":"842"}}},"Insurance sales agents":{"ageData":{"2012":{"total":"540","16to19":"4","20to24":"27","25to34":"118","35to44":"111","45to54":"134","55to64":"101","65+":"45","medianAge":"101"}},"title":"Insurance sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2012":{"total":"540","women":"44.1","white":"8.1","black":"1.8","asian":"10.3"}},"wageData":{"2012":{"workers":"389","median":"827","maleWorkers":"197","maleMedian":"1,026","femaleWorkers":"191","femaleMedian":"641"}}},"Securities, commodities, and financial services sales agents":{"ageData":{"2012":{"total":"280","16to19":"1","20to24":"21","25to34":"75","35to44":"65","45to54":"66","55to64":"35","65+":"17","medianAge":"35"}},"title":"Securities, commodities, and financial services sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2012":{"total":"280","women":"27.9","white":"3.4","black":"8.3","asian":"8.9"}},"wageData":{"2012":{"workers":"220","median":"1,131","maleWorkers":"156","maleMedian":"1,247","femaleWorkers":"64","femaleMedian":"862"}}},"Travel agents":{"ageData":{"2012":{"total":"73","16to19":"0","20to24":"3","25to34":"10","35to44":"14","45to54":"15","55to64":"16","65+":"16","medianAge":"16"}},"title":"Travel agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2012":{"total":"73","women":"79.0","white":"2.5","black":"9.3","asian":"4.8"}},"wageData":{"2012":{"workers":"44","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"33","femaleMedian":"-"}}},"Sales representatives, services, all other":{"ageData":{"2012":{"total":"457","16to19":"3","20to24":"41","25to34":"107","35to44":"109","45to54":"106","55to64":"75","65+":"16","medianAge":"75"}},"title":"Sales representatives, services, all other","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2012":{"total":"457","women":"31.0","white":"7.9","black":"3.7","asian":"10.1"}},"wageData":{"2012":{"workers":"415","median":"935","maleWorkers":"286","maleMedian":"992","femaleWorkers":"130","femaleMedian":"825"}}},"Sales representatives, wholesale and manufacturing":{"ageData":{"2012":{"total":"1,277","16to19":"8","20to24":"62","25to34":"241","35to44":"319","45to54":"366","55to64":"217","65+":"64","medianAge":"217"}},"title":"Sales representatives, wholesale and manufacturing","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2012":{"total":"1,277","women":"27.0","white":"3.7","black":"3.7","asian":"9.4"}},"wageData":{"2012":{"workers":"1,091","median":"1,064","maleWorkers":"806","maleMedian":"1,161","femaleWorkers":"285","femaleMedian":"822"}}},"Models, demonstrators, and product promoters":{"ageData":{"2012":{"total":"65","16to19":"5","20to24":"8","25to34":"12","35to44":"3","45to54":"11","55to64":"18","65+":"9","medianAge":"18"}},"title":"Models, demonstrators, and product promoters","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2012":{"total":"65","women":"83.4","white":"19.4","black":"4.0","asian":"10.6"}},"wageData":{"2012":{"workers":"18","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Real estate brokers and sales agents":{"ageData":{"2012":{"total":"761","16to19":"1","20to24":"24","25to34":"89","35to44":"153","45to54":"185","55to64":"191","65+":"116","medianAge":"191"}},"title":"Real estate brokers and sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2012":{"total":"761","women":"57.1","white":"4.0","black":"4.7","asian":"8.7"}},"wageData":{"2012":{"workers":"328","median":"789","maleWorkers":"134","maleMedian":"1,031","femaleWorkers":"194","femaleMedian":"680"}}},"Sales engineers":{"ageData":{"2012":{"total":"27","16to19":"0","20to24":"0","25to34":"6","35to44":"6","45to54":"9","55to64":"5","65+":"0","medianAge":"5"}},"title":"Sales engineers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2012":{"total":"27","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"26","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Telemarketers":{"ageData":{"2012":{"total":"97","16to19":"8","20to24":"30","25to34":"24","35to44":"12","45to54":"8","55to64":"11","65+":"4","medianAge":"11"}},"title":"Telemarketers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2012":{"total":"97","women":"50.3","white":"23.0","black":"1.1","asian":"14.7"}},"wageData":{"2012":{"workers":"65","median":"464","maleWorkers":"35","maleMedian":"-","femaleWorkers":"29","femaleMedian":"-"}}},"Door-to-door sales workers, news and street vendors, and related workers":{"ageData":{"2012":{"total":"198","16to19":"7","20to24":"19","25to34":"40","35to44":"32","45to54":"43","55to64":"31","65+":"26","medianAge":"31"}},"title":"Door-to-door sales workers, news and street vendors, and related workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2012":{"total":"198","women":"62.2","white":"10.2","black":"3.8","asian":"13.5"}},"wageData":{"2012":{"workers":"43","median":"-","maleWorkers":"27","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Sales and related workers, all other":{"ageData":{"2012":{"total":"204","16to19":"4","20to24":"18","25to34":"40","35to44":"41","45to54":"44","55to64":"30","65+":"26","medianAge":"30"}},"title":"Sales and related workers, all other","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2012":{"total":"204","women":"47.9","white":"7.7","black":"4.7","asian":"10.3"}},"wageData":{"2012":{"workers":"144","median":"785","maleWorkers":"81","maleMedian":"996","femaleWorkers":"62","femaleMedian":"653"}}},"Office and administrative support occupations":{"ageData":{"2012":{"total":"17,695","16to19":"483","20to24":"1,931","25to34":"3,647","35to44":"3,448","45to54":"4,110","55to64":"3,164","65+":"912","medianAge":"3,164"}},"title":"Office and administrative support occupations","depth":2,"parent":"Sales and office occupations","sexRaceEthnicityData":{"2012":{"total":"17,695","women":"73.3","white":"12.9","black":"4.2","asian":"14.5"}},"wageData":{"2012":{"workers":"13,683","median":"643","maleWorkers":"3,774","maleMedian":"700","femaleWorkers":"9,909","femaleMedian":"629"}}},"First-line supervisors of office and administrative support workers":{"ageData":{"2012":{"total":"1,416","16to19":"7","20to24":"41","25to34":"287","35to44":"347","45to54":"392","55to64":"291","65+":"50","medianAge":"291"}},"title":"First-line supervisors of office and administrative support workers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"1,416","women":"68.5","white":"11.3","black":"3.5","asian":"11.9"}},"wageData":{"2012":{"workers":"1,274","median":"795","maleWorkers":"416","maleMedian":"895","femaleWorkers":"858","femaleMedian":"760"}}},"Switchboard operators, including answering service":{"ageData":{"2012":{"total":"35","16to19":"1","20to24":"5","25to34":"9","35to44":"3","45to54":"7","55to64":"6","65+":"4","medianAge":"6"}},"title":"Switchboard operators, including answering service","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"35","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"28","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"20","femaleMedian":"-"}}},"Telephone operators":{"ageData":{"2012":{"total":"42","16to19":"1","20to24":"8","25to34":"12","35to44":"4","45to54":"10","55to64":"5","65+":"1","medianAge":"5"}},"title":"Telephone operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"42","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"35","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"30","femaleMedian":"-"}}},"Communications equipment operators, all other":{"ageData":{"2012":{"total":"9","16to19":"0","20to24":"0","25to34":"4","35to44":"1","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Communications equipment operators, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"8","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Bill and account collectors":{"ageData":{"2012":{"total":"206","16to19":"2","20to24":"25","25to34":"63","35to44":"46","45to54":"35","55to64":"29","65+":"6","medianAge":"29"}},"title":"Bill and account collectors","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"206","women":"69.1","white":"15.3","black":"3.6","asian":"17.6"}},"wageData":{"2012":{"workers":"183","median":"640","maleWorkers":"61","maleMedian":"681","femaleWorkers":"122","femaleMedian":"633"}}},"Billing and posting clerks":{"ageData":{"2012":{"total":"475","16to19":"4","20to24":"27","25to34":"110","35to44":"109","45to54":"118","55to64":"93","65+":"14","medianAge":"93"}},"title":"Billing and posting clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"475","women":"90.1","white":"11.8","black":"4.0","asian":"16.2"}},"wageData":{"2012":{"workers":"394","median":"627","maleWorkers":"47","maleMedian":"-","femaleWorkers":"347","femaleMedian":"615"}}},"Bookkeeping, accounting, and auditing clerks":{"ageData":{"2012":{"total":"1,268","16to19":"7","20to24":"63","25to34":"164","35to44":"249","45to54":"351","55to64":"310","65+":"124","medianAge":"310"}},"title":"Bookkeeping, accounting, and auditing clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"1,268","women":"89.1","white":"7.6","black":"5.0","asian":"9.0"}},"wageData":{"2012":{"workers":"857","median":"677","maleWorkers":"102","maleMedian":"740","femaleWorkers":"755","femaleMedian":"672"}}},"Gaming cage workers":{"ageData":{"2012":{"total":"8","16to19":"0","20to24":"1","25to34":"2","35to44":"2","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Gaming cage workers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"6","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Payroll and timekeeping clerks":{"ageData":{"2012":{"total":"155","16to19":"0","20to24":"4","25to34":"20","35to44":"35","45to54":"58","55to64":"31","65+":"5","medianAge":"31"}},"title":"Payroll and timekeeping clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"155","women":"92.6","white":"9.5","black":"4.6","asian":"15.1"}},"wageData":{"2012":{"workers":"126","median":"702","maleWorkers":"9","maleMedian":"-","femaleWorkers":"116","femaleMedian":"707"}}},"Procurement clerks":{"ageData":{"2012":{"total":"27","16to19":"0","20to24":"0","25to34":"7","35to44":"7","45to54":"5","55to64":"7","65+":"1","medianAge":"7"}},"title":"Procurement clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"27","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"26","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Tellers":{"ageData":{"2012":{"total":"380","16to19":"13","20to24":"107","25to34":"85","35to44":"68","45to54":"57","55to64":"36","65+":"15","medianAge":"36"}},"title":"Tellers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"380","women":"87.3","white":"11.6","black":"5.7","asian":"18.6"}},"wageData":{"2012":{"workers":"268","median":"497","maleWorkers":"30","maleMedian":"-","femaleWorkers":"238","femaleMedian":"499"}}},"Financial clerks, all other":{"ageData":{"2012":{"total":"52","16to19":"2","20to24":"5","25to34":"11","35to44":"8","45to54":"13","55to64":"10","65+":"3","medianAge":"10"}},"title":"Financial clerks, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"52","women":"68.4","white":"17.1","black":"4.1","asian":"16.6"}},"wageData":{"2012":{"workers":"44","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"32","femaleMedian":"-"}}},"Brokerage clerks":{"ageData":{"2012":{"total":"5","16to19":"0","20to24":"1","25to34":"0","35to44":"3","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Brokerage clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"5","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Correspondence clerks":{"ageData":{"2012":{"total":"6","16to19":"0","20to24":"1","25to34":"2","35to44":"2","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Correspondence clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"6","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Court, municipal, and license clerks":{"ageData":{"2012":{"total":"85","16to19":"0","20to24":"3","25to34":"16","35to44":"15","45to54":"28","55to64":"19","65+":"4","medianAge":"19"}},"title":"Court, municipal, and license clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"85","women":"77.2","white":"23.0","black":"1.2","asian":"13.4"}},"wageData":{"2012":{"workers":"77","median":"699","maleWorkers":"14","maleMedian":"-","femaleWorkers":"63","femaleMedian":"693"}}},"Credit authorizers, checkers, and clerks":{"ageData":{"2012":{"total":"43","16to19":"0","20to24":"4","25to34":"9","35to44":"11","45to54":"13","55to64":"6","65+":"0","medianAge":"6"}},"title":"Credit authorizers, checkers, and clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"43","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"42","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"31","femaleMedian":"-"}}},"Customer service representatives":{"ageData":{"2012":{"total":"1,956","16to19":"92","20to24":"333","25to34":"508","35to44":"381","45to54":"348","55to64":"237","65+":"58","medianAge":"237"}},"title":"Customer service representatives","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"1,956","women":"67.8","white":"16.2","black":"4.2","asian":"18.0"}},"wageData":{"2012":{"workers":"1,535","median":"608","maleWorkers":"502","maleMedian":"684","femaleWorkers":"1,033","femaleMedian":"585"}}},"Eligibility interviewers, government programs":{"ageData":{"2012":{"total":"92","16to19":"0","20to24":"2","25to34":"23","35to44":"20","45to54":"20","55to64":"21","65+":"6","medianAge":"21"}},"title":"Eligibility interviewers, government programs","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"92","women":"81.4","white":"19.8","black":"2.1","asian":"23.1"}},"wageData":{"2012":{"workers":"78","median":"769","maleWorkers":"17","maleMedian":"-","femaleWorkers":"61","femaleMedian":"730"}}},"File clerks":{"ageData":{"2012":{"total":"292","16to19":"27","20to24":"34","25to34":"51","35to44":"45","45to54":"69","55to64":"49","65+":"17","medianAge":"49"}},"title":"File clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"292","women":"81.3","white":"14.1","black":"4.6","asian":"16.4"}},"wageData":{"2012":{"workers":"204","median":"645","maleWorkers":"44","maleMedian":"-","femaleWorkers":"159","femaleMedian":"635"}}},"Hotel, motel, and resort desk clerks":{"ageData":{"2012":{"total":"110","16to19":"8","20to24":"34","25to34":"32","35to44":"16","45to54":"10","55to64":"7","65+":"3","medianAge":"7"}},"title":"Hotel, motel, and resort desk clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"110","women":"64.6","white":"18.4","black":"6.3","asian":"18.6"}},"wageData":{"2012":{"workers":"73","median":"522","maleWorkers":"29","maleMedian":"-","femaleWorkers":"44","femaleMedian":"-"}}},"Interviewers, except eligibility and loan":{"ageData":{"2012":{"total":"135","16to19":"3","20to24":"16","25to34":"35","35to44":"25","45to54":"27","55to64":"27","65+":"3","medianAge":"27"}},"title":"Interviewers, except eligibility and loan","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"135","women":"83.7","white":"20.0","black":"6.0","asian":"12.1"}},"wageData":{"2012":{"workers":"104","median":"593","maleWorkers":"13","maleMedian":"-","femaleWorkers":"91","femaleMedian":"581"}}},"Library assistants, clerical":{"ageData":{"2012":{"total":"97","16to19":"3","20to24":"16","25to34":"11","35to44":"11","45to54":"22","55to64":"22","65+":"12","medianAge":"22"}},"title":"Library assistants, clerical","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"97","women":"84.0","white":"7.0","black":"3.2","asian":"5.8"}},"wageData":{"2012":{"workers":"34","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Loan interviewers and clerks":{"ageData":{"2012":{"total":"144","16to19":"0","20to24":"7","25to34":"50","35to44":"34","45to54":"33","55to64":"16","65+":"3","medianAge":"16"}},"title":"Loan interviewers and clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"144","women":"81.2","white":"10.9","black":"4.0","asian":"10.4"}},"wageData":{"2012":{"workers":"133","median":"692","maleWorkers":"26","maleMedian":"-","femaleWorkers":"107","femaleMedian":"682"}}},"New accounts clerks":{"ageData":{"2012":{"total":"26","16to19":"0","20to24":"5","25to34":"6","35to44":"6","45to54":"6","55to64":"2","65+":"1","medianAge":"2"}},"title":"New accounts clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"26","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"22","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"15","femaleMedian":"-"}}},"Order clerks":{"ageData":{"2012":{"total":"104","16to19":"5","20to24":"14","25to34":"25","35to44":"19","45to54":"20","55to64":"15","65+":"5","medianAge":"15"}},"title":"Order clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"104","women":"58.2","white":"5.8","black":"4.1","asian":"21.3"}},"wageData":{"2012":{"workers":"90","median":"561","maleWorkers":"37","maleMedian":"-","femaleWorkers":"53","femaleMedian":"595"}}},"Human resources assistants, except payroll and timekeeping":{"ageData":{"2012":{"total":"132","16to19":"0","20to24":"13","25to34":"37","35to44":"34","45to54":"20","55to64":"25","65+":"3","medianAge":"25"}},"title":"Human resources assistants, except payroll and timekeeping","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"132","women":"82.7","white":"18.3","black":"1.9","asian":"7.9"}},"wageData":{"2012":{"workers":"105","median":"759","maleWorkers":"17","maleMedian":"-","femaleWorkers":"88","femaleMedian":"724"}}},"Receptionists and information clerks":{"ageData":{"2012":{"total":"1,237","16to19":"56","20to24":"234","25to34":"276","35to44":"215","45to54":"211","55to64":"179","65+":"65","medianAge":"179"}},"title":"Receptionists and information clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"1,237","women":"91.5","white":"12.1","black":"4.3","asian":"17.9"}},"wageData":{"2012":{"workers":"831","median":"531","maleWorkers":"73","maleMedian":"604","femaleWorkers":"758","femaleMedian":"524"}}},"Reservation and transportation ticket agents and travel clerks":{"ageData":{"2012":{"total":"117","16to19":"3","20to24":"11","25to34":"26","35to44":"29","45to54":"29","55to64":"16","65+":"2","medianAge":"16"}},"title":"Reservation and transportation ticket agents and travel clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"117","women":"58.6","white":"21.8","black":"10.9","asian":"21.5"}},"wageData":{"2012":{"workers":"99","median":"738","maleWorkers":"45","maleMedian":"-","femaleWorkers":"54","femaleMedian":"634"}}},"Information and record clerks, all other":{"ageData":{"2012":{"total":"104","16to19":"2","20to24":"5","25to34":"21","35to44":"24","45to54":"23","55to64":"23","65+":"7","medianAge":"23"}},"title":"Information and record clerks, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"104","women":"80.2","white":"17.0","black":"2.5","asian":"13.4"}},"wageData":{"2012":{"workers":"87","median":"661","maleWorkers":"15","maleMedian":"-","femaleWorkers":"73","femaleMedian":"677"}}},"Cargo and freight agents":{"ageData":{"2012":{"total":"25","16to19":"0","20to24":"0","25to34":"4","35to44":"4","45to54":"12","55to64":"4","65+":"1","medianAge":"4"}},"title":"Cargo and freight agents","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"25","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"21","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Couriers and messengers":{"ageData":{"2012":{"total":"213","16to19":"3","20to24":"16","25to34":"40","35to44":"49","45to54":"45","55to64":"38","65+":"22","medianAge":"38"}},"title":"Couriers and messengers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"213","women":"15.5","white":"13.0","black":"2.4","asian":"16.9"}},"wageData":{"2012":{"workers":"139","median":"737","maleWorkers":"120","maleMedian":"744","femaleWorkers":"19","femaleMedian":"-"}}},"Dispatchers":{"ageData":{"2012":{"total":"277","16to19":"3","20to24":"19","25to34":"85","35to44":"64","45to54":"61","55to64":"38","65+":"6","medianAge":"38"}},"title":"Dispatchers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"277","women":"61.5","white":"13.5","black":"2.3","asian":"16.7"}},"wageData":{"2012":{"workers":"252","median":"648","maleWorkers":"94","maleMedian":"796","femaleWorkers":"159","femaleMedian":"605"}}},"Meter readers, utilities":{"ageData":{"2012":{"total":"29","16to19":"0","20to24":"4","25to34":"8","35to44":"6","45to54":"8","55to64":"1","65+":"1","medianAge":"1"}},"title":"Meter readers, utilities","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"29","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"25","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Postal service clerks":{"ageData":{"2012":{"total":"148","16to19":"1","20to24":"1","25to34":"8","35to44":"20","45to54":"47","55to64":"65","65+":"5","medianAge":"65"}},"title":"Postal service clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"148","women":"50.0","white":"21.3","black":"9.5","asian":"12.0"}},"wageData":{"2012":{"workers":"137","median":"980","maleWorkers":"64","maleMedian":"1,000","femaleWorkers":"73","femaleMedian":"910"}}},"Postal service mail carriers":{"ageData":{"2012":{"total":"318","16to19":"0","20to24":"1","25to34":"31","35to44":"65","45to54":"126","55to64":"83","65+":"10","medianAge":"83"}},"title":"Postal service mail carriers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"318","women":"37.7","white":"16.5","black":"6.7","asian":"8.8"}},"wageData":{"2012":{"workers":"279","median":"990","maleWorkers":"186","maleMedian":"1,026","femaleWorkers":"93","femaleMedian":"907"}}},"Postal service mail sorters, processors, and processing machine operators":{"ageData":{"2012":{"total":"66","16to19":"1","20to24":"5","25to34":"6","35to44":"10","45to54":"21","55to64":"19","65+":"3","medianAge":"19"}},"title":"Postal service mail sorters, processors, and processing machine operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"66","women":"47.6","white":"28.6","black":"12.7","asian":"9.8"}},"wageData":{"2012":{"workers":"56","median":"891","maleWorkers":"33","maleMedian":"-","femaleWorkers":"23","femaleMedian":"-"}}},"Production, planning, and expediting clerks":{"ageData":{"2012":{"total":"272","16to19":"2","20to24":"15","25to34":"69","35to44":"59","45to54":"62","55to64":"55","65+":"10","medianAge":"55"}},"title":"Production, planning, and expediting clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"272","women":"55.0","white":"11.0","black":"3.2","asian":"12.5"}},"wageData":{"2012":{"workers":"242","median":"858","maleWorkers":"111","maleMedian":"946","femaleWorkers":"131","femaleMedian":"765"}}},"Shipping, receiving, and traffic clerks":{"ageData":{"2012":{"total":"527","16to19":"11","20to24":"74","25to34":"126","35to44":"112","45to54":"116","55to64":"71","65+":"16","medianAge":"71"}},"title":"Shipping, receiving, and traffic clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"527","women":"27.8","white":"15.6","black":"3.6","asian":"23.7"}},"wageData":{"2012":{"workers":"458","median":"556","maleWorkers":"333","maleMedian":"577","femaleWorkers":"125","femaleMedian":"522"}}},"Stock clerks and order fillers":{"ageData":{"2012":{"total":"1,453","16to19":"124","20to24":"308","25to34":"315","35to44":"217","45to54":"244","55to64":"172","65+":"73","medianAge":"172"}},"title":"Stock clerks and order fillers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"1,453","women":"35.5","white":"16.7","black":"4.5","asian":"18.1"}},"wageData":{"2012":{"workers":"936","median":"505","maleWorkers":"625","maleMedian":"516","femaleWorkers":"310","femaleMedian":"484"}}},"Weighers, measurers, checkers, and samplers, recordkeeping":{"ageData":{"2012":{"total":"74","16to19":"1","20to24":"8","25to34":"22","35to44":"20","45to54":"11","55to64":"10","65+":"1","medianAge":"10"}},"title":"Weighers, measurers, checkers, and samplers, recordkeeping","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"74","women":"49.1","white":"19.9","black":"2.8","asian":"21.9"}},"wageData":{"2012":{"workers":"64","median":"638","maleWorkers":"35","maleMedian":"-","femaleWorkers":"29","femaleMedian":"-"}}},"Secretaries and administrative assistants":{"ageData":{"2012":{"total":"2,904","16to19":"28","20to24":"163","25to34":"465","35to44":"559","45to54":"792","55to64":"685","65+":"212","medianAge":"685"}},"title":"Secretaries and administrative assistants","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"2,904","women":"95.3","white":"8.6","black":"3.2","asian":"10.3"}},"wageData":{"2012":{"workers":"2,251","median":"669","maleWorkers":"105","maleMedian":"803","femaleWorkers":"2,146","femaleMedian":"665"}}},"Computer operators":{"ageData":{"2012":{"total":"102","16to19":"2","20to24":"9","25to34":"15","35to44":"23","45to54":"31","55to64":"17","65+":"5","medianAge":"17"}},"title":"Computer operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"102","women":"50.7","white":"12.2","black":"6.5","asian":"10.7"}},"wageData":{"2012":{"workers":"87","median":"785","maleWorkers":"42","maleMedian":"-","femaleWorkers":"45","femaleMedian":"-"}}},"Data entry keyers":{"ageData":{"2012":{"total":"337","16to19":"9","20to24":"40","25to34":"88","35to44":"58","45to54":"80","55to64":"54","65+":"9","medianAge":"54"}},"title":"Data entry keyers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"337","women":"77.0","white":"14.0","black":"5.1","asian":"13.8"}},"wageData":{"2012":{"workers":"259","median":"591","maleWorkers":"57","maleMedian":"611","femaleWorkers":"202","femaleMedian":"586"}}},"Word processors and typists":{"ageData":{"2012":{"total":"119","16to19":"1","20to24":"7","25to34":"24","35to44":"23","45to54":"34","55to64":"23","65+":"7","medianAge":"23"}},"title":"Word processors and typists","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"119","women":"88.7","white":"12.4","black":"2.8","asian":"12.9"}},"wageData":{"2012":{"workers":"90","median":"624","maleWorkers":"8","maleMedian":"-","femaleWorkers":"82","femaleMedian":"622"}}},"Desktop publishers":{"ageData":{"2012":{"total":"3","16to19":"0","20to24":"0","25to34":"0","35to44":"2","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Desktop publishers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Insurance claims and policy processing clerks":{"ageData":{"2012":{"total":"230","16to19":"0","20to24":"17","25to34":"70","35to44":"41","45to54":"60","55to64":"34","65+":"7","medianAge":"34"}},"title":"Insurance claims and policy processing clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"230","women":"81.9","white":"12.7","black":"3.6","asian":"13.7"}},"wageData":{"2012":{"workers":"226","median":"643","maleWorkers":"44","maleMedian":"-","femaleWorkers":"182","femaleMedian":"631"}}},"Mail clerks and mail machine operators, except postal service":{"ageData":{"2012":{"total":"81","16to19":"2","20to24":"11","25to34":"9","35to44":"12","45to54":"18","55to64":"21","65+":"9","medianAge":"21"}},"title":"Mail clerks and mail machine operators, except postal service","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"81","women":"41.2","white":"18.1","black":"10.6","asian":"10.1"}},"wageData":{"2012":{"workers":"72","median":"580","maleWorkers":"44","maleMedian":"-","femaleWorkers":"27","femaleMedian":"-"}}},"Office clerks, general":{"ageData":{"2012":{"total":"1,103","16to19":"45","20to24":"147","25to34":"220","35to44":"192","45to54":"261","55to64":"172","65+":"66","medianAge":"172"}},"title":"Office clerks, general","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"1,103","women":"83.4","white":"12.4","black":"5.0","asian":"16.9"}},"wageData":{"2012":{"workers":"798","median":"601","maleWorkers":"131","maleMedian":"607","femaleWorkers":"667","femaleMedian":"600"}}},"Office machine operators, except computer":{"ageData":{"2012":{"total":"46","16to19":"2","20to24":"8","25to34":"10","35to44":"6","45to54":"9","55to64":"9","65+":"2","medianAge":"9"}},"title":"Office machine operators, except computer","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"46","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"34","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Proofreaders and copy markers":{"ageData":{"2012":{"total":"10","16to19":"0","20to24":"2","25to34":"1","35to44":"0","45to54":"2","55to64":"4","65+":"1","medianAge":"4"}},"title":"Proofreaders and copy markers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"5","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Statistical assistants":{"ageData":{"2012":{"total":"32","16to19":"0","20to24":"4","25to34":"9","35to44":"6","45to54":"7","55to64":"3","65+":"3","medianAge":"3"}},"title":"Statistical assistants","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"32","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"25","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"14","femaleMedian":"-"}}},"Office and administrative support workers, all other":{"ageData":{"2012":{"total":"570","16to19":"9","20to24":"54","25to34":"121","35to44":"126","45to54":"131","55to64":"99","65+":"29","medianAge":"99"}},"title":"Office and administrative support workers, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2012":{"total":"570","women":"77.3","white":"14.1","black":"3.9","asian":"11.0"}},"wageData":{"2012":{"workers":"452","median":"707","maleWorkers":"103","maleMedian":"788","femaleWorkers":"349","femaleMedian":"686"}}},"Natural resources, construction, and maintenance occupations":{"ageData":{"2012":{"total":"12,821","16to19":"295","20to24":"1,067","25to34":"3,077","35to44":"3,045","45to54":"3,092","55to64":"1,840","65+":"404","medianAge":"1,840"}},"title":"Natural resources, construction, and maintenance occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2012":{"total":"12,821","women":"4.3","white":"7.0","black":"2.1","asian":"25.5"}},"wageData":{"2012":{"workers":"9,968","median":"740","maleWorkers":"9,579","maleMedian":"749","femaleWorkers":"389","femaleMedian":"550"}}},"Farming, fishing, and forestry occupations":{"ageData":{"2012":{"total":"994","16to19":"88","20to24":"134","25to34":"232","35to44":"191","45to54":"185","55to64":"117","65+":"47","medianAge":"117"}},"title":"Farming, fishing, and forestry occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2012":{"total":"994","women":"22.7","white":"5.3","black":"1.8","asian":"44.2"}},"wageData":{"2012":{"workers":"777","median":"435","maleWorkers":"611","maleMedian":"457","femaleWorkers":"166","femaleMedian":"377"}}},"First-line supervisors of farming, fishing, and forestry workers":{"ageData":{"2012":{"total":"50","16to19":"0","20to24":"2","25to34":"9","35to44":"11","45to54":"15","55to64":"8","65+":"5","medianAge":"8"}},"title":"First-line supervisors of farming, fishing, and forestry workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2012":{"total":"50","women":"14.1","white":"7.8","black":"4.2","asian":"23.9"}},"wageData":{"2012":{"workers":"39","median":"-","maleWorkers":"34","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Agricultural inspectors":{"ageData":{"2012":{"total":"16","16to19":"0","20to24":"0","25to34":"2","35to44":"6","45to54":"4","55to64":"3","65+":"1","medianAge":"3"}},"title":"Agricultural inspectors","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2012":{"total":"16","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"17","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Animal breeders":{"ageData":{"2012":{"total":"6","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"2","55to64":"1","65+":"1","medianAge":"1"}},"title":"Animal breeders","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2012":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Graders and sorters, agricultural products":{"ageData":{"2012":{"total":"118","16to19":"4","20to24":"8","25to34":"30","35to44":"24","45to54":"30","55to64":"19","65+":"3","medianAge":"19"}},"title":"Graders and sorters, agricultural products","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2012":{"total":"118","women":"59.8","white":"16.6","black":"2.1","asian":"58.0"}},"wageData":{"2012":{"workers":"108","median":"410","maleWorkers":"37","maleMedian":"-","femaleWorkers":"70","femaleMedian":"396"}}},"Miscellaneous agricultural workers":{"ageData":{"2012":{"total":"711","16to19":"79","20to24":"119","25to34":"172","35to44":"135","45to54":"108","55to64":"68","65+":"31","medianAge":"68"}},"title":"Miscellaneous agricultural workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2012":{"total":"711","women":"18.9","white":"3.2","black":"1.5","asian":"48.9"}},"wageData":{"2012":{"workers":"560","median":"426","maleWorkers":"478","maleMedian":"444","femaleWorkers":"81","femaleMedian":"350"}}},"Fishers and related fishing workers":{"ageData":{"2012":{"total":"33","16to19":"0","20to24":"0","25to34":"5","35to44":"5","45to54":"10","55to64":"6","65+":"5","medianAge":"6"}},"title":"Fishers and related fishing workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2012":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"8","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Hunters and trappers":{"ageData":{"2012":{"total":"2","16to19":"0","20to24":"0","25to34":"2","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Hunters and trappers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2012":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"2","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Forest and conservation workers":{"ageData":{"2012":{"total":"9","16to19":"2","20to24":"1","25to34":"1","35to44":"1","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Forest and conservation workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2012":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Logging workers":{"ageData":{"2012":{"total":"49","16to19":"2","20to24":"3","25to34":"11","35to44":"8","45to54":"15","55to64":"9","65+":"1","medianAge":"9"}},"title":"Logging workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2012":{"total":"49","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"37","median":"-","maleWorkers":"36","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Construction and extraction occupations":{"ageData":{"2012":{"total":"7,005","16to19":"132","20to24":"544","25to34":"1,773","35to44":"1,701","45to54":"1,706","55to64":"957","65+":"192","medianAge":"957"}},"title":"Construction and extraction occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2012":{"total":"7,005","women":"2.5","white":"6.2","black":"1.6","asian":"28.9"}},"wageData":{"2012":{"workers":"5,102","median":"740","maleWorkers":"5,004","maleMedian":"741","femaleWorkers":"98","femaleMedian":"723"}}},"First-line supervisors of construction trades and extraction workers":{"ageData":{"2012":{"total":"634","16to19":"0","20to24":"14","25to34":"131","35to44":"152","45to54":"188","55to64":"115","65+":"34","medianAge":"115"}},"title":"First-line supervisors of construction trades and extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"634","women":"2.8","white":"4.5","black":"1.3","asian":"14.0"}},"wageData":{"2012":{"workers":"488","median":"1,019","maleWorkers":"475","maleMedian":"1,018","femaleWorkers":"13","femaleMedian":"-"}}},"Boilermakers":{"ageData":{"2012":{"total":"23","16to19":"0","20to24":"2","25to34":"4","35to44":"4","45to54":"6","55to64":"5","65+":"2","medianAge":"5"}},"title":"Boilermakers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"23","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"23","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Brickmasons, blockmasons, and stonemasons":{"ageData":{"2012":{"total":"122","16to19":"5","20to24":"8","25to34":"27","35to44":"40","45to54":"28","55to64":"12","65+":"2","medianAge":"12"}},"title":"Brickmasons, blockmasons, and stonemasons","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"122","women":"0.1","white":"5.8","black":"0.3","asian":"43.2"}},"wageData":{"2012":{"workers":"94","median":"641","maleWorkers":"94","maleMedian":"641","femaleWorkers":"0","femaleMedian":"-"}}},"Carpenters":{"ageData":{"2012":{"total":"1,223","16to19":"22","20to24":"81","25to34":"308","35to44":"308","45to54":"295","55to64":"175","65+":"34","medianAge":"175"}},"title":"Carpenters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"1,223","women":"1.6","white":"4.2","black":"1.9","asian":"29.0"}},"wageData":{"2012":{"workers":"750","median":"675","maleWorkers":"743","maleMedian":"673","femaleWorkers":"7","femaleMedian":"-"}}},"Carpet, floor, and tile installers and finishers":{"ageData":{"2012":{"total":"150","16to19":"2","20to24":"18","25to34":"38","35to44":"36","45to54":"36","55to64":"19","65+":"1","medianAge":"19"}},"title":"Carpet, floor, and tile installers and finishers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"150","women":"2.2","white":"8.8","black":"0.4","asian":"37.8"}},"wageData":{"2012":{"workers":"84","median":"599","maleWorkers":"83","maleMedian":"603","femaleWorkers":"1","femaleMedian":"-"}}},"Cement masons, concrete finishers, and terrazzo workers":{"ageData":{"2012":{"total":"68","16to19":"0","20to24":"6","25to34":"20","35to44":"18","45to54":"19","55to64":"4","65+":"1","medianAge":"4"}},"title":"Cement masons, concrete finishers, and terrazzo workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"68","women":"2.7","white":"5.8","black":"3.1","asian":"53.3"}},"wageData":{"2012":{"workers":"53","median":"601","maleWorkers":"53","maleMedian":"601","femaleWorkers":"0","femaleMedian":"-"}}},"Construction laborers":{"ageData":{"2012":{"total":"1,387","16to19":"45","20to24":"161","25to34":"412","35to44":"313","45to54":"282","55to64":"140","65+":"33","medianAge":"140"}},"title":"Construction laborers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"1,387","women":"2.9","white":"8.4","black":"2.0","asian":"41.2"}},"wageData":{"2012":{"workers":"937","median":"607","maleWorkers":"913","maleMedian":"609","femaleWorkers":"24","femaleMedian":"-"}}},"Paving, surfacing, and tamping equipment operators":{"ageData":{"2012":{"total":"23","16to19":"0","20to24":"2","25to34":"6","35to44":"6","45to54":"4","55to64":"3","65+":"0","medianAge":"3"}},"title":"Paving, surfacing, and tamping equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"23","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"15","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Pile-driver operators":{"ageData":{"2012":{"total":"4","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"0","55to64":"2","65+":"0","medianAge":"2"}},"title":"Pile-driver operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Operating engineers and other construction equipment operators":{"ageData":{"2012":{"total":"348","16to19":"5","20to24":"22","25to34":"69","35to44":"74","45to54":"94","55to64":"75","65+":"10","medianAge":"75"}},"title":"Operating engineers and other construction equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"348","women":"1.3","white":"6.0","black":"0.2","asian":"17.1"}},"wageData":{"2012":{"workers":"321","median":"805","maleWorkers":"316","maleMedian":"805","femaleWorkers":"5","femaleMedian":"-"}}},"Drywall installers, ceiling tile installers, and tapers":{"ageData":{"2012":{"total":"129","16to19":"2","20to24":"10","25to34":"42","35to44":"39","45to54":"24","55to64":"11","65+":"1","medianAge":"11"}},"title":"Drywall installers, ceiling tile installers, and tapers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"129","women":"0.3","white":"2.7","black":"0.0","asian":"62.0"}},"wageData":{"2012":{"workers":"94","median":"568","maleWorkers":"94","maleMedian":"567","femaleWorkers":"0","femaleMedian":"-"}}},"Electricians":{"ageData":{"2012":{"total":"692","16to19":"6","20to24":"42","25to34":"150","35to44":"172","45to54":"196","55to64":"111","65+":"15","medianAge":"111"}},"title":"Electricians","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"692","women":"1.8","white":"6.0","black":"2.3","asian":"14.8"}},"wageData":{"2012":{"workers":"574","median":"932","maleWorkers":"563","maleMedian":"929","femaleWorkers":"11","femaleMedian":"-"}}},"Glaziers":{"ageData":{"2012":{"total":"46","16to19":"0","20to24":"2","25to34":"18","35to44":"12","45to54":"6","55to64":"6","65+":"2","medianAge":"6"}},"title":"Glaziers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"46","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"38","median":"-","maleWorkers":"38","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Insulation workers":{"ageData":{"2012":{"total":"44","16to19":"1","20to24":"4","25to34":"11","35to44":"17","45to54":"8","55to64":"2","65+":"0","medianAge":"2"}},"title":"Insulation workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"44","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"33","median":"-","maleWorkers":"32","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Painters, construction and maintenance":{"ageData":{"2012":{"total":"485","16to19":"12","20to24":"38","25to34":"124","35to44":"113","45to54":"117","55to64":"66","65+":"15","medianAge":"66"}},"title":"Painters, construction and maintenance","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"485","women":"5.5","white":"5.5","black":"2.0","asian":"42.6"}},"wageData":{"2012":{"workers":"261","median":"568","maleWorkers":"252","maleMedian":"559","femaleWorkers":"8","femaleMedian":"-"}}},"Paperhangers":{"ageData":{"2012":{"total":"7","16to19":"0","20to24":"1","25to34":"2","35to44":"0","45to54":"2","55to64":"0","65+":"1","medianAge":"0"}},"title":"Paperhangers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Pipelayers, plumbers, pipefitters, and steamfitters":{"ageData":{"2012":{"total":"534","16to19":"7","20to24":"36","25to34":"129","35to44":"135","45to54":"150","55to64":"62","65+":"15","medianAge":"62"}},"title":"Pipelayers, plumbers, pipefitters, and steamfitters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"534","women":"1.3","white":"6.6","black":"1.5","asian":"20.9"}},"wageData":{"2012":{"workers":"436","median":"878","maleWorkers":"430","maleMedian":"876","femaleWorkers":"6","femaleMedian":"-"}}},"Plasterers and stucco masons":{"ageData":{"2012":{"total":"18","16to19":"1","20to24":"2","25to34":"3","35to44":"7","45to54":"4","55to64":"0","65+":"0","medianAge":"0"}},"title":"Plasterers and stucco masons","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"18","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"14","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Reinforcing iron and rebar workers":{"ageData":{"2012":{"total":"8","16to19":"0","20to24":"1","25to34":"5","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Reinforcing iron and rebar workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"8","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Roofers":{"ageData":{"2012":{"total":"196","16to19":"3","20to24":"15","25to34":"70","35to44":"47","45to54":"41","55to64":"17","65+":"4","medianAge":"17"}},"title":"Roofers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"196","women":"1.5","white":"7.0","black":"0.5","asian":"45.1"}},"wageData":{"2012":{"workers":"123","median":"533","maleWorkers":"121","maleMedian":"524","femaleWorkers":"2","femaleMedian":"-"}}},"Sheet metal workers":{"ageData":{"2012":{"total":"123","16to19":"2","20to24":"8","25to34":"26","35to44":"29","45to54":"32","55to64":"23","65+":"3","medianAge":"23"}},"title":"Sheet metal workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"123","women":"4.6","white":"3.2","black":"1.7","asian":"12.1"}},"wageData":{"2012":{"workers":"103","median":"885","maleWorkers":"100","maleMedian":"880","femaleWorkers":"3","femaleMedian":"-"}}},"Structural iron and steel workers":{"ageData":{"2012":{"total":"65","16to19":"1","20to24":"5","25to34":"17","35to44":"28","45to54":"10","55to64":"4","65+":"0","medianAge":"4"}},"title":"Structural iron and steel workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"65","women":"2.8","white":"6.5","black":"0.0","asian":"15.8"}},"wageData":{"2012":{"workers":"60","median":"759","maleWorkers":"59","maleMedian":"767","femaleWorkers":"1","femaleMedian":"-"}}},"Solar photovoltaic installers":{"ageData":{"2012":{"total":"7","16to19":"0","20to24":"1","25to34":"1","35to44":"4","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Solar photovoltaic installers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers, construction trades":{"ageData":{"2012":{"total":"53","16to19":"4","20to24":"8","25to34":"20","35to44":"12","45to54":"5","55to64":"4","65+":"0","medianAge":"4"}},"title":"Helpers, construction trades","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"53","women":"4.5","white":"12.1","black":"1.3","asian":"38.4"}},"wageData":{"2012":{"workers":"42","median":"-","maleWorkers":"40","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Construction and building inspectors":{"ageData":{"2012":{"total":"118","16to19":"1","20to24":"4","25to34":"12","35to44":"20","45to54":"32","55to64":"40","65+":"9","medianAge":"40"}},"title":"Construction and building inspectors","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"118","women":"7.8","white":"5.5","black":"2.1","asian":"7.7"}},"wageData":{"2012":{"workers":"87","median":"932","maleWorkers":"83","maleMedian":"940","femaleWorkers":"4","femaleMedian":"-"}}},"Elevator installers and repairers":{"ageData":{"2012":{"total":"29","16to19":"0","20to24":"0","25to34":"5","35to44":"7","45to54":"13","55to64":"4","65+":"0","medianAge":"4"}},"title":"Elevator installers and repairers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"29","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"31","median":"-","maleWorkers":"29","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Fence erectors":{"ageData":{"2012":{"total":"33","16to19":"3","20to24":"6","25to34":"6","35to44":"6","45to54":"11","55to64":"2","65+":"0","medianAge":"2"}},"title":"Fence erectors","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"26","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Hazardous materials removal workers":{"ageData":{"2012":{"total":"38","16to19":"1","20to24":"5","25to34":"8","35to44":"10","45to54":"10","55to64":"1","65+":"2","medianAge":"1"}},"title":"Hazardous materials removal workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"38","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"28","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Highway maintenance workers":{"ageData":{"2012":{"total":"108","16to19":"3","20to24":"4","25to34":"17","35to44":"25","45to54":"31","55to64":"24","65+":"5","medianAge":"24"}},"title":"Highway maintenance workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"108","women":"1.5","white":"11.0","black":"0.1","asian":"12.4"}},"wageData":{"2012":{"workers":"98","median":"683","maleWorkers":"97","maleMedian":"683","femaleWorkers":"1","femaleMedian":"-"}}},"Rail-track laying and maintenance equipment operators":{"ageData":{"2012":{"total":"10","16to19":"0","20to24":"0","25to34":"4","35to44":"1","45to54":"5","55to64":"1","65+":"0","medianAge":"1"}},"title":"Rail-track laying and maintenance equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Septic tank servicers and sewer pipe cleaners":{"ageData":{"2012":{"total":"8","16to19":"0","20to24":"1","25to34":"0","35to44":"5","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Septic tank servicers and sewer pipe cleaners","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Miscellaneous construction and related workers":{"ageData":{"2012":{"total":"32","16to19":"0","20to24":"1","25to34":"12","35to44":"5","45to54":"7","55to64":"7","65+":"0","medianAge":"7"}},"title":"Miscellaneous construction and related workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"32","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"24","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Derrick, rotary drill, and service unit operators, oil, gas, and mining":{"ageData":{"2012":{"total":"37","16to19":"1","20to24":"6","25to34":"13","35to44":"10","45to54":"6","55to64":"1","65+":"0","medianAge":"1"}},"title":"Derrick, rotary drill, and service unit operators, oil, gas, and mining","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"37","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"32","median":"-","maleWorkers":"32","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Earth drillers, except oil and gas":{"ageData":{"2012":{"total":"35","16to19":"0","20to24":"6","25to34":"7","35to44":"10","45to54":"7","55to64":"3","65+":"1","medianAge":"3"}},"title":"Earth drillers, except oil and gas","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"35","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"28","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Explosives workers, ordnance handling experts, and blasters":{"ageData":{"2012":{"total":"8","16to19":"0","20to24":"1","25to34":"2","35to44":"1","45to54":"3","55to64":"0","65+":"0","medianAge":"0"}},"title":"Explosives workers, ordnance handling experts, and blasters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Mining machine operators":{"ageData":{"2012":{"total":"65","16to19":"1","20to24":"8","25to34":"20","35to44":"16","45to54":"14","55to64":"7","65+":"0","medianAge":"7"}},"title":"Mining machine operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"65","women":"0.3","white":"3.8","black":"0.0","asian":"17.2"}},"wageData":{"2012":{"workers":"65","median":"997","maleWorkers":"65","maleMedian":"996","femaleWorkers":"0","femaleMedian":"-"}}},"Roof bolters, mining":{"ageData":{"2012":{"total":"3","16to19":"0","20to24":"0","25to34":"2","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Roof bolters, mining","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Roustabouts, oil and gas":{"ageData":{"2012":{"total":"14","16to19":"2","20to24":"3","25to34":"4","35to44":"1","45to54":"3","55to64":"1","65+":"0","medianAge":"1"}},"title":"Roustabouts, oil and gas","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"16","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Helpers--extraction workers":{"ageData":{"2012":{"total":"5","16to19":"0","20to24":"2","25to34":"1","35to44":"0","45to54":"0","55to64":"2","65+":"0","medianAge":"2"}},"title":"Helpers--extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Other extraction workers":{"ageData":{"2012":{"total":"75","16to19":"3","20to24":"10","25to34":"26","35to44":"16","45to54":"14","55to64":"4","65+":"0","medianAge":"4"}},"title":"Other extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2012":{"total":"75","women":"4.5","white":"5.6","black":"1.0","asian":"26.2"}},"wageData":{"2012":{"workers":"84","median":"985","maleWorkers":"83","maleMedian":"981","femaleWorkers":"1","femaleMedian":"-"}}},"Installation, maintenance, and repair occupations":{"ageData":{"2012":{"total":"4,821","16to19":"75","20to24":"390","25to34":"1,071","35to44":"1,153","45to54":"1,201","55to64":"766","65+":"165","medianAge":"766"}},"title":"Installation, maintenance, and repair occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2012":{"total":"4,821","women":"3.2","white":"8.4","black":"3.0","asian":"16.6"}},"wageData":{"2012":{"workers":"4,088","median":"808","maleWorkers":"3,963","maleMedian":"809","femaleWorkers":"125","femaleMedian":"757"}}},"First-line supervisors of mechanics, installers, and repairers":{"ageData":{"2012":{"total":"292","16to19":"1","20to24":"6","25to34":"47","35to44":"72","45to54":"84","55to64":"73","65+":"10","medianAge":"73"}},"title":"First-line supervisors of mechanics, installers, and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"292","women":"5.9","white":"11.3","black":"1.0","asian":"10.4"}},"wageData":{"2012":{"workers":"280","median":"936","maleWorkers":"262","maleMedian":"934","femaleWorkers":"17","femaleMedian":"-"}}},"Computer, automated teller, and office machine repairers":{"ageData":{"2012":{"total":"296","16to19":"2","20to24":"29","25to34":"73","35to44":"73","45to54":"67","55to64":"40","65+":"13","medianAge":"40"}},"title":"Computer, automated teller, and office machine repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"296","women":"10.7","white":"10.8","black":"7.2","asian":"9.9"}},"wageData":{"2012":{"workers":"218","median":"854","maleWorkers":"193","maleMedian":"880","femaleWorkers":"26","femaleMedian":"-"}}},"Radio and telecommunications equipment installers and repairers":{"ageData":{"2012":{"total":"158","16to19":"1","20to24":"10","25to34":"39","35to44":"47","45to54":"31","55to64":"25","65+":"5","medianAge":"25"}},"title":"Radio and telecommunications equipment installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"158","women":"5.8","white":"11.2","black":"3.2","asian":"13.8"}},"wageData":{"2012":{"workers":"142","median":"885","maleWorkers":"132","maleMedian":"898","femaleWorkers":"10","femaleMedian":"-"}}},"Avionics technicians":{"ageData":{"2012":{"total":"14","16to19":"0","20to24":"1","25to34":"3","35to44":"3","45to54":"6","55to64":"1","65+":"0","medianAge":"1"}},"title":"Avionics technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"10","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Electric motor, power tool, and related repairers":{"ageData":{"2012":{"total":"37","16to19":"1","20to24":"5","25to34":"11","35to44":"8","45to54":"7","55to64":"3","65+":"1","medianAge":"3"}},"title":"Electric motor, power tool, and related repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"37","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"37","median":"-","maleWorkers":"37","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electrical and electronics installers and repairers, transportation equipment":{"ageData":{"2012":{"total":"5","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Electrical and electronics installers and repairers, transportation equipment","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electrical and electronics repairers, industrial and utility":{"ageData":{"2012":{"total":"12","16to19":"0","20to24":"0","25to34":"3","35to44":"2","45to54":"4","55to64":"3","65+":"1","medianAge":"3"}},"title":"Electrical and electronics repairers, industrial and utility","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"10","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electronic equipment installers and repairers, motor vehicles":{"ageData":{"2012":{"total":"18","16to19":"0","20to24":"0","25to34":"5","35to44":"4","45to54":"4","55to64":"5","65+":"0","medianAge":"5"}},"title":"Electronic equipment installers and repairers, motor vehicles","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"18","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"15","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Electronic home entertainment equipment installers and repairers":{"ageData":{"2012":{"total":"50","16to19":"1","20to24":"5","25to34":"14","35to44":"12","45to54":"13","55to64":"2","65+":"2","medianAge":"2"}},"title":"Electronic home entertainment equipment installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"50","women":"0.5","white":"11.6","black":"4.3","asian":"13.2"}},"wageData":{"2012":{"workers":"44","median":"-","maleWorkers":"44","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Security and fire alarm systems installers":{"ageData":{"2012":{"total":"41","16to19":"0","20to24":"4","25to34":"11","35to44":"11","45to54":"10","55to64":"3","65+":"2","medianAge":"3"}},"title":"Security and fire alarm systems installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"41","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"34","median":"-","maleWorkers":"34","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Aircraft mechanics and service technicians":{"ageData":{"2012":{"total":"153","16to19":"0","20to24":"11","25to34":"33","35to44":"28","45to54":"49","55to64":"26","65+":"5","medianAge":"26"}},"title":"Aircraft mechanics and service technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"153","women":"1.6","white":"7.5","black":"5.4","asian":"14.3"}},"wageData":{"2012":{"workers":"144","median":"993","maleWorkers":"142","maleMedian":"986","femaleWorkers":"2","femaleMedian":"-"}}},"Automotive body and related repairers":{"ageData":{"2012":{"total":"140","16to19":"4","20to24":"12","25to34":"36","35to44":"37","45to54":"27","55to64":"18","65+":"5","medianAge":"18"}},"title":"Automotive body and related repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"140","women":"1.8","white":"5.7","black":"2.3","asian":"25.3"}},"wageData":{"2012":{"workers":"120","median":"619","maleWorkers":"119","maleMedian":"618","femaleWorkers":"2","femaleMedian":"-"}}},"Automotive glass installers and repairers":{"ageData":{"2012":{"total":"22","16to19":"0","20to24":"2","25to34":"6","35to44":"9","45to54":"3","55to64":"2","65+":"0","medianAge":"2"}},"title":"Automotive glass installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"22","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"17","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Automotive service technicians and mechanics":{"ageData":{"2012":{"total":"867","16to19":"19","20to24":"107","25to34":"202","35to44":"203","45to54":"194","55to64":"121","65+":"23","medianAge":"121"}},"title":"Automotive service technicians and mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"867","women":"1.2","white":"9.6","black":"4.7","asian":"21.3"}},"wageData":{"2012":{"workers":"691","median":"702","maleWorkers":"684","maleMedian":"704","femaleWorkers":"7","femaleMedian":"-"}}},"Bus and truck mechanics and diesel engine specialists":{"ageData":{"2012":{"total":"316","16to19":"6","20to24":"25","25to34":"75","35to44":"64","45to54":"77","55to64":"56","65+":"14","medianAge":"56"}},"title":"Bus and truck mechanics and diesel engine specialists","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"316","women":"0.5","white":"8.6","black":"1.3","asian":"13.4"}},"wageData":{"2012":{"workers":"271","median":"843","maleWorkers":"271","maleMedian":"844","femaleWorkers":"1","femaleMedian":"-"}}},"Heavy vehicle and mobile equipment service technicians and mechanics":{"ageData":{"2012":{"total":"194","16to19":"1","20to24":"10","25to34":"39","35to44":"44","45to54":"61","55to64":"32","65+":"6","medianAge":"32"}},"title":"Heavy vehicle and mobile equipment service technicians and mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"194","women":"1.0","white":"5.4","black":"2.0","asian":"17.3"}},"wageData":{"2012":{"workers":"174","median":"941","maleWorkers":"171","maleMedian":"942","femaleWorkers":"3","femaleMedian":"-"}}},"Small engine mechanics":{"ageData":{"2012":{"total":"56","16to19":"1","20to24":"5","25to34":"18","35to44":"13","45to54":"9","55to64":"7","65+":"3","medianAge":"7"}},"title":"Small engine mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"56","women":"1.4","white":"4.9","black":"0.2","asian":"12.2"}},"wageData":{"2012":{"workers":"42","median":"-","maleWorkers":"41","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Miscellaneous vehicle and mobile equipment mechanics, installers, and repairers":{"ageData":{"2012":{"total":"87","16to19":"7","20to24":"23","25to34":"24","35to44":"17","45to54":"13","55to64":"3","65+":"1","medianAge":"3"}},"title":"Miscellaneous vehicle and mobile equipment mechanics, installers, and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"87","women":"1.8","white":"8.0","black":"0.0","asian":"31.4"}},"wageData":{"2012":{"workers":"67","median":"493","maleWorkers":"66","maleMedian":"496","femaleWorkers":"1","femaleMedian":"-"}}},"Control and valve installers and repairers":{"ageData":{"2012":{"total":"27","16to19":"0","20to24":"1","25to34":"5","35to44":"7","45to54":"10","55to64":"3","65+":"0","medianAge":"3"}},"title":"Control and valve installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"27","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"25","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Heating, air conditioning, and refrigeration mechanics and installers":{"ageData":{"2012":{"total":"340","16to19":"5","20to24":"27","25to34":"96","35to44":"81","45to54":"87","55to64":"37","65+":"6","medianAge":"37"}},"title":"Heating, air conditioning, and refrigeration mechanics and installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"340","women":"1.6","white":"7.1","black":"3.2","asian":"16.2"}},"wageData":{"2012":{"workers":"280","median":"827","maleWorkers":"276","maleMedian":"829","femaleWorkers":"4","femaleMedian":"-"}}},"Home appliance repairers":{"ageData":{"2012":{"total":"47","16to19":"0","20to24":"4","25to34":"13","35to44":"8","45to54":"9","55to64":"9","65+":"5","medianAge":"9"}},"title":"Home appliance repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"47","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"35","median":"-","maleWorkers":"33","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Industrial and refractory machinery mechanics":{"ageData":{"2012":{"total":"454","16to19":"4","20to24":"18","25to34":"71","35to44":"105","45to54":"138","55to64":"102","65+":"15","medianAge":"102"}},"title":"Industrial and refractory machinery mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"454","women":"1.9","white":"4.5","black":"2.9","asian":"13.3"}},"wageData":{"2012":{"workers":"424","median":"867","maleWorkers":"415","maleMedian":"871","femaleWorkers":"10","femaleMedian":"-"}}},"Maintenance and repair workers, general":{"ageData":{"2012":{"total":"442","16to19":"7","20to24":"18","25to34":"76","35to44":"110","45to54":"121","55to64":"90","65+":"19","medianAge":"90"}},"title":"Maintenance and repair workers, general","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"442","women":"2.2","white":"8.4","black":"3.2","asian":"19.4"}},"wageData":{"2012":{"workers":"371","median":"731","maleWorkers":"364","maleMedian":"732","femaleWorkers":"6","femaleMedian":"-"}}},"Maintenance workers, machinery":{"ageData":{"2012":{"total":"28","16to19":"1","20to24":"6","25to34":"8","35to44":"5","45to54":"4","55to64":"5","65+":"1","medianAge":"5"}},"title":"Maintenance workers, machinery","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"28","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"25","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Millwrights":{"ageData":{"2012":{"total":"53","16to19":"1","20to24":"1","25to34":"14","35to44":"11","45to54":"14","55to64":"12","65+":"0","medianAge":"12"}},"title":"Millwrights","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"53","women":"6.4","white":"2.1","black":"1.4","asian":"6.7"}},"wageData":{"2012":{"workers":"50","median":"938","maleWorkers":"46","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Electrical power-line installers and repairers":{"ageData":{"2012":{"total":"110","16to19":"0","20to24":"17","25to34":"31","35to44":"25","45to54":"24","55to64":"12","65+":"0","medianAge":"12"}},"title":"Electrical power-line installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"110","women":"2.4","white":"7.8","black":"0.3","asian":"7.9"}},"wageData":{"2012":{"workers":"117","median":"988","maleWorkers":"115","maleMedian":"990","femaleWorkers":"2","femaleMedian":"-"}}},"Telecommunications line installers and repairers":{"ageData":{"2012":{"total":"177","16to19":"1","20to24":"10","25to34":"50","35to44":"58","45to54":"36","55to64":"19","65+":"2","medianAge":"19"}},"title":"Telecommunications line installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"177","women":"4.8","white":"11.2","black":"1.9","asian":"15.7"}},"wageData":{"2012":{"workers":"171","median":"915","maleWorkers":"164","maleMedian":"910","femaleWorkers":"8","femaleMedian":"-"}}},"Precision instrument and equipment repairers":{"ageData":{"2012":{"total":"60","16to19":"0","20to24":"1","25to34":"10","35to44":"13","45to54":"16","55to64":"13","65+":"6","medianAge":"13"}},"title":"Precision instrument and equipment repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"60","women":"16.0","white":"9.1","black":"1.1","asian":"13.3"}},"wageData":{"2012":{"workers":"44","median":"-","maleWorkers":"38","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Wind turbine service technicians":{"ageData":{"2012":{"total":"3","16to19":"0","20to24":"1","25to34":"1","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Wind turbine service technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Coin, vending, and amusement machine servicers and repairers":{"ageData":{"2012":{"total":"33","16to19":"0","20to24":"3","25to34":"6","35to44":"8","45to54":"7","55to64":"6","65+":"1","medianAge":"6"}},"title":"Coin, vending, and amusement machine servicers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"23","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Commercial divers":{"ageData":{"2012":{"total":"3","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Commercial divers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Locksmiths and safe repairers":{"ageData":{"2012":{"total":"31","16to19":"0","20to24":"1","25to34":"3","35to44":"7","45to54":"12","55to64":"6","65+":"3","medianAge":"6"}},"title":"Locksmiths and safe repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"31","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"17","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Manufactured building and mobile home installers":{"ageData":{"2012":{"total":"5","16to19":"0","20to24":"1","25to34":"0","35to44":"2","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Manufactured building and mobile home installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Riggers":{"ageData":{"2012":{"total":"13","16to19":"0","20to24":"2","25to34":"1","35to44":"3","45to54":"4","55to64":"2","65+":"0","medianAge":"2"}},"title":"Riggers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"10","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Signal and track switch repairers":{"ageData":{"2012":{"total":"5","16to19":"0","20to24":"0","25to34":"1","35to44":"3","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Signal and track switch repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers--installation, maintenance, and repair workers":{"ageData":{"2012":{"total":"30","16to19":"4","20to24":"5","25to34":"8","35to44":"7","45to54":"4","55to64":"2","65+":"0","medianAge":"2"}},"title":"Helpers--installation, maintenance, and repair workers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"30","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"20","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Other installation, maintenance, and repair workers":{"ageData":{"2012":{"total":"205","16to19":"7","20to24":"18","25to34":"37","35to44":"51","45to54":"54","55to64":"25","65+":"15","medianAge":"25"}},"title":"Other installation, maintenance, and repair workers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2012":{"total":"205","women":"3.6","white":"5.9","black":"1.4","asian":"21.2"}},"wageData":{"2012":{"workers":"147","median":"677","maleWorkers":"142","maleMedian":"671","femaleWorkers":"5","femaleMedian":"-"}}},"Production, transportation, and material moving occupations":{"ageData":{"2012":{"total":"16,994","16to19":"447","20to24":"1,576","25to34":"3,360","35to44":"3,603","45to54":"4,296","55to64":"2,904","65+":"809","medianAge":"2,904"}},"title":"Production, transportation, and material moving occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2012":{"total":"16,994","women":"21.8","white":"13.8","black":"4.2","asian":"21.7"}},"wageData":{"2012":{"workers":"13,842","median":"624","maleWorkers":"11,069","maleMedian":"675","femaleWorkers":"2,773","femaleMedian":"493"}}},"Production occupations":{"ageData":{"2012":{"total":"8,455","16to19":"147","20to24":"748","25to34":"1,697","35to44":"1,885","45to54":"2,178","55to64":"1,481","65+":"319","medianAge":"1,481"}},"title":"Production occupations","depth":2,"parent":"Production, transportation, and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"8,455","women":"27.7","white":"11.6","black":"5.8","asian":"21.7"}},"wageData":{"2012":{"workers":"7,427","median":"627","maleWorkers":"5,497","maleMedian":"695","femaleWorkers":"1,930","femaleMedian":"496"}}},"First-line supervisors of production and operating workers":{"ageData":{"2012":{"total":"808","16to19":"1","20to24":"24","25to34":"115","35to44":"194","45to54":"265","55to64":"174","65+":"34","medianAge":"174"}},"title":"First-line supervisors of production and operating workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"808","women":"19.5","white":"9.4","black":"5.8","asian":"13.9"}},"wageData":{"2012":{"workers":"734","median":"917","maleWorkers":"601","maleMedian":"954","femaleWorkers":"132","femaleMedian":"674"}}},"Aircraft structure, surfaces, rigging, and systems assemblers":{"ageData":{"2012":{"total":"23","16to19":"1","20to24":"3","25to34":"5","35to44":"5","45to54":"3","55to64":"6","65+":"0","medianAge":"6"}},"title":"Aircraft structure, surfaces, rigging, and systems assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"23","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"22","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Electrical, electronics, and electromechanical assemblers":{"ageData":{"2012":{"total":"166","16to19":"2","20to24":"17","25to34":"25","35to44":"42","45to54":"42","55to64":"34","65+":"5","medianAge":"34"}},"title":"Electrical, electronics, and electromechanical assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"166","women":"52.8","white":"13.4","black":"16.3","asian":"24.0"}},"wageData":{"2012":{"workers":"155","median":"564","maleWorkers":"77","maleMedian":"620","femaleWorkers":"78","femaleMedian":"520"}}},"Engine and other machine assemblers":{"ageData":{"2012":{"total":"32","16to19":"0","20to24":"1","25to34":"5","35to44":"7","45to54":"11","55to64":"8","65+":"0","medianAge":"8"}},"title":"Engine and other machine assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"32","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"32","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Structural metal fabricators and fitters":{"ageData":{"2012":{"total":"25","16to19":"0","20to24":"2","25to34":"4","35to44":"8","45to54":"7","55to64":"3","65+":"1","medianAge":"3"}},"title":"Structural metal fabricators and fitters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"25","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"19","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Miscellaneous assemblers and fabricators":{"ageData":{"2012":{"total":"919","16to19":"25","20to24":"96","25to34":"189","35to44":"202","45to54":"225","55to64":"145","65+":"37","medianAge":"145"}},"title":"Miscellaneous assemblers and fabricators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"919","women":"38.4","white":"15.8","black":"6.9","asian":"19.3"}},"wageData":{"2012":{"workers":"833","median":"557","maleWorkers":"513","maleMedian":"606","femaleWorkers":"320","femaleMedian":"499"}}},"Bakers":{"ageData":{"2012":{"total":"199","16to19":"7","20to24":"36","25to34":"41","35to44":"31","45to54":"40","55to64":"34","65+":"10","medianAge":"34"}},"title":"Bakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"199","women":"53.9","white":"15.6","black":"5.1","asian":"28.4"}},"wageData":{"2012":{"workers":"121","median":"474","maleWorkers":"65","maleMedian":"501","femaleWorkers":"55","femaleMedian":"450"}}},"Butchers and other meat, poultry, and fish processing workers":{"ageData":{"2012":{"total":"311","16to19":"9","20to24":"40","25to34":"69","35to44":"82","45to54":"62","55to64":"32","65+":"17","medianAge":"32"}},"title":"Butchers and other meat, poultry, and fish processing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"311","women":"23.0","white":"13.5","black":"7.9","asian":"41.6"}},"wageData":{"2012":{"workers":"273","median":"507","maleWorkers":"208","maleMedian":"537","femaleWorkers":"64","femaleMedian":"417"}}},"Food and tobacco roasting, baking, and drying machine operators and tenders":{"ageData":{"2012":{"total":"11","16to19":"0","20to24":"2","25to34":"2","35to44":"3","45to54":"1","55to64":"1","65+":"1","medianAge":"1"}},"title":"Food and tobacco roasting, baking, and drying machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"10","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Food batchmakers":{"ageData":{"2012":{"total":"84","16to19":"5","20to24":"11","25to34":"19","35to44":"21","45to54":"13","55to64":"12","65+":"4","medianAge":"12"}},"title":"Food batchmakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"84","women":"59.6","white":"12.2","black":"5.7","asian":"33.5"}},"wageData":{"2012":{"workers":"59","median":"512","maleWorkers":"27","maleMedian":"-","femaleWorkers":"32","femaleMedian":"-"}}},"Food cooking machine operators and tenders":{"ageData":{"2012":{"total":"14","16to19":"1","20to24":"2","25to34":"2","35to44":"2","45to54":"3","55to64":"2","65+":"2","medianAge":"2"}},"title":"Food cooking machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"13","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Food processing workers, all other":{"ageData":{"2012":{"total":"117","16to19":"1","20to24":"23","25to34":"27","35to44":"24","45to54":"26","55to64":"13","65+":"3","medianAge":"13"}},"title":"Food processing workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"117","women":"29.5","white":"15.9","black":"5.9","asian":"34.6"}},"wageData":{"2012":{"workers":"90","median":"529","maleWorkers":"67","maleMedian":"549","femaleWorkers":"23","femaleMedian":"-"}}},"Computer control programmers and operators":{"ageData":{"2012":{"total":"67","16to19":"1","20to24":"3","25to34":"14","35to44":"15","45to54":"20","55to64":"13","65+":"2","medianAge":"13"}},"title":"Computer control programmers and operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"67","women":"8.4","white":"6.4","black":"3.3","asian":"17.1"}},"wageData":{"2012":{"workers":"67","median":"710","maleWorkers":"62","maleMedian":"728","femaleWorkers":"5","femaleMedian":"-"}}},"Extruding and drawing machine setters, operators, and tenders, metal and plastic":{"ageData":{"2012":{"total":"10","16to19":"0","20to24":"1","25to34":"3","35to44":"0","45to54":"4","55to64":"2","65+":"0","medianAge":"2"}},"title":"Extruding and drawing machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"10","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Forging machine setters, operators, and tenders, metal and plastic":{"ageData":{"2012":{"total":"10","16to19":"0","20to24":"1","25to34":"0","35to44":"3","45to54":"4","55to64":"2","65+":"0","medianAge":"2"}},"title":"Forging machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"10","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Rolling machine setters, operators, and tenders, metal and plastic":{"ageData":{"2012":{"total":"8","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"4","55to64":"0","65+":"0","medianAge":"0"}},"title":"Rolling machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Cutting, punching, and press machine setters, operators, and tenders, metal and plastic":{"ageData":{"2012":{"total":"87","16to19":"3","20to24":"13","25to34":"14","35to44":"18","45to54":"23","55to64":"15","65+":"1","medianAge":"15"}},"title":"Cutting, punching, and press machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"87","women":"18.9","white":"8.4","black":"3.3","asian":"22.9"}},"wageData":{"2012":{"workers":"80","median":"556","maleWorkers":"65","maleMedian":"575","femaleWorkers":"15","femaleMedian":"-"}}},"Drilling and boring machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2012":{"total":"3","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Drilling and boring machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"3","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Grinding, lapping, polishing, and buffing machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2012":{"total":"54","16to19":"4","20to24":"7","25to34":"15","35to44":"8","45to54":"8","55to64":"10","65+":"2","medianAge":"10"}},"title":"Grinding, lapping, polishing, and buffing machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"54","women":"6.6","white":"13.7","black":"0.7","asian":"21.8"}},"wageData":{"2012":{"workers":"53","median":"588","maleWorkers":"48","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Lathe and turning machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2012":{"total":"17","16to19":"0","20to24":"2","25to34":"1","35to44":"4","45to54":"7","55to64":"2","65+":"2","medianAge":"2"}},"title":"Lathe and turning machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"17","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"15","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Milling and planing machine setters, operators, and tenders, metal and plastic":{"ageData":{"2012":{"total":"3","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Milling and planing machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Machinists":{"ageData":{"2012":{"total":"397","16to19":"3","20to24":"28","25to34":"75","35to44":"90","45to54":"104","55to64":"80","65+":"16","medianAge":"80"}},"title":"Machinists","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"397","women":"3.8","white":"4.5","black":"4.9","asian":"11.7"}},"wageData":{"2012":{"workers":"381","median":"760","maleWorkers":"366","maleMedian":"762","femaleWorkers":"16","femaleMedian":"-"}}},"Metal furnace operators, tenders, pourers, and casters":{"ageData":{"2012":{"total":"17","16to19":"0","20to24":"1","25to34":"2","35to44":"3","45to54":"6","55to64":"4","65+":"0","medianAge":"4"}},"title":"Metal furnace operators, tenders, pourers, and casters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"17","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"12","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Model makers and patternmakers, metal and plastic":{"ageData":{"2012":{"total":"11","16to19":"0","20to24":"1","25to34":"0","35to44":"0","45to54":"4","55to64":"5","65+":"1","medianAge":"5"}},"title":"Model makers and patternmakers, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"7","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Molders and molding machine setters, operators, and tenders, metal and plastic":{"ageData":{"2012":{"total":"37","16to19":"1","20to24":"4","25to34":"8","35to44":"7","45to54":"7","55to64":"7","65+":"1","medianAge":"7"}},"title":"Molders and molding machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"37","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"38","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Multiple machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2012":{"total":"5","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Multiple machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Tool and die makers":{"ageData":{"2012":{"total":"56","16to19":"0","20to24":"0","25to34":"6","35to44":"8","45to54":"15","55to64":"22","65+":"5","medianAge":"22"}},"title":"Tool and die makers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"56","women":"0.8","white":"3.1","black":"5.6","asian":"4.3"}},"wageData":{"2012":{"workers":"51","median":"1,005","maleWorkers":"51","maleMedian":"1,005","femaleWorkers":"0","femaleMedian":"-"}}},"Welding, soldering, and brazing workers":{"ageData":{"2012":{"total":"593","16to19":"6","20to24":"60","25to34":"175","35to44":"143","45to54":"123","55to64":"74","65+":"12","medianAge":"74"}},"title":"Welding, soldering, and brazing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"593","women":"4.8","white":"8.7","black":"2.6","asian":"23.0"}},"wageData":{"2012":{"workers":"551","median":"712","maleWorkers":"525","maleMedian":"722","femaleWorkers":"26","femaleMedian":"-"}}},"Heat treating equipment setters, operators, and tenders, metal and plastic":{"ageData":{"2012":{"total":"4","16to19":"0","20to24":"1","25to34":"0","35to44":"0","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Heat treating equipment setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Layout workers, metal and plastic":{"ageData":{"2012":{"total":"4","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"2","65+":"0","medianAge":"2"}},"title":"Layout workers, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Plating and coating machine setters, operators, and tenders, metal and plastic":{"ageData":{"2012":{"total":"18","16to19":"0","20to24":"2","25to34":"3","35to44":"5","45to54":"5","55to64":"1","65+":"0","medianAge":"1"}},"title":"Plating and coating machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"18","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"16","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Tool grinders, filers, and sharpeners":{"ageData":{"2012":{"total":"3","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"2","65+":"0","medianAge":"2"}},"title":"Tool grinders, filers, and sharpeners","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Metal workers and plastic workers, all other":{"ageData":{"2012":{"total":"375","16to19":"3","20to24":"33","25to34":"84","35to44":"91","45to54":"93","55to64":"64","65+":"7","medianAge":"64"}},"title":"Metal workers and plastic workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"375","women":"19.5","white":"14.4","black":"6.6","asian":"26.0"}},"wageData":{"2012":{"workers":"374","median":"618","maleWorkers":"304","maleMedian":"645","femaleWorkers":"70","femaleMedian":"544"}}},"Prepress technicians and workers":{"ageData":{"2012":{"total":"33","16to19":"0","20to24":"2","25to34":"6","35to44":"9","45to54":"7","55to64":"5","65+":"4","medianAge":"5"}},"title":"Prepress technicians and workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"23","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Printing press operators":{"ageData":{"2012":{"total":"201","16to19":"3","20to24":"13","25to34":"33","35to44":"43","45to54":"66","55to64":"36","65+":"7","medianAge":"36"}},"title":"Printing press operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"201","women":"17.2","white":"10.1","black":"3.4","asian":"15.6"}},"wageData":{"2012":{"workers":"167","median":"628","maleWorkers":"139","maleMedian":"666","femaleWorkers":"28","femaleMedian":"-"}}},"Print binding and finishing workers":{"ageData":{"2012":{"total":"22","16to19":"0","20to24":"1","25to34":"1","35to44":"2","45to54":"7","55to64":"8","65+":"3","medianAge":"8"}},"title":"Print binding and finishing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"22","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"17","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Laundry and dry-cleaning workers":{"ageData":{"2012":{"total":"185","16to19":"8","20to24":"13","25to34":"36","35to44":"41","45to54":"41","55to64":"36","65+":"10","medianAge":"36"}},"title":"Laundry and dry-cleaning workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"185","women":"53.3","white":"20.8","black":"10.3","asian":"37.1"}},"wageData":{"2012":{"workers":"123","median":"410","maleWorkers":"57","maleMedian":"462","femaleWorkers":"66","femaleMedian":"359"}}},"Pressers, textile, garment, and related materials":{"ageData":{"2012":{"total":"54","16to19":"0","20to24":"0","25to34":"16","35to44":"12","45to54":"13","55to64":"7","65+":"5","medianAge":"7"}},"title":"Pressers, textile, garment, and related materials","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"54","women":"70.6","white":"17.0","black":"3.5","asian":"47.9"}},"wageData":{"2012":{"workers":"41","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"29","femaleMedian":"-"}}},"Sewing machine operators":{"ageData":{"2012":{"total":"166","16to19":"1","20to24":"8","25to34":"28","35to44":"31","45to54":"44","55to64":"39","65+":"15","medianAge":"39"}},"title":"Sewing machine operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"166","women":"74.2","white":"5.6","black":"11.4","asian":"43.8"}},"wageData":{"2012":{"workers":"127","median":"385","maleWorkers":"41","maleMedian":"-","femaleWorkers":"86","femaleMedian":"369"}}},"Shoe and leather workers and repairers":{"ageData":{"2012":{"total":"11","16to19":"0","20to24":"0","25to34":"1","35to44":"2","45to54":"5","55to64":"2","65+":"1","medianAge":"2"}},"title":"Shoe and leather workers and repairers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"5","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Shoe machine operators and tenders":{"ageData":{"2012":{"total":"11","16to19":"0","20to24":"2","25to34":"0","35to44":"3","45to54":"5","55to64":"0","65+":"1","medianAge":"0"}},"title":"Shoe machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"10","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Tailors, dressmakers, and sewers":{"ageData":{"2012":{"total":"86","16to19":"1","20to24":"1","25to34":"6","35to44":"16","45to54":"29","55to64":"18","65+":"15","medianAge":"18"}},"title":"Tailors, dressmakers, and sewers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"86","women":"77.1","white":"5.9","black":"19.5","asian":"24.9"}},"wageData":{"2012":{"workers":"42","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"30","femaleMedian":"-"}}},"Textile bleaching and dyeing machine operators and tenders":{"ageData":{"2012":{"total":"5","16to19":"0","20to24":"0","25to34":"2","35to44":"2","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Textile bleaching and dyeing machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Textile cutting machine setters, operators, and tenders":{"ageData":{"2012":{"total":"12","16to19":"0","20to24":"0","25to34":"1","35to44":"5","45to54":"3","55to64":"3","65+":"0","medianAge":"3"}},"title":"Textile cutting machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"9","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Textile knitting and weaving machine setters, operators, and tenders":{"ageData":{"2012":{"total":"7","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"5","55to64":"0","65+":"0","medianAge":"0"}},"title":"Textile knitting and weaving machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"6","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Textile winding, twisting, and drawing out machine setters, operators, and tenders":{"ageData":{"2012":{"total":"14","16to19":"0","20to24":"0","25to34":"1","35to44":"5","45to54":"4","55to64":"2","65+":"1","medianAge":"2"}},"title":"Textile winding, twisting, and drawing out machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"15","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Extruding and forming machine setters, operators, and tenders, synthetic and glass fibers":{"ageData":{"2012":{"total":"1","16to19":"0","20to24":"1","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Extruding and forming machine setters, operators, and tenders, synthetic and glass fibers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Fabric and apparel patternmakers":{"ageData":{"2012":{"total":"3","16to19":"0","20to24":"1","25to34":"0","35to44":"1","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Fabric and apparel patternmakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Upholsterers":{"ageData":{"2012":{"total":"34","16to19":"1","20to24":"1","25to34":"4","35to44":"8","45to54":"10","55to64":"9","65+":"2","medianAge":"9"}},"title":"Upholsterers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"34","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"14","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Textile, apparel, and furnishings workers, all other":{"ageData":{"2012":{"total":"14","16to19":"0","20to24":"0","25to34":"6","35to44":"2","45to54":"3","55to64":"4","65+":"0","medianAge":"4"}},"title":"Textile, apparel, and furnishings workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"16","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Cabinetmakers and bench carpenters":{"ageData":{"2012":{"total":"45","16to19":"1","20to24":"2","25to34":"8","35to44":"7","45to54":"14","55to64":"13","65+":"0","medianAge":"13"}},"title":"Cabinetmakers and bench carpenters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"45","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"35","median":"-","maleWorkers":"34","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Furniture finishers":{"ageData":{"2012":{"total":"7","16to19":"0","20to24":"1","25to34":"1","35to44":"3","45to54":"2","55to64":"1","65+":"1","medianAge":"1"}},"title":"Furniture finishers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"5","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Model makers and patternmakers, wood":{"ageData":{"2012":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Model makers and patternmakers, wood","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"0","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"0","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Sawing machine setters, operators, and tenders, wood":{"ageData":{"2012":{"total":"30","16to19":"0","20to24":"2","25to34":"4","35to44":"5","45to54":"10","55to64":"8","65+":"1","medianAge":"8"}},"title":"Sawing machine setters, operators, and tenders, wood","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"30","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"26","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Woodworking machine setters, operators, and tenders, except sawing":{"ageData":{"2012":{"total":"21","16to19":"1","20to24":"2","25to34":"4","35to44":"6","45to54":"5","55to64":"3","65+":"1","medianAge":"3"}},"title":"Woodworking machine setters, operators, and tenders, except sawing","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"21","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"21","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Woodworkers, all other":{"ageData":{"2012":{"total":"21","16to19":"2","20to24":"2","25to34":"5","35to44":"1","45to54":"4","55to64":"5","65+":"2","medianAge":"5"}},"title":"Woodworkers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"21","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"12","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Power plant operators, distributors, and dispatchers":{"ageData":{"2012":{"total":"44","16to19":"0","20to24":"2","25to34":"7","35to44":"12","45to54":"12","55to64":"10","65+":"1","medianAge":"10"}},"title":"Power plant operators, distributors, and dispatchers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"44","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"43","median":"-","maleWorkers":"41","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Stationary engineers and boiler operators":{"ageData":{"2012":{"total":"121","16to19":"0","20to24":"5","25to34":"20","35to44":"22","45to54":"35","55to64":"33","65+":"5","medianAge":"33"}},"title":"Stationary engineers and boiler operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"121","women":"5.5","white":"10.4","black":"4.3","asian":"13.8"}},"wageData":{"2012":{"workers":"105","median":"830","maleWorkers":"99","maleMedian":"831","femaleWorkers":"6","femaleMedian":"-"}}},"Water and wastewater treatment plant and system operators":{"ageData":{"2012":{"total":"72","16to19":"0","20to24":"0","25to34":"14","35to44":"13","45to54":"31","55to64":"11","65+":"2","medianAge":"11"}},"title":"Water and wastewater treatment plant and system operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"72","women":"4.5","white":"8.4","black":"1.7","asian":"19.6"}},"wageData":{"2012":{"workers":"70","median":"862","maleWorkers":"67","maleMedian":"870","femaleWorkers":"3","femaleMedian":"-"}}},"Miscellaneous plant and system operators":{"ageData":{"2012":{"total":"39","16to19":"0","20to24":"3","25to34":"7","35to44":"11","45to54":"9","55to64":"10","65+":"1","medianAge":"10"}},"title":"Miscellaneous plant and system operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"39","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"35","median":"-","maleWorkers":"31","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Chemical processing machine setters, operators, and tenders":{"ageData":{"2012":{"total":"68","16to19":"0","20to24":"8","25to34":"15","35to44":"14","45to54":"17","55to64":"13","65+":"0","medianAge":"13"}},"title":"Chemical processing machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"68","women":"16.2","white":"4.5","black":"0.8","asian":"10.7"}},"wageData":{"2012":{"workers":"72","median":"851","maleWorkers":"62","maleMedian":"890","femaleWorkers":"10","femaleMedian":"-"}}},"Crushing, grinding, polishing, mixing, and blending workers":{"ageData":{"2012":{"total":"100","16to19":"1","20to24":"8","25to34":"29","35to44":"19","45to54":"22","55to64":"17","65+":"4","medianAge":"17"}},"title":"Crushing, grinding, polishing, mixing, and blending workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"100","women":"15.0","white":"14.5","black":"6.8","asian":"18.4"}},"wageData":{"2012":{"workers":"86","median":"628","maleWorkers":"74","maleMedian":"651","femaleWorkers":"12","femaleMedian":"-"}}},"Cutting workers":{"ageData":{"2012":{"total":"67","16to19":"2","20to24":"7","25to34":"13","35to44":"15","45to54":"19","55to64":"10","65+":"0","medianAge":"10"}},"title":"Cutting workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"67","women":"19.2","white":"14.1","black":"3.5","asian":"15.8"}},"wageData":{"2012":{"workers":"60","median":"524","maleWorkers":"49","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Extruding, forming, pressing, and compacting machine setters, operators, and tenders":{"ageData":{"2012":{"total":"45","16to19":"1","20to24":"1","25to34":"10","35to44":"12","45to54":"15","55to64":"6","65+":"0","medianAge":"6"}},"title":"Extruding, forming, pressing, and compacting machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"45","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"38","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Furnace, kiln, oven, drier, and kettle operators and tenders":{"ageData":{"2012":{"total":"16","16to19":"0","20to24":"3","25to34":"4","35to44":"3","45to54":"6","55to64":"1","65+":"0","medianAge":"1"}},"title":"Furnace, kiln, oven, drier, and kettle operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"16","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"14","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Inspectors, testers, sorters, samplers, and weighers":{"ageData":{"2012":{"total":"689","16to19":"6","20to24":"51","25to34":"124","35to44":"157","45to54":"188","55to64":"138","65+":"25","medianAge":"138"}},"title":"Inspectors, testers, sorters, samplers, and weighers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"689","women":"33.4","white":"11.5","black":"6.7","asian":"13.6"}},"wageData":{"2012":{"workers":"621","median":"729","maleWorkers":"416","maleMedian":"824","femaleWorkers":"206","femaleMedian":"570"}}},"Jewelers and precious stone and metal workers":{"ageData":{"2012":{"total":"46","16to19":"0","20to24":"1","25to34":"9","35to44":"4","45to54":"14","55to64":"9","65+":"8","medianAge":"9"}},"title":"Jewelers and precious stone and metal workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"46","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"22","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Medical, dental, and ophthalmic laboratory technicians":{"ageData":{"2012":{"total":"95","16to19":"2","20to24":"15","25to34":"15","35to44":"24","45to54":"17","55to64":"18","65+":"5","medianAge":"18"}},"title":"Medical, dental, and ophthalmic laboratory technicians","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"95","women":"50.7","white":"1.6","black":"8.9","asian":"15.9"}},"wageData":{"2012":{"workers":"76","median":"585","maleWorkers":"35","maleMedian":"-","femaleWorkers":"42","femaleMedian":"-"}}},"Packaging and filling machine operators and tenders":{"ageData":{"2012":{"total":"261","16to19":"7","20to24":"22","25to34":"55","35to44":"57","45to54":"75","55to64":"40","65+":"5","medianAge":"40"}},"title":"Packaging and filling machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"261","women":"52.3","white":"14.1","black":"8.8","asian":"38.0"}},"wageData":{"2012":{"workers":"242","median":"481","maleWorkers":"111","maleMedian":"553","femaleWorkers":"131","femaleMedian":"431"}}},"Painting workers":{"ageData":{"2012":{"total":"150","16to19":"3","20to24":"20","25to34":"41","35to44":"33","45to54":"37","55to64":"12","65+":"4","medianAge":"12"}},"title":"Painting workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"150","women":"15.1","white":"5.7","black":"4.3","asian":"34.9"}},"wageData":{"2012":{"workers":"135","median":"626","maleWorkers":"111","maleMedian":"654","femaleWorkers":"24","femaleMedian":"-"}}},"Photographic process workers and processing machine operators":{"ageData":{"2012":{"total":"55","16to19":"1","20to24":"10","25to34":"20","35to44":"10","45to54":"8","55to64":"6","65+":"0","medianAge":"6"}},"title":"Photographic process workers and processing machine operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"55","women":"45.6","white":"13.3","black":"4.9","asian":"18.7"}},"wageData":{"2012":{"workers":"39","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"15","femaleMedian":"-"}}},"Semiconductor processors":{"ageData":{"2012":{"total":"4","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Semiconductor processors","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"6","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Adhesive bonding machine operators and tenders":{"ageData":{"2012":{"total":"9","16to19":"0","20to24":"3","25to34":"2","35to44":"3","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Adhesive bonding machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"8","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Cleaning, washing, and metal pickling equipment operators and tenders":{"ageData":{"2012":{"total":"7","16to19":"0","20to24":"0","25to34":"2","35to44":"3","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Cleaning, washing, and metal pickling equipment operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"8","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Cooling and freezing equipment operators and tenders":{"ageData":{"2012":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Cooling and freezing equipment operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Etchers and engravers":{"ageData":{"2012":{"total":"6","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"3","55to64":"1","65+":"0","medianAge":"1"}},"title":"Etchers and engravers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"4","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Molders, shapers, and casters, except metal and plastic":{"ageData":{"2012":{"total":"41","16to19":"0","20to24":"4","25to34":"8","35to44":"8","45to54":"10","55to64":"8","65+":"4","medianAge":"8"}},"title":"Molders, shapers, and casters, except metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"41","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"26","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Paper goods machine setters, operators, and tenders":{"ageData":{"2012":{"total":"35","16to19":"1","20to24":"2","25to34":"7","35to44":"10","45to54":"10","55to64":"5","65+":"0","medianAge":"5"}},"title":"Paper goods machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"35","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"32","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Tire builders":{"ageData":{"2012":{"total":"19","16to19":"1","20to24":"3","25to34":"6","35to44":"3","45to54":"3","55to64":"2","65+":"1","medianAge":"2"}},"title":"Tire builders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"17","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Helpers--production workers":{"ageData":{"2012":{"total":"59","16to19":"6","20to24":"11","25to34":"11","35to44":"13","45to54":"11","55to64":"4","65+":"3","medianAge":"4"}},"title":"Helpers--production workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"59","women":"34.8","white":"19.8","black":"2.9","asian":"30.6"}},"wageData":{"2012":{"workers":"40","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Production workers, all other":{"ageData":{"2012":{"total":"933","16to19":"24","20to24":"99","25to34":"206","35to44":"213","45to54":"226","55to64":"148","65+":"16","medianAge":"148"}},"title":"Production workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2012":{"total":"933","women":"26.3","white":"13.7","black":"4.0","asian":"21.5"}},"wageData":{"2012":{"workers":"849","median":"584","maleWorkers":"626","maleMedian":"619","femaleWorkers":"223","femaleMedian":"504"}}},"Transportation and material moving occupations":{"ageData":{"2012":{"total":"8,540","16to19":"299","20to24":"828","25to34":"1,663","35to44":"1,718","45to54":"2,118","55to64":"1,424","65+":"490","medianAge":"1,424"}},"title":"Transportation and material moving occupations","depth":2,"parent":"Production, transportation, and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"8,540","women":"15.9","white":"15.9","black":"2.7","asian":"21.7"}},"wageData":{"2012":{"workers":"6,415","median":"621","maleWorkers":"5,572","maleMedian":"650","femaleWorkers":"843","femaleMedian":"487"}}},"Supervisors of transportation and material moving workers":{"ageData":{"2012":{"total":"200","16to19":"0","20to24":"16","25to34":"51","35to44":"41","45to54":"54","55to64":"35","65+":"3","medianAge":"35"}},"title":"Supervisors of transportation and material moving workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"200","women":"23.0","white":"13.5","black":"4.4","asian":"18.4"}},"wageData":{"2012":{"workers":"189","median":"812","maleWorkers":"146","maleMedian":"873","femaleWorkers":"42","femaleMedian":"-"}}},"Aircraft pilots and flight engineers":{"ageData":{"2012":{"total":"129","16to19":"0","20to24":"3","25to34":"22","35to44":"27","45to54":"41","55to64":"30","65+":"6","medianAge":"30"}},"title":"Aircraft pilots and flight engineers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"129","women":"4.1","white":"2.7","black":"2.5","asian":"5.0"}},"wageData":{"2012":{"workers":"90","median":"1,440","maleWorkers":"86","maleMedian":"1,444","femaleWorkers":"4","femaleMedian":"-"}}},"Air traffic controllers and airfield operations specialists":{"ageData":{"2012":{"total":"44","16to19":"0","20to24":"0","25to34":"14","35to44":"10","45to54":"11","55to64":"7","65+":"2","medianAge":"7"}},"title":"Air traffic controllers and airfield operations specialists","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"44","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"47","median":"-","maleWorkers":"44","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Flight attendants":{"ageData":{"2012":{"total":"88","16to19":"0","20to24":"1","25to34":"12","35to44":"18","45to54":"30","55to64":"20","65+":"6","medianAge":"20"}},"title":"Flight attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"88","women":"77.6","white":"11.8","black":"5.9","asian":"10.5"}},"wageData":{"2012":{"workers":"59","median":"775","maleWorkers":"16","maleMedian":"-","femaleWorkers":"42","femaleMedian":"-"}}},"Ambulance drivers and attendants, except emergency medical technicians":{"ageData":{"2012":{"total":"20","16to19":"0","20to24":"1","25to34":"6","35to44":"4","45to54":"4","55to64":"3","65+":"1","medianAge":"3"}},"title":"Ambulance drivers and attendants, except emergency medical technicians","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"20","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"16","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Bus drivers":{"ageData":{"2012":{"total":"558","16to19":"1","20to24":"7","25to34":"45","35to44":"83","45to54":"167","55to64":"167","65+":"87","medianAge":"167"}},"title":"Bus drivers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"558","women":"45.5","white":"25.3","black":"2.3","asian":"12.9"}},"wageData":{"2012":{"workers":"302","median":"601","maleWorkers":"177","maleMedian":"652","femaleWorkers":"126","femaleMedian":"516"}}},"Driver/sales workers and truck drivers":{"ageData":{"2012":{"total":"3,201","16to19":"37","20to24":"171","25to34":"569","35to44":"714","45to54":"911","55to64":"602","65+":"196","medianAge":"602"}},"title":"Driver/sales workers and truck drivers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"3,201","women":"5.4","white":"14.0","black":"1.6","asian":"19.3"}},"wageData":{"2012":{"workers":"2,533","median":"730","maleWorkers":"2,433","maleMedian":"736","femaleWorkers":"101","femaleMedian":"537"}}},"Taxi drivers and chauffeurs":{"ageData":{"2012":{"total":"336","16to19":"2","20to24":"15","25to34":"42","35to44":"63","45to54":"93","55to64":"80","65+":"40","medianAge":"80"}},"title":"Taxi drivers and chauffeurs","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"336","women":"13.2","white":"24.8","black":"13.8","asian":"16.0"}},"wageData":{"2012":{"workers":"183","median":"554","maleWorkers":"161","maleMedian":"572","femaleWorkers":"22","femaleMedian":"-"}}},"Motor vehicle operators, all other":{"ageData":{"2012":{"total":"63","16to19":"0","20to24":"1","25to34":"6","35to44":"10","45to54":"10","55to64":"10","65+":"25","medianAge":"10"}},"title":"Motor vehicle operators, all other","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"63","women":"13.3","white":"14.4","black":"1.4","asian":"10.5"}},"wageData":{"2012":{"workers":"35","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Locomotive engineers and operators":{"ageData":{"2012":{"total":"41","16to19":"0","20to24":"0","25to34":"6","35to44":"12","45to54":"13","55to64":"9","65+":"1","medianAge":"9"}},"title":"Locomotive engineers and operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"41","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"44","median":"-","maleWorkers":"42","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Railroad brake, signal, and switch operators":{"ageData":{"2012":{"total":"10","16to19":"0","20to24":"2","25to34":"1","35to44":"2","45to54":"3","55to64":"2","65+":"0","medianAge":"2"}},"title":"Railroad brake, signal, and switch operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"9","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Railroad conductors and yardmasters":{"ageData":{"2012":{"total":"52","16to19":"1","20to24":"6","25to34":"15","35to44":"13","45to54":"9","55to64":"8","65+":"0","medianAge":"8"}},"title":"Railroad conductors and yardmasters","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"52","women":"5.6","white":"16.2","black":"0.7","asian":"12.5"}},"wageData":{"2012":{"workers":"46","median":"-","maleWorkers":"45","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Subway, streetcar, and other rail transportation workers":{"ageData":{"2012":{"total":"11","16to19":"0","20to24":"2","25to34":"3","35to44":"2","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Subway, streetcar, and other rail transportation workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"12","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Sailors and marine oilers":{"ageData":{"2012":{"total":"16","16to19":"2","20to24":"1","25to34":"7","35to44":"2","45to54":"2","55to64":"2","65+":"1","medianAge":"2"}},"title":"Sailors and marine oilers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"16","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"15","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Ship and boat captains and operators":{"ageData":{"2012":{"total":"37","16to19":"0","20to24":"2","25to34":"6","35to44":"8","45to54":"10","55to64":"8","65+":"3","medianAge":"8"}},"title":"Ship and boat captains and operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"37","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"29","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Ship engineers":{"ageData":{"2012":{"total":"7","16to19":"0","20to24":"0","25to34":"1","35to44":"3","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Ship engineers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Bridge and lock tenders":{"ageData":{"2012":{"total":"7","16to19":"0","20to24":"0","25to34":"0","35to44":"2","45to54":"2","55to64":"3","65+":"0","medianAge":"3"}},"title":"Bridge and lock tenders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"8","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Parking lot attendants":{"ageData":{"2012":{"total":"81","16to19":"6","20to24":"28","25to34":"8","35to44":"10","45to54":"14","55to64":"10","65+":"5","medianAge":"10"}},"title":"Parking lot attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"81","women":"11.6","white":"23.5","black":"5.3","asian":"35.5"}},"wageData":{"2012":{"workers":"50","median":"404","maleWorkers":"45","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Automotive and watercraft service attendants":{"ageData":{"2012":{"total":"94","16to19":"14","20to24":"23","25to34":"23","35to44":"10","45to54":"13","55to64":"10","65+":"1","medianAge":"10"}},"title":"Automotive and watercraft service attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"94","women":"9.2","white":"12.9","black":"5.2","asian":"12.5"}},"wageData":{"2012":{"workers":"67","median":"428","maleWorkers":"63","maleMedian":"453","femaleWorkers":"4","femaleMedian":"-"}}},"Transportation inspectors":{"ageData":{"2012":{"total":"36","16to19":"0","20to24":"2","25to34":"8","35to44":"6","45to54":"8","55to64":"11","65+":"2","medianAge":"11"}},"title":"Transportation inspectors","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"36","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"29","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Transportation attendants, except flight attendants":{"ageData":{"2012":{"total":"38","16to19":"2","20to24":"4","25to34":"7","35to44":"4","45to54":"7","55to64":"11","65+":"4","medianAge":"11"}},"title":"Transportation attendants, except flight attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"38","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"23","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"15","femaleMedian":"-"}}},"Other transportation workers":{"ageData":{"2012":{"total":"17","16to19":"1","20to24":"5","25to34":"1","35to44":"3","45to54":"4","55to64":"3","65+":"0","medianAge":"3"}},"title":"Other transportation workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"17","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"14","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Conveyor operators and tenders":{"ageData":{"2012":{"total":"4","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"3","55to64":"0","65+":"0","medianAge":"0"}},"title":"Conveyor operators and tenders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"3","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Crane and tower operators":{"ageData":{"2012":{"total":"62","16to19":"1","20to24":"5","25to34":"11","35to44":"14","45to54":"18","55to64":"11","65+":"3","medianAge":"11"}},"title":"Crane and tower operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"62","women":"4.0","white":"12.3","black":"0.9","asian":"12.2"}},"wageData":{"2012":{"workers":"61","median":"753","maleWorkers":"58","maleMedian":"777","femaleWorkers":"3","femaleMedian":"-"}}},"Dredge, excavating, and loading machine operators":{"ageData":{"2012":{"total":"42","16to19":"0","20to24":"4","25to34":"6","35to44":"7","45to54":"14","55to64":"8","65+":"4","medianAge":"8"}},"title":"Dredge, excavating, and loading machine operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"42","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"32","median":"-","maleWorkers":"31","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Hoist and winch operators":{"ageData":{"2012":{"total":"5","16to19":"0","20to24":"1","25to34":"0","35to44":"1","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Hoist and winch operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Industrial truck and tractor operators":{"ageData":{"2012":{"total":"537","16to19":"6","20to24":"50","25to34":"162","35to44":"122","45to54":"132","55to64":"59","65+":"6","medianAge":"59"}},"title":"Industrial truck and tractor operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"537","women":"7.4","white":"18.4","black":"1.6","asian":"31.3"}},"wageData":{"2012":{"workers":"498","median":"562","maleWorkers":"467","maleMedian":"566","femaleWorkers":"31","femaleMedian":"-"}}},"Cleaners of vehicles and equipment":{"ageData":{"2012":{"total":"315","16to19":"33","20to24":"64","25to34":"73","35to44":"61","45to54":"50","55to64":"25","65+":"9","medianAge":"25"}},"title":"Cleaners of vehicles and equipment","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"315","women":"15.2","white":"16.8","black":"2.7","asian":"35.9"}},"wageData":{"2012":{"workers":"217","median":"425","maleWorkers":"187","maleMedian":"431","femaleWorkers":"30","femaleMedian":"-"}}},"Laborers and freight, stock, and material movers, hand":{"ageData":{"2012":{"total":"1,849","16to19":"146","20to24":"356","25to34":"408","35to44":"324","45to54":"348","55to64":"211","65+":"58","medianAge":"211"}},"title":"Laborers and freight, stock, and material movers, hand","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"1,849","women":"18.7","white":"15.9","black":"2.5","asian":"23.0"}},"wageData":{"2012":{"workers":"1,322","median":"510","maleWorkers":"1,103","maleMedian":"519","femaleWorkers":"218","femaleMedian":"476"}}},"Machine feeders and offbearers":{"ageData":{"2012":{"total":"27","16to19":"1","20to24":"3","25to34":"5","35to44":"4","45to54":"6","55to64":"6","65+":"1","medianAge":"6"}},"title":"Machine feeders and offbearers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"27","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"26","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Packers and packagers, hand":{"ageData":{"2012":{"total":"431","16to19":"43","20to24":"46","25to34":"100","35to44":"93","45to54":"88","55to64":"45","65+":"16","medianAge":"45"}},"title":"Packers and packagers, hand","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"431","women":"53.1","white":"14.0","black":"3.5","asian":"42.0"}},"wageData":{"2012":{"workers":"306","median":"404","maleWorkers":"146","maleMedian":"426","femaleWorkers":"160","femaleMedian":"394"}}},"Pumping station operators":{"ageData":{"2012":{"total":"25","16to19":"0","20to24":"0","25to34":"9","35to44":"4","45to54":"7","55to64":"4","65+":"2","medianAge":"4"}},"title":"Pumping station operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"25","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"21","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Refuse and recyclable material collectors":{"ageData":{"2012":{"total":"106","16to19":"3","20to24":"9","25to34":"23","35to44":"27","45to54":"30","55to64":"11","65+":"4","medianAge":"11"}},"title":"Refuse and recyclable material collectors","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"106","women":"6.6","white":"24.9","black":"1.4","asian":"29.4"}},"wageData":{"2012":{"workers":"75","median":"501","maleWorkers":"71","maleMedian":"497","femaleWorkers":"3","femaleMedian":"-"}}},"Mine shuttle car operators":{"ageData":{"2012":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Mine shuttle car operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Tank car, truck, and ship loaders":{"ageData":{"2012":{"total":"4","16to19":"0","20to24":"1","25to34":"1","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Tank car, truck, and ship loaders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Material moving workers, all other":{"ageData":{"2012":{"total":"45","16to19":"1","20to24":"1","25to34":"9","35to44":"12","45to54":"9","55to64":"10","65+":"4","medianAge":"10"}},"title":"Material moving workers, all other","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2012":{"total":"45","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2012":{"workers":"40","median":"-","maleWorkers":"39","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}}}');


var $577b8123572c4454$exports = {};
$577b8123572c4454$exports = JSON.parse('{"Total":{"ageData":{"2011":{"total":"139,869","16to19":"4,327","20to24":"13,036","25to34":"30,537","35to44":"30,270","45to54":"32,867","55to64":"22,186","65+":"6,647","medianAge":"22,186"}},"title":"Total","depth":1,"parent":"","sexRaceEthnicityData":{"2011":{"total":"139,869","women":"46.9","white":"10.8","black":"4.9","asian":"14.5"}},"wageData":{"2011":{"workers":"100,457","median":"$756","maleWorkers":"55,971","maleMedian":"$832","femaleWorkers":"44,486","femaleMedian":"$684"}}},"Management, professional, and related occupations":{"ageData":{"2011":{"total":"52,547","16to19":"290","20to24":"2,611","25to34":"11,643","35to44":"12,574","45to54":"13,277","55to64":"9,383","65+":"2,768","medianAge":"9,383"}},"title":"Management, professional, and related occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2011":{"total":"52,547","women":"51.4","white":"8.4","black":"6.1","asian":"7.5"}},"wageData":{"2011":{"workers":"39,791","median":"1,082","maleWorkers":"19,267","maleMedian":"1,269","femaleWorkers":"20,524","femaleMedian":"941"}}},"Management, business, and financial operations occupations":{"ageData":{"2011":{"total":"21,589","16to19":"57","20to24":"777","25to34":"4,091","35to44":"5,274","45to54":"6,014","55to64":"4,048","65+":"1,329","medianAge":"4,048"}},"title":"Management, business, and financial operations occupations","depth":2,"parent":"Management, professional, and related occupations","sexRaceEthnicityData":{"2011":{"total":"21,589","women":"43.1","white":"7.3","black":"5.1","asian":"7.7"}},"wageData":{"2011":{"workers":"16,061","median":"1,160","maleWorkers":"8,676","maleMedian":"1,370","femaleWorkers":"7,386","femaleMedian":"977"}}},"Management occupations":{"ageData":{"2011":{"total":"15,250","16to19":"42","20to24":"451","25to34":"2,574","35to44":"3,724","45to54":"4,437","55to64":"3,003","65+":"1,019","medianAge":"3,003"}},"title":"Management occupations","depth":3,"parent":"Management, business, and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"15,250","women":"38.1","white":"6.3","black":"4.6","asian":"7.7"}},"wageData":{"2011":{"workers":"10,891","median":"1,237","maleWorkers":"6,451","maleMedian":"1,427","femaleWorkers":"4,440","femaleMedian":"1,018"}}},"Chief executives":{"ageData":{"2011":{"total":"1,515","16to19":"1","20to24":"8","25to34":"116","35to44":"291","45to54":"556","55to64":"392","65+":"150","medianAge":"392"}},"title":"Chief executives","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"1,515","women":"24.2","white":"2.7","black":"3.0","asian":"4.1"}},"wageData":{"2011":{"workers":"990","median":"1,963","maleWorkers":"745","maleMedian":"2,122","femaleWorkers":"245","femaleMedian":"1,464"}}},"General and operations managers":{"ageData":{"2011":{"total":"978","16to19":"1","20to24":"19","25to34":"175","35to44":"253","45to54":"324","55to64":"182","65+":"25","medianAge":"182"}},"title":"General and operations managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"978","women":"30.4","white":"6.6","black":"2.7","asian":"7.6"}},"wageData":{"2011":{"workers":"921","median":"1,191","maleWorkers":"651","maleMedian":"1,319","femaleWorkers":"270","femaleMedian":"972"}}},"Legislators":{"ageData":{"2011":{"total":"16","16to19":"0","20to24":"0","25to34":"1","35to44":"4","45to54":"3","55to64":"2","65+":"5","medianAge":"2"}},"title":"Legislators","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"16","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"13","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Advertising and promotions managers":{"ageData":{"2011":{"total":"87","16to19":"0","20to24":"5","25to34":"28","35to44":"23","45to54":"15","55to64":"11","65+":"3","medianAge":"11"}},"title":"Advertising and promotions managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"87","women":"50.5","white":"1.6","black":"1.5","asian":"5.6"}},"wageData":{"2011":{"workers":"68","median":"1,164","maleWorkers":"28","maleMedian":"-","femaleWorkers":"40","femaleMedian":"-"}}},"Marketing and sales managers":{"ageData":{"2011":{"total":"1,009","16to19":"4","20to24":"36","25to34":"258","35to44":"301","45to54":"262","55to64":"125","65+":"24","medianAge":"125"}},"title":"Marketing and sales managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"1,009","women":"45.8","white":"5.6","black":"5.6","asian":"6.6"}},"wageData":{"2011":{"workers":"891","median":"1,408","maleWorkers":"499","maleMedian":"1,660","femaleWorkers":"392","femaleMedian":"1,127"}}},"Public relations and fundraising managers":{"ageData":{"2011":{"total":"63","16to19":"0","20to24":"1","25to34":"16","35to44":"16","45to54":"20","55to64":"9","65+":"2","medianAge":"9"}},"title":"Public relations and fundraising managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"63","women":"52.4","white":"2.8","black":"0.4","asian":"3.1"}},"wageData":{"2011":{"workers":"62","median":"1,475","maleWorkers":"33","maleMedian":"-","femaleWorkers":"29","femaleMedian":"-"}}},"Administrative services managers":{"ageData":{"2011":{"total":"128","16to19":"2","20to24":"3","25to34":"17","35to44":"25","45to54":"45","55to64":"28","65+":"8","medianAge":"28"}},"title":"Administrative services managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"128","women":"39.5","white":"6.9","black":"2.2","asian":"7.3"}},"wageData":{"2011":{"workers":"115","median":"1,021","maleWorkers":"71","maleMedian":"1,170","femaleWorkers":"44","femaleMedian":"-"}}},"Computer and information systems managers":{"ageData":{"2011":{"total":"553","16to19":"0","20to24":"10","25to34":"103","35to44":"199","45to54":"162","55to64":"74","65+":"6","medianAge":"74"}},"title":"Computer and information systems managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"553","women":"25.3","white":"5.7","black":"12.9","asian":"3.8"}},"wageData":{"2011":{"workers":"530","median":"1,579","maleWorkers":"392","maleMedian":"1,595","femaleWorkers":"138","femaleMedian":"1,543"}}},"Financial managers":{"ageData":{"2011":{"total":"1,107","16to19":"1","20to24":"43","25to34":"242","35to44":"308","45to54":"300","55to64":"176","65+":"39","medianAge":"176"}},"title":"Financial managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"1,107","women":"54.2","white":"6.5","black":"5.8","asian":"8.7"}},"wageData":{"2011":{"workers":"1,044","median":"1,166","maleWorkers":"477","maleMedian":"1,504","femaleWorkers":"567","femaleMedian":"991"}}},"Compensation and benefits managers":{"ageData":{"2011":{"total":"21","16to19":"0","20to24":"0","25to34":"5","35to44":"4","45to54":"7","55to64":"4","65+":"0","medianAge":"4"}},"title":"Compensation and benefits managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"21","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"21","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"14","femaleMedian":"-"}}},"Human resources managers":{"ageData":{"2011":{"total":"243","16to19":"0","20to24":"7","25to34":"39","35to44":"78","45to54":"71","55to64":"44","65+":"4","medianAge":"44"}},"title":"Human resources managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"243","women":"73.6","white":"11.3","black":"2.1","asian":"9.5"}},"wageData":{"2011":{"workers":"207","median":"1,331","maleWorkers":"58","maleMedian":"1,488","femaleWorkers":"149","femaleMedian":"1,273"}}},"Training and development managers":{"ageData":{"2011":{"total":"38","16to19":"0","20to24":"1","25to34":"7","35to44":"10","45to54":"9","55to64":"9","65+":"1","medianAge":"9"}},"title":"Training and development managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"38","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"36","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Industrial production managers":{"ageData":{"2011":{"total":"259","16to19":"1","20to24":"4","25to34":"38","35to44":"76","45to54":"81","55to64":"55","65+":"4","medianAge":"55"}},"title":"Industrial production managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"259","women":"16.5","white":"3.9","black":"5.1","asian":"8.9"}},"wageData":{"2011":{"workers":"250","median":"1,211","maleWorkers":"204","maleMedian":"1,245","femaleWorkers":"45","femaleMedian":"-"}}},"Purchasing managers":{"ageData":{"2011":{"total":"204","16to19":"0","20to24":"2","25to34":"34","35to44":"44","45to54":"73","55to64":"41","65+":"9","medianAge":"41"}},"title":"Purchasing managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"204","women":"47.3","white":"8.8","black":"2.1","asian":"8.8"}},"wageData":{"2011":{"workers":"183","median":"1,242","maleWorkers":"94","maleMedian":"1,368","femaleWorkers":"89","femaleMedian":"1,026"}}},"Transportation, storage, and distribution managers":{"ageData":{"2011":{"total":"254","16to19":"0","20to24":"13","25to34":"52","35to44":"71","45to54":"68","55to64":"42","65+":"8","medianAge":"42"}},"title":"Transportation, storage, and distribution managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"254","women":"14.1","white":"8.7","black":"3.0","asian":"8.9"}},"wageData":{"2011":{"workers":"229","median":"882","maleWorkers":"196","maleMedian":"861","femaleWorkers":"33","femaleMedian":"-"}}},"Farmers, ranchers, and other agricultural managers":{"ageData":{"2011":{"total":"978","16to19":"5","20to24":"28","25to34":"92","35to44":"122","45to54":"214","55to64":"253","65+":"264","medianAge":"253"}},"title":"Farmers, ranchers, and other agricultural managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"978","women":"23.0","white":"0.9","black":"0.8","asian":"4.1"}},"wageData":{"2011":{"workers":"98","median":"800","maleWorkers":"81","maleMedian":"855","femaleWorkers":"17","femaleMedian":"-"}}},"Construction managers":{"ageData":{"2011":{"total":"926","16to19":"0","20to24":"18","25to34":"157","35to44":"235","45to54":"294","55to64":"182","65+":"40","medianAge":"182"}},"title":"Construction managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"926","women":"6.1","white":"3.0","black":"1.5","asian":"9.7"}},"wageData":{"2011":{"workers":"464","median":"1,268","maleWorkers":"433","maleMedian":"1,325","femaleWorkers":"31","femaleMedian":"-"}}},"Education administrators":{"ageData":{"2011":{"total":"853","16to19":"0","20to24":"16","25to34":"146","35to44":"224","45to54":"220","55to64":"202","65+":"45","medianAge":"202"}},"title":"Education administrators","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"853","women":"65.2","white":"13.3","black":"2.9","asian":"6.5"}},"wageData":{"2011":{"workers":"735","median":"1,228","maleWorkers":"268","maleMedian":"1,532","femaleWorkers":"467","femaleMedian":"1,061"}}},"Architectural and engineering managers":{"ageData":{"2011":{"total":"106","16to19":"0","20to24":"1","25to34":"10","35to44":"30","45to54":"39","55to64":"20","65+":"5","medianAge":"20"}},"title":"Architectural and engineering managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"106","women":"8.5","white":"1.3","black":"5.9","asian":"4.7"}},"wageData":{"2011":{"workers":"98","median":"1,914","maleWorkers":"91","maleMedian":"1,908","femaleWorkers":"7","femaleMedian":"-"}}},"Food service managers":{"ageData":{"2011":{"total":"1,051","16to19":"15","20to24":"118","25to34":"274","35to44":"232","45to54":"255","55to64":"126","65+":"31","medianAge":"126"}},"title":"Food service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"1,051","women":"45.7","white":"9.2","black":"9.2","asian":"13.9"}},"wageData":{"2011":{"workers":"675","median":"660","maleWorkers":"361","maleMedian":"734","femaleWorkers":"314","femaleMedian":"599"}}},"Funeral service managers":{"ageData":{"2011":{"total":"13","16to19":"0","20to24":"0","25to34":"1","35to44":"2","45to54":"5","55to64":"2","65+":"2","medianAge":"2"}},"title":"Funeral service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"8","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Gaming managers":{"ageData":{"2011":{"total":"23","16to19":"0","20to24":"1","25to34":"2","35to44":"6","45to54":"6","55to64":"6","65+":"3","medianAge":"6"}},"title":"Gaming managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"23","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"22","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Lodging managers":{"ageData":{"2011":{"total":"148","16to19":"1","20to24":"7","25to34":"28","35to44":"32","45to54":"31","55to64":"32","65+":"16","medianAge":"32"}},"title":"Lodging managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"148","women":"52.4","white":"7.0","black":"13.4","asian":"8.1"}},"wageData":{"2011":{"workers":"91","median":"883","maleWorkers":"36","maleMedian":"-","femaleWorkers":"55","femaleMedian":"841"}}},"Medical and health services managers":{"ageData":{"2011":{"total":"529","16to19":"1","20to24":"3","25to34":"73","35to44":"121","45to54":"178","55to64":"134","65+":"19","medianAge":"134"}},"title":"Medical and health services managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"529","women":"71.4","white":"11.2","black":"5.0","asian":"8.4"}},"wageData":{"2011":{"workers":"450","median":"1,252","maleWorkers":"125","maleMedian":"1,456","femaleWorkers":"325","femaleMedian":"1,166"}}},"Natural sciences managers":{"ageData":{"2011":{"total":"16","16to19":"0","20to24":"0","25to34":"2","35to44":"8","45to54":"4","55to64":"2","65+":"1","medianAge":"2"}},"title":"Natural sciences managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"16","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"12","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Postmasters and mail superintendents":{"ageData":{"2011":{"total":"40","16to19":"0","20to24":"0","25to34":"1","35to44":"5","45to54":"18","55to64":"13","65+":"2","medianAge":"13"}},"title":"Postmasters and mail superintendents","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"29","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"19","femaleMedian":"-"}}},"Property, real estate, and community association managers":{"ageData":{"2011":{"total":"587","16to19":"1","20to24":"13","25to34":"95","35to44":"121","45to54":"146","55to64":"126","65+":"86","medianAge":"126"}},"title":"Property, real estate, and community association managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"587","women":"48.0","white":"8.8","black":"3.1","asian":"8.8"}},"wageData":{"2011":{"workers":"317","median":"921","maleWorkers":"135","maleMedian":"1,201","femaleWorkers":"182","femaleMedian":"728"}}},"Social and community service managers":{"ageData":{"2011":{"total":"329","16to19":"1","20to24":"11","25to34":"54","35to44":"72","45to54":"97","55to64":"71","65+":"24","medianAge":"71"}},"title":"Social and community service managers","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"329","women":"71.3","white":"11.3","black":"2.6","asian":"6.9"}},"wageData":{"2011":{"workers":"277","median":"1,045","maleWorkers":"81","maleMedian":"1,221","femaleWorkers":"196","femaleMedian":"973"}}},"Emergency management directors":{"ageData":{"2011":{"total":"5","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Emergency management directors","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"5","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Managers, all other":{"ageData":{"2011":{"total":"3,173","16to19":"8","20to24":"84","25to34":"509","35to44":"812","45to54":"931","55to64":"638","65+":"191","medianAge":"638"}},"title":"Managers, all other","depth":4,"parent":"Management occupations","sexRaceEthnicityData":{"2011":{"total":"3,173","women":"33.9","white":"5.9","black":"5.4","asian":"8.6"}},"wageData":{"2011":{"workers":"2,050","median":"1,265","maleWorkers":"1,313","maleMedian":"1,406","femaleWorkers":"737","femaleMedian":"1,047"}}},"Business and financial operations occupations":{"ageData":{"2011":{"total":"6,339","16to19":"15","20to24":"326","25to34":"1,516","35to44":"1,550","45to54":"1,578","55to64":"1,044","65+":"310","medianAge":"1,044"}},"title":"Business and financial operations occupations","depth":3,"parent":"Management, business, and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"6,339","women":"55.3","white":"9.8","black":"6.6","asian":"7.8"}},"wageData":{"2011":{"workers":"5,170","median":"1,038","maleWorkers":"2,225","maleMedian":"1,225","femaleWorkers":"2,946","femaleMedian":"937"}}},"Agents and business managers of artists, performers, and athletes":{"ageData":{"2011":{"total":"48","16to19":"0","20to24":"3","25to34":"14","35to44":"10","45to54":"14","55to64":"6","65+":"0","medianAge":"6"}},"title":"Agents and business managers of artists, performers, and athletes","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"48","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"25","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Buyers and purchasing agents, farm products":{"ageData":{"2011":{"total":"12","16to19":"0","20to24":"0","25to34":"2","35to44":"2","45to54":"2","55to64":"4","65+":"3","medianAge":"4"}},"title":"Buyers and purchasing agents, farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"7","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Wholesale and retail buyers, except farm products":{"ageData":{"2011":{"total":"170","16to19":"2","20to24":"16","25to34":"47","35to44":"36","45to54":"33","55to64":"28","65+":"7","medianAge":"28"}},"title":"Wholesale and retail buyers, except farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"170","women":"46.4","white":"4.2","black":"4.7","asian":"11.8"}},"wageData":{"2011":{"workers":"130","median":"882","maleWorkers":"68","maleMedian":"928","femaleWorkers":"62","femaleMedian":"849"}}},"Purchasing agents, except wholesale, retail, and farm products":{"ageData":{"2011":{"total":"259","16to19":"2","20to24":"11","25to34":"54","35to44":"64","45to54":"70","55to64":"51","65+":"6","medianAge":"51"}},"title":"Purchasing agents, except wholesale, retail, and farm products","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"259","women":"54.0","white":"8.7","black":"3.5","asian":"5.3"}},"wageData":{"2011":{"workers":"226","median":"1,015","maleWorkers":"108","maleMedian":"1,129","femaleWorkers":"118","femaleMedian":"945"}}},"Claims adjusters, appraisers, examiners, and investigators":{"ageData":{"2011":{"total":"296","16to19":"0","20to24":"16","25to34":"71","35to44":"83","45to54":"74","55to64":"44","65+":"9","medianAge":"44"}},"title":"Claims adjusters, appraisers, examiners, and investigators","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"296","women":"58.6","white":"16.5","black":"2.3","asian":"9.5"}},"wageData":{"2011":{"workers":"271","median":"913","maleWorkers":"110","maleMedian":"1,077","femaleWorkers":"162","femaleMedian":"804"}}},"Compliance officers":{"ageData":{"2011":{"total":"198","16to19":"0","20to24":"3","25to34":"31","35to44":"57","45to54":"59","55to64":"42","65+":"7","medianAge":"42"}},"title":"Compliance officers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"198","women":"43.8","white":"10.9","black":"3.8","asian":"9.4"}},"wageData":{"2011":{"workers":"176","median":"1,125","maleWorkers":"98","maleMedian":"1,279","femaleWorkers":"78","femaleMedian":"995"}}},"Cost estimators":{"ageData":{"2011":{"total":"119","16to19":"0","20to24":"7","25to34":"29","35to44":"23","45to54":"28","55to64":"22","65+":"10","medianAge":"22"}},"title":"Cost estimators","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"119","women":"15.0","white":"2.7","black":"2.3","asian":"6.0"}},"wageData":{"2011":{"workers":"106","median":"1,080","maleWorkers":"87","maleMedian":"1,117","femaleWorkers":"19","femaleMedian":"-"}}},"Human resources workers":{"ageData":{"2011":{"total":"595","16to19":"0","20to24":"30","25to34":"144","35to44":"169","45to54":"146","55to64":"89","65+":"16","medianAge":"89"}},"title":"Human resources workers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"595","women":"74.5","white":"15.1","black":"4.4","asian":"10.5"}},"wageData":{"2011":{"workers":"522","median":"938","maleWorkers":"116","maleMedian":"1,053","femaleWorkers":"406","femaleMedian":"912"}}},"Compensation, benefits, and job analysis specialists":{"ageData":{"2011":{"total":"65","16to19":"0","20to24":"2","25to34":"15","35to44":"16","45to54":"13","55to64":"16","65+":"2","medianAge":"16"}},"title":"Compensation, benefits, and job analysis specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"65","women":"75.5","white":"10.7","black":"2.3","asian":"5.2"}},"wageData":{"2011":{"workers":"53","median":"893","maleWorkers":"13","maleMedian":"-","femaleWorkers":"39","femaleMedian":"-"}}},"Training and development specialists":{"ageData":{"2011":{"total":"130","16to19":"1","20to24":"4","25to34":"25","35to44":"36","45to54":"35","55to64":"25","65+":"4","medianAge":"25"}},"title":"Training and development specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"130","women":"57.2","white":"13.6","black":"4.4","asian":"8.5"}},"wageData":{"2011":{"workers":"117","median":"1,059","maleWorkers":"53","maleMedian":"1,260","femaleWorkers":"64","femaleMedian":"951"}}},"Logisticians":{"ageData":{"2011":{"total":"88","16to19":"1","20to24":"10","25to34":"21","35to44":"15","45to54":"26","55to64":"13","65+":"1","medianAge":"13"}},"title":"Logisticians","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"88","women":"35.6","white":"7.3","black":"1.7","asian":"12.3"}},"wageData":{"2011":{"workers":"77","median":"864","maleWorkers":"50","maleMedian":"938","femaleWorkers":"27","femaleMedian":"-"}}},"Management analysts":{"ageData":{"2011":{"total":"707","16to19":"2","20to24":"19","25to34":"148","35to44":"151","45to54":"192","55to64":"138","65+":"57","medianAge":"138"}},"title":"Management analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"707","women":"41.9","white":"6.8","black":"8.5","asian":"4.5"}},"wageData":{"2011":{"workers":"458","median":"1,355","maleWorkers":"250","maleMedian":"1,514","femaleWorkers":"208","femaleMedian":"1,174"}}},"Meeting, convention, and event planners":{"ageData":{"2011":{"total":"109","16to19":"1","20to24":"17","25to34":"37","35to44":"19","45to54":"18","55to64":"13","65+":"3","medianAge":"13"}},"title":"Meeting, convention, and event planners","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"109","women":"76.2","white":"11.6","black":"2.0","asian":"12.4"}},"wageData":{"2011":{"workers":"87","median":"889","maleWorkers":"16","maleMedian":"-","femaleWorkers":"71","femaleMedian":"892"}}},"Fundraisers":{"ageData":{"2011":{"total":"78","16to19":"1","20to24":"10","25to34":"18","35to44":"18","45to54":"18","55to64":"11","65+":"3","medianAge":"11"}},"title":"Fundraisers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"78","women":"72.0","white":"3.9","black":"3.0","asian":"3.7"}},"wageData":{"2011":{"workers":"56","median":"1,064","maleWorkers":"14","maleMedian":"-","femaleWorkers":"42","femaleMedian":"-"}}},"Market research analysts and marketing specialists":{"ageData":{"2011":{"total":"205","16to19":"1","20to24":"18","25to34":"83","35to44":"42","45to54":"42","55to64":"14","65+":"3","medianAge":"14"}},"title":"Market research analysts and marketing specialists","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"205","women":"57.5","white":"5.2","black":"7.3","asian":"6.3"}},"wageData":{"2011":{"workers":"167","median":"1,157","maleWorkers":"66","maleMedian":"1,446","femaleWorkers":"101","femaleMedian":"1,029"}}},"Business operations specialists, all other":{"ageData":{"2011":{"total":"281","16to19":"1","20to24":"18","25to34":"58","35to44":"71","45to54":"65","55to64":"52","65+":"15","medianAge":"52"}},"title":"Business operations specialists, all other","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"281","women":"66.9","white":"12.2","black":"4.5","asian":"8.7"}},"wageData":{"2011":{"workers":"238","median":"991","maleWorkers":"88","maleMedian":"1,185","femaleWorkers":"149","femaleMedian":"908"}}},"Accountants and auditors":{"ageData":{"2011":{"total":"1,653","16to19":"1","20to24":"93","25to34":"395","35to44":"408","45to54":"410","55to64":"262","65+":"85","medianAge":"262"}},"title":"Accountants and auditors","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"1,653","women":"61.3","white":"8.5","black":"10.3","asian":"7.6"}},"wageData":{"2011":{"workers":"1,383","median":"1,056","maleWorkers":"532","maleMedian":"1,250","femaleWorkers":"852","femaleMedian":"956"}}},"Appraisers and assessors of real estate":{"ageData":{"2011":{"total":"88","16to19":"0","20to24":"2","25to34":"13","35to44":"17","45to54":"26","55to64":"20","65+":"10","medianAge":"20"}},"title":"Appraisers and assessors of real estate","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"88","women":"34.4","white":"3.7","black":"1.6","asian":"0.0"}},"wageData":{"2011":{"workers":"50","median":"990","maleWorkers":"30","maleMedian":"-","femaleWorkers":"20","femaleMedian":"-"}}},"Budget analysts":{"ageData":{"2011":{"total":"53","16to19":"0","20to24":"2","25to34":"9","35to44":"11","45to54":"17","55to64":"12","65+":"2","medianAge":"12"}},"title":"Budget analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"53","women":"51.8","white":"20.1","black":"8.9","asian":"3.6"}},"wageData":{"2011":{"workers":"52","median":"1,174","maleWorkers":"22","maleMedian":"-","femaleWorkers":"30","femaleMedian":"-"}}},"Credit analysts":{"ageData":{"2011":{"total":"24","16to19":"0","20to24":"3","25to34":"6","35to44":"9","45to54":"5","55to64":"2","65+":"0","medianAge":"2"}},"title":"Credit analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"24","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"21","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Financial analysts":{"ageData":{"2011":{"total":"84","16to19":"0","20to24":"3","25to34":"28","35to44":"29","45to54":"11","55to64":"8","65+":"3","medianAge":"8"}},"title":"Financial analysts","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"84","women":"34.8","white":"6.0","black":"13.4","asian":"2.7"}},"wageData":{"2011":{"workers":"63","median":"1,737","maleWorkers":"40","maleMedian":"-","femaleWorkers":"22","femaleMedian":"-"}}},"Personal financial advisors":{"ageData":{"2011":{"total":"371","16to19":"0","20to24":"14","25to34":"97","35to44":"88","45to54":"86","55to64":"57","65+":"30","medianAge":"57"}},"title":"Personal financial advisors","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"371","women":"31.2","white":"6.8","black":"5.6","asian":"6.7"}},"wageData":{"2011":{"workers":"270","median":"1,239","maleWorkers":"173","maleMedian":"1,535","femaleWorkers":"97","femaleMedian":"941"}}},"Insurance underwriters":{"ageData":{"2011":{"total":"117","16to19":"0","20to24":"0","25to34":"31","35to44":"29","45to54":"33","55to64":"19","65+":"4","medianAge":"19"}},"title":"Insurance underwriters","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"117","women":"62.7","white":"10.7","black":"3.0","asian":"3.0"}},"wageData":{"2011":{"workers":"108","median":"970","maleWorkers":"44","maleMedian":"-","femaleWorkers":"64","femaleMedian":"939"}}},"Financial examiners":{"ageData":{"2011":{"total":"8","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"4","55to64":"1","65+":"0","medianAge":"1"}},"title":"Financial examiners","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"7","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Credit counselors and loan officers":{"ageData":{"2011":{"total":"326","16to19":"0","20to24":"16","25to34":"84","35to44":"91","45to54":"82","55to64":"44","65+":"8","medianAge":"44"}},"title":"Credit counselors and loan officers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"326","women":"53.7","white":"12.1","black":"5.5","asian":"11.4"}},"wageData":{"2011":{"workers":"306","median":"1,024","maleWorkers":"147","maleMedian":"1,345","femaleWorkers":"159","femaleMedian":"829"}}},"Tax examiners and collectors, and revenue agents":{"ageData":{"2011":{"total":"70","16to19":"0","20to24":"1","25to34":"16","35to44":"12","45to54":"25","55to64":"14","65+":"1","medianAge":"14"}},"title":"Tax examiners and collectors, and revenue agents","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"70","women":"56.2","white":"24.2","black":"8.6","asian":"10.8"}},"wageData":{"2011":{"workers":"67","median":"920","maleWorkers":"27","maleMedian":"-","femaleWorkers":"40","femaleMedian":"-"}}},"Tax preparers":{"ageData":{"2011":{"total":"110","16to19":"0","20to24":"4","25to34":"22","35to44":"17","45to54":"23","55to64":"25","65+":"18","medianAge":"25"}},"title":"Tax preparers","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"110","women":"65.8","white":"9.8","black":"5.8","asian":"11.9"}},"wageData":{"2011":{"workers":"55","median":"701","maleWorkers":"13","maleMedian":"-","femaleWorkers":"41","femaleMedian":"-"}}},"Financial specialists, all other":{"ageData":{"2011":{"total":"77","16to19":"0","20to24":"3","25to34":"16","35to44":"26","45to54":"20","55to64":"11","65+":"1","medianAge":"11"}},"title":"Financial specialists, all other","depth":4,"parent":"Business and financial operations occupations","sexRaceEthnicityData":{"2011":{"total":"77","women":"61.8","white":"16.4","black":"11.2","asian":"7.5"}},"wageData":{"2011":{"workers":"72","median":"913","maleWorkers":"30","maleMedian":"-","femaleWorkers":"41","femaleMedian":"-"}}},"Professional and related occupations":{"ageData":{"2011":{"total":"30,957","16to19":"234","20to24":"1,834","25to34":"7,552","35to44":"7,301","45to54":"7,262","55to64":"5,335","65+":"1,439","medianAge":"5,335"}},"title":"Professional and related occupations","depth":2,"parent":"Management, professional, and related occupations","sexRaceEthnicityData":{"2011":{"total":"30,957","women":"57.1","white":"9.1","black":"6.8","asian":"7.4"}},"wageData":{"2011":{"workers":"23,730","median":"1,029","maleWorkers":"10,592","maleMedian":"1,211","femaleWorkers":"13,139","femaleMedian":"919"}}},"Computer and mathematical occupations":{"ageData":{"2011":{"total":"3,608","16to19":"14","20to24":"198","25to34":"1,036","35to44":"1,034","45to54":"845","55to64":"408","65+":"73","medianAge":"408"}},"title":"Computer and mathematical occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2011":{"total":"3,608","women":"25.0","white":"6.9","black":"16.6","asian":"5.7"}},"wageData":{"2011":{"workers":"3,296","median":"1,305","maleWorkers":"2,509","maleMedian":"1,369","femaleWorkers":"787","femaleMedian":"1,126"}}},"Computer and information research scientists":{"ageData":{"2011":{"total":"20","16to19":"0","20to24":"3","25to34":"7","35to44":"5","45to54":"3","55to64":"2","65+":"0","medianAge":"2"}},"title":"Computer and information research scientists","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2011":{"total":"20","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"19","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Computer systems analysts":{"ageData":{"2011":{"total":"447","16to19":"1","20to24":"12","25to34":"109","35to44":"113","45to54":"133","55to64":"64","65+":"16","medianAge":"64"}},"title":"Computer systems analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2011":{"total":"447","women":"33.9","white":"7.1","black":"14.9","asian":"4.4"}},"wageData":{"2011":{"workers":"373","median":"1,328","maleWorkers":"242","maleMedian":"1,410","femaleWorkers":"132","femaleMedian":"1,144"}}},"Information security analysts":{"ageData":{"2011":{"total":"44","16to19":"0","20to24":"3","25to34":"12","35to44":"14","45to54":"11","55to64":"5","65+":"0","medianAge":"5"}},"title":"Information security analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2011":{"total":"44","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"45","median":"-","maleWorkers":"38","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Computer programmers":{"ageData":{"2011":{"total":"459","16to19":"4","20to24":"30","25to34":"110","35to44":"131","45to54":"105","55to64":"66","65+":"14","medianAge":"66"}},"title":"Computer programmers","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2011":{"total":"459","women":"20.8","white":"4.3","black":"15.4","asian":"5.8"}},"wageData":{"2011":{"workers":"411","median":"1,277","maleWorkers":"329","maleMedian":"1,330","femaleWorkers":"83","femaleMedian":"1,238"}}},"Software developers, applications and systems software":{"ageData":{"2011":{"total":"1,044","16to19":"1","20to24":"44","25to34":"331","35to44":"340","45to54":"230","55to64":"87","65+":"11","medianAge":"87"}},"title":"Software developers, applications and systems software","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2011":{"total":"1,044","women":"19.0","white":"4.8","black":"27.1","asian":"4.6"}},"wageData":{"2011":{"workers":"990","median":"1,558","maleWorkers":"812","maleMedian":"1,606","femaleWorkers":"179","femaleMedian":"1,388"}}},"Web developers":{"ageData":{"2011":{"total":"182","16to19":"1","20to24":"20","25to34":"61","35to44":"58","45to54":"28","55to64":"12","65+":"2","medianAge":"12"}},"title":"Web developers","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2011":{"total":"182","women":"38.6","white":"5.9","black":"11.1","asian":"6.9"}},"wageData":{"2011":{"workers":"117","median":"1,017","maleWorkers":"81","maleMedian":"1,033","femaleWorkers":"35","femaleMedian":"-"}}},"Computer support specialists":{"ageData":{"2011":{"total":"461","16to19":"3","20to24":"40","25to34":"146","35to44":"112","45to54":"90","55to64":"60","65+":"10","medianAge":"60"}},"title":"Computer support specialists","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2011":{"total":"461","women":"26.3","white":"11.8","black":"8.7","asian":"7.5"}},"wageData":{"2011":{"workers":"434","median":"915","maleWorkers":"326","maleMedian":"896","femaleWorkers":"107","femaleMedian":"951"}}},"Database administrators":{"ageData":{"2011":{"total":"134","16to19":"0","20to24":"5","25to34":"34","35to44":"34","45to54":"40","55to64":"21","65+":"1","medianAge":"21"}},"title":"Database administrators","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2011":{"total":"134","women":"37.3","white":"9.2","black":"11.8","asian":"9.0"}},"wageData":{"2011":{"workers":"138","median":"1,238","maleWorkers":"90","maleMedian":"1,470","femaleWorkers":"48","femaleMedian":"-"}}},"Network and computer systems administrators":{"ageData":{"2011":{"total":"233","16to19":"0","20to24":"9","25to34":"69","35to44":"77","45to54":"52","55to64":"22","65+":"4","medianAge":"22"}},"title":"Network and computer systems administrators","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2011":{"total":"233","women":"22.8","white":"6.2","black":"10.0","asian":"7.2"}},"wageData":{"2011":{"workers":"221","median":"1,180","maleWorkers":"172","maleMedian":"1,243","femaleWorkers":"49","femaleMedian":"-"}}},"Computer network architects":{"ageData":{"2011":{"total":"98","16to19":"0","20to24":"2","25to34":"25","35to44":"29","45to54":"30","55to64":"9","65+":"2","medianAge":"9"}},"title":"Computer network architects","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2011":{"total":"98","women":"11.4","white":"3.1","black":"13.9","asian":"7.0"}},"wageData":{"2011":{"workers":"94","median":"1,441","maleWorkers":"81","maleMedian":"1,585","femaleWorkers":"12","femaleMedian":"-"}}},"Computer occupations, all other":{"ageData":{"2011":{"total":"306","16to19":"4","20to24":"21","25to34":"81","35to44":"74","45to54":"81","55to64":"37","65+":"9","medianAge":"37"}},"title":"Computer occupations, all other","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2011":{"total":"306","women":"21.7","white":"8.8","black":"11.9","asian":"6.5"}},"wageData":{"2011":{"workers":"282","median":"1,127","maleWorkers":"221","maleMedian":"1,165","femaleWorkers":"61","femaleMedian":"998"}}},"Actuaries":{"ageData":{"2011":{"total":"18","16to19":"0","20to24":"1","25to34":"7","35to44":"4","45to54":"3","55to64":"2","65+":"1","medianAge":"2"}},"title":"Actuaries","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2011":{"total":"18","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"17","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Mathematicians":{"ageData":{"2011":{"total":"2","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Mathematicians","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2011":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Operations research analysts":{"ageData":{"2011":{"total":"116","16to19":"0","20to24":"6","25to34":"33","35to44":"30","45to54":"28","55to64":"15","65+":"3","medianAge":"15"}},"title":"Operations research analysts","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2011":{"total":"116","women":"45.1","white":"14.5","black":"6.5","asian":"4.1"}},"wageData":{"2011":{"workers":"116","median":"1,273","maleWorkers":"66","maleMedian":"1,258","femaleWorkers":"51","femaleMedian":"1,326"}}},"Statisticians":{"ageData":{"2011":{"total":"37","16to19":"0","20to24":"2","25to34":"9","35to44":"14","45to54":"8","55to64":"5","65+":"0","medianAge":"5"}},"title":"Statisticians","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2011":{"total":"37","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"30","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Miscellaneous mathematical science occupations":{"ageData":{"2011":{"total":"6","16to19":"0","20to24":"0","25to34":"2","35to44":"0","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Miscellaneous mathematical science occupations","depth":4,"parent":"Computer and mathematical occupations","sexRaceEthnicityData":{"2011":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"6","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Architecture and engineering occupations":{"ageData":{"2011":{"total":"2,785","16to19":"8","20to24":"139","25to34":"650","35to44":"642","45to54":"755","55to64":"487","65+":"102","medianAge":"487"}},"title":"Architecture and engineering occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2011":{"total":"2,785","women":"13.6","white":"5.2","black":"8.8","asian":"6.4"}},"wageData":{"2011":{"workers":"2,494","median":"1,315","maleWorkers":"2,178","maleMedian":"1,343","femaleWorkers":"316","femaleMedian":"1,140"}}},"Architects, except naval":{"ageData":{"2011":{"total":"181","16to19":"0","20to24":"4","25to34":"41","35to44":"36","45to54":"49","55to64":"41","65+":"10","medianAge":"41"}},"title":"Architects, except naval","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2011":{"total":"181","women":"20.7","white":"1.6","black":"5.5","asian":"4.1"}},"wageData":{"2011":{"workers":"113","median":"1,325","maleWorkers":"92","maleMedian":"1,351","femaleWorkers":"21","femaleMedian":"-"}}},"Surveyors, cartographers, and photogrammetrists":{"ageData":{"2011":{"total":"42","16to19":"0","20to24":"4","25to34":"13","35to44":"8","45to54":"7","55to64":"10","65+":"2","medianAge":"10"}},"title":"Surveyors, cartographers, and photogrammetrists","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2011":{"total":"42","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"31","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Aerospace engineers":{"ageData":{"2011":{"total":"144","16to19":"0","20to24":"6","25to34":"36","35to44":"33","45to54":"37","55to64":"27","65+":"5","medianAge":"27"}},"title":"Aerospace engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2011":{"total":"144","women":"12.4","white":"5.7","black":"8.0","asian":"8.2"}},"wageData":{"2011":{"workers":"134","median":"1,621","maleWorkers":"119","maleMedian":"1,745","femaleWorkers":"16","femaleMedian":"-"}}},"Agricultural engineers":{"ageData":{"2011":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Agricultural engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2011":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Biomedical engineers":{"ageData":{"2011":{"total":"12","16to19":"1","20to24":"3","25to34":"3","35to44":"2","45to54":"3","55to64":"1","65+":"0","medianAge":"1"}},"title":"Biomedical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2011":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"12","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Chemical engineers":{"ageData":{"2011":{"total":"74","16to19":"0","20to24":"3","25to34":"20","35to44":"19","45to54":"20","55to64":"12","65+":"1","medianAge":"12"}},"title":"Chemical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2011":{"total":"74","women":"22.3","white":"5.5","black":"13.8","asian":"5.1"}},"wageData":{"2011":{"workers":"73","median":"1,757","maleWorkers":"57","maleMedian":"1,885","femaleWorkers":"16","femaleMedian":"-"}}},"Civil engineers":{"ageData":{"2011":{"total":"383","16to19":"0","20to24":"20","25to34":"100","35to44":"87","45to54":"97","55to64":"62","65+":"17","medianAge":"62"}},"title":"Civil engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2011":{"total":"383","women":"13.1","white":"4.3","black":"7.8","asian":"4.7"}},"wageData":{"2011":{"workers":"335","median":"1,398","maleWorkers":"289","maleMedian":"1,436","femaleWorkers":"46","femaleMedian":"-"}}},"Computer hardware engineers":{"ageData":{"2011":{"total":"77","16to19":"1","20to24":"4","25to34":"22","35to44":"20","45to54":"20","55to64":"8","65+":"3","medianAge":"8"}},"title":"Computer hardware engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2011":{"total":"77","women":"13.2","white":"3.1","black":"19.1","asian":"5.2"}},"wageData":{"2011":{"workers":"76","median":"1,528","maleWorkers":"66","maleMedian":"1,546","femaleWorkers":"10","femaleMedian":"-"}}},"Electrical and electronics engineers":{"ageData":{"2011":{"total":"309","16to19":"0","20to24":"14","25to34":"73","35to44":"68","45to54":"96","55to64":"47","65+":"12","medianAge":"47"}},"title":"Electrical and electronics engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2011":{"total":"309","women":"8.8","white":"4.8","black":"12.0","asian":"7.4"}},"wageData":{"2011":{"workers":"283","median":"1,442","maleWorkers":"256","maleMedian":"1,455","femaleWorkers":"26","femaleMedian":"-"}}},"Environmental engineers":{"ageData":{"2011":{"total":"45","16to19":"0","20to24":"1","25to34":"7","35to44":"11","45to54":"15","55to64":"8","65+":"1","medianAge":"8"}},"title":"Environmental engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2011":{"total":"45","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"36","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Industrial engineers, including health and safety":{"ageData":{"2011":{"total":"174","16to19":"0","20to24":"7","25to34":"39","35to44":"46","45to54":"53","55to64":"24","65+":"5","medianAge":"24"}},"title":"Industrial engineers, including health and safety","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2011":{"total":"174","women":"17.8","white":"2.3","black":"7.0","asian":"8.6"}},"wageData":{"2011":{"workers":"178","median":"1,336","maleWorkers":"143","maleMedian":"1,356","femaleWorkers":"34","femaleMedian":"-"}}},"Marine engineers and naval architects":{"ageData":{"2011":{"total":"9","16to19":"0","20to24":"1","25to34":"2","35to44":"3","45to54":"1","55to64":"1","65+":"1","medianAge":"1"}},"title":"Marine engineers and naval architects","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2011":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Materials engineers":{"ageData":{"2011":{"total":"32","16to19":"0","20to24":"0","25to34":"6","35to44":"11","45to54":"10","55to64":"5","65+":"0","medianAge":"5"}},"title":"Materials engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2011":{"total":"32","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"30","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Mechanical engineers":{"ageData":{"2011":{"total":"322","16to19":"0","20to24":"12","25to34":"83","35to44":"78","45to54":"92","55to64":"43","65+":"14","medianAge":"43"}},"title":"Mechanical engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2011":{"total":"322","women":"5.5","white":"5.7","black":"12.0","asian":"3.9"}},"wageData":{"2011":{"workers":"306","median":"1,374","maleWorkers":"290","maleMedian":"1,399","femaleWorkers":"16","femaleMedian":"-"}}},"Mining and geological engineers, including mining safety engineers":{"ageData":{"2011":{"total":"11","16to19":"0","20to24":"2","25to34":"1","35to44":"3","45to54":"2","55to64":"4","65+":"0","medianAge":"4"}},"title":"Mining and geological engineers, including mining safety engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2011":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"9","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Nuclear engineers":{"ageData":{"2011":{"total":"20","16to19":"0","20to24":"2","25to34":"7","35to44":"1","45to54":"3","55to64":"7","65+":"1","medianAge":"7"}},"title":"Nuclear engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2011":{"total":"20","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"23","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Petroleum engineers":{"ageData":{"2011":{"total":"25","16to19":"0","20to24":"3","25to34":"6","35to44":"3","45to54":"6","55to64":"7","65+":"0","medianAge":"7"}},"title":"Petroleum engineers","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2011":{"total":"25","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"19","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Engineers, all other":{"ageData":{"2011":{"total":"337","16to19":"0","20to24":"14","25to34":"92","35to44":"74","45to54":"83","55to64":"59","65+":"15","medianAge":"59"}},"title":"Engineers, all other","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2011":{"total":"337","women":"10.8","white":"5.7","black":"10.5","asian":"4.7"}},"wageData":{"2011":{"workers":"310","median":"1,366","maleWorkers":"275","maleMedian":"1,361","femaleWorkers":"35","femaleMedian":"-"}}},"Drafters":{"ageData":{"2011":{"total":"147","16to19":"1","20to24":"10","25to34":"31","35to44":"38","45to54":"32","55to64":"31","65+":"5","medianAge":"31"}},"title":"Drafters","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2011":{"total":"147","women":"20.8","white":"2.1","black":"3.9","asian":"8.4"}},"wageData":{"2011":{"workers":"124","median":"941","maleWorkers":"102","maleMedian":"1,052","femaleWorkers":"23","femaleMedian":"-"}}},"Engineering technicians, except drafters":{"ageData":{"2011":{"total":"376","16to19":"4","20to24":"28","25to34":"55","35to44":"83","45to54":"113","55to64":"83","65+":"10","medianAge":"83"}},"title":"Engineering technicians, except drafters","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2011":{"total":"376","women":"16.3","white":"11.3","black":"6.7","asian":"9.4"}},"wageData":{"2011":{"workers":"341","median":"954","maleWorkers":"301","maleMedian":"952","femaleWorkers":"40","femaleMedian":"-"}}},"Surveying and mapping technicians":{"ageData":{"2011":{"total":"62","16to19":"0","20to24":"3","25to34":"14","35to44":"16","45to54":"18","55to64":"8","65+":"2","medianAge":"8"}},"title":"Surveying and mapping technicians","depth":4,"parent":"Architecture and engineering occupations","sexRaceEthnicityData":{"2011":{"total":"62","women":"12.2","white":"1.7","black":"1.9","asian":"10.0"}},"wageData":{"2011":{"workers":"53","median":"777","maleWorkers":"47","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Life, physical, and social science occupations":{"ageData":{"2011":{"total":"1,303","16to19":"5","20to24":"85","25to34":"366","35to44":"294","45to54":"261","55to64":"229","65+":"63","medianAge":"229"}},"title":"Life, physical, and social science occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2011":{"total":"1,303","women":"47.3","white":"7.3","black":"9.8","asian":"5.9"}},"wageData":{"2011":{"workers":"1,043","median":"1,108","maleWorkers":"565","maleMedian":"1,156","femaleWorkers":"479","femaleMedian":"1,038"}}},"Agricultural and food scientists":{"ageData":{"2011":{"total":"39","16to19":"0","20to24":"4","25to34":"11","35to44":"4","45to54":"9","55to64":"8","65+":"2","medianAge":"8"}},"title":"Agricultural and food scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2011":{"total":"39","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"27","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Biological scientists":{"ageData":{"2011":{"total":"114","16to19":"0","20to24":"5","25to34":"37","35to44":"23","45to54":"23","55to64":"24","65+":"2","medianAge":"24"}},"title":"Biological scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2011":{"total":"114","women":"48.2","white":"7.7","black":"13.5","asian":"6.8"}},"wageData":{"2011":{"workers":"103","median":"1,031","maleWorkers":"53","maleMedian":"1,177","femaleWorkers":"50","femaleMedian":"853"}}},"Conservation scientists and foresters":{"ageData":{"2011":{"total":"28","16to19":"0","20to24":"1","25to34":"7","35to44":"2","45to54":"6","55to64":"11","65+":"1","medianAge":"11"}},"title":"Conservation scientists and foresters","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2011":{"total":"28","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"22","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Medical scientists":{"ageData":{"2011":{"total":"156","16to19":"0","20to24":"9","25to34":"49","35to44":"46","45to54":"29","55to64":"18","65+":"5","medianAge":"18"}},"title":"Medical scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2011":{"total":"156","women":"54.4","white":"5.2","black":"25.1","asian":"7.0"}},"wageData":{"2011":{"workers":"141","median":"1,109","maleWorkers":"64","maleMedian":"1,102","femaleWorkers":"78","femaleMedian":"1,127"}}},"Life scientists, all other":{"ageData":{"2011":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Life scientists, all other","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2011":{"total":"0","women":"-","white":"-","black":"-","asian":"-"}}},"Astronomers and physicists":{"ageData":{"2011":{"total":"20","16to19":"0","20to24":"0","25to34":"8","35to44":"2","45to54":"5","55to64":"3","65+":"3","medianAge":"3"}},"title":"Astronomers and physicists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2011":{"total":"20","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"18","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Atmospheric and space scientists":{"ageData":{"2011":{"total":"7","16to19":"0","20to24":"0","25to34":"3","35to44":"2","45to54":"2","55to64":"0","65+":"1","medianAge":"0"}},"title":"Atmospheric and space scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2011":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"7","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Chemists and materials scientists":{"ageData":{"2011":{"total":"88","16to19":"0","20to24":"4","25to34":"25","35to44":"22","45to54":"20","55to64":"13","65+":"4","medianAge":"13"}},"title":"Chemists and materials scientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2011":{"total":"88","women":"45.9","white":"9.5","black":"11.5","asian":"4.6"}},"wageData":{"2011":{"workers":"83","median":"1,169","maleWorkers":"45","maleMedian":"-","femaleWorkers":"38","femaleMedian":"-"}}},"Environmental scientists and geoscientists":{"ageData":{"2011":{"total":"98","16to19":"0","20to24":"3","25to34":"24","35to44":"20","45to54":"28","55to64":"19","65+":"3","medianAge":"19"}},"title":"Environmental scientists and geoscientists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2011":{"total":"98","women":"28.9","white":"4.9","black":"0.6","asian":"3.0"}},"wageData":{"2011":{"workers":"86","median":"1,383","maleWorkers":"61","maleMedian":"1,408","femaleWorkers":"25","femaleMedian":"-"}}},"Physical scientists, all other":{"ageData":{"2011":{"total":"152","16to19":"0","20to24":"6","25to34":"52","35to44":"41","45to54":"29","55to64":"19","65+":"5","medianAge":"19"}},"title":"Physical scientists, all other","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2011":{"total":"152","women":"39.8","white":"6.7","black":"19.9","asian":"2.9"}},"wageData":{"2011":{"workers":"133","median":"1,383","maleWorkers":"82","maleMedian":"1,483","femaleWorkers":"51","femaleMedian":"1,167"}}},"Economists":{"ageData":{"2011":{"total":"23","16to19":"0","20to24":"1","25to34":"3","35to44":"6","45to54":"4","55to64":"9","65+":"0","medianAge":"9"}},"title":"Economists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2011":{"total":"23","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"20","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Survey researchers":{"ageData":{"2011":{"total":"3","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"1","55to64":"0","65+":"1","medianAge":"0"}},"title":"Survey researchers","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2011":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Psychologists":{"ageData":{"2011":{"total":"197","16to19":"0","20to24":"2","25to34":"40","35to44":"46","45to54":"35","55to64":"46","65+":"27","medianAge":"46"}},"title":"Psychologists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2011":{"total":"197","women":"71.2","white":"5.1","black":"2.9","asian":"5.9"}},"wageData":{"2011":{"workers":"104","median":"1,229","maleWorkers":"31","maleMedian":"-","femaleWorkers":"74","femaleMedian":"1,244"}}},"Sociologists":{"ageData":{"2011":{"total":"4","16to19":"0","20to24":"0","25to34":"1","35to44":"2","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Sociologists","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2011":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"2","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Urban and regional planners":{"ageData":{"2011":{"total":"26","16to19":"0","20to24":"0","25to34":"5","35to44":"6","45to54":"8","55to64":"7","65+":"1","medianAge":"7"}},"title":"Urban and regional planners","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2011":{"total":"26","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"19","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Miscellaneous social scientists and related workers":{"ageData":{"2011":{"total":"60","16to19":"0","20to24":"4","25to34":"20","35to44":"10","45to54":"10","55to64":"14","65+":"2","medianAge":"14"}},"title":"Miscellaneous social scientists and related workers","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2011":{"total":"60","women":"55.4","white":"10.7","black":"4.4","asian":"9.4"}},"wageData":{"2011":{"workers":"48","median":"-","maleWorkers":"19","maleMedian":"-","femaleWorkers":"29","femaleMedian":"-"}}},"Agricultural and food science technicians":{"ageData":{"2011":{"total":"24","16to19":"0","20to24":"3","25to34":"6","35to44":"6","45to54":"5","55to64":"2","65+":"1","medianAge":"2"}},"title":"Agricultural and food science technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2011":{"total":"24","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"13","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Biological technicians":{"ageData":{"2011":{"total":"21","16to19":"1","20to24":"2","25to34":"7","35to44":"4","45to54":"4","55to64":"1","65+":"1","medianAge":"1"}},"title":"Biological technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2011":{"total":"21","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"19","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Chemical technicians":{"ageData":{"2011":{"total":"77","16to19":"0","20to24":"8","25to34":"19","35to44":"19","45to54":"20","55to64":"10","65+":"1","medianAge":"10"}},"title":"Chemical technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2011":{"total":"77","women":"40.3","white":"9.1","black":"5.1","asian":"14.3"}},"wageData":{"2011":{"workers":"69","median":"788","maleWorkers":"40","maleMedian":"-","femaleWorkers":"29","femaleMedian":"-"}}},"Geological and petroleum technicians":{"ageData":{"2011":{"total":"10","16to19":"0","20to24":"0","25to34":"3","35to44":"1","45to54":"2","55to64":"2","65+":"1","medianAge":"2"}},"title":"Geological and petroleum technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2011":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"6","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Nuclear technicians":{"ageData":{"2011":{"total":"3","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Nuclear technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2011":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"3","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Social science research assistants":{"ageData":{"2011":{"total":"3","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Social science research assistants","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2011":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Miscellaneous life, physical, and social science technicians":{"ageData":{"2011":{"total":"151","16to19":"3","20to24":"32","25to34":"45","35to44":"32","45to54":"18","55to64":"18","65+":"4","medianAge":"18"}},"title":"Miscellaneous life, physical, and social science technicians","depth":4,"parent":"Life, physical, and social science occupations","sexRaceEthnicityData":{"2011":{"total":"151","women":"41.9","white":"11.1","black":"9.4","asian":"6.5"}},"wageData":{"2011":{"workers":"118","median":"763","maleWorkers":"69","maleMedian":"807","femaleWorkers":"49","femaleMedian":"-"}}},"Community and social service occupations":{"ageData":{"2011":{"total":"2,352","16to19":"15","20to24":"123","25to34":"536","35to44":"516","45to54":"527","55to64":"489","65+":"146","medianAge":"489"}},"title":"Community and social service occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2011":{"total":"2,352","women":"64.5","white":"18.1","black":"2.8","asian":"10.7"}},"wageData":{"2011":{"workers":"1,931","median":"813","maleWorkers":"728","maleMedian":"906","femaleWorkers":"1,202","femaleMedian":"772"}}},"Counselors":{"ageData":{"2011":{"total":"732","16to19":"8","20to24":"45","25to34":"200","35to44":"149","45to54":"141","55to64":"152","65+":"37","medianAge":"152"}},"title":"Counselors","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2011":{"total":"732","women":"69.9","white":"18.7","black":"2.8","asian":"11.2"}},"wageData":{"2011":{"workers":"568","median":"828","maleWorkers":"188","maleMedian":"874","femaleWorkers":"380","femaleMedian":"808"}}},"Social workers":{"ageData":{"2011":{"total":"769","16to19":"1","20to24":"28","25to34":"205","35to44":"206","45to54":"174","55to64":"132","65+":"24","medianAge":"132"}},"title":"Social workers","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2011":{"total":"769","women":"81.6","white":"22.8","black":"2.4","asian":"11.2"}},"wageData":{"2011":{"workers":"684","median":"817","maleWorkers":"130","maleMedian":"902","femaleWorkers":"554","femaleMedian":"798"}}},"Probation officers and correctional treatment specialists":{"ageData":{"2011":{"total":"94","16to19":"0","20to24":"4","25to34":"30","35to44":"29","45to54":"20","55to64":"9","65+":"2","medianAge":"9"}},"title":"Probation officers and correctional treatment specialists","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2011":{"total":"94","women":"56.8","white":"22.5","black":"0.6","asian":"13.5"}},"wageData":{"2011":{"workers":"86","median":"822","maleWorkers":"41","maleMedian":"-","femaleWorkers":"44","femaleMedian":"-"}}},"Social and human service assistants":{"ageData":{"2011":{"total":"131","16to19":"3","20to24":"14","25to34":"29","35to44":"22","45to54":"32","55to64":"27","65+":"5","medianAge":"27"}},"title":"Social and human service assistants","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2011":{"total":"131","women":"82.4","white":"18.0","black":"2.6","asian":"19.0"}},"wageData":{"2011":{"workers":"105","median":"597","maleWorkers":"21","maleMedian":"-","femaleWorkers":"83","femaleMedian":"597"}}},"Miscellaneous community and social service specialists, including health educators and community health workers":{"ageData":{"2011":{"total":"83","16to19":"2","20to24":"10","25to34":"19","35to44":"15","45to54":"20","55to64":"12","65+":"5","medianAge":"12"}},"title":"Miscellaneous community and social service specialists, including health educators and community health workers","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2011":{"total":"83","women":"67.5","white":"17.6","black":"2.9","asian":"10.9"}},"wageData":{"2011":{"workers":"62","median":"676","maleWorkers":"23","maleMedian":"-","femaleWorkers":"39","femaleMedian":"-"}}},"Clergy":{"ageData":{"2011":{"total":"414","16to19":"1","20to24":"10","25to34":"39","35to44":"73","45to54":"106","55to64":"128","65+":"58","medianAge":"128"}},"title":"Clergy","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2011":{"total":"414","women":"17.7","white":"11.3","black":"4.1","asian":"6.8"}},"wageData":{"2011":{"workers":"343","median":"945","maleWorkers":"292","maleMedian":"961","femaleWorkers":"51","femaleMedian":"889"}}},"Directors, religious activities and education":{"ageData":{"2011":{"total":"44","16to19":"0","20to24":"4","25to34":"8","35to44":"8","45to54":"14","55to64":"9","65+":"2","medianAge":"9"}},"title":"Directors, religious activities and education","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2011":{"total":"44","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"34","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"25","femaleMedian":"-"}}},"Religious workers, all other":{"ageData":{"2011":{"total":"85","16to19":"0","20to24":"8","25to34":"7","35to44":"14","45to54":"21","55to64":"21","65+":"13","medianAge":"21"}},"title":"Religious workers, all other","depth":4,"parent":"Community and social service occupations","sexRaceEthnicityData":{"2011":{"total":"85","women":"67.9","white":"8.5","black":"3.0","asian":"8.6"}},"wageData":{"2011":{"workers":"50","median":"654","maleWorkers":"24","maleMedian":"-","femaleWorkers":"26","femaleMedian":"-"}}},"Legal occupations":{"ageData":{"2011":{"total":"1,770","16to19":"3","20to24":"41","25to34":"387","35to44":"406","45to54":"425","55to64":"378","65+":"131","medianAge":"378"}},"title":"Legal occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2011":{"total":"1,770","women":"49.8","white":"7.3","black":"3.9","asian":"5.4"}},"wageData":{"2011":{"workers":"1,259","median":"1,277","maleWorkers":"583","maleMedian":"1,758","femaleWorkers":"676","femaleMedian":"1,003"}}},"Lawyers":{"ageData":{"2011":{"total":"1,085","16to19":"0","20to24":"2","25to34":"224","35to44":"263","45to54":"255","55to64":"238","65+":"102","medianAge":"238"}},"title":"Lawyers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2011":{"total":"1,085","women":"31.9","white":"5.3","black":"4.2","asian":"3.2"}},"wageData":{"2011":{"workers":"704","median":"1,774","maleWorkers":"462","maleMedian":"1,884","femaleWorkers":"242","femaleMedian":"1,631"}}},"Judicial law clerks":{"ageData":{"2011":{"total":"5","16to19":"0","20to24":"1","25to34":"2","35to44":"1","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Judicial law clerks","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2011":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"4","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Judges, magistrates, and other judicial workers":{"ageData":{"2011":{"total":"67","16to19":"0","20to24":"1","25to34":"10","35to44":"10","45to54":"17","55to64":"21","65+":"8","medianAge":"21"}},"title":"Judges, magistrates, and other judicial workers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2011":{"total":"67","women":"44.4","white":"11.5","black":"1.1","asian":"8.3"}},"wageData":{"2011":{"workers":"58","median":"1,655","maleWorkers":"32","maleMedian":"-","femaleWorkers":"26","femaleMedian":"-"}}},"Paralegals and legal assistants":{"ageData":{"2011":{"total":"404","16to19":"3","20to24":"26","25to34":"112","35to44":"79","45to54":"99","55to64":"73","65+":"13","medianAge":"73"}},"title":"Paralegals and legal assistants","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2011":{"total":"404","women":"84.3","white":"11.0","black":"3.0","asian":"8.3"}},"wageData":{"2011":{"workers":"338","median":"824","maleWorkers":"52","maleMedian":"884","femaleWorkers":"286","femaleMedian":"813"}}},"Miscellaneous legal support workers":{"ageData":{"2011":{"total":"209","16to19":"0","20to24":"12","25to34":"39","35to44":"53","45to54":"52","55to64":"45","65+":"7","medianAge":"45"}},"title":"Miscellaneous legal support workers","depth":4,"parent":"Legal occupations","sexRaceEthnicityData":{"2011":{"total":"209","women":"76.7","white":"9.3","black":"4.3","asian":"10.5"}},"wageData":{"2011":{"workers":"155","median":"815","maleWorkers":"35","maleMedian":"-","femaleWorkers":"120","femaleMedian":"788"}}},"Education, training, and library occupations":{"ageData":{"2011":{"total":"8,619","16to19":"92","20to24":"579","25to34":"1,957","35to44":"1,946","45to54":"2,013","55to64":"1,585","65+":"446","medianAge":"1,585"}},"title":"Education, training, and library occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2011":{"total":"8,619","women":"73.6","white":"9.7","black":"3.5","asian":"8.3"}},"wageData":{"2011":{"workers":"6,518","median":"919","maleWorkers":"1,749","maleMedian":"1,109","femaleWorkers":"4,769","femaleMedian":"869"}}},"Postsecondary teachers":{"ageData":{"2011":{"total":"1,355","16to19":"5","20to24":"86","25to34":"299","35to44":"270","45to54":"281","55to64":"279","65+":"135","medianAge":"279"}},"title":"Postsecondary teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2011":{"total":"1,355","women":"46.2","white":"7.3","black":"10.1","asian":"4.8"}},"wageData":{"2011":{"workers":"925","median":"1,209","maleWorkers":"526","maleMedian":"1,358","femaleWorkers":"399","femaleMedian":"1,093"}}},"Preschool and kindergarten teachers":{"ageData":{"2011":{"total":"707","16to19":"6","20to24":"92","25to34":"184","35to44":"182","45to54":"142","55to64":"85","65+":"16","medianAge":"85"}},"title":"Preschool and kindergarten teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2011":{"total":"707","women":"97.7","white":"14.5","black":"2.8","asian":"12.7"}},"wageData":{"2011":{"workers":"532","median":"606","maleWorkers":"13","maleMedian":"-","femaleWorkers":"519","femaleMedian":"603"}}},"Elementary and middle school teachers":{"ageData":{"2011":{"total":"2,848","16to19":"7","20to24":"124","25to34":"701","35to44":"741","45to54":"676","55to64":"507","65+":"92","medianAge":"507"}},"title":"Elementary and middle school teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2011":{"total":"2,848","women":"81.7","white":"9.8","black":"1.6","asian":"8.0"}},"wageData":{"2011":{"workers":"2,436","median":"947","maleWorkers":"463","maleMedian":"1,022","femaleWorkers":"1,973","femaleMedian":"933"}}},"Secondary school teachers":{"ageData":{"2011":{"total":"1,136","16to19":"5","20to24":"44","25to34":"289","35to44":"279","45to54":"271","55to64":"205","65+":"42","medianAge":"205"}},"title":"Secondary school teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2011":{"total":"1,136","women":"58.0","white":"7.4","black":"2.1","asian":"6.9"}},"wageData":{"2011":{"workers":"1,005","median":"1,015","maleWorkers":"431","maleMedian":"1,049","femaleWorkers":"575","femaleMedian":"989"}}},"Special education teachers":{"ageData":{"2011":{"total":"388","16to19":"1","20to24":"11","25to34":"102","35to44":"93","45to54":"104","55to64":"65","65+":"12","medianAge":"65"}},"title":"Special education teachers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2011":{"total":"388","women":"85.4","white":"8.0","black":"1.8","asian":"6.8"}},"wageData":{"2011":{"workers":"364","median":"939","maleWorkers":"55","maleMedian":"967","femaleWorkers":"308","femaleMedian":"935"}}},"Other teachers and instructors":{"ageData":{"2011":{"total":"812","16to19":"37","20to24":"95","25to34":"157","35to44":"133","45to54":"169","55to64":"146","65+":"75","medianAge":"146"}},"title":"Other teachers and instructors","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2011":{"total":"812","women":"62.6","white":"8.0","black":"3.9","asian":"7.3"}},"wageData":{"2011":{"workers":"368","median":"858","maleWorkers":"163","maleMedian":"1,105","femaleWorkers":"205","femaleMedian":"739"}}},"Archivists, curators, and museum technicians":{"ageData":{"2011":{"total":"48","16to19":"1","20to24":"3","25to34":"5","35to44":"7","45to54":"13","55to64":"16","65+":"3","medianAge":"16"}},"title":"Archivists, curators, and museum technicians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2011":{"total":"48","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"38","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"26","femaleMedian":"-"}}},"Librarians":{"ageData":{"2011":{"total":"198","16to19":"1","20to24":"10","25to34":"27","35to44":"29","45to54":"46","55to64":"64","65+":"22","medianAge":"64"}},"title":"Librarians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2011":{"total":"198","women":"86.2","white":"10.1","black":"2.6","asian":"3.9"}},"wageData":{"2011":{"workers":"139","median":"850","maleWorkers":"21","maleMedian":"-","femaleWorkers":"118","femaleMedian":"813"}}},"Library technicians":{"ageData":{"2011":{"total":"37","16to19":"6","20to24":"7","25to34":"6","35to44":"5","45to54":"5","55to64":"6","65+":"2","medianAge":"6"}},"title":"Library technicians","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2011":{"total":"37","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"13","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Teacher assistants":{"ageData":{"2011":{"total":"950","16to19":"23","20to24":"99","25to34":"163","35to44":"175","45to54":"276","55to64":"178","65+":"36","medianAge":"178"}},"title":"Teacher assistants","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2011":{"total":"950","women":"92.2","white":"14.3","black":"2.6","asian":"14.9"}},"wageData":{"2011":{"workers":"605","median":"480","maleWorkers":"39","maleMedian":"-","femaleWorkers":"566","femaleMedian":"471"}}},"Other education, training, and library workers":{"ageData":{"2011":{"total":"140","16to19":"2","20to24":"9","25to34":"23","35to44":"32","45to54":"30","55to64":"34","65+":"11","medianAge":"34"}},"title":"Other education, training, and library workers","depth":4,"parent":"Education, training, and library occupations","sexRaceEthnicityData":{"2011":{"total":"140","women":"71.2","white":"7.7","black":"3.4","asian":"9.2"}},"wageData":{"2011":{"workers":"94","median":"982","maleWorkers":"23","maleMedian":"-","femaleWorkers":"71","femaleMedian":"979"}}},"Arts, design, entertainment, sports, and media occupations":{"ageData":{"2011":{"total":"2,779","16to19":"68","20to24":"273","25to34":"711","35to44":"586","45to54":"563","55to64":"419","65+":"160","medianAge":"419"}},"title":"Arts, design, entertainment, sports, and media occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2011":{"total":"2,779","women":"46.1","white":"6.0","black":"3.6","asian":"9.1"}},"wageData":{"2011":{"workers":"1,464","median":"929","maleWorkers":"850","maleMedian":"995","femaleWorkers":"613","femaleMedian":"856"}}},"Artists and related workers":{"ageData":{"2011":{"total":"180","16to19":"1","20to24":"10","25to34":"34","35to44":"49","45to54":"35","55to64":"36","65+":"16","medianAge":"36"}},"title":"Artists and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2011":{"total":"180","women":"48.0","white":"3.8","black":"3.8","asian":"2.8"}},"wageData":{"2011":{"workers":"56","median":"1,115","maleWorkers":"36","maleMedian":"-","femaleWorkers":"21","femaleMedian":"-"}}},"Designers":{"ageData":{"2011":{"total":"766","16to19":"5","20to24":"51","25to34":"207","35to44":"170","45to54":"187","55to64":"109","65+":"36","medianAge":"109"}},"title":"Designers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2011":{"total":"766","women":"51.3","white":"3.6","black":"3.2","asian":"10.5"}},"wageData":{"2011":{"workers":"458","median":"950","maleWorkers":"257","maleMedian":"1,045","femaleWorkers":"201","femaleMedian":"816"}}},"Actors":{"ageData":{"2011":{"total":"28","16to19":"3","20to24":"4","25to34":"7","35to44":"5","45to54":"6","55to64":"2","65+":"2","medianAge":"2"}},"title":"Actors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2011":{"total":"28","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"8","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Producers and directors":{"ageData":{"2011":{"total":"149","16to19":"2","20to24":"15","25to34":"46","35to44":"30","45to54":"31","55to64":"20","65+":"6","medianAge":"20"}},"title":"Producers and directors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2011":{"total":"149","women":"40.7","white":"8.2","black":"3.2","asian":"7.3"}},"wageData":{"2011":{"workers":"105","median":"1,023","maleWorkers":"58","maleMedian":"1,130","femaleWorkers":"47","femaleMedian":"-"}}},"Athletes, coaches, umpires, and related workers":{"ageData":{"2011":{"total":"272","16to19":"39","20to24":"59","25to34":"59","35to44":"41","45to54":"40","55to64":"29","65+":"5","medianAge":"29"}},"title":"Athletes, coaches, umpires, and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2011":{"total":"272","women":"34.5","white":"5.4","black":"2.6","asian":"9.7"}},"wageData":{"2011":{"workers":"109","median":"825","maleWorkers":"84","maleMedian":"919","femaleWorkers":"25","femaleMedian":"-"}}},"Dancers and choreographers":{"ageData":{"2011":{"total":"20","16to19":"1","20to24":"8","25to34":"7","35to44":"1","45to54":"2","55to64":"0","65+":"1","medianAge":"0"}},"title":"Dancers and choreographers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2011":{"total":"20","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"6","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Musicians, singers, and related workers":{"ageData":{"2011":{"total":"191","16to19":"3","20to24":"22","25to34":"40","35to44":"39","45to54":"31","55to64":"38","65+":"18","medianAge":"38"}},"title":"Musicians, singers, and related workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2011":{"total":"191","women":"29.8","white":"15.1","black":"1.2","asian":"6.6"}},"wageData":{"2011":{"workers":"35","median":"-","maleWorkers":"29","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Entertainers and performers, sports and related workers, all other":{"ageData":{"2011":{"total":"44","16to19":"3","20to24":"7","25to34":"14","35to44":"5","45to54":"3","55to64":"9","65+":"3","medianAge":"9"}},"title":"Entertainers and performers, sports and related workers, all other","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2011":{"total":"44","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"7","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Announcers":{"ageData":{"2011":{"total":"53","16to19":"0","20to24":"7","25to34":"15","35to44":"12","45to54":"12","55to64":"5","65+":"2","medianAge":"5"}},"title":"Announcers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2011":{"total":"53","women":"26.9","white":"8.5","black":"1.1","asian":"24.8"}},"wageData":{"2011":{"workers":"32","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"News analysts, reporters and correspondents":{"ageData":{"2011":{"total":"70","16to19":"0","20to24":"5","25to34":"24","35to44":"15","45to54":"13","55to64":"12","65+":"2","medianAge":"12"}},"title":"News analysts, reporters and correspondents","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2011":{"total":"70","women":"34.1","white":"9.3","black":"5.0","asian":"11.4"}},"wageData":{"2011":{"workers":"62","median":"937","maleWorkers":"44","maleMedian":"-","femaleWorkers":"18","femaleMedian":"-"}}},"Public relations specialists":{"ageData":{"2011":{"total":"158","16to19":"1","20to24":"14","25to34":"47","35to44":"36","45to54":"29","55to64":"21","65+":"10","medianAge":"21"}},"title":"Public relations specialists","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2011":{"total":"158","women":"61.6","white":"6.3","black":"2.7","asian":"9.8"}},"wageData":{"2011":{"workers":"123","median":"954","maleWorkers":"49","maleMedian":"-","femaleWorkers":"75","femaleMedian":"887"}}},"Editors":{"ageData":{"2011":{"total":"166","16to19":"1","20to24":"16","25to34":"49","35to44":"31","45to54":"31","55to64":"27","65+":"11","medianAge":"27"}},"title":"Editors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2011":{"total":"166","women":"54.2","white":"4.6","black":"3.8","asian":"3.4"}},"wageData":{"2011":{"workers":"132","median":"902","maleWorkers":"58","maleMedian":"933","femaleWorkers":"74","femaleMedian":"892"}}},"Technical writers":{"ageData":{"2011":{"total":"60","16to19":"0","20to24":"1","25to34":"8","35to44":"13","45to54":"21","55to64":"12","65+":"5","medianAge":"12"}},"title":"Technical writers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2011":{"total":"60","women":"60.2","white":"4.2","black":"4.6","asian":"4.1"}},"wageData":{"2011":{"workers":"46","median":"-","maleWorkers":"20","maleMedian":"-","femaleWorkers":"26","femaleMedian":"-"}}},"Writers and authors":{"ageData":{"2011":{"total":"218","16to19":"1","20to24":"14","25to34":"49","35to44":"40","45to54":"52","55to64":"40","65+":"23","medianAge":"40"}},"title":"Writers and authors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2011":{"total":"218","women":"57.0","white":"4.5","black":"3.1","asian":"3.7"}},"wageData":{"2011":{"workers":"85","median":"918","maleWorkers":"42","maleMedian":"-","femaleWorkers":"43","femaleMedian":"-"}}},"Miscellaneous media and communication workers":{"ageData":{"2011":{"total":"89","16to19":"2","20to24":"9","25to34":"22","35to44":"17","45to54":"18","55to64":"12","65+":"9","medianAge":"12"}},"title":"Miscellaneous media and communication workers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2011":{"total":"89","women":"64.9","white":"7.9","black":"12.5","asian":"30.6"}},"wageData":{"2011":{"workers":"47","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"32","femaleMedian":"-"}}},"Broadcast and sound engineering technicians and radio operators":{"ageData":{"2011":{"total":"106","16to19":"2","20to24":"13","25to34":"29","35to44":"28","45to54":"18","55to64":"14","65+":"2","medianAge":"14"}},"title":"Broadcast and sound engineering technicians and radio operators","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2011":{"total":"106","women":"9.9","white":"9.1","black":"6.0","asian":"10.2"}},"wageData":{"2011":{"workers":"79","median":"857","maleWorkers":"73","maleMedian":"872","femaleWorkers":"6","femaleMedian":"-"}}},"Photographers":{"ageData":{"2011":{"total":"148","16to19":"2","20to24":"12","25to34":"41","35to44":"37","45to54":"25","55to64":"25","65+":"6","medianAge":"25"}},"title":"Photographers","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2011":{"total":"148","women":"51.3","white":"3.5","black":"2.8","asian":"9.6"}},"wageData":{"2011":{"workers":"45","median":"-","maleWorkers":"29","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Television, video, and motion picture camera operators and editors":{"ageData":{"2011":{"total":"57","16to19":"1","20to24":"6","25to34":"16","35to44":"14","45to54":"8","55to64":"9","65+":"3","medianAge":"9"}},"title":"Television, video, and motion picture camera operators and editors","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2011":{"total":"57","women":"19.9","white":"8.6","black":"5.7","asian":"4.5"}},"wageData":{"2011":{"workers":"27","median":"-","maleWorkers":"22","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Media and communication equipment workers, all other":{"ageData":{"2011":{"total":"3","16to19":"0","20to24":"0","25to34":"0","35to44":"2","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Media and communication equipment workers, all other","depth":4,"parent":"Arts, design, entertainment, sports, and media occupations","sexRaceEthnicityData":{"2011":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Healthcare practitioners and technical occupations":{"ageData":{"2011":{"total":"7,740","16to19":"29","20to24":"395","25to34":"1,908","35to44":"1,877","45to54":"1,873","55to64":"1,341","65+":"318","medianAge":"1,341"}},"title":"Healthcare practitioners and technical occupations","depth":3,"parent":"Professional and related occupations","sexRaceEthnicityData":{"2011":{"total":"7,740","women":"74.4","white":"10.0","black":"7.8","asian":"6.7"}},"wageData":{"2011":{"workers":"5,725","median":"995","maleWorkers":"1,429","maleMedian":"1,129","femaleWorkers":"4,296","femaleMedian":"965"}}},"Chiropractors":{"ageData":{"2011":{"total":"56","16to19":"0","20to24":"0","25to34":"9","35to44":"13","45to54":"18","55to64":"10","65+":"4","medianAge":"10"}},"title":"Chiropractors","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"56","women":"24.5","white":"1.1","black":"7.9","asian":"1.3"}},"wageData":{"2011":{"workers":"5","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Dentists":{"ageData":{"2011":{"total":"181","16to19":"0","20to24":"0","25to34":"24","35to44":"44","45to54":"44","55to64":"46","65+":"22","medianAge":"46"}},"title":"Dentists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"181","women":"22.2","white":"1.0","black":"11.0","asian":"5.8"}},"wageData":{"2011":{"workers":"42","median":"-","maleWorkers":"33","maleMedian":"-","femaleWorkers":"9","femaleMedian":"-"}}},"Dietitians and nutritionists":{"ageData":{"2011":{"total":"102","16to19":"2","20to24":"5","25to34":"20","35to44":"18","45to54":"32","55to64":"20","65+":"5","medianAge":"20"}},"title":"Dietitians and nutritionists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"102","women":"90.6","white":"15.2","black":"4.5","asian":"8.4"}},"wageData":{"2011":{"workers":"69","median":"897","maleWorkers":"6","maleMedian":"-","femaleWorkers":"64","femaleMedian":"906"}}},"Optometrists":{"ageData":{"2011":{"total":"28","16to19":"0","20to24":"0","25to34":"1","35to44":"5","45to54":"7","55to64":"8","65+":"5","medianAge":"8"}},"title":"Optometrists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"28","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"9","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Pharmacists":{"ageData":{"2011":{"total":"274","16to19":"1","20to24":"13","25to34":"80","35to44":"77","45to54":"49","55to64":"38","65+":"15","medianAge":"38"}},"title":"Pharmacists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"274","women":"55.7","white":"7.1","black":"15.3","asian":"4.4"}},"wageData":{"2011":{"workers":"195","median":"1,917","maleWorkers":"85","maleMedian":"1,998","femaleWorkers":"110","femaleMedian":"1,898"}}},"Physicians and surgeons":{"ageData":{"2011":{"total":"822","16to19":"1","20to24":"4","25to34":"168","35to44":"209","45to54":"206","55to64":"157","65+":"78","medianAge":"157"}},"title":"Physicians and surgeons","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"822","women":"33.8","white":"5.3","black":"16.1","asian":"6.6"}},"wageData":{"2011":{"workers":"573","median":"1,860","maleWorkers":"366","maleMedian":"1,935","femaleWorkers":"206","femaleMedian":"1,527"}}},"Physician assistants":{"ageData":{"2011":{"total":"82","16to19":"0","20to24":"4","25to34":"31","35to44":"22","45to54":"13","55to64":"10","65+":"1","medianAge":"10"}},"title":"Physician assistants","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"82","women":"69.8","white":"9.6","black":"2.7","asian":"10.1"}},"wageData":{"2011":{"workers":"69","median":"1,220","maleWorkers":"24","maleMedian":"-","femaleWorkers":"44","femaleMedian":"-"}}},"Podiatrists":{"ageData":{"2011":{"total":"6","16to19":"0","20to24":"0","25to34":"0","35to44":"2","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Podiatrists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Audiologists":{"ageData":{"2011":{"total":"19","16to19":"0","20to24":"0","25to34":"4","35to44":"3","45to54":"8","55to64":"3","65+":"1","medianAge":"3"}},"title":"Audiologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"14","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Occupational therapists":{"ageData":{"2011":{"total":"112","16to19":"0","20to24":"1","25to34":"30","35to44":"38","45to54":"27","55to64":"12","65+":"4","medianAge":"12"}},"title":"Occupational therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"112","women":"92.0","white":"2.7","black":"7.6","asian":"4.6"}},"wageData":{"2011":{"workers":"72","median":"1,189","maleWorkers":"10","maleMedian":"-","femaleWorkers":"62","femaleMedian":"1,193"}}},"Physical therapists":{"ageData":{"2011":{"total":"222","16to19":"0","20to24":"11","25to34":"60","35to44":"71","45to54":"57","55to64":"19","65+":"4","medianAge":"19"}},"title":"Physical therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"222","women":"67.8","white":"5.2","black":"8.9","asian":"5.0"}},"wageData":{"2011":{"workers":"146","median":"1,322","maleWorkers":"59","maleMedian":"1,522","femaleWorkers":"87","femaleMedian":"1,216"}}},"Radiation therapists":{"ageData":{"2011":{"total":"14","16to19":"0","20to24":"1","25to34":"4","35to44":"2","45to54":"5","55to64":"1","65+":"0","medianAge":"1"}},"title":"Radiation therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"12","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Recreational therapists":{"ageData":{"2011":{"total":"14","16to19":"0","20to24":"1","25to34":"2","35to44":"4","45to54":"4","55to64":"2","65+":"1","medianAge":"2"}},"title":"Recreational therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"10","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Respiratory therapists":{"ageData":{"2011":{"total":"134","16to19":"0","20to24":"6","25to34":"27","35to44":"37","45to54":"37","55to64":"24","65+":"2","medianAge":"24"}},"title":"Respiratory therapists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"134","women":"62.0","white":"8.1","black":"5.6","asian":"8.5"}},"wageData":{"2011":{"workers":"126","median":"997","maleWorkers":"53","maleMedian":"966","femaleWorkers":"73","femaleMedian":"1,028"}}},"Speech-language pathologists":{"ageData":{"2011":{"total":"125","16to19":"0","20to24":"6","25to34":"41","35to44":"38","45to54":"18","55to64":"20","65+":"2","medianAge":"20"}},"title":"Speech-language pathologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"125","women":"95.6","white":"1.5","black":"1.5","asian":"6.4"}},"wageData":{"2011":{"workers":"87","median":"1,075","maleWorkers":"3","maleMedian":"-","femaleWorkers":"84","femaleMedian":"1,076"}}},"Exercise physiologists":{"ageData":{"2011":{"total":"2","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Exercise physiologists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Therapists, all other":{"ageData":{"2011":{"total":"138","16to19":"0","20to24":"7","25to34":"46","35to44":"31","45to54":"28","55to64":"20","65+":"5","medianAge":"20"}},"title":"Therapists, all other","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"138","women":"79.9","white":"8.0","black":"3.2","asian":"6.0"}},"wageData":{"2011":{"workers":"83","median":"885","maleWorkers":"19","maleMedian":"-","femaleWorkers":"64","femaleMedian":"869"}}},"Veterinarians":{"ageData":{"2011":{"total":"71","16to19":"1","20to24":"2","25to34":"23","35to44":"16","45to54":"14","55to64":"8","65+":"8","medianAge":"8"}},"title":"Veterinarians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"71","women":"56.4","white":"1.6","black":"4.0","asian":"5.0"}},"wageData":{"2011":{"workers":"40","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Registered nurses":{"ageData":{"2011":{"total":"2,706","16to19":"3","20to24":"110","25to34":"628","35to44":"641","45to54":"679","55to64":"552","65+":"94","medianAge":"552"}},"title":"Registered nurses","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"2,706","women":"91.1","white":"10.4","black":"7.3","asian":"5.1"}},"wageData":{"2011":{"workers":"2,145","median":"1,039","maleWorkers":"208","maleMedian":"1,081","femaleWorkers":"1,937","femaleMedian":"1,034"}}},"Nurse anesthetists":{"ageData":{"2011":{"total":"33","16to19":"0","20to24":"0","25to34":"2","35to44":"8","45to54":"14","55to64":"9","65+":"0","medianAge":"9"}},"title":"Nurse anesthetists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"26","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Nurse midwives":{"ageData":{"2011":{"total":"5","16to19":"0","20to24":"0","25to34":"0","35to44":"4","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Nurse midwives","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"2","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Nurse practitioners":{"ageData":{"2011":{"total":"100","16to19":"0","20to24":"1","25to34":"13","35to44":"31","45to54":"33","55to64":"21","65+":"1","medianAge":"21"}},"title":"Nurse practitioners","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"100","women":"90.6","white":"7.3","black":"2.4","asian":"8.6"}},"wageData":{"2011":{"workers":"81","median":"1,461","maleWorkers":"11","maleMedian":"-","femaleWorkers":"69","femaleMedian":"1,432"}}},"Health diagnosing and treating practitioners, all other":{"ageData":{"2011":{"total":"26","16to19":"0","20to24":"0","25to34":"4","35to44":"4","45to54":"9","55to64":"7","65+":"3","medianAge":"7"}},"title":"Health diagnosing and treating practitioners, all other","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"26","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"5","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Clinical laboratory technologists and technicians":{"ageData":{"2011":{"total":"321","16to19":"1","20to24":"25","25to34":"80","35to44":"66","45to54":"87","55to64":"56","65+":"6","medianAge":"56"}},"title":"Clinical laboratory technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"321","women":"73.6","white":"15.3","black":"8.9","asian":"9.4"}},"wageData":{"2011":{"workers":"282","median":"861","maleWorkers":"77","maleMedian":"888","femaleWorkers":"206","femaleMedian":"845"}}},"Dental hygienists":{"ageData":{"2011":{"total":"148","16to19":"0","20to24":"5","25to34":"41","35to44":"41","45to54":"33","55to64":"25","65+":"2","medianAge":"25"}},"title":"Dental hygienists","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"148","women":"97.5","white":"0.5","black":"5.5","asian":"7.2"}},"wageData":{"2011":{"workers":"61","median":"986","maleWorkers":"3","maleMedian":"-","femaleWorkers":"59","femaleMedian":"992"}}},"Diagnostic related technologists and technicians":{"ageData":{"2011":{"total":"342","16to19":"0","20to24":"21","25to34":"87","35to44":"84","45to54":"97","55to64":"48","65+":"5","medianAge":"48"}},"title":"Diagnostic related technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"342","women":"73.0","white":"9.0","black":"4.0","asian":"7.2"}},"wageData":{"2011":{"workers":"273","median":"981","maleWorkers":"82","maleMedian":"1,054","femaleWorkers":"191","femaleMedian":"964"}}},"Emergency medical technicians and paramedics":{"ageData":{"2011":{"total":"185","16to19":"2","20to24":"30","25to34":"81","35to44":"34","45to54":"27","55to64":"8","65+":"2","medianAge":"8"}},"title":"Emergency medical technicians and paramedics","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"185","women":"36.0","white":"4.5","black":"0.9","asian":"6.4"}},"wageData":{"2011":{"workers":"167","median":"715","maleWorkers":"113","maleMedian":"757","femaleWorkers":"54","femaleMedian":"649"}}},"Health practitioner support technologists and technicians":{"ageData":{"2011":{"total":"511","16to19":"13","20to24":"86","25to34":"167","35to44":"93","45to54":"96","55to64":"44","65+":"11","medianAge":"44"}},"title":"Health practitioner support technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"511","women":"78.6","white":"15.1","black":"5.6","asian":"11.0"}},"wageData":{"2011":{"workers":"374","median":"644","maleWorkers":"91","maleMedian":"682","femaleWorkers":"283","femaleMedian":"632"}}},"Licensed practical and licensed vocational nurses":{"ageData":{"2011":{"total":"560","16to19":"4","20to24":"30","25to34":"132","35to44":"144","45to54":"135","55to64":"95","65+":"21","medianAge":"95"}},"title":"Licensed practical and licensed vocational nurses","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"560","women":"90.5","white":"23.7","black":"3.9","asian":"8.3"}},"wageData":{"2011":{"workers":"424","median":"722","maleWorkers":"39","maleMedian":"-","femaleWorkers":"386","femaleMedian":"720"}}},"Medical records and health information technicians":{"ageData":{"2011":{"total":"116","16to19":"1","20to24":"8","25to34":"32","35to44":"26","45to54":"22","55to64":"23","65+":"5","medianAge":"23"}},"title":"Medical records and health information technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"116","women":"89.7","white":"10.6","black":"9.5","asian":"19.6"}},"wageData":{"2011":{"workers":"107","median":"588","maleWorkers":"10","maleMedian":"-","femaleWorkers":"96","femaleMedian":"574"}}},"Opticians, dispensing":{"ageData":{"2011":{"total":"51","16to19":"1","20to24":"3","25to34":"10","35to44":"12","45to54":"12","55to64":"11","65+":"3","medianAge":"11"}},"title":"Opticians, dispensing","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"51","women":"64.3","white":"9.4","black":"1.8","asian":"4.8"}},"wageData":{"2011":{"workers":"34","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"26","femaleMedian":"-"}}},"Miscellaneous health technologists and technicians":{"ageData":{"2011":{"total":"167","16to19":"0","20to24":"10","25to34":"43","35to44":"41","45to54":"43","55to64":"27","65+":"3","medianAge":"27"}},"title":"Miscellaneous health technologists and technicians","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"167","women":"65.7","white":"16.7","black":"11.8","asian":"9.7"}},"wageData":{"2011":{"workers":"127","median":"744","maleWorkers":"38","maleMedian":"-","femaleWorkers":"89","femaleMedian":"711"}}},"Other healthcare practitioners and technical occupations":{"ageData":{"2011":{"total":"70","16to19":"0","20to24":"4","25to34":"17","35to44":"19","45to54":"14","55to64":"11","65+":"4","medianAge":"11"}},"title":"Other healthcare practitioners and technical occupations","depth":4,"parent":"Healthcare practitioners and technical occupations","sexRaceEthnicityData":{"2011":{"total":"70","women":"39.5","white":"9.4","black":"5.1","asian":"5.6"}},"wageData":{"2011":{"workers":"63","median":"870","maleWorkers":"41","maleMedian":"-","femaleWorkers":"22","femaleMedian":"-"}}},"Service occupations":{"ageData":{"2011":{"total":"24,787","16to19":"1,829","20to24":"3,788","25to34":"5,515","35to44":"4,722","45to54":"4,794","55to64":"3,072","65+":"1,066","medianAge":"3,072"}},"title":"Service occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2011":{"total":"24,787","women":"55.9","white":"15.4","black":"4.9","asian":"21.0"}},"wageData":{"2011":{"workers":"14,378","median":"486","maleWorkers":"7,387","maleMedian":"551","femaleWorkers":"6,991","femaleMedian":"433"}}},"Healthcare support occupations":{"ageData":{"2011":{"total":"3,359","16to19":"81","20to24":"478","25to34":"865","35to44":"675","45to54":"698","55to64":"448","65+":"114","medianAge":"448"}},"title":"Healthcare support occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2011":{"total":"3,359","women":"87.7","white":"24.6","black":"4.3","asian":"13.9"}},"wageData":{"2011":{"workers":"2,190","median":"487","maleWorkers":"290","maleMedian":"521","femaleWorkers":"1,900","femaleMedian":"483"}}},"Nursing, psychiatric, and home health aides":{"ageData":{"2011":{"total":"1,981","16to19":"47","20to24":"275","25to34":"445","35to44":"401","45to54":"441","55to64":"284","65+":"89","medianAge":"284"}},"title":"Nursing, psychiatric, and home health aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2011":{"total":"1,981","women":"87.8","white":"33.1","black":"4.3","asian":"13.3"}},"wageData":{"2011":{"workers":"1,305","median":"453","maleWorkers":"172","maleMedian":"502","femaleWorkers":"1,134","femaleMedian":"446"}}},"Occupational therapy assistants and aides":{"ageData":{"2011":{"total":"17","16to19":"0","20to24":"1","25to34":"10","35to44":"4","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Occupational therapy assistants and aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2011":{"total":"17","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"12","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Physical therapist assistants and aides":{"ageData":{"2011":{"total":"75","16to19":"1","20to24":"15","25to34":"28","35to44":"16","45to54":"11","55to64":"5","65+":"0","medianAge":"5"}},"title":"Physical therapist assistants and aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2011":{"total":"75","women":"60.8","white":"10.4","black":"3.5","asian":"9.7"}},"wageData":{"2011":{"workers":"54","median":"665","maleWorkers":"22","maleMedian":"-","femaleWorkers":"32","femaleMedian":"-"}}},"Massage therapists":{"ageData":{"2011":{"total":"146","16to19":"1","20to24":"14","25to34":"44","35to44":"30","45to54":"29","55to64":"24","65+":"3","medianAge":"24"}},"title":"Massage therapists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2011":{"total":"146","women":"86.5","white":"5.5","black":"5.5","asian":"7.0"}},"wageData":{"2011":{"workers":"34","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Dental assistants":{"ageData":{"2011":{"total":"307","16to19":"3","20to24":"46","25to34":"92","35to44":"73","45to54":"54","55to64":"33","65+":"5","medianAge":"33"}},"title":"Dental assistants","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2011":{"total":"307","women":"97.9","white":"8.3","black":"5.1","asian":"16.3"}},"wageData":{"2011":{"workers":"191","median":"579","maleWorkers":"7","maleMedian":"-","femaleWorkers":"184","femaleMedian":"582"}}},"Medical assistants":{"ageData":{"2011":{"total":"395","16to19":"5","20to24":"56","25to34":"152","35to44":"73","45to54":"67","55to64":"36","65+":"6","medianAge":"36"}},"title":"Medical assistants","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2011":{"total":"395","women":"93.4","white":"14.3","black":"5.2","asian":"20.2"}},"wageData":{"2011":{"workers":"314","median":"522","maleWorkers":"21","maleMedian":"-","femaleWorkers":"293","femaleMedian":"518"}}},"Medical transcriptionists":{"ageData":{"2011":{"total":"74","16to19":"0","20to24":"3","25to34":"9","35to44":"12","45to54":"25","55to64":"20","65+":"4","medianAge":"20"}},"title":"Medical transcriptionists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2011":{"total":"74","women":"95.4","white":"0.3","black":"0.0","asian":"2.1"}},"wageData":{"2011":{"workers":"44","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"43","femaleMedian":"-"}}},"Pharmacy aides":{"ageData":{"2011":{"total":"48","16to19":"4","20to24":"15","25to34":"6","35to44":"10","45to54":"11","55to64":"3","65+":"0","medianAge":"3"}},"title":"Pharmacy aides","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2011":{"total":"48","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"23","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"14","femaleMedian":"-"}}},"Veterinary assistants and laboratory animal caretakers":{"ageData":{"2011":{"total":"38","16to19":"2","20to24":"11","25to34":"15","35to44":"4","45to54":"1","55to64":"4","65+":"0","medianAge":"4"}},"title":"Veterinary assistants and laboratory animal caretakers","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2011":{"total":"38","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"20","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Phlebotomists":{"ageData":{"2011":{"total":"119","16to19":"2","20to24":"16","25to34":"31","35to44":"29","45to54":"25","55to64":"14","65+":"2","medianAge":"14"}},"title":"Phlebotomists","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2011":{"total":"119","women":"81.8","white":"26.7","black":"4.9","asian":"13.7"}},"wageData":{"2011":{"workers":"94","median":"521","maleWorkers":"16","maleMedian":"-","femaleWorkers":"77","femaleMedian":"516"}}},"Miscellaneous healthcare support occupations, including medical equipment preparers":{"ageData":{"2011":{"total":"158","16to19":"16","20to24":"27","25to34":"33","35to44":"22","45to54":"32","55to64":"23","65+":"4","medianAge":"23"}},"title":"Miscellaneous healthcare support occupations, including medical equipment preparers","depth":3,"parent":"Healthcare support occupations","sexRaceEthnicityData":{"2011":{"total":"158","women":"74.0","white":"24.3","black":"2.8","asian":"13.3"}},"wageData":{"2011":{"workers":"98","median":"487","maleWorkers":"26","maleMedian":"-","femaleWorkers":"72","femaleMedian":"480"}}},"Protective service occupations":{"ageData":{"2011":{"total":"3,210","16to19":"90","20to24":"267","25to34":"821","35to44":"806","45to54":"675","55to64":"407","65+":"143","medianAge":"407"}},"title":"Protective service occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2011":{"total":"3,210","women":"20.7","white":"17.4","black":"2.1","asian":"12.6"}},"wageData":{"2011":{"workers":"2,798","median":"757","maleWorkers":"2,287","maleMedian":"797","femaleWorkers":"511","femaleMedian":"602"}}},"First-line supervisors of correctional officers":{"ageData":{"2011":{"total":"42","16to19":"0","20to24":"1","25to34":"8","35to44":"10","45to54":"16","55to64":"6","65+":"2","medianAge":"6"}},"title":"First-line supervisors of correctional officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2011":{"total":"42","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"41","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"First-line supervisors of police and detectives":{"ageData":{"2011":{"total":"107","16to19":"0","20to24":"0","25to34":"9","35to44":"37","45to54":"37","55to64":"20","65+":"4","medianAge":"20"}},"title":"First-line supervisors of police and detectives","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2011":{"total":"107","women":"17.5","white":"9.3","black":"4.0","asian":"6.7"}},"wageData":{"2011":{"workers":"101","median":"1,083","maleWorkers":"83","maleMedian":"1,109","femaleWorkers":"18","femaleMedian":"-"}}},"First-line supervisors of fire fighting and prevention workers":{"ageData":{"2011":{"total":"44","16to19":"0","20to24":"0","25to34":"4","35to44":"14","45to54":"19","55to64":"7","65+":"0","medianAge":"7"}},"title":"First-line supervisors of fire fighting and prevention workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2011":{"total":"44","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"40","median":"-","maleWorkers":"39","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"First-line supervisors of protective service workers, all other":{"ageData":{"2011":{"total":"111","16to19":"0","20to24":"4","25to34":"21","35to44":"22","45to54":"34","55to64":"25","65+":"7","medianAge":"25"}},"title":"First-line supervisors of protective service workers, all other","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2011":{"total":"111","women":"24.2","white":"17.6","black":"1.1","asian":"11.5"}},"wageData":{"2011":{"workers":"96","median":"716","maleWorkers":"73","maleMedian":"788","femaleWorkers":"23","femaleMedian":"-"}}},"Firefighters":{"ageData":{"2011":{"total":"305","16to19":"2","20to24":"21","25to34":"118","35to44":"97","45to54":"55","55to64":"11","65+":"2","medianAge":"11"}},"title":"Firefighters","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2011":{"total":"305","women":"4.5","white":"2.9","black":"0.6","asian":"10.0"}},"wageData":{"2011":{"workers":"291","median":"1,000","maleWorkers":"281","maleMedian":"998","femaleWorkers":"11","femaleMedian":"-"}}},"Fire inspectors":{"ageData":{"2011":{"total":"20","16to19":"0","20to24":"0","25to34":"5","35to44":"5","45to54":"8","55to64":"2","65+":"0","medianAge":"2"}},"title":"Fire inspectors","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2011":{"total":"20","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"18","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Bailiffs, correctional officers, and jailers":{"ageData":{"2011":{"total":"446","16to19":"3","20to24":"29","25to34":"129","35to44":"127","45to54":"99","55to64":"49","65+":"9","medianAge":"49"}},"title":"Bailiffs, correctional officers, and jailers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2011":{"total":"446","women":"27.9","white":"25.1","black":"1.9","asian":"13.0"}},"wageData":{"2011":{"workers":"436","median":"682","maleWorkers":"320","maleMedian":"722","femaleWorkers":"116","femaleMedian":"586"}}},"Detectives and criminal investigators":{"ageData":{"2011":{"total":"151","16to19":"0","20to24":"3","25to34":"32","35to44":"52","45to54":"41","55to64":"17","65+":"6","medianAge":"17"}},"title":"Detectives and criminal investigators","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2011":{"total":"151","women":"16.7","white":"8.9","black":"1.2","asian":"14.9"}},"wageData":{"2011":{"workers":"147","median":"1,154","maleWorkers":"125","maleMedian":"1,192","femaleWorkers":"22","femaleMedian":"-"}}},"Fish and game wardens":{"ageData":{"2011":{"total":"6","16to19":"0","20to24":"0","25to34":"2","35to44":"2","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Fish and game wardens","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2011":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Parking enforcement workers":{"ageData":{"2011":{"total":"7","16to19":"0","20to24":"1","25to34":"0","35to44":"2","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Parking enforcement workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2011":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"5","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Police and sheriff\'s patrol officers":{"ageData":{"2011":{"total":"668","16to19":"2","20to24":"20","25to34":"218","35to44":"234","45to54":"126","55to64":"59","65+":"9","medianAge":"59"}},"title":"Police and sheriff\'s patrol officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2011":{"total":"668","women":"12.0","white":"11.5","black":"2.0","asian":"12.7"}},"wageData":{"2011":{"workers":"653","median":"947","maleWorkers":"578","maleMedian":"948","femaleWorkers":"75","femaleMedian":"938"}}},"Transit and railroad police":{"ageData":{"2011":{"total":"8","16to19":"0","20to24":"0","25to34":"2","35to44":"3","45to54":"3","55to64":"0","65+":"0","medianAge":"0"}},"title":"Transit and railroad police","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2011":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Animal control workers":{"ageData":{"2011":{"total":"6","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Animal control workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2011":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"8","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Private detectives and investigators":{"ageData":{"2011":{"total":"92","16to19":"1","20to24":"7","25to34":"18","35to44":"26","45to54":"20","55to64":"15","65+":"5","medianAge":"15"}},"title":"Private detectives and investigators","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2011":{"total":"92","women":"35.3","white":"8.3","black":"1.2","asian":"11.5"}},"wageData":{"2011":{"workers":"86","median":"869","maleWorkers":"56","maleMedian":"891","femaleWorkers":"30","femaleMedian":"-"}}},"Security guards and gaming surveillance officers":{"ageData":{"2011":{"total":"963","16to19":"17","20to24":"137","25to34":"229","35to44":"152","45to54":"181","55to64":"165","65+":"83","medianAge":"165"}},"title":"Security guards and gaming surveillance officers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2011":{"total":"963","women":"19.2","white":"27.2","black":"3.6","asian":"15.4"}},"wageData":{"2011":{"workers":"775","median":"519","maleWorkers":"619","maleMedian":"544","femaleWorkers":"156","femaleMedian":"474"}}},"Crossing guards":{"ageData":{"2011":{"total":"59","16to19":"1","20to24":"3","25to34":"6","35to44":"7","45to54":"17","55to64":"14","65+":"11","medianAge":"14"}},"title":"Crossing guards","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2011":{"total":"59","women":"64.3","white":"19.7","black":"0.0","asian":"5.5"}},"wageData":{"2011":{"workers":"23","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Transportation security screeners":{"ageData":{"2011":{"total":"27","16to19":"0","20to24":"1","25to34":"9","35to44":"7","45to54":"7","55to64":"3","65+":"1","medianAge":"3"}},"title":"Transportation security screeners","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2011":{"total":"27","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"21","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"10","femaleMedian":"-"}}},"Lifeguards and other recreational, and all other protective service workers":{"ageData":{"2011":{"total":"146","16to19":"64","20to24":"39","25to34":"12","35to44":"7","45to54":"10","55to64":"12","65+":"4","medianAge":"12"}},"title":"Lifeguards and other recreational, and all other protective service workers","depth":3,"parent":"Protective service occupations","sexRaceEthnicityData":{"2011":{"total":"146","women":"58.1","white":"6.2","black":"0.3","asian":"6.3"}},"wageData":{"2011":{"workers":"44","median":"-","maleWorkers":"21","maleMedian":"-","femaleWorkers":"23","femaleMedian":"-"}}},"Food preparation and serving related occupations":{"ageData":{"2011":{"total":"7,747","16to19":"1,189","20to24":"1,846","25to34":"1,808","35to44":"1,119","45to54":"1,028","55to64":"557","65+":"201","medianAge":"557"}},"title":"Food preparation and serving related occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2011":{"total":"7,747","women":"54.4","white":"12.6","black":"5.9","asian":"21.8"}},"wageData":{"2011":{"workers":"3,930","median":"409","maleWorkers":"2,021","maleMedian":"429","femaleWorkers":"1,909","femaleMedian":"390"}}},"Chefs and head cooks":{"ageData":{"2011":{"total":"347","16to19":"11","20to24":"33","25to34":"100","35to44":"100","45to54":"60","55to64":"35","65+":"8","medianAge":"35"}},"title":"Chefs and head cooks","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2011":{"total":"347","women":"18.7","white":"9.1","black":"15.3","asian":"18.0"}},"wageData":{"2011":{"workers":"299","median":"580","maleWorkers":"245","maleMedian":"601","femaleWorkers":"53","femaleMedian":"502"}}},"First-line supervisors of food preparation and serving workers":{"ageData":{"2011":{"total":"505","16to19":"16","20to24":"90","25to34":"131","35to44":"106","45to54":"93","55to64":"56","65+":"13","medianAge":"56"}},"title":"First-line supervisors of food preparation and serving workers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2011":{"total":"505","women":"59.1","white":"18.2","black":"3.2","asian":"15.1"}},"wageData":{"2011":{"workers":"378","median":"485","maleWorkers":"158","maleMedian":"525","femaleWorkers":"220","femaleMedian":"458"}}},"Cooks":{"ageData":{"2011":{"total":"1,990","16to19":"207","20to24":"355","25to34":"480","35to44":"356","45to54":"359","55to64":"174","65+":"57","medianAge":"174"}},"title":"Cooks","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2011":{"total":"1,990","women":"39.2","white":"17.9","black":"5.9","asian":"30.4"}},"wageData":{"2011":{"workers":"1,210","median":"390","maleWorkers":"761","maleMedian":"406","femaleWorkers":"449","femaleMedian":"363"}}},"Food preparation workers":{"ageData":{"2011":{"total":"784","16to19":"153","20to24":"187","25to34":"154","35to44":"99","45to54":"110","55to64":"57","65+":"24","medianAge":"57"}},"title":"Food preparation workers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2011":{"total":"784","women":"58.0","white":"14.4","black":"5.7","asian":"23.0"}},"wageData":{"2011":{"workers":"357","median":"384","maleWorkers":"155","maleMedian":"395","femaleWorkers":"202","femaleMedian":"375"}}},"Bartenders":{"ageData":{"2011":{"total":"392","16to19":"4","20to24":"71","25to34":"157","35to44":"72","45to54":"50","55to64":"28","65+":"10","medianAge":"28"}},"title":"Bartenders","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2011":{"total":"392","women":"55.7","white":"5.1","black":"2.1","asian":"10.1"}},"wageData":{"2011":{"workers":"210","median":"545","maleWorkers":"104","maleMedian":"593","femaleWorkers":"106","femaleMedian":"505"}}},"Combined food preparation and serving workers, including fast food":{"ageData":{"2011":{"total":"326","16to19":"58","20to24":"85","25to34":"65","35to44":"38","45to54":"47","55to64":"24","65+":"9","medianAge":"24"}},"title":"Combined food preparation and serving workers, including fast food","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2011":{"total":"326","women":"66.0","white":"16.3","black":"3.7","asian":"15.4"}},"wageData":{"2011":{"workers":"161","median":"387","maleWorkers":"46","maleMedian":"-","femaleWorkers":"114","femaleMedian":"385"}}},"Counter attendants, cafeteria, food concession, and coffee shop":{"ageData":{"2011":{"total":"255","16to19":"122","20to24":"72","25to34":"23","35to44":"13","45to54":"13","55to64":"9","65+":"4","medianAge":"9"}},"title":"Counter attendants, cafeteria, food concession, and coffee shop","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2011":{"total":"255","women":"68.3","white":"9.1","black":"3.5","asian":"16.9"}},"wageData":{"2011":{"workers":"58","median":"323","maleWorkers":"26","maleMedian":"-","femaleWorkers":"32","femaleMedian":"-"}}},"Waiters and waitresses":{"ageData":{"2011":{"total":"2,059","16to19":"309","20to24":"681","25to34":"547","35to44":"222","45to54":"180","55to64":"88","65+":"31","medianAge":"88"}},"title":"Waiters and waitresses","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2011":{"total":"2,059","women":"69.5","white":"7.8","black":"6.6","asian":"17.1"}},"wageData":{"2011":{"workers":"872","median":"407","maleWorkers":"313","maleMedian":"466","femaleWorkers":"559","femaleMedian":"389"}}},"Food servers, nonrestaurant":{"ageData":{"2011":{"total":"181","16to19":"28","20to24":"39","25to34":"29","35to44":"18","45to54":"30","55to64":"23","65+":"14","medianAge":"23"}},"title":"Food servers, nonrestaurant","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2011":{"total":"181","women":"67.7","white":"21.0","black":"6.1","asian":"17.1"}},"wageData":{"2011":{"workers":"84","median":"419","maleWorkers":"31","maleMedian":"-","femaleWorkers":"52","femaleMedian":"393"}}},"Dining room and cafeteria attendants and bartender helpers":{"ageData":{"2011":{"total":"347","16to19":"87","20to24":"84","25to34":"49","35to44":"42","45to54":"42","55to64":"28","65+":"15","medianAge":"28"}},"title":"Dining room and cafeteria attendants and bartender helpers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2011":{"total":"347","women":"46.8","white":"9.8","black":"4.9","asian":"31.5"}},"wageData":{"2011":{"workers":"119","median":"383","maleWorkers":"77","maleMedian":"392","femaleWorkers":"42","femaleMedian":"-"}}},"Dishwashers":{"ageData":{"2011":{"total":"273","16to19":"64","20to24":"55","25to34":"50","35to44":"39","45to54":"33","55to64":"23","65+":"9","medianAge":"23"}},"title":"Dishwashers","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2011":{"total":"273","women":"19.9","white":"11.9","black":"7.4","asian":"34.4"}},"wageData":{"2011":{"workers":"118","median":"332","maleWorkers":"90","maleMedian":"321","femaleWorkers":"28","femaleMedian":"-"}}},"Hosts and hostesses, restaurant, lounge, and coffee shop":{"ageData":{"2011":{"total":"286","16to19":"128","20to24":"92","25to34":"23","35to44":"15","45to54":"12","55to64":"9","65+":"7","medianAge":"9"}},"title":"Hosts and hostesses, restaurant, lounge, and coffee shop","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2011":{"total":"286","women":"83.0","white":"6.9","black":"3.3","asian":"16.4"}},"wageData":{"2011":{"workers":"62","median":"369","maleWorkers":"10","maleMedian":"-","femaleWorkers":"52","femaleMedian":"356"}}},"Food preparation and serving related workers, all other":{"ageData":{"2011":{"total":"4","16to19":"0","20to24":"1","25to34":"0","35to44":"0","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Food preparation and serving related workers, all other","depth":3,"parent":"Food preparation and serving related occupations","sexRaceEthnicityData":{"2011":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Building and grounds cleaning and maintenance occupations":{"ageData":{"2011":{"total":"5,492","16to19":"174","20to24":"473","25to34":"1,022","35to44":"1,128","45to54":"1,412","55to64":"967","65+":"317","medianAge":"967"}},"title":"Building and grounds cleaning and maintenance occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2011":{"total":"5,492","women":"38.8","white":"13.7","black":"3.1","asian":"34.8"}},"wageData":{"2011":{"workers":"3,339","median":"465","maleWorkers":"2,212","maleMedian":"502","femaleWorkers":"1,128","femaleMedian":"406"}}},"First-line supervisors of housekeeping and janitorial workers":{"ageData":{"2011":{"total":"292","16to19":"0","20to24":"3","25to34":"35","35to44":"70","45to54":"98","55to64":"72","65+":"14","medianAge":"72"}},"title":"First-line supervisors of housekeeping and janitorial workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2011":{"total":"292","women":"41.0","white":"17.3","black":"3.5","asian":"16.0"}},"wageData":{"2011":{"workers":"179","median":"646","maleWorkers":"113","maleMedian":"756","femaleWorkers":"67","femaleMedian":"488"}}},"First-line supervisors of landscaping, lawn service, and groundskeeping workers":{"ageData":{"2011":{"total":"274","16to19":"1","20to24":"10","25to34":"59","35to44":"77","45to54":"74","55to64":"44","65+":"9","medianAge":"44"}},"title":"First-line supervisors of landscaping, lawn service, and groundskeeping workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2011":{"total":"274","women":"9.9","white":"4.9","black":"1.4","asian":"19.1"}},"wageData":{"2011":{"workers":"94","median":"797","maleWorkers":"85","maleMedian":"808","femaleWorkers":"10","femaleMedian":"-"}}},"Janitors and building cleaners":{"ageData":{"2011":{"total":"2,186","16to19":"78","20to24":"189","25to34":"318","35to44":"393","45to54":"586","55to64":"459","65+":"164","medianAge":"459"}},"title":"Janitors and building cleaners","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2011":{"total":"2,186","women":"30.3","white":"16.6","black":"3.1","asian":"30.4"}},"wageData":{"2011":{"workers":"1,496","median":"489","maleWorkers":"1,111","maleMedian":"514","femaleWorkers":"384","femaleMedian":"418"}}},"Maids and housekeeping cleaners":{"ageData":{"2011":{"total":"1,419","16to19":"29","20to24":"94","25to34":"253","35to44":"311","45to54":"408","55to64":"245","65+":"79","medianAge":"245"}},"title":"Maids and housekeeping cleaners","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2011":{"total":"1,419","women":"88.6","white":"16.5","black":"4.5","asian":"39.9"}},"wageData":{"2011":{"workers":"751","median":"399","maleWorkers":"114","maleMedian":"473","femaleWorkers":"638","femaleMedian":"392"}}},"Pest control workers":{"ageData":{"2011":{"total":"75","16to19":"0","20to24":"7","25to34":"17","35to44":"22","45to54":"16","55to64":"10","65+":"3","medianAge":"10"}},"title":"Pest control workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2011":{"total":"75","women":"3.7","white":"7.0","black":"0.0","asian":"20.3"}},"wageData":{"2011":{"workers":"58","median":"575","maleWorkers":"57","maleMedian":"572","femaleWorkers":"1","femaleMedian":"-"}}},"Grounds maintenance workers":{"ageData":{"2011":{"total":"1,247","16to19":"65","20to24":"171","25to34":"341","35to44":"256","45to54":"231","55to64":"136","65+":"48","medianAge":"136"}},"title":"Grounds maintenance workers","depth":3,"parent":"Building and grounds cleaning and maintenance occupations","sexRaceEthnicityData":{"2011":{"total":"1,247","women":"5.2","white":"7.1","black":"1.8","asian":"45.2"}},"wageData":{"2011":{"workers":"761","median":"425","maleWorkers":"732","maleMedian":"424","femaleWorkers":"29","femaleMedian":"-"}}},"Personal care and service occupations":{"ageData":{"2011":{"total":"4,979","16to19":"296","20to24":"724","25to34":"999","35to44":"995","45to54":"981","55to64":"694","65+":"291","medianAge":"694"}},"title":"Personal care and service occupations","depth":2,"parent":"Service occupations","sexRaceEthnicityData":{"2011":{"total":"4,979","women":"78.4","white":"14.1","black":"7.6","asian":"14.7"}},"wageData":{"2011":{"workers":"2,121","median":"453","maleWorkers":"578","maleMedian":"562","femaleWorkers":"1,543","femaleMedian":"422"}}},"First-line supervisors of gaming workers":{"ageData":{"2011":{"total":"120","16to19":"2","20to24":"14","25to34":"28","35to44":"31","45to54":"25","55to64":"14","65+":"6","medianAge":"14"}},"title":"First-line supervisors of gaming workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2011":{"total":"120","women":"46.4","white":"3.7","black":"9.1","asian":"8.4"}},"wageData":{"2011":{"workers":"90","median":"739","maleWorkers":"51","maleMedian":"876","femaleWorkers":"39","femaleMedian":"-"}}},"First-line supervisors of personal service workers":{"ageData":{"2011":{"total":"192","16to19":"0","20to24":"16","25to34":"31","35to44":"61","45to54":"49","55to64":"30","65+":"5","medianAge":"30"}},"title":"First-line supervisors of personal service workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2011":{"total":"192","women":"73.5","white":"9.9","black":"13.8","asian":"11.0"}},"wageData":{"2011":{"workers":"67","median":"613","maleWorkers":"21","maleMedian":"-","femaleWorkers":"46","femaleMedian":"-"}}},"Animal trainers":{"ageData":{"2011":{"total":"49","16to19":"1","20to24":"7","25to34":"9","35to44":"9","45to54":"15","55to64":"7","65+":"1","medianAge":"7"}},"title":"Animal trainers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2011":{"total":"49","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"16","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Nonfarm animal caretakers":{"ageData":{"2011":{"total":"179","16to19":"15","20to24":"39","25to34":"27","35to44":"34","45to54":"40","55to64":"20","65+":"5","medianAge":"20"}},"title":"Nonfarm animal caretakers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2011":{"total":"179","women":"75.9","white":"2.7","black":"1.4","asian":"11.0"}},"wageData":{"2011":{"workers":"82","median":"419","maleWorkers":"22","maleMedian":"-","femaleWorkers":"60","femaleMedian":"417"}}},"Gaming services workers":{"ageData":{"2011":{"total":"113","16to19":"3","20to24":"8","25to34":"31","35to44":"24","45to54":"26","55to64":"15","65+":"6","medianAge":"15"}},"title":"Gaming services workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2011":{"total":"113","women":"44.9","white":"5.6","black":"23.3","asian":"16.4"}},"wageData":{"2011":{"workers":"82","median":"636","maleWorkers":"43","maleMedian":"-","femaleWorkers":"39","femaleMedian":"-"}}},"Motion picture projectionists":{"ageData":{"2011":{"total":"8","16to19":"1","20to24":"4","25to34":"1","35to44":"0","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Motion picture projectionists","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2011":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Ushers, lobby attendants, and ticket takers":{"ageData":{"2011":{"total":"46","16to19":"12","20to24":"11","25to34":"11","35to44":"4","45to54":"2","55to64":"4","65+":"2","medianAge":"4"}},"title":"Ushers, lobby attendants, and ticket takers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2011":{"total":"46","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"9","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Miscellaneous entertainment attendants and related workers":{"ageData":{"2011":{"total":"182","16to19":"41","20to24":"46","25to34":"30","35to44":"19","45to54":"17","55to64":"17","65+":"12","medianAge":"17"}},"title":"Miscellaneous entertainment attendants and related workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2011":{"total":"182","women":"51.7","white":"13.9","black":"3.8","asian":"11.3"}},"wageData":{"2011":{"workers":"66","median":"424","maleWorkers":"35","maleMedian":"-","femaleWorkers":"31","femaleMedian":"-"}}},"Embalmers and funeral attendants":{"ageData":{"2011":{"total":"8","16to19":"0","20to24":"1","25to34":"1","35to44":"1","45to54":"1","55to64":"0","65+":"4","medianAge":"0"}},"title":"Embalmers and funeral attendants","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2011":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"5","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Morticians, undertakers, and funeral directors":{"ageData":{"2011":{"total":"23","16to19":"0","20to24":"0","25to34":"4","35to44":"6","45to54":"3","55to64":"6","65+":"4","medianAge":"6"}},"title":"Morticians, undertakers, and funeral directors","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2011":{"total":"23","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"16","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Barbers":{"ageData":{"2011":{"total":"89","16to19":"0","20to24":"7","25to34":"21","35to44":"15","45to54":"13","55to64":"17","65+":"15","medianAge":"17"}},"title":"Barbers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2011":{"total":"89","women":"24.0","white":"27.7","black":"2.6","asian":"17.6"}},"wageData":{"2011":{"workers":"29","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Hairdressers, hairstylists, and cosmetologists":{"ageData":{"2011":{"total":"758","16to19":"7","20to24":"94","25to34":"196","35to44":"174","45to54":"144","55to64":"104","65+":"40","medianAge":"104"}},"title":"Hairdressers, hairstylists, and cosmetologists","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2011":{"total":"758","women":"93.0","white":"11.6","black":"4.1","asian":"12.8"}},"wageData":{"2011":{"workers":"282","median":"453","maleWorkers":"23","maleMedian":"-","femaleWorkers":"259","femaleMedian":"440"}}},"Miscellaneous personal appearance workers":{"ageData":{"2011":{"total":"251","16to19":"5","20to24":"13","25to34":"62","35to44":"80","45to54":"50","55to64":"32","65+":"8","medianAge":"32"}},"title":"Miscellaneous personal appearance workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2011":{"total":"251","women":"84.1","white":"5.9","black":"55.1","asian":"5.3"}},"wageData":{"2011":{"workers":"136","median":"441","maleWorkers":"32","maleMedian":"-","femaleWorkers":"104","femaleMedian":"413"}}},"Baggage porters, bellhops, and concierges":{"ageData":{"2011":{"total":"81","16to19":"2","20to24":"12","25to34":"20","35to44":"15","45to54":"16","55to64":"12","65+":"4","medianAge":"12"}},"title":"Baggage porters, bellhops, and concierges","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2011":{"total":"81","women":"14.0","white":"20.7","black":"9.1","asian":"28.4"}},"wageData":{"2011":{"workers":"63","median":"545","maleWorkers":"55","maleMedian":"561","femaleWorkers":"8","femaleMedian":"-"}}},"Tour and travel guides":{"ageData":{"2011":{"total":"38","16to19":"5","20to24":"10","25to34":"4","35to44":"4","45to54":"5","55to64":"5","65+":"5","medianAge":"5"}},"title":"Tour and travel guides","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2011":{"total":"38","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"9","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Childcare workers":{"ageData":{"2011":{"total":"1,231","16to19":"126","20to24":"219","25to34":"215","35to44":"219","45to54":"229","55to64":"156","65+":"66","medianAge":"156"}},"title":"Childcare workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2011":{"total":"1,231","women":"94.5","white":"15.0","black":"3.4","asian":"18.1"}},"wageData":{"2011":{"workers":"367","median":"382","maleWorkers":"26","maleMedian":"-","femaleWorkers":"342","femaleMedian":"383"}}},"Personal care aides":{"ageData":{"2011":{"total":"1,057","16to19":"21","20to24":"129","25to34":"194","35to44":"189","45to54":"252","55to64":"189","65+":"82","medianAge":"189"}},"title":"Personal care aides","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2011":{"total":"1,057","women":"85.6","white":"21.9","black":"5.8","asian":"19.3"}},"wageData":{"2011":{"workers":"549","median":"412","maleWorkers":"94","maleMedian":"454","femaleWorkers":"455","femaleMedian":"407"}}},"Recreation and fitness workers":{"ageData":{"2011":{"total":"390","16to19":"38","20to24":"62","25to34":"82","35to44":"74","45to54":"65","55to64":"49","65+":"20","medianAge":"49"}},"title":"Recreation and fitness workers","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2011":{"total":"390","women":"64.1","white":"10.5","black":"3.4","asian":"7.2"}},"wageData":{"2011":{"workers":"177","median":"506","maleWorkers":"76","maleMedian":"575","femaleWorkers":"101","femaleMedian":"494"}}},"Residential advisors":{"ageData":{"2011":{"total":"59","16to19":"3","20to24":"11","25to34":"13","35to44":"12","45to54":"11","55to64":"9","65+":"1","medianAge":"9"}},"title":"Residential advisors","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2011":{"total":"59","women":"58.3","white":"22.4","black":"5.1","asian":"5.4"}},"wageData":{"2011":{"workers":"42","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"27","femaleMedian":"-"}}},"Personal care and service workers, all other":{"ageData":{"2011":{"total":"105","16to19":"14","20to24":"21","25to34":"20","35to44":"22","45to54":"14","55to64":"9","65+":"5","medianAge":"9"}},"title":"Personal care and service workers, all other","depth":3,"parent":"Personal care and service occupations","sexRaceEthnicityData":{"2011":{"total":"105","women":"48.2","white":"8.1","black":"2.3","asian":"11.5"}},"wageData":{"2011":{"workers":"34","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Sales and office occupations":{"ageData":{"2011":{"total":"33,066","16to19":"1,482","20to24":"3,972","25to34":"6,802","35to44":"6,342","45to54":"7,436","55to64":"5,305","65+":"1,727","medianAge":"5,305"}},"title":"Sales and office occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2011":{"total":"33,066","women":"62.3","white":"11.3","black":"4.4","asian":"13.2"}},"wageData":{"2011":{"workers":"22,989","median":"638","maleWorkers":"9,012","maleMedian":"738","femaleWorkers":"13,977","femaleMedian":"602"}}},"Sales and related occupations":{"ageData":{"2011":{"total":"15,330","16to19":"993","20to24":"2,124","25to34":"3,152","35to44":"2,797","45to54":"3,166","55to64":"2,206","65+":"893","medianAge":"2,206"}},"title":"Sales and related occupations","depth":2,"parent":"Sales and office occupations","sexRaceEthnicityData":{"2011":{"total":"15,330","women":"49.6","white":"9.8","black":"4.9","asian":"12.6"}},"wageData":{"2011":{"workers":"9,294","median":"670","maleWorkers":"5,225","maleMedian":"804","femaleWorkers":"4,069","femaleMedian":"549"}}},"First-line supervisors of retail sales workers":{"ageData":{"2011":{"total":"3,217","16to19":"17","20to24":"271","25to34":"784","35to44":"676","45to54":"817","55to64":"489","65+":"163","medianAge":"489"}},"title":"First-line supervisors of retail sales workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2011":{"total":"3,217","women":"43.5","white":"8.8","black":"5.4","asian":"10.9"}},"wageData":{"2011":{"workers":"2,223","median":"676","maleWorkers":"1,263","maleMedian":"759","femaleWorkers":"959","femaleMedian":"599"}}},"First-line supervisors of non-retail sales workers":{"ageData":{"2011":{"total":"1,088","16to19":"2","20to24":"34","25to34":"187","35to44":"276","45to54":"319","55to64":"201","65+":"69","medianAge":"201"}},"title":"First-line supervisors of non-retail sales workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2011":{"total":"1,088","women":"26.7","white":"5.8","black":"4.9","asian":"10.1"}},"wageData":{"2011":{"workers":"702","median":"951","maleWorkers":"488","maleMedian":"1,016","femaleWorkers":"214","femaleMedian":"781"}}},"Cashiers":{"ageData":{"2011":{"total":"3,158","16to19":"635","20to24":"843","25to34":"565","35to44":"381","45to54":"363","55to64":"265","65+":"106","medianAge":"265"}},"title":"Cashiers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2011":{"total":"3,158","women":"73.6","white":"15.6","black":"6.5","asian":"18.1"}},"wageData":{"2011":{"workers":"1,343","median":"383","maleWorkers":"381","maleMedian":"411","femaleWorkers":"962","femaleMedian":"373"}}},"Counter and rental clerks":{"ageData":{"2011":{"total":"139","16to19":"11","20to24":"29","25to34":"24","35to44":"19","45to54":"26","55to64":"20","65+":"10","medianAge":"20"}},"title":"Counter and rental clerks","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2011":{"total":"139","women":"48.6","white":"10.2","black":"8.6","asian":"13.0"}},"wageData":{"2011":{"workers":"87","median":"603","maleWorkers":"50","maleMedian":"620","femaleWorkers":"38","femaleMedian":"-"}}},"Parts salespersons":{"ageData":{"2011":{"total":"131","16to19":"2","20to24":"16","25to34":"31","35to44":"25","45to54":"28","55to64":"23","65+":"6","medianAge":"23"}},"title":"Parts salespersons","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2011":{"total":"131","women":"15.5","white":"6.5","black":"0.3","asian":"10.3"}},"wageData":{"2011":{"workers":"117","median":"610","maleWorkers":"100","maleMedian":"587","femaleWorkers":"16","femaleMedian":"-"}}},"Retail salespersons":{"ageData":{"2011":{"total":"3,224","16to19":"273","20to24":"663","25to34":"639","35to44":"471","45to54":"535","55to64":"457","65+":"188","medianAge":"457"}},"title":"Retail salespersons","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2011":{"total":"3,224","women":"51.2","white":"11.5","black":"4.4","asian":"14.3"}},"wageData":{"2011":{"workers":"1,789","median":"545","maleWorkers":"1,056","maleMedian":"620","femaleWorkers":"733","femaleMedian":"466"}}},"Advertising sales agents":{"ageData":{"2011":{"total":"254","16to19":"0","20to24":"22","25to34":"82","35to44":"56","45to54":"61","55to64":"24","65+":"9","medianAge":"24"}},"title":"Advertising sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2011":{"total":"254","women":"55.6","white":"10.8","black":"1.6","asian":"8.8"}},"wageData":{"2011":{"workers":"202","median":"893","maleWorkers":"90","maleMedian":"961","femaleWorkers":"112","femaleMedian":"772"}}},"Insurance sales agents":{"ageData":{"2011":{"total":"531","16to19":"4","20to24":"26","25to34":"108","35to44":"112","45to54":"137","55to64":"99","65+":"45","medianAge":"99"}},"title":"Insurance sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2011":{"total":"531","women":"47.3","white":"8.2","black":"3.2","asian":"9.1"}},"wageData":{"2011":{"workers":"384","median":"807","maleWorkers":"183","maleMedian":"1,033","femaleWorkers":"201","femaleMedian":"665"}}},"Securities, commodities, and financial services sales agents":{"ageData":{"2011":{"total":"267","16to19":"0","20to24":"13","25to34":"81","35to44":"63","45to54":"54","55to64":"41","65+":"15","medianAge":"41"}},"title":"Securities, commodities, and financial services sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2011":{"total":"267","women":"29.9","white":"4.7","black":"6.5","asian":"5.6"}},"wageData":{"2011":{"workers":"222","median":"1,144","maleWorkers":"149","maleMedian":"1,269","femaleWorkers":"73","femaleMedian":"884"}}},"Travel agents":{"ageData":{"2011":{"total":"69","16to19":"0","20to24":"5","25to34":"7","35to44":"13","45to54":"19","55to64":"14","65+":"10","medianAge":"14"}},"title":"Travel agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2011":{"total":"69","women":"79.4","white":"5.9","black":"5.3","asian":"9.5"}},"wageData":{"2011":{"workers":"49","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"38","femaleMedian":"-"}}},"Sales representatives, services, all other":{"ageData":{"2011":{"total":"503","16to19":"5","20to24":"41","25to34":"129","35to44":"122","45to54":"109","55to64":"75","65+":"22","medianAge":"75"}},"title":"Sales representatives, services, all other","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2011":{"total":"503","women":"31.2","white":"7.6","black":"4.6","asian":"10.9"}},"wageData":{"2011":{"workers":"397","median":"887","maleWorkers":"278","maleMedian":"953","femaleWorkers":"119","femaleMedian":"757"}}},"Sales representatives, wholesale and manufacturing":{"ageData":{"2011":{"total":"1,297","16to19":"13","20to24":"60","25to34":"266","35to44":"314","45to54":"361","55to64":"212","65+":"71","medianAge":"212"}},"title":"Sales representatives, wholesale and manufacturing","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2011":{"total":"1,297","women":"25.9","white":"2.9","black":"3.4","asian":"7.9"}},"wageData":{"2011":{"workers":"1,091","median":"991","maleWorkers":"829","maleMedian":"1,019","femaleWorkers":"262","femaleMedian":"927"}}},"Models, demonstrators, and product promoters":{"ageData":{"2011":{"total":"78","16to19":"9","20to24":"11","25to34":"13","35to44":"13","45to54":"11","55to64":"11","65+":"9","medianAge":"11"}},"title":"Models, demonstrators, and product promoters","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2011":{"total":"78","women":"79.2","white":"13.0","black":"0.2","asian":"14.6"}},"wageData":{"2011":{"workers":"15","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Real estate brokers and sales agents":{"ageData":{"2011":{"total":"811","16to19":"1","20to24":"24","25to34":"122","35to44":"153","45to54":"203","55to64":"192","65+":"116","medianAge":"192"}},"title":"Real estate brokers and sales agents","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2011":{"total":"811","women":"56.8","white":"4.6","black":"4.2","asian":"8.8"}},"wageData":{"2011":{"workers":"380","median":"812","maleWorkers":"176","maleMedian":"992","femaleWorkers":"204","femaleMedian":"676"}}},"Sales engineers":{"ageData":{"2011":{"total":"30","16to19":"0","20to24":"2","25to34":"2","35to44":"7","45to54":"12","55to64":"5","65+":"2","medianAge":"5"}},"title":"Sales engineers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2011":{"total":"30","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"30","median":"-","maleWorkers":"27","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Telemarketers":{"ageData":{"2011":{"total":"108","16to19":"9","20to24":"28","25to34":"32","35to44":"9","45to54":"14","55to64":"11","65+":"5","medianAge":"11"}},"title":"Telemarketers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2011":{"total":"108","women":"59.4","white":"14.9","black":"1.2","asian":"17.4"}},"wageData":{"2011":{"workers":"69","median":"412","maleWorkers":"29","maleMedian":"-","femaleWorkers":"40","femaleMedian":"-"}}},"Door-to-door sales workers, news and street vendors, and related workers":{"ageData":{"2011":{"total":"201","16to19":"8","20to24":"19","25to34":"39","35to44":"34","45to54":"47","55to64":"33","65+":"20","medianAge":"33"}},"title":"Door-to-door sales workers, news and street vendors, and related workers","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2011":{"total":"201","women":"59.2","white":"12.6","black":"3.0","asian":"17.8"}},"wageData":{"2011":{"workers":"55","median":"526","maleWorkers":"35","maleMedian":"-","femaleWorkers":"20","femaleMedian":"-"}}},"Sales and related workers, all other":{"ageData":{"2011":{"total":"226","16to19":"4","20to24":"16","25to34":"41","35to44":"53","45to54":"51","55to64":"36","65+":"25","medianAge":"36"}},"title":"Sales and related workers, all other","depth":3,"parent":"Sales and related occupations","sexRaceEthnicityData":{"2011":{"total":"226","women":"50.7","white":"8.5","black":"3.3","asian":"10.0"}},"wageData":{"2011":{"workers":"140","median":"781","maleWorkers":"76","maleMedian":"985","femaleWorkers":"64","femaleMedian":"618"}}},"Office and administrative support occupations":{"ageData":{"2011":{"total":"17,736","16to19":"489","20to24":"1,848","25to34":"3,650","35to44":"3,546","45to54":"4,270","55to64":"3,099","65+":"835","medianAge":"3,099"}},"title":"Office and administrative support occupations","depth":2,"parent":"Sales and office occupations","sexRaceEthnicityData":{"2011":{"total":"17,736","women":"73.4","white":"12.6","black":"4.1","asian":"13.7"}},"wageData":{"2011":{"workers":"13,695","median":"623","maleWorkers":"3,787","maleMedian":"668","femaleWorkers":"9,908","femaleMedian":"615"}}},"First-line supervisors of office and administrative support workers":{"ageData":{"2011":{"total":"1,423","16to19":"4","20to24":"49","25to34":"269","35to44":"361","45to54":"391","55to64":"296","65+":"53","medianAge":"296"}},"title":"First-line supervisors of office and administrative support workers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"1,423","women":"68.2","white":"9.6","black":"3.7","asian":"11.7"}},"wageData":{"2011":{"workers":"1,274","median":"764","maleWorkers":"418","maleMedian":"833","femaleWorkers":"856","femaleMedian":"741"}}},"Switchboard operators, including answering service":{"ageData":{"2011":{"total":"39","16to19":"0","20to24":"3","25to34":"12","35to44":"4","45to54":"5","55to64":"12","65+":"4","medianAge":"12"}},"title":"Switchboard operators, including answering service","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"39","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"29","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"25","femaleMedian":"-"}}},"Telephone operators":{"ageData":{"2011":{"total":"40","16to19":"0","20to24":"9","25to34":"10","35to44":"7","45to54":"8","55to64":"6","65+":"0","medianAge":"6"}},"title":"Telephone operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"38","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"30","femaleMedian":"-"}}},"Communications equipment operators, all other":{"ageData":{"2011":{"total":"7","16to19":"0","20to24":"0","25to34":"3","35to44":"2","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Communications equipment operators, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"6","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Bill and account collectors":{"ageData":{"2011":{"total":"211","16to19":"1","20to24":"27","25to34":"65","35to44":"44","45to54":"42","55to64":"25","65+":"8","medianAge":"25"}},"title":"Bill and account collectors","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"211","women":"70.6","white":"17.3","black":"3.8","asian":"18.4"}},"wageData":{"2011":{"workers":"178","median":"608","maleWorkers":"48","maleMedian":"-","femaleWorkers":"130","femaleMedian":"597"}}},"Billing and posting clerks":{"ageData":{"2011":{"total":"471","16to19":"3","20to24":"35","25to34":"117","35to44":"100","45to54":"134","55to64":"69","65+":"13","medianAge":"69"}},"title":"Billing and posting clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"471","women":"90.1","white":"12.3","black":"4.5","asian":"15.2"}},"wageData":{"2011":{"workers":"397","median":"607","maleWorkers":"38","maleMedian":"-","femaleWorkers":"359","femaleMedian":"605"}}},"Bookkeeping, accounting, and auditing clerks":{"ageData":{"2011":{"total":"1,300","16to19":"4","20to24":"64","25to34":"192","35to44":"278","45to54":"362","55to64":"283","65+":"117","medianAge":"283"}},"title":"Bookkeeping, accounting, and auditing clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"1,300","women":"89.9","white":"7.7","black":"4.1","asian":"8.4"}},"wageData":{"2011":{"workers":"862","median":"655","maleWorkers":"112","maleMedian":"654","femaleWorkers":"750","femaleMedian":"656"}}},"Gaming cage workers":{"ageData":{"2011":{"total":"5","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"1","55to64":"1","65+":"1","medianAge":"1"}},"title":"Gaming cage workers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Payroll and timekeeping clerks":{"ageData":{"2011":{"total":"168","16to19":"1","20to24":"4","25to34":"20","35to44":"46","45to54":"58","55to64":"32","65+":"6","medianAge":"32"}},"title":"Payroll and timekeeping clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"168","women":"89.3","white":"14.2","black":"3.7","asian":"12.0"}},"wageData":{"2011":{"workers":"136","median":"710","maleWorkers":"11","maleMedian":"-","femaleWorkers":"125","femaleMedian":"704"}}},"Procurement clerks":{"ageData":{"2011":{"total":"26","16to19":"0","20to24":"0","25to34":"1","35to44":"7","45to54":"8","55to64":"8","65+":"1","medianAge":"8"}},"title":"Procurement clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"26","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"24","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Tellers":{"ageData":{"2011":{"total":"413","16to19":"17","20to24":"106","25to34":"111","35to44":"57","45to54":"59","55to64":"50","65+":"14","medianAge":"50"}},"title":"Tellers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"413","women":"85.3","white":"8.7","black":"3.9","asian":"14.8"}},"wageData":{"2011":{"workers":"283","median":"492","maleWorkers":"41","maleMedian":"-","femaleWorkers":"241","femaleMedian":"500"}}},"Financial clerks, all other":{"ageData":{"2011":{"total":"64","16to19":"1","20to24":"5","25to34":"16","35to44":"16","45to54":"15","55to64":"10","65+":"2","medianAge":"10"}},"title":"Financial clerks, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"64","women":"77.1","white":"10.4","black":"14.1","asian":"14.9"}},"wageData":{"2011":{"workers":"64","median":"793","maleWorkers":"16","maleMedian":"-","femaleWorkers":"48","femaleMedian":"-"}}},"Brokerage clerks":{"ageData":{"2011":{"total":"11","16to19":"0","20to24":"0","25to34":"3","35to44":"4","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Brokerage clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"11","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Correspondence clerks":{"ageData":{"2011":{"total":"12","16to19":"0","20to24":"4","25to34":"5","35to44":"2","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Correspondence clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"10","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Court, municipal, and license clerks":{"ageData":{"2011":{"total":"86","16to19":"0","20to24":"1","25to34":"13","35to44":"20","45to54":"25","55to64":"24","65+":"3","medianAge":"24"}},"title":"Court, municipal, and license clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"86","women":"79.5","white":"16.6","black":"3.5","asian":"7.3"}},"wageData":{"2011":{"workers":"74","median":"763","maleWorkers":"14","maleMedian":"-","femaleWorkers":"60","femaleMedian":"738"}}},"Credit authorizers, checkers, and clerks":{"ageData":{"2011":{"total":"45","16to19":"0","20to24":"2","25to34":"11","35to44":"14","45to54":"10","55to64":"7","65+":"0","medianAge":"7"}},"title":"Credit authorizers, checkers, and clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"45","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"47","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"34","femaleMedian":"-"}}},"Customer service representatives":{"ageData":{"2011":{"total":"1,916","16to19":"90","20to24":"305","25to34":"496","35to44":"378","45to54":"369","55to64":"229","65+":"48","medianAge":"229"}},"title":"Customer service representatives","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"1,916","women":"66.5","white":"15.7","black":"4.5","asian":"16.9"}},"wageData":{"2011":{"workers":"1,509","median":"588","maleWorkers":"538","maleMedian":"628","femaleWorkers":"972","femaleMedian":"569"}}},"Eligibility interviewers, government programs":{"ageData":{"2011":{"total":"85","16to19":"0","20to24":"2","25to34":"27","35to44":"22","45to54":"16","55to64":"15","65+":"4","medianAge":"15"}},"title":"Eligibility interviewers, government programs","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"85","women":"84.2","white":"22.4","black":"3.3","asian":"19.7"}},"wageData":{"2011":{"workers":"79","median":"632","maleWorkers":"9","maleMedian":"-","femaleWorkers":"70","femaleMedian":"632"}}},"File clerks":{"ageData":{"2011":{"total":"334","16to19":"23","20to24":"48","25to34":"55","35to44":"63","45to54":"77","55to64":"49","65+":"18","medianAge":"49"}},"title":"File clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"334","women":"83.9","white":"13.7","black":"6.4","asian":"15.3"}},"wageData":{"2011":{"workers":"248","median":"616","maleWorkers":"32","maleMedian":"-","femaleWorkers":"217","femaleMedian":"620"}}},"Hotel, motel, and resort desk clerks":{"ageData":{"2011":{"total":"135","16to19":"5","20to24":"38","25to34":"40","35to44":"20","45to54":"13","55to64":"12","65+":"7","medianAge":"12"}},"title":"Hotel, motel, and resort desk clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"135","women":"64.4","white":"19.6","black":"7.8","asian":"16.9"}},"wageData":{"2011":{"workers":"86","median":"423","maleWorkers":"33","maleMedian":"-","femaleWorkers":"53","femaleMedian":"416"}}},"Interviewers, except eligibility and loan":{"ageData":{"2011":{"total":"153","16to19":"6","20to24":"15","25to34":"39","35to44":"24","45to54":"36","55to64":"26","65+":"8","medianAge":"26"}},"title":"Interviewers, except eligibility and loan","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"153","women":"84.4","white":"17.2","black":"4.5","asian":"18.3"}},"wageData":{"2011":{"workers":"121","median":"546","maleWorkers":"21","maleMedian":"-","femaleWorkers":"99","femaleMedian":"551"}}},"Library assistants, clerical":{"ageData":{"2011":{"total":"113","16to19":"7","20to24":"26","25to34":"11","35to44":"15","45to54":"15","55to64":"29","65+":"10","medianAge":"29"}},"title":"Library assistants, clerical","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"113","women":"81.6","white":"8.6","black":"5.2","asian":"8.5"}},"wageData":{"2011":{"workers":"49","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"38","femaleMedian":"-"}}},"Loan interviewers and clerks":{"ageData":{"2011":{"total":"117","16to19":"1","20to24":"6","25to34":"34","35to44":"37","45to54":"26","55to64":"12","65+":"2","medianAge":"12"}},"title":"Loan interviewers and clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"117","women":"82.7","white":"11.9","black":"4.2","asian":"10.4"}},"wageData":{"2011":{"workers":"110","median":"706","maleWorkers":"17","maleMedian":"-","femaleWorkers":"93","femaleMedian":"696"}}},"New accounts clerks":{"ageData":{"2011":{"total":"33","16to19":"0","20to24":"4","25to34":"11","35to44":"6","45to54":"7","55to64":"5","65+":"0","medianAge":"5"}},"title":"New accounts clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"33","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"27","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"19","femaleMedian":"-"}}},"Order clerks":{"ageData":{"2011":{"total":"113","16to19":"4","20to24":"15","25to34":"21","35to44":"20","45to54":"25","55to64":"23","65+":"5","medianAge":"23"}},"title":"Order clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"113","women":"67.1","white":"5.9","black":"5.4","asian":"11.5"}},"wageData":{"2011":{"workers":"96","median":"586","maleWorkers":"35","maleMedian":"-","femaleWorkers":"60","femaleMedian":"577"}}},"Human resources assistants, except payroll and timekeeping":{"ageData":{"2011":{"total":"40","16to19":"1","20to24":"3","25to34":"9","35to44":"11","45to54":"10","55to64":"6","65+":"1","medianAge":"6"}},"title":"Human resources assistants, except payroll and timekeeping","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"40","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"45","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"40","femaleMedian":"-"}}},"Receptionists and information clerks":{"ageData":{"2011":{"total":"1,259","16to19":"66","20to24":"232","25to34":"258","35to44":"210","45to54":"227","55to64":"192","65+":"73","medianAge":"192"}},"title":"Receptionists and information clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"1,259","women":"92.1","white":"11.3","black":"3.9","asian":"17.0"}},"wageData":{"2011":{"workers":"868","median":"520","maleWorkers":"78","maleMedian":"521","femaleWorkers":"790","femaleMedian":"520"}}},"Reservation and transportation ticket agents and travel clerks":{"ageData":{"2011":{"total":"99","16to19":"2","20to24":"8","25to34":"21","35to44":"25","45to54":"29","55to64":"12","65+":"3","medianAge":"12"}},"title":"Reservation and transportation ticket agents and travel clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"99","women":"59.5","white":"23.2","black":"5.8","asian":"8.8"}},"wageData":{"2011":{"workers":"80","median":"649","maleWorkers":"33","maleMedian":"-","femaleWorkers":"47","femaleMedian":"-"}}},"Information and record clerks, all other":{"ageData":{"2011":{"total":"118","16to19":"3","20to24":"7","25to34":"27","35to44":"19","45to54":"30","55to64":"25","65+":"7","medianAge":"25"}},"title":"Information and record clerks, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"118","women":"83.6","white":"15.2","black":"2.1","asian":"11.5"}},"wageData":{"2011":{"workers":"105","median":"744","maleWorkers":"18","maleMedian":"-","femaleWorkers":"86","femaleMedian":"737"}}},"Cargo and freight agents":{"ageData":{"2011":{"total":"8","16to19":"0","20to24":"0","25to34":"2","35to44":"2","45to54":"3","55to64":"0","65+":"0","medianAge":"0"}},"title":"Cargo and freight agents","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"6","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Couriers and messengers":{"ageData":{"2011":{"total":"249","16to19":"3","20to24":"11","25to34":"41","35to44":"57","45to54":"78","55to64":"35","65+":"24","medianAge":"35"}},"title":"Couriers and messengers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"249","women":"16.4","white":"16.7","black":"2.5","asian":"14.4"}},"wageData":{"2011":{"workers":"164","median":"744","maleWorkers":"145","maleMedian":"785","femaleWorkers":"19","femaleMedian":"-"}}},"Dispatchers":{"ageData":{"2011":{"total":"239","16to19":"5","20to24":"13","25to34":"66","35to44":"56","45to54":"54","55to64":"38","65+":"6","medianAge":"38"}},"title":"Dispatchers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"239","women":"57.9","white":"17.8","black":"1.9","asian":"12.0"}},"wageData":{"2011":{"workers":"207","median":"651","maleWorkers":"81","maleMedian":"728","femaleWorkers":"126","femaleMedian":"626"}}},"Meter readers, utilities":{"ageData":{"2011":{"total":"28","16to19":"0","20to24":"6","25to34":"7","35to44":"6","45to54":"6","55to64":"1","65+":"1","medianAge":"1"}},"title":"Meter readers, utilities","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"28","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"21","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Postal service clerks":{"ageData":{"2011":{"total":"146","16to19":"0","20to24":"1","25to34":"8","35to44":"24","45to54":"46","55to64":"60","65+":"6","medianAge":"60"}},"title":"Postal service clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"146","women":"50.9","white":"26.4","black":"10.9","asian":"10.1"}},"wageData":{"2011":{"workers":"129","median":"978","maleWorkers":"66","maleMedian":"1,014","femaleWorkers":"63","femaleMedian":"892"}}},"Postal service mail carriers":{"ageData":{"2011":{"total":"348","16to19":"0","20to24":"9","25to34":"36","35to44":"71","45to54":"151","55to64":"71","65+":"11","medianAge":"71"}},"title":"Postal service mail carriers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"348","women":"36.0","white":"13.7","black":"6.9","asian":"10.0"}},"wageData":{"2011":{"workers":"303","median":"979","maleWorkers":"205","maleMedian":"1,017","femaleWorkers":"98","femaleMedian":"892"}}},"Postal service mail sorters, processors, and processing machine operators":{"ageData":{"2011":{"total":"60","16to19":"0","20to24":"2","25to34":"10","35to44":"12","45to54":"18","55to64":"15","65+":"3","medianAge":"15"}},"title":"Postal service mail sorters, processors, and processing machine operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"60","women":"40.5","white":"30.5","black":"8.9","asian":"16.2"}},"wageData":{"2011":{"workers":"57","median":"918","maleWorkers":"33","maleMedian":"-","femaleWorkers":"24","femaleMedian":"-"}}},"Production, planning, and expediting clerks":{"ageData":{"2011":{"total":"236","16to19":"0","20to24":"13","25to34":"48","35to44":"61","45to54":"63","55to64":"45","65+":"6","medianAge":"45"}},"title":"Production, planning, and expediting clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"236","women":"53.5","white":"8.9","black":"2.9","asian":"9.5"}},"wageData":{"2011":{"workers":"226","median":"812","maleWorkers":"110","maleMedian":"916","femaleWorkers":"116","femaleMedian":"722"}}},"Shipping, receiving, and traffic clerks":{"ageData":{"2011":{"total":"559","16to19":"15","20to24":"64","25to34":"132","35to44":"130","45to54":"133","55to64":"70","65+":"14","medianAge":"70"}},"title":"Shipping, receiving, and traffic clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"559","women":"28.5","white":"14.2","black":"3.7","asian":"24.3"}},"wageData":{"2011":{"workers":"481","median":"562","maleWorkers":"340","maleMedian":"571","femaleWorkers":"141","femaleMedian":"543"}}},"Stock clerks and order fillers":{"ageData":{"2011":{"total":"1,503","16to19":"126","20to24":"306","25to34":"351","35to44":"228","45to54":"262","55to64":"187","65+":"43","medianAge":"187"}},"title":"Stock clerks and order fillers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"1,503","women":"34.8","white":"15.5","black":"3.4","asian":"18.8"}},"wageData":{"2011":{"workers":"992","median":"492","maleWorkers":"655","maleMedian":"488","femaleWorkers":"337","femaleMedian":"501"}}},"Weighers, measurers, checkers, and samplers, recordkeeping":{"ageData":{"2011":{"total":"70","16to19":"2","20to24":"2","25to34":"17","35to44":"14","45to54":"14","55to64":"17","65+":"4","medianAge":"17"}},"title":"Weighers, measurers, checkers, and samplers, recordkeeping","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"70","women":"55.7","white":"17.6","black":"5.0","asian":"22.1"}},"wageData":{"2011":{"workers":"60","median":"596","maleWorkers":"32","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Secretaries and administrative assistants":{"ageData":{"2011":{"total":"2,871","16to19":"32","20to24":"150","25to34":"467","35to44":"565","45to54":"803","55to64":"670","65+":"184","medianAge":"670"}},"title":"Secretaries and administrative assistants","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"2,871","women":"95.9","white":"8.2","black":"2.6","asian":"9.7"}},"wageData":{"2011":{"workers":"2,143","median":"654","maleWorkers":"84","maleMedian":"757","femaleWorkers":"2,059","femaleMedian":"651"}}},"Computer operators":{"ageData":{"2011":{"total":"126","16to19":"2","20to24":"9","25to34":"22","35to44":"15","45to54":"41","55to64":"34","65+":"3","medianAge":"34"}},"title":"Computer operators","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"126","women":"49.9","white":"11.1","black":"5.9","asian":"11.1"}},"wageData":{"2011":{"workers":"116","median":"724","maleWorkers":"59","maleMedian":"853","femaleWorkers":"56","femaleMedian":"651"}}},"Data entry keyers":{"ageData":{"2011":{"total":"334","16to19":"6","20to24":"31","25to34":"91","35to44":"75","45to54":"80","55to64":"40","65+":"10","medianAge":"40"}},"title":"Data entry keyers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"334","women":"83.2","white":"16.0","black":"4.9","asian":"12.6"}},"wageData":{"2011":{"workers":"280","median":"595","maleWorkers":"49","maleMedian":"-","femaleWorkers":"231","femaleMedian":"597"}}},"Word processors and typists":{"ageData":{"2011":{"total":"136","16to19":"2","20to24":"9","25to34":"22","35to44":"28","45to54":"37","55to64":"29","65+":"9","medianAge":"29"}},"title":"Word processors and typists","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"136","women":"88.5","white":"18.8","black":"6.2","asian":"10.0"}},"wageData":{"2011":{"workers":"109","median":"599","maleWorkers":"10","maleMedian":"-","femaleWorkers":"99","femaleMedian":"594"}}},"Desktop publishers":{"ageData":{"2011":{"total":"2","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"0","55to64":"0","65+":"1","medianAge":"0"}},"title":"Desktop publishers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Insurance claims and policy processing clerks":{"ageData":{"2011":{"total":"246","16to19":"2","20to24":"19","25to34":"66","35to44":"51","45to54":"62","55to64":"42","65+":"4","medianAge":"42"}},"title":"Insurance claims and policy processing clerks","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"246","women":"83.0","white":"17.4","black":"2.1","asian":"10.1"}},"wageData":{"2011":{"workers":"236","median":"660","maleWorkers":"39","maleMedian":"-","femaleWorkers":"197","femaleMedian":"647"}}},"Mail clerks and mail machine operators, except postal service":{"ageData":{"2011":{"total":"93","16to19":"4","20to24":"14","25to34":"16","35to44":"13","45to54":"24","55to64":"13","65+":"10","medianAge":"13"}},"title":"Mail clerks and mail machine operators, except postal service","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"93","women":"53.0","white":"18.0","black":"3.3","asian":"15.0"}},"wageData":{"2011":{"workers":"79","median":"521","maleWorkers":"38","maleMedian":"-","femaleWorkers":"41","femaleMedian":"-"}}},"Office clerks, general":{"ageData":{"2011":{"total":"1,061","16to19":"46","20to24":"124","25to34":"211","35to44":"198","45to54":"255","55to64":"168","65+":"61","medianAge":"168"}},"title":"Office clerks, general","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"1,061","women":"85.4","white":"13.5","black":"5.0","asian":"15.5"}},"wageData":{"2011":{"workers":"794","median":"604","maleWorkers":"121","maleMedian":"712","femaleWorkers":"673","femaleMedian":"594"}}},"Office machine operators, except computer":{"ageData":{"2011":{"total":"45","16to19":"1","20to24":"6","25to34":"11","35to44":"6","45to54":"14","55to64":"6","65+":"2","medianAge":"6"}},"title":"Office machine operators, except computer","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"45","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"31","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"20","femaleMedian":"-"}}},"Proofreaders and copy markers":{"ageData":{"2011":{"total":"7","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"2","55to64":"3","65+":"0","medianAge":"3"}},"title":"Proofreaders and copy markers","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"7","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Statistical assistants":{"ageData":{"2011":{"total":"18","16to19":"0","20to24":"2","25to34":"5","35to44":"3","45to54":"5","55to64":"2","65+":"2","medianAge":"2"}},"title":"Statistical assistants","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"18","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"12","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Office and administrative support workers, all other":{"ageData":{"2011":{"total":"513","16to19":"4","20to24":"41","25to34":"124","35to44":"117","45to54":"118","55to64":"91","65+":"20","medianAge":"91"}},"title":"Office and administrative support workers, all other","depth":3,"parent":"Office and administrative support occupations","sexRaceEthnicityData":{"2011":{"total":"513","women":"74.8","white":"14.2","black":"4.0","asian":"12.6"}},"wageData":{"2011":{"workers":"387","median":"679","maleWorkers":"101","maleMedian":"792","femaleWorkers":"286","femaleMedian":"645"}}},"Natural resources, construction, and maintenance occupations":{"ageData":{"2011":{"total":"13,009","16to19":"278","20to24":"1,146","25to34":"3,237","35to44":"3,069","45to54":"3,144","55to64":"1,766","65+":"369","medianAge":"1,766"}},"title":"Natural resources, construction, and maintenance occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2011":{"total":"13,009","women":"4.2","white":"6.5","black":"2.0","asian":"25.3"}},"wageData":{"2011":{"workers":"9,965","median":"732","maleWorkers":"9,574","maleMedian":"740","femaleWorkers":"391","femaleMedian":"515"}}},"Farming, fishing, and forestry occupations":{"ageData":{"2011":{"total":"1,001","16to19":"100","20to24":"136","25to34":"228","35to44":"189","45to54":"183","55to64":"117","65+":"48","medianAge":"117"}},"title":"Farming, fishing, and forestry occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2011":{"total":"1,001","women":"21.6","white":"4.3","black":"1.4","asian":"43.0"}},"wageData":{"2011":{"workers":"775","median":"430","maleWorkers":"625","maleMedian":"445","femaleWorkers":"150","femaleMedian":"371"}}},"First-line supervisors of farming, fishing, and forestry workers":{"ageData":{"2011":{"total":"52","16to19":"0","20to24":"2","25to34":"7","35to44":"9","45to54":"14","55to64":"12","65+":"7","medianAge":"12"}},"title":"First-line supervisors of farming, fishing, and forestry workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2011":{"total":"52","women":"8.4","white":"1.0","black":"0.0","asian":"23.2"}},"wageData":{"2011":{"workers":"38","median":"-","maleWorkers":"35","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Agricultural inspectors":{"ageData":{"2011":{"total":"22","16to19":"0","20to24":"3","25to34":"5","35to44":"6","45to54":"5","55to64":"3","65+":"0","medianAge":"3"}},"title":"Agricultural inspectors","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2011":{"total":"22","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"23","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Animal breeders":{"ageData":{"2011":{"total":"10","16to19":"2","20to24":"0","25to34":"1","35to44":"1","45to54":"2","55to64":"3","65+":"1","medianAge":"3"}},"title":"Animal breeders","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2011":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"3","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Graders and sorters, agricultural products":{"ageData":{"2011":{"total":"95","16to19":"3","20to24":"9","25to34":"18","35to44":"23","45to54":"19","55to64":"18","65+":"4","medianAge":"18"}},"title":"Graders and sorters, agricultural products","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2011":{"total":"95","women":"60.2","white":"12.6","black":"3.6","asian":"51.5"}},"wageData":{"2011":{"workers":"85","median":"379","maleWorkers":"32","maleMedian":"-","femaleWorkers":"53","femaleMedian":"363"}}},"Miscellaneous agricultural workers":{"ageData":{"2011":{"total":"708","16to19":"91","20to24":"112","25to34":"173","35to44":"126","45to54":"112","55to64":"66","65+":"29","medianAge":"66"}},"title":"Miscellaneous agricultural workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2011":{"total":"708","women":"19.1","white":"2.8","black":"1.3","asian":"49.6"}},"wageData":{"2011":{"workers":"565","median":"419","maleWorkers":"488","maleMedian":"427","femaleWorkers":"77","femaleMedian":"370"}}},"Fishers and related fishing workers":{"ageData":{"2011":{"total":"37","16to19":"0","20to24":"4","25to34":"9","35to44":"8","45to54":"7","55to64":"4","65+":"4","medianAge":"4"}},"title":"Fishers and related fishing workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2011":{"total":"37","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"13","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Hunters and trappers":{"ageData":{"2011":{"total":"2","16to19":"0","20to24":"0","25to34":"2","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Hunters and trappers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2011":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Forest and conservation workers":{"ageData":{"2011":{"total":"14","16to19":"0","20to24":"1","25to34":"5","35to44":"2","45to54":"2","55to64":"3","65+":"0","medianAge":"3"}},"title":"Forest and conservation workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2011":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"8","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Logging workers":{"ageData":{"2011":{"total":"61","16to19":"2","20to24":"4","25to34":"10","35to44":"14","45to54":"21","55to64":"9","65+":"1","medianAge":"9"}},"title":"Logging workers","depth":3,"parent":"Farming, fishing, and forestry occupations","sexRaceEthnicityData":{"2011":{"total":"61","women":"0.9","white":"7.0","black":"0.0","asian":"9.1"}},"wageData":{"2011":{"workers":"39","median":"-","maleWorkers":"39","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Construction and extraction occupations":{"ageData":{"2011":{"total":"7,125","16to19":"118","20to24":"598","25to34":"1,929","35to44":"1,756","45to54":"1,679","55to64":"883","65+":"161","medianAge":"883"}},"title":"Construction and extraction occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2011":{"total":"7,125","women":"2.3","white":"5.9","black":"1.5","asian":"29.4"}},"wageData":{"2011":{"workers":"5,031","median":"717","maleWorkers":"4,937","maleMedian":"718","femaleWorkers":"95","femaleMedian":"612"}}},"First-line supervisors of construction trades and extraction workers":{"ageData":{"2011":{"total":"634","16to19":"1","20to24":"15","25to34":"130","35to44":"159","45to54":"195","55to64":"117","65+":"16","medianAge":"117"}},"title":"First-line supervisors of construction trades and extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"634","women":"2.2","white":"5.2","black":"0.7","asian":"16.5"}},"wageData":{"2011":{"workers":"482","median":"992","maleWorkers":"467","maleMedian":"1,001","femaleWorkers":"15","femaleMedian":"-"}}},"Boilermakers":{"ageData":{"2011":{"total":"19","16to19":"0","20to24":"1","25to34":"7","35to44":"4","45to54":"4","55to64":"2","65+":"0","medianAge":"2"}},"title":"Boilermakers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"19","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"18","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Brickmasons, blockmasons, and stonemasons":{"ageData":{"2011":{"total":"146","16to19":"2","20to24":"12","25to34":"39","35to44":"35","45to54":"37","55to64":"19","65+":"2","medianAge":"19"}},"title":"Brickmasons, blockmasons, and stonemasons","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"146","women":"0.9","white":"5.0","black":"1.9","asian":"39.3"}},"wageData":{"2011":{"workers":"96","median":"710","maleWorkers":"95","maleMedian":"706","femaleWorkers":"1","femaleMedian":"-"}}},"Carpenters":{"ageData":{"2011":{"total":"1,330","16to19":"16","20to24":"94","25to34":"332","35to44":"358","45to54":"338","55to64":"170","65+":"22","medianAge":"170"}},"title":"Carpenters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"1,330","women":"1.9","white":"5.3","black":"1.6","asian":"26.7"}},"wageData":{"2011":{"workers":"737","median":"630","maleWorkers":"727","maleMedian":"630","femaleWorkers":"10","femaleMedian":"-"}}},"Carpet, floor, and tile installers and finishers":{"ageData":{"2011":{"total":"189","16to19":"7","20to24":"21","25to34":"61","35to44":"48","45to54":"35","55to64":"14","65+":"4","medianAge":"14"}},"title":"Carpet, floor, and tile installers and finishers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"189","women":"0.5","white":"6.3","black":"2.4","asian":"43.2"}},"wageData":{"2011":{"workers":"110","median":"579","maleWorkers":"109","maleMedian":"581","femaleWorkers":"1","femaleMedian":"-"}}},"Cement masons, concrete finishers, and terrazzo workers":{"ageData":{"2011":{"total":"70","16to19":"0","20to24":"6","25to34":"22","35to44":"16","45to54":"18","55to64":"6","65+":"1","medianAge":"6"}},"title":"Cement masons, concrete finishers, and terrazzo workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"70","women":"0.0","white":"9.3","black":"0.6","asian":"47.8"}},"wageData":{"2011":{"workers":"59","median":"651","maleWorkers":"59","maleMedian":"651","femaleWorkers":"0","femaleMedian":"-"}}},"Construction laborers":{"ageData":{"2011":{"total":"1,253","16to19":"39","20to24":"154","25to34":"379","35to44":"291","45to54":"254","55to64":"114","65+":"22","medianAge":"114"}},"title":"Construction laborers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"1,253","women":"2.1","white":"7.3","black":"1.8","asian":"42.9"}},"wageData":{"2011":{"workers":"862","median":"586","maleWorkers":"846","maleMedian":"587","femaleWorkers":"15","femaleMedian":"-"}}},"Paving, surfacing, and tamping equipment operators":{"ageData":{"2011":{"total":"21","16to19":"0","20to24":"2","25to34":"5","35to44":"6","45to54":"4","55to64":"4","65+":"0","medianAge":"4"}},"title":"Paving, surfacing, and tamping equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"21","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"19","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Pile-driver operators":{"ageData":{"2011":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Pile-driver operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Operating engineers and other construction equipment operators":{"ageData":{"2011":{"total":"369","16to19":"4","20to24":"22","25to34":"88","35to44":"85","45to54":"93","55to64":"62","65+":"15","medianAge":"62"}},"title":"Operating engineers and other construction equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"369","women":"0.8","white":"5.0","black":"0.2","asian":"16.6"}},"wageData":{"2011":{"workers":"345","median":"809","maleWorkers":"343","maleMedian":"809","femaleWorkers":"2","femaleMedian":"-"}}},"Drywall installers, ceiling tile installers, and tapers":{"ageData":{"2011":{"total":"150","16to19":"1","20to24":"12","25to34":"50","35to44":"50","45to54":"20","55to64":"14","65+":"2","medianAge":"14"}},"title":"Drywall installers, ceiling tile installers, and tapers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"150","women":"1.7","white":"2.0","black":"0.6","asian":"59.7"}},"wageData":{"2011":{"workers":"101","median":"507","maleWorkers":"100","maleMedian":"509","femaleWorkers":"1","femaleMedian":"-"}}},"Electricians":{"ageData":{"2011":{"total":"682","16to19":"6","20to24":"50","25to34":"184","35to44":"162","45to54":"177","55to64":"86","65+":"18","medianAge":"86"}},"title":"Electricians","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"682","women":"1.5","white":"6.1","black":"2.4","asian":"14.0"}},"wageData":{"2011":{"workers":"542","median":"857","maleWorkers":"539","maleMedian":"855","femaleWorkers":"3","femaleMedian":"-"}}},"Glaziers":{"ageData":{"2011":{"total":"48","16to19":"0","20to24":"3","25to34":"13","35to44":"10","45to54":"13","55to64":"6","65+":"2","medianAge":"6"}},"title":"Glaziers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"48","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"40","median":"-","maleWorkers":"40","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Insulation workers":{"ageData":{"2011":{"total":"47","16to19":"1","20to24":"6","25to34":"15","35to44":"11","45to54":"8","55to64":"4","65+":"0","medianAge":"4"}},"title":"Insulation workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"47","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"41","median":"-","maleWorkers":"39","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Painters, construction and maintenance":{"ageData":{"2011":{"total":"528","16to19":"12","20to24":"40","25to34":"133","35to44":"140","45to54":"114","55to64":"70","65+":"20","medianAge":"70"}},"title":"Painters, construction and maintenance","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"528","women":"6.8","white":"6.5","black":"2.5","asian":"41.8"}},"wageData":{"2011":{"workers":"266","median":"544","maleWorkers":"249","maleMedian":"555","femaleWorkers":"17","femaleMedian":"-"}}},"Paperhangers":{"ageData":{"2011":{"total":"8","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"2","55to64":"4","65+":"0","medianAge":"4"}},"title":"Paperhangers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Pipelayers, plumbers, pipefitters, and steamfitters":{"ageData":{"2011":{"total":"519","16to19":"5","20to24":"30","25to34":"139","35to44":"138","45to54":"134","55to64":"66","65+":"7","medianAge":"66"}},"title":"Pipelayers, plumbers, pipefitters, and steamfitters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"519","women":"1.7","white":"6.4","black":"1.4","asian":"22.5"}},"wageData":{"2011":{"workers":"417","median":"851","maleWorkers":"406","maleMedian":"853","femaleWorkers":"11","femaleMedian":"-"}}},"Plasterers and stucco masons":{"ageData":{"2011":{"total":"24","16to19":"0","20to24":"0","25to34":"8","35to44":"8","45to54":"6","55to64":"2","65+":"0","medianAge":"2"}},"title":"Plasterers and stucco masons","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"24","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"13","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Reinforcing iron and rebar workers":{"ageData":{"2011":{"total":"7","16to19":"0","20to24":"0","25to34":"3","35to44":"1","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Reinforcing iron and rebar workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Roofers":{"ageData":{"2011":{"total":"222","16to19":"4","20to24":"31","25to34":"86","35to44":"42","45to54":"39","55to64":"14","65+":"6","medianAge":"14"}},"title":"Roofers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"222","women":"1.1","white":"4.9","black":"0.8","asian":"47.3"}},"wageData":{"2011":{"workers":"143","median":"523","maleWorkers":"141","maleMedian":"520","femaleWorkers":"3","femaleMedian":"-"}}},"Sheet metal workers":{"ageData":{"2011":{"total":"126","16to19":"5","20to24":"16","25to34":"32","35to44":"21","45to54":"34","55to64":"14","65+":"4","medianAge":"14"}},"title":"Sheet metal workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"126","women":"2.3","white":"2.2","black":"0.6","asian":"18.9"}},"wageData":{"2011":{"workers":"107","median":"805","maleWorkers":"104","maleMedian":"805","femaleWorkers":"3","femaleMedian":"-"}}},"Structural iron and steel workers":{"ageData":{"2011":{"total":"66","16to19":"0","20to24":"6","25to34":"20","35to44":"21","45to54":"12","55to64":"7","65+":"1","medianAge":"7"}},"title":"Structural iron and steel workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"66","women":"0.0","white":"4.1","black":"0.0","asian":"19.5"}},"wageData":{"2011":{"workers":"66","median":"870","maleWorkers":"66","maleMedian":"870","femaleWorkers":"0","femaleMedian":"-"}}},"Solar photovoltaic installers":{"ageData":{"2011":{"total":"5","16to19":"0","20to24":"1","25to34":"2","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Solar photovoltaic installers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers, construction trades":{"ageData":{"2011":{"total":"63","16to19":"5","20to24":"14","25to34":"17","35to44":"13","45to54":"10","55to64":"4","65+":"0","medianAge":"4"}},"title":"Helpers, construction trades","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"63","women":"8.0","white":"10.5","black":"2.4","asian":"41.1"}},"wageData":{"2011":{"workers":"50","median":"469","maleWorkers":"47","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Construction and building inspectors":{"ageData":{"2011":{"total":"75","16to19":"0","20to24":"3","25to34":"7","35to44":"19","45to54":"18","55to64":"20","65+":"7","medianAge":"20"}},"title":"Construction and building inspectors","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"75","women":"4.7","white":"5.0","black":"0.2","asian":"11.6"}},"wageData":{"2011":{"workers":"54","median":"906","maleWorkers":"52","maleMedian":"919","femaleWorkers":"2","femaleMedian":"-"}}},"Elevator installers and repairers":{"ageData":{"2011":{"total":"30","16to19":"0","20to24":"0","25to34":"7","35to44":"9","45to54":"10","55to64":"4","65+":"0","medianAge":"4"}},"title":"Elevator installers and repairers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"30","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"30","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Fence erectors":{"ageData":{"2011":{"total":"45","16to19":"0","20to24":"10","25to34":"11","35to44":"11","45to54":"6","55to64":"5","65+":"1","medianAge":"5"}},"title":"Fence erectors","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"45","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"32","median":"-","maleWorkers":"32","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Hazardous materials removal workers":{"ageData":{"2011":{"total":"32","16to19":"0","20to24":"6","25to34":"7","35to44":"8","45to54":"7","55to64":"3","65+":"1","medianAge":"3"}},"title":"Hazardous materials removal workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"32","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"25","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Highway maintenance workers":{"ageData":{"2011":{"total":"105","16to19":"1","20to24":"8","25to34":"17","35to44":"19","45to54":"37","55to64":"18","65+":"5","medianAge":"18"}},"title":"Highway maintenance workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"105","women":"2.5","white":"11.0","black":"0.5","asian":"13.2"}},"wageData":{"2011":{"workers":"96","median":"708","maleWorkers":"94","maleMedian":"711","femaleWorkers":"2","femaleMedian":"-"}}},"Rail-track laying and maintenance equipment operators":{"ageData":{"2011":{"total":"7","16to19":"0","20to24":"1","25to34":"2","35to44":"1","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Rail-track laying and maintenance equipment operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"8","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Septic tank servicers and sewer pipe cleaners":{"ageData":{"2011":{"total":"11","16to19":"0","20to24":"1","25to34":"2","35to44":"6","45to54":"3","55to64":"0","65+":"0","medianAge":"0"}},"title":"Septic tank servicers and sewer pipe cleaners","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"9","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Miscellaneous construction and related workers":{"ageData":{"2011":{"total":"36","16to19":"1","20to24":"3","25to34":"10","35to44":"10","45to54":"6","55to64":"5","65+":"0","medianAge":"5"}},"title":"Miscellaneous construction and related workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"36","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"28","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Derrick, rotary drill, and service unit operators, oil, gas, and mining":{"ageData":{"2011":{"total":"46","16to19":"0","20to24":"5","25to34":"24","35to44":"7","45to54":"3","55to64":"4","65+":"1","medianAge":"4"}},"title":"Derrick, rotary drill, and service unit operators, oil, gas, and mining","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"46","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"42","median":"-","maleWorkers":"42","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Earth drillers, except oil and gas":{"ageData":{"2011":{"total":"23","16to19":"0","20to24":"1","25to34":"6","35to44":"5","45to54":"4","55to64":"4","65+":"1","medianAge":"4"}},"title":"Earth drillers, except oil and gas","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"23","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"17","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Explosives workers, ordnance handling experts, and blasters":{"ageData":{"2011":{"total":"9","16to19":"0","20to24":"0","25to34":"2","35to44":"2","45to54":"4","55to64":"2","65+":"0","medianAge":"2"}},"title":"Explosives workers, ordnance handling experts, and blasters","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"10","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Mining machine operators":{"ageData":{"2011":{"total":"78","16to19":"0","20to24":"6","25to34":"22","35to44":"21","45to54":"16","55to64":"11","65+":"1","medianAge":"11"}},"title":"Mining machine operators","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"78","women":"1.6","white":"3.0","black":"0.0","asian":"15.5"}},"wageData":{"2011":{"workers":"70","median":"1,022","maleWorkers":"69","maleMedian":"1,010","femaleWorkers":"1","femaleMedian":"-"}}},"Roof bolters, mining":{"ageData":{"2011":{"total":"10","16to19":"0","20to24":"3","25to34":"4","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Roof bolters, mining","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"12","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Roustabouts, oil and gas":{"ageData":{"2011":{"total":"17","16to19":"0","20to24":"3","25to34":"9","35to44":"2","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Roustabouts, oil and gas","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"17","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"18","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Helpers--extraction workers":{"ageData":{"2011":{"total":"8","16to19":"0","20to24":"2","25to34":"4","35to44":"0","45to54":"0","55to64":"0","65+":"1","medianAge":"0"}},"title":"Helpers--extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"8","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Other extraction workers":{"ageData":{"2011":{"total":"68","16to19":"6","20to24":"8","25to34":"25","35to44":"14","45to54":"9","55to64":"4","65+":"1","medianAge":"4"}},"title":"Other extraction workers","depth":3,"parent":"Construction and extraction occupations","sexRaceEthnicityData":{"2011":{"total":"68","women":"1.7","white":"1.1","black":"1.9","asian":"36.1"}},"wageData":{"2011":{"workers":"49","median":"-","maleWorkers":"49","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Installation, maintenance, and repair occupations":{"ageData":{"2011":{"total":"4,883","16to19":"60","20to24":"411","25to34":"1,080","35to44":"1,123","45to54":"1,283","55to64":"766","65+":"160","medianAge":"766"}},"title":"Installation, maintenance, and repair occupations","depth":2,"parent":"Natural resources, construction, and maintenance occupations","sexRaceEthnicityData":{"2011":{"total":"4,883","women":"3.5","white":"7.9","black":"2.9","asian":"15.8"}},"wageData":{"2011":{"workers":"4,159","median":"806","maleWorkers":"4,013","maleMedian":"807","femaleWorkers":"146","femaleMedian":"751"}}},"First-line supervisors of mechanics, installers, and repairers":{"ageData":{"2011":{"total":"313","16to19":"0","20to24":"8","25to34":"49","35to44":"57","45to54":"102","55to64":"87","65+":"11","medianAge":"87"}},"title":"First-line supervisors of mechanics, installers, and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"313","women":"6.8","white":"6.4","black":"0.9","asian":"9.7"}},"wageData":{"2011":{"workers":"327","median":"947","maleWorkers":"306","maleMedian":"936","femaleWorkers":"21","femaleMedian":"-"}}},"Computer, automated teller, and office machine repairers":{"ageData":{"2011":{"total":"305","16to19":"3","20to24":"38","25to34":"72","35to44":"70","45to54":"69","55to64":"40","65+":"12","medianAge":"40"}},"title":"Computer, automated teller, and office machine repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"305","women":"9.0","white":"11.0","black":"6.3","asian":"9.9"}},"wageData":{"2011":{"workers":"237","median":"811","maleWorkers":"215","maleMedian":"812","femaleWorkers":"22","femaleMedian":"-"}}},"Radio and telecommunications equipment installers and repairers":{"ageData":{"2011":{"total":"150","16to19":"1","20to24":"9","25to34":"34","35to44":"45","45to54":"35","55to64":"24","65+":"2","medianAge":"24"}},"title":"Radio and telecommunications equipment installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"150","women":"7.7","white":"10.1","black":"3.2","asian":"10.6"}},"wageData":{"2011":{"workers":"139","median":"898","maleWorkers":"127","maleMedian":"883","femaleWorkers":"12","femaleMedian":"-"}}},"Avionics technicians":{"ageData":{"2011":{"total":"16","16to19":"0","20to24":"0","25to34":"6","35to44":"4","45to54":"3","55to64":"2","65+":"1","medianAge":"2"}},"title":"Avionics technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"16","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"16","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Electric motor, power tool, and related repairers":{"ageData":{"2011":{"total":"35","16to19":"0","20to24":"1","25to34":"6","35to44":"10","45to54":"9","55to64":"7","65+":"2","medianAge":"7"}},"title":"Electric motor, power tool, and related repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"35","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"26","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electrical and electronics installers and repairers, transportation equipment":{"ageData":{"2011":{"total":"6","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Electrical and electronics installers and repairers, transportation equipment","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electrical and electronics repairers, industrial and utility":{"ageData":{"2011":{"total":"14","16to19":"0","20to24":"0","25to34":"4","35to44":"5","45to54":"2","55to64":"3","65+":"0","medianAge":"3"}},"title":"Electrical and electronics repairers, industrial and utility","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"15","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Electronic equipment installers and repairers, motor vehicles":{"ageData":{"2011":{"total":"20","16to19":"0","20to24":"0","25to34":"3","35to44":"4","45to54":"7","55to64":"4","65+":"0","medianAge":"4"}},"title":"Electronic equipment installers and repairers, motor vehicles","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"20","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"14","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Electronic home entertainment equipment installers and repairers":{"ageData":{"2011":{"total":"38","16to19":"1","20to24":"4","25to34":"13","35to44":"8","45to54":"9","55to64":"2","65+":"0","medianAge":"2"}},"title":"Electronic home entertainment equipment installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"38","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"32","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Security and fire alarm systems installers":{"ageData":{"2011":{"total":"53","16to19":"0","20to24":"2","25to34":"16","35to44":"16","45to54":"12","55to64":"4","65+":"3","medianAge":"4"}},"title":"Security and fire alarm systems installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"53","women":"0.0","white":"6.3","black":"1.0","asian":"17.8"}},"wageData":{"2011":{"workers":"44","median":"-","maleWorkers":"44","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Aircraft mechanics and service technicians":{"ageData":{"2011":{"total":"164","16to19":"0","20to24":"7","25to34":"36","35to44":"40","45to54":"56","55to64":"20","65+":"5","medianAge":"20"}},"title":"Aircraft mechanics and service technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"164","women":"3.1","white":"8.9","black":"3.1","asian":"17.2"}},"wageData":{"2011":{"workers":"143","median":"988","maleWorkers":"139","maleMedian":"990","femaleWorkers":"4","femaleMedian":"-"}}},"Automotive body and related repairers":{"ageData":{"2011":{"total":"140","16to19":"1","20to24":"17","25to34":"27","35to44":"40","45to54":"34","55to64":"17","65+":"4","medianAge":"17"}},"title":"Automotive body and related repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"140","women":"1.2","white":"6.9","black":"2.9","asian":"18.1"}},"wageData":{"2011":{"workers":"107","median":"624","maleWorkers":"107","maleMedian":"625","femaleWorkers":"1","femaleMedian":"-"}}},"Automotive glass installers and repairers":{"ageData":{"2011":{"total":"17","16to19":"0","20to24":"1","25to34":"4","35to44":"5","45to54":"5","55to64":"2","65+":"0","medianAge":"2"}},"title":"Automotive glass installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"17","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"11","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Automotive service technicians and mechanics":{"ageData":{"2011":{"total":"855","16to19":"12","20to24":"120","25to34":"206","35to44":"189","45to54":"198","55to64":"108","65+":"21","medianAge":"108"}},"title":"Automotive service technicians and mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"855","women":"1.4","white":"7.8","black":"4.2","asian":"19.7"}},"wageData":{"2011":{"workers":"653","median":"714","maleWorkers":"645","maleMedian":"718","femaleWorkers":"8","femaleMedian":"-"}}},"Bus and truck mechanics and diesel engine specialists":{"ageData":{"2011":{"total":"312","16to19":"3","20to24":"28","25to34":"75","35to44":"61","45to54":"82","55to64":"53","65+":"10","medianAge":"53"}},"title":"Bus and truck mechanics and diesel engine specialists","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"312","women":"0.7","white":"4.0","black":"2.5","asian":"15.1"}},"wageData":{"2011":{"workers":"286","median":"801","maleWorkers":"286","maleMedian":"802","femaleWorkers":"1","femaleMedian":"-"}}},"Heavy vehicle and mobile equipment service technicians and mechanics":{"ageData":{"2011":{"total":"199","16to19":"1","20to24":"12","25to34":"49","35to44":"45","45to54":"56","55to64":"29","65+":"7","medianAge":"29"}},"title":"Heavy vehicle and mobile equipment service technicians and mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"199","women":"1.3","white":"5.0","black":"1.2","asian":"11.1"}},"wageData":{"2011":{"workers":"182","median":"822","maleWorkers":"179","maleMedian":"822","femaleWorkers":"3","femaleMedian":"-"}}},"Small engine mechanics":{"ageData":{"2011":{"total":"52","16to19":"2","20to24":"8","25to34":"9","35to44":"6","45to54":"10","55to64":"11","65+":"7","medianAge":"11"}},"title":"Small engine mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"52","women":"0.3","white":"6.4","black":"0.1","asian":"8.6"}},"wageData":{"2011":{"workers":"32","median":"-","maleWorkers":"31","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Miscellaneous vehicle and mobile equipment mechanics, installers, and repairers":{"ageData":{"2011":{"total":"95","16to19":"10","20to24":"22","25to34":"19","35to44":"17","45to54":"18","55to64":"7","65+":"1","medianAge":"7"}},"title":"Miscellaneous vehicle and mobile equipment mechanics, installers, and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"95","women":"1.6","white":"6.3","black":"0.1","asian":"21.0"}},"wageData":{"2011":{"workers":"73","median":"463","maleWorkers":"71","maleMedian":"463","femaleWorkers":"2","femaleMedian":"-"}}},"Control and valve installers and repairers":{"ageData":{"2011":{"total":"24","16to19":"0","20to24":"0","25to34":"8","35to44":"4","45to54":"6","55to64":"7","65+":"0","medianAge":"7"}},"title":"Control and valve installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"24","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"25","median":"-","maleWorkers":"24","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Heating, air conditioning, and refrigeration mechanics and installers":{"ageData":{"2011":{"total":"338","16to19":"5","20to24":"24","25to34":"99","35to44":"82","45to54":"83","55to64":"40","65+":"4","medianAge":"40"}},"title":"Heating, air conditioning, and refrigeration mechanics and installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"338","women":"0.8","white":"5.8","black":"1.9","asian":"16.9"}},"wageData":{"2011":{"workers":"281","median":"793","maleWorkers":"279","maleMedian":"795","femaleWorkers":"1","femaleMedian":"-"}}},"Home appliance repairers":{"ageData":{"2011":{"total":"43","16to19":"1","20to24":"4","25to34":"7","35to44":"11","45to54":"8","55to64":"9","65+":"3","medianAge":"9"}},"title":"Home appliance repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"43","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"27","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Industrial and refractory machinery mechanics":{"ageData":{"2011":{"total":"433","16to19":"2","20to24":"11","25to34":"83","35to44":"104","45to54":"135","55to64":"86","65+":"12","medianAge":"86"}},"title":"Industrial and refractory machinery mechanics","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"433","women":"2.5","white":"7.1","black":"3.8","asian":"15.2"}},"wageData":{"2011":{"workers":"425","median":"868","maleWorkers":"415","maleMedian":"870","femaleWorkers":"10","femaleMedian":"-"}}},"Maintenance and repair workers, general":{"ageData":{"2011":{"total":"422","16to19":"3","20to24":"20","25to34":"61","35to44":"90","45to54":"131","55to64":"93","65+":"23","medianAge":"93"}},"title":"Maintenance and repair workers, general","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"422","women":"3.2","white":"12.2","black":"1.9","asian":"17.4"}},"wageData":{"2011":{"workers":"359","median":"758","maleWorkers":"347","maleMedian":"756","femaleWorkers":"11","femaleMedian":"-"}}},"Maintenance workers, machinery":{"ageData":{"2011":{"total":"38","16to19":"1","20to24":"6","25to34":"6","35to44":"5","45to54":"7","55to64":"8","65+":"3","medianAge":"8"}},"title":"Maintenance workers, machinery","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"38","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"34","median":"-","maleWorkers":"31","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Millwrights":{"ageData":{"2011":{"total":"58","16to19":"0","20to24":"3","25to34":"11","35to44":"8","45to54":"23","55to64":"12","65+":"0","medianAge":"12"}},"title":"Millwrights","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"58","women":"2.0","white":"4.7","black":"0.8","asian":"3.0"}},"wageData":{"2011":{"workers":"57","median":"892","maleWorkers":"56","maleMedian":"897","femaleWorkers":"1","femaleMedian":"-"}}},"Electrical power-line installers and repairers":{"ageData":{"2011":{"total":"124","16to19":"1","20to24":"10","25to34":"39","35to44":"26","45to54":"31","55to64":"17","65+":"1","medianAge":"17"}},"title":"Electrical power-line installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"124","women":"0.2","white":"8.6","black":"0.4","asian":"11.5"}},"wageData":{"2011":{"workers":"111","median":"1,116","maleWorkers":"111","maleMedian":"1,116","femaleWorkers":"0","femaleMedian":"-"}}},"Telecommunications line installers and repairers":{"ageData":{"2011":{"total":"201","16to19":"2","20to24":"14","25to34":"52","35to44":"68","45to54":"47","55to64":"16","65+":"2","medianAge":"16"}},"title":"Telecommunications line installers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"201","women":"4.3","white":"12.2","black":"1.1","asian":"17.3"}},"wageData":{"2011":{"workers":"192","median":"915","maleWorkers":"185","maleMedian":"926","femaleWorkers":"7","femaleMedian":"-"}}},"Precision instrument and equipment repairers":{"ageData":{"2011":{"total":"76","16to19":"2","20to24":"2","25to34":"16","35to44":"16","45to54":"18","55to64":"15","65+":"7","medianAge":"15"}},"title":"Precision instrument and equipment repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"76","women":"16.2","white":"5.0","black":"2.7","asian":"21.6"}},"wageData":{"2011":{"workers":"62","median":"898","maleWorkers":"52","maleMedian":"914","femaleWorkers":"10","femaleMedian":"-"}}},"Wind turbine service technicians":{"ageData":{"2011":{"total":"2","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Wind turbine service technicians","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"2","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Coin, vending, and amusement machine servicers and repairers":{"ageData":{"2011":{"total":"46","16to19":"0","20to24":"4","25to34":"10","35to44":"11","45to54":"11","55to64":"7","65+":"3","medianAge":"7"}},"title":"Coin, vending, and amusement machine servicers and repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"46","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"29","median":"-","maleWorkers":"27","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Commercial divers":{"ageData":{"2011":{"total":"0","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Commercial divers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"0","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Locksmiths and safe repairers":{"ageData":{"2011":{"total":"28","16to19":"0","20to24":"0","25to34":"4","35to44":"6","45to54":"9","55to64":"5","65+":"4","medianAge":"5"}},"title":"Locksmiths and safe repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"28","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"17","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Manufactured building and mobile home installers":{"ageData":{"2011":{"total":"7","16to19":"0","20to24":"0","25to34":"3","35to44":"0","45to54":"1","55to64":"1","65+":"1","medianAge":"1"}},"title":"Manufactured building and mobile home installers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Riggers":{"ageData":{"2011":{"total":"14","16to19":"0","20to24":"1","25to34":"2","35to44":"3","45to54":"4","55to64":"3","65+":"0","medianAge":"3"}},"title":"Riggers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"15","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Signal and track switch repairers":{"ageData":{"2011":{"total":"5","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"4","55to64":"0","65+":"0","medianAge":"0"}},"title":"Signal and track switch repairers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"5","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Helpers--installation, maintenance, and repair workers":{"ageData":{"2011":{"total":"24","16to19":"4","20to24":"5","25to34":"4","35to44":"7","45to54":"1","55to64":"1","65+":"1","medianAge":"1"}},"title":"Helpers--installation, maintenance, and repair workers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"24","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"18","median":"-","maleWorkers":"17","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Other installation, maintenance, and repair workers":{"ageData":{"2011":{"total":"215","16to19":"2","20to24":"27","25to34":"43","35to44":"56","45to54":"53","55to64":"25","65+":"10","medianAge":"25"}},"title":"Other installation, maintenance, and repair workers","depth":3,"parent":"Installation, maintenance, and repair occupations","sexRaceEthnicityData":{"2011":{"total":"215","women":"7.8","white":"9.2","black":"3.0","asian":"23.3"}},"wageData":{"2011":{"workers":"149","median":"671","maleWorkers":"137","maleMedian":"718","femaleWorkers":"12","femaleMedian":"-"}}},"Production, transportation, and material moving occupations":{"ageData":{"2011":{"total":"16,461","16to19":"447","20to24":"1,519","25to34":"3,341","35to44":"3,563","45to54":"4,215","55to64":"2,659","65+":"717","medianAge":"2,659"}},"title":"Production, transportation, and material moving occupations","depth":1,"parent":"","sexRaceEthnicityData":{"2011":{"total":"16,461","women":"21.6","white":"13.7","black":"4.3","asian":"21.0"}},"wageData":{"2011":{"workers":"13,333","median":"609","maleWorkers":"10,730","maleMedian":"651","femaleWorkers":"2,603","femaleMedian":"485"}}},"Production occupations":{"ageData":{"2011":{"total":"8,142","16to19":"142","20to24":"712","25to34":"1,685","35to44":"1,812","45to54":"2,185","55to64":"1,346","65+":"260","medianAge":"1,346"}},"title":"Production occupations","depth":2,"parent":"Production, transportation, and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"8,142","women":"28.4","white":"11.0","black":"5.9","asian":"21.6"}},"wageData":{"2011":{"workers":"7,058","median":"605","maleWorkers":"5,241","maleMedian":"667","femaleWorkers":"1,817","femaleMedian":"483"}}},"First-line supervisors of production and operating workers":{"ageData":{"2011":{"total":"727","16to19":"1","20to24":"20","25to34":"118","35to44":"172","45to54":"251","55to64":"146","65+":"20","medianAge":"146"}},"title":"First-line supervisors of production and operating workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"727","women":"18.6","white":"7.7","black":"5.6","asian":"12.7"}},"wageData":{"2011":{"workers":"654","median":"888","maleWorkers":"530","maleMedian":"929","femaleWorkers":"124","femaleMedian":"665"}}},"Aircraft structure, surfaces, rigging, and systems assemblers":{"ageData":{"2011":{"total":"20","16to19":"0","20to24":"1","25to34":"2","35to44":"3","45to54":"9","55to64":"5","65+":"0","medianAge":"5"}},"title":"Aircraft structure, surfaces, rigging, and systems assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"20","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"19","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Electrical, electronics, and electromechanical assemblers":{"ageData":{"2011":{"total":"156","16to19":"2","20to24":"17","25to34":"21","35to44":"33","45to54":"46","55to64":"30","65+":"7","medianAge":"30"}},"title":"Electrical, electronics, and electromechanical assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"156","women":"51.9","white":"13.5","black":"21.5","asian":"20.4"}},"wageData":{"2011":{"workers":"148","median":"521","maleWorkers":"75","maleMedian":"591","femaleWorkers":"73","femaleMedian":"449"}}},"Engine and other machine assemblers":{"ageData":{"2011":{"total":"34","16to19":"1","20to24":"1","25to34":"7","35to44":"4","45to54":"12","55to64":"8","65+":"0","medianAge":"8"}},"title":"Engine and other machine assemblers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"34","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"30","median":"-","maleWorkers":"25","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Structural metal fabricators and fitters":{"ageData":{"2011":{"total":"32","16to19":"0","20to24":"1","25to34":"8","35to44":"8","45to54":"12","55to64":"1","65+":"1","medianAge":"1"}},"title":"Structural metal fabricators and fitters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"32","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"33","median":"-","maleWorkers":"31","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Miscellaneous assemblers and fabricators":{"ageData":{"2011":{"total":"860","16to19":"19","20to24":"87","25to34":"190","35to44":"195","45to54":"222","55to64":"124","65+":"23","medianAge":"124"}},"title":"Miscellaneous assemblers and fabricators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"860","women":"38.2","white":"16.3","black":"7.5","asian":"20.3"}},"wageData":{"2011":{"workers":"758","median":"519","maleWorkers":"473","maleMedian":"566","femaleWorkers":"285","femaleMedian":"479"}}},"Bakers":{"ageData":{"2011":{"total":"207","16to19":"8","20to24":"33","25to34":"40","35to44":"36","45to54":"49","55to64":"30","65+":"10","medianAge":"30"}},"title":"Bakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"207","women":"55.0","white":"13.3","black":"5.0","asian":"32.9"}},"wageData":{"2011":{"workers":"125","median":"448","maleWorkers":"63","maleMedian":"471","femaleWorkers":"63","femaleMedian":"416"}}},"Butchers and other meat, poultry, and fish processing workers":{"ageData":{"2011":{"total":"342","16to19":"11","20to24":"46","25to34":"91","35to44":"67","45to54":"74","55to64":"42","65+":"11","medianAge":"42"}},"title":"Butchers and other meat, poultry, and fish processing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"342","women":"26.6","white":"17.2","black":"10.6","asian":"38.0"}},"wageData":{"2011":{"workers":"281","median":"504","maleWorkers":"215","maleMedian":"515","femaleWorkers":"66","femaleMedian":"479"}}},"Food and tobacco roasting, baking, and drying machine operators and tenders":{"ageData":{"2011":{"total":"12","16to19":"1","20to24":"2","25to34":"2","35to44":"3","45to54":"1","55to64":"3","65+":"0","medianAge":"3"}},"title":"Food and tobacco roasting, baking, and drying machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"12","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"7","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Food batchmakers":{"ageData":{"2011":{"total":"90","16to19":"4","20to24":"10","25to34":"24","35to44":"18","45to54":"19","55to64":"12","65+":"2","medianAge":"12"}},"title":"Food batchmakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"90","women":"53.3","white":"15.3","black":"4.3","asian":"29.3"}},"wageData":{"2011":{"workers":"63","median":"554","maleWorkers":"35","maleMedian":"-","femaleWorkers":"28","femaleMedian":"-"}}},"Food cooking machine operators and tenders":{"ageData":{"2011":{"total":"24","16to19":"1","20to24":"4","25to34":"5","35to44":"4","45to54":"5","55to64":"2","65+":"2","medianAge":"2"}},"title":"Food cooking machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"24","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"17","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Food processing workers, all other":{"ageData":{"2011":{"total":"115","16to19":"1","20to24":"12","25to34":"29","35to44":"29","45to54":"34","55to64":"8","65+":"2","medianAge":"8"}},"title":"Food processing workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"115","women":"29.9","white":"14.2","black":"2.5","asian":"39.8"}},"wageData":{"2011":{"workers":"104","median":"534","maleWorkers":"78","maleMedian":"544","femaleWorkers":"25","femaleMedian":"-"}}},"Computer control programmers and operators":{"ageData":{"2011":{"total":"72","16to19":"0","20to24":"5","25to34":"19","35to44":"19","45to54":"18","55to64":"8","65+":"2","medianAge":"8"}},"title":"Computer control programmers and operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"72","women":"5.5","white":"4.5","black":"6.0","asian":"12.9"}},"wageData":{"2011":{"workers":"70","median":"770","maleWorkers":"65","maleMedian":"781","femaleWorkers":"5","femaleMedian":"-"}}},"Extruding and drawing machine setters, operators, and tenders, metal and plastic":{"ageData":{"2011":{"total":"13","16to19":"0","20to24":"1","25to34":"4","35to44":"4","45to54":"2","55to64":"2","65+":"0","medianAge":"2"}},"title":"Extruding and drawing machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"11","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Forging machine setters, operators, and tenders, metal and plastic":{"ageData":{"2011":{"total":"6","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"3","55to64":"1","65+":"1","medianAge":"1"}},"title":"Forging machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"5","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Rolling machine setters, operators, and tenders, metal and plastic":{"ageData":{"2011":{"total":"8","16to19":"0","20to24":"0","25to34":"3","35to44":"1","45to54":"3","55to64":"1","65+":"0","medianAge":"1"}},"title":"Rolling machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"9","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Cutting, punching, and press machine setters, operators, and tenders, metal and plastic":{"ageData":{"2011":{"total":"100","16to19":"1","20to24":"11","25to34":"22","35to44":"24","45to54":"24","55to64":"16","65+":"2","medianAge":"16"}},"title":"Cutting, punching, and press machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"100","women":"14.8","white":"10.7","black":"3.3","asian":"18.2"}},"wageData":{"2011":{"workers":"92","median":"591","maleWorkers":"78","maleMedian":"608","femaleWorkers":"15","femaleMedian":"-"}}},"Drilling and boring machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2011":{"total":"5","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Drilling and boring machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"5","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Grinding, lapping, polishing, and buffing machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2011":{"total":"65","16to19":"3","20to24":"10","25to34":"8","35to44":"14","45to54":"15","55to64":"13","65+":"2","medianAge":"13"}},"title":"Grinding, lapping, polishing, and buffing machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"65","women":"6.7","white":"10.0","black":"0.2","asian":"29.6"}},"wageData":{"2011":{"workers":"60","median":"643","maleWorkers":"57","maleMedian":"641","femaleWorkers":"3","femaleMedian":"-"}}},"Lathe and turning machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2011":{"total":"15","16to19":"0","20to24":"0","25to34":"1","35to44":"8","45to54":"3","55to64":"2","65+":"1","medianAge":"2"}},"title":"Lathe and turning machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"15","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"15","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Milling and planing machine setters, operators, and tenders, metal and plastic":{"ageData":{"2011":{"total":"4","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"3","55to64":"0","65+":"0","medianAge":"0"}},"title":"Milling and planing machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Machinists":{"ageData":{"2011":{"total":"419","16to19":"4","20to24":"29","25to34":"73","35to44":"92","45to54":"116","55to64":"85","65+":"19","medianAge":"85"}},"title":"Machinists","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"419","women":"4.4","white":"3.7","black":"4.2","asian":"14.1"}},"wageData":{"2011":{"workers":"393","median":"755","maleWorkers":"377","maleMedian":"767","femaleWorkers":"16","femaleMedian":"-"}}},"Metal furnace operators, tenders, pourers, and casters":{"ageData":{"2011":{"total":"16","16to19":"0","20to24":"0","25to34":"6","35to44":"4","45to54":"3","55to64":"2","65+":"0","medianAge":"2"}},"title":"Metal furnace operators, tenders, pourers, and casters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"16","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"19","median":"-","maleWorkers":"18","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Model makers and patternmakers, metal and plastic":{"ageData":{"2011":{"total":"7","16to19":"0","20to24":"0","25to34":"2","35to44":"1","45to54":"1","55to64":"1","65+":"2","medianAge":"1"}},"title":"Model makers and patternmakers, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"4","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Molders and molding machine setters, operators, and tenders, metal and plastic":{"ageData":{"2011":{"total":"45","16to19":"1","20to24":"4","25to34":"9","35to44":"6","45to54":"19","55to64":"5","65+":"0","medianAge":"5"}},"title":"Molders and molding machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"45","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"47","median":"-","maleWorkers":"35","maleMedian":"-","femaleWorkers":"12","femaleMedian":"-"}}},"Multiple machine tool setters, operators, and tenders, metal and plastic":{"ageData":{"2011":{"total":"5","16to19":"0","20to24":"1","25to34":"0","35to44":"1","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Multiple machine tool setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Tool and die makers":{"ageData":{"2011":{"total":"66","16to19":"1","20to24":"1","25to34":"5","35to44":"14","45to54":"21","55to64":"19","65+":"5","medianAge":"19"}},"title":"Tool and die makers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"66","women":"2.3","white":"3.7","black":"0.6","asian":"9.4"}},"wageData":{"2011":{"workers":"61","median":"920","maleWorkers":"59","maleMedian":"930","femaleWorkers":"2","femaleMedian":"-"}}},"Welding, soldering, and brazing workers":{"ageData":{"2011":{"total":"505","16to19":"6","20to24":"53","25to34":"127","35to44":"119","45to54":"118","55to64":"69","65+":"14","medianAge":"69"}},"title":"Welding, soldering, and brazing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"505","women":"7.8","white":"7.6","black":"3.8","asian":"20.9"}},"wageData":{"2011":{"workers":"461","median":"679","maleWorkers":"426","maleMedian":"695","femaleWorkers":"36","femaleMedian":"-"}}},"Heat treating equipment setters, operators, and tenders, metal and plastic":{"ageData":{"2011":{"total":"4","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Heat treating equipment setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"5","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Layout workers, metal and plastic":{"ageData":{"2011":{"total":"6","16to19":"0","20to24":"0","25to34":"3","35to44":"1","45to54":"2","55to64":"0","65+":"1","medianAge":"0"}},"title":"Layout workers, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"8","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Plating and coating machine setters, operators, and tenders, metal and plastic":{"ageData":{"2011":{"total":"15","16to19":"0","20to24":"1","25to34":"3","35to44":"5","45to54":"4","55to64":"2","65+":"0","medianAge":"2"}},"title":"Plating and coating machine setters, operators, and tenders, metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"15","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"15","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Tool grinders, filers, and sharpeners":{"ageData":{"2011":{"total":"7","16to19":"1","20to24":"1","25to34":"1","35to44":"0","45to54":"3","55to64":"0","65+":"1","medianAge":"0"}},"title":"Tool grinders, filers, and sharpeners","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"7","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Metal workers and plastic workers, all other":{"ageData":{"2011":{"total":"368","16to19":"5","20to24":"33","25to34":"83","35to44":"95","45to54":"90","55to64":"55","65+":"7","medianAge":"55"}},"title":"Metal workers and plastic workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"368","women":"22.0","white":"10.3","black":"7.2","asian":"24.3"}},"wageData":{"2011":{"workers":"356","median":"561","maleWorkers":"275","maleMedian":"583","femaleWorkers":"81","femaleMedian":"517"}}},"Prepress technicians and workers":{"ageData":{"2011":{"total":"41","16to19":"2","20to24":"4","25to34":"9","35to44":"6","45to54":"13","55to64":"7","65+":"1","medianAge":"7"}},"title":"Prepress technicians and workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"41","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"30","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"16","femaleMedian":"-"}}},"Printing press operators":{"ageData":{"2011":{"total":"217","16to19":"4","20to24":"20","25to34":"41","35to44":"45","45to54":"69","55to64":"33","65+":"6","medianAge":"33"}},"title":"Printing press operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"217","women":"18.7","white":"12.0","black":"2.2","asian":"16.9"}},"wageData":{"2011":{"workers":"186","median":"613","maleWorkers":"155","maleMedian":"646","femaleWorkers":"31","femaleMedian":"-"}}},"Print binding and finishing workers":{"ageData":{"2011":{"total":"16","16to19":"0","20to24":"0","25to34":"4","35to44":"2","45to54":"6","55to64":"4","65+":"0","medianAge":"4"}},"title":"Print binding and finishing workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"16","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"13","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Laundry and dry-cleaning workers":{"ageData":{"2011":{"total":"174","16to19":"5","20to24":"19","25to34":"30","35to44":"33","45to54":"39","55to64":"37","65+":"11","medianAge":"37"}},"title":"Laundry and dry-cleaning workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"174","women":"60.7","white":"15.2","black":"10.4","asian":"33.8"}},"wageData":{"2011":{"workers":"115","median":"412","maleWorkers":"52","maleMedian":"447","femaleWorkers":"64","femaleMedian":"386"}}},"Pressers, textile, garment, and related materials":{"ageData":{"2011":{"total":"48","16to19":"0","20to24":"0","25to34":"15","35to44":"13","45to54":"8","55to64":"9","65+":"2","medianAge":"9"}},"title":"Pressers, textile, garment, and related materials","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"48","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"37","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"24","femaleMedian":"-"}}},"Sewing machine operators":{"ageData":{"2011":{"total":"169","16to19":"0","20to24":"4","25to34":"29","35to44":"40","45to54":"48","55to64":"36","65+":"11","medianAge":"36"}},"title":"Sewing machine operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"169","women":"78.5","white":"9.7","black":"12.0","asian":"36.9"}},"wageData":{"2011":{"workers":"112","median":"403","maleWorkers":"28","maleMedian":"-","femaleWorkers":"84","femaleMedian":"398"}}},"Shoe and leather workers and repairers":{"ageData":{"2011":{"total":"11","16to19":"0","20to24":"1","25to34":"1","35to44":"2","45to54":"4","55to64":"1","65+":"1","medianAge":"1"}},"title":"Shoe and leather workers and repairers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"8","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Shoe machine operators and tenders":{"ageData":{"2011":{"total":"8","16to19":"0","20to24":"0","25to34":"1","35to44":"3","45to54":"4","55to64":"0","65+":"0","medianAge":"0"}},"title":"Shoe machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"2","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Tailors, dressmakers, and sewers":{"ageData":{"2011":{"total":"94","16to19":"0","20to24":"3","25to34":"9","35to44":"18","45to54":"29","55to64":"24","65+":"11","medianAge":"24"}},"title":"Tailors, dressmakers, and sewers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"94","women":"74.9","white":"4.2","black":"10.7","asian":"27.5"}},"wageData":{"2011":{"workers":"46","median":"-","maleWorkers":"13","maleMedian":"-","femaleWorkers":"33","femaleMedian":"-"}}},"Textile bleaching and dyeing machine operators and tenders":{"ageData":{"2011":{"total":"1","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"0","65+":"0","medianAge":"0"}},"title":"Textile bleaching and dyeing machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"4","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Textile cutting machine setters, operators, and tenders":{"ageData":{"2011":{"total":"5","16to19":"0","20to24":"0","25to34":"1","35to44":"2","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Textile cutting machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"6","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Textile knitting and weaving machine setters, operators, and tenders":{"ageData":{"2011":{"total":"14","16to19":"1","20to24":"0","25to34":"0","35to44":"3","45to54":"6","55to64":"3","65+":"1","medianAge":"3"}},"title":"Textile knitting and weaving machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"14","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"8","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Textile winding, twisting, and drawing out machine setters, operators, and tenders":{"ageData":{"2011":{"total":"16","16to19":"0","20to24":"0","25to34":"6","35to44":"3","45to54":"4","55to64":"3","65+":"0","medianAge":"3"}},"title":"Textile winding, twisting, and drawing out machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"16","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"19","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"11","femaleMedian":"-"}}},"Extruding and forming machine setters, operators, and tenders, synthetic and glass fibers":{"ageData":{"2011":{"total":"1","16to19":"0","20to24":"0","25to34":"1","35to44":"0","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Extruding and forming machine setters, operators, and tenders, synthetic and glass fibers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"2","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Fabric and apparel patternmakers":{"ageData":{"2011":{"total":"5","16to19":"0","20to24":"0","25to34":"2","35to44":"2","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Fabric and apparel patternmakers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"5","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Upholsterers":{"ageData":{"2011":{"total":"47","16to19":"1","20to24":"4","25to34":"11","35to44":"9","45to54":"7","55to64":"14","65+":"1","medianAge":"14"}},"title":"Upholsterers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"47","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"34","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"4","femaleMedian":"-"}}},"Textile, apparel, and furnishings workers, all other":{"ageData":{"2011":{"total":"22","16to19":"1","20to24":"1","25to34":"3","35to44":"5","45to54":"5","55to64":"5","65+":"2","medianAge":"5"}},"title":"Textile, apparel, and furnishings workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"22","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"15","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Cabinetmakers and bench carpenters":{"ageData":{"2011":{"total":"66","16to19":"0","20to24":"5","25to34":"12","35to44":"13","45to54":"18","55to64":"17","65+":"2","medianAge":"17"}},"title":"Cabinetmakers and bench carpenters","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"66","women":"2.3","white":"0.3","black":"1.5","asian":"8.0"}},"wageData":{"2011":{"workers":"42","median":"-","maleWorkers":"41","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Furniture finishers":{"ageData":{"2011":{"total":"17","16to19":"0","20to24":"0","25to34":"2","35to44":"3","45to54":"6","55to64":"6","65+":"0","medianAge":"6"}},"title":"Furniture finishers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"17","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"11","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Model makers and patternmakers, wood":{"ageData":{"2011":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Model makers and patternmakers, wood","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"1","median":"-","maleWorkers":"1","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Sawing machine setters, operators, and tenders, wood":{"ageData":{"2011":{"total":"32","16to19":"2","20to24":"7","25to34":"6","35to44":"6","45to54":"7","55to64":"3","65+":"1","medianAge":"3"}},"title":"Sawing machine setters, operators, and tenders, wood","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"32","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"31","median":"-","maleWorkers":"30","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Woodworking machine setters, operators, and tenders, except sawing":{"ageData":{"2011":{"total":"20","16to19":"0","20to24":"2","25to34":"6","35to44":"2","45to54":"6","55to64":"4","65+":"0","medianAge":"4"}},"title":"Woodworking machine setters, operators, and tenders, except sawing","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"20","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"17","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Woodworkers, all other":{"ageData":{"2011":{"total":"21","16to19":"1","20to24":"2","25to34":"5","35to44":"2","45to54":"5","55to64":"3","65+":"1","medianAge":"3"}},"title":"Woodworkers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"21","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"10","median":"-","maleWorkers":"8","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Power plant operators, distributors, and dispatchers":{"ageData":{"2011":{"total":"50","16to19":"0","20to24":"0","25to34":"10","35to44":"12","45to54":"19","55to64":"7","65+":"2","medianAge":"7"}},"title":"Power plant operators, distributors, and dispatchers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"50","women":"1.8","white":"5.9","black":"2.0","asian":"6.5"}},"wageData":{"2011":{"workers":"53","median":"1,091","maleWorkers":"52","maleMedian":"1,085","femaleWorkers":"1","femaleMedian":"-"}}},"Stationary engineers and boiler operators":{"ageData":{"2011":{"total":"95","16to19":"1","20to24":"1","25to34":"9","35to44":"18","45to54":"31","55to64":"30","65+":"5","medianAge":"30"}},"title":"Stationary engineers and boiler operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"95","women":"2.2","white":"13.5","black":"3.4","asian":"17.4"}},"wageData":{"2011":{"workers":"93","median":"855","maleWorkers":"92","maleMedian":"851","femaleWorkers":"1","femaleMedian":"-"}}},"Water and wastewater treatment plant and system operators":{"ageData":{"2011":{"total":"71","16to19":"0","20to24":"1","25to34":"12","35to44":"13","45to54":"25","55to64":"18","65+":"1","medianAge":"18"}},"title":"Water and wastewater treatment plant and system operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"71","women":"5.2","white":"11.1","black":"0.8","asian":"10.8"}},"wageData":{"2011":{"workers":"75","median":"780","maleWorkers":"70","maleMedian":"788","femaleWorkers":"5","femaleMedian":"-"}}},"Miscellaneous plant and system operators":{"ageData":{"2011":{"total":"39","16to19":"0","20to24":"1","25to34":"7","35to44":"9","45to54":"10","55to64":"10","65+":"2","medianAge":"10"}},"title":"Miscellaneous plant and system operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"39","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"37","median":"-","maleWorkers":"34","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Chemical processing machine setters, operators, and tenders":{"ageData":{"2011":{"total":"65","16to19":"1","20to24":"5","25to34":"18","35to44":"12","45to54":"16","55to64":"12","65+":"0","medianAge":"12"}},"title":"Chemical processing machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"65","women":"16.4","white":"9.8","black":"2.4","asian":"11.3"}},"wageData":{"2011":{"workers":"66","median":"853","maleWorkers":"52","maleMedian":"947","femaleWorkers":"14","femaleMedian":"-"}}},"Crushing, grinding, polishing, mixing, and blending workers":{"ageData":{"2011":{"total":"94","16to19":"2","20to24":"9","25to34":"29","35to44":"20","45to54":"21","55to64":"13","65+":"1","medianAge":"13"}},"title":"Crushing, grinding, polishing, mixing, and blending workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"94","women":"13.5","white":"8.1","black":"3.9","asian":"21.0"}},"wageData":{"2011":{"workers":"94","median":"659","maleWorkers":"82","maleMedian":"702","femaleWorkers":"12","femaleMedian":"-"}}},"Cutting workers":{"ageData":{"2011":{"total":"84","16to19":"3","20to24":"9","25to34":"19","35to44":"19","45to54":"17","55to64":"16","65+":"1","medianAge":"16"}},"title":"Cutting workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"84","women":"22.5","white":"9.8","black":"1.2","asian":"28.5"}},"wageData":{"2011":{"workers":"69","median":"518","maleWorkers":"55","maleMedian":"540","femaleWorkers":"13","femaleMedian":"-"}}},"Extruding, forming, pressing, and compacting machine setters, operators, and tenders":{"ageData":{"2011":{"total":"34","16to19":"0","20to24":"3","25to34":"7","35to44":"8","45to54":"12","55to64":"4","65+":"0","medianAge":"4"}},"title":"Extruding, forming, pressing, and compacting machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"34","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"31","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Furnace, kiln, oven, drier, and kettle operators and tenders":{"ageData":{"2011":{"total":"11","16to19":"0","20to24":"1","25to34":"6","35to44":"1","45to54":"1","55to64":"2","65+":"0","medianAge":"2"}},"title":"Furnace, kiln, oven, drier, and kettle operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"11","median":"-","maleWorkers":"11","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Inspectors, testers, sorters, samplers, and weighers":{"ageData":{"2011":{"total":"647","16to19":"6","20to24":"54","25to34":"135","35to44":"145","45to54":"176","55to64":"116","65+":"15","medianAge":"116"}},"title":"Inspectors, testers, sorters, samplers, and weighers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"647","women":"34.9","white":"8.1","black":"6.0","asian":"16.4"}},"wageData":{"2011":{"workers":"608","median":"675","maleWorkers":"396","maleMedian":"792","femaleWorkers":"212","femaleMedian":"541"}}},"Jewelers and precious stone and metal workers":{"ageData":{"2011":{"total":"41","16to19":"0","20to24":"2","25to34":"3","35to44":"8","45to54":"10","55to64":"14","65+":"5","medianAge":"14"}},"title":"Jewelers and precious stone and metal workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"41","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"14","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"7","femaleMedian":"-"}}},"Medical, dental, and ophthalmic laboratory technicians":{"ageData":{"2011":{"total":"87","16to19":"1","20to24":"12","25to34":"15","35to44":"23","45to54":"21","55to64":"11","65+":"3","medianAge":"11"}},"title":"Medical, dental, and ophthalmic laboratory technicians","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"87","women":"53.1","white":"7.3","black":"9.8","asian":"13.0"}},"wageData":{"2011":{"workers":"68","median":"612","maleWorkers":"34","maleMedian":"-","femaleWorkers":"34","femaleMedian":"-"}}},"Packaging and filling machine operators and tenders":{"ageData":{"2011":{"total":"288","16to19":"10","20to24":"36","25to34":"69","35to44":"60","45to54":"70","55to64":"37","65+":"6","medianAge":"37"}},"title":"Packaging and filling machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"288","women":"50.6","white":"13.3","black":"5.6","asian":"40.9"}},"wageData":{"2011":{"workers":"259","median":"455","maleWorkers":"120","maleMedian":"505","femaleWorkers":"139","femaleMedian":"421"}}},"Painting workers":{"ageData":{"2011":{"total":"120","16to19":"2","20to24":"9","25to34":"29","35to44":"34","45to54":"30","55to64":"13","65+":"3","medianAge":"13"}},"title":"Painting workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"120","women":"13.4","white":"10.8","black":"3.1","asian":"23.1"}},"wageData":{"2011":{"workers":"111","median":"602","maleWorkers":"99","maleMedian":"608","femaleWorkers":"12","femaleMedian":"-"}}},"Photographic process workers and processing machine operators":{"ageData":{"2011":{"total":"43","16to19":"3","20to24":"13","25to34":"14","35to44":"5","45to54":"5","55to64":"3","65+":"0","medianAge":"3"}},"title":"Photographic process workers and processing machine operators","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"43","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"24","median":"-","maleWorkers":"10","maleMedian":"-","femaleWorkers":"13","femaleMedian":"-"}}},"Semiconductor processors":{"ageData":{"2011":{"total":"3","16to19":"0","20to24":"1","25to34":"0","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Semiconductor processors","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"4","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Adhesive bonding machine operators and tenders":{"ageData":{"2011":{"total":"9","16to19":"0","20to24":"1","25to34":"0","35to44":"5","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Adhesive bonding machine operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"9","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"10","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Cleaning, washing, and metal pickling equipment operators and tenders":{"ageData":{"2011":{"total":"11","16to19":"0","20to24":"0","25to34":"4","35to44":"4","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Cleaning, washing, and metal pickling equipment operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"13","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Cooling and freezing equipment operators and tenders":{"ageData":{"2011":{"total":"3","16to19":"0","20to24":"0","25to34":"0","35to44":"1","45to54":"1","55to64":"1","65+":"0","medianAge":"1"}},"title":"Cooling and freezing equipment operators and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"3","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Etchers and engravers":{"ageData":{"2011":{"total":"10","16to19":"0","20to24":"1","25to34":"0","35to44":"4","45to54":"3","55to64":"1","65+":"1","medianAge":"1"}},"title":"Etchers and engravers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"10","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"7","median":"-","maleWorkers":"4","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Molders, shapers, and casters, except metal and plastic":{"ageData":{"2011":{"total":"37","16to19":"2","20to24":"7","25to34":"7","35to44":"4","45to54":"7","55to64":"6","65+":"4","medianAge":"6"}},"title":"Molders, shapers, and casters, except metal and plastic","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"37","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"21","median":"-","maleWorkers":"15","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Paper goods machine setters, operators, and tenders":{"ageData":{"2011":{"total":"37","16to19":"0","20to24":"1","25to34":"7","35to44":"10","45to54":"14","55to64":"3","65+":"1","medianAge":"3"}},"title":"Paper goods machine setters, operators, and tenders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"37","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"31","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Tire builders":{"ageData":{"2011":{"total":"20","16to19":"0","20to24":"1","25to34":"5","35to44":"6","45to54":"7","55to64":"1","65+":"0","medianAge":"1"}},"title":"Tire builders","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"20","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"17","median":"-","maleWorkers":"16","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Helpers--production workers":{"ageData":{"2011":{"total":"54","16to19":"6","20to24":"15","25to34":"10","35to44":"10","45to54":"7","55to64":"5","65+":"1","medianAge":"5"}},"title":"Helpers--production workers","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"54","women":"25.6","white":"11.2","black":"3.4","asian":"30.6"}},"wageData":{"2011":{"workers":"45","median":"-","maleWorkers":"40","maleMedian":"-","femaleWorkers":"6","femaleMedian":"-"}}},"Production workers, all other":{"ageData":{"2011":{"total":"777","16to19":"16","20to24":"70","25to34":"166","35to44":"185","45to54":"205","55to64":"115","65+":"20","medianAge":"115"}},"title":"Production workers, all other","depth":3,"parent":"Production occupations","sexRaceEthnicityData":{"2011":{"total":"777","women":"26.2","white":"14.7","black":"5.3","asian":"21.5"}},"wageData":{"2011":{"workers":"652","median":"579","maleWorkers":"502","maleMedian":"612","femaleWorkers":"151","femaleMedian":"483"}}},"Transportation and material moving occupations":{"ageData":{"2011":{"total":"8,318","16to19":"305","20to24":"807","25to34":"1,655","35to44":"1,751","45to54":"2,030","55to64":"1,313","65+":"456","medianAge":"1,313"}},"title":"Transportation and material moving occupations","depth":2,"parent":"Production, transportation, and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"8,318","women":"14.9","white":"16.3","black":"2.7","asian":"20.3"}},"wageData":{"2011":{"workers":"6,275","median":"614","maleWorkers":"5,489","maleMedian":"634","femaleWorkers":"786","femaleMedian":"490"}}},"Supervisors of transportation and material moving workers":{"ageData":{"2011":{"total":"228","16to19":"0","20to24":"15","25to34":"43","35to44":"57","45to54":"72","55to64":"35","65+":"6","medianAge":"35"}},"title":"Supervisors of transportation and material moving workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"228","women":"22.1","white":"16.5","black":"2.3","asian":"13.7"}},"wageData":{"2011":{"workers":"208","median":"761","maleWorkers":"170","maleMedian":"773","femaleWorkers":"38","femaleMedian":"-"}}},"Aircraft pilots and flight engineers":{"ageData":{"2011":{"total":"121","16to19":"0","20to24":"3","25to34":"16","35to44":"24","45to54":"45","55to64":"28","65+":"5","medianAge":"28"}},"title":"Aircraft pilots and flight engineers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"121","women":"4.3","white":"2.9","black":"2.4","asian":"3.9"}},"wageData":{"2011":{"workers":"93","median":"1,461","maleWorkers":"89","maleMedian":"1,466","femaleWorkers":"4","femaleMedian":"-"}}},"Air traffic controllers and airfield operations specialists":{"ageData":{"2011":{"total":"43","16to19":"0","20to24":"1","25to34":"12","35to44":"11","45to54":"10","55to64":"7","65+":"1","medianAge":"7"}},"title":"Air traffic controllers and airfield operations specialists","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"43","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"40","median":"-","maleWorkers":"35","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Flight attendants":{"ageData":{"2011":{"total":"88","16to19":"0","20to24":"1","25to34":"14","35to44":"24","45to54":"30","55to64":"15","65+":"4","medianAge":"15"}},"title":"Flight attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"88","women":"77.4","white":"9.3","black":"3.2","asian":"10.4"}},"wageData":{"2011":{"workers":"52","median":"791","maleWorkers":"14","maleMedian":"-","femaleWorkers":"38","femaleMedian":"-"}}},"Ambulance drivers and attendants, except emergency medical technicians":{"ageData":{"2011":{"total":"13","16to19":"0","20to24":"2","25to34":"5","35to44":"0","45to54":"3","55to64":"3","65+":"1","medianAge":"3"}},"title":"Ambulance drivers and attendants, except emergency medical technicians","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"13","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"9","median":"-","maleWorkers":"9","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Bus drivers":{"ageData":{"2011":{"total":"573","16to19":"3","20to24":"5","25to34":"46","35to44":"98","45to54":"171","55to64":"158","65+":"92","medianAge":"158"}},"title":"Bus drivers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"573","women":"43.4","white":"24.6","black":"1.6","asian":"12.7"}},"wageData":{"2011":{"workers":"310","median":"608","maleWorkers":"188","maleMedian":"645","femaleWorkers":"122","femaleMedian":"579"}}},"Driver/sales workers and truck drivers":{"ageData":{"2011":{"total":"3,059","16to19":"43","20to24":"167","25to34":"550","35to44":"716","45to54":"858","55to64":"547","65+":"178","medianAge":"547"}},"title":"Driver/sales workers and truck drivers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"3,059","women":"4.8","white":"13.7","black":"1.6","asian":"17.6"}},"wageData":{"2011":{"workers":"2,439","median":"705","maleWorkers":"2,337","maleMedian":"712","femaleWorkers":"102","femaleMedian":"511"}}},"Taxi drivers and chauffeurs":{"ageData":{"2011":{"total":"342","16to19":"0","20to24":"15","25to34":"64","35to44":"63","45to54":"92","55to64":"67","65+":"41","medianAge":"67"}},"title":"Taxi drivers and chauffeurs","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"342","women":"12.5","white":"26.7","black":"15.6","asian":"16.0"}},"wageData":{"2011":{"workers":"207","median":"553","maleWorkers":"178","maleMedian":"576","femaleWorkers":"29","femaleMedian":"-"}}},"Motor vehicle operators, all other":{"ageData":{"2011":{"total":"62","16to19":"0","20to24":"3","25to34":"9","35to44":"11","45to54":"11","55to64":"8","65+":"21","medianAge":"8"}},"title":"Motor vehicle operators, all other","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"62","women":"5.6","white":"13.5","black":"3.4","asian":"21.2"}},"wageData":{"2011":{"workers":"28","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Locomotive engineers and operators":{"ageData":{"2011":{"total":"45","16to19":"0","20to24":"1","25to34":"6","35to44":"12","45to54":"13","55to64":"11","65+":"2","medianAge":"11"}},"title":"Locomotive engineers and operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"45","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"43","median":"-","maleWorkers":"42","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Railroad brake, signal, and switch operators":{"ageData":{"2011":{"total":"5","16to19":"0","20to24":"1","25to34":"2","35to44":"0","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Railroad brake, signal, and switch operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Railroad conductors and yardmasters":{"ageData":{"2011":{"total":"52","16to19":"1","20to24":"4","25to34":"11","35to44":"12","45to54":"14","55to64":"9","65+":"2","medianAge":"9"}},"title":"Railroad conductors and yardmasters","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"52","women":"6.6","white":"27.2","black":"2.7","asian":"4.7"}},"wageData":{"2011":{"workers":"48","median":"-","maleWorkers":"45","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Subway, streetcar, and other rail transportation workers":{"ageData":{"2011":{"total":"11","16to19":"0","20to24":"1","25to34":"3","35to44":"1","45to54":"4","55to64":"2","65+":"0","medianAge":"2"}},"title":"Subway, streetcar, and other rail transportation workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"11","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"14","median":"-","maleWorkers":"12","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Sailors and marine oilers":{"ageData":{"2011":{"total":"22","16to19":"0","20to24":"5","25to34":"9","35to44":"3","45to54":"1","55to64":"3","65+":"1","medianAge":"3"}},"title":"Sailors and marine oilers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"22","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"23","median":"-","maleWorkers":"23","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Ship and boat captains and operators":{"ageData":{"2011":{"total":"37","16to19":"0","20to24":"1","25to34":"9","35to44":"5","45to54":"11","55to64":"9","65+":"3","medianAge":"9"}},"title":"Ship and boat captains and operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"37","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"35","median":"-","maleWorkers":"35","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Ship engineers":{"ageData":{"2011":{"total":"8","16to19":"1","20to24":"0","25to34":"3","35to44":"3","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Ship engineers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"8","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"6","median":"-","maleWorkers":"6","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Bridge and lock tenders":{"ageData":{"2011":{"total":"6","16to19":"0","20to24":"0","25to34":"1","35to44":"1","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Bridge and lock tenders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"6","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"7","median":"-","maleWorkers":"7","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Parking lot attendants":{"ageData":{"2011":{"total":"73","16to19":"6","20to24":"17","25to34":"16","35to44":"13","45to54":"12","55to64":"6","65+":"2","medianAge":"6"}},"title":"Parking lot attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"73","women":"13.2","white":"26.6","black":"4.1","asian":"28.7"}},"wageData":{"2011":{"workers":"46","median":"-","maleWorkers":"40","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Automotive and watercraft service attendants":{"ageData":{"2011":{"total":"76","16to19":"11","20to24":"18","25to34":"16","35to44":"12","45to54":"8","55to64":"6","65+":"4","medianAge":"6"}},"title":"Automotive and watercraft service attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"76","women":"10.6","white":"7.1","black":"2.3","asian":"17.1"}},"wageData":{"2011":{"workers":"42","median":"-","maleWorkers":"40","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Transportation inspectors":{"ageData":{"2011":{"total":"32","16to19":"0","20to24":"2","25to34":"7","35to44":"5","45to54":"11","55to64":"6","65+":"1","medianAge":"6"}},"title":"Transportation inspectors","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"32","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"32","median":"-","maleWorkers":"28","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Transportation attendants, except flight attendants":{"ageData":{"2011":{"total":"32","16to19":"0","20to24":"3","25to34":"6","35to44":"3","45to54":"7","55to64":"10","65+":"3","medianAge":"10"}},"title":"Transportation attendants, except flight attendants","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"32","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"13","median":"-","maleWorkers":"5","maleMedian":"-","femaleWorkers":"8","femaleMedian":"-"}}},"Other transportation workers":{"ageData":{"2011":{"total":"16","16to19":"0","20to24":"1","25to34":"4","35to44":"3","45to54":"4","55to64":"2","65+":"1","medianAge":"2"}},"title":"Other transportation workers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"16","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"15","median":"-","maleWorkers":"14","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Conveyor operators and tenders":{"ageData":{"2011":{"total":"5","16to19":"1","20to24":"0","25to34":"0","35to44":"0","45to54":"2","55to64":"1","65+":"0","medianAge":"1"}},"title":"Conveyor operators and tenders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"5","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"5","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}},"Crane and tower operators":{"ageData":{"2011":{"total":"63","16to19":"0","20to24":"5","25to34":"12","35to44":"20","45to54":"17","55to64":"7","65+":"2","medianAge":"7"}},"title":"Crane and tower operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"63","women":"0.4","white":"13.7","black":"1.9","asian":"21.8"}},"wageData":{"2011":{"workers":"63","median":"739","maleWorkers":"62","maleMedian":"736","femaleWorkers":"1","femaleMedian":"-"}}},"Dredge, excavating, and loading machine operators":{"ageData":{"2011":{"total":"51","16to19":"0","20to24":"6","25to34":"7","35to44":"10","45to54":"16","55to64":"9","65+":"1","medianAge":"9"}},"title":"Dredge, excavating, and loading machine operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"51","women":"0.7","white":"0.0","black":"0.0","asian":"17.2"}},"wageData":{"2011":{"workers":"37","median":"-","maleWorkers":"37","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Hoist and winch operators":{"ageData":{"2011":{"total":"4","16to19":"0","20to24":"1","25to34":"2","35to44":"1","45to54":"1","55to64":"0","65+":"0","medianAge":"0"}},"title":"Hoist and winch operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"4","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"5","median":"-","maleWorkers":"3","maleMedian":"-","femaleWorkers":"2","femaleMedian":"-"}}},"Industrial truck and tractor operators":{"ageData":{"2011":{"total":"528","16to19":"9","20to24":"55","25to34":"142","35to44":"130","45to54":"124","55to64":"57","65+":"12","medianAge":"57"}},"title":"Industrial truck and tractor operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"528","women":"6.7","white":"22.7","black":"1.3","asian":"27.9"}},"wageData":{"2011":{"workers":"491","median":"562","maleWorkers":"456","maleMedian":"556","femaleWorkers":"35","femaleMedian":"-"}}},"Cleaners of vehicles and equipment":{"ageData":{"2011":{"total":"331","16to19":"43","20to24":"62","25to34":"75","35to44":"70","45to54":"42","55to64":"32","65+":"7","medianAge":"32"}},"title":"Cleaners of vehicles and equipment","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"331","women":"12.0","white":"14.2","black":"1.3","asian":"33.4"}},"wageData":{"2011":{"workers":"230","median":"465","maleWorkers":"206","maleMedian":"458","femaleWorkers":"25","femaleMedian":"-"}}},"Laborers and freight, stock, and material movers, hand":{"ageData":{"2011":{"total":"1,787","16to19":"161","20to24":"323","25to34":"423","35to44":"321","45to54":"322","55to64":"188","65+":"49","medianAge":"188"}},"title":"Laborers and freight, stock, and material movers, hand","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"1,787","women":"16.9","white":"17.4","black":"3.1","asian":"21.8"}},"wageData":{"2011":{"workers":"1,260","median":"509","maleWorkers":"1,085","maleMedian":"520","femaleWorkers":"175","femaleMedian":"416"}}},"Machine feeders and offbearers":{"ageData":{"2011":{"total":"36","16to19":"3","20to24":"5","25to34":"10","35to44":"6","45to54":"7","55to64":"4","65+":"1","medianAge":"4"}},"title":"Machine feeders and offbearers","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"36","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"32","median":"-","maleWorkers":"27","maleMedian":"-","femaleWorkers":"5","femaleMedian":"-"}}},"Packers and packagers, hand":{"ageData":{"2011":{"total":"393","16to19":"16","20to24":"63","25to34":"98","35to44":"77","45to54":"78","55to64":"50","65+":"11","medianAge":"50"}},"title":"Packers and packagers, hand","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"393","women":"53.5","white":"14.1","black":"3.6","asian":"45.8"}},"wageData":{"2011":{"workers":"300","median":"397","maleWorkers":"135","maleMedian":"396","femaleWorkers":"165","femaleMedian":"397"}}},"Pumping station operators":{"ageData":{"2011":{"total":"21","16to19":"0","20to24":"3","25to34":"6","35to44":"4","45to54":"3","55to64":"5","65+":"0","medianAge":"5"}},"title":"Pumping station operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"21","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"26","median":"-","maleWorkers":"26","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Refuse and recyclable material collectors":{"ageData":{"2011":{"total":"92","16to19":"2","20to24":"12","25to34":"22","35to44":"16","45to54":"24","55to64":"12","65+":"4","medianAge":"12"}},"title":"Refuse and recyclable material collectors","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"92","women":"7.7","white":"17.1","black":"0.7","asian":"30.0"}},"wageData":{"2011":{"workers":"58","median":"541","maleWorkers":"56","maleMedian":"580","femaleWorkers":"3","femaleMedian":"-"}}},"Mine shuttle car operators":{"ageData":{"2011":{"total":"1","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"0","55to64":"1","65+":"0","medianAge":"1"}},"title":"Mine shuttle car operators","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"1","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"1","median":"-","maleWorkers":"0","maleMedian":"-","femaleWorkers":"1","femaleMedian":"-"}}},"Tank car, truck, and ship loaders":{"ageData":{"2011":{"total":"3","16to19":"0","20to24":"0","25to34":"0","35to44":"0","45to54":"2","55to64":"0","65+":"0","medianAge":"0"}},"title":"Tank car, truck, and ship loaders","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"3","women":"-","white":"-","black":"-","asian":"-"}},"wageData":{"2011":{"workers":"3","median":"-","maleWorkers":"2","maleMedian":"-","femaleWorkers":"0","femaleMedian":"-"}}},"Material moving workers, all other":{"ageData":{"2011":{"total":"62","16to19":"3","20to24":"7","25to34":"6","35to44":"19","45to54":"12","55to64":"13","65+":"2","medianAge":"13"}},"title":"Material moving workers, all other","depth":3,"parent":"Transportation and material moving occupations","sexRaceEthnicityData":{"2011":{"total":"62","women":"10.3","white":"16.4","black":"0.4","asian":"24.0"}},"wageData":{"2011":{"workers":"45","median":"-","maleWorkers":"42","maleMedian":"-","femaleWorkers":"3","femaleMedian":"-"}}}}');


function $4d50368102d8f869$export$1686aec5678ceb1c() {
    let data = {};
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).mergeWith(data, (0, (/*@__PURE__*/$parcel$interopDefault($46f25f1365a55a00$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($83f0759578d3f154$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($0894db524f4dc2d8$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($7475598ace082300$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($b40301d0d2c81e1e$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($62ee90ffcb92ff51$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($ef9839ab9dc2d130$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($b278c546eac81c0f$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($577b8123572c4454$exports))), (objValue, srcValue, key, object, source, stack)=>{
        if (objValue && srcValue && objValue !== srcValue && typeof objValue !== "object" && typeof srcValue !== "object") console.warn({
            objValue: objValue,
            srcValue: srcValue,
            key: key,
            object: object,
            source: source
        });
    });
    // mark jobs as "complete", "incomplete", or "nodata"
    // record number of children
    Object.values(data).forEach((job)=>{
        $4d50368102d8f869$var$setJobRelations(job, data);
        $4d50368102d8f869$var$setJobDataCompleteness(job);
        $4d50368102d8f869$var$setJobDomination(job);
    });
    function findSubJobs(job) {
        job.subcategories = 0;
        job.occupations = 0;
        job.occupationsWithNoData = 0;
        job.occupationsWithMissingData = 0;
        Object.keys(job.children).forEach((childJob)=>{
            let jobData = data[childJob];
            let [subcategories, occupations, noData, missingData] = findSubJobs(jobData);
            if (occupations) job.subcategories++;
            else {
                job.occupations++;
                if (jobData.noData) job.occupationsWithNoData++;
                if (jobData.missingData) job.occupationsWithMissingData++;
            }
            job.subcategories += subcategories;
            job.occupations += occupations;
            job.occupationsWithNoData += noData;
            job.occupationsWithMissingData += missingData;
        });
        return [
            job.subcategories,
            job.occupations,
            job.occupationsWithNoData,
            job.occupationsWithMissingData
        ];
    }
    Object.entries(data).forEach(([parent, job])=>{
        if (!job.parent) findSubJobs(job);
    });
    return data;
}
function $4d50368102d8f869$var$setJobRelations(job, data) {
    if (!job.children) job.children = {};
    if (job.parent) {
        job.parent = data[job.parent];
        if (!job.parent.children) job.parent.children = {};
        job.parent.children[job.title] = job;
    }
}
function $4d50368102d8f869$var$setJobDataCompleteness(job) {
    let maleWageCount = 0;
    let femaleWageCount = 0;
    let totalWageCount = 0;
    let totalMedianCount = 0;
    Object.values(job.wageData).forEach((wageData)=>{
        totalWageCount++;
        if (wageData.median !== "-") totalMedianCount++;
        if (wageData.femaleMedian !== "-") femaleWageCount++;
        if (wageData.maleMedian !== "-") maleWageCount++;
    });
    job.noData = totalMedianCount === 0;
    job.missingData = !job.noData && (femaleWageCount !== totalWageCount || maleWageCount !== totalWageCount);
    return job;
}
function $4d50368102d8f869$var$sum(...numbers) {
    return numbers.reduce((total, num)=>{
        return total + num;
    }, 0);
}
function $4d50368102d8f869$var$avg(...numbers) {
    return $4d50368102d8f869$var$sum(...numbers) / numbers.length;
}
function $4d50368102d8f869$var$confidence(score) {
    switch(Math.floor(score)){
        case 0:
            return "very low";
        case 1:
            return "very low";
        case 2:
            return "low";
        case 3:
            return "medium-low";
        case 4:
            return "medium";
        case 6:
            return "medium";
        case 7:
            return "medium-high";
        case 8:
            return "medium-high";
        default:
            return "high";
    }
}
function $4d50368102d8f869$var$setJobDomination(job) {
    if (!job.noData) {
        let dominationPerYear = [];
        let participationPerYear = [];
        Object.entries(job.sexRaceEthnicityData).forEach(([year, data])=>{
            if (data.women !== "-") {
                let total = (0, (/*@__PURE__*/$parcel$interopDefault($6690377ff2917a7c$exports)))(data.total).value();
                participationPerYear.push(total * 1000);
                let womenPercent = (0, (/*@__PURE__*/$parcel$interopDefault($6690377ff2917a7c$exports)))(data.women).value();
                let menPercent = 100 - womenPercent;
                let yearlyDomination = menPercent - womenPercent;
                dominationPerYear.push(yearlyDomination);
            }
        });
        // for this, let's decide that "gender dominated" means a lead of +20 points on average
        let dominationAverage = $4d50368102d8f869$var$avg(...dominationPerYear);
        let averageParticipation = $4d50368102d8f869$var$avg(...participationPerYear);
        // the raw data
        job.dominationPerYear = dominationPerYear;
        job.dominationAverage = dominationAverage;
        job.confidenceValue = Math.floor(averageParticipation / 50000);
        job.confidenceScore = $4d50368102d8f869$var$confidence(job.confidenceValue);
        let minIsFemale = Math.min(...dominationPerYear) < 0;
        let maxIsMale = Math.max(...dominationPerYear) > 0;
        job.hasFlipped = minIsFemale && maxIsMale;
    }
    return job;
}



var $igqD6 = parcelRequire("igqD6");


var $73t87 = parcelRequire("73t87");


var $f1q41 = parcelRequire("f1q41");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $igqD6 = parcelRequire("igqD6");


var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("lDTld");

var $acw62 = parcelRequire("acw62");

var $lDTld = parcelRequire("lDTld");

var $8nd05 = parcelRequire("8nd05");
var $3b4cff6eff59c4cb$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $3b4cff6eff59c4cb$export$2e2bcd8739ae039 = $3b4cff6eff59c4cb$var$weakMemoize;


var $72623ab6bcb0a33b$exports = {};
"use strict";
var $3251146683c5d714$exports = {};
"use strict";

$3251146683c5d714$exports = (parcelRequire("9cCWX"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($3251146683c5d714$exports.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$72623ab6bcb0a33b$exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f1be2661c8fac766$var$hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($72623ab6bcb0a33b$exports)))(targetComponent, sourceComponent);
};
var $f1be2661c8fac766$export$2e2bcd8739ae039 = $f1be2661c8fac766$var$hoistNonReactStatics;



var $2Hahg = parcelRequire("2Hahg");

var $cqnxX = parcelRequire("cqnxX");
var $094eab6f6c422d65$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $094eab6f6c422d65$var$EmotionCacheContext = /* #__PURE__ */ (0, $acw62.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $lDTld.default)({
    key: "css"
}) : null);
var $094eab6f6c422d65$export$e7094788287c5e9b = $094eab6f6c422d65$var$EmotionCacheContext.Provider;
var $094eab6f6c422d65$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($094eab6f6c422d65$var$EmotionCacheContext);
};
var $094eab6f6c422d65$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($094eab6f6c422d65$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $094eab6f6c422d65$export$971d5caa766a69d7 = /* #__PURE__ */ (0, $acw62.createContext)({});
var $094eab6f6c422d65$export$407448d2b89b1813 = function useTheme() {
    return (0, $acw62.useContext)($094eab6f6c422d65$export$971d5caa766a69d7);
};
var $094eab6f6c422d65$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, theme);
};
var $094eab6f6c422d65$var$createCacheWithTheme = /* #__PURE__ */ (0, $3b4cff6eff59c4cb$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $3b4cff6eff59c4cb$export$2e2bcd8739ae039)(function(theme) {
        return $094eab6f6c422d65$var$getTheme(outerTheme, theme);
    });
});
var $094eab6f6c422d65$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = (0, $acw62.useContext)($094eab6f6c422d65$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $094eab6f6c422d65$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ (0, $acw62.createElement)($094eab6f6c422d65$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $094eab6f6c422d65$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = (0, $acw62.useContext)($094eab6f6c422d65$export$971d5caa766a69d7);
        return /*#__PURE__*/ (0, $acw62.createElement)(Component, (0, $8nd05.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ (0, $acw62.forwardRef)(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $f1be2661c8fac766$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $094eab6f6c422d65$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $094eab6f6c422d65$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $094eab6f6c422d65$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $094eab6f6c422d65$var$getLastPart(match[1]);
    return undefined;
};
var $094eab6f6c422d65$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $094eab6f6c422d65$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $094eab6f6c422d65$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $094eab6f6c422d65$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($094eab6f6c422d65$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $094eab6f6c422d65$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $094eab6f6c422d65$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : function useInsertionEffect(create) {
    create();
};
function $094eab6f6c422d65$export$3b14a55fb2447963(create) {
    $094eab6f6c422d65$var$useInsertionEffect(create);
}
var $094eab6f6c422d65$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $094eab6f6c422d65$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $094eab6f6c422d65$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($094eab6f6c422d65$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$094eab6f6c422d65$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $094eab6f6c422d65$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $2Hahg.registerStyles)(cache, serialized, isStringTag);
    var rules = $094eab6f6c422d65$export$3b14a55fb2447963(function() {
        return (0, $2Hahg.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $094eab6f6c422d65$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $094eab6f6c422d65$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$094eab6f6c422d65$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $2Hahg.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $cqnxX.serializeStyles)(registeredStyles, undefined, (0, $acw62.useContext)($094eab6f6c422d65$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($094eab6f6c422d65$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $094eab6f6c422d65$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, /*#__PURE__*/ (0, $acw62.createElement)($094eab6f6c422d65$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ (0, $acw62.createElement)(WrappedComponent, newProps));
});


var $27ab08c24269de64$exports = {};
function $27ab08c24269de64$var$_extends() {
    $27ab08c24269de64$exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;
    return $27ab08c24269de64$var$_extends.apply(this, arguments);
}
$27ab08c24269de64$exports = $27ab08c24269de64$var$_extends, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;






var $2Hahg = parcelRequire("2Hahg");

var $cqnxX = parcelRequire("cqnxX");
var $63d46a01db878c10$var$pkg = {
    name: "@emotion/react",
    version: "11.9.0",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.js",
        "macro.d.ts",
        "macro.js.flow"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.13.10",
        "@emotion/babel-plugin": "^11.7.1",
        "@emotion/cache": "^11.7.1",
        "@emotion/serialize": "^1.0.3",
        "@emotion/utils": "^1.1.0",
        "@emotion/weak-memoize": "^0.2.5",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        "@babel/core": "^7.0.0",
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@babel/core": {
            optional: true
        },
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@babel/core": "^7.13.10",
        "@emotion/css": "11.9.0",
        "@emotion/css-prettifier": "1.0.1",
        "@emotion/server": "11.4.0",
        "@emotion/styled": "11.8.1",
        "@types/react": "^16.9.11",
        dtslint: "^4.2.1",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact"
    }
};
var $63d46a01db878c10$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $094eab6f6c422d65$export$dda1d9f60106f0e9).call(props, "css")) // $FlowFixMe
    return (0, $acw62.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $094eab6f6c422d65$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $094eab6f6c422d65$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $acw62.createElement).apply(null, createElementArgArray);
};
var $63d46a01db878c10$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : (0, $acw62.useLayoutEffect);
var $63d46a01db878c10$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $63d46a01db878c10$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $094eab6f6c422d65$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $cqnxX.serializeStyles)([
        styles
    ], undefined, (0, $acw62.useContext)((0, $094eab6f6c422d65$export$971d5caa766a69d7)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = (0, $acw62.useRef)();
    $63d46a01db878c10$var$useInsertionEffect(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    $63d46a01db878c10$var$useInsertionEffect(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $2Hahg.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $63d46a01db878c10$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $cqnxX.serializeStyles)(args);
}
var $63d46a01db878c10$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $63d46a01db878c10$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $63d46a01db878c10$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $63d46a01db878c10$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $2Hahg.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $63d46a01db878c10$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $094eab6f6c422d65$export$3b14a55fb2447963)(function() {
        for(var i = 0; i < serializedArr.length; i++)var res = (0, $2Hahg.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $63d46a01db878c10$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $094eab6f6c422d65$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $cqnxX.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $2Hahg.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $63d46a01db878c10$var$merge(cache.registered, css, $63d46a01db878c10$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: (0, $acw62.useContext)((0, $094eab6f6c422d65$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, /*#__PURE__*/ (0, $acw62.createElement)($63d46a01db878c10$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $63d46a01db878c10$var$isBrowser, $63d46a01db878c10$var$isJest, $63d46a01db878c10$var$globalContext, $63d46a01db878c10$var$globalKey;


function $cbe7edbf3ccb8828$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}



var $9X7IJ = parcelRequire("9X7IJ");

var $fSwVM = parcelRequire("fSwVM");
var $5dda1db15c8c646c$exports = {};
"use strict";
Object.defineProperty($5dda1db15c8c646c$exports, "__esModule", {
    value: true
});
var $5dda1db15c8c646c$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $5dda1db15c8c646c$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $5dda1db15c8c646c$var$_react2 = $5dda1db15c8c646c$var$_interopRequireDefault($acw62);
var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$8da5bfbbed271cd7$exports = (parcelRequire("hOzOt"))();


var $5dda1db15c8c646c$var$_propTypes2 = $5dda1db15c8c646c$var$_interopRequireDefault($8da5bfbbed271cd7$exports);
function $5dda1db15c8c646c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5dda1db15c8c646c$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $5dda1db15c8c646c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5dda1db15c8c646c$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5dda1db15c8c646c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5dda1db15c8c646c$var$sizerStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    visibility: "hidden",
    height: 0,
    overflow: "scroll",
    whiteSpace: "pre"
};
var $5dda1db15c8c646c$var$INPUT_PROPS_BLACKLIST = [
    "extraWidth",
    "injectStyles",
    "inputClassName",
    "inputRef",
    "inputStyle",
    "minWidth",
    "onAutosize",
    "placeholderIsMinWidth"
];
var $5dda1db15c8c646c$var$cleanInputProps = function cleanInputProps(inputProps) {
    $5dda1db15c8c646c$var$INPUT_PROPS_BLACKLIST.forEach(function(field) {
        return delete inputProps[field];
    });
    return inputProps;
};
var $5dda1db15c8c646c$var$copyStyles = function copyStyles(styles, node) {
    node.style.fontSize = styles.fontSize;
    node.style.fontFamily = styles.fontFamily;
    node.style.fontWeight = styles.fontWeight;
    node.style.fontStyle = styles.fontStyle;
    node.style.letterSpacing = styles.letterSpacing;
    node.style.textTransform = styles.textTransform;
};
var $5dda1db15c8c646c$var$isIE = typeof window !== "undefined" && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
var $5dda1db15c8c646c$var$generateId = function generateId() {
    // we only need an auto-generated ID for stylesheet injection, which is only
    // used for IE. so if the browser is not IE, this should return undefined.
    return $5dda1db15c8c646c$var$isIE ? "_" + Math.random().toString(36).substr(2, 12) : undefined;
};
var $5dda1db15c8c646c$var$AutosizeInput = function(_Component) {
    $5dda1db15c8c646c$var$_inherits(AutosizeInput, _Component);
    $5dda1db15c8c646c$var$_createClass(AutosizeInput, null, [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var id = props.id;
                return id !== state.prevId ? {
                    inputId: id || $5dda1db15c8c646c$var$generateId(),
                    prevId: id
                } : null;
            }
        }
    ]);
    function AutosizeInput(props) {
        $5dda1db15c8c646c$var$_classCallCheck(this, AutosizeInput);
        var _this = $5dda1db15c8c646c$var$_possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
        _this.inputRef = function(el) {
            _this.input = el;
            if (typeof _this.props.inputRef === "function") _this.props.inputRef(el);
        };
        _this.placeHolderSizerRef = function(el) {
            _this.placeHolderSizer = el;
        };
        _this.sizerRef = function(el) {
            _this.sizer = el;
        };
        _this.state = {
            inputWidth: props.minWidth,
            inputId: props.id || $5dda1db15c8c646c$var$generateId(),
            prevId: props.id
        };
        return _this;
    }
    $5dda1db15c8c646c$var$_createClass(AutosizeInput, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.mounted = true;
                this.copyInputStyles();
                this.updateInputWidth();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (prevState.inputWidth !== this.state.inputWidth) {
                    if (typeof this.props.onAutosize === "function") this.props.onAutosize(this.state.inputWidth);
                }
                this.updateInputWidth();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
            }
        },
        {
            key: "copyInputStyles",
            value: function copyInputStyles() {
                if (!this.mounted || !window.getComputedStyle) return;
                var inputStyles = this.input && window.getComputedStyle(this.input);
                if (!inputStyles) return;
                $5dda1db15c8c646c$var$copyStyles(inputStyles, this.sizer);
                if (this.placeHolderSizer) $5dda1db15c8c646c$var$copyStyles(inputStyles, this.placeHolderSizer);
            }
        },
        {
            key: "updateInputWidth",
            value: function updateInputWidth() {
                if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === "undefined") return;
                var newInputWidth = void 0;
                if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
                else newInputWidth = this.sizer.scrollWidth + 2;
                // add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
                var extraWidth = this.props.type === "number" && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
                newInputWidth += extraWidth;
                if (newInputWidth < this.props.minWidth) newInputWidth = this.props.minWidth;
                if (newInputWidth !== this.state.inputWidth) this.setState({
                    inputWidth: newInputWidth
                });
            }
        },
        {
            key: "getInput",
            value: function getInput() {
                return this.input;
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.input.focus();
            }
        },
        {
            key: "blur",
            value: function blur() {
                this.input.blur();
            }
        },
        {
            key: "select",
            value: function select() {
                this.input.select();
            }
        },
        {
            key: "renderStyles",
            value: function renderStyles() {
                // this method injects styles to hide IE's clear indicator, which messes
                // with input size detection. the stylesheet is only injected when the
                // browser is IE, and can also be disabled by the `injectStyles` prop.
                var injectStyles = this.props.injectStyles;
                return $5dda1db15c8c646c$var$isIE && injectStyles ? $5dda1db15c8c646c$var$_react2.default.createElement("style", {
                    dangerouslySetInnerHTML: {
                        __html: "input#" + this.state.inputId + "::-ms-clear {display: none;}"
                    }
                }) : null;
            }
        },
        {
            key: "render",
            value: function render() {
                var sizerValue = [
                    this.props.defaultValue,
                    this.props.value,
                    ""
                ].reduce(function(previousValue, currentValue) {
                    if (previousValue !== null && previousValue !== undefined) return previousValue;
                    return currentValue;
                });
                var wrapperStyle = $5dda1db15c8c646c$var$_extends({}, this.props.style);
                if (!wrapperStyle.display) wrapperStyle.display = "inline-block";
                var inputStyle = $5dda1db15c8c646c$var$_extends({
                    boxSizing: "content-box",
                    width: this.state.inputWidth + "px"
                }, this.props.inputStyle);
                var inputProps = $5dda1db15c8c646c$var$_objectWithoutProperties(this.props, []);
                $5dda1db15c8c646c$var$cleanInputProps(inputProps);
                inputProps.className = this.props.inputClassName;
                inputProps.id = this.state.inputId;
                inputProps.style = inputStyle;
                return $5dda1db15c8c646c$var$_react2.default.createElement("div", {
                    className: this.props.className,
                    style: wrapperStyle
                }, this.renderStyles(), $5dda1db15c8c646c$var$_react2.default.createElement("input", $5dda1db15c8c646c$var$_extends({}, inputProps, {
                    ref: this.inputRef
                })), $5dda1db15c8c646c$var$_react2.default.createElement("div", {
                    ref: this.sizerRef,
                    style: $5dda1db15c8c646c$var$sizerStyle
                }, sizerValue), this.props.placeholder ? $5dda1db15c8c646c$var$_react2.default.createElement("div", {
                    ref: this.placeHolderSizerRef,
                    style: $5dda1db15c8c646c$var$sizerStyle
                }, this.props.placeholder) : null);
            }
        }
    ]);
    return AutosizeInput;
}($acw62.Component);
$5dda1db15c8c646c$var$AutosizeInput.propTypes = {
    className: $5dda1db15c8c646c$var$_propTypes2.default.string,
    defaultValue: $5dda1db15c8c646c$var$_propTypes2.default.any,
    extraWidth: $5dda1db15c8c646c$var$_propTypes2.default.oneOfType([
        $5dda1db15c8c646c$var$_propTypes2.default.number,
        $5dda1db15c8c646c$var$_propTypes2.default.string
    ]),
    id: $5dda1db15c8c646c$var$_propTypes2.default.string,
    injectStyles: $5dda1db15c8c646c$var$_propTypes2.default.bool,
    inputClassName: $5dda1db15c8c646c$var$_propTypes2.default.string,
    inputRef: $5dda1db15c8c646c$var$_propTypes2.default.func,
    inputStyle: $5dda1db15c8c646c$var$_propTypes2.default.object,
    minWidth: $5dda1db15c8c646c$var$_propTypes2.default.oneOfType([
        $5dda1db15c8c646c$var$_propTypes2.default.number,
        $5dda1db15c8c646c$var$_propTypes2.default.string
    ]),
    onAutosize: $5dda1db15c8c646c$var$_propTypes2.default.func,
    onChange: $5dda1db15c8c646c$var$_propTypes2.default.func,
    placeholder: $5dda1db15c8c646c$var$_propTypes2.default.string,
    placeholderIsMinWidth: $5dda1db15c8c646c$var$_propTypes2.default.bool,
    style: $5dda1db15c8c646c$var$_propTypes2.default.object,
    value: $5dda1db15c8c646c$var$_propTypes2.default.any // field value
};
$5dda1db15c8c646c$var$AutosizeInput.defaultProps = {
    minWidth: 1,
    injectStyles: true
};
$5dda1db15c8c646c$exports.default = $5dda1db15c8c646c$var$AutosizeInput;



var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");

var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $07378f5e4d664a8b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $07378f5e4d664a8b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $07378f5e4d664a8b$export$407448d2b89b1813(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $07378f5e4d664a8b$var$ownKeys(Object(source), true).forEach(function(key) {
            $07378f5e4d664a8b$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $07378f5e4d664a8b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $07378f5e4d664a8b$var$_getPrototypeOf(o) {
    $07378f5e4d664a8b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $07378f5e4d664a8b$var$_getPrototypeOf(o);
}
function $07378f5e4d664a8b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $07378f5e4d664a8b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $07378f5e4d664a8b$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return $07378f5e4d664a8b$var$_assertThisInitialized(self);
}
function $07378f5e4d664a8b$export$71511d61b312f219(Derived) {
    var hasNativeReflectConstruct = $07378f5e4d664a8b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $07378f5e4d664a8b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $07378f5e4d664a8b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $07378f5e4d664a8b$var$_possibleConstructorReturn(this, result);
    };
}
// ==============================
// NO OP
// ==============================
var $07378f5e4d664a8b$export$2329c99376c9d0a4 = function noop() {};
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $07378f5e4d664a8b$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $07378f5e4d664a8b$export$ef35774e6d314e91(prefix, state, className) {
    var arr = [
        className
    ];
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($07378f5e4d664a8b$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
} // ==============================
// Clean Value
// ==============================
var $07378f5e4d664a8b$export$a9c23c6ac3fc3eca = function cleanValue(value) {
    if (Array.isArray(value)) return value.filter(Boolean);
    if ((0, $fSwVM.default)(value) === "object" && value !== null) return [
        value
    ];
    return [];
}; // ==============================
// Clean Common Props
// ==============================
var $07378f5e4d664a8b$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $9X7IJ.default)(props, [
        "className",
        "clearValue",
        "cx",
        "getStyles",
        "getValue",
        "hasValue",
        "isMulti",
        "isRtl",
        "options",
        "selectOption",
        "selectProps",
        "setValue",
        "theme"
    ]);
    return $07378f5e4d664a8b$export$407448d2b89b1813({}, innerProps);
}; // ==============================
// Handle Input Change
// ==============================
function $07378f5e4d664a8b$export$7f8ddf7c7c20b3cd(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === "string") return newValue;
    }
    return inputValue;
} // ==============================
// Scroll Helpers
// ==============================
function $07378f5e4d664a8b$export$96f57966bedc81b4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------
function $07378f5e4d664a8b$var$getScrollTop(el) {
    if ($07378f5e4d664a8b$export$96f57966bedc81b4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $07378f5e4d664a8b$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($07378f5e4d664a8b$export$96f57966bedc81b4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------
function $07378f5e4d664a8b$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    var docEl = document.documentElement; // suck it, flow...
    if (style.position === "fixed") return docEl;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return docEl;
} // Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $07378f5e4d664a8b$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $07378f5e4d664a8b$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $07378f5e4d664a8b$export$2329c99376c9d0a4;
    var start = $07378f5e4d664a8b$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $07378f5e4d664a8b$var$easeOutCubic(currentTime, start, change, duration);
        $07378f5e4d664a8b$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
} // Scroll Into View
// ------------------------------
function $07378f5e4d664a8b$export$d66501df72047452(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $07378f5e4d664a8b$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $07378f5e4d664a8b$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $07378f5e4d664a8b$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// Touch Capability Detector
// ==============================
function $07378f5e4d664a8b$export$df995fae86a55f06() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
} // ==============================
// Mobile Device Detector
// ==============================
function $07378f5e4d664a8b$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
} // ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $07378f5e4d664a8b$var$passiveOptionAccessed = false;
var $07378f5e4d664a8b$var$options = {
    get passive () {
        return $07378f5e4d664a8b$var$passiveOptionAccessed = true;
    }
}; // check for SSR
var $07378f5e4d664a8b$var$w = typeof window !== "undefined" ? window : {};
if ($07378f5e4d664a8b$var$w.addEventListener && $07378f5e4d664a8b$var$w.removeEventListener) {
    $07378f5e4d664a8b$var$w.addEventListener("p", $07378f5e4d664a8b$export$2329c99376c9d0a4, $07378f5e4d664a8b$var$options);
    $07378f5e4d664a8b$var$w.removeEventListener("p", $07378f5e4d664a8b$export$2329c99376c9d0a4, false);
}
var $07378f5e4d664a8b$export$2408f22a0fab9ae5 = $07378f5e4d664a8b$var$passiveOptionAccessed;
function $07378f5e4d664a8b$var$getMenuPlacement(_ref) {
    var maxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, placement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, theme = _ref.theme;
    var spacing = theme.spacing;
    var scrollParent = $07378f5e4d664a8b$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: maxHeight
    }; // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = window.innerHeight;
    var scrollTop = $07378f5e4d664a8b$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(placement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: maxHeight
            };
             // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $07378f5e4d664a8b$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: maxHeight
                };
            } // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $07378f5e4d664a8b$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                 // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            } // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (placement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = maxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            } // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (placement === "bottom") {
                if (shouldScroll) $07378f5e4d664a8b$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: maxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: maxHeight
            };
             // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $07378f5e4d664a8b$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: maxHeight
                };
            } // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $07378f5e4d664a8b$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            } // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: maxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(placement, '".'));
    } // fulfil contract with flow: implicit return value of undefined
    return defaultState;
} // Menu Component
// ------------------------------
function $07378f5e4d664a8b$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var $07378f5e4d664a8b$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $07378f5e4d664a8b$export$7ccc53e8f1e7dfc5 = function menuCSS(_ref2) {
    var _ref3;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return _ref3 = {
        label: "menu"
    }, (0, $kSlfw.default)(_ref3, $07378f5e4d664a8b$var$alignToControl(placement), "100%"), (0, $kSlfw.default)(_ref3, "backgroundColor", colors.neutral0), (0, $kSlfw.default)(_ref3, "borderRadius", borderRadius), (0, $kSlfw.default)(_ref3, "boxShadow", "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)"), (0, $kSlfw.default)(_ref3, "marginBottom", spacing.menuGutter), (0, $kSlfw.default)(_ref3, "marginTop", spacing.menuGutter), (0, $kSlfw.default)(_ref3, "position", "absolute"), (0, $kSlfw.default)(_ref3, "width", "100%"), (0, $kSlfw.default)(_ref3, "zIndex", 1), _ref3;
};
var $07378f5e4d664a8b$var$PortalPlacementContext = /*#__PURE__*/ (0, $acw62.createContext)({
    getPortalPlacement: null
}); // NOTE: internal only
var $07378f5e4d664a8b$export$3a1a48c8f6ef640e = /*#__PURE__*/ function(_Component) {
    (0, $1gYAD.default)(MenuPlacer, _Component);
    var _super = $07378f5e4d664a8b$export$71511d61b312f219(MenuPlacer);
    function MenuPlacer() {
        var _this;
        (0, $6CZeq.default)(this, MenuPlacer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            maxHeight: _this.props.maxMenuHeight,
            placement: null
        };
        _this.getPlacement = function(ref) {
            var _this$props = _this.props, minMenuHeight = _this$props.minMenuHeight, maxMenuHeight = _this$props.maxMenuHeight, menuPlacement = _this$props.menuPlacement, menuPosition = _this$props.menuPosition, menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView, theme = _this$props.theme;
            if (!ref) return; // DO NOT scroll if position is fixed
            var isFixedPosition = menuPosition === "fixed";
            var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
            var state = $07378f5e4d664a8b$var$getMenuPlacement({
                maxHeight: maxMenuHeight,
                menuEl: ref,
                minHeight: minMenuHeight,
                placement: menuPlacement,
                shouldScroll: shouldScroll,
                isFixedPosition: isFixedPosition,
                theme: theme
            });
            var getPortalPlacement = _this.context.getPortalPlacement;
            if (getPortalPlacement) getPortalPlacement(state);
            _this.setState(state);
        };
        _this.getUpdatedProps = function() {
            var menuPlacement = _this.props.menuPlacement;
            var placement = _this.state.placement || $07378f5e4d664a8b$var$coercePlacement(menuPlacement);
            return $07378f5e4d664a8b$export$407448d2b89b1813($07378f5e4d664a8b$export$407448d2b89b1813({}, _this.props), {}, {
                placement: placement,
                maxHeight: _this.state.maxHeight
            });
        };
        return _this;
    }
    (0, $cHPF9.default)(MenuPlacer, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children({
                    ref: this.getPlacement,
                    placerProps: this.getUpdatedProps()
                });
            }
        }
    ]);
    return MenuPlacer;
}((0, $acw62.Component));
$07378f5e4d664a8b$export$3a1a48c8f6ef640e.contextType = $07378f5e4d664a8b$var$PortalPlacementContext;
var $07378f5e4d664a8b$var$Menu = function Menu(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles("menu", props),
        className: cx({
            menu: true
        }, className),
        ref: innerRef
    }, innerProps), children);
};
// Menu List
// ==============================
var $07378f5e4d664a8b$export$ae1af26003f05816 = function menuListCSS(_ref4) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return {
        maxHeight: maxHeight,
        overflowY: "auto",
        paddingBottom: baseUnit,
        paddingTop: baseUnit,
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    };
};
var $07378f5e4d664a8b$var$MenuList = function MenuList(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles("menuList", props),
        className: cx({
            "menu-list": true,
            "menu-list--is-multi": isMulti
        }, className),
        ref: innerRef
    }, innerProps), children);
}; // ==============================
// Menu Notices
// ==============================
var $07378f5e4d664a8b$var$noticeCSS = function noticeCSS(_ref5) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
        textAlign: "center"
    };
};
var $07378f5e4d664a8b$export$3b14a55fb2447963 = $07378f5e4d664a8b$var$noticeCSS;
var $07378f5e4d664a8b$export$953cecd6e717a553 = $07378f5e4d664a8b$var$noticeCSS;
var $07378f5e4d664a8b$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles("noOptionsMessage", props),
        className: cx({
            "menu-notice": true,
            "menu-notice--no-options": true
        }, className)
    }, innerProps), children);
};
$07378f5e4d664a8b$var$NoOptionsMessage.defaultProps = {
    children: "No options"
};
var $07378f5e4d664a8b$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles("loadingMessage", props),
        className: cx({
            "menu-notice": true,
            "menu-notice--loading": true
        }, className)
    }, innerProps), children);
};
$07378f5e4d664a8b$var$LoadingMessage.defaultProps = {
    children: "Loading..."
}; // ==============================
// Menu Portal
// ==============================
var $07378f5e4d664a8b$export$ffb5f4729a158638 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $07378f5e4d664a8b$var$MenuPortal = /*#__PURE__*/ function(_Component2) {
    (0, $1gYAD.default)(MenuPortal, _Component2);
    var _super2 = $07378f5e4d664a8b$export$71511d61b312f219(MenuPortal);
    function MenuPortal() {
        var _this2;
        (0, $6CZeq.default)(this, MenuPortal);
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        _this2.state = {
            placement: null
        };
        _this2.getPortalPlacement = function(_ref7) {
            var placement = _ref7.placement;
            var initialPlacement = $07378f5e4d664a8b$var$coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed
            if (placement !== initialPlacement) _this2.setState({
                placement: placement
            });
        };
        return _this2;
    }
    (0, $cHPF9.default)(MenuPortal, [
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, appendTo = _this$props2.appendTo, children = _this$props2.children, className = _this$props2.className, controlElement = _this$props2.controlElement, cx = _this$props2.cx, innerProps = _this$props2.innerProps, menuPlacement = _this$props2.menuPlacement, position = _this$props2.menuPosition, getStyles = _this$props2.getStyles;
                var isFixed = position === "fixed"; // bail early if required elements aren't present
                if (!appendTo && !isFixed || !controlElement) return null;
                var placement = this.state.placement || $07378f5e4d664a8b$var$coercePlacement(menuPlacement);
                var rect = $07378f5e4d664a8b$var$getBoundingClientObj(controlElement);
                var scrollDistance = isFixed ? 0 : window.pageYOffset;
                var offset = rect[placement] + scrollDistance;
                var state = {
                    offset: offset,
                    position: position,
                    rect: rect
                }; // same wrapper element whether fixed or portalled
                var menuWrapper = (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
                    css: getStyles("menuPortal", state),
                    className: cx({
                        "menu-portal": true
                    }, className)
                }, innerProps), children);
                return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($07378f5e4d664a8b$var$PortalPlacementContext.Provider, {
                    value: {
                        getPortalPlacement: this.getPortalPlacement
                    }
                }, appendTo ? /*#__PURE__*/ (0, $1u0KT.createPortal)(menuWrapper, appendTo) : menuWrapper);
            }
        }
    ]);
    return MenuPortal;
}((0, $acw62.Component));
var $07378f5e4d664a8b$export$4368d992c4eafac0 = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : null,
        pointerEvents: isDisabled ? "none" : null,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var $07378f5e4d664a8b$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles("container", props),
        className: cx({
            "--is-disabled": isDisabled,
            "--is-rtl": isRtl
        }, className)
    }, innerProps), children);
}; // ==============================
// Value Container
// ==============================
var $07378f5e4d664a8b$export$4a5767248b18ef41 = function valueContainerCSS(_ref2) {
    var spacing = _ref2.theme.spacing;
    return {
        alignItems: "center",
        display: "flex",
        flex: 1,
        flexWrap: "wrap",
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    };
};
var $07378f5e4d664a8b$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, className = props.className, cx = props.cx, innerProps = props.innerProps, isMulti = props.isMulti, getStyles = props.getStyles, hasValue = props.hasValue;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles("valueContainer", props),
        className: cx({
            "value-container": true,
            "value-container--is-multi": isMulti,
            "value-container--has-value": hasValue
        }, className)
    }, innerProps), children);
}; // ==============================
// Indicator Container
// ==============================
var $07378f5e4d664a8b$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var $07378f5e4d664a8b$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, className = props.className, cx = props.cx, innerProps = props.innerProps, getStyles = props.getStyles;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles("indicatorsContainer", props),
        className: cx({
            indicators: true
        }, className)
    }, innerProps), children);
};
var $07378f5e4d664a8b$var$_templateObject;
function $07378f5e4d664a8b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $07378f5e4d664a8b$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
// ==============================
// Dropdown & Clear Icons
// ==============================
var $07378f5e4d664a8b$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $9X7IJ.default)(_ref, [
        "size"
    ]);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("svg", (0, $8nd05.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $07378f5e4d664a8b$var$_ref2
    }, props));
};
var $07378f5e4d664a8b$var$CrossIcon = function CrossIcon(props) {
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($07378f5e4d664a8b$var$Svg, (0, $8nd05.default)({
        size: 20
    }, props), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $07378f5e4d664a8b$var$DownChevron = function DownChevron(props) {
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($07378f5e4d664a8b$var$Svg, (0, $8nd05.default)({
        size: 20
    }, props), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================
var $07378f5e4d664a8b$var$baseCSS = function baseCSS(_ref3) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return {
        label: "indicatorContainer",
        color: isFocused ? colors.neutral60 : colors.neutral20,
        display: "flex",
        padding: baseUnit * 2,
        transition: "color 150ms",
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    };
};
var $07378f5e4d664a8b$export$2d1720544b23b823 = $07378f5e4d664a8b$var$baseCSS;
var $07378f5e4d664a8b$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles("dropdownIndicator", props),
        className: cx({
            indicator: true,
            "dropdown-indicator": true
        }, className)
    }, innerProps), children || (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($07378f5e4d664a8b$var$DownChevron, null));
};
var $07378f5e4d664a8b$export$8b22cf2602fb60ce = $07378f5e4d664a8b$var$baseCSS;
var $07378f5e4d664a8b$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles("clearIndicator", props),
        className: cx({
            indicator: true,
            "clear-indicator": true
        }, className)
    }, innerProps), children || (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($07378f5e4d664a8b$var$CrossIcon, null));
}; // ==============================
// Separator
// ==============================
var $07378f5e4d664a8b$export$35e795649ee09318 = function indicatorSeparatorCSS(_ref4) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return {
        label: "indicatorSeparator",
        alignSelf: "stretch",
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2,
        width: 1
    };
};
var $07378f5e4d664a8b$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", (0, $8nd05.default)({}, innerProps, {
        css: getStyles("indicatorSeparator", props),
        className: cx({
            "indicator-separator": true
        }, className)
    }));
}; // ==============================
// Loading
// ==============================
var $07378f5e4d664a8b$var$loadingDotAnimations = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)($07378f5e4d664a8b$var$_templateObject || ($07378f5e4d664a8b$var$_templateObject = (0, $cbe7edbf3ccb8828$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $07378f5e4d664a8b$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return {
        label: "loadingIndicator",
        color: isFocused ? colors.neutral60 : colors.neutral20,
        display: "flex",
        padding: baseUnit * 2,
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    };
};
var $07378f5e4d664a8b$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        css: /*#__PURE__*/ (0, $63d46a01db878c10$export$dbf350e5966cf602)({
            animation: "".concat($07378f5e4d664a8b$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : null,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, "", "")
    });
};
var $07378f5e4d664a8b$var$LoadingIndicator = function LoadingIndicator(props) {
    var className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles("loadingIndicator", props),
        className: cx({
            indicator: true,
            "loading-indicator": true
        }, className)
    }, innerProps), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($07378f5e4d664a8b$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($07378f5e4d664a8b$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($07378f5e4d664a8b$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$07378f5e4d664a8b$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $07378f5e4d664a8b$export$f1e1789686576879 = function css(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return {
        label: "control",
        alignItems: "center",
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms",
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    };
};
var $07378f5e4d664a8b$var$Control = function Control(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, className = props.className, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        ref: innerRef,
        css: getStyles("control", props),
        className: cx({
            control: true,
            "control--is-disabled": isDisabled,
            "control--is-focused": isFocused,
            "control--menu-is-open": menuIsOpen
        }, className)
    }, innerProps), children);
};
var $07378f5e4d664a8b$export$39b482c5e57630a8 = function groupCSS(_ref) {
    var spacing = _ref.theme.spacing;
    return {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $07378f5e4d664a8b$var$Group = function Group(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles("group", props),
        className: cx({
            group: true
        }, className)
    }, innerProps), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Heading, (0, $8nd05.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        cx: cx
    }), label), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", null, children));
};
var $07378f5e4d664a8b$export$dda1d9f60106f0e9 = function groupHeadingCSS(_ref2) {
    var spacing = _ref2.theme.spacing;
    return {
        label: "group",
        color: "#999",
        cursor: "default",
        display: "block",
        fontSize: "75%",
        fontWeight: "500",
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    };
};
var $07378f5e4d664a8b$var$GroupHeading = function GroupHeading(props) {
    var getStyles = props.getStyles, cx = props.cx, className = props.className;
    var _cleanCommonProps = $07378f5e4d664a8b$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $9X7IJ.default)(_cleanCommonProps, [
        "data"
    ]);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles("groupHeading", props),
        className: cx({
            "group-heading": true
        }, className)
    }, innerProps));
};
var $07378f5e4d664a8b$export$342063e11d6c3cad = function inputCSS(_ref) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        visibility: isDisabled ? "hidden" : "visible",
        color: colors.neutral80
    };
};
var $07378f5e4d664a8b$var$inputStyle = function inputStyle(isHidden) {
    return {
        label: "input",
        background: 0,
        border: 0,
        fontSize: "inherit",
        opacity: isHidden ? 0 : 1,
        outline: 0,
        padding: 0,
        color: "inherit"
    };
};
var $07378f5e4d664a8b$var$Input = function Input(props) {
    var className = props.className, cx = props.cx, getStyles = props.getStyles;
    var _cleanCommonProps = $07378f5e4d664a8b$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, innerProps = (0, $9X7IJ.default)(_cleanCommonProps, [
        "innerRef",
        "isDisabled",
        "isHidden"
    ]);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", {
        css: getStyles("input", props)
    }, (0, $63d46a01db878c10$export$c8a8987d4410bf2d)((0, (/*@__PURE__*/$parcel$interopDefault($5dda1db15c8c646c$exports))), (0, $8nd05.default)({
        className: cx({
            input: true
        }, className),
        inputRef: innerRef,
        inputStyle: $07378f5e4d664a8b$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $07378f5e4d664a8b$export$9e5f44173e64f162 = function multiValueCSS(_ref) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return {
        label: "multiValue",
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        display: "flex",
        margin: spacing.baseUnit / 2,
        minWidth: 0 // resolves flex/text-overflow bug
    };
};
var $07378f5e4d664a8b$export$43caf9889c228507 = function multiValueLabelCSS(_ref2) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        overflow: "hidden",
        padding: 3,
        paddingLeft: 6,
        textOverflow: cropWithEllipsis ? "ellipsis" : null,
        whiteSpace: "nowrap"
    };
};
var $07378f5e4d664a8b$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return {
        alignItems: "center",
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused && colors.dangerLight,
        display: "flex",
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    };
};
var $07378f5e4d664a8b$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", innerProps, children);
};
var $07378f5e4d664a8b$var$MultiValueContainer = $07378f5e4d664a8b$var$MultiValueGeneric;
var $07378f5e4d664a8b$var$MultiValueLabel = $07378f5e4d664a8b$var$MultiValueGeneric;
function $07378f5e4d664a8b$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", innerProps, children || (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($07378f5e4d664a8b$var$CrossIcon, {
        size: 14
    }));
}
var $07378f5e4d664a8b$var$MultiValue = function MultiValue(props) {
    var children = props.children, className = props.className, components = props.components, cx = props.cx, data = props.data, getStyles = props.getStyles, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)((0, $63d46a01db878c10$export$9b9c0f9d9f3552b8), null, function(_ref6) {
        var css = _ref6.css, emotionCx = _ref6.cx;
        return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Container, {
            data: data,
            innerProps: $07378f5e4d664a8b$export$407448d2b89b1813({
                className: emotionCx(css(getStyles("multiValue", props)), cx({
                    "multi-value": true,
                    "multi-value--is-disabled": isDisabled
                }, className))
            }, innerProps),
            selectProps: selectProps
        }, (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Label, {
            data: data,
            innerProps: {
                className: emotionCx(css(getStyles("multiValueLabel", props)), cx({
                    "multi-value__label": true
                }, className))
            },
            selectProps: selectProps
        }, children), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Remove, {
            data: data,
            innerProps: $07378f5e4d664a8b$export$407448d2b89b1813({
                className: emotionCx(css(getStyles("multiValueRemove", props)), cx({
                    "multi-value__remove": true
                }, className))
            }, removeProps),
            selectProps: selectProps
        }));
    });
};
$07378f5e4d664a8b$var$MultiValue.defaultProps = {
    cropWithEllipsis: true
};
var $07378f5e4d664a8b$export$90a7f3efeed30595 = function optionCSS(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        label: "option",
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
        }
    };
};
var $07378f5e4d664a8b$var$Option = function Option(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles("option", props),
        className: cx({
            option: true,
            "option--is-disabled": isDisabled,
            "option--is-focused": isFocused,
            "option--is-selected": isSelected
        }, className),
        ref: innerRef
    }, innerProps), children);
};
var $07378f5e4d664a8b$export$efccba1c4a2ef57b = function placeholderCSS(_ref) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        label: "placeholder",
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2,
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)"
    };
};
var $07378f5e4d664a8b$var$Placeholder = function Placeholder(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles("placeholder", props),
        className: cx({
            placeholder: true
        }, className)
    }, innerProps), children);
};
var $07378f5e4d664a8b$export$d141bba7fdc215a3 = function css(_ref) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        label: "singleValue",
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2,
        maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
        overflow: "hidden",
        position: "absolute",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        top: "50%",
        transform: "translateY(-50%)"
    };
};
var $07378f5e4d664a8b$var$SingleValue = function SingleValue(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles("singleValue", props),
        className: cx({
            "single-value": true,
            "single-value--is-disabled": isDisabled
        }, className)
    }, innerProps), children);
};
var $07378f5e4d664a8b$export$db3b6bfb95261072 = {
    ClearIndicator: $07378f5e4d664a8b$var$ClearIndicator,
    Control: $07378f5e4d664a8b$var$Control,
    DropdownIndicator: $07378f5e4d664a8b$var$DropdownIndicator,
    DownChevron: $07378f5e4d664a8b$var$DownChevron,
    CrossIcon: $07378f5e4d664a8b$var$CrossIcon,
    Group: $07378f5e4d664a8b$var$Group,
    GroupHeading: $07378f5e4d664a8b$var$GroupHeading,
    IndicatorsContainer: $07378f5e4d664a8b$var$IndicatorsContainer,
    IndicatorSeparator: $07378f5e4d664a8b$var$IndicatorSeparator,
    Input: $07378f5e4d664a8b$var$Input,
    LoadingIndicator: $07378f5e4d664a8b$var$LoadingIndicator,
    Menu: $07378f5e4d664a8b$var$Menu,
    MenuList: $07378f5e4d664a8b$var$MenuList,
    MenuPortal: $07378f5e4d664a8b$var$MenuPortal,
    LoadingMessage: $07378f5e4d664a8b$var$LoadingMessage,
    NoOptionsMessage: $07378f5e4d664a8b$var$NoOptionsMessage,
    MultiValue: $07378f5e4d664a8b$var$MultiValue,
    MultiValueContainer: $07378f5e4d664a8b$var$MultiValueContainer,
    MultiValueLabel: $07378f5e4d664a8b$var$MultiValueLabel,
    MultiValueRemove: $07378f5e4d664a8b$var$MultiValueRemove,
    Option: $07378f5e4d664a8b$var$Option,
    Placeholder: $07378f5e4d664a8b$var$Placeholder,
    SelectContainer: $07378f5e4d664a8b$var$SelectContainer,
    SingleValue: $07378f5e4d664a8b$var$SingleValue,
    ValueContainer: $07378f5e4d664a8b$var$ValueContainer
};
var $07378f5e4d664a8b$export$e7094788287c5e9b = function defaultComponents(props) {
    return $07378f5e4d664a8b$export$407448d2b89b1813($07378f5e4d664a8b$export$407448d2b89b1813({}, $07378f5e4d664a8b$export$db3b6bfb95261072), props.components);
};


var $8nd05 = parcelRequire("8nd05");


var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");

var $kbxxf = parcelRequire("kbxxf");

var $acw62 = parcelRequire("acw62");

var $e111773323c0bcc0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $e111773323c0bcc0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e111773323c0bcc0$var$safeIsNaN(first) && $e111773323c0bcc0$var$safeIsNaN(second)) return true;
    return false;
}
function $e111773323c0bcc0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e111773323c0bcc0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e111773323c0bcc0$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e111773323c0bcc0$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $e111773323c0bcc0$export$2e2bcd8739ae039 = $e111773323c0bcc0$var$memoizeOne;



var $9X7IJ = parcelRequire("9X7IJ");
function $0c1496466ef568ed$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $0c1496466ef568ed$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $0c1496466ef568ed$var$A11yText = function A11yText(props) {
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", (0, $8nd05.default)({
        css: $0c1496466ef568ed$var$_ref
    }, props));
};
var $0c1496466ef568ed$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case "menu":
                return "Use Up and Down to choose options".concat(isDisabled ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
            case "input":
                return "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "");
            case "value":
                return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
            default:
                return "";
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return "option ".concat(label, ", deselected.");
            case "select-option":
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return "";
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, _props$focused = props.focused, focused = _props$focused === void 0 ? {} : _props$focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
        };
        if (context === "value" && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === "menu") {
            var disabled = isDisabled ? " disabled" : "";
            var status = "".concat(isSelected ? "selected" : "focused").concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return "";
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
    }
};
var $0c1496466ef568ed$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps["aria-label"];
    var ariaLive = selectProps["aria-live"]; // Update aria live message configuration when prop changes
    var messages = (0, $acw62.useMemo)(function() {
        return (0, $07378f5e4d664a8b$export$407448d2b89b1813)((0, $07378f5e4d664a8b$export$407448d2b89b1813)({}, $0c1496466ef568ed$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]); // Update aria live selected option when prop changes
    var ariaSelected = (0, $acw62.useMemo)(function() {
        var message = "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, removedValue = ariaSelection.removedValue, value = ariaSelection.value; // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            var selected = removedValue || option || asOption(value);
            var onChangeProps = (0, $07378f5e4d664a8b$export$407448d2b89b1813)({
                isDisabled: selected && isOptionDisabled(selected),
                label: selected ? getOptionLabel(selected) : ""
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        isOptionDisabled,
        getOptionLabel,
        messages
    ]);
    var ariaFocused = (0, $acw62.useMemo)(function() {
        var focusMsg = "";
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused),
                isSelected: isSelected,
                options: options,
                context: focused === focusedOption ? "menu" : "value",
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        options,
        selectValue
    ]);
    var ariaResults = (0, $acw62.useMemo)(function() {
        var resultsMsg = "";
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $acw62.useMemo)(function() {
        var guidanceMsg = "";
        if (messages.guidance) {
            var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
            guidanceMsg = messages.guidance({
                "aria-label": ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($0c1496466ef568ed$var$A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && (0, $63d46a01db878c10$export$c8a8987d4410bf2d)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        id: "aria-context"
    }, ariaContext)));
};
var $0c1496466ef568ed$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $0c1496466ef568ed$var$anyDiacritic = new RegExp("[" + $0c1496466ef568ed$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $0c1496466ef568ed$var$diacriticToBase = {};
for(var $0c1496466ef568ed$var$i = 0; $0c1496466ef568ed$var$i < $0c1496466ef568ed$var$diacritics.length; $0c1496466ef568ed$var$i++){
    var $0c1496466ef568ed$var$diacritic = $0c1496466ef568ed$var$diacritics[$0c1496466ef568ed$var$i];
    for(var $0c1496466ef568ed$var$j = 0; $0c1496466ef568ed$var$j < $0c1496466ef568ed$var$diacritic.letters.length; $0c1496466ef568ed$var$j++)$0c1496466ef568ed$var$diacriticToBase[$0c1496466ef568ed$var$diacritic.letters[$0c1496466ef568ed$var$j]] = $0c1496466ef568ed$var$diacritic.base;
}
var $0c1496466ef568ed$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($0c1496466ef568ed$var$anyDiacritic, function(match) {
        return $0c1496466ef568ed$var$diacriticToBase[match];
    });
};
var $0c1496466ef568ed$var$memoizedStripDiacriticsForInput = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)($0c1496466ef568ed$var$stripDiacritics);
var $0c1496466ef568ed$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $0c1496466ef568ed$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $0c1496466ef568ed$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        var _ignoreCase$ignoreAcc = (0, $07378f5e4d664a8b$export$407448d2b89b1813)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $0c1496466ef568ed$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $0c1496466ef568ed$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $0c1496466ef568ed$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $0c1496466ef568ed$var$memoizedStripDiacriticsForInput(input);
            candidate = $0c1496466ef568ed$var$stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
function $0c1496466ef568ed$var$DummyInput(_ref) {
    _ref.in;
    _ref.out;
    _ref.onExited;
    _ref.appear;
    _ref.enter;
    _ref.exit;
    var innerRef = _ref.innerRef;
    _ref.emotion;
    var props = (0, $9X7IJ.default)(_ref, [
        "in",
        "out",
        "onExited",
        "appear",
        "enter",
        "exit",
        "innerRef",
        "emotion"
    ]);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("input", (0, $8nd05.default)({
        ref: innerRef
    }, props, {
        css: /*#__PURE__*/ (0, $63d46a01db878c10$export$dbf350e5966cf602)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            fontSize: "inherit",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(0)"
        }, "", "")
    }));
}
var $0c1496466ef568ed$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $0c1496466ef568ed$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $acw62.useRef)(false);
    var isTop = (0, $acw62.useRef)(false);
    var touchStart = (0, $acw62.useRef)(0);
    var scrollTarget = (0, $acw62.useRef)(null);
    var handleEventDelta = (0, $acw62.useCallback)(function(event, delta) {
        // Reference should never be `null` at this point, but flow complains otherwise
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false; // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        } // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true; // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        } // cancel scroll
        if (shouldCancelScroll) $0c1496466ef568ed$var$cancelScroll(event);
    }, []);
    var onWheel = (0, $acw62.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $acw62.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $acw62.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $07378f5e4d664a8b$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false; // all the if statements are to appease Flow 😢
        if (typeof el.addEventListener === "function") el.addEventListener("wheel", onWheel, notPassive);
        if (typeof el.addEventListener === "function") el.addEventListener("touchstart", onTouchStart, notPassive);
        if (typeof el.addEventListener === "function") el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return; // all the if statements are to appease Flow 😢
        if (typeof el.removeEventListener === "function") el.removeEventListener("wheel", onWheel, false);
        if (typeof el.removeEventListener === "function") el.removeEventListener("touchstart", onTouchStart, false);
        if (typeof el.removeEventListener === "function") el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $0c1496466ef568ed$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $0c1496466ef568ed$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $0c1496466ef568ed$var$preventTouchMove(e) {
    e.preventDefault();
}
function $0c1496466ef568ed$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $0c1496466ef568ed$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $0c1496466ef568ed$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $0c1496466ef568ed$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $0c1496466ef568ed$var$activeScrollLocks = 0;
var $0c1496466ef568ed$var$listenerOptions = {
    capture: false,
    passive: false
};
function $0c1496466ef568ed$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $acw62.useRef)({});
    var scrollTarget = (0, $acw62.useRef)(null);
    var addScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$0c1496466ef568ed$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $0c1496466ef568ed$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
         // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $0c1496466ef568ed$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($0c1496466ef568ed$var$LOCK_STYLES).forEach(function(key) {
                var val = $0c1496466ef568ed$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        } // account for touch devices
        if (target && $0c1496466ef568ed$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener("touchmove", $0c1496466ef568ed$var$preventTouchMove, $0c1496466ef568ed$var$listenerOptions); // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener("touchstart", $0c1496466ef568ed$var$preventInertiaScroll, $0c1496466ef568ed$var$listenerOptions);
                touchScrollTarget.addEventListener("touchmove", $0c1496466ef568ed$var$allowTouchMove, $0c1496466ef568ed$var$listenerOptions);
            }
        } // increment active scroll locks
        $0c1496466ef568ed$var$activeScrollLocks += 1;
    }, []);
    var removeScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$0c1496466ef568ed$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style; // safely decrement active scroll locks
        $0c1496466ef568ed$var$activeScrollLocks = Math.max($0c1496466ef568ed$var$activeScrollLocks - 1, 0); // reapply original body styles, if any
        if (accountForScrollbars && $0c1496466ef568ed$var$activeScrollLocks < 1) $0c1496466ef568ed$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
         // remove touch listeners
        if (target && $0c1496466ef568ed$var$isTouchDevice()) {
            target.removeEventListener("touchmove", $0c1496466ef568ed$var$preventTouchMove, $0c1496466ef568ed$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener("touchstart", $0c1496466ef568ed$var$preventInertiaScroll, $0c1496466ef568ed$var$listenerOptions);
                touchScrollTarget.removeEventListener("touchmove", $0c1496466ef568ed$var$allowTouchMove, $0c1496466ef568ed$var$listenerOptions);
            }
        }
    }, []);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $0c1496466ef568ed$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $0c1496466ef568ed$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $0c1496466ef568ed$var$_ref2 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $0c1496466ef568ed$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $0c1496466ef568ed$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $0c1496466ef568ed$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, lockEnabled && (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", {
        onClick: $0c1496466ef568ed$var$blurSelectInput,
        css: $0c1496466ef568ed$var$_ref2
    }), children(targetRef));
}
var $0c1496466ef568ed$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $0c1496466ef568ed$export$407448d2b89b1813 = function getOptionLabel(option) {
    return option.label;
};
var $0c1496466ef568ed$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $0c1496466ef568ed$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $0c1496466ef568ed$var$defaultStyles = {
    clearIndicator: (0, $07378f5e4d664a8b$export$8b22cf2602fb60ce),
    container: (0, $07378f5e4d664a8b$export$4368d992c4eafac0),
    control: (0, $07378f5e4d664a8b$export$f1e1789686576879),
    dropdownIndicator: (0, $07378f5e4d664a8b$export$2d1720544b23b823),
    group: (0, $07378f5e4d664a8b$export$39b482c5e57630a8),
    groupHeading: (0, $07378f5e4d664a8b$export$dda1d9f60106f0e9),
    indicatorsContainer: (0, $07378f5e4d664a8b$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $07378f5e4d664a8b$export$35e795649ee09318),
    input: (0, $07378f5e4d664a8b$export$342063e11d6c3cad),
    loadingIndicator: (0, $07378f5e4d664a8b$export$882b5998b3b9117c),
    loadingMessage: (0, $07378f5e4d664a8b$export$953cecd6e717a553),
    menu: (0, $07378f5e4d664a8b$export$7ccc53e8f1e7dfc5),
    menuList: (0, $07378f5e4d664a8b$export$ae1af26003f05816),
    menuPortal: (0, $07378f5e4d664a8b$export$ffb5f4729a158638),
    multiValue: (0, $07378f5e4d664a8b$export$9e5f44173e64f162),
    multiValueLabel: (0, $07378f5e4d664a8b$export$43caf9889c228507),
    multiValueRemove: (0, $07378f5e4d664a8b$export$625550452a3fa3ec),
    noOptionsMessage: (0, $07378f5e4d664a8b$export$3b14a55fb2447963),
    option: (0, $07378f5e4d664a8b$export$90a7f3efeed30595),
    placeholder: (0, $07378f5e4d664a8b$export$efccba1c4a2ef57b),
    singleValue: (0, $07378f5e4d664a8b$export$d141bba7fdc215a3),
    valueContainer: (0, $07378f5e4d664a8b$export$4a5767248b18ef41)
}; // Merge Utility
// Allows consumers to extend a base Select with additional styles
function $0c1496466ef568ed$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $07378f5e4d664a8b$export$407448d2b89b1813)({}, source); // massage in target styles
    Object.keys(target).forEach(function(key) {
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $0c1496466ef568ed$var$colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var $0c1496466ef568ed$var$borderRadius = 4; // Used to calculate consistent margin/padding on elements
var $0c1496466ef568ed$var$baseUnit = 4; // The minimum height of the control
var $0c1496466ef568ed$var$controlHeight = 38; // The amount of space between the control and menu */
var $0c1496466ef568ed$var$menuGutter = $0c1496466ef568ed$var$baseUnit * 2;
var $0c1496466ef568ed$var$spacing = {
    baseUnit: $0c1496466ef568ed$var$baseUnit,
    controlHeight: $0c1496466ef568ed$var$controlHeight,
    menuGutter: $0c1496466ef568ed$var$menuGutter
};
var $0c1496466ef568ed$export$4368d992c4eafac0 = {
    borderRadius: $0c1496466ef568ed$var$borderRadius,
    colors: $0c1496466ef568ed$var$colors,
    spacing: $0c1496466ef568ed$var$spacing
};
var $0c1496466ef568ed$export$8b22cf2602fb60ce = {
    "aria-live": "polite",
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $07378f5e4d664a8b$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $07378f5e4d664a8b$export$df995fae86a55f06)(),
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $0c1496466ef568ed$export$db3b6bfb95261072(),
    formatGroupLabel: $0c1496466ef568ed$var$formatGroupLabel,
    getOptionLabel: $0c1496466ef568ed$export$407448d2b89b1813,
    getOptionValue: $0c1496466ef568ed$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $0c1496466ef568ed$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $07378f5e4d664a8b$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: "0",
    tabSelectsValue: true
};
function $0c1496466ef568ed$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $0c1496466ef568ed$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $0c1496466ef568ed$var$_isOptionSelected(props, option, selectValue);
    var label = $0c1496466ef568ed$var$getOptionLabel$1(props, option);
    var value = $0c1496466ef568ed$var$getOptionValue$1(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $0c1496466ef568ed$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if (groupOrOption.options) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $0c1496466ef568ed$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $0c1496466ef568ed$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $0c1496466ef568ed$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $0c1496466ef568ed$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }) // Flow limitation (see https://github.com/facebook/flow/issues/1414)
    .filter(function(categorizedOption) {
        return !!categorizedOption;
    });
}
function $0c1496466ef568ed$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $kbxxf.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $0c1496466ef568ed$var$buildFocusableOptions(props, selectValue) {
    return $0c1496466ef568ed$var$buildFocusableOptionsFromCategorizedOptions($0c1496466ef568ed$var$buildCategorizedOptions(props, selectValue));
}
function $0c1496466ef568ed$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$0c1496466ef568ed$var$shouldHideSelectedOptions(props) || !isSelected) && $0c1496466ef568ed$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $0c1496466ef568ed$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $0c1496466ef568ed$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $0c1496466ef568ed$var$getOptionLabel$1 = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $0c1496466ef568ed$var$getOptionValue$1 = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $0c1496466ef568ed$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $0c1496466ef568ed$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $0c1496466ef568ed$var$getOptionValue$1(props, option);
    return selectValue.some(function(i) {
        return $0c1496466ef568ed$var$getOptionValue$1(props, i) === candidate;
    });
}
function $0c1496466ef568ed$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $0c1496466ef568ed$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $0c1496466ef568ed$var$instanceId = 1;
var $0c1496466ef568ed$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $1gYAD.default)(Select, _Component);
    var _super = (0, $07378f5e4d664a8b$export$71511d61b312f219)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $6CZeq.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = "";
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue) {
            var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "set-value";
            var option = arguments.length > 2 ? arguments[2] : undefined;
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti;
            _this.onInputChange("", {
                action: "set-value"
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                }), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue([].concat((0, $kbxxf.default)(selectValue), [
                    newValue
                ]), "select-option", newValue);
                else _this.setValue(newValue, "select-option");
            } else {
                _this.ariaOnChange(newValue, {
                    action: "select-option",
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = isMulti ? newValueArray : newValueArray[0] || null;
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange(_this.props.isMulti ? [] : null, {
                action: "clear",
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = isMulti ? newValueArray : newValueArray[0] || null;
            _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $07378f5e4d664a8b$export$ef35774e6d314e91).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $0c1496466ef568ed$var$getOptionLabel$1(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $0c1496466ef568ed$var$getOptionValue$1(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var base = $0c1496466ef568ed$var$defaultStyles[key](props);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $07378f5e4d664a8b$export$e7094788287c5e9b)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $0c1496466ef568ed$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $0c1496466ef568ed$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $07378f5e4d664a8b$export$407448d2b89b1813)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $07378f5e4d664a8b$export$96f57966bedc81b4)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return; // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
             // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change"
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur"
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $0c1496466ef568ed$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            } // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close"
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = "react-select-" + (_this.props.instanceId || ++$0c1496466ef568ed$var$instanceId);
        _this.state.selectValue = (0, $07378f5e4d664a8b$export$a9c23c6ac3fc3eca)(_props.value);
        return _this;
    }
    (0, $cHPF9.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programatically disabled while focused
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                 // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $07378f5e4d664a8b$export$d66501df72047452)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            } // ==============================
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close"
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            } // ==============================
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            } // aliased for consumers
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                } // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue; // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customizations.
                if (!this.props.theme) return $0c1496466ef568ed$export$4368d992c4eafac0;
                 // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme($0c1496466ef568ed$export$4368d992c4eafac0);
                 // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $07378f5e4d664a8b$export$407448d2b89b1813)((0, $07378f5e4d664a8b$export$407448d2b89b1813)({}, $0c1496466ef568ed$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti; // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $0c1496466ef568ed$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $0c1496466ef568ed$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $0c1496466ef568ed$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var inputValue = this.props.inputValue;
                    var selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: inputValue,
                        selectValue: selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            } // ==============================
        },
        {
            key: "startListeningComposition",
            value: // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var inputIsHidden = this.state.inputIsHidden;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input"); // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = {
                    "aria-autocomplete": "list",
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"]
                };
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0c1496466ef568ed$var$DummyInput, (0, $8nd05.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $07378f5e4d664a8b$export$2329c99376c9d0a4),
                    onFocus: this.onInputFocus,
                    readOnly: true,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Input, (0, $8nd05.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state4 = this.state, selectValue = _this$state4.selectValue, focusedValue = _this$state4.focusedValue, isFocused = _this$state4.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Placeholder, (0, $8nd05.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), placeholder);
                if (isMulti) {
                    var selectValues = selectValue.map(function(opt, index) {
                        var isOptionFocused = opt === focusedValue;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(MultiValue, (0, $8nd05.default)({}, commonProps, {
                            components: {
                                Container: MultiValueContainer,
                                Label: MultiValueLabel,
                                Remove: MultiValueRemove
                            },
                            isFocused: isOptionFocused,
                            isDisabled: isDisabled,
                            key: "".concat(_this3.getOptionValue(opt)).concat(index),
                            index: index,
                            removeProps: {
                                onClick: function onClick() {
                                    return _this3.removeValue(opt);
                                },
                                onTouchEnd: function onTouchEnd() {
                                    return _this3.removeValue(opt);
                                },
                                onMouseDown: function onMouseDown(e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                            },
                            data: opt
                        }), _this3.formatOptionLabel(opt, "value"));
                    });
                    return selectValues;
                }
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SingleValue, (0, $8nd05.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ClearIndicator, (0, $8nd05.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(LoadingIndicator, (0, $8nd05.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(IndicatorSeparator, (0, $8nd05.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(DropdownIndicator, (0, $8nd05.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null; // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Option, (0, $8nd05.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === "group") {
                        var data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Group, (0, $8nd05.default)({}, commonProps, {
                            key: groupId,
                            data: data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === "option") return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $07378f5e4d664a8b$export$3a1a48c8f6ef640e), (0, $8nd05.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Menu, (0, $8nd05.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0c1496466ef568ed$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(MenuList, (0, $8nd05.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                }); // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(MenuPortal, (0, $8nd05.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name;
                var selectValue = this.state.selectValue;
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                            name: name,
                            type: "hidden"
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state5 = this.state, ariaSelection = _this$state5.ariaSelection, focusedOption = _this$state5.focusedOption, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused, selectValue = _this$state5.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0c1496466ef568ed$var$LiveRegion, (0, $8nd05.default)({}, commonProps, {
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SelectContainer, (0, $8nd05.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Control, (0, $8nd05.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ValueContainer, (0, $8nd05.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(IndicatorsContainer, (0, $8nd05.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue;
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var selectValue = (0, $07378f5e4d664a8b$export$a9c23c6ac3fc3eca)(value);
                    var focusableOptions = menuIsOpen ? $0c1496466ef568ed$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $0c1496466ef568ed$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $0c1496466ef568ed$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                } // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                return (0, $07378f5e4d664a8b$export$407448d2b89b1813)((0, $07378f5e4d664a8b$export$407448d2b89b1813)((0, $07378f5e4d664a8b$export$407448d2b89b1813)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props
                });
            }
        }
    ]);
    return Select;
}((0, $acw62.Component));
$0c1496466ef568ed$export$25ce5a424b770e84.defaultProps = $0c1496466ef568ed$export$8b22cf2602fb60ce;



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");


var $acw62 = parcelRequire("acw62");
var $b1870d752d02e690$var$defaultProps = {
    defaultInputValue: "",
    defaultMenuIsOpen: false,
    defaultValue: null
};
var $b1870d752d02e690$export$953cecd6e717a553 = function manageState(SelectComponent) {
    var _class, _temp;
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        (0, $1gYAD.default)(StateManager, _Component);
        var _super = (0, $07378f5e4d664a8b$export$71511d61b312f219)(StateManager);
        function StateManager() {
            var _this;
            (0, $6CZeq.default)(this, StateManager);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            _this.select = void 0;
            _this.state = {
                inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
                menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
                value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
            };
            _this.onChange = function(value, actionMeta) {
                _this.callProp("onChange", value, actionMeta);
                _this.setState({
                    value: value
                });
            };
            _this.onInputChange = function(value, actionMeta) {
                // TODO: for backwards compatibility, we allow the prop to return a new
                // value, but now inputValue is a controllable prop we probably shouldn't
                var newValue = _this.callProp("onInputChange", value, actionMeta);
                _this.setState({
                    inputValue: newValue !== undefined ? newValue : value
                });
            };
            _this.onMenuOpen = function() {
                _this.callProp("onMenuOpen");
                _this.setState({
                    menuIsOpen: true
                });
            };
            _this.onMenuClose = function() {
                _this.callProp("onMenuClose");
                _this.setState({
                    menuIsOpen: false
                });
            };
            return _this;
        }
        (0, $cHPF9.default)(StateManager, [
            {
                key: "focus",
                value: function focus() {
                    this.select.focus();
                }
            },
            {
                key: "blur",
                value: function blur() {
                    this.select.blur();
                } // FIXME: untyped flow code, return any
            },
            {
                key: "getProp",
                value: function getProp(key) {
                    return this.props[key] !== undefined ? this.props[key] : this.state[key];
                } // FIXME: untyped flow code, return any
            },
            {
                key: "callProp",
                value: function callProp(name) {
                    if (typeof this.props[name] === "function") {
                        var _this$props;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        return (_this$props = this.props)[name].apply(_this$props, args);
                    }
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var _this$props2 = this.props;
                    _this$props2.defaultInputValue;
                    _this$props2.defaultMenuIsOpen;
                    _this$props2.defaultValue;
                    var props = (0, $9X7IJ.default)(_this$props2, [
                        "defaultInputValue",
                        "defaultMenuIsOpen",
                        "defaultValue"
                    ]);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SelectComponent, (0, $8nd05.default)({}, props, {
                        ref: function ref(_ref) {
                            _this2.select = _ref;
                        },
                        inputValue: this.getProp("inputValue"),
                        menuIsOpen: this.getProp("menuIsOpen"),
                        onChange: this.onChange,
                        onInputChange: this.onInputChange,
                        onMenuClose: this.onMenuClose,
                        onMenuOpen: this.onMenuOpen,
                        value: this.getProp("value")
                    }));
                }
            }
        ]);
        return StateManager;
    }((0, $acw62.Component)), _class.defaultProps = $b1870d752d02e690$var$defaultProps, _temp;
};



var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");


var $acw62 = parcelRequire("acw62");


var $lDTld = parcelRequire("lDTld");


var $b95e04f2d4c66124$exports = {};
var $41f5c206613f56c9$exports = {};
var $1e0ecff44bad0ea1$exports = {};
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$1e0ecff44bad0ea1$exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, $1e0ecff44bad0ea1$exports.__esModule = true, $1e0ecff44bad0ea1$exports["default"] = $1e0ecff44bad0ea1$exports;


function $41f5c206613f56c9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1e0ecff44bad0ea1$exports(arr);
}
$41f5c206613f56c9$exports = $41f5c206613f56c9$var$_arrayWithoutHoles, $41f5c206613f56c9$exports.__esModule = true, $41f5c206613f56c9$exports["default"] = $41f5c206613f56c9$exports;


var $cce79e023a3a67e7$exports = {};
function $cce79e023a3a67e7$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
$cce79e023a3a67e7$exports = $cce79e023a3a67e7$var$_iterableToArray, $cce79e023a3a67e7$exports.__esModule = true, $cce79e023a3a67e7$exports["default"] = $cce79e023a3a67e7$exports;


var $51f08ebed50a2438$exports = {};

function $51f08ebed50a2438$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1e0ecff44bad0ea1$exports(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1e0ecff44bad0ea1$exports(o, minLen);
}
$51f08ebed50a2438$exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, $51f08ebed50a2438$exports.__esModule = true, $51f08ebed50a2438$exports["default"] = $51f08ebed50a2438$exports;


var $67c90abe6042aecd$exports = {};
function $67c90abe6042aecd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$67c90abe6042aecd$exports = $67c90abe6042aecd$var$_nonIterableSpread, $67c90abe6042aecd$exports.__esModule = true, $67c90abe6042aecd$exports["default"] = $67c90abe6042aecd$exports;


function $b95e04f2d4c66124$var$_toConsumableArray(arr) {
    return $41f5c206613f56c9$exports(arr) || $cce79e023a3a67e7$exports(arr) || $51f08ebed50a2438$exports(arr) || $67c90abe6042aecd$exports();
}
$b95e04f2d4c66124$exports = $b95e04f2d4c66124$var$_toConsumableArray, $b95e04f2d4c66124$exports.__esModule = true, $b95e04f2d4c66124$exports["default"] = $b95e04f2d4c66124$exports;


var $c5fdcdd8d5286ae7$exports = {};
var $8bc9a7bbcf9a2a3b$exports = {};
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$8bc9a7bbcf9a2a3b$exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, $8bc9a7bbcf9a2a3b$exports.__esModule = true, $8bc9a7bbcf9a2a3b$exports["default"] = $8bc9a7bbcf9a2a3b$exports;


function $c5fdcdd8d5286ae7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8bc9a7bbcf9a2a3b$exports(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
$c5fdcdd8d5286ae7$exports = $c5fdcdd8d5286ae7$var$_objectWithoutProperties, $c5fdcdd8d5286ae7$exports.__esModule = true, $c5fdcdd8d5286ae7$exports["default"] = $c5fdcdd8d5286ae7$exports;


var $c4870074adc2be76$exports = {};
function $c4870074adc2be76$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
$c4870074adc2be76$exports = $c4870074adc2be76$var$_taggedTemplateLiteral, $c4870074adc2be76$exports.__esModule = true, $c4870074adc2be76$exports["default"] = $c4870074adc2be76$exports;


var $2ef66ab8c52ac1c0$exports = {};
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
$2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports;



var $bb7ca61ce45563c4$exports = {};
var $010f4e0e13c82e16$exports = {};

var $010f4e0e13c82e16$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
var $b77c8068776c2a21$exports = {};

var $b77c8068776c2a21$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$b77c8068776c2a21$exports = $b77c8068776c2a21$var$toPrimitive, $b77c8068776c2a21$exports.__esModule = true, $b77c8068776c2a21$exports["default"] = $b77c8068776c2a21$exports;


function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $b77c8068776c2a21$exports(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : String(i);
}
$010f4e0e13c82e16$exports = $010f4e0e13c82e16$var$toPropertyKey, $010f4e0e13c82e16$exports.__esModule = true, $010f4e0e13c82e16$exports["default"] = $010f4e0e13c82e16$exports;


function $bb7ca61ce45563c4$var$_defineProperty(obj, key, value) {
    key = $010f4e0e13c82e16$exports(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$bb7ca61ce45563c4$exports = $bb7ca61ce45563c4$var$_defineProperty, $bb7ca61ce45563c4$exports.__esModule = true, $bb7ca61ce45563c4$exports["default"] = $bb7ca61ce45563c4$exports;


parcelRequire("1u0KT");
var $7532f3e29d96fa2a$export$a7deb1594c5ce10e = /*#__PURE__*/ function(_Component) {
    (0, $1gYAD.default)(NonceProvider, _Component);
    var _super = (0, $07378f5e4d664a8b$export$71511d61b312f219)(NonceProvider);
    function NonceProvider(props) {
        var _this;
        (0, $6CZeq.default)(this, NonceProvider);
        _this = _super.call(this, props);
        _this.createEmotionCache = function(nonce, key) {
            return (0, $lDTld.default)({
                nonce: nonce,
                key: key
            });
        };
        _this.createEmotionCache = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(_this.createEmotionCache);
        return _this;
    }
    (0, $cHPF9.default)(NonceProvider, [
        {
            key: "render",
            value: function render() {
                var emotionCache = this.createEmotionCache(this.props.nonce, this.props.cacheKey);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $094eab6f6c422d65$export$e7094788287c5e9b), {
                    value: emotionCache
                }, this.props.children);
            }
        }
    ]);
    return NonceProvider;
}((0, $acw62.Component));
var $7532f3e29d96fa2a$var$index = (0, $b1870d752d02e690$export$953cecd6e717a553)((0, $0c1496466ef568ed$export$25ce5a424b770e84));
var $7532f3e29d96fa2a$export$2e2bcd8739ae039 = $7532f3e29d96fa2a$var$index;


const $fb0eeba3a61229ce$var$Searcher = ({ setOccupation: setOccupation, occupations: occupations })=>{
    let options = Object.values(occupations).map((suggestion)=>{
        suggestion.value = suggestion.title;
        suggestion.label = suggestion.title;
        suggestion.isDisabled = suggestion.noData;
        return suggestion;
    });
    let keepers = (0, $acw62.useRef)({
        lastFilteredOn: "",
        filtered: $fb0eeba3a61229ce$var$getKeepers(options, "")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
        escapeClearsValue: true,
        isClearable: true,
        defaultValue: options[0],
        styles: {
            option: ()=>({}),
            singleValue: (original)=>({
                    ...original,
                    color: "white"
                }),
            input: (original)=>({
                    ...original,
                    color: "white"
                }),
            control: (original)=>({
                    ...original,
                    color: "white",
                    backgroundColor: "#1d1f21"
                }),
            menu: ()=>({
                    border: "1px solid #aaa",
                    borderRadius: "5px",
                    backgroundColor: "#1d1f21"
                })
        },
        components: {
            Option: $fb0eeba3a61229ce$var$Option
        },
        filterOption: ({ data: data }, string)=>{
            if (keepers.current.lastFilteredOn !== string) {
                keepers.current.filtered = $fb0eeba3a61229ce$var$getKeepers(options, string);
                keepers.current.lastFilteredOn = string;
            }
            return keepers.current.filtered[data.title];
        },
        options: options,
        onChange: (option, { action: action })=>{
            if (action === "select-option") setOccupation(option);
        }
    });
};
var $fb0eeba3a61229ce$export$2e2bcd8739ae039 = $fb0eeba3a61229ce$var$Searcher;
const $fb0eeba3a61229ce$var$Option = ({ children: children, ...props })=>{
    const { onMouseMove: onMouseMove, onMouseOver: onMouseOver, ...rest } = props.innerProps;
    const newProps = Object.assign(props, {
        innerProps: rest
    });
    const { data: option } = newProps;
    let prefix = "";
    if (option.noData) prefix = "[no data]";
    else if (option.missingData) prefix = "[incomplete data]";
    let subtitle = [];
    let subjobs = [];
    if (option.subcategories) subjobs.push(`${option.subcategories} subcategories`);
    if (option.occupations) subjobs.push(`${option.occupations} occupations`);
    if (subjobs.length) subtitle.push(subjobs.join(", "));
    if (option.dominationAverage) {
        if (option.dominationAverage > 20) subtitle.push(`male dominated (+${Math.round(option.dominationAverage)}%) (confidence: ${option.confidenceScore})`);
        else if (option.dominationAverage > 0) subtitle.push(`male leading (+${Math.round(option.dominationAverage)}%) (confidence: ${option.confidenceScore})`);
        else if (option.dominationAverage < -20) subtitle.push(`female dominated (+${-Math.round(option.dominationAverage)}%) (confidence: ${option.confidenceScore})`);
        else if (option.dominationAverage < 0) subtitle.push(`female leading (+${-Math.round(option.dominationAverage)}%) (confidence: ${option.confidenceScore})`);
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $07378f5e4d664a8b$export$db3b6bfb95261072).Option, {
        ...newProps,
        className: (0, $igqD6.cx)((0, $igqD6.css)`
          cursor: default;
          display: block;
          padding: 8px 12px;
          width: 100%;
          user-select: none;
          box-sizing: border-box;

          padding-left: ${option.depth * 20}px;

          ${newProps.isDisabled ? (0, $igqD6.css)`
            opacity: .5;
          ` : ""}

          ${newProps.isSelected ? (0, $igqD6.css)`
            background-color: #2684FF;
          ` : ""}

          ${newProps.isFocused ? (0, $igqD6.css)`
            background-color: rgba(255,255,255,.25);
          ` : ""}

          :hover {
            background-color: rgba(255,255,255,.25)
          }
        `, {
            option: true,
            "option--is-disabled": newProps.isDisabled,
            "option--is-focused": newProps.isFocused,
            "option--is-selected": newProps.isSelected
        }),
        children: [
            option.noData && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: (0, $igqD6.css)``,
                        children: [
                            prefix,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: (0, $igqD6.css)`text-decoration: line-through;`,
                        children: option.title
                    })
                ]
            }),
            option.missingData && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: (0, $igqD6.css)``,
                        children: [
                            prefix,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: option.title
                    })
                ]
            }),
            !option.noData && !option.missingData && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: option.title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $igqD6.css)`
        font-style: italic;
        font-size: 14px;
      `,
                children: subtitle.join(" | ")
            })
        ]
    });
};
function $fb0eeba3a61229ce$var$getKeepers(options, value) {
    let keepers = {};
    function keepUp(occupation) {
        keepers[occupation.title] = true;
        if (occupation.parent) keepUp(occupation.parent);
    }
    function keepDown(occupation) {
        keepers[occupation.title] = true;
        let children = Object.values(occupation.children);
        if (children.length) children.forEach(keepDown);
    }
    options.forEach((occupation)=>{
        // if we've already marked this as good, don't do anything more
        if (keepers[occupation.title] === true) return;
        // default to false
        keepers[occupation.title] = false;
        if (occupation.title.toLowerCase().includes(value.toLowerCase())) keepUp(occupation);
    });
    return keepers;
}


const $210c12135ffdf67d$export$a5529e381d0d1474 = ()=>{
    let occupations = (0, $acw62.useMemo)(()=>(0, $4d50368102d8f869$export$1686aec5678ceb1c)(), []);
    const defaultOccupation = Object.values(occupations)[0];
    const [occupation, setOccupation] = (0, $acw62.useState)(defaultOccupation);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3d4d1bba653c6d14$export$6955bcca4cd3539f), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fb0eeba3a61229ce$export$2e2bcd8739ae039), {
                    occupations: occupations,
                    setOccupation: setOccupation
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($210c12135ffdf67d$export$f0d9bb3750b5fe52, {
                    jobData: occupation
                })
            ]
        })
    });
};
function $210c12135ffdf67d$var$basicBarGraph(inputConfig) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, $210c12135ffdf67d$var$basicGraph(), {
        data: {
            type: (0, $73t87.bar)() // for ESM specify as: bar()
        },
        bar: {
            radius: 5,
            padding: 5,
            width: {
                ratio: 0.5
            }
        }
    }, inputConfig);
}
function $210c12135ffdf67d$var$basicGraph(inputConfig) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, {
        data: {
            x: "x",
            colors: {
                Men: "#00c73c",
                Women: "#fa7171",
                Median: "#2ad0ff",
                Total: "#e3e448"
            }
        }
    }, inputConfig);
}
function $210c12135ffdf67d$var$getAllKeys(data) {
    let keys = [];
    Object.keys(data).forEach((key)=>{
        keys.push(key);
    });
    return keys;
}
function $210c12135ffdf67d$var$getAllNumeralValues(data, property, mapFn) {
    let values = [];
    Object.values(data).forEach((value)=>{
        let num = (0, (/*@__PURE__*/$parcel$interopDefault($6690377ff2917a7c$exports)))(value[property]).value();
        if (mapFn) num = mapFn(num, value);
        values.push(num);
    });
    return values;
}
const $210c12135ffdf67d$export$f0d9bb3750b5fe52 = ({ jobData: jobData })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            jobData.title,
            /*#__PURE__*/ (0, $ayMG0.jsx)($210c12135ffdf67d$var$Chart, {
                config: $210c12135ffdf67d$var$basicGraph({
                    data: {
                        type: (0, $73t87.spline)(),
                        columns: [
                            [
                                "x",
                                ...$210c12135ffdf67d$var$getAllKeys(jobData.wageData)
                            ],
                            [
                                "Men",
                                ...$210c12135ffdf67d$var$getAllNumeralValues(jobData.wageData, "maleMedian")
                            ],
                            [
                                "Women",
                                ...$210c12135ffdf67d$var$getAllNumeralValues(jobData.wageData, "femaleMedian")
                            ],
                            [
                                "Median",
                                ...$210c12135ffdf67d$var$getAllNumeralValues(jobData.wageData, "median")
                            ]
                        ],
                        labels: {
                            format (value) {
                                if (!value && value !== 0) return "";
                                return (0, (/*@__PURE__*/$parcel$interopDefault($6690377ff2917a7c$exports)))(value).format("$0,0");
                            }
                        }
                    },
                    axis: {
                        y: {
                            label: "Average weekly earnings",
                            tick: {
                                format (value) {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6690377ff2917a7c$exports)))(value).format("$0,0");
                                }
                            }
                        },
                        x: {
                            type: "category"
                        }
                    },
                    tooltip: {
                        format: {
                            value (value, key, index) {
                                return (0, (/*@__PURE__*/$parcel$interopDefault($6690377ff2917a7c$exports)))(value).format("$0,0");
                            }
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($210c12135ffdf67d$var$Chart, {
                config: ()=>{
                    let keys = $210c12135ffdf67d$var$getAllKeys(jobData.sexRaceEthnicityData);
                    let menData = [];
                    let menPercents = [];
                    let womenData = [];
                    let womenPercents = [];
                    let totalData = [];
                    Object.values(jobData.sexRaceEthnicityData).forEach(({ women: women, total: total })=>{
                        if (women !== "-") {
                            let totalNum = (0, (/*@__PURE__*/$parcel$interopDefault($6690377ff2917a7c$exports)))(total).value();
                            let womenPercent = (0, (/*@__PURE__*/$parcel$interopDefault($6690377ff2917a7c$exports)))(women).value();
                            let menPercent = 100 - womenPercent;
                            womenPercents.push(womenPercent);
                            womenData.push(womenPercent / 100 * totalNum * 1000);
                            menPercents.push(menPercent);
                            menData.push(menPercent / 100 * totalNum * 1000);
                            totalData.push(totalNum * 1000);
                        } else {
                            womenPercents.push(null);
                            womenData.push(null);
                            menPercents.push(null);
                            menData.push(null);
                            totalData.push(null);
                        }
                    });
                    return $210c12135ffdf67d$var$basicGraph({
                        data: {
                            type: (0, $73t87.spline)(),
                            types: {
                                Total: (0, $73t87.spline)()
                            },
                            columns: [
                                [
                                    "x",
                                    ...keys
                                ],
                                [
                                    "Men",
                                    ...menPercents
                                ],
                                [
                                    "Women",
                                    ...womenPercents
                                ]
                            ],
                            labels: {
                                format (value, key, index) {
                                    if (!value && value !== 0) return "";
                                    if (key === "Men") return `${Math.floor(menPercents[index])}%`;
                                    else if (key === "Women") return `${Math.floor(womenPercents[index])}%`;
                                }
                            }
                        },
                        axis: {
                            y: {
                                label: "Participation (percent)",
                                tick: {
                                    format (value) {
                                        return (0, (/*@__PURE__*/$parcel$interopDefault($6690377ff2917a7c$exports)))(value).format();
                                    }
                                },
                                min: 0,
                                max: 100
                            },
                            x: {
                                type: "category"
                            }
                        },
                        tooltip: {
                            format: {
                                value (value, ratio, key, index) {
                                    if (key === "Men") return `${(0, (/*@__PURE__*/$parcel$interopDefault($6690377ff2917a7c$exports)))(Math.floor(menData[index])).format()} (${menPercents[index]}%)`;
                                    else if (key === "Women") return `${(0, (/*@__PURE__*/$parcel$interopDefault($6690377ff2917a7c$exports)))(Math.floor(womenData[index])).format()} (${womenPercents[index]}%)`;
                                    else return (0, (/*@__PURE__*/$parcel$interopDefault($6690377ff2917a7c$exports)))(value).format();
                                }
                            }
                        }
                    });
                }
            })
        ]
    });
};
let $210c12135ffdf67d$var$increment = 0;
const $210c12135ffdf67d$var$Chart = ({ config: config, ...htmlProps })=>{
    const chart = (0, $acw62.useRef)();
    const chartId = (0, $acw62.useRef)(`chart-${$210c12135ffdf67d$var$increment++}`);
    (0, $acw62.useEffect)(()=>{
        if (typeof config === "function") config = config();
        chart.current = (0, $73t87.default).generate({
            ...config,
            bindto: `#${chartId.current}`
        });
    }, [
        config
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        id: chartId.current,
        ...htmlProps,
        className: (0, $igqD6.cx)((0, $igqD6.css)`
        width: 100%; 
        height: 500px;

        color: white;

        .bb-tooltip {
          border-radius: 8px;
        }

        .bb-tooltip-container {
          font-family: Source Code Pro Woff, Monaco, monospace;
        }

        .bb-tooltip {
          background: #1b1b1b;
        }

        .bb-tooltip td {
          background: none;
        } 

        .bb-tooltip td, .bb-tooltip th {
          padding: 8px 16px;
        }
        
        .bb-tooltip, .bb-tooltip td, .bb-tooltip th {
          border-color: #313131;
          font-size: 14px;
        }

      `, htmlProps.className || "")
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
"use strict";



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $91fb32bbe67abcd9$exports = {};
var $d0ba187f52746566$exports = {};

var $acw62 = parcelRequire("acw62");
var $3239e52599398978$exports = {};
var $0840bf372bb785c9$exports = {};
"use strict";
Object.defineProperty($0840bf372bb785c9$exports, "__esModule", {
    value: true
});
function $0840bf372bb785c9$var$_slicedToArray(arr, i) {
    return $0840bf372bb785c9$var$_arrayWithHoles(arr) || $0840bf372bb785c9$var$_iterableToArrayLimit(arr, i) || $0840bf372bb785c9$var$_unsupportedIterableToArray(arr, i) || $0840bf372bb785c9$var$_nonIterableRest();
}
function $0840bf372bb785c9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $0840bf372bb785c9$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $0840bf372bb785c9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0840bf372bb785c9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0840bf372bb785c9$var$_arrayLikeToArray(o, minLen);
}
function $0840bf372bb785c9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0840bf372bb785c9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// A reserved attribute.
// It is handled by React separately and shouldn't be written to the DOM.
var $0840bf372bb785c9$var$RESERVED = 0; // A simple string attribute.
// Attributes that aren't in the filter are presumed to have this type.
var $0840bf372bb785c9$var$STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
// "enumerated" attributes with "true" and "false" as possible values.
// When true, it should be set to a "true" string.
// When false, it should be set to a "false" string.
var $0840bf372bb785c9$var$BOOLEANISH_STRING = 2; // A real boolean attribute.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
var $0840bf372bb785c9$var$BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
// For any other value, should be present with that value.
var $0840bf372bb785c9$var$OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
// When falsy, it should be removed.
var $0840bf372bb785c9$var$NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
// When falsy, it should be removed.
var $0840bf372bb785c9$var$POSITIVE_NUMERIC = 6;
function $0840bf372bb785c9$var$getPropertyInfo(name) {
    return $0840bf372bb785c9$var$properties.hasOwnProperty(name) ? $0840bf372bb785c9$var$properties[name] : null;
}
function $0840bf372bb785c9$var$PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
    this.acceptsBooleans = type === $0840bf372bb785c9$var$BOOLEANISH_STRING || type === $0840bf372bb785c9$var$BOOLEAN || type === $0840bf372bb785c9$var$OVERLOADED_BOOLEAN;
    this.attributeName = attributeName;
    this.attributeNamespace = attributeNamespace;
    this.mustUseProperty = mustUseProperty;
    this.propertyName = name;
    this.type = type;
    this.sanitizeURL = sanitizeURL;
    this.removeEmptyString = removeEmptyString;
} // When adding attributes to this list, be sure to also add them to
// the `possibleStandardNames` module to ensure casing and incorrect
// name warnings.
var $0840bf372bb785c9$var$properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
var $0840bf372bb785c9$var$reservedProps = [
    "children",
    "dangerouslySetInnerHTML",
    // elements (not just inputs). Now that ReactDOMInput assigns to the
    // defaultValue property -- do we need this?
    "defaultValue",
    "defaultChecked",
    "innerHTML",
    "suppressContentEditableWarning",
    "suppressHydrationWarning",
    "style"
];
$0840bf372bb785c9$var$reservedProps.forEach(function(name) {
    $0840bf372bb785c9$var$properties[name] = new $0840bf372bb785c9$var$PropertyInfoRecord(name, $0840bf372bb785c9$var$RESERVED, false, name, null, false, false);
}); // A few React string attributes have a different name.
// This is a mapping from React prop names to the attribute names.
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(_ref) {
    var _ref2 = $0840bf372bb785c9$var$_slicedToArray(_ref, 2), name = _ref2[0], attributeName = _ref2[1];
    $0840bf372bb785c9$var$properties[name] = new $0840bf372bb785c9$var$PropertyInfoRecord(name, $0840bf372bb785c9$var$STRING, false, attributeName, null, false, false);
}); // These are "enumerated" HTML attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(name) {
    $0840bf372bb785c9$var$properties[name] = new $0840bf372bb785c9$var$PropertyInfoRecord(name, $0840bf372bb785c9$var$BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
}); // These are "enumerated" SVG attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
// Since these are SVG attributes, their attribute names are case-sensitive.
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(name) {
    $0840bf372bb785c9$var$properties[name] = new $0840bf372bb785c9$var$PropertyInfoRecord(name, $0840bf372bb785c9$var$BOOLEANISH_STRING, false, name, null, false, false);
}); // These are HTML boolean attributes.
[
    "allowFullScreen",
    "async",
    // on the client side because the browsers are inconsistent. Instead we call focus().
    "autoFocus",
    "autoPlay",
    "controls",
    "default",
    "defer",
    "disabled",
    "disablePictureInPicture",
    "disableRemotePlayback",
    "formNoValidate",
    "hidden",
    "loop",
    "noModule",
    "noValidate",
    "open",
    "playsInline",
    "readOnly",
    "required",
    "reversed",
    "scoped",
    "seamless",
    "itemScope"
].forEach(function(name) {
    $0840bf372bb785c9$var$properties[name] = new $0840bf372bb785c9$var$PropertyInfoRecord(name, $0840bf372bb785c9$var$BOOLEAN, false, name.toLowerCase(), null, false, false);
}); // These are the few React props that we set as DOM properties
// rather than attributes. These are all booleans.
[
    "checked",
    // disabled with `removeAttribute`. We have special logic for handling this.
    "multiple",
    "muted",
    "selected" // NOTE: if you add a camelCased prop to this list,
].forEach(function(name) {
    $0840bf372bb785c9$var$properties[name] = new $0840bf372bb785c9$var$PropertyInfoRecord(name, $0840bf372bb785c9$var$BOOLEAN, true, name, null, false, false);
}); // These are HTML attributes that are "overloaded booleans": they behave like
// booleans, but can also accept a string value.
[
    "capture",
    "download" // NOTE: if you add a camelCased prop to this list,
].forEach(function(name) {
    $0840bf372bb785c9$var$properties[name] = new $0840bf372bb785c9$var$PropertyInfoRecord(name, $0840bf372bb785c9$var$OVERLOADED_BOOLEAN, false, name, null, false, false);
}); // These are HTML attributes that must be positive numbers.
[
    "cols",
    "rows",
    "size",
    "span" // NOTE: if you add a camelCased prop to this list,
].forEach(function(name) {
    $0840bf372bb785c9$var$properties[name] = new $0840bf372bb785c9$var$PropertyInfoRecord(name, $0840bf372bb785c9$var$POSITIVE_NUMERIC, false, name, null, false, false);
}); // These are HTML attributes that must be numbers.
[
    "rowSpan",
    "start"
].forEach(function(name) {
    $0840bf372bb785c9$var$properties[name] = new $0840bf372bb785c9$var$PropertyInfoRecord(name, $0840bf372bb785c9$var$NUMERIC, false, name.toLowerCase(), null, false, false);
});
var $0840bf372bb785c9$var$CAMELIZE = /[\-\:]([a-z])/g;
var $0840bf372bb785c9$var$capitalize = function capitalize(token) {
    return token[1].toUpperCase();
}; // This is a list of all SVG attributes that need special casing, namespacing,
// or boolean value assignment. Regular attributes that just accept strings
// and have the same names are omitted, just like in the HTML attribute filter.
// Some of these attributes can be hard to find. This list was created by
// scraping the MDN documentation.
[
    "accent-height",
    "alignment-baseline",
    "arabic-form",
    "baseline-shift",
    "cap-height",
    "clip-path",
    "clip-rule",
    "color-interpolation",
    "color-interpolation-filters",
    "color-profile",
    "color-rendering",
    "dominant-baseline",
    "enable-background",
    "fill-opacity",
    "fill-rule",
    "flood-color",
    "flood-opacity",
    "font-family",
    "font-size",
    "font-size-adjust",
    "font-stretch",
    "font-style",
    "font-variant",
    "font-weight",
    "glyph-name",
    "glyph-orientation-horizontal",
    "glyph-orientation-vertical",
    "horiz-adv-x",
    "horiz-origin-x",
    "image-rendering",
    "letter-spacing",
    "lighting-color",
    "marker-end",
    "marker-mid",
    "marker-start",
    "overline-position",
    "overline-thickness",
    "paint-order",
    "panose-1",
    "pointer-events",
    "rendering-intent",
    "shape-rendering",
    "stop-color",
    "stop-opacity",
    "strikethrough-position",
    "strikethrough-thickness",
    "stroke-dasharray",
    "stroke-dashoffset",
    "stroke-linecap",
    "stroke-linejoin",
    "stroke-miterlimit",
    "stroke-opacity",
    "stroke-width",
    "text-anchor",
    "text-decoration",
    "text-rendering",
    "underline-position",
    "underline-thickness",
    "unicode-bidi",
    "unicode-range",
    "units-per-em",
    "v-alphabetic",
    "v-hanging",
    "v-ideographic",
    "v-mathematical",
    "vector-effect",
    "vert-adv-y",
    "vert-origin-x",
    "vert-origin-y",
    "word-spacing",
    "writing-mode",
    "xmlns:xlink",
    "x-height" // NOTE: if you add a camelCased prop to this list,
].forEach(function(attributeName) {
    var name = attributeName.replace($0840bf372bb785c9$var$CAMELIZE, $0840bf372bb785c9$var$capitalize);
    $0840bf372bb785c9$var$properties[name] = new $0840bf372bb785c9$var$PropertyInfoRecord(name, $0840bf372bb785c9$var$STRING, false, attributeName, null, false, false);
}); // String SVG attributes with the xlink namespace.
[
    "xlink:actuate",
    "xlink:arcrole",
    "xlink:role",
    "xlink:show",
    "xlink:title",
    "xlink:type" // NOTE: if you add a camelCased prop to this list,
].forEach(function(attributeName) {
    var name = attributeName.replace($0840bf372bb785c9$var$CAMELIZE, $0840bf372bb785c9$var$capitalize);
    $0840bf372bb785c9$var$properties[name] = new $0840bf372bb785c9$var$PropertyInfoRecord(name, $0840bf372bb785c9$var$STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
}); // String SVG attributes with the xml namespace.
[
    "xml:base",
    "xml:lang",
    "xml:space" // NOTE: if you add a camelCased prop to this list,
].forEach(function(attributeName) {
    var name = attributeName.replace($0840bf372bb785c9$var$CAMELIZE, $0840bf372bb785c9$var$capitalize);
    $0840bf372bb785c9$var$properties[name] = new $0840bf372bb785c9$var$PropertyInfoRecord(name, $0840bf372bb785c9$var$STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
}); // These attribute exists both in HTML and SVG.
// The attribute name is case-sensitive in SVG so we can't just use
// the React name like we do for attributes that exist only in HTML.
[
    "tabIndex",
    "crossOrigin"
].forEach(function(attributeName) {
    $0840bf372bb785c9$var$properties[attributeName] = new $0840bf372bb785c9$var$PropertyInfoRecord(attributeName, $0840bf372bb785c9$var$STRING, false, attributeName.toLowerCase(), null, false, false);
}); // These attributes accept URLs. These must not allow javascript: URLS.
// These will also need to accept Trusted Types object in the future.
var $0840bf372bb785c9$var$xlinkHref = "xlinkHref";
$0840bf372bb785c9$var$properties[$0840bf372bb785c9$var$xlinkHref] = new $0840bf372bb785c9$var$PropertyInfoRecord("xlinkHref", $0840bf372bb785c9$var$STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(attributeName) {
    $0840bf372bb785c9$var$properties[attributeName] = new $0840bf372bb785c9$var$PropertyInfoRecord(attributeName, $0840bf372bb785c9$var$STRING, false, attributeName.toLowerCase(), null, true, true);
});
// An attribute in which the DOM/SVG standard name is the same as the React prop name (e.g., 'accept').
var $a9ddea9fff9a59d9$export$7359a57b3ac1f378;
var $a9ddea9fff9a59d9$export$5ab28d07cff57c11;
var $a9ddea9fff9a59d9$export$bbecfff5ecf65cd8;
var $a9ddea9fff9a59d9$var$SAME = 0;
$a9ddea9fff9a59d9$export$7359a57b3ac1f378 = $a9ddea9fff9a59d9$var$SAME;
// An attribute in which the React prop name is the camelcased version of the DOM/SVG standard name (e.g., 'acceptCharset').
var $a9ddea9fff9a59d9$var$CAMELCASE = 1;
$a9ddea9fff9a59d9$export$5ab28d07cff57c11 = $a9ddea9fff9a59d9$var$CAMELCASE;
$a9ddea9fff9a59d9$export$bbecfff5ecf65cd8 = {
    accept: 0,
    acceptCharset: 1,
    "accept-charset": "acceptCharset",
    accessKey: 1,
    action: 0,
    allowFullScreen: 1,
    alt: 0,
    as: 0,
    async: 0,
    autoCapitalize: 1,
    autoComplete: 1,
    autoCorrect: 1,
    autoFocus: 1,
    autoPlay: 1,
    autoSave: 1,
    capture: 0,
    cellPadding: 1,
    cellSpacing: 1,
    challenge: 0,
    charSet: 1,
    checked: 0,
    children: 0,
    cite: 0,
    class: "className",
    classID: 1,
    className: 1,
    cols: 0,
    colSpan: 1,
    content: 0,
    contentEditable: 1,
    contextMenu: 1,
    controls: 0,
    controlsList: 1,
    coords: 0,
    crossOrigin: 1,
    dangerouslySetInnerHTML: 1,
    data: 0,
    dateTime: 1,
    default: 0,
    defaultChecked: 1,
    defaultValue: 1,
    defer: 0,
    dir: 0,
    disabled: 0,
    disablePictureInPicture: 1,
    disableRemotePlayback: 1,
    download: 0,
    draggable: 0,
    encType: 1,
    enterKeyHint: 1,
    for: "htmlFor",
    form: 0,
    formMethod: 1,
    formAction: 1,
    formEncType: 1,
    formNoValidate: 1,
    formTarget: 1,
    frameBorder: 1,
    headers: 0,
    height: 0,
    hidden: 0,
    high: 0,
    href: 0,
    hrefLang: 1,
    htmlFor: 1,
    httpEquiv: 1,
    "http-equiv": "httpEquiv",
    icon: 0,
    id: 0,
    innerHTML: 1,
    inputMode: 1,
    integrity: 0,
    is: 0,
    itemID: 1,
    itemProp: 1,
    itemRef: 1,
    itemScope: 1,
    itemType: 1,
    keyParams: 1,
    keyType: 1,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: 0,
    low: 0,
    manifest: 0,
    marginWidth: 1,
    marginHeight: 1,
    max: 0,
    maxLength: 1,
    media: 0,
    mediaGroup: 1,
    method: 0,
    min: 0,
    minLength: 1,
    multiple: 0,
    muted: 0,
    name: 0,
    noModule: 1,
    nonce: 0,
    noValidate: 1,
    open: 0,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: 1,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 1,
    readOnly: 1,
    referrerPolicy: 1,
    rel: 0,
    required: 0,
    reversed: 0,
    role: 0,
    rows: 0,
    rowSpan: 1,
    sandbox: 0,
    scope: 0,
    scoped: 0,
    scrolling: 0,
    seamless: 0,
    selected: 0,
    shape: 0,
    size: 0,
    sizes: 0,
    span: 0,
    spellCheck: 1,
    src: 0,
    srcDoc: 1,
    srcLang: 1,
    srcSet: 1,
    start: 0,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 1,
    target: 0,
    title: 0,
    type: 0,
    useMap: 1,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,
    about: 0,
    accentHeight: 1,
    "accent-height": "accentHeight",
    accumulate: 0,
    additive: 0,
    alignmentBaseline: 1,
    "alignment-baseline": "alignmentBaseline",
    allowReorder: 1,
    alphabetic: 0,
    amplitude: 0,
    arabicForm: 1,
    "arabic-form": "arabicForm",
    ascent: 0,
    attributeName: 1,
    attributeType: 1,
    autoReverse: 1,
    azimuth: 0,
    baseFrequency: 1,
    baselineShift: 1,
    "baseline-shift": "baselineShift",
    baseProfile: 1,
    bbox: 0,
    begin: 0,
    bias: 0,
    by: 0,
    calcMode: 1,
    capHeight: 1,
    "cap-height": "capHeight",
    clip: 0,
    clipPath: 1,
    "clip-path": "clipPath",
    clipPathUnits: 1,
    clipRule: 1,
    "clip-rule": "clipRule",
    color: 0,
    colorInterpolation: 1,
    "color-interpolation": "colorInterpolation",
    colorInterpolationFilters: 1,
    "color-interpolation-filters": "colorInterpolationFilters",
    colorProfile: 1,
    "color-profile": "colorProfile",
    colorRendering: 1,
    "color-rendering": "colorRendering",
    contentScriptType: 1,
    contentStyleType: 1,
    cursor: 0,
    cx: 0,
    cy: 0,
    d: 0,
    datatype: 0,
    decelerate: 0,
    descent: 0,
    diffuseConstant: 1,
    direction: 0,
    display: 0,
    divisor: 0,
    dominantBaseline: 1,
    "dominant-baseline": "dominantBaseline",
    dur: 0,
    dx: 0,
    dy: 0,
    edgeMode: 1,
    elevation: 0,
    enableBackground: 1,
    "enable-background": "enableBackground",
    end: 0,
    exponent: 0,
    externalResourcesRequired: 1,
    fill: 0,
    fillOpacity: 1,
    "fill-opacity": "fillOpacity",
    fillRule: 1,
    "fill-rule": "fillRule",
    filter: 0,
    filterRes: 1,
    filterUnits: 1,
    floodOpacity: 1,
    "flood-opacity": "floodOpacity",
    floodColor: 1,
    "flood-color": "floodColor",
    focusable: 0,
    fontFamily: 1,
    "font-family": "fontFamily",
    fontSize: 1,
    "font-size": "fontSize",
    fontSizeAdjust: 1,
    "font-size-adjust": "fontSizeAdjust",
    fontStretch: 1,
    "font-stretch": "fontStretch",
    fontStyle: 1,
    "font-style": "fontStyle",
    fontVariant: 1,
    "font-variant": "fontVariant",
    fontWeight: 1,
    "font-weight": "fontWeight",
    format: 0,
    from: 0,
    fx: 0,
    fy: 0,
    g1: 0,
    g2: 0,
    glyphName: 1,
    "glyph-name": "glyphName",
    glyphOrientationHorizontal: 1,
    "glyph-orientation-horizontal": "glyphOrientationHorizontal",
    glyphOrientationVertical: 1,
    "glyph-orientation-vertical": "glyphOrientationVertical",
    glyphRef: 1,
    gradientTransform: 1,
    gradientUnits: 1,
    hanging: 0,
    horizAdvX: 1,
    "horiz-adv-x": "horizAdvX",
    horizOriginX: 1,
    "horiz-origin-x": "horizOriginX",
    ideographic: 0,
    imageRendering: 1,
    "image-rendering": "imageRendering",
    in2: 0,
    in: 0,
    inlist: 0,
    intercept: 0,
    k1: 0,
    k2: 0,
    k3: 0,
    k4: 0,
    k: 0,
    kernelMatrix: 1,
    kernelUnitLength: 1,
    kerning: 0,
    keyPoints: 1,
    keySplines: 1,
    keyTimes: 1,
    lengthAdjust: 1,
    letterSpacing: 1,
    "letter-spacing": "letterSpacing",
    lightingColor: 1,
    "lighting-color": "lightingColor",
    limitingConeAngle: 1,
    local: 0,
    markerEnd: 1,
    "marker-end": "markerEnd",
    markerHeight: 1,
    markerMid: 1,
    "marker-mid": "markerMid",
    markerStart: 1,
    "marker-start": "markerStart",
    markerUnits: 1,
    markerWidth: 1,
    mask: 0,
    maskContentUnits: 1,
    maskUnits: 1,
    mathematical: 0,
    mode: 0,
    numOctaves: 1,
    offset: 0,
    opacity: 0,
    operator: 0,
    order: 0,
    orient: 0,
    orientation: 0,
    origin: 0,
    overflow: 0,
    overlinePosition: 1,
    "overline-position": "overlinePosition",
    overlineThickness: 1,
    "overline-thickness": "overlineThickness",
    paintOrder: 1,
    "paint-order": "paintOrder",
    panose1: 0,
    "panose-1": "panose1",
    pathLength: 1,
    patternContentUnits: 1,
    patternTransform: 1,
    patternUnits: 1,
    pointerEvents: 1,
    "pointer-events": "pointerEvents",
    points: 0,
    pointsAtX: 1,
    pointsAtY: 1,
    pointsAtZ: 1,
    prefix: 0,
    preserveAlpha: 1,
    preserveAspectRatio: 1,
    primitiveUnits: 1,
    property: 0,
    r: 0,
    radius: 0,
    refX: 1,
    refY: 1,
    renderingIntent: 1,
    "rendering-intent": "renderingIntent",
    repeatCount: 1,
    repeatDur: 1,
    requiredExtensions: 1,
    requiredFeatures: 1,
    resource: 0,
    restart: 0,
    result: 0,
    results: 0,
    rotate: 0,
    rx: 0,
    ry: 0,
    scale: 0,
    security: 0,
    seed: 0,
    shapeRendering: 1,
    "shape-rendering": "shapeRendering",
    slope: 0,
    spacing: 0,
    specularConstant: 1,
    specularExponent: 1,
    speed: 0,
    spreadMethod: 1,
    startOffset: 1,
    stdDeviation: 1,
    stemh: 0,
    stemv: 0,
    stitchTiles: 1,
    stopColor: 1,
    "stop-color": "stopColor",
    stopOpacity: 1,
    "stop-opacity": "stopOpacity",
    strikethroughPosition: 1,
    "strikethrough-position": "strikethroughPosition",
    strikethroughThickness: 1,
    "strikethrough-thickness": "strikethroughThickness",
    string: 0,
    stroke: 0,
    strokeDasharray: 1,
    "stroke-dasharray": "strokeDasharray",
    strokeDashoffset: 1,
    "stroke-dashoffset": "strokeDashoffset",
    strokeLinecap: 1,
    "stroke-linecap": "strokeLinecap",
    strokeLinejoin: 1,
    "stroke-linejoin": "strokeLinejoin",
    strokeMiterlimit: 1,
    "stroke-miterlimit": "strokeMiterlimit",
    strokeWidth: 1,
    "stroke-width": "strokeWidth",
    strokeOpacity: 1,
    "stroke-opacity": "strokeOpacity",
    suppressContentEditableWarning: 1,
    suppressHydrationWarning: 1,
    surfaceScale: 1,
    systemLanguage: 1,
    tableValues: 1,
    targetX: 1,
    targetY: 1,
    textAnchor: 1,
    "text-anchor": "textAnchor",
    textDecoration: 1,
    "text-decoration": "textDecoration",
    textLength: 1,
    textRendering: 1,
    "text-rendering": "textRendering",
    to: 0,
    transform: 0,
    typeof: 0,
    u1: 0,
    u2: 0,
    underlinePosition: 1,
    "underline-position": "underlinePosition",
    underlineThickness: 1,
    "underline-thickness": "underlineThickness",
    unicode: 0,
    unicodeBidi: 1,
    "unicode-bidi": "unicodeBidi",
    unicodeRange: 1,
    "unicode-range": "unicodeRange",
    unitsPerEm: 1,
    "units-per-em": "unitsPerEm",
    unselectable: 0,
    vAlphabetic: 1,
    "v-alphabetic": "vAlphabetic",
    values: 0,
    vectorEffect: 1,
    "vector-effect": "vectorEffect",
    version: 0,
    vertAdvY: 1,
    "vert-adv-y": "vertAdvY",
    vertOriginX: 1,
    "vert-origin-x": "vertOriginX",
    vertOriginY: 1,
    "vert-origin-y": "vertOriginY",
    vHanging: 1,
    "v-hanging": "vHanging",
    vIdeographic: 1,
    "v-ideographic": "vIdeographic",
    viewBox: 1,
    viewTarget: 1,
    visibility: 0,
    vMathematical: 1,
    "v-mathematical": "vMathematical",
    vocab: 0,
    widths: 0,
    wordSpacing: 1,
    "word-spacing": "wordSpacing",
    writingMode: 1,
    "writing-mode": "writingMode",
    x1: 0,
    x2: 0,
    x: 0,
    xChannelSelector: 1,
    xHeight: 1,
    "x-height": "xHeight",
    xlinkActuate: 1,
    "xlink:actuate": "xlinkActuate",
    xlinkArcrole: 1,
    "xlink:arcrole": "xlinkArcrole",
    xlinkHref: 1,
    "xlink:href": "xlinkHref",
    xlinkRole: 1,
    "xlink:role": "xlinkRole",
    xlinkShow: 1,
    "xlink:show": "xlinkShow",
    xlinkTitle: 1,
    "xlink:title": "xlinkTitle",
    xlinkType: 1,
    "xlink:type": "xlinkType",
    xmlBase: 1,
    "xml:base": "xmlBase",
    xmlLang: 1,
    "xml:lang": "xmlLang",
    xmlns: 0,
    "xml:space": "xmlSpace",
    xmlnsXlink: 1,
    "xmlns:xlink": "xmlnsXlink",
    xmlSpace: 1,
    y1: 0,
    y2: 0,
    y: 0,
    yChannelSelector: 1,
    z: 0,
    zoomAndPan: 1
};


var $0840bf372bb785c9$var$CAMELCASE = $a9ddea9fff9a59d9$export$5ab28d07cff57c11, $0840bf372bb785c9$var$SAME = $a9ddea9fff9a59d9$export$7359a57b3ac1f378, $0840bf372bb785c9$var$possibleStandardNamesOptimized = $a9ddea9fff9a59d9$export$bbecfff5ecf65cd8;
var $0840bf372bb785c9$var$ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
var $0840bf372bb785c9$var$ATTRIBUTE_NAME_CHAR = $0840bf372bb785c9$var$ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
/**
 * Checks whether a property name is a custom attribute.
 *
 * @see {@link https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/HTMLDOMPropertyConfig.js#L23-L25}
 *
 * @param {string}
 * @return {boolean}
 */ var $0840bf372bb785c9$var$isCustomAttribute = RegExp.prototype.test.bind(new RegExp("^(data|aria)-[" + $0840bf372bb785c9$var$ATTRIBUTE_NAME_CHAR + "]*$"));
var $0840bf372bb785c9$var$possibleStandardNames = Object.keys($0840bf372bb785c9$var$possibleStandardNamesOptimized).reduce(function(accumulator, standardName) {
    var propName = $0840bf372bb785c9$var$possibleStandardNamesOptimized[standardName];
    if (propName === $0840bf372bb785c9$var$SAME) accumulator[standardName] = standardName;
    else if (propName === $0840bf372bb785c9$var$CAMELCASE) accumulator[standardName.toLowerCase()] = standardName;
    else accumulator[standardName] = propName;
    return accumulator;
}, {});
$0840bf372bb785c9$exports.BOOLEAN = $0840bf372bb785c9$var$BOOLEAN;
$0840bf372bb785c9$exports.BOOLEANISH_STRING = $0840bf372bb785c9$var$BOOLEANISH_STRING;
$0840bf372bb785c9$exports.NUMERIC = $0840bf372bb785c9$var$NUMERIC;
$0840bf372bb785c9$exports.OVERLOADED_BOOLEAN = $0840bf372bb785c9$var$OVERLOADED_BOOLEAN;
$0840bf372bb785c9$exports.POSITIVE_NUMERIC = $0840bf372bb785c9$var$POSITIVE_NUMERIC;
$0840bf372bb785c9$exports.RESERVED = $0840bf372bb785c9$var$RESERVED;
$0840bf372bb785c9$exports.STRING = $0840bf372bb785c9$var$STRING;
$0840bf372bb785c9$exports.getPropertyInfo = $0840bf372bb785c9$var$getPropertyInfo;
$0840bf372bb785c9$exports.isCustomAttribute = $0840bf372bb785c9$var$isCustomAttribute;
$0840bf372bb785c9$exports.possibleStandardNames = $0840bf372bb785c9$var$possibleStandardNames;


var $ac535f8559572213$exports = {};

var $acw62 = parcelRequire("acw62");
var $71148f37a304a9c5$exports = {};
"use strict";
var $71148f37a304a9c5$var$__importDefault = $71148f37a304a9c5$exports && $71148f37a304a9c5$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
$71148f37a304a9c5$exports.__esModule = true;

var $71148f37a304a9c5$var$style_to_object_1 = $71148f37a304a9c5$var$__importDefault((parcelRequire("8SsuU")));
var $f5184b1855e76cde$export$1e511d4a378977f5;
var $f5184b1855e76cde$export$8a7688a96d852767;
"use strict";
$f5184b1855e76cde$export$1e511d4a378977f5 = true;
$f5184b1855e76cde$export$8a7688a96d852767 = void 0;
var $f5184b1855e76cde$var$CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9-]+$/;
var $f5184b1855e76cde$var$HYPHEN_REGEX = /-([a-z])/g;
var $f5184b1855e76cde$var$NO_HYPHEN_REGEX = /^[^-]+$/;
var $f5184b1855e76cde$var$VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var $f5184b1855e76cde$var$MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
var $f5184b1855e76cde$var$skipCamelCase = function(property) {
    return !property || $f5184b1855e76cde$var$NO_HYPHEN_REGEX.test(property) || $f5184b1855e76cde$var$CUSTOM_PROPERTY_REGEX.test(property);
};
var $f5184b1855e76cde$var$capitalize = function(match, character) {
    return character.toUpperCase();
};
var $f5184b1855e76cde$var$trimHyphen = function(match, prefix) {
    return "".concat(prefix, "-");
};
var $f5184b1855e76cde$var$camelCase = function(property, options) {
    if (options === void 0) options = {};
    if ($f5184b1855e76cde$var$skipCamelCase(property)) return property;
    property = property.toLowerCase();
    if (options.reactCompat) property = property.replace($f5184b1855e76cde$var$MS_VENDOR_PREFIX_REGEX, $f5184b1855e76cde$var$trimHyphen);
    else property = property.replace($f5184b1855e76cde$var$VENDOR_PREFIX_REGEX, $f5184b1855e76cde$var$trimHyphen);
    return property.replace($f5184b1855e76cde$var$HYPHEN_REGEX, $f5184b1855e76cde$var$capitalize);
};
$f5184b1855e76cde$export$8a7688a96d852767 = $f5184b1855e76cde$var$camelCase;


function $71148f37a304a9c5$var$StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== "string") return output;
    (0, $71148f37a304a9c5$var$style_to_object_1["default"])(style, function(property, value) {
        if (property && value) output[(0, $f5184b1855e76cde$export$8a7688a96d852767)(property, options)] = value;
    });
    return output;
}
$71148f37a304a9c5$exports["default"] = $71148f37a304a9c5$var$StyleToJS;


var $ac535f8559572213$require$styleToJS = $71148f37a304a9c5$exports.default;
/**
 * Swap key with value in an object.
 *
 * @param {object} obj - The object.
 * @param {Function} [override] - The override method.
 * @returns - The inverted object.
 */ function $ac535f8559572213$var$invertObject(obj, override) {
    if (!obj || typeof obj !== "object") throw new TypeError("First argument must be an object");
    var key;
    var value;
    var isOverridePresent = typeof override === "function";
    var overrides = {};
    var result = {};
    for(key in obj){
        value = obj[key];
        if (isOverridePresent) {
            overrides = override(key, value);
            if (overrides && overrides.length === 2) {
                result[overrides[0]] = overrides[1];
                continue;
            }
        }
        if (typeof value === "string") result[value] = key;
    }
    return result;
}
/**
 * Check if a given tag is a custom component.
 *
 * @see {@link https://github.com/facebook/react/blob/v16.6.3/packages/react-dom/src/shared/isCustomComponent.js}
 *
 * @param {string} tagName - The name of the html tag.
 * @param {object} props - The props being passed to the element.
 * @returns - Whether tag is custom component.
 */ function $ac535f8559572213$var$isCustomComponent(tagName, props) {
    if (tagName.indexOf("-") === -1) return props && typeof props.is === "string";
    switch(tagName){
        // These are reserved SVG and MathML elements.
        // We don't mind this whitelist too much because we expect it to never grow.
        // The alternative is to track the namespace in a few places which is convoluted.
        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return false;
        default:
            return true;
    }
}
var $ac535f8559572213$var$styleToJSOptions = {
    reactCompat: true
};
/**
 * Sets style prop.
 *
 * @param {null|undefined|string} style
 * @param {object} props
 */ function $ac535f8559572213$var$setStyleProp(style, props) {
    if (style === null || style === undefined) return;
    try {
        props.style = $ac535f8559572213$require$styleToJS(style, $ac535f8559572213$var$styleToJSOptions);
    } catch (err) {
        props.style = {};
    }
}
/**
 * @constant {boolean}
 * @see {@link https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html}
 */ var $ac535f8559572213$var$PRESERVE_CUSTOM_ATTRIBUTES = $acw62.version.split(".")[0] >= 16;
// Taken from
// https://github.com/facebook/react/blob/cae635054e17a6f107a39d328649137b83f25972/packages/react-dom/src/client/validateDOMNesting.js#L213
var $ac535f8559572213$var$elementsWithNoTextChildren = new Set([
    "tr",
    "tbody",
    "thead",
    "tfoot",
    "colgroup",
    "table",
    "head",
    "html",
    "frameset"
]);
/**
 * Checks if the given node can contain text nodes
 *
 * @param {DomElement} node - Node.
 * @returns - Whether node can contain text nodes.
 */ function $ac535f8559572213$var$canTextBeChildOfNode(node) {
    return !$ac535f8559572213$var$elementsWithNoTextChildren.has(node.name);
}
$ac535f8559572213$exports = {
    PRESERVE_CUSTOM_ATTRIBUTES: $ac535f8559572213$var$PRESERVE_CUSTOM_ATTRIBUTES,
    invertObject: $ac535f8559572213$var$invertObject,
    isCustomComponent: $ac535f8559572213$var$isCustomComponent,
    setStyleProp: $ac535f8559572213$var$setStyleProp,
    canTextBeChildOfNode: $ac535f8559572213$var$canTextBeChildOfNode,
    elementsWithNoTextChildren: $ac535f8559572213$var$elementsWithNoTextChildren
};


/**
 * Converts HTML/SVG DOM attributes to React props.
 *
 * @param {object} [attributes={}] - HTML/SVG DOM attributes.
 * @returns - React props.
 */ $3239e52599398978$exports = function attributesToProps(attributes) {
    attributes = attributes || {};
    var valueOnlyInputs = {
        reset: true,
        submit: true
    };
    var attributeName;
    var attributeNameLowerCased;
    var attributeValue;
    var propName;
    var propertyInfo;
    var props = {};
    var inputIsValueOnly = attributes.type && valueOnlyInputs[attributes.type];
    for(attributeName in attributes){
        attributeValue = attributes[attributeName];
        // ARIA (aria-*) or custom data (data-*) attribute
        if ($0840bf372bb785c9$exports.isCustomAttribute(attributeName)) {
            props[attributeName] = attributeValue;
            continue;
        }
        // convert HTML/SVG attribute to React prop
        attributeNameLowerCased = attributeName.toLowerCase();
        propName = $3239e52599398978$var$getPropName(attributeNameLowerCased);
        if (propName) {
            propertyInfo = $0840bf372bb785c9$exports.getPropertyInfo(propName);
            // convert attribute to uncontrolled component prop (e.g., `value` to `defaultValue`)
            // https://reactjs.org/docs/uncontrolled-components.html
            if ((propName === "checked" || propName === "value") && !inputIsValueOnly) propName = $3239e52599398978$var$getPropName("default" + attributeNameLowerCased);
            props[propName] = attributeValue;
            switch(propertyInfo && propertyInfo.type){
                case $0840bf372bb785c9$exports.BOOLEAN:
                    props[propName] = true;
                    break;
                case $0840bf372bb785c9$exports.OVERLOADED_BOOLEAN:
                    if (attributeValue === "") props[propName] = true;
                    break;
            }
            continue;
        }
        // preserve custom attribute if React >=16
        if ($ac535f8559572213$exports.PRESERVE_CUSTOM_ATTRIBUTES) props[attributeName] = attributeValue;
    }
    // transform inline style to object
    $ac535f8559572213$exports.setStyleProp(attributes.style, props);
    return props;
};
/**
 * Gets prop name from lowercased attribute name.
 *
 * @param {string} attributeName - Lowercased attribute name.
 * @returns - Prop name.
 */ function $3239e52599398978$var$getPropName(attributeName) {
    return $0840bf372bb785c9$exports.possibleStandardNames[attributeName];
}



var $d0ba187f52746566$var$setStyleProp = $ac535f8559572213$exports.setStyleProp;
var $d0ba187f52746566$var$canTextBeChildOfNode = $ac535f8559572213$exports.canTextBeChildOfNode;
/**
 * Converts DOM nodes to JSX element(s).
 *
 * @param {DomElement[]} nodes - DOM nodes.
 * @param {object} [options={}] - Options.
 * @param {Function} [options.replace] - Replacer.
 * @param {object} [options.library] - Library (React, Preact, etc.).
 * @returns - String or JSX element(s).
 */ function $d0ba187f52746566$var$domToReact(nodes, options) {
    options = options || {};
    var library = options.library || $acw62;
    var cloneElement = library.cloneElement;
    var createElement = library.createElement;
    var isValidElement = library.isValidElement;
    var result = [];
    var node;
    var isWhitespace;
    var hasReplace = typeof options.replace === "function";
    var replaceElement;
    var props;
    var children;
    var trim = options.trim;
    for(var i = 0, len = nodes.length; i < len; i++){
        node = nodes[i];
        // replace with custom React element (if present)
        if (hasReplace) {
            replaceElement = options.replace(node);
            if (isValidElement(replaceElement)) {
                // set "key" prop for sibling elements
                // https://fb.me/react-warning-keys
                if (len > 1) replaceElement = cloneElement(replaceElement, {
                    key: replaceElement.key || i
                });
                result.push(replaceElement);
                continue;
            }
        }
        if (node.type === "text") {
            isWhitespace = !node.data.trim().length;
            if (isWhitespace && node.parent && !$d0ba187f52746566$var$canTextBeChildOfNode(node.parent)) continue;
            if (trim && isWhitespace) continue;
            // We have a text node that's not whitespace and it can be nested
            // in its parent so add it to the results
            result.push(node.data);
            continue;
        }
        props = node.attribs;
        if ($d0ba187f52746566$var$skipAttributesToProps(node)) $d0ba187f52746566$var$setStyleProp(props.style, props);
        else if (props) props = $3239e52599398978$exports(props);
        children = null;
        switch(node.type){
            case "script":
            case "style":
                // prevent text in <script> or <style> from being escaped
                // https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
                if (node.children[0]) props.dangerouslySetInnerHTML = {
                    __html: node.children[0].data
                };
                break;
            case "tag":
                // setting textarea value in children is an antipattern in React
                // https://reactjs.org/docs/forms.html#the-textarea-tag
                if (node.name === "textarea" && node.children[0]) props.defaultValue = node.children[0].data;
                else if (node.children && node.children.length) // continue recursion of creating React elements (if applicable)
                children = $d0ba187f52746566$var$domToReact(node.children, options);
                break;
            // skip all other cases (e.g., comment)
            default:
                continue;
        }
        // set "key" prop for sibling elements
        // https://fb.me/react-warning-keys
        if (len > 1) props.key = i;
        result.push(createElement(node.name, props, children));
    }
    return result.length === 1 ? result[0] : result;
}
/**
 * Determines whether DOM element attributes should be transformed to props.
 * Web Components should not have their attributes transformed except for `style`.
 *
 * @param {DomElement} node
 * @returns - Whether node attributes should be converted to props.
 */ function $d0ba187f52746566$var$skipAttributesToProps(node) {
    return $ac535f8559572213$exports.PRESERVE_CUSTOM_ATTRIBUTES && node.type === "tag" && $ac535f8559572213$exports.isCustomComponent(node.name, node.attribs);
}
$d0ba187f52746566$exports = $d0ba187f52746566$var$domToReact;



var $7592383cd1426d1f$exports = {};

$parcel$defineInteropFlag($7592383cd1426d1f$exports);

$parcel$export($7592383cd1426d1f$exports, "default", () => $7592383cd1426d1f$export$2e2bcd8739ae039);
var $d7455ff9112a8deb$exports = {};
var $bbc86b70d21ac339$exports = {};
// constants
var $bbc86b70d21ac339$var$HTML = "html";
var $bbc86b70d21ac339$var$HEAD = "head";
var $bbc86b70d21ac339$var$BODY = "body";
var $bbc86b70d21ac339$var$FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/; // e.g., <h1>
var $bbc86b70d21ac339$var$HEAD_TAG_REGEX = /<head.*>/i;
var $bbc86b70d21ac339$var$BODY_TAG_REGEX = /<body.*>/i;
// falls back to `parseFromString` if `createHTMLDocument` cannot be used
var $bbc86b70d21ac339$var$parseFromDocument = function() {
    throw new Error("This browser does not support `document.implementation.createHTMLDocument`");
};
var $bbc86b70d21ac339$var$parseFromString = function() {
    throw new Error("This browser does not support `DOMParser.prototype.parseFromString`");
};
/**
 * DOMParser (performance: slow).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMParser#Parsing_an_SVG_or_HTML_document
 */ if (typeof window.DOMParser === "function") {
    var $bbc86b70d21ac339$var$domParser = new window.DOMParser();
    var $bbc86b70d21ac339$var$mimeType = "text/html";
    /**
   * Creates an HTML document using `DOMParser.parseFromString`.
   *
   * @param  {string} html      - The HTML string.
   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
   * @return {HTMLDocument}
   */ $bbc86b70d21ac339$var$parseFromString = function(html, tagName) {
        if (tagName) html = "<" + tagName + ">" + html + "</" + tagName + ">";
        return $bbc86b70d21ac339$var$domParser.parseFromString(html, $bbc86b70d21ac339$var$mimeType);
    };
    $bbc86b70d21ac339$var$parseFromDocument = $bbc86b70d21ac339$var$parseFromString;
}

/**
 * DOMImplementation (performance: fair).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMImplementation/createHTMLDocument
 */ if (document.implementation) {
    var $bbc86b70d21ac339$var$isIE = (parcelRequire("bbrtK")).isIE;
    // title parameter is required in IE
    // https://msdn.microsoft.com/en-us/library/ff975457(v=vs.85).aspx
    var $bbc86b70d21ac339$var$doc = document.implementation.createHTMLDocument($bbc86b70d21ac339$var$isIE() ? "html-dom-parser" : undefined);
    /**
   * Use HTML document created by `document.implementation.createHTMLDocument`.
   *
   * @param  {string} html      - The HTML string.
   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
   * @return {HTMLDocument}
   */ $bbc86b70d21ac339$var$parseFromDocument = function(html, tagName) {
        if (tagName) {
            $bbc86b70d21ac339$var$doc.documentElement.getElementsByTagName(tagName)[0].innerHTML = html;
            return $bbc86b70d21ac339$var$doc;
        }
        $bbc86b70d21ac339$var$doc.documentElement.innerHTML = html;
        return $bbc86b70d21ac339$var$doc;
    };
}
/**
 * Template (performance: fast).
 *
 * @see https://developer.mozilla.org/docs/Web/HTML/Element/template
 */ var $bbc86b70d21ac339$var$template = document.createElement("template");
var $bbc86b70d21ac339$var$parseFromTemplate;
if ($bbc86b70d21ac339$var$template.content) /**
   * Uses a template element (content fragment) to parse HTML.
   *
   * @param  {string} html - The HTML string.
   * @return {NodeList}
   */ $bbc86b70d21ac339$var$parseFromTemplate = function(html) {
    $bbc86b70d21ac339$var$template.innerHTML = html;
    return $bbc86b70d21ac339$var$template.content.childNodes;
};
/**
 * Parses HTML string to DOM nodes.
 *
 * @param  {string}   html - HTML markup.
 * @return {NodeList}
 */ function $bbc86b70d21ac339$var$domparser(html) {
    var firstTagName;
    var match = html.match($bbc86b70d21ac339$var$FIRST_TAG_REGEX);
    if (match && match[1]) firstTagName = match[1].toLowerCase();
    var doc;
    var element;
    var elements;
    switch(firstTagName){
        case $bbc86b70d21ac339$var$HTML:
            doc = $bbc86b70d21ac339$var$parseFromString(html);
            // the created document may come with filler head/body elements,
            // so make sure to remove them if they don't actually exist
            if (!$bbc86b70d21ac339$var$HEAD_TAG_REGEX.test(html)) {
                element = doc.getElementsByTagName($bbc86b70d21ac339$var$HEAD)[0];
                if (element) element.parentNode.removeChild(element);
            }
            if (!$bbc86b70d21ac339$var$BODY_TAG_REGEX.test(html)) {
                element = doc.getElementsByTagName($bbc86b70d21ac339$var$BODY)[0];
                if (element) element.parentNode.removeChild(element);
            }
            return doc.getElementsByTagName($bbc86b70d21ac339$var$HTML);
        case $bbc86b70d21ac339$var$HEAD:
        case $bbc86b70d21ac339$var$BODY:
            elements = $bbc86b70d21ac339$var$parseFromDocument(html).getElementsByTagName(firstTagName);
            // if there's a sibling element, then return both elements
            if ($bbc86b70d21ac339$var$BODY_TAG_REGEX.test(html) && $bbc86b70d21ac339$var$HEAD_TAG_REGEX.test(html)) return elements[0].parentNode.childNodes;
            return elements;
        // low-level tag or text
        default:
            if ($bbc86b70d21ac339$var$parseFromTemplate) return $bbc86b70d21ac339$var$parseFromTemplate(html);
            return $bbc86b70d21ac339$var$parseFromDocument(html, $bbc86b70d21ac339$var$BODY).getElementsByTagName($bbc86b70d21ac339$var$BODY)[0].childNodes;
    }
}
$bbc86b70d21ac339$exports = $bbc86b70d21ac339$var$domparser;



var $bbrtK = parcelRequire("bbrtK");
var $d7455ff9112a8deb$require$formatDOM = $bbrtK.formatDOM;
var $d7455ff9112a8deb$var$DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/; // e.g., <!doctype html>
/**
 * Parses HTML string to DOM nodes in browser.
 *
 * @param  {string} html  - HTML markup.
 * @return {DomElement[]} - DOM elements.
 */ function $d7455ff9112a8deb$var$HTMLDOMParser(html) {
    if (typeof html !== "string") throw new TypeError("First argument must be a string");
    if (html === "") return [];
    // match directive
    var match = html.match($d7455ff9112a8deb$var$DIRECTIVE_REGEX);
    var directive;
    if (match && match[1]) directive = match[1];
    return $d7455ff9112a8deb$require$formatDOM($bbc86b70d21ac339$exports(html), null, directive);
}
$d7455ff9112a8deb$exports = $d7455ff9112a8deb$var$HTMLDOMParser;


var $7592383cd1426d1f$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($d7455ff9112a8deb$exports)));


var $91fb32bbe67abcd9$require$htmlToDOM = $7592383cd1426d1f$exports;
// support backwards compatibility for ES Module
$91fb32bbe67abcd9$require$htmlToDOM = /* istanbul ignore next */ typeof $91fb32bbe67abcd9$require$htmlToDOM.default === "function" ? $91fb32bbe67abcd9$require$htmlToDOM.default : $91fb32bbe67abcd9$require$htmlToDOM;
var $91fb32bbe67abcd9$var$domParserOptions = {
    lowerCaseAttributeNames: false
};
/**
 * Converts HTML string to React elements.
 *
 * @param {string} html - HTML string.
 * @param {object} [options] - Parser options.
 * @param {object} [options.htmlparser2] - htmlparser2 options.
 * @param {object} [options.library] - Library for React, Preact, etc.
 * @param {Function} [options.replace] - Replace method.
 * @returns {JSX.Element|JSX.Element[]|string} - React element(s), empty array, or string.
 */ function $91fb32bbe67abcd9$var$HTMLReactParser(html, options) {
    if (typeof html !== "string") throw new TypeError("First argument must be a string");
    if (html === "") return [];
    options = options || {};
    return $d0ba187f52746566$exports($91fb32bbe67abcd9$require$htmlToDOM(html, options.htmlparser2 || $91fb32bbe67abcd9$var$domParserOptions), options);
}
$91fb32bbe67abcd9$var$HTMLReactParser.domToReact = $d0ba187f52746566$exports;
$91fb32bbe67abcd9$var$HTMLReactParser.htmlToDOM = $91fb32bbe67abcd9$require$htmlToDOM;
$91fb32bbe67abcd9$var$HTMLReactParser.attributesToProps = $3239e52599398978$exports;

$91fb32bbe67abcd9$var$HTMLReactParser.Element = (parcelRequire("2UBPZ")).Element;
// support CommonJS and ES Modules
$91fb32bbe67abcd9$exports = $91fb32bbe67abcd9$var$HTMLReactParser;
$91fb32bbe67abcd9$exports.default = $91fb32bbe67abcd9$var$HTMLReactParser;


var $59166f144ce3d0bc$export$562c76a291853ae = (0, (/*@__PURE__*/$parcel$interopDefault($91fb32bbe67abcd9$exports))).domToReact;
var $59166f144ce3d0bc$export$131c6d55a47cefc8 = (0, (/*@__PURE__*/$parcel$interopDefault($91fb32bbe67abcd9$exports))).htmlToDOM;
var $59166f144ce3d0bc$export$af8e902ee50b21fc = (0, (/*@__PURE__*/$parcel$interopDefault($91fb32bbe67abcd9$exports))).attributesToProps;
var $59166f144ce3d0bc$export$db77ccec0bb4ccac = (0, (/*@__PURE__*/$parcel$interopDefault($91fb32bbe67abcd9$exports))).Element;
var $59166f144ce3d0bc$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($91fb32bbe67abcd9$exports)));



var $f1q41 = parcelRequire("f1q41");

var $igqD6 = parcelRequire("igqD6");

const $d79fcc86840adac0$export$7acfa6ed01010e37 = ({ html: html, className: className, ...props })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d4d1bba653c6d14$export$6955bcca4cd3539f), {
        className: (0, $igqD6.cx)(className, $d79fcc86840adac0$var$codeCss),
        ...props,
        children: $d79fcc86840adac0$export$443991c2a30388c6(html)
    });
};
const $d79fcc86840adac0$var$codeCss = (0, $igqD6.css)`
& {

  *:before,
  *:after {
    color: rgb(90, 155, 230);
  }
  /* generic block-level elements */

  code.language-html,
  code.lang-html {
    display: block;
    white-space: pre;
    overflow: hidden;
    color: rgb(90, 90, 90);
    line-height: 1.2em;
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  /* Generic Inline Elements */
  [data-block-tag] {
    display: block;
  }

  [data-inline-tag],
  [data-self-closing-tag] {
    display: inline;
  }

  [data-block-tag],
  [data-inline-tag],
  [data-self-closing-tag] {
    &[data-inline-tag="header"]>header {
      padding-top: 2.4rem
    }

    [data-self-closing-tag]:before {
      content: "<" attr(data-self-closing-tag) " ";
    }

    [data-self-closing-tag]:after {
      content: " />";
      display: inline-block;
      white-space: pre;
    }

    [data-tag-start]::before {
      content: "<" attr(data-tag-start);
    }

    [data-tag-start]::after {
      content: "> ";
    }

    [data-tag-attr]:before,
    [data-tag-attr]:before {
      color: rgb(110, 192, 56);
      content: ' ' attr(data-tag-attr);
    }

    [data-tag-attr]:after,
    [data-tag-attr]:after {
      color: rgb(198, 198, 198);
      content: '=';
    }

    [data-tag-string] {
      color: orange;
    }

    [data-tag-string]:before,
    [data-tag-string]:after {
      color: orange;
      content: '"';
    }

    [data-tag-string] {
      color: orange;
    }

    [data-tag-string]:before,
    [data-tag-string]:after {
      color: orange;
      content: '"';
    }

    [data-tag-content] {
      display: block;
      padding: 0 2em;
    }

    [data-tag-end]::before {
      content: " </" attr(data-tag-end);
    }

    [data-tag-end]::after {
      content: "> ";
    }
  }

  a {
    display: flex;

    background: transparent;

    &:hover > [data-self-closing-tag="link"] {
        background: #2e5c00;
    }
  }

  .horizontal-rule {
    white-space: nowrap;
    overflow: hidden;
  }

  code {
    font-family: Source Code Pro Woff, Monaco, monospace;
    color: orange;
  }
}
`;
function $d79fcc86840adac0$export$443991c2a30388c6(string) {
    const options = {
        replace: (domNode)=>{
            let { name: name, children: children, attribs: attribs } = domNode;
            // if it doesn't have a name, don't replace it
            if (!name) return;
            // yeah, don't do anything with the head tag
            if (name === "head") return "";
            let ElementToUse = $d79fcc86840adac0$var$CustomElements[name] || $d79fcc86840adac0$var$Element;
            return /*#__PURE__*/ (0, $ayMG0.jsx)(ElementToUse, {
                type: name,
                ...(0, $59166f144ce3d0bc$export$af8e902ee50b21fc)(attribs),
                children: (0, $59166f144ce3d0bc$export$562c76a291853ae)(children, options)
            });
        }
    };
    return (0, $59166f144ce3d0bc$export$2e2bcd8739ae039)(string.split("\n").map((line)=>{
        if (line.trim() === "") return "<br>";
        else return line;
    }).join("\n"), options)[1];
}
/*
this is the core of the site.
we take html elements from an index file, turn them into JSX, read that JSX, and turn it into expressive JSX.
example:
  content.html:

  ```
  <header> I'm Nathaniel Hutchins </header>
  ```

  becomes

  ```
  <header-tag data-inline-tag="header">
    <header-start data-tag-start="header"></header-start>
    <header id="im-nathaniel-hutchins">  I'm Nathaniel Hutchins  </header>
    <header-end data-tag-end="header"></header-end>
  </header-tag>
  ```
*/ // some basic defaults
/**
 * Shamelessly stolen from markdown-to-jsx
 *
 * https://github.com/probablyup/markdown-to-jsx/blob/bc2f57412332dc670f066320c0f38d0252e0f057/index.js#L261-L275
 */ function $d79fcc86840adac0$var$slugify(str = "") {
    return str.trim().replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
const $d79fcc86840adac0$var$Element = ({ children: children, type: type, display: display = "block", as: as, asProps: asProps = {}, ...attributes })=>{
    let Tag = `${type}-tag`;
    let TagBegin = `${type}-start`;
    let AttrKey = `${type}-attrkey`;
    let AttrVal = `${type}-attrval`;
    let TagAs = as || type;
    let TagEnd = `${type}-end`;
    if (attributes.htmlFor) {
        attributes.for = attributes.htmlFor;
        delete attributes.htmlFor;
    }
    if (display === "inline") {
        if (children) return /*#__PURE__*/ (0, $ayMG0.jsxs)(Tag, {
            "data-inline-tag": type,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)(TagBegin, {
                    "data-tag-start": type,
                    children: Object.entries(attributes).map(([key, value])=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)(AttrKey, {
                                    "data-tag-attr": key
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)(AttrVal, {
                                    "data-tag-string": true,
                                    children: value
                                })
                            ]
                        }, key))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)(TagAs, {
                    ...asProps,
                    children: [
                        " ",
                        children,
                        " "
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)(TagEnd, {
                    "data-tag-end": type
                })
            ]
        });
        else return /*#__PURE__*/ (0, $ayMG0.jsx)(Tag, {
            "data-self-closing-tag": type,
            children: Object.entries(attributes).map(([key, value])=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)(AttrKey, {
                            "data-tag-attr": key
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)(AttrVal, {
                            "data-tag-string": true,
                            children: value
                        })
                    ]
                }, key))
        });
    } else if (display === "block") return /*#__PURE__*/ (0, $ayMG0.jsxs)(Tag, {
        "data-block-tag": type,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(TagBegin, {
                "data-tag-start": type,
                children: Object.entries(attributes).map(([key, value])=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)(AttrKey, {
                                "data-tag-attr": key
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)(AttrVal, {
                                "data-tag-string": true,
                                children: value
                            })
                        ]
                    }, key))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(TagAs, {
                "data-tag-content": type,
                ...asProps,
                children: children
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(TagEnd, {
                "data-tag-end": type
            })
        ]
    });
    return null;
};
function $d79fcc86840adac0$var$getTreeText(children) {
    let text = "";
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (child)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(child, "props.children")) text += $d79fcc86840adac0$var$getTreeText(child.props.children);
        else text += child;
    });
    return text;
}
const $d79fcc86840adac0$var$Header = ({ children: children, as: as = "header" })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d79fcc86840adac0$var$Element, {
        display: "inline",
        type: "header",
        as: as,
        asProps: {
            id: $d79fcc86840adac0$var$slugify($d79fcc86840adac0$var$getTreeText(children))
        },
        children: children
    });
};
const $d79fcc86840adac0$var$Link = ({ url: url, to: to, hash: hash })=>{
    if (url && hash) throw new Error("Cannot have both hash and url for a link. hash:", hash, "url:", url);
    let props = {};
    if (hash) props.href = `#${$d79fcc86840adac0$var$slugify(hash)}`;
    else {
        props.href = url || to;
        if (props.href.startsWith("http")) props.target = "_blank";
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d79fcc86840adac0$var$Element, {
            type: "link",
            display: "inline",
            to: to || url || hash
        })
    });
};
const $d79fcc86840adac0$var$BannerImage = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("code", {
            className: "lang-html",
            children: [
                "<!--",
                children,
                "-->"
            ]
        })
    });
};
const $d79fcc86840adac0$var$Break = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: (0, $igqD6.css)` display: block; `,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
    });
};
const $d79fcc86840adac0$var$CustomElements = {
    link: $d79fcc86840adac0$var$Link,
    "banner-image": $d79fcc86840adac0$var$BannerImage,
    header: $d79fcc86840adac0$var$Header,
    br: $d79fcc86840adac0$var$Break,
    // using a functional component as a function
    // don't do this, probably
    paragraph: (props)=>$d79fcc86840adac0$var$Element({
            ...props,
            as: "p"
        }),
    body: (props)=>$d79fcc86840adac0$var$Element({
            ...props,
            as: "div"
        }),
    section: (props)=>$d79fcc86840adac0$var$Element({
            ...props
        }),
    navbar: (props)=>$d79fcc86840adac0$var$Element({
            ...props,
            as: "nav"
        })
};


const $bd51ae0e4c21d08e$var$mainPageHtml = '<body>\n\n  <navigation for="this site">\n    <link to="this page" url="/" />\n    <link to="name generator" url="/tt/ng" />\n    <link to="dice roller" url="/tt/dr" />\n    <link to="plot timeliner" url="/wt/tl" />\n  </navigation>\n\n  <navigation for="this page">\n    <link hash="I\'m Nathaniel Hutchins" />\n    <link hash="If you\'re a JS developer, you might like..." />\n    <link hash="no-boilerplate-redux: Reduce the reducers" />\n    <link hash="Framework Agnostic Libraries: Mithril in React" />\n    <link hash="Context Store: Single Source of Truth in React" />\n    <link hash="Contact" />\n  </navigation>\n\n  <header> I\'m Nathaniel Hutchins </header>\n\n  <paragraph>\n    I\'m a JavaScript Developer. I read books. I like ASCII art. The rest is irrelevant.\n  </paragraph>\n\n<banner-image>\n\n    ______                .          .                    .             .               . \n_,-\':IWWWW\\___    .      _____              \u2022        .         .               . .__  .   \n .:IIIIWWWWWWW\\__   _,--\'.;IWW\\_                      .               _,-----_ ,-\'  `--.  \n .:;IIIIIWWWWWWWW\\_/    .;IIWWIW\\_      .         .          \u2022   .  ,\'  ,, _  \\     __--\' \n  :;IIIWWWWWWWWWW;:   .:;IIIIWWWWWW\\_                               /,,__--\'  ,--_ _\'  \\. \n   .:;IIWWWWWWWWWW;.   :;IIIIIWWWWWWW\\__      .      .       .   ._--\' _-   /   )`__  `-. \n    ::IIIWWWWWWWWW:.   .;IIIWWWWWWWWWWI:M\\__             .     _-\'  /    /||     / `__   \\\n     ::;;;IIIIW;:.        .:;IIMMMWWWI:WWWWWW\\_    .          /  /    /||       ee   `__  \n       .:;;III:             ..:::IIII::WWWWWWWW\\           .,\' /   /||                 \\_ \n                             .........===~~~~~~~~~~~~~~~~~~/ /  /||~~~~~~~~~~~~~~~~~~~~~\\_\n                 ....... __--_ .--- \'     -       -       /  /||-  - -_ --__----__-- _- _\\\n  ...     ..  ......_ --\'      _                          |||    -_  -  -- __-- _ -- -_   \n...........  ......\'_                -        -               _    -   __ - __  -_  --  - \n...........  .......__   _     _       -      -_                  _ -   - __- _-_ --   -_ \n.........    ...........--- -____-- ____               _   -   _    -      -- __- -    _  \n.......    .............................~~-----__-----_----_--_--.- __- ___ _.__ _._ ____-\n.....   ...........  .....................................................................\n\n</banner-image>\n\n  <header>If you\'re a JS developer, you might like...</header>\n\n  <section>\n    <header> no-boilerplate-redux: Reduce the reducers </header>\n\n    <paragraph>\n      no-boilerplate-redux is an React+Redux tool that removes the need for Actions, Action Creators, and Reducers. Instead, it provides a simple interface for setting properties on a redux store. Even better -- no need to commit! no-boilerplate-redux can be used alongside vanilla reducers.\n    </paragraph>\n\n    <link to="npm/no-boilerplate-redux" url="https://www.npmjs.com/package/no-boilerplate-redux" />\n    <link to="github/no-boilerplate-redux" url="https://github.com/MynockSpit/no-boilerplate-redux" />\n  </section>\n\n  <section>\n    <header> Framework Agnostic Libraries: Mithril in React </header>\n\n    <paragraph>\n      An experiment in how you could make a library in one framework (Mithril) and use it in another (React). Not all that useful... unless you\'re building a component library and don\'t want to re-write it for every view layer out there.\n    </paragraph>\n\n    <link to="stackblitz/react-library-via-mithril" url="https://stackblitz.com/edit/react-library-via-mithril" />\n  </section>\n\n  <section>\n    <header> Context Store: Single Source of Truth in React </header>\n\n    <paragraph>\n      A reference implementation for how you might make a single-source-of-truth store in pure React. Use React-style syntax, add a global provider, then forget about needing to lift up state.\n    </paragraph>\n    \n    <link to="stackblitz/react-store" url="https://stackblitz.com/edit/react-store" />\n  </section>\n\n<banner-image>\n\n  ` : | | | |:  ||  :     `  :  |  |+|: | : : :|   .        `     .        .:||`        ` \n      ` : | :|  ||  |:  :    `  |  | :| : | : |:   |  .                    :|||  +        \n         .\' \':  ||  |:  |  \'       ` || | : | |: : |   .  `     +     .   :.||`      .   `\n                `\'  ||  |  \' |   *    ` : | | :| |*|  :   :               :|||            \n        *    *       `  |  : :  |  .      ` \' :| | :| . : :         *   :.|||` +          \n             .`            | |  |  : .:|       ` | || | : |: |          | |||             \n      \'          .         + `  |  :  .: .         \'| | : :| :    .   |:| ||   `          \n         .                 .    ` *|  || :       `    | | :| | :      |:| |       .       \n .                .          .        || |.: *          | || : :     :|||                 \n        .            .   . *    .   .  ` |||.  +        + \'| |||  .  ||`               `  \n     .             *              .     +:`|!             . ||||  :.||`                   \n +                      .                ..!|*          . | :`||+ |||`  `.       .        \n     .                         +      : |||`        .| :| | | |.| ||`     .            *  \n       *     +   \'               +  :|| |`     :.+. || || | |:`|| `                       \n                            .      .||` .    ..|| | |: \'` `| | |`  +              *       \n  .       +++                      ||        !|!: `       :| |                            \n              +         .      .    | .      `|||.:      .||    .      .    `          `  \n          \'                           `|.   .  `:|||   + ||\'     `              `         \n  __    +      *                         `\'       `\'|.    `:                         .   `\n"\'  `---"""----....____,..^---`^``----.,.___          `.    `.  .    ____,.,------.,.___  \n    ___,--\'""`---"\'   ^  ^ ^        ^       """\'---,..___ __,..---""\'       ^     ^ ^   `"\n--"\'                                 ^         ^               ``--..,__      ^           \n\n</banner-image>\n\n  <section>\n    <header> Contact </header>\n\n    <link to="Email/MynockSpit" url="mailto:mynockspit@gmail.com" />\n    <link to="Threads/MynockSpit" url="https://www.threads.net/@mynockspit" />\n    <link to="Github/MynockSpit" url="https://github.com/MynockSpit" />\n  </section>\n\n</body>';
const $bd51ae0e4c21d08e$export$b94310965bed44e6 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d79fcc86840adac0$export$7acfa6ed01010e37), {
        html: $bd51ae0e4c21d08e$var$mainPageHtml
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $gorid = parcelRequire("gorid");
(0, $gorid.Chart).register(...(0, $gorid.registerables));
var $5b117e7d5e461010$export$2e2bcd8739ae039 = (0, $gorid.Chart);




var $aphAM = parcelRequire("aphAM");parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $4RmmN = parcelRequire("4RmmN");

var $igqD6 = parcelRequire("igqD6");
(0, $5b117e7d5e461010$export$2e2bcd8739ae039).defaults.font.size = 14;
(0, $5b117e7d5e461010$export$2e2bcd8739ae039).defaults.font.family = "Arial";
const $7fda7cd463156458$export$bd0832b179ca357a = ()=>{
    const navigate = (0, $aphAM.useNavigate)();
    const loc = (0, $aphAM.useLocation)();
    const page = loc.pathname.replace("/tabletop-tools/", "").replace(/\/.*/, "");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3d4d1bba653c6d14$export$6955bcca4cd3539f), {
        expand: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4RmmN.default), {
                className: (0, $igqD6.css)`flex-shrink: 0;`,
                activeKey: page,
                onChange: (route)=>{
                    navigate(`/tabletop-tools/${route}`);
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4RmmN.default).TabPane, {
                        tab: "Dice Roller"
                    }, "dice-roller"),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4RmmN.default).TabPane, {
                        tab: "Name Generator"
                    }, "name-generator")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Outlet), {})
        ]
    });
};



var $hz7px = parcelRequire("hz7px");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $igqD6 = parcelRequire("igqD6");
var $efa84364dc18fe38$exports = {};
$efa84364dc18fe38$exports = JSON.parse('{"letters":{"0":{"0":10,"1":5,"2":5,"3":1,"_total":21},"1":{"0":2,"1":1,"4":1,"5":1,"6":3,"7":1,"8":2,"9":5,"_total":16},"2":{"0":14,"2":1,"3":1,"4":2,"_total":18},"3":{"0":3,"5":2,"_total":5},"4":{"0":1,"_total":1},"5":{"0":2,"2":1,"_total":3},"6":{"1":1,"7":1,"_total":2},"7":{"0":1,"_total":1},"8":{"0":1,"7":1,"_total":2},"9":{"0":1,"1":2,"8":2,"9":2,"_total":7}," ":{"0":3,"1":11,"2":20,"3":8,"4":4,"5":3,"6":3,"7":2,"9":3,"_total":2437,"a":278,"n":69,"e":85,"i":159,"d":54,"h":88,"s":197,"f":81,"w":128,"m":134,"o":142,"t":337,"c":163,"p":121,"b":88,"r":86,"u":27,"y":19,"v":19,"l":41,"q":1,"g":42,"j":11,"z":3,"k":7},"n":{"_total":750,"o":58,"g":134,"d":162,"t":79,"i":43,"y":7,"e":89,"s":38,"l":1,"a":34,"m":2,"n":17,"c":67,"k":8,"u":6,"f":4,"b":1},"o":{"_total":770,"r":164,"w":42,"n":160,"f":83,"a":5,"m":60,"u":103,"p":9,"o":18,"d":9,"v":13,"c":12,"t":28,"l":34,"g":3,"s":18,"b":2,"i":5,"y":1,"k":1},"e":{"_total":1092,"a":88,"r":232,"l":48,"n":145,"o":12,"w":25,"c":57,"v":14,"f":7,"q":1,"s":158,"e":28,"t":46,"d":80,"h":3,"i":17,"m":20,"y":21,"b":2,"x":37,"g":6,"p":21,"u":23,"k":1},"a":{"_total":953,"s":87,"v":24,"n":199,"l":92,"t":180,"y":44,"r":110,"w":9,"i":41,"c":39,"b":13,"k":14,"u":8,"g":17,"d":23,"f":8,"m":30,"p":13,"h":1,"j":1},"s":{"_total":466,"t":96,"n":17,"a":54,"i":51,"e":84,"s":46,"o":39,"h":25,"l":13,"u":20,"k":1,"p":10,"c":5,"y":2,"m":1,"f":2},"t":{"_total":867,"e":161,"h":265,"o":115,"u":21,"i":115,"s":44,"a":35,"y":31,"r":40,"t":28,"c":1,"l":6,"w":4,"p":1},"i":{"_total":866,"s":75,"v":23,"n":266,"e":53,"t":109,"g":22,"o":56,"l":30,"z":9,"b":7,"c":60,"r":24,"d":78,"m":16,"p":5,"a":18,"x":1,"k":9,"f":5},"d":{"_total":233,"e":53,"s":6,"a":60,"u":2,"i":75,"n":4,"o":20,"d":2,"l":1,"r":4,"y":4,"t":1,"v":1},"l":{"_total":344,"i":63,"o":25,"a":28,"d":23,"l":47,"e":73,"y":42,"s":15,"u":12,"p":1,"f":3,"m":2,"t":5,"v":2,"r":2,"w":1},"v":{"_total":100,"e":71,"y":1,"i":14,"o":8,"a":6},"r":{"_total":656,"i":72,"c":12,"e":233,"d":29,"t":59,"a":40,"n":30,"o":47,"k":10,"r":5,"v":5,"s":49,"g":10,"h":10,"m":14,"l":7,"y":7,"u":10,"w":1,"f":3,"b":1,"p":1,"j":1},"h":{"_total":445,"e":186,"t":13,"i":55,"a":105,"o":58,"r":6,"u":10,"l":3,"y":1,"m":7,"w":1},"f":{"_total":136,"i":19,"o":40,"a":17,"r":16,"l":4,"t":9,"e":13,"f":14,"u":4},"c":{"_total":427,"e":75,"h":46,"o":78,"a":94,"l":13,"t":44,"k":11,"y":7,"i":24,"n":4,"r":14,"c":4,"u":10,"s":3},"w":{"_total":175,"i":52,"a":23,"h":34,"f":3,"e":31,"n":6,"l":2,"u":1,"o":14,"s":4,"c":2,"r":1,"t":2},"m":{"_total":275,"u":5,"o":54,"e":84,"a":66,"i":29,"p":16,"b":14,"m":6,"n":1},"u":{"_total":282,"c":11,"r":47,"t":47,"l":29,"n":34,"s":45,"i":4,"a":3,"d":7,"g":11,"m":9,"p":19,"e":9,"b":7},"g":{"_total":150,"h":23,"l":6,"s":5,"e":40,"o":15,"i":13,"u":2,"g":3,"n":10,"t":1,"r":27,"a":4,"f":1},"p":{"_total":243,"a":35,"e":71,"l":13,"u":9,"p":12,"i":9,"r":27,"s":8,"h":5,"o":50,"t":4},"b":{"_total":131,"r":5,"e":48,"o":14,"l":25,"i":7,"y":8,"a":9,"u":13,"n":1,"s":1},"z":{"_total":15,"z":5,"a":8,"e":2},"y":{"_total":38,"o":18,"l":5,"s":5,"t":1,"c":3,"m":1,"p":1,"e":4},"k":{"_total":38,"i":7,"e":23,"s":3,"y":1,"n":2,"a":1,"g":1},"q":{"_total":2,"u":2},"j":{"_total":13,"e":3,"a":1,"o":4,"u":5},"x":{"_total":37,"c":1,"t":2,"p":32,"a":1,"e":1}},"wordLengths":{"1":124,"2":367,"3":386,"4":430,"5":270,"6":221,"7":186,"8":164,"9":105,"10":89,"11":36,"12":17,"13":36,"14":5,"18":1},"numberOfWords":2437}');



var $ggrpt = parcelRequire("ggrpt");
let $f4937a4a443bc2fd$var$cachedInputs = {};
function $f4937a4a443bc2fd$export$fad0cdf6ca34814a(inputText) {
    if (!$f4937a4a443bc2fd$var$cachedInputs[inputText]) {
        let model = {
            letters: {},
            wordLengths: {},
            numberOfWords: 0
        };
        // for the purpose of name generation, remove symbols
        let normalizedInputText = " " + inputText.toLowerCase().replace(/\W/g, " ").replace(/\s+/g, " ").trim();
        let thisWordLength = 0;
        normalizedInputText.split("").forEach((letter, index, allLetters)=>{
            let nextLetter = allLetters[index + 1] || " ";
            // handle word lengths
            if (letter !== " ") thisWordLength++;
            // handle end-of word stuff
            if (nextLetter === " " && thisWordLength > 0) {
                if (!model.wordLengths[thisWordLength]) model.wordLengths[thisWordLength] = 0;
                model.wordLengths[thisWordLength]++;
                model.numberOfWords++;
                thisWordLength = 0;
            }
            // handle next-letter probability
            // NOTE: "_total" is *NOT* a count of how many `letter` exists in the input string.
            // It is an indicator of how many `nextLetter`s we have found that follow `letter`.
            // This is an important distinction, because it means (for example) that the world
            // `small` will have a `_total` of 1 for the letter `l` and not 2. This is correct.
            // Don't "fix" this.
            if (nextLetter !== " ") {
                if (!model.letters[letter]) model.letters[letter] = {
                    _total: 0
                };
                if (!model.letters[letter][nextLetter]) model.letters[letter][nextLetter] = 0;
                model.letters[letter][nextLetter] += 1;
                model.letters[letter]._total += 1;
            }
        });
        $f4937a4a443bc2fd$var$cachedInputs[inputText] = model;
    }
    return $f4937a4a443bc2fd$var$cachedInputs[inputText];
}
function $f4937a4a443bc2fd$export$9aa50adaec601a13(markovDefinition, baseWord = "", { minLength: minLength = 3, maxLength: maxLength } = {}) {
    const alphabet = "abcdefghijklmnopqrstuvwxyz".split("");
    let { letters: letters, wordLengths: wordLengths, numberOfWords: numberOfWords } = markovDefinition;
    // great, so now that we have a chain of likely next characters, make a word out of it
    let word = baseWord;
    let wordLength;
    let currentLetter = " ";
    if (!maxLength) {
        // determine name length
        // We use the number of times a given word length appears as a weight. For example, if we
        // had 100 four letter words, and 1 five letter word, it's 100x more likely to get a 4 letter
        // word length than 5. We determine the length by determining the total number of words then
        // finding a random number between 0 and that total, then slowly subtracting word lengths
        // until the sum is less than zero.
        let wordLengthIndex = (0, $ggrpt.random)(numberOfWords);
        Object.entries(wordLengths).sort((a, b)=>a[0] - b[0]).find(([length, value])=>{
            wordLengthIndex -= value;
            if (wordLengthIndex <= 0) {
                wordLength = Math.max(length, minLength, baseWord.length);
                return true;
            }
            return undefined;
        });
    } else wordLength = (0, $ggrpt.random)(maxLength, minLength);
    // run until the internal logic breaks the loop
    while(true){
        let characterChoice = (0, $ggrpt.random)(letters[currentLetter]._total);
        if (word.length >= wordLength) break;
        for(let index = 0; index < alphabet.length; index++){
            let aleph = alphabet[index];
            let has = letters[currentLetter][aleph];
            if (has) characterChoice -= has;
            if (characterChoice <= 0) {
                word += aleph;
                currentLetter = aleph;
                break;
            }
        }
    }
    return word;
}



var $4Uh7a = parcelRequire("4Uh7a");
var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");
parcelRequire("3i86m");
var $lpQ06 = parcelRequire("lpQ06");

var $670jt = parcelRequire("670jt");

var $P8Drj = parcelRequire("P8Drj");
var $2LRCS = parcelRequire("2LRCS");
// ============================== Shared ==============================
const $798d9db240249fbb$var$genSharedDividerStyle = (token)=>{
    const { componentCls: componentCls, sizePaddingEdgeHorizontal: sizePaddingEdgeHorizontal, colorSplit: colorSplit, lineWidth: lineWidth, textPaddingInline: textPaddingInline, orientationMargin: orientationMargin, verticalMarginInline: verticalMarginInline } = token;
    return {
        [componentCls]: Object.assign(Object.assign({}, (0, $670jt.resetComponent)(token)), {
            borderBlockStart: `${(0, $lpQ06.unit)(lineWidth)} solid ${colorSplit}`,
            // vertical
            "&-vertical": {
                position: "relative",
                top: "-0.06em",
                display: "inline-block",
                height: "0.9em",
                marginInline: verticalMarginInline,
                marginBlock: 0,
                verticalAlign: "middle",
                borderTop: 0,
                borderInlineStart: `${(0, $lpQ06.unit)(lineWidth)} solid ${colorSplit}`
            },
            "&-horizontal": {
                display: "flex",
                clear: "both",
                width: "100%",
                minWidth: "100%",
                // Fix https://github.com/ant-design/ant-design/issues/10914
                margin: `${(0, $lpQ06.unit)(token.dividerHorizontalGutterMargin)} 0`
            },
            [`&-horizontal${componentCls}-with-text`]: {
                display: "flex",
                alignItems: "center",
                margin: `${(0, $lpQ06.unit)(token.dividerHorizontalWithTextGutterMargin)} 0`,
                color: token.colorTextHeading,
                fontWeight: 500,
                fontSize: token.fontSizeLG,
                whiteSpace: "nowrap",
                textAlign: "center",
                borderBlockStart: `0 ${colorSplit}`,
                "&::before, &::after": {
                    position: "relative",
                    width: "50%",
                    borderBlockStart: `${(0, $lpQ06.unit)(lineWidth)} solid transparent`,
                    // Chrome not accept `inherit` in `border-top`
                    borderBlockStartColor: "inherit",
                    borderBlockEnd: 0,
                    transform: "translateY(50%)",
                    content: "''"
                }
            },
            [`&-horizontal${componentCls}-with-text-left`]: {
                "&::before": {
                    width: `calc(${orientationMargin} * 100%)`
                },
                "&::after": {
                    width: `calc(100% - ${orientationMargin} * 100%)`
                }
            },
            [`&-horizontal${componentCls}-with-text-right`]: {
                "&::before": {
                    width: `calc(100% - ${orientationMargin} * 100%)`
                },
                "&::after": {
                    width: `calc(${orientationMargin} * 100%)`
                }
            },
            [`${componentCls}-inner-text`]: {
                display: "inline-block",
                paddingBlock: 0,
                paddingInline: textPaddingInline
            },
            "&-dashed": {
                background: "none",
                borderColor: colorSplit,
                borderStyle: "dashed",
                borderWidth: `${(0, $lpQ06.unit)(lineWidth)} 0 0`
            },
            [`&-horizontal${componentCls}-with-text${componentCls}-dashed`]: {
                "&::before, &::after": {
                    borderStyle: "dashed none none"
                }
            },
            [`&-vertical${componentCls}-dashed`]: {
                borderInlineStartWidth: lineWidth,
                borderInlineEnd: 0,
                borderBlockStart: 0,
                borderBlockEnd: 0
            },
            [`&-plain${componentCls}-with-text`]: {
                color: token.colorText,
                fontWeight: "normal",
                fontSize: token.fontSize
            },
            [`&-horizontal${componentCls}-with-text-left${componentCls}-no-default-orientation-margin-left`]: {
                "&::before": {
                    width: 0
                },
                "&::after": {
                    width: "100%"
                },
                [`${componentCls}-inner-text`]: {
                    paddingInlineStart: sizePaddingEdgeHorizontal
                }
            },
            [`&-horizontal${componentCls}-with-text-right${componentCls}-no-default-orientation-margin-right`]: {
                "&::before": {
                    width: "100%"
                },
                "&::after": {
                    width: 0
                },
                [`${componentCls}-inner-text`]: {
                    paddingInlineEnd: sizePaddingEdgeHorizontal
                }
            }
        })
    };
};
const $798d9db240249fbb$export$9ca1be8807fe0675 = (token)=>({
        textPaddingInline: "1em",
        orientationMargin: 0.05,
        verticalMarginInline: token.marginXS
    });
var // ============================== Export ==============================
$798d9db240249fbb$export$2e2bcd8739ae039 = (0, $P8Drj.genStyleHooks)("Divider", (token)=>{
    const dividerToken = (0, $2LRCS.merge)(token, {
        dividerHorizontalWithTextGutterMargin: token.margin,
        dividerHorizontalGutterMargin: token.marginLG,
        sizePaddingEdgeHorizontal: 0
    });
    return [
        $798d9db240249fbb$var$genSharedDividerStyle(dividerToken)
    ];
}, $798d9db240249fbb$export$9ca1be8807fe0675, {
    unitless: {
        orientationMargin: true
    }
});


"use client";
var $4728a501f42302e5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $4728a501f42302e5$var$Divider = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction, divider: divider } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const { prefixCls: customizePrefixCls, type: type = "horizontal", orientation: orientation = "center", orientationMargin: orientationMargin, className: className, rootClassName: rootClassName, children: children, dashed: dashed, plain: plain, style: style } = props, restProps = $4728a501f42302e5$var$__rest(props, [
        "prefixCls",
        "type",
        "orientation",
        "orientationMargin",
        "className",
        "rootClassName",
        "children",
        "dashed",
        "plain",
        "style"
    ]);
    const prefixCls = getPrefixCls("divider", customizePrefixCls);
    const [wrapCSSVar, hashId] = (0, $798d9db240249fbb$export$2e2bcd8739ae039)(prefixCls);
    const orientationPrefix = orientation.length > 0 ? `-${orientation}` : orientation;
    const hasChildren = !!children;
    const hasCustomMarginLeft = orientation === "left" && orientationMargin != null;
    const hasCustomMarginRight = orientation === "right" && orientationMargin != null;
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, divider === null || divider === void 0 ? void 0 : divider.className, hashId, `${prefixCls}-${type}`, {
        [`${prefixCls}-with-text`]: hasChildren,
        [`${prefixCls}-with-text${orientationPrefix}`]: hasChildren,
        [`${prefixCls}-dashed`]: !!dashed,
        [`${prefixCls}-plain`]: !!plain,
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-no-default-orientation-margin-left`]: hasCustomMarginLeft,
        [`${prefixCls}-no-default-orientation-margin-right`]: hasCustomMarginRight
    }, className, rootClassName);
    const memoizedOrientationMargin = $acw62.useMemo(()=>{
        if (typeof orientationMargin === "number") return orientationMargin;
        if (/^\d+$/.test(orientationMargin)) return Number(orientationMargin);
        return orientationMargin;
    }, [
        orientationMargin
    ]);
    const innerStyle = Object.assign(Object.assign({}, hasCustomMarginLeft && {
        marginLeft: memoizedOrientationMargin
    }), hasCustomMarginRight && {
        marginRight: memoizedOrientationMargin
    });
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", Object.assign({
        className: classString,
        style: Object.assign(Object.assign({}, divider === null || divider === void 0 ? void 0 : divider.style), style)
    }, restProps, {
        role: "separator"
    }), children && type !== "vertical" && /*#__PURE__*/ $acw62.createElement("span", {
        className: `${prefixCls}-inner-text`,
        style: innerStyle
    }, children)));
};
var $4728a501f42302e5$export$2e2bcd8739ae039 = $4728a501f42302e5$var$Divider;


var $eTcXV = parcelRequire("eTcXV");

var $f1q41 = parcelRequire("f1q41");

var $ggrpt = parcelRequire("ggrpt");

var $ayMG0 = parcelRequire("ayMG0");

var $igqD6 = parcelRequire("igqD6");
parcelRequire("acw62");
const $a885d5a76759c567$export$b04be29aa201d4f5 = ({ children: children, title: title, className: className })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $igqD6.cx)((0, $igqD6.css)`display: flex; flex-direction: column; flex: 1 1 auto;`, className),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: (0, $igqD6.css)`margin-left: 3px;`,
                children: [
                    title,
                    " \xa0"
                ]
            }),
            children
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");
function $c214a86aa3c24363$export$e71df740df7e68bf(stateHook, path) {
    let value = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(stateHook[0], path);
    let setValue = (value)=>stateHook[1]((state)=>{
            let nextState = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep(state);
            if (typeof value === "function") return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).set(nextState, path, value((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(nextState, path)));
            else return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).set(nextState, path, value);
        });
    return [
        value,
        setValue
    ];
}


function $6d1fa168c938f39f$export$2f645645f7bca764(defaultValue = [], addNewValue = ()=>({})) {
    const id = (0, $acw62.useRef)(0);
    const [state, setState] = (0, $acw62.useState)(defaultValue.map((item)=>({
            key: id.current++,
            data: item
        })));
    function add(value) {
        setState((state)=>{
            return [
                ...state,
                {
                    key: id.current++,
                    data: addNewValue()
                }
            ];
        });
    }
    function each(renderer) {
        return state.map((item, index)=>{
            let stateHook = (0, $c214a86aa3c24363$export$e71df740df7e68bf)([
                state,
                setState
            ], `${index}.data`);
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                children: renderer({
                    removeItem: ()=>{
                        setState((state)=>{
                            return state.filter((filterItem)=>item.key !== filterItem.key);
                        });
                    },
                    getItemState: (filterKey)=>filterKey ? (0, $c214a86aa3c24363$export$e71df740df7e68bf)(stateHook, filterKey) : stateHook
                })
            }, item.key);
        });
    }
    return [
        state.map((item)=>item.data),
        each,
        add
    ];
}


function $b26c7d5932956bc4$var$makeName(nameStart, minLength, maxLength) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).capitalize((0, $f4937a4a443bc2fd$export$9aa50adaec601a13)((0, (/*@__PURE__*/$parcel$interopDefault($efa84364dc18fe38$exports))), nameStart, {
        minLength: Number(minLength) || undefined,
        maxLength: Number(maxLength) || undefined
    }));
}
const $b26c7d5932956bc4$export$fe3d36a3c7c467aa = ()=>{
    const [generatedNames, setGeneratedNames] = (0, $acw62.useState)([]);
    const [state, eachItem, addItem] = (0, $6d1fa168c938f39f$export$2f645645f7bca764)([
        {
            nameStart: "",
            minLength: 5,
            maxLength: 9
        }
    ], ()=>({
            nameStart: "",
            minLength: 5,
            maxLength: 9
        }));
    let columns = Math.floor(window.innerWidth / 200);
    let frs = new Array(columns).fill("1fr").join(" ");
    (0, $ggrpt.useResizeRerender)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $igqD6.css)`font-family: Arial; font-weight: 100;`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, $igqD6.css)`display: grid; gap: 60px; grid-template-columns: 4fr 1fr;`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: (0, $igqD6.css)`display: grid; gap: 20px; grid-template-columns: 4fr 2fr 2fr 1fr;`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a885d5a76759c567$export$b04be29aa201d4f5), {
                                        title: "Name starts with..."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a885d5a76759c567$export$b04be29aa201d4f5), {
                                        title: "Min length"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a885d5a76759c567$export$b04be29aa201d4f5), {
                                        title: "Max length"
                                    })
                                ]
                            }),
                            eachItem(({ removeItem: removeItem, getItemState: getItemState })=>{
                                let nameStart = (0, $ggrpt.convertToInputState)(getItemState("nameStart"));
                                let minLength = (0, $ggrpt.convertToInputState)(getItemState("minLength"));
                                let maxLength = (0, $ggrpt.convertToInputState)(getItemState("maxLength"));
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: (0, $igqD6.css)`display: grid; gap: 20px; grid-template-columns: 4fr 2fr 2fr 1fr; margin-bottom: 10px;`,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTcXV.default), {
                                            ...nameStart.input
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTcXV.default), {
                                            ...minLength.input
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTcXV.default), {
                                            ...maxLength.input
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Uh7a.default), {
                                            onClick: removeItem,
                                            children: "Remove"
                                        })
                                    ]
                                });
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Uh7a.default), {
                                onClick: addItem,
                                children: "Add name"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: (0, $igqD6.css)`display: flex; gap: 10px; flex-direction: row; flex: 1 1 auto; padding-top: 23px;`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Uh7a.default), {
                                onClick: ()=>{
                                    setGeneratedNames((names)=>{
                                        return [
                                            ...names,
                                            state.map((nameConfig)=>$b26c7d5932956bc4$var$makeName(nameConfig.nameStart, nameConfig.minLength, nameConfig.maxLength)).join(" ")
                                        ];
                                    });
                                },
                                children: "Generate"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Uh7a.default), {
                                onClick: ()=>setGeneratedNames([]),
                                children: "Clear"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $igqD6.css)`
        display: grid;
        grid-template-columns: repeat( auto-fill, minmax(max-content, 200px) );
        column-gap: 40px;
      `,
                children: generatedNames.map((name, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: (0, $igqD6.css)`white-space: nowrap;`,
                        children: name
                    }, name + index))
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4Uh7a = parcelRequire("4Uh7a");
var $jnHKE = parcelRequire("jnHKE");
var $h5DBq = parcelRequire("h5DBq");
var $eTcXV = parcelRequire("eTcXV");
var $kbxxf = parcelRequire("kbxxf");

var $iORrr = parcelRequire("iORrr");

var $acw62 = parcelRequire("acw62");


var $aT8OD = parcelRequire("aT8OD");

var $kbxxf = parcelRequire("kbxxf");

var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $8e7f784a29e9449d$var$CheckCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "filled"
};
var $8e7f784a29e9449d$export$2e2bcd8739ae039 = $8e7f784a29e9449d$var$CheckCircleFilled;



var $adRcI = parcelRequire("adRcI");
var $9149fdfb4424d1d9$var$CheckCircleFilled = function CheckCircleFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $adRcI.default), (0, $8nd05.default)({}, props, {
        ref: ref,
        icon: (0, $8e7f784a29e9449d$export$2e2bcd8739ae039)
    }));
};
var $9149fdfb4424d1d9$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($9149fdfb4424d1d9$var$CheckCircleFilled);



var $b9YHa = parcelRequire("b9YHa");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $ce0f95a23ea8b20d$var$ExclamationCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "exclamation-circle",
    "theme": "filled"
};
var $ce0f95a23ea8b20d$export$2e2bcd8739ae039 = $ce0f95a23ea8b20d$var$ExclamationCircleFilled;



var $adRcI = parcelRequire("adRcI");
var $2444f6da62064575$var$ExclamationCircleFilled = function ExclamationCircleFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $adRcI.default), (0, $8nd05.default)({}, props, {
        ref: ref,
        icon: (0, $ce0f95a23ea8b20d$export$2e2bcd8739ae039)
    }));
};
var $2444f6da62064575$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($2444f6da62064575$var$ExclamationCircleFilled);



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $57a9c466662aed09$var$InfoCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "filled"
};
var $57a9c466662aed09$export$2e2bcd8739ae039 = $57a9c466662aed09$var$InfoCircleFilled;



var $adRcI = parcelRequire("adRcI");
var $b5d5d018bfa4ba6e$var$InfoCircleFilled = function InfoCircleFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $adRcI.default), (0, $8nd05.default)({}, props, {
        ref: ref,
        icon: (0, $57a9c466662aed09$export$2e2bcd8739ae039)
    }));
};
var $b5d5d018bfa4ba6e$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($b5d5d018bfa4ba6e$var$InfoCircleFilled);



var $8g1PZ = parcelRequire("8g1PZ");

var $brFSt = parcelRequire("brFSt");

var $4257x = parcelRequire("4257x");


var $aT8OD = parcelRequire("aT8OD");

var $0G7XT = parcelRequire("0G7XT");

var $hRCaH = parcelRequire("hRCaH");

var $acw62 = parcelRequire("acw62");

var $3fDfx = parcelRequire("3fDfx");

var $acw62 = parcelRequire("acw62");

var $4Uh7a = parcelRequire("4Uh7a");

var $bLQWM = parcelRequire("bLQWM");
"use client";
function $4c53afaea8b9c117$var$isThenable(thing) {
    return !!(thing && thing.then);
}
const $4c53afaea8b9c117$var$ActionButton = (props)=>{
    const { type: type, children: children, prefixCls: prefixCls, buttonProps: buttonProps, close: close, autoFocus: autoFocus, emitEvent: emitEvent, isSilent: isSilent, quitOnNullishReturnValue: quitOnNullishReturnValue, actionFn: actionFn } = props;
    const clickedRef = $acw62.useRef(false);
    const buttonRef = $acw62.useRef(null);
    const [loading, setLoading] = (0, $3fDfx.default)(false);
    const onInternalClose = function() {
        close === null || close === void 0 || close.apply(void 0, arguments);
    };
    $acw62.useEffect(()=>{
        let timeoutId = null;
        if (autoFocus) timeoutId = setTimeout(()=>{
            var _a;
            (_a = buttonRef.current) === null || _a === void 0 || _a.focus();
        });
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, []);
    const handlePromiseOnOk = (returnValueOfOnOk)=>{
        if (!$4c53afaea8b9c117$var$isThenable(returnValueOfOnOk)) return;
        setLoading(true);
        returnValueOfOnOk.then(function() {
            setLoading(false, true);
            onInternalClose.apply(void 0, arguments);
            clickedRef.current = false;
        }, (e)=>{
            // See: https://github.com/ant-design/ant-design/issues/6183
            setLoading(false, true);
            clickedRef.current = false;
            // Do not throw if is `await` mode
            if (isSilent === null || isSilent === void 0 ? void 0 : isSilent()) return;
            return Promise.reject(e);
        });
    };
    const onClick = (e)=>{
        if (clickedRef.current) return;
        clickedRef.current = true;
        if (!actionFn) {
            onInternalClose();
            return;
        }
        let returnValueOfOnOk;
        if (emitEvent) {
            returnValueOfOnOk = actionFn(e);
            if (quitOnNullishReturnValue && !$4c53afaea8b9c117$var$isThenable(returnValueOfOnOk)) {
                clickedRef.current = false;
                onInternalClose(e);
                return;
            }
        } else if (actionFn.length) {
            returnValueOfOnOk = actionFn(close);
            // https://github.com/ant-design/ant-design/issues/23358
            clickedRef.current = false;
        } else {
            returnValueOfOnOk = actionFn();
            if (!returnValueOfOnOk) {
                onInternalClose();
                return;
            }
        }
        handlePromiseOnOk(returnValueOfOnOk);
    };
    return /*#__PURE__*/ $acw62.createElement((0, $4Uh7a.default), Object.assign({}, (0, $bLQWM.convertLegacyProps)(type), {
        onClick: onClick,
        loading: loading,
        prefixCls: prefixCls
    }, buttonProps, {
        ref: buttonRef
    }), children);
};
var $4c53afaea8b9c117$export$2e2bcd8739ae039 = $4c53afaea8b9c117$var$ActionButton;



var $acw62 = parcelRequire("acw62");
const $6eed8829240c00e1$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});
const { Provider: $6eed8829240c00e1$export$7c9538f5f3c365e9 } = $6eed8829240c00e1$export$ab57792b9b6974a6;


"use client";
const $b41cca75d2dc2fd0$var$ConfirmCancelBtn = ()=>{
    const { autoFocusButton: autoFocusButton, cancelButtonProps: cancelButtonProps, cancelTextLocale: cancelTextLocale, isSilent: isSilent, mergedOkCancel: mergedOkCancel, rootPrefixCls: rootPrefixCls, close: close, onCancel: onCancel, onConfirm: onConfirm } = (0, $acw62.useContext)((0, $6eed8829240c00e1$export$ab57792b9b6974a6));
    return mergedOkCancel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c53afaea8b9c117$export$2e2bcd8739ae039), {
        isSilent: isSilent,
        actionFn: onCancel,
        close: function() {
            close === null || close === void 0 || close.apply(void 0, arguments);
            onConfirm === null || onConfirm === void 0 || onConfirm(false);
        },
        autoFocus: autoFocusButton === "cancel",
        buttonProps: cancelButtonProps,
        prefixCls: `${rootPrefixCls}-btn`
    }, cancelTextLocale) : null;
};
var $b41cca75d2dc2fd0$export$2e2bcd8739ae039 = $b41cca75d2dc2fd0$var$ConfirmCancelBtn;



var $acw62 = parcelRequire("acw62");


"use client";
const $a937a1d7917b01bb$var$ConfirmOkBtn = ()=>{
    const { autoFocusButton: autoFocusButton, close: close, isSilent: isSilent, okButtonProps: okButtonProps, rootPrefixCls: rootPrefixCls, okTextLocale: okTextLocale, okType: okType, onConfirm: onConfirm, onOk: onOk } = (0, $acw62.useContext)((0, $6eed8829240c00e1$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c53afaea8b9c117$export$2e2bcd8739ae039), {
        isSilent: isSilent,
        type: okType || "primary",
        actionFn: onOk,
        close: function() {
            close === null || close === void 0 || close.apply(void 0, arguments);
            onConfirm === null || onConfirm === void 0 || onConfirm(true);
        },
        autoFocus: autoFocusButton === "ok",
        buttonProps: okButtonProps,
        prefixCls: `${rootPrefixCls}-btn`
    }, okTextLocale);
};
var $a937a1d7917b01bb$export$2e2bcd8739ae039 = $a937a1d7917b01bb$var$ConfirmOkBtn;




var $acw62 = parcelRequire("acw62");

var $AWXcC = parcelRequire("AWXcC");

var $8g1PZ = parcelRequire("8g1PZ");

var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $7PQDT = parcelRequire("7PQDT");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $92d33d80ee6bc497$export$ee4e38b469b6f5d1 = /*#__PURE__*/ $acw62.createContext({});



var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $8g1PZ = parcelRequire("8g1PZ");

var $d1wDM = parcelRequire("d1wDM");

var $i35Ni = parcelRequire("i35Ni");

var $iCi4s = parcelRequire("iCi4s");

var $d49SP = parcelRequire("d49SP");
var $281efe5882c936de$var$attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var $281efe5882c936de$var$eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var $281efe5882c936de$var$propList = "".concat($281efe5882c936de$var$attributes, " ").concat($281efe5882c936de$var$eventsName).split(/[\s\n]+/);
/* eslint-enable max-len */ var $281efe5882c936de$var$ariaPrefix = "aria-";
var $281efe5882c936de$var$dataPrefix = "data-";
function $281efe5882c936de$var$match(key, prefix) {
    return key.indexOf(prefix) === 0;
}
function $281efe5882c936de$export$2e2bcd8739ae039(props) {
    var ariaOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var mergedConfig;
    if (ariaOnly === false) mergedConfig = {
        aria: true,
        data: true,
        attr: true
    };
    else if (ariaOnly === true) mergedConfig = {
        aria: true
    };
    else mergedConfig = (0, $d49SP.default)({}, ariaOnly);
    var attrs = {};
    Object.keys(props).forEach(function(key) {
        if (// Aria
        mergedConfig.aria && (key === "role" || $281efe5882c936de$var$match(key, $281efe5882c936de$var$ariaPrefix)) || // Data
        mergedConfig.data && $281efe5882c936de$var$match(key, $281efe5882c936de$var$dataPrefix) || // Attr
        mergedConfig.attr && $281efe5882c936de$var$propList.includes(key)) attrs[key] = props[key];
    });
    return attrs;
}



var $acw62 = parcelRequire("acw62");
// =============================== Motion ===============================
function $90c55518cdbfc131$export$ec1a7ebf4579c1c3(prefixCls, transitionName, animationName) {
    var motionName = transitionName;
    if (!motionName && animationName) motionName = "".concat(prefixCls, "-").concat(animationName);
    return motionName;
}
// =============================== Offset ===============================
function $90c55518cdbfc131$var$getScroll(w, top) {
    var ret = w["page".concat(top ? "Y" : "X", "Offset")];
    var method = "scroll".concat(top ? "Top" : "Left");
    if (typeof ret !== "number") {
        var d = w.document;
        ret = d.documentElement[method];
        if (typeof ret !== "number") ret = d.body[method];
    }
    return ret;
}
function $90c55518cdbfc131$export$cc800923e997bb8(el) {
    var rect = el.getBoundingClientRect();
    var pos = {
        left: rect.left,
        top: rect.top
    };
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += $90c55518cdbfc131$var$getScroll(w);
    pos.top += $90c55518cdbfc131$var$getScroll(w, true);
    return pos;
}



var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8iiJy = parcelRequire("8iiJy");


var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $8g1PZ = parcelRequire("8g1PZ");

var $85dLH = parcelRequire("85dLH");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $112494d152ccd867$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.memo(function(_ref) {
    var children = _ref.children;
    return children;
}, function(_, _ref2) {
    var shouldUpdate = _ref2.shouldUpdate;
    return !shouldUpdate;
});


var $d87bfeabd0b3848d$var$sentinelStyle = {
    width: 0,
    height: 0,
    overflow: "hidden",
    outline: "none"
};
var $d87bfeabd0b3848d$var$Panel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, className = props.className, style = props.style, title = props.title, ariaId = props.ariaId, footer = props.footer, closable = props.closable, closeIcon = props.closeIcon, onClose = props.onClose, children = props.children, bodyStyle = props.bodyStyle, bodyProps = props.bodyProps, modalRender = props.modalRender, onMouseDown = props.onMouseDown, onMouseUp = props.onMouseUp, holderRef = props.holderRef, visible = props.visible, forceRender = props.forceRender, width = props.width, height = props.height, modalClassNames = props.classNames, modalStyles = props.styles;
    // ================================= Refs =================================
    var _React$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $92d33d80ee6bc497$export$ee4e38b469b6f5d1)), panelRef = _React$useContext.panel;
    var mergedRef = (0, $85dLH.useComposeRef)(holderRef, panelRef);
    var sentinelStartRef = (0, $acw62.useRef)();
    var sentinelEndRef = (0, $acw62.useRef)();
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, function() {
        return {
            focus: function focus() {
                var _sentinelStartRef$cur;
                (_sentinelStartRef$cur = sentinelStartRef.current) === null || _sentinelStartRef$cur === void 0 || _sentinelStartRef$cur.focus();
            },
            changeActive: function changeActive(next) {
                var _document = document, activeElement = _document.activeElement;
                if (next && activeElement === sentinelEndRef.current) sentinelStartRef.current.focus();
                else if (!next && activeElement === sentinelStartRef.current) sentinelEndRef.current.focus();
            }
        };
    });
    // ================================ Style =================================
    var contentStyle = {};
    if (width !== undefined) contentStyle.width = width;
    if (height !== undefined) contentStyle.height = height;
    // ================================ Render ================================
    var footerNode;
    if (footer) footerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-footer"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.footer),
        style: (0, $d49SP.default)({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.footer)
    }, footer);
    var headerNode;
    if (title) headerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-header"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.header),
        style: (0, $d49SP.default)({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.header)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat(prefixCls, "-title"),
        id: ariaId
    }, title));
    var closer;
    if (closable) closer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onClose,
        "aria-label": "Close",
        className: "".concat(prefixCls, "-close")
    }, closeIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "".concat(prefixCls, "-close-x")
    }));
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-content"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.content),
        style: modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.content
    }, closer, headerNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, $8nd05.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-body"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.body),
        style: (0, $d49SP.default)((0, $d49SP.default)({}, bodyStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.body)
    }, bodyProps), children), footerNode);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        key: "dialog-element",
        role: "dialog",
        "aria-labelledby": title ? ariaId : null,
        "aria-modal": "true",
        ref: mergedRef,
        style: (0, $d49SP.default)((0, $d49SP.default)({}, style), contentStyle),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, className),
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        tabIndex: 0,
        ref: sentinelStartRef,
        style: $d87bfeabd0b3848d$var$sentinelStyle,
        "aria-hidden": "true"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $112494d152ccd867$export$2e2bcd8739ae039), {
        shouldUpdate: visible || forceRender
    }, modalRender ? modalRender(content) : content), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        tabIndex: 0,
        ref: sentinelEndRef,
        style: $d87bfeabd0b3848d$var$sentinelStyle,
        "aria-hidden": "true"
    }));
});
var $d87bfeabd0b3848d$export$2e2bcd8739ae039 = $d87bfeabd0b3848d$var$Panel;


var $b02b23d234e320c9$var$Content = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, title = props.title, style = props.style, className = props.className, visible = props.visible, forceRender = props.forceRender, destroyOnClose = props.destroyOnClose, motionName = props.motionName, ariaId = props.ariaId, onVisibleChanged = props.onVisibleChanged, mousePosition = props.mousePosition;
    var dialogRef = (0, $acw62.useRef)();
    // ============================= Style ==============================
    var _React$useState = $acw62.useState(), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), transformOrigin = _React$useState2[0], setTransformOrigin = _React$useState2[1];
    var contentStyle = {};
    if (transformOrigin) contentStyle.transformOrigin = transformOrigin;
    function onPrepare() {
        var elementOffset = (0, $90c55518cdbfc131$export$cc800923e997bb8)(dialogRef.current);
        setTransformOrigin(mousePosition ? "".concat(mousePosition.x - elementOffset.left, "px ").concat(mousePosition.y - elementOffset.top, "px") : "");
    }
    // ============================= Render =============================
    return /*#__PURE__*/ $acw62.createElement((0, $8iiJy.default), {
        visible: visible,
        onVisibleChanged: onVisibleChanged,
        onAppearPrepare: onPrepare,
        onEnterPrepare: onPrepare,
        forceRender: forceRender,
        motionName: motionName,
        removeOnLeave: destroyOnClose,
        ref: dialogRef
    }, function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ $acw62.createElement((0, $d87bfeabd0b3848d$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
            ref: ref,
            title: title,
            ariaId: ariaId,
            prefixCls: prefixCls,
            holderRef: motionRef,
            style: (0, $d49SP.default)((0, $d49SP.default)((0, $d49SP.default)({}, motionStyle), style), contentStyle),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, motionClassName)
        }));
    });
});
$b02b23d234e320c9$var$Content.displayName = "Content";
var $b02b23d234e320c9$export$2e2bcd8739ae039 = $b02b23d234e320c9$var$Content;



var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8iiJy = parcelRequire("8iiJy");
function $e10e3c44c896dc47$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, style = props.style, visible = props.visible, maskProps = props.maskProps, motionName = props.motionName, className = props.className;
    return /*#__PURE__*/ $acw62.createElement((0, $8iiJy.default), {
        key: "mask",
        visible: visible,
        motionName: motionName,
        leavedClassName: "".concat(prefixCls, "-mask-hidden")
    }, function(_ref, ref) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
            ref: ref,
            style: (0, $d49SP.default)((0, $d49SP.default)({}, motionStyle), style),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-mask"), motionClassName, className)
        }, maskProps));
    });
}


parcelRequire("u43uR");
function $850025f1cddd8729$export$2e2bcd8739ae039(props) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-dialog" : _props$prefixCls, zIndex = props.zIndex, _props$visible = props.visible, visible = _props$visible === void 0 ? false : _props$visible, _props$keyboard = props.keyboard, keyboard = _props$keyboard === void 0 ? true : _props$keyboard, _props$focusTriggerAf = props.focusTriggerAfterClose, focusTriggerAfterClose = _props$focusTriggerAf === void 0 ? true : _props$focusTriggerAf, wrapStyle = props.wrapStyle, wrapClassName = props.wrapClassName, wrapProps = props.wrapProps, onClose = props.onClose, afterOpenChange = props.afterOpenChange, afterClose = props.afterClose, transitionName = props.transitionName, animation = props.animation, _props$closable = props.closable, closable = _props$closable === void 0 ? true : _props$closable, _props$mask = props.mask, mask = _props$mask === void 0 ? true : _props$mask, maskTransitionName = props.maskTransitionName, maskAnimation = props.maskAnimation, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, maskStyle = props.maskStyle, maskProps = props.maskProps, rootClassName = props.rootClassName, modalClassNames = props.classNames, modalStyles = props.styles;
    var lastOutSideActiveElementRef = (0, $acw62.useRef)();
    var wrapperRef = (0, $acw62.useRef)();
    var contentRef = (0, $acw62.useRef)();
    var _React$useState = $acw62.useState(visible), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
    // ========================== Init ==========================
    var ariaId = (0, $i35Ni.default)();
    function saveLastOutSideActiveElementRef() {
        if (!(0, $d1wDM.default)(wrapperRef.current, document.activeElement)) lastOutSideActiveElementRef.current = document.activeElement;
    }
    function focusDialogContent() {
        if (!(0, $d1wDM.default)(wrapperRef.current, document.activeElement)) {
            var _contentRef$current;
            (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || _contentRef$current.focus();
        }
    }
    // ========================= Events =========================
    function onDialogVisibleChanged(newVisible) {
        // Try to focus
        if (newVisible) focusDialogContent();
        else {
            // Clean up scroll bar & focus back
            setAnimatedVisible(false);
            if (mask && lastOutSideActiveElementRef.current && focusTriggerAfterClose) {
                try {
                    lastOutSideActiveElementRef.current.focus({
                        preventScroll: true
                    });
                } catch (e) {
                // Do nothing
                }
                lastOutSideActiveElementRef.current = null;
            }
            // Trigger afterClose only when change visible from true to false
            if (animatedVisible) afterClose === null || afterClose === void 0 || afterClose();
        }
        afterOpenChange === null || afterOpenChange === void 0 || afterOpenChange(newVisible);
    }
    function onInternalClose(e) {
        onClose === null || onClose === void 0 || onClose(e);
    }
    // >>> Content
    var contentClickRef = (0, $acw62.useRef)(false);
    var contentTimeoutRef = (0, $acw62.useRef)();
    // We need record content click incase content popup out of dialog
    var onContentMouseDown = function onContentMouseDown() {
        clearTimeout(contentTimeoutRef.current);
        contentClickRef.current = true;
    };
    var onContentMouseUp = function onContentMouseUp() {
        contentTimeoutRef.current = setTimeout(function() {
            contentClickRef.current = false;
        });
    };
    // >>> Wrapper
    // Close only when element not on dialog
    var onWrapperClick = null;
    if (maskClosable) onWrapperClick = function onWrapperClick(e) {
        if (contentClickRef.current) contentClickRef.current = false;
        else if (wrapperRef.current === e.target) onInternalClose(e);
    };
    function onWrapperKeyDown(e) {
        if (keyboard && e.keyCode === (0, $iCi4s.default).ESC) {
            e.stopPropagation();
            onInternalClose(e);
            return;
        }
        // keep focus inside dialog
        if (visible) {
            if (e.keyCode === (0, $iCi4s.default).TAB) contentRef.current.changeActive(!e.shiftKey);
        }
    }
    // ========================= Effect =========================
    (0, $acw62.useEffect)(function() {
        if (visible) {
            setAnimatedVisible(true);
            saveLastOutSideActiveElementRef();
        }
    }, [
        visible
    ]);
    // Remove direct should also check the scroll bar update
    (0, $acw62.useEffect)(function() {
        return function() {
            clearTimeout(contentTimeoutRef.current);
        };
    }, []);
    // ========================= Render =========================
    return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-root"), rootClassName)
    }, (0, $281efe5882c936de$export$2e2bcd8739ae039)(props, {
        data: true
    })), /*#__PURE__*/ $acw62.createElement((0, $e10e3c44c896dc47$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        visible: mask && visible,
        motionName: (0, $90c55518cdbfc131$export$ec1a7ebf4579c1c3)(prefixCls, maskTransitionName, maskAnimation),
        style: (0, $d49SP.default)((0, $d49SP.default)({
            zIndex: zIndex
        }, maskStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.mask),
        maskProps: maskProps,
        className: modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.mask
    }), /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        tabIndex: -1,
        onKeyDown: onWrapperKeyDown,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-wrap"), wrapClassName, modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.wrapper),
        ref: wrapperRef,
        onClick: onWrapperClick,
        style: (0, $d49SP.default)((0, $d49SP.default)((0, $d49SP.default)({
            zIndex: zIndex
        }, wrapStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.wrapper), {}, {
            display: !animatedVisible ? "none" : null
        })
    }, wrapProps), /*#__PURE__*/ $acw62.createElement((0, $b02b23d234e320c9$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        onMouseDown: onContentMouseDown,
        onMouseUp: onContentMouseUp,
        ref: contentRef,
        closable: closable,
        ariaId: ariaId,
        prefixCls: prefixCls,
        visible: visible && animatedVisible,
        onClose: onInternalClose,
        onVisibleChanged: onDialogVisibleChanged,
        motionName: (0, $90c55518cdbfc131$export$ec1a7ebf4579c1c3)(prefixCls, transitionName, animation)
    }))));
}


// fix issue #10656
/*
 * getContainer remarks
 * Custom container should not be return, because in the Portal component, it will remove the
 * return container element here, if the custom container is the only child of it's component,
 * like issue #10656, It will has a conflict with removeChild method in react-dom.
 * So here should add a child (div element) to custom container.
 * */ var $08b45dfd0eb11827$var$DialogWrap = function DialogWrap(props) {
    var visible = props.visible, getContainer = props.getContainer, forceRender = props.forceRender, _props$destroyOnClose = props.destroyOnClose, destroyOnClose = _props$destroyOnClose === void 0 ? false : _props$destroyOnClose, _afterClose = props.afterClose, panelRef = props.panelRef;
    var _React$useState = $acw62.useState(visible), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
    var refContext = $acw62.useMemo(function() {
        return {
            panel: panelRef
        };
    }, [
        panelRef
    ]);
    $acw62.useEffect(function() {
        if (visible) setAnimatedVisible(true);
    }, [
        visible
    ]);
    // Destroy on close will remove wrapped div
    if (!forceRender && destroyOnClose && !animatedVisible) return null;
    return /*#__PURE__*/ $acw62.createElement((0, $92d33d80ee6bc497$export$ee4e38b469b6f5d1).Provider, {
        value: refContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7PQDT.default), {
        open: visible || forceRender || animatedVisible,
        autoDestroy: false,
        getContainer: getContainer,
        autoLock: visible || animatedVisible
    }, /*#__PURE__*/ $acw62.createElement((0, $850025f1cddd8729$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        destroyOnClose: destroyOnClose,
        afterClose: function afterClose() {
            _afterClose === null || _afterClose === void 0 || _afterClose();
            setAnimatedVisible(false);
        }
    }))));
};
$08b45dfd0eb11827$var$DialogWrap.displayName = "Dialog";
var $08b45dfd0eb11827$export$2e2bcd8739ae039 = $08b45dfd0eb11827$var$DialogWrap;



var $fc48b5916203bd39$export$2e2bcd8739ae039 = (0, $08b45dfd0eb11827$export$2e2bcd8739ae039);



var $cwFcq = parcelRequire("cwFcq");

var $4257x = parcelRequire("4257x");

var $h4v51 = parcelRequire("h4v51");

var $h4v51 = parcelRequire("h4v51");
var $5ac27a8c1ec0b63e$var$isStyleNameSupport = function isStyleNameSupport(styleName) {
    if ((0, $h4v51.default)() && window.document.documentElement) {
        var styleNameList = Array.isArray(styleName) ? styleName : [
            styleName
        ];
        var documentElement = window.document.documentElement;
        return styleNameList.some(function(name) {
            return name in documentElement.style;
        });
    }
    return false;
};
var $5ac27a8c1ec0b63e$var$isStyleValueSupport = function isStyleValueSupport(styleName, value) {
    if (!$5ac27a8c1ec0b63e$var$isStyleNameSupport(styleName)) return false;
    var ele = document.createElement("div");
    var origin = ele.style[styleName];
    ele.style[styleName] = value;
    return ele.style[styleName] !== origin;
};
function $5ac27a8c1ec0b63e$export$d616d7831008e86c(styleName, styleValue) {
    if (!Array.isArray(styleName) && styleValue !== undefined) return $5ac27a8c1ec0b63e$var$isStyleValueSupport(styleName, styleValue);
    return $5ac27a8c1ec0b63e$var$isStyleNameSupport(styleName);
}


const $ebcf30cec053af5e$export$7dbdadf5e9653129 = ()=>(0, $h4v51.default)() && window.document.documentElement;




var $3GcAE = parcelRequire("3GcAE");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $eSOz6 = parcelRequire("eSOz6");

var $3gns8 = parcelRequire("3gns8");
parcelRequire("gwOwm");
var $a4gyP = parcelRequire("a4gyP");

var $acw62 = parcelRequire("acw62");
function $9ce1b741d917b083$var$voidFunc() {}
const $9ce1b741d917b083$var$WatermarkContext = /*#__PURE__*/ $acw62.createContext({
    add: $9ce1b741d917b083$var$voidFunc,
    remove: $9ce1b741d917b083$var$voidFunc
});
function $9ce1b741d917b083$export$94ab53417567be34(panelSelector) {
    const watermark = $acw62.useContext($9ce1b741d917b083$var$WatermarkContext);
    const panelEleRef = $acw62.useRef();
    const panelRef = (0, $a4gyP.default)((ele)=>{
        if (ele) {
            const innerContentEle = panelSelector ? ele.querySelector(panelSelector) : ele;
            watermark.add(innerContentEle);
            panelEleRef.current = innerContentEle;
        } else watermark.remove(panelEleRef.current);
    });
    return panelRef;
}
var $9ce1b741d917b083$export$2e2bcd8739ae039 = $9ce1b741d917b083$var$WatermarkContext;



var $kbxxf = parcelRequire("kbxxf");

var $acw62 = parcelRequire("acw62");

var $AWXcC = parcelRequire("AWXcC");

var $9f1hj = parcelRequire("9f1hj");

var $0G7XT = parcelRequire("0G7XT");

var $acw62 = parcelRequire("acw62");

var $4Uh7a = parcelRequire("4Uh7a");

"use client";
const $671e2637f7c09c5d$var$NormalCancelBtn = ()=>{
    const { cancelButtonProps: cancelButtonProps, cancelTextLocale: cancelTextLocale, onCancel: onCancel } = (0, $acw62.useContext)((0, $6eed8829240c00e1$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Uh7a.default), Object.assign({
        onClick: onCancel
    }, cancelButtonProps), cancelTextLocale);
};
var $671e2637f7c09c5d$export$2e2bcd8739ae039 = $671e2637f7c09c5d$var$NormalCancelBtn;



var $acw62 = parcelRequire("acw62");

var $4Uh7a = parcelRequire("4Uh7a");

var $bLQWM = parcelRequire("bLQWM");

"use client";
const $dbfeff6b64918b5e$var$NormalOkBtn = ()=>{
    const { confirmLoading: confirmLoading, okButtonProps: okButtonProps, okType: okType, okTextLocale: okTextLocale, onOk: onOk } = (0, $acw62.useContext)((0, $6eed8829240c00e1$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Uh7a.default), Object.assign({}, (0, $bLQWM.convertLegacyProps)(okType), {
        loading: confirmLoading,
        onClick: onOk
    }, okButtonProps), okTextLocale);
};
var $dbfeff6b64918b5e$export$2e2bcd8739ae039 = $dbfeff6b64918b5e$var$NormalOkBtn;




var $62TUi = parcelRequire("62TUi");
"use client";
function $52ee3afc292c0929$export$97c34646962d356e(prefixCls, closeIcon) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: `${prefixCls}-close-x`
    }, closeIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $AWXcC.default), {
        className: `${prefixCls}-close-icon`
    }));
}
const $52ee3afc292c0929$export$a06f1c675e846f6f = (props)=>{
    const { okText: okText, okType: okType = "primary", cancelText: cancelText, confirmLoading: confirmLoading, onOk: onOk, onCancel: onCancel, okButtonProps: okButtonProps, cancelButtonProps: cancelButtonProps, footer: footer } = props;
    const [locale] = (0, $0G7XT.default)("Modal", (0, $62TUi.getConfirmLocale)());
    // ================== Locale Text ==================
    const okTextLocale = okText || (locale === null || locale === void 0 ? void 0 : locale.okText);
    const cancelTextLocale = cancelText || (locale === null || locale === void 0 ? void 0 : locale.cancelText);
    // ================= Context Value =================
    const btnCtxValue = {
        confirmLoading: confirmLoading,
        okButtonProps: okButtonProps,
        cancelButtonProps: cancelButtonProps,
        okTextLocale: okTextLocale,
        cancelTextLocale: cancelTextLocale,
        okType: okType,
        onOk: onOk,
        onCancel: onCancel
    };
    const btnCtxValueMemo = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>btnCtxValue, (0, $kbxxf.default)(Object.values(btnCtxValue)));
    let footerNode;
    if (typeof footer === "function" || typeof footer === "undefined") {
        footerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $671e2637f7c09c5d$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbfeff6b64918b5e$export$2e2bcd8739ae039), null));
        if (typeof footer === "function") footerNode = footer(footerNode, {
            OkBtn: (0, $dbfeff6b64918b5e$export$2e2bcd8739ae039),
            CancelBtn: (0, $671e2637f7c09c5d$export$2e2bcd8739ae039)
        });
        footerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6eed8829240c00e1$export$7c9538f5f3c365e9), {
            value: btnCtxValueMemo
        }, footerNode);
    } else footerNode = footer;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9f1hj.DisabledContextProvider), {
        disabled: false
    }, footerNode);
};



var $670jt = parcelRequire("670jt");
parcelRequire("3i86m");
var $hsEk2 = parcelRequire("hsEk2");

var $gvSPY = parcelRequire("gvSPY");
const $cfaac789ec22cce1$export$82e6205b15e6c637 = new (0, $hsEk2.default)("antFadeIn", {
    "0%": {
        opacity: 0
    },
    "100%": {
        opacity: 1
    }
});
const $cfaac789ec22cce1$export$c091916f1530334c = new (0, $hsEk2.default)("antFadeOut", {
    "0%": {
        opacity: 1
    },
    "100%": {
        opacity: 0
    }
});
const $cfaac789ec22cce1$export$2909268c8354a12 = function(token) {
    let sameLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-fade`;
    const sameLevelPrefix = sameLevel ? "&" : "";
    return [
        (0, $gvSPY.initMotion)(motionCls, $cfaac789ec22cce1$export$82e6205b15e6c637, $cfaac789ec22cce1$export$c091916f1530334c, token.motionDurationMid, sameLevel),
        {
            [`
        ${sameLevelPrefix}${motionCls}-enter,
        ${sameLevelPrefix}${motionCls}-appear
      `]: {
                opacity: 0,
                animationTimingFunction: "linear"
            },
            [`${sameLevelPrefix}${motionCls}-leave`]: {
                animationTimingFunction: "linear"
            }
        }
    ];
};


var $i1ZDk = parcelRequire("i1ZDk");

var $P8Drj = parcelRequire("P8Drj");
var $2LRCS = parcelRequire("2LRCS");
parcelRequire("3i86m");
var $lpQ06 = parcelRequire("lpQ06");
"use client";
function $4273ff34fb23b4b1$var$box(position) {
    return {
        position: position,
        inset: 0
    };
}
const $4273ff34fb23b4b1$export$8bb6dada04673ddd = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return [
        {
            [`${componentCls}-root`]: {
                [`${componentCls}${antCls}-zoom-enter, ${componentCls}${antCls}-zoom-appear`]: {
                    // reset scale avoid mousePosition bug
                    transform: "none",
                    opacity: 0,
                    animationDuration: token.motionDurationSlow,
                    // https://github.com/ant-design/ant-design/issues/11777
                    userSelect: "none"
                },
                // https://github.com/ant-design/ant-design/issues/37329
                // https://github.com/ant-design/ant-design/issues/40272
                [`${componentCls}${antCls}-zoom-leave ${componentCls}-content`]: {
                    pointerEvents: "none"
                },
                [`${componentCls}-mask`]: Object.assign(Object.assign({}, $4273ff34fb23b4b1$var$box("fixed")), {
                    zIndex: token.zIndexPopupBase,
                    height: "100%",
                    backgroundColor: token.colorBgMask,
                    pointerEvents: "none",
                    [`${componentCls}-hidden`]: {
                        display: "none"
                    }
                }),
                [`${componentCls}-wrap`]: Object.assign(Object.assign({}, $4273ff34fb23b4b1$var$box("fixed")), {
                    zIndex: token.zIndexPopupBase,
                    overflow: "auto",
                    outline: 0,
                    WebkitOverflowScrolling: "touch",
                    // Note: Firefox not support `:has` yet
                    [`&:has(${componentCls}${antCls}-zoom-enter), &:has(${componentCls}${antCls}-zoom-appear)`]: {
                        pointerEvents: "none"
                    }
                })
            }
        },
        {
            [`${componentCls}-root`]: (0, $cfaac789ec22cce1$export$2909268c8354a12)(token)
        }
    ];
};
const $4273ff34fb23b4b1$var$genModalStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return [
        // ======================== Root =========================
        {
            [`${componentCls}-root`]: {
                [`${componentCls}-wrap-rtl`]: {
                    direction: "rtl"
                },
                [`${componentCls}-centered`]: {
                    textAlign: "center",
                    "&::before": {
                        display: "inline-block",
                        width: 0,
                        height: "100%",
                        verticalAlign: "middle",
                        content: '""'
                    },
                    [componentCls]: {
                        top: 0,
                        display: "inline-block",
                        paddingBottom: 0,
                        textAlign: "start",
                        verticalAlign: "middle"
                    }
                },
                [`@media (max-width: ${token.screenSMMax}px)`]: {
                    [componentCls]: {
                        maxWidth: "calc(100vw - 16px)",
                        margin: `${(0, $lpQ06.unit)(token.marginXS)} auto`
                    },
                    [`${componentCls}-centered`]: {
                        [componentCls]: {
                            flex: 1
                        }
                    }
                }
            }
        },
        // ======================== Modal ========================
        {
            [componentCls]: Object.assign(Object.assign({}, (0, $670jt.resetComponent)(token)), {
                pointerEvents: "none",
                position: "relative",
                top: 100,
                width: "auto",
                maxWidth: `calc(100vw - ${(0, $lpQ06.unit)(token.calc(token.margin).mul(2).equal())})`,
                margin: "0 auto",
                paddingBottom: token.paddingLG,
                [`${componentCls}-title`]: {
                    margin: 0,
                    color: token.titleColor,
                    fontWeight: token.fontWeightStrong,
                    fontSize: token.titleFontSize,
                    lineHeight: token.titleLineHeight,
                    wordWrap: "break-word"
                },
                [`${componentCls}-content`]: {
                    position: "relative",
                    backgroundColor: token.contentBg,
                    backgroundClip: "padding-box",
                    border: 0,
                    borderRadius: token.borderRadiusLG,
                    boxShadow: token.boxShadow,
                    pointerEvents: "auto",
                    padding: token.contentPadding
                },
                [`${componentCls}-close`]: Object.assign({
                    position: "absolute",
                    top: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
                    insetInlineEnd: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
                    zIndex: token.calc(token.zIndexPopupBase).add(10).equal(),
                    padding: 0,
                    color: token.modalCloseIconColor,
                    fontWeight: token.fontWeightStrong,
                    lineHeight: 1,
                    textDecoration: "none",
                    background: "transparent",
                    borderRadius: token.borderRadiusSM,
                    width: token.modalCloseBtnSize,
                    height: token.modalCloseBtnSize,
                    border: 0,
                    outline: 0,
                    cursor: "pointer",
                    transition: `color ${token.motionDurationMid}, background-color ${token.motionDurationMid}`,
                    "&-x": {
                        display: "flex",
                        fontSize: token.fontSizeLG,
                        fontStyle: "normal",
                        lineHeight: `${(0, $lpQ06.unit)(token.modalCloseBtnSize)}`,
                        justifyContent: "center",
                        textTransform: "none",
                        textRendering: "auto"
                    },
                    "&:hover": {
                        color: token.modalIconHoverColor,
                        backgroundColor: token.closeBtnHoverBg,
                        textDecoration: "none"
                    },
                    "&:active": {
                        backgroundColor: token.closeBtnActiveBg
                    }
                }, (0, $670jt.genFocusStyle)(token)),
                [`${componentCls}-header`]: {
                    color: token.colorText,
                    background: token.headerBg,
                    borderRadius: `${(0, $lpQ06.unit)(token.borderRadiusLG)} ${(0, $lpQ06.unit)(token.borderRadiusLG)} 0 0`,
                    marginBottom: token.headerMarginBottom,
                    padding: token.headerPadding,
                    borderBottom: token.headerBorderBottom
                },
                [`${componentCls}-body`]: {
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight,
                    wordWrap: "break-word",
                    padding: token.bodyPadding
                },
                [`${componentCls}-footer`]: {
                    textAlign: "end",
                    background: token.footerBg,
                    marginTop: token.footerMarginTop,
                    padding: token.footerPadding,
                    borderTop: token.footerBorderTop,
                    borderRadius: token.footerBorderRadius,
                    [`${token.antCls}-btn + ${token.antCls}-btn:not(${token.antCls}-dropdown-trigger)`]: {
                        marginBottom: 0,
                        marginInlineStart: token.marginXS
                    }
                },
                [`${componentCls}-open`]: {
                    overflow: "hidden"
                }
            })
        },
        // ======================== Pure =========================
        {
            [`${componentCls}-pure-panel`]: {
                top: "auto",
                padding: 0,
                display: "flex",
                flexDirection: "column",
                [`${componentCls}-content,
          ${componentCls}-body,
          ${componentCls}-confirm-body-wrapper`]: {
                    display: "flex",
                    flexDirection: "column",
                    flex: "auto"
                },
                [`${componentCls}-confirm-body`]: {
                    marginBottom: "auto"
                }
            }
        }
    ];
};
const $4273ff34fb23b4b1$var$genRTLStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-root`]: {
            [`${componentCls}-wrap-rtl`]: {
                direction: "rtl",
                [`${componentCls}-confirm-body`]: {
                    direction: "rtl"
                }
            }
        }
    };
};
const $4273ff34fb23b4b1$export$362fb92a8f81bbf9 = (token)=>{
    const headerPaddingVertical = token.padding;
    const headerFontSize = token.fontSizeHeading5;
    const headerLineHeight = token.lineHeightHeading5;
    const modalToken = (0, $2LRCS.merge)(token, {
        modalHeaderHeight: token.calc(token.calc(headerLineHeight).mul(headerFontSize).equal()).add(token.calc(headerPaddingVertical).mul(2).equal()).equal(),
        modalFooterBorderColorSplit: token.colorSplit,
        modalFooterBorderStyle: token.lineType,
        modalFooterBorderWidth: token.lineWidth,
        modalIconHoverColor: token.colorIconHover,
        modalCloseIconColor: token.colorIcon,
        modalCloseBtnSize: token.fontHeight,
        modalConfirmIconSize: token.fontHeight,
        modalTitleHeight: token.calc(token.titleFontSize).mul(token.titleLineHeight).equal()
    });
    return modalToken;
};
const $4273ff34fb23b4b1$export$9ca1be8807fe0675 = (token)=>({
        footerBg: "transparent",
        headerBg: token.colorBgElevated,
        titleLineHeight: token.lineHeightHeading5,
        titleFontSize: token.fontSizeHeading5,
        contentBg: token.colorBgElevated,
        titleColor: token.colorTextHeading,
        // internal
        closeBtnHoverBg: token.wireframe ? "transparent" : token.colorFillContent,
        closeBtnActiveBg: token.wireframe ? "transparent" : token.colorFillContentHover,
        contentPadding: token.wireframe ? 0 : `${(0, $lpQ06.unit)(token.paddingMD)} ${(0, $lpQ06.unit)(token.paddingContentHorizontalLG)}`,
        headerPadding: token.wireframe ? `${(0, $lpQ06.unit)(token.padding)} ${(0, $lpQ06.unit)(token.paddingLG)}` : 0,
        headerBorderBottom: token.wireframe ? `${(0, $lpQ06.unit)(token.lineWidth)} ${token.lineType} ${token.colorSplit}` : "none",
        headerMarginBottom: token.wireframe ? 0 : token.marginXS,
        bodyPadding: token.wireframe ? token.paddingLG : 0,
        footerPadding: token.wireframe ? `${(0, $lpQ06.unit)(token.paddingXS)} ${(0, $lpQ06.unit)(token.padding)}` : 0,
        footerBorderTop: token.wireframe ? `${(0, $lpQ06.unit)(token.lineWidth)} ${token.lineType} ${token.colorSplit}` : "none",
        footerBorderRadius: token.wireframe ? `0 0 ${(0, $lpQ06.unit)(token.borderRadiusLG)} ${(0, $lpQ06.unit)(token.borderRadiusLG)}` : 0,
        footerMarginTop: token.wireframe ? 0 : token.marginSM,
        confirmBodyPadding: token.wireframe ? `${(0, $lpQ06.unit)(token.padding * 2)} ${(0, $lpQ06.unit)(token.padding * 2)} ${(0, $lpQ06.unit)(token.paddingLG)}` : 0,
        confirmIconMarginInlineEnd: token.wireframe ? token.margin : token.marginSM,
        confirmBtnsMarginTop: token.wireframe ? token.marginLG : token.marginSM
    });
var $4273ff34fb23b4b1$export$2e2bcd8739ae039 = (0, $P8Drj.genStyleHooks)("Modal", (token)=>{
    const modalToken = $4273ff34fb23b4b1$export$362fb92a8f81bbf9(token);
    return [
        $4273ff34fb23b4b1$var$genModalStyle(modalToken),
        $4273ff34fb23b4b1$var$genRTLStyle(modalToken),
        $4273ff34fb23b4b1$export$8bb6dada04673ddd(modalToken),
        (0, $i1ZDk.initZoomMotion)(modalToken, "zoom")
    ];
}, $4273ff34fb23b4b1$export$9ca1be8807fe0675, {
    unitless: {
        titleLineHeight: true
    }
});



var $brFSt = parcelRequire("brFSt");

var $dnT3A = parcelRequire("dnT3A");
"use client";
var $e567711acbe5f453$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $e567711acbe5f453$var$mousePosition;
// ref: https://github.com/ant-design/ant-design/issues/15795
const $e567711acbe5f453$var$getClickPosition = (e)=>{
    $e567711acbe5f453$var$mousePosition = {
        x: e.pageX,
        y: e.pageY
    };
    // 100ms 内发生过点击事件，则从点击位置动画展示
    // 否则直接 zoom 展示
    // 这样可以兼容非点击方式展开
    setTimeout(()=>{
        $e567711acbe5f453$var$mousePosition = null;
    }, 100);
};
// 只有点击事件支持从鼠标位置动画展开
if ((0, $ebcf30cec053af5e$export$7dbdadf5e9653129)()) document.documentElement.addEventListener("click", $e567711acbe5f453$var$getClickPosition, true);
const $e567711acbe5f453$var$Modal = (props)=>{
    var _a;
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction, modal: modal } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const handleCancel = (e)=>{
        const { onCancel: onCancel } = props;
        onCancel === null || onCancel === void 0 || onCancel(e);
    };
    const handleOk = (e)=>{
        const { onOk: onOk } = props;
        onOk === null || onOk === void 0 || onOk(e);
    };
    var _ref;
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, open: open, wrapClassName: wrapClassName, centered: centered, getContainer: getContainer, closeIcon: closeIcon, closable: closable, focusTriggerAfterClose: focusTriggerAfterClose = true, style: style, visible: // Deprecated
    visible, width: width = 520, footer: footer, classNames: modalClassNames, styles: modalStyles } = props, restProps = $e567711acbe5f453$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "open",
        "wrapClassName",
        "centered",
        "getContainer",
        "closeIcon",
        "closable",
        "focusTriggerAfterClose",
        "style",
        "visible",
        "width",
        "footer",
        "classNames",
        "styles"
    ]);
    const prefixCls = getPrefixCls("modal", customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    // Style
    const rootCls = (0, $dnT3A.default)(prefixCls);
    const [wrapCSSVar, hashId] = (0, $4273ff34fb23b4b1$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const wrapClassNameExtended = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(wrapClassName, {
        [`${prefixCls}-centered`]: !!centered,
        [`${prefixCls}-wrap-rtl`]: direction === "rtl"
    });
    const dialogFooter = footer !== null && /*#__PURE__*/ $acw62.createElement((0, $52ee3afc292c0929$export$a06f1c675e846f6f), Object.assign({}, props, {
        onOk: handleOk,
        onCancel: handleCancel
    }));
    const [mergedClosable, mergedCloseIcon] = (0, $cwFcq.default)(closable, closeIcon, (icon)=>(0, $52ee3afc292c0929$export$97c34646962d356e)(prefixCls, icon), /*#__PURE__*/ $acw62.createElement((0, $AWXcC.default), {
        className: `${prefixCls}-close-icon`
    }), true);
    // ============================ Refs ============================
    // Select `ant-modal-content` by `panelRef`
    const panelRef = (0, $9ce1b741d917b083$export$94ab53417567be34)(`.${prefixCls}-content`);
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, $brFSt.useZIndex)("Modal", restProps.zIndex);
    // =========================== Render ===========================
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $3gns8.NoCompactStyle), null, /*#__PURE__*/ $acw62.createElement((0, $eSOz6.NoFormStyle), {
        status: true,
        override: true
    }, /*#__PURE__*/ $acw62.createElement((0, $3GcAE.default).Provider, {
        value: contextZIndex
    }, /*#__PURE__*/ $acw62.createElement((0, $fc48b5916203bd39$export$2e2bcd8739ae039), Object.assign({
        width: width
    }, restProps, {
        zIndex: zIndex,
        getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
        prefixCls: prefixCls,
        rootClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(hashId, rootClassName, rootCls),
        footer: dialogFooter,
        visible: open !== null && open !== void 0 ? open : visible,
        mousePosition: (_a = restProps.mousePosition) !== null && _a !== void 0 ? _a : $e567711acbe5f453$var$mousePosition,
        onClose: handleCancel,
        closable: mergedClosable,
        closeIcon: mergedCloseIcon,
        focusTriggerAfterClose: focusTriggerAfterClose,
        transitionName: (0, $4257x.getTransitionName)(rootPrefixCls, "zoom", props.transitionName),
        maskTransitionName: (0, $4257x.getTransitionName)(rootPrefixCls, "fade", props.maskTransitionName),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(hashId, className, modal === null || modal === void 0 ? void 0 : modal.className),
        style: Object.assign(Object.assign({}, modal === null || modal === void 0 ? void 0 : modal.style), style),
        classNames: Object.assign(Object.assign({
            wrapper: wrapClassNameExtended
        }, modal === null || modal === void 0 ? void 0 : modal.classNames), modalClassNames),
        styles: Object.assign(Object.assign({}, modal === null || modal === void 0 ? void 0 : modal.styles), modalStyles),
        panelRef: panelRef
    }))))));
};
var $e567711acbe5f453$export$2e2bcd8739ae039 = $e567711acbe5f453$var$Modal;


parcelRequire("3i86m");
var $lpQ06 = parcelRequire("lpQ06");


var $670jt = parcelRequire("670jt");

var $P8Drj = parcelRequire("P8Drj");
"use client";
// ============================= Confirm ==============================
const $a173d9189703051e$var$genModalConfirmStyle = (token)=>{
    const { componentCls: componentCls, titleFontSize: titleFontSize, titleLineHeight: titleLineHeight, modalConfirmIconSize: modalConfirmIconSize, fontSize: fontSize, lineHeight: lineHeight, modalTitleHeight: modalTitleHeight, fontHeight: fontHeight, confirmBodyPadding: confirmBodyPadding } = token;
    const confirmComponentCls = `${componentCls}-confirm`;
    return {
        [confirmComponentCls]: {
            "&-rtl": {
                direction: "rtl"
            },
            [`${token.antCls}-modal-header`]: {
                display: "none"
            },
            [`${confirmComponentCls}-body-wrapper`]: Object.assign({}, (0, $670jt.clearFix)()),
            [`&${componentCls} ${componentCls}-body`]: {
                padding: confirmBodyPadding
            },
            // ====================== Body ======================
            [`${confirmComponentCls}-body`]: {
                display: "flex",
                flexWrap: "nowrap",
                alignItems: "start",
                [`> ${token.iconCls}`]: {
                    flex: "none",
                    fontSize: modalConfirmIconSize,
                    marginInlineEnd: token.confirmIconMarginInlineEnd,
                    marginTop: token.calc(token.calc(fontHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
                },
                [`&-has-title > ${token.iconCls}`]: {
                    marginTop: token.calc(token.calc(modalTitleHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
                }
            },
            [`${confirmComponentCls}-paragraph`]: {
                display: "flex",
                flexDirection: "column",
                flex: "auto",
                rowGap: token.marginXS,
                maxWidth: `calc(100% - ${(0, $lpQ06.unit)(token.calc(token.modalConfirmIconSize).add(token.marginSM).equal())})`
            },
            [`${confirmComponentCls}-title`]: {
                color: token.colorTextHeading,
                fontWeight: token.fontWeightStrong,
                fontSize: titleFontSize,
                lineHeight: titleLineHeight
            },
            [`${confirmComponentCls}-content`]: {
                color: token.colorText,
                fontSize: fontSize,
                lineHeight: lineHeight
            },
            // ===================== Footer =====================
            [`${confirmComponentCls}-btns`]: {
                textAlign: "end",
                marginTop: token.confirmBtnsMarginTop,
                [`${token.antCls}-btn + ${token.antCls}-btn`]: {
                    marginBottom: 0,
                    marginInlineStart: token.marginXS
                }
            }
        },
        [`${confirmComponentCls}-error ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorError
        },
        [`${confirmComponentCls}-warning ${confirmComponentCls}-body > ${token.iconCls},
        ${confirmComponentCls}-confirm ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorWarning
        },
        [`${confirmComponentCls}-info ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorInfo
        },
        [`${confirmComponentCls}-success ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorSuccess
        }
    };
};
var // ============================== Export ==============================
$a173d9189703051e$export$2e2bcd8739ae039 = (0, $P8Drj.genSubStyleComponent)([
    "Modal",
    "confirm"
], (token)=>{
    const modalToken = (0, $4273ff34fb23b4b1$export$362fb92a8f81bbf9)(token);
    return [
        $a173d9189703051e$var$genModalConfirmStyle(modalToken)
    ];
}, (0, $4273ff34fb23b4b1$export$9ca1be8807fe0675), {
    // confirm is weak than modal since no conflict here
    order: -1000
});


"use client";
var $e57a817b0bed94b2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $e57a817b0bed94b2$export$78cf841dc2c9f0b5(props) {
    const { prefixCls: prefixCls, icon: icon, okText: okText, cancelText: cancelText, confirmPrefixCls: confirmPrefixCls, type: type, okCancel: okCancel, footer: footer, // Legacy for static function usage
    locale: staticLocale } = props, resetProps = $e57a817b0bed94b2$var$__rest(props, [
        "prefixCls",
        "icon",
        "okText",
        "cancelText",
        "confirmPrefixCls",
        "type",
        "okCancel",
        "footer",
        "locale"
    ]);
    // Icon
    let mergedIcon = icon;
    // 支持传入{ icon: null }来隐藏`Modal.confirm`默认的Icon
    if (!icon && icon !== null) switch(type){
        case "info":
            mergedIcon = /*#__PURE__*/ $acw62.createElement((0, $b5d5d018bfa4ba6e$export$2e2bcd8739ae039), null);
            break;
        case "success":
            mergedIcon = /*#__PURE__*/ $acw62.createElement((0, $9149fdfb4424d1d9$export$2e2bcd8739ae039), null);
            break;
        case "error":
            mergedIcon = /*#__PURE__*/ $acw62.createElement((0, $b9YHa.default), null);
            break;
        default:
            mergedIcon = /*#__PURE__*/ $acw62.createElement((0, $2444f6da62064575$export$2e2bcd8739ae039), null);
    }
    // 默认为 true，保持向下兼容
    const mergedOkCancel = okCancel !== null && okCancel !== void 0 ? okCancel : type === "confirm";
    const autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || "ok";
    const [locale] = (0, $0G7XT.default)("Modal");
    const mergedLocale = staticLocale || locale;
    // ================== Locale Text ==================
    const okTextLocale = okText || (mergedOkCancel ? mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.okText : mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.justOkText);
    const cancelTextLocale = cancelText || (mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.cancelText);
    // ================= Context Value =================
    const btnCtxValue = Object.assign({
        autoFocusButton: autoFocusButton,
        cancelTextLocale: cancelTextLocale,
        okTextLocale: okTextLocale,
        mergedOkCancel: mergedOkCancel
    }, resetProps);
    const btnCtxValueMemo = $acw62.useMemo(()=>btnCtxValue, (0, $kbxxf.default)(Object.values(btnCtxValue)));
    // ====================== Footer Origin Node ======================
    const footerOriginNode = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $b41cca75d2dc2fd0$export$2e2bcd8739ae039), null), /*#__PURE__*/ $acw62.createElement((0, $a937a1d7917b01bb$export$2e2bcd8739ae039), null));
    const hasTitle = props.title !== undefined && props.title !== null;
    const bodyCls = `${confirmPrefixCls}-body`;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: `${confirmPrefixCls}-body-wrapper`
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(bodyCls, {
            [`${bodyCls}-has-title`]: hasTitle
        })
    }, mergedIcon, /*#__PURE__*/ $acw62.createElement("div", {
        className: `${confirmPrefixCls}-paragraph`
    }, hasTitle && /*#__PURE__*/ $acw62.createElement("span", {
        className: `${confirmPrefixCls}-title`
    }, props.title), /*#__PURE__*/ $acw62.createElement("div", {
        className: `${confirmPrefixCls}-content`
    }, props.content))), footer === undefined || typeof footer === "function" ? /*#__PURE__*/ $acw62.createElement((0, $6eed8829240c00e1$export$7c9538f5f3c365e9), {
        value: btnCtxValueMemo
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: `${confirmPrefixCls}-btns`
    }, typeof footer === "function" ? footer(footerOriginNode, {
        OkBtn: $a937a1d7917b01bb$export$2e2bcd8739ae039,
        CancelBtn: $b41cca75d2dc2fd0$export$2e2bcd8739ae039
    }) : footerOriginNode)) : footer, /*#__PURE__*/ $acw62.createElement((0, $a173d9189703051e$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }));
}
const $e57a817b0bed94b2$var$ConfirmDialog = (props)=>{
    const { close: close, zIndex: zIndex, afterClose: afterClose, open: open, keyboard: keyboard, centered: centered, getContainer: getContainer, maskStyle: maskStyle, direction: direction, prefixCls: prefixCls, wrapClassName: wrapClassName, rootPrefixCls: rootPrefixCls, bodyStyle: bodyStyle, closable: closable = false, closeIcon: closeIcon, modalRender: modalRender, focusTriggerAfterClose: focusTriggerAfterClose, onConfirm: onConfirm, styles: styles } = props;
    var _ref;
    const confirmPrefixCls = `${prefixCls}-confirm`;
    const width = props.width || 416;
    const style = props.style || {};
    const mask = props.mask === undefined ? true : props.mask;
    // 默认为 false，保持旧版默认行为
    const maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(confirmPrefixCls, `${confirmPrefixCls}-${props.type}`, {
        [`${confirmPrefixCls}-rtl`]: direction === "rtl"
    }, props.className);
    // ========================= zIndex =========================
    const [, token] = (0, $hRCaH.default)();
    const mergedZIndex = $acw62.useMemo(()=>{
        if (zIndex !== undefined) return zIndex;
        // Static always use max zIndex
        return token.zIndexPopupBase + (0, $brFSt.CONTAINER_MAX_OFFSET);
    }, [
        zIndex,
        token
    ]);
    // ========================= Render =========================
    return /*#__PURE__*/ $acw62.createElement((0, $e567711acbe5f453$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: classString,
        wrapClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
            [`${confirmPrefixCls}-centered`]: !!props.centered
        }, wrapClassName),
        onCancel: ()=>{
            close === null || close === void 0 || close({
                triggerCancel: true
            });
            onConfirm === null || onConfirm === void 0 || onConfirm(false);
        },
        open: open,
        title: "",
        footer: null,
        transitionName: (0, $4257x.getTransitionName)(rootPrefixCls || "", "zoom", props.transitionName),
        maskTransitionName: (0, $4257x.getTransitionName)(rootPrefixCls || "", "fade", props.maskTransitionName),
        mask: mask,
        maskClosable: maskClosable,
        style: style,
        styles: Object.assign({
            body: bodyStyle,
            mask: maskStyle
        }, styles),
        width: width,
        zIndex: mergedZIndex,
        afterClose: afterClose,
        keyboard: keyboard,
        centered: centered,
        getContainer: getContainer,
        closable: closable,
        closeIcon: closeIcon,
        modalRender: modalRender,
        focusTriggerAfterClose: focusTriggerAfterClose
    }, /*#__PURE__*/ $acw62.createElement($e57a817b0bed94b2$export$78cf841dc2c9f0b5, Object.assign({}, props, {
        confirmPrefixCls: confirmPrefixCls
    })));
};
const $e57a817b0bed94b2$var$ConfirmDialogWrapper = (props)=>{
    const { rootPrefixCls: rootPrefixCls, iconPrefixCls: iconPrefixCls, direction: direction, theme: theme } = props;
    return /*#__PURE__*/ $acw62.createElement((0, $aT8OD.default), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: iconPrefixCls,
        direction: direction,
        theme: theme
    }, /*#__PURE__*/ $acw62.createElement($e57a817b0bed94b2$var$ConfirmDialog, Object.assign({}, props)));
};
var $e57a817b0bed94b2$export$2e2bcd8739ae039 = $e57a817b0bed94b2$var$ConfirmDialogWrapper;


const $2077bf4ca69b0fef$var$destroyFns = [];
var $2077bf4ca69b0fef$export$2e2bcd8739ae039 = $2077bf4ca69b0fef$var$destroyFns;



var $62TUi = parcelRequire("62TUi");
"use client";
var $31d3fb1111bc089d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $31d3fb1111bc089d$var$defaultRootPrefixCls = "";
function $31d3fb1111bc089d$var$getRootPrefixCls() {
    return $31d3fb1111bc089d$var$defaultRootPrefixCls;
}
function $31d3fb1111bc089d$export$2e2bcd8739ae039(config) {
    const container = document.createDocumentFragment();
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    let currentConfig = Object.assign(Object.assign({}, config), {
        close: close,
        open: true
    });
    let timeoutId;
    function destroy() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        const triggerCancel = args.some((param)=>param && param.triggerCancel);
        if (config.onCancel && triggerCancel) config.onCancel.apply(config, [
            ()=>{}
        ].concat((0, $kbxxf.default)(args.slice(1))));
        for(let i = 0; i < (0, $2077bf4ca69b0fef$export$2e2bcd8739ae039).length; i++){
            const fn = (0, $2077bf4ca69b0fef$export$2e2bcd8739ae039)[i];
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            if (fn === close) {
                (0, $2077bf4ca69b0fef$export$2e2bcd8739ae039).splice(i, 1);
                break;
            }
        }
        (0, $iORrr.unmount)(container);
    }
    function render(_a) {
        var { okText: okText, cancelText: cancelText, prefixCls: customizePrefixCls, getContainer: getContainer } = _a, props = $31d3fb1111bc089d$var$__rest(_a, [
            "okText",
            "cancelText",
            "prefixCls",
            "getContainer"
        ]);
        clearTimeout(timeoutId);
        /**
     * https://github.com/ant-design/ant-design/issues/23623
     *
     * Sync render blocks React event. Let's make this async.
     */ timeoutId = setTimeout(()=>{
            const runtimeLocale = (0, $62TUi.getConfirmLocale)();
            const { getPrefixCls: getPrefixCls, getIconPrefixCls: getIconPrefixCls, getTheme: getTheme } = (0, $aT8OD.globalConfig)();
            // because Modal.config  set rootPrefixCls, which is different from other components
            const rootPrefixCls = getPrefixCls(undefined, $31d3fb1111bc089d$var$getRootPrefixCls());
            const prefixCls = customizePrefixCls || `${rootPrefixCls}-modal`;
            const iconPrefixCls = getIconPrefixCls();
            const theme = getTheme();
            let mergedGetContainer = getContainer;
            if (mergedGetContainer === false) mergedGetContainer = undefined;
            (0, $iORrr.render)(/*#__PURE__*/ $acw62.createElement((0, $e57a817b0bed94b2$export$2e2bcd8739ae039), Object.assign({}, props, {
                getContainer: mergedGetContainer,
                prefixCls: prefixCls,
                rootPrefixCls: rootPrefixCls,
                iconPrefixCls: iconPrefixCls,
                okText: okText,
                locale: runtimeLocale,
                theme: theme,
                cancelText: cancelText || runtimeLocale.cancelText
            })), container);
        });
    }
    function close() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        currentConfig = Object.assign(Object.assign({}, currentConfig), {
            open: false,
            afterClose: ()=>{
                if (typeof config.afterClose === "function") config.afterClose();
                destroy.apply(this, args);
            }
        });
        // Legacy support
        if (currentConfig.visible) delete currentConfig.visible;
        render(currentConfig);
    }
    function update(configUpdate) {
        if (typeof configUpdate === "function") currentConfig = configUpdate(currentConfig);
        else currentConfig = Object.assign(Object.assign({}, currentConfig), configUpdate);
        render(currentConfig);
    }
    render(currentConfig);
    (0, $2077bf4ca69b0fef$export$2e2bcd8739ae039).push(close);
    return {
        destroy: close,
        update: update
    };
}
function $31d3fb1111bc089d$export$503fa8fed137d104(props) {
    return Object.assign(Object.assign({}, props), {
        type: "warning"
    });
}
function $31d3fb1111bc089d$export$2f728eab0dacbb2e(props) {
    return Object.assign(Object.assign({}, props), {
        type: "info"
    });
}
function $31d3fb1111bc089d$export$2b5f8d7f29c805d4(props) {
    return Object.assign(Object.assign({}, props), {
        type: "success"
    });
}
function $31d3fb1111bc089d$export$60e9e0884ce12b55(props) {
    return Object.assign(Object.assign({}, props), {
        type: "error"
    });
}
function $31d3fb1111bc089d$export$665b64399d4af99c(props) {
    return Object.assign(Object.assign({}, props), {
        type: "confirm"
    });
}
function $31d3fb1111bc089d$export$ff0b30c638ae2396(_ref) {
    let { rootPrefixCls: rootPrefixCls } = _ref;
    $31d3fb1111bc089d$var$defaultRootPrefixCls = rootPrefixCls;
}





var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");


var $acw62 = parcelRequire("acw62");

var $iSQh8 = parcelRequire("iSQh8");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");
var $aT8OD = parcelRequire("aT8OD");
"use client";
function $91653a8941ab7768$export$29e2a8c3cdb34b03(Component) {
    return (props)=>/*#__PURE__*/ $acw62.createElement((0, $aT8OD.default), {
            theme: {
                token: {
                    motion: false,
                    zIndexPopupBase: 0
                }
            }
        }, /*#__PURE__*/ $acw62.createElement(Component, Object.assign({}, props)));
}
/* istanbul ignore next */ const $91653a8941ab7768$var$genPurePanel = (Component, defaultPrefixCls, getDropdownCls, postProps)=>{
    const PurePanel = (props)=>{
        const { prefixCls: customizePrefixCls, style: style } = props;
        const holderRef = $acw62.useRef(null);
        const [popupHeight, setPopupHeight] = $acw62.useState(0);
        const [popupWidth, setPopupWidth] = $acw62.useState(0);
        const [open, setOpen] = (0, $iSQh8.default)(false, {
            value: props.open
        });
        const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $dRTnM.ConfigContext));
        const prefixCls = getPrefixCls(defaultPrefixCls || "select", customizePrefixCls);
        $acw62.useEffect(()=>{
            // We do not care about ssr
            setOpen(true);
            if (typeof ResizeObserver !== "undefined") {
                const resizeObserver = new ResizeObserver((entries)=>{
                    const element = entries[0].target;
                    setPopupHeight(element.offsetHeight + 8);
                    setPopupWidth(element.offsetWidth);
                });
                const interval = setInterval(()=>{
                    var _a;
                    const dropdownCls = getDropdownCls ? `.${getDropdownCls(prefixCls)}` : `.${prefixCls}-dropdown`;
                    const popup = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(dropdownCls);
                    if (popup) {
                        clearInterval(interval);
                        resizeObserver.observe(popup);
                    }
                }, 10);
                return ()=>{
                    clearInterval(interval);
                    resizeObserver.disconnect();
                };
            }
        }, []);
        let mergedProps = Object.assign(Object.assign({}, props), {
            style: Object.assign(Object.assign({}, style), {
                margin: 0
            }),
            open: open,
            visible: open,
            getPopupContainer: ()=>holderRef.current
        });
        if (postProps) mergedProps = postProps(mergedProps);
        const mergedStyle = {
            paddingBottom: popupHeight,
            position: "relative",
            minWidth: popupWidth
        };
        return /*#__PURE__*/ $acw62.createElement("div", {
            ref: holderRef,
            style: mergedStyle
        }, /*#__PURE__*/ $acw62.createElement(Component, Object.assign({}, mergedProps)));
    };
    return $91653a8941ab7768$export$29e2a8c3cdb34b03(PurePanel);
};
var $91653a8941ab7768$export$2e2bcd8739ae039 = $91653a8941ab7768$var$genPurePanel;


parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");




var $dnT3A = parcelRequire("dnT3A");
"use client";
var $5c5e8cd61d089094$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5c5e8cd61d089094$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, closeIcon: closeIcon, closable: closable, type: type, title: title, children: children, footer: footer } = props, restProps = $5c5e8cd61d089094$var$__rest(props, [
        "prefixCls",
        "className",
        "closeIcon",
        "closable",
        "type",
        "title",
        "children",
        "footer"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const rootPrefixCls = getPrefixCls();
    const prefixCls = customizePrefixCls || getPrefixCls("modal");
    const rootCls = (0, $dnT3A.default)(rootPrefixCls);
    const [wrapCSSVar, hashId] = (0, $4273ff34fb23b4b1$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const confirmPrefixCls = `${prefixCls}-confirm`;
    // Choose target props by confirm mark
    let additionalProps = {};
    if (type) additionalProps = {
        closable: closable !== null && closable !== void 0 ? closable : false,
        title: "",
        footer: "",
        children: /*#__PURE__*/ $acw62.createElement((0, $e57a817b0bed94b2$export$78cf841dc2c9f0b5), Object.assign({}, props, {
            prefixCls: prefixCls,
            confirmPrefixCls: confirmPrefixCls,
            rootPrefixCls: rootPrefixCls,
            content: children
        }))
    };
    else additionalProps = {
        closable: closable !== null && closable !== void 0 ? closable : true,
        title: title,
        footer: footer !== null && /*#__PURE__*/ $acw62.createElement((0, $52ee3afc292c0929$export$a06f1c675e846f6f), Object.assign({}, props)),
        children: children
    };
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $d87bfeabd0b3848d$export$2e2bcd8739ae039), Object.assign({
        prefixCls: prefixCls,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(hashId, `${prefixCls}-pure-panel`, type && confirmPrefixCls, type && `${confirmPrefixCls}-${type}`, className, rootCls)
    }, restProps, {
        closeIcon: (0, $52ee3afc292c0929$export$97c34646962d356e)(prefixCls, closeIcon),
        closable: closable
    }, additionalProps)));
};
var $5c5e8cd61d089094$export$2e2bcd8739ae039 = (0, $91653a8941ab7768$export$29e2a8c3cdb34b03)($5c5e8cd61d089094$var$PurePanel);



var $kbxxf = parcelRequire("kbxxf");

var $acw62 = parcelRequire("acw62");

var $kbxxf = parcelRequire("kbxxf");

var $acw62 = parcelRequire("acw62");
"use client";
function $36203fe8ea319954$export$2e2bcd8739ae039() {
    const [elements, setElements] = $acw62.useState([]);
    const patchElement = $acw62.useCallback((element)=>{
        // append a new element to elements (and create a new ref)
        setElements((originElements)=>[].concat((0, $kbxxf.default)(originElements), [
                element
            ]));
        // return a function that removes the new element out of elements (and create a new ref)
        // it works a little like useEffect
        return ()=>{
            setElements((originElements)=>originElements.filter((ele)=>ele !== element));
        };
    }, []);
    return [
        elements,
        patchElement
    ];
}





var $kbxxf = parcelRequire("kbxxf");

var $acw62 = parcelRequire("acw62");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $h9Mt9 = parcelRequire("h9Mt9");

var $0G7XT = parcelRequire("0G7XT");

"use client";
var $f743e93ee4f7840b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $f743e93ee4f7840b$var$HookModal = (_a, ref)=>{
    var _b;
    var { afterClose: hookAfterClose, config: config } = _a, restProps = $f743e93ee4f7840b$var$__rest(_a, [
        "afterClose",
        "config"
    ]);
    const [open, setOpen] = $acw62.useState(true);
    const [innerConfig, setInnerConfig] = $acw62.useState(config);
    const { direction: direction, getPrefixCls: getPrefixCls } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const prefixCls = getPrefixCls("modal");
    const rootPrefixCls = getPrefixCls();
    const afterClose = ()=>{
        var _a;
        hookAfterClose();
        (_a = innerConfig.afterClose) === null || _a === void 0 || _a.call(innerConfig);
    };
    const close = function() {
        setOpen(false);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        const triggerCancel = args.some((param)=>param && param.triggerCancel);
        if (innerConfig.onCancel && triggerCancel) innerConfig.onCancel.apply(innerConfig, [
            ()=>{}
        ].concat((0, $kbxxf.default)(args.slice(1))));
    };
    $acw62.useImperativeHandle(ref, ()=>({
            destroy: close,
            update: (newConfig)=>{
                setInnerConfig((originConfig)=>Object.assign(Object.assign({}, originConfig), newConfig));
            }
        }));
    const mergedOkCancel = (_b = innerConfig.okCancel) !== null && _b !== void 0 ? _b : innerConfig.type === "confirm";
    const [contextLocale] = (0, $0G7XT.default)("Modal", (0, $h9Mt9.default).Modal);
    return /*#__PURE__*/ $acw62.createElement((0, $e57a817b0bed94b2$export$2e2bcd8739ae039), Object.assign({
        prefixCls: prefixCls,
        rootPrefixCls: rootPrefixCls
    }, innerConfig, {
        close: close,
        open: open,
        afterClose: afterClose,
        okText: innerConfig.okText || (mergedOkCancel ? contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.okText : contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.justOkText),
        direction: innerConfig.direction || direction,
        cancelText: innerConfig.cancelText || (contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.cancelText)
    }, restProps));
};
var $f743e93ee4f7840b$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($f743e93ee4f7840b$var$HookModal);


"use client";
let $b16aece18eefbd47$var$uuid = 0;
const $b16aece18eefbd47$var$ElementsHolder = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef((_props, ref)=>{
    const [elements, patchElement] = (0, $36203fe8ea319954$export$2e2bcd8739ae039)();
    $acw62.useImperativeHandle(ref, ()=>({
            patchElement: patchElement
        }), []);
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, elements);
}));
function $b16aece18eefbd47$var$useModal() {
    const holderRef = $acw62.useRef(null);
    // ========================== Effect ==========================
    const [actionQueue, setActionQueue] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        if (actionQueue.length) {
            const cloneQueue = (0, $kbxxf.default)(actionQueue);
            cloneQueue.forEach((action)=>{
                action();
            });
            setActionQueue([]);
        }
    }, [
        actionQueue
    ]);
    // =========================== Hook ===========================
    const getConfirmFunc = $acw62.useCallback((withFunc)=>function hookConfirm(config) {
            var _a;
            $b16aece18eefbd47$var$uuid += 1;
            const modalRef = /*#__PURE__*/ $acw62.createRef();
            // Proxy to promise with `onClose`
            let resolvePromise;
            const promise = new Promise((resolve)=>{
                resolvePromise = resolve;
            });
            let silent = false;
            let closeFunc;
            const modal = /*#__PURE__*/ $acw62.createElement((0, $f743e93ee4f7840b$export$2e2bcd8739ae039), {
                key: `modal-${$b16aece18eefbd47$var$uuid}`,
                config: withFunc(config),
                ref: modalRef,
                afterClose: ()=>{
                    closeFunc === null || closeFunc === void 0 || closeFunc();
                },
                isSilent: ()=>silent,
                onConfirm: (confirmed)=>{
                    resolvePromise(confirmed);
                }
            });
            closeFunc = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.patchElement(modal);
            if (closeFunc) (0, $2077bf4ca69b0fef$export$2e2bcd8739ae039).push(closeFunc);
            const instance = {
                destroy: ()=>{
                    function destroyAction() {
                        var _a;
                        (_a = modalRef.current) === null || _a === void 0 || _a.destroy();
                    }
                    if (modalRef.current) destroyAction();
                    else setActionQueue((prev)=>[].concat((0, $kbxxf.default)(prev), [
                            destroyAction
                        ]));
                },
                update: (newConfig)=>{
                    function updateAction() {
                        var _a;
                        (_a = modalRef.current) === null || _a === void 0 || _a.update(newConfig);
                    }
                    if (modalRef.current) updateAction();
                    else setActionQueue((prev)=>[].concat((0, $kbxxf.default)(prev), [
                            updateAction
                        ]));
                },
                then: (resolve)=>{
                    silent = true;
                    return promise.then(resolve);
                }
            };
            return instance;
        }, []);
    const fns = $acw62.useMemo(()=>({
            info: getConfirmFunc((0, $31d3fb1111bc089d$export$2f728eab0dacbb2e)),
            success: getConfirmFunc((0, $31d3fb1111bc089d$export$2b5f8d7f29c805d4)),
            error: getConfirmFunc((0, $31d3fb1111bc089d$export$60e9e0884ce12b55)),
            warning: getConfirmFunc((0, $31d3fb1111bc089d$export$503fa8fed137d104)),
            confirm: getConfirmFunc((0, $31d3fb1111bc089d$export$665b64399d4af99c))
        }), []);
    return [
        fns,
        /*#__PURE__*/ $acw62.createElement($b16aece18eefbd47$var$ElementsHolder, {
            key: "modal-holder",
            ref: holderRef
        })
    ];
}
var $b16aece18eefbd47$export$2e2bcd8739ae039 = $b16aece18eefbd47$var$useModal;


"use client";
function $e47cb76d58815cb1$var$modalWarn(props) {
    return (0, $31d3fb1111bc089d$export$2e2bcd8739ae039)((0, $31d3fb1111bc089d$export$503fa8fed137d104)(props));
}
const $e47cb76d58815cb1$var$Modal = (0, $e567711acbe5f453$export$2e2bcd8739ae039);
$e47cb76d58815cb1$var$Modal.useModal = (0, $b16aece18eefbd47$export$2e2bcd8739ae039);
$e47cb76d58815cb1$var$Modal.info = function infoFn(props) {
    return (0, $31d3fb1111bc089d$export$2e2bcd8739ae039)((0, $31d3fb1111bc089d$export$2f728eab0dacbb2e)(props));
};
$e47cb76d58815cb1$var$Modal.success = function successFn(props) {
    return (0, $31d3fb1111bc089d$export$2e2bcd8739ae039)((0, $31d3fb1111bc089d$export$2b5f8d7f29c805d4)(props));
};
$e47cb76d58815cb1$var$Modal.error = function errorFn(props) {
    return (0, $31d3fb1111bc089d$export$2e2bcd8739ae039)((0, $31d3fb1111bc089d$export$60e9e0884ce12b55)(props));
};
$e47cb76d58815cb1$var$Modal.warning = $e47cb76d58815cb1$var$modalWarn;
$e47cb76d58815cb1$var$Modal.warn = $e47cb76d58815cb1$var$modalWarn;
$e47cb76d58815cb1$var$Modal.confirm = function confirmFn(props) {
    return (0, $31d3fb1111bc089d$export$2e2bcd8739ae039)((0, $31d3fb1111bc089d$export$665b64399d4af99c)(props));
};
$e47cb76d58815cb1$var$Modal.destroyAll = function destroyAllFn() {
    while((0, $2077bf4ca69b0fef$export$2e2bcd8739ae039).length){
        const close = (0, $2077bf4ca69b0fef$export$2e2bcd8739ae039).pop();
        if (close) close();
    }
};
$e47cb76d58815cb1$var$Modal.config = (0, $31d3fb1111bc089d$export$ff0b30c638ae2396);
$e47cb76d58815cb1$var$Modal._InternalPanelDoNotUseOrYouWillBeFired = (0, $5c5e8cd61d089094$export$2e2bcd8739ae039);
var $e47cb76d58815cb1$export$2e2bcd8739ae039 = $e47cb76d58815cb1$var$Modal;


var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");
const $c676d8b8b586adda$export$15e5fca53711d340 = (propValue)=>{
    if (!propValue) return null;
    return typeof propValue === "function" ? propValue() : propValue;
};



var $4257x = parcelRequire("4257x");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $VoMtX = parcelRequire("VoMtX");

var $8g1PZ = parcelRequire("8g1PZ");
parcelRequire("hRA8u");
var $7v8Xm = parcelRequire("7v8Xm");

var $acw62 = parcelRequire("acw62");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");


var $670jt = parcelRequire("670jt");

var $i1ZDk = parcelRequire("i1ZDk");

var $1HprZ = parcelRequire("1HprZ");

var $P8Drj = parcelRequire("P8Drj");
var $2LRCS = parcelRequire("2LRCS");
var $bZMQK = parcelRequire("bZMQK");

var $11ZuO = parcelRequire("11ZuO");
"use client";
const $7c34a58b2ba4d17c$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, popoverColor: popoverColor, titleMinWidth: titleMinWidth, fontWeightStrong: fontWeightStrong, innerPadding: innerPadding, boxShadowSecondary: boxShadowSecondary, colorTextHeading: colorTextHeading, borderRadiusLG: borderRadiusLG, zIndexPopup: zIndexPopup, titleMarginBottom: titleMarginBottom, colorBgElevated: colorBgElevated, popoverBg: popoverBg, titleBorderBottom: titleBorderBottom, innerContentPadding: innerContentPadding, titlePadding: titlePadding } = token;
    return [
        {
            [componentCls]: Object.assign(Object.assign({}, (0, $670jt.resetComponent)(token)), {
                position: "absolute",
                top: 0,
                // use `left` to fix https://github.com/ant-design/ant-design/issues/39195
                left: {
                    _skip_check_: true,
                    value: 0
                },
                zIndex: zIndexPopup,
                fontWeight: "normal",
                whiteSpace: "normal",
                textAlign: "start",
                cursor: "auto",
                userSelect: "text",
                transformOrigin: `var(--arrow-x, 50%) var(--arrow-y, 50%)`,
                "--antd-arrow-background-color": colorBgElevated,
                "&-rtl": {
                    direction: "rtl"
                },
                "&-hidden": {
                    display: "none"
                },
                [`${componentCls}-content`]: {
                    position: "relative"
                },
                [`${componentCls}-inner`]: {
                    backgroundColor: popoverBg,
                    backgroundClip: "padding-box",
                    borderRadius: borderRadiusLG,
                    boxShadow: boxShadowSecondary,
                    padding: innerPadding
                },
                [`${componentCls}-title`]: {
                    minWidth: titleMinWidth,
                    marginBottom: titleMarginBottom,
                    color: colorTextHeading,
                    fontWeight: fontWeightStrong,
                    borderBottom: titleBorderBottom,
                    padding: titlePadding
                },
                [`${componentCls}-inner-content`]: {
                    color: popoverColor,
                    padding: innerContentPadding
                }
            })
        },
        // Arrow Style
        (0, $1HprZ.default)(token, "var(--antd-arrow-background-color)"),
        // Pure Render
        {
            [`${componentCls}-pure`]: {
                position: "relative",
                maxWidth: "none",
                margin: token.sizePopupArrow,
                display: "inline-block",
                [`${componentCls}-content`]: {
                    display: "inline-block"
                }
            }
        }
    ];
};
const $7c34a58b2ba4d17c$var$genColorStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: (0, $bZMQK.PresetColors).map((colorKey)=>{
            const lightColor = token[`${colorKey}6`];
            return {
                [`&${componentCls}-${colorKey}`]: {
                    "--antd-arrow-background-color": lightColor,
                    [`${componentCls}-inner`]: {
                        backgroundColor: lightColor
                    },
                    [`${componentCls}-arrow`]: {
                        background: "transparent"
                    }
                }
            };
        })
    };
};
const $7c34a58b2ba4d17c$export$9ca1be8807fe0675 = (token)=>{
    const { lineWidth: lineWidth, controlHeight: controlHeight, fontHeight: fontHeight, padding: padding, wireframe: wireframe, zIndexPopupBase: zIndexPopupBase, borderRadiusLG: borderRadiusLG, marginXS: marginXS, lineType: lineType, colorSplit: colorSplit, paddingSM: paddingSM } = token;
    const titlePaddingBlockDist = controlHeight - fontHeight;
    const popoverTitlePaddingBlockTop = titlePaddingBlockDist / 2;
    const popoverTitlePaddingBlockBottom = titlePaddingBlockDist / 2 - lineWidth;
    const popoverPaddingHorizontal = padding;
    return Object.assign(Object.assign(Object.assign({
        titleMinWidth: 177,
        zIndexPopup: zIndexPopupBase + 30
    }, (0, $11ZuO.getArrowToken)(token)), (0, $1HprZ.getArrowOffsetToken)({
        contentRadius: borderRadiusLG,
        limitVerticalRadius: true
    })), {
        // internal
        innerPadding: wireframe ? 0 : 12,
        titleMarginBottom: wireframe ? 0 : marginXS,
        titlePadding: wireframe ? `${popoverTitlePaddingBlockTop}px ${popoverPaddingHorizontal}px ${popoverTitlePaddingBlockBottom}px` : 0,
        titleBorderBottom: wireframe ? `${lineWidth}px ${lineType} ${colorSplit}` : "none",
        innerContentPadding: wireframe ? `${paddingSM}px ${popoverPaddingHorizontal}px` : 0
    });
};
var $7c34a58b2ba4d17c$export$2e2bcd8739ae039 = (0, $P8Drj.genStyleHooks)("Popover", (token)=>{
    const { colorBgElevated: colorBgElevated, colorText: colorText } = token;
    const popoverToken = (0, $2LRCS.merge)(token, {
        popoverBg: colorBgElevated,
        popoverColor: colorText
    });
    return [
        $7c34a58b2ba4d17c$var$genBaseStyle(popoverToken),
        $7c34a58b2ba4d17c$var$genColorStyle(popoverToken),
        (0, $i1ZDk.initZoomMotion)(popoverToken, "zoom-big")
    ];
}, $7c34a58b2ba4d17c$export$9ca1be8807fe0675, {
    resetStyle: false,
    deprecatedTokens: [
        [
            "width",
            "titleMinWidth"
        ],
        [
            "minWidth",
            "titleMinWidth"
        ]
    ]
});


"use client";
var $b7a2edcc9afcf494$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $b7a2edcc9afcf494$export$6953fc58cbc4170a = (prefixCls, title, content)=>{
    if (!title && !content) return undefined;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, title && /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-title`
    }, (0, $c676d8b8b586adda$export$15e5fca53711d340)(title)), /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-inner-content`
    }, (0, $c676d8b8b586adda$export$15e5fca53711d340)(content)));
};
const $b7a2edcc9afcf494$export$c40925af82c95d5b = (props)=>{
    const { hashId: hashId, prefixCls: prefixCls, className: className, style: style, placement: placement = "top", title: title, content: content, children: children } = props;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(hashId, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className),
        style: style
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ $acw62.createElement((0, $7v8Xm.default), Object.assign({}, props, {
        className: hashId,
        prefixCls: prefixCls
    }), children || $b7a2edcc9afcf494$export$6953fc58cbc4170a(prefixCls, title, content)));
};
const $b7a2edcc9afcf494$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls } = props, restProps = $b7a2edcc9afcf494$var$__rest(props, [
        "prefixCls"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const prefixCls = getPrefixCls("popover", customizePrefixCls);
    const [wrapCSSVar, hashId] = (0, $7c34a58b2ba4d17c$export$2e2bcd8739ae039)(prefixCls);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement($b7a2edcc9afcf494$export$c40925af82c95d5b, Object.assign({}, restProps, {
        prefixCls: prefixCls,
        hashId: hashId
    })));
};
var $b7a2edcc9afcf494$export$2e2bcd8739ae039 = $b7a2edcc9afcf494$var$PurePanel;



"use client";
var $50a5b629c434844e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $50a5b629c434844e$var$Overlay = (_ref)=>{
    let { title: title, content: content, prefixCls: prefixCls } = _ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, title && /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-title`
    }, (0, $c676d8b8b586adda$export$15e5fca53711d340)(title)), /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-inner-content`
    }, (0, $c676d8b8b586adda$export$15e5fca53711d340)(content)));
};
const $50a5b629c434844e$var$Popover = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, title: title, content: content, overlayClassName: overlayClassName, placement: placement = "top", trigger: trigger = "hover", mouseEnterDelay: mouseEnterDelay = 0.1, mouseLeaveDelay: mouseLeaveDelay = 0.1, overlayStyle: overlayStyle = {} } = props, otherProps = $50a5b629c434844e$var$__rest(props, [
        "prefixCls",
        "title",
        "content",
        "overlayClassName",
        "placement",
        "trigger",
        "mouseEnterDelay",
        "mouseLeaveDelay",
        "overlayStyle"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const prefixCls = getPrefixCls("popover", customizePrefixCls);
    const [wrapCSSVar, hashId] = (0, $7c34a58b2ba4d17c$export$2e2bcd8739ae039)(prefixCls);
    const rootPrefixCls = getPrefixCls();
    const overlayCls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(overlayClassName, hashId);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $VoMtX.default), Object.assign({
        placement: placement,
        trigger: trigger,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        overlayStyle: overlayStyle
    }, otherProps, {
        prefixCls: prefixCls,
        overlayClassName: overlayCls,
        ref: ref,
        overlay: title || content ? /*#__PURE__*/ $acw62.createElement($50a5b629c434844e$var$Overlay, {
            prefixCls: prefixCls,
            title: title,
            content: content
        }) : null,
        transitionName: (0, $4257x.getTransitionName)(rootPrefixCls, "zoom-big", otherProps.transitionName),
        "data-popover-inject": true
    })));
});
$50a5b629c434844e$var$Popover._InternalPanelDoNotUseOrYouWillBeFired = (0, $b7a2edcc9afcf494$export$2e2bcd8739ae039);
var $50a5b629c434844e$export$2e2bcd8739ae039 = $50a5b629c434844e$var$Popover;


var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8nd05 = parcelRequire("8nd05");

var $kbxxf = parcelRequire("kbxxf");

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $fSwVM = parcelRequire("fSwVM");

var $iSQh8 = parcelRequire("iSQh8");
parcelRequire("u43uR");

var $acw62 = parcelRequire("acw62");

var $fSwVM = parcelRequire("fSwVM");

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $kbxxf = parcelRequire("kbxxf");

var $eUqlC = parcelRequire("eUqlC");

var $d49SP = parcelRequire("d49SP");

var $9X7IJ = parcelRequire("9X7IJ");

var $8g1PZ = parcelRequire("8g1PZ");

var $6hDTM = parcelRequire("6hDTM");

var $iSQh8 = parcelRequire("iSQh8");

var $ycMhT = parcelRequire("ycMhT");

var $iCi4s = parcelRequire("iCi4s");

var $85dLH = parcelRequire("85dLH");

var $acw62 = parcelRequire("acw62");

var $fSwVM = parcelRequire("fSwVM");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");
var $707d52f2ac65b829$var$TransBtn = function TransBtn(_ref) {
    var className = _ref.className, customizeIcon = _ref.customizeIcon, customizeIconProps = _ref.customizeIconProps, _onMouseDown = _ref.onMouseDown, onClick = _ref.onClick, children = _ref.children;
    var icon;
    if (typeof customizeIcon === "function") icon = customizeIcon(customizeIconProps);
    else icon = customizeIcon;
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: className,
        onMouseDown: function onMouseDown(event) {
            event.preventDefault();
            if (_onMouseDown) _onMouseDown(event);
        },
        style: {
            userSelect: "none",
            WebkitUserSelect: "none"
        },
        unselectable: "on",
        onClick: onClick,
        "aria-hidden": true
    }, icon !== undefined ? icon : /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className.split(/\s+/).map(function(cls) {
            return "".concat(cls, "-icon");
        }))
    }, children));
};
var $707d52f2ac65b829$export$2e2bcd8739ae039 = $707d52f2ac65b829$var$TransBtn;



var $acw62 = parcelRequire("acw62");
function $2025e240a41c9299$export$9ea6397a890aa3e5(prefixCls, onClearMouseDown, displayValues, allowClear, clearIcon) {
    var disabled = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    var mergedSearchValue = arguments.length > 6 ? arguments[6] : undefined;
    var mode = arguments.length > 7 ? arguments[7] : undefined;
    var mergedClearIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        if ((0, $fSwVM.default)(allowClear) === "object") return allowClear.clearIcon;
        if (!!clearIcon) return clearIcon;
    }, [
        allowClear,
        clearIcon
    ]);
    var mergedAllowClear = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        if (!disabled && !!allowClear && (displayValues.length || mergedSearchValue) && !(mode === "combobox" && mergedSearchValue === "")) return true;
        return false;
    }, [
        allowClear,
        disabled,
        displayValues.length,
        mergedSearchValue,
        mode
    ]);
    return {
        allowClear: mergedAllowClear,
        clearIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $707d52f2ac65b829$export$2e2bcd8739ae039), {
            className: "".concat(prefixCls, "-clear"),
            onMouseDown: onClearMouseDown,
            customizeIcon: mergedClearIcon
        }, "\xd7")
    };
}


/**
 * BaseSelect provide some parsed data into context.
 * You can use this hooks to get them.
 */ 
var $acw62 = parcelRequire("acw62");
var $de346c10040f695b$export$8234047c0aea33cf = /*#__PURE__*/ $acw62.createContext(null);
function $de346c10040f695b$export$2e2bcd8739ae039() {
    return $acw62.useContext($de346c10040f695b$export$8234047c0aea33cf);
}



var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");
function $6ca183ed87ff681f$export$2e2bcd8739ae039() {
    var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), bool = _React$useState2[0], setBool = _React$useState2[1];
    var delayRef = $acw62.useRef(null);
    var cancelLatest = function cancelLatest() {
        window.clearTimeout(delayRef.current);
    };
    $acw62.useEffect(function() {
        return cancelLatest;
    }, []);
    var delaySetBool = function delaySetBool(value, callback) {
        cancelLatest();
        delayRef.current = window.setTimeout(function() {
            setBool(value);
            if (callback) callback();
        }, timeout);
    };
    return [
        bool,
        delaySetBool,
        cancelLatest
    ];
}



var $acw62 = parcelRequire("acw62");
function $d2c203a0ff231923$export$2e2bcd8739ae039() {
    var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 250;
    var lockRef = $acw62.useRef(null);
    var timeoutRef = $acw62.useRef(null);
    // Clean up
    $acw62.useEffect(function() {
        return function() {
            window.clearTimeout(timeoutRef.current);
        };
    }, []);
    function doLock(locked) {
        if (locked || lockRef.current === null) lockRef.current = locked;
        window.clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(function() {
            lockRef.current = null;
        }, duration);
    }
    return [
        function() {
            return lockRef.current;
        },
        doLock
    ];
}



var $acw62 = parcelRequire("acw62");
function $aebeaa3bc993c458$export$2e2bcd8739ae039(elements, open, triggerOpen, customizedTrigger) {
    var propsRef = $acw62.useRef(null);
    propsRef.current = {
        open: open,
        triggerOpen: triggerOpen,
        customizedTrigger: customizedTrigger
    };
    $acw62.useEffect(function() {
        function onGlobalMouseDown(event) {
            var _propsRef$current;
            // If trigger is customized, Trigger will take control of popupVisible
            if ((_propsRef$current = propsRef.current) !== null && _propsRef$current !== void 0 && _propsRef$current.customizedTrigger) return;
            var target = event.target;
            if (target.shadowRoot && event.composed) target = event.composedPath()[0] || target;
            if (propsRef.current.open && elements().filter(function(element) {
                return element;
            }).every(function(element) {
                return !element.contains(target) && element !== target;
            })) // Should trigger close
            propsRef.current.triggerOpen(false);
        }
        window.addEventListener("mousedown", onGlobalMouseDown);
        return function() {
            return window.removeEventListener("mousedown", onGlobalMouseDown);
        };
    }, []);
}



var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $iCi4s = parcelRequire("iCi4s");

var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");


var $6dkAu = parcelRequire("6dkAu");


var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $85dLH = parcelRequire("85dLH");

var $u43uR = parcelRequire("u43uR");
var $2a075c3c6c029a86$var$Input = function Input(_ref, ref) {
    var _inputNode2;
    var prefixCls = _ref.prefixCls, id = _ref.id, inputElement = _ref.inputElement, disabled = _ref.disabled, tabIndex = _ref.tabIndex, autoFocus = _ref.autoFocus, autoComplete = _ref.autoComplete, editable = _ref.editable, activeDescendantId = _ref.activeDescendantId, value = _ref.value, maxLength = _ref.maxLength, _onKeyDown = _ref.onKeyDown, _onMouseDown = _ref.onMouseDown, _onChange = _ref.onChange, onPaste = _ref.onPaste, _onCompositionStart = _ref.onCompositionStart, _onCompositionEnd = _ref.onCompositionEnd, open = _ref.open, attrs = _ref.attrs;
    var inputNode = inputElement || /*#__PURE__*/ $acw62.createElement("input", null);
    var _inputNode = inputNode, originRef = _inputNode.ref, originProps = _inputNode.props;
    var onOriginKeyDown = originProps.onKeyDown, onOriginChange = originProps.onChange, onOriginMouseDown = originProps.onMouseDown, onOriginCompositionStart = originProps.onCompositionStart, onOriginCompositionEnd = originProps.onCompositionEnd, style = originProps.style;
    (0, $u43uR.warning)(!("maxLength" in inputNode.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled.");
    inputNode = /*#__PURE__*/ $acw62.cloneElement(inputNode, (0, $d49SP.default)((0, $d49SP.default)((0, $d49SP.default)({
        type: "search"
    }, originProps), {}, {
        // Override over origin props
        id: id,
        ref: (0, $85dLH.composeRef)(ref, originRef),
        disabled: disabled,
        tabIndex: tabIndex,
        autoComplete: autoComplete || "off",
        autoFocus: autoFocus,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-selection-search-input"), (_inputNode2 = inputNode) === null || _inputNode2 === void 0 || (_inputNode2 = _inputNode2.props) === null || _inputNode2 === void 0 ? void 0 : _inputNode2.className),
        role: "combobox",
        "aria-expanded": open || false,
        "aria-haspopup": "listbox",
        "aria-owns": "".concat(id, "_list"),
        "aria-autocomplete": "list",
        "aria-controls": "".concat(id, "_list"),
        "aria-activedescendant": open ? activeDescendantId : undefined
    }, attrs), {}, {
        value: editable ? value : "",
        maxLength: maxLength,
        readOnly: !editable,
        unselectable: !editable ? "on" : null,
        style: (0, $d49SP.default)((0, $d49SP.default)({}, style), {}, {
            opacity: editable ? null : 0
        }),
        onKeyDown: function onKeyDown(event) {
            _onKeyDown(event);
            if (onOriginKeyDown) onOriginKeyDown(event);
        },
        onMouseDown: function onMouseDown(event) {
            _onMouseDown(event);
            if (onOriginMouseDown) onOriginMouseDown(event);
        },
        onChange: function onChange(event) {
            _onChange(event);
            if (onOriginChange) onOriginChange(event);
        },
        onCompositionStart: function onCompositionStart(event) {
            _onCompositionStart(event);
            if (onOriginCompositionStart) onOriginCompositionStart(event);
        },
        onCompositionEnd: function onCompositionEnd(event) {
            _onCompositionEnd(event);
            if (onOriginCompositionEnd) onOriginCompositionEnd(event);
        },
        onPaste: onPaste
    }));
    return inputNode;
};
var $2a075c3c6c029a86$var$RefInput = /*#__PURE__*/ $acw62.forwardRef($2a075c3c6c029a86$var$Input);
$2a075c3c6c029a86$var$RefInput.displayName = "Input";
var $2a075c3c6c029a86$export$2e2bcd8739ae039 = $2a075c3c6c029a86$var$RefInput;


/* eslint-disable react-hooks/rules-of-hooks */ 
var $acw62 = parcelRequire("acw62");

var $fSwVM = parcelRequire("fSwVM");
function $953a8baf84e85e44$export$45b10814cc054894(value) {
    if (Array.isArray(value)) return value;
    return value !== undefined ? [
        value
    ] : [];
}
var $953a8baf84e85e44$export$7383f122bf48ec30 = typeof window !== "undefined" && window.document && window.document.documentElement;
var $953a8baf84e85e44$export$df7146797a248522 = $953a8baf84e85e44$export$7383f122bf48ec30;
function $953a8baf84e85e44$export$96bdbc84526f3739(value) {
    return value !== undefined && value !== null;
}
function $953a8baf84e85e44$export$9d186c3672bb89c6(value) {
    return !value && value !== 0;
}
function $953a8baf84e85e44$var$isTitleType(title) {
    return [
        "string",
        "number"
    ].includes((0, $fSwVM.default)(title));
}
function $953a8baf84e85e44$export$70d1bf7729efff40(item) {
    var title = undefined;
    if (item) {
        if ($953a8baf84e85e44$var$isTitleType(item.title)) title = item.title.toString();
        else if ($953a8baf84e85e44$var$isTitleType(item.label)) title = item.label.toString();
    }
    return title;
}


function $614cdd3d723d82e4$export$2e2bcd8739ae039(effect, deps) {
    // Never happen in test env
    if (0, $953a8baf84e85e44$export$df7146797a248522) /* istanbul ignore next */ $acw62.useLayoutEffect(effect, deps);
    else $acw62.useEffect(effect, deps);
} /* eslint-enable */ 



function $d5637f77b1efb84d$var$itemKey(value) {
    var _value$key;
    return (_value$key = value.key) !== null && _value$key !== void 0 ? _value$key : value.value;
}
var $d5637f77b1efb84d$var$onPreventMouseDown = function onPreventMouseDown(event) {
    event.preventDefault();
    event.stopPropagation();
};
var $d5637f77b1efb84d$var$SelectSelector = function SelectSelector(props) {
    var id = props.id, prefixCls = props.prefixCls, values = props.values, open = props.open, searchValue = props.searchValue, autoClearSearchValue = props.autoClearSearchValue, inputRef = props.inputRef, placeholder = props.placeholder, disabled = props.disabled, mode = props.mode, showSearch = props.showSearch, autoFocus = props.autoFocus, autoComplete = props.autoComplete, activeDescendantId = props.activeDescendantId, tabIndex = props.tabIndex, removeIcon = props.removeIcon, maxTagCount = props.maxTagCount, maxTagTextLength = props.maxTagTextLength, _props$maxTagPlacehol = props.maxTagPlaceholder, maxTagPlaceholder = _props$maxTagPlacehol === void 0 ? function(omittedValues) {
        return "+ ".concat(omittedValues.length, " ...");
    } : _props$maxTagPlacehol, tagRender = props.tagRender, onToggleOpen = props.onToggleOpen, onRemove = props.onRemove, onInputChange = props.onInputChange, onInputPaste = props.onInputPaste, onInputKeyDown = props.onInputKeyDown, onInputMouseDown = props.onInputMouseDown, onInputCompositionStart = props.onInputCompositionStart, onInputCompositionEnd = props.onInputCompositionEnd;
    var measureRef = $acw62.useRef(null);
    var _useState = (0, $acw62.useState)(0), _useState2 = (0, $eUqlC.default)(_useState, 2), inputWidth = _useState2[0], setInputWidth = _useState2[1];
    var _useState3 = (0, $acw62.useState)(false), _useState4 = (0, $eUqlC.default)(_useState3, 2), focused = _useState4[0], setFocused = _useState4[1];
    var selectionPrefixCls = "".concat(prefixCls, "-selection");
    // ===================== Search ======================
    var inputValue = open || mode === "multiple" && autoClearSearchValue === false || mode === "tags" ? searchValue : "";
    var inputEditable = mode === "tags" || mode === "multiple" && autoClearSearchValue === false || showSearch && (open || focused);
    // We measure width and set to the input immediately
    (0, $614cdd3d723d82e4$export$2e2bcd8739ae039)(function() {
        setInputWidth(measureRef.current.scrollWidth);
    }, [
        inputValue
    ]);
    // ===================== Render ======================
    // >>> Render Selector Node. Includes Item & Rest
    function defaultRenderSelector(item, content, itemDisabled, closable, onClose) {
        return /*#__PURE__*/ $acw62.createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(selectionPrefixCls, "-item"), (0, $kSlfw.default)({}, "".concat(selectionPrefixCls, "-item-disabled"), itemDisabled)),
            title: (0, $953a8baf84e85e44$export$70d1bf7729efff40)(item)
        }, /*#__PURE__*/ $acw62.createElement("span", {
            className: "".concat(selectionPrefixCls, "-item-content")
        }, content), closable && /*#__PURE__*/ $acw62.createElement((0, $707d52f2ac65b829$export$2e2bcd8739ae039), {
            className: "".concat(selectionPrefixCls, "-item-remove"),
            onMouseDown: $d5637f77b1efb84d$var$onPreventMouseDown,
            onClick: onClose,
            customizeIcon: removeIcon
        }, "\xd7"));
    }
    function customizeRenderSelector(value, content, itemDisabled, closable, onClose) {
        var onMouseDown = function onMouseDown(e) {
            $d5637f77b1efb84d$var$onPreventMouseDown(e);
            onToggleOpen(!open);
        };
        return /*#__PURE__*/ $acw62.createElement("span", {
            onMouseDown: onMouseDown
        }, tagRender({
            label: content,
            value: value,
            disabled: itemDisabled,
            closable: closable,
            onClose: onClose
        }));
    }
    function renderItem(valueItem) {
        var itemDisabled = valueItem.disabled, label = valueItem.label, value = valueItem.value;
        var closable = !disabled && !itemDisabled;
        var displayLabel = label;
        if (typeof maxTagTextLength === "number") {
            if (typeof label === "string" || typeof label === "number") {
                var strLabel = String(displayLabel);
                if (strLabel.length > maxTagTextLength) displayLabel = "".concat(strLabel.slice(0, maxTagTextLength), "...");
            }
        }
        var onClose = function onClose(event) {
            if (event) event.stopPropagation();
            onRemove(valueItem);
        };
        return typeof tagRender === "function" ? customizeRenderSelector(value, displayLabel, itemDisabled, closable, onClose) : defaultRenderSelector(valueItem, displayLabel, itemDisabled, closable, onClose);
    }
    function renderRest(omittedValues) {
        var content = typeof maxTagPlaceholder === "function" ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
        return defaultRenderSelector({
            title: content
        }, content, false);
    }
    // >>> Input Node
    var inputNode = /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(selectionPrefixCls, "-search"),
        style: {
            width: inputWidth
        },
        onFocus: function onFocus() {
            setFocused(true);
        },
        onBlur: function onBlur() {
            setFocused(false);
        }
    }, /*#__PURE__*/ $acw62.createElement((0, $2a075c3c6c029a86$export$2e2bcd8739ae039), {
        ref: inputRef,
        open: open,
        prefixCls: prefixCls,
        id: id,
        inputElement: null,
        disabled: disabled,
        autoFocus: autoFocus,
        autoComplete: autoComplete,
        editable: inputEditable,
        activeDescendantId: activeDescendantId,
        value: inputValue,
        onKeyDown: onInputKeyDown,
        onMouseDown: onInputMouseDown,
        onChange: onInputChange,
        onPaste: onInputPaste,
        onCompositionStart: onInputCompositionStart,
        onCompositionEnd: onInputCompositionEnd,
        tabIndex: tabIndex,
        attrs: (0, $281efe5882c936de$export$2e2bcd8739ae039)(props, true)
    }), /*#__PURE__*/ $acw62.createElement("span", {
        ref: measureRef,
        className: "".concat(selectionPrefixCls, "-search-mirror"),
        "aria-hidden": true
    }, inputValue, "\xa0"));
    // >>> Selections
    var selectionNode = /*#__PURE__*/ $acw62.createElement((0, $6dkAu.default), {
        prefixCls: "".concat(selectionPrefixCls, "-overflow"),
        data: values,
        renderItem: renderItem,
        renderRest: renderRest,
        suffix: inputNode,
        itemKey: $d5637f77b1efb84d$var$itemKey,
        maxCount: maxTagCount
    });
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, selectionNode, !values.length && !inputValue && /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(selectionPrefixCls, "-placeholder")
    }, placeholder));
};
var $d5637f77b1efb84d$export$2e2bcd8739ae039 = $d5637f77b1efb84d$var$SelectSelector;



var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");



var $a02e5d1ded01272e$var$SingleSelector = function SingleSelector(props) {
    var inputElement = props.inputElement, prefixCls = props.prefixCls, id = props.id, inputRef = props.inputRef, disabled = props.disabled, autoFocus = props.autoFocus, autoComplete = props.autoComplete, activeDescendantId = props.activeDescendantId, mode = props.mode, open = props.open, values = props.values, placeholder = props.placeholder, tabIndex = props.tabIndex, showSearch = props.showSearch, searchValue = props.searchValue, activeValue = props.activeValue, maxLength = props.maxLength, onInputKeyDown = props.onInputKeyDown, onInputMouseDown = props.onInputMouseDown, onInputChange = props.onInputChange, onInputPaste = props.onInputPaste, onInputCompositionStart = props.onInputCompositionStart, onInputCompositionEnd = props.onInputCompositionEnd, title = props.title;
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), inputChanged = _React$useState2[0], setInputChanged = _React$useState2[1];
    var combobox = mode === "combobox";
    var inputEditable = combobox || showSearch;
    var item = values[0];
    var inputValue = searchValue || "";
    if (combobox && activeValue && !inputChanged) inputValue = activeValue;
    $acw62.useEffect(function() {
        if (combobox) setInputChanged(false);
    }, [
        combobox,
        activeValue
    ]);
    // Not show text when closed expect combobox mode
    var hasTextInput = mode !== "combobox" && !open && !showSearch ? false : !!inputValue;
    // Get title of selection item
    var selectionTitle = title === undefined ? (0, $953a8baf84e85e44$export$70d1bf7729efff40)(item) : title;
    var renderPlaceholder = function renderPlaceholder() {
        if (item) return null;
        var hiddenStyle = hasTextInput ? {
            visibility: "hidden"
        } : undefined;
        return /*#__PURE__*/ $acw62.createElement("span", {
            className: "".concat(prefixCls, "-selection-placeholder"),
            style: hiddenStyle
        }, placeholder);
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-selection-search")
    }, /*#__PURE__*/ $acw62.createElement((0, $2a075c3c6c029a86$export$2e2bcd8739ae039), {
        ref: inputRef,
        prefixCls: prefixCls,
        id: id,
        open: open,
        inputElement: inputElement,
        disabled: disabled,
        autoFocus: autoFocus,
        autoComplete: autoComplete,
        editable: inputEditable,
        activeDescendantId: activeDescendantId,
        value: inputValue,
        onKeyDown: onInputKeyDown,
        onMouseDown: onInputMouseDown,
        onChange: function onChange(e) {
            setInputChanged(true);
            onInputChange(e);
        },
        onPaste: onInputPaste,
        onCompositionStart: onInputCompositionStart,
        onCompositionEnd: onInputCompositionEnd,
        tabIndex: tabIndex,
        attrs: (0, $281efe5882c936de$export$2e2bcd8739ae039)(props, true),
        maxLength: combobox ? maxLength : undefined
    })), !combobox && item ? /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-selection-item"),
        title: selectionTitle,
        style: hasTextInput ? {
            visibility: "hidden"
        } : undefined
    }, item.label) : null, renderPlaceholder());
};
var $a02e5d1ded01272e$export$2e2bcd8739ae039 = $a02e5d1ded01272e$var$SingleSelector;




var $iCi4s = parcelRequire("iCi4s");
function $4ae276a1f02fe75e$export$48ac81d4a07c29c(currentKeyCode) {
    return ![
        // System function button
        (0, $iCi4s.default).ESC,
        (0, $iCi4s.default).SHIFT,
        (0, $iCi4s.default).BACKSPACE,
        (0, $iCi4s.default).TAB,
        (0, $iCi4s.default).WIN_KEY,
        (0, $iCi4s.default).ALT,
        (0, $iCi4s.default).META,
        (0, $iCi4s.default).WIN_KEY_RIGHT,
        (0, $iCi4s.default).CTRL,
        (0, $iCi4s.default).SEMICOLON,
        (0, $iCi4s.default).EQUALS,
        (0, $iCi4s.default).CAPS_LOCK,
        (0, $iCi4s.default).CONTEXT_MENU,
        // F1-F12
        (0, $iCi4s.default).F1,
        (0, $iCi4s.default).F2,
        (0, $iCi4s.default).F3,
        (0, $iCi4s.default).F4,
        (0, $iCi4s.default).F5,
        (0, $iCi4s.default).F6,
        (0, $iCi4s.default).F7,
        (0, $iCi4s.default).F8,
        (0, $iCi4s.default).F9,
        (0, $iCi4s.default).F10,
        (0, $iCi4s.default).F11,
        (0, $iCi4s.default).F12
    ].includes(currentKeyCode);
}


var $56b625f0dbf4c4f8$var$Selector = function Selector(props, ref) {
    var inputRef = (0, $acw62.useRef)(null);
    var compositionStatusRef = (0, $acw62.useRef)(false);
    var prefixCls = props.prefixCls, open = props.open, mode = props.mode, showSearch = props.showSearch, tokenWithEnter = props.tokenWithEnter, autoClearSearchValue = props.autoClearSearchValue, onSearch = props.onSearch, onSearchSubmit = props.onSearchSubmit, onToggleOpen = props.onToggleOpen, onInputKeyDown = props.onInputKeyDown, domRef = props.domRef;
    // ======================= Ref =======================
    $acw62.useImperativeHandle(ref, function() {
        return {
            focus: function focus() {
                inputRef.current.focus();
            },
            blur: function blur() {
                inputRef.current.blur();
            }
        };
    });
    // ====================== Input ======================
    var _useLock = (0, $d2c203a0ff231923$export$2e2bcd8739ae039)(0), _useLock2 = (0, $eUqlC.default)(_useLock, 2), getInputMouseDown = _useLock2[0], setInputMouseDown = _useLock2[1];
    var onInternalInputKeyDown = function onInternalInputKeyDown(event) {
        var which = event.which;
        if (which === (0, $iCi4s.default).UP || which === (0, $iCi4s.default).DOWN) event.preventDefault();
        if (onInputKeyDown) onInputKeyDown(event);
        if (which === (0, $iCi4s.default).ENTER && mode === "tags" && !compositionStatusRef.current && !open) // When menu isn't open, OptionList won't trigger a value change
        // So when enter is pressed, the tag's input value should be emitted here to let selector know
        onSearchSubmit === null || onSearchSubmit === void 0 || onSearchSubmit(event.target.value);
        if ((0, $4ae276a1f02fe75e$export$48ac81d4a07c29c)(which)) onToggleOpen(true);
    };
    /**
   * We can not use `findDOMNode` sine it will get warning,
   * have to use timer to check if is input element.
   */ var onInternalInputMouseDown = function onInternalInputMouseDown() {
        setInputMouseDown(true);
    };
    // When paste come, ignore next onChange
    var pastedTextRef = (0, $acw62.useRef)(null);
    var triggerOnSearch = function triggerOnSearch(value) {
        if (onSearch(value, true, compositionStatusRef.current) !== false) onToggleOpen(true);
    };
    var onInputCompositionStart = function onInputCompositionStart() {
        compositionStatusRef.current = true;
    };
    var onInputCompositionEnd = function onInputCompositionEnd(e) {
        compositionStatusRef.current = false;
        // Trigger search again to support `tokenSeparators` with typewriting
        if (mode !== "combobox") triggerOnSearch(e.target.value);
    };
    var onInputChange = function onInputChange(event) {
        var value = event.target.value;
        // Pasted text should replace back to origin content
        if (tokenWithEnter && pastedTextRef.current && /[\r\n]/.test(pastedTextRef.current)) {
            // CRLF will be treated as a single space for input element
            var replacedText = pastedTextRef.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
            value = value.replace(replacedText, pastedTextRef.current);
        }
        pastedTextRef.current = null;
        triggerOnSearch(value);
    };
    var onInputPaste = function onInputPaste(e) {
        var clipboardData = e.clipboardData;
        var value = clipboardData.getData("text");
        pastedTextRef.current = value;
    };
    var onClick = function onClick(_ref) {
        var target = _ref.target;
        if (target !== inputRef.current) {
            // Should focus input if click the selector
            var isIE = document.body.style.msTouchAction !== undefined;
            if (isIE) setTimeout(function() {
                inputRef.current.focus();
            });
            else inputRef.current.focus();
        }
    };
    var onMouseDown = function onMouseDown(event) {
        var inputMouseDown = getInputMouseDown();
        // when mode is combobox, don't prevent default behavior
        // https://github.com/ant-design/ant-design/issues/37320
        if (event.target !== inputRef.current && !inputMouseDown && mode !== "combobox") event.preventDefault();
        if (mode !== "combobox" && (!showSearch || !inputMouseDown) || !open) {
            if (open && autoClearSearchValue !== false) onSearch("", true, false);
            onToggleOpen();
        }
    };
    // ================= Inner Selector ==================
    var sharedProps = {
        inputRef: inputRef,
        onInputKeyDown: onInternalInputKeyDown,
        onInputMouseDown: onInternalInputMouseDown,
        onInputChange: onInputChange,
        onInputPaste: onInputPaste,
        onInputCompositionStart: onInputCompositionStart,
        onInputCompositionEnd: onInputCompositionEnd
    };
    var selectNode = mode === "multiple" || mode === "tags" ? /*#__PURE__*/ $acw62.createElement((0, $d5637f77b1efb84d$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, sharedProps)) : /*#__PURE__*/ $acw62.createElement((0, $a02e5d1ded01272e$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, sharedProps));
    return /*#__PURE__*/ $acw62.createElement("div", {
        ref: domRef,
        className: "".concat(prefixCls, "-selector"),
        onClick: onClick,
        onMouseDown: onMouseDown
    }, selectNode);
};
var $56b625f0dbf4c4f8$var$ForwardSelector = /*#__PURE__*/ $acw62.forwardRef($56b625f0dbf4c4f8$var$Selector);
$56b625f0dbf4c4f8$var$ForwardSelector.displayName = "Selector";
var $56b625f0dbf4c4f8$export$2e2bcd8739ae039 = $56b625f0dbf4c4f8$var$ForwardSelector;



var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $9X7IJ = parcelRequire("9X7IJ");

var $eyPR1 = parcelRequire("eyPR1");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
var $1800478cf911b314$var$_excluded = [
    "prefixCls",
    "disabled",
    "visible",
    "children",
    "popupElement",
    "animation",
    "transitionName",
    "dropdownStyle",
    "dropdownClassName",
    "direction",
    "placement",
    "builtinPlacements",
    "dropdownMatchSelectWidth",
    "dropdownRender",
    "dropdownAlign",
    "getPopupContainer",
    "empty",
    "getTriggerDOMNode",
    "onPopupVisibleChange",
    "onPopupMouseEnter"
];
var $1800478cf911b314$var$getBuiltInPlacements = function getBuiltInPlacements(dropdownMatchSelectWidth) {
    // Enable horizontal overflow auto-adjustment when a custom dropdown width is provided
    var adjustX = dropdownMatchSelectWidth === true ? 0 : 1;
    return {
        bottomLeft: {
            points: [
                "tl",
                "bl"
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: "scroll"
        },
        bottomRight: {
            points: [
                "tr",
                "br"
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: "scroll"
        },
        topLeft: {
            points: [
                "bl",
                "tl"
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: "scroll"
        },
        topRight: {
            points: [
                "br",
                "tr"
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: "scroll"
        }
    };
};
var $1800478cf911b314$var$SelectTrigger = function SelectTrigger(props, ref) {
    var prefixCls = props.prefixCls, disabled = props.disabled, visible = props.visible, children = props.children, popupElement = props.popupElement, animation = props.animation, transitionName = props.transitionName, dropdownStyle = props.dropdownStyle, dropdownClassName = props.dropdownClassName, _props$direction = props.direction, direction = _props$direction === void 0 ? "ltr" : _props$direction, placement = props.placement, builtinPlacements = props.builtinPlacements, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, dropdownRender = props.dropdownRender, dropdownAlign = props.dropdownAlign, getPopupContainer = props.getPopupContainer, empty = props.empty, getTriggerDOMNode = props.getTriggerDOMNode, onPopupVisibleChange = props.onPopupVisibleChange, onPopupMouseEnter = props.onPopupMouseEnter, restProps = (0, $9X7IJ.default)(props, $1800478cf911b314$var$_excluded);
    var dropdownPrefixCls = "".concat(prefixCls, "-dropdown");
    var popupNode = popupElement;
    if (dropdownRender) popupNode = dropdownRender(popupElement);
    var mergedBuiltinPlacements = $acw62.useMemo(function() {
        return builtinPlacements || $1800478cf911b314$var$getBuiltInPlacements(dropdownMatchSelectWidth);
    }, [
        builtinPlacements,
        dropdownMatchSelectWidth
    ]);
    // ===================== Motion ======================
    var mergedTransitionName = animation ? "".concat(dropdownPrefixCls, "-").concat(animation) : transitionName;
    // =================== Popup Width ===================
    var isNumberPopupWidth = typeof dropdownMatchSelectWidth === "number";
    var stretch = $acw62.useMemo(function() {
        if (isNumberPopupWidth) return null;
        return dropdownMatchSelectWidth === false ? "minWidth" : "width";
    }, [
        dropdownMatchSelectWidth,
        isNumberPopupWidth
    ]);
    var popupStyle = dropdownStyle;
    if (isNumberPopupWidth) popupStyle = (0, $d49SP.default)((0, $d49SP.default)({}, popupStyle), {}, {
        width: dropdownMatchSelectWidth
    });
    // ======================= Ref =======================
    var popupRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, function() {
        return {
            getPopupElement: function getPopupElement() {
                return popupRef.current;
            }
        };
    });
    return /*#__PURE__*/ $acw62.createElement((0, $eyPR1.default), (0, $8nd05.default)({}, restProps, {
        showAction: onPopupVisibleChange ? [
            "click"
        ] : [],
        hideAction: onPopupVisibleChange ? [
            "click"
        ] : [],
        popupPlacement: placement || (direction === "rtl" ? "bottomRight" : "bottomLeft"),
        builtinPlacements: mergedBuiltinPlacements,
        prefixCls: dropdownPrefixCls,
        popupTransitionName: mergedTransitionName,
        popup: /*#__PURE__*/ $acw62.createElement("div", {
            ref: popupRef,
            onMouseEnter: onPopupMouseEnter
        }, popupNode),
        stretch: stretch,
        popupAlign: dropdownAlign,
        popupVisible: visible,
        getPopupContainer: getPopupContainer,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(dropdownClassName, (0, $kSlfw.default)({}, "".concat(dropdownPrefixCls, "-empty"), empty)),
        popupStyle: popupStyle,
        getTriggerDOMNode: getTriggerDOMNode,
        onPopupVisibleChange: onPopupVisibleChange
    }), children);
};
var $1800478cf911b314$var$RefSelectTrigger = /*#__PURE__*/ $acw62.forwardRef($1800478cf911b314$var$SelectTrigger);
$1800478cf911b314$var$RefSelectTrigger.displayName = "SelectTrigger";
var $1800478cf911b314$export$2e2bcd8739ae039 = $1800478cf911b314$var$RefSelectTrigger;




var $kbxxf = parcelRequire("kbxxf");

var $aJJ3v = parcelRequire("aJJ3v");

var $d49SP = parcelRequire("d49SP");

var $u43uR = parcelRequire("u43uR");
function $67e3f69030e63308$var$getKey(data, index) {
    var key = data.key;
    var value;
    if ("value" in data) value = data.value;
    if (key !== null && key !== undefined) return key;
    if (value !== undefined) return value;
    return "rc-index-key-".concat(index);
}
function $67e3f69030e63308$export$6c519d302dced239(fieldNames, childrenAsData) {
    var _ref = fieldNames || {}, label = _ref.label, value = _ref.value, options = _ref.options, groupLabel = _ref.groupLabel;
    var mergedLabel = label || (childrenAsData ? "children" : "label");
    return {
        label: mergedLabel,
        value: value || "value",
        options: options || "options",
        groupLabel: groupLabel || mergedLabel
    };
}
function $67e3f69030e63308$export$7baa7c13b358b002(options) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, fieldNames = _ref2.fieldNames, childrenAsData = _ref2.childrenAsData;
    var flattenList = [];
    var _fillFieldNames = $67e3f69030e63308$export$6c519d302dced239(fieldNames, false), fieldLabel = _fillFieldNames.label, fieldValue = _fillFieldNames.value, fieldOptions = _fillFieldNames.options, groupLabel = _fillFieldNames.groupLabel;
    function dig(list, isGroupOption) {
        list.forEach(function(data) {
            if (isGroupOption || !(fieldOptions in data)) {
                var value = data[fieldValue];
                // Option
                flattenList.push({
                    key: $67e3f69030e63308$var$getKey(data, flattenList.length),
                    groupOption: isGroupOption,
                    data: data,
                    label: data[fieldLabel],
                    value: value
                });
            } else {
                var grpLabel = data[groupLabel];
                if (grpLabel === undefined && childrenAsData) grpLabel = data.label;
                // Option Group
                flattenList.push({
                    key: $67e3f69030e63308$var$getKey(data, flattenList.length),
                    group: true,
                    data: data,
                    label: grpLabel
                });
                dig(data[fieldOptions], true);
            }
        });
    }
    dig(options, false);
    return flattenList;
}
function $67e3f69030e63308$export$d0b21b213c8c013c(option) {
    var newOption = (0, $d49SP.default)({}, option);
    if (!("props" in newOption)) Object.defineProperty(newOption, "props", {
        get: function get() {
            (0, $u43uR.default)(false, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`.");
            return newOption;
        }
    });
    return newOption;
}
function $67e3f69030e63308$export$a09ca2a89e052b14(text, tokens) {
    if (!tokens || !tokens.length) return null;
    var match = false;
    function separate(str, _ref3) {
        var _ref4 = (0, $aJJ3v.default)(_ref3), token = _ref4[0], restTokens = _ref4.slice(1);
        if (!token) return [
            str
        ];
        var list = str.split(token);
        match = match || list.length > 1;
        return list.reduce(function(prevList, unitStr) {
            return [].concat((0, $kbxxf.default)(prevList), (0, $kbxxf.default)(separate(unitStr, restTokens)));
        }, []).filter(function(unit) {
            return unit;
        });
    }
    var list = separate(text, tokens);
    return match ? list : null;
}


var $2dc4538d56993d0c$var$_excluded = [
    "id",
    "prefixCls",
    "className",
    "showSearch",
    "tagRender",
    "direction",
    "omitDomProps",
    "displayValues",
    "onDisplayValuesChange",
    "emptyOptions",
    "notFoundContent",
    "onClear",
    "mode",
    "disabled",
    "loading",
    "getInputElement",
    "getRawInputElement",
    "open",
    "defaultOpen",
    "onDropdownVisibleChange",
    "activeValue",
    "onActiveValueChange",
    "activeDescendantId",
    "searchValue",
    "autoClearSearchValue",
    "onSearch",
    "onSearchSplit",
    "tokenSeparators",
    "allowClear",
    "suffixIcon",
    "clearIcon",
    "OptionList",
    "animation",
    "transitionName",
    "dropdownStyle",
    "dropdownClassName",
    "dropdownMatchSelectWidth",
    "dropdownRender",
    "dropdownAlign",
    "placement",
    "builtinPlacements",
    "getPopupContainer",
    "showAction",
    "onFocus",
    "onBlur",
    "onKeyUp",
    "onKeyDown",
    "onMouseDown"
];
var $2dc4538d56993d0c$var$DEFAULT_OMIT_PROPS = [
    "value",
    "onChange",
    "removeIcon",
    "placeholder",
    "autoFocus",
    "maxTagCount",
    "maxTagTextLength",
    "maxTagPlaceholder",
    "choiceTransitionName",
    "onInputKeyDown",
    "onPopupScroll",
    "tabIndex"
];
function $2dc4538d56993d0c$export$7f654ad2a77ad2ac(mode) {
    return mode === "tags" || mode === "multiple";
}
var $2dc4538d56993d0c$var$BaseSelect = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _customizeRawInputEle, _classNames2;
    var id = props.id, prefixCls = props.prefixCls, className = props.className, showSearch = props.showSearch, tagRender = props.tagRender, direction = props.direction, omitDomProps = props.omitDomProps, displayValues = props.displayValues, onDisplayValuesChange = props.onDisplayValuesChange, emptyOptions = props.emptyOptions, _props$notFoundConten = props.notFoundContent, notFoundContent = _props$notFoundConten === void 0 ? "Not Found" : _props$notFoundConten, onClear = props.onClear, mode = props.mode, disabled = props.disabled, loading = props.loading, getInputElement = props.getInputElement, getRawInputElement = props.getRawInputElement, open = props.open, defaultOpen = props.defaultOpen, onDropdownVisibleChange = props.onDropdownVisibleChange, activeValue = props.activeValue, onActiveValueChange = props.onActiveValueChange, activeDescendantId = props.activeDescendantId, searchValue = props.searchValue, autoClearSearchValue = props.autoClearSearchValue, onSearch = props.onSearch, onSearchSplit = props.onSearchSplit, tokenSeparators = props.tokenSeparators, allowClear = props.allowClear, suffixIcon = props.suffixIcon, clearIcon = props.clearIcon, OptionList = props.OptionList, animation = props.animation, transitionName = props.transitionName, dropdownStyle = props.dropdownStyle, dropdownClassName = props.dropdownClassName, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, dropdownRender = props.dropdownRender, dropdownAlign = props.dropdownAlign, placement = props.placement, builtinPlacements = props.builtinPlacements, getPopupContainer = props.getPopupContainer, _props$showAction = props.showAction, showAction = _props$showAction === void 0 ? [] : _props$showAction, onFocus = props.onFocus, onBlur = props.onBlur, onKeyUp = props.onKeyUp, onKeyDown = props.onKeyDown, onMouseDown = props.onMouseDown, restProps = (0, $9X7IJ.default)(props, $2dc4538d56993d0c$var$_excluded);
    // ============================== MISC ==============================
    var multiple = $2dc4538d56993d0c$export$7f654ad2a77ad2ac(mode);
    var mergedShowSearch = (showSearch !== undefined ? showSearch : multiple) || mode === "combobox";
    var domProps = (0, $d49SP.default)({}, restProps);
    $2dc4538d56993d0c$var$DEFAULT_OMIT_PROPS.forEach(function(propName) {
        delete domProps[propName];
    });
    omitDomProps === null || omitDomProps === void 0 || omitDomProps.forEach(function(propName) {
        delete domProps[propName];
    });
    // ============================= Mobile =============================
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), mobile = _React$useState2[0], setMobile = _React$useState2[1];
    $acw62.useEffect(function() {
        // Only update on the client side
        setMobile((0, $ycMhT.default)());
    }, []);
    // ============================== Refs ==============================
    var containerRef = $acw62.useRef(null);
    var selectorDomRef = $acw62.useRef(null);
    var triggerRef = $acw62.useRef(null);
    var selectorRef = $acw62.useRef(null);
    var listRef = $acw62.useRef(null);
    var blurRef = $acw62.useRef(false);
    /** Used for component focused management */ var _useDelayReset = (0, $6ca183ed87ff681f$export$2e2bcd8739ae039)(), _useDelayReset2 = (0, $eUqlC.default)(_useDelayReset, 3), mockFocused = _useDelayReset2[0], setMockFocused = _useDelayReset2[1], cancelSetMockFocused = _useDelayReset2[2];
    // =========================== Imperative ===========================
    $acw62.useImperativeHandle(ref, function() {
        var _selectorRef$current, _selectorRef$current2;
        return {
            focus: (_selectorRef$current = selectorRef.current) === null || _selectorRef$current === void 0 ? void 0 : _selectorRef$current.focus,
            blur: (_selectorRef$current2 = selectorRef.current) === null || _selectorRef$current2 === void 0 ? void 0 : _selectorRef$current2.blur,
            scrollTo: function scrollTo(arg) {
                var _listRef$current;
                return (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.scrollTo(arg);
            }
        };
    });
    // ========================== Search Value ==========================
    var mergedSearchValue = $acw62.useMemo(function() {
        var _displayValues$;
        if (mode !== "combobox") return searchValue;
        var val = (_displayValues$ = displayValues[0]) === null || _displayValues$ === void 0 ? void 0 : _displayValues$.value;
        return typeof val === "string" || typeof val === "number" ? String(val) : "";
    }, [
        searchValue,
        mode,
        displayValues
    ]);
    // ========================== Custom Input ==========================
    // Only works in `combobox`
    var customizeInputElement = mode === "combobox" && typeof getInputElement === "function" && getInputElement() || null;
    // Used for customize replacement for `rc-cascader`
    var customizeRawInputElement = typeof getRawInputElement === "function" && getRawInputElement();
    var customizeRawInputRef = (0, $85dLH.useComposeRef)(selectorDomRef, customizeRawInputElement === null || customizeRawInputElement === void 0 || (_customizeRawInputEle = customizeRawInputElement.props) === null || _customizeRawInputEle === void 0 ? void 0 : _customizeRawInputEle.ref);
    // ============================== Open ==============================
    // SSR not support Portal which means we need delay `open` for the first time render
    var _React$useState3 = $acw62.useState(false), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), rendered = _React$useState4[0], setRendered = _React$useState4[1];
    (0, $6hDTM.default)(function() {
        setRendered(true);
    }, []);
    var _useMergedState = (0, $iSQh8.default)(false, {
        defaultValue: defaultOpen,
        value: open
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), innerOpen = _useMergedState2[0], setInnerOpen = _useMergedState2[1];
    var mergedOpen = rendered ? innerOpen : false;
    // Not trigger `open` in `combobox` when `notFoundContent` is empty
    var emptyListContent = !notFoundContent && emptyOptions;
    if (disabled || emptyListContent && mergedOpen && mode === "combobox") mergedOpen = false;
    var triggerOpen = emptyListContent ? false : mergedOpen;
    var onToggleOpen = $acw62.useCallback(function(newOpen) {
        var nextOpen = newOpen !== undefined ? newOpen : !mergedOpen;
        if (!disabled) {
            setInnerOpen(nextOpen);
            if (mergedOpen !== nextOpen) onDropdownVisibleChange === null || onDropdownVisibleChange === void 0 || onDropdownVisibleChange(nextOpen);
        }
    }, [
        disabled,
        mergedOpen,
        setInnerOpen,
        onDropdownVisibleChange
    ]);
    // ============================= Search =============================
    var tokenWithEnter = $acw62.useMemo(function() {
        return (tokenSeparators || []).some(function(tokenSeparator) {
            return [
                "\n",
                "\r\n"
            ].includes(tokenSeparator);
        });
    }, [
        tokenSeparators
    ]);
    var onInternalSearch = function onInternalSearch(searchText, fromTyping, isCompositing) {
        var ret = true;
        var newSearchText = searchText;
        onActiveValueChange === null || onActiveValueChange === void 0 || onActiveValueChange(null);
        // Check if match the `tokenSeparators`
        var patchLabels = isCompositing ? null : (0, $67e3f69030e63308$export$a09ca2a89e052b14)(searchText, tokenSeparators);
        // Ignore combobox since it's not split-able
        if (mode !== "combobox" && patchLabels) {
            newSearchText = "";
            onSearchSplit === null || onSearchSplit === void 0 || onSearchSplit(patchLabels);
            // Should close when paste finish
            onToggleOpen(false);
            // Tell Selector that break next actions
            ret = false;
        }
        if (onSearch && mergedSearchValue !== newSearchText) onSearch(newSearchText, {
            source: fromTyping ? "typing" : "effect"
        });
        return ret;
    };
    // Only triggered when menu is closed & mode is tags
    // If menu is open, OptionList will take charge
    // If mode isn't tags, press enter is not meaningful when you can't see any option
    var onInternalSearchSubmit = function onInternalSearchSubmit(searchText) {
        // prevent empty tags from appearing when you click the Enter button
        if (!searchText || !searchText.trim()) return;
        onSearch(searchText, {
            source: "submit"
        });
    };
    // Close will clean up single mode search text
    $acw62.useEffect(function() {
        if (!mergedOpen && !multiple && mode !== "combobox") onInternalSearch("", false, false);
    }, [
        mergedOpen
    ]);
    // ============================ Disabled ============================
    // Close dropdown & remove focus state when disabled change
    $acw62.useEffect(function() {
        if (innerOpen && disabled) setInnerOpen(false);
        // After onBlur is triggered, the focused does not need to be reset
        if (disabled && !blurRef.current) setMockFocused(false);
    }, [
        disabled
    ]);
    // ============================ Keyboard ============================
    /**
   * We record input value here to check if can press to clean up by backspace
   * - null: Key is not down, this is reset by key up
   * - true: Search text is empty when first time backspace down
   * - false: Search text is not empty when first time backspace down
   */ var _useLock = (0, $d2c203a0ff231923$export$2e2bcd8739ae039)(), _useLock2 = (0, $eUqlC.default)(_useLock, 2), getClearLock = _useLock2[0], setClearLock = _useLock2[1];
    // KeyDown
    var onInternalKeyDown = function onInternalKeyDown(event) {
        var clearLock = getClearLock();
        var which = event.which;
        if (which === (0, $iCi4s.default).ENTER) {
            // Do not submit form when type in the input
            if (mode !== "combobox") event.preventDefault();
            // We only manage open state here, close logic should handle by list component
            if (!mergedOpen) onToggleOpen(true);
        }
        setClearLock(!!mergedSearchValue);
        // Remove value by `backspace`
        if (which === (0, $iCi4s.default).BACKSPACE && !clearLock && multiple && !mergedSearchValue && displayValues.length) {
            var cloneDisplayValues = (0, $kbxxf.default)(displayValues);
            var removedDisplayValue = null;
            for(var i = cloneDisplayValues.length - 1; i >= 0; i -= 1){
                var current = cloneDisplayValues[i];
                if (!current.disabled) {
                    cloneDisplayValues.splice(i, 1);
                    removedDisplayValue = current;
                    break;
                }
            }
            if (removedDisplayValue) onDisplayValuesChange(cloneDisplayValues, {
                type: "remove",
                values: [
                    removedDisplayValue
                ]
            });
        }
        for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
        if (mergedOpen && listRef.current) {
            var _listRef$current2;
            (_listRef$current2 = listRef.current).onKeyDown.apply(_listRef$current2, [
                event
            ].concat(rest));
        }
        onKeyDown === null || onKeyDown === void 0 || onKeyDown.apply(void 0, [
            event
        ].concat(rest));
    };
    // KeyUp
    var onInternalKeyUp = function onInternalKeyUp(event) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)rest[_key2 - 1] = arguments[_key2];
        if (mergedOpen && listRef.current) {
            var _listRef$current3;
            (_listRef$current3 = listRef.current).onKeyUp.apply(_listRef$current3, [
                event
            ].concat(rest));
        }
        onKeyUp === null || onKeyUp === void 0 || onKeyUp.apply(void 0, [
            event
        ].concat(rest));
    };
    // ============================ Selector ============================
    var onSelectorRemove = function onSelectorRemove(val) {
        var newValues = displayValues.filter(function(i) {
            return i !== val;
        });
        onDisplayValuesChange(newValues, {
            type: "remove",
            values: [
                val
            ]
        });
    };
    // ========================== Focus / Blur ==========================
    /** Record real focus status */ var focusRef = $acw62.useRef(false);
    var onContainerFocus = function onContainerFocus() {
        setMockFocused(true);
        if (!disabled) {
            if (onFocus && !focusRef.current) onFocus.apply(void 0, arguments);
            // `showAction` should handle `focus` if set
            if (showAction.includes("focus")) onToggleOpen(true);
        }
        focusRef.current = true;
    };
    var onContainerBlur = function onContainerBlur() {
        blurRef.current = true;
        setMockFocused(false, function() {
            focusRef.current = false;
            blurRef.current = false;
            onToggleOpen(false);
        });
        if (disabled) return;
        if (mergedSearchValue) {
            // `tags` mode should move `searchValue` into values
            if (mode === "tags") onSearch(mergedSearchValue, {
                source: "submit"
            });
            else if (mode === "multiple") // `multiple` mode only clean the search value but not trigger event
            onSearch("", {
                source: "blur"
            });
        }
        if (onBlur) onBlur.apply(void 0, arguments);
    };
    // Give focus back of Select
    var activeTimeoutIds = [];
    $acw62.useEffect(function() {
        return function() {
            activeTimeoutIds.forEach(function(timeoutId) {
                return clearTimeout(timeoutId);
            });
            activeTimeoutIds.splice(0, activeTimeoutIds.length);
        };
    }, []);
    var onInternalMouseDown = function onInternalMouseDown(event) {
        var _triggerRef$current;
        var target = event.target;
        var popupElement = (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.getPopupElement();
        // We should give focus back to selector if clicked item is not focusable
        if (popupElement && popupElement.contains(target)) {
            var timeoutId = setTimeout(function() {
                var index = activeTimeoutIds.indexOf(timeoutId);
                if (index !== -1) activeTimeoutIds.splice(index, 1);
                cancelSetMockFocused();
                if (!mobile && !popupElement.contains(document.activeElement)) {
                    var _selectorRef$current3;
                    (_selectorRef$current3 = selectorRef.current) === null || _selectorRef$current3 === void 0 || _selectorRef$current3.focus();
                }
            });
            activeTimeoutIds.push(timeoutId);
        }
        for(var _len3 = arguments.length, restArgs = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)restArgs[_key3 - 1] = arguments[_key3];
        onMouseDown === null || onMouseDown === void 0 || onMouseDown.apply(void 0, [
            event
        ].concat(restArgs));
    };
    // ============================ Dropdown ============================
    var _React$useState5 = $acw62.useState({}), _React$useState6 = (0, $eUqlC.default)(_React$useState5, 2), forceUpdate = _React$useState6[1];
    // We need force update here since popup dom is render async
    function onPopupMouseEnter() {
        forceUpdate({});
    }
    // Used for raw custom input trigger
    var onTriggerVisibleChange;
    if (customizeRawInputElement) onTriggerVisibleChange = function onTriggerVisibleChange(newOpen) {
        onToggleOpen(newOpen);
    };
    // Close when click on non-select element
    (0, $aebeaa3bc993c458$export$2e2bcd8739ae039)(function() {
        var _triggerRef$current2;
        return [
            containerRef.current,
            (_triggerRef$current2 = triggerRef.current) === null || _triggerRef$current2 === void 0 ? void 0 : _triggerRef$current2.getPopupElement()
        ];
    }, triggerOpen, onToggleOpen, !!customizeRawInputElement);
    // ============================ Context =============================
    var baseSelectContext = $acw62.useMemo(function() {
        return (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
            notFoundContent: notFoundContent,
            open: mergedOpen,
            triggerOpen: triggerOpen,
            id: id,
            showSearch: mergedShowSearch,
            multiple: multiple,
            toggleOpen: onToggleOpen
        });
    }, [
        props,
        notFoundContent,
        triggerOpen,
        mergedOpen,
        id,
        mergedShowSearch,
        multiple,
        onToggleOpen
    ]);
    // ==================================================================
    // ==                            Render                            ==
    // ==================================================================
    // ============================= Arrow ==============================
    var showSuffixIcon = !!suffixIcon || loading;
    var arrowNode;
    if (showSuffixIcon) arrowNode = /*#__PURE__*/ $acw62.createElement((0, $707d52f2ac65b829$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-arrow"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-arrow-loading"), loading)),
        customizeIcon: suffixIcon,
        customizeIconProps: {
            loading: loading,
            searchValue: mergedSearchValue,
            open: mergedOpen,
            focused: mockFocused,
            showSearch: mergedShowSearch
        }
    });
    // ============================= Clear ==============================
    var onClearMouseDown = function onClearMouseDown() {
        var _selectorRef$current4;
        onClear === null || onClear === void 0 || onClear();
        (_selectorRef$current4 = selectorRef.current) === null || _selectorRef$current4 === void 0 || _selectorRef$current4.focus();
        onDisplayValuesChange([], {
            type: "clear",
            values: displayValues
        });
        onInternalSearch("", false, false);
    };
    var _useAllowClear = (0, $2025e240a41c9299$export$9ea6397a890aa3e5)(prefixCls, onClearMouseDown, displayValues, allowClear, clearIcon, disabled, mergedSearchValue, mode), mergedAllowClear = _useAllowClear.allowClear, clearNode = _useAllowClear.clearIcon;
    // =========================== OptionList ===========================
    var optionList = /*#__PURE__*/ $acw62.createElement(OptionList, {
        ref: listRef
    });
    // ============================= Select =============================
    var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, className, (_classNames2 = {}, (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-focused"), mockFocused), (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-multiple"), multiple), (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-single"), !multiple), (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-allow-clear"), allowClear), (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-show-arrow"), showSuffixIcon), (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-disabled"), disabled), (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-loading"), loading), (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-open"), mergedOpen), (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-customize-input"), customizeInputElement), (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-show-search"), mergedShowSearch), _classNames2));
    // >>> Selector
    var selectorNode = /*#__PURE__*/ $acw62.createElement((0, $1800478cf911b314$export$2e2bcd8739ae039), {
        ref: triggerRef,
        disabled: disabled,
        prefixCls: prefixCls,
        visible: triggerOpen,
        popupElement: optionList,
        animation: animation,
        transitionName: transitionName,
        dropdownStyle: dropdownStyle,
        dropdownClassName: dropdownClassName,
        direction: direction,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth,
        dropdownRender: dropdownRender,
        dropdownAlign: dropdownAlign,
        placement: placement,
        builtinPlacements: builtinPlacements,
        getPopupContainer: getPopupContainer,
        empty: emptyOptions,
        getTriggerDOMNode: function getTriggerDOMNode() {
            return selectorDomRef.current;
        },
        onPopupVisibleChange: onTriggerVisibleChange,
        onPopupMouseEnter: onPopupMouseEnter
    }, customizeRawInputElement ? /*#__PURE__*/ $acw62.cloneElement(customizeRawInputElement, {
        ref: customizeRawInputRef
    }) : /*#__PURE__*/ $acw62.createElement((0, $56b625f0dbf4c4f8$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        domRef: selectorDomRef,
        prefixCls: prefixCls,
        inputElement: customizeInputElement,
        ref: selectorRef,
        id: id,
        showSearch: mergedShowSearch,
        autoClearSearchValue: autoClearSearchValue,
        mode: mode,
        activeDescendantId: activeDescendantId,
        tagRender: tagRender,
        values: displayValues,
        open: mergedOpen,
        onToggleOpen: onToggleOpen,
        activeValue: activeValue,
        searchValue: mergedSearchValue,
        onSearch: onInternalSearch,
        onSearchSubmit: onInternalSearchSubmit,
        onRemove: onSelectorRemove,
        tokenWithEnter: tokenWithEnter
    })));
    // >>> Render
    var renderNode;
    // Render raw
    if (customizeRawInputElement) renderNode = selectorNode;
    else renderNode = /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        className: mergedClassName
    }, domProps, {
        ref: containerRef,
        onMouseDown: onInternalMouseDown,
        onKeyDown: onInternalKeyDown,
        onKeyUp: onInternalKeyUp,
        onFocus: onContainerFocus,
        onBlur: onContainerBlur
    }), mockFocused && !mergedOpen && /*#__PURE__*/ $acw62.createElement("span", {
        style: {
            width: 0,
            height: 0,
            position: "absolute",
            overflow: "hidden",
            opacity: 0
        },
        "aria-live": "polite"
    }, "".concat(displayValues.map(function(_ref) {
        var label = _ref.label, value = _ref.value;
        return [
            "number",
            "string"
        ].includes((0, $fSwVM.default)(label)) ? label : value;
    }).join(", "))), selectorNode, arrowNode, mergedAllowClear && clearNode);
    return /*#__PURE__*/ $acw62.createElement((0, $de346c10040f695b$export$8234047c0aea33cf).Provider, {
        value: baseSelectContext
    }, renderNode);
});
var $2dc4538d56993d0c$export$2e2bcd8739ae039 = $2dc4538d56993d0c$var$BaseSelect;


/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ var $cb22e94bdb4eaaa5$var$OptGroup = function OptGroup() {
    return null;
};
$cb22e94bdb4eaaa5$var$OptGroup.isSelectOptGroup = true;
var $cb22e94bdb4eaaa5$export$2e2bcd8739ae039 = $cb22e94bdb4eaaa5$var$OptGroup;


/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ var $2f79e5076b69401d$var$Option = function Option() {
    return null;
};
$2f79e5076b69401d$var$Option.isSelectOption = true;
var $2f79e5076b69401d$export$2e2bcd8739ae039 = $2f79e5076b69401d$var$Option;



var $kSlfw = parcelRequire("kSlfw");

var $9X7IJ = parcelRequire("9X7IJ");

var $8nd05 = parcelRequire("8nd05");

var $kbxxf = parcelRequire("kbxxf");

var $eUqlC = parcelRequire("eUqlC");

var $8g1PZ = parcelRequire("8g1PZ");

var $iCi4s = parcelRequire("iCi4s");

var $3Ysvw = parcelRequire("3Ysvw");

var $1pcHX = parcelRequire("1pcHX");


var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $fSwVM = parcelRequire("fSwVM");

var $eUqlC = parcelRequire("eUqlC");

var $kSlfw = parcelRequire("kSlfw");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $8g1PZ = parcelRequire("8g1PZ");

var $bVxlN = parcelRequire("bVxlN");

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");

var $bVxlN = parcelRequire("bVxlN");

var $8g1PZ = parcelRequire("8g1PZ");
/**
 * Fill component to provided the scroll content real height.
 */ var $a7c020883d75d0d6$var$Filler = /*#__PURE__*/ $acw62.forwardRef(function(_ref, ref) {
    var height = _ref.height, offsetY = _ref.offsetY, offsetX = _ref.offsetX, children = _ref.children, prefixCls = _ref.prefixCls, onInnerResize = _ref.onInnerResize, innerProps = _ref.innerProps, rtl = _ref.rtl, extra = _ref.extra;
    var outerStyle = {};
    var innerStyle = {
        display: "flex",
        flexDirection: "column"
    };
    if (offsetY !== undefined) {
        var _objectSpread2;
        // Not set `width` since this will break `sticky: right`
        outerStyle = {
            height: height,
            position: "relative",
            overflow: "hidden"
        };
        innerStyle = (0, $d49SP.default)((0, $d49SP.default)({}, innerStyle), {}, (_objectSpread2 = {
            transform: "translateY(".concat(offsetY, "px)")
        }, (0, $kSlfw.default)(_objectSpread2, rtl ? "marginRight" : "marginLeft", -offsetX), (0, $kSlfw.default)(_objectSpread2, "position", "absolute"), (0, $kSlfw.default)(_objectSpread2, "left", 0), (0, $kSlfw.default)(_objectSpread2, "right", 0), (0, $kSlfw.default)(_objectSpread2, "top", 0), _objectSpread2));
    }
    return /*#__PURE__*/ $acw62.createElement("div", {
        style: outerStyle
    }, /*#__PURE__*/ $acw62.createElement((0, $bVxlN.default), {
        onResize: function onResize(_ref2) {
            var offsetHeight = _ref2.offsetHeight;
            if (offsetHeight && onInnerResize) onInnerResize();
        }
    }, /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        style: innerStyle,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)({}, "".concat(prefixCls, "-holder-inner"), prefixCls)),
        ref: ref
    }, innerProps), children, extra)));
});
$a7c020883d75d0d6$var$Filler.displayName = "Filler";
var $a7c020883d75d0d6$export$2e2bcd8739ae039 = $a7c020883d75d0d6$var$Filler;



var $d49SP = parcelRequire("d49SP");

var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $dTiBu = parcelRequire("dTiBu");
function $2ebd4898b033397e$var$getPageXY(e, horizontal) {
    var obj = "touches" in e ? e.touches[0] : e;
    return obj[horizontal ? "pageX" : "pageY"];
}
var $2ebd4898b033397e$var$ScrollBar = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _classNames;
    var prefixCls = props.prefixCls, rtl = props.rtl, scrollOffset = props.scrollOffset, scrollRange = props.scrollRange, onStartMove = props.onStartMove, onStopMove = props.onStopMove, onScroll = props.onScroll, horizontal = props.horizontal, spinSize = props.spinSize, containerSize = props.containerSize, style = props.style, propsThumbStyle = props.thumbStyle;
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), dragging = _React$useState2[0], setDragging = _React$useState2[1];
    var _React$useState3 = $acw62.useState(null), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), pageXY = _React$useState4[0], setPageXY = _React$useState4[1];
    var _React$useState5 = $acw62.useState(null), _React$useState6 = (0, $eUqlC.default)(_React$useState5, 2), startTop = _React$useState6[0], setStartTop = _React$useState6[1];
    var isLTR = !rtl;
    // ========================= Refs =========================
    var scrollbarRef = $acw62.useRef();
    var thumbRef = $acw62.useRef();
    // ======================= Visible ========================
    var _React$useState7 = $acw62.useState(false), _React$useState8 = (0, $eUqlC.default)(_React$useState7, 2), visible = _React$useState8[0], setVisible = _React$useState8[1];
    var visibleTimeoutRef = $acw62.useRef();
    var delayHidden = function delayHidden() {
        clearTimeout(visibleTimeoutRef.current);
        setVisible(true);
        visibleTimeoutRef.current = setTimeout(function() {
            setVisible(false);
        }, 3000);
    };
    // ======================== Range =========================
    var enableScrollRange = scrollRange - containerSize || 0;
    var enableOffsetRange = containerSize - spinSize || 0;
    // `scrollWidth` < `clientWidth` means no need to show scrollbar
    var canScroll = enableScrollRange > 0;
    // ========================= Top ==========================
    var top = $acw62.useMemo(function() {
        if (scrollOffset === 0 || enableScrollRange === 0) return 0;
        var ptg = scrollOffset / enableScrollRange;
        return ptg * enableOffsetRange;
    }, [
        scrollOffset,
        enableScrollRange,
        enableOffsetRange
    ]);
    // ====================== Container =======================
    var onContainerMouseDown = function onContainerMouseDown(e) {
        e.stopPropagation();
        e.preventDefault();
    };
    // ======================== Thumb =========================
    var stateRef = $acw62.useRef({
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    });
    stateRef.current = {
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    };
    var onThumbMouseDown = function onThumbMouseDown(e) {
        setDragging(true);
        setPageXY($2ebd4898b033397e$var$getPageXY(e, horizontal));
        setStartTop(stateRef.current.top);
        onStartMove();
        e.stopPropagation();
        e.preventDefault();
    };
    // ======================== Effect ========================
    // React make event as passive, but we need to preventDefault
    // Add event on dom directly instead.
    // ref: https://github.com/facebook/react/issues/9809
    $acw62.useEffect(function() {
        var onScrollbarTouchStart = function onScrollbarTouchStart(e) {
            e.preventDefault();
        };
        var scrollbarEle = scrollbarRef.current;
        var thumbEle = thumbRef.current;
        scrollbarEle.addEventListener("touchstart", onScrollbarTouchStart);
        thumbEle.addEventListener("touchstart", onThumbMouseDown);
        return function() {
            scrollbarEle.removeEventListener("touchstart", onScrollbarTouchStart);
            thumbEle.removeEventListener("touchstart", onThumbMouseDown);
        };
    }, []);
    // Pass to effect
    var enableScrollRangeRef = $acw62.useRef();
    enableScrollRangeRef.current = enableScrollRange;
    var enableOffsetRangeRef = $acw62.useRef();
    enableOffsetRangeRef.current = enableOffsetRange;
    $acw62.useEffect(function() {
        if (dragging) {
            var moveRafId;
            var onMouseMove = function onMouseMove(e) {
                var _stateRef$current = stateRef.current, stateDragging = _stateRef$current.dragging, statePageY = _stateRef$current.pageY, stateStartTop = _stateRef$current.startTop;
                (0, $dTiBu.default).cancel(moveRafId);
                if (stateDragging) {
                    var offset = $2ebd4898b033397e$var$getPageXY(e, horizontal) - statePageY;
                    var newTop = stateStartTop;
                    if (!isLTR && horizontal) newTop -= offset;
                    else newTop += offset;
                    var tmpEnableScrollRange = enableScrollRangeRef.current;
                    var tmpEnableOffsetRange = enableOffsetRangeRef.current;
                    var ptg = tmpEnableOffsetRange ? newTop / tmpEnableOffsetRange : 0;
                    var newScrollTop = Math.ceil(ptg * tmpEnableScrollRange);
                    newScrollTop = Math.max(newScrollTop, 0);
                    newScrollTop = Math.min(newScrollTop, tmpEnableScrollRange);
                    moveRafId = (0, $dTiBu.default)(function() {
                        onScroll(newScrollTop, horizontal);
                    });
                }
            };
            var onMouseUp = function onMouseUp() {
                setDragging(false);
                onStopMove();
            };
            window.addEventListener("mousemove", onMouseMove);
            window.addEventListener("touchmove", onMouseMove);
            window.addEventListener("mouseup", onMouseUp);
            window.addEventListener("touchend", onMouseUp);
            return function() {
                window.removeEventListener("mousemove", onMouseMove);
                window.removeEventListener("touchmove", onMouseMove);
                window.removeEventListener("mouseup", onMouseUp);
                window.removeEventListener("touchend", onMouseUp);
                (0, $dTiBu.default).cancel(moveRafId);
            };
        }
    }, [
        dragging
    ]);
    $acw62.useEffect(function() {
        delayHidden();
    }, [
        scrollOffset
    ]);
    // ====================== Imperative ======================
    $acw62.useImperativeHandle(ref, function() {
        return {
            delayHidden: delayHidden
        };
    });
    // ======================== Render ========================
    var scrollbarPrefixCls = "".concat(prefixCls, "-scrollbar");
    var containerStyle = {
        position: "absolute",
        visibility: visible && canScroll ? null : "hidden"
    };
    var thumbStyle = {
        position: "absolute",
        background: "rgba(0, 0, 0, 0.5)",
        borderRadius: 99,
        cursor: "pointer",
        userSelect: "none"
    };
    if (horizontal) {
        // Container
        containerStyle.height = 8;
        containerStyle.left = 0;
        containerStyle.right = 0;
        containerStyle.bottom = 0;
        // Thumb
        thumbStyle.height = "100%";
        thumbStyle.width = spinSize;
        if (isLTR) thumbStyle.left = top;
        else thumbStyle.right = top;
    } else {
        // Container
        containerStyle.width = 8;
        containerStyle.top = 0;
        containerStyle.bottom = 0;
        if (isLTR) containerStyle.right = 0;
        else containerStyle.left = 0;
        // Thumb
        thumbStyle.width = "100%";
        thumbStyle.height = spinSize;
        thumbStyle.top = top;
    }
    return /*#__PURE__*/ $acw62.createElement("div", {
        ref: scrollbarRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(scrollbarPrefixCls, (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(scrollbarPrefixCls, "-horizontal"), horizontal), (0, $kSlfw.default)(_classNames, "".concat(scrollbarPrefixCls, "-vertical"), !horizontal), (0, $kSlfw.default)(_classNames, "".concat(scrollbarPrefixCls, "-visible"), visible), _classNames)),
        style: (0, $d49SP.default)((0, $d49SP.default)({}, containerStyle), style),
        onMouseDown: onContainerMouseDown,
        onMouseMove: delayHidden
    }, /*#__PURE__*/ $acw62.createElement("div", {
        ref: thumbRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(scrollbarPrefixCls, "-thumb"), (0, $kSlfw.default)({}, "".concat(scrollbarPrefixCls, "-thumb-moving"), dragging)),
        style: (0, $d49SP.default)((0, $d49SP.default)({}, thumbStyle), propsThumbStyle),
        onMouseDown: onThumbMouseDown
    }));
});
var $2ebd4898b033397e$export$2e2bcd8739ae039 = $2ebd4898b033397e$var$ScrollBar;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $cb3ead46d99b2bdd$export$6d08773d2e66f8f2(_ref) {
    var children = _ref.children, setRef = _ref.setRef;
    var refFunc = $acw62.useCallback(function(node) {
        setRef(node);
    }, []);
    return /*#__PURE__*/ $acw62.cloneElement(children, {
        ref: refFunc
    });
}


function $c2cc76a198e74e0d$export$2e2bcd8739ae039(list, startIndex, endIndex, scrollWidth, setNodeRef, renderFunc, _ref) {
    var getKey = _ref.getKey;
    return list.slice(startIndex, endIndex + 1).map(function(item, index) {
        var eleIndex = startIndex + index;
        var node = renderFunc(item, eleIndex, {
            style: {
                width: scrollWidth
            }
        });
        var key = getKey(item);
        return /*#__PURE__*/ $acw62.createElement((0, $cb3ead46d99b2bdd$export$6d08773d2e66f8f2), {
            key: key,
            setRef: function setRef(ele) {
                return setNodeRef(item, ele);
            }
        }, node);
    });
}



var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $b2dYb = parcelRequire("b2dYb");

var $dTiBu = parcelRequire("dTiBu");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");
// Firefox has low performance of map.
var $443f2a75671c17cb$var$CacheMap = /*#__PURE__*/ function() {
    function CacheMap() {
        (0, $6CZeq.default)(this, CacheMap);
        this.maps = void 0;
        // Used for cache key
        // `useMemo` no need to update if `id` not change
        this.id = 0;
        this.maps = Object.create(null);
    }
    (0, $cHPF9.default)(CacheMap, [
        {
            key: "set",
            value: function set(key, value) {
                this.maps[key] = value;
                this.id += 1;
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this.maps[key];
            }
        }
    ]);
    return CacheMap;
}();
var $443f2a75671c17cb$export$2e2bcd8739ae039 = $443f2a75671c17cb$var$CacheMap;


function $291e20ad7019c1c9$export$2e2bcd8739ae039(getKey, onItemAdd, onItemRemove) {
    var _React$useState = $acw62.useState(0), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), updatedMark = _React$useState2[0], setUpdatedMark = _React$useState2[1];
    var instanceRef = (0, $acw62.useRef)(new Map());
    var heightsRef = (0, $acw62.useRef)(new (0, $443f2a75671c17cb$export$2e2bcd8739ae039)());
    var collectRafRef = (0, $acw62.useRef)();
    function cancelRaf() {
        (0, $dTiBu.default).cancel(collectRafRef.current);
    }
    function collectHeight() {
        var sync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        cancelRaf();
        var doCollect = function doCollect() {
            instanceRef.current.forEach(function(element, key) {
                if (element && element.offsetParent) {
                    var htmlElement = (0, $b2dYb.default)(element);
                    var offsetHeight = htmlElement.offsetHeight;
                    if (heightsRef.current.get(key) !== offsetHeight) heightsRef.current.set(key, htmlElement.offsetHeight);
                }
            });
            // Always trigger update mark to tell parent that should re-calculate heights when resized
            setUpdatedMark(function(c) {
                return c + 1;
            });
        };
        if (sync) doCollect();
        else collectRafRef.current = (0, $dTiBu.default)(doCollect);
    }
    function setInstanceRef(item, instance) {
        var key = getKey(item);
        var origin = instanceRef.current.get(key);
        if (instance) {
            instanceRef.current.set(key, instance);
            collectHeight();
        } else instanceRef.current.delete(key);
        // Instance changed
        if (!origin !== !instance) {
            if (instance) onItemAdd === null || onItemAdd === void 0 || onItemAdd(item);
            else onItemRemove === null || onItemRemove === void 0 || onItemRemove(item);
        }
    }
    (0, $acw62.useEffect)(function() {
        return cancelRaf;
    }, []);
    return [
        setInstanceRef,
        collectHeight,
        heightsRef.current,
        updatedMark
    ];
}



var $fSwVM = parcelRequire("fSwVM");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $dTiBu = parcelRequire("dTiBu");

var $6hDTM = parcelRequire("6hDTM");
parcelRequire("gwOwm");
var $e77930eb0c8ae9f1$var$MAX_TIMES = 10;
function $e77930eb0c8ae9f1$export$2e2bcd8739ae039(containerRef, data, heights, itemHeight, getKey, collectHeight, syncScrollTop, triggerFlash) {
    var scrollRef = $acw62.useRef();
    var _React$useState = $acw62.useState(null), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), syncState = _React$useState2[0], setSyncState = _React$useState2[1];
    // ========================== Sync Scroll ==========================
    (0, $6hDTM.default)(function() {
        if (syncState && syncState.times < $e77930eb0c8ae9f1$var$MAX_TIMES) {
            // Never reach
            if (!containerRef.current) {
                setSyncState(function(ori) {
                    return (0, $d49SP.default)({}, ori);
                });
                return;
            }
            collectHeight();
            var targetAlign = syncState.targetAlign, originAlign = syncState.originAlign, index = syncState.index, offset = syncState.offset;
            var height = containerRef.current.clientHeight;
            var needCollectHeight = false;
            var newTargetAlign = targetAlign;
            var targetTop = null;
            // Go to next frame if height not exist
            if (height) {
                var mergedAlign = targetAlign || originAlign;
                // Get top & bottom
                var stackTop = 0;
                var itemTop = 0;
                var itemBottom = 0;
                var maxLen = Math.min(data.length - 1, index);
                for(var i = 0; i <= maxLen; i += 1){
                    var key = getKey(data[i]);
                    itemTop = stackTop;
                    var cacheHeight = heights.get(key);
                    itemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
                    stackTop = itemBottom;
                }
                // Check if need sync height (visible range has item not record height)
                var leftHeight = mergedAlign === "top" ? offset : height - offset;
                for(var _i = maxLen; _i >= 0; _i -= 1){
                    var _key = getKey(data[_i]);
                    var _cacheHeight = heights.get(_key);
                    if (_cacheHeight === undefined) {
                        needCollectHeight = true;
                        break;
                    }
                    leftHeight -= _cacheHeight;
                    if (leftHeight <= 0) break;
                }
                // Scroll to
                switch(mergedAlign){
                    case "top":
                        targetTop = itemTop - offset;
                        break;
                    case "bottom":
                        targetTop = itemBottom - height + offset;
                        break;
                    default:
                        var scrollTop = containerRef.current.scrollTop;
                        var scrollBottom = scrollTop + height;
                        if (itemTop < scrollTop) newTargetAlign = "top";
                        else if (itemBottom > scrollBottom) newTargetAlign = "bottom";
                }
                if (targetTop !== null) syncScrollTop(targetTop);
                // One more time for sync
                if (targetTop !== syncState.lastTop) needCollectHeight = true;
            }
            // Trigger next effect
            if (needCollectHeight) setSyncState((0, $d49SP.default)((0, $d49SP.default)({}, syncState), {}, {
                times: syncState.times + 1,
                targetAlign: newTargetAlign,
                lastTop: targetTop
            }));
        }
    }, [
        syncState,
        containerRef.current
    ]);
    // =========================== Scroll To ===========================
    return function(arg) {
        // When not argument provided, we think dev may want to show the scrollbar
        if (arg === null || arg === undefined) {
            triggerFlash();
            return;
        }
        // Normal scroll logic
        (0, $dTiBu.default).cancel(scrollRef.current);
        if (typeof arg === "number") syncScrollTop(arg);
        else if (arg && (0, $fSwVM.default)(arg) === "object") {
            var index;
            var align = arg.align;
            if ("index" in arg) index = arg.index;
            else index = data.findIndex(function(item) {
                return getKey(item) === arg.key;
            });
            var _arg$offset = arg.offset, offset = _arg$offset === void 0 ? 0 : _arg$offset;
            setSyncState({
                times: 0,
                index: index,
                offset: offset,
                originAlign: align
            });
        }
    };
}



var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");
/**
 * Get index with specific start index one by one. e.g.
 * min: 3, max: 9, start: 6
 *
 * Return index is:
 * [0]: 6
 * [1]: 7
 * [2]: 5
 * [3]: 8
 * [4]: 4
 * [5]: 9
 * [6]: 3
 */ function $07ea81b6f4a7cb44$export$38f9023d45dd4a23(min, max, start, index) {
    var beforeCount = start - min;
    var afterCount = max - start;
    var balanceCount = Math.min(beforeCount, afterCount) * 2;
    // Balance
    if (index <= balanceCount) {
        var stepIndex = Math.floor(index / 2);
        if (index % 2) return start + stepIndex + 1;
        return start - stepIndex;
    }
    // One is out of range
    if (beforeCount > afterCount) return start - (index - afterCount);
    return start + (index - beforeCount);
}
function $07ea81b6f4a7cb44$export$418b8d8b03eefdf5(originList, targetList, getKey) {
    var originLen = originList.length;
    var targetLen = targetList.length;
    var shortList;
    var longList;
    if (originLen === 0 && targetLen === 0) return null;
    if (originLen < targetLen) {
        shortList = originList;
        longList = targetList;
    } else {
        shortList = targetList;
        longList = originList;
    }
    var notExistKey = {
        __EMPTY_ITEM__: true
    };
    function getItemKey(item) {
        if (item !== undefined) return getKey(item);
        return notExistKey;
    }
    // Loop to find diff one
    var diffIndex = null;
    var multiple = Math.abs(originLen - targetLen) !== 1;
    for(var i = 0; i < longList.length; i += 1){
        var shortKey = getItemKey(shortList[i]);
        var longKey = getItemKey(longList[i]);
        if (shortKey !== longKey) {
            diffIndex = i;
            multiple = multiple || shortKey !== getItemKey(longList[i + 1]);
            break;
        }
    }
    return diffIndex === null ? null : {
        index: diffIndex,
        multiple: multiple
    };
}


function $792c44421728f1ca$export$2e2bcd8739ae039(data, getKey, onDiff) {
    var _React$useState = $acw62.useState(data), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), prevData = _React$useState2[0], setPrevData = _React$useState2[1];
    var _React$useState3 = $acw62.useState(null), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), diffItem = _React$useState4[0], setDiffItem = _React$useState4[1];
    $acw62.useEffect(function() {
        var diff = (0, $07ea81b6f4a7cb44$export$418b8d8b03eefdf5)(prevData || [], data || [], getKey);
        if ((diff === null || diff === void 0 ? void 0 : diff.index) !== undefined) {
            onDiff === null || onDiff === void 0 || onDiff(diff.index);
            setDiffItem(data[diff.index]);
        }
        setPrevData(data);
    }, [
        data
    ]);
    return [
        diffItem
    ];
}



var $acw62 = parcelRequire("acw62");

var $dTiBu = parcelRequire("dTiBu");

var $fSwVM = parcelRequire("fSwVM");
var $63d773591ee5124d$var$isFF = (typeof navigator === "undefined" ? "undefined" : (0, $fSwVM.default)(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
var $63d773591ee5124d$export$2e2bcd8739ae039 = $63d773591ee5124d$var$isFF;



var $acw62 = parcelRequire("acw62");
var $3f9e2a044ed7754f$export$2e2bcd8739ae039 = function(isScrollAtTop, isScrollAtBottom) {
    // Do lock for a wheel when scrolling
    var lockRef = (0, $acw62.useRef)(false);
    var lockTimeoutRef = (0, $acw62.useRef)(null);
    function lockScroll() {
        clearTimeout(lockTimeoutRef.current);
        lockRef.current = true;
        lockTimeoutRef.current = setTimeout(function() {
            lockRef.current = false;
        }, 50);
    }
    // Pass to ref since global add is in closure
    var scrollPingRef = (0, $acw62.useRef)({
        top: isScrollAtTop,
        bottom: isScrollAtBottom
    });
    scrollPingRef.current.top = isScrollAtTop;
    scrollPingRef.current.bottom = isScrollAtBottom;
    return function(deltaY) {
        var smoothOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var originScroll = // Pass origin wheel when on the top
        deltaY < 0 && scrollPingRef.current.top || // Pass origin wheel when on the bottom
        deltaY > 0 && scrollPingRef.current.bottom;
        if (smoothOffset && originScroll) {
            // No need lock anymore when it's smooth offset from touchMove interval
            clearTimeout(lockTimeoutRef.current);
            lockRef.current = false;
        } else if (!originScroll || lockRef.current) lockScroll();
        return !lockRef.current && originScroll;
    };
};


function $bc091312f55e72d3$export$2e2bcd8739ae039(inVirtual, isScrollAtTop, isScrollAtBottom, horizontalScroll, /***
 * Return `true` when you need to prevent default event
 */ onWheelDelta) {
    var offsetRef = (0, $acw62.useRef)(0);
    var nextFrameRef = (0, $acw62.useRef)(null);
    // Firefox patch
    var wheelValueRef = (0, $acw62.useRef)(null);
    var isMouseScrollRef = (0, $acw62.useRef)(false);
    // Scroll status sync
    var originScroll = (0, $3f9e2a044ed7754f$export$2e2bcd8739ae039)(isScrollAtTop, isScrollAtBottom);
    function onWheelY(event, deltaY) {
        (0, $dTiBu.default).cancel(nextFrameRef.current);
        offsetRef.current += deltaY;
        wheelValueRef.current = deltaY;
        // Do nothing when scroll at the edge, Skip check when is in scroll
        if (originScroll(deltaY)) return;
        // Proxy of scroll events
        if (!(0, $63d773591ee5124d$export$2e2bcd8739ae039)) event.preventDefault();
        nextFrameRef.current = (0, $dTiBu.default)(function() {
            // Patch a multiple for Firefox to fix wheel number too small
            // ref: https://github.com/ant-design/ant-design/issues/26372#issuecomment-679460266
            var patchMultiple = isMouseScrollRef.current ? 10 : 1;
            onWheelDelta(offsetRef.current * patchMultiple);
            offsetRef.current = 0;
        });
    }
    function onWheelX(event, deltaX) {
        onWheelDelta(deltaX, true);
        if (!(0, $63d773591ee5124d$export$2e2bcd8739ae039)) event.preventDefault();
    }
    // Check for which direction does wheel do. `sx` means `shift + wheel`
    var wheelDirectionRef = (0, $acw62.useRef)(null);
    var wheelDirectionCleanRef = (0, $acw62.useRef)(null);
    function onWheel(event) {
        if (!inVirtual) return;
        // Wait for 2 frame to clean direction
        (0, $dTiBu.default).cancel(wheelDirectionCleanRef.current);
        wheelDirectionCleanRef.current = (0, $dTiBu.default)(function() {
            wheelDirectionRef.current = null;
        }, 2);
        var deltaX = event.deltaX, deltaY = event.deltaY, shiftKey = event.shiftKey;
        var mergedDeltaX = deltaX;
        var mergedDeltaY = deltaY;
        if (wheelDirectionRef.current === "sx" || !wheelDirectionRef.current && (shiftKey || false) && deltaY && !deltaX) {
            mergedDeltaX = deltaY;
            mergedDeltaY = 0;
            wheelDirectionRef.current = "sx";
        }
        var absX = Math.abs(mergedDeltaX);
        var absY = Math.abs(mergedDeltaY);
        if (wheelDirectionRef.current === null) wheelDirectionRef.current = horizontalScroll && absX > absY ? "x" : "y";
        if (wheelDirectionRef.current === "y") onWheelY(event, mergedDeltaY);
        else onWheelX(event, mergedDeltaX);
    }
    // A patch for firefox
    function onFireFoxScroll(event) {
        if (!inVirtual) return;
        isMouseScrollRef.current = event.detail === wheelValueRef.current;
    }
    return [
        onWheel,
        onFireFoxScroll
    ];
}



var $acw62 = parcelRequire("acw62");

var $6hDTM = parcelRequire("6hDTM");
var $565f15d1b93ca0eb$var$SMOOTH_PTG = 14 / 15;
function $565f15d1b93ca0eb$export$2e2bcd8739ae039(inVirtual, listRef, callback) {
    var touchedRef = (0, $acw62.useRef)(false);
    var touchYRef = (0, $acw62.useRef)(0);
    var elementRef = (0, $acw62.useRef)(null);
    // Smooth scroll
    var intervalRef = (0, $acw62.useRef)(null);
    /* eslint-disable prefer-const */ var cleanUpEvents;
    var onTouchMove = function onTouchMove(e) {
        if (touchedRef.current) {
            var currentY = Math.ceil(e.touches[0].pageY);
            var offsetY = touchYRef.current - currentY;
            touchYRef.current = currentY;
            if (callback(offsetY)) e.preventDefault();
            // Smooth interval
            clearInterval(intervalRef.current);
            intervalRef.current = setInterval(function() {
                offsetY *= $565f15d1b93ca0eb$var$SMOOTH_PTG;
                if (!callback(offsetY, true) || Math.abs(offsetY) <= 0.1) clearInterval(intervalRef.current);
            }, 16);
        }
    };
    var onTouchEnd = function onTouchEnd() {
        touchedRef.current = false;
        cleanUpEvents();
    };
    var onTouchStart = function onTouchStart(e) {
        cleanUpEvents();
        if (e.touches.length === 1 && !touchedRef.current) {
            touchedRef.current = true;
            touchYRef.current = Math.ceil(e.touches[0].pageY);
            elementRef.current = e.target;
            elementRef.current.addEventListener("touchmove", onTouchMove);
            elementRef.current.addEventListener("touchend", onTouchEnd);
        }
    };
    cleanUpEvents = function cleanUpEvents() {
        if (elementRef.current) {
            elementRef.current.removeEventListener("touchmove", onTouchMove);
            elementRef.current.removeEventListener("touchend", onTouchEnd);
        }
    };
    (0, $6hDTM.default)(function() {
        if (inVirtual) listRef.current.addEventListener("touchstart", onTouchStart);
        return function() {
            var _listRef$current;
            (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.removeEventListener("touchstart", onTouchStart);
            cleanUpEvents();
            clearInterval(intervalRef.current);
        };
    }, [
        inVirtual
    ]);
}




var $6hDTM = parcelRequire("6hDTM");
var $b4a482bc5e551190$var$MIN_SIZE = 20;
function $b4a482bc5e551190$export$f2ca68955ab35ace() {
    var containerSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var scrollRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var baseSize = containerSize / scrollRange * 100;
    if (isNaN(baseSize)) baseSize = 0;
    baseSize = Math.max(baseSize, $b4a482bc5e551190$var$MIN_SIZE);
    baseSize = Math.min(baseSize, containerSize / 2);
    return Math.floor(baseSize);
}


parcelRequire("gwOwm");
var $a4gyP = parcelRequire("a4gyP");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");
function $352c687fd82e878a$export$a1d82723752af087(mergedData, getKey, heights, itemHeight) {
    var _React$useMemo = $acw62.useMemo(function() {
        return [
            new Map(),
            []
        ];
    }, [
        mergedData,
        heights.id,
        itemHeight
    ]), _React$useMemo2 = (0, $eUqlC.default)(_React$useMemo, 2), key2Index = _React$useMemo2[0], bottomList = _React$useMemo2[1];
    var getSize = function getSize(startKey) {
        var endKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : startKey;
        // Get from cache first
        var startIndex = key2Index.get(startKey);
        var endIndex = key2Index.get(endKey);
        // Loop to fill the cache
        if (startIndex === undefined || endIndex === undefined) {
            var dataLen = mergedData.length;
            for(var i = bottomList.length; i < dataLen; i += 1){
                var _heights$get;
                var item = mergedData[i];
                var key = getKey(item);
                key2Index.set(key, i);
                var cacheHeight = (_heights$get = heights.get(key)) !== null && _heights$get !== void 0 ? _heights$get : itemHeight;
                bottomList[i] = (bottomList[i - 1] || 0) + cacheHeight;
                if (key === startKey) startIndex = i;
                if (key === endKey) endIndex = i;
                if (startIndex !== undefined && endIndex !== undefined) break;
            }
        }
        return {
            top: bottomList[startIndex - 1] || 0,
            bottom: bottomList[endIndex]
        };
    };
    return getSize;
}


var $919681ceac17068c$var$_excluded = [
    "prefixCls",
    "className",
    "height",
    "itemHeight",
    "fullHeight",
    "style",
    "data",
    "children",
    "itemKey",
    "virtual",
    "direction",
    "scrollWidth",
    "component",
    "onScroll",
    "onVirtualScroll",
    "onVisibleChange",
    "innerProps",
    "extraRender",
    "styles"
];
var $919681ceac17068c$var$EMPTY_DATA = [];
var $919681ceac17068c$var$ScrollStyle = {
    overflowY: "auto",
    overflowAnchor: "none"
};
function $919681ceac17068c$export$cc3be4e46e8486ed(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-virtual-list" : _props$prefixCls, className = props.className, height = props.height, itemHeight = props.itemHeight, _props$fullHeight = props.fullHeight, fullHeight = _props$fullHeight === void 0 ? true : _props$fullHeight, style = props.style, data = props.data, children = props.children, itemKey = props.itemKey, virtual = props.virtual, direction = props.direction, scrollWidth = props.scrollWidth, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, onScroll = props.onScroll, onVirtualScroll = props.onVirtualScroll, onVisibleChange = props.onVisibleChange, innerProps = props.innerProps, extraRender = props.extraRender, styles = props.styles, restProps = (0, $9X7IJ.default)(props, $919681ceac17068c$var$_excluded);
    // ================================= MISC =================================
    var useVirtual = !!(virtual !== false && height && itemHeight);
    var inVirtual = useVirtual && data && (itemHeight * data.length > height || !!scrollWidth);
    var isRTL = direction === "rtl";
    var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, (0, $kSlfw.default)({}, "".concat(prefixCls, "-rtl"), isRTL), className);
    var mergedData = data || $919681ceac17068c$var$EMPTY_DATA;
    var componentRef = (0, $acw62.useRef)();
    var fillerInnerRef = (0, $acw62.useRef)();
    // =============================== Item Key ===============================
    var _useState = (0, $acw62.useState)(0), _useState2 = (0, $eUqlC.default)(_useState, 2), offsetTop = _useState2[0], setOffsetTop = _useState2[1];
    var _useState3 = (0, $acw62.useState)(0), _useState4 = (0, $eUqlC.default)(_useState3, 2), offsetLeft = _useState4[0], setOffsetLeft = _useState4[1];
    var _useState5 = (0, $acw62.useState)(false), _useState6 = (0, $eUqlC.default)(_useState5, 2), scrollMoving = _useState6[0], setScrollMoving = _useState6[1];
    var onScrollbarStartMove = function onScrollbarStartMove() {
        setScrollMoving(true);
    };
    var onScrollbarStopMove = function onScrollbarStopMove() {
        setScrollMoving(false);
    };
    // =============================== Item Key ===============================
    var getKey = $acw62.useCallback(function(item) {
        if (typeof itemKey === "function") return itemKey(item);
        return item === null || item === void 0 ? void 0 : item[itemKey];
    }, [
        itemKey
    ]);
    var sharedConfig = {
        getKey: getKey
    };
    // ================================ Scroll ================================
    function syncScrollTop(newTop) {
        setOffsetTop(function(origin) {
            var value;
            if (typeof newTop === "function") value = newTop(origin);
            else value = newTop;
            var alignedTop = keepInRange(value);
            componentRef.current.scrollTop = alignedTop;
            return alignedTop;
        });
    }
    // ================================ Legacy ================================
    // Put ref here since the range is generate by follow
    var rangeRef = (0, $acw62.useRef)({
        start: 0,
        end: mergedData.length
    });
    var diffItemRef = (0, $acw62.useRef)();
    var _useDiffItem = (0, $792c44421728f1ca$export$2e2bcd8739ae039)(mergedData, getKey), _useDiffItem2 = (0, $eUqlC.default)(_useDiffItem, 1), diffItem = _useDiffItem2[0];
    diffItemRef.current = diffItem;
    // ================================ Height ================================
    var _useHeights = (0, $291e20ad7019c1c9$export$2e2bcd8739ae039)(getKey, null, null), _useHeights2 = (0, $eUqlC.default)(_useHeights, 4), setInstanceRef = _useHeights2[0], collectHeight = _useHeights2[1], heights = _useHeights2[2], heightUpdatedMark = _useHeights2[3];
    // ========================== Visible Calculation =========================
    var _React$useMemo = $acw62.useMemo(function() {
        if (!useVirtual) return {
            scrollHeight: undefined,
            start: 0,
            end: mergedData.length - 1,
            offset: undefined
        };
        // Always use virtual scroll bar in avoid shaking
        if (!inVirtual) {
            var _fillerInnerRef$curre;
            return {
                scrollHeight: ((_fillerInnerRef$curre = fillerInnerRef.current) === null || _fillerInnerRef$curre === void 0 ? void 0 : _fillerInnerRef$curre.offsetHeight) || 0,
                start: 0,
                end: mergedData.length - 1,
                offset: undefined
            };
        }
        var itemTop = 0;
        var startIndex;
        var startOffset;
        var endIndex;
        var dataLen = mergedData.length;
        for(var i = 0; i < dataLen; i += 1){
            var item = mergedData[i];
            var key = getKey(item);
            var cacheHeight = heights.get(key);
            var currentItemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
            // Check item top in the range
            if (currentItemBottom >= offsetTop && startIndex === undefined) {
                startIndex = i;
                startOffset = itemTop;
            }
            // Check item bottom in the range. We will render additional one item for motion usage
            if (currentItemBottom > offsetTop + height && endIndex === undefined) endIndex = i;
            itemTop = currentItemBottom;
        }
        // When scrollTop at the end but data cut to small count will reach this
        if (startIndex === undefined) {
            startIndex = 0;
            startOffset = 0;
            endIndex = Math.ceil(height / itemHeight);
        }
        if (endIndex === undefined) endIndex = mergedData.length - 1;
        // Give cache to improve scroll experience
        endIndex = Math.min(endIndex + 1, mergedData.length - 1);
        return {
            scrollHeight: itemTop,
            start: startIndex,
            end: endIndex,
            offset: startOffset
        };
    }, [
        inVirtual,
        useVirtual,
        offsetTop,
        mergedData,
        heightUpdatedMark,
        height
    ]), scrollHeight = _React$useMemo.scrollHeight, start = _React$useMemo.start, end = _React$useMemo.end, fillerOffset = _React$useMemo.offset;
    rangeRef.current.start = start;
    rangeRef.current.end = end;
    // ================================= Size =================================
    var _React$useState = $acw62.useState({
        width: 0,
        height: height
    }), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), size = _React$useState2[0], setSize = _React$useState2[1];
    var onHolderResize = function onHolderResize(sizeInfo) {
        setSize({
            width: sizeInfo.width || sizeInfo.offsetWidth,
            height: sizeInfo.height || sizeInfo.offsetHeight
        });
    };
    // Hack on scrollbar to enable flash call
    var verticalScrollBarRef = (0, $acw62.useRef)();
    var horizontalScrollBarRef = (0, $acw62.useRef)();
    var horizontalScrollBarSpinSize = $acw62.useMemo(function() {
        return (0, $b4a482bc5e551190$export$f2ca68955ab35ace)(size.width, scrollWidth);
    }, [
        size.width,
        scrollWidth
    ]);
    var verticalScrollBarSpinSize = $acw62.useMemo(function() {
        return (0, $b4a482bc5e551190$export$f2ca68955ab35ace)(size.height, scrollHeight);
    }, [
        size.height,
        scrollHeight
    ]);
    // =============================== In Range ===============================
    var maxScrollHeight = scrollHeight - height;
    var maxScrollHeightRef = (0, $acw62.useRef)(maxScrollHeight);
    maxScrollHeightRef.current = maxScrollHeight;
    function keepInRange(newScrollTop) {
        var newTop = newScrollTop;
        if (!Number.isNaN(maxScrollHeightRef.current)) newTop = Math.min(newTop, maxScrollHeightRef.current);
        newTop = Math.max(newTop, 0);
        return newTop;
    }
    var isScrollAtTop = offsetTop <= 0;
    var isScrollAtBottom = offsetTop >= maxScrollHeight;
    var originScroll = (0, $3f9e2a044ed7754f$export$2e2bcd8739ae039)(isScrollAtTop, isScrollAtBottom);
    // ================================ Scroll ================================
    var getVirtualScrollInfo = function getVirtualScrollInfo() {
        return {
            x: isRTL ? -offsetLeft : offsetLeft,
            y: offsetTop
        };
    };
    var lastVirtualScrollInfoRef = (0, $acw62.useRef)(getVirtualScrollInfo());
    var triggerScroll = (0, $a4gyP.default)(function() {
        if (onVirtualScroll) {
            var nextInfo = getVirtualScrollInfo();
            // Trigger when offset changed
            if (lastVirtualScrollInfoRef.current.x !== nextInfo.x || lastVirtualScrollInfoRef.current.y !== nextInfo.y) {
                onVirtualScroll(nextInfo);
                lastVirtualScrollInfoRef.current = nextInfo;
            }
        }
    });
    function onScrollBar(newScrollOffset, horizontal) {
        var newOffset = newScrollOffset;
        if (horizontal) {
            (0, $1u0KT.flushSync)(function() {
                setOffsetLeft(newOffset);
            });
            triggerScroll();
        } else syncScrollTop(newOffset);
    }
    // When data size reduce. It may trigger native scroll event back to fit scroll position
    function onFallbackScroll(e) {
        var newScrollTop = e.currentTarget.scrollTop;
        if (newScrollTop !== offsetTop) syncScrollTop(newScrollTop);
        // Trigger origin onScroll
        onScroll === null || onScroll === void 0 || onScroll(e);
        triggerScroll();
    }
    var keepInHorizontalRange = function keepInHorizontalRange(nextOffsetLeft) {
        var tmpOffsetLeft = nextOffsetLeft;
        var max = scrollWidth - size.width;
        tmpOffsetLeft = Math.max(tmpOffsetLeft, 0);
        tmpOffsetLeft = Math.min(tmpOffsetLeft, max);
        return tmpOffsetLeft;
    };
    var onWheelDelta = (0, $a4gyP.default)(function(offsetXY, fromHorizontal) {
        if (fromHorizontal) {
            // Horizontal scroll no need sync virtual position
            (0, $1u0KT.flushSync)(function() {
                setOffsetLeft(function(left) {
                    var nextOffsetLeft = left + (isRTL ? -offsetXY : offsetXY);
                    return keepInHorizontalRange(nextOffsetLeft);
                });
            });
            triggerScroll();
        } else syncScrollTop(function(top) {
            var newTop = top + offsetXY;
            return newTop;
        });
    });
    // Since this added in global,should use ref to keep update
    var _useFrameWheel = (0, $bc091312f55e72d3$export$2e2bcd8739ae039)(useVirtual, isScrollAtTop, isScrollAtBottom, !!scrollWidth, onWheelDelta), _useFrameWheel2 = (0, $eUqlC.default)(_useFrameWheel, 2), onRawWheel = _useFrameWheel2[0], onFireFoxScroll = _useFrameWheel2[1];
    // Mobile touch move
    (0, $565f15d1b93ca0eb$export$2e2bcd8739ae039)(useVirtual, componentRef, function(deltaY, smoothOffset) {
        if (originScroll(deltaY, smoothOffset)) return false;
        onRawWheel({
            preventDefault: function preventDefault() {},
            deltaY: deltaY
        });
        return true;
    });
    (0, $6hDTM.default)(function() {
        // Firefox only
        function onMozMousePixelScroll(e) {
            if (useVirtual) e.preventDefault();
        }
        var componentEle = componentRef.current;
        componentEle.addEventListener("wheel", onRawWheel);
        componentEle.addEventListener("DOMMouseScroll", onFireFoxScroll);
        componentEle.addEventListener("MozMousePixelScroll", onMozMousePixelScroll);
        return function() {
            componentEle.removeEventListener("wheel", onRawWheel);
            componentEle.removeEventListener("DOMMouseScroll", onFireFoxScroll);
            componentEle.removeEventListener("MozMousePixelScroll", onMozMousePixelScroll);
        };
    }, [
        useVirtual
    ]);
    // Sync scroll left
    (0, $6hDTM.default)(function() {
        if (scrollWidth) setOffsetLeft(function(left) {
            return keepInHorizontalRange(left);
        });
    }, [
        size.width,
        scrollWidth
    ]);
    // ================================= Ref ==================================
    var delayHideScrollBar = function delayHideScrollBar() {
        var _verticalScrollBarRef, _horizontalScrollBarR;
        (_verticalScrollBarRef = verticalScrollBarRef.current) === null || _verticalScrollBarRef === void 0 || _verticalScrollBarRef.delayHidden();
        (_horizontalScrollBarR = horizontalScrollBarRef.current) === null || _horizontalScrollBarR === void 0 || _horizontalScrollBarR.delayHidden();
    };
    var _scrollTo = (0, $e77930eb0c8ae9f1$export$2e2bcd8739ae039)(componentRef, mergedData, heights, itemHeight, getKey, function() {
        return collectHeight(true);
    }, syncScrollTop, delayHideScrollBar);
    $acw62.useImperativeHandle(ref, function() {
        return {
            getScrollInfo: getVirtualScrollInfo,
            scrollTo: function scrollTo(config) {
                function isPosScroll(arg) {
                    return arg && (0, $fSwVM.default)(arg) === "object" && ("left" in arg || "top" in arg);
                }
                if (isPosScroll(config)) {
                    // Scroll X
                    if (config.left !== undefined) setOffsetLeft(keepInHorizontalRange(config.left));
                    // Scroll Y
                    _scrollTo(config.top);
                } else _scrollTo(config);
            }
        };
    });
    // ================================ Effect ================================
    /** We need told outside that some list not rendered */ (0, $6hDTM.default)(function() {
        if (onVisibleChange) {
            var renderList = mergedData.slice(start, end + 1);
            onVisibleChange(renderList, mergedData);
        }
    }, [
        start,
        end,
        mergedData
    ]);
    // ================================ Extra =================================
    var getSize = (0, $352c687fd82e878a$export$a1d82723752af087)(mergedData, getKey, heights, itemHeight);
    var extraContent = extraRender === null || extraRender === void 0 ? void 0 : extraRender({
        start: start,
        end: end,
        virtual: inVirtual,
        offsetX: offsetLeft,
        offsetY: fillerOffset,
        rtl: isRTL,
        getSize: getSize
    });
    // ================================ Render ================================
    var listChildren = (0, $c2cc76a198e74e0d$export$2e2bcd8739ae039)(mergedData, start, end, scrollWidth, setInstanceRef, children, sharedConfig);
    var componentStyle = null;
    if (height) {
        componentStyle = (0, $d49SP.default)((0, $kSlfw.default)({}, fullHeight ? "height" : "maxHeight", height), $919681ceac17068c$var$ScrollStyle);
        if (useVirtual) {
            componentStyle.overflowY = "hidden";
            if (scrollWidth) componentStyle.overflowX = "hidden";
            if (scrollMoving) componentStyle.pointerEvents = "none";
        }
    }
    var containerProps = {};
    if (isRTL) containerProps.dir = "rtl";
    return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        style: (0, $d49SP.default)((0, $d49SP.default)({}, style), {}, {
            position: "relative"
        }),
        className: mergedClassName
    }, containerProps, restProps), /*#__PURE__*/ $acw62.createElement((0, $bVxlN.default), {
        onResize: onHolderResize
    }, /*#__PURE__*/ $acw62.createElement(Component, {
        className: "".concat(prefixCls, "-holder"),
        style: componentStyle,
        ref: componentRef,
        onScroll: onFallbackScroll,
        onMouseEnter: delayHideScrollBar
    }, /*#__PURE__*/ $acw62.createElement((0, $a7c020883d75d0d6$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        height: scrollHeight,
        offsetX: offsetLeft,
        offsetY: fillerOffset,
        scrollWidth: scrollWidth,
        onInnerResize: collectHeight,
        ref: fillerInnerRef,
        innerProps: innerProps,
        rtl: isRTL,
        extra: extraContent
    }, listChildren))), inVirtual && scrollHeight > height && /*#__PURE__*/ $acw62.createElement((0, $2ebd4898b033397e$export$2e2bcd8739ae039), {
        ref: verticalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetTop,
        scrollRange: scrollHeight,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: verticalScrollBarSpinSize,
        containerSize: size.height,
        style: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBar,
        thumbStyle: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBarThumb
    }), inVirtual && scrollWidth && /*#__PURE__*/ $acw62.createElement((0, $2ebd4898b033397e$export$2e2bcd8739ae039), {
        ref: horizontalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetLeft,
        scrollRange: scrollWidth,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: horizontalScrollBarSpinSize,
        containerSize: size.width,
        horizontal: true,
        style: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBar,
        thumbStyle: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBarThumb
    }));
}
var $919681ceac17068c$var$List = /*#__PURE__*/ $acw62.forwardRef($919681ceac17068c$export$cc3be4e46e8486ed);
$919681ceac17068c$var$List.displayName = "List";
var $919681ceac17068c$export$2e2bcd8739ae039 = $919681ceac17068c$var$List;


var $2f16cd4e45d13ddf$export$2e2bcd8739ae039 = (0, $919681ceac17068c$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// Use any here since we do not get the type during compilation
var $44daf1c3d5d48cca$var$SelectContext = /*#__PURE__*/ $acw62.createContext(null);
var $44daf1c3d5d48cca$export$2e2bcd8739ae039 = $44daf1c3d5d48cca$var$SelectContext;




/* istanbul ignore file */ function $b345c0bc7d688d6a$export$3bbcfec016973a77() {
    return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}


var $4a507f608f30c004$var$_excluded = [
    "disabled",
    "title",
    "children",
    "style",
    "className"
];
// export interface OptionListProps<OptionsType extends object[]> {
function $4a507f608f30c004$var$isTitleType(content) {
    return typeof content === "string" || typeof content === "number";
}
/**
 * Using virtual list of option display.
 * Will fallback to dom if use customize render.
 */ var $4a507f608f30c004$var$OptionList = function OptionList(_, ref) {
    var _useBaseProps = (0, $de346c10040f695b$export$2e2bcd8739ae039)(), prefixCls = _useBaseProps.prefixCls, id = _useBaseProps.id, open = _useBaseProps.open, multiple = _useBaseProps.multiple, mode = _useBaseProps.mode, searchValue = _useBaseProps.searchValue, toggleOpen = _useBaseProps.toggleOpen, notFoundContent = _useBaseProps.notFoundContent, onPopupScroll = _useBaseProps.onPopupScroll;
    var _React$useContext = $acw62.useContext((0, $44daf1c3d5d48cca$export$2e2bcd8739ae039)), flattenOptions = _React$useContext.flattenOptions, onActiveValue = _React$useContext.onActiveValue, defaultActiveFirstOption = _React$useContext.defaultActiveFirstOption, onSelect = _React$useContext.onSelect, menuItemSelectedIcon = _React$useContext.menuItemSelectedIcon, rawValues = _React$useContext.rawValues, fieldNames = _React$useContext.fieldNames, virtual = _React$useContext.virtual, direction = _React$useContext.direction, listHeight = _React$useContext.listHeight, listItemHeight = _React$useContext.listItemHeight, optionRender = _React$useContext.optionRender;
    var itemPrefixCls = "".concat(prefixCls, "-item");
    var memoFlattenOptions = (0, $3Ysvw.default)(function() {
        return flattenOptions;
    }, [
        open,
        flattenOptions
    ], function(prev, next) {
        return next[0] && prev[1] !== next[1];
    });
    // =========================== List ===========================
    var listRef = $acw62.useRef(null);
    var onListMouseDown = function onListMouseDown(event) {
        event.preventDefault();
    };
    var scrollIntoView = function scrollIntoView(args) {
        if (listRef.current) listRef.current.scrollTo(typeof args === "number" ? {
            index: args
        } : args);
    };
    // ========================== Active ==========================
    var getEnabledActiveIndex = function getEnabledActiveIndex(index) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var len = memoFlattenOptions.length;
        for(var i = 0; i < len; i += 1){
            var current = (index + i * offset + len) % len;
            var _memoFlattenOptions$c = memoFlattenOptions[current], group = _memoFlattenOptions$c.group, data = _memoFlattenOptions$c.data;
            if (!group && !data.disabled) return current;
        }
        return -1;
    };
    var _React$useState = $acw62.useState(function() {
        return getEnabledActiveIndex(0);
    }), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), activeIndex = _React$useState2[0], setActiveIndex = _React$useState2[1];
    var setActive = function setActive(index) {
        var fromKeyboard = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        setActiveIndex(index);
        var info = {
            source: fromKeyboard ? "keyboard" : "mouse"
        };
        // Trigger active event
        var flattenItem = memoFlattenOptions[index];
        if (!flattenItem) {
            onActiveValue(null, -1, info);
            return;
        }
        onActiveValue(flattenItem.value, index, info);
    };
    // Auto active first item when list length or searchValue changed
    (0, $acw62.useEffect)(function() {
        setActive(defaultActiveFirstOption !== false ? getEnabledActiveIndex(0) : -1);
    }, [
        memoFlattenOptions.length,
        searchValue
    ]);
    // https://github.com/ant-design/ant-design/issues/34975
    var isSelected = $acw62.useCallback(function(value) {
        return rawValues.has(value) && mode !== "combobox";
    }, [
        mode,
        (0, $kbxxf.default)(rawValues).toString(),
        rawValues.size
    ]);
    // Auto scroll to item position in single mode
    (0, $acw62.useEffect)(function() {
        /**
     * React will skip `onChange` when component update.
     * `setActive` function will call root accessibility state update which makes re-render.
     * So we need to delay to let Input component trigger onChange first.
     */ var timeoutId = setTimeout(function() {
            if (!multiple && open && rawValues.size === 1) {
                var value = Array.from(rawValues)[0];
                var index = memoFlattenOptions.findIndex(function(_ref) {
                    var data = _ref.data;
                    return data.value === value;
                });
                if (index !== -1) {
                    setActive(index);
                    scrollIntoView(index);
                }
            }
        });
        // Force trigger scrollbar visible when open
        if (open) {
            var _listRef$current;
            (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.scrollTo(undefined);
        }
        return function() {
            return clearTimeout(timeoutId);
        };
    }, [
        open,
        searchValue
    ]);
    // ========================== Values ==========================
    var onSelectValue = function onSelectValue(value) {
        if (value !== undefined) onSelect(value, {
            selected: !rawValues.has(value)
        });
        // Single mode should always close by select
        if (!multiple) toggleOpen(false);
    };
    // ========================= Keyboard =========================
    $acw62.useImperativeHandle(ref, function() {
        return {
            onKeyDown: function onKeyDown(event) {
                var which = event.which, ctrlKey = event.ctrlKey;
                switch(which){
                    // >>> Arrow keys & ctrl + n/p on Mac
                    case (0, $iCi4s.default).N:
                    case (0, $iCi4s.default).P:
                    case (0, $iCi4s.default).UP:
                    case (0, $iCi4s.default).DOWN:
                        var offset = 0;
                        if (which === (0, $iCi4s.default).UP) offset = -1;
                        else if (which === (0, $iCi4s.default).DOWN) offset = 1;
                        else if ((0, $b345c0bc7d688d6a$export$3bbcfec016973a77)() && ctrlKey) {
                            if (which === (0, $iCi4s.default).N) offset = 1;
                            else if (which === (0, $iCi4s.default).P) offset = -1;
                        }
                        if (offset !== 0) {
                            var nextActiveIndex = getEnabledActiveIndex(activeIndex + offset, offset);
                            scrollIntoView(nextActiveIndex);
                            setActive(nextActiveIndex, true);
                        }
                        break;
                    // >>> Select
                    case (0, $iCi4s.default).ENTER:
                        // value
                        var item = memoFlattenOptions[activeIndex];
                        if (item && !item.data.disabled) onSelectValue(item.value);
                        else onSelectValue(undefined);
                        if (open) event.preventDefault();
                        break;
                    // >>> Close
                    case (0, $iCi4s.default).ESC:
                        toggleOpen(false);
                        if (open) event.stopPropagation();
                }
            },
            onKeyUp: function onKeyUp() {},
            scrollTo: function scrollTo(index) {
                scrollIntoView(index);
            }
        };
    });
    // ========================== Render ==========================
    if (memoFlattenOptions.length === 0) return /*#__PURE__*/ $acw62.createElement("div", {
        role: "listbox",
        id: "".concat(id, "_list"),
        className: "".concat(itemPrefixCls, "-empty"),
        onMouseDown: onListMouseDown
    }, notFoundContent);
    var omitFieldNameList = Object.keys(fieldNames).map(function(key) {
        return fieldNames[key];
    });
    var getLabel = function getLabel(item) {
        return item.label;
    };
    function getItemAriaProps(item, index) {
        var group = item.group;
        return {
            role: group ? "presentation" : "option",
            id: "".concat(id, "_list_").concat(index)
        };
    }
    var renderItem = function renderItem(index) {
        var item = memoFlattenOptions[index];
        if (!item) return null;
        var itemData = item.data || {};
        var value = itemData.value;
        var group = item.group;
        var attrs = (0, $281efe5882c936de$export$2e2bcd8739ae039)(itemData, true);
        var mergedLabel = getLabel(item);
        return item ? /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
            "aria-label": typeof mergedLabel === "string" && !group ? mergedLabel : null
        }, attrs, {
            key: index
        }, getItemAriaProps(item, index), {
            "aria-selected": isSelected(value)
        }), value) : null;
    };
    var a11yProps = {
        role: "listbox",
        id: "".concat(id, "_list")
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, virtual && /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({}, a11yProps, {
        style: {
            height: 0,
            width: 0,
            overflow: "hidden"
        }
    }), renderItem(activeIndex - 1), renderItem(activeIndex), renderItem(activeIndex + 1)), /*#__PURE__*/ $acw62.createElement((0, $2f16cd4e45d13ddf$export$2e2bcd8739ae039), {
        itemKey: "key",
        ref: listRef,
        data: memoFlattenOptions,
        height: listHeight,
        itemHeight: listItemHeight,
        fullHeight: false,
        onMouseDown: onListMouseDown,
        onScroll: onPopupScroll,
        virtual: virtual,
        direction: direction,
        innerProps: virtual ? null : a11yProps
    }, function(item, itemIndex) {
        var _classNames;
        var group = item.group, groupOption = item.groupOption, data = item.data, label = item.label, value = item.value;
        var key = data.key;
        // Group
        if (group) {
            var _data$title;
            var groupTitle = (_data$title = data.title) !== null && _data$title !== void 0 ? _data$title : $4a507f608f30c004$var$isTitleType(label) ? label.toString() : undefined;
            return /*#__PURE__*/ $acw62.createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(itemPrefixCls, "".concat(itemPrefixCls, "-group")),
                title: groupTitle
            }, label !== undefined ? label : key);
        }
        var disabled = data.disabled, title = data.title, children = data.children, style = data.style, className = data.className, otherProps = (0, $9X7IJ.default)(data, $4a507f608f30c004$var$_excluded);
        var passedProps = (0, $1pcHX.default)(otherProps, omitFieldNameList);
        // Option
        var selected = isSelected(value);
        var optionPrefixCls = "".concat(itemPrefixCls, "-option");
        var optionClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(itemPrefixCls, optionPrefixCls, className, (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(optionPrefixCls, "-grouped"), groupOption), (0, $kSlfw.default)(_classNames, "".concat(optionPrefixCls, "-active"), activeIndex === itemIndex && !disabled), (0, $kSlfw.default)(_classNames, "".concat(optionPrefixCls, "-disabled"), disabled), (0, $kSlfw.default)(_classNames, "".concat(optionPrefixCls, "-selected"), selected), _classNames));
        var mergedLabel = getLabel(item);
        var iconVisible = !menuItemSelectedIcon || typeof menuItemSelectedIcon === "function" || selected;
        // https://github.com/ant-design/ant-design/issues/34145
        var content = typeof mergedLabel === "number" ? mergedLabel : mergedLabel || value;
        // https://github.com/ant-design/ant-design/issues/26717
        var optionTitle = $4a507f608f30c004$var$isTitleType(content) ? content.toString() : undefined;
        if (title !== undefined) optionTitle = title;
        return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({}, (0, $281efe5882c936de$export$2e2bcd8739ae039)(passedProps), !virtual ? getItemAriaProps(item, itemIndex) : {}, {
            "aria-selected": selected,
            className: optionClassName,
            title: optionTitle,
            onMouseMove: function onMouseMove() {
                if (activeIndex === itemIndex || disabled) return;
                setActive(itemIndex);
            },
            onClick: function onClick() {
                if (!disabled) onSelectValue(value);
            },
            style: style
        }), /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(optionPrefixCls, "-content")
        }, typeof optionRender === "function" ? optionRender(item, {
            index: itemIndex
        }) : content), /*#__PURE__*/ $acw62.isValidElement(menuItemSelectedIcon) || selected, iconVisible && /*#__PURE__*/ $acw62.createElement((0, $707d52f2ac65b829$export$2e2bcd8739ae039), {
            className: "".concat(itemPrefixCls, "-option-state"),
            customizeIcon: menuItemSelectedIcon,
            customizeIconProps: {
                value: value,
                disabled: disabled,
                isSelected: selected
            }
        }, selected ? "\u2713" : null));
    }));
};
var $4a507f608f30c004$var$RefOptionList = /*#__PURE__*/ $acw62.forwardRef($4a507f608f30c004$var$OptionList);
$4a507f608f30c004$var$RefOptionList.displayName = "OptionList";
var $4a507f608f30c004$export$2e2bcd8739ae039 = $4a507f608f30c004$var$RefOptionList;




var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
var /**
 * Cache `value` related LabeledValue & options.
 */ $91018b9a345d68e7$export$2e2bcd8739ae039 = function(labeledValues, valueOptions) {
    var cacheRef = $acw62.useRef({
        values: new Map(),
        options: new Map()
    });
    var filledLabeledValues = $acw62.useMemo(function() {
        var _cacheRef$current = cacheRef.current, prevValueCache = _cacheRef$current.values, prevOptionCache = _cacheRef$current.options;
        // Fill label by cache
        var patchedValues = labeledValues.map(function(item) {
            if (item.label === undefined) {
                var _prevValueCache$get;
                return (0, $d49SP.default)((0, $d49SP.default)({}, item), {}, {
                    label: (_prevValueCache$get = prevValueCache.get(item.value)) === null || _prevValueCache$get === void 0 ? void 0 : _prevValueCache$get.label
                });
            }
            return item;
        });
        // Refresh cache
        var valueCache = new Map();
        var optionCache = new Map();
        patchedValues.forEach(function(item) {
            valueCache.set(item.value, item);
            optionCache.set(item.value, valueOptions.get(item.value) || prevOptionCache.get(item.value));
        });
        cacheRef.current.values = valueCache;
        cacheRef.current.options = optionCache;
        return patchedValues;
    }, [
        labeledValues,
        valueOptions
    ]);
    var getOption = $acw62.useCallback(function(val) {
        return valueOptions.get(val) || cacheRef.current.options.get(val);
    }, [
        valueOptions
    ]);
    return [
        filledLabeledValues,
        getOption
    ];
};



var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");


function $47ef072d0f92ab84$var$includes(test, search) {
    return (0, $953a8baf84e85e44$export$45b10814cc054894)(test).join("").toUpperCase().includes(search);
}
var $47ef072d0f92ab84$export$2e2bcd8739ae039 = function(options, fieldNames, searchValue, filterOption, optionFilterProp) {
    return $acw62.useMemo(function() {
        if (!searchValue || filterOption === false) return options;
        var fieldOptions = fieldNames.options, fieldLabel = fieldNames.label, fieldValue = fieldNames.value;
        var filteredOptions = [];
        var customizeFilter = typeof filterOption === "function";
        var upperSearch = searchValue.toUpperCase();
        var filterFunc = customizeFilter ? filterOption : function(_, option) {
            // Use provided `optionFilterProp`
            if (optionFilterProp) return $47ef072d0f92ab84$var$includes(option[optionFilterProp], upperSearch);
            // Auto select `label` or `value` by option type
            if (option[fieldOptions]) // hack `fieldLabel` since `OptionGroup` children is not `label`
            return $47ef072d0f92ab84$var$includes(option[fieldLabel !== "children" ? fieldLabel : "label"], upperSearch);
            return $47ef072d0f92ab84$var$includes(option[fieldValue], upperSearch);
        };
        var wrapOption = customizeFilter ? function(opt) {
            return (0, $67e3f69030e63308$export$d0b21b213c8c013c)(opt);
        } : function(opt) {
            return opt;
        };
        options.forEach(function(item) {
            // Group should check child options
            if (item[fieldOptions]) {
                // Check group first
                var matchGroup = filterFunc(searchValue, wrapOption(item));
                if (matchGroup) filteredOptions.push(item);
                else {
                    // Check option
                    var subOptions = item[fieldOptions].filter(function(subItem) {
                        return filterFunc(searchValue, wrapOption(subItem));
                    });
                    if (subOptions.length) filteredOptions.push((0, $d49SP.default)((0, $d49SP.default)({}, item), {}, (0, $kSlfw.default)({}, fieldOptions, subOptions)));
                }
                return;
            }
            if (filterFunc(searchValue, wrapOption(item))) filteredOptions.push(item);
        });
        return filteredOptions;
    }, [
        options,
        filterOption,
        optionFilterProp,
        searchValue,
        fieldNames
    ]);
};



var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $h4v51 = parcelRequire("h4v51");
var $8656bcd9ded5e8cf$var$uuid = 0;
var $8656bcd9ded5e8cf$export$df7146797a248522 = (0, $h4v51.default)();
function $8656bcd9ded5e8cf$export$36ec425867d538d7() {
    var retId;
    // Test never reach
    /* istanbul ignore if */ if ($8656bcd9ded5e8cf$export$df7146797a248522) {
        retId = $8656bcd9ded5e8cf$var$uuid;
        $8656bcd9ded5e8cf$var$uuid += 1;
    } else retId = "TEST_OR_SSR";
    return retId;
}
function $8656bcd9ded5e8cf$export$2e2bcd8739ae039(id) {
    // Inner id for accessibility usage. Only work in client side
    var _React$useState = $acw62.useState(), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    $acw62.useEffect(function() {
        setInnerId("rc_select_".concat($8656bcd9ded5e8cf$export$36ec425867d538d7()));
    }, []);
    return id || innerId;
}



var $acw62 = parcelRequire("acw62");

var $d49SP = parcelRequire("d49SP");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $jWR62 = parcelRequire("jWR62");
var $e44edf3963c3279c$var$_excluded = [
    "children",
    "value"
], $e44edf3963c3279c$var$_excluded2 = [
    "children"
];
function $e44edf3963c3279c$var$convertNodeToOption(node) {
    var _ref = node, key = _ref.key, _ref$props = _ref.props, children = _ref$props.children, value = _ref$props.value, restProps = (0, $9X7IJ.default)(_ref$props, $e44edf3963c3279c$var$_excluded);
    return (0, $d49SP.default)({
        key: key,
        value: value !== undefined ? value : key,
        children: children
    }, restProps);
}
function $e44edf3963c3279c$export$3beca35db74c3985(nodes) {
    var optionOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return (0, $jWR62.default)(nodes).map(function(node, index) {
        if (!/*#__PURE__*/ $acw62.isValidElement(node) || !node.type) return null;
        var _ref2 = node, isSelectOptGroup = _ref2.type.isSelectOptGroup, key = _ref2.key, _ref2$props = _ref2.props, children = _ref2$props.children, restProps = (0, $9X7IJ.default)(_ref2$props, $e44edf3963c3279c$var$_excluded2);
        if (optionOnly || !isSelectOptGroup) return $e44edf3963c3279c$var$convertNodeToOption(node);
        return (0, $d49SP.default)((0, $d49SP.default)({
            key: "__RC_SELECT_GRP__".concat(key === null ? index : key, "__"),
            label: key
        }, restProps), {}, {
            options: $e44edf3963c3279c$export$3beca35db74c3985(children)
        });
    }).filter(function(data) {
        return data;
    });
}


function $05553a78451953de$export$2e2bcd8739ae039(options, children, fieldNames, optionFilterProp, optionLabelProp) {
    return $acw62.useMemo(function() {
        var mergedOptions = options;
        var childrenAsData = !options;
        if (childrenAsData) mergedOptions = (0, $e44edf3963c3279c$export$3beca35db74c3985)(children);
        var valueOptions = new Map();
        var labelOptions = new Map();
        var setLabelOptions = function setLabelOptions(labelOptionsMap, option, key) {
            if (key && typeof key === "string") labelOptionsMap.set(option[key], option);
        };
        function dig(optionList) {
            var isChildren = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            // for loop to speed up collection speed
            for(var i = 0; i < optionList.length; i += 1){
                var option = optionList[i];
                if (!option[fieldNames.options] || isChildren) {
                    valueOptions.set(option[fieldNames.value], option);
                    setLabelOptions(labelOptions, option, fieldNames.label);
                    // https://github.com/ant-design/ant-design/issues/35304
                    setLabelOptions(labelOptions, option, optionFilterProp);
                    setLabelOptions(labelOptions, option, optionLabelProp);
                } else dig(option[fieldNames.options], true);
            }
        }
        dig(mergedOptions);
        return {
            options: mergedOptions,
            valueOptions: valueOptions,
            labelOptions: labelOptions
        };
    }, [
        options,
        children,
        fieldNames,
        optionFilterProp,
        optionLabelProp
    ]);
}



var $acw62 = parcelRequire("acw62");
function $fb4ced1ec5128b6c$export$2e2bcd8739ae039(callback) {
    var funcRef = $acw62.useRef();
    funcRef.current = callback;
    var cacheFn = $acw62.useCallback(function() {
        return funcRef.current.apply(funcRef, arguments);
    }, []);
    return cacheFn;
}





var $fSwVM = parcelRequire("fSwVM");

var $jWR62 = parcelRequire("jWR62");

var $u43uR = parcelRequire("u43uR");

var $acw62 = parcelRequire("acw62");



function $0dd83a53fec15284$var$warningProps(props) {
    var mode = props.mode, options = props.options, children = props.children, backfill = props.backfill, allowClear = props.allowClear, placeholder = props.placeholder, getInputElement = props.getInputElement, showSearch = props.showSearch, onSearch = props.onSearch, defaultOpen = props.defaultOpen, autoFocus = props.autoFocus, labelInValue = props.labelInValue, value = props.value, inputValue = props.inputValue, optionLabelProp = props.optionLabelProp;
    var multiple = (0, $2dc4538d56993d0c$export$7f654ad2a77ad2ac)(mode);
    var mergedShowSearch = showSearch !== undefined ? showSearch : multiple || mode === "combobox";
    var mergedOptions = options || (0, $e44edf3963c3279c$export$3beca35db74c3985)(children);
    // `tags` should not set option as disabled
    (0, $u43uR.default)(mode !== "tags" || mergedOptions.every(function(opt) {
        return !opt.disabled;
    }), "Please avoid setting option to disabled in tags mode since user can always type text as tag.");
    // `combobox` & `tags` should option be `string` type
    if (mode === "tags" || mode === "combobox") {
        var hasNumberValue = mergedOptions.some(function(item) {
            if (item.options) return item.options.some(function(opt) {
                return typeof ("value" in opt ? opt.value : opt.key) === "number";
            });
            return typeof ("value" in item ? item.value : item.key) === "number";
        });
        (0, $u43uR.default)(!hasNumberValue, "`value` of Option should not use number type when `mode` is `tags` or `combobox`.");
    }
    // `combobox` should not use `optionLabelProp`
    (0, $u43uR.default)(mode !== "combobox" || !optionLabelProp, "`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly.");
    // Only `combobox` support `backfill`
    (0, $u43uR.default)(mode === "combobox" || !backfill, "`backfill` only works with `combobox` mode.");
    // Only `combobox` support `getInputElement`
    (0, $u43uR.default)(mode === "combobox" || !getInputElement, "`getInputElement` only work with `combobox` mode.");
    // Customize `getInputElement` should not use `allowClear` & `placeholder`
    (0, $u43uR.noteOnce)(mode !== "combobox" || !getInputElement || !allowClear || !placeholder, "Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`.");
    // `onSearch` should use in `combobox` or `showSearch`
    if (onSearch && !mergedShowSearch && mode !== "combobox" && mode !== "tags") (0, $u43uR.default)(false, "`onSearch` should work with `showSearch` instead of use alone.");
    (0, $u43uR.noteOnce)(!defaultOpen || autoFocus, "`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed.");
    if (value !== undefined && value !== null) {
        var values = (0, $953a8baf84e85e44$export$45b10814cc054894)(value);
        (0, $u43uR.default)(!labelInValue || values.every(function(val) {
            return (0, $fSwVM.default)(val) === "object" && ("key" in val || "value" in val);
        }), "`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`");
        (0, $u43uR.default)(!multiple || Array.isArray(value), "`value` should be array when `mode` is `multiple` or `tags`");
    }
    // Syntactic sugar should use correct children type
    if (children) {
        var invalidateChildType = null;
        (0, $jWR62.default)(children).some(function(node) {
            if (!/*#__PURE__*/ $acw62.isValidElement(node) || !node.type) return false;
            var _ref = node, type = _ref.type;
            if (type.isSelectOption) return false;
            if (type.isSelectOptGroup) {
                var allChildrenValid = (0, $jWR62.default)(node.props.children).every(function(subNode) {
                    if (!/*#__PURE__*/ $acw62.isValidElement(subNode) || !node.type || subNode.type.isSelectOption) return true;
                    invalidateChildType = subNode.type;
                    return false;
                });
                if (allChildrenValid) return false;
                return true;
            }
            invalidateChildType = type;
            return true;
        });
        if (invalidateChildType) (0, $u43uR.default)(false, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(invalidateChildType.displayName || invalidateChildType.name || invalidateChildType, "`."));
        (0, $u43uR.default)(inputValue === undefined, "`inputValue` is deprecated, please use `searchValue` instead.");
    }
}
function $0dd83a53fec15284$export$c33a1be4de1ec2c(options, fieldNames) {
    if (options) {
        var recursiveOptions = function recursiveOptions(optionsList) {
            var inGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            for(var i = 0; i < optionsList.length; i++){
                var option = optionsList[i];
                if (option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.value] === null) {
                    (0, $u43uR.default)(false, "`value` in Select options should not be `null`.");
                    return true;
                }
                if (!inGroup && Array.isArray(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.options]) && recursiveOptions(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.options], true)) break;
            }
        };
        recursiveOptions(options);
    }
}
var $0dd83a53fec15284$export$2e2bcd8739ae039 = $0dd83a53fec15284$var$warningProps;


var $89a6c2622fd5143d$var$_excluded = [
    "id",
    "mode",
    "prefixCls",
    "backfill",
    "fieldNames",
    "inputValue",
    "searchValue",
    "onSearch",
    "autoClearSearchValue",
    "onSelect",
    "onDeselect",
    "dropdownMatchSelectWidth",
    "filterOption",
    "filterSort",
    "optionFilterProp",
    "optionLabelProp",
    "options",
    "optionRender",
    "children",
    "defaultActiveFirstOption",
    "menuItemSelectedIcon",
    "virtual",
    "direction",
    "listHeight",
    "listItemHeight",
    "value",
    "defaultValue",
    "labelInValue",
    "onChange"
];
var $89a6c2622fd5143d$var$OMIT_DOM_PROPS = [
    "inputValue"
];
function $89a6c2622fd5143d$var$isRawValue(value) {
    return !value || (0, $fSwVM.default)(value) !== "object";
}
var $89a6c2622fd5143d$var$Select = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var id = props.id, mode = props.mode, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-select" : _props$prefixCls, backfill = props.backfill, fieldNames = props.fieldNames, inputValue = props.inputValue, searchValue = props.searchValue, onSearch = props.onSearch, _props$autoClearSearc = props.autoClearSearchValue, autoClearSearchValue = _props$autoClearSearc === void 0 ? true : _props$autoClearSearc, onSelect = props.onSelect, onDeselect = props.onDeselect, _props$dropdownMatchS = props.dropdownMatchSelectWidth, dropdownMatchSelectWidth = _props$dropdownMatchS === void 0 ? true : _props$dropdownMatchS, filterOption = props.filterOption, filterSort = props.filterSort, optionFilterProp = props.optionFilterProp, optionLabelProp = props.optionLabelProp, options = props.options, optionRender = props.optionRender, children = props.children, defaultActiveFirstOption = props.defaultActiveFirstOption, menuItemSelectedIcon = props.menuItemSelectedIcon, virtual = props.virtual, direction = props.direction, _props$listHeight = props.listHeight, listHeight = _props$listHeight === void 0 ? 200 : _props$listHeight, _props$listItemHeight = props.listItemHeight, listItemHeight = _props$listItemHeight === void 0 ? 20 : _props$listItemHeight, value = props.value, defaultValue = props.defaultValue, labelInValue = props.labelInValue, onChange = props.onChange, restProps = (0, $9X7IJ.default)(props, $89a6c2622fd5143d$var$_excluded);
    var mergedId = (0, $8656bcd9ded5e8cf$export$2e2bcd8739ae039)(id);
    var multiple = (0, $2dc4538d56993d0c$export$7f654ad2a77ad2ac)(mode);
    var childrenAsData = !!(!options && children);
    var mergedFilterOption = $acw62.useMemo(function() {
        if (filterOption === undefined && mode === "combobox") return false;
        return filterOption;
    }, [
        filterOption,
        mode
    ]);
    // ========================= FieldNames =========================
    var mergedFieldNames = $acw62.useMemo(function() {
        return (0, $67e3f69030e63308$export$6c519d302dced239)(fieldNames, childrenAsData);
    }, /* eslint-disable react-hooks/exhaustive-deps */ [
        // We stringify fieldNames to avoid unnecessary re-renders.
        JSON.stringify(fieldNames),
        childrenAsData
    ]);
    // =========================== Search ===========================
    var _useMergedState = (0, $iSQh8.default)("", {
        value: searchValue !== undefined ? searchValue : inputValue,
        postState: function postState(search) {
            return search || "";
        }
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), mergedSearchValue = _useMergedState2[0], setSearchValue = _useMergedState2[1];
    // =========================== Option ===========================
    var parsedOptions = (0, $05553a78451953de$export$2e2bcd8739ae039)(options, children, mergedFieldNames, optionFilterProp, optionLabelProp);
    var valueOptions = parsedOptions.valueOptions, labelOptions = parsedOptions.labelOptions, mergedOptions = parsedOptions.options;
    // ========================= Wrap Value =========================
    var convert2LabelValues = $acw62.useCallback(function(draftValues) {
        // Convert to array
        var valueList = (0, $953a8baf84e85e44$export$45b10814cc054894)(draftValues);
        // Convert to labelInValue type
        return valueList.map(function(val) {
            var rawValue;
            var rawLabel;
            var rawKey;
            var rawDisabled;
            var rawTitle;
            // Fill label & value
            if ($89a6c2622fd5143d$var$isRawValue(val)) rawValue = val;
            else {
                var _val$value;
                rawKey = val.key;
                rawLabel = val.label;
                rawValue = (_val$value = val.value) !== null && _val$value !== void 0 ? _val$value : rawKey;
            }
            var option = valueOptions.get(rawValue);
            if (option) {
                var _option$key;
                // Fill missing props
                if (rawLabel === undefined) rawLabel = option === null || option === void 0 ? void 0 : option[optionLabelProp || mergedFieldNames.label];
                if (rawKey === undefined) rawKey = (_option$key = option === null || option === void 0 ? void 0 : option.key) !== null && _option$key !== void 0 ? _option$key : rawValue;
                rawDisabled = option === null || option === void 0 ? void 0 : option.disabled;
                rawTitle = option === null || option === void 0 ? void 0 : option.title;
                var optionLabel;
            }
            return {
                label: rawLabel,
                value: rawValue,
                key: rawKey,
                disabled: rawDisabled,
                title: rawTitle
            };
        });
    }, [
        mergedFieldNames,
        optionLabelProp,
        valueOptions
    ]);
    // =========================== Values ===========================
    var _useMergedState3 = (0, $iSQh8.default)(defaultValue, {
        value: value
    }), _useMergedState4 = (0, $eUqlC.default)(_useMergedState3, 2), internalValue = _useMergedState4[0], setInternalValue = _useMergedState4[1];
    // Merged value with LabelValueType
    var rawLabeledValues = $acw62.useMemo(function() {
        var _values$;
        var values = convert2LabelValues(internalValue);
        // combobox no need save value when it's no value (exclude value equal 0)
        if (mode === "combobox" && (0, $953a8baf84e85e44$export$9d186c3672bb89c6)((_values$ = values[0]) === null || _values$ === void 0 ? void 0 : _values$.value)) return [];
        return values;
    }, [
        internalValue,
        convert2LabelValues,
        mode
    ]);
    // Fill label with cache to avoid option remove
    var _useCache = (0, $91018b9a345d68e7$export$2e2bcd8739ae039)(rawLabeledValues, valueOptions), _useCache2 = (0, $eUqlC.default)(_useCache, 2), mergedValues = _useCache2[0], getMixedOption = _useCache2[1];
    var displayValues = $acw62.useMemo(function() {
        // `null` need show as placeholder instead
        // https://github.com/ant-design/ant-design/issues/25057
        if (!mode && mergedValues.length === 1) {
            var firstValue = mergedValues[0];
            if (firstValue.value === null && (firstValue.label === null || firstValue.label === undefined)) return [];
        }
        return mergedValues.map(function(item) {
            var _item$label;
            return (0, $d49SP.default)((0, $d49SP.default)({}, item), {}, {
                label: (_item$label = item.label) !== null && _item$label !== void 0 ? _item$label : item.value
            });
        });
    }, [
        mode,
        mergedValues
    ]);
    /** Convert `displayValues` to raw value type set */ var rawValues = $acw62.useMemo(function() {
        return new Set(mergedValues.map(function(val) {
            return val.value;
        }));
    }, [
        mergedValues
    ]);
    $acw62.useEffect(function() {
        if (mode === "combobox") {
            var _mergedValues$;
            var strValue = (_mergedValues$ = mergedValues[0]) === null || _mergedValues$ === void 0 ? void 0 : _mergedValues$.value;
            setSearchValue((0, $953a8baf84e85e44$export$96bdbc84526f3739)(strValue) ? String(strValue) : "");
        }
    }, [
        mergedValues
    ]);
    // ======================= Display Option =======================
    // Create a placeholder item if not exist in `options`
    var createTagOption = (0, $fb4ced1ec5128b6c$export$2e2bcd8739ae039)(function(val, label) {
        var _ref;
        var mergedLabel = label !== null && label !== void 0 ? label : val;
        return _ref = {}, (0, $kSlfw.default)(_ref, mergedFieldNames.value, val), (0, $kSlfw.default)(_ref, mergedFieldNames.label, mergedLabel), _ref;
    });
    // Fill tag as option if mode is `tags`
    var filledTagOptions = $acw62.useMemo(function() {
        if (mode !== "tags") return mergedOptions;
        // >>> Tag mode
        var cloneOptions = (0, $kbxxf.default)(mergedOptions);
        // Check if value exist in options (include new patch item)
        var existOptions = function existOptions(val) {
            return valueOptions.has(val);
        };
        // Fill current value as option
        (0, $kbxxf.default)(mergedValues).sort(function(a, b) {
            return a.value < b.value ? -1 : 1;
        }).forEach(function(item) {
            var val = item.value;
            if (!existOptions(val)) cloneOptions.push(createTagOption(val, item.label));
        });
        return cloneOptions;
    }, [
        createTagOption,
        mergedOptions,
        valueOptions,
        mergedValues,
        mode
    ]);
    var filteredOptions = (0, $47ef072d0f92ab84$export$2e2bcd8739ae039)(filledTagOptions, mergedFieldNames, mergedSearchValue, mergedFilterOption, optionFilterProp);
    // Fill options with search value if needed
    var filledSearchOptions = $acw62.useMemo(function() {
        if (mode !== "tags" || !mergedSearchValue || filteredOptions.some(function(item) {
            return item[optionFilterProp || "value"] === mergedSearchValue;
        })) return filteredOptions;
        // ignore when search value equal select input value
        if (filteredOptions.some(function(item) {
            return item[mergedFieldNames.value] === mergedSearchValue;
        })) return filteredOptions;
        // Fill search value as option
        return [
            createTagOption(mergedSearchValue)
        ].concat((0, $kbxxf.default)(filteredOptions));
    }, [
        createTagOption,
        optionFilterProp,
        mode,
        filteredOptions,
        mergedSearchValue,
        mergedFieldNames
    ]);
    var orderedFilteredOptions = $acw62.useMemo(function() {
        if (!filterSort) return filledSearchOptions;
        return (0, $kbxxf.default)(filledSearchOptions).sort(function(a, b) {
            return filterSort(a, b);
        });
    }, [
        filledSearchOptions,
        filterSort
    ]);
    var displayOptions = $acw62.useMemo(function() {
        return (0, $67e3f69030e63308$export$7baa7c13b358b002)(orderedFilteredOptions, {
            fieldNames: mergedFieldNames,
            childrenAsData: childrenAsData
        });
    }, [
        orderedFilteredOptions,
        mergedFieldNames,
        childrenAsData
    ]);
    // =========================== Change ===========================
    var triggerChange = function triggerChange(values) {
        var labeledValues = convert2LabelValues(values);
        setInternalValue(labeledValues);
        if (onChange && // Trigger event only when value changed
        (labeledValues.length !== mergedValues.length || labeledValues.some(function(newVal, index) {
            var _mergedValues$index;
            return ((_mergedValues$index = mergedValues[index]) === null || _mergedValues$index === void 0 ? void 0 : _mergedValues$index.value) !== (newVal === null || newVal === void 0 ? void 0 : newVal.value);
        }))) {
            var returnValues = labelInValue ? labeledValues : labeledValues.map(function(v) {
                return v.value;
            });
            var returnOptions = labeledValues.map(function(v) {
                return (0, $67e3f69030e63308$export$d0b21b213c8c013c)(getMixedOption(v.value));
            });
            onChange(// Value
            multiple ? returnValues : returnValues[0], // Option
            multiple ? returnOptions : returnOptions[0]);
        }
    };
    // ======================= Accessibility ========================
    var _React$useState = $acw62.useState(null), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), activeValue = _React$useState2[0], setActiveValue = _React$useState2[1];
    var _React$useState3 = $acw62.useState(0), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), accessibilityIndex = _React$useState4[0], setAccessibilityIndex = _React$useState4[1];
    var mergedDefaultActiveFirstOption = defaultActiveFirstOption !== undefined ? defaultActiveFirstOption : mode !== "combobox";
    var onActiveValue = $acw62.useCallback(function(active, index) {
        var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref2$source = _ref2.source, source = _ref2$source === void 0 ? "keyboard" : _ref2$source;
        setAccessibilityIndex(index);
        if (backfill && mode === "combobox" && active !== null && source === "keyboard") setActiveValue(String(active));
    }, [
        backfill,
        mode
    ]);
    // ========================= OptionList =========================
    var triggerSelect = function triggerSelect(val, selected, type) {
        var getSelectEnt = function getSelectEnt() {
            var _option$key2;
            var option = getMixedOption(val);
            return [
                labelInValue ? {
                    label: option === null || option === void 0 ? void 0 : option[mergedFieldNames.label],
                    value: val,
                    key: (_option$key2 = option === null || option === void 0 ? void 0 : option.key) !== null && _option$key2 !== void 0 ? _option$key2 : val
                } : val,
                (0, $67e3f69030e63308$export$d0b21b213c8c013c)(option)
            ];
        };
        if (selected && onSelect) {
            var _getSelectEnt = getSelectEnt(), _getSelectEnt2 = (0, $eUqlC.default)(_getSelectEnt, 2), wrappedValue = _getSelectEnt2[0], _option = _getSelectEnt2[1];
            onSelect(wrappedValue, _option);
        } else if (!selected && onDeselect && type !== "clear") {
            var _getSelectEnt3 = getSelectEnt(), _getSelectEnt4 = (0, $eUqlC.default)(_getSelectEnt3, 2), _wrappedValue = _getSelectEnt4[0], _option2 = _getSelectEnt4[1];
            onDeselect(_wrappedValue, _option2);
        }
    };
    // Used for OptionList selection
    var onInternalSelect = (0, $fb4ced1ec5128b6c$export$2e2bcd8739ae039)(function(val, info) {
        var cloneValues;
        // Single mode always trigger select only with option list
        var mergedSelect = multiple ? info.selected : true;
        if (mergedSelect) cloneValues = multiple ? [].concat((0, $kbxxf.default)(mergedValues), [
            val
        ]) : [
            val
        ];
        else cloneValues = mergedValues.filter(function(v) {
            return v.value !== val;
        });
        triggerChange(cloneValues);
        triggerSelect(val, mergedSelect);
        // Clean search value if single or configured
        if (mode === "combobox") // setSearchValue(String(val));
        setActiveValue("");
        else if (!(0, $2dc4538d56993d0c$export$7f654ad2a77ad2ac) || autoClearSearchValue) {
            setSearchValue("");
            setActiveValue("");
        }
    });
    // ======================= Display Change =======================
    // BaseSelect display values change
    var onDisplayValuesChange = function onDisplayValuesChange(nextValues, info) {
        triggerChange(nextValues);
        var type = info.type, values = info.values;
        if (type === "remove" || type === "clear") values.forEach(function(item) {
            triggerSelect(item.value, false, type);
        });
    };
    // =========================== Search ===========================
    var onInternalSearch = function onInternalSearch(searchText, info) {
        setSearchValue(searchText);
        setActiveValue(null);
        // [Submit] Tag mode should flush input
        if (info.source === "submit") {
            var formatted = (searchText || "").trim();
            // prevent empty tags from appearing when you click the Enter button
            if (formatted) {
                var newRawValues = Array.from(new Set([].concat((0, $kbxxf.default)(rawValues), [
                    formatted
                ])));
                triggerChange(newRawValues);
                triggerSelect(formatted, true);
                setSearchValue("");
            }
            return;
        }
        if (info.source !== "blur") {
            if (mode === "combobox") triggerChange(searchText);
            onSearch === null || onSearch === void 0 || onSearch(searchText);
        }
    };
    var onInternalSearchSplit = function onInternalSearchSplit(words) {
        var patchValues = words;
        if (mode !== "tags") patchValues = words.map(function(word) {
            var opt = labelOptions.get(word);
            return opt === null || opt === void 0 ? void 0 : opt.value;
        }).filter(function(val) {
            return val !== undefined;
        });
        var newRawValues = Array.from(new Set([].concat((0, $kbxxf.default)(rawValues), (0, $kbxxf.default)(patchValues))));
        triggerChange(newRawValues);
        newRawValues.forEach(function(newRawValue) {
            triggerSelect(newRawValue, true);
        });
    };
    // ========================== Context ===========================
    var selectContext = $acw62.useMemo(function() {
        var realVirtual = virtual !== false && dropdownMatchSelectWidth !== false;
        return (0, $d49SP.default)((0, $d49SP.default)({}, parsedOptions), {}, {
            flattenOptions: displayOptions,
            onActiveValue: onActiveValue,
            defaultActiveFirstOption: mergedDefaultActiveFirstOption,
            onSelect: onInternalSelect,
            menuItemSelectedIcon: menuItemSelectedIcon,
            rawValues: rawValues,
            fieldNames: mergedFieldNames,
            virtual: realVirtual,
            direction: direction,
            listHeight: listHeight,
            listItemHeight: listItemHeight,
            childrenAsData: childrenAsData,
            optionRender: optionRender
        });
    }, [
        parsedOptions,
        displayOptions,
        onActiveValue,
        mergedDefaultActiveFirstOption,
        onInternalSelect,
        menuItemSelectedIcon,
        rawValues,
        mergedFieldNames,
        virtual,
        dropdownMatchSelectWidth,
        listHeight,
        listItemHeight,
        childrenAsData,
        optionRender
    ]);
    // ==============================================================
    // ==                          Render                          ==
    // ==============================================================
    return /*#__PURE__*/ $acw62.createElement((0, $44daf1c3d5d48cca$export$2e2bcd8739ae039).Provider, {
        value: selectContext
    }, /*#__PURE__*/ $acw62.createElement((0, $2dc4538d56993d0c$export$2e2bcd8739ae039), (0, $8nd05.default)({}, restProps, {
        // >>> MISC
        id: mergedId,
        prefixCls: prefixCls,
        ref: ref,
        omitDomProps: $89a6c2622fd5143d$var$OMIT_DOM_PROPS,
        mode: mode,
        displayValues: displayValues,
        onDisplayValuesChange: onDisplayValuesChange,
        direction: direction,
        searchValue: mergedSearchValue,
        onSearch: onInternalSearch,
        autoClearSearchValue: autoClearSearchValue,
        onSearchSplit: onInternalSearchSplit,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth,
        OptionList: (0, $4a507f608f30c004$export$2e2bcd8739ae039),
        emptyOptions: !displayOptions.length,
        activeValue: activeValue,
        activeDescendantId: "".concat(mergedId, "_list_").concat(accessibilityIndex)
    })));
});
var $89a6c2622fd5143d$var$TypedSelect = $89a6c2622fd5143d$var$Select;
$89a6c2622fd5143d$var$TypedSelect.Option = (0, $2f79e5076b69401d$export$2e2bcd8739ae039);
$89a6c2622fd5143d$var$TypedSelect.OptGroup = (0, $cb22e94bdb4eaaa5$export$2e2bcd8739ae039);
var $89a6c2622fd5143d$export$2e2bcd8739ae039 = $89a6c2622fd5143d$var$TypedSelect;






var $65dbbed9df0fecca$export$2e2bcd8739ae039 = (0, $89a6c2622fd5143d$export$2e2bcd8739ae039);



var $1pcHX = parcelRequire("1pcHX");

var $brFSt = parcelRequire("brFSt");

var $4257x = parcelRequire("4257x");


var $8Vr1S = parcelRequire("8Vr1S");

parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $acw62 = parcelRequire("acw62");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $0G7XT = parcelRequire("0G7XT");

var $9nbKF = parcelRequire("9nbKF");

var $acw62 = parcelRequire("acw62");

var $hRCaH = parcelRequire("hRCaH");
"use client";
const $148bd952cb1a5a76$var$Empty = ()=>{
    const [, token] = (0, $hRCaH.default)();
    const bgColor = new (0, $9nbKF.TinyColor)(token.colorBgBase);
    // Dark Theme need more dark of this
    const themeStyle = bgColor.toHsl().l < 0.5 ? {
        opacity: 0.65
    } : {};
    return /*#__PURE__*/ $acw62.createElement("svg", {
        style: themeStyle,
        width: "184",
        height: "152",
        viewBox: "0 0 184 152",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $acw62.createElement("g", {
        transform: "translate(24 31.67)"
    }, /*#__PURE__*/ $acw62.createElement("ellipse", {
        fillOpacity: ".8",
        fill: "#F5F5F7",
        cx: "67.797",
        cy: "106.89",
        rx: "67.797",
        ry: "12.668"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
        fill: "#AEB8C2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
        fill: "url(#linearGradient-1)",
        transform: "translate(13.56)"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
        fill: "#F5F5F7"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
        fill: "#DCE0E6"
    })), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
        fill: "#DCE0E6"
    }), /*#__PURE__*/ $acw62.createElement("g", {
        transform: "translate(149.65 15.383)",
        fill: "#FFF"
    }, /*#__PURE__*/ $acw62.createElement("ellipse", {
        cx: "20.654",
        cy: "3.167",
        rx: "2.849",
        ry: "2.815"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
    }))));
};
var $148bd952cb1a5a76$export$2e2bcd8739ae039 = $148bd952cb1a5a76$var$Empty;



var $9nbKF = parcelRequire("9nbKF");

var $acw62 = parcelRequire("acw62");

var $hRCaH = parcelRequire("hRCaH");
"use client";
const $ae7f97f0fd68830c$var$Simple = ()=>{
    const [, token] = (0, $hRCaH.default)();
    const { colorFill: colorFill, colorFillTertiary: colorFillTertiary, colorFillQuaternary: colorFillQuaternary, colorBgContainer: colorBgContainer } = token;
    const { borderColor: borderColor, shadowColor: shadowColor, contentColor: contentColor } = (0, $acw62.useMemo)(()=>({
            borderColor: new (0, $9nbKF.TinyColor)(colorFill).onBackground(colorBgContainer).toHexShortString(),
            shadowColor: new (0, $9nbKF.TinyColor)(colorFillTertiary).onBackground(colorBgContainer).toHexShortString(),
            contentColor: new (0, $9nbKF.TinyColor)(colorFillQuaternary).onBackground(colorBgContainer).toHexShortString()
        }), [
        colorFill,
        colorFillTertiary,
        colorFillQuaternary,
        colorBgContainer
    ]);
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: "64",
        height: "41",
        viewBox: "0 0 64 41",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("g", {
        transform: "translate(0 1)",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $acw62.createElement("ellipse", {
        fill: shadowColor,
        cx: "32",
        cy: "33",
        rx: "32",
        ry: "7"
    }), /*#__PURE__*/ $acw62.createElement("g", {
        fillRule: "nonzero",
        stroke: borderColor
    }, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
        fill: contentColor
    }))));
};
var $ae7f97f0fd68830c$export$2e2bcd8739ae039 = $ae7f97f0fd68830c$var$Simple;



var $P8Drj = parcelRequire("P8Drj");
var $2LRCS = parcelRequire("2LRCS");
// ============================== Shared ==============================
const $ee15fc052b6837a1$var$genSharedEmptyStyle = (token)=>{
    const { componentCls: componentCls, margin: margin, marginXS: marginXS, marginXL: marginXL, fontSize: fontSize, lineHeight: lineHeight } = token;
    return {
        [componentCls]: {
            marginInline: marginXS,
            fontSize: fontSize,
            lineHeight: lineHeight,
            textAlign: "center",
            // 原来 &-image 没有父子结构，现在为了外层承担我们的hashId，改成父子结果
            [`${componentCls}-image`]: {
                height: token.emptyImgHeight,
                marginBottom: marginXS,
                opacity: token.opacityImage,
                img: {
                    height: "100%"
                },
                svg: {
                    maxWidth: "100%",
                    height: "100%",
                    margin: "auto"
                }
            },
            [`${componentCls}-description`]: {
                color: token.colorText
            },
            // 原来 &-footer 没有父子结构，现在为了外层承担我们的hashId，改成父子结果
            [`${componentCls}-footer`]: {
                marginTop: margin
            },
            "&-normal": {
                marginBlock: marginXL,
                color: token.colorTextDisabled,
                [`${componentCls}-description`]: {
                    color: token.colorTextDisabled
                },
                [`${componentCls}-image`]: {
                    height: token.emptyImgHeightMD
                }
            },
            "&-small": {
                marginBlock: marginXS,
                color: token.colorTextDisabled,
                [`${componentCls}-image`]: {
                    height: token.emptyImgHeightSM
                }
            }
        }
    };
};
var // ============================== Export ==============================
$ee15fc052b6837a1$export$2e2bcd8739ae039 = (0, $P8Drj.genStyleHooks)("Empty", (token)=>{
    const { componentCls: componentCls, controlHeightLG: controlHeightLG, calc: calc } = token;
    const emptyToken = (0, $2LRCS.merge)(token, {
        emptyImgCls: `${componentCls}-img`,
        emptyImgHeight: calc(controlHeightLG).mul(2.5).equal(),
        emptyImgHeightMD: controlHeightLG,
        emptyImgHeightSM: calc(controlHeightLG).mul(0.875).equal()
    });
    return [
        $ee15fc052b6837a1$var$genSharedEmptyStyle(emptyToken)
    ];
});


"use client";
var $ec66348328372da5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ec66348328372da5$var$defaultEmptyImg = /*#__PURE__*/ $acw62.createElement((0, $148bd952cb1a5a76$export$2e2bcd8739ae039), null);
const $ec66348328372da5$var$simpleEmptyImg = /*#__PURE__*/ $acw62.createElement((0, $ae7f97f0fd68830c$export$2e2bcd8739ae039), null);
const $ec66348328372da5$var$Empty = (_a)=>{
    var { className: className, rootClassName: rootClassName, prefixCls: customizePrefixCls, image: image = $ec66348328372da5$var$defaultEmptyImg, description: description, children: children, imageStyle: imageStyle, style: style } = _a, restProps = $ec66348328372da5$var$__rest(_a, [
        "className",
        "rootClassName",
        "prefixCls",
        "image",
        "description",
        "children",
        "imageStyle",
        "style"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, empty: empty } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const prefixCls = getPrefixCls("empty", customizePrefixCls);
    const [wrapCSSVar, hashId] = (0, $ee15fc052b6837a1$export$2e2bcd8739ae039)(prefixCls);
    const [locale] = (0, $0G7XT.default)("Empty");
    const des = typeof description !== "undefined" ? description : locale === null || locale === void 0 ? void 0 : locale.description;
    const alt = typeof des === "string" ? des : "empty";
    let imageNode = null;
    if (typeof image === "string") imageNode = /*#__PURE__*/ $acw62.createElement("img", {
        alt: alt,
        src: image
    });
    else imageNode = image;
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(hashId, prefixCls, empty === null || empty === void 0 ? void 0 : empty.className, {
            [`${prefixCls}-normal`]: image === $ec66348328372da5$var$simpleEmptyImg,
            [`${prefixCls}-rtl`]: direction === "rtl"
        }, className, rootClassName),
        style: Object.assign(Object.assign({}, empty === null || empty === void 0 ? void 0 : empty.style), style)
    }, restProps), /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-image`,
        style: imageStyle
    }, imageNode), des && /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-description`
    }, des), children && /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-footer`
    }, children)));
};
$ec66348328372da5$var$Empty.PRESENTED_IMAGE_DEFAULT = $ec66348328372da5$var$defaultEmptyImg;
$ec66348328372da5$var$Empty.PRESENTED_IMAGE_SIMPLE = $ec66348328372da5$var$simpleEmptyImg;
var $ec66348328372da5$export$2e2bcd8739ae039 = $ec66348328372da5$var$Empty;


"use client";
const $3feb83783705e448$var$DefaultRenderEmpty = (props)=>{
    const { componentName: componentName } = props;
    const { getPrefixCls: getPrefixCls } = (0, $acw62.useContext)((0, $dRTnM.ConfigContext));
    const prefix = getPrefixCls("empty");
    switch(componentName){
        case "Table":
        case "List":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ec66348328372da5$export$2e2bcd8739ae039), {
                image: (0, $ec66348328372da5$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE
            });
        case "Select":
        case "TreeSelect":
        case "Cascader":
        case "Transfer":
        case "Mentions":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ec66348328372da5$export$2e2bcd8739ae039), {
                image: (0, $ec66348328372da5$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                className: `${prefix}-small`
            });
        /* istanbul ignore next */ default:
            // Should never hit if we take all the component into consider.
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ec66348328372da5$export$2e2bcd8739ae039), null);
    }
};
var $3feb83783705e448$export$2e2bcd8739ae039 = $3feb83783705e448$var$DefaultRenderEmpty;



var $9f1hj = parcelRequire("9f1hj");

var $IFe7R = parcelRequire("IFe7R");

var $eSOz6 = parcelRequire("eSOz6");

var $3gns8 = parcelRequire("3gns8");
parcelRequire("3i86m");
var $lpQ06 = parcelRequire("lpQ06");

var $670jt = parcelRequire("670jt");

var $1g5Jl = parcelRequire("1g5Jl");

var $P8Drj = parcelRequire("P8Drj");
var $2LRCS = parcelRequire("2LRCS");

var $670jt = parcelRequire("670jt");
parcelRequire("3i86m");
var $hsEk2 = parcelRequire("hsEk2");

var $gvSPY = parcelRequire("gvSPY");
const $103c380d878d9852$export$c81b62e088da1305 = new (0, $hsEk2.default)("antMoveDownIn", {
    "0%": {
        transform: "translate3d(0, 100%, 0)",
        transformOrigin: "0 0",
        opacity: 0
    },
    "100%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    }
});
const $103c380d878d9852$export$6c1eca72ac4f6672 = new (0, $hsEk2.default)("antMoveDownOut", {
    "0%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    },
    "100%": {
        transform: "translate3d(0, 100%, 0)",
        transformOrigin: "0 0",
        opacity: 0
    }
});
const $103c380d878d9852$export$8dd54688d033571 = new (0, $hsEk2.default)("antMoveLeftIn", {
    "0%": {
        transform: "translate3d(-100%, 0, 0)",
        transformOrigin: "0 0",
        opacity: 0
    },
    "100%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    }
});
const $103c380d878d9852$export$be161c4e647bea9b = new (0, $hsEk2.default)("antMoveLeftOut", {
    "0%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    },
    "100%": {
        transform: "translate3d(-100%, 0, 0)",
        transformOrigin: "0 0",
        opacity: 0
    }
});
const $103c380d878d9852$export$a984c43131c7d145 = new (0, $hsEk2.default)("antMoveRightIn", {
    "0%": {
        transform: "translate3d(100%, 0, 0)",
        transformOrigin: "0 0",
        opacity: 0
    },
    "100%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    }
});
const $103c380d878d9852$export$e141ac6798b476df = new (0, $hsEk2.default)("antMoveRightOut", {
    "0%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    },
    "100%": {
        transform: "translate3d(100%, 0, 0)",
        transformOrigin: "0 0",
        opacity: 0
    }
});
const $103c380d878d9852$export$ab676201eaaca05 = new (0, $hsEk2.default)("antMoveUpIn", {
    "0%": {
        transform: "translate3d(0, -100%, 0)",
        transformOrigin: "0 0",
        opacity: 0
    },
    "100%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    }
});
const $103c380d878d9852$export$ec1b91b8ec2f6331 = new (0, $hsEk2.default)("antMoveUpOut", {
    "0%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    },
    "100%": {
        transform: "translate3d(0, -100%, 0)",
        transformOrigin: "0 0",
        opacity: 0
    }
});
const $103c380d878d9852$var$moveMotion = {
    "move-up": {
        inKeyframes: $103c380d878d9852$export$ab676201eaaca05,
        outKeyframes: $103c380d878d9852$export$ec1b91b8ec2f6331
    },
    "move-down": {
        inKeyframes: $103c380d878d9852$export$c81b62e088da1305,
        outKeyframes: $103c380d878d9852$export$6c1eca72ac4f6672
    },
    "move-left": {
        inKeyframes: $103c380d878d9852$export$8dd54688d033571,
        outKeyframes: $103c380d878d9852$export$be161c4e647bea9b
    },
    "move-right": {
        inKeyframes: $103c380d878d9852$export$a984c43131c7d145,
        outKeyframes: $103c380d878d9852$export$e141ac6798b476df
    }
};
const $103c380d878d9852$export$913b1b7e3288c319 = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $103c380d878d9852$var$moveMotion[motionName];
    return [
        (0, $gvSPY.initMotion)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};


var $llQv4 = parcelRequire("llQv4");
"use client";
const $879d950d114a8bdf$var$genItemStyle = (token)=>{
    const { optionHeight: optionHeight, optionFontSize: optionFontSize, optionLineHeight: optionLineHeight, optionPadding: optionPadding } = token;
    return {
        position: "relative",
        display: "block",
        minHeight: optionHeight,
        padding: optionPadding,
        color: token.colorText,
        fontWeight: "normal",
        fontSize: optionFontSize,
        lineHeight: optionLineHeight,
        boxSizing: "border-box"
    };
};
const $879d950d114a8bdf$var$genSingleStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls } = token;
    const selectItemCls = `${componentCls}-item`;
    const slideUpEnterActive = `&${antCls}-slide-up-enter${antCls}-slide-up-enter-active`;
    const slideUpAppearActive = `&${antCls}-slide-up-appear${antCls}-slide-up-appear-active`;
    const slideUpLeaveActive = `&${antCls}-slide-up-leave${antCls}-slide-up-leave-active`;
    const dropdownPlacementCls = `${componentCls}-dropdown-placement-`;
    return [
        {
            [`${componentCls}-dropdown`]: Object.assign(Object.assign({}, (0, $670jt.resetComponent)(token)), {
                position: "absolute",
                top: -9999,
                zIndex: token.zIndexPopup,
                boxSizing: "border-box",
                padding: token.paddingXXS,
                overflow: "hidden",
                fontSize: token.fontSize,
                // Fix select render lag of long text in chrome
                // https://github.com/ant-design/ant-design/issues/11456
                // https://github.com/ant-design/ant-design/issues/11843
                fontVariant: "initial",
                backgroundColor: token.colorBgElevated,
                borderRadius: token.borderRadiusLG,
                outline: "none",
                boxShadow: token.boxShadowSecondary,
                [`
          ${slideUpEnterActive}${dropdownPlacementCls}bottomLeft,
          ${slideUpAppearActive}${dropdownPlacementCls}bottomLeft
        `]: {
                    animationName: (0, $llQv4.slideUpIn)
                },
                [`
          ${slideUpEnterActive}${dropdownPlacementCls}topLeft,
          ${slideUpAppearActive}${dropdownPlacementCls}topLeft,
          ${slideUpEnterActive}${dropdownPlacementCls}topRight,
          ${slideUpAppearActive}${dropdownPlacementCls}topRight
        `]: {
                    animationName: (0, $llQv4.slideDownIn)
                },
                [`${slideUpLeaveActive}${dropdownPlacementCls}bottomLeft`]: {
                    animationName: (0, $llQv4.slideUpOut)
                },
                [`
          ${slideUpLeaveActive}${dropdownPlacementCls}topLeft,
          ${slideUpLeaveActive}${dropdownPlacementCls}topRight
        `]: {
                    animationName: (0, $llQv4.slideDownOut)
                },
                "&-hidden": {
                    display: "none"
                },
                [`${selectItemCls}`]: Object.assign(Object.assign({}, $879d950d114a8bdf$var$genItemStyle(token)), {
                    cursor: "pointer",
                    transition: `background ${token.motionDurationSlow} ease`,
                    borderRadius: token.borderRadiusSM,
                    // =========== Group ============
                    "&-group": {
                        color: token.colorTextDescription,
                        fontSize: token.fontSizeSM,
                        cursor: "default"
                    },
                    // =========== Option ===========
                    "&-option": {
                        display: "flex",
                        "&-content": Object.assign({
                            flex: "auto"
                        }, (0, $670jt.textEllipsis)),
                        "&-state": {
                            flex: "none",
                            display: "flex",
                            alignItems: "center"
                        },
                        [`&-active:not(${selectItemCls}-option-disabled)`]: {
                            backgroundColor: token.optionActiveBg
                        },
                        [`&-selected:not(${selectItemCls}-option-disabled)`]: {
                            color: token.optionSelectedColor,
                            fontWeight: token.optionSelectedFontWeight,
                            backgroundColor: token.optionSelectedBg,
                            [`${selectItemCls}-option-state`]: {
                                color: token.colorPrimary
                            }
                        },
                        "&-disabled": {
                            [`&${selectItemCls}-option-selected`]: {
                                backgroundColor: token.colorBgContainerDisabled
                            },
                            color: token.colorTextDisabled,
                            cursor: "not-allowed"
                        },
                        "&-grouped": {
                            paddingInlineStart: token.calc(token.controlPaddingHorizontal).mul(2).equal()
                        }
                    }
                }),
                // =========================== RTL ===========================
                "&-rtl": {
                    direction: "rtl"
                }
            })
        },
        // Follow code may reuse in other components
        (0, $llQv4.initSlideMotion)(token, "slide-up"),
        (0, $llQv4.initSlideMotion)(token, "slide-down"),
        (0, $103c380d878d9852$export$913b1b7e3288c319)(token, "move-up"),
        (0, $103c380d878d9852$export$913b1b7e3288c319)(token, "move-down")
    ];
};
var $879d950d114a8bdf$export$2e2bcd8739ae039 = $879d950d114a8bdf$var$genSingleStyle;



var $670jt = parcelRequire("670jt");

var $2LRCS = parcelRequire("2LRCS");
parcelRequire("3i86m");
var $lpQ06 = parcelRequire("lpQ06");
"use client";
const $4da12f0c4f4b3a28$var$FIXED_ITEM_MARGIN = 2;
const $4da12f0c4f4b3a28$var$getSelectItemStyle = (token)=>{
    const { multipleSelectItemHeight: multipleSelectItemHeight, selectHeight: selectHeight, lineWidth: lineWidth } = token;
    const selectItemDist = token.calc(selectHeight).sub(multipleSelectItemHeight).div(2).sub(lineWidth).equal();
    return selectItemDist;
};
function $4da12f0c4f4b3a28$var$genSizeStyle(token, suffix) {
    const { componentCls: componentCls, iconCls: iconCls } = token;
    const selectOverflowPrefixCls = `${componentCls}-selection-overflow`;
    const selectItemHeight = token.multipleSelectItemHeight;
    const selectItemDist = $4da12f0c4f4b3a28$var$getSelectItemStyle(token);
    const suffixCls = suffix ? `${componentCls}-${suffix}` : "";
    return {
        [`${componentCls}-multiple${suffixCls}`]: {
            fontSize: token.fontSize,
            /**
       * Do not merge `height` & `line-height` under style with `selection` & `search`, since chrome
       * may update to redesign with its align logic.
       */ // =========================== Overflow ===========================
            [selectOverflowPrefixCls]: {
                position: "relative",
                display: "flex",
                flex: "auto",
                flexWrap: "wrap",
                maxWidth: "100%",
                "&-item": {
                    flex: "none",
                    alignSelf: "center",
                    maxWidth: "100%",
                    display: "inline-flex"
                }
            },
            // ========================= Selector =========================
            [`${componentCls}-selector`]: {
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                height: "100%",
                // Multiple is little different that horizontal is follow the vertical
                padding: `${(0, $lpQ06.unit)(token.calc(selectItemDist).sub($4da12f0c4f4b3a28$var$FIXED_ITEM_MARGIN).equal())} ${(0, $lpQ06.unit)(token.calc($4da12f0c4f4b3a28$var$FIXED_ITEM_MARGIN).mul(2).equal())}`,
                borderRadius: token.borderRadius,
                [`${componentCls}-show-search&`]: {
                    cursor: "text"
                },
                [`${componentCls}-disabled&`]: {
                    background: token.multipleSelectorBgDisabled,
                    cursor: "not-allowed"
                },
                "&:after": {
                    display: "inline-block",
                    width: 0,
                    margin: `${(0, $lpQ06.unit)($4da12f0c4f4b3a28$var$FIXED_ITEM_MARGIN)} 0`,
                    lineHeight: (0, $lpQ06.unit)(selectItemHeight),
                    visibility: "hidden",
                    content: '"\\a0"'
                }
            },
            [`
        &${componentCls}-show-arrow ${componentCls}-selector,
        &${componentCls}-allow-clear ${componentCls}-selector
      `]: {
                paddingInlineEnd: token.calc(token.fontSizeIcon).add(token.controlPaddingHorizontal).equal()
            },
            // ======================== Selections ========================
            [`${componentCls}-selection-item`]: {
                display: "flex",
                alignSelf: "center",
                flex: "none",
                boxSizing: "border-box",
                maxWidth: "100%",
                height: selectItemHeight,
                marginTop: $4da12f0c4f4b3a28$var$FIXED_ITEM_MARGIN,
                marginBottom: $4da12f0c4f4b3a28$var$FIXED_ITEM_MARGIN,
                lineHeight: (0, $lpQ06.unit)(token.calc(selectItemHeight).sub(token.calc(token.lineWidth).mul(2)).equal()),
                background: token.multipleItemBg,
                border: `${(0, $lpQ06.unit)(token.lineWidth)} ${token.lineType} ${token.multipleItemBorderColor}`,
                borderRadius: token.borderRadiusSM,
                cursor: "default",
                transition: `font-size ${token.motionDurationSlow}, line-height ${token.motionDurationSlow}, height ${token.motionDurationSlow}`,
                marginInlineEnd: token.calc($4da12f0c4f4b3a28$var$FIXED_ITEM_MARGIN).mul(2).equal(),
                paddingInlineStart: token.paddingXS,
                paddingInlineEnd: token.calc(token.paddingXS).div(2).equal(),
                [`${componentCls}-disabled&`]: {
                    color: token.multipleItemColorDisabled,
                    borderColor: token.multipleItemBorderColorDisabled,
                    cursor: "not-allowed"
                },
                // It's ok not to do this, but 24px makes bottom narrow in view should adjust
                "&-content": {
                    display: "inline-block",
                    marginInlineEnd: token.calc(token.paddingXS).div(2).equal(),
                    overflow: "hidden",
                    whiteSpace: "pre",
                    // fix whitespace wrapping. custom tags display all whitespace within.
                    textOverflow: "ellipsis"
                },
                "&-remove": Object.assign(Object.assign({}, (0, $670jt.resetIcon)()), {
                    display: "inline-flex",
                    alignItems: "center",
                    color: token.colorIcon,
                    fontWeight: "bold",
                    fontSize: 10,
                    lineHeight: "inherit",
                    cursor: "pointer",
                    [`> ${iconCls}`]: {
                        verticalAlign: "-0.2em"
                    },
                    "&:hover": {
                        color: token.colorIconHover
                    }
                })
            },
            // ========================== Input ==========================
            [`${selectOverflowPrefixCls}-item + ${selectOverflowPrefixCls}-item`]: {
                [`${componentCls}-selection-search`]: {
                    marginInlineStart: 0
                }
            },
            // https://github.com/ant-design/ant-design/issues/44754
            [`${selectOverflowPrefixCls}-item-suffix`]: {
                height: "100%"
            },
            [`${componentCls}-selection-search`]: {
                display: "inline-flex",
                position: "relative",
                maxWidth: "100%",
                marginInlineStart: token.calc(token.inputPaddingHorizontalBase).sub(selectItemDist).equal(),
                [`
          &-input,
          &-mirror
        `]: {
                    height: selectItemHeight,
                    fontFamily: token.fontFamily,
                    lineHeight: (0, $lpQ06.unit)(selectItemHeight),
                    transition: `all ${token.motionDurationSlow}`
                },
                "&-input": {
                    width: "100%",
                    minWidth: 4.1 // fix search cursor missing
                },
                "&-mirror": {
                    position: "absolute",
                    top: 0,
                    insetInlineStart: 0,
                    insetInlineEnd: "auto",
                    zIndex: 999,
                    whiteSpace: "pre",
                    // fix whitespace wrapping caused width calculation bug
                    visibility: "hidden"
                }
            },
            // ======================= Placeholder =======================
            [`${componentCls}-selection-placeholder`]: {
                position: "absolute",
                top: "50%",
                insetInlineStart: token.inputPaddingHorizontalBase,
                insetInlineEnd: token.inputPaddingHorizontalBase,
                transform: "translateY(-50%)",
                transition: `all ${token.motionDurationSlow}`
            }
        }
    };
}
const $4da12f0c4f4b3a28$var$genMultipleStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const smallToken = (0, $2LRCS.merge)(token, {
        selectHeight: token.controlHeightSM,
        multipleSelectItemHeight: token.controlHeightXS,
        borderRadius: token.borderRadiusSM,
        borderRadiusSM: token.borderRadiusXS
    });
    const largeToken = (0, $2LRCS.merge)(token, {
        fontSize: token.fontSizeLG,
        selectHeight: token.controlHeightLG,
        multipleSelectItemHeight: token.multipleItemHeightLG,
        borderRadius: token.borderRadiusLG,
        borderRadiusSM: token.borderRadius
    });
    return [
        $4da12f0c4f4b3a28$var$genSizeStyle(token),
        // ======================== Small ========================
        $4da12f0c4f4b3a28$var$genSizeStyle(smallToken, "sm"),
        // Padding
        {
            [`${componentCls}-multiple${componentCls}-sm`]: {
                [`${componentCls}-selection-placeholder`]: {
                    insetInline: token.calc(token.controlPaddingHorizontalSM).sub(token.lineWidth).equal()
                },
                // https://github.com/ant-design/ant-design/issues/29559
                [`${componentCls}-selection-search`]: {
                    marginInlineStart: 2 // Magic Number
                }
            }
        },
        // ======================== Large ========================
        $4da12f0c4f4b3a28$var$genSizeStyle(largeToken, "lg")
    ];
};
var $4da12f0c4f4b3a28$export$2e2bcd8739ae039 = $4da12f0c4f4b3a28$var$genMultipleStyle;



var $670jt = parcelRequire("670jt");

var $2LRCS = parcelRequire("2LRCS");
parcelRequire("3i86m");
var $lpQ06 = parcelRequire("lpQ06");
"use client";
function $143140f2aef1b4ae$var$genSizeStyle(token, suffix) {
    const { componentCls: componentCls, inputPaddingHorizontalBase: inputPaddingHorizontalBase, borderRadius: borderRadius } = token;
    const selectHeightWithoutBorder = token.calc(token.controlHeight).sub(token.calc(token.lineWidth).mul(2)).equal();
    const suffixCls = suffix ? `${componentCls}-${suffix}` : "";
    return {
        [`${componentCls}-single${suffixCls}`]: {
            fontSize: token.fontSize,
            height: token.controlHeight,
            // ========================= Selector =========================
            [`${componentCls}-selector`]: Object.assign(Object.assign({}, (0, $670jt.resetComponent)(token, true)), {
                display: "flex",
                borderRadius: borderRadius,
                [`${componentCls}-selection-search`]: {
                    position: "absolute",
                    top: 0,
                    insetInlineStart: inputPaddingHorizontalBase,
                    insetInlineEnd: inputPaddingHorizontalBase,
                    bottom: 0,
                    "&-input": {
                        width: "100%",
                        WebkitAppearance: "textfield"
                    }
                },
                [`
          ${componentCls}-selection-item,
          ${componentCls}-selection-placeholder
        `]: {
                    padding: 0,
                    lineHeight: (0, $lpQ06.unit)(selectHeightWithoutBorder),
                    transition: `all ${token.motionDurationSlow}, visibility 0s`,
                    alignSelf: "center"
                },
                [`${componentCls}-selection-placeholder`]: {
                    transition: "none",
                    pointerEvents: "none"
                },
                // For common baseline align
                [[
                    "&:after",
                    /* For '' value baseline align */ `${componentCls}-selection-item:empty:after`,
                    /* For undefined value baseline align */ `${componentCls}-selection-placeholder:empty:after`
                ].join(",")]: {
                    display: "inline-block",
                    width: 0,
                    visibility: "hidden",
                    content: '"\\a0"'
                }
            }),
            [`
        &${componentCls}-show-arrow ${componentCls}-selection-item,
        &${componentCls}-show-arrow ${componentCls}-selection-placeholder
      `]: {
                paddingInlineEnd: token.showArrowPaddingInlineEnd
            },
            // Opacity selection if open
            [`&${componentCls}-open ${componentCls}-selection-item`]: {
                color: token.colorTextPlaceholder
            },
            // ========================== Input ==========================
            // We only change the style of non-customize input which is only support by `combobox` mode.
            // Not customize
            [`&:not(${componentCls}-customize-input)`]: {
                [`${componentCls}-selector`]: {
                    width: "100%",
                    height: "100%",
                    padding: `0 ${(0, $lpQ06.unit)(inputPaddingHorizontalBase)}`,
                    [`${componentCls}-selection-search-input`]: {
                        height: selectHeightWithoutBorder
                    },
                    "&:after": {
                        lineHeight: (0, $lpQ06.unit)(selectHeightWithoutBorder)
                    }
                }
            },
            [`&${componentCls}-customize-input`]: {
                [`${componentCls}-selector`]: {
                    "&:after": {
                        display: "none"
                    },
                    [`${componentCls}-selection-search`]: {
                        position: "static",
                        width: "100%"
                    },
                    [`${componentCls}-selection-placeholder`]: {
                        position: "absolute",
                        insetInlineStart: 0,
                        insetInlineEnd: 0,
                        padding: `0 ${(0, $lpQ06.unit)(inputPaddingHorizontalBase)}`,
                        "&:after": {
                            display: "none"
                        }
                    }
                }
            }
        }
    };
}
function $143140f2aef1b4ae$export$2e2bcd8739ae039(token) {
    const { componentCls: componentCls } = token;
    const inputPaddingHorizontalSM = token.calc(token.controlPaddingHorizontalSM).sub(token.lineWidth).equal();
    return [
        $143140f2aef1b4ae$var$genSizeStyle(token),
        // ======================== Small ========================
        // Shared
        $143140f2aef1b4ae$var$genSizeStyle((0, $2LRCS.merge)(token, {
            controlHeight: token.controlHeightSM,
            borderRadius: token.borderRadiusSM
        }), "sm"),
        // padding
        {
            [`${componentCls}-single${componentCls}-sm`]: {
                [`&:not(${componentCls}-customize-input)`]: {
                    [`${componentCls}-selection-search`]: {
                        insetInlineStart: inputPaddingHorizontalSM,
                        insetInlineEnd: inputPaddingHorizontalSM
                    },
                    [`${componentCls}-selector`]: {
                        padding: `0 ${(0, $lpQ06.unit)(inputPaddingHorizontalSM)}`
                    },
                    // With arrow should provides `padding-right` to show the arrow
                    [`&${componentCls}-show-arrow ${componentCls}-selection-search`]: {
                        insetInlineEnd: token.calc(inputPaddingHorizontalSM).add(token.calc(token.fontSize).mul(1.5)).equal()
                    },
                    [`
            &${componentCls}-show-arrow ${componentCls}-selection-item,
            &${componentCls}-show-arrow ${componentCls}-selection-placeholder
          `]: {
                        paddingInlineEnd: token.calc(token.fontSize).mul(1.5).equal()
                    }
                }
            }
        },
        // ======================== Large ========================
        // Shared
        $143140f2aef1b4ae$var$genSizeStyle((0, $2LRCS.merge)(token, {
            controlHeight: token.singleItemHeightLG,
            fontSize: token.fontSizeLG,
            borderRadius: token.borderRadiusLG
        }), "lg")
    ];
}


"use client";
// ============================= Selector =============================
const $62a9ef7c3b113a0f$var$genSelectorStyle = (token)=>{
    const { componentCls: componentCls, selectorBg: selectorBg } = token;
    return {
        position: "relative",
        backgroundColor: selectorBg,
        border: `${(0, $lpQ06.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
        transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`,
        input: {
            cursor: "pointer"
        },
        [`${componentCls}-show-search&`]: {
            cursor: "text",
            input: {
                cursor: "auto",
                color: "inherit",
                height: "100%"
            }
        },
        [`${componentCls}-disabled&`]: {
            color: token.colorTextDisabled,
            background: token.colorBgContainerDisabled,
            cursor: "not-allowed",
            [`${componentCls}-multiple&`]: {
                background: token.multipleSelectorBgDisabled
            },
            input: {
                cursor: "not-allowed"
            }
        }
    };
};
// ============================== Status ==============================
const $62a9ef7c3b113a0f$var$genStatusStyle = function(rootSelectCls, token) {
    let overwriteDefaultBorder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    const { componentCls: componentCls, borderHoverColor: borderHoverColor, antCls: antCls, borderActiveColor: borderActiveColor, outlineColor: outlineColor, controlOutlineWidth: controlOutlineWidth } = token;
    const overwriteStyle = overwriteDefaultBorder ? {
        [`${componentCls}-selector`]: {
            borderColor: borderActiveColor
        }
    } : {};
    return {
        [rootSelectCls]: {
            [`&:not(${componentCls}-disabled):not(${componentCls}-customize-input):not(${antCls}-pagination-size-changer)`]: Object.assign(Object.assign({}, overwriteStyle), {
                [`&:hover ${componentCls}-selector`]: {
                    borderColor: borderHoverColor
                },
                [`${componentCls}-focused& ${componentCls}-selector`]: {
                    borderColor: borderActiveColor,
                    boxShadow: `0 0 0 ${(0, $lpQ06.unit)(controlOutlineWidth)} ${outlineColor}`,
                    outline: 0
                }
            })
        }
    };
};
// ============================== Styles ==============================
// /* Reset search input style */
const $62a9ef7c3b113a0f$var$getSearchInputWithoutBorderStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-selection-search-input`]: {
            margin: 0,
            padding: 0,
            background: "transparent",
            border: "none",
            outline: "none",
            appearance: "none",
            fontFamily: "inherit",
            "&::-webkit-search-cancel-button": {
                display: "none",
                "-webkit-appearance": "none"
            }
        }
    };
};
// =============================== Base ===============================
const $62a9ef7c3b113a0f$var$genBaseStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, inputPaddingHorizontalBase: inputPaddingHorizontalBase, iconCls: iconCls } = token;
    return {
        [componentCls]: Object.assign(Object.assign({}, (0, $670jt.resetComponent)(token)), {
            position: "relative",
            display: "inline-block",
            cursor: "pointer",
            [`&:not(${componentCls}-customize-input) ${componentCls}-selector`]: Object.assign(Object.assign({}, $62a9ef7c3b113a0f$var$genSelectorStyle(token)), $62a9ef7c3b113a0f$var$getSearchInputWithoutBorderStyle(token)),
            // [`&:not(&-disabled):hover ${selectCls}-selector`]: {
            //   ...genHoverStyle(token),
            // },
            // ======================== Selection ========================
            [`${componentCls}-selection-item`]: Object.assign(Object.assign({
                flex: 1,
                fontWeight: "normal",
                position: "relative",
                userSelect: "none"
            }, (0, $670jt.textEllipsis)), {
                // https://github.com/ant-design/ant-design/issues/40421
                [`> ${antCls}-typography`]: {
                    display: "inline"
                }
            }),
            // ======================= Placeholder =======================
            [`${componentCls}-selection-placeholder`]: Object.assign(Object.assign({}, (0, $670jt.textEllipsis)), {
                flex: 1,
                color: token.colorTextPlaceholder,
                pointerEvents: "none"
            }),
            // ========================== Arrow ==========================
            [`${componentCls}-arrow`]: Object.assign(Object.assign({}, (0, $670jt.resetIcon)()), {
                position: "absolute",
                top: "50%",
                insetInlineStart: "auto",
                insetInlineEnd: inputPaddingHorizontalBase,
                height: token.fontSizeIcon,
                marginTop: token.calc(token.fontSizeIcon).mul(-1).div(2).equal(),
                color: token.colorTextQuaternary,
                fontSize: token.fontSizeIcon,
                lineHeight: 1,
                textAlign: "center",
                pointerEvents: "none",
                display: "flex",
                alignItems: "center",
                [iconCls]: {
                    verticalAlign: "top",
                    transition: `transform ${token.motionDurationSlow}`,
                    "> svg": {
                        verticalAlign: "top"
                    },
                    [`&:not(${componentCls}-suffix)`]: {
                        pointerEvents: "auto"
                    }
                },
                [`${componentCls}-disabled &`]: {
                    cursor: "not-allowed"
                },
                "> *:not(:last-child)": {
                    marginInlineEnd: 8 // FIXME: magic
                }
            }),
            // ========================== Clear ==========================
            [`${componentCls}-clear`]: {
                position: "absolute",
                top: "50%",
                insetInlineStart: "auto",
                insetInlineEnd: inputPaddingHorizontalBase,
                zIndex: 1,
                display: "inline-block",
                width: token.fontSizeIcon,
                height: token.fontSizeIcon,
                marginTop: token.calc(token.fontSizeIcon).mul(-1).div(2).equal(),
                color: token.colorTextQuaternary,
                fontSize: token.fontSizeIcon,
                fontStyle: "normal",
                lineHeight: 1,
                textAlign: "center",
                textTransform: "none",
                background: token.clearBg,
                cursor: "pointer",
                opacity: 0,
                transition: `color ${token.motionDurationMid} ease, opacity ${token.motionDurationSlow} ease`,
                textRendering: "auto",
                "&:before": {
                    display: "block"
                },
                "&:hover": {
                    color: token.colorTextTertiary
                }
            },
            "&:hover": {
                [`${componentCls}-clear`]: {
                    opacity: 1
                }
            }
        }),
        // ========================= Feedback ==========================
        [`${componentCls}-has-feedback`]: {
            [`${componentCls}-clear`]: {
                insetInlineEnd: token.calc(inputPaddingHorizontalBase).add(token.fontSize).add(token.paddingXS).equal()
            }
        }
    };
};
// ============================== Styles ==============================
const $62a9ef7c3b113a0f$var$genSelectStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return [
        {
            [componentCls]: {
                // ==================== BorderLess ====================
                [`&-borderless ${componentCls}-selector`]: {
                    backgroundColor: `transparent !important`,
                    borderColor: `transparent !important`,
                    boxShadow: `none !important`
                },
                // ==================== In Form ====================
                [`&${componentCls}-in-form-item`]: {
                    width: "100%"
                }
            }
        },
        // =====================================================
        // ==                       LTR                       ==
        // =====================================================
        // Base
        $62a9ef7c3b113a0f$var$genBaseStyle(token),
        // Single
        (0, $143140f2aef1b4ae$export$2e2bcd8739ae039)(token),
        // Multiple
        (0, $4da12f0c4f4b3a28$export$2e2bcd8739ae039)(token),
        // Dropdown
        (0, $879d950d114a8bdf$export$2e2bcd8739ae039)(token),
        // =====================================================
        // ==                       RTL                       ==
        // =====================================================
        {
            [`${componentCls}-rtl`]: {
                direction: "rtl"
            }
        },
        // =====================================================
        // ==                     Status                      ==
        // =====================================================
        $62a9ef7c3b113a0f$var$genStatusStyle(componentCls, (0, $2LRCS.merge)(token, {
            borderHoverColor: token.colorPrimaryHover,
            borderActiveColor: token.colorPrimary,
            outlineColor: token.controlOutline
        })),
        $62a9ef7c3b113a0f$var$genStatusStyle(`${componentCls}-status-error`, (0, $2LRCS.merge)(token, {
            borderHoverColor: token.colorErrorHover,
            borderActiveColor: token.colorError,
            outlineColor: token.colorErrorOutline
        }), true),
        $62a9ef7c3b113a0f$var$genStatusStyle(`${componentCls}-status-warning`, (0, $2LRCS.merge)(token, {
            borderHoverColor: token.colorWarningHover,
            borderActiveColor: token.colorWarning,
            outlineColor: token.colorWarningOutline
        }), true),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $1g5Jl.genCompactItemStyle)(token, {
            borderElCls: `${componentCls}-selector`,
            focusElCls: `${componentCls}-focused`
        })
    ];
};
const $62a9ef7c3b113a0f$export$9ca1be8807fe0675 = (token)=>{
    const { fontSize: fontSize, lineHeight: lineHeight, controlHeight: controlHeight, controlPaddingHorizontal: controlPaddingHorizontal, zIndexPopupBase: zIndexPopupBase, colorText: colorText, fontWeightStrong: fontWeightStrong, controlItemBgActive: controlItemBgActive, controlItemBgHover: controlItemBgHover, colorBgContainer: colorBgContainer, colorFillSecondary: colorFillSecondary, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, colorBgContainerDisabled: colorBgContainerDisabled, colorTextDisabled: colorTextDisabled } = token;
    return {
        zIndexPopup: zIndexPopupBase + 50,
        optionSelectedColor: colorText,
        optionSelectedFontWeight: fontWeightStrong,
        optionSelectedBg: controlItemBgActive,
        optionActiveBg: controlItemBgHover,
        optionPadding: `${(controlHeight - fontSize * lineHeight) / 2}px ${controlPaddingHorizontal}px`,
        optionFontSize: fontSize,
        optionLineHeight: lineHeight,
        optionHeight: controlHeight,
        selectorBg: colorBgContainer,
        clearBg: colorBgContainer,
        singleItemHeightLG: controlHeightLG,
        multipleItemBg: colorFillSecondary,
        multipleItemBorderColor: "transparent",
        multipleItemHeight: controlHeightSM,
        multipleItemHeightLG: controlHeight,
        multipleSelectorBgDisabled: colorBgContainerDisabled,
        multipleItemColorDisabled: colorTextDisabled,
        multipleItemBorderColorDisabled: "transparent",
        showArrowPaddingInlineEnd: Math.ceil(token.fontSize * 1.25)
    };
};
var $62a9ef7c3b113a0f$export$2e2bcd8739ae039 = (0, $P8Drj.genStyleHooks)("Select", (token, _ref)=>{
    let { rootPrefixCls: rootPrefixCls } = _ref;
    const selectToken = (0, $2LRCS.merge)(token, {
        rootPrefixCls: rootPrefixCls,
        inputPaddingHorizontalBase: token.calc(token.paddingSM).sub(1).equal(),
        multipleSelectItemHeight: token.multipleItemHeight,
        selectHeight: token.controlHeight
    });
    return [
        $62a9ef7c3b113a0f$var$genSelectStyle(selectToken)
    ];
}, $62a9ef7c3b113a0f$export$9ca1be8807fe0675, {
    unitless: {
        optionLineHeight: true,
        optionSelectedFontWeight: true
    }
});


"use client";
const $cc6bf27ad83e91b3$var$getBuiltInPlacements = (popupOverflow)=>{
    const htmlRegion = popupOverflow === "scroll" ? "scroll" : "visible";
    const sharedConfig = {
        overflow: {
            adjustX: true,
            adjustY: true,
            shiftY: true
        },
        htmlRegion: htmlRegion,
        dynamicInset: true
    };
    return {
        bottomLeft: Object.assign(Object.assign({}, sharedConfig), {
            points: [
                "tl",
                "bl"
            ],
            offset: [
                0,
                4
            ]
        }),
        bottomRight: Object.assign(Object.assign({}, sharedConfig), {
            points: [
                "tr",
                "br"
            ],
            offset: [
                0,
                4
            ]
        }),
        topLeft: Object.assign(Object.assign({}, sharedConfig), {
            points: [
                "bl",
                "tl"
            ],
            offset: [
                0,
                -4
            ]
        }),
        topRight: Object.assign(Object.assign({}, sharedConfig), {
            points: [
                "br",
                "tr"
            ],
            offset: [
                0,
                -4
            ]
        })
    };
};
function $cc6bf27ad83e91b3$export$2e2bcd8739ae039(buildInPlacements, popupOverflow) {
    return buildInPlacements || $cc6bf27ad83e91b3$var$getBuiltInPlacements(popupOverflow);
}



var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $94b215ba0d5fdf99$var$CheckOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
                }
            }
        ]
    },
    "name": "check",
    "theme": "outlined"
};
var $94b215ba0d5fdf99$export$2e2bcd8739ae039 = $94b215ba0d5fdf99$var$CheckOutlined;



var $adRcI = parcelRequire("adRcI");
var $731042e70a6ddd3b$var$CheckOutlined = function CheckOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $adRcI.default), (0, $8nd05.default)({}, props, {
        ref: ref,
        icon: (0, $94b215ba0d5fdf99$export$2e2bcd8739ae039)
    }));
};
var $731042e70a6ddd3b$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($731042e70a6ddd3b$var$CheckOutlined);



var $b9YHa = parcelRequire("b9YHa");

var $AWXcC = parcelRequire("AWXcC");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $4785c2fd6b878d9a$var$DownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    },
    "name": "down",
    "theme": "outlined"
};
var $4785c2fd6b878d9a$export$2e2bcd8739ae039 = $4785c2fd6b878d9a$var$DownOutlined;



var $adRcI = parcelRequire("adRcI");
var $9387210f6c0d2379$var$DownOutlined = function DownOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $adRcI.default), (0, $8nd05.default)({}, props, {
        ref: ref,
        icon: (0, $4785c2fd6b878d9a$export$2e2bcd8739ae039)
    }));
};
var $9387210f6c0d2379$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($9387210f6c0d2379$var$DownOutlined);



var $iCcrH = parcelRequire("iCcrH");

var $ldXL3 = parcelRequire("ldXL3");

"use client";
function $f15feb4dca87ef73$export$2e2bcd8739ae039(_ref) {
    let { suffixIcon: suffixIcon, clearIcon: clearIcon, menuItemSelectedIcon: menuItemSelectedIcon, removeIcon: removeIcon, loading: loading, multiple: multiple, hasFeedback: hasFeedback, prefixCls: prefixCls, showSuffixIcon: showSuffixIcon, feedbackIcon: feedbackIcon, showArrow: showArrow, componentName: componentName } = _ref;
    // Clear Icon
    const mergedClearIcon = clearIcon !== null && clearIcon !== void 0 ? clearIcon : /*#__PURE__*/ $acw62.createElement((0, $b9YHa.default), null);
    // Validation Feedback Icon
    const getSuffixIconNode = (arrowIcon)=>{
        if (suffixIcon === null && !hasFeedback && !showArrow) return null;
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, showSuffixIcon !== false && arrowIcon, hasFeedback && feedbackIcon);
    };
    // Arrow item icon
    let mergedSuffixIcon = null;
    if (suffixIcon !== undefined) mergedSuffixIcon = getSuffixIconNode(suffixIcon);
    else if (loading) mergedSuffixIcon = getSuffixIconNode(/*#__PURE__*/ $acw62.createElement((0, $iCcrH.default), {
        spin: true
    }));
    else {
        const iconCls = `${prefixCls}-suffix`;
        mergedSuffixIcon = (_ref2)=>{
            let { open: open, showSearch: showSearch } = _ref2;
            if (open && showSearch) return getSuffixIconNode(/*#__PURE__*/ $acw62.createElement((0, $ldXL3.default), {
                className: iconCls
            }));
            return getSuffixIconNode(/*#__PURE__*/ $acw62.createElement((0, $9387210f6c0d2379$export$2e2bcd8739ae039), {
                className: iconCls
            }));
        };
    }
    // Checked item icon
    let mergedItemIcon = null;
    if (menuItemSelectedIcon !== undefined) mergedItemIcon = menuItemSelectedIcon;
    else if (multiple) mergedItemIcon = /*#__PURE__*/ $acw62.createElement((0, $731042e70a6ddd3b$export$2e2bcd8739ae039), null);
    else mergedItemIcon = null;
    let mergedRemoveIcon = null;
    if (removeIcon !== undefined) mergedRemoveIcon = removeIcon;
    else mergedRemoveIcon = /*#__PURE__*/ $acw62.createElement((0, $AWXcC.default), null);
    return {
        clearIcon: mergedClearIcon,
        suffixIcon: mergedSuffixIcon,
        itemIcon: mergedItemIcon,
        removeIcon: mergedRemoveIcon
    };
}


/**
 * Since Select, TreeSelect, Cascader is same Select like component.
 * We just use same hook to handle this logic.
 *
 * If `suffixIcon` is not equal to `null`, always show it.
 */ function $ce5709ba38c89ca7$export$2e2bcd8739ae039(suffixIcon, showArrow) {
    return showArrow !== undefined ? showArrow : suffixIcon !== null;
}



var $dnT3A = parcelRequire("dnT3A");
"use client";
var $1b56c179e5783cdb$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $1b56c179e5783cdb$var$SECRET_COMBOBOX_MODE_DO_NOT_USE = "SECRET_COMBOBOX_MODE_DO_NOT_USE";
const $1b56c179e5783cdb$var$InternalSelect = (_a, ref)=>{
    var _b, _c;
    var { prefixCls: customizePrefixCls, bordered: bordered = true, className: className, rootClassName: rootClassName, getPopupContainer: getPopupContainer, popupClassName: popupClassName, dropdownClassName: dropdownClassName, listHeight: listHeight = 256, placement: placement, listItemHeight: listItemHeight = 24, size: customizeSize, disabled: customDisabled, notFoundContent: notFoundContent, status: customStatus, builtinPlacements: builtinPlacements, dropdownMatchSelectWidth: dropdownMatchSelectWidth, popupMatchSelectWidth: popupMatchSelectWidth, direction: propDirection, style: style, allowClear: allowClear } = _a, props = $1b56c179e5783cdb$var$__rest(_a, [
        "prefixCls",
        "bordered",
        "className",
        "rootClassName",
        "getPopupContainer",
        "popupClassName",
        "dropdownClassName",
        "listHeight",
        "placement",
        "listItemHeight",
        "size",
        "disabled",
        "notFoundContent",
        "status",
        "builtinPlacements",
        "dropdownMatchSelectWidth",
        "popupMatchSelectWidth",
        "direction",
        "style",
        "allowClear"
    ]);
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, renderEmpty: renderEmpty, direction: contextDirection, virtual: virtual, popupMatchSelectWidth: contextPopupMatchSelectWidth, popupOverflow: popupOverflow, select: select } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const prefixCls = getPrefixCls("select", customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const direction = propDirection !== null && propDirection !== void 0 ? propDirection : contextDirection;
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $3gns8.useCompactItemContext)(prefixCls, direction);
    const rootCls = (0, $dnT3A.default)(prefixCls);
    const [wrapCSSVar, hashId] = (0, $62a9ef7c3b113a0f$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const mode = $acw62.useMemo(()=>{
        const { mode: m } = props;
        if (m === "combobox") return undefined;
        if (m === $1b56c179e5783cdb$var$SECRET_COMBOBOX_MODE_DO_NOT_USE) return "combobox";
        return m;
    }, [
        props.mode
    ]);
    const isMultiple = mode === "multiple" || mode === "tags";
    const showSuffixIcon = (0, $ce5709ba38c89ca7$export$2e2bcd8739ae039)(props.suffixIcon, props.showArrow);
    const mergedPopupMatchSelectWidth = (_b = popupMatchSelectWidth !== null && popupMatchSelectWidth !== void 0 ? popupMatchSelectWidth : dropdownMatchSelectWidth) !== null && _b !== void 0 ? _b : contextPopupMatchSelectWidth;
    // ===================== Form Status =====================
    const { status: contextStatus, hasFeedback: hasFeedback, isFormItemInput: isFormItemInput, feedbackIcon: feedbackIcon } = $acw62.useContext((0, $eSOz6.FormItemInputContext));
    const mergedStatus = (0, $8Vr1S.getMergedStatus)(contextStatus, customStatus);
    // ===================== Empty =====================
    let mergedNotFound;
    if (notFoundContent !== undefined) mergedNotFound = notFoundContent;
    else if (mode === "combobox") mergedNotFound = null;
    else mergedNotFound = (renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty("Select")) || /*#__PURE__*/ $acw62.createElement((0, $3feb83783705e448$export$2e2bcd8739ae039), {
        componentName: "Select"
    });
    // ===================== Icons =====================
    const { suffixIcon: suffixIcon, itemIcon: itemIcon, removeIcon: removeIcon, clearIcon: clearIcon } = (0, $f15feb4dca87ef73$export$2e2bcd8739ae039)(Object.assign(Object.assign({}, props), {
        multiple: isMultiple,
        hasFeedback: hasFeedback,
        feedbackIcon: feedbackIcon,
        showSuffixIcon: showSuffixIcon,
        prefixCls: prefixCls,
        showArrow: props.showArrow,
        componentName: "Select"
    }));
    const mergedAllowClear = allowClear === true ? {
        clearIcon: clearIcon
    } : allowClear;
    const selectProps = (0, $1pcHX.default)(props, [
        "suffixIcon",
        "itemIcon"
    ]);
    const mergedPopupClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(popupClassName || dropdownClassName, {
        [`${prefixCls}-dropdown-${direction}`]: direction === "rtl"
    }, rootClassName, rootCls, hashId);
    const mergedSize = (0, $IFe7R.default)((ctx)=>{
        var _a;
        return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
    });
    // ===================== Disabled =====================
    const disabled = $acw62.useContext((0, $9f1hj.default));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    const mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
        [`${prefixCls}-lg`]: mergedSize === "large",
        [`${prefixCls}-sm`]: mergedSize === "small",
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-borderless`]: !bordered,
        [`${prefixCls}-in-form-item`]: isFormItemInput
    }, (0, $8Vr1S.getStatusClassNames)(prefixCls, mergedStatus, hasFeedback), compactItemClassnames, select === null || select === void 0 ? void 0 : select.className, className, rootClassName, rootCls, hashId);
    // ===================== Placement =====================
    const memoPlacement = $acw62.useMemo(()=>{
        if (placement !== undefined) return placement;
        return direction === "rtl" ? "bottomRight" : "bottomLeft";
    }, [
        placement,
        direction
    ]);
    const mergedBuiltinPlacements = (0, $cc6bf27ad83e91b3$export$2e2bcd8739ae039)(builtinPlacements, popupOverflow);
    // ====================== zIndex =========================
    const [zIndex] = (0, $brFSt.useZIndex)("SelectLike", (_c = props.dropdownStyle) === null || _c === void 0 ? void 0 : _c.zIndex);
    // ====================== Render =======================
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $65dbbed9df0fecca$export$2e2bcd8739ae039), Object.assign({
        ref: ref,
        virtual: virtual,
        showSearch: select === null || select === void 0 ? void 0 : select.showSearch
    }, selectProps, {
        style: Object.assign(Object.assign({}, select === null || select === void 0 ? void 0 : select.style), style),
        dropdownMatchSelectWidth: mergedPopupMatchSelectWidth,
        builtinPlacements: mergedBuiltinPlacements,
        transitionName: (0, $4257x.getTransitionName)(rootPrefixCls, "slide-up", props.transitionName),
        listHeight: listHeight,
        listItemHeight: listItemHeight,
        mode: mode,
        prefixCls: prefixCls,
        placement: memoPlacement,
        direction: direction,
        suffixIcon: suffixIcon,
        menuItemSelectedIcon: itemIcon,
        removeIcon: removeIcon,
        allowClear: mergedAllowClear,
        notFoundContent: mergedNotFound,
        className: mergedClassName,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        dropdownClassName: mergedPopupClassName,
        disabled: mergedDisabled,
        dropdownStyle: Object.assign(Object.assign({}, props === null || props === void 0 ? void 0 : props.dropdownStyle), {
            zIndex: zIndex
        })
    })));
};
const $1b56c179e5783cdb$var$Select = /*#__PURE__*/ $acw62.forwardRef($1b56c179e5783cdb$var$InternalSelect);
// We don't care debug panel
/* istanbul ignore next */ const $1b56c179e5783cdb$var$PurePanel = (0, $91653a8941ab7768$export$2e2bcd8739ae039)($1b56c179e5783cdb$var$Select);
$1b56c179e5783cdb$var$Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = $1b56c179e5783cdb$var$SECRET_COMBOBOX_MODE_DO_NOT_USE;
$1b56c179e5783cdb$var$Select.Option = (0, $2f79e5076b69401d$export$2e2bcd8739ae039);
$1b56c179e5783cdb$var$Select.OptGroup = (0, $cb22e94bdb4eaaa5$export$2e2bcd8739ae039);
$1b56c179e5783cdb$var$Select._InternalPanelDoNotUseOrYouWillBeFired = $1b56c179e5783cdb$var$PurePanel;
var $1b56c179e5783cdb$export$2e2bcd8739ae039 = $1b56c179e5783cdb$var$Select;


var $acw62 = parcelRequire("acw62");



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $4da90ab6d25f30a4$var$CopyOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z"
                }
            }
        ]
    },
    "name": "copy",
    "theme": "outlined"
};
var $4da90ab6d25f30a4$export$2e2bcd8739ae039 = $4da90ab6d25f30a4$var$CopyOutlined;



var $adRcI = parcelRequire("adRcI");
var $cf161c40cf97635f$var$CopyOutlined = function CopyOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $adRcI.default), (0, $8nd05.default)({}, props, {
        ref: ref,
        icon: (0, $4da90ab6d25f30a4$export$2e2bcd8739ae039)
    }));
};
var $cf161c40cf97635f$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($cf161c40cf97635f$var$CopyOutlined);



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $20d973f7249e2921$var$EditOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    },
    "name": "edit",
    "theme": "outlined"
};
var $20d973f7249e2921$export$2e2bcd8739ae039 = $20d973f7249e2921$var$EditOutlined;



var $adRcI = parcelRequire("adRcI");
var $498b707c3c04dc0a$var$EditOutlined = function EditOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $adRcI.default), (0, $8nd05.default)({}, props, {
        ref: ref,
        icon: (0, $20d973f7249e2921$export$2e2bcd8739ae039)
    }));
};
var $498b707c3c04dc0a$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($498b707c3c04dc0a$var$EditOutlined);



var $8g1PZ = parcelRequire("8g1PZ");
var $e5a78797c4262d1f$exports = {};
"use strict";
var $9e6bd5018912b3a9$exports = {};
$9e6bd5018912b3a9$exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case "INPUT":
        case "TEXTAREA":
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === "Caret" && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};


var $e5a78797c4262d1f$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $e5a78797c4262d1f$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $e5a78797c4262d1f$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $e5a78797c4262d1f$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $9e6bd5018912b3a9$exports();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $e5a78797c4262d1f$var$clipboardToIE11Formatting[options.format] || $e5a78797c4262d1f$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $e5a78797c4262d1f$var$format("message" in options ? options.message : $e5a78797c4262d1f$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
$e5a78797c4262d1f$exports = $e5a78797c4262d1f$var$copy;



var $bVxlN = parcelRequire("bVxlN");

var $jWR62 = parcelRequire("jWR62");

var $6hDTM = parcelRequire("6hDTM");

var $iSQh8 = parcelRequire("iSQh8");

var $1pcHX = parcelRequire("1pcHX");

var $85dLH = parcelRequire("85dLH");

var $acw62 = parcelRequire("acw62");


var $iCi4s = parcelRequire("iCi4s");

var $acw62 = parcelRequire("acw62");
"use client";
var $3aff44b895d5798c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $3aff44b895d5798c$var$inlineStyle = {
    border: 0,
    background: "transparent",
    padding: 0,
    lineHeight: "inherit",
    display: "inline-block"
};
const $3aff44b895d5798c$var$TransButton = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const onKeyDown = (event)=>{
        const { keyCode: keyCode } = event;
        if (keyCode === (0, $iCi4s.default).ENTER) event.preventDefault();
    };
    const onKeyUp = (event)=>{
        const { keyCode: keyCode } = event;
        const { onClick: onClick } = props;
        if (keyCode === (0, $iCi4s.default).ENTER && onClick) onClick();
    };
    const { style: style, noStyle: noStyle, disabled: disabled } = props, restProps = $3aff44b895d5798c$var$__rest(props, [
        "style",
        "noStyle",
        "disabled"
    ]);
    let mergedStyle = {};
    if (!noStyle) mergedStyle = Object.assign({}, $3aff44b895d5798c$var$inlineStyle);
    if (disabled) mergedStyle.pointerEvents = "none";
    mergedStyle = Object.assign(Object.assign({}, mergedStyle), style);
    return /*#__PURE__*/ $acw62.createElement("div", Object.assign({
        role: "button",
        tabIndex: 0,
        ref: ref
    }, restProps, {
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        style: mergedStyle
    }));
});
var $3aff44b895d5798c$export$2e2bcd8739ae039 = $3aff44b895d5798c$var$TransButton;


parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

var $0G7XT = parcelRequire("0G7XT");

var $VoMtX = parcelRequire("VoMtX");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $579f6109eaa96326$var$EnterOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "enter",
    "theme": "outlined"
};
var $579f6109eaa96326$export$2e2bcd8739ae039 = $579f6109eaa96326$var$EnterOutlined;



var $adRcI = parcelRequire("adRcI");
var $ac0f9536ca737b46$var$EnterOutlined = function EnterOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $adRcI.default), (0, $8nd05.default)({}, props, {
        ref: ref,
        icon: (0, $579f6109eaa96326$export$2e2bcd8739ae039)
    }));
};
var $ac0f9536ca737b46$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($ac0f9536ca737b46$var$EnterOutlined);



var $8g1PZ = parcelRequire("8g1PZ");

var $iCi4s = parcelRequire("iCi4s");

var $acw62 = parcelRequire("acw62");

var $4a1I5 = parcelRequire("4a1I5");

var $lEgf5 = parcelRequire("lEgf5");

var $if8uR = parcelRequire("if8uR");

var $P8Drj = parcelRequire("P8Drj");
/*
.typography-title(@fontSize; @fontWeight; @lineHeight; @headingColor; @headingMarginBottom;) {
  margin-bottom: @headingMarginBottom;
  color: @headingColor;
  font-weight: @fontWeight;
  fontSize: @fontSize;
  line-height: @lineHeight;
}
*/ 
var $eIR68 = parcelRequire("eIR68");
parcelRequire("3i86m");
var $lpQ06 = parcelRequire("lpQ06");

var $if8uR = parcelRequire("if8uR");
// eslint-disable-next-line import/prefer-default-export
const $950f24b0c690e3c4$var$getTitleStyle = (fontSize, lineHeight, color, token)=>{
    const { titleMarginBottom: titleMarginBottom, fontWeightStrong: fontWeightStrong } = token;
    return {
        marginBottom: titleMarginBottom,
        color: color,
        fontWeight: fontWeightStrong,
        fontSize: fontSize,
        lineHeight: lineHeight
    };
};
const $950f24b0c690e3c4$export$83146cf7d1bec659 = (token)=>{
    const headings = [
        1,
        2,
        3,
        4,
        5
    ];
    const styles = {};
    headings.forEach((headingLevel)=>{
        styles[`
      h${headingLevel}&,
      div&-h${headingLevel},
      div&-h${headingLevel} > textarea,
      h${headingLevel}
    `] = $950f24b0c690e3c4$var$getTitleStyle(token[`fontSizeHeading${headingLevel}`], token[`lineHeightHeading${headingLevel}`], token.colorTextHeading, token);
    });
    return styles;
};
const $950f24b0c690e3c4$export$566f4066c7caac18 = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        "a&, a": Object.assign(Object.assign({}, (0, $if8uR.operationUnit)(token)), {
            textDecoration: token.linkDecoration,
            "&:active, &:hover": {
                textDecoration: token.linkHoverDecoration
            },
            [`&[disabled], &${componentCls}-disabled`]: {
                color: token.colorTextDisabled,
                cursor: "not-allowed",
                "&:active, &:hover": {
                    color: token.colorTextDisabled
                },
                "&:active": {
                    pointerEvents: "none"
                }
            }
        })
    };
};
const $950f24b0c690e3c4$export$977383a86f45014b = (token)=>({
        code: {
            margin: "0 0.2em",
            paddingInline: "0.4em",
            paddingBlock: "0.2em 0.1em",
            fontSize: "85%",
            fontFamily: token.fontFamilyCode,
            background: "rgba(150, 150, 150, 0.1)",
            border: "1px solid rgba(100, 100, 100, 0.2)",
            borderRadius: 3
        },
        kbd: {
            margin: "0 0.2em",
            paddingInline: "0.4em",
            paddingBlock: "0.15em 0.1em",
            fontSize: "90%",
            fontFamily: token.fontFamilyCode,
            background: "rgba(150, 150, 150, 0.06)",
            border: "1px solid rgba(100, 100, 100, 0.2)",
            borderBottomWidth: 2,
            borderRadius: 3
        },
        mark: {
            padding: 0,
            // FIXME hardcode in v4
            backgroundColor: (0, $eIR68.gold)[2]
        },
        "u, ins": {
            textDecoration: "underline",
            textDecorationSkipInk: "auto"
        },
        "s, del": {
            textDecoration: "line-through"
        },
        strong: {
            fontWeight: 600
        },
        // list
        "ul, ol": {
            marginInline: 0,
            marginBlock: "0 1em",
            padding: 0,
            li: {
                marginInline: "20px 0",
                marginBlock: 0,
                paddingInline: "4px 0",
                paddingBlock: 0
            }
        },
        ul: {
            listStyleType: "circle",
            ul: {
                listStyleType: "disc"
            }
        },
        ol: {
            listStyleType: "decimal"
        },
        // pre & block
        "pre, blockquote": {
            margin: "1em 0"
        },
        pre: {
            padding: "0.4em 0.6em",
            whiteSpace: "pre-wrap",
            wordWrap: "break-word",
            background: "rgba(150, 150, 150, 0.1)",
            border: "1px solid rgba(100, 100, 100, 0.2)",
            borderRadius: 3,
            fontFamily: token.fontFamilyCode,
            // Compatible for marked
            code: {
                display: "inline",
                margin: 0,
                padding: 0,
                fontSize: "inherit",
                fontFamily: "inherit",
                background: "transparent",
                border: 0
            }
        },
        blockquote: {
            paddingInline: "0.6em 0",
            paddingBlock: 0,
            borderInlineStart: "4px solid rgba(100, 100, 100, 0.2)",
            opacity: 0.85
        }
    });
const $950f24b0c690e3c4$export$2667badb03518972 = (token)=>{
    const { componentCls: componentCls, paddingSM: paddingSM } = token;
    const inputShift = paddingSM;
    return {
        "&-edit-content": {
            position: "relative",
            "div&": {
                insetInlineStart: token.calc(token.paddingSM).mul(-1).equal(),
                marginTop: token.calc(inputShift).mul(-1).equal(),
                marginBottom: `calc(1em - ${(0, $lpQ06.unit)(inputShift)})`
            },
            [`${componentCls}-edit-content-confirm`]: {
                position: "absolute",
                insetInlineEnd: token.calc(token.marginXS).add(2).equal(),
                insetBlockEnd: token.marginXS,
                color: token.colorTextDescription,
                // default style
                fontWeight: "normal",
                fontSize: token.fontSize,
                fontStyle: "normal",
                pointerEvents: "none"
            },
            textarea: {
                margin: "0!important",
                // Fix Editable Textarea flash in Firefox
                MozTransition: "none",
                height: "1em"
            }
        }
    };
};
const $950f24b0c690e3c4$export$34755446404037a5 = (token)=>({
        "&-copy-success": {
            [`
    &,
    &:hover,
    &:focus`]: {
                color: token.colorSuccess
            }
        }
    });
const $950f24b0c690e3c4$export$d9556a50eba3003b = ()=>({
        [`
  a&-ellipsis,
  span&-ellipsis
  `]: {
            display: "inline-block",
            maxWidth: "100%"
        },
        "&-single-line": {
            whiteSpace: "nowrap"
        },
        "&-ellipsis-single-line": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            // https://blog.csdn.net/iefreer/article/details/50421025
            "a&, span&": {
                verticalAlign: "bottom"
            },
            "> code": {
                paddingBlock: 0,
                maxWidth: "calc(100% - 1.2em)",
                display: "inline-block",
                overflow: "hidden",
                textOverflow: "ellipsis",
                verticalAlign: "bottom",
                // https://github.com/ant-design/ant-design/issues/45953
                boxSizing: "content-box"
            }
        },
        "&-ellipsis-multiple-line": {
            display: "-webkit-box",
            overflow: "hidden",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical"
        }
    });


const $29a5bb3c87e057f0$var$genTypographyStyle = (token)=>{
    const { componentCls: componentCls, titleMarginTop: titleMarginTop } = token;
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
            color: token.colorText,
            wordBreak: "break-word",
            lineHeight: token.lineHeight,
            [`&${componentCls}-secondary`]: {
                color: token.colorTextDescription
            },
            [`&${componentCls}-success`]: {
                color: token.colorSuccess
            },
            [`&${componentCls}-warning`]: {
                color: token.colorWarning
            },
            [`&${componentCls}-danger`]: {
                color: token.colorError,
                "a&:active, a&:focus": {
                    color: token.colorErrorActive
                },
                "a&:hover": {
                    color: token.colorErrorHover
                }
            },
            [`&${componentCls}-disabled`]: {
                color: token.colorTextDisabled,
                cursor: "not-allowed",
                userSelect: "none"
            },
            [`
        div&,
        p
      `]: {
                marginBottom: "1em"
            }
        }, (0, $950f24b0c690e3c4$export$83146cf7d1bec659)(token)), {
            [`
      & + h1${componentCls},
      & + h2${componentCls},
      & + h3${componentCls},
      & + h4${componentCls},
      & + h5${componentCls}
      `]: {
                marginTop: titleMarginTop
            },
            [`
      div,
      ul,
      li,
      p,
      h1,
      h2,
      h3,
      h4,
      h5`]: {
                [`
        + h1,
        + h2,
        + h3,
        + h4,
        + h5
        `]: {
                    marginTop: titleMarginTop
                }
            }
        }), (0, $950f24b0c690e3c4$export$977383a86f45014b)(token)), (0, $950f24b0c690e3c4$export$566f4066c7caac18)(token)), {
            // Operation
            [`
        ${componentCls}-expand,
        ${componentCls}-edit,
        ${componentCls}-copy
      `]: Object.assign(Object.assign({}, (0, $if8uR.operationUnit)(token)), {
                marginInlineStart: token.marginXXS
            })
        }), (0, $950f24b0c690e3c4$export$2667badb03518972)(token)), (0, $950f24b0c690e3c4$export$34755446404037a5)(token)), (0, $950f24b0c690e3c4$export$d9556a50eba3003b)()), {
            "&-rtl": {
                direction: "rtl"
            }
        })
    };
};
const $29a5bb3c87e057f0$export$9ca1be8807fe0675 = ()=>({
        titleMarginTop: "1.2em",
        titleMarginBottom: "0.5em"
    });
var // ============================== Export ==============================
$29a5bb3c87e057f0$export$2e2bcd8739ae039 = (0, $P8Drj.genStyleHooks)("Typography", (token)=>[
        $29a5bb3c87e057f0$var$genTypographyStyle(token)
    ], $29a5bb3c87e057f0$export$9ca1be8807fe0675);


"use client";
const $8a5b8988dc6b65c3$var$Editable = (props)=>{
    const { prefixCls: prefixCls, "aria-label": ariaLabel, className: className, style: style, direction: direction, maxLength: maxLength, autoSize: autoSize = true, value: value, onSave: onSave, onCancel: onCancel, onEnd: onEnd, component: component, enterIcon: enterIcon = /*#__PURE__*/ $acw62.createElement((0, $ac0f9536ca737b46$export$2e2bcd8739ae039), null) } = props;
    const ref = $acw62.useRef(null);
    const inComposition = $acw62.useRef(false);
    const lastKeyCode = $acw62.useRef();
    const [current, setCurrent] = $acw62.useState(value);
    $acw62.useEffect(()=>{
        setCurrent(value);
    }, [
        value
    ]);
    $acw62.useEffect(()=>{
        if (ref.current && ref.current.resizableTextArea) {
            const { textArea: textArea } = ref.current.resizableTextArea;
            textArea.focus();
            const { length: length } = textArea.value;
            textArea.setSelectionRange(length, length);
        }
    }, []);
    const onChange = (_ref)=>{
        let { target: target } = _ref;
        setCurrent(target.value.replace(/[\n\r]/g, ""));
    };
    const onCompositionStart = ()=>{
        inComposition.current = true;
    };
    const onCompositionEnd = ()=>{
        inComposition.current = false;
    };
    const onKeyDown = (_ref2)=>{
        let { keyCode: keyCode } = _ref2;
        // We don't record keyCode when IME is using
        if (inComposition.current) return;
        lastKeyCode.current = keyCode;
    };
    const confirmChange = ()=>{
        onSave(current.trim());
    };
    const onKeyUp = (_ref3)=>{
        let { keyCode: keyCode, ctrlKey: ctrlKey, altKey: altKey, metaKey: metaKey, shiftKey: shiftKey } = _ref3;
        // Check if it's a real key
        if (lastKeyCode.current === keyCode && !inComposition.current && !ctrlKey && !altKey && !metaKey && !shiftKey) {
            if (keyCode === (0, $iCi4s.default).ENTER) {
                confirmChange();
                onEnd === null || onEnd === void 0 || onEnd();
            } else if (keyCode === (0, $iCi4s.default).ESC) onCancel();
        }
    };
    const onBlur = ()=>{
        confirmChange();
    };
    const textClassName = component ? `${prefixCls}-${component}` : "";
    const [wrapCSSVar, hashId] = (0, $29a5bb3c87e057f0$export$2e2bcd8739ae039)(prefixCls);
    const textAreaClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, `${prefixCls}-edit-content`, {
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, className, textClassName, hashId);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", {
        className: textAreaClassName,
        style: style
    }, /*#__PURE__*/ $acw62.createElement((0, $lEgf5.default), {
        ref: ref,
        maxLength: maxLength,
        value: current,
        onChange: onChange,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd,
        onBlur: onBlur,
        "aria-label": ariaLabel,
        rows: 1,
        autoSize: autoSize
    }), enterIcon !== null ? (0, $4a1I5.cloneElement)(enterIcon, {
        className: `${prefixCls}-edit-content-confirm`
    }) : null));
};
var $8a5b8988dc6b65c3$export$2e2bcd8739ae039 = $8a5b8988dc6b65c3$var$Editable;



var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $85dLH = parcelRequire("85dLH");

parcelRequire("aT8OD");
var $dRTnM = parcelRequire("dRTnM");

"use client";
var $a3673f44358dd6b6$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $a3673f44358dd6b6$var$Typography = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, component: Component = "article", className: className, rootClassName: rootClassName, setContentRef: setContentRef, children: children, direction: typographyDirection, style: style } = props, restProps = $a3673f44358dd6b6$var$__rest(props, [
        "prefixCls",
        "component",
        "className",
        "rootClassName",
        "setContentRef",
        "children",
        "direction",
        "style"
    ]);
    const { getPrefixCls: getPrefixCls, direction: contextDirection, typography: typography } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const direction = typographyDirection !== null && typographyDirection !== void 0 ? typographyDirection : contextDirection;
    let mergedRef = ref;
    if (setContentRef) mergedRef = (0, $85dLH.composeRef)(ref, setContentRef);
    const prefixCls = getPrefixCls("typography", customizePrefixCls);
    // Style
    const [wrapCSSVar, hashId] = (0, $29a5bb3c87e057f0$export$2e2bcd8739ae039)(prefixCls);
    const componentClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, typography === null || typography === void 0 ? void 0 : typography.className, {
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, className, rootClassName, hashId);
    const mergedStyle = Object.assign(Object.assign({}, typography === null || typography === void 0 ? void 0 : typography.style), style);
    return wrapCSSVar(/*#__PURE__*/ // @ts-expect-error: Expression produces a union type that is too complex to represent.
    $acw62.createElement(Component, Object.assign({
        className: componentClassName,
        style: mergedStyle,
        ref: mergedRef
    }, restProps), children));
});
var // es default export should use const instead of let
$a3673f44358dd6b6$export$2e2bcd8739ae039 = $a3673f44358dd6b6$var$Typography;



var $acw62 = parcelRequire("acw62");
function $4f54d14ab15fca01$export$2e2bcd8739ae039(propConfig, templateConfig) {
    return $acw62.useMemo(()=>{
        const support = !!propConfig;
        return [
            support,
            Object.assign(Object.assign({}, templateConfig), support && typeof propConfig === "object" ? propConfig : null)
        ];
    }, [
        propConfig
    ]);
}



var $acw62 = parcelRequire("acw62");
/** Similar with `useEffect` but only trigger after mounted */ const $16a6c1cd6424d279$var$useUpdatedEffect = (callback, conditions)=>{
    const mountRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        if (mountRef.current) callback();
        else mountRef.current = true;
    }, conditions);
};
var $16a6c1cd6424d279$export$2e2bcd8739ae039 = $16a6c1cd6424d279$var$useUpdatedEffect;



var $acw62 = parcelRequire("acw62");

var $jWR62 = parcelRequire("jWR62");

var $6hDTM = parcelRequire("6hDTM");
"use client";
function $89c852553f755dc1$var$cuttable(node) {
    const type = typeof node;
    return type === "string" || type === "number";
}
function $89c852553f755dc1$var$getNodesLen(nodeList) {
    let totalLen = 0;
    nodeList.forEach((node)=>{
        if ($89c852553f755dc1$var$cuttable(node)) totalLen += String(node).length;
        else totalLen += 1;
    });
    return totalLen;
}
function $89c852553f755dc1$var$sliceNodes(nodeList, len) {
    let currLen = 0;
    const currentNodeList = [];
    for(let i = 0; i < nodeList.length; i += 1){
        // Match to return
        if (currLen === len) return currentNodeList;
        const node = nodeList[i];
        const canCut = $89c852553f755dc1$var$cuttable(node);
        const nodeLen = canCut ? String(node).length : 1;
        const nextLen = currLen + nodeLen;
        // Exceed but current not which means we need cut this
        // This will not happen on validate ReactElement
        if (nextLen > len) {
            const restLen = len - currLen;
            currentNodeList.push(String(node).slice(0, restLen));
            return currentNodeList;
        }
        currentNodeList.push(node);
        currLen = nextLen;
    }
    return nodeList;
}
const $89c852553f755dc1$var$NONE = 0;
const $89c852553f755dc1$var$PREPARE = 1;
const $89c852553f755dc1$var$WALKING = 2;
const $89c852553f755dc1$var$DONE_WITH_ELLIPSIS = 3;
const $89c852553f755dc1$var$DONE_WITHOUT_ELLIPSIS = 4;
const $89c852553f755dc1$var$Ellipsis = (_ref)=>{
    let { enabledMeasure: enabledMeasure, children: children, text: text, width: width, fontSize: fontSize, rows: rows, onEllipsis: onEllipsis } = _ref;
    const [[startLen, midLen, endLen], setCutLength] = $acw62.useState([
        0,
        0,
        0
    ]);
    // record last done with ellipsis width
    const [lastLen, setLastLen] = $acw62.useState(0);
    const [walkingState, setWalkingState] = $acw62.useState($89c852553f755dc1$var$NONE);
    const [singleRowHeight, setSingleRowHeight] = $acw62.useState(0);
    const singleRowRef = $acw62.useRef(null);
    const midRowRef = $acw62.useRef(null);
    const nodeList = $acw62.useMemo(()=>(0, $jWR62.default)(text), [
        text
    ]);
    const totalLen = $acw62.useMemo(()=>$89c852553f755dc1$var$getNodesLen(nodeList), [
        nodeList
    ]);
    const mergedChildren = $acw62.useMemo(()=>{
        if (!enabledMeasure || walkingState !== $89c852553f755dc1$var$DONE_WITH_ELLIPSIS) {
            // if has lastLen, use it as temporary width to avoid lots of text to squeeze space.
            if (lastLen && walkingState !== $89c852553f755dc1$var$DONE_WITHOUT_ELLIPSIS && enabledMeasure) return children($89c852553f755dc1$var$sliceNodes(nodeList, lastLen), lastLen < totalLen);
            return children(nodeList, false);
        }
        return children($89c852553f755dc1$var$sliceNodes(nodeList, midLen), midLen < totalLen);
    }, [
        enabledMeasure,
        walkingState,
        children,
        nodeList,
        midLen,
        totalLen
    ]);
    // ======================== Walk ========================
    (0, $6hDTM.default)(()=>{
        if (enabledMeasure && width && fontSize && totalLen) {
            setWalkingState($89c852553f755dc1$var$PREPARE);
            setCutLength([
                0,
                Math.ceil(totalLen / 2),
                totalLen
            ]);
        }
    }, [
        enabledMeasure,
        width,
        fontSize,
        text,
        totalLen,
        rows
    ]);
    (0, $6hDTM.default)(()=>{
        var _a;
        if (walkingState === $89c852553f755dc1$var$PREPARE) setSingleRowHeight(((_a = singleRowRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0);
    }, [
        walkingState
    ]);
    (0, $6hDTM.default)(()=>{
        var _a, _b;
        if (singleRowHeight) {
            if (walkingState === $89c852553f755dc1$var$PREPARE) {
                // Ignore if position is enough
                const midHeight = ((_a = midRowRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0;
                const maxHeight = rows * singleRowHeight;
                if (midHeight <= maxHeight) {
                    setWalkingState($89c852553f755dc1$var$DONE_WITHOUT_ELLIPSIS);
                    onEllipsis(false);
                } else setWalkingState($89c852553f755dc1$var$WALKING);
            } else if (walkingState === $89c852553f755dc1$var$WALKING) {
                if (startLen !== endLen) {
                    const midHeight = ((_b = midRowRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0;
                    const maxHeight = rows * singleRowHeight;
                    let nextStartLen = startLen;
                    let nextEndLen = endLen;
                    // We reach the last round
                    if (startLen === endLen - 1) nextEndLen = startLen;
                    else if (midHeight <= maxHeight) nextStartLen = midLen;
                    else nextEndLen = midLen;
                    const nextMidLen = Math.ceil((nextStartLen + nextEndLen) / 2);
                    setCutLength([
                        nextStartLen,
                        nextMidLen,
                        nextEndLen
                    ]);
                } else {
                    setWalkingState($89c852553f755dc1$var$DONE_WITH_ELLIPSIS);
                    setLastLen(midLen);
                    onEllipsis(true);
                }
            }
        }
    }, [
        walkingState,
        startLen,
        endLen,
        rows,
        singleRowHeight
    ]);
    // ======================= Render =======================
    const measureStyle = {
        width: width,
        whiteSpace: "normal",
        margin: 0,
        padding: 0
    };
    const renderMeasure = (content, ref, style)=>/*#__PURE__*/ $acw62.createElement("span", {
            "aria-hidden": true,
            ref: ref,
            style: Object.assign({
                position: "fixed",
                display: "block",
                left: 0,
                top: 0,
                zIndex: -9999,
                visibility: "hidden",
                pointerEvents: "none",
                fontSize: Math.ceil(fontSize / 2) * 2
            }, style)
        }, content);
    const renderMeasureSlice = (len, ref)=>{
        const sliceNodeList = $89c852553f755dc1$var$sliceNodes(nodeList, len);
        return renderMeasure(children(sliceNodeList, true), ref, measureStyle);
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, mergedChildren, enabledMeasure && walkingState !== $89c852553f755dc1$var$DONE_WITH_ELLIPSIS && walkingState !== $89c852553f755dc1$var$DONE_WITHOUT_ELLIPSIS && /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, renderMeasure("lg", singleRowRef, {
        wordBreak: "keep-all",
        whiteSpace: "nowrap"
    }), walkingState === $89c852553f755dc1$var$PREPARE ? renderMeasure(children(nodeList, false), midRowRef, measureStyle) : renderMeasureSlice(midLen, midRowRef)));
};
var $89c852553f755dc1$export$2e2bcd8739ae039 = $89c852553f755dc1$var$Ellipsis;



var $acw62 = parcelRequire("acw62");

var $VoMtX = parcelRequire("VoMtX");
"use client";
const $2c5f09c9102f607d$var$EllipsisTooltip = (_ref)=>{
    let { enabledEllipsis: enabledEllipsis, isEllipsis: isEllipsis, children: children, tooltipProps: tooltipProps } = _ref;
    if (!(tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.title) || !enabledEllipsis) return children;
    return /*#__PURE__*/ $acw62.createElement((0, $VoMtX.default), Object.assign({
        open: isEllipsis ? undefined : false
    }, tooltipProps), children);
};
var $2c5f09c9102f607d$export$2e2bcd8739ae039 = $2c5f09c9102f607d$var$EllipsisTooltip;


"use client";
var $c756fe581e322b8b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $c756fe581e322b8b$var$wrapperDecorations(_ref, content) {
    let { mark: mark, code: code, underline: underline, delete: del, strong: strong, keyboard: keyboard, italic: italic } = _ref;
    let currentContent = content;
    function wrap(tag, needed) {
        if (!needed) return;
        currentContent = /*#__PURE__*/ $acw62.createElement(tag, {}, currentContent);
    }
    wrap("strong", strong);
    wrap("u", underline);
    wrap("del", del);
    wrap("code", code);
    wrap("mark", mark);
    wrap("kbd", keyboard);
    wrap("i", italic);
    return currentContent;
}
function $c756fe581e322b8b$var$getNode(dom, defaultNode, needDom) {
    if (dom === true || dom === undefined) return defaultNode;
    return dom || needDom && defaultNode;
}
function $c756fe581e322b8b$var$toList(val) {
    if (val === false) return [
        false,
        false
    ];
    return Array.isArray(val) ? val : [
        val
    ];
}
const $c756fe581e322b8b$var$ELLIPSIS_STR = "...";
const $c756fe581e322b8b$var$Base = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    var _a, _b, _c;
    const { prefixCls: customizePrefixCls, className: className, style: style, type: type, disabled: disabled, children: children, ellipsis: ellipsis, editable: editable, copyable: copyable, component: component, title: title } = props, restProps = $c756fe581e322b8b$var$__rest(props, [
        "prefixCls",
        "className",
        "style",
        "type",
        "disabled",
        "children",
        "ellipsis",
        "editable",
        "copyable",
        "component",
        "title"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $dRTnM.ConfigContext));
    const [textLocale] = (0, $0G7XT.default)("Text");
    const typographyRef = $acw62.useRef(null);
    const editIconRef = $acw62.useRef(null);
    // ============================ MISC ============================
    const prefixCls = getPrefixCls("typography", customizePrefixCls);
    const textProps = (0, $1pcHX.default)(restProps, [
        "mark",
        "code",
        "delete",
        "underline",
        "strong",
        "keyboard",
        "italic"
    ]);
    // ========================== Editable ==========================
    const [enableEdit, editConfig] = (0, $4f54d14ab15fca01$export$2e2bcd8739ae039)(editable);
    const [editing, setEditing] = (0, $iSQh8.default)(false, {
        value: editConfig.editing
    });
    const { triggerType: triggerType = [
        "icon"
    ] } = editConfig;
    const triggerEdit = (edit)=>{
        var _a;
        if (edit) (_a = editConfig.onStart) === null || _a === void 0 || _a.call(editConfig);
        setEditing(edit);
    };
    // Focus edit icon when back
    (0, $16a6c1cd6424d279$export$2e2bcd8739ae039)(()=>{
        var _a;
        if (!editing) (_a = editIconRef.current) === null || _a === void 0 || _a.focus();
    }, [
        editing
    ]);
    const onEditClick = (e)=>{
        e === null || e === void 0 || e.preventDefault();
        triggerEdit(true);
    };
    const onEditChange = (value)=>{
        var _a;
        (_a = editConfig.onChange) === null || _a === void 0 || _a.call(editConfig, value);
        triggerEdit(false);
    };
    const onEditCancel = ()=>{
        var _a;
        (_a = editConfig.onCancel) === null || _a === void 0 || _a.call(editConfig);
        triggerEdit(false);
    };
    // ========================== Copyable ==========================
    const [enableCopy, copyConfig] = (0, $4f54d14ab15fca01$export$2e2bcd8739ae039)(copyable);
    const [copied, setCopied] = $acw62.useState(false);
    const copyIdRef = $acw62.useRef(null);
    const copyOptions = {};
    if (copyConfig.format) copyOptions.format = copyConfig.format;
    const cleanCopyId = ()=>{
        if (copyIdRef.current) clearTimeout(copyIdRef.current);
    };
    const onCopyClick = (e)=>{
        var _a;
        e === null || e === void 0 || e.preventDefault();
        e === null || e === void 0 || e.stopPropagation();
        (0, (/*@__PURE__*/$parcel$interopDefault($e5a78797c4262d1f$exports)))(copyConfig.text || String(children) || "", copyOptions);
        setCopied(true);
        // Trigger tips update
        cleanCopyId();
        copyIdRef.current = setTimeout(()=>{
            setCopied(false);
        }, 3000);
        (_a = copyConfig.onCopy) === null || _a === void 0 || _a.call(copyConfig, e);
    };
    $acw62.useEffect(()=>cleanCopyId, []);
    // ========================== Ellipsis ==========================
    const [isLineClampSupport, setIsLineClampSupport] = $acw62.useState(false);
    const [isTextOverflowSupport, setIsTextOverflowSupport] = $acw62.useState(false);
    const [expanded, setExpanded] = $acw62.useState(false);
    const [isJsEllipsis, setIsJsEllipsis] = $acw62.useState(false);
    const [isNativeEllipsis, setIsNativeEllipsis] = $acw62.useState(false);
    const [isNativeVisible, setIsNativeVisible] = $acw62.useState(true);
    const [enableEllipsis, ellipsisConfig] = (0, $4f54d14ab15fca01$export$2e2bcd8739ae039)(ellipsis, {
        expandable: false
    });
    const mergedEnableEllipsis = enableEllipsis && !expanded;
    // Shared prop to reduce bundle size
    const { rows: rows = 1 } = ellipsisConfig;
    const needMeasureEllipsis = $acw62.useMemo(()=>// Disable ellipsis
        !mergedEnableEllipsis || // Provide suffix
        ellipsisConfig.suffix !== undefined || ellipsisConfig.onEllipsis || // Can't use css ellipsis since we need to provide the place for button
        ellipsisConfig.expandable || enableEdit || enableCopy, [
        mergedEnableEllipsis,
        ellipsisConfig,
        enableEdit,
        enableCopy
    ]);
    (0, $6hDTM.default)(()=>{
        if (enableEllipsis && !needMeasureEllipsis) {
            setIsLineClampSupport((0, $5ac27a8c1ec0b63e$export$d616d7831008e86c)("webkitLineClamp"));
            setIsTextOverflowSupport((0, $5ac27a8c1ec0b63e$export$d616d7831008e86c)("textOverflow"));
        }
    }, [
        needMeasureEllipsis,
        enableEllipsis
    ]);
    const cssEllipsis = $acw62.useMemo(()=>{
        if (needMeasureEllipsis) return false;
        if (rows === 1) return isTextOverflowSupport;
        return isLineClampSupport;
    }, [
        needMeasureEllipsis,
        isTextOverflowSupport,
        isLineClampSupport
    ]);
    const isMergedEllipsis = mergedEnableEllipsis && (cssEllipsis ? isNativeEllipsis : isJsEllipsis);
    const cssTextOverflow = mergedEnableEllipsis && rows === 1 && cssEllipsis;
    const cssLineClamp = mergedEnableEllipsis && rows > 1 && cssEllipsis;
    // >>>>> Expand
    const onExpandClick = (e)=>{
        var _a;
        setExpanded(true);
        (_a = ellipsisConfig.onExpand) === null || _a === void 0 || _a.call(ellipsisConfig, e);
    };
    const [ellipsisWidth, setEllipsisWidth] = $acw62.useState(0);
    const [ellipsisFontSize, setEllipsisFontSize] = $acw62.useState(0);
    const onResize = (_ref2, element)=>{
        let { offsetWidth: offsetWidth } = _ref2;
        var _a;
        setEllipsisWidth(offsetWidth);
        setEllipsisFontSize(parseInt((_a = window.getComputedStyle) === null || _a === void 0 ? void 0 : _a.call(window, element).fontSize, 10) || 0);
    };
    // >>>>> JS Ellipsis
    const onJsEllipsis = (jsEllipsis)=>{
        var _a;
        setIsJsEllipsis(jsEllipsis);
        // Trigger if changed
        if (isJsEllipsis !== jsEllipsis) (_a = ellipsisConfig.onEllipsis) === null || _a === void 0 || _a.call(ellipsisConfig, jsEllipsis);
    };
    // >>>>> Native ellipsis
    $acw62.useEffect(()=>{
        const textEle = typographyRef.current;
        if (enableEllipsis && cssEllipsis && textEle) {
            const currentEllipsis = cssLineClamp ? textEle.offsetHeight < textEle.scrollHeight : textEle.offsetWidth < textEle.scrollWidth;
            if (isNativeEllipsis !== currentEllipsis) setIsNativeEllipsis(currentEllipsis);
        }
    }, [
        enableEllipsis,
        cssEllipsis,
        children,
        cssLineClamp,
        isNativeVisible
    ]);
    // https://github.com/ant-design/ant-design/issues/36786
    // Use IntersectionObserver to check if element is invisible
    $acw62.useEffect(()=>{
        const textEle = typographyRef.current;
        if (typeof IntersectionObserver === "undefined" || !textEle || !cssEllipsis || !mergedEnableEllipsis) return;
        /* eslint-disable-next-line compat/compat */ const observer = new IntersectionObserver(()=>{
            setIsNativeVisible(!!textEle.offsetParent);
        });
        observer.observe(textEle);
        return ()=>{
            observer.disconnect();
        };
    }, [
        cssEllipsis,
        mergedEnableEllipsis
    ]);
    // ========================== Tooltip ===========================
    let tooltipProps = {};
    if (ellipsisConfig.tooltip === true) tooltipProps = {
        title: (_a = editConfig.text) !== null && _a !== void 0 ? _a : children
    };
    else if (/*#__PURE__*/ $acw62.isValidElement(ellipsisConfig.tooltip)) tooltipProps = {
        title: ellipsisConfig.tooltip
    };
    else if (typeof ellipsisConfig.tooltip === "object") tooltipProps = Object.assign({
        title: (_b = editConfig.text) !== null && _b !== void 0 ? _b : children
    }, ellipsisConfig.tooltip);
    else tooltipProps = {
        title: ellipsisConfig.tooltip
    };
    const topAriaLabel = $acw62.useMemo(()=>{
        const isValid = (val)=>[
                "string",
                "number"
            ].includes(typeof val);
        if (!enableEllipsis || cssEllipsis) return undefined;
        if (isValid(editConfig.text)) return editConfig.text;
        if (isValid(children)) return children;
        if (isValid(title)) return title;
        if (isValid(tooltipProps.title)) return tooltipProps.title;
        return undefined;
    }, [
        enableEllipsis,
        cssEllipsis,
        title,
        tooltipProps.title,
        isMergedEllipsis
    ]);
    // =========================== Render ===========================
    // >>>>>>>>>>> Editing input
    if (editing) return /*#__PURE__*/ $acw62.createElement((0, $8a5b8988dc6b65c3$export$2e2bcd8739ae039), {
        value: (_c = editConfig.text) !== null && _c !== void 0 ? _c : typeof children === "string" ? children : "",
        onSave: onEditChange,
        onCancel: onEditCancel,
        onEnd: editConfig.onEnd,
        prefixCls: prefixCls,
        className: className,
        style: style,
        direction: direction,
        component: component,
        maxLength: editConfig.maxLength,
        autoSize: editConfig.autoSize,
        enterIcon: editConfig.enterIcon
    });
    // >>>>>>>>>>> Typography
    // Expand
    const renderExpand = ()=>{
        const { expandable: expandable, symbol: symbol } = ellipsisConfig;
        if (!expandable) return null;
        let expandContent;
        if (symbol) expandContent = symbol;
        else expandContent = textLocale === null || textLocale === void 0 ? void 0 : textLocale.expand;
        return /*#__PURE__*/ $acw62.createElement("a", {
            key: "expand",
            className: `${prefixCls}-expand`,
            onClick: onExpandClick,
            "aria-label": textLocale === null || textLocale === void 0 ? void 0 : textLocale.expand
        }, expandContent);
    };
    // Edit
    const renderEdit = ()=>{
        if (!enableEdit) return;
        const { icon: icon, tooltip: tooltip } = editConfig;
        const editTitle = (0, $jWR62.default)(tooltip)[0] || (textLocale === null || textLocale === void 0 ? void 0 : textLocale.edit);
        const ariaLabel = typeof editTitle === "string" ? editTitle : "";
        return triggerType.includes("icon") ? /*#__PURE__*/ $acw62.createElement((0, $VoMtX.default), {
            key: "edit",
            title: tooltip === false ? "" : editTitle
        }, /*#__PURE__*/ $acw62.createElement((0, $3aff44b895d5798c$export$2e2bcd8739ae039), {
            ref: editIconRef,
            className: `${prefixCls}-edit`,
            onClick: onEditClick,
            "aria-label": ariaLabel
        }, icon || /*#__PURE__*/ $acw62.createElement((0, $498b707c3c04dc0a$export$2e2bcd8739ae039), {
            role: "button"
        }))) : null;
    };
    // Copy
    const renderCopy = ()=>{
        if (!enableCopy) return;
        const { tooltips: tooltips, icon: icon } = copyConfig;
        const tooltipNodes = $c756fe581e322b8b$var$toList(tooltips);
        const iconNodes = $c756fe581e322b8b$var$toList(icon);
        const copyTitle = copied ? $c756fe581e322b8b$var$getNode(tooltipNodes[1], textLocale === null || textLocale === void 0 ? void 0 : textLocale.copied) : $c756fe581e322b8b$var$getNode(tooltipNodes[0], textLocale === null || textLocale === void 0 ? void 0 : textLocale.copy);
        const systemStr = copied ? textLocale === null || textLocale === void 0 ? void 0 : textLocale.copied : textLocale === null || textLocale === void 0 ? void 0 : textLocale.copy;
        const ariaLabel = typeof copyTitle === "string" ? copyTitle : systemStr;
        return /*#__PURE__*/ $acw62.createElement((0, $VoMtX.default), {
            key: "copy",
            title: copyTitle
        }, /*#__PURE__*/ $acw62.createElement((0, $3aff44b895d5798c$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(`${prefixCls}-copy`, copied && `${prefixCls}-copy-success`),
            onClick: onCopyClick,
            "aria-label": ariaLabel
        }, copied ? $c756fe581e322b8b$var$getNode(iconNodes[1], /*#__PURE__*/ $acw62.createElement((0, $731042e70a6ddd3b$export$2e2bcd8739ae039), null), true) : $c756fe581e322b8b$var$getNode(iconNodes[0], /*#__PURE__*/ $acw62.createElement((0, $cf161c40cf97635f$export$2e2bcd8739ae039), null), true)));
    };
    const renderOperations = (renderExpanded)=>[
            renderExpanded && renderExpand(),
            renderEdit(),
            renderCopy()
        ];
    const renderEllipsis = (needEllipsis)=>[
            needEllipsis && /*#__PURE__*/ $acw62.createElement("span", {
                "aria-hidden": true,
                key: "ellipsis"
            }, $c756fe581e322b8b$var$ELLIPSIS_STR),
            ellipsisConfig.suffix,
            renderOperations(needEllipsis)
        ];
    return /*#__PURE__*/ $acw62.createElement((0, $bVxlN.default), {
        onResize: onResize,
        disabled: !mergedEnableEllipsis || cssEllipsis
    }, (resizeRef)=>/*#__PURE__*/ $acw62.createElement((0, $2c5f09c9102f607d$export$2e2bcd8739ae039), {
            tooltipProps: tooltipProps,
            enabledEllipsis: mergedEnableEllipsis,
            isEllipsis: isMergedEllipsis
        }, /*#__PURE__*/ $acw62.createElement((0, $a3673f44358dd6b6$export$2e2bcd8739ae039), Object.assign({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                [`${prefixCls}-${type}`]: type,
                [`${prefixCls}-disabled`]: disabled,
                [`${prefixCls}-ellipsis`]: enableEllipsis,
                [`${prefixCls}-single-line`]: mergedEnableEllipsis && rows === 1,
                [`${prefixCls}-ellipsis-single-line`]: cssTextOverflow,
                [`${prefixCls}-ellipsis-multiple-line`]: cssLineClamp
            }, className),
            prefixCls: customizePrefixCls,
            style: Object.assign(Object.assign({}, style), {
                WebkitLineClamp: cssLineClamp ? rows : undefined
            }),
            component: component,
            ref: (0, $85dLH.composeRef)(resizeRef, typographyRef, ref),
            direction: direction,
            onClick: triggerType.includes("text") ? onEditClick : undefined,
            "aria-label": topAriaLabel === null || topAriaLabel === void 0 ? void 0 : topAriaLabel.toString(),
            title: title
        }, textProps), /*#__PURE__*/ $acw62.createElement((0, $89c852553f755dc1$export$2e2bcd8739ae039), {
            enabledMeasure: mergedEnableEllipsis && !cssEllipsis,
            text: children,
            rows: rows,
            width: ellipsisWidth,
            fontSize: ellipsisFontSize,
            onEllipsis: onJsEllipsis
        }, (node, needEllipsis)=>{
            let renderNode = node;
            if (node.length && needEllipsis && topAriaLabel) renderNode = /*#__PURE__*/ $acw62.createElement("span", {
                key: "show-content",
                "aria-hidden": true
            }, renderNode);
            const wrappedContext = $c756fe581e322b8b$var$wrapperDecorations(props, /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, renderNode, renderEllipsis(needEllipsis)));
            return wrappedContext;
        }))));
});
var $c756fe581e322b8b$export$2e2bcd8739ae039 = $c756fe581e322b8b$var$Base;


"use client";
var $e59afc5fcefd918d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $e59afc5fcefd918d$var$Link = /*#__PURE__*/ $acw62.forwardRef((_a, ref)=>{
    var { ellipsis: ellipsis, rel: rel } = _a, restProps = $e59afc5fcefd918d$var$__rest(_a, [
        "ellipsis",
        "rel"
    ]);
    const mergedProps = Object.assign(Object.assign({}, restProps), {
        rel: rel === undefined && restProps.target === "_blank" ? "noopener noreferrer" : rel
    });
    // @ts-expect-error: https://github.com/ant-design/ant-design/issues/26622
    delete mergedProps.navigate;
    return /*#__PURE__*/ $acw62.createElement((0, $c756fe581e322b8b$export$2e2bcd8739ae039), Object.assign({}, mergedProps, {
        ref: ref,
        ellipsis: !!ellipsis,
        component: "a"
    }));
});
var $e59afc5fcefd918d$export$2e2bcd8739ae039 = $e59afc5fcefd918d$var$Link;



var $acw62 = parcelRequire("acw62");

"use client";
const $32838ac41e3e19d1$var$Paragraph = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $c756fe581e322b8b$export$2e2bcd8739ae039), Object.assign({
        ref: ref
    }, props, {
        component: "div"
    })));
var $32838ac41e3e19d1$export$2e2bcd8739ae039 = $32838ac41e3e19d1$var$Paragraph;



var $acw62 = parcelRequire("acw62");

var $1pcHX = parcelRequire("1pcHX");


"use client";
var $3704098f38e9f562$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $3704098f38e9f562$var$Text = (_a, ref)=>{
    var { ellipsis: ellipsis } = _a, restProps = $3704098f38e9f562$var$__rest(_a, [
        "ellipsis"
    ]);
    const mergedEllipsis = $acw62.useMemo(()=>{
        if (ellipsis && typeof ellipsis === "object") return (0, $1pcHX.default)(ellipsis, [
            "expandable",
            "rows"
        ]);
        return ellipsis;
    }, [
        ellipsis
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $c756fe581e322b8b$export$2e2bcd8739ae039), Object.assign({
        ref: ref
    }, restProps, {
        ellipsis: mergedEllipsis,
        component: "span"
    }));
};
var $3704098f38e9f562$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($3704098f38e9f562$var$Text);



var $acw62 = parcelRequire("acw62");


"use client";
var $af44bdd0e8458ef3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $af44bdd0e8458ef3$var$TITLE_ELE_LIST = [
    1,
    2,
    3,
    4,
    5
];
const $af44bdd0e8458ef3$var$Title = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { level: level = 1 } = props, restProps = $af44bdd0e8458ef3$var$__rest(props, [
        "level"
    ]);
    let component;
    if ($af44bdd0e8458ef3$var$TITLE_ELE_LIST.includes(level)) component = `h${level}`;
    else component = "h1";
    return /*#__PURE__*/ $acw62.createElement((0, $c756fe581e322b8b$export$2e2bcd8739ae039), Object.assign({
        ref: ref
    }, restProps, {
        component: component
    }));
});
var $af44bdd0e8458ef3$export$2e2bcd8739ae039 = $af44bdd0e8458ef3$var$Title;



"use client";
const $69754065fe3b4b60$var$Typography = (0, $a3673f44358dd6b6$export$2e2bcd8739ae039);
$69754065fe3b4b60$var$Typography.Text = (0, $3704098f38e9f562$export$2e2bcd8739ae039);
$69754065fe3b4b60$var$Typography.Link = (0, $e59afc5fcefd918d$export$2e2bcd8739ae039);
$69754065fe3b4b60$var$Typography.Title = (0, $af44bdd0e8458ef3$export$2e2bcd8739ae039);
$69754065fe3b4b60$var$Typography.Paragraph = (0, $32838ac41e3e19d1$export$2e2bcd8739ae039);
var $69754065fe3b4b60$export$2e2bcd8739ae039 = $69754065fe3b4b60$var$Typography;



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $1f7080d7f45398b4$var$DeleteOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"
                }
            }
        ]
    },
    "name": "delete",
    "theme": "outlined"
};
var $1f7080d7f45398b4$export$2e2bcd8739ae039 = $1f7080d7f45398b4$var$DeleteOutlined;



var $adRcI = parcelRequire("adRcI");
var $66758f779ccbee67$var$DeleteOutlined = function DeleteOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $adRcI.default), (0, $8nd05.default)({}, props, {
        ref: ref,
        icon: (0, $1f7080d7f45398b4$export$2e2bcd8739ae039)
    }));
};
var $66758f779ccbee67$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($66758f779ccbee67$var$DeleteOutlined);



var $igqD6 = parcelRequire("igqD6");

var $ii71U = parcelRequire("ii71U");
var $90f256c567e4c320$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($90f256c567e4c320$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $90f256c567e4c320$exports = g;
});



var $f1q41 = parcelRequire("f1q41");
const { confirm: $c4397ea6dba41bfd$var$confirm } = (0, $e47cb76d58815cb1$export$2e2bcd8739ae039);
const [$c4397ea6dba41bfd$var$useTimeline, $c4397ea6dba41bfd$var$setTimeline, $c4397ea6dba41bfd$var$getTimeline, $c4397ea6dba41bfd$var$subscribeToTimeline] = (0, $ii71U.makeStateHook)({
    scenes: []
});
const [$c4397ea6dba41bfd$var$useMetadata, $c4397ea6dba41bfd$var$setMetadata, $c4397ea6dba41bfd$var$getMetadata] = (0, $ii71U.makeStateHook)({
    highlightBars: [],
    characters: [],
    threads: [],
    tags: []
});
const [$c4397ea6dba41bfd$var$useSaveInfo, $c4397ea6dba41bfd$var$setSaveInfo] = (0, $ii71U.makeStateHook)({
    lastAutosavedAt: null
});
// widths of the cards
const $c4397ea6dba41bfd$var$cardWidth = 400;
// height needed for the top cap
const $c4397ea6dba41bfd$var$topCapHeight = 64;
const $c4397ea6dba41bfd$var$oppositeSideGap = 60;
const $c4397ea6dba41bfd$var$sameSideGap = 60;
// size of the pins on the bar
const $c4397ea6dba41bfd$var$pinSize = 24;
// widths of the bar
const $c4397ea6dba41bfd$var$barWidth = 4;
const $c4397ea6dba41bfd$var$barWidthHighlight = 10;
// total width of the center gutter
const $c4397ea6dba41bfd$var$gutterWidth = $c4397ea6dba41bfd$var$pinSize * 1.5 - 4;
const $c4397ea6dba41bfd$var$lineColor = "white";
function $c4397ea6dba41bfd$var$loadInputData(data) {
    let parsedData = JSON.parse(data);
    let characterSet = new Set();
    let tagSet = new Set();
    let threadsSet = new Set();
    parsedData.scenes.forEach((scene)=>{
        scene.characters.forEach((character)=>{
            characterSet.add(character);
        });
        scene.tags.forEach((tag)=>{
            tagSet.add(tag);
        });
        scene.threads.forEach((threads)=>{
            threadsSet.add(threads);
        });
    });
    $c4397ea6dba41bfd$var$setTimeline(parsedData);
    $c4397ea6dba41bfd$var$setMetadata({
        highlightBars: [],
        characters: Array.from(characterSet),
        threads: Array.from(threadsSet),
        tags: Array.from(tagSet)
    });
    window.localStorage.setItem("timeline-save-hash", $c4397ea6dba41bfd$var$hashSave(data));
}
function $c4397ea6dba41bfd$var$arrayToOptions(array) {
    return array.map((item)=>({
            label: item,
            value: item
        }));
}
function $c4397ea6dba41bfd$var$hashSave(data) {
    return JSON.stringify(data);
}
function $c4397ea6dba41bfd$var$getHashedSave() {
    return window.localStorage.getItem("timeline-save-hash");
}
function $c4397ea6dba41bfd$var$saveFile() {
    let saveData = JSON.stringify($c4397ea6dba41bfd$var$getTimeline());
    let blob = new window.Blob([
        saveData
    ], {
        type: "text/json;charset=utf-8"
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($90f256c567e4c320$exports))).saveAs(blob, $c4397ea6dba41bfd$var$getTimeline().title + ".json");
    window.localStorage.setItem("timeline-save-hash", $c4397ea6dba41bfd$var$hashSave(saveData));
}
function $c4397ea6dba41bfd$var$newTimeline() {
    $c4397ea6dba41bfd$var$unsavedChanges(()=>{
        $c4397ea6dba41bfd$var$setTimeline({
            scenes: []
        });
        $c4397ea6dba41bfd$var$setMetadata({
            highlightBars: [],
            characters: [],
            threads: [],
            tags: []
        });
    });
}
function $c4397ea6dba41bfd$var$unsavedChanges(fn) {
    let saveData = JSON.stringify($c4397ea6dba41bfd$var$getTimeline());
    let hasUnsavedChanges = $c4397ea6dba41bfd$var$getHashedSave() !== $c4397ea6dba41bfd$var$hashSave(saveData);
    let hasAnyData = $c4397ea6dba41bfd$var$getTimeline().scenes.length > 0;
    if (hasUnsavedChanges && hasAnyData) {
        let modal = $c4397ea6dba41bfd$var$confirm({
            title: "Unsaved Changes!",
            content: `Warning! You have unsaved changes on the current timeline. Would you like to save this timeline to a file before proceeding?`,
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2444f6da62064575$export$2e2bcd8739ae039), {}),
            okText: "Save",
            cancelText: "Cancel",
            onOk () {
                $c4397ea6dba41bfd$var$saveFile();
                fn();
            },
            footer (node, { OkBtn: OkBtn, CancelBtn: CancelBtn }) {
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)(CancelBtn, {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Uh7a.default), {
                            danger: true,
                            onClick: ()=>{
                                modal.destroy();
                                fn();
                            },
                            children: "Don't Save"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)(OkBtn, {})
                    ]
                });
            }
        });
    } else fn();
}
function $c4397ea6dba41bfd$var$autosave() {
    window.localStorage.setItem("timeline", JSON.stringify($c4397ea6dba41bfd$var$getTimeline()));
    $c4397ea6dba41bfd$var$setSaveInfo((saveInfo)=>({
            ...saveInfo,
            lastAutosavedAt: new Date()
        }));
}
const $c4397ea6dba41bfd$export$52f642ff31e0e4d0 = ()=>{
    const [timeline, setTimeline] = $c4397ea6dba41bfd$var$useTimeline();
    const scenes = timeline.scenes;
    const setScenes = (0, $ii71U.filterSetData)(setTimeline, "scenes");
    const [metadata, setMetadata] = $c4397ea6dba41bfd$var$useMetadata();
    const [filter, setFilter] = (0, $acw62.useState)({
        characters: [],
        tags: [],
        threads: []
    });
    const inputFileRef = (0, $acw62.useRef)(null);
    const [saveInfo] = $c4397ea6dba41bfd$var$useSaveInfo();
    (0, $acw62.useEffect)(()=>{
        let unsubscribeTimeline = $c4397ea6dba41bfd$var$subscribeToTimeline((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).debounce($c4397ea6dba41bfd$var$autosave, 300));
        if (window.localStorage.getItem("timeline")) try {
            $c4397ea6dba41bfd$var$loadInputData(window.localStorage.getItem("timeline"));
        } catch (e) {
            console.error("Cannot load file from storage", e);
        }
        return ()=>{
            unsubscribeTimeline();
        };
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $h5DBq.default), {
                gap: 20,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $h5DBq.default), {
                        vertical: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                className: (0, $igqD6.css)`display: inline-block; min-width: 150px;`,
                                children: "Title"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTcXV.default), {
                                value: timeline.title,
                                onChange: ({ target: target })=>{
                                    setTimeline((timeline)=>{
                                        timeline.title = target.value;
                                        return timeline;
                                    });
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h5DBq.default), {
                        vertical: true,
                        justify: "flex-end",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Uh7a.default), {
                            onClick: $c4397ea6dba41bfd$var$saveFile,
                            children: "Save file"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $h5DBq.default), {
                        vertical: true,
                        justify: "flex-end",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Uh7a.default), {
                                onClick: ()=>{
                                    $c4397ea6dba41bfd$var$unsavedChanges(()=>{
                                        inputFileRef.current?.click();
                                    });
                                },
                                children: "Load file"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                ref: inputFileRef,
                                type: "file",
                                className: (0, $igqD6.css)`
              display: none;
            `,
                                onChange: (event)=>{
                                    const reader = new window.FileReader();
                                    reader.onload = (event)=>{
                                        $c4397ea6dba41bfd$var$loadInputData(event.target.result);
                                    };
                                    reader.readAsText(event.target.files[0]);
                                    event.target.value = "";
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h5DBq.default), {
                        vertical: true,
                        justify: "flex-end",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Uh7a.default), {
                            onClick: $c4397ea6dba41bfd$var$newTimeline,
                            children: "New timeline"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h5DBq.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {
                            type: "vertical",
                            className: (0, $igqD6.css)`
              height: 100%;
            `
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $h5DBq.default), {
                        vertical: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                className: (0, $igqD6.css)`display: inline-block; min-width: 150px;`,
                                children: "Threads"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                options: $c4397ea6dba41bfd$var$arrayToOptions(metadata.threads),
                                mode: "multiple",
                                popupMatchSelectWidth: false,
                                placeholder: "All threads",
                                onChange: (values)=>setFilter((state)=>{
                                        let nextFilter = {
                                            ...state
                                        };
                                        nextFilter.threads = values;
                                        return nextFilter;
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $h5DBq.default), {
                        vertical: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                className: (0, $igqD6.css)`display: inline-block; min-width: 150px;`,
                                children: "Tags"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                options: $c4397ea6dba41bfd$var$arrayToOptions(metadata.tags),
                                mode: "multiple",
                                popupMatchSelectWidth: false,
                                placeholder: "All tags",
                                onChange: (values)=>setFilter((state)=>{
                                        let nextFilter = {
                                            ...state
                                        };
                                        nextFilter.tags = values;
                                        return nextFilter;
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $h5DBq.default), {
                        vertical: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                className: (0, $igqD6.css)`display: inline-block; min-width: 150px;`,
                                children: "Characters"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                options: $c4397ea6dba41bfd$var$arrayToOptions(metadata.characters),
                                mode: "multiple",
                                popupMatchSelectWidth: false,
                                placeholder: "All characters",
                                onChange: (values)=>setFilter((state)=>{
                                        let nextFilter = {
                                            ...state
                                        };
                                        nextFilter.characters = values;
                                        return nextFilter;
                                    })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h5DBq.default), {
                className: (0, $igqD6.css)`margin-top: 5px;`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69754065fe3b4b60$export$2e2bcd8739ae039).Text, {
                    type: "secondary",
                    children: saveInfo.lastAutosavedAt ? `Last autosaved at: ${saveInfo.lastAutosavedAt}` : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "\xa0"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($c4397ea6dba41bfd$var$Timeline, {
                scenes: scenes,
                setScenes: setScenes,
                metadata: metadata,
                filter: filter
            })
        ]
    });
};
function $c4397ea6dba41bfd$var$getElementHeights(elements) {
    let yCoordOnLeft = $c4397ea6dba41bfd$var$topCapHeight;
    let yCoordOnRight = $c4397ea6dba41bfd$var$topCapHeight;
    let positions = [];
    elements.forEach((node, index)=>{
        positions[index] = {};
        // not sure why this happens, but it does
        if (!node) return;
        let isLast = elements.length - 1 === index;
        if (yCoordOnLeft <= yCoordOnRight) {
            positions[index].nodeSide = "left";
            // store top so we can use it to calculate height after we've figured out the new top
            let nodeTop = yCoordOnLeft;
            positions[index].nodeTop = nodeTop;
            // before setting the new left top, make sure we position the right top appropriately
            if (yCoordOnRight - yCoordOnLeft < $c4397ea6dba41bfd$var$oppositeSideGap) yCoordOnRight = yCoordOnLeft + $c4397ea6dba41bfd$var$oppositeSideGap;
            // then update leftTop with the appropriate height
            yCoordOnLeft += node.offsetHeight + $c4397ea6dba41bfd$var$sameSideGap;
            // finally configure the height
            let nextPanelCoord = Math.min(yCoordOnLeft, yCoordOnRight);
            if (isLast) nextPanelCoord = Math.max(yCoordOnLeft, yCoordOnRight);
            let height = nextPanelCoord - nodeTop;
            positions[index].barHeight = height;
            positions[index].nodeBottom = nodeTop + height;
        } else {
            positions[index].nodeSide = "right";
            // store top so we can use it to calculate height after we've figured out the new top
            let nodeTop = yCoordOnRight;
            positions[index].nodeTop = nodeTop;
            // before setting the new left top, make sure we position the right top appropriately
            if (yCoordOnLeft - yCoordOnRight < $c4397ea6dba41bfd$var$oppositeSideGap) yCoordOnLeft = yCoordOnRight + $c4397ea6dba41bfd$var$oppositeSideGap;
            // then update leftTop with the appropriate height
            yCoordOnRight += node.offsetHeight + $c4397ea6dba41bfd$var$sameSideGap;
            // finally configure the height
            let nextPanelCoord = Math.min(yCoordOnLeft, yCoordOnRight);
            if (isLast) nextPanelCoord = Math.max(yCoordOnLeft, yCoordOnRight);
            let height = nextPanelCoord - nodeTop;
            positions[index].barHeight = height;
            positions[index].nodeBottom = nodeTop + height;
        }
    });
    return positions;
}
const $c4397ea6dba41bfd$var$Timeline = ({ scenes: scenes, setScenes: setScenes, metadata: metadata, filter: filter })=>{
    const sceneNodes = (0, $acw62.useRef)([]);
    const [positions, setPositions] = (0, $acw62.useState)([]);
    sceneNodes.current = [];
    (0, $acw62.useEffect)(()=>{
        let newPositions = $c4397ea6dba41bfd$var$getElementHeights(sceneNodes.current);
        if (JSON.stringify(positions) !== JSON.stringify(newPositions)) setPositions(newPositions);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $igqD6.css)`
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    `,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: (0, $igqD6.css)`
        position: relative;
      `,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($c4397ea6dba41bfd$var$Bar, {
                    cap: "top",
                    insertAt: 0,
                    highlight: metadata.highlightBars.includes(0),
                    setScenes: setScenes,
                    pin: false,
                    filter: filter
                }),
                scenes.map((scene, index)=>{
                    let hasCharacter = filter.characters.length ? Boolean(filter.characters.find((character)=>scene.characters.includes(character))) : true;
                    let hasThread = filter.threads.length ? Boolean(filter.threads.find((thread)=>scene.threads.includes(thread))) : true;
                    let hasTag = filter.tags.length ? Boolean(filter.tags.find((tag)=>scene.tags.includes(tag))) : true;
                    const shouldRender = hasCharacter && hasThread && hasTag;
                    if (!shouldRender) return null;
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($c4397ea6dba41bfd$var$Event, {
                            nodes: sceneNodes,
                            positions: positions,
                            summary: scene.summary,
                            characters: scene.characters,
                            tags: scene.tags,
                            threads: scene.threads,
                            index: index,
                            setScenes: setScenes,
                            metadata: metadata,
                            filter: filter,
                            isLast: index === scenes.length - 1
                        })
                    }, scene.createdAt);
                })
            ]
        })
    });
};
function $c4397ea6dba41bfd$var$dragElement(element, positions, index, setTransformCoords, setScenes) {
    return (event)=>{
        if (event.target === element.current) {
            let startingClientX = event.clientX;
            let startingClientY = event.clientY;
            let startingScrollX = window.scrollX;
            let startingScrollY = window.scrollY;
            event.preventDefault();
            let lastClientX = event.clientX;
            let lastClientY = event.clientY;
            let insertIndex;
            function move(event) {
                lastClientX = event.clientX ?? lastClientX;
                lastClientY = event.clientY ?? lastClientY;
                let diffX = lastClientX - startingClientX + (startingScrollX - window.scrollX);
                let diffY = lastClientY - startingClientY - (startingScrollY - window.scrollY);
                let currentNodeTop = positions[index].nodeTop + diffY;
                insertIndex = positions.findIndex((position, thisIndex)=>{
                    return currentNodeTop < position.nodeTop && thisIndex !== index;
                });
                if (insertIndex === -1) insertIndex = positions.length;
                if (insertIndex === index + 1) $c4397ea6dba41bfd$var$setMetadata("highlightBars", [
                    index,
                    insertIndex
                ]);
                else $c4397ea6dba41bfd$var$setMetadata("highlightBars", [
                    insertIndex
                ]);
                setTransformCoords([
                    diffX,
                    diffY
                ]);
            }
            function up() {
                $c4397ea6dba41bfd$var$setMetadata("highlightBars", []);
                if (insertIndex !== undefined && insertIndex !== index + 1) // This is a bit complex. We want to move our current item to a new position, but we need to remove it first. So there's a bunch of index hacking in here.
                setScenes((scenes)=>{
                    let element = scenes[index];
                    scenes.splice(index, 1);
                    let normalizedInsertIndex = insertIndex;
                    // -1 means that we didn't find a next index, so we want to insert it at the end
                    if (insertIndex === -1) normalizedInsertIndex = scenes.length;
                    else if (index < insertIndex) // If our current index is less than our insertIndex, it means that when we remove the element (a few lines earlier), all the later indexes got shifted, so we have to shift our insert index too.
                    normalizedInsertIndex = Math.max(insertIndex - 1, 0);
                    scenes.splice(normalizedInsertIndex, 0, element);
                    return scenes;
                });
                else // if we didn't move, just reset the coordinates (we don't do so in the other case, b/c there's a useEffect that handles the state transition more reliably in that case)
                setTransformCoords([
                    0,
                    0
                ]);
                document.removeEventListener("mousemove", move);
                document.removeEventListener("scroll", move);
                document.removeEventListener("mouseup", up);
            }
            document.addEventListener("mousemove", move);
            document.addEventListener("scroll", move);
            document.addEventListener("mouseup", up);
        }
    };
}
const $c4397ea6dba41bfd$var$Event = ({ nodes: nodes, positions: positions, summary: summary, characters: characters, tags: tags, threads: threads, index: index, setScenes: setScenes, metadata: metadata, isLast: isLast, filter: filter } = {})=>{
    let position = positions[index];
    let side = position?.nodeSide ?? "left";
    let height = position?.barHeight ?? 0;
    let thisNode = (0, $acw62.useRef)(null);
    let [transformCoords, setTransformCoords] = (0, $acw62.useState)([
        0,
        0
    ]);
    let [baseCoords, setBaseCords] = (0, $acw62.useState)([
        0,
        0
    ]);
    let xBase = side === "right" ? $c4397ea6dba41bfd$var$gutterWidth : -$c4397ea6dba41bfd$var$cardWidth;
    let yBase = -($c4397ea6dba41bfd$var$pinSize / 2) + position?.nodeTop;
    // This effect makes sure that there's at least one frame of rendering with a reorder WITHOUT a coordinate change. That allows the transition effect to work.
    (0, $acw62.useEffect)(()=>{
        setBaseCords([
            xBase,
            yBase
        ]);
        // Also, any time the base coords change (which only happens during re-ordering, clear the transform coords.)
        setTransformCoords([
            0,
            0
        ]);
    }, [
        xBase,
        yBase
    ]);
    const dragger = (element)=>$c4397ea6dba41bfd$var$dragElement(element, positions, index, setTransformCoords, setScenes);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $igqD6.css)`
        display: flex;
      `,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($c4397ea6dba41bfd$var$Bar, {
                height: height,
                insertAt: index + 1,
                highlight: metadata.highlightBars.includes(index + 1),
                setScenes: setScenes,
                cap: isLast ? "bottom" : "none",
                pinY: transformCoords[1],
                side: side,
                dragger: dragger,
                filter: filter
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $jnHKE.default), {
                ref: (node)=>{
                    nodes.current[index] = node;
                    thisNode.current = node;
                },
                style: {
                    transform: `translate(${transformCoords[0] + baseCoords[0]}px, ${transformCoords[1] + baseCoords[1]}px)`
                },
                className: (0, $igqD6.css)`
          position: absolute;
          top: 0;
          left: 0;

          margin-top: 20px;

          transition: ${transformCoords[0] !== 0 || transformCoords[1] !== 0 ? "none" : "transform .3s"};
          ${transformCoords[0] !== 0 || transformCoords[1] !== 0 ? (0, $igqD6.css)`z-index: 100;` : ""}

          width: ${$c4397ea6dba41bfd$var$cardWidth}px;
          padding: 12px;

          cursor: all-scroll;

          & .ant-card-body {
            padding: 0px;
            cursor: initial;
          }

          &:hover button {
            display: block;
          }`,
                onMouseDown: dragger(thisNode),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTcXV.default).TextArea, {
                        autoSize: true,
                        value: summary,
                        bordered: false,
                        className: (0, $igqD6.css)`
            padding: 0;
          `,
                        placeholder: "Describe the scene...",
                        onChange: (event)=>{
                            setScenes(index, (scene)=>{
                                return {
                                    ...scene,
                                    summary: event.target.value
                                };
                            });
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50a5b629c434844e$export$2e2bcd8739ae039), {
                        content: /*#__PURE__*/ (0, $ayMG0.jsx)($c4397ea6dba41bfd$var$EditSceneDetails, {
                            metadata: metadata,
                            threads: threads,
                            characters: characters,
                            tags: tags,
                            setScenes: setScenes,
                            index: index
                        }),
                        rootClassName: (0, $igqD6.css)`
            min-width: 400px;
          `,
                        placement: "bottom",
                        trigger: "click",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Uh7a.default), {
                            type: "text",
                            size: "small",
                            className: (0, $igqD6.css)`
            width: 100%;
            text-align: left;
            height: auto !important;
          `,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $69754065fe3b4b60$export$2e2bcd8739ae039).Text, {
                                type: "secondary",
                                className: (0, $igqD6.css)`
              width: 100%;
              display: inline-block;
              margin-bottom: 0;
              font-size: 10px;
            `,
                                children: [
                                    !characters.length && !tags.length && !threads.length && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: "Add scene details..."
                                    }),
                                    !!characters.length && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: (0, $igqD6.css)`display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;`,
                                        children: [
                                            "Characters: ",
                                            characters?.join(", ")
                                        ]
                                    }),
                                    !!tags.length && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: (0, $igqD6.css)`display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; `,
                                        children: [
                                            "Tags: ",
                                            tags?.map((item)=>`#${item}`).join(", ")
                                        ]
                                    }),
                                    !!threads.length && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: (0, $igqD6.css)`display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; `,
                                        children: [
                                            "Threads: ",
                                            threads?.map((item)=>`"${item}"`).join(", ")
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Uh7a.default), {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66758f779ccbee67$export$2e2bcd8739ae039), {}),
                        shape: "circle",
                        type: "text",
                        size: "small",
                        className: (0, $igqD6.css)`
            position: absolute;
            display: none;
            top: 0;
            right: 0;
            margin-right: 4px;
            margin-top: 4px;
          `,
                        onClick: ()=>$c4397ea6dba41bfd$var$confirm({
                                title: "Are you sure you want to delete this scene?",
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2444f6da62064575$export$2e2bcd8739ae039), {}),
                                okText: "Yes",
                                okType: "danger",
                                cancelText: "No",
                                onOk () {
                                    setScenes((scenes)=>{
                                        scenes.splice(index, 1);
                                        return scenes;
                                    });
                                }
                            })
                    })
                ]
            })
        ]
    });
};
const $c4397ea6dba41bfd$var$EditSceneDetails = ({ metadata: metadata, threads: threads, characters: characters, tags: tags, setScenes: setScenes, index: index })=>{
    function setSelect(key, values) {
        $c4397ea6dba41bfd$var$setMetadata(key, (metadataItem)=>{
            let metadataSet = new Set(metadataItem);
            values.forEach((entry)=>{
                metadataSet.add(entry);
            });
            return Array.from(metadataSet);
        });
        setScenes(index, (scene)=>{
            return {
                ...scene,
                [key]: values
            };
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                        className: (0, $igqD6.css)`display: inline-block; margin-top: 10px;`,
                        children: "Thread"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                        mode: "tags",
                        bordered: false,
                        className: (0, $igqD6.css)`
            width: 100%;
            & .ant-select-selector {
              padding: 0;
            }
          `,
                        placeholder: "Which thread is this scene a part of?",
                        options: metadata.threads.map((thread)=>({
                                label: thread,
                                value: thread
                            })),
                        value: threads,
                        onChange: (values)=>setSelect("threads", values)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                        className: (0, $igqD6.css)`display: inline-block; margin-top: 4px;`,
                        children: "Characters"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                        mode: "tags",
                        bordered: false,
                        className: (0, $igqD6.css)`
            width: 100%;
            & .ant-select-selector {
              padding: 0;
            }
          `,
                        placeholder: "Characters involved in scene",
                        options: metadata.characters.map((character)=>({
                                label: character,
                                value: character
                            })),
                        value: characters,
                        onChange: (values)=>setSelect("characters", values)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                        className: (0, $igqD6.css)`display: inline-block; margin-top: 4px;`,
                        children: "Tags"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                        mode: "tags",
                        bordered: false,
                        className: (0, $igqD6.css)`
            width: 100%;
            & .ant-select-selector {
              padding: 0;
            }
          `,
                        placeholder: "Free-form tags",
                        options: metadata.tags.map((tag)=>({
                                label: tag,
                                value: tag
                            })),
                        value: tags.map((tag)=>{
                            if (typeof tag !== "string") return tag[0] + ":" + tag[1];
                            return tag;
                        }),
                        onChange: (values)=>setSelect("tags", values)
                    })
                ]
            })
        ]
    });
};
const $c4397ea6dba41bfd$var$Bar = ({ height: height = $c4397ea6dba41bfd$var$topCapHeight, setScenes: setScenes, highlight: highlight, insertAt: insertAt, cap: cap = "none", pin: pin = true, side: side, pinY: pinY = 0, dragger: dragger, filter: filter })=>{
    const negativeTop = $c4397ea6dba41bfd$var$pinSize / 2;
    const internalBarWidth = highlight ? $c4397ea6dba41bfd$var$barWidthHighlight : $c4397ea6dba41bfd$var$barWidth;
    const containerRef = (0, $acw62.useRef)(null);
    const pipeRef = (0, $acw62.useRef)(null);
    const [createDotPosition, setCreateDotPosition] = (0, $acw62.useState)(0);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: containerRef,
        className: (0, $igqD6.css)`
        position: relative;
      `,
        onMouseMove: (event)=>{
            let rect = containerRef.current.getBoundingClientRect();
            let y = event.clientY - rect.top - $c4397ea6dba41bfd$var$pinSize / 2 // y position within the element.
            ;
            let buffer = 5;
            let topBoundary = cap === "top" ? 0 : $c4397ea6dba41bfd$var$pinSize - negativeTop + buffer;
            let bottomBoundary = cap === "bottom" ? rect.height - $c4397ea6dba41bfd$var$pinSize : rect.height - $c4397ea6dba41bfd$var$pinSize * 1.5 - buffer;
            if (y < topBoundary) y = topBoundary;
            else if (y > bottomBoundary) y = bottomBoundary;
            setCreateDotPosition(parseInt(y));
        },
        children: [
            pin && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        transform: `translateY(${pinY}px)`
                    },
                    className: (0, $igqD6.css)`
            display: flex;
            justify-content: center;
            
            width: ${$c4397ea6dba41bfd$var$pinSize}px;
            height: ${$c4397ea6dba41bfd$var$pinSize}px;

            background-color: ${$c4397ea6dba41bfd$var$lineColor};
            border-radius: 100%;

            color: black;
            font-family: Arial;
            font-weight: bold;

            transition: margin-left .3s;

            position: absolute;
            top: -${negativeTop}px;
            left: ${$c4397ea6dba41bfd$var$gutterWidth / 2 - $c4397ea6dba41bfd$var$pinSize / 2}px;

            ${pinY[0] !== 0 ? (0, $igqD6.css)`z-index: 100;` : ""};
          `,
                    children: [
                        insertAt,
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            ref: pipeRef,
                            className: (0, $igqD6.css)`
              position: absolute;
              left: 0;
            
              width: ${$c4397ea6dba41bfd$var$cardWidth}px;
              margin-left: ${side === "left" ? -$c4397ea6dba41bfd$var$cardWidth : $c4397ea6dba41bfd$var$pinSize}px;
          
              height: 100%;
              display: flex;
              align-items: center;
          
              cursor: all-scroll;
            `,
                            onMouseDown: dragger(pipeRef),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: (0, $igqD6.css)`
              height: 2px;
              width: calc(${$c4397ea6dba41bfd$var$cardWidth}px + ${$c4397ea6dba41bfd$var$gutterWidth / 2}px);
              pointer-events: none;

              background: ${$c4397ea6dba41bfd$var$lineColor};
              transition: margin-left 1s;
            `
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $igqD6.css)`
        &:hover>div>div {
          display: flex;
        }`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: (0, $igqD6.css)`
          background: ${$c4397ea6dba41bfd$var$lineColor};
        
          width: ${internalBarWidth}px;
          height: ${height}px;
        
          transition: all .3s;

          ${cap !== "none" ? (0, $igqD6.css)`
          border-${cap}-left-radius: 50px;
          border-${cap}-right-radius: 50px;
          ` : ""}

          margin: 0px ${$c4397ea6dba41bfd$var$gutterWidth / 2 - internalBarWidth / 2}px;
        `,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            top: `${createDotPosition}px`
                        },
                        className: (0, $igqD6.css)`
              display: none;
              position: absolute;
              width: ${$c4397ea6dba41bfd$var$pinSize}px;
              height: ${$c4397ea6dba41bfd$var$pinSize}px;
              background-color: ${$c4397ea6dba41bfd$var$lineColor};
              border-radius: 100%;
              margin-left: -${$c4397ea6dba41bfd$var$pinSize / 2 - internalBarWidth / 2}px;

              justify-content: center;
              color: black;
              font-family: Arial;
              font-size: 25px;

              cursor: pointer;
            `,
                        onClick: (event)=>{
                            setScenes((scenes)=>{
                                scenes.splice(insertAt, 0, {
                                    createdAt: new Date(),
                                    summary: "",
                                    characters: filter?.characters ?? [],
                                    tags: filter?.tags ?? [],
                                    threads: filter?.threads ?? []
                                });
                                return scenes;
                            });
                        },
                        children: "+"
                    })
                })
            })
        ]
    });
};



var $aT8OD = parcelRequire("aT8OD");parcelRequire("3i86m");
var $iPfci = parcelRequire("iPfci");
var $ly9Vc = parcelRequire("ly9Vc");

var $1wI7H = parcelRequire("1wI7H");

var $fcQiF = parcelRequire("fcQiF");

var $jL5bw = parcelRequire("jL5bw");
const $64636abf1746fc18$var$getDesignToken = (config)=>{
    const theme = (config === null || config === void 0 ? void 0 : config.algorithm) ? (0, $iPfci.default)(config.algorithm) : (0, $iPfci.default)((0, $1wI7H.default));
    const mergedToken = Object.assign(Object.assign({}, (0, $fcQiF.default)), config === null || config === void 0 ? void 0 : config.token);
    return (0, $ly9Vc.getComputedToken)(mergedToken, {
        override: config === null || config === void 0 ? void 0 : config.token
    }, theme, (0, $jL5bw.default));
};
var $64636abf1746fc18$export$2e2bcd8739ae039 = $64636abf1746fc18$var$getDesignToken;



var $iqsy8 = parcelRequire("iqsy8");
var $hRCaH = parcelRequire("hRCaH");

var $9JyOV = parcelRequire("9JyOV");

var $1wI7H = parcelRequire("1wI7H");
function $55c634384c51114e$export$2e2bcd8739ae039(token) {
    const { sizeUnit: sizeUnit, sizeStep: sizeStep } = token;
    const compactSizeStep = sizeStep - 2;
    return {
        sizeXXL: sizeUnit * (compactSizeStep + 10),
        sizeXL: sizeUnit * (compactSizeStep + 6),
        sizeLG: sizeUnit * (compactSizeStep + 2),
        sizeMD: sizeUnit * (compactSizeStep + 2),
        sizeMS: sizeUnit * (compactSizeStep + 1),
        size: sizeUnit * compactSizeStep,
        sizeSM: sizeUnit * compactSizeStep,
        sizeXS: sizeUnit * (compactSizeStep - 1),
        sizeXXS: sizeUnit * (compactSizeStep - 1)
    };
}



var $1oU0E = parcelRequire("1oU0E");
const $7480e91aa2c69f50$var$derivative = (token, mapToken)=>{
    const mergedMapToken = mapToken !== null && mapToken !== void 0 ? mapToken : (0, $1wI7H.default)(token);
    const fontSize = mergedMapToken.fontSizeSM; // Smaller size font-size as base
    const controlHeight = mergedMapToken.controlHeight - 4;
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, mergedMapToken), (0, $55c634384c51114e$export$2e2bcd8739ae039)(mapToken !== null && mapToken !== void 0 ? mapToken : token)), (0, $1oU0E.default)(fontSize)), {
        controlHeight: // controlHeight
        controlHeight
    }), (0, $9JyOV.default)(Object.assign(Object.assign({}, mergedMapToken), {
        controlHeight: controlHeight
    })));
};
var $7480e91aa2c69f50$export$2e2bcd8739ae039 = $7480e91aa2c69f50$var$derivative;


parcelRequire("eIR68");
var $i1881 = parcelRequire("i1881");

var $fcQiF = parcelRequire("fcQiF");

var $lqU0w = parcelRequire("lqU0w");
parcelRequire("eIR68");
var $i1881 = parcelRequire("i1881");

var $9nbKF = parcelRequire("9nbKF");
const $d59c2d385264216d$export$31f6399ba7ce6bea = (baseColor, alpha)=>new (0, $9nbKF.TinyColor)(baseColor).setAlpha(alpha).toRgbString();
const $d59c2d385264216d$export$7003a8a990e79359 = (baseColor, brightness)=>{
    const instance = new (0, $9nbKF.TinyColor)(baseColor);
    return instance.lighten(brightness).toHexString();
};


const $bb5c99fa51be6547$export$da275153033f4ec1 = (baseColor)=>{
    const colors = (0, $i1881.default)(baseColor, {
        theme: "dark"
    });
    return {
        1: colors[0],
        2: colors[1],
        3: colors[2],
        4: colors[3],
        5: colors[6],
        6: colors[5],
        7: colors[4],
        8: colors[6],
        9: colors[5],
        10: colors[4]
    };
};
const $bb5c99fa51be6547$export$3e0cb0c1d9c1b691 = (bgBaseColor, textBaseColor)=>{
    const colorBgBase = bgBaseColor || "#000";
    const colorTextBase = textBaseColor || "#fff";
    return {
        colorBgBase: colorBgBase,
        colorTextBase: colorTextBase,
        colorText: (0, $d59c2d385264216d$export$31f6399ba7ce6bea)(colorTextBase, 0.85),
        colorTextSecondary: (0, $d59c2d385264216d$export$31f6399ba7ce6bea)(colorTextBase, 0.65),
        colorTextTertiary: (0, $d59c2d385264216d$export$31f6399ba7ce6bea)(colorTextBase, 0.45),
        colorTextQuaternary: (0, $d59c2d385264216d$export$31f6399ba7ce6bea)(colorTextBase, 0.25),
        colorFill: (0, $d59c2d385264216d$export$31f6399ba7ce6bea)(colorTextBase, 0.18),
        colorFillSecondary: (0, $d59c2d385264216d$export$31f6399ba7ce6bea)(colorTextBase, 0.12),
        colorFillTertiary: (0, $d59c2d385264216d$export$31f6399ba7ce6bea)(colorTextBase, 0.08),
        colorFillQuaternary: (0, $d59c2d385264216d$export$31f6399ba7ce6bea)(colorTextBase, 0.04),
        colorBgElevated: (0, $d59c2d385264216d$export$7003a8a990e79359)(colorBgBase, 12),
        colorBgContainer: (0, $d59c2d385264216d$export$7003a8a990e79359)(colorBgBase, 8),
        colorBgLayout: (0, $d59c2d385264216d$export$7003a8a990e79359)(colorBgBase, 0),
        colorBgSpotlight: (0, $d59c2d385264216d$export$7003a8a990e79359)(colorBgBase, 26),
        colorBgBlur: (0, $d59c2d385264216d$export$31f6399ba7ce6bea)(colorTextBase, 0.04),
        colorBorder: (0, $d59c2d385264216d$export$7003a8a990e79359)(colorBgBase, 26),
        colorBorderSecondary: (0, $d59c2d385264216d$export$7003a8a990e79359)(colorBgBase, 19)
    };
};



var $1wI7H = parcelRequire("1wI7H");
const $179e3c86520dcfc1$var$derivative = (token, mapToken)=>{
    const colorPalettes = Object.keys((0, $fcQiF.defaultPresetColors)).map((colorKey)=>{
        const colors = (0, $i1881.default)(token[colorKey], {
            theme: "dark"
        });
        return new Array(10).fill(1).reduce((prev, _, i)=>{
            prev[`${colorKey}-${i + 1}`] = colors[i];
            prev[`${colorKey}${i + 1}`] = colors[i];
            return prev;
        }, {});
    }).reduce((prev, cur)=>{
        prev = Object.assign(Object.assign({}, prev), cur);
        return prev;
    }, {});
    const mergedMapToken = mapToken !== null && mapToken !== void 0 ? mapToken : (0, $1wI7H.default)(token);
    return Object.assign(Object.assign(Object.assign({}, mergedMapToken), colorPalettes), (0, $lqU0w.default)(token, {
        generateColorPalettes: $bb5c99fa51be6547$export$da275153033f4ec1,
        generateNeutralColorPalettes: $bb5c99fa51be6547$export$3e0cb0c1d9c1b691
    }));
};
var $179e3c86520dcfc1$export$2e2bcd8739ae039 = $179e3c86520dcfc1$var$derivative;



var $1wI7H = parcelRequire("1wI7H");
"use client";
// ZombieJ: We export as object to user but array in internal.
// This is used to minimize the bundle size for antd package but safe to refactor as object also.
// Please do not export internal `useToken` directly to avoid something export unexpected.
/** Get current context Design Token. Will be different if you are using nest theme config. */ function $a978954eaf874e83$var$useToken() {
    const [theme, token, hashId] = (0, $hRCaH.default)();
    return {
        theme: theme,
        token: token,
        hashId: hashId
    };
}
var $a978954eaf874e83$export$2e2bcd8739ae039 = {
    defaultConfig: /** @private Test Usage. Do not use in production. */ $iqsy8.defaultConfig,
    /** Default seedToken */ defaultSeed: (0, $iqsy8.defaultConfig).token,
    useToken: $a978954eaf874e83$var$useToken,
    defaultAlgorithm: $1wI7H.default,
    darkAlgorithm: $179e3c86520dcfc1$export$2e2bcd8739ae039,
    compactAlgorithm: $7480e91aa2c69f50$export$2e2bcd8739ae039,
    getDesignToken: $64636abf1746fc18$export$2e2bcd8739ae039
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $aphAM = parcelRequire("aphAM");parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

parcelRequire("igqD6");
const { darkAlgorithm: $e534f70fb0db2d2b$var$darkAlgorithm } = (0, $a978954eaf874e83$export$2e2bcd8739ae039);
const $e534f70fb0db2d2b$export$70f2e80c165569be = ()=>{
    const navigate = (0, $aphAM.useNavigate)();
    const loc = (0, $aphAM.useLocation)();
    // const page = loc.pathname
    //   .replace('/tabletop-tools/', '')
    //   .replace(/\/.*/, '')
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d4d1bba653c6d14$export$6955bcca4cd3539f), {
        expand: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Outlet), {})
    });
};


function $2b6e161c9edcf319$var$redirect({ from: from = "", to: to }) {
    let fromList = typeof from === "string" ? [
        from
    ] : from;
    let routes = fromList.map((from)=>{
        let fromWithStar;
        if (from.endsWith("/*")) fromWithStar = from;
        else if (from.endsWith("/")) fromWithStar = from + "*";
        else fromWithStar = from + "/*";
        let fromWithoutStar = fromWithStar.replace(/\/\*$/, "");
        let fromProp = {};
        if (from === "") fromProp.index = true;
        else fromProp.path = fromWithStar;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
            ...fromProp,
            element: /*#__PURE__*/ (0, $ayMG0.jsx)($2b6e161c9edcf319$var$Redirect, {
                from: fromWithoutStar,
                to: to
            })
        }, from);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: routes
    });
}
const $2b6e161c9edcf319$var$Redirect = ({ from: from, to: to })=>{
    const { pathname: pathname } = (0, $aphAM.useResolvedPath)("");
    const { search: search, hash: hash } = (0, $aphAM.useLocation)();
    const parentRoute = pathname.replace(new RegExp(from + "(/|$)"), "");
    const theRestOfThePath = (0, $aphAM.useParams)()?.["*"] ?? "";
    let finalTo = to.endsWith("/") ? to : [
        parentRoute,
        to,
        theRestOfThePath
    ].join("/").replace(/\/+/g, "/") + search + hash;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
        to: finalTo,
        replace: true
    });
};
const $2b6e161c9edcf319$var$App = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aT8OD.default), {
        theme: {
            algorithm: (0, $a978954eaf874e83$export$2e2bcd8739ae039).darkAlgorithm
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.BrowserRouter), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Routes), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Route), {
                    path: "/",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                            index: true,
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd51ae0e4c21d08e$export$b94310965bed44e6), {})
                        }),
                        $2b6e161c9edcf319$var$redirect({
                            from: "we",
                            to: "wage-equality"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                            path: "we/*",
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)($2b6e161c9edcf319$var$Redirect, {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                            path: "wage-equality",
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $210c12135ffdf67d$export$a5529e381d0d1474), {})
                        }),
                        $2b6e161c9edcf319$var$redirect({
                            from: "tt",
                            to: "tabletop-tools"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Route), {
                            path: "tabletop-tools",
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7fda7cd463156458$export$bd0832b179ca357a), {}),
                            children: [
                                $2b6e161c9edcf319$var$redirect({
                                    from: [
                                        "",
                                        "dr"
                                    ],
                                    to: "dice-roller"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                    path: "dice-roller",
                                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hz7px.DiceRoller), {})
                                }),
                                $2b6e161c9edcf319$var$redirect({
                                    from: [
                                        "ng"
                                    ],
                                    to: "name-generator"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                    path: "name-generator",
                                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b26c7d5932956bc4$export$fe3d36a3c7c467aa), {})
                                })
                            ]
                        }),
                        $2b6e161c9edcf319$var$redirect({
                            from: [
                                "wt",
                                "at",
                                "author-tools"
                            ],
                            to: "writer-tools"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Route), {
                            path: "writer-tools",
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e534f70fb0db2d2b$export$70f2e80c165569be), {}),
                            children: [
                                $2b6e161c9edcf319$var$redirect({
                                    from: [
                                        "",
                                        "tl"
                                    ],
                                    to: "timeline"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                    path: "timeline",
                                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c4397ea6dba41bfd$export$52f642ff31e0e4d0), {})
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
(0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).render(/*#__PURE__*/ (0, $ayMG0.jsx)($2b6e161c9edcf319$var$App, {}), document.querySelector("#app"));


//# sourceMappingURL=index.989bf276.js.map
